var sE = Object.defineProperty;
var lE = (pt, yt, ir) => yt in pt ? sE(pt, yt, { enumerable: !0, configurable: !0, writable: !0, value: ir }) : pt[yt] = ir;
var Hm = (pt, yt, ir) => lE(pt, typeof yt != "symbol" ? yt + "" : yt, ir);
import * as React from "react";
import React__default, { useState, useEffect, useMemo, isValidElement, cloneElement, Children, forwardRef, createContext, useRef, useImperativeHandle, useCallback, useLayoutEffect, useContext, memo, PureComponent, useId as useId$3, createElement, Fragment, startTransition } from "react";
import * as ReactDOM from "react-dom";
import ReactDOM__default, { createPortal } from "react-dom";
function getDefaultExportFromCjs$1(pt) {
  return pt && pt.__esModule && Object.prototype.hasOwnProperty.call(pt, "default") ? pt.default : pt;
}
var jsxRuntime$1 = { exports: {} }, reactJsxRuntime_production$1 = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production$1;
function requireReactJsxRuntime_production$1() {
  if (hasRequiredReactJsxRuntime_production$1) return reactJsxRuntime_production$1;
  hasRequiredReactJsxRuntime_production$1 = 1;
  var pt = Symbol.for("react.transitional.element"), yt = Symbol.for("react.fragment");
  function ir(ti, ii, ui) {
    var ai = null;
    if (ui !== void 0 && (ai = "" + ui), ii.key !== void 0 && (ai = "" + ii.key), "key" in ii) {
      ui = {};
      for (var li in ii)
        li !== "key" && (ui[li] = ii[li]);
    } else ui = ii;
    return ii = ui.ref, {
      $$typeof: pt,
      type: ti,
      key: ai,
      ref: ii !== void 0 ? ii : null,
      props: ui
    };
  }
  return reactJsxRuntime_production$1.Fragment = yt, reactJsxRuntime_production$1.jsx = ir, reactJsxRuntime_production$1.jsxs = ir, reactJsxRuntime_production$1;
}
var reactJsxRuntime_development$1 = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development$1;
function requireReactJsxRuntime_development$1() {
  return hasRequiredReactJsxRuntime_development$1 || (hasRequiredReactJsxRuntime_development$1 = 1, process.env.NODE_ENV !== "production" && (function() {
    function pt(ji) {
      if (ji == null) return null;
      if (typeof ji == "function")
        return ji.$$typeof === _o ? null : ji.displayName || ji.name || null;
      if (typeof ji == "string") return ji;
      switch (ji) {
        case xi:
          return "Fragment";
        case Pi:
          return "Profiler";
        case Si:
          return "StrictMode";
        case Mi:
          return "Suspense";
        case Oo:
          return "SuspenseList";
        case fo:
          return "Activity";
      }
      if (typeof ji == "object")
        switch (typeof ji.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), ji.$$typeof) {
          case vi:
            return "Portal";
          case Oi:
            return ji.displayName || "Context";
          case $i:
            return (ji._context.displayName || "Context") + ".Consumer";
          case Di:
            var Hi = ji.render;
            return ji = ji.displayName, ji || (ji = Hi.displayName || Hi.name || "", ji = ji !== "" ? "ForwardRef(" + ji + ")" : "ForwardRef"), ji;
          case io:
            return Hi = ji.displayName || null, Hi !== null ? Hi : pt(ji.type) || "Memo";
          case xo:
            Hi = ji._payload, ji = ji._init;
            try {
              return pt(ji(Hi));
            } catch {
            }
        }
      return null;
    }
    function yt(ji) {
      return "" + ji;
    }
    function ir(ji) {
      try {
        yt(ji);
        var Hi = !1;
      } catch {
        Hi = !0;
      }
      if (Hi) {
        Hi = console;
        var zo = Hi.error, Lo = typeof Symbol == "function" && Symbol.toStringTag && ji[Symbol.toStringTag] || ji.constructor.name || "Object";
        return zo.call(
          Hi,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          Lo
        ), yt(ji);
      }
    }
    function ti(ji) {
      if (ji === xi) return "<>";
      if (typeof ji == "object" && ji !== null && ji.$$typeof === xo)
        return "<...>";
      try {
        var Hi = pt(ji);
        return Hi ? "<" + Hi + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function ii() {
      var ji = Li.A;
      return ji === null ? null : ji.getOwner();
    }
    function ui() {
      return Error("react-stack-top-frame");
    }
    function ai(ji) {
      if (Co.call(ji, "key")) {
        var Hi = Object.getOwnPropertyDescriptor(ji, "key").get;
        if (Hi && Hi.isReactWarning) return !1;
      }
      return ji.key !== void 0;
    }
    function li(ji, Hi) {
      function zo() {
        Vo || (Vo = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          Hi
        ));
      }
      zo.isReactWarning = !0, Object.defineProperty(ji, "key", {
        get: zo,
        configurable: !0
      });
    }
    function oi() {
      var ji = pt(this.type);
      return No[ji] || (No[ji] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), ji = this.props.ref, ji !== void 0 ? ji : null;
    }
    function si(ji, Hi, zo, Lo, sa, Ko) {
      var ca = zo.ref;
      return ji = {
        $$typeof: Ti,
        type: ji,
        key: Hi,
        props: zo,
        _owner: Lo
      }, (ca !== void 0 ? ca : null) !== null ? Object.defineProperty(ji, "ref", {
        enumerable: !1,
        get: oi
      }) : Object.defineProperty(ji, "ref", { enumerable: !1, value: null }), ji._store = {}, Object.defineProperty(ji._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(ji, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(ji, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: sa
      }), Object.defineProperty(ji, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: Ko
      }), Object.freeze && (Object.freeze(ji.props), Object.freeze(ji)), ji;
    }
    function di(ji, Hi, zo, Lo, sa, Ko) {
      var ca = Hi.children;
      if (ca !== void 0)
        if (Lo)
          if (Ni(ca)) {
            for (Lo = 0; Lo < ca.length; Lo++)
              fi(ca[Lo]);
            Object.freeze && Object.freeze(ca);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else fi(ca);
      if (Co.call(Hi, "key")) {
        ca = pt(ji);
        var pa = Object.keys(Hi).filter(function(ia) {
          return ia !== "key";
        });
        Lo = 0 < pa.length ? "{key: someKey, " + pa.join(": ..., ") + ": ...}" : "{key: someKey}", Wi[ca + Lo] || (pa = 0 < pa.length ? "{" + pa.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          Lo,
          ca,
          pa,
          ca
        ), Wi[ca + Lo] = !0);
      }
      if (ca = null, zo !== void 0 && (ir(zo), ca = "" + zo), ai(Hi) && (ir(Hi.key), ca = "" + Hi.key), "key" in Hi) {
        zo = {};
        for (var ga in Hi)
          ga !== "key" && (zo[ga] = Hi[ga]);
      } else zo = Hi;
      return ca && li(
        zo,
        typeof ji == "function" ? ji.displayName || ji.name || "Unknown" : ji
      ), si(
        ji,
        ca,
        zo,
        ii(),
        sa,
        Ko
      );
    }
    function fi(ji) {
      gi(ji) ? ji._store && (ji._store.validated = 1) : typeof ji == "object" && ji !== null && ji.$$typeof === xo && (ji._payload.status === "fulfilled" ? gi(ji._payload.value) && ji._payload.value._store && (ji._payload.value._store.validated = 1) : ji._store && (ji._store.validated = 1));
    }
    function gi(ji) {
      return typeof ji == "object" && ji !== null && ji.$$typeof === Ti;
    }
    var mi = React__default, Ti = Symbol.for("react.transitional.element"), vi = Symbol.for("react.portal"), xi = Symbol.for("react.fragment"), Si = Symbol.for("react.strict_mode"), Pi = Symbol.for("react.profiler"), $i = Symbol.for("react.consumer"), Oi = Symbol.for("react.context"), Di = Symbol.for("react.forward_ref"), Mi = Symbol.for("react.suspense"), Oo = Symbol.for("react.suspense_list"), io = Symbol.for("react.memo"), xo = Symbol.for("react.lazy"), fo = Symbol.for("react.activity"), _o = Symbol.for("react.client.reference"), Li = mi.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, Co = Object.prototype.hasOwnProperty, Ni = Array.isArray, Yi = console.createTask ? console.createTask : function() {
      return null;
    };
    mi = {
      react_stack_bottom_frame: function(ji) {
        return ji();
      }
    };
    var Vo, No = {}, Ui = mi.react_stack_bottom_frame.bind(
      mi,
      ui
    )(), jo = Yi(ti(ui)), Wi = {};
    reactJsxRuntime_development$1.Fragment = xi, reactJsxRuntime_development$1.jsx = function(ji, Hi, zo) {
      var Lo = 1e4 > Li.recentlyCreatedOwnerStacks++;
      return di(
        ji,
        Hi,
        zo,
        !1,
        Lo ? Error("react-stack-top-frame") : Ui,
        Lo ? Yi(ti(ji)) : jo
      );
    }, reactJsxRuntime_development$1.jsxs = function(ji, Hi, zo) {
      var Lo = 1e4 > Li.recentlyCreatedOwnerStacks++;
      return di(
        ji,
        Hi,
        zo,
        !0,
        Lo ? Error("react-stack-top-frame") : Ui,
        Lo ? Yi(ti(ji)) : jo
      );
    };
  })()), reactJsxRuntime_development$1;
}
var hasRequiredJsxRuntime$1;
function requireJsxRuntime$1() {
  return hasRequiredJsxRuntime$1 || (hasRequiredJsxRuntime$1 = 1, process.env.NODE_ENV === "production" ? jsxRuntime$1.exports = requireReactJsxRuntime_production$1() : jsxRuntime$1.exports = requireReactJsxRuntime_development$1()), jsxRuntime$1.exports;
}
var jsxRuntimeExports$1 = requireJsxRuntime$1();
const mockPath = "mock/skyline", getImageUrl = (pt, yt, ir, ti = !1) => ti ? "/mock/data/test.png" : `${pt}/runs/${yt}?id=${ir.id}&image=true`;
function useStreamResults(pt) {
  const [yt, ir] = useState([]), ti = pt.includes(mockPath), [ii, ui] = useState(!0);
  return useEffect(() => {
    const ai = new AbortController(), li = "latest", oi = `${pt}/runs/${li}`, si = (di) => Object.entries(di || {}).filter(([, fi]) => !/\.flv$/i.test(fi.path)).map(([, fi]) => ({
      ...fi,
      status: fi.status !== "good" && fi.status !== "bad" ? "fail" : fi.status,
      image_url: getImageUrl(pt, li, fi, ti)
    }));
    return (async () => {
      try {
        let di;
        if (ti)
          di = await (await fetch("/mock/data/results.json")).json();
        else {
          const gi = await fetch(oi, { signal: ai.signal });
          if (!gi.ok) throw new Error(`HTTP ${gi.status}`);
          di = await gi.json();
        }
        const fi = si(di);
        ai.signal.aborted || ir(fi), ui(!1);
      } catch (di) {
        ai.signal.aborted || (console.error(`❌ Failed to load stream results from ${oi}`, di), ir([]), ui(!1));
      }
    })(), () => ai.abort();
  }, [pt]), [yt, ii];
}
function useFilterSortStreams(pt, { search: yt = "", sortBy: ir = "confidence", sortOrder: ti = "desc", filters: ii = [] }) {
  return useMemo(() => {
    const ui = (yt || "").toLowerCase(), li = (ii != null && ii.length ? pt.filter((mi) => ii.includes(mi == null ? void 0 : mi.status)) : pt).filter((mi) => `${(mi == null ? void 0 : mi.name) ?? ""}`.toLowerCase().includes(ui)), oi = (mi) => (typeof mi == "number" ? mi : -1 / 0) || 0, si = (mi, Ti) => mi < Ti ? -1 : mi > Ti ? 1 : 0, di = new Intl.Collator(void 0, { sensitivity: "base", numeric: !0 }), fi = (mi) => ir === "confidence" ? oi(mi == null ? void 0 : mi.confidence) : ir === "name" ? (mi == null ? void 0 : mi.name) ?? "" : 0, gi = (mi, Ti) => {
      const vi = fi(mi), xi = fi(Ti);
      let Si = ir === "name" ? di.compare(String(vi), String(xi)) : si(vi, xi);
      return Si === 0 && (Si = di.compare(String((mi == null ? void 0 : mi.name) ?? ""), String((Ti == null ? void 0 : Ti.name) ?? "")), Si === 0 && (Si = si(oi(mi == null ? void 0 : mi.id), oi(Ti == null ? void 0 : Ti.id)))), ti === "asc" ? Si : -Si;
    };
    return [...li].sort(gi);
  }, [pt, yt, ir, ti, ii]);
}
var propTypes$1 = { exports: {} }, reactIs$4 = { exports: {} }, reactIs_production_min$2 = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min$2;
function requireReactIs_production_min$2() {
  if (hasRequiredReactIs_production_min$2) return reactIs_production_min$2;
  hasRequiredReactIs_production_min$2 = 1;
  var pt = typeof Symbol == "function" && Symbol.for, yt = pt ? Symbol.for("react.element") : 60103, ir = pt ? Symbol.for("react.portal") : 60106, ti = pt ? Symbol.for("react.fragment") : 60107, ii = pt ? Symbol.for("react.strict_mode") : 60108, ui = pt ? Symbol.for("react.profiler") : 60114, ai = pt ? Symbol.for("react.provider") : 60109, li = pt ? Symbol.for("react.context") : 60110, oi = pt ? Symbol.for("react.async_mode") : 60111, si = pt ? Symbol.for("react.concurrent_mode") : 60111, di = pt ? Symbol.for("react.forward_ref") : 60112, fi = pt ? Symbol.for("react.suspense") : 60113, gi = pt ? Symbol.for("react.suspense_list") : 60120, mi = pt ? Symbol.for("react.memo") : 60115, Ti = pt ? Symbol.for("react.lazy") : 60116, vi = pt ? Symbol.for("react.block") : 60121, xi = pt ? Symbol.for("react.fundamental") : 60117, Si = pt ? Symbol.for("react.responder") : 60118, Pi = pt ? Symbol.for("react.scope") : 60119;
  function $i(Di) {
    if (typeof Di == "object" && Di !== null) {
      var Mi = Di.$$typeof;
      switch (Mi) {
        case yt:
          switch (Di = Di.type, Di) {
            case oi:
            case si:
            case ti:
            case ui:
            case ii:
            case fi:
              return Di;
            default:
              switch (Di = Di && Di.$$typeof, Di) {
                case li:
                case di:
                case Ti:
                case mi:
                case ai:
                  return Di;
                default:
                  return Mi;
              }
          }
        case ir:
          return Mi;
      }
    }
  }
  function Oi(Di) {
    return $i(Di) === si;
  }
  return reactIs_production_min$2.AsyncMode = oi, reactIs_production_min$2.ConcurrentMode = si, reactIs_production_min$2.ContextConsumer = li, reactIs_production_min$2.ContextProvider = ai, reactIs_production_min$2.Element = yt, reactIs_production_min$2.ForwardRef = di, reactIs_production_min$2.Fragment = ti, reactIs_production_min$2.Lazy = Ti, reactIs_production_min$2.Memo = mi, reactIs_production_min$2.Portal = ir, reactIs_production_min$2.Profiler = ui, reactIs_production_min$2.StrictMode = ii, reactIs_production_min$2.Suspense = fi, reactIs_production_min$2.isAsyncMode = function(Di) {
    return Oi(Di) || $i(Di) === oi;
  }, reactIs_production_min$2.isConcurrentMode = Oi, reactIs_production_min$2.isContextConsumer = function(Di) {
    return $i(Di) === li;
  }, reactIs_production_min$2.isContextProvider = function(Di) {
    return $i(Di) === ai;
  }, reactIs_production_min$2.isElement = function(Di) {
    return typeof Di == "object" && Di !== null && Di.$$typeof === yt;
  }, reactIs_production_min$2.isForwardRef = function(Di) {
    return $i(Di) === di;
  }, reactIs_production_min$2.isFragment = function(Di) {
    return $i(Di) === ti;
  }, reactIs_production_min$2.isLazy = function(Di) {
    return $i(Di) === Ti;
  }, reactIs_production_min$2.isMemo = function(Di) {
    return $i(Di) === mi;
  }, reactIs_production_min$2.isPortal = function(Di) {
    return $i(Di) === ir;
  }, reactIs_production_min$2.isProfiler = function(Di) {
    return $i(Di) === ui;
  }, reactIs_production_min$2.isStrictMode = function(Di) {
    return $i(Di) === ii;
  }, reactIs_production_min$2.isSuspense = function(Di) {
    return $i(Di) === fi;
  }, reactIs_production_min$2.isValidElementType = function(Di) {
    return typeof Di == "string" || typeof Di == "function" || Di === ti || Di === si || Di === ui || Di === ii || Di === fi || Di === gi || typeof Di == "object" && Di !== null && (Di.$$typeof === Ti || Di.$$typeof === mi || Di.$$typeof === ai || Di.$$typeof === li || Di.$$typeof === di || Di.$$typeof === xi || Di.$$typeof === Si || Di.$$typeof === Pi || Di.$$typeof === vi);
  }, reactIs_production_min$2.typeOf = $i, reactIs_production_min$2;
}
var reactIs_development$4 = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development$4;
function requireReactIs_development$4() {
  return hasRequiredReactIs_development$4 || (hasRequiredReactIs_development$4 = 1, process.env.NODE_ENV !== "production" && (function() {
    var pt = typeof Symbol == "function" && Symbol.for, yt = pt ? Symbol.for("react.element") : 60103, ir = pt ? Symbol.for("react.portal") : 60106, ti = pt ? Symbol.for("react.fragment") : 60107, ii = pt ? Symbol.for("react.strict_mode") : 60108, ui = pt ? Symbol.for("react.profiler") : 60114, ai = pt ? Symbol.for("react.provider") : 60109, li = pt ? Symbol.for("react.context") : 60110, oi = pt ? Symbol.for("react.async_mode") : 60111, si = pt ? Symbol.for("react.concurrent_mode") : 60111, di = pt ? Symbol.for("react.forward_ref") : 60112, fi = pt ? Symbol.for("react.suspense") : 60113, gi = pt ? Symbol.for("react.suspense_list") : 60120, mi = pt ? Symbol.for("react.memo") : 60115, Ti = pt ? Symbol.for("react.lazy") : 60116, vi = pt ? Symbol.for("react.block") : 60121, xi = pt ? Symbol.for("react.fundamental") : 60117, Si = pt ? Symbol.for("react.responder") : 60118, Pi = pt ? Symbol.for("react.scope") : 60119;
    function $i(qo) {
      return typeof qo == "string" || typeof qo == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      qo === ti || qo === si || qo === ui || qo === ii || qo === fi || qo === gi || typeof qo == "object" && qo !== null && (qo.$$typeof === Ti || qo.$$typeof === mi || qo.$$typeof === ai || qo.$$typeof === li || qo.$$typeof === di || qo.$$typeof === xi || qo.$$typeof === Si || qo.$$typeof === Pi || qo.$$typeof === vi);
    }
    function Oi(qo) {
      if (typeof qo == "object" && qo !== null) {
        var xa = qo.$$typeof;
        switch (xa) {
          case yt:
            var $a = qo.type;
            switch ($a) {
              case oi:
              case si:
              case ti:
              case ui:
              case ii:
              case fi:
                return $a;
              default:
                var ys = $a && $a.$$typeof;
                switch (ys) {
                  case li:
                  case di:
                  case Ti:
                  case mi:
                  case ai:
                    return ys;
                  default:
                    return xa;
                }
            }
          case ir:
            return xa;
        }
      }
    }
    var Di = oi, Mi = si, Oo = li, io = ai, xo = yt, fo = di, _o = ti, Li = Ti, Co = mi, Ni = ir, Yi = ui, Vo = ii, No = fi, Ui = !1;
    function jo(qo) {
      return Ui || (Ui = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), Wi(qo) || Oi(qo) === oi;
    }
    function Wi(qo) {
      return Oi(qo) === si;
    }
    function ji(qo) {
      return Oi(qo) === li;
    }
    function Hi(qo) {
      return Oi(qo) === ai;
    }
    function zo(qo) {
      return typeof qo == "object" && qo !== null && qo.$$typeof === yt;
    }
    function Lo(qo) {
      return Oi(qo) === di;
    }
    function sa(qo) {
      return Oi(qo) === ti;
    }
    function Ko(qo) {
      return Oi(qo) === Ti;
    }
    function ca(qo) {
      return Oi(qo) === mi;
    }
    function pa(qo) {
      return Oi(qo) === ir;
    }
    function ga(qo) {
      return Oi(qo) === ui;
    }
    function ia(qo) {
      return Oi(qo) === ii;
    }
    function ra(qo) {
      return Oi(qo) === fi;
    }
    reactIs_development$4.AsyncMode = Di, reactIs_development$4.ConcurrentMode = Mi, reactIs_development$4.ContextConsumer = Oo, reactIs_development$4.ContextProvider = io, reactIs_development$4.Element = xo, reactIs_development$4.ForwardRef = fo, reactIs_development$4.Fragment = _o, reactIs_development$4.Lazy = Li, reactIs_development$4.Memo = Co, reactIs_development$4.Portal = Ni, reactIs_development$4.Profiler = Yi, reactIs_development$4.StrictMode = Vo, reactIs_development$4.Suspense = No, reactIs_development$4.isAsyncMode = jo, reactIs_development$4.isConcurrentMode = Wi, reactIs_development$4.isContextConsumer = ji, reactIs_development$4.isContextProvider = Hi, reactIs_development$4.isElement = zo, reactIs_development$4.isForwardRef = Lo, reactIs_development$4.isFragment = sa, reactIs_development$4.isLazy = Ko, reactIs_development$4.isMemo = ca, reactIs_development$4.isPortal = pa, reactIs_development$4.isProfiler = ga, reactIs_development$4.isStrictMode = ia, reactIs_development$4.isSuspense = ra, reactIs_development$4.isValidElementType = $i, reactIs_development$4.typeOf = Oi;
  })()), reactIs_development$4;
}
var hasRequiredReactIs$4;
function requireReactIs$4() {
  return hasRequiredReactIs$4 || (hasRequiredReactIs$4 = 1, process.env.NODE_ENV === "production" ? reactIs$4.exports = requireReactIs_production_min$2() : reactIs$4.exports = requireReactIs_development$4()), reactIs$4.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign$1, hasRequiredObjectAssign$1;
function requireObjectAssign$1() {
  if (hasRequiredObjectAssign$1) return objectAssign$1;
  hasRequiredObjectAssign$1 = 1;
  var pt = Object.getOwnPropertySymbols, yt = Object.prototype.hasOwnProperty, ir = Object.prototype.propertyIsEnumerable;
  function ti(ui) {
    if (ui == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(ui);
  }
  function ii() {
    try {
      if (!Object.assign)
        return !1;
      var ui = new String("abc");
      if (ui[5] = "de", Object.getOwnPropertyNames(ui)[0] === "5")
        return !1;
      for (var ai = {}, li = 0; li < 10; li++)
        ai["_" + String.fromCharCode(li)] = li;
      var oi = Object.getOwnPropertyNames(ai).map(function(di) {
        return ai[di];
      });
      if (oi.join("") !== "0123456789")
        return !1;
      var si = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(di) {
        si[di] = di;
      }), Object.keys(Object.assign({}, si)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return objectAssign$1 = ii() ? Object.assign : function(ui, ai) {
    for (var li, oi = ti(ui), si, di = 1; di < arguments.length; di++) {
      li = Object(arguments[di]);
      for (var fi in li)
        yt.call(li, fi) && (oi[fi] = li[fi]);
      if (pt) {
        si = pt(li);
        for (var gi = 0; gi < si.length; gi++)
          ir.call(li, si[gi]) && (oi[si[gi]] = li[si[gi]]);
      }
    }
    return oi;
  }, objectAssign$1;
}
var ReactPropTypesSecret_1$1, hasRequiredReactPropTypesSecret$1;
function requireReactPropTypesSecret$1() {
  if (hasRequiredReactPropTypesSecret$1) return ReactPropTypesSecret_1$1;
  hasRequiredReactPropTypesSecret$1 = 1;
  var pt = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ReactPropTypesSecret_1$1 = pt, ReactPropTypesSecret_1$1;
}
var has$4, hasRequiredHas$2;
function requireHas$2() {
  return hasRequiredHas$2 || (hasRequiredHas$2 = 1, has$4 = Function.call.bind(Object.prototype.hasOwnProperty)), has$4;
}
var checkPropTypes_1$1, hasRequiredCheckPropTypes$1;
function requireCheckPropTypes$1() {
  if (hasRequiredCheckPropTypes$1) return checkPropTypes_1$1;
  hasRequiredCheckPropTypes$1 = 1;
  var pt = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var yt = /* @__PURE__ */ requireReactPropTypesSecret$1(), ir = {}, ti = /* @__PURE__ */ requireHas$2();
    pt = function(ui) {
      var ai = "Warning: " + ui;
      typeof console < "u" && console.error(ai);
      try {
        throw new Error(ai);
      } catch {
      }
    };
  }
  function ii(ui, ai, li, oi, si) {
    if (process.env.NODE_ENV !== "production") {
      for (var di in ui)
        if (ti(ui, di)) {
          var fi;
          try {
            if (typeof ui[di] != "function") {
              var gi = Error(
                (oi || "React class") + ": " + li + " type `" + di + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof ui[di] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw gi.name = "Invariant Violation", gi;
            }
            fi = ui[di](ai, di, oi, li, null, yt);
          } catch (Ti) {
            fi = Ti;
          }
          if (fi && !(fi instanceof Error) && pt(
            (oi || "React class") + ": type specification of " + li + " `" + di + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof fi + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), fi instanceof Error && !(fi.message in ir)) {
            ir[fi.message] = !0;
            var mi = si ? si() : "";
            pt(
              "Failed " + li + " type: " + fi.message + (mi ?? "")
            );
          }
        }
    }
  }
  return ii.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (ir = {});
  }, checkPropTypes_1$1 = ii, checkPropTypes_1$1;
}
var factoryWithTypeCheckers$1, hasRequiredFactoryWithTypeCheckers$1;
function requireFactoryWithTypeCheckers$1() {
  if (hasRequiredFactoryWithTypeCheckers$1) return factoryWithTypeCheckers$1;
  hasRequiredFactoryWithTypeCheckers$1 = 1;
  var pt = requireReactIs$4(), yt = requireObjectAssign$1(), ir = /* @__PURE__ */ requireReactPropTypesSecret$1(), ti = /* @__PURE__ */ requireHas$2(), ii = /* @__PURE__ */ requireCheckPropTypes$1(), ui = function() {
  };
  process.env.NODE_ENV !== "production" && (ui = function(li) {
    var oi = "Warning: " + li;
    typeof console < "u" && console.error(oi);
    try {
      throw new Error(oi);
    } catch {
    }
  });
  function ai() {
    return null;
  }
  return factoryWithTypeCheckers$1 = function(li, oi) {
    var si = typeof Symbol == "function" && Symbol.iterator, di = "@@iterator";
    function fi(Wi) {
      var ji = Wi && (si && Wi[si] || Wi[di]);
      if (typeof ji == "function")
        return ji;
    }
    var gi = "<<anonymous>>", mi = {
      array: Si("array"),
      bigint: Si("bigint"),
      bool: Si("boolean"),
      func: Si("function"),
      number: Si("number"),
      object: Si("object"),
      string: Si("string"),
      symbol: Si("symbol"),
      any: Pi(),
      arrayOf: $i,
      element: Oi(),
      elementType: Di(),
      instanceOf: Mi,
      node: fo(),
      objectOf: io,
      oneOf: Oo,
      oneOfType: xo,
      shape: Li,
      exact: Co
    };
    function Ti(Wi, ji) {
      return Wi === ji ? Wi !== 0 || 1 / Wi === 1 / ji : Wi !== Wi && ji !== ji;
    }
    function vi(Wi, ji) {
      this.message = Wi, this.data = ji && typeof ji == "object" ? ji : {}, this.stack = "";
    }
    vi.prototype = Error.prototype;
    function xi(Wi) {
      if (process.env.NODE_ENV !== "production")
        var ji = {}, Hi = 0;
      function zo(sa, Ko, ca, pa, ga, ia, ra) {
        if (pa = pa || gi, ia = ia || ca, ra !== ir) {
          if (oi) {
            var qo = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw qo.name = "Invariant Violation", qo;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var xa = pa + ":" + ca;
            !ji[xa] && // Avoid spamming the console because they are often not actionable except for lib authors
            Hi < 3 && (ui(
              "You are manually calling a React.PropTypes validation function for the `" + ia + "` prop on `" + pa + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), ji[xa] = !0, Hi++);
          }
        }
        return Ko[ca] == null ? sa ? Ko[ca] === null ? new vi("The " + ga + " `" + ia + "` is marked as required " + ("in `" + pa + "`, but its value is `null`.")) : new vi("The " + ga + " `" + ia + "` is marked as required in " + ("`" + pa + "`, but its value is `undefined`.")) : null : Wi(Ko, ca, pa, ga, ia);
      }
      var Lo = zo.bind(null, !1);
      return Lo.isRequired = zo.bind(null, !0), Lo;
    }
    function Si(Wi) {
      function ji(Hi, zo, Lo, sa, Ko, ca) {
        var pa = Hi[zo], ga = Vo(pa);
        if (ga !== Wi) {
          var ia = No(pa);
          return new vi(
            "Invalid " + sa + " `" + Ko + "` of type " + ("`" + ia + "` supplied to `" + Lo + "`, expected ") + ("`" + Wi + "`."),
            { expectedType: Wi }
          );
        }
        return null;
      }
      return xi(ji);
    }
    function Pi() {
      return xi(ai);
    }
    function $i(Wi) {
      function ji(Hi, zo, Lo, sa, Ko) {
        if (typeof Wi != "function")
          return new vi("Property `" + Ko + "` of component `" + Lo + "` has invalid PropType notation inside arrayOf.");
        var ca = Hi[zo];
        if (!Array.isArray(ca)) {
          var pa = Vo(ca);
          return new vi("Invalid " + sa + " `" + Ko + "` of type " + ("`" + pa + "` supplied to `" + Lo + "`, expected an array."));
        }
        for (var ga = 0; ga < ca.length; ga++) {
          var ia = Wi(ca, ga, Lo, sa, Ko + "[" + ga + "]", ir);
          if (ia instanceof Error)
            return ia;
        }
        return null;
      }
      return xi(ji);
    }
    function Oi() {
      function Wi(ji, Hi, zo, Lo, sa) {
        var Ko = ji[Hi];
        if (!li(Ko)) {
          var ca = Vo(Ko);
          return new vi("Invalid " + Lo + " `" + sa + "` of type " + ("`" + ca + "` supplied to `" + zo + "`, expected a single ReactElement."));
        }
        return null;
      }
      return xi(Wi);
    }
    function Di() {
      function Wi(ji, Hi, zo, Lo, sa) {
        var Ko = ji[Hi];
        if (!pt.isValidElementType(Ko)) {
          var ca = Vo(Ko);
          return new vi("Invalid " + Lo + " `" + sa + "` of type " + ("`" + ca + "` supplied to `" + zo + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return xi(Wi);
    }
    function Mi(Wi) {
      function ji(Hi, zo, Lo, sa, Ko) {
        if (!(Hi[zo] instanceof Wi)) {
          var ca = Wi.name || gi, pa = jo(Hi[zo]);
          return new vi("Invalid " + sa + " `" + Ko + "` of type " + ("`" + pa + "` supplied to `" + Lo + "`, expected ") + ("instance of `" + ca + "`."));
        }
        return null;
      }
      return xi(ji);
    }
    function Oo(Wi) {
      if (!Array.isArray(Wi))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? ui(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : ui("Invalid argument supplied to oneOf, expected an array.")), ai;
      function ji(Hi, zo, Lo, sa, Ko) {
        for (var ca = Hi[zo], pa = 0; pa < Wi.length; pa++)
          if (Ti(ca, Wi[pa]))
            return null;
        var ga = JSON.stringify(Wi, function(ra, qo) {
          var xa = No(qo);
          return xa === "symbol" ? String(qo) : qo;
        });
        return new vi("Invalid " + sa + " `" + Ko + "` of value `" + String(ca) + "` " + ("supplied to `" + Lo + "`, expected one of " + ga + "."));
      }
      return xi(ji);
    }
    function io(Wi) {
      function ji(Hi, zo, Lo, sa, Ko) {
        if (typeof Wi != "function")
          return new vi("Property `" + Ko + "` of component `" + Lo + "` has invalid PropType notation inside objectOf.");
        var ca = Hi[zo], pa = Vo(ca);
        if (pa !== "object")
          return new vi("Invalid " + sa + " `" + Ko + "` of type " + ("`" + pa + "` supplied to `" + Lo + "`, expected an object."));
        for (var ga in ca)
          if (ti(ca, ga)) {
            var ia = Wi(ca, ga, Lo, sa, Ko + "." + ga, ir);
            if (ia instanceof Error)
              return ia;
          }
        return null;
      }
      return xi(ji);
    }
    function xo(Wi) {
      if (!Array.isArray(Wi))
        return process.env.NODE_ENV !== "production" && ui("Invalid argument supplied to oneOfType, expected an instance of array."), ai;
      for (var ji = 0; ji < Wi.length; ji++) {
        var Hi = Wi[ji];
        if (typeof Hi != "function")
          return ui(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Ui(Hi) + " at index " + ji + "."
          ), ai;
      }
      function zo(Lo, sa, Ko, ca, pa) {
        for (var ga = [], ia = 0; ia < Wi.length; ia++) {
          var ra = Wi[ia], qo = ra(Lo, sa, Ko, ca, pa, ir);
          if (qo == null)
            return null;
          qo.data && ti(qo.data, "expectedType") && ga.push(qo.data.expectedType);
        }
        var xa = ga.length > 0 ? ", expected one of type [" + ga.join(", ") + "]" : "";
        return new vi("Invalid " + ca + " `" + pa + "` supplied to " + ("`" + Ko + "`" + xa + "."));
      }
      return xi(zo);
    }
    function fo() {
      function Wi(ji, Hi, zo, Lo, sa) {
        return Ni(ji[Hi]) ? null : new vi("Invalid " + Lo + " `" + sa + "` supplied to " + ("`" + zo + "`, expected a ReactNode."));
      }
      return xi(Wi);
    }
    function _o(Wi, ji, Hi, zo, Lo) {
      return new vi(
        (Wi || "React class") + ": " + ji + " type `" + Hi + "." + zo + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Lo + "`."
      );
    }
    function Li(Wi) {
      function ji(Hi, zo, Lo, sa, Ko) {
        var ca = Hi[zo], pa = Vo(ca);
        if (pa !== "object")
          return new vi("Invalid " + sa + " `" + Ko + "` of type `" + pa + "` " + ("supplied to `" + Lo + "`, expected `object`."));
        for (var ga in Wi) {
          var ia = Wi[ga];
          if (typeof ia != "function")
            return _o(Lo, sa, Ko, ga, No(ia));
          var ra = ia(ca, ga, Lo, sa, Ko + "." + ga, ir);
          if (ra)
            return ra;
        }
        return null;
      }
      return xi(ji);
    }
    function Co(Wi) {
      function ji(Hi, zo, Lo, sa, Ko) {
        var ca = Hi[zo], pa = Vo(ca);
        if (pa !== "object")
          return new vi("Invalid " + sa + " `" + Ko + "` of type `" + pa + "` " + ("supplied to `" + Lo + "`, expected `object`."));
        var ga = yt({}, Hi[zo], Wi);
        for (var ia in ga) {
          var ra = Wi[ia];
          if (ti(Wi, ia) && typeof ra != "function")
            return _o(Lo, sa, Ko, ia, No(ra));
          if (!ra)
            return new vi(
              "Invalid " + sa + " `" + Ko + "` key `" + ia + "` supplied to `" + Lo + "`.\nBad object: " + JSON.stringify(Hi[zo], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(Wi), null, "  ")
            );
          var qo = ra(ca, ia, Lo, sa, Ko + "." + ia, ir);
          if (qo)
            return qo;
        }
        return null;
      }
      return xi(ji);
    }
    function Ni(Wi) {
      switch (typeof Wi) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !Wi;
        case "object":
          if (Array.isArray(Wi))
            return Wi.every(Ni);
          if (Wi === null || li(Wi))
            return !0;
          var ji = fi(Wi);
          if (ji) {
            var Hi = ji.call(Wi), zo;
            if (ji !== Wi.entries) {
              for (; !(zo = Hi.next()).done; )
                if (!Ni(zo.value))
                  return !1;
            } else
              for (; !(zo = Hi.next()).done; ) {
                var Lo = zo.value;
                if (Lo && !Ni(Lo[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Yi(Wi, ji) {
      return Wi === "symbol" ? !0 : ji ? ji["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && ji instanceof Symbol : !1;
    }
    function Vo(Wi) {
      var ji = typeof Wi;
      return Array.isArray(Wi) ? "array" : Wi instanceof RegExp ? "object" : Yi(ji, Wi) ? "symbol" : ji;
    }
    function No(Wi) {
      if (typeof Wi > "u" || Wi === null)
        return "" + Wi;
      var ji = Vo(Wi);
      if (ji === "object") {
        if (Wi instanceof Date)
          return "date";
        if (Wi instanceof RegExp)
          return "regexp";
      }
      return ji;
    }
    function Ui(Wi) {
      var ji = No(Wi);
      switch (ji) {
        case "array":
        case "object":
          return "an " + ji;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + ji;
        default:
          return ji;
      }
    }
    function jo(Wi) {
      return !Wi.constructor || !Wi.constructor.name ? gi : Wi.constructor.name;
    }
    return mi.checkPropTypes = ii, mi.resetWarningCache = ii.resetWarningCache, mi.PropTypes = mi, mi;
  }, factoryWithTypeCheckers$1;
}
var factoryWithThrowingShims$1, hasRequiredFactoryWithThrowingShims$1;
function requireFactoryWithThrowingShims$1() {
  if (hasRequiredFactoryWithThrowingShims$1) return factoryWithThrowingShims$1;
  hasRequiredFactoryWithThrowingShims$1 = 1;
  var pt = /* @__PURE__ */ requireReactPropTypesSecret$1();
  function yt() {
  }
  function ir() {
  }
  return ir.resetWarningCache = yt, factoryWithThrowingShims$1 = function() {
    function ti(ai, li, oi, si, di, fi) {
      if (fi !== pt) {
        var gi = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw gi.name = "Invariant Violation", gi;
      }
    }
    ti.isRequired = ti;
    function ii() {
      return ti;
    }
    var ui = {
      array: ti,
      bigint: ti,
      bool: ti,
      func: ti,
      number: ti,
      object: ti,
      string: ti,
      symbol: ti,
      any: ti,
      arrayOf: ii,
      element: ti,
      elementType: ti,
      instanceOf: ii,
      node: ti,
      objectOf: ii,
      oneOf: ii,
      oneOfType: ii,
      shape: ii,
      exact: ii,
      checkPropTypes: ir,
      resetWarningCache: yt
    };
    return ui.PropTypes = ui, ui;
  }, factoryWithThrowingShims$1;
}
var hasRequiredPropTypes$1;
function requirePropTypes$1() {
  if (hasRequiredPropTypes$1) return propTypes$1.exports;
  if (hasRequiredPropTypes$1 = 1, process.env.NODE_ENV !== "production") {
    var pt = requireReactIs$4(), yt = !0;
    propTypes$1.exports = /* @__PURE__ */ requireFactoryWithTypeCheckers$1()(pt.isElement, yt);
  } else
    propTypes$1.exports = /* @__PURE__ */ requireFactoryWithThrowingShims$1()();
  return propTypes$1.exports;
}
var propTypesExports$1 = /* @__PURE__ */ requirePropTypes$1();
const PropTypes$1 = /* @__PURE__ */ getDefaultExportFromCjs$1(propTypesExports$1);
var clspPlayer_min = { exports: {} }, hasRequiredClspPlayer_min;
function requireClspPlayer_min() {
  return hasRequiredClspPlayer_min || (hasRequiredClspPlayer_min = 1, (function(pt, yt) {
    (function(ti, ii) {
      pt.exports = ii();
    })(self, () => (
      /******/
      (() => {
        var ir = {
          /***/
          909: (
            /***/
            ((ai) => {
              ai.exports = function(li, oi, si) {
                function di(Si, Pi) {
                  if (oi === void 0 && typeof window < "u") {
                    var $i = window.localStorage.getItem("skylineos.clsp-player.version");
                    $i !== li && (window.localStorage.setItem("skylineos.clsp-player.logLevel", 0), window.localStorage.setItem("skylineos.clsp-player.version", li));
                    var Oi = Number(window.localStorage.getItem("skylineos.clsp-player.logLevel"));
                    oi = isNaN(Oi) || Oi < 0 ? 0 : Oi, window.localStorage.setItem("skylineos.clsp-player.logLevel", oi);
                  }
                  this.logLevel = oi, this.prefix = Si, this.prefixStyle = Pi;
                }
                di.logLevels = ["critical", "error", "warn", "info", "debug", "silly"], di.factory = function(Si, Pi) {
                  return new di(Si || "", Pi);
                }, di.prototype._constructMessage = function(Si, Pi) {
                  var $i = "(" + Si + ") --> " + Pi;
                  return this.prefix && this.prefixStyle && this.logLevel > 1 ? ["%c" + this.prefix, this.prefixStyle, $i] : this.prefix ? [this.prefix, $i] : [$i];
                };
                var fi = 5, gi = 4, mi = 3, Ti = 2, vi = 1, xi = 0;
                return di.prototype.silly = function(Si) {
                  this.logLevel < fi || si || console.log.apply(console, this._constructMessage(di.logLevels[fi], Si));
                }, di.prototype.debug = function(Si) {
                  this.logLevel < gi || si || console.log.apply(console, this._constructMessage(di.logLevels[gi], Si));
                }, di.prototype.info = function(Si) {
                  this.logLevel < mi || si || console.log.apply(console, this._constructMessage(di.logLevels[mi], Si));
                }, di.prototype.warn = function(Si) {
                  this.logLevel < Ti || si || console.warn.apply(console, this._constructMessage(di.logLevels[Ti], Si));
                }, di.prototype.error = function(Si) {
                  this.logLevel < vi || si || console.error.apply(console, this._constructMessage(di.logLevels[vi], Si));
                }, di.prototype.critical = function(Si) {
                  si || console.error.apply(console, this._constructMessage(di.logLevels[xi], Si));
                }, di;
              };
            })
          ),
          /***/
          8192: (
            /***/
            ((ai, li, oi) => {
              var si = oi(4007), di = oi(6586), fi = oi(8330), gi = oi(909), mi = !0, Ti = 80, vi = 443, xi = {
                clsp: Ti,
                clsps: vi
              }, Si = fi.name.split("/").pop(), Pi = fi.version, $i = gi(Pi).factory(), Oi = 53, Di = "video/mp4; codecs='avc1.42E01E'", Mi = 20;
              function Oo() {
                var Ui, jo, Wi;
                if (window.MediaSource = window.MediaSource || window.WebKitMediaSource, !window.MediaSource)
                  return console.error("Media Source Extensions not supported in your browser, unable to load CLSP Player"), !1;
                var ji = si(Ui = navigator.userAgent.toLowerCase()).call(Ui, "trident") > -1;
                if (ji)
                  return $i.debug("Detected Internet Explorer browser, which is not supported."), !1;
                var Hi = si(jo = navigator.userAgent.toLowerCase()).call(jo, "edge") > -1;
                if (Hi)
                  return $i.debug("Detected older Edge browser, which is not supported"), !1;
                var zo = si(Wi = navigator.userAgent.toLowerCase()).call(Wi, "firefox") > -1;
                if (zo)
                  return $i.debug("Detected Firefox browser"), !0;
                var Lo = !!window.chrome;
                if (!Lo)
                  return !1;
                try {
                  var sa = di(navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./)[2], 10);
                  return $i.debug("Detected Chrome version ".concat(sa)), sa >= Oi;
                } catch (Ko) {
                  return $i.critical("Unable to detect Chrome version"), $i.critical(Ko), !1;
                }
              }
              function io(Ui) {
                return Ui === Di;
              }
              function xo() {
                return $i.debug("Determining Page_Visibility_API property names."), typeof document > "u" ? {
                  hiddenStateName: "",
                  visibilityChangeEventName: ""
                } : typeof document.hidden < "u" ? ($i.debug("Using standard Page_Visibility_API property names."), {
                  hiddenStateName: "hidden",
                  visibilityChangeEventName: "visibilitychange"
                }) : typeof document.msHidden < "u" ? ($i.debug("Using Microsoft Page_Visibility_API property names."), {
                  hiddenStateName: "msHidden",
                  visibilityChangeEventName: "msvisibilitychange"
                }) : typeof document.webkitHidden < "u" ? ($i.debug("Using Webkit Page_Visibility_API property names."), {
                  hiddenStateName: "webkitHidden",
                  visibilityChangeEventName: "webkitvisibilitychange"
                }) : ($i.critical("Unable to use the page visibility api - switching tabs and minimizing the page may result in slow downs and page crashes."), {
                  hiddenStateName: "",
                  visibilityChangeEventName: ""
                });
              }
              function fo(Ui) {
                return xi[Ui];
              }
              function _o(Ui, jo) {
                xi[Ui] = jo;
              }
              function Li() {
                mi = !0;
              }
              function Co() {
                mi = !1;
              }
              function Ni() {
                return !mi;
              }
              var Yi = xo();
              function Vo() {
                return document[Yi.hiddenStateName];
              }
              function No() {
                return window.navigator.onLine;
              }
              ai.exports = {
                name: Si,
                version: Pi,
                MINIMUM_CHROME_VERSION: Oi,
                SUPPORTED_MIME_TYPE: Di,
                DEFAULT_STREAM_TIMEOUT: Mi,
                supported: Oo,
                isSupportedMimeType: io,
                windowStateNames: Yi,
                isDocumentHidden: Vo,
                isOnline: No,
                getDefaultStreamPort: fo,
                setDefaultStreamPort: _o,
                enablePlayerLogging: Li,
                disablePlayerLogging: Co,
                isPlayerLoggingDisabled: Ni
              };
            })
          ),
          /***/
          228: (
            /***/
            ((ai) => {
              var li = Object.prototype.hasOwnProperty, oi = "~";
              function si() {
              }
              Object.create && (si.prototype = /* @__PURE__ */ Object.create(null), new si().__proto__ || (oi = !1));
              function di(Ti, vi, xi) {
                this.fn = Ti, this.context = vi, this.once = xi || !1;
              }
              function fi(Ti, vi, xi, Si, Pi) {
                if (typeof xi != "function")
                  throw new TypeError("The listener must be a function");
                var $i = new di(xi, Si || Ti, Pi), Oi = oi ? oi + vi : vi;
                return Ti._events[Oi] ? Ti._events[Oi].fn ? Ti._events[Oi] = [Ti._events[Oi], $i] : Ti._events[Oi].push($i) : (Ti._events[Oi] = $i, Ti._eventsCount++), Ti;
              }
              function gi(Ti, vi) {
                --Ti._eventsCount === 0 ? Ti._events = new si() : delete Ti._events[vi];
              }
              function mi() {
                this._events = new si(), this._eventsCount = 0;
              }
              mi.prototype.eventNames = function() {
                var vi = [], xi, Si;
                if (this._eventsCount === 0) return vi;
                for (Si in xi = this._events)
                  li.call(xi, Si) && vi.push(oi ? Si.slice(1) : Si);
                return Object.getOwnPropertySymbols ? vi.concat(Object.getOwnPropertySymbols(xi)) : vi;
              }, mi.prototype.listeners = function(vi) {
                var xi = oi ? oi + vi : vi, Si = this._events[xi];
                if (!Si) return [];
                if (Si.fn) return [Si.fn];
                for (var Pi = 0, $i = Si.length, Oi = new Array($i); Pi < $i; Pi++)
                  Oi[Pi] = Si[Pi].fn;
                return Oi;
              }, mi.prototype.listenerCount = function(vi) {
                var xi = oi ? oi + vi : vi, Si = this._events[xi];
                return Si ? Si.fn ? 1 : Si.length : 0;
              }, mi.prototype.emit = function(vi, xi, Si, Pi, $i, Oi) {
                var Di = oi ? oi + vi : vi;
                if (!this._events[Di]) return !1;
                var Mi = this._events[Di], Oo = arguments.length, io, xo;
                if (Mi.fn) {
                  switch (Mi.once && this.removeListener(vi, Mi.fn, void 0, !0), Oo) {
                    case 1:
                      return Mi.fn.call(Mi.context), !0;
                    case 2:
                      return Mi.fn.call(Mi.context, xi), !0;
                    case 3:
                      return Mi.fn.call(Mi.context, xi, Si), !0;
                    case 4:
                      return Mi.fn.call(Mi.context, xi, Si, Pi), !0;
                    case 5:
                      return Mi.fn.call(Mi.context, xi, Si, Pi, $i), !0;
                    case 6:
                      return Mi.fn.call(Mi.context, xi, Si, Pi, $i, Oi), !0;
                  }
                  for (xo = 1, io = new Array(Oo - 1); xo < Oo; xo++)
                    io[xo - 1] = arguments[xo];
                  Mi.fn.apply(Mi.context, io);
                } else {
                  var fo = Mi.length, _o;
                  for (xo = 0; xo < fo; xo++)
                    switch (Mi[xo].once && this.removeListener(vi, Mi[xo].fn, void 0, !0), Oo) {
                      case 1:
                        Mi[xo].fn.call(Mi[xo].context);
                        break;
                      case 2:
                        Mi[xo].fn.call(Mi[xo].context, xi);
                        break;
                      case 3:
                        Mi[xo].fn.call(Mi[xo].context, xi, Si);
                        break;
                      case 4:
                        Mi[xo].fn.call(Mi[xo].context, xi, Si, Pi);
                        break;
                      default:
                        if (!io) for (_o = 1, io = new Array(Oo - 1); _o < Oo; _o++)
                          io[_o - 1] = arguments[_o];
                        Mi[xo].fn.apply(Mi[xo].context, io);
                    }
                }
                return !0;
              }, mi.prototype.on = function(vi, xi, Si) {
                return fi(this, vi, xi, Si, !1);
              }, mi.prototype.once = function(vi, xi, Si) {
                return fi(this, vi, xi, Si, !0);
              }, mi.prototype.removeListener = function(vi, xi, Si, Pi) {
                var $i = oi ? oi + vi : vi;
                if (!this._events[$i]) return this;
                if (!xi)
                  return gi(this, $i), this;
                var Oi = this._events[$i];
                if (Oi.fn)
                  Oi.fn === xi && (!Pi || Oi.once) && (!Si || Oi.context === Si) && gi(this, $i);
                else {
                  for (var Di = 0, Mi = [], Oo = Oi.length; Di < Oo; Di++)
                    (Oi[Di].fn !== xi || Pi && !Oi[Di].once || Si && Oi[Di].context !== Si) && Mi.push(Oi[Di]);
                  Mi.length ? this._events[$i] = Mi.length === 1 ? Mi[0] : Mi : gi(this, $i);
                }
                return this;
              }, mi.prototype.removeAllListeners = function(vi) {
                var xi;
                return vi ? (xi = oi ? oi + vi : vi, this._events[xi] && gi(this, xi)) : (this._events = new si(), this._eventsCount = 0), this;
              }, mi.prototype.off = mi.prototype.removeListener, mi.prototype.addListener = mi.prototype.on, mi.prefixed = oi, mi.EventEmitter = mi, ai.exports = mi;
            })
          ),
          /***/
          2973: (
            /***/
            ((ai) => {
              function li(di) {
                return di != null && typeof di.then == "function";
              }
              function oi(di, fi, gi = {}) {
                si(di, fi, gi);
                const Ti = Object.assign({
                  iterations: 1 / 0,
                  stopOnError: !0
                }, gi);
                return new Promise((vi, xi) => {
                  const Si = (Pi) => {
                    let $i = !1;
                    const Oi = () => {
                      $i = !0;
                    }, Di = () => {
                      if (Pi === Ti.iterations || $i) {
                        vi();
                        return;
                      }
                      Si(Pi + 1);
                    }, Mi = typeof fi == "function" ? fi(Pi) : fi;
                    if (typeof fi == "function" && (!Number.isInteger(Mi) || Mi < 0)) {
                      xi(new Error('Function for "intervalLength" argument must return a non-negative integer.'));
                      return;
                    }
                    setTimeout(() => {
                      const Oo = di(Pi, Oi);
                      if (!li(Oo)) {
                        xi(new Error('Return value of "func" must be a Promise.'));
                        return;
                      }
                      Oo.then(Di).catch((io) => {
                        if (!Ti.stopOnError) {
                          Di();
                          return;
                        }
                        xi(io);
                      });
                    }, Mi);
                  };
                  Si(1);
                });
              }
              function si(di, fi, gi) {
                if (typeof di != "function")
                  throw new TypeError('Argument 1, "func", must be a function.');
                if (typeof fi == "number") {
                  if (!Number.isInteger(fi) || fi < 0)
                    throw new TypeError('Argument 2, "intervalLength", must be a non-negative integer or a function that returns a non-negative integer.');
                } else if (typeof fi != "function")
                  throw new TypeError('Argument 2, "intervalLength", must be a non-negative integer or a function that returns a non-negative integer.');
                if (typeof gi != "object")
                  throw new TypeError('Argument 3, "options", must be an object.');
                const mi = ["iterations", "stopOnError"];
                if (Object.keys(gi).forEach((Ti) => {
                  if (!mi.includes(Ti))
                    throw new TypeError('Option "' + Ti + '" is not a valid option.');
                }), typeof gi.iterations < "u" && gi.iterations !== 1 / 0 && (!Number.isInteger(gi.iterations) || gi.iterations < 1))
                  throw new TypeError('Option "iterations" must be Infinity or an integer greater than 0.');
                if (typeof gi.stopOnError < "u" && typeof gi.stopOnError != "boolean")
                  throw new TypeError('Option "stopOnError" must be a boolean.');
              }
              ai.exports = oi;
            })
          ),
          /***/
          9843: (
            /***/
            ((ai) => {
              function li(oi) {
                return oi == null;
              }
              ai.exports = li;
            })
          ),
          /***/
          7924: (
            /***/
            (function(ai, li, oi) {
              (function(di, fi) {
                ai.exports = fi();
              })(this, function() {
                var di = (function(fi) {
                  var gi = "@VERSION@-@BUILDLEVEL@", mi = fi.localStorage || /* @__PURE__ */ (function() {
                    var Wi = {};
                    return {
                      setItem: function(ji, Hi) {
                        Wi[ji] = Hi;
                      },
                      getItem: function(ji) {
                        return Wi[ji];
                      },
                      removeItem: function(ji) {
                        delete Wi[ji];
                      }
                    };
                  })(), Ti = {
                    CONNECT: 1,
                    CONNACK: 2,
                    PUBLISH: 3,
                    PUBACK: 4,
                    PUBREC: 5,
                    PUBREL: 6,
                    PUBCOMP: 7,
                    SUBSCRIBE: 8,
                    SUBACK: 9,
                    UNSUBSCRIBE: 10,
                    UNSUBACK: 11,
                    PINGREQ: 12,
                    PINGRESP: 13,
                    DISCONNECT: 14
                  }, vi = function(Wi, ji) {
                    for (var Hi in Wi)
                      if (Wi.hasOwnProperty(Hi))
                        if (ji.hasOwnProperty(Hi)) {
                          if (typeof Wi[Hi] !== ji[Hi])
                            throw new Error($i(Si.INVALID_TYPE, [typeof Wi[Hi], Hi]));
                        } else {
                          var zo = "Unknown property, " + Hi + ". Valid properties are:";
                          for (var Lo in ji)
                            ji.hasOwnProperty(Lo) && (zo = zo + " " + Lo);
                          throw new Error(zo);
                        }
                  }, xi = function(Wi, ji) {
                    return function() {
                      return Wi.apply(ji, arguments);
                    };
                  }, Si = {
                    OK: { code: 0, text: "AMQJSC0000I OK." },
                    CONNECT_TIMEOUT: { code: 1, text: "AMQJSC0001E Connect timed out." },
                    SUBSCRIBE_TIMEOUT: { code: 2, text: "AMQJS0002E Subscribe timed out." },
                    UNSUBSCRIBE_TIMEOUT: { code: 3, text: "AMQJS0003E Unsubscribe timed out." },
                    PING_TIMEOUT: { code: 4, text: "AMQJS0004E Ping timed out." },
                    INTERNAL_ERROR: { code: 5, text: "AMQJS0005E Internal error. Error Message: {0}, Stack trace: {1}" },
                    CONNACK_RETURNCODE: { code: 6, text: "AMQJS0006E Bad Connack return code:{0} {1}." },
                    SOCKET_ERROR: { code: 7, text: "AMQJS0007E Socket error:{0}." },
                    SOCKET_CLOSE: { code: 8, text: "AMQJS0008I Socket closed." },
                    MALFORMED_UTF: { code: 9, text: "AMQJS0009E Malformed UTF data:{0} {1} {2}." },
                    UNSUPPORTED: { code: 10, text: "AMQJS0010E {0} is not supported by this browser." },
                    INVALID_STATE: { code: 11, text: "AMQJS0011E Invalid state {0}." },
                    INVALID_TYPE: { code: 12, text: "AMQJS0012E Invalid type {0} for {1}." },
                    INVALID_ARGUMENT: { code: 13, text: "AMQJS0013E Invalid argument {0} for {1}." },
                    UNSUPPORTED_OPERATION: { code: 14, text: "AMQJS0014E Unsupported operation." },
                    INVALID_STORED_DATA: { code: 15, text: "AMQJS0015E Invalid data in local storage key={0} value={1}." },
                    INVALID_MQTT_MESSAGE_TYPE: { code: 16, text: "AMQJS0016E Invalid MQTT message type {0}." },
                    MALFORMED_UNICODE: { code: 17, text: "AMQJS0017E Malformed Unicode string:{0} {1}." },
                    BUFFER_FULL: { code: 18, text: "AMQJS0018E Message buffer is full, maximum buffer size: {0}." }
                  }, Pi = {
                    0: "Connection Accepted",
                    1: "Connection Refused: unacceptable protocol version",
                    2: "Connection Refused: identifier rejected",
                    3: "Connection Refused: server unavailable",
                    4: "Connection Refused: bad user name or password",
                    5: "Connection Refused: not authorized"
                  }, $i = function(Wi, ji) {
                    var Hi = Wi.text;
                    if (ji) {
                      for (var zo, Lo, sa = 0; sa < ji.length; sa++)
                        if (zo = "{" + sa + "}", Lo = Hi.indexOf(zo), Lo > 0) {
                          var Ko = Hi.substring(0, Lo), ca = Hi.substring(Lo + zo.length);
                          Hi = Ko + ji[sa] + ca;
                        }
                    }
                    return Hi;
                  }, Oi = [0, 6, 77, 81, 73, 115, 100, 112, 3], Di = [0, 4, 77, 81, 84, 84, 4], Mi = function(Wi, ji) {
                    this.type = Wi;
                    for (var Hi in ji)
                      ji.hasOwnProperty(Hi) && (this[Hi] = ji[Hi]);
                  };
                  Mi.prototype.encode = function() {
                    var Wi = (this.type & 15) << 4, ji = 0, Hi = [], zo = 0, Lo;
                    switch (this.messageIdentifier !== void 0 && (ji += 2), this.type) {
                      // If this a Connect then we need to include 12 bytes for its header
                      case Ti.CONNECT:
                        switch (this.mqttVersion) {
                          case 3:
                            ji += Oi.length + 3;
                            break;
                          case 4:
                            ji += Di.length + 3;
                            break;
                        }
                        ji += Li(this.clientId) + 2, this.willMessage !== void 0 && (ji += Li(this.willMessage.destinationName) + 2, Lo = this.willMessage.payloadBytes, Lo instanceof Uint8Array || (Lo = new Uint8Array(Ko)), ji += Lo.byteLength + 2), this.userName !== void 0 && (ji += Li(this.userName) + 2), this.password !== void 0 && (ji += Li(this.password) + 2);
                        break;
                      // Subscribe, Unsubscribe can both contain topic strings
                      case Ti.SUBSCRIBE:
                        Wi |= 2;
                        for (var sa = 0; sa < this.topics.length; sa++)
                          Hi[sa] = Li(this.topics[sa]), ji += Hi[sa] + 2;
                        ji += this.requestedQos.length;
                        break;
                      case Ti.UNSUBSCRIBE:
                        Wi |= 2;
                        for (var sa = 0; sa < this.topics.length; sa++)
                          Hi[sa] = Li(this.topics[sa]), ji += Hi[sa] + 2;
                        break;
                      case Ti.PUBREL:
                        Wi |= 2;
                        break;
                      case Ti.PUBLISH:
                        this.payloadMessage.duplicate && (Wi |= 8), Wi = Wi |= this.payloadMessage.qos << 1, this.payloadMessage.retained && (Wi |= 1), zo = Li(this.payloadMessage.destinationName), ji += zo + 2;
                        var Ko = this.payloadMessage.payloadBytes;
                        ji += Ko.byteLength, Ko instanceof ArrayBuffer ? Ko = new Uint8Array(Ko) : Ko instanceof Uint8Array || (Ko = new Uint8Array(Ko.buffer));
                        break;
                    }
                    var ca = _o(ji), pa = ca.length + 1, ga = new ArrayBuffer(ji + pa), ia = new Uint8Array(ga);
                    if (ia[0] = Wi, ia.set(ca, 1), this.type == Ti.PUBLISH)
                      pa = xo(this.payloadMessage.destinationName, zo, ia, pa);
                    else if (this.type == Ti.CONNECT) {
                      switch (this.mqttVersion) {
                        case 3:
                          ia.set(Oi, pa), pa += Oi.length;
                          break;
                        case 4:
                          ia.set(Di, pa), pa += Di.length;
                          break;
                      }
                      var ra = 0;
                      this.cleanSession && (ra = 2), this.willMessage !== void 0 && (ra |= 4, ra |= this.willMessage.qos << 3, this.willMessage.retained && (ra |= 32)), this.userName !== void 0 && (ra |= 128), this.password !== void 0 && (ra |= 64), ia[pa++] = ra, pa = io(this.keepAliveInterval, ia, pa);
                    }
                    switch (this.messageIdentifier !== void 0 && (pa = io(this.messageIdentifier, ia, pa)), this.type) {
                      case Ti.CONNECT:
                        pa = xo(this.clientId, Li(this.clientId), ia, pa), this.willMessage !== void 0 && (pa = xo(this.willMessage.destinationName, Li(this.willMessage.destinationName), ia, pa), pa = io(Lo.byteLength, ia, pa), ia.set(Lo, pa), pa += Lo.byteLength), this.userName !== void 0 && (pa = xo(this.userName, Li(this.userName), ia, pa)), this.password !== void 0 && (pa = xo(this.password, Li(this.password), ia, pa));
                        break;
                      case Ti.PUBLISH:
                        ia.set(Ko, pa);
                        break;
                      //    	    case MESSAGE_TYPE.PUBREC:
                      //    	    case MESSAGE_TYPE.PUBREL:
                      //    	    case MESSAGE_TYPE.PUBCOMP:
                      //    	    	break;
                      case Ti.SUBSCRIBE:
                        for (var sa = 0; sa < this.topics.length; sa++)
                          pa = xo(this.topics[sa], Hi[sa], ia, pa), ia[pa++] = this.requestedQos[sa];
                        break;
                      case Ti.UNSUBSCRIBE:
                        for (var sa = 0; sa < this.topics.length; sa++)
                          pa = xo(this.topics[sa], Hi[sa], ia, pa);
                        break;
                    }
                    return ga;
                  };
                  function Oo(Wi, ji) {
                    var Hi = ji, zo = Wi[ji], Lo = zo >> 4, sa = zo &= 15;
                    ji += 1;
                    var Ko, ca = 0, pa = 1;
                    do {
                      if (ji == Wi.length)
                        return [null, Hi];
                      Ko = Wi[ji++], ca += (Ko & 127) * pa, pa *= 128;
                    } while ((Ko & 128) !== 0);
                    var ga = ji + ca;
                    if (ga > Wi.length)
                      return [null, Hi];
                    var ia = new Mi(Lo);
                    switch (Lo) {
                      case Ti.CONNACK:
                        var ra = Wi[ji++];
                        ra & 1 && (ia.sessionPresent = !0), ia.returnCode = Wi[ji++];
                        break;
                      case Ti.PUBLISH:
                        var qo = sa >> 1 & 3, xa = fo(Wi, ji);
                        ji += 2;
                        var $a = Ni(Wi, ji, xa);
                        ji += xa, qo > 0 && (ia.messageIdentifier = fo(Wi, ji), ji += 2);
                        var ys = new jo(Wi.subarray(ji, ga));
                        (sa & 1) == 1 && (ys.retained = !0), (sa & 8) == 8 && (ys.duplicate = !0), ys.qos = qo, ys.destinationName = $a, ia.payloadMessage = ys;
                        break;
                      case Ti.PUBACK:
                      case Ti.PUBREC:
                      case Ti.PUBREL:
                      case Ti.PUBCOMP:
                      case Ti.UNSUBACK:
                        ia.messageIdentifier = fo(Wi, ji);
                        break;
                      case Ti.SUBACK:
                        ia.messageIdentifier = fo(Wi, ji), ji += 2, ia.returnCode = Wi.subarray(ji, ga);
                        break;
                    }
                    return [ia, ga];
                  }
                  function io(Wi, ji, Hi) {
                    return ji[Hi++] = Wi >> 8, ji[Hi++] = Wi % 256, Hi;
                  }
                  function xo(Wi, ji, Hi, zo) {
                    return zo = io(ji, Hi, zo), Co(Wi, Hi, zo), zo + ji;
                  }
                  function fo(Wi, ji) {
                    return 256 * Wi[ji] + Wi[ji + 1];
                  }
                  function _o(Wi) {
                    var ji = new Array(1), Hi = 0;
                    do {
                      var zo = Wi % 128;
                      Wi = Wi >> 7, Wi > 0 && (zo |= 128), ji[Hi++] = zo;
                    } while (Wi > 0 && Hi < 4);
                    return ji;
                  }
                  function Li(Wi) {
                    for (var ji = 0, Hi = 0; Hi < Wi.length; Hi++) {
                      var zo = Wi.charCodeAt(Hi);
                      zo > 2047 ? (55296 <= zo && zo <= 56319 && (Hi++, ji++), ji += 3) : zo > 127 ? ji += 2 : ji++;
                    }
                    return ji;
                  }
                  function Co(Wi, ji, Hi) {
                    for (var zo = Hi, Lo = 0; Lo < Wi.length; Lo++) {
                      var sa = Wi.charCodeAt(Lo);
                      if (55296 <= sa && sa <= 56319) {
                        var Ko = Wi.charCodeAt(++Lo);
                        if (isNaN(Ko))
                          throw new Error($i(Si.MALFORMED_UNICODE, [sa, Ko]));
                        sa = (sa - 55296 << 10) + (Ko - 56320) + 65536;
                      }
                      sa <= 127 ? ji[zo++] = sa : sa <= 2047 ? (ji[zo++] = sa >> 6 & 31 | 192, ji[zo++] = sa & 63 | 128) : sa <= 65535 ? (ji[zo++] = sa >> 12 & 15 | 224, ji[zo++] = sa >> 6 & 63 | 128, ji[zo++] = sa & 63 | 128) : (ji[zo++] = sa >> 18 & 7 | 240, ji[zo++] = sa >> 12 & 63 | 128, ji[zo++] = sa >> 6 & 63 | 128, ji[zo++] = sa & 63 | 128);
                    }
                    return ji;
                  }
                  function Ni(Wi, ji, Hi) {
                    for (var zo = "", Lo, sa = ji; sa < ji + Hi; ) {
                      var Ko = Wi[sa++];
                      if (Ko < 128)
                        Lo = Ko;
                      else {
                        var ca = Wi[sa++] - 128;
                        if (ca < 0)
                          throw new Error($i(Si.MALFORMED_UTF, [Ko.toString(16), ca.toString(16), ""]));
                        if (Ko < 224)
                          Lo = 64 * (Ko - 192) + ca;
                        else {
                          var pa = Wi[sa++] - 128;
                          if (pa < 0)
                            throw new Error($i(Si.MALFORMED_UTF, [Ko.toString(16), ca.toString(16), pa.toString(16)]));
                          if (Ko < 240)
                            Lo = 4096 * (Ko - 224) + 64 * ca + pa;
                          else {
                            var ga = Wi[sa++] - 128;
                            if (ga < 0)
                              throw new Error($i(Si.MALFORMED_UTF, [Ko.toString(16), ca.toString(16), pa.toString(16), ga.toString(16)]));
                            if (Ko < 248)
                              Lo = 262144 * (Ko - 240) + 4096 * ca + 64 * pa + ga;
                            else
                              throw new Error($i(Si.MALFORMED_UTF, [Ko.toString(16), ca.toString(16), pa.toString(16), ga.toString(16)]));
                          }
                        }
                      }
                      Lo > 65535 && (Lo -= 65536, zo += String.fromCharCode(55296 + (Lo >> 10)), Lo = 56320 + (Lo & 1023)), zo += String.fromCharCode(Lo);
                    }
                    return zo;
                  }
                  var Yi = function(Wi, ji) {
                    this._client = Wi, this._keepAliveInterval = ji * 1e3, this.isReset = !1;
                    var Hi = new Mi(Ti.PINGREQ).encode(), zo = function(sa) {
                      return function() {
                        return Lo.apply(sa);
                      };
                    }, Lo = function() {
                      this.isReset ? (this.isReset = !1, this._client._trace("Pinger.doPing", "send PINGREQ"), this._client.socket.send(Hi), this.timeout = setTimeout(zo(this), this._keepAliveInterval)) : (this._client._trace("Pinger.doPing", "Timed out"), this._client._disconnected(Si.PING_TIMEOUT.code, $i(Si.PING_TIMEOUT)));
                    };
                    this.reset = function() {
                      this.isReset = !0, clearTimeout(this.timeout), this._keepAliveInterval > 0 && (this.timeout = setTimeout(zo(this), this._keepAliveInterval));
                    }, this.cancel = function() {
                      clearTimeout(this.timeout);
                    };
                  }, Vo = function(Wi, ji, Hi, zo) {
                    ji || (ji = 30);
                    var Lo = function(sa, Ko, ca) {
                      return function() {
                        return sa.apply(Ko, ca);
                      };
                    };
                    this.timeout = setTimeout(Lo(Hi, Wi, zo), ji * 1e3), this.cancel = function() {
                      clearTimeout(this.timeout);
                    };
                  }, No = function(Wi, ji, Hi, zo, Lo) {
                    if (!("WebSocket" in fi && fi.WebSocket !== null))
                      throw new Error($i(Si.UNSUPPORTED, ["WebSocket"]));
                    if (!("ArrayBuffer" in fi && fi.ArrayBuffer !== null))
                      throw new Error($i(Si.UNSUPPORTED, ["ArrayBuffer"]));
                    this._trace("Paho.Client", Wi, ji, Hi, zo, Lo), this.host = ji, this.port = Hi, this.path = zo, this.uri = Wi, this.clientId = Lo, this._wsuri = null, this._localKey = ji + ":" + Hi + (zo != "/mqtt" ? ":" + zo : "") + ":" + Lo + ":", this._msg_queue = [], this._buffered_msg_queue = [], this._sentMessages = {}, this._receivedMessages = {}, this._notify_msg_sent = {}, this._message_identifier = 1, this._sequence = 0;
                    for (var sa in mi)
                      (sa.indexOf("Sent:" + this._localKey) === 0 || sa.indexOf("Received:" + this._localKey) === 0) && this.restore(sa);
                  };
                  No.prototype.host = null, No.prototype.port = null, No.prototype.path = null, No.prototype.uri = null, No.prototype.clientId = null, No.prototype.socket = null, No.prototype.connected = !1, No.prototype.maxMessageIdentifier = 65536, No.prototype.connectOptions = null, No.prototype.hostIndex = null, No.prototype.onConnected = null, No.prototype.onConnectionLost = null, No.prototype.onMessageDelivered = null, No.prototype.onMessageArrived = null, No.prototype.traceFunction = null, No.prototype._msg_queue = null, No.prototype._buffered_msg_queue = null, No.prototype._connectTimeout = null, No.prototype.sendPinger = null, No.prototype.receivePinger = null, No.prototype._reconnectInterval = 1, No.prototype._reconnecting = !1, No.prototype._reconnectTimeout = null, No.prototype.disconnectedPublishing = !1, No.prototype.disconnectedBufferSize = 5e3, No.prototype.receiveBuffer = null, No.prototype._traceBuffer = null, No.prototype._MAX_TRACE_ENTRIES = 100, No.prototype.connect = function(Wi) {
                    var ji = this._traceMask(Wi, "password");
                    if (this._trace("Client.connect", ji, this.socket, this.connected), this.connected)
                      throw new Error($i(Si.INVALID_STATE, ["already connected"]));
                    if (this.socket)
                      throw new Error($i(Si.INVALID_STATE, ["already connected"]));
                    this._reconnecting && (this._reconnectTimeout.cancel(), this._reconnectTimeout = null, this._reconnecting = !1), this.connectOptions = Wi, this._reconnectInterval = 1, this._reconnecting = !1, Wi.uris ? (this.hostIndex = 0, this._doConnect(Wi.uris[0])) : this._doConnect(this.uri);
                  }, No.prototype.subscribe = function(Wi, ji) {
                    if (this._trace("Client.subscribe", Wi, ji), !this.connected)
                      throw new Error($i(Si.INVALID_STATE, ["not connected"]));
                    var Hi = new Mi(Ti.SUBSCRIBE);
                    Hi.topics = Wi.constructor === Array ? Wi : [Wi], ji.qos === void 0 && (ji.qos = 0), Hi.requestedQos = [];
                    for (var zo = 0; zo < Hi.topics.length; zo++)
                      Hi.requestedQos[zo] = ji.qos;
                    ji.onSuccess && (Hi.onSuccess = function(Lo) {
                      ji.onSuccess({ invocationContext: ji.invocationContext, grantedQos: Lo });
                    }), ji.onFailure && (Hi.onFailure = function(Lo) {
                      ji.onFailure({ invocationContext: ji.invocationContext, errorCode: Lo, errorMessage: $i(Lo) });
                    }), ji.timeout && (Hi.timeOut = new Vo(
                      this,
                      ji.timeout,
                      ji.onFailure,
                      [{
                        invocationContext: ji.invocationContext,
                        errorCode: Si.SUBSCRIBE_TIMEOUT.code,
                        errorMessage: $i(Si.SUBSCRIBE_TIMEOUT)
                      }]
                    )), this._requires_ack(Hi), this._schedule_message(Hi);
                  }, No.prototype.unsubscribe = function(Wi, ji) {
                    if (this._trace("Client.unsubscribe", Wi, ji), !this.connected)
                      throw new Error($i(Si.INVALID_STATE, ["not connected"]));
                    var Hi = new Mi(Ti.UNSUBSCRIBE);
                    Hi.topics = Wi.constructor === Array ? Wi : [Wi], ji.onSuccess && (Hi.callback = function() {
                      ji.onSuccess({ invocationContext: ji.invocationContext });
                    }), ji.timeout && (Hi.timeOut = new Vo(
                      this,
                      ji.timeout,
                      ji.onFailure,
                      [{
                        invocationContext: ji.invocationContext,
                        errorCode: Si.UNSUBSCRIBE_TIMEOUT.code,
                        errorMessage: $i(Si.UNSUBSCRIBE_TIMEOUT)
                      }]
                    )), this._requires_ack(Hi), this._schedule_message(Hi);
                  }, No.prototype.send = function(Wi) {
                    this._trace("Client.send", Wi);
                    var ji = new Mi(Ti.PUBLISH);
                    if (ji.payloadMessage = Wi, this.connected)
                      Wi.qos > 0 ? this._requires_ack(ji) : this.onMessageDelivered && (this._notify_msg_sent[ji] = this.onMessageDelivered(ji.payloadMessage)), this._schedule_message(ji);
                    else if (this._reconnecting && this.disconnectedPublishing) {
                      var Hi = Object.keys(this._sentMessages).length + this._buffered_msg_queue.length;
                      if (Hi > this.disconnectedBufferSize)
                        throw new Error($i(Si.BUFFER_FULL, [this.disconnectedBufferSize]));
                      Wi.qos > 0 ? this._requires_ack(ji) : (ji.sequence = ++this._sequence, this._buffered_msg_queue.unshift(ji));
                    } else
                      throw new Error($i(Si.INVALID_STATE, ["not connected"]));
                  }, No.prototype.disconnect = function() {
                    if (this._trace("Client.disconnect"), this._reconnecting && (this._reconnectTimeout.cancel(), this._reconnectTimeout = null, this._reconnecting = !1), !this.socket)
                      throw new Error($i(Si.INVALID_STATE, ["not connecting or connected"]));
                    var Wi = new Mi(Ti.DISCONNECT);
                    this._notify_msg_sent[Wi] = xi(this._disconnected, this), this._schedule_message(Wi);
                  }, No.prototype.getTraceLog = function() {
                    if (this._traceBuffer !== null) {
                      this._trace("Client.getTraceLog", /* @__PURE__ */ new Date()), this._trace("Client.getTraceLog in flight messages", this._sentMessages.length);
                      for (var Wi in this._sentMessages)
                        this._trace("_sentMessages ", Wi, this._sentMessages[Wi]);
                      for (var Wi in this._receivedMessages)
                        this._trace("_receivedMessages ", Wi, this._receivedMessages[Wi]);
                      return this._traceBuffer;
                    }
                  }, No.prototype.startTrace = function() {
                    this._traceBuffer === null && (this._traceBuffer = []), this._trace("Client.startTrace", /* @__PURE__ */ new Date(), gi);
                  }, No.prototype.stopTrace = function() {
                    delete this._traceBuffer;
                  }, No.prototype._doConnect = function(Wi) {
                    if (this.connectOptions.useSSL) {
                      var ji = Wi.split(":");
                      ji[0] = "wss", Wi = ji.join(":");
                    }
                    this._wsuri = Wi, this.connected = !1, this.connectOptions.mqttVersion < 4 ? this.socket = new WebSocket(Wi, ["mqttv3.1"]) : this.socket = new WebSocket(Wi, ["mqtt"]), this.socket.binaryType = "arraybuffer", this.socket.onopen = xi(this._on_socket_open, this), this.socket.onmessage = xi(this._on_socket_message, this), this.socket.onerror = xi(this._on_socket_error, this), this.socket.onclose = xi(this._on_socket_close, this), this.sendPinger = new Yi(this, this.connectOptions.keepAliveInterval), this.receivePinger = new Yi(this, this.connectOptions.keepAliveInterval), this._connectTimeout && (this._connectTimeout.cancel(), this._connectTimeout = null), this._connectTimeout = new Vo(this, this.connectOptions.timeout, this._disconnected, [Si.CONNECT_TIMEOUT.code, $i(Si.CONNECT_TIMEOUT)]);
                  }, No.prototype._schedule_message = function(Wi) {
                    this._msg_queue.unshift(Wi), this.connected && this._process_queue();
                  }, No.prototype.store = function(Wi, ji) {
                    var Hi = { type: ji.type, messageIdentifier: ji.messageIdentifier, version: 1 };
                    switch (ji.type) {
                      case Ti.PUBLISH:
                        ji.pubRecReceived && (Hi.pubRecReceived = !0), Hi.payloadMessage = {};
                        for (var zo = "", Lo = ji.payloadMessage.payloadBytes, sa = 0; sa < Lo.length; sa++)
                          Lo[sa] <= 15 ? zo = zo + "0" + Lo[sa].toString(16) : zo = zo + Lo[sa].toString(16);
                        Hi.payloadMessage.payloadHex = zo, Hi.payloadMessage.qos = ji.payloadMessage.qos, Hi.payloadMessage.destinationName = ji.payloadMessage.destinationName, ji.payloadMessage.duplicate && (Hi.payloadMessage.duplicate = !0), ji.payloadMessage.retained && (Hi.payloadMessage.retained = !0), Wi.indexOf("Sent:") === 0 && (ji.sequence === void 0 && (ji.sequence = ++this._sequence), Hi.sequence = ji.sequence);
                        break;
                      default:
                        throw Error($i(Si.INVALID_STORED_DATA, [Wi + this._localKey + ji.messageIdentifier, Hi]));
                    }
                    mi.setItem(Wi + this._localKey + ji.messageIdentifier, JSON.stringify(Hi));
                  }, No.prototype.restore = function(Wi) {
                    var ji = mi.getItem(Wi), Hi = JSON.parse(ji), zo = new Mi(Hi.type, Hi);
                    switch (Hi.type) {
                      case Ti.PUBLISH:
                        for (var Lo = Hi.payloadMessage.payloadHex, sa = new ArrayBuffer(Lo.length / 2), Ko = new Uint8Array(sa), ca = 0; Lo.length >= 2; ) {
                          var pa = parseInt(Lo.substring(0, 2), 16);
                          Lo = Lo.substring(2, Lo.length), Ko[ca++] = pa;
                        }
                        var ga = new jo(Ko);
                        ga.qos = Hi.payloadMessage.qos, ga.destinationName = Hi.payloadMessage.destinationName, Hi.payloadMessage.duplicate && (ga.duplicate = !0), Hi.payloadMessage.retained && (ga.retained = !0), zo.payloadMessage = ga;
                        break;
                      default:
                        throw Error($i(Si.INVALID_STORED_DATA, [Wi, ji]));
                    }
                    Wi.indexOf("Sent:" + this._localKey) === 0 ? (zo.payloadMessage.duplicate = !0, this._sentMessages[zo.messageIdentifier] = zo) : Wi.indexOf("Received:" + this._localKey) === 0 && (this._receivedMessages[zo.messageIdentifier] = zo);
                  }, No.prototype._process_queue = function() {
                    for (var Wi = null; Wi = this._msg_queue.pop(); )
                      this._socket_send(Wi), this._notify_msg_sent[Wi] && (this._notify_msg_sent[Wi](), delete this._notify_msg_sent[Wi]);
                  }, No.prototype._requires_ack = function(Wi) {
                    var ji = Object.keys(this._sentMessages).length;
                    if (ji > this.maxMessageIdentifier)
                      throw Error("Too many messages:" + ji);
                    for (; this._sentMessages[this._message_identifier] !== void 0; )
                      this._message_identifier++;
                    Wi.messageIdentifier = this._message_identifier, this._sentMessages[Wi.messageIdentifier] = Wi, Wi.type === Ti.PUBLISH && this.store("Sent:", Wi), this._message_identifier === this.maxMessageIdentifier && (this._message_identifier = 1);
                  }, No.prototype._on_socket_open = function() {
                    var Wi = new Mi(Ti.CONNECT, this.connectOptions);
                    Wi.clientId = this.clientId, this._socket_send(Wi);
                  }, No.prototype._on_socket_message = function(Wi) {
                    this._trace("Client._on_socket_message", Wi.data);
                    for (var ji = this._deframeMessages(Wi.data), Hi = 0; Hi < ji.length; Hi += 1)
                      this._handleMessage(ji[Hi]);
                  }, No.prototype._deframeMessages = function(Wi) {
                    var ji = new Uint8Array(Wi), Hi = [];
                    if (this.receiveBuffer) {
                      var zo = new Uint8Array(this.receiveBuffer.length + ji.length);
                      zo.set(this.receiveBuffer), zo.set(ji, this.receiveBuffer.length), ji = zo, delete this.receiveBuffer;
                    }
                    try {
                      for (var Lo = 0; Lo < ji.length; ) {
                        var sa = Oo(ji, Lo), Ko = sa[0];
                        if (Lo = sa[1], Ko !== null)
                          Hi.push(Ko);
                        else
                          break;
                      }
                      Lo < ji.length && (this.receiveBuffer = ji.subarray(Lo));
                    } catch (pa) {
                      var ca = pa.hasOwnProperty("stack") == "undefined" ? pa.stack.toString() : "No Error Stack Available";
                      this._disconnected(Si.INTERNAL_ERROR.code, $i(Si.INTERNAL_ERROR, [pa.message, ca]));
                      return;
                    }
                    return Hi;
                  }, No.prototype._handleMessage = function(Wi) {
                    this._trace("Client._handleMessage", Wi);
                    try {
                      switch (Wi.type) {
                        case Ti.CONNACK:
                          if (this._connectTimeout.cancel(), this._reconnectTimeout && this._reconnectTimeout.cancel(), this.connectOptions.cleanSession) {
                            for (var ji in this._sentMessages) {
                              var ra = this._sentMessages[ji];
                              mi.removeItem("Sent:" + this._localKey + ra.messageIdentifier);
                            }
                            this._sentMessages = {};
                            for (var ji in this._receivedMessages) {
                              var ga = this._receivedMessages[ji];
                              mi.removeItem("Received:" + this._localKey + ga.messageIdentifier);
                            }
                            this._receivedMessages = {};
                          }
                          if (Wi.returnCode === 0)
                            this.connected = !0, this.connectOptions.uris && (this.hostIndex = this.connectOptions.uris.length);
                          else {
                            this._disconnected(Si.CONNACK_RETURNCODE.code, $i(Si.CONNACK_RETURNCODE, [Wi.returnCode, Pi[Wi.returnCode]]));
                            break;
                          }
                          var Lo = [];
                          for (var Hi in this._sentMessages)
                            this._sentMessages.hasOwnProperty(Hi) && Lo.push(this._sentMessages[Hi]);
                          if (this._buffered_msg_queue.length > 0)
                            for (var zo = null; zo = this._buffered_msg_queue.pop(); )
                              Lo.push(zo), this.onMessageDelivered && (this._notify_msg_sent[zo] = this.onMessageDelivered(zo.payloadMessage));
                          for (var Lo = Lo.sort(function(xa, $a) {
                            return xa.sequence - $a.sequence;
                          }), sa = 0, Ko = Lo.length; sa < Ko; sa++) {
                            var ra = Lo[sa];
                            if (ra.type == Ti.PUBLISH && ra.pubRecReceived) {
                              var ca = new Mi(Ti.PUBREL, { messageIdentifier: ra.messageIdentifier });
                              this._schedule_message(ca);
                            } else
                              this._schedule_message(ra);
                          }
                          this.connectOptions.onSuccess && this.connectOptions.onSuccess({ invocationContext: this.connectOptions.invocationContext });
                          var pa = !1;
                          this._reconnecting && (pa = !0, this._reconnectInterval = 1, this._reconnecting = !1), this._connected(pa, this._wsuri), this._process_queue();
                          break;
                        case Ti.PUBLISH:
                          this._receivePublish(Wi);
                          break;
                        case Ti.PUBACK:
                          var ra = this._sentMessages[Wi.messageIdentifier];
                          ra && (delete this._sentMessages[Wi.messageIdentifier], mi.removeItem("Sent:" + this._localKey + Wi.messageIdentifier), this.onMessageDelivered && this.onMessageDelivered(ra.payloadMessage));
                          break;
                        case Ti.PUBREC:
                          var ra = this._sentMessages[Wi.messageIdentifier];
                          if (ra) {
                            ra.pubRecReceived = !0;
                            var ca = new Mi(Ti.PUBREL, { messageIdentifier: Wi.messageIdentifier });
                            this.store("Sent:", ra), this._schedule_message(ca);
                          }
                          break;
                        case Ti.PUBREL:
                          var ga = this._receivedMessages[Wi.messageIdentifier];
                          mi.removeItem("Received:" + this._localKey + Wi.messageIdentifier), ga && (this._receiveMessage(ga), delete this._receivedMessages[Wi.messageIdentifier]);
                          var ia = new Mi(Ti.PUBCOMP, { messageIdentifier: Wi.messageIdentifier });
                          this._schedule_message(ia);
                          break;
                        case Ti.PUBCOMP:
                          var ra = this._sentMessages[Wi.messageIdentifier];
                          delete this._sentMessages[Wi.messageIdentifier], mi.removeItem("Sent:" + this._localKey + Wi.messageIdentifier), this.onMessageDelivered && this.onMessageDelivered(ra.payloadMessage);
                          break;
                        case Ti.SUBACK:
                          var ra = this._sentMessages[Wi.messageIdentifier];
                          ra && (ra.timeOut && ra.timeOut.cancel(), Wi.returnCode[0] === 128 ? ra.onFailure && ra.onFailure(Wi.returnCode) : ra.onSuccess && ra.onSuccess(Wi.returnCode), delete this._sentMessages[Wi.messageIdentifier]);
                          break;
                        case Ti.UNSUBACK:
                          var ra = this._sentMessages[Wi.messageIdentifier];
                          ra && (ra.timeOut && ra.timeOut.cancel(), ra.callback && ra.callback(), delete this._sentMessages[Wi.messageIdentifier]);
                          break;
                        case Ti.PINGRESP:
                          this.sendPinger.reset();
                          break;
                        case Ti.DISCONNECT:
                          this._disconnected(Si.INVALID_MQTT_MESSAGE_TYPE.code, $i(Si.INVALID_MQTT_MESSAGE_TYPE, [Wi.type]));
                          break;
                        default:
                          this._disconnected(Si.INVALID_MQTT_MESSAGE_TYPE.code, $i(Si.INVALID_MQTT_MESSAGE_TYPE, [Wi.type]));
                      }
                    } catch (xa) {
                      var qo = xa.hasOwnProperty("stack") == "undefined" ? xa.stack.toString() : "No Error Stack Available";
                      this._disconnected(Si.INTERNAL_ERROR.code, $i(Si.INTERNAL_ERROR, [xa.message, qo]));
                      return;
                    }
                  }, No.prototype._on_socket_error = function(Wi) {
                    this._reconnecting || this._disconnected(Si.SOCKET_ERROR.code, $i(Si.SOCKET_ERROR, [Wi.data]));
                  }, No.prototype._on_socket_close = function() {
                    this._reconnecting || this._disconnected(Si.SOCKET_CLOSE.code, $i(Si.SOCKET_CLOSE));
                  }, No.prototype._socket_send = function(Wi) {
                    if (Wi.type == 1) {
                      var ji = this._traceMask(Wi, "password");
                      this._trace("Client._socket_send", ji);
                    } else this._trace("Client._socket_send", Wi);
                    this.socket.send(Wi.encode()), this.sendPinger.reset();
                  }, No.prototype._receivePublish = function(Wi) {
                    switch (Wi.payloadMessage.qos) {
                      case "undefined":
                      case 0:
                        this._receiveMessage(Wi);
                        break;
                      case 1:
                        var ji = new Mi(Ti.PUBACK, { messageIdentifier: Wi.messageIdentifier });
                        this._schedule_message(ji), this._receiveMessage(Wi);
                        break;
                      case 2:
                        this._receivedMessages[Wi.messageIdentifier] = Wi, this.store("Received:", Wi);
                        var Hi = new Mi(Ti.PUBREC, { messageIdentifier: Wi.messageIdentifier });
                        this._schedule_message(Hi);
                        break;
                      default:
                        throw Error("Invaild qos=" + Wi.payloadMessage.qos);
                    }
                  }, No.prototype._receiveMessage = function(Wi) {
                    this.onMessageArrived && this.onMessageArrived(Wi.payloadMessage);
                  }, No.prototype._connected = function(Wi, ji) {
                    this.onConnected && this.onConnected(Wi, ji);
                  }, No.prototype._reconnect = function() {
                    this._trace("Client._reconnect"), this.connected || (this._reconnecting = !0, this.sendPinger.cancel(), this.receivePinger.cancel(), this._reconnectInterval < 128 && (this._reconnectInterval = this._reconnectInterval * 2), this.connectOptions.uris ? (this.hostIndex = 0, this._doConnect(this.connectOptions.uris[0])) : this._doConnect(this.uri));
                  }, No.prototype._disconnected = function(Wi, ji) {
                    if (this._trace("Client._disconnected", Wi, ji), Wi !== void 0 && this._reconnecting) {
                      this._reconnectTimeout = new Vo(this, this._reconnectInterval, this._reconnect);
                      return;
                    }
                    if (this.sendPinger.cancel(), this.receivePinger.cancel(), this._connectTimeout && (this._connectTimeout.cancel(), this._connectTimeout = null), this._msg_queue = [], this._buffered_msg_queue = [], this._notify_msg_sent = {}, this.socket && (this.socket.onopen = null, this.socket.onmessage = null, this.socket.onerror = null, this.socket.onclose = null, this.socket.readyState === 1 && this.socket.close(), delete this.socket), this.connectOptions.uris && this.hostIndex < this.connectOptions.uris.length - 1)
                      this.hostIndex++, this._doConnect(this.connectOptions.uris[this.hostIndex]);
                    else if (Wi === void 0 && (Wi = Si.OK.code, ji = $i(Si.OK)), this.connected) {
                      if (this.connected = !1, this.onConnectionLost && this.onConnectionLost({ errorCode: Wi, errorMessage: ji, reconnect: this.connectOptions.reconnect, uri: this._wsuri }), Wi !== Si.OK.code && this.connectOptions.reconnect) {
                        this._reconnectInterval = 1, this._reconnect();
                        return;
                      }
                    } else
                      this.connectOptions.mqttVersion === 4 && this.connectOptions.mqttVersionExplicit === !1 ? (this._trace("Failed to connect V4, dropping back to V3"), this.connectOptions.mqttVersion = 3, this.connectOptions.uris ? (this.hostIndex = 0, this._doConnect(this.connectOptions.uris[0])) : this._doConnect(this.uri)) : this.connectOptions.onFailure && this.connectOptions.onFailure({ invocationContext: this.connectOptions.invocationContext, errorCode: Wi, errorMessage: ji });
                  }, No.prototype._trace = function() {
                    if (this.traceFunction) {
                      var Wi = Array.prototype.slice.call(arguments);
                      for (var ji in Wi)
                        typeof Wi[ji] < "u" && Wi.splice(ji, 1, JSON.stringify(Wi[ji]));
                      var Hi = Wi.join("");
                      this.traceFunction({ severity: "Debug", message: Hi });
                    }
                    if (this._traceBuffer !== null)
                      for (var ji = 0, zo = arguments.length; ji < zo; ji++)
                        this._traceBuffer.length == this._MAX_TRACE_ENTRIES && this._traceBuffer.shift(), ji === 0 ? this._traceBuffer.push(arguments[ji]) : typeof arguments[ji] > "u" ? this._traceBuffer.push(arguments[ji]) : this._traceBuffer.push("  " + JSON.stringify(arguments[ji]));
                  }, No.prototype._traceMask = function(Wi, ji) {
                    var Hi = {};
                    for (var zo in Wi)
                      Wi.hasOwnProperty(zo) && (zo == ji ? Hi[zo] = "******" : Hi[zo] = Wi[zo]);
                    return Hi;
                  };
                  var Ui = function(Wi, ji, Hi, zo) {
                    var Lo;
                    if (typeof Wi != "string")
                      throw new Error($i(Si.INVALID_TYPE, [typeof Wi, "host"]));
                    if (arguments.length == 2) {
                      zo = ji, Lo = Wi;
                      var sa = Lo.match(/^(wss?):\/\/((\[(.+)\])|([^\/]+?))(:(\d+))?(\/.*)$/);
                      if (sa)
                        Wi = sa[4] || sa[2], ji = parseInt(sa[7]), Hi = sa[8];
                      else
                        throw new Error($i(Si.INVALID_ARGUMENT, [Wi, "host"]));
                    } else {
                      if (arguments.length == 3 && (zo = Hi, Hi = "/mqtt"), typeof ji != "number" || ji < 0)
                        throw new Error($i(Si.INVALID_TYPE, [typeof ji, "port"]));
                      if (typeof Hi != "string")
                        throw new Error($i(Si.INVALID_TYPE, [typeof Hi, "path"]));
                      var Ko = Wi.indexOf(":") !== -1 && Wi.slice(0, 1) !== "[" && Wi.slice(-1) !== "]";
                      Lo = "ws://" + (Ko ? "[" + Wi + "]" : Wi) + ":" + ji + Hi;
                    }
                    for (var ca = 0, pa = 0; pa < zo.length; pa++) {
                      var ga = zo.charCodeAt(pa);
                      55296 <= ga && ga <= 56319 && pa++, ca++;
                    }
                    if (typeof zo != "string" || ca > 65535)
                      throw new Error($i(Si.INVALID_ARGUMENT, [zo, "clientId"]));
                    var ia = new No(Lo, Wi, ji, Hi, zo);
                    Object.defineProperties(this, {
                      host: {
                        get: function() {
                          return Wi;
                        },
                        set: function() {
                          throw new Error($i(Si.UNSUPPORTED_OPERATION));
                        }
                      },
                      port: {
                        get: function() {
                          return ji;
                        },
                        set: function() {
                          throw new Error($i(Si.UNSUPPORTED_OPERATION));
                        }
                      },
                      path: {
                        get: function() {
                          return Hi;
                        },
                        set: function() {
                          throw new Error($i(Si.UNSUPPORTED_OPERATION));
                        }
                      },
                      uri: {
                        get: function() {
                          return Lo;
                        },
                        set: function() {
                          throw new Error($i(Si.UNSUPPORTED_OPERATION));
                        }
                      },
                      clientId: {
                        get: function() {
                          return ia.clientId;
                        },
                        set: function() {
                          throw new Error($i(Si.UNSUPPORTED_OPERATION));
                        }
                      },
                      onConnected: {
                        get: function() {
                          return ia.onConnected;
                        },
                        set: function(ra) {
                          if (typeof ra == "function")
                            ia.onConnected = ra;
                          else
                            throw new Error($i(Si.INVALID_TYPE, [typeof ra, "onConnected"]));
                        }
                      },
                      disconnectedPublishing: {
                        get: function() {
                          return ia.disconnectedPublishing;
                        },
                        set: function(ra) {
                          ia.disconnectedPublishing = ra;
                        }
                      },
                      disconnectedBufferSize: {
                        get: function() {
                          return ia.disconnectedBufferSize;
                        },
                        set: function(ra) {
                          ia.disconnectedBufferSize = ra;
                        }
                      },
                      onConnectionLost: {
                        get: function() {
                          return ia.onConnectionLost;
                        },
                        set: function(ra) {
                          if (typeof ra == "function")
                            ia.onConnectionLost = ra;
                          else
                            throw new Error($i(Si.INVALID_TYPE, [typeof ra, "onConnectionLost"]));
                        }
                      },
                      onMessageDelivered: {
                        get: function() {
                          return ia.onMessageDelivered;
                        },
                        set: function(ra) {
                          if (typeof ra == "function")
                            ia.onMessageDelivered = ra;
                          else
                            throw new Error($i(Si.INVALID_TYPE, [typeof ra, "onMessageDelivered"]));
                        }
                      },
                      onMessageArrived: {
                        get: function() {
                          return ia.onMessageArrived;
                        },
                        set: function(ra) {
                          if (typeof ra == "function")
                            ia.onMessageArrived = ra;
                          else
                            throw new Error($i(Si.INVALID_TYPE, [typeof ra, "onMessageArrived"]));
                        }
                      },
                      trace: {
                        get: function() {
                          return ia.traceFunction;
                        },
                        set: function(ra) {
                          if (typeof ra == "function")
                            ia.traceFunction = ra;
                          else
                            throw new Error($i(Si.INVALID_TYPE, [typeof ra, "onTrace"]));
                        }
                      }
                    }), this.connect = function(ra) {
                      if (ra = ra || {}, vi(ra, {
                        timeout: "number",
                        userName: "string",
                        password: "string",
                        willMessage: "object",
                        keepAliveInterval: "number",
                        cleanSession: "boolean",
                        useSSL: "boolean",
                        invocationContext: "object",
                        onSuccess: "function",
                        onFailure: "function",
                        hosts: "object",
                        ports: "object",
                        reconnect: "boolean",
                        mqttVersion: "number",
                        mqttVersionExplicit: "boolean",
                        uris: "object"
                      }), ra.keepAliveInterval === void 0 && (ra.keepAliveInterval = 60), ra.mqttVersion > 4 || ra.mqttVersion < 3)
                        throw new Error($i(Si.INVALID_ARGUMENT, [ra.mqttVersion, "connectOptions.mqttVersion"]));
                      if (ra.mqttVersion === void 0 ? (ra.mqttVersionExplicit = !1, ra.mqttVersion = 4) : ra.mqttVersionExplicit = !0, ra.password !== void 0 && ra.userName === void 0)
                        throw new Error($i(Si.INVALID_ARGUMENT, [ra.password, "connectOptions.password"]));
                      if (ra.willMessage) {
                        if (!(ra.willMessage instanceof jo))
                          throw new Error($i(Si.INVALID_TYPE, [ra.willMessage, "connectOptions.willMessage"]));
                        if (ra.willMessage.stringPayload = null, typeof ra.willMessage.destinationName > "u")
                          throw new Error($i(Si.INVALID_TYPE, [typeof ra.willMessage.destinationName, "connectOptions.willMessage.destinationName"]));
                      }
                      if (typeof ra.cleanSession > "u" && (ra.cleanSession = !0), ra.hosts) {
                        if (!(ra.hosts instanceof Array))
                          throw new Error($i(Si.INVALID_ARGUMENT, [ra.hosts, "connectOptions.hosts"]));
                        if (ra.hosts.length < 1)
                          throw new Error($i(Si.INVALID_ARGUMENT, [ra.hosts, "connectOptions.hosts"]));
                        for (var qo = !1, xa = 0; xa < ra.hosts.length; xa++) {
                          if (typeof ra.hosts[xa] != "string")
                            throw new Error($i(Si.INVALID_TYPE, [typeof ra.hosts[xa], "connectOptions.hosts[" + xa + "]"]));
                          if (/^(wss?):\/\/((\[(.+)\])|([^\/]+?))(:(\d+))?(\/.*)$/.test(ra.hosts[xa])) {
                            if (xa === 0)
                              qo = !0;
                            else if (!qo)
                              throw new Error($i(Si.INVALID_ARGUMENT, [ra.hosts[xa], "connectOptions.hosts[" + xa + "]"]));
                          } else if (qo)
                            throw new Error($i(Si.INVALID_ARGUMENT, [ra.hosts[xa], "connectOptions.hosts[" + xa + "]"]));
                        }
                        if (qo)
                          ra.uris = ra.hosts;
                        else {
                          if (!ra.ports)
                            throw new Error($i(Si.INVALID_ARGUMENT, [ra.ports, "connectOptions.ports"]));
                          if (!(ra.ports instanceof Array))
                            throw new Error($i(Si.INVALID_ARGUMENT, [ra.ports, "connectOptions.ports"]));
                          if (ra.hosts.length !== ra.ports.length)
                            throw new Error($i(Si.INVALID_ARGUMENT, [ra.ports, "connectOptions.ports"]));
                          ra.uris = [];
                          for (var xa = 0; xa < ra.hosts.length; xa++) {
                            if (typeof ra.ports[xa] != "number" || ra.ports[xa] < 0)
                              throw new Error($i(Si.INVALID_TYPE, [typeof ra.ports[xa], "connectOptions.ports[" + xa + "]"]));
                            var $a = ra.hosts[xa], ys = ra.ports[xa], Ss = $a.indexOf(":") !== -1;
                            Lo = "ws://" + (Ss ? "[" + $a + "]" : $a) + ":" + ys + Hi, ra.uris.push(Lo);
                          }
                        }
                      }
                      ia.connect(ra);
                    }, this.subscribe = function(ra, qo) {
                      if (typeof ra != "string" && ra.constructor !== Array)
                        throw new Error("Invalid argument:" + ra);
                      if (qo = qo || {}, vi(qo, {
                        qos: "number",
                        invocationContext: "object",
                        onSuccess: "function",
                        onFailure: "function",
                        timeout: "number"
                      }), qo.timeout && !qo.onFailure)
                        throw new Error("subscribeOptions.timeout specified with no onFailure callback.");
                      if (typeof qo.qos < "u" && !(qo.qos === 0 || qo.qos === 1 || qo.qos === 2))
                        throw new Error($i(Si.INVALID_ARGUMENT, [qo.qos, "subscribeOptions.qos"]));
                      ia.subscribe(ra, qo);
                    }, this.unsubscribe = function(ra, qo) {
                      if (typeof ra != "string" && ra.constructor !== Array)
                        throw new Error("Invalid argument:" + ra);
                      if (qo = qo || {}, vi(qo, {
                        invocationContext: "object",
                        onSuccess: "function",
                        onFailure: "function",
                        timeout: "number"
                      }), qo.timeout && !qo.onFailure)
                        throw new Error("unsubscribeOptions.timeout specified with no onFailure callback.");
                      ia.unsubscribe(ra, qo);
                    }, this.send = function(ra, qo, xa, $a) {
                      var ys;
                      if (arguments.length === 0)
                        throw new Error("Invalid argument.length");
                      if (arguments.length == 1) {
                        if (!(ra instanceof jo) && typeof ra != "string")
                          throw new Error("Invalid argument:" + typeof ra);
                        if (ys = ra, typeof ys.destinationName > "u")
                          throw new Error($i(Si.INVALID_ARGUMENT, [ys.destinationName, "Message.destinationName"]));
                        ia.send(ys);
                      } else
                        ys = new jo(qo), ys.destinationName = ra, arguments.length >= 3 && (ys.qos = xa), arguments.length >= 4 && (ys.retained = $a), ia.send(ys);
                    }, this.publish = function(ra, qo, xa, $a) {
                      var ys;
                      if (arguments.length === 0)
                        throw new Error("Invalid argument.length");
                      if (arguments.length == 1) {
                        if (!(ra instanceof jo) && typeof ra != "string")
                          throw new Error("Invalid argument:" + typeof ra);
                        if (ys = ra, typeof ys.destinationName > "u")
                          throw new Error($i(Si.INVALID_ARGUMENT, [ys.destinationName, "Message.destinationName"]));
                        ia.send(ys);
                      } else
                        ys = new jo(qo), ys.destinationName = ra, arguments.length >= 3 && (ys.qos = xa), arguments.length >= 4 && (ys.retained = $a), ia.send(ys);
                    }, this.disconnect = function() {
                      ia.disconnect();
                    }, this.getTraceLog = function() {
                      return ia.getTraceLog();
                    }, this.startTrace = function() {
                      ia.startTrace();
                    }, this.stopTrace = function() {
                      ia.stopTrace();
                    }, this.isConnected = function() {
                      return ia.connected;
                    };
                  }, jo = function(Wi) {
                    var ji;
                    if (typeof Wi == "string" || Wi instanceof ArrayBuffer || ArrayBuffer.isView(Wi) && !(Wi instanceof DataView))
                      ji = Wi;
                    else
                      throw $i(Si.INVALID_ARGUMENT, [Wi, "newPayload"]);
                    var Hi, zo = 0, Lo = !1, sa = !1;
                    Object.defineProperties(this, {
                      payloadString: {
                        enumerable: !0,
                        get: function() {
                          return typeof ji == "string" ? ji : Ni(ji, 0, ji.length);
                        }
                      },
                      payloadBytes: {
                        enumerable: !0,
                        get: function() {
                          if (typeof ji == "string") {
                            var Ko = new ArrayBuffer(Li(ji)), ca = new Uint8Array(Ko);
                            return Co(ji, ca, 0), ca;
                          } else
                            return ji;
                        }
                      },
                      destinationName: {
                        enumerable: !0,
                        get: function() {
                          return Hi;
                        },
                        set: function(Ko) {
                          if (typeof Ko == "string")
                            Hi = Ko;
                          else
                            throw new Error($i(Si.INVALID_ARGUMENT, [Ko, "newDestinationName"]));
                        }
                      },
                      qos: {
                        enumerable: !0,
                        get: function() {
                          return zo;
                        },
                        set: function(Ko) {
                          if (Ko === 0 || Ko === 1 || Ko === 2)
                            zo = Ko;
                          else
                            throw new Error("Invalid argument:" + Ko);
                        }
                      },
                      retained: {
                        enumerable: !0,
                        get: function() {
                          return Lo;
                        },
                        set: function(Ko) {
                          if (typeof Ko == "boolean")
                            Lo = Ko;
                          else
                            throw new Error($i(Si.INVALID_ARGUMENT, [Ko, "newRetained"]));
                        }
                      },
                      topic: {
                        enumerable: !0,
                        get: function() {
                          return Hi;
                        },
                        set: function(Ko) {
                          Hi = Ko;
                        }
                      },
                      duplicate: {
                        enumerable: !0,
                        get: function() {
                          return sa;
                        },
                        set: function(Ko) {
                          sa = Ko;
                        }
                      }
                    });
                  };
                  return {
                    Client: Ui,
                    Message: jo
                  };
                })(typeof oi.g < "u" ? oi.g : typeof self < "u" ? self : typeof window < "u" ? window : {});
                return di;
              });
            })
          ),
          /***/
          7320: (
            /***/
            ((ai) => {
              var li;
              ai.exports.w = function(oi, si) {
                var di = new li(), fi;
                return Promise.race([
                  oi,
                  new Promise(function(gi, mi) {
                    fi = setTimeout(function() {
                      mi(di);
                    }, si);
                  })
                ]).then(function(gi) {
                  return clearTimeout(fi), gi;
                }, function(gi) {
                  throw clearTimeout(fi), gi;
                });
              }, li = function() {
                Error.call(this), this.stack = Error().stack, this.message = "Timeout";
              }, li.prototype = Object.create(Error.prototype), li.prototype.name = "TimeoutError";
            })
          ),
          /***/
          1630: (
            /***/
            ((ai) => {
              function li(oi, si) {
                return Object.prototype.hasOwnProperty.call(oi, si);
              }
              ai.exports = function(oi, si, di, fi) {
                si = si || "&", di = di || "=";
                var gi = {};
                if (typeof oi != "string" || oi.length === 0)
                  return gi;
                var mi = /\+/g;
                oi = oi.split(si);
                var Ti = 1e3;
                fi && typeof fi.maxKeys == "number" && (Ti = fi.maxKeys);
                var vi = oi.length;
                Ti > 0 && vi > Ti && (vi = Ti);
                for (var xi = 0; xi < vi; ++xi) {
                  var Si = oi[xi].replace(mi, "%20"), Pi = Si.indexOf(di), $i, Oi, Di, Mi;
                  Pi >= 0 ? ($i = Si.substr(0, Pi), Oi = Si.substr(Pi + 1)) : ($i = Si, Oi = ""), Di = decodeURIComponent($i), Mi = decodeURIComponent(Oi), li(gi, Di) ? Array.isArray(gi[Di]) ? gi[Di].push(Mi) : gi[Di] = [gi[Di], Mi] : gi[Di] = Mi;
                }
                return gi;
              };
            })
          ),
          /***/
          9106: (
            /***/
            ((ai) => {
              var li = function(oi) {
                switch (typeof oi) {
                  case "string":
                    return oi;
                  case "boolean":
                    return oi ? "true" : "false";
                  case "number":
                    return isFinite(oi) ? oi : "";
                  default:
                    return "";
                }
              };
              ai.exports = function(oi, si, di, fi) {
                return si = si || "&", di = di || "=", oi === null && (oi = void 0), typeof oi == "object" ? Object.keys(oi).map(function(gi) {
                  var mi = encodeURIComponent(li(gi)) + di;
                  return Array.isArray(oi[gi]) ? oi[gi].map(function(Ti) {
                    return mi + encodeURIComponent(li(Ti));
                  }).join(si) : mi + encodeURIComponent(li(oi[gi]));
                }).join(si) : fi ? encodeURIComponent(li(fi)) + di + encodeURIComponent(li(oi)) : "";
              };
            })
          ),
          /***/
          7186: (
            /***/
            ((ai, li, oi) => {
              li.decode = li.parse = oi(1630), li.encode = li.stringify = oi(9106);
            })
          ),
          /***/
          4224: (
            /***/
            (function(ai, li) {
              var oi = this && this.__awaiter || function(Ti, vi, xi, Si) {
                function Pi($i) {
                  return $i instanceof xi ? $i : new xi(function(Oi) {
                    Oi($i);
                  });
                }
                return new (xi || (xi = Promise))(function($i, Oi) {
                  function Di(io) {
                    try {
                      Oo(Si.next(io));
                    } catch (xo) {
                      Oi(xo);
                    }
                  }
                  function Mi(io) {
                    try {
                      Oo(Si.throw(io));
                    } catch (xo) {
                      Oi(xo);
                    }
                  }
                  function Oo(io) {
                    io.done ? $i(io.value) : Pi(io.value).then(Di, Mi);
                  }
                  Oo((Si = Si.apply(Ti, vi || [])).next());
                });
              };
              Object.defineProperty(li, "__esModule", { value: !0 });
              const si = (Ti) => oi(void 0, void 0, void 0, function* () {
                return new Promise((vi) => setTimeout(() => vi(Ti), Ti));
              });
              li.sleep = si, li.sleepMilliseconds = si;
              const di = (Ti) => oi(void 0, void 0, void 0, function* () {
                return si(Ti * 1e3);
              });
              li.sleepSeconds = di;
              const fi = (Ti) => oi(void 0, void 0, void 0, function* () {
                return di(Ti * 60);
              });
              li.sleepMinutes = fi;
              const gi = (Ti) => oi(void 0, void 0, void 0, function* () {
                return fi(Ti * 60);
              });
              li.sleepHours = gi;
              const mi = (Ti) => oi(void 0, void 0, void 0, function* () {
                return gi(Ti * 24);
              });
              li.sleepDays = mi;
            })
          ),
          /***/
          255: (
            /***/
            (function(ai, li) {
              var oi, si;
              (function(di, fi) {
                var gi = window.srcDoc;
                oi = [li], si = (function(mi) {
                  fi(mi, gi), di.srcDoc = mi;
                }).apply(li, oi), si !== void 0 && (ai.exports = si);
              })(this, function(di, fi) {
                var gi, mi, Ti = "srcdoc" in document.createElement("iframe"), vi = "Polyfill may not function in the presence of the `sandbox` attribute. Consider using the `force` option.", xi = /\ballow-same-origin\b/, Si = function(Di, Mi) {
                  var Oo = Di.getAttribute("sandbox");
                  typeof Oo == "string" && !xi.test(Oo) && (Mi && Mi.force ? Di.removeAttribute("sandbox") : (!Mi || Mi.force !== !1) && (Oi(vi), Di.setAttribute("data-srcdoc-polyfill", vi)));
                }, Pi = {
                  compliant: function(Di, Mi, Oo) {
                    Mi && (Si(Di, Oo), Di.setAttribute("srcdoc", Mi));
                  },
                  legacy: function(Di, Mi, Oo) {
                    var io;
                    !Di || !Di.getAttribute || (Mi ? Di.setAttribute("srcdoc", Mi) : Mi = Di.getAttribute("srcdoc"), Mi && (Si(Di, Oo), io = "javascript: window.frameElement.getAttribute('srcdoc');", Di.contentWindow && (Di.contentWindow.location = io), Di.setAttribute("src", io)));
                  }
                }, $i = di, Oi;
                if (window.console && window.console.error ? Oi = function(Di) {
                  window.console.error("[srcdoc-polyfill] " + Di);
                } : Oi = function() {
                }, $i.set = Pi.compliant, $i.noConflict = function() {
                  return window.srcDoc = fi, $i;
                }, !Ti)
                  for ($i.set = Pi.legacy, mi = document.getElementsByTagName("iframe"), gi = mi.length; gi--; )
                    $i.set(mi[gi]);
              });
            })
          ),
          /***/
          1270: (
            /***/
            (function(ai, li, oi) {
              ai = oi.nmd(ai);
              var si;
              /*! https://mths.be/punycode v1.3.2 by @mathias */
              (function(di) {
                li && li.nodeType, ai && ai.nodeType;
                var fi = typeof oi.g == "object" && oi.g;
                fi.global === fi || fi.window === fi || fi.self;
                var gi, mi = 2147483647, Ti = 36, vi = 1, xi = 26, Si = 38, Pi = 700, $i = 72, Oi = 128, Di = "-", Mi = /^xn--/, Oo = /[^\x20-\x7E]/, io = /[\x2E\u3002\uFF0E\uFF61]/g, xo = {
                  overflow: "Overflow: input needs wider integers to process",
                  "not-basic": "Illegal input >= 0x80 (not a basic code point)",
                  "invalid-input": "Invalid input"
                }, fo = Ti - vi, _o = Math.floor, Li = String.fromCharCode;
                function Co(sa) {
                  throw RangeError(xo[sa]);
                }
                function Ni(sa, Ko) {
                  for (var ca = sa.length, pa = []; ca--; )
                    pa[ca] = Ko(sa[ca]);
                  return pa;
                }
                function Yi(sa, Ko) {
                  var ca = sa.split("@"), pa = "";
                  ca.length > 1 && (pa = ca[0] + "@", sa = ca[1]), sa = sa.replace(io, ".");
                  var ga = sa.split("."), ia = Ni(ga, Ko).join(".");
                  return pa + ia;
                }
                function Vo(sa) {
                  for (var Ko = [], ca = 0, pa = sa.length, ga, ia; ca < pa; )
                    ga = sa.charCodeAt(ca++), ga >= 55296 && ga <= 56319 && ca < pa ? (ia = sa.charCodeAt(ca++), (ia & 64512) == 56320 ? Ko.push(((ga & 1023) << 10) + (ia & 1023) + 65536) : (Ko.push(ga), ca--)) : Ko.push(ga);
                  return Ko;
                }
                function No(sa) {
                  return Ni(sa, function(Ko) {
                    var ca = "";
                    return Ko > 65535 && (Ko -= 65536, ca += Li(Ko >>> 10 & 1023 | 55296), Ko = 56320 | Ko & 1023), ca += Li(Ko), ca;
                  }).join("");
                }
                function Ui(sa) {
                  return sa - 48 < 10 ? sa - 22 : sa - 65 < 26 ? sa - 65 : sa - 97 < 26 ? sa - 97 : Ti;
                }
                function jo(sa, Ko) {
                  return sa + 22 + 75 * (sa < 26) - ((Ko != 0) << 5);
                }
                function Wi(sa, Ko, ca) {
                  var pa = 0;
                  for (sa = ca ? _o(sa / Pi) : sa >> 1, sa += _o(sa / Ko); sa > fo * xi >> 1; pa += Ti)
                    sa = _o(sa / fo);
                  return _o(pa + (fo + 1) * sa / (sa + Si));
                }
                function ji(sa) {
                  var Ko = [], ca = sa.length, pa, ga = 0, ia = Oi, ra = $i, qo, xa, $a, ys, Ss, Xa, Es, Rs, La;
                  for (qo = sa.lastIndexOf(Di), qo < 0 && (qo = 0), xa = 0; xa < qo; ++xa)
                    sa.charCodeAt(xa) >= 128 && Co("not-basic"), Ko.push(sa.charCodeAt(xa));
                  for ($a = qo > 0 ? qo + 1 : 0; $a < ca; ) {
                    for (ys = ga, Ss = 1, Xa = Ti; $a >= ca && Co("invalid-input"), Es = Ui(sa.charCodeAt($a++)), (Es >= Ti || Es > _o((mi - ga) / Ss)) && Co("overflow"), ga += Es * Ss, Rs = Xa <= ra ? vi : Xa >= ra + xi ? xi : Xa - ra, !(Es < Rs); Xa += Ti)
                      La = Ti - Rs, Ss > _o(mi / La) && Co("overflow"), Ss *= La;
                    pa = Ko.length + 1, ra = Wi(ga - ys, pa, ys == 0), _o(ga / pa) > mi - ia && Co("overflow"), ia += _o(ga / pa), ga %= pa, Ko.splice(ga++, 0, ia);
                  }
                  return No(Ko);
                }
                function Hi(sa) {
                  var Ko, ca, pa, ga, ia, ra, qo, xa, $a, ys, Ss, Xa = [], Es, Rs, La, Ja;
                  for (sa = Vo(sa), Es = sa.length, Ko = Oi, ca = 0, ia = $i, ra = 0; ra < Es; ++ra)
                    Ss = sa[ra], Ss < 128 && Xa.push(Li(Ss));
                  for (pa = ga = Xa.length, ga && Xa.push(Di); pa < Es; ) {
                    for (qo = mi, ra = 0; ra < Es; ++ra)
                      Ss = sa[ra], Ss >= Ko && Ss < qo && (qo = Ss);
                    for (Rs = pa + 1, qo - Ko > _o((mi - ca) / Rs) && Co("overflow"), ca += (qo - Ko) * Rs, Ko = qo, ra = 0; ra < Es; ++ra)
                      if (Ss = sa[ra], Ss < Ko && ++ca > mi && Co("overflow"), Ss == Ko) {
                        for (xa = ca, $a = Ti; ys = $a <= ia ? vi : $a >= ia + xi ? xi : $a - ia, !(xa < ys); $a += Ti)
                          Ja = xa - ys, La = Ti - ys, Xa.push(
                            Li(jo(ys + Ja % La, 0))
                          ), xa = _o(Ja / La);
                        Xa.push(Li(jo(xa, 0))), ia = Wi(ca, Rs, pa == ga), ca = 0, ++pa;
                      }
                    ++ca, ++Ko;
                  }
                  return Xa.join("");
                }
                function zo(sa) {
                  return Yi(sa, function(Ko) {
                    return Mi.test(Ko) ? ji(Ko.slice(4).toLowerCase()) : Ko;
                  });
                }
                function Lo(sa) {
                  return Yi(sa, function(Ko) {
                    return Oo.test(Ko) ? "xn--" + Hi(Ko) : Ko;
                  });
                }
                gi = {
                  /**
                   * A string representing the current Punycode.js version number.
                   * @memberOf punycode
                   * @type String
                   */
                  version: "1.3.2",
                  /**
                   * An object of methods to convert from JavaScript's internal character
                   * representation (UCS-2) to Unicode code points, and back.
                   * @see <https://mathiasbynens.be/notes/javascript-encoding>
                   * @memberOf punycode
                   * @type Object
                   */
                  ucs2: {
                    decode: Vo,
                    encode: No
                  },
                  decode: ji,
                  encode: Hi,
                  toASCII: Lo,
                  toUnicode: zo
                }, si = (function() {
                  return gi;
                }).call(li, oi, li, ai), si !== void 0 && (ai.exports = si);
              })();
            })
          ),
          /***/
          8835: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1270), di = oi(2268);
              li.parse = _o, li.resolve = Co, li.resolveObject = Ni, li.format = Li, li.Url = fi;
              function fi() {
                this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
              }
              var gi = /^([a-z0-9.+-]+:)/i, mi = /:[0-9]*$/, Ti = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, vi = ["<", ">", '"', "`", " ", "\r", `
`, "	"], xi = ["{", "}", "|", "\\", "^", "`"].concat(vi), Si = ["'"].concat(xi), Pi = ["%", "/", "?", ";", "#"].concat(Si), $i = ["/", "?", "#"], Oi = 255, Di = /^[+a-z0-9A-Z_-]{0,63}$/, Mi = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, Oo = {
                javascript: !0,
                "javascript:": !0
              }, io = {
                javascript: !0,
                "javascript:": !0
              }, xo = {
                http: !0,
                https: !0,
                ftp: !0,
                gopher: !0,
                file: !0,
                "http:": !0,
                "https:": !0,
                "ftp:": !0,
                "gopher:": !0,
                "file:": !0
              }, fo = oi(7186);
              function _o(Yi, Vo, No) {
                if (Yi && di.isObject(Yi) && Yi instanceof fi) return Yi;
                var Ui = new fi();
                return Ui.parse(Yi, Vo, No), Ui;
              }
              fi.prototype.parse = function(Yi, Vo, No) {
                if (!di.isString(Yi))
                  throw new TypeError("Parameter 'url' must be a string, not " + typeof Yi);
                var Ui = Yi.indexOf("?"), jo = Ui !== -1 && Ui < Yi.indexOf("#") ? "?" : "#", Wi = Yi.split(jo), ji = /\\/g;
                Wi[0] = Wi[0].replace(ji, "/"), Yi = Wi.join(jo);
                var Hi = Yi;
                if (Hi = Hi.trim(), !No && Yi.split("#").length === 1) {
                  var zo = Ti.exec(Hi);
                  if (zo)
                    return this.path = Hi, this.href = Hi, this.pathname = zo[1], zo[2] ? (this.search = zo[2], Vo ? this.query = fo.parse(this.search.substr(1)) : this.query = this.search.substr(1)) : Vo && (this.search = "", this.query = {}), this;
                }
                var Lo = gi.exec(Hi);
                if (Lo) {
                  Lo = Lo[0];
                  var sa = Lo.toLowerCase();
                  this.protocol = sa, Hi = Hi.substr(Lo.length);
                }
                if (No || Lo || Hi.match(/^\/\/[^@\/]+@[^@\/]+/)) {
                  var Ko = Hi.substr(0, 2) === "//";
                  Ko && !(Lo && io[Lo]) && (Hi = Hi.substr(2), this.slashes = !0);
                }
                if (!io[Lo] && (Ko || Lo && !xo[Lo])) {
                  for (var ca = -1, pa = 0; pa < $i.length; pa++) {
                    var ga = Hi.indexOf($i[pa]);
                    ga !== -1 && (ca === -1 || ga < ca) && (ca = ga);
                  }
                  var ia, ra;
                  ca === -1 ? ra = Hi.lastIndexOf("@") : ra = Hi.lastIndexOf("@", ca), ra !== -1 && (ia = Hi.slice(0, ra), Hi = Hi.slice(ra + 1), this.auth = decodeURIComponent(ia)), ca = -1;
                  for (var pa = 0; pa < Pi.length; pa++) {
                    var ga = Hi.indexOf(Pi[pa]);
                    ga !== -1 && (ca === -1 || ga < ca) && (ca = ga);
                  }
                  ca === -1 && (ca = Hi.length), this.host = Hi.slice(0, ca), Hi = Hi.slice(ca), this.parseHost(), this.hostname = this.hostname || "";
                  var qo = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
                  if (!qo)
                    for (var xa = this.hostname.split(/\./), pa = 0, $a = xa.length; pa < $a; pa++) {
                      var ys = xa[pa];
                      if (ys && !ys.match(Di)) {
                        for (var Ss = "", Xa = 0, Es = ys.length; Xa < Es; Xa++)
                          ys.charCodeAt(Xa) > 127 ? Ss += "x" : Ss += ys[Xa];
                        if (!Ss.match(Di)) {
                          var Rs = xa.slice(0, pa), La = xa.slice(pa + 1), Ja = ys.match(Mi);
                          Ja && (Rs.push(Ja[1]), La.unshift(Ja[2])), La.length && (Hi = "/" + La.join(".") + Hi), this.hostname = Rs.join(".");
                          break;
                        }
                      }
                    }
                  this.hostname.length > Oi ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), qo || (this.hostname = si.toASCII(this.hostname));
                  var ja = this.port ? ":" + this.port : "", Ta = this.hostname || "";
                  this.host = Ta + ja, this.href += this.host, qo && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), Hi[0] !== "/" && (Hi = "/" + Hi));
                }
                if (!Oo[sa])
                  for (var pa = 0, $a = Si.length; pa < $a; pa++) {
                    var rs = Si[pa];
                    if (Hi.indexOf(rs) !== -1) {
                      var Qa = encodeURIComponent(rs);
                      Qa === rs && (Qa = escape(rs)), Hi = Hi.split(rs).join(Qa);
                    }
                  }
                var Cs = Hi.indexOf("#");
                Cs !== -1 && (this.hash = Hi.substr(Cs), Hi = Hi.slice(0, Cs));
                var _a = Hi.indexOf("?");
                if (_a !== -1 ? (this.search = Hi.substr(_a), this.query = Hi.substr(_a + 1), Vo && (this.query = fo.parse(this.query)), Hi = Hi.slice(0, _a)) : Vo && (this.search = "", this.query = {}), Hi && (this.pathname = Hi), xo[sa] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
                  var ja = this.pathname || "", _s = this.search || "";
                  this.path = ja + _s;
                }
                return this.href = this.format(), this;
              };
              function Li(Yi) {
                return di.isString(Yi) && (Yi = _o(Yi)), Yi instanceof fi ? Yi.format() : fi.prototype.format.call(Yi);
              }
              fi.prototype.format = function() {
                var Yi = this.auth || "";
                Yi && (Yi = encodeURIComponent(Yi), Yi = Yi.replace(/%3A/i, ":"), Yi += "@");
                var Vo = this.protocol || "", No = this.pathname || "", Ui = this.hash || "", jo = !1, Wi = "";
                this.host ? jo = Yi + this.host : this.hostname && (jo = Yi + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]"), this.port && (jo += ":" + this.port)), this.query && di.isObject(this.query) && Object.keys(this.query).length && (Wi = fo.stringify(this.query));
                var ji = this.search || Wi && "?" + Wi || "";
                return Vo && Vo.substr(-1) !== ":" && (Vo += ":"), this.slashes || (!Vo || xo[Vo]) && jo !== !1 ? (jo = "//" + (jo || ""), No && No.charAt(0) !== "/" && (No = "/" + No)) : jo || (jo = ""), Ui && Ui.charAt(0) !== "#" && (Ui = "#" + Ui), ji && ji.charAt(0) !== "?" && (ji = "?" + ji), No = No.replace(/[?#]/g, function(Hi) {
                  return encodeURIComponent(Hi);
                }), ji = ji.replace("#", "%23"), Vo + jo + No + ji + Ui;
              };
              function Co(Yi, Vo) {
                return _o(Yi, !1, !0).resolve(Vo);
              }
              fi.prototype.resolve = function(Yi) {
                return this.resolveObject(_o(Yi, !1, !0)).format();
              };
              function Ni(Yi, Vo) {
                return Yi ? _o(Yi, !1, !0).resolveObject(Vo) : Vo;
              }
              fi.prototype.resolveObject = function(Yi) {
                if (di.isString(Yi)) {
                  var Vo = new fi();
                  Vo.parse(Yi, !1, !0), Yi = Vo;
                }
                for (var No = new fi(), Ui = Object.keys(this), jo = 0; jo < Ui.length; jo++) {
                  var Wi = Ui[jo];
                  No[Wi] = this[Wi];
                }
                if (No.hash = Yi.hash, Yi.href === "")
                  return No.href = No.format(), No;
                if (Yi.slashes && !Yi.protocol) {
                  for (var ji = Object.keys(Yi), Hi = 0; Hi < ji.length; Hi++) {
                    var zo = ji[Hi];
                    zo !== "protocol" && (No[zo] = Yi[zo]);
                  }
                  return xo[No.protocol] && No.hostname && !No.pathname && (No.path = No.pathname = "/"), No.href = No.format(), No;
                }
                if (Yi.protocol && Yi.protocol !== No.protocol) {
                  if (!xo[Yi.protocol]) {
                    for (var Lo = Object.keys(Yi), sa = 0; sa < Lo.length; sa++) {
                      var Ko = Lo[sa];
                      No[Ko] = Yi[Ko];
                    }
                    return No.href = No.format(), No;
                  }
                  if (No.protocol = Yi.protocol, !Yi.host && !io[Yi.protocol]) {
                    for (var $a = (Yi.pathname || "").split("/"); $a.length && !(Yi.host = $a.shift()); ) ;
                    Yi.host || (Yi.host = ""), Yi.hostname || (Yi.hostname = ""), $a[0] !== "" && $a.unshift(""), $a.length < 2 && $a.unshift(""), No.pathname = $a.join("/");
                  } else
                    No.pathname = Yi.pathname;
                  if (No.search = Yi.search, No.query = Yi.query, No.host = Yi.host || "", No.auth = Yi.auth, No.hostname = Yi.hostname || Yi.host, No.port = Yi.port, No.pathname || No.search) {
                    var ca = No.pathname || "", pa = No.search || "";
                    No.path = ca + pa;
                  }
                  return No.slashes = No.slashes || Yi.slashes, No.href = No.format(), No;
                }
                var ga = No.pathname && No.pathname.charAt(0) === "/", ia = Yi.host || Yi.pathname && Yi.pathname.charAt(0) === "/", ra = ia || ga || No.host && Yi.pathname, qo = ra, xa = No.pathname && No.pathname.split("/") || [], $a = Yi.pathname && Yi.pathname.split("/") || [], ys = No.protocol && !xo[No.protocol];
                if (ys && (No.hostname = "", No.port = null, No.host && (xa[0] === "" ? xa[0] = No.host : xa.unshift(No.host)), No.host = "", Yi.protocol && (Yi.hostname = null, Yi.port = null, Yi.host && ($a[0] === "" ? $a[0] = Yi.host : $a.unshift(Yi.host)), Yi.host = null), ra = ra && ($a[0] === "" || xa[0] === "")), ia)
                  No.host = Yi.host || Yi.host === "" ? Yi.host : No.host, No.hostname = Yi.hostname || Yi.hostname === "" ? Yi.hostname : No.hostname, No.search = Yi.search, No.query = Yi.query, xa = $a;
                else if ($a.length)
                  xa || (xa = []), xa.pop(), xa = xa.concat($a), No.search = Yi.search, No.query = Yi.query;
                else if (!di.isNullOrUndefined(Yi.search)) {
                  if (ys) {
                    No.hostname = No.host = xa.shift();
                    var Ss = No.host && No.host.indexOf("@") > 0 ? No.host.split("@") : !1;
                    Ss && (No.auth = Ss.shift(), No.host = No.hostname = Ss.shift());
                  }
                  return No.search = Yi.search, No.query = Yi.query, (!di.isNull(No.pathname) || !di.isNull(No.search)) && (No.path = (No.pathname ? No.pathname : "") + (No.search ? No.search : "")), No.href = No.format(), No;
                }
                if (!xa.length)
                  return No.pathname = null, No.search ? No.path = "/" + No.search : No.path = null, No.href = No.format(), No;
                for (var Xa = xa.slice(-1)[0], Es = (No.host || Yi.host || xa.length > 1) && (Xa === "." || Xa === "..") || Xa === "", Rs = 0, La = xa.length; La >= 0; La--)
                  Xa = xa[La], Xa === "." ? xa.splice(La, 1) : Xa === ".." ? (xa.splice(La, 1), Rs++) : Rs && (xa.splice(La, 1), Rs--);
                if (!ra && !qo)
                  for (; Rs--; Rs)
                    xa.unshift("..");
                ra && xa[0] !== "" && (!xa[0] || xa[0].charAt(0) !== "/") && xa.unshift(""), Es && xa.join("/").substr(-1) !== "/" && xa.push("");
                var Ja = xa[0] === "" || xa[0] && xa[0].charAt(0) === "/";
                if (ys) {
                  No.hostname = No.host = Ja ? "" : xa.length ? xa.shift() : "";
                  var Ss = No.host && No.host.indexOf("@") > 0 ? No.host.split("@") : !1;
                  Ss && (No.auth = Ss.shift(), No.host = No.hostname = Ss.shift());
                }
                return ra = ra || No.host && xa.length, ra && !Ja && xa.unshift(""), xa.length ? No.pathname = xa.join("/") : (No.pathname = null, No.path = null), (!di.isNull(No.pathname) || !di.isNull(No.search)) && (No.path = (No.pathname ? No.pathname : "") + (No.search ? No.search : "")), No.auth = Yi.auth || No.auth, No.slashes = No.slashes || Yi.slashes, No.href = No.format(), No;
              }, fi.prototype.parseHost = function() {
                var Yi = this.host, Vo = mi.exec(Yi);
                Vo && (Vo = Vo[0], Vo !== ":" && (this.port = Vo.substr(1)), Yi = Yi.substr(0, Yi.length - Vo.length)), Yi && (this.hostname = Yi);
              };
            })
          ),
          /***/
          2268: (
            /***/
            ((ai) => {
              ai.exports = {
                isString: function(li) {
                  return typeof li == "string";
                },
                isObject: function(li) {
                  return typeof li == "object" && li !== null;
                },
                isNull: function(li) {
                  return li === null;
                },
                isNullOrUndefined: function(li) {
                  return li == null;
                }
              };
            })
          ),
          /***/
          6615: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(8402);
            })
          ),
          /***/
          7169: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(7867);
            })
          ),
          /***/
          1393: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(530);
            })
          ),
          /***/
          6319: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(2616);
            })
          ),
          /***/
          6226: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(4525);
            })
          ),
          /***/
          8628: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(6343);
            })
          ),
          /***/
          4007: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(7852);
            })
          ),
          /***/
          5413: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(1618);
            })
          ),
          /***/
          8079: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(8894);
            })
          ),
          /***/
          3363: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(9528);
            })
          ),
          /***/
          8979: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(6686);
            })
          ),
          /***/
          385: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(26);
            })
          ),
          /***/
          1265: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(4598);
            })
          ),
          /***/
          5110: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(9703);
            })
          ),
          /***/
          1549: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(8251);
            })
          ),
          /***/
          8573: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(4532);
            })
          ),
          /***/
          8928: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(6513);
            })
          ),
          /***/
          6751: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(3220);
            })
          ),
          /***/
          6100: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(9563);
            })
          ),
          /***/
          697: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(6490);
            })
          ),
          /***/
          7119: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(5980);
            })
          ),
          /***/
          6586: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(1921);
            })
          ),
          /***/
          1240: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(5204);
            })
          ),
          /***/
          2574: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(5177);
            })
          ),
          /***/
          4607: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(4674);
            })
          ),
          /***/
          6255: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(568);
            })
          ),
          /***/
          6984: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(9792);
            })
          ),
          /***/
          7842: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(9428);
            })
          ),
          /***/
          2472: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(4062);
            })
          ),
          /***/
          5953: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1234).default, di = oi(591), fi = oi(3071), gi = oi(4006), mi = oi(5169), Ti = oi(3113), vi = oi(1958), xi = oi(6269), Si = oi(6160), Pi = oi(734), $i = oi(5186);
              function Oi() {
                ai.exports = Oi = function() {
                  return Mi;
                }, ai.exports.__esModule = !0, ai.exports.default = ai.exports;
                var Di, Mi = {}, Oo = Object.prototype, io = Oo.hasOwnProperty, xo = di || function(Xa, Es, Rs) {
                  Xa[Es] = Rs.value;
                }, fo = typeof fi == "function" ? fi : {}, _o = fo.iterator || "@@iterator", Li = fo.asyncIterator || "@@asyncIterator", Co = fo.toStringTag || "@@toStringTag";
                function Ni(Xa, Es, Rs) {
                  return di(Xa, Es, {
                    value: Rs,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                  }), Xa[Es];
                }
                try {
                  Ni({}, "");
                } catch {
                  Ni = function(Rs, La, Ja) {
                    return Rs[La] = Ja;
                  };
                }
                function Yi(Xa, Es, Rs, La) {
                  var Ja = Es && Es.prototype instanceof Hi ? Es : Hi, ja = gi(Ja.prototype), Ta = new ys(La || []);
                  return xo(ja, "_invoke", {
                    value: ra(Xa, Rs, Ta)
                  }), ja;
                }
                function Vo(Xa, Es, Rs) {
                  try {
                    return {
                      type: "normal",
                      arg: Xa.call(Es, Rs)
                    };
                  } catch (La) {
                    return {
                      type: "throw",
                      arg: La
                    };
                  }
                }
                Mi.wrap = Yi;
                var No = "suspendedStart", Ui = "suspendedYield", jo = "executing", Wi = "completed", ji = {};
                function Hi() {
                }
                function zo() {
                }
                function Lo() {
                }
                var sa = {};
                Ni(sa, _o, function() {
                  return this;
                });
                var Ko = mi, ca = Ko && Ko(Ko(Ss([])));
                ca && ca !== Oo && io.call(ca, _o) && (sa = ca);
                var pa = Lo.prototype = Hi.prototype = gi(sa);
                function ga(Xa) {
                  var Es;
                  Ti(Es = ["next", "throw", "return"]).call(Es, function(Rs) {
                    Ni(Xa, Rs, function(La) {
                      return this._invoke(Rs, La);
                    });
                  });
                }
                function ia(Xa, Es) {
                  function Rs(Ja, ja, Ta, rs) {
                    var Qa = Vo(Xa[Ja], Xa, ja);
                    if (Qa.type !== "throw") {
                      var Cs = Qa.arg, _a = Cs.value;
                      return _a && si(_a) == "object" && io.call(_a, "__await") ? Es.resolve(_a.__await).then(function(_s) {
                        Rs("next", _s, Ta, rs);
                      }, function(_s) {
                        Rs("throw", _s, Ta, rs);
                      }) : Es.resolve(_a).then(function(_s) {
                        Cs.value = _s, Ta(Cs);
                      }, function(_s) {
                        return Rs("throw", _s, Ta, rs);
                      });
                    }
                    rs(Qa.arg);
                  }
                  var La;
                  xo(this, "_invoke", {
                    value: function(ja, Ta) {
                      function rs() {
                        return new Es(function(Qa, Cs) {
                          Rs(ja, Ta, Qa, Cs);
                        });
                      }
                      return La = La ? La.then(rs, rs) : rs();
                    }
                  });
                }
                function ra(Xa, Es, Rs) {
                  var La = No;
                  return function(Ja, ja) {
                    if (La === jo) throw Error("Generator is already running");
                    if (La === Wi) {
                      if (Ja === "throw") throw ja;
                      return {
                        value: Di,
                        done: !0
                      };
                    }
                    for (Rs.method = Ja, Rs.arg = ja; ; ) {
                      var Ta = Rs.delegate;
                      if (Ta) {
                        var rs = qo(Ta, Rs);
                        if (rs) {
                          if (rs === ji) continue;
                          return rs;
                        }
                      }
                      if (Rs.method === "next") Rs.sent = Rs._sent = Rs.arg;
                      else if (Rs.method === "throw") {
                        if (La === No) throw La = Wi, Rs.arg;
                        Rs.dispatchException(Rs.arg);
                      } else Rs.method === "return" && Rs.abrupt("return", Rs.arg);
                      La = jo;
                      var Qa = Vo(Xa, Es, Rs);
                      if (Qa.type === "normal") {
                        if (La = Rs.done ? Wi : Ui, Qa.arg === ji) continue;
                        return {
                          value: Qa.arg,
                          done: Rs.done
                        };
                      }
                      Qa.type === "throw" && (La = Wi, Rs.method = "throw", Rs.arg = Qa.arg);
                    }
                  };
                }
                function qo(Xa, Es) {
                  var Rs = Es.method, La = Xa.iterator[Rs];
                  if (La === Di) return Es.delegate = null, Rs === "throw" && Xa.iterator.return && (Es.method = "return", Es.arg = Di, qo(Xa, Es), Es.method === "throw") || Rs !== "return" && (Es.method = "throw", Es.arg = new TypeError("The iterator does not provide a '" + Rs + "' method")), ji;
                  var Ja = Vo(La, Xa.iterator, Es.arg);
                  if (Ja.type === "throw") return Es.method = "throw", Es.arg = Ja.arg, Es.delegate = null, ji;
                  var ja = Ja.arg;
                  return ja ? ja.done ? (Es[Xa.resultName] = ja.value, Es.next = Xa.nextLoc, Es.method !== "return" && (Es.method = "next", Es.arg = Di), Es.delegate = null, ji) : ja : (Es.method = "throw", Es.arg = new TypeError("iterator result is not an object"), Es.delegate = null, ji);
                }
                function xa(Xa) {
                  var Es, Rs = {
                    tryLoc: Xa[0]
                  };
                  1 in Xa && (Rs.catchLoc = Xa[1]), 2 in Xa && (Rs.finallyLoc = Xa[2], Rs.afterLoc = Xa[3]), vi(Es = this.tryEntries).call(Es, Rs);
                }
                function $a(Xa) {
                  var Es = Xa.completion || {};
                  Es.type = "normal", delete Es.arg, Xa.completion = Es;
                }
                function ys(Xa) {
                  this.tryEntries = [{
                    tryLoc: "root"
                  }], Ti(Xa).call(Xa, xa, this), this.reset(!0);
                }
                function Ss(Xa) {
                  if (Xa || Xa === "") {
                    var Es = Xa[_o];
                    if (Es) return Es.call(Xa);
                    if (typeof Xa.next == "function") return Xa;
                    if (!isNaN(Xa.length)) {
                      var Rs = -1, La = function Ja() {
                        for (; ++Rs < Xa.length; ) if (io.call(Xa, Rs)) return Ja.value = Xa[Rs], Ja.done = !1, Ja;
                        return Ja.value = Di, Ja.done = !0, Ja;
                      };
                      return La.next = La;
                    }
                  }
                  throw new TypeError(si(Xa) + " is not iterable");
                }
                return zo.prototype = Lo, xo(pa, "constructor", {
                  value: Lo,
                  configurable: !0
                }), xo(Lo, "constructor", {
                  value: zo,
                  configurable: !0
                }), zo.displayName = Ni(Lo, Co, "GeneratorFunction"), Mi.isGeneratorFunction = function(Xa) {
                  var Es = typeof Xa == "function" && Xa.constructor;
                  return !!Es && (Es === zo || (Es.displayName || Es.name) === "GeneratorFunction");
                }, Mi.mark = function(Xa) {
                  return xi ? xi(Xa, Lo) : (Xa.__proto__ = Lo, Ni(Xa, Co, "GeneratorFunction")), Xa.prototype = gi(pa), Xa;
                }, Mi.awrap = function(Xa) {
                  return {
                    __await: Xa
                  };
                }, ga(ia.prototype), Ni(ia.prototype, Li, function() {
                  return this;
                }), Mi.AsyncIterator = ia, Mi.async = function(Xa, Es, Rs, La, Ja) {
                  Ja === void 0 && (Ja = Si);
                  var ja = new ia(Yi(Xa, Es, Rs, La), Ja);
                  return Mi.isGeneratorFunction(Es) ? ja : ja.next().then(function(Ta) {
                    return Ta.done ? Ta.value : ja.next();
                  });
                }, ga(pa), Ni(pa, Co, "Generator"), Ni(pa, _o, function() {
                  return this;
                }), Ni(pa, "toString", function() {
                  return "[object Generator]";
                }), Mi.keys = function(Xa) {
                  var Es = Object(Xa), Rs = [];
                  for (var La in Es) vi(Rs).call(Rs, La);
                  return Pi(Rs).call(Rs), function Ja() {
                    for (; Rs.length; ) {
                      var ja = Rs.pop();
                      if (ja in Es) return Ja.value = ja, Ja.done = !1, Ja;
                    }
                    return Ja.done = !0, Ja;
                  };
                }, Mi.values = Ss, ys.prototype = {
                  constructor: ys,
                  reset: function(Es) {
                    var Rs;
                    if (this.prev = 0, this.next = 0, this.sent = this._sent = Di, this.done = !1, this.delegate = null, this.method = "next", this.arg = Di, Ti(Rs = this.tryEntries).call(Rs, $a), !Es) for (var La in this) La.charAt(0) === "t" && io.call(this, La) && !isNaN(+$i(La).call(La, 1)) && (this[La] = Di);
                  },
                  stop: function() {
                    this.done = !0;
                    var Es = this.tryEntries[0].completion;
                    if (Es.type === "throw") throw Es.arg;
                    return this.rval;
                  },
                  dispatchException: function(Es) {
                    if (this.done) throw Es;
                    var Rs = this;
                    function La(Cs, _a) {
                      return Ta.type = "throw", Ta.arg = Es, Rs.next = Cs, _a && (Rs.method = "next", Rs.arg = Di), !!_a;
                    }
                    for (var Ja = this.tryEntries.length - 1; Ja >= 0; --Ja) {
                      var ja = this.tryEntries[Ja], Ta = ja.completion;
                      if (ja.tryLoc === "root") return La("end");
                      if (ja.tryLoc <= this.prev) {
                        var rs = io.call(ja, "catchLoc"), Qa = io.call(ja, "finallyLoc");
                        if (rs && Qa) {
                          if (this.prev < ja.catchLoc) return La(ja.catchLoc, !0);
                          if (this.prev < ja.finallyLoc) return La(ja.finallyLoc);
                        } else if (rs) {
                          if (this.prev < ja.catchLoc) return La(ja.catchLoc, !0);
                        } else {
                          if (!Qa) throw Error("try statement without catch or finally");
                          if (this.prev < ja.finallyLoc) return La(ja.finallyLoc);
                        }
                      }
                    }
                  },
                  abrupt: function(Es, Rs) {
                    for (var La = this.tryEntries.length - 1; La >= 0; --La) {
                      var Ja = this.tryEntries[La];
                      if (Ja.tryLoc <= this.prev && io.call(Ja, "finallyLoc") && this.prev < Ja.finallyLoc) {
                        var ja = Ja;
                        break;
                      }
                    }
                    ja && (Es === "break" || Es === "continue") && ja.tryLoc <= Rs && Rs <= ja.finallyLoc && (ja = null);
                    var Ta = ja ? ja.completion : {};
                    return Ta.type = Es, Ta.arg = Rs, ja ? (this.method = "next", this.next = ja.finallyLoc, ji) : this.complete(Ta);
                  },
                  complete: function(Es, Rs) {
                    if (Es.type === "throw") throw Es.arg;
                    return Es.type === "break" || Es.type === "continue" ? this.next = Es.arg : Es.type === "return" ? (this.rval = this.arg = Es.arg, this.method = "return", this.next = "end") : Es.type === "normal" && Rs && (this.next = Rs), ji;
                  },
                  finish: function(Es) {
                    for (var Rs = this.tryEntries.length - 1; Rs >= 0; --Rs) {
                      var La = this.tryEntries[Rs];
                      if (La.finallyLoc === Es) return this.complete(La.completion, La.afterLoc), $a(La), ji;
                    }
                  },
                  catch: function(Es) {
                    for (var Rs = this.tryEntries.length - 1; Rs >= 0; --Rs) {
                      var La = this.tryEntries[Rs];
                      if (La.tryLoc === Es) {
                        var Ja = La.completion;
                        if (Ja.type === "throw") {
                          var ja = Ja.arg;
                          $a(La);
                        }
                        return ja;
                      }
                    }
                    throw Error("illegal catch attempt");
                  },
                  delegateYield: function(Es, Rs, La) {
                    return this.delegate = {
                      iterator: Ss(Es),
                      resultName: Rs,
                      nextLoc: La
                    }, this.method === "next" && (this.arg = Di), ji;
                  }
                }, Mi;
              }
              ai.exports = Oi, ai.exports.__esModule = !0, ai.exports.default = ai.exports;
            })
          ),
          /***/
          1234: (
            /***/
            ((ai, li, oi) => {
              var si = oi(3071), di = oi(4473);
              function fi(gi) {
                "@babel/helpers - typeof";
                return ai.exports = fi = typeof si == "function" && typeof di == "symbol" ? function(mi) {
                  return typeof mi;
                } : function(mi) {
                  return mi && typeof si == "function" && mi.constructor === si && mi !== si.prototype ? "symbol" : typeof mi;
                }, ai.exports.__esModule = !0, ai.exports.default = ai.exports, fi(gi);
              }
              ai.exports = fi, ai.exports.__esModule = !0, ai.exports.default = ai.exports;
            })
          ),
          /***/
          4828: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5953)();
              ai.exports = si;
              try {
                regeneratorRuntime = si;
              } catch {
                typeof globalThis == "object" ? globalThis.regeneratorRuntime = si : Function("r", "regeneratorRuntime = r")(si);
              }
            })
          ),
          /***/
          7985: (
            /***/
            ((ai, li, oi) => {
              var si = oi(6450);
              ai.exports = si;
            })
          ),
          /***/
          7725: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8402);
              ai.exports = si;
            })
          ),
          /***/
          8690: (
            /***/
            ((ai, li, oi) => {
              var si = oi(3067);
              ai.exports = si;
            })
          ),
          /***/
          3700: (
            /***/
            ((ai, li, oi) => {
              var si = oi(9709);
              ai.exports = si;
            })
          ),
          /***/
          2544: (
            /***/
            ((ai, li, oi) => {
              var si = oi(4525);
              ai.exports = si;
            })
          ),
          /***/
          5779: (
            /***/
            ((ai, li, oi) => {
              var si = oi(3266);
              ai.exports = si;
            })
          ),
          /***/
          9433: (
            /***/
            ((ai, li, oi) => {
              var si = oi(4106);
              ai.exports = si;
            })
          ),
          /***/
          6221: (
            /***/
            ((ai, li, oi) => {
              var si = oi(6686);
              ai.exports = si;
            })
          ),
          /***/
          6975: (
            /***/
            ((ai, li, oi) => {
              var si = oi(3658);
              ai.exports = si;
            })
          ),
          /***/
          6040: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8251);
              ai.exports = si;
            })
          ),
          /***/
          4842: (
            /***/
            ((ai, li, oi) => {
              var si = oi(6513);
              ai.exports = si;
            })
          ),
          /***/
          1168: (
            /***/
            ((ai, li, oi) => {
              var si = oi(9261);
              ai.exports = si;
            })
          ),
          /***/
          4972: (
            /***/
            ((ai, li, oi) => {
              var si = oi(7777);
              ai.exports = si;
            })
          ),
          /***/
          9645: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5204);
              oi(7637), oi(3568), ai.exports = si;
            })
          ),
          /***/
          8377: (
            /***/
            ((ai, li, oi) => {
              var si = oi(9416);
              ai.exports = si;
            })
          ),
          /***/
          7264: (
            /***/
            ((ai, li, oi) => {
              var si = oi(4139);
              oi(768), oi(8549), oi(7152), oi(1372), ai.exports = si;
            })
          ),
          /***/
          9692: (
            /***/
            ((ai, li, oi) => {
              var si = oi(7045);
              ai.exports = si;
            })
          ),
          /***/
          5663: (
            /***/
            ((ai, li, oi) => {
              var si = oi(70);
              ai.exports = si;
            })
          ),
          /***/
          3607: (
            /***/
            ((ai, li, oi) => {
              oi(7057), oi(7277);
              var si = oi(2046);
              ai.exports = si.Array.from;
            })
          ),
          /***/
          3531: (
            /***/
            ((ai, li, oi) => {
              oi(2425);
              var si = oi(2046);
              ai.exports = si.Array.isArray;
            })
          ),
          /***/
          6275: (
            /***/
            ((ai, li, oi) => {
              oi(8545);
              var si = oi(1747);
              ai.exports = si("Array", "concat");
            })
          ),
          /***/
          6177: (
            /***/
            ((ai, li, oi) => {
              oi(9295);
              var si = oi(1747);
              ai.exports = si("Array", "filter");
            })
          ),
          /***/
          2092: (
            /***/
            ((ai, li, oi) => {
              oi(5650);
              var si = oi(1747);
              ai.exports = si("Array", "forEach");
            })
          ),
          /***/
          1362: (
            /***/
            ((ai, li, oi) => {
              oi(9748);
              var si = oi(1747);
              ai.exports = si("Array", "includes");
            })
          ),
          /***/
          3309: (
            /***/
            ((ai, li, oi) => {
              oi(6391);
              var si = oi(1747);
              ai.exports = si("Array", "indexOf");
            })
          ),
          /***/
          6535: (
            /***/
            ((ai, li, oi) => {
              oi(9363), oi(3643);
              var si = oi(1747);
              ai.exports = si("Array", "keys");
            })
          ),
          /***/
          8253: (
            /***/
            ((ai, li, oi) => {
              oi(6687);
              var si = oi(1747);
              ai.exports = si("Array", "map");
            })
          ),
          /***/
          1127: (
            /***/
            ((ai, li, oi) => {
              oi(5745);
              var si = oi(1747);
              ai.exports = si("Array", "push");
            })
          ),
          /***/
          6693: (
            /***/
            ((ai, li, oi) => {
              oi(6339);
              var si = oi(1747);
              ai.exports = si("Array", "reduce");
            })
          ),
          /***/
          6429: (
            /***/
            ((ai, li, oi) => {
              oi(8559);
              var si = oi(1747);
              ai.exports = si("Array", "reverse");
            })
          ),
          /***/
          5265: (
            /***/
            ((ai, li, oi) => {
              oi(2099);
              var si = oi(1747);
              ai.exports = si("Array", "slice");
            })
          ),
          /***/
          4923: (
            /***/
            ((ai, li, oi) => {
              oi(8334);
              var si = oi(1747);
              ai.exports = si("Array", "splice");
            })
          ),
          /***/
          5354: (
            /***/
            ((ai, li, oi) => {
              oi(5362);
              var si = oi(2046);
              ai.exports = si.Date.now;
            })
          ),
          /***/
          2567: (
            /***/
            ((ai, li, oi) => {
              oi(9307);
              var si = oi(1747);
              ai.exports = si("Function", "bind");
            })
          ),
          /***/
          4712: (
            /***/
            ((ai, li, oi) => {
              oi(9363), oi(7057);
              var si = oi(3448);
              ai.exports = si;
            })
          ),
          /***/
          3034: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8280), di = oi(2567), fi = Function.prototype;
              ai.exports = function(gi) {
                var mi = gi.bind;
                return gi === fi || si(fi, gi) && mi === fi.bind ? di : mi;
              };
            })
          ),
          /***/
          8218: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8280), di = oi(6275), fi = Array.prototype;
              ai.exports = function(gi) {
                var mi = gi.concat;
                return gi === fi || si(fi, gi) && mi === fi.concat ? di : mi;
              };
            })
          ),
          /***/
          3155: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8280), di = oi(6177), fi = Array.prototype;
              ai.exports = function(gi) {
                var mi = gi.filter;
                return gi === fi || si(fi, gi) && mi === fi.filter ? di : mi;
              };
            })
          ),
          /***/
          6880: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8280), di = oi(1362), fi = oi(4378), gi = Array.prototype, mi = String.prototype;
              ai.exports = function(Ti) {
                var vi = Ti.includes;
                return Ti === gi || si(gi, Ti) && vi === gi.includes ? di : typeof Ti == "string" || Ti === mi || si(mi, Ti) && vi === mi.includes ? fi : vi;
              };
            })
          ),
          /***/
          4507: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8280), di = oi(3309), fi = Array.prototype;
              ai.exports = function(gi) {
                var mi = gi.indexOf;
                return gi === fi || si(fi, gi) && mi === fi.indexOf ? di : mi;
              };
            })
          ),
          /***/
          9299: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8280), di = oi(8253), fi = Array.prototype;
              ai.exports = function(gi) {
                var mi = gi.map;
                return gi === fi || si(fi, gi) && mi === fi.map ? di : mi;
              };
            })
          ),
          /***/
          8685: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8280), di = oi(1127), fi = Array.prototype;
              ai.exports = function(gi) {
                var mi = gi.push;
                return gi === fi || si(fi, gi) && mi === fi.push ? di : mi;
              };
            })
          ),
          /***/
          8823: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8280), di = oi(6693), fi = Array.prototype;
              ai.exports = function(gi) {
                var mi = gi.reduce;
                return gi === fi || si(fi, gi) && mi === fi.reduce ? di : mi;
              };
            })
          ),
          /***/
          8059: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8280), di = oi(6429), fi = Array.prototype;
              ai.exports = function(gi) {
                var mi = gi.reverse;
                return gi === fi || si(fi, gi) && mi === fi.reverse ? di : mi;
              };
            })
          ),
          /***/
          303: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8280), di = oi(5265), fi = Array.prototype;
              ai.exports = function(gi) {
                var mi = gi.slice;
                return gi === fi || si(fi, gi) && mi === fi.slice ? di : mi;
              };
            })
          ),
          /***/
          5029: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8280), di = oi(4923), fi = Array.prototype;
              ai.exports = function(gi) {
                var mi = gi.splice;
                return gi === fi || si(fi, gi) && mi === fi.splice ? di : mi;
              };
            })
          ),
          /***/
          3423: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8280), di = oi(7511), fi = String.prototype;
              ai.exports = function(gi) {
                var mi = gi.trim;
                return typeof gi == "string" || gi === fi || si(fi, gi) && mi === fi.trim ? di : mi;
              };
            })
          ),
          /***/
          149: (
            /***/
            ((ai, li, oi) => {
              oi(5837);
              var si = oi(2046), di = si.Object;
              ai.exports = function(gi, mi) {
                return di.create(gi, mi);
              };
            })
          ),
          /***/
          8970: (
            /***/
            ((ai, li, oi) => {
              oi(7810);
              var si = oi(2046), di = si.Object, fi = ai.exports = function(mi, Ti) {
                return di.defineProperties(mi, Ti);
              };
              di.defineProperties.sham && (fi.sham = !0);
            })
          ),
          /***/
          1926: (
            /***/
            ((ai, li, oi) => {
              oi(6750);
              var si = oi(2046), di = si.Object, fi = ai.exports = function(mi, Ti, vi) {
                return di.defineProperty(mi, Ti, vi);
              };
              di.defineProperty.sham && (fi.sham = !0);
            })
          ),
          /***/
          30: (
            /***/
            ((ai, li, oi) => {
              oi(4729);
              var si = oi(2046);
              ai.exports = si.Object.entries;
            })
          ),
          /***/
          5092: (
            /***/
            ((ai, li, oi) => {
              oi(7052);
              var si = oi(2046), di = si.Object, fi = ai.exports = function(mi, Ti) {
                return di.getOwnPropertyDescriptor(mi, Ti);
              };
              di.getOwnPropertyDescriptor.sham && (fi.sham = !0);
            })
          ),
          /***/
          9147: (
            /***/
            ((ai, li, oi) => {
              oi(179);
              var si = oi(2046);
              ai.exports = si.Object.getOwnPropertyDescriptors;
            })
          ),
          /***/
          4776: (
            /***/
            ((ai, li, oi) => {
              oi(4452);
              var si = oi(2046);
              ai.exports = si.Object.getOwnPropertySymbols;
            })
          ),
          /***/
          6286: (
            /***/
            ((ai, li, oi) => {
              oi(8966);
              var si = oi(2046);
              ai.exports = si.Object.getPrototypeOf;
            })
          ),
          /***/
          9661: (
            /***/
            ((ai, li, oi) => {
              oi(3589);
              var si = oi(2046);
              ai.exports = si.Object.keys;
            })
          ),
          /***/
          1418: (
            /***/
            ((ai, li, oi) => {
              oi(1906);
              var si = oi(2046);
              ai.exports = si.Object.setPrototypeOf;
            })
          ),
          /***/
          8699: (
            /***/
            ((ai, li, oi) => {
              oi(5395);
              var si = oi(2046);
              ai.exports = si.Object.values;
            })
          ),
          /***/
          4326: (
            /***/
            ((ai, li, oi) => {
              oi(2193);
              var si = oi(2046);
              ai.exports = si.parseInt;
            })
          ),
          /***/
          7027: (
            /***/
            ((ai, li, oi) => {
              oi(4502), oi(9363), oi(3643), oi(5931), oi(7450), oi(6415), oi(7380), oi(5823), oi(7714), oi(7057);
              var si = oi(2046);
              ai.exports = si.Promise;
            })
          ),
          /***/
          6098: (
            /***/
            ((ai, li, oi) => {
              oi(1220);
              var si = oi(2046);
              ai.exports = si.Reflect.construct;
            })
          ),
          /***/
          655: (
            /***/
            ((ai, li, oi) => {
              oi(3357);
              var si = oi(2046);
              ai.exports = si.Reflect.get;
            })
          ),
          /***/
          4378: (
            /***/
            ((ai, li, oi) => {
              oi(9770);
              var si = oi(1747);
              ai.exports = si("String", "includes");
            })
          ),
          /***/
          7511: (
            /***/
            ((ai, li, oi) => {
              oi(727);
              var si = oi(1747);
              ai.exports = si("String", "trim");
            })
          ),
          /***/
          3842: (
            /***/
            ((ai, li, oi) => {
              oi(8545), oi(3643), oi(4452), oi(3997), oi(5084), oi(2596), oi(5721), oi(4954), oi(4123), oi(3377), oi(2230), oi(5344), oi(1660), oi(4610), oi(3669), oi(4810), oi(3325), oi(7024), oi(8172), oi(5205);
              var si = oi(2046);
              ai.exports = si.Symbol;
            })
          ),
          /***/
          1730: (
            /***/
            ((ai, li, oi) => {
              oi(9363), oi(3643), oi(7057), oi(4954);
              var si = oi(560);
              ai.exports = si.f("iterator");
            })
          ),
          /***/
          1661: (
            /***/
            ((ai, li, oi) => {
              oi(8537), oi(3669);
              var si = oi(560);
              ai.exports = si.f("toPrimitive");
            })
          ),
          /***/
          7173: (
            /***/
            ((ai, li, oi) => {
              oi(9363), oi(3643), oi(6571);
              var si = oi(2046);
              ai.exports = si.WeakMap;
            })
          ),
          /***/
          7499: (
            /***/
            ((ai, li, oi) => {
              oi(9363), oi(3643), oi(741);
              var si = oi(2046);
              ai.exports = si.WeakSet;
            })
          ),
          /***/
          3113: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(8959);
            })
          ),
          /***/
          1958: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(3520);
            })
          ),
          /***/
          734: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(288);
            })
          ),
          /***/
          5186: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(4908);
            })
          ),
          /***/
          4006: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(7764);
            })
          ),
          /***/
          591: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(4997);
            })
          ),
          /***/
          5169: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(7415);
            })
          ),
          /***/
          6269: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(5363);
            })
          ),
          /***/
          6160: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(7166);
            })
          ),
          /***/
          3071: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(2321);
            })
          ),
          /***/
          4473: (
            /***/
            ((ai, li, oi) => {
              ai.exports = oi(2231);
            })
          ),
          /***/
          8980: (
            /***/
            ((ai, li, oi) => {
              var si = oi(7985);
              ai.exports = si;
            })
          ),
          /***/
          1564: (
            /***/
            ((ai, li, oi) => {
              var si = oi(7725);
              ai.exports = si;
            })
          ),
          /***/
          9029: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8690);
              ai.exports = si;
            })
          ),
          /***/
          3375: (
            /***/
            ((ai, li, oi) => {
              var si = oi(3700);
              ai.exports = si;
            })
          ),
          /***/
          8959: (
            /***/
            ((ai, li, oi) => {
              var si = oi(2544);
              ai.exports = si;
            })
          ),
          /***/
          3520: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5779);
              ai.exports = si;
            })
          ),
          /***/
          288: (
            /***/
            ((ai, li, oi) => {
              var si = oi(9433);
              ai.exports = si;
            })
          ),
          /***/
          4908: (
            /***/
            ((ai, li, oi) => {
              var si = oi(6221);
              ai.exports = si;
            })
          ),
          /***/
          7764: (
            /***/
            ((ai, li, oi) => {
              var si = oi(6975);
              ai.exports = si;
            })
          ),
          /***/
          4997: (
            /***/
            ((ai, li, oi) => {
              var si = oi(6040);
              ai.exports = si;
            })
          ),
          /***/
          5983: (
            /***/
            ((ai, li, oi) => {
              var si = oi(4842);
              ai.exports = si;
            })
          ),
          /***/
          7415: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1168);
              ai.exports = si;
            })
          ),
          /***/
          5363: (
            /***/
            ((ai, li, oi) => {
              var si = oi(4972);
              ai.exports = si;
            })
          ),
          /***/
          7166: (
            /***/
            ((ai, li, oi) => {
              var si = oi(9645);
              oi(1599), oi(7939), oi(4362), ai.exports = si;
            })
          ),
          /***/
          1138: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8377);
              ai.exports = si;
            })
          ),
          /***/
          2321: (
            /***/
            ((ai, li, oi) => {
              var si = oi(7264);
              oi(3939), oi(1785), oi(1697), oi(4664), oi(3422), oi(36), oi(8703), oi(6878), oi(9671), oi(359), ai.exports = si;
            })
          ),
          /***/
          2231: (
            /***/
            ((ai, li, oi) => {
              var si = oi(9692);
              ai.exports = si;
            })
          ),
          /***/
          9280: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5663);
              ai.exports = si;
            })
          ),
          /***/
          2159: (
            /***/
            ((ai, li, oi) => {
              var si = oi(2250), di = oi(4640), fi = TypeError;
              ai.exports = function(gi) {
                if (si(gi)) return gi;
                throw new fi(di(gi) + " is not a function");
              };
            })
          ),
          /***/
          2235: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5468), di = oi(4640), fi = TypeError;
              ai.exports = function(gi) {
                if (si(gi)) return gi;
                throw new fi(di(gi) + " is not a constructor");
              };
            })
          ),
          /***/
          43: (
            /***/
            ((ai, li, oi) => {
              var si = oi(4018), di = String, fi = TypeError;
              ai.exports = function(gi) {
                if (si(gi)) return gi;
                throw new fi("Can't set " + di(gi) + " as a prototype");
              };
            })
          ),
          /***/
          2156: (
            /***/
            ((ai) => {
              ai.exports = function() {
              };
            })
          ),
          /***/
          9596: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8280), di = TypeError;
              ai.exports = function(fi, gi) {
                if (si(gi, fi)) return fi;
                throw new di("Incorrect invocation");
              };
            })
          ),
          /***/
          6624: (
            /***/
            ((ai, li, oi) => {
              var si = oi(6285), di = String, fi = TypeError;
              ai.exports = function(gi) {
                if (si(gi)) return gi;
                throw new fi(di(gi) + " is not an object");
              };
            })
          ),
          /***/
          6375: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8828);
              ai.exports = si(function() {
                if (typeof ArrayBuffer == "function") {
                  var di = new ArrayBuffer(8);
                  Object.isExtensible(di) && Object.defineProperty(di, "a", { value: 8 });
                }
              });
            })
          ),
          /***/
          2914: (
            /***/
            ((ai, li, oi) => {
              var si = oi(726).forEach, di = oi(7623), fi = di("forEach");
              ai.exports = fi ? [].forEach : function(mi) {
                return si(this, mi, arguments.length > 1 ? arguments[1] : void 0);
              };
            })
          ),
          /***/
          1229: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8311), di = oi(3930), fi = oi(9298), gi = oi(6818), mi = oi(7812), Ti = oi(5468), vi = oi(575), xi = oi(5543), Si = oi(300), Pi = oi(3448), $i = Array;
              ai.exports = function(Di) {
                var Mi = fi(Di), Oo = Ti(this), io = arguments.length, xo = io > 1 ? arguments[1] : void 0, fo = xo !== void 0;
                fo && (xo = si(xo, io > 2 ? arguments[2] : void 0));
                var _o = Pi(Mi), Li = 0, Co, Ni, Yi, Vo, No, Ui;
                if (_o && !(this === $i && mi(_o)))
                  for (Ni = Oo ? new this() : [], Vo = Si(Mi, _o), No = Vo.next; !(Yi = di(No, Vo)).done; Li++)
                    Ui = fo ? gi(Vo, xo, [Yi.value, Li], !0) : Yi.value, xi(Ni, Li, Ui);
                else
                  for (Co = vi(Mi), Ni = Oo ? new this(Co) : $i(Co); Co > Li; Li++)
                    Ui = fo ? xo(Mi[Li], Li) : Mi[Li], xi(Ni, Li, Ui);
                return Ni.length = Li, Ni;
              };
            })
          ),
          /***/
          4436: (
            /***/
            ((ai, li, oi) => {
              var si = oi(7374), di = oi(4849), fi = oi(575), gi = function(mi) {
                return function(Ti, vi, xi) {
                  var Si = si(Ti), Pi = fi(Si);
                  if (Pi === 0) return !mi && -1;
                  var $i = di(xi, Pi), Oi;
                  if (mi && vi !== vi) {
                    for (; Pi > $i; )
                      if (Oi = Si[$i++], Oi !== Oi) return !0;
                  } else for (; Pi > $i; $i++)
                    if ((mi || $i in Si) && Si[$i] === vi) return mi || $i || 0;
                  return !mi && -1;
                };
              };
              ai.exports = {
                // `Array.prototype.includes` method
                // https://tc39.es/ecma262/#sec-array.prototype.includes
                includes: gi(!0),
                // `Array.prototype.indexOf` method
                // https://tc39.es/ecma262/#sec-array.prototype.indexof
                indexOf: gi(!1)
              };
            })
          ),
          /***/
          726: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8311), di = oi(1907), fi = oi(6946), gi = oi(9298), mi = oi(575), Ti = oi(6968), vi = di([].push), xi = function(Si) {
                var Pi = Si === 1, $i = Si === 2, Oi = Si === 3, Di = Si === 4, Mi = Si === 6, Oo = Si === 7, io = Si === 5 || Mi;
                return function(xo, fo, _o, Li) {
                  for (var Co = gi(xo), Ni = fi(Co), Yi = mi(Ni), Vo = si(fo, _o), No = 0, Ui = Li || Ti, jo = Pi ? Ui(xo, Yi) : $i || Oo ? Ui(xo, 0) : void 0, Wi, ji; Yi > No; No++) if ((io || No in Ni) && (Wi = Ni[No], ji = Vo(Wi, No, Co), Si))
                    if (Pi) jo[No] = ji;
                    else if (ji) switch (Si) {
                      case 3:
                        return !0;
                      // some
                      case 5:
                        return Wi;
                      // find
                      case 6:
                        return No;
                      // findIndex
                      case 2:
                        vi(jo, Wi);
                    }
                    else switch (Si) {
                      case 4:
                        return !1;
                      // every
                      case 7:
                        vi(jo, Wi);
                    }
                  return Mi ? -1 : Oi || Di ? Di : jo;
                };
              };
              ai.exports = {
                // `Array.prototype.forEach` method
                // https://tc39.es/ecma262/#sec-array.prototype.foreach
                forEach: xi(0),
                // `Array.prototype.map` method
                // https://tc39.es/ecma262/#sec-array.prototype.map
                map: xi(1),
                // `Array.prototype.filter` method
                // https://tc39.es/ecma262/#sec-array.prototype.filter
                filter: xi(2),
                // `Array.prototype.some` method
                // https://tc39.es/ecma262/#sec-array.prototype.some
                some: xi(3),
                // `Array.prototype.every` method
                // https://tc39.es/ecma262/#sec-array.prototype.every
                every: xi(4),
                // `Array.prototype.find` method
                // https://tc39.es/ecma262/#sec-array.prototype.find
                find: xi(5),
                // `Array.prototype.findIndex` method
                // https://tc39.es/ecma262/#sec-array.prototype.findIndex
                findIndex: xi(6),
                // `Array.prototype.filterReject` method
                // https://github.com/tc39/proposal-array-filtering
                filterReject: xi(7)
              };
            })
          ),
          /***/
          7171: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8828), di = oi(6264), fi = oi(798), gi = di("species");
              ai.exports = function(mi) {
                return fi >= 51 || !si(function() {
                  var Ti = [], vi = Ti.constructor = {};
                  return vi[gi] = function() {
                    return { foo: 1 };
                  }, Ti[mi](Boolean).foo !== 1;
                });
              };
            })
          ),
          /***/
          7623: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8828);
              ai.exports = function(di, fi) {
                var gi = [][di];
                return !!gi && si(function() {
                  gi.call(null, fi || function() {
                    return 1;
                  }, 1);
                });
              };
            })
          ),
          /***/
          5043: (
            /***/
            ((ai, li, oi) => {
              var si = oi(2159), di = oi(9298), fi = oi(6946), gi = oi(575), mi = TypeError, Ti = "Reduce of empty array with no initial value", vi = function(xi) {
                return function(Si, Pi, $i, Oi) {
                  var Di = di(Si), Mi = fi(Di), Oo = gi(Di);
                  if (si(Pi), Oo === 0 && $i < 2) throw new mi(Ti);
                  var io = xi ? Oo - 1 : 0, xo = xi ? -1 : 1;
                  if ($i < 2) for (; ; ) {
                    if (io in Mi) {
                      Oi = Mi[io], io += xo;
                      break;
                    }
                    if (io += xo, xi ? io < 0 : Oo <= io)
                      throw new mi(Ti);
                  }
                  for (; xi ? io >= 0 : Oo > io; io += xo) io in Mi && (Oi = Pi(Oi, Mi[io], io, Di));
                  return Oi;
                };
              };
              ai.exports = {
                // `Array.prototype.reduce` method
                // https://tc39.es/ecma262/#sec-array.prototype.reduce
                left: vi(!1),
                // `Array.prototype.reduceRight` method
                // https://tc39.es/ecma262/#sec-array.prototype.reduceright
                right: vi(!0)
              };
            })
          ),
          /***/
          3130: (
            /***/
            ((ai, li, oi) => {
              var si = oi(9447), di = oi(1793), fi = TypeError, gi = Object.getOwnPropertyDescriptor, mi = si && !(function() {
                if (this !== void 0) return !0;
                try {
                  Object.defineProperty([], "length", { writable: !1 }).length = 1;
                } catch (Ti) {
                  return Ti instanceof TypeError;
                }
              })();
              ai.exports = mi ? function(Ti, vi) {
                if (di(Ti) && !gi(Ti, "length").writable)
                  throw new fi("Cannot set read only .length");
                return Ti.length = vi;
              } : function(Ti, vi) {
                return Ti.length = vi;
              };
            })
          ),
          /***/
          3427: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1907);
              ai.exports = si([].slice);
            })
          ),
          /***/
          4321: (
            /***/
            ((ai, li, oi) => {
              var si = oi(3427), di = Math.floor, fi = function(gi, mi) {
                var Ti = gi.length;
                if (Ti < 8)
                  for (var vi = 1, xi, Si; vi < Ti; ) {
                    for (Si = vi, xi = gi[vi]; Si && mi(gi[Si - 1], xi) > 0; )
                      gi[Si] = gi[--Si];
                    Si !== vi++ && (gi[Si] = xi);
                  }
                else
                  for (var Pi = di(Ti / 2), $i = fi(si(gi, 0, Pi), mi), Oi = fi(si(gi, Pi), mi), Di = $i.length, Mi = Oi.length, Oo = 0, io = 0; Oo < Di || io < Mi; )
                    gi[Oo + io] = Oo < Di && io < Mi ? mi($i[Oo], Oi[io]) <= 0 ? $i[Oo++] : Oi[io++] : Oo < Di ? $i[Oo++] : Oi[io++];
                return gi;
              };
              ai.exports = fi;
            })
          ),
          /***/
          4010: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1793), di = oi(5468), fi = oi(6285), gi = oi(6264), mi = gi("species"), Ti = Array;
              ai.exports = function(vi) {
                var xi;
                return si(vi) && (xi = vi.constructor, di(xi) && (xi === Ti || si(xi.prototype)) ? xi = void 0 : fi(xi) && (xi = xi[mi], xi === null && (xi = void 0))), xi === void 0 ? Ti : xi;
              };
            })
          ),
          /***/
          6968: (
            /***/
            ((ai, li, oi) => {
              var si = oi(4010);
              ai.exports = function(di, fi) {
                return new (si(di))(fi === 0 ? 0 : fi);
              };
            })
          ),
          /***/
          6818: (
            /***/
            ((ai, li, oi) => {
              var si = oi(6624), di = oi(154);
              ai.exports = function(fi, gi, mi, Ti) {
                try {
                  return Ti ? gi(si(mi)[0], mi[1]) : gi(mi);
                } catch (vi) {
                  di(fi, "throw", vi);
                }
              };
            })
          ),
          /***/
          473: (
            /***/
            ((ai, li, oi) => {
              var si = oi(6264), di = si("iterator"), fi = !1;
              try {
                var gi = 0, mi = {
                  next: function() {
                    return { done: !!gi++ };
                  },
                  return: function() {
                    fi = !0;
                  }
                };
                mi[di] = function() {
                  return this;
                }, Array.from(mi, function() {
                  throw 2;
                });
              } catch {
              }
              ai.exports = function(Ti, vi) {
                try {
                  if (!vi && !fi) return !1;
                } catch {
                  return !1;
                }
                var xi = !1;
                try {
                  var Si = {};
                  Si[di] = function() {
                    return {
                      next: function() {
                        return { done: xi = !0 };
                      }
                    };
                  }, Ti(Si);
                } catch {
                }
                return xi;
              };
            })
          ),
          /***/
          5807: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1907), di = si({}.toString), fi = si("".slice);
              ai.exports = function(gi) {
                return fi(di(gi), 8, -1);
              };
            })
          ),
          /***/
          3948: (
            /***/
            ((ai, li, oi) => {
              var si = oi(2623), di = oi(2250), fi = oi(5807), gi = oi(6264), mi = gi("toStringTag"), Ti = Object, vi = fi(/* @__PURE__ */ (function() {
                return arguments;
              })()) === "Arguments", xi = function(Si, Pi) {
                try {
                  return Si[Pi];
                } catch {
                }
              };
              ai.exports = si ? fi : function(Si) {
                var Pi, $i, Oi;
                return Si === void 0 ? "Undefined" : Si === null ? "Null" : typeof ($i = xi(Pi = Ti(Si), mi)) == "string" ? $i : vi ? fi(Pi) : (Oi = fi(Pi)) === "Object" && di(Pi.callee) ? "Arguments" : Oi;
              };
            })
          ),
          /***/
          1182: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1907), di = oi(2802), fi = oi(1548).getWeakData, gi = oi(9596), mi = oi(6624), Ti = oi(7136), vi = oi(6285), xi = oi(4823), Si = oi(726), Pi = oi(9724), $i = oi(4932), Oi = $i.set, Di = $i.getterFor, Mi = Si.find, Oo = Si.findIndex, io = si([].splice), xo = 0, fo = function(Co) {
                return Co.frozen || (Co.frozen = new _o());
              }, _o = function() {
                this.entries = [];
              }, Li = function(Co, Ni) {
                return Mi(Co.entries, function(Yi) {
                  return Yi[0] === Ni;
                });
              };
              _o.prototype = {
                get: function(Co) {
                  var Ni = Li(this, Co);
                  if (Ni) return Ni[1];
                },
                has: function(Co) {
                  return !!Li(this, Co);
                },
                set: function(Co, Ni) {
                  var Yi = Li(this, Co);
                  Yi ? Yi[1] = Ni : this.entries.push([Co, Ni]);
                },
                delete: function(Co) {
                  var Ni = Oo(this.entries, function(Yi) {
                    return Yi[0] === Co;
                  });
                  return ~Ni && io(this.entries, Ni, 1), !!~Ni;
                }
              }, ai.exports = {
                getConstructor: function(Co, Ni, Yi, Vo) {
                  var No = Co(function(ji, Hi) {
                    gi(ji, Ui), Oi(ji, {
                      type: Ni,
                      id: xo++,
                      frozen: null
                    }), Ti(Hi) || xi(Hi, ji[Vo], { that: ji, AS_ENTRIES: Yi });
                  }), Ui = No.prototype, jo = Di(Ni), Wi = function(ji, Hi, zo) {
                    var Lo = jo(ji), sa = fi(mi(Hi), !0);
                    return sa === !0 ? fo(Lo).set(Hi, zo) : sa[Lo.id] = zo, ji;
                  };
                  return di(Ui, {
                    // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
                    // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
                    // https://tc39.es/ecma262/#sec-weakset.prototype.delete
                    delete: function(ji) {
                      var Hi = jo(this);
                      if (!vi(ji)) return !1;
                      var zo = fi(ji);
                      return zo === !0 ? fo(Hi).delete(ji) : zo && Pi(zo, Hi.id) && delete zo[Hi.id];
                    },
                    // `{ WeakMap, WeakSet }.prototype.has(key)` methods
                    // https://tc39.es/ecma262/#sec-weakmap.prototype.has
                    // https://tc39.es/ecma262/#sec-weakset.prototype.has
                    has: function(Hi) {
                      var zo = jo(this);
                      if (!vi(Hi)) return !1;
                      var Lo = fi(Hi);
                      return Lo === !0 ? fo(zo).has(Hi) : Lo && Pi(Lo, zo.id);
                    }
                  }), di(Ui, Yi ? {
                    // `WeakMap.prototype.get(key)` method
                    // https://tc39.es/ecma262/#sec-weakmap.prototype.get
                    get: function(Hi) {
                      var zo = jo(this);
                      if (vi(Hi)) {
                        var Lo = fi(Hi);
                        if (Lo === !0) return fo(zo).get(Hi);
                        if (Lo) return Lo[zo.id];
                      }
                    },
                    // `WeakMap.prototype.set(key, value)` method
                    // https://tc39.es/ecma262/#sec-weakmap.prototype.set
                    set: function(Hi, zo) {
                      return Wi(this, Hi, zo);
                    }
                  } : {
                    // `WeakSet.prototype.add(value)` method
                    // https://tc39.es/ecma262/#sec-weakset.prototype.add
                    add: function(Hi) {
                      return Wi(this, Hi, !0);
                    }
                  }), No;
                }
              };
            })
          ),
          /***/
          7081: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(5951), fi = oi(1548), gi = oi(8828), mi = oi(1626), Ti = oi(4823), vi = oi(9596), xi = oi(2250), Si = oi(6285), Pi = oi(7136), $i = oi(4840), Oi = oi(4284).f, Di = oi(726).forEach, Mi = oi(9447), Oo = oi(4932), io = Oo.set, xo = Oo.getterFor;
              ai.exports = function(fo, _o, Li) {
                var Co = fo.indexOf("Map") !== -1, Ni = fo.indexOf("Weak") !== -1, Yi = Co ? "set" : "add", Vo = di[fo], No = Vo && Vo.prototype, Ui = {}, jo;
                if (!Mi || !xi(Vo) || !(Ni || No.forEach && !gi(function() {
                  new Vo().entries().next();
                })))
                  jo = Li.getConstructor(_o, fo, Co, Yi), fi.enable();
                else {
                  jo = _o(function(Hi, zo) {
                    io(vi(Hi, Wi), {
                      type: fo,
                      collection: new Vo()
                    }), Pi(zo) || Ti(zo, Hi[Yi], { that: Hi, AS_ENTRIES: Co });
                  });
                  var Wi = jo.prototype, ji = xo(fo);
                  Di(["add", "clear", "delete", "forEach", "get", "has", "set", "keys", "values", "entries"], function(Hi) {
                    var zo = Hi === "add" || Hi === "set";
                    Hi in No && !(Ni && Hi === "clear") && mi(Wi, Hi, function(Lo, sa) {
                      var Ko = ji(this).collection;
                      if (!zo && Ni && !Si(Lo)) return Hi === "get" ? void 0 : !1;
                      var ca = Ko[Hi](Lo === 0 ? 0 : Lo, sa);
                      return zo ? this : ca;
                    });
                  }), Ni || Oi(Wi, "size", {
                    configurable: !0,
                    get: function() {
                      return ji(this).collection.size;
                    }
                  });
                }
                return $i(jo, fo, !1, !0), Ui[fo] = jo, si({ global: !0, forced: !0 }, Ui), Ni || Li.setStrong(jo, fo, Co), jo;
              };
            })
          ),
          /***/
          9595: (
            /***/
            ((ai, li, oi) => {
              var si = oi(9724), di = oi(1042), fi = oi(3846), gi = oi(4284);
              ai.exports = function(mi, Ti, vi) {
                for (var xi = di(Ti), Si = gi.f, Pi = fi.f, $i = 0; $i < xi.length; $i++) {
                  var Oi = xi[$i];
                  !si(mi, Oi) && !(vi && si(vi, Oi)) && Si(mi, Oi, Pi(Ti, Oi));
                }
              };
            })
          ),
          /***/
          5735: (
            /***/
            ((ai, li, oi) => {
              var si = oi(6264), di = si("match");
              ai.exports = function(fi) {
                var gi = /./;
                try {
                  "/./"[fi](gi);
                } catch {
                  try {
                    return gi[di] = !1, "/./"[fi](gi);
                  } catch {
                  }
                }
                return !1;
              };
            })
          ),
          /***/
          7382: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8828);
              ai.exports = !si(function() {
                function di() {
                }
                return di.prototype.constructor = null, Object.getPrototypeOf(new di()) !== di.prototype;
              });
            })
          ),
          /***/
          9550: (
            /***/
            ((ai) => {
              ai.exports = function(li, oi) {
                return { value: li, done: oi };
              };
            })
          ),
          /***/
          1626: (
            /***/
            ((ai, li, oi) => {
              var si = oi(9447), di = oi(4284), fi = oi(5817);
              ai.exports = si ? function(gi, mi, Ti) {
                return di.f(gi, mi, fi(1, Ti));
              } : function(gi, mi, Ti) {
                return gi[mi] = Ti, gi;
              };
            })
          ),
          /***/
          5817: (
            /***/
            ((ai) => {
              ai.exports = function(li, oi) {
                return {
                  enumerable: !(li & 1),
                  configurable: !(li & 2),
                  writable: !(li & 4),
                  value: oi
                };
              };
            })
          ),
          /***/
          5543: (
            /***/
            ((ai, li, oi) => {
              var si = oi(9447), di = oi(4284), fi = oi(5817);
              ai.exports = function(gi, mi, Ti) {
                si ? di.f(gi, mi, fi(0, Ti)) : gi[mi] = Ti;
              };
            })
          ),
          /***/
          9251: (
            /***/
            ((ai, li, oi) => {
              var si = oi(4284);
              ai.exports = function(di, fi, gi) {
                return si.f(di, fi, gi);
              };
            })
          ),
          /***/
          8055: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1626);
              ai.exports = function(di, fi, gi, mi) {
                return mi && mi.enumerable ? di[fi] = gi : si(di, fi, gi), di;
              };
            })
          ),
          /***/
          2802: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8055);
              ai.exports = function(di, fi, gi) {
                for (var mi in fi)
                  gi && gi.unsafe && di[mi] ? di[mi] = fi[mi] : si(di, mi, fi[mi], gi);
                return di;
              };
            })
          ),
          /***/
          2532: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5951), di = Object.defineProperty;
              ai.exports = function(fi, gi) {
                try {
                  di(si, fi, { value: gi, configurable: !0, writable: !0 });
                } catch {
                  si[fi] = gi;
                }
                return gi;
              };
            })
          ),
          /***/
          4535: (
            /***/
            ((ai, li, oi) => {
              var si = oi(4640), di = TypeError;
              ai.exports = function(fi, gi) {
                if (!delete fi[gi]) throw new di("Cannot delete property " + si(gi) + " of " + si(fi));
              };
            })
          ),
          /***/
          9447: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8828);
              ai.exports = !si(function() {
                return Object.defineProperty({}, 1, { get: function() {
                  return 7;
                } })[1] !== 7;
              });
            })
          ),
          /***/
          9552: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5951), di = oi(6285), fi = si.document, gi = di(fi) && di(fi.createElement);
              ai.exports = function(mi) {
                return gi ? fi.createElement(mi) : {};
              };
            })
          ),
          /***/
          8024: (
            /***/
            ((ai) => {
              var li = TypeError, oi = 9007199254740991;
              ai.exports = function(si) {
                if (si > oi) throw li("Maximum allowed index exceeded");
                return si;
              };
            })
          ),
          /***/
          9287: (
            /***/
            ((ai) => {
              ai.exports = {
                CSSRuleList: 0,
                CSSStyleDeclaration: 0,
                CSSValueList: 0,
                ClientRectList: 0,
                DOMRectList: 0,
                DOMStringList: 0,
                DOMTokenList: 1,
                DataTransferItemList: 0,
                FileList: 0,
                HTMLAllCollection: 0,
                HTMLCollection: 0,
                HTMLFormElement: 0,
                HTMLSelectElement: 0,
                MediaList: 0,
                MimeTypeArray: 0,
                NamedNodeMap: 0,
                NodeList: 1,
                PaintRequestList: 0,
                Plugin: 0,
                PluginArray: 0,
                SVGLengthList: 0,
                SVGNumberList: 0,
                SVGPathSegList: 0,
                SVGPointList: 0,
                SVGStringList: 0,
                SVGTransformList: 0,
                SourceBufferList: 0,
                StyleSheetList: 0,
                TextTrackCueList: 0,
                TextTrackList: 0,
                TouchList: 0
              };
            })
          ),
          /***/
          376: (
            /***/
            ((ai) => {
              ai.exports = [
                "constructor",
                "hasOwnProperty",
                "isPrototypeOf",
                "propertyIsEnumerable",
                "toLocaleString",
                "toString",
                "valueOf"
              ];
            })
          ),
          /***/
          8606: (
            /***/
            ((ai, li, oi) => {
              var si = oi(6794);
              ai.exports = /ipad|iphone|ipod/i.test(si) && typeof Pebble < "u";
            })
          ),
          /***/
          1829: (
            /***/
            ((ai, li, oi) => {
              var si = oi(6794);
              ai.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(si);
            })
          ),
          /***/
          7586: (
            /***/
            ((ai, li, oi) => {
              var si = oi(2832);
              ai.exports = si === "NODE";
            })
          ),
          /***/
          9291: (
            /***/
            ((ai, li, oi) => {
              var si = oi(6794);
              ai.exports = /web0s(?!.*chrome)/i.test(si);
            })
          ),
          /***/
          6794: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5951), di = si.navigator, fi = di && di.userAgent;
              ai.exports = fi ? String(fi) : "";
            })
          ),
          /***/
          798: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5951), di = oi(6794), fi = si.process, gi = si.Deno, mi = fi && fi.versions || gi && gi.version, Ti = mi && mi.v8, vi, xi;
              Ti && (vi = Ti.split("."), xi = vi[0] > 0 && vi[0] < 4 ? 1 : +(vi[0] + vi[1])), !xi && di && (vi = di.match(/Edge\/(\d+)/), (!vi || vi[1] >= 74) && (vi = di.match(/Chrome\/(\d+)/), vi && (xi = +vi[1]))), ai.exports = xi;
            })
          ),
          /***/
          2832: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5951), di = oi(6794), fi = oi(5807), gi = function(mi) {
                return di.slice(0, mi.length) === mi;
              };
              ai.exports = (function() {
                return gi("Bun/") ? "BUN" : gi("Cloudflare-Workers") ? "CLOUDFLARE" : gi("Deno/") ? "DENO" : gi("Node.js/") ? "NODE" : si.Bun && typeof Bun.version == "string" ? "BUN" : si.Deno && typeof Deno.version == "object" ? "DENO" : fi(si.process) === "process" ? "NODE" : si.window && si.document ? "BROWSER" : "REST";
              })();
            })
          ),
          /***/
          5762: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1907), di = Error, fi = si("".replace), gi = (function(vi) {
                return String(new di(vi).stack);
              })("zxcasd"), mi = /\n\s*at [^:]*:[^\n]*/, Ti = mi.test(gi);
              ai.exports = function(vi, xi) {
                if (Ti && typeof vi == "string" && !di.prepareStackTrace)
                  for (; xi--; ) vi = fi(vi, mi, "");
                return vi;
              };
            })
          ),
          /***/
          5884: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1626), di = oi(5762), fi = oi(3888), gi = Error.captureStackTrace;
              ai.exports = function(mi, Ti, vi, xi) {
                fi && (gi ? gi(mi, Ti) : si(mi, "stack", di(vi, xi)));
              };
            })
          ),
          /***/
          3888: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8828), di = oi(5817);
              ai.exports = !si(function() {
                var fi = new Error("a");
                return "stack" in fi ? (Object.defineProperty(fi, "stack", di(1, 7)), fi.stack !== 7) : !0;
              });
            })
          ),
          /***/
          1091: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5951), di = oi(6024), fi = oi(2361), gi = oi(2250), mi = oi(3846).f, Ti = oi(7463), vi = oi(2046), xi = oi(8311), Si = oi(1626), Pi = oi(9724);
              oi(6128);
              var $i = function(Oi) {
                var Di = function(Mi, Oo, io) {
                  if (this instanceof Di) {
                    switch (arguments.length) {
                      case 0:
                        return new Oi();
                      case 1:
                        return new Oi(Mi);
                      case 2:
                        return new Oi(Mi, Oo);
                    }
                    return new Oi(Mi, Oo, io);
                  }
                  return di(Oi, this, arguments);
                };
                return Di.prototype = Oi.prototype, Di;
              };
              ai.exports = function(Oi, Di) {
                var Mi = Oi.target, Oo = Oi.global, io = Oi.stat, xo = Oi.proto, fo = Oo ? si : io ? si[Mi] : si[Mi] && si[Mi].prototype, _o = Oo ? vi : vi[Mi] || Si(vi, Mi, {})[Mi], Li = _o.prototype, Co, Ni, Yi, Vo, No, Ui, jo, Wi, ji;
                for (Vo in Di)
                  Co = Ti(Oo ? Vo : Mi + (io ? "." : "#") + Vo, Oi.forced), Ni = !Co && fo && Pi(fo, Vo), Ui = _o[Vo], Ni && (Oi.dontCallGetSet ? (ji = mi(fo, Vo), jo = ji && ji.value) : jo = fo[Vo]), No = Ni && jo ? jo : Di[Vo], !(!Co && !xo && typeof Ui == typeof No) && (Oi.bind && Ni ? Wi = xi(No, si) : Oi.wrap && Ni ? Wi = $i(No) : xo && gi(No) ? Wi = fi(No) : Wi = No, (Oi.sham || No && No.sham || Ui && Ui.sham) && Si(Wi, "sham", !0), Si(_o, Vo, Wi), xo && (Yi = Mi + "Prototype", Pi(vi, Yi) || Si(vi, Yi, {}), Si(vi[Yi], Vo, No), Oi.real && Li && (Co || !Li[Vo]) && Si(Li, Vo, No)));
              };
            })
          ),
          /***/
          8828: (
            /***/
            ((ai) => {
              ai.exports = function(li) {
                try {
                  return !!li();
                } catch {
                  return !0;
                }
              };
            })
          ),
          /***/
          5681: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8828);
              ai.exports = !si(function() {
                return Object.isExtensible(Object.preventExtensions({}));
              });
            })
          ),
          /***/
          6024: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1505), di = Function.prototype, fi = di.apply, gi = di.call;
              ai.exports = typeof Reflect == "object" && Reflect.apply || (si ? gi.bind(fi) : function() {
                return gi.apply(fi, arguments);
              });
            })
          ),
          /***/
          8311: (
            /***/
            ((ai, li, oi) => {
              var si = oi(2361), di = oi(2159), fi = oi(1505), gi = si(si.bind);
              ai.exports = function(mi, Ti) {
                return di(mi), Ti === void 0 ? mi : fi ? gi(mi, Ti) : function() {
                  return mi.apply(Ti, arguments);
                };
              };
            })
          ),
          /***/
          1505: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8828);
              ai.exports = !si(function() {
                var di = (function() {
                }).bind();
                return typeof di != "function" || di.hasOwnProperty("prototype");
              });
            })
          ),
          /***/
          4673: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1907), di = oi(2159), fi = oi(6285), gi = oi(9724), mi = oi(3427), Ti = oi(1505), vi = Function, xi = si([].concat), Si = si([].join), Pi = {}, $i = function(Oi, Di, Mi) {
                if (!gi(Pi, Di)) {
                  for (var Oo = [], io = 0; io < Di; io++) Oo[io] = "a[" + io + "]";
                  Pi[Di] = vi("C,a", "return new C(" + Si(Oo, ",") + ")");
                }
                return Pi[Di](Oi, Mi);
              };
              ai.exports = Ti ? vi.bind : function(Di) {
                var Mi = di(this), Oo = Mi.prototype, io = mi(arguments, 1), xo = function() {
                  var _o = xi(io, mi(arguments));
                  return this instanceof xo ? $i(Mi, _o.length, _o) : Mi.apply(Di, _o);
                };
                return fi(Oo) && (xo.prototype = Oo), xo;
              };
            })
          ),
          /***/
          3930: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1505), di = Function.prototype.call;
              ai.exports = si ? di.bind(di) : function() {
                return di.apply(di, arguments);
              };
            })
          ),
          /***/
          6833: (
            /***/
            ((ai, li, oi) => {
              var si = oi(9447), di = oi(9724), fi = Function.prototype, gi = si && Object.getOwnPropertyDescriptor, mi = di(fi, "name"), Ti = mi && (function() {
              }).name === "something", vi = mi && (!si || si && gi(fi, "name").configurable);
              ai.exports = {
                EXISTS: mi,
                PROPER: Ti,
                CONFIGURABLE: vi
              };
            })
          ),
          /***/
          1871: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1907), di = oi(2159);
              ai.exports = function(fi, gi, mi) {
                try {
                  return si(di(Object.getOwnPropertyDescriptor(fi, gi)[mi]));
                } catch {
                }
              };
            })
          ),
          /***/
          2361: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5807), di = oi(1907);
              ai.exports = function(fi) {
                if (si(fi) === "Function") return di(fi);
              };
            })
          ),
          /***/
          1907: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1505), di = Function.prototype, fi = di.call, gi = si && di.bind.bind(fi, fi);
              ai.exports = si ? gi : function(mi) {
                return function() {
                  return fi.apply(mi, arguments);
                };
              };
            })
          ),
          /***/
          1747: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5951), di = oi(2046);
              ai.exports = function(fi, gi) {
                var mi = di[fi + "Prototype"], Ti = mi && mi[gi];
                if (Ti) return Ti;
                var vi = si[fi], xi = vi && vi.prototype;
                return xi && xi[gi];
              };
            })
          ),
          /***/
          5582: (
            /***/
            ((ai, li, oi) => {
              var si = oi(2046), di = oi(5951), fi = oi(2250), gi = function(mi) {
                return fi(mi) ? mi : void 0;
              };
              ai.exports = function(mi, Ti) {
                return arguments.length < 2 ? gi(si[mi]) || gi(di[mi]) : si[mi] && si[mi][Ti] || di[mi] && di[mi][Ti];
              };
            })
          ),
          /***/
          3448: (
            /***/
            ((ai, li, oi) => {
              var si = oi(3948), di = oi(9367), fi = oi(7136), gi = oi(3742), mi = oi(6264), Ti = mi("iterator");
              ai.exports = function(vi) {
                if (!fi(vi)) return di(vi, Ti) || di(vi, "@@iterator") || gi[si(vi)];
              };
            })
          ),
          /***/
          300: (
            /***/
            ((ai, li, oi) => {
              var si = oi(3930), di = oi(2159), fi = oi(6624), gi = oi(4640), mi = oi(3448), Ti = TypeError;
              ai.exports = function(vi, xi) {
                var Si = arguments.length < 2 ? mi(vi) : xi;
                if (di(Si)) return fi(si(Si, vi));
                throw new Ti(gi(vi) + " is not iterable");
              };
            })
          ),
          /***/
          6656: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1907), di = oi(1793), fi = oi(2250), gi = oi(5807), mi = oi(160), Ti = si([].push);
              ai.exports = function(vi) {
                if (fi(vi)) return vi;
                if (di(vi)) {
                  for (var xi = vi.length, Si = [], Pi = 0; Pi < xi; Pi++) {
                    var $i = vi[Pi];
                    typeof $i == "string" ? Ti(Si, $i) : (typeof $i == "number" || gi($i) === "Number" || gi($i) === "String") && Ti(Si, mi($i));
                  }
                  var Oi = Si.length, Di = !0;
                  return function(Mi, Oo) {
                    if (Di)
                      return Di = !1, Oo;
                    if (di(this)) return Oo;
                    for (var io = 0; io < Oi; io++) if (Si[io] === Mi) return Oo;
                  };
                }
              };
            })
          ),
          /***/
          9367: (
            /***/
            ((ai, li, oi) => {
              var si = oi(2159), di = oi(7136);
              ai.exports = function(fi, gi) {
                var mi = fi[gi];
                return di(mi) ? void 0 : si(mi);
              };
            })
          ),
          /***/
          5951: (
            /***/
            (function(ai, li, oi) {
              var si = function(di) {
                return di && di.Math === Math && di;
              };
              ai.exports = // eslint-disable-next-line es/no-global-this -- safe
              si(typeof globalThis == "object" && globalThis) || si(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
              si(typeof self == "object" && self) || si(typeof oi.g == "object" && oi.g) || si(typeof this == "object" && this) || // eslint-disable-next-line no-new-func -- fallback
              /* @__PURE__ */ (function() {
                return this;
              })() || Function("return this")();
            })
          ),
          /***/
          9724: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1907), di = oi(9298), fi = si({}.hasOwnProperty);
              ai.exports = Object.hasOwn || function(mi, Ti) {
                return fi(di(mi), Ti);
              };
            })
          ),
          /***/
          8530: (
            /***/
            ((ai) => {
              ai.exports = {};
            })
          ),
          /***/
          3904: (
            /***/
            ((ai) => {
              ai.exports = function(li, oi) {
                try {
                  arguments.length === 1 ? console.error(li) : console.error(li, oi);
                } catch {
                }
              };
            })
          ),
          /***/
          2416: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5582);
              ai.exports = si("document", "documentElement");
            })
          ),
          /***/
          3648: (
            /***/
            ((ai, li, oi) => {
              var si = oi(9447), di = oi(8828), fi = oi(9552);
              ai.exports = !si && !di(function() {
                return Object.defineProperty(fi("div"), "a", {
                  get: function() {
                    return 7;
                  }
                }).a !== 7;
              });
            })
          ),
          /***/
          6946: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1907), di = oi(8828), fi = oi(5807), gi = Object, mi = si("".split);
              ai.exports = di(function() {
                return !gi("z").propertyIsEnumerable(0);
              }) ? function(Ti) {
                return fi(Ti) === "String" ? mi(Ti, "") : gi(Ti);
              } : gi;
            })
          ),
          /***/
          2647: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1907), di = oi(2250), fi = oi(6128), gi = si(Function.toString);
              di(fi.inspectSource) || (fi.inspectSource = function(mi) {
                return gi(mi);
              }), ai.exports = fi.inspectSource;
            })
          ),
          /***/
          9259: (
            /***/
            ((ai, li, oi) => {
              var si = oi(6285), di = oi(1626);
              ai.exports = function(fi, gi) {
                si(gi) && "cause" in gi && di(fi, "cause", gi.cause);
              };
            })
          ),
          /***/
          1548: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(1907), fi = oi(8530), gi = oi(6285), mi = oi(9724), Ti = oi(4284).f, vi = oi(4443), xi = oi(5407), Si = oi(7005), Pi = oi(6499), $i = oi(5681), Oi = !1, Di = Pi("meta"), Mi = 0, Oo = function(Co) {
                Ti(Co, Di, { value: {
                  objectID: "O" + Mi++,
                  // object ID
                  weakData: {}
                  // weak collections IDs
                } });
              }, io = function(Co, Ni) {
                if (!gi(Co)) return typeof Co == "symbol" ? Co : (typeof Co == "string" ? "S" : "P") + Co;
                if (!mi(Co, Di)) {
                  if (!Si(Co)) return "F";
                  if (!Ni) return "E";
                  Oo(Co);
                }
                return Co[Di].objectID;
              }, xo = function(Co, Ni) {
                if (!mi(Co, Di)) {
                  if (!Si(Co)) return !0;
                  if (!Ni) return !1;
                  Oo(Co);
                }
                return Co[Di].weakData;
              }, fo = function(Co) {
                return $i && Oi && Si(Co) && !mi(Co, Di) && Oo(Co), Co;
              }, _o = function() {
                Li.enable = function() {
                }, Oi = !0;
                var Co = vi.f, Ni = di([].splice), Yi = {};
                Yi[Di] = 1, Co(Yi).length && (vi.f = function(Vo) {
                  for (var No = Co(Vo), Ui = 0, jo = No.length; Ui < jo; Ui++)
                    if (No[Ui] === Di) {
                      Ni(No, Ui, 1);
                      break;
                    }
                  return No;
                }, si({ target: "Object", stat: !0, forced: !0 }, {
                  getOwnPropertyNames: xi.f
                }));
              }, Li = ai.exports = {
                enable: _o,
                fastKey: io,
                getWeakData: xo,
                onFreeze: fo
              };
              fi[Di] = !0;
            })
          ),
          /***/
          4932: (
            /***/
            ((ai, li, oi) => {
              var si = oi(551), di = oi(5951), fi = oi(6285), gi = oi(1626), mi = oi(9724), Ti = oi(6128), vi = oi(2522), xi = oi(8530), Si = "Object already initialized", Pi = di.TypeError, $i = di.WeakMap, Oi, Di, Mi, Oo = function(_o) {
                return Mi(_o) ? Di(_o) : Oi(_o, {});
              }, io = function(_o) {
                return function(Li) {
                  var Co;
                  if (!fi(Li) || (Co = Di(Li)).type !== _o)
                    throw new Pi("Incompatible receiver, " + _o + " required");
                  return Co;
                };
              };
              if (si || Ti.state) {
                var xo = Ti.state || (Ti.state = new $i());
                xo.get = xo.get, xo.has = xo.has, xo.set = xo.set, Oi = function(_o, Li) {
                  if (xo.has(_o)) throw new Pi(Si);
                  return Li.facade = _o, xo.set(_o, Li), Li;
                }, Di = function(_o) {
                  return xo.get(_o) || {};
                }, Mi = function(_o) {
                  return xo.has(_o);
                };
              } else {
                var fo = vi("state");
                xi[fo] = !0, Oi = function(_o, Li) {
                  if (mi(_o, fo)) throw new Pi(Si);
                  return Li.facade = _o, gi(_o, fo, Li), Li;
                }, Di = function(_o) {
                  return mi(_o, fo) ? _o[fo] : {};
                }, Mi = function(_o) {
                  return mi(_o, fo);
                };
              }
              ai.exports = {
                set: Oi,
                get: Di,
                has: Mi,
                enforce: Oo,
                getterFor: io
              };
            })
          ),
          /***/
          7812: (
            /***/
            ((ai, li, oi) => {
              var si = oi(6264), di = oi(3742), fi = si("iterator"), gi = Array.prototype;
              ai.exports = function(mi) {
                return mi !== void 0 && (di.Array === mi || gi[fi] === mi);
              };
            })
          ),
          /***/
          1793: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5807);
              ai.exports = Array.isArray || function(fi) {
                return si(fi) === "Array";
              };
            })
          ),
          /***/
          2250: (
            /***/
            ((ai) => {
              var li = typeof document == "object" && document.all;
              ai.exports = typeof li > "u" && li !== void 0 ? function(oi) {
                return typeof oi == "function" || oi === li;
              } : function(oi) {
                return typeof oi == "function";
              };
            })
          ),
          /***/
          5468: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1907), di = oi(8828), fi = oi(2250), gi = oi(3948), mi = oi(5582), Ti = oi(2647), vi = function() {
              }, xi = mi("Reflect", "construct"), Si = /^\s*(?:class|function)\b/, Pi = si(Si.exec), $i = !Si.test(vi), Oi = function(Oo) {
                if (!fi(Oo)) return !1;
                try {
                  return xi(vi, [], Oo), !0;
                } catch {
                  return !1;
                }
              }, Di = function(Oo) {
                if (!fi(Oo)) return !1;
                switch (gi(Oo)) {
                  case "AsyncFunction":
                  case "GeneratorFunction":
                  case "AsyncGeneratorFunction":
                    return !1;
                }
                try {
                  return $i || !!Pi(Si, Ti(Oo));
                } catch {
                  return !0;
                }
              };
              Di.sham = !0, ai.exports = !xi || di(function() {
                var Mi;
                return Oi(Oi.call) || !Oi(Object) || !Oi(function() {
                  Mi = !0;
                }) || Mi;
              }) ? Di : Oi;
            })
          ),
          /***/
          218: (
            /***/
            ((ai, li, oi) => {
              var si = oi(9724);
              ai.exports = function(di) {
                return di !== void 0 && (si(di, "value") || si(di, "writable"));
              };
            })
          ),
          /***/
          7463: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8828), di = oi(2250), fi = /#|\.prototype\./, gi = function(Si, Pi) {
                var $i = Ti[mi(Si)];
                return $i === xi ? !0 : $i === vi ? !1 : di(Pi) ? si(Pi) : !!Pi;
              }, mi = gi.normalize = function(Si) {
                return String(Si).replace(fi, ".").toLowerCase();
              }, Ti = gi.data = {}, vi = gi.NATIVE = "N", xi = gi.POLYFILL = "P";
              ai.exports = gi;
            })
          ),
          /***/
          7136: (
            /***/
            ((ai) => {
              ai.exports = function(li) {
                return li == null;
              };
            })
          ),
          /***/
          6285: (
            /***/
            ((ai, li, oi) => {
              var si = oi(2250);
              ai.exports = function(di) {
                return typeof di == "object" ? di !== null : si(di);
              };
            })
          ),
          /***/
          4018: (
            /***/
            ((ai, li, oi) => {
              var si = oi(6285);
              ai.exports = function(di) {
                return si(di) || di === null;
              };
            })
          ),
          /***/
          7376: (
            /***/
            ((ai) => {
              ai.exports = !0;
            })
          ),
          /***/
          2087: (
            /***/
            ((ai, li, oi) => {
              var si = oi(6285), di = oi(5807), fi = oi(6264), gi = fi("match");
              ai.exports = function(mi) {
                var Ti;
                return si(mi) && ((Ti = mi[gi]) !== void 0 ? !!Ti : di(mi) === "RegExp");
              };
            })
          ),
          /***/
          5594: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5582), di = oi(2250), fi = oi(8280), gi = oi(1175), mi = Object;
              ai.exports = gi ? function(Ti) {
                return typeof Ti == "symbol";
              } : function(Ti) {
                var vi = si("Symbol");
                return di(vi) && fi(vi.prototype, mi(Ti));
              };
            })
          ),
          /***/
          4823: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8311), di = oi(3930), fi = oi(6624), gi = oi(4640), mi = oi(7812), Ti = oi(575), vi = oi(8280), xi = oi(300), Si = oi(3448), Pi = oi(154), $i = TypeError, Oi = function(Mi, Oo) {
                this.stopped = Mi, this.result = Oo;
              }, Di = Oi.prototype;
              ai.exports = function(Mi, Oo, io) {
                var xo = io && io.that, fo = !!(io && io.AS_ENTRIES), _o = !!(io && io.IS_RECORD), Li = !!(io && io.IS_ITERATOR), Co = !!(io && io.INTERRUPTED), Ni = si(Oo, xo), Yi, Vo, No, Ui, jo, Wi, ji, Hi = function(Lo) {
                  return Yi && Pi(Yi, "normal", Lo), new Oi(!0, Lo);
                }, zo = function(Lo) {
                  return fo ? (fi(Lo), Co ? Ni(Lo[0], Lo[1], Hi) : Ni(Lo[0], Lo[1])) : Co ? Ni(Lo, Hi) : Ni(Lo);
                };
                if (_o)
                  Yi = Mi.iterator;
                else if (Li)
                  Yi = Mi;
                else {
                  if (Vo = Si(Mi), !Vo) throw new $i(gi(Mi) + " is not iterable");
                  if (mi(Vo)) {
                    for (No = 0, Ui = Ti(Mi); Ui > No; No++)
                      if (jo = zo(Mi[No]), jo && vi(Di, jo)) return jo;
                    return new Oi(!1);
                  }
                  Yi = xi(Mi, Vo);
                }
                for (Wi = _o ? Mi.next : Yi.next; !(ji = di(Wi, Yi)).done; ) {
                  try {
                    jo = zo(ji.value);
                  } catch (Lo) {
                    Pi(Yi, "throw", Lo);
                  }
                  if (typeof jo == "object" && jo && vi(Di, jo)) return jo;
                }
                return new Oi(!1);
              };
            })
          ),
          /***/
          154: (
            /***/
            ((ai, li, oi) => {
              var si = oi(3930), di = oi(6624), fi = oi(9367);
              ai.exports = function(gi, mi, Ti) {
                var vi, xi;
                di(gi);
                try {
                  if (vi = fi(gi, "return"), !vi) {
                    if (mi === "throw") throw Ti;
                    return Ti;
                  }
                  vi = si(vi, gi);
                } catch (Si) {
                  xi = !0, vi = Si;
                }
                if (mi === "throw") throw Ti;
                if (xi) throw vi;
                return di(vi), Ti;
              };
            })
          ),
          /***/
          7181: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5116).IteratorPrototype, di = oi(8075), fi = oi(5817), gi = oi(4840), mi = oi(3742), Ti = function() {
                return this;
              };
              ai.exports = function(vi, xi, Si, Pi) {
                var $i = xi + " Iterator";
                return vi.prototype = di(si, { next: fi(+!Pi, Si) }), gi(vi, $i, !1, !0), mi[$i] = Ti, vi;
              };
            })
          ),
          /***/
          183: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(3930), fi = oi(7376), gi = oi(6833), mi = oi(2250), Ti = oi(7181), vi = oi(5972), xi = oi(9192), Si = oi(4840), Pi = oi(1626), $i = oi(8055), Oi = oi(6264), Di = oi(3742), Mi = oi(5116), Oo = gi.PROPER, io = gi.CONFIGURABLE, xo = Mi.IteratorPrototype, fo = Mi.BUGGY_SAFARI_ITERATORS, _o = Oi("iterator"), Li = "keys", Co = "values", Ni = "entries", Yi = function() {
                return this;
              };
              ai.exports = function(Vo, No, Ui, jo, Wi, ji, Hi) {
                Ti(Ui, No, jo);
                var zo = function(xa) {
                  if (xa === Wi && pa) return pa;
                  if (!fo && xa && xa in Ko) return Ko[xa];
                  switch (xa) {
                    case Li:
                      return function() {
                        return new Ui(this, xa);
                      };
                    case Co:
                      return function() {
                        return new Ui(this, xa);
                      };
                    case Ni:
                      return function() {
                        return new Ui(this, xa);
                      };
                  }
                  return function() {
                    return new Ui(this);
                  };
                }, Lo = No + " Iterator", sa = !1, Ko = Vo.prototype, ca = Ko[_o] || Ko["@@iterator"] || Wi && Ko[Wi], pa = !fo && ca || zo(Wi), ga = No === "Array" && Ko.entries || ca, ia, ra, qo;
                if (ga && (ia = vi(ga.call(new Vo())), ia !== Object.prototype && ia.next && (!fi && vi(ia) !== xo && (xi ? xi(ia, xo) : mi(ia[_o]) || $i(ia, _o, Yi)), Si(ia, Lo, !0, !0), fi && (Di[Lo] = Yi))), Oo && Wi === Co && ca && ca.name !== Co && (!fi && io ? Pi(Ko, "name", Co) : (sa = !0, pa = function() {
                  return di(ca, this);
                })), Wi)
                  if (ra = {
                    values: zo(Co),
                    keys: ji ? pa : zo(Li),
                    entries: zo(Ni)
                  }, Hi) for (qo in ra)
                    (fo || sa || !(qo in Ko)) && $i(Ko, qo, ra[qo]);
                  else si({ target: No, proto: !0, forced: fo || sa }, ra);
                return (!fi || Hi) && Ko[_o] !== pa && $i(Ko, _o, pa, { name: Wi }), Di[No] = pa, ra;
              };
            })
          ),
          /***/
          5116: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8828), di = oi(2250), fi = oi(6285), gi = oi(8075), mi = oi(5972), Ti = oi(8055), vi = oi(6264), xi = oi(7376), Si = vi("iterator"), Pi = !1, $i, Oi, Di;
              [].keys && (Di = [].keys(), "next" in Di ? (Oi = mi(mi(Di)), Oi !== Object.prototype && ($i = Oi)) : Pi = !0);
              var Mi = !fi($i) || si(function() {
                var Oo = {};
                return $i[Si].call(Oo) !== Oo;
              });
              Mi ? $i = {} : xi && ($i = gi($i)), di($i[Si]) || Ti($i, Si, function() {
                return this;
              }), ai.exports = {
                IteratorPrototype: $i,
                BUGGY_SAFARI_ITERATORS: Pi
              };
            })
          ),
          /***/
          3742: (
            /***/
            ((ai) => {
              ai.exports = {};
            })
          ),
          /***/
          575: (
            /***/
            ((ai, li, oi) => {
              var si = oi(3121);
              ai.exports = function(di) {
                return si(di.length);
              };
            })
          ),
          /***/
          1176: (
            /***/
            ((ai) => {
              var li = Math.ceil, oi = Math.floor;
              ai.exports = Math.trunc || function(di) {
                var fi = +di;
                return (fi > 0 ? oi : li)(fi);
              };
            })
          ),
          /***/
          2292: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5951), di = oi(2098), fi = oi(8311), gi = oi(9472).set, mi = oi(9245), Ti = oi(1829), vi = oi(8606), xi = oi(9291), Si = oi(7586), Pi = si.MutationObserver || si.WebKitMutationObserver, $i = si.document, Oi = si.process, Di = si.Promise, Mi = di("queueMicrotask"), Oo, io, xo, fo, _o;
              if (!Mi) {
                var Li = new mi(), Co = function() {
                  var Ni, Yi;
                  for (Si && (Ni = Oi.domain) && Ni.exit(); Yi = Li.get(); ) try {
                    Yi();
                  } catch (Vo) {
                    throw Li.head && Oo(), Vo;
                  }
                  Ni && Ni.enter();
                };
                !Ti && !Si && !xi && Pi && $i ? (io = !0, xo = $i.createTextNode(""), new Pi(Co).observe(xo, { characterData: !0 }), Oo = function() {
                  xo.data = io = !io;
                }) : !vi && Di && Di.resolve ? (fo = Di.resolve(void 0), fo.constructor = Di, _o = fi(fo.then, fo), Oo = function() {
                  _o(Co);
                }) : Si ? Oo = function() {
                  Oi.nextTick(Co);
                } : (gi = fi(gi, si), Oo = function() {
                  gi(Co);
                }), Mi = function(Ni) {
                  Li.head || Oo(), Li.add(Ni);
                };
              }
              ai.exports = Mi;
            })
          ),
          /***/
          6254: (
            /***/
            ((ai, li, oi) => {
              var si = oi(2159), di = TypeError, fi = function(gi) {
                var mi, Ti;
                this.promise = new gi(function(vi, xi) {
                  if (mi !== void 0 || Ti !== void 0) throw new di("Bad Promise constructor");
                  mi = vi, Ti = xi;
                }), this.resolve = si(mi), this.reject = si(Ti);
              };
              ai.exports.f = function(gi) {
                return new fi(gi);
              };
            })
          ),
          /***/
          2096: (
            /***/
            ((ai, li, oi) => {
              var si = oi(160);
              ai.exports = function(di, fi) {
                return di === void 0 ? arguments.length < 2 ? "" : fi : si(di);
              };
            })
          ),
          /***/
          2074: (
            /***/
            ((ai, li, oi) => {
              var si = oi(2087), di = TypeError;
              ai.exports = function(fi) {
                if (si(fi))
                  throw new di("The method doesn't accept regular expressions");
                return fi;
              };
            })
          ),
          /***/
          2778: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5951), di = oi(8828), fi = oi(1907), gi = oi(160), mi = oi(5993).trim, Ti = oi(6395), vi = si.parseInt, xi = si.Symbol, Si = xi && xi.iterator, Pi = /^[+-]?0x/i, $i = fi(Pi.exec), Oi = vi(Ti + "08") !== 8 || vi(Ti + "0x16") !== 22 || Si && !di(function() {
                vi(Object(Si));
              });
              ai.exports = Oi ? function(Mi, Oo) {
                var io = mi(gi(Mi));
                return vi(io, Oo >>> 0 || ($i(Pi, io) ? 16 : 10));
              } : vi;
            })
          ),
          /***/
          9538: (
            /***/
            ((ai, li, oi) => {
              var si = oi(9447), di = oi(1907), fi = oi(3930), gi = oi(8828), mi = oi(2875), Ti = oi(7170), vi = oi(193), xi = oi(9298), Si = oi(6946), Pi = Object.assign, $i = Object.defineProperty, Oi = di([].concat);
              ai.exports = !Pi || gi(function() {
                if (si && Pi({ b: 1 }, Pi($i({}, "a", {
                  enumerable: !0,
                  get: function() {
                    $i(this, "b", {
                      value: 3,
                      enumerable: !1
                    });
                  }
                }), { b: 2 })).b !== 1) return !0;
                var Di = {}, Mi = {}, Oo = Symbol("assign detection"), io = "abcdefghijklmnopqrst";
                return Di[Oo] = 7, io.split("").forEach(function(xo) {
                  Mi[xo] = xo;
                }), Pi({}, Di)[Oo] !== 7 || mi(Pi({}, Mi)).join("") !== io;
              }) ? function(Mi, Oo) {
                for (var io = xi(Mi), xo = arguments.length, fo = 1, _o = Ti.f, Li = vi.f; xo > fo; )
                  for (var Co = Si(arguments[fo++]), Ni = _o ? Oi(mi(Co), _o(Co)) : mi(Co), Yi = Ni.length, Vo = 0, No; Yi > Vo; )
                    No = Ni[Vo++], (!si || fi(Li, Co, No)) && (io[No] = Co[No]);
                return io;
              } : Pi;
            })
          ),
          /***/
          8075: (
            /***/
            ((ai, li, oi) => {
              var si = oi(6624), di = oi(2220), fi = oi(376), gi = oi(8530), mi = oi(2416), Ti = oi(9552), vi = oi(2522), xi = ">", Si = "<", Pi = "prototype", $i = "script", Oi = vi("IE_PROTO"), Di = function() {
              }, Mi = function(_o) {
                return Si + $i + xi + _o + Si + "/" + $i + xi;
              }, Oo = function(_o) {
                _o.write(Mi("")), _o.close();
                var Li = _o.parentWindow.Object;
                return _o = null, Li;
              }, io = function() {
                var _o = Ti("iframe"), Li = "java" + $i + ":", Co;
                return _o.style.display = "none", mi.appendChild(_o), _o.src = String(Li), Co = _o.contentWindow.document, Co.open(), Co.write(Mi("document.F=Object")), Co.close(), Co.F;
              }, xo, fo = function() {
                try {
                  xo = new ActiveXObject("htmlfile");
                } catch {
                }
                fo = typeof document < "u" ? document.domain && xo ? Oo(xo) : io() : Oo(xo);
                for (var _o = fi.length; _o--; ) delete fo[Pi][fi[_o]];
                return fo();
              };
              gi[Oi] = !0, ai.exports = Object.create || function(Li, Co) {
                var Ni;
                return Li !== null ? (Di[Pi] = si(Li), Ni = new Di(), Di[Pi] = null, Ni[Oi] = Li) : Ni = fo(), Co === void 0 ? Ni : di.f(Ni, Co);
              };
            })
          ),
          /***/
          2220: (
            /***/
            ((ai, li, oi) => {
              var si = oi(9447), di = oi(8661), fi = oi(4284), gi = oi(6624), mi = oi(7374), Ti = oi(2875);
              li.f = si && !di ? Object.defineProperties : function(xi, Si) {
                gi(xi);
                for (var Pi = mi(Si), $i = Ti(Si), Oi = $i.length, Di = 0, Mi; Oi > Di; ) fi.f(xi, Mi = $i[Di++], Pi[Mi]);
                return xi;
              };
            })
          ),
          /***/
          4284: (
            /***/
            ((ai, li, oi) => {
              var si = oi(9447), di = oi(3648), fi = oi(8661), gi = oi(6624), mi = oi(470), Ti = TypeError, vi = Object.defineProperty, xi = Object.getOwnPropertyDescriptor, Si = "enumerable", Pi = "configurable", $i = "writable";
              li.f = si ? fi ? function(Di, Mi, Oo) {
                if (gi(Di), Mi = mi(Mi), gi(Oo), typeof Di == "function" && Mi === "prototype" && "value" in Oo && $i in Oo && !Oo[$i]) {
                  var io = xi(Di, Mi);
                  io && io[$i] && (Di[Mi] = Oo.value, Oo = {
                    configurable: Pi in Oo ? Oo[Pi] : io[Pi],
                    enumerable: Si in Oo ? Oo[Si] : io[Si],
                    writable: !1
                  });
                }
                return vi(Di, Mi, Oo);
              } : vi : function(Di, Mi, Oo) {
                if (gi(Di), Mi = mi(Mi), gi(Oo), di) try {
                  return vi(Di, Mi, Oo);
                } catch {
                }
                if ("get" in Oo || "set" in Oo) throw new Ti("Accessors not supported");
                return "value" in Oo && (Di[Mi] = Oo.value), Di;
              };
            })
          ),
          /***/
          3846: (
            /***/
            ((ai, li, oi) => {
              var si = oi(9447), di = oi(3930), fi = oi(193), gi = oi(5817), mi = oi(7374), Ti = oi(470), vi = oi(9724), xi = oi(3648), Si = Object.getOwnPropertyDescriptor;
              li.f = si ? Si : function($i, Oi) {
                if ($i = mi($i), Oi = Ti(Oi), xi) try {
                  return Si($i, Oi);
                } catch {
                }
                if (vi($i, Oi)) return gi(!di(fi.f, $i, Oi), $i[Oi]);
              };
            })
          ),
          /***/
          5407: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5807), di = oi(7374), fi = oi(4443).f, gi = oi(3427), mi = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], Ti = function(vi) {
                try {
                  return fi(vi);
                } catch {
                  return gi(mi);
                }
              };
              ai.exports.f = function(xi) {
                return mi && si(xi) === "Window" ? Ti(xi) : fi(di(xi));
              };
            })
          ),
          /***/
          4443: (
            /***/
            ((ai, li, oi) => {
              var si = oi(3045), di = oi(376), fi = di.concat("length", "prototype");
              li.f = Object.getOwnPropertyNames || function(mi) {
                return si(mi, fi);
              };
            })
          ),
          /***/
          7170: (
            /***/
            ((ai, li) => {
              li.f = Object.getOwnPropertySymbols;
            })
          ),
          /***/
          5972: (
            /***/
            ((ai, li, oi) => {
              var si = oi(9724), di = oi(2250), fi = oi(9298), gi = oi(2522), mi = oi(7382), Ti = gi("IE_PROTO"), vi = Object, xi = vi.prototype;
              ai.exports = mi ? vi.getPrototypeOf : function(Si) {
                var Pi = fi(Si);
                if (si(Pi, Ti)) return Pi[Ti];
                var $i = Pi.constructor;
                return di($i) && Pi instanceof $i ? $i.prototype : Pi instanceof vi ? xi : null;
              };
            })
          ),
          /***/
          7005: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8828), di = oi(6285), fi = oi(5807), gi = oi(6375), mi = Object.isExtensible, Ti = si(function() {
              });
              ai.exports = Ti || gi ? function(xi) {
                return !di(xi) || gi && fi(xi) === "ArrayBuffer" ? !1 : mi ? mi(xi) : !0;
              } : mi;
            })
          ),
          /***/
          8280: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1907);
              ai.exports = si({}.isPrototypeOf);
            })
          ),
          /***/
          3045: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1907), di = oi(9724), fi = oi(7374), gi = oi(4436).indexOf, mi = oi(8530), Ti = si([].push);
              ai.exports = function(vi, xi) {
                var Si = fi(vi), Pi = 0, $i = [], Oi;
                for (Oi in Si) !di(mi, Oi) && di(Si, Oi) && Ti($i, Oi);
                for (; xi.length > Pi; ) di(Si, Oi = xi[Pi++]) && (~gi($i, Oi) || Ti($i, Oi));
                return $i;
              };
            })
          ),
          /***/
          2875: (
            /***/
            ((ai, li, oi) => {
              var si = oi(3045), di = oi(376);
              ai.exports = Object.keys || function(gi) {
                return si(gi, di);
              };
            })
          ),
          /***/
          193: (
            /***/
            ((ai, li) => {
              var oi = {}.propertyIsEnumerable, si = Object.getOwnPropertyDescriptor, di = si && !oi.call({ 1: 2 }, 1);
              li.f = di ? function(gi) {
                var mi = si(this, gi);
                return !!mi && mi.enumerable;
              } : oi;
            })
          ),
          /***/
          9192: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1871), di = oi(6285), fi = oi(4239), gi = oi(43);
              ai.exports = Object.setPrototypeOf || ("__proto__" in {} ? (function() {
                var mi = !1, Ti = {}, vi;
                try {
                  vi = si(Object.prototype, "__proto__", "set"), vi(Ti, []), mi = Ti instanceof Array;
                } catch {
                }
                return function(Si, Pi) {
                  return fi(Si), gi(Pi), di(Si) && (mi ? vi(Si, Pi) : Si.__proto__ = Pi), Si;
                };
              })() : void 0);
            })
          ),
          /***/
          4298: (
            /***/
            ((ai, li, oi) => {
              var si = oi(9447), di = oi(8828), fi = oi(1907), gi = oi(5972), mi = oi(2875), Ti = oi(7374), vi = oi(193).f, xi = fi(vi), Si = fi([].push), Pi = si && di(function() {
                var Oi = /* @__PURE__ */ Object.create(null);
                return Oi[2] = 2, !xi(Oi, 2);
              }), $i = function(Oi) {
                return function(Di) {
                  for (var Mi = Ti(Di), Oo = mi(Mi), io = Pi && gi(Mi) === null, xo = Oo.length, fo = 0, _o = [], Li; xo > fo; )
                    Li = Oo[fo++], (!si || (io ? Li in Mi : xi(Mi, Li))) && Si(_o, Oi ? [Li, Mi[Li]] : Mi[Li]);
                  return _o;
                };
              };
              ai.exports = {
                // `Object.entries` method
                // https://tc39.es/ecma262/#sec-object.entries
                entries: $i(!0),
                // `Object.values` method
                // https://tc39.es/ecma262/#sec-object.values
                values: $i(!1)
              };
            })
          ),
          /***/
          4878: (
            /***/
            ((ai, li, oi) => {
              var si = oi(2623), di = oi(3948);
              ai.exports = si ? {}.toString : function() {
                return "[object " + di(this) + "]";
              };
            })
          ),
          /***/
          581: (
            /***/
            ((ai, li, oi) => {
              var si = oi(3930), di = oi(2250), fi = oi(6285), gi = TypeError;
              ai.exports = function(mi, Ti) {
                var vi, xi;
                if (Ti === "string" && di(vi = mi.toString) && !fi(xi = si(vi, mi)) || di(vi = mi.valueOf) && !fi(xi = si(vi, mi)) || Ti !== "string" && di(vi = mi.toString) && !fi(xi = si(vi, mi))) return xi;
                throw new gi("Can't convert object to primitive value");
              };
            })
          ),
          /***/
          1042: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5582), di = oi(1907), fi = oi(4443), gi = oi(7170), mi = oi(6624), Ti = di([].concat);
              ai.exports = si("Reflect", "ownKeys") || function(xi) {
                var Si = fi.f(mi(xi)), Pi = gi.f;
                return Pi ? Ti(Si, Pi(xi)) : Si;
              };
            })
          ),
          /***/
          2046: (
            /***/
            ((ai) => {
              ai.exports = {};
            })
          ),
          /***/
          4420: (
            /***/
            ((ai) => {
              ai.exports = function(li) {
                try {
                  return { error: !1, value: li() };
                } catch (oi) {
                  return { error: !0, value: oi };
                }
              };
            })
          ),
          /***/
          1759: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5951), di = oi(5463), fi = oi(2250), gi = oi(7463), mi = oi(2647), Ti = oi(6264), vi = oi(2832), xi = oi(7376), Si = oi(798), Pi = di && di.prototype, $i = Ti("species"), Oi = !1, Di = fi(si.PromiseRejectionEvent), Mi = gi("Promise", function() {
                var Oo = mi(di), io = Oo !== String(di);
                if (!io && Si === 66 || xi && !(Pi.catch && Pi.finally)) return !0;
                if (!Si || Si < 51 || !/native code/.test(Oo)) {
                  var xo = new di(function(Li) {
                    Li(1);
                  }), fo = function(Li) {
                    Li(function() {
                    }, function() {
                    });
                  }, _o = xo.constructor = {};
                  if (_o[$i] = fo, Oi = xo.then(function() {
                  }) instanceof fo, !Oi) return !0;
                }
                return !io && (vi === "BROWSER" || vi === "DENO") && !Di;
              });
              ai.exports = {
                CONSTRUCTOR: Mi,
                REJECTION_EVENT: Di,
                SUBCLASSING: Oi
              };
            })
          ),
          /***/
          5463: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5951);
              ai.exports = si.Promise;
            })
          ),
          /***/
          3569: (
            /***/
            ((ai, li, oi) => {
              var si = oi(6624), di = oi(6285), fi = oi(6254);
              ai.exports = function(gi, mi) {
                if (si(gi), di(mi) && mi.constructor === gi) return mi;
                var Ti = fi.f(gi), vi = Ti.resolve;
                return vi(mi), Ti.promise;
              };
            })
          ),
          /***/
          3282: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5463), di = oi(473), fi = oi(1759).CONSTRUCTOR;
              ai.exports = fi || !di(function(gi) {
                si.all(gi).then(void 0, function() {
                });
              });
            })
          ),
          /***/
          9245: (
            /***/
            ((ai) => {
              var li = function() {
                this.head = null, this.tail = null;
              };
              li.prototype = {
                add: function(oi) {
                  var si = { item: oi, next: null }, di = this.tail;
                  di ? di.next = si : this.head = si, this.tail = si;
                },
                get: function() {
                  var oi = this.head;
                  if (oi) {
                    var si = this.head = oi.next;
                    return si === null && (this.tail = null), oi.item;
                  }
                }
              }, ai.exports = li;
            })
          ),
          /***/
          4239: (
            /***/
            ((ai, li, oi) => {
              var si = oi(7136), di = TypeError;
              ai.exports = function(fi) {
                if (si(fi)) throw new di("Can't call method on " + fi);
                return fi;
              };
            })
          ),
          /***/
          2098: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5951), di = oi(9447), fi = Object.getOwnPropertyDescriptor;
              ai.exports = function(gi) {
                if (!di) return si[gi];
                var mi = fi(si, gi);
                return mi && mi.value;
              };
            })
          ),
          /***/
          485: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5951), di = oi(6024), fi = oi(2250), gi = oi(2832), mi = oi(6794), Ti = oi(3427), vi = oi(4787), xi = si.Function, Si = /MSIE .\./.test(mi) || gi === "BUN" && (function() {
                var Pi = si.Bun.version.split(".");
                return Pi.length < 3 || Pi[0] === "0" && (Pi[1] < 3 || Pi[1] === "3" && Pi[2] === "0");
              })();
              ai.exports = function(Pi, $i) {
                var Oi = $i ? 2 : 1;
                return Si ? function(Di, Mi) {
                  var Oo = vi(arguments.length, 1) > Oi, io = fi(Di) ? Di : xi(Di), xo = Oo ? Ti(arguments, Oi) : [], fo = Oo ? function() {
                    di(io, this, xo);
                  } : io;
                  return $i ? Pi(fo, Mi) : Pi(fo);
                } : Pi;
              };
            })
          ),
          /***/
          7118: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5582), di = oi(9251), fi = oi(6264), gi = oi(9447), mi = fi("species");
              ai.exports = function(Ti) {
                var vi = si(Ti);
                gi && vi && !vi[mi] && di(vi, mi, {
                  configurable: !0,
                  get: function() {
                    return this;
                  }
                });
              };
            })
          ),
          /***/
          4840: (
            /***/
            ((ai, li, oi) => {
              var si = oi(2623), di = oi(4284).f, fi = oi(1626), gi = oi(9724), mi = oi(4878), Ti = oi(6264), vi = Ti("toStringTag");
              ai.exports = function(xi, Si, Pi, $i) {
                var Oi = Pi ? xi : xi && xi.prototype;
                Oi && (gi(Oi, vi) || di(Oi, vi, { configurable: !0, value: Si }), $i && !si && fi(Oi, "toString", mi));
              };
            })
          ),
          /***/
          2522: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5816), di = oi(6499), fi = si("keys");
              ai.exports = function(gi) {
                return fi[gi] || (fi[gi] = di(gi));
              };
            })
          ),
          /***/
          6128: (
            /***/
            ((ai, li, oi) => {
              var si = oi(7376), di = oi(5951), fi = oi(2532), gi = "__core-js_shared__", mi = ai.exports = di[gi] || fi(gi, {});
              (mi.versions || (mi.versions = [])).push({
                version: "3.41.0",
                mode: si ? "pure" : "global",
                copyright: "© 2014-2025 Denis Pushkarev (zloirock.ru)",
                license: "https://github.com/zloirock/core-js/blob/v3.41.0/LICENSE",
                source: "https://github.com/zloirock/core-js"
              });
            })
          ),
          /***/
          5816: (
            /***/
            ((ai, li, oi) => {
              var si = oi(6128);
              ai.exports = function(di, fi) {
                return si[di] || (si[di] = fi || {});
              };
            })
          ),
          /***/
          8450: (
            /***/
            ((ai, li, oi) => {
              var si = oi(6624), di = oi(2235), fi = oi(7136), gi = oi(6264), mi = gi("species");
              ai.exports = function(Ti, vi) {
                var xi = si(Ti).constructor, Si;
                return xi === void 0 || fi(Si = si(xi)[mi]) ? vi : di(Si);
              };
            })
          ),
          /***/
          1470: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1907), di = oi(5482), fi = oi(160), gi = oi(4239), mi = si("".charAt), Ti = si("".charCodeAt), vi = si("".slice), xi = function(Si) {
                return function(Pi, $i) {
                  var Oi = fi(gi(Pi)), Di = di($i), Mi = Oi.length, Oo, io;
                  return Di < 0 || Di >= Mi ? Si ? "" : void 0 : (Oo = Ti(Oi, Di), Oo < 55296 || Oo > 56319 || Di + 1 === Mi || (io = Ti(Oi, Di + 1)) < 56320 || io > 57343 ? Si ? mi(Oi, Di) : Oo : Si ? vi(Oi, Di, Di + 2) : (Oo - 55296 << 10) + (io - 56320) + 65536);
                };
              };
              ai.exports = {
                // `String.prototype.codePointAt` method
                // https://tc39.es/ecma262/#sec-string.prototype.codepointat
                codeAt: xi(!1),
                // `String.prototype.at` method
                // https://github.com/mathiasbynens/String.prototype.at
                charAt: xi(!0)
              };
            })
          ),
          /***/
          9156: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1907), di = 2147483647, fi = 36, gi = 1, mi = 26, Ti = 38, vi = 700, xi = 72, Si = 128, Pi = "-", $i = /[^\0-\u007E]/, Oi = /[.\u3002\uFF0E\uFF61]/g, Di = "Overflow: input needs wider integers to process", Mi = fi - gi, Oo = RangeError, io = si(Oi.exec), xo = Math.floor, fo = String.fromCharCode, _o = si("".charCodeAt), Li = si([].join), Co = si([].push), Ni = si("".replace), Yi = si("".split), Vo = si("".toLowerCase), No = function(ji) {
                for (var Hi = [], zo = 0, Lo = ji.length; zo < Lo; ) {
                  var sa = _o(ji, zo++);
                  if (sa >= 55296 && sa <= 56319 && zo < Lo) {
                    var Ko = _o(ji, zo++);
                    (Ko & 64512) === 56320 ? Co(Hi, ((sa & 1023) << 10) + (Ko & 1023) + 65536) : (Co(Hi, sa), zo--);
                  } else
                    Co(Hi, sa);
                }
                return Hi;
              }, Ui = function(ji) {
                return ji + 22 + 75 * (ji < 26);
              }, jo = function(ji, Hi, zo) {
                var Lo = 0;
                for (ji = zo ? xo(ji / vi) : ji >> 1, ji += xo(ji / Hi); ji > Mi * mi >> 1; )
                  ji = xo(ji / Mi), Lo += fi;
                return xo(Lo + (Mi + 1) * ji / (ji + Ti));
              }, Wi = function(ji) {
                var Hi = [];
                ji = No(ji);
                var zo = ji.length, Lo = Si, sa = 0, Ko = xi, ca, pa;
                for (ca = 0; ca < ji.length; ca++)
                  pa = ji[ca], pa < 128 && Co(Hi, fo(pa));
                var ga = Hi.length, ia = ga;
                for (ga && Co(Hi, Pi); ia < zo; ) {
                  var ra = di;
                  for (ca = 0; ca < ji.length; ca++)
                    pa = ji[ca], pa >= Lo && pa < ra && (ra = pa);
                  var qo = ia + 1;
                  if (ra - Lo > xo((di - sa) / qo))
                    throw new Oo(Di);
                  for (sa += (ra - Lo) * qo, Lo = ra, ca = 0; ca < ji.length; ca++) {
                    if (pa = ji[ca], pa < Lo && ++sa > di)
                      throw new Oo(Di);
                    if (pa === Lo) {
                      for (var xa = sa, $a = fi; ; ) {
                        var ys = $a <= Ko ? gi : $a >= Ko + mi ? mi : $a - Ko;
                        if (xa < ys) break;
                        var Ss = xa - ys, Xa = fi - ys;
                        Co(Hi, fo(Ui(ys + Ss % Xa))), xa = xo(Ss / Xa), $a += fi;
                      }
                      Co(Hi, fo(Ui(xa))), Ko = jo(sa, qo, ia === ga), sa = 0, ia++;
                    }
                  }
                  sa++, Lo++;
                }
                return Li(Hi, "");
              };
              ai.exports = function(ji) {
                var Hi = [], zo = Yi(Ni(Vo(ji), Oi, "."), "."), Lo, sa;
                for (Lo = 0; Lo < zo.length; Lo++)
                  sa = zo[Lo], Co(Hi, io($i, sa) ? "xn--" + Wi(sa) : sa);
                return Li(Hi, ".");
              };
            })
          ),
          /***/
          5819: (
            /***/
            ((ai, li, oi) => {
              var si = oi(6833).PROPER, di = oi(8828), fi = oi(6395), gi = "​᠎";
              ai.exports = function(mi) {
                return di(function() {
                  return !!fi[mi]() || gi[mi]() !== gi || si && fi[mi].name !== mi;
                });
              };
            })
          ),
          /***/
          5993: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1907), di = oi(4239), fi = oi(160), gi = oi(6395), mi = si("".replace), Ti = RegExp("^[" + gi + "]+"), vi = RegExp("(^|[^" + gi + "])[" + gi + "]+$"), xi = function(Si) {
                return function(Pi) {
                  var $i = fi(di(Pi));
                  return Si & 1 && ($i = mi($i, Ti, "")), Si & 2 && ($i = mi($i, vi, "$1")), $i;
                };
              };
              ai.exports = {
                // `String.prototype.{ trimLeft, trimStart }` methods
                // https://tc39.es/ecma262/#sec-string.prototype.trimstart
                start: xi(1),
                // `String.prototype.{ trimRight, trimEnd }` methods
                // https://tc39.es/ecma262/#sec-string.prototype.trimend
                end: xi(2),
                // `String.prototype.trim` method
                // https://tc39.es/ecma262/#sec-string.prototype.trim
                trim: xi(3)
              };
            })
          ),
          /***/
          9846: (
            /***/
            ((ai, li, oi) => {
              var si = oi(798), di = oi(8828), fi = oi(5951), gi = fi.String;
              ai.exports = !!Object.getOwnPropertySymbols && !di(function() {
                var mi = Symbol("symbol detection");
                return !gi(mi) || !(Object(mi) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
                !Symbol.sham && si && si < 41;
              });
            })
          ),
          /***/
          3467: (
            /***/
            ((ai, li, oi) => {
              var si = oi(3930), di = oi(5582), fi = oi(6264), gi = oi(8055);
              ai.exports = function() {
                var mi = di("Symbol"), Ti = mi && mi.prototype, vi = Ti && Ti.valueOf, xi = fi("toPrimitive");
                Ti && !Ti[xi] && gi(Ti, xi, function(Si) {
                  return si(vi, this);
                }, { arity: 1 });
              };
            })
          ),
          /***/
          2595: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5582), di = oi(1907), fi = si("Symbol"), gi = fi.keyFor, mi = di(fi.prototype.valueOf);
              ai.exports = fi.isRegisteredSymbol || function(vi) {
                try {
                  return gi(mi(vi)) !== void 0;
                } catch {
                  return !1;
                }
              };
            })
          ),
          /***/
          9197: (
            /***/
            ((ai, li, oi) => {
              for (var si = oi(5816), di = oi(5582), fi = oi(1907), gi = oi(5594), mi = oi(6264), Ti = di("Symbol"), vi = Ti.isWellKnownSymbol, xi = di("Object", "getOwnPropertyNames"), Si = fi(Ti.prototype.valueOf), Pi = si("wks"), $i = 0, Oi = xi(Ti), Di = Oi.length; $i < Di; $i++)
                try {
                  var Mi = Oi[$i];
                  gi(Ti[Mi]) && mi(Mi);
                } catch {
                }
              ai.exports = function(io) {
                if (vi && vi(io)) return !0;
                try {
                  for (var xo = Si(io), fo = 0, _o = xi(Pi), Li = _o.length; fo < Li; fo++)
                    if (Pi[_o[fo]] == xo) return !0;
                } catch {
                }
                return !1;
              };
            })
          ),
          /***/
          4411: (
            /***/
            ((ai, li, oi) => {
              var si = oi(9846);
              ai.exports = si && !!Symbol.for && !!Symbol.keyFor;
            })
          ),
          /***/
          9472: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5951), di = oi(6024), fi = oi(8311), gi = oi(2250), mi = oi(9724), Ti = oi(8828), vi = oi(2416), xi = oi(3427), Si = oi(9552), Pi = oi(4787), $i = oi(1829), Oi = oi(7586), Di = si.setImmediate, Mi = si.clearImmediate, Oo = si.process, io = si.Dispatch, xo = si.Function, fo = si.MessageChannel, _o = si.String, Li = 0, Co = {}, Ni = "onreadystatechange", Yi, Vo, No, Ui;
              Ti(function() {
                Yi = si.location;
              });
              var jo = function(zo) {
                if (mi(Co, zo)) {
                  var Lo = Co[zo];
                  delete Co[zo], Lo();
                }
              }, Wi = function(zo) {
                return function() {
                  jo(zo);
                };
              }, ji = function(zo) {
                jo(zo.data);
              }, Hi = function(zo) {
                si.postMessage(_o(zo), Yi.protocol + "//" + Yi.host);
              };
              (!Di || !Mi) && (Di = function(Lo) {
                Pi(arguments.length, 1);
                var sa = gi(Lo) ? Lo : xo(Lo), Ko = xi(arguments, 1);
                return Co[++Li] = function() {
                  di(sa, void 0, Ko);
                }, Vo(Li), Li;
              }, Mi = function(Lo) {
                delete Co[Lo];
              }, Oi ? Vo = function(zo) {
                Oo.nextTick(Wi(zo));
              } : io && io.now ? Vo = function(zo) {
                io.now(Wi(zo));
              } : fo && !$i ? (No = new fo(), Ui = No.port2, No.port1.onmessage = ji, Vo = fi(Ui.postMessage, Ui)) : si.addEventListener && gi(si.postMessage) && !si.importScripts && Yi && Yi.protocol !== "file:" && !Ti(Hi) ? (Vo = Hi, si.addEventListener("message", ji, !1)) : Ni in Si("script") ? Vo = function(zo) {
                vi.appendChild(Si("script"))[Ni] = function() {
                  vi.removeChild(this), jo(zo);
                };
              } : Vo = function(zo) {
                setTimeout(Wi(zo), 0);
              }), ai.exports = {
                set: Di,
                clear: Mi
              };
            })
          ),
          /***/
          4849: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5482), di = Math.max, fi = Math.min;
              ai.exports = function(gi, mi) {
                var Ti = si(gi);
                return Ti < 0 ? di(Ti + mi, 0) : fi(Ti, mi);
              };
            })
          ),
          /***/
          7374: (
            /***/
            ((ai, li, oi) => {
              var si = oi(6946), di = oi(4239);
              ai.exports = function(fi) {
                return si(di(fi));
              };
            })
          ),
          /***/
          5482: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1176);
              ai.exports = function(di) {
                var fi = +di;
                return fi !== fi || fi === 0 ? 0 : si(fi);
              };
            })
          ),
          /***/
          3121: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5482), di = Math.min;
              ai.exports = function(fi) {
                var gi = si(fi);
                return gi > 0 ? di(gi, 9007199254740991) : 0;
              };
            })
          ),
          /***/
          9298: (
            /***/
            ((ai, li, oi) => {
              var si = oi(4239), di = Object;
              ai.exports = function(fi) {
                return di(si(fi));
              };
            })
          ),
          /***/
          6028: (
            /***/
            ((ai, li, oi) => {
              var si = oi(3930), di = oi(6285), fi = oi(5594), gi = oi(9367), mi = oi(581), Ti = oi(6264), vi = TypeError, xi = Ti("toPrimitive");
              ai.exports = function(Si, Pi) {
                if (!di(Si) || fi(Si)) return Si;
                var $i = gi(Si, xi), Oi;
                if ($i) {
                  if (Pi === void 0 && (Pi = "default"), Oi = si($i, Si, Pi), !di(Oi) || fi(Oi)) return Oi;
                  throw new vi("Can't convert object to primitive value");
                }
                return Pi === void 0 && (Pi = "number"), mi(Si, Pi);
              };
            })
          ),
          /***/
          470: (
            /***/
            ((ai, li, oi) => {
              var si = oi(6028), di = oi(5594);
              ai.exports = function(fi) {
                var gi = si(fi, "string");
                return di(gi) ? gi : gi + "";
              };
            })
          ),
          /***/
          2623: (
            /***/
            ((ai, li, oi) => {
              var si = oi(6264), di = si("toStringTag"), fi = {};
              fi[di] = "z", ai.exports = String(fi) === "[object z]";
            })
          ),
          /***/
          160: (
            /***/
            ((ai, li, oi) => {
              var si = oi(3948), di = String;
              ai.exports = function(fi) {
                if (si(fi) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
                return di(fi);
              };
            })
          ),
          /***/
          4640: (
            /***/
            ((ai) => {
              var li = String;
              ai.exports = function(oi) {
                try {
                  return li(oi);
                } catch {
                  return "Object";
                }
              };
            })
          ),
          /***/
          6499: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1907), di = 0, fi = Math.random(), gi = si(1 .toString);
              ai.exports = function(mi) {
                return "Symbol(" + (mi === void 0 ? "" : mi) + ")_" + gi(++di + fi, 36);
              };
            })
          ),
          /***/
          4791: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8828), di = oi(6264), fi = oi(9447), gi = oi(7376), mi = di("iterator");
              ai.exports = !si(function() {
                var Ti = new URL("b?a=1&b=2&c=3", "https://a"), vi = Ti.searchParams, xi = new URLSearchParams("a=1&a=2&b=3"), Si = "";
                return Ti.pathname = "c%20d", vi.forEach(function(Pi, $i) {
                  vi.delete("b"), Si += $i + Pi;
                }), xi.delete("a", 2), xi.delete("b", void 0), gi && (!Ti.toJSON || !xi.has("a", 1) || xi.has("a", 2) || !xi.has("a", void 0) || xi.has("b")) || !vi.size && (gi || !fi) || !vi.sort || Ti.href !== "https://a/c%20d?a=1&c=3" || vi.get("c") !== "3" || String(new URLSearchParams("?a=1")) !== "a=1" || !vi[mi] || new URL("https://a@b").username !== "a" || new URLSearchParams(new URLSearchParams("a=b")).get("a") !== "b" || new URL("https://тест").host !== "xn--e1aybc" || new URL("https://a#б").hash !== "#%D0%B1" || Si !== "a1c3" || new URL("https://x", void 0).host !== "x";
              });
            })
          ),
          /***/
          1175: (
            /***/
            ((ai, li, oi) => {
              var si = oi(9846);
              ai.exports = si && !Symbol.sham && typeof Symbol.iterator == "symbol";
            })
          ),
          /***/
          8661: (
            /***/
            ((ai, li, oi) => {
              var si = oi(9447), di = oi(8828);
              ai.exports = si && di(function() {
                return Object.defineProperty(function() {
                }, "prototype", {
                  value: 42,
                  writable: !1
                }).prototype !== 42;
              });
            })
          ),
          /***/
          4787: (
            /***/
            ((ai) => {
              var li = TypeError;
              ai.exports = function(oi, si) {
                if (oi < si) throw new li("Not enough arguments");
                return oi;
              };
            })
          ),
          /***/
          551: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5951), di = oi(2250), fi = si.WeakMap;
              ai.exports = di(fi) && /native code/.test(String(fi));
            })
          ),
          /***/
          366: (
            /***/
            ((ai, li, oi) => {
              var si = oi(2046), di = oi(9724), fi = oi(560), gi = oi(4284).f;
              ai.exports = function(mi) {
                var Ti = si.Symbol || (si.Symbol = {});
                di(Ti, mi) || gi(Ti, mi, {
                  value: fi.f(mi)
                });
              };
            })
          ),
          /***/
          560: (
            /***/
            ((ai, li, oi) => {
              var si = oi(6264);
              li.f = si;
            })
          ),
          /***/
          6264: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5951), di = oi(5816), fi = oi(9724), gi = oi(6499), mi = oi(9846), Ti = oi(1175), vi = si.Symbol, xi = di("wks"), Si = Ti ? vi.for || vi : vi && vi.withoutSetter || gi;
              ai.exports = function(Pi) {
                return fi(xi, Pi) || (xi[Pi] = mi && fi(vi, Pi) ? vi[Pi] : Si("Symbol." + Pi)), xi[Pi];
              };
            })
          ),
          /***/
          6395: (
            /***/
            ((ai) => {
              ai.exports = `	
\v\f\r                　\u2028\u2029\uFEFF`;
            })
          ),
          /***/
          2048: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(8280), fi = oi(5972), gi = oi(9192), mi = oi(9595), Ti = oi(8075), vi = oi(1626), xi = oi(5817), Si = oi(9259), Pi = oi(5884), $i = oi(4823), Oi = oi(2096), Di = oi(6264), Mi = Di("toStringTag"), Oo = Error, io = [].push, xo = function(Li, Co) {
                var Ni = di(fo, this), Yi;
                gi ? Yi = gi(new Oo(), Ni ? fi(this) : fo) : (Yi = Ni ? this : Ti(fo), vi(Yi, Mi, "Error")), Co !== void 0 && vi(Yi, "message", Oi(Co)), Pi(Yi, xo, Yi.stack, 1), arguments.length > 2 && Si(Yi, arguments[2]);
                var Vo = [];
                return $i(Li, io, { that: Vo }), vi(Yi, "errors", Vo), Yi;
              };
              gi ? gi(xo, Oo) : mi(xo, Oo, { name: !0 });
              var fo = xo.prototype = Ti(Oo.prototype, {
                constructor: xi(1, xo),
                message: xi(1, ""),
                name: xi(1, "AggregateError")
              });
              si({ global: !0, constructor: !0, arity: 2 }, {
                AggregateError: xo
              });
            })
          ),
          /***/
          4502: (
            /***/
            ((ai, li, oi) => {
              oi(2048);
            })
          ),
          /***/
          8545: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(8828), fi = oi(1793), gi = oi(6285), mi = oi(9298), Ti = oi(575), vi = oi(8024), xi = oi(5543), Si = oi(6968), Pi = oi(7171), $i = oi(6264), Oi = oi(798), Di = $i("isConcatSpreadable"), Mi = Oi >= 51 || !di(function() {
                var xo = [];
                return xo[Di] = !1, xo.concat()[0] !== xo;
              }), Oo = function(xo) {
                if (!gi(xo)) return !1;
                var fo = xo[Di];
                return fo !== void 0 ? !!fo : fi(xo);
              }, io = !Mi || !Pi("concat");
              si({ target: "Array", proto: !0, arity: 1, forced: io }, {
                // eslint-disable-next-line no-unused-vars -- required for `.length`
                concat: function(fo) {
                  var _o = mi(this), Li = Si(_o, 0), Co = 0, Ni, Yi, Vo, No, Ui;
                  for (Ni = -1, Vo = arguments.length; Ni < Vo; Ni++)
                    if (Ui = Ni === -1 ? _o : arguments[Ni], Oo(Ui))
                      for (No = Ti(Ui), vi(Co + No), Yi = 0; Yi < No; Yi++, Co++) Yi in Ui && xi(Li, Co, Ui[Yi]);
                    else
                      vi(Co + 1), xi(Li, Co++, Ui);
                  return Li.length = Co, Li;
                }
              });
            })
          ),
          /***/
          9295: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(726).filter, fi = oi(7171), gi = fi("filter");
              si({ target: "Array", proto: !0, forced: !gi }, {
                filter: function(Ti) {
                  return di(this, Ti, arguments.length > 1 ? arguments[1] : void 0);
                }
              });
            })
          ),
          /***/
          5650: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(2914);
              si({ target: "Array", proto: !0, forced: [].forEach !== di }, {
                forEach: di
              });
            })
          ),
          /***/
          7277: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(1229), fi = oi(473), gi = !fi(function(mi) {
                Array.from(mi);
              });
              si({ target: "Array", stat: !0, forced: gi }, {
                from: di
              });
            })
          ),
          /***/
          9748: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(4436).includes, fi = oi(8828), gi = oi(2156), mi = fi(function() {
                return !Array(1).includes();
              });
              si({ target: "Array", proto: !0, forced: mi }, {
                includes: function(vi) {
                  return di(this, vi, arguments.length > 1 ? arguments[1] : void 0);
                }
              }), gi("includes");
            })
          ),
          /***/
          6391: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(2361), fi = oi(4436).indexOf, gi = oi(7623), mi = di([].indexOf), Ti = !!mi && 1 / mi([1], 1, -0) < 0, vi = Ti || !gi("indexOf");
              si({ target: "Array", proto: !0, forced: vi }, {
                indexOf: function(Si) {
                  var Pi = arguments.length > 1 ? arguments[1] : void 0;
                  return Ti ? mi(this, Si, Pi) || 0 : fi(this, Si, Pi);
                }
              });
            })
          ),
          /***/
          2425: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(1793);
              si({ target: "Array", stat: !0 }, {
                isArray: di
              });
            })
          ),
          /***/
          9363: (
            /***/
            ((ai, li, oi) => {
              var si = oi(7374), di = oi(2156), fi = oi(3742), gi = oi(4932), mi = oi(4284).f, Ti = oi(183), vi = oi(9550), xi = oi(7376), Si = oi(9447), Pi = "Array Iterator", $i = gi.set, Oi = gi.getterFor(Pi);
              ai.exports = Ti(Array, "Array", function(Mi, Oo) {
                $i(this, {
                  type: Pi,
                  target: si(Mi),
                  // target
                  index: 0,
                  // next index
                  kind: Oo
                  // kind
                });
              }, function() {
                var Mi = Oi(this), Oo = Mi.target, io = Mi.index++;
                if (!Oo || io >= Oo.length)
                  return Mi.target = null, vi(void 0, !0);
                switch (Mi.kind) {
                  case "keys":
                    return vi(io, !1);
                  case "values":
                    return vi(Oo[io], !1);
                }
                return vi([io, Oo[io]], !1);
              }, "values");
              var Di = fi.Arguments = fi.Array;
              if (di("keys"), di("values"), di("entries"), !xi && Si && Di.name !== "values") try {
                mi(Di, "name", { value: "values" });
              } catch {
              }
            })
          ),
          /***/
          6687: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(726).map, fi = oi(7171), gi = fi("map");
              si({ target: "Array", proto: !0, forced: !gi }, {
                map: function(Ti) {
                  return di(this, Ti, arguments.length > 1 ? arguments[1] : void 0);
                }
              });
            })
          ),
          /***/
          5745: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(9298), fi = oi(575), gi = oi(3130), mi = oi(8024), Ti = oi(8828), vi = Ti(function() {
                return [].push.call({ length: 4294967296 }, 1) !== 4294967297;
              }), xi = function() {
                try {
                  Object.defineProperty([], "length", { writable: !1 }).push();
                } catch (Pi) {
                  return Pi instanceof TypeError;
                }
              }, Si = vi || !xi();
              si({ target: "Array", proto: !0, arity: 1, forced: Si }, {
                // eslint-disable-next-line no-unused-vars -- required for `.length`
                push: function($i) {
                  var Oi = di(this), Di = fi(Oi), Mi = arguments.length;
                  mi(Di + Mi);
                  for (var Oo = 0; Oo < Mi; Oo++)
                    Oi[Di] = arguments[Oo], Di++;
                  return gi(Oi, Di), Di;
                }
              });
            })
          ),
          /***/
          6339: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(5043).left, fi = oi(7623), gi = oi(798), mi = oi(7586), Ti = !mi && gi > 79 && gi < 83, vi = Ti || !fi("reduce");
              si({ target: "Array", proto: !0, forced: vi }, {
                reduce: function(Si) {
                  var Pi = arguments.length;
                  return di(this, Si, Pi, Pi > 1 ? arguments[1] : void 0);
                }
              });
            })
          ),
          /***/
          8559: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(1907), fi = oi(1793), gi = di([].reverse), mi = [1, 2];
              si({ target: "Array", proto: !0, forced: String(mi) === String(mi.reverse()) }, {
                reverse: function() {
                  return fi(this) && (this.length = this.length), gi(this);
                }
              });
            })
          ),
          /***/
          2099: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(1793), fi = oi(5468), gi = oi(6285), mi = oi(4849), Ti = oi(575), vi = oi(7374), xi = oi(5543), Si = oi(6264), Pi = oi(7171), $i = oi(3427), Oi = Pi("slice"), Di = Si("species"), Mi = Array, Oo = Math.max;
              si({ target: "Array", proto: !0, forced: !Oi }, {
                slice: function(xo, fo) {
                  var _o = vi(this), Li = Ti(_o), Co = mi(xo, Li), Ni = mi(fo === void 0 ? Li : fo, Li), Yi, Vo, No;
                  if (di(_o) && (Yi = _o.constructor, fi(Yi) && (Yi === Mi || di(Yi.prototype)) ? Yi = void 0 : gi(Yi) && (Yi = Yi[Di], Yi === null && (Yi = void 0)), Yi === Mi || Yi === void 0))
                    return $i(_o, Co, Ni);
                  for (Vo = new (Yi === void 0 ? Mi : Yi)(Oo(Ni - Co, 0)), No = 0; Co < Ni; Co++, No++) Co in _o && xi(Vo, No, _o[Co]);
                  return Vo.length = No, Vo;
                }
              });
            })
          ),
          /***/
          8334: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(9298), fi = oi(4849), gi = oi(5482), mi = oi(575), Ti = oi(3130), vi = oi(8024), xi = oi(6968), Si = oi(5543), Pi = oi(4535), $i = oi(7171), Oi = $i("splice"), Di = Math.max, Mi = Math.min;
              si({ target: "Array", proto: !0, forced: !Oi }, {
                splice: function(io, xo) {
                  var fo = di(this), _o = mi(fo), Li = fi(io, _o), Co = arguments.length, Ni, Yi, Vo, No, Ui, jo;
                  for (Co === 0 ? Ni = Yi = 0 : Co === 1 ? (Ni = 0, Yi = _o - Li) : (Ni = Co - 2, Yi = Mi(Di(gi(xo), 0), _o - Li)), vi(_o + Ni - Yi), Vo = xi(fo, Yi), No = 0; No < Yi; No++)
                    Ui = Li + No, Ui in fo && Si(Vo, No, fo[Ui]);
                  if (Vo.length = Yi, Ni < Yi) {
                    for (No = Li; No < _o - Yi; No++)
                      Ui = No + Yi, jo = No + Ni, Ui in fo ? fo[jo] = fo[Ui] : Pi(fo, jo);
                    for (No = _o; No > _o - Yi + Ni; No--) Pi(fo, No - 1);
                  } else if (Ni > Yi)
                    for (No = _o - Yi; No > Li; No--)
                      Ui = No + Yi - 1, jo = No + Ni - 1, Ui in fo ? fo[jo] = fo[Ui] : Pi(fo, jo);
                  for (No = 0; No < Ni; No++)
                    fo[No + Li] = arguments[No + 2];
                  return Ti(fo, _o - Yi + Ni), Vo;
                }
              });
            })
          ),
          /***/
          5362: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(1907), fi = Date, gi = di(fi.prototype.getTime);
              si({ target: "Date", stat: !0 }, {
                now: function() {
                  return gi(new fi());
                }
              });
            })
          ),
          /***/
          8537: (
            /***/
            (() => {
            })
          ),
          /***/
          9307: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(4673);
              si({ target: "Function", proto: !0, forced: Function.bind !== di }, {
                bind: di
              });
            })
          ),
          /***/
          9721: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(5582), fi = oi(6024), gi = oi(3930), mi = oi(1907), Ti = oi(8828), vi = oi(2250), xi = oi(5594), Si = oi(3427), Pi = oi(6656), $i = oi(9846), Oi = String, Di = di("JSON", "stringify"), Mi = mi(/./.exec), Oo = mi("".charAt), io = mi("".charCodeAt), xo = mi("".replace), fo = mi(1 .toString), _o = /[\uD800-\uDFFF]/g, Li = /^[\uD800-\uDBFF]$/, Co = /^[\uDC00-\uDFFF]$/, Ni = !$i || Ti(function() {
                var Ui = di("Symbol")("stringify detection");
                return Di([Ui]) !== "[null]" || Di({ a: Ui }) !== "{}" || Di(Object(Ui)) !== "{}";
              }), Yi = Ti(function() {
                return Di("\uDF06\uD834") !== '"\\udf06\\ud834"' || Di("\uDEAD") !== '"\\udead"';
              }), Vo = function(Ui, jo) {
                var Wi = Si(arguments), ji = Pi(jo);
                if (!(!vi(ji) && (Ui === void 0 || xi(Ui))))
                  return Wi[1] = function(Hi, zo) {
                    if (vi(ji) && (zo = gi(ji, this, Oi(Hi), zo)), !xi(zo)) return zo;
                  }, fi(Di, null, Wi);
              }, No = function(Ui, jo, Wi) {
                var ji = Oo(Wi, jo - 1), Hi = Oo(Wi, jo + 1);
                return Mi(Li, Ui) && !Mi(Co, Hi) || Mi(Co, Ui) && !Mi(Li, ji) ? "\\u" + fo(io(Ui, 0), 16) : Ui;
              };
              Di && si({ target: "JSON", stat: !0, arity: 3, forced: Ni || Yi }, {
                // eslint-disable-next-line no-unused-vars -- required for `.length`
                stringify: function(jo, Wi, ji) {
                  var Hi = Si(arguments), zo = fi(Ni ? Vo : Di, null, Hi);
                  return Yi && typeof zo == "string" ? xo(zo, _o, No) : zo;
                }
              });
            })
          ),
          /***/
          7024: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5951), di = oi(4840);
              di(si.JSON, "JSON", !0);
            })
          ),
          /***/
          8172: (
            /***/
            (() => {
            })
          ),
          /***/
          5837: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(9447), fi = oi(8075);
              si({ target: "Object", stat: !0, sham: !di }, {
                create: fi
              });
            })
          ),
          /***/
          7810: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(9447), fi = oi(2220).f;
              si({ target: "Object", stat: !0, forced: Object.defineProperties !== fi, sham: !di }, {
                defineProperties: fi
              });
            })
          ),
          /***/
          6750: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(9447), fi = oi(4284).f;
              si({ target: "Object", stat: !0, forced: Object.defineProperty !== fi, sham: !di }, {
                defineProperty: fi
              });
            })
          ),
          /***/
          4729: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(4298).entries;
              si({ target: "Object", stat: !0 }, {
                entries: function(gi) {
                  return di(gi);
                }
              });
            })
          ),
          /***/
          7052: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(8828), fi = oi(7374), gi = oi(3846).f, mi = oi(9447), Ti = !mi || di(function() {
                gi(1);
              });
              si({ target: "Object", stat: !0, forced: Ti, sham: !mi }, {
                getOwnPropertyDescriptor: function(xi, Si) {
                  return gi(fi(xi), Si);
                }
              });
            })
          ),
          /***/
          179: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(9447), fi = oi(1042), gi = oi(7374), mi = oi(3846), Ti = oi(5543);
              si({ target: "Object", stat: !0, sham: !di }, {
                getOwnPropertyDescriptors: function(xi) {
                  for (var Si = gi(xi), Pi = mi.f, $i = fi(Si), Oi = {}, Di = 0, Mi, Oo; $i.length > Di; )
                    Oo = Pi(Si, Mi = $i[Di++]), Oo !== void 0 && Ti(Oi, Mi, Oo);
                  return Oi;
                }
              });
            })
          ),
          /***/
          5264: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(9846), fi = oi(8828), gi = oi(7170), mi = oi(9298), Ti = !di || fi(function() {
                gi.f(1);
              });
              si({ target: "Object", stat: !0, forced: Ti }, {
                getOwnPropertySymbols: function(xi) {
                  var Si = gi.f;
                  return Si ? Si(mi(xi)) : [];
                }
              });
            })
          ),
          /***/
          8966: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(8828), fi = oi(9298), gi = oi(5972), mi = oi(7382), Ti = di(function() {
                gi(1);
              });
              si({ target: "Object", stat: !0, forced: Ti, sham: !mi }, {
                getPrototypeOf: function(xi) {
                  return gi(fi(xi));
                }
              });
            })
          ),
          /***/
          3589: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(9298), fi = oi(2875), gi = oi(8828), mi = gi(function() {
                fi(1);
              });
              si({ target: "Object", stat: !0, forced: mi }, {
                keys: function(vi) {
                  return fi(di(vi));
                }
              });
            })
          ),
          /***/
          1906: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(9192);
              si({ target: "Object", stat: !0 }, {
                setPrototypeOf: di
              });
            })
          ),
          /***/
          3643: (
            /***/
            (() => {
            })
          ),
          /***/
          5395: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(4298).values;
              si({ target: "Object", stat: !0 }, {
                values: function(gi) {
                  return di(gi);
                }
              });
            })
          ),
          /***/
          2193: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(2778);
              si({ global: !0, forced: parseInt !== di }, {
                parseInt: di
              });
            })
          ),
          /***/
          7450: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(3930), fi = oi(2159), gi = oi(6254), mi = oi(4420), Ti = oi(4823), vi = oi(3282);
              si({ target: "Promise", stat: !0, forced: vi }, {
                allSettled: function(Si) {
                  var Pi = this, $i = gi.f(Pi), Oi = $i.resolve, Di = $i.reject, Mi = mi(function() {
                    var Oo = fi(Pi.resolve), io = [], xo = 0, fo = 1;
                    Ti(Si, function(_o) {
                      var Li = xo++, Co = !1;
                      fo++, di(Oo, Pi, _o).then(function(Ni) {
                        Co || (Co = !0, io[Li] = { status: "fulfilled", value: Ni }, --fo || Oi(io));
                      }, function(Ni) {
                        Co || (Co = !0, io[Li] = { status: "rejected", reason: Ni }, --fo || Oi(io));
                      });
                    }), --fo || Oi(io);
                  });
                  return Mi.error && Di(Mi.value), $i.promise;
                }
              });
            })
          ),
          /***/
          6630: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(3930), fi = oi(2159), gi = oi(6254), mi = oi(4420), Ti = oi(4823), vi = oi(3282);
              si({ target: "Promise", stat: !0, forced: vi }, {
                all: function(Si) {
                  var Pi = this, $i = gi.f(Pi), Oi = $i.resolve, Di = $i.reject, Mi = mi(function() {
                    var Oo = fi(Pi.resolve), io = [], xo = 0, fo = 1;
                    Ti(Si, function(_o) {
                      var Li = xo++, Co = !1;
                      fo++, di(Oo, Pi, _o).then(function(Ni) {
                        Co || (Co = !0, io[Li] = Ni, --fo || Oi(io));
                      }, Di);
                    }), --fo || Oi(io);
                  });
                  return Mi.error && Di(Mi.value), $i.promise;
                }
              });
            })
          ),
          /***/
          6415: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(3930), fi = oi(2159), gi = oi(5582), mi = oi(6254), Ti = oi(4420), vi = oi(4823), xi = oi(3282), Si = "No one promise resolved";
              si({ target: "Promise", stat: !0, forced: xi }, {
                any: function($i) {
                  var Oi = this, Di = gi("AggregateError"), Mi = mi.f(Oi), Oo = Mi.resolve, io = Mi.reject, xo = Ti(function() {
                    var fo = fi(Oi.resolve), _o = [], Li = 0, Co = 1, Ni = !1;
                    vi($i, function(Yi) {
                      var Vo = Li++, No = !1;
                      Co++, di(fo, Oi, Yi).then(function(Ui) {
                        No || Ni || (Ni = !0, Oo(Ui));
                      }, function(Ui) {
                        No || Ni || (No = !0, _o[Vo] = Ui, --Co || io(new Di(_o, Si)));
                      });
                    }), --Co || io(new Di(_o, Si));
                  });
                  return xo.error && io(xo.value), Mi.promise;
                }
              });
            })
          ),
          /***/
          1866: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(7376), fi = oi(1759).CONSTRUCTOR, gi = oi(5463), mi = oi(5582), Ti = oi(2250), vi = oi(8055), xi = gi && gi.prototype;
              if (si({ target: "Promise", proto: !0, forced: fi, real: !0 }, {
                catch: function(Pi) {
                  return this.then(void 0, Pi);
                }
              }), !di && Ti(gi)) {
                var Si = mi("Promise").prototype.catch;
                xi.catch !== Si && vi(xi, "catch", Si, { unsafe: !0 });
              }
            })
          ),
          /***/
          3825: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(7376), fi = oi(7586), gi = oi(5951), mi = oi(3930), Ti = oi(8055), vi = oi(9192), xi = oi(4840), Si = oi(7118), Pi = oi(2159), $i = oi(2250), Oi = oi(6285), Di = oi(9596), Mi = oi(8450), Oo = oi(9472).set, io = oi(2292), xo = oi(3904), fo = oi(4420), _o = oi(9245), Li = oi(4932), Co = oi(5463), Ni = oi(1759), Yi = oi(6254), Vo = "Promise", No = Ni.CONSTRUCTOR, Ui = Ni.REJECTION_EVENT, jo = Ni.SUBCLASSING, Wi = Li.getterFor(Vo), ji = Li.set, Hi = Co && Co.prototype, zo = Co, Lo = Hi, sa = gi.TypeError, Ko = gi.document, ca = gi.process, pa = Yi.f, ga = pa, ia = !!(Ko && Ko.createEvent && gi.dispatchEvent), ra = "unhandledrejection", qo = "rejectionhandled", xa = 0, $a = 1, ys = 2, Ss = 1, Xa = 2, Es, Rs, La, Ja, ja = function(Vs) {
                var es;
                return Oi(Vs) && $i(es = Vs.then) ? es : !1;
              }, Ta = function(Vs, es) {
                var Is = es.value, fl = es.state === $a, sl = fl ? Vs.ok : Vs.fail, Il = Vs.resolve, Vl = Vs.reject, Bl = Vs.domain, ql, xl, Ul;
                try {
                  sl ? (fl || (es.rejection === Xa && _s(es), es.rejection = Ss), sl === !0 ? ql = Is : (Bl && Bl.enter(), ql = sl(Is), Bl && (Bl.exit(), Ul = !0)), ql === Vs.promise ? Vl(new sa("Promise-chain cycle")) : (xl = ja(ql)) ? mi(xl, ql, Il, Vl) : Il(ql)) : Vl(Is);
                } catch (Xl) {
                  Bl && !Ul && Bl.exit(), Vl(Xl);
                }
              }, rs = function(Vs, es) {
                Vs.notified || (Vs.notified = !0, io(function() {
                  for (var Is = Vs.reactions, fl; fl = Is.get(); )
                    Ta(fl, Vs);
                  Vs.notified = !1, es && !Vs.rejection && Cs(Vs);
                }));
              }, Qa = function(Vs, es, Is) {
                var fl, sl;
                ia ? (fl = Ko.createEvent("Event"), fl.promise = es, fl.reason = Is, fl.initEvent(Vs, !1, !0), gi.dispatchEvent(fl)) : fl = { promise: es, reason: Is }, !Ui && (sl = gi["on" + Vs]) ? sl(fl) : Vs === ra && xo("Unhandled promise rejection", Is);
              }, Cs = function(Vs) {
                mi(Oo, gi, function() {
                  var es = Vs.facade, Is = Vs.value, fl = _a(Vs), sl;
                  if (fl && (sl = fo(function() {
                    fi ? ca.emit("unhandledRejection", Is, es) : Qa(ra, es, Is);
                  }), Vs.rejection = fi || _a(Vs) ? Xa : Ss, sl.error))
                    throw sl.value;
                });
              }, _a = function(Vs) {
                return Vs.rejection !== Ss && !Vs.parent;
              }, _s = function(Vs) {
                mi(Oo, gi, function() {
                  var es = Vs.facade;
                  fi ? ca.emit("rejectionHandled", es) : Qa(qo, es, Vs.value);
                });
              }, el = function(Vs, es, Is) {
                return function(fl) {
                  Vs(es, fl, Is);
                };
              }, Ps = function(Vs, es, Is) {
                Vs.done || (Vs.done = !0, Is && (Vs = Is), Vs.value = es, Vs.state = ys, rs(Vs, !0));
              }, nl = function(Vs, es, Is) {
                if (!Vs.done) {
                  Vs.done = !0, Is && (Vs = Is);
                  try {
                    if (Vs.facade === es) throw new sa("Promise can't be resolved itself");
                    var fl = ja(es);
                    fl ? io(function() {
                      var sl = { done: !1 };
                      try {
                        mi(
                          fl,
                          es,
                          el(nl, sl, Vs),
                          el(Ps, sl, Vs)
                        );
                      } catch (Il) {
                        Ps(sl, Il, Vs);
                      }
                    }) : (Vs.value = es, Vs.state = $a, rs(Vs, !1));
                  } catch (sl) {
                    Ps({ done: !1 }, sl, Vs);
                  }
                }
              };
              if (No && (zo = function(es) {
                Di(this, Lo), Pi(es), mi(Es, this);
                var Is = Wi(this);
                try {
                  es(el(nl, Is), el(Ps, Is));
                } catch (fl) {
                  Ps(Is, fl);
                }
              }, Lo = zo.prototype, Es = function(es) {
                ji(this, {
                  type: Vo,
                  done: !1,
                  notified: !1,
                  parent: !1,
                  reactions: new _o(),
                  rejection: !1,
                  state: xa,
                  value: null
                });
              }, Es.prototype = Ti(Lo, "then", function(es, Is) {
                var fl = Wi(this), sl = pa(Mi(this, zo));
                return fl.parent = !0, sl.ok = $i(es) ? es : !0, sl.fail = $i(Is) && Is, sl.domain = fi ? ca.domain : void 0, fl.state === xa ? fl.reactions.add(sl) : io(function() {
                  Ta(sl, fl);
                }), sl.promise;
              }), Rs = function() {
                var Vs = new Es(), es = Wi(Vs);
                this.promise = Vs, this.resolve = el(nl, es), this.reject = el(Ps, es);
              }, Yi.f = pa = function(Vs) {
                return Vs === zo || Vs === La ? new Rs(Vs) : ga(Vs);
              }, !di && $i(Co) && Hi !== Object.prototype)) {
                Ja = Hi.then, jo || Ti(Hi, "then", function(es, Is) {
                  var fl = this;
                  return new zo(function(sl, Il) {
                    mi(Ja, fl, sl, Il);
                  }).then(es, Is);
                }, { unsafe: !0 });
                try {
                  delete Hi.constructor;
                } catch {
                }
                vi && vi(Hi, Lo);
              }
              si({ global: !0, constructor: !0, wrap: !0, forced: No }, {
                Promise: zo
              }), xi(zo, Vo, !1, !0), Si(Vo);
            })
          ),
          /***/
          7714: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(7376), fi = oi(5463), gi = oi(8828), mi = oi(5582), Ti = oi(2250), vi = oi(8450), xi = oi(3569), Si = oi(8055), Pi = fi && fi.prototype, $i = !!fi && gi(function() {
                Pi.finally.call({ then: function() {
                } }, function() {
                });
              });
              if (si({ target: "Promise", proto: !0, real: !0, forced: $i }, {
                finally: function(Di) {
                  var Mi = vi(this, mi("Promise")), Oo = Ti(Di);
                  return this.then(
                    Oo ? function(io) {
                      return xi(Mi, Di()).then(function() {
                        return io;
                      });
                    } : Di,
                    Oo ? function(io) {
                      return xi(Mi, Di()).then(function() {
                        throw io;
                      });
                    } : Di
                  );
                }
              }), !di && Ti(fi)) {
                var Oi = mi("Promise").prototype.finally;
                Pi.finally !== Oi && Si(Pi, "finally", Oi, { unsafe: !0 });
              }
            })
          ),
          /***/
          5931: (
            /***/
            ((ai, li, oi) => {
              oi(3825), oi(6630), oi(1866), oi(2736), oi(7286), oi(6761);
            })
          ),
          /***/
          2736: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(3930), fi = oi(2159), gi = oi(6254), mi = oi(4420), Ti = oi(4823), vi = oi(3282);
              si({ target: "Promise", stat: !0, forced: vi }, {
                race: function(Si) {
                  var Pi = this, $i = gi.f(Pi), Oi = $i.reject, Di = mi(function() {
                    var Mi = fi(Pi.resolve);
                    Ti(Si, function(Oo) {
                      di(Mi, Pi, Oo).then($i.resolve, Oi);
                    });
                  });
                  return Di.error && Oi(Di.value), $i.promise;
                }
              });
            })
          ),
          /***/
          7286: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(6254), fi = oi(1759).CONSTRUCTOR;
              si({ target: "Promise", stat: !0, forced: fi }, {
                reject: function(mi) {
                  var Ti = di.f(this), vi = Ti.reject;
                  return vi(mi), Ti.promise;
                }
              });
            })
          ),
          /***/
          6761: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(5582), fi = oi(7376), gi = oi(5463), mi = oi(1759).CONSTRUCTOR, Ti = oi(3569), vi = di("Promise"), xi = fi && !mi;
              si({ target: "Promise", stat: !0, forced: fi || mi }, {
                resolve: function(Pi) {
                  return Ti(xi && this === vi ? gi : this, Pi);
                }
              });
            })
          ),
          /***/
          7380: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(5951), fi = oi(6024), gi = oi(3427), mi = oi(6254), Ti = oi(2159), vi = oi(4420), xi = di.Promise, Si = !1, Pi = !xi || !xi.try || vi(function() {
                xi.try(function($i) {
                  Si = $i === 8;
                }, 8);
              }).error || !Si;
              si({ target: "Promise", stat: !0, forced: Pi }, {
                try: function($i) {
                  var Oi = arguments.length > 1 ? gi(arguments, 1) : [], Di = mi.f(this), Mi = vi(function() {
                    return fi(Ti($i), void 0, Oi);
                  });
                  return (Mi.error ? Di.reject : Di.resolve)(Mi.value), Di.promise;
                }
              });
            })
          ),
          /***/
          5823: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(6254);
              si({ target: "Promise", stat: !0 }, {
                withResolvers: function() {
                  var gi = di.f(this);
                  return {
                    promise: gi.promise,
                    resolve: gi.resolve,
                    reject: gi.reject
                  };
                }
              });
            })
          ),
          /***/
          1220: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(5582), fi = oi(6024), gi = oi(4673), mi = oi(2235), Ti = oi(6624), vi = oi(6285), xi = oi(8075), Si = oi(8828), Pi = di("Reflect", "construct"), $i = Object.prototype, Oi = [].push, Di = Si(function() {
                function io() {
                }
                return !(Pi(function() {
                }, [], io) instanceof io);
              }), Mi = !Si(function() {
                Pi(function() {
                });
              }), Oo = Di || Mi;
              si({ target: "Reflect", stat: !0, forced: Oo, sham: Oo }, {
                construct: function(xo, fo) {
                  mi(xo), Ti(fo);
                  var _o = arguments.length < 3 ? xo : mi(arguments[2]);
                  if (Mi && !Di) return Pi(xo, fo, _o);
                  if (xo === _o) {
                    switch (fo.length) {
                      case 0:
                        return new xo();
                      case 1:
                        return new xo(fo[0]);
                      case 2:
                        return new xo(fo[0], fo[1]);
                      case 3:
                        return new xo(fo[0], fo[1], fo[2]);
                      case 4:
                        return new xo(fo[0], fo[1], fo[2], fo[3]);
                    }
                    var Li = [null];
                    return fi(Oi, Li, fo), new (fi(gi, xo, Li))();
                  }
                  var Co = _o.prototype, Ni = xi(vi(Co) ? Co : $i), Yi = fi(xo, Ni, fo);
                  return vi(Yi) ? Yi : Ni;
                }
              });
            })
          ),
          /***/
          3357: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(3930), fi = oi(6285), gi = oi(6624), mi = oi(218), Ti = oi(3846), vi = oi(5972);
              function xi(Si, Pi) {
                var $i = arguments.length < 3 ? Si : arguments[2], Oi, Di;
                if (gi(Si) === $i) return Si[Pi];
                if (Oi = Ti.f(Si, Pi), Oi) return mi(Oi) ? Oi.value : Oi.get === void 0 ? void 0 : di(Oi.get, $i);
                if (fi(Di = vi(Si))) return xi(Di, Pi, $i);
              }
              si({ target: "Reflect", stat: !0 }, {
                get: xi
              });
            })
          ),
          /***/
          5205: (
            /***/
            (() => {
            })
          ),
          /***/
          1074: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(1907), fi = oi(4849), gi = RangeError, mi = String.fromCharCode, Ti = String.fromCodePoint, vi = di([].join), xi = !!Ti && Ti.length !== 1;
              si({ target: "String", stat: !0, arity: 1, forced: xi }, {
                // eslint-disable-next-line no-unused-vars -- required for `.length`
                fromCodePoint: function(Pi) {
                  for (var $i = [], Oi = arguments.length, Di = 0, Mi; Oi > Di; ) {
                    if (Mi = +arguments[Di++], fi(Mi, 1114111) !== Mi) throw new gi(Mi + " is not a valid code point");
                    $i[Di] = Mi < 65536 ? mi(Mi) : mi(((Mi -= 65536) >> 10) + 55296, Mi % 1024 + 56320);
                  }
                  return vi($i, "");
                }
              });
            })
          ),
          /***/
          9770: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(1907), fi = oi(2074), gi = oi(4239), mi = oi(160), Ti = oi(5735), vi = di("".indexOf);
              si({ target: "String", proto: !0, forced: !Ti("includes") }, {
                includes: function(Si) {
                  return !!~vi(
                    mi(gi(this)),
                    mi(fi(Si)),
                    arguments.length > 1 ? arguments[1] : void 0
                  );
                }
              });
            })
          ),
          /***/
          7057: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1470).charAt, di = oi(160), fi = oi(4932), gi = oi(183), mi = oi(9550), Ti = "String Iterator", vi = fi.set, xi = fi.getterFor(Ti);
              gi(String, "String", function(Si) {
                vi(this, {
                  type: Ti,
                  string: di(Si),
                  index: 0
                });
              }, function() {
                var Pi = xi(this), $i = Pi.string, Oi = Pi.index, Di;
                return Oi >= $i.length ? mi(void 0, !0) : (Di = si($i, Oi), Pi.index += Di.length, mi(Di, !1));
              });
            })
          ),
          /***/
          727: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(5993).trim, fi = oi(5819);
              si({ target: "String", proto: !0, forced: fi("trim") }, {
                trim: function() {
                  return di(this);
                }
              });
            })
          ),
          /***/
          3997: (
            /***/
            ((ai, li, oi) => {
              var si = oi(366);
              si("asyncIterator");
            })
          ),
          /***/
          3674: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(5951), fi = oi(3930), gi = oi(1907), mi = oi(7376), Ti = oi(9447), vi = oi(9846), xi = oi(8828), Si = oi(9724), Pi = oi(8280), $i = oi(6624), Oi = oi(7374), Di = oi(470), Mi = oi(160), Oo = oi(5817), io = oi(8075), xo = oi(2875), fo = oi(4443), _o = oi(5407), Li = oi(7170), Co = oi(3846), Ni = oi(4284), Yi = oi(2220), Vo = oi(193), No = oi(8055), Ui = oi(9251), jo = oi(5816), Wi = oi(2522), ji = oi(8530), Hi = oi(6499), zo = oi(6264), Lo = oi(560), sa = oi(366), Ko = oi(3467), ca = oi(4840), pa = oi(4932), ga = oi(726).forEach, ia = Wi("hidden"), ra = "Symbol", qo = "prototype", xa = pa.set, $a = pa.getterFor(ra), ys = Object[qo], Ss = di.Symbol, Xa = Ss && Ss[qo], Es = di.RangeError, Rs = di.TypeError, La = di.QObject, Ja = Co.f, ja = Ni.f, Ta = _o.f, rs = Vo.f, Qa = gi([].push), Cs = jo("symbols"), _a = jo("op-symbols"), _s = jo("wks"), el = !La || !La[qo] || !La[qo].findChild, Ps = function(ql, xl, Ul) {
                var Xl = Ja(ys, xl);
                Xl && delete ys[xl], ja(ql, xl, Ul), Xl && ql !== ys && ja(ys, xl, Xl);
              }, nl = Ti && xi(function() {
                return io(ja({}, "a", {
                  get: function() {
                    return ja(this, "a", { value: 7 }).a;
                  }
                })).a !== 7;
              }) ? Ps : ja, Vs = function(ql, xl) {
                var Ul = Cs[ql] = io(Xa);
                return xa(Ul, {
                  type: ra,
                  tag: ql,
                  description: xl
                }), Ti || (Ul.description = xl), Ul;
              }, es = function(xl, Ul, Xl) {
                xl === ys && es(_a, Ul, Xl), $i(xl);
                var hu = Di(Ul);
                return $i(Xl), Si(Cs, hu) ? (Xl.enumerable ? (Si(xl, ia) && xl[ia][hu] && (xl[ia][hu] = !1), Xl = io(Xl, { enumerable: Oo(0, !1) })) : (Si(xl, ia) || ja(xl, ia, Oo(1, io(null))), xl[ia][hu] = !0), nl(xl, hu, Xl)) : ja(xl, hu, Xl);
              }, Is = function(xl, Ul) {
                $i(xl);
                var Xl = Oi(Ul), hu = xo(Xl).concat(Bl(Xl));
                return ga(hu, function(Tu) {
                  (!Ti || fi(sl, Xl, Tu)) && es(xl, Tu, Xl[Tu]);
                }), xl;
              }, fl = function(xl, Ul) {
                return Ul === void 0 ? io(xl) : Is(io(xl), Ul);
              }, sl = function(xl) {
                var Ul = Di(xl), Xl = fi(rs, this, Ul);
                return this === ys && Si(Cs, Ul) && !Si(_a, Ul) ? !1 : Xl || !Si(this, Ul) || !Si(Cs, Ul) || Si(this, ia) && this[ia][Ul] ? Xl : !0;
              }, Il = function(xl, Ul) {
                var Xl = Oi(xl), hu = Di(Ul);
                if (!(Xl === ys && Si(Cs, hu) && !Si(_a, hu))) {
                  var Tu = Ja(Xl, hu);
                  return Tu && Si(Cs, hu) && !(Si(Xl, ia) && Xl[ia][hu]) && (Tu.enumerable = !0), Tu;
                }
              }, Vl = function(xl) {
                var Ul = Ta(Oi(xl)), Xl = [];
                return ga(Ul, function(hu) {
                  !Si(Cs, hu) && !Si(ji, hu) && Qa(Xl, hu);
                }), Xl;
              }, Bl = function(ql) {
                var xl = ql === ys, Ul = Ta(xl ? _a : Oi(ql)), Xl = [];
                return ga(Ul, function(hu) {
                  Si(Cs, hu) && (!xl || Si(ys, hu)) && Qa(Xl, Cs[hu]);
                }), Xl;
              };
              vi || (Ss = function() {
                if (Pi(Xa, this)) throw new Rs("Symbol is not a constructor");
                var xl = !arguments.length || arguments[0] === void 0 ? void 0 : Mi(arguments[0]), Ul = Hi(xl), Xl = function(hu) {
                  var Tu = this === void 0 ? di : this;
                  Tu === ys && fi(Xl, _a, hu), Si(Tu, ia) && Si(Tu[ia], Ul) && (Tu[ia][Ul] = !1);
                  var Ku = Oo(1, hu);
                  try {
                    nl(Tu, Ul, Ku);
                  } catch (Wl) {
                    if (!(Wl instanceof Es)) throw Wl;
                    Ps(Tu, Ul, Ku);
                  }
                };
                return Ti && el && nl(ys, Ul, { configurable: !0, set: Xl }), Vs(Ul, xl);
              }, Xa = Ss[qo], No(Xa, "toString", function() {
                return $a(this).tag;
              }), No(Ss, "withoutSetter", function(ql) {
                return Vs(Hi(ql), ql);
              }), Vo.f = sl, Ni.f = es, Yi.f = Is, Co.f = Il, fo.f = _o.f = Vl, Li.f = Bl, Lo.f = function(ql) {
                return Vs(zo(ql), ql);
              }, Ti && (Ui(Xa, "description", {
                configurable: !0,
                get: function() {
                  return $a(this).description;
                }
              }), mi || No(ys, "propertyIsEnumerable", sl, { unsafe: !0 }))), si({ global: !0, constructor: !0, wrap: !0, forced: !vi, sham: !vi }, {
                Symbol: Ss
              }), ga(xo(_s), function(ql) {
                sa(ql);
              }), si({ target: ra, stat: !0, forced: !vi }, {
                useSetter: function() {
                  el = !0;
                },
                useSimple: function() {
                  el = !1;
                }
              }), si({ target: "Object", stat: !0, forced: !vi, sham: !Ti }, {
                // `Object.create` method
                // https://tc39.es/ecma262/#sec-object.create
                create: fl,
                // `Object.defineProperty` method
                // https://tc39.es/ecma262/#sec-object.defineproperty
                defineProperty: es,
                // `Object.defineProperties` method
                // https://tc39.es/ecma262/#sec-object.defineproperties
                defineProperties: Is,
                // `Object.getOwnPropertyDescriptor` method
                // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
                getOwnPropertyDescriptor: Il
              }), si({ target: "Object", stat: !0, forced: !vi }, {
                // `Object.getOwnPropertyNames` method
                // https://tc39.es/ecma262/#sec-object.getownpropertynames
                getOwnPropertyNames: Vl
              }), Ko(), ca(Ss, ra), ji[ia] = !0;
            })
          ),
          /***/
          5084: (
            /***/
            (() => {
            })
          ),
          /***/
          3313: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(5582), fi = oi(9724), gi = oi(160), mi = oi(5816), Ti = oi(4411), vi = mi("string-to-symbol-registry"), xi = mi("symbol-to-string-registry");
              si({ target: "Symbol", stat: !0, forced: !Ti }, {
                for: function(Si) {
                  var Pi = gi(Si);
                  if (fi(vi, Pi)) return vi[Pi];
                  var $i = di("Symbol")(Pi);
                  return vi[Pi] = $i, xi[$i] = Pi, $i;
                }
              });
            })
          ),
          /***/
          2596: (
            /***/
            ((ai, li, oi) => {
              var si = oi(366);
              si("hasInstance");
            })
          ),
          /***/
          5721: (
            /***/
            ((ai, li, oi) => {
              var si = oi(366);
              si("isConcatSpreadable");
            })
          ),
          /***/
          4954: (
            /***/
            ((ai, li, oi) => {
              var si = oi(366);
              si("iterator");
            })
          ),
          /***/
          4452: (
            /***/
            ((ai, li, oi) => {
              oi(3674), oi(3313), oi(751), oi(9721), oi(5264);
            })
          ),
          /***/
          751: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(9724), fi = oi(5594), gi = oi(4640), mi = oi(5816), Ti = oi(4411), vi = mi("symbol-to-string-registry");
              si({ target: "Symbol", stat: !0, forced: !Ti }, {
                keyFor: function(Si) {
                  if (!fi(Si)) throw new TypeError(gi(Si) + " is not a symbol");
                  if (di(vi, Si)) return vi[Si];
                }
              });
            })
          ),
          /***/
          3377: (
            /***/
            ((ai, li, oi) => {
              var si = oi(366);
              si("matchAll");
            })
          ),
          /***/
          4123: (
            /***/
            ((ai, li, oi) => {
              var si = oi(366);
              si("match");
            })
          ),
          /***/
          2230: (
            /***/
            ((ai, li, oi) => {
              var si = oi(366);
              si("replace");
            })
          ),
          /***/
          5344: (
            /***/
            ((ai, li, oi) => {
              var si = oi(366);
              si("search");
            })
          ),
          /***/
          1660: (
            /***/
            ((ai, li, oi) => {
              var si = oi(366);
              si("species");
            })
          ),
          /***/
          4610: (
            /***/
            ((ai, li, oi) => {
              var si = oi(366);
              si("split");
            })
          ),
          /***/
          3669: (
            /***/
            ((ai, li, oi) => {
              var si = oi(366), di = oi(3467);
              si("toPrimitive"), di();
            })
          ),
          /***/
          4810: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5582), di = oi(366), fi = oi(4840);
              di("toStringTag"), fi(si("Symbol"), "Symbol");
            })
          ),
          /***/
          3325: (
            /***/
            ((ai, li, oi) => {
              var si = oi(366);
              si("unscopables");
            })
          ),
          /***/
          7249: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5681), di = oi(5951), fi = oi(1907), gi = oi(2802), mi = oi(1548), Ti = oi(7081), vi = oi(1182), xi = oi(6285), Si = oi(4932).enforce, Pi = oi(8828), $i = oi(551), Oi = Object, Di = Array.isArray, Mi = Oi.isExtensible, Oo = Oi.isFrozen, io = Oi.isSealed, xo = Oi.freeze, fo = Oi.seal, _o = !di.ActiveXObject && "ActiveXObject" in di, Li, Co = function(ji) {
                return function() {
                  return ji(this, arguments.length ? arguments[0] : void 0);
                };
              }, Ni = Ti("WeakMap", Co, vi), Yi = Ni.prototype, Vo = fi(Yi.set), No = function() {
                return si && Pi(function() {
                  var ji = xo([]);
                  return Vo(new Ni(), ji, 1), !Oo(ji);
                });
              };
              if ($i) if (_o) {
                Li = vi.getConstructor(Co, "WeakMap", !0), mi.enable();
                var Ui = fi(Yi.delete), jo = fi(Yi.has), Wi = fi(Yi.get);
                gi(Yi, {
                  delete: function(ji) {
                    if (xi(ji) && !Mi(ji)) {
                      var Hi = Si(this);
                      return Hi.frozen || (Hi.frozen = new Li()), Ui(this, ji) || Hi.frozen.delete(ji);
                    }
                    return Ui(this, ji);
                  },
                  has: function(Hi) {
                    if (xi(Hi) && !Mi(Hi)) {
                      var zo = Si(this);
                      return zo.frozen || (zo.frozen = new Li()), jo(this, Hi) || zo.frozen.has(Hi);
                    }
                    return jo(this, Hi);
                  },
                  get: function(Hi) {
                    if (xi(Hi) && !Mi(Hi)) {
                      var zo = Si(this);
                      return zo.frozen || (zo.frozen = new Li()), jo(this, Hi) ? Wi(this, Hi) : zo.frozen.get(Hi);
                    }
                    return Wi(this, Hi);
                  },
                  set: function(Hi, zo) {
                    if (xi(Hi) && !Mi(Hi)) {
                      var Lo = Si(this);
                      Lo.frozen || (Lo.frozen = new Li()), jo(this, Hi) ? Vo(this, Hi, zo) : Lo.frozen.set(Hi, zo);
                    } else Vo(this, Hi, zo);
                    return this;
                  }
                });
              } else No() && gi(Yi, {
                set: function(Hi, zo) {
                  var Lo;
                  return Di(Hi) && (Oo(Hi) ? Lo = xo : io(Hi) && (Lo = fo)), Vo(this, Hi, zo), Lo && Lo(Hi), this;
                }
              });
            })
          ),
          /***/
          6571: (
            /***/
            ((ai, li, oi) => {
              oi(7249);
            })
          ),
          /***/
          7575: (
            /***/
            ((ai, li, oi) => {
              var si = oi(7081), di = oi(1182);
              si("WeakSet", function(fi) {
                return function() {
                  return fi(this, arguments.length ? arguments[0] : void 0);
                };
              }, di);
            })
          ),
          /***/
          741: (
            /***/
            ((ai, li, oi) => {
              oi(7575);
            })
          ),
          /***/
          1599: (
            /***/
            ((ai, li, oi) => {
              oi(4502);
            })
          ),
          /***/
          768: (
            /***/
            ((ai, li, oi) => {
              var si = oi(6264), di = oi(4284).f, fi = si("metadata"), gi = Function.prototype;
              gi[fi] === void 0 && di(gi, fi, {
                value: null
              });
            })
          ),
          /***/
          7939: (
            /***/
            ((ai, li, oi) => {
              oi(7450);
            })
          ),
          /***/
          4362: (
            /***/
            ((ai, li, oi) => {
              oi(6415);
            })
          ),
          /***/
          7637: (
            /***/
            ((ai, li, oi) => {
              oi(7380);
            })
          ),
          /***/
          3568: (
            /***/
            ((ai, li, oi) => {
              oi(5823);
            })
          ),
          /***/
          8549: (
            /***/
            ((ai, li, oi) => {
              var si = oi(366);
              si("asyncDispose");
            })
          ),
          /***/
          1697: (
            /***/
            ((ai, li, oi) => {
              var si = oi(366);
              si("customMatcher");
            })
          ),
          /***/
          7152: (
            /***/
            ((ai, li, oi) => {
              var si = oi(366);
              si("dispose");
            })
          ),
          /***/
          3939: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(2595);
              si({ target: "Symbol", stat: !0 }, {
                isRegisteredSymbol: di
              });
            })
          ),
          /***/
          3422: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(2595);
              si({ target: "Symbol", stat: !0, name: "isRegisteredSymbol" }, {
                isRegistered: di
              });
            })
          ),
          /***/
          1785: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(9197);
              si({ target: "Symbol", stat: !0, forced: !0 }, {
                isWellKnownSymbol: di
              });
            })
          ),
          /***/
          36: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(9197);
              si({ target: "Symbol", stat: !0, name: "isWellKnownSymbol", forced: !0 }, {
                isWellKnown: di
              });
            })
          ),
          /***/
          8703: (
            /***/
            ((ai, li, oi) => {
              var si = oi(366);
              si("matcher");
            })
          ),
          /***/
          6878: (
            /***/
            ((ai, li, oi) => {
              var si = oi(366);
              si("metadataKey");
            })
          ),
          /***/
          1372: (
            /***/
            ((ai, li, oi) => {
              var si = oi(366);
              si("metadata");
            })
          ),
          /***/
          4664: (
            /***/
            ((ai, li, oi) => {
              var si = oi(366);
              si("observable");
            })
          ),
          /***/
          9671: (
            /***/
            ((ai, li, oi) => {
              var si = oi(366);
              si("patternMatch");
            })
          ),
          /***/
          359: (
            /***/
            ((ai, li, oi) => {
              var si = oi(366);
              si("replaceAll");
            })
          ),
          /***/
          237: (
            /***/
            (() => {
            })
          ),
          /***/
          2560: (
            /***/
            ((ai, li, oi) => {
              oi(9363);
              var si = oi(9287), di = oi(5951), fi = oi(4840), gi = oi(3742);
              for (var mi in si)
                fi(di[mi], mi), gi[mi] = gi.Array;
            })
          ),
          /***/
          1978: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(5951), fi = oi(485), gi = fi(di.setInterval, !0);
              si({ global: !0, bind: !0, forced: di.setInterval !== gi }, {
                setInterval: gi
              });
            })
          ),
          /***/
          6496: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(5951), fi = oi(485), gi = fi(di.setTimeout, !0);
              si({ global: !0, bind: !0, forced: di.setTimeout !== gi }, {
                setTimeout: gi
              });
            })
          ),
          /***/
          3342: (
            /***/
            ((ai, li, oi) => {
              oi(1978), oi(6496);
            })
          ),
          /***/
          7105: (
            /***/
            ((ai, li, oi) => {
              oi(9363), oi(1074);
              var si = oi(1091), di = oi(5951), fi = oi(2098), gi = oi(5582), mi = oi(3930), Ti = oi(1907), vi = oi(9447), xi = oi(4791), Si = oi(8055), Pi = oi(9251), $i = oi(2802), Oi = oi(4840), Di = oi(7181), Mi = oi(4932), Oo = oi(9596), io = oi(2250), xo = oi(9724), fo = oi(8311), _o = oi(3948), Li = oi(6624), Co = oi(6285), Ni = oi(160), Yi = oi(8075), Vo = oi(5817), No = oi(300), Ui = oi(3448), jo = oi(9550), Wi = oi(4787), ji = oi(6264), Hi = oi(4321), zo = ji("iterator"), Lo = "URLSearchParams", sa = Lo + "Iterator", Ko = Mi.set, ca = Mi.getterFor(Lo), pa = Mi.getterFor(sa), ga = fi("fetch"), ia = fi("Request"), ra = fi("Headers"), qo = ia && ia.prototype, xa = ra && ra.prototype, $a = di.TypeError, ys = di.encodeURIComponent, Ss = String.fromCharCode, Xa = gi("String", "fromCodePoint"), Es = parseInt, Rs = Ti("".charAt), La = Ti([].join), Ja = Ti([].push), ja = Ti("".replace), Ta = Ti([].shift), rs = Ti([].splice), Qa = Ti("".split), Cs = Ti("".slice), _a = Ti(/./.exec), _s = /\+/g, el = "�", Ps = /^[0-9a-f]+$/i, nl = function(Wl, uu) {
                var du = Cs(Wl, uu, uu + 2);
                return _a(Ps, du) ? Es(du, 16) : NaN;
              }, Vs = function(Wl) {
                for (var uu = 0, du = 128; du > 0 && (Wl & du) !== 0; du >>= 1)
                  uu++;
                return uu;
              }, es = function(Wl) {
                var uu = null;
                switch (Wl.length) {
                  case 1:
                    uu = Wl[0];
                    break;
                  case 2:
                    uu = (Wl[0] & 31) << 6 | Wl[1] & 63;
                    break;
                  case 3:
                    uu = (Wl[0] & 15) << 12 | (Wl[1] & 63) << 6 | Wl[2] & 63;
                    break;
                  case 4:
                    uu = (Wl[0] & 7) << 18 | (Wl[1] & 63) << 12 | (Wl[2] & 63) << 6 | Wl[3] & 63;
                    break;
                }
                return uu > 1114111 ? null : uu;
              }, Is = function(Wl) {
                Wl = ja(Wl, _s, " ");
                for (var uu = Wl.length, du = "", za = 0; za < uu; ) {
                  var Ya = Rs(Wl, za);
                  if (Ya === "%") {
                    if (Rs(Wl, za + 1) === "%" || za + 3 > uu) {
                      du += "%", za++;
                      continue;
                    }
                    var Ws = nl(Wl, za + 1);
                    if (Ws !== Ws) {
                      du += Ya, za++;
                      continue;
                    }
                    za += 2;
                    var wl = Vs(Ws);
                    if (wl === 0)
                      Ya = Ss(Ws);
                    else {
                      if (wl === 1 || wl > 4) {
                        du += el, za++;
                        continue;
                      }
                      for (var Gl = [Ws], bl = 1; bl < wl && (za++, !(za + 3 > uu || Rs(Wl, za) !== "%")); ) {
                        var Za = nl(Wl, za + 1);
                        if (Za !== Za) {
                          za += 3;
                          break;
                        }
                        if (Za > 191 || Za < 128) break;
                        Ja(Gl, Za), za += 2, bl++;
                      }
                      if (Gl.length !== wl) {
                        du += el;
                        continue;
                      }
                      var rl = es(Gl);
                      rl === null ? du += el : Ya = Xa(rl);
                    }
                  }
                  du += Ya, za++;
                }
                return du;
              }, fl = /[!'()~]|%20/g, sl = {
                "!": "%21",
                "'": "%27",
                "(": "%28",
                ")": "%29",
                "~": "%7E",
                "%20": "+"
              }, Il = function(Wl) {
                return sl[Wl];
              }, Vl = function(Wl) {
                return ja(ys(Wl), fl, Il);
              }, Bl = Di(function(uu, du) {
                Ko(this, {
                  type: sa,
                  target: ca(uu).entries,
                  index: 0,
                  kind: du
                });
              }, Lo, function() {
                var uu = pa(this), du = uu.target, za = uu.index++;
                if (!du || za >= du.length)
                  return uu.target = null, jo(void 0, !0);
                var Ya = du[za];
                switch (uu.kind) {
                  case "keys":
                    return jo(Ya.key, !1);
                  case "values":
                    return jo(Ya.value, !1);
                }
                return jo([Ya.key, Ya.value], !1);
              }, !0), ql = function(Wl) {
                this.entries = [], this.url = null, Wl !== void 0 && (Co(Wl) ? this.parseObject(Wl) : this.parseQuery(typeof Wl == "string" ? Rs(Wl, 0) === "?" ? Cs(Wl, 1) : Wl : Ni(Wl)));
              };
              ql.prototype = {
                type: Lo,
                bindURL: function(Wl) {
                  this.url = Wl, this.update();
                },
                parseObject: function(Wl) {
                  var uu = this.entries, du = Ui(Wl), za, Ya, Ws, wl, Gl, bl, Za;
                  if (du)
                    for (za = No(Wl, du), Ya = za.next; !(Ws = mi(Ya, za)).done; ) {
                      if (wl = No(Li(Ws.value)), Gl = wl.next, (bl = mi(Gl, wl)).done || (Za = mi(Gl, wl)).done || !mi(Gl, wl).done) throw new $a("Expected sequence with length 2");
                      Ja(uu, { key: Ni(bl.value), value: Ni(Za.value) });
                    }
                  else for (var rl in Wl) xo(Wl, rl) && Ja(uu, { key: rl, value: Ni(Wl[rl]) });
                },
                parseQuery: function(Wl) {
                  if (Wl)
                    for (var uu = this.entries, du = Qa(Wl, "&"), za = 0, Ya, Ws; za < du.length; )
                      Ya = du[za++], Ya.length && (Ws = Qa(Ya, "="), Ja(uu, {
                        key: Is(Ta(Ws)),
                        value: Is(La(Ws, "="))
                      }));
                },
                serialize: function() {
                  for (var Wl = this.entries, uu = [], du = 0, za; du < Wl.length; )
                    za = Wl[du++], Ja(uu, Vl(za.key) + "=" + Vl(za.value));
                  return La(uu, "&");
                },
                update: function() {
                  this.entries.length = 0, this.parseQuery(this.url.query);
                },
                updateURL: function() {
                  this.url && this.url.update();
                }
              };
              var xl = function() {
                Oo(this, Ul);
                var uu = arguments.length > 0 ? arguments[0] : void 0, du = Ko(this, new ql(uu));
                vi || (this.size = du.entries.length);
              }, Ul = xl.prototype;
              if ($i(Ul, {
                // `URLSearchParams.prototype.append` method
                // https://url.spec.whatwg.org/#dom-urlsearchparams-append
                append: function(uu, du) {
                  var za = ca(this);
                  Wi(arguments.length, 2), Ja(za.entries, { key: Ni(uu), value: Ni(du) }), vi || this.length++, za.updateURL();
                },
                // `URLSearchParams.prototype.delete` method
                // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
                delete: function(Wl) {
                  for (var uu = ca(this), du = Wi(arguments.length, 1), za = uu.entries, Ya = Ni(Wl), Ws = du < 2 ? void 0 : arguments[1], wl = Ws === void 0 ? Ws : Ni(Ws), Gl = 0; Gl < za.length; ) {
                    var bl = za[Gl];
                    if (bl.key === Ya && (wl === void 0 || bl.value === wl)) {
                      if (rs(za, Gl, 1), wl !== void 0) break;
                    } else Gl++;
                  }
                  vi || (this.size = za.length), uu.updateURL();
                },
                // `URLSearchParams.prototype.get` method
                // https://url.spec.whatwg.org/#dom-urlsearchparams-get
                get: function(uu) {
                  var du = ca(this).entries;
                  Wi(arguments.length, 1);
                  for (var za = Ni(uu), Ya = 0; Ya < du.length; Ya++)
                    if (du[Ya].key === za) return du[Ya].value;
                  return null;
                },
                // `URLSearchParams.prototype.getAll` method
                // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
                getAll: function(uu) {
                  var du = ca(this).entries;
                  Wi(arguments.length, 1);
                  for (var za = Ni(uu), Ya = [], Ws = 0; Ws < du.length; Ws++)
                    du[Ws].key === za && Ja(Ya, du[Ws].value);
                  return Ya;
                },
                // `URLSearchParams.prototype.has` method
                // https://url.spec.whatwg.org/#dom-urlsearchparams-has
                has: function(uu) {
                  for (var du = ca(this).entries, za = Wi(arguments.length, 1), Ya = Ni(uu), Ws = za < 2 ? void 0 : arguments[1], wl = Ws === void 0 ? Ws : Ni(Ws), Gl = 0; Gl < du.length; ) {
                    var bl = du[Gl++];
                    if (bl.key === Ya && (wl === void 0 || bl.value === wl)) return !0;
                  }
                  return !1;
                },
                // `URLSearchParams.prototype.set` method
                // https://url.spec.whatwg.org/#dom-urlsearchparams-set
                set: function(uu, du) {
                  var za = ca(this);
                  Wi(arguments.length, 1);
                  for (var Ya = za.entries, Ws = !1, wl = Ni(uu), Gl = Ni(du), bl = 0, Za; bl < Ya.length; bl++)
                    Za = Ya[bl], Za.key === wl && (Ws ? rs(Ya, bl--, 1) : (Ws = !0, Za.value = Gl));
                  Ws || Ja(Ya, { key: wl, value: Gl }), vi || (this.size = Ya.length), za.updateURL();
                },
                // `URLSearchParams.prototype.sort` method
                // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
                sort: function() {
                  var uu = ca(this);
                  Hi(uu.entries, function(du, za) {
                    return du.key > za.key ? 1 : -1;
                  }), uu.updateURL();
                },
                // `URLSearchParams.prototype.forEach` method
                forEach: function(uu) {
                  for (var du = ca(this).entries, za = fo(uu, arguments.length > 1 ? arguments[1] : void 0), Ya = 0, Ws; Ya < du.length; )
                    Ws = du[Ya++], za(Ws.value, Ws.key, this);
                },
                // `URLSearchParams.prototype.keys` method
                keys: function() {
                  return new Bl(this, "keys");
                },
                // `URLSearchParams.prototype.values` method
                values: function() {
                  return new Bl(this, "values");
                },
                // `URLSearchParams.prototype.entries` method
                entries: function() {
                  return new Bl(this, "entries");
                }
              }, { enumerable: !0 }), Si(Ul, zo, Ul.entries, { name: "entries" }), Si(Ul, "toString", function() {
                return ca(this).serialize();
              }, { enumerable: !0 }), vi && Pi(Ul, "size", {
                get: function() {
                  return ca(this).entries.length;
                },
                configurable: !0,
                enumerable: !0
              }), Oi(xl, Lo), si({ global: !0, constructor: !0, forced: !xi }, {
                URLSearchParams: xl
              }), !xi && io(ra)) {
                var Xl = Ti(xa.has), hu = Ti(xa.set), Tu = function(Wl) {
                  if (Co(Wl)) {
                    var uu = Wl.body, du;
                    if (_o(uu) === Lo)
                      return du = Wl.headers ? new ra(Wl.headers) : new ra(), Xl(du, "content-type") || hu(du, "content-type", "application/x-www-form-urlencoded;charset=UTF-8"), Yi(Wl, {
                        body: Vo(0, Ni(uu)),
                        headers: Vo(0, du)
                      });
                  }
                  return Wl;
                };
                if (io(ga) && si({ global: !0, enumerable: !0, dontCallGetSet: !0, forced: !0 }, {
                  fetch: function(uu) {
                    return ga(uu, arguments.length > 1 ? Tu(arguments[1]) : {});
                  }
                }), io(ia)) {
                  var Ku = function(uu) {
                    return Oo(this, qo), new ia(uu, arguments.length > 1 ? Tu(arguments[1]) : {});
                  };
                  qo.constructor = Ku, Ku.prototype = qo, si({ global: !0, constructor: !0, dontCallGetSet: !0, forced: !0 }, {
                    Request: Ku
                  });
                }
              }
              ai.exports = {
                URLSearchParams: xl,
                getState: ca
              };
            })
          ),
          /***/
          5042: (
            /***/
            (() => {
            })
          ),
          /***/
          7649: (
            /***/
            (() => {
            })
          ),
          /***/
          6299: (
            /***/
            ((ai, li, oi) => {
              oi(7105);
            })
          ),
          /***/
          3604: (
            /***/
            (() => {
            })
          ),
          /***/
          8669: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(5582), fi = oi(8828), gi = oi(4787), mi = oi(160), Ti = oi(4791), vi = di("URL"), xi = Ti && fi(function() {
                vi.canParse();
              }), Si = fi(function() {
                return vi.canParse.length !== 1;
              });
              si({ target: "URL", stat: !0, forced: !xi || Si }, {
                canParse: function($i) {
                  var Oi = gi(arguments.length, 1), Di = mi($i), Mi = Oi < 2 || arguments[1] === void 0 ? void 0 : mi(arguments[1]);
                  try {
                    return !!new vi(Di, Mi);
                  } catch {
                    return !1;
                  }
                }
              });
            })
          ),
          /***/
          6909: (
            /***/
            ((ai, li, oi) => {
              oi(7057);
              var si = oi(1091), di = oi(9447), fi = oi(4791), gi = oi(5951), mi = oi(8311), Ti = oi(1907), vi = oi(8055), xi = oi(9251), Si = oi(9596), Pi = oi(9724), $i = oi(9538), Oi = oi(1229), Di = oi(3427), Mi = oi(1470).codeAt, Oo = oi(9156), io = oi(160), xo = oi(4840), fo = oi(4787), _o = oi(7105), Li = oi(4932), Co = Li.set, Ni = Li.getterFor("URL"), Yi = _o.URLSearchParams, Vo = _o.getState, No = gi.URL, Ui = gi.TypeError, jo = gi.parseInt, Wi = Math.floor, ji = Math.pow, Hi = Ti("".charAt), zo = Ti(/./.exec), Lo = Ti([].join), sa = Ti(1 .toString), Ko = Ti([].pop), ca = Ti([].push), pa = Ti("".replace), ga = Ti([].shift), ia = Ti("".split), ra = Ti("".slice), qo = Ti("".toLowerCase), xa = Ti([].unshift), $a = "Invalid authority", ys = "Invalid scheme", Ss = "Invalid host", Xa = "Invalid port", Es = /[a-z]/i, Rs = /[\d+-.a-z]/i, La = /\d/, Ja = /^0x/i, ja = /^[0-7]+$/, Ta = /^\d+$/, rs = /^[\da-f]+$/i, Qa = /[\0\t\n\r #%/:<>?@[\\\]^|]/, Cs = /[\0\t\n\r #/:<>?@[\\\]^|]/, _a = /^[\u0000-\u0020]+/, _s = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/, el = /[\t\n\r]/g, Ps, nl = function(Tl) {
                var Yl = ia(Tl, "."), Dl, Cl, Hl, Gu, xu, ac, hc;
                if (Yl.length && Yl[Yl.length - 1] === "" && Yl.length--, Dl = Yl.length, Dl > 4) return Tl;
                for (Cl = [], Hl = 0; Hl < Dl; Hl++) {
                  if (Gu = Yl[Hl], Gu === "") return Tl;
                  if (xu = 10, Gu.length > 1 && Hi(Gu, 0) === "0" && (xu = zo(Ja, Gu) ? 16 : 8, Gu = ra(Gu, xu === 8 ? 1 : 2)), Gu === "")
                    ac = 0;
                  else {
                    if (!zo(xu === 10 ? Ta : xu === 8 ? ja : rs, Gu)) return Tl;
                    ac = jo(Gu, xu);
                  }
                  ca(Cl, ac);
                }
                for (Hl = 0; Hl < Dl; Hl++)
                  if (ac = Cl[Hl], Hl === Dl - 1) {
                    if (ac >= ji(256, 5 - Dl)) return null;
                  } else if (ac > 255) return null;
                for (hc = Ko(Cl), Hl = 0; Hl < Cl.length; Hl++)
                  hc += Cl[Hl] * ji(256, 3 - Hl);
                return hc;
              }, Vs = function(Tl) {
                var Yl = [0, 0, 0, 0, 0, 0, 0, 0], Dl = 0, Cl = null, Hl = 0, Gu, xu, ac, hc, mc, jc, iu, yc = function() {
                  return Hi(Tl, Hl);
                };
                if (yc() === ":") {
                  if (Hi(Tl, 1) !== ":") return;
                  Hl += 2, Dl++, Cl = Dl;
                }
                for (; yc(); ) {
                  if (Dl === 8) return;
                  if (yc() === ":") {
                    if (Cl !== null) return;
                    Hl++, Dl++, Cl = Dl;
                    continue;
                  }
                  for (Gu = xu = 0; xu < 4 && zo(rs, yc()); )
                    Gu = Gu * 16 + jo(yc(), 16), Hl++, xu++;
                  if (yc() === ".") {
                    if (xu === 0 || (Hl -= xu, Dl > 6)) return;
                    for (ac = 0; yc(); ) {
                      if (hc = null, ac > 0)
                        if (yc() === "." && ac < 4) Hl++;
                        else return;
                      if (!zo(La, yc())) return;
                      for (; zo(La, yc()); ) {
                        if (mc = jo(yc(), 10), hc === null) hc = mc;
                        else {
                          if (hc === 0) return;
                          hc = hc * 10 + mc;
                        }
                        if (hc > 255) return;
                        Hl++;
                      }
                      Yl[Dl] = Yl[Dl] * 256 + hc, ac++, (ac === 2 || ac === 4) && Dl++;
                    }
                    if (ac !== 4) return;
                    break;
                  } else if (yc() === ":") {
                    if (Hl++, !yc()) return;
                  } else if (yc()) return;
                  Yl[Dl++] = Gu;
                }
                if (Cl !== null)
                  for (jc = Dl - Cl, Dl = 7; Dl !== 0 && jc > 0; )
                    iu = Yl[Dl], Yl[Dl--] = Yl[Cl + jc - 1], Yl[Cl + --jc] = iu;
                else if (Dl !== 8) return;
                return Yl;
              }, es = function(Tl) {
                for (var Yl = null, Dl = 1, Cl = null, Hl = 0, Gu = 0; Gu < 8; Gu++)
                  Tl[Gu] !== 0 ? (Hl > Dl && (Yl = Cl, Dl = Hl), Cl = null, Hl = 0) : (Cl === null && (Cl = Gu), ++Hl);
                return Hl > Dl ? Cl : Yl;
              }, Is = function(Tl) {
                var Yl, Dl, Cl, Hl;
                if (typeof Tl == "number") {
                  for (Yl = [], Dl = 0; Dl < 4; Dl++)
                    xa(Yl, Tl % 256), Tl = Wi(Tl / 256);
                  return Lo(Yl, ".");
                }
                if (typeof Tl == "object") {
                  for (Yl = "", Cl = es(Tl), Dl = 0; Dl < 8; Dl++)
                    Hl && Tl[Dl] === 0 || (Hl && (Hl = !1), Cl === Dl ? (Yl += Dl ? ":" : "::", Hl = !0) : (Yl += sa(Tl[Dl], 16), Dl < 7 && (Yl += ":")));
                  return "[" + Yl + "]";
                }
                return Tl;
              }, fl = {}, sl = $i({}, fl, {
                " ": 1,
                '"': 1,
                "<": 1,
                ">": 1,
                "`": 1
              }), Il = $i({}, sl, {
                "#": 1,
                "?": 1,
                "{": 1,
                "}": 1
              }), Vl = $i({}, Il, {
                "/": 1,
                ":": 1,
                ";": 1,
                "=": 1,
                "@": 1,
                "[": 1,
                "\\": 1,
                "]": 1,
                "^": 1,
                "|": 1
              }), Bl = function(Tl, Yl) {
                var Dl = Mi(Tl, 0);
                return Dl > 32 && Dl < 127 && !Pi(Yl, Tl) ? Tl : encodeURIComponent(Tl);
              }, ql = {
                ftp: 21,
                file: null,
                http: 80,
                https: 443,
                ws: 80,
                wss: 443
              }, xl = function(Tl, Yl) {
                var Dl;
                return Tl.length === 2 && zo(Es, Hi(Tl, 0)) && ((Dl = Hi(Tl, 1)) === ":" || !Yl && Dl === "|");
              }, Ul = function(Tl) {
                var Yl;
                return Tl.length > 1 && xl(ra(Tl, 0, 2)) && (Tl.length === 2 || (Yl = Hi(Tl, 2)) === "/" || Yl === "\\" || Yl === "?" || Yl === "#");
              }, Xl = function(Tl) {
                return Tl === "." || qo(Tl) === "%2e";
              }, hu = function(Tl) {
                return Tl = qo(Tl), Tl === ".." || Tl === "%2e." || Tl === ".%2e" || Tl === "%2e%2e";
              }, Tu = {}, Ku = {}, Wl = {}, uu = {}, du = {}, za = {}, Ya = {}, Ws = {}, wl = {}, Gl = {}, bl = {}, Za = {}, rl = {}, zs = {}, al = {}, Ol = {}, $l = {}, Zl = {}, tu = {}, su = {}, dl = {}, Su = function(Tl, Yl, Dl) {
                var Cl = io(Tl), Hl, Gu, xu;
                if (Yl) {
                  if (Gu = this.parse(Cl), Gu) throw new Ui(Gu);
                  this.searchParams = null;
                } else {
                  if (Dl !== void 0 && (Hl = new Su(Dl, !0)), Gu = this.parse(Cl, null, Hl), Gu) throw new Ui(Gu);
                  xu = Vo(new Yi()), xu.bindURL(this), this.searchParams = xu;
                }
              };
              Su.prototype = {
                type: "URL",
                // https://url.spec.whatwg.org/#url-parsing
                // eslint-disable-next-line max-statements -- TODO
                parse: function(Tl, Yl, Dl) {
                  var Cl = this, Hl = Yl || Tu, Gu = 0, xu = "", ac = !1, hc = !1, mc = !1, jc, iu, yc, Mu;
                  for (Tl = io(Tl), Yl || (Cl.scheme = "", Cl.username = "", Cl.password = "", Cl.host = null, Cl.port = null, Cl.path = [], Cl.query = null, Cl.fragment = null, Cl.cannotBeABaseURL = !1, Tl = pa(Tl, _a, ""), Tl = pa(Tl, _s, "$1")), Tl = pa(Tl, el, ""), jc = Oi(Tl); Gu <= jc.length; ) {
                    switch (iu = jc[Gu], Hl) {
                      case Tu:
                        if (iu && zo(Es, iu))
                          xu += qo(iu), Hl = Ku;
                        else {
                          if (Yl)
                            return ys;
                          Hl = Wl;
                          continue;
                        }
                        break;
                      case Ku:
                        if (iu && (zo(Rs, iu) || iu === "+" || iu === "-" || iu === "."))
                          xu += qo(iu);
                        else if (iu === ":") {
                          if (Yl && (Cl.isSpecial() !== Pi(ql, xu) || xu === "file" && (Cl.includesCredentials() || Cl.port !== null) || Cl.scheme === "file" && !Cl.host)) return;
                          if (Cl.scheme = xu, Yl) {
                            Cl.isSpecial() && ql[Cl.scheme] === Cl.port && (Cl.port = null);
                            return;
                          }
                          xu = "", Cl.scheme === "file" ? Hl = zs : Cl.isSpecial() && Dl && Dl.scheme === Cl.scheme ? Hl = uu : Cl.isSpecial() ? Hl = Ws : jc[Gu + 1] === "/" ? (Hl = du, Gu++) : (Cl.cannotBeABaseURL = !0, ca(Cl.path, ""), Hl = tu);
                        } else {
                          if (Yl)
                            return ys;
                          xu = "", Hl = Wl, Gu = 0;
                          continue;
                        }
                        break;
                      case Wl:
                        if (!Dl || Dl.cannotBeABaseURL && iu !== "#") return ys;
                        if (Dl.cannotBeABaseURL && iu === "#") {
                          Cl.scheme = Dl.scheme, Cl.path = Di(Dl.path), Cl.query = Dl.query, Cl.fragment = "", Cl.cannotBeABaseURL = !0, Hl = dl;
                          break;
                        }
                        Hl = Dl.scheme === "file" ? zs : za;
                        continue;
                      case uu:
                        if (iu === "/" && jc[Gu + 1] === "/")
                          Hl = wl, Gu++;
                        else {
                          Hl = za;
                          continue;
                        }
                        break;
                      case du:
                        if (iu === "/") {
                          Hl = Gl;
                          break;
                        } else {
                          Hl = Zl;
                          continue;
                        }
                      case za:
                        if (Cl.scheme = Dl.scheme, iu === Ps)
                          Cl.username = Dl.username, Cl.password = Dl.password, Cl.host = Dl.host, Cl.port = Dl.port, Cl.path = Di(Dl.path), Cl.query = Dl.query;
                        else if (iu === "/" || iu === "\\" && Cl.isSpecial())
                          Hl = Ya;
                        else if (iu === "?")
                          Cl.username = Dl.username, Cl.password = Dl.password, Cl.host = Dl.host, Cl.port = Dl.port, Cl.path = Di(Dl.path), Cl.query = "", Hl = su;
                        else if (iu === "#")
                          Cl.username = Dl.username, Cl.password = Dl.password, Cl.host = Dl.host, Cl.port = Dl.port, Cl.path = Di(Dl.path), Cl.query = Dl.query, Cl.fragment = "", Hl = dl;
                        else {
                          Cl.username = Dl.username, Cl.password = Dl.password, Cl.host = Dl.host, Cl.port = Dl.port, Cl.path = Di(Dl.path), Cl.path.length--, Hl = Zl;
                          continue;
                        }
                        break;
                      case Ya:
                        if (Cl.isSpecial() && (iu === "/" || iu === "\\"))
                          Hl = wl;
                        else if (iu === "/")
                          Hl = Gl;
                        else {
                          Cl.username = Dl.username, Cl.password = Dl.password, Cl.host = Dl.host, Cl.port = Dl.port, Hl = Zl;
                          continue;
                        }
                        break;
                      case Ws:
                        if (Hl = wl, iu !== "/" || Hi(xu, Gu + 1) !== "/") continue;
                        Gu++;
                        break;
                      case wl:
                        if (iu !== "/" && iu !== "\\") {
                          Hl = Gl;
                          continue;
                        }
                        break;
                      case Gl:
                        if (iu === "@") {
                          ac && (xu = "%40" + xu), ac = !0, yc = Oi(xu);
                          for (var sc = 0; sc < yc.length; sc++) {
                            var wc = yc[sc];
                            if (wc === ":" && !mc) {
                              mc = !0;
                              continue;
                            }
                            var Wc = Bl(wc, Vl);
                            mc ? Cl.password += Wc : Cl.username += Wc;
                          }
                          xu = "";
                        } else if (iu === Ps || iu === "/" || iu === "?" || iu === "#" || iu === "\\" && Cl.isSpecial()) {
                          if (ac && xu === "") return $a;
                          Gu -= Oi(xu).length + 1, xu = "", Hl = bl;
                        } else xu += iu;
                        break;
                      case bl:
                      case Za:
                        if (Yl && Cl.scheme === "file") {
                          Hl = Ol;
                          continue;
                        } else if (iu === ":" && !hc) {
                          if (xu === "") return Ss;
                          if (Mu = Cl.parseHost(xu), Mu) return Mu;
                          if (xu = "", Hl = rl, Yl === Za) return;
                        } else if (iu === Ps || iu === "/" || iu === "?" || iu === "#" || iu === "\\" && Cl.isSpecial()) {
                          if (Cl.isSpecial() && xu === "") return Ss;
                          if (Yl && xu === "" && (Cl.includesCredentials() || Cl.port !== null)) return;
                          if (Mu = Cl.parseHost(xu), Mu) return Mu;
                          if (xu = "", Hl = $l, Yl) return;
                          continue;
                        } else
                          iu === "[" ? hc = !0 : iu === "]" && (hc = !1), xu += iu;
                        break;
                      case rl:
                        if (zo(La, iu))
                          xu += iu;
                        else if (iu === Ps || iu === "/" || iu === "?" || iu === "#" || iu === "\\" && Cl.isSpecial() || Yl) {
                          if (xu !== "") {
                            var Xu = jo(xu, 10);
                            if (Xu > 65535) return Xa;
                            Cl.port = Cl.isSpecial() && Xu === ql[Cl.scheme] ? null : Xu, xu = "";
                          }
                          if (Yl) return;
                          Hl = $l;
                          continue;
                        } else return Xa;
                        break;
                      case zs:
                        if (Cl.scheme = "file", iu === "/" || iu === "\\") Hl = al;
                        else if (Dl && Dl.scheme === "file")
                          switch (iu) {
                            case Ps:
                              Cl.host = Dl.host, Cl.path = Di(Dl.path), Cl.query = Dl.query;
                              break;
                            case "?":
                              Cl.host = Dl.host, Cl.path = Di(Dl.path), Cl.query = "", Hl = su;
                              break;
                            case "#":
                              Cl.host = Dl.host, Cl.path = Di(Dl.path), Cl.query = Dl.query, Cl.fragment = "", Hl = dl;
                              break;
                            default:
                              Ul(Lo(Di(jc, Gu), "")) || (Cl.host = Dl.host, Cl.path = Di(Dl.path), Cl.shortenPath()), Hl = Zl;
                              continue;
                          }
                        else {
                          Hl = Zl;
                          continue;
                        }
                        break;
                      case al:
                        if (iu === "/" || iu === "\\") {
                          Hl = Ol;
                          break;
                        }
                        Dl && Dl.scheme === "file" && !Ul(Lo(Di(jc, Gu), "")) && (xl(Dl.path[0], !0) ? ca(Cl.path, Dl.path[0]) : Cl.host = Dl.host), Hl = Zl;
                        continue;
                      case Ol:
                        if (iu === Ps || iu === "/" || iu === "\\" || iu === "?" || iu === "#") {
                          if (!Yl && xl(xu))
                            Hl = Zl;
                          else if (xu === "") {
                            if (Cl.host = "", Yl) return;
                            Hl = $l;
                          } else {
                            if (Mu = Cl.parseHost(xu), Mu) return Mu;
                            if (Cl.host === "localhost" && (Cl.host = ""), Yl) return;
                            xu = "", Hl = $l;
                          }
                          continue;
                        } else xu += iu;
                        break;
                      case $l:
                        if (Cl.isSpecial()) {
                          if (Hl = Zl, iu !== "/" && iu !== "\\") continue;
                        } else if (!Yl && iu === "?")
                          Cl.query = "", Hl = su;
                        else if (!Yl && iu === "#")
                          Cl.fragment = "", Hl = dl;
                        else if (iu !== Ps && (Hl = Zl, iu !== "/"))
                          continue;
                        break;
                      case Zl:
                        if (iu === Ps || iu === "/" || iu === "\\" && Cl.isSpecial() || !Yl && (iu === "?" || iu === "#")) {
                          if (hu(xu) ? (Cl.shortenPath(), iu !== "/" && !(iu === "\\" && Cl.isSpecial()) && ca(Cl.path, "")) : Xl(xu) ? iu !== "/" && !(iu === "\\" && Cl.isSpecial()) && ca(Cl.path, "") : (Cl.scheme === "file" && !Cl.path.length && xl(xu) && (Cl.host && (Cl.host = ""), xu = Hi(xu, 0) + ":"), ca(Cl.path, xu)), xu = "", Cl.scheme === "file" && (iu === Ps || iu === "?" || iu === "#"))
                            for (; Cl.path.length > 1 && Cl.path[0] === ""; )
                              ga(Cl.path);
                          iu === "?" ? (Cl.query = "", Hl = su) : iu === "#" && (Cl.fragment = "", Hl = dl);
                        } else
                          xu += Bl(iu, Il);
                        break;
                      case tu:
                        iu === "?" ? (Cl.query = "", Hl = su) : iu === "#" ? (Cl.fragment = "", Hl = dl) : iu !== Ps && (Cl.path[0] += Bl(iu, fl));
                        break;
                      case su:
                        !Yl && iu === "#" ? (Cl.fragment = "", Hl = dl) : iu !== Ps && (iu === "'" && Cl.isSpecial() ? Cl.query += "%27" : iu === "#" ? Cl.query += "%23" : Cl.query += Bl(iu, fl));
                        break;
                      case dl:
                        iu !== Ps && (Cl.fragment += Bl(iu, sl));
                        break;
                    }
                    Gu++;
                  }
                },
                // https://url.spec.whatwg.org/#host-parsing
                parseHost: function(Tl) {
                  var Yl, Dl, Cl;
                  if (Hi(Tl, 0) === "[") {
                    if (Hi(Tl, Tl.length - 1) !== "]" || (Yl = Vs(ra(Tl, 1, -1)), !Yl)) return Ss;
                    this.host = Yl;
                  } else if (this.isSpecial()) {
                    if (Tl = Oo(Tl), zo(Qa, Tl) || (Yl = nl(Tl), Yl === null)) return Ss;
                    this.host = Yl;
                  } else {
                    if (zo(Cs, Tl)) return Ss;
                    for (Yl = "", Dl = Oi(Tl), Cl = 0; Cl < Dl.length; Cl++)
                      Yl += Bl(Dl[Cl], fl);
                    this.host = Yl;
                  }
                },
                // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
                cannotHaveUsernamePasswordPort: function() {
                  return !this.host || this.cannotBeABaseURL || this.scheme === "file";
                },
                // https://url.spec.whatwg.org/#include-credentials
                includesCredentials: function() {
                  return this.username !== "" || this.password !== "";
                },
                // https://url.spec.whatwg.org/#is-special
                isSpecial: function() {
                  return Pi(ql, this.scheme);
                },
                // https://url.spec.whatwg.org/#shorten-a-urls-path
                shortenPath: function() {
                  var Tl = this.path, Yl = Tl.length;
                  Yl && (this.scheme !== "file" || Yl !== 1 || !xl(Tl[0], !0)) && Tl.length--;
                },
                // https://url.spec.whatwg.org/#concept-url-serializer
                serialize: function() {
                  var Tl = this, Yl = Tl.scheme, Dl = Tl.username, Cl = Tl.password, Hl = Tl.host, Gu = Tl.port, xu = Tl.path, ac = Tl.query, hc = Tl.fragment, mc = Yl + ":";
                  return Hl !== null ? (mc += "//", Tl.includesCredentials() && (mc += Dl + (Cl ? ":" + Cl : "") + "@"), mc += Is(Hl), Gu !== null && (mc += ":" + Gu)) : Yl === "file" && (mc += "//"), mc += Tl.cannotBeABaseURL ? xu[0] : xu.length ? "/" + Lo(xu, "/") : "", ac !== null && (mc += "?" + ac), hc !== null && (mc += "#" + hc), mc;
                },
                // https://url.spec.whatwg.org/#dom-url-href
                setHref: function(Tl) {
                  var Yl = this.parse(Tl);
                  if (Yl) throw new Ui(Yl);
                  this.searchParams.update();
                },
                // https://url.spec.whatwg.org/#dom-url-origin
                getOrigin: function() {
                  var Tl = this.scheme, Yl = this.port;
                  if (Tl === "blob") try {
                    return new cu(Tl.path[0]).origin;
                  } catch {
                    return "null";
                  }
                  return Tl === "file" || !this.isSpecial() ? "null" : Tl + "://" + Is(this.host) + (Yl !== null ? ":" + Yl : "");
                },
                // https://url.spec.whatwg.org/#dom-url-protocol
                getProtocol: function() {
                  return this.scheme + ":";
                },
                setProtocol: function(Tl) {
                  this.parse(io(Tl) + ":", Tu);
                },
                // https://url.spec.whatwg.org/#dom-url-username
                getUsername: function() {
                  return this.username;
                },
                setUsername: function(Tl) {
                  var Yl = Oi(io(Tl));
                  if (!this.cannotHaveUsernamePasswordPort()) {
                    this.username = "";
                    for (var Dl = 0; Dl < Yl.length; Dl++)
                      this.username += Bl(Yl[Dl], Vl);
                  }
                },
                // https://url.spec.whatwg.org/#dom-url-password
                getPassword: function() {
                  return this.password;
                },
                setPassword: function(Tl) {
                  var Yl = Oi(io(Tl));
                  if (!this.cannotHaveUsernamePasswordPort()) {
                    this.password = "";
                    for (var Dl = 0; Dl < Yl.length; Dl++)
                      this.password += Bl(Yl[Dl], Vl);
                  }
                },
                // https://url.spec.whatwg.org/#dom-url-host
                getHost: function() {
                  var Tl = this.host, Yl = this.port;
                  return Tl === null ? "" : Yl === null ? Is(Tl) : Is(Tl) + ":" + Yl;
                },
                setHost: function(Tl) {
                  this.cannotBeABaseURL || this.parse(Tl, bl);
                },
                // https://url.spec.whatwg.org/#dom-url-hostname
                getHostname: function() {
                  var Tl = this.host;
                  return Tl === null ? "" : Is(Tl);
                },
                setHostname: function(Tl) {
                  this.cannotBeABaseURL || this.parse(Tl, Za);
                },
                // https://url.spec.whatwg.org/#dom-url-port
                getPort: function() {
                  var Tl = this.port;
                  return Tl === null ? "" : io(Tl);
                },
                setPort: function(Tl) {
                  this.cannotHaveUsernamePasswordPort() || (Tl = io(Tl), Tl === "" ? this.port = null : this.parse(Tl, rl));
                },
                // https://url.spec.whatwg.org/#dom-url-pathname
                getPathname: function() {
                  var Tl = this.path;
                  return this.cannotBeABaseURL ? Tl[0] : Tl.length ? "/" + Lo(Tl, "/") : "";
                },
                setPathname: function(Tl) {
                  this.cannotBeABaseURL || (this.path = [], this.parse(Tl, $l));
                },
                // https://url.spec.whatwg.org/#dom-url-search
                getSearch: function() {
                  var Tl = this.query;
                  return Tl ? "?" + Tl : "";
                },
                setSearch: function(Tl) {
                  Tl = io(Tl), Tl === "" ? this.query = null : (Hi(Tl, 0) === "?" && (Tl = ra(Tl, 1)), this.query = "", this.parse(Tl, su)), this.searchParams.update();
                },
                // https://url.spec.whatwg.org/#dom-url-searchparams
                getSearchParams: function() {
                  return this.searchParams.facade;
                },
                // https://url.spec.whatwg.org/#dom-url-hash
                getHash: function() {
                  var Tl = this.fragment;
                  return Tl ? "#" + Tl : "";
                },
                setHash: function(Tl) {
                  if (Tl = io(Tl), Tl === "") {
                    this.fragment = null;
                    return;
                  }
                  Hi(Tl, 0) === "#" && (Tl = ra(Tl, 1)), this.fragment = "", this.parse(Tl, dl);
                },
                update: function() {
                  this.query = this.searchParams.serialize() || null;
                }
              };
              var cu = function(Yl) {
                var Dl = Si(this, Ru), Cl = fo(arguments.length, 1) > 1 ? arguments[1] : void 0, Hl = Co(Dl, new Su(Yl, !1, Cl));
                di || (Dl.href = Hl.serialize(), Dl.origin = Hl.getOrigin(), Dl.protocol = Hl.getProtocol(), Dl.username = Hl.getUsername(), Dl.password = Hl.getPassword(), Dl.host = Hl.getHost(), Dl.hostname = Hl.getHostname(), Dl.port = Hl.getPort(), Dl.pathname = Hl.getPathname(), Dl.search = Hl.getSearch(), Dl.searchParams = Hl.getSearchParams(), Dl.hash = Hl.getHash());
              }, Ru = cu.prototype, bu = function(Tl, Yl) {
                return {
                  get: function() {
                    return Ni(this)[Tl]();
                  },
                  set: Yl && function(Dl) {
                    return Ni(this)[Yl](Dl);
                  },
                  configurable: !0,
                  enumerable: !0
                };
              };
              if (di && (xi(Ru, "href", bu("serialize", "setHref")), xi(Ru, "origin", bu("getOrigin")), xi(Ru, "protocol", bu("getProtocol", "setProtocol")), xi(Ru, "username", bu("getUsername", "setUsername")), xi(Ru, "password", bu("getPassword", "setPassword")), xi(Ru, "host", bu("getHost", "setHost")), xi(Ru, "hostname", bu("getHostname", "setHostname")), xi(Ru, "port", bu("getPort", "setPort")), xi(Ru, "pathname", bu("getPathname", "setPathname")), xi(Ru, "search", bu("getSearch", "setSearch")), xi(Ru, "searchParams", bu("getSearchParams")), xi(Ru, "hash", bu("getHash", "setHash"))), vi(Ru, "toJSON", function() {
                return Ni(this).serialize();
              }, { enumerable: !0 }), vi(Ru, "toString", function() {
                return Ni(this).serialize();
              }, { enumerable: !0 }), No) {
                var Hu = No.createObjectURL, cc = No.revokeObjectURL;
                Hu && vi(cu, "createObjectURL", mi(Hu, No)), cc && vi(cu, "revokeObjectURL", mi(cc, No));
              }
              xo(cu, "URL"), si({ global: !0, constructor: !0, forced: !fi, sham: !di }, {
                URL: cu
              });
            })
          ),
          /***/
          3487: (
            /***/
            ((ai, li, oi) => {
              oi(6909);
            })
          ),
          /***/
          8670: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1091), di = oi(5582), fi = oi(4787), gi = oi(160), mi = oi(4791), Ti = di("URL");
              si({ target: "URL", stat: !0, forced: !mi }, {
                parse: function(xi) {
                  var Si = fi(arguments.length, 1), Pi = gi(xi), $i = Si < 2 || arguments[1] === void 0 ? void 0 : gi(arguments[1]);
                  try {
                    return new Ti(Pi, $i);
                  } catch {
                    return null;
                  }
                }
              });
            })
          ),
          /***/
          4783: (
            /***/
            (() => {
            })
          ),
          /***/
          6450: (
            /***/
            ((ai, li, oi) => {
              var si = oi(3607);
              ai.exports = si;
            })
          ),
          /***/
          8402: (
            /***/
            ((ai, li, oi) => {
              var si = oi(3531);
              ai.exports = si;
            })
          ),
          /***/
          1969: (
            /***/
            ((ai, li, oi) => {
              var si = oi(2092);
              ai.exports = si;
            })
          ),
          /***/
          1374: (
            /***/
            ((ai, li, oi) => {
              var si = oi(6535);
              ai.exports = si;
            })
          ),
          /***/
          7867: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5354);
              ai.exports = si;
            })
          ),
          /***/
          3067: (
            /***/
            ((ai, li, oi) => {
              var si = oi(4712);
              oi(2560), ai.exports = si;
            })
          ),
          /***/
          9709: (
            /***/
            ((ai, li, oi) => {
              var si = oi(3034);
              ai.exports = si;
            })
          ),
          /***/
          530: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8218);
              ai.exports = si;
            })
          ),
          /***/
          2616: (
            /***/
            ((ai, li, oi) => {
              var si = oi(3155);
              ai.exports = si;
            })
          ),
          /***/
          4525: (
            /***/
            ((ai, li, oi) => {
              var si = oi(3948), di = oi(9724), fi = oi(8280), gi = oi(1969);
              oi(237);
              var mi = Array.prototype, Ti = {
                DOMTokenList: !0,
                NodeList: !0
              };
              ai.exports = function(vi) {
                var xi = vi.forEach;
                return vi === mi || fi(mi, vi) && xi === mi.forEach || di(Ti, si(vi)) ? gi : xi;
              };
            })
          ),
          /***/
          6343: (
            /***/
            ((ai, li, oi) => {
              var si = oi(6880);
              ai.exports = si;
            })
          ),
          /***/
          7852: (
            /***/
            ((ai, li, oi) => {
              var si = oi(4507);
              ai.exports = si;
            })
          ),
          /***/
          1618: (
            /***/
            ((ai, li, oi) => {
              oi(2560);
              var si = oi(3948), di = oi(9724), fi = oi(8280), gi = oi(1374), mi = Array.prototype, Ti = {
                DOMTokenList: !0,
                NodeList: !0
              };
              ai.exports = function(vi) {
                var xi = vi.keys;
                return vi === mi || fi(mi, vi) && xi === mi.keys || di(Ti, si(vi)) ? gi : xi;
              };
            })
          ),
          /***/
          8894: (
            /***/
            ((ai, li, oi) => {
              var si = oi(9299);
              ai.exports = si;
            })
          ),
          /***/
          3266: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8685);
              ai.exports = si;
            })
          ),
          /***/
          9528: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8823);
              ai.exports = si;
            })
          ),
          /***/
          4106: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8059);
              ai.exports = si;
            })
          ),
          /***/
          6686: (
            /***/
            ((ai, li, oi) => {
              var si = oi(303);
              ai.exports = si;
            })
          ),
          /***/
          26: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5029);
              ai.exports = si;
            })
          ),
          /***/
          4598: (
            /***/
            ((ai, li, oi) => {
              var si = oi(3423);
              ai.exports = si;
            })
          ),
          /***/
          3658: (
            /***/
            ((ai, li, oi) => {
              var si = oi(149);
              ai.exports = si;
            })
          ),
          /***/
          9703: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8970);
              ai.exports = si;
            })
          ),
          /***/
          8251: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1926);
              ai.exports = si;
            })
          ),
          /***/
          4532: (
            /***/
            ((ai, li, oi) => {
              var si = oi(30);
              ai.exports = si;
            })
          ),
          /***/
          6513: (
            /***/
            ((ai, li, oi) => {
              var si = oi(5092);
              ai.exports = si;
            })
          ),
          /***/
          3220: (
            /***/
            ((ai, li, oi) => {
              var si = oi(9147);
              ai.exports = si;
            })
          ),
          /***/
          9563: (
            /***/
            ((ai, li, oi) => {
              var si = oi(4776);
              ai.exports = si;
            })
          ),
          /***/
          9261: (
            /***/
            ((ai, li, oi) => {
              var si = oi(6286);
              ai.exports = si;
            })
          ),
          /***/
          6490: (
            /***/
            ((ai, li, oi) => {
              var si = oi(9661);
              ai.exports = si;
            })
          ),
          /***/
          7777: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1418);
              ai.exports = si;
            })
          ),
          /***/
          5980: (
            /***/
            ((ai, li, oi) => {
              var si = oi(8699);
              ai.exports = si;
            })
          ),
          /***/
          1921: (
            /***/
            ((ai, li, oi) => {
              var si = oi(4326);
              ai.exports = si;
            })
          ),
          /***/
          5204: (
            /***/
            ((ai, li, oi) => {
              var si = oi(7027);
              oi(2560), ai.exports = si;
            })
          ),
          /***/
          5177: (
            /***/
            ((ai, li, oi) => {
              var si = oi(6098);
              ai.exports = si;
            })
          ),
          /***/
          9416: (
            /***/
            ((ai, li, oi) => {
              var si = oi(655);
              ai.exports = si;
            })
          ),
          /***/
          4674: (
            /***/
            ((ai, li, oi) => {
              oi(3342);
              var si = oi(2046);
              ai.exports = si.setInterval;
            })
          ),
          /***/
          568: (
            /***/
            ((ai, li, oi) => {
              oi(3342);
              var si = oi(2046);
              ai.exports = si.setTimeout;
            })
          ),
          /***/
          4139: (
            /***/
            ((ai, li, oi) => {
              var si = oi(3842);
              oi(2560), ai.exports = si;
            })
          ),
          /***/
          7045: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1730);
              oi(2560), ai.exports = si;
            })
          ),
          /***/
          70: (
            /***/
            ((ai, li, oi) => {
              var si = oi(1661);
              ai.exports = si;
            })
          ),
          /***/
          9792: (
            /***/
            ((ai, li, oi) => {
              var si = oi(6908);
              ai.exports = si;
            })
          ),
          /***/
          9428: (
            /***/
            ((ai, li, oi) => {
              var si = oi(7173);
              oi(2560), ai.exports = si;
            })
          ),
          /***/
          4062: (
            /***/
            ((ai, li, oi) => {
              var si = oi(7499);
              oi(2560), ai.exports = si;
            })
          ),
          /***/
          9076: (
            /***/
            ((ai, li, oi) => {
              oi(6299), oi(5042), oi(7649), oi(3604);
              var si = oi(2046);
              ai.exports = si.URLSearchParams;
            })
          ),
          /***/
          6908: (
            /***/
            ((ai, li, oi) => {
              oi(9076), oi(3487), oi(8669), oi(8670), oi(4783);
              var si = oi(2046);
              ai.exports = si.URL;
            })
          ),
          /***/
          8330: (
            /***/
            ((ai) => {
              ai.exports = /* @__PURE__ */ JSON.parse(`{"name":"@skylineos/clsp-player","title":"Skyline CLSP Player","version":"0.23.15","description":"Skyline Technology Solutions' CLSP Video Player.  Stream video in near-real-time in modern browsers.","keywords":["html5","clsp","video","player","skyline"],"license":"MIT","repository":"https://github.com/skylineos/clsp-player.git","main":"dist/clsp-player.min.js","scripts":{"build":"./scripts/build/build.sh","serve":"./scripts/serve/serve.sh","lint":"eslint .","lint-fix":"eslint . --fix","prepack":"NODE_ENV=production yarn run build","postpack":"./scripts/build/pre-build.sh","preversion":"./scripts/version.sh --pre","version":"./scripts/version.sh","postversion":"./scripts/version.sh --post","test:jest":"jest && ./test/jest/scripts/echo-coverage-hyperlink.sh","test":"yarn run test:jest","test:dev":"jest --coverage=false","test:watch":"yarn run test:dev --watch","test:wdio":"start-server-and-test serve http://localhost:8080 wdio","validate:ts":"tsc index.d.ts","wdio":"wdio run wdio.conf.js"},"dependencies":{"@babel/runtime-corejs3":"7.26.10","eventemitter3":"4.0.7","interval-promise":"1.4.0","lodash":"4.17.21","paho-mqtt":"1.1.0","promise-timeout":"1.3.0","sleepjs":"4.0.2","srcdoc-polyfill":"1.0.0","url":"0.11.0","uuid":"8.3.0"},"devDependencies":{"@babel/core":"^7.26.10","@babel/eslint-parser":"^7.26.0","@babel/eslint-plugin":"^7.26.0","@babel/plugin-transform-class-properties":"7.25.9","@babel/plugin-transform-object-rest-spread":"7.25.9","@babel/plugin-transform-runtime":"^7.26.0","@babel/preset-env":"^7.26.0","@babel/register":"^7.16.5","@eslint/eslintrc":"^3.3.0","@eslint/js":"^9.22.0","@wdio/cli":"^9.12.1","@wdio/local-runner":"^9.12.1","@wdio/mocha-framework":"^9.12.1","@wdio/spec-reporter":"^9.11.0","babel-loader":"^9.2.1","chalk":"4.1.0","chromedriver":"^134.0.0","css-loader":"7.1.2","eslint":"^9.17.0","eslint-config-standard":"^17.1.0","eslint-plugin-import":"2.31.0","eslint-plugin-jest":"28.11.0","eslint-plugin-n":"^17.16.2","eslint-plugin-node":"11.1.0","eslint-plugin-promise":"7.2.1","globals":"^16.0.0","humanize":"0.0.9","jest":"29.7.0","jest-environment-jsdom":"^29.7.0","jest-extended":"4.0.2","jest-mock-console":"2.0.0","jquery":"3.5.1","mini-css-extract-plugin":"2.7.6","moment":"2.29.4","progress-bar-webpack-plugin":"2.1.0","standard":"14.3.4","start-server-and-test":"^2.0.11","style-loader":"1.2.1","typescript":"4.0.3","url-loader":"4.1.0","wdio-chromedriver-service":"^8.1.1","webpack":"5.95.0","webpack-bundle-analyzer":"4.10.0","webpack-dev-server":"5.2.0","write-file-webpack-plugin":"4.5.1"},"packageManager":"yarn@1.22.22+sha512.a6b2f7906b721bba3d67d4aff083df04dad64c399707841b7acf00f6b133b7ac24255f2652fa22ae3534329dc6180534e98d17432037ff6fd140556e2bb3137e"}`);
            })
          )
          /******/
        }, ti = {};
        function ii(ai) {
          var li = ti[ai];
          if (li !== void 0)
            return li.exports;
          var oi = ti[ai] = {
            /******/
            id: ai,
            /******/
            loaded: !1,
            /******/
            exports: {}
            /******/
          };
          return ir[ai].call(oi.exports, oi, oi.exports, ii), oi.loaded = !0, oi.exports;
        }
        ii.n = (ai) => {
          var li = ai && ai.__esModule ? (
            /******/
            () => ai.default
          ) : (
            /******/
            () => ai
          );
          return ii.d(li, { a: li }), li;
        }, ii.d = (ai, li) => {
          for (var oi in li)
            ii.o(li, oi) && !ii.o(ai, oi) && Object.defineProperty(ai, oi, { enumerable: !0, get: li[oi] });
        }, ii.g = (function() {
          if (typeof globalThis == "object") return globalThis;
          try {
            return this || new Function("return this")();
          } catch {
            if (typeof window == "object") return window;
          }
        })(), ii.o = (ai, li) => Object.prototype.hasOwnProperty.call(ai, li), ii.r = (ai) => {
          typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(ai, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(ai, "__esModule", { value: !0 });
        }, ii.nmd = (ai) => (ai.paths = [], ai.children || (ai.children = []), ai);
        var ui = {};
        return (() => {
          ii.r(ui), ii.d(ui, {
            Iov: () => (
              /* reexport */
              eh
            ),
            IovCollection: () => (
              /* reexport */
              xg
            ),
            TourController: () => (
              /* reexport */
              $h
            ),
            utils: () => (
              /* reexport */
              ra()
            )
          }), ii(255);
          var ai = ii(2574), li = /* @__PURE__ */ ii.n(ai), oi = ii(7166);
          function si(Ua, oa, ya, ha, Aa, da, fa) {
            try {
              var gs = Ua[da](fa), Gs = gs.value;
            } catch (qs) {
              return void ya(qs);
            }
            gs.done ? oa(Gs) : oi.resolve(Gs).then(ha, Aa);
          }
          function di(Ua) {
            return function() {
              var oa = this, ya = arguments;
              return new oi(function(ha, Aa) {
                var da = Ua.apply(oa, ya);
                function fa(Gs) {
                  si(da, ha, Aa, fa, gs, "next", Gs);
                }
                function gs(Gs) {
                  si(da, ha, Aa, fa, gs, "throw", Gs);
                }
                fa(void 0);
              });
            };
          }
          function fi(Ua, oa) {
            if (!(Ua instanceof oa)) throw new TypeError("Cannot call a class as a function");
          }
          var gi = ii(4997), mi = ii(2321), Ti = ii(2231);
          function vi(Ua) {
            "@babel/helpers - typeof";
            return vi = typeof mi == "function" && typeof Ti == "symbol" ? function(oa) {
              return typeof oa;
            } : function(oa) {
              return oa && typeof mi == "function" && oa.constructor === mi && oa !== mi.prototype ? "symbol" : typeof oa;
            }, vi(Ua);
          }
          var xi = ii(9280);
          function Si(Ua, oa) {
            if (vi(Ua) != "object" || !Ua) return Ua;
            var ya = Ua[xi];
            if (ya !== void 0) {
              var ha = ya.call(Ua, oa);
              if (vi(ha) != "object") return ha;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return (oa === "string" ? String : Number)(Ua);
          }
          function Pi(Ua) {
            var oa = Si(Ua, "string");
            return vi(oa) == "symbol" ? oa : oa + "";
          }
          function $i(Ua, oa) {
            for (var ya = 0; ya < oa.length; ya++) {
              var ha = oa[ya];
              ha.enumerable = ha.enumerable || !1, ha.configurable = !0, "value" in ha && (ha.writable = !0), gi(Ua, Pi(ha.key), ha);
            }
          }
          function Oi(Ua, oa, ya) {
            return oa && $i(Ua.prototype, oa), ya && $i(Ua, ya), gi(Ua, "prototype", {
              writable: !1
            }), Ua;
          }
          function Di(Ua) {
            if (Ua === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return Ua;
          }
          function Mi(Ua, oa) {
            if (oa && (vi(oa) == "object" || typeof oa == "function")) return oa;
            if (oa !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
            return Di(Ua);
          }
          var Oo = ii(5363), io = ii(3375), xo = ii(7415);
          function fo(Ua) {
            var oa;
            return fo = Oo ? io(oa = xo).call(oa) : function(ya) {
              return ya.__proto__ || xo(ya);
            }, fo(Ua);
          }
          var _o = ii(1138), Li = ii(5983);
          function Co(Ua, oa) {
            for (; !{}.hasOwnProperty.call(Ua, oa) && (Ua = fo(Ua)) !== null; ) ;
            return Ua;
          }
          function Ni() {
            var Ua;
            return Ni = typeof Reflect < "u" && _o ? io(Ua = _o).call(Ua) : function(oa, ya, ha) {
              var Aa = Co(oa, ya);
              if (Aa) {
                var da = Li(Aa, ya);
                return da.get ? da.get.call(arguments.length < 3 ? oa : ha) : da.value;
              }
            }, Ni.apply(null, arguments);
          }
          var Yi = ii(7764);
          function Vo(Ua, oa) {
            var ya;
            return Vo = Oo ? io(ya = Oo).call(ya) : function(ha, Aa) {
              return ha.__proto__ = Aa, ha;
            }, Vo(Ua, oa);
          }
          function No(Ua, oa) {
            if (typeof oa != "function" && oa !== null) throw new TypeError("Super expression must either be null or a function");
            Ua.prototype = Yi(oa && oa.prototype, {
              constructor: {
                value: Ua,
                writable: !0,
                configurable: !0
              }
            }), gi(Ua, "prototype", {
              writable: !1
            }), oa && Vo(Ua, oa);
          }
          function Ui(Ua, oa, ya) {
            return (oa = Pi(oa)) in Ua ? gi(Ua, oa, {
              value: ya,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : Ua[oa] = ya, Ua;
          }
          var jo = ii(1240), Wi = /* @__PURE__ */ ii.n(jo), ji = ii(7169), Hi = /* @__PURE__ */ ii.n(ji), zo = ii(2472), Lo = /* @__PURE__ */ ii.n(zo), sa = ii(4828), Ko = /* @__PURE__ */ ii.n(sa), ca = ii(4224), pa = ii(9843), ga = /* @__PURE__ */ ii.n(pa), ia = ii(8192), ra = /* @__PURE__ */ ii.n(ia), qo = ii(7119), xa = /* @__PURE__ */ ii.n(qo), $a = ii(8628), ys = /* @__PURE__ */ ii.n($a), Ss = ii(228), Xa = /* @__PURE__ */ ii.n(Ss), Es = ii(1393), Rs = /* @__PURE__ */ ii.n(Es), La = ii(909), Ja = /* @__PURE__ */ ii.n(La), ja = /* @__PURE__ */ (function() {
            function Ua(oa) {
              var ya;
              if (fi(this, Ua), Ui(this, "logId", null), Ui(this, "isDestroyed", !1), Ui(this, "isDestroyComplete", !1), !oa)
                throw new Error("Logging options are required");
              if (typeof oa == "object" && (this.logId = oa.id, this.logColor = oa.color), typeof oa == "string" && (this.logId = oa), !this.logId)
                throw new Error("`logId` is required to construct a new ".concat(this.constructor.name));
              this.logColor || (this.logColor = "black"), this.logger = Ja()(ra().version).factory(Rs()(ya = "".concat(this.constructor.name, " ")).call(ya, this.logId), "color: ".concat(this.logColor, ";")), this.logger.info("Constructing new ".concat(this.constructor.name, " instance"));
            }
            return Oi(Ua, [{
              key: "_reset",
              value: (function() {
                var oa = di(/* @__PURE__ */ Ko().mark(function ha() {
                  return Ko().wrap(function(da) {
                    for (; ; ) switch (da.prev = da.next) {
                      case 0:
                      case "end":
                        return da.stop();
                    }
                  }, ha);
                }));
                function ya() {
                  return oa.apply(this, arguments);
                }
                return ya;
              })()
            }, {
              key: "reset",
              value: (function() {
                var oa = di(/* @__PURE__ */ Ko().mark(function ha() {
                  return Ko().wrap(function(da) {
                    for (; ; ) switch (da.prev = da.next) {
                      case 0:
                        return this.logger.info("Resetting..."), this.isDestroyed = !1, this.isDestroyComplete = !1, da.next = 5, this._reset();
                      case 5:
                        this.logger.info("Reset complete");
                      case 6:
                      case "end":
                        return da.stop();
                    }
                  }, ha, this);
                }));
                function ya() {
                  return oa.apply(this, arguments);
                }
                return ya;
              })()
              /**
               * Put your class's destroy logic in this method.
               *
               * @todo - should this be private?
               */
            }, {
              key: "_destroy",
              value: (function() {
                var oa = di(/* @__PURE__ */ Ko().mark(function ha() {
                  return Ko().wrap(function(da) {
                    for (; ; ) switch (da.prev = da.next) {
                      case 0:
                      case "end":
                        return da.stop();
                    }
                  }, ha);
                }));
                function ya() {
                  return oa.apply(this, arguments);
                }
                return ya;
              })()
            }, {
              key: "destroy",
              value: (function() {
                var oa = di(/* @__PURE__ */ Ko().mark(function ha() {
                  return Ko().wrap(function(da) {
                    for (; ; ) switch (da.prev = da.next) {
                      case 0:
                        if (!this.isDestroyed) {
                          da.next = 3;
                          break;
                        }
                        return this.logger.info("Already destroyed"), da.abrupt("return");
                      case 3:
                        return this.isDestroyed = !0, this.logger.info("Destroying..."), da.next = 7, this._destroy();
                      case 7:
                        this.isDestroyComplete = !0, this.logger.info("Destroy complete");
                      case 9:
                      case "end":
                        return da.stop();
                    }
                  }, ha, this);
                }));
                function ya() {
                  return oa.apply(this, arguments);
                }
                return ya;
              })()
            }]);
          })();
          function Ta(Ua, oa, ya) {
            return oa = fo(oa), Mi(Ua, rs() ? li()(oa, ya || [], fo(Ua).constructor) : oa.apply(Ua, ya));
          }
          function rs() {
            try {
              var Ua = !Boolean.prototype.valueOf.call(li()(Boolean, [], function() {
              }));
            } catch {
            }
            return (rs = function() {
              return !!Ua;
            })();
          }
          function Qa(Ua, oa, ya, ha) {
            var Aa = Ni(fo(Ua.prototype), oa, ya);
            return 2 & ha && typeof Aa == "function" ? function(da) {
              return Aa.apply(ya, da);
            } : Aa;
          }
          var Cs = /* @__PURE__ */ (function(Ua) {
            function oa(ya) {
              var ha;
              return fi(this, oa), ha = Ta(this, oa, [ya]), Ui(ha, "events", null), ha.events = new (Xa())(), ha;
            }
            return No(oa, Ua), Oi(oa, [{
              key: "on",
              value: function(ha, Aa) {
                var da = xa()(this.constructor.events);
                if (!ys()(da).call(da, ha))
                  throw new Error('Unable to register listener for unknown event "'.concat(ha, '"'));
                if (!Aa)
                  throw new Error('Unable to register for event "'.concat(ha, '" without a handler'));
                return this.isDestroyed ? (this.logger.error('Tried to register handler for event "'.concat(ha, '" while destroyed!')), this) : (this.events.on(ha, Aa), this);
              }
              // @todo - should this be a private field?
            }, {
              key: "emit",
              value: function(ha, Aa) {
                if (this.isDestroyed) {
                  this.logger.error('Tried to emit "'.concat(ha, '" while destroyed!'));
                  return;
                }
                this.events.emit(ha, Aa);
              }
            }, {
              key: "_reset",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  return Ko().wrap(function(fa) {
                    for (; ; ) switch (fa.prev = fa.next) {
                      case 0:
                        return this.events = new (Xa())(), fa.next = 3, Qa(oa, "_reset", this, 3)([]);
                      case 3:
                      case "end":
                        return fa.stop();
                    }
                  }, Aa, this);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "_destroy",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  return Ko().wrap(function(fa) {
                    for (; ; ) switch (fa.prev = fa.next) {
                      case 0:
                        return this.events.removeAllListeners(), this.events = null, fa.next = 4, Qa(oa, "_destroy", this, 3)([]);
                      case 4:
                      case "end":
                        return fa.stop();
                    }
                  }, Aa, this);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }]);
          })(ja);
          Ui(Cs, "events", {});
          var _a = ii(4007), _s = /* @__PURE__ */ ii.n(_a), el = ii(8979), Ps = /* @__PURE__ */ ii.n(el), nl = ii(385), Vs = /* @__PURE__ */ ii.n(nl), es = ii(8079), Is = /* @__PURE__ */ ii.n(es), fl = ii(3363), sl = /* @__PURE__ */ ii.n(fl), Il = ii(6226), Vl = /* @__PURE__ */ ii.n(Il), Bl = ii(697), ql = /* @__PURE__ */ ii.n(Bl), xl = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), Ul = new Uint8Array(16);
          function Xl() {
            if (!xl)
              throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
            return xl(Ul);
          }
          const hu = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
          function Tu(Ua) {
            return typeof Ua == "string" && hu.test(Ua);
          }
          const Ku = Tu;
          for (var Wl = [], uu = 0; uu < 256; ++uu)
            Wl.push((uu + 256).toString(16).substr(1));
          function du(Ua) {
            var oa = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, ya = (Wl[Ua[oa + 0]] + Wl[Ua[oa + 1]] + Wl[Ua[oa + 2]] + Wl[Ua[oa + 3]] + "-" + Wl[Ua[oa + 4]] + Wl[Ua[oa + 5]] + "-" + Wl[Ua[oa + 6]] + Wl[Ua[oa + 7]] + "-" + Wl[Ua[oa + 8]] + Wl[Ua[oa + 9]] + "-" + Wl[Ua[oa + 10]] + Wl[Ua[oa + 11]] + Wl[Ua[oa + 12]] + Wl[Ua[oa + 13]] + Wl[Ua[oa + 14]] + Wl[Ua[oa + 15]]).toLowerCase();
            if (!Ku(ya))
              throw TypeError("Stringified UUID is invalid");
            return ya;
          }
          const za = du;
          function Ya(Ua, oa, ya) {
            Ua = Ua || {};
            var ha = Ua.random || (Ua.rng || Xl)();
            if (ha[6] = ha[6] & 15 | 64, ha[8] = ha[8] & 63 | 128, oa) {
              ya = ya || 0;
              for (var Aa = 0; Aa < 16; ++Aa)
                oa[ya + Aa] = ha[Aa];
              return oa;
            }
            return za(ha);
          }
          const Ws = Ya;
          function wl(Ua) {
            function oa(ya, ha, Aa, da, fa, gs) {
              oa.constructorArgumentsBouncer(
                ya,
                ha,
                Aa,
                da,
                fa,
                gs
              ), this.logId = ya;
              try {
                this.logger = gs.Logger.factory(`Router ${this.logId}`, "color: maroon;");
              } catch (Gs) {
                throw console.error(Gs), new Error("Error while constructing Logger!");
              }
              this.clientId = ha, this.host = Aa, this.port = da, this.useSSL = fa, this.logger.debug("Constructing..."), this.Reconnect = null;
              try {
                this.clspClient = new Ua.MQTT.Client(
                  this.host,
                  this.port,
                  "/mqtt",
                  this.clientId
                );
              } catch (Gs) {
                const qs = new Error("Error while constructing Paho Client!");
                throw this.logger.critical(qs), this.logger.critical(Gs), qs;
              }
              this.clspClient.onConnectionLost = this._onConnectionLost.bind(this), this.clspClient.onMessageArrived = this._onMessageArrived.bind(this), this.clspClient.onMessageDelivered = this._onMessageDelivered.bind(this), this.boundWindowMessageEventHandler = this._windowMessageEventHandler.bind(this), window.addEventListener(
                "message",
                this.boundWindowMessageEventHandler,
                !1
              ), this.CONNECTION_TIMEOUT = gs.CONNECTION_TIMEOUT, this.KEEP_ALIVE_INTERVAL = gs.KEEP_ALIVE_INTERVAL, this.PUBLISH_TIMEOUT = gs.PUBLISH_TIMEOUT, this.isDestroyed = !1, this.isDestroyComplete = !1;
            }
            return oa.constructorArgumentsBouncer = function(ya, ha, Aa, da, fa, gs) {
              if (typeof Ua != "object")
                throw new Error("Paho is required to construct a Router");
              if (typeof Ua.MQTT != "object")
                throw new Error("Paho.MQTT is required to construct a Router");
              if (typeof Ua.MQTT.Client != "function")
                throw new Error("Paho.MQTT.Client is required to construct a Router");
              if (typeof Ua.MQTT.Message != "function")
                throw new Error("Paho.MQTT.Message is required to construct a Router");
              if (ya === void 0)
                throw new Error("`logId` is required to construct a Router");
              if (ha === void 0)
                throw new Error("`clientId` is required to construct a Router");
              if (Aa === void 0)
                throw new Error("`host` is required to construct a Router");
              if (da === void 0)
                throw new Error("`port` is required to construct a Router");
              if (fa === void 0)
                throw new Error("`useSSL` is required to construct a Router");
              if (typeof gs != "object")
                throw new Error("`options` is required to construct a Router");
              if (gs.Logger === void 0)
                throw new Error("`options.Logger` is required to construct a Router");
              if (gs.CONNECTION_TIMEOUT === void 0)
                throw new Error("`options.CONNECTION_TIMEOUT` is required to construct a Router");
              if (gs.KEEP_ALIVE_INTERVAL === void 0)
                throw new Error("`options.KEEP_ALIVE_INTERVAL` is required to construct a Router");
              if (gs.PUBLISH_TIMEOUT === void 0)
                throw new Error("`options.PUBLISH_TIMEOUT` is required to construct a Router");
            }, oa.pahoErrorCodes = {
              NOT_CONNECTED: "AMQJS0011E",
              ALREADY_CONNECTED: "AMQJS0011E"
            }, oa.events = {
              // Triggered when the Router is successfully instantiated.
              // Can only be triggered at time of router instantiation.
              CREATE_SUCCESS: "clsp_router_create_success",
              // Triggered when there is an error during Router instantiation.
              // Can only be triggered at time of router instantiation.
              CREATE_FAILURE: "clsp_router_create_failure",
              // Triggered when the connection to the CLSP server is established.
              // Can only be triggered at time of connection.
              CONNECT_SUCCESS: "clsp_router_connect_success",
              // Triggered when trying to connect to the CLSP server fails.
              // Can only be triggered at time of connection.
              CONNECT_FAILURE: "clsp_router_connect_failure",
              // Triggered when the connection to the CLSP server has been established, but is later lost.
              // Can be triggered for as long as the connection is open.
              CONNECTION_LOST: "clsp_router_connection_lost",
              // Triggered when the connection to the CLSP server is terminated normally.
              // Can only be triggered at time of disconnection.
              DISCONNECT_SUCCESS: "clsp_router_disconnect_success",
              DISCONNECT_FAILURE: "clsp_router_disconnect_failure",
              // Triggered when a message is successfully published to the server
              // Can only be triggered on publish
              PUBLISH_SUCCESS: "clsp_router_publish_success",
              // Triggered when a message fails to be published to the server
              // Can only be triggered on publish
              PUBLISH_FAILURE: "clsp_router_publish_failure",
              // Triggered when trying to subscribe to a topic fails.
              // Can only be triggered when a subscribe is attempted.
              SUBSCRIBE_FAILURE: "clsp_router_subscribe_failure",
              // When successfully unsubscribed from a topic
              // Can only be triggered when an unsubscribe is attempted.
              UNSUBSCRIBE_SUCCESS: "clsp_router_unsubscribe_success",
              // When trying to unsubscribe from a topic fails.
              // Can only be triggered when an unsubscribe is attempted.
              UNSUBSCRIBE_FAILURE: "clsp_router_unsubscribe_failure",
              // Triggered when a segment / moof is transmitted.
              // Can be triggered for as long as the connection is open.
              MESSAGE_ARRIVED: "clsp_router_message_arrived",
              // Triggered when an error is encountered while processing window messages.
              // Can be triggered any time.
              WINDOW_MESSAGE_FAIL: "clsp_router_window_message_fail"
            }, oa.commands = {
              CONNECT: "connect",
              DISCONNECT: "disconnect",
              PUBLISH: "publish",
              SUBSCRIBE: "subscribe",
              UNSUBSCRIBE: "unsubscribe",
              SEND: "send"
            }, oa.factory = function(ya, ha, Aa, da, fa, gs) {
              return new oa(
                ya,
                ha,
                Aa,
                da,
                fa,
                gs
              );
            }, oa.prototype._sendToParentWindow = function(ya) {
              if (this.logger.debug("Sending message to parent window..."), !this.isDestroyed) {
                if (typeof ya != "object")
                  throw new Error("_sendToParentWindow must be passed an object");
                switch (ya.clientId = this.clientId, ya.event) {
                  case oa.events.CREATE_SUCCESS:
                  case oa.events.CONNECT_SUCCESS:
                  case oa.events.DISCONNECT_SUCCESS:
                    break;
                  case oa.events.MESSAGE_ARRIVED: {
                    if (!Object.prototype.hasOwnProperty.call(ya, "destinationName") || !Object.prototype.hasOwnProperty.call(ya, "payloadString") || !Object.prototype.hasOwnProperty.call(ya, "payloadBytes"))
                      throw new Error('improperly formatted "data" message sent to _sendToParentWindow');
                    break;
                  }
                  case oa.events.UNSUBSCRIBE_SUCCESS: {
                    if (!Object.prototype.hasOwnProperty.call(ya, "event") || !Object.prototype.hasOwnProperty.call(ya, "topic") || !Object.prototype.hasOwnProperty.call(ya, "response"))
                      throw new Error('improperly formatted "unsubscribe success" message sent to _sendToParentWindow');
                    break;
                  }
                  case oa.events.CONNECT_FAILURE:
                  case oa.events.CONNECTION_LOST:
                  case oa.events.SUBSCRIBE_FAILURE:
                  case oa.events.UNSUBSCRIBE_FAILURE:
                  case oa.events.WINDOW_MESSAGE_FAIL: {
                    if (!Object.prototype.hasOwnProperty.call(ya, "reason"))
                      throw new Error('improperly formatted "fail" message sent to _sendToParentWindow');
                    break;
                  }
                  case oa.events.PUBLISH_SUCCESS: {
                    if (!ya.publishId)
                      throw new Error("publish message must contain a publishId");
                    if (!ya.topic)
                      throw new Error("publish message must contain a topic");
                    break;
                  }
                  case oa.events.PUBLISH_FAILURE: {
                    if (!ya.publishId)
                      throw new Error("publish message must contain a publishId");
                    if (!Object.prototype.hasOwnProperty.call(ya, "reason"))
                      throw new Error('improperly formatted "fail" message sent to _sendToParentWindow');
                    break;
                  }
                  default:
                    throw new Error("Unknown event " + ya.event + " sent to _sendToParentWindow");
                }
                try {
                  window.parent.postMessage(ya, "*");
                } catch (ha) {
                  console.error(ha);
                }
              }
            }, oa.prototype._onMessageArrived = function(ya) {
              this.logger.debug("Received CLSP message...");
              try {
                let ha = "";
                try {
                  ha = ya.payloadString;
                } catch {
                }
                this._sendToParentWindow({
                  event: oa.events.MESSAGE_ARRIVED,
                  destinationName: ya.destinationName,
                  payloadString: ha,
                  // @todo - why is this necessary when it doesn't exist?
                  payloadBytes: ya.payloadBytes || null
                });
              } catch (ha) {
                this.logger.error(ha);
              }
            }, oa.prototype._onMessageDelivered = function(ya) {
              this.logger.debug("Delivered CLSP message..."), ya._onDelivered && ya._onDelivered();
            }, oa.prototype._onCommandReceived = function(ya, ha, Aa) {
              switch (ya) {
                case oa.commands.SUBSCRIBE: {
                  this._subscribe(ha.topic);
                  break;
                }
                case oa.commands.UNSUBSCRIBE: {
                  this._unsubscribe(ha.topic);
                  break;
                }
                case oa.commands.PUBLISH: {
                  let da = null;
                  try {
                    da = JSON.stringify(ha.data);
                  } catch {
                    this.logger.error('ERROR: Unable to handle the "publish" window message event!'), this.logger.error("json stringify error: " + ha.data);
                    return;
                  }
                  this._publish(
                    ha.publishId,
                    ha.topic,
                    da
                  );
                  break;
                }
                case oa.commands.CONNECT: {
                  this.connect();
                  break;
                }
                case oa.commands.DISCONNECT: {
                  this.disconnect();
                  break;
                }
                case oa.commands.SEND: {
                  this._publish(
                    ha.publishId,
                    ha.topic,
                    ha.byteArray
                  );
                  break;
                }
                default:
                  this.logger.error('Unknown Command: "' + ya + '"');
              }
            }, oa.prototype._windowMessageEventHandler = function(ya) {
              const ha = ya.data;
              if (!ha)
                return;
              const Aa = ha.method;
              if (Aa) {
                this.logger.debug('Handling incoming window message for "' + Aa + '"...');
                try {
                  this._onCommandReceived(Aa, ha, ya);
                } catch (da) {
                  this.logger.error(da), this._sendToParentWindow({
                    event: oa.events.WINDOW_MESSAGE_FAIL,
                    reason: "window message event failure"
                  });
                }
              }
            }, oa.prototype._connect_onSuccess = function(ya) {
              this.logger.info("Successfully established CLSP connection"), this._sendToParentWindow({
                event: oa.events.CONNECT_SUCCESS
              });
            }, oa.prototype._connect_onFailure = function(ya) {
              this.logger.info("CLSP Connection Failure!"), this._sendToParentWindow({
                event: oa.events.CONNECT_FAILURE,
                reason: "Connection Failed - Error code " + parseInt(ya.errorCode) + ": " + ya.errorMessage
              });
            }, oa.prototype._onConnectionLost = function(ya, ha = {}) {
              this.logger.debug("CLSP connection lost");
              const Aa = parseInt(ya.errorCode);
              if (Aa === 0) {
                this._sendToParentWindow({
                  event: oa.events.DISCONNECT_SUCCESS,
                  data: ha
                });
                return;
              }
              this.logger.warn("CLSP connection lost improperly!"), this._sendToParentWindow({
                event: oa.events.CONNECTION_LOST,
                reason: 'connection lost error code "' + Aa + '" with message: ' + ya.errorMessage,
                data: ha
              });
            }, oa.prototype._connectionWasLost = function(ya) {
              this.logger.debug("CLSP Connection was lost while trying to perform another action");
              const ha = {
                errorCode: 0
              };
              this._onConnectionLost(ha, ya);
            }, oa.prototype._subscribe_onSuccess = function(ya, ha) {
              this.logger.debug('Successfully subscribed to topic "' + ya + '"');
            }, oa.prototype._subscribe_onFailure = function(ya, ha) {
              this.logger.error('Failed to subscribe to topic "' + ya + '"'), this._sendToParentWindow({
                event: oa.events.SUBSCRIBE_FAILURE,
                reason: "Subscribe Failed - Error code " + parseInt(ha.errorCode) + ": " + ha.errorMessage
              });
            }, oa.prototype._subscribe = function(ya) {
              if (this.logger.debug('Subscribing to topic "' + ya + '"'), !ya)
                throw new Error("topic is a required argument when subscribing");
              this.clspClient.subscribe(ya, {
                onSuccess: this._subscribe_onSuccess.bind(this, ya),
                onFailure: this._subscribe_onFailure.bind(this, ya)
              });
            }, oa.prototype._unsubscribe_onSuccess = function(ya, ha) {
              this.logger.info('Successfully unsubscribed from topic "' + ya + '"'), this._sendToParentWindow({
                event: oa.events.UNSUBSCRIBE_SUCCESS,
                topic: ya,
                response: ha
              });
            }, oa.prototype._unsubscribe_onFailure = function(ya, ha) {
              this.logger.warn('Failed to unsubscribe from topic "' + ya + '"'), this._sendToParentWindow({
                event: oa.events.UNSUBSCRIBE_FAILURE,
                reason: "Unsubscribe Failed - Error code " + parseInt(ha.errorCode) + ": " + ha.errorMessage
              });
            }, oa.prototype._unsubscribe = function(ya) {
              if (this.logger.info('Unsubscribing from topic "' + ya + '"'), !ya)
                throw new Error("topic is a required argument when unsubscribing");
              if (!this.clspClient.isConnected())
                return this._unsubscribe_onSuccess(ya);
              this.clspClient.unsubscribe(ya, {
                onSuccess: this._unsubscribe_onSuccess.bind(this, ya),
                onFailure: this._unsubscribe_onFailure.bind(this, ya)
              });
            }, oa.prototype._publish_onSuccess = function(ya, ha) {
              this.logger.info('Successfully published topic "' + ha + '" with id "' + ya + '"'), this._sendToParentWindow({
                event: oa.events.PUBLISH_SUCCESS,
                publishId: ya,
                topic: ha
              });
            }, oa.prototype._publish_onFailure = function(ya, ha, Aa) {
              this.logger.info('Successfully published topic "' + ha + '" with id "' + ya + '"'), this._sendToParentWindow({
                event: oa.events.PUBLISH_FAILURE,
                publishId: ya,
                reason: Aa
              });
            }, oa.prototype._publish = function(ya, ha, Aa) {
              if (this.logger.debug('Publishing to topic "' + ha + '"'), !Aa)
                throw new Error("payload is a required argument when publishing");
              if (!ha)
                throw new Error("topic is a required argument when publishing");
              if (!this.clspClient.isConnected())
                return this._publish_onSuccess(ya, ha);
              const da = this, fa = new Ua.MQTT.Message(Aa);
              fa.destinationName = ha;
              let gs = setTimeout(function() {
                clearTimeout(gs), gs = null;
                const Gs = 'publish operation for "' + ha + '" timed out after ' + da.PUBLISH_TIMEOUT + " seconds.";
                da._publish_onFailure(ya, ha, Gs);
              }, this.PUBLISH_TIMEOUT * 1e3);
              fa._onDelivered = function(Gs) {
                gs && (clearTimeout(gs), gs = null, da._publish_onSuccess(ya, ha));
              }, this.clspClient.publish(fa);
            }, oa.prototype.connect = function() {
              this.logger.info("Connecting...");
              const ya = new Ua.MQTT.Message(JSON.stringify({
                clientId: this.clientId
              }));
              ya.destinationName = "iov/clientDisconnect";
              const ha = {
                timeout: this.CONNECTION_TIMEOUT,
                keepAliveInterval: this.KEEP_ALIVE_INTERVAL,
                onSuccess: this._connect_onSuccess.bind(this),
                onFailure: this._connect_onFailure.bind(this),
                willMessage: ya
                // @todo - should `reconnect` be set here?
              };
              this.useSSL === !0 && (ha.useSSL = !0);
              try {
                this.clspClient.connect(ha), this.logger.info("Connected");
              } catch (Aa) {
                if (Aa.message.startsWith(oa.pahoErrorCodes.ALREADY_CONNECTED))
                  return;
                this.logger.error("Failed to connect", Aa), this._sendToParentWindow({
                  event: oa.events.CONNECT_FAILURE,
                  reason: "General error when trying to connect."
                });
              }
            }, oa.prototype.disconnect = function() {
              this.logger.info("Disconnecting");
              try {
                this.clspClient.isConnected() ? this.clspClient.disconnect() : this._connectionWasLost();
              } catch (ya) {
                if (ya.message.startsWith(oa.pahoErrorCodes.NOT_CONNECTED))
                  return;
                throw this.logger.error("ERROR while disconnecting"), this.logger.error(ya), ya;
              }
            }, oa.prototype.destroy = function() {
              this.logger.info("Destroying..."), !this.isDestroyed && (this.isDestroyed = !0, window.removeEventListener("message", this.boundWindowMessageEventHandler), this.boundWindowMessageEventHandler = null, this.disconnect(), this.clspClient = null, this.isDestroyComplete = !1, this.logger.info("destroy complete"));
            }, oa;
          }
          function Gl(Ua, oa, ya) {
            return oa = fo(oa), Mi(Ua, bl() ? li()(oa, ya || [], fo(Ua).constructor) : oa.apply(Ua, ya));
          }
          function bl() {
            try {
              var Ua = !Boolean.prototype.valueOf.call(li()(Boolean, [], function() {
              }));
            } catch {
            }
            return (bl = function() {
              return !!Ua;
            })();
          }
          var Za = wl(), rl = Za.commands, zs = Za.events, al = /* @__PURE__ */ (function(Ua) {
            function oa(ya, ha) {
              var Aa;
              if (fi(this, oa), Aa = Gl(this, oa, [ya]), !ya)
                throw new Error("logId is required to construct a new RouterStatsManager instance.");
              if (!ha)
                throw new Error("clientId is required to construct a new RouterStatsManager instance.");
              return Aa.logId = ya, Aa.clientId = ha, Aa;
            }
            return No(oa, Ua), Oi(oa);
          })(Cs);
          Ui(al, "routerCommands", rl), Ui(al, "routerEvents", zs);
          var Ol = ii(6255), $l = /* @__PURE__ */ ii.n(Ol), Zl = ii(7320), tu = ii(6100), su = /* @__PURE__ */ ii.n(tu), dl = ii(6319), Su = /* @__PURE__ */ ii.n(dl), cu = ii(8928), Ru = /* @__PURE__ */ ii.n(cu), bu = ii(6751), Hu = /* @__PURE__ */ ii.n(bu), cc = ii(5110), Tl = /* @__PURE__ */ ii.n(cc), Yl = ii(1549), Dl = /* @__PURE__ */ ii.n(Yl);
          function Cl() {
            return {
              /**
               * The `onload` event handler for the `<body> onload` event.  This event
               * handler will instantiate the Router.
               *
               * On success or failure, a message will be sent to the parent window to
               * indicate success or failure.
               *
               * @param {string} logId
               *   a string that identifies this Conduit / Router in log messages
               * @param {class} Router
               *   The Router class
               * @param {object} config
               *   An object containing all necessary Router config options
               *
               * @returns {Router|null}
               *   The instantiated router, or `null` if an error is encountered
               */
              onload: function(Ua, oa, ya, ha) {
                try {
                  const Aa = ya.factory(
                    ha.logId,
                    ha.clientId,
                    ha.host,
                    ha.port,
                    ha.useSSL,
                    {
                      CONNECTION_TIMEOUT: ha.CONNECTION_TIMEOUT,
                      KEEP_ALIVE_INTERVAL: ha.KEEP_ALIVE_INTERVAL,
                      PUBLISH_TIMEOUT: ha.PUBLISH_TIMEOUT,
                      Logger: ha.Logger
                    }
                  );
                  return Aa._sendToParentWindow({
                    event: ya.events.CREATE_SUCCESS
                  }), Aa.logger.info(Ua + " onload - Router created"), Aa;
                } catch (Aa) {
                  return console.error(Ua + " onload - Error while loading:"), console.error(Aa), window.parent.postMessage({
                    event: ya.events.CREATE_FAILURE,
                    reason: Aa
                  }, "*"), null;
                }
              },
              /**
               * The `onunload` event handler for the `<body> onunload` event.  This
               * event handler will destroy this iframe's Router if it exists.
               *
               * @param {string} logId
               *   a string that identifies this Conduit / Router in log messages
               * @param {Router} router
               *   The router that was instantiated for this iframe
               *
               * @returns {void}
               */
              onunload: function(Ua, oa, ya) {
                if (!ya) {
                  console.warn(Ua + " onunload - Router not instantiated, exiting...");
                  return;
                }
                try {
                  ya.logger.info(Ua + " onunload - Router being destroyed in onunload..."), ya.destroy(), ya.logger.info(Ua + " onunload - Router destroyed in onunload");
                } catch (ha) {
                  ya.logger.error(Ua + " onunload - Error while unloading:"), ya.logger.error(ha);
                }
              }
            };
          }
          var Hl = ii(1564);
          function Gu(Ua, oa) {
            (oa == null || oa > Ua.length) && (oa = Ua.length);
            for (var ya = 0, ha = Array(oa); ya < oa; ya++) ha[ya] = Ua[ya];
            return ha;
          }
          function xu(Ua) {
            if (Hl(Ua)) return Gu(Ua);
          }
          var ac = ii(9029), hc = ii(8980);
          function mc(Ua) {
            if (typeof mi < "u" && ac(Ua) != null || Ua["@@iterator"] != null) return hc(Ua);
          }
          var jc = ii(4908);
          function iu(Ua, oa) {
            if (Ua) {
              var ya;
              if (typeof Ua == "string") return Gu(Ua, oa);
              var ha = jc(ya = {}.toString.call(Ua)).call(ya, 8, -1);
              return ha === "Object" && Ua.constructor && (ha = Ua.constructor.name), ha === "Map" || ha === "Set" ? hc(Ua) : ha === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ha) ? Gu(Ua, oa) : void 0;
            }
          }
          function yc() {
            throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
          }
          function Mu(Ua) {
            return xu(Ua) || mc(Ua) || iu(Ua) || yc();
          }
          var sc = ii(6586), wc = /* @__PURE__ */ ii.n(sc), Wc = ii(8835);
          function Xu(Ua, oa) {
            var ya = ql()(Ua);
            if (su()) {
              var ha = su()(Ua);
              oa && (ha = Su()(ha).call(ha, function(Aa) {
                return Ru()(Ua, Aa).enumerable;
              })), ya.push.apply(ya, ha);
            }
            return ya;
          }
          function fd(Ua) {
            for (var oa = 1; oa < arguments.length; oa++) {
              var ya, ha, Aa = arguments[oa] != null ? arguments[oa] : {};
              oa % 2 ? Vl()(ya = Xu(Object(Aa), !0)).call(ya, function(da) {
                Ui(Ua, da, Aa[da]);
              }) : Hu() ? Tl()(Ua, Hu()(Aa)) : Vl()(ha = Xu(Object(Aa))).call(ha, function(da) {
                Dl()(Ua, da, Ru()(Aa, da));
              });
            }
            return Ua;
          }
          var rd = /* @__PURE__ */ (function() {
            function Ua(oa, ya, ha, Aa) {
              var da = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
              if (fi(this, Ua), !oa)
                throw new Error("streamName is required to create a stream configuration.");
              if (!ya)
                throw new Error("host is required to create a stream configuration.");
              if (!ha)
                throw new Error("port is required to create a stream configuration.");
              if (!Aa && Aa !== !1)
                throw new Error("useSSL is required to create a stream configuration.");
              if (!da || typeof da != "object")
                throw new Error("tokenConfig is required to create a stream configuration.");
              this.streamName = oa, this.host = ya, this.port = ha, this.useSSL = Aa, this.tokenConfig = da, this.isDestroyed = !1, this.isDestroyComplete = !1;
            }
            return Oi(Ua, [{
              key: "clone",
              value: function(ya) {
                if (!Ua.isStreamConfiguration(ya))
                  throw new Error("Cannot clone with invalid streamConfiguration");
                var ha = Ua.factory.apply(Ua, Mu(ya.toObject()));
                return ha;
              }
            }, {
              key: "toObject",
              value: function() {
                return {
                  streamName: this.streamName,
                  host: this.host,
                  port: this.port,
                  useSSL: this.useSSL,
                  tokenConfig: fd({}, this.tokenConfig)
                };
              }
            }, {
              key: "protocol",
              get: function() {
                return this.useSSL ? "clsps" : "clsp";
              }
            }, {
              key: "url",
              get: function() {
                var ya, ha, Aa;
                return Rs()(ya = Rs()(ha = Rs()(Aa = "".concat(this.protocol, "://")).call(Aa, this.host, ":")).call(ha, this.port, "/")).call(ya, this.streamName);
              }
            }, {
              key: "destroy",
              value: function() {
                this.isDestroyed || (this.isDestroyed = !0, this.streamName = null, this.host = null, this.port = null, this.useSSL = null, this.tokenConfig = null, this.isDestroyComplete = !1, this.logger.info("destroy complete"));
              }
            }], [{
              key: "factory",
              value: function(ya, ha, Aa, da, fa) {
                return new Ua(ya, ha, Aa, da, fa);
              }
            }, {
              key: "fromObject",
              value: function(ya) {
                if (!ya || typeof ya != "object")
                  throw new Error("config must be an object to create a streamConfiguration");
                return Ua.factory(ya.streamName, ya.host, ya.port, ya.useSSL, fd({}, ya.tokenConfig));
              }
            }, {
              key: "isStreamConfiguration",
              value: function(ya) {
                return ya instanceof Ua;
              }
            }, {
              key: "generateConfigFromUrl",
              value: function(ya) {
                if (!ya)
                  throw new Error("No source was given to be parsed!");
                var ha = Wc.parse(ya), Aa, da, fa = "", gs = "";
                if (ha.protocol = ha.protocol.toLowerCase(), ha.protocol === "clsps:")
                  Aa = !0, da = ra().getDefaultStreamPort("clsps");
                else if (ha.protocol === "clsp:")
                  Aa = !1, da = ra().getDefaultStreamPort("clsp");
                else
                  throw new Error("The given source is not a clsp url, and therefore cannot be parsed.");
                var Gs = ha.pathname.split("/"), qs = Gs[Gs.length - 1], El = ha.hostname, kl = ha.port;
                (!kl || kl.length === 0) && (kl = da), kl = wc()(kl), El === "@" && (El = window.location.hostname);
                for (var ju = _s()(ya).call(ya, ha.pathname) + ha.pathname.length, Yu = ya.substr(ju).split("?")[1] || "", Lc = {}, Ed = Yu.split("&"), tc = 0; tc < Ed.length; tc++) {
                  var bc = Ed[tc].split("=");
                  Lc[decodeURIComponent(bc[0])] = decodeURIComponent(bc[1] || "");
                }
                if (typeof Lc.token < "u" && Lc.token.length > 0) {
                  var ud, qf, yd, Id, vu = Rs()(ud = Rs()(qf = Rs()(yd = Rs()(Id = "".concat(ha.protocol, "://")).call(Id, El, ":")).call(yd, kl, "/")).call(qf, qs, "?token=")).call(ud, Lc.token);
                  fa = window.btoa(vu), gs = Lc.token;
                }
                return {
                  streamName: qs,
                  host: El,
                  port: kl,
                  useSSL: Aa,
                  tokenConfig: {
                    b64HashAccessUrl: fa,
                    jwt: gs
                  }
                };
              }
            }, {
              key: "fromUrl",
              value: function(ya) {
                var ha = Ua.generateConfigFromUrl(ya);
                return Ua.fromObject(ha);
              }
            }]);
          })();
          function _c(Ua, oa) {
            var ya = ql()(Ua);
            if (su()) {
              var ha = su()(Ua);
              oa && (ha = Su()(ha).call(ha, function(Aa) {
                return Ru()(Ua, Aa).enumerable;
              })), ya.push.apply(ya, ha);
            }
            return ya;
          }
          function dh(Ua) {
            for (var oa = 1; oa < arguments.length; oa++) {
              var ya, ha, Aa = arguments[oa] != null ? arguments[oa] : {};
              oa % 2 ? Vl()(ya = _c(Object(Aa), !0)).call(ya, function(da) {
                Ui(Ua, da, Aa[da]);
              }) : Hu() ? Tl()(Ua, Hu()(Aa)) : Vl()(ha = _c(Object(Aa))).call(ha, function(da) {
                Dl()(Ua, da, Ru()(Aa, da));
              });
            }
            return Ua;
          }
          function Bd(Ua, oa, ya) {
            return oa = fo(oa), Mi(Ua, Jc() ? li()(oa, ya || [], fo(Ua).constructor) : oa.apply(Ua, ya));
          }
          function Jc() {
            try {
              var Ua = !Boolean.prototype.valueOf.call(li()(Boolean, [], function() {
              }));
            } catch {
            }
            return (Jc = function() {
              return !!Ua;
            })();
          }
          function ep(Ua, oa, ya, ha) {
            var Aa = Ni(fo(Ua.prototype), oa, ya);
            return 2 & ha && typeof Aa == "function" ? function(da) {
              return Aa.apply(ya, da);
            } : Aa;
          }
          var Mf = 120, Kh = 30, pd = ra().DEFAULT_STREAM_TIMEOUT, Cc = /* @__PURE__ */ (function(Ua) {
            function oa(ya, ha, Aa, da) {
              var fa;
              if (fi(this, oa), fa = Bd(this, oa, [ya, ha]), !rd.isStreamConfiguration(Aa))
                throw new Error("invalid streamConfiguration passed to Router Iframe Manager constructor");
              if (!da)
                throw new Error("containerElement is required to construct a new Router Iframe Manager instance");
              return fa.streamConfiguration = Aa, fa.containerElement = da, fa.iframe = null, fa.isCreated = !1, fa.hasIframeDestroyedExternallyEventBeenEmitted = !1, fa.ROUTER_CONNECTION_TIMEOUT = Mf, fa.ROUTER_KEEP_ALIVE_INTERVAL = Kh, fa.ROUTER_PUBLISH_TIMEOUT = pd, fa;
            }
            return No(oa, Ua), Oi(oa, [{
              key: "create",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  return Ko().wrap(function(fa) {
                    for (; ; ) switch (fa.prev = fa.next) {
                      case 0:
                        if (!this.isDestroyed) {
                          fa.next = 2;
                          break;
                        }
                        throw new Error("Tried to create a destroyed Router Iframe Manager!");
                      case 2:
                        if (!this.isCreated) {
                          fa.next = 5;
                          break;
                        }
                        return this.logger.warn("Router Iframe Manager already created..."), fa.abrupt("return");
                      case 5:
                        return this.logger.debug("Initializing..."), fa.prev = 6, fa.next = 9, (0, Zl.w)(this._create(), 2e3);
                      case 9:
                        this.logger.info("Router created successfully"), this.isCreated = !0, fa.next = 17;
                        break;
                      case 13:
                        fa.prev = 13, fa.t0 = fa.catch(6), this.logger.error("Failed to create the Iframe/Router!"), this.logger.error(fa.t0);
                      case 17:
                      case "end":
                        return fa.stop();
                    }
                  }, Aa, this, [[6, 13]]);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "_create",
              value: function() {
                var ha = this;
                return new (Wi())(function(Aa, da) {
                  ha._onRouterCreated = function(fa) {
                    if (fa)
                      return da(fa);
                    Aa();
                  }, ha.iframe = ha._generateIframe(), ha.containerElement.appendChild(ha.iframe);
                });
              }
            }, {
              key: "_handleRouterCreatedEvent",
              value: function(ha, Aa) {
                if (this.isDestroyed)
                  throw new Error("Tried to create a Router for a destroyed Router Iframe Manager!");
                if (!this._onRouterCreated)
                  throw new Error("Tried to create Router prior to initialization!");
                if (this.isCreated)
                  throw new Error("Tried to create Router after initialization!");
                switch (ha) {
                  case oa.routerEvents.CREATE_SUCCESS: {
                    this._onRouterCreated();
                    break;
                  }
                  case oa.routerEvents.CREATE_FAILURE: {
                    this._onRouterCreated(new Error(Aa.data.reason));
                    break;
                  }
                  default:
                    throw new Error("Unknown eventType: ".concat(ha));
                }
              }
              /**
               * @private
               *
               * Generate an iframe with an embedded CLSP Router.
               *
               * @returns Element
               */
            }, {
              key: "_generateIframe",
              value: function() {
                var ha, Aa, da, fa, gs, Gs, qs, El, kl, ju, Yu, Lc, Ed, tc, bc;
                this.logger.debug("Generating Iframe...");
                var ud = document.createElement("iframe");
                return ud.setAttribute("id", this.clientId), ud.width = 0, ud.height = 0, ud.setAttribute("style", "display:none;"), ud.srcdoc = Rs()(ha = Rs()(Aa = Rs()(da = Rs()(fa = Rs()(gs = Rs()(Gs = Rs()(qs = Rs()(El = Rs()(kl = Rs()(ju = Rs()(Yu = Rs()(Lc = Rs()(Ed = Rs()(tc = Rs()(bc = `
      <html>
        <head>
          <script type="text/javascript">

            // Configure the CLSP properties
            window.clspRouterConfig = {
              logId: '`.concat(this.logId, `',
              clientId: '`)).call(bc, this.clientId, `',
              host: '`)).call(tc, this.streamConfiguration.host, `',
              port: `)).call(Ed, this.streamConfiguration.port, `,
              useSSL: `)).call(Lc, this.streamConfiguration.useSSL, `,
              CONNECTION_TIMEOUT: `)).call(Yu, this.ROUTER_CONNECTION_TIMEOUT, `,
              KEEP_ALIVE_INTERVAL: `)).call(ju, this.ROUTER_KEEP_ALIVE_INTERVAL, `,
              PUBLISH_TIMEOUT: `)).call(kl, this.ROUTER_PUBLISH_TIMEOUT, `,
              Logger: (`)).call(El, Ja().toString(), ')("')).call(qs, ra().version, `"),
            };

            window.Router = `)).call(Gs, wl.toString(), `(window.parent.Paho);
            window.iframeEventHandlers = `)).call(gs, Cl.toString(), `();
          <\/script>
        </head>
        <body
          onload="window.router = window.iframeEventHandlers.onload(
            '`)).call(fa, this.logId, `',
            '`)).call(da, this.clientId, `',
            window.Router,
            window.clspRouterConfig
          );"
          onunload="window.iframeEventHandlers.onunload(
            '`)).call(Aa, this.logId, `',
            '`)).call(ha, this.clientId, `',
            window.router
          );"
        >
          <div id="message"></div>
        </body>
      </html>
    `), ud;
              }
            }, {
              key: "wasIframeDestroyedExternally",
              value: function() {
                return !this.iframe.contentWindow;
              }
              /**
               * @private
               *
               * Pass a Router command to the iframe.  Should only ever be invoked in
               * response to a Router Manager command event.
               *
               * @param {Object} message
               *   The message / event data to send with the command
               */
            }, {
              key: "command",
              value: function(ha, Aa) {
                if (this.logger.debug("Sending a message to the iframe..."), this.isDestroyComplete) {
                  this.logger.warn("Cannot send message via destroyed iframe", ha, Aa);
                  return;
                }
                if (this.wasIframeDestroyedExternally()) {
                  if (this.isDestroyed) {
                    this.logger.info("Iframe was destroyed externally while in process of destroying");
                    return;
                  }
                  if (this.logger.info("Cannot process command because the iframe is destroyed."), this.hasIframeDestroyedExternallyEventBeenEmitted)
                    return;
                  this.hasIframeDestroyedExternallyEventBeenEmitted = !0, this.logger.info("Iframe destroyed externally!"), this.emit(oa.events.IFRAME_DESTROYED_EXTERNALLY);
                  return;
                }
                try {
                  var da = dh({
                    method: ha
                  }, Aa);
                  this.iframe.contentWindow.postMessage(da, "*");
                } catch (fa) {
                  this.logger.error("Failed while trying to execute command ".concat(fa)), this.logger.error(fa);
                }
              }
            }, {
              key: "_destroyIframe",
              value: function() {
                this.isDestroyComplete || (this.iframe.parentNode.removeChild(this.iframe), this.iframe.srcdoc = "", this.iframe = null);
              }
            }, {
              key: "_destroy",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  return Ko().wrap(function(fa) {
                    for (; ; ) switch (fa.prev = fa.next) {
                      case 0:
                        return this._destroyIframe(), this.streamConfiguration = null, this.containerElement = null, fa.next = 5, ep(oa, "_destroy", this, 3)([]);
                      case 5:
                      case "end":
                        return fa.stop();
                    }
                  }, Aa, this);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }], [{
              key: "factory",
              value: function(ha, Aa, da, fa) {
                return new oa(ha, Aa, da, fa);
              }
            }]);
          })(al);
          Ui(Cc, "events", {
            IFRAME_DESTROYED_EXTERNALLY: "iframe-destroyed-externally"
          }), Ui(Cc, "routerEvents", {
            CREATE_SUCCESS: al.routerEvents.CREATE_SUCCESS,
            CREATE_FAILURE: al.routerEvents.CREATE_FAILURE
          });
          function jf(Ua, oa, ya) {
            return oa = fo(oa), Mi(Ua, tp() ? li()(oa, ya || [], fo(Ua).constructor) : oa.apply(Ua, ya));
          }
          function tp() {
            try {
              var Ua = !Boolean.prototype.valueOf.call(li()(Boolean, [], function() {
              }));
            } catch {
            }
            return (tp = function() {
              return !!Ua;
            })();
          }
          function Fp(Ua, oa, ya, ha) {
            var Aa = Ni(fo(Ua.prototype), oa, ya);
            return 2 & ha && typeof Aa == "function" ? function(da) {
              return Aa.apply(ya, da);
            } : Aa;
          }
          var fh = 5, Qc = /* @__PURE__ */ (function(Ua) {
            function oa(ya, ha, Aa) {
              var da;
              if (fi(this, oa), da = jf(this, oa, [ya, ha, Aa]), !Aa)
                throw new Error("Tried to instantiate a RouterTransactionManager without a routerIframeManager!");
              return da.routerIframeManager = Aa, da.isHalting = !1, da.isHalted = !1, da.iframeWasDestroyedExternally = !1, da.publishHandlers = {}, da.pendingTransactions = {}, da.subscribeHandlers = {}, da.unsubscribeHandlers = {}, da.unsubscribesInProgress = {}, da.TRANSACTION_TIMEOUT = fh, da.routerIframeManager.on(Cc.events.IFRAME_DESTROYED_EXTERNALLY, function() {
                da.iframeWasDestroyedExternally = !0;
              }), da;
            }
            return No(oa, Ua), Oi(oa, [{
              key: "issueCommand",
              value: function(ha) {
                var Aa = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (this.isDestroyed) {
                  this.logger.warn('Cannot issue command "'.concat(ha, '" to Router after destruction'));
                  return;
                }
                this.logger.debug("Issuing command ".concat(ha, " to Router...")), this.routerIframeManager.command(ha, Aa);
              }
            }, {
              key: "_formatTransactionResponsePayload",
              value: function(ha) {
                var Aa = ha.payloadString;
                if (ha.payloadString)
                  try {
                    ha.payloadString = JSON.parse(Aa) || {};
                  } catch (da) {
                    this.logger.warn("Failed to parse payloadString"), this.logger.warn(da), ha.payloadString = Aa;
                  }
                return ha;
              }
              /**
               * Request
               *
               * When asking the server for something, we do not get a response right away.
               * Instead, we must perform the following steps:
               *
               * 1. generate a unique string, which will be sent to the server as the "response topic"
               * 1. subscribe
               *
               * @todo - this needs to be refactored to use PromiseTimeout
               *
               * @param {String} topic
               *   The topic to perform a transaction on
               * @param {Object} messageData
               *   The data to be published
               *
               * @returns {Promise}
               *   Resolves when the transaction successfully finishes
               *   Rejects if there is any error or timeout during the transaction
               */
            }, {
              key: "transaction",
              value: function(ha) {
                var Aa = this, da = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, fa = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.TRANSACTION_TIMEOUT, gs = arguments.length > 3 ? arguments[3] : void 0;
                this.logger.debug("transaction for ".concat(ha, "..."));
                var Gs = Ws();
                if (!gs) {
                  var qs;
                  gs = Rs()(qs = "".concat(this.clientId, "/transaction/")).call(qs, Gs), da.resp_topic = gs;
                }
                return this.pendingTransactions[Gs] = {
                  id: Gs,
                  hasTimedOut: !1,
                  timeout: null
                }, new (Wi())(/* @__PURE__ */ (function() {
                  var El = di(/* @__PURE__ */ Ko().mark(function kl(ju, Yu) {
                    var Lc;
                    return Ko().wrap(function(tc) {
                      for (; ; ) switch (tc.prev = tc.next) {
                        case 0:
                          return Lc = /* @__PURE__ */ (function() {
                            var bc = di(/* @__PURE__ */ Ko().mark(function ud(qf, yd) {
                              return Ko().wrap(function(vu) {
                                for (; ; ) switch (vu.prev = vu.next) {
                                  case 0:
                                    return vu.prev = 0, vu.next = 3, Aa.unsubscribe(gs);
                                  case 3:
                                    if (Aa.pendingTransactions[Gs].timeout && (clearTimeout(Aa.pendingTransactions[Gs].timeout), Aa.pendingTransactions[Gs].timeout = null), !qf) {
                                      vu.next = 6;
                                      break;
                                    }
                                    throw qf;
                                  case 6:
                                    ju(Aa._formatTransactionResponsePayload(yd)), vu.next = 12;
                                    break;
                                  case 9:
                                    vu.prev = 9, vu.t0 = vu.catch(0), Yu(vu.t0);
                                  case 12:
                                  case "end":
                                    return vu.stop();
                                }
                              }, ud, null, [[0, 9]]);
                            }));
                            return function(qf, yd) {
                              return bc.apply(this, arguments);
                            };
                          })(), tc.prev = 1, Aa.pendingTransactions[Gs].timeout = $l()(function() {
                            var bc;
                            if (!Aa.pendingTransactions || !Aa.pendingTransactions[Gs]) {
                              Aa.logger.warn("Pending transaction for ".concat(Gs, " was not cancelled..."));
                              return;
                            }
                            Aa.pendingTransactions[Gs].hasTimedOut || (Aa.pendingTransactions[Gs].hasTimedOut = !0, Lc(new Error(Rs()(bc = "Transaction for ".concat(ha, " timed out after ")).call(bc, fa, " seconds"))));
                          }, fa * 1e3), Aa.subscribe(gs, function(bc) {
                            Lc(null, bc);
                          }), tc.next = 6, Aa.publish(ha, da);
                        case 6:
                          tc.next = 11;
                          break;
                        case 8:
                          tc.prev = 8, tc.t0 = tc.catch(1), Lc(tc.t0);
                        case 11:
                        case "end":
                          return tc.stop();
                      }
                    }, kl, null, [[1, 8]]);
                  }));
                  return function(kl, ju) {
                    return El.apply(this, arguments);
                  };
                })());
              }
              /**
               * @async
               *
               * Publishing something to the CLSP server means that you send a request and
               * get a confirmation of deliver from Paho.  It's different from the
               * transaction in that you do not need to subscribe to a topic to get a
               * response/ack from the server (because you don't expect a response from the
               * server).  All transactions use publish in addition to sub/unsub.
               *
               * Publish actions include:
               * - stopping a stream
               * - sending stats
               *
               * @param {String} topic
               *   The topic to publish to
               * @param {Object} data
               *   The data to publish
               *
               * @returns {Promise}
               *   Resolves when publish operation is successful
               *   Rejects when publish operation fails
               */
            }, {
              key: "publish",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa(da, fa) {
                  var gs, Gs, qs, El, kl, ju, Yu, Lc = arguments;
                  return Ko().wrap(function(tc) {
                    for (; ; ) switch (tc.prev = tc.next) {
                      case 0:
                        if (gs = Lc.length > 2 && Lc[2] !== void 0 ? Lc[2] : this.TRANSACTION_TIMEOUT, !this.isDestroyComplete) {
                          tc.next = 4;
                          break;
                        }
                        return this.logger.info('Tried to publish to topic "'.concat(da, '" while destroyed')), tc.abrupt("return");
                      case 4:
                        return this.logger.debug('Publishing to topic "'.concat(da, '"')), Gs = Ws(), tc.prev = 6, tc.next = 9, (0, Zl.w)(this._publish(Gs, da, fa), gs * 1e3);
                      case 9:
                        this.logger.info(Rs()(qs = 'Successfully published to topic "'.concat(da, '" with id "')).call(qs, Gs, '"')), tc.next = 26;
                        break;
                      case 12:
                        if (tc.prev = 12, tc.t0 = tc.catch(6), !this.isDestroyed) {
                          tc.next = 17;
                          break;
                        }
                        return this.logger.info(Rs()(kl = 'Publish to topic "'.concat(da, '" with id "')).call(kl, Gs, '" failed while destroying')), tc.abrupt("return");
                      case 17:
                        if (!(this.isHalting || this.isHalted)) {
                          tc.next = 20;
                          break;
                        }
                        return this.logger.info(Rs()(ju = 'Publish to topic "'.concat(da, '" with id "')).call(ju, Gs, '" failed while halting/halted')), tc.abrupt("return");
                      case 20:
                        if (!this.iframeWasDestroyedExternally) {
                          tc.next = 23;
                          break;
                        }
                        return this.logger.info(Rs()(Yu = 'Publish to topic "'.concat(da, '" with id "')).call(Yu, Gs, '" failed while iframe was destroyed externally')), tc.abrupt("return");
                      case 23:
                        throw this.logger.error(Rs()(El = 'Failed to publish to topic "'.concat(da, '" with id "')).call(El, Gs, '"')), this.logger.error(tc.t0), tc.t0;
                      case 26:
                        return tc.prev = 26, delete this.publishHandlers[Gs], tc.finish(26);
                      case 29:
                      case "end":
                        return tc.stop();
                    }
                  }, Aa, this, [[6, 12, 26, 29]]);
                }));
                function ha(Aa, da) {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "_publish",
              value: function(ha, Aa, da) {
                var fa = this;
                return new (Wi())(function(gs, Gs) {
                  fa.publishHandlers[ha] = function(qs) {
                    if (qs)
                      return Gs(qs);
                    gs();
                  }, fa.issueCommand(oa.routerCommands.PUBLISH, {
                    publishId: ha,
                    topic: Aa,
                    data: da
                  });
                });
              }
            }, {
              key: "_handlePublishRouterEvent",
              value: function(ha, Aa) {
                var da = Aa.data.publishId;
                if (!da)
                  throw new Error("Cannot handle publish event without publishId");
                if (!this.publishHandlers[da]) {
                  var fa;
                  this.logger.warn(Rs()(fa = 'No handler for publishId "'.concat(da, '" for publish event "')).call(fa, ha, '"'));
                  return;
                }
                switch (ha) {
                  case oa.routerEvents.PUBLISH_SUCCESS: {
                    this.publishHandlers[da]();
                    break;
                  }
                  case oa.routerEvents.PUBLISH_FAILURE: {
                    this.publishHandlers[da](new Error(Aa.data.reason));
                    break;
                  }
                  default:
                    throw new Error("Unknown eventType: ".concat(ha));
                }
              }
              /**
               * Register a handler that will being listening to a topic until that topic
               * is unsubscribed from.
               *
               * Note that currently, the only use cases for a "persistent" subscription
               * are stream resync and the actual stream itself.  All other subscribe use
               * cases are transactional, and therefore use the `transaction` method.  Use
               * this `subscribe` method cautiously / sparingly.
               *
               * @param {String} topic
               *   The topic to subscribe to
               * @param {RouterTransactionManager-subscribeHandler} handler
               *   The callback for the subscribe operation
               */
            }, {
              key: "subscribe",
              value: function(ha, Aa) {
                this.logger.debug('Subscribing to topic "'.concat(ha, '"')), this.subscribeHandlers[ha] = Aa, this.issueCommand(oa.routerCommands.SUBSCRIBE, {
                  topic: ha
                });
              }
            }, {
              key: "_handleMessageArrivedRouterEvent",
              value: function(ha, Aa) {
                if (this.isDestroyComplete)
                  throw new Error("Tried to handle Router message arrived event after destroy was complete!");
                var da = Aa.data, fa = da.destinationName;
                if (!fa)
                  throw new Error("Cannot handle subscribe event without a topic");
                if (!this.subscribeHandlers[fa]) {
                  var gs;
                  this.logger.info(Rs()(gs = 'No handler for subscribe topic "'.concat(fa, '" for message event "')).call(gs, ha, '"'));
                  return;
                }
                switch (ha) {
                  case oa.routerEvents.MESSAGE_ARRIVED: {
                    this.subscribeHandlers[fa](da, Aa);
                    break;
                  }
                  default:
                    throw new Error("Unknown eventType: ".concat(ha));
                }
              }
              /**
               * @async
               *
               * Stop listening to a topic
               *
               * @param {String} topic
               *   The topic to unsubscribe from
               */
            }, {
              key: "unsubscribe",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa(da) {
                  var fa, gs = arguments;
                  return Ko().wrap(function(qs) {
                    for (; ; ) switch (qs.prev = qs.next) {
                      case 0:
                        if (fa = gs.length > 1 && gs[1] !== void 0 ? gs[1] : this.TRANSACTION_TIMEOUT, !this.isDestroyComplete) {
                          qs.next = 4;
                          break;
                        }
                        return this.logger.info('Tried to unsubscribe from topic "'.concat(da, '" while destroyed')), qs.abrupt("return");
                      case 4:
                        if (!this.unsubscribesInProgress[da]) {
                          qs.next = 7;
                          break;
                        }
                        return this.logger.info("Already unsubscribing from ".concat(da)), qs.abrupt("return");
                      case 7:
                        return this.logger.debug('Unsubscribing from topic "'.concat(da, '"')), qs.prev = 8, delete this.subscribeHandlers[da], this.unsubscribesInProgress[da] = !0, qs.next = 13, (0, Zl.w)(this._unsubscribe(da), fa * 1e3);
                      case 13:
                        this.logger.info('Successfully unsubscribed from topic "'.concat(da, '"')), qs.next = 29;
                        break;
                      case 16:
                        if (qs.prev = 16, qs.t0 = qs.catch(8), !this.isDestroyed) {
                          qs.next = 21;
                          break;
                        }
                        return this.logger.info('Unsubscribe from topic "'.concat(da, '" failed while destroying')), qs.abrupt("return");
                      case 21:
                        if (!(this.isHalting || this.isHalted)) {
                          qs.next = 24;
                          break;
                        }
                        return this.logger.info('Unsubscribe from topic "'.concat(da, '" failed while halting/halted')), qs.abrupt("return");
                      case 24:
                        if (!this.iframeWasDestroyedExternally) {
                          qs.next = 27;
                          break;
                        }
                        return this.logger.info('Unsubscribe from topic "'.concat(da, '" failed while iframe was destroyed externally')), qs.abrupt("return");
                      case 27:
                        throw this.logger.info('Failed to unsubscribe from topic "'.concat(da, '"')), qs.t0;
                      case 29:
                        return qs.prev = 29, delete this.unsubscribesInProgress[da], delete this.unsubscribeHandlers[da], qs.finish(29);
                      case 33:
                      case "end":
                        return qs.stop();
                    }
                  }, Aa, this, [[8, 16, 29, 33]]);
                }));
                function ha(Aa) {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "_unsubscribe",
              value: function(ha) {
                var Aa = this;
                return new (Wi())(function(da, fa) {
                  Aa.unsubscribeHandlers[ha] = function(gs) {
                    if (gs)
                      return fa(gs);
                    da();
                  }, Aa.issueCommand(oa.routerCommands.UNSUBSCRIBE, {
                    topic: ha
                  });
                });
              }
            }, {
              key: "_handleUnsubscribeRouterEvent",
              value: function(ha, Aa) {
                var da = Aa.data.topic;
                if (this.isDestroyComplete)
                  throw new Error("Tried to check unsubscribe handler after destroy was complete!");
                if (!da)
                  throw new Error("Cannot handle unsubscribe event without a topic");
                if (!this.unsubscribeHandlers[da]) {
                  var fa;
                  this.logger.warn(Rs()(fa = 'No handler for topic "'.concat(da, '" for unsubscribe event "')).call(fa, ha, '"'));
                  return;
                }
                switch (ha) {
                  case oa.routerEvents.UNSUBSCRIBE_SUCCESS: {
                    this.unsubscribeHandlers[da]();
                    break;
                  }
                  case oa.routerEvents.UNSUBSCRIBE_FAILURE: {
                    this.unsubscribeHandlers[da](new Error(Aa.data.reason));
                    break;
                  }
                  default:
                    throw new Error("Unknown eventType: ".concat(ha));
                }
              }
            }, {
              key: "onRouterEvent",
              value: function(ha, Aa) {
                if (this.isDestroyComplete)
                  throw new Error("Tried to handle Router event ".concat(ha, " after destroy was complete!"));
                switch (ha) {
                  case oa.routerEvents.PUBLISH_SUCCESS:
                  case oa.routerEvents.PUBLISH_FAILURE: {
                    this._handlePublishRouterEvent(ha, Aa);
                    break;
                  }
                  case oa.routerEvents.UNSUBSCRIBE_SUCCESS:
                  case oa.routerEvents.UNSUBSCRIBE_FAILURE: {
                    this._handleUnsubscribeRouterEvent(ha, Aa);
                    break;
                  }
                  case oa.routerEvents.MESSAGE_ARRIVED: {
                    this._handleMessageArrivedRouterEvent(ha, Aa);
                    break;
                  }
                  default:
                    throw new Error("Unknown eventType: ".concat(ha));
                }
              }
            }, {
              key: "halt",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  var da = this, fa, gs, Gs;
                  return Ko().wrap(function(El) {
                    for (; ; ) switch (El.prev = El.next) {
                      case 0:
                        if (!this.isDestroyed) {
                          El.next = 3;
                          break;
                        }
                        return this.logger.info("Tried to halt while destroyed"), El.abrupt("return");
                      case 3:
                        if (!(this.isHalting || this.isHalted)) {
                          El.next = 6;
                          break;
                        }
                        return this.logger.info("Tried to halt while halting/halted"), El.abrupt("return");
                      case 6:
                        this.logger.info("Halting all handlers..."), this.isHalting = !0;
                        for (fa in this.pendingTransactions)
                          gs = this.pendingTransactions[fa], gs.timeout && (clearTimeout(gs.timeout), gs.timeout = null);
                        return this.pendingTransactions = {}, this.unsubscribeHandlers = {}, this.publishHandlers = {}, Gs = ql()(this.subscribeHandlers), El.next = 15, Wi().allSettled(Is()(Gs).call(Gs, function(kl) {
                          return da.unsubscribe(kl);
                        }));
                      case 15:
                        this.subscribeHandlers = {}, this.unsubscribesInProgress = {}, this.isHalting = !1, this.isHalted = !0, this.logger.info("Finished halting all handlers");
                      case 20:
                      case "end":
                        return El.stop();
                    }
                  }, Aa, this);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
              /**
               * @todo - provide method description
               *
               * @todo - return a Promise
               *
               * @param {String} topic
               *   The topic to send to
               * @param {Array} byteArray
               *   The raw data to send
               */
            }, {
              key: "directSend",
              value: function(ha, Aa) {
                this.logger.debug("directSend..."), this.issueCommand(oa.routerCommands.SEND, {
                  topic: ha,
                  byteArray: Aa
                });
              }
            }, {
              key: "_destroy",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  return Ko().wrap(function(fa) {
                    for (; ; ) switch (fa.prev = fa.next) {
                      case 0:
                        return fa.next = 2, this.halt();
                      case 2:
                        return this.pendingTransactions = null, this.unsubscribeHandlers = null, this.publishHandlers = null, this.subscribeHandlers = null, this.unsubscribesInProgress = null, fa.next = 9, Fp(oa, "_destroy", this, 3)([]);
                      case 9:
                      case "end":
                        return fa.stop();
                    }
                  }, Aa, this);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }], [{
              key: "factory",
              value: function(ha, Aa, da) {
                return new oa(ha, Aa, da);
              }
            }]);
          })(al);
          Ui(Qc, "routerEvents", {
            PUBLISH_SUCCESS: al.routerEvents.PUBLISH_SUCCESS,
            PUBLISH_FAILURE: al.routerEvents.PUBLISH_FAILURE,
            UNSUBSCRIBE_SUCCESS: al.routerEvents.UNSUBSCRIBE_SUCCESS,
            UNSUBSCRIBE_FAILURE: al.routerEvents.UNSUBSCRIBE_FAILURE,
            MESSAGE_ARRIVED: al.routerEvents.MESSAGE_ARRIVED
          });
          function Tc(Ua, oa, ya) {
            return oa = fo(oa), Mi(Ua, Ud() ? li()(oa, ya || [], fo(Ua).constructor) : oa.apply(Ua, ya));
          }
          function Ud() {
            try {
              var Ua = !Boolean.prototype.valueOf.call(li()(Boolean, [], function() {
              }));
            } catch {
            }
            return (Ud = function() {
              return !!Ua;
            })();
          }
          function Ff(Ua, oa, ya, ha) {
            var Aa = Ni(fo(Ua.prototype), oa, ya);
            return 2 & ha && typeof Aa == "function" ? function(da) {
              return Aa.apply(ya, da);
            } : Aa;
          }
          var Kc = ra().DEFAULT_STREAM_TIMEOUT, vf = ra().DEFAULT_STREAM_TIMEOUT, mp = ra().DEFAULT_STREAM_TIMEOUT, Vd = ra().DEFAULT_STREAM_TIMEOUT, Wd = /* @__PURE__ */ (function(Ua) {
            function oa(ya, ha, Aa, da) {
              var fa, gs;
              if (fi(this, oa), gs = Tc(this, oa, [ya, ha]), !rd.isStreamConfiguration(Aa))
                throw new Error("A StreamConfiguration is required to instantiate a RouterStreamManager");
              if (!da)
                throw new Error("A RouterTransactionManager is required to instantiate a RouterStreamManager");
              return gs.streamConfiguration = Aa, gs.routerTransactionManager = da, gs.STREAM_DATA_TIMEOUT_DURATION = Kc, gs.MOOV_TIMEOUT_DURATION = vf, gs.FIRST_MOOF_TIMEOUT_DURATION = mp, gs.MOOF_TIMEOUT_DURATION = Vd, gs.streamName = gs.streamConfiguration.streamName, gs.moovRequestTopic = Rs()(fa = "".concat(gs.clientId, "/init-segment/")).call(fa, wc()(Math.random() * 1e6)), gs.guid = null, gs.firstMoofTimeout = null, gs.moofTimeout = null, gs.isPlaying = !1, gs.isStopping = !1, gs;
            }
            return No(oa, Ua), Oi(oa, [{
              key: "play",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  var da = this, fa, gs, Gs, qs, El;
                  return Ko().wrap(function(ju) {
                    for (; ; ) switch (ju.prev = ju.next) {
                      case 0:
                        if (!this.isDestroyed) {
                          ju.next = 3;
                          break;
                        }
                        return this.logger.info("Tried to play from destroyed RouterStreamManager"), ju.abrupt("return");
                      case 3:
                        if (ju.prev = 3, !this._hasJWTTokenConfig()) {
                          ju.next = 8;
                          break;
                        }
                        return ju.next = 7, this._validateJWT();
                      case 7:
                        this.streamName = ju.sent;
                      case 8:
                        return this.logger.info("Play is requesting stream..."), ju.next = 11, this._requestStreamData();
                      case 11:
                        return fa = ju.sent, gs = fa.guid, Gs = fa.mimeCodec, this.guid = gs, this.routerTransactionManager.subscribe("iov/video/".concat(this.guid, "/resync"), function() {
                          da.emit(oa.events.RESYNC_STREAM_COMPLETE, {
                            guid: da.guid,
                            streamName: da.streamName
                          });
                        }), ju.next = 18, this._requestMoov();
                      case 18:
                        return qs = ju.sent, El = qs.moov, ju.next = 22, this._requestMoofs();
                      case 22:
                        return this.isPlaying = !0, ju.abrupt("return", {
                          guid: gs,
                          mimeCodec: Gs,
                          moov: El
                        });
                      case 26:
                        return ju.prev = 26, ju.t0 = ju.catch(3), this.logger.error("Error trying to play stream ".concat(this.streamName)), ju.next = 31, this.stop();
                      case 31:
                        throw ju.t0;
                      case 32:
                      case "end":
                        return ju.stop();
                    }
                  }, Aa, this, [[3, 26]]);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "stop",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  var da = this, fa, gs;
                  return Ko().wrap(function(qs) {
                    for (; ; ) switch (qs.prev = qs.next) {
                      case 0:
                        if (this._clearFirstMoofTimeout(), this._clearMoofTimeout(), !this.isDestroyComplete) {
                          qs.next = 4;
                          break;
                        }
                        return qs.abrupt("return");
                      case 4:
                        if (this.isPlaying) {
                          qs.next = 6;
                          break;
                        }
                        return qs.abrupt("return");
                      case 6:
                        if (this.guid) {
                          qs.next = 9;
                          break;
                        }
                        return this.logger.info("Trying to stop stream ".concat(this.streamName, " with no guid!")), qs.abrupt("return");
                      case 9:
                        return this.isStopping = !0, qs.next = 12, Wi().allSettled([
                          // Stop listening for the moov
                          this.routerTransactionManager.unsubscribe(this.moovRequestTopic),
                          // Stop listening for moofs
                          this.routerTransactionManager.unsubscribe("iov/video/".concat(this.guid, "/live")),
                          // Stop listening for resync events
                          this.routerTransactionManager.unsubscribe("iov/video/".concat(this.guid, "/resync")),
                          // Tell the server we've stopped
                          this.routerTransactionManager.publish("iov/video/".concat(this.guid, "/stop"), {
                            clientId: this.clientId
                          })
                        ]);
                      case 12:
                        if (fa = qs.sent, this.guid = null, this.isPlaying = !1, this.isStopping = !1, gs = sl()(fa).call(fa, function(El, kl) {
                          return kl.status !== "fulfilled" && El.push(kl), El;
                        }, []), !gs.length) {
                          qs.next = 21;
                          break;
                        }
                        throw this.logger.warn("Error(s) encountered while stopping:"), Vl()(gs).call(gs, function(El) {
                          da.logger.error(El.reason);
                        }), gs[0].reason;
                      case 21:
                      case "end":
                        return qs.stop();
                    }
                  }, Aa, this);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "getStreamList",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  var da, fa;
                  return Ko().wrap(function(Gs) {
                    for (; ; ) switch (Gs.prev = Gs.next) {
                      case 0:
                        return this.logger.debug("Getting Stream List..."), Gs.next = 3, this.routerTransactionManager.transaction("iov/video/list");
                      case 3:
                        return da = Gs.sent, fa = da.payloadString, Gs.abrupt("return", fa);
                      case 6:
                      case "end":
                        return Gs.stop();
                    }
                  }, Aa, this);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "_hasJWTTokenConfig",
              value: function() {
                return !!(this.streamConfiguration.tokenConfig && this.streamConfiguration.tokenConfig.jwt && this.streamConfiguration.tokenConfig.jwt.length > 0);
              }
              /**
               * @private
               *
               * @async
               *
               * Validate the jwt that this instance was constructed with.
               *
               * @returns {String}
               *   the stream name
               */
            }, {
              key: "_validateJWT",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  var da, fa, gs, Gs;
                  return Ko().wrap(function(El) {
                    for (; ; ) switch (El.prev = El.next) {
                      case 0:
                        return this.logger.debug("Validating JWT..."), El.next = 3, this.routerTransactionManager.transaction("iov/jwtValidate", {
                          b64HashURL: this.streamConfiguration.tokenConfig.b64HashAccessUrl,
                          token: this.streamConfiguration.tokenConfig.jwt
                        });
                      case 3:
                        if (da = El.sent, fa = da.payloadString, fa.error !== "" && this.emit(oa.events.JWT_AUTHORIZATION_FAILURE, {
                          error: fa.error
                        }), fa.status === 200) {
                          El.next = 8;
                          break;
                        }
                        throw new Error(fa.error);
                      case 8:
                        return gs = fa.target_url.split("/"), Gs = gs[gs.length - 1], El.abrupt("return", Gs);
                      case 11:
                      case "end":
                        return El.stop();
                    }
                  }, Aa, this);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "_requestStreamData",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  var da, fa, gs;
                  return Ko().wrap(function(qs) {
                    for (; ; ) switch (qs.prev = qs.next) {
                      case 0:
                        return this.logger.debug("Requesting Stream..."), this._hasJWTTokenConfig() ? da = {
                          clientId: this.clientId,
                          token: this.streamConfiguration.tokenConfig.jwt
                        } : da = {
                          clientId: this.clientId
                        }, qs.next = 4, this.routerTransactionManager.transaction("iov/video/".concat(window.btoa(this.streamName), "/request"), da, this.STREAM_DATA_TIMEOUT_DURATION);
                      case 4:
                        if (fa = qs.sent, gs = fa.payloadString, gs.mimeCodec) {
                          qs.next = 8;
                          break;
                        }
                        throw new Error("Error while requesting stream: mimeCodec was not received!");
                      case 8:
                        if (gs.guid) {
                          qs.next = 10;
                          break;
                        }
                        throw new Error("Error while requesting stream: guid was not received!");
                      case 10:
                        return qs.abrupt("return", gs);
                      case 11:
                      case "end":
                        return qs.stop();
                    }
                  }, Aa, this);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "_clearFirstMoofTimeout",
              value: function() {
                this.firstMoofTimeout && (clearTimeout(this.firstMoofTimeout), this.firstMoofTimeout = null);
              }
            }, {
              key: "_clearMoofTimeout",
              value: function() {
                this.moofTimeout && (clearTimeout(this.moofTimeout), this.moofTimeout = null);
              }
              /**
               * @private
               *
               * @async
               *
               * Request the moov from the SFS
               *
               * @returns {Object}
               *   The moov
               */
            }, {
              key: "_requestMoov",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  var da, fa, gs;
                  return Ko().wrap(function(qs) {
                    for (; ; ) switch (qs.prev = qs.next) {
                      case 0:
                        if (!this.isDestroyed) {
                          qs.next = 2;
                          break;
                        }
                        throw new Error("Tried to request moov while destroyed");
                      case 2:
                        if (this.logger.info("Requesting the moov..."), this.guid) {
                          qs.next = 5;
                          break;
                        }
                        throw new Error("The guid must be set before requesting the moov");
                      case 5:
                        return this._hasJWTTokenConfig() ? da = {
                          initSegmentTopic: this.moovRequestTopic,
                          clientId: this.clientId,
                          token: this.streamConfiguration.tokenConfig.jwt
                        } : da = {
                          initSegmentTopic: this.moovRequestTopic,
                          clientId: this.clientId
                        }, qs.next = 8, this.routerTransactionManager.transaction(
                          "iov/video/".concat(this.guid, "/play"),
                          da,
                          this.MOOV_TIMEOUT_DURATION,
                          // We must override the subscribe topic to get the moov
                          this.moovRequestTopic
                        );
                      case 8:
                        return fa = qs.sent, gs = fa.payloadBytes, qs.abrupt("return", {
                          moov: gs
                        });
                      case 11:
                      case "end":
                        return qs.stop();
                    }
                  }, Aa, this);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "_requestMoofs",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  var da = this;
                  return Ko().wrap(function(gs) {
                    for (; ; ) switch (gs.prev = gs.next) {
                      case 0:
                        if (!this.isDestroyed) {
                          gs.next = 2;
                          break;
                        }
                        throw new Error("Tried to request moofs while destroyed");
                      case 2:
                        if (this.logger.info("Setting up moof listener..."), this.guid) {
                          gs.next = 5;
                          break;
                        }
                        throw new Error("The guid must be set before requesting moofs");
                      case 5:
                        return gs.abrupt("return", new (Wi())(function(Gs, qs) {
                          var El = !1, kl = !1;
                          da.firstMoofTimeout = $l()(function() {
                            var Yu;
                            El || (El = !0, da._clearFirstMoofTimeout(), qs(new Error(Rs()(Yu = "First moof for stream ".concat(da.streamName, " timed out after ")).call(Yu, da.FIRST_MOOF_TIMEOUT_DURATION, " seconds"))));
                          }, da.FIRST_MOOF_TIMEOUT_DURATION * 1e3);
                          var ju = "iov/video/".concat(da.guid, "/live");
                          da.routerTransactionManager.subscribe(ju, function(Yu) {
                            if (da.isDestroyed) {
                              da.logger.info("Received moof while destroyed!");
                              return;
                            }
                            if (!kl) {
                              if (El) {
                                da.logger.warn("Received first moof, but moofTimeout has already occurred...");
                                return;
                              }
                              da._clearFirstMoofTimeout(), kl = !0, Gs({
                                moofReceivedTopic: ju
                              });
                            }
                            da._clearMoofTimeout(), da.moofTimeout = $l()(function() {
                              if (da.isDestroyed) {
                                da.logger.info("Moof timeout reached while destroyed");
                                return;
                              }
                              da.emit(oa.events.VIDEO_SEGMENT_TIMEOUT, {
                                timeout: da.MOOF_TIMEOUT_DURATION
                              });
                            }, da.MOOF_TIMEOUT_DURATION * 1e3), da.emit(oa.events.VIDEO_SEGMENT_RECEIVED, {
                              clspMessage: Yu
                            });
                          });
                        }));
                      case 6:
                      case "end":
                        return gs.stop();
                    }
                  }, Aa, this);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "_destroy",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  return Ko().wrap(function(fa) {
                    for (; ; ) switch (fa.prev = fa.next) {
                      case 0:
                        return fa.prev = 0, fa.next = 3, this.stop();
                      case 3:
                        fa.next = 9;
                        break;
                      case 5:
                        fa.prev = 5, fa.t0 = fa.catch(0), this.logger.error("Failed to stop when destroying!"), this.logger.error(fa.t0);
                      case 9:
                        return this.streamConfiguration = null, this.routerTransactionManager = null, this.streamName = null, this.moovRequestTopic = null, this.guid = null, this.firstMoofTimeout = null, this.moofTimeout = null, fa.next = 18, Ff(oa, "_destroy", this, 3)([]);
                      case 18:
                      case "end":
                        return fa.stop();
                    }
                  }, Aa, this, [[0, 5]]);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }], [{
              key: "factory",
              value: function(ha, Aa, da, fa) {
                return new oa(ha, Aa, da, fa);
              }
            }]);
          })(al);
          Ui(Wd, "events", {
            RESYNC_STREAM_COMPLETE: "resync-stream-complete",
            VIDEO_SEGMENT_RECEIVED: "video-segment-received",
            VIDEO_SEGMENT_TIMEOUT: "video-segment-timeout",
            JWT_AUTHORIZATION_FAILURE: "jwt-authorization-failure"
          }), Ui(Wd, "routerEvents", {});
          var Bp = ii(4607), $d = /* @__PURE__ */ ii.n(Bp);
          function qc(Ua, oa, ya) {
            return oa = fo(oa), Mi(Ua, vp() ? li()(oa, ya || [], fo(Ua).constructor) : oa.apply(Ua, ya));
          }
          function vp() {
            try {
              var Ua = !Boolean.prototype.valueOf.call(li()(Boolean, [], function() {
              }));
            } catch {
            }
            return (vp = function() {
              return !!Ua;
            })();
          }
          function Gd(Ua, oa, ya, ha) {
            var Aa = Ni(fo(Ua.prototype), oa, ya);
            return 2 & ha && typeof Aa == "function" ? function(da) {
              return Aa.apply(ya, da);
            } : Aa;
          }
          var yf = 5, rp = /* @__PURE__ */ (function(Ua) {
            function oa(ya, ha, Aa) {
              var da;
              if (fi(this, oa), da = qc(this, oa, [ya, ha]), !Aa)
                throw new Error("A RouterTransactionManager is required to instantiate a RouterStatsManager");
              return da.routerTransactionManager = Aa, da.statsMsg = {
                byteCount: 0,
                inkbps: 0,
                host: document.location.host,
                clientId: da.clientId
              }, da.publishInterval = null, da.isStopped = !0, da.PUBLISH_STATS_INTERVAL = yf, da;
            }
            return No(oa, Ua), Oi(oa, [{
              key: "updateByteCount",
              value: function(ha) {
                if (this.isDestroyed) {
                  this.logger.info("Tried to updateByteCount while destroyed");
                  return;
                }
                this.logger.silly("Updating bytecount..."), this.statsMsg.byteCount += ha.length;
              }
              /**
               * We have to send stats to the server at least once per minute, or else the
               * CLSP service will stop streaming to this Router.
               *
               * @returns {void}
               */
            }, {
              key: "start",
              value: function() {
                var ha = this;
                if (this.isDestroyed) {
                  this.logger.info("Tried to start while destroyed");
                  return;
                }
                this.publishInterval && this.stop(), this.logger.info("Starting stats publishing..."), this.publishInterval = $d()(function() {
                  ha._publishStats();
                }, this.PUBLISH_STATS_INTERVAL * 1e3), this.isStopped = !1;
              }
              /**
               * Stop publishing stats to the server.  Do this When we no longer want to
               * stream to the Router.
               *
               * @returns {void}
               */
            }, {
              key: "stop",
              value: function() {
                if (this.isDestroyComplete) {
                  this.logger.info("Tried to stop while destroyed");
                  return;
                }
                this.logger.info("Stopping stats publishing..."), this.publishInterval && (clearInterval(this.publishInterval), this.publishInterval = null), this.isStopped = !0;
              }
              /**
               * @private
               *
               * @async
               *
               * Send stats to the server.
               *
               * @returns {void}
               */
            }, {
              key: "_publishStats",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  return Ko().wrap(function(fa) {
                    for (; ; ) switch (fa.prev = fa.next) {
                      case 0:
                        if (!this.isDestroyed) {
                          fa.next = 3;
                          break;
                        }
                        return this.logger.info("Tried to _publishStats while destroyed"), fa.abrupt("return");
                      case 3:
                        return this.statsMsg.inkbps = this.statsMsg.byteCount * 8 / 3e4, this.statsMsg.byteCount = 0, fa.prev = 5, this.logger.info("About to send stats message..."), fa.next = 9, this.routerTransactionManager.publish("iov/stats", this.statsMsg);
                      case 9:
                        this.logger.debug("iov status", this.statsMsg), fa.next = 15;
                        break;
                      case 12:
                        fa.prev = 12, fa.t0 = fa.catch(5), this.isStopped || (this.logger.error("Error while publishing stats!"), this.logger.error(fa.t0), this.emit(oa.events.PUBLISH_FAILURE, {
                          error: fa.t0
                        }), this.stop());
                      case 15:
                      case "end":
                        return fa.stop();
                    }
                  }, Aa, this, [[5, 12]]);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "_destroy",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  return Ko().wrap(function(fa) {
                    for (; ; ) switch (fa.prev = fa.next) {
                      case 0:
                        return this.stop(), this.statsMsg = null, this.routerTransactionManager = null, fa.next = 5, Gd(oa, "_destroy", this, 3)([]);
                      case 5:
                      case "end":
                        return fa.stop();
                    }
                  }, Aa, this);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }], [{
              key: "factory",
              value: function(ha, Aa, da) {
                return new oa(ha, Aa, da);
              }
            }]);
          })(al);
          Ui(rp, "events", {
            PUBLISH_FAILURE: "publish-failed"
          }), Ui(rp, "routerEvents", {});
          function Up(Ua, oa, ya) {
            return oa = fo(oa), Mi(Ua, ph() ? li()(oa, ya || [], fo(Ua).constructor) : oa.apply(Ua, ya));
          }
          function ph() {
            try {
              var Ua = !Boolean.prototype.valueOf.call(li()(Boolean, [], function() {
              }));
            } catch {
            }
            return (ph = function() {
              return !!Ua;
            })();
          }
          function hh(Ua, oa, ya, ha) {
            var Aa = Ni(fo(Ua.prototype), oa, ya);
            return 2 & ha && typeof Aa == "function" ? function(da) {
              return Aa.apply(ya, da);
            } : Aa;
          }
          var af = 3, Ic = 0, qh = 5, Ec = 120, gh = 30, Zc = /* @__PURE__ */ (function(Ua) {
            function oa(ya, ha, Aa) {
              var da;
              if (fi(this, oa), da = Up(this, oa, [ya, ha]), !Aa)
                throw new Error("A RouterTransactionManager is required to instantiate a RouterConnectionManager");
              return da.routerTransactionManager = Aa, da.statsManager = rp.factory(da.logId, da.clientId, da.routerTransactionManager), da.statsManager.on(rp.events.PUBLISH_FAILURE, function(fa) {
                da.logger.warn("Publish stats failure - attempting to reconnect..."), da.reconnect();
              }), da.MAX_RECONNECTION_ATTEMPTS = af, da.MAX_RECONNECTION_TIME = Ic, da.IMMEDIATE_RECONNECTION_DELAY = qh, da.IMMEDIATE_RECONNECTION_DURATION = Ec, da.RECONNECTION_DELAY = gh, da.isConnected = !1, da.isConnecting = !1, da.isDisconnecting = !1, da.isReconnecting = !1, da._onConnect = null, da._onDisconnect = null, da;
            }
            return No(oa, Ua), Oi(oa, [{
              key: "connect",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  var da, fa = arguments;
                  return Ko().wrap(function(Gs) {
                    for (; ; ) switch (Gs.prev = Gs.next) {
                      case 0:
                        return da = fa.length > 0 && fa[0] !== void 0 ? fa[0] : !0, Gs.prev = 1, Gs.next = 4, this.reconnect(!1);
                      case 4:
                        if (!this.isDestroyed) {
                          Gs.next = 7;
                          break;
                        }
                        return this.logger.info("Destroy occurred before the connection finished"), Gs.abrupt("return");
                      case 7:
                        if (!this.isDisconnecting) {
                          Gs.next = 10;
                          break;
                        }
                        return this.logger.info("Disconnection occurred before the connection finished"), Gs.abrupt("return");
                      case 10:
                        da && this.emit(oa.events.CONNECT_SUCCESS), Gs.next = 18;
                        break;
                      case 13:
                        Gs.prev = 13, Gs.t0 = Gs.catch(1), this.logger.error("Failed to connect"), this.logger.error(Gs.t0), da && this.emit(oa.events.CONNECT_FAILURE, {
                          error: Gs.t0
                        });
                      case 18:
                      case "end":
                        return Gs.stop();
                    }
                  }, Aa, this, [[1, 13]]);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "_connect",
              value: function() {
                var ha = this;
                return new (Wi())(function(Aa, da) {
                  ha._onConnect = function(fa) {
                    if (ha._onConnect = null, fa)
                      return da(fa);
                    Aa();
                  }, ha.routerTransactionManager.issueCommand(oa.routerCommands.CONNECT);
                });
              }
            }, {
              key: "_handleConnectRouterEvent",
              value: function(ha, Aa) {
                switch (ha) {
                  case oa.routerEvents.CONNECT_SUCCESS: {
                    this._onConnect();
                    break;
                  }
                  case oa.routerEvents.CONNECT_FAILURE: {
                    this._onConnect(new Error(Aa.data.reason));
                    break;
                  }
                  default:
                    throw new Error("Unknown eventType: ".concat(ha));
                }
              }
              /**
               * @async
               *
               * Attempt to reconnect a certain number of times
               *
               * @returns {Promise}
               */
            }, {
              key: "reconnect",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  var da, fa, gs, Gs = arguments;
                  return Ko().wrap(function(El) {
                    for (; ; ) switch (El.prev = El.next) {
                      case 0:
                        if (da = Gs.length > 0 && Gs[0] !== void 0 ? Gs[0] : !0, !this.isDestroyed) {
                          El.next = 4;
                          break;
                        }
                        return this.logger.info("Tried to reconnect on destroyed RouterConnectionManager"), El.abrupt("return");
                      case 4:
                        if (!this.isDisconnecting) {
                          El.next = 7;
                          break;
                        }
                        return this.logger.info("Tried to reconnect while there was a disconnection in progress"), El.abrupt("return");
                      case 7:
                        if (!this.isConnecting) {
                          El.next = 10;
                          break;
                        }
                        return this.logger.info("Connection already in progress"), El.abrupt("return");
                      case 10:
                        if (!this.isReconnecting) {
                          El.next = 13;
                          break;
                        }
                        return this.logger.info("A reconnection attempt is already in progress"), El.abrupt("return");
                      case 13:
                        return this.logger.info("Reconnecting..."), this.isConnecting = !0, this.isReconnecting = !0, fa = Hi()(), gs = this.MAX_RECONNECTION_TIME ? fa + this.MAX_RECONNECTION_TIME * 1e3 : 0, El.prev = 18, El.next = 21, this._reconnect(fa, gs);
                      case 21:
                        if (!this.isDestroyed) {
                          El.next = 24;
                          break;
                        }
                        return this.logger.info("Destruction occurred before the reconnection finished"), El.abrupt("return");
                      case 24:
                        if (!this.isDisconnecting) {
                          El.next = 27;
                          break;
                        }
                        return this.logger.info("Disconnection occurred before the reconnection finished"), El.abrupt("return");
                      case 27:
                        this.logger.info("Successfully reconnected!"), da && this.emit(oa.events.RECONNECT_SUCCESS), El.next = 35;
                        break;
                      case 31:
                        El.prev = 31, El.t0 = El.catch(18), this.logger.error("Failed to reconnect"), da && this.emit(oa.events.RECONNECT_FAILURE, {
                          error: El.t0
                        });
                      case 35:
                        return El.prev = 35, this.isConnecting = !1, this.isReconnecting = !1, El.finish(35);
                      case 39:
                      case "end":
                        return El.stop();
                    }
                  }, Aa, this, [[18, 31, 35, 39]]);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "_reconnect",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa(da, fa) {
                  var gs, Gs, qs = arguments;
                  return Ko().wrap(function(kl) {
                    for (; ; ) switch (kl.prev = kl.next) {
                      case 0:
                        if (gs = qs.length > 2 && qs[2] !== void 0 ? qs[2] : 0, !this.isDestroyed) {
                          kl.next = 4;
                          break;
                        }
                        return this.logger.info("Tried to _reconnect on destroyed RouterConnectionManager"), kl.abrupt("return");
                      case 4:
                        if (!this.isDisconnecting) {
                          kl.next = 7;
                          break;
                        }
                        return this.logger.info("Tried to _reconnect while there was a disconnection in progress"), kl.abrupt("return");
                      case 7:
                        if (!this.isConnected) {
                          kl.next = 10;
                          break;
                        }
                        return this.logger.info("Already connected."), kl.abrupt("return");
                      case 10:
                        if (gs++, !(this.MAX_RECONNECTION_ATTEMPTS && gs > this.MAX_RECONNECTION_ATTEMPTS)) {
                          kl.next = 13;
                          break;
                        }
                        throw new Error("Failed to reconnect after ".concat(gs, " attempts."));
                      case 13:
                        if (!(this.MAX_RECONNECTION_TIME && Hi()() > fa)) {
                          kl.next = 15;
                          break;
                        }
                        throw new Error("Failed to reconnect after ".concat(this.MAX_RECONNECTION_TIME, " seconds."));
                      case 15:
                        return gs > 1 && this.logger.warn("Reconnection attempt #".concat(gs, "...")), kl.prev = 16, kl.next = 19, this.disconnect(!1);
                      case 19:
                        return kl.next = 21, (0, Zl.w)(this._connect(), this.IMMEDIATE_RECONNECTION_DELAY * 1e3);
                      case 21:
                        this.isConnected = !0, this.statsManager.start(), this.logger.info("Reconnected successfully after ".concat(gs, " attempts")), kl.next = 35;
                        break;
                      case 26:
                        return kl.prev = 26, kl.t0 = kl.catch(16), this.logger.error("Error while trying to reconnect:"), this.logger.error(kl.t0), Gs = Hi()() - da > this.IMMEDIATE_RECONNECTION_DURATION * 1e3 ? this.RECONNECTION_DELAY : this.IMMEDIATE_RECONNECTION_DELAY, kl.next = 33, (0, ca.sleepSeconds)(Gs);
                      case 33:
                        return kl.next = 35, this._reconnect(da, fa, gs);
                      case 35:
                      case "end":
                        return kl.stop();
                    }
                  }, Aa, this, [[16, 26]]);
                }));
                function ha(Aa, da) {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "disconnect",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  var da, fa = arguments;
                  return Ko().wrap(function(Gs) {
                    for (; ; ) switch (Gs.prev = Gs.next) {
                      case 0:
                        if (da = fa.length > 0 && fa[0] !== void 0 ? fa[0] : !0, !this.isDestroyComplete) {
                          Gs.next = 4;
                          break;
                        }
                        return this.logger.info("Tried to disconnect on a destroyed RouterConnectionManager"), Gs.abrupt("return");
                      case 4:
                        if (!this.isDisconnecting) {
                          Gs.next = 7;
                          break;
                        }
                        return this.logger.info("There is already a disconnection in progress"), Gs.abrupt("return");
                      case 7:
                        if (this.isConnected) {
                          Gs.next = 9;
                          break;
                        }
                        return Gs.abrupt("return");
                      case 9:
                        return this.logger.info("Disconnecting..."), this.isDisconnecting = !0, Gs.prev = 11, this.statsManager.stop(), Gs.next = 15, (0, Zl.w)(this._disconnect(), this.IMMEDIATE_RECONNECTION_DELAY * 1e3);
                      case 15:
                        da && this.emit(oa.events.DISCONNECT_SUCCESS), Gs.next = 28;
                        break;
                      case 18:
                        if (Gs.prev = 18, Gs.t0 = Gs.catch(11), !this.isDestroyComplete) {
                          Gs.next = 23;
                          break;
                        }
                        return this.logger.info("Disconnect failed while destroyed"), Gs.abrupt("return");
                      case 23:
                        if (!this.routerTransactionManager.iframeWasDestroyedExternally) {
                          Gs.next = 26;
                          break;
                        }
                        return this.logger.info("Disconnect failed while iframe was destroyed externally"), Gs.abrupt("return");
                      case 26:
                        throw da && this.emit(oa.events.DISCONNECT_FAILURE, {
                          error: Gs.t0
                        }), Gs.t0;
                      case 28:
                        return Gs.prev = 28, this._onDisconnect = null, this.isConnected = !1, this.isDisconnecting = !1, Gs.finish(28);
                      case 33:
                      case "end":
                        return Gs.stop();
                    }
                  }, Aa, this, [[11, 18, 28, 33]]);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "_disconnect",
              value: function() {
                var ha = this;
                return new (Wi())(function(Aa, da) {
                  ha._onDisconnect = function(fa) {
                    if (fa)
                      return da(fa);
                    Aa();
                  }, ha.routerTransactionManager.issueCommand(oa.routerCommands.DISCONNECT);
                });
              }
            }, {
              key: "_handleDisconnectRouterEvent",
              value: function(ha, Aa) {
                switch (ha) {
                  case oa.routerEvents.DISCONNECT_SUCCESS: {
                    this._onDisconnect();
                    break;
                  }
                  case oa.routerEvents.DISCONNECT_FAILURE: {
                    this._onDisconnect(new Error(Aa.data.reason));
                    break;
                  }
                  default:
                    throw new Error("Unknown eventType: ".concat(ha));
                }
              }
              /**
               * Handler for the CONNECTION_LOST event.  Will stop stats and attempt to
               * reconnect.
               *
               * @param {*} event
               */
            }, {
              key: "_handleConnectionLostRouterEvent",
              value: function(ha) {
                var Aa = ha.data.event;
                this.logger.debug('connection lost "'.concat(Aa, '" event')), this.isConnected = !1, this.statsManager.stop(), this.reconnect();
              }
            }, {
              key: "onRouterEvent",
              value: function(ha, Aa) {
                if (this.isDestroyComplete)
                  throw new Error("Tried to handle Router event ".concat(ha, " after destroy was complete!"));
                switch (ha) {
                  case oa.routerEvents.CONNECT_SUCCESS:
                  case oa.routerEvents.CONNECT_FAILURE: {
                    this._handleConnectRouterEvent(ha, Aa);
                    break;
                  }
                  case oa.routerEvents.DISCONNECT_SUCCESS:
                  case oa.routerEvents.DISCONNECT_FAILURE: {
                    this._handleDisconnectRouterEvent(ha, Aa);
                    break;
                  }
                  case oa.routerEvents.CONNECTION_LOST: {
                    this._handleConnectionLostRouterEvent(Aa);
                    break;
                  }
                  default:
                    throw new Error("Unknown eventType: ".concat(ha));
                }
              }
            }, {
              key: "_destroy",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  return Ko().wrap(function(fa) {
                    for (; ; ) switch (fa.prev = fa.next) {
                      case 0:
                        return fa.prev = 0, fa.next = 3, this.disconnect();
                      case 3:
                        fa.next = 9;
                        break;
                      case 5:
                        fa.prev = 5, fa.t0 = fa.catch(0), this.logger.error("Error while disconnecting while destroying:"), this.logger.error(fa.t0);
                      case 9:
                        return fa.prev = 9, fa.next = 12, this.statsManager.destroy();
                      case 12:
                        fa.next = 18;
                        break;
                      case 14:
                        fa.prev = 14, fa.t1 = fa.catch(9), this.logger.error("Error while destroying statsManager while destroying:"), this.logger.error(fa.t1);
                      case 18:
                        return this.statsManager = null, this.routerTransactionManager = null, this._onConnect = null, this._onDisconnect = null, fa.next = 24, hh(oa, "_destroy", this, 3)([]);
                      case 24:
                      case "end":
                        return fa.stop();
                    }
                  }, Aa, this, [[0, 5], [9, 14]]);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }], [{
              key: "factory",
              value: function(ha, Aa, da) {
                return new oa(ha, Aa, da);
              }
            }]);
          })(al);
          Ui(Zc, "events", {
            // Emitted when a connection attempt
            CONNECT_SUCCESS: "connect-success",
            CONNECT_FAILURE: "connect-failure",
            RECONNECT_SUCCESS: "reconnect-success",
            RECONNECT_FAILURE: "reconnect-failure",
            DISCONNECT_SUCCESS: "disconnect-success",
            DISCONNECT_FAILURE: "disconnect-failure"
          }), Ui(Zc, "routerEvents", {
            CONNECT_SUCCESS: al.routerEvents.CONNECT_SUCCESS,
            CONNECT_FAILURE: al.routerEvents.CONNECT_FAILURE,
            DISCONNECT_SUCCESS: al.routerEvents.DISCONNECT_SUCCESS,
            DISCONNECT_FAILURE: al.routerEvents.DISCONNECT_FAILURE,
            CONNECTION_LOST: al.routerEvents.CONNECTION_LOST
          });
          function mh(Ua, oa, ya) {
            return oa = fo(oa), Mi(Ua, Bf() ? li()(oa, ya || [], fo(Ua).constructor) : oa.apply(Ua, ya));
          }
          function Bf() {
            try {
              var Ua = !Boolean.prototype.valueOf.call(li()(Boolean, [], function() {
              }));
            } catch {
            }
            return (Bf = function() {
              return !!Ua;
            })();
          }
          function ou(Ua, oa, ya, ha) {
            var Aa = Ni(fo(Ua.prototype), oa, ya);
            return 2 & ha && typeof Aa == "function" ? function(da) {
              return Aa.apply(ya, da);
            } : Aa;
          }
          var Hd = /* @__PURE__ */ (function(Ua) {
            function oa(ya, ha, Aa, da) {
              var fa;
              if (fi(this, oa), fa = mh(this, oa, [ya]), !ha)
                throw new Error("clientId is required to construct a new Conduit instance.");
              if (!rd.isStreamConfiguration(Aa))
                throw new Error("invalid streamConfiguration passed to Conduit constructor");
              if (!da)
                throw new Error("containerElement is required to construct a new Conduit instance");
              return fa.clientId = ha, fa.streamConfiguration = Aa, fa.containerElement = da, fa.isInitialized = !1, fa.routerIframeManager = Cc.factory(fa.logId, fa.clientId, fa.streamConfiguration, fa.containerElement), fa.routerTransactionManager = Qc.factory(fa.logId, fa.clientId, fa.routerIframeManager), fa.routerConnectionManager = Zc.factory(fa.logId, fa.clientId, fa.routerTransactionManager), fa.routerStreamManager = Wd.factory(fa.logId, fa.clientId, fa.streamConfiguration, fa.routerTransactionManager), fa;
            }
            return No(oa, Ua), Oi(oa, [{
              key: "initialize",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  var da = this;
                  return Ko().wrap(function(gs) {
                    for (; ; ) switch (gs.prev = gs.next) {
                      case 0:
                        return this.routerIframeManager.on(Cc.events.IFRAME_DESTROYED_EXTERNALLY, function() {
                          if (da.isDestroyed) {
                            da.logger.info("Iframe was destroyed externally while in process of destroying");
                            return;
                          }
                          da.emit(oa.events.IFRAME_DESTROYED_EXTERNALLY), da.routerConnectionManager.disconnect();
                        }), this.routerConnectionManager.on(Zc.events.RECONNECT_SUCCESS, function() {
                          da.emit(oa.events.RECONNECT_SUCCESS);
                        }), this.routerConnectionManager.on(Zc.events.RECONNECT_FAILURE, function(Gs) {
                          var qs = Gs.error;
                          da.emit(oa.events.RECONNECT_FAILURE, {
                            error: qs
                          });
                        }), this.routerStreamManager.on(Wd.events.RESYNC_STREAM_COMPLETE, function(Gs) {
                          da.emit(oa.events.RESYNC_STREAM_COMPLETE, Gs);
                        }), this.routerStreamManager.on(Wd.events.VIDEO_SEGMENT_RECEIVED, function(Gs) {
                          da.emit(oa.events.VIDEO_SEGMENT_RECEIVED, Gs);
                        }), this.routerStreamManager.on(Wd.events.VIDEO_SEGMENT_TIMEOUT, function(Gs) {
                          var qs;
                          da.logger.warn(Rs()(qs = "Did not receive a video segment for ".concat(da.routerStreamManager.streamName, " in ")).call(qs, Gs.timeout, " seconds, attempting to reconnect...")), da.routerConnectionManager.reconnect();
                        }), this.routerStreamManager.on(Wd.events.JWT_AUTHORIZATION_FAILURE, function(Gs) {
                          da.emit(oa.events.JWT_AUTHORIZATION_FAILURE, Gs);
                        }), gs.next = 9, this.routerIframeManager.create();
                      case 9:
                        this.isInitialized = !0;
                      case 10:
                      case "end":
                        return gs.stop();
                    }
                  }, Aa, this);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
              /**
               * Play the configured stream.
               *
               * @returns {object}
               *  - guid
               *  - mimeCodec
               *  - moov
               */
            }, {
              key: "play",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  var da, fa, gs, Gs;
                  return Ko().wrap(function(El) {
                    for (; ; ) switch (El.prev = El.next) {
                      case 0:
                        if (!this.isDestroyed) {
                          El.next = 3;
                          break;
                        }
                        return this.logger.info("Tried to play a stream from a destroyed Conduit"), El.abrupt("return");
                      case 3:
                        if (this.isInitialized) {
                          El.next = 6;
                          break;
                        }
                        return this.logger.info("Tried to play a stream without first initializing the Conduit"), El.abrupt("return");
                      case 6:
                        return this.logger.info("Playing..."), El.prev = 7, El.next = 10, this.routerConnectionManager.connect();
                      case 10:
                        El.next = 17;
                        break;
                      case 12:
                        throw El.prev = 12, El.t0 = El.catch(7), this.logger.error("Error while trying to connect before playing:"), this.logger.error(El.t0), El.t0;
                      case 17:
                        return El.prev = 17, El.next = 20, this.routerStreamManager.play();
                      case 20:
                        return da = El.sent, fa = da.guid, gs = da.mimeCodec, Gs = da.moov, El.abrupt("return", {
                          guid: fa,
                          mimeCodec: gs,
                          moov: Gs
                        });
                      case 27:
                        return El.prev = 27, El.t1 = El.catch(17), this.logger.error("Error trying to play stream ".concat(this.routerStreamManager.streamName)), El.next = 32, this.stop();
                      case 32:
                        throw El.t1;
                      case 33:
                      case "end":
                        return El.stop();
                    }
                  }, Aa, this, [[7, 12], [17, 27]]);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "stop",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  return Ko().wrap(function(fa) {
                    for (; ; ) switch (fa.prev = fa.next) {
                      case 0:
                        return this.logger.info("Stopping stream..."), fa.prev = 1, fa.next = 4, this.routerStreamManager.stop();
                      case 4:
                        fa.next = 9;
                        break;
                      case 6:
                        fa.prev = 6, fa.t0 = fa.catch(1), this.routerIframeManager.wasIframeDestroyedExternally() || (this.logger.error("Error while stopping while destroying"), this.logger.error(fa.t0));
                      case 9:
                        return fa.prev = 9, fa.next = 12, this.routerConnectionManager.disconnect();
                      case 12:
                        fa.next = 17;
                        break;
                      case 14:
                        fa.prev = 14, fa.t1 = fa.catch(9), this.routerIframeManager.wasIframeDestroyedExternally() || (this.logger.error("Error while stopping while destroying"), this.logger.error(fa.t1));
                      case 17:
                      case "end":
                        return fa.stop();
                    }
                  }, Aa, this, [[1, 6], [9, 14]]);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "segmentUsed",
              value: function(ha) {
                this.shouldLogSourceBuffer && this.logSourceBufferTopic && this.routerTransactionManager.directSend(this.logSourceBufferTopic, ha), this.routerConnectionManager.statsManager.updateByteCount(ha);
              }
              /**
               * When the Router sends a message back from its iframe, the Conduit
               * Collection handles it.  If the message was meant for this Conduit, the
               * Conduit Collection will call this method with the event data.
               *
               * @param {Object} event
               *   We expect event to have "data.event", which represents the event that
               *   occurred relative to the clsp stream.  "ready" means the stream is ready,
               *   "fail" means there was an error, "data" means a video segment / moof was
               *   sent.
               */
            }, {
              key: "onRouterEvent",
              value: function(ha, Aa) {
                this.logger.debug('Message received for "'.concat(ha, '" event'));
                try {
                  switch (ha) {
                    case Cc.routerEvents.CREATE_SUCCESS:
                    case Cc.routerEvents.CREATE_FAILURE: {
                      this.routerIframeManager._handleRouterCreatedEvent(ha, Aa);
                      break;
                    }
                    case Zc.routerEvents.CONNECT_SUCCESS:
                    case Zc.routerEvents.CONNECT_FAILURE:
                    case Zc.routerEvents.DISCONNECT_SUCCESS:
                    case Zc.routerEvents.DISCONNECT_FAILURE:
                    case Zc.routerEvents.CONNECTION_LOST: {
                      this.routerConnectionManager.onRouterEvent(ha, Aa);
                      break;
                    }
                    case Qc.routerEvents.UNSUBSCRIBE_SUCCESS:
                    case Qc.routerEvents.UNSUBSCRIBE_FAILURE:
                    case Qc.routerEvents.PUBLISH_SUCCESS:
                    case Qc.routerEvents.PUBLISH_FAILURE:
                    case Qc.routerEvents.MESSAGE_ARRIVED: {
                      this.routerTransactionManager.onRouterEvent(ha, Aa);
                      break;
                    }
                    case oa.routerEvents.WINDOW_MESSAGE_FAIL: {
                      this.routerConnectionManager.disconnect();
                      break;
                    }
                    // Log the error, but don't throw
                    default:
                      this.logger.error("No match for event: ".concat(ha));
                  }
                } catch (da) {
                  this.logger.error("onMessageError"), this.logger.error(da), this.emit(oa.events.ROUTER_EVENT_ERROR, {
                    error: da
                  });
                }
              }
              /**
               * @async
               *
               * Clean up and dereference the necessary properties.  Will also disconnect
               * and destroy the iframe.
               *
               * @returns {void}
               */
            }, {
              key: "_destroy",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  return Ko().wrap(function(fa) {
                    for (; ; ) switch (fa.prev = fa.next) {
                      case 0:
                        return fa.prev = 0, fa.next = 3, this.stop();
                      case 3:
                        fa.next = 9;
                        break;
                      case 5:
                        fa.prev = 5, fa.t0 = fa.catch(0), this.logger.error("Error while stopping while destroying"), this.logger.error(fa.t0);
                      case 9:
                        return fa.prev = 9, fa.next = 12, this.routerStreamManager.destroy();
                      case 12:
                        fa.next = 18;
                        break;
                      case 14:
                        fa.prev = 14, fa.t1 = fa.catch(9), this.logger.error("Error while destroying routerStreamManager while destroying"), this.logger.error(fa.t1);
                      case 18:
                        return fa.prev = 18, fa.next = 21, this.routerConnectionManager.destroy();
                      case 21:
                        fa.next = 27;
                        break;
                      case 23:
                        fa.prev = 23, fa.t2 = fa.catch(18), this.logger.error("Error while destroying routerConnectionManager while destroying"), this.logger.error(fa.t2);
                      case 27:
                        return fa.prev = 27, fa.next = 30, this.routerTransactionManager.destroy();
                      case 30:
                        fa.next = 36;
                        break;
                      case 32:
                        fa.prev = 32, fa.t3 = fa.catch(27), this.logger.error("Error while destroying routerTransactionManager while destroying"), this.logger.error(fa.t3);
                      case 36:
                        return fa.prev = 36, fa.next = 39, this.routerIframeManager.destroy();
                      case 39:
                        fa.next = 45;
                        break;
                      case 41:
                        fa.prev = 41, fa.t4 = fa.catch(36), this.logger.error("Error while destroying routerIframeManager while destroying"), this.logger.error(fa.t4);
                      case 45:
                        return this.routerStreamManager = null, this.routerConnectionManager = null, this.routerTransactionManager = null, this.routerIframeManager = null, this.clientId = null, this.streamConfiguration = null, this.containerElement = null, fa.next = 54, ou(oa, "_destroy", this, 3)([]);
                      case 54:
                      case "end":
                        return fa.stop();
                    }
                  }, Aa, this, [[0, 5], [9, 14], [18, 23], [27, 32], [36, 41]]);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }], [{
              key: "factory",
              value: function(ha, Aa, da, fa) {
                return new oa(ha, Aa, da, fa);
              }
            }]);
          })(Cs);
          Ui(Hd, "events", {
            ROUTER_EVENT_ERROR: "router-event-error",
            RECONNECT_SUCCESS: Zc.events.RECONNECT_SUCCESS,
            RECONNECT_FAILURE: Zc.events.RECONNECT_FAILURE,
            RESYNC_STREAM_COMPLETE: Wd.events.RESYNC_STREAM_COMPLETE,
            VIDEO_SEGMENT_RECEIVED: Wd.events.VIDEO_SEGMENT_RECEIVED,
            IFRAME_DESTROYED_EXTERNALLY: Cc.events.IFRAME_DESTROYED_EXTERNALLY,
            JWT_AUTHORIZATION_FAILURE: Wd.events.JWT_AUTHORIZATION_FAILURE
          }), Ui(Hd, "routerEvents", al.routerEvents);
          var yp = ii(5413), bf = /* @__PURE__ */ ii.n(yp), Tf = ii(7924), bp = /* @__PURE__ */ ii.n(Tf);
          const od = {
            Paho: bp(),
            register: function() {
              window.Paho || (window.Paho = {
                MQTT: bp()
              });
            }
          };
          function ad(Ua, oa, ya) {
            return oa = fo(oa), Mi(Ua, Dd() ? li()(oa, ya || [], fo(Ua).constructor) : oa.apply(Ua, ya));
          }
          function Dd() {
            try {
              var Ua = !Boolean.prototype.valueOf.call(li()(Boolean, [], function() {
              }));
            } catch {
            }
            return (Dd = function() {
              return !!Ua;
            })();
          }
          function wd(Ua, oa, ya, ha) {
            var Aa = Ni(fo(Ua.prototype), oa, ya);
            return 2 & ha && typeof Aa == "function" ? function(da) {
              return Aa.apply(ya, da);
            } : Aa;
          }
          var nd, zd = /* @__PURE__ */ (function(Ua) {
            function oa(ya) {
              var ha;
              return fi(this, oa), ha = ad(this, oa, [ya]), Ui(ha, "_routeWindowMessageToTargetConduit", function(Aa) {
                var da = Aa.data.clientId;
                if (da) {
                  ha.logger.debug("Received Window Message event for ".concat(da));
                  var fa = Aa.data.event;
                  if (!ha.has(da)) {
                    var gs, Gs;
                    if (fa === "fail")
                      return;
                    if (ys()(gs = ha.deletedConduitClientIds).call(gs, da)) {
                      ha.logger.warn("Received a message for deleted conduit ".concat(da));
                      return;
                    }
                    throw new Error(Rs()(Gs = "Unable to route message of type ".concat(fa, ' for Conduit with clientId "')).call(Gs, da, '".  A Conduit with that clientId does not exist.'));
                  }
                  ha.get(da).onRouterEvent(fa, Aa);
                }
              }), ha.totalConduitCount = 0, ha.conduits = {}, ha.deletedConduitClientIds = [], od.register(), window.addEventListener("message", ha._routeWindowMessageToTargetConduit), ha;
            }
            return No(oa, Ua), Oi(oa, [{
              key: "create",
              value: (
                /**
                 * Create a Conduit for a specific stream, and add it to this collection.
                 *
                 * @returns {Conduit}
                 */
                function(ha, Aa, da, fa) {
                  var gs;
                  this.logger.debug(Rs()(gs = "creating a conduit with logId ".concat(ha, " and clientId ")).call(gs, Aa));
                  var Gs = Hd.factory(ha, Aa, da, fa);
                  return this._add(Gs), this.totalConduitCount++, Gs;
                }
              )
              /**
               * Add a Conduit instance to this collection.
               *
               * @private
               *
               * @param {Conduit} conduit
               *   The conduit instance to add
               *
               * @returns {this}
               */
            }, {
              key: "_add",
              value: function(ha) {
                var Aa = ha.clientId;
                return this.conduits[Aa] = ha, this;
              }
              /**
               * Determine whether or not a Conduit with the passed clientId exists in this
               * collection.
               *
               * @param {String} clientId
               *   The clientId of the conduit to find
               *
               * @returns {Boolean}
               *   True if the conduit with the given clientId exists
               *   False if the conduit with the given clientId does not exist
               */
            }, {
              key: "has",
              value: function(ha) {
                return Object.prototype.hasOwnProperty.call(this.conduits, ha);
              }
              /**
               * Get a Conduit with the passed clientId from this collection.
               *
               * @param {String} clientId
               *   The clientId of the conduit instance to get
               *
               * @returns {Conduit|undefined}
               *   If a Conduit with this clientId doest not exist, undefined is returned.
               */
            }, {
              key: "get",
              value: function(ha) {
                return this.conduits[ha];
              }
              /**
               * Remove a conduit instance from this collection and destroy it.
               *
               * @param {String} clientId
               *   The clientId of the conduit to remove and destroy
               *
               * @returns {this}
               */
            }, {
              key: "remove",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa(da) {
                  var fa;
                  return Ko().wrap(function(Gs) {
                    for (; ; ) switch (Gs.prev = Gs.next) {
                      case 0:
                        if (fa = this.get(da), fa) {
                          Gs.next = 3;
                          break;
                        }
                        return Gs.abrupt("return");
                      case 3:
                        return Gs.next = 5, fa.destroy();
                      case 5:
                        return delete this.conduits[da], this.deletedConduitClientIds.push(da), Gs.abrupt("return", this);
                      case 8:
                      case "end":
                        return Gs.stop();
                    }
                  }, Aa, this);
                }));
                function ha(Aa) {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "_destroy",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  var da;
                  return Ko().wrap(function(gs) {
                    for (; ; ) switch (gs.prev = gs.next) {
                      case 0:
                        window.removeEventListener("message", this._routeWindowMessageToTargetConduit), gs.t0 = bf()(Ko()).call(Ko(), this.conduits);
                      case 2:
                        if ((gs.t1 = gs.t0()).done) {
                          gs.next = 15;
                          break;
                        }
                        return da = gs.t1.value, gs.prev = 4, gs.next = 7, this.remove(da);
                      case 7:
                        gs.next = 13;
                        break;
                      case 9:
                        gs.prev = 9, gs.t2 = gs.catch(4), this.logger.error("Error while removing conduit ".concat(da, " while destroying")), this.logger.error(gs.t2);
                      case 13:
                        gs.next = 2;
                        break;
                      case 15:
                        return this.conduits = null, this.deletedConduitClientIds = null, gs.next = 19, wd(oa, "_destroy", this, 3)([]);
                      case 19:
                      case "end":
                        return gs.stop();
                    }
                  }, Aa, this, [[4, 9]]);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }], [{
              key: "asSingleton",
              value: function() {
                return nd || (nd = oa.factory("1")), nd;
              }
            }, {
              key: "factory",
              value: function(ha) {
                return new oa(ha);
              }
            }]);
          })(ja);
          function vh(Ua, oa, ya) {
            return oa = fo(oa), Mi(Ua, Vp() ? li()(oa, ya || [], fo(Ua).constructor) : oa.apply(Ua, ya));
          }
          function Vp() {
            try {
              var Ua = !Boolean.prototype.valueOf.call(li()(Boolean, [], function() {
              }));
            } catch {
            }
            return (Vp = function() {
              return !!Ua;
            })();
          }
          function Wp(Ua, oa, ya, ha) {
            var Aa = Ni(fo(Ua.prototype), oa, ya);
            return 2 & ha && typeof Aa == "function" ? function(da) {
              return Aa.apply(ya, da);
            } : Aa;
          }
          var hd = /* @__PURE__ */ (function(Ua) {
            function oa(ya, ha, Aa, da) {
              var fa;
              return fi(this, oa), fa = vh(this, oa, [ya]), fa._constructorArgumentsBouncer(ha, Aa, da), fa.clientId = ha, fa.streamConfiguration = Aa, fa.containerElement = da, fa.conduit = zd.asSingleton().create(fa.logId, fa.clientId, fa.streamConfiguration, fa.containerElement), fa;
            }
            return No(oa, Ua), Oi(oa, [{
              key: "_constructorArgumentsBouncer",
              value: function(ha, Aa, da) {
                if (!ha)
                  throw new Error("clientId is required to construct a new Conduit instance.");
                if (!rd.isStreamConfiguration(Aa))
                  throw new Error("invalid streamConfiguration passed to Conduit constructor");
                if (!da)
                  throw new Error("containerElement is required to construct a new Conduit instance");
              }
            }, {
              key: "initialize",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  return Ko().wrap(function(fa) {
                    for (; ; ) switch (fa.prev = fa.next) {
                      case 0:
                        if (!this.isDestroyed) {
                          fa.next = 2;
                          break;
                        }
                        throw new Error("Tried to initialize while destroyed");
                      case 2:
                        return fa.next = 4, this.conduit.initialize();
                      case 4:
                      case "end":
                        return fa.stop();
                    }
                  }, Aa, this);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "_destroy",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  return Ko().wrap(function(fa) {
                    for (; ; ) switch (fa.prev = fa.next) {
                      case 0:
                        return fa.next = 2, zd.asSingleton().remove(this.clientId);
                      case 2:
                        return this.conduit = null, this.streamConfiguration = null, this.containerElement = null, fa.next = 7, Wp(oa, "_destroy", this, 3)([]);
                      case 7:
                      case "end":
                        return fa.stop();
                    }
                  }, Aa, this);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }], [{
              key: "factory",
              value: (
                /**
                 * Create a new CLSP Client
                 *
                 * @param {String} logId
                 *   a string that identifies this router in log messages
                 * @param {String} clientId
                 *   the guid to be used to construct the topic
                 * @param {StreamConfiguration} streamConfiguration
                 *   The stream configuration to pull from the CLSP server / SFS
                 * @param {Element} containerElement
                 *   The container of the video element and where the Conduit's iframe will be
                 *   inserted
                 */
                function(ha, Aa, da, fa) {
                  return new oa(ha, Aa, da, fa);
                }
              )
            }]);
          })(ja);
          Ui(hd, "events", Hd.events);
          var Uf = ii(1265), lc = /* @__PURE__ */ ii.n(Uf), Gp = ii(6984), Kd = /* @__PURE__ */ ii.n(Gp), Tp = ii(7842), qd = /* @__PURE__ */ ii.n(Tp), yh = ii(2973), Vf = /* @__PURE__ */ ii.n(yh);
          function Ep(Ua, oa, ya) {
            return oa = fo(oa), Mi(Ua, Hp() ? li()(oa, ya || [], fo(Ua).constructor) : oa.apply(Ua, ya));
          }
          function Hp() {
            try {
              var Ua = !Boolean.prototype.valueOf.call(li()(Boolean, [], function() {
              }));
            } catch {
            }
            return (Hp = function() {
              return !!Ua;
            })();
          }
          function Wf(Ua, oa, ya, ha) {
            var Aa = Ni(fo(Ua.prototype), oa, ya);
            return 2 & ha && typeof Aa == "function" ? function(da) {
              return Aa.apply(ya, da);
            } : Aa;
          }
          function Sp(Ua, oa, ya) {
            sd(Ua, oa), oa.set(Ua, ya);
          }
          function Gf(Ua, oa) {
            sd(Ua, oa), oa.add(Ua);
          }
          function sd(Ua, oa) {
            if (oa.has(Ua)) throw new TypeError("Cannot initialize the same private elements twice on an object");
          }
          function _d(Ua, oa) {
            return Ua.get(Yd(Ua, oa));
          }
          function Yd(Ua, oa, ya) {
            if (typeof Ua == "function" ? Ua === oa : Ua.has(oa)) return arguments.length < 3 ? oa : ya;
            throw new TypeError("Private element is not present on this object");
          }
          var zp = 10, Ef = 0.25, Yh = 1, xp = /* @__PURE__ */ new (Lo())(), wp = /* @__PURE__ */ new (qd())(), Xd = /* @__PURE__ */ new (qd())(), np = /* @__PURE__ */ new (qd())(), sf = /* @__PURE__ */ (function(Ua) {
            function oa(ya) {
              var ha;
              if (fi(this, oa), ha = Ep(this, oa, [ya]), Gf(ha, xp), Sp(ha, wp, /* @__PURE__ */ (function() {
                var Aa = di(/* @__PURE__ */ Ko().mark(function da(fa) {
                  return Ko().wrap(function(Gs) {
                    for (; ; ) switch (Gs.prev = Gs.next) {
                      case 0:
                        return Gs.prev = 0, Gs.next = 3, ha.waitUntilReady();
                      case 3:
                        Gs.next = 9;
                        break;
                      case 5:
                        return Gs.prev = 5, Gs.t0 = Gs.catch(0), ha.emit(oa.events.SOURCE_OPEN_ERROR, {
                          error: Gs.t0
                        }), Gs.abrupt("return");
                      case 9:
                        Gs.prev = 9, ha.mediaSource.duration = ha.DURATION, Gs.next = 19;
                        break;
                      case 13:
                        return Gs.prev = 13, Gs.t1 = Gs.catch(9), ha.logger.error('Error while setting mediaSource duration to "'.concat(ha.DURATION, '"')), ha.logger.error(Gs.t1), ha.emit(oa.events.SOURCE_OPEN_ERROR, {
                          error: Gs.t1
                        }), Gs.abrupt("return");
                      case 19:
                        ha.emit(oa.events.SOURCE_OPEN, fa);
                      case 20:
                      case "end":
                        return Gs.stop();
                    }
                  }, da, null, [[0, 5], [9, 13]]);
                }));
                return function(da) {
                  return Aa.apply(this, arguments);
                };
              })()), Sp(ha, Xd, function(Aa) {
                ha.emit(oa.events.SOURCE_ENDED, Aa);
              }), Sp(ha, np, function(Aa) {
                ha.emit(oa.events.ERROR, Aa);
              }), ha.mediaSource = new window.MediaSource(), !ha.mediaSource)
                throw new Error("The video element or mediaSource is not ready!");
              return ha.mediaSource.addEventListener("sourceopen", _d(wp, ha)), ha.mediaSource.addEventListener("sourceended", _d(Xd, ha)), ha.mediaSource.addEventListener("error", _d(np, ha)), ha.objectURL = null, ha.DURATION = zp, ha.IS_READY_INTERVAL = Ef, ha.IS_READY_TIMEOUT = Yh, ha;
            }
            return No(oa, Ua), Oi(oa, [{
              key: "isReady",
              value: function() {
                return this.isDestroyComplete ? !1 : this.mediaSource.readyState === "open";
              }
              /**
               * @async
               *
               * Wait for this MediaSource to become ready.
               *
               * @returns {void}
               */
            }, {
              key: "waitUntilReady",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  var da = this;
                  return Ko().wrap(function(gs) {
                    for (; ; ) switch (gs.prev = gs.next) {
                      case 0:
                        if (!this.isDestroyComplete) {
                          gs.next = 2;
                          break;
                        }
                        throw new Error("MediaSource will not become ready because it has already been destroyed");
                      case 2:
                        if (!this.isReady()) {
                          gs.next = 4;
                          break;
                        }
                        return gs.abrupt("return");
                      case 4:
                        return gs.next = 6, Vf()(/* @__PURE__ */ (function() {
                          var Gs = di(/* @__PURE__ */ Ko().mark(function qs(El, kl) {
                            return Ko().wrap(function(Yu) {
                              for (; ; ) switch (Yu.prev = Yu.next) {
                                case 0:
                                  da.isReady() && kl();
                                case 1:
                                case "end":
                                  return Yu.stop();
                              }
                            }, qs);
                          }));
                          return function(qs, El) {
                            return Gs.apply(this, arguments);
                          };
                        })(), this.IS_READY_INTERVAL * 1e3, {
                          iterations: this.IS_READY_TIMEOUT / this.IS_READY_INTERVAL
                        });
                      case 6:
                        if (this.isReady()) {
                          gs.next = 8;
                          break;
                        }
                        throw new Error("MediaSource `readyState` timed out waiting to be `open`!");
                      case 8:
                      case "end":
                        return gs.stop();
                    }
                  }, Aa, this);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "asObjectURL",
              value: function() {
                if (this.isDestroyed)
                  throw new Error("Cannot create objectURL while destroyed");
                return this.objectURL || (this.objectURL = Kd().createObjectURL(this.mediaSource)), this.objectURL;
              }
            }, {
              key: "_destroy",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  return Ko().wrap(function(fa) {
                    for (; ; ) switch (fa.prev = fa.next) {
                      case 0:
                        return this.mediaSource.removeEventListener("sourceopen", _d(wp, this)), this.mediaSource.removeEventListener("sourceended", _d(Xd, this)), this.mediaSource.removeEventListener("error", _d(np, this)), fa.prev = 3, fa.next = 6, this.waitUntilReady();
                      case 6:
                        this.mediaSource.endOfStream(), fa.next = 13;
                        break;
                      case 9:
                        fa.prev = 9, fa.t0 = fa.catch(3), this.logger.info("MediaSource did not become ready while destroying, continuing destroy anyway..."), this.logger.info(fa.t0);
                      case 13:
                        return Yd(xp, this, Xh).call(this), Yd(xp, this, _p).call(this), fa.next = 17, Wf(oa, "_destroy", this, 3)([]);
                      case 17:
                      case "end":
                        return fa.stop();
                    }
                  }, Aa, this, [[3, 9]]);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }], [{
              key: "isMimeCodecSupported",
              value: (
                /**
                 * Check to see if the passed mimeCodec is supported by this browser.
                 *
                 * @see - https://developer.mozilla.org/en-US/docs/Web/API/MediaSource/isTypeSupported
                 *
                 * @param {string} mimeCodec
                 *   The mime code to check for support / compatibility
                 *
                 * @returns {boolean}
                 *   - true if the mimeCodec is supported
                 *   - false if the mimeCodec is not supported
                 */
                function(ha) {
                  return ha ? window.MediaSource.isTypeSupported(ha) : !1;
                }
              )
              /**
               * Create a new MediaSourceWrapper, which is a wrapper around `window.MediaSource`
               *
               * @param {string|object} logId
               *   a string that identifies this MediaSource in log messages
               *   @see - src/js/utils/Destroyable
               */
            }, {
              key: "factory",
              value: function(ha) {
                return new oa(ha);
              }
            }]);
          })(Cs);
          function _p() {
            this.objectURL && Kd().revokeObjectURL(this.objectURL), this.objectURL = null;
          }
          function Xh() {
            var Ua = this.mediaSource.sourceBuffers;
            Ua.SourceBuffers && (Ua = Ua.SourceBuffers());
            for (var oa = 0; oa < Ua.length; oa++) {
              var ya = Ua[oa];
              this.mediaSource.removeSourceBuffer(ya);
            }
          }
          Ui(sf, "events", {
            // --- Custom events
            SOURCE_OPEN_ERROR: "source-open-error",
            // --- MSE MediaSource events
            // @todo - create an event name that makes sense in layman's terms, such
            // as "INITIALIZED" either here or in MSEWrapper
            SOURCE_OPEN: "sourceopen",
            // @todo - create an event name that makes sense in layman's terms, such
            // as "FINISHED" either here or in MSEWrapper
            SOURCE_ENDED: "sourceended",
            ERROR: "error"
          });
          function lf(Ua, oa, ya) {
            return oa = fo(oa), Mi(Ua, bh() ? li()(oa, ya || [], fo(Ua).constructor) : oa.apply(Ua, ya));
          }
          function bh() {
            try {
              var Ua = !Boolean.prototype.valueOf.call(li()(Boolean, [], function() {
              }));
            } catch {
            }
            return (bh = function() {
              return !!Ua;
            })();
          }
          function uf(Ua, oa, ya, ha) {
            var Aa = Ni(fo(Ua.prototype), oa, ya);
            return 2 & ha && typeof Aa == "function" ? function(da) {
              return Aa.apply(ya, da);
            } : Aa;
          }
          function gd(Ua, oa, ya) {
            Sf(Ua, oa), oa.set(Ua, ya);
          }
          function Sf(Ua, oa) {
            if (oa.has(Ua)) throw new TypeError("Cannot initialize the same private elements twice on an object");
          }
          function Yc(Ua, oa) {
            return Ua.get(Kp(Ua, oa));
          }
          function Kp(Ua, oa, ya) {
            if (typeof Ua == "function" ? Ua === oa : Ua.has(oa)) return arguments.length < 3 ? oa : ya;
            throw new TypeError("Private element is not present on this object");
          }
          var Sc = "and cannot free space to append additional buffers", xf = 0.25, qp = 10, Pp = 2, Pd = 2, Cd = /* @__PURE__ */ new (qd())(), Hf = /* @__PURE__ */ new (qd())(), Zd = /* @__PURE__ */ (function(Ua) {
            function oa(ya, ha, Aa) {
              var da;
              if (fi(this, oa), da = lf(this, oa, [ya]), Ui(da, "mimeCodec", null), Ui(da, "mediaSource", null), Ui(da, "sourceBuffer", null), Ui(da, "timeBuffered", null), gd(da, Cd, function(fa) {
                if (da.isDestroyComplete)
                  throw new Error("Received `updateend` event while destroyed!");
                if (da.lastSourceBufferOp === "remove") {
                  da.logger.debug("onUpdateEnd ocurred as the result of a remove operation");
                  return;
                }
                if (da.shouldAbortOnNextUpdateEnd)
                  try {
                    da.metric("sourceBuffer.abort", 1), da.sourceBuffer.abort(), da.shouldAbortOnNextUpdateEnd = !1;
                  } catch (gs) {
                    da.metric("error.sourceBuffer.abort", 1), da.emit(oa.events.ABORT_ERROR, {
                      error: gs
                    });
                  }
                try {
                  if (da.sourceBuffer.buffered.length <= 0) {
                    da.metric("sourceBuffer.updateEnd.bufferLength.empty", 1), da.logger.debug("After updating, the sourceBuffer has no length!");
                    return;
                  }
                } catch {
                  da.metric("sourceBuffer.updateEnd.bufferLength.error", 1), da.logger.debug("The mediaSource was removed while an update operation was occurring.");
                  return;
                }
                da.emit(oa.events.UPDATE_END, fa);
              }), gd(da, Hf, function(fa) {
                da.emit(oa.events.ERROR, fa);
              }), !ha)
                throw new Error("`mimeCodec` is required to instantiate a SourceBuffer");
              if (!Aa)
                throw new Error("`mediaSource` is required to instantiate a SourceBuffer");
              return da.mimeCodec = ha, da.mediaSource = Aa, da.sourceBuffer = da.mediaSource.mediaSource.addSourceBuffer(da.mimeCodec), da.sourceBuffer.mode = "sequence", da.sourceBuffer.addEventListener("updateend", Yc(Cd, da)), da.sourceBuffer.addEventListener("error", Yc(Hf, da)), da.IS_READY_INTERVAL = xf, da.IS_READY_TIMEOUT = qp, da.DRIFT_THRESHOLD = Pp, da.BUFFER_SIZE_LIMIT = oa.getDefaultBufferSizeLimit(), da.BUFFER_TRUNCATE_VALUE = wc()(da.BUFFER_SIZE_LIMIT / Pd), da;
            }
            return No(oa, Ua), Oi(oa, [{
              key: "isReady",
              value: function() {
                return this.isDestroyComplete ? !1 : this.sourceBuffer.updating === !1;
              }
              /**
               * @async
               *
               * Wait for this SourceBuffer to become ready.
               *
               * @returns {void}
               */
            }, {
              key: "waitUntilReady",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  var da = this;
                  return Ko().wrap(function(gs) {
                    for (; ; ) switch (gs.prev = gs.next) {
                      case 0:
                        if (!this.isDestroyComplete) {
                          gs.next = 2;
                          break;
                        }
                        throw new Error("SourceBuffer will not become ready because it has already been destroyed");
                      case 2:
                        if (!this.isReady()) {
                          gs.next = 4;
                          break;
                        }
                        return gs.abrupt("return");
                      case 4:
                        return gs.next = 6, Vf()(/* @__PURE__ */ (function() {
                          var Gs = di(/* @__PURE__ */ Ko().mark(function qs(El, kl) {
                            return Ko().wrap(function(Yu) {
                              for (; ; ) switch (Yu.prev = Yu.next) {
                                case 0:
                                  da.isReady() && kl();
                                case 1:
                                case "end":
                                  return Yu.stop();
                              }
                            }, qs);
                          }));
                          return function(qs, El) {
                            return Gs.apply(this, arguments);
                          };
                        })(), this.IS_READY_INTERVAL * 1e3, {
                          iterations: this.IS_READY_TIMEOUT / this.IS_READY_INTERVAL
                        });
                      case 6:
                        if (this.isReady()) {
                          gs.next = 8;
                          break;
                        }
                        throw new Error("SourceBuffer `updating` timed out!");
                      case 8:
                      case "end":
                        return gs.stop();
                    }
                  }, Aa, this);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "append",
              value: function(ha) {
                if (!this.isDestroyComplete) {
                  this.logger.silly("Appending to the sourceBuffer...");
                  var Aa = ha.timestamp, da = ha.byteArray, fa = (Hi()() - Aa) / 1e3;
                  if (fa > this.DRIFT_THRESHOLD) {
                    this.emit(oa.events.DRIFT_THRESHOLD_EXCEEDED, {
                      estimatedDrift: fa,
                      driftThreshold: this.DRIFT_THRESHOLD
                    });
                    return;
                  }
                  this.logger.silly("Appending to the buffer with an estimated drift of ".concat(fa));
                  try {
                    if (this.sourceBuffer.updating) {
                      this.logger.warn("Source buffer is still updating! Cannot append!");
                      return;
                    }
                    this.lastSourceBufferOp = "append", this.sourceBuffer.appendBuffer(da);
                  } catch (Gs) {
                    try {
                      var gs;
                      if (Gs.message && ys()(gs = Gs.message.toLowerCase()).call(gs, Sc))
                        this.logger.warn("source buffer is full, about to flush it..."), this.clear();
                      else
                        throw Gs;
                    } finally {
                      this.metric("error.sourceBuffer.append", 1);
                    }
                  }
                }
              }
              /**
               * Schedule an abort for the next possible time.
               *
               * @returns {void}
               */
            }, {
              key: "abort",
              value: function() {
                this.shouldAbortOnNextUpdateEnd = !0;
              }
              /** Detect a gap in the buffered time ranges */
            }, {
              key: "gapInBufferedRanges",
              value: function(ha) {
                var Aa = this.sourceBuffer.buffered;
                if (Aa.length <= 1 || ha + 1 === Aa.length)
                  return !1;
                var da = Aa.end(ha), fa = Aa.start(ha + 1), gs = fa - da;
                return gs > 0;
              }
              /**
               * Calculate size and time information about the current state of the buffer.
               *
               * @todo - provide better description
               */
            }, {
              key: "getTimes",
              value: function() {
                if (this.isDestroyComplete)
                  return null;
                this.logger.silly("getBufferTimes...");
                var ha = [];
                try {
                  var Aa = this.timeBuffered, da = this.sourceBuffer.buffered;
                  this.logger.debug("this.sourceBuffer.buffered length: " + da.length);
                  for (var fa = 0; fa < da.length; fa++) {
                    var gs, Gs;
                    this.logger.info(Rs()(gs = Rs()(Gs = "Range ".concat(fa, ": ")).call(Gs, da.start(fa), " to ")).call(gs, da.end(fa), " seconds"));
                    var qs = da.start(fa), El = da.end(fa), kl = El - qs;
                    ha.push({
                      previousBufferSize: Aa,
                      currentBufferSize: kl,
                      bufferTimeStart: qs,
                      bufferTimeEnd: El
                    });
                  }
                  var ju = da.length - 1;
                  return this.timeBuffered = da.end(ju) - da.start(0), this.logger.silly("getBufferTimes finished successfully..."), ha;
                } catch {
                  return this.logger.info("Failed to getBufferTimes..."), null;
                }
              }
              /**
               * Trim the SourceBuffer to help with memory management and to help keep the
               * video stream near-real time (?)
               *
               * @todo - under what circumstances should this be called?  Right now, it is
               * called after EVERY UPDATE_END event!  Is that correct / necessary? Maybe
               * it should only be called every other time, or every 5th time...
               *
               * @param {object[]|null} info
               *   optional, SourceBuffer time info
               * @param {boolean} shouldClear
               *   optional, defaults to false
               *   if true, will clear the entire SourceBuffer's internal buffer
               */
            }, {
              key: "trim",
              value: function() {
                var ha = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.getTimes(), Aa = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                if (!this.isDestroyComplete) {
                  if (this.logger.debug("time buffered: " + this.timeBuffered), !ha || ha.length === 0) {
                    this.logger.debug("Tried to trim buffer, failed to get buffer times...");
                    return;
                  }
                  var da = ha.shift();
                  this.logger.silly("trimBuffer..."), this.metric("sourceBuffer.lastKnownBufferSize", this.timeBuffered);
                  var fa = Aa || this.timeBuffered > this.BUFFER_SIZE_LIMIT;
                  if (!fa) {
                    this.logger.debug("No need to trim");
                    return;
                  }
                  if (!this.isReady()) {
                    this.logger.info("Need to trim, but not ready...");
                    return;
                  }
                  try {
                    if (this.metric("sourceBuffer.trim", this.BUFFER_TRUNCATE_VALUE), Aa)
                      this.logger.debug("Clearing buffer..."), this.sourceBuffer.remove(da.bufferTimeStart, 1 / 0), this.logger.debug("Successfully cleared buffer...");
                    else {
                      var gs = da.bufferTimeStart + this.BUFFER_TRUNCATE_VALUE;
                      this.logger.debug("Trimming buffer..."), this.lastSourceBufferOp = "remove", this.sourceBuffer.remove(da.bufferTimeStart, gs), this.logger.debug("Successfully trimmed buffer...");
                    }
                  } catch (Gs) {
                    if (Gs.constructor.name === "DOMException") {
                      this.logger.info("Encountered DOMException while trying to trim buffer");
                      return;
                    }
                    throw this.logger.debug("trimBuffer failure!"), Gs;
                  }
                }
              }
              /**
               * Completely clear / flush the SourceBuffer's internal buffer.
               *
               * To be called when the buffer is full, prior to the destruction of the
               * parent MediaSource, and during destruction of this SourceBuffer.
               *
               * @todo - it would be better if we could either destroy the SourceBuffer
               * before destroying the parent MediaSource...
               */
            }, {
              key: "clear",
              value: function() {
                var ha;
                this.logger.info("Clearing buffer..."), lc()(ha = this).call(ha, void 0, !0);
              }
            }, {
              key: "metric",
              value: (
                // @todo @metrics
                function() {
                }
              )
            }, {
              key: "_destroy",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  var da = this;
                  return Ko().wrap(function(gs) {
                    for (; ; ) switch (gs.prev = gs.next) {
                      case 0:
                        return gs.next = 2, new (Wi())(function(Gs, qs) {
                          var El = function() {
                            da.sourceBuffer.removeEventListener("updateend", El), Gs();
                          };
                          if (!da.sourceBuffer)
                            return Gs();
                          da.sourceBuffer.addEventListener("updateend", El), da.abort(), da.logger.debug("giving sourceBuffer some time to finish updating itself..."), $l()(El, 1e3);
                        });
                      case 2:
                        try {
                          this.clear();
                        } catch (Gs) {
                          this.logger.error("Error while clearing the buffer while destroying, continuing destroy anyway..."), this.logger.error(Gs);
                        }
                        return this.sourceBuffer.removeEventListener("updateend", Yc(Cd, this)), this.sourceBuffer.removeEventListener("error", Yc(Hf, this)), this.mimeCodec = null, this.mediaSource = null, this.sourceBuffer = null, this.timeBuffered = null, gs.next = 11, uf(oa, "_destroy", this, 3)([]);
                      case 11:
                      case "end":
                        return gs.stop();
                    }
                  }, Aa, this);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }], [{
              key: "getDefaultBufferSizeLimit",
              value: function() {
                return 90 + Math.floor(Math.random() * 200);
              }
              /**
               * Create a new SourceBuffer, which is a wrapper around `window.SourceBuffer`
               *
               * @param {string|object} logId
               *   a string that identifies this SourceBuffer in log messages
               *   @see - src/js/utils/Destroyable
               * @param {string} mimeCodec
               *   The mime codec of the stream
               * @param {MediaSource} mediaSource
               *   The MediaSource instance to which this SourceBuffer instance will be
               *   added
               */
            }, {
              key: "factory",
              value: function(ha, Aa, da) {
                return new oa(ha, Aa, da);
              }
            }]);
          })(Cs);
          Ui(Zd, "events", {
            // --- Custom Events
            ABORT_ERROR: "abort-error",
            DRIFT_THRESHOLD_EXCEEDED: "drift-threshold-exceeded",
            // --- MSE Source Buffer Events
            // @todo - create an event name that makes sense in layman's terms, such
            // as "???" either here or in MSEWrapper
            UPDATE_END: "updateend",
            ERROR: "error"
          });
          var ef;
          function Yp(Ua, oa, ya) {
            return oa = fo(oa), Mi(Ua, Th() ? li()(oa, ya || [], fo(Ua).constructor) : oa.apply(Ua, ya));
          }
          function Th() {
            try {
              var Ua = !Boolean.prototype.valueOf.call(li()(Boolean, [], function() {
              }));
            } catch {
            }
            return (Th = function() {
              return !!Ua;
            })();
          }
          function Jh(Ua, oa, ya, ha) {
            var Aa = Ni(fo(Ua.prototype), oa, ya);
            return 2 & ha && typeof Aa == "function" ? function(da) {
              return Aa.apply(ya, da);
            } : Aa;
          }
          function Eh(Ua, oa) {
            Cp(Ua, oa), oa.add(Ua);
          }
          function Cp(Ua, oa) {
            if (oa.has(Ua)) throw new TypeError("Cannot initialize the same private elements twice on an object");
          }
          function Rd(Ua, oa, ya) {
            if (typeof Ua == "function" ? Ua === oa : Ua.has(oa)) return arguments.length < 3 ? oa : ya;
            throw new TypeError("Private element is not present on this object");
          }
          var Qh = 5, md = /* @__PURE__ */ new (Lo())(), ld = /* @__PURE__ */ (function(Ua) {
            function oa(ya) {
              var ha;
              return fi(this, oa), ha = Yp(this, oa, [ya]), Eh(ha, md), ha.segmentQueue = [], ha.sequenceNumber = 0, ha.mediaSource = null, ha.sourceBuffer = null, ha.appendsSinceTimeEndUpdated = 0, ha.APPENDS_WITH_SAME_TIME_END_THRESHOLD = Qh, ha;
            }
            return No(oa, Ua), Oi(oa, [{
              key: "initialize",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  var da = this;
                  return Ko().wrap(function(gs) {
                    for (; ; ) switch (gs.prev = gs.next) {
                      case 0:
                        if (!this.isDestroyed) {
                          gs.next = 2;
                          break;
                        }
                        throw new Error("Tried to initialize while destroyed");
                      case 2:
                        return this.metric("mediaSource.created", 1), gs.next = 5, this.destroyMediaSource();
                      case 5:
                        this.mediaSource = sf.factory(this.logId), this.mediaSource.on(sf.events.ERROR, function(Gs) {
                          da.emit(oa.events.MEDIA_SOURCE_ERROR, Gs);
                        }), this.sourceBuffer && this.sourceBuffer.abort();
                      case 8:
                      case "end":
                        return gs.stop();
                    }
                  }, Aa, this);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "initializeSourceBuffer",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa(da) {
                  var fa = this;
                  return Ko().wrap(function(Gs) {
                    for (; ; ) switch (Gs.prev = Gs.next) {
                      case 0:
                        if (!this.isDestroyed) {
                          Gs.next = 2;
                          break;
                        }
                        throw new Error("Tried to initialize source buffer while destroyed");
                      case 2:
                        return this.logger.info("initializeSourceBuffer..."), Gs.prev = 3, Gs.next = 6, this.mediaSource.waitUntilReady();
                      case 6:
                        Gs.next = 12;
                        break;
                      case 8:
                        throw Gs.prev = 8, Gs.t0 = Gs.catch(3), this.logger.error("Cannot create the sourceBuffer if the mediaSource is not ready."), Gs.t0;
                      case 12:
                        if (!this.sourceBuffer) {
                          Gs.next = 15;
                          break;
                        }
                        return Gs.next = 15, this.sourceBuffer.destroy();
                      case 15:
                        this.sourceBuffer = Zd.factory(this.logId, da, this.mediaSource), this.metric("sourceBuffer.created", 1), this.sourceBuffer.on(Zd.events.ERROR, function(qs) {
                          fa.emit(oa.events.SOURCE_BUFFER_ERROR, qs);
                        }), this.sourceBuffer.on(Zd.events.UPDATE_END, function(qs) {
                          Rd(md, fa, Od).call(fa);
                        }), this.sourceBuffer.on(Zd.events.DRIFT_THRESHOLD_EXCEEDED, function(qs) {
                          var El, kl = qs.estimatedDrift, ju = qs.driftThreshold;
                          fa.logger.info(Rs()(El = "Estimated drift of ".concat(kl, " is above the ")).call(El, ju, " threshold.  Flushing queue...")), Rd(md, fa, wf).call(fa);
                        }), this.sourceBuffer.on(Zd.events.ABORT_ERROR, function(qs) {
                          var El = qs.error;
                          fa.logger.error("Error while aborting SourceBuffer!"), fa.logger.error(El);
                        });
                      case 21:
                      case "end":
                        return Gs.stop();
                    }
                  }, Aa, this, [[3, 8]]);
                }));
                function ha(Aa) {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "appendMoov",
              value: function(ha) {
                if (!this.isDestroyed) {
                  if (this.logger.info("appendMoov"), !ha)
                    throw new Error("Must provide a moov to append!");
                  this.metric("sourceBuffer.lastMoovSize", ha.length), this.metric("queue.appendMoov", 1), Rd(md, this, zf).call(this, ha), Rd(md, this, ip).call(this);
                }
              }
              /**
               *
               * @param {*} videoSegment
               *   The moof / bytearray
               */
            }, {
              key: "showVideoSegment",
              value: function(ha) {
                if (!this.isDestroyed) {
                  if (this.logger.silly("showVideoSegment"), !ha)
                    throw new Error("Must provide a moof to append!");
                  this.metric("sourceBuffer.lastMoofSize", ha.length), this.metric("queue.append", 1), Rd(md, this, zf).call(this, Rd(md, this, Sh).call(this, ha)), this.sequenceNumber++, Rd(md, this, ip).call(this);
                }
              }
            }, {
              key: "destroyMediaSource",
              value: (
                // @todo - this logic needs to be consolidated into MediaSource or
                // SourceBuffer
                (function() {
                  var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                    return Ko().wrap(function(fa) {
                      for (; ; ) switch (fa.prev = fa.next) {
                        case 0:
                          if (this.mediaSource) {
                            fa.next = 2;
                            break;
                          }
                          return fa.abrupt("return");
                        case 2:
                          this.metric("sourceBuffer.destroyed", 1), this.logger.info("Destroying mediaSource...");
                          try {
                            this.sourceBuffer && this.sourceBuffer.clear();
                          } catch (gs) {
                            Rd(md, this, Rp).call(this, gs);
                          }
                          if (fa.prev = 5, !this.sourceBuffer) {
                            fa.next = 9;
                            break;
                          }
                          return fa.next = 9, this.sourceBuffer.waitUntilReady();
                        case 9:
                          fa.next = 15;
                          break;
                        case 11:
                          fa.prev = 11, fa.t0 = fa.catch(5), this.logger.error("Error: sourceBuffer did not become ready, going to try to destry mediasource anyway!"), this.logger.error(fa.t0);
                        case 15:
                          return fa.next = 17, this.mediaSource.destroy();
                        case 17:
                          this.sourceBuffer && this.sourceBuffer.abort(), this.metric("mediaSource.destroyed", 1);
                        case 19:
                        case "end":
                          return fa.stop();
                      }
                    }, Aa, this, [[5, 11]]);
                  }));
                  function ha() {
                    return ya.apply(this, arguments);
                  }
                  return ha;
                })()
              )
              // @todo @metrics
            }, {
              key: "metric",
              value: function(ha, Aa) {
              }
            }, {
              key: "_destroy",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  return Ko().wrap(function(fa) {
                    for (; ; ) switch (fa.prev = fa.next) {
                      case 0:
                        return fa.prev = 0, fa.next = 3, this.destroyMediaSource();
                      case 3:
                        fa.next = 9;
                        break;
                      case 5:
                        fa.prev = 5, fa.t0 = fa.catch(0), this.logger.error("Error while destroying mediaSource while destroying!"), this.logger.error(fa.t0);
                      case 9:
                        return fa.prev = 9, fa.next = 12, this.sourceBuffer.destroy();
                      case 12:
                        fa.next = 18;
                        break;
                      case 14:
                        fa.prev = 14, fa.t1 = fa.catch(9), this.logger.error("Error while destroying sourceBuffer while destroying!"), this.logger.error(fa.t1);
                      case 18:
                        return this.mediaSource = null, this.sourceBuffer = null, this.previousTimeEnd = null, this.segmentQueue = null, fa.next = 24, Jh(oa, "_destroy", this, 3)([]);
                      case 24:
                      case "end":
                        return fa.stop();
                    }
                  }, Aa, this, [[0, 5], [9, 14]]);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }], [{
              key: "factory",
              value: (
                // @todo @metrics
                // static METRIC_TYPES = [
                //   'mediaSource.created',
                //   'mediaSource.destroyed',
                //   'objectURL.created',
                //   'objectURL.revoked',
                //   'mediaSource.reinitialized',
                //   'sourceBuffer.created',
                //   'sourceBuffer.destroyed',
                //   'queue.added',
                //   'queue.removed',
                //   'sourceBuffer.append',
                //   'error.sourceBuffer.append',
                //   'frameDrop.hiddenTab',
                //   'queue.mediaSourceNotReady',
                //   'queue.sourceBufferNotReady',
                //   'queue.shift',
                //   'queue.append',
                //   'sourceBuffer.lastKnownBufferSize',
                //   'sourceBuffer.trim',
                //   'sourceBuffer.trim.error',
                //   'sourceBuffer.updateEnd',
                //   'sourceBuffer.updateEnd.bufferLength.empty',
                //   'sourceBuffer.updateEnd.bufferLength.error',
                //   'sourceBuffer.updateEnd.removeEvent',
                //   'sourceBuffer.updateEnd.appendEvent',
                //   'sourceBuffer.updateEnd.bufferFrozen',
                //   'sourceBuffer.abort',
                //   'error.sourceBuffer.abort',
                //   'sourceBuffer.lastMoofSize',
                // ];
                /**
                 * Create a new SourceBuffer, which is a wrapper around `window.SourceBuffer`
                 *
                 * @param {string|object} logId
                 *   a string that identifies this SourceBuffer in log messages
                 *   @see - src/js/utils/Destroyable
                 */
                function(ha) {
                  return new oa(ha);
                }
              )
            }]);
          })(Cs);
          ef = ld;
          function wf() {
            this.metric("queue.removed", this.segmentQueue.length + 1), this.segmentQueue = [];
          }
          function zf(Ua) {
            this.segmentQueue.length ? this.logger.debug("Queueing segment.  The queue currently has ".concat(this.segmentQueue.length, " segments.")) : this.logger.silly("Queueing segment.  The queue is currently empty."), this.metric("queue.added", 1), this.segmentQueue.push({
              timestamp: Hi()(),
              byteArray: Ua
            });
          }
          function ip() {
            if (!this.isDestroyed) {
              if (this.logger.silly("#processNextInQueue"), this.segmentQueue.length === 0) {
                this.logger.info("No segments in queue to process");
                return;
              }
              if (ra().isDocumentHidden()) {
                this.logger.debug("Tab not in focus - dropping frame..."), this.metric("frameDrop.hiddenTab", 1), this.metric("queue.cannotProcessNext", 1), this.segmentQueue.shift();
                return;
              }
              if (!this.mediaSource.isReady()) {
                this.metric("queue.mediaSourceNotReady", 1), this.metric("queue.cannotProcessNext", 1), this.logger.warn("Media source not ready"), this.segmentQueue.shift();
                return;
              }
              if (!this.sourceBuffer) {
                this.logger.info("Tried to play before the SourceBuffer was initialized");
                return;
              }
              if (!this.sourceBuffer.isReady()) {
                this.logger.warn("The sourceBuffer is not ready"), this.metric("queue.sourceBufferNotReady", 1), this.metric("queue.cannotProcessNext", 1);
                return;
              }
              this.logger.silly("appending to source buffer"), this.metric("queue.shift", 1), this.metric("queue.canProcessNext", 1), this.segmentQueue.length >= 2 && this.logger.debug("segment queue has " + this.segmentQueue.length + " segments"), this.sourceBuffer.append(this.segmentQueue.shift());
            }
          }
          function Sh(Ua) {
            return Ua[20] = (this.sequenceNumber & 4278190080) >> 24, Ua[21] = (this.sequenceNumber & 16711680) >> 16, Ua[22] = (this.sequenceNumber & 65280) >> 8, Ua[23] = this.sequenceNumber & 255, Ua;
          }
          function Rp(Ua) {
            this.metric("sourceBuffer.trim.error", 1), this.logger.error("sourceBuffer.remove --> Error while trimming sourceBuffer"), this.logger.error(Ua);
          }
          function xh(Ua) {
            if (!Ua)
              throw new Error("Info must be passed to process video segment shown event!");
            if (this.logger.silly("On video segment shown..."), this.metric("sourceBuffer.updateEnd.appendEvent", 1), this.logger.debug("Appends with same time end: " + this.appendsSinceTimeEndUpdated), Ua.bufferTimeEnd <= this.previousTimeEnd) {
              this.logger.info("previoustimeend: " + this.previousTimeEnd + ", buffertimeend: " + Ua.bufferTimeEnd), this.appendsSinceTimeEndUpdated += 1, this.metric("sourceBuffer.updateEnd.bufferFrozen", 1), this.appendsSinceTimeEndUpdated > this.APPENDS_WITH_SAME_TIME_END_THRESHOLD && (this.logger.warn("Stream frozen. Reinitializing"), this.emit(ef.events.STREAM_FROZEN));
              return;
            }
            this.appendsSinceTimeEndUpdated = 0, this.previousTimeEnd = Ua.bufferTimeEnd, this.emit(ef.events.VIDEO_SEGMENT_SHOWN, {
              info: Ua
            });
            try {
              var oa;
              lc()(oa = this.sourceBuffer).call(oa);
            } catch (ya) {
              Rd(md, this, Rp).call(this, ya);
            }
          }
          function Od() {
            this.logger.silly("onUpdateEnd"), this.metric("sourceBuffer.updateEnd", 1);
            var Ua = this.sourceBuffer.getTimes(), oa = Ua[Ua.length - 1];
            Rd(md, this, xh).call(this, oa);
            try {
              Rd(md, this, ip).call(this);
            } catch (ya) {
              this.logger.info("Error while showing video segment!"), this.emit(ef.events.SHOW_VIDEO_SEGMENT_ERROR, {
                error: ya
              });
            }
          }
          Ui(ld, "events", {
            METRIC: "metric",
            STREAM_FROZEN: "stream-frozen",
            VIDEO_SEGMENT_SHOWN: "video-segment-shown",
            SHOW_VIDEO_SEGMENT_ERROR: "show-video-segment-error",
            MEDIA_SOURCE_ERROR: "unexpected-media-source-error",
            SOURCE_BUFFER_ERROR: "unexpected-source-buffer-error"
          });
          var Kf;
          function vc(Ua, oa, ya) {
            return oa = fo(oa), Mi(Ua, Op() ? li()(oa, ya || [], fo(Ua).constructor) : oa.apply(Ua, ya));
          }
          function Op() {
            try {
              var Ua = !Boolean.prototype.valueOf.call(li()(Boolean, [], function() {
              }));
            } catch {
            }
            return (Op = function() {
              return !!Ua;
            })();
          }
          function _f(Ua, oa, ya, ha) {
            var Aa = Ni(fo(Ua.prototype), oa, ya);
            return 2 & ha && typeof Aa == "function" ? function(da) {
              return Aa.apply(ya, da);
            } : Aa;
          }
          function Ap(Ua, oa) {
            op(Ua, oa), oa.add(Ua);
          }
          function op(Ua, oa) {
            if (oa.has(Ua)) throw new TypeError("Cannot initialize the same private elements twice on an object");
          }
          function Sa(Ua, oa, ya) {
            if (typeof Ua == "function" ? Ua === oa : Ua.has(oa)) return arguments.length < 3 ? oa : ya;
            throw new TypeError("Private element is not present on this object");
          }
          var ma = !1, Ho = 5, Io = 2, Ri = /* @__PURE__ */ new (Lo())(), qi = /* @__PURE__ */ (function(Ua) {
            function oa(ya, ha, Aa, da) {
              var fa;
              if (fi(this, oa), fa = vc(this, oa, [ya]), Ap(fa, Ri), Ui(fa, "isInitialized", !1), Ui(fa, "isInitializing", !1), Ui(fa, "isRestarting", !1), Ui(fa, "isTryingToPlay", !1), Ui(fa, "isStopping", !1), Ui(fa, "isStopped", !1), Ui(fa, "clspClientCount", 0), Ui(fa, "clspClient", null), Ui(fa, "streamConfiguration", null), Ui(fa, "firstFrameShown", !1), Ui(fa, "mseWrapper", null), Ui(fa, "moov", null), Ui(fa, "latestSegmentReceivedAt", null), Ui(fa, "segmentIntervalAverage", null), Ui(fa, "intervalBetweenSegments", null), Ui(fa, "segmentIntervals", []), Ui(fa, "ENABLE_METRICS", ma), Ui(fa, "SEGMENT_INTERVAL_SAMPLE_SIZE", Ho), Ui(fa, "DRIFT_CORRECTION_CONSTANT", Io), ga()(ha))
                throw new Error("Tried to construct without an id");
              if (!Aa)
                throw new Error("Tried to construct without a container element");
              if (!da)
                throw new Error("Tried to construct without a video element");
              return fa.id = ha, fa.containerElement = Aa, fa.videoElement = da, fa;
            }
            return No(oa, Ua), Oi(oa, [{
              key: "setStreamConfiguration",
              value: function(ha) {
                if (this.isDestroyed) {
                  this.logger.error("Tried to setStreamConfiguration while destroyed");
                  return;
                }
                if (!rd.isStreamConfiguration(ha))
                  throw new Error("Tried to set invalid streamConfiguration!");
                this.streamConfiguration = ha;
              }
            }, {
              key: "initialize",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  var da = this, fa, gs = arguments;
                  return Ko().wrap(function(qs) {
                    for (; ; ) switch (qs.prev = qs.next) {
                      case 0:
                        if (fa = gs.length > 0 && gs[0] !== void 0 ? gs[0] : !1, !this.isDestroyed) {
                          qs.next = 4;
                          break;
                        }
                        return this.logger.error("Tried to initialize while destroyed"), qs.abrupt("return");
                      case 4:
                        if (!this.isInitializing) {
                          qs.next = 7;
                          break;
                        }
                        return this.logger.info("Initialization already in progress"), qs.abrupt("return");
                      case 7:
                        if (!(this.isInitialized && !fa)) {
                          qs.next = 10;
                          break;
                        }
                        return this.logger.info("Already initialized"), qs.abrupt("return");
                      case 10:
                        if (this.isInitialized = !1, this.isInitializing = !0, this.logger.info("Initializing with ".concat(this.streamConfiguration.streamName)), qs.prev = 13, this.clientId = oa.generateClientId(), !this.clspClient) {
                          qs.next = 18;
                          break;
                        }
                        return qs.next = 18, this.clspClient.destroy();
                      case 18:
                        return this.clspClient = null, this.clspClient = hd.factory(Sa(Ri, this, Fs).call(this), this.clientId, this.streamConfiguration, this.containerElement), this.clspClient.conduit.on(hd.events.RECONNECT_SUCCESS, /* @__PURE__ */ di(/* @__PURE__ */ Ko().mark(function El() {
                          return Ko().wrap(function(ju) {
                            for (; ; ) switch (ju.prev = ju.next) {
                              case 0:
                                return da.logger.info("ClspClient reconnected, restarting..."), ju.prev = 1, ju.next = 4, da.restart();
                              case 4:
                                ju.next = 11;
                                break;
                              case 6:
                                ju.prev = 6, ju.t0 = ju.catch(1), da.logger.error("Error while restarting after reconnection!"), da.logger.error(ju.t0), da.emit(oa.events.RECONNECT_FAILURE, {
                                  error: ju.t0
                                });
                              case 11:
                              case "end":
                                return ju.stop();
                            }
                          }, El, null, [[1, 6]]);
                        }))), this.clspClient.conduit.on(hd.events.RECONNECT_FAILURE, function(El) {
                          var kl = El.error;
                          da.emit(oa.events.RECONNECT_FAILURE, {
                            error: kl
                          });
                        }), this.clspClient.conduit.on(hd.events.ROUTER_EVENT_ERROR, function(El) {
                          var kl = El.error;
                          da.emit(oa.events.ROUTER_EVENT_ERROR, {
                            error: kl
                          });
                        }), this.clspClient.conduit.on(hd.events.RESYNC_STREAM_COMPLETE, function(El) {
                          da.logger.warn("Resyncing stream ".concat(El.streamName, "...")), da.emit(oa.events.RECONNECT_FAILURE, {
                            error: new Error("Resync detected")
                          });
                        }), this.clspClient.conduit.on(hd.events.VIDEO_SEGMENT_RECEIVED, function(El) {
                          Sa(Ri, da, _l).call(da, El.clspMessage.payloadBytes);
                        }), this.clspClient.conduit.on(hd.events.IFRAME_DESTROYED_EXTERNALLY, function() {
                          if (da.isDestroyed) {
                            da.logger.info("Iframe was destroyed externally while in process of destroying");
                            return;
                          }
                          da.emit(oa.events.IFRAME_DESTROYED_EXTERNALLY);
                        }), this.clspClient.conduit.on(hd.events.JWT_AUTHORIZATION_FAILURE, function(El) {
                          da.emit(oa.events.JWT_AUTHORIZATION_FAILURE, {
                            error: El.error,
                            playerId: da.id
                          });
                        }), qs.next = 29, this.clspClient.initialize();
                      case 29:
                        this.isInitialized = !0;
                      case 30:
                        return qs.prev = 30, this.isInitializing = !1, qs.finish(30);
                      case 33:
                      case "end":
                        return qs.stop();
                    }
                  }, Aa, this, [[13, , 30, 33]]);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "restart",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  var da;
                  return Ko().wrap(function(gs) {
                    for (; ; ) switch (gs.prev = gs.next) {
                      case 0:
                        if (!this.isDestroyed) {
                          gs.next = 3;
                          break;
                        }
                        return this.logger.error("Tried to restart while destroyed"), gs.abrupt("return");
                      case 3:
                        if (!this.isRestarting) {
                          gs.next = 6;
                          break;
                        }
                        return this.logger.info("Restart already in progress"), gs.abrupt("return");
                      case 6:
                        if (!this.isInitializing) {
                          gs.next = 9;
                          break;
                        }
                        return this.logger.info("Cannot restart, initialization already in progress"), gs.abrupt("return");
                      case 9:
                        return this.logger.info("restart"), this.isRestarting = !0, gs.prev = 11, da = !this.videoElement.src, gs.next = 15, this.stop();
                      case 15:
                        return gs.next = 17, this.initialize(da);
                      case 17:
                        return gs.next = 19, this.play();
                      case 19:
                        if (!da) {
                          gs.next = 29;
                          break;
                        }
                        return gs.prev = 20, gs.next = 23, Sa(Ri, this, bs).call(this);
                      case 23:
                        gs.next = 29;
                        break;
                      case 25:
                        throw gs.prev = 25, gs.t0 = gs.catch(20), this.logger.error("Error while trying to play CLSP video from video element..."), gs.t0;
                      case 29:
                        return gs.prev = 29, this.isRestarting = !1, gs.finish(29);
                      case 32:
                      case "end":
                        return gs.stop();
                    }
                  }, Aa, this, [[11, , 29, 32], [20, 25]]);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
              /**
               * Note that if an error is thrown during play, the IovPlayer instance should
               * be destroyed to free resources.
               */
            }, {
              key: "play",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  var da, fa, gs;
                  return Ko().wrap(function(qs) {
                    for (; ; ) switch (qs.prev = qs.next) {
                      case 0:
                        if (!this.isDestroyed) {
                          qs.next = 3;
                          break;
                        }
                        return this.logger.info("Tried to play while destroyed"), qs.abrupt("return");
                      case 3:
                        if (!(!this.isInitialized || this.isInitializing)) {
                          qs.next = 5;
                          break;
                        }
                        throw new Error("Tried to play before initializing!");
                      case 5:
                        if (this.isStopping, !this.isTryingToPlay) {
                          qs.next = 9;
                          break;
                        }
                        return this.logger.info("Already trying to play"), qs.abrupt("return");
                      case 9:
                        return this.logger.info("play"), this.isTryingToPlay = !0, qs.prev = 11, qs.next = 14, this.clspClient.conduit.play();
                      case 14:
                        if (da = qs.sent, fa = da.mimeCodec, gs = da.moov, sf.isMimeCodecSupported(fa)) {
                          qs.next = 20;
                          break;
                        }
                        throw this.emit(oa.events.UNSUPPORTED_MIME_CODEC, {
                          mimeCodec: fa
                        }), new Error("Unsupported mime codec: ".concat(fa));
                      case 20:
                        return this.moov = gs, this.mimeCodec = fa, qs.next = 24, Sa(Ri, this, Na).call(this, !1);
                      case 24:
                        this.isPlaying = !0, this.isStopped = !1;
                      case 26:
                        return qs.prev = 26, this.isTryingToPlay = !1, qs.finish(26);
                      case 29:
                      case "end":
                        return qs.stop();
                    }
                  }, Aa, this, [[11, , 26, 29]]);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "stop",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  return Ko().wrap(function(fa) {
                    for (; ; ) switch (fa.prev = fa.next) {
                      case 0:
                        if (!this.isDestroyComplete) {
                          fa.next = 2;
                          break;
                        }
                        throw new Error("Tried to stop after destroyed!");
                      case 2:
                        if (this.isInitialized) {
                          fa.next = 4;
                          break;
                        }
                        throw new Error("Tried to stop before initializing!");
                      case 4:
                        if (!this.isStopped) {
                          fa.next = 7;
                          break;
                        }
                        return this.logger.info("Already stopped"), fa.abrupt("return");
                      case 7:
                        if (!this.isStopping) {
                          fa.next = 10;
                          break;
                        }
                        return this.logger.info("Already stopping"), fa.abrupt("return");
                      case 10:
                        return this.logger.info("stop..."), this.isStopping = !0, this.moov = null, fa.prev = 13, fa.prev = 14, fa.next = 17, this.clspClient.conduit.stop();
                      case 17:
                        fa.next = 23;
                        break;
                      case 19:
                        fa.prev = 19, fa.t0 = fa.catch(14), this.logger.error("failed to stop the clspClient"), this.logger.error(fa.t0);
                      case 23:
                        return fa.prev = 23, fa.next = 26, Sa(Ri, this, Yo).call(this);
                      case 26:
                        fa.next = 32;
                        break;
                      case 28:
                        fa.prev = 28, fa.t1 = fa.catch(23), this.logger.error("Failed to destroy mseWrapper while stopping, continuing anyway..."), this.logger.error(fa.t1);
                      case 32:
                        this.logger.info("stop succeeded"), fa.next = 39;
                        break;
                      case 35:
                        throw fa.prev = 35, fa.t2 = fa.catch(13), this.logger.error("stop failed..."), fa.t2;
                      case 39:
                        return fa.prev = 39, this.isStopping = !1, this.isStopped = !0, fa.finish(39);
                      case 43:
                      case "end":
                        return fa.stop();
                    }
                  }, Aa, this, [[13, 35, 39, 43], [14, 19], [23, 28]]);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "_destroy",
              value: (
                /**
                 * @async
                 */
                (function() {
                  var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                    return Ko().wrap(function(fa) {
                      for (; ; ) switch (fa.prev = fa.next) {
                        case 0:
                          return fa.prev = 0, fa.next = 3, this.stop();
                        case 3:
                          fa.next = 9;
                          break;
                        case 5:
                          fa.prev = 5, fa.t0 = fa.catch(0), this.logger.error("Error encountered while trying to stop during Iov Player destroy, continuing with destroy..."), this.logger.error(fa.t0);
                        case 9:
                          return fa.next = 11, this.clspClient.destroy();
                        case 11:
                          return this.clspClient = null, this.streamConfiguration = null, this.firstFrameShown = null, this.moov = null, this.latestSegmentReceivedAt = null, this.segmentIntervalAverage = null, this.intervalBetweenSegments = null, this.segmentIntervals = null, fa.next = 21, _f(oa, "_destroy", this, 3)([]);
                        case 21:
                        case "end":
                          return fa.stop();
                      }
                    }, Aa, this, [[0, 5]]);
                  }));
                  function ha() {
                    return ya.apply(this, arguments);
                  }
                  return ha;
                })()
              )
            }], [{
              key: "factory",
              value: (
                // @todo @metrics
                // static METRIC_TYPES = [
                //   'sourceBuffer.bufferTimeEnd',
                //   'video.currentTime',
                //   'video.drift',
                //   'video.driftCorrection',
                //   'video.intervalBetweenSegments',
                //   'video.segmentIntervalAverage',
                // ];
                /**
                 * Construct a new IovPlayer
                 *
                 * @param {string} logId
                 *   a string that identifies this IovPlayer in log messages
                 * @param {HTMLElement} containerElement
                 *   The container element that will contain the iframe
                 * @param {HTMLElement} videoElement
                 *   The video element that will be used to play the CLSP stream
                 */
                function(ha, Aa, da, fa) {
                  return new oa(ha, Aa, da, fa);
                }
              )
            }, {
              key: "generateClientId",
              value: function() {
                return [ra().name, ra().version.replace("+", "-build-"), Ws()].join("--");
              }
            }]);
          })(Cs);
          Kf = qi;
          function Yo() {
            return ba.apply(this, arguments);
          }
          function ba() {
            return ba = di(/* @__PURE__ */ Ko().mark(function Ua() {
              return Ko().wrap(function(ya) {
                for (; ; ) switch (ya.prev = ya.next) {
                  case 0:
                    if (!this.mseWrapper) {
                      ya.next = 7;
                      break;
                    }
                    return ya.prev = 1, ya.next = 4, this.mseWrapper.destroy();
                  case 4:
                    return ya.prev = 4, this.mseWrapper = null, ya.finish(4);
                  case 7:
                  case "end":
                    return ya.stop();
                }
              }, Ua, this, [[1, , 4, 7]]);
            })), ba.apply(this, arguments);
          }
          function Na() {
            return Ma.apply(this, arguments);
          }
          function Ma() {
            return Ma = di(/* @__PURE__ */ Ko().mark(function Ua() {
              var oa = this, ya, ha = arguments;
              return Ko().wrap(function(da) {
                for (; ; ) switch (da.prev = da.next) {
                  case 0:
                    if (ya = ha.length > 0 && ha[0] !== void 0 ? ha[0] : !0, !this.isDestroyed) {
                      da.next = 4;
                      break;
                    }
                    return this.logger.warn("Tried to reinitializeMseWrapper while destroyed..."), da.abrupt("return");
                  case 4:
                    return this.logger.info("reinitializeMseWrapper"), da.prev = 5, da.next = 8, Sa(Ri, this, Yo).call(this);
                  case 8:
                    da.next = 14;
                    break;
                  case 10:
                    da.prev = 10, da.t0 = da.catch(5), this.logger.error("Failed to destroy mseWrapper while reinitializing mseWrapper, continuing anyway..."), this.logger.error(da.t0);
                  case 14:
                    return this.mseWrapper = null, this.mseWrapper = ld.factory(this.logId, this.videoElement), this.mseWrapper.on(ld.events.METRIC, function(fa) {
                      var gs = fa.type, Gs = fa.value;
                      Sa(Ri, oa, eu).call(oa, gs, Gs);
                    }), this.mseWrapper.on(ld.events.SHOW_VIDEO_SEGMENT_ERROR, function(fa) {
                      var gs = fa.error;
                      oa.logger.error("Error while showing video segment!"), oa.logger.error(gs), Sa(Ri, oa, Na).call(oa);
                    }), this.mseWrapper.on(ld.events.MEDIA_SOURCE_ERROR, function(fa) {
                      oa.logger.warn("mediaSource.generic --> mediaSource error"), oa.logger.error(fa), Sa(Ri, oa, Na).call(oa);
                    }), this.mseWrapper.on(ld.events.SOURCE_BUFFER_ERROR, function(fa) {
                      oa.logger.debug("sourceBuffer.generic --> sourceBuffer error"), Sa(Ri, oa, Na).call(oa);
                    }), this.mseWrapper.on(ld.events.STREAM_FROZEN, function() {
                      oa.logger.info("stream appears to be frozen - reinitializing..."), Sa(Ri, oa, Na).call(oa);
                    }), this.mseWrapper.on(ld.events.VIDEO_SEGMENT_SHOWN, /* @__PURE__ */ (function() {
                      var fa = di(/* @__PURE__ */ Ko().mark(function gs(Gs) {
                        var qs;
                        return Ko().wrap(function(kl) {
                          for (; ; ) switch (kl.prev = kl.next) {
                            case 0:
                              if (qs = Gs.info, !oa.isDestroyed) {
                                kl.next = 4;
                                break;
                              }
                              return oa.logger.warn("Got video segement while destroyed..."), kl.abrupt("return");
                            case 4:
                              if (oa.logger.silly("On Append Finish..."), oa.firstFrameShown || (oa.firstFrameShown = !0, oa.videoElement.id = oa.clientId, oa.videoElement.dataset.name = oa.streamConfiguration.streamName, oa.emit(Kf.events.FIRST_FRAME_SHOWN)), oa.drift = qs.bufferTimeEnd - oa.videoElement.currentTime, Sa(Ri, oa, eu).call(oa, "sourceBuffer.bufferTimeEnd", qs.bufferTimeEnd), Sa(Ri, oa, eu).call(oa, "video.currentTime", oa.videoElement.currentTime), Sa(Ri, oa, eu).call(oa, "video.drift", oa.drift), oa.drift > oa.segmentIntervalAverage / 1e3 + oa.DRIFT_CORRECTION_CONSTANT && (Sa(Ri, oa, eu).call(oa, "video.driftCorrection", 1), oa.videoElement.currentTime = qs.bufferTimeEnd), oa.videoElement.paused !== !0) {
                                kl.next = 23;
                                break;
                              }
                              return oa.logger.info("Video is paused!"), kl.prev = 13, kl.next = 16, Sa(Ri, oa, bs).call(oa);
                            case 16:
                              kl.next = 23;
                              break;
                            case 18:
                              kl.prev = 18, kl.t0 = kl.catch(13), oa.logger.error("Error while trying to play CLSP video from video element..."), oa.logger.error(kl.t0), Sa(Ri, oa, Na).call(oa);
                            case 23:
                            case "end":
                              return kl.stop();
                          }
                        }, gs, null, [[13, 18]]);
                      }));
                      return function(gs) {
                        return fa.apply(this, arguments);
                      };
                    })()), da.prev = 22, da.next = 25, this.mseWrapper.initialize();
                  case 25:
                    this.videoElement.src = "", this.videoElement.src = this.mseWrapper.mediaSource.asObjectURL(), this.mseWrapper.mediaSource.on(sf.events.SOURCE_OPEN_ERROR, function(fa) {
                      var gs = fa.error;
                      oa.logger.error('Failed to initialize mediaSource - Error on "sourceopen" event:'), oa.logger.error(gs), Sa(Ri, oa, Na).call(oa);
                    }), this.mseWrapper.mediaSource.on(sf.events.SOURCE_OPEN, /* @__PURE__ */ (function() {
                      var fa = di(/* @__PURE__ */ Ko().mark(function gs(Gs) {
                        return Ko().wrap(function(El) {
                          for (; ; ) switch (El.prev = El.next) {
                            case 0:
                              return oa.logger.info("on mediaSource sourceopen"), El.prev = 1, El.prev = 2, El.next = 5, oa.mseWrapper.initializeSourceBuffer(oa.mimeCodec);
                            case 5:
                              El.next = 11;
                              break;
                            case 7:
                              throw El.prev = 7, El.t0 = El.catch(2), oa.logger.warn("Error while initializing SourceBuffer!"), El.t0;
                            case 11:
                              oa.emit(Kf.events.VIDEO_INFO_RECEIVED), El.prev = 12, oa.mseWrapper.appendMoov(oa.moov), El.next = 20;
                              break;
                            case 16:
                              throw El.prev = 16, El.t1 = El.catch(12), oa.logger.warn("Error while appending moov!"), El.t1;
                            case 20:
                              El.next = 26;
                              break;
                            case 22:
                              El.prev = 22, El.t2 = El.catch(1), oa.logger.warn(El.t2), oa.emit(Kf.events.REINITIALZE_ERROR, {
                                error: El.t2
                              });
                            case 26:
                            case "end":
                              return El.stop();
                          }
                        }, gs, null, [[1, 22], [2, 7], [12, 16]]);
                      }));
                      return function(gs) {
                        return fa.apply(this, arguments);
                      };
                    })()), this.mseWrapper.mediaSource.on(sf.events.SOURCE_ENDED, /* @__PURE__ */ (function() {
                      var fa = di(/* @__PURE__ */ Ko().mark(function gs(Gs) {
                        return Ko().wrap(function(El) {
                          for (; ; ) switch (El.prev = El.next) {
                            case 0:
                              return oa.logger.info("on mediaSource sourceended"), El.prev = 1, El.next = 4, oa.stop();
                            case 4:
                              El.next = 10;
                              break;
                            case 6:
                              El.prev = 6, El.t0 = El.catch(1), oa.logger.error("Error while stopping in SOURCE_ENDED event!"), oa.logger.error(El.t0);
                            case 10:
                            case "end":
                              return El.stop();
                          }
                        }, gs, null, [[1, 6]]);
                      }));
                      return function(gs) {
                        return fa.apply(this, arguments);
                      };
                    })()), da.next = 39;
                    break;
                  case 32:
                    if (da.prev = 32, da.t1 = da.catch(22), !ya) {
                      da.next = 38;
                      break;
                    }
                    this.emit(Kf.events.REINITIALZE_ERROR, {
                      error: da.t1
                    }), da.next = 39;
                    break;
                  case 38:
                    throw da.t1;
                  case 39:
                  case "end":
                    return da.stop();
                }
              }, Ua, this, [[5, 10], [22, 32]]);
            })), Ma.apply(this, arguments);
          }
          function bs() {
            return Ds.apply(this, arguments);
          }
          function Ds() {
            return Ds = di(/* @__PURE__ */ Ko().mark(function Ua() {
              return Ko().wrap(function(ya) {
                for (; ; ) switch (ya.prev = ya.next) {
                  case 0:
                    return ya.next = 2, this.videoElement.play();
                  case 2:
                  case "end":
                    return ya.stop();
                }
              }, Ua, this);
            })), Ds.apply(this, arguments);
          }
          function Fs() {
            var Ua;
            return Rs()(Ua = "".concat(this.logId, ".clspClient:")).call(Ua, ++this.clspClientCount);
          }
          function _l(Ua) {
            if (!this.isStopped && (this.emit(Kf.events.VIDEO_RECEIVED), Sa(Ri, this, Ll).call(this), !!this.mseWrapper)) {
              if (ra().isDocumentHidden()) {
                this.logger.info("Document is in hidden state, not appending moof");
                return;
              }
              try {
                this.mseWrapper.showVideoSegment(Ua), this.clspClient.conduit.segmentUsed(Ua);
              } catch (oa) {
                this.logger.error("Error while trying to show video segment!"), this.logger.error(oa), Sa(Ri, this, Na).call(this);
              }
            }
          }
          function Ll() {
            if (!this.latestSegmentReceivedAt) {
              this.latestSegmentReceivedAt = Hi()();
              return;
            }
            var Ua = this.latestSegmentReceivedAt;
            if (this.latestSegmentReceivedAt = Hi()(), this.intervalBetweenSegments = this.latestSegmentReceivedAt - Ua, !!this.intervalBetweenSegments) {
              this.segmentIntervals.length >= this.SEGMENT_INTERVAL_SAMPLE_SIZE && this.segmentIntervals.shift(), this.segmentIntervals.push(this.intervalBetweenSegments);
              for (var oa = 0, ya = 0; ya < this.segmentIntervals.length; ya++)
                oa += this.segmentIntervals[ya];
              this.segmentIntervalAverage = oa / this.segmentIntervals.length, Sa(Ri, this, eu).call(this, "video.intervalBetweenSegments", this.intervalBetweenSegments), Sa(Ri, this, eu).call(this, "video.segmentIntervalAverage", this.segmentIntervalAverage);
            }
          }
          function eu(Ua, oa) {
          }
          Ui(qi, "events", {
            METRIC: "metric",
            UNSUPPORTED_MIME_CODEC: "unsupportedMimeCodec",
            FIRST_FRAME_SHOWN: "firstFrameShown",
            VIDEO_RECEIVED: "videoReceived",
            VIDEO_INFO_RECEIVED: "videoInfoReceived",
            REINITIALZE_ERROR: "reinitialize-error",
            IFRAME_DESTROYED_EXTERNALLY: Hd.events.IFRAME_DESTROYED_EXTERNALLY,
            RECONNECT_FAILURE: Hd.events.RECONNECT_FAILURE,
            ROUTER_EVENT_ERROR: Hd.events.ROUTER_EVENT_ERROR,
            JWT_AUTHORIZATION_FAILURE: Hd.events.JWT_AUTHORIZATION_FAILURE
          });
          var fu;
          function Fu(Ua, oa, ya) {
            return oa = fo(oa), Mi(Ua, Ou() ? li()(oa, ya || [], fo(Ua).constructor) : oa.apply(Ua, ya));
          }
          function Ou() {
            try {
              var Ua = !Boolean.prototype.valueOf.call(li()(Boolean, [], function() {
              }));
            } catch {
            }
            return (Ou = function() {
              return !!Ua;
            })();
          }
          function qu(Ua, oa) {
            Ju(Ua, oa), oa.add(Ua);
          }
          function Ju(Ua, oa) {
            if (oa.has(Ua)) throw new TypeError("Cannot initialize the same private elements twice on an object");
          }
          function nc(Ua, oa, ya) {
            if (typeof Ua == "function" ? Ua === oa : Ua.has(oa)) return arguments.length < 3 ? oa : ya;
            throw new TypeError("Private element is not present on this object");
          }
          var $c = 100, Rc = /* @__PURE__ */ new (Lo())(), xc = /* @__PURE__ */ (function(Ua) {
            function oa(ya) {
              var ha;
              return fi(this, oa), ha = Fu(this, oa, [ya]), qu(ha, Rc), ha.initialize(), ha.MAX_RETRIES_ON_PLAY_ERROR = $c, ha;
            }
            return No(oa, Ua), Oi(oa, [{
              key: "initialize",
              value: function() {
                this.logger.info("Initializing"), this.players = {}, this.playerStack = [], this.playerLogMessageIds = {}, this.retryAttempts = {}, this.mostRecentlyPlayedId = null, this.mostRecentlyAddedId = null, this.totalPlayersAdded = 0, this.pendingRemoval = {};
              }
            }, {
              key: "generatePlayerLogId",
              value: function(ha) {
                var Aa, da;
                return Rs()(Aa = Rs()(da = "".concat(this.logId, ".player:")).call(da, this.totalPlayersAdded, ":")).call(Aa, ha);
              }
            }, {
              key: "create",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa(da, fa, gs) {
                  var Gs, qs;
                  return Ko().wrap(function(kl) {
                    for (; ; ) switch (kl.prev = kl.next) {
                      case 0:
                        return Gs = this._create(da, fa, gs), qs = Gs.id, nc(Rc, this, Ip).call(this, Gs), kl.next = 5, nc(Rc, this, tf).call(this, qs);
                      case 5:
                        return kl.abrupt("return", qs);
                      case 6:
                      case "end":
                        return kl.stop();
                    }
                  }, Aa, this);
                }));
                function ha(Aa, da, fa) {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "_create",
              value: function(ha, Aa, da) {
                var fa = this;
                if (!ha)
                  throw new Error("A container element is required to create an IovPlayer");
                if (!Aa)
                  throw new Error("A video element is required to create an IovPlayer");
                if (!da)
                  throw new Error("stream configuration is required to create an IovPlayer");
                this.totalPlayersAdded++;
                var gs = Ws(), Gs = qi.factory(this.generatePlayerLogId(da.streamName), gs, ha, Aa);
                return Gs.setStreamConfiguration(da), Gs.on(qi.events.IFRAME_DESTROYED_EXTERNALLY, function() {
                  if (fa.isDestroyed) {
                    fa.logger.info("Iframe was destroyed externally while in process of destroying");
                    return;
                  }
                  fa.emit(oa.events.IFRAME_DESTROYED_EXTERNALLY, {
                    id: gs
                  });
                }), Gs.on(qi.events.VIDEO_RECEIVED, function() {
                  fa.emit(oa.events.VIDEO_RECEIVED, {
                    id: gs
                  });
                }), Gs.on(qi.events.VIDEO_INFO_RECEIVED, function() {
                  fa.emit(oa.events.VIDEO_INFO_RECEIVED, {
                    id: gs
                  });
                }), Gs.on(qi.events.FIRST_FRAME_SHOWN, /* @__PURE__ */ di(/* @__PURE__ */ Ko().mark(function qs() {
                  return Ko().wrap(function(kl) {
                    for (; ; ) switch (kl.prev = kl.next) {
                      case 0:
                        fa.emit(oa.events.FIRST_FRAME_SHOWN, {
                          id: gs
                        }), fa.mostRecentlyPlayedId = gs;
                        try {
                          fa.logger.info("First frame received for ".concat(fa.playerLogMessageIds[gs], ", destroying all previous players...")), fa.destroyAllPreviousPlayers(gs);
                        } catch (ju) {
                          fa.logger.error("Error while destroying previous players for ".concat(fa.playerLogMessageIds[gs])), fa.logger.error(ju);
                        }
                      case 3:
                      case "end":
                        return kl.stop();
                    }
                  }, qs);
                }))), Gs.on(qi.events.RECONNECT_FAILURE, /* @__PURE__ */ di(/* @__PURE__ */ Ko().mark(function qs() {
                  return Ko().wrap(function(kl) {
                    for (; ; ) switch (kl.prev = kl.next) {
                      case 0:
                        return kl.prev = 0, fa.logger.info("Critical player error RECONNECT_FAILURE for player ".concat(fa.playerLogMessageIds[gs])), kl.next = 4, nc(Rc, fa, vd).call(fa, gs, qi.events.RECONNECT_FAILURE);
                      case 4:
                        kl.next = 10;
                        break;
                      case 6:
                        kl.prev = 6, kl.t0 = kl.catch(0), fa.logger.error("Error while handling player error RECONNECT_FAILURE for player ".concat(fa.playerLogMessageIds[gs])), fa.logger.error(kl.t0);
                      case 10:
                      case "end":
                        return kl.stop();
                    }
                  }, qs, null, [[0, 6]]);
                }))), Gs.on(qi.events.ROUTER_EVENT_ERROR, /* @__PURE__ */ di(/* @__PURE__ */ Ko().mark(function qs() {
                  return Ko().wrap(function(kl) {
                    for (; ; ) switch (kl.prev = kl.next) {
                      case 0:
                        return kl.prev = 0, fa.logger.info("Critical player error ROUTER_EVENT_ERROR for player ".concat(fa.playerLogMessageIds[gs])), kl.next = 4, nc(Rc, fa, vd).call(fa, gs, qi.events.ROUTER_EVENT_ERROR);
                      case 4:
                        kl.next = 10;
                        break;
                      case 6:
                        kl.prev = 6, kl.t0 = kl.catch(0), fa.logger.error("Error while handling player error ROUTER_EVENT_ERROR for player ".concat(fa.playerLogMessageIds[gs])), fa.logger.error(kl.t0);
                      case 10:
                      case "end":
                        return kl.stop();
                    }
                  }, qs, null, [[0, 6]]);
                }))), Gs.on(qi.events.REINITIALZE_ERROR, /* @__PURE__ */ di(/* @__PURE__ */ Ko().mark(function qs() {
                  return Ko().wrap(function(kl) {
                    for (; ; ) switch (kl.prev = kl.next) {
                      case 0:
                        return kl.prev = 0, fa.logger.info("Critical player error REINITIALZE_ERROR for player ".concat(fa.playerLogMessageIds[gs])), kl.next = 4, nc(Rc, fa, vd).call(fa, gs, qi.events.REINITIALZE_ERROR);
                      case 4:
                        kl.next = 10;
                        break;
                      case 6:
                        kl.prev = 6, kl.t0 = kl.catch(0), fa.logger.error("Error while handling player error REINITIALZE_ERROR for player ".concat(fa.playerLogMessageIds[gs])), fa.logger.error(kl.t0);
                      case 10:
                      case "end":
                        return kl.stop();
                    }
                  }, qs, null, [[0, 6]]);
                }))), Gs.on(qi.events.JWT_AUTHORIZATION_FAILURE, function(qs) {
                  fa.logger.error("Critical JWT authorization error: ".concat(qs.error)), fa.retryAttempts[gs] = fa.MAX_RETRIES_ON_PLAY_ERROR + 1;
                }), Gs;
              }
            }, {
              key: "destroyAllPreviousPlayers",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa(da) {
                  var fa, gs, Gs, qs;
                  return Ko().wrap(function(kl) {
                    for (; ; ) switch (kl.prev = kl.next) {
                      case 0:
                        if (Gs = _s()(fa = this.playerStack).call(fa, da), Gs !== -1) {
                          kl.next = 3;
                          break;
                        }
                        return kl.abrupt("return");
                      case 3:
                        return qs = Ps()(gs = this.playerStack).call(gs, 0, Gs), kl.prev = 4, kl.next = 7, this.removeMany(qs);
                      case 7:
                        kl.next = 13;
                        break;
                      case 9:
                        kl.prev = 9, kl.t0 = kl.catch(4), this.logger.error("Error(s) while destroying players before ".concat(this.playerLogMessageIds[da], ", continuing anyway...")), this.logger.error(kl.t0);
                      case 13:
                      case "end":
                        return kl.stop();
                    }
                  }, Aa, this, [[4, 9]]);
                }));
                function ha(Aa) {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "has",
              value: function(ha) {
                return ga()(ha) || this.pendingRemoval[ha] ? !1 : Object.prototype.hasOwnProperty.call(this.players, ha);
              }
            }, {
              key: "get",
              value: function(ha) {
                return this.has(ha) ? this.players[ha] : null;
              }
            }, {
              key: "remove",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa(da) {
                  var fa, gs, Gs, qs, El, kl;
                  return Ko().wrap(function(Yu) {
                    for (; ; ) switch (Yu.prev = Yu.next) {
                      case 0:
                        if (gs = this.get(da), gs !== null) {
                          Yu.next = 3;
                          break;
                        }
                        return Yu.abrupt("return");
                      case 3:
                        return gs.logger.info("IovPlayerCollection - removing player..."), Gs = this.playerLogMessageIds[da], this.pendingRemoval[da] = !0, this.mostRecentlyPlayedId === da && (this.mostRecentlyPlayedId = null), qs = _s()(fa = this.playerStack).call(fa, da), qs !== -1 && Vs()(El = this.playerStack).call(El, qs, 1), this.mostRecentlyAddedId === da && (kl = this.playerStack.length, kl === 0 ? this.mostRecentlyAddedId = null : this.mostRecentlyAddedId = this.playerStack[kl - 1]), delete this.players[da], delete this.playerLogMessageIds[da], delete this.pendingRemoval[da], Yu.prev = 13, Yu.next = 16, gs.destroy();
                      case 16:
                        Yu.next = 22;
                        break;
                      case 18:
                        Yu.prev = 18, Yu.t0 = Yu.catch(13), this.logger.error("Error destroying IovPlayer ".concat(Gs, " while removing, continuing anyway")), this.logger.error(Yu.t0);
                      case 22:
                      case "end":
                        return Yu.stop();
                    }
                  }, Aa, this, [[13, 18]]);
                }));
                function ha(Aa) {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "removeMany",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa(da) {
                  var fa = this, gs, Gs, qs;
                  return Ko().wrap(function(kl) {
                    for (; ; ) switch (kl.prev = kl.next) {
                      case 0:
                        return gs = Is()(da).call(da, function(ju) {
                          return fa.remove(ju);
                        }), kl.next = 3, Wi().allSettled(gs);
                      case 3:
                        if (Gs = kl.sent, qs = sl()(Gs).call(Gs, function(ju, Yu) {
                          return Yu.status !== "fulfilled" && ju.push(Yu), ju;
                        }, []), !qs.length) {
                          kl.next = 9;
                          break;
                        }
                        throw this.logger.error("Error(s) encountered while destroying IovPlayer(s) during removeMany..."), Vl()(qs).call(qs, function(ju) {
                          fa.logger.error(ju.reason);
                        }), qs[0].reason;
                      case 9:
                      case "end":
                        return kl.stop();
                    }
                  }, Aa, this);
                }));
                function ha(Aa) {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "removeAll",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  var da;
                  return Ko().wrap(function(gs) {
                    for (; ; ) switch (gs.prev = gs.next) {
                      case 0:
                        return da = ql()(this.players), gs.next = 3, this.removeMany(da);
                      case 3:
                      case "end":
                        return gs.stop();
                    }
                  }, Aa, this);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "_destroy",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  return Ko().wrap(function(fa) {
                    for (; ; ) switch (fa.prev = fa.next) {
                      case 0:
                        return fa.prev = 0, fa.next = 3, this.removeAll();
                      case 3:
                        fa.next = 9;
                        break;
                      case 5:
                        fa.prev = 5, fa.t0 = fa.catch(0), this.logger.error("Error(s) encountered while removing while destroying, continuing anyway..."), this.logger.error(fa.t0);
                      case 9:
                        this.players = null, this.playerLogMessageIds = null, this.pendingRemoval = null, this.playerStack = null;
                      case 13:
                      case "end":
                        return fa.stop();
                    }
                  }, Aa, this, [[0, 5]]);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }], [{
              key: "factory",
              value: function(ha) {
                return new oa(ha);
              }
            }]);
          })(Cs);
          fu = xc;
          function vd(Ua, oa) {
            return zu.apply(this, arguments);
          }
          function zu() {
            return zu = di(/* @__PURE__ */ Ko().mark(function Ua(oa, ya) {
              var ha, Aa, da;
              return Ko().wrap(function(gs) {
                for (; ; ) switch (gs.prev = gs.next) {
                  case 0:
                    if (!(oa === this.mostRecentlyPlayedId || oa === this.mostRecentlyAddedId)) {
                      gs.next = 12;
                      break;
                    }
                    return this.logger.info(Rs()(Aa = "Active IovPlayer ".concat(this.playerLogMessageIds[oa], ' emitted the "')).call(Aa, ya, '" event, recreating it...')), gs.prev = 2, gs.next = 5, nc(Rc, this, Fc).call(this, oa);
                  case 5:
                    gs.next = 11;
                    break;
                  case 7:
                    gs.prev = 7, gs.t0 = gs.catch(2), this.logger.error("Error while recreating ".concat(this.playerLogMessageIds[oa])), this.logger.error(gs.t0);
                  case 11:
                    return gs.abrupt("return");
                  case 12:
                    return this.logger.info(Rs()(ha = "Stale IovPlayer ".concat(this.playerLogMessageIds[oa], ' emitted the "')).call(ha, ya, '" event, destroying it...')), gs.prev = 13, gs.next = 16, this.remove(oa);
                  case 16:
                    gs.next = 22;
                    break;
                  case 18:
                    gs.prev = 18, gs.t1 = gs.catch(13), this.logger.error(Rs()(da = "Error while removing Stale IovPlayer ".concat(this.playerLogMessageIds[oa], ' during "')).call(da, ya, '" event, continuing anyway...')), this.logger.error(gs.t1);
                  case 22:
                  case "end":
                    return gs.stop();
                }
              }, Ua, this, [[2, 7], [13, 18]]);
            })), zu.apply(this, arguments);
          }
          function ic(Ua, oa) {
            var ya, ha = _s()(ya = this.playerStack).call(ya, Ua);
            if (ha === -1)
              throw new Error("Cannot replace ".concat(this.playerLogMessageIds[Ua], " in stack because it doesn't exist in the stack..."));
            this.playerStack[ha] = oa;
          }
          function Fc(Ua) {
            return kd.apply(this, arguments);
          }
          function kd() {
            return kd = di(/* @__PURE__ */ Ko().mark(function Ua(oa) {
              var ya = this, ha, Aa, da, fa;
              return Ko().wrap(function(Gs) {
                for (; ; ) switch (Gs.prev = Gs.next) {
                  case 0:
                    if (ha = this.get(oa), ha !== null) {
                      Gs.next = 3;
                      break;
                    }
                    throw new Error("Cannot recreate IovPlayer with non-existent id ".concat(oa));
                  case 3:
                    return Aa = this.playerLogMessageIds[oa], da = this._create(ha.containerElement, ha.videoElement, ha.streamConfiguration), fa = da.id, this.players[fa] = da, this.playerLogMessageIds[fa] = this.totalPlayersAdded, this.retryAttempts[fa] = 0, nc(Rc, this, ic).call(this, oa, fa), this.mostRecentlyAddedId === oa && (this.mostRecentlyAddedId = fa), this.mostRecentlyPlayedId === oa && (this.mostRecentlyPlayedId = fa), this.remove(oa).catch(function(qs) {
                      ya.logger.error("Error while removing player ".concat(Aa, " while recreating, continuing anyway...")), ya.logger.error(qs);
                    }), Gs.next = 15, nc(Rc, this, tf).call(this, fa);
                  case 15:
                  case "end":
                    return Gs.stop();
                }
              }, Ua, this);
            })), kd.apply(this, arguments);
          }
          function tf(Ua) {
            return Ad.apply(this, arguments);
          }
          function Ad() {
            return Ad = di(/* @__PURE__ */ Ko().mark(function Ua(oa) {
              var ya, ha;
              return Ko().wrap(function(da) {
                for (; ; ) switch (da.prev = da.next) {
                  case 0:
                    if (ya = this.get(oa), ya !== null) {
                      da.next = 3;
                      break;
                    }
                    throw new Error("Cannot play - IovPlayer id ".concat(oa, " doesn't exist"));
                  case 3:
                    return da.prev = 3, da.next = 6, ya.initialize();
                  case 6:
                    return da.next = 8, ya.play();
                  case 8:
                    ya.logger.info("Play succeeded!"), da.next = 26;
                    break;
                  case 11:
                    if (da.prev = 11, da.t0 = da.catch(3), this.logger.error("Error while trying to play IovPlayer ".concat(this.playerLogMessageIds[oa], "...")), this.logger.error(da.t0), !(this.MAX_RETRIES_ON_PLAY_ERROR > 0 && this.retryAttempts[oa] <= this.MAX_RETRIES_ON_PLAY_ERROR)) {
                      da.next = 21;
                      break;
                    }
                    return this.logger.warn(Rs()(ha = "Retry play attempt #".concat(this.retryAttempts[oa]++, " for player ")).call(ha, this.playerLogMessageIds[oa], "...")), da.next = 19, nc(Rc, this, tf).call(this, oa);
                  case 19:
                    da.next = 26;
                    break;
                  case 21:
                    return this.logger.error("Destroying IovPlayer after exhausting play and retry attempts"), this.emit(fu.events.DISPLAY_ERROR_MSG, {
                      error: da.t0
                    }), da.next = 25, this.remove(oa);
                  case 25:
                    throw da.t0;
                  case 26:
                  case "end":
                    return da.stop();
                }
              }, Ua, this, [[3, 11]]);
            })), Ad.apply(this, arguments);
          }
          function Ip(Ua) {
            var oa = Ua.id;
            if (this.has(oa))
              throw new Error("Cannot add an iovPlayer without a unique id");
            this.players[oa] = Ua, this.playerLogMessageIds[oa] = this.totalPlayersAdded, this.retryAttempts[oa] = 0, this.mostRecentlyAddedId = oa, this.playerStack.push(oa);
          }
          Ui(xc, "events", {
            // Needed for videojs plugin
            VIDEO_RECEIVED: qi.events.VIDEO_RECEIVED,
            // Needed for videojs plugin
            VIDEO_INFO_RECEIVED: qi.events.VIDEO_INFO_RECEIVED,
            FIRST_FRAME_SHOWN: qi.events.FIRST_FRAME_SHOWN,
            IFRAME_DESTROYED_EXTERNALLY: qi.events.IFRAME_DESTROYED_EXTERNALLY,
            DISPLAY_ERROR_MSG: qi.events.DISPLAY_ERROR_MSG
          });
          function Xp(Ua, oa, ya) {
            return oa = fo(oa), Mi(Ua, Pf() ? li()(oa, ya || [], fo(Ua).constructor) : oa.apply(Ua, ya));
          }
          function Pf() {
            try {
              var Ua = !Boolean.prototype.valueOf.call(li()(Boolean, [], function() {
              }));
            } catch {
            }
            return (Pf = function() {
              return !!Ua;
            })();
          }
          function cf(Ua, oa, ya, ha) {
            var Aa = Ni(fo(Ua.prototype), oa, ya);
            return 2 & ha && typeof Aa == "function" ? function(da) {
              return Aa.apply(ya, da);
            } : Aa;
          }
          function Jp(Ua, oa) {
            rf(Ua, oa), oa.add(Ua);
          }
          function rf(Ua, oa) {
            if (oa.has(Ua)) throw new TypeError("Cannot initialize the same private elements twice on an object");
          }
          function Qp(Ua, oa, ya) {
            if (typeof Ua == "function" ? Ua === oa : Ua.has(oa)) return arguments.length < 3 ? oa : ya;
            throw new TypeError("Private element is not present on this object");
          }
          var Zh = !1, df = 5, Zp = "clsp-player-container", ap = "clsp-player", Eg = "clsp-player-loading-animation", sp = "clsp-player-error-msg", lp = /* @__PURE__ */ new (Lo())(), eh = /* @__PURE__ */ (function(Ua) {
            function oa(ya, ha, Aa) {
              var da;
              if (fi(this, oa), !ra().supported())
                throw new Error("You are using an unsupported browser - Unable to play CLSP video");
              if (da = Xp(this, oa, [ya]), Jp(da, lp), Ui(da, "onConnectionChange", /* @__PURE__ */ di(/* @__PURE__ */ Ko().mark(function gs() {
                return Ko().wrap(function(qs) {
                  for (; ; ) switch (qs.prev = qs.next) {
                    case 0:
                      if (!ra().isOnline()) {
                        qs.next = 12;
                        break;
                      }
                      return da.logger.info("Back online..."), qs.prev = 2, qs.next = 5, da.restart();
                    case 5:
                      qs.next = 11;
                      break;
                    case 7:
                      qs.prev = 7, qs.t0 = qs.catch(2), da.logger.error("Error while trying to restart during online event"), da.logger.error(qs.t0);
                    case 11:
                      return qs.abrupt("return");
                    case 12:
                      return da.logger.info("Offline!"), qs.prev = 13, qs.next = 16, da.stop();
                    case 16:
                      qs.next = 22;
                      break;
                    case 18:
                      qs.prev = 18, qs.t1 = qs.catch(13), da.logger.error("Error encountered while stopping during offline event:"), da.logger.error(qs.t1);
                    case 22:
                    case "end":
                      return qs.stop();
                  }
                }, gs, null, [[2, 7], [13, 18]]);
              }))), Ui(da, "onVisibilityChange", /* @__PURE__ */ di(/* @__PURE__ */ Ko().mark(function gs() {
                return Ko().wrap(function(qs) {
                  for (; ; ) switch (qs.prev = qs.next) {
                    case 0:
                      if (!ra().isDocumentHidden()) {
                        qs.next = 11;
                        break;
                      }
                      return qs.prev = 1, qs.next = 4, da.stop();
                    case 4:
                      qs.next = 10;
                      break;
                    case 6:
                      qs.prev = 6, qs.t0 = qs.catch(1), da.logger.error("Error while trying to stop during visibilityChange event"), da.logger.error(qs.t0);
                    case 10:
                      return qs.abrupt("return");
                    case 11:
                      if (da.logger.info("Back in focus..."), da.streamConfiguration) {
                        qs.next = 14;
                        break;
                      }
                      return qs.abrupt("return");
                    case 14:
                      return qs.prev = 14, qs.next = 17, da.restart();
                    case 17:
                      qs.next = 23;
                      break;
                    case 19:
                      qs.prev = 19, qs.t1 = qs.catch(14), da.logger.error("Error while restarting during onVisibilityChange!"), da.logger.error(qs.t1);
                    case 23:
                    case "end":
                      return qs.stop();
                  }
                }, gs, null, [[1, 6], [14, 19]]);
              }))), Ui(da, "getErrorMsgContainer", function() {
                return da.containerElement.getElementsByClassName(sp)[0];
              }), Ui(da, "getLoadingAnimation", function() {
                return da.containerElement.getElementsByClassName(Eg);
              }), Ui(da, "destroyAllLoadingAnimations", function() {
                for (var gs = da.getLoadingAnimation(), Gs = 0; Gs < gs.length; Gs++)
                  gs[Gs].remove();
              }), Ui(da, "createLoadingAnimation", function() {
                var gs = da.getLoadingAnimation();
                if (!(gs.length > 0)) {
                  var Gs = document.createElement("div");
                  Gs.classList.add(Eg), da.containerElement.insertBefore(Gs, da.videoElement);
                }
              }), Ui(da, "clearErrorMsg", function() {
                da.getErrorMsgContainer().style.display = "none", da.getErrorMsgContainer().innerHTML = "";
              }), Ui(da, "displayErrorMsg", function(gs) {
                var Gs = da.getErrorMsgContainer();
                Gs.style.display = "block", Gs.innerHTML = gs;
              }), Ui(da, "initializeErrorMsgContainer", function() {
                if (da.getErrorMsgContainer() === void 0) {
                  var gs = document.createElement("div");
                  gs.classList.add(sp), da.containerElement.insertBefore(gs, da.videoElement);
                } else
                  da.clearErrorMsg();
              }), ga()(ha))
                throw new Error("id is required to construct an Iov");
              if (!Aa)
                throw new Error("Tried to construct without config");
              da.id = ha, da.shouldRetainVideoElement = !1, da.containerElement = null, da.videoElement = null, da._config = Aa, Qp(lp, da, $p).call(da, Aa);
              var fa = ra().windowStateNames.visibilityChangeEventName;
              return fa && document.addEventListener(fa, da.onVisibilityChange, !1), window.addEventListener("online", da.onConnectionChange, !1), window.addEventListener("offline", da.onConnectionChange, !1), da.ENABLE_METRICS = Zh, da.CONNECTION_CHANGE_PLAY_DELAY = df, da.iovPlayerCollection = xc.factory("".concat(da.logId, ".iovPlayerCollection")), da.iovPlayerCollection.on(xc.events.FIRST_FRAME_SHOWN, function() {
                da.emit(oa.events.FIRST_FRAME_SHOWN);
              }), da.iovPlayerCollection.on(xc.events.VIDEO_RECEIVED, function() {
                da.emit(oa.events.VIDEO_RECEIVED);
              }), da.iovPlayerCollection.on(xc.events.VIDEO_INFO_RECEIVED, function() {
                da.emit(oa.events.VIDEO_INFO_RECEIVED);
              }), da.iovPlayerCollection.on(xc.events.IFRAME_DESTROYED_EXTERNALLY, function() {
                if (da.isDestroyed) {
                  da.logger.info("Iframe was destroyed externally while in process of destroying");
                  return;
                }
                da.emit(oa.events.IFRAME_DESTROYED_EXTERNALLY);
              }), da.iovPlayerCollection.on(xc.events.DISPLAY_ERROR_MSG, function(gs) {
                da.logger.info("Displaying error msg to user"), da.videoElement.src = "", da.displayErrorMsg(gs.error.message);
              }), da;
            }
            return No(oa, Ua), Oi(oa, [{
              key: "changeSrc",
              value: (
                /**
                 * @param {StreamConfiguration|String} url
                 *   The StreamConfiguration or url of the new stream
                 */
                (function() {
                  var ya = di(/* @__PURE__ */ Ko().mark(function Aa(da) {
                    var fa = this, gs;
                    return Ko().wrap(function(qs) {
                      for (; ; ) switch (qs.prev = qs.next) {
                        case 0:
                          if (!this.isDestroyed) {
                            qs.next = 3;
                            break;
                          }
                          return this.logger.info("Tried to changeSrc while destroyed"), qs.abrupt("return");
                        case 3:
                          if (this.logger.info("Changing Stream..."), da) {
                            qs.next = 6;
                            break;
                          }
                          throw new Error("url is required to changeSrc");
                        case 6:
                          if (this.streamConfiguration = rd.isStreamConfiguration(da) ? da : rd.fromUrl(da), !ra().isDocumentHidden()) {
                            qs.next = 10;
                            break;
                          }
                          return this.logger.info("Tried to changeSrc while tab was hidden!"), qs.abrupt("return");
                        case 10:
                          if (ra().isOnline()) {
                            qs.next = 13;
                            break;
                          }
                          return this.logger.info("Tried to changeSrc while not connected to the internet!"), qs.abrupt("return");
                        case 13:
                          return this.createLoadingAnimation(), this.initializeErrorMsgContainer(), qs.next = 17, (0, ca.sleepSeconds)(Math.random());
                        case 17:
                          return qs.prev = 17, qs.next = 20, this.iovPlayerCollection.create(this.containerElement, this.videoElement, this.streamConfiguration);
                        case 20:
                          gs = qs.sent, qs.next = 29;
                          break;
                        case 23:
                          throw qs.prev = 23, qs.t0 = qs.catch(17), this.logger.error("Error while creating / playing the player for stream ".concat(this.streamConfiguration.streamName)), this.logger.error(qs.t0), this.destroyAllLoadingAnimations(), qs.t0;
                        case 29:
                          if (gs) {
                            qs.next = 32;
                            break;
                          }
                          throw this.destroyAllLoadingAnimations(), new Error("IovPlayer was created, but no id was returned");
                        case 32:
                          return qs.next = 34, new (Wi())(function(El, kl) {
                            fa.iovPlayerCollection.on(xc.events.FIRST_FRAME_SHOWN, /* @__PURE__ */ (function() {
                              var ju = di(/* @__PURE__ */ Ko().mark(function Yu(Lc) {
                                var Ed;
                                return Ko().wrap(function(bc) {
                                  for (; ; ) switch (bc.prev = bc.next) {
                                    case 0:
                                      if (Ed = Lc.id, fa.destroyAllLoadingAnimations(), gs === Ed) {
                                        bc.next = 4;
                                        break;
                                      }
                                      return bc.abrupt("return");
                                    case 4:
                                      return fa.logger.info("Next player has received its first frame..."), bc.next = 7, (0, ca.sleepSeconds)(fa.SHOW_NEXT_VIDEO_DELAY);
                                    case 7:
                                      if (bc.prev = 7, !fa.isDestroyed) {
                                        bc.next = 10;
                                        break;
                                      }
                                      throw new Error("Next player received first frame while destroyed!");
                                    case 10:
                                      El(), bc.next = 17;
                                      break;
                                    case 13:
                                      bc.prev = 13, bc.t0 = bc.catch(7), fa.logger.error("Error while handling first frame shown event!"), kl(bc.t0);
                                    case 17:
                                    case "end":
                                      return bc.stop();
                                  }
                                }, Yu, null, [[7, 13]]);
                              }));
                              return function(Yu) {
                                return ju.apply(this, arguments);
                              };
                            })());
                          });
                        case 34:
                        case "end":
                          return qs.stop();
                      }
                    }, Aa, this, [[17, 23]]);
                  }));
                  function ha(Aa) {
                    return ya.apply(this, arguments);
                  }
                  return ha;
                })()
              )
            }, {
              key: "stop",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  return Ko().wrap(function(fa) {
                    for (; ; ) switch (fa.prev = fa.next) {
                      case 0:
                        if (!this.isDestroyComplete) {
                          fa.next = 2;
                          break;
                        }
                        throw new Error("Tried to stop while destroyed");
                      case 2:
                        if (!this.isStopping) {
                          fa.next = 5;
                          break;
                        }
                        return this.logger.info("Already stopping"), fa.abrupt("return");
                      case 5:
                        return this.isStopping = !0, fa.prev = 6, fa.next = 9, this.iovPlayerCollection.removeAll();
                      case 9:
                        return fa.prev = 9, this.isStopping = !1, fa.finish(9);
                      case 12:
                      case "end":
                        return fa.stop();
                    }
                  }, Aa, this, [[6, , 9, 12]]);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "restart",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  return Ko().wrap(function(fa) {
                    for (; ; ) switch (fa.prev = fa.next) {
                      case 0:
                        if (!this.isDestroyed) {
                          fa.next = 2;
                          break;
                        }
                        throw new Error("Tried to restart while destroyed");
                      case 2:
                        return this.logger.info("Restart"), fa.prev = 3, fa.next = 6, this.stop();
                      case 6:
                        fa.next = 12;
                        break;
                      case 8:
                        fa.prev = 8, fa.t0 = fa.catch(3), this.logger.warn("Failed to stop while restarting, continuing anyway..."), this.logger.error(fa.t0);
                      case 12:
                        return fa.prev = 12, fa.next = 15, this.changeSrc(this.streamConfiguration);
                      case 15:
                        fa.next = 21;
                        break;
                      case 17:
                        throw fa.prev = 17, fa.t1 = fa.catch(12), this.logger.error("Failed to changeSrc while restarting!"), fa.t1;
                      case 21:
                      case "end":
                        return fa.stop();
                    }
                  }, Aa, this, [[3, 8], [12, 17]]);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "enterFullscreen",
              value: function() {
                window.document.fullscreenElement || this.containerElement.requestFullscreen();
              }
            }, {
              key: "exitFullscreen",
              value: function() {
                window.document.exitFullscreen && window.document.exitFullscreen();
              }
            }, {
              key: "toggleFullscreen",
              value: function() {
                window.document.fullscreenElement ? this.exitFullscreen() : this.enterFullscreen();
              }
              // @todo @metrics
            }, {
              key: "metric",
              value: function(ha, Aa) {
              }
              /**
               * Dereference the necessary properties, clear any intervals and timeouts, and
               * remove any listeners.  Will also destroy the player.
               *
               * @returns {Promise}
               */
            }, {
              key: "_destroy",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  var da, fa, gs, Gs;
                  return Ko().wrap(function(El) {
                    for (; ; ) switch (El.prev = El.next) {
                      case 0:
                        return da = Hi()(), fa = ra().windowStateNames.visibilityChangeEventName, fa && document.removeEventListener(fa, this.onVisibilityChange), window.removeEventListener("online", this.onConnectionChange), window.removeEventListener("offline", this.onConnectionChange), El.prev = 5, El.next = 8, this.stop();
                      case 8:
                        El.next = 14;
                        break;
                      case 10:
                        El.prev = 10, El.t0 = El.catch(5), this.logger.error("Error while stopping while destroying"), this.logger.error(El.t0);
                      case 14:
                        return El.prev = 14, El.next = 17, this.iovPlayerCollection.destroy();
                      case 17:
                        El.next = 23;
                        break;
                      case 19:
                        El.prev = 19, El.t1 = El.catch(14), this.logger.error("Error while destroying IOV Player Collection while destroying"), this.logger.error(El.t1);
                      case 23:
                        return this.streamConfiguration = null, Qp(lp, this, Sg).call(this), this._config = null, El.next = 28, cf(oa, "_destroy", this, 3)([]);
                      case 28:
                        gs = Hi()(), Gs = (gs - da) / 1e3, this.logger.info("Destroy complete in ".concat(Gs, " seconds..."));
                      case 31:
                      case "end":
                        return El.stop();
                    }
                  }, Aa, this, [[5, 10], [14, 19]]);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "destroy",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  return Ko().wrap(function(fa) {
                    for (; ; ) switch (fa.prev = fa.next) {
                      case 0:
                        return this.emit(oa.events.DESTROYING, {
                          iov: this
                        }), fa.next = 3, cf(oa, "destroy", this, 3)([]);
                      case 3:
                      case "end":
                        return fa.stop();
                    }
                  }, Aa, this);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }], [{
              key: "factory",
              value: function(ha, Aa, da) {
                return new oa(ha, Aa, da);
              }
            }]);
          })(Cs);
          function $p(Ua) {
            var oa = Ua.videoElementId, ya = Ua.videoElement, ha = Ua.containerElementId, Aa = Ua.containerElement;
            if (this.logger.info("Initializing elements..."), ha && (Aa = document.getElementById(ha)), this.containerElement = Aa, (oa || ya) && (this.shouldRetainVideoElement = !0), oa && (ya = document.getElementById(oa)), this.videoElement = ya, this.shouldRetainVideoElement && !this.videoElement)
              throw oa ? new Error('Unable to get element with id: "'.concat(oa, '"')) : new Error("No video element or id was passed");
            if (!this.videoElement && !this.containerElement)
              throw new Error("Must pass at least 1 valid container or video element or id");
            if (this.videoElement || (ya = document.createElement("video"), Aa.appendChild(ya), this.videoElement = ya), this.containerElement || (this.containerElement = this.videoElement.parentNode), !this.containerElement || !this.videoElement)
              throw new Error("Unable to get both the container and video elements");
            this.containerElement.classList.add(Zp), this.videoElement.classList.add(ap), this.videoElement.muted = !0, this.videoElement.playsinline = !0;
          }
          function Sg() {
            this.logger.info("Unnitializing elements..."), this.destroyAllLoadingAnimations(), this.containerElement.classList.remove(Zp), this.videoElement.classList.remove(ap), this.videoElement.src = "", this.shouldRetainVideoElement || (this.containerElement.removeChild(this.videoElement), this.videoElement.remove()), this.videoElement = null, this.containerElement = null;
          }
          Ui(eh, "events", {
            METRIC: "metric",
            FIRST_FRAME_SHOWN: qi.events.FIRST_FRAME_SHOWN,
            VIDEO_RECEIVED: qi.events.VIDEO_RECEIVED,
            VIDEO_INFO_RECEIVED: qi.events.VIDEO_INFO_RECEIVED,
            IFRAME_DESTROYED_EXTERNALLY: qi.events.IFRAME_DESTROYED_EXTERNALLY,
            DESTROYING: "destroying"
          });
          function wh(Ua, oa, ya) {
            return oa = fo(oa), Mi(Ua, _h() ? li()(oa, ya || [], fo(Ua).constructor) : oa.apply(Ua, ya));
          }
          function _h() {
            try {
              var Ua = !Boolean.prototype.valueOf.call(li()(Boolean, [], function() {
              }));
            } catch {
            }
            return (_h = function() {
              return !!Ua;
            })();
          }
          function th(Ua, oa, ya, ha) {
            var Aa = Ni(fo(Ua.prototype), oa, ya);
            return 2 & ha && typeof Aa == "function" ? function(da) {
              return Aa.apply(ya, da);
            } : Aa;
          }
          var Ph = 0, ff, xg = /* @__PURE__ */ (function(Ua) {
            function oa() {
              var ya;
              return fi(this, oa), ya = wh(this, oa, ["0"]), ya.iovs = {}, ya.pendingRemoval = {}, ya;
            }
            return No(oa, Ua), Oi(oa, [{
              key: "create",
              value: function() {
                var ha = this, Aa = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, da = Ph;
                Ph++, this.logger.info("Creating Iov ".concat(da));
                var fa = eh.factory("iov:".concat(da), da, Aa);
                return this.logger.info("Created Iov ".concat(da)), fa.on(eh.events.IFRAME_DESTROYED_EXTERNALLY, /* @__PURE__ */ di(/* @__PURE__ */ Ko().mark(function gs() {
                  return Ko().wrap(function(qs) {
                    for (; ; ) switch (qs.prev = qs.next) {
                      case 0:
                        return fa.logger.info("IovCollection: iframe was destroyed, removing iov..."), qs.prev = 1, qs.next = 4, ha.remove(fa.id);
                      case 4:
                        qs.next = 10;
                        break;
                      case 6:
                        qs.prev = 6, qs.t0 = qs.catch(1), fa.logger.error("IovCollection: error while removing iov from collection!"), fa.logger.error(qs.t0);
                      case 10:
                      case "end":
                        return qs.stop();
                    }
                  }, gs, null, [[1, 6]]);
                }))), this.add(fa), fa;
              }
              /**
               * Add an Iov instance to this collection.  It can then be accessed by its id.
               *
               * @param {Iov} iov
               *   The iov instance to add
               *
               * @returns {this}
               */
            }, {
              key: "add",
              value: function(ha) {
                var Aa = ha.id;
                if (ga()(Aa))
                  throw new Error("Tried to add Iov without id");
                if (this.has(Aa))
                  throw new Error("Cannot add an Iov with a previously-used id");
                return this.logger.info("Adding Iov ".concat(Aa)), this.iovs[Aa] = ha, this;
              }
              /**
               * Determine whether or not an iov with the passed id exists in this
               * collection.
               *
               * @param {String} id
               *   The id of the iov to find
               *
               * @returns {Boolean}
               *   True if the iov with the given id exists
               *   False if the iov with the given id does not exist
               */
            }, {
              key: "has",
              value: function(ha) {
                return ga()(ha) || this.pendingRemoval[ha] ? !1 : Object.prototype.hasOwnProperty.call(this.iovs, ha);
              }
              /**
               * Get an iov with the passed id from this collection.
               *
               * @param {String} id
               *   The id of the iov instance to get
               *
               * @returns {Iov|null}
               *   If an iov with this id doest not exist, undefined is returned.
               */
            }, {
              key: "get",
              value: function(ha) {
                return this.has(ha) ? this.iovs[ha] : null;
              }
              /**
               * Remove an iov instance from this collection and destroy it.
               *
               * @param {String} id
               *   The id of the iov to remove and destroy
               *
               * @returns {this}
               */
            }, {
              key: "remove",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa(da) {
                  var fa;
                  return Ko().wrap(function(Gs) {
                    for (; ; ) switch (Gs.prev = Gs.next) {
                      case 0:
                        if (fa = this.get(da), fa !== null) {
                          Gs.next = 3;
                          break;
                        }
                        return Gs.abrupt("return");
                      case 3:
                        return Gs.prev = 3, this.pendingRemoval[da] = !0, delete this.iovs[da], fa.logger.info("IovCollection - removing iov..."), Gs.next = 9, fa.destroy();
                      case 9:
                        Gs.next = 15;
                        break;
                      case 11:
                        Gs.prev = 11, Gs.t0 = Gs.catch(3), this.logger.error("Error destroying Iov ".concat(da, " while removing")), this.logger.error(Gs.t0);
                      case 15:
                        return delete this.pendingRemoval[da], Gs.abrupt("return", this);
                      case 17:
                      case "end":
                        return Gs.stop();
                    }
                  }, Aa, this, [[3, 11]]);
                }));
                function ha(Aa) {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "_destroy",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  var da;
                  return Ko().wrap(function(gs) {
                    for (; ; ) switch (gs.prev = gs.next) {
                      case 0:
                        gs.t0 = bf()(Ko()).call(Ko(), this.iovs);
                      case 1:
                        if ((gs.t1 = gs.t0()).done) {
                          gs.next = 14;
                          break;
                        }
                        return da = gs.t1.value, gs.prev = 3, gs.next = 6, this.remove(da);
                      case 6:
                        gs.next = 12;
                        break;
                      case 8:
                        gs.prev = 8, gs.t2 = gs.catch(3), this.logger.error("Error while removing IOV ".concat(da, " while destroying")), this.logger.error(gs.t2);
                      case 12:
                        gs.next = 1;
                        break;
                      case 14:
                        return this.iovs = null, this.pendingRemoval = null, gs.next = 18, th(oa, "_destroy", this, 3)([]);
                      case 18:
                      case "end":
                        return gs.stop();
                    }
                  }, Aa, this, [[3, 8]]);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }], [{
              key: "asSingleton",
              value: function() {
                return ff || (ff = oa.factory()), ff;
              }
              /**
               * @private
               */
            }, {
              key: "factory",
              value: function() {
                return new oa();
              }
            }]);
          })(ja);
          function rh(Ua) {
            if (Hl(Ua)) return Ua;
          }
          var Ch = ii(3520);
          function wg(Ua, oa) {
            var ya = Ua == null ? null : typeof mi < "u" && ac(Ua) || Ua["@@iterator"];
            if (ya != null) {
              var ha, Aa, da, fa, gs = [], Gs = !0, qs = !1;
              try {
                if (da = (ya = ya.call(Ua)).next, oa !== 0) for (; !(Gs = (ha = da.call(ya)).done) && (Ch(gs).call(gs, ha.value), gs.length !== oa); Gs = !0) ;
              } catch (El) {
                qs = !0, Aa = El;
              } finally {
                try {
                  if (!Gs && ya.return != null && (fa = ya.return(), Object(fa) !== fa)) return;
                } finally {
                  if (qs) throw Aa;
                }
              }
              return gs;
            }
          }
          function Rh() {
            throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
          }
          function _g(Ua, oa) {
            return rh(Ua) || wg(Ua, oa) || iu(Ua, oa) || Rh();
          }
          var eg = ii(6615), Kg = /* @__PURE__ */ ii.n(eg), Cf = ii(8573), Oh = /* @__PURE__ */ ii.n(Cf);
          function tg(Ua, oa, ya) {
            return oa = fo(oa), Mi(Ua, rg() ? li()(oa, ya || [], fo(Ua).constructor) : oa.apply(Ua, ya));
          }
          function rg() {
            try {
              var Ua = !Boolean.prototype.valueOf.call(li()(Boolean, [], function() {
              }));
            } catch {
            }
            return (rg = function() {
              return !!Ua;
            })();
          }
          function Pg(Ua, oa, ya, ha) {
            var Aa = Ni(fo(Ua.prototype), oa, ya);
            return 2 & ha && typeof Aa == "function" ? function(da) {
              return Aa.apply(ya, da);
            } : Aa;
          }
          var Ah = 10, Ih = 9, nh = 0, $h = /* @__PURE__ */ (function(Ua) {
            function oa(ya, ha) {
              var Aa, da = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
              return fi(this, oa), Aa = tg(this, oa, [nh]), nh++, Aa.iovCollection = ya, Aa.startTime = null, Aa.streamConfigurations = [], Aa.iov = null, Aa.currentIndex = 0, Aa.interval = null, Aa.videoElementId = ha, Aa.pendingChangeSrcs = {}, Aa.options = {
                onLoaded: da.onLoad || function() {
                },
                onShown: da.onShown || function() {
                }
              }, Aa.TOUR_INTERVAL_DURATION = Ah, Aa.TOUR_PRELOAD_DURATION = Ih, Aa;
            }
            return No(oa, Ua), Oi(oa, [{
              key: "addUrls",
              value: function(ha) {
                Kg()(ha) || (ha = [ha]);
                for (var Aa = 0; Aa < ha.length; Aa++)
                  this.streamConfigurations.push(rd.fromUrl(ha[Aa]));
              }
            }, {
              key: "_cancelChangeSrc",
              value: function(ha) {
                Object.prototype.hasOwnProperty.call(this.pendingChangeSrcs, ha) && (this.iov.cancelChangeSrc(ha), this.pendingChangeSrcs[ha].timeout && (clearTimeout(this.pendingChangeSrcs[ha].timeout), this.pendingChangeSrcs[ha].timeout = null), delete this.pendingChangeSrcs[ha]);
              }
            }, {
              key: "_cancelAllChangeSrcs",
              value: function() {
                for (var ha = 0, Aa = Oh()(this.pendingChangeSrcs); ha < Aa.length; ha++) {
                  var da = _g(Aa[ha], 1), fa = da[0];
                  this._cancelChangeSrc(fa);
                }
              }
            }, {
              key: "_changeSrc",
              value: function(ha, Aa) {
                var da = this, fa = this.TOUR_INTERVAL_DURATION + this.TOUR_PRELOAD_DURATION, gs = null, Gs = null, qs = null;
                return this._cancelAllChangeSrcs(), new (Wi())(/* @__PURE__ */ (function() {
                  var El = di(/* @__PURE__ */ Ko().mark(function kl(ju, Yu) {
                    var Lc, Ed, tc, bc, ud;
                    return Ko().wrap(function(yd) {
                      for (; ; ) switch (yd.prev = yd.next) {
                        case 0:
                          return Lc = function() {
                            da.logger.debug("Successfull played ".concat(Aa.streamName)), gs && (clearTimeout(gs), gs = null), Gs && (clearTimeout(Gs), Gs = null), delete da.pendingChangeSrcs[qs], da.options.onLoaded(null, ha, Aa), ju();
                          }, Ed = function(vu) {
                            da.logger.error(vu), da._cancelChangeSrc(qs), gs && (clearTimeout(gs), gs = null), Gs && (clearTimeout(Gs), Gs = null), da.options.onLoaded(vu, ha, Aa), Yu(vu);
                          }, gs = $l()(function() {
                            gs && (clearTimeout(gs), gs = null), da._showNextStream(0, ha, Aa);
                          }, da.TOUR_PRELOAD_DURATION * 1e3), Gs = $l()(function() {
                            var Id;
                            Ed(new Error(Rs()(Id = "Failed to play ".concat(Aa.streamName, " after ")).call(Id, fa, " seconds")));
                          }, fa * 1e3), yd.prev = 4, tc = da.iov.changeSrc(Aa, !1), bc = tc.id, ud = tc.firstFrameReceivedPromise, qs = bc, da.pendingChangeSrcs[qs] = {
                            id: qs,
                            timeout: Gs
                          }, yd.next = 10, ud;
                        case 10:
                          Lc(), yd.next = 16;
                          break;
                        case 13:
                          yd.prev = 13, yd.t0 = yd.catch(4), Ed(yd.t0);
                        case 16:
                        case "end":
                          return yd.stop();
                      }
                    }, kl, null, [[4, 13]]);
                  }));
                  return function(kl, ju) {
                    return El.apply(this, arguments);
                  };
                })());
              }
            }, {
              key: "_showNextStream",
              value: function(ha, Aa, da) {
                var fa = this, gs = function() {
                  fa.iov.showNextStream(), fa.options.onShown(null, Aa, da);
                };
                if (!ha) {
                  gs();
                  return;
                }
                var Gs = this.TOUR_PRELOAD_DURATION * 1e3 - (Hi()() - ha);
                if (Gs <= 0) {
                  gs();
                  return;
                }
                $l()(function() {
                  gs();
                }, Gs);
              }
            }, {
              key: "next",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  var da, fa, gs, Gs, qs, El, kl = arguments;
                  return Ko().wrap(function(Yu) {
                    for (; ; ) switch (Yu.prev = Yu.next) {
                      case 0:
                        return da = kl.length > 0 && kl[0] !== void 0 ? kl[0] : !1, fa = kl.length > 1 && kl[1] !== void 0 ? kl[1] : !1, gs = da ? 0 : Hi()(), this.currentIndex === this.streamConfigurations.length && (this.currentIndex = 0), Gs = this.streamConfigurations[this.currentIndex], this.currentIndex++, qs = this.currentIndex, El = !1, Yu.prev = 8, Yu.next = 11, this._changeSrc(qs, Gs);
                      case 11:
                        El = !0, this._showNextStream(gs, qs, Gs), Yu.next = 20;
                        break;
                      case 15:
                        Yu.prev = 15, Yu.t0 = Yu.catch(8), this.logger.error("Failed to play ".concat(Gs.streamName)), this.logger.error(Yu.t0), El || this._showNextStream(gs, qs, Gs);
                      case 20:
                        if (!fa) {
                          Yu.next = 24;
                          break;
                        }
                        return clearInterval(this.interval), Yu.next = 24, this.resume(!0);
                      case 24:
                      case "end":
                        return Yu.stop();
                    }
                  }, Aa, this, [[8, 15]]);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "previous",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  return Ko().wrap(function(fa) {
                    for (; ; ) switch (fa.prev = fa.next) {
                      case 0:
                        return this.currentIndex === 0 ? this.currentIndex = this.streamConfigurations.length - 2 : this.currentIndex === 1 ? this.currentIndex = this.streamConfigurations.length - 1 : this.currentIndex -= 2, fa.next = 3, this.next(!0, !0);
                      case 3:
                      case "end":
                        return fa.stop();
                    }
                  }, Aa, this);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "resume",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  var da = this, fa, gs, Gs = arguments;
                  return Ko().wrap(function(El) {
                    for (; ; ) switch (El.prev = El.next) {
                      case 0:
                        if (fa = Gs.length > 0 && Gs[0] !== void 0 ? Gs[0] : !1, gs = Gs.length > 1 && Gs[1] !== void 0 ? Gs[1] : !0, !(!fa && this.interval)) {
                          El.next = 4;
                          break;
                        }
                        return El.abrupt("return");
                      case 4:
                        if (this.interval && (clearInterval(this.interval), this.interval = null), this.nextTimeout && (clearTimeout(this.nextTimeout), this.nextTimeout = null), gs) {
                          El.next = 9;
                          break;
                        }
                        return El.next = 9, this.next(!0);
                      case 9:
                        this.pause(), this.nextTimeout = $l()(function() {
                          da.nextTimeout && (clearTimeout(da.nextTimeout), da.nextTimeout = null), da.next(), da.interval = $d()(function() {
                            da.next();
                          }, da.TOUR_INTERVAL_DURATION * 1e3);
                        }, (this.TOUR_INTERVAL_DURATION - this.TOUR_PRELOAD_DURATION) * 1e3);
                      case 11:
                      case "end":
                        return El.stop();
                    }
                  }, Aa, this);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
              /**
               * This is meant to be the entry point to the tour.  It should only be called
               * once, at the beginning, to start the tour.
               */
            }, {
              key: "start",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  return Ko().wrap(function(fa) {
                    for (; ; ) switch (fa.prev = fa.next) {
                      case 0:
                        return this.iov = this.iovCollection.create({
                          videoElementId: this.videoElementId
                        }), fa.next = 3, this.resume(!0, !1);
                      case 3:
                      case "end":
                        return fa.stop();
                    }
                  }, Aa, this);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "pause",
              value: function() {
                this.interval && (clearInterval(this.interval), this.interval = null);
              }
            }, {
              key: "stop",
              value: function() {
                this.pause(), this.currentIndex = 0;
              }
            }, {
              key: "reset",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  return Ko().wrap(function(fa) {
                    for (; ; ) switch (fa.prev = fa.next) {
                      case 0:
                        return this.stop(), fa.next = 3, this.resume(!0);
                      case 3:
                      case "end":
                        return fa.stop();
                    }
                  }, Aa, this);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }, {
              key: "fullscreen",
              value: function() {
                this.iov && this.iov.toggleFullscreen();
              }
              /**
               * Destroy this tour and all associated streamConfigurations and iovs
               */
            }, {
              key: "_destroy",
              value: (function() {
                var ya = di(/* @__PURE__ */ Ko().mark(function Aa() {
                  var da;
                  return Ko().wrap(function(gs) {
                    for (; ; ) switch (gs.prev = gs.next) {
                      case 0:
                        for (this._cancelAllChangeSrcs(), this.pause(), da = 0; da < this.streamConfigurations.length; da++)
                          this.streamConfigurations[da].destroy();
                        if (this.streamConfigurations = null, !this.iov) {
                          gs.next = 15;
                          break;
                        }
                        return gs.prev = 5, gs.next = 8, this.iovCollection.remove(this.iov.id);
                      case 8:
                        gs.next = 14;
                        break;
                      case 10:
                        gs.prev = 10, gs.t0 = gs.catch(5), this.logger.error("Error while removing IOV ".concat(this.iov.id, " while destroying")), this.logger.error(gs.t0);
                      case 14:
                        this.iov = null;
                      case 15:
                        return this.iovCollection = null, this.videoElementId = null, gs.next = 19, Pg(oa, "_destroy", this, 3)([]);
                      case 19:
                      case "end":
                        return gs.stop();
                    }
                  }, Aa, this, [[5, 10]]);
                }));
                function ha() {
                  return ya.apply(this, arguments);
                }
                return ha;
              })()
            }], [{
              key: "factory",
              value: function(ha, Aa, da) {
                return new oa(ha, Aa, da);
              }
            }]);
          })(Cs);
        })(), ui;
      })()
    ));
  })(clspPlayer_min)), clspPlayer_min.exports;
}
requireClspPlayer_min();
var hls$1 = { exports: {} }, hls = hls$1.exports, hasRequiredHls;
function requireHls() {
  return hasRequiredHls || (hasRequiredHls = 1, (function(pt, yt) {
    typeof window < "u" && (function(ti, ii) {
      pt.exports = ii();
    })(hls, function() {
      return (
        /******/
        (function(ir) {
          var ti = {};
          function ii(ui) {
            if (ti[ui])
              return ti[ui].exports;
            var ai = ti[ui] = {
              /******/
              i: ui,
              /******/
              l: !1,
              /******/
              exports: {}
              /******/
            };
            return ir[ui].call(ai.exports, ai, ai.exports, ii), ai.l = !0, ai.exports;
          }
          return ii.m = ir, ii.c = ti, ii.d = function(ui, ai, li) {
            ii.o(ui, ai) || Object.defineProperty(ui, ai, { enumerable: !0, get: li });
          }, ii.r = function(ui) {
            typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(ui, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(ui, "__esModule", { value: !0 });
          }, ii.t = function(ui, ai) {
            if (ai & 1 && (ui = ii(ui)), ai & 8 || ai & 4 && typeof ui == "object" && ui && ui.__esModule) return ui;
            var li = /* @__PURE__ */ Object.create(null);
            if (ii.r(li), Object.defineProperty(li, "default", { enumerable: !0, value: ui }), ai & 2 && typeof ui != "string") for (var oi in ui) ii.d(li, oi, (function(si) {
              return ui[si];
            }).bind(null, oi));
            return li;
          }, ii.n = function(ui) {
            var ai = ui && ui.__esModule ? (
              /******/
              function() {
                return ui.default;
              }
            ) : (
              /******/
              function() {
                return ui;
              }
            );
            return ii.d(ai, "a", ai), ai;
          }, ii.o = function(ui, ai) {
            return Object.prototype.hasOwnProperty.call(ui, ai);
          }, ii.p = "/dist/", ii(ii.s = "./src/hls.ts");
        })({
          /***/
          "./node_modules/eventemitter3/index.js": (
            /*!*********************************************!*\
              !*** ./node_modules/eventemitter3/index.js ***!
              \*********************************************/
            /*! no static exports found */
            /*! ModuleConcatenation bailout: Module is not an ECMAScript module */
            /***/
            (function(ir, ti, ii) {
              var ui = Object.prototype.hasOwnProperty, ai = "~";
              function li() {
              }
              Object.create && (li.prototype = /* @__PURE__ */ Object.create(null), new li().__proto__ || (ai = !1));
              function oi(gi, mi, Ti) {
                this.fn = gi, this.context = mi, this.once = Ti || !1;
              }
              function si(gi, mi, Ti, vi, xi) {
                if (typeof Ti != "function")
                  throw new TypeError("The listener must be a function");
                var Si = new oi(Ti, vi || gi, xi), Pi = ai ? ai + mi : mi;
                return gi._events[Pi] ? gi._events[Pi].fn ? gi._events[Pi] = [gi._events[Pi], Si] : gi._events[Pi].push(Si) : (gi._events[Pi] = Si, gi._eventsCount++), gi;
              }
              function di(gi, mi) {
                --gi._eventsCount === 0 ? gi._events = new li() : delete gi._events[mi];
              }
              function fi() {
                this._events = new li(), this._eventsCount = 0;
              }
              fi.prototype.eventNames = function() {
                var mi = [], Ti, vi;
                if (this._eventsCount === 0) return mi;
                for (vi in Ti = this._events)
                  ui.call(Ti, vi) && mi.push(ai ? vi.slice(1) : vi);
                return Object.getOwnPropertySymbols ? mi.concat(Object.getOwnPropertySymbols(Ti)) : mi;
              }, fi.prototype.listeners = function(mi) {
                var Ti = ai ? ai + mi : mi, vi = this._events[Ti];
                if (!vi) return [];
                if (vi.fn) return [vi.fn];
                for (var xi = 0, Si = vi.length, Pi = new Array(Si); xi < Si; xi++)
                  Pi[xi] = vi[xi].fn;
                return Pi;
              }, fi.prototype.listenerCount = function(mi) {
                var Ti = ai ? ai + mi : mi, vi = this._events[Ti];
                return vi ? vi.fn ? 1 : vi.length : 0;
              }, fi.prototype.emit = function(mi, Ti, vi, xi, Si, Pi) {
                var $i = ai ? ai + mi : mi;
                if (!this._events[$i]) return !1;
                var Oi = this._events[$i], Di = arguments.length, Mi, Oo;
                if (Oi.fn) {
                  switch (Oi.once && this.removeListener(mi, Oi.fn, void 0, !0), Di) {
                    case 1:
                      return Oi.fn.call(Oi.context), !0;
                    case 2:
                      return Oi.fn.call(Oi.context, Ti), !0;
                    case 3:
                      return Oi.fn.call(Oi.context, Ti, vi), !0;
                    case 4:
                      return Oi.fn.call(Oi.context, Ti, vi, xi), !0;
                    case 5:
                      return Oi.fn.call(Oi.context, Ti, vi, xi, Si), !0;
                    case 6:
                      return Oi.fn.call(Oi.context, Ti, vi, xi, Si, Pi), !0;
                  }
                  for (Oo = 1, Mi = new Array(Di - 1); Oo < Di; Oo++)
                    Mi[Oo - 1] = arguments[Oo];
                  Oi.fn.apply(Oi.context, Mi);
                } else {
                  var io = Oi.length, xo;
                  for (Oo = 0; Oo < io; Oo++)
                    switch (Oi[Oo].once && this.removeListener(mi, Oi[Oo].fn, void 0, !0), Di) {
                      case 1:
                        Oi[Oo].fn.call(Oi[Oo].context);
                        break;
                      case 2:
                        Oi[Oo].fn.call(Oi[Oo].context, Ti);
                        break;
                      case 3:
                        Oi[Oo].fn.call(Oi[Oo].context, Ti, vi);
                        break;
                      case 4:
                        Oi[Oo].fn.call(Oi[Oo].context, Ti, vi, xi);
                        break;
                      default:
                        if (!Mi) for (xo = 1, Mi = new Array(Di - 1); xo < Di; xo++)
                          Mi[xo - 1] = arguments[xo];
                        Oi[Oo].fn.apply(Oi[Oo].context, Mi);
                    }
                }
                return !0;
              }, fi.prototype.on = function(mi, Ti, vi) {
                return si(this, mi, Ti, vi, !1);
              }, fi.prototype.once = function(mi, Ti, vi) {
                return si(this, mi, Ti, vi, !0);
              }, fi.prototype.removeListener = function(mi, Ti, vi, xi) {
                var Si = ai ? ai + mi : mi;
                if (!this._events[Si]) return this;
                if (!Ti)
                  return di(this, Si), this;
                var Pi = this._events[Si];
                if (Pi.fn)
                  Pi.fn === Ti && (!xi || Pi.once) && (!vi || Pi.context === vi) && di(this, Si);
                else {
                  for (var $i = 0, Oi = [], Di = Pi.length; $i < Di; $i++)
                    (Pi[$i].fn !== Ti || xi && !Pi[$i].once || vi && Pi[$i].context !== vi) && Oi.push(Pi[$i]);
                  Oi.length ? this._events[Si] = Oi.length === 1 ? Oi[0] : Oi : di(this, Si);
                }
                return this;
              }, fi.prototype.removeAllListeners = function(mi) {
                var Ti;
                return mi ? (Ti = ai ? ai + mi : mi, this._events[Ti] && di(this, Ti)) : (this._events = new li(), this._eventsCount = 0), this;
              }, fi.prototype.off = fi.prototype.removeListener, fi.prototype.addListener = fi.prototype.on, fi.prefixed = ai, fi.EventEmitter = fi, ir.exports = fi;
            })
          ),
          /***/
          "./node_modules/url-toolkit/src/url-toolkit.js": (
            /*!*****************************************************!*\
              !*** ./node_modules/url-toolkit/src/url-toolkit.js ***!
              \*****************************************************/
            /*! no static exports found */
            /*! ModuleConcatenation bailout: Module is not an ECMAScript module */
            /***/
            (function(ir, ti, ii) {
              (function(ui) {
                var ai = /^((?:[a-zA-Z0-9+\-.]+:)?)(\/\/[^\/?#]*)?((?:[^\/?#]*\/)*[^;?#]*)?(;[^?#]*)?(\?[^#]*)?(#.*)?$/, li = /^([^\/?#]*)(.*)$/, oi = /(?:\/|^)\.(?=\/)/g, si = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g, di = {
                  // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
                  // E.g
                  // With opts.alwaysNormalize = false (default, spec compliant)
                  // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
                  // With opts.alwaysNormalize = true (not spec compliant)
                  // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
                  buildAbsoluteURL: function(fi, gi, mi) {
                    if (mi = mi || {}, fi = fi.trim(), gi = gi.trim(), !gi) {
                      if (!mi.alwaysNormalize)
                        return fi;
                      var Ti = di.parseURL(fi);
                      if (!Ti)
                        throw new Error("Error trying to parse base URL.");
                      return Ti.path = di.normalizePath(
                        Ti.path
                      ), di.buildURLFromParts(Ti);
                    }
                    var vi = di.parseURL(gi);
                    if (!vi)
                      throw new Error("Error trying to parse relative URL.");
                    if (vi.scheme)
                      return mi.alwaysNormalize ? (vi.path = di.normalizePath(vi.path), di.buildURLFromParts(vi)) : gi;
                    var xi = di.parseURL(fi);
                    if (!xi)
                      throw new Error("Error trying to parse base URL.");
                    if (!xi.netLoc && xi.path && xi.path[0] !== "/") {
                      var Si = li.exec(xi.path);
                      xi.netLoc = Si[1], xi.path = Si[2];
                    }
                    xi.netLoc && !xi.path && (xi.path = "/");
                    var Pi = {
                      // 2c) Otherwise, the embedded URL inherits the scheme of
                      // the base URL.
                      scheme: xi.scheme,
                      netLoc: vi.netLoc,
                      path: null,
                      params: vi.params,
                      query: vi.query,
                      fragment: vi.fragment
                    };
                    if (!vi.netLoc && (Pi.netLoc = xi.netLoc, vi.path[0] !== "/"))
                      if (!vi.path)
                        Pi.path = xi.path, vi.params || (Pi.params = xi.params, vi.query || (Pi.query = xi.query));
                      else {
                        var $i = xi.path, Oi = $i.substring(0, $i.lastIndexOf("/") + 1) + vi.path;
                        Pi.path = di.normalizePath(Oi);
                      }
                    return Pi.path === null && (Pi.path = mi.alwaysNormalize ? di.normalizePath(vi.path) : vi.path), di.buildURLFromParts(Pi);
                  },
                  parseURL: function(fi) {
                    var gi = ai.exec(fi);
                    return gi ? {
                      scheme: gi[1] || "",
                      netLoc: gi[2] || "",
                      path: gi[3] || "",
                      params: gi[4] || "",
                      query: gi[5] || "",
                      fragment: gi[6] || ""
                    } : null;
                  },
                  normalizePath: function(fi) {
                    for (fi = fi.split("").reverse().join("").replace(oi, ""); fi.length !== (fi = fi.replace(si, "")).length; )
                      ;
                    return fi.split("").reverse().join("");
                  },
                  buildURLFromParts: function(fi) {
                    return fi.scheme + fi.netLoc + fi.path + fi.params + fi.query + fi.fragment;
                  }
                };
                ir.exports = di;
              })();
            })
          ),
          /***/
          "./node_modules/webworkify-webpack/index.js": (
            /*!**************************************************!*\
              !*** ./node_modules/webworkify-webpack/index.js ***!
              \**************************************************/
            /*! no static exports found */
            /*! ModuleConcatenation bailout: Module is not an ECMAScript module */
            /***/
            (function(ir, ti, ii) {
              function ui(mi) {
                var Ti = {};
                function vi(Si) {
                  if (Ti[Si])
                    return Ti[Si].exports;
                  var Pi = Ti[Si] = {
                    /******/
                    i: Si,
                    /******/
                    l: !1,
                    /******/
                    exports: {}
                    /******/
                  };
                  return mi[Si].call(Pi.exports, Pi, Pi.exports, vi), Pi.l = !0, Pi.exports;
                }
                vi.m = mi, vi.c = Ti, vi.i = function(Si) {
                  return Si;
                }, vi.d = function(Si, Pi, $i) {
                  vi.o(Si, Pi) || Object.defineProperty(Si, Pi, {
                    /******/
                    configurable: !1,
                    /******/
                    enumerable: !0,
                    /******/
                    get: $i
                    /******/
                  });
                }, vi.r = function(Si) {
                  Object.defineProperty(Si, "__esModule", { value: !0 });
                }, vi.n = function(Si) {
                  var Pi = Si && Si.__esModule ? (
                    /******/
                    function() {
                      return Si.default;
                    }
                  ) : (
                    /******/
                    function() {
                      return Si;
                    }
                  );
                  return vi.d(Pi, "a", Pi), Pi;
                }, vi.o = function(Si, Pi) {
                  return Object.prototype.hasOwnProperty.call(Si, Pi);
                }, vi.p = "/", vi.oe = function(Si) {
                  throw console.error(Si), Si;
                };
                var xi = vi(vi.s = ENTRY_MODULE);
                return xi.default || xi;
              }
              var ai = "[\\.|\\-|\\+|\\w|/|@]+", li = "\\(\\s*(/\\*.*?\\*/)?\\s*.*?(" + ai + ").*?\\)";
              function oi(mi) {
                return (mi + "").replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
              }
              function si(mi) {
                return !isNaN(1 * mi);
              }
              function di(mi, Ti, vi) {
                var xi = {};
                xi[vi] = [];
                var Si = Ti.toString(), Pi = Si.match(/^function\s?\w*\(\w+,\s*\w+,\s*(\w+)\)/);
                if (!Pi) return xi;
                for (var $i = Pi[1], Oi = new RegExp("(\\\\n|\\W)" + oi($i) + li, "g"), Di; Di = Oi.exec(Si); )
                  Di[3] !== "dll-reference" && xi[vi].push(Di[3]);
                for (Oi = new RegExp("\\(" + oi($i) + '\\("(dll-reference\\s(' + ai + '))"\\)\\)' + li, "g"); Di = Oi.exec(Si); )
                  mi[Di[2]] || (xi[vi].push(Di[1]), mi[Di[2]] = ii(Di[1]).m), xi[Di[2]] = xi[Di[2]] || [], xi[Di[2]].push(Di[4]);
                for (var Mi = Object.keys(xi), Oo = 0; Oo < Mi.length; Oo++)
                  for (var io = 0; io < xi[Mi[Oo]].length; io++)
                    si(xi[Mi[Oo]][io]) && (xi[Mi[Oo]][io] = 1 * xi[Mi[Oo]][io]);
                return xi;
              }
              function fi(mi) {
                var Ti = Object.keys(mi);
                return Ti.reduce(function(vi, xi) {
                  return vi || mi[xi].length > 0;
                }, !1);
              }
              function gi(mi, Ti) {
                for (var vi = {
                  main: [Ti]
                }, xi = {
                  main: []
                }, Si = {
                  main: {}
                }; fi(vi); )
                  for (var Pi = Object.keys(vi), $i = 0; $i < Pi.length; $i++) {
                    var Oi = Pi[$i], Di = vi[Oi], Mi = Di.pop();
                    if (Si[Oi] = Si[Oi] || {}, !(Si[Oi][Mi] || !mi[Oi][Mi])) {
                      Si[Oi][Mi] = !0, xi[Oi] = xi[Oi] || [], xi[Oi].push(Mi);
                      for (var Oo = di(mi, mi[Oi][Mi], Oi), io = Object.keys(Oo), xo = 0; xo < io.length; xo++)
                        vi[io[xo]] = vi[io[xo]] || [], vi[io[xo]] = vi[io[xo]].concat(Oo[io[xo]]);
                    }
                  }
                return xi;
              }
              ir.exports = function(mi, Ti) {
                Ti = Ti || {};
                var vi = {
                  main: ii.m
                }, xi = Ti.all ? { main: Object.keys(vi.main) } : gi(vi, mi), Si = "";
                Object.keys(xi).filter(function(Mi) {
                  return Mi !== "main";
                }).forEach(function(Mi) {
                  for (var Oo = 0; xi[Mi][Oo]; )
                    Oo++;
                  xi[Mi].push(Oo), vi[Mi][Oo] = "(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })", Si = Si + "var " + Mi + " = (" + ui.toString().replace("ENTRY_MODULE", JSON.stringify(Oo)) + ")({" + xi[Mi].map(function(io) {
                    return "" + JSON.stringify(io) + ": " + vi[Mi][io].toString();
                  }).join(",") + `});
`;
                }), Si = Si + "new ((" + ui.toString().replace("ENTRY_MODULE", JSON.stringify(mi)) + ")({" + xi.main.map(function(Mi) {
                  return "" + JSON.stringify(Mi) + ": " + vi.main[Mi].toString();
                }).join(",") + "}))(self);";
                var Pi = new window.Blob([Si], { type: "text/javascript" });
                if (Ti.bare)
                  return Pi;
                var $i = window.URL || window.webkitURL || window.mozURL || window.msURL, Oi = $i.createObjectURL(Pi), Di = new window.Worker(Oi);
                return Di.objectURL = Oi, Di;
              };
            })
          ),
          /***/
          "./src/crypt/decrypter.js": (
            /*!********************************************!*\
              !*** ./src/crypt/decrypter.js + 3 modules ***!
              \********************************************/
            /*! exports provided: default */
            /*! ModuleConcatenation bailout: Cannot concat with ./src/errors.ts because of ./src/hls.ts */
            /*! ModuleConcatenation bailout: Cannot concat with ./src/events.js because of ./src/hls.ts */
            /*! ModuleConcatenation bailout: Cannot concat with ./src/utils/get-self-scope.js because of ./src/hls.ts */
            /*! ModuleConcatenation bailout: Cannot concat with ./src/utils/logger.js because of ./src/hls.ts */
            /***/
            (function(ir, ti, ii) {
              ii.r(ti);
              var ui = /* @__PURE__ */ (function() {
                function Si($i, Oi) {
                  this.subtle = $i, this.aesIV = Oi;
                }
                var Pi = Si.prototype;
                return Pi.decrypt = function(Oi, Di) {
                  return this.subtle.decrypt({
                    name: "AES-CBC",
                    iv: this.aesIV
                  }, Di, Oi);
                }, Si;
              })(), ai = /* @__PURE__ */ (function() {
                function Si($i, Oi) {
                  this.subtle = $i, this.key = Oi;
                }
                var Pi = Si.prototype;
                return Pi.expandKey = function() {
                  return this.subtle.importKey("raw", this.key, {
                    name: "AES-CBC"
                  }, !1, ["encrypt", "decrypt"]);
                }, Si;
              })(), li = ai;
              function oi(Si) {
                var Pi = Si.byteLength, $i = Pi && new DataView(Si).getUint8(Pi - 1);
                return $i ? Si.slice(0, Pi - $i) : Si;
              }
              var si = /* @__PURE__ */ (function() {
                function Si() {
                  this.rcon = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], this.subMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)], this.invSubMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)], this.sBox = new Uint32Array(256), this.invSBox = new Uint32Array(256), this.key = new Uint32Array(0), this.initTable();
                }
                var Pi = Si.prototype;
                return Pi.uint8ArrayToUint32Array_ = function(Oi) {
                  for (var Di = new DataView(Oi), Mi = new Uint32Array(4), Oo = 0; Oo < 4; Oo++)
                    Mi[Oo] = Di.getUint32(Oo * 4);
                  return Mi;
                }, Pi.initTable = function() {
                  var Oi = this.sBox, Di = this.invSBox, Mi = this.subMix, Oo = Mi[0], io = Mi[1], xo = Mi[2], fo = Mi[3], _o = this.invSubMix, Li = _o[0], Co = _o[1], Ni = _o[2], Yi = _o[3], Vo = new Uint32Array(256), No = 0, Ui = 0, jo = 0;
                  for (jo = 0; jo < 256; jo++)
                    jo < 128 ? Vo[jo] = jo << 1 : Vo[jo] = jo << 1 ^ 283;
                  for (jo = 0; jo < 256; jo++) {
                    var Wi = Ui ^ Ui << 1 ^ Ui << 2 ^ Ui << 3 ^ Ui << 4;
                    Wi = Wi >>> 8 ^ Wi & 255 ^ 99, Oi[No] = Wi, Di[Wi] = No;
                    var ji = Vo[No], Hi = Vo[ji], zo = Vo[Hi], Lo = Vo[Wi] * 257 ^ Wi * 16843008;
                    Oo[No] = Lo << 24 | Lo >>> 8, io[No] = Lo << 16 | Lo >>> 16, xo[No] = Lo << 8 | Lo >>> 24, fo[No] = Lo, Lo = zo * 16843009 ^ Hi * 65537 ^ ji * 257 ^ No * 16843008, Li[Wi] = Lo << 24 | Lo >>> 8, Co[Wi] = Lo << 16 | Lo >>> 16, Ni[Wi] = Lo << 8 | Lo >>> 24, Yi[Wi] = Lo, No ? (No = ji ^ Vo[Vo[Vo[zo ^ ji]]], Ui ^= Vo[Vo[Ui]]) : No = Ui = 1;
                  }
                }, Pi.expandKey = function(Oi) {
                  for (var Di = this.uint8ArrayToUint32Array_(Oi), Mi = !0, Oo = 0; Oo < Di.length && Mi; )
                    Mi = Di[Oo] === this.key[Oo], Oo++;
                  if (!Mi) {
                    this.key = Di;
                    var io = this.keySize = Di.length;
                    if (io !== 4 && io !== 6 && io !== 8)
                      throw new Error("Invalid aes key size=" + io);
                    var xo = this.ksRows = (io + 6 + 1) * 4, fo, _o, Li = this.keySchedule = new Uint32Array(xo), Co = this.invKeySchedule = new Uint32Array(xo), Ni = this.sBox, Yi = this.rcon, Vo = this.invSubMix, No = Vo[0], Ui = Vo[1], jo = Vo[2], Wi = Vo[3], ji, Hi;
                    for (fo = 0; fo < xo; fo++) {
                      if (fo < io) {
                        ji = Li[fo] = Di[fo];
                        continue;
                      }
                      Hi = ji, fo % io === 0 ? (Hi = Hi << 8 | Hi >>> 24, Hi = Ni[Hi >>> 24] << 24 | Ni[Hi >>> 16 & 255] << 16 | Ni[Hi >>> 8 & 255] << 8 | Ni[Hi & 255], Hi ^= Yi[fo / io | 0] << 24) : io > 6 && fo % io === 4 && (Hi = Ni[Hi >>> 24] << 24 | Ni[Hi >>> 16 & 255] << 16 | Ni[Hi >>> 8 & 255] << 8 | Ni[Hi & 255]), Li[fo] = ji = (Li[fo - io] ^ Hi) >>> 0;
                    }
                    for (_o = 0; _o < xo; _o++)
                      fo = xo - _o, _o & 3 ? Hi = Li[fo] : Hi = Li[fo - 4], _o < 4 || fo <= 4 ? Co[_o] = Hi : Co[_o] = No[Ni[Hi >>> 24]] ^ Ui[Ni[Hi >>> 16 & 255]] ^ jo[Ni[Hi >>> 8 & 255]] ^ Wi[Ni[Hi & 255]], Co[_o] = Co[_o] >>> 0;
                  }
                }, Pi.networkToHostOrderSwap = function(Oi) {
                  return Oi << 24 | (Oi & 65280) << 8 | (Oi & 16711680) >> 8 | Oi >>> 24;
                }, Pi.decrypt = function(Oi, Di, Mi, Oo) {
                  for (var io = this.keySize + 6, xo = this.invKeySchedule, fo = this.invSBox, _o = this.invSubMix, Li = _o[0], Co = _o[1], Ni = _o[2], Yi = _o[3], Vo = this.uint8ArrayToUint32Array_(Mi), No = Vo[0], Ui = Vo[1], jo = Vo[2], Wi = Vo[3], ji = new Int32Array(Oi), Hi = new Int32Array(ji.length), zo, Lo, sa, Ko, ca, pa, ga, ia, ra, qo, xa, $a, ys, Ss, Xa = this.networkToHostOrderSwap; Di < ji.length; ) {
                    for (ra = Xa(ji[Di]), qo = Xa(ji[Di + 1]), xa = Xa(ji[Di + 2]), $a = Xa(ji[Di + 3]), ca = ra ^ xo[0], pa = $a ^ xo[1], ga = xa ^ xo[2], ia = qo ^ xo[3], ys = 4, Ss = 1; Ss < io; Ss++)
                      zo = Li[ca >>> 24] ^ Co[pa >> 16 & 255] ^ Ni[ga >> 8 & 255] ^ Yi[ia & 255] ^ xo[ys], Lo = Li[pa >>> 24] ^ Co[ga >> 16 & 255] ^ Ni[ia >> 8 & 255] ^ Yi[ca & 255] ^ xo[ys + 1], sa = Li[ga >>> 24] ^ Co[ia >> 16 & 255] ^ Ni[ca >> 8 & 255] ^ Yi[pa & 255] ^ xo[ys + 2], Ko = Li[ia >>> 24] ^ Co[ca >> 16 & 255] ^ Ni[pa >> 8 & 255] ^ Yi[ga & 255] ^ xo[ys + 3], ca = zo, pa = Lo, ga = sa, ia = Ko, ys = ys + 4;
                    zo = fo[ca >>> 24] << 24 ^ fo[pa >> 16 & 255] << 16 ^ fo[ga >> 8 & 255] << 8 ^ fo[ia & 255] ^ xo[ys], Lo = fo[pa >>> 24] << 24 ^ fo[ga >> 16 & 255] << 16 ^ fo[ia >> 8 & 255] << 8 ^ fo[ca & 255] ^ xo[ys + 1], sa = fo[ga >>> 24] << 24 ^ fo[ia >> 16 & 255] << 16 ^ fo[ca >> 8 & 255] << 8 ^ fo[pa & 255] ^ xo[ys + 2], Ko = fo[ia >>> 24] << 24 ^ fo[ca >> 16 & 255] << 16 ^ fo[pa >> 8 & 255] << 8 ^ fo[ga & 255] ^ xo[ys + 3], ys = ys + 3, Hi[Di] = Xa(zo ^ No), Hi[Di + 1] = Xa(Ko ^ Ui), Hi[Di + 2] = Xa(sa ^ jo), Hi[Di + 3] = Xa(Lo ^ Wi), No = ra, Ui = qo, jo = xa, Wi = $a, Di = Di + 4;
                  }
                  return Oo ? oi(Hi.buffer) : Hi.buffer;
                }, Pi.destroy = function() {
                  this.key = void 0, this.keySize = void 0, this.ksRows = void 0, this.sBox = void 0, this.invSBox = void 0, this.subMix = void 0, this.invSubMix = void 0, this.keySchedule = void 0, this.invKeySchedule = void 0, this.rcon = void 0;
                }, Si;
              })(), di = si, fi = ii("./src/errors.ts"), gi = ii("./src/utils/logger.js"), mi = ii("./src/events.js"), Ti = ii("./src/utils/get-self-scope.js"), vi = Object(Ti.getSelfScope)(), xi = /* @__PURE__ */ (function() {
                function Si($i, Oi, Di) {
                  var Mi = Di === void 0 ? {} : Di, Oo = Mi.removePKCS7Padding, io = Oo === void 0 ? !0 : Oo;
                  if (this.logEnabled = !0, this.observer = $i, this.config = Oi, this.removePKCS7Padding = io, io)
                    try {
                      var xo = vi.crypto;
                      xo && (this.subtle = xo.subtle || xo.webkitSubtle);
                    } catch {
                    }
                  this.disableWebCrypto = !this.subtle;
                }
                var Pi = Si.prototype;
                return Pi.isSync = function() {
                  return this.disableWebCrypto && this.config.enableSoftwareAES;
                }, Pi.decrypt = function(Oi, Di, Mi, Oo) {
                  var io = this;
                  if (this.disableWebCrypto && this.config.enableSoftwareAES) {
                    this.logEnabled && (gi.logger.log("JS AES decrypt"), this.logEnabled = !1);
                    var xo = this.decryptor;
                    xo || (this.decryptor = xo = new di()), xo.expandKey(Di), Oo(xo.decrypt(Oi, 0, Mi, this.removePKCS7Padding));
                  } else {
                    this.logEnabled && (gi.logger.log("WebCrypto AES decrypt"), this.logEnabled = !1);
                    var fo = this.subtle;
                    this.key !== Di && (this.key = Di, this.fastAesKey = new li(fo, Di)), this.fastAesKey.expandKey().then(function(_o) {
                      var Li = new ui(fo, Mi);
                      Li.decrypt(Oi, _o).catch(function(Co) {
                        io.onWebCryptoError(Co, Oi, Di, Mi, Oo);
                      }).then(function(Co) {
                        Oo(Co);
                      });
                    }).catch(function(_o) {
                      io.onWebCryptoError(_o, Oi, Di, Mi, Oo);
                    });
                  }
                }, Pi.onWebCryptoError = function(Oi, Di, Mi, Oo, io) {
                  this.config.enableSoftwareAES ? (gi.logger.log("WebCrypto Error, disable WebCrypto API"), this.disableWebCrypto = !0, this.logEnabled = !0, this.decrypt(Di, Mi, Oo, io)) : (gi.logger.error("decrypting error : " + Oi.message), this.observer.trigger(mi.default.ERROR, {
                    type: fi.ErrorTypes.MEDIA_ERROR,
                    details: fi.ErrorDetails.FRAG_DECRYPT_ERROR,
                    fatal: !0,
                    reason: Oi.message
                  }));
                }, Pi.destroy = function() {
                  var Oi = this.decryptor;
                  Oi && (Oi.destroy(), this.decryptor = void 0);
                }, Si;
              })();
              ti.default = xi;
            })
          ),
          /***/
          "./src/demux/demuxer-inline.js": (
            /*!**************************************************!*\
              !*** ./src/demux/demuxer-inline.js + 12 modules ***!
              \**************************************************/
            /*! exports provided: default */
            /*! ModuleConcatenation bailout: Cannot concat with ./src/crypt/decrypter.js because of ./src/hls.ts */
            /*! ModuleConcatenation bailout: Cannot concat with ./src/demux/id3.js because of ./src/hls.ts */
            /*! ModuleConcatenation bailout: Cannot concat with ./src/demux/mp4demuxer.js because of ./src/hls.ts */
            /*! ModuleConcatenation bailout: Cannot concat with ./src/errors.ts because of ./src/hls.ts */
            /*! ModuleConcatenation bailout: Cannot concat with ./src/events.js because of ./src/hls.ts */
            /*! ModuleConcatenation bailout: Cannot concat with ./src/polyfills/number.js because of ./src/hls.ts */
            /*! ModuleConcatenation bailout: Cannot concat with ./src/utils/get-self-scope.js because of ./src/hls.ts */
            /*! ModuleConcatenation bailout: Cannot concat with ./src/utils/logger.js because of ./src/hls.ts */
            /***/
            (function(ir, ti, ii) {
              ii.r(ti);
              var ui = ii("./src/events.js"), ai = ii("./src/errors.ts"), li = ii("./src/crypt/decrypter.js"), oi = ii("./src/polyfills/number.js"), si = ii("./src/utils/logger.js"), di = ii("./src/utils/get-self-scope.js");
              function fi(La, Ja, ja, Ta) {
                var rs, Qa, Cs, _a, _s, el = navigator.userAgent.toLowerCase(), Ps = Ta, nl = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350];
                if (rs = ((Ja[ja + 2] & 192) >>> 6) + 1, Qa = (Ja[ja + 2] & 60) >>> 2, Qa > nl.length - 1) {
                  La.trigger(ui.default.ERROR, {
                    type: ai.ErrorTypes.MEDIA_ERROR,
                    details: ai.ErrorDetails.FRAG_PARSING_ERROR,
                    fatal: !0,
                    reason: "invalid ADTS sampling index:" + Qa
                  });
                  return;
                }
                return _a = (Ja[ja + 2] & 1) << 2, _a |= (Ja[ja + 3] & 192) >>> 6, si.logger.log("manifest codec:" + Ta + ",ADTS data:type:" + rs + ",sampleingIndex:" + Qa + "[" + nl[Qa] + "Hz],channelConfig:" + _a), /firefox/i.test(el) ? Qa >= 6 ? (rs = 5, _s = new Array(4), Cs = Qa - 3) : (rs = 2, _s = new Array(2), Cs = Qa) : el.indexOf("android") !== -1 ? (rs = 2, _s = new Array(2), Cs = Qa) : (rs = 5, _s = new Array(4), Ta && (Ta.indexOf("mp4a.40.29") !== -1 || Ta.indexOf("mp4a.40.5") !== -1) || !Ta && Qa >= 6 ? Cs = Qa - 3 : ((Ta && Ta.indexOf("mp4a.40.2") !== -1 && (Qa >= 6 && _a === 1 || /vivaldi/i.test(el)) || !Ta && _a === 1) && (rs = 2, _s = new Array(2)), Cs = Qa)), _s[0] = rs << 3, _s[0] |= (Qa & 14) >> 1, _s[1] |= (Qa & 1) << 7, _s[1] |= _a << 3, rs === 5 && (_s[1] |= (Cs & 14) >> 1, _s[2] = (Cs & 1) << 7, _s[2] |= 8, _s[3] = 0), {
                  config: _s,
                  samplerate: nl[Qa],
                  channelCount: _a,
                  codec: "mp4a.40." + rs,
                  manifestCodec: Ps
                };
              }
              function gi(La, Ja) {
                return La[Ja] === 255 && (La[Ja + 1] & 246) === 240;
              }
              function mi(La, Ja) {
                return La[Ja + 1] & 1 ? 7 : 9;
              }
              function Ti(La, Ja) {
                return (La[Ja + 3] & 3) << 11 | La[Ja + 4] << 3 | (La[Ja + 5] & 224) >>> 5;
              }
              function vi(La, Ja) {
                return !!(Ja + 1 < La.length && gi(La, Ja));
              }
              function xi(La, Ja) {
                if (vi(La, Ja)) {
                  var ja = mi(La, Ja);
                  if (Ja + ja >= La.length)
                    return !1;
                  var Ta = Ti(La, Ja);
                  if (Ta <= ja)
                    return !1;
                  var rs = Ja + Ta;
                  if (rs === La.length || rs + 1 < La.length && gi(La, rs))
                    return !0;
                }
                return !1;
              }
              function Si(La, Ja, ja, Ta, rs) {
                if (!La.samplerate) {
                  var Qa = fi(Ja, ja, Ta, rs);
                  La.config = Qa.config, La.samplerate = Qa.samplerate, La.channelCount = Qa.channelCount, La.codec = Qa.codec, La.manifestCodec = Qa.manifestCodec, si.logger.log("parsed codec:" + La.codec + ",rate:" + Qa.samplerate + ",nb channel:" + Qa.channelCount);
                }
              }
              function Pi(La) {
                return 1024 * 9e4 / La;
              }
              function $i(La, Ja, ja, Ta, rs) {
                var Qa, Cs, _a, _s = La.length;
                if (Qa = mi(La, Ja), Cs = Ti(La, Ja), Cs -= Qa, Cs > 0 && Ja + Qa + Cs <= _s)
                  return _a = ja + Ta * rs, {
                    headerLength: Qa,
                    frameLength: Cs,
                    stamp: _a
                  };
              }
              function Oi(La, Ja, ja, Ta, rs) {
                var Qa = Pi(La.samplerate), Cs = $i(Ja, ja, Ta, rs, Qa);
                if (Cs) {
                  var _a = Cs.stamp, _s = Cs.headerLength, el = Cs.frameLength, Ps = {
                    unit: Ja.subarray(ja + _s, ja + _s + el),
                    pts: _a,
                    dts: _a
                  };
                  return La.samples.push(Ps), {
                    sample: Ps,
                    length: el + _s
                  };
                }
              }
              var Di = ii("./src/demux/id3.js"), Mi = /* @__PURE__ */ (function() {
                function La(ja, Ta, rs) {
                  this.observer = ja, this.config = rs, this.remuxer = Ta;
                }
                var Ja = La.prototype;
                return Ja.resetInitSegment = function(Ta, rs, Qa, Cs) {
                  this._audioTrack = {
                    container: "audio/adts",
                    type: "audio",
                    id: 0,
                    sequenceNumber: 0,
                    isAAC: !0,
                    samples: [],
                    len: 0,
                    manifestCodec: rs,
                    duration: Cs,
                    inputTimeScale: 9e4
                  };
                }, Ja.resetTimeStamp = function() {
                }, La.probe = function(Ta) {
                  if (!Ta)
                    return !1;
                  for (var rs = Di.default.getID3Data(Ta, 0) || [], Qa = rs.length, Cs = Ta.length; Qa < Cs; Qa++)
                    if (xi(Ta, Qa))
                      return si.logger.log("ADTS sync word found !"), !0;
                  return !1;
                }, Ja.append = function(Ta, rs, Qa, Cs) {
                  for (var _a = this._audioTrack, _s = Di.default.getID3Data(Ta, 0) || [], el = Di.default.getTimeStamp(_s), Ps = Object(oi.isFiniteNumber)(el) ? el * 90 : rs * 9e4, nl = 0, Vs = Ps, es = Ta.length, Is = _s.length, fl = [{
                    pts: Vs,
                    dts: Vs,
                    data: _s
                  }]; Is < es - 1; )
                    if (vi(Ta, Is) && Is + 5 < es) {
                      Si(_a, this.observer, Ta, Is, _a.manifestCodec);
                      var sl = Oi(_a, Ta, Is, Ps, nl);
                      if (sl)
                        Is += sl.length, Vs = sl.sample.pts, nl++;
                      else {
                        si.logger.log("Unable to parse AAC frame");
                        break;
                      }
                    } else Di.default.isHeader(Ta, Is) ? (_s = Di.default.getID3Data(Ta, Is), fl.push({
                      pts: Vs,
                      dts: Vs,
                      data: _s
                    }), Is += _s.length) : Is++;
                  this.remuxer.remux(_a, {
                    samples: []
                  }, {
                    samples: fl,
                    inputTimeScale: 9e4
                  }, {
                    samples: []
                  }, rs, Qa, Cs);
                }, Ja.destroy = function() {
                }, La;
              })(), Oo = Mi, io = ii("./src/demux/mp4demuxer.js"), xo = {
                BitratesMap: [32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160],
                SamplingRateMap: [44100, 48e3, 32e3, 22050, 24e3, 16e3, 11025, 12e3, 8e3],
                SamplesCoefficients: [
                  // MPEG 2.5
                  [
                    0,
                    // Reserved
                    72,
                    // Layer3
                    144,
                    // Layer2
                    12
                    // Layer1
                  ],
                  // Reserved
                  [
                    0,
                    // Reserved
                    0,
                    // Layer3
                    0,
                    // Layer2
                    0
                    // Layer1
                  ],
                  // MPEG 2
                  [
                    0,
                    // Reserved
                    72,
                    // Layer3
                    144,
                    // Layer2
                    12
                    // Layer1
                  ],
                  // MPEG 1
                  [
                    0,
                    // Reserved
                    144,
                    // Layer3
                    144,
                    // Layer2
                    12
                    // Layer1
                  ]
                ],
                BytesInSlot: [
                  0,
                  // Reserved
                  1,
                  // Layer3
                  1,
                  // Layer2
                  4
                  // Layer1
                ],
                appendFrame: function(Ja, ja, Ta, rs, Qa) {
                  if (!(Ta + 24 > ja.length)) {
                    var Cs = this.parseHeader(ja, Ta);
                    if (Cs && Ta + Cs.frameLength <= ja.length) {
                      var _a = Cs.samplesPerFrame * 9e4 / Cs.sampleRate, _s = rs + Qa * _a, el = {
                        unit: ja.subarray(Ta, Ta + Cs.frameLength),
                        pts: _s,
                        dts: _s
                      };
                      return Ja.config = [], Ja.channelCount = Cs.channelCount, Ja.samplerate = Cs.sampleRate, Ja.samples.push(el), {
                        sample: el,
                        length: Cs.frameLength
                      };
                    }
                  }
                },
                parseHeader: function(Ja, ja) {
                  var Ta = Ja[ja + 1] >> 3 & 3, rs = Ja[ja + 1] >> 1 & 3, Qa = Ja[ja + 2] >> 4 & 15, Cs = Ja[ja + 2] >> 2 & 3, _a = Ja[ja + 2] >> 1 & 1;
                  if (Ta !== 1 && Qa !== 0 && Qa !== 15 && Cs !== 3) {
                    var _s = Ta === 3 ? 3 - rs : rs === 3 ? 3 : 4, el = xo.BitratesMap[_s * 14 + Qa - 1] * 1e3, Ps = Ta === 3 ? 0 : Ta === 2 ? 1 : 2, nl = xo.SamplingRateMap[Ps * 3 + Cs], Vs = Ja[ja + 3] >> 6 === 3 ? 1 : 2, es = xo.SamplesCoefficients[Ta][rs], Is = xo.BytesInSlot[rs], fl = es * 8 * Is, sl = parseInt(es * el / nl + _a, 10) * Is;
                    return {
                      sampleRate: nl,
                      channelCount: Vs,
                      frameLength: sl,
                      samplesPerFrame: fl
                    };
                  }
                },
                isHeaderPattern: function(Ja, ja) {
                  return Ja[ja] === 255 && (Ja[ja + 1] & 224) === 224 && (Ja[ja + 1] & 6) !== 0;
                },
                isHeader: function(Ja, ja) {
                  return !!(ja + 1 < Ja.length && this.isHeaderPattern(Ja, ja));
                },
                probe: function(Ja, ja) {
                  if (ja + 1 < Ja.length && this.isHeaderPattern(Ja, ja)) {
                    var Ta = 4, rs = this.parseHeader(Ja, ja), Qa = Ta;
                    rs && rs.frameLength && (Qa = rs.frameLength);
                    var Cs = ja + Qa;
                    if (Cs === Ja.length || Cs + 1 < Ja.length && this.isHeaderPattern(Ja, Cs))
                      return !0;
                  }
                  return !1;
                }
              }, fo = xo, _o = /* @__PURE__ */ (function() {
                function La(ja) {
                  this.data = ja, this.bytesAvailable = ja.byteLength, this.word = 0, this.bitsAvailable = 0;
                }
                var Ja = La.prototype;
                return Ja.loadWord = function() {
                  var Ta = this.data, rs = this.bytesAvailable, Qa = Ta.byteLength - rs, Cs = new Uint8Array(4), _a = Math.min(4, rs);
                  if (_a === 0)
                    throw new Error("no bytes available");
                  Cs.set(Ta.subarray(Qa, Qa + _a)), this.word = new DataView(Cs.buffer).getUint32(0), this.bitsAvailable = _a * 8, this.bytesAvailable -= _a;
                }, Ja.skipBits = function(Ta) {
                  var rs;
                  this.bitsAvailable > Ta ? (this.word <<= Ta, this.bitsAvailable -= Ta) : (Ta -= this.bitsAvailable, rs = Ta >> 3, Ta -= rs >> 3, this.bytesAvailable -= rs, this.loadWord(), this.word <<= Ta, this.bitsAvailable -= Ta);
                }, Ja.readBits = function(Ta) {
                  var rs = Math.min(this.bitsAvailable, Ta), Qa = this.word >>> 32 - rs;
                  return Ta > 32 && si.logger.error("Cannot read more than 32 bits at a time"), this.bitsAvailable -= rs, this.bitsAvailable > 0 ? this.word <<= rs : this.bytesAvailable > 0 && this.loadWord(), rs = Ta - rs, rs > 0 && this.bitsAvailable ? Qa << rs | this.readBits(rs) : Qa;
                }, Ja.skipLZ = function() {
                  var Ta;
                  for (Ta = 0; Ta < this.bitsAvailable; ++Ta)
                    if ((this.word & 2147483648 >>> Ta) !== 0)
                      return this.word <<= Ta, this.bitsAvailable -= Ta, Ta;
                  return this.loadWord(), Ta + this.skipLZ();
                }, Ja.skipUEG = function() {
                  this.skipBits(1 + this.skipLZ());
                }, Ja.skipEG = function() {
                  this.skipBits(1 + this.skipLZ());
                }, Ja.readUEG = function() {
                  var Ta = this.skipLZ();
                  return this.readBits(Ta + 1) - 1;
                }, Ja.readEG = function() {
                  var Ta = this.readUEG();
                  return 1 & Ta ? 1 + Ta >>> 1 : -1 * (Ta >>> 1);
                }, Ja.readBoolean = function() {
                  return this.readBits(1) === 1;
                }, Ja.readUByte = function() {
                  return this.readBits(8);
                }, Ja.readUShort = function() {
                  return this.readBits(16);
                }, Ja.readUInt = function() {
                  return this.readBits(32);
                }, Ja.skipScalingList = function(Ta) {
                  var rs = 8, Qa = 8, Cs, _a;
                  for (Cs = 0; Cs < Ta; Cs++)
                    Qa !== 0 && (_a = this.readEG(), Qa = (rs + _a + 256) % 256), rs = Qa === 0 ? rs : Qa;
                }, Ja.readSPS = function() {
                  var Ta = 0, rs = 0, Qa = 0, Cs = 0, _a, _s, el, Ps, nl, Vs, es, Is = this.readUByte.bind(this), fl = this.readBits.bind(this), sl = this.readUEG.bind(this), Il = this.readBoolean.bind(this), Vl = this.skipBits.bind(this), Bl = this.skipEG.bind(this), ql = this.skipUEG.bind(this), xl = this.skipScalingList.bind(this);
                  if (Is(), _a = Is(), fl(5), Vl(3), Is(), ql(), _a === 100 || _a === 110 || _a === 122 || _a === 244 || _a === 44 || _a === 83 || _a === 86 || _a === 118 || _a === 128) {
                    var Ul = sl();
                    if (Ul === 3 && Vl(1), ql(), ql(), Vl(1), Il())
                      for (Vs = Ul !== 3 ? 8 : 12, es = 0; es < Vs; es++)
                        Il() && (es < 6 ? xl(16) : xl(64));
                  }
                  ql();
                  var Xl = sl();
                  if (Xl === 0)
                    sl();
                  else if (Xl === 1)
                    for (Vl(1), Bl(), Bl(), _s = sl(), es = 0; es < _s; es++)
                      Bl();
                  ql(), Vl(1), el = sl(), Ps = sl(), nl = fl(1), nl === 0 && Vl(1), Vl(1), Il() && (Ta = sl(), rs = sl(), Qa = sl(), Cs = sl());
                  var hu = [1, 1];
                  if (Il() && Il()) {
                    var Tu = Is();
                    switch (Tu) {
                      case 1:
                        hu = [1, 1];
                        break;
                      case 2:
                        hu = [12, 11];
                        break;
                      case 3:
                        hu = [10, 11];
                        break;
                      case 4:
                        hu = [16, 11];
                        break;
                      case 5:
                        hu = [40, 33];
                        break;
                      case 6:
                        hu = [24, 11];
                        break;
                      case 7:
                        hu = [20, 11];
                        break;
                      case 8:
                        hu = [32, 11];
                        break;
                      case 9:
                        hu = [80, 33];
                        break;
                      case 10:
                        hu = [18, 11];
                        break;
                      case 11:
                        hu = [15, 11];
                        break;
                      case 12:
                        hu = [64, 33];
                        break;
                      case 13:
                        hu = [160, 99];
                        break;
                      case 14:
                        hu = [4, 3];
                        break;
                      case 15:
                        hu = [3, 2];
                        break;
                      case 16:
                        hu = [2, 1];
                        break;
                      case 255: {
                        hu = [Is() << 8 | Is(), Is() << 8 | Is()];
                        break;
                      }
                    }
                  }
                  return {
                    width: Math.ceil((el + 1) * 16 - Ta * 2 - rs * 2),
                    height: (2 - nl) * (Ps + 1) * 16 - (nl ? 2 : 4) * (Qa + Cs),
                    pixelRatio: hu
                  };
                }, Ja.readSliceType = function() {
                  return this.readUByte(), this.readUEG(), this.readUEG();
                }, La;
              })(), Li = _o, Co = /* @__PURE__ */ (function() {
                function La(ja, Ta, rs, Qa) {
                  this.decryptdata = rs, this.discardEPB = Qa, this.decrypter = new li.default(ja, Ta, {
                    removePKCS7Padding: !1
                  });
                }
                var Ja = La.prototype;
                return Ja.decryptBuffer = function(Ta, rs) {
                  this.decrypter.decrypt(Ta, this.decryptdata.key.buffer, this.decryptdata.iv.buffer, rs);
                }, Ja.decryptAacSample = function(Ta, rs, Qa, Cs) {
                  var _a = Ta[rs].unit, _s = _a.subarray(16, _a.length - _a.length % 16), el = _s.buffer.slice(_s.byteOffset, _s.byteOffset + _s.length), Ps = this;
                  this.decryptBuffer(el, function(nl) {
                    nl = new Uint8Array(nl), _a.set(nl, 16), Cs || Ps.decryptAacSamples(Ta, rs + 1, Qa);
                  });
                }, Ja.decryptAacSamples = function(Ta, rs, Qa) {
                  for (; ; rs++) {
                    if (rs >= Ta.length) {
                      Qa();
                      return;
                    }
                    if (!(Ta[rs].unit.length < 32)) {
                      var Cs = this.decrypter.isSync();
                      if (this.decryptAacSample(Ta, rs, Qa, Cs), !Cs)
                        return;
                    }
                  }
                }, Ja.getAvcEncryptedData = function(Ta) {
                  for (var rs = Math.floor((Ta.length - 48) / 160) * 16 + 16, Qa = new Int8Array(rs), Cs = 0, _a = 32; _a <= Ta.length - 16; _a += 160, Cs += 16)
                    Qa.set(Ta.subarray(_a, _a + 16), Cs);
                  return Qa;
                }, Ja.getAvcDecryptedUnit = function(Ta, rs) {
                  rs = new Uint8Array(rs);
                  for (var Qa = 0, Cs = 32; Cs <= Ta.length - 16; Cs += 160, Qa += 16)
                    Ta.set(rs.subarray(Qa, Qa + 16), Cs);
                  return Ta;
                }, Ja.decryptAvcSample = function(Ta, rs, Qa, Cs, _a, _s) {
                  var el = this.discardEPB(_a.data), Ps = this.getAvcEncryptedData(el), nl = this;
                  this.decryptBuffer(Ps.buffer, function(Vs) {
                    _a.data = nl.getAvcDecryptedUnit(el, Vs), _s || nl.decryptAvcSamples(Ta, rs, Qa + 1, Cs);
                  });
                }, Ja.decryptAvcSamples = function(Ta, rs, Qa, Cs) {
                  for (; ; rs++, Qa = 0) {
                    if (rs >= Ta.length) {
                      Cs();
                      return;
                    }
                    for (var _a = Ta[rs].units; !(Qa >= _a.length); Qa++) {
                      var _s = _a[Qa];
                      if (!(_s.data.length <= 48 || _s.type !== 1 && _s.type !== 5)) {
                        var el = this.decrypter.isSync();
                        if (this.decryptAvcSample(Ta, rs, Qa, Cs, _s, el), !el)
                          return;
                      }
                    }
                  }
                }, La;
              })(), Ni = Co, Yi = {
                video: 1,
                audio: 2,
                id3: 3,
                text: 4
              }, Vo = /* @__PURE__ */ (function() {
                function La(ja, Ta, rs, Qa) {
                  this.observer = ja, this.config = rs, this.typeSupported = Qa, this.remuxer = Ta, this.sampleAes = null, this.pmtUnknownTypes = {};
                }
                var Ja = La.prototype;
                return Ja.setDecryptData = function(Ta) {
                  Ta != null && Ta.key != null && Ta.method === "SAMPLE-AES" ? this.sampleAes = new Ni(this.observer, this.config, Ta, this.discardEPB) : this.sampleAes = null;
                }, La.probe = function(Ta) {
                  var rs = La._syncOffset(Ta);
                  return rs < 0 ? !1 : (rs && si.logger.warn("MPEG2-TS detected but first sync word found @ offset " + rs + ", junk ahead ?"), !0);
                }, La._syncOffset = function(Ta) {
                  for (var rs = Math.min(1e3, Ta.length - 564), Qa = 0; Qa < rs; ) {
                    if (Ta[Qa] === 71 && Ta[Qa + 188] === 71 && Ta[Qa + 376] === 71)
                      return Qa;
                    Qa++;
                  }
                  return -1;
                }, La.createTrack = function(Ta, rs) {
                  return {
                    container: Ta === "video" || Ta === "audio" ? "video/mp2t" : void 0,
                    type: Ta,
                    id: Yi[Ta],
                    pid: -1,
                    inputTimeScale: 9e4,
                    sequenceNumber: 0,
                    samples: [],
                    dropped: Ta === "video" ? 0 : void 0,
                    isAAC: Ta === "audio" ? !0 : void 0,
                    duration: Ta === "audio" ? rs : void 0
                  };
                }, Ja.resetInitSegment = function(Ta, rs, Qa, Cs) {
                  this.pmtParsed = !1, this._pmtId = -1, this.pmtUnknownTypes = {}, this._avcTrack = La.createTrack("video", Cs), this._audioTrack = La.createTrack("audio", Cs), this._id3Track = La.createTrack("id3", Cs), this._txtTrack = La.createTrack("text", Cs), this.aacOverFlow = null, this.aacLastPTS = null, this.avcSample = null, this.audioCodec = rs, this.videoCodec = Qa, this._duration = Cs;
                }, Ja.resetTimeStamp = function() {
                }, Ja.append = function(Ta, rs, Qa, Cs) {
                  var _a, _s = Ta.length, el, Ps, nl, Vs, es, Is = !1;
                  this.pmtUnknownTypes = {}, this.contiguous = Qa;
                  var fl = this.pmtParsed, sl = this._avcTrack, Il = this._audioTrack, Vl = this._id3Track, Bl = sl.pid, ql = Il.pid, xl = Vl.pid, Ul = this._pmtId, Xl = sl.pesData, hu = Il.pesData, Tu = Vl.pesData, Ku = this._parsePAT, Wl = this._parsePMT.bind(this), uu = this._parsePES, du = this._parseAVCPES.bind(this), za = this._parseAACPES.bind(this), Ya = this._parseMPEGPES.bind(this), Ws = this._parseID3PES.bind(this), wl = La._syncOffset(Ta);
                  for (_s -= (_s + wl) % 188, _a = wl; _a < _s; _a += 188)
                    if (Ta[_a] === 71) {
                      if (el = !!(Ta[_a + 1] & 64), Ps = ((Ta[_a + 1] & 31) << 8) + Ta[_a + 2], nl = (Ta[_a + 3] & 48) >> 4, nl > 1) {
                        if (Vs = _a + 5 + Ta[_a + 4], Vs === _a + 188)
                          continue;
                      } else
                        Vs = _a + 4;
                      switch (Ps) {
                        case Bl:
                          el && (Xl && (es = uu(Xl)) && du(es, !1), Xl = {
                            data: [],
                            size: 0
                          }), Xl && (Xl.data.push(Ta.subarray(Vs, _a + 188)), Xl.size += _a + 188 - Vs);
                          break;
                        case ql:
                          el && (hu && (es = uu(hu)) && (Il.isAAC ? za(es) : Ya(es)), hu = {
                            data: [],
                            size: 0
                          }), hu && (hu.data.push(Ta.subarray(Vs, _a + 188)), hu.size += _a + 188 - Vs);
                          break;
                        case xl:
                          el && (Tu && (es = uu(Tu)) && Ws(es), Tu = {
                            data: [],
                            size: 0
                          }), Tu && (Tu.data.push(Ta.subarray(Vs, _a + 188)), Tu.size += _a + 188 - Vs);
                          break;
                        case 0:
                          el && (Vs += Ta[Vs] + 1), Ul = this._pmtId = Ku(Ta, Vs);
                          break;
                        case Ul:
                          el && (Vs += Ta[Vs] + 1);
                          var Gl = Wl(Ta, Vs, this.typeSupported.mpeg === !0 || this.typeSupported.mp3 === !0, this.sampleAes != null);
                          Bl = Gl.avc, Bl > 0 && (sl.pid = Bl), ql = Gl.audio, ql > 0 && (Il.pid = ql, Il.isAAC = Gl.isAAC), xl = Gl.id3, xl > 0 && (Vl.pid = xl), Is && !fl && (si.logger.log("reparse from beginning"), Is = !1, _a = wl - 188), fl = this.pmtParsed = !0;
                          break;
                        case 17:
                        case 8191:
                          break;
                        default:
                          Is = !0;
                          break;
                      }
                    } else
                      this.observer.trigger(ui.default.ERROR, {
                        type: ai.ErrorTypes.MEDIA_ERROR,
                        details: ai.ErrorDetails.FRAG_PARSING_ERROR,
                        fatal: !1,
                        reason: "TS packet did not start with 0x47"
                      });
                  Xl && (es = uu(Xl)) ? (du(es, !0), sl.pesData = null) : sl.pesData = Xl, hu && (es = uu(hu)) ? (Il.isAAC ? za(es) : Ya(es), Il.pesData = null) : (hu && hu.size && si.logger.log("last AAC PES packet truncated,might overlap between fragments"), Il.pesData = hu), Tu && (es = uu(Tu)) ? (Ws(es), Vl.pesData = null) : Vl.pesData = Tu, this.sampleAes == null ? this.remuxer.remux(Il, sl, Vl, this._txtTrack, rs, Qa, Cs) : this.decryptAndRemux(Il, sl, Vl, this._txtTrack, rs, Qa, Cs);
                }, Ja.decryptAndRemux = function(Ta, rs, Qa, Cs, _a, _s, el) {
                  if (Ta.samples && Ta.isAAC) {
                    var Ps = this;
                    this.sampleAes.decryptAacSamples(Ta.samples, 0, function() {
                      Ps.decryptAndRemuxAvc(Ta, rs, Qa, Cs, _a, _s, el);
                    });
                  } else
                    this.decryptAndRemuxAvc(Ta, rs, Qa, Cs, _a, _s, el);
                }, Ja.decryptAndRemuxAvc = function(Ta, rs, Qa, Cs, _a, _s, el) {
                  if (rs.samples) {
                    var Ps = this;
                    this.sampleAes.decryptAvcSamples(rs.samples, 0, 0, function() {
                      Ps.remuxer.remux(Ta, rs, Qa, Cs, _a, _s, el);
                    });
                  } else
                    this.remuxer.remux(Ta, rs, Qa, Cs, _a, _s, el);
                }, Ja.destroy = function() {
                  this._initPTS = this._initDTS = void 0, this._duration = 0;
                }, Ja._parsePAT = function(Ta, rs) {
                  return (Ta[rs + 10] & 31) << 8 | Ta[rs + 11];
                }, Ja._trackUnknownPmt = function(Ta, rs, Qa) {
                  var Cs = this.pmtUnknownTypes[Ta] || 0;
                  return Cs === 0 && (this.pmtUnknownTypes[Ta] = 0, rs.call(si.logger, Qa)), this.pmtUnknownTypes[Ta]++, Cs;
                }, Ja._parsePMT = function(Ta, rs, Qa, Cs) {
                  var _a, _s, el, Ps, nl = {
                    audio: -1,
                    avc: -1,
                    id3: -1,
                    isAAC: !0
                  };
                  for (_a = (Ta[rs + 1] & 15) << 8 | Ta[rs + 2], _s = rs + 3 + _a - 4, el = (Ta[rs + 10] & 15) << 8 | Ta[rs + 11], rs += 12 + el; rs < _s; ) {
                    switch (Ps = (Ta[rs + 1] & 31) << 8 | Ta[rs + 2], Ta[rs]) {
                      case 207:
                        if (!Cs) {
                          this._trackUnknownPmt(Ta[rs], si.logger.warn, "ADTS AAC with AES-128-CBC frame encryption found in unencrypted stream");
                          break;
                        }
                      /* falls through */
                      // ISO/IEC 13818-7 ADTS AAC (MPEG-2 lower bit-rate audio)
                      case 15:
                        nl.audio === -1 && (nl.audio = Ps);
                        break;
                      // Packetized metadata (ID3)
                      case 21:
                        nl.id3 === -1 && (nl.id3 = Ps);
                        break;
                      case 219:
                        if (!Cs) {
                          this._trackUnknownPmt(Ta[rs], si.logger.warn, "H.264 with AES-128-CBC slice encryption found in unencrypted stream");
                          break;
                        }
                      /* falls through */
                      // ITU-T Rec. H.264 and ISO/IEC 14496-10 (lower bit-rate video)
                      case 27:
                        nl.avc === -1 && (nl.avc = Ps);
                        break;
                      // ISO/IEC 11172-3 (MPEG-1 audio)
                      // or ISO/IEC 13818-3 (MPEG-2 halved sample rate audio)
                      case 3:
                      case 4:
                        Qa ? nl.audio === -1 && (nl.audio = Ps, nl.isAAC = !1) : this._trackUnknownPmt(Ta[rs], si.logger.warn, "MPEG audio found, not supported in this browser");
                        break;
                      case 36:
                        this._trackUnknownPmt(Ta[rs], si.logger.warn, "Unsupported HEVC stream type found");
                        break;
                      default:
                        this._trackUnknownPmt(Ta[rs], si.logger.log, "Unknown stream type:" + Ta[rs]);
                        break;
                    }
                    rs += ((Ta[rs + 3] & 15) << 8 | Ta[rs + 4]) + 5;
                  }
                  return nl;
                }, Ja._parsePES = function(Ta) {
                  var rs = 0, Qa, Cs, _a, _s, el, Ps, nl, Vs, es, Is = Ta.data;
                  if (!Ta || Ta.size === 0)
                    return null;
                  for (; Is[0].length < 19 && Is.length > 1; ) {
                    var fl = new Uint8Array(Is[0].length + Is[1].length);
                    fl.set(Is[0]), fl.set(Is[1], Is[0].length), Is[0] = fl, Is.splice(1, 1);
                  }
                  if (Qa = Is[0], _a = (Qa[0] << 16) + (Qa[1] << 8) + Qa[2], _a === 1) {
                    if (_s = (Qa[4] << 8) + Qa[5], _s && _s > Ta.size - 6 || (Cs = Qa[7], Cs & 192 && (nl = (Qa[9] & 14) * 536870912 + // 1 << 29
                    (Qa[10] & 255) * 4194304 + // 1 << 22
                    (Qa[11] & 254) * 16384 + // 1 << 14
                    (Qa[12] & 255) * 128 + // 1 << 7
                    (Qa[13] & 254) / 2, Cs & 64 ? (Vs = (Qa[14] & 14) * 536870912 + // 1 << 29
                    (Qa[15] & 255) * 4194304 + // 1 << 22
                    (Qa[16] & 254) * 16384 + // 1 << 14
                    (Qa[17] & 255) * 128 + // 1 << 7
                    (Qa[18] & 254) / 2, nl - Vs > 60 * 9e4 && (si.logger.warn(Math.round((nl - Vs) / 9e4) + "s delta between PTS and DTS, align them"), nl = Vs)) : Vs = nl), el = Qa[8], es = el + 9, Ta.size <= es))
                      return null;
                    Ta.size -= es, Ps = new Uint8Array(Ta.size);
                    for (var sl = 0, Il = Is.length; sl < Il; sl++) {
                      Qa = Is[sl];
                      var Vl = Qa.byteLength;
                      if (es)
                        if (es > Vl) {
                          es -= Vl;
                          continue;
                        } else
                          Qa = Qa.subarray(es), Vl -= es, es = 0;
                      Ps.set(Qa, rs), rs += Vl;
                    }
                    return _s && (_s -= el + 3), {
                      data: Ps,
                      pts: nl,
                      dts: Vs,
                      len: _s
                    };
                  } else
                    return null;
                }, Ja.pushAccesUnit = function(Ta, rs) {
                  if (Ta.units.length && Ta.frame) {
                    var Qa = rs.samples, Cs = Qa.length;
                    if (isNaN(Ta.pts))
                      if (Cs) {
                        var _a = Qa[Cs - 1];
                        Ta.pts = _a.pts, Ta.dts = _a.dts;
                      } else {
                        rs.dropped++;
                        return;
                      }
                    !this.config.forceKeyFrameOnDiscontinuity || Ta.key === !0 || rs.sps && (Cs || this.contiguous) ? (Ta.id = Cs, Qa.push(Ta)) : rs.dropped++;
                  }
                  Ta.debug.length && si.logger.log(Ta.pts + "/" + Ta.dts + ":" + Ta.debug);
                }, Ja._parseAVCPES = function(Ta, rs) {
                  var Qa = this, Cs = this._avcTrack, _a = this._parseAVCNALu(Ta.data), _s, el = this.avcSample, Ps, nl = !1, Vs, es = this.pushAccesUnit.bind(this), Is = function(sl, Il, Vl, Bl) {
                    return {
                      key: sl,
                      pts: Il,
                      dts: Vl,
                      units: [],
                      debug: Bl
                    };
                  };
                  Ta.data = null, el && _a.length && !Cs.audFound && (es(el, Cs), el = this.avcSample = Is(!1, Ta.pts, Ta.dts, "")), _a.forEach(function(fl) {
                    switch (fl.type) {
                      // NDR
                      case 1:
                        Ps = !0, el || (el = Qa.avcSample = Is(!0, Ta.pts, Ta.dts, "")), el.frame = !0;
                        var sl = fl.data;
                        if (nl && sl.length > 4) {
                          var Il = new Li(sl).readSliceType();
                          (Il === 2 || Il === 4 || Il === 7 || Il === 9) && (el.key = !0);
                        }
                        break;
                      // IDR
                      case 5:
                        Ps = !0, el || (el = Qa.avcSample = Is(!0, Ta.pts, Ta.dts, "")), el.key = !0, el.frame = !0;
                        break;
                      // SEI
                      case 6:
                        Ps = !0, _s = new Li(Qa.discardEPB(fl.data)), _s.readUByte();
                        for (var Vl = 0, Bl = 0, ql = !1, xl = 0; !ql && _s.bytesAvailable > 1; ) {
                          Vl = 0;
                          do
                            xl = _s.readUByte(), Vl += xl;
                          while (xl === 255);
                          Bl = 0;
                          do
                            xl = _s.readUByte(), Bl += xl;
                          while (xl === 255);
                          if (Vl === 4 && _s.bytesAvailable !== 0) {
                            ql = !0;
                            var Ul = _s.readUByte();
                            if (Ul === 181) {
                              var Xl = _s.readUShort();
                              if (Xl === 49) {
                                var hu = _s.readUInt();
                                if (hu === 1195456820) {
                                  var Tu = _s.readUByte();
                                  if (Tu === 3) {
                                    var Ku = _s.readUByte(), Wl = _s.readUByte(), uu = 31 & Ku, du = [Ku, Wl];
                                    for (Vs = 0; Vs < uu; Vs++)
                                      du.push(_s.readUByte()), du.push(_s.readUByte()), du.push(_s.readUByte());
                                    Qa._insertSampleInOrder(Qa._txtTrack.samples, {
                                      type: 3,
                                      pts: Ta.pts,
                                      bytes: du
                                    });
                                  }
                                }
                              }
                            }
                          } else if (Vl === 5 && _s.bytesAvailable !== 0) {
                            if (ql = !0, Bl > 16) {
                              var za = [];
                              for (Vs = 0; Vs < 16; Vs++)
                                za.push(_s.readUByte().toString(16)), (Vs === 3 || Vs === 5 || Vs === 7 || Vs === 9) && za.push("-");
                              var Ya = Bl - 16, Ws = new Uint8Array(Ya);
                              for (Vs = 0; Vs < Ya; Vs++)
                                Ws[Vs] = _s.readUByte();
                              Qa._insertSampleInOrder(Qa._txtTrack.samples, {
                                pts: Ta.pts,
                                payloadType: Vl,
                                uuid: za.join(""),
                                userDataBytes: Ws,
                                userData: Object(Di.utf8ArrayToStr)(Ws.buffer)
                              });
                            }
                          } else if (Bl < _s.bytesAvailable)
                            for (Vs = 0; Vs < Bl; Vs++)
                              _s.readUByte();
                        }
                        break;
                      // SPS
                      case 7:
                        if (Ps = !0, nl = !0, !Cs.sps) {
                          _s = new Li(fl.data);
                          var wl = _s.readSPS();
                          Cs.width = wl.width, Cs.height = wl.height, Cs.pixelRatio = wl.pixelRatio, Cs.sps = [fl.data], Cs.duration = Qa._duration;
                          var Gl = fl.data.subarray(1, 4), bl = "avc1.";
                          for (Vs = 0; Vs < 3; Vs++) {
                            var Za = Gl[Vs].toString(16);
                            Za.length < 2 && (Za = "0" + Za), bl += Za;
                          }
                          Cs.codec = bl;
                        }
                        break;
                      // PPS
                      case 8:
                        Ps = !0, Cs.pps || (Cs.pps = [fl.data]);
                        break;
                      // AUD
                      case 9:
                        Ps = !1, Cs.audFound = !0, el && es(el, Cs), el = Qa.avcSample = Is(!1, Ta.pts, Ta.dts, "");
                        break;
                      // Filler Data
                      case 12:
                        Ps = !1;
                        break;
                      default:
                        Ps = !1, el && (el.debug += "unknown NAL " + fl.type + " ");
                        break;
                    }
                    if (el && Ps) {
                      var rl = el.units;
                      rl.push(fl);
                    }
                  }), rs && el && (es(el, Cs), this.avcSample = null);
                }, Ja._insertSampleInOrder = function(Ta, rs) {
                  var Qa = Ta.length;
                  if (Qa > 0) {
                    if (rs.pts >= Ta[Qa - 1].pts)
                      Ta.push(rs);
                    else
                      for (var Cs = Qa - 1; Cs >= 0; Cs--)
                        if (rs.pts < Ta[Cs].pts) {
                          Ta.splice(Cs, 0, rs);
                          break;
                        }
                  } else
                    Ta.push(rs);
                }, Ja._getLastNalUnit = function() {
                  var Ta = this.avcSample, rs;
                  if (!Ta || Ta.units.length === 0) {
                    var Qa = this._avcTrack, Cs = Qa.samples;
                    Ta = Cs[Cs.length - 1];
                  }
                  if (Ta) {
                    var _a = Ta.units;
                    rs = _a[_a.length - 1];
                  }
                  return rs;
                }, Ja._parseAVCNALu = function(Ta) {
                  var rs = 0, Qa = Ta.byteLength, Cs, _a, _s = this._avcTrack, el = _s.naluState || 0, Ps = el, nl = [], Vs, es, Is = -1, fl;
                  for (el === -1 && (Is = 0, fl = Ta[0] & 31, el = 0, rs = 1); rs < Qa; ) {
                    if (Cs = Ta[rs++], !el) {
                      el = Cs ? 0 : 1;
                      continue;
                    }
                    if (el === 1) {
                      el = Cs ? 0 : 2;
                      continue;
                    }
                    if (!Cs)
                      el = 3;
                    else if (Cs === 1) {
                      if (Is >= 0)
                        Vs = {
                          data: Ta.subarray(Is, rs - el - 1),
                          type: fl
                        }, nl.push(Vs);
                      else {
                        var sl = this._getLastNalUnit();
                        if (sl && (Ps && rs <= 4 - Ps && sl.state && (sl.data = sl.data.subarray(0, sl.data.byteLength - Ps)), _a = rs - el - 1, _a > 0)) {
                          var Il = new Uint8Array(sl.data.byteLength + _a);
                          Il.set(sl.data, 0), Il.set(Ta.subarray(0, _a), sl.data.byteLength), sl.data = Il;
                        }
                      }
                      rs < Qa ? (es = Ta[rs] & 31, Is = rs, fl = es, el = 0) : el = -1;
                    } else
                      el = 0;
                  }
                  if (Is >= 0 && el >= 0 && (Vs = {
                    data: Ta.subarray(Is, Qa),
                    type: fl,
                    state: el
                  }, nl.push(Vs)), nl.length === 0) {
                    var Vl = this._getLastNalUnit();
                    if (Vl) {
                      var Bl = new Uint8Array(Vl.data.byteLength + Ta.byteLength);
                      Bl.set(Vl.data, 0), Bl.set(Ta, Vl.data.byteLength), Vl.data = Bl;
                    }
                  }
                  return _s.naluState = el, nl;
                }, Ja.discardEPB = function(Ta) {
                  for (var rs = Ta.byteLength, Qa = [], Cs = 1, _a, _s; Cs < rs - 2; )
                    Ta[Cs] === 0 && Ta[Cs + 1] === 0 && Ta[Cs + 2] === 3 ? (Qa.push(Cs + 2), Cs += 2) : Cs++;
                  if (Qa.length === 0)
                    return Ta;
                  _a = rs - Qa.length, _s = new Uint8Array(_a);
                  var el = 0;
                  for (Cs = 0; Cs < _a; el++, Cs++)
                    el === Qa[0] && (el++, Qa.shift()), _s[Cs] = Ta[el];
                  return _s;
                }, Ja._parseAACPES = function(Ta) {
                  var rs = this._audioTrack, Qa = Ta.data, Cs = Ta.pts, _a = 0, _s = this.aacOverFlow, el = this.aacLastPTS, Ps, nl, Vs, es, Is;
                  if (_s) {
                    var fl = new Uint8Array(_s.byteLength + Qa.byteLength);
                    fl.set(_s, 0), fl.set(Qa, _s.byteLength), Qa = fl;
                  }
                  for (Vs = _a, Is = Qa.length; Vs < Is - 1 && !vi(Qa, Vs); Vs++)
                    ;
                  if (Vs) {
                    var sl, Il;
                    if (Vs < Is - 1 ? (sl = "AAC PES did not start with ADTS header,offset:" + Vs, Il = !1) : (sl = "no ADTS header found in AAC PES", Il = !0), si.logger.warn("parsing error:" + sl), this.observer.trigger(ui.default.ERROR, {
                      type: ai.ErrorTypes.MEDIA_ERROR,
                      details: ai.ErrorDetails.FRAG_PARSING_ERROR,
                      fatal: Il,
                      reason: sl
                    }), Il)
                      return;
                  }
                  if (Si(rs, this.observer, Qa, Vs, this.audioCodec), nl = 0, Ps = Pi(rs.samplerate), _s && el) {
                    var Vl = el + Ps;
                    Math.abs(Vl - Cs) > 1 && (si.logger.log("AAC: align PTS for overlapping frames by " + Math.round((Vl - Cs) / 90)), Cs = Vl);
                  }
                  for (; Vs < Is; )
                    if (vi(Qa, Vs)) {
                      if (Vs + 5 < Is) {
                        var Bl = Oi(rs, Qa, Vs, Cs, nl);
                        if (Bl) {
                          Vs += Bl.length, es = Bl.sample.pts, nl++;
                          continue;
                        }
                      }
                      break;
                    } else
                      Vs++;
                  Vs < Is ? _s = Qa.subarray(Vs, Is) : _s = null, this.aacOverFlow = _s, this.aacLastPTS = es;
                }, Ja._parseMPEGPES = function(Ta) {
                  for (var rs = Ta.data, Qa = rs.length, Cs = 0, _a = 0, _s = Ta.pts; _a < Qa; )
                    if (fo.isHeader(rs, _a)) {
                      var el = fo.appendFrame(this._audioTrack, rs, _a, _s, Cs);
                      if (el)
                        _a += el.length, Cs++;
                      else
                        break;
                    } else
                      _a++;
                }, Ja._parseID3PES = function(Ta) {
                  this._id3Track.samples.push(Ta);
                }, La;
              })(), No = Vo, Ui = /* @__PURE__ */ (function() {
                function La(ja, Ta, rs) {
                  this.observer = ja, this.config = rs, this.remuxer = Ta;
                }
                var Ja = La.prototype;
                return Ja.resetInitSegment = function(Ta, rs, Qa, Cs) {
                  this._audioTrack = {
                    container: "audio/mpeg",
                    type: "audio",
                    id: -1,
                    sequenceNumber: 0,
                    isAAC: !1,
                    samples: [],
                    len: 0,
                    manifestCodec: rs,
                    duration: Cs,
                    inputTimeScale: 9e4
                  };
                }, Ja.resetTimeStamp = function() {
                }, La.probe = function(Ta) {
                  var rs, Qa, Cs = Di.default.getID3Data(Ta, 0);
                  if (Cs && Di.default.getTimeStamp(Cs) !== void 0) {
                    for (rs = Cs.length, Qa = Math.min(Ta.length - 1, rs + 100); rs < Qa; rs++)
                      if (fo.probe(Ta, rs))
                        return si.logger.log("MPEG Audio sync word found !"), !0;
                  }
                  return !1;
                }, Ja.append = function(Ta, rs, Qa, Cs) {
                  for (var _a = Di.default.getID3Data(Ta, 0) || [], _s = Di.default.getTimeStamp(_a), el = _s !== void 0 ? 90 * _s : rs * 9e4, Ps = _a.length, nl = Ta.length, Vs = 0, es = 0, Is = this._audioTrack, fl = [{
                    pts: el,
                    dts: el,
                    data: _a
                  }]; Ps < nl; )
                    if (fo.isHeader(Ta, Ps)) {
                      var sl = fo.appendFrame(Is, Ta, Ps, el, Vs);
                      if (sl)
                        Ps += sl.length, es = sl.sample.pts, Vs++;
                      else
                        break;
                    } else Di.default.isHeader(Ta, Ps) ? (_a = Di.default.getID3Data(Ta, Ps), fl.push({
                      pts: es,
                      dts: es,
                      data: _a
                    }), Ps += _a.length) : Ps++;
                  this.remuxer.remux(Is, {
                    samples: []
                  }, {
                    samples: fl,
                    inputTimeScale: 9e4
                  }, {
                    samples: []
                  }, rs, Qa, Cs);
                }, Ja.destroy = function() {
                }, La;
              })(), jo = Ui, Wi = /* @__PURE__ */ (function() {
                function La() {
                }
                return La.getSilentFrame = function(ja, Ta) {
                  switch (ja) {
                    case "mp4a.40.2":
                      if (Ta === 1)
                        return new Uint8Array([0, 200, 0, 128, 35, 128]);
                      if (Ta === 2)
                        return new Uint8Array([33, 0, 73, 144, 2, 25, 0, 35, 128]);
                      if (Ta === 3)
                        return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 142]);
                      if (Ta === 4)
                        return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 128, 44, 128, 8, 2, 56]);
                      if (Ta === 5)
                        return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 56]);
                      if (Ta === 6)
                        return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 0, 178, 0, 32, 8, 224]);
                      break;
                    // handle HE-AAC below (mp4a.40.5 / mp4a.40.29)
                    default:
                      if (Ta === 1)
                        return new Uint8Array([1, 64, 34, 128, 163, 78, 230, 128, 186, 8, 0, 0, 0, 28, 6, 241, 193, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
                      if (Ta === 2)
                        return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
                      if (Ta === 3)
                        return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
                      break;
                  }
                  return null;
                }, La;
              })(), ji = Wi, Hi = Math.pow(2, 32) - 1, zo = /* @__PURE__ */ (function() {
                function La() {
                }
                return La.init = function() {
                  La.types = {
                    avc1: [],
                    // codingname
                    avcC: [],
                    btrt: [],
                    dinf: [],
                    dref: [],
                    esds: [],
                    ftyp: [],
                    hdlr: [],
                    mdat: [],
                    mdhd: [],
                    mdia: [],
                    mfhd: [],
                    minf: [],
                    moof: [],
                    moov: [],
                    mp4a: [],
                    ".mp3": [],
                    mvex: [],
                    mvhd: [],
                    pasp: [],
                    sdtp: [],
                    stbl: [],
                    stco: [],
                    stsc: [],
                    stsd: [],
                    stsz: [],
                    stts: [],
                    tfdt: [],
                    tfhd: [],
                    traf: [],
                    trak: [],
                    trun: [],
                    trex: [],
                    tkhd: [],
                    vmhd: [],
                    smhd: []
                  };
                  var ja;
                  for (ja in La.types)
                    La.types.hasOwnProperty(ja) && (La.types[ja] = [ja.charCodeAt(0), ja.charCodeAt(1), ja.charCodeAt(2), ja.charCodeAt(3)]);
                  var Ta = new Uint8Array([
                    0,
                    // version 0
                    0,
                    0,
                    0,
                    // flags
                    0,
                    0,
                    0,
                    0,
                    // pre_defined
                    118,
                    105,
                    100,
                    101,
                    // handler_type: 'vide'
                    0,
                    0,
                    0,
                    0,
                    // reserved
                    0,
                    0,
                    0,
                    0,
                    // reserved
                    0,
                    0,
                    0,
                    0,
                    // reserved
                    86,
                    105,
                    100,
                    101,
                    111,
                    72,
                    97,
                    110,
                    100,
                    108,
                    101,
                    114,
                    0
                    // name: 'VideoHandler'
                  ]), rs = new Uint8Array([
                    0,
                    // version 0
                    0,
                    0,
                    0,
                    // flags
                    0,
                    0,
                    0,
                    0,
                    // pre_defined
                    115,
                    111,
                    117,
                    110,
                    // handler_type: 'soun'
                    0,
                    0,
                    0,
                    0,
                    // reserved
                    0,
                    0,
                    0,
                    0,
                    // reserved
                    0,
                    0,
                    0,
                    0,
                    // reserved
                    83,
                    111,
                    117,
                    110,
                    100,
                    72,
                    97,
                    110,
                    100,
                    108,
                    101,
                    114,
                    0
                    // name: 'SoundHandler'
                  ]);
                  La.HDLR_TYPES = {
                    video: Ta,
                    audio: rs
                  };
                  var Qa = new Uint8Array([
                    0,
                    // version 0
                    0,
                    0,
                    0,
                    // flags
                    0,
                    0,
                    0,
                    1,
                    // entry_count
                    0,
                    0,
                    0,
                    12,
                    // entry_size
                    117,
                    114,
                    108,
                    32,
                    // 'url' type
                    0,
                    // version 0
                    0,
                    0,
                    1
                    // entry_flags
                  ]), Cs = new Uint8Array([
                    0,
                    // version
                    0,
                    0,
                    0,
                    // flags
                    0,
                    0,
                    0,
                    0
                    // entry_count
                  ]);
                  La.STTS = La.STSC = La.STCO = Cs, La.STSZ = new Uint8Array([
                    0,
                    // version
                    0,
                    0,
                    0,
                    // flags
                    0,
                    0,
                    0,
                    0,
                    // sample_size
                    0,
                    0,
                    0,
                    0
                    // sample_count
                  ]), La.VMHD = new Uint8Array([
                    0,
                    // version
                    0,
                    0,
                    1,
                    // flags
                    0,
                    0,
                    // graphicsmode
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                    // opcolor
                  ]), La.SMHD = new Uint8Array([
                    0,
                    // version
                    0,
                    0,
                    0,
                    // flags
                    0,
                    0,
                    // balance
                    0,
                    0
                    // reserved
                  ]), La.STSD = new Uint8Array([
                    0,
                    // version 0
                    0,
                    0,
                    0,
                    // flags
                    0,
                    0,
                    0,
                    1
                  ]);
                  var _a = new Uint8Array([105, 115, 111, 109]), _s = new Uint8Array([97, 118, 99, 49]), el = new Uint8Array([0, 0, 0, 1]);
                  La.FTYP = La.box(La.types.ftyp, _a, el, _a, _s), La.DINF = La.box(La.types.dinf, La.box(La.types.dref, Qa));
                }, La.box = function(ja) {
                  for (var Ta = Array.prototype.slice.call(arguments, 1), rs = 8, Qa = Ta.length, Cs = Qa, _a; Qa--; )
                    rs += Ta[Qa].byteLength;
                  for (_a = new Uint8Array(rs), _a[0] = rs >> 24 & 255, _a[1] = rs >> 16 & 255, _a[2] = rs >> 8 & 255, _a[3] = rs & 255, _a.set(ja, 4), Qa = 0, rs = 8; Qa < Cs; Qa++)
                    _a.set(Ta[Qa], rs), rs += Ta[Qa].byteLength;
                  return _a;
                }, La.hdlr = function(ja) {
                  return La.box(La.types.hdlr, La.HDLR_TYPES[ja]);
                }, La.mdat = function(ja) {
                  return La.box(La.types.mdat, ja);
                }, La.mdhd = function(ja, Ta) {
                  Ta *= ja;
                  var rs = Math.floor(Ta / (Hi + 1)), Qa = Math.floor(Ta % (Hi + 1));
                  return La.box(La.types.mdhd, new Uint8Array([
                    1,
                    // version 1
                    0,
                    0,
                    0,
                    // flags
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    // creation_time
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3,
                    // modification_time
                    ja >> 24 & 255,
                    ja >> 16 & 255,
                    ja >> 8 & 255,
                    ja & 255,
                    // timescale
                    rs >> 24,
                    rs >> 16 & 255,
                    rs >> 8 & 255,
                    rs & 255,
                    Qa >> 24,
                    Qa >> 16 & 255,
                    Qa >> 8 & 255,
                    Qa & 255,
                    85,
                    196,
                    // 'und' language (undetermined)
                    0,
                    0
                  ]));
                }, La.mdia = function(ja) {
                  return La.box(La.types.mdia, La.mdhd(ja.timescale, ja.duration), La.hdlr(ja.type), La.minf(ja));
                }, La.mfhd = function(ja) {
                  return La.box(La.types.mfhd, new Uint8Array([
                    0,
                    0,
                    0,
                    0,
                    // flags
                    ja >> 24,
                    ja >> 16 & 255,
                    ja >> 8 & 255,
                    ja & 255
                    // sequence_number
                  ]));
                }, La.minf = function(ja) {
                  return ja.type === "audio" ? La.box(La.types.minf, La.box(La.types.smhd, La.SMHD), La.DINF, La.stbl(ja)) : La.box(La.types.minf, La.box(La.types.vmhd, La.VMHD), La.DINF, La.stbl(ja));
                }, La.moof = function(ja, Ta, rs) {
                  return La.box(La.types.moof, La.mfhd(ja), La.traf(rs, Ta));
                }, La.moov = function(ja) {
                  for (var Ta = ja.length, rs = []; Ta--; )
                    rs[Ta] = La.trak(ja[Ta]);
                  return La.box.apply(null, [La.types.moov, La.mvhd(ja[0].timescale, ja[0].duration)].concat(rs).concat(La.mvex(ja)));
                }, La.mvex = function(ja) {
                  for (var Ta = ja.length, rs = []; Ta--; )
                    rs[Ta] = La.trex(ja[Ta]);
                  return La.box.apply(null, [La.types.mvex].concat(rs));
                }, La.mvhd = function(ja, Ta) {
                  Ta *= ja;
                  var rs = Math.floor(Ta / (Hi + 1)), Qa = Math.floor(Ta % (Hi + 1)), Cs = new Uint8Array([
                    1,
                    // version 1
                    0,
                    0,
                    0,
                    // flags
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    // creation_time
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3,
                    // modification_time
                    ja >> 24 & 255,
                    ja >> 16 & 255,
                    ja >> 8 & 255,
                    ja & 255,
                    // timescale
                    rs >> 24,
                    rs >> 16 & 255,
                    rs >> 8 & 255,
                    rs & 255,
                    Qa >> 24,
                    Qa >> 16 & 255,
                    Qa >> 8 & 255,
                    Qa & 255,
                    0,
                    1,
                    0,
                    0,
                    // 1.0 rate
                    1,
                    0,
                    // 1.0 volume
                    0,
                    0,
                    // reserved
                    0,
                    0,
                    0,
                    0,
                    // reserved
                    0,
                    0,
                    0,
                    0,
                    // reserved
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    64,
                    0,
                    0,
                    0,
                    // transformation: unity matrix
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    // pre_defined
                    255,
                    255,
                    255,
                    255
                    // next_track_ID
                  ]);
                  return La.box(La.types.mvhd, Cs);
                }, La.sdtp = function(ja) {
                  var Ta = ja.samples || [], rs = new Uint8Array(4 + Ta.length), Qa, Cs;
                  for (Cs = 0; Cs < Ta.length; Cs++)
                    Qa = Ta[Cs].flags, rs[Cs + 4] = Qa.dependsOn << 4 | Qa.isDependedOn << 2 | Qa.hasRedundancy;
                  return La.box(La.types.sdtp, rs);
                }, La.stbl = function(ja) {
                  return La.box(La.types.stbl, La.stsd(ja), La.box(La.types.stts, La.STTS), La.box(La.types.stsc, La.STSC), La.box(La.types.stsz, La.STSZ), La.box(La.types.stco, La.STCO));
                }, La.avc1 = function(ja) {
                  var Ta = [], rs = [], Qa, Cs, _a;
                  for (Qa = 0; Qa < ja.sps.length; Qa++)
                    Cs = ja.sps[Qa], _a = Cs.byteLength, Ta.push(_a >>> 8 & 255), Ta.push(_a & 255), Ta = Ta.concat(Array.prototype.slice.call(Cs));
                  for (Qa = 0; Qa < ja.pps.length; Qa++)
                    Cs = ja.pps[Qa], _a = Cs.byteLength, rs.push(_a >>> 8 & 255), rs.push(_a & 255), rs = rs.concat(Array.prototype.slice.call(Cs));
                  var _s = La.box(La.types.avcC, new Uint8Array([
                    1,
                    // version
                    Ta[3],
                    // profile
                    Ta[4],
                    // profile compat
                    Ta[5],
                    // level
                    255,
                    // lengthSizeMinusOne, hard-coded to 4 bytes
                    224 | ja.sps.length
                    // 3bit reserved (111) + numOfSequenceParameterSets
                  ].concat(Ta).concat([
                    ja.pps.length
                    // numOfPictureParameterSets
                  ]).concat(rs))), el = ja.width, Ps = ja.height, nl = ja.pixelRatio[0], Vs = ja.pixelRatio[1];
                  return La.box(
                    La.types.avc1,
                    new Uint8Array([
                      0,
                      0,
                      0,
                      // reserved
                      0,
                      0,
                      0,
                      // reserved
                      0,
                      1,
                      // data_reference_index
                      0,
                      0,
                      // pre_defined
                      0,
                      0,
                      // reserved
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      // pre_defined
                      el >> 8 & 255,
                      el & 255,
                      // width
                      Ps >> 8 & 255,
                      Ps & 255,
                      // height
                      0,
                      72,
                      0,
                      0,
                      // horizresolution
                      0,
                      72,
                      0,
                      0,
                      // vertresolution
                      0,
                      0,
                      0,
                      0,
                      // reserved
                      0,
                      1,
                      // frame_count
                      18,
                      100,
                      97,
                      105,
                      108,
                      // dailymotion/hls.js
                      121,
                      109,
                      111,
                      116,
                      105,
                      111,
                      110,
                      47,
                      104,
                      108,
                      115,
                      46,
                      106,
                      115,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      // compressorname
                      0,
                      24,
                      // depth = 24
                      17,
                      17
                    ]),
                    // pre_defined = -1
                    _s,
                    La.box(La.types.btrt, new Uint8Array([
                      0,
                      28,
                      156,
                      128,
                      // bufferSizeDB
                      0,
                      45,
                      198,
                      192,
                      // maxBitrate
                      0,
                      45,
                      198,
                      192
                    ])),
                    // avgBitrate
                    La.box(La.types.pasp, new Uint8Array([
                      nl >> 24,
                      // hSpacing
                      nl >> 16 & 255,
                      nl >> 8 & 255,
                      nl & 255,
                      Vs >> 24,
                      // vSpacing
                      Vs >> 16 & 255,
                      Vs >> 8 & 255,
                      Vs & 255
                    ]))
                  );
                }, La.esds = function(ja) {
                  var Ta = ja.config.length;
                  return new Uint8Array([
                    0,
                    // version 0
                    0,
                    0,
                    0,
                    // flags
                    3,
                    // descriptor_type
                    23 + Ta,
                    // length
                    0,
                    1,
                    // es_id
                    0,
                    // stream_priority
                    4,
                    // descriptor_type
                    15 + Ta,
                    // length
                    64,
                    // codec : mpeg4_audio
                    21,
                    // stream_type
                    0,
                    0,
                    0,
                    // buffer_size
                    0,
                    0,
                    0,
                    0,
                    // maxBitrate
                    0,
                    0,
                    0,
                    0,
                    // avgBitrate
                    5
                    // descriptor_type
                  ].concat([Ta]).concat(ja.config).concat([6, 1, 2]));
                }, La.mp4a = function(ja) {
                  var Ta = ja.samplerate;
                  return La.box(La.types.mp4a, new Uint8Array([
                    0,
                    0,
                    0,
                    // reserved
                    0,
                    0,
                    0,
                    // reserved
                    0,
                    1,
                    // data_reference_index
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    // reserved
                    0,
                    ja.channelCount,
                    // channelcount
                    0,
                    16,
                    // sampleSize:16bits
                    0,
                    0,
                    0,
                    0,
                    // reserved2
                    Ta >> 8 & 255,
                    Ta & 255,
                    //
                    0,
                    0
                  ]), La.box(La.types.esds, La.esds(ja)));
                }, La.mp3 = function(ja) {
                  var Ta = ja.samplerate;
                  return La.box(La.types[".mp3"], new Uint8Array([
                    0,
                    0,
                    0,
                    // reserved
                    0,
                    0,
                    0,
                    // reserved
                    0,
                    1,
                    // data_reference_index
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    // reserved
                    0,
                    ja.channelCount,
                    // channelcount
                    0,
                    16,
                    // sampleSize:16bits
                    0,
                    0,
                    0,
                    0,
                    // reserved2
                    Ta >> 8 & 255,
                    Ta & 255,
                    //
                    0,
                    0
                  ]));
                }, La.stsd = function(ja) {
                  return ja.type === "audio" ? !ja.isAAC && ja.codec === "mp3" ? La.box(La.types.stsd, La.STSD, La.mp3(ja)) : La.box(La.types.stsd, La.STSD, La.mp4a(ja)) : La.box(La.types.stsd, La.STSD, La.avc1(ja));
                }, La.tkhd = function(ja) {
                  var Ta = ja.id, rs = ja.duration * ja.timescale, Qa = ja.width, Cs = ja.height, _a = Math.floor(rs / (Hi + 1)), _s = Math.floor(rs % (Hi + 1));
                  return La.box(La.types.tkhd, new Uint8Array([
                    1,
                    // version 1
                    0,
                    0,
                    7,
                    // flags
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    // creation_time
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3,
                    // modification_time
                    Ta >> 24 & 255,
                    Ta >> 16 & 255,
                    Ta >> 8 & 255,
                    Ta & 255,
                    // track_ID
                    0,
                    0,
                    0,
                    0,
                    // reserved
                    _a >> 24,
                    _a >> 16 & 255,
                    _a >> 8 & 255,
                    _a & 255,
                    _s >> 24,
                    _s >> 16 & 255,
                    _s >> 8 & 255,
                    _s & 255,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    // reserved
                    0,
                    0,
                    // layer
                    0,
                    0,
                    // alternate_group
                    0,
                    0,
                    // non-audio track volume
                    0,
                    0,
                    // reserved
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    64,
                    0,
                    0,
                    0,
                    // transformation: unity matrix
                    Qa >> 8 & 255,
                    Qa & 255,
                    0,
                    0,
                    // width
                    Cs >> 8 & 255,
                    Cs & 255,
                    0,
                    0
                    // height
                  ]));
                }, La.traf = function(ja, Ta) {
                  var rs = La.sdtp(ja), Qa = ja.id, Cs = Math.floor(Ta / (Hi + 1)), _a = Math.floor(Ta % (Hi + 1));
                  return La.box(
                    La.types.traf,
                    La.box(La.types.tfhd, new Uint8Array([
                      0,
                      // version 0
                      0,
                      0,
                      0,
                      // flags
                      Qa >> 24,
                      Qa >> 16 & 255,
                      Qa >> 8 & 255,
                      Qa & 255
                      // track_ID
                    ])),
                    La.box(La.types.tfdt, new Uint8Array([
                      1,
                      // version 1
                      0,
                      0,
                      0,
                      // flags
                      Cs >> 24,
                      Cs >> 16 & 255,
                      Cs >> 8 & 255,
                      Cs & 255,
                      _a >> 24,
                      _a >> 16 & 255,
                      _a >> 8 & 255,
                      _a & 255
                    ])),
                    La.trun(ja, rs.length + 16 + // tfhd
                    20 + // tfdt
                    8 + // traf header
                    16 + // mfhd
                    8 + // moof header
                    8),
                    // mdat header
                    rs
                  );
                }, La.trak = function(ja) {
                  return ja.duration = ja.duration || 4294967295, La.box(La.types.trak, La.tkhd(ja), La.mdia(ja));
                }, La.trex = function(ja) {
                  var Ta = ja.id;
                  return La.box(La.types.trex, new Uint8Array([
                    0,
                    // version 0
                    0,
                    0,
                    0,
                    // flags
                    Ta >> 24,
                    Ta >> 16 & 255,
                    Ta >> 8 & 255,
                    Ta & 255,
                    // track_ID
                    0,
                    0,
                    0,
                    1,
                    // default_sample_description_index
                    0,
                    0,
                    0,
                    0,
                    // default_sample_duration
                    0,
                    0,
                    0,
                    0,
                    // default_sample_size
                    0,
                    1,
                    0,
                    1
                    // default_sample_flags
                  ]));
                }, La.trun = function(ja, Ta) {
                  var rs = ja.samples || [], Qa = rs.length, Cs = 12 + 16 * Qa, _a = new Uint8Array(Cs), _s, el, Ps, nl, Vs, es;
                  for (Ta += 8 + Cs, _a.set([
                    0,
                    // version 0
                    0,
                    15,
                    1,
                    // flags
                    Qa >>> 24 & 255,
                    Qa >>> 16 & 255,
                    Qa >>> 8 & 255,
                    Qa & 255,
                    // sample_count
                    Ta >>> 24 & 255,
                    Ta >>> 16 & 255,
                    Ta >>> 8 & 255,
                    Ta & 255
                    // data_offset
                  ], 0), _s = 0; _s < Qa; _s++)
                    el = rs[_s], Ps = el.duration, nl = el.size, Vs = el.flags, es = el.cts, _a.set([
                      Ps >>> 24 & 255,
                      Ps >>> 16 & 255,
                      Ps >>> 8 & 255,
                      Ps & 255,
                      // sample_duration
                      nl >>> 24 & 255,
                      nl >>> 16 & 255,
                      nl >>> 8 & 255,
                      nl & 255,
                      // sample_size
                      Vs.isLeading << 2 | Vs.dependsOn,
                      Vs.isDependedOn << 6 | Vs.hasRedundancy << 4 | Vs.paddingValue << 1 | Vs.isNonSync,
                      Vs.degradPrio & 61440,
                      Vs.degradPrio & 15,
                      // sample_flags
                      es >>> 24 & 255,
                      es >>> 16 & 255,
                      es >>> 8 & 255,
                      es & 255
                      // sample_composition_time_offset
                    ], 12 + 16 * _s);
                  return La.box(La.types.trun, _a);
                }, La.initSegment = function(ja) {
                  La.types || La.init();
                  var Ta = La.moov(ja), rs;
                  return rs = new Uint8Array(La.FTYP.byteLength + Ta.byteLength), rs.set(La.FTYP), rs.set(Ta, La.FTYP.byteLength), rs;
                }, La;
              })(), Lo = zo, sa = 9e4;
              function Ko(La, Ja, ja, Ta) {
                ja === void 0 && (ja = 1), Ta === void 0 && (Ta = !1);
                var rs = La * Ja * ja;
                return Ta ? Math.round(rs) : rs;
              }
              function ca(La, Ja) {
                return Ja === void 0 && (Ja = !1), Ko(La, 1e3, 1 / sa, Ja);
              }
              function pa(La, Ja) {
                return Ja === void 0 && (Ja = 1), Ko(La, sa, 1 / Ja);
              }
              var ga = pa(10), ia = pa(0.2), ra = null, qo = /* @__PURE__ */ (function() {
                function La(ja, Ta, rs, Qa) {
                  if (this.observer = ja, this.config = Ta, this.typeSupported = rs, this.ISGenerated = !1, ra === null) {
                    var Cs = navigator.userAgent.match(/Chrome\/(\d+)/i);
                    ra = Cs ? parseInt(Cs[1]) : 0;
                  }
                }
                var Ja = La.prototype;
                return Ja.destroy = function() {
                }, Ja.resetTimeStamp = function(Ta) {
                  this._initPTS = this._initDTS = Ta;
                }, Ja.resetInitSegment = function() {
                  this.ISGenerated = !1;
                }, Ja.getVideoStartPts = function(Ta) {
                  var rs = !1, Qa = Ta.reduce(function(Cs, _a) {
                    var _s = _a.pts - Cs;
                    return _s < -4294967296 ? (rs = !0, xa(Cs, _a.pts)) : _s > 0 ? Cs : _a.pts;
                  }, Ta[0].pts);
                  return rs && si.logger.debug("PTS rollover detected"), Qa;
                }, Ja.remux = function(Ta, rs, Qa, Cs, _a, _s, el) {
                  if (this.ISGenerated || this.generateIS(Ta, rs, _a), this.ISGenerated) {
                    var Ps = Ta.samples.length, nl = rs.samples.length, Vs = _a, es = _a;
                    if (Ps && nl) {
                      var Is = this.getVideoStartPts(rs.samples), fl = xa(Ta.samples[0].pts, Is) - Is, sl = fl / rs.inputTimeScale;
                      Vs += Math.max(0, sl), es += Math.max(0, -sl);
                    }
                    if (Ps) {
                      Ta.timescale || (si.logger.warn("regenerate InitSegment as audio detected"), this.generateIS(Ta, rs, _a));
                      var Il = this.remuxAudio(Ta, Vs, _s, el);
                      if (nl) {
                        var Vl;
                        Il && (Vl = Il.endPTS - Il.startPTS), rs.timescale || (si.logger.warn("regenerate InitSegment as video detected"), this.generateIS(Ta, rs, _a)), this.remuxVideo(rs, es, _s, Vl);
                      }
                    } else if (nl) {
                      var Bl = this.remuxVideo(rs, es, _s, 0, el);
                      Bl && Ta.codec && this.remuxEmptyAudio(Ta, Vs, _s, Bl);
                    }
                  }
                  Qa.samples.length && this.remuxID3(Qa, _a), Cs.samples.length && this.remuxText(Cs, _a), this.observer.trigger(ui.default.FRAG_PARSED);
                }, Ja.generateIS = function(Ta, rs, Qa) {
                  var Cs = this.observer, _a = Ta.samples, _s = rs.samples, el = this.typeSupported, Ps = "audio/mp4", nl = {}, Vs = {
                    tracks: nl
                  }, es = this._initPTS === void 0, Is, fl;
                  if (es && (Is = fl = 1 / 0), Ta.config && _a.length && (Ta.timescale = Ta.samplerate, si.logger.log("audio sampling rate : " + Ta.samplerate), Ta.isAAC || (el.mpeg ? (Ps = "audio/mpeg", Ta.codec = "") : el.mp3 && (Ta.codec = "mp3")), nl.audio = {
                    container: Ps,
                    codec: Ta.codec,
                    initSegment: !Ta.isAAC && el.mpeg ? new Uint8Array() : Lo.initSegment([Ta]),
                    metadata: {
                      channelCount: Ta.channelCount
                    }
                  }, es && (Is = fl = _a[0].pts - Math.round(Ta.inputTimeScale * Qa))), rs.sps && rs.pps && _s.length) {
                    var sl = rs.inputTimeScale;
                    if (rs.timescale = sl, nl.video = {
                      container: "video/mp4",
                      codec: rs.codec,
                      initSegment: Lo.initSegment([rs]),
                      metadata: {
                        width: rs.width,
                        height: rs.height
                      }
                    }, es) {
                      var Il = this.getVideoStartPts(_s), Vl = Math.round(sl * Qa);
                      fl = Math.min(fl, xa(_s[0].dts, Il) - Vl), Is = Math.min(Is, Il - Vl), this.observer.trigger(ui.default.INIT_PTS_FOUND, {
                        initPTS: Is
                      });
                    }
                  } else es && nl.audio && this.observer.trigger(ui.default.INIT_PTS_FOUND, {
                    initPTS: Is
                  });
                  Object.keys(nl).length ? (Cs.trigger(ui.default.FRAG_PARSING_INIT_SEGMENT, Vs), this.ISGenerated = !0, es && (this._initPTS = Is, this._initDTS = fl)) : Cs.trigger(ui.default.ERROR, {
                    type: ai.ErrorTypes.MEDIA_ERROR,
                    details: ai.ErrorDetails.FRAG_PARSING_ERROR,
                    fatal: !1,
                    reason: "no audio/video samples found"
                  });
                }, Ja.remuxVideo = function(Ta, rs, Qa, Cs) {
                  var _a = Ta.timescale, _s = Ta.samples, el = [], Ps = _s.length, nl = this._initPTS, Vs = 8, es, Is, fl, sl, Il, Vl = Number.POSITIVE_INFINITY, Bl = Number.NEGATIVE_INFINITY, ql = 0, xl = !1, Ul = this.nextAvcDts;
                  if (Ps !== 0) {
                    if (!Qa) {
                      var Xl = rs * _a, hu = _s[0].pts - xa(_s[0].dts, _s[0].pts);
                      Ul = Xl - hu;
                    }
                    for (var Tu = 0; Tu < Ps; Tu++) {
                      var Ku = _s[Tu];
                      Ku.pts = xa(Ku.pts - nl, Ul), Ku.dts = xa(Ku.dts - nl, Ul), Ku.dts > Ku.pts && (ql = Math.max(Math.min(ql, Ku.pts - Ku.dts), -1 * ia)), Ku.dts < _s[Tu > 0 ? Tu - 1 : Tu].dts && (xl = !0);
                    }
                    xl && _s.sort(function(iu, yc) {
                      var Mu = iu.dts - yc.dts, sc = iu.pts - yc.pts;
                      return Mu || sc || iu.id - yc.id;
                    }), sl = _s[0].dts, Il = _s[Ps - 1].dts;
                    var Wl = Math.round((Il - sl) / (Ps - 1));
                    if (ql < 0) {
                      if (ql < Wl * -2) {
                        si.logger.warn("PTS < DTS detected in video samples, offsetting DTS from PTS by " + ca(-Wl, !0) + " ms");
                        for (var uu = ql, du = 0; du < Ps; du++)
                          _s[du].dts = uu = Math.max(uu, _s[du].pts - Wl), _s[du].pts = Math.max(uu, _s[du].pts);
                      } else {
                        si.logger.warn("PTS < DTS detected in video samples, shifting DTS by " + ca(ql, !0) + " ms to overcome this issue");
                        for (var za = 0; za < Ps; za++)
                          _s[za].dts = _s[za].dts + ql;
                      }
                      sl = _s[0].dts, Il = _s[Ps - 1].dts;
                    }
                    if (Qa) {
                      var Ya = sl - Ul, Ws = Ya > Wl, wl = Ya < -1;
                      if (Ws || wl) {
                        Ws ? si.logger.warn("AVC: " + ca(Ya, !0) + " ms (" + Ya + "dts) hole between fragments detected, filling it") : si.logger.warn("AVC: " + ca(-Ya, !0) + " ms (" + Ya + "dts) overlapping between fragments detected"), sl = Ul;
                        var Gl = _s[0].pts - Ya;
                        _s[0].dts = sl, _s[0].pts = Gl, si.logger.log("Video: First PTS/DTS adjusted: " + ca(Gl, !0) + "/" + ca(sl, !0) + ", delta: " + ca(Ya, !0) + " ms");
                      }
                    }
                    ra && ra < 75 && (sl = Math.max(0, sl));
                    for (var bl = 0, Za = 0, rl = 0; rl < Ps; rl++) {
                      for (var zs = _s[rl], al = zs.units, Ol = al.length, $l = 0, Zl = 0; Zl < Ol; Zl++)
                        $l += al[Zl].data.length;
                      Za += $l, bl += Ol, zs.length = $l, zs.dts = Math.max(zs.dts, sl), zs.pts = Math.max(zs.pts, zs.dts, 0), Vl = Math.min(zs.pts, Vl), Bl = Math.max(zs.pts, Bl);
                    }
                    Il = _s[Ps - 1].dts;
                    var tu = Za + 4 * bl + 8;
                    try {
                      Is = new Uint8Array(tu);
                    } catch {
                      this.observer.trigger(ui.default.ERROR, {
                        type: ai.ErrorTypes.MUX_ERROR,
                        details: ai.ErrorDetails.REMUX_ALLOC_ERROR,
                        fatal: !1,
                        bytes: tu,
                        reason: "fail allocating video mdat " + tu
                      });
                      return;
                    }
                    var su = new DataView(Is.buffer);
                    su.setUint32(0, tu), Is.set(Lo.types.mdat, 4);
                    for (var dl = 0; dl < Ps; dl++) {
                      for (var Su = _s[dl], cu = Su.units, Ru = 0, bu = void 0, Hu = 0, cc = cu.length; Hu < cc; Hu++) {
                        var Tl = cu[Hu], Yl = Tl.data, Dl = Tl.data.byteLength;
                        su.setUint32(Vs, Dl), Vs += 4, Is.set(Yl, Vs), Vs += Dl, Ru += 4 + Dl;
                      }
                      if (dl < Ps - 1)
                        es = _s[dl + 1].dts - Su.dts;
                      else {
                        var Cl = this.config, Hl = Su.dts - _s[dl > 0 ? dl - 1 : dl].dts;
                        if (Cl.stretchShortVideoTrack) {
                          var Gu = Cl.maxBufferHole, xu = Math.floor(Gu * _a), ac = (Cs ? Vl + Cs * _a : this.nextAudioPts) - Su.pts;
                          ac > xu ? (es = ac - Hl, es < 0 && (es = Hl), si.logger.log("It is approximately " + ca(ac, !1) + " ms to the next segment; using duration " + ca(es, !1) + " ms for the last video frame.")) : es = Hl;
                        } else
                          es = Hl;
                      }
                      bu = Math.round(Su.pts - Su.dts), el.push({
                        size: Ru,
                        // constant duration
                        duration: es,
                        cts: bu,
                        flags: {
                          isLeading: 0,
                          isDependedOn: 0,
                          hasRedundancy: 0,
                          degradPrio: 0,
                          dependsOn: Su.key ? 2 : 1,
                          isNonSync: Su.key ? 0 : 1
                        }
                      });
                    }
                    this.nextAvcDts = Il + es;
                    var hc = Ta.dropped;
                    if (Ta.nbNalu = 0, Ta.dropped = 0, el.length && navigator.userAgent.toLowerCase().indexOf("chrome") > -1) {
                      var mc = el[0].flags;
                      mc.dependsOn = 2, mc.isNonSync = 0;
                    }
                    Ta.samples = el, fl = Lo.moof(Ta.sequenceNumber++, sl, Ta), Ta.samples = [];
                    var jc = {
                      data1: fl,
                      data2: Is,
                      startPTS: Vl / _a,
                      endPTS: (Bl + es) / _a,
                      startDTS: sl / _a,
                      endDTS: this.nextAvcDts / _a,
                      type: "video",
                      hasAudio: !1,
                      hasVideo: !0,
                      nb: el.length,
                      dropped: hc
                    };
                    return this.observer.trigger(ui.default.FRAG_PARSING_DATA, jc), jc;
                  }
                }, Ja.remuxAudio = function(Ta, rs, Qa, Cs) {
                  var _a = Ta.inputTimeScale, _s = Ta.timescale, el = _a / _s, Ps = Ta.isAAC ? 1024 : 1152, nl = Ps * el, Vs = this._initPTS, es = !Ta.isAAC && this.typeSupported.mpeg, Is, fl, sl, Il, Vl, Bl, ql = es ? 0 : 8, xl = Ta.samples, Ul = [], Xl = this.nextAudioPts;
                  if (Qa |= xl.length && Xl && (Cs && Math.abs(rs - Xl / _a) < 0.1 || Math.abs(xl[0].pts - Xl - Vs) < 20 * nl), xl.forEach(function(bu) {
                    bu.pts = bu.dts = xa(bu.pts - Vs, rs * _a);
                  }), xl = xl.filter(function(bu) {
                    return bu.pts >= 0;
                  }), xl.length !== 0) {
                    if (Qa || (Cs ? Xl = Math.max(0, rs * _a) : Xl = xl[0].pts), Ta.isAAC)
                      for (var hu = this.config.maxAudioFramesDrift, Tu = 0, Ku = Xl; Tu < xl.length; ) {
                        var Wl = xl[Tu], uu = Wl.pts, du = uu - Ku;
                        if (du <= -hu * nl)
                          Qa || Tu > 0 ? (si.logger.warn("Dropping 1 audio frame @ " + ca(Ku, !0) / 1e3 + "s due to " + ca(du, !0) + " ms overlap."), xl.splice(Tu, 1)) : (si.logger.warn("Audio frame @ " + ca(uu, !0) / 1e3 + "s overlaps nextAudioPts by " + ca(du, !0) + " ms."), Ku = uu + nl, Tu++);
                        else if (du >= hu * nl && du < ga && Ku) {
                          var za = Math.round(du / nl);
                          si.logger.warn("Injecting " + za + " audio frames @ " + ca(Ku, !0) / 1e3 + "s due to " + ca(du, !0) + " ms gap.");
                          for (var Ya = 0; Ya < za; Ya++) {
                            var Ws = Math.max(Ku, 0);
                            fl = ji.getSilentFrame(Ta.manifestCodec || Ta.codec, Ta.channelCount), fl || (si.logger.log("Unable to get silent frame for given audio codec; duplicating last frame instead."), fl = Wl.unit.subarray()), xl.splice(Tu, 0, {
                              unit: fl,
                              pts: Ws,
                              dts: Ws
                            }), Ku += nl, Tu++;
                          }
                          Wl.pts = Wl.dts = Ku, Ku += nl, Tu++;
                        } else
                          Wl.pts = Wl.dts = Ku, Ku += nl, Tu++;
                      }
                    for (var wl = xl.length, Gl = 0; wl--; )
                      Gl += xl[wl].unit.byteLength;
                    for (var bl = 0, Za = xl.length; bl < Za; bl++) {
                      var rl = xl[bl], zs = rl.unit, al = rl.pts;
                      if (Bl !== void 0 && Is)
                        Is.duration = Math.round((al - Bl) / el);
                      else {
                        var Ol = al - Xl, $l = 0;
                        if (Qa && Ta.isAAC && Ol) {
                          if (Ol > 0 && Ol < ga)
                            $l = Math.round((al - Xl) / nl), si.logger.log(ca(Ol, !0) + " ms hole between AAC samples detected,filling it"), $l > 0 && (fl = ji.getSilentFrame(Ta.manifestCodec || Ta.codec, Ta.channelCount), fl || (fl = zs.subarray()), Gl += $l * fl.length);
                          else if (Ol < -12) {
                            si.logger.log("drop overlapping AAC sample, expected/parsed/delta: " + ca(Xl, !0) + " ms / " + ca(al, !0) + " ms / " + ca(-Ol, !0) + " ms"), Gl -= zs.byteLength;
                            continue;
                          }
                          al = Xl;
                        }
                        if (Vl = al, Gl > 0) {
                          Gl += ql;
                          try {
                            sl = new Uint8Array(Gl);
                          } catch {
                            this.observer.trigger(ui.default.ERROR, {
                              type: ai.ErrorTypes.MUX_ERROR,
                              details: ai.ErrorDetails.REMUX_ALLOC_ERROR,
                              fatal: !1,
                              bytes: Gl,
                              reason: "fail allocating audio mdat " + Gl
                            });
                            return;
                          }
                          if (!es) {
                            var Zl = new DataView(sl.buffer);
                            Zl.setUint32(0, Gl), sl.set(Lo.types.mdat, 4);
                          }
                        } else
                          return;
                        for (var tu = 0; tu < $l; tu++)
                          fl = ji.getSilentFrame(Ta.manifestCodec || Ta.codec, Ta.channelCount), fl || (si.logger.log("Unable to get silent frame for given audio codec; duplicating this frame instead."), fl = zs.subarray()), sl.set(fl, ql), ql += fl.byteLength, Is = {
                            size: fl.byteLength,
                            cts: 0,
                            duration: 1024,
                            flags: {
                              isLeading: 0,
                              isDependedOn: 0,
                              hasRedundancy: 0,
                              degradPrio: 0,
                              dependsOn: 1
                            }
                          }, Ul.push(Is);
                      }
                      sl.set(zs, ql);
                      var su = zs.byteLength;
                      ql += su, Is = {
                        size: su,
                        cts: 0,
                        duration: 0,
                        flags: {
                          isLeading: 0,
                          isDependedOn: 0,
                          hasRedundancy: 0,
                          degradPrio: 0,
                          dependsOn: 1
                        }
                      }, Ul.push(Is), Bl = al;
                    }
                    var dl = 0;
                    if (wl = Ul.length, wl >= 2 && (dl = Ul[wl - 2].duration, Is.duration = dl), wl) {
                      this.nextAudioPts = Xl = Bl + el * dl, Ta.samples = Ul, es ? Il = new Uint8Array() : Il = Lo.moof(Ta.sequenceNumber++, Vl / el, Ta), Ta.samples = [];
                      var Su = Vl / _a, cu = Xl / _a, Ru = {
                        data1: Il,
                        data2: sl,
                        startPTS: Su,
                        endPTS: cu,
                        startDTS: Su,
                        endDTS: cu,
                        type: "audio",
                        hasAudio: !0,
                        hasVideo: !1,
                        nb: wl
                      };
                      return this.observer.trigger(ui.default.FRAG_PARSING_DATA, Ru), Ru;
                    }
                    return null;
                  }
                }, Ja.remuxEmptyAudio = function(Ta, rs, Qa, Cs) {
                  var _a = Ta.inputTimeScale, _s = Ta.samplerate ? Ta.samplerate : _a, el = _a / _s, Ps = this.nextAudioPts, nl = (Ps !== void 0 ? Ps : Cs.startDTS * _a) + this._initDTS, Vs = Cs.endDTS * _a + this._initDTS, es = 1024, Is = el * es, fl = Math.ceil((Vs - nl) / Is), sl = ji.getSilentFrame(Ta.manifestCodec || Ta.codec, Ta.channelCount);
                  if (si.logger.warn("remux empty Audio"), !sl) {
                    si.logger.trace("Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec!");
                    return;
                  }
                  for (var Il = [], Vl = 0; Vl < fl; Vl++) {
                    var Bl = nl + Vl * Is;
                    Il.push({
                      unit: sl,
                      pts: Bl,
                      dts: Bl
                    });
                  }
                  Ta.samples = Il, this.remuxAudio(Ta, rs, Qa);
                }, Ja.remuxID3 = function(Ta, rs) {
                  var Qa = Ta.samples.length;
                  if (Qa) {
                    for (var Cs = Ta.inputTimeScale, _a = this._initPTS, _s = this._initDTS, el = 0; el < Qa; el++) {
                      var Ps = Ta.samples[el];
                      Ps.pts = xa(Ps.pts - _a, rs * Cs) / Cs, Ps.dts = xa(Ps.dts - _s, rs * Cs) / Cs;
                    }
                    this.observer.trigger(ui.default.FRAG_PARSING_METADATA, {
                      samples: Ta.samples
                    }), Ta.samples = [];
                  }
                }, Ja.remuxText = function(Ta, rs) {
                  var Qa = Ta.samples.length, Cs = Ta.inputTimeScale, _a = this._initPTS;
                  if (Qa) {
                    for (var _s = 0; _s < Qa; _s++) {
                      var el = Ta.samples[_s];
                      el.pts = xa(el.pts - _a, rs * Cs) / Cs;
                    }
                    Ta.samples.sort(function(Ps, nl) {
                      return Ps.pts - nl.pts;
                    }), this.observer.trigger(ui.default.FRAG_PARSING_USERDATA, {
                      samples: Ta.samples
                    });
                  }
                  Ta.samples = [];
                }, La;
              })();
              function xa(La, Ja) {
                var ja;
                if (Ja === void 0)
                  return La;
                for (Ja < La ? ja = -8589934592 : ja = 8589934592; Math.abs(La - Ja) > 4294967296; )
                  La += ja;
                return La;
              }
              var $a = qo, ys = /* @__PURE__ */ (function() {
                function La(ja) {
                  this.observer = ja;
                }
                var Ja = La.prototype;
                return Ja.destroy = function() {
                }, Ja.resetTimeStamp = function() {
                }, Ja.resetInitSegment = function() {
                }, Ja.remux = function(Ta, rs, Qa, Cs, _a, _s, el, Ps) {
                  var nl = this.observer, Vs = "";
                  Ta && (Vs += "audio"), rs && (Vs += "video"), nl.trigger(ui.default.FRAG_PARSING_DATA, {
                    data1: Ps,
                    startPTS: _a,
                    startDTS: _a,
                    type: Vs,
                    hasAudio: !!Ta,
                    hasVideo: !!rs,
                    nb: 1,
                    dropped: 0
                  }), nl.trigger(ui.default.FRAG_PARSED);
                }, La;
              })(), Ss = ys, Xa = Object(di.getSelfScope)(), Es;
              try {
                Es = Xa.performance.now.bind(Xa.performance);
              } catch {
                si.logger.debug("Unable to use Performance API on this environment"), Es = Xa.Date.now;
              }
              var Rs = /* @__PURE__ */ (function() {
                function La(ja, Ta, rs, Qa) {
                  this.observer = ja, this.typeSupported = Ta, this.config = rs, this.vendor = Qa;
                }
                var Ja = La.prototype;
                return Ja.destroy = function() {
                  var Ta = this.demuxer;
                  Ta && Ta.destroy();
                }, Ja.push = function(Ta, rs, Qa, Cs, _a, _s, el, Ps, nl, Vs, es, Is) {
                  var fl = this;
                  if (Ta.byteLength > 0 && rs != null && rs.key != null && rs.method === "AES-128") {
                    var sl = this.decrypter;
                    sl == null && (sl = this.decrypter = new li.default(this.observer, this.config));
                    var Il = Es();
                    sl.decrypt(Ta, rs.key.buffer, rs.iv.buffer, function(Vl) {
                      var Bl = Es();
                      fl.observer.trigger(ui.default.FRAG_DECRYPTED, {
                        stats: {
                          tstart: Il,
                          tdecrypt: Bl
                        }
                      }), fl.pushDecrypted(new Uint8Array(Vl), rs, new Uint8Array(Qa), Cs, _a, _s, el, Ps, nl, Vs, es, Is);
                    });
                  } else
                    this.pushDecrypted(new Uint8Array(Ta), rs, new Uint8Array(Qa), Cs, _a, _s, el, Ps, nl, Vs, es, Is);
                }, Ja.pushDecrypted = function(Ta, rs, Qa, Cs, _a, _s, el, Ps, nl, Vs, es, Is) {
                  var fl = this.demuxer, sl = this.remuxer;
                  if (!fl || // in case of continuity change, or track switch
                  // we might switch from content type (AAC container to TS container, or TS to fmp4 for example)
                  el || Ps) {
                    for (var Il = this.observer, Vl = this.typeSupported, Bl = this.config, ql = [{
                      demux: No,
                      remux: $a
                    }, {
                      demux: io.default,
                      remux: Ss
                    }, {
                      demux: Oo,
                      remux: $a
                    }, {
                      demux: jo,
                      remux: $a
                    }], xl, Ul = 0, Xl = ql.length; Ul < Xl && (xl = ql[Ul], !xl.demux.probe(Ta)); Ul++)
                      ;
                    if (!xl) {
                      Il.trigger(ui.default.ERROR, {
                        type: ai.ErrorTypes.MEDIA_ERROR,
                        details: ai.ErrorDetails.FRAG_PARSING_ERROR,
                        fatal: !0,
                        reason: "no demux matching with content found"
                      });
                      return;
                    }
                    (!sl || !(sl instanceof xl.remux)) && (sl = new xl.remux(Il, Bl, Vl, this.vendor)), (!fl || !(fl instanceof xl.demux)) && (fl = new xl.demux(Il, sl, Bl, Vl), this.probe = xl.demux.probe), this.demuxer = fl, this.remuxer = sl;
                  }
                  (el || Ps) && (fl.resetInitSegment(Qa, Cs, _a, Vs), sl.resetInitSegment()), el && (fl.resetTimeStamp(Is), sl.resetTimeStamp(Is)), typeof fl.setDecryptData == "function" && fl.setDecryptData(rs), fl.append(Ta, _s, nl, es);
                }, La;
              })();
              ti.default = Rs;
            })
          ),
          /***/
          "./src/demux/demuxer-worker.js": (
            /*!*************************************!*\
              !*** ./src/demux/demuxer-worker.js ***!
              \*************************************/
            /*! exports provided: default */
            /*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./src/demux/demuxer.js (referenced with require.resolve) */
            /***/
            (function(ir, ti, ii) {
              ii.r(ti);
              var ui = ii(
                /*! ../demux/demuxer-inline */
                "./src/demux/demuxer-inline.js"
              ), ai = ii(
                /*! ../events */
                "./src/events.js"
              ), li = ii(
                /*! ../utils/logger */
                "./src/utils/logger.js"
              ), oi = ii(
                /*! eventemitter3 */
                "./node_modules/eventemitter3/index.js"
              ), si = function(fi) {
                var gi = new oi.EventEmitter();
                gi.trigger = function(vi) {
                  for (var xi = arguments.length, Si = new Array(xi > 1 ? xi - 1 : 0), Pi = 1; Pi < xi; Pi++)
                    Si[Pi - 1] = arguments[Pi];
                  gi.emit.apply(gi, [vi, vi].concat(Si));
                }, gi.off = function(vi) {
                  for (var xi = arguments.length, Si = new Array(xi > 1 ? xi - 1 : 0), Pi = 1; Pi < xi; Pi++)
                    Si[Pi - 1] = arguments[Pi];
                  gi.removeListener.apply(gi, [vi].concat(Si));
                };
                var mi = function(vi, xi) {
                  fi.postMessage({
                    event: vi,
                    data: xi
                  });
                };
                fi.addEventListener("message", function(Ti) {
                  var vi = Ti.data;
                  switch (vi.cmd) {
                    case "init":
                      var xi = JSON.parse(vi.config);
                      fi.demuxer = new ui.default(gi, vi.typeSupported, xi, vi.vendor), Object(li.enableLogs)(xi.debug), mi("init", null);
                      break;
                    case "demux":
                      fi.demuxer.push(vi.data, vi.decryptdata, vi.initSegment, vi.audioCodec, vi.videoCodec, vi.timeOffset, vi.discontinuity, vi.trackSwitch, vi.contiguous, vi.duration, vi.accurateTimeOffset, vi.defaultInitPTS);
                      break;
                  }
                }), gi.on(ai.default.FRAG_DECRYPTED, mi), gi.on(ai.default.FRAG_PARSING_INIT_SEGMENT, mi), gi.on(ai.default.FRAG_PARSED, mi), gi.on(ai.default.ERROR, mi), gi.on(ai.default.FRAG_PARSING_METADATA, mi), gi.on(ai.default.FRAG_PARSING_USERDATA, mi), gi.on(ai.default.INIT_PTS_FOUND, mi), gi.on(ai.default.FRAG_PARSING_DATA, function(Ti, vi) {
                  var xi = [], Si = {
                    event: Ti,
                    data: vi
                  };
                  vi.data1 && (Si.data1 = vi.data1.buffer, xi.push(vi.data1.buffer), delete vi.data1), vi.data2 && (Si.data2 = vi.data2.buffer, xi.push(vi.data2.buffer), delete vi.data2), fi.postMessage(Si, xi);
                });
              };
              ti.default = si;
            })
          ),
          /***/
          "./src/demux/id3.js": (
            /*!**************************!*\
              !*** ./src/demux/id3.js ***!
              \**************************/
            /*! exports provided: default, utf8ArrayToStr */
            /***/
            (function(ir, ti, ii) {
              ii.r(ti), ii.d(ti, "utf8ArrayToStr", function() {
                return si;
              });
              var ui = ii(
                /*! ../utils/get-self-scope */
                "./src/utils/get-self-scope.js"
              ), ai = /* @__PURE__ */ (function() {
                function di() {
                }
                return di.isHeader = function(gi, mi) {
                  return mi + 10 <= gi.length && gi[mi] === 73 && gi[mi + 1] === 68 && gi[mi + 2] === 51 && gi[mi + 3] < 255 && gi[mi + 4] < 255 && gi[mi + 6] < 128 && gi[mi + 7] < 128 && gi[mi + 8] < 128 && gi[mi + 9] < 128;
                }, di.isFooter = function(gi, mi) {
                  return mi + 10 <= gi.length && gi[mi] === 51 && gi[mi + 1] === 68 && gi[mi + 2] === 73 && gi[mi + 3] < 255 && gi[mi + 4] < 255 && gi[mi + 6] < 128 && gi[mi + 7] < 128 && gi[mi + 8] < 128 && gi[mi + 9] < 128;
                }, di.getID3Data = function(gi, mi) {
                  for (var Ti = mi, vi = 0; di.isHeader(gi, mi); ) {
                    vi += 10;
                    var xi = di._readSize(gi, mi + 6);
                    vi += xi, di.isFooter(gi, mi + 10) && (vi += 10), mi += vi;
                  }
                  if (vi > 0)
                    return gi.subarray(Ti, Ti + vi);
                }, di._readSize = function(gi, mi) {
                  var Ti = 0;
                  return Ti = (gi[mi] & 127) << 21, Ti |= (gi[mi + 1] & 127) << 14, Ti |= (gi[mi + 2] & 127) << 7, Ti |= gi[mi + 3] & 127, Ti;
                }, di.getTimeStamp = function(gi) {
                  for (var mi = di.getID3Frames(gi), Ti = 0; Ti < mi.length; Ti++) {
                    var vi = mi[Ti];
                    if (di.isTimeStampFrame(vi))
                      return di._readTimeStamp(vi);
                  }
                }, di.isTimeStampFrame = function(gi) {
                  return gi && gi.key === "PRIV" && gi.info === "com.apple.streaming.transportStreamTimestamp";
                }, di._getFrameData = function(gi) {
                  var mi = String.fromCharCode(gi[0], gi[1], gi[2], gi[3]), Ti = di._readSize(gi, 4), vi = 10;
                  return {
                    type: mi,
                    size: Ti,
                    data: gi.subarray(vi, vi + Ti)
                  };
                }, di.getID3Frames = function(gi) {
                  for (var mi = 0, Ti = []; di.isHeader(gi, mi); ) {
                    var vi = di._readSize(gi, mi + 6);
                    mi += 10;
                    for (var xi = mi + vi; mi + 8 < xi; ) {
                      var Si = di._getFrameData(gi.subarray(mi)), Pi = di._decodeFrame(Si);
                      Pi && Ti.push(Pi), mi += Si.size + 10;
                    }
                    di.isFooter(gi, mi) && (mi += 10);
                  }
                  return Ti;
                }, di._decodeFrame = function(gi) {
                  return gi.type === "PRIV" ? di._decodePrivFrame(gi) : gi.type[0] === "W" ? di._decodeURLFrame(gi) : di._decodeTextFrame(gi);
                }, di._readTimeStamp = function(gi) {
                  if (gi.data.byteLength === 8) {
                    var mi = new Uint8Array(gi.data), Ti = mi[3] & 1, vi = (mi[4] << 23) + (mi[5] << 15) + (mi[6] << 7) + mi[7];
                    return vi /= 45, Ti && (vi += 4772185884e-2), Math.round(vi);
                  }
                }, di._decodePrivFrame = function(gi) {
                  if (!(gi.size < 2)) {
                    var mi = di._utf8ArrayToStr(gi.data, !0), Ti = new Uint8Array(gi.data.subarray(mi.length + 1));
                    return {
                      key: gi.type,
                      info: mi,
                      data: Ti.buffer
                    };
                  }
                }, di._decodeTextFrame = function(gi) {
                  if (!(gi.size < 2))
                    if (gi.type === "TXXX") {
                      var mi = 1, Ti = di._utf8ArrayToStr(gi.data.subarray(mi), !0);
                      mi += Ti.length + 1;
                      var vi = di._utf8ArrayToStr(gi.data.subarray(mi));
                      return {
                        key: gi.type,
                        info: Ti,
                        data: vi
                      };
                    } else {
                      var xi = di._utf8ArrayToStr(gi.data.subarray(1));
                      return {
                        key: gi.type,
                        data: xi
                      };
                    }
                }, di._decodeURLFrame = function(gi) {
                  if (gi.type === "WXXX") {
                    if (gi.size < 2)
                      return;
                    var mi = 1, Ti = di._utf8ArrayToStr(gi.data.subarray(mi), !0);
                    mi += Ti.length + 1;
                    var vi = di._utf8ArrayToStr(gi.data.subarray(mi));
                    return {
                      key: gi.type,
                      info: Ti,
                      data: vi
                    };
                  } else {
                    var xi = di._utf8ArrayToStr(gi.data);
                    return {
                      key: gi.type,
                      data: xi
                    };
                  }
                }, di._utf8ArrayToStr = function(gi, mi) {
                  mi === void 0 && (mi = !1);
                  var Ti = oi();
                  if (Ti) {
                    var vi = Ti.decode(gi);
                    if (mi) {
                      var xi = vi.indexOf("\0");
                      return xi !== -1 ? vi.substring(0, xi) : vi;
                    }
                    return vi.replace(/\0/g, "");
                  }
                  for (var Si = gi.length, Pi, $i, Oi, Di = "", Mi = 0; Mi < Si; ) {
                    if (Pi = gi[Mi++], Pi === 0 && mi)
                      return Di;
                    if (Pi === 0 || Pi === 3)
                      continue;
                    switch (Pi >> 4) {
                      case 0:
                      case 1:
                      case 2:
                      case 3:
                      case 4:
                      case 5:
                      case 6:
                      case 7:
                        Di += String.fromCharCode(Pi);
                        break;
                      case 12:
                      case 13:
                        $i = gi[Mi++], Di += String.fromCharCode((Pi & 31) << 6 | $i & 63);
                        break;
                      case 14:
                        $i = gi[Mi++], Oi = gi[Mi++], Di += String.fromCharCode((Pi & 15) << 12 | ($i & 63) << 6 | (Oi & 63) << 0);
                        break;
                    }
                  }
                  return Di;
                }, di;
              })(), li;
              function oi() {
                var di = Object(ui.getSelfScope)();
                return !li && typeof di.TextDecoder < "u" && (li = new di.TextDecoder("utf-8")), li;
              }
              var si = ai._utf8ArrayToStr;
              ti.default = ai;
            })
          ),
          /***/
          "./src/demux/mp4demuxer.js": (
            /*!*********************************!*\
              !*** ./src/demux/mp4demuxer.js ***!
              \*********************************/
            /*! exports provided: default */
            /***/
            (function(ir, ti, ii) {
              ii.r(ti);
              var ui = ii(
                /*! ../utils/logger */
                "./src/utils/logger.js"
              ), ai = ii(
                /*! ../events */
                "./src/events.js"
              ), li = Math.pow(2, 32) - 1, oi = /* @__PURE__ */ (function() {
                function si(fi, gi) {
                  this.observer = fi, this.remuxer = gi;
                }
                var di = si.prototype;
                return di.resetTimeStamp = function(gi) {
                  this.initPTS = gi;
                }, di.resetInitSegment = function(gi, mi, Ti, vi) {
                  if (gi && gi.byteLength) {
                    var xi = this.initData = si.parseInitSegment(gi);
                    mi == null && (mi = "mp4a.40.5"), Ti == null && (Ti = "avc1.42e01e");
                    var Si = {};
                    xi.audio && xi.video ? Si.audiovideo = {
                      container: "video/mp4",
                      codec: mi + "," + Ti,
                      initSegment: vi ? gi : null
                    } : (xi.audio && (Si.audio = {
                      container: "audio/mp4",
                      codec: mi,
                      initSegment: vi ? gi : null
                    }), xi.video && (Si.video = {
                      container: "video/mp4",
                      codec: Ti,
                      initSegment: vi ? gi : null
                    })), this.observer.trigger(ai.default.FRAG_PARSING_INIT_SEGMENT, {
                      tracks: Si
                    });
                  } else
                    mi && (this.audioCodec = mi), Ti && (this.videoCodec = Ti);
                }, si.probe = function(gi) {
                  return si.findBox({
                    data: gi,
                    start: 0,
                    end: Math.min(gi.length, 16384)
                  }, ["moof"]).length > 0;
                }, si.bin2str = function(gi) {
                  return String.fromCharCode.apply(null, gi);
                }, si.readUint16 = function(gi, mi) {
                  gi.data && (mi += gi.start, gi = gi.data);
                  var Ti = gi[mi] << 8 | gi[mi + 1];
                  return Ti < 0 ? 65536 + Ti : Ti;
                }, si.readUint32 = function(gi, mi) {
                  gi.data && (mi += gi.start, gi = gi.data);
                  var Ti = gi[mi] << 24 | gi[mi + 1] << 16 | gi[mi + 2] << 8 | gi[mi + 3];
                  return Ti < 0 ? 4294967296 + Ti : Ti;
                }, si.writeUint32 = function(gi, mi, Ti) {
                  gi.data && (mi += gi.start, gi = gi.data), gi[mi] = Ti >> 24, gi[mi + 1] = Ti >> 16 & 255, gi[mi + 2] = Ti >> 8 & 255, gi[mi + 3] = Ti & 255;
                }, si.findBox = function(gi, mi) {
                  var Ti = [], vi, xi, Si, Pi, $i, Oi, Di;
                  if (gi.data ? (Oi = gi.start, Pi = gi.end, gi = gi.data) : (Oi = 0, Pi = gi.byteLength), !mi.length)
                    return null;
                  for (vi = Oi; vi < Pi; )
                    xi = si.readUint32(gi, vi), Si = si.bin2str(gi.subarray(vi + 4, vi + 8)), Di = xi > 1 ? vi + xi : Pi, Si === mi[0] && (mi.length === 1 ? Ti.push({
                      data: gi,
                      start: vi + 8,
                      end: Di
                    }) : ($i = si.findBox({
                      data: gi,
                      start: vi + 8,
                      end: Di
                    }, mi.slice(1)), $i.length && (Ti = Ti.concat($i)))), vi = Di;
                  return Ti;
                }, si.parseSegmentIndex = function(gi) {
                  var mi = si.findBox(gi, ["moov"])[0], Ti = mi ? mi.end : null, vi = 0, xi = si.findBox(gi, ["sidx"]), Si;
                  if (!xi || !xi[0])
                    return null;
                  Si = [], xi = xi[0];
                  var Pi = xi.data[0];
                  vi = Pi === 0 ? 8 : 16;
                  var $i = si.readUint32(xi, vi);
                  vi += 4;
                  var Oi = 0, Di = 0;
                  Pi === 0 ? vi += 8 : vi += 16, vi += 2;
                  var Mi = xi.end + Di, Oo = si.readUint16(xi, vi);
                  vi += 2;
                  for (var io = 0; io < Oo; io++) {
                    var xo = vi, fo = si.readUint32(xi, xo);
                    xo += 4;
                    var _o = fo & 2147483647, Li = (fo & 2147483648) >>> 31;
                    if (Li === 1) {
                      console.warn("SIDX has hierarchical references (not supported)");
                      return;
                    }
                    var Co = si.readUint32(xi, xo);
                    xo += 4, Si.push({
                      referenceSize: _o,
                      subsegmentDuration: Co,
                      // unscaled
                      info: {
                        duration: Co / $i,
                        start: Mi,
                        end: Mi + _o - 1
                      }
                    }), Mi += _o, xo += 4, vi = xo;
                  }
                  return {
                    earliestPresentationTime: Oi,
                    timescale: $i,
                    version: Pi,
                    referencesCount: Oo,
                    references: Si,
                    moovEndOffset: Ti
                  };
                }, si.parseInitSegment = function(gi) {
                  var mi = [], Ti = si.findBox(gi, ["moov", "trak"]);
                  return Ti.forEach(function(vi) {
                    var xi = si.findBox(vi, ["tkhd"])[0];
                    if (xi) {
                      var Si = xi.data[xi.start], Pi = Si === 0 ? 12 : 20, $i = si.readUint32(xi, Pi), Oi = si.findBox(vi, ["mdia", "mdhd"])[0];
                      if (Oi) {
                        Si = Oi.data[Oi.start], Pi = Si === 0 ? 12 : 20;
                        var Di = si.readUint32(Oi, Pi), Mi = si.findBox(vi, ["mdia", "hdlr"])[0];
                        if (Mi) {
                          var Oo = si.bin2str(Mi.data.subarray(Mi.start + 8, Mi.start + 12)), io = {
                            soun: "audio",
                            vide: "video"
                          }[Oo];
                          if (io) {
                            var xo = si.findBox(vi, ["mdia", "minf", "stbl", "stsd"]);
                            if (xo.length) {
                              xo = xo[0];
                              var fo = si.bin2str(xo.data.subarray(xo.start + 12, xo.start + 16));
                              ui.logger.log("MP4Demuxer:" + io + ":" + fo + " found");
                            }
                            mi[$i] = {
                              timescale: Di,
                              type: io
                            }, mi[io] = {
                              timescale: Di,
                              id: $i
                            };
                          }
                        }
                      }
                    }
                  }), mi;
                }, si.getStartDTS = function(gi, mi) {
                  var Ti, vi, xi;
                  return Ti = si.findBox(mi, ["moof", "traf"]), vi = [].concat.apply([], Ti.map(function(Si) {
                    return si.findBox(Si, ["tfhd"]).map(function(Pi) {
                      var $i, Oi, Di;
                      return $i = si.readUint32(Pi, 4), Oi = gi[$i].timescale || 9e4, Di = si.findBox(Si, ["tfdt"]).map(function(Mi) {
                        var Oo, io;
                        return Oo = Mi.data[Mi.start], io = si.readUint32(Mi, 4), Oo === 1 && (io *= Math.pow(2, 32), io += si.readUint32(Mi, 8)), io;
                      })[0], Di / Oi;
                    });
                  })), xi = Math.min.apply(null, vi), isFinite(xi) ? xi : 0;
                }, si.offsetStartDTS = function(gi, mi, Ti) {
                  si.findBox(mi, ["moof", "traf"]).map(function(vi) {
                    return si.findBox(vi, ["tfhd"]).map(function(xi) {
                      var Si = si.readUint32(xi, 4), Pi = gi[Si].timescale || 9e4;
                      si.findBox(vi, ["tfdt"]).map(function($i) {
                        var Oi = $i.data[$i.start], Di = si.readUint32($i, 4);
                        if (Oi === 0)
                          si.writeUint32($i, 4, Di - Ti * Pi);
                        else {
                          Di *= Math.pow(2, 32), Di += si.readUint32($i, 8), Di -= Ti * Pi, Di = Math.max(Di, 0);
                          var Mi = Math.floor(Di / (li + 1)), Oo = Math.floor(Di % (li + 1));
                          si.writeUint32($i, 4, Mi), si.writeUint32($i, 8, Oo);
                        }
                      });
                    });
                  });
                }, di.append = function(gi, mi, Ti, vi) {
                  var xi = this.initData;
                  xi || (this.resetInitSegment(gi, this.audioCodec, this.videoCodec, !1), xi = this.initData);
                  var Si, Pi = this.initPTS;
                  if (Pi === void 0) {
                    var $i = si.getStartDTS(xi, gi);
                    this.initPTS = Pi = $i - mi, this.observer.trigger(ai.default.INIT_PTS_FOUND, {
                      initPTS: Pi
                    });
                  }
                  si.offsetStartDTS(xi, gi, Pi), Si = si.getStartDTS(xi, gi), this.remuxer.remux(xi.audio, xi.video, null, null, Si, Ti, vi, gi);
                }, di.destroy = function() {
                }, si;
              })();
              ti.default = oi;
            })
          ),
          /***/
          "./src/errors.ts": (
            /*!***********************!*\
              !*** ./src/errors.ts ***!
              \***********************/
            /*! exports provided: ErrorTypes, ErrorDetails */
            /***/
            (function(ir, ti, ii) {
              ii.r(ti), ii.d(ti, "ErrorTypes", function() {
                return ui;
              }), ii.d(ti, "ErrorDetails", function() {
                return ai;
              });
              var ui;
              (function(li) {
                li.NETWORK_ERROR = "networkError", li.MEDIA_ERROR = "mediaError", li.KEY_SYSTEM_ERROR = "keySystemError", li.MUX_ERROR = "muxError", li.OTHER_ERROR = "otherError";
              })(ui || (ui = {}));
              var ai;
              (function(li) {
                li.KEY_SYSTEM_NO_KEYS = "keySystemNoKeys", li.KEY_SYSTEM_NO_ACCESS = "keySystemNoAccess", li.KEY_SYSTEM_NO_SESSION = "keySystemNoSession", li.KEY_SYSTEM_LICENSE_REQUEST_FAILED = "keySystemLicenseRequestFailed", li.KEY_SYSTEM_NO_INIT_DATA = "keySystemNoInitData", li.MANIFEST_LOAD_ERROR = "manifestLoadError", li.MANIFEST_LOAD_TIMEOUT = "manifestLoadTimeOut", li.MANIFEST_PARSING_ERROR = "manifestParsingError", li.MANIFEST_INCOMPATIBLE_CODECS_ERROR = "manifestIncompatibleCodecsError", li.LEVEL_EMPTY_ERROR = "levelEmptyError", li.LEVEL_LOAD_ERROR = "levelLoadError", li.LEVEL_LOAD_TIMEOUT = "levelLoadTimeOut", li.LEVEL_SWITCH_ERROR = "levelSwitchError", li.AUDIO_TRACK_LOAD_ERROR = "audioTrackLoadError", li.AUDIO_TRACK_LOAD_TIMEOUT = "audioTrackLoadTimeOut", li.FRAG_LOAD_ERROR = "fragLoadError", li.FRAG_LOAD_TIMEOUT = "fragLoadTimeOut", li.FRAG_DECRYPT_ERROR = "fragDecryptError", li.FRAG_PARSING_ERROR = "fragParsingError", li.REMUX_ALLOC_ERROR = "remuxAllocError", li.KEY_LOAD_ERROR = "keyLoadError", li.KEY_LOAD_TIMEOUT = "keyLoadTimeOut", li.BUFFER_ADD_CODEC_ERROR = "bufferAddCodecError", li.BUFFER_APPEND_ERROR = "bufferAppendError", li.BUFFER_APPENDING_ERROR = "bufferAppendingError", li.BUFFER_STALLED_ERROR = "bufferStalledError", li.BUFFER_FULL_ERROR = "bufferFullError", li.BUFFER_SEEK_OVER_HOLE = "bufferSeekOverHole", li.BUFFER_NUDGE_ON_STALL = "bufferNudgeOnStall", li.INTERNAL_EXCEPTION = "internalException";
              })(ai || (ai = {}));
            })
          ),
          /***/
          "./src/events.js": (
            /*!***********************!*\
              !*** ./src/events.js ***!
              \***********************/
            /*! exports provided: default */
            /***/
            (function(ir, ti, ii) {
              ii.r(ti);
              var ui = {
                // fired before MediaSource is attaching to media element - data: { media }
                MEDIA_ATTACHING: "hlsMediaAttaching",
                // fired when MediaSource has been succesfully attached to media element - data: { }
                MEDIA_ATTACHED: "hlsMediaAttached",
                // fired before detaching MediaSource from media element - data: { }
                MEDIA_DETACHING: "hlsMediaDetaching",
                // fired when MediaSource has been detached from media element - data: { }
                MEDIA_DETACHED: "hlsMediaDetached",
                // fired when we buffer is going to be reset - data: { }
                BUFFER_RESET: "hlsBufferReset",
                // fired when we know about the codecs that we need buffers for to push into - data: {tracks : { container, codec, levelCodec, initSegment, metadata }}
                BUFFER_CODECS: "hlsBufferCodecs",
                // fired when sourcebuffers have been created - data: { tracks : tracks }
                BUFFER_CREATED: "hlsBufferCreated",
                // fired when we append a segment to the buffer - data: { segment: segment object }
                BUFFER_APPENDING: "hlsBufferAppending",
                // fired when we are done with appending a media segment to the buffer - data : { parent : segment parent that triggered BUFFER_APPENDING, pending : nb of segments waiting for appending for this segment parent}
                BUFFER_APPENDED: "hlsBufferAppended",
                // fired when the stream is finished and we want to notify the media buffer that there will be no more data - data: { }
                BUFFER_EOS: "hlsBufferEos",
                // fired when the media buffer should be flushed - data { startOffset, endOffset }
                BUFFER_FLUSHING: "hlsBufferFlushing",
                // fired when the media buffer has been flushed - data: { }
                BUFFER_FLUSHED: "hlsBufferFlushed",
                // fired to signal that a manifest loading starts - data: { url : manifestURL}
                MANIFEST_LOADING: "hlsManifestLoading",
                // fired after manifest has been loaded - data: { levels : [available quality levels], audioTracks : [ available audio tracks], url : manifestURL, stats : { trequest, tfirst, tload, mtime}}
                MANIFEST_LOADED: "hlsManifestLoaded",
                // fired after manifest has been parsed - data: { levels : [available quality levels], firstLevel : index of first quality level appearing in Manifest}
                MANIFEST_PARSED: "hlsManifestParsed",
                // fired when a level switch is requested - data: { level : id of new level }
                LEVEL_SWITCHING: "hlsLevelSwitching",
                // fired when a level switch is effective - data: { level : id of new level }
                LEVEL_SWITCHED: "hlsLevelSwitched",
                // fired when a level playlist loading starts - data: { url : level URL, level : id of level being loaded}
                LEVEL_LOADING: "hlsLevelLoading",
                // fired when a level playlist loading finishes - data: { details : levelDetails object, level : id of loaded level, stats : { trequest, tfirst, tload, mtime} }
                LEVEL_LOADED: "hlsLevelLoaded",
                // fired when a level's details have been updated based on previous details, after it has been loaded - data: { details : levelDetails object, level : id of updated level }
                LEVEL_UPDATED: "hlsLevelUpdated",
                // fired when a level's PTS information has been updated after parsing a fragment - data: { details : levelDetails object, level : id of updated level, drift: PTS drift observed when parsing last fragment }
                LEVEL_PTS_UPDATED: "hlsLevelPtsUpdated",
                // fired to notify that levels have changed after removing a level - data: { levels : [available quality levels] }
                LEVELS_UPDATED: "hlsLevelsUpdated",
                // fired to notify that audio track lists has been updated - data: { audioTracks : audioTracks }
                AUDIO_TRACKS_UPDATED: "hlsAudioTracksUpdated",
                // fired when an audio track switching is requested - data: { id : audio track id }
                AUDIO_TRACK_SWITCHING: "hlsAudioTrackSwitching",
                // fired when an audio track switch actually occurs - data: { id : audio track id }
                AUDIO_TRACK_SWITCHED: "hlsAudioTrackSwitched",
                // fired when an audio track loading starts - data: { url : audio track URL, id : audio track id }
                AUDIO_TRACK_LOADING: "hlsAudioTrackLoading",
                // fired when an audio track loading finishes - data: { details : levelDetails object, id : audio track id, stats : { trequest, tfirst, tload, mtime } }
                AUDIO_TRACK_LOADED: "hlsAudioTrackLoaded",
                // fired to notify that subtitle track lists has been updated - data: { subtitleTracks : subtitleTracks }
                SUBTITLE_TRACKS_UPDATED: "hlsSubtitleTracksUpdated",
                // fired when an subtitle track switch occurs - data: { id : subtitle track id }
                SUBTITLE_TRACK_SWITCH: "hlsSubtitleTrackSwitch",
                // fired when a subtitle track loading starts - data: { url : subtitle track URL, id : subtitle track id }
                SUBTITLE_TRACK_LOADING: "hlsSubtitleTrackLoading",
                // fired when a subtitle track loading finishes - data: { details : levelDetails object, id : subtitle track id, stats : { trequest, tfirst, tload, mtime } }
                SUBTITLE_TRACK_LOADED: "hlsSubtitleTrackLoaded",
                // fired when a subtitle fragment has been processed - data: { success : boolean, frag : the processed frag }
                SUBTITLE_FRAG_PROCESSED: "hlsSubtitleFragProcessed",
                // fired when a set of VTTCues to be managed externally has been parsed - data: { type: string, track: string, cues: [ VTTCue ] }
                CUES_PARSED: "hlsCuesParsed",
                // fired when a text track to be managed externally is found - data: { tracks: [ { label: string, kind: string, default: boolean } ] }
                NON_NATIVE_TEXT_TRACKS_FOUND: "hlsNonNativeTextTracksFound",
                // fired when the first timestamp is found - data: { id : demuxer id, initPTS: initPTS, frag : fragment object }
                INIT_PTS_FOUND: "hlsInitPtsFound",
                // fired when a fragment loading starts - data: { frag : fragment object }
                FRAG_LOADING: "hlsFragLoading",
                // fired when a fragment loading is progressing - data: { frag : fragment object, { trequest, tfirst, loaded } }
                FRAG_LOAD_PROGRESS: "hlsFragLoadProgress",
                // Identifier for fragment load aborting for emergency switch down - data: { frag : fragment object }
                FRAG_LOAD_EMERGENCY_ABORTED: "hlsFragLoadEmergencyAborted",
                // fired when a fragment loading is completed - data: { frag : fragment object, payload : fragment payload, stats : { trequest, tfirst, tload, length } }
                FRAG_LOADED: "hlsFragLoaded",
                // fired when a fragment has finished decrypting - data: { id : demuxer id, frag: fragment object, payload : fragment payload, stats : { tstart, tdecrypt } }
                FRAG_DECRYPTED: "hlsFragDecrypted",
                // fired when Init Segment has been extracted from fragment - data: { id : demuxer id, frag: fragment object, moov : moov MP4 box, codecs : codecs found while parsing fragment }
                FRAG_PARSING_INIT_SEGMENT: "hlsFragParsingInitSegment",
                // fired when parsing sei text is completed - data: { id : demuxer id, frag: fragment object, samples : [ sei samples pes ] }
                FRAG_PARSING_USERDATA: "hlsFragParsingUserdata",
                // fired when parsing id3 is completed - data: { id : demuxer id, frag: fragment object, samples : [ id3 samples pes ] }
                FRAG_PARSING_METADATA: "hlsFragParsingMetadata",
                // fired when data have been extracted from fragment - data: { id : demuxer id, frag: fragment object, data1 : moof MP4 box or TS fragments, data2 : mdat MP4 box or null}
                FRAG_PARSING_DATA: "hlsFragParsingData",
                // fired when fragment parsing is completed - data: { id : demuxer id, frag: fragment object }
                FRAG_PARSED: "hlsFragParsed",
                // fired when fragment remuxed MP4 boxes have all been appended into SourceBuffer - data: { id : demuxer id, frag : fragment object, stats : { trequest, tfirst, tload, tparsed, tbuffered, length, bwEstimate } }
                FRAG_BUFFERED: "hlsFragBuffered",
                // fired when fragment matching with current media position is changing - data : { id : demuxer id, frag : fragment object }
                FRAG_CHANGED: "hlsFragChanged",
                // Identifier for a FPS drop event - data: { curentDropped, currentDecoded, totalDroppedFrames }
                FPS_DROP: "hlsFpsDrop",
                // triggered when FPS drop triggers auto level capping - data: { level, droppedlevel }
                FPS_DROP_LEVEL_CAPPING: "hlsFpsDropLevelCapping",
                // Identifier for an error event - data: { type : error type, details : error details, fatal : if true, hls.js cannot/will not try to recover, if false, hls.js will try to recover,other error specific data }
                ERROR: "hlsError",
                // fired when hls.js instance starts destroying. Different from MEDIA_DETACHED as one could want to detach and reattach a media to the instance of hls.js to handle mid-rolls for example - data: { }
                DESTROYING: "hlsDestroying",
                // fired when a decrypt key loading starts - data: { frag : fragment object }
                KEY_LOADING: "hlsKeyLoading",
                // fired when a decrypt key loading is completed - data: { frag : fragment object, payload : key payload, stats : { trequest, tfirst, tload, length } }
                KEY_LOADED: "hlsKeyLoaded",
                // fired upon stream controller state transitions - data: { previousState, nextState }
                STREAM_STATE_TRANSITION: "hlsStreamStateTransition",
                // fired when the live back buffer is reached defined by the liveBackBufferLength config option - data : { bufferEnd: number }
                LIVE_BACK_BUFFER_REACHED: "hlsLiveBackBufferReached"
              };
              ti.default = ui;
            })
          ),
          /***/
          "./src/hls.ts": (
            /*!*********************************!*\
              !*** ./src/hls.ts + 50 modules ***!
              \*********************************/
            /*! exports provided: default */
            /*! ModuleConcatenation bailout: Cannot concat with ./src/crypt/decrypter.js because of ./src/demux/demuxer-worker.js */
            /*! ModuleConcatenation bailout: Cannot concat with ./src/demux/demuxer-inline.js because of ./src/demux/demuxer-worker.js */
            /*! ModuleConcatenation bailout: Cannot concat with ./src/demux/id3.js because of ./src/demux/demuxer-worker.js */
            /*! ModuleConcatenation bailout: Cannot concat with ./src/demux/mp4demuxer.js because of ./src/demux/demuxer-worker.js */
            /*! ModuleConcatenation bailout: Cannot concat with ./src/errors.ts because of ./src/demux/demuxer-worker.js */
            /*! ModuleConcatenation bailout: Cannot concat with ./src/events.js because of ./src/demux/demuxer-worker.js */
            /*! ModuleConcatenation bailout: Cannot concat with ./src/polyfills/number.js because of ./src/demux/demuxer-worker.js */
            /*! ModuleConcatenation bailout: Cannot concat with ./src/utils/get-self-scope.js because of ./src/demux/demuxer-worker.js */
            /*! ModuleConcatenation bailout: Cannot concat with ./src/utils/logger.js because of ./src/demux/demuxer-worker.js */
            /*! ModuleConcatenation bailout: Cannot concat with ./node_modules/eventemitter3/index.js (<- Module is not an ECMAScript module) */
            /*! ModuleConcatenation bailout: Cannot concat with ./node_modules/url-toolkit/src/url-toolkit.js (<- Module is not an ECMAScript module) */
            /***/
            (function(ir, ti, ii) {
              ii.r(ti), ii.d(ti, "default", function() {
                return (
                  /* binding */
                  op
                );
              });
              var ui = {};
              ii.r(ui), ii.d(ui, "newCue", function() {
                return ad;
              });
              var ai = ii("./node_modules/url-toolkit/src/url-toolkit.js"), li = ii("./src/errors.ts"), oi = ii("./src/polyfills/number.js"), si = ii("./src/events.js"), di = ii("./src/utils/logger.js"), fi = {
                hlsEventGeneric: !0,
                hlsHandlerDestroying: !0,
                hlsHandlerDestroyed: !0
              }, gi = /* @__PURE__ */ (function() {
                function Sa(Ho) {
                  this.hls = void 0, this.handledEvents = void 0, this.useGenericHandler = void 0, this.hls = Ho, this.onEvent = this.onEvent.bind(this);
                  for (var Io = arguments.length, Ri = new Array(Io > 1 ? Io - 1 : 0), qi = 1; qi < Io; qi++)
                    Ri[qi - 1] = arguments[qi];
                  this.handledEvents = Ri, this.useGenericHandler = !0, this.registerListeners();
                }
                var ma = Sa.prototype;
                return ma.destroy = function() {
                  this.onHandlerDestroying(), this.unregisterListeners(), this.onHandlerDestroyed();
                }, ma.onHandlerDestroying = function() {
                }, ma.onHandlerDestroyed = function() {
                }, ma.isEventHandler = function() {
                  return typeof this.handledEvents == "object" && this.handledEvents.length && typeof this.onEvent == "function";
                }, ma.registerListeners = function() {
                  this.isEventHandler() && this.handledEvents.forEach(function(Io) {
                    if (fi[Io])
                      throw new Error("Forbidden event-name: " + Io);
                    this.hls.on(Io, this.onEvent);
                  }, this);
                }, ma.unregisterListeners = function() {
                  this.isEventHandler() && this.handledEvents.forEach(function(Io) {
                    this.hls.off(Io, this.onEvent);
                  }, this);
                }, ma.onEvent = function(Io, Ri) {
                  this.onEventGeneric(Io, Ri);
                }, ma.onEventGeneric = function(Io, Ri) {
                  var qi = function(ba, Na) {
                    var Ma = "on" + ba.replace("hls", "");
                    if (typeof this[Ma] != "function")
                      throw new Error("Event " + ba + " has no generic handler in this " + this.constructor.name + " class (tried " + Ma + ")");
                    return this[Ma].bind(this, Na);
                  };
                  try {
                    qi.call(this, Io, Ri).call();
                  } catch (Yo) {
                    di.logger.error("An internal error happened while handling event " + Io + '. Error message: "' + Yo.message + '". Here is a stacktrace:', Yo), this.hls.trigger(si.default.ERROR, {
                      type: li.ErrorTypes.OTHER_ERROR,
                      details: li.ErrorDetails.INTERNAL_EXCEPTION,
                      fatal: !1,
                      event: Io,
                      err: Yo
                    });
                  }
                }, Sa;
              })(), mi = gi, Ti;
              (function(Sa) {
                Sa.MANIFEST = "manifest", Sa.LEVEL = "level", Sa.AUDIO_TRACK = "audioTrack", Sa.SUBTITLE_TRACK = "subtitleTrack";
              })(Ti || (Ti = {}));
              var vi;
              (function(Sa) {
                Sa.MAIN = "main", Sa.AUDIO = "audio", Sa.SUBTITLE = "subtitle";
              })(vi || (vi = {}));
              var xi = ii("./src/demux/mp4demuxer.js");
              function Si(Sa, ma) {
                for (var Ho = 0; Ho < ma.length; Ho++) {
                  var Io = ma[Ho];
                  Io.enumerable = Io.enumerable || !1, Io.configurable = !0, "value" in Io && (Io.writable = !0), Object.defineProperty(Sa, Io.key, Io);
                }
              }
              function Pi(Sa, ma, Ho) {
                return ma && Si(Sa.prototype, ma), Sa;
              }
              var $i = /* @__PURE__ */ (function() {
                function Sa(ma, Ho) {
                  this._uri = null, this.baseuri = void 0, this.reluri = void 0, this.method = null, this.key = null, this.iv = null, this.baseuri = ma, this.reluri = Ho;
                }
                return Pi(Sa, [{
                  key: "uri",
                  get: function() {
                    return !this._uri && this.reluri && (this._uri = Object(ai.buildAbsoluteURL)(this.baseuri, this.reluri, {
                      alwaysNormalize: !0
                    })), this._uri;
                  }
                }]), Sa;
              })();
              function Oi(Sa, ma) {
                for (var Ho = 0; Ho < ma.length; Ho++) {
                  var Io = ma[Ho];
                  Io.enumerable = Io.enumerable || !1, Io.configurable = !0, "value" in Io && (Io.writable = !0), Object.defineProperty(Sa, Io.key, Io);
                }
              }
              function Di(Sa, ma, Ho) {
                return ma && Oi(Sa.prototype, ma), Sa;
              }
              var Mi;
              (function(Sa) {
                Sa.AUDIO = "audio", Sa.VIDEO = "video";
              })(Mi || (Mi = {}));
              var Oo = /* @__PURE__ */ (function() {
                function Sa() {
                  var Ho;
                  this._url = null, this._byteRange = null, this._decryptdata = null, this._elementaryStreams = (Ho = {}, Ho[Mi.AUDIO] = !1, Ho[Mi.VIDEO] = !1, Ho), this.deltaPTS = 0, this.rawProgramDateTime = null, this.programDateTime = null, this.title = null, this.tagList = [], this.cc = void 0, this.type = void 0, this.relurl = void 0, this.baseurl = void 0, this.duration = void 0, this.start = void 0, this.sn = 0, this.urlId = 0, this.level = 0, this.levelkey = void 0, this.loader = void 0;
                }
                var ma = Sa.prototype;
                return ma.setByteRange = function(Io, Ri) {
                  var qi = Io.split("@", 2), Yo = [];
                  qi.length === 1 ? Yo[0] = Ri ? Ri.byteRangeEndOffset : 0 : Yo[0] = parseInt(qi[1]), Yo[1] = parseInt(qi[0]) + Yo[0], this._byteRange = Yo;
                }, ma.addElementaryStream = function(Io) {
                  this._elementaryStreams[Io] = !0;
                }, ma.hasElementaryStream = function(Io) {
                  return this._elementaryStreams[Io] === !0;
                }, ma.createInitializationVector = function(Io) {
                  for (var Ri = new Uint8Array(16), qi = 12; qi < 16; qi++)
                    Ri[qi] = Io >> 8 * (15 - qi) & 255;
                  return Ri;
                }, ma.setDecryptDataFromLevelKey = function(Io, Ri) {
                  var qi = Io;
                  return Io != null && Io.method && Io.uri && !Io.iv && (qi = new $i(Io.baseuri, Io.reluri), qi.method = Io.method, qi.iv = this.createInitializationVector(Ri)), qi;
                }, Di(Sa, [{
                  key: "url",
                  get: function() {
                    return !this._url && this.relurl && (this._url = Object(ai.buildAbsoluteURL)(this.baseurl, this.relurl, {
                      alwaysNormalize: !0
                    })), this._url;
                  },
                  set: function(Io) {
                    this._url = Io;
                  }
                }, {
                  key: "byteRange",
                  get: function() {
                    return this._byteRange ? this._byteRange : [];
                  }
                  /**
                   * @type {number}
                   */
                }, {
                  key: "byteRangeStartOffset",
                  get: function() {
                    return this.byteRange[0];
                  }
                }, {
                  key: "byteRangeEndOffset",
                  get: function() {
                    return this.byteRange[1];
                  }
                }, {
                  key: "decryptdata",
                  get: function() {
                    if (!this.levelkey && !this._decryptdata)
                      return null;
                    if (!this._decryptdata && this.levelkey) {
                      var Io = this.sn;
                      typeof Io != "number" && (this.levelkey && this.levelkey.method === "AES-128" && !this.levelkey.iv && di.logger.warn('missing IV for initialization segment with method="' + this.levelkey.method + '" - compliance issue'), Io = 0), this._decryptdata = this.setDecryptDataFromLevelKey(this.levelkey, Io);
                    }
                    return this._decryptdata;
                  }
                }, {
                  key: "endProgramDateTime",
                  get: function() {
                    if (this.programDateTime === null || !Object(oi.isFiniteNumber)(this.programDateTime))
                      return null;
                    var Io = Object(oi.isFiniteNumber)(this.duration) ? this.duration : 0;
                    return this.programDateTime + Io * 1e3;
                  }
                }, {
                  key: "encrypted",
                  get: function() {
                    return !!(this.decryptdata && this.decryptdata.uri !== null && this.decryptdata.key === null);
                  }
                }]), Sa;
              })();
              function io(Sa, ma) {
                for (var Ho = 0; Ho < ma.length; Ho++) {
                  var Io = ma[Ho];
                  Io.enumerable = Io.enumerable || !1, Io.configurable = !0, "value" in Io && (Io.writable = !0), Object.defineProperty(Sa, Io.key, Io);
                }
              }
              function xo(Sa, ma, Ho) {
                return ma && io(Sa.prototype, ma), Sa;
              }
              var fo = /* @__PURE__ */ (function() {
                function Sa(ma) {
                  this.endCC = 0, this.endSN = 0, this.fragments = [], this.initSegment = null, this.live = !0, this.needSidxRanges = !1, this.startCC = 0, this.startSN = 0, this.startTimeOffset = null, this.targetduration = 0, this.totalduration = 0, this.type = null, this.url = ma, this.version = null;
                }
                return xo(Sa, [{
                  key: "hasProgramDateTime",
                  get: function() {
                    return !!(this.fragments[0] && Object(oi.isFiniteNumber)(this.fragments[0].programDateTime));
                  }
                }]), Sa;
              })(), _o = /^(\d+)x(\d+)$/, Li = /\s*(.+?)\s*=((?:\".*?\")|.*?)(?:,|$)/g, Co = /* @__PURE__ */ (function() {
                function Sa(Ho) {
                  typeof Ho == "string" && (Ho = Sa.parseAttrList(Ho));
                  for (var Io in Ho)
                    Ho.hasOwnProperty(Io) && (this[Io] = Ho[Io]);
                }
                var ma = Sa.prototype;
                return ma.decimalInteger = function(Io) {
                  var Ri = parseInt(this[Io], 10);
                  return Ri > Number.MAX_SAFE_INTEGER ? 1 / 0 : Ri;
                }, ma.hexadecimalInteger = function(Io) {
                  if (this[Io]) {
                    var Ri = (this[Io] || "0x").slice(2);
                    Ri = (Ri.length & 1 ? "0" : "") + Ri;
                    for (var qi = new Uint8Array(Ri.length / 2), Yo = 0; Yo < Ri.length / 2; Yo++)
                      qi[Yo] = parseInt(Ri.slice(Yo * 2, Yo * 2 + 2), 16);
                    return qi;
                  } else
                    return null;
                }, ma.hexadecimalIntegerAsNumber = function(Io) {
                  var Ri = parseInt(this[Io], 16);
                  return Ri > Number.MAX_SAFE_INTEGER ? 1 / 0 : Ri;
                }, ma.decimalFloatingPoint = function(Io) {
                  return parseFloat(this[Io]);
                }, ma.enumeratedString = function(Io) {
                  return this[Io];
                }, ma.decimalResolution = function(Io) {
                  var Ri = _o.exec(this[Io]);
                  if (Ri !== null)
                    return {
                      width: parseInt(Ri[1], 10),
                      height: parseInt(Ri[2], 10)
                    };
                }, Sa.parseAttrList = function(Io) {
                  var Ri, qi = {};
                  for (Li.lastIndex = 0; (Ri = Li.exec(Io)) !== null; ) {
                    var Yo = Ri[2], ba = '"';
                    Yo.indexOf(ba) === 0 && Yo.lastIndexOf(ba) === Yo.length - 1 && (Yo = Yo.slice(1, -1)), qi[Ri[1]] = Yo;
                  }
                  return qi;
                }, Sa;
              })(), Ni = Co, Yi = {
                audio: {
                  a3ds: !0,
                  "ac-3": !0,
                  "ac-4": !0,
                  alac: !0,
                  alaw: !0,
                  dra1: !0,
                  "dts+": !0,
                  "dts-": !0,
                  dtsc: !0,
                  dtse: !0,
                  dtsh: !0,
                  "ec-3": !0,
                  enca: !0,
                  g719: !0,
                  g726: !0,
                  m4ae: !0,
                  mha1: !0,
                  mha2: !0,
                  mhm1: !0,
                  mhm2: !0,
                  mlpa: !0,
                  mp4a: !0,
                  "raw ": !0,
                  Opus: !0,
                  samr: !0,
                  sawb: !0,
                  sawp: !0,
                  sevc: !0,
                  sqcp: !0,
                  ssmv: !0,
                  twos: !0,
                  ulaw: !0
                },
                video: {
                  avc1: !0,
                  avc2: !0,
                  avc3: !0,
                  avc4: !0,
                  avcp: !0,
                  drac: !0,
                  dvav: !0,
                  dvhe: !0,
                  encv: !0,
                  hev1: !0,
                  hvc1: !0,
                  mjp2: !0,
                  mp4v: !0,
                  mvc1: !0,
                  mvc2: !0,
                  mvc3: !0,
                  mvc4: !0,
                  resv: !0,
                  rv60: !0,
                  s263: !0,
                  svc1: !0,
                  svc2: !0,
                  "vc-1": !0,
                  vp08: !0,
                  vp09: !0
                }
              };
              function Vo(Sa, ma) {
                var Ho = Yi[ma];
                return !!Ho && Ho[Sa.slice(0, 4)] === !0;
              }
              function No(Sa, ma) {
                return MediaSource.isTypeSupported((ma || "video") + '/mp4;codecs="' + Sa + '"');
              }
              var Ui = /(?:#EXT-X-STREAM-INF:([^\n\r]*)[\r\n]+([^\r\n]+)|#EXT-X-SESSION-DATA:([^\n\r]*)[\r\n]+)/g, jo = /#EXT-X-MEDIA:(.*)/g, Wi = new RegExp([
                /#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,
                // duration (#EXTINF:<duration>,<title>), group 1 => duration, group 2 => title
                /|(?!#)([\S+ ?]+)/.source,
                // segment URI, group 3 => the URI (note newline is not eaten)
                /|#EXT-X-BYTERANGE:*(.+)/.source,
                // next segment's byterange, group 4 => range spec (x@y)
                /|#EXT-X-PROGRAM-DATE-TIME:(.+)/.source,
                // next segment's program date/time group 5 => the datetime spec
                /|#.*/.source
                // All other non-segment oriented tags will match with all groups empty
              ].join(""), "g"), ji = /(?:(?:#(EXTM3U))|(?:#EXT-X-(PLAYLIST-TYPE):(.+))|(?:#EXT-X-(MEDIA-SEQUENCE): *(\d+))|(?:#EXT-X-(TARGETDURATION): *(\d+))|(?:#EXT-X-(KEY):(.+))|(?:#EXT-X-(START):(.+))|(?:#EXT-X-(ENDLIST))|(?:#EXT-X-(DISCONTINUITY-SEQ)UENCE:(\d+))|(?:#EXT-X-(DIS)CONTINUITY))|(?:#EXT-X-(VERSION):(\d+))|(?:#EXT-X-(MAP):(.+))|(?:(#)([^:]*):(.*))|(?:(#)(.*))(?:.*)\r?\n?/, Hi = /\.(mp4|m4s|m4v|m4a)$/i, zo = /* @__PURE__ */ (function() {
                function Sa() {
                }
                return Sa.findGroup = function(Ho, Io) {
                  for (var Ri = 0; Ri < Ho.length; Ri++) {
                    var qi = Ho[Ri];
                    if (qi.id === Io)
                      return qi;
                  }
                }, Sa.convertAVC1ToAVCOTI = function(Ho) {
                  var Io = Ho.split("."), Ri;
                  return Io.length > 2 ? (Ri = Io.shift() + ".", Ri += parseInt(Io.shift()).toString(16), Ri += ("000" + parseInt(Io.shift()).toString(16)).substr(-4)) : Ri = Ho, Ri;
                }, Sa.resolve = function(Ho, Io) {
                  return ai.buildAbsoluteURL(Io, Ho, {
                    alwaysNormalize: !0
                  });
                }, Sa.parseMasterPlaylist = function(Ho, Io) {
                  var Ri = [], qi = {}, Yo = !1;
                  Ui.lastIndex = 0;
                  function ba(_l, Ll) {
                    ["video", "audio"].forEach(function(eu) {
                      var fu = _l.filter(function(Ou) {
                        return Vo(Ou, eu);
                      });
                      if (fu.length) {
                        var Fu = fu.filter(function(Ou) {
                          return Ou.lastIndexOf("avc1", 0) === 0 || Ou.lastIndexOf("mp4a", 0) === 0;
                        });
                        Ll[eu + "Codec"] = Fu.length > 0 ? Fu[0] : fu[0], _l = _l.filter(function(Ou) {
                          return fu.indexOf(Ou) === -1;
                        });
                      }
                    }), Ll.unknownCodecs = _l;
                  }
                  for (var Na; (Na = Ui.exec(Ho)) != null; )
                    if (Na[1]) {
                      var Ma = {}, bs = Ma.attrs = new Ni(Na[1]);
                      Ma.url = Sa.resolve(Na[2], Io);
                      var Ds = bs.decimalResolution("RESOLUTION");
                      Ds && (Ma.width = Ds.width, Ma.height = Ds.height), Ma.bitrate = bs.decimalInteger("AVERAGE-BANDWIDTH") || bs.decimalInteger("BANDWIDTH"), Ma.name = bs.NAME, ba([].concat((bs.CODECS || "").split(/[ ,]+/)), Ma), Ma.videoCodec && Ma.videoCodec.indexOf("avc1") !== -1 && (Ma.videoCodec = Sa.convertAVC1ToAVCOTI(Ma.videoCodec)), Ri.push(Ma);
                    } else if (Na[3]) {
                      var Fs = new Ni(Na[3]);
                      Fs["DATA-ID"] && (Yo = !0, qi[Fs["DATA-ID"]] = Fs);
                    }
                  return {
                    levels: Ri,
                    sessionData: Yo ? qi : null
                  };
                }, Sa.parseMasterPlaylistMedia = function(Ho, Io, Ri, qi) {
                  qi === void 0 && (qi = []);
                  var Yo, ba = [], Na = 0;
                  for (jo.lastIndex = 0; (Yo = jo.exec(Ho)) !== null; ) {
                    var Ma = new Ni(Yo[1]);
                    if (Ma.TYPE === Ri) {
                      var bs = {
                        attrs: Ma,
                        id: Na++,
                        groupId: Ma["GROUP-ID"],
                        instreamId: Ma["INSTREAM-ID"],
                        name: Ma.NAME || Ma.LANGUAGE,
                        type: Ri,
                        default: Ma.DEFAULT === "YES",
                        autoselect: Ma.AUTOSELECT === "YES",
                        forced: Ma.FORCED === "YES",
                        lang: Ma.LANGUAGE
                      };
                      if (Ma.URI && (bs.url = Sa.resolve(Ma.URI, Io)), qi.length) {
                        var Ds = Sa.findGroup(qi, bs.groupId);
                        bs.audioCodec = Ds ? Ds.codec : qi[0].codec;
                      }
                      ba.push(bs);
                    }
                  }
                  return ba;
                }, Sa.parseLevelPlaylist = function(Ho, Io, Ri, qi, Yo) {
                  var ba = 0, Na = 0, Ma = new fo(Io), bs = 0, Ds = null, Fs = new Oo(), _l, Ll, eu, fu = null;
                  for (Wi.lastIndex = 0; (_l = Wi.exec(Ho)) !== null; ) {
                    var Fu = _l[1];
                    if (Fu) {
                      Fs.duration = parseFloat(Fu);
                      var Ou = (" " + _l[2]).slice(1);
                      Fs.title = Ou || null, Fs.tagList.push(Ou ? ["INF", Fu, Ou] : ["INF", Fu]);
                    } else if (_l[3]) {
                      if (Object(oi.isFiniteNumber)(Fs.duration)) {
                        var qu = ba++;
                        Fs.type = qi, Fs.start = Na, eu && (Fs.levelkey = eu), Fs.sn = qu, Fs.level = Ri, Fs.cc = bs, Fs.urlId = Yo, Fs.baseurl = Io, Fs.relurl = (" " + _l[3]).slice(1), sa(Fs, Ds), Ma.fragments.push(Fs), Ds = Fs, Na += Fs.duration, Fs = new Oo();
                      }
                    } else if (_l[4]) {
                      var Ju = (" " + _l[4]).slice(1);
                      Ds ? Fs.setByteRange(Ju, Ds) : Fs.setByteRange(Ju);
                    } else if (_l[5])
                      Fs.rawProgramDateTime = (" " + _l[5]).slice(1), Fs.tagList.push(["PROGRAM-DATE-TIME", Fs.rawProgramDateTime]), fu === null && (fu = Ma.fragments.length);
                    else {
                      if (_l = _l[0].match(ji), !_l) {
                        di.logger.warn("No matches on slow regex match for level playlist!");
                        continue;
                      }
                      for (Ll = 1; Ll < _l.length && !(typeof _l[Ll] < "u"); Ll++)
                        ;
                      var nc = (" " + _l[Ll + 1]).slice(1), $c = (" " + _l[Ll + 2]).slice(1);
                      switch (_l[Ll]) {
                        case "#":
                          Fs.tagList.push($c ? [nc, $c] : [nc]);
                          break;
                        case "PLAYLIST-TYPE":
                          Ma.type = nc.toUpperCase();
                          break;
                        case "MEDIA-SEQUENCE":
                          ba = Ma.startSN = parseInt(nc);
                          break;
                        case "TARGETDURATION":
                          Ma.targetduration = parseFloat(nc);
                          break;
                        case "VERSION":
                          Ma.version = parseInt(nc);
                          break;
                        case "EXTM3U":
                          break;
                        case "ENDLIST":
                          Ma.live = !1;
                          break;
                        case "DIS":
                          bs++, Fs.tagList.push(["DIS"]);
                          break;
                        case "DISCONTINUITY-SEQ":
                          bs = parseInt(nc);
                          break;
                        case "KEY": {
                          var Rc = nc, xc = new Ni(Rc), vd = xc.enumeratedString("METHOD"), zu = xc.URI, ic = xc.hexadecimalInteger("IV"), Fc = xc.KEYFORMAT || "identity";
                          if (Fc === "com.apple.streamingkeydelivery") {
                            di.logger.warn("Keyformat com.apple.streamingkeydelivery is not supported");
                            continue;
                          }
                          vd && (eu = new $i(Io, zu), zu && ["AES-128", "SAMPLE-AES", "SAMPLE-AES-CENC"].indexOf(vd) >= 0 && (eu.method = vd, eu.key = null, eu.iv = ic));
                          break;
                        }
                        case "START": {
                          var kd = new Ni(nc), tf = kd.decimalFloatingPoint("TIME-OFFSET");
                          Object(oi.isFiniteNumber)(tf) && (Ma.startTimeOffset = tf);
                          break;
                        }
                        case "MAP": {
                          var Ad = new Ni(nc);
                          Fs.relurl = Ad.URI, Ad.BYTERANGE && Fs.setByteRange(Ad.BYTERANGE), Fs.baseurl = Io, Fs.level = Ri, Fs.type = qi, Fs.sn = "initSegment", Ma.initSegment = Fs, Fs = new Oo(), Fs.rawProgramDateTime = Ma.initSegment.rawProgramDateTime;
                          break;
                        }
                        default:
                          di.logger.warn("line parsed but not handled: " + _l);
                          break;
                      }
                    }
                  }
                  return Fs = Ds, Fs && !Fs.relurl && (Ma.fragments.pop(), Na -= Fs.duration), Ma.totalduration = Na, Ma.averagetargetduration = Na / Ma.fragments.length, Ma.endSN = ba - 1, Ma.startCC = Ma.fragments[0] ? Ma.fragments[0].cc : 0, Ma.endCC = bs, !Ma.initSegment && Ma.fragments.length && Ma.fragments.every(function(Ip) {
                    return Hi.test(Ip.relurl);
                  }) && (di.logger.warn("MP4 fragments found but no init segment (probably no MAP, incomplete M3U8), trying to fetch SIDX"), Fs = new Oo(), Fs.relurl = Ma.fragments[0].relurl, Fs.baseurl = Io, Fs.level = Ri, Fs.type = qi, Fs.sn = "initSegment", Ma.initSegment = Fs, Ma.needSidxRanges = !0), fu && Lo(Ma.fragments, fu), Ma;
                }, Sa;
              })();
              function Lo(Sa, ma) {
                for (var Ho = Sa[ma], Io = ma - 1; Io >= 0; Io--) {
                  var Ri = Sa[Io];
                  Ri.programDateTime = Ho.programDateTime - Ri.duration * 1e3, Ho = Ri;
                }
              }
              function sa(Sa, ma) {
                Sa.rawProgramDateTime ? Sa.programDateTime = Date.parse(Sa.rawProgramDateTime) : ma != null && ma.programDateTime && (Sa.programDateTime = ma.endProgramDateTime), Object(oi.isFiniteNumber)(Sa.programDateTime) || (Sa.programDateTime = null, Sa.rawProgramDateTime = null);
              }
              function Ko(Sa, ma) {
                Sa.prototype = Object.create(ma.prototype), Sa.prototype.constructor = Sa, Sa.__proto__ = ma;
              }
              var ca = window, pa = ca.performance, ga = /* @__PURE__ */ (function(Sa) {
                Ko(ma, Sa);
                function ma(Io) {
                  var Ri;
                  return Ri = Sa.call(this, Io, si.default.MANIFEST_LOADING, si.default.LEVEL_LOADING, si.default.AUDIO_TRACK_LOADING, si.default.SUBTITLE_TRACK_LOADING) || this, Ri.loaders = {}, Ri;
                }
                ma.canHaveQualityLevels = function(Ri) {
                  return Ri !== Ti.AUDIO_TRACK && Ri !== Ti.SUBTITLE_TRACK;
                }, ma.mapContextToLevelType = function(Ri) {
                  var qi = Ri.type;
                  switch (qi) {
                    case Ti.AUDIO_TRACK:
                      return vi.AUDIO;
                    case Ti.SUBTITLE_TRACK:
                      return vi.SUBTITLE;
                    default:
                      return vi.MAIN;
                  }
                }, ma.getResponseUrl = function(Ri, qi) {
                  var Yo = Ri.url;
                  return (Yo === void 0 || Yo.indexOf("data:") === 0) && (Yo = qi.url), Yo;
                };
                var Ho = ma.prototype;
                return Ho.createInternalLoader = function(Ri) {
                  var qi = this.hls.config, Yo = qi.pLoader, ba = qi.loader, Na = Yo || ba, Ma = new Na(qi);
                  return Ri.loader = Ma, this.loaders[Ri.type] = Ma, Ma;
                }, Ho.getInternalLoader = function(Ri) {
                  return this.loaders[Ri.type];
                }, Ho.resetInternalLoader = function(Ri) {
                  this.loaders[Ri] && delete this.loaders[Ri];
                }, Ho.destroyInternalLoaders = function() {
                  for (var Ri in this.loaders) {
                    var qi = this.loaders[Ri];
                    qi && qi.destroy(), this.resetInternalLoader(Ri);
                  }
                }, Ho.destroy = function() {
                  this.destroyInternalLoaders(), Sa.prototype.destroy.call(this);
                }, Ho.onManifestLoading = function(Ri) {
                  this.load({
                    url: Ri.url,
                    type: Ti.MANIFEST,
                    level: 0,
                    id: null,
                    responseType: "text"
                  });
                }, Ho.onLevelLoading = function(Ri) {
                  this.load({
                    url: Ri.url,
                    type: Ti.LEVEL,
                    level: Ri.level,
                    id: Ri.id,
                    responseType: "text"
                  });
                }, Ho.onAudioTrackLoading = function(Ri) {
                  this.load({
                    url: Ri.url,
                    type: Ti.AUDIO_TRACK,
                    level: null,
                    id: Ri.id,
                    responseType: "text"
                  });
                }, Ho.onSubtitleTrackLoading = function(Ri) {
                  this.load({
                    url: Ri.url,
                    type: Ti.SUBTITLE_TRACK,
                    level: null,
                    id: Ri.id,
                    responseType: "text"
                  });
                }, Ho.load = function(Ri) {
                  var qi = this.hls.config;
                  di.logger.debug("Loading playlist of type " + Ri.type + ", level: " + Ri.level + ", id: " + Ri.id);
                  var Yo = this.getInternalLoader(Ri);
                  if (Yo) {
                    var ba = Yo.context;
                    if (ba && ba.url === Ri.url)
                      return di.logger.trace("playlist request ongoing"), !1;
                    di.logger.warn("aborting previous loader for type: " + Ri.type), Yo.abort();
                  }
                  var Na, Ma, bs, Ds;
                  switch (Ri.type) {
                    case Ti.MANIFEST:
                      Na = qi.manifestLoadingMaxRetry, Ma = qi.manifestLoadingTimeOut, bs = qi.manifestLoadingRetryDelay, Ds = qi.manifestLoadingMaxRetryTimeout;
                      break;
                    case Ti.LEVEL:
                      Na = 0, Ds = 0, bs = 0, Ma = qi.levelLoadingTimeOut;
                      break;
                    default:
                      Na = qi.levelLoadingMaxRetry, Ma = qi.levelLoadingTimeOut, bs = qi.levelLoadingRetryDelay, Ds = qi.levelLoadingMaxRetryTimeout;
                      break;
                  }
                  Yo = this.createInternalLoader(Ri);
                  var Fs = {
                    timeout: Ma,
                    maxRetry: Na,
                    retryDelay: bs,
                    maxRetryDelay: Ds
                  }, _l = {
                    onSuccess: this.loadsuccess.bind(this),
                    onError: this.loaderror.bind(this),
                    onTimeout: this.loadtimeout.bind(this)
                  };
                  return di.logger.debug("Calling internal loader delegate for URL: " + Ri.url), Yo.load(Ri, Fs, _l), !0;
                }, Ho.loadsuccess = function(Ri, qi, Yo, ba) {
                  if (ba === void 0 && (ba = null), Yo.isSidxRequest) {
                    this._handleSidxRequest(Ri, Yo), this._handlePlaylistLoaded(Ri, qi, Yo, ba);
                    return;
                  }
                  if (this.resetInternalLoader(Yo.type), typeof Ri.data != "string")
                    throw new Error('expected responseType of "text" for PlaylistLoader');
                  var Na = Ri.data;
                  if (qi.tload = pa.now(), Na.indexOf("#EXTM3U") !== 0) {
                    this._handleManifestParsingError(Ri, Yo, "no EXTM3U delimiter", ba);
                    return;
                  }
                  Na.indexOf("#EXTINF:") > 0 || Na.indexOf("#EXT-X-TARGETDURATION:") > 0 ? this._handleTrackOrLevelPlaylist(Ri, qi, Yo, ba) : this._handleMasterPlaylist(Ri, qi, Yo, ba);
                }, Ho.loaderror = function(Ri, qi, Yo) {
                  Yo === void 0 && (Yo = null), this._handleNetworkError(qi, Yo, !1, Ri);
                }, Ho.loadtimeout = function(Ri, qi, Yo) {
                  Yo === void 0 && (Yo = null), this._handleNetworkError(qi, Yo, !0);
                }, Ho._handleMasterPlaylist = function(Ri, qi, Yo, ba) {
                  var Na = this.hls, Ma = Ri.data, bs = ma.getResponseUrl(Ri, Yo), Ds = zo.parseMasterPlaylist(Ma, bs), Fs = Ds.levels, _l = Ds.sessionData;
                  if (!Fs.length) {
                    this._handleManifestParsingError(Ri, Yo, "no level found in manifest", ba);
                    return;
                  }
                  var Ll = Fs.map(function(qu) {
                    return {
                      id: qu.attrs.AUDIO,
                      codec: qu.audioCodec
                    };
                  }), eu = zo.parseMasterPlaylistMedia(Ma, bs, "AUDIO", Ll), fu = zo.parseMasterPlaylistMedia(Ma, bs, "SUBTITLES"), Fu = zo.parseMasterPlaylistMedia(Ma, bs, "CLOSED-CAPTIONS");
                  if (eu.length) {
                    var Ou = !1;
                    eu.forEach(function(qu) {
                      qu.url || (Ou = !0);
                    }), Ou === !1 && Fs[0].audioCodec && !Fs[0].attrs.AUDIO && (di.logger.log("audio codec signaled in quality level, but no embedded audio track signaled, create one"), eu.unshift({
                      type: "main",
                      name: "main",
                      default: !1,
                      autoselect: !1,
                      forced: !1,
                      id: -1,
                      attrs: {},
                      url: ""
                    }));
                  }
                  Na.trigger(si.default.MANIFEST_LOADED, {
                    levels: Fs,
                    audioTracks: eu,
                    subtitles: fu,
                    captions: Fu,
                    url: bs,
                    stats: qi,
                    networkDetails: ba,
                    sessionData: _l
                  });
                }, Ho._handleTrackOrLevelPlaylist = function(Ri, qi, Yo, ba) {
                  var Na = this.hls, Ma = Yo.id, bs = Yo.level, Ds = Yo.type, Fs = ma.getResponseUrl(Ri, Yo), _l = Object(oi.isFiniteNumber)(Ma) ? Ma : 0, Ll = Object(oi.isFiniteNumber)(bs) ? bs : _l, eu = ma.mapContextToLevelType(Yo), fu = zo.parseLevelPlaylist(Ri.data, Fs, Ll, eu, _l);
                  if (fu.tload = qi.tload, !fu.fragments.length) {
                    Na.trigger(si.default.ERROR, {
                      type: li.ErrorTypes.NETWORK_ERROR,
                      details: li.ErrorDetails.LEVEL_EMPTY_ERROR,
                      fatal: !1,
                      url: Fs,
                      reason: "no fragments found in level",
                      level: typeof Yo.level == "number" ? Yo.level : void 0
                    });
                    return;
                  }
                  if (Ds === Ti.MANIFEST) {
                    var Fu = {
                      url: Fs,
                      details: fu
                    };
                    Na.trigger(si.default.MANIFEST_LOADED, {
                      levels: [Fu],
                      audioTracks: [],
                      url: Fs,
                      stats: qi,
                      networkDetails: ba,
                      sessionData: null
                    });
                  }
                  if (qi.tparsed = pa.now(), fu.needSidxRanges) {
                    var Ou = fu.initSegment.url;
                    this.load({
                      url: Ou,
                      isSidxRequest: !0,
                      type: Ds,
                      level: bs,
                      levelDetails: fu,
                      id: Ma,
                      rangeStart: 0,
                      rangeEnd: 2048,
                      responseType: "arraybuffer"
                    });
                    return;
                  }
                  Yo.levelDetails = fu, this._handlePlaylistLoaded(Ri, qi, Yo, ba);
                }, Ho._handleSidxRequest = function(Ri, qi) {
                  if (typeof Ri.data == "string")
                    throw new Error("sidx request must be made with responseType of array buffer");
                  var Yo = xi.default.parseSegmentIndex(new Uint8Array(Ri.data));
                  if (Yo) {
                    var ba = Yo.references, Na = qi.levelDetails;
                    ba.forEach(function(Ma, bs) {
                      var Ds = Ma.info;
                      if (Na) {
                        var Fs = Na.fragments[bs];
                        Fs.byteRange.length === 0 && Fs.setByteRange(String(1 + Ds.end - Ds.start) + "@" + String(Ds.start));
                      }
                    }), Na && Na.initSegment.setByteRange(String(Yo.moovEndOffset) + "@0");
                  }
                }, Ho._handleManifestParsingError = function(Ri, qi, Yo, ba) {
                  this.hls.trigger(si.default.ERROR, {
                    type: li.ErrorTypes.NETWORK_ERROR,
                    details: li.ErrorDetails.MANIFEST_PARSING_ERROR,
                    fatal: !0,
                    url: Ri.url,
                    reason: Yo,
                    networkDetails: ba
                  });
                }, Ho._handleNetworkError = function(Ri, qi, Yo, ba) {
                  Yo === void 0 && (Yo = !1), ba === void 0 && (ba = null), di.logger.info("A network error occured while loading a " + Ri.type + "-type playlist");
                  var Na, Ma, bs = this.getInternalLoader(Ri);
                  switch (Ri.type) {
                    case Ti.MANIFEST:
                      Na = Yo ? li.ErrorDetails.MANIFEST_LOAD_TIMEOUT : li.ErrorDetails.MANIFEST_LOAD_ERROR, Ma = !0;
                      break;
                    case Ti.LEVEL:
                      Na = Yo ? li.ErrorDetails.LEVEL_LOAD_TIMEOUT : li.ErrorDetails.LEVEL_LOAD_ERROR, Ma = !1;
                      break;
                    case Ti.AUDIO_TRACK:
                      Na = Yo ? li.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT : li.ErrorDetails.AUDIO_TRACK_LOAD_ERROR, Ma = !1;
                      break;
                    default:
                      Ma = !1;
                  }
                  bs && (bs.abort(), this.resetInternalLoader(Ri.type));
                  var Ds = {
                    type: li.ErrorTypes.NETWORK_ERROR,
                    details: Na,
                    fatal: Ma,
                    url: Ri.url,
                    loader: bs,
                    context: Ri,
                    networkDetails: qi
                  };
                  ba && (Ds.response = ba), this.hls.trigger(si.default.ERROR, Ds);
                }, Ho._handlePlaylistLoaded = function(Ri, qi, Yo, ba) {
                  var Na = Yo.type, Ma = Yo.level, bs = Yo.id, Ds = Yo.levelDetails;
                  if (!Ds || !Ds.targetduration) {
                    this._handleManifestParsingError(Ri, Yo, "invalid target duration", ba);
                    return;
                  }
                  var Fs = ma.canHaveQualityLevels(Yo.type);
                  if (Fs)
                    this.hls.trigger(si.default.LEVEL_LOADED, {
                      details: Ds,
                      level: Ma || 0,
                      id: bs || 0,
                      stats: qi,
                      networkDetails: ba
                    });
                  else
                    switch (Na) {
                      case Ti.AUDIO_TRACK:
                        this.hls.trigger(si.default.AUDIO_TRACK_LOADED, {
                          details: Ds,
                          id: bs,
                          stats: qi,
                          networkDetails: ba
                        });
                        break;
                      case Ti.SUBTITLE_TRACK:
                        this.hls.trigger(si.default.SUBTITLE_TRACK_LOADED, {
                          details: Ds,
                          id: bs,
                          stats: qi,
                          networkDetails: ba
                        });
                        break;
                    }
                }, ma;
              })(mi), ia = ga;
              function ra(Sa, ma) {
                Sa.prototype = Object.create(ma.prototype), Sa.prototype.constructor = Sa, Sa.__proto__ = ma;
              }
              var qo = /* @__PURE__ */ (function(Sa) {
                ra(ma, Sa);
                function ma(Io) {
                  var Ri;
                  return Ri = Sa.call(this, Io, si.default.FRAG_LOADING) || this, Ri.loaders = {}, Ri;
                }
                var Ho = ma.prototype;
                return Ho.destroy = function() {
                  var Ri = this.loaders;
                  for (var qi in Ri) {
                    var Yo = Ri[qi];
                    Yo && Yo.destroy();
                  }
                  this.loaders = {}, Sa.prototype.destroy.call(this);
                }, Ho.onFragLoading = function(Ri) {
                  var qi = Ri.frag, Yo = qi.type, ba = this.loaders, Na = this.hls.config, Ma = Na.fLoader, bs = Na.loader;
                  qi.loaded = 0;
                  var Ds = ba[Yo];
                  Ds && (di.logger.warn("abort previous fragment loader for type: " + Yo), Ds.abort()), Ds = ba[Yo] = qi.loader = Na.fLoader ? new Ma(Na) : new bs(Na);
                  var Fs, _l, Ll;
                  Fs = {
                    url: qi.url,
                    frag: qi,
                    responseType: "arraybuffer",
                    progressData: !1
                  };
                  var eu = qi.byteRangeStartOffset, fu = qi.byteRangeEndOffset;
                  Object(oi.isFiniteNumber)(eu) && Object(oi.isFiniteNumber)(fu) && (Fs.rangeStart = eu, Fs.rangeEnd = fu), _l = {
                    timeout: Na.fragLoadingTimeOut,
                    maxRetry: 0,
                    retryDelay: 0,
                    maxRetryDelay: Na.fragLoadingMaxRetryTimeout
                  }, Ll = {
                    onSuccess: this.loadsuccess.bind(this),
                    onError: this.loaderror.bind(this),
                    onTimeout: this.loadtimeout.bind(this),
                    onProgress: this.loadprogress.bind(this)
                  }, Ds.load(Fs, _l, Ll);
                }, Ho.loadsuccess = function(Ri, qi, Yo, ba) {
                  ba === void 0 && (ba = null);
                  var Na = Ri.data, Ma = Yo.frag;
                  Ma.loader = void 0, this.loaders[Ma.type] = void 0, this.hls.trigger(si.default.FRAG_LOADED, {
                    payload: Na,
                    frag: Ma,
                    stats: qi,
                    networkDetails: ba
                  });
                }, Ho.loaderror = function(Ri, qi, Yo) {
                  Yo === void 0 && (Yo = null);
                  var ba = qi.frag, Na = ba.loader;
                  Na && Na.abort(), this.loaders[ba.type] = void 0, this.hls.trigger(si.default.ERROR, {
                    type: li.ErrorTypes.NETWORK_ERROR,
                    details: li.ErrorDetails.FRAG_LOAD_ERROR,
                    fatal: !1,
                    frag: qi.frag,
                    response: Ri,
                    networkDetails: Yo
                  });
                }, Ho.loadtimeout = function(Ri, qi, Yo) {
                  Yo === void 0 && (Yo = null);
                  var ba = qi.frag, Na = ba.loader;
                  Na && Na.abort(), this.loaders[ba.type] = void 0, this.hls.trigger(si.default.ERROR, {
                    type: li.ErrorTypes.NETWORK_ERROR,
                    details: li.ErrorDetails.FRAG_LOAD_TIMEOUT,
                    fatal: !1,
                    frag: qi.frag,
                    networkDetails: Yo
                  });
                }, Ho.loadprogress = function(Ri, qi, Yo, ba) {
                  ba === void 0 && (ba = null);
                  var Na = qi.frag;
                  Na.loaded = Ri.loaded, this.hls.trigger(si.default.FRAG_LOAD_PROGRESS, {
                    frag: Na,
                    stats: Ri,
                    networkDetails: ba
                  });
                }, ma;
              })(mi), xa = qo;
              function $a(Sa, ma) {
                Sa.prototype = Object.create(ma.prototype), Sa.prototype.constructor = Sa, Sa.__proto__ = ma;
              }
              var ys = /* @__PURE__ */ (function(Sa) {
                $a(ma, Sa);
                function ma(Io) {
                  var Ri;
                  return Ri = Sa.call(this, Io, si.default.KEY_LOADING) || this, Ri.loaders = {}, Ri.decryptkey = null, Ri.decrypturl = null, Ri;
                }
                var Ho = ma.prototype;
                return Ho.destroy = function() {
                  for (var Ri in this.loaders) {
                    var qi = this.loaders[Ri];
                    qi && qi.destroy();
                  }
                  this.loaders = {}, Sa.prototype.destroy.call(this);
                }, Ho.onKeyLoading = function(Ri) {
                  var qi = Ri.frag, Yo = qi.type, ba = this.loaders[Yo];
                  if (!qi.decryptdata) {
                    di.logger.warn("Missing decryption data on fragment in onKeyLoading");
                    return;
                  }
                  var Na = qi.decryptdata.uri;
                  if (Na !== this.decrypturl || this.decryptkey === null) {
                    var Ma = this.hls.config;
                    if (ba && (di.logger.warn("abort previous key loader for type:" + Yo), ba.abort()), !Na) {
                      di.logger.warn("key uri is falsy");
                      return;
                    }
                    qi.loader = this.loaders[Yo] = new Ma.loader(Ma), this.decrypturl = Na, this.decryptkey = null;
                    var bs = {
                      url: Na,
                      frag: qi,
                      responseType: "arraybuffer"
                    }, Ds = {
                      timeout: Ma.fragLoadingTimeOut,
                      maxRetry: 0,
                      retryDelay: Ma.fragLoadingRetryDelay,
                      maxRetryDelay: Ma.fragLoadingMaxRetryTimeout
                    }, Fs = {
                      onSuccess: this.loadsuccess.bind(this),
                      onError: this.loaderror.bind(this),
                      onTimeout: this.loadtimeout.bind(this)
                    };
                    qi.loader.load(bs, Ds, Fs);
                  } else this.decryptkey && (qi.decryptdata.key = this.decryptkey, this.hls.trigger(si.default.KEY_LOADED, {
                    frag: qi
                  }));
                }, Ho.loadsuccess = function(Ri, qi, Yo) {
                  var ba = Yo.frag;
                  if (!ba.decryptdata) {
                    di.logger.error("after key load, decryptdata unset");
                    return;
                  }
                  this.decryptkey = ba.decryptdata.key = new Uint8Array(Ri.data), ba.loader = void 0, delete this.loaders[ba.type], this.hls.trigger(si.default.KEY_LOADED, {
                    frag: ba
                  });
                }, Ho.loaderror = function(Ri, qi) {
                  var Yo = qi.frag, ba = Yo.loader;
                  ba && ba.abort(), delete this.loaders[Yo.type], this.hls.trigger(si.default.ERROR, {
                    type: li.ErrorTypes.NETWORK_ERROR,
                    details: li.ErrorDetails.KEY_LOAD_ERROR,
                    fatal: !1,
                    frag: Yo,
                    response: Ri
                  });
                }, Ho.loadtimeout = function(Ri, qi) {
                  var Yo = qi.frag, ba = Yo.loader;
                  ba && ba.abort(), delete this.loaders[Yo.type], this.hls.trigger(si.default.ERROR, {
                    type: li.ErrorTypes.NETWORK_ERROR,
                    details: li.ErrorDetails.KEY_LOAD_TIMEOUT,
                    fatal: !1,
                    frag: Yo
                  });
                }, ma;
              })(mi), Ss = ys;
              function Xa(Sa, ma) {
                Sa.prototype = Object.create(ma.prototype), Sa.prototype.constructor = Sa, Sa.__proto__ = ma;
              }
              var Es = {
                NOT_LOADED: "NOT_LOADED",
                APPENDING: "APPENDING",
                PARTIAL: "PARTIAL",
                OK: "OK"
              }, Rs = /* @__PURE__ */ (function(Sa) {
                Xa(ma, Sa);
                function ma(Io) {
                  var Ri;
                  return Ri = Sa.call(this, Io, si.default.BUFFER_APPENDED, si.default.FRAG_BUFFERED, si.default.FRAG_LOADED) || this, Ri.bufferPadding = 0.2, Ri.fragments = /* @__PURE__ */ Object.create(null), Ri.timeRanges = /* @__PURE__ */ Object.create(null), Ri.config = Io.config, Ri;
                }
                var Ho = ma.prototype;
                return Ho.destroy = function() {
                  this.fragments = /* @__PURE__ */ Object.create(null), this.timeRanges = /* @__PURE__ */ Object.create(null), this.config = null, mi.prototype.destroy.call(this), Sa.prototype.destroy.call(this);
                }, Ho.getBufferedFrag = function(Ri, qi) {
                  var Yo = this.fragments, ba = Object.keys(Yo).filter(function(Ma) {
                    var bs = Yo[Ma];
                    if (bs.body.type !== qi || !bs.buffered)
                      return !1;
                    var Ds = bs.body;
                    return Ds.startPTS <= Ri && Ri <= Ds.endPTS;
                  });
                  if (ba.length === 0)
                    return null;
                  var Na = ba.pop();
                  return Yo[Na].body;
                }, Ho.detectEvictedFragments = function(Ri, qi) {
                  var Yo = this;
                  Object.keys(this.fragments).forEach(function(ba) {
                    var Na = Yo.fragments[ba];
                    if (!(!Na || !Na.buffered)) {
                      var Ma = Na.range[Ri];
                      if (Ma)
                        for (var bs = Ma.time, Ds = 0; Ds < bs.length; Ds++) {
                          var Fs = bs[Ds];
                          if (!Yo.isTimeBuffered(Fs.startPTS, Fs.endPTS, qi)) {
                            Yo.removeFragment(Na.body);
                            break;
                          }
                        }
                    }
                  });
                }, Ho.detectPartialFragments = function(Ri) {
                  var qi = this, Yo = this.getFragmentKey(Ri), ba = this.fragments[Yo];
                  ba && (ba.buffered = !0, Object.keys(this.timeRanges).forEach(function(Na) {
                    if (Ri.hasElementaryStream(Na)) {
                      var Ma = qi.timeRanges[Na];
                      ba.range[Na] = qi.getBufferedTimes(Ri.startPTS, Ri.endPTS, Ma);
                    }
                  }));
                }, Ho.getBufferedTimes = function(Ri, qi, Yo) {
                  for (var ba = [], Na, Ma, bs = !1, Ds = 0; Ds < Yo.length; Ds++)
                    if (Na = Yo.start(Ds) - this.bufferPadding, Ma = Yo.end(Ds) + this.bufferPadding, Ri >= Na && qi <= Ma) {
                      ba.push({
                        startPTS: Math.max(Ri, Yo.start(Ds)),
                        endPTS: Math.min(qi, Yo.end(Ds))
                      });
                      break;
                    } else if (Ri < Ma && qi > Na)
                      ba.push({
                        startPTS: Math.max(Ri, Yo.start(Ds)),
                        endPTS: Math.min(qi, Yo.end(Ds))
                      }), bs = !0;
                    else if (qi <= Na)
                      break;
                  return {
                    time: ba,
                    partial: bs
                  };
                }, Ho.getFragmentKey = function(Ri) {
                  return Ri.type + "_" + Ri.level + "_" + Ri.urlId + "_" + Ri.sn;
                }, Ho.getPartialFragment = function(Ri) {
                  var qi = this, Yo, ba, Na, Ma = null, bs = 0;
                  return Object.keys(this.fragments).forEach(function(Ds) {
                    var Fs = qi.fragments[Ds];
                    qi.isPartial(Fs) && (ba = Fs.body.startPTS - qi.bufferPadding, Na = Fs.body.endPTS + qi.bufferPadding, Ri >= ba && Ri <= Na && (Yo = Math.min(Ri - ba, Na - Ri), bs <= Yo && (Ma = Fs.body, bs = Yo)));
                  }), Ma;
                }, Ho.getState = function(Ri) {
                  var qi = this.getFragmentKey(Ri), Yo = this.fragments[qi], ba = Es.NOT_LOADED;
                  return Yo !== void 0 && (Yo.buffered ? this.isPartial(Yo) === !0 ? ba = Es.PARTIAL : ba = Es.OK : ba = Es.APPENDING), ba;
                }, Ho.isPartial = function(Ri) {
                  return Ri.buffered === !0 && (Ri.range.video !== void 0 && Ri.range.video.partial === !0 || Ri.range.audio !== void 0 && Ri.range.audio.partial === !0);
                }, Ho.isTimeBuffered = function(Ri, qi, Yo) {
                  for (var ba, Na, Ma = 0; Ma < Yo.length; Ma++) {
                    if (ba = Yo.start(Ma) - this.bufferPadding, Na = Yo.end(Ma) + this.bufferPadding, Ri >= ba && qi <= Na)
                      return !0;
                    if (qi <= ba)
                      return !1;
                  }
                  return !1;
                }, Ho.onFragLoaded = function(Ri) {
                  var qi = Ri.frag;
                  !Object(oi.isFiniteNumber)(qi.sn) || qi.bitrateTest || (this.fragments[this.getFragmentKey(qi)] = {
                    body: qi,
                    range: /* @__PURE__ */ Object.create(null),
                    buffered: !1
                  });
                }, Ho.onBufferAppended = function(Ri) {
                  var qi = this;
                  this.timeRanges = Ri.timeRanges, Object.keys(this.timeRanges).forEach(function(Yo) {
                    var ba = qi.timeRanges[Yo];
                    qi.detectEvictedFragments(Yo, ba);
                  });
                }, Ho.onFragBuffered = function(Ri) {
                  this.detectPartialFragments(Ri.frag);
                }, Ho.hasFragment = function(Ri) {
                  var qi = this.getFragmentKey(Ri);
                  return this.fragments[qi] !== void 0;
                }, Ho.removeFragment = function(Ri) {
                  var qi = this.getFragmentKey(Ri);
                  delete this.fragments[qi];
                }, Ho.removeAllFragments = function() {
                  this.fragments = /* @__PURE__ */ Object.create(null);
                }, ma;
              })(mi), La = {
                /**
                 * Searches for an item in an array which matches a certain condition.
                 * This requires the condition to only match one item in the array,
                 * and for the array to be ordered.
                 *
                 * @param {Array<T>} list The array to search.
                 * @param {BinarySearchComparison<T>} comparisonFn
                 *      Called and provided a candidate item as the first argument.
                 *      Should return:
                 *          > -1 if the item should be located at a lower index than the provided item.
                 *          > 1 if the item should be located at a higher index than the provided item.
                 *          > 0 if the item is the item you're looking for.
                 *
                 * @return {T | null} The object if it is found or null otherwise.
                 */
                search: function(ma, Ho) {
                  for (var Io = 0, Ri = ma.length - 1, qi = null, Yo = null; Io <= Ri; ) {
                    qi = (Io + Ri) / 2 | 0, Yo = ma[qi];
                    var ba = Ho(Yo);
                    if (ba > 0)
                      Io = qi + 1;
                    else if (ba < 0)
                      Ri = qi - 1;
                    else
                      return Yo;
                  }
                  return null;
                }
              }, Ja = La, ja = /* @__PURE__ */ (function() {
                function Sa() {
                }
                return Sa.isBuffered = function(Ho, Io) {
                  try {
                    if (Ho) {
                      for (var Ri = Ho.buffered, qi = 0; qi < Ri.length; qi++)
                        if (Io >= Ri.start(qi) && Io <= Ri.end(qi))
                          return !0;
                    }
                  } catch {
                  }
                  return !1;
                }, Sa.bufferInfo = function(Ho, Io, Ri) {
                  try {
                    if (Ho) {
                      var qi = Ho.buffered, Yo = [], ba;
                      for (ba = 0; ba < qi.length; ba++)
                        Yo.push({
                          start: qi.start(ba),
                          end: qi.end(ba)
                        });
                      return this.bufferedInfo(Yo, Io, Ri);
                    }
                  } catch {
                  }
                  return {
                    len: 0,
                    start: Io,
                    end: Io,
                    nextStart: void 0
                  };
                }, Sa.bufferedInfo = function(Ho, Io, Ri) {
                  Ho.sort(function(fu, Fu) {
                    var Ou = fu.start - Fu.start;
                    return Ou || Fu.end - fu.end;
                  });
                  var qi = [];
                  if (Ri)
                    for (var Yo = 0; Yo < Ho.length; Yo++) {
                      var ba = qi.length;
                      if (ba) {
                        var Na = qi[ba - 1].end;
                        Ho[Yo].start - Na < Ri ? Ho[Yo].end > Na && (qi[ba - 1].end = Ho[Yo].end) : qi.push(Ho[Yo]);
                      } else
                        qi.push(Ho[Yo]);
                    }
                  else
                    qi = Ho;
                  for (var Ma = 0, bs, Ds = Io, Fs = Io, _l = 0; _l < qi.length; _l++) {
                    var Ll = qi[_l].start, eu = qi[_l].end;
                    if (Io + Ri >= Ll && Io < eu)
                      Ds = Ll, Fs = eu, Ma = Fs - Io;
                    else if (Io + Ri < Ll) {
                      bs = Ll;
                      break;
                    }
                  }
                  return {
                    len: Ma,
                    start: Ds,
                    end: Fs,
                    nextStart: bs
                  };
                }, Sa;
              })(), Ta = ii("./node_modules/eventemitter3/index.js"), rs = ii("./node_modules/webworkify-webpack/index.js"), Qa = ii("./src/demux/demuxer-inline.js");
              function Cs() {
                return window.MediaSource || window.WebKitMediaSource;
              }
              var _a = ii("./src/utils/get-self-scope.js");
              function _s(Sa, ma) {
                Sa.prototype = Object.create(ma.prototype), Sa.prototype.constructor = Sa, Sa.__proto__ = ma;
              }
              var el = /* @__PURE__ */ (function(Sa) {
                _s(ma, Sa);
                function ma() {
                  return Sa.apply(this, arguments) || this;
                }
                var Ho = ma.prototype;
                return Ho.trigger = function(Ri) {
                  for (var qi = arguments.length, Yo = new Array(qi > 1 ? qi - 1 : 0), ba = 1; ba < qi; ba++)
                    Yo[ba - 1] = arguments[ba];
                  this.emit.apply(this, [Ri, Ri].concat(Yo));
                }, ma;
              })(Ta.EventEmitter), Ps = Object(_a.getSelfScope)(), nl = Cs() || {
                isTypeSupported: function() {
                  return !1;
                }
              }, Vs = /* @__PURE__ */ (function() {
                function Sa(Ho, Io) {
                  var Ri = this;
                  this.hls = Ho, this.id = Io;
                  var qi = this.observer = new el(), Yo = Ho.config, ba = function(Fs, _l) {
                    _l = _l || {}, _l.frag = Ri.frag, _l.id = Ri.id, Ho.trigger(Fs, _l);
                  };
                  qi.on(si.default.FRAG_DECRYPTED, ba), qi.on(si.default.FRAG_PARSING_INIT_SEGMENT, ba), qi.on(si.default.FRAG_PARSING_DATA, ba), qi.on(si.default.FRAG_PARSED, ba), qi.on(si.default.ERROR, ba), qi.on(si.default.FRAG_PARSING_METADATA, ba), qi.on(si.default.FRAG_PARSING_USERDATA, ba), qi.on(si.default.INIT_PTS_FOUND, ba);
                  var Na = {
                    mp4: nl.isTypeSupported("video/mp4"),
                    mpeg: nl.isTypeSupported("audio/mpeg"),
                    mp3: nl.isTypeSupported('audio/mp4; codecs="mp3"')
                  }, Ma = navigator.vendor;
                  if (Yo.enableWorker && typeof Worker < "u") {
                    di.logger.log("demuxing in webworker");
                    var bs;
                    try {
                      bs = this.w = rs(
                        /*require.resolve*/
                        /*! ../demux/demuxer-worker.js */
                        "./src/demux/demuxer-worker.js"
                      ), this.onwmsg = this.onWorkerMessage.bind(this), bs.addEventListener("message", this.onwmsg), bs.onerror = function(Ds) {
                        Ho.trigger(si.default.ERROR, {
                          type: li.ErrorTypes.OTHER_ERROR,
                          details: li.ErrorDetails.INTERNAL_EXCEPTION,
                          fatal: !0,
                          event: "demuxerWorker",
                          err: {
                            message: Ds.message + " (" + Ds.filename + ":" + Ds.lineno + ")"
                          }
                        });
                      }, bs.postMessage({
                        cmd: "init",
                        typeSupported: Na,
                        vendor: Ma,
                        id: Io,
                        config: JSON.stringify(Yo)
                      });
                    } catch (Ds) {
                      di.logger.warn("Error in worker:", Ds), di.logger.error("Error while initializing DemuxerWorker, fallback on DemuxerInline"), bs && Ps.URL.revokeObjectURL(bs.objectURL), this.demuxer = new Qa.default(qi, Na, Yo, Ma), this.w = void 0;
                    }
                  } else
                    this.demuxer = new Qa.default(qi, Na, Yo, Ma);
                }
                var ma = Sa.prototype;
                return ma.destroy = function() {
                  var Io = this.w;
                  if (Io)
                    Io.removeEventListener("message", this.onwmsg), Io.terminate(), this.w = null;
                  else {
                    var Ri = this.demuxer;
                    Ri && (Ri.destroy(), this.demuxer = null);
                  }
                  var qi = this.observer;
                  qi && (qi.removeAllListeners(), this.observer = null);
                }, ma.push = function(Io, Ri, qi, Yo, ba, Na, Ma, bs) {
                  var Ds = this.w, Fs = Object(oi.isFiniteNumber)(ba.startPTS) ? ba.startPTS : ba.start, _l = ba.decryptdata, Ll = this.frag, eu = !(Ll && ba.cc === Ll.cc), fu = !(Ll && ba.level === Ll.level), Fu = Ll && ba.sn === Ll.sn + 1, Ou = !fu && Fu;
                  if (eu && di.logger.log(this.id + ":discontinuity detected"), fu && di.logger.log(this.id + ":switch detected"), this.frag = ba, Ds)
                    Ds.postMessage({
                      cmd: "demux",
                      data: Io,
                      decryptdata: _l,
                      initSegment: Ri,
                      audioCodec: qi,
                      videoCodec: Yo,
                      timeOffset: Fs,
                      discontinuity: eu,
                      trackSwitch: fu,
                      contiguous: Ou,
                      duration: Na,
                      accurateTimeOffset: Ma,
                      defaultInitPTS: bs
                    }, Io instanceof ArrayBuffer ? [Io] : []);
                  else {
                    var qu = this.demuxer;
                    qu && qu.push(Io, _l, Ri, qi, Yo, Fs, eu, fu, Ou, Na, Ma, bs);
                  }
                }, ma.onWorkerMessage = function(Io) {
                  var Ri = Io.data, qi = this.hls;
                  switch (Ri.event) {
                    case "init":
                      Ps.URL.revokeObjectURL(this.w.objectURL);
                      break;
                    // special case for FRAG_PARSING_DATA: data1 and data2 are transferable objects
                    case si.default.FRAG_PARSING_DATA:
                      Ri.data.data1 = new Uint8Array(Ri.data1), Ri.data2 && (Ri.data.data2 = new Uint8Array(Ri.data2));
                    /* falls through */
                    default:
                      Ri.data = Ri.data || {}, Ri.data.frag = this.frag, Ri.data.id = this.id, qi.trigger(Ri.event, Ri.data);
                      break;
                  }
                }, Sa;
              })(), es = Vs;
              function Is(Sa, ma, Ho) {
                switch (ma) {
                  case "audio":
                    Sa.audioGroupIds || (Sa.audioGroupIds = []), Sa.audioGroupIds.push(Ho);
                    break;
                  case "text":
                    Sa.textGroupIds || (Sa.textGroupIds = []), Sa.textGroupIds.push(Ho);
                    break;
                }
              }
              function fl(Sa, ma, Ho) {
                var Io = Sa[ma], Ri = Sa[Ho], qi = Ri.startPTS;
                if (Object(oi.isFiniteNumber)(qi))
                  Ho > ma ? (Io.duration = qi - Io.start, Io.duration < 0 && di.logger.warn("negative duration computed for frag " + Io.sn + ",level " + Io.level + ", there should be some duration drift between playlist and fragment!")) : (Ri.duration = Io.start - qi, Ri.duration < 0 && di.logger.warn("negative duration computed for frag " + Ri.sn + ",level " + Ri.level + ", there should be some duration drift between playlist and fragment!"));
                else if (Ho > ma) {
                  var Yo = Io.cc === Ri.cc;
                  Ri.start = Io.start + (Yo && Io.minEndPTS ? Io.minEndPTS - Io.start : Io.duration);
                } else
                  Ri.start = Math.max(Io.start - Ri.duration, 0);
              }
              function sl(Sa, ma, Ho, Io, Ri, qi) {
                var Yo = Ho, ba = Io;
                if (Object(oi.isFiniteNumber)(ma.startPTS)) {
                  var Na = Math.abs(ma.startPTS - Ho);
                  Object(oi.isFiniteNumber)(ma.deltaPTS) ? ma.deltaPTS = Math.max(Na, ma.deltaPTS) : ma.deltaPTS = Na, Yo = Math.max(Ho, ma.startPTS), Ho = Math.min(Ho, ma.startPTS), ba = Math.min(Io, ma.endPTS), Io = Math.max(Io, ma.endPTS), Ri = Math.min(Ri, ma.startDTS), qi = Math.max(qi, ma.endDTS);
                }
                var Ma = Ho - ma.start;
                ma.start = ma.startPTS = Ho, ma.maxStartPTS = Yo, ma.endPTS = Io, ma.minEndPTS = ba, ma.startDTS = Ri, ma.endDTS = qi, ma.duration = Io - Ho;
                var bs = ma.sn;
                if (!Sa || bs < Sa.startSN || bs > Sa.endSN)
                  return 0;
                var Ds, Fs, _l;
                for (Ds = bs - Sa.startSN, Fs = Sa.fragments, Fs[Ds] = ma, _l = Ds; _l > 0; _l--)
                  fl(Fs, _l, _l - 1);
                for (_l = Ds; _l < Fs.length - 1; _l++)
                  fl(Fs, _l, _l + 1);
                return Sa.PTSKnown = !0, Ma;
              }
              function Il(Sa, ma) {
                ma.initSegment && Sa.initSegment && (ma.initSegment = Sa.initSegment);
                var Ho = 0, Io;
                if (Bl(Sa, ma, function(Yo, ba) {
                  Ho = Yo.cc - ba.cc, Object(oi.isFiniteNumber)(Yo.startPTS) && (ba.start = ba.startPTS = Yo.startPTS, ba.endPTS = Yo.endPTS, ba.duration = Yo.duration, ba.backtracked = Yo.backtracked, ba.dropped = Yo.dropped, Io = ba), ma.PTSKnown = !0;
                }), !!ma.PTSKnown) {
                  if (Ho) {
                    di.logger.log("discontinuity sliding from playlist, take drift into account");
                    for (var Ri = ma.fragments, qi = 0; qi < Ri.length; qi++)
                      Ri[qi].cc += Ho;
                  }
                  Io ? sl(ma, Io, Io.startPTS, Io.endPTS, Io.startDTS, Io.endDTS) : ql(Sa, ma), ma.PTSKnown = Sa.PTSKnown;
                }
              }
              function Vl(Sa, ma, Ho) {
                Ho === void 0 && (Ho = 0);
                var Io = -1;
                Bl(Sa, ma, function(Yo, ba, Na) {
                  ba.start = Yo.start, Io = Na;
                });
                var Ri = ma.fragments;
                if (Io < 0) {
                  Ri.forEach(function(Yo) {
                    Yo.start += Ho;
                  });
                  return;
                }
                for (var qi = Io + 1; qi < Ri.length; qi++)
                  Ri[qi].start = Ri[qi - 1].start + Ri[qi - 1].duration;
              }
              function Bl(Sa, ma, Ho) {
                if (!(!Sa || !ma))
                  for (var Io = Math.max(Sa.startSN, ma.startSN) - ma.startSN, Ri = Math.min(Sa.endSN, ma.endSN) - ma.startSN, qi = ma.startSN - Sa.startSN, Yo = Io; Yo <= Ri; Yo++) {
                    var ba = Sa.fragments[qi + Yo], Na = ma.fragments[Yo];
                    if (!ba || !Na)
                      break;
                    Ho(ba, Na, Yo);
                  }
              }
              function ql(Sa, ma) {
                var Ho = ma.startSN - Sa.startSN, Io = Sa.fragments, Ri = ma.fragments;
                if (!(Ho < 0 || Ho > Io.length))
                  for (var qi = 0; qi < Ri.length; qi++)
                    Ri[qi].start += Io[Ho].start;
              }
              function xl(Sa, ma, Ho) {
                var Io = 1e3 * (ma.averagetargetduration ? ma.averagetargetduration : ma.targetduration), Ri = Io / 2;
                return Sa && ma.endSN === Sa.endSN && (Io = Ri), Ho && (Io = Math.max(Ri, Io - (window.performance.now() - Ho))), Math.round(Io);
              }
              var Ul = {
                toString: function(ma) {
                  for (var Ho = "", Io = ma.length, Ri = 0; Ri < Io; Ri++)
                    Ho += "[" + ma.start(Ri).toFixed(3) + "," + ma.end(Ri).toFixed(3) + "]";
                  return Ho;
                }
              }, Xl = Ul;
              function hu(Sa, ma) {
                for (var Ho = null, Io = 0; Io < Sa.length; Io += 1) {
                  var Ri = Sa[Io];
                  if (Ri && Ri.cc === ma) {
                    Ho = Ri;
                    break;
                  }
                }
                return Ho;
              }
              function Tu(Sa, ma) {
                return Ja.search(Sa, function(Ho) {
                  return Ho.cc < ma ? 1 : Ho.cc > ma ? -1 : 0;
                });
              }
              function Ku(Sa, ma, Ho) {
                var Io = !1;
                return ma && ma.details && Ho && (Ho.endCC > Ho.startCC || Sa && Sa.cc < Ho.startCC) && (Io = !0), Io;
              }
              function Wl(Sa, ma) {
                var Ho = Sa.fragments, Io = ma.fragments;
                if (!Io.length || !Ho.length) {
                  di.logger.log("No fragments to align");
                  return;
                }
                var Ri = hu(Ho, Io[0].cc);
                if (!Ri || Ri && !Ri.startPTS) {
                  di.logger.log("No frag in previous level to align on");
                  return;
                }
                return Ri;
              }
              function uu(Sa, ma) {
                ma.fragments.forEach(function(Ho) {
                  if (Ho) {
                    var Io = Ho.start + Sa;
                    Ho.start = Ho.startPTS = Io, Ho.endPTS = Io + Ho.duration;
                  }
                }), ma.PTSKnown = !0;
              }
              function du(Sa, ma, Ho) {
                za(Sa, Ho, ma), !Ho.PTSKnown && ma && Ya(Ho, ma.details);
              }
              function za(Sa, ma, Ho) {
                if (Ku(Sa, Ho, ma)) {
                  var Io = Wl(Ho.details, ma);
                  Io && (di.logger.log("Adjusting PTS using last level due to CC increase within current level"), uu(Io.start, ma));
                }
              }
              function Ya(Sa, ma) {
                if (ma && ma.fragments.length) {
                  if (!Sa.hasProgramDateTime || !ma.hasProgramDateTime)
                    return;
                  var Ho = ma.fragments[0].programDateTime, Io = Sa.fragments[0].programDateTime, Ri = (Io - Ho) / 1e3 + ma.fragments[0].start;
                  Object(oi.isFiniteNumber)(Ri) && (di.logger.log("adjusting PTS using programDateTime delta, sliding:" + Ri.toFixed(3)), uu(Ri, Sa));
                }
              }
              function Ws(Sa, ma, Ho) {
                if (ma === null || !Array.isArray(Sa) || !Sa.length || !Object(oi.isFiniteNumber)(ma))
                  return null;
                var Io = Sa[0].programDateTime;
                if (ma < (Io || 0))
                  return null;
                var Ri = Sa[Sa.length - 1].endProgramDateTime;
                if (ma >= (Ri || 0))
                  return null;
                Ho = Ho || 0;
                for (var qi = 0; qi < Sa.length; ++qi) {
                  var Yo = Sa[qi];
                  if (bl(ma, Ho, Yo))
                    return Yo;
                }
                return null;
              }
              function wl(Sa, ma, Ho, Io) {
                Ho === void 0 && (Ho = 0), Io === void 0 && (Io = 0);
                var Ri = null;
                if (Sa ? Ri = ma[Sa.sn - ma[0].sn + 1] : Ho === 0 && ma[0].start === 0 && (Ri = ma[0]), Ri && Gl(Ho, Io, Ri) === 0)
                  return Ri;
                var qi = Ja.search(ma, Gl.bind(null, Ho, Io));
                return qi || Ri;
              }
              function Gl(Sa, ma, Ho) {
                Sa === void 0 && (Sa = 0), ma === void 0 && (ma = 0);
                var Io = Math.min(ma, Ho.duration + (Ho.deltaPTS ? Ho.deltaPTS : 0));
                return Ho.start + Ho.duration - Io <= Sa ? 1 : Ho.start - Io > Sa && Ho.start ? -1 : 0;
              }
              function bl(Sa, ma, Ho) {
                var Io = Math.min(ma, Ho.duration + (Ho.deltaPTS ? Ho.deltaPTS : 0)) * 1e3, Ri = Ho.endProgramDateTime || 0;
                return Ri - Io > Sa;
              }
              var Za = 250, rl = 2, zs = 0.1, al = 0.05, Ol = /* @__PURE__ */ (function() {
                function Sa(Ho, Io, Ri, qi) {
                  this.config = Ho, this.media = Io, this.fragmentTracker = Ri, this.hls = qi, this.nudgeRetry = 0, this.stallReported = !1, this.stalled = null, this.moved = !1, this.seeking = !1;
                }
                var ma = Sa.prototype;
                return ma.poll = function(Io) {
                  var Ri = this.config, qi = this.media, Yo = this.stalled, ba = qi.currentTime, Na = qi.seeking, Ma = this.seeking && !Na, bs = !this.seeking && Na;
                  if (this.seeking = Na, ba !== Io) {
                    if (this.moved = !0, Yo !== null) {
                      if (this.stallReported) {
                        var Ds = self.performance.now() - Yo;
                        di.logger.warn("playback not stuck anymore @" + ba + ", after " + Math.round(Ds) + "ms"), this.stallReported = !1;
                      }
                      this.stalled = null, this.nudgeRetry = 0;
                    }
                    return;
                  }
                  if ((bs || Ma) && (this.stalled = null), !(qi.paused || qi.ended || qi.playbackRate === 0 || !qi.buffered.length)) {
                    var Fs = ja.bufferInfo(qi, ba, 0), _l = Fs.len > 0, Ll = Fs.nextStart || 0;
                    if (!(!_l && !Ll)) {
                      if (Na) {
                        var eu = Fs.len > rl, fu = !Ll || Ll - ba > rl && !this.fragmentTracker.getPartialFragment(ba);
                        if (eu || fu)
                          return;
                        this.moved = !1;
                      }
                      if (!this.moved && this.stalled) {
                        var Fu = Math.max(Ll, Fs.start || 0) - ba;
                        if (Fu > 0 && Fu <= rl) {
                          this._trySkipBufferHole(null);
                          return;
                        }
                      }
                      var Ou = self.performance.now();
                      if (Yo === null) {
                        this.stalled = Ou;
                        return;
                      }
                      var qu = Ou - Yo;
                      !Na && qu >= Za && this._reportStall(Fs.len);
                      var Ju = ja.bufferInfo(qi, ba, Ri.maxBufferHole);
                      this._tryFixBufferStall(Ju, qu);
                    }
                  }
                }, ma._tryFixBufferStall = function(Io, Ri) {
                  var qi = this.config, Yo = this.fragmentTracker, ba = this.media, Na = ba.currentTime, Ma = Yo.getPartialFragment(Na);
                  if (Ma) {
                    var bs = this._trySkipBufferHole(Ma);
                    if (bs)
                      return;
                  }
                  Io.len > qi.maxBufferHole && Ri > qi.highBufferWatchdogPeriod * 1e3 && (di.logger.warn("Trying to nudge playhead over buffer-hole"), this.stalled = null, this._tryNudgeBuffer());
                }, ma._reportStall = function(Io) {
                  var Ri = this.hls, qi = this.media, Yo = this.stallReported;
                  Yo || (this.stallReported = !0, di.logger.warn("Playback stalling at @" + qi.currentTime + " due to low buffer (buffer=" + Io + ")"), Ri.trigger(si.default.ERROR, {
                    type: li.ErrorTypes.MEDIA_ERROR,
                    details: li.ErrorDetails.BUFFER_STALLED_ERROR,
                    fatal: !1,
                    buffer: Io
                  }));
                }, ma._trySkipBufferHole = function(Io) {
                  for (var Ri = this.config, qi = this.hls, Yo = this.media, ba = Yo.currentTime, Na = 0, Ma = 0; Ma < Yo.buffered.length; Ma++) {
                    var bs = Yo.buffered.start(Ma);
                    if (ba + Ri.maxBufferHole >= Na && ba < bs) {
                      var Ds = Math.max(bs + al, Yo.currentTime + zs);
                      return di.logger.warn("skipping hole, adjusting currentTime from " + ba + " to " + Ds), this.moved = !0, this.stalled = null, Yo.currentTime = Ds, Io && qi.trigger(si.default.ERROR, {
                        type: li.ErrorTypes.MEDIA_ERROR,
                        details: li.ErrorDetails.BUFFER_SEEK_OVER_HOLE,
                        fatal: !1,
                        reason: "fragment loaded with buffer holes, seeking from " + ba + " to " + Ds,
                        frag: Io
                      }), Ds;
                    }
                    Na = Yo.buffered.end(Ma);
                  }
                  return 0;
                }, ma._tryNudgeBuffer = function() {
                  var Io = this.config, Ri = this.hls, qi = this.media, Yo = qi.currentTime, ba = (this.nudgeRetry || 0) + 1;
                  if (this.nudgeRetry = ba, ba < Io.nudgeMaxRetry) {
                    var Na = Yo + ba * Io.nudgeOffset;
                    di.logger.warn("Nudging 'currentTime' from " + Yo + " to " + Na), qi.currentTime = Na, Ri.trigger(si.default.ERROR, {
                      type: li.ErrorTypes.MEDIA_ERROR,
                      details: li.ErrorDetails.BUFFER_NUDGE_ON_STALL,
                      fatal: !1
                    });
                  } else
                    di.logger.error("Playhead still not moving while enough data buffered @" + Yo + " after " + Io.nudgeMaxRetry + " nudges"), Ri.trigger(si.default.ERROR, {
                      type: li.ErrorTypes.MEDIA_ERROR,
                      details: li.ErrorDetails.BUFFER_STALLED_ERROR,
                      fatal: !0
                    });
                }, Sa;
              })();
              function $l(Sa) {
                if (Sa === void 0)
                  throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return Sa;
              }
              function Zl(Sa, ma) {
                Sa.prototype = Object.create(ma.prototype), Sa.prototype.constructor = Sa, Sa.__proto__ = ma;
              }
              var tu = /* @__PURE__ */ (function(Sa) {
                Zl(ma, Sa);
                function ma(Io) {
                  for (var Ri, qi = arguments.length, Yo = new Array(qi > 1 ? qi - 1 : 0), ba = 1; ba < qi; ba++)
                    Yo[ba - 1] = arguments[ba];
                  return Ri = Sa.call.apply(Sa, [this, Io].concat(Yo)) || this, Ri._boundTick = void 0, Ri._tickTimer = null, Ri._tickInterval = null, Ri._tickCallCount = 0, Ri._boundTick = Ri.tick.bind($l(Ri)), Ri;
                }
                var Ho = ma.prototype;
                return Ho.onHandlerDestroying = function() {
                  this.clearNextTick(), this.clearInterval();
                }, Ho.hasInterval = function() {
                  return !!this._tickInterval;
                }, Ho.hasNextTick = function() {
                  return !!this._tickTimer;
                }, Ho.setInterval = function(Ri) {
                  return this._tickInterval ? !1 : (this._tickInterval = self.setInterval(this._boundTick, Ri), !0);
                }, Ho.clearInterval = function() {
                  return this._tickInterval ? (self.clearInterval(this._tickInterval), this._tickInterval = null, !0) : !1;
                }, Ho.clearNextTick = function() {
                  return this._tickTimer ? (self.clearTimeout(this._tickTimer), this._tickTimer = null, !0) : !1;
                }, Ho.tick = function() {
                  this._tickCallCount++, this._tickCallCount === 1 && (this.doTick(), this._tickCallCount > 1 && (this.clearNextTick(), this._tickTimer = self.setTimeout(this._boundTick, 0)), this._tickCallCount = 0);
                }, Ho.doTick = function() {
                }, ma;
              })(mi);
              function su(Sa, ma) {
                Sa.prototype = Object.create(ma.prototype), Sa.prototype.constructor = Sa, Sa.__proto__ = ma;
              }
              var dl = {
                STOPPED: "STOPPED",
                STARTING: "STARTING",
                IDLE: "IDLE",
                PAUSED: "PAUSED",
                KEY_LOADING: "KEY_LOADING",
                FRAG_LOADING: "FRAG_LOADING",
                FRAG_LOADING_WAITING_RETRY: "FRAG_LOADING_WAITING_RETRY",
                WAITING_TRACK: "WAITING_TRACK",
                PARSING: "PARSING",
                PARSED: "PARSED",
                BUFFER_FLUSHING: "BUFFER_FLUSHING",
                ENDED: "ENDED",
                ERROR: "ERROR",
                WAITING_INIT_PTS: "WAITING_INIT_PTS",
                WAITING_LEVEL: "WAITING_LEVEL"
              }, Su = /* @__PURE__ */ (function(Sa) {
                su(ma, Sa);
                function ma() {
                  return Sa.apply(this, arguments) || this;
                }
                var Ho = ma.prototype;
                return Ho.doTick = function() {
                }, Ho.startLoad = function() {
                }, Ho.stopLoad = function() {
                  var Ri = this.fragCurrent;
                  Ri && (Ri.loader && Ri.loader.abort(), this.fragmentTracker.removeFragment(Ri)), this.demuxer && (this.demuxer.destroy(), this.demuxer = null), this.fragCurrent = null, this.fragPrevious = null, this.clearInterval(), this.clearNextTick(), this.state = dl.STOPPED;
                }, Ho._streamEnded = function(Ri, qi) {
                  var Yo = this.fragCurrent, ba = this.fragmentTracker;
                  if (!qi.live && Yo && !Yo.backtracked && Yo.sn === qi.endSN && !Ri.nextStart) {
                    var Na = ba.getState(Yo);
                    return Na === Es.PARTIAL || Na === Es.OK;
                  }
                  return !1;
                }, Ho.onMediaSeeking = function() {
                  var Ri = this.config, qi = this.media, Yo = this.mediaBuffer, ba = this.state, Na = qi ? qi.currentTime : null, Ma = ja.bufferInfo(Yo || qi, Na, this.config.maxBufferHole);
                  if (di.logger.log("media seeking to " + (Object(oi.isFiniteNumber)(Na) ? Na.toFixed(3) : Na)), ba === dl.FRAG_LOADING) {
                    var bs = this.fragCurrent;
                    if (Ma.len === 0 && bs) {
                      var Ds = Ri.maxFragLookUpTolerance, Fs = bs.start - Ds, _l = bs.start + bs.duration + Ds;
                      Na < Fs || Na > _l ? (bs.loader && (di.logger.log("seeking outside of buffer while fragment load in progress, cancel fragment load"), bs.loader.abort()), this.fragCurrent = null, this.fragPrevious = null, this.state = dl.IDLE) : di.logger.log("seeking outside of buffer but within currently loaded fragment range");
                    }
                  } else ba === dl.ENDED && (Ma.len === 0 && (this.fragPrevious = null, this.fragCurrent = null), this.state = dl.IDLE);
                  qi && (this.lastCurrentTime = Na), this.loadedmetadata || (this.nextLoadPosition = this.startPosition = Na), this.tick();
                }, Ho.onMediaEnded = function() {
                  this.startPosition = this.lastCurrentTime = 0;
                }, Ho.onHandlerDestroying = function() {
                  this.stopLoad(), Sa.prototype.onHandlerDestroying.call(this);
                }, Ho.onHandlerDestroyed = function() {
                  this.state = dl.STOPPED, this.fragmentTracker = null;
                }, Ho.computeLivePosition = function(Ri, qi) {
                  var Yo = this.config.liveSyncDuration !== void 0 ? this.config.liveSyncDuration : this.config.liveSyncDurationCount * qi.targetduration;
                  return Ri + Math.max(0, qi.totalduration - Yo);
                }, ma;
              })(tu);
              function cu(Sa, ma) {
                for (var Ho = 0; Ho < ma.length; Ho++) {
                  var Io = ma[Ho];
                  Io.enumerable = Io.enumerable || !1, Io.configurable = !0, "value" in Io && (Io.writable = !0), Object.defineProperty(Sa, Io.key, Io);
                }
              }
              function Ru(Sa, ma, Ho) {
                return ma && cu(Sa.prototype, ma), Sa;
              }
              function bu(Sa, ma) {
                Sa.prototype = Object.create(ma.prototype), Sa.prototype.constructor = Sa, Sa.__proto__ = ma;
              }
              var Hu = 100, cc = /* @__PURE__ */ (function(Sa) {
                bu(ma, Sa);
                function ma(Io, Ri) {
                  var qi;
                  return qi = Sa.call(this, Io, si.default.MEDIA_ATTACHED, si.default.MEDIA_DETACHING, si.default.MANIFEST_LOADING, si.default.MANIFEST_PARSED, si.default.LEVEL_LOADED, si.default.LEVELS_UPDATED, si.default.KEY_LOADED, si.default.FRAG_LOADED, si.default.FRAG_LOAD_EMERGENCY_ABORTED, si.default.FRAG_PARSING_INIT_SEGMENT, si.default.FRAG_PARSING_DATA, si.default.FRAG_PARSED, si.default.ERROR, si.default.AUDIO_TRACK_SWITCHING, si.default.AUDIO_TRACK_SWITCHED, si.default.BUFFER_CREATED, si.default.BUFFER_APPENDED, si.default.BUFFER_FLUSHED) || this, qi.fragmentTracker = Ri, qi.config = Io.config, qi.audioCodecSwap = !1, qi._state = dl.STOPPED, qi.stallReported = !1, qi.gapController = null, qi.altAudio = !1, qi.audioOnly = !1, qi.bitrateTest = !1, qi;
                }
                var Ho = ma.prototype;
                return Ho.startLoad = function(Ri) {
                  if (this.levels) {
                    var qi = this.lastCurrentTime, Yo = this.hls;
                    if (this.stopLoad(), this.setInterval(Hu), this.level = -1, this.fragLoadError = 0, !this.startFragRequested) {
                      var ba = Yo.startLevel;
                      ba === -1 && (Yo.config.testBandwidth ? (ba = 0, this.bitrateTest = !0) : ba = Yo.nextAutoLevel), this.level = Yo.nextLoadLevel = ba, this.loadedmetadata = !1;
                    }
                    qi > 0 && Ri === -1 && (di.logger.log("override startPosition with lastCurrentTime @" + qi.toFixed(3)), Ri = qi), this.state = dl.IDLE, this.nextLoadPosition = this.startPosition = this.lastCurrentTime = Ri, this.tick();
                  } else
                    this.forceStartLoad = !0, this.state = dl.STOPPED;
                }, Ho.stopLoad = function() {
                  this.forceStartLoad = !1, Sa.prototype.stopLoad.call(this);
                }, Ho.doTick = function() {
                  switch (this.state) {
                    case dl.BUFFER_FLUSHING:
                      this.fragLoadError = 0;
                      break;
                    case dl.IDLE:
                      this._doTickIdle();
                      break;
                    case dl.WAITING_LEVEL:
                      var Ri = this.levels[this.level];
                      Ri && Ri.details && (this.state = dl.IDLE);
                      break;
                    case dl.FRAG_LOADING_WAITING_RETRY:
                      var qi = window.performance.now(), Yo = this.retryDate;
                      (!Yo || qi >= Yo || this.media && this.media.seeking) && (di.logger.log("mediaController: retryDate reached, switch back to IDLE state"), this.state = dl.IDLE);
                      break;
                  }
                  this._checkBuffer(), this._checkFragmentChanged();
                }, Ho._doTickIdle = function() {
                  var Ri = this.hls, qi = Ri.config, Yo = this.media;
                  if (!(this.levelLastLoaded === void 0 || !Yo && (this.startFragRequested || !qi.startFragPrefetch))) {
                    if (this.altAudio && this.audioOnly) {
                      this.demuxer.frag = null;
                      return;
                    }
                    var ba;
                    this.loadedmetadata ? ba = Yo.currentTime : ba = this.nextLoadPosition;
                    var Na = Ri.nextLoadLevel, Ma = this.levels[Na];
                    if (Ma) {
                      var bs = Ma.bitrate, Ds;
                      bs ? Ds = Math.max(8 * qi.maxBufferSize / bs, qi.maxBufferLength) : Ds = qi.maxBufferLength, Ds = Math.min(Ds, qi.maxMaxBufferLength);
                      var Fs = ba < qi.maxBufferHole ? Math.max(rl, qi.maxBufferHole) : qi.maxBufferHole, _l = ja.bufferInfo(this.mediaBuffer ? this.mediaBuffer : Yo, ba, Fs), Ll = _l.len;
                      if (!(Ll >= Ds)) {
                        di.logger.trace("buffer length of " + Ll.toFixed(3) + " is below max of " + Ds.toFixed(3) + ". checking for more payload ..."), this.level = Ri.nextLoadLevel = Na;
                        var eu = Ma.details;
                        if (!eu || eu.live && this.levelLastLoaded !== Na) {
                          this.state = dl.WAITING_LEVEL;
                          return;
                        }
                        if (this._streamEnded(_l, eu)) {
                          var fu = {};
                          this.altAudio && (fu.type = "video"), this.hls.trigger(si.default.BUFFER_EOS, fu), this.state = dl.ENDED;
                          return;
                        }
                        this._fetchPayloadOrEos(ba, _l, eu);
                      }
                    }
                  }
                }, Ho._fetchPayloadOrEos = function(Ri, qi, Yo) {
                  var ba = this.fragPrevious;
                  this.level;
                  var Na = Yo.fragments, Ma = Na.length;
                  if (Ma !== 0) {
                    var bs = Na[0].start, Ds = Na[Ma - 1].start + Na[Ma - 1].duration, Fs = qi.end, _l;
                    if (Yo.initSegment && !Yo.initSegment.data)
                      _l = Yo.initSegment;
                    else if (Yo.live) {
                      var Ll = this.config.initialLiveManifestSize;
                      if (Ma < Ll) {
                        di.logger.warn("Can not start playback of a level, reason: not enough fragments " + Ma + " < " + Ll);
                        return;
                      }
                      if (_l = this._ensureFragmentAtLivePoint(Yo, Fs, bs, Ds, ba, Na), _l === null)
                        return;
                    } else
                      Fs < bs && (_l = Na[0]);
                    _l || (_l = this._findFragment(bs, ba, Ma, Na, Fs, Ds, Yo)), _l && (_l.encrypted ? this._loadKey(_l, Yo) : this._loadFragment(_l, Yo, Ri, Fs));
                  }
                }, Ho._ensureFragmentAtLivePoint = function(Ri, qi, Yo, ba, Na, Ma) {
                  var bs = this.hls.config, Ds = this.media, Fs, _l = 1 / 0;
                  if (bs.liveMaxLatencyDuration !== void 0 ? _l = bs.liveMaxLatencyDuration : Object(oi.isFiniteNumber)(bs.liveMaxLatencyDurationCount) && (_l = bs.liveMaxLatencyDurationCount * Ri.targetduration), qi < Math.max(Yo - bs.maxFragLookUpTolerance, ba - _l)) {
                    var Ll = this.liveSyncPosition = this.computeLivePosition(Yo, Ri);
                    qi = Ll, Ds && !Ds.paused && Ds.readyState && Ds.duration > Ll && Ll > Ds.currentTime && (di.logger.log("buffer end: " + qi.toFixed(3) + " is located too far from the end of live sliding playlist, reset currentTime to : " + Ll.toFixed(3)), Ds.currentTime = Ll), this.nextLoadPosition = Ll;
                  }
                  if (Ri.PTSKnown && qi > ba && Ds && Ds.readyState)
                    return null;
                  if (this.startFragRequested && !Ri.PTSKnown && Na)
                    if (Ri.hasProgramDateTime)
                      di.logger.log("live playlist, switching playlist, load frag with same PDT: " + Na.programDateTime), Fs = Ws(Ma, Na.endProgramDateTime, bs.maxFragLookUpTolerance);
                    else {
                      var eu = Na.sn + 1;
                      if (eu >= Ri.startSN && eu <= Ri.endSN) {
                        var fu = Ma[eu - Ri.startSN];
                        Na.cc === fu.cc && (Fs = fu, di.logger.log("live playlist, switching playlist, load frag with next SN: " + Fs.sn));
                      }
                      Fs || (Fs = Ja.search(Ma, function(Fu) {
                        return Na.cc - Fu.cc;
                      }), Fs && di.logger.log("live playlist, switching playlist, load frag with same CC: " + Fs.sn));
                    }
                  return Fs;
                }, Ho._findFragment = function(Ri, qi, Yo, ba, Na, Ma, bs) {
                  var Ds = this.hls.config, Fs;
                  if (Na < Ma) {
                    var _l = Na > Ma - Ds.maxFragLookUpTolerance ? 0 : Ds.maxFragLookUpTolerance;
                    Fs = wl(qi, ba, Na, _l);
                  } else
                    Fs = ba[Yo - 1];
                  if (Fs) {
                    var Ll = Fs.sn - bs.startSN, eu = qi && Fs.level === qi.level, fu = ba[Ll - 1], Fu = ba[Ll + 1];
                    if (qi && Fs.sn === qi.sn)
                      if (eu && !Fs.backtracked)
                        if (Fs.sn < bs.endSN) {
                          var Ou = qi.deltaPTS;
                          Ou && Ou > Ds.maxBufferHole && qi.dropped && Ll ? (Fs = fu, di.logger.warn("Previous fragment was dropped with large PTS gap between audio and video. Maybe fragment is not starting with a keyframe? Loading previous one to try to overcome this")) : (Fs = Fu, this.fragmentTracker.getState(Fs) !== Es.OK && di.logger.log("Re-loading fragment with SN: " + Fs.sn));
                        } else
                          Fs = null;
                      else Fs.backtracked && (Fu && Fu.backtracked ? (di.logger.warn("Already backtracked from fragment " + Fu.sn + ", will not backtrack to fragment " + Fs.sn + ". Loading fragment " + Fu.sn), Fs = Fu) : (di.logger.warn("Loaded fragment with dropped frames, backtracking 1 segment to find a keyframe"), Fs.dropped = 0, fu ? (Fs = fu, Fs.backtracked = !0) : Ll && (Fs = null)));
                  }
                  return Fs;
                }, Ho._loadKey = function(Ri, qi) {
                  di.logger.log("Loading key for " + Ri.sn + " of [" + qi.startSN + "-" + qi.endSN + "], level " + this.level), this.state = dl.KEY_LOADING, this.hls.trigger(si.default.KEY_LOADING, {
                    frag: Ri
                  });
                }, Ho._loadFragment = function(Ri, qi, Yo, ba) {
                  var Na = this.fragmentTracker.getState(Ri);
                  this.fragCurrent = Ri, Ri.sn !== "initSegment" && (this.startFragRequested = !0), Object(oi.isFiniteNumber)(Ri.sn) && !Ri.bitrateTest && (this.nextLoadPosition = Ri.start + Ri.duration), Ri.backtracked || Na === Es.NOT_LOADED || Na === Es.PARTIAL ? (Ri.autoLevel = this.hls.autoLevelEnabled, Ri.bitrateTest = this.bitrateTest, di.logger.log("Loading " + Ri.sn + " of [" + qi.startSN + "-" + qi.endSN + "], level " + this.level + ", " + (this.loadedmetadata ? "currentTime" : "nextLoadPosition") + ": " + parseFloat(Yo.toFixed(3)) + ", bufferEnd: " + parseFloat(ba.toFixed(3))), this.hls.trigger(si.default.FRAG_LOADING, {
                    frag: Ri
                  }), this.demuxer || (this.demuxer = new es(this.hls, "main")), this.state = dl.FRAG_LOADING) : Na === Es.APPENDING && this._reduceMaxBufferLength(Ri.duration) && this.fragmentTracker.removeFragment(Ri);
                }, Ho.getBufferedFrag = function(Ri) {
                  return this.fragmentTracker.getBufferedFrag(Ri, vi.MAIN);
                }, Ho.followingBufferedFrag = function(Ri) {
                  return Ri ? this.getBufferedFrag(Ri.endPTS + 0.5) : null;
                }, Ho._checkFragmentChanged = function() {
                  var Ri, qi, Yo = this.media;
                  if (Yo && Yo.readyState && Yo.seeking === !1 && (qi = Yo.currentTime, qi > this.lastCurrentTime && (this.lastCurrentTime = qi), ja.isBuffered(Yo, qi) ? Ri = this.getBufferedFrag(qi) : ja.isBuffered(Yo, qi + 0.1) && (Ri = this.getBufferedFrag(qi + 0.1)), Ri)) {
                    var ba = Ri;
                    if (ba !== this.fragPlaying) {
                      this.hls.trigger(si.default.FRAG_CHANGED, {
                        frag: ba
                      });
                      var Na = ba.level;
                      (!this.fragPlaying || this.fragPlaying.level !== Na) && this.hls.trigger(si.default.LEVEL_SWITCHED, {
                        level: Na
                      }), this.fragPlaying = ba;
                    }
                  }
                }, Ho.immediateLevelSwitch = function() {
                  if (di.logger.log("immediateLevelSwitch"), !this.immediateSwitch) {
                    this.immediateSwitch = !0;
                    var Ri = this.media, qi;
                    Ri ? (qi = Ri.paused, qi || Ri.pause()) : qi = !0, this.previouslyPaused = qi;
                  }
                  var Yo = this.fragCurrent;
                  Yo && Yo.loader && Yo.loader.abort(), this.fragCurrent = null, this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
                }, Ho.immediateLevelSwitchEnd = function() {
                  var Ri = this.media;
                  Ri && Ri.buffered.length && (this.immediateSwitch = !1, Ri.currentTime > 0 && ja.isBuffered(Ri, Ri.currentTime) && (Ri.currentTime -= 1e-4), this.previouslyPaused || Ri.play());
                }, Ho.nextLevelSwitch = function() {
                  var Ri = this.media;
                  if (Ri && Ri.readyState) {
                    var qi, Yo = this.getBufferedFrag(Ri.currentTime);
                    if (Yo && Yo.startPTS > 1 && this.flushMainBuffer(0, Yo.startPTS - 1), Ri.paused)
                      qi = 0;
                    else {
                      var ba = this.hls.nextLoadLevel, Na = this.levels[ba], Ma = this.fragLastKbps;
                      Ma && this.fragCurrent ? qi = this.fragCurrent.duration * Na.bitrate / (1e3 * Ma) + 1 : qi = 0;
                    }
                    var bs = this.getBufferedFrag(Ri.currentTime + qi);
                    if (bs) {
                      var Ds = this.followingBufferedFrag(bs);
                      if (Ds) {
                        var Fs = this.fragCurrent;
                        Fs && Fs.loader && Fs.loader.abort(), this.fragCurrent = null;
                        var _l = Math.max(bs.endPTS, Ds.maxStartPTS + Math.min(this.config.maxFragLookUpTolerance, Ds.duration));
                        this.flushMainBuffer(_l, Number.POSITIVE_INFINITY);
                      }
                    }
                  }
                }, Ho.flushMainBuffer = function(Ri, qi) {
                  this.state = dl.BUFFER_FLUSHING;
                  var Yo = {
                    startOffset: Ri,
                    endOffset: qi
                  };
                  this.altAudio && (Yo.type = "video"), this.hls.trigger(si.default.BUFFER_FLUSHING, Yo);
                }, Ho.onMediaAttached = function(Ri) {
                  var qi = this.media = this.mediaBuffer = Ri.media;
                  this.onvseeking = this.onMediaSeeking.bind(this), this.onvseeked = this.onMediaSeeked.bind(this), this.onvended = this.onMediaEnded.bind(this), qi.addEventListener("seeking", this.onvseeking), qi.addEventListener("seeked", this.onvseeked), qi.addEventListener("ended", this.onvended);
                  var Yo = this.config;
                  this.levels && Yo.autoStartLoad && this.hls.startLoad(Yo.startPosition), this.gapController = new Ol(Yo, qi, this.fragmentTracker, this.hls);
                }, Ho.onMediaDetaching = function() {
                  var Ri = this.media;
                  Ri && Ri.ended && (di.logger.log("MSE detaching and video ended, reset startPosition"), this.startPosition = this.lastCurrentTime = 0);
                  var qi = this.levels;
                  qi && qi.forEach(function(Yo) {
                    Yo.details && Yo.details.fragments.forEach(function(ba) {
                      ba.backtracked = void 0;
                    });
                  }), Ri && (Ri.removeEventListener("seeking", this.onvseeking), Ri.removeEventListener("seeked", this.onvseeked), Ri.removeEventListener("ended", this.onvended), this.onvseeking = this.onvseeked = this.onvended = null), this.fragmentTracker.removeAllFragments(), this.media = this.mediaBuffer = null, this.loadedmetadata = !1, this.stopLoad();
                }, Ho.onMediaSeeked = function() {
                  var Ri = this.media, qi = Ri ? Ri.currentTime : void 0;
                  Object(oi.isFiniteNumber)(qi) && di.logger.log("media seeked to " + qi.toFixed(3)), this.tick();
                }, Ho.onManifestLoading = function() {
                  di.logger.log("trigger BUFFER_RESET"), this.hls.trigger(si.default.BUFFER_RESET), this.fragmentTracker.removeAllFragments(), this.stalled = !1, this.startPosition = this.lastCurrentTime = 0;
                }, Ho.onManifestParsed = function(Ri) {
                  var qi = !1, Yo = !1, ba;
                  Ri.levels.forEach(function(Ma) {
                    ba = Ma.audioCodec, ba && (ba.indexOf("mp4a.40.2") !== -1 && (qi = !0), ba.indexOf("mp4a.40.5") !== -1 && (Yo = !0));
                  }), this.audioCodecSwitch = qi && Yo, this.audioCodecSwitch && di.logger.log("both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC"), this.altAudio = Ri.altAudio, this.levels = Ri.levels, this.startFragRequested = !1;
                  var Na = this.config;
                  (Na.autoStartLoad || this.forceStartLoad) && this.hls.startLoad(Na.startPosition);
                }, Ho.onLevelLoaded = function(Ri) {
                  var qi = Ri.details, Yo = Ri.level, ba = this.levels[this.levelLastLoaded], Na = this.levels[Yo], Ma = qi.totalduration, bs = 0;
                  if (di.logger.log("level " + Yo + " loaded [" + qi.startSN + "," + qi.endSN + "],duration:" + Ma), qi.live || Na.details && Na.details.live) {
                    var Ds = Na.details;
                    Ds && qi.fragments.length > 0 ? (Il(Ds, qi), bs = qi.fragments[0].start, this.liveSyncPosition = this.computeLivePosition(bs, Ds), qi.PTSKnown && Object(oi.isFiniteNumber)(bs) ? di.logger.log("live playlist sliding:" + bs.toFixed(3)) : (di.logger.log("live playlist - outdated PTS, unknown sliding"), du(this.fragPrevious, ba, qi))) : (di.logger.log("live playlist - first load, unknown sliding"), qi.PTSKnown = !1, du(this.fragPrevious, ba, qi));
                  } else
                    qi.PTSKnown = !1;
                  if (Na.details = qi, this.levelLastLoaded = Yo, this.hls.trigger(si.default.LEVEL_UPDATED, {
                    details: qi,
                    level: Yo
                  }), this.startFragRequested === !1) {
                    if (this.startPosition === -1 || this.lastCurrentTime === -1) {
                      var Fs = qi.startTimeOffset;
                      Object(oi.isFiniteNumber)(Fs) ? (Fs < 0 && (di.logger.log("negative start time offset " + Fs + ", count from end of last fragment"), Fs = bs + Ma + Fs), di.logger.log("start time offset found in playlist, adjust startPosition to " + Fs), this.startPosition = Fs) : qi.live ? (this.startPosition = this.computeLivePosition(bs, qi), di.logger.log("configure startPosition to " + this.startPosition)) : this.startPosition = 0, this.lastCurrentTime = this.startPosition;
                    }
                    this.nextLoadPosition = this.startPosition;
                  }
                  this.state === dl.WAITING_LEVEL && (this.state = dl.IDLE), this.tick();
                }, Ho.onKeyLoaded = function() {
                  this.state === dl.KEY_LOADING && (this.state = dl.IDLE, this.tick());
                }, Ho.onFragLoaded = function(Ri) {
                  var qi = this.fragCurrent, Yo = this.hls, ba = this.levels, Na = this.media, Ma = Ri.frag;
                  if (this.state === dl.FRAG_LOADING && qi && Ma.type === "main" && Ma.level === qi.level && Ma.sn === qi.sn) {
                    var bs = Ri.stats, Ds = ba[qi.level], Fs = Ds.details;
                    if (this.bitrateTest = !1, this.stats = bs, di.logger.log("Loaded " + qi.sn + " of [" + Fs.startSN + " ," + Fs.endSN + "],level " + qi.level), Ma.bitrateTest && Yo.nextLoadLevel)
                      this.state = dl.IDLE, this.startFragRequested = !1, bs.tparsed = bs.tbuffered = window.performance.now(), Yo.trigger(si.default.FRAG_BUFFERED, {
                        stats: bs,
                        frag: qi,
                        id: "main"
                      }), this.tick();
                    else if (Ma.sn === "initSegment")
                      this.state = dl.IDLE, bs.tparsed = bs.tbuffered = window.performance.now(), Fs.initSegment.data = Ri.payload, Yo.trigger(si.default.FRAG_BUFFERED, {
                        stats: bs,
                        frag: qi,
                        id: "main"
                      }), this.tick();
                    else {
                      di.logger.log("Parsing " + qi.sn + " of [" + Fs.startSN + " ," + Fs.endSN + "],level " + qi.level + ", cc " + qi.cc), this.state = dl.PARSING, this.pendingBuffering = !0, this.appended = !1, Ma.bitrateTest && (Ma.bitrateTest = !1, this.fragmentTracker.onFragLoaded({
                        frag: Ma
                      }));
                      var _l = !(Na && Na.seeking) && (Fs.PTSKnown || !Fs.live), Ll = Fs.initSegment ? Fs.initSegment.data : [], eu = this._getAudioCodec(Ds), fu = this.demuxer = this.demuxer || new es(this.hls, "main");
                      fu.push(Ri.payload, Ll, eu, Ds.videoCodec, qi, Fs.totalduration, _l);
                    }
                  }
                  this.fragLoadError = 0;
                }, Ho.onFragParsingInitSegment = function(Ri) {
                  var qi = this.fragCurrent, Yo = Ri.frag;
                  if (qi && Ri.id === "main" && Yo.sn === qi.sn && Yo.level === qi.level && this.state === dl.PARSING) {
                    var ba = Ri.tracks, Na, Ma;
                    if (this.audioOnly = ba.audio && !ba.video, this.altAudio && !this.audioOnly && delete ba.audio, Ma = ba.audio, Ma) {
                      var bs = this.levels[this.level].audioCodec, Ds = navigator.userAgent.toLowerCase();
                      bs && this.audioCodecSwap && (di.logger.log("swapping playlist audio codec"), bs.indexOf("mp4a.40.5") !== -1 ? bs = "mp4a.40.2" : bs = "mp4a.40.5"), this.audioCodecSwitch && Ma.metadata.channelCount !== 1 && // don't force HE-AAC if firefox
                      Ds.indexOf("firefox") === -1 && (bs = "mp4a.40.5"), Ds.indexOf("android") !== -1 && Ma.container !== "audio/mpeg" && (bs = "mp4a.40.2", di.logger.log("Android: force audio codec to " + bs)), Ma.levelCodec = bs, Ma.id = Ri.id;
                    }
                    Ma = ba.video, Ma && (Ma.levelCodec = this.levels[this.level].videoCodec, Ma.id = Ri.id), this.hls.trigger(si.default.BUFFER_CODECS, ba);
                    for (Na in ba) {
                      Ma = ba[Na], di.logger.log("main track:" + Na + ",container:" + Ma.container + ",codecs[level/parsed]=[" + Ma.levelCodec + "/" + Ma.codec + "]");
                      var Fs = Ma.initSegment;
                      Fs && (this.appended = !0, this.pendingBuffering = !0, this.hls.trigger(si.default.BUFFER_APPENDING, {
                        type: Na,
                        data: Fs,
                        parent: "main",
                        content: "initSegment"
                      }));
                    }
                    this.tick();
                  }
                }, Ho.onFragParsingData = function(Ri) {
                  var qi = this, Yo = this.fragCurrent, ba = Ri.frag;
                  if (Yo && Ri.id === "main" && ba.sn === Yo.sn && ba.level === Yo.level && !(Ri.type === "audio" && this.altAudio) && // filter out main audio if audio track is loaded through audio stream controller
                  this.state === dl.PARSING) {
                    var Na = this.levels[this.level], Ma = Yo;
                    if (Object(oi.isFiniteNumber)(Ri.endPTS) || (Ri.endPTS = Ri.startPTS + Yo.duration, Ri.endDTS = Ri.startDTS + Yo.duration), Ri.hasAudio === !0 && Ma.addElementaryStream(Mi.AUDIO), Ri.hasVideo === !0 && Ma.addElementaryStream(Mi.VIDEO), di.logger.log("Parsed " + Ri.type + ",PTS:[" + Ri.startPTS.toFixed(3) + "," + Ri.endPTS.toFixed(3) + "],DTS:[" + Ri.startDTS.toFixed(3) + "/" + Ri.endDTS.toFixed(3) + "],nb:" + Ri.nb + ",dropped:" + (Ri.dropped || 0)), Ri.type === "video")
                      if (Ma.dropped = Ri.dropped, Ma.dropped)
                        if (Ma.backtracked)
                          di.logger.warn("Already backtracked on this fragment, appending with the gap", Ma.sn);
                        else {
                          var bs = Na.details;
                          if (bs && Ma.sn === bs.startSN)
                            di.logger.warn("missing video frame(s) on first frag, appending with gap", Ma.sn);
                          else {
                            di.logger.warn("missing video frame(s), backtracking fragment", Ma.sn), this.fragmentTracker.removeFragment(Ma), Ma.backtracked = !0, this.nextLoadPosition = Ri.startPTS, this.state = dl.IDLE, this.fragPrevious = Ma, this.demuxer && (this.demuxer.destroy(), this.demuxer = null), this.tick();
                            return;
                          }
                        }
                      else
                        Ma.backtracked = !1;
                    var Ds = sl(Na.details, Ma, Ri.startPTS, Ri.endPTS, Ri.startDTS, Ri.endDTS), Fs = this.hls;
                    Fs.trigger(si.default.LEVEL_PTS_UPDATED, {
                      details: Na.details,
                      level: this.level,
                      drift: Ds,
                      type: Ri.type,
                      start: Ri.startPTS,
                      end: Ri.endPTS
                    }), [Ri.data1, Ri.data2].forEach(function(_l) {
                      _l && _l.length && qi.state === dl.PARSING && (qi.appended = !0, qi.pendingBuffering = !0, Fs.trigger(si.default.BUFFER_APPENDING, {
                        type: Ri.type,
                        data: _l,
                        parent: "main",
                        content: "data"
                      }));
                    }), this.tick();
                  }
                }, Ho.onFragParsed = function(Ri) {
                  var qi = this.fragCurrent, Yo = Ri.frag;
                  qi && Ri.id === "main" && Yo.sn === qi.sn && Yo.level === qi.level && this.state === dl.PARSING && (this.stats.tparsed = window.performance.now(), this.state = dl.PARSED, this._checkAppendedParsed());
                }, Ho.onAudioTrackSwitching = function(Ri) {
                  var qi = this.altAudio, Yo = !!Ri.url, ba = Ri.id;
                  if (!Yo) {
                    if (this.mediaBuffer !== this.media) {
                      di.logger.log("switching on main audio, use media.buffered to schedule main fragment loading"), this.mediaBuffer = this.media;
                      var Na = this.fragCurrent;
                      Na.loader && (di.logger.log("switching to main audio track, cancel main fragment load"), Na.loader.abort()), this.fragCurrent = null, this.fragPrevious = null, this.demuxer && (this.demuxer.destroy(), this.demuxer = null), this.state = dl.IDLE;
                    }
                    var Ma = this.hls;
                    qi && Ma.trigger(si.default.BUFFER_FLUSHING, {
                      startOffset: 0,
                      endOffset: Number.POSITIVE_INFINITY,
                      type: "audio"
                    }), Ma.trigger(si.default.AUDIO_TRACK_SWITCHED, {
                      id: ba
                    });
                  }
                }, Ho.onAudioTrackSwitched = function(Ri) {
                  var qi = Ri.id, Yo = !!this.hls.audioTracks[qi].url;
                  if (Yo) {
                    var ba = this.videoBuffer;
                    ba && this.mediaBuffer !== ba && (di.logger.log("switching on alternate audio, use video.buffered to schedule main fragment loading"), this.mediaBuffer = ba);
                  }
                  this.altAudio = Yo, this.tick();
                }, Ho.onBufferCreated = function(Ri) {
                  var qi = Ri.tracks, Yo, ba, Na = !1;
                  for (var Ma in qi) {
                    var bs = qi[Ma];
                    bs.id === "main" ? (ba = Ma, Yo = bs, Ma === "video" && (this.videoBuffer = qi[Ma].buffer)) : Na = !0;
                  }
                  Na && Yo ? (di.logger.log("alternate track found, use " + ba + ".buffered to schedule main fragment loading"), this.mediaBuffer = Yo.buffer) : this.mediaBuffer = this.media;
                }, Ho.onBufferAppended = function(Ri) {
                  if (Ri.parent === "main") {
                    var qi = this.state;
                    (qi === dl.PARSING || qi === dl.PARSED) && (this.pendingBuffering = Ri.pending > 0, this._checkAppendedParsed());
                  }
                }, Ho._checkAppendedParsed = function() {
                  if (this.state === dl.PARSED && (!this.appended || !this.pendingBuffering)) {
                    var Ri = this.fragCurrent;
                    if (Ri) {
                      var qi = this.mediaBuffer ? this.mediaBuffer : this.media;
                      di.logger.log("main buffered : " + Xl.toString(qi.buffered)), this.fragPrevious = Ri;
                      var Yo = this.stats;
                      Yo.tbuffered = window.performance.now(), this.fragLastKbps = Math.round(8 * Yo.total / (Yo.tbuffered - Yo.tfirst)), this.hls.trigger(si.default.FRAG_BUFFERED, {
                        stats: Yo,
                        frag: Ri,
                        id: "main"
                      }), this.state = dl.IDLE;
                    }
                    (this.loadedmetadata || this.startPosition <= 0) && this.tick();
                  }
                }, Ho.onError = function(Ri) {
                  var qi = Ri.frag || this.fragCurrent;
                  if (!(qi && qi.type !== "main")) {
                    var Yo = !!this.media && ja.isBuffered(this.media, this.media.currentTime) && ja.isBuffered(this.media, this.media.currentTime + 0.5);
                    switch (Ri.details) {
                      case li.ErrorDetails.FRAG_LOAD_ERROR:
                      case li.ErrorDetails.FRAG_LOAD_TIMEOUT:
                      case li.ErrorDetails.KEY_LOAD_ERROR:
                      case li.ErrorDetails.KEY_LOAD_TIMEOUT:
                        if (!Ri.fatal)
                          if (this.fragLoadError + 1 <= this.config.fragLoadingMaxRetry) {
                            var ba = Math.min(Math.pow(2, this.fragLoadError) * this.config.fragLoadingRetryDelay, this.config.fragLoadingMaxRetryTimeout);
                            di.logger.warn("mediaController: frag loading failed, retry in " + ba + " ms"), this.retryDate = window.performance.now() + ba, this.loadedmetadata || (this.startFragRequested = !1, this.nextLoadPosition = this.startPosition), this.fragLoadError++, this.state = dl.FRAG_LOADING_WAITING_RETRY;
                          } else
                            di.logger.error("mediaController: " + Ri.details + " reaches max retry, redispatch as fatal ..."), Ri.fatal = !0, this.state = dl.ERROR;
                        break;
                      case li.ErrorDetails.LEVEL_LOAD_ERROR:
                      case li.ErrorDetails.LEVEL_LOAD_TIMEOUT:
                        this.state !== dl.ERROR && (Ri.fatal ? (this.state = dl.ERROR, di.logger.warn("streamController: " + Ri.details + ",switch to " + this.state + " state ...")) : !Ri.levelRetry && this.state === dl.WAITING_LEVEL && (this.state = dl.IDLE));
                        break;
                      case li.ErrorDetails.BUFFER_FULL_ERROR:
                        Ri.parent === "main" && (this.state === dl.PARSING || this.state === dl.PARSED) && (Yo ? (this._reduceMaxBufferLength(this.config.maxBufferLength), this.state = dl.IDLE) : (di.logger.warn("buffer full error also media.currentTime is not buffered, flush everything"), this.fragCurrent = null, this.flushMainBuffer(0, Number.POSITIVE_INFINITY)));
                        break;
                    }
                  }
                }, Ho._reduceMaxBufferLength = function(Ri) {
                  var qi = this.config;
                  return qi.maxMaxBufferLength >= Ri ? (qi.maxMaxBufferLength /= 2, di.logger.warn("main:reduce max buffer length to " + qi.maxMaxBufferLength + "s"), !0) : !1;
                }, Ho._checkBuffer = function() {
                  var Ri = this.media;
                  if (!(!Ri || Ri.readyState === 0)) {
                    var qi = this.mediaBuffer ? this.mediaBuffer : Ri, Yo = qi.buffered;
                    !this.loadedmetadata && Yo.length ? (this.loadedmetadata = !0, this._seekToStartPos()) : this.immediateSwitch ? this.immediateLevelSwitchEnd() : this.gapController.poll(this.lastCurrentTime, Yo);
                  }
                }, Ho.onFragLoadEmergencyAborted = function() {
                  this.state = dl.IDLE, this.loadedmetadata || (this.startFragRequested = !1, this.nextLoadPosition = this.startPosition), this.tick();
                }, Ho.onBufferFlushed = function() {
                  var Ri = this.mediaBuffer ? this.mediaBuffer : this.media;
                  if (Ri) {
                    var qi = this.audioOnly ? Mi.AUDIO : Mi.VIDEO;
                    this.fragmentTracker.detectEvictedFragments(qi, Ri.buffered);
                  }
                  this.state = dl.IDLE, this.fragPrevious = null;
                }, Ho.onLevelsUpdated = function(Ri) {
                  this.levels = Ri.levels;
                }, Ho.swapAudioCodec = function() {
                  this.audioCodecSwap = !this.audioCodecSwap;
                }, Ho._seekToStartPos = function() {
                  var Ri = this.media, qi = Ri.currentTime, Yo = this.startPosition;
                  if (qi !== Yo && Yo >= 0) {
                    if (Ri.seeking) {
                      di.logger.log("could not seek to " + Yo + ", already seeking at " + qi);
                      return;
                    }
                    var ba = Ri.buffered.length ? Ri.buffered.start(0) : 0, Na = ba - Yo;
                    Na > 0 && Na < this.config.maxBufferHole && (di.logger.log("adjusting start position by " + Na + " to match buffer start"), Yo += Na, this.startPosition = Yo), di.logger.log("seek to target start position " + Yo + " from current time " + qi + ". ready state " + Ri.readyState), Ri.currentTime = Yo;
                  }
                }, Ho._getAudioCodec = function(Ri) {
                  var qi = this.config.defaultAudioCodec || Ri.audioCodec;
                  return this.audioCodecSwap && (di.logger.log("swapping playlist audio codec"), qi && (qi.indexOf("mp4a.40.5") !== -1 ? qi = "mp4a.40.2" : qi = "mp4a.40.5")), qi;
                }, Ru(ma, [{
                  key: "state",
                  set: function(Ri) {
                    if (this.state !== Ri) {
                      var qi = this.state;
                      this._state = Ri, di.logger.log("main stream-controller: " + qi + "->" + Ri), this.hls.trigger(si.default.STREAM_STATE_TRANSITION, {
                        previousState: qi,
                        nextState: Ri
                      });
                    }
                  },
                  get: function() {
                    return this._state;
                  }
                }, {
                  key: "currentLevel",
                  get: function() {
                    var Ri = this.media;
                    if (Ri) {
                      var qi = this.getBufferedFrag(Ri.currentTime);
                      if (qi)
                        return qi.level;
                    }
                    return -1;
                  }
                }, {
                  key: "nextBufferedFrag",
                  get: function() {
                    var Ri = this.media;
                    return Ri ? this.followingBufferedFrag(this.getBufferedFrag(Ri.currentTime)) : null;
                  }
                }, {
                  key: "nextLevel",
                  get: function() {
                    var Ri = this.nextBufferedFrag;
                    return Ri ? Ri.level : -1;
                  }
                }, {
                  key: "liveSyncPosition",
                  get: function() {
                    return this._liveSyncPosition;
                  },
                  set: function(Ri) {
                    this._liveSyncPosition = Ri;
                  }
                }]), ma;
              })(Su), Tl = cc;
              function Yl(Sa, ma) {
                for (var Ho = 0; Ho < ma.length; Ho++) {
                  var Io = ma[Ho];
                  Io.enumerable = Io.enumerable || !1, Io.configurable = !0, "value" in Io && (Io.writable = !0), Object.defineProperty(Sa, Io.key, Io);
                }
              }
              function Dl(Sa, ma, Ho) {
                return ma && Yl(Sa.prototype, ma), Sa;
              }
              function Cl(Sa, ma) {
                Sa.prototype = Object.create(ma.prototype), Sa.prototype.constructor = Sa, Sa.__proto__ = ma;
              }
              var Hl, Gu = /* @__PURE__ */ (function(Sa) {
                Cl(ma, Sa);
                function ma(Io) {
                  var Ri;
                  return Ri = Sa.call(this, Io, si.default.MANIFEST_LOADED, si.default.LEVEL_LOADED, si.default.AUDIO_TRACK_SWITCHED, si.default.FRAG_LOADED, si.default.ERROR) || this, Ri.canload = !1, Ri.currentLevelIndex = null, Ri.manualLevelIndex = -1, Ri.timer = null, Hl = /chrome|firefox/.test(navigator.userAgent.toLowerCase()), Ri;
                }
                var Ho = ma.prototype;
                return Ho.onHandlerDestroying = function() {
                  this.clearTimer(), this.manualLevelIndex = -1;
                }, Ho.clearTimer = function() {
                  this.timer !== null && (clearTimeout(this.timer), this.timer = null);
                }, Ho.startLoad = function() {
                  var Ri = this._levels;
                  this.canload = !0, this.levelRetryCount = 0, Ri && Ri.forEach(function(qi) {
                    qi.loadError = 0;
                    var Yo = qi.details;
                    Yo && Yo.live && (qi.details = void 0);
                  }), this.timer !== null && this.loadLevel();
                }, Ho.stopLoad = function() {
                  this.canload = !1;
                }, Ho.onManifestLoaded = function(Ri) {
                  var qi = [], Yo = [], ba, Na = {}, Ma = null, bs = !1, Ds = !1;
                  if (Ri.levels.forEach(function(Ll) {
                    var eu = Ll.attrs;
                    Ll.loadError = 0, Ll.fragmentError = !1, bs = bs || !!Ll.videoCodec, Ds = Ds || !!Ll.audioCodec, Hl && Ll.audioCodec && Ll.audioCodec.indexOf("mp4a.40.34") !== -1 && (Ll.audioCodec = void 0), Ma = Na[Ll.bitrate], Ma ? Ma.url.push(Ll.url) : (Ll.url = [Ll.url], Ll.urlId = 0, Na[Ll.bitrate] = Ll, qi.push(Ll)), eu && (eu.AUDIO && Is(Ma || Ll, "audio", eu.AUDIO), eu.SUBTITLES && Is(Ma || Ll, "text", eu.SUBTITLES));
                  }), bs && Ds && (qi = qi.filter(function(Ll) {
                    var eu = Ll.videoCodec;
                    return !!eu;
                  })), qi = qi.filter(function(Ll) {
                    var eu = Ll.audioCodec, fu = Ll.videoCodec;
                    return (!eu || No(eu, "audio")) && (!fu || No(fu, "video"));
                  }), Ri.audioTracks && (Yo = Ri.audioTracks.filter(function(Ll) {
                    return !Ll.audioCodec || No(Ll.audioCodec, "audio");
                  }), Yo.forEach(function(Ll, eu) {
                    Ll.id = eu;
                  })), qi.length > 0) {
                    ba = qi[0].bitrate, qi.sort(function(Ll, eu) {
                      return Ll.bitrate - eu.bitrate;
                    }), this._levels = qi;
                    for (var Fs = 0; Fs < qi.length; Fs++)
                      if (qi[Fs].bitrate === ba) {
                        this._firstLevel = Fs, di.logger.log("manifest loaded," + qi.length + " level(s) found, first bitrate:" + ba);
                        break;
                      }
                    var _l = Ds && !bs;
                    this.hls.trigger(si.default.MANIFEST_PARSED, {
                      levels: qi,
                      audioTracks: Yo,
                      firstLevel: this._firstLevel,
                      stats: Ri.stats,
                      audio: Ds,
                      video: bs,
                      altAudio: !_l && Yo.some(function(Ll) {
                        return !!Ll.url;
                      })
                    });
                  } else
                    this.hls.trigger(si.default.ERROR, {
                      type: li.ErrorTypes.MEDIA_ERROR,
                      details: li.ErrorDetails.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
                      fatal: !0,
                      url: this.hls.url,
                      reason: "no level with compatible codecs found in manifest"
                    });
                }, Ho.setLevelInternal = function(Ri) {
                  var qi = this._levels, Yo = this.hls;
                  if (Ri >= 0 && Ri < qi.length) {
                    if (this.clearTimer(), this.currentLevelIndex !== Ri) {
                      di.logger.log("switching to level " + Ri), this.currentLevelIndex = Ri;
                      var ba = qi[Ri];
                      ba.level = Ri, Yo.trigger(si.default.LEVEL_SWITCHING, ba);
                    }
                    var Na = qi[Ri], Ma = Na.details;
                    if (!Ma || Ma.live) {
                      var bs = Na.urlId;
                      Yo.trigger(si.default.LEVEL_LOADING, {
                        url: Na.url[bs],
                        level: Ri,
                        id: bs
                      });
                    }
                  } else
                    Yo.trigger(si.default.ERROR, {
                      type: li.ErrorTypes.OTHER_ERROR,
                      details: li.ErrorDetails.LEVEL_SWITCH_ERROR,
                      level: Ri,
                      fatal: !1,
                      reason: "invalid level idx"
                    });
                }, Ho.onError = function(Ri) {
                  if (Ri.fatal) {
                    Ri.type === li.ErrorTypes.NETWORK_ERROR && this.clearTimer();
                    return;
                  }
                  var qi = !1, Yo = !1, ba;
                  switch (Ri.details) {
                    case li.ErrorDetails.FRAG_LOAD_ERROR:
                    case li.ErrorDetails.FRAG_LOAD_TIMEOUT:
                    case li.ErrorDetails.KEY_LOAD_ERROR:
                    case li.ErrorDetails.KEY_LOAD_TIMEOUT:
                      ba = Ri.frag.level, Yo = !0;
                      break;
                    case li.ErrorDetails.LEVEL_LOAD_ERROR:
                    case li.ErrorDetails.LEVEL_LOAD_TIMEOUT:
                      ba = Ri.context.level, qi = !0;
                      break;
                    case li.ErrorDetails.REMUX_ALLOC_ERROR:
                      ba = Ri.level, qi = !0;
                      break;
                  }
                  ba !== void 0 && this.recoverLevel(Ri, ba, qi, Yo);
                }, Ho.recoverLevel = function(Ri, qi, Yo, ba) {
                  var Na = this, Ma = this.hls.config, bs = Ri.details, Ds = this._levels[qi], Fs, _l, Ll;
                  if (Ds.loadError++, Ds.fragmentError = ba, Yo)
                    if (this.levelRetryCount + 1 <= Ma.levelLoadingMaxRetry)
                      _l = Math.min(Math.pow(2, this.levelRetryCount) * Ma.levelLoadingRetryDelay, Ma.levelLoadingMaxRetryTimeout), this.timer = setTimeout(function() {
                        return Na.loadLevel();
                      }, _l), Ri.levelRetry = !0, this.levelRetryCount++, di.logger.warn("level controller, " + bs + ", retry in " + _l + " ms, current retry count is " + this.levelRetryCount);
                    else {
                      di.logger.error("level controller, cannot recover from " + bs + " error"), this.currentLevelIndex = null, this.clearTimer(), Ri.fatal = !0;
                      return;
                    }
                  (Yo || ba) && (Fs = Ds.url.length, Fs > 1 && Ds.loadError < Fs ? (Ds.urlId = (Ds.urlId + 1) % Fs, Ds.details = void 0, di.logger.warn("level controller, " + bs + " for level " + qi + ": switching to redundant URL-id " + Ds.urlId)) : this.manualLevelIndex === -1 ? (Ll = qi === 0 ? this._levels.length - 1 : qi - 1, di.logger.warn("level controller, " + bs + ": switch to " + Ll), this.hls.nextAutoLevel = this.currentLevelIndex = Ll) : ba && (di.logger.warn("level controller, " + bs + ": reload a fragment"), this.currentLevelIndex = null));
                }, Ho.onFragLoaded = function(Ri) {
                  var qi = Ri.frag;
                  if (qi !== void 0 && qi.type === "main") {
                    var Yo = this._levels[qi.level];
                    Yo !== void 0 && (Yo.fragmentError = !1, Yo.loadError = 0, this.levelRetryCount = 0);
                  }
                }, Ho.onLevelLoaded = function(Ri) {
                  var qi = this, Yo = Ri.level, ba = Ri.details;
                  if (Yo === this.currentLevelIndex) {
                    var Na = this._levels[Yo];
                    if (Na.fragmentError || (Na.loadError = 0, this.levelRetryCount = 0), ba.live) {
                      var Ma = xl(Na.details, ba, Ri.stats.trequest);
                      di.logger.log("live playlist, reload in " + Math.round(Ma) + " ms"), this.timer = setTimeout(function() {
                        return qi.loadLevel();
                      }, Ma);
                    } else
                      this.clearTimer();
                  }
                }, Ho.onAudioTrackSwitched = function(Ri) {
                  var qi = this.hls.audioTracks[Ri.id].groupId, Yo = this.hls.levels[this.currentLevelIndex];
                  if (Yo && Yo.audioGroupIds) {
                    for (var ba = -1, Na = 0; Na < Yo.audioGroupIds.length; Na++)
                      if (Yo.audioGroupIds[Na] === qi) {
                        ba = Na;
                        break;
                      }
                    ba !== Yo.urlId && (Yo.urlId = ba, this.startLoad());
                  }
                }, Ho.loadLevel = function() {
                  if (di.logger.debug("call to loadLevel"), this.currentLevelIndex !== null && this.canload) {
                    var Ri = this._levels[this.currentLevelIndex];
                    if (typeof Ri == "object" && Ri.url.length > 0) {
                      var qi = this.currentLevelIndex, Yo = Ri.urlId, ba = Ri.url[Yo];
                      di.logger.log("Attempt loading level index " + qi + " with URL-id " + Yo), this.hls.trigger(si.default.LEVEL_LOADING, {
                        url: ba,
                        level: qi,
                        id: Yo
                      });
                    }
                  }
                }, Ho.removeLevel = function(Ri, qi) {
                  var Yo = this.levels.filter(function(ba, Na) {
                    return Na !== Ri ? !0 : ba.url.length > 1 && qi !== void 0 ? (ba.url = ba.url.filter(function(Ma, bs) {
                      return bs !== qi;
                    }), ba.urlId = 0, !0) : !1;
                  }).map(function(ba, Na) {
                    var Ma = ba.details;
                    return Ma && Ma.fragments && Ma.fragments.forEach(function(bs) {
                      bs.level = Na;
                    }), ba;
                  });
                  this._levels = Yo, this.hls.trigger(si.default.LEVELS_UPDATED, {
                    levels: Yo
                  });
                }, Dl(ma, [{
                  key: "levels",
                  get: function() {
                    return this._levels;
                  }
                }, {
                  key: "level",
                  get: function() {
                    return this.currentLevelIndex;
                  },
                  set: function(Ri) {
                    var qi = this._levels;
                    qi && (Ri = Math.min(Ri, qi.length - 1), (this.currentLevelIndex !== Ri || !qi[Ri].details) && this.setLevelInternal(Ri));
                  }
                }, {
                  key: "manualLevel",
                  get: function() {
                    return this.manualLevelIndex;
                  },
                  set: function(Ri) {
                    this.manualLevelIndex = Ri, this._startLevel === void 0 && (this._startLevel = Ri), Ri !== -1 && (this.level = Ri);
                  }
                }, {
                  key: "firstLevel",
                  get: function() {
                    return this._firstLevel;
                  },
                  set: function(Ri) {
                    this._firstLevel = Ri;
                  }
                }, {
                  key: "startLevel",
                  get: function() {
                    if (this._startLevel === void 0) {
                      var Ri = this.hls.config.startLevel;
                      return Ri !== void 0 ? Ri : this._firstLevel;
                    } else
                      return this._startLevel;
                  },
                  set: function(Ri) {
                    this._startLevel = Ri;
                  }
                }, {
                  key: "nextLoadLevel",
                  get: function() {
                    return this.manualLevelIndex !== -1 ? this.manualLevelIndex : this.hls.nextAutoLevel;
                  },
                  set: function(Ri) {
                    this.level = Ri, this.manualLevelIndex === -1 && (this.hls.nextAutoLevel = Ri);
                  }
                }]), ma;
              })(mi), xu = ii("./src/demux/id3.js");
              function ac(Sa, ma) {
                var Ho;
                try {
                  Ho = new Event("addtrack");
                } catch {
                  Ho = document.createEvent("Event"), Ho.initEvent("addtrack", !1, !1);
                }
                Ho.track = Sa, ma.dispatchEvent(Ho);
              }
              function hc(Sa) {
                if (Sa != null && Sa.cues)
                  for (; Sa.cues.length > 0; )
                    Sa.removeCue(Sa.cues[0]);
              }
              function mc(Sa, ma) {
                if (ma < Sa[0].endTime)
                  return Sa[0];
                if (ma > Sa[Sa.length - 1].endTime)
                  return Sa[Sa.length - 1];
                for (var Ho = 0, Io = Sa.length - 1; Ho <= Io; ) {
                  var Ri = Math.floor((Io + Ho) / 2);
                  if (ma < Sa[Ri].endTime)
                    Io = Ri - 1;
                  else if (ma > Sa[Ri].endTime)
                    Ho = Ri + 1;
                  else
                    return Sa[Ri];
                }
                return Sa[Ho].endTime - ma < ma - Sa[Io].endTime ? Sa[Ho] : Sa[Io];
              }
              function jc(Sa, ma) {
                Sa.prototype = Object.create(ma.prototype), Sa.prototype.constructor = Sa, Sa.__proto__ = ma;
              }
              var iu = 0.25, yc = /* @__PURE__ */ (function(Sa) {
                jc(ma, Sa);
                function ma(Io) {
                  var Ri;
                  return Ri = Sa.call(this, Io, si.default.MEDIA_ATTACHED, si.default.MEDIA_DETACHING, si.default.FRAG_PARSING_METADATA, si.default.LIVE_BACK_BUFFER_REACHED) || this, Ri.id3Track = void 0, Ri.media = void 0, Ri;
                }
                var Ho = ma.prototype;
                return Ho.destroy = function() {
                  mi.prototype.destroy.call(this);
                }, Ho.onMediaAttached = function(Ri) {
                  this.media = Ri.media, this.media;
                }, Ho.onMediaDetaching = function() {
                  hc(this.id3Track), this.id3Track = void 0, this.media = void 0;
                }, Ho.getID3Track = function(Ri) {
                  for (var qi = 0; qi < Ri.length; qi++) {
                    var Yo = Ri[qi];
                    if (Yo.kind === "metadata" && Yo.label === "id3")
                      return ac(Yo, this.media), Yo;
                  }
                  return this.media.addTextTrack("metadata", "id3");
                }, Ho.onFragParsingMetadata = function(Ri) {
                  var qi = Ri.frag, Yo = Ri.samples;
                  this.id3Track || (this.id3Track = this.getID3Track(this.media.textTracks), this.id3Track.mode = "hidden");
                  for (var ba = window.WebKitDataCue || window.VTTCue || window.TextTrackCue, Na = 0; Na < Yo.length; Na++) {
                    var Ma = xu.default.getID3Frames(Yo[Na].data);
                    if (Ma) {
                      var bs = Math.max(Yo[Na].pts, 0), Ds = Na < Yo.length - 1 ? Yo[Na + 1].pts : qi.endPTS;
                      Ds || (Ds = qi.start + qi.duration);
                      var Fs = Ds - bs;
                      Fs <= 0 && (Ds = bs + iu);
                      for (var _l = 0; _l < Ma.length; _l++) {
                        var Ll = Ma[_l];
                        if (!xu.default.isTimeStampFrame(Ll)) {
                          var eu = new ba(bs, Ds, "");
                          eu.value = Ll, this.id3Track.addCue(eu);
                        }
                      }
                    }
                  }
                }, Ho.onLiveBackBufferReached = function(Ri) {
                  var qi = Ri.bufferEnd, Yo = this.id3Track;
                  if (!(!Yo || !Yo.cues || !Yo.cues.length)) {
                    var ba = mc(Yo.cues, qi);
                    if (ba)
                      for (; Yo.cues[0] !== ba; )
                        Yo.removeCue(Yo.cues[0]);
                  }
                }, ma;
              })(mi), Mu = yc;
              function sc() {
                var Sa = Cs();
                if (!Sa)
                  return !1;
                var ma = self.SourceBuffer || self.WebKitSourceBuffer, Ho = Sa && typeof Sa.isTypeSupported == "function" && Sa.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'), Io = !ma || ma.prototype && typeof ma.prototype.appendBuffer == "function" && typeof ma.prototype.remove == "function";
                return !!Ho && !!Io;
              }
              var wc = /* @__PURE__ */ (function() {
                function Sa(Ho) {
                  this.alpha_ = void 0, this.estimate_ = void 0, this.totalWeight_ = void 0, this.alpha_ = Ho ? Math.exp(Math.log(0.5) / Ho) : 0, this.estimate_ = 0, this.totalWeight_ = 0;
                }
                var ma = Sa.prototype;
                return ma.sample = function(Io, Ri) {
                  var qi = Math.pow(this.alpha_, Io);
                  this.estimate_ = Ri * (1 - qi) + qi * this.estimate_, this.totalWeight_ += Io;
                }, ma.getTotalWeight = function() {
                  return this.totalWeight_;
                }, ma.getEstimate = function() {
                  if (this.alpha_) {
                    var Io = 1 - Math.pow(this.alpha_, this.totalWeight_);
                    return this.estimate_ / Io;
                  } else
                    return this.estimate_;
                }, Sa;
              })(), Wc = wc, Xu = /* @__PURE__ */ (function() {
                function Sa(Ho, Io, Ri, qi) {
                  this.hls = void 0, this.defaultEstimate_ = void 0, this.minWeight_ = void 0, this.minDelayMs_ = void 0, this.slow_ = void 0, this.fast_ = void 0, this.hls = Ho, this.defaultEstimate_ = qi, this.minWeight_ = 1e-3, this.minDelayMs_ = 50, this.slow_ = new Wc(Io), this.fast_ = new Wc(Ri);
                }
                var ma = Sa.prototype;
                return ma.sample = function(Io, Ri) {
                  Io = Math.max(Io, this.minDelayMs_);
                  var qi = 8 * Ri, Yo = Io / 1e3, ba = qi / Yo;
                  this.fast_.sample(Yo, ba), this.slow_.sample(Yo, ba);
                }, ma.canEstimate = function() {
                  var Io = this.fast_;
                  return Io && Io.getTotalWeight() >= this.minWeight_;
                }, ma.getEstimate = function() {
                  return this.canEstimate() ? Math.min(this.fast_.getEstimate(), this.slow_.getEstimate()) : this.defaultEstimate_;
                }, ma.destroy = function() {
                }, Sa;
              })(), fd = Xu;
              function rd(Sa, ma) {
                for (var Ho = 0; Ho < ma.length; Ho++) {
                  var Io = ma[Ho];
                  Io.enumerable = Io.enumerable || !1, Io.configurable = !0, "value" in Io && (Io.writable = !0), Object.defineProperty(Sa, Io.key, Io);
                }
              }
              function _c(Sa, ma, Ho) {
                return ma && rd(Sa.prototype, ma), Sa;
              }
              function dh(Sa) {
                if (Sa === void 0)
                  throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return Sa;
              }
              function Bd(Sa, ma) {
                Sa.prototype = Object.create(ma.prototype), Sa.prototype.constructor = Sa, Sa.__proto__ = ma;
              }
              var Jc = window, ep = Jc.performance, Mf = /* @__PURE__ */ (function(Sa) {
                Bd(ma, Sa);
                function ma(Io) {
                  var Ri;
                  return Ri = Sa.call(this, Io, si.default.FRAG_LOADING, si.default.FRAG_LOADED, si.default.FRAG_BUFFERED, si.default.ERROR) || this, Ri.lastLoadedFragLevel = 0, Ri._nextAutoLevel = -1, Ri.hls = Io, Ri.timer = null, Ri._bwEstimator = null, Ri.onCheck = Ri._abandonRulesCheck.bind(dh(Ri)), Ri;
                }
                var Ho = ma.prototype;
                return Ho.destroy = function() {
                  this.clearTimer(), mi.prototype.destroy.call(this);
                }, Ho.onFragLoading = function(Ri) {
                  var qi = Ri.frag;
                  if (qi.type === "main" && (this.timer || (this.fragCurrent = qi, this.timer = setInterval(this.onCheck, 100)), !this._bwEstimator)) {
                    var Yo = this.hls, ba = Yo.config, Na = qi.level, Ma = Yo.levels[Na].details.live, bs, Ds;
                    Ma ? (bs = ba.abrEwmaFastLive, Ds = ba.abrEwmaSlowLive) : (bs = ba.abrEwmaFastVoD, Ds = ba.abrEwmaSlowVoD), this._bwEstimator = new fd(Yo, Ds, bs, ba.abrEwmaDefaultEstimate);
                  }
                }, Ho._abandonRulesCheck = function() {
                  var Ri = this.hls, qi = Ri.media, Yo = this.fragCurrent;
                  if (Yo) {
                    var ba = Yo.loader;
                    if (!ba || ba.stats && ba.stats.aborted) {
                      di.logger.warn("frag loader destroy or aborted, disarm abandonRules"), this.clearTimer(), this._nextAutoLevel = -1;
                      return;
                    }
                    var Na = ba.stats;
                    if (qi && Na && (!qi.paused && qi.playbackRate !== 0 || !qi.readyState) && Yo.autoLevel && Yo.level) {
                      var Ma = ep.now() - Na.trequest, bs = Math.abs(qi.playbackRate);
                      if (Ma > 500 * Yo.duration / bs) {
                        var Ds = Ri.levels, Fs = Math.max(1, Na.bw ? Na.bw / 8 : Na.loaded * 1e3 / Ma), _l = Ds[Yo.level];
                        if (!_l)
                          return;
                        var Ll = _l.realBitrate ? Math.max(_l.realBitrate, _l.bitrate) : _l.bitrate, eu = Na.total ? Na.total : Math.max(Na.loaded, Math.round(Yo.duration * Ll / 8)), fu = qi.currentTime, Fu = (eu - Na.loaded) / Fs, Ou = (ja.bufferInfo(qi, fu, Ri.config.maxBufferHole).end - fu) / bs;
                        if (Ou < 2 * Yo.duration / bs && Fu > Ou) {
                          var qu = Ri.minAutoLevel, Ju, nc;
                          for (nc = Yo.level - 1; nc > qu; nc--) {
                            var $c = Ds[nc].realBitrate ? Math.max(Ds[nc].realBitrate, Ds[nc].bitrate) : Ds[nc].bitrate, Rc = Yo.duration * $c / (8 * 0.8 * Fs);
                            if (Rc < Ou)
                              break;
                          }
                          Ju < Fu && (di.logger.warn("loading too slow, abort fragment loading and switch to level " + nc + ":fragLoadedDelay[" + nc + "]<fragLoadedDelay[" + (Yo.level - 1) + "];bufferStarvationDelay:" + Ju.toFixed(1) + "<" + Fu.toFixed(1) + ":" + Ou.toFixed(1)), Ri.nextLoadLevel = nc, this._bwEstimator.sample(Ma, Na.loaded), ba.abort(), this.clearTimer(), Ri.trigger(si.default.FRAG_LOAD_EMERGENCY_ABORTED, {
                            frag: Yo,
                            stats: Na
                          }));
                        }
                      }
                    }
                  }
                }, Ho.onFragLoaded = function(Ri) {
                  var qi = Ri.frag;
                  if (qi.type === "main" && Object(oi.isFiniteNumber)(qi.sn)) {
                    if (this.clearTimer(), this.lastLoadedFragLevel = qi.level, this._nextAutoLevel = -1, this.hls.config.abrMaxWithRealBitrate) {
                      var Yo = this.hls.levels[qi.level], ba = (Yo.loaded ? Yo.loaded.bytes : 0) + Ri.stats.loaded, Na = (Yo.loaded ? Yo.loaded.duration : 0) + Ri.frag.duration;
                      Yo.loaded = {
                        bytes: ba,
                        duration: Na
                      }, Yo.realBitrate = Math.round(8 * ba / Na);
                    }
                    if (Ri.frag.bitrateTest) {
                      var Ma = Ri.stats;
                      Ma.tparsed = Ma.tbuffered = Ma.tload, this.onFragBuffered(Ri);
                    }
                  }
                }, Ho.onFragBuffered = function(Ri) {
                  var qi = Ri.stats, Yo = Ri.frag;
                  if (qi.aborted !== !0 && Yo.type === "main" && Object(oi.isFiniteNumber)(Yo.sn) && (!Yo.bitrateTest || qi.tload === qi.tbuffered)) {
                    var ba = qi.tparsed - qi.trequest;
                    di.logger.log("latency/loading/parsing/append/kbps:" + Math.round(qi.tfirst - qi.trequest) + "/" + Math.round(qi.tload - qi.tfirst) + "/" + Math.round(qi.tparsed - qi.tload) + "/" + Math.round(qi.tbuffered - qi.tparsed) + "/" + Math.round(8 * qi.loaded / (qi.tbuffered - qi.trequest))), this._bwEstimator.sample(ba, qi.loaded), qi.bwEstimate = this._bwEstimator.getEstimate(), Yo.bitrateTest ? this.bitrateTestDelay = ba / 1e3 : this.bitrateTestDelay = 0;
                  }
                }, Ho.onError = function(Ri) {
                  switch (Ri.details) {
                    case li.ErrorDetails.FRAG_LOAD_ERROR:
                    case li.ErrorDetails.FRAG_LOAD_TIMEOUT:
                      this.clearTimer();
                      break;
                  }
                }, Ho.clearTimer = function() {
                  clearInterval(this.timer), this.timer = null;
                }, Ho._findBestLevel = function(Ri, qi, Yo, ba, Na, Ma, bs, Ds, Fs) {
                  for (var _l = Na; _l >= ba; _l--) {
                    var Ll = Fs[_l];
                    if (Ll) {
                      var eu = Ll.details, fu = eu ? eu.totalduration / eu.fragments.length : qi, Fu = eu ? eu.live : !1, Ou = void 0;
                      _l <= Ri ? Ou = bs * Yo : Ou = Ds * Yo;
                      var qu = Fs[_l].realBitrate ? Math.max(Fs[_l].realBitrate, Fs[_l].bitrate) : Fs[_l].bitrate, Ju = qu * fu / Ou;
                      if (di.logger.trace("level/adjustedbw/bitrate/avgDuration/maxFetchDuration/fetchDuration: " + _l + "/" + Math.round(Ou) + "/" + qu + "/" + fu + "/" + Ma + "/" + Ju), Ou > qu && // fragment fetchDuration unknown OR live stream OR fragment fetchDuration less than max allowed fetch duration, then this level matches
                      // we don't account for max Fetch Duration for live streams, this is to avoid switching down when near the edge of live sliding window ...
                      // special case to support startLevel = -1 (bitrateTest) on live streams : in that case we should not exit loop so that _findBestLevel will return -1
                      (!Ju || Fu && !this.bitrateTestDelay || Ju < Ma))
                        return _l;
                    }
                  }
                  return -1;
                }, _c(ma, [{
                  key: "nextAutoLevel",
                  get: function() {
                    var Ri = this._nextAutoLevel, qi = this._bwEstimator;
                    if (Ri !== -1 && (!qi || !qi.canEstimate()))
                      return Ri;
                    var Yo = this._nextABRAutoLevel;
                    return Ri !== -1 && (Yo = Math.min(Ri, Yo)), Yo;
                  },
                  set: function(Ri) {
                    this._nextAutoLevel = Ri;
                  }
                }, {
                  key: "_nextABRAutoLevel",
                  get: function() {
                    var Ri = this.hls, qi = Ri.maxAutoLevel, Yo = Ri.levels, ba = Ri.config, Na = Ri.minAutoLevel, Ma = Ri.media, bs = this.lastLoadedFragLevel, Ds = this.fragCurrent ? this.fragCurrent.duration : 0, Fs = Ma ? Ma.currentTime : 0, _l = Ma && Ma.playbackRate !== 0 ? Math.abs(Ma.playbackRate) : 1, Ll = this._bwEstimator ? this._bwEstimator.getEstimate() : ba.abrEwmaDefaultEstimate, eu = (ja.bufferInfo(Ma, Fs, ba.maxBufferHole).end - Fs) / _l, fu = this._findBestLevel(bs, Ds, Ll, Na, qi, eu, ba.abrBandWidthFactor, ba.abrBandWidthUpFactor, Yo);
                    if (fu >= 0)
                      return fu;
                    di.logger.trace("rebuffering expected to happen, lets try to find a quality level minimizing the rebuffering");
                    var Fu = Ds ? Math.min(Ds, ba.maxStarvationDelay) : ba.maxStarvationDelay, Ou = ba.abrBandWidthFactor, qu = ba.abrBandWidthUpFactor;
                    if (eu === 0) {
                      var Ju = this.bitrateTestDelay;
                      if (Ju) {
                        var nc = Ds ? Math.min(Ds, ba.maxLoadingDelay) : ba.maxLoadingDelay;
                        Fu = nc - Ju, di.logger.trace("bitrate test took " + Math.round(1e3 * Ju) + "ms, set first fragment max fetchDuration to " + Math.round(1e3 * Fu) + " ms"), Ou = qu = 1;
                      }
                    }
                    return fu = this._findBestLevel(bs, Ds, Ll, Na, qi, eu + Fu, Ou, qu, Yo), Math.max(fu, 0);
                  }
                }]), ma;
              })(mi), Kh = Mf;
              function pd(Sa, ma) {
                Sa.prototype = Object.create(ma.prototype), Sa.prototype.constructor = Sa, Sa.__proto__ = ma;
              }
              var Cc = Cs(), jf = /* @__PURE__ */ (function(Sa) {
                pd(ma, Sa);
                function ma(Io) {
                  var Ri;
                  return Ri = Sa.call(this, Io, si.default.MEDIA_ATTACHING, si.default.MEDIA_DETACHING, si.default.MANIFEST_PARSED, si.default.BUFFER_RESET, si.default.BUFFER_APPENDING, si.default.BUFFER_CODECS, si.default.BUFFER_EOS, si.default.BUFFER_FLUSHING, si.default.LEVEL_PTS_UPDATED, si.default.LEVEL_UPDATED) || this, Ri._msDuration = null, Ri._levelDuration = null, Ri._levelTargetDuration = 10, Ri._live = null, Ri._objectUrl = null, Ri._needsFlush = !1, Ri._needsEos = !1, Ri.config = void 0, Ri.audioTimestampOffset = void 0, Ri.bufferCodecEventsExpected = 0, Ri._bufferCodecEventsTotal = 0, Ri.media = null, Ri.mediaSource = null, Ri.segments = [], Ri.parent = void 0, Ri.appending = !1, Ri.appended = 0, Ri.appendError = 0, Ri.flushBufferCounter = 0, Ri.tracks = {}, Ri.pendingTracks = {}, Ri.sourceBuffer = {}, Ri.flushRange = [], Ri._onMediaSourceOpen = function() {
                    di.logger.log("media source opened"), Ri.hls.trigger(si.default.MEDIA_ATTACHED, {
                      media: Ri.media
                    });
                    var qi = Ri.mediaSource;
                    qi && qi.removeEventListener("sourceopen", Ri._onMediaSourceOpen), Ri.checkPendingTracks();
                  }, Ri._onMediaSourceClose = function() {
                    di.logger.log("media source closed");
                  }, Ri._onMediaSourceEnded = function() {
                    di.logger.log("media source ended");
                  }, Ri._onSBUpdateEnd = function() {
                    if (Ri.audioTimestampOffset && Ri.sourceBuffer.audio) {
                      var qi = Ri.sourceBuffer.audio;
                      di.logger.warn("change mpeg audio timestamp offset from " + qi.timestampOffset + " to " + Ri.audioTimestampOffset), qi.timestampOffset = Ri.audioTimestampOffset, delete Ri.audioTimestampOffset;
                    }
                    Ri._needsFlush && Ri.doFlush(), Ri._needsEos && Ri.checkEos(), Ri.appending = !1;
                    var Yo = Ri.parent, ba = Ri.segments.reduce(function(Fs, _l) {
                      return _l.parent === Yo ? Fs + 1 : Fs;
                    }, 0), Na = {}, Ma = Ri.sourceBuffer;
                    for (var bs in Ma) {
                      var Ds = Ma[bs];
                      if (!Ds)
                        throw Error("handling source buffer update end error: source buffer for " + bs + " uninitilized and unable to update buffered TimeRanges.");
                      Na[bs] = Ds.buffered;
                    }
                    Ri.hls.trigger(si.default.BUFFER_APPENDED, {
                      parent: Yo,
                      pending: ba,
                      timeRanges: Na
                    }), Ri._needsFlush || Ri.doAppending(), Ri.updateMediaElementDuration(), ba === 0 && Ri.flushLiveBackBuffer();
                  }, Ri._onSBUpdateError = function(qi) {
                    di.logger.error("sourceBuffer error:", qi), Ri.hls.trigger(si.default.ERROR, {
                      type: li.ErrorTypes.MEDIA_ERROR,
                      details: li.ErrorDetails.BUFFER_APPENDING_ERROR,
                      fatal: !1
                    });
                  }, Ri.config = Io.config, Ri;
                }
                var Ho = ma.prototype;
                return Ho.destroy = function() {
                  mi.prototype.destroy.call(this);
                }, Ho.onLevelPtsUpdated = function(Ri) {
                  var qi = Ri.type, Yo = this.tracks.audio;
                  if (qi === "audio" && Yo && Yo.container === "audio/mpeg") {
                    var ba = this.sourceBuffer.audio;
                    if (!ba)
                      throw Error("Level PTS Updated and source buffer for audio uninitalized");
                    var Na = Math.abs(ba.timestampOffset - Ri.start);
                    if (Na > 0.1) {
                      var Ma = ba.updating;
                      try {
                        ba.abort();
                      } catch (bs) {
                        di.logger.warn("can not abort audio buffer: " + bs);
                      }
                      Ma ? this.audioTimestampOffset = Ri.start : (di.logger.warn("change mpeg audio timestamp offset from " + ba.timestampOffset + " to " + Ri.start), ba.timestampOffset = Ri.start);
                    }
                  }
                }, Ho.onManifestParsed = function(Ri) {
                  var qi = 2;
                  (Ri.audio && !Ri.video || !Ri.altAudio) && (qi = 1), this.bufferCodecEventsExpected = this._bufferCodecEventsTotal = qi, di.logger.log(this.bufferCodecEventsExpected + " bufferCodec event(s) expected");
                }, Ho.onMediaAttaching = function(Ri) {
                  var qi = this.media = Ri.media;
                  if (qi && Cc) {
                    var Yo = this.mediaSource = new Cc();
                    Yo.addEventListener("sourceopen", this._onMediaSourceOpen), Yo.addEventListener("sourceended", this._onMediaSourceEnded), Yo.addEventListener("sourceclose", this._onMediaSourceClose), qi.src = window.URL.createObjectURL(Yo), this._objectUrl = qi.src;
                  }
                }, Ho.onMediaDetaching = function() {
                  di.logger.log("media source detaching");
                  var Ri = this.mediaSource;
                  if (Ri) {
                    if (Ri.readyState === "open")
                      try {
                        Ri.endOfStream();
                      } catch (qi) {
                        di.logger.warn("onMediaDetaching:" + qi.message + " while calling endOfStream");
                      }
                    Ri.removeEventListener("sourceopen", this._onMediaSourceOpen), Ri.removeEventListener("sourceended", this._onMediaSourceEnded), Ri.removeEventListener("sourceclose", this._onMediaSourceClose), this.media && (this._objectUrl && window.URL.revokeObjectURL(this._objectUrl), this.media.src === this._objectUrl ? (this.media.removeAttribute("src"), this.media.load()) : di.logger.warn("media.src was changed by a third party - skip cleanup")), this.mediaSource = null, this.media = null, this._objectUrl = null, this.bufferCodecEventsExpected = this._bufferCodecEventsTotal, this.pendingTracks = {}, this.tracks = {}, this.sourceBuffer = {}, this.flushRange = [], this.segments = [], this.appended = 0;
                  }
                  this.hls.trigger(si.default.MEDIA_DETACHED);
                }, Ho.checkPendingTracks = function() {
                  var Ri = this.bufferCodecEventsExpected, qi = this.pendingTracks, Yo = Object.keys(qi).length;
                  (Yo && !Ri || Yo === 2) && (this.createSourceBuffers(qi), this.pendingTracks = {}, this.doAppending());
                }, Ho.onBufferReset = function() {
                  var Ri = this.sourceBuffer;
                  for (var qi in Ri) {
                    var Yo = Ri[qi];
                    try {
                      Yo && (this.mediaSource && this.mediaSource.removeSourceBuffer(Yo), Yo.removeEventListener("updateend", this._onSBUpdateEnd), Yo.removeEventListener("error", this._onSBUpdateError));
                    } catch {
                    }
                  }
                  this.sourceBuffer = {}, this.flushRange = [], this.segments = [], this.appended = 0;
                }, Ho.onBufferCodecs = function(Ri) {
                  var qi = this;
                  Object.keys(this.sourceBuffer).length || (Object.keys(Ri).forEach(function(Yo) {
                    qi.pendingTracks[Yo] = Ri[Yo];
                  }), this.bufferCodecEventsExpected = Math.max(this.bufferCodecEventsExpected - 1, 0), this.mediaSource && this.mediaSource.readyState === "open" && this.checkPendingTracks());
                }, Ho.createSourceBuffers = function(Ri) {
                  var qi = this.sourceBuffer, Yo = this.mediaSource;
                  if (!Yo)
                    throw Error("createSourceBuffers called when mediaSource was null");
                  for (var ba in Ri)
                    if (!qi[ba]) {
                      var Na = Ri[ba];
                      if (!Na)
                        throw Error("source buffer exists for track " + ba + ", however track does not");
                      var Ma = Na.levelCodec || Na.codec, bs = Na.container + ";codecs=" + Ma;
                      di.logger.log("creating sourceBuffer(" + bs + ")");
                      try {
                        var Ds = qi[ba] = Yo.addSourceBuffer(bs);
                        Ds.addEventListener("updateend", this._onSBUpdateEnd), Ds.addEventListener("error", this._onSBUpdateError), this.tracks[ba] = {
                          buffer: Ds,
                          codec: Ma,
                          id: Na.id,
                          container: Na.container,
                          levelCodec: Na.levelCodec
                        };
                      } catch (Fs) {
                        di.logger.error("error while trying to add sourceBuffer:" + Fs.message), this.hls.trigger(si.default.ERROR, {
                          type: li.ErrorTypes.MEDIA_ERROR,
                          details: li.ErrorDetails.BUFFER_ADD_CODEC_ERROR,
                          fatal: !1,
                          err: Fs,
                          mimeType: bs
                        });
                      }
                    }
                  this.hls.trigger(si.default.BUFFER_CREATED, {
                    tracks: this.tracks
                  });
                }, Ho.onBufferAppending = function(Ri) {
                  this._needsFlush || (this.segments ? this.segments.push(Ri) : this.segments = [Ri], this.doAppending());
                }, Ho.onBufferEos = function(Ri) {
                  for (var qi in this.sourceBuffer)
                    if (!Ri.type || Ri.type === qi) {
                      var Yo = this.sourceBuffer[qi];
                      Yo && !Yo.ended && (Yo.ended = !0, di.logger.log(qi + " sourceBuffer now EOS"));
                    }
                  this.checkEos();
                }, Ho.checkEos = function() {
                  var Ri = this.sourceBuffer, qi = this.mediaSource;
                  if (!qi || qi.readyState !== "open") {
                    this._needsEos = !1;
                    return;
                  }
                  for (var Yo in Ri) {
                    var ba = Ri[Yo];
                    if (ba) {
                      if (!ba.ended)
                        return;
                      if (ba.updating) {
                        this._needsEos = !0;
                        return;
                      }
                    }
                  }
                  di.logger.log("all media data are available, signal endOfStream() to MediaSource and stop loading fragment");
                  try {
                    qi.endOfStream();
                  } catch {
                    di.logger.warn("exception while calling mediaSource.endOfStream()");
                  }
                  this._needsEos = !1;
                }, Ho.onBufferFlushing = function(Ri) {
                  Ri.type ? this.flushRange.push({
                    start: Ri.startOffset,
                    end: Ri.endOffset,
                    type: Ri.type
                  }) : (this.flushRange.push({
                    start: Ri.startOffset,
                    end: Ri.endOffset,
                    type: "video"
                  }), this.flushRange.push({
                    start: Ri.startOffset,
                    end: Ri.endOffset,
                    type: "audio"
                  })), this.flushBufferCounter = 0, this.doFlush();
                }, Ho.flushLiveBackBuffer = function() {
                  if (this._live) {
                    var Ri = this.config.liveBackBufferLength;
                    if (!(!isFinite(Ri) || Ri < 0)) {
                      if (!this.media) {
                        di.logger.error("flushLiveBackBuffer called without attaching media");
                        return;
                      }
                      for (var qi = this.media.currentTime, Yo = this.sourceBuffer, ba = Object.keys(Yo), Na = qi - Math.max(Ri, this._levelTargetDuration), Ma = ba.length - 1; Ma >= 0; Ma--) {
                        var bs = ba[Ma], Ds = Yo[bs];
                        if (Ds) {
                          var Fs = Ds.buffered;
                          Fs.length > 0 && Na > Fs.start(0) && this.removeBufferRange(bs, Ds, 0, Na) && this.hls.trigger(si.default.LIVE_BACK_BUFFER_REACHED, {
                            bufferEnd: Na
                          });
                        }
                      }
                    }
                  }
                }, Ho.onLevelUpdated = function(Ri) {
                  var qi = Ri.details;
                  qi.fragments.length > 0 && (this._levelDuration = qi.totalduration + qi.fragments[0].start, this._levelTargetDuration = qi.averagetargetduration || qi.targetduration || 10, this._live = qi.live, this.updateMediaElementDuration());
                }, Ho.updateMediaElementDuration = function() {
                  var Ri = this.config, qi;
                  if (!(this._levelDuration === null || !this.media || !this.mediaSource || !this.sourceBuffer || this.media.readyState === 0 || this.mediaSource.readyState !== "open")) {
                    for (var Yo in this.sourceBuffer) {
                      var ba = this.sourceBuffer[Yo];
                      if (ba && ba.updating === !0)
                        return;
                    }
                    qi = this.media.duration, this._msDuration === null && (this._msDuration = this.mediaSource.duration), this._live === !0 && Ri.liveDurationInfinity === !0 ? (di.logger.log("Media Source duration is set to Infinity"), this._msDuration = this.mediaSource.duration = 1 / 0) : (this._levelDuration > this._msDuration && this._levelDuration > qi || !Object(oi.isFiniteNumber)(qi)) && (di.logger.log("Updating Media Source duration to " + this._levelDuration.toFixed(3)), this._msDuration = this.mediaSource.duration = this._levelDuration);
                  }
                }, Ho.doFlush = function() {
                  for (; this.flushRange.length; ) {
                    var Ri = this.flushRange[0];
                    if (this.flushBuffer(Ri.start, Ri.end, Ri.type))
                      this.flushRange.shift(), this.flushBufferCounter = 0;
                    else {
                      this._needsFlush = !0;
                      return;
                    }
                  }
                  if (this.flushRange.length === 0) {
                    this._needsFlush = !1;
                    var qi = 0, Yo = this.sourceBuffer;
                    try {
                      for (var ba in Yo) {
                        var Na = Yo[ba];
                        Na && (qi += Na.buffered.length);
                      }
                    } catch {
                      di.logger.error("error while accessing sourceBuffer.buffered");
                    }
                    this.appended = qi, this.hls.trigger(si.default.BUFFER_FLUSHED);
                  }
                }, Ho.doAppending = function() {
                  var Ri = this.config, qi = this.hls, Yo = this.segments, ba = this.sourceBuffer;
                  if (Object.keys(ba).length) {
                    if (!this.media || this.media.error) {
                      this.segments = [], di.logger.error("trying to append although a media error occured, flush segment and abort");
                      return;
                    }
                    if (!this.appending) {
                      var Na = Yo.shift();
                      if (Na)
                        try {
                          var Ma = ba[Na.type];
                          if (!Ma) {
                            this._onSBUpdateEnd();
                            return;
                          }
                          if (Ma.updating) {
                            Yo.unshift(Na);
                            return;
                          }
                          Ma.ended = !1, this.parent = Na.parent, Ma.appendBuffer(Na.data), this.appendError = 0, this.appended++, this.appending = !0;
                        } catch (Ds) {
                          di.logger.error("error while trying to append buffer:" + Ds.message), Yo.unshift(Na);
                          var bs = {
                            type: li.ErrorTypes.MEDIA_ERROR,
                            parent: Na.parent,
                            details: "",
                            fatal: !1
                          };
                          Ds.code === 22 ? (this.segments = [], bs.details = li.ErrorDetails.BUFFER_FULL_ERROR) : (this.appendError++, bs.details = li.ErrorDetails.BUFFER_APPEND_ERROR, this.appendError > Ri.appendErrorMaxRetry && (di.logger.log("fail " + Ri.appendErrorMaxRetry + " times to append segment in sourceBuffer"), this.segments = [], bs.fatal = !0)), qi.trigger(si.default.ERROR, bs);
                        }
                    }
                  }
                }, Ho.flushBuffer = function(Ri, qi, Yo) {
                  var ba = this.sourceBuffer;
                  if (!Object.keys(ba).length)
                    return !0;
                  var Na = "null";
                  if (this.media && (Na = this.media.currentTime.toFixed(3)), di.logger.log("flushBuffer,pos/start/end: " + Na + "/" + Ri + "/" + qi), this.flushBufferCounter >= this.appended)
                    return di.logger.warn("abort flushing too many retries"), !0;
                  var Ma = ba[Yo];
                  if (Ma) {
                    if (Ma.ended = !1, Ma.updating)
                      return di.logger.warn("cannot flush, sb updating in progress"), !1;
                    if (this.removeBufferRange(Yo, Ma, Ri, qi))
                      return this.flushBufferCounter++, !1;
                  }
                  return di.logger.log("buffer flushed"), !0;
                }, Ho.removeBufferRange = function(Ri, qi, Yo, ba) {
                  try {
                    for (var Na = 0; Na < qi.buffered.length; Na++) {
                      var Ma = qi.buffered.start(Na), bs = qi.buffered.end(Na), Ds = Math.max(Ma, Yo), Fs = Math.min(bs, ba);
                      if (Math.min(Fs, bs) - Ds > 0.5) {
                        var _l = "null";
                        return this.media && (_l = this.media.currentTime.toString()), di.logger.log("sb remove " + Ri + " [" + Ds + "," + Fs + "], of [" + Ma + "," + bs + "], pos:" + _l), qi.remove(Ds, Fs), !0;
                      }
                    }
                  } catch (Ll) {
                    di.logger.warn("removeBufferRange failed", Ll);
                  }
                  return !1;
                }, ma;
              })(mi), tp = jf;
              function Fp(Sa, ma) {
                for (var Ho = 0; Ho < ma.length; Ho++) {
                  var Io = ma[Ho];
                  Io.enumerable = Io.enumerable || !1, Io.configurable = !0, "value" in Io && (Io.writable = !0), Object.defineProperty(Sa, Io.key, Io);
                }
              }
              function fh(Sa, ma, Ho) {
                return ma && Fp(Sa.prototype, ma), Ho && Fp(Sa, Ho), Sa;
              }
              function Qc(Sa, ma) {
                Sa.prototype = Object.create(ma.prototype), Sa.prototype.constructor = Sa, Sa.__proto__ = ma;
              }
              var Tc = /* @__PURE__ */ (function(Sa) {
                Qc(ma, Sa);
                function ma(Io) {
                  var Ri;
                  return Ri = Sa.call(this, Io, si.default.FPS_DROP_LEVEL_CAPPING, si.default.MEDIA_ATTACHING, si.default.MANIFEST_PARSED, si.default.LEVELS_UPDATED, si.default.BUFFER_CODECS, si.default.MEDIA_DETACHING) || this, Ri.autoLevelCapping = Number.POSITIVE_INFINITY, Ri.firstLevel = null, Ri.levels = [], Ri.media = null, Ri.restrictedLevels = [], Ri.timer = null, Ri.clientRect = null, Ri;
                }
                var Ho = ma.prototype;
                return Ho.destroy = function() {
                  this.hls.config.capLevelToPlayerSize && (this.media = null, this.clientRect = null, this.stopCapping());
                }, Ho.onFpsDropLevelCapping = function(Ri) {
                  ma.isLevelAllowed(Ri.droppedLevel, this.restrictedLevels) && this.restrictedLevels.push(Ri.droppedLevel);
                }, Ho.onMediaAttaching = function(Ri) {
                  this.media = Ri.media instanceof window.HTMLVideoElement ? Ri.media : null;
                }, Ho.onManifestParsed = function(Ri) {
                  var qi = this.hls;
                  this.restrictedLevels = [], this.levels = Ri.levels, this.firstLevel = Ri.firstLevel, qi.config.capLevelToPlayerSize && Ri.video && this.startCapping();
                }, Ho.onBufferCodecs = function(Ri) {
                  var qi = this.hls;
                  qi.config.capLevelToPlayerSize && Ri.video && this.startCapping();
                }, Ho.onLevelsUpdated = function(Ri) {
                  this.levels = Ri.levels;
                }, Ho.onMediaDetaching = function() {
                  this.stopCapping();
                }, Ho.detectPlayerSize = function() {
                  if (this.media) {
                    var Ri = this.levels ? this.levels.length : 0;
                    if (Ri) {
                      var qi = this.hls;
                      qi.autoLevelCapping = this.getMaxLevel(Ri - 1), qi.autoLevelCapping > this.autoLevelCapping && qi.streamController.nextLevelSwitch(), this.autoLevelCapping = qi.autoLevelCapping;
                    }
                  }
                }, Ho.getMaxLevel = function(Ri) {
                  var qi = this;
                  if (!this.levels)
                    return -1;
                  var Yo = this.levels.filter(function(ba, Na) {
                    return ma.isLevelAllowed(Na, qi.restrictedLevels) && Na <= Ri;
                  });
                  return this.clientRect = null, ma.getMaxLevelByMediaSize(Yo, this.mediaWidth, this.mediaHeight);
                }, Ho.startCapping = function() {
                  this.timer || (this.autoLevelCapping = Number.POSITIVE_INFINITY, this.hls.firstLevel = this.getMaxLevel(this.firstLevel), clearInterval(this.timer), this.timer = setInterval(this.detectPlayerSize.bind(this), 1e3), this.detectPlayerSize());
                }, Ho.stopCapping = function() {
                  this.restrictedLevels = [], this.firstLevel = null, this.autoLevelCapping = Number.POSITIVE_INFINITY, this.timer && (this.timer = clearInterval(this.timer), this.timer = null);
                }, Ho.getDimensions = function() {
                  if (this.clientRect)
                    return this.clientRect;
                  var Ri = this.media, qi = {
                    width: 0,
                    height: 0
                  };
                  if (Ri) {
                    var Yo = Ri.getBoundingClientRect();
                    qi.width = Yo.width, qi.height = Yo.height, !qi.width && !qi.height && (qi.width = Yo.right - Yo.left || Ri.width || 0, qi.height = Yo.bottom - Yo.top || Ri.height || 0);
                  }
                  return this.clientRect = qi, qi;
                }, ma.isLevelAllowed = function(Ri, qi) {
                  return qi === void 0 && (qi = []), qi.indexOf(Ri) === -1;
                }, ma.getMaxLevelByMediaSize = function(Ri, qi, Yo) {
                  if (!Ri || Ri && !Ri.length)
                    return -1;
                  for (var ba = function(Fs, _l) {
                    return _l ? Fs.width !== _l.width || Fs.height !== _l.height : !0;
                  }, Na = Ri.length - 1, Ma = 0; Ma < Ri.length; Ma += 1) {
                    var bs = Ri[Ma];
                    if ((bs.width >= qi || bs.height >= Yo) && ba(bs, Ri[Ma + 1])) {
                      Na = Ma;
                      break;
                    }
                  }
                  return Na;
                }, fh(ma, [{
                  key: "mediaWidth",
                  get: function() {
                    return this.getDimensions().width * ma.contentScaleFactor;
                  }
                }, {
                  key: "mediaHeight",
                  get: function() {
                    return this.getDimensions().height * ma.contentScaleFactor;
                  }
                }], [{
                  key: "contentScaleFactor",
                  get: function() {
                    var Ri = 1;
                    try {
                      Ri = window.devicePixelRatio;
                    } catch {
                    }
                    return Ri;
                  }
                }]), ma;
              })(mi), Ud = Tc;
              function Ff(Sa, ma) {
                Sa.prototype = Object.create(ma.prototype), Sa.prototype.constructor = Sa, Sa.__proto__ = ma;
              }
              var Kc = window, vf = Kc.performance, mp = /* @__PURE__ */ (function(Sa) {
                Ff(ma, Sa);
                function ma(Io) {
                  return Sa.call(this, Io, si.default.MEDIA_ATTACHING) || this;
                }
                var Ho = ma.prototype;
                return Ho.destroy = function() {
                  this.timer && clearInterval(this.timer), this.isVideoPlaybackQualityAvailable = !1;
                }, Ho.onMediaAttaching = function(Ri) {
                  var qi = this.hls.config;
                  if (qi.capLevelOnFPSDrop) {
                    var Yo = this.video = Ri.media instanceof window.HTMLVideoElement ? Ri.media : null;
                    typeof Yo.getVideoPlaybackQuality == "function" && (this.isVideoPlaybackQualityAvailable = !0), clearInterval(this.timer), this.timer = setInterval(this.checkFPSInterval.bind(this), qi.fpsDroppedMonitoringPeriod);
                  }
                }, Ho.checkFPS = function(Ri, qi, Yo) {
                  var ba = vf.now();
                  if (qi) {
                    if (this.lastTime) {
                      var Na = ba - this.lastTime, Ma = Yo - this.lastDroppedFrames, bs = qi - this.lastDecodedFrames, Ds = 1e3 * Ma / Na, Fs = this.hls;
                      if (Fs.trigger(si.default.FPS_DROP, {
                        currentDropped: Ma,
                        currentDecoded: bs,
                        totalDroppedFrames: Yo
                      }), Ds > 0 && Ma > Fs.config.fpsDroppedMonitoringThreshold * bs) {
                        var _l = Fs.currentLevel;
                        di.logger.warn("drop FPS ratio greater than max allowed value for currentLevel: " + _l), _l > 0 && (Fs.autoLevelCapping === -1 || Fs.autoLevelCapping >= _l) && (_l = _l - 1, Fs.trigger(si.default.FPS_DROP_LEVEL_CAPPING, {
                          level: _l,
                          droppedLevel: Fs.currentLevel
                        }), Fs.autoLevelCapping = _l, Fs.streamController.nextLevelSwitch());
                      }
                    }
                    this.lastTime = ba, this.lastDroppedFrames = Yo, this.lastDecodedFrames = qi;
                  }
                }, Ho.checkFPSInterval = function() {
                  var Ri = this.video;
                  if (Ri)
                    if (this.isVideoPlaybackQualityAvailable) {
                      var qi = Ri.getVideoPlaybackQuality();
                      this.checkFPS(Ri, qi.totalVideoFrames, qi.droppedVideoFrames);
                    } else
                      this.checkFPS(Ri, Ri.webkitDecodedFrameCount, Ri.webkitDroppedFrameCount);
                }, ma;
              })(mi), Vd = mp, Wd = /* @__PURE__ */ (function() {
                function Sa(Ho) {
                  Ho && Ho.xhrSetup && (this.xhrSetup = Ho.xhrSetup);
                }
                var ma = Sa.prototype;
                return ma.destroy = function() {
                  this.abort(), this.loader = null;
                }, ma.abort = function() {
                  var Io = this.loader;
                  Io && Io.readyState !== 4 && (this.stats.aborted = !0, Io.abort()), window.clearTimeout(this.requestTimeout), this.requestTimeout = null, window.clearTimeout(this.retryTimeout), this.retryTimeout = null;
                }, ma.load = function(Io, Ri, qi) {
                  this.context = Io, this.config = Ri, this.callbacks = qi, this.stats = {
                    trequest: window.performance.now(),
                    retry: 0
                  }, this.retryDelay = Ri.retryDelay, this.loadInternal();
                }, ma.loadInternal = function() {
                  var Io, Ri = this.context;
                  Io = this.loader = new window.XMLHttpRequest();
                  var qi = this.stats;
                  qi.tfirst = 0, qi.loaded = 0;
                  var Yo = this.xhrSetup;
                  try {
                    if (Yo)
                      try {
                        Yo(Io, Ri.url);
                      } catch {
                        Io.open("GET", Ri.url, !0), Yo(Io, Ri.url);
                      }
                    Io.readyState || Io.open("GET", Ri.url, !0);
                  } catch (ba) {
                    this.callbacks.onError({
                      code: Io.status,
                      text: ba.message
                    }, Ri, Io);
                    return;
                  }
                  Ri.rangeEnd && Io.setRequestHeader("Range", "bytes=" + Ri.rangeStart + "-" + (Ri.rangeEnd - 1)), Io.onreadystatechange = this.readystatechange.bind(this), Io.onprogress = this.loadprogress.bind(this), Io.responseType = Ri.responseType, this.requestTimeout = window.setTimeout(this.loadtimeout.bind(this), this.config.timeout), Io.send();
                }, ma.readystatechange = function(Io) {
                  var Ri = Io.currentTarget, qi = Ri.readyState, Yo = this.stats, ba = this.context, Na = this.config;
                  if (!Yo.aborted && qi >= 2)
                    if (window.clearTimeout(this.requestTimeout), Yo.tfirst === 0 && (Yo.tfirst = Math.max(window.performance.now(), Yo.trequest)), qi === 4) {
                      var Ma = Ri.status;
                      if (Ma >= 200 && Ma < 300) {
                        Yo.tload = Math.max(Yo.tfirst, window.performance.now());
                        var bs, Ds;
                        ba.responseType === "arraybuffer" ? (bs = Ri.response, Ds = bs.byteLength) : (bs = Ri.responseText, Ds = bs.length), Yo.loaded = Yo.total = Ds;
                        var Fs = {
                          url: Ri.responseURL,
                          data: bs
                        };
                        this.callbacks.onSuccess(Fs, Yo, ba, Ri);
                      } else
                        Yo.retry >= Na.maxRetry || Ma >= 400 && Ma < 499 ? (di.logger.error(Ma + " while loading " + ba.url), this.callbacks.onError({
                          code: Ma,
                          text: Ri.statusText
                        }, ba, Ri)) : (di.logger.warn(Ma + " while loading " + ba.url + ", retrying in " + this.retryDelay + "..."), this.destroy(), this.retryTimeout = window.setTimeout(this.loadInternal.bind(this), this.retryDelay), this.retryDelay = Math.min(2 * this.retryDelay, Na.maxRetryDelay), Yo.retry++);
                    } else
                      this.requestTimeout = window.setTimeout(this.loadtimeout.bind(this), Na.timeout);
                }, ma.loadtimeout = function() {
                  di.logger.warn("timeout while loading " + this.context.url), this.callbacks.onTimeout(this.stats, this.context, null);
                }, ma.loadprogress = function(Io) {
                  var Ri = Io.currentTarget, qi = this.stats;
                  qi.loaded = Io.loaded, Io.lengthComputable && (qi.total = Io.total);
                  var Yo = this.callbacks.onProgress;
                  Yo && Yo(qi, this.context, null, Ri);
                }, Sa;
              })(), Bp = Wd;
              function $d(Sa, ma) {
                for (var Ho = 0; Ho < ma.length; Ho++) {
                  var Io = ma[Ho];
                  Io.enumerable = Io.enumerable || !1, Io.configurable = !0, "value" in Io && (Io.writable = !0), Object.defineProperty(Sa, Io.key, Io);
                }
              }
              function qc(Sa, ma, Ho) {
                return ma && $d(Sa.prototype, ma), Sa;
              }
              function vp(Sa, ma) {
                Sa.prototype = Object.create(ma.prototype), Sa.prototype.constructor = Sa, Sa.__proto__ = ma;
              }
              var Gd = /* @__PURE__ */ (function(Sa) {
                vp(ma, Sa);
                function ma(Io) {
                  var Ri;
                  return Ri = Sa.call(this, Io, si.default.MANIFEST_LOADING, si.default.MANIFEST_PARSED, si.default.AUDIO_TRACK_LOADED, si.default.AUDIO_TRACK_SWITCHED, si.default.LEVEL_LOADED, si.default.ERROR) || this, Ri._trackId = -1, Ri._selectDefaultTrack = !0, Ri.tracks = [], Ri.trackIdBlacklist = /* @__PURE__ */ Object.create(null), Ri.audioGroupId = null, Ri;
                }
                var Ho = ma.prototype;
                return Ho.onManifestLoading = function() {
                  this.tracks = [], this._trackId = -1, this._selectDefaultTrack = !0;
                }, Ho.onManifestParsed = function(Ri) {
                  var qi = this.tracks = Ri.audioTracks || [];
                  this.hls.trigger(si.default.AUDIO_TRACKS_UPDATED, {
                    audioTracks: qi
                  }), this._selectAudioGroup(this.hls.nextLoadLevel);
                }, Ho.onAudioTrackLoaded = function(Ri) {
                  if (Ri.id >= this.tracks.length) {
                    di.logger.warn("Invalid audio track id:", Ri.id);
                    return;
                  }
                  if (di.logger.log("audioTrack " + Ri.id + " loaded"), this.tracks[Ri.id].details = Ri.details, Ri.details.live && !this.hasInterval()) {
                    var qi = Ri.details.targetduration * 1e3;
                    this.setInterval(qi);
                  }
                  !Ri.details.live && this.hasInterval() && this.clearInterval();
                }, Ho.onAudioTrackSwitched = function(Ri) {
                  var qi = this.tracks[Ri.id].groupId;
                  qi && this.audioGroupId !== qi && (this.audioGroupId = qi);
                }, Ho.onLevelLoaded = function(Ri) {
                  this._selectAudioGroup(Ri.level);
                }, Ho.onError = function(Ri) {
                  Ri.type === li.ErrorTypes.NETWORK_ERROR && (Ri.fatal && this.clearInterval(), Ri.details === li.ErrorDetails.AUDIO_TRACK_LOAD_ERROR && (di.logger.warn("Network failure on audio-track id:", Ri.context.id), this._handleLoadError()));
                }, Ho._setAudioTrack = function(Ri) {
                  if (this._trackId === Ri && this.tracks[this._trackId].details) {
                    di.logger.debug("Same id as current audio-track passed, and track details available -> no-op");
                    return;
                  }
                  if (Ri < 0 || Ri >= this.tracks.length) {
                    di.logger.warn("Invalid id passed to audio-track controller");
                    return;
                  }
                  var qi = this.tracks[Ri];
                  di.logger.log("Now switching to audio-track index " + Ri), this.clearInterval(), this._trackId = Ri;
                  var Yo = qi.url, ba = qi.type, Na = qi.id;
                  this.hls.trigger(si.default.AUDIO_TRACK_SWITCHING, {
                    id: Na,
                    type: ba,
                    url: Yo
                  }), this._loadTrackDetailsIfNeeded(qi);
                }, Ho.doTick = function() {
                  this._updateTrack(this._trackId);
                }, Ho._selectAudioGroup = function(Ri) {
                  var qi = this.hls.levels[Ri];
                  if (!(!qi || !qi.audioGroupIds)) {
                    var Yo = qi.audioGroupIds[qi.urlId];
                    this.audioGroupId !== Yo && (this.audioGroupId = Yo, this._selectInitialAudioTrack());
                  }
                }, Ho._selectInitialAudioTrack = function() {
                  var Ri = this, qi = this.tracks;
                  if (qi.length) {
                    var Yo = this.tracks[this._trackId], ba = null;
                    if (Yo && (ba = Yo.name), this._selectDefaultTrack) {
                      var Na = qi.filter(function(Ds) {
                        return Ds.default;
                      });
                      Na.length ? qi = Na : di.logger.warn("No default audio tracks defined");
                    }
                    var Ma = !1, bs = function() {
                      qi.forEach(function(Fs) {
                        Ma || (!Ri.audioGroupId || Fs.groupId === Ri.audioGroupId) && (!ba || ba === Fs.name) && (Ri._setAudioTrack(Fs.id), Ma = !0);
                      });
                    };
                    bs(), Ma || (ba = null, bs()), Ma || (di.logger.error("No track found for running audio group-ID: " + this.audioGroupId), this.hls.trigger(si.default.ERROR, {
                      type: li.ErrorTypes.MEDIA_ERROR,
                      details: li.ErrorDetails.AUDIO_TRACK_LOAD_ERROR,
                      fatal: !0
                    }));
                  }
                }, Ho._needsTrackLoading = function(Ri) {
                  var qi = Ri.details, Yo = Ri.url;
                  return !qi || qi.live ? !!Yo : !1;
                }, Ho._loadTrackDetailsIfNeeded = function(Ri) {
                  if (this._needsTrackLoading(Ri)) {
                    var qi = Ri.url, Yo = Ri.id;
                    di.logger.log("loading audio-track playlist for id: " + Yo), this.hls.trigger(si.default.AUDIO_TRACK_LOADING, {
                      url: qi,
                      id: Yo
                    });
                  }
                }, Ho._updateTrack = function(Ri) {
                  if (!(Ri < 0 || Ri >= this.tracks.length)) {
                    this.clearInterval(), this._trackId = Ri, di.logger.log("trying to update audio-track " + Ri);
                    var qi = this.tracks[Ri];
                    this._loadTrackDetailsIfNeeded(qi);
                  }
                }, Ho._handleLoadError = function() {
                  this.trackIdBlacklist[this._trackId] = !0;
                  var Ri = this._trackId, qi = this.tracks[Ri], Yo = qi.name, ba = qi.language, Na = qi.groupId;
                  di.logger.warn("Loading failed on audio track id: " + Ri + ", group-id: " + Na + ', name/language: "' + Yo + '" / "' + ba + '"');
                  for (var Ma = Ri, bs = 0; bs < this.tracks.length; bs++)
                    if (!this.trackIdBlacklist[bs]) {
                      var Ds = this.tracks[bs];
                      if (Ds.name === Yo) {
                        Ma = bs;
                        break;
                      }
                    }
                  if (Ma === Ri) {
                    di.logger.warn('No fallback audio-track found for name/language: "' + Yo + '" / "' + ba + '"');
                    return;
                  }
                  di.logger.log("Attempting audio-track fallback id:", Ma, "group-id:", this.tracks[Ma].groupId), this._setAudioTrack(Ma);
                }, qc(ma, [{
                  key: "audioTracks",
                  get: function() {
                    return this.tracks;
                  }
                  /**
                   * @type {number} Index into audio-tracks list of currently selected track.
                   */
                }, {
                  key: "audioTrack",
                  get: function() {
                    return this._trackId;
                  },
                  set: function(Ri) {
                    this._setAudioTrack(Ri), this._selectDefaultTrack = !1;
                  }
                }]), ma;
              })(tu), yf = Gd;
              function rp(Sa, ma) {
                for (var Ho = 0; Ho < ma.length; Ho++) {
                  var Io = ma[Ho];
                  Io.enumerable = Io.enumerable || !1, Io.configurable = !0, "value" in Io && (Io.writable = !0), Object.defineProperty(Sa, Io.key, Io);
                }
              }
              function Up(Sa, ma, Ho) {
                return ma && rp(Sa.prototype, ma), Sa;
              }
              function ph(Sa, ma) {
                Sa.prototype = Object.create(ma.prototype), Sa.prototype.constructor = Sa, Sa.__proto__ = ma;
              }
              var hh = window, af = hh.performance, Ic = 100, qh = /* @__PURE__ */ (function(Sa) {
                ph(ma, Sa);
                function ma(Io, Ri) {
                  var qi;
                  return qi = Sa.call(this, Io, si.default.MEDIA_ATTACHED, si.default.MEDIA_DETACHING, si.default.AUDIO_TRACKS_UPDATED, si.default.AUDIO_TRACK_SWITCHING, si.default.AUDIO_TRACK_LOADED, si.default.KEY_LOADED, si.default.FRAG_LOADED, si.default.FRAG_PARSING_INIT_SEGMENT, si.default.FRAG_PARSING_DATA, si.default.FRAG_PARSED, si.default.ERROR, si.default.BUFFER_RESET, si.default.BUFFER_CREATED, si.default.BUFFER_APPENDED, si.default.BUFFER_FLUSHED, si.default.INIT_PTS_FOUND) || this, qi.fragmentTracker = Ri, qi.config = Io.config, qi.audioCodecSwap = !1, qi._state = dl.STOPPED, qi.initPTS = [], qi.waitingFragment = null, qi.videoTrackCC = null, qi.waitingVideoCC = null, qi;
                }
                var Ho = ma.prototype;
                return Ho.onInitPtsFound = function(Ri) {
                  var qi = Ri.id, Yo = Ri.frag.cc, ba = Ri.initPTS;
                  qi === "main" && (this.initPTS[Yo] = ba, this.videoTrackCC = Yo, di.logger.log("InitPTS for cc: " + Yo + " found from main: " + ba), this.state === dl.WAITING_INIT_PTS && this.tick());
                }, Ho.startLoad = function(Ri) {
                  if (this.tracks) {
                    var qi = this.lastCurrentTime;
                    this.stopLoad(), this.setInterval(Ic), this.fragLoadError = 0, qi > 0 && Ri === -1 ? (di.logger.log("audio:override startPosition with lastCurrentTime @" + qi.toFixed(3)), this.state = dl.IDLE) : (this.lastCurrentTime = this.startPosition ? this.startPosition : Ri, this.state = dl.STARTING), this.nextLoadPosition = this.startPosition = this.lastCurrentTime, this.tick();
                  } else
                    this.startPosition = Ri, this.state = dl.STOPPED;
                }, Ho.doTick = function() {
                  var Ri, qi, Yo, ba = this.hls, Na = ba.config;
                  switch (this.state) {
                    case dl.ERROR:
                    // don't do anything in error state to avoid breaking further ...
                    case dl.PAUSED:
                    // don't do anything in paused state either ...
                    case dl.BUFFER_FLUSHING:
                      break;
                    case dl.STARTING:
                      this.state = dl.WAITING_TRACK, this.loadedmetadata = !1;
                      break;
                    case dl.IDLE:
                      var Ma = this.tracks;
                      if (!Ma || !this.media && (this.startFragRequested || !Na.startFragPrefetch))
                        break;
                      if (this.loadedmetadata)
                        Ri = this.media.currentTime;
                      else if (Ri = this.nextLoadPosition, Ri === void 0)
                        break;
                      var bs = this.mediaBuffer ? this.mediaBuffer : this.media, Ds = this.videoBuffer ? this.videoBuffer : this.media, Fs = Ri < Na.maxBufferHole ? Math.max(rl, Na.maxBufferHole) : Na.maxBufferHole, _l = ja.bufferInfo(bs, Ri, Fs), Ll = ja.bufferInfo(Ds, Ri, Fs), eu = _l.len, fu = _l.end, Fu = this.fragPrevious, Ou = Math.min(Na.maxBufferLength, Na.maxMaxBufferLength), qu = Math.max(Ou, Ll.len), Ju = this.audioSwitch, nc = this.trackId;
                      if ((eu < qu || Ju) && nc < Ma.length) {
                        if (Yo = Ma[nc].details, typeof Yo > "u") {
                          this.state = dl.WAITING_TRACK;
                          break;
                        }
                        if (!Ju && this._streamEnded(_l, Yo)) {
                          this.hls.trigger(si.default.BUFFER_EOS, {
                            type: "audio"
                          }), this.state = dl.ENDED;
                          return;
                        }
                        var $c = Yo.fragments, Rc = $c.length, xc = $c[0].start, vd = $c[Rc - 1].start + $c[Rc - 1].duration, zu;
                        if (Ju) {
                          if (Yo.live && !Yo.PTSKnown)
                            di.logger.log("switching audiotrack, live stream, unknown PTS,load first fragment"), fu = 0;
                          else if (fu = Ri, Yo.PTSKnown && Ri < xc)
                            if (_l.end > xc || _l.nextStart)
                              di.logger.log("alt audio track ahead of main track, seek to start of alt audio track"), this.media.currentTime = xc + 0.05;
                            else
                              return;
                        }
                        if (Yo.initSegment && !Yo.initSegment.data)
                          zu = Yo.initSegment;
                        else if (fu <= xc) {
                          if (zu = $c[0], this.videoTrackCC !== null && zu.cc !== this.videoTrackCC && (zu = Tu($c, this.videoTrackCC)), Yo.live && zu.loadIdx && zu.loadIdx === this.fragLoadIdx) {
                            var ic = _l.nextStart ? _l.nextStart : xc;
                            di.logger.log("no alt audio available @currentTime:" + this.media.currentTime + ", seeking @" + (ic + 0.05)), this.media.currentTime = ic + 0.05;
                            return;
                          }
                        } else {
                          var Fc, kd = Na.maxFragLookUpTolerance, tf = Fu ? $c[Fu.sn - $c[0].sn + 1] : void 0;
                          fu < vd ? (fu > vd - kd && (kd = 0), tf && !Gl(fu, kd, tf) ? Fc = tf : Fc = Ja.search($c, function(Qp) {
                            return Gl(fu, kd, Qp);
                          })) : Fc = $c[Rc - 1], Fc && (zu = Fc, xc = Fc.start, Fu && zu.level === Fu.level && zu.sn === Fu.sn && (zu.sn < Yo.endSN ? (zu = $c[zu.sn + 1 - Yo.startSN], this.fragmentTracker.getState(zu) !== Es.OK && di.logger.log("SN just loaded, load next one: " + zu.sn)) : zu = null));
                        }
                        zu && (zu.encrypted ? (di.logger.log("Loading key for " + zu.sn + " of [" + Yo.startSN + " ," + Yo.endSN + "],track " + nc), this.state = dl.KEY_LOADING, ba.trigger(si.default.KEY_LOADING, {
                          frag: zu
                        })) : (this.fragCurrent = zu, (Ju || this.fragmentTracker.getState(zu) === Es.NOT_LOADED) && (di.logger.log("Loading " + zu.sn + ", cc: " + zu.cc + " of [" + Yo.startSN + " ," + Yo.endSN + "],track " + nc + ", " + (this.loadedmetadata ? "currentTime" : "nextLoadPosition") + ": " + Ri + ", bufferEnd: " + fu.toFixed(3)), zu.sn !== "initSegment" && (this.startFragRequested = !0), Object(oi.isFiniteNumber)(zu.sn) && (this.nextLoadPosition = zu.start + zu.duration), ba.trigger(si.default.FRAG_LOADING, {
                          frag: zu
                        }), this.state = dl.FRAG_LOADING)));
                      }
                      break;
                    case dl.WAITING_TRACK:
                      qi = this.tracks[this.trackId], qi && qi.details && (this.state = dl.IDLE);
                      break;
                    case dl.FRAG_LOADING_WAITING_RETRY:
                      var Ad = af.now(), Ip = this.retryDate;
                      bs = this.media;
                      var Xp = bs && bs.seeking;
                      (!Ip || Ad >= Ip || Xp) && (di.logger.log("audioStreamController: retryDate reached, switch back to IDLE state"), this.state = dl.IDLE);
                      break;
                    case dl.WAITING_INIT_PTS:
                      var Pf = this.waitingFragment;
                      if (Pf) {
                        var cf = Pf.frag.cc;
                        if (this.initPTS[cf] !== void 0)
                          this.waitingFragment = null, this.state = dl.FRAG_LOADING, this.onFragLoaded(Pf);
                        else if (this.videoTrackCC !== this.waitingVideoCC)
                          di.logger.log("Waiting fragment cc (" + cf + ") cancelled because video is at cc " + this.videoTrackCC), this.clearWaitingFragment();
                        else {
                          var Jp = ja.bufferInfo(this.mediaBuffer, this.media.currentTime, Na.maxBufferHole), rf = Gl(Jp.end, Na.maxFragLookUpTolerance, Pf.frag);
                          rf < 0 && (di.logger.log("Waiting fragment cc (" + cf + ") @ " + Pf.frag.start + " cancelled because another fragment at " + Jp.end + " is needed"), this.clearWaitingFragment());
                        }
                      } else
                        this.state = dl.IDLE;
                      break;
                  }
                }, Ho.clearWaitingFragment = function() {
                  var Ri = this.waitingFragment;
                  Ri && (this.fragmentTracker.removeFragment(Ri.frag), this.waitingFragment = null, this.waitingVideoCC = null, this.state = dl.IDLE);
                }, Ho.onMediaAttached = function(Ri) {
                  var qi = this.media = this.mediaBuffer = Ri.media;
                  this.onvseeking = this.onMediaSeeking.bind(this), this.onvended = this.onMediaEnded.bind(this), qi.addEventListener("seeking", this.onvseeking), qi.addEventListener("ended", this.onvended);
                  var Yo = this.config;
                  this.tracks && Yo.autoStartLoad && this.startLoad(Yo.startPosition);
                }, Ho.onMediaDetaching = function() {
                  var Ri = this.media;
                  Ri && Ri.ended && (di.logger.log("MSE detaching and video ended, reset startPosition"), this.startPosition = this.lastCurrentTime = 0), Ri && (Ri.removeEventListener("seeking", this.onvseeking), Ri.removeEventListener("ended", this.onvended), this.onvseeking = this.onvseeked = this.onvended = null), this.media = this.mediaBuffer = this.videoBuffer = null, this.loadedmetadata = !1, this.fragmentTracker.removeAllFragments(), this.stopLoad();
                }, Ho.onAudioTracksUpdated = function(Ri) {
                  di.logger.log("audio tracks updated"), this.tracks = Ri.audioTracks;
                }, Ho.onAudioTrackSwitching = function(Ri) {
                  var qi = !!Ri.url;
                  this.trackId = Ri.id, this.fragCurrent = null, this.clearWaitingFragment(), this.state = dl.PAUSED, qi ? this.setInterval(Ic) : this.demuxer && (this.demuxer.destroy(), this.demuxer = null), qi && (this.audioSwitch = !0, this.state = dl.IDLE), this.tick();
                }, Ho.onAudioTrackLoaded = function(Ri) {
                  var qi = Ri.details, Yo = Ri.id, ba = this.tracks[Yo], Na = ba.details, Ma = qi.totalduration, bs = 0;
                  if (di.logger.log("track " + Yo + " loaded [" + qi.startSN + "," + qi.endSN + "],duration:" + Ma), qi.live || Na && Na.live ? Na && qi.fragments.length > 0 ? (Il(Na, qi), bs = qi.fragments[0].start, qi.PTSKnown ? di.logger.log("live audio playlist sliding:" + bs.toFixed(3)) : di.logger.log("live audio playlist - outdated PTS, unknown sliding")) : (qi.PTSKnown = !1, di.logger.log("live audio playlist - first load, unknown sliding")) : qi.PTSKnown = !1, ba.details = qi, !this.startFragRequested) {
                    if (this.startPosition === -1) {
                      var Ds = qi.startTimeOffset;
                      Object(oi.isFiniteNumber)(Ds) ? (di.logger.log("start time offset found in playlist, adjust startPosition to " + Ds), this.startPosition = Ds) : qi.live ? (this.startPosition = this.computeLivePosition(bs, qi), di.logger.log("compute startPosition for audio-track to " + this.startPosition)) : this.startPosition = 0;
                    }
                    this.nextLoadPosition = this.startPosition;
                  }
                  this.state === dl.WAITING_TRACK && (this.state = dl.IDLE), this.tick();
                }, Ho.onKeyLoaded = function() {
                  this.state === dl.KEY_LOADING && (this.state = dl.IDLE, this.tick());
                }, Ho.onFragLoaded = function(Ri) {
                  var qi = this.fragCurrent, Yo = Ri.frag;
                  if (this.state === dl.FRAG_LOADING && qi && Yo.type === "audio" && Yo.level === qi.level && Yo.sn === qi.sn) {
                    var ba = this.tracks[this.trackId], Na = ba.details, Ma = Na.totalduration, bs = qi.level, Ds = qi.sn, Fs = qi.cc, _l = this.config.defaultAudioCodec || ba.audioCodec || "mp4a.40.2", Ll = this.stats = Ri.stats;
                    if (Ds === "initSegment")
                      this.state = dl.IDLE, Ll.tparsed = Ll.tbuffered = af.now(), Na.initSegment.data = Ri.payload, this.hls.trigger(si.default.FRAG_BUFFERED, {
                        stats: Ll,
                        frag: qi,
                        id: "audio"
                      }), this.tick();
                    else {
                      this.state = dl.PARSING, this.appended = !1, this.demuxer || (this.demuxer = new es(this.hls, "audio"));
                      var eu = this.initPTS[Fs], fu = Na.initSegment ? Na.initSegment.data : [];
                      if (eu !== void 0) {
                        this.pendingBuffering = !0, di.logger.log("Demuxing " + Ds + " of [" + Na.startSN + " ," + Na.endSN + "],track " + bs);
                        var Fu = !1;
                        this.demuxer.push(Ri.payload, fu, _l, null, qi, Ma, Fu, eu);
                      } else
                        di.logger.log("Unknown video PTS for cc " + Fs + ", waiting for video PTS before demuxing audio frag " + Ds + " of [" + Na.startSN + " ," + Na.endSN + "],track " + bs), this.waitingFragment = Ri, this.waitingVideoCC = this.videoTrackCC, this.state = dl.WAITING_INIT_PTS;
                    }
                  }
                  this.fragLoadError = 0;
                }, Ho.onFragParsingInitSegment = function(Ri) {
                  var qi = this.fragCurrent, Yo = Ri.frag;
                  if (qi && Ri.id === "audio" && Yo.sn === qi.sn && Yo.level === qi.level && this.state === dl.PARSING) {
                    var ba = Ri.tracks, Na;
                    if (ba.video && delete ba.video, Na = ba.audio, Na) {
                      Na.levelCodec = Na.codec, Na.id = Ri.id, this.hls.trigger(si.default.BUFFER_CODECS, ba), di.logger.log("audio track:audio,container:" + Na.container + ",codecs[level/parsed]=[" + Na.levelCodec + "/" + Na.codec + "]");
                      var Ma = Na.initSegment;
                      if (Ma) {
                        var bs = {
                          type: "audio",
                          data: Ma,
                          parent: "audio",
                          content: "initSegment"
                        };
                        this.audioSwitch ? this.pendingData = [bs] : (this.appended = !0, this.pendingBuffering = !0, this.hls.trigger(si.default.BUFFER_APPENDING, bs));
                      }
                      this.tick();
                    }
                  }
                }, Ho.onFragParsingData = function(Ri) {
                  var qi = this, Yo = this.fragCurrent, ba = Ri.frag;
                  if (Yo && Ri.id === "audio" && Ri.type === "audio" && ba.sn === Yo.sn && ba.level === Yo.level && this.state === dl.PARSING) {
                    var Na = this.trackId, Ma = this.tracks[Na], bs = this.hls;
                    Object(oi.isFiniteNumber)(Ri.endPTS) || (Ri.endPTS = Ri.startPTS + Yo.duration, Ri.endDTS = Ri.startDTS + Yo.duration), Yo.addElementaryStream(Mi.AUDIO), di.logger.log("parsed " + Ri.type + ",PTS:[" + Ri.startPTS.toFixed(3) + "," + Ri.endPTS.toFixed(3) + "],DTS:[" + Ri.startDTS.toFixed(3) + "/" + Ri.endDTS.toFixed(3) + "],nb:" + Ri.nb), sl(Ma.details, Yo, Ri.startPTS, Ri.endPTS);
                    var Ds = this.media, Fs = !1;
                    if (this.audioSwitch)
                      if (Ds && Ds.readyState) {
                        var _l = Ds.currentTime;
                        di.logger.log("switching audio track : currentTime:" + _l), _l >= Ri.startPTS && (di.logger.log("switching audio track : flushing all audio"), this.state = dl.BUFFER_FLUSHING, bs.trigger(si.default.BUFFER_FLUSHING, {
                          startOffset: 0,
                          endOffset: Number.POSITIVE_INFINITY,
                          type: "audio"
                        }), Fs = !0, this.audioSwitch = !1, bs.trigger(si.default.AUDIO_TRACK_SWITCHED, {
                          id: Na
                        }));
                      } else
                        this.audioSwitch = !1, bs.trigger(si.default.AUDIO_TRACK_SWITCHED, {
                          id: Na
                        });
                    var Ll = this.pendingData;
                    if (!Ll) {
                      di.logger.warn("Apparently attempt to enqueue media payload without codec initialization data upfront"), bs.trigger(si.default.ERROR, {
                        type: li.ErrorTypes.MEDIA_ERROR,
                        details: null,
                        fatal: !0
                      });
                      return;
                    }
                    this.audioSwitch || ([Ri.data1, Ri.data2].forEach(function(eu) {
                      eu && eu.length && Ll.push({
                        type: Ri.type,
                        data: eu,
                        parent: "audio",
                        content: "data"
                      });
                    }), !Fs && Ll.length && (Ll.forEach(function(eu) {
                      qi.state === dl.PARSING && (qi.pendingBuffering = !0, qi.hls.trigger(si.default.BUFFER_APPENDING, eu));
                    }), this.pendingData = [], this.appended = !0)), this.tick();
                  }
                }, Ho.onFragParsed = function(Ri) {
                  var qi = this.fragCurrent, Yo = Ri.frag;
                  qi && Ri.id === "audio" && Yo.sn === qi.sn && Yo.level === qi.level && this.state === dl.PARSING && (this.stats.tparsed = af.now(), this.state = dl.PARSED, this._checkAppendedParsed());
                }, Ho.onBufferReset = function() {
                  this.mediaBuffer = this.videoBuffer = null, this.loadedmetadata = !1;
                }, Ho.onBufferCreated = function(Ri) {
                  var qi = Ri.tracks.audio;
                  qi && (this.mediaBuffer = qi.buffer, this.loadedmetadata = !0), Ri.tracks.video && (this.videoBuffer = Ri.tracks.video.buffer);
                }, Ho.onBufferAppended = function(Ri) {
                  if (Ri.parent === "audio") {
                    var qi = this.state;
                    (qi === dl.PARSING || qi === dl.PARSED) && (this.pendingBuffering = Ri.pending > 0, this._checkAppendedParsed());
                  }
                }, Ho._checkAppendedParsed = function() {
                  if (this.state === dl.PARSED && (!this.appended || !this.pendingBuffering)) {
                    var Ri = this.fragCurrent, qi = this.stats, Yo = this.hls;
                    if (Ri) {
                      this.fragPrevious = Ri, qi.tbuffered = af.now(), Yo.trigger(si.default.FRAG_BUFFERED, {
                        stats: qi,
                        frag: Ri,
                        id: "audio"
                      });
                      var ba = this.mediaBuffer ? this.mediaBuffer : this.media;
                      ba && di.logger.log("audio buffered : " + Xl.toString(ba.buffered)), this.audioSwitch && this.appended && (this.audioSwitch = !1, Yo.trigger(si.default.AUDIO_TRACK_SWITCHED, {
                        id: this.trackId
                      })), this.state = dl.IDLE;
                    }
                    this.tick();
                  }
                }, Ho.onError = function(Ri) {
                  var qi = Ri.frag;
                  if (!(qi && qi.type !== "audio"))
                    switch (Ri.details) {
                      case li.ErrorDetails.FRAG_LOAD_ERROR:
                      case li.ErrorDetails.FRAG_LOAD_TIMEOUT:
                        var Yo = Ri.frag;
                        if (Yo && Yo.type !== "audio")
                          break;
                        if (!Ri.fatal) {
                          var ba = this.fragLoadError;
                          ba ? ba++ : ba = 1;
                          var Na = this.config;
                          if (ba <= Na.fragLoadingMaxRetry) {
                            this.fragLoadError = ba;
                            var Ma = Math.min(Math.pow(2, ba - 1) * Na.fragLoadingRetryDelay, Na.fragLoadingMaxRetryTimeout);
                            di.logger.warn("AudioStreamController: frag loading failed, retry in " + Ma + " ms"), this.retryDate = af.now() + Ma, this.state = dl.FRAG_LOADING_WAITING_RETRY;
                          } else
                            di.logger.error("AudioStreamController: " + Ri.details + " reaches max retry, redispatch as fatal ..."), Ri.fatal = !0, this.state = dl.ERROR;
                        }
                        break;
                      case li.ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
                      case li.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
                      case li.ErrorDetails.KEY_LOAD_ERROR:
                      case li.ErrorDetails.KEY_LOAD_TIMEOUT:
                        this.state !== dl.ERROR && (this.state = Ri.fatal ? dl.ERROR : dl.IDLE, di.logger.warn("AudioStreamController: " + Ri.details + " while loading frag, now switching to " + this.state + " state ..."));
                        break;
                      case li.ErrorDetails.BUFFER_FULL_ERROR:
                        if (Ri.parent === "audio" && (this.state === dl.PARSING || this.state === dl.PARSED)) {
                          var bs = this.mediaBuffer, Ds = this.media.currentTime, Fs = bs && ja.isBuffered(bs, Ds) && ja.isBuffered(bs, Ds + 0.5);
                          if (Fs) {
                            var _l = this.config;
                            _l.maxMaxBufferLength >= _l.maxBufferLength && (_l.maxMaxBufferLength /= 2, di.logger.warn("AudioStreamController: reduce max buffer length to " + _l.maxMaxBufferLength + "s")), this.state = dl.IDLE;
                          } else
                            di.logger.warn("AudioStreamController: buffer full error also media.currentTime is not buffered, flush audio buffer"), this.fragCurrent = null, this.state = dl.BUFFER_FLUSHING, this.hls.trigger(si.default.BUFFER_FLUSHING, {
                              startOffset: 0,
                              endOffset: Number.POSITIVE_INFINITY,
                              type: "audio"
                            });
                        }
                        break;
                    }
                }, Ho.onBufferFlushed = function() {
                  var Ri = this, qi = this.pendingData;
                  qi && qi.length ? (di.logger.log("AudioStreamController: appending pending audio data after buffer flushed"), qi.forEach(function(Yo) {
                    Ri.hls.trigger(si.default.BUFFER_APPENDING, Yo);
                  }), this.appended = !0, this.pendingData = [], this.state = dl.PARSED) : (this.state = dl.IDLE, this.fragPrevious = null, this.tick());
                }, Up(ma, [{
                  key: "state",
                  set: function(Ri) {
                    if (this.state !== Ri) {
                      var qi = this.state;
                      this._state = Ri, di.logger.log("audio stream:" + qi + "->" + Ri);
                    }
                  },
                  get: function() {
                    return this._state;
                  }
                }]), ma;
              })(Su), Ec = qh, gh = (function() {
                if (typeof window < "u" && window.VTTCue)
                  return window.VTTCue;
                var Sa = "auto", ma = {
                  "": !0,
                  lr: !0,
                  rl: !0
                }, Ho = {
                  start: !0,
                  middle: !0,
                  end: !0,
                  left: !0,
                  right: !0
                };
                function Io(ba) {
                  if (typeof ba != "string")
                    return !1;
                  var Na = ma[ba.toLowerCase()];
                  return Na ? ba.toLowerCase() : !1;
                }
                function Ri(ba) {
                  if (typeof ba != "string")
                    return !1;
                  var Na = Ho[ba.toLowerCase()];
                  return Na ? ba.toLowerCase() : !1;
                }
                function qi(ba) {
                  for (var Na = 1; Na < arguments.length; Na++) {
                    var Ma = arguments[Na];
                    for (var bs in Ma)
                      ba[bs] = Ma[bs];
                  }
                  return ba;
                }
                function Yo(ba, Na, Ma) {
                  var bs = this, Ds = {};
                  Ds.enumerable = !0, bs.hasBeenReset = !1;
                  var Fs = "", _l = !1, Ll = ba, eu = Na, fu = Ma, Fu = null, Ou = "", qu = !0, Ju = "auto", nc = "start", $c = 50, Rc = "middle", xc = 50, vd = "middle";
                  Object.defineProperty(bs, "id", qi({}, Ds, {
                    get: function() {
                      return Fs;
                    },
                    set: function(ic) {
                      Fs = "" + ic;
                    }
                  })), Object.defineProperty(bs, "pauseOnExit", qi({}, Ds, {
                    get: function() {
                      return _l;
                    },
                    set: function(ic) {
                      _l = !!ic;
                    }
                  })), Object.defineProperty(bs, "startTime", qi({}, Ds, {
                    get: function() {
                      return Ll;
                    },
                    set: function(ic) {
                      if (typeof ic != "number")
                        throw new TypeError("Start time must be set to a number.");
                      Ll = ic, this.hasBeenReset = !0;
                    }
                  })), Object.defineProperty(bs, "endTime", qi({}, Ds, {
                    get: function() {
                      return eu;
                    },
                    set: function(ic) {
                      if (typeof ic != "number")
                        throw new TypeError("End time must be set to a number.");
                      eu = ic, this.hasBeenReset = !0;
                    }
                  })), Object.defineProperty(bs, "text", qi({}, Ds, {
                    get: function() {
                      return fu;
                    },
                    set: function(ic) {
                      fu = "" + ic, this.hasBeenReset = !0;
                    }
                  })), Object.defineProperty(bs, "region", qi({}, Ds, {
                    get: function() {
                      return Fu;
                    },
                    set: function(ic) {
                      Fu = ic, this.hasBeenReset = !0;
                    }
                  })), Object.defineProperty(bs, "vertical", qi({}, Ds, {
                    get: function() {
                      return Ou;
                    },
                    set: function(ic) {
                      var Fc = Io(ic);
                      if (Fc === !1)
                        throw new SyntaxError("An invalid or illegal string was specified.");
                      Ou = Fc, this.hasBeenReset = !0;
                    }
                  })), Object.defineProperty(bs, "snapToLines", qi({}, Ds, {
                    get: function() {
                      return qu;
                    },
                    set: function(ic) {
                      qu = !!ic, this.hasBeenReset = !0;
                    }
                  })), Object.defineProperty(bs, "line", qi({}, Ds, {
                    get: function() {
                      return Ju;
                    },
                    set: function(ic) {
                      if (typeof ic != "number" && ic !== Sa)
                        throw new SyntaxError("An invalid number or illegal string was specified.");
                      Ju = ic, this.hasBeenReset = !0;
                    }
                  })), Object.defineProperty(bs, "lineAlign", qi({}, Ds, {
                    get: function() {
                      return nc;
                    },
                    set: function(ic) {
                      var Fc = Ri(ic);
                      if (!Fc)
                        throw new SyntaxError("An invalid or illegal string was specified.");
                      nc = Fc, this.hasBeenReset = !0;
                    }
                  })), Object.defineProperty(bs, "position", qi({}, Ds, {
                    get: function() {
                      return $c;
                    },
                    set: function(ic) {
                      if (ic < 0 || ic > 100)
                        throw new Error("Position must be between 0 and 100.");
                      $c = ic, this.hasBeenReset = !0;
                    }
                  })), Object.defineProperty(bs, "positionAlign", qi({}, Ds, {
                    get: function() {
                      return Rc;
                    },
                    set: function(ic) {
                      var Fc = Ri(ic);
                      if (!Fc)
                        throw new SyntaxError("An invalid or illegal string was specified.");
                      Rc = Fc, this.hasBeenReset = !0;
                    }
                  })), Object.defineProperty(bs, "size", qi({}, Ds, {
                    get: function() {
                      return xc;
                    },
                    set: function(ic) {
                      if (ic < 0 || ic > 100)
                        throw new Error("Size must be between 0 and 100.");
                      xc = ic, this.hasBeenReset = !0;
                    }
                  })), Object.defineProperty(bs, "align", qi({}, Ds, {
                    get: function() {
                      return vd;
                    },
                    set: function(ic) {
                      var Fc = Ri(ic);
                      if (!Fc)
                        throw new SyntaxError("An invalid or illegal string was specified.");
                      vd = Fc, this.hasBeenReset = !0;
                    }
                  })), bs.displayState = void 0;
                }
                return Yo.prototype.getCueAsHTML = function() {
                  var ba = window.WebVTT;
                  return ba.convertCueToDOMTree(window, this.text);
                }, Yo;
              })(), Zc = function() {
                return {
                  decode: function(Ho) {
                    if (!Ho)
                      return "";
                    if (typeof Ho != "string")
                      throw new Error("Error - expected string data.");
                    return decodeURIComponent(encodeURIComponent(Ho));
                  }
                };
              };
              function mh() {
                this.window = window, this.state = "INITIAL", this.buffer = "", this.decoder = new Zc(), this.regionList = [];
              }
              function Bf(Sa) {
                function ma(Io, Ri, qi, Yo) {
                  return (Io | 0) * 3600 + (Ri | 0) * 60 + (qi | 0) + (Yo | 0) / 1e3;
                }
                var Ho = Sa.match(/^(\d+):(\d{2})(:\d{2})?\.(\d{3})/);
                return Ho ? Ho[3] ? ma(Ho[1], Ho[2], Ho[3].replace(":", ""), Ho[4]) : Ho[1] > 59 ? ma(Ho[1], Ho[2], 0, Ho[4]) : ma(0, Ho[1], Ho[2], Ho[4]) : null;
              }
              function ou() {
                this.values = /* @__PURE__ */ Object.create(null);
              }
              ou.prototype = {
                // Only accept the first assignment to any key.
                set: function(ma, Ho) {
                  !this.get(ma) && Ho !== "" && (this.values[ma] = Ho);
                },
                // Return the value for a key, or a default value.
                // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
                // a number of possible default values as properties where 'defaultKey' is
                // the key of the property that will be chosen; otherwise it's assumed to be
                // a single value.
                get: function(ma, Ho, Io) {
                  return Io ? this.has(ma) ? this.values[ma] : Ho[Io] : this.has(ma) ? this.values[ma] : Ho;
                },
                // Check whether we have a value for a key.
                has: function(ma) {
                  return ma in this.values;
                },
                // Accept a setting if its one of the given alternatives.
                alt: function(ma, Ho, Io) {
                  for (var Ri = 0; Ri < Io.length; ++Ri)
                    if (Ho === Io[Ri]) {
                      this.set(ma, Ho);
                      break;
                    }
                },
                // Accept a setting if its a valid (signed) integer.
                integer: function(ma, Ho) {
                  /^-?\d+$/.test(Ho) && this.set(ma, parseInt(Ho, 10));
                },
                // Accept a setting if its a valid percentage.
                percent: function(ma, Ho) {
                  return Ho.match(/^([\d]{1,3})(\.[\d]*)?%$/) && (Ho = parseFloat(Ho), Ho >= 0 && Ho <= 100) ? (this.set(ma, Ho), !0) : !1;
                }
              };
              function Hd(Sa, ma, Ho, Io) {
                var Ri = Io ? Sa.split(Io) : [Sa];
                for (var qi in Ri)
                  if (typeof Ri[qi] == "string") {
                    var Yo = Ri[qi].split(Ho);
                    if (Yo.length === 2) {
                      var ba = Yo[0], Na = Yo[1];
                      ma(ba, Na);
                    }
                  }
              }
              var yp = new gh(0, 0, 0), bf = yp.align === "middle" ? "middle" : "center";
              function Tf(Sa, ma, Ho) {
                var Io = Sa;
                function Ri() {
                  var ba = Bf(Sa);
                  if (ba === null)
                    throw new Error("Malformed timestamp: " + Io);
                  return Sa = Sa.replace(/^[^\sa-zA-Z-]+/, ""), ba;
                }
                function qi(ba, Na) {
                  var Ma = new ou();
                  Hd(ba, function(Fs, _l) {
                    switch (Fs) {
                      case "region":
                        for (var Ll = Ho.length - 1; Ll >= 0; Ll--)
                          if (Ho[Ll].id === _l) {
                            Ma.set(Fs, Ho[Ll].region);
                            break;
                          }
                        break;
                      case "vertical":
                        Ma.alt(Fs, _l, ["rl", "lr"]);
                        break;
                      case "line":
                        var eu = _l.split(","), fu = eu[0];
                        Ma.integer(Fs, fu), Ma.percent(Fs, fu) && Ma.set("snapToLines", !1), Ma.alt(Fs, fu, ["auto"]), eu.length === 2 && Ma.alt("lineAlign", eu[1], ["start", bf, "end"]);
                        break;
                      case "position":
                        eu = _l.split(","), Ma.percent(Fs, eu[0]), eu.length === 2 && Ma.alt("positionAlign", eu[1], ["start", bf, "end", "line-left", "line-right", "auto"]);
                        break;
                      case "size":
                        Ma.percent(Fs, _l);
                        break;
                      case "align":
                        Ma.alt(Fs, _l, ["start", bf, "end", "left", "right"]);
                        break;
                    }
                  }, /:/, /\s/), Na.region = Ma.get("region", null), Na.vertical = Ma.get("vertical", "");
                  var bs = Ma.get("line", "auto");
                  bs === "auto" && yp.line === -1 && (bs = -1), Na.line = bs, Na.lineAlign = Ma.get("lineAlign", "start"), Na.snapToLines = Ma.get("snapToLines", !0), Na.size = Ma.get("size", 100), Na.align = Ma.get("align", bf);
                  var Ds = Ma.get("position", "auto");
                  Ds === "auto" && yp.position === 50 && (Ds = Na.align === "start" || Na.align === "left" ? 0 : Na.align === "end" || Na.align === "right" ? 100 : 50), Na.position = Ds;
                }
                function Yo() {
                  Sa = Sa.replace(/^\s+/, "");
                }
                if (Yo(), ma.startTime = Ri(), Yo(), Sa.substr(0, 3) !== "-->")
                  throw new Error("Malformed time stamp (time stamps must be separated by '-->'): " + Io);
                Sa = Sa.substr(3), Yo(), ma.endTime = Ri(), Yo(), qi(Sa, ma);
              }
              function bp(Sa) {
                return Sa.replace(/<br(?: \/)?>/gi, `
`);
              }
              mh.prototype = {
                parse: function(ma) {
                  var Ho = this;
                  ma && (Ho.buffer += Ho.decoder.decode(ma, {
                    stream: !0
                  }));
                  function Io() {
                    var Ma = Ho.buffer, bs = 0;
                    for (Ma = bp(Ma); bs < Ma.length && Ma[bs] !== "\r" && Ma[bs] !== `
`; )
                      ++bs;
                    var Ds = Ma.substr(0, bs);
                    return Ma[bs] === "\r" && ++bs, Ma[bs] === `
` && ++bs, Ho.buffer = Ma.substr(bs), Ds;
                  }
                  function Ri(Ma) {
                    Hd(Ma, function(bs, Ds) {
                    }, /:/);
                  }
                  try {
                    var qi;
                    if (Ho.state === "INITIAL") {
                      if (!/\r\n|\n/.test(Ho.buffer))
                        return this;
                      qi = Io();
                      var Yo = qi.match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
                      if (!Yo || !Yo[0])
                        throw new Error("Malformed WebVTT signature.");
                      Ho.state = "HEADER";
                    }
                    for (var ba = !1; Ho.buffer; ) {
                      if (!/\r\n|\n/.test(Ho.buffer))
                        return this;
                      switch (ba ? ba = !1 : qi = Io(), Ho.state) {
                        case "HEADER":
                          /:/.test(qi) ? Ri(qi) : qi || (Ho.state = "ID");
                          continue;
                        case "NOTE":
                          qi || (Ho.state = "ID");
                          continue;
                        case "ID":
                          if (/^NOTE($|[ \t])/.test(qi)) {
                            Ho.state = "NOTE";
                            break;
                          }
                          if (!qi)
                            continue;
                          if (Ho.cue = new gh(0, 0, ""), Ho.state = "CUE", qi.indexOf("-->") === -1) {
                            Ho.cue.id = qi;
                            continue;
                          }
                        // Process line as start of a cue.
                        /* falls through */
                        case "CUE":
                          try {
                            Tf(qi, Ho.cue, Ho.regionList);
                          } catch {
                            Ho.cue = null, Ho.state = "BADCUE";
                            continue;
                          }
                          Ho.state = "CUETEXT";
                          continue;
                        case "CUETEXT":
                          var Na = qi.indexOf("-->") !== -1;
                          if (!qi || Na && (ba = !0)) {
                            Ho.oncue && Ho.oncue(Ho.cue), Ho.cue = null, Ho.state = "ID";
                            continue;
                          }
                          Ho.cue.text && (Ho.cue.text += `
`), Ho.cue.text += qi;
                          continue;
                        case "BADCUE":
                          qi || (Ho.state = "ID");
                          continue;
                      }
                    }
                  } catch {
                    Ho.state === "CUETEXT" && Ho.cue && Ho.oncue && Ho.oncue(Ho.cue), Ho.cue = null, Ho.state = Ho.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
                  }
                  return this;
                },
                flush: function() {
                  var ma = this;
                  try {
                    if (ma.buffer += ma.decoder.decode(), (ma.cue || ma.state === "HEADER") && (ma.buffer += `

`, ma.parse()), ma.state === "INITIAL")
                      throw new Error("Malformed WebVTT signature.");
                  } catch (Ho) {
                    throw Ho;
                  }
                  return ma.onflush && ma.onflush(), this;
                }
              };
              var od = mh;
              function ad(Sa, ma, Ho, Io) {
                for (var Ri = [], qi, Yo, ba, Na, Ma, bs = window.VTTCue || TextTrackCue, Ds = 0; Ds < Io.rows.length; Ds++)
                  if (qi = Io.rows[Ds], ba = !0, Na = 0, Ma = "", !qi.isEmpty()) {
                    for (var Fs = 0; Fs < qi.chars.length; Fs++)
                      qi.chars[Fs].uchar.match(/\s/) && ba ? Na++ : (Ma += qi.chars[Fs].uchar, ba = !1);
                    qi.cueStartTime = ma, ma === Ho && (Ho += 1e-4), Yo = new bs(ma, Ho, bp(Ma.trim())), Na >= 16 ? Na-- : Na++, navigator.userAgent.match(/Firefox\//) ? Yo.line = Ds + 1 : Yo.line = Ds > 7 ? Ds - 2 : Ds + 1, Yo.align = "left", Yo.position = Math.max(0, Math.min(100, 100 * (Na / 32))), Ri.push(Yo), Sa && Sa.addCue(Yo);
                  }
                return Ri;
              }
              var Dd = {
                42: 225,
                // lowercase a, acute accent
                92: 233,
                // lowercase e, acute accent
                94: 237,
                // lowercase i, acute accent
                95: 243,
                // lowercase o, acute accent
                96: 250,
                // lowercase u, acute accent
                123: 231,
                // lowercase c with cedilla
                124: 247,
                // division symbol
                125: 209,
                // uppercase N tilde
                126: 241,
                // lowercase n tilde
                127: 9608,
                // Full block
                // THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
                // THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
                // THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
                128: 174,
                // Registered symbol (R)
                129: 176,
                // degree sign
                130: 189,
                // 1/2 symbol
                131: 191,
                // Inverted (open) question mark
                132: 8482,
                // Trademark symbol (TM)
                133: 162,
                // Cents symbol
                134: 163,
                // Pounds sterling
                135: 9834,
                // Music 8'th note
                136: 224,
                // lowercase a, grave accent
                137: 32,
                // transparent space (regular)
                138: 232,
                // lowercase e, grave accent
                139: 226,
                // lowercase a, circumflex accent
                140: 234,
                // lowercase e, circumflex accent
                141: 238,
                // lowercase i, circumflex accent
                142: 244,
                // lowercase o, circumflex accent
                143: 251,
                // lowercase u, circumflex accent
                // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
                // THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
                144: 193,
                // capital letter A with acute
                145: 201,
                // capital letter E with acute
                146: 211,
                // capital letter O with acute
                147: 218,
                // capital letter U with acute
                148: 220,
                // capital letter U with diaresis
                149: 252,
                // lowercase letter U with diaeresis
                150: 8216,
                // opening single quote
                151: 161,
                // inverted exclamation mark
                152: 42,
                // asterisk
                153: 8217,
                // closing single quote
                154: 9473,
                // box drawings heavy horizontal
                155: 169,
                // copyright sign
                156: 8480,
                // Service mark
                157: 8226,
                // (round) bullet
                158: 8220,
                // Left double quotation mark
                159: 8221,
                // Right double quotation mark
                160: 192,
                // uppercase A, grave accent
                161: 194,
                // uppercase A, circumflex
                162: 199,
                // uppercase C with cedilla
                163: 200,
                // uppercase E, grave accent
                164: 202,
                // uppercase E, circumflex
                165: 203,
                // capital letter E with diaresis
                166: 235,
                // lowercase letter e with diaresis
                167: 206,
                // uppercase I, circumflex
                168: 207,
                // uppercase I, with diaresis
                169: 239,
                // lowercase i, with diaresis
                170: 212,
                // uppercase O, circumflex
                171: 217,
                // uppercase U, grave accent
                172: 249,
                // lowercase u, grave accent
                173: 219,
                // uppercase U, circumflex
                174: 171,
                // left-pointing double angle quotation mark
                175: 187,
                // right-pointing double angle quotation mark
                // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
                // THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
                176: 195,
                // Uppercase A, tilde
                177: 227,
                // Lowercase a, tilde
                178: 205,
                // Uppercase I, acute accent
                179: 204,
                // Uppercase I, grave accent
                180: 236,
                // Lowercase i, grave accent
                181: 210,
                // Uppercase O, grave accent
                182: 242,
                // Lowercase o, grave accent
                183: 213,
                // Uppercase O, tilde
                184: 245,
                // Lowercase o, tilde
                185: 123,
                // Open curly brace
                186: 125,
                // Closing curly brace
                187: 92,
                // Backslash
                188: 94,
                // Caret
                189: 95,
                // Underscore
                190: 124,
                // Pipe (vertical line)
                191: 8764,
                // Tilde operator
                192: 196,
                // Uppercase A, umlaut
                193: 228,
                // Lowercase A, umlaut
                194: 214,
                // Uppercase O, umlaut
                195: 246,
                // Lowercase o, umlaut
                196: 223,
                // Esszett (sharp S)
                197: 165,
                // Yen symbol
                198: 164,
                // Generic currency sign
                199: 9475,
                // Box drawings heavy vertical
                200: 197,
                // Uppercase A, ring
                201: 229,
                // Lowercase A, ring
                202: 216,
                // Uppercase O, stroke
                203: 248,
                // Lowercase o, strok
                204: 9487,
                // Box drawings heavy down and right
                205: 9491,
                // Box drawings heavy down and left
                206: 9495,
                // Box drawings heavy up and right
                207: 9499
                // Box drawings heavy up and left
              }, wd = function(ma) {
                var Ho = ma;
                return Dd.hasOwnProperty(ma) && (Ho = Dd[ma]), String.fromCharCode(Ho);
              }, nd = 15, zd = 100, vh = {
                17: 1,
                18: 3,
                21: 5,
                22: 7,
                23: 9,
                16: 11,
                19: 12,
                20: 14
              }, Vp = {
                17: 2,
                18: 4,
                21: 6,
                22: 8,
                23: 10,
                19: 13,
                20: 15
              }, Wp = {
                25: 1,
                26: 3,
                29: 5,
                30: 7,
                31: 9,
                24: 11,
                27: 12,
                28: 14
              }, hd = {
                25: 2,
                26: 4,
                29: 6,
                30: 8,
                31: 10,
                27: 13,
                28: 15
              }, Uf = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "black", "transparent"], lc;
              (function(Sa) {
                Sa[Sa.ERROR = 0] = "ERROR", Sa[Sa.TEXT = 1] = "TEXT", Sa[Sa.WARNING = 2] = "WARNING", Sa[Sa.INFO = 2] = "INFO", Sa[Sa.DEBUG = 3] = "DEBUG", Sa[Sa.DATA = 3] = "DATA";
              })(lc || (lc = {}));
              var Gp = /* @__PURE__ */ (function() {
                function Sa() {
                  this.time = null, this.verboseLevel = lc.ERROR;
                }
                var ma = Sa.prototype;
                return ma.log = function(Io, Ri) {
                  this.verboseLevel >= Io && di.logger.log(this.time + " [" + Io + "] " + Ri);
                }, Sa;
              })(), Kd = function(ma) {
                for (var Ho = [], Io = 0; Io < ma.length; Io++)
                  Ho.push(ma[Io].toString(16));
                return Ho;
              }, Tp = /* @__PURE__ */ (function() {
                function Sa(Ho, Io, Ri, qi, Yo) {
                  this.foreground = void 0, this.underline = void 0, this.italics = void 0, this.background = void 0, this.flash = void 0, this.foreground = Ho || "white", this.underline = Io || !1, this.italics = Ri || !1, this.background = qi || "black", this.flash = Yo || !1;
                }
                var ma = Sa.prototype;
                return ma.reset = function() {
                  this.foreground = "white", this.underline = !1, this.italics = !1, this.background = "black", this.flash = !1;
                }, ma.setStyles = function(Io) {
                  for (var Ri = ["foreground", "underline", "italics", "background", "flash"], qi = 0; qi < Ri.length; qi++) {
                    var Yo = Ri[qi];
                    Io.hasOwnProperty(Yo) && (this[Yo] = Io[Yo]);
                  }
                }, ma.isDefault = function() {
                  return this.foreground === "white" && !this.underline && !this.italics && this.background === "black" && !this.flash;
                }, ma.equals = function(Io) {
                  return this.foreground === Io.foreground && this.underline === Io.underline && this.italics === Io.italics && this.background === Io.background && this.flash === Io.flash;
                }, ma.copy = function(Io) {
                  this.foreground = Io.foreground, this.underline = Io.underline, this.italics = Io.italics, this.background = Io.background, this.flash = Io.flash;
                }, ma.toString = function() {
                  return "color=" + this.foreground + ", underline=" + this.underline + ", italics=" + this.italics + ", background=" + this.background + ", flash=" + this.flash;
                }, Sa;
              })(), qd = /* @__PURE__ */ (function() {
                function Sa(Ho, Io, Ri, qi, Yo, ba) {
                  this.uchar = void 0, this.penState = void 0, this.uchar = Ho || " ", this.penState = new Tp(Io, Ri, qi, Yo, ba);
                }
                var ma = Sa.prototype;
                return ma.reset = function() {
                  this.uchar = " ", this.penState.reset();
                }, ma.setChar = function(Io, Ri) {
                  this.uchar = Io, this.penState.copy(Ri);
                }, ma.setPenState = function(Io) {
                  this.penState.copy(Io);
                }, ma.equals = function(Io) {
                  return this.uchar === Io.uchar && this.penState.equals(Io.penState);
                }, ma.copy = function(Io) {
                  this.uchar = Io.uchar, this.penState.copy(Io.penState);
                }, ma.isEmpty = function() {
                  return this.uchar === " " && this.penState.isDefault();
                }, Sa;
              })(), yh = /* @__PURE__ */ (function() {
                function Sa(Ho) {
                  this.chars = void 0, this.pos = void 0, this.currPenState = void 0, this.cueStartTime = void 0, this.logger = void 0, this.chars = [];
                  for (var Io = 0; Io < zd; Io++)
                    this.chars.push(new qd());
                  this.logger = Ho, this.pos = 0, this.currPenState = new Tp();
                }
                var ma = Sa.prototype;
                return ma.equals = function(Io) {
                  for (var Ri = !0, qi = 0; qi < zd; qi++)
                    if (!this.chars[qi].equals(Io.chars[qi])) {
                      Ri = !1;
                      break;
                    }
                  return Ri;
                }, ma.copy = function(Io) {
                  for (var Ri = 0; Ri < zd; Ri++)
                    this.chars[Ri].copy(Io.chars[Ri]);
                }, ma.isEmpty = function() {
                  for (var Io = !0, Ri = 0; Ri < zd; Ri++)
                    if (!this.chars[Ri].isEmpty()) {
                      Io = !1;
                      break;
                    }
                  return Io;
                }, ma.setCursor = function(Io) {
                  this.pos !== Io && (this.pos = Io), this.pos < 0 ? (this.logger.log(lc.DEBUG, "Negative cursor position " + this.pos), this.pos = 0) : this.pos > zd && (this.logger.log(lc.DEBUG, "Too large cursor position " + this.pos), this.pos = zd);
                }, ma.moveCursor = function(Io) {
                  var Ri = this.pos + Io;
                  if (Io > 1)
                    for (var qi = this.pos + 1; qi < Ri + 1; qi++)
                      this.chars[qi].setPenState(this.currPenState);
                  this.setCursor(Ri);
                }, ma.backSpace = function() {
                  this.moveCursor(-1), this.chars[this.pos].setChar(" ", this.currPenState);
                }, ma.insertChar = function(Io) {
                  Io >= 144 && this.backSpace();
                  var Ri = wd(Io);
                  if (this.pos >= zd) {
                    this.logger.log(lc.ERROR, "Cannot insert " + Io.toString(16) + " (" + Ri + ") at position " + this.pos + ". Skipping it!");
                    return;
                  }
                  this.chars[this.pos].setChar(Ri, this.currPenState), this.moveCursor(1);
                }, ma.clearFromPos = function(Io) {
                  var Ri;
                  for (Ri = Io; Ri < zd; Ri++)
                    this.chars[Ri].reset();
                }, ma.clear = function() {
                  this.clearFromPos(0), this.pos = 0, this.currPenState.reset();
                }, ma.clearToEndOfRow = function() {
                  this.clearFromPos(this.pos);
                }, ma.getTextString = function() {
                  for (var Io = [], Ri = !0, qi = 0; qi < zd; qi++) {
                    var Yo = this.chars[qi].uchar;
                    Yo !== " " && (Ri = !1), Io.push(Yo);
                  }
                  return Ri ? "" : Io.join("");
                }, ma.setPenStyles = function(Io) {
                  this.currPenState.setStyles(Io);
                  var Ri = this.chars[this.pos];
                  Ri.setPenState(this.currPenState);
                }, Sa;
              })(), Vf = /* @__PURE__ */ (function() {
                function Sa(Ho) {
                  this.rows = void 0, this.currRow = void 0, this.nrRollUpRows = void 0, this.lastOutputScreen = void 0, this.logger = void 0, this.rows = [];
                  for (var Io = 0; Io < nd; Io++)
                    this.rows.push(new yh(Ho));
                  this.logger = Ho, this.currRow = nd - 1, this.nrRollUpRows = null, this.lastOutputScreen = null, this.reset();
                }
                var ma = Sa.prototype;
                return ma.reset = function() {
                  for (var Io = 0; Io < nd; Io++)
                    this.rows[Io].clear();
                  this.currRow = nd - 1;
                }, ma.equals = function(Io) {
                  for (var Ri = !0, qi = 0; qi < nd; qi++)
                    if (!this.rows[qi].equals(Io.rows[qi])) {
                      Ri = !1;
                      break;
                    }
                  return Ri;
                }, ma.copy = function(Io) {
                  for (var Ri = 0; Ri < nd; Ri++)
                    this.rows[Ri].copy(Io.rows[Ri]);
                }, ma.isEmpty = function() {
                  for (var Io = !0, Ri = 0; Ri < nd; Ri++)
                    if (!this.rows[Ri].isEmpty()) {
                      Io = !1;
                      break;
                    }
                  return Io;
                }, ma.backSpace = function() {
                  var Io = this.rows[this.currRow];
                  Io.backSpace();
                }, ma.clearToEndOfRow = function() {
                  var Io = this.rows[this.currRow];
                  Io.clearToEndOfRow();
                }, ma.insertChar = function(Io) {
                  var Ri = this.rows[this.currRow];
                  Ri.insertChar(Io);
                }, ma.setPen = function(Io) {
                  var Ri = this.rows[this.currRow];
                  Ri.setPenStyles(Io);
                }, ma.moveCursor = function(Io) {
                  var Ri = this.rows[this.currRow];
                  Ri.moveCursor(Io);
                }, ma.setCursor = function(Io) {
                  this.logger.log(lc.INFO, "setCursor: " + Io);
                  var Ri = this.rows[this.currRow];
                  Ri.setCursor(Io);
                }, ma.setPAC = function(Io) {
                  this.logger.log(lc.INFO, "pacData = " + JSON.stringify(Io));
                  var Ri = Io.row - 1;
                  if (this.nrRollUpRows && Ri < this.nrRollUpRows - 1 && (Ri = this.nrRollUpRows - 1), this.nrRollUpRows && this.currRow !== Ri) {
                    for (var qi = 0; qi < nd; qi++)
                      this.rows[qi].clear();
                    var Yo = this.currRow + 1 - this.nrRollUpRows, ba = this.lastOutputScreen;
                    if (ba) {
                      var Na = ba.rows[Yo].cueStartTime, Ma = this.logger.time;
                      if (Na && Ma !== null && Na < Ma)
                        for (var bs = 0; bs < this.nrRollUpRows; bs++)
                          this.rows[Ri - this.nrRollUpRows + bs + 1].copy(ba.rows[Yo + bs]);
                    }
                  }
                  this.currRow = Ri;
                  var Ds = this.rows[this.currRow];
                  if (Io.indent !== null) {
                    var Fs = Io.indent, _l = Math.max(Fs - 1, 0);
                    Ds.setCursor(Io.indent), Io.color = Ds.chars[_l].penState.foreground;
                  }
                  var Ll = {
                    foreground: Io.color,
                    underline: Io.underline,
                    italics: Io.italics,
                    background: "black",
                    flash: !1
                  };
                  this.setPen(Ll);
                }, ma.setBkgData = function(Io) {
                  this.logger.log(lc.INFO, "bkgData = " + JSON.stringify(Io)), this.backSpace(), this.setPen(Io), this.insertChar(32);
                }, ma.setRollUpRows = function(Io) {
                  this.nrRollUpRows = Io;
                }, ma.rollUp = function() {
                  if (this.nrRollUpRows === null) {
                    this.logger.log(lc.DEBUG, "roll_up but nrRollUpRows not set yet");
                    return;
                  }
                  this.logger.log(lc.TEXT, this.getDisplayText());
                  var Io = this.currRow + 1 - this.nrRollUpRows, Ri = this.rows.splice(Io, 1)[0];
                  Ri.clear(), this.rows.splice(this.currRow, 0, Ri), this.logger.log(lc.INFO, "Rolling up");
                }, ma.getDisplayText = function(Io) {
                  Io = Io || !1;
                  for (var Ri = [], qi = "", Yo = -1, ba = 0; ba < nd; ba++) {
                    var Na = this.rows[ba].getTextString();
                    Na && (Yo = ba + 1, Io ? Ri.push("Row " + Yo + ": '" + Na + "'") : Ri.push(Na.trim()));
                  }
                  return Ri.length > 0 && (Io ? qi = "[" + Ri.join(" | ") + "]" : qi = Ri.join(`
`)), qi;
                }, ma.getTextAndFormat = function() {
                  return this.rows;
                }, Sa;
              })(), Ep = /* @__PURE__ */ (function() {
                function Sa(Ho, Io, Ri) {
                  this.chNr = void 0, this.outputFilter = void 0, this.mode = void 0, this.verbose = void 0, this.displayedMemory = void 0, this.nonDisplayedMemory = void 0, this.lastOutputScreen = void 0, this.currRollUpRow = void 0, this.writeScreen = void 0, this.cueStartTime = void 0, this.logger = void 0, this.chNr = Ho, this.outputFilter = Io, this.mode = null, this.verbose = 0, this.displayedMemory = new Vf(Ri), this.nonDisplayedMemory = new Vf(Ri), this.lastOutputScreen = new Vf(Ri), this.currRollUpRow = this.displayedMemory.rows[nd - 1], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null, this.logger = Ri;
                }
                var ma = Sa.prototype;
                return ma.reset = function() {
                  this.mode = null, this.displayedMemory.reset(), this.nonDisplayedMemory.reset(), this.lastOutputScreen.reset(), this.outputFilter.reset(), this.currRollUpRow = this.displayedMemory.rows[nd - 1], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null;
                }, ma.getHandler = function() {
                  return this.outputFilter;
                }, ma.setHandler = function(Io) {
                  this.outputFilter = Io;
                }, ma.setPAC = function(Io) {
                  this.writeScreen.setPAC(Io);
                }, ma.setBkgData = function(Io) {
                  this.writeScreen.setBkgData(Io);
                }, ma.setMode = function(Io) {
                  Io !== this.mode && (this.mode = Io, this.logger.log(lc.INFO, "MODE=" + Io), this.mode === "MODE_POP-ON" ? this.writeScreen = this.nonDisplayedMemory : (this.writeScreen = this.displayedMemory, this.writeScreen.reset()), this.mode !== "MODE_ROLL-UP" && (this.displayedMemory.nrRollUpRows = null, this.nonDisplayedMemory.nrRollUpRows = null), this.mode = Io);
                }, ma.insertChars = function(Io) {
                  for (var Ri = 0; Ri < Io.length; Ri++)
                    this.writeScreen.insertChar(Io[Ri]);
                  var qi = this.writeScreen === this.displayedMemory ? "DISP" : "NON_DISP";
                  this.logger.log(lc.INFO, qi + ": " + this.writeScreen.getDisplayText(!0)), (this.mode === "MODE_PAINT-ON" || this.mode === "MODE_ROLL-UP") && (this.logger.log(lc.TEXT, "DISPLAYED: " + this.displayedMemory.getDisplayText(!0)), this.outputDataUpdate());
                }, ma.ccRCL = function() {
                  this.logger.log(lc.INFO, "RCL - Resume Caption Loading"), this.setMode("MODE_POP-ON");
                }, ma.ccBS = function() {
                  this.logger.log(lc.INFO, "BS - BackSpace"), this.mode !== "MODE_TEXT" && (this.writeScreen.backSpace(), this.writeScreen === this.displayedMemory && this.outputDataUpdate());
                }, ma.ccAOF = function() {
                }, ma.ccAON = function() {
                }, ma.ccDER = function() {
                  this.logger.log(lc.INFO, "DER- Delete to End of Row"), this.writeScreen.clearToEndOfRow(), this.outputDataUpdate();
                }, ma.ccRU = function(Io) {
                  this.logger.log(lc.INFO, "RU(" + Io + ") - Roll Up"), this.writeScreen = this.displayedMemory, this.setMode("MODE_ROLL-UP"), this.writeScreen.setRollUpRows(Io);
                }, ma.ccFON = function() {
                  this.logger.log(lc.INFO, "FON - Flash On"), this.writeScreen.setPen({
                    flash: !0
                  });
                }, ma.ccRDC = function() {
                  this.logger.log(lc.INFO, "RDC - Resume Direct Captioning"), this.setMode("MODE_PAINT-ON");
                }, ma.ccTR = function() {
                  this.logger.log(lc.INFO, "TR"), this.setMode("MODE_TEXT");
                }, ma.ccRTD = function() {
                  this.logger.log(lc.INFO, "RTD"), this.setMode("MODE_TEXT");
                }, ma.ccEDM = function() {
                  this.logger.log(lc.INFO, "EDM - Erase Displayed Memory"), this.displayedMemory.reset(), this.outputDataUpdate(!0);
                }, ma.ccCR = function() {
                  this.logger.log(lc.INFO, "CR - Carriage Return"), this.writeScreen.rollUp(), this.outputDataUpdate(!0);
                }, ma.ccENM = function() {
                  this.logger.log(lc.INFO, "ENM - Erase Non-displayed Memory"), this.nonDisplayedMemory.reset();
                }, ma.ccEOC = function() {
                  if (this.logger.log(lc.INFO, "EOC - End Of Caption"), this.mode === "MODE_POP-ON") {
                    var Io = this.displayedMemory;
                    this.displayedMemory = this.nonDisplayedMemory, this.nonDisplayedMemory = Io, this.writeScreen = this.nonDisplayedMemory, this.logger.log(lc.TEXT, "DISP: " + this.displayedMemory.getDisplayText());
                  }
                  this.outputDataUpdate(!0);
                }, ma.ccTO = function(Io) {
                  this.logger.log(lc.INFO, "TO(" + Io + ") - Tab Offset"), this.writeScreen.moveCursor(Io);
                }, ma.ccMIDROW = function(Io) {
                  var Ri = {
                    flash: !1
                  };
                  if (Ri.underline = Io % 2 === 1, Ri.italics = Io >= 46, Ri.italics)
                    Ri.foreground = "white";
                  else {
                    var qi = Math.floor(Io / 2) - 16, Yo = ["white", "green", "blue", "cyan", "red", "yellow", "magenta"];
                    Ri.foreground = Yo[qi];
                  }
                  this.logger.log(lc.INFO, "MIDROW: " + JSON.stringify(Ri)), this.writeScreen.setPen(Ri);
                }, ma.outputDataUpdate = function(Io) {
                  Io === void 0 && (Io = !1);
                  var Ri = this.logger.time;
                  Ri !== null && this.outputFilter && (this.cueStartTime === null && !this.displayedMemory.isEmpty() ? this.cueStartTime = Ri : this.displayedMemory.equals(this.lastOutputScreen) || (this.outputFilter.newCue(this.cueStartTime, Ri, this.lastOutputScreen), Io && this.outputFilter.dispatchCue && this.outputFilter.dispatchCue(), this.cueStartTime = this.displayedMemory.isEmpty() ? null : Ri), this.lastOutputScreen.copy(this.displayedMemory));
                }, ma.cueSplitAtTime = function(Io) {
                  this.outputFilter && (this.displayedMemory.isEmpty() || (this.outputFilter.newCue && this.outputFilter.newCue(this.cueStartTime, Io, this.displayedMemory), this.cueStartTime = Io));
                }, Sa;
              })(), Hp = /* @__PURE__ */ (function() {
                function Sa(Ho, Io, Ri) {
                  this.channels = void 0, this.currentChannel = 0, this.cmdHistory = void 0, this.logger = void 0;
                  var qi = new Gp();
                  this.channels = [null, new Ep(Ho, Io, qi), new Ep(Ho + 1, Ri, qi)], this.cmdHistory = Gf(), this.logger = qi;
                }
                var ma = Sa.prototype;
                return ma.getHandler = function(Io) {
                  return this.channels[Io].getHandler();
                }, ma.setHandler = function(Io, Ri) {
                  this.channels[Io].setHandler(Ri);
                }, ma.addData = function(Io, Ri) {
                  var qi, Yo, ba, Na = !1;
                  this.logger.time = Io;
                  for (var Ma = 0; Ma < Ri.length; Ma += 2)
                    if (Yo = Ri[Ma] & 127, ba = Ri[Ma + 1] & 127, !(Yo === 0 && ba === 0)) {
                      if (this.logger.log(lc.DATA, "[" + Kd([Ri[Ma], Ri[Ma + 1]]) + "] -> (" + Kd([Yo, ba]) + ")"), qi = this.parseCmd(Yo, ba), qi || (qi = this.parseMidrow(Yo, ba)), qi || (qi = this.parsePAC(Yo, ba)), qi || (qi = this.parseBackgroundAttributes(Yo, ba)), !qi && (Na = this.parseChars(Yo, ba), Na)) {
                        var bs = this.currentChannel;
                        if (bs && bs > 0) {
                          var Ds = this.channels[bs];
                          Ds.insertChars(Na);
                        } else
                          this.logger.log(lc.WARNING, "No channel found yet. TEXT-MODE?");
                      }
                      !qi && !Na && this.logger.log(lc.WARNING, "Couldn't parse cleaned data " + Kd([Yo, ba]) + " orig: " + Kd([Ri[Ma], Ri[Ma + 1]]));
                    }
                }, ma.parseCmd = function(Io, Ri) {
                  var qi = this.cmdHistory, Yo = (Io === 20 || Io === 28 || Io === 21 || Io === 29) && Ri >= 32 && Ri <= 47, ba = (Io === 23 || Io === 31) && Ri >= 33 && Ri <= 35;
                  if (!(Yo || ba))
                    return !1;
                  if (Sp(Io, Ri, qi))
                    return Wf(null, null, qi), this.logger.log(lc.DEBUG, "Repeated command (" + Kd([Io, Ri]) + ") is dropped"), !0;
                  var Na = Io === 20 || Io === 21 || Io === 23 ? 1 : 2, Ma = this.channels[Na];
                  return Io === 20 || Io === 21 || Io === 28 || Io === 29 ? Ri === 32 ? Ma.ccRCL() : Ri === 33 ? Ma.ccBS() : Ri === 34 ? Ma.ccAOF() : Ri === 35 ? Ma.ccAON() : Ri === 36 ? Ma.ccDER() : Ri === 37 ? Ma.ccRU(2) : Ri === 38 ? Ma.ccRU(3) : Ri === 39 ? Ma.ccRU(4) : Ri === 40 ? Ma.ccFON() : Ri === 41 ? Ma.ccRDC() : Ri === 42 ? Ma.ccTR() : Ri === 43 ? Ma.ccRTD() : Ri === 44 ? Ma.ccEDM() : Ri === 45 ? Ma.ccCR() : Ri === 46 ? Ma.ccENM() : Ri === 47 && Ma.ccEOC() : Ma.ccTO(Ri - 32), Wf(Io, Ri, qi), this.currentChannel = Na, !0;
                }, ma.parseMidrow = function(Io, Ri) {
                  var qi = 0;
                  if ((Io === 17 || Io === 25) && Ri >= 32 && Ri <= 47) {
                    if (Io === 17 ? qi = 1 : qi = 2, qi !== this.currentChannel)
                      return this.logger.log(lc.ERROR, "Mismatch channel in midrow parsing"), !1;
                    var Yo = this.channels[qi];
                    return Yo ? (Yo.ccMIDROW(Ri), this.logger.log(lc.DEBUG, "MIDROW (" + Kd([Io, Ri]) + ")"), !0) : !1;
                  }
                  return !1;
                }, ma.parsePAC = function(Io, Ri) {
                  var qi, Yo = this.cmdHistory, ba = (Io >= 17 && Io <= 23 || Io >= 25 && Io <= 31) && Ri >= 64 && Ri <= 127, Na = (Io === 16 || Io === 24) && Ri >= 64 && Ri <= 95;
                  if (!(ba || Na))
                    return !1;
                  if (Sp(Io, Ri, Yo))
                    return Wf(null, null, Yo), !0;
                  var Ma = Io <= 23 ? 1 : 2;
                  Ri >= 64 && Ri <= 95 ? qi = Ma === 1 ? vh[Io] : Wp[Io] : qi = Ma === 1 ? Vp[Io] : hd[Io];
                  var bs = this.channels[Ma];
                  return bs ? (bs.setPAC(this.interpretPAC(qi, Ri)), Wf(Io, Ri, Yo), this.currentChannel = Ma, !0) : !1;
                }, ma.interpretPAC = function(Io, Ri) {
                  var qi = Ri, Yo = {
                    color: null,
                    italics: !1,
                    indent: null,
                    underline: !1,
                    row: Io
                  };
                  return Ri > 95 ? qi = Ri - 96 : qi = Ri - 64, Yo.underline = (qi & 1) === 1, qi <= 13 ? Yo.color = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "white"][Math.floor(qi / 2)] : qi <= 15 ? (Yo.italics = !0, Yo.color = "white") : Yo.indent = Math.floor((qi - 16) / 2) * 4, Yo;
                }, ma.parseChars = function(Io, Ri) {
                  var qi, Yo = null, ba = null;
                  if (Io >= 25 ? (qi = 2, ba = Io - 8) : (qi = 1, ba = Io), ba >= 17 && ba <= 19) {
                    var Na = Ri;
                    ba === 17 ? Na = Ri + 80 : ba === 18 ? Na = Ri + 112 : Na = Ri + 144, this.logger.log(lc.INFO, "Special char '" + wd(Na) + "' in channel " + qi), Yo = [Na];
                  } else Io >= 32 && Io <= 127 && (Yo = Ri === 0 ? [Io] : [Io, Ri]);
                  if (Yo) {
                    var Ma = Kd(Yo);
                    this.logger.log(lc.DEBUG, "Char codes =  " + Ma.join(",")), Wf(Io, Ri, this.cmdHistory);
                  }
                  return Yo;
                }, ma.parseBackgroundAttributes = function(Io, Ri) {
                  var qi = (Io === 16 || Io === 24) && Ri >= 32 && Ri <= 47, Yo = (Io === 23 || Io === 31) && Ri >= 45 && Ri <= 47;
                  if (!(qi || Yo))
                    return !1;
                  var ba, Na = {};
                  Io === 16 || Io === 24 ? (ba = Math.floor((Ri - 32) / 2), Na.background = Uf[ba], Ri % 2 === 1 && (Na.background = Na.background + "_semi")) : Ri === 45 ? Na.background = "transparent" : (Na.foreground = "black", Ri === 47 && (Na.underline = !0));
                  var Ma = Io <= 23 ? 1 : 2, bs = this.channels[Ma];
                  return bs.setBkgData(Na), Wf(Io, Ri, this.cmdHistory), !0;
                }, ma.reset = function() {
                  for (var Io = 0; Io < Object.keys(this.channels).length; Io++) {
                    var Ri = this.channels[Io];
                    Ri && Ri.reset();
                  }
                  this.cmdHistory = Gf();
                }, ma.cueSplitAtTime = function(Io) {
                  for (var Ri = 0; Ri < this.channels.length; Ri++) {
                    var qi = this.channels[Ri];
                    qi && qi.cueSplitAtTime(Io);
                  }
                }, Sa;
              })();
              function Wf(Sa, ma, Ho) {
                Ho.a = Sa, Ho.b = ma;
              }
              function Sp(Sa, ma, Ho) {
                return Ho.a === Sa && Ho.b === ma;
              }
              function Gf() {
                return {
                  a: null,
                  b: null
                };
              }
              var sd = Hp, _d = /* @__PURE__ */ (function() {
                function Sa(Ho, Io) {
                  this.timelineController = void 0, this.cueRanges = [], this.trackName = void 0, this.startTime = null, this.endTime = null, this.screen = null, this.timelineController = Ho, this.trackName = Io;
                }
                var ma = Sa.prototype;
                return ma.dispatchCue = function() {
                  this.startTime !== null && (this.timelineController.addCues(this.trackName, this.startTime, this.endTime, this.screen, this.cueRanges), this.startTime = null);
                }, ma.newCue = function(Io, Ri, qi) {
                  (this.startTime === null || this.startTime > Io) && (this.startTime = Io), this.endTime = Ri, this.screen = qi, this.timelineController.createCaptionsTrack(this.trackName);
                }, ma.reset = function() {
                  this.cueRanges = [];
                }, Sa;
              })(), Yd = function(ma, Ho, Io) {
                return ma.substr(0, Ho.length) === Ho;
              }, zp = function(ma) {
                var Ho = parseInt(ma.substr(-3)), Io = parseInt(ma.substr(-6, 2)), Ri = parseInt(ma.substr(-9, 2)), qi = ma.length > 9 ? parseInt(ma.substr(0, ma.indexOf(":"))) : 0;
                if (!Object(oi.isFiniteNumber)(Ho) || !Object(oi.isFiniteNumber)(Io) || !Object(oi.isFiniteNumber)(Ri) || !Object(oi.isFiniteNumber)(qi))
                  throw Error("Malformed X-TIMESTAMP-MAP: Local:" + ma);
                return Ho += 1e3 * Io, Ho += 60 * 1e3 * Ri, Ho += 3600 * 1e3 * qi, Ho;
              }, Ef = function(ma) {
                for (var Ho = 5381, Io = ma.length; Io; )
                  Ho = Ho * 33 ^ ma.charCodeAt(--Io);
                return (Ho >>> 0).toString();
              }, Yh = function(ma, Ho, Io) {
                var Ri = ma[Ho], qi = ma[Ri.prevCC];
                if (!qi || !qi.new && Ri.new) {
                  ma.ccOffset = ma.presentationOffset = Ri.start, Ri.new = !1;
                  return;
                }
                for (; qi && qi.new; )
                  ma.ccOffset += Ri.start - qi.start, Ri.new = !1, Ri = qi, qi = ma[Ri.prevCC];
                ma.presentationOffset = Io;
              }, xp = {
                parse: function(ma, Ho, Io, Ri, qi, Yo) {
                  var ba = /\r\n|\n\r|\n|\r/g, Na = Object(xu.utf8ArrayToStr)(new Uint8Array(ma)).trim().replace(ba, `
`).split(`
`), Ma = "00:00.000", bs = 0, Ds = 0, Fs = 0, _l = [], Ll, eu = !0, fu = !1, Fu = new od();
                  Fu.oncue = function(Ou) {
                    var qu = Io[Ri], Ju = Io.ccOffset;
                    qu && qu.new && (Ds !== void 0 ? Ju = Io.ccOffset = qu.start : Yh(Io, Ri, Fs)), Fs && (Ju = Fs - Io.presentationOffset), fu && (Ou.startTime += Ju - Ds, Ou.endTime += Ju - Ds), Ou.id = Ef(Ou.startTime.toString()) + Ef(Ou.endTime.toString()) + Ef(Ou.text), Ou.text = decodeURIComponent(encodeURIComponent(Ou.text)), Ou.endTime > 0 && _l.push(Ou);
                  }, Fu.onparsingerror = function(Ou) {
                    Ll = Ou;
                  }, Fu.onflush = function() {
                    if (Ll && Yo) {
                      Yo(Ll);
                      return;
                    }
                    qi(_l);
                  }, Na.forEach(function(Ou) {
                    if (eu)
                      if (Yd(Ou, "X-TIMESTAMP-MAP=")) {
                        eu = !1, fu = !0, Ou.substr(16).split(",").forEach(function(qu) {
                          Yd(qu, "LOCAL:") ? Ma = qu.substr(6) : Yd(qu, "MPEGTS:") && (bs = parseInt(qu.substr(7)));
                        });
                        try {
                          Ho + (Io[Ri].start * 9e4 || 0) < 0 && (Ho += 8589934592), bs -= Ho, Ds = zp(Ma) / 1e3, Fs = bs / 9e4;
                        } catch (qu) {
                          fu = !1, Ll = qu;
                        }
                        return;
                      } else Ou === "" && (eu = !1);
                    Fu.parse(Ou + `
`);
                  }), Fu.flush();
                }
              }, wp = xp;
              function Xd(Sa) {
                if (Sa === void 0)
                  throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return Sa;
              }
              function np(Sa, ma) {
                Sa.prototype = Object.create(ma.prototype), Sa.prototype.constructor = Sa, Sa.__proto__ = ma;
              }
              var sf = /* @__PURE__ */ (function(Sa) {
                np(ma, Sa);
                function ma(Io) {
                  var Ri;
                  if (Ri = Sa.call(this, Io, si.default.MEDIA_ATTACHING, si.default.MEDIA_DETACHING, si.default.FRAG_PARSING_USERDATA, si.default.FRAG_DECRYPTED, si.default.MANIFEST_LOADING, si.default.MANIFEST_LOADED, si.default.FRAG_LOADED, si.default.INIT_PTS_FOUND) || this, Ri.media = null, Ri.config = void 0, Ri.enabled = !0, Ri.Cues = void 0, Ri.textTracks = [], Ri.tracks = [], Ri.initPTS = [], Ri.unparsedVttFrags = [], Ri.captionsTracks = {}, Ri.nonNativeCaptionsTracks = {}, Ri.captionsProperties = void 0, Ri.cea608Parser1 = void 0, Ri.cea608Parser2 = void 0, Ri.lastSn = -1, Ri.prevCC = -1, Ri.vttCCs = lf(), Ri.hls = Io, Ri.config = Io.config, Ri.Cues = Io.config.cueHandler, Ri.captionsProperties = {
                    textTrack1: {
                      label: Ri.config.captionsTextTrack1Label,
                      languageCode: Ri.config.captionsTextTrack1LanguageCode
                    },
                    textTrack2: {
                      label: Ri.config.captionsTextTrack2Label,
                      languageCode: Ri.config.captionsTextTrack2LanguageCode
                    },
                    textTrack3: {
                      label: Ri.config.captionsTextTrack3Label,
                      languageCode: Ri.config.captionsTextTrack3LanguageCode
                    },
                    textTrack4: {
                      label: Ri.config.captionsTextTrack4Label,
                      languageCode: Ri.config.captionsTextTrack4LanguageCode
                    }
                  }, Ri.config.enableCEA708Captions) {
                    var qi = new _d(Xd(Ri), "textTrack1"), Yo = new _d(Xd(Ri), "textTrack2"), ba = new _d(Xd(Ri), "textTrack3"), Na = new _d(Xd(Ri), "textTrack4");
                    Ri.cea608Parser1 = new sd(1, qi, Yo), Ri.cea608Parser2 = new sd(3, ba, Na);
                  }
                  return Ri;
                }
                var Ho = ma.prototype;
                return Ho.addCues = function(Ri, qi, Yo, ba, Na) {
                  for (var Ma = !1, bs = Na.length; bs--; ) {
                    var Ds = Na[bs], Fs = Xh(Ds[0], Ds[1], qi, Yo);
                    if (Fs >= 0 && (Ds[0] = Math.min(Ds[0], qi), Ds[1] = Math.max(Ds[1], Yo), Ma = !0, Fs / (Yo - qi) > 0.5))
                      return;
                  }
                  if (Ma || Na.push([qi, Yo]), this.config.renderTextTracksNatively)
                    this.Cues.newCue(this.captionsTracks[Ri], qi, Yo, ba);
                  else {
                    var _l = this.Cues.newCue(null, qi, Yo, ba);
                    this.hls.trigger(si.default.CUES_PARSED, {
                      type: "captions",
                      cues: _l,
                      track: Ri
                    });
                  }
                }, Ho.onInitPtsFound = function(Ri) {
                  var qi = this, Yo = Ri.frag, ba = Ri.id, Na = Ri.initPTS, Ma = this.unparsedVttFrags;
                  ba === "main" && (this.initPTS[Yo.cc] = Na), Ma.length && (this.unparsedVttFrags = [], Ma.forEach(function(bs) {
                    qi.onFragLoaded(bs);
                  }));
                }, Ho.getExistingTrack = function(Ri) {
                  var qi = this.media;
                  if (qi)
                    for (var Yo = 0; Yo < qi.textTracks.length; Yo++) {
                      var ba = qi.textTracks[Yo];
                      if (ba[Ri])
                        return ba;
                    }
                  return null;
                }, Ho.createCaptionsTrack = function(Ri) {
                  this.config.renderTextTracksNatively ? this.createNativeTrack(Ri) : this.createNonNativeTrack(Ri);
                }, Ho.createNativeTrack = function(Ri) {
                  if (!this.captionsTracks[Ri]) {
                    var qi = this.captionsProperties, Yo = this.captionsTracks, ba = this.media, Na = qi[Ri], Ma = Na.label, bs = Na.languageCode, Ds = this.getExistingTrack(Ri);
                    if (Ds)
                      Yo[Ri] = Ds, hc(Yo[Ri]), ac(Yo[Ri], ba);
                    else {
                      var Fs = this.createTextTrack("captions", Ma, bs);
                      Fs && (Fs[Ri] = !0, Yo[Ri] = Fs);
                    }
                  }
                }, Ho.createNonNativeTrack = function(Ri) {
                  if (!this.nonNativeCaptionsTracks[Ri]) {
                    var qi = this.captionsProperties[Ri];
                    if (qi) {
                      var Yo = qi.label, ba = {
                        _id: Ri,
                        label: Yo,
                        kind: "captions",
                        default: qi.media ? !!qi.media.default : !1,
                        closedCaptions: qi.media
                      };
                      this.nonNativeCaptionsTracks[Ri] = ba, this.hls.trigger(si.default.NON_NATIVE_TEXT_TRACKS_FOUND, {
                        tracks: [ba]
                      });
                    }
                  }
                }, Ho.createTextTrack = function(Ri, qi, Yo) {
                  var ba = this.media;
                  if (ba)
                    return ba.addTextTrack(Ri, qi, Yo);
                }, Ho.destroy = function() {
                  Sa.prototype.destroy.call(this);
                }, Ho.onMediaAttaching = function(Ri) {
                  this.media = Ri.media, this._cleanTracks();
                }, Ho.onMediaDetaching = function() {
                  var Ri = this.captionsTracks;
                  Object.keys(Ri).forEach(function(qi) {
                    hc(Ri[qi]), delete Ri[qi];
                  }), this.nonNativeCaptionsTracks = {};
                }, Ho.onManifestLoading = function() {
                  this.lastSn = -1, this.prevCC = -1, this.vttCCs = lf(), this._cleanTracks(), this.tracks = [], this.captionsTracks = {}, this.nonNativeCaptionsTracks = {};
                }, Ho._cleanTracks = function() {
                  var Ri = this.media;
                  if (Ri) {
                    var qi = Ri.textTracks;
                    if (qi)
                      for (var Yo = 0; Yo < qi.length; Yo++)
                        hc(qi[Yo]);
                  }
                }, Ho.onManifestLoaded = function(Ri) {
                  var qi = this;
                  if (this.textTracks = [], this.unparsedVttFrags = this.unparsedVttFrags || [], this.initPTS = [], this.cea608Parser1 && this.cea608Parser2 && (this.cea608Parser1.reset(), this.cea608Parser2.reset()), this.config.enableWebVTT) {
                    var Yo = Ri.subtitles || [], ba = this.tracks && Yo && this.tracks.length === Yo.length;
                    if (this.tracks = Ri.subtitles || [], this.config.renderTextTracksNatively) {
                      var Na = this.media ? this.media.textTracks : [];
                      this.tracks.forEach(function(bs, Ds) {
                        var Fs;
                        if (Ds < Na.length) {
                          for (var _l = null, Ll = 0; Ll < Na.length; Ll++)
                            if (_p(Na[Ll], bs)) {
                              _l = Na[Ll];
                              break;
                            }
                          _l && (Fs = _l);
                        }
                        Fs || (Fs = qi.createTextTrack("subtitles", bs.name, bs.lang)), bs.default ? Fs.mode = qi.hls.subtitleDisplay ? "showing" : "hidden" : Fs.mode = "disabled", qi.textTracks.push(Fs);
                      });
                    } else if (!ba && this.tracks && this.tracks.length) {
                      var Ma = this.tracks.map(function(bs) {
                        return {
                          label: bs.name,
                          kind: bs.type.toLowerCase(),
                          default: bs.default,
                          subtitleTrack: bs
                        };
                      });
                      this.hls.trigger(si.default.NON_NATIVE_TEXT_TRACKS_FOUND, {
                        tracks: Ma
                      });
                    }
                  }
                  this.config.enableCEA708Captions && Ri.captions && Ri.captions.forEach(function(bs) {
                    var Ds = /(?:CC|SERVICE)([1-4])/.exec(bs.instreamId);
                    if (Ds) {
                      var Fs = "textTrack" + Ds[1], _l = qi.captionsProperties[Fs];
                      _l && (_l.label = bs.name, bs.lang && (_l.languageCode = bs.lang), _l.media = bs);
                    }
                  });
                }, Ho.onFragLoaded = function(Ri) {
                  var qi = Ri.frag, Yo = Ri.payload, ba = this.cea608Parser1, Na = this.cea608Parser2, Ma = this.initPTS, bs = this.lastSn, Ds = this.unparsedVttFrags;
                  if (qi.type === "main") {
                    var Fs = qi.sn;
                    qi.sn !== bs + 1 && ba && Na && (ba.reset(), Na.reset()), this.lastSn = Fs;
                  } else if (qi.type === "subtitle")
                    if (Yo.byteLength) {
                      if (!Object(oi.isFiniteNumber)(Ma[qi.cc])) {
                        Ds.push(Ri), Ma.length && this.hls.trigger(si.default.SUBTITLE_FRAG_PROCESSED, {
                          success: !1,
                          frag: qi
                        });
                        return;
                      }
                      var _l = qi.decryptdata;
                      (_l == null || _l.key == null || _l.method !== "AES-128") && this._parseVTTs(qi, Yo);
                    } else
                      this.hls.trigger(si.default.SUBTITLE_FRAG_PROCESSED, {
                        success: !1,
                        frag: qi
                      });
                }, Ho._parseVTTs = function(Ri, qi) {
                  var Yo = this, ba = this.hls, Na = this.prevCC, Ma = this.textTracks, bs = this.vttCCs;
                  bs[Ri.cc] || (bs[Ri.cc] = {
                    start: Ri.start,
                    prevCC: Na,
                    new: !0
                  }, this.prevCC = Ri.cc), wp.parse(qi, this.initPTS[Ri.cc], bs, Ri.cc, function(Ds) {
                    if (Yo.config.renderTextTracksNatively) {
                      var Fs = Ma[Ri.level];
                      if (Fs.mode === "disabled") {
                        ba.trigger(si.default.SUBTITLE_FRAG_PROCESSED, {
                          success: !1,
                          frag: Ri
                        });
                        return;
                      }
                      Ds.forEach(function(Ll) {
                        if (!Fs.cues.getCueById(Ll.id))
                          try {
                            if (Fs.addCue(Ll), !Fs.cues.getCueById(Ll.id))
                              throw new Error("addCue is failed for: " + Ll);
                          } catch (fu) {
                            di.logger.debug("Failed occurred on adding cues: " + fu);
                            var eu = new window.TextTrackCue(Ll.startTime, Ll.endTime, Ll.text);
                            eu.id = Ll.id, Fs.addCue(eu);
                          }
                      });
                    } else {
                      var _l = Yo.tracks[Ri.level].default ? "default" : "subtitles" + Ri.level;
                      ba.trigger(si.default.CUES_PARSED, {
                        type: "subtitles",
                        cues: Ds,
                        track: _l
                      });
                    }
                    ba.trigger(si.default.SUBTITLE_FRAG_PROCESSED, {
                      success: !0,
                      frag: Ri
                    });
                  }, function(Ds) {
                    di.logger.log("Failed to parse VTT cue: " + Ds), ba.trigger(si.default.SUBTITLE_FRAG_PROCESSED, {
                      success: !1,
                      frag: Ri
                    });
                  });
                }, Ho.onFragDecrypted = function(Ri) {
                  var qi = Ri.frag, Yo = Ri.payload;
                  if (qi.type === "subtitle") {
                    if (!Object(oi.isFiniteNumber)(this.initPTS[qi.cc])) {
                      this.unparsedVttFrags.push(Ri);
                      return;
                    }
                    this._parseVTTs(qi, Yo);
                  }
                }, Ho.onFragParsingUserdata = function(Ri) {
                  var qi = this.cea608Parser1, Yo = this.cea608Parser2;
                  if (!(!this.enabled || !(qi && Yo)))
                    for (var ba = 0; ba < Ri.samples.length; ba++) {
                      var Na = Ri.samples[ba].bytes;
                      if (Na) {
                        var Ma = this.extractCea608Data(Na);
                        qi.addData(Ri.samples[ba].pts, Ma[0]), Yo.addData(Ri.samples[ba].pts, Ma[1]);
                      }
                    }
                }, Ho.extractCea608Data = function(Ri) {
                  for (var qi = Ri[0] & 31, Yo = 2, ba = [[], []], Na = 0; Na < qi; Na++) {
                    var Ma = Ri[Yo++], bs = 127 & Ri[Yo++], Ds = 127 & Ri[Yo++], Fs = (4 & Ma) !== 0, _l = 3 & Ma;
                    bs === 0 && Ds === 0 || Fs && (_l === 0 || _l === 1) && (ba[_l].push(bs), ba[_l].push(Ds));
                  }
                  return ba;
                }, ma;
              })(mi);
              function _p(Sa, ma) {
                return Sa && Sa.label === ma.name && !(Sa.textTrack1 || Sa.textTrack2);
              }
              function Xh(Sa, ma, Ho, Io) {
                return Math.min(ma, Io) - Math.max(Sa, Ho);
              }
              function lf() {
                return {
                  ccOffset: 0,
                  presentationOffset: 0,
                  0: {
                    start: 0,
                    prevCC: -1,
                    new: !1
                  }
                };
              }
              var bh = sf;
              function uf(Sa, ma) {
                for (var Ho = 0; Ho < ma.length; Ho++) {
                  var Io = ma[Ho];
                  Io.enumerable = Io.enumerable || !1, Io.configurable = !0, "value" in Io && (Io.writable = !0), Object.defineProperty(Sa, Io.key, Io);
                }
              }
              function gd(Sa, ma, Ho) {
                return ma && uf(Sa.prototype, ma), Sa;
              }
              function Sf(Sa, ma) {
                Sa.prototype = Object.create(ma.prototype), Sa.prototype.constructor = Sa, Sa.__proto__ = ma;
              }
              var Yc = /* @__PURE__ */ (function(Sa) {
                Sf(ma, Sa);
                function ma(Io) {
                  var Ri;
                  return Ri = Sa.call(this, Io, si.default.MEDIA_ATTACHED, si.default.MEDIA_DETACHING, si.default.MANIFEST_LOADED, si.default.SUBTITLE_TRACK_LOADED) || this, Ri.tracks = [], Ri.trackId = -1, Ri.media = null, Ri.stopped = !0, Ri.subtitleDisplay = !0, Ri.queuedDefaultTrack = null, Ri;
                }
                var Ho = ma.prototype;
                return Ho.destroy = function() {
                  mi.prototype.destroy.call(this);
                }, Ho.onMediaAttached = function(Ri) {
                  var qi = this;
                  this.media = Ri.media, this.media && (Object(oi.isFiniteNumber)(this.queuedDefaultTrack) && (this.subtitleTrack = this.queuedDefaultTrack, this.queuedDefaultTrack = null), this.trackChangeListener = this._onTextTracksChanged.bind(this), this.useTextTrackPolling = !(this.media.textTracks && "onchange" in this.media.textTracks), this.useTextTrackPolling ? this.subtitlePollingInterval = setInterval(function() {
                    qi.trackChangeListener();
                  }, 500) : this.media.textTracks.addEventListener("change", this.trackChangeListener));
                }, Ho.onMediaDetaching = function() {
                  if (this.media) {
                    this.useTextTrackPolling ? clearInterval(this.subtitlePollingInterval) : this.media.textTracks.removeEventListener("change", this.trackChangeListener), Object(oi.isFiniteNumber)(this.subtitleTrack) && (this.queuedDefaultTrack = this.subtitleTrack);
                    var Ri = Kp(this.media.textTracks);
                    Ri.forEach(function(qi) {
                      hc(qi);
                    }), this.subtitleTrack = -1, this.media = null;
                  }
                }, Ho.onManifestLoaded = function(Ri) {
                  var qi = this, Yo = Ri.subtitles || [];
                  this.tracks = Yo, this.hls.trigger(si.default.SUBTITLE_TRACKS_UPDATED, {
                    subtitleTracks: Yo
                  }), Yo.forEach(function(ba) {
                    ba.default && (qi.media ? qi.subtitleTrack = ba.id : qi.queuedDefaultTrack = ba.id);
                  });
                }, Ho.onSubtitleTrackLoaded = function(Ri) {
                  var qi = this, Yo = Ri.id, ba = Ri.details, Na = this.trackId, Ma = this.tracks, bs = Ma[Na];
                  if (Yo >= Ma.length || Yo !== Na || !bs || this.stopped) {
                    this._clearReloadTimer();
                    return;
                  }
                  if (di.logger.log("subtitle track " + Yo + " loaded"), ba.live) {
                    var Ds = xl(bs.details, ba, Ri.stats.trequest);
                    di.logger.log("Reloading live subtitle playlist in " + Ds + "ms"), this.timer = setTimeout(function() {
                      qi._loadCurrentTrack();
                    }, Ds);
                  } else
                    this._clearReloadTimer();
                }, Ho.startLoad = function() {
                  this.stopped = !1, this._loadCurrentTrack();
                }, Ho.stopLoad = function() {
                  this.stopped = !0, this._clearReloadTimer();
                }, Ho._clearReloadTimer = function() {
                  this.timer && (clearTimeout(this.timer), this.timer = null);
                }, Ho._loadCurrentTrack = function() {
                  var Ri = this.trackId, qi = this.tracks, Yo = this.hls, ba = qi[Ri];
                  Ri < 0 || !ba || ba.details && !ba.details.live || (di.logger.log("Loading subtitle track " + Ri), Yo.trigger(si.default.SUBTITLE_TRACK_LOADING, {
                    url: ba.url,
                    id: Ri
                  }));
                }, Ho._toggleTrackModes = function(Ri) {
                  var qi = this.media, Yo = this.subtitleDisplay, ba = this.trackId;
                  if (qi) {
                    var Na = Kp(qi.textTracks);
                    if (Ri === -1)
                      [].slice.call(Na).forEach(function(Ds) {
                        Ds.mode = "disabled";
                      });
                    else {
                      var Ma = Na[ba];
                      Ma && (Ma.mode = "disabled");
                    }
                    var bs = Na[Ri];
                    bs && (bs.mode = Yo ? "showing" : "hidden");
                  }
                }, Ho._setSubtitleTrackInternal = function(Ri) {
                  var qi = this.hls, Yo = this.tracks;
                  !Object(oi.isFiniteNumber)(Ri) || Ri < -1 || Ri >= Yo.length || (this.trackId = Ri, di.logger.log("Switching to subtitle track " + Ri), qi.trigger(si.default.SUBTITLE_TRACK_SWITCH, {
                    id: Ri
                  }), this._loadCurrentTrack());
                }, Ho._onTextTracksChanged = function() {
                  if (!(!this.media || !this.hls.config.renderTextTracksNatively)) {
                    for (var Ri = -1, qi = Kp(this.media.textTracks), Yo = 0; Yo < qi.length; Yo++)
                      if (qi[Yo].mode === "hidden")
                        Ri = Yo;
                      else if (qi[Yo].mode === "showing") {
                        Ri = Yo;
                        break;
                      }
                    this.subtitleTrack = Ri;
                  }
                }, gd(ma, [{
                  key: "subtitleTracks",
                  get: function() {
                    return this.tracks;
                  }
                  /** get index of the selected subtitle track (index in subtitle track lists) **/
                }, {
                  key: "subtitleTrack",
                  get: function() {
                    return this.trackId;
                  },
                  set: function(Ri) {
                    this.trackId !== Ri && (this._toggleTrackModes(Ri), this._setSubtitleTrackInternal(Ri));
                  }
                }]), ma;
              })(mi);
              function Kp(Sa) {
                for (var ma = [], Ho = 0; Ho < Sa.length; Ho++) {
                  var Io = Sa[Ho];
                  Io.kind === "subtitles" && Io.label && ma.push(Sa[Ho]);
                }
                return ma;
              }
              var Sc = Yc, xf = ii("./src/crypt/decrypter.js");
              function qp(Sa) {
                if (Sa === void 0)
                  throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return Sa;
              }
              function Pp(Sa, ma) {
                Sa.prototype = Object.create(ma.prototype), Sa.prototype.constructor = Sa, Sa.__proto__ = ma;
              }
              var Pd = window, Cd = Pd.performance, Hf = 500, Zd = /* @__PURE__ */ (function(Sa) {
                Pp(ma, Sa);
                function ma(Io, Ri) {
                  var qi;
                  return qi = Sa.call(this, Io, si.default.MEDIA_ATTACHED, si.default.MEDIA_DETACHING, si.default.ERROR, si.default.KEY_LOADED, si.default.FRAG_LOADED, si.default.SUBTITLE_TRACKS_UPDATED, si.default.SUBTITLE_TRACK_SWITCH, si.default.SUBTITLE_TRACK_LOADED, si.default.SUBTITLE_FRAG_PROCESSED, si.default.LEVEL_UPDATED) || this, qi.fragmentTracker = Ri, qi.config = Io.config, qi.state = dl.STOPPED, qi.tracks = [], qi.tracksBuffered = [], qi.currentTrackId = -1, qi.decrypter = new xf.default(Io, Io.config), qi.lastAVStart = 0, qi._onMediaSeeking = qi.onMediaSeeking.bind(qp(qi)), qi;
                }
                var Ho = ma.prototype;
                return Ho.startLoad = function() {
                  this.stopLoad(), this.state = dl.IDLE;
                  var Ri = this.tracks[this.currentTrackId];
                  Ri && Ri.details && (this.setInterval(Hf), this.tick());
                }, Ho.onSubtitleFragProcessed = function(Ri) {
                  var qi = Ri.frag, Yo = Ri.success;
                  if (this.fragPrevious = qi, this.state = dl.IDLE, !!Yo) {
                    var ba = this.tracksBuffered[this.currentTrackId];
                    if (ba) {
                      for (var Na, Ma = qi.start, bs = 0; bs < ba.length; bs++)
                        if (Ma >= ba[bs].start && Ma <= ba[bs].end) {
                          Na = ba[bs];
                          break;
                        }
                      var Ds = qi.start + qi.duration;
                      Na ? Na.end = Ds : (Na = {
                        start: Ma,
                        end: Ds
                      }, ba.push(Na));
                    }
                  }
                }, Ho.onMediaAttached = function(Ri) {
                  var qi = Ri.media;
                  this.media = qi, qi.addEventListener("seeking", this._onMediaSeeking), this.state = dl.IDLE;
                }, Ho.onMediaDetaching = function() {
                  var Ri = this;
                  this.media && (this.media.removeEventListener("seeking", this._onMediaSeeking), this.fragmentTracker.removeAllFragments(), this.currentTrackId = -1, this.tracks.forEach(function(qi) {
                    Ri.tracksBuffered[qi.id] = [];
                  }), this.media = null, this.state = dl.STOPPED);
                }, Ho.onError = function(Ri) {
                  var qi = Ri.frag;
                  !qi || qi.type !== "subtitle" || (this.fragCurrent && this.fragCurrent.loader && this.fragCurrent.loader.abort(), this.state = dl.IDLE);
                }, Ho.onSubtitleTracksUpdated = function(Ri) {
                  var qi = this;
                  di.logger.log("subtitle tracks updated"), this.tracksBuffered = [], this.tracks = Ri.subtitleTracks, this.tracks.forEach(function(Yo) {
                    qi.tracksBuffered[Yo.id] = [];
                  });
                }, Ho.onSubtitleTrackSwitch = function(Ri) {
                  if (this.currentTrackId = Ri.id, !this.tracks || !this.tracks.length || this.currentTrackId === -1) {
                    this.clearInterval();
                    return;
                  }
                  var qi = this.tracks[this.currentTrackId];
                  qi && qi.details && this.setInterval(Hf);
                }, Ho.onSubtitleTrackLoaded = function(Ri) {
                  var qi = Ri.id, Yo = Ri.details, ba = this.currentTrackId, Na = this.tracks, Ma = Na[ba];
                  qi >= Na.length || qi !== ba || !Ma || (Yo.live && Vl(Ma.details, Yo, this.lastAVStart), Ma.details = Yo, this.setInterval(Hf));
                }, Ho.onKeyLoaded = function() {
                  this.state === dl.KEY_LOADING && (this.state = dl.IDLE);
                }, Ho.onFragLoaded = function(Ri) {
                  var qi = this.fragCurrent, Yo = Ri.frag.decryptdata, ba = Ri.frag, Na = this.hls;
                  if (this.state === dl.FRAG_LOADING && qi && Ri.frag.type === "subtitle" && qi.sn === Ri.frag.sn && Ri.payload.byteLength > 0 && Yo && Yo.key && Yo.method === "AES-128") {
                    var Ma = Cd.now();
                    this.decrypter.decrypt(Ri.payload, Yo.key.buffer, Yo.iv.buffer, function(bs) {
                      var Ds = Cd.now();
                      Na.trigger(si.default.FRAG_DECRYPTED, {
                        frag: ba,
                        payload: bs,
                        stats: {
                          tstart: Ma,
                          tdecrypt: Ds
                        }
                      });
                    });
                  }
                }, Ho.onLevelUpdated = function(Ri) {
                  var qi = Ri.details, Yo = qi.fragments;
                  this.lastAVStart = Yo.length ? Yo[0].start : 0;
                }, Ho.doTick = function() {
                  if (!this.media) {
                    this.state = dl.IDLE;
                    return;
                  }
                  switch (this.state) {
                    case dl.IDLE: {
                      var Ri = this.config, qi = this.currentTrackId, Yo = this.fragmentTracker, ba = this.media, Na = this.tracks;
                      if (!Na || !Na[qi] || !Na[qi].details)
                        break;
                      var Ma = Ri.maxBufferHole, bs = Ri.maxFragLookUpTolerance, Ds = Math.min(Ri.maxBufferLength, Ri.maxMaxBufferLength), Fs = ja.bufferedInfo(this._getBuffered(), ba.currentTime, Ma), _l = Fs.end, Ll = Fs.len, eu = Na[qi].details, fu = eu.fragments, Fu = fu.length, Ou = fu[Fu - 1].start + fu[Fu - 1].duration;
                      if (Ll > Ds)
                        return;
                      var qu, Ju = this.fragPrevious;
                      _l < Ou ? (Ju && eu.hasProgramDateTime && (qu = Ws(fu, Ju.endProgramDateTime, bs)), qu || (qu = wl(Ju, fu, _l, bs))) : qu = fu[Fu - 1], qu && qu.encrypted ? (di.logger.log("Loading key for " + qu.sn), this.state = dl.KEY_LOADING, this.hls.trigger(si.default.KEY_LOADING, {
                        frag: qu
                      })) : qu && Yo.getState(qu) === Es.NOT_LOADED && (this.fragCurrent = qu, this.state = dl.FRAG_LOADING, this.hls.trigger(si.default.FRAG_LOADING, {
                        frag: qu
                      }));
                    }
                  }
                }, Ho.stopLoad = function() {
                  this.lastAVStart = 0, this.fragPrevious = null, Sa.prototype.stopLoad.call(this);
                }, Ho._getBuffered = function() {
                  return this.tracksBuffered[this.currentTrackId] || [];
                }, Ho.onMediaSeeking = function() {
                  if (this.fragCurrent) {
                    var Ri = this.media ? this.media.currentTime : 0, qi = this.config.maxFragLookUpTolerance, Yo = this.fragCurrent.start - qi, ba = this.fragCurrent.start + this.fragCurrent.duration + qi;
                    (Ri < Yo || Ri > ba) && (this.fragCurrent.loader && this.fragCurrent.loader.abort(), this.fragmentTracker.removeFragment(this.fragCurrent), this.fragCurrent = null, this.fragPrevious = null, this.state = dl.IDLE, this.tick());
                  }
                }, ma;
              })(Su), ef;
              (function(Sa) {
                Sa.WIDEVINE = "com.widevine.alpha", Sa.PLAYREADY = "com.microsoft.playready";
              })(ef || (ef = {}));
              var Yp = (function() {
                return typeof window < "u" && window.navigator && window.navigator.requestMediaKeySystemAccess ? window.navigator.requestMediaKeySystemAccess.bind(window.navigator) : null;
              })();
              function Th(Sa, ma) {
                for (var Ho = 0; Ho < ma.length; Ho++) {
                  var Io = ma[Ho];
                  Io.enumerable = Io.enumerable || !1, Io.configurable = !0, "value" in Io && (Io.writable = !0), Object.defineProperty(Sa, Io.key, Io);
                }
              }
              function Jh(Sa, ma, Ho) {
                return ma && Th(Sa.prototype, ma), Sa;
              }
              function Eh(Sa, ma) {
                Sa.prototype = Object.create(ma.prototype), Sa.prototype.constructor = Sa, Sa.__proto__ = ma;
              }
              var Cp = 3, Rd = function(ma, Ho, Io) {
                var Ri = {
                  // initDataTypes: ['keyids', 'mp4'],
                  // label: "",
                  // persistentState: "not-allowed", // or "required" ?
                  // distinctiveIdentifier: "not-allowed", // or "required" ?
                  // sessionTypes: ['temporary'],
                  audioCapabilities: [],
                  // { contentType: 'audio/mp4; codecs="mp4a.40.2"' }
                  videoCapabilities: []
                  // { contentType: 'video/mp4; codecs="avc1.42E01E"' }
                };
                return ma.forEach(function(qi) {
                  Ri.audioCapabilities.push({
                    contentType: 'audio/mp4; codecs="' + qi + '"',
                    robustness: Io.audioRobustness || ""
                  });
                }), Ho.forEach(function(qi) {
                  Ri.videoCapabilities.push({
                    contentType: 'video/mp4; codecs="' + qi + '"',
                    robustness: Io.videoRobustness || ""
                  });
                }), [Ri];
              }, Qh = function(ma, Ho, Io, Ri) {
                switch (ma) {
                  case ef.WIDEVINE:
                    return Rd(Ho, Io, Ri);
                  default:
                    throw new Error("Unknown key-system: " + ma);
                }
              }, md = /* @__PURE__ */ (function(Sa) {
                Eh(ma, Sa);
                function ma(Io) {
                  var Ri;
                  return Ri = Sa.call(this, Io, si.default.MEDIA_ATTACHED, si.default.MEDIA_DETACHED, si.default.MANIFEST_PARSED) || this, Ri._widevineLicenseUrl = void 0, Ri._licenseXhrSetup = void 0, Ri._emeEnabled = void 0, Ri._requestMediaKeySystemAccess = void 0, Ri._drmSystemOptions = void 0, Ri._config = void 0, Ri._mediaKeysList = [], Ri._media = null, Ri._hasSetMediaKeys = !1, Ri._requestLicenseFailureCount = 0, Ri.mediaKeysPromise = null, Ri._onMediaEncrypted = function(qi) {
                    if (di.logger.log('Media is encrypted using "' + qi.initDataType + '" init data type'), !Ri.mediaKeysPromise) {
                      di.logger.error("Fatal: Media is encrypted but no CDM access or no keys have been requested"), Ri.hls.trigger(si.default.ERROR, {
                        type: li.ErrorTypes.KEY_SYSTEM_ERROR,
                        details: li.ErrorDetails.KEY_SYSTEM_NO_KEYS,
                        fatal: !0
                      });
                      return;
                    }
                    var Yo = function(Na) {
                      Ri._media && (Ri._attemptSetMediaKeys(Na), Ri._generateRequestWithPreferredKeySession(qi.initDataType, qi.initData));
                    };
                    Ri.mediaKeysPromise.then(Yo).catch(Yo);
                  }, Ri._config = Io.config, Ri._widevineLicenseUrl = Ri._config.widevineLicenseUrl, Ri._licenseXhrSetup = Ri._config.licenseXhrSetup, Ri._emeEnabled = Ri._config.emeEnabled, Ri._requestMediaKeySystemAccess = Ri._config.requestMediaKeySystemAccessFunc, Ri._drmSystemOptions = Io.config.drmSystemOptions, Ri;
                }
                var Ho = ma.prototype;
                return Ho.getLicenseServerUrl = function(Ri) {
                  switch (Ri) {
                    case ef.WIDEVINE:
                      if (!this._widevineLicenseUrl)
                        break;
                      return this._widevineLicenseUrl;
                  }
                  throw new Error('no license server URL configured for key-system "' + Ri + '"');
                }, Ho._attemptKeySystemAccess = function(Ri, qi, Yo) {
                  var ba = this, Na = Qh(Ri, qi, Yo, this._drmSystemOptions);
                  di.logger.log("Requesting encrypted media key-system access");
                  var Ma = this.requestMediaKeySystemAccess(Ri, Na);
                  this.mediaKeysPromise = Ma.then(function(bs) {
                    return ba._onMediaKeySystemAccessObtained(Ri, bs);
                  }), Ma.catch(function(bs) {
                    di.logger.error('Failed to obtain key-system "' + Ri + '" access:', bs);
                  });
                }, Ho._onMediaKeySystemAccessObtained = function(Ri, qi) {
                  var Yo = this;
                  di.logger.log('Access for key-system "' + Ri + '" obtained');
                  var ba = {
                    mediaKeysSessionInitialized: !1,
                    mediaKeySystemAccess: qi,
                    mediaKeySystemDomain: Ri
                  };
                  this._mediaKeysList.push(ba);
                  var Na = Promise.resolve().then(function() {
                    return qi.createMediaKeys();
                  }).then(function(Ma) {
                    return ba.mediaKeys = Ma, di.logger.log('Media-keys created for key-system "' + Ri + '"'), Yo._onMediaKeysCreated(), Ma;
                  });
                  return Na.catch(function(Ma) {
                    di.logger.error("Failed to create media-keys:", Ma);
                  }), Na;
                }, Ho._onMediaKeysCreated = function() {
                  var Ri = this;
                  this._mediaKeysList.forEach(function(qi) {
                    qi.mediaKeysSession || (qi.mediaKeysSession = qi.mediaKeys.createSession(), Ri._onNewMediaKeySession(qi.mediaKeysSession));
                  });
                }, Ho._onNewMediaKeySession = function(Ri) {
                  var qi = this;
                  di.logger.log("New key-system session " + Ri.sessionId), Ri.addEventListener("message", function(Yo) {
                    qi._onKeySessionMessage(Ri, Yo.message);
                  }, !1);
                }, Ho._onKeySessionMessage = function(Ri, qi) {
                  di.logger.log("Got EME message event, creating license request"), this._requestLicense(qi, function(Yo) {
                    di.logger.log("Received license data (length: " + (Yo && Yo.byteLength) + "), updating key-session"), Ri.update(Yo);
                  });
                }, Ho._attemptSetMediaKeys = function(Ri) {
                  if (!this._media)
                    throw new Error("Attempted to set mediaKeys without first attaching a media element");
                  if (!this._hasSetMediaKeys) {
                    var qi = this._mediaKeysList[0];
                    if (!qi || !qi.mediaKeys) {
                      di.logger.error("Fatal: Media is encrypted but no CDM access or no keys have been obtained yet"), this.hls.trigger(si.default.ERROR, {
                        type: li.ErrorTypes.KEY_SYSTEM_ERROR,
                        details: li.ErrorDetails.KEY_SYSTEM_NO_KEYS,
                        fatal: !0
                      });
                      return;
                    }
                    di.logger.log("Setting keys for encrypted media"), this._media.setMediaKeys(qi.mediaKeys), this._hasSetMediaKeys = !0;
                  }
                }, Ho._generateRequestWithPreferredKeySession = function(Ri, qi) {
                  var Yo = this, ba = this._mediaKeysList[0];
                  if (!ba) {
                    di.logger.error("Fatal: Media is encrypted but not any key-system access has been obtained yet"), this.hls.trigger(si.default.ERROR, {
                      type: li.ErrorTypes.KEY_SYSTEM_ERROR,
                      details: li.ErrorDetails.KEY_SYSTEM_NO_ACCESS,
                      fatal: !0
                    });
                    return;
                  }
                  if (ba.mediaKeysSessionInitialized) {
                    di.logger.warn("Key-Session already initialized but requested again");
                    return;
                  }
                  var Na = ba.mediaKeysSession;
                  if (!Na) {
                    di.logger.error("Fatal: Media is encrypted but no key-session existing"), this.hls.trigger(si.default.ERROR, {
                      type: li.ErrorTypes.KEY_SYSTEM_ERROR,
                      details: li.ErrorDetails.KEY_SYSTEM_NO_SESSION,
                      fatal: !0
                    });
                    return;
                  }
                  if (!qi) {
                    di.logger.warn("Fatal: initData required for generating a key session is null"), this.hls.trigger(si.default.ERROR, {
                      type: li.ErrorTypes.KEY_SYSTEM_ERROR,
                      details: li.ErrorDetails.KEY_SYSTEM_NO_INIT_DATA,
                      fatal: !0
                    });
                    return;
                  }
                  di.logger.log('Generating key-session request for "' + Ri + '" init data type'), ba.mediaKeysSessionInitialized = !0, Na.generateRequest(Ri, qi).then(function() {
                    di.logger.debug("Key-session generation succeeded");
                  }).catch(function(Ma) {
                    di.logger.error("Error generating key-session request:", Ma), Yo.hls.trigger(si.default.ERROR, {
                      type: li.ErrorTypes.KEY_SYSTEM_ERROR,
                      details: li.ErrorDetails.KEY_SYSTEM_NO_SESSION,
                      fatal: !1
                    });
                  });
                }, Ho._createLicenseXhr = function(Ri, qi, Yo) {
                  var ba = new XMLHttpRequest(), Na = this._licenseXhrSetup;
                  try {
                    if (Na)
                      try {
                        Na(ba, Ri);
                      } catch {
                        ba.open("POST", Ri, !0), Na(ba, Ri);
                      }
                    ba.readyState || ba.open("POST", Ri, !0);
                  } catch (Ma) {
                    throw new Error("issue setting up KeySystem license XHR " + Ma);
                  }
                  return ba.responseType = "arraybuffer", ba.onreadystatechange = this._onLicenseRequestReadyStageChange.bind(this, ba, Ri, qi, Yo), ba;
                }, Ho._onLicenseRequestReadyStageChange = function(Ri, qi, Yo, ba) {
                  switch (Ri.readyState) {
                    case 4:
                      if (Ri.status === 200)
                        this._requestLicenseFailureCount = 0, di.logger.log("License request succeeded"), Ri.responseType !== "arraybuffer" && di.logger.warn("xhr response type was not set to the expected arraybuffer for license request"), ba(Ri.response);
                      else {
                        if (di.logger.error("License Request XHR failed (" + qi + "). Status: " + Ri.status + " (" + Ri.statusText + ")"), this._requestLicenseFailureCount++, this._requestLicenseFailureCount > Cp) {
                          this.hls.trigger(si.default.ERROR, {
                            type: li.ErrorTypes.KEY_SYSTEM_ERROR,
                            details: li.ErrorDetails.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                            fatal: !0
                          });
                          return;
                        }
                        var Na = Cp - this._requestLicenseFailureCount + 1;
                        di.logger.warn("Retrying license request, " + Na + " attempts left"), this._requestLicense(Yo, ba);
                      }
                      break;
                  }
                }, Ho._generateLicenseRequestChallenge = function(Ri, qi) {
                  switch (Ri.mediaKeySystemDomain) {
                    // case KeySystems.PLAYREADY:
                    // from https://github.com/MicrosoftEdge/Demos/blob/master/eme/scripts/demo.js
                    /*
                      if (this.licenseType !== this.LICENSE_TYPE_WIDEVINE) {
                        // For PlayReady CDMs, we need to dig the Challenge out of the XML.
                        var keyMessageXml = new DOMParser().parseFromString(String.fromCharCode.apply(null, new Uint16Array(keyMessage)), 'application/xml');
                        if (keyMessageXml.getElementsByTagName('Challenge')[0]) {
                            challenge = atob(keyMessageXml.getElementsByTagName('Challenge')[0].childNodes[0].nodeValue);
                        } else {
                            throw 'Cannot find <Challenge> in key message';
                        }
                        var headerNames = keyMessageXml.getElementsByTagName('name');
                        var headerValues = keyMessageXml.getElementsByTagName('value');
                        if (headerNames.length !== headerValues.length) {
                            throw 'Mismatched header <name>/<value> pair in key message';
                        }
                        for (var i = 0; i < headerNames.length; i++) {
                            xhr.setRequestHeader(headerNames[i].childNodes[0].nodeValue, headerValues[i].childNodes[0].nodeValue);
                        }
                      }
                      break;
                    */
                    case ef.WIDEVINE:
                      return qi;
                  }
                  throw new Error("unsupported key-system: " + Ri.mediaKeySystemDomain);
                }, Ho._requestLicense = function(Ri, qi) {
                  di.logger.log("Requesting content license for key-system");
                  var Yo = this._mediaKeysList[0];
                  if (!Yo) {
                    di.logger.error("Fatal error: Media is encrypted but no key-system access has been obtained yet"), this.hls.trigger(si.default.ERROR, {
                      type: li.ErrorTypes.KEY_SYSTEM_ERROR,
                      details: li.ErrorDetails.KEY_SYSTEM_NO_ACCESS,
                      fatal: !0
                    });
                    return;
                  }
                  try {
                    var ba = this.getLicenseServerUrl(Yo.mediaKeySystemDomain), Na = this._createLicenseXhr(ba, Ri, qi);
                    di.logger.log("Sending license request to URL: " + ba);
                    var Ma = this._generateLicenseRequestChallenge(Yo, Ri);
                    Na.send(Ma);
                  } catch (bs) {
                    di.logger.error("Failure requesting DRM license: " + bs), this.hls.trigger(si.default.ERROR, {
                      type: li.ErrorTypes.KEY_SYSTEM_ERROR,
                      details: li.ErrorDetails.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                      fatal: !0
                    });
                  }
                }, Ho.onMediaAttached = function(Ri) {
                  if (this._emeEnabled) {
                    var qi = Ri.media;
                    this._media = qi, qi.addEventListener("encrypted", this._onMediaEncrypted);
                  }
                }, Ho.onMediaDetached = function() {
                  var Ri = this._media, qi = this._mediaKeysList;
                  Ri && (Ri.removeEventListener("encrypted", this._onMediaEncrypted), this._media = null, this._mediaKeysList = [], Promise.all(qi.map(function(Yo) {
                    if (Yo.mediaKeysSession)
                      return Yo.mediaKeysSession.close().catch(function() {
                      });
                  })).then(function() {
                    return Ri.setMediaKeys(null);
                  }).catch(function() {
                  }));
                }, Ho.onManifestParsed = function(Ri) {
                  if (this._emeEnabled) {
                    var qi = Ri.levels.map(function(ba) {
                      return ba.audioCodec;
                    }), Yo = Ri.levels.map(function(ba) {
                      return ba.videoCodec;
                    });
                    this._attemptKeySystemAccess(ef.WIDEVINE, qi, Yo);
                  }
                }, Jh(ma, [{
                  key: "requestMediaKeySystemAccess",
                  get: function() {
                    if (!this._requestMediaKeySystemAccess)
                      throw new Error("No requestMediaKeySystemAccess function configured");
                    return this._requestMediaKeySystemAccess;
                  }
                }]), ma;
              })(mi), ld = md;
              function wf(Sa, ma) {
                var Ho = Object.keys(Sa);
                if (Object.getOwnPropertySymbols) {
                  var Io = Object.getOwnPropertySymbols(Sa);
                  ma && (Io = Io.filter(function(Ri) {
                    return Object.getOwnPropertyDescriptor(Sa, Ri).enumerable;
                  })), Ho.push.apply(Ho, Io);
                }
                return Ho;
              }
              function zf(Sa) {
                for (var ma = 1; ma < arguments.length; ma++) {
                  var Ho = arguments[ma] != null ? arguments[ma] : {};
                  ma % 2 ? wf(Object(Ho), !0).forEach(function(Io) {
                    ip(Sa, Io, Ho[Io]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Sa, Object.getOwnPropertyDescriptors(Ho)) : wf(Object(Ho)).forEach(function(Io) {
                    Object.defineProperty(Sa, Io, Object.getOwnPropertyDescriptor(Ho, Io));
                  });
                }
                return Sa;
              }
              function ip(Sa, ma, Ho) {
                return ma in Sa ? Object.defineProperty(Sa, ma, { value: Ho, enumerable: !0, configurable: !0, writable: !0 }) : Sa[ma] = Ho, Sa;
              }
              var Sh = zf(zf({
                autoStartLoad: !0,
                // used by stream-controller
                startPosition: -1,
                // used by stream-controller
                defaultAudioCodec: void 0,
                // used by stream-controller
                debug: !1,
                // used by logger
                capLevelOnFPSDrop: !1,
                // used by fps-controller
                capLevelToPlayerSize: !1,
                // used by cap-level-controller
                initialLiveManifestSize: 1,
                // used by stream-controller
                maxBufferLength: 30,
                // used by stream-controller
                maxBufferSize: 60 * 1e3 * 1e3,
                // used by stream-controller
                maxBufferHole: 0.5,
                // used by stream-controller
                lowBufferWatchdogPeriod: 0.5,
                // used by stream-controller
                highBufferWatchdogPeriod: 3,
                // used by stream-controller
                nudgeOffset: 0.1,
                // used by stream-controller
                nudgeMaxRetry: 3,
                // used by stream-controller
                maxFragLookUpTolerance: 0.25,
                // used by stream-controller
                liveSyncDurationCount: 3,
                // used by stream-controller
                liveMaxLatencyDurationCount: 1 / 0,
                // used by stream-controller
                liveSyncDuration: void 0,
                // used by stream-controller
                liveMaxLatencyDuration: void 0,
                // used by stream-controller
                liveDurationInfinity: !1,
                // used by buffer-controller
                liveBackBufferLength: 1 / 0,
                // used by buffer-controller
                maxMaxBufferLength: 600,
                // used by stream-controller
                enableWorker: !0,
                // used by demuxer
                enableSoftwareAES: !0,
                // used by decrypter
                manifestLoadingTimeOut: 1e4,
                // used by playlist-loader
                manifestLoadingMaxRetry: 1,
                // used by playlist-loader
                manifestLoadingRetryDelay: 1e3,
                // used by playlist-loader
                manifestLoadingMaxRetryTimeout: 64e3,
                // used by playlist-loader
                startLevel: void 0,
                // used by level-controller
                levelLoadingTimeOut: 1e4,
                // used by playlist-loader
                levelLoadingMaxRetry: 4,
                // used by playlist-loader
                levelLoadingRetryDelay: 1e3,
                // used by playlist-loader
                levelLoadingMaxRetryTimeout: 64e3,
                // used by playlist-loader
                fragLoadingTimeOut: 2e4,
                // used by fragment-loader
                fragLoadingMaxRetry: 6,
                // used by fragment-loader
                fragLoadingRetryDelay: 1e3,
                // used by fragment-loader
                fragLoadingMaxRetryTimeout: 64e3,
                // used by fragment-loader
                startFragPrefetch: !1,
                // used by stream-controller
                fpsDroppedMonitoringPeriod: 5e3,
                // used by fps-controller
                fpsDroppedMonitoringThreshold: 0.2,
                // used by fps-controller
                appendErrorMaxRetry: 3,
                // used by buffer-controller
                loader: Bp,
                // loader: FetchLoader,
                fLoader: void 0,
                // used by fragment-loader
                pLoader: void 0,
                // used by playlist-loader
                xhrSetup: void 0,
                // used by xhr-loader
                licenseXhrSetup: void 0,
                // used by eme-controller
                // fetchSetup: void 0,
                abrController: Kh,
                bufferController: tp,
                capLevelController: Ud,
                fpsController: Vd,
                stretchShortVideoTrack: !1,
                // used by mp4-remuxer
                maxAudioFramesDrift: 1,
                // used by mp4-remuxer
                forceKeyFrameOnDiscontinuity: !0,
                // used by ts-demuxer
                abrEwmaFastLive: 3,
                // used by abr-controller
                abrEwmaSlowLive: 9,
                // used by abr-controller
                abrEwmaFastVoD: 3,
                // used by abr-controller
                abrEwmaSlowVoD: 9,
                // used by abr-controller
                abrEwmaDefaultEstimate: 5e5,
                // 500 kbps  // used by abr-controller
                abrBandWidthFactor: 0.95,
                // used by abr-controller
                abrBandWidthUpFactor: 0.7,
                // used by abr-controller
                abrMaxWithRealBitrate: !1,
                // used by abr-controller
                maxStarvationDelay: 4,
                // used by abr-controller
                maxLoadingDelay: 4,
                // used by abr-controller
                minAutoBitrate: 0,
                // used by hls
                emeEnabled: !1,
                // used by eme-controller
                widevineLicenseUrl: void 0,
                // used by eme-controller
                drmSystemOptions: {},
                // used by eme-controller
                requestMediaKeySystemAccessFunc: Yp,
                // used by eme-controller
                testBandwidth: !0
              }, Rp()), {}, {
                subtitleStreamController: Zd,
                subtitleTrackController: Sc,
                timelineController: bh,
                audioStreamController: Ec,
                audioTrackController: yf,
                emeController: ld
              });
              function Rp() {
                return {
                  cueHandler: ui,
                  // used by timeline-controller
                  enableCEA708Captions: !0,
                  // used by timeline-controller
                  enableWebVTT: !0,
                  // used by timeline-controller
                  captionsTextTrack1Label: "English",
                  // used by timeline-controller
                  captionsTextTrack1LanguageCode: "en",
                  // used by timeline-controller
                  captionsTextTrack2Label: "Spanish",
                  // used by timeline-controller
                  captionsTextTrack2LanguageCode: "es",
                  // used by timeline-controller
                  captionsTextTrack3Label: "Unknown CC",
                  // used by timeline-controller
                  captionsTextTrack3LanguageCode: "",
                  // used by timeline-controller
                  captionsTextTrack4Label: "Unknown CC",
                  // used by timeline-controller
                  captionsTextTrack4LanguageCode: "",
                  // used by timeline-controller
                  renderTextTracksNatively: !0
                };
              }
              function xh(Sa, ma) {
                var Ho = Object.keys(Sa);
                if (Object.getOwnPropertySymbols) {
                  var Io = Object.getOwnPropertySymbols(Sa);
                  ma && (Io = Io.filter(function(Ri) {
                    return Object.getOwnPropertyDescriptor(Sa, Ri).enumerable;
                  })), Ho.push.apply(Ho, Io);
                }
                return Ho;
              }
              function Od(Sa) {
                for (var ma = 1; ma < arguments.length; ma++) {
                  var Ho = arguments[ma] != null ? arguments[ma] : {};
                  ma % 2 ? xh(Object(Ho), !0).forEach(function(Io) {
                    Kf(Sa, Io, Ho[Io]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Sa, Object.getOwnPropertyDescriptors(Ho)) : xh(Object(Ho)).forEach(function(Io) {
                    Object.defineProperty(Sa, Io, Object.getOwnPropertyDescriptor(Ho, Io));
                  });
                }
                return Sa;
              }
              function Kf(Sa, ma, Ho) {
                return ma in Sa ? Object.defineProperty(Sa, ma, { value: Ho, enumerable: !0, configurable: !0, writable: !0 }) : Sa[ma] = Ho, Sa;
              }
              function vc(Sa) {
                if (Sa === void 0)
                  throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return Sa;
              }
              function Op(Sa, ma) {
                for (var Ho = 0; Ho < ma.length; Ho++) {
                  var Io = ma[Ho];
                  Io.enumerable = Io.enumerable || !1, Io.configurable = !0, "value" in Io && (Io.writable = !0), Object.defineProperty(Sa, Io.key, Io);
                }
              }
              function _f(Sa, ma, Ho) {
                return ma && Op(Sa.prototype, ma), Ho && Op(Sa, Ho), Sa;
              }
              function Ap(Sa, ma) {
                Sa.prototype = Object.create(ma.prototype), Sa.prototype.constructor = Sa, Sa.__proto__ = ma;
              }
              var op = /* @__PURE__ */ (function(Sa) {
                Ap(ma, Sa), ma.isSupported = function() {
                  return sc();
                }, _f(ma, null, [{
                  key: "version",
                  /**
                   * @type {string}
                   */
                  get: function() {
                    return "0.14.17";
                  }
                }, {
                  key: "Events",
                  get: function() {
                    return si.default;
                  }
                  /**
                   * @type {HlsErrorTypes}
                   */
                }, {
                  key: "ErrorTypes",
                  get: function() {
                    return li.ErrorTypes;
                  }
                  /**
                   * @type {HlsErrorDetails}
                   */
                }, {
                  key: "ErrorDetails",
                  get: function() {
                    return li.ErrorDetails;
                  }
                  /**
                   * @type {HlsConfig}
                   */
                }, {
                  key: "DefaultConfig",
                  get: function() {
                    return ma.defaultConfig ? ma.defaultConfig : Sh;
                  },
                  set: function(Ri) {
                    ma.defaultConfig = Ri;
                  }
                  /**
                   * Creates an instance of an HLS client that can attach to exactly one `HTMLMediaElement`.
                   *
                   * @constructs Hls
                   * @param {HlsConfig} config
                   */
                }]);
                function ma(Io) {
                  var Ri;
                  Io === void 0 && (Io = {}), Ri = Sa.call(this) || this, Ri.config = void 0, Ri._autoLevelCapping = void 0, Ri.abrController = void 0, Ri.capLevelController = void 0, Ri.levelController = void 0, Ri.streamController = void 0, Ri.networkControllers = void 0, Ri.audioTrackController = void 0, Ri.subtitleTrackController = void 0, Ri.emeController = void 0, Ri.coreComponents = void 0, Ri.media = null, Ri.url = null;
                  var qi = ma.DefaultConfig;
                  if ((Io.liveSyncDurationCount || Io.liveMaxLatencyDurationCount) && (Io.liveSyncDuration || Io.liveMaxLatencyDuration))
                    throw new Error("Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration");
                  Ri.config = Od(Od({}, qi), Io);
                  var Yo = vc(Ri), ba = Yo.config;
                  if (ba.liveMaxLatencyDurationCount !== void 0 && ba.liveMaxLatencyDurationCount <= ba.liveSyncDurationCount)
                    throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be gt "liveSyncDurationCount"');
                  if (ba.liveMaxLatencyDuration !== void 0 && (ba.liveSyncDuration === void 0 || ba.liveMaxLatencyDuration <= ba.liveSyncDuration))
                    throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be gt "liveSyncDuration"');
                  Object(di.enableLogs)(ba.debug), Ri._autoLevelCapping = -1;
                  var Na = Ri.abrController = new ba.abrController(vc(Ri)), Ma = new ba.bufferController(vc(Ri)), bs = Ri.capLevelController = new ba.capLevelController(vc(Ri)), Ds = new ba.fpsController(vc(Ri)), Fs = new ia(vc(Ri)), _l = new xa(vc(Ri)), Ll = new Ss(vc(Ri)), eu = new Mu(vc(Ri)), fu = Ri.levelController = new Gu(vc(Ri)), Fu = new Rs(vc(Ri)), Ou = Ri.streamController = new Tl(vc(Ri), Fu), qu = [fu, Ou], Ju = ba.audioStreamController;
                  Ju && qu.push(new Ju(vc(Ri), Fu)), Ri.networkControllers = qu;
                  var nc = [Fs, _l, Ll, Na, Ma, bs, Ds, eu, Fu];
                  if (Ju = ba.audioTrackController, Ju) {
                    var $c = new Ju(vc(Ri));
                    Ri.audioTrackController = $c, nc.push($c);
                  }
                  if (Ju = ba.subtitleTrackController, Ju) {
                    var Rc = new Ju(vc(Ri));
                    Ri.subtitleTrackController = Rc, qu.push(Rc);
                  }
                  if (Ju = ba.emeController, Ju) {
                    var xc = new Ju(vc(Ri));
                    Ri.emeController = xc, nc.push(xc);
                  }
                  return Ju = ba.subtitleStreamController, Ju && qu.push(new Ju(vc(Ri), Fu)), Ju = ba.timelineController, Ju && nc.push(new Ju(vc(Ri))), Ri.coreComponents = nc, Ri;
                }
                var Ho = ma.prototype;
                return Ho.destroy = function() {
                  di.logger.log("destroy"), this.trigger(si.default.DESTROYING), this.detachMedia(), this.coreComponents.concat(this.networkControllers).forEach(function(Ri) {
                    Ri.destroy();
                  }), this.url = null, this.removeAllListeners(), this._autoLevelCapping = -1;
                }, Ho.attachMedia = function(Ri) {
                  di.logger.log("attachMedia"), this.media = Ri, this.trigger(si.default.MEDIA_ATTACHING, {
                    media: Ri
                  });
                }, Ho.detachMedia = function() {
                  di.logger.log("detachMedia"), this.trigger(si.default.MEDIA_DETACHING), this.media = null;
                }, Ho.loadSource = function(Ri) {
                  Ri = ai.buildAbsoluteURL(window.location.href, Ri, {
                    alwaysNormalize: !0
                  }), di.logger.log("loadSource:" + Ri), this.url = Ri, this.trigger(si.default.MANIFEST_LOADING, {
                    url: Ri
                  });
                }, Ho.startLoad = function(Ri) {
                  Ri === void 0 && (Ri = -1), di.logger.log("startLoad(" + Ri + ")"), this.networkControllers.forEach(function(qi) {
                    qi.startLoad(Ri);
                  });
                }, Ho.stopLoad = function() {
                  di.logger.log("stopLoad"), this.networkControllers.forEach(function(Ri) {
                    Ri.stopLoad();
                  });
                }, Ho.swapAudioCodec = function() {
                  di.logger.log("swapAudioCodec"), this.streamController.swapAudioCodec();
                }, Ho.recoverMediaError = function() {
                  di.logger.log("recoverMediaError");
                  var Ri = this.media;
                  this.detachMedia(), Ri && this.attachMedia(Ri);
                }, Ho.removeLevel = function(Ri, qi) {
                  qi === void 0 && (qi = 0), this.levelController.removeLevel(Ri, qi);
                }, _f(ma, [{
                  key: "levels",
                  get: function() {
                    return this.levelController.levels;
                  }
                  /**
                   * Index of quality level currently played
                   * @type {number}
                   */
                }, {
                  key: "currentLevel",
                  get: function() {
                    return this.streamController.currentLevel;
                  },
                  set: function(Ri) {
                    di.logger.log("set currentLevel:" + Ri), this.loadLevel = Ri, this.streamController.immediateLevelSwitch();
                  }
                  /**
                   * Index of next quality level loaded as scheduled by stream controller.
                   * @type {number}
                   */
                }, {
                  key: "nextLevel",
                  get: function() {
                    return this.streamController.nextLevel;
                  },
                  set: function(Ri) {
                    di.logger.log("set nextLevel:" + Ri), this.levelController.manualLevel = Ri, this.streamController.nextLevelSwitch();
                  }
                  /**
                   * Return the quality level of the currently or last (of none is loaded currently) segment
                   * @type {number}
                   */
                }, {
                  key: "loadLevel",
                  get: function() {
                    return this.levelController.level;
                  },
                  set: function(Ri) {
                    di.logger.log("set loadLevel:" + Ri), this.levelController.manualLevel = Ri;
                  }
                  /**
                   * get next quality level loaded
                   * @type {number}
                   */
                }, {
                  key: "nextLoadLevel",
                  get: function() {
                    return this.levelController.nextLoadLevel;
                  },
                  set: function(Ri) {
                    this.levelController.nextLoadLevel = Ri;
                  }
                  /**
                   * Return "first level": like a default level, if not set,
                   * falls back to index of first level referenced in manifest
                   * @type {number}
                   */
                }, {
                  key: "firstLevel",
                  get: function() {
                    return Math.max(this.levelController.firstLevel, this.minAutoLevel);
                  },
                  set: function(Ri) {
                    di.logger.log("set firstLevel:" + Ri), this.levelController.firstLevel = Ri;
                  }
                  /**
                   * Return start level (level of first fragment that will be played back)
                   * if not overrided by user, first level appearing in manifest will be used as start level
                   * if -1 : automatic start level selection, playback will start from level matching download bandwidth
                   * (determined from download of first segment)
                   * @type {number}
                   */
                }, {
                  key: "startLevel",
                  get: function() {
                    return this.levelController.startLevel;
                  },
                  set: function(Ri) {
                    di.logger.log("set startLevel:" + Ri), Ri !== -1 && (Ri = Math.max(Ri, this.minAutoLevel)), this.levelController.startLevel = Ri;
                  }
                  /**
                   * set  dynamically set capLevelToPlayerSize against (`CapLevelController`)
                   *
                   * @type {boolean}
                   */
                }, {
                  key: "capLevelToPlayerSize",
                  set: function(Ri) {
                    var qi = !!Ri;
                    qi !== this.config.capLevelToPlayerSize && (qi ? this.capLevelController.startCapping() : (this.capLevelController.stopCapping(), this.autoLevelCapping = -1, this.streamController.nextLevelSwitch()), this.config.capLevelToPlayerSize = qi);
                  }
                  /**
                   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
                   * @type {number}
                   */
                }, {
                  key: "autoLevelCapping",
                  get: function() {
                    return this._autoLevelCapping;
                  },
                  /**
                   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
                   * @type {number}
                   */
                  set: function(Ri) {
                    di.logger.log("set autoLevelCapping:" + Ri), this._autoLevelCapping = Ri;
                  }
                  /**
                   * True when automatic level selection enabled
                   * @type {boolean}
                   */
                }, {
                  key: "bandwidthEstimate",
                  get: function() {
                    var Ri = this.abrController._bwEstimator;
                    return Ri ? Ri.getEstimate() : NaN;
                  }
                }, {
                  key: "autoLevelEnabled",
                  get: function() {
                    return this.levelController.manualLevel === -1;
                  }
                  /**
                   * Level set manually (if any)
                   * @type {number}
                   */
                }, {
                  key: "manualLevel",
                  get: function() {
                    return this.levelController.manualLevel;
                  }
                  /**
                   * min level selectable in auto mode according to config.minAutoBitrate
                   * @type {number}
                   */
                }, {
                  key: "minAutoLevel",
                  get: function() {
                    for (var Ri = this.levels, qi = this.config.minAutoBitrate, Yo = Ri ? Ri.length : 0, ba = 0; ba < Yo; ba++) {
                      var Na = Ri[ba].realBitrate ? Math.max(Ri[ba].realBitrate, Ri[ba].bitrate) : Ri[ba].bitrate;
                      if (Na > qi)
                        return ba;
                    }
                    return 0;
                  }
                  /**
                   * max level selectable in auto mode according to autoLevelCapping
                   * @type {number}
                   */
                }, {
                  key: "maxAutoLevel",
                  get: function() {
                    var Ri = this.levels, qi = this.autoLevelCapping, Yo;
                    return qi === -1 && Ri && Ri.length ? Yo = Ri.length - 1 : Yo = qi, Yo;
                  }
                  /**
                   * next automatically selected quality level
                   * @type {number}
                   */
                }, {
                  key: "nextAutoLevel",
                  get: function() {
                    return Math.min(Math.max(this.abrController.nextAutoLevel, this.minAutoLevel), this.maxAutoLevel);
                  },
                  set: function(Ri) {
                    this.abrController.nextAutoLevel = Math.max(this.minAutoLevel, Ri);
                  }
                  /**
                   * @type {AudioTrack[]}
                   */
                  // todo(typescript-audioTrackController)
                }, {
                  key: "audioTracks",
                  get: function() {
                    var Ri = this.audioTrackController;
                    return Ri ? Ri.audioTracks : [];
                  }
                  /**
                   * index of the selected audio track (index in audio track lists)
                   * @type {number}
                   */
                }, {
                  key: "audioTrack",
                  get: function() {
                    var Ri = this.audioTrackController;
                    return Ri ? Ri.audioTrack : -1;
                  },
                  set: function(Ri) {
                    var qi = this.audioTrackController;
                    qi && (qi.audioTrack = Ri);
                  }
                  /**
                   * @type {Seconds}
                   */
                }, {
                  key: "liveSyncPosition",
                  get: function() {
                    return this.streamController.liveSyncPosition;
                  }
                  /**
                   * get alternate subtitle tracks list from playlist
                   * @type {SubtitleTrack[]}
                   */
                  // todo(typescript-subtitleTrackController)
                }, {
                  key: "subtitleTracks",
                  get: function() {
                    var Ri = this.subtitleTrackController;
                    return Ri ? Ri.subtitleTracks : [];
                  }
                  /**
                   * index of the selected subtitle track (index in subtitle track lists)
                   * @type {number}
                   */
                }, {
                  key: "subtitleTrack",
                  get: function() {
                    var Ri = this.subtitleTrackController;
                    return Ri ? Ri.subtitleTrack : -1;
                  },
                  set: function(Ri) {
                    var qi = this.subtitleTrackController;
                    qi && (qi.subtitleTrack = Ri);
                  }
                  /**
                   * @type {boolean}
                   */
                }, {
                  key: "subtitleDisplay",
                  get: function() {
                    var Ri = this.subtitleTrackController;
                    return Ri ? Ri.subtitleDisplay : !1;
                  },
                  set: function(Ri) {
                    var qi = this.subtitleTrackController;
                    qi && (qi.subtitleDisplay = Ri);
                  }
                }]), ma;
              })(el);
              op.defaultConfig = void 0;
            })
          ),
          /***/
          "./src/polyfills/number.js": (
            /*!*********************************!*\
              !*** ./src/polyfills/number.js ***!
              \*********************************/
            /*! exports provided: isFiniteNumber, MAX_SAFE_INTEGER */
            /***/
            (function(ir, ti, ii) {
              ii.r(ti), ii.d(ti, "isFiniteNumber", function() {
                return ui;
              }), ii.d(ti, "MAX_SAFE_INTEGER", function() {
                return ai;
              });
              var ui = Number.isFinite || function(li) {
                return typeof li == "number" && isFinite(li);
              }, ai = Number.MAX_SAFE_INTEGER || 9007199254740991;
            })
          ),
          /***/
          "./src/utils/get-self-scope.js": (
            /*!*************************************!*\
              !*** ./src/utils/get-self-scope.js ***!
              \*************************************/
            /*! exports provided: getSelfScope */
            /***/
            (function(ir, ti, ii) {
              ii.r(ti), ii.d(ti, "getSelfScope", function() {
                return ui;
              });
              function ui() {
                return typeof window > "u" ? self : window;
              }
            })
          ),
          /***/
          "./src/utils/logger.js": (
            /*!*****************************!*\
              !*** ./src/utils/logger.js ***!
              \*****************************/
            /*! exports provided: enableLogs, logger */
            /***/
            (function(ir, ti, ii) {
              ii.r(ti), ii.d(ti, "enableLogs", function() {
                return mi;
              }), ii.d(ti, "logger", function() {
                return Ti;
              });
              var ui = ii(
                /*! ./get-self-scope */
                "./src/utils/get-self-scope.js"
              );
              function ai() {
              }
              var li = {
                trace: ai,
                debug: ai,
                log: ai,
                warn: ai,
                info: ai,
                error: ai
              }, oi = li;
              function si(vi, xi) {
                return xi = "[" + vi + "] > " + xi, xi;
              }
              var di = Object(ui.getSelfScope)();
              function fi(vi) {
                var xi = di.console[vi];
                return xi ? function() {
                  for (var Si = arguments.length, Pi = new Array(Si), $i = 0; $i < Si; $i++)
                    Pi[$i] = arguments[$i];
                  Pi[0] && (Pi[0] = si(vi, Pi[0])), xi.apply(di.console, Pi);
                } : ai;
              }
              function gi(vi) {
                for (var xi = arguments.length, Si = new Array(xi > 1 ? xi - 1 : 0), Pi = 1; Pi < xi; Pi++)
                  Si[Pi - 1] = arguments[Pi];
                Si.forEach(function($i) {
                  oi[$i] = vi[$i] ? vi[$i].bind(vi) : fi($i);
                });
              }
              var mi = function(xi) {
                if (di.console && xi === !0 || typeof xi == "object") {
                  gi(
                    xi,
                    // Remove out from list here to hard-disable a log-level
                    // 'trace',
                    "debug",
                    "log",
                    "info",
                    "warn",
                    "error"
                  );
                  try {
                    oi.log();
                  } catch {
                    oi = li;
                  }
                } else
                  oi = li;
              }, Ti = oi;
            })
          )
          /******/
        }).default
      );
    });
  })(hls$1)), hls$1.exports;
}
requireHls();
var __assign$1 = function() {
  return __assign$1 = Object.assign || function(pt) {
    for (var yt, ir = 1, ti = arguments.length; ir < ti; ir++) {
      yt = arguments[ir];
      for (var ii in yt) Object.prototype.hasOwnProperty.call(yt, ii) && (pt[ii] = yt[ii]);
    }
    return pt;
  }, __assign$1.apply(this, arguments);
}, ll = Object.defineProperty, cl = (pt, yt, ir) => yt in pt ? ll(pt, yt, { enumerable: !0, configurable: !0, writable: !0, value: ir }) : pt[yt] = ir, Ga = (pt, yt, ir) => cl(pt, typeof yt != "symbol" ? yt + "" : yt, ir);
function getDefaultExportFromCjs(pt) {
  return pt && pt.__esModule && Object.prototype.hasOwnProperty.call(pt, "default") ? pt.default : pt;
}
var jsxRuntime = { exports: {} }, reactJsxRuntime_production = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production;
function requireReactJsxRuntime_production() {
  if (hasRequiredReactJsxRuntime_production) return reactJsxRuntime_production;
  hasRequiredReactJsxRuntime_production = 1;
  var pt = Symbol.for("react.transitional.element"), yt = Symbol.for("react.fragment");
  function ir(ti, ii, ui) {
    var ai = null;
    if (ui !== void 0 && (ai = "" + ui), ii.key !== void 0 && (ai = "" + ii.key), "key" in ii) {
      ui = {};
      for (var li in ii)
        li !== "key" && (ui[li] = ii[li]);
    } else ui = ii;
    return ii = ui.ref, {
      $$typeof: pt,
      type: ti,
      key: ai,
      ref: ii !== void 0 ? ii : null,
      props: ui
    };
  }
  return reactJsxRuntime_production.Fragment = yt, reactJsxRuntime_production.jsx = ir, reactJsxRuntime_production.jsxs = ir, reactJsxRuntime_production;
}
var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  return hasRequiredReactJsxRuntime_development || (hasRequiredReactJsxRuntime_development = 1, process.env.NODE_ENV !== "production" && (function() {
    function pt(ji) {
      if (ji == null) return null;
      if (typeof ji == "function")
        return ji.$$typeof === _o ? null : ji.displayName || ji.name || null;
      if (typeof ji == "string") return ji;
      switch (ji) {
        case xi:
          return "Fragment";
        case Pi:
          return "Profiler";
        case Si:
          return "StrictMode";
        case Mi:
          return "Suspense";
        case Oo:
          return "SuspenseList";
        case fo:
          return "Activity";
      }
      if (typeof ji == "object")
        switch (typeof ji.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), ji.$$typeof) {
          case vi:
            return "Portal";
          case Oi:
            return ji.displayName || "Context";
          case $i:
            return (ji._context.displayName || "Context") + ".Consumer";
          case Di:
            var Hi = ji.render;
            return ji = ji.displayName, ji || (ji = Hi.displayName || Hi.name || "", ji = ji !== "" ? "ForwardRef(" + ji + ")" : "ForwardRef"), ji;
          case io:
            return Hi = ji.displayName || null, Hi !== null ? Hi : pt(ji.type) || "Memo";
          case xo:
            Hi = ji._payload, ji = ji._init;
            try {
              return pt(ji(Hi));
            } catch {
            }
        }
      return null;
    }
    function yt(ji) {
      return "" + ji;
    }
    function ir(ji) {
      try {
        yt(ji);
        var Hi = !1;
      } catch {
        Hi = !0;
      }
      if (Hi) {
        Hi = console;
        var zo = Hi.error, Lo = typeof Symbol == "function" && Symbol.toStringTag && ji[Symbol.toStringTag] || ji.constructor.name || "Object";
        return zo.call(
          Hi,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          Lo
        ), yt(ji);
      }
    }
    function ti(ji) {
      if (ji === xi) return "<>";
      if (typeof ji == "object" && ji !== null && ji.$$typeof === xo)
        return "<...>";
      try {
        var Hi = pt(ji);
        return Hi ? "<" + Hi + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function ii() {
      var ji = Li.A;
      return ji === null ? null : ji.getOwner();
    }
    function ui() {
      return Error("react-stack-top-frame");
    }
    function ai(ji) {
      if (Co.call(ji, "key")) {
        var Hi = Object.getOwnPropertyDescriptor(ji, "key").get;
        if (Hi && Hi.isReactWarning) return !1;
      }
      return ji.key !== void 0;
    }
    function li(ji, Hi) {
      function zo() {
        Vo || (Vo = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          Hi
        ));
      }
      zo.isReactWarning = !0, Object.defineProperty(ji, "key", {
        get: zo,
        configurable: !0
      });
    }
    function oi() {
      var ji = pt(this.type);
      return No[ji] || (No[ji] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), ji = this.props.ref, ji !== void 0 ? ji : null;
    }
    function si(ji, Hi, zo, Lo, sa, Ko) {
      var ca = zo.ref;
      return ji = {
        $$typeof: Ti,
        type: ji,
        key: Hi,
        props: zo,
        _owner: Lo
      }, (ca !== void 0 ? ca : null) !== null ? Object.defineProperty(ji, "ref", {
        enumerable: !1,
        get: oi
      }) : Object.defineProperty(ji, "ref", { enumerable: !1, value: null }), ji._store = {}, Object.defineProperty(ji._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(ji, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(ji, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: sa
      }), Object.defineProperty(ji, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: Ko
      }), Object.freeze && (Object.freeze(ji.props), Object.freeze(ji)), ji;
    }
    function di(ji, Hi, zo, Lo, sa, Ko) {
      var ca = Hi.children;
      if (ca !== void 0)
        if (Lo)
          if (Ni(ca)) {
            for (Lo = 0; Lo < ca.length; Lo++)
              fi(ca[Lo]);
            Object.freeze && Object.freeze(ca);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else fi(ca);
      if (Co.call(Hi, "key")) {
        ca = pt(ji);
        var pa = Object.keys(Hi).filter(function(ia) {
          return ia !== "key";
        });
        Lo = 0 < pa.length ? "{key: someKey, " + pa.join(": ..., ") + ": ...}" : "{key: someKey}", Wi[ca + Lo] || (pa = 0 < pa.length ? "{" + pa.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          Lo,
          ca,
          pa,
          ca
        ), Wi[ca + Lo] = !0);
      }
      if (ca = null, zo !== void 0 && (ir(zo), ca = "" + zo), ai(Hi) && (ir(Hi.key), ca = "" + Hi.key), "key" in Hi) {
        zo = {};
        for (var ga in Hi)
          ga !== "key" && (zo[ga] = Hi[ga]);
      } else zo = Hi;
      return ca && li(
        zo,
        typeof ji == "function" ? ji.displayName || ji.name || "Unknown" : ji
      ), si(
        ji,
        ca,
        zo,
        ii(),
        sa,
        Ko
      );
    }
    function fi(ji) {
      gi(ji) ? ji._store && (ji._store.validated = 1) : typeof ji == "object" && ji !== null && ji.$$typeof === xo && (ji._payload.status === "fulfilled" ? gi(ji._payload.value) && ji._payload.value._store && (ji._payload.value._store.validated = 1) : ji._store && (ji._store.validated = 1));
    }
    function gi(ji) {
      return typeof ji == "object" && ji !== null && ji.$$typeof === Ti;
    }
    var mi = React__default, Ti = Symbol.for("react.transitional.element"), vi = Symbol.for("react.portal"), xi = Symbol.for("react.fragment"), Si = Symbol.for("react.strict_mode"), Pi = Symbol.for("react.profiler"), $i = Symbol.for("react.consumer"), Oi = Symbol.for("react.context"), Di = Symbol.for("react.forward_ref"), Mi = Symbol.for("react.suspense"), Oo = Symbol.for("react.suspense_list"), io = Symbol.for("react.memo"), xo = Symbol.for("react.lazy"), fo = Symbol.for("react.activity"), _o = Symbol.for("react.client.reference"), Li = mi.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, Co = Object.prototype.hasOwnProperty, Ni = Array.isArray, Yi = console.createTask ? console.createTask : function() {
      return null;
    };
    mi = {
      react_stack_bottom_frame: function(ji) {
        return ji();
      }
    };
    var Vo, No = {}, Ui = mi.react_stack_bottom_frame.bind(
      mi,
      ui
    )(), jo = Yi(ti(ui)), Wi = {};
    reactJsxRuntime_development.Fragment = xi, reactJsxRuntime_development.jsx = function(ji, Hi, zo) {
      var Lo = 1e4 > Li.recentlyCreatedOwnerStacks++;
      return di(
        ji,
        Hi,
        zo,
        !1,
        Lo ? Error("react-stack-top-frame") : Ui,
        Lo ? Yi(ti(ji)) : jo
      );
    }, reactJsxRuntime_development.jsxs = function(ji, Hi, zo) {
      var Lo = 1e4 > Li.recentlyCreatedOwnerStacks++;
      return di(
        ji,
        Hi,
        zo,
        !0,
        Lo ? Error("react-stack-top-frame") : Ui,
        Lo ? Yi(ti(ji)) : jo
      );
    };
  })()), reactJsxRuntime_development;
}
var hasRequiredJsxRuntime;
function requireJsxRuntime() {
  return hasRequiredJsxRuntime || (hasRequiredJsxRuntime = 1, process.env.NODE_ENV === "production" ? jsxRuntime.exports = requireReactJsxRuntime_production() : jsxRuntime.exports = requireReactJsxRuntime_development()), jsxRuntime.exports;
}
var jsxRuntimeExports = requireJsxRuntime(), propTypes = { exports: {} }, reactIs$2 = { exports: {} }, reactIs_production_min$1 = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min$1;
function requireReactIs_production_min$1() {
  if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
  hasRequiredReactIs_production_min$1 = 1;
  var pt = typeof Symbol == "function" && Symbol.for, yt = pt ? Symbol.for("react.element") : 60103, ir = pt ? Symbol.for("react.portal") : 60106, ti = pt ? Symbol.for("react.fragment") : 60107, ii = pt ? Symbol.for("react.strict_mode") : 60108, ui = pt ? Symbol.for("react.profiler") : 60114, ai = pt ? Symbol.for("react.provider") : 60109, li = pt ? Symbol.for("react.context") : 60110, oi = pt ? Symbol.for("react.async_mode") : 60111, si = pt ? Symbol.for("react.concurrent_mode") : 60111, di = pt ? Symbol.for("react.forward_ref") : 60112, fi = pt ? Symbol.for("react.suspense") : 60113, gi = pt ? Symbol.for("react.suspense_list") : 60120, mi = pt ? Symbol.for("react.memo") : 60115, Ti = pt ? Symbol.for("react.lazy") : 60116, vi = pt ? Symbol.for("react.block") : 60121, xi = pt ? Symbol.for("react.fundamental") : 60117, Si = pt ? Symbol.for("react.responder") : 60118, Pi = pt ? Symbol.for("react.scope") : 60119;
  function $i(Di) {
    if (typeof Di == "object" && Di !== null) {
      var Mi = Di.$$typeof;
      switch (Mi) {
        case yt:
          switch (Di = Di.type, Di) {
            case oi:
            case si:
            case ti:
            case ui:
            case ii:
            case fi:
              return Di;
            default:
              switch (Di = Di && Di.$$typeof, Di) {
                case li:
                case di:
                case Ti:
                case mi:
                case ai:
                  return Di;
                default:
                  return Mi;
              }
          }
        case ir:
          return Mi;
      }
    }
  }
  function Oi(Di) {
    return $i(Di) === si;
  }
  return reactIs_production_min$1.AsyncMode = oi, reactIs_production_min$1.ConcurrentMode = si, reactIs_production_min$1.ContextConsumer = li, reactIs_production_min$1.ContextProvider = ai, reactIs_production_min$1.Element = yt, reactIs_production_min$1.ForwardRef = di, reactIs_production_min$1.Fragment = ti, reactIs_production_min$1.Lazy = Ti, reactIs_production_min$1.Memo = mi, reactIs_production_min$1.Portal = ir, reactIs_production_min$1.Profiler = ui, reactIs_production_min$1.StrictMode = ii, reactIs_production_min$1.Suspense = fi, reactIs_production_min$1.isAsyncMode = function(Di) {
    return Oi(Di) || $i(Di) === oi;
  }, reactIs_production_min$1.isConcurrentMode = Oi, reactIs_production_min$1.isContextConsumer = function(Di) {
    return $i(Di) === li;
  }, reactIs_production_min$1.isContextProvider = function(Di) {
    return $i(Di) === ai;
  }, reactIs_production_min$1.isElement = function(Di) {
    return typeof Di == "object" && Di !== null && Di.$$typeof === yt;
  }, reactIs_production_min$1.isForwardRef = function(Di) {
    return $i(Di) === di;
  }, reactIs_production_min$1.isFragment = function(Di) {
    return $i(Di) === ti;
  }, reactIs_production_min$1.isLazy = function(Di) {
    return $i(Di) === Ti;
  }, reactIs_production_min$1.isMemo = function(Di) {
    return $i(Di) === mi;
  }, reactIs_production_min$1.isPortal = function(Di) {
    return $i(Di) === ir;
  }, reactIs_production_min$1.isProfiler = function(Di) {
    return $i(Di) === ui;
  }, reactIs_production_min$1.isStrictMode = function(Di) {
    return $i(Di) === ii;
  }, reactIs_production_min$1.isSuspense = function(Di) {
    return $i(Di) === fi;
  }, reactIs_production_min$1.isValidElementType = function(Di) {
    return typeof Di == "string" || typeof Di == "function" || Di === ti || Di === si || Di === ui || Di === ii || Di === fi || Di === gi || typeof Di == "object" && Di !== null && (Di.$$typeof === Ti || Di.$$typeof === mi || Di.$$typeof === ai || Di.$$typeof === li || Di.$$typeof === di || Di.$$typeof === xi || Di.$$typeof === Si || Di.$$typeof === Pi || Di.$$typeof === vi);
  }, reactIs_production_min$1.typeOf = $i, reactIs_production_min$1;
}
var reactIs_development$2 = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development$2;
function requireReactIs_development$2() {
  return hasRequiredReactIs_development$2 || (hasRequiredReactIs_development$2 = 1, process.env.NODE_ENV !== "production" && (function() {
    var pt = typeof Symbol == "function" && Symbol.for, yt = pt ? Symbol.for("react.element") : 60103, ir = pt ? Symbol.for("react.portal") : 60106, ti = pt ? Symbol.for("react.fragment") : 60107, ii = pt ? Symbol.for("react.strict_mode") : 60108, ui = pt ? Symbol.for("react.profiler") : 60114, ai = pt ? Symbol.for("react.provider") : 60109, li = pt ? Symbol.for("react.context") : 60110, oi = pt ? Symbol.for("react.async_mode") : 60111, si = pt ? Symbol.for("react.concurrent_mode") : 60111, di = pt ? Symbol.for("react.forward_ref") : 60112, fi = pt ? Symbol.for("react.suspense") : 60113, gi = pt ? Symbol.for("react.suspense_list") : 60120, mi = pt ? Symbol.for("react.memo") : 60115, Ti = pt ? Symbol.for("react.lazy") : 60116, vi = pt ? Symbol.for("react.block") : 60121, xi = pt ? Symbol.for("react.fundamental") : 60117, Si = pt ? Symbol.for("react.responder") : 60118, Pi = pt ? Symbol.for("react.scope") : 60119;
    function $i(qo) {
      return typeof qo == "string" || typeof qo == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      qo === ti || qo === si || qo === ui || qo === ii || qo === fi || qo === gi || typeof qo == "object" && qo !== null && (qo.$$typeof === Ti || qo.$$typeof === mi || qo.$$typeof === ai || qo.$$typeof === li || qo.$$typeof === di || qo.$$typeof === xi || qo.$$typeof === Si || qo.$$typeof === Pi || qo.$$typeof === vi);
    }
    function Oi(qo) {
      if (typeof qo == "object" && qo !== null) {
        var xa = qo.$$typeof;
        switch (xa) {
          case yt:
            var $a = qo.type;
            switch ($a) {
              case oi:
              case si:
              case ti:
              case ui:
              case ii:
              case fi:
                return $a;
              default:
                var ys = $a && $a.$$typeof;
                switch (ys) {
                  case li:
                  case di:
                  case Ti:
                  case mi:
                  case ai:
                    return ys;
                  default:
                    return xa;
                }
            }
          case ir:
            return xa;
        }
      }
    }
    var Di = oi, Mi = si, Oo = li, io = ai, xo = yt, fo = di, _o = ti, Li = Ti, Co = mi, Ni = ir, Yi = ui, Vo = ii, No = fi, Ui = !1;
    function jo(qo) {
      return Ui || (Ui = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), Wi(qo) || Oi(qo) === oi;
    }
    function Wi(qo) {
      return Oi(qo) === si;
    }
    function ji(qo) {
      return Oi(qo) === li;
    }
    function Hi(qo) {
      return Oi(qo) === ai;
    }
    function zo(qo) {
      return typeof qo == "object" && qo !== null && qo.$$typeof === yt;
    }
    function Lo(qo) {
      return Oi(qo) === di;
    }
    function sa(qo) {
      return Oi(qo) === ti;
    }
    function Ko(qo) {
      return Oi(qo) === Ti;
    }
    function ca(qo) {
      return Oi(qo) === mi;
    }
    function pa(qo) {
      return Oi(qo) === ir;
    }
    function ga(qo) {
      return Oi(qo) === ui;
    }
    function ia(qo) {
      return Oi(qo) === ii;
    }
    function ra(qo) {
      return Oi(qo) === fi;
    }
    reactIs_development$2.AsyncMode = Di, reactIs_development$2.ConcurrentMode = Mi, reactIs_development$2.ContextConsumer = Oo, reactIs_development$2.ContextProvider = io, reactIs_development$2.Element = xo, reactIs_development$2.ForwardRef = fo, reactIs_development$2.Fragment = _o, reactIs_development$2.Lazy = Li, reactIs_development$2.Memo = Co, reactIs_development$2.Portal = Ni, reactIs_development$2.Profiler = Yi, reactIs_development$2.StrictMode = Vo, reactIs_development$2.Suspense = No, reactIs_development$2.isAsyncMode = jo, reactIs_development$2.isConcurrentMode = Wi, reactIs_development$2.isContextConsumer = ji, reactIs_development$2.isContextProvider = Hi, reactIs_development$2.isElement = zo, reactIs_development$2.isForwardRef = Lo, reactIs_development$2.isFragment = sa, reactIs_development$2.isLazy = Ko, reactIs_development$2.isMemo = ca, reactIs_development$2.isPortal = pa, reactIs_development$2.isProfiler = ga, reactIs_development$2.isStrictMode = ia, reactIs_development$2.isSuspense = ra, reactIs_development$2.isValidElementType = $i, reactIs_development$2.typeOf = Oi;
  })()), reactIs_development$2;
}
var hasRequiredReactIs$2;
function requireReactIs$2() {
  return hasRequiredReactIs$2 || (hasRequiredReactIs$2 = 1, process.env.NODE_ENV === "production" ? reactIs$2.exports = requireReactIs_production_min$1() : reactIs$2.exports = requireReactIs_development$2()), reactIs$2.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign, hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var pt = Object.getOwnPropertySymbols, yt = Object.prototype.hasOwnProperty, ir = Object.prototype.propertyIsEnumerable;
  function ti(ui) {
    if (ui == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(ui);
  }
  function ii() {
    try {
      if (!Object.assign)
        return !1;
      var ui = new String("abc");
      if (ui[5] = "de", Object.getOwnPropertyNames(ui)[0] === "5")
        return !1;
      for (var ai = {}, li = 0; li < 10; li++)
        ai["_" + String.fromCharCode(li)] = li;
      var oi = Object.getOwnPropertyNames(ai).map(function(di) {
        return ai[di];
      });
      if (oi.join("") !== "0123456789")
        return !1;
      var si = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(di) {
        si[di] = di;
      }), Object.keys(Object.assign({}, si)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return objectAssign = ii() ? Object.assign : function(ui, ai) {
    for (var li, oi = ti(ui), si, di = 1; di < arguments.length; di++) {
      li = Object(arguments[di]);
      for (var fi in li)
        yt.call(li, fi) && (oi[fi] = li[fi]);
      if (pt) {
        si = pt(li);
        for (var gi = 0; gi < si.length; gi++)
          ir.call(li, si[gi]) && (oi[si[gi]] = li[si[gi]]);
      }
    }
    return oi;
  }, objectAssign;
}
var ReactPropTypesSecret_1, hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var pt = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ReactPropTypesSecret_1 = pt, ReactPropTypesSecret_1;
}
var has$3, hasRequiredHas$1;
function requireHas$1() {
  return hasRequiredHas$1 || (hasRequiredHas$1 = 1, has$3 = Function.call.bind(Object.prototype.hasOwnProperty)), has$3;
}
var checkPropTypes_1, hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var pt = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var yt = /* @__PURE__ */ requireReactPropTypesSecret(), ir = {}, ti = /* @__PURE__ */ requireHas$1();
    pt = function(ui) {
      var ai = "Warning: " + ui;
      typeof console < "u" && console.error(ai);
      try {
        throw new Error(ai);
      } catch {
      }
    };
  }
  function ii(ui, ai, li, oi, si) {
    if (process.env.NODE_ENV !== "production") {
      for (var di in ui)
        if (ti(ui, di)) {
          var fi;
          try {
            if (typeof ui[di] != "function") {
              var gi = Error(
                (oi || "React class") + ": " + li + " type `" + di + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof ui[di] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw gi.name = "Invariant Violation", gi;
            }
            fi = ui[di](ai, di, oi, li, null, yt);
          } catch (Ti) {
            fi = Ti;
          }
          if (fi && !(fi instanceof Error) && pt(
            (oi || "React class") + ": type specification of " + li + " `" + di + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof fi + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), fi instanceof Error && !(fi.message in ir)) {
            ir[fi.message] = !0;
            var mi = si ? si() : "";
            pt(
              "Failed " + li + " type: " + fi.message + (mi ?? "")
            );
          }
        }
    }
  }
  return ii.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (ir = {});
  }, checkPropTypes_1 = ii, checkPropTypes_1;
}
var factoryWithTypeCheckers, hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var pt = requireReactIs$2(), yt = requireObjectAssign(), ir = /* @__PURE__ */ requireReactPropTypesSecret(), ti = /* @__PURE__ */ requireHas$1(), ii = /* @__PURE__ */ requireCheckPropTypes(), ui = function() {
  };
  process.env.NODE_ENV !== "production" && (ui = function(li) {
    var oi = "Warning: " + li;
    typeof console < "u" && console.error(oi);
    try {
      throw new Error(oi);
    } catch {
    }
  });
  function ai() {
    return null;
  }
  return factoryWithTypeCheckers = function(li, oi) {
    var si = typeof Symbol == "function" && Symbol.iterator, di = "@@iterator";
    function fi(Wi) {
      var ji = Wi && (si && Wi[si] || Wi[di]);
      if (typeof ji == "function")
        return ji;
    }
    var gi = "<<anonymous>>", mi = {
      array: Si("array"),
      bigint: Si("bigint"),
      bool: Si("boolean"),
      func: Si("function"),
      number: Si("number"),
      object: Si("object"),
      string: Si("string"),
      symbol: Si("symbol"),
      any: Pi(),
      arrayOf: $i,
      element: Oi(),
      elementType: Di(),
      instanceOf: Mi,
      node: fo(),
      objectOf: io,
      oneOf: Oo,
      oneOfType: xo,
      shape: Li,
      exact: Co
    };
    function Ti(Wi, ji) {
      return Wi === ji ? Wi !== 0 || 1 / Wi === 1 / ji : Wi !== Wi && ji !== ji;
    }
    function vi(Wi, ji) {
      this.message = Wi, this.data = ji && typeof ji == "object" ? ji : {}, this.stack = "";
    }
    vi.prototype = Error.prototype;
    function xi(Wi) {
      if (process.env.NODE_ENV !== "production")
        var ji = {}, Hi = 0;
      function zo(sa, Ko, ca, pa, ga, ia, ra) {
        if (pa = pa || gi, ia = ia || ca, ra !== ir) {
          if (oi) {
            var qo = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw qo.name = "Invariant Violation", qo;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var xa = pa + ":" + ca;
            !ji[xa] && // Avoid spamming the console because they are often not actionable except for lib authors
            Hi < 3 && (ui(
              "You are manually calling a React.PropTypes validation function for the `" + ia + "` prop on `" + pa + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), ji[xa] = !0, Hi++);
          }
        }
        return Ko[ca] == null ? sa ? Ko[ca] === null ? new vi("The " + ga + " `" + ia + "` is marked as required " + ("in `" + pa + "`, but its value is `null`.")) : new vi("The " + ga + " `" + ia + "` is marked as required in " + ("`" + pa + "`, but its value is `undefined`.")) : null : Wi(Ko, ca, pa, ga, ia);
      }
      var Lo = zo.bind(null, !1);
      return Lo.isRequired = zo.bind(null, !0), Lo;
    }
    function Si(Wi) {
      function ji(Hi, zo, Lo, sa, Ko, ca) {
        var pa = Hi[zo], ga = Vo(pa);
        if (ga !== Wi) {
          var ia = No(pa);
          return new vi(
            "Invalid " + sa + " `" + Ko + "` of type " + ("`" + ia + "` supplied to `" + Lo + "`, expected ") + ("`" + Wi + "`."),
            { expectedType: Wi }
          );
        }
        return null;
      }
      return xi(ji);
    }
    function Pi() {
      return xi(ai);
    }
    function $i(Wi) {
      function ji(Hi, zo, Lo, sa, Ko) {
        if (typeof Wi != "function")
          return new vi("Property `" + Ko + "` of component `" + Lo + "` has invalid PropType notation inside arrayOf.");
        var ca = Hi[zo];
        if (!Array.isArray(ca)) {
          var pa = Vo(ca);
          return new vi("Invalid " + sa + " `" + Ko + "` of type " + ("`" + pa + "` supplied to `" + Lo + "`, expected an array."));
        }
        for (var ga = 0; ga < ca.length; ga++) {
          var ia = Wi(ca, ga, Lo, sa, Ko + "[" + ga + "]", ir);
          if (ia instanceof Error)
            return ia;
        }
        return null;
      }
      return xi(ji);
    }
    function Oi() {
      function Wi(ji, Hi, zo, Lo, sa) {
        var Ko = ji[Hi];
        if (!li(Ko)) {
          var ca = Vo(Ko);
          return new vi("Invalid " + Lo + " `" + sa + "` of type " + ("`" + ca + "` supplied to `" + zo + "`, expected a single ReactElement."));
        }
        return null;
      }
      return xi(Wi);
    }
    function Di() {
      function Wi(ji, Hi, zo, Lo, sa) {
        var Ko = ji[Hi];
        if (!pt.isValidElementType(Ko)) {
          var ca = Vo(Ko);
          return new vi("Invalid " + Lo + " `" + sa + "` of type " + ("`" + ca + "` supplied to `" + zo + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return xi(Wi);
    }
    function Mi(Wi) {
      function ji(Hi, zo, Lo, sa, Ko) {
        if (!(Hi[zo] instanceof Wi)) {
          var ca = Wi.name || gi, pa = jo(Hi[zo]);
          return new vi("Invalid " + sa + " `" + Ko + "` of type " + ("`" + pa + "` supplied to `" + Lo + "`, expected ") + ("instance of `" + ca + "`."));
        }
        return null;
      }
      return xi(ji);
    }
    function Oo(Wi) {
      if (!Array.isArray(Wi))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? ui(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : ui("Invalid argument supplied to oneOf, expected an array.")), ai;
      function ji(Hi, zo, Lo, sa, Ko) {
        for (var ca = Hi[zo], pa = 0; pa < Wi.length; pa++)
          if (Ti(ca, Wi[pa]))
            return null;
        var ga = JSON.stringify(Wi, function(ia, ra) {
          var qo = No(ra);
          return qo === "symbol" ? String(ra) : ra;
        });
        return new vi("Invalid " + sa + " `" + Ko + "` of value `" + String(ca) + "` " + ("supplied to `" + Lo + "`, expected one of " + ga + "."));
      }
      return xi(ji);
    }
    function io(Wi) {
      function ji(Hi, zo, Lo, sa, Ko) {
        if (typeof Wi != "function")
          return new vi("Property `" + Ko + "` of component `" + Lo + "` has invalid PropType notation inside objectOf.");
        var ca = Hi[zo], pa = Vo(ca);
        if (pa !== "object")
          return new vi("Invalid " + sa + " `" + Ko + "` of type " + ("`" + pa + "` supplied to `" + Lo + "`, expected an object."));
        for (var ga in ca)
          if (ti(ca, ga)) {
            var ia = Wi(ca, ga, Lo, sa, Ko + "." + ga, ir);
            if (ia instanceof Error)
              return ia;
          }
        return null;
      }
      return xi(ji);
    }
    function xo(Wi) {
      if (!Array.isArray(Wi))
        return process.env.NODE_ENV !== "production" && ui("Invalid argument supplied to oneOfType, expected an instance of array."), ai;
      for (var ji = 0; ji < Wi.length; ji++) {
        var Hi = Wi[ji];
        if (typeof Hi != "function")
          return ui(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Ui(Hi) + " at index " + ji + "."
          ), ai;
      }
      function zo(Lo, sa, Ko, ca, pa) {
        for (var ga = [], ia = 0; ia < Wi.length; ia++) {
          var ra = Wi[ia], qo = ra(Lo, sa, Ko, ca, pa, ir);
          if (qo == null)
            return null;
          qo.data && ti(qo.data, "expectedType") && ga.push(qo.data.expectedType);
        }
        var xa = ga.length > 0 ? ", expected one of type [" + ga.join(", ") + "]" : "";
        return new vi("Invalid " + ca + " `" + pa + "` supplied to " + ("`" + Ko + "`" + xa + "."));
      }
      return xi(zo);
    }
    function fo() {
      function Wi(ji, Hi, zo, Lo, sa) {
        return Ni(ji[Hi]) ? null : new vi("Invalid " + Lo + " `" + sa + "` supplied to " + ("`" + zo + "`, expected a ReactNode."));
      }
      return xi(Wi);
    }
    function _o(Wi, ji, Hi, zo, Lo) {
      return new vi(
        (Wi || "React class") + ": " + ji + " type `" + Hi + "." + zo + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + Lo + "`."
      );
    }
    function Li(Wi) {
      function ji(Hi, zo, Lo, sa, Ko) {
        var ca = Hi[zo], pa = Vo(ca);
        if (pa !== "object")
          return new vi("Invalid " + sa + " `" + Ko + "` of type `" + pa + "` " + ("supplied to `" + Lo + "`, expected `object`."));
        for (var ga in Wi) {
          var ia = Wi[ga];
          if (typeof ia != "function")
            return _o(Lo, sa, Ko, ga, No(ia));
          var ra = ia(ca, ga, Lo, sa, Ko + "." + ga, ir);
          if (ra)
            return ra;
        }
        return null;
      }
      return xi(ji);
    }
    function Co(Wi) {
      function ji(Hi, zo, Lo, sa, Ko) {
        var ca = Hi[zo], pa = Vo(ca);
        if (pa !== "object")
          return new vi("Invalid " + sa + " `" + Ko + "` of type `" + pa + "` " + ("supplied to `" + Lo + "`, expected `object`."));
        var ga = yt({}, Hi[zo], Wi);
        for (var ia in ga) {
          var ra = Wi[ia];
          if (ti(Wi, ia) && typeof ra != "function")
            return _o(Lo, sa, Ko, ia, No(ra));
          if (!ra)
            return new vi(
              "Invalid " + sa + " `" + Ko + "` key `" + ia + "` supplied to `" + Lo + "`.\nBad object: " + JSON.stringify(Hi[zo], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(Wi), null, "  ")
            );
          var qo = ra(ca, ia, Lo, sa, Ko + "." + ia, ir);
          if (qo)
            return qo;
        }
        return null;
      }
      return xi(ji);
    }
    function Ni(Wi) {
      switch (typeof Wi) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !Wi;
        case "object":
          if (Array.isArray(Wi))
            return Wi.every(Ni);
          if (Wi === null || li(Wi))
            return !0;
          var ji = fi(Wi);
          if (ji) {
            var Hi = ji.call(Wi), zo;
            if (ji !== Wi.entries) {
              for (; !(zo = Hi.next()).done; )
                if (!Ni(zo.value))
                  return !1;
            } else
              for (; !(zo = Hi.next()).done; ) {
                var Lo = zo.value;
                if (Lo && !Ni(Lo[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Yi(Wi, ji) {
      return Wi === "symbol" ? !0 : ji ? ji["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && ji instanceof Symbol : !1;
    }
    function Vo(Wi) {
      var ji = typeof Wi;
      return Array.isArray(Wi) ? "array" : Wi instanceof RegExp ? "object" : Yi(ji, Wi) ? "symbol" : ji;
    }
    function No(Wi) {
      if (typeof Wi > "u" || Wi === null)
        return "" + Wi;
      var ji = Vo(Wi);
      if (ji === "object") {
        if (Wi instanceof Date)
          return "date";
        if (Wi instanceof RegExp)
          return "regexp";
      }
      return ji;
    }
    function Ui(Wi) {
      var ji = No(Wi);
      switch (ji) {
        case "array":
        case "object":
          return "an " + ji;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + ji;
        default:
          return ji;
      }
    }
    function jo(Wi) {
      return !Wi.constructor || !Wi.constructor.name ? gi : Wi.constructor.name;
    }
    return mi.checkPropTypes = ii, mi.resetWarningCache = ii.resetWarningCache, mi.PropTypes = mi, mi;
  }, factoryWithTypeCheckers;
}
var factoryWithThrowingShims, hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var pt = /* @__PURE__ */ requireReactPropTypesSecret();
  function yt() {
  }
  function ir() {
  }
  return ir.resetWarningCache = yt, factoryWithThrowingShims = function() {
    function ti(ai, li, oi, si, di, fi) {
      if (fi !== pt) {
        var gi = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw gi.name = "Invariant Violation", gi;
      }
    }
    ti.isRequired = ti;
    function ii() {
      return ti;
    }
    var ui = {
      array: ti,
      bigint: ti,
      bool: ti,
      func: ti,
      number: ti,
      object: ti,
      string: ti,
      symbol: ti,
      any: ti,
      arrayOf: ii,
      element: ti,
      elementType: ti,
      instanceOf: ii,
      node: ti,
      objectOf: ii,
      oneOf: ii,
      oneOfType: ii,
      shape: ii,
      exact: ii,
      checkPropTypes: ir,
      resetWarningCache: yt
    };
    return ui.PropTypes = ui, ui;
  }, factoryWithThrowingShims;
}
var hasRequiredPropTypes;
function requirePropTypes() {
  if (hasRequiredPropTypes) return propTypes.exports;
  if (hasRequiredPropTypes = 1, process.env.NODE_ENV !== "production") {
    var pt = requireReactIs$2(), yt = !0;
    propTypes.exports = /* @__PURE__ */ requireFactoryWithTypeCheckers()(pt.isElement, yt);
  } else
    propTypes.exports = /* @__PURE__ */ requireFactoryWithThrowingShims()();
  return propTypes.exports;
}
var propTypesExports = /* @__PURE__ */ requirePropTypes();
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
function isHostComponent$2(pt) {
  return typeof pt == "string";
}
function appendOwnerState$1(pt, yt, ir) {
  return pt === void 0 || isHostComponent$2(pt) ? yt : {
    ...yt,
    ownerState: {
      ...yt.ownerState,
      ...ir
    }
  };
}
function areArraysEqual(pt, yt, ir = (ti, ii) => ti === ii) {
  return pt.length === yt.length && pt.every((ti, ii) => ir(ti, yt[ii]));
}
const defaultContextValue = {
  disableDefaultClasses: !1
}, ClassNameConfiguratorContext = /* @__PURE__ */ React.createContext(defaultContextValue);
process.env.NODE_ENV !== "production" && (ClassNameConfiguratorContext.displayName = "ClassNameConfiguratorContext");
function useClassNamesOverride(pt) {
  const {
    disableDefaultClasses: yt
  } = React.useContext(ClassNameConfiguratorContext);
  return (ir) => yt ? "" : pt(ir);
}
function extractEventHandlers$1(pt, yt = []) {
  if (pt === void 0)
    return {};
  const ir = {};
  return Object.keys(pt).filter((ti) => ti.match(/^on[A-Z]/) && typeof pt[ti] == "function" && !yt.includes(ti)).forEach((ti) => {
    ir[ti] = pt[ti];
  }), ir;
}
function isHostComponent$1(pt) {
  return typeof pt == "string";
}
function useRootElementName(pt) {
  const {
    rootElementName: yt = "",
    componentName: ir
  } = pt, [ti, ii] = React.useState(yt.toUpperCase());
  process.env.NODE_ENV !== "production" && React.useEffect(() => {
    yt && ti !== yt.toUpperCase() && console.error(`useRootElementName: the \`rootElementName\` prop of ${ir ? `the ${ir} component` : "a component"} expected the '${yt}' element, but a '${ti.toLowerCase()}' was rendered instead`, "This may cause hydration issues in an SSR context, for example in a Next.js app");
  }, [yt, ti, ir]);
  const ui = React.useCallback((ai) => {
    ii((ai == null ? void 0 : ai.tagName) ?? "");
  }, []);
  return [ti, ui];
}
function useForkRef$1(...pt) {
  const yt = React.useRef(void 0), ir = React.useCallback((ti) => {
    const ii = pt.map((ui) => {
      if (ui == null)
        return null;
      if (typeof ui == "function") {
        const ai = ui, li = ai(ti);
        return typeof li == "function" ? li : () => {
          ai(null);
        };
      }
      return ui.current = ti, () => {
        ui.current = null;
      };
    });
    return () => {
      ii.forEach((ui) => ui == null ? void 0 : ui());
    };
  }, pt);
  return React.useMemo(() => pt.every((ti) => ti == null) ? null : (ti) => {
    yt.current && (yt.current(), yt.current = void 0), ti != null && (yt.current = ir(ti));
  }, pt);
}
function r$4(pt) {
  var yt, ir, ti = "";
  if (typeof pt == "string" || typeof pt == "number") ti += pt;
  else if (typeof pt == "object") if (Array.isArray(pt)) {
    var ii = pt.length;
    for (yt = 0; yt < ii; yt++) pt[yt] && (ir = r$4(pt[yt])) && (ti && (ti += " "), ti += ir);
  } else for (ir in pt) pt[ir] && (ti && (ti += " "), ti += ir);
  return ti;
}
function clsx$1() {
  for (var pt, yt, ir = 0, ti = "", ii = arguments.length; ir < ii; ir++) (pt = arguments[ir]) && (yt = r$4(pt)) && (ti && (ti += " "), ti += yt);
  return ti;
}
function omitEventHandlers$1(pt) {
  if (pt === void 0)
    return {};
  const yt = {};
  return Object.keys(pt).filter((ir) => !(ir.match(/^on[A-Z]/) && typeof pt[ir] == "function")).forEach((ir) => {
    yt[ir] = pt[ir];
  }), yt;
}
function mergeSlotProps$2(pt) {
  const {
    getSlotProps: yt,
    additionalProps: ir,
    externalSlotProps: ti,
    externalForwardedProps: ii,
    className: ui
  } = pt;
  if (!yt) {
    const mi = clsx$1(ir == null ? void 0 : ir.className, ui, ii == null ? void 0 : ii.className, ti == null ? void 0 : ti.className), Ti = {
      ...ir == null ? void 0 : ir.style,
      ...ii == null ? void 0 : ii.style,
      ...ti == null ? void 0 : ti.style
    }, vi = {
      ...ir,
      ...ii,
      ...ti
    };
    return mi.length > 0 && (vi.className = mi), Object.keys(Ti).length > 0 && (vi.style = Ti), {
      props: vi,
      internalRef: void 0
    };
  }
  const ai = extractEventHandlers$1({
    ...ii,
    ...ti
  }), li = omitEventHandlers$1(ti), oi = omitEventHandlers$1(ii), si = yt(ai), di = clsx$1(si == null ? void 0 : si.className, ir == null ? void 0 : ir.className, ui, ii == null ? void 0 : ii.className, ti == null ? void 0 : ti.className), fi = {
    ...si == null ? void 0 : si.style,
    ...ir == null ? void 0 : ir.style,
    ...ii == null ? void 0 : ii.style,
    ...ti == null ? void 0 : ti.style
  }, gi = {
    ...si,
    ...ir,
    ...oi,
    ...li
  };
  return di.length > 0 && (gi.className = di), Object.keys(fi).length > 0 && (gi.style = fi), {
    props: gi,
    internalRef: si.ref
  };
}
function resolveComponentProps$1(pt, yt, ir) {
  return typeof pt == "function" ? pt(yt, ir) : pt;
}
function useSlotProps$1(pt) {
  var yt;
  const {
    elementType: ir,
    externalSlotProps: ti,
    ownerState: ii,
    skipResolvingSlotProps: ui = !1,
    ...ai
  } = pt, li = ui ? {} : resolveComponentProps$1(ti, ii), {
    props: oi,
    internalRef: si
  } = mergeSlotProps$2({
    ...ai,
    externalSlotProps: li
  }), di = useForkRef$1(si, li == null ? void 0 : li.ref, (yt = pt.additionalProps) == null ? void 0 : yt.ref);
  return appendOwnerState$1(ir, {
    ...oi,
    ref: di
  }, ii);
}
function chainPropTypes$1(pt, yt) {
  return process.env.NODE_ENV === "production" ? () => null : function(...ir) {
    return pt(...ir) || yt(...ir);
  };
}
function isClassComponent$2(pt) {
  const {
    prototype: yt = {}
  } = pt;
  return !!yt.isReactComponent;
}
function acceptingRef$1(pt, yt, ir, ti, ii) {
  const ui = pt[yt], ai = ii || yt;
  if (ui == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let li;
  const oi = ui.type;
  return typeof oi == "function" && !isClassComponent$2(oi) && (li = "Did you accidentally use a plain function component for an element instead?"), li !== void 0 ? new Error(`Invalid ${ti} \`${ai}\` supplied to \`${ir}\`. Expected an element that can hold a ref. ${li} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const elementAcceptingRef$1 = chainPropTypes$1(PropTypes.element, acceptingRef$1);
elementAcceptingRef$1.isRequired = chainPropTypes$1(PropTypes.element.isRequired, acceptingRef$1);
const specialProperty$1 = "exact-prop: ​";
function exactProp$1(pt) {
  return process.env.NODE_ENV === "production" ? pt : {
    ...pt,
    [specialProperty$1]: (yt) => {
      const ir = Object.keys(yt).filter((ti) => !pt.hasOwnProperty(ti));
      return ir.length > 0 ? new Error(`The following props are not supported: ${ir.map((ti) => `\`${ti}\``).join(", ")}. Please remove them.`) : null;
    }
  };
}
function formatMuiErrorMessage$1(pt, ...yt) {
  const ir = new URL(`https://mui.com/production-error/?code=${pt}`);
  return yt.forEach((ti) => ir.searchParams.append("args[]", ti)), `Minified MUI error #${pt}; visit ${ir} for the full message.`;
}
function HTMLElementType$1(pt, yt, ir, ti, ii) {
  if (process.env.NODE_ENV === "production")
    return null;
  const ui = pt[yt], ai = ii || yt;
  return ui == null ? null : ui && ui.nodeType !== 1 ? new Error(`Invalid ${ti} \`${ai}\` supplied to \`${ir}\`. Expected an HTMLElement.`) : null;
}
const refType$1 = PropTypes.oneOfType([PropTypes.func, PropTypes.object]);
function createChainedFunction$1(...pt) {
  return pt.reduce((yt, ir) => ir == null ? yt : function(...ti) {
    yt.apply(this, ti), ir.apply(this, ti);
  }, () => {
  });
}
function ownerDocument$1(pt) {
  return pt && pt.ownerDocument || document;
}
function ownerWindow$1(pt) {
  return ownerDocument$1(pt).defaultView || window;
}
function setRef$1(pt, yt) {
  typeof pt == "function" ? pt(yt) : pt && (pt.current = yt);
}
const useEnhancedEffect$1 = typeof window < "u" ? React.useLayoutEffect : React.useEffect;
let globalId$1 = 0;
function useGlobalId$1(pt) {
  const [yt, ir] = React.useState(pt), ti = pt || yt;
  return React.useEffect(() => {
    yt == null && (globalId$1 += 1, ir(`mui-${globalId$1}`));
  }, [yt]), ti;
}
const safeReact$1 = {
  ...React
}, maybeReactUseId$1 = safeReact$1.useId;
function useId$2(pt) {
  if (maybeReactUseId$1 !== void 0) {
    const yt = maybeReactUseId$1();
    return pt ?? yt;
  }
  return useGlobalId$1(pt);
}
function useControlled$1({
  controlled: pt,
  default: yt,
  name: ir,
  state: ti = "value"
}) {
  const {
    current: ii
  } = React.useRef(pt !== void 0), [ui, ai] = React.useState(yt), li = ii ? pt : ui;
  if (process.env.NODE_ENV !== "production") {
    React.useEffect(() => {
      ii !== (pt !== void 0) && console.error([`MUI: A component is changing the ${ii ? "" : "un"}controlled ${ti} state of ${ir} to be ${ii ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${ir} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [ti, ir, pt]);
    const {
      current: si
    } = React.useRef(yt);
    React.useEffect(() => {
      !ii && !Object.is(si, yt) && console.error([`MUI: A component is changing the default ${ti} state of an uncontrolled ${ir} after being initialized. To suppress this warning opt to use a controlled ${ir}.`].join(`
`));
    }, [JSON.stringify(yt)]);
  }
  const oi = React.useCallback((si) => {
    ii || ai(si);
  }, []);
  return [li, oi];
}
function useEventCallback$1(pt) {
  const yt = React.useRef(pt);
  return useEnhancedEffect$1(() => {
    yt.current = pt;
  }), React.useRef((...ir) => (
    // @ts-expect-error hide `this`
    (0, yt.current)(...ir)
  )).current;
}
function isFocusVisible$1(pt) {
  try {
    return pt.matches(":focus-visible");
  } catch {
    process.env.NODE_ENV !== "production" && !/jsdom/.test(window.navigator.userAgent) && console.warn(["MUI: The `:focus-visible` pseudo class is not supported in this browser.", "Some components rely on this feature to work properly."].join(`
`));
  }
  return !1;
}
function getScrollbarSize$1(pt = window) {
  const yt = pt.document.documentElement.clientWidth;
  return pt.innerWidth - yt;
}
const visuallyHidden = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px"
};
function composeClasses$1(pt, yt, ir = void 0) {
  const ti = {};
  for (const ii in pt) {
    const ui = pt[ii];
    let ai = "", li = !0;
    for (let oi = 0; oi < ui.length; oi += 1) {
      const si = ui[oi];
      si && (ai += (li === !0 ? "" : " ") + yt(si), li = !1, ir && ir[si] && (ai += " " + ir[si]));
    }
    ti[ii] = ai;
  }
  return ti;
}
const globalStateClasses$1 = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function getReactElementRef$1(pt) {
  var yt;
  return parseInt(React.version, 10) >= 19 ? ((yt = pt == null ? void 0 : pt.props) == null ? void 0 : yt.ref) || null : (pt == null ? void 0 : pt.ref) || null;
}
const GLOBAL_CLASS_PREFIX = "base";
function buildStateClass(pt) {
  return `${GLOBAL_CLASS_PREFIX}--${pt}`;
}
function buildSlotClass(pt, yt) {
  return `${GLOBAL_CLASS_PREFIX}-${pt}-${yt}`;
}
function generateUtilityClass$1(pt, yt) {
  const ir = globalStateClasses$1[yt];
  return ir ? buildStateClass(ir) : buildSlotClass(pt, yt);
}
function generateUtilityClasses$1(pt, yt) {
  const ir = {};
  return yt.forEach((ti) => {
    ir[ti] = generateUtilityClass$1(pt, ti);
  }), ir;
}
const COMPONENT_NAME$b = "Button";
function getButtonUtilityClass(pt) {
  return generateUtilityClass$1(COMPONENT_NAME$b, pt);
}
generateUtilityClasses$1(COMPONENT_NAME$b, ["root", "active", "disabled", "focusVisible"]);
function useButton(pt = {}) {
  const {
    disabled: yt = !1,
    focusableWhenDisabled: ir,
    href: ti,
    rootRef: ii,
    tabIndex: ui,
    to: ai,
    type: li,
    rootElementName: oi
  } = pt, si = React.useRef(null), [di, fi] = React.useState(!1), [gi, mi] = React.useState(!1);
  yt && !ir && gi && mi(!1);
  const [Ti, vi] = useRootElementName({
    rootElementName: oi ?? (ti || ai ? "a" : void 0),
    componentName: "Button"
  }), xi = (fo) => (_o) => {
    var Li;
    gi && _o.preventDefault(), (Li = fo.onMouseLeave) == null || Li.call(fo, _o);
  }, Si = (fo) => (_o) => {
    var Li;
    isFocusVisible$1(_o.target) || mi(!1), (Li = fo.onBlur) == null || Li.call(fo, _o);
  }, Pi = (fo) => (_o) => {
    var Li, Co;
    si.current || (si.current = _o.currentTarget), isFocusVisible$1(_o.target) && (mi(!0), (Li = fo.onFocusVisible) == null || Li.call(fo, _o)), (Co = fo.onFocus) == null || Co.call(fo, _o);
  }, $i = () => {
    const fo = si.current;
    return Ti === "BUTTON" || Ti === "INPUT" && ["button", "submit", "reset"].includes(fo == null ? void 0 : fo.type) || Ti === "A" && (fo == null ? void 0 : fo.href);
  }, Oi = (fo) => (_o) => {
    var Li;
    yt || (Li = fo.onClick) == null || Li.call(fo, _o);
  }, Di = (fo) => (_o) => {
    var Li;
    yt || (fi(!0), document.addEventListener("mouseup", () => {
      fi(!1);
    }, {
      once: !0
    })), (Li = fo.onMouseDown) == null || Li.call(fo, _o);
  }, Mi = (fo) => (_o) => {
    var Li, Co;
    (Li = fo.onKeyDown) == null || Li.call(fo, _o), !_o.defaultMuiPrevented && (_o.target === _o.currentTarget && !$i() && _o.key === " " && _o.preventDefault(), _o.target === _o.currentTarget && _o.key === " " && !yt && fi(!0), _o.target === _o.currentTarget && !$i() && _o.key === "Enter" && !yt && ((Co = fo.onClick) == null || Co.call(fo, _o), _o.preventDefault()));
  }, Oo = (fo) => (_o) => {
    var Li, Co;
    _o.target === _o.currentTarget && fi(!1), (Li = fo.onKeyUp) == null || Li.call(fo, _o), _o.target === _o.currentTarget && !$i() && !yt && _o.key === " " && !_o.defaultMuiPrevented && ((Co = fo.onClick) == null || Co.call(fo, _o));
  }, io = useForkRef$1(vi, ii, si), xo = {};
  return ui !== void 0 && (xo.tabIndex = ui), Ti === "BUTTON" ? (xo.type = li ?? "button", ir ? xo["aria-disabled"] = yt : xo.disabled = yt) : Ti === "INPUT" ? li && ["button", "submit", "reset"].includes(li) && (ir ? xo["aria-disabled"] = yt : xo.disabled = yt) : Ti !== "" && (!ti && !ai && (xo.role = "button", xo.tabIndex = ui ?? 0), yt && (xo["aria-disabled"] = yt, xo.tabIndex = ir ? ui ?? 0 : -1)), {
    getRootProps: (fo = {}) => {
      const _o = {
        ...extractEventHandlers$1(pt),
        ...extractEventHandlers$1(fo)
      }, Li = {
        type: li,
        ..._o,
        ...xo,
        ...fo,
        onBlur: Si(_o),
        onClick: Oi(_o),
        onFocus: Pi(_o),
        onKeyDown: Mi(_o),
        onKeyUp: Oo(_o),
        onMouseDown: Di(_o),
        onMouseLeave: xi(_o),
        ref: io
      };
      return delete Li.onFocusVisible, Li;
    },
    focusVisible: gi,
    setFocusVisible: mi,
    active: di,
    rootRef: io
  };
}
const useUtilityClasses$H = (pt) => {
  const {
    active: yt,
    disabled: ir,
    focusVisible: ti
  } = pt;
  return composeClasses$1({
    root: ["root", ir && "disabled", ti && "focusVisible", yt && "active"]
  }, useClassNamesOverride(getButtonUtilityClass));
}, Button$1 = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const {
    action: ir,
    children: ti,
    disabled: ii,
    focusableWhenDisabled: ui = !1,
    onFocusVisible: ai,
    slotProps: li = {},
    slots: oi = {},
    rootElementName: si = "button",
    ...di
  } = pt, fi = React.useRef(null);
  let gi = si;
  typeof oi.root == "string" ? gi = oi.root : (di.href || di.to) && (gi = "a");
  const {
    active: mi,
    focusVisible: Ti,
    setFocusVisible: vi,
    getRootProps: xi
  } = useButton({
    ...pt,
    focusableWhenDisabled: ui,
    rootElementName: gi
  });
  React.useImperativeHandle(ir, () => ({
    focusVisible: () => {
      vi(!0), fi.current.focus();
    }
  }), [vi]);
  const Si = {
    ...pt,
    active: mi,
    focusableWhenDisabled: ui,
    focusVisible: Ti
  }, Pi = useUtilityClasses$H(Si), $i = di.href || di.to ? "a" : "button", Oi = oi.root ?? $i, Di = useSlotProps$1({
    elementType: Oi,
    getSlotProps: xi,
    externalForwardedProps: di,
    externalSlotProps: li.root,
    additionalProps: {
      ref: yt
    },
    ownerState: Si,
    className: Pi.root
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Oi, {
    ...Di,
    children: ti
  });
});
process.env.NODE_ENV !== "production" && (Button$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions. It currently only supports `focusVisible()` action.
   */
  action: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      focusVisible: PropTypes.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, allows a disabled button to receive focus.
   * @default false
   */
  focusableWhenDisabled: PropTypes.bool,
  /**
   * @ignore
   */
  href: PropTypes.string,
  /**
   * @ignore
   */
  onFocusVisible: PropTypes.func,
  /**
   * The HTML element that is ultimately rendered, for example 'button' or 'a'
   * @default 'button'
   */
  rootElementName: PropTypes.string,
  /**
   * The props used for each slot inside the Button.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Button.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * @ignore
   */
  to: PropTypes.string
});
const DropdownContext = /* @__PURE__ */ React.createContext(null);
process.env.NODE_ENV !== "production" && (DropdownContext.displayName = "DropdownContext");
function areEqual(pt, yt) {
  return pt === yt;
}
const EMPTY_OBJECT$1 = {}, NOOP$1 = () => {
};
function getControlledState(pt, yt) {
  const ir = {
    ...pt
  };
  return Object.keys(yt).forEach((ti) => {
    yt[ti] !== void 0 && (ir[ti] = yt[ti]);
  }), ir;
}
function useStateChangeDetection(pt) {
  const {
    nextState: yt,
    initialState: ir,
    stateComparers: ti,
    onStateChange: ii,
    controlledProps: ui,
    lastActionRef: ai
  } = pt, li = React.useRef(ir);
  React.useEffect(() => {
    if (ai.current === null)
      return;
    const oi = getControlledState(li.current, ui);
    Object.keys(yt).forEach((si) => {
      const di = ti[si] ?? areEqual, fi = yt[si], gi = oi[si];
      (gi == null && fi != null || gi != null && fi == null || gi != null && fi != null && !di(fi, gi)) && (ii == null || ii(ai.current.event ?? null, si, fi, ai.current.type ?? "", yt));
    }), li.current = yt, ai.current = null;
  }, [li, yt, ai, ii, ti, ui]);
}
function useControllableReducer(pt) {
  const yt = React.useRef(null), {
    reducer: ir,
    initialState: ti,
    controlledProps: ii = EMPTY_OBJECT$1,
    stateComparers: ui = EMPTY_OBJECT$1,
    onStateChange: ai = NOOP$1,
    actionContext: li,
    componentName: oi = ""
  } = pt, si = React.useRef(ii);
  process.env.NODE_ENV !== "production" && React.useEffect(() => {
    Object.keys(ii).forEach((Ti) => {
      si.current[Ti] !== void 0 && ii[Ti] === void 0 && console.error(`useControllableReducer: ${oi ? `The ${oi} component` : "A component"} is changing a controlled prop to be uncontrolled: ${Ti}`), si.current[Ti] === void 0 && ii[Ti] !== void 0 && console.error(`useControllableReducer: ${oi ? `The ${oi} component` : "A component"} is changing an uncontrolled prop to be controlled: ${Ti}`);
    });
  }, [ii, oi]);
  const di = React.useCallback((Ti, vi) => {
    yt.current = vi;
    const xi = getControlledState(Ti, ii);
    return ir(xi, vi);
  }, [ii, ir]), [fi, gi] = React.useReducer(di, ti), mi = React.useCallback((Ti) => {
    gi({
      ...Ti,
      context: li
    });
  }, [li]);
  return useStateChangeDetection({
    nextState: fi,
    initialState: ti,
    stateComparers: ui ?? EMPTY_OBJECT$1,
    onStateChange: ai ?? NOOP$1,
    controlledProps: ii,
    lastActionRef: yt
  }), [getControlledState(fi, ii), mi];
}
const DropdownActionTypes = {
  blur: "dropdown:blur",
  escapeKeyDown: "dropdown:escapeKeyDown",
  toggle: "dropdown:toggle",
  open: "dropdown:open",
  close: "dropdown:close"
};
function dropdownReducer(pt, yt) {
  switch (yt.type) {
    case DropdownActionTypes.blur:
      return {
        open: !1,
        changeReason: yt.event
      };
    case DropdownActionTypes.escapeKeyDown:
      return {
        open: !1,
        changeReason: yt.event
      };
    case DropdownActionTypes.toggle:
      return {
        open: !pt.open,
        changeReason: yt.event
      };
    case DropdownActionTypes.open:
      return {
        open: !0,
        changeReason: yt.event
      };
    case DropdownActionTypes.close:
      return {
        open: !1,
        changeReason: yt.event
      };
    default:
      throw new Error("Unhandled action");
  }
}
function useDropdown(pt = {}) {
  const {
    defaultOpen: yt,
    onOpenChange: ir,
    open: ti,
    componentName: ii = "useDropdown"
  } = pt, [ui, ai] = React.useState(""), [li, oi] = React.useState(null), si = React.useRef(null), di = React.useCallback((Ti, vi, xi, Si) => {
    vi === "open" && (ir == null || ir(Ti, xi)), si.current = Si;
  }, [ir]), fi = React.useMemo(() => ti !== void 0 ? {
    open: ti
  } : {}, [ti]), [gi, mi] = useControllableReducer({
    controlledProps: fi,
    initialState: yt ? {
      open: !0,
      changeReason: null
    } : {
      open: !1,
      changeReason: null
    },
    onStateChange: di,
    reducer: dropdownReducer,
    componentName: ii
  });
  return React.useEffect(() => {
    !gi.open && si.current !== null && si.current !== DropdownActionTypes.blur && (li == null || li.focus());
  }, [gi.open, li]), {
    contextValue: {
      state: gi,
      dispatch: mi,
      popupId: ui,
      registerPopup: ai,
      registerTrigger: oi,
      triggerElement: li
    },
    open: gi.open
  };
}
function Dropdown(pt) {
  const {
    children: yt,
    open: ir,
    defaultOpen: ti,
    onOpenChange: ii
  } = pt, {
    contextValue: ui
  } = useDropdown({
    defaultOpen: ti,
    onOpenChange: ii,
    open: ir
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DropdownContext.Provider, {
    value: ui,
    children: yt
  });
}
process.env.NODE_ENV !== "production" && (Dropdown.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * If `true`, the dropdown is initially open.
   */
  defaultOpen: PropTypes.bool,
  /**
   * Callback fired when the component requests to be opened or closed.
   */
  onOpenChange: PropTypes.func,
  /**
   * Allows to control whether the dropdown is open.
   * This is a controlled counterpart of `defaultOpen`.
   */
  open: PropTypes.bool
});
process.env.NODE_ENV !== "production" && (Dropdown.propTypes = exactProp$1(Dropdown.propTypes));
const candidatesSelector$1 = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function getTabIndex$1(pt) {
  const yt = parseInt(pt.getAttribute("tabindex") || "", 10);
  return Number.isNaN(yt) ? pt.contentEditable === "true" || (pt.nodeName === "AUDIO" || pt.nodeName === "VIDEO" || pt.nodeName === "DETAILS") && pt.getAttribute("tabindex") === null ? 0 : pt.tabIndex : yt;
}
function isNonTabbableRadio$1(pt) {
  if (pt.tagName !== "INPUT" || pt.type !== "radio" || !pt.name)
    return !1;
  const yt = (ti) => pt.ownerDocument.querySelector(`input[type="radio"]${ti}`);
  let ir = yt(`[name="${pt.name}"]:checked`);
  return ir || (ir = yt(`[name="${pt.name}"]`)), ir !== pt;
}
function isNodeMatchingSelectorFocusable$1(pt) {
  return !(pt.disabled || pt.tagName === "INPUT" && pt.type === "hidden" || isNonTabbableRadio$1(pt));
}
function defaultGetTabbable$1(pt) {
  const yt = [], ir = [];
  return Array.from(pt.querySelectorAll(candidatesSelector$1)).forEach((ti, ii) => {
    const ui = getTabIndex$1(ti);
    ui === -1 || !isNodeMatchingSelectorFocusable$1(ti) || (ui === 0 ? yt.push(ti) : ir.push({
      documentOrder: ii,
      tabIndex: ui,
      node: ti
    }));
  }), ir.sort((ti, ii) => ti.tabIndex === ii.tabIndex ? ti.documentOrder - ii.documentOrder : ti.tabIndex - ii.tabIndex).map((ti) => ti.node).concat(yt);
}
function defaultIsEnabled$1() {
  return !0;
}
function FocusTrap$1(pt) {
  const {
    children: yt,
    disableAutoFocus: ir = !1,
    disableEnforceFocus: ti = !1,
    disableRestoreFocus: ii = !1,
    getTabbable: ui = defaultGetTabbable$1,
    isEnabled: ai = defaultIsEnabled$1,
    open: li
  } = pt, oi = React.useRef(!1), si = React.useRef(null), di = React.useRef(null), fi = React.useRef(null), gi = React.useRef(null), mi = React.useRef(!1), Ti = React.useRef(null), vi = useForkRef$1(getReactElementRef$1(yt), Ti), xi = React.useRef(null);
  React.useEffect(() => {
    !li || !Ti.current || (mi.current = !ir);
  }, [ir, li]), React.useEffect(() => {
    if (!li || !Ti.current)
      return;
    const $i = ownerDocument$1(Ti.current);
    return Ti.current.contains($i.activeElement) || (Ti.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), Ti.current.setAttribute("tabIndex", "-1")), mi.current && Ti.current.focus()), () => {
      ii || (fi.current && fi.current.focus && (oi.current = !0, fi.current.focus()), fi.current = null);
    };
  }, [li]), React.useEffect(() => {
    if (!li || !Ti.current)
      return;
    const $i = ownerDocument$1(Ti.current), Oi = (Oo) => {
      xi.current = Oo, !(ti || !ai() || Oo.key !== "Tab") && $i.activeElement === Ti.current && Oo.shiftKey && (oi.current = !0, di.current && di.current.focus());
    }, Di = () => {
      var Oo, io;
      const xo = Ti.current;
      if (xo === null)
        return;
      if (!$i.hasFocus() || !ai() || oi.current) {
        oi.current = !1;
        return;
      }
      if (xo.contains($i.activeElement) || ti && $i.activeElement !== si.current && $i.activeElement !== di.current)
        return;
      if ($i.activeElement !== gi.current)
        gi.current = null;
      else if (gi.current !== null)
        return;
      if (!mi.current)
        return;
      let fo = [];
      if (($i.activeElement === si.current || $i.activeElement === di.current) && (fo = ui(Ti.current)), fo.length > 0) {
        const _o = !!((Oo = xi.current) != null && Oo.shiftKey && ((io = xi.current) == null ? void 0 : io.key) === "Tab"), Li = fo[0], Co = fo[fo.length - 1];
        typeof Li != "string" && typeof Co != "string" && (_o ? Co.focus() : Li.focus());
      } else
        xo.focus();
    };
    $i.addEventListener("focusin", Di), $i.addEventListener("keydown", Oi, !0);
    const Mi = setInterval(() => {
      $i.activeElement && $i.activeElement.tagName === "BODY" && Di();
    }, 50);
    return () => {
      clearInterval(Mi), $i.removeEventListener("focusin", Di), $i.removeEventListener("keydown", Oi, !0);
    };
  }, [ir, ti, ii, ai, li, ui]);
  const Si = ($i) => {
    fi.current === null && (fi.current = $i.relatedTarget), mi.current = !0, gi.current = $i.target;
    const Oi = yt.props.onFocus;
    Oi && Oi($i);
  }, Pi = ($i) => {
    fi.current === null && (fi.current = $i.relatedTarget), mi.current = !0;
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      tabIndex: li ? 0 : -1,
      onFocus: Pi,
      ref: si,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ React.cloneElement(yt, {
      ref: vi,
      onFocus: Si
    }), /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      tabIndex: li ? 0 : -1,
      onFocus: Pi,
      ref: di,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" && (FocusTrap$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: elementAcceptingRef$1,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: PropTypes.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: PropTypes.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: PropTypes.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: PropTypes.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: PropTypes.func,
  /**
   * If `true`, focus is locked.
   */
  open: PropTypes.bool.isRequired
});
process.env.NODE_ENV !== "production" && (FocusTrap$1.propTypes = exactProp$1(FocusTrap$1.propTypes));
const FormControlContext$1 = /* @__PURE__ */ React.createContext(void 0);
process.env.NODE_ENV !== "production" && (FormControlContext$1.displayName = "FormControlContext");
function useFormControlContext() {
  return React.useContext(FormControlContext$1);
}
const COMPONENT_NAME$a = "Input";
function getInputUtilityClass$1(pt) {
  return generateUtilityClass$1(COMPONENT_NAME$a, pt);
}
generateUtilityClasses$1(COMPONENT_NAME$a, ["root", "formControl", "focused", "disabled", "error", "multiline", "input", "inputMultiline", "inputTypeSearch", "adornedStart", "adornedEnd"]);
function useInput(pt = {}) {
  const {
    defaultValue: yt,
    disabled: ir = !1,
    error: ti = !1,
    onBlur: ii,
    onChange: ui,
    onFocus: ai,
    required: li = !1,
    value: oi,
    inputRef: si
  } = pt, di = useFormControlContext();
  let fi, gi, mi, Ti, vi;
  if (di) {
    if (fi = void 0, gi = di.disabled ?? !1, mi = di.error ?? !1, Ti = di.required ?? !1, vi = di.value, process.env.NODE_ENV !== "production") {
      const fo = ["defaultValue", "disabled", "error", "required", "value"].filter((_o) => pt[_o] !== void 0);
      fo.length > 0 && console.warn(["MUI: You have set props on an input that is inside a FormControl.", "Set these props on a FormControl instead. Otherwise they will be ignored.", `Ignored props: ${fo.join(", ")}`].join(`
`));
    }
  } else
    fi = yt, gi = ir, mi = ti, Ti = li, vi = oi;
  const {
    current: xi
  } = React.useRef(vi != null), Si = React.useCallback((fo) => {
    process.env.NODE_ENV !== "production" && fo && fo.nodeName !== "INPUT" && !fo.focus && console.error(["MUI: You have provided a `slots.input` to the input component", "that does not correctly handle the `ref` prop.", "Make sure the `ref` prop is called with a HTMLInputElement."].join(`
`));
  }, []), Pi = React.useRef(null), $i = useForkRef$1(Pi, si, Si), [Oi, Di] = React.useState(!1);
  React.useEffect(() => {
    !di && gi && Oi && (Di(!1), ii == null || ii());
  }, [di, gi, Oi, ii]);
  const Mi = (fo) => (_o) => {
    var Li, Co;
    if (di != null && di.disabled) {
      _o.stopPropagation();
      return;
    }
    (Li = fo.onFocus) == null || Li.call(fo, _o), di && di.onFocus ? (Co = di == null ? void 0 : di.onFocus) == null || Co.call(di) : Di(!0);
  }, Oo = (fo) => (_o) => {
    var Li;
    (Li = fo.onBlur) == null || Li.call(fo, _o), di && di.onBlur ? di.onBlur() : Di(!1);
  }, io = (fo) => (_o, ...Li) => {
    var Co, Ni;
    if (!xi && (_o.target || Pi.current) == null)
      throw new Error(process.env.NODE_ENV !== "production" ? "MUI: Expected valid input target. Did you use a custom `slots.input` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : formatMuiErrorMessage$1(17));
    (Co = di == null ? void 0 : di.onChange) == null || Co.call(di, _o), (Ni = fo.onChange) == null || Ni.call(fo, _o, ...Li);
  }, xo = (fo) => (_o) => {
    var Li;
    Pi.current && _o.currentTarget === _o.target && Pi.current.focus(), (Li = fo.onClick) == null || Li.call(fo, _o);
  };
  return {
    disabled: gi,
    error: mi,
    focused: Oi,
    formControlContext: di,
    getInputProps: (fo = {}) => {
      const _o = {
        onBlur: ii,
        onChange: ui,
        onFocus: ai,
        ...extractEventHandlers$1(fo)
      }, Li = {
        ..._o,
        onBlur: Oo(_o),
        onChange: io(_o),
        onFocus: Mi(_o)
      };
      return {
        ...Li,
        "aria-invalid": mi || void 0,
        defaultValue: fi,
        value: vi,
        required: Ti,
        disabled: gi,
        ...fo,
        ref: $i,
        ...Li
      };
    },
    getRootProps: (fo = {}) => {
      const _o = {
        ...extractEventHandlers$1(pt, ["onBlur", "onChange", "onFocus"]),
        ...extractEventHandlers$1(fo)
      };
      return {
        ...fo,
        ..._o,
        onClick: xo(_o)
      };
    },
    inputRef: $i,
    required: Ti,
    value: vi
  };
}
const useUtilityClasses$G = (pt) => {
  const {
    disabled: yt,
    error: ir,
    focused: ti,
    formControlContext: ii,
    multiline: ui,
    startAdornment: ai,
    endAdornment: li
  } = pt;
  return composeClasses$1({
    root: ["root", yt && "disabled", ir && "error", ti && "focused", !!ii && "formControl", ui && "multiline", !!ai && "adornedStart", !!li && "adornedEnd"],
    input: ["input", yt && "disabled", ui && "multiline"]
  }, useClassNamesOverride(getInputUtilityClass$1));
}, Input$2 = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const {
    "aria-describedby": ir,
    "aria-label": ti,
    "aria-labelledby": ii,
    autoComplete: ui,
    autoFocus: ai,
    className: li,
    defaultValue: oi,
    disabled: si,
    endAdornment: di,
    error: fi,
    id: gi,
    multiline: mi = !1,
    name: Ti,
    onClick: vi,
    onChange: xi,
    onKeyDown: Si,
    onKeyUp: Pi,
    onFocus: $i,
    onBlur: Oi,
    placeholder: Di,
    readOnly: Mi,
    required: Oo,
    startAdornment: io,
    value: xo,
    type: fo,
    rows: _o,
    slotProps: Li = {},
    slots: Co = {},
    minRows: Ni,
    maxRows: Yi,
    ...Vo
  } = pt, {
    getRootProps: No,
    getInputProps: Ui,
    focused: jo,
    formControlContext: Wi,
    error: ji,
    disabled: Hi
  } = useInput({
    disabled: si,
    defaultValue: oi,
    error: fi,
    onBlur: Oi,
    onClick: vi,
    onChange: xi,
    onFocus: $i,
    required: Oo,
    value: xo
  }), zo = mi ? void 0 : fo ?? "text", Lo = {
    ...pt,
    disabled: Hi,
    error: ji,
    focused: jo,
    formControlContext: Wi,
    multiline: mi,
    type: zo
  }, sa = useUtilityClasses$G(Lo), Ko = {
    "aria-describedby": ir,
    "aria-label": ti,
    "aria-labelledby": ii,
    autoComplete: ui,
    autoFocus: ai,
    id: gi,
    onKeyDown: Si,
    onKeyUp: Pi,
    name: Ti,
    placeholder: Di,
    readOnly: Mi,
    type: zo
  }, ca = Co.root ?? "div", pa = useSlotProps$1({
    elementType: ca,
    getSlotProps: No,
    externalSlotProps: Li.root,
    externalForwardedProps: Vo,
    additionalProps: {
      ref: yt
    },
    ownerState: Lo,
    className: [sa.root, li]
  }), ga = mi ? Co.textarea ?? "textarea" : Co.input ?? "input", ia = useSlotProps$1({
    elementType: ga,
    getSlotProps: (ra) => Ui({
      ...Ko,
      ...ra
    }),
    externalSlotProps: Li.input,
    additionalProps: {
      rows: mi ? _o : void 0,
      ...mi && !isHostComponent$1(ga) && {
        minRows: _o || Ni,
        maxRows: _o || Yi
      }
    },
    ownerState: Lo,
    className: sa.input
  });
  return process.env.NODE_ENV !== "production" && mi && _o && (Ni || Yi) && console.warn("MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set."), /* @__PURE__ */ jsxRuntimeExports.jsxs(ca, {
    ...pa,
    children: [io, /* @__PURE__ */ jsxRuntimeExports.jsx(ga, {
      ...ia
    }), di]
  });
});
process.env.NODE_ENV !== "production" && (Input$2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  "aria-describedby": PropTypes.string,
  /**
   * @ignore
   */
  "aria-label": PropTypes.string,
  /**
   * @ignore
   */
  "aria-labelledby": PropTypes.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Class name applied to the root element.
   */
  className: PropTypes.string,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * Trailing adornment for this input.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error by setting the `aria-invalid` attribute on the input and the `baseui--error` class on the root element.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * @ignore
   */
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.object
  })]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.number,
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.number,
  /**
   * If `true`, a `textarea` element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * @ignore
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.number,
  /**
   * The props used for each slot inside the Input.
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the InputBase.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType,
    textarea: PropTypes.elementType
  }),
  /**
   * Leading adornment for this input.
   */
  startAdornment: PropTypes.node,
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: PropTypes.oneOf(["button", "checkbox", "color", "date", "datetime-local", "email", "file", "hidden", "image", "month", "number", "password", "radio", "range", "reset", "search", "submit", "tel", "text", "time", "url", "week"]),
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
});
const COMPONENT_NAME$9 = "Menu";
function getMenuUtilityClass$1(pt) {
  return generateUtilityClass$1(COMPONENT_NAME$9, pt);
}
generateUtilityClasses$1(COMPONENT_NAME$9, ["root", "listbox", "expanded"]);
const ListActionTypes = {
  blur: "list:blur",
  itemClick: "list:itemClick",
  itemHover: "list:itemHover",
  itemsChange: "list:itemsChange",
  keyDown: "list:keyDown",
  resetHighlight: "list:resetHighlight",
  highlightLast: "list:highlightLast",
  textNavigation: "list:textNavigation",
  clearSelection: "list:clearSelection"
};
function findValidItemToHighlight(pt, yt, ir, ti, ii, ui) {
  if (ir.length === 0 || !ti && ir.every((li, oi) => ii(li, oi)))
    return -1;
  let ai = pt;
  for (; ; ) {
    if (!ui && yt === "next" && ai === ir.length || !ui && yt === "previous" && ai === -1)
      return -1;
    if (!ti && ii(ir[ai], ai))
      ai += yt === "next" ? 1 : -1, ui && (ai = (ai + ir.length) % ir.length);
    else
      return ai;
  }
}
function moveHighlight(pt, yt, ir) {
  const {
    items: ti,
    isItemDisabled: ii,
    disableListWrap: ui,
    disabledItemsFocusable: ai,
    itemComparer: li,
    focusManagement: oi
  } = ir, si = oi === "DOM" ? 0 : -1, di = ti.length - 1, fi = pt == null ? -1 : ti.findIndex((xi) => li(xi, pt));
  let gi, mi, Ti = !ui;
  switch (yt) {
    case "reset":
      if (si === -1)
        return null;
      gi = 0, mi = "next", Ti = !1;
      break;
    case "start":
      gi = 0, mi = "next", Ti = !1;
      break;
    case "end":
      gi = di, mi = "previous", Ti = !1;
      break;
    default: {
      const xi = fi + yt;
      xi < 0 ? !Ti && fi !== -1 || Math.abs(yt) > 1 ? (gi = 0, mi = "next") : (gi = di, mi = "previous") : xi > di ? !Ti || Math.abs(yt) > 1 ? (gi = di, mi = "previous") : (gi = 0, mi = "next") : (gi = xi, mi = yt >= 0 ? "next" : "previous");
    }
  }
  const vi = findValidItemToHighlight(gi, mi, ti, ai, ii, Ti);
  return vi === -1 && pt !== null && !ii(pt, fi) ? pt : ti[vi] ?? null;
}
function toggleSelection(pt, yt, ir, ti) {
  return ir === "none" ? [] : ir === "single" ? ti(yt[0], pt) ? yt : [pt] : yt.some((ii) => ti(ii, pt)) ? yt.filter((ii) => !ti(ii, pt)) : [...yt, pt];
}
function handleItemSelection(pt, yt, ir) {
  const {
    itemComparer: ti,
    isItemDisabled: ii,
    selectionMode: ui,
    items: ai
  } = ir, {
    selectedValues: li
  } = yt, oi = ai.findIndex((di) => ti(pt, di));
  if (ii(pt, oi))
    return yt;
  const si = toggleSelection(pt, li, ui, ti);
  return {
    ...yt,
    selectedValues: si,
    highlightedValue: pt
  };
}
function handleKeyDown(pt, yt, ir) {
  const ti = yt.highlightedValue, {
    orientation: ii,
    pageSize: ui
  } = ir;
  switch (pt) {
    case "Home":
      return {
        ...yt,
        highlightedValue: moveHighlight(ti, "start", ir)
      };
    case "End":
      return {
        ...yt,
        highlightedValue: moveHighlight(ti, "end", ir)
      };
    case "PageUp":
      return {
        ...yt,
        highlightedValue: moveHighlight(ti, -ui, ir)
      };
    case "PageDown":
      return {
        ...yt,
        highlightedValue: moveHighlight(ti, ui, ir)
      };
    case "ArrowUp":
      if (ii !== "vertical")
        break;
      return {
        ...yt,
        highlightedValue: moveHighlight(ti, -1, ir)
      };
    case "ArrowDown":
      if (ii !== "vertical")
        break;
      return {
        ...yt,
        highlightedValue: moveHighlight(ti, 1, ir)
      };
    case "ArrowLeft": {
      if (ii === "vertical")
        break;
      return {
        ...yt,
        highlightedValue: moveHighlight(ti, ii === "horizontal-ltr" ? -1 : 1, ir)
      };
    }
    case "ArrowRight": {
      if (ii === "vertical")
        break;
      return {
        ...yt,
        highlightedValue: moveHighlight(ti, ii === "horizontal-ltr" ? 1 : -1, ir)
      };
    }
    case "Enter":
    case " ":
      return yt.highlightedValue === null ? yt : handleItemSelection(yt.highlightedValue, yt, ir);
  }
  return yt;
}
function handleBlur(pt, yt) {
  return yt.focusManagement === "DOM" ? pt : {
    ...pt,
    highlightedValue: null
  };
}
function textCriteriaMatches$1(pt, yt, ir) {
  var ti;
  const ii = (ti = ir(pt)) == null ? void 0 : ti.trim().toLowerCase();
  return !ii || ii.length === 0 ? !1 : ii.startsWith(yt);
}
function handleTextNavigation(pt, yt, ir) {
  const {
    items: ti,
    isItemDisabled: ii,
    disabledItemsFocusable: ui,
    getItemAsString: ai
  } = ir, li = yt.length > 1;
  let oi = li ? pt.highlightedValue : moveHighlight(pt.highlightedValue, 1, ir);
  for (let si = 0; si < ti.length; si += 1) {
    if (!oi || !li && pt.highlightedValue === oi)
      return pt;
    if (textCriteriaMatches$1(oi, yt, ai) && (!ii(oi, ti.indexOf(oi)) || ui))
      return {
        ...pt,
        highlightedValue: oi
      };
    oi = moveHighlight(oi, 1, ir);
  }
  return pt;
}
function handleItemsChange(pt, yt, ir, ti) {
  const {
    itemComparer: ii,
    focusManagement: ui
  } = ti;
  let ai = null;
  ir.highlightedValue != null ? ai = pt.find((oi) => ii(oi, ir.highlightedValue)) ?? null : ui === "DOM" && yt.length === 0 && (ai = moveHighlight(null, "reset", ti));
  const li = (ir.selectedValues ?? []).filter((oi) => pt.some((si) => ii(si, oi)));
  return {
    ...ir,
    highlightedValue: ai,
    selectedValues: li
  };
}
function handleResetHighlight(pt, yt) {
  return {
    ...pt,
    highlightedValue: moveHighlight(null, "reset", yt)
  };
}
function handleHighlightLast(pt, yt) {
  return {
    ...pt,
    highlightedValue: moveHighlight(null, "end", yt)
  };
}
function handleClearSelection(pt, yt) {
  return {
    ...pt,
    selectedValues: [],
    highlightedValue: moveHighlight(null, "reset", yt)
  };
}
function listReducer(pt, yt) {
  const {
    type: ir,
    context: ti
  } = yt;
  switch (ir) {
    case ListActionTypes.keyDown:
      return handleKeyDown(yt.key, pt, ti);
    case ListActionTypes.itemClick:
      return handleItemSelection(yt.item, pt, ti);
    case ListActionTypes.blur:
      return handleBlur(pt, ti);
    case ListActionTypes.textNavigation:
      return handleTextNavigation(pt, yt.searchString, ti);
    case ListActionTypes.itemsChange:
      return handleItemsChange(yt.items, yt.previousItems, pt, ti);
    case ListActionTypes.resetHighlight:
      return handleResetHighlight(pt, ti);
    case ListActionTypes.highlightLast:
      return handleHighlightLast(pt, ti);
    case ListActionTypes.clearSelection:
      return handleClearSelection(pt, ti);
    default:
      return pt;
  }
}
const TEXT_NAVIGATION_RESET_TIMEOUT = 500;
function useTextNavigation(pt) {
  const yt = React.useRef({
    searchString: "",
    lastTime: null
  });
  return React.useCallback((ir) => {
    if (ir.key.length === 1 && ir.key !== " ") {
      const ti = yt.current, ii = ir.key.toLowerCase(), ui = performance.now();
      ti.searchString.length > 0 && ti.lastTime && ui - ti.lastTime > TEXT_NAVIGATION_RESET_TIMEOUT ? ti.searchString = ii : (ti.searchString.length !== 1 || ii !== ti.searchString) && (ti.searchString += ii), ti.lastTime = ui, pt(ti.searchString, ir);
    }
  }, [pt]);
}
const EMPTY_OBJECT = {}, NOOP = () => {
}, defaultItemComparer = (pt, yt) => pt === yt, defaultIsItemDisabled = () => !1, defaultItemStringifier = (pt) => typeof pt == "string" ? pt : String(pt), defaultGetInitialState = () => ({
  highlightedValue: null,
  selectedValues: []
});
function useList(pt) {
  const {
    controlledProps: yt = EMPTY_OBJECT,
    disabledItemsFocusable: ir = !1,
    disableListWrap: ti = !1,
    focusManagement: ii = "activeDescendant",
    getInitialState: ui = defaultGetInitialState,
    getItemDomElement: ai,
    getItemId: li,
    isItemDisabled: oi = defaultIsItemDisabled,
    rootRef: si,
    onStateChange: di = NOOP,
    items: fi,
    itemComparer: gi = defaultItemComparer,
    getItemAsString: mi = defaultItemStringifier,
    onChange: Ti,
    onHighlightChange: vi,
    onItemsChange: xi,
    orientation: Si = "vertical",
    pageSize: Pi = 5,
    reducerActionContext: $i = EMPTY_OBJECT,
    selectionMode: Oi = "single",
    stateReducer: Di,
    componentName: Mi = "useList"
  } = pt;
  if (process.env.NODE_ENV !== "production") {
    if (ii === "DOM" && ai == null)
      throw new Error("useList: The `getItemDomElement` prop is required when using the `DOM` focus management.");
    if (ii === "activeDescendant" && li == null)
      throw new Error("useList: The `getItemId` prop is required when using the `activeDescendant` focus management.");
  }
  const Oo = React.useRef(null), io = useForkRef$1(si, Oo), xo = React.useCallback((ca, pa, ga) => {
    var ia;
    vi == null || vi(ca, pa, ga), ii === "DOM" && pa != null && (ga === ListActionTypes.itemClick || ga === ListActionTypes.keyDown || ga === ListActionTypes.textNavigation) && ((ia = ai == null ? void 0 : ai(pa)) == null || ia.focus());
  }, [ai, vi, ii]), fo = React.useMemo(() => ({
    highlightedValue: gi,
    selectedValues: (ca, pa) => areArraysEqual(ca, pa, gi)
  }), [gi]), _o = React.useCallback((ca, pa, ga, ia, ra) => {
    switch (di == null || di(ca, pa, ga, ia, ra), pa) {
      case "highlightedValue":
        xo(ca, ga, ia);
        break;
      case "selectedValues":
        Ti == null || Ti(ca, ga, ia);
        break;
    }
  }, [xo, Ti, di]), Li = React.useMemo(() => ({
    disabledItemsFocusable: ir,
    disableListWrap: ti,
    focusManagement: ii,
    isItemDisabled: oi,
    itemComparer: gi,
    items: fi,
    getItemAsString: mi,
    onHighlightChange: xo,
    orientation: Si,
    pageSize: Pi,
    selectionMode: Oi,
    stateComparers: fo
  }), [ir, ti, ii, oi, gi, fi, mi, xo, Si, Pi, Oi, fo]), Co = ui(), Ni = Di ?? listReducer, Yi = React.useMemo(() => ({
    ...$i,
    ...Li
  }), [$i, Li]), [Vo, No] = useControllableReducer({
    reducer: Ni,
    actionContext: Yi,
    initialState: Co,
    controlledProps: yt,
    stateComparers: fo,
    onStateChange: _o,
    componentName: Mi
  }), {
    highlightedValue: Ui,
    selectedValues: jo
  } = Vo, Wi = useTextNavigation((ca, pa) => No({
    type: ListActionTypes.textNavigation,
    event: pa,
    searchString: ca
  })), ji = React.useRef([]);
  React.useEffect(() => {
    areArraysEqual(ji.current, fi, gi) || (No({
      type: ListActionTypes.itemsChange,
      event: null,
      items: fi,
      previousItems: ji.current
    }), ji.current = fi, xi == null || xi(fi));
  }, [fi, gi, No, xi]);
  const Hi = (ca) => (pa) => {
    var ga;
    if ((ga = ca.onKeyDown) == null || ga.call(ca, pa), pa.defaultMuiPrevented)
      return;
    const ia = ["Home", "End", "PageUp", "PageDown"];
    Si === "vertical" ? ia.push("ArrowUp", "ArrowDown") : ia.push("ArrowLeft", "ArrowRight"), ii === "activeDescendant" && ia.push(" ", "Enter"), ia.includes(pa.key) && pa.preventDefault(), No({
      type: ListActionTypes.keyDown,
      key: pa.key,
      event: pa
    }), Wi(pa);
  }, zo = (ca) => (pa) => {
    var ga, ia;
    (ga = ca.onBlur) == null || ga.call(ca, pa), !pa.defaultMuiPrevented && ((ia = Oo.current) != null && ia.contains(pa.relatedTarget) || No({
      type: ListActionTypes.blur,
      event: pa
    }));
  }, Lo = (ca = {}) => {
    const pa = extractEventHandlers$1(ca);
    return {
      ...ca,
      "aria-activedescendant": ii === "activeDescendant" && Ui != null ? li(Ui) : void 0,
      tabIndex: ii === "DOM" ? -1 : 0,
      ref: io,
      ...pa,
      onBlur: zo(pa),
      onKeyDown: Hi(pa)
    };
  }, sa = React.useCallback((ca) => {
    const pa = (jo ?? []).some((ia) => ia != null && gi(ca, ia)), ga = Ui != null && gi(ca, Ui);
    return {
      focusable: ii === "DOM",
      highlighted: ga,
      selected: pa
    };
  }, [gi, jo, Ui, ii]), Ko = React.useMemo(() => ({
    dispatch: No,
    getItemState: sa
  }), [No, sa]);
  return React.useDebugValue({
    state: Vo
  }), {
    contextValue: Ko,
    dispatch: No,
    getRootProps: Lo,
    rootRef: io,
    state: Vo
  };
}
const ListContext$1 = /* @__PURE__ */ React.createContext(null);
process.env.NODE_ENV !== "production" && (ListContext$1.displayName = "ListContext");
function useListItem(pt) {
  const {
    handlePointerOverEvents: yt = !1,
    item: ir
  } = pt, ti = React.useContext(ListContext$1);
  if (!ti)
    throw new Error("useListItem must be used within a ListProvider");
  const {
    dispatch: ii,
    getItemState: ui
  } = ti, {
    highlighted: ai,
    selected: li,
    focusable: oi
  } = ui(ir), si = React.useCallback((gi) => (mi) => {
    var Ti;
    if ((Ti = gi.onClick) == null || Ti.call(gi, mi), !mi.defaultPrevented) {
      if (process.env.NODE_ENV !== "production" && ir === void 0)
        throw new Error(["MUI: The `item` provided to useListItem() is undefined.", "This should happen only during server-side rendering under React 17."].join(`
`));
      ii({
        type: ListActionTypes.itemClick,
        item: ir,
        event: mi
      });
    }
  }, [ii, ir]), di = React.useCallback((gi) => (mi) => {
    var Ti;
    if ((Ti = gi.onMouseOver) == null || Ti.call(gi, mi), !mi.defaultPrevented) {
      if (process.env.NODE_ENV !== "production" && ir === void 0)
        throw new Error(["MUI: The `item` provided to useListItem() is undefined.", "This should happen only during server-side rendering under React 17."].join(`
`));
      ii({
        type: ListActionTypes.itemHover,
        item: ir,
        event: mi
      });
    }
  }, [ii, ir]);
  let fi;
  return oi && (fi = ai ? 0 : -1), {
    getRootProps: (gi = {}) => {
      const mi = extractEventHandlers$1(gi);
      return {
        ...gi,
        onClick: si(mi),
        onPointerOver: yt ? di(mi) : void 0,
        tabIndex: fi
      };
    },
    highlighted: ai,
    selected: li
  };
}
function menuReducer(pt, yt) {
  var ir, ti, ii;
  if (yt.type === ListActionTypes.itemHover)
    return {
      ...pt,
      highlightedValue: yt.item
    };
  const ui = listReducer(pt, yt);
  if (ui.highlightedValue === null && yt.context.items.length > 0)
    return {
      ...ui,
      highlightedValue: yt.context.items[0]
    };
  if (yt.type === ListActionTypes.keyDown && yt.event.key === "Escape")
    return {
      ...ui,
      open: !1
    };
  if (yt.type === ListActionTypes.blur && !((ir = yt.context.listboxRef.current) != null && ir.contains(yt.event.relatedTarget))) {
    const ai = (ti = yt.context.listboxRef.current) == null ? void 0 : ti.getAttribute("id"), li = (ii = yt.event.relatedTarget) == null ? void 0 : ii.getAttribute("aria-controls");
    return ai && li && ai === li ? ui : {
      ...ui,
      open: !1,
      highlightedValue: yt.context.items[0]
    };
  }
  return ui;
}
const CompoundComponentContext = /* @__PURE__ */ React.createContext(null);
process.env.NODE_ENV !== "production" && (CompoundComponentContext.displayName = "CompoundComponentContext");
function sortSubitems(pt) {
  const yt = Array.from(pt.keys()).map((ir) => {
    const ti = pt.get(ir);
    return {
      key: ir,
      subitem: ti
    };
  });
  return yt.sort((ir, ti) => {
    const ii = ir.subitem.ref.current, ui = ti.subitem.ref.current;
    return ii === null || ui === null || ii === ui ? 0 : ii.compareDocumentPosition(ui) & Node.DOCUMENT_POSITION_PRECEDING ? 1 : -1;
  }), new Map(yt.map((ir) => [ir.key, ir.subitem]));
}
function useCompoundParent() {
  const [pt, yt] = React.useState(/* @__PURE__ */ new Map()), ir = React.useRef(/* @__PURE__ */ new Set()), ti = React.useCallback(function(li) {
    ir.current.delete(li), yt((oi) => {
      const si = new Map(oi);
      return si.delete(li), si;
    });
  }, []), ii = React.useCallback(function(li, oi) {
    let si;
    return typeof li == "function" ? si = li(ir.current) : si = li, ir.current.add(si), yt((di) => {
      const fi = new Map(di);
      return fi.set(si, oi), fi;
    }), {
      id: si,
      deregister: () => ti(si)
    };
  }, [ti]), ui = React.useMemo(() => sortSubitems(pt), [pt]), ai = React.useCallback(function(li) {
    return Array.from(ui.keys()).indexOf(li);
  }, [ui]);
  return {
    contextValue: React.useMemo(() => ({
      getItemIndex: ai,
      registerItem: ii,
      totalSubitemCount: pt.size
    }), [ai, ii, pt.size]),
    subitems: ui
  };
}
function useCompoundItem(pt, yt) {
  const ir = React.useContext(CompoundComponentContext);
  if (ir === null)
    throw new Error("useCompoundItem must be used within a useCompoundParent");
  const {
    registerItem: ti
  } = ir, [ii, ui] = React.useState(typeof pt == "function" ? void 0 : pt);
  return useEnhancedEffect$1(() => {
    const {
      id: ai,
      deregister: li
    } = ti(pt, yt);
    return ui(ai), li;
  }, [ti, yt, pt]), {
    id: ii,
    index: ii !== void 0 ? ir.getItemIndex(ii) : -1,
    totalItemCount: ir.totalSubitemCount
  };
}
function combineHooksSlotProps(pt, yt) {
  return function(ir = {}) {
    const ti = {
      ...ir,
      ...pt(ir)
    };
    return {
      ...ti,
      ...yt(ti)
    };
  };
}
const FALLBACK_MENU_CONTEXT = {
  dispatch: () => {
  },
  registerPopup: () => {
  },
  state: {
    open: !0,
    changeReason: null
  },
  triggerElement: null
};
function useMenu(pt = {}) {
  const {
    listboxRef: yt,
    onItemsChange: ir,
    id: ti,
    disabledItemsFocusable: ii = !0,
    disableListWrap: ui = !1,
    autoFocus: ai = !0,
    componentName: li = "useMenu"
  } = pt, oi = React.useRef(null), si = useForkRef$1(oi, yt), di = useId$2(ti) ?? "", {
    state: {
      open: fi,
      changeReason: gi
    },
    dispatch: mi,
    triggerElement: Ti,
    registerPopup: vi
  } = React.useContext(DropdownContext) ?? FALLBACK_MENU_CONTEXT, xi = React.useRef(fi), {
    subitems: Si,
    contextValue: Pi
  } = useCompoundParent(), $i = React.useMemo(() => Array.from(Si.keys()), [Si]), Oi = React.useCallback((No) => {
    var Ui;
    return No == null ? null : ((Ui = Si.get(No)) == null ? void 0 : Ui.ref.current) ?? null;
  }, [Si]), Di = React.useCallback((No) => {
    var Ui;
    return ((Ui = Si == null ? void 0 : Si.get(No)) == null ? void 0 : Ui.disabled) || !1;
  }, [Si]), Mi = React.useCallback((No) => {
    var Ui, jo, Wi;
    return ((Ui = Si.get(No)) == null ? void 0 : Ui.label) || ((Wi = (jo = Si.get(No)) == null ? void 0 : jo.ref.current) == null ? void 0 : Wi.innerText);
  }, [Si]), Oo = React.useMemo(() => ({
    listboxRef: oi
  }), [oi]), {
    dispatch: io,
    getRootProps: xo,
    contextValue: fo,
    state: {
      highlightedValue: _o
    },
    rootRef: Li
  } = useList({
    disabledItemsFocusable: ii,
    disableListWrap: ui,
    focusManagement: "DOM",
    getItemDomElement: Oi,
    getInitialState: () => ({
      selectedValues: [],
      highlightedValue: null
    }),
    isItemDisabled: Di,
    items: $i,
    getItemAsString: Mi,
    rootRef: si,
    onItemsChange: ir,
    reducerActionContext: Oo,
    selectionMode: "none",
    stateReducer: menuReducer,
    componentName: li
  });
  useEnhancedEffect$1(() => {
    vi(di);
  }, [di, vi]), useEnhancedEffect$1(() => {
    fi && (gi == null ? void 0 : gi.type) === "keydown" && gi.key === "ArrowUp" && io({
      type: ListActionTypes.highlightLast,
      event: gi
    });
  }, [fi, gi, io]), React.useEffect(() => {
    var No, Ui, jo;
    fi && ai && _o && !xi.current && ((jo = (Ui = (No = Si.get(_o)) == null ? void 0 : No.ref) == null ? void 0 : Ui.current) == null || jo.focus());
  }, [fi, ai, _o, Si, $i]), React.useEffect(() => {
    var No, Ui, jo;
    (No = oi.current) != null && No.contains(document.activeElement) && _o !== null && ((jo = (Ui = Si == null ? void 0 : Si.get(_o)) == null ? void 0 : Ui.ref.current) == null || jo.focus());
  }, [_o, Si]);
  const Co = (No) => (Ui) => {
    var jo, Wi;
    (jo = No.onBlur) == null || jo.call(No, Ui), !Ui.defaultMuiPrevented && ((Wi = oi.current) != null && Wi.contains(Ui.relatedTarget) || Ui.relatedTarget === Ti || mi({
      type: DropdownActionTypes.blur,
      event: Ui
    }));
  }, Ni = (No) => (Ui) => {
    var jo;
    (jo = No.onKeyDown) == null || jo.call(No, Ui), !Ui.defaultMuiPrevented && Ui.key === "Escape" && mi({
      type: DropdownActionTypes.escapeKeyDown,
      event: Ui
    });
  }, Yi = (No = {}) => ({
    onBlur: Co(No),
    onKeyDown: Ni(No)
  }), Vo = (No = {}) => {
    const Ui = combineHooksSlotProps(Yi, xo), jo = extractEventHandlers$1(No);
    return {
      ...No,
      ...jo,
      ...Ui(jo),
      id: di,
      role: "menu"
    };
  };
  return React.useDebugValue({
    subitems: Si,
    highlightedValue: _o
  }), {
    contextValue: {
      ...Pi,
      ...fo
    },
    dispatch: io,
    getListboxProps: Vo,
    highlightedValue: _o,
    listboxRef: Li,
    menuItems: Si,
    open: fi,
    triggerElement: Ti
  };
}
function MenuProvider(pt) {
  const {
    value: yt,
    children: ir
  } = pt, {
    dispatch: ti,
    getItemIndex: ii,
    getItemState: ui,
    registerItem: ai,
    totalSubitemCount: li
  } = yt, oi = React.useMemo(() => ({
    dispatch: ti,
    getItemState: ui,
    getItemIndex: ii
  }), [ti, ii, ui]), si = React.useMemo(() => ({
    getItemIndex: ii,
    registerItem: ai,
    totalSubitemCount: li
  }), [ai, ii, li]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CompoundComponentContext.Provider, {
    value: si,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(ListContext$1.Provider, {
      value: oi,
      children: ir
    })
  });
}
const min$1 = Math.min, max$1 = Math.max, round$3 = Math.round, floor = Math.floor, createCoords = (pt) => ({
  x: pt,
  y: pt
}), oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, oppositeAlignmentMap = {
  start: "end",
  end: "start"
};
function clamp$2(pt, yt, ir) {
  return max$1(pt, min$1(yt, ir));
}
function evaluate(pt, yt) {
  return typeof pt == "function" ? pt(yt) : pt;
}
function getSide(pt) {
  return pt.split("-")[0];
}
function getAlignment(pt) {
  return pt.split("-")[1];
}
function getOppositeAxis(pt) {
  return pt === "x" ? "y" : "x";
}
function getAxisLength(pt) {
  return pt === "y" ? "height" : "width";
}
const yAxisSides = /* @__PURE__ */ new Set(["top", "bottom"]);
function getSideAxis(pt) {
  return yAxisSides.has(getSide(pt)) ? "y" : "x";
}
function getAlignmentAxis(pt) {
  return getOppositeAxis(getSideAxis(pt));
}
function getAlignmentSides(pt, yt, ir) {
  ir === void 0 && (ir = !1);
  const ti = getAlignment(pt), ii = getAlignmentAxis(pt), ui = getAxisLength(ii);
  let ai = ii === "x" ? ti === (ir ? "end" : "start") ? "right" : "left" : ti === "start" ? "bottom" : "top";
  return yt.reference[ui] > yt.floating[ui] && (ai = getOppositePlacement(ai)), [ai, getOppositePlacement(ai)];
}
function getExpandedPlacements(pt) {
  const yt = getOppositePlacement(pt);
  return [getOppositeAlignmentPlacement(pt), yt, getOppositeAlignmentPlacement(yt)];
}
function getOppositeAlignmentPlacement(pt) {
  return pt.replace(/start|end/g, (yt) => oppositeAlignmentMap[yt]);
}
const lrPlacement = ["left", "right"], rlPlacement = ["right", "left"], tbPlacement = ["top", "bottom"], btPlacement = ["bottom", "top"];
function getSideList(pt, yt, ir) {
  switch (pt) {
    case "top":
    case "bottom":
      return ir ? yt ? rlPlacement : lrPlacement : yt ? lrPlacement : rlPlacement;
    case "left":
    case "right":
      return yt ? tbPlacement : btPlacement;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(pt, yt, ir, ti) {
  const ii = getAlignment(pt);
  let ui = getSideList(getSide(pt), ir === "start", ti);
  return ii && (ui = ui.map((ai) => ai + "-" + ii), yt && (ui = ui.concat(ui.map(getOppositeAlignmentPlacement)))), ui;
}
function getOppositePlacement(pt) {
  return pt.replace(/left|right|bottom|top/g, (yt) => oppositeSideMap[yt]);
}
function expandPaddingObject(pt) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...pt
  };
}
function getPaddingObject(pt) {
  return typeof pt != "number" ? expandPaddingObject(pt) : {
    top: pt,
    right: pt,
    bottom: pt,
    left: pt
  };
}
function rectToClientRect(pt) {
  const {
    x: yt,
    y: ir,
    width: ti,
    height: ii
  } = pt;
  return {
    width: ti,
    height: ii,
    top: ir,
    left: yt,
    right: yt + ti,
    bottom: ir + ii,
    x: yt,
    y: ir
  };
}
function computeCoordsFromPlacement(pt, yt, ir) {
  let {
    reference: ti,
    floating: ii
  } = pt;
  const ui = getSideAxis(yt), ai = getAlignmentAxis(yt), li = getAxisLength(ai), oi = getSide(yt), si = ui === "y", di = ti.x + ti.width / 2 - ii.width / 2, fi = ti.y + ti.height / 2 - ii.height / 2, gi = ti[li] / 2 - ii[li] / 2;
  let mi;
  switch (oi) {
    case "top":
      mi = {
        x: di,
        y: ti.y - ii.height
      };
      break;
    case "bottom":
      mi = {
        x: di,
        y: ti.y + ti.height
      };
      break;
    case "right":
      mi = {
        x: ti.x + ti.width,
        y: fi
      };
      break;
    case "left":
      mi = {
        x: ti.x - ii.width,
        y: fi
      };
      break;
    default:
      mi = {
        x: ti.x,
        y: ti.y
      };
  }
  switch (getAlignment(yt)) {
    case "start":
      mi[ai] -= gi * (ir && si ? -1 : 1);
      break;
    case "end":
      mi[ai] += gi * (ir && si ? -1 : 1);
      break;
  }
  return mi;
}
const computePosition$1 = async (pt, yt, ir) => {
  const {
    placement: ti = "bottom",
    strategy: ii = "absolute",
    middleware: ui = [],
    platform: ai
  } = ir, li = ui.filter(Boolean), oi = await (ai.isRTL == null ? void 0 : ai.isRTL(yt));
  let si = await ai.getElementRects({
    reference: pt,
    floating: yt,
    strategy: ii
  }), {
    x: di,
    y: fi
  } = computeCoordsFromPlacement(si, ti, oi), gi = ti, mi = {}, Ti = 0;
  for (let vi = 0; vi < li.length; vi++) {
    const {
      name: xi,
      fn: Si
    } = li[vi], {
      x: Pi,
      y: $i,
      data: Oi,
      reset: Di
    } = await Si({
      x: di,
      y: fi,
      initialPlacement: ti,
      placement: gi,
      strategy: ii,
      middlewareData: mi,
      rects: si,
      platform: ai,
      elements: {
        reference: pt,
        floating: yt
      }
    });
    di = Pi ?? di, fi = $i ?? fi, mi = {
      ...mi,
      [xi]: {
        ...mi[xi],
        ...Oi
      }
    }, Di && Ti <= 50 && (Ti++, typeof Di == "object" && (Di.placement && (gi = Di.placement), Di.rects && (si = Di.rects === !0 ? await ai.getElementRects({
      reference: pt,
      floating: yt,
      strategy: ii
    }) : Di.rects), {
      x: di,
      y: fi
    } = computeCoordsFromPlacement(si, gi, oi)), vi = -1);
  }
  return {
    x: di,
    y: fi,
    placement: gi,
    strategy: ii,
    middlewareData: mi
  };
};
async function detectOverflow(pt, yt) {
  var ir;
  yt === void 0 && (yt = {});
  const {
    x: ti,
    y: ii,
    platform: ui,
    rects: ai,
    elements: li,
    strategy: oi
  } = pt, {
    boundary: si = "clippingAncestors",
    rootBoundary: di = "viewport",
    elementContext: fi = "floating",
    altBoundary: gi = !1,
    padding: mi = 0
  } = evaluate(yt, pt), Ti = getPaddingObject(mi), vi = li[gi ? fi === "floating" ? "reference" : "floating" : fi], xi = rectToClientRect(await ui.getClippingRect({
    element: (ir = await (ui.isElement == null ? void 0 : ui.isElement(vi))) == null || ir ? vi : vi.contextElement || await (ui.getDocumentElement == null ? void 0 : ui.getDocumentElement(li.floating)),
    boundary: si,
    rootBoundary: di,
    strategy: oi
  })), Si = fi === "floating" ? {
    x: ti,
    y: ii,
    width: ai.floating.width,
    height: ai.floating.height
  } : ai.reference, Pi = await (ui.getOffsetParent == null ? void 0 : ui.getOffsetParent(li.floating)), $i = await (ui.isElement == null ? void 0 : ui.isElement(Pi)) ? await (ui.getScale == null ? void 0 : ui.getScale(Pi)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, Oi = rectToClientRect(ui.convertOffsetParentRelativeRectToViewportRelativeRect ? await ui.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: li,
    rect: Si,
    offsetParent: Pi,
    strategy: oi
  }) : Si);
  return {
    top: (xi.top - Oi.top + Ti.top) / $i.y,
    bottom: (Oi.bottom - xi.bottom + Ti.bottom) / $i.y,
    left: (xi.left - Oi.left + Ti.left) / $i.x,
    right: (Oi.right - xi.right + Ti.right) / $i.x
  };
}
const flip$2 = function(pt) {
  return pt === void 0 && (pt = {}), {
    name: "flip",
    options: pt,
    async fn(yt) {
      var ir, ti;
      const {
        placement: ii,
        middlewareData: ui,
        rects: ai,
        initialPlacement: li,
        platform: oi,
        elements: si
      } = yt, {
        mainAxis: di = !0,
        crossAxis: fi = !0,
        fallbackPlacements: gi,
        fallbackStrategy: mi = "bestFit",
        fallbackAxisSideDirection: Ti = "none",
        flipAlignment: vi = !0,
        ...xi
      } = evaluate(pt, yt);
      if ((ir = ui.arrow) != null && ir.alignmentOffset)
        return {};
      const Si = getSide(ii), Pi = getSideAxis(li), $i = getSide(li) === li, Oi = await (oi.isRTL == null ? void 0 : oi.isRTL(si.floating)), Di = gi || ($i || !vi ? [getOppositePlacement(li)] : getExpandedPlacements(li)), Mi = Ti !== "none";
      !gi && Mi && Di.push(...getOppositeAxisPlacements(li, vi, Ti, Oi));
      const Oo = [li, ...Di], io = await detectOverflow(yt, xi), xo = [];
      let fo = ((ti = ui.flip) == null ? void 0 : ti.overflows) || [];
      if (di && xo.push(io[Si]), fi) {
        const Ni = getAlignmentSides(ii, ai, Oi);
        xo.push(io[Ni[0]], io[Ni[1]]);
      }
      if (fo = [...fo, {
        placement: ii,
        overflows: xo
      }], !xo.every((Ni) => Ni <= 0)) {
        var _o, Li;
        const Ni = (((_o = ui.flip) == null ? void 0 : _o.index) || 0) + 1, Yi = Oo[Ni];
        if (Yi && (!(fi === "alignment" && Pi !== getSideAxis(Yi)) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        fo.every((No) => No.overflows[0] > 0 && getSideAxis(No.placement) === Pi)))
          return {
            data: {
              index: Ni,
              overflows: fo
            },
            reset: {
              placement: Yi
            }
          };
        let Vo = (Li = fo.filter((No) => No.overflows[0] <= 0).sort((No, Ui) => No.overflows[1] - Ui.overflows[1])[0]) == null ? void 0 : Li.placement;
        if (!Vo)
          switch (mi) {
            case "bestFit": {
              var Co;
              const No = (Co = fo.filter((Ui) => {
                if (Mi) {
                  const jo = getSideAxis(Ui.placement);
                  return jo === Pi || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  jo === "y";
                }
                return !0;
              }).map((Ui) => [Ui.placement, Ui.overflows.filter((jo) => jo > 0).reduce((jo, Wi) => jo + Wi, 0)]).sort((Ui, jo) => Ui[1] - jo[1])[0]) == null ? void 0 : Co[0];
              No && (Vo = No);
              break;
            }
            case "initialPlacement":
              Vo = li;
              break;
          }
        if (ii !== Vo)
          return {
            reset: {
              placement: Vo
            }
          };
      }
      return {};
    }
  };
}, originSides = /* @__PURE__ */ new Set(["left", "top"]);
async function convertValueToCoords(pt, yt) {
  const {
    placement: ir,
    platform: ti,
    elements: ii
  } = pt, ui = await (ti.isRTL == null ? void 0 : ti.isRTL(ii.floating)), ai = getSide(ir), li = getAlignment(ir), oi = getSideAxis(ir) === "y", si = originSides.has(ai) ? -1 : 1, di = ui && oi ? -1 : 1, fi = evaluate(yt, pt);
  let {
    mainAxis: gi,
    crossAxis: mi,
    alignmentAxis: Ti
  } = typeof fi == "number" ? {
    mainAxis: fi,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: fi.mainAxis || 0,
    crossAxis: fi.crossAxis || 0,
    alignmentAxis: fi.alignmentAxis
  };
  return li && typeof Ti == "number" && (mi = li === "end" ? Ti * -1 : Ti), oi ? {
    x: mi * di,
    y: gi * si
  } : {
    x: gi * si,
    y: mi * di
  };
}
const offset$2 = function(pt) {
  return pt === void 0 && (pt = 0), {
    name: "offset",
    options: pt,
    async fn(yt) {
      var ir, ti;
      const {
        x: ii,
        y: ui,
        placement: ai,
        middlewareData: li
      } = yt, oi = await convertValueToCoords(yt, pt);
      return ai === ((ir = li.offset) == null ? void 0 : ir.placement) && (ti = li.arrow) != null && ti.alignmentOffset ? {} : {
        x: ii + oi.x,
        y: ui + oi.y,
        data: {
          ...oi,
          placement: ai
        }
      };
    }
  };
}, shift$2 = function(pt) {
  return pt === void 0 && (pt = {}), {
    name: "shift",
    options: pt,
    async fn(yt) {
      const {
        x: ir,
        y: ti,
        placement: ii
      } = yt, {
        mainAxis: ui = !0,
        crossAxis: ai = !1,
        limiter: li = {
          fn: (xi) => {
            let {
              x: Si,
              y: Pi
            } = xi;
            return {
              x: Si,
              y: Pi
            };
          }
        },
        ...oi
      } = evaluate(pt, yt), si = {
        x: ir,
        y: ti
      }, di = await detectOverflow(yt, oi), fi = getSideAxis(getSide(ii)), gi = getOppositeAxis(fi);
      let mi = si[gi], Ti = si[fi];
      if (ui) {
        const xi = gi === "y" ? "top" : "left", Si = gi === "y" ? "bottom" : "right", Pi = mi + di[xi], $i = mi - di[Si];
        mi = clamp$2(Pi, mi, $i);
      }
      if (ai) {
        const xi = fi === "y" ? "top" : "left", Si = fi === "y" ? "bottom" : "right", Pi = Ti + di[xi], $i = Ti - di[Si];
        Ti = clamp$2(Pi, Ti, $i);
      }
      const vi = li.fn({
        ...yt,
        [gi]: mi,
        [fi]: Ti
      });
      return {
        ...vi,
        data: {
          x: vi.x - ir,
          y: vi.y - ti,
          enabled: {
            [gi]: ui,
            [fi]: ai
          }
        }
      };
    }
  };
};
function hasWindow() {
  return typeof window < "u";
}
function getNodeName(pt) {
  return isNode(pt) ? (pt.nodeName || "").toLowerCase() : "#document";
}
function getWindow(pt) {
  var yt;
  return (pt == null || (yt = pt.ownerDocument) == null ? void 0 : yt.defaultView) || window;
}
function getDocumentElement(pt) {
  var yt;
  return (yt = (isNode(pt) ? pt.ownerDocument : pt.document) || window.document) == null ? void 0 : yt.documentElement;
}
function isNode(pt) {
  return hasWindow() ? pt instanceof Node || pt instanceof getWindow(pt).Node : !1;
}
function isElement(pt) {
  return hasWindow() ? pt instanceof Element || pt instanceof getWindow(pt).Element : !1;
}
function isHTMLElement(pt) {
  return hasWindow() ? pt instanceof HTMLElement || pt instanceof getWindow(pt).HTMLElement : !1;
}
function isShadowRoot(pt) {
  return !hasWindow() || typeof ShadowRoot > "u" ? !1 : pt instanceof ShadowRoot || pt instanceof getWindow(pt).ShadowRoot;
}
const invalidOverflowDisplayValues = /* @__PURE__ */ new Set(["inline", "contents"]);
function isOverflowElement(pt) {
  const {
    overflow: yt,
    overflowX: ir,
    overflowY: ti,
    display: ii
  } = getComputedStyle(pt);
  return /auto|scroll|overlay|hidden|clip/.test(yt + ti + ir) && !invalidOverflowDisplayValues.has(ii);
}
const tableElements = /* @__PURE__ */ new Set(["table", "td", "th"]);
function isTableElement(pt) {
  return tableElements.has(getNodeName(pt));
}
const topLayerSelectors = [":popover-open", ":modal"];
function isTopLayer(pt) {
  return topLayerSelectors.some((yt) => {
    try {
      return pt.matches(yt);
    } catch {
      return !1;
    }
  });
}
const transformProperties = ["transform", "translate", "scale", "rotate", "perspective"], willChangeValues = ["transform", "translate", "scale", "rotate", "perspective", "filter"], containValues = ["paint", "layout", "strict", "content"];
function isContainingBlock(pt) {
  const yt = isWebKit(), ir = isElement(pt) ? getComputedStyle(pt) : pt;
  return transformProperties.some((ti) => ir[ti] ? ir[ti] !== "none" : !1) || (ir.containerType ? ir.containerType !== "normal" : !1) || !yt && (ir.backdropFilter ? ir.backdropFilter !== "none" : !1) || !yt && (ir.filter ? ir.filter !== "none" : !1) || willChangeValues.some((ti) => (ir.willChange || "").includes(ti)) || containValues.some((ti) => (ir.contain || "").includes(ti));
}
function getContainingBlock(pt) {
  let yt = getParentNode(pt);
  for (; isHTMLElement(yt) && !isLastTraversableNode(yt); ) {
    if (isContainingBlock(yt))
      return yt;
    if (isTopLayer(yt))
      return null;
    yt = getParentNode(yt);
  }
  return null;
}
function isWebKit() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const lastTraversableNodeNames = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function isLastTraversableNode(pt) {
  return lastTraversableNodeNames.has(getNodeName(pt));
}
function getComputedStyle(pt) {
  return getWindow(pt).getComputedStyle(pt);
}
function getNodeScroll(pt) {
  return isElement(pt) ? {
    scrollLeft: pt.scrollLeft,
    scrollTop: pt.scrollTop
  } : {
    scrollLeft: pt.scrollX,
    scrollTop: pt.scrollY
  };
}
function getParentNode(pt) {
  if (getNodeName(pt) === "html")
    return pt;
  const yt = (
    // Step into the shadow DOM of the parent of a slotted node.
    pt.assignedSlot || // DOM Element detected.
    pt.parentNode || // ShadowRoot detected.
    isShadowRoot(pt) && pt.host || // Fallback.
    getDocumentElement(pt)
  );
  return isShadowRoot(yt) ? yt.host : yt;
}
function getNearestOverflowAncestor(pt) {
  const yt = getParentNode(pt);
  return isLastTraversableNode(yt) ? pt.ownerDocument ? pt.ownerDocument.body : pt.body : isHTMLElement(yt) && isOverflowElement(yt) ? yt : getNearestOverflowAncestor(yt);
}
function getOverflowAncestors(pt, yt, ir) {
  var ti;
  yt === void 0 && (yt = []), ir === void 0 && (ir = !0);
  const ii = getNearestOverflowAncestor(pt), ui = ii === ((ti = pt.ownerDocument) == null ? void 0 : ti.body), ai = getWindow(ii);
  if (ui) {
    const li = getFrameElement(ai);
    return yt.concat(ai, ai.visualViewport || [], isOverflowElement(ii) ? ii : [], li && ir ? getOverflowAncestors(li) : []);
  }
  return yt.concat(ii, getOverflowAncestors(ii, [], ir));
}
function getFrameElement(pt) {
  return pt.parent && Object.getPrototypeOf(pt.parent) ? pt.frameElement : null;
}
function getCssDimensions(pt) {
  const yt = getComputedStyle(pt);
  let ir = parseFloat(yt.width) || 0, ti = parseFloat(yt.height) || 0;
  const ii = isHTMLElement(pt), ui = ii ? pt.offsetWidth : ir, ai = ii ? pt.offsetHeight : ti, li = round$3(ir) !== ui || round$3(ti) !== ai;
  return li && (ir = ui, ti = ai), {
    width: ir,
    height: ti,
    $: li
  };
}
function unwrapElement(pt) {
  return isElement(pt) ? pt : pt.contextElement;
}
function getScale$1(pt) {
  const yt = unwrapElement(pt);
  if (!isHTMLElement(yt))
    return createCoords(1);
  const ir = yt.getBoundingClientRect(), {
    width: ti,
    height: ii,
    $: ui
  } = getCssDimensions(yt);
  let ai = (ui ? round$3(ir.width) : ir.width) / ti, li = (ui ? round$3(ir.height) : ir.height) / ii;
  return (!ai || !Number.isFinite(ai)) && (ai = 1), (!li || !Number.isFinite(li)) && (li = 1), {
    x: ai,
    y: li
  };
}
const noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(pt) {
  const yt = getWindow(pt);
  return !isWebKit() || !yt.visualViewport ? noOffsets : {
    x: yt.visualViewport.offsetLeft,
    y: yt.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(pt, yt, ir) {
  return yt === void 0 && (yt = !1), !ir || yt && ir !== getWindow(pt) ? !1 : yt;
}
function getBoundingClientRect(pt, yt, ir, ti) {
  yt === void 0 && (yt = !1), ir === void 0 && (ir = !1);
  const ii = pt.getBoundingClientRect(), ui = unwrapElement(pt);
  let ai = createCoords(1);
  yt && (ti ? isElement(ti) && (ai = getScale$1(ti)) : ai = getScale$1(pt));
  const li = shouldAddVisualOffsets(ui, ir, ti) ? getVisualOffsets(ui) : createCoords(0);
  let oi = (ii.left + li.x) / ai.x, si = (ii.top + li.y) / ai.y, di = ii.width / ai.x, fi = ii.height / ai.y;
  if (ui) {
    const gi = getWindow(ui), mi = ti && isElement(ti) ? getWindow(ti) : ti;
    let Ti = gi, vi = getFrameElement(Ti);
    for (; vi && ti && mi !== Ti; ) {
      const xi = getScale$1(vi), Si = vi.getBoundingClientRect(), Pi = getComputedStyle(vi), $i = Si.left + (vi.clientLeft + parseFloat(Pi.paddingLeft)) * xi.x, Oi = Si.top + (vi.clientTop + parseFloat(Pi.paddingTop)) * xi.y;
      oi *= xi.x, si *= xi.y, di *= xi.x, fi *= xi.y, oi += $i, si += Oi, Ti = getWindow(vi), vi = getFrameElement(Ti);
    }
  }
  return rectToClientRect({
    width: di,
    height: fi,
    x: oi,
    y: si
  });
}
function getWindowScrollBarX(pt, yt) {
  const ir = getNodeScroll(pt).scrollLeft;
  return yt ? yt.left + ir : getBoundingClientRect(getDocumentElement(pt)).left + ir;
}
function getHTMLOffset(pt, yt, ir) {
  ir === void 0 && (ir = !1);
  const ti = pt.getBoundingClientRect(), ii = ti.left + yt.scrollLeft - (ir ? 0 : (
    // RTL <body> scrollbar.
    getWindowScrollBarX(pt, ti)
  )), ui = ti.top + yt.scrollTop;
  return {
    x: ii,
    y: ui
  };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(pt) {
  let {
    elements: yt,
    rect: ir,
    offsetParent: ti,
    strategy: ii
  } = pt;
  const ui = ii === "fixed", ai = getDocumentElement(ti), li = yt ? isTopLayer(yt.floating) : !1;
  if (ti === ai || li && ui)
    return ir;
  let oi = {
    scrollLeft: 0,
    scrollTop: 0
  }, si = createCoords(1);
  const di = createCoords(0), fi = isHTMLElement(ti);
  if ((fi || !fi && !ui) && ((getNodeName(ti) !== "body" || isOverflowElement(ai)) && (oi = getNodeScroll(ti)), isHTMLElement(ti))) {
    const mi = getBoundingClientRect(ti);
    si = getScale$1(ti), di.x = mi.x + ti.clientLeft, di.y = mi.y + ti.clientTop;
  }
  const gi = ai && !fi && !ui ? getHTMLOffset(ai, oi, !0) : createCoords(0);
  return {
    width: ir.width * si.x,
    height: ir.height * si.y,
    x: ir.x * si.x - oi.scrollLeft * si.x + di.x + gi.x,
    y: ir.y * si.y - oi.scrollTop * si.y + di.y + gi.y
  };
}
function getClientRects(pt) {
  return Array.from(pt.getClientRects());
}
function getDocumentRect(pt) {
  const yt = getDocumentElement(pt), ir = getNodeScroll(pt), ti = pt.ownerDocument.body, ii = max$1(yt.scrollWidth, yt.clientWidth, ti.scrollWidth, ti.clientWidth), ui = max$1(yt.scrollHeight, yt.clientHeight, ti.scrollHeight, ti.clientHeight);
  let ai = -ir.scrollLeft + getWindowScrollBarX(pt);
  const li = -ir.scrollTop;
  return getComputedStyle(ti).direction === "rtl" && (ai += max$1(yt.clientWidth, ti.clientWidth) - ii), {
    width: ii,
    height: ui,
    x: ai,
    y: li
  };
}
function getViewportRect(pt, yt) {
  const ir = getWindow(pt), ti = getDocumentElement(pt), ii = ir.visualViewport;
  let ui = ti.clientWidth, ai = ti.clientHeight, li = 0, oi = 0;
  if (ii) {
    ui = ii.width, ai = ii.height;
    const si = isWebKit();
    (!si || si && yt === "fixed") && (li = ii.offsetLeft, oi = ii.offsetTop);
  }
  return {
    width: ui,
    height: ai,
    x: li,
    y: oi
  };
}
const absoluteOrFixed = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function getInnerBoundingClientRect(pt, yt) {
  const ir = getBoundingClientRect(pt, !0, yt === "fixed"), ti = ir.top + pt.clientTop, ii = ir.left + pt.clientLeft, ui = isHTMLElement(pt) ? getScale$1(pt) : createCoords(1), ai = pt.clientWidth * ui.x, li = pt.clientHeight * ui.y, oi = ii * ui.x, si = ti * ui.y;
  return {
    width: ai,
    height: li,
    x: oi,
    y: si
  };
}
function getClientRectFromClippingAncestor(pt, yt, ir) {
  let ti;
  if (yt === "viewport")
    ti = getViewportRect(pt, ir);
  else if (yt === "document")
    ti = getDocumentRect(getDocumentElement(pt));
  else if (isElement(yt))
    ti = getInnerBoundingClientRect(yt, ir);
  else {
    const ii = getVisualOffsets(pt);
    ti = {
      x: yt.x - ii.x,
      y: yt.y - ii.y,
      width: yt.width,
      height: yt.height
    };
  }
  return rectToClientRect(ti);
}
function hasFixedPositionAncestor(pt, yt) {
  const ir = getParentNode(pt);
  return ir === yt || !isElement(ir) || isLastTraversableNode(ir) ? !1 : getComputedStyle(ir).position === "fixed" || hasFixedPositionAncestor(ir, yt);
}
function getClippingElementAncestors(pt, yt) {
  const ir = yt.get(pt);
  if (ir)
    return ir;
  let ti = getOverflowAncestors(pt, [], !1).filter((li) => isElement(li) && getNodeName(li) !== "body"), ii = null;
  const ui = getComputedStyle(pt).position === "fixed";
  let ai = ui ? getParentNode(pt) : pt;
  for (; isElement(ai) && !isLastTraversableNode(ai); ) {
    const li = getComputedStyle(ai), oi = isContainingBlock(ai);
    !oi && li.position === "fixed" && (ii = null), (ui ? !oi && !ii : !oi && li.position === "static" && ii && absoluteOrFixed.has(ii.position) || isOverflowElement(ai) && !oi && hasFixedPositionAncestor(pt, ai)) ? ti = ti.filter((si) => si !== ai) : ii = li, ai = getParentNode(ai);
  }
  return yt.set(pt, ti), ti;
}
function getClippingRect(pt) {
  let {
    element: yt,
    boundary: ir,
    rootBoundary: ti,
    strategy: ii
  } = pt;
  const ui = [...ir === "clippingAncestors" ? isTopLayer(yt) ? [] : getClippingElementAncestors(yt, this._c) : [].concat(ir), ti], ai = ui[0], li = ui.reduce((oi, si) => {
    const di = getClientRectFromClippingAncestor(yt, si, ii);
    return oi.top = max$1(di.top, oi.top), oi.right = min$1(di.right, oi.right), oi.bottom = min$1(di.bottom, oi.bottom), oi.left = max$1(di.left, oi.left), oi;
  }, getClientRectFromClippingAncestor(yt, ai, ii));
  return {
    width: li.right - li.left,
    height: li.bottom - li.top,
    x: li.left,
    y: li.top
  };
}
function getDimensions(pt) {
  const {
    width: yt,
    height: ir
  } = getCssDimensions(pt);
  return {
    width: yt,
    height: ir
  };
}
function getRectRelativeToOffsetParent(pt, yt, ir) {
  const ti = isHTMLElement(yt), ii = getDocumentElement(yt), ui = ir === "fixed", ai = getBoundingClientRect(pt, !0, ui, yt);
  let li = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const oi = createCoords(0);
  function si() {
    oi.x = getWindowScrollBarX(ii);
  }
  if (ti || !ti && !ui)
    if ((getNodeName(yt) !== "body" || isOverflowElement(ii)) && (li = getNodeScroll(yt)), ti) {
      const mi = getBoundingClientRect(yt, !0, ui, yt);
      oi.x = mi.x + yt.clientLeft, oi.y = mi.y + yt.clientTop;
    } else ii && si();
  ui && !ti && ii && si();
  const di = ii && !ti && !ui ? getHTMLOffset(ii, li) : createCoords(0), fi = ai.left + li.scrollLeft - oi.x - di.x, gi = ai.top + li.scrollTop - oi.y - di.y;
  return {
    x: fi,
    y: gi,
    width: ai.width,
    height: ai.height
  };
}
function isStaticPositioned(pt) {
  return getComputedStyle(pt).position === "static";
}
function getTrueOffsetParent(pt, yt) {
  if (!isHTMLElement(pt) || getComputedStyle(pt).position === "fixed")
    return null;
  if (yt)
    return yt(pt);
  let ir = pt.offsetParent;
  return getDocumentElement(pt) === ir && (ir = ir.ownerDocument.body), ir;
}
function getOffsetParent(pt, yt) {
  const ir = getWindow(pt);
  if (isTopLayer(pt))
    return ir;
  if (!isHTMLElement(pt)) {
    let ii = getParentNode(pt);
    for (; ii && !isLastTraversableNode(ii); ) {
      if (isElement(ii) && !isStaticPositioned(ii))
        return ii;
      ii = getParentNode(ii);
    }
    return ir;
  }
  let ti = getTrueOffsetParent(pt, yt);
  for (; ti && isTableElement(ti) && isStaticPositioned(ti); )
    ti = getTrueOffsetParent(ti, yt);
  return ti && isLastTraversableNode(ti) && isStaticPositioned(ti) && !isContainingBlock(ti) ? ir : ti || getContainingBlock(pt) || ir;
}
const getElementRects = async function(pt) {
  const yt = this.getOffsetParent || getOffsetParent, ir = this.getDimensions, ti = await ir(pt.floating);
  return {
    reference: getRectRelativeToOffsetParent(pt.reference, await yt(pt.floating), pt.strategy),
    floating: {
      x: 0,
      y: 0,
      width: ti.width,
      height: ti.height
    }
  };
};
function isRTL(pt) {
  return getComputedStyle(pt).direction === "rtl";
}
const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale: getScale$1,
  isElement,
  isRTL
};
function rectsAreEqual(pt, yt) {
  return pt.x === yt.x && pt.y === yt.y && pt.width === yt.width && pt.height === yt.height;
}
function observeMove(pt, yt) {
  let ir = null, ti;
  const ii = getDocumentElement(pt);
  function ui() {
    var li;
    clearTimeout(ti), (li = ir) == null || li.disconnect(), ir = null;
  }
  function ai(li, oi) {
    li === void 0 && (li = !1), oi === void 0 && (oi = 1), ui();
    const si = pt.getBoundingClientRect(), {
      left: di,
      top: fi,
      width: gi,
      height: mi
    } = si;
    if (li || yt(), !gi || !mi)
      return;
    const Ti = floor(fi), vi = floor(ii.clientWidth - (di + gi)), xi = floor(ii.clientHeight - (fi + mi)), Si = floor(di), Pi = {
      rootMargin: -Ti + "px " + -vi + "px " + -xi + "px " + -Si + "px",
      threshold: max$1(0, min$1(1, oi)) || 1
    };
    let $i = !0;
    function Oi(Di) {
      const Mi = Di[0].intersectionRatio;
      if (Mi !== oi) {
        if (!$i)
          return ai();
        Mi ? ai(!1, Mi) : ti = setTimeout(() => {
          ai(!1, 1e-7);
        }, 1e3);
      }
      Mi === 1 && !rectsAreEqual(si, pt.getBoundingClientRect()) && ai(), $i = !1;
    }
    try {
      ir = new IntersectionObserver(Oi, {
        ...Pi,
        // Handle <iframe>s
        root: ii.ownerDocument
      });
    } catch {
      ir = new IntersectionObserver(Oi, Pi);
    }
    ir.observe(pt);
  }
  return ai(!0), ui;
}
function autoUpdate(pt, yt, ir, ti) {
  ti === void 0 && (ti = {});
  const {
    ancestorScroll: ii = !0,
    ancestorResize: ui = !0,
    elementResize: ai = typeof ResizeObserver == "function",
    layoutShift: li = typeof IntersectionObserver == "function",
    animationFrame: oi = !1
  } = ti, si = unwrapElement(pt), di = ii || ui ? [...si ? getOverflowAncestors(si) : [], ...getOverflowAncestors(yt)] : [];
  di.forEach((Si) => {
    ii && Si.addEventListener("scroll", ir, {
      passive: !0
    }), ui && Si.addEventListener("resize", ir);
  });
  const fi = si && li ? observeMove(si, ir) : null;
  let gi = -1, mi = null;
  ai && (mi = new ResizeObserver((Si) => {
    let [Pi] = Si;
    Pi && Pi.target === si && mi && (mi.unobserve(yt), cancelAnimationFrame(gi), gi = requestAnimationFrame(() => {
      var $i;
      ($i = mi) == null || $i.observe(yt);
    })), ir();
  }), si && !oi && mi.observe(si), mi.observe(yt));
  let Ti, vi = oi ? getBoundingClientRect(pt) : null;
  oi && xi();
  function xi() {
    const Si = getBoundingClientRect(pt);
    vi && !rectsAreEqual(vi, Si) && ir(), vi = Si, Ti = requestAnimationFrame(xi);
  }
  return ir(), () => {
    var Si;
    di.forEach((Pi) => {
      ii && Pi.removeEventListener("scroll", ir), ui && Pi.removeEventListener("resize", ir);
    }), fi == null || fi(), (Si = mi) == null || Si.disconnect(), mi = null, oi && cancelAnimationFrame(Ti);
  };
}
const offset$1 = offset$2, shift$1 = shift$2, flip$1 = flip$2, computePosition = (pt, yt, ir) => {
  const ti = /* @__PURE__ */ new Map(), ii = {
    platform,
    ...ir
  }, ui = {
    ...ii.platform,
    _c: ti
  };
  return computePosition$1(pt, yt, {
    ...ii,
    platform: ui
  });
};
var isClient = typeof document < "u", noop$6 = function() {
}, index = isClient ? useLayoutEffect : noop$6;
function deepEqual(pt, yt) {
  if (pt === yt)
    return !0;
  if (typeof pt != typeof yt)
    return !1;
  if (typeof pt == "function" && pt.toString() === yt.toString())
    return !0;
  let ir, ti, ii;
  if (pt && yt && typeof pt == "object") {
    if (Array.isArray(pt)) {
      if (ir = pt.length, ir !== yt.length) return !1;
      for (ti = ir; ti-- !== 0; )
        if (!deepEqual(pt[ti], yt[ti]))
          return !1;
      return !0;
    }
    if (ii = Object.keys(pt), ir = ii.length, ir !== Object.keys(yt).length)
      return !1;
    for (ti = ir; ti-- !== 0; )
      if (!{}.hasOwnProperty.call(yt, ii[ti]))
        return !1;
    for (ti = ir; ti-- !== 0; ) {
      const ui = ii[ti];
      if (!(ui === "_owner" && pt.$$typeof) && !deepEqual(pt[ui], yt[ui]))
        return !1;
    }
    return !0;
  }
  return pt !== pt && yt !== yt;
}
function getDPR(pt) {
  return typeof window > "u" ? 1 : (pt.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function roundByDPR(pt, yt) {
  const ir = getDPR(pt);
  return Math.round(yt * ir) / ir;
}
function useLatestRef(pt) {
  const yt = React.useRef(pt);
  return index(() => {
    yt.current = pt;
  }), yt;
}
function useFloating(pt) {
  pt === void 0 && (pt = {});
  const {
    placement: yt = "bottom",
    strategy: ir = "absolute",
    middleware: ti = [],
    platform: ii,
    elements: {
      reference: ui,
      floating: ai
    } = {},
    transform: li = !0,
    whileElementsMounted: oi,
    open: si
  } = pt, [di, fi] = React.useState({
    x: 0,
    y: 0,
    strategy: ir,
    placement: yt,
    middlewareData: {},
    isPositioned: !1
  }), [gi, mi] = React.useState(ti);
  deepEqual(gi, ti) || mi(ti);
  const [Ti, vi] = React.useState(null), [xi, Si] = React.useState(null), Pi = React.useCallback((Ui) => {
    Ui !== Mi.current && (Mi.current = Ui, vi(Ui));
  }, []), $i = React.useCallback((Ui) => {
    Ui !== Oo.current && (Oo.current = Ui, Si(Ui));
  }, []), Oi = ui || Ti, Di = ai || xi, Mi = React.useRef(null), Oo = React.useRef(null), io = React.useRef(di), xo = oi != null, fo = useLatestRef(oi), _o = useLatestRef(ii), Li = useLatestRef(si), Co = React.useCallback(() => {
    if (!Mi.current || !Oo.current)
      return;
    const Ui = {
      placement: yt,
      strategy: ir,
      middleware: gi
    };
    _o.current && (Ui.platform = _o.current), computePosition(Mi.current, Oo.current, Ui).then((jo) => {
      const Wi = {
        ...jo,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: Li.current !== !1
      };
      Ni.current && !deepEqual(io.current, Wi) && (io.current = Wi, ReactDOM.flushSync(() => {
        fi(Wi);
      }));
    });
  }, [gi, yt, ir, _o, Li]);
  index(() => {
    si === !1 && io.current.isPositioned && (io.current.isPositioned = !1, fi((Ui) => ({
      ...Ui,
      isPositioned: !1
    })));
  }, [si]);
  const Ni = React.useRef(!1);
  index(() => (Ni.current = !0, () => {
    Ni.current = !1;
  }), []), index(() => {
    if (Oi && (Mi.current = Oi), Di && (Oo.current = Di), Oi && Di) {
      if (fo.current)
        return fo.current(Oi, Di, Co);
      Co();
    }
  }, [Oi, Di, Co, fo, xo]);
  const Yi = React.useMemo(() => ({
    reference: Mi,
    floating: Oo,
    setReference: Pi,
    setFloating: $i
  }), [Pi, $i]), Vo = React.useMemo(() => ({
    reference: Oi,
    floating: Di
  }), [Oi, Di]), No = React.useMemo(() => {
    const Ui = {
      position: ir,
      left: 0,
      top: 0
    };
    if (!Vo.floating)
      return Ui;
    const jo = roundByDPR(Vo.floating, di.x), Wi = roundByDPR(Vo.floating, di.y);
    return li ? {
      ...Ui,
      transform: "translate(" + jo + "px, " + Wi + "px)",
      ...getDPR(Vo.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: ir,
      left: jo,
      top: Wi
    };
  }, [ir, li, Vo.floating, di.x, di.y]);
  return React.useMemo(() => ({
    ...di,
    update: Co,
    refs: Yi,
    elements: Vo,
    floatingStyles: No
  }), [di, Co, Yi, Vo, No]);
}
const offset = (pt, yt) => ({
  ...offset$1(pt),
  options: [pt, yt]
}), shift = (pt, yt) => ({
  ...shift$1(pt),
  options: [pt, yt]
}), flip = (pt, yt) => ({
  ...flip$1(pt),
  options: [pt, yt]
});
function getContainer$3(pt) {
  return typeof pt == "function" ? pt() : pt;
}
const Portal$1 = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const {
    children: ir,
    container: ti,
    disablePortal: ii = !1
  } = pt, [ui, ai] = React.useState(null), li = useForkRef$1(/* @__PURE__ */ React.isValidElement(ir) ? getReactElementRef$1(ir) : null, yt);
  if (useEnhancedEffect$1(() => {
    ii || ai(getContainer$3(ti) || document.body);
  }, [ti, ii]), useEnhancedEffect$1(() => {
    if (ui && !ii)
      return setRef$1(yt, ui), () => {
        setRef$1(yt, null);
      };
  }, [yt, ui, ii]), ii) {
    if (/* @__PURE__ */ React.isValidElement(ir)) {
      const oi = {
        ref: li
      };
      return /* @__PURE__ */ React.cloneElement(ir, oi);
    }
    return ir;
  }
  return ui && /* @__PURE__ */ ReactDOM.createPortal(ir, ui);
});
process.env.NODE_ENV !== "production" && (Portal$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: PropTypes.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType$1, PropTypes.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool
});
process.env.NODE_ENV !== "production" && (Portal$1.propTypes = exactProp$1(Portal$1.propTypes));
const COMPONENT_NAME$8 = "Popup";
function getPopupUtilityClass(pt) {
  return generateUtilityClass$1(COMPONENT_NAME$8, pt);
}
generateUtilityClasses$1(COMPONENT_NAME$8, ["root", "open"]);
const TransitionContext = /* @__PURE__ */ React.createContext(null);
process.env.NODE_ENV !== "production" && (TransitionContext.displayName = "TransitionContext");
function useTransitionTrigger(pt) {
  const [yt, ir] = React.useState(!0), ti = React.useRef(!1), ii = React.useRef(0), [ui, ai] = React.useState(!1), li = React.useRef(pt);
  React.useEffect(() => {
    !pt && // checking registeredTransitions.current instead of hasTransition to avoid this effect re-firing whenever hasTransition changes
    ii.current > 0 && // prevents waiting for a pending transition right after mounting
    li.current !== pt && (ti.current = !0, ir(!1)), li.current = pt;
  }, [pt]);
  const oi = React.useCallback(() => {
    ti.current = !1, ir(!0);
  }, []), si = React.useCallback(() => (ii.current += 1, ai(!0), () => {
    ii.current -= 1, ii.current === 0 && ai(!1);
  }), []);
  let di;
  return ui ? pt ? di = !1 : di = !ti.current && yt : di = !pt, {
    contextValue: React.useMemo(() => ({
      requestedEnter: pt,
      onExited: oi,
      registerTransition: si,
      hasExited: di
    }), [oi, pt, si, di]),
    hasExited: di
  };
}
const PopupContext = /* @__PURE__ */ React.createContext(null);
process.env.NODE_ENV !== "production" && (PopupContext.displayName = "PopupContext");
function useUtilityClasses$F(pt) {
  const {
    open: yt
  } = pt;
  return composeClasses$1({
    root: ["root", yt && "open"]
  }, useClassNamesOverride(getPopupUtilityClass));
}
function resolveAnchor(pt) {
  return typeof pt == "function" ? pt() : pt;
}
const Popup = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const {
    anchor: ir,
    children: ti,
    container: ii,
    disablePortal: ui = !1,
    keepMounted: ai = !1,
    middleware: li,
    offset: oi = 0,
    open: si = !1,
    placement: di = "bottom",
    slotProps: fi = {},
    slots: gi = {},
    strategy: mi = "absolute",
    ...Ti
  } = pt, {
    refs: vi,
    elements: xi,
    floatingStyles: Si,
    update: Pi,
    placement: $i
  } = useFloating({
    elements: {
      reference: resolveAnchor(ir)
    },
    open: si,
    middleware: li ?? [offset(oi ?? 0), flip(), shift()],
    placement: di,
    strategy: mi,
    whileElementsMounted: ai ? void 0 : autoUpdate
  }), Oi = useForkRef$1(vi.setFloating, yt);
  useEnhancedEffect$1(() => {
    if (ai && si && xi.reference && xi.floating)
      return autoUpdate(xi.reference, xi.floating, Pi);
  }, [ai, si, xi, Pi]);
  const Di = {
    ...pt,
    disablePortal: ui,
    keepMounted: ai,
    offset,
    open: si,
    placement: di,
    finalPlacement: $i,
    strategy: mi
  }, {
    contextValue: Mi,
    hasExited: Oo
  } = useTransitionTrigger(si), io = ai && Oo ? "hidden" : void 0, xo = useUtilityClasses$F(Di), fo = (gi == null ? void 0 : gi.root) ?? "div", _o = useSlotProps$1({
    elementType: fo,
    externalSlotProps: fi.root,
    externalForwardedProps: Ti,
    ownerState: Di,
    className: xo.root,
    additionalProps: {
      ref: Oi,
      role: "tooltip",
      style: {
        ...Si,
        visibility: io
      }
    }
  }), Li = React.useMemo(() => ({
    placement: $i
  }), [$i]);
  return ai || !Oo ? /* @__PURE__ */ jsxRuntimeExports.jsx(Portal$1, {
    disablePortal: ui,
    container: ii,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(PopupContext.Provider, {
      value: Li,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(TransitionContext.Provider, {
        value: Mi,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(fo, {
          ..._o,
          children: ti
        })
      })
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (Popup.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtual element](https://floating-ui.com/docs/virtual-elements),
   * or a function that returns either.
   * It's used to set the position of the popup.
   */
  anchor: PropTypes.oneOfType([HTMLElementType$1, PropTypes.object, PropTypes.func]),
  /**
   * @ignore
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /**
   * An HTML element or function that returns one. The container will have the portal children appended to it.
   * By default, it uses the body of the top-level document object, so it's `document.body` in these cases.
   */
  container: PropTypes.oneOfType([HTMLElementType$1, PropTypes.func]),
  /**
   * If `true`, the popup will be rendered where it is defined, without the use of portals.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * If `true`, the popup will exist in the DOM even if it's closed.
   * Its visibility will be controlled by the `visibility` CSS property.
   *
   * Otherwise, a closed popup will be removed from the DOM.
   *
   * @default false
   */
  keepMounted: PropTypes.bool,
  /**
   * Collection of Floating UI middleware to use when positioning the popup.
   * If not provided, the [`offset`](https://floating-ui.com/docs/offset)
   * and [`flip`](https://floating-ui.com/docs/flip) functions will be used.
   *
   * @see https://floating-ui.com/docs/computePosition#middleware
   */
  middleware: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([!1]), PropTypes.shape({
    fn: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    options: PropTypes.any
  })])),
  /**
   * Distance between a popup and the trigger element.
   * This prop is ignored when custom `middleware` is provided.
   *
   * @default 0
   * @see https://floating-ui.com/docs/offset
   */
  offset: PropTypes.oneOfType([PropTypes.func, PropTypes.number, PropTypes.shape({
    alignmentAxis: PropTypes.number,
    crossAxis: PropTypes.number,
    mainAxis: PropTypes.number
  })]),
  /**
   * If `true`, the popup is visible.
   *
   * @default false
   */
  open: PropTypes.bool,
  /**
   * Determines where to place the popup relative to the trigger element.
   *
   * @default 'bottom'
   * @see https://floating-ui.com/docs/computePosition#placement
   */
  placement: PropTypes.oneOf(["bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * The props used for each slot inside the Popup.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Popup.
   * Either a string to use a HTML element or a component.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * The type of CSS position property to use (absolute or fixed).
   *
   * @default 'absolute'
   * @see https://floating-ui.com/docs/computePosition#strategy
   */
  strategy: PropTypes.oneOf(["absolute", "fixed"])
});
function useUtilityClasses$E(pt) {
  const {
    open: yt
  } = pt;
  return composeClasses$1({
    root: ["root", yt && "expanded"],
    listbox: ["listbox", yt && "expanded"]
  }, useClassNamesOverride(getMenuUtilityClass$1));
}
const Menu$1 = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const {
    actions: ir,
    anchor: ti,
    children: ii,
    onItemsChange: ui,
    slotProps: ai = {},
    slots: li = {},
    ...oi
  } = pt, {
    contextValue: si,
    getListboxProps: di,
    dispatch: fi,
    open: gi,
    triggerElement: mi
  } = useMenu({
    onItemsChange: ui,
    componentName: "Menu"
  }), Ti = ti ?? mi;
  React.useImperativeHandle(ir, () => ({
    dispatch: fi,
    resetHighlight: () => fi({
      type: ListActionTypes.resetHighlight,
      event: null
    })
  }), [fi]);
  const vi = {
    ...pt,
    open: gi
  }, xi = useUtilityClasses$E(vi), Si = li.root ?? "div", Pi = useSlotProps$1({
    elementType: Si,
    externalSlotProps: ai.root,
    externalForwardedProps: oi,
    additionalProps: {
      ref: yt,
      role: void 0
    },
    className: xi.root,
    ownerState: vi
  }), $i = li.listbox ?? "ul", Oi = useSlotProps$1({
    elementType: $i,
    getSlotProps: di,
    externalSlotProps: ai.listbox,
    className: xi.listbox,
    ownerState: vi
  });
  return gi === !0 && Ti == null ? /* @__PURE__ */ jsxRuntimeExports.jsx(Si, {
    ...Pi,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx($i, {
      ...Oi,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuProvider, {
        value: si,
        children: ii
      })
    })
  }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Popup, {
    keepMounted: !0,
    ...Pi,
    open: gi,
    anchor: Ti,
    slots: {
      root: Si
    },
    children: /* @__PURE__ */ jsxRuntimeExports.jsx($i, {
      ...Oi,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuProvider, {
        value: si,
        children: ii
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (Menu$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref with imperative actions that can be performed on the menu.
   */
  actions: refType$1,
  /**
   * The element based on which the menu is positioned.
   */
  anchor: PropTypes.oneOfType([HTMLElementType$1, PropTypes.object, PropTypes.func]),
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * Function called when the items displayed in the menu change.
   */
  onItemsChange: PropTypes.func,
  /**
   * The props used for each slot inside the Menu.
   * @default {}
   */
  slotProps: PropTypes.shape({
    listbox: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Menu.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    listbox: PropTypes.elementType,
    root: PropTypes.elementType
  })
});
function useMenuButton(pt = {}) {
  const {
    disabled: yt = !1,
    focusableWhenDisabled: ir,
    rootRef: ti
  } = pt, ii = React.useContext(DropdownContext);
  if (ii === null)
    throw new Error("useMenuButton: no menu context available.");
  const {
    state: ui,
    dispatch: ai,
    registerTrigger: li,
    popupId: oi
  } = ii, {
    getRootProps: si,
    rootRef: di,
    active: fi
  } = useButton({
    disabled: yt,
    focusableWhenDisabled: ir,
    rootRef: ti
  }), gi = useForkRef$1(di, li), mi = (xi) => (Si) => {
    var Pi;
    (Pi = xi.onClick) == null || Pi.call(xi, Si), !Si.defaultMuiPrevented && ai({
      type: DropdownActionTypes.toggle,
      event: Si
    });
  }, Ti = (xi) => (Si) => {
    var Pi;
    (Pi = xi.onKeyDown) == null || Pi.call(xi, Si), !Si.defaultMuiPrevented && (Si.key === "ArrowDown" || Si.key === "ArrowUp") && (Si.preventDefault(), ai({
      type: DropdownActionTypes.open,
      event: Si
    }));
  }, vi = (xi = {}) => ({
    onClick: mi(xi),
    onKeyDown: Ti(xi)
  });
  return {
    active: fi,
    getRootProps: (xi = {}) => {
      const Si = extractEventHandlers$1(xi), Pi = combineHooksSlotProps(vi, si);
      return {
        "aria-haspopup": "menu",
        "aria-expanded": ui.open,
        "aria-controls": oi,
        ...xi,
        ...Si,
        ...Pi(Si),
        tabIndex: 0,
        // this is needed to make the button focused after click in Safari
        ref: gi
      };
    },
    open: ui.open,
    rootRef: gi
  };
}
const COMPONENT_NAME$7 = "MenuButton";
function getMenuButtonUtilityClass(pt) {
  return generateUtilityClass$1(COMPONENT_NAME$7, pt);
}
generateUtilityClasses$1(COMPONENT_NAME$7, ["root", "active", "disabled", "expanded"]);
const useUtilityClasses$D = (pt) => {
  const {
    active: yt,
    disabled: ir,
    open: ti
  } = pt;
  return composeClasses$1({
    root: ["root", ir && "disabled", yt && "active", ti && "expanded"]
  }, useClassNamesOverride(getMenuButtonUtilityClass));
}, MenuButton = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const {
    children: ir,
    disabled: ti = !1,
    label: ii,
    slots: ui = {},
    slotProps: ai = {},
    focusableWhenDisabled: li = !1,
    ...oi
  } = pt, {
    getRootProps: si,
    open: di,
    active: fi
  } = useMenuButton({
    disabled: ti,
    focusableWhenDisabled: li,
    rootRef: yt
  }), gi = {
    ...pt,
    open: di,
    active: fi,
    disabled: ti,
    focusableWhenDisabled: li
  }, mi = useUtilityClasses$D(gi), Ti = ui.root || "button", vi = useSlotProps$1({
    elementType: Ti,
    getSlotProps: si,
    externalForwardedProps: oi,
    externalSlotProps: ai.root,
    additionalProps: {
      ref: yt,
      type: "button"
    },
    ownerState: gi,
    className: mi.root
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Ti, {
    ...vi,
    children: ir
  });
});
process.env.NODE_ENV !== "production" && (MenuButton.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * Class name applied to the root element.
   */
  className: PropTypes.string,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, allows a disabled button to receive focus.
   * @default false
   */
  focusableWhenDisabled: PropTypes.bool,
  /**
   * Label of the button
   */
  label: PropTypes.string,
  /**
   * The components used for each slot inside the MenuButton.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The props used for each slot inside the MenuButton.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  })
});
function isOverflowing$1(pt) {
  const yt = ownerDocument$1(pt);
  return yt.body === pt ? ownerWindow$1(pt).innerWidth > yt.documentElement.clientWidth : pt.scrollHeight > pt.clientHeight;
}
function ariaHidden$1(pt, yt) {
  yt ? pt.setAttribute("aria-hidden", "true") : pt.removeAttribute("aria-hidden");
}
function getPaddingRight$1(pt) {
  return parseInt(ownerWindow$1(pt).getComputedStyle(pt).paddingRight, 10) || 0;
}
function isAriaHiddenForbiddenOnElement$1(pt) {
  const yt = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].includes(pt.tagName), ir = pt.tagName === "INPUT" && pt.getAttribute("type") === "hidden";
  return yt || ir;
}
function ariaHiddenSiblings$1(pt, yt, ir, ti, ii) {
  const ui = [yt, ir, ...ti];
  [].forEach.call(pt.children, (ai) => {
    const li = !ui.includes(ai), oi = !isAriaHiddenForbiddenOnElement$1(ai);
    li && oi && ariaHidden$1(ai, ii);
  });
}
function findIndexOf$1(pt, yt) {
  let ir = -1;
  return pt.some((ti, ii) => yt(ti) ? (ir = ii, !0) : !1), ir;
}
function handleContainer$1(pt, yt) {
  const ir = [], ti = pt.container;
  if (!yt.disableScrollLock) {
    if (isOverflowing$1(ti)) {
      const ui = getScrollbarSize$1(ownerWindow$1(ti));
      ir.push({
        value: ti.style.paddingRight,
        property: "padding-right",
        el: ti
      }), ti.style.paddingRight = `${getPaddingRight$1(ti) + ui}px`;
      const ai = ownerDocument$1(ti).querySelectorAll(".mui-fixed");
      [].forEach.call(ai, (li) => {
        ir.push({
          value: li.style.paddingRight,
          property: "padding-right",
          el: li
        }), li.style.paddingRight = `${getPaddingRight$1(li) + ui}px`;
      });
    }
    let ii;
    if (ti.parentNode instanceof DocumentFragment)
      ii = ownerDocument$1(ti).body;
    else {
      const ui = ti.parentElement, ai = ownerWindow$1(ti);
      ii = (ui == null ? void 0 : ui.nodeName) === "HTML" && ai.getComputedStyle(ui).overflowY === "scroll" ? ui : ti;
    }
    ir.push({
      value: ii.style.overflow,
      property: "overflow",
      el: ii
    }, {
      value: ii.style.overflowX,
      property: "overflow-x",
      el: ii
    }, {
      value: ii.style.overflowY,
      property: "overflow-y",
      el: ii
    }), ii.style.overflow = "hidden";
  }
  return () => {
    ir.forEach(({
      value: ii,
      el: ui,
      property: ai
    }) => {
      ii ? ui.style.setProperty(ai, ii) : ui.style.removeProperty(ai);
    });
  };
}
function getHiddenSiblings$1(pt) {
  const yt = [];
  return [].forEach.call(pt.children, (ir) => {
    ir.getAttribute("aria-hidden") === "true" && yt.push(ir);
  }), yt;
}
let ModalManager$1 = class {
  constructor() {
    this.modals = [], this.containers = [];
  }
  add(pt, yt) {
    let ir = this.modals.indexOf(pt);
    if (ir !== -1)
      return ir;
    ir = this.modals.length, this.modals.push(pt), pt.modalRef && ariaHidden$1(pt.modalRef, !1);
    const ti = getHiddenSiblings$1(yt);
    ariaHiddenSiblings$1(yt, pt.mount, pt.modalRef, ti, !0);
    const ii = findIndexOf$1(this.containers, (ui) => ui.container === yt);
    return ii !== -1 ? (this.containers[ii].modals.push(pt), ir) : (this.containers.push({
      modals: [pt],
      container: yt,
      restore: null,
      hiddenSiblings: ti
    }), ir);
  }
  mount(pt, yt) {
    const ir = findIndexOf$1(this.containers, (ii) => ii.modals.includes(pt)), ti = this.containers[ir];
    ti.restore || (ti.restore = handleContainer$1(ti, yt));
  }
  remove(pt, yt = !0) {
    const ir = this.modals.indexOf(pt);
    if (ir === -1)
      return ir;
    const ti = findIndexOf$1(this.containers, (ui) => ui.modals.includes(pt)), ii = this.containers[ti];
    if (ii.modals.splice(ii.modals.indexOf(pt), 1), this.modals.splice(ir, 1), ii.modals.length === 0)
      ii.restore && ii.restore(), pt.modalRef && ariaHidden$1(pt.modalRef, yt), ariaHiddenSiblings$1(ii.container, pt.mount, pt.modalRef, ii.hiddenSiblings, !1), this.containers.splice(ti, 1);
    else {
      const ui = ii.modals[ii.modals.length - 1];
      ui.modalRef && ariaHidden$1(ui.modalRef, !1);
    }
    return ir;
  }
  isTopModal(pt) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === pt;
  }
};
function getContainer$2(pt) {
  return typeof pt == "function" ? pt() : pt;
}
function getHasTransition$1(pt) {
  return pt ? pt.props.hasOwnProperty("in") : !1;
}
const defaultManager = new ModalManager$1();
function useModal$1(pt) {
  const {
    container: yt,
    disableEscapeKeyDown: ir = !1,
    disableScrollLock: ti = !1,
    // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager: ii = defaultManager,
    closeAfterTransition: ui = !1,
    onTransitionEnter: ai,
    onTransitionExited: li,
    children: oi,
    onClose: si,
    open: di,
    rootRef: fi
  } = pt, gi = React.useRef({}), mi = React.useRef(null), Ti = React.useRef(null), vi = useForkRef$1(Ti, fi), [xi, Si] = React.useState(!di), Pi = getHasTransition$1(oi);
  let $i = !0;
  (pt["aria-hidden"] === "false" || pt["aria-hidden"] === !1) && ($i = !1);
  const Oi = () => ownerDocument$1(mi.current), Di = () => (gi.current.modalRef = Ti.current, gi.current.mount = mi.current, gi.current), Mi = () => {
    ii.mount(Di(), {
      disableScrollLock: ti
    }), Ti.current && (Ti.current.scrollTop = 0);
  }, Oo = useEventCallback$1(() => {
    const Co = getContainer$2(yt) || Oi().body;
    ii.add(Di(), Co), Ti.current && Mi();
  }), io = React.useCallback(() => ii.isTopModal(Di()), [ii]), xo = useEventCallback$1((Co) => {
    mi.current = Co, Co && (di && io() ? Mi() : Ti.current && ariaHidden$1(Ti.current, $i));
  }), fo = React.useCallback(() => {
    ii.remove(Di(), $i);
  }, [$i, ii]);
  React.useEffect(() => () => {
    fo();
  }, [fo]), React.useEffect(() => {
    di ? Oo() : (!Pi || !ui) && fo();
  }, [di, fo, Pi, ui, Oo]);
  const _o = (Co) => (Ni) => {
    var Yi;
    (Yi = Co.onKeyDown) == null || Yi.call(Co, Ni), !(Ni.key !== "Escape" || Ni.which === 229 || // Wait until IME is settled.
    !io()) && (ir || (Ni.stopPropagation(), si && si(Ni, "escapeKeyDown")));
  }, Li = (Co) => (Ni) => {
    var Yi;
    (Yi = Co.onClick) == null || Yi.call(Co, Ni), Ni.target === Ni.currentTarget && si && si(Ni, "backdropClick");
  };
  return {
    getRootProps: (Co = {}) => {
      const Ni = extractEventHandlers$1(pt);
      delete Ni.onTransitionEnter, delete Ni.onTransitionExited;
      const Yi = {
        ...Ni,
        ...Co
      };
      return {
        /*
         * Marking an element with the role presentation indicates to assistive technology
         * that this element should be ignored; it exists to support the web application and
         * is not meant for humans to interact with directly.
         * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
         */
        role: "presentation",
        ...Yi,
        onKeyDown: _o(Yi),
        ref: vi
      };
    },
    getBackdropProps: (Co = {}) => {
      const Ni = Co;
      return {
        "aria-hidden": !0,
        ...Ni,
        onClick: Li(Ni),
        open: di
      };
    },
    getTransitionProps: () => {
      const Co = () => {
        Si(!1), ai && ai();
      }, Ni = () => {
        Si(!0), li && li(), ui && fo();
      };
      return {
        onEnter: createChainedFunction$1(Co, oi == null ? void 0 : oi.props.onEnter),
        onExited: createChainedFunction$1(Ni, oi == null ? void 0 : oi.props.onExited)
      };
    },
    rootRef: vi,
    portalRef: xo,
    isTopModal: io,
    exited: xi,
    hasTransition: Pi
  };
}
const COMPONENT_NAME$6 = "Modal";
function getModalUtilityClass$1(pt) {
  return generateUtilityClass$1(COMPONENT_NAME$6, pt);
}
generateUtilityClasses$1(COMPONENT_NAME$6, ["root", "hidden", "backdrop"]);
const useUtilityClasses$C = (pt) => {
  const {
    open: yt,
    exited: ir
  } = pt;
  return composeClasses$1({
    root: ["root", !yt && ir && "hidden"],
    backdrop: ["backdrop"]
  }, useClassNamesOverride(getModalUtilityClass$1));
}, Modal$2 = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const {
    children: ir,
    closeAfterTransition: ti = !1,
    container: ii,
    disableAutoFocus: ui = !1,
    disableEnforceFocus: ai = !1,
    disableEscapeKeyDown: li = !1,
    disablePortal: oi = !1,
    disableRestoreFocus: si = !1,
    disableScrollLock: di = !1,
    hideBackdrop: fi = !1,
    keepMounted: gi = !1,
    onBackdropClick: mi,
    onClose: Ti,
    onKeyDown: vi,
    open: xi,
    onTransitionEnter: Si,
    onTransitionExited: Pi,
    slotProps: $i = {},
    slots: Oi = {},
    ...Di
  } = pt, Mi = {
    ...pt,
    closeAfterTransition: ti,
    disableAutoFocus: ui,
    disableEnforceFocus: ai,
    disableEscapeKeyDown: li,
    disablePortal: oi,
    disableRestoreFocus: si,
    disableScrollLock: di,
    hideBackdrop: fi,
    keepMounted: gi
  }, {
    getRootProps: Oo,
    getBackdropProps: io,
    getTransitionProps: xo,
    portalRef: fo,
    isTopModal: _o,
    exited: Li,
    hasTransition: Co
  } = useModal$1({
    ...Mi,
    rootRef: yt
  }), Ni = {
    ...Mi,
    exited: Li,
    hasTransition: Co
  }, Yi = useUtilityClasses$C(Ni), Vo = {};
  if (ir.props.tabIndex === void 0 && (Vo.tabIndex = "-1"), Co) {
    const {
      onEnter: ji,
      onExited: Hi
    } = xo();
    Vo.onEnter = ji, Vo.onExited = Hi;
  }
  const No = Oi.root ?? "div", Ui = useSlotProps$1({
    elementType: No,
    externalSlotProps: $i.root,
    externalForwardedProps: Di,
    getSlotProps: Oo,
    className: Yi.root,
    ownerState: Ni
  }), jo = Oi.backdrop, Wi = useSlotProps$1({
    elementType: jo,
    externalSlotProps: $i.backdrop,
    getSlotProps: (ji) => io({
      ...ji,
      onClick: (Hi) => {
        mi && mi(Hi), ji != null && ji.onClick && ji.onClick(Hi);
      }
    }),
    className: Yi.backdrop,
    ownerState: Ni
  });
  return !gi && !xi && (!Co || Li) ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(Portal$1, {
    ref: fo,
    container: ii,
    disablePortal: oi,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(No, {
      ...Ui,
      children: [!fi && jo ? /* @__PURE__ */ jsxRuntimeExports.jsx(jo, {
        ...Wi
      }) : null, /* @__PURE__ */ jsxRuntimeExports.jsx(FocusTrap$1, {
        disableEnforceFocus: ai,
        disableAutoFocus: ui,
        disableRestoreFocus: si,
        isEnabled: _o,
        open: xi,
        children: /* @__PURE__ */ React.cloneElement(ir, Vo)
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (Modal$2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: elementAcceptingRef$1.isRequired,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: PropTypes.bool,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType$1, PropTypes.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: PropTypes.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: PropTypes.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: PropTypes.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: PropTypes.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: PropTypes.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: PropTypes.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: PropTypes.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: PropTypes.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: PropTypes.shape({
    backdrop: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    backdrop: PropTypes.elementType,
    root: PropTypes.elementType
  })
});
const COMPONENT_NAME$5 = "Option";
function getOptionUtilityClass(pt) {
  return generateUtilityClass$1(COMPONENT_NAME$5, pt);
}
generateUtilityClasses$1(COMPONENT_NAME$5, ["root", "disabled", "selected", "highlighted"]);
function useOption(pt) {
  const {
    value: yt,
    label: ir,
    disabled: ti,
    rootRef: ii,
    id: ui
  } = pt, {
    getRootProps: ai,
    highlighted: li,
    selected: oi
  } = useListItem({
    item: yt
  }), {
    getRootProps: si,
    rootRef: di
  } = useButton({
    disabled: ti,
    focusableWhenDisabled: !0
  }), fi = useId$2(ui), gi = React.useRef(null), mi = React.useMemo(() => ({
    disabled: ti,
    label: ir,
    value: yt,
    ref: gi,
    id: fi
  }), [ti, ir, yt, fi]), {
    index: Ti
  } = useCompoundItem(yt, mi), vi = useForkRef$1(ii, gi, di), xi = (Pi) => ($i) => {
    var Oi;
    (Oi = Pi.onKeyDown) == null || Oi.call(Pi, $i), !$i.defaultMuiPrevented && [" ", "Enter"].includes($i.key) && ($i.defaultMuiPrevented = !0);
  }, Si = (Pi = {}) => ({
    onKeyDown: xi(Pi)
  });
  return {
    getRootProps: (Pi = {}) => {
      const $i = extractEventHandlers$1(Pi), Oi = combineHooksSlotProps(ai, combineHooksSlotProps(si, Si));
      return {
        ...Pi,
        ...$i,
        ...Oi($i),
        id: fi,
        ref: vi,
        role: "option",
        "aria-selected": oi
      };
    },
    highlighted: li,
    index: Ti,
    selected: oi,
    rootRef: vi
  };
}
function useOptionContextStabilizer(pt) {
  const yt = React.useContext(ListContext$1);
  if (!yt)
    throw new Error("Option: ListContext was not found.");
  const {
    getItemState: ir,
    dispatch: ti
  } = yt, {
    highlighted: ii,
    selected: ui,
    focusable: ai
  } = ir(pt), li = React.useCallback((oi) => {
    if (oi !== pt)
      throw new Error(["MUI Base Option: Tried to access the state of another Option.", "This is unsupported when the Option uses the OptionContextStabilizer as a performance optimization."].join("/n"));
    return {
      highlighted: ii,
      selected: ui,
      focusable: ai
    };
  }, [ii, ui, ai, pt]);
  return {
    contextValue: React.useMemo(() => ({
      dispatch: ti,
      getItemState: li
    }), [ti, li])
  };
}
function useUtilityClasses$B(pt) {
  const {
    disabled: yt,
    highlighted: ir,
    selected: ti
  } = pt;
  return composeClasses$1({
    root: ["root", yt && "disabled", ir && "highlighted", ti && "selected"]
  }, useClassNamesOverride(getOptionUtilityClass));
}
const InnerOption = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  var ir, ti;
  const {
    children: ii,
    disabled: ui = !1,
    label: ai,
    slotProps: li = {},
    slots: oi = {},
    value: si,
    ...di
  } = pt, fi = oi.root ?? "li", gi = React.useRef(null), mi = useForkRef$1(gi, yt), Ti = ai ?? (typeof ii == "string" ? ii : (ti = (ir = gi.current) == null ? void 0 : ir.textContent) == null ? void 0 : ti.trim()), {
    getRootProps: vi,
    selected: xi,
    highlighted: Si,
    index: Pi
  } = useOption({
    disabled: ui,
    label: Ti,
    rootRef: mi,
    value: si
  }), $i = {
    ...pt,
    disabled: ui,
    highlighted: Si,
    index: Pi,
    selected: xi
  }, Oi = useUtilityClasses$B($i), Di = useSlotProps$1({
    getSlotProps: vi,
    elementType: fi,
    externalSlotProps: li.root,
    externalForwardedProps: di,
    className: Oi.root,
    ownerState: $i
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(fi, {
    ...Di,
    children: ii
  });
});
process.env.NODE_ENV !== "production" && (InnerOption.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  children: PropTypes.node,
  className: PropTypes.string,
  /**
   * If `true`, the option will be disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * A text representation of the option's content.
   * Used for keyboard text navigation matching.
   */
  label: PropTypes.string,
  /**
   * The props used for each slot inside the Option.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Option.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * The value of the option.
   */
  value: PropTypes.any.isRequired
});
const InnerOptionMemo = /* @__PURE__ */ React.memo(InnerOption), Option = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const {
    value: ir
  } = pt, {
    contextValue: ti
  } = useOptionContextStabilizer(ir);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ListContext$1.Provider, {
    value: ti,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(InnerOptionMemo, {
      ...pt,
      ref: yt
    })
  });
});
process.env.NODE_ENV !== "production" && (Option.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the option will be disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * A text representation of the option's content.
   * Used for keyboard text navigation matching.
   */
  label: PropTypes.string,
  /**
   * The props used for each slot inside the Option.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Option.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * The value of the option.
   */
  value: PropTypes.any.isRequired
});
const SelectActionTypes = {
  buttonClick: "buttonClick",
  browserAutoFill: "browserAutoFill"
}, defaultOptionStringifier = (pt) => {
  const {
    label: yt,
    value: ir
  } = pt;
  return typeof yt == "string" ? yt : typeof ir == "string" ? ir : String(pt);
};
function selectReducer(pt, yt) {
  const {
    open: ir
  } = pt, {
    context: {
      selectionMode: ti
    }
  } = yt;
  if (yt.type === SelectActionTypes.buttonClick) {
    const ui = pt.selectedValues[0] ?? moveHighlight(null, "start", yt.context);
    return {
      ...pt,
      open: !ir,
      highlightedValue: ir ? null : ui
    };
  }
  if (yt.type === SelectActionTypes.browserAutoFill)
    return handleItemSelection(yt.item, pt, yt.context);
  const ii = listReducer(pt, yt);
  switch (yt.type) {
    case ListActionTypes.keyDown:
      if (pt.open) {
        if (yt.event.key === "Escape")
          return {
            ...ii,
            open: !1
          };
      } else {
        if (yt.event.key === "ArrowDown")
          return {
            ...pt,
            open: !0,
            highlightedValue: pt.selectedValues[0] ?? moveHighlight(null, "start", yt.context)
          };
        if (yt.event.key === "ArrowUp")
          return {
            ...pt,
            open: !0,
            highlightedValue: pt.selectedValues[0] ?? moveHighlight(null, "end", yt.context)
          };
      }
      break;
    case ListActionTypes.itemClick:
      if (ti === "single")
        return {
          ...ii,
          open: !1
        };
      break;
    case ListActionTypes.blur:
      return {
        ...ii,
        open: !1
      };
    default:
      return ii;
  }
  return ii;
}
function defaultFormValueProvider(pt) {
  return Array.isArray(pt) ? pt.length === 0 ? "" : JSON.stringify(pt.map((yt) => yt.value)) : (pt == null ? void 0 : pt.value) == null ? "" : typeof pt.value == "string" || typeof pt.value == "number" ? pt.value : JSON.stringify(pt.value);
}
function useSelect(pt) {
  const {
    areOptionsEqual: yt,
    buttonRef: ir,
    defaultOpen: ti = !1,
    defaultValue: ii,
    disabled: ui = !1,
    listboxId: ai,
    listboxRef: li,
    multiple: oi = !1,
    name: si,
    required: di,
    onChange: fi,
    onHighlightChange: gi,
    onOpenChange: mi,
    open: Ti,
    options: vi,
    getOptionAsString: xi = defaultOptionStringifier,
    getSerializedValue: Si = defaultFormValueProvider,
    value: Pi,
    componentName: $i = "useSelect"
  } = pt, Oi = React.useRef(null), Di = useForkRef$1(ir, Oi), Mi = React.useRef(null), Oo = useId$2(ai);
  let io;
  Pi === void 0 && ii === void 0 ? io = [] : ii !== void 0 && (oi ? io = ii : io = ii == null ? [] : [ii]);
  const xo = React.useMemo(() => {
    if (Pi !== void 0)
      return oi ? Pi : Pi == null ? [] : [Pi];
  }, [Pi, oi]), {
    subitems: fo,
    contextValue: _o
  } = useCompoundParent(), Li = React.useMemo(() => vi != null ? new Map(vi.map((Ps, nl) => [Ps.value, {
    value: Ps.value,
    label: Ps.label,
    disabled: Ps.disabled,
    ref: /* @__PURE__ */ React.createRef(),
    id: `${Oo}_${nl}`
  }])) : fo, [vi, fo, Oo]), Co = useForkRef$1(li, Mi), {
    getRootProps: Ni,
    active: Yi,
    focusVisible: Vo,
    rootRef: No
  } = useButton({
    disabled: ui,
    rootRef: Di
  }), Ui = React.useMemo(() => Array.from(Li.keys()), [Li]), jo = React.useCallback((Ps) => {
    if (yt !== void 0) {
      const nl = Ui.find((Vs) => yt(Vs, Ps));
      return Li.get(nl);
    }
    return Li.get(Ps);
  }, [Li, yt, Ui]), Wi = React.useCallback((Ps) => {
    const nl = jo(Ps);
    return (nl == null ? void 0 : nl.disabled) ?? !1;
  }, [jo]), ji = React.useCallback((Ps) => {
    const nl = jo(Ps);
    return nl ? xi(nl) : "";
  }, [jo, xi]), Hi = React.useMemo(() => ({
    selectedValues: xo,
    open: Ti
  }), [xo, Ti]), zo = React.useCallback((Ps) => {
    var nl;
    return (nl = Li.get(Ps)) == null ? void 0 : nl.id;
  }, [Li]), Lo = React.useCallback((Ps, nl) => {
    oi ? fi == null || fi(Ps, nl) : fi == null || fi(Ps, nl[0] ?? null);
  }, [oi, fi]), sa = React.useCallback((Ps, nl) => {
    gi == null || gi(Ps, nl ?? null);
  }, [gi]), Ko = React.useCallback((Ps, nl, Vs) => {
    var es;
    nl === "open" && (mi == null || mi(Vs), Vs === !1 && (Ps == null ? void 0 : Ps.type) !== "blur" && ((es = Oi.current) == null || es.focus()));
  }, [mi]), ca = React.useCallback((Ps) => {
    var nl;
    return Ps == null ? null : ((nl = fo.get(Ps)) == null ? void 0 : nl.ref.current) ?? null;
  }, [fo]), pa = {
    getInitialState: () => ({
      highlightedValue: null,
      selectedValues: io ?? [],
      open: ti
    }),
    getItemId: zo,
    controlledProps: Hi,
    focusManagement: "DOM",
    getItemDomElement: ca,
    itemComparer: yt,
    isItemDisabled: Wi,
    rootRef: Co,
    onChange: Lo,
    onHighlightChange: sa,
    onStateChange: Ko,
    reducerActionContext: React.useMemo(() => ({
      multiple: oi
    }), [oi]),
    items: Ui,
    getItemAsString: ji,
    selectionMode: oi ? "multiple" : "single",
    stateReducer: selectReducer,
    componentName: $i
  }, {
    dispatch: ga,
    getRootProps: ia,
    contextValue: ra,
    state: {
      open: qo,
      highlightedValue: xa,
      selectedValues: $a
    },
    rootRef: ys
  } = useList(pa), Ss = React.useRef(qo);
  useEnhancedEffect$1(() => {
    var Ps;
    if (qo && xa !== null) {
      const nl = (Ps = jo(xa)) == null ? void 0 : Ps.ref;
      if (!Mi.current || !(nl != null && nl.current))
        return;
      Ss.current || nl.current.focus({
        preventScroll: !0
      });
      const Vs = Mi.current.getBoundingClientRect(), es = nl.current.getBoundingClientRect();
      es.top < Vs.top ? Mi.current.scrollTop -= Vs.top - es.top : es.bottom > Vs.bottom && (Mi.current.scrollTop += es.bottom - Vs.bottom);
    }
  }, [qo, xa, jo]);
  const Xa = React.useCallback((Ps) => jo(Ps), [jo]), Es = (Ps) => (nl) => {
    var Vs;
    if ((Vs = Ps == null ? void 0 : Ps.onClick) == null || Vs.call(Ps, nl), !nl.defaultMuiPrevented) {
      const es = {
        type: SelectActionTypes.buttonClick,
        event: nl
      };
      ga(es);
    }
  }, Rs = (Ps) => (nl) => {
    var Vs;
    (Vs = Ps.onKeyDown) == null || Vs.call(Ps, nl), !nl.defaultMuiPrevented && (nl.key === "ArrowDown" || nl.key === "ArrowUp") && (nl.preventDefault(), ga({
      type: ListActionTypes.keyDown,
      key: nl.key,
      event: nl
    }));
  }, La = (Ps = {}) => ({
    onClick: Es(Ps),
    onKeyDown: Rs(Ps)
  }), Ja = (Ps = {}) => ({
    ...Ps,
    ...La(Ps),
    role: "combobox",
    "aria-expanded": qo,
    "aria-controls": Oo
  }), ja = (Ps = {}) => {
    const nl = extractEventHandlers$1(Ps), Vs = combineHooksSlotProps(Ja, Ni);
    return {
      ...Ps,
      ...Vs(nl)
    };
  }, Ta = (Ps) => (nl) => {
    var Vs, es;
    (Vs = Ps.onBlur) == null || Vs.call(Ps, nl), !nl.defaultMuiPrevented && ((es = Mi.current) != null && es.contains(nl.relatedTarget) || nl.relatedTarget === Oi.current) && (nl.defaultMuiPrevented = !0);
  }, rs = (Ps = {}) => ({
    onBlur: Ta(Ps)
  }), Qa = (Ps = {}) => {
    const nl = extractEventHandlers$1(Ps), Vs = combineHooksSlotProps(rs, ia);
    return {
      id: Oo,
      role: "listbox",
      "aria-multiselectable": oi ? "true" : void 0,
      ...Ps,
      ...Vs(nl)
    };
  };
  React.useDebugValue({
    selectedOptions: $a,
    highlightedOption: xa,
    open: qo
  });
  const Cs = React.useMemo(() => ({
    ...ra,
    ..._o
  }), [ra, _o]);
  let _a;
  pt.multiple ? _a = $a : _a = $a.length > 0 ? $a[0] : null;
  let _s;
  oi ? _s = _a.map((Ps) => Xa(Ps)).filter((Ps) => Ps !== void 0) : _s = Xa(_a) ?? null;
  const el = (Ps) => (nl) => {
    var Vs;
    if ((Vs = Ps == null ? void 0 : Ps.onChange) == null || Vs.call(Ps, nl), nl.defaultMuiPrevented)
      return;
    const es = Li.get(nl.target.value);
    nl.target.value === "" ? ga({
      type: ListActionTypes.clearSelection
    }) : es !== void 0 && ga({
      type: SelectActionTypes.browserAutoFill,
      item: es.value,
      event: nl
    });
  };
  return {
    buttonActive: Yi,
    buttonFocusVisible: Vo,
    buttonRef: No,
    contextValue: Cs,
    disabled: ui,
    dispatch: ga,
    getButtonProps: ja,
    getHiddenInputProps: (Ps = {}) => {
      const nl = extractEventHandlers$1(Ps);
      return {
        name: si,
        tabIndex: -1,
        "aria-hidden": !0,
        required: di ? !0 : void 0,
        value: Si(_s),
        style: visuallyHidden,
        ...Ps,
        onChange: el(nl)
      };
    },
    getListboxProps: Qa,
    getOptionMetadata: Xa,
    listboxRef: ys,
    open: qo,
    options: Ui,
    value: _a,
    highlightedOption: xa
  };
}
function SelectProvider(pt) {
  const {
    value: yt,
    children: ir
  } = pt, {
    dispatch: ti,
    getItemIndex: ii,
    getItemState: ui,
    registerItem: ai,
    totalSubitemCount: li
  } = yt, oi = React.useMemo(() => ({
    dispatch: ti,
    getItemState: ui,
    getItemIndex: ii
  }), [ti, ii, ui]), si = React.useMemo(() => ({
    getItemIndex: ii,
    registerItem: ai,
    totalSubitemCount: li
  }), [ai, ii, li]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CompoundComponentContext.Provider, {
    value: si,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(ListContext$1.Provider, {
      value: oi,
      children: ir
    })
  });
}
const COMPONENT_NAME$4 = "Select";
function getSelectUtilityClass(pt) {
  return generateUtilityClass$1(COMPONENT_NAME$4, pt);
}
generateUtilityClasses$1(COMPONENT_NAME$4, ["root", "button", "listbox", "popup", "active", "expanded", "disabled", "focusVisible"]);
var _span$2;
function defaultRenderValue(pt) {
  return Array.isArray(pt) ? /* @__PURE__ */ jsxRuntimeExports.jsx(React.Fragment, {
    children: pt.map((yt) => yt.label).join(", ")
  }) : (pt == null ? void 0 : pt.label) ?? null;
}
function useUtilityClasses$A(pt) {
  const {
    active: yt,
    disabled: ir,
    open: ti,
    focusVisible: ii
  } = pt;
  return composeClasses$1({
    root: ["root", ir && "disabled", ii && "focusVisible", yt && "active", ti && "expanded"],
    listbox: ["listbox", ir && "disabled"],
    popup: ["popup"]
  }, useClassNamesOverride(getSelectUtilityClass));
}
const Select$2 = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const {
    areOptionsEqual: ir,
    autoComplete: ti,
    autoFocus: ii,
    children: ui,
    defaultValue: ai,
    defaultListboxOpen: li = !1,
    disabled: oi,
    getSerializedValue: si,
    listboxId: di,
    listboxOpen: fi,
    multiple: gi = !1,
    name: mi,
    required: Ti = !1,
    onChange: vi,
    onListboxOpenChange: xi,
    getOptionAsString: Si = defaultOptionStringifier,
    renderValue: Pi,
    placeholder: $i,
    slotProps: Oi = {},
    slots: Di = {},
    value: Mi,
    ...Oo
  } = pt, io = Pi ?? defaultRenderValue, [xo, fo] = React.useState(!1), _o = React.useRef(null), Li = React.useRef(null), Co = Di.root ?? "button", Ni = Di.listbox ?? "ul", Yi = Di.popup ?? "div", Vo = React.useCallback(($a) => {
    fo($a != null);
  }, []), No = useForkRef$1(yt, _o, Vo);
  React.useEffect(() => {
    ii && _o.current.focus();
  }, [ii]);
  const {
    buttonActive: Ui,
    buttonFocusVisible: jo,
    contextValue: Wi,
    disabled: ji,
    getButtonProps: Hi,
    getListboxProps: zo,
    getHiddenInputProps: Lo,
    getOptionMetadata: sa,
    value: Ko,
    open: ca
  } = useSelect({
    name: mi,
    required: Ti,
    getSerializedValue: si,
    areOptionsEqual: ir,
    buttonRef: No,
    defaultOpen: li,
    defaultValue: ai,
    disabled: oi,
    listboxId: di,
    multiple: gi,
    open: fi,
    onChange: vi,
    onOpenChange: xi,
    getOptionAsString: Si,
    value: Mi,
    componentName: "Select"
  }), pa = {
    ...pt,
    active: Ui,
    defaultListboxOpen: li,
    disabled: ji,
    focusVisible: jo,
    open: ca,
    multiple: gi,
    renderValue: io,
    value: Ko
  }, ga = useUtilityClasses$A(pa), ia = useSlotProps$1({
    elementType: Co,
    getSlotProps: Hi,
    externalSlotProps: Oi.root,
    externalForwardedProps: Oo,
    ownerState: pa,
    className: ga.root
  }), ra = useSlotProps$1({
    elementType: Ni,
    getSlotProps: zo,
    externalSlotProps: Oi.listbox,
    additionalProps: {
      ref: Li
    },
    ownerState: pa,
    className: ga.listbox
  }), qo = useSlotProps$1({
    elementType: Yi,
    externalSlotProps: Oi.popup,
    additionalProps: {
      anchor: _o.current,
      keepMounted: !0,
      open: ca,
      placement: "bottom-start",
      role: void 0
    },
    ownerState: pa,
    className: ga.popup
  });
  let xa;
  return gi ? xa = Ko.map(($a) => sa($a)).filter(($a) => $a !== void 0) : xa = sa(Ko) ?? null, /* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(Co, {
      ...ia,
      children: io(xa) ?? $i ?? // fall back to a zero-width space to prevent layout shift
      // from https://github.com/mui/material-ui/pull/24563
      (_span$2 || (_span$2 = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
        className: "notranslate",
        "aria-hidden": !0,
        children: "​"
      })))
    }), xo && /* @__PURE__ */ jsxRuntimeExports.jsx(Popup, {
      slots: {
        root: Yi
      },
      ...qo,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Ni, {
        ...ra,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(SelectProvider, {
          value: Wi,
          children: ui
        })
      })
    }), /* @__PURE__ */ jsxRuntimeExports.jsx("input", {
      ...Lo(),
      autoComplete: ti
    })]
  });
});
process.env.NODE_ENV !== "production" && (Select$2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A function used to determine if two options' values are equal.
   * By default, reference equality is used.
   *
   * There is a performance impact when using the `areOptionsEqual` prop (proportional to the number of options).
   * Therefore, it's recommented to use the default reference equality comparison whenever possible.
   */
  areOptionsEqual: PropTypes.func,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the select element is focused during the first mount
   * @default false
   */
  autoFocus: PropTypes.bool,
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the select will be initially open.
   * @default false
   */
  defaultListboxOpen: PropTypes.bool,
  /**
   * The default selected value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the select is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * A function used to convert the option label to a string.
   * It's useful when labels are elements and need to be converted to plain text
   * to enable navigation using character keys on a keyboard.
   *
   * @default defaultOptionStringifier
   */
  getOptionAsString: PropTypes.func,
  /**
   * A function to convert the currently selected value to a string.
   * Used to set a value of a hidden input associated with the select,
   * so that the selected value can be posted with a form.
   */
  getSerializedValue: PropTypes.func,
  /**
   * `id` attribute of the listbox element.
   */
  listboxId: PropTypes.string,
  /**
   * Controls the open state of the select's listbox.
   * @default undefined
   */
  listboxOpen: PropTypes.bool,
  /**
   * If `true`, selecting multiple values is allowed.
   * This affects the type of the `value`, `defaultValue`, and `onChange` props.
   *
   * @default false
   */
  multiple: PropTypes.bool,
  /**
   * Name of the element. For example used by the server to identify the fields in form submits.
   */
  name: PropTypes.string,
  /**
   * Callback fired when an option is selected.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see listboxOpen).
   */
  onListboxOpenChange: PropTypes.func,
  /**
   * Text to show when there is no selected value.
   */
  placeholder: PropTypes.node,
  /**
   * Function that customizes the rendering of the selected value.
   */
  renderValue: PropTypes.func,
  /**
   * If `true`, the Select cannot be empty when submitting form.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * The props used for each slot inside the Input.
   * @default {}
   */
  slotProps: PropTypes.shape({
    listbox: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    popup: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Select.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    listbox: PropTypes.elementType,
    popup: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The selected value.
   * Set to `null` to deselect all options.
   */
  value: PropTypes.any
});
const COMPONENT_NAME$3 = "TabPanel";
function getTabPanelUtilityClass(pt) {
  return generateUtilityClass$1(COMPONENT_NAME$3, pt);
}
generateUtilityClasses$1(COMPONENT_NAME$3, ["root", "hidden"]);
const COMPONENT_NAME$2 = "Tabs";
function getTabsUtilityClass(pt) {
  return generateUtilityClass$1(COMPONENT_NAME$2, pt);
}
generateUtilityClasses$1(COMPONENT_NAME$2, ["root", "horizontal", "vertical"]);
function useTabs(pt) {
  const {
    value: yt,
    defaultValue: ir,
    onChange: ti,
    orientation: ii = "horizontal",
    direction: ui = "ltr",
    selectionFollowsFocus: ai = !1
  } = pt, [li, oi] = useControlled$1({
    controlled: yt,
    default: ir,
    name: "Tabs",
    state: "value"
  }), si = React.useCallback((xi, Si) => {
    oi(Si), ti == null || ti(xi, Si);
  }, [ti, oi]), {
    subitems: di,
    contextValue: fi
  } = useCompoundParent(), gi = React.useRef(() => {
  }), mi = React.useCallback((xi) => {
    var Si;
    return (Si = di.get(xi)) == null ? void 0 : Si.id;
  }, [di]), Ti = React.useCallback((xi) => gi.current(xi), []), vi = React.useCallback((xi) => {
    gi.current = xi;
  }, []);
  return {
    contextValue: {
      direction: ui,
      getTabId: Ti,
      getTabPanelId: mi,
      onSelected: si,
      orientation: ii,
      registerTabIdLookup: vi,
      selectionFollowsFocus: ai,
      value: li,
      ...fi
    }
  };
}
const TabsContext = /* @__PURE__ */ React.createContext(null);
process.env.NODE_ENV !== "production" && (TabsContext.displayName = "TabsContext");
function useTabsContext() {
  const pt = React.useContext(TabsContext);
  if (pt == null)
    throw new Error("No TabsContext provided");
  return pt;
}
function TabsProvider(pt) {
  const {
    value: yt,
    children: ir
  } = pt, {
    direction: ti,
    getItemIndex: ii,
    onSelected: ui,
    orientation: ai,
    registerItem: li,
    registerTabIdLookup: oi,
    selectionFollowsFocus: si,
    totalSubitemCount: di,
    value: fi,
    getTabId: gi,
    getTabPanelId: mi
  } = yt, Ti = React.useMemo(() => ({
    getItemIndex: ii,
    registerItem: li,
    totalSubitemCount: di
  }), [li, ii, di]), vi = React.useMemo(() => ({
    direction: ti,
    getTabId: gi,
    getTabPanelId: mi,
    onSelected: ui,
    orientation: ai,
    registerTabIdLookup: oi,
    selectionFollowsFocus: si,
    value: fi
  }), [ti, gi, mi, ui, ai, oi, si, fi]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CompoundComponentContext.Provider, {
    value: Ti,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(TabsContext.Provider, {
      value: vi,
      children: ir
    })
  });
}
const useUtilityClasses$z = (pt) => {
  const {
    orientation: yt
  } = pt;
  return composeClasses$1({
    root: ["root", yt]
  }, useClassNamesOverride(getTabsUtilityClass));
}, Tabs = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const {
    children: ir,
    value: ti,
    defaultValue: ii,
    orientation: ui = "horizontal",
    direction: ai = "ltr",
    onChange: li,
    selectionFollowsFocus: oi,
    slotProps: si = {},
    slots: di = {},
    ...fi
  } = pt, gi = {
    ...pt,
    orientation: ui,
    direction: ai
  }, {
    contextValue: mi
  } = useTabs(gi), Ti = useUtilityClasses$z(gi), vi = di.root ?? "div", xi = useSlotProps$1({
    elementType: vi,
    externalSlotProps: si.root,
    externalForwardedProps: fi,
    additionalProps: {
      ref: yt
    },
    ownerState: gi,
    className: Ti.root
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(vi, {
    ...xi,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(TabsProvider, {
      value: mi,
      children: ir
    })
  });
});
process.env.NODE_ENV !== "production" && (Tabs.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The direction of the text.
   * @default 'ltr'
   */
  direction: PropTypes.oneOf(["ltr", "rtl"]),
  /**
   * Callback invoked when new value is being set.
   */
  onChange: PropTypes.func,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  /**
   * If `true` the selected tab changes on focus. Otherwise it only
   * changes on activation.
   */
  selectionFollowsFocus: PropTypes.bool,
  /**
   * The props used for each slot inside the Tabs.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Tabs.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this prop to `null`.
   */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
});
function tabPanelValueGenerator(pt) {
  return pt.size;
}
function useTabPanel(pt) {
  const {
    value: yt,
    id: ir,
    rootRef: ti
  } = pt, ii = useTabsContext();
  if (ii === null)
    throw new Error("No TabContext provided");
  const {
    value: ui,
    getTabId: ai
  } = ii, li = useId$2(ir), oi = React.useRef(null), si = useForkRef$1(oi, ti), di = React.useMemo(() => ({
    id: li,
    ref: oi
  }), [li]), {
    id: fi
  } = useCompoundItem(yt ?? tabPanelValueGenerator, di), gi = fi !== ui, mi = fi !== void 0 ? ai(fi) : void 0;
  return {
    hidden: gi,
    getRootProps: (Ti = {}) => ({
      "aria-labelledby": mi ?? void 0,
      hidden: gi,
      id: li ?? void 0,
      ...Ti,
      ref: si
    }),
    rootRef: si
  };
}
const useUtilityClasses$y = (pt) => {
  const {
    hidden: yt
  } = pt;
  return composeClasses$1({
    root: ["root", yt && "hidden"]
  }, useClassNamesOverride(getTabPanelUtilityClass));
}, TabPanel = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const {
    children: ir,
    value: ti,
    slotProps: ii = {},
    slots: ui = {},
    ...ai
  } = pt, {
    hidden: li,
    getRootProps: oi
  } = useTabPanel(pt), si = {
    ...pt,
    hidden: li
  }, di = useUtilityClasses$y(si), fi = ui.root ?? "div", gi = useSlotProps$1({
    elementType: fi,
    getSlotProps: oi,
    externalSlotProps: ii.root,
    externalForwardedProps: ai,
    additionalProps: {
      role: "tabpanel",
      ref: yt
    },
    ownerState: si,
    className: di.root
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(fi, {
    ...gi,
    children: !li && ir
  });
});
process.env.NODE_ENV !== "production" && (TabPanel.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The props used for each slot inside the TabPanel.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the TabPanel.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * The value of the TabPanel. It will be shown when the Tab with the corresponding value is selected.
   * If not provided, it will fall back to the index of the panel.
   * It is recommended to explicitly provide it, as it's required for the tab panel to be rendered on the server.
   */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
});
const COMPONENT_NAME$1 = "TabsList";
function getTabsListUtilityClass(pt) {
  return generateUtilityClass$1(COMPONENT_NAME$1, pt);
}
generateUtilityClasses$1(COMPONENT_NAME$1, ["root", "horizontal", "vertical"]);
const TabsListActionTypes = {
  valueChange: "valueChange"
};
function tabsListReducer(pt, yt) {
  if (yt.type === TabsListActionTypes.valueChange)
    return {
      ...pt,
      highlightedValue: yt.value
    };
  const ir = listReducer(pt, yt), {
    context: {
      selectionFollowsFocus: ti
    }
  } = yt;
  if (yt.type === ListActionTypes.itemsChange) {
    if (ir.selectedValues.length > 0)
      return {
        ...ir,
        highlightedValue: ir.selectedValues[0]
      };
    moveHighlight(null, "reset", yt.context);
  }
  return ti && ir.highlightedValue != null ? {
    ...ir,
    selectedValues: [ir.highlightedValue]
  } : ir;
}
function useTabsList(pt) {
  const {
    rootRef: yt
  } = pt, {
    direction: ir = "ltr",
    onSelected: ti,
    orientation: ii = "horizontal",
    value: ui,
    registerTabIdLookup: ai,
    selectionFollowsFocus: li
  } = useTabsContext(), {
    subitems: oi,
    contextValue: si
  } = useCompoundParent(), di = React.useCallback((xo) => {
    var fo;
    return (fo = oi.get(xo)) == null ? void 0 : fo.id;
  }, [oi]);
  ai(di);
  const fi = React.useMemo(() => Array.from(oi.keys()), [oi]), gi = React.useCallback((xo) => {
    var fo;
    return xo == null ? null : ((fo = oi.get(xo)) == null ? void 0 : fo.ref.current) ?? null;
  }, [oi]), mi = ir === "rtl";
  let Ti;
  ii === "vertical" ? Ti = "vertical" : Ti = mi ? "horizontal-rtl" : "horizontal-ltr";
  const vi = React.useCallback((xo, fo) => {
    ti(xo, fo[0] ?? null);
  }, [ti]), xi = React.useMemo(() => ui === void 0 ? {} : ui != null ? {
    selectedValues: [ui]
  } : {
    selectedValues: []
  }, [ui]), Si = React.useCallback((xo) => {
    var fo;
    return ((fo = oi.get(xo)) == null ? void 0 : fo.disabled) ?? !1;
  }, [oi]), {
    contextValue: Pi,
    dispatch: $i,
    getRootProps: Oi,
    state: {
      highlightedValue: Di,
      selectedValues: Mi
    },
    rootRef: Oo
  } = useList({
    controlledProps: xi,
    disabledItemsFocusable: !li,
    focusManagement: "DOM",
    getItemDomElement: gi,
    isItemDisabled: Si,
    items: fi,
    rootRef: yt,
    onChange: vi,
    orientation: Ti,
    reducerActionContext: React.useMemo(() => ({
      selectionFollowsFocus: li || !1
    }), [li]),
    selectionMode: "single",
    stateReducer: tabsListReducer
  });
  React.useEffect(() => {
    ui !== void 0 && ui != null && $i({
      type: TabsListActionTypes.valueChange,
      value: ui
    });
  }, [$i, ui]);
  const io = (xo = {}) => ({
    ...xo,
    ...Oi(xo),
    "aria-orientation": ii === "vertical" ? "vertical" : void 0,
    role: "tablist"
  });
  return {
    contextValue: React.useMemo(() => ({
      ...si,
      ...Pi
    }), [si, Pi]),
    dispatch: $i,
    getRootProps: io,
    highlightedValue: Di,
    isRtl: mi,
    orientation: ii,
    rootRef: Oo,
    selectedValue: Mi[0] ?? null
  };
}
function TabsListProvider(pt) {
  const {
    value: yt,
    children: ir
  } = pt, {
    dispatch: ti,
    getItemIndex: ii,
    getItemState: ui,
    registerItem: ai,
    totalSubitemCount: li
  } = yt, oi = React.useMemo(() => ({
    dispatch: ti,
    getItemState: ui,
    getItemIndex: ii
  }), [ti, ii, ui]), si = React.useMemo(() => ({
    getItemIndex: ii,
    registerItem: ai,
    totalSubitemCount: li
  }), [ai, ii, li]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CompoundComponentContext.Provider, {
    value: si,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(ListContext$1.Provider, {
      value: oi,
      children: ir
    })
  });
}
const useUtilityClasses$x = (pt) => {
  const {
    orientation: yt
  } = pt;
  return composeClasses$1({
    root: ["root", yt]
  }, useClassNamesOverride(getTabsListUtilityClass));
}, TabsList = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const {
    children: ir,
    slotProps: ti = {},
    slots: ii = {},
    ...ui
  } = pt, {
    isRtl: ai,
    orientation: li,
    getRootProps: oi,
    contextValue: si
  } = useTabsList({
    rootRef: yt
  }), di = {
    ...pt,
    isRtl: ai,
    orientation: li
  }, fi = useUtilityClasses$x(di), gi = ii.root ?? "div", mi = useSlotProps$1({
    elementType: gi,
    getSlotProps: oi,
    externalSlotProps: ti.root,
    externalForwardedProps: ui,
    ownerState: di,
    className: fi.root
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TabsListProvider, {
    value: si,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(gi, {
      ...mi,
      children: ir
    })
  });
});
process.env.NODE_ENV !== "production" && (TabsList.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The props used for each slot inside the TabsList.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the TabsList.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  })
});
const COMPONENT_NAME = "Tab";
function getTabUtilityClass(pt) {
  return generateUtilityClass$1(COMPONENT_NAME, pt);
}
generateUtilityClasses$1(COMPONENT_NAME, ["root", "selected", "disabled"]);
function tabValueGenerator(pt) {
  return pt.size;
}
function useTab(pt) {
  const {
    value: yt,
    rootRef: ir,
    disabled: ti = !1,
    id: ii
  } = pt, ui = React.useRef(null), ai = useId$2(ii), {
    value: li,
    selectionFollowsFocus: oi,
    getTabPanelId: si
  } = useTabsContext(), di = React.useMemo(() => ({
    disabled: ti,
    ref: ui,
    id: ai
  }), [ti, ui, ai]), {
    id: fi,
    index: gi,
    totalItemCount: mi
  } = useCompoundItem(yt ?? tabValueGenerator, di), {
    getRootProps: Ti,
    highlighted: vi,
    selected: xi
  } = useListItem({
    item: fi
  }), {
    getRootProps: Si,
    rootRef: Pi,
    active: $i,
    focusVisible: Oi,
    setFocusVisible: Di
  } = useButton({
    disabled: ti,
    focusableWhenDisabled: !oi,
    type: "button"
  }), Mi = useForkRef$1(ui, ir, Pi), Oo = fi !== void 0 ? si(fi) : void 0;
  return {
    getRootProps: (io = {}) => {
      const xo = extractEventHandlers$1(io), fo = combineHooksSlotProps(Ti, Si);
      return {
        ...io,
        ...fo(xo),
        role: "tab",
        "aria-controls": Oo,
        "aria-selected": xi,
        id: ai,
        ref: Mi
      };
    },
    active: $i,
    focusVisible: Oi,
    highlighted: vi,
    index: gi,
    rootRef: Mi,
    // the `selected` state isn't set on the server (it relies on effects to be calculated),
    // so we fall back to checking the `value` prop with the selectedValue from the TabsContext
    selected: xi || fi === li,
    setFocusVisible: Di,
    totalTabsCount: mi
  };
}
const useUtilityClasses$w = (pt) => {
  const {
    selected: yt,
    disabled: ir
  } = pt;
  return composeClasses$1({
    root: ["root", yt && "selected", ir && "disabled"]
  }, useClassNamesOverride(getTabUtilityClass));
}, Tab = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const {
    action: ir,
    children: ti,
    disabled: ii = !1,
    onChange: ui,
    onClick: ai,
    onFocus: li,
    slotProps: oi = {},
    slots: si = {},
    value: di,
    ...fi
  } = pt, gi = React.useRef(null), mi = useForkRef$1(gi, yt), {
    active: Ti,
    highlighted: vi,
    selected: xi,
    getRootProps: Si
  } = useTab({
    ...pt,
    rootRef: mi,
    value: di
  }), Pi = {
    ...pt,
    active: Ti,
    disabled: ii,
    highlighted: vi,
    selected: xi
  }, $i = useUtilityClasses$w(Pi), Oi = si.root ?? "button", Di = useSlotProps$1({
    elementType: Oi,
    getSlotProps: Si,
    externalSlotProps: oi.root,
    externalForwardedProps: fi,
    additionalProps: {
      ref: yt
    },
    ownerState: Pi,
    className: $i.root
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Oi, {
    ...Di,
    children: ti
  });
});
process.env.NODE_ENV !== "production" && (Tab.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions. It currently only supports `focusVisible()` action.
   */
  action: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      focusVisible: PropTypes.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * Callback invoked when new value is being set.
   */
  onChange: PropTypes.func,
  /**
   * The props used for each slot inside the Tab.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Tab.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * You can provide your own value. Otherwise, it falls back to the child position index.
   */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
});
const Button = (pt) => {
  const {
    children: yt,
    label: ir,
    type: ti = "outlined",
    state: ii = "default",
    handleClick: ui = () => {
    },
    iconLeft: ai,
    iconRight: li,
    iconTop: oi,
    iconBottom: si,
    ...di
  } = pt;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("alc-button", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Button$1,
    {
      className: [ti, ii].join(" ").replace(/\s+/, " ").trim(),
      disabled: ii === "disabled",
      onClick: ui,
      ...di,
      children: [
        ai && /* @__PURE__ */ jsxRuntimeExports.jsx("i", { "aria-hidden": !0, className: `icon-left ${ai}` }),
        oi && /* @__PURE__ */ jsxRuntimeExports.jsx("i", { "aria-hidden": !0, className: `icon-top ${oi}` }),
        yt,
        ir,
        li && /* @__PURE__ */ jsxRuntimeExports.jsx("i", { "aria-hidden": !0, className: `icon-right ${li}` }),
        si && /* @__PURE__ */ jsxRuntimeExports.jsx("i", { "aria-hidden": !0, className: `icon-bottom ${si}` })
      ]
    }
  ) });
};
Button.propTypes = {
  /**
  * Callback on a click of the button
   * @default () => {}
  */
  handleClick: PropTypes.func,
  /**
   * The content passed as children (slots)
   */
  children: PropTypes.node,
  /**
  * Icon to display on the left side of the label
  */
  iconLeft: PropTypes.string,
  /**
  * Icon to display on the right side of the label
  */
  iconRight: PropTypes.string,
  /**
  * Icon to display on the top of the label
  */
  iconTop: PropTypes.string,
  /**
  * Icon to display on the bottom of the label
  */
  iconBottom: PropTypes.string,
  /**
   * Text to display in the button. The text will default to be all uppercase
  */
  label: PropTypes.string.isRequired,
  /**
  * State of the button
   * @default default
  */
  state: PropTypes.oneOf([
    "default",
    "active",
    "disabled",
    "error"
  ]),
  /**
  * Styling type for the button
   * @default outlined
  */
  type: PropTypes.oneOf([
    "browse",
    "filled",
    "outlined",
    "text"
  ])
};
function composeClasses$2(pt, yt, ir = void 0) {
  const ti = {};
  for (const ii in pt) {
    const ui = pt[ii];
    let ai = "", li = !0;
    for (let oi = 0; oi < ui.length; oi += 1) {
      const si = ui[oi];
      si && (ai += (li === !0 ? "" : " ") + yt(si), li = !1, ir && ir[si] && (ai += " " + ir[si]));
    }
    ti[ii] = ai;
  }
  return ti;
}
const refType$2 = PropTypes.oneOfType([PropTypes.func, PropTypes.object]);
function formatMuiErrorMessage$2(pt, ...yt) {
  const ir = new URL(`https://mui.com/production-error/?code=${pt}`);
  return yt.forEach((ti) => ir.searchParams.append("args[]", ti)), `Minified MUI error #${pt}; visit ${ir} for the full message.`;
}
function capitalize$1(pt) {
  if (typeof pt != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : formatMuiErrorMessage$2(7));
  return pt.charAt(0).toUpperCase() + pt.slice(1);
}
function slotShouldForwardProp$1(pt) {
  return pt !== "ownerState" && pt !== "theme" && pt !== "sx" && pt !== "as";
}
const rootShouldForwardProp$1 = (pt) => slotShouldForwardProp$1(pt) && pt !== "classes";
var reactIs$1$1 = { exports: {} }, reactIs_production$1 = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production$1;
function requireReactIs_production$1() {
  if (hasRequiredReactIs_production$1) return reactIs_production$1;
  hasRequiredReactIs_production$1 = 1;
  var pt = Symbol.for("react.transitional.element"), yt = Symbol.for("react.portal"), ir = Symbol.for("react.fragment"), ti = Symbol.for("react.strict_mode"), ii = Symbol.for("react.profiler"), ui = Symbol.for("react.consumer"), ai = Symbol.for("react.context"), li = Symbol.for("react.forward_ref"), oi = Symbol.for("react.suspense"), si = Symbol.for("react.suspense_list"), di = Symbol.for("react.memo"), fi = Symbol.for("react.lazy"), gi = Symbol.for("react.view_transition"), mi = Symbol.for("react.client.reference");
  function Ti(vi) {
    if (typeof vi == "object" && vi !== null) {
      var xi = vi.$$typeof;
      switch (xi) {
        case pt:
          switch (vi = vi.type, vi) {
            case ir:
            case ii:
            case ti:
            case oi:
            case si:
            case gi:
              return vi;
            default:
              switch (vi = vi && vi.$$typeof, vi) {
                case ai:
                case li:
                case fi:
                case di:
                  return vi;
                case ui:
                  return vi;
                default:
                  return xi;
              }
          }
        case yt:
          return xi;
      }
    }
  }
  return reactIs_production$1.ContextConsumer = ui, reactIs_production$1.ContextProvider = ai, reactIs_production$1.Element = pt, reactIs_production$1.ForwardRef = li, reactIs_production$1.Fragment = ir, reactIs_production$1.Lazy = fi, reactIs_production$1.Memo = di, reactIs_production$1.Portal = yt, reactIs_production$1.Profiler = ii, reactIs_production$1.StrictMode = ti, reactIs_production$1.Suspense = oi, reactIs_production$1.SuspenseList = si, reactIs_production$1.isContextConsumer = function(vi) {
    return Ti(vi) === ui;
  }, reactIs_production$1.isContextProvider = function(vi) {
    return Ti(vi) === ai;
  }, reactIs_production$1.isElement = function(vi) {
    return typeof vi == "object" && vi !== null && vi.$$typeof === pt;
  }, reactIs_production$1.isForwardRef = function(vi) {
    return Ti(vi) === li;
  }, reactIs_production$1.isFragment = function(vi) {
    return Ti(vi) === ir;
  }, reactIs_production$1.isLazy = function(vi) {
    return Ti(vi) === fi;
  }, reactIs_production$1.isMemo = function(vi) {
    return Ti(vi) === di;
  }, reactIs_production$1.isPortal = function(vi) {
    return Ti(vi) === yt;
  }, reactIs_production$1.isProfiler = function(vi) {
    return Ti(vi) === ii;
  }, reactIs_production$1.isStrictMode = function(vi) {
    return Ti(vi) === ti;
  }, reactIs_production$1.isSuspense = function(vi) {
    return Ti(vi) === oi;
  }, reactIs_production$1.isSuspenseList = function(vi) {
    return Ti(vi) === si;
  }, reactIs_production$1.isValidElementType = function(vi) {
    return typeof vi == "string" || typeof vi == "function" || vi === ir || vi === ii || vi === ti || vi === oi || vi === si || typeof vi == "object" && vi !== null && (vi.$$typeof === fi || vi.$$typeof === di || vi.$$typeof === ai || vi.$$typeof === ui || vi.$$typeof === li || vi.$$typeof === mi || vi.getModuleId !== void 0);
  }, reactIs_production$1.typeOf = Ti, reactIs_production$1;
}
var reactIs_development$1$1 = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development$1$1;
function requireReactIs_development$1$1() {
  return hasRequiredReactIs_development$1$1 || (hasRequiredReactIs_development$1$1 = 1, process.env.NODE_ENV !== "production" && (function() {
    function pt(vi) {
      if (typeof vi == "object" && vi !== null) {
        var xi = vi.$$typeof;
        switch (xi) {
          case yt:
            switch (vi = vi.type, vi) {
              case ti:
              case ui:
              case ii:
              case si:
              case di:
              case mi:
                return vi;
              default:
                switch (vi = vi && vi.$$typeof, vi) {
                  case li:
                  case oi:
                  case gi:
                  case fi:
                    return vi;
                  case ai:
                    return vi;
                  default:
                    return xi;
                }
            }
          case ir:
            return xi;
        }
      }
    }
    var yt = Symbol.for("react.transitional.element"), ir = Symbol.for("react.portal"), ti = Symbol.for("react.fragment"), ii = Symbol.for("react.strict_mode"), ui = Symbol.for("react.profiler"), ai = Symbol.for("react.consumer"), li = Symbol.for("react.context"), oi = Symbol.for("react.forward_ref"), si = Symbol.for("react.suspense"), di = Symbol.for("react.suspense_list"), fi = Symbol.for("react.memo"), gi = Symbol.for("react.lazy"), mi = Symbol.for("react.view_transition"), Ti = Symbol.for("react.client.reference");
    reactIs_development$1$1.ContextConsumer = ai, reactIs_development$1$1.ContextProvider = li, reactIs_development$1$1.Element = yt, reactIs_development$1$1.ForwardRef = oi, reactIs_development$1$1.Fragment = ti, reactIs_development$1$1.Lazy = gi, reactIs_development$1$1.Memo = fi, reactIs_development$1$1.Portal = ir, reactIs_development$1$1.Profiler = ui, reactIs_development$1$1.StrictMode = ii, reactIs_development$1$1.Suspense = si, reactIs_development$1$1.SuspenseList = di, reactIs_development$1$1.isContextConsumer = function(vi) {
      return pt(vi) === ai;
    }, reactIs_development$1$1.isContextProvider = function(vi) {
      return pt(vi) === li;
    }, reactIs_development$1$1.isElement = function(vi) {
      return typeof vi == "object" && vi !== null && vi.$$typeof === yt;
    }, reactIs_development$1$1.isForwardRef = function(vi) {
      return pt(vi) === oi;
    }, reactIs_development$1$1.isFragment = function(vi) {
      return pt(vi) === ti;
    }, reactIs_development$1$1.isLazy = function(vi) {
      return pt(vi) === gi;
    }, reactIs_development$1$1.isMemo = function(vi) {
      return pt(vi) === fi;
    }, reactIs_development$1$1.isPortal = function(vi) {
      return pt(vi) === ir;
    }, reactIs_development$1$1.isProfiler = function(vi) {
      return pt(vi) === ui;
    }, reactIs_development$1$1.isStrictMode = function(vi) {
      return pt(vi) === ii;
    }, reactIs_development$1$1.isSuspense = function(vi) {
      return pt(vi) === si;
    }, reactIs_development$1$1.isSuspenseList = function(vi) {
      return pt(vi) === di;
    }, reactIs_development$1$1.isValidElementType = function(vi) {
      return typeof vi == "string" || typeof vi == "function" || vi === ti || vi === ui || vi === ii || vi === si || vi === di || typeof vi == "object" && vi !== null && (vi.$$typeof === gi || vi.$$typeof === fi || vi.$$typeof === li || vi.$$typeof === ai || vi.$$typeof === oi || vi.$$typeof === Ti || vi.getModuleId !== void 0);
    }, reactIs_development$1$1.typeOf = pt;
  })()), reactIs_development$1$1;
}
var hasRequiredReactIs$1$1;
function requireReactIs$1$1() {
  return hasRequiredReactIs$1$1 || (hasRequiredReactIs$1$1 = 1, process.env.NODE_ENV === "production" ? reactIs$1$1.exports = /* @__PURE__ */ requireReactIs_production$1() : reactIs$1$1.exports = /* @__PURE__ */ requireReactIs_development$1$1()), reactIs$1$1.exports;
}
var reactIsExports$2 = /* @__PURE__ */ requireReactIs$1$1();
function isPlainObject$6(pt) {
  if (typeof pt != "object" || pt === null)
    return !1;
  const yt = Object.getPrototypeOf(pt);
  return (yt === null || yt === Object.prototype || Object.getPrototypeOf(yt) === null) && !(Symbol.toStringTag in pt) && !(Symbol.iterator in pt);
}
function deepClone$1(pt) {
  if (/* @__PURE__ */ React.isValidElement(pt) || reactIsExports$2.isValidElementType(pt) || !isPlainObject$6(pt))
    return pt;
  const yt = {};
  return Object.keys(pt).forEach((ir) => {
    yt[ir] = deepClone$1(pt[ir]);
  }), yt;
}
function deepmerge$1(pt, yt, ir = {
  clone: !0
}) {
  const ti = ir.clone ? {
    ...pt
  } : pt;
  return isPlainObject$6(pt) && isPlainObject$6(yt) && Object.keys(yt).forEach((ii) => {
    /* @__PURE__ */ React.isValidElement(yt[ii]) || reactIsExports$2.isValidElementType(yt[ii]) ? ti[ii] = yt[ii] : isPlainObject$6(yt[ii]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(pt, ii) && isPlainObject$6(pt[ii]) ? ti[ii] = deepmerge$1(pt[ii], yt[ii], ir) : ir.clone ? ti[ii] = isPlainObject$6(yt[ii]) ? deepClone$1(yt[ii]) : yt[ii] : ti[ii] = yt[ii];
  }), ti;
}
function merge$1(pt, yt) {
  return yt ? deepmerge$1(pt, yt, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : pt;
}
const responsivePropType$1 = process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {};
function sortContainerQueries$1(pt, yt) {
  if (!pt.containerQueries)
    return yt;
  const ir = Object.keys(yt).filter((ti) => ti.startsWith("@container")).sort((ti, ii) => {
    var ui, ai;
    const li = /min-width:\s*([0-9.]+)/;
    return +(((ui = ti.match(li)) == null ? void 0 : ui[1]) || 0) - +(((ai = ii.match(li)) == null ? void 0 : ai[1]) || 0);
  });
  return ir.length ? ir.reduce((ti, ii) => {
    const ui = yt[ii];
    return delete ti[ii], ti[ii] = ui, ti;
  }, {
    ...yt
  }) : yt;
}
function isCqShorthand$1(pt, yt) {
  return yt === "@" || yt.startsWith("@") && (pt.some((ir) => yt.startsWith(`@${ir}`)) || !!yt.match(/^@\d/));
}
function getContainerQuery$1(pt, yt) {
  const ir = yt.match(/^@([^/]+)?\/?(.+)?$/);
  if (!ir) {
    if (process.env.NODE_ENV !== "production")
      throw (
        /* minify-error */
        new Error(`MUI: The provided shorthand ${`(${yt})`} is invalid. The format should be \`@<breakpoint | number>\` or \`@<breakpoint | number>/<container>\`.
For example, \`@sm\` or \`@600\` or \`@40rem/sidebar\`.`)
      );
    return null;
  }
  const [, ti, ii] = ir, ui = Number.isNaN(+ti) ? ti || 0 : +ti;
  return pt.containerQueries(ii).up(ui);
}
function cssContainerQueries$1(pt) {
  const yt = (ui, ai) => ui.replace("@media", ai ? `@container ${ai}` : "@container");
  function ir(ui, ai) {
    ui.up = (...li) => yt(pt.breakpoints.up(...li), ai), ui.down = (...li) => yt(pt.breakpoints.down(...li), ai), ui.between = (...li) => yt(pt.breakpoints.between(...li), ai), ui.only = (...li) => yt(pt.breakpoints.only(...li), ai), ui.not = (...li) => {
      const oi = yt(pt.breakpoints.not(...li), ai);
      return oi.includes("not all and") ? oi.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or") : oi;
    };
  }
  const ti = {}, ii = (ui) => (ir(ti, ui), ti);
  return ir(ii), {
    ...pt,
    containerQueries: ii
  };
}
const values$1$1 = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, defaultBreakpoints$1 = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (pt) => `@media (min-width:${values$1$1[pt]}px)`
}, defaultContainerQueries$1 = {
  containerQueries: (pt) => ({
    up: (yt) => {
      let ir = typeof yt == "number" ? yt : values$1$1[yt] || yt;
      return typeof ir == "number" && (ir = `${ir}px`), pt ? `@container ${pt} (min-width:${ir})` : `@container (min-width:${ir})`;
    }
  })
};
function handleBreakpoints$1(pt, yt, ir) {
  const ti = pt.theme || {};
  if (Array.isArray(yt)) {
    const ii = ti.breakpoints || defaultBreakpoints$1;
    return yt.reduce((ui, ai, li) => (ui[ii.up(ii.keys[li])] = ir(yt[li]), ui), {});
  }
  if (typeof yt == "object") {
    const ii = ti.breakpoints || defaultBreakpoints$1;
    return Object.keys(yt).reduce((ui, ai) => {
      if (isCqShorthand$1(ii.keys, ai)) {
        const li = getContainerQuery$1(ti.containerQueries ? ti : defaultContainerQueries$1, ai);
        li && (ui[li] = ir(yt[ai], ai));
      } else if (Object.keys(ii.values || values$1$1).includes(ai)) {
        const li = ii.up(ai);
        ui[li] = ir(yt[ai], ai);
      } else {
        const li = ai;
        ui[li] = yt[li];
      }
      return ui;
    }, {});
  }
  return ir(yt);
}
function createEmptyBreakpointObject$1(pt = {}) {
  var yt;
  return ((yt = pt.keys) == null ? void 0 : yt.reduce((ir, ti) => {
    const ii = pt.up(ti);
    return ir[ii] = {}, ir;
  }, {})) || {};
}
function removeUnusedBreakpoints$1(pt, yt) {
  return pt.reduce((ir, ti) => {
    const ii = ir[ti];
    return (!ii || Object.keys(ii).length === 0) && delete ir[ti], ir;
  }, yt);
}
function getPath$2(pt, yt, ir = !0) {
  if (!yt || typeof yt != "string")
    return null;
  if (pt && pt.vars && ir) {
    const ti = `vars.${yt}`.split(".").reduce((ii, ui) => ii && ii[ui] ? ii[ui] : null, pt);
    if (ti != null)
      return ti;
  }
  return yt.split(".").reduce((ti, ii) => ti && ti[ii] != null ? ti[ii] : null, pt);
}
function getStyleValue$1(pt, yt, ir, ti = ir) {
  let ii;
  return typeof pt == "function" ? ii = pt(ir) : Array.isArray(pt) ? ii = pt[ir] || ti : ii = getPath$2(pt, ir) || ti, yt && (ii = yt(ii, ti, pt)), ii;
}
function style$1$1(pt) {
  const {
    prop: yt,
    cssProperty: ir = pt.prop,
    themeKey: ti,
    transform: ii
  } = pt, ui = (ai) => {
    if (ai[yt] == null)
      return null;
    const li = ai[yt], oi = ai.theme, si = getPath$2(oi, ti) || {};
    return handleBreakpoints$1(ai, li, (di) => {
      let fi = getStyleValue$1(si, ii, di);
      return di === fi && typeof di == "string" && (fi = getStyleValue$1(si, ii, `${yt}${di === "default" ? "" : capitalize$1(di)}`, di)), ir === !1 ? fi : {
        [ir]: fi
      };
    });
  };
  return ui.propTypes = process.env.NODE_ENV !== "production" ? {
    [yt]: responsivePropType$1
  } : {}, ui.filterProps = [yt], ui;
}
function memoize$1$1(pt) {
  const yt = {};
  return (ir) => (yt[ir] === void 0 && (yt[ir] = pt(ir)), yt[ir]);
}
const properties$1 = {
  m: "margin",
  p: "padding"
}, directions$1 = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, aliases$1 = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, getCssProperties$1 = memoize$1$1((pt) => {
  if (pt.length > 2)
    if (aliases$1[pt])
      pt = aliases$1[pt];
    else
      return [pt];
  const [yt, ir] = pt.split(""), ti = properties$1[yt], ii = directions$1[ir] || "";
  return Array.isArray(ii) ? ii.map((ui) => ti + ui) : [ti + ii];
}), marginKeys$1 = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], paddingKeys$1 = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], spacingKeys$1 = [...marginKeys$1, ...paddingKeys$1];
function createUnaryUnit$1(pt, yt, ir, ti) {
  const ii = getPath$2(pt, yt, !0) ?? ir;
  return typeof ii == "number" || typeof ii == "string" ? (ui) => typeof ui == "string" ? ui : (process.env.NODE_ENV !== "production" && typeof ui != "number" && console.error(`MUI: Expected ${ti} argument to be a number or a string, got ${ui}.`), typeof ii == "string" ? ii.startsWith("var(") && ui === 0 ? 0 : ii.startsWith("var(") && ui === 1 ? ii : `calc(${ui} * ${ii})` : ii * ui) : Array.isArray(ii) ? (ui) => {
    if (typeof ui == "string")
      return ui;
    const ai = Math.abs(ui);
    process.env.NODE_ENV !== "production" && (Number.isInteger(ai) ? ai > ii.length - 1 && console.error([`MUI: The value provided (${ai}) overflows.`, `The supported values are: ${JSON.stringify(ii)}.`, `${ai} > ${ii.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${yt}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${yt}\` as a number.`].join(`
`)));
    const li = ii[ai];
    return ui >= 0 ? li : typeof li == "number" ? -li : typeof li == "string" && li.startsWith("var(") ? `calc(-1 * ${li})` : `-${li}`;
  } : typeof ii == "function" ? ii : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${yt}\` value (${ii}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function createUnarySpacing$1(pt) {
  return createUnaryUnit$1(pt, "spacing", 8, "spacing");
}
function getValue$1(pt, yt) {
  return typeof yt == "string" || yt == null ? yt : pt(yt);
}
function getStyleFromPropValue$1(pt, yt) {
  return (ir) => pt.reduce((ti, ii) => (ti[ii] = getValue$1(yt, ir), ti), {});
}
function resolveCssProperty$1(pt, yt, ir, ti) {
  if (!yt.includes(ir))
    return null;
  const ii = getCssProperties$1(ir), ui = getStyleFromPropValue$1(ii, ti), ai = pt[ir];
  return handleBreakpoints$1(pt, ai, ui);
}
function style$2(pt, yt) {
  const ir = createUnarySpacing$1(pt.theme);
  return Object.keys(pt).map((ti) => resolveCssProperty$1(pt, yt, ti, ir)).reduce(merge$1, {});
}
function margin$1(pt) {
  return style$2(pt, marginKeys$1);
}
margin$1.propTypes = process.env.NODE_ENV !== "production" ? marginKeys$1.reduce((pt, yt) => (pt[yt] = responsivePropType$1, pt), {}) : {};
margin$1.filterProps = marginKeys$1;
function padding$1(pt) {
  return style$2(pt, paddingKeys$1);
}
padding$1.propTypes = process.env.NODE_ENV !== "production" ? paddingKeys$1.reduce((pt, yt) => (pt[yt] = responsivePropType$1, pt), {}) : {};
padding$1.filterProps = paddingKeys$1;
process.env.NODE_ENV !== "production" && spacingKeys$1.reduce((pt, yt) => (pt[yt] = responsivePropType$1, pt), {});
function compose$1(...pt) {
  const yt = pt.reduce((ti, ii) => (ii.filterProps.forEach((ui) => {
    ti[ui] = ii;
  }), ti), {}), ir = (ti) => Object.keys(ti).reduce((ii, ui) => yt[ui] ? merge$1(ii, yt[ui](ti)) : ii, {});
  return ir.propTypes = process.env.NODE_ENV !== "production" ? pt.reduce((ti, ii) => Object.assign(ti, ii.propTypes), {}) : {}, ir.filterProps = pt.reduce((ti, ii) => ti.concat(ii.filterProps), []), ir;
}
function borderTransform$1(pt) {
  return typeof pt != "number" ? pt : `${pt}px solid`;
}
function createBorderStyle$1(pt, yt) {
  return style$1$1({
    prop: pt,
    themeKey: "borders",
    transform: yt
  });
}
const border$1 = createBorderStyle$1("border", borderTransform$1), borderTop$1 = createBorderStyle$1("borderTop", borderTransform$1), borderRight$1 = createBorderStyle$1("borderRight", borderTransform$1), borderBottom$1 = createBorderStyle$1("borderBottom", borderTransform$1), borderLeft$1 = createBorderStyle$1("borderLeft", borderTransform$1), borderColor$1 = createBorderStyle$1("borderColor"), borderTopColor$1 = createBorderStyle$1("borderTopColor"), borderRightColor$1 = createBorderStyle$1("borderRightColor"), borderBottomColor$1 = createBorderStyle$1("borderBottomColor"), borderLeftColor$1 = createBorderStyle$1("borderLeftColor"), outline$1 = createBorderStyle$1("outline", borderTransform$1), outlineColor$1 = createBorderStyle$1("outlineColor"), borderRadius$1 = (pt) => {
  if (pt.borderRadius !== void 0 && pt.borderRadius !== null) {
    const yt = createUnaryUnit$1(pt.theme, "shape.borderRadius", 4, "borderRadius"), ir = (ti) => ({
      borderRadius: getValue$1(yt, ti)
    });
    return handleBreakpoints$1(pt, pt.borderRadius, ir);
  }
  return null;
};
borderRadius$1.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: responsivePropType$1
} : {};
borderRadius$1.filterProps = ["borderRadius"];
compose$1(border$1, borderTop$1, borderRight$1, borderBottom$1, borderLeft$1, borderColor$1, borderTopColor$1, borderRightColor$1, borderBottomColor$1, borderLeftColor$1, borderRadius$1, outline$1, outlineColor$1);
const gap$1 = (pt) => {
  if (pt.gap !== void 0 && pt.gap !== null) {
    const yt = createUnaryUnit$1(pt.theme, "spacing", 8, "gap"), ir = (ti) => ({
      gap: getValue$1(yt, ti)
    });
    return handleBreakpoints$1(pt, pt.gap, ir);
  }
  return null;
};
gap$1.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: responsivePropType$1
} : {};
gap$1.filterProps = ["gap"];
const columnGap$1 = (pt) => {
  if (pt.columnGap !== void 0 && pt.columnGap !== null) {
    const yt = createUnaryUnit$1(pt.theme, "spacing", 8, "columnGap"), ir = (ti) => ({
      columnGap: getValue$1(yt, ti)
    });
    return handleBreakpoints$1(pt, pt.columnGap, ir);
  }
  return null;
};
columnGap$1.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: responsivePropType$1
} : {};
columnGap$1.filterProps = ["columnGap"];
const rowGap$1 = (pt) => {
  if (pt.rowGap !== void 0 && pt.rowGap !== null) {
    const yt = createUnaryUnit$1(pt.theme, "spacing", 8, "rowGap"), ir = (ti) => ({
      rowGap: getValue$1(yt, ti)
    });
    return handleBreakpoints$1(pt, pt.rowGap, ir);
  }
  return null;
};
rowGap$1.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: responsivePropType$1
} : {};
rowGap$1.filterProps = ["rowGap"];
const gridColumn$1 = style$1$1({
  prop: "gridColumn"
}), gridRow$1 = style$1$1({
  prop: "gridRow"
}), gridAutoFlow$1 = style$1$1({
  prop: "gridAutoFlow"
}), gridAutoColumns$1 = style$1$1({
  prop: "gridAutoColumns"
}), gridAutoRows$1 = style$1$1({
  prop: "gridAutoRows"
}), gridTemplateColumns$1 = style$1$1({
  prop: "gridTemplateColumns"
}), gridTemplateRows$1 = style$1$1({
  prop: "gridTemplateRows"
}), gridTemplateAreas$1 = style$1$1({
  prop: "gridTemplateAreas"
}), gridArea$1 = style$1$1({
  prop: "gridArea"
});
compose$1(gap$1, columnGap$1, rowGap$1, gridColumn$1, gridRow$1, gridAutoFlow$1, gridAutoColumns$1, gridAutoRows$1, gridTemplateColumns$1, gridTemplateRows$1, gridTemplateAreas$1, gridArea$1);
function paletteTransform$1(pt, yt) {
  return yt === "grey" ? yt : pt;
}
const color$1 = style$1$1({
  prop: "color",
  themeKey: "palette",
  transform: paletteTransform$1
}), bgcolor$1 = style$1$1({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: paletteTransform$1
}), backgroundColor$1 = style$1$1({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: paletteTransform$1
});
compose$1(color$1, bgcolor$1, backgroundColor$1);
function sizingTransform$1(pt) {
  return pt <= 1 && pt !== 0 ? `${pt * 100}%` : pt;
}
const width$1 = style$1$1({
  prop: "width",
  transform: sizingTransform$1
}), maxWidth$1 = (pt) => {
  if (pt.maxWidth !== void 0 && pt.maxWidth !== null) {
    const yt = (ir) => {
      var ti, ii, ui, ai, li;
      const oi = ((ui = (ii = (ti = pt.theme) == null ? void 0 : ti.breakpoints) == null ? void 0 : ii.values) == null ? void 0 : ui[ir]) || values$1$1[ir];
      return oi ? ((li = (ai = pt.theme) == null ? void 0 : ai.breakpoints) == null ? void 0 : li.unit) !== "px" ? {
        maxWidth: `${oi}${pt.theme.breakpoints.unit}`
      } : {
        maxWidth: oi
      } : {
        maxWidth: sizingTransform$1(ir)
      };
    };
    return handleBreakpoints$1(pt, pt.maxWidth, yt);
  }
  return null;
};
maxWidth$1.filterProps = ["maxWidth"];
const minWidth$1 = style$1$1({
  prop: "minWidth",
  transform: sizingTransform$1
}), height$1 = style$1$1({
  prop: "height",
  transform: sizingTransform$1
}), maxHeight$1 = style$1$1({
  prop: "maxHeight",
  transform: sizingTransform$1
}), minHeight$1 = style$1$1({
  prop: "minHeight",
  transform: sizingTransform$1
});
style$1$1({
  prop: "size",
  cssProperty: "width",
  transform: sizingTransform$1
});
style$1$1({
  prop: "size",
  cssProperty: "height",
  transform: sizingTransform$1
});
const boxSizing$1 = style$1$1({
  prop: "boxSizing"
});
compose$1(width$1, maxWidth$1, minWidth$1, height$1, maxHeight$1, minHeight$1, boxSizing$1);
const defaultSxConfig$1 = {
  // borders
  border: {
    themeKey: "borders",
    transform: borderTransform$1
  },
  borderTop: {
    themeKey: "borders",
    transform: borderTransform$1
  },
  borderRight: {
    themeKey: "borders",
    transform: borderTransform$1
  },
  borderBottom: {
    themeKey: "borders",
    transform: borderTransform$1
  },
  borderLeft: {
    themeKey: "borders",
    transform: borderTransform$1
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: borderTransform$1
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: borderRadius$1
  },
  // palette
  color: {
    themeKey: "palette",
    transform: paletteTransform$1
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: paletteTransform$1
  },
  backgroundColor: {
    themeKey: "palette",
    transform: paletteTransform$1
  },
  // spacing
  p: {
    style: padding$1
  },
  pt: {
    style: padding$1
  },
  pr: {
    style: padding$1
  },
  pb: {
    style: padding$1
  },
  pl: {
    style: padding$1
  },
  px: {
    style: padding$1
  },
  py: {
    style: padding$1
  },
  padding: {
    style: padding$1
  },
  paddingTop: {
    style: padding$1
  },
  paddingRight: {
    style: padding$1
  },
  paddingBottom: {
    style: padding$1
  },
  paddingLeft: {
    style: padding$1
  },
  paddingX: {
    style: padding$1
  },
  paddingY: {
    style: padding$1
  },
  paddingInline: {
    style: padding$1
  },
  paddingInlineStart: {
    style: padding$1
  },
  paddingInlineEnd: {
    style: padding$1
  },
  paddingBlock: {
    style: padding$1
  },
  paddingBlockStart: {
    style: padding$1
  },
  paddingBlockEnd: {
    style: padding$1
  },
  m: {
    style: margin$1
  },
  mt: {
    style: margin$1
  },
  mr: {
    style: margin$1
  },
  mb: {
    style: margin$1
  },
  ml: {
    style: margin$1
  },
  mx: {
    style: margin$1
  },
  my: {
    style: margin$1
  },
  margin: {
    style: margin$1
  },
  marginTop: {
    style: margin$1
  },
  marginRight: {
    style: margin$1
  },
  marginBottom: {
    style: margin$1
  },
  marginLeft: {
    style: margin$1
  },
  marginX: {
    style: margin$1
  },
  marginY: {
    style: margin$1
  },
  marginInline: {
    style: margin$1
  },
  marginInlineStart: {
    style: margin$1
  },
  marginInlineEnd: {
    style: margin$1
  },
  marginBlock: {
    style: margin$1
  },
  marginBlockStart: {
    style: margin$1
  },
  marginBlockEnd: {
    style: margin$1
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (pt) => ({
      "@media print": {
        display: pt
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: gap$1
  },
  rowGap: {
    style: rowGap$1
  },
  columnGap: {
    style: columnGap$1
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: sizingTransform$1
  },
  maxWidth: {
    style: maxWidth$1
  },
  minWidth: {
    transform: sizingTransform$1
  },
  height: {
    transform: sizingTransform$1
  },
  maxHeight: {
    transform: sizingTransform$1
  },
  minHeight: {
    transform: sizingTransform$1
  },
  boxSizing: {},
  // typography
  font: {
    themeKey: "font"
  },
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function objectsHaveSameKeys$1(...pt) {
  const yt = pt.reduce((ti, ii) => ti.concat(Object.keys(ii)), []), ir = new Set(yt);
  return pt.every((ti) => ir.size === Object.keys(ti).length);
}
function callIfFn$1(pt, yt) {
  return typeof pt == "function" ? pt(yt) : pt;
}
function unstable_createStyleFunctionSx$1() {
  function pt(ir, ti, ii, ui) {
    const ai = {
      [ir]: ti,
      theme: ii
    }, li = ui[ir];
    if (!li)
      return {
        [ir]: ti
      };
    const {
      cssProperty: oi = ir,
      themeKey: si,
      transform: di,
      style: fi
    } = li;
    if (ti == null)
      return null;
    if (si === "typography" && ti === "inherit")
      return {
        [ir]: ti
      };
    const gi = getPath$2(ii, si) || {};
    return fi ? fi(ai) : handleBreakpoints$1(ai, ti, (mi) => {
      let Ti = getStyleValue$1(gi, di, mi);
      return mi === Ti && typeof mi == "string" && (Ti = getStyleValue$1(gi, di, `${ir}${mi === "default" ? "" : capitalize$1(mi)}`, mi)), oi === !1 ? Ti : {
        [oi]: Ti
      };
    });
  }
  function yt(ir) {
    const {
      sx: ti,
      theme: ii = {},
      nested: ui
    } = ir || {};
    if (!ti)
      return null;
    const ai = ii.unstable_sxConfig ?? defaultSxConfig$1;
    function li(oi) {
      let si = oi;
      if (typeof oi == "function")
        si = oi(ii);
      else if (typeof oi != "object")
        return oi;
      if (!si)
        return null;
      const di = createEmptyBreakpointObject$1(ii.breakpoints), fi = Object.keys(di);
      let gi = di;
      return Object.keys(si).forEach((mi) => {
        const Ti = callIfFn$1(si[mi], ii);
        if (Ti != null)
          if (typeof Ti == "object")
            if (ai[mi])
              gi = merge$1(gi, pt(mi, Ti, ii, ai));
            else {
              const vi = handleBreakpoints$1({
                theme: ii
              }, Ti, (xi) => ({
                [mi]: xi
              }));
              objectsHaveSameKeys$1(vi, Ti) ? gi[mi] = yt({
                sx: Ti,
                theme: ii,
                nested: !0
              }) : gi = merge$1(gi, vi);
            }
          else
            gi = merge$1(gi, pt(mi, Ti, ii, ai));
      }), !ui && ii.modularCssLayers ? {
        "@layer sx": sortContainerQueries$1(ii, removeUnusedBreakpoints$1(fi, gi))
      } : sortContainerQueries$1(ii, removeUnusedBreakpoints$1(fi, gi));
    }
    return Array.isArray(ti) ? ti.map(li) : li(ti);
  }
  return yt;
}
const styleFunctionSx$1 = unstable_createStyleFunctionSx$1();
styleFunctionSx$1.filterProps = ["sx"];
const splitProps = (pt) => {
  var yt;
  const ir = {
    systemProps: {},
    otherProps: {}
  }, ti = ((yt = pt == null ? void 0 : pt.theme) == null ? void 0 : yt.unstable_sxConfig) ?? defaultSxConfig$1;
  return Object.keys(pt).forEach((ii) => {
    ti[ii] ? ir.systemProps[ii] = pt[ii] : ir.otherProps[ii] = pt[ii];
  }), ir;
};
function extendSxProp$1(pt) {
  const {
    sx: yt,
    ...ir
  } = pt, {
    systemProps: ti,
    otherProps: ii
  } = splitProps(ir);
  let ui;
  return Array.isArray(yt) ? ui = [ti, ...yt] : typeof yt == "function" ? ui = (...ai) => {
    const li = yt(...ai);
    return isPlainObject$6(li) ? {
      ...ti,
      ...li
    } : ti;
  } : ui = {
    ...ti,
    ...yt
  }, {
    ...ii,
    sx: ui
  };
}
function _extends$q() {
  return _extends$q = Object.assign ? Object.assign.bind() : function(pt) {
    for (var yt = 1; yt < arguments.length; yt++) {
      var ir = arguments[yt];
      for (var ti in ir) ({}).hasOwnProperty.call(ir, ti) && (pt[ti] = ir[ti]);
    }
    return pt;
  }, _extends$q.apply(null, arguments);
}
function sheetForTag$1(pt) {
  if (pt.sheet)
    return pt.sheet;
  for (var yt = 0; yt < document.styleSheets.length; yt++)
    if (document.styleSheets[yt].ownerNode === pt)
      return document.styleSheets[yt];
}
function createStyleElement$1(pt) {
  var yt = document.createElement("style");
  return yt.setAttribute("data-emotion", pt.key), pt.nonce !== void 0 && yt.setAttribute("nonce", pt.nonce), yt.appendChild(document.createTextNode("")), yt.setAttribute("data-s", ""), yt;
}
var StyleSheet$1 = /* @__PURE__ */ (function() {
  function pt(ir) {
    var ti = this;
    this._insertTag = function(ii) {
      var ui;
      ti.tags.length === 0 ? ti.insertionPoint ? ui = ti.insertionPoint.nextSibling : ti.prepend ? ui = ti.container.firstChild : ui = ti.before : ui = ti.tags[ti.tags.length - 1].nextSibling, ti.container.insertBefore(ii, ui), ti.tags.push(ii);
    }, this.isSpeedy = ir.speedy === void 0 ? !0 : ir.speedy, this.tags = [], this.ctr = 0, this.nonce = ir.nonce, this.key = ir.key, this.container = ir.container, this.prepend = ir.prepend, this.insertionPoint = ir.insertionPoint, this.before = null;
  }
  var yt = pt.prototype;
  return yt.hydrate = function(ir) {
    ir.forEach(this._insertTag);
  }, yt.insert = function(ir) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(createStyleElement$1(this));
    var ti = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var ii = sheetForTag$1(ti);
      try {
        ii.insertRule(ir, ii.cssRules.length);
      } catch {
      }
    } else
      ti.appendChild(document.createTextNode(ir));
    this.ctr++;
  }, yt.flush = function() {
    this.tags.forEach(function(ir) {
      var ti;
      return (ti = ir.parentNode) == null ? void 0 : ti.removeChild(ir);
    }), this.tags = [], this.ctr = 0;
  }, pt;
})(), MS$1 = "-ms-", MOZ$1 = "-moz-", WEBKIT$1 = "-webkit-", COMMENT$1 = "comm", RULESET$1 = "rule", DECLARATION$1 = "decl", IMPORT$1 = "@import", KEYFRAMES$1 = "@keyframes", LAYER$1 = "@layer", abs$1 = Math.abs, from$2 = String.fromCharCode, assign$2 = Object.assign;
function hash$1(pt, yt) {
  return charat$1(pt, 0) ^ 45 ? (((yt << 2 ^ charat$1(pt, 0)) << 2 ^ charat$1(pt, 1)) << 2 ^ charat$1(pt, 2)) << 2 ^ charat$1(pt, 3) : 0;
}
function trim$1(pt) {
  return pt.trim();
}
function match$1(pt, yt) {
  return (pt = yt.exec(pt)) ? pt[0] : pt;
}
function replace$1(pt, yt, ir) {
  return pt.replace(yt, ir);
}
function indexof$1(pt, yt) {
  return pt.indexOf(yt);
}
function charat$1(pt, yt) {
  return pt.charCodeAt(yt) | 0;
}
function substr$1(pt, yt, ir) {
  return pt.slice(yt, ir);
}
function strlen$1(pt) {
  return pt.length;
}
function sizeof$1(pt) {
  return pt.length;
}
function append$2(pt, yt) {
  return yt.push(pt), pt;
}
function combine$1(pt, yt) {
  return pt.map(yt).join("");
}
var line$1 = 1, column$1 = 1, length$1 = 0, position$1 = 0, character$1 = 0, characters$1 = "";
function node$1(pt, yt, ir, ti, ii, ui, ai) {
  return { value: pt, root: yt, parent: ir, type: ti, props: ii, children: ui, line: line$1, column: column$1, length: ai, return: "" };
}
function copy$3(pt, yt) {
  return assign$2(node$1("", null, null, "", null, null, 0), pt, { length: -pt.length }, yt);
}
function char$1() {
  return character$1;
}
function prev$1() {
  return character$1 = position$1 > 0 ? charat$1(characters$1, --position$1) : 0, column$1--, character$1 === 10 && (column$1 = 1, line$1--), character$1;
}
function next$1() {
  return character$1 = position$1 < length$1 ? charat$1(characters$1, position$1++) : 0, column$1++, character$1 === 10 && (column$1 = 1, line$1++), character$1;
}
function peek$3() {
  return charat$1(characters$1, position$1);
}
function caret$1() {
  return position$1;
}
function slice$1(pt, yt) {
  return substr$1(characters$1, pt, yt);
}
function token$1(pt) {
  switch (pt) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc$1(pt) {
  return line$1 = column$1 = 1, length$1 = strlen$1(characters$1 = pt), position$1 = 0, [];
}
function dealloc$1(pt) {
  return characters$1 = "", pt;
}
function delimit$1(pt) {
  return trim$1(slice$1(position$1 - 1, delimiter$1(pt === 91 ? pt + 2 : pt === 40 ? pt + 1 : pt)));
}
function whitespace$1(pt) {
  for (; (character$1 = peek$3()) && character$1 < 33; )
    next$1();
  return token$1(pt) > 2 || token$1(character$1) > 3 ? "" : " ";
}
function escaping$1(pt, yt) {
  for (; --yt && next$1() && !(character$1 < 48 || character$1 > 102 || character$1 > 57 && character$1 < 65 || character$1 > 70 && character$1 < 97); )
    ;
  return slice$1(pt, caret$1() + (yt < 6 && peek$3() == 32 && next$1() == 32));
}
function delimiter$1(pt) {
  for (; next$1(); )
    switch (character$1) {
      // ] ) " '
      case pt:
        return position$1;
      // " '
      case 34:
      case 39:
        pt !== 34 && pt !== 39 && delimiter$1(character$1);
        break;
      // (
      case 40:
        pt === 41 && delimiter$1(pt);
        break;
      // \
      case 92:
        next$1();
        break;
    }
  return position$1;
}
function commenter$1(pt, yt) {
  for (; next$1() && pt + character$1 !== 57 && !(pt + character$1 === 84 && peek$3() === 47); )
    ;
  return "/*" + slice$1(yt, position$1 - 1) + "*" + from$2(pt === 47 ? pt : next$1());
}
function identifier$1(pt) {
  for (; !token$1(peek$3()); )
    next$1();
  return slice$1(pt, position$1);
}
function compile$1(pt) {
  return dealloc$1(parse$1("", null, null, null, [""], pt = alloc$1(pt), 0, [0], pt));
}
function parse$1(pt, yt, ir, ti, ii, ui, ai, li, oi) {
  for (var si = 0, di = 0, fi = ai, gi = 0, mi = 0, Ti = 0, vi = 1, xi = 1, Si = 1, Pi = 0, $i = "", Oi = ii, Di = ui, Mi = ti, Oo = $i; xi; )
    switch (Ti = Pi, Pi = next$1()) {
      // (
      case 40:
        if (Ti != 108 && charat$1(Oo, fi - 1) == 58) {
          indexof$1(Oo += replace$1(delimit$1(Pi), "&", "&\f"), "&\f") != -1 && (Si = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        Oo += delimit$1(Pi);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        Oo += whitespace$1(Ti);
        break;
      // \
      case 92:
        Oo += escaping$1(caret$1() - 1, 7);
        continue;
      // /
      case 47:
        switch (peek$3()) {
          case 42:
          case 47:
            append$2(comment$1(commenter$1(next$1(), caret$1()), yt, ir), oi);
            break;
          default:
            Oo += "/";
        }
        break;
      // {
      case 123 * vi:
        li[si++] = strlen$1(Oo) * Si;
      // } ; \0
      case 125 * vi:
      case 59:
      case 0:
        switch (Pi) {
          // \0 }
          case 0:
          case 125:
            xi = 0;
          // ;
          case 59 + di:
            Si == -1 && (Oo = replace$1(Oo, /\f/g, "")), mi > 0 && strlen$1(Oo) - fi && append$2(mi > 32 ? declaration$1(Oo + ";", ti, ir, fi - 1) : declaration$1(replace$1(Oo, " ", "") + ";", ti, ir, fi - 2), oi);
            break;
          // @ ;
          case 59:
            Oo += ";";
          // { rule/at-rule
          default:
            if (append$2(Mi = ruleset$1(Oo, yt, ir, si, di, ii, li, $i, Oi = [], Di = [], fi), ui), Pi === 123)
              if (di === 0)
                parse$1(Oo, yt, Mi, Mi, Oi, ui, fi, li, Di);
              else
                switch (gi === 99 && charat$1(Oo, 3) === 110 ? 100 : gi) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    parse$1(pt, Mi, Mi, ti && append$2(ruleset$1(pt, Mi, Mi, 0, 0, ii, li, $i, ii, Oi = [], fi), Di), ii, Di, fi, li, ti ? Oi : Di);
                    break;
                  default:
                    parse$1(Oo, Mi, Mi, Mi, [""], Di, 0, li, Di);
                }
        }
        si = di = mi = 0, vi = Si = 1, $i = Oo = "", fi = ai;
        break;
      // :
      case 58:
        fi = 1 + strlen$1(Oo), mi = Ti;
      default:
        if (vi < 1) {
          if (Pi == 123)
            --vi;
          else if (Pi == 125 && vi++ == 0 && prev$1() == 125)
            continue;
        }
        switch (Oo += from$2(Pi), Pi * vi) {
          // &
          case 38:
            Si = di > 0 ? 1 : (Oo += "\f", -1);
            break;
          // ,
          case 44:
            li[si++] = (strlen$1(Oo) - 1) * Si, Si = 1;
            break;
          // @
          case 64:
            peek$3() === 45 && (Oo += delimit$1(next$1())), gi = peek$3(), di = fi = strlen$1($i = Oo += identifier$1(caret$1())), Pi++;
            break;
          // -
          case 45:
            Ti === 45 && strlen$1(Oo) == 2 && (vi = 0);
        }
    }
  return ui;
}
function ruleset$1(pt, yt, ir, ti, ii, ui, ai, li, oi, si, di) {
  for (var fi = ii - 1, gi = ii === 0 ? ui : [""], mi = sizeof$1(gi), Ti = 0, vi = 0, xi = 0; Ti < ti; ++Ti)
    for (var Si = 0, Pi = substr$1(pt, fi + 1, fi = abs$1(vi = ai[Ti])), $i = pt; Si < mi; ++Si)
      ($i = trim$1(vi > 0 ? gi[Si] + " " + Pi : replace$1(Pi, /&\f/g, gi[Si]))) && (oi[xi++] = $i);
  return node$1(pt, yt, ir, ii === 0 ? RULESET$1 : li, oi, si, di);
}
function comment$1(pt, yt, ir) {
  return node$1(pt, yt, ir, COMMENT$1, from$2(char$1()), substr$1(pt, 2, -2), 0);
}
function declaration$1(pt, yt, ir, ti) {
  return node$1(pt, yt, ir, DECLARATION$1, substr$1(pt, 0, ti), substr$1(pt, ti + 1, -1), ti);
}
function serialize$1(pt, yt) {
  for (var ir = "", ti = sizeof$1(pt), ii = 0; ii < ti; ii++)
    ir += yt(pt[ii], ii, pt, yt) || "";
  return ir;
}
function stringify$1(pt, yt, ir, ti) {
  switch (pt.type) {
    case LAYER$1:
      if (pt.children.length) break;
    case IMPORT$1:
    case DECLARATION$1:
      return pt.return = pt.return || pt.value;
    case COMMENT$1:
      return "";
    case KEYFRAMES$1:
      return pt.return = pt.value + "{" + serialize$1(pt.children, ti) + "}";
    case RULESET$1:
      pt.value = pt.props.join(",");
  }
  return strlen$1(ir = serialize$1(pt.children, ti)) ? pt.return = pt.value + "{" + ir + "}" : "";
}
function middleware$1(pt) {
  var yt = sizeof$1(pt);
  return function(ir, ti, ii, ui) {
    for (var ai = "", li = 0; li < yt; li++)
      ai += pt[li](ir, ti, ii, ui) || "";
    return ai;
  };
}
function rulesheet$1(pt) {
  return function(yt) {
    yt.root || (yt = yt.return) && pt(yt);
  };
}
function memoize$2(pt) {
  var yt = /* @__PURE__ */ Object.create(null);
  return function(ir) {
    return yt[ir] === void 0 && (yt[ir] = pt(ir)), yt[ir];
  };
}
var identifierWithPointTracking$1 = function(pt, yt, ir) {
  for (var ti = 0, ii = 0; ti = ii, ii = peek$3(), ti === 38 && ii === 12 && (yt[ir] = 1), !token$1(ii); )
    next$1();
  return slice$1(pt, position$1);
}, toRules$1 = function(pt, yt) {
  var ir = -1, ti = 44;
  do
    switch (token$1(ti)) {
      case 0:
        ti === 38 && peek$3() === 12 && (yt[ir] = 1), pt[ir] += identifierWithPointTracking$1(position$1 - 1, yt, ir);
        break;
      case 2:
        pt[ir] += delimit$1(ti);
        break;
      case 4:
        if (ti === 44) {
          pt[++ir] = peek$3() === 58 ? "&\f" : "", yt[ir] = pt[ir].length;
          break;
        }
      // fallthrough
      default:
        pt[ir] += from$2(ti);
    }
  while (ti = next$1());
  return pt;
}, getRules$1 = function(pt, yt) {
  return dealloc$1(toRules$1(alloc$1(pt), yt));
}, fixedElements$1 = /* @__PURE__ */ new WeakMap(), compat$1 = function(pt) {
  if (!(pt.type !== "rule" || !pt.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  pt.length < 1)) {
    for (var yt = pt.value, ir = pt.parent, ti = pt.column === ir.column && pt.line === ir.line; ir.type !== "rule"; )
      if (ir = ir.parent, !ir) return;
    if (!(pt.props.length === 1 && yt.charCodeAt(0) !== 58 && !fixedElements$1.get(ir)) && !ti) {
      fixedElements$1.set(pt, !0);
      for (var ii = [], ui = getRules$1(yt, ii), ai = ir.props, li = 0, oi = 0; li < ui.length; li++)
        for (var si = 0; si < ai.length; si++, oi++)
          pt.props[oi] = ii[li] ? ui[li].replace(/&\f/g, ai[si]) : ai[si] + " " + ui[li];
    }
  }
}, removeLabel$1 = function(pt) {
  if (pt.type === "decl") {
    var yt = pt.value;
    yt.charCodeAt(0) === 108 && // charcode for b
    yt.charCodeAt(2) === 98 && (pt.return = "", pt.value = "");
  }
};
function prefix$2(pt, yt) {
  switch (hash$1(pt, yt)) {
    // color-adjust
    case 5103:
      return WEBKIT$1 + "print-" + pt + pt;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT$1 + pt + pt;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT$1 + pt + MOZ$1 + pt + MS$1 + pt + pt;
    // flex, flex-direction
    case 6828:
    case 4268:
      return WEBKIT$1 + pt + MS$1 + pt + pt;
    // order
    case 6165:
      return WEBKIT$1 + pt + MS$1 + "flex-" + pt + pt;
    // align-items
    case 5187:
      return WEBKIT$1 + pt + replace$1(pt, /(\w+).+(:[^]+)/, WEBKIT$1 + "box-$1$2" + MS$1 + "flex-$1$2") + pt;
    // align-self
    case 5443:
      return WEBKIT$1 + pt + MS$1 + "flex-item-" + replace$1(pt, /flex-|-self/, "") + pt;
    // align-content
    case 4675:
      return WEBKIT$1 + pt + MS$1 + "flex-line-pack" + replace$1(pt, /align-content|flex-|-self/, "") + pt;
    // flex-shrink
    case 5548:
      return WEBKIT$1 + pt + MS$1 + replace$1(pt, "shrink", "negative") + pt;
    // flex-basis
    case 5292:
      return WEBKIT$1 + pt + MS$1 + replace$1(pt, "basis", "preferred-size") + pt;
    // flex-grow
    case 6060:
      return WEBKIT$1 + "box-" + replace$1(pt, "-grow", "") + WEBKIT$1 + pt + MS$1 + replace$1(pt, "grow", "positive") + pt;
    // transition
    case 4554:
      return WEBKIT$1 + replace$1(pt, /([^-])(transform)/g, "$1" + WEBKIT$1 + "$2") + pt;
    // cursor
    case 6187:
      return replace$1(replace$1(replace$1(pt, /(zoom-|grab)/, WEBKIT$1 + "$1"), /(image-set)/, WEBKIT$1 + "$1"), pt, "") + pt;
    // background, background-image
    case 5495:
    case 3959:
      return replace$1(pt, /(image-set\([^]*)/, WEBKIT$1 + "$1$`$1");
    // justify-content
    case 4968:
      return replace$1(replace$1(pt, /(.+:)(flex-)?(.*)/, WEBKIT$1 + "box-pack:$3" + MS$1 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT$1 + pt + pt;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace$1(pt, /(.+)-inline(.+)/, WEBKIT$1 + "$1$2") + pt;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen$1(pt) - 1 - yt > 6) switch (charat$1(pt, yt + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          if (charat$1(pt, yt + 4) !== 45) break;
        // (f)ill-available, (f)it-content
        case 102:
          return replace$1(pt, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT$1 + "$2-$3$1" + MOZ$1 + (charat$1(pt, yt + 3) == 108 ? "$3" : "$2-$3")) + pt;
        // (s)tretch
        case 115:
          return ~indexof$1(pt, "stretch") ? prefix$2(replace$1(pt, "stretch", "fill-available"), yt) + pt : pt;
      }
      break;
    // position: sticky
    case 4949:
      if (charat$1(pt, yt + 1) !== 115) break;
    // display: (flex|inline-flex)
    case 6444:
      switch (charat$1(pt, strlen$1(pt) - 3 - (~indexof$1(pt, "!important") && 10))) {
        // stic(k)y
        case 107:
          return replace$1(pt, ":", ":" + WEBKIT$1) + pt;
        // (inline-)?fl(e)x
        case 101:
          return replace$1(pt, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT$1 + (charat$1(pt, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT$1 + "$2$3$1" + MS$1 + "$2box$3") + pt;
      }
      break;
    // writing-mode
    case 5936:
      switch (charat$1(pt, yt + 11)) {
        // vertical-l(r)
        case 114:
          return WEBKIT$1 + pt + MS$1 + replace$1(pt, /[svh]\w+-[tblr]{2}/, "tb") + pt;
        // vertical-r(l)
        case 108:
          return WEBKIT$1 + pt + MS$1 + replace$1(pt, /[svh]\w+-[tblr]{2}/, "tb-rl") + pt;
        // horizontal(-)tb
        case 45:
          return WEBKIT$1 + pt + MS$1 + replace$1(pt, /[svh]\w+-[tblr]{2}/, "lr") + pt;
      }
      return WEBKIT$1 + pt + MS$1 + pt + pt;
  }
  return pt;
}
var prefixer$1 = function(pt, yt, ir, ti) {
  if (pt.length > -1 && !pt.return) switch (pt.type) {
    case DECLARATION$1:
      pt.return = prefix$2(pt.value, pt.length);
      break;
    case KEYFRAMES$1:
      return serialize$1([copy$3(pt, {
        value: replace$1(pt.value, "@", "@" + WEBKIT$1)
      })], ti);
    case RULESET$1:
      if (pt.length) return combine$1(pt.props, function(ii) {
        switch (match$1(ii, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ":read-only":
          case ":read-write":
            return serialize$1([copy$3(pt, {
              props: [replace$1(ii, /:(read-\w+)/, ":" + MOZ$1 + "$1")]
            })], ti);
          // :placeholder
          case "::placeholder":
            return serialize$1([copy$3(pt, {
              props: [replace$1(ii, /:(plac\w+)/, ":" + WEBKIT$1 + "input-$1")]
            }), copy$3(pt, {
              props: [replace$1(ii, /:(plac\w+)/, ":" + MOZ$1 + "$1")]
            }), copy$3(pt, {
              props: [replace$1(ii, /:(plac\w+)/, MS$1 + "input-$1")]
            })], ti);
        }
        return "";
      });
  }
}, defaultStylisPlugins$1 = [prefixer$1], createCache$1 = function(pt) {
  var yt = pt.key;
  if (yt === "css") {
    var ir = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(ir, function(Ti) {
      var vi = Ti.getAttribute("data-emotion");
      vi.indexOf(" ") !== -1 && (document.head.appendChild(Ti), Ti.setAttribute("data-s", ""));
    });
  }
  var ti = pt.stylisPlugins || defaultStylisPlugins$1, ii = {}, ui, ai = [];
  ui = pt.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + yt + ' "]'),
    function(Ti) {
      for (var vi = Ti.getAttribute("data-emotion").split(" "), xi = 1; xi < vi.length; xi++)
        ii[vi[xi]] = !0;
      ai.push(Ti);
    }
  );
  var li, oi = [compat$1, removeLabel$1];
  {
    var si, di = [stringify$1, rulesheet$1(function(Ti) {
      si.insert(Ti);
    })], fi = middleware$1(oi.concat(ti, di)), gi = function(Ti) {
      return serialize$1(compile$1(Ti), fi);
    };
    li = function(Ti, vi, xi, Si) {
      si = xi, gi(Ti ? Ti + "{" + vi.styles + "}" : vi.styles), Si && (mi.inserted[vi.name] = !0);
    };
  }
  var mi = {
    key: yt,
    sheet: new StyleSheet$1({
      key: yt,
      container: ui,
      nonce: pt.nonce,
      speedy: pt.speedy,
      prepend: pt.prepend,
      insertionPoint: pt.insertionPoint
    }),
    nonce: pt.nonce,
    inserted: ii,
    registered: {},
    insert: li
  };
  return mi.sheet.hydrate(ai), mi;
}, hoistNonReactStatics_cjs$1, hasRequiredHoistNonReactStatics_cjs$1;
function requireHoistNonReactStatics_cjs$1() {
  if (hasRequiredHoistNonReactStatics_cjs$1) return hoistNonReactStatics_cjs$1;
  hasRequiredHoistNonReactStatics_cjs$1 = 1;
  var pt = requireReactIs$2(), yt = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, ir = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, ti = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, ii = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, ui = {};
  ui[pt.ForwardRef] = ti, ui[pt.Memo] = ii;
  function ai(Ti) {
    return pt.isMemo(Ti) ? ii : ui[Ti.$$typeof] || yt;
  }
  var li = Object.defineProperty, oi = Object.getOwnPropertyNames, si = Object.getOwnPropertySymbols, di = Object.getOwnPropertyDescriptor, fi = Object.getPrototypeOf, gi = Object.prototype;
  function mi(Ti, vi, xi) {
    if (typeof vi != "string") {
      if (gi) {
        var Si = fi(vi);
        Si && Si !== gi && mi(Ti, Si, xi);
      }
      var Pi = oi(vi);
      si && (Pi = Pi.concat(si(vi)));
      for (var $i = ai(Ti), Oi = ai(vi), Di = 0; Di < Pi.length; ++Di) {
        var Mi = Pi[Di];
        if (!ir[Mi] && !(xi && xi[Mi]) && !(Oi && Oi[Mi]) && !($i && $i[Mi])) {
          var Oo = di(vi, Mi);
          try {
            li(Ti, Mi, Oo);
          } catch {
          }
        }
      }
    }
    return Ti;
  }
  return hoistNonReactStatics_cjs$1 = mi, hoistNonReactStatics_cjs$1;
}
requireHoistNonReactStatics_cjs$1();
var isBrowser$1 = !0;
function getRegisteredStyles$1(pt, yt, ir) {
  var ti = "";
  return ir.split(" ").forEach(function(ii) {
    pt[ii] !== void 0 ? yt.push(pt[ii] + ";") : ii && (ti += ii + " ");
  }), ti;
}
var registerStyles$1 = function(pt, yt, ir) {
  var ti = pt.key + "-" + yt.name;
  (ir === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$1 === !1) && pt.registered[ti] === void 0 && (pt.registered[ti] = yt.styles);
}, insertStyles$1 = function(pt, yt, ir) {
  registerStyles$1(pt, yt, ir);
  var ti = pt.key + "-" + yt.name;
  if (pt.inserted[yt.name] === void 0) {
    var ii = yt;
    do
      pt.insert(yt === ii ? "." + ti : "", ii, pt.sheet, !0), ii = ii.next;
    while (ii !== void 0);
  }
};
function murmur2$1(pt) {
  for (var yt = 0, ir, ti = 0, ii = pt.length; ii >= 4; ++ti, ii -= 4)
    ir = pt.charCodeAt(ti) & 255 | (pt.charCodeAt(++ti) & 255) << 8 | (pt.charCodeAt(++ti) & 255) << 16 | (pt.charCodeAt(++ti) & 255) << 24, ir = /* Math.imul(k, m): */
    (ir & 65535) * 1540483477 + ((ir >>> 16) * 59797 << 16), ir ^= /* k >>> r: */
    ir >>> 24, yt = /* Math.imul(k, m): */
    (ir & 65535) * 1540483477 + ((ir >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (yt & 65535) * 1540483477 + ((yt >>> 16) * 59797 << 16);
  switch (ii) {
    case 3:
      yt ^= (pt.charCodeAt(ti + 2) & 255) << 16;
    case 2:
      yt ^= (pt.charCodeAt(ti + 1) & 255) << 8;
    case 1:
      yt ^= pt.charCodeAt(ti) & 255, yt = /* Math.imul(h, m): */
      (yt & 65535) * 1540483477 + ((yt >>> 16) * 59797 << 16);
  }
  return yt ^= yt >>> 13, yt = /* Math.imul(h, m): */
  (yt & 65535) * 1540483477 + ((yt >>> 16) * 59797 << 16), ((yt ^ yt >>> 15) >>> 0).toString(36);
}
var unitlessKeys$1 = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, hyphenateRegex$1 = /[A-Z]|^ms/g, animationRegex$1 = /_EMO_([^_]+?)_([^]*?)_EMO_/g, isCustomProperty$1 = function(pt) {
  return pt.charCodeAt(1) === 45;
}, isProcessableValue$1 = function(pt) {
  return pt != null && typeof pt != "boolean";
}, processStyleName$1 = /* @__PURE__ */ memoize$2(function(pt) {
  return isCustomProperty$1(pt) ? pt : pt.replace(hyphenateRegex$1, "-$&").toLowerCase();
}), processStyleValue$1 = function(pt, yt) {
  switch (pt) {
    case "animation":
    case "animationName":
      if (typeof yt == "string")
        return yt.replace(animationRegex$1, function(ir, ti, ii) {
          return cursor$1 = {
            name: ti,
            styles: ii,
            next: cursor$1
          }, ti;
        });
  }
  return unitlessKeys$1[pt] !== 1 && !isCustomProperty$1(pt) && typeof yt == "number" && yt !== 0 ? yt + "px" : yt;
};
function handleInterpolation$1(pt, yt, ir) {
  if (ir == null)
    return "";
  var ti = ir;
  if (ti.__emotion_styles !== void 0)
    return ti;
  switch (typeof ir) {
    case "boolean":
      return "";
    case "object": {
      var ii = ir;
      if (ii.anim === 1)
        return cursor$1 = {
          name: ii.name,
          styles: ii.styles,
          next: cursor$1
        }, ii.name;
      var ui = ir;
      if (ui.styles !== void 0) {
        var ai = ui.next;
        if (ai !== void 0)
          for (; ai !== void 0; )
            cursor$1 = {
              name: ai.name,
              styles: ai.styles,
              next: cursor$1
            }, ai = ai.next;
        var li = ui.styles + ";";
        return li;
      }
      return createStringFromObject$1(pt, yt, ir);
    }
    case "function": {
      if (pt !== void 0) {
        var oi = cursor$1, si = ir(pt);
        return cursor$1 = oi, handleInterpolation$1(pt, yt, si);
      }
      break;
    }
  }
  var di = ir;
  if (yt == null)
    return di;
  var fi = yt[di];
  return fi !== void 0 ? fi : di;
}
function createStringFromObject$1(pt, yt, ir) {
  var ti = "";
  if (Array.isArray(ir))
    for (var ii = 0; ii < ir.length; ii++)
      ti += handleInterpolation$1(pt, yt, ir[ii]) + ";";
  else
    for (var ui in ir) {
      var ai = ir[ui];
      if (typeof ai != "object") {
        var li = ai;
        yt != null && yt[li] !== void 0 ? ti += ui + "{" + yt[li] + "}" : isProcessableValue$1(li) && (ti += processStyleName$1(ui) + ":" + processStyleValue$1(ui, li) + ";");
      } else if (Array.isArray(ai) && typeof ai[0] == "string" && (yt == null || yt[ai[0]] === void 0))
        for (var oi = 0; oi < ai.length; oi++)
          isProcessableValue$1(ai[oi]) && (ti += processStyleName$1(ui) + ":" + processStyleValue$1(ui, ai[oi]) + ";");
      else {
        var si = handleInterpolation$1(pt, yt, ai);
        switch (ui) {
          case "animation":
          case "animationName": {
            ti += processStyleName$1(ui) + ":" + si + ";";
            break;
          }
          default:
            ti += ui + "{" + si + "}";
        }
      }
    }
  return ti;
}
var labelPattern$1 = /label:\s*([^\s;{]+)\s*(;|$)/g, cursor$1;
function serializeStyles$1(pt, yt, ir) {
  if (pt.length === 1 && typeof pt[0] == "object" && pt[0] !== null && pt[0].styles !== void 0)
    return pt[0];
  var ti = !0, ii = "";
  cursor$1 = void 0;
  var ui = pt[0];
  if (ui == null || ui.raw === void 0)
    ti = !1, ii += handleInterpolation$1(ir, yt, ui);
  else {
    var ai = ui;
    ii += ai[0];
  }
  for (var li = 1; li < pt.length; li++)
    if (ii += handleInterpolation$1(ir, yt, pt[li]), ti) {
      var oi = ui;
      ii += oi[li];
    }
  labelPattern$1.lastIndex = 0;
  for (var si = "", di; (di = labelPattern$1.exec(ii)) !== null; )
    si += "-" + di[1];
  var fi = murmur2$1(ii) + si;
  return {
    name: fi,
    styles: ii,
    next: cursor$1
  };
}
var syncFallback$1 = function(pt) {
  return pt();
}, useInsertionEffect$1 = React.useInsertionEffect ? React.useInsertionEffect : !1, useInsertionEffectAlwaysWithSyncFallback$1 = useInsertionEffect$1 || syncFallback$1, useInsertionEffectWithLayoutFallback = useInsertionEffect$1 || React.useLayoutEffect, EmotionCacheContext$1 = /* @__PURE__ */ React.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ createCache$1({
    key: "css"
  }) : null
);
EmotionCacheContext$1.Provider;
var withEmotionCache$1 = function(pt) {
  return /* @__PURE__ */ forwardRef(function(yt, ir) {
    var ti = useContext(EmotionCacheContext$1);
    return pt(yt, ti, ir);
  });
}, ThemeContext$1 = /* @__PURE__ */ React.createContext({}), hasOwn$1 = {}.hasOwnProperty, typePropName$1 = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", createEmotionProps$1 = function(pt, yt) {
  var ir = {};
  for (var ti in yt)
    hasOwn$1.call(yt, ti) && (ir[ti] = yt[ti]);
  return ir[typePropName$1] = pt, ir;
}, Insertion$1$1 = function(pt) {
  var yt = pt.cache, ir = pt.serialized, ti = pt.isStringTag;
  return registerStyles$1(yt, ir, ti), useInsertionEffectAlwaysWithSyncFallback$1(function() {
    return insertStyles$1(yt, ir, ti);
  }), null;
}, Emotion$2 = /* @__PURE__ */ withEmotionCache$1(function(pt, yt, ir) {
  var ti = pt.css;
  typeof ti == "string" && yt.registered[ti] !== void 0 && (ti = yt.registered[ti]);
  var ii = pt[typePropName$1], ui = [ti], ai = "";
  typeof pt.className == "string" ? ai = getRegisteredStyles$1(yt.registered, ui, pt.className) : pt.className != null && (ai = pt.className + " ");
  var li = serializeStyles$1(ui, void 0, React.useContext(ThemeContext$1));
  ai += yt.key + "-" + li.name;
  var oi = {};
  for (var si in pt)
    hasOwn$1.call(pt, si) && si !== "css" && si !== typePropName$1 && (oi[si] = pt[si]);
  return oi.className = ai, ir && (oi.ref = ir), /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Insertion$1$1, {
    cache: yt,
    serialized: li,
    isStringTag: typeof ii == "string"
  }), /* @__PURE__ */ React.createElement(ii, oi));
}), Emotion$1$1 = Emotion$2, jsx$1 = function(pt, yt) {
  var ir = arguments;
  if (yt == null || !hasOwn$1.call(yt, "css"))
    return React.createElement.apply(void 0, ir);
  var ti = ir.length, ii = new Array(ti);
  ii[0] = Emotion$1$1, ii[1] = createEmotionProps$1(pt, yt);
  for (var ui = 2; ui < ti; ui++)
    ii[ui] = ir[ui];
  return React.createElement.apply(null, ii);
};
(function(pt) {
  var yt;
  yt || (yt = pt.JSX || (pt.JSX = {}));
})(jsx$1 || (jsx$1 = {}));
var Global$1 = /* @__PURE__ */ withEmotionCache$1(function(pt, yt) {
  var ir = pt.styles, ti = serializeStyles$1([ir], void 0, React.useContext(ThemeContext$1)), ii = React.useRef();
  return useInsertionEffectWithLayoutFallback(function() {
    var ui = yt.key + "-global", ai = new yt.sheet.constructor({
      key: ui,
      nonce: yt.sheet.nonce,
      container: yt.sheet.container,
      speedy: yt.sheet.isSpeedy
    }), li = !1, oi = document.querySelector('style[data-emotion="' + ui + " " + ti.name + '"]');
    return yt.sheet.tags.length && (ai.before = yt.sheet.tags[0]), oi !== null && (li = !0, oi.setAttribute("data-emotion", ui), ai.hydrate([oi])), ii.current = [ai, li], function() {
      ai.flush();
    };
  }, [yt]), useInsertionEffectWithLayoutFallback(function() {
    var ui = ii.current, ai = ui[0], li = ui[1];
    if (li) {
      ui[1] = !1;
      return;
    }
    if (ti.next !== void 0 && insertStyles$1(yt, ti.next, !0), ai.tags.length) {
      var oi = ai.tags[ai.tags.length - 1].nextElementSibling;
      ai.before = oi, ai.flush();
    }
    yt.insert("", ti, ai, !1);
  }, [yt, ti.name]), null;
});
function css$1() {
  for (var pt = arguments.length, yt = new Array(pt), ir = 0; ir < pt; ir++)
    yt[ir] = arguments[ir];
  return serializeStyles$1(yt);
}
function keyframes$1() {
  var pt = css$1.apply(void 0, arguments), yt = "animation-" + pt.name;
  return {
    name: yt,
    styles: "@keyframes " + yt + "{" + pt.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
var reactPropsRegex$1 = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, isPropValid$1 = /* @__PURE__ */ memoize$2(
  function(pt) {
    return reactPropsRegex$1.test(pt) || pt.charCodeAt(0) === 111 && pt.charCodeAt(1) === 110 && pt.charCodeAt(2) < 91;
  }
  /* Z+1 */
), testOmitPropsOnStringTag$1 = isPropValid$1, testOmitPropsOnComponent$1 = function(pt) {
  return pt !== "theme";
}, getDefaultShouldForwardProp$1 = function(pt) {
  return typeof pt == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  pt.charCodeAt(0) > 96 ? testOmitPropsOnStringTag$1 : testOmitPropsOnComponent$1;
}, composeShouldForwardProps$1 = function(pt, yt, ir) {
  var ti;
  if (yt) {
    var ii = yt.shouldForwardProp;
    ti = pt.__emotion_forwardProp && ii ? function(ui) {
      return pt.__emotion_forwardProp(ui) && ii(ui);
    } : ii;
  }
  return typeof ti != "function" && ir && (ti = pt.__emotion_forwardProp), ti;
}, Insertion$2 = function(pt) {
  var yt = pt.cache, ir = pt.serialized, ti = pt.isStringTag;
  return registerStyles$1(yt, ir, ti), useInsertionEffectAlwaysWithSyncFallback$1(function() {
    return insertStyles$1(yt, ir, ti);
  }), null;
}, createStyled$1$1 = function pt(yt, ir) {
  var ti = yt.__emotion_real === yt, ii = ti && yt.__emotion_base || yt, ui, ai;
  ir !== void 0 && (ui = ir.label, ai = ir.target);
  var li = composeShouldForwardProps$1(yt, ir, ti), oi = li || getDefaultShouldForwardProp$1(ii), si = !oi("as");
  return function() {
    var di = arguments, fi = ti && yt.__emotion_styles !== void 0 ? yt.__emotion_styles.slice(0) : [];
    if (ui !== void 0 && fi.push("label:" + ui + ";"), di[0] == null || di[0].raw === void 0)
      fi.push.apply(fi, di);
    else {
      var gi = di[0];
      fi.push(gi[0]);
      for (var mi = di.length, Ti = 1; Ti < mi; Ti++)
        fi.push(di[Ti], gi[Ti]);
    }
    var vi = withEmotionCache$1(function(xi, Si, Pi) {
      var $i = si && xi.as || ii, Oi = "", Di = [], Mi = xi;
      if (xi.theme == null) {
        Mi = {};
        for (var Oo in xi)
          Mi[Oo] = xi[Oo];
        Mi.theme = React.useContext(ThemeContext$1);
      }
      typeof xi.className == "string" ? Oi = getRegisteredStyles$1(Si.registered, Di, xi.className) : xi.className != null && (Oi = xi.className + " ");
      var io = serializeStyles$1(fi.concat(Di), Si.registered, Mi);
      Oi += Si.key + "-" + io.name, ai !== void 0 && (Oi += " " + ai);
      var xo = si && li === void 0 ? getDefaultShouldForwardProp$1($i) : oi, fo = {};
      for (var _o in xi)
        si && _o === "as" || xo(_o) && (fo[_o] = xi[_o]);
      return fo.className = Oi, Pi && (fo.ref = Pi), /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Insertion$2, {
        cache: Si,
        serialized: io,
        isStringTag: typeof $i == "string"
      }), /* @__PURE__ */ React.createElement($i, fo));
    });
    return vi.displayName = ui !== void 0 ? ui : "Styled(" + (typeof ii == "string" ? ii : ii.displayName || ii.name || "Component") + ")", vi.defaultProps = yt.defaultProps, vi.__emotion_real = vi, vi.__emotion_base = ii, vi.__emotion_styles = fi, vi.__emotion_forwardProp = li, Object.defineProperty(vi, "toString", {
      value: function() {
        return "." + ai;
      }
    }), vi.withComponent = function(xi, Si) {
      var Pi = pt(xi, _extends$q({}, ir, Si, {
        shouldForwardProp: composeShouldForwardProps$1(vi, Si, !0)
      }));
      return Pi.apply(void 0, fi);
    }, vi;
  };
}, tags$1 = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], styled$2$1 = createStyled$1$1.bind(null);
tags$1.forEach(function(pt) {
  styled$2$1[pt] = styled$2$1(pt);
});
function isEmpty$2(pt) {
  return pt == null || Object.keys(pt).length === 0;
}
function GlobalStyles$2(pt) {
  const {
    styles: yt,
    defaultTheme: ir = {}
  } = pt, ti = typeof yt == "function" ? (ii) => yt(isEmpty$2(ii) ? ir : ii) : yt;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Global$1, {
    styles: ti
  });
}
process.env.NODE_ENV !== "production" && (GlobalStyles$2.propTypes = {
  defaultTheme: PropTypes.object,
  styles: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.object, PropTypes.func])
});
/**
 * @mui/styled-engine v7.3.9
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function styled$1$1(pt, yt) {
  const ir = styled$2$1(pt, yt);
  return process.env.NODE_ENV !== "production" ? (...ti) => {
    const ii = typeof pt == "string" ? `"${pt}"` : "component";
    return ti.length === 0 ? console.error([`MUI: Seems like you called \`styled(${ii})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : ti.some((ui) => ui === void 0) && console.error(`MUI: the styled(${ii})(...args) API requires all its args to be defined.`), ir(...ti);
  } : ir;
}
function internal_mutateStyles$1(pt, yt) {
  Array.isArray(pt.__emotion_styles) && (pt.__emotion_styles = yt(pt.__emotion_styles));
}
const wrapper$1 = [];
function internal_serializeStyles$1(pt) {
  return wrapper$1[0] = pt, serializeStyles$1(wrapper$1);
}
const sortBreakpointsValues$1 = (pt) => {
  const yt = Object.keys(pt).map((ir) => ({
    key: ir,
    val: pt[ir]
  })) || [];
  return yt.sort((ir, ti) => ir.val - ti.val), yt.reduce((ir, ti) => ({
    ...ir,
    [ti.key]: ti.val
  }), {});
};
function createBreakpoints$1(pt) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: yt = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: ir = "px",
    step: ti = 5,
    ...ii
  } = pt, ui = sortBreakpointsValues$1(yt), ai = Object.keys(ui);
  function li(gi) {
    return `@media (min-width:${typeof yt[gi] == "number" ? yt[gi] : gi}${ir})`;
  }
  function oi(gi) {
    return `@media (max-width:${(typeof yt[gi] == "number" ? yt[gi] : gi) - ti / 100}${ir})`;
  }
  function si(gi, mi) {
    const Ti = ai.indexOf(mi);
    return `@media (min-width:${typeof yt[gi] == "number" ? yt[gi] : gi}${ir}) and (max-width:${(Ti !== -1 && typeof yt[ai[Ti]] == "number" ? yt[ai[Ti]] : mi) - ti / 100}${ir})`;
  }
  function di(gi) {
    return ai.indexOf(gi) + 1 < ai.length ? si(gi, ai[ai.indexOf(gi) + 1]) : li(gi);
  }
  function fi(gi) {
    const mi = ai.indexOf(gi);
    return mi === 0 ? li(ai[1]) : mi === ai.length - 1 ? oi(ai[mi]) : si(gi, ai[ai.indexOf(gi) + 1]).replace("@media", "@media not all and");
  }
  return {
    keys: ai,
    values: ui,
    up: li,
    down: oi,
    between: si,
    only: di,
    not: fi,
    unit: ir,
    ...ii
  };
}
const shape$1 = {
  borderRadius: 4
};
function createSpacing$1(pt = 8, yt = createUnarySpacing$1({
  spacing: pt
})) {
  if (pt.mui)
    return pt;
  const ir = (...ti) => (process.env.NODE_ENV !== "production" && (ti.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${ti.length}`)), (ti.length === 0 ? [1] : ti).map((ii) => {
    const ui = yt(ii);
    return typeof ui == "number" ? `${ui}px` : ui;
  }).join(" "));
  return ir.mui = !0, ir;
}
function applyStyles$1(pt, yt) {
  var ir;
  const ti = this;
  if (ti.vars) {
    if (!((ir = ti.colorSchemes) != null && ir[pt]) || typeof ti.getColorSchemeSelector != "function")
      return {};
    let ii = ti.getColorSchemeSelector(pt);
    return ii === "&" ? yt : ((ii.includes("data-") || ii.includes(".")) && (ii = `*:where(${ii.replace(/\s*&$/, "")}) &`), {
      [ii]: yt
    });
  }
  return ti.palette.mode === pt ? yt : {};
}
function createTheme$1$1(pt = {}, ...yt) {
  const {
    breakpoints: ir = {},
    palette: ti = {},
    spacing: ii,
    shape: ui = {},
    ...ai
  } = pt, li = createBreakpoints$1(ir), oi = createSpacing$1(ii);
  let si = deepmerge$1({
    breakpoints: li,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: {
      mode: "light",
      ...ti
    },
    spacing: oi,
    shape: {
      ...shape$1,
      ...ui
    }
  }, ai);
  return si = cssContainerQueries$1(si), si.applyStyles = applyStyles$1, si = yt.reduce((di, fi) => deepmerge$1(di, fi), si), si.unstable_sxConfig = {
    ...defaultSxConfig$1,
    ...ai == null ? void 0 : ai.unstable_sxConfig
  }, si.unstable_sx = function(di) {
    return styleFunctionSx$1({
      sx: di,
      theme: this
    });
  }, si;
}
function isObjectEmpty$2(pt) {
  return Object.keys(pt).length === 0;
}
function useTheme$2$1(pt = null) {
  const yt = React.useContext(ThemeContext$1);
  return !yt || isObjectEmpty$2(yt) ? pt : yt;
}
const systemDefaultTheme$1$1 = createTheme$1$1();
function useTheme$1$1(pt = systemDefaultTheme$1$1) {
  return useTheme$2$1(pt);
}
function wrapGlobalLayer(pt) {
  const yt = internal_serializeStyles$1(pt);
  return pt !== yt && yt.styles ? (yt.styles.match(/^@layer\s+[^{]*$/) || (yt.styles = `@layer global{${yt.styles}}`), yt) : pt;
}
function GlobalStyles$1({
  styles: pt,
  themeId: yt,
  defaultTheme: ir = {}
}) {
  const ti = useTheme$1$1(ir), ii = yt && ti[yt] || ti;
  let ui = typeof pt == "function" ? pt(ii) : pt;
  return ii.modularCssLayers && (Array.isArray(ui) ? ui = ui.map((ai) => wrapGlobalLayer(typeof ai == "function" ? ai(ii) : ai)) : ui = wrapGlobalLayer(ui)), /* @__PURE__ */ jsxRuntimeExports.jsx(GlobalStyles$2, {
    styles: ui
  });
}
process.env.NODE_ENV !== "production" && (GlobalStyles$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  defaultTheme: PropTypes.object,
  /**
   * @ignore
   */
  styles: PropTypes.oneOfType([PropTypes.array, PropTypes.func, PropTypes.number, PropTypes.object, PropTypes.string, PropTypes.bool]),
  /**
   * @ignore
   */
  themeId: PropTypes.string
});
const defaultGenerator$1 = (pt) => pt, createClassNameGenerator$1 = () => {
  let pt = defaultGenerator$1;
  return {
    configure(yt) {
      pt = yt;
    },
    generate(yt) {
      return pt(yt);
    },
    reset() {
      pt = defaultGenerator$1;
    }
  };
}, ClassNameGenerator$1 = createClassNameGenerator$1(), globalStateClasses$2 = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function generateUtilityClass$2(pt, yt, ir = "Mui") {
  const ti = globalStateClasses$2[yt];
  return ti ? `${ir}-${ti}` : `${ClassNameGenerator$1.generate(pt)}-${yt}`;
}
function generateUtilityClasses$2(pt, yt, ir = "Mui") {
  const ti = {};
  return yt.forEach((ii) => {
    ti[ii] = generateUtilityClass$2(pt, ii, ir);
  }), ti;
}
function getFunctionComponentName$1(pt, yt = "") {
  return pt.displayName || pt.name || yt;
}
function getWrappedName$1(pt, yt, ir) {
  const ti = getFunctionComponentName$1(yt);
  return pt.displayName || (ti !== "" ? `${ir}(${ti})` : ir);
}
function getDisplayName$1(pt) {
  if (pt != null) {
    if (typeof pt == "string")
      return pt;
    if (typeof pt == "function")
      return getFunctionComponentName$1(pt, "Component");
    if (typeof pt == "object")
      switch (pt.$$typeof) {
        case reactIsExports$2.ForwardRef:
          return getWrappedName$1(pt, pt.render, "ForwardRef");
        case reactIsExports$2.Memo:
          return getWrappedName$1(pt, pt.type, "memo");
        default:
          return;
      }
  }
}
function preprocessStyles$1(pt) {
  const {
    variants: yt,
    ...ir
  } = pt, ti = {
    variants: yt,
    style: internal_serializeStyles$1(ir),
    isProcessed: !0
  };
  return ti.style === ir || yt && yt.forEach((ii) => {
    typeof ii.style != "function" && (ii.style = internal_serializeStyles$1(ii.style));
  }), ti;
}
const systemDefaultTheme$2 = createTheme$1$1();
function shouldForwardProp$1(pt) {
  return pt !== "ownerState" && pt !== "theme" && pt !== "sx" && pt !== "as";
}
function shallowLayer$1(pt, yt) {
  return yt && pt && typeof pt == "object" && pt.styles && !pt.styles.startsWith("@layer") && (pt.styles = `@layer ${yt}{${String(pt.styles)}}`), pt;
}
function defaultOverridesResolver$1(pt) {
  return pt ? (yt, ir) => ir[pt] : null;
}
function attachTheme$1(pt, yt, ir) {
  pt.theme = isObjectEmpty$1$1(pt.theme) ? ir : pt.theme[yt] || pt.theme;
}
function processStyle$1(pt, yt, ir) {
  const ti = typeof yt == "function" ? yt(pt) : yt;
  if (Array.isArray(ti))
    return ti.flatMap((ii) => processStyle$1(pt, ii, ir));
  if (Array.isArray(ti == null ? void 0 : ti.variants)) {
    let ii;
    if (ti.isProcessed)
      ii = ir ? shallowLayer$1(ti.style, ir) : ti.style;
    else {
      const {
        variants: ui,
        ...ai
      } = ti;
      ii = ir ? shallowLayer$1(internal_serializeStyles$1(ai), ir) : ai;
    }
    return processStyleVariants$1(pt, ti.variants, [ii], ir);
  }
  return ti != null && ti.isProcessed ? ir ? shallowLayer$1(internal_serializeStyles$1(ti.style), ir) : ti.style : ir ? shallowLayer$1(internal_serializeStyles$1(ti), ir) : ti;
}
function processStyleVariants$1(pt, yt, ir = [], ti = void 0) {
  var ii;
  let ui;
  e: for (let ai = 0; ai < yt.length; ai += 1) {
    const li = yt[ai];
    if (typeof li.props == "function") {
      if (ui ?? (ui = {
        ...pt,
        ...pt.ownerState,
        ownerState: pt.ownerState
      }), !li.props(ui))
        continue;
    } else
      for (const oi in li.props)
        if (pt[oi] !== li.props[oi] && ((ii = pt.ownerState) == null ? void 0 : ii[oi]) !== li.props[oi])
          continue e;
    typeof li.style == "function" ? (ui ?? (ui = {
      ...pt,
      ...pt.ownerState,
      ownerState: pt.ownerState
    }), ir.push(ti ? shallowLayer$1(internal_serializeStyles$1(li.style(ui)), ti) : li.style(ui))) : ir.push(ti ? shallowLayer$1(internal_serializeStyles$1(li.style), ti) : li.style);
  }
  return ir;
}
function createStyled$2(pt = {}) {
  const {
    themeId: yt,
    defaultTheme: ir = systemDefaultTheme$2,
    rootShouldForwardProp: ti = shouldForwardProp$1,
    slotShouldForwardProp: ii = shouldForwardProp$1
  } = pt;
  function ui(ai) {
    attachTheme$1(ai, yt, ir);
  }
  return (ai, li = {}) => {
    internal_mutateStyles$1(ai, (Di) => Di.filter((Mi) => Mi !== styleFunctionSx$1));
    const {
      name: oi,
      slot: si,
      skipVariantsResolver: di,
      skipSx: fi,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: gi = defaultOverridesResolver$1(lowercaseFirstLetter$1(si)),
      ...mi
    } = li, Ti = oi && oi.startsWith("Mui") || si ? "components" : "custom", vi = di !== void 0 ? di : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      si && si !== "Root" && si !== "root" || !1
    ), xi = fi || !1;
    let Si = shouldForwardProp$1;
    si === "Root" || si === "root" ? Si = ti : si ? Si = ii : isStringTag$1(ai) && (Si = void 0);
    const Pi = styled$1$1(ai, {
      shouldForwardProp: Si,
      label: generateStyledLabel$1(oi, si),
      ...mi
    }), $i = (Di) => {
      if (Di.__emotion_real === Di)
        return Di;
      if (typeof Di == "function")
        return function(Mi) {
          return processStyle$1(Mi, Di, Mi.theme.modularCssLayers ? Ti : void 0);
        };
      if (isPlainObject$6(Di)) {
        const Mi = preprocessStyles$1(Di);
        return function(Oo) {
          return Mi.variants ? processStyle$1(Oo, Mi, Oo.theme.modularCssLayers ? Ti : void 0) : Oo.theme.modularCssLayers ? shallowLayer$1(Mi.style, Ti) : Mi.style;
        };
      }
      return Di;
    }, Oi = (...Di) => {
      const Mi = [], Oo = Di.map($i), io = [];
      if (Mi.push(ui), oi && gi && io.push(function(_o) {
        var Li, Co;
        const Ni = (Co = (Li = _o.theme.components) == null ? void 0 : Li[oi]) == null ? void 0 : Co.styleOverrides;
        if (!Ni)
          return null;
        const Yi = {};
        for (const Vo in Ni)
          Yi[Vo] = processStyle$1(_o, Ni[Vo], _o.theme.modularCssLayers ? "theme" : void 0);
        return gi(_o, Yi);
      }), oi && !vi && io.push(function(_o) {
        var Li, Co;
        const Ni = _o.theme, Yi = (Co = (Li = Ni == null ? void 0 : Ni.components) == null ? void 0 : Li[oi]) == null ? void 0 : Co.variants;
        return Yi ? processStyleVariants$1(_o, Yi, [], _o.theme.modularCssLayers ? "theme" : void 0) : null;
      }), xi || io.push(styleFunctionSx$1), Array.isArray(Oo[0])) {
        const _o = Oo.shift(), Li = new Array(Mi.length).fill(""), Co = new Array(io.length).fill("");
        let Ni;
        Ni = [...Li, ..._o, ...Co], Ni.raw = [...Li, ..._o.raw, ...Co], Mi.unshift(Ni);
      }
      const xo = [...Mi, ...Oo, ...io], fo = Pi(...xo);
      return ai.muiName && (fo.muiName = ai.muiName), process.env.NODE_ENV !== "production" && (fo.displayName = generateDisplayName$1(oi, si, ai)), fo;
    };
    return Pi.withConfig && (Oi.withConfig = Pi.withConfig), Oi;
  };
}
function generateDisplayName$1(pt, yt, ir) {
  return pt ? `${pt}${capitalize$1(yt || "")}` : `Styled(${getDisplayName$1(ir)})`;
}
function generateStyledLabel$1(pt, yt) {
  let ir;
  return process.env.NODE_ENV !== "production" && pt && (ir = `${pt}-${lowercaseFirstLetter$1(yt || "Root")}`), ir;
}
function isObjectEmpty$1$1(pt) {
  for (const yt in pt)
    return !1;
  return !0;
}
function isStringTag$1(pt) {
  return typeof pt == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  pt.charCodeAt(0) > 96;
}
function lowercaseFirstLetter$1(pt) {
  return pt && pt.charAt(0).toLowerCase() + pt.slice(1);
}
function resolveProps$1(pt, yt, ir = !1) {
  const ti = {
    ...yt
  };
  for (const ii in pt)
    if (Object.prototype.hasOwnProperty.call(pt, ii)) {
      const ui = ii;
      if (ui === "components" || ui === "slots")
        ti[ui] = {
          ...pt[ui],
          ...ti[ui]
        };
      else if (ui === "componentsProps" || ui === "slotProps") {
        const ai = pt[ui], li = yt[ui];
        if (!li)
          ti[ui] = ai || {};
        else if (!ai)
          ti[ui] = li;
        else {
          ti[ui] = {
            ...li
          };
          for (const oi in ai)
            if (Object.prototype.hasOwnProperty.call(ai, oi)) {
              const si = oi;
              ti[ui][si] = resolveProps$1(ai[si], li[si], ir);
            }
        }
      } else ui === "className" && ir && yt.className ? ti.className = clsx$1(pt == null ? void 0 : pt.className, yt == null ? void 0 : yt.className) : ui === "style" && ir && yt.style ? ti.style = {
        ...pt == null ? void 0 : pt.style,
        ...yt == null ? void 0 : yt.style
      } : ti[ui] === void 0 && (ti[ui] = pt[ui]);
    }
  return ti;
}
const useEnhancedEffect$2 = typeof window < "u" ? React.useLayoutEffect : React.useEffect;
function clamp$1(pt, yt = Number.MIN_SAFE_INTEGER, ir = Number.MAX_SAFE_INTEGER) {
  return Math.max(yt, Math.min(pt, ir));
}
function clampWrapper$1(pt, yt = 0, ir = 1) {
  return process.env.NODE_ENV !== "production" && (pt < yt || pt > ir) && console.error(`MUI: The value provided ${pt} is out of range [${yt}, ${ir}].`), clamp$1(pt, yt, ir);
}
function hexToRgb$1(pt) {
  pt = pt.slice(1);
  const yt = new RegExp(`.{1,${pt.length >= 6 ? 2 : 1}}`, "g");
  let ir = pt.match(yt);
  return ir && ir[0].length === 1 && (ir = ir.map((ti) => ti + ti)), process.env.NODE_ENV !== "production" && pt.length !== pt.trim().length && console.error(`MUI: The color: "${pt}" is invalid. Make sure the color input doesn't contain leading/trailing space.`), ir ? `rgb${ir.length === 4 ? "a" : ""}(${ir.map((ti, ii) => ii < 3 ? parseInt(ti, 16) : Math.round(parseInt(ti, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function decomposeColor$1(pt) {
  if (pt.type)
    return pt;
  if (pt.charAt(0) === "#")
    return decomposeColor$1(hexToRgb$1(pt));
  const yt = pt.indexOf("("), ir = pt.substring(0, yt);
  if (!["rgb", "rgba", "hsl", "hsla", "color"].includes(ir))
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${pt}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : formatMuiErrorMessage$2(9, pt));
  let ti = pt.substring(yt + 1, pt.length - 1), ii;
  if (ir === "color") {
    if (ti = ti.split(" "), ii = ti.shift(), ti.length === 4 && ti[3].charAt(0) === "/" && (ti[3] = ti[3].slice(1)), !["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].includes(ii))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${ii}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : formatMuiErrorMessage$2(10, ii));
  } else
    ti = ti.split(",");
  return ti = ti.map((ui) => parseFloat(ui)), {
    type: ir,
    values: ti,
    colorSpace: ii
  };
}
const colorChannel$1 = (pt) => {
  const yt = decomposeColor$1(pt);
  return yt.values.slice(0, 3).map((ir, ti) => yt.type.includes("hsl") && ti !== 0 ? `${ir}%` : ir).join(" ");
}, private_safeColorChannel$1 = (pt, yt) => {
  try {
    return colorChannel$1(pt);
  } catch {
    return yt && process.env.NODE_ENV !== "production" && console.warn(yt), pt;
  }
};
function recomposeColor$1(pt) {
  const {
    type: yt,
    colorSpace: ir
  } = pt;
  let {
    values: ti
  } = pt;
  return yt.includes("rgb") ? ti = ti.map((ii, ui) => ui < 3 ? parseInt(ii, 10) : ii) : yt.includes("hsl") && (ti[1] = `${ti[1]}%`, ti[2] = `${ti[2]}%`), yt.includes("color") ? ti = `${ir} ${ti.join(" ")}` : ti = `${ti.join(", ")}`, `${yt}(${ti})`;
}
function hslToRgb$1(pt) {
  pt = decomposeColor$1(pt);
  const {
    values: yt
  } = pt, ir = yt[0], ti = yt[1] / 100, ii = yt[2] / 100, ui = ti * Math.min(ii, 1 - ii), ai = (si, di = (si + ir / 30) % 12) => ii - ui * Math.max(Math.min(di - 3, 9 - di, 1), -1);
  let li = "rgb";
  const oi = [Math.round(ai(0) * 255), Math.round(ai(8) * 255), Math.round(ai(4) * 255)];
  return pt.type === "hsla" && (li += "a", oi.push(yt[3])), recomposeColor$1({
    type: li,
    values: oi
  });
}
function getLuminance$1(pt) {
  pt = decomposeColor$1(pt);
  let yt = pt.type === "hsl" || pt.type === "hsla" ? decomposeColor$1(hslToRgb$1(pt)).values : pt.values;
  return yt = yt.map((ir) => (pt.type !== "color" && (ir /= 255), ir <= 0.03928 ? ir / 12.92 : ((ir + 0.055) / 1.055) ** 2.4)), Number((0.2126 * yt[0] + 0.7152 * yt[1] + 0.0722 * yt[2]).toFixed(3));
}
function getContrastRatio$1(pt, yt) {
  const ir = getLuminance$1(pt), ti = getLuminance$1(yt);
  return (Math.max(ir, ti) + 0.05) / (Math.min(ir, ti) + 0.05);
}
function alpha$1(pt, yt) {
  return pt = decomposeColor$1(pt), yt = clampWrapper$1(yt), (pt.type === "rgb" || pt.type === "hsl") && (pt.type += "a"), pt.type === "color" ? pt.values[3] = `/${yt}` : pt.values[3] = yt, recomposeColor$1(pt);
}
function private_safeAlpha$1(pt, yt, ir) {
  try {
    return alpha$1(pt, yt);
  } catch {
    return ir && process.env.NODE_ENV !== "production" && console.warn(ir), pt;
  }
}
function darken$1(pt, yt) {
  if (pt = decomposeColor$1(pt), yt = clampWrapper$1(yt), pt.type.includes("hsl"))
    pt.values[2] *= 1 - yt;
  else if (pt.type.includes("rgb") || pt.type.includes("color"))
    for (let ir = 0; ir < 3; ir += 1)
      pt.values[ir] *= 1 - yt;
  return recomposeColor$1(pt);
}
function private_safeDarken$1(pt, yt, ir) {
  try {
    return darken$1(pt, yt);
  } catch {
    return ir && process.env.NODE_ENV !== "production" && console.warn(ir), pt;
  }
}
function lighten$1(pt, yt) {
  if (pt = decomposeColor$1(pt), yt = clampWrapper$1(yt), pt.type.includes("hsl"))
    pt.values[2] += (100 - pt.values[2]) * yt;
  else if (pt.type.includes("rgb"))
    for (let ir = 0; ir < 3; ir += 1)
      pt.values[ir] += (255 - pt.values[ir]) * yt;
  else if (pt.type.includes("color"))
    for (let ir = 0; ir < 3; ir += 1)
      pt.values[ir] += (1 - pt.values[ir]) * yt;
  return recomposeColor$1(pt);
}
function private_safeLighten$1(pt, yt, ir) {
  try {
    return lighten$1(pt, yt);
  } catch {
    return ir && process.env.NODE_ENV !== "production" && console.warn(ir), pt;
  }
}
function emphasize$1(pt, yt = 0.15) {
  return getLuminance$1(pt) > 0.5 ? darken$1(pt, yt) : lighten$1(pt, yt);
}
function private_safeEmphasize$1(pt, yt, ir) {
  try {
    return emphasize$1(pt, yt);
  } catch {
    return pt;
  }
}
const specialProperty$2 = "exact-prop: ​";
function exactProp$2(pt) {
  return process.env.NODE_ENV === "production" ? pt : {
    ...pt,
    [specialProperty$2]: (yt) => {
      const ir = Object.keys(yt).filter((ti) => !pt.hasOwnProperty(ti));
      return ir.length > 0 ? new Error(`The following props are not supported: ${ir.map((ti) => `\`${ti}\``).join(", ")}. Please remove them.`) : null;
    }
  };
}
const RtlContext$1 = /* @__PURE__ */ React.createContext();
process.env.NODE_ENV !== "production" && (PropTypes.node, PropTypes.bool);
const useRtl$1 = () => React.useContext(RtlContext$1) ?? !1, PropsContext$1 = /* @__PURE__ */ React.createContext(void 0);
process.env.NODE_ENV !== "production" && (PropTypes.node, PropTypes.object);
function getThemeProps$1(pt) {
  const {
    theme: yt,
    name: ir,
    props: ti
  } = pt;
  if (!yt || !yt.components || !yt.components[ir])
    return ti;
  const ii = yt.components[ir];
  return ii.defaultProps ? resolveProps$1(ii.defaultProps, ti, yt.components.mergeClassNameAndStyle) : !ii.styleOverrides && !ii.variants ? resolveProps$1(ii, ti, yt.components.mergeClassNameAndStyle) : ti;
}
function useDefaultProps$1$1({
  props: pt,
  name: yt
}) {
  const ir = React.useContext(PropsContext$1);
  return getThemeProps$1({
    props: pt,
    name: yt,
    theme: {
      components: ir
    }
  });
}
let globalId = 0;
function useGlobalId(pt) {
  const [yt, ir] = React.useState(pt), ti = pt || yt;
  return React.useEffect(() => {
    yt == null && (globalId += 1, ir(`mui-${globalId}`));
  }, [yt]), ti;
}
const safeReact = {
  ...React
}, maybeReactUseId = safeReact.useId;
function useId$1(pt) {
  if (maybeReactUseId !== void 0) {
    const yt = maybeReactUseId();
    return pt ?? yt;
  }
  return useGlobalId(pt);
}
const arg$1 = {
  theme: void 0
};
function unstable_memoTheme$1(pt) {
  let yt, ir;
  return function(ti) {
    let ii = yt;
    return (ii === void 0 || ti.theme !== ir) && (arg$1.theme = ti.theme, ii = preprocessStyles$1(pt(arg$1)), yt = ii, ir = ti.theme), ii;
  };
}
function createGetCssVar$1$1(pt = "") {
  function yt(...ir) {
    if (!ir.length)
      return "";
    const ti = ir[0];
    return typeof ti == "string" && !ti.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/) ? `, var(--${pt ? `${pt}-` : ""}${ti}${yt(...ir.slice(1))})` : `, ${ti}`;
  }
  return (ir, ...ti) => `var(--${pt ? `${pt}-` : ""}${ir}${yt(...ti)})`;
}
const assignNestedKeys$1 = (pt, yt, ir, ti = []) => {
  let ii = pt;
  yt.forEach((ui, ai) => {
    ai === yt.length - 1 ? Array.isArray(ii) ? ii[Number(ui)] = ir : ii && typeof ii == "object" && (ii[ui] = ir) : ii && typeof ii == "object" && (ii[ui] || (ii[ui] = ti.includes(ui) ? [] : {}), ii = ii[ui]);
  });
}, walkObjectDeep$1 = (pt, yt, ir) => {
  function ti(ii, ui = [], ai = []) {
    Object.entries(ii).forEach(([li, oi]) => {
      (!ir || ir && !ir([...ui, li])) && oi != null && (typeof oi == "object" && Object.keys(oi).length > 0 ? ti(oi, [...ui, li], Array.isArray(oi) ? [...ai, li] : ai) : yt([...ui, li], oi, ai));
    });
  }
  ti(pt);
}, getCssValue$1 = (pt, yt) => typeof yt == "number" ? ["lineHeight", "fontWeight", "opacity", "zIndex"].some((ir) => pt.includes(ir)) || pt[pt.length - 1].toLowerCase().includes("opacity") ? yt : `${yt}px` : yt;
function cssVarsParser$1(pt, yt) {
  const {
    prefix: ir,
    shouldSkipGeneratingVar: ti
  } = yt || {}, ii = {}, ui = {}, ai = {};
  return walkObjectDeep$1(
    pt,
    (li, oi, si) => {
      if ((typeof oi == "string" || typeof oi == "number") && (!ti || !ti(li, oi))) {
        const di = `--${ir ? `${ir}-` : ""}${li.join("-")}`, fi = getCssValue$1(li, oi);
        Object.assign(ii, {
          [di]: fi
        }), assignNestedKeys$1(ui, li, `var(${di})`, si), assignNestedKeys$1(ai, li, `var(${di}, ${fi})`, si);
      }
    },
    (li) => li[0] === "vars"
    // skip 'vars/*' paths
  ), {
    css: ii,
    vars: ui,
    varsWithDefaults: ai
  };
}
function prepareCssVars$1(pt, yt = {}) {
  const {
    getSelector: ir = Si,
    disableCssColorScheme: ti,
    colorSchemeSelector: ii,
    enableContrastVars: ui
  } = yt, {
    colorSchemes: ai = {},
    components: li,
    defaultColorScheme: oi = "light",
    ...si
  } = pt, {
    vars: di,
    css: fi,
    varsWithDefaults: gi
  } = cssVarsParser$1(si, yt);
  let mi = gi;
  const Ti = {}, {
    [oi]: vi,
    ...xi
  } = ai;
  if (Object.entries(xi || {}).forEach(([Pi, $i]) => {
    const {
      vars: Oi,
      css: Di,
      varsWithDefaults: Mi
    } = cssVarsParser$1($i, yt);
    mi = deepmerge$1(mi, Mi), Ti[Pi] = {
      css: Di,
      vars: Oi
    };
  }), vi) {
    const {
      css: Pi,
      vars: $i,
      varsWithDefaults: Oi
    } = cssVarsParser$1(vi, yt);
    mi = deepmerge$1(mi, Oi), Ti[oi] = {
      css: Pi,
      vars: $i
    };
  }
  function Si(Pi, $i) {
    var Oi, Di;
    let Mi = ii;
    if (ii === "class" && (Mi = ".%s"), ii === "data" && (Mi = "[data-%s]"), ii != null && ii.startsWith("data-") && !ii.includes("%s") && (Mi = `[${ii}="%s"]`), Pi) {
      if (Mi === "media")
        return pt.defaultColorScheme === Pi ? ":root" : {
          [`@media (prefers-color-scheme: ${((Di = (Oi = ai[Pi]) == null ? void 0 : Oi.palette) == null ? void 0 : Di.mode) || Pi})`]: {
            ":root": $i
          }
        };
      if (Mi)
        return pt.defaultColorScheme === Pi ? `:root, ${Mi.replace("%s", String(Pi))}` : Mi.replace("%s", String(Pi));
    }
    return ":root";
  }
  return {
    vars: mi,
    generateThemeVars: () => {
      let Pi = {
        ...di
      };
      return Object.entries(Ti).forEach(([, {
        vars: $i
      }]) => {
        Pi = deepmerge$1(Pi, $i);
      }), Pi;
    },
    generateStyleSheets: () => {
      var Pi, $i;
      const Oi = [], Di = pt.defaultColorScheme || "light";
      function Mi(xo, fo) {
        Object.keys(fo).length && Oi.push(typeof xo == "string" ? {
          [xo]: {
            ...fo
          }
        } : xo);
      }
      Mi(ir(void 0, {
        ...fi
      }), fi);
      const {
        [Di]: Oo,
        ...io
      } = Ti;
      if (Oo) {
        const {
          css: xo
        } = Oo, fo = ($i = (Pi = ai[Di]) == null ? void 0 : Pi.palette) == null ? void 0 : $i.mode, _o = !ti && fo ? {
          colorScheme: fo,
          ...xo
        } : {
          ...xo
        };
        Mi(ir(Di, {
          ..._o
        }), _o);
      }
      return Object.entries(io).forEach(([xo, {
        css: fo
      }]) => {
        var _o, Li;
        const Co = (Li = (_o = ai[xo]) == null ? void 0 : _o.palette) == null ? void 0 : Li.mode, Ni = !ti && Co ? {
          colorScheme: Co,
          ...fo
        } : {
          ...fo
        };
        Mi(ir(xo, {
          ...Ni
        }), Ni);
      }), ui && Oi.push({
        ":root": {
          // use double underscore to indicate that these are private variables
          "--__l-threshold": "0.7",
          "--__l": "clamp(0, (l / var(--__l-threshold) - 1) * -infinity, 1)",
          "--__a": "clamp(0.87, (l / var(--__l-threshold) - 1) * -infinity, 1)"
          // 0.87 is the default alpha value for black text.
        }
      }), Oi;
    }
  };
}
function createGetColorSchemeSelector$1(pt) {
  return function(yt) {
    return pt === "media" ? (process.env.NODE_ENV !== "production" && yt !== "light" && yt !== "dark" && console.error(`MUI: @media (prefers-color-scheme) supports only 'light' or 'dark', but receive '${yt}'.`), `@media (prefers-color-scheme: ${yt})`) : pt ? pt.startsWith("data-") && !pt.includes("%s") ? `[${pt}="${yt}"] &` : pt === "class" ? `.${yt} &` : pt === "data" ? `[data-${yt}] &` : `${pt.replace("%s", yt)} &` : "&";
  };
}
const common$1 = {
  black: "#000",
  white: "#fff"
}, grey$1 = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, purple$1 = {
  50: "#f3e5f5",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  700: "#7b1fa2"
}, red$1 = {
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  700: "#d32f2f",
  800: "#c62828"
}, orange$1 = {
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  700: "#f57c00",
  900: "#e65100"
}, blue$1 = {
  50: "#e3f2fd",
  200: "#90caf9",
  400: "#42a5f5",
  700: "#1976d2",
  800: "#1565c0"
}, lightBlue$1 = {
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  700: "#0288d1",
  900: "#01579b"
}, green$1 = {
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20"
};
function getLight$1() {
  return {
    // The colors used to style the text.
    text: {
      // The most important text.
      primary: "rgba(0, 0, 0, 0.87)",
      // Secondary text.
      secondary: "rgba(0, 0, 0, 0.6)",
      // Disabled text have even lower visual prominence.
      disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
      paper: common$1.white,
      default: common$1.white
    },
    // The colors used to style the action elements.
    action: {
      // The color of an active action like an icon button.
      active: "rgba(0, 0, 0, 0.54)",
      // The color of an hovered action.
      hover: "rgba(0, 0, 0, 0.04)",
      hoverOpacity: 0.04,
      // The color of a selected action.
      selected: "rgba(0, 0, 0, 0.08)",
      selectedOpacity: 0.08,
      // The color of a disabled action.
      disabled: "rgba(0, 0, 0, 0.26)",
      // The background color of a disabled action.
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(0, 0, 0, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.12
    }
  };
}
const light$1 = getLight$1();
function getDark$1() {
  return {
    text: {
      primary: common$1.white,
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
      paper: "#121212",
      default: "#121212"
    },
    action: {
      active: common$1.white,
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: 0.08,
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: 0.16,
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.24
    }
  };
}
const dark$1 = getDark$1();
function addLightOrDark$1(pt, yt, ir, ti) {
  const ii = ti.light || ti, ui = ti.dark || ti * 1.5;
  pt[yt] || (pt.hasOwnProperty(ir) ? pt[yt] = pt[ir] : yt === "light" ? pt.light = lighten$1(pt.main, ii) : yt === "dark" && (pt.dark = darken$1(pt.main, ui)));
}
function mixLightOrDark$1(pt, yt, ir, ti, ii) {
  const ui = ii.light || ii, ai = ii.dark || ii * 1.5;
  yt[ir] || (yt.hasOwnProperty(ti) ? yt[ir] = yt[ti] : ir === "light" ? yt.light = `color-mix(in ${pt}, ${yt.main}, #fff ${(ui * 100).toFixed(0)}%)` : ir === "dark" && (yt.dark = `color-mix(in ${pt}, ${yt.main}, #000 ${(ai * 100).toFixed(0)}%)`));
}
function getDefaultPrimary$1(pt = "light") {
  return pt === "dark" ? {
    main: blue$1[200],
    light: blue$1[50],
    dark: blue$1[400]
  } : {
    main: blue$1[700],
    light: blue$1[400],
    dark: blue$1[800]
  };
}
function getDefaultSecondary$1(pt = "light") {
  return pt === "dark" ? {
    main: purple$1[200],
    light: purple$1[50],
    dark: purple$1[400]
  } : {
    main: purple$1[500],
    light: purple$1[300],
    dark: purple$1[700]
  };
}
function getDefaultError$1(pt = "light") {
  return pt === "dark" ? {
    main: red$1[500],
    light: red$1[300],
    dark: red$1[700]
  } : {
    main: red$1[700],
    light: red$1[400],
    dark: red$1[800]
  };
}
function getDefaultInfo$1(pt = "light") {
  return pt === "dark" ? {
    main: lightBlue$1[400],
    light: lightBlue$1[300],
    dark: lightBlue$1[700]
  } : {
    main: lightBlue$1[700],
    light: lightBlue$1[500],
    dark: lightBlue$1[900]
  };
}
function getDefaultSuccess$1(pt = "light") {
  return pt === "dark" ? {
    main: green$1[400],
    light: green$1[300],
    dark: green$1[700]
  } : {
    main: green$1[800],
    light: green$1[500],
    dark: green$1[900]
  };
}
function getDefaultWarning$1(pt = "light") {
  return pt === "dark" ? {
    main: orange$1[400],
    light: orange$1[300],
    dark: orange$1[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: orange$1[500],
    dark: orange$1[900]
  };
}
function contrastColor$1(pt) {
  return `oklch(from ${pt} var(--__l) 0 h / var(--__a))`;
}
function createPalette$1(pt) {
  const {
    mode: yt = "light",
    contrastThreshold: ir = 3,
    tonalOffset: ti = 0.2,
    colorSpace: ii,
    ...ui
  } = pt, ai = pt.primary || getDefaultPrimary$1(yt), li = pt.secondary || getDefaultSecondary$1(yt), oi = pt.error || getDefaultError$1(yt), si = pt.info || getDefaultInfo$1(yt), di = pt.success || getDefaultSuccess$1(yt), fi = pt.warning || getDefaultWarning$1(yt);
  function gi(vi) {
    if (ii)
      return contrastColor$1(vi);
    const xi = getContrastRatio$1(vi, dark$1.text.primary) >= ir ? dark$1.text.primary : light$1.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const Si = getContrastRatio$1(vi, xi);
      Si < 3 && console.error([`MUI: The contrast ratio of ${Si}:1 for ${xi} on ${vi}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return xi;
  }
  const mi = ({
    color: vi,
    name: xi,
    mainShade: Si = 500,
    lightShade: Pi = 300,
    darkShade: $i = 700
  }) => {
    if (vi = {
      ...vi
    }, !vi.main && vi[Si] && (vi.main = vi[Si]), !vi.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${xi ? ` (${xi})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${Si}\` property.` : formatMuiErrorMessage$2(11, xi ? ` (${xi})` : "", Si));
    if (typeof vi.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${xi ? ` (${xi})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(vi.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : formatMuiErrorMessage$2(12, xi ? ` (${xi})` : "", JSON.stringify(vi.main)));
    return ii ? (mixLightOrDark$1(ii, vi, "light", Pi, ti), mixLightOrDark$1(ii, vi, "dark", $i, ti)) : (addLightOrDark$1(vi, "light", Pi, ti), addLightOrDark$1(vi, "dark", $i, ti)), vi.contrastText || (vi.contrastText = gi(vi.main)), vi;
  };
  let Ti;
  return yt === "light" ? Ti = getLight$1() : yt === "dark" && (Ti = getDark$1()), process.env.NODE_ENV !== "production" && (Ti || console.error(`MUI: The palette mode \`${yt}\` is not supported.`)), deepmerge$1({
    // A collection of common colors.
    common: {
      ...common$1
    },
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: yt,
    // The colors used to represent primary interface elements for a user.
    primary: mi({
      color: ai,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: mi({
      color: li,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: mi({
      color: oi,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: mi({
      color: fi,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: mi({
      color: si,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: mi({
      color: di,
      name: "success"
    }),
    // The grey colors.
    grey: grey$1,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: ir,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: gi,
    // Generate a rich color object.
    augmentColor: mi,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: ti,
    // The light and dark mode object.
    ...Ti
  }, ui);
}
function prepareTypographyVars$1(pt) {
  const yt = {};
  return Object.entries(pt).forEach((ir) => {
    const [ti, ii] = ir;
    typeof ii == "object" && (yt[ti] = `${ii.fontStyle ? `${ii.fontStyle} ` : ""}${ii.fontVariant ? `${ii.fontVariant} ` : ""}${ii.fontWeight ? `${ii.fontWeight} ` : ""}${ii.fontStretch ? `${ii.fontStretch} ` : ""}${ii.fontSize || ""}${ii.lineHeight ? `/${ii.lineHeight} ` : ""}${ii.fontFamily || ""}`);
  }), yt;
}
function createMixins$1(pt, yt) {
  return {
    toolbar: {
      minHeight: 56,
      [pt.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [pt.up("sm")]: {
        minHeight: 64
      }
    },
    ...yt
  };
}
function round$2(pt) {
  return Math.round(pt * 1e5) / 1e5;
}
const caseAllCaps$1 = {
  textTransform: "uppercase"
}, defaultFontFamily$1 = '"Roboto", "Helvetica", "Arial", sans-serif';
function createTypography$1(pt, yt) {
  const {
    fontFamily: ir = defaultFontFamily$1,
    // The default font size of the Material Specification.
    fontSize: ti = 14,
    // px
    fontWeightLight: ii = 300,
    fontWeightRegular: ui = 400,
    fontWeightMedium: ai = 500,
    fontWeightBold: li = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: oi = 16,
    // Apply the CSS properties to all the variants.
    allVariants: si,
    pxToRem: di,
    ...fi
  } = typeof yt == "function" ? yt(pt) : yt;
  process.env.NODE_ENV !== "production" && (typeof ti != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof oi != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const gi = ti / 14, mi = di || ((xi) => `${xi / oi * gi}rem`), Ti = (xi, Si, Pi, $i, Oi) => ({
    fontFamily: ir,
    fontWeight: xi,
    fontSize: mi(Si),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: Pi,
    // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
    // across font-families can cause issues with the kerning.
    ...ir === defaultFontFamily$1 ? {
      letterSpacing: `${round$2($i / Si)}em`
    } : {},
    ...Oi,
    ...si
  }), vi = {
    h1: Ti(ii, 96, 1.167, -1.5),
    h2: Ti(ii, 60, 1.2, -0.5),
    h3: Ti(ui, 48, 1.167, 0),
    h4: Ti(ui, 34, 1.235, 0.25),
    h5: Ti(ui, 24, 1.334, 0),
    h6: Ti(ai, 20, 1.6, 0.15),
    subtitle1: Ti(ui, 16, 1.75, 0.15),
    subtitle2: Ti(ai, 14, 1.57, 0.1),
    body1: Ti(ui, 16, 1.5, 0.15),
    body2: Ti(ui, 14, 1.43, 0.15),
    button: Ti(ai, 14, 1.75, 0.4, caseAllCaps$1),
    caption: Ti(ui, 12, 1.66, 0.4),
    overline: Ti(ui, 12, 2.66, 1, caseAllCaps$1),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return deepmerge$1({
    htmlFontSize: oi,
    pxToRem: mi,
    fontFamily: ir,
    fontSize: ti,
    fontWeightLight: ii,
    fontWeightRegular: ui,
    fontWeightMedium: ai,
    fontWeightBold: li,
    ...vi
  }, fi, {
    clone: !1
    // No need to clone deep
  });
}
const shadowKeyUmbraOpacity$1 = 0.2, shadowKeyPenumbraOpacity$1 = 0.14, shadowAmbientShadowOpacity$1 = 0.12;
function createShadow$1(...pt) {
  return [`${pt[0]}px ${pt[1]}px ${pt[2]}px ${pt[3]}px rgba(0,0,0,${shadowKeyUmbraOpacity$1})`, `${pt[4]}px ${pt[5]}px ${pt[6]}px ${pt[7]}px rgba(0,0,0,${shadowKeyPenumbraOpacity$1})`, `${pt[8]}px ${pt[9]}px ${pt[10]}px ${pt[11]}px rgba(0,0,0,${shadowAmbientShadowOpacity$1})`].join(",");
}
const shadows$1 = ["none", createShadow$1(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow$1(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow$1(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow$1(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow$1(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow$1(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow$1(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow$1(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow$1(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow$1(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow$1(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow$1(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow$1(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow$1(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow$1(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow$1(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow$1(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow$1(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow$1(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow$1(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow$1(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow$1(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow$1(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow$1(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], easing$1 = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, duration$1 = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function formatMs$1(pt) {
  return `${Math.round(pt)}ms`;
}
function getAutoHeightDuration$1(pt) {
  if (!pt)
    return 0;
  const yt = pt / 36;
  return Math.min(Math.round((4 + 15 * yt ** 0.25 + yt / 5) * 10), 3e3);
}
function createTransitions$1(pt) {
  const yt = {
    ...easing$1,
    ...pt.easing
  }, ir = {
    ...duration$1,
    ...pt.duration
  };
  return {
    getAutoHeightDuration: getAutoHeightDuration$1,
    create: (ti = ["all"], ii = {}) => {
      const {
        duration: ui = ir.standard,
        easing: ai = yt.easeInOut,
        delay: li = 0,
        ...oi
      } = ii;
      if (process.env.NODE_ENV !== "production") {
        const si = (fi) => typeof fi == "string", di = (fi) => !Number.isNaN(parseFloat(fi));
        !si(ti) && !Array.isArray(ti) && console.error('MUI: Argument "props" must be a string or Array.'), !di(ui) && !si(ui) && console.error(`MUI: Argument "duration" must be a number or a string but found ${ui}.`), si(ai) || console.error('MUI: Argument "easing" must be a string.'), !di(li) && !si(li) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof ii != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(oi).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(oi).join(",")}].`);
      }
      return (Array.isArray(ti) ? ti : [ti]).map((si) => `${si} ${typeof ui == "string" ? ui : formatMs$1(ui)} ${ai} ${typeof li == "string" ? li : formatMs$1(li)}`).join(",");
    },
    ...pt,
    easing: yt,
    duration: ir
  };
}
const zIndex$1 = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
function isSerializable$1(pt) {
  return isPlainObject$6(pt) || typeof pt > "u" || typeof pt == "string" || typeof pt == "boolean" || typeof pt == "number" || Array.isArray(pt);
}
function stringifyTheme$1(pt = {}) {
  const yt = {
    ...pt
  };
  function ir(ti) {
    const ii = Object.entries(ti);
    for (let ui = 0; ui < ii.length; ui++) {
      const [ai, li] = ii[ui];
      !isSerializable$1(li) || ai.startsWith("unstable_") ? delete ti[ai] : isPlainObject$6(li) && (ti[ai] = {
        ...li
      }, ir(ti[ai]));
    }
  }
  return ir(yt), `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(yt, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}
function coefficientToPercentage$1(pt) {
  return typeof pt == "number" ? `${(pt * 100).toFixed(0)}%` : `calc((${pt}) * 100%)`;
}
const parseAddition$1 = (pt) => {
  if (!Number.isNaN(+pt))
    return +pt;
  const yt = pt.match(/\d*\.?\d+/g);
  if (!yt)
    return 0;
  let ir = 0;
  for (let ti = 0; ti < yt.length; ti += 1)
    ir += +yt[ti];
  return ir;
};
function attachColorManipulators$1(pt) {
  Object.assign(pt, {
    alpha(yt, ir) {
      const ti = this || pt;
      return ti.colorSpace ? `oklch(from ${yt} l c h / ${typeof ir == "string" ? `calc(${ir})` : ir})` : ti.vars ? `rgba(${yt.replace(/var\(--([^,\s)]+)(?:,[^)]+)?\)+/g, "var(--$1Channel)")} / ${typeof ir == "string" ? `calc(${ir})` : ir})` : alpha$1(yt, parseAddition$1(ir));
    },
    lighten(yt, ir) {
      const ti = this || pt;
      return ti.colorSpace ? `color-mix(in ${ti.colorSpace}, ${yt}, #fff ${coefficientToPercentage$1(ir)})` : lighten$1(yt, ir);
    },
    darken(yt, ir) {
      const ti = this || pt;
      return ti.colorSpace ? `color-mix(in ${ti.colorSpace}, ${yt}, #000 ${coefficientToPercentage$1(ir)})` : darken$1(yt, ir);
    }
  });
}
function createThemeNoVars$1(pt = {}, ...yt) {
  const {
    breakpoints: ir,
    mixins: ti = {},
    spacing: ii,
    palette: ui = {},
    transitions: ai = {},
    typography: li = {},
    shape: oi,
    colorSpace: si,
    ...di
  } = pt;
  if (pt.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
  // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
  pt.generateThemeVars === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name or follow the [docs](https://mui.com/material-ui/customization/css-theme-variables/usage/) to enable the feature." : formatMuiErrorMessage$2(20));
  const fi = createPalette$1({
    ...ui,
    colorSpace: si
  }), gi = createTheme$1$1(pt);
  let mi = deepmerge$1(gi, {
    mixins: createMixins$1(gi.breakpoints, ti),
    palette: fi,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: shadows$1.slice(),
    typography: createTypography$1(fi, li),
    transitions: createTransitions$1(ai),
    zIndex: {
      ...zIndex$1
    }
  });
  if (mi = deepmerge$1(mi, di), mi = yt.reduce((Ti, vi) => deepmerge$1(Ti, vi), mi), process.env.NODE_ENV !== "production") {
    const Ti = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], vi = (xi, Si) => {
      let Pi;
      for (Pi in xi) {
        const $i = xi[Pi];
        if (Ti.includes(Pi) && Object.keys($i).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const Oi = generateUtilityClass$2("", Pi);
            console.error([`MUI: The \`${Si}\` component increases the CSS specificity of the \`${Pi}\` internal state.`, "You can not override it like this: ", JSON.stringify(xi, null, 2), "", `Instead, you need to use the '&.${Oi}' syntax:`, JSON.stringify({
              root: {
                [`&.${Oi}`]: $i
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          xi[Pi] = {};
        }
      }
    };
    Object.keys(mi.components).forEach((xi) => {
      const Si = mi.components[xi].styleOverrides;
      Si && xi.startsWith("Mui") && vi(Si, xi);
    });
  }
  return mi.unstable_sxConfig = {
    ...defaultSxConfig$1,
    ...di == null ? void 0 : di.unstable_sxConfig
  }, mi.unstable_sx = function(Ti) {
    return styleFunctionSx$1({
      sx: Ti,
      theme: this
    });
  }, mi.toRuntimeSource = stringifyTheme$1, attachColorManipulators$1(mi), mi;
}
function getOverlayAlpha$1(pt) {
  let yt;
  return pt < 1 ? yt = 5.11916 * pt ** 2 : yt = 4.5 * Math.log(pt + 1) + 2, Math.round(yt * 10) / 1e3;
}
const defaultDarkOverlays$1 = [...Array(25)].map((pt, yt) => {
  if (yt === 0)
    return "none";
  const ir = getOverlayAlpha$1(yt);
  return `linear-gradient(rgba(255 255 255 / ${ir}), rgba(255 255 255 / ${ir}))`;
});
function getOpacity$1(pt) {
  return {
    inputPlaceholder: pt === "dark" ? 0.5 : 0.42,
    inputUnderline: pt === "dark" ? 0.7 : 0.42,
    switchTrackDisabled: pt === "dark" ? 0.2 : 0.12,
    switchTrack: pt === "dark" ? 0.3 : 0.38
  };
}
function getOverlays$1(pt) {
  return pt === "dark" ? defaultDarkOverlays$1 : [];
}
function createColorScheme$1(pt) {
  const {
    palette: yt = {
      mode: "light"
    },
    // need to cast to avoid module augmentation test
    opacity: ir,
    overlays: ti,
    colorSpace: ii,
    ...ui
  } = pt, ai = createPalette$1({
    ...yt,
    colorSpace: ii
  });
  return {
    palette: ai,
    opacity: {
      ...getOpacity$1(ai.mode),
      ...ir
    },
    overlays: ti || getOverlays$1(ai.mode),
    ...ui
  };
}
function shouldSkipGeneratingVar$1(pt) {
  var yt;
  return !!pt[0].match(/(cssVarPrefix|colorSchemeSelector|modularCssLayers|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!pt[0].match(/sxConfig$/) || // ends with sxConfig
  pt[0] === "palette" && !!((yt = pt[1]) != null && yt.match(/(mode|contrastThreshold|tonalOffset)/));
}
const excludeVariablesFromRoot$1 = (pt) => [...[...Array(25)].map((yt, ir) => `--${pt ? `${pt}-` : ""}overlays-${ir}`), `--${pt ? `${pt}-` : ""}palette-AppBar-darkBg`, `--${pt ? `${pt}-` : ""}palette-AppBar-darkColor`], defaultGetSelector$1 = (pt) => (yt, ir) => {
  const ti = pt.rootSelector || ":root", ii = pt.colorSchemeSelector;
  let ui = ii;
  if (ii === "class" && (ui = ".%s"), ii === "data" && (ui = "[data-%s]"), ii != null && ii.startsWith("data-") && !ii.includes("%s") && (ui = `[${ii}="%s"]`), pt.defaultColorScheme === yt) {
    if (yt === "dark") {
      const ai = {};
      return excludeVariablesFromRoot$1(pt.cssVarPrefix).forEach((li) => {
        ai[li] = ir[li], delete ir[li];
      }), ui === "media" ? {
        [ti]: ir,
        "@media (prefers-color-scheme: dark)": {
          [ti]: ai
        }
      } : ui ? {
        [ui.replace("%s", yt)]: ai,
        [`${ti}, ${ui.replace("%s", yt)}`]: ir
      } : {
        [ti]: {
          ...ir,
          ...ai
        }
      };
    }
    if (ui && ui !== "media")
      return `${ti}, ${ui.replace("%s", String(yt))}`;
  } else if (yt) {
    if (ui === "media")
      return {
        [`@media (prefers-color-scheme: ${String(yt)})`]: {
          [ti]: ir
        }
      };
    if (ui)
      return ui.replace("%s", String(yt));
  }
  return ti;
};
function assignNode$1(pt, yt) {
  yt.forEach((ir) => {
    pt[ir] || (pt[ir] = {});
  });
}
function setColor$1(pt, yt, ir) {
  !pt[yt] && ir && (pt[yt] = ir);
}
function toRgb$1(pt) {
  return typeof pt != "string" || !pt.startsWith("hsl") ? pt : hslToRgb$1(pt);
}
function setColorChannel$1(pt, yt) {
  `${yt}Channel` in pt || (pt[`${yt}Channel`] = private_safeColorChannel$1(toRgb$1(pt[yt]), `MUI: Can't create \`palette.${yt}Channel\` because \`palette.${yt}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().
To suppress this warning, you need to explicitly provide the \`palette.${yt}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`));
}
function getSpacingVal$1(pt) {
  return typeof pt == "number" ? `${pt}px` : typeof pt == "string" || typeof pt == "function" || Array.isArray(pt) ? pt : "8px";
}
const silent$1 = (pt) => {
  try {
    return pt();
  } catch {
  }
}, createGetCssVar$2 = (pt = "mui") => createGetCssVar$1$1(pt);
function attachColorScheme$1$1(pt, yt, ir, ti, ii) {
  if (!ir)
    return;
  ir = ir === !0 ? {} : ir;
  const ui = ii === "dark" ? "dark" : "light";
  if (!ti) {
    yt[ii] = createColorScheme$1({
      ...ir,
      palette: {
        mode: ui,
        ...ir == null ? void 0 : ir.palette
      },
      colorSpace: pt
    });
    return;
  }
  const {
    palette: ai,
    ...li
  } = createThemeNoVars$1({
    ...ti,
    palette: {
      mode: ui,
      ...ir == null ? void 0 : ir.palette
    },
    colorSpace: pt
  });
  return yt[ii] = {
    ...ir,
    palette: ai,
    opacity: {
      ...getOpacity$1(ui),
      ...ir == null ? void 0 : ir.opacity
    },
    overlays: (ir == null ? void 0 : ir.overlays) || getOverlays$1(ui)
  }, li;
}
function createThemeWithVars$1(pt = {}, ...yt) {
  const {
    colorSchemes: ir = {
      light: !0
    },
    defaultColorScheme: ti,
    disableCssColorScheme: ii = !1,
    cssVarPrefix: ui = "mui",
    nativeColor: ai = !1,
    shouldSkipGeneratingVar: li = shouldSkipGeneratingVar$1,
    colorSchemeSelector: oi = ir.light && ir.dark ? "media" : void 0,
    rootSelector: si = ":root",
    ...di
  } = pt, fi = Object.keys(ir)[0], gi = ti || (ir.light && fi !== "light" ? "light" : fi), mi = createGetCssVar$2(ui), {
    [gi]: Ti,
    light: vi,
    dark: xi,
    ...Si
  } = ir, Pi = {
    ...Si
  };
  let $i = Ti;
  if ((gi === "dark" && !("dark" in ir) || gi === "light" && !("light" in ir)) && ($i = !0), !$i)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The \`colorSchemes.${gi}\` option is either missing or invalid.` : formatMuiErrorMessage$2(21, gi));
  let Oi;
  ai && (Oi = "oklch");
  const Di = attachColorScheme$1$1(Oi, Pi, $i, di, gi);
  vi && !Pi.light && attachColorScheme$1$1(Oi, Pi, vi, void 0, "light"), xi && !Pi.dark && attachColorScheme$1$1(Oi, Pi, xi, void 0, "dark");
  let Mi = {
    defaultColorScheme: gi,
    ...Di,
    cssVarPrefix: ui,
    colorSchemeSelector: oi,
    rootSelector: si,
    getCssVar: mi,
    colorSchemes: Pi,
    font: {
      ...prepareTypographyVars$1(Di.typography),
      ...Di.font
    },
    spacing: getSpacingVal$1(di.spacing)
  };
  Object.keys(Mi.colorSchemes).forEach((_o) => {
    const Li = Mi.colorSchemes[_o].palette, Co = (Yi) => {
      const Vo = Yi.split("-"), No = Vo[1], Ui = Vo[2];
      return mi(Yi, Li[No][Ui]);
    };
    Li.mode === "light" && (setColor$1(Li.common, "background", "#fff"), setColor$1(Li.common, "onBackground", "#000")), Li.mode === "dark" && (setColor$1(Li.common, "background", "#000"), setColor$1(Li.common, "onBackground", "#fff"));
    function Ni(Yi, Vo, No) {
      if (Oi) {
        let Ui;
        return Yi === private_safeAlpha$1 && (Ui = `transparent ${((1 - No) * 100).toFixed(0)}%`), Yi === private_safeDarken$1 && (Ui = `#000 ${(No * 100).toFixed(0)}%`), Yi === private_safeLighten$1 && (Ui = `#fff ${(No * 100).toFixed(0)}%`), `color-mix(in ${Oi}, ${Vo}, ${Ui})`;
      }
      return Yi(Vo, No);
    }
    if (assignNode$1(Li, ["Alert", "AppBar", "Avatar", "Button", "Chip", "FilledInput", "LinearProgress", "Skeleton", "Slider", "SnackbarContent", "SpeedDialAction", "StepConnector", "StepContent", "Switch", "TableCell", "Tooltip"]), Li.mode === "light") {
      setColor$1(Li.Alert, "errorColor", Ni(private_safeDarken$1, ai ? mi("palette-error-light") : Li.error.light, 0.6)), setColor$1(Li.Alert, "infoColor", Ni(private_safeDarken$1, ai ? mi("palette-info-light") : Li.info.light, 0.6)), setColor$1(Li.Alert, "successColor", Ni(private_safeDarken$1, ai ? mi("palette-success-light") : Li.success.light, 0.6)), setColor$1(Li.Alert, "warningColor", Ni(private_safeDarken$1, ai ? mi("palette-warning-light") : Li.warning.light, 0.6)), setColor$1(Li.Alert, "errorFilledBg", Co("palette-error-main")), setColor$1(Li.Alert, "infoFilledBg", Co("palette-info-main")), setColor$1(Li.Alert, "successFilledBg", Co("palette-success-main")), setColor$1(Li.Alert, "warningFilledBg", Co("palette-warning-main")), setColor$1(Li.Alert, "errorFilledColor", silent$1(() => Li.getContrastText(Li.error.main))), setColor$1(Li.Alert, "infoFilledColor", silent$1(() => Li.getContrastText(Li.info.main))), setColor$1(Li.Alert, "successFilledColor", silent$1(() => Li.getContrastText(Li.success.main))), setColor$1(Li.Alert, "warningFilledColor", silent$1(() => Li.getContrastText(Li.warning.main))), setColor$1(Li.Alert, "errorStandardBg", Ni(private_safeLighten$1, ai ? mi("palette-error-light") : Li.error.light, 0.9)), setColor$1(Li.Alert, "infoStandardBg", Ni(private_safeLighten$1, ai ? mi("palette-info-light") : Li.info.light, 0.9)), setColor$1(Li.Alert, "successStandardBg", Ni(private_safeLighten$1, ai ? mi("palette-success-light") : Li.success.light, 0.9)), setColor$1(Li.Alert, "warningStandardBg", Ni(private_safeLighten$1, ai ? mi("palette-warning-light") : Li.warning.light, 0.9)), setColor$1(Li.Alert, "errorIconColor", Co("palette-error-main")), setColor$1(Li.Alert, "infoIconColor", Co("palette-info-main")), setColor$1(Li.Alert, "successIconColor", Co("palette-success-main")), setColor$1(Li.Alert, "warningIconColor", Co("palette-warning-main")), setColor$1(Li.AppBar, "defaultBg", Co("palette-grey-100")), setColor$1(Li.Avatar, "defaultBg", Co("palette-grey-400")), setColor$1(Li.Button, "inheritContainedBg", Co("palette-grey-300")), setColor$1(Li.Button, "inheritContainedHoverBg", Co("palette-grey-A100")), setColor$1(Li.Chip, "defaultBorder", Co("palette-grey-400")), setColor$1(Li.Chip, "defaultAvatarColor", Co("palette-grey-700")), setColor$1(Li.Chip, "defaultIconColor", Co("palette-grey-700")), setColor$1(Li.FilledInput, "bg", "rgba(0, 0, 0, 0.06)"), setColor$1(Li.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)"), setColor$1(Li.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)"), setColor$1(Li.LinearProgress, "primaryBg", Ni(private_safeLighten$1, ai ? mi("palette-primary-main") : Li.primary.main, 0.62)), setColor$1(Li.LinearProgress, "secondaryBg", Ni(private_safeLighten$1, ai ? mi("palette-secondary-main") : Li.secondary.main, 0.62)), setColor$1(Li.LinearProgress, "errorBg", Ni(private_safeLighten$1, ai ? mi("palette-error-main") : Li.error.main, 0.62)), setColor$1(Li.LinearProgress, "infoBg", Ni(private_safeLighten$1, ai ? mi("palette-info-main") : Li.info.main, 0.62)), setColor$1(Li.LinearProgress, "successBg", Ni(private_safeLighten$1, ai ? mi("palette-success-main") : Li.success.main, 0.62)), setColor$1(Li.LinearProgress, "warningBg", Ni(private_safeLighten$1, ai ? mi("palette-warning-light") : Li.warning.main, 0.62)), setColor$1(Li.Skeleton, "bg", Oi ? Ni(private_safeAlpha$1, ai ? mi("palette-text-primary") : Li.text.primary, 0.11) : `rgba(${Co("palette-text-primaryChannel")} / 0.11)`), setColor$1(Li.Slider, "primaryTrack", Ni(private_safeLighten$1, ai ? mi("palette-primary-main") : Li.primary.main, 0.62)), setColor$1(Li.Slider, "secondaryTrack", Ni(private_safeLighten$1, ai ? mi("palette-secondary-main") : Li.secondary.main, 0.62)), setColor$1(Li.Slider, "errorTrack", Ni(private_safeLighten$1, ai ? mi("palette-error-main") : Li.error.main, 0.62)), setColor$1(Li.Slider, "infoTrack", Ni(private_safeLighten$1, ai ? mi("palette-info-main") : Li.info.main, 0.62)), setColor$1(Li.Slider, "successTrack", Ni(private_safeLighten$1, ai ? mi("palette-success-main") : Li.success.main, 0.62)), setColor$1(Li.Slider, "warningTrack", Ni(private_safeLighten$1, ai ? mi("palette-warning-main") : Li.warning.main, 0.62));
      const Yi = Oi ? Ni(private_safeDarken$1, ai ? mi("palette-background-default") : Li.background.default, 0.6825) : private_safeEmphasize$1(Li.background.default, 0.8);
      setColor$1(Li.SnackbarContent, "bg", Yi), setColor$1(Li.SnackbarContent, "color", silent$1(() => Oi ? dark$1.text.primary : Li.getContrastText(Yi))), setColor$1(Li.SpeedDialAction, "fabHoverBg", private_safeEmphasize$1(Li.background.paper, 0.15)), setColor$1(Li.StepConnector, "border", Co("palette-grey-400")), setColor$1(Li.StepContent, "border", Co("palette-grey-400")), setColor$1(Li.Switch, "defaultColor", Co("palette-common-white")), setColor$1(Li.Switch, "defaultDisabledColor", Co("palette-grey-100")), setColor$1(Li.Switch, "primaryDisabledColor", Ni(private_safeLighten$1, ai ? mi("palette-primary-main") : Li.primary.main, 0.62)), setColor$1(Li.Switch, "secondaryDisabledColor", Ni(private_safeLighten$1, ai ? mi("palette-secondary-main") : Li.secondary.main, 0.62)), setColor$1(Li.Switch, "errorDisabledColor", Ni(private_safeLighten$1, ai ? mi("palette-error-main") : Li.error.main, 0.62)), setColor$1(Li.Switch, "infoDisabledColor", Ni(private_safeLighten$1, ai ? mi("palette-info-main") : Li.info.main, 0.62)), setColor$1(Li.Switch, "successDisabledColor", Ni(private_safeLighten$1, ai ? mi("palette-success-main") : Li.success.main, 0.62)), setColor$1(Li.Switch, "warningDisabledColor", Ni(private_safeLighten$1, ai ? mi("palette-warning-main") : Li.warning.main, 0.62)), setColor$1(Li.TableCell, "border", Ni(private_safeLighten$1, private_safeAlpha$1(ai ? mi("palette-divider") : Li.divider, 1), 0.88)), setColor$1(Li.Tooltip, "bg", Ni(private_safeAlpha$1, ai ? mi("palette-grey-700") : Li.grey[700], 0.92));
    }
    if (Li.mode === "dark") {
      setColor$1(Li.Alert, "errorColor", Ni(private_safeLighten$1, ai ? mi("palette-error-light") : Li.error.light, 0.6)), setColor$1(Li.Alert, "infoColor", Ni(private_safeLighten$1, ai ? mi("palette-info-light") : Li.info.light, 0.6)), setColor$1(Li.Alert, "successColor", Ni(private_safeLighten$1, ai ? mi("palette-success-light") : Li.success.light, 0.6)), setColor$1(Li.Alert, "warningColor", Ni(private_safeLighten$1, ai ? mi("palette-warning-light") : Li.warning.light, 0.6)), setColor$1(Li.Alert, "errorFilledBg", Co("palette-error-dark")), setColor$1(Li.Alert, "infoFilledBg", Co("palette-info-dark")), setColor$1(Li.Alert, "successFilledBg", Co("palette-success-dark")), setColor$1(Li.Alert, "warningFilledBg", Co("palette-warning-dark")), setColor$1(Li.Alert, "errorFilledColor", silent$1(() => Li.getContrastText(Li.error.dark))), setColor$1(Li.Alert, "infoFilledColor", silent$1(() => Li.getContrastText(Li.info.dark))), setColor$1(Li.Alert, "successFilledColor", silent$1(() => Li.getContrastText(Li.success.dark))), setColor$1(Li.Alert, "warningFilledColor", silent$1(() => Li.getContrastText(Li.warning.dark))), setColor$1(Li.Alert, "errorStandardBg", Ni(private_safeDarken$1, ai ? mi("palette-error-light") : Li.error.light, 0.9)), setColor$1(Li.Alert, "infoStandardBg", Ni(private_safeDarken$1, ai ? mi("palette-info-light") : Li.info.light, 0.9)), setColor$1(Li.Alert, "successStandardBg", Ni(private_safeDarken$1, ai ? mi("palette-success-light") : Li.success.light, 0.9)), setColor$1(Li.Alert, "warningStandardBg", Ni(private_safeDarken$1, ai ? mi("palette-warning-light") : Li.warning.light, 0.9)), setColor$1(Li.Alert, "errorIconColor", Co("palette-error-main")), setColor$1(Li.Alert, "infoIconColor", Co("palette-info-main")), setColor$1(Li.Alert, "successIconColor", Co("palette-success-main")), setColor$1(Li.Alert, "warningIconColor", Co("palette-warning-main")), setColor$1(Li.AppBar, "defaultBg", Co("palette-grey-900")), setColor$1(Li.AppBar, "darkBg", Co("palette-background-paper")), setColor$1(Li.AppBar, "darkColor", Co("palette-text-primary")), setColor$1(Li.Avatar, "defaultBg", Co("palette-grey-600")), setColor$1(Li.Button, "inheritContainedBg", Co("palette-grey-800")), setColor$1(Li.Button, "inheritContainedHoverBg", Co("palette-grey-700")), setColor$1(Li.Chip, "defaultBorder", Co("palette-grey-700")), setColor$1(Li.Chip, "defaultAvatarColor", Co("palette-grey-300")), setColor$1(Li.Chip, "defaultIconColor", Co("palette-grey-300")), setColor$1(Li.FilledInput, "bg", "rgba(255, 255, 255, 0.09)"), setColor$1(Li.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)"), setColor$1(Li.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)"), setColor$1(Li.LinearProgress, "primaryBg", Ni(private_safeDarken$1, ai ? mi("palette-primary-main") : Li.primary.main, 0.5)), setColor$1(Li.LinearProgress, "secondaryBg", Ni(private_safeDarken$1, ai ? mi("palette-secondary-main") : Li.secondary.main, 0.5)), setColor$1(Li.LinearProgress, "errorBg", Ni(private_safeDarken$1, ai ? mi("palette-error-main") : Li.error.main, 0.5)), setColor$1(Li.LinearProgress, "infoBg", Ni(private_safeDarken$1, ai ? mi("palette-info-main") : Li.info.main, 0.5)), setColor$1(Li.LinearProgress, "successBg", Ni(private_safeDarken$1, ai ? mi("palette-success-main") : Li.success.main, 0.5)), setColor$1(Li.LinearProgress, "warningBg", Ni(private_safeDarken$1, ai ? mi("palette-warning-main") : Li.warning.main, 0.5)), setColor$1(Li.Skeleton, "bg", Oi ? Ni(private_safeAlpha$1, ai ? mi("palette-text-primary") : Li.text.primary, 0.13) : `rgba(${Co("palette-text-primaryChannel")} / 0.13)`), setColor$1(Li.Slider, "primaryTrack", Ni(private_safeDarken$1, ai ? mi("palette-primary-main") : Li.primary.main, 0.5)), setColor$1(Li.Slider, "secondaryTrack", Ni(private_safeDarken$1, ai ? mi("palette-secondary-main") : Li.secondary.main, 0.5)), setColor$1(Li.Slider, "errorTrack", Ni(private_safeDarken$1, ai ? mi("palette-error-main") : Li.error.main, 0.5)), setColor$1(Li.Slider, "infoTrack", Ni(private_safeDarken$1, ai ? mi("palette-info-main") : Li.info.main, 0.5)), setColor$1(Li.Slider, "successTrack", Ni(private_safeDarken$1, ai ? mi("palette-success-main") : Li.success.main, 0.5)), setColor$1(Li.Slider, "warningTrack", Ni(private_safeDarken$1, ai ? mi("palette-warning-light") : Li.warning.main, 0.5));
      const Yi = Oi ? Ni(private_safeLighten$1, ai ? mi("palette-background-default") : Li.background.default, 0.985) : private_safeEmphasize$1(Li.background.default, 0.98);
      setColor$1(Li.SnackbarContent, "bg", Yi), setColor$1(Li.SnackbarContent, "color", silent$1(() => Oi ? light$1.text.primary : Li.getContrastText(Yi))), setColor$1(Li.SpeedDialAction, "fabHoverBg", private_safeEmphasize$1(Li.background.paper, 0.15)), setColor$1(Li.StepConnector, "border", Co("palette-grey-600")), setColor$1(Li.StepContent, "border", Co("palette-grey-600")), setColor$1(Li.Switch, "defaultColor", Co("palette-grey-300")), setColor$1(Li.Switch, "defaultDisabledColor", Co("palette-grey-600")), setColor$1(Li.Switch, "primaryDisabledColor", Ni(private_safeDarken$1, ai ? mi("palette-primary-main") : Li.primary.main, 0.55)), setColor$1(Li.Switch, "secondaryDisabledColor", Ni(private_safeDarken$1, ai ? mi("palette-secondary-main") : Li.secondary.main, 0.55)), setColor$1(Li.Switch, "errorDisabledColor", Ni(private_safeDarken$1, ai ? mi("palette-error-main") : Li.error.main, 0.55)), setColor$1(Li.Switch, "infoDisabledColor", Ni(private_safeDarken$1, ai ? mi("palette-info-main") : Li.info.main, 0.55)), setColor$1(Li.Switch, "successDisabledColor", Ni(private_safeDarken$1, ai ? mi("palette-success-main") : Li.success.main, 0.55)), setColor$1(Li.Switch, "warningDisabledColor", Ni(private_safeDarken$1, ai ? mi("palette-warning-light") : Li.warning.main, 0.55)), setColor$1(Li.TableCell, "border", Ni(private_safeDarken$1, private_safeAlpha$1(ai ? mi("palette-divider") : Li.divider, 1), 0.68)), setColor$1(Li.Tooltip, "bg", Ni(private_safeAlpha$1, ai ? mi("palette-grey-700") : Li.grey[700], 0.92));
    }
    setColorChannel$1(Li.background, "default"), setColorChannel$1(Li.background, "paper"), setColorChannel$1(Li.common, "background"), setColorChannel$1(Li.common, "onBackground"), setColorChannel$1(Li, "divider"), Object.keys(Li).forEach((Yi) => {
      const Vo = Li[Yi];
      Yi !== "tonalOffset" && Vo && typeof Vo == "object" && (Vo.main && setColor$1(Li[Yi], "mainChannel", private_safeColorChannel$1(toRgb$1(Vo.main))), Vo.light && setColor$1(Li[Yi], "lightChannel", private_safeColorChannel$1(toRgb$1(Vo.light))), Vo.dark && setColor$1(Li[Yi], "darkChannel", private_safeColorChannel$1(toRgb$1(Vo.dark))), Vo.contrastText && setColor$1(Li[Yi], "contrastTextChannel", private_safeColorChannel$1(toRgb$1(Vo.contrastText))), Yi === "text" && (setColorChannel$1(Li[Yi], "primary"), setColorChannel$1(Li[Yi], "secondary")), Yi === "action" && (Vo.active && setColorChannel$1(Li[Yi], "active"), Vo.selected && setColorChannel$1(Li[Yi], "selected")));
    });
  }), Mi = yt.reduce((_o, Li) => deepmerge$1(_o, Li), Mi);
  const Oo = {
    prefix: ui,
    disableCssColorScheme: ii,
    shouldSkipGeneratingVar: li,
    getSelector: defaultGetSelector$1(Mi),
    enableContrastVars: ai
  }, {
    vars: io,
    generateThemeVars: xo,
    generateStyleSheets: fo
  } = prepareCssVars$1(Mi, Oo);
  return Mi.vars = io, Object.entries(Mi.colorSchemes[Mi.defaultColorScheme]).forEach(([_o, Li]) => {
    Mi[_o] = Li;
  }), Mi.generateThemeVars = xo, Mi.generateStyleSheets = fo, Mi.generateSpacing = function() {
    return createSpacing$1(di.spacing, createUnarySpacing$1(this));
  }, Mi.getColorSchemeSelector = createGetColorSchemeSelector$1(oi), Mi.spacing = Mi.generateSpacing(), Mi.shouldSkipGeneratingVar = li, Mi.unstable_sxConfig = {
    ...defaultSxConfig$1,
    ...di == null ? void 0 : di.unstable_sxConfig
  }, Mi.unstable_sx = function(_o) {
    return styleFunctionSx$1({
      sx: _o,
      theme: this
    });
  }, Mi.toRuntimeSource = stringifyTheme$1, Mi;
}
function attachColorScheme$2(pt, yt, ir) {
  pt.colorSchemes && ir && (pt.colorSchemes[yt] = {
    ...ir !== !0 && ir,
    palette: createPalette$1({
      ...ir === !0 ? {} : ir.palette,
      mode: yt
    })
    // cast type to skip module augmentation test
  });
}
function createTheme$2(pt = {}, ...yt) {
  const {
    palette: ir,
    cssVariables: ti = !1,
    colorSchemes: ii = ir ? void 0 : {
      light: !0
    },
    defaultColorScheme: ui = ir == null ? void 0 : ir.mode,
    ...ai
  } = pt, li = ui || "light", oi = ii == null ? void 0 : ii[li], si = {
    ...ii,
    ...ir ? {
      [li]: {
        ...typeof oi != "boolean" && oi,
        palette: ir
      }
    } : void 0
  };
  if (ti === !1) {
    if (!("colorSchemes" in pt))
      return createThemeNoVars$1(pt, ...yt);
    let di = ir;
    "palette" in pt || si[li] && (si[li] !== !0 ? di = si[li].palette : li === "dark" && (di = {
      mode: "dark"
    }));
    const fi = createThemeNoVars$1({
      ...pt,
      palette: di
    }, ...yt);
    return fi.defaultColorScheme = li, fi.colorSchemes = si, fi.palette.mode === "light" && (fi.colorSchemes.light = {
      ...si.light !== !0 && si.light,
      palette: fi.palette
    }, attachColorScheme$2(fi, "dark", si.dark)), fi.palette.mode === "dark" && (fi.colorSchemes.dark = {
      ...si.dark !== !0 && si.dark,
      palette: fi.palette
    }, attachColorScheme$2(fi, "light", si.light)), fi;
  }
  return !ir && !("light" in si) && li === "light" && (si.light = !0), createThemeWithVars$1({
    ...ai,
    colorSchemes: si,
    defaultColorScheme: li,
    ...typeof ti != "boolean" && ti
  }, ...yt);
}
const defaultTheme$1 = createTheme$2(), THEME_ID$1 = "$$material";
function useTheme$3() {
  const pt = useTheme$1$1(defaultTheme$1);
  return process.env.NODE_ENV !== "production" && React.useDebugValue(pt), pt[THEME_ID$1] || pt;
}
function GlobalStyles(pt) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GlobalStyles$1, {
    ...pt,
    defaultTheme: defaultTheme$1,
    themeId: THEME_ID$1
  });
}
process.env.NODE_ENV !== "production" && (GlobalStyles.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The styles you want to apply globally.
   */
  styles: PropTypes.oneOfType([PropTypes.array, PropTypes.func, PropTypes.number, PropTypes.object, PropTypes.string, PropTypes.bool])
});
const styled$3 = createStyled$2({
  themeId: THEME_ID$1,
  defaultTheme: defaultTheme$1,
  rootShouldForwardProp: rootShouldForwardProp$1
});
function globalCss(pt) {
  return function(yt) {
    return (
      // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
      /* @__PURE__ */ jsxRuntimeExports.jsx(GlobalStyles, {
        styles: typeof pt == "function" ? (ir) => pt({
          theme: ir,
          ...yt
        }) : pt
      })
    );
  };
}
function internal_createExtendSxProp() {
  return extendSxProp$1;
}
function useControlled$2(pt) {
  const {
    controlled: yt,
    default: ir,
    name: ti,
    state: ii = "value"
  } = pt, {
    current: ui
  } = React.useRef(yt !== void 0), [ai, li] = React.useState(ir), oi = ui ? yt : ai;
  if (process.env.NODE_ENV !== "production") {
    React.useEffect(() => {
      ui !== (yt !== void 0) && console.error([`MUI: A component is changing the ${ui ? "" : "un"}controlled ${ii} state of ${ti} to be ${ui ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${ti} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [ii, ti, yt]);
    const {
      current: di
    } = React.useRef(ir);
    React.useEffect(() => {
      !ui && JSON.stringify(ir) !== JSON.stringify(di) && console.error([`MUI: A component is changing the default ${ii} state of an uncontrolled ${ti} after being initialized. To suppress this warning opt to use a controlled ${ti}.`].join(`
`));
    }, [JSON.stringify(ir)]);
  }
  const si = React.useCallback((di) => {
    ui || li(di);
  }, []);
  return [oi, si];
}
const FormControlContext = /* @__PURE__ */ React.createContext(void 0);
process.env.NODE_ENV !== "production" && (FormControlContext.displayName = "FormControlContext");
function useFormControl() {
  return React.useContext(FormControlContext);
}
function chainPropTypes$2(pt, yt) {
  return process.env.NODE_ENV === "production" ? () => null : function(...ir) {
    return pt(...ir) || yt(...ir);
  };
}
function isClassComponent$1$1(pt) {
  const {
    prototype: yt = {}
  } = pt;
  return !!yt.isReactComponent;
}
function elementTypeAcceptingRef$2(pt, yt, ir, ti, ii) {
  const ui = pt[yt], ai = ii || yt;
  if (ui == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let li;
  return typeof ui == "function" && !isClassComponent$1$1(ui) && (li = "Did you accidentally provide a plain function component instead?"), ui === React.Fragment && (li = "Did you accidentally provide a React.Fragment instead?"), li !== void 0 ? new Error(`Invalid ${ti} \`${ai}\` supplied to \`${ir}\`. Expected an element type that can hold a ref. ${li} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const elementTypeAcceptingRef$1$1 = chainPropTypes$2(PropTypes.elementType, elementTypeAcceptingRef$2);
function isFocusVisible$2(pt) {
  try {
    return pt.matches(":focus-visible");
  } catch {
    process.env.NODE_ENV !== "production" && !window.navigator.userAgent.includes("jsdom") && console.warn(["MUI: The `:focus-visible` pseudo class is not supported in this browser.", "Some components rely on this feature to work properly."].join(`
`));
  }
  return !1;
}
process.env.NODE_ENV !== "production" && (PropTypes.node, PropTypes.object.isRequired);
function useDefaultProps$2(pt) {
  return useDefaultProps$1$1(pt);
}
function useForkRef$2(...pt) {
  const yt = React.useRef(void 0), ir = React.useCallback((ti) => {
    const ii = pt.map((ui) => {
      if (ui == null)
        return null;
      if (typeof ui == "function") {
        const ai = ui, li = ai(ti);
        return typeof li == "function" ? li : () => {
          ai(null);
        };
      }
      return ui.current = ti, () => {
        ui.current = null;
      };
    });
    return () => {
      ii.forEach((ui) => ui == null ? void 0 : ui());
    };
  }, pt);
  return React.useMemo(() => pt.every((ti) => ti == null) ? null : (ti) => {
    yt.current && (yt.current(), yt.current = void 0), ti != null && (yt.current = ir(ti));
  }, pt);
}
function useEventCallback$2(pt) {
  const yt = React.useRef(pt);
  return useEnhancedEffect$2(() => {
    yt.current = pt;
  }), React.useRef((...ir) => (
    // @ts-expect-error hide `this`
    (0, yt.current)(...ir)
  )).current;
}
const UNINITIALIZED$1 = {};
function useLazyRef$1(pt, yt) {
  const ir = React.useRef(UNINITIALIZED$1);
  return ir.current === UNINITIALIZED$1 && (ir.current = pt(yt)), ir;
}
let LazyRipple$1 = class h0 {
  constructor() {
    Ga(this, "mountEffect", () => {
      this.shouldMount && !this.didMount && this.ref.current !== null && (this.didMount = !0, this.mounted.resolve());
    }), this.ref = {
      current: null
    }, this.mounted = null, this.didMount = !1, this.shouldMount = !1, this.setShouldMount = null;
  }
  /** React ref to the ripple instance */
  /** If the ripple component should be mounted */
  /** Promise that resolves when the ripple component is mounted */
  /** If the ripple component has been mounted */
  /** React state hook setter */
  static create() {
    return new h0();
  }
  static use() {
    const yt = useLazyRef$1(h0.create).current, [ir, ti] = React.useState(!1);
    return yt.shouldMount = ir, yt.setShouldMount = ti, React.useEffect(yt.mountEffect, [ir]), yt;
  }
  mount() {
    return this.mounted || (this.mounted = createControlledPromise$1(), this.shouldMount = !0, this.setShouldMount(this.shouldMount)), this.mounted;
  }
  /* Ripple API */
  start(...yt) {
    this.mount().then(() => {
      var ir;
      return (ir = this.ref.current) == null ? void 0 : ir.start(...yt);
    });
  }
  stop(...yt) {
    this.mount().then(() => {
      var ir;
      return (ir = this.ref.current) == null ? void 0 : ir.stop(...yt);
    });
  }
  pulsate(...yt) {
    this.mount().then(() => {
      var ir;
      return (ir = this.ref.current) == null ? void 0 : ir.pulsate(...yt);
    });
  }
};
function useLazyRipple$1() {
  return LazyRipple$1.use();
}
function createControlledPromise$1() {
  let pt, yt;
  const ir = new Promise((ti, ii) => {
    pt = ti, yt = ii;
  });
  return ir.resolve = pt, ir.reject = yt, ir;
}
function _objectWithoutPropertiesLoose$l(pt, yt) {
  if (pt == null) return {};
  var ir = {};
  for (var ti in pt) if ({}.hasOwnProperty.call(pt, ti)) {
    if (yt.indexOf(ti) !== -1) continue;
    ir[ti] = pt[ti];
  }
  return ir;
}
function _setPrototypeOf$1(pt, yt) {
  return _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(ir, ti) {
    return ir.__proto__ = ti, ir;
  }, _setPrototypeOf$1(pt, yt);
}
function _inheritsLoose$1(pt, yt) {
  pt.prototype = Object.create(yt.prototype), pt.prototype.constructor = pt, _setPrototypeOf$1(pt, yt);
}
const config$2 = {
  disabled: !1
};
var timeoutsShape$1 = process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
process.env.NODE_ENV !== "production" && PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]);
const TransitionGroupContext$1 = React__default.createContext(null);
var forceReflow$1 = function(pt) {
  return pt.scrollTop;
}, UNMOUNTED$1 = "unmounted", EXITED$1 = "exited", ENTERING$1 = "entering", ENTERED$1 = "entered", EXITING$1 = "exiting", Transition$1 = /* @__PURE__ */ (function(pt) {
  _inheritsLoose$1(yt, pt);
  function yt(ti, ii) {
    var ui;
    ui = pt.call(this, ti, ii) || this;
    var ai = ii, li = ai && !ai.isMounting ? ti.enter : ti.appear, oi;
    return ui.appearStatus = null, ti.in ? li ? (oi = EXITED$1, ui.appearStatus = ENTERING$1) : oi = ENTERED$1 : ti.unmountOnExit || ti.mountOnEnter ? oi = UNMOUNTED$1 : oi = EXITED$1, ui.state = {
      status: oi
    }, ui.nextCallback = null, ui;
  }
  yt.getDerivedStateFromProps = function(ti, ii) {
    var ui = ti.in;
    return ui && ii.status === UNMOUNTED$1 ? {
      status: EXITED$1
    } : null;
  };
  var ir = yt.prototype;
  return ir.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, ir.componentDidUpdate = function(ti) {
    var ii = null;
    if (ti !== this.props) {
      var ui = this.state.status;
      this.props.in ? ui !== ENTERING$1 && ui !== ENTERED$1 && (ii = ENTERING$1) : (ui === ENTERING$1 || ui === ENTERED$1) && (ii = EXITING$1);
    }
    this.updateStatus(!1, ii);
  }, ir.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, ir.getTimeouts = function() {
    var ti = this.props.timeout, ii, ui, ai;
    return ii = ui = ai = ti, ti != null && typeof ti != "number" && (ii = ti.exit, ui = ti.enter, ai = ti.appear !== void 0 ? ti.appear : ui), {
      exit: ii,
      enter: ui,
      appear: ai
    };
  }, ir.updateStatus = function(ti, ii) {
    if (ti === void 0 && (ti = !1), ii !== null)
      if (this.cancelNextCallback(), ii === ENTERING$1) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var ui = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this);
          ui && forceReflow$1(ui);
        }
        this.performEnter(ti);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === EXITED$1 && this.setState({
      status: UNMOUNTED$1
    });
  }, ir.performEnter = function(ti) {
    var ii = this, ui = this.props.enter, ai = this.context ? this.context.isMounting : ti, li = this.props.nodeRef ? [ai] : [ReactDOM__default.findDOMNode(this), ai], oi = li[0], si = li[1], di = this.getTimeouts(), fi = ai ? di.appear : di.enter;
    if (!ti && !ui || config$2.disabled) {
      this.safeSetState({
        status: ENTERED$1
      }, function() {
        ii.props.onEntered(oi);
      });
      return;
    }
    this.props.onEnter(oi, si), this.safeSetState({
      status: ENTERING$1
    }, function() {
      ii.props.onEntering(oi, si), ii.onTransitionEnd(fi, function() {
        ii.safeSetState({
          status: ENTERED$1
        }, function() {
          ii.props.onEntered(oi, si);
        });
      });
    });
  }, ir.performExit = function() {
    var ti = this, ii = this.props.exit, ui = this.getTimeouts(), ai = this.props.nodeRef ? void 0 : ReactDOM__default.findDOMNode(this);
    if (!ii || config$2.disabled) {
      this.safeSetState({
        status: EXITED$1
      }, function() {
        ti.props.onExited(ai);
      });
      return;
    }
    this.props.onExit(ai), this.safeSetState({
      status: EXITING$1
    }, function() {
      ti.props.onExiting(ai), ti.onTransitionEnd(ui.exit, function() {
        ti.safeSetState({
          status: EXITED$1
        }, function() {
          ti.props.onExited(ai);
        });
      });
    });
  }, ir.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, ir.safeSetState = function(ti, ii) {
    ii = this.setNextCallback(ii), this.setState(ti, ii);
  }, ir.setNextCallback = function(ti) {
    var ii = this, ui = !0;
    return this.nextCallback = function(ai) {
      ui && (ui = !1, ii.nextCallback = null, ti(ai));
    }, this.nextCallback.cancel = function() {
      ui = !1;
    }, this.nextCallback;
  }, ir.onTransitionEnd = function(ti, ii) {
    this.setNextCallback(ii);
    var ui = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this), ai = ti == null && !this.props.addEndListener;
    if (!ui || ai) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var li = this.props.nodeRef ? [this.nextCallback] : [ui, this.nextCallback], oi = li[0], si = li[1];
      this.props.addEndListener(oi, si);
    }
    ti != null && setTimeout(this.nextCallback, ti);
  }, ir.render = function() {
    var ti = this.state.status;
    if (ti === UNMOUNTED$1)
      return null;
    var ii = this.props, ui = ii.children;
    ii.in, ii.mountOnEnter, ii.unmountOnExit, ii.appear, ii.enter, ii.exit, ii.timeout, ii.addEndListener, ii.onEnter, ii.onEntering, ii.onEntered, ii.onExit, ii.onExiting, ii.onExited, ii.nodeRef;
    var ai = _objectWithoutPropertiesLoose$l(ii, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ React__default.createElement(TransitionGroupContext$1.Provider, {
        value: null
      }, typeof ui == "function" ? ui(ti, ai) : React__default.cloneElement(React__default.Children.only(ui), ai))
    );
  }, yt;
})(React__default.Component);
Transition$1.contextType = TransitionGroupContext$1;
Transition$1.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element > "u" ? PropTypes.any : function(pt, yt, ir, ti, ii, ui) {
      var ai = pt[yt];
      return PropTypes.instanceOf(ai && "ownerDocument" in ai ? ai.ownerDocument.defaultView.Element : Element)(pt, yt, ir, ti, ii, ui);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(pt) {
    var yt = timeoutsShape$1;
    pt.addEndListener || (yt = yt.isRequired);
    for (var ir = arguments.length, ti = new Array(ir > 1 ? ir - 1 : 0), ii = 1; ii < ir; ii++)
      ti[ii - 1] = arguments[ii];
    return yt.apply(void 0, [pt].concat(ti));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {};
function noop$5() {
}
Transition$1.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: noop$5,
  onEntering: noop$5,
  onEntered: noop$5,
  onExit: noop$5,
  onExiting: noop$5,
  onExited: noop$5
};
Transition$1.UNMOUNTED = UNMOUNTED$1;
Transition$1.EXITED = EXITED$1;
Transition$1.ENTERING = ENTERING$1;
Transition$1.ENTERED = ENTERED$1;
Transition$1.EXITING = EXITING$1;
function _assertThisInitialized$1(pt) {
  if (pt === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return pt;
}
function getChildMapping$1(pt, yt) {
  var ir = function(ii) {
    return yt && isValidElement(ii) ? yt(ii) : ii;
  }, ti = /* @__PURE__ */ Object.create(null);
  return pt && Children.map(pt, function(ii) {
    return ii;
  }).forEach(function(ii) {
    ti[ii.key] = ir(ii);
  }), ti;
}
function mergeChildMappings$1(pt, yt) {
  pt = pt || {}, yt = yt || {};
  function ir(di) {
    return di in yt ? yt[di] : pt[di];
  }
  var ti = /* @__PURE__ */ Object.create(null), ii = [];
  for (var ui in pt)
    ui in yt ? ii.length && (ti[ui] = ii, ii = []) : ii.push(ui);
  var ai, li = {};
  for (var oi in yt) {
    if (ti[oi])
      for (ai = 0; ai < ti[oi].length; ai++) {
        var si = ti[oi][ai];
        li[ti[oi][ai]] = ir(si);
      }
    li[oi] = ir(oi);
  }
  for (ai = 0; ai < ii.length; ai++)
    li[ii[ai]] = ir(ii[ai]);
  return li;
}
function getProp$1(pt, yt, ir) {
  return ir[yt] != null ? ir[yt] : pt.props[yt];
}
function getInitialChildMapping$1(pt, yt) {
  return getChildMapping$1(pt.children, function(ir) {
    return cloneElement(ir, {
      onExited: yt.bind(null, ir),
      in: !0,
      appear: getProp$1(ir, "appear", pt),
      enter: getProp$1(ir, "enter", pt),
      exit: getProp$1(ir, "exit", pt)
    });
  });
}
function getNextChildMapping$1(pt, yt, ir) {
  var ti = getChildMapping$1(pt.children), ii = mergeChildMappings$1(yt, ti);
  return Object.keys(ii).forEach(function(ui) {
    var ai = ii[ui];
    if (isValidElement(ai)) {
      var li = ui in yt, oi = ui in ti, si = yt[ui], di = isValidElement(si) && !si.props.in;
      oi && (!li || di) ? ii[ui] = cloneElement(ai, {
        onExited: ir.bind(null, ai),
        in: !0,
        exit: getProp$1(ai, "exit", pt),
        enter: getProp$1(ai, "enter", pt)
      }) : !oi && li && !di ? ii[ui] = cloneElement(ai, {
        in: !1
      }) : oi && li && isValidElement(si) && (ii[ui] = cloneElement(ai, {
        onExited: ir.bind(null, ai),
        in: si.props.in,
        exit: getProp$1(ai, "exit", pt),
        enter: getProp$1(ai, "enter", pt)
      }));
    }
  }), ii;
}
var values$2 = Object.values || function(pt) {
  return Object.keys(pt).map(function(yt) {
    return pt[yt];
  });
}, defaultProps$1 = {
  component: "div",
  childFactory: function(pt) {
    return pt;
  }
}, TransitionGroup$1 = /* @__PURE__ */ (function(pt) {
  _inheritsLoose$1(yt, pt);
  function yt(ti, ii) {
    var ui;
    ui = pt.call(this, ti, ii) || this;
    var ai = ui.handleExited.bind(_assertThisInitialized$1(ui));
    return ui.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: ai,
      firstRender: !0
    }, ui;
  }
  var ir = yt.prototype;
  return ir.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, ir.componentWillUnmount = function() {
    this.mounted = !1;
  }, yt.getDerivedStateFromProps = function(ti, ii) {
    var ui = ii.children, ai = ii.handleExited, li = ii.firstRender;
    return {
      children: li ? getInitialChildMapping$1(ti, ai) : getNextChildMapping$1(ti, ui, ai),
      firstRender: !1
    };
  }, ir.handleExited = function(ti, ii) {
    var ui = getChildMapping$1(this.props.children);
    ti.key in ui || (ti.props.onExited && ti.props.onExited(ii), this.mounted && this.setState(function(ai) {
      var li = _extends$q({}, ai.children);
      return delete li[ti.key], {
        children: li
      };
    }));
  }, ir.render = function() {
    var ti = this.props, ii = ti.component, ui = ti.childFactory, ai = _objectWithoutPropertiesLoose$l(ti, ["component", "childFactory"]), li = this.state.contextValue, oi = values$2(this.state.children).map(ui);
    return delete ai.appear, delete ai.enter, delete ai.exit, ii === null ? /* @__PURE__ */ React__default.createElement(TransitionGroupContext$1.Provider, {
      value: li
    }, oi) : /* @__PURE__ */ React__default.createElement(TransitionGroupContext$1.Provider, {
      value: li
    }, /* @__PURE__ */ React__default.createElement(ii, ai, oi));
  }, yt;
})(React__default.Component);
TransitionGroup$1.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes.func
} : {};
TransitionGroup$1.defaultProps = defaultProps$1;
const EMPTY$1 = [];
function useOnMount$1(pt) {
  React.useEffect(pt, EMPTY$1);
}
let Timeout$1 = class ab {
  constructor() {
    Ga(this, "currentId", null), Ga(this, "clear", () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    }), Ga(this, "disposeEffect", () => this.clear);
  }
  static create() {
    return new ab();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(yt, ir) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, ir();
    }, yt);
  }
};
function useTimeout$1() {
  const pt = useLazyRef$1(Timeout$1.create).current;
  return useOnMount$1(pt.disposeEffect), pt;
}
function Ripple$1(pt) {
  const {
    className: yt,
    classes: ir,
    pulsate: ti = !1,
    rippleX: ii,
    rippleY: ui,
    rippleSize: ai,
    in: li,
    onExited: oi,
    timeout: si
  } = pt, [di, fi] = React.useState(!1), gi = clsx$1(yt, ir.ripple, ir.rippleVisible, ti && ir.ripplePulsate), mi = {
    width: ai,
    height: ai,
    top: -(ai / 2) + ui,
    left: -(ai / 2) + ii
  }, Ti = clsx$1(ir.child, di && ir.childLeaving, ti && ir.childPulsate);
  return !li && !di && fi(!0), React.useEffect(() => {
    if (!li && oi != null) {
      const vi = setTimeout(oi, si);
      return () => {
        clearTimeout(vi);
      };
    }
  }, [oi, li, si]), /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
    className: gi,
    style: mi,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      className: Ti
    })
  });
}
process.env.NODE_ENV !== "production" && (Ripple$1.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: PropTypes.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: PropTypes.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: PropTypes.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: PropTypes.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: PropTypes.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: PropTypes.number,
  /**
   * exit delay
   */
  timeout: PropTypes.number.isRequired
});
const touchRippleClasses$1 = generateUtilityClasses$2("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), DURATION$1 = 550, DELAY_RIPPLE$1 = 80, enterKeyframe$1 = keyframes$1`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`, exitKeyframe$1 = keyframes$1`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`, pulsateKeyframe$1 = keyframes$1`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`, TouchRippleRoot$1 = styled$3("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), TouchRippleRipple$1 = styled$3(Ripple$1, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})`
  opacity: 0;
  position: absolute;

  &.${touchRippleClasses$1.rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${enterKeyframe$1};
    animation-duration: ${DURATION$1}ms;
    animation-timing-function: ${({
  theme: pt
}) => pt.transitions.easing.easeInOut};
  }

  &.${touchRippleClasses$1.ripplePulsate} {
    animation-duration: ${({
  theme: pt
}) => pt.transitions.duration.shorter}ms;
  }

  & .${touchRippleClasses$1.child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${touchRippleClasses$1.childLeaving} {
    opacity: 0;
    animation-name: ${exitKeyframe$1};
    animation-duration: ${DURATION$1}ms;
    animation-timing-function: ${({
  theme: pt
}) => pt.transitions.easing.easeInOut};
  }

  & .${touchRippleClasses$1.childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${pulsateKeyframe$1};
    animation-duration: 2500ms;
    animation-timing-function: ${({
  theme: pt
}) => pt.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`, TouchRipple$1 = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const ir = useDefaultProps$2({
    props: pt,
    name: "MuiTouchRipple"
  }), {
    center: ti = !1,
    classes: ii = {},
    className: ui,
    ...ai
  } = ir, [li, oi] = React.useState([]), si = React.useRef(0), di = React.useRef(null);
  React.useEffect(() => {
    di.current && (di.current(), di.current = null);
  }, [li]);
  const fi = React.useRef(!1), gi = useTimeout$1(), mi = React.useRef(null), Ti = React.useRef(null), vi = React.useCallback(($i) => {
    const {
      pulsate: Oi,
      rippleX: Di,
      rippleY: Mi,
      rippleSize: Oo,
      cb: io
    } = $i;
    oi((xo) => [...xo, /* @__PURE__ */ jsxRuntimeExports.jsx(TouchRippleRipple$1, {
      classes: {
        ripple: clsx$1(ii.ripple, touchRippleClasses$1.ripple),
        rippleVisible: clsx$1(ii.rippleVisible, touchRippleClasses$1.rippleVisible),
        ripplePulsate: clsx$1(ii.ripplePulsate, touchRippleClasses$1.ripplePulsate),
        child: clsx$1(ii.child, touchRippleClasses$1.child),
        childLeaving: clsx$1(ii.childLeaving, touchRippleClasses$1.childLeaving),
        childPulsate: clsx$1(ii.childPulsate, touchRippleClasses$1.childPulsate)
      },
      timeout: DURATION$1,
      pulsate: Oi,
      rippleX: Di,
      rippleY: Mi,
      rippleSize: Oo
    }, si.current)]), si.current += 1, di.current = io;
  }, [ii]), xi = React.useCallback(($i = {}, Oi = {}, Di = () => {
  }) => {
    const {
      pulsate: Mi = !1,
      center: Oo = ti || Oi.pulsate,
      fakeElement: io = !1
      // For test purposes
    } = Oi;
    if (($i == null ? void 0 : $i.type) === "mousedown" && fi.current) {
      fi.current = !1;
      return;
    }
    ($i == null ? void 0 : $i.type) === "touchstart" && (fi.current = !0);
    const xo = io ? null : Ti.current, fo = xo ? xo.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let _o, Li, Co;
    if (Oo || $i === void 0 || $i.clientX === 0 && $i.clientY === 0 || !$i.clientX && !$i.touches)
      _o = Math.round(fo.width / 2), Li = Math.round(fo.height / 2);
    else {
      const {
        clientX: Ni,
        clientY: Yi
      } = $i.touches && $i.touches.length > 0 ? $i.touches[0] : $i;
      _o = Math.round(Ni - fo.left), Li = Math.round(Yi - fo.top);
    }
    if (Oo)
      Co = Math.sqrt((2 * fo.width ** 2 + fo.height ** 2) / 3), Co % 2 === 0 && (Co += 1);
    else {
      const Ni = Math.max(Math.abs((xo ? xo.clientWidth : 0) - _o), _o) * 2 + 2, Yi = Math.max(Math.abs((xo ? xo.clientHeight : 0) - Li), Li) * 2 + 2;
      Co = Math.sqrt(Ni ** 2 + Yi ** 2);
    }
    $i != null && $i.touches ? mi.current === null && (mi.current = () => {
      vi({
        pulsate: Mi,
        rippleX: _o,
        rippleY: Li,
        rippleSize: Co,
        cb: Di
      });
    }, gi.start(DELAY_RIPPLE$1, () => {
      mi.current && (mi.current(), mi.current = null);
    })) : vi({
      pulsate: Mi,
      rippleX: _o,
      rippleY: Li,
      rippleSize: Co,
      cb: Di
    });
  }, [ti, vi, gi]), Si = React.useCallback(() => {
    xi({}, {
      pulsate: !0
    });
  }, [xi]), Pi = React.useCallback(($i, Oi) => {
    if (gi.clear(), ($i == null ? void 0 : $i.type) === "touchend" && mi.current) {
      mi.current(), mi.current = null, gi.start(0, () => {
        Pi($i, Oi);
      });
      return;
    }
    mi.current = null, oi((Di) => Di.length > 0 ? Di.slice(1) : Di), di.current = Oi;
  }, [gi]);
  return React.useImperativeHandle(yt, () => ({
    pulsate: Si,
    start: xi,
    stop: Pi
  }), [Si, xi, Pi]), /* @__PURE__ */ jsxRuntimeExports.jsx(TouchRippleRoot$1, {
    className: clsx$1(touchRippleClasses$1.root, ii.root, ui),
    ref: Ti,
    ...ai,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(TransitionGroup$1, {
      component: null,
      exit: !0,
      children: li
    })
  });
});
process.env.NODE_ENV !== "production" && (TouchRipple$1.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string
});
function getButtonBaseUtilityClass$1(pt) {
  return generateUtilityClass$2("MuiButtonBase", pt);
}
const buttonBaseClasses$1 = generateUtilityClasses$2("MuiButtonBase", ["root", "disabled", "focusVisible"]), useUtilityClasses$v = (pt) => {
  const {
    disabled: yt,
    focusVisible: ir,
    focusVisibleClassName: ti,
    classes: ii
  } = pt, ui = composeClasses$2({
    root: ["root", yt && "disabled", ir && "focusVisible"]
  }, getButtonBaseUtilityClass$1, ii);
  return ir && ti && (ui.root += ` ${ti}`), ui;
}, ButtonBaseRoot$1 = styled$3("button", {
  name: "MuiButtonBase",
  slot: "Root"
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${buttonBaseClasses$1.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), ButtonBase$1 = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const ir = useDefaultProps$2({
    props: pt,
    name: "MuiButtonBase"
  }), {
    action: ti,
    centerRipple: ii = !1,
    children: ui,
    className: ai,
    component: li = "button",
    disabled: oi = !1,
    disableRipple: si = !1,
    disableTouchRipple: di = !1,
    focusRipple: fi = !1,
    focusVisibleClassName: gi,
    LinkComponent: mi = "a",
    onBlur: Ti,
    onClick: vi,
    onContextMenu: xi,
    onDragLeave: Si,
    onFocus: Pi,
    onFocusVisible: $i,
    onKeyDown: Oi,
    onKeyUp: Di,
    onMouseDown: Mi,
    onMouseLeave: Oo,
    onMouseUp: io,
    onTouchEnd: xo,
    onTouchMove: fo,
    onTouchStart: _o,
    tabIndex: Li = 0,
    TouchRippleProps: Co,
    touchRippleRef: Ni,
    type: Yi,
    ...Vo
  } = ir, No = React.useRef(null), Ui = useLazyRipple$1(), jo = useForkRef$2(Ui.ref, Ni), [Wi, ji] = React.useState(!1);
  oi && Wi && ji(!1), React.useImperativeHandle(ti, () => ({
    focusVisible: () => {
      ji(!0), No.current.focus();
    }
  }), []);
  const Hi = Ui.shouldMount && !si && !oi;
  React.useEffect(() => {
    Wi && fi && !si && Ui.pulsate();
  }, [si, fi, Wi, Ui]);
  const zo = useRippleHandler$1(Ui, "start", Mi, di), Lo = useRippleHandler$1(Ui, "stop", xi, di), sa = useRippleHandler$1(Ui, "stop", Si, di), Ko = useRippleHandler$1(Ui, "stop", io, di), ca = useRippleHandler$1(Ui, "stop", (Ja) => {
    Wi && Ja.preventDefault(), Oo && Oo(Ja);
  }, di), pa = useRippleHandler$1(Ui, "start", _o, di), ga = useRippleHandler$1(Ui, "stop", xo, di), ia = useRippleHandler$1(Ui, "stop", fo, di), ra = useRippleHandler$1(Ui, "stop", (Ja) => {
    isFocusVisible$2(Ja.target) || ji(!1), Ti && Ti(Ja);
  }, !1), qo = useEventCallback$2((Ja) => {
    No.current || (No.current = Ja.currentTarget), isFocusVisible$2(Ja.target) && (ji(!0), $i && $i(Ja)), Pi && Pi(Ja);
  }), xa = () => {
    const Ja = No.current;
    return li && li !== "button" && !(Ja.tagName === "A" && Ja.href);
  }, $a = useEventCallback$2((Ja) => {
    fi && !Ja.repeat && Wi && Ja.key === " " && Ui.stop(Ja, () => {
      Ui.start(Ja);
    }), Ja.target === Ja.currentTarget && xa() && Ja.key === " " && Ja.preventDefault(), Oi && Oi(Ja), Ja.target === Ja.currentTarget && xa() && Ja.key === "Enter" && !oi && (Ja.preventDefault(), vi && vi(Ja));
  }), ys = useEventCallback$2((Ja) => {
    fi && Ja.key === " " && Wi && !Ja.defaultPrevented && Ui.stop(Ja, () => {
      Ui.pulsate(Ja);
    }), Di && Di(Ja), vi && Ja.target === Ja.currentTarget && xa() && Ja.key === " " && !Ja.defaultPrevented && vi(Ja);
  });
  let Ss = li;
  Ss === "button" && (Vo.href || Vo.to) && (Ss = mi);
  const Xa = {};
  if (Ss === "button") {
    const Ja = !!Vo.formAction;
    Xa.type = Yi === void 0 && !Ja ? "button" : Yi, Xa.disabled = oi;
  } else
    !Vo.href && !Vo.to && (Xa.role = "button"), oi && (Xa["aria-disabled"] = oi);
  const Es = useForkRef$2(yt, No), Rs = {
    ...ir,
    centerRipple: ii,
    component: li,
    disabled: oi,
    disableRipple: si,
    disableTouchRipple: di,
    focusRipple: fi,
    tabIndex: Li,
    focusVisible: Wi
  }, La = useUtilityClasses$v(Rs);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ButtonBaseRoot$1, {
    as: Ss,
    className: clsx$1(La.root, ai),
    ownerState: Rs,
    onBlur: ra,
    onClick: vi,
    onContextMenu: Lo,
    onFocus: qo,
    onKeyDown: $a,
    onKeyUp: ys,
    onMouseDown: zo,
    onMouseLeave: ca,
    onMouseUp: Ko,
    onDragLeave: sa,
    onTouchEnd: ga,
    onTouchMove: ia,
    onTouchStart: pa,
    ref: Es,
    tabIndex: oi ? -1 : Li,
    type: Yi,
    ...Xa,
    ...Vo,
    children: [ui, Hi ? /* @__PURE__ */ jsxRuntimeExports.jsx(TouchRipple$1, {
      ref: jo,
      center: ii,
      ...Co
    }) : null]
  });
});
function useRippleHandler$1(pt, yt, ir, ti = !1) {
  return useEventCallback$2((ii) => (ir && ir(ii), ti || pt[yt](ii), !0));
}
process.env.NODE_ENV !== "production" && (ButtonBase$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: refType$2,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: PropTypes.bool,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef$1$1,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: PropTypes.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: PropTypes.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * @ignore
   */
  formAction: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  /**
   * @ignore
   */
  href: PropTypes.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: PropTypes.elementType,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * @ignore
   */
  onContextMenu: PropTypes.func,
  /**
   * @ignore
   */
  onDragLeave: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,
  /**
   * @ignore
   */
  onMouseDown: PropTypes.func,
  /**
   * @ignore
   */
  onMouseLeave: PropTypes.func,
  /**
   * @ignore
   */
  onMouseUp: PropTypes.func,
  /**
   * @ignore
   */
  onTouchEnd: PropTypes.func,
  /**
   * @ignore
   */
  onTouchMove: PropTypes.func,
  /**
   * @ignore
   */
  onTouchStart: PropTypes.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @default 0
   */
  tabIndex: PropTypes.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: PropTypes.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      pulsate: PropTypes.func.isRequired,
      start: PropTypes.func.isRequired,
      stop: PropTypes.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: PropTypes.oneOfType([PropTypes.oneOf(["button", "reset", "submit"]), PropTypes.string])
});
function getSwitchBaseUtilityClass(pt) {
  return generateUtilityClass$2("PrivateSwitchBase", pt);
}
generateUtilityClasses$2("PrivateSwitchBase", ["root", "checked", "disabled", "input", "edgeStart", "edgeEnd"]);
function isHostComponent$3(pt) {
  return typeof pt == "string";
}
function appendOwnerState$2(pt, yt, ir) {
  return pt === void 0 || isHostComponent$3(pt) ? yt : {
    ...yt,
    ownerState: {
      ...yt.ownerState,
      ...ir
    }
  };
}
function resolveComponentProps$2(pt, yt, ir) {
  return typeof pt == "function" ? pt(yt, ir) : pt;
}
function extractEventHandlers$2(pt, yt = []) {
  if (pt === void 0)
    return {};
  const ir = {};
  return Object.keys(pt).filter((ti) => ti.match(/^on[A-Z]/) && typeof pt[ti] == "function" && !yt.includes(ti)).forEach((ti) => {
    ir[ti] = pt[ti];
  }), ir;
}
function omitEventHandlers$2(pt) {
  if (pt === void 0)
    return {};
  const yt = {};
  return Object.keys(pt).filter((ir) => !(ir.match(/^on[A-Z]/) && typeof pt[ir] == "function")).forEach((ir) => {
    yt[ir] = pt[ir];
  }), yt;
}
function mergeSlotProps$1$1(pt) {
  const {
    getSlotProps: yt,
    additionalProps: ir,
    externalSlotProps: ti,
    externalForwardedProps: ii,
    className: ui
  } = pt;
  if (!yt) {
    const mi = clsx$1(ir == null ? void 0 : ir.className, ui, ii == null ? void 0 : ii.className, ti == null ? void 0 : ti.className), Ti = {
      ...ir == null ? void 0 : ir.style,
      ...ii == null ? void 0 : ii.style,
      ...ti == null ? void 0 : ti.style
    }, vi = {
      ...ir,
      ...ii,
      ...ti
    };
    return mi.length > 0 && (vi.className = mi), Object.keys(Ti).length > 0 && (vi.style = Ti), {
      props: vi,
      internalRef: void 0
    };
  }
  const ai = extractEventHandlers$2({
    ...ii,
    ...ti
  }), li = omitEventHandlers$2(ti), oi = omitEventHandlers$2(ii), si = yt(ai), di = clsx$1(si == null ? void 0 : si.className, ir == null ? void 0 : ir.className, ui, ii == null ? void 0 : ii.className, ti == null ? void 0 : ti.className), fi = {
    ...si == null ? void 0 : si.style,
    ...ir == null ? void 0 : ir.style,
    ...ii == null ? void 0 : ii.style,
    ...ti == null ? void 0 : ti.style
  }, gi = {
    ...si,
    ...ir,
    ...oi,
    ...li
  };
  return di.length > 0 && (gi.className = di), Object.keys(fi).length > 0 && (gi.style = fi), {
    props: gi,
    internalRef: si.ref
  };
}
function useSlot$1(pt, yt) {
  const {
    className: ir,
    elementType: ti,
    ownerState: ii,
    externalForwardedProps: ui,
    internalForwardedProps: ai,
    shouldForwardComponentProp: li = !1,
    ...oi
  } = yt, {
    component: si,
    slots: di = {
      [pt]: void 0
    },
    slotProps: fi = {
      [pt]: void 0
    },
    ...gi
  } = ui, mi = di[pt] || ti, Ti = resolveComponentProps$2(fi[pt], ii), {
    props: {
      component: vi,
      ...xi
    },
    internalRef: Si
  } = mergeSlotProps$1$1({
    className: ir,
    ...oi,
    externalForwardedProps: pt === "root" ? gi : void 0,
    externalSlotProps: Ti
  }), Pi = useForkRef$2(Si, Ti == null ? void 0 : Ti.ref, yt.ref), $i = pt === "root" ? vi || si : vi, Oi = appendOwnerState$2(mi, {
    ...pt === "root" && !si && !di[pt] && ai,
    ...pt !== "root" && !di[pt] && ai,
    ...xi,
    ...$i && !li && {
      as: $i
    },
    ...$i && li && {
      component: $i
    },
    ref: Pi
  }, ii);
  return [mi, Oi];
}
const useUtilityClasses$u = (pt) => {
  const {
    classes: yt,
    checked: ir,
    disabled: ti,
    edge: ii
  } = pt, ui = {
    root: ["root", ir && "checked", ti && "disabled", ii && `edge${capitalize$1(ii)}`],
    input: ["input"]
  };
  return composeClasses$2(ui, getSwitchBaseUtilityClass, yt);
}, SwitchBaseRoot = styled$3(ButtonBase$1, {
  name: "MuiSwitchBase"
})({
  padding: 9,
  borderRadius: "50%",
  variants: [{
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: ({
      edge: pt,
      ownerState: yt
    }) => pt === "start" && yt.size !== "small",
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }, {
    props: ({
      edge: pt,
      ownerState: yt
    }) => pt === "end" && yt.size !== "small",
    style: {
      marginRight: -12
    }
  }]
}), SwitchBaseInput = styled$3("input", {
  name: "MuiSwitchBase",
  shouldForwardProp: rootShouldForwardProp$1
})({
  cursor: "inherit",
  position: "absolute",
  opacity: 0,
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
}), SwitchBase = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const {
    autoFocus: ir,
    checked: ti,
    checkedIcon: ii,
    defaultChecked: ui,
    disabled: ai,
    disableFocusRipple: li = !1,
    edge: oi = !1,
    icon: si,
    id: di,
    inputProps: fi,
    inputRef: gi,
    name: mi,
    onBlur: Ti,
    onChange: vi,
    onFocus: xi,
    readOnly: Si,
    required: Pi = !1,
    tabIndex: $i,
    type: Oi,
    value: Di,
    slots: Mi = {},
    slotProps: Oo = {},
    ...io
  } = pt, [xo, fo] = useControlled$2({
    controlled: ti,
    default: !!ui,
    name: "SwitchBase",
    state: "checked"
  }), _o = useFormControl(), Li = (Lo) => {
    xi && xi(Lo), _o && _o.onFocus && _o.onFocus(Lo);
  }, Co = (Lo) => {
    Ti && Ti(Lo), _o && _o.onBlur && _o.onBlur(Lo);
  }, Ni = (Lo) => {
    if (Lo.nativeEvent.defaultPrevented || Si)
      return;
    const sa = Lo.target.checked;
    fo(sa), vi && vi(Lo, sa);
  };
  let Yi = ai;
  _o && typeof Yi > "u" && (Yi = _o.disabled);
  const Vo = Oi === "checkbox" || Oi === "radio", No = {
    ...pt,
    checked: xo,
    disabled: Yi,
    disableFocusRipple: li,
    edge: oi
  }, Ui = useUtilityClasses$u(No), jo = {
    slots: Mi,
    slotProps: {
      input: fi,
      ...Oo
    }
  }, [Wi, ji] = useSlot$1("root", {
    ref: yt,
    elementType: SwitchBaseRoot,
    className: Ui.root,
    shouldForwardComponentProp: !0,
    externalForwardedProps: {
      ...jo,
      component: "span",
      ...io
    },
    getSlotProps: (Lo) => ({
      ...Lo,
      onFocus: (sa) => {
        var Ko;
        (Ko = Lo.onFocus) == null || Ko.call(Lo, sa), Li(sa);
      },
      onBlur: (sa) => {
        var Ko;
        (Ko = Lo.onBlur) == null || Ko.call(Lo, sa), Co(sa);
      }
    }),
    ownerState: No,
    additionalProps: {
      centerRipple: !0,
      focusRipple: !li,
      role: void 0,
      tabIndex: null
    }
  }), [Hi, zo] = useSlot$1("input", {
    ref: gi,
    elementType: SwitchBaseInput,
    className: Ui.input,
    externalForwardedProps: jo,
    getSlotProps: (Lo) => ({
      ...Lo,
      onChange: (sa) => {
        var Ko;
        (Ko = Lo.onChange) == null || Ko.call(Lo, sa), Ni(sa);
      }
    }),
    ownerState: No,
    additionalProps: {
      autoFocus: ir,
      checked: ti,
      defaultChecked: ui,
      disabled: Yi,
      id: Vo ? di : void 0,
      name: mi,
      readOnly: Si,
      required: Pi,
      tabIndex: $i,
      type: Oi,
      ...Oi === "checkbox" && Di === void 0 ? {} : {
        value: Di
      }
    }
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Wi, {
    ...ji,
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(Hi, {
      ...zo
    }), xo ? ii : si]
  });
});
process.env.NODE_ENV !== "production" && (SwitchBase.propTypes = {
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * @ignore
   */
  defaultChecked: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: PropTypes.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: PropTypes.node.isRequired,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$2,
  /*
   * @ignore
   */
  name: PropTypes.string,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   */
  required: PropTypes.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.object,
  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The input component prop `type`.
   */
  type: PropTypes.string.isRequired,
  /**
   * The value of the component.
   */
  value: PropTypes.any
});
const memoTheme$1 = unstable_memoTheme$1;
function getSvgIconUtilityClass$1(pt) {
  return generateUtilityClass$2("MuiSvgIcon", pt);
}
generateUtilityClasses$2("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const useUtilityClasses$t = (pt) => {
  const {
    color: yt,
    fontSize: ir,
    classes: ti
  } = pt, ii = {
    root: ["root", yt !== "inherit" && `color${capitalize$1(yt)}`, `fontSize${capitalize$1(ir)}`]
  };
  return composeClasses$2(ii, getSvgIconUtilityClass$1, ti);
}, SvgIconRoot$1 = styled$3("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (pt, yt) => {
    const {
      ownerState: ir
    } = pt;
    return [yt.root, ir.color !== "inherit" && yt[`color${capitalize$1(ir.color)}`], yt[`fontSize${capitalize$1(ir.fontSize)}`]];
  }
})(memoTheme$1(({
  theme: pt
}) => {
  var yt, ir, ti, ii, ui, ai, li, oi, si, di, fi, gi, mi, Ti;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    flexShrink: 0,
    transition: (ii = (yt = pt.transitions) == null ? void 0 : yt.create) == null ? void 0 : ii.call(yt, "fill", {
      duration: (ti = (ir = (pt.vars ?? pt).transitions) == null ? void 0 : ir.duration) == null ? void 0 : ti.shorter
    }),
    variants: [
      {
        props: (vi) => !vi.hasSvgAsChild,
        style: {
          // the <svg> will define the property that has `currentColor`
          // for example heroicons uses fill="none" and stroke="currentColor"
          fill: "currentColor"
        }
      },
      {
        props: {
          fontSize: "inherit"
        },
        style: {
          fontSize: "inherit"
        }
      },
      {
        props: {
          fontSize: "small"
        },
        style: {
          fontSize: ((ai = (ui = pt.typography) == null ? void 0 : ui.pxToRem) == null ? void 0 : ai.call(ui, 20)) || "1.25rem"
        }
      },
      {
        props: {
          fontSize: "medium"
        },
        style: {
          fontSize: ((oi = (li = pt.typography) == null ? void 0 : li.pxToRem) == null ? void 0 : oi.call(li, 24)) || "1.5rem"
        }
      },
      {
        props: {
          fontSize: "large"
        },
        style: {
          fontSize: ((di = (si = pt.typography) == null ? void 0 : si.pxToRem) == null ? void 0 : di.call(si, 35)) || "2.1875rem"
        }
      },
      // TODO v5 deprecate color prop, v6 remove for sx
      ...Object.entries((pt.vars ?? pt).palette).filter(([, vi]) => vi && vi.main).map(([vi]) => {
        var xi, Si;
        return {
          props: {
            color: vi
          },
          style: {
            color: (Si = (xi = (pt.vars ?? pt).palette) == null ? void 0 : xi[vi]) == null ? void 0 : Si.main
          }
        };
      }),
      {
        props: {
          color: "action"
        },
        style: {
          color: (gi = (fi = (pt.vars ?? pt).palette) == null ? void 0 : fi.action) == null ? void 0 : gi.active
        }
      },
      {
        props: {
          color: "disabled"
        },
        style: {
          color: (Ti = (mi = (pt.vars ?? pt).palette) == null ? void 0 : mi.action) == null ? void 0 : Ti.disabled
        }
      },
      {
        props: {
          color: "inherit"
        },
        style: {
          color: void 0
        }
      }
    ]
  };
})), SvgIcon$1 = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const ir = useDefaultProps$2({
    props: pt,
    name: "MuiSvgIcon"
  }), {
    children: ti,
    className: ii,
    color: ui = "inherit",
    component: ai = "svg",
    fontSize: li = "medium",
    htmlColor: oi,
    inheritViewBox: si = !1,
    titleAccess: di,
    viewBox: fi = "0 0 24 24",
    ...gi
  } = ir, mi = /* @__PURE__ */ React.isValidElement(ti) && ti.type === "svg", Ti = {
    ...ir,
    color: ui,
    component: ai,
    fontSize: li,
    instanceFontSize: pt.fontSize,
    inheritViewBox: si,
    viewBox: fi,
    hasSvgAsChild: mi
  }, vi = {};
  si || (vi.viewBox = fi);
  const xi = useUtilityClasses$t(Ti);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(SvgIconRoot$1, {
    as: ai,
    className: clsx$1(xi.root, ii),
    focusable: "false",
    color: oi,
    "aria-hidden": di ? void 0 : !0,
    role: di ? "img" : void 0,
    ref: yt,
    ...vi,
    ...gi,
    ...mi && ti.props,
    ownerState: Ti,
    children: [mi ? ti.props.children : ti, di ? /* @__PURE__ */ jsxRuntimeExports.jsx("title", {
      children: di
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (SvgIcon$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "large", "medium", "small"]), PropTypes.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: PropTypes.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: PropTypes.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Reference/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: PropTypes.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: PropTypes.string
});
SvgIcon$1.muiName = "SvgIcon";
function createSvgIcon$1(pt, yt) {
  function ir(ti, ii) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(SvgIcon$1, {
      "data-testid": process.env.NODE_ENV !== "production" ? `${yt}Icon` : void 0,
      ref: ii,
      ...ti,
      children: pt
    });
  }
  return process.env.NODE_ENV !== "production" && (ir.displayName = `${yt}Icon`), ir.muiName = SvgIcon$1.muiName, /* @__PURE__ */ React.memo(/* @__PURE__ */ React.forwardRef(ir));
}
const CheckBoxOutlineBlankIcon = createSvgIcon$1(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank"), CheckBoxIcon = createSvgIcon$1(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox"), IndeterminateCheckBoxIcon = createSvgIcon$1(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");
function getCheckboxUtilityClass(pt) {
  return generateUtilityClass$2("MuiCheckbox", pt);
}
const checkboxClasses = generateUtilityClasses$2("MuiCheckbox", ["root", "checked", "disabled", "indeterminate", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium"]);
function hasCorrectMainProperty$1(pt) {
  return typeof pt.main == "string";
}
function checkSimplePaletteColorValues$1(pt, yt = []) {
  if (!hasCorrectMainProperty$1(pt))
    return !1;
  for (const ir of yt)
    if (!pt.hasOwnProperty(ir) || typeof pt[ir] != "string")
      return !1;
  return !0;
}
function createSimplePaletteValueFilter$1(pt = []) {
  return ([, yt]) => yt && checkSimplePaletteColorValues$1(yt, pt);
}
function createChainedFunction$2(...pt) {
  return pt.reduce((yt, ir) => ir == null ? yt : function(...ti) {
    yt.apply(this, ti), ir.apply(this, ti);
  }, () => {
  });
}
function debounce$2(pt, yt = 166) {
  let ir;
  function ti(...ii) {
    const ui = () => {
      pt.apply(this, ii);
    };
    clearTimeout(ir), ir = setTimeout(ui, yt);
  }
  return ti.clear = () => {
    clearTimeout(ir);
  }, ti;
}
function ownerDocument$2(pt) {
  return pt && pt.ownerDocument || document;
}
function ownerWindow$2(pt) {
  return ownerDocument$2(pt).defaultView || window;
}
function setRef$2(pt, yt) {
  typeof pt == "function" ? pt(yt) : pt && (pt.current = yt);
}
function isEventHandler$1(pt, yt) {
  const ir = pt.charCodeAt(2);
  return pt[0] === "o" && pt[1] === "n" && ir >= 65 && ir <= 90 && typeof yt == "function";
}
function mergeSlotProps$3(pt, yt) {
  if (!pt)
    return yt;
  function ir(ai, li) {
    const oi = {};
    return Object.keys(li).forEach((si) => {
      isEventHandler$1(si, li[si]) && typeof ai[si] == "function" && (oi[si] = (...di) => {
        ai[si](...di), li[si](...di);
      });
    }), oi;
  }
  if (typeof pt == "function" || typeof yt == "function")
    return (ai) => {
      const li = typeof yt == "function" ? yt(ai) : yt, oi = typeof pt == "function" ? pt({
        ...ai,
        ...li
      }) : pt, si = clsx$1(ai == null ? void 0 : ai.className, li == null ? void 0 : li.className, oi == null ? void 0 : oi.className), di = ir(oi, li);
      return {
        ...li,
        ...oi,
        ...di,
        ...!!si && {
          className: si
        },
        ...(li == null ? void 0 : li.style) && (oi == null ? void 0 : oi.style) && {
          style: {
            ...li.style,
            ...oi.style
          }
        },
        ...(li == null ? void 0 : li.sx) && (oi == null ? void 0 : oi.sx) && {
          sx: [...Array.isArray(li.sx) ? li.sx : [li.sx], ...Array.isArray(oi.sx) ? oi.sx : [oi.sx]]
        }
      };
    };
  const ti = yt, ii = ir(pt, ti), ui = clsx$1(ti == null ? void 0 : ti.className, pt == null ? void 0 : pt.className);
  return {
    ...yt,
    ...pt,
    ...ii,
    ...!!ui && {
      className: ui
    },
    ...(ti == null ? void 0 : ti.style) && (pt == null ? void 0 : pt.style) && {
      style: {
        ...ti.style,
        ...pt.style
      }
    },
    ...(ti == null ? void 0 : ti.sx) && (pt == null ? void 0 : pt.sx) && {
      sx: [...Array.isArray(ti.sx) ? ti.sx : [ti.sx], ...Array.isArray(pt.sx) ? pt.sx : [pt.sx]]
    }
  };
}
const useUtilityClasses$s = (pt) => {
  const {
    classes: yt,
    indeterminate: ir,
    color: ti,
    size: ii
  } = pt, ui = {
    root: ["root", ir && "indeterminate", `color${capitalize$1(ti)}`, `size${capitalize$1(ii)}`]
  }, ai = composeClasses$2(ui, getCheckboxUtilityClass, yt);
  return {
    ...yt,
    // forward the disabled and checked classes to the SwitchBase
    ...ai
  };
}, CheckboxRoot = styled$3(SwitchBase, {
  shouldForwardProp: (pt) => rootShouldForwardProp$1(pt) || pt === "classes",
  name: "MuiCheckbox",
  slot: "Root",
  overridesResolver: (pt, yt) => {
    const {
      ownerState: ir
    } = pt;
    return [yt.root, ir.indeterminate && yt.indeterminate, yt[`size${capitalize$1(ir.size)}`], ir.color !== "default" && yt[`color${capitalize$1(ir.color)}`]];
  }
})(memoTheme$1(({
  theme: pt
}) => ({
  color: (pt.vars || pt).palette.text.secondary,
  variants: [{
    props: {
      color: "default",
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: pt.alpha((pt.vars || pt).palette.action.active, (pt.vars || pt).palette.action.hoverOpacity)
      }
    }
  }, ...Object.entries(pt.palette).filter(createSimplePaletteValueFilter$1()).map(([yt]) => ({
    props: {
      color: yt,
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: pt.alpha((pt.vars || pt).palette[yt].main, (pt.vars || pt).palette.action.hoverOpacity)
      }
    }
  })), ...Object.entries(pt.palette).filter(createSimplePaletteValueFilter$1()).map(([yt]) => ({
    props: {
      color: yt
    },
    style: {
      [`&.${checkboxClasses.checked}, &.${checkboxClasses.indeterminate}`]: {
        color: (pt.vars || pt).palette[yt].main
      },
      [`&.${checkboxClasses.disabled}`]: {
        color: (pt.vars || pt).palette.action.disabled
      }
    }
  })), {
    // Should be last to override other colors
    props: {
      disableRipple: !1
    },
    style: {
      // Reset on touch devices, it doesn't add specificity
      "&:hover": {
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }]
}))), defaultCheckedIcon = /* @__PURE__ */ jsxRuntimeExports.jsx(CheckBoxIcon, {}), defaultIcon = /* @__PURE__ */ jsxRuntimeExports.jsx(CheckBoxOutlineBlankIcon, {}), defaultIndeterminateIcon = /* @__PURE__ */ jsxRuntimeExports.jsx(IndeterminateCheckBoxIcon, {}), Checkbox$1 = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const ir = useDefaultProps$2({
    props: pt,
    name: "MuiCheckbox"
  }), {
    checkedIcon: ti = defaultCheckedIcon,
    color: ii = "primary",
    icon: ui = defaultIcon,
    indeterminate: ai = !1,
    indeterminateIcon: li = defaultIndeterminateIcon,
    inputProps: oi,
    size: si = "medium",
    disableRipple: di = !1,
    className: fi,
    slots: gi = {},
    slotProps: mi = {},
    ...Ti
  } = ir, vi = ai ? li : ui, xi = ai ? li : ti, Si = {
    ...ir,
    disableRipple: di,
    color: ii,
    indeterminate: ai,
    size: si
  }, Pi = useUtilityClasses$s(Si), $i = mi.input ?? oi, [Oi, Di] = useSlot$1("root", {
    ref: yt,
    elementType: CheckboxRoot,
    className: clsx$1(Pi.root, fi),
    shouldForwardComponentProp: !0,
    externalForwardedProps: {
      slots: gi,
      slotProps: mi,
      ...Ti
    },
    ownerState: Si,
    additionalProps: {
      type: "checkbox",
      icon: /* @__PURE__ */ React.cloneElement(vi, {
        fontSize: vi.props.fontSize ?? si
      }),
      checkedIcon: /* @__PURE__ */ React.cloneElement(xi, {
        fontSize: xi.props.fontSize ?? si
      }),
      disableRipple: di,
      slots: gi,
      slotProps: {
        input: mergeSlotProps$3(typeof $i == "function" ? $i(Si) : $i, {
          "data-indeterminate": ai
        })
      }
    }
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Oi, {
    ...Di,
    classes: Pi
  });
});
process.env.NODE_ENV !== "production" && (Checkbox$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,
  /**
   * The icon to display when the component is checked.
   * @default <CheckBoxIcon />
   */
  checkedIcon: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <CheckBoxOutlineBlankIcon />
   */
  icon: PropTypes.node,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the `input`.
   * @default false
   */
  indeterminate: PropTypes.bool,
  /**
   * The icon to display when the component is indeterminate.
   * @default <IndeterminateCheckBoxIcon />
   */
  indeterminateIcon: PropTypes.node,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputProps: PropTypes.object,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense checkbox styling.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: PropTypes.any
});
function hasValue(pt) {
  return pt != null && !(Array.isArray(pt) && pt.length === 0);
}
function isFilled(pt, yt = !1) {
  return pt && (hasValue(pt.value) && pt.value !== "" || yt && hasValue(pt.defaultValue) && pt.defaultValue !== "");
}
function getTypographyUtilityClass(pt) {
  return generateUtilityClass$2("MuiTypography", pt);
}
generateUtilityClasses$2("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]);
const v6Colors = {
  primary: !0,
  secondary: !0,
  error: !0,
  info: !0,
  success: !0,
  warning: !0,
  textPrimary: !0,
  textSecondary: !0,
  textDisabled: !0
}, extendSxProp = internal_createExtendSxProp(), useUtilityClasses$r = (pt) => {
  const {
    align: yt,
    gutterBottom: ir,
    noWrap: ti,
    paragraph: ii,
    variant: ui,
    classes: ai
  } = pt, li = {
    root: ["root", ui, pt.align !== "inherit" && `align${capitalize$1(yt)}`, ir && "gutterBottom", ti && "noWrap", ii && "paragraph"]
  };
  return composeClasses$2(li, getTypographyUtilityClass, ai);
}, TypographyRoot = styled$3("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (pt, yt) => {
    const {
      ownerState: ir
    } = pt;
    return [yt.root, ir.variant && yt[ir.variant], ir.align !== "inherit" && yt[`align${capitalize$1(ir.align)}`], ir.noWrap && yt.noWrap, ir.gutterBottom && yt.gutterBottom, ir.paragraph && yt.paragraph];
  }
})(memoTheme$1(({
  theme: pt
}) => {
  var yt;
  return {
    margin: 0,
    variants: [{
      props: {
        variant: "inherit"
      },
      style: {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: "inherit",
        lineHeight: "inherit",
        letterSpacing: "inherit"
      }
    }, ...Object.entries(pt.typography).filter(([ir, ti]) => ir !== "inherit" && ti && typeof ti == "object").map(([ir, ti]) => ({
      props: {
        variant: ir
      },
      style: ti
    })), ...Object.entries(pt.palette).filter(createSimplePaletteValueFilter$1()).map(([ir]) => ({
      props: {
        color: ir
      },
      style: {
        color: (pt.vars || pt).palette[ir].main
      }
    })), ...Object.entries(((yt = pt.palette) == null ? void 0 : yt.text) || {}).filter(([, ir]) => typeof ir == "string").map(([ir]) => ({
      props: {
        color: `text${capitalize$1(ir)}`
      },
      style: {
        color: (pt.vars || pt).palette.text[ir]
      }
    })), {
      props: ({
        ownerState: ir
      }) => ir.align !== "inherit",
      style: {
        textAlign: "var(--Typography-textAlign)"
      }
    }, {
      props: ({
        ownerState: ir
      }) => ir.noWrap,
      style: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }
    }, {
      props: ({
        ownerState: ir
      }) => ir.gutterBottom,
      style: {
        marginBottom: "0.35em"
      }
    }, {
      props: ({
        ownerState: ir
      }) => ir.paragraph,
      style: {
        marginBottom: 16
      }
    }]
  };
})), defaultVariantMapping = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, Typography = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const {
    color: ir,
    ...ti
  } = useDefaultProps$2({
    props: pt,
    name: "MuiTypography"
  }), ii = !v6Colors[ir], ui = extendSxProp({
    ...ti,
    ...ii && {
      color: ir
    }
  }), {
    align: ai = "inherit",
    className: li,
    component: oi,
    gutterBottom: si = !1,
    noWrap: di = !1,
    paragraph: fi = !1,
    variant: gi = "body1",
    variantMapping: mi = defaultVariantMapping,
    ...Ti
  } = ui, vi = {
    ...ui,
    align: ai,
    color: ir,
    className: li,
    component: oi,
    gutterBottom: si,
    noWrap: di,
    paragraph: fi,
    variant: gi,
    variantMapping: mi
  }, xi = oi || (fi ? "p" : mi[gi] || defaultVariantMapping[gi]) || "span", Si = useUtilityClasses$r(vi);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TypographyRoot, {
    as: xi,
    ref: yt,
    className: clsx$1(Si.root, li),
    ...Ti,
    ownerState: vi,
    style: {
      ...ai !== "inherit" && {
        "--Typography-textAlign": ai
      },
      ...Ti.style
    }
  });
});
process.env.NODE_ENV !== "production" && (Typography.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: PropTypes.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary", "success", "error", "info", "warning", "textPrimary", "textSecondary", "textDisabled"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: PropTypes.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: PropTypes.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   * @deprecated Use the `component` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  paragraph: PropTypes.bool,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), PropTypes.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: PropTypes.object
});
function getFormControlLabelUtilityClasses(pt) {
  return generateUtilityClass$2("MuiFormControlLabel", pt);
}
const formControlLabelClasses = generateUtilityClasses$2("MuiFormControlLabel", ["root", "labelPlacementStart", "labelPlacementTop", "labelPlacementBottom", "disabled", "label", "error", "required", "asterisk"]);
function formControlState({
  props: pt,
  states: yt,
  muiFormControl: ir
}) {
  return yt.reduce((ti, ii) => (ti[ii] = pt[ii], ir && typeof pt[ii] > "u" && (ti[ii] = ir[ii]), ti), {});
}
const useUtilityClasses$q = (pt) => {
  const {
    classes: yt,
    disabled: ir,
    labelPlacement: ti,
    error: ii,
    required: ui
  } = pt, ai = {
    root: ["root", ir && "disabled", `labelPlacement${capitalize$1(ti)}`, ii && "error", ui && "required"],
    label: ["label", ir && "disabled"],
    asterisk: ["asterisk", ii && "error"]
  };
  return composeClasses$2(ai, getFormControlLabelUtilityClasses, yt);
}, FormControlLabelRoot = styled$3("label", {
  name: "MuiFormControlLabel",
  slot: "Root",
  overridesResolver: (pt, yt) => {
    const {
      ownerState: ir
    } = pt;
    return [{
      [`& .${formControlLabelClasses.label}`]: yt.label
    }, yt.root, yt[`labelPlacement${capitalize$1(ir.labelPlacement)}`]];
  }
})(memoTheme$1(({
  theme: pt
}) => ({
  display: "inline-flex",
  alignItems: "center",
  cursor: "pointer",
  // For correct alignment with the text.
  verticalAlign: "middle",
  WebkitTapHighlightColor: "transparent",
  marginLeft: -11,
  marginRight: 16,
  // used for row presentation of radio/checkbox
  [`&.${formControlLabelClasses.disabled}`]: {
    cursor: "default"
  },
  [`& .${formControlLabelClasses.label}`]: {
    [`&.${formControlLabelClasses.disabled}`]: {
      color: (pt.vars || pt).palette.text.disabled
    }
  },
  variants: [{
    props: {
      labelPlacement: "start"
    },
    style: {
      flexDirection: "row-reverse",
      marginRight: -11
    }
  }, {
    props: {
      labelPlacement: "top"
    },
    style: {
      flexDirection: "column-reverse"
    }
  }, {
    props: {
      labelPlacement: "bottom"
    },
    style: {
      flexDirection: "column"
    }
  }, {
    props: ({
      labelPlacement: yt
    }) => yt === "start" || yt === "top" || yt === "bottom",
    style: {
      marginLeft: 16
      // used for row presentation of radio/checkbox
    }
  }]
}))), AsteriskComponent = styled$3("span", {
  name: "MuiFormControlLabel",
  slot: "Asterisk"
})(memoTheme$1(({
  theme: pt
}) => ({
  [`&.${formControlLabelClasses.error}`]: {
    color: (pt.vars || pt).palette.error.main
  }
}))), FormControlLabel = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const ir = useDefaultProps$2({
    props: pt,
    name: "MuiFormControlLabel"
  }), {
    checked: ti,
    className: ii,
    componentsProps: ui = {},
    control: ai,
    disabled: li,
    disableTypography: oi,
    inputRef: si,
    label: di,
    labelPlacement: fi = "end",
    name: gi,
    onChange: mi,
    required: Ti,
    slots: vi = {},
    slotProps: xi = {},
    value: Si,
    ...Pi
  } = ir, $i = useFormControl(), Oi = li ?? ai.props.disabled ?? ($i == null ? void 0 : $i.disabled), Di = Ti ?? ai.props.required, Mi = {
    disabled: Oi,
    required: Di
  };
  ["checked", "name", "onChange", "value", "inputRef"].forEach((Ni) => {
    typeof ai.props[Ni] > "u" && typeof ir[Ni] < "u" && (Mi[Ni] = ir[Ni]);
  });
  const Oo = formControlState({
    props: ir,
    muiFormControl: $i,
    states: ["error"]
  }), io = {
    ...ir,
    disabled: Oi,
    labelPlacement: fi,
    required: Di,
    error: Oo.error
  }, xo = useUtilityClasses$q(io), fo = {
    slots: vi,
    slotProps: {
      ...ui,
      ...xi
    }
  }, [_o, Li] = useSlot$1("typography", {
    elementType: Typography,
    externalForwardedProps: fo,
    ownerState: io
  });
  let Co = di;
  return Co != null && Co.type !== Typography && !oi && (Co = /* @__PURE__ */ jsxRuntimeExports.jsx(_o, {
    component: "span",
    ...Li,
    className: clsx$1(xo.label, Li == null ? void 0 : Li.className),
    children: Co
  })), /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControlLabelRoot, {
    className: clsx$1(xo.root, ii),
    ownerState: io,
    ref: yt,
    ...Pi,
    children: [/* @__PURE__ */ React.cloneElement(ai, Mi), Di ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
      children: [Co, /* @__PURE__ */ jsxRuntimeExports.jsxs(AsteriskComponent, {
        ownerState: io,
        "aria-hidden": !0,
        className: xo.asterisk,
        children: [" ", "*"]
      })]
    }) : Co]
  });
});
process.env.NODE_ENV !== "production" && (FormControlLabel.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component appears selected.
   */
  checked: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The props used for each slot inside.
   * @default {}
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  componentsProps: PropTypes.shape({
    typography: PropTypes.object
  }),
  /**
   * A control element. For instance, it can be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: PropTypes.element.isRequired,
  /**
   * If `true`, the control is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is rendered as it is passed without an additional typography node.
   */
  disableTypography: PropTypes.bool,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$2,
  /**
   * A text or an element to be used in an enclosing label element.
   */
  label: PropTypes.node,
  /**
   * The position of the label.
   * @default 'end'
   */
  labelPlacement: PropTypes.oneOf(["bottom", "end", "start", "top"]),
  /**
   * @ignore
   */
  name: PropTypes.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: PropTypes.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    typography: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    typography: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The value of the component.
   */
  value: PropTypes.any
});
const Checkbox = (pt) => {
  const {
    checked: yt,
    handleChange: ir,
    label: ti,
    // not currently being used, but will need to be updated in the future
    labelColor: ii = "var(--vp-skyline-blue)",
    labelPlacement: ui = "start",
    title: ai,
    id: li,
    ...oi
  } = pt, si = useId$3(), di = li || `checkbox-${si}`, fi = useRef(null);
  useEffect(() => {
    if (fi.current) {
      const mi = fi.current.querySelector('input[type="checkbox"]');
      mi && (yt ? mi.setAttribute("checked", "checked") : mi.removeAttribute("checked"));
    }
  }, [yt]);
  const gi = (mi) => {
    mi.key === "Enter" && (mi.preventDefault(), ir && ir({
      target: {
        checked: !yt
      }
    }));
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("alc-checkbox", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    FormControlLabel,
    {
      label: ti,
      labelPlacement: ui,
      style: {
        color: ii
      },
      htmlFor: di,
      control: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Checkbox$1,
        {
          id: di,
          checked: yt,
          "aria-checked": yt,
          onChange: ir,
          onKeyDown: gi,
          title: ai,
          slotProps: {
            // aria-label & checked status are needed for WCAG compatibility (1.3.1 & 4.1.2)
            input: {
              "aria-label": ti ? void 0 : ai || "Checkbox"
            }
          },
          ...oi,
          "data-testid": "checkbox"
        }
      )
    }
  ) });
};
Checkbox.propTypes = {
  /**
  * Tracks checked state of the checkbox
  */
  checked: PropTypes.bool,
  /**
  * Callback function when state of toggle changes
  */
  handleChange: PropTypes.func,
  /**
   * Unique identifier used for accessibility
   */
  id: PropTypes.string,
  /**
  * Rendered label for the checkbox
  */
  label: PropTypes.string,
  /**
  * Color of the label
  */
  labelColor: PropTypes.string,
  /**
  * Positioning of label
  */
  labelPlacement: PropTypes.oneOf([
    "top",
    "start",
    "bottom",
    "end"
  ]),
  /**
  * HTML Title attribute creates an info icon and tooltip
  * Not being used at the moment, will need to update the svg to
  * be thicker when the title is used.
  */
  title: PropTypes.string
};
PropTypes.string, PropTypes.bool, PropTypes.shape({
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  useWarning: PropTypes.bool,
  warningMessage: PropTypes.string,
  errorMessage: PropTypes.string,
  endAdornment: PropTypes.node
}), PropTypes.string, PropTypes.string, PropTypes.oneOfType([PropTypes.string, PropTypes.number]), PropTypes.string, PropTypes.node, PropTypes.bool, PropTypes.func, PropTypes.func, PropTypes.string, PropTypes.bool, PropTypes.oneOf([
  "email",
  "number",
  "tel",
  "text",
  "time",
  "url",
  "password",
  "hidden",
  "file"
]), PropTypes.bool, PropTypes.string, PropTypes.string, PropTypes.bool, PropTypes.string, PropTypes.bool, PropTypes.func, PropTypes.string;
const Title = (pt) => {
  const {
    title: yt,
    backgroundColor: ir = "var(--vp-dark-blue)",
    textColor: ti = "var(--vp-white)",
    children: ii,
    level: ui = 2,
    // Default to h2
    ...ai
  } = pt, li = `h${ui}`;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("alc-title", { style: {
    backgroundColor: ir,
    color: ti
  }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(li, { ...ai, children: yt }),
    ii
  ] });
};
Title.propTypes = {
  /**
   * The background color of the title container.
   */
  backgroundColor: PropTypes.string,
  /**
   * The slot content of title container.
   */
  children: PropTypes.node,
  /**
   * The heading level of the title (h1-h6).
   */
  level: PropTypes.oneOf([
    1,
    2,
    3,
    4,
    5,
    6
  ]),
  /**
   * The text color of the title.
   */
  textColor: PropTypes.string,
  /**
   * The text content of the title.
   */
  title: PropTypes.string.isRequired
};
var __assign = function() {
  return __assign = Object.assign || function(pt) {
    for (var yt, ir = 1, ti = arguments.length; ir < ti; ir++) {
      yt = arguments[ir];
      for (var ii in yt) Object.prototype.hasOwnProperty.call(yt, ii) && (pt[ii] = yt[ii]);
    }
    return pt;
  }, __assign.apply(this, arguments);
};
function __spreadArray(pt, yt, ir) {
  if (ir || arguments.length === 2) for (var ti = 0, ii = yt.length, ui; ti < ii; ti++)
    (ui || !(ti in yt)) && (ui || (ui = Array.prototype.slice.call(yt, 0, ti)), ui[ti] = yt[ti]);
  return pt.concat(ui || Array.prototype.slice.call(yt));
}
var reactPropsRegex$2 = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, isPropValid$2 = /* @__PURE__ */ memoize$2(
  function(pt) {
    return reactPropsRegex$2.test(pt) || pt.charCodeAt(0) === 111 && pt.charCodeAt(1) === 110 && pt.charCodeAt(2) < 91;
  }
  /* Z+1 */
), MS$2 = "-ms-", MOZ$2 = "-moz-", WEBKIT$2 = "-webkit-", COMMENT$2 = "comm", RULESET$2 = "rule", DECLARATION$2 = "decl", IMPORT$2 = "@import", NAMESPACE = "@namespace", KEYFRAMES$2 = "@keyframes", LAYER$2 = "@layer", abs$2 = Math.abs, from$1 = String.fromCharCode, assign$1 = Object.assign;
function hash$2(pt, yt) {
  return charat$2(pt, 0) ^ 45 ? (((yt << 2 ^ charat$2(pt, 0)) << 2 ^ charat$2(pt, 1)) << 2 ^ charat$2(pt, 2)) << 2 ^ charat$2(pt, 3) : 0;
}
function trim$2(pt) {
  return pt.trim();
}
function match$2(pt, yt) {
  return (pt = yt.exec(pt)) ? pt[0] : pt;
}
function replace$2(pt, yt, ir) {
  return pt.replace(yt, ir);
}
function indexof$2(pt, yt, ir) {
  return pt.indexOf(yt, ir);
}
function charat$2(pt, yt) {
  return pt.charCodeAt(yt) | 0;
}
function substr$2(pt, yt, ir) {
  return pt.slice(yt, ir);
}
function strlen$2(pt) {
  return pt.length;
}
function sizeof$2(pt) {
  return pt.length;
}
function append$1(pt, yt) {
  return yt.push(pt), pt;
}
function combine$2(pt, yt) {
  return pt.map(yt).join("");
}
function filter(pt, yt) {
  return pt.filter(function(ir) {
    return !match$2(ir, yt);
  });
}
var line$2 = 1, column$2 = 1, length$2 = 0, position$2 = 0, character$2 = 0, characters$2 = "";
function node$2(pt, yt, ir, ti, ii, ui, ai, li) {
  return { value: pt, root: yt, parent: ir, type: ti, props: ii, children: ui, line: line$2, column: column$2, length: ai, return: "", siblings: li };
}
function copy$2(pt, yt) {
  return assign$1(node$2("", null, null, "", null, null, 0, pt.siblings), pt, { length: -pt.length }, yt);
}
function lift(pt) {
  for (; pt.root; )
    pt = copy$2(pt.root, { children: [pt] });
  append$1(pt, pt.siblings);
}
function char$2() {
  return character$2;
}
function prev$2() {
  return character$2 = position$2 > 0 ? charat$2(characters$2, --position$2) : 0, column$2--, character$2 === 10 && (column$2 = 1, line$2--), character$2;
}
function next$2() {
  return character$2 = position$2 < length$2 ? charat$2(characters$2, position$2++) : 0, column$2++, character$2 === 10 && (column$2 = 1, line$2++), character$2;
}
function peek$2() {
  return charat$2(characters$2, position$2);
}
function caret$2() {
  return position$2;
}
function slice$2(pt, yt) {
  return substr$2(characters$2, pt, yt);
}
function token$2(pt) {
  switch (pt) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc$2(pt) {
  return line$2 = column$2 = 1, length$2 = strlen$2(characters$2 = pt), position$2 = 0, [];
}
function dealloc$2(pt) {
  return characters$2 = "", pt;
}
function delimit$2(pt) {
  return trim$2(slice$2(position$2 - 1, delimiter$2(pt === 91 ? pt + 2 : pt === 40 ? pt + 1 : pt)));
}
function whitespace$2(pt) {
  for (; (character$2 = peek$2()) && character$2 < 33; )
    next$2();
  return token$2(pt) > 2 || token$2(character$2) > 3 ? "" : " ";
}
function escaping$2(pt, yt) {
  for (; --yt && next$2() && !(character$2 < 48 || character$2 > 102 || character$2 > 57 && character$2 < 65 || character$2 > 70 && character$2 < 97); )
    ;
  return slice$2(pt, caret$2() + (yt < 6 && peek$2() == 32 && next$2() == 32));
}
function delimiter$2(pt) {
  for (; next$2(); )
    switch (character$2) {
      // ] ) " '
      case pt:
        return position$2;
      // " '
      case 34:
      case 39:
        pt !== 34 && pt !== 39 && delimiter$2(character$2);
        break;
      // (
      case 40:
        pt === 41 && delimiter$2(pt);
        break;
      // \
      case 92:
        next$2();
        break;
    }
  return position$2;
}
function commenter$2(pt, yt) {
  for (; next$2() && pt + character$2 !== 57 && !(pt + character$2 === 84 && peek$2() === 47); )
    ;
  return "/*" + slice$2(yt, position$2 - 1) + "*" + from$1(pt === 47 ? pt : next$2());
}
function identifier$2(pt) {
  for (; !token$2(peek$2()); )
    next$2();
  return slice$2(pt, position$2);
}
function compile$2(pt) {
  return dealloc$2(parse$2("", null, null, null, [""], pt = alloc$2(pt), 0, [0], pt));
}
function parse$2(pt, yt, ir, ti, ii, ui, ai, li, oi) {
  for (var si = 0, di = 0, fi = ai, gi = 0, mi = 0, Ti = 0, vi = 1, xi = 1, Si = 1, Pi = 0, $i = "", Oi = ii, Di = ui, Mi = ti, Oo = $i; xi; )
    switch (Ti = Pi, Pi = next$2()) {
      // (
      case 40:
        if (Ti != 108 && charat$2(Oo, fi - 1) == 58) {
          indexof$2(Oo += replace$2(delimit$2(Pi), "&", "&\f"), "&\f", abs$2(si ? li[si - 1] : 0)) != -1 && (Si = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        Oo += delimit$2(Pi);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        Oo += whitespace$2(Ti);
        break;
      // \
      case 92:
        Oo += escaping$2(caret$2() - 1, 7);
        continue;
      // /
      case 47:
        switch (peek$2()) {
          case 42:
          case 47:
            append$1(comment$2(commenter$2(next$2(), caret$2()), yt, ir, oi), oi), (token$2(Ti || 1) == 5 || token$2(peek$2() || 1) == 5) && strlen$2(Oo) && substr$2(Oo, -1, void 0) !== " " && (Oo += " ");
            break;
          default:
            Oo += "/";
        }
        break;
      // {
      case 123 * vi:
        li[si++] = strlen$2(Oo) * Si;
      // } ; \0
      case 125 * vi:
      case 59:
      case 0:
        switch (Pi) {
          // \0 }
          case 0:
          case 125:
            xi = 0;
          // ;
          case 59 + di:
            Si == -1 && (Oo = replace$2(Oo, /\f/g, "")), mi > 0 && (strlen$2(Oo) - fi || vi === 0 && Ti === 47) && append$1(mi > 32 ? declaration$2(Oo + ";", ti, ir, fi - 1, oi) : declaration$2(replace$2(Oo, " ", "") + ";", ti, ir, fi - 2, oi), oi);
            break;
          // @ ;
          case 59:
            Oo += ";";
          // { rule/at-rule
          default:
            if (append$1(Mi = ruleset$2(Oo, yt, ir, si, di, ii, li, $i, Oi = [], Di = [], fi, ui), ui), Pi === 123)
              if (di === 0)
                parse$2(Oo, yt, Mi, Mi, Oi, ui, fi, li, Di);
              else {
                switch (gi) {
                  // c(ontainer)
                  case 99:
                    if (charat$2(Oo, 3) === 110) break;
                  // l(ayer)
                  case 108:
                    if (charat$2(Oo, 2) === 97) break;
                  default:
                    di = 0;
                  // d(ocument) m(edia) s(upports)
                  case 100:
                  case 109:
                  case 115:
                }
                di ? parse$2(pt, Mi, Mi, ti && append$1(ruleset$2(pt, Mi, Mi, 0, 0, ii, li, $i, ii, Oi = [], fi, Di), Di), ii, Di, fi, li, ti ? Oi : Di) : parse$2(Oo, Mi, Mi, Mi, [""], Di, 0, li, Di);
              }
        }
        si = di = mi = 0, vi = Si = 1, $i = Oo = "", fi = ai;
        break;
      // :
      case 58:
        fi = 1 + strlen$2(Oo), mi = Ti;
      default:
        if (vi < 1) {
          if (Pi == 123)
            --vi;
          else if (Pi == 125 && vi++ == 0 && prev$2() == 125)
            continue;
        }
        switch (Oo += from$1(Pi), Pi * vi) {
          // &
          case 38:
            Si = di > 0 ? 1 : (Oo += "\f", -1);
            break;
          // ,
          case 44:
            li[si++] = (strlen$2(Oo) - 1) * Si, Si = 1;
            break;
          // @
          case 64:
            peek$2() === 45 && (Oo += delimit$2(next$2())), gi = peek$2(), di = fi = strlen$2($i = Oo += identifier$2(caret$2())), Pi++;
            break;
          // -
          case 45:
            Ti === 45 && strlen$2(Oo) == 2 && (vi = 0);
        }
    }
  return ui;
}
function ruleset$2(pt, yt, ir, ti, ii, ui, ai, li, oi, si, di, fi) {
  for (var gi = ii - 1, mi = ii === 0 ? ui : [""], Ti = sizeof$2(mi), vi = 0, xi = 0, Si = 0; vi < ti; ++vi)
    for (var Pi = 0, $i = substr$2(pt, gi + 1, gi = abs$2(xi = ai[vi])), Oi = pt; Pi < Ti; ++Pi)
      (Oi = trim$2(xi > 0 ? mi[Pi] + " " + $i : replace$2($i, /&\f/g, mi[Pi]))) && (oi[Si++] = Oi);
  return node$2(pt, yt, ir, ii === 0 ? RULESET$2 : li, oi, si, di, fi);
}
function comment$2(pt, yt, ir, ti) {
  return node$2(pt, yt, ir, COMMENT$2, from$1(char$2()), substr$2(pt, 2, -2), 0, ti);
}
function declaration$2(pt, yt, ir, ti, ii) {
  return node$2(pt, yt, ir, DECLARATION$2, substr$2(pt, 0, ti), substr$2(pt, ti + 1, -1), ti, ii);
}
function prefix$1(pt, yt, ir) {
  switch (hash$2(pt, yt)) {
    // color-adjust
    case 5103:
      return WEBKIT$2 + "print-" + pt + pt;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
      return WEBKIT$2 + pt + pt;
    // mask-composite
    case 4855:
      return WEBKIT$2 + pt.replace("add", "source-over").replace("substract", "source-out").replace("intersect", "source-in").replace("exclude", "xor") + pt;
    // tab-size
    case 4789:
      return MOZ$2 + pt + pt;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT$2 + pt + MOZ$2 + pt + MS$2 + pt + pt;
    // writing-mode
    case 5936:
      switch (charat$2(pt, yt + 11)) {
        // vertical-l(r)
        case 114:
          return WEBKIT$2 + pt + MS$2 + replace$2(pt, /[svh]\w+-[tblr]{2}/, "tb") + pt;
        // vertical-r(l)
        case 108:
          return WEBKIT$2 + pt + MS$2 + replace$2(pt, /[svh]\w+-[tblr]{2}/, "tb-rl") + pt;
        // horizontal(-)tb
        case 45:
          return WEBKIT$2 + pt + MS$2 + replace$2(pt, /[svh]\w+-[tblr]{2}/, "lr") + pt;
      }
    // flex, flex-direction, scroll-snap-type, writing-mode
    case 6828:
    case 4268:
    case 2903:
      return WEBKIT$2 + pt + MS$2 + pt + pt;
    // order
    case 6165:
      return WEBKIT$2 + pt + MS$2 + "flex-" + pt + pt;
    // align-items
    case 5187:
      return WEBKIT$2 + pt + replace$2(pt, /(\w+).+(:[^]+)/, WEBKIT$2 + "box-$1$2" + MS$2 + "flex-$1$2") + pt;
    // align-self
    case 5443:
      return WEBKIT$2 + pt + MS$2 + "flex-item-" + replace$2(pt, /flex-|-self/g, "") + (match$2(pt, /flex-|baseline/) ? "" : MS$2 + "grid-row-" + replace$2(pt, /flex-|-self/g, "")) + pt;
    // align-content
    case 4675:
      return WEBKIT$2 + pt + MS$2 + "flex-line-pack" + replace$2(pt, /align-content|flex-|-self/g, "") + pt;
    // flex-shrink
    case 5548:
      return WEBKIT$2 + pt + MS$2 + replace$2(pt, "shrink", "negative") + pt;
    // flex-basis
    case 5292:
      return WEBKIT$2 + pt + MS$2 + replace$2(pt, "basis", "preferred-size") + pt;
    // flex-grow
    case 6060:
      return WEBKIT$2 + "box-" + replace$2(pt, "-grow", "") + WEBKIT$2 + pt + MS$2 + replace$2(pt, "grow", "positive") + pt;
    // transition
    case 4554:
      return WEBKIT$2 + replace$2(pt, /([^-])(transform)/g, "$1" + WEBKIT$2 + "$2") + pt;
    // cursor
    case 6187:
      return replace$2(replace$2(replace$2(pt, /(zoom-|grab)/, WEBKIT$2 + "$1"), /(image-set)/, WEBKIT$2 + "$1"), pt, "") + pt;
    // background, background-image
    case 5495:
    case 3959:
      return replace$2(pt, /(image-set\([^]*)/, WEBKIT$2 + "$1$`$1");
    // justify-content
    case 4968:
      return replace$2(replace$2(pt, /(.+:)(flex-)?(.*)/, WEBKIT$2 + "box-pack:$3" + MS$2 + "flex-pack:$3"), /space-between/, "justify") + WEBKIT$2 + pt + pt;
    // justify-self
    case 4200:
      if (!match$2(pt, /flex-|baseline/)) return MS$2 + "grid-column-align" + substr$2(pt, yt) + pt;
      break;
    // grid-template-(columns|rows)
    case 2592:
    case 3360:
      return MS$2 + replace$2(pt, "template-", "") + pt;
    // grid-(row|column)-start
    case 4384:
    case 3616:
      return ir && ir.some(function(ti, ii) {
        return yt = ii, match$2(ti.props, /grid-\w+-end/);
      }) ? ~indexof$2(pt + (ir = ir[yt].value), "span", 0) ? pt : MS$2 + replace$2(pt, "-start", "") + pt + MS$2 + "grid-row-span:" + (~indexof$2(ir, "span", 0) ? match$2(ir, /\d+/) : +match$2(ir, /\d+/) - +match$2(pt, /\d+/)) + ";" : MS$2 + replace$2(pt, "-start", "") + pt;
    // grid-(row|column)-end
    case 4896:
    case 4128:
      return ir && ir.some(function(ti) {
        return match$2(ti.props, /grid-\w+-start/);
      }) ? pt : MS$2 + replace$2(replace$2(pt, "-end", "-span"), "span ", "") + pt;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace$2(pt, /(.+)-inline(.+)/, WEBKIT$2 + "$1$2") + pt;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen$2(pt) - 1 - yt > 6)
        switch (charat$2(pt, yt + 1)) {
          // (m)ax-content, (m)in-content
          case 109:
            if (charat$2(pt, yt + 4) !== 45)
              break;
          // (f)ill-available, (f)it-content
          case 102:
            return replace$2(pt, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT$2 + "$2-$3$1" + MOZ$2 + (charat$2(pt, yt + 3) == 108 ? "$3" : "$2-$3")) + pt;
          // (s)tretch
          case 115:
            return ~indexof$2(pt, "stretch", 0) ? prefix$1(replace$2(pt, "stretch", "fill-available"), yt, ir) + pt : pt;
        }
      break;
    // grid-(column|row)
    case 5152:
    case 5920:
      return replace$2(pt, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(ti, ii, ui, ai, li, oi, si) {
        return MS$2 + ii + ":" + ui + si + (ai ? MS$2 + ii + "-span:" + (li ? oi : +oi - +ui) + si : "") + pt;
      });
    // position: sticky
    case 4949:
      if (charat$2(pt, yt + 6) === 121)
        return replace$2(pt, ":", ":" + WEBKIT$2) + pt;
      break;
    // display: (flex|inline-flex|grid|inline-grid)
    case 6444:
      switch (charat$2(pt, charat$2(pt, 14) === 45 ? 18 : 11)) {
        // (inline-)?fle(x)
        case 120:
          return replace$2(pt, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + WEBKIT$2 + (charat$2(pt, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT$2 + "$2$3$1" + MS$2 + "$2box$3") + pt;
        // (inline-)?gri(d)
        case 100:
          return replace$2(pt, ":", ":" + MS$2) + pt;
      }
      break;
    // scroll-margin, scroll-margin-(top|right|bottom|left)
    case 5719:
    case 2647:
    case 2135:
    case 3927:
    case 2391:
      return replace$2(pt, "scroll-", "scroll-snap-") + pt;
  }
  return pt;
}
function serialize$2(pt, yt) {
  for (var ir = "", ti = 0; ti < pt.length; ti++)
    ir += yt(pt[ti], ti, pt, yt) || "";
  return ir;
}
function stringify$2(pt, yt, ir, ti) {
  switch (pt.type) {
    case LAYER$2:
      if (pt.children.length) break;
    case IMPORT$2:
    case NAMESPACE:
    case DECLARATION$2:
      return pt.return = pt.return || pt.value;
    case COMMENT$2:
      return "";
    case KEYFRAMES$2:
      return pt.return = pt.value + "{" + serialize$2(pt.children, ti) + "}";
    case RULESET$2:
      if (!strlen$2(pt.value = pt.props.join(","))) return "";
  }
  return strlen$2(ir = serialize$2(pt.children, ti)) ? pt.return = pt.value + "{" + ir + "}" : "";
}
function middleware$2(pt) {
  var yt = sizeof$2(pt);
  return function(ir, ti, ii, ui) {
    for (var ai = "", li = 0; li < yt; li++)
      ai += pt[li](ir, ti, ii, ui) || "";
    return ai;
  };
}
function rulesheet$2(pt) {
  return function(yt) {
    yt.root || (yt = yt.return) && pt(yt);
  };
}
function prefixer$2(pt, yt, ir, ti) {
  if (pt.length > -1 && !pt.return)
    switch (pt.type) {
      case DECLARATION$2:
        pt.return = prefix$1(pt.value, pt.length, ir);
        return;
      case KEYFRAMES$2:
        return serialize$2([copy$2(pt, { value: replace$2(pt.value, "@", "@" + WEBKIT$2) })], ti);
      case RULESET$2:
        if (pt.length)
          return combine$2(ir = pt.props, function(ii) {
            switch (match$2(ii, ti = /(::plac\w+|:read-\w+)/)) {
              // :read-(only|write)
              case ":read-only":
              case ":read-write":
                lift(copy$2(pt, { props: [replace$2(ii, /:(read-\w+)/, ":" + MOZ$2 + "$1")] })), lift(copy$2(pt, { props: [ii] })), assign$1(pt, { props: filter(ir, ti) });
                break;
              // :placeholder
              case "::placeholder":
                lift(copy$2(pt, { props: [replace$2(ii, /:(plac\w+)/, ":" + WEBKIT$2 + "input-$1")] })), lift(copy$2(pt, { props: [replace$2(ii, /:(plac\w+)/, ":" + MOZ$2 + "$1")] })), lift(copy$2(pt, { props: [replace$2(ii, /:(plac\w+)/, MS$2 + "input-$1")] })), lift(copy$2(pt, { props: [ii] })), assign$1(pt, { props: filter(ir, ti) });
                break;
            }
            return "";
          });
    }
}
var a$4 = typeof process < "u" && process.env !== void 0 && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", c$5 = "active", u$3 = "data-styled-version", l$2 = "6.3.12", p$3 = `/*!sc*/
`, h$3 = typeof window < "u" && typeof document < "u", d$2 = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof process < "u" && process.env !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? process.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && process.env.REACT_APP_SC_DISABLE_SPEEDY : typeof process < "u" && process.env !== void 0 && process.env.SC_DISABLE_SPEEDY !== void 0 && process.env.SC_DISABLE_SPEEDY !== "" ? process.env.SC_DISABLE_SPEEDY !== "false" && process.env.SC_DISABLE_SPEEDY : process.env.NODE_ENV !== "production"), m$3 = process.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
`, 18: "ThemeProvider: Please make sure your useTheme hook is within a `<ThemeProvider>`" } : {};
function y$5() {
  for (var pt = [], yt = 0; yt < arguments.length; yt++) pt[yt] = arguments[yt];
  for (var ir = pt[0], ti = [], ii = 1, ui = pt.length; ii < ui; ii += 1) ti.push(pt[ii]);
  return ti.forEach(function(ai) {
    ir = ir.replace(/%[a-z]/, ai);
  }), ir;
}
function v$4(pt) {
  for (var yt = [], ir = 1; ir < arguments.length; ir++) yt[ir - 1] = arguments[ir];
  return process.env.NODE_ENV === "production" ? new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(pt, " for more information.").concat(yt.length > 0 ? " Args: ".concat(yt.join(", ")) : "")) : new Error(y$5.apply(void 0, __spreadArray([m$3[pt]], yt, !1)).trim());
}
var g$2 = 1 << 30, S$5 = /* @__PURE__ */ new Map(), w$4 = /* @__PURE__ */ new Map(), b$5 = 1, N$3 = function(pt) {
  if (S$5.has(pt)) return S$5.get(pt);
  for (; w$4.has(b$5); ) b$5++;
  var yt = b$5++;
  if (process.env.NODE_ENV !== "production" && ((0 | yt) < 0 || yt > g$2)) throw v$4(16, "".concat(yt));
  return S$5.set(pt, yt), w$4.set(yt, pt), yt;
}, E$2 = function(pt, yt) {
  b$5 = yt + 1, S$5.set(pt, yt), w$4.set(yt, pt);
}, C$4 = /invalid hook call/i, _$4 = /* @__PURE__ */ new Set(), A$3 = function(pt, yt) {
  if (process.env.NODE_ENV !== "production") {
    var ir = yt ? ' with the id of "'.concat(yt, '"') : "", ti = "The component ".concat(pt).concat(ir, ` has been created dynamically.
`) + `You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.
See https://styled-components.com/docs/basics#define-styled-components-outside-of-the-render-method for more info.
`, ii = console.error;
    try {
      var ui = !0;
      console.error = function(ai) {
        for (var li = [], oi = 1; oi < arguments.length; oi++) li[oi - 1] = arguments[oi];
        C$4.test(ai) ? (ui = !1, _$4.delete(ti)) : ii.apply(void 0, __spreadArray([ai], li, !1));
      }, typeof React__default.useState == "function" && React__default.useState(null), ui && !_$4.has(ti) && (console.warn(ti), _$4.add(ti));
    } catch (ai) {
      C$4.test(ai.message) && _$4.delete(ti);
    } finally {
      console.error = ii;
    }
  }
}, P$7 = Object.freeze([]), I$5 = Object.freeze({});
function O$5(pt, yt, ir) {
  return ir === void 0 && (ir = I$5), pt.theme !== ir.theme && pt.theme || yt || ir.theme;
}
var D$4 = /* @__PURE__ */ new Set(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "blockquote", "body", "button", "br", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "menu", "meter", "nav", "object", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "slot", "small", "span", "strong", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "switch", "symbol", "text", "textPath", "tspan", "use"]), R$4 = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, T$5 = /(^-|-$)/g;
function x$6(pt) {
  return pt.replace(R$4, "-").replace(T$5, "");
}
var j$5 = /(a)(d)/gi, k$6 = function(pt) {
  return String.fromCharCode(pt + (pt > 25 ? 39 : 97));
};
function M$4(pt) {
  var yt, ir = "";
  for (yt = Math.abs(pt); yt > 52; yt = yt / 52 | 0) ir = k$6(yt % 52) + ir;
  return (k$6(yt % 52) + ir).replace(j$5, "$1-$2");
}
var V$5, F$5 = function(pt, yt) {
  for (var ir = yt.length; ir; ) pt = 33 * pt ^ yt.charCodeAt(--ir);
  return pt;
}, G$5 = function(pt) {
  return F$5(5381, pt);
};
function L$6(pt) {
  return M$4(G$5(pt) >>> 0);
}
function B$3(pt) {
  return process.env.NODE_ENV !== "production" && typeof pt == "string" && pt || pt.displayName || pt.name || "Component";
}
function z$4(pt) {
  return typeof pt == "string" && (process.env.NODE_ENV === "production" || pt.charAt(0) === pt.charAt(0).toLowerCase());
}
var $$5 = typeof Symbol == "function" && Symbol.for, Y$5 = $$5 ? Symbol.for("react.memo") : 60115, W$5 = $$5 ? Symbol.for("react.forward_ref") : 60112, q$5 = { childContextTypes: !0, contextType: !0, contextTypes: !0, defaultProps: !0, displayName: !0, getDefaultProps: !0, getDerivedStateFromError: !0, getDerivedStateFromProps: !0, mixins: !0, propTypes: !0, type: !0 }, H$5 = { name: !0, length: !0, prototype: !0, caller: !0, callee: !0, arguments: !0, arity: !0 }, U$5 = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }, J$5 = ((V$5 = {})[W$5] = { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, V$5[Y$5] = U$5, V$5);
function X$4(pt) {
  return ("type" in (yt = pt) && yt.type.$$typeof) === Y$5 ? U$5 : "$$typeof" in pt ? J$5[pt.$$typeof] : q$5;
  var yt;
}
var Z$3 = Object.defineProperty, K$5 = Object.getOwnPropertyNames, Q$3 = Object.getOwnPropertySymbols, ee$3 = Object.getOwnPropertyDescriptor, te$4 = Object.getPrototypeOf, ne$1 = Object.prototype;
function oe$3(pt, yt, ir) {
  if (typeof yt != "string") {
    if (ne$1) {
      var ti = te$4(yt);
      ti && ti !== ne$1 && oe$3(pt, ti, ir);
    }
    var ii = K$5(yt);
    Q$3 && (ii = ii.concat(Q$3(yt)));
    for (var ui = X$4(pt), ai = X$4(yt), li = 0; li < ii.length; ++li) {
      var oi = ii[li];
      if (!(oi in H$5 || ir && ir[oi] || ai && oi in ai || ui && oi in ui)) {
        var si = ee$3(yt, oi);
        try {
          Z$3(pt, oi, si);
        } catch {
        }
      }
    }
  }
  return pt;
}
function re$4(pt) {
  return typeof pt == "function";
}
function se$3(pt) {
  return typeof pt == "object" && "styledComponentId" in pt;
}
function ie$2(pt, yt) {
  return pt && yt ? "".concat(pt, " ").concat(yt) : pt || yt || "";
}
function ae$3(pt, yt) {
  return pt.join("");
}
function ce$3(pt) {
  return pt !== null && typeof pt == "object" && pt.constructor.name === Object.name && !("props" in pt && pt.$$typeof);
}
function ue$2(pt, yt, ir) {
  if (ir === void 0 && (ir = !1), !ir && !ce$3(pt) && !Array.isArray(pt)) return yt;
  if (Array.isArray(yt)) for (var ti = 0; ti < yt.length; ti++) pt[ti] = ue$2(pt[ti], yt[ti]);
  else if (ce$3(yt)) for (var ti in yt) pt[ti] = ue$2(pt[ti], yt[ti]);
  return pt;
}
function le$3(pt, yt) {
  Object.defineProperty(pt, "toString", { value: yt });
}
var pe$2 = (function() {
  function pt(yt) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = yt, this._cGroup = 0, this._cIndex = 0;
  }
  return pt.prototype.indexOfGroup = function(yt) {
    if (yt === this._cGroup) return this._cIndex;
    var ir = this._cIndex;
    if (yt > this._cGroup) for (var ti = this._cGroup; ti < yt; ti++) ir += this.groupSizes[ti];
    else for (ti = this._cGroup - 1; ti >= yt; ti--) ir -= this.groupSizes[ti];
    return this._cGroup = yt, this._cIndex = ir, ir;
  }, pt.prototype.insertRules = function(yt, ir) {
    if (yt >= this.groupSizes.length) {
      for (var ti = this.groupSizes, ii = ti.length, ui = ii; yt >= ui; ) if ((ui <<= 1) < 0) throw v$4(16, "".concat(yt));
      this.groupSizes = new Uint32Array(ui), this.groupSizes.set(ti), this.length = ui;
      for (var ai = ii; ai < ui; ai++) this.groupSizes[ai] = 0;
    }
    for (var li = this.indexOfGroup(yt + 1), oi = 0, si = (ai = 0, ir.length); ai < si; ai++) this.tag.insertRule(li, ir[ai]) && (this.groupSizes[yt]++, li++, oi++);
    oi > 0 && this._cGroup > yt && (this._cIndex += oi);
  }, pt.prototype.clearGroup = function(yt) {
    if (yt < this.length) {
      var ir = this.groupSizes[yt], ti = this.indexOfGroup(yt), ii = ti + ir;
      this.groupSizes[yt] = 0;
      for (var ui = ti; ui < ii; ui++) this.tag.deleteRule(ti);
      ir > 0 && this._cGroup > yt && (this._cIndex -= ir);
    }
  }, pt.prototype.getGroup = function(yt) {
    var ir = "";
    if (yt >= this.length || this.groupSizes[yt] === 0) return ir;
    for (var ti = this.groupSizes[yt], ii = this.indexOfGroup(yt), ui = ii + ti, ai = ii; ai < ui; ai++) ir += this.tag.getRule(ai) + p$3;
    return ir;
  }, pt;
})(), he$3 = "style[".concat(a$4, "][").concat(u$3, '="').concat(l$2, '"]'), de$2 = new RegExp("^".concat(a$4, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), fe$3 = function(pt) {
  return typeof ShadowRoot < "u" && pt instanceof ShadowRoot || "host" in pt && pt.nodeType === 11;
}, me$3 = function(pt) {
  if (!pt) return document;
  if (fe$3(pt)) return pt;
  if ("getRootNode" in pt) {
    var yt = pt.getRootNode();
    if (fe$3(yt)) return yt;
  }
  return document;
}, ye$2 = function(pt, yt, ir) {
  for (var ti, ii = ir.split(","), ui = 0, ai = ii.length; ui < ai; ui++) (ti = ii[ui]) && pt.registerName(yt, ti);
}, ve$3 = function(pt, yt) {
  for (var ir, ti = ((ir = yt.textContent) !== null && ir !== void 0 ? ir : "").split(p$3), ii = [], ui = 0, ai = ti.length; ui < ai; ui++) {
    var li = ti[ui].trim();
    if (li) {
      var oi = li.match(de$2);
      if (oi) {
        var si = 0 | parseInt(oi[1], 10), di = oi[2];
        si !== 0 && (E$2(di, si), ye$2(pt, di, oi[3]), pt.getTag().insertRules(si, ii)), ii.length = 0;
      } else ii.push(li);
    }
  }
}, ge$3 = function(pt) {
  for (var yt = me$3(pt.options.target).querySelectorAll(he$3), ir = 0, ti = yt.length; ir < ti; ir++) {
    var ii = yt[ir];
    ii && ii.getAttribute(a$4) !== c$5 && (ve$3(pt, ii), ii.parentNode && ii.parentNode.removeChild(ii));
  }
};
function Se$3() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
}
var we$3 = function(pt) {
  var yt = document.head, ir = pt || yt, ti = document.createElement("style"), ii = (function(li) {
    var oi = Array.from(li.querySelectorAll("style[".concat(a$4, "]")));
    return oi[oi.length - 1];
  })(ir), ui = ii !== void 0 ? ii.nextSibling : null;
  ti.setAttribute(a$4, c$5), ti.setAttribute(u$3, l$2);
  var ai = Se$3();
  return ai && ti.setAttribute("nonce", ai), ir.insertBefore(ti, ui), ti;
}, be$3 = (function() {
  function pt(yt) {
    this.element = we$3(yt), this.element.appendChild(document.createTextNode("")), this.sheet = (function(ir) {
      var ti;
      if (ir.sheet) return ir.sheet;
      for (var ii = (ti = ir.getRootNode().styleSheets) !== null && ti !== void 0 ? ti : document.styleSheets, ui = 0, ai = ii.length; ui < ai; ui++) {
        var li = ii[ui];
        if (li.ownerNode === ir) return li;
      }
      throw v$4(17);
    })(this.element), this.length = 0;
  }
  return pt.prototype.insertRule = function(yt, ir) {
    try {
      return this.sheet.insertRule(ir, yt), this.length++, !0;
    } catch {
      return !1;
    }
  }, pt.prototype.deleteRule = function(yt) {
    this.sheet.deleteRule(yt), this.length--;
  }, pt.prototype.getRule = function(yt) {
    var ir = this.sheet.cssRules[yt];
    return ir && ir.cssText ? ir.cssText : "";
  }, pt;
})(), Ne$3 = (function() {
  function pt(yt) {
    this.element = we$3(yt), this.nodes = this.element.childNodes, this.length = 0;
  }
  return pt.prototype.insertRule = function(yt, ir) {
    if (yt <= this.length && yt >= 0) {
      var ti = document.createTextNode(ir);
      return this.element.insertBefore(ti, this.nodes[yt] || null), this.length++, !0;
    }
    return !1;
  }, pt.prototype.deleteRule = function(yt) {
    this.element.removeChild(this.nodes[yt]), this.length--;
  }, pt.prototype.getRule = function(yt) {
    return yt < this.length ? this.nodes[yt].textContent : "";
  }, pt;
})(), Ee$3 = (function() {
  function pt(yt) {
    this.rules = [], this.length = 0;
  }
  return pt.prototype.insertRule = function(yt, ir) {
    return yt <= this.length && (yt === this.length ? this.rules.push(ir) : this.rules.splice(yt, 0, ir), this.length++, !0);
  }, pt.prototype.deleteRule = function(yt) {
    this.rules.splice(yt, 1), this.length--;
  }, pt.prototype.getRule = function(yt) {
    return yt < this.length ? this.rules[yt] : "";
  }, pt;
})(), Ce$2 = h$3, _e$3 = { isServer: !h$3, useCSSOMInjection: !d$2 }, Ae$3 = (function() {
  function pt(yt, ir, ti) {
    yt === void 0 && (yt = I$5), ir === void 0 && (ir = {});
    var ii = this;
    this.options = __assign(__assign({}, _e$3), yt), this.gs = ir, this.names = new Map(ti), this.server = !!yt.isServer, !this.server && h$3 && Ce$2 && (Ce$2 = !1, ge$3(this)), le$3(this, function() {
      return (function(ui) {
        for (var ai = ui.getTag(), li = ai.length, oi = "", si = function(fi) {
          var gi = (function(Si) {
            return w$4.get(Si);
          })(fi);
          if (gi === void 0) return "continue";
          var mi = ui.names.get(gi);
          if (mi === void 0 || !mi.size) return "continue";
          var Ti = ai.getGroup(fi);
          if (Ti.length === 0) return "continue";
          var vi = a$4 + ".g" + fi + '[id="' + gi + '"]', xi = "";
          mi.forEach(function(Si) {
            Si.length > 0 && (xi += Si + ",");
          }), oi += Ti + vi + '{content:"' + xi + '"}' + p$3;
        }, di = 0; di < li; di++) si(di);
        return oi;
      })(ii);
    });
  }
  return pt.registerId = function(yt) {
    return N$3(yt);
  }, pt.prototype.rehydrate = function() {
    !this.server && h$3 && ge$3(this);
  }, pt.prototype.reconstructWithOptions = function(yt, ir) {
    ir === void 0 && (ir = !0);
    var ti = new pt(__assign(__assign({}, this.options), yt), this.gs, ir && this.names || void 0);
    return !this.server && h$3 && yt.target !== this.options.target && me$3(this.options.target) !== me$3(yt.target) && ge$3(ti), ti;
  }, pt.prototype.allocateGSInstance = function(yt) {
    return this.gs[yt] = (this.gs[yt] || 0) + 1;
  }, pt.prototype.getTag = function() {
    return this.tag || (this.tag = (yt = (function(ir) {
      var ti = ir.useCSSOMInjection, ii = ir.target;
      return ir.isServer ? new Ee$3(ii) : ti ? new be$3(ii) : new Ne$3(ii);
    })(this.options), new pe$2(yt)));
    var yt;
  }, pt.prototype.hasNameForId = function(yt, ir) {
    var ti, ii;
    return (ii = (ti = this.names.get(yt)) === null || ti === void 0 ? void 0 : ti.has(ir)) !== null && ii !== void 0 && ii;
  }, pt.prototype.registerName = function(yt, ir) {
    N$3(yt);
    var ti = this.names.get(yt);
    ti ? ti.add(ir) : this.names.set(yt, /* @__PURE__ */ new Set([ir]));
  }, pt.prototype.insertRules = function(yt, ir, ti) {
    this.registerName(yt, ir), this.getTag().insertRules(N$3(yt), ti);
  }, pt.prototype.clearNames = function(yt) {
    this.names.has(yt) && this.names.get(yt).clear();
  }, pt.prototype.clearRules = function(yt) {
    this.getTag().clearGroup(N$3(yt)), this.clearNames(yt);
  }, pt.prototype.clearTag = function() {
    this.tag = void 0;
  }, pt;
})();
function Pe$2(pt, yt) {
  return yt == null || typeof yt == "boolean" || yt === "" ? "" : typeof yt != "number" || yt === 0 || pt in unitlessKeys$1 || pt.startsWith("--") ? String(yt).trim() : "".concat(yt, "px");
}
var Ie$2 = function(pt) {
  return pt >= "A" && pt <= "Z";
};
function Oe$3(pt) {
  for (var yt = "", ir = 0; ir < pt.length; ir++) {
    var ti = pt[ir];
    if (ir === 1 && ti === "-" && pt[0] === "-") return pt;
    Ie$2(ti) ? yt += "-" + ti.toLowerCase() : yt += ti;
  }
  return yt.startsWith("ms-") ? "-" + yt : yt;
}
var De$3 = Symbol.for("sc-keyframes");
function Re$3(pt) {
  return typeof pt == "object" && pt !== null && De$3 in pt;
}
var Te$3 = function(pt) {
  return pt == null || pt === !1 || pt === "";
}, xe$3 = function(pt) {
  var yt = [];
  for (var ir in pt) {
    var ti = pt[ir];
    pt.hasOwnProperty(ir) && !Te$3(ti) && (Array.isArray(ti) && ti.isCss || re$4(ti) ? yt.push("".concat(Oe$3(ir), ":"), ti, ";") : ce$3(ti) ? yt.push.apply(yt, __spreadArray(__spreadArray(["".concat(ir, " {")], xe$3(ti), !1), ["}"], !1)) : yt.push("".concat(Oe$3(ir), ": ").concat(Pe$2(ir, ti), ";")));
  }
  return yt;
};
function je$3(pt, yt, ir, ti, ii) {
  if (ii === void 0 && (ii = []), typeof pt == "string") return pt && ii.push(pt), ii;
  if (Te$3(pt)) return ii;
  if (se$3(pt)) return ii.push(".".concat(pt.styledComponentId)), ii;
  if (re$4(pt)) {
    if (!re$4(ai = pt) || ai.prototype && ai.prototype.isReactComponent || !yt) return ii.push(pt), ii;
    var ui = pt(yt);
    return process.env.NODE_ENV === "production" || typeof ui != "object" || Array.isArray(ui) || Re$3(ui) || ce$3(ui) || ui === null || console.error("".concat(B$3(pt), " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.")), je$3(ui, yt, ir, ti, ii);
  }
  var ai;
  if (Re$3(pt)) return ir ? (pt.inject(ir, ti), ii.push(pt.getName(ti))) : ii.push(pt), ii;
  if (ce$3(pt)) {
    for (var li = xe$3(pt), oi = 0; oi < li.length; oi++) ii.push(li[oi]);
    return ii;
  }
  if (!Array.isArray(pt)) return ii.push(pt.toString()), ii;
  for (oi = 0; oi < pt.length; oi++) je$3(pt[oi], yt, ir, ti, ii);
  return ii;
}
function ke$3(pt) {
  for (var yt = 0; yt < pt.length; yt += 1) {
    var ir = pt[yt];
    if (re$4(ir) && !se$3(ir)) return !1;
  }
  return !0;
}
var Me$3 = G$5(l$2), Ve$2 = (function() {
  function pt(yt, ir, ti) {
    this.rules = yt, this.staticRulesId = "", this.isStatic = process.env.NODE_ENV === "production" && (ti === void 0 || ti.isStatic) && ke$3(yt), this.componentId = ir, this.baseHash = F$5(Me$3, ir), this.baseStyle = ti, Ae$3.registerId(ir);
  }
  return pt.prototype.generateAndInjectStyles = function(yt, ir, ti) {
    var ii = this.baseStyle ? this.baseStyle.generateAndInjectStyles(yt, ir, ti).className : "";
    if (this.isStatic && !ti.hash) if (this.staticRulesId && ir.hasNameForId(this.componentId, this.staticRulesId)) ii = ie$2(ii, this.staticRulesId);
    else {
      var ui = ae$3(je$3(this.rules, yt, ir, ti)), ai = M$4(F$5(this.baseHash, ui) >>> 0);
      if (!ir.hasNameForId(this.componentId, ai)) {
        var li = ti(ui, ".".concat(ai), void 0, this.componentId);
        ir.insertRules(this.componentId, ai, li);
      }
      ii = ie$2(ii, ai), this.staticRulesId = ai;
    }
    else {
      for (var oi = F$5(this.baseHash, ti.hash), si = "", di = 0; di < this.rules.length; di++) {
        var fi = this.rules[di];
        if (typeof fi == "string") si += fi, process.env.NODE_ENV !== "production" && (oi = F$5(oi, fi));
        else if (fi) {
          var gi = ae$3(je$3(fi, yt, ir, ti));
          oi = F$5(F$5(oi, String(di)), gi), si += gi;
        }
      }
      if (si) {
        var mi = M$4(oi >>> 0);
        if (!ir.hasNameForId(this.componentId, mi)) {
          var Ti = ti(si, ".".concat(mi), void 0, this.componentId);
          ir.insertRules(this.componentId, mi, Ti);
        }
        ii = ie$2(ii, mi);
      }
    }
    return { className: ii, css: typeof window > "u" ? ir.getTag().getGroup(N$3(this.componentId)) : "" };
  }, pt;
})(), Fe$3 = /&/g, Ge$3 = 47, Le$3 = 42;
function Be$3(pt) {
  if (pt.indexOf("}") === -1) return !1;
  for (var yt = pt.length, ir = 0, ti = 0, ii = !1, ui = 0; ui < yt; ui++) {
    var ai = pt.charCodeAt(ui);
    if (ti !== 0 || ii || ai !== Ge$3 || pt.charCodeAt(ui + 1) !== Le$3) if (ii) ai === Le$3 && pt.charCodeAt(ui + 1) === Ge$3 && (ii = !1, ui++);
    else if (ai !== 34 && ai !== 39 || ui !== 0 && pt.charCodeAt(ui - 1) === 92) {
      if (ti === 0) {
        if (ai === 123) ir++;
        else if (ai === 125 && --ir < 0) return !0;
      }
    } else ti === 0 ? ti = ai : ti === ai && (ti = 0);
    else ii = !0, ui++;
  }
  return ir !== 0 || ti !== 0;
}
function ze$2(pt, yt) {
  return pt.map(function(ir) {
    return ir.type === "rule" && (ir.value = "".concat(yt, " ").concat(ir.value), ir.value = ir.value.replaceAll(",", ",".concat(yt, " ")), ir.props = ir.props.map(function(ti) {
      return "".concat(yt, " ").concat(ti);
    })), Array.isArray(ir.children) && ir.type !== "@keyframes" && (ir.children = ze$2(ir.children, yt)), ir;
  });
}
function $e$3(pt) {
  var yt, ir, ti, ii = I$5, ui = ii.options, ai = ui === void 0 ? I$5 : ui, li = ii.plugins, oi = li === void 0 ? P$7 : li, si = function(Ti, vi, xi) {
    return xi.startsWith(ir) && xi.endsWith(ir) && xi.replaceAll(ir, "").length > 0 ? ".".concat(yt) : Ti;
  }, di = oi.slice();
  di.push(function(Ti) {
    Ti.type === RULESET$2 && Ti.value.includes("&") && (ti || (ti = new RegExp("\\".concat(ir, "\\b"), "g")), Ti.props[0] = Ti.props[0].replace(Fe$3, ir).replace(ti, si));
  }), ai.prefix && di.push(prefixer$2), di.push(stringify$2);
  var fi = [], gi = middleware$2(di.concat(rulesheet$2(function(Ti) {
    return fi.push(Ti);
  }))), mi = function(Ti, vi, xi, Si) {
    vi === void 0 && (vi = ""), xi === void 0 && (xi = ""), Si === void 0 && (Si = "&"), yt = Si, ir = vi, ti = void 0;
    var Pi = (function(Oi) {
      if (!Be$3(Oi)) return Oi;
      for (var Di = Oi.length, Mi = "", Oo = 0, io = 0, xo = 0, fo = !1, _o = 0; _o < Di; _o++) {
        var Li = Oi.charCodeAt(_o);
        if (xo !== 0 || fo || Li !== Ge$3 || Oi.charCodeAt(_o + 1) !== Le$3) if (fo) Li === Le$3 && Oi.charCodeAt(_o + 1) === Ge$3 && (fo = !1, _o++);
        else if (Li !== 34 && Li !== 39 || _o !== 0 && Oi.charCodeAt(_o - 1) === 92) {
          if (xo === 0) if (Li === 123) io++;
          else if (Li === 125) {
            if (--io < 0) {
              for (var Co = _o + 1; Co < Di; ) {
                var Ni = Oi.charCodeAt(Co);
                if (Ni === 59 || Ni === 10) break;
                Co++;
              }
              Co < Di && Oi.charCodeAt(Co) === 59 && Co++, io = 0, _o = Co - 1, Oo = Co;
              continue;
            }
            io === 0 && (Mi += Oi.substring(Oo, _o + 1), Oo = _o + 1);
          } else Li === 59 && io === 0 && (Mi += Oi.substring(Oo, _o + 1), Oo = _o + 1);
        } else xo === 0 ? xo = Li : xo === Li && (xo = 0);
        else fo = !0, _o++;
      }
      if (Oo < Di) {
        var Yi = Oi.substring(Oo);
        Be$3(Yi) || (Mi += Yi);
      }
      return Mi;
    })((function(Oi) {
      if (Oi.indexOf("//") === -1) return Oi;
      for (var Di = Oi.length, Mi = [], Oo = 0, io = 0, xo = 0, fo = 0; io < Di; ) {
        var _o = Oi.charCodeAt(io);
        if (_o !== 34 && _o !== 39 || io !== 0 && Oi.charCodeAt(io - 1) === 92) if (xo === 0) if (_o === Ge$3 && io + 1 < Di && Oi.charCodeAt(io + 1) === Le$3) {
          for (io += 2; io + 1 < Di && (Oi.charCodeAt(io) !== Le$3 || Oi.charCodeAt(io + 1) !== Ge$3); ) io++;
          io += 2;
        } else if (_o === 40 && io >= 3 && (32 | Oi.charCodeAt(io - 1)) == 108 && (32 | Oi.charCodeAt(io - 2)) == 114 && (32 | Oi.charCodeAt(io - 3)) == 117) fo = 1, io++;
        else if (fo > 0) _o === 41 ? fo-- : _o === 40 && fo++, io++;
        else if (_o === Le$3 && io + 1 < Di && Oi.charCodeAt(io + 1) === Ge$3) io > Oo && Mi.push(Oi.substring(Oo, io)), Oo = io += 2;
        else if (_o === Ge$3 && io + 1 < Di && Oi.charCodeAt(io + 1) === Ge$3) {
          for (io > Oo && Mi.push(Oi.substring(Oo, io)); io < Di && Oi.charCodeAt(io) !== 10; ) io++;
          Oo = io;
        } else io++;
        else io++;
        else xo === 0 ? xo = _o : xo === _o && (xo = 0), io++;
      }
      return Oo === 0 ? Oi : (Oo < Di && Mi.push(Oi.substring(Oo)), Mi.join(""));
    })(Ti)), $i = compile$2(xi || vi ? "".concat(xi, " ").concat(vi, " { ").concat(Pi, " }") : Pi);
    return ai.namespace && ($i = ze$2($i, ai.namespace)), fi = [], serialize$2($i, gi), fi;
  };
  return mi.hash = oi.length ? oi.reduce(function(Ti, vi) {
    return vi.name || v$4(15), F$5(Ti, vi.name);
  }, 5381).toString() : "", mi;
}
var Ye$3 = new Ae$3(), We$3 = $e$3(), qe$3 = React__default.createContext({ shouldForwardProp: void 0, styleSheet: Ye$3, stylis: We$3 });
qe$3.Consumer;
React__default.createContext(void 0);
function Je$2() {
  return React__default.useContext(qe$3);
}
var Ze$2 = React__default.createContext(void 0);
Ze$2.Consumer;
function et$1(pt) {
  var yt = React__default.useContext(Ze$2), ir = React__default.useMemo(function() {
    return (function(ti, ii) {
      if (!ti) throw v$4(14);
      if (re$4(ti)) {
        var ui = ti(ii);
        if (process.env.NODE_ENV !== "production" && (ui === null || Array.isArray(ui) || typeof ui != "object")) throw v$4(7);
        return ui;
      }
      if (Array.isArray(ti) || typeof ti != "object") throw v$4(8);
      return ii ? __assign(__assign({}, ii), ti) : ti;
    })(pt.theme, yt);
  }, [pt.theme, yt]);
  return pt.children ? React__default.createElement(Ze$2.Provider, { value: ir }, pt.children) : null;
}
var tt$1 = {}, nt$1 = /* @__PURE__ */ new Set();
function ot$2(pt, yt, ir) {
  var ti = se$3(pt), ii = pt, ui = !z$4(pt), ai = yt.attrs, li = ai === void 0 ? P$7 : ai, oi = yt.componentId, si = oi === void 0 ? (function(Oi, Di) {
    var Mi = typeof Oi != "string" ? "sc" : x$6(Oi);
    tt$1[Mi] = (tt$1[Mi] || 0) + 1;
    var Oo = "".concat(Mi, "-").concat(L$6(l$2 + Mi + tt$1[Mi]));
    return Di ? "".concat(Di, "-").concat(Oo) : Oo;
  })(yt.displayName, yt.parentComponentId) : oi, di = yt.displayName, fi = di === void 0 ? (function(Oi) {
    return z$4(Oi) ? "styled.".concat(Oi) : "Styled(".concat(B$3(Oi), ")");
  })(pt) : di, gi = yt.displayName && yt.componentId ? "".concat(x$6(yt.displayName), "-").concat(yt.componentId) : yt.componentId || si, mi = ti && ii.attrs ? ii.attrs.concat(li).filter(Boolean) : li, Ti = yt.shouldForwardProp;
  if (ti && ii.shouldForwardProp) {
    var vi = ii.shouldForwardProp;
    if (yt.shouldForwardProp) {
      var xi = yt.shouldForwardProp;
      Ti = function(Oi, Di) {
        return vi(Oi, Di) && xi(Oi, Di);
      };
    } else Ti = vi;
  }
  var Si = new Ve$2(ir, gi, ti ? ii.componentStyle : void 0);
  function Pi(Oi, Di) {
    return (function(Mi, Oo, io) {
      var xo = Mi.attrs, fo = Mi.componentStyle, _o = Mi.defaultProps, Li = Mi.foldedComponentIds, Co = Mi.styledComponentId, Ni = Mi.target, Yi = React__default.useContext(Ze$2), Vo = Je$2(), No = Mi.shouldForwardProp || Vo.shouldForwardProp;
      process.env.NODE_ENV !== "production" && React__default.useDebugValue && React__default.useDebugValue(Co);
      var Ui = O$5(Oo, Yi, _o) || I$5, jo = (function(Ko, ca, pa) {
        for (var ga, ia = __assign(__assign({}, ca), { className: void 0, theme: pa }), ra = 0; ra < Ko.length; ra += 1) {
          var qo = re$4(ga = Ko[ra]) ? ga(ia) : ga;
          for (var xa in qo) xa === "className" ? ia.className = ie$2(ia.className, qo[xa]) : xa === "style" ? ia.style = __assign(__assign({}, ia.style), qo[xa]) : xa in ca && ca[xa] === void 0 || (ia[xa] = qo[xa]);
        }
        return "className" in ca && typeof ca.className == "string" && (ia.className = ie$2(ia.className, ca.className)), ia;
      })(xo, Oo, Ui), Wi = jo.as || Ni, ji = {};
      for (var Hi in jo) jo[Hi] === void 0 || Hi[0] === "$" || Hi === "as" || Hi === "theme" && jo.theme === Ui || (Hi === "forwardedAs" ? ji.as = jo.forwardedAs : No && !No(Hi, Wi) || (ji[Hi] = jo[Hi], No || process.env.NODE_ENV !== "development" || isPropValid$2(Hi) || nt$1.has(Hi) || !D$4.has(Wi) || (nt$1.add(Hi), console.warn('styled-components: it looks like an unknown prop "'.concat(Hi, '" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via `<StyleSheetManager shouldForwardProp={...}>` (connect an API like `@emotion/is-prop-valid`) or consider using transient props (`$` prefix for automatic filtering.)')))));
      var zo = (function(Ko, ca) {
        var pa = Je$2(), ga = Ko.generateAndInjectStyles(ca, pa.styleSheet, pa.stylis);
        return process.env.NODE_ENV !== "production" && React__default.useDebugValue && React__default.useDebugValue(ga.className), ga;
      })(fo, jo), Lo = zo.className;
      process.env.NODE_ENV !== "production" && Mi.warnTooManyClasses && Mi.warnTooManyClasses(Lo);
      var sa = ie$2(Li, Co);
      return Lo && (sa += " " + Lo), jo.className && (sa += " " + jo.className), ji[z$4(Wi) && !D$4.has(Wi) ? "class" : "className"] = sa, io && (ji.ref = io), createElement(Wi, ji);
    })($i, Oi, Di);
  }
  Pi.displayName = fi;
  var $i = React__default.forwardRef(Pi);
  return $i.attrs = mi, $i.componentStyle = Si, $i.displayName = fi, $i.shouldForwardProp = Ti, $i.foldedComponentIds = ti ? ie$2(ii.foldedComponentIds, ii.styledComponentId) : "", $i.styledComponentId = gi, $i.target = ti ? ii.target : pt, Object.defineProperty($i, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(Oi) {
    this._foldedDefaultProps = ti ? (function(Di) {
      for (var Mi = [], Oo = 1; Oo < arguments.length; Oo++) Mi[Oo - 1] = arguments[Oo];
      for (var io = 0, xo = Mi; io < xo.length; io++) ue$2(Di, xo[io], !0);
      return Di;
    })({}, ii.defaultProps, Oi) : Oi;
  } }), process.env.NODE_ENV !== "production" && (A$3(fi, gi), $i.warnTooManyClasses = /* @__PURE__ */ (function(Oi, Di) {
    var Mi = {}, Oo = !1;
    return function(io) {
      if (!Oo && (Mi[io] = !0, Object.keys(Mi).length >= 200)) {
        var xo = Di ? ' with the id of "'.concat(Di, '"') : "";
        console.warn("Over ".concat(200, " classes were generated for component ").concat(Oi).concat(xo, `.
`) + `Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), Oo = !0, Mi = {};
      }
    };
  })(fi, gi)), le$3($i, function() {
    return ".".concat($i.styledComponentId);
  }), ui && oe$3($i, pt, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0 }), $i;
}
function rt$1(pt, yt) {
  for (var ir = [pt[0]], ti = 0, ii = yt.length; ti < ii; ti += 1) ir.push(yt[ti], pt[ti + 1]);
  return ir;
}
var st$2 = function(pt) {
  return Object.assign(pt, { isCss: !0 });
};
function it$1(pt) {
  for (var yt = [], ir = 1; ir < arguments.length; ir++) yt[ir - 1] = arguments[ir];
  if (re$4(pt) || ce$3(pt)) return st$2(je$3(rt$1(P$7, __spreadArray([pt], yt, !0))));
  var ti = pt;
  return yt.length === 0 && ti.length === 1 && typeof ti[0] == "string" ? je$3(ti) : st$2(je$3(rt$1(ti, yt)));
}
function at$2(pt, yt, ir) {
  if (ir === void 0 && (ir = I$5), !yt) throw v$4(1, yt);
  var ti = function(ii) {
    for (var ui = [], ai = 1; ai < arguments.length; ai++) ui[ai - 1] = arguments[ai];
    return pt(yt, ir, it$1.apply(void 0, __spreadArray([ii], ui, !1)));
  };
  return ti.attrs = function(ii) {
    return at$2(pt, yt, __assign(__assign({}, ir), { attrs: Array.prototype.concat(ir.attrs, ii).filter(Boolean) }));
  }, ti.withConfig = function(ii) {
    return at$2(pt, yt, __assign(__assign({}, ir), ii));
  }, ti;
}
var ct$1 = function(pt) {
  return at$2(ot$2, pt);
}, ut$2 = ct$1;
D$4.forEach(function(pt) {
  ut$2[pt] = ct$1(pt);
});
process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`);
var gt$2 = "__sc-".concat(a$4, "__");
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && typeof window < "u" && (window[gt$2] || (window[gt$2] = 0), window[gt$2] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://styled-components.com/docs/faqs#why-am-i-getting-a-warning-about-several-instances-of-module-on-the-page for more info.`), window[gt$2] += 1);
var l$1;
function r$3(pt, yt) {
  return pt[yt];
}
function i$2(pt = [], yt, ir = 0) {
  return [...pt.slice(0, ir), yt, ...pt.slice(ir)];
}
function s$5(pt = [], yt, ir = "id") {
  const ti = pt.slice(), ii = r$3(yt, ir);
  return ii ? ti.splice(ti.findIndex((ui) => r$3(ui, ir) === ii), 1) : ti.splice(ti.findIndex((ui) => ui === yt), 1), ti;
}
function d$1(pt) {
  return pt.map((yt, ir) => {
    const ti = Object.assign(Object.assign({}, yt), { sortable: yt.sortable || !!yt.sortFunction || void 0 });
    return yt.id || (ti.id = ir + 1), ti;
  });
}
function c$4(pt, yt) {
  return Math.ceil(pt / yt);
}
function g$1(pt, yt) {
  return Math.min(pt, yt);
}
(function(pt) {
  pt.ASC = "asc", pt.DESC = "desc";
})(l$1 || (l$1 = {}));
const u$2 = () => null;
function p$2(pt, yt = [], ir = []) {
  let ti = {}, ii = [...ir];
  return yt.length && yt.forEach((ui) => {
    if (!ui.when || typeof ui.when != "function") throw new Error('"when" must be defined in the conditional style object and must be function');
    ui.when(pt) && (ti = ui.style || {}, ui.classNames && (ii = [...ii, ...ui.classNames]), typeof ui.style == "function" && (ti = ui.style(pt) || {}));
  }), { conditionalStyle: ti, classNames: ii.join(" ") };
}
function b$4(pt, yt = [], ir = "id") {
  const ti = r$3(pt, ir);
  return ti ? yt.some((ii) => r$3(ii, ir) === ti) : yt.some((ii) => ii === pt);
}
function m$2(pt, yt) {
  return yt ? pt.findIndex((ir) => h$2(ir.id, yt)) : -1;
}
function h$2(pt, yt) {
  return pt == yt;
}
function w$3(pt, yt) {
  const ir = !pt.toggleOnSelectedRowsChange;
  switch (yt.type) {
    case "SELECT_ALL_ROWS": {
      const { keyField: ti, rows: ii, rowCount: ui, mergeSelections: ai } = yt, li = !pt.allSelected, oi = !pt.toggleOnSelectedRowsChange;
      if (ai) {
        const si = li ? [...pt.selectedRows, ...ii.filter((di) => !b$4(di, pt.selectedRows, ti))] : pt.selectedRows.filter((di) => !b$4(di, ii, ti));
        return Object.assign(Object.assign({}, pt), { allSelected: li, selectedCount: si.length, selectedRows: si, toggleOnSelectedRowsChange: oi });
      }
      return Object.assign(Object.assign({}, pt), { allSelected: li, selectedCount: li ? ui : 0, selectedRows: li ? ii : [], toggleOnSelectedRowsChange: oi });
    }
    case "SELECT_SINGLE_ROW": {
      const { keyField: ti, row: ii, isSelected: ui, rowCount: ai, singleSelect: li } = yt;
      return li ? ui ? Object.assign(Object.assign({}, pt), { selectedCount: 0, allSelected: !1, selectedRows: [], toggleOnSelectedRowsChange: ir }) : Object.assign(Object.assign({}, pt), { selectedCount: 1, allSelected: !1, selectedRows: [ii], toggleOnSelectedRowsChange: ir }) : ui ? Object.assign(Object.assign({}, pt), { selectedCount: pt.selectedRows.length > 0 ? pt.selectedRows.length - 1 : 0, allSelected: !1, selectedRows: s$5(pt.selectedRows, ii, ti), toggleOnSelectedRowsChange: ir }) : Object.assign(Object.assign({}, pt), { selectedCount: pt.selectedRows.length + 1, allSelected: pt.selectedRows.length + 1 === ai, selectedRows: i$2(pt.selectedRows, ii), toggleOnSelectedRowsChange: ir });
    }
    case "SELECT_MULTIPLE_ROWS": {
      const { keyField: ti, selectedRows: ii, totalRows: ui, mergeSelections: ai } = yt;
      if (ai) {
        const li = [...pt.selectedRows, ...ii.filter((oi) => !b$4(oi, pt.selectedRows, ti))];
        return Object.assign(Object.assign({}, pt), { selectedCount: li.length, allSelected: !1, selectedRows: li, toggleOnSelectedRowsChange: ir });
      }
      return Object.assign(Object.assign({}, pt), { selectedCount: ii.length, allSelected: ii.length === ui, selectedRows: ii, toggleOnSelectedRowsChange: ir });
    }
    case "CLEAR_SELECTED_ROWS": {
      const { selectedRowsFlag: ti } = yt;
      return Object.assign(Object.assign({}, pt), { allSelected: !1, selectedCount: 0, selectedRows: [], selectedRowsFlag: ti });
    }
    case "SORT_CHANGE": {
      const { sortDirection: ti, selectedColumn: ii, clearSelectedOnSort: ui } = yt;
      return Object.assign(Object.assign(Object.assign({}, pt), { selectedColumn: ii, sortDirection: ti, currentPage: 1 }), ui && { allSelected: !1, selectedCount: 0, selectedRows: [], toggleOnSelectedRowsChange: ir });
    }
    case "CHANGE_PAGE": {
      const { page: ti, paginationServer: ii, visibleOnly: ui, persistSelectedOnPageChange: ai } = yt, li = ii && ai, oi = ii && !ai || ui;
      return Object.assign(Object.assign(Object.assign(Object.assign({}, pt), { currentPage: ti }), li && { allSelected: !1 }), oi && { allSelected: !1, selectedCount: 0, selectedRows: [], toggleOnSelectedRowsChange: ir });
    }
    case "CHANGE_ROWS_PER_PAGE": {
      const { rowsPerPage: ti, page: ii } = yt;
      return Object.assign(Object.assign({}, pt), { currentPage: ii, rowsPerPage: ti });
    }
  }
}
const f$3 = it$1`
	pointer-events: none;
	opacity: 0.4;
`, x$5 = ut$2.div`
	position: relative;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	max-width: 100%;
	${({ disabled: pt }) => pt && f$3};
	${({ theme: pt }) => pt.table.style};
`, C$3 = it$1`
	position: sticky;
	position: -webkit-sticky; /* Safari */
	top: 0;
	z-index: 1;
`, y$4 = ut$2.div`
	display: flex;
	width: 100%;
	${({ $fixedHeader: pt }) => pt && C$3};
	${({ theme: pt }) => pt.head.style};
`, R$3 = ut$2.div`
	display: flex;
	align-items: stretch;
	width: 100%;
	${({ theme: pt }) => pt.headRow.style};
	${({ $dense: pt, theme: yt }) => pt && yt.headRow.denseStyle};
`, v$3 = (pt, ...yt) => it$1`
		@media screen and (max-width: ${599}px) {
			${it$1(pt, ...yt)}
		}
	`, S$4 = (pt, ...yt) => it$1`
		@media screen and (max-width: ${959}px) {
			${it$1(pt, ...yt)}
		}
	`, E$1 = (pt, ...yt) => it$1`
		@media screen and (max-width: ${1280}px) {
			${it$1(pt, ...yt)}
		}
	`, O$4 = (pt) => (yt, ...ir) => it$1`
			@media screen and (max-width: ${pt}px) {
				${it$1(yt, ...ir)}
			}
		`, $$4 = ut$2.div`
	position: relative;
	display: flex;
	align-items: center;
	box-sizing: border-box;
	line-height: normal;
	${({ theme: pt, $headCell: yt }) => pt[yt ? "headCells" : "cells"].style};
	${({ $noPadding: pt }) => pt && "padding: 0"};
`, k$5 = ut$2($$4)`
	flex-grow: ${({ button: pt, grow: yt }) => yt === 0 || pt ? 0 : yt || 1};
	flex-shrink: 0;
	flex-basis: 0;
	max-width: ${({ maxWidth: pt }) => pt || "100%"};
	min-width: ${({ minWidth: pt }) => pt || "100px"};
	${({ width: pt }) => pt && it$1`
			min-width: ${pt};
			max-width: ${pt};
		`};
	${({ right: pt }) => pt && "justify-content: flex-end"};
	${({ button: pt, center: yt }) => (yt || pt) && "justify-content: center"};
	${({ compact: pt, button: yt }) => (pt || yt) && "padding: 0"};

	/* handle hiding cells */
	${({ hide: pt }) => pt && pt === "sm" && v$3`
    display: none;
  `};
	${({ hide: pt }) => pt && pt === "md" && S$4`
    display: none;
  `};
	${({ hide: pt }) => pt && pt === "lg" && E$1`
    display: none;
  `};
	${({ hide: pt }) => pt && Number.isInteger(pt) && O$4(pt)`
    display: none;
  `};
`, P$6 = it$1`
	div:first-child {
		white-space: ${({ $wrapCell: pt }) => pt ? "normal" : "nowrap"};
		overflow: ${({ $allowOverflow: pt }) => pt ? "visible" : "hidden"};
		text-overflow: ellipsis;
	}
`, D$3 = ut$2(k$5).attrs((pt) => ({ style: pt.style }))`
	${({ $renderAsCell: pt }) => !pt && P$6};
	${({ theme: pt, $isDragging: yt }) => yt && pt.cells.draggingStyle};
	${({ $cellStyle: pt }) => pt};
`;
var H$4 = React.memo(function({ id: pt, column: yt, row: ir, rowIndex: ti, dataTag: ii, isDragging: ui, onDragStart: ai, onDragOver: li, onDragEnd: oi, onDragEnter: si, onDragLeave: di }) {
  const { conditionalStyle: fi, classNames: gi } = p$2(ir, yt.conditionalCellStyles, ["rdt_TableCell"]);
  return React.createElement(D$3, { id: pt, "data-column-id": yt.id, role: "cell", className: gi, "data-tag": ii, $cellStyle: yt.style, $renderAsCell: !!yt.cell, $allowOverflow: yt.allowOverflow, button: yt.button, center: yt.center, compact: yt.compact, grow: yt.grow, hide: yt.hide, maxWidth: yt.maxWidth, minWidth: yt.minWidth, right: yt.right, width: yt.width, $wrapCell: yt.wrap, style: fi, $isDragging: ui, onDragStart: ai, onDragOver: li, onDragEnd: oi, onDragEnter: si, onDragLeave: di }, !yt.cell && React.createElement("div", { "data-tag": ii }, (function(mi, Ti, vi, xi) {
    return Ti ? vi && typeof vi == "function" ? vi(mi, xi) : Ti(mi, xi) : null;
  })(ir, yt.selector, yt.format, ti)), yt.cell && yt.cell(ir, ti, yt, pt));
});
const F$4 = "input";
var j$4 = React.memo(function({ name: pt, component: yt = F$4, componentOptions: ir = { style: {} }, indeterminate: ti = !1, checked: ii = !1, disabled: ui = !1, onClick: ai = u$2 }) {
  const li = yt, oi = li !== F$4 ? ir.style : ((di) => Object.assign(Object.assign({ fontSize: "18px" }, !di && { cursor: "pointer" }), { padding: 0, marginTop: "1px", verticalAlign: "middle", position: "relative" }))(ui), si = React.useMemo(() => (function(di, ...fi) {
    let gi;
    return Object.keys(di).map((mi) => di[mi]).forEach((mi, Ti) => {
      typeof mi == "function" && (gi = Object.assign(Object.assign({}, di), { [Object.keys(di)[Ti]]: mi(...fi) }));
    }), gi || di;
  })(ir, ti), [ir, ti]);
  return React.createElement(li, Object.assign({ type: "checkbox", ref: (di) => {
    di && (di.indeterminate = ti);
  }, style: oi, onClick: ui ? u$2 : ai, name: pt, "aria-label": pt, checked: ii, disabled: ui }, si, { onChange: u$2 }));
});
const I$4 = ut$2($$4)`
	flex: 0 0 48px;
	min-width: 48px;
	justify-content: center;
	align-items: center;
	user-select: none;
	white-space: nowrap;
`;
function T$4({ name: pt, keyField: yt, row: ir, rowCount: ti, selected: ii, selectableRowsComponent: ui, selectableRowsComponentProps: ai, selectableRowsSingle: li, selectableRowDisabled: oi, onSelectedRow: si }) {
  const di = !(!oi || !oi(ir));
  return React.createElement(I$4, { onClick: (fi) => fi.stopPropagation(), className: "rdt_TableCell", $noPadding: !0 }, React.createElement(j$4, { name: pt, component: ui, componentOptions: ai, checked: ii, "aria-checked": ii, onClick: () => {
    si({ type: "SELECT_SINGLE_ROW", row: ir, isSelected: ii, keyField: yt, rowCount: ti, singleSelect: li });
  }, disabled: di }));
}
const L$5 = ut$2.button`
	display: inline-flex;
	align-items: center;
	user-select: none;
	white-space: nowrap;
	border: none;
	background-color: transparent;
	${({ theme: pt }) => pt.expanderButton.style};
`;
function M$3({ disabled: pt = !1, expanded: yt = !1, expandableIcon: ir, id: ti, row: ii, onToggled: ui }) {
  const ai = yt ? ir.expanded : ir.collapsed;
  return React.createElement(L$5, { "aria-disabled": pt, onClick: () => ui && ui(ii), "data-testid": `expander-button-${ti}`, disabled: pt, "aria-label": yt ? "Collapse Row" : "Expand Row", role: "button", type: "button" }, ai);
}
const A$2 = ut$2($$4)`
	white-space: nowrap;
	font-weight: 400;
	min-width: 48px;
	${({ theme: pt }) => pt.expanderCell.style};
`;
function _$3({ row: pt, expanded: yt = !1, expandableIcon: ir, id: ti, onToggled: ii, disabled: ui = !1 }) {
  return React.createElement(A$2, { onClick: (ai) => ai.stopPropagation(), $noPadding: !0 }, React.createElement(M$3, { id: ti, row: pt, expanded: yt, expandableIcon: ir, disabled: ui, onToggled: ii }));
}
const N$2 = ut$2.div`
	width: 100%;
	box-sizing: border-box;
	${({ theme: pt }) => pt.expanderRow.style};
	${({ $extendedRowStyle: pt }) => pt};
`;
var z$3 = React.memo(function({ data: pt, ExpanderComponent: yt, expanderComponentProps: ir, extendedRowStyle: ti, extendedClassNames: ii }) {
  const ui = ["rdt_ExpanderRow", ...ii.split(" ").filter((ai) => ai !== "rdt_TableRow")].join(" ");
  return React.createElement(N$2, { className: ui, $extendedRowStyle: ti }, React.createElement(yt, Object.assign({ data: pt }, ir)));
});
const W$4 = "allowRowEvents";
var B$2, G$4, V$4;
(function(pt) {
  pt.LTR = "ltr", pt.RTL = "rtl", pt.AUTO = "auto";
})(B$2 || (B$2 = {})), (function(pt) {
  pt.LEFT = "left", pt.RIGHT = "right", pt.CENTER = "center";
})(G$4 || (G$4 = {})), (function(pt) {
  pt.SM = "sm", pt.MD = "md", pt.LG = "lg";
})(V$4 || (V$4 = {}));
const U$4 = it$1`
	&:hover {
		${({ $highlightOnHover: pt, theme: yt }) => pt && yt.rows.highlightOnHoverStyle};
	}
`, Y$4 = it$1`
	&:hover {
		cursor: pointer;
	}
`, K$4 = ut$2.div.attrs((pt) => ({ style: pt.style }))`
	display: flex;
	align-items: stretch;
	align-content: stretch;
	width: 100%;
	box-sizing: border-box;
	${({ theme: pt }) => pt.rows.style};
	${({ $dense: pt, theme: yt }) => pt && yt.rows.denseStyle};
	${({ $striped: pt, theme: yt }) => pt && yt.rows.stripedStyle};
	${({ $highlightOnHover: pt }) => pt && U$4};
	${({ $pointerOnHover: pt }) => pt && Y$4};
	${({ $selected: pt, theme: yt }) => pt && yt.rows.selectedHighlightStyle};
	${({ $conditionalStyle: pt }) => pt};
`;
function q$4({ columns: pt = [], conditionalRowStyles: yt = [], defaultExpanded: ir = !1, defaultExpanderDisabled: ti = !1, dense: ii = !1, expandableIcon: ui, expandableRows: ai = !1, expandableRowsComponent: li, expandableRowsComponentProps: oi, expandableRowsHideExpander: si, expandOnRowClicked: di = !1, expandOnRowDoubleClicked: fi = !1, highlightOnHover: gi = !1, id: mi, expandableInheritConditionalStyles: Ti, keyField: vi, onRowClicked: xi = u$2, onRowDoubleClicked: Si = u$2, onRowMouseEnter: Pi = u$2, onRowMouseLeave: $i = u$2, onRowExpandToggled: Oi = u$2, onSelectedRow: Di = u$2, pointerOnHover: Mi = !1, row: Oo, rowCount: io, rowIndex: xo, selectableRowDisabled: fo = null, selectableRows: _o = !1, selectableRowsComponent: Li, selectableRowsComponentProps: Co, selectableRowsHighlight: Ni = !1, selectableRowsSingle: Yi = !1, selected: Vo, striped: No = !1, draggingColumnId: Ui, onDragStart: jo, onDragOver: Wi, onDragEnd: ji, onDragEnter: Hi, onDragLeave: zo }) {
  const [Lo, sa] = React.useState(ir);
  React.useEffect(() => {
    sa(ir);
  }, [ir]);
  const Ko = React.useCallback(() => {
    sa(!Lo), Oi(!Lo, Oo);
  }, [Lo, Oi, Oo]), ca = Mi || ai && (di || fi), pa = React.useCallback((Es) => {
    Es.target.getAttribute("data-tag") === W$4 && (xi(Oo, Es), !ti && ai && di && Ko());
  }, [ti, di, ai, Ko, xi, Oo]), ga = React.useCallback((Es) => {
    Es.target.getAttribute("data-tag") === W$4 && (Si(Oo, Es), !ti && ai && fi && Ko());
  }, [ti, fi, ai, Ko, Si, Oo]), ia = React.useCallback((Es) => {
    Pi(Oo, Es);
  }, [Pi, Oo]), ra = React.useCallback((Es) => {
    $i(Oo, Es);
  }, [$i, Oo]), qo = r$3(Oo, vi), { conditionalStyle: xa, classNames: $a } = p$2(Oo, yt, ["rdt_TableRow"]), ys = Ni && Vo, Ss = Ti ? xa : {}, Xa = No && xo % 2 == 0;
  return React.createElement(React.Fragment, null, React.createElement(K$4, { id: `row-${mi}`, role: "row", $striped: Xa, $highlightOnHover: gi, $pointerOnHover: !ti && ca, $dense: ii, onClick: pa, onDoubleClick: ga, onMouseEnter: ia, onMouseLeave: ra, className: $a, $selected: ys, $conditionalStyle: xa }, _o && React.createElement(T$4, { name: `select-row-${qo}`, keyField: vi, row: Oo, rowCount: io, selected: Vo, selectableRowsComponent: Li, selectableRowsComponentProps: Co, selectableRowDisabled: fo, selectableRowsSingle: Yi, onSelectedRow: Di }), ai && !si && React.createElement(_$3, { id: qo, expandableIcon: ui, expanded: Lo, row: Oo, onToggled: Ko, disabled: ti }), pt.map((Es) => Es.omit ? null : React.createElement(H$4, { id: `cell-${Es.id}-${qo}`, key: `cell-${Es.id}-${qo}`, dataTag: Es.ignoreRowClick || Es.button ? null : W$4, column: Es, row: Oo, rowIndex: xo, isDragging: h$2(Ui, Es.id), onDragStart: jo, onDragOver: Wi, onDragEnd: ji, onDragEnter: Hi, onDragLeave: zo }))), ai && Lo && React.createElement(z$3, { key: `expander-${qo}`, data: Oo, extendedRowStyle: Ss, extendedClassNames: $a, ExpanderComponent: li, expanderComponentProps: oi }));
}
const J$4 = ut$2.span`
	padding: 2px;
	color: inherit;
	flex-grow: 0;
	flex-shrink: 0;
	${({ $sortActive: pt }) => pt ? "opacity: 1" : "opacity: 0"};
	${({ $sortDirection: pt }) => pt === "desc" && "transform: rotate(180deg)"};
`, Q$2 = ({ sortActive: pt, sortDirection: yt }) => React__default.createElement(J$4, { $sortActive: pt, $sortDirection: yt }, "▲"), X$3 = ut$2(k$5)`
	${({ button: pt }) => pt && "text-align: center"};
	${({ theme: pt, $isDragging: yt }) => yt && pt.headCells.draggingStyle};
`, Z$2 = it$1`
	cursor: pointer;
	span.__rdt_custom_sort_icon__ {
		i,
		svg {
			transform: 'translate3d(0, 0, 0)';
			${({ $sortActive: pt }) => pt ? "opacity: 1" : "opacity: 0"};
			color: inherit;
			font-size: 18px;
			height: 18px;
			width: 18px;
			backface-visibility: hidden;
			transform-style: preserve-3d;
			transition-duration: 95ms;
			transition-property: transform;
		}

		&.asc i,
		&.asc svg {
			transform: rotate(180deg);
		}
	}

	${({ $sortActive: pt }) => !pt && it$1`
			&:hover,
			&:focus {
				opacity: 0.7;

				span,
				span.__rdt_custom_sort_icon__ * {
					opacity: 0.7;
				}
			}
		`};
`, ee$2 = ut$2.div`
	display: inline-flex;
	align-items: center;
	justify-content: inherit;
	height: 100%;
	width: 100%;
	outline: none;
	user-select: none;
	overflow: hidden;
	${({ disabled: pt }) => !pt && Z$2};
`, te$3 = ut$2.div`
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
`;
var ne = React.memo(function({ column: pt, disabled: yt, draggingColumnId: ir, selectedColumn: ti = {}, sortDirection: ii, sortIcon: ui, sortServer: ai, pagination: li, paginationServer: oi, persistSelectedOnSort: si, selectableRowsVisibleOnly: di, onSort: fi, onDragStart: gi, onDragOver: mi, onDragEnd: Ti, onDragEnter: vi, onDragLeave: xi }) {
  React.useEffect(() => {
    typeof pt.selector == "string" && console.error(`Warning: ${pt.selector} is a string based column selector which has been deprecated as of v7 and will be removed in v8. Instead, use a selector function e.g. row => row[field]...`);
  }, []);
  const [Si, Pi] = React.useState(!1), $i = React.useRef(null);
  if (React.useEffect(() => {
    $i.current && Pi($i.current.scrollWidth > $i.current.clientWidth);
  }, [Si]), pt.omit) return null;
  const Oi = () => {
    if (!pt.sortable && !pt.selector) return;
    let Co = ii;
    h$2(ti.id, pt.id) && (Co = ii === l$1.ASC ? l$1.DESC : l$1.ASC), fi({ type: "SORT_CHANGE", sortDirection: Co, selectedColumn: pt, clearSelectedOnSort: li && oi && !si || ai || di });
  }, Di = (Co) => React.createElement(Q$2, { sortActive: Co, sortDirection: ii }), Mi = () => React.createElement("span", { className: [ii, "__rdt_custom_sort_icon__"].join(" ") }, ui), Oo = !(!pt.sortable || !h$2(ti.id, pt.id)), io = !pt.sortable || yt, xo = pt.sortable && !ui && !pt.right, fo = pt.sortable && !ui && pt.right, _o = pt.sortable && ui && !pt.right, Li = pt.sortable && ui && pt.right;
  return React.createElement(X$3, { "data-column-id": pt.id, className: "rdt_TableCol", $headCell: !0, allowOverflow: pt.allowOverflow, button: pt.button, compact: pt.compact, grow: pt.grow, hide: pt.hide, maxWidth: pt.maxWidth, minWidth: pt.minWidth, right: pt.right, center: pt.center, width: pt.width, draggable: pt.reorder, $isDragging: h$2(pt.id, ir), onDragStart: gi, onDragOver: mi, onDragEnd: Ti, onDragEnter: vi, onDragLeave: xi }, pt.name && React.createElement(ee$2, { "data-column-id": pt.id, "data-sort-id": pt.id, role: "columnheader", tabIndex: 0, className: "rdt_TableCol_Sortable", onClick: io ? void 0 : Oi, onKeyPress: io ? void 0 : (Co) => {
    Co.key === "Enter" && Oi();
  }, $sortActive: !io && Oo, disabled: io }, !io && Li && Mi(), !io && fo && Di(Oo), typeof pt.name == "string" ? React.createElement(te$3, { title: Si ? pt.name : void 0, ref: $i, "data-column-id": pt.id }, pt.name) : pt.name, !io && _o && Mi(), !io && xo && Di(Oo)));
});
const oe$2 = ut$2($$4)`
	flex: 0 0 48px;
	justify-content: center;
	align-items: center;
	user-select: none;
	white-space: nowrap;
	font-size: unset;
`;
function ae$2({ headCell: pt = !0, rowData: yt, keyField: ir, allSelected: ti, mergeSelections: ii, selectedRows: ui, selectableRowsComponent: ai, selectableRowsComponentProps: li, selectableRowDisabled: oi, onSelectAllRows: si }) {
  const di = ui.length > 0 && !ti, fi = oi ? yt.filter((Ti) => !oi(Ti)) : yt, gi = fi.length === 0, mi = Math.min(yt.length, fi.length);
  return React.createElement(oe$2, { className: "rdt_TableCol", $headCell: pt, $noPadding: !0 }, React.createElement(j$4, { name: "select-all-rows", component: ai, componentOptions: li, onClick: () => {
    si({ type: "SELECT_ALL_ROWS", rows: fi, rowCount: mi, mergeSelections: ii, keyField: ir });
  }, checked: ti, indeterminate: di, disabled: gi }));
}
function le$2(pt = B$2.AUTO) {
  const yt = typeof window == "object", [ir, ti] = React.useState(!1);
  return React.useEffect(() => {
    if (yt) if (pt !== "auto") ti(pt === "rtl");
    else {
      const ii = !(!window.document || !window.document.createElement), ui = document.getElementsByTagName("BODY")[0], ai = document.getElementsByTagName("HTML")[0], li = ui.dir === "rtl" || ai.dir === "rtl";
      ti(ii && li);
    }
  }, [pt, yt]), ir;
}
const re$3 = ut$2.div`
	display: flex;
	align-items: center;
	flex: 1 0 auto;
	height: 100%;
	color: ${({ theme: pt }) => pt.contextMenu.fontColor};
	font-size: ${({ theme: pt }) => pt.contextMenu.fontSize};
	font-weight: 400;
`, ie$1 = ut$2.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	flex-wrap: wrap;
`, se$2 = ut$2.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	box-sizing: inherit;
	z-index: 1;
	align-items: center;
	justify-content: space-between;
	display: flex;
	${({ $rtl: pt }) => pt && "direction: rtl"};
	${({ theme: pt }) => pt.contextMenu.style};
	${({ theme: pt, $visible: yt }) => yt && pt.contextMenu.activeStyle};
`;
function de$1({ contextMessage: pt, contextActions: yt, contextComponent: ir, selectedCount: ti, direction: ii }) {
  const ui = le$2(ii), ai = ti > 0;
  return ir ? React.createElement(se$2, { $visible: ai }, React.cloneElement(ir, { selectedCount: ti })) : React.createElement(se$2, { $visible: ai, $rtl: ui }, React.createElement(re$3, null, ((li, oi, si) => {
    if (oi === 0) return null;
    const di = oi === 1 ? li.singular : li.plural;
    return si ? `${oi} ${li.message || ""} ${di}` : `${oi} ${di} ${li.message || ""}`;
  })(pt, ti, ui)), React.createElement(ie$1, null, yt));
}
const ce$2 = ut$2.div`
	position: relative;
	box-sizing: border-box;
	overflow: hidden;
	display: flex;
	flex: 1 1 auto;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	flex-wrap: wrap;
	${({ theme: pt }) => pt.header.style}
`, ge$2 = ut$2.div`
	flex: 1 0 auto;
	color: ${({ theme: pt }) => pt.header.fontColor};
	font-size: ${({ theme: pt }) => pt.header.fontSize};
	font-weight: 400;
`, ue$1 = ut$2.div`
	flex: 1 0 auto;
	display: flex;
	align-items: center;
	justify-content: flex-end;

	> * {
		margin-left: 5px;
	}
`, pe$1 = ({ title: pt, actions: yt = null, contextMessage: ir, contextActions: ti, contextComponent: ii, selectedCount: ui, direction: ai, showMenu: li = !0 }) => React.createElement(ce$2, { className: "rdt_TableHeader", role: "heading", "aria-level": 1 }, React.createElement(ge$2, null, pt), yt && React.createElement(ue$1, null, yt), li && React.createElement(de$1, { contextMessage: ir, contextActions: ti, contextComponent: ii, direction: ai, selectedCount: ui }));
function be$2(pt, yt) {
  var ir = {};
  for (var ti in pt) Object.prototype.hasOwnProperty.call(pt, ti) && yt.indexOf(ti) < 0 && (ir[ti] = pt[ti]);
  if (pt != null && typeof Object.getOwnPropertySymbols == "function") {
    var ii = 0;
    for (ti = Object.getOwnPropertySymbols(pt); ii < ti.length; ii++) yt.indexOf(ti[ii]) < 0 && Object.prototype.propertyIsEnumerable.call(pt, ti[ii]) && (ir[ti[ii]] = pt[ti[ii]]);
  }
  return ir;
}
const me$2 = { left: "flex-start", right: "flex-end", center: "center" }, he$2 = ut$2.header`
	position: relative;
	display: flex;
	flex: 1 1 auto;
	box-sizing: border-box;
	align-items: center;
	padding: 4px 16px 4px 24px;
	width: 100%;
	justify-content: ${({ align: pt }) => me$2[pt]};
	flex-wrap: ${({ $wrapContent: pt }) => pt ? "wrap" : "nowrap"};
	${({ theme: pt }) => pt.subHeader.style}
`, we$2 = (pt) => {
  var { align: yt = "right", wrapContent: ir = !0 } = pt, ti = be$2(pt, ["align", "wrapContent"]);
  return React.createElement(he$2, Object.assign({ align: yt, $wrapContent: ir }, ti));
}, fe$2 = ut$2.div`
	display: flex;
	flex-direction: column;
`, xe$2 = ut$2.div`
	position: relative;
	width: 100%;
	border-radius: inherit;
	${({ $responsive: pt, $fixedHeader: yt }) => pt && it$1`
			overflow-x: auto;

			// hidden prevents vertical scrolling in firefox when fixedHeader is disabled
			overflow-y: ${yt ? "auto" : "hidden"};
			min-height: 0;
		`};

	${({ $fixedHeader: pt = !1, $fixedHeaderScrollHeight: yt = "100vh" }) => pt && it$1`
			max-height: ${yt};
			-webkit-overflow-scrolling: touch;
		`};

	${({ theme: pt }) => pt.responsiveWrapper.style};
`, Ce$1 = ut$2.div`
	position: relative;
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	${(pt) => pt.theme.progress.style};
`, ye$1 = ut$2.div`
	position: relative;
	width: 100%;
	${({ theme: pt }) => pt.tableWrapper.style};
`, Re$2 = ut$2($$4)`
	white-space: nowrap;
	${({ theme: pt }) => pt.expanderCell.style};
`, ve$2 = ut$2.div`
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	${({ theme: pt }) => pt.noData.style};
`, Se$2 = () => React__default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, React__default.createElement("path", { d: "M7 10l5 5 5-5z" }), React__default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })), Ee$2 = ut$2.select`
	cursor: pointer;
	height: 24px;
	max-width: 100%;
	user-select: none;
	padding-left: 8px;
	padding-right: 24px;
	box-sizing: content-box;
	font-size: inherit;
	color: inherit;
	border: none;
	background-color: transparent;
	appearance: none;
	direction: ltr;
	flex-shrink: 0;

	&::-ms-expand {
		display: none;
	}

	&:disabled::-ms-expand {
		background: #f60;
	}

	option {
		color: initial;
	}
`, Oe$2 = ut$2.div`
	position: relative;
	flex-shrink: 0;
	font-size: inherit;
	color: inherit;
	margin-top: 1px;

	svg {
		top: 0;
		right: 0;
		color: inherit;
		position: absolute;
		fill: currentColor;
		width: 24px;
		height: 24px;
		display: inline-block;
		user-select: none;
		pointer-events: none;
	}
`, $e$2 = (pt) => {
  var { defaultValue: yt, onChange: ir } = pt, ti = be$2(pt, ["defaultValue", "onChange"]);
  return React.createElement(Oe$2, null, React.createElement(Ee$2, Object.assign({ onChange: ir, defaultValue: yt }, ti)), React.createElement(Se$2, null));
}, ke$2 = { columns: [], data: [], title: "", keyField: "id", selectableRows: !1, selectableRowsHighlight: !1, selectableRowsNoSelectAll: !1, selectableRowSelected: null, selectableRowDisabled: null, selectableRowsComponent: "input", selectableRowsComponentProps: {}, selectableRowsVisibleOnly: !1, selectableRowsSingle: !1, clearSelectedRows: !1, expandableRows: !1, expandableRowDisabled: null, expandableRowExpanded: null, expandOnRowClicked: !1, expandableRowsHideExpander: !1, expandOnRowDoubleClicked: !1, expandableInheritConditionalStyles: !1, expandableRowsComponent: function() {
  return React__default.createElement("div", null, "To add an expander pass in a component instance via ", React__default.createElement("strong", null, "expandableRowsComponent"), ". You can then access props.data from this component.");
}, expandableIcon: { collapsed: React__default.createElement(() => React__default.createElement("svg", { fill: "currentColor", height: "24", viewBox: "0 0 24 24", width: "24", xmlns: "http://www.w3.org/2000/svg" }, React__default.createElement("path", { d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" }), React__default.createElement("path", { d: "M0-.25h24v24H0z", fill: "none" })), null), expanded: React__default.createElement(() => React__default.createElement("svg", { fill: "currentColor", height: "24", viewBox: "0 0 24 24", width: "24", xmlns: "http://www.w3.org/2000/svg" }, React__default.createElement("path", { d: "M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z" }), React__default.createElement("path", { d: "M0-.75h24v24H0z", fill: "none" })), null) }, expandableRowsComponentProps: {}, progressPending: !1, progressComponent: React__default.createElement("div", { style: { fontSize: "24px", fontWeight: 700, padding: "24px" } }, "Loading..."), persistTableHead: !1, sortIcon: null, sortFunction: null, sortServer: !1, striped: !1, highlightOnHover: !1, pointerOnHover: !1, noContextMenu: !1, contextMessage: { singular: "item", plural: "items", message: "selected" }, actions: null, contextActions: null, contextComponent: null, defaultSortFieldId: null, defaultSortAsc: !0, responsive: !0, noDataComponent: React__default.createElement("div", { style: { padding: "24px" } }, "There are no records to display"), disabled: !1, noTableHead: !1, noHeader: !1, subHeader: !1, subHeaderAlign: G$4.RIGHT, subHeaderWrap: !0, subHeaderComponent: null, fixedHeader: !1, fixedHeaderScrollHeight: "100vh", pagination: !1, paginationServer: !1, paginationServerOptions: { persistSelectedOnSort: !1, persistSelectedOnPageChange: !1 }, paginationDefaultPage: 1, paginationResetDefaultPage: !1, paginationTotalRows: 0, paginationPerPage: 10, paginationRowsPerPageOptions: [10, 15, 20, 25, 30], paginationComponent: null, paginationComponentOptions: {}, paginationIconFirstPage: React__default.createElement(() => React__default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", "aria-hidden": "true", role: "presentation" }, React__default.createElement("path", { d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z" }), React__default.createElement("path", { fill: "none", d: "M24 24H0V0h24v24z" })), null), paginationIconLastPage: React__default.createElement(() => React__default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", "aria-hidden": "true", role: "presentation" }, React__default.createElement("path", { d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z" }), React__default.createElement("path", { fill: "none", d: "M0 0h24v24H0V0z" })), null), paginationIconNext: React__default.createElement(() => React__default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", "aria-hidden": "true", role: "presentation" }, React__default.createElement("path", { d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" }), React__default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })), null), paginationIconPrevious: React__default.createElement(() => React__default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", "aria-hidden": "true", role: "presentation" }, React__default.createElement("path", { d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" }), React__default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })), null), dense: !1, conditionalRowStyles: [], theme: "default", customStyles: {}, direction: B$2.AUTO, onChangePage: u$2, onChangeRowsPerPage: u$2, onRowClicked: u$2, onRowDoubleClicked: u$2, onRowMouseEnter: u$2, onRowMouseLeave: u$2, onRowExpandToggled: u$2, onSelectedRowsChange: u$2, onSort: u$2, onColumnOrderChange: u$2 }, Pe$1 = { rowsPerPageText: "Rows per page:", rangeSeparatorText: "of", noRowsPerPage: !1, selectAllRowsItem: !1, selectAllRowsItemText: "All" }, De$2 = ut$2.nav`
	display: flex;
	flex: 1 1 auto;
	justify-content: flex-end;
	align-items: center;
	box-sizing: border-box;
	padding-right: 8px;
	padding-left: 8px;
	width: 100%;
	${({ theme: pt }) => pt.pagination.style};
`, He$2 = ut$2.button`
	position: relative;
	display: block;
	user-select: none;
	border: none;
	${({ theme: pt }) => pt.pagination.pageButtonsStyle};
	${({ $isRTL: pt }) => pt && "transform: scale(-1, -1)"};
`, Fe$2 = ut$2.div`
	display: flex;
	align-items: center;
	border-radius: 4px;
	white-space: nowrap;
	${v$3`
    width: 100%;
    justify-content: space-around;
  `};
`, je$2 = ut$2.span`
	flex-shrink: 1;
	user-select: none;
`, Ie$1 = ut$2(je$2)`
	margin: 0 24px;
`, Te$2 = ut$2(je$2)`
	margin: 0 4px;
`;
var Le$2 = React.memo(function({ rowsPerPage: pt, rowCount: yt, currentPage: ir, direction: ti = ke$2.direction, paginationRowsPerPageOptions: ii = ke$2.paginationRowsPerPageOptions, paginationIconLastPage: ui = ke$2.paginationIconLastPage, paginationIconFirstPage: ai = ke$2.paginationIconFirstPage, paginationIconNext: li = ke$2.paginationIconNext, paginationIconPrevious: oi = ke$2.paginationIconPrevious, paginationComponentOptions: si = ke$2.paginationComponentOptions, onChangeRowsPerPage: di = ke$2.onChangeRowsPerPage, onChangePage: fi = ke$2.onChangePage }) {
  const gi = (() => {
    const Co = typeof window == "object";
    function Ni() {
      return { width: Co ? window.innerWidth : void 0, height: Co ? window.innerHeight : void 0 };
    }
    const [Yi, Vo] = React.useState(Ni);
    return React.useEffect(() => {
      if (!Co) return () => null;
      function No() {
        Vo(Ni());
      }
      return window.addEventListener("resize", No), () => window.removeEventListener("resize", No);
    }, []), Yi;
  })(), mi = le$2(ti), Ti = gi.width && gi.width > 599, vi = c$4(yt, pt), xi = ir * pt, Si = xi - pt + 1, Pi = ir === 1, $i = ir === vi, Oi = Object.assign(Object.assign({}, Pe$1), si), Di = ir === vi ? `${Si}-${yt} ${Oi.rangeSeparatorText} ${yt}` : `${Si}-${xi} ${Oi.rangeSeparatorText} ${yt}`, Mi = React.useCallback(() => fi(ir - 1), [ir, fi]), Oo = React.useCallback(() => fi(ir + 1), [ir, fi]), io = React.useCallback(() => fi(1), [fi]), xo = React.useCallback(() => fi(c$4(yt, pt)), [fi, yt, pt]), fo = React.useCallback((Co) => di(Number(Co.target.value), ir), [ir, di]), _o = ii.map((Co) => React.createElement("option", { key: Co, value: Co }, Co));
  Oi.selectAllRowsItem && _o.push(React.createElement("option", { key: -1, value: yt }, Oi.selectAllRowsItemText));
  const Li = React.createElement($e$2, { onChange: fo, defaultValue: pt, "aria-label": Oi.rowsPerPageText }, _o);
  return React.createElement(De$2, { className: "rdt_Pagination" }, !Oi.noRowsPerPage && Ti && React.createElement(React.Fragment, null, React.createElement(Te$2, null, Oi.rowsPerPageText), Li), Ti && React.createElement(Ie$1, null, Di), React.createElement(Fe$2, null, React.createElement(He$2, { id: "pagination-first-page", type: "button", "aria-label": "First Page", "aria-disabled": Pi, onClick: io, disabled: Pi, $isRTL: mi }, ai), React.createElement(He$2, { id: "pagination-previous-page", type: "button", "aria-label": "Previous Page", "aria-disabled": Pi, onClick: Mi, disabled: Pi, $isRTL: mi }, oi), !Oi.noRowsPerPage && !Ti && Li, React.createElement(He$2, { id: "pagination-next-page", type: "button", "aria-label": "Next Page", "aria-disabled": $i, onClick: Oo, disabled: $i, $isRTL: mi }, li), React.createElement(He$2, { id: "pagination-last-page", type: "button", "aria-label": "Last Page", "aria-disabled": $i, onClick: xo, disabled: $i, $isRTL: mi }, ui)));
});
const Me$2 = (pt, yt) => {
  const ir = React.useRef(!0);
  React.useEffect(() => {
    ir.current ? ir.current = !1 : pt();
  }, yt);
};
function Ae$2(pt) {
  return pt && pt.__esModule && Object.prototype.hasOwnProperty.call(pt, "default") ? pt.default : pt;
}
var _e$2 = function(pt) {
  return /* @__PURE__ */ (function(yt) {
    return !!yt && typeof yt == "object";
  })(pt) && !(function(yt) {
    var ir = Object.prototype.toString.call(yt);
    return ir === "[object RegExp]" || ir === "[object Date]" || (function(ti) {
      return ti.$$typeof === Ne$2;
    })(yt);
  })(pt);
}, Ne$2 = typeof Symbol == "function" && Symbol.for ? Symbol.for("react.element") : 60103;
function ze$1(pt, yt) {
  return yt.clone !== !1 && yt.isMergeableObject(pt) ? Ue$2((ir = pt, Array.isArray(ir) ? [] : {}), pt, yt) : pt;
  var ir;
}
function We$2(pt, yt, ir) {
  return pt.concat(yt).map(function(ti) {
    return ze$1(ti, ir);
  });
}
function Be$2(pt) {
  return Object.keys(pt).concat((function(yt) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(yt).filter(function(ir) {
      return Object.propertyIsEnumerable.call(yt, ir);
    }) : [];
  })(pt));
}
function Ge$2(pt, yt) {
  try {
    return yt in pt;
  } catch {
    return !1;
  }
}
function Ve$1(pt, yt, ir) {
  var ti = {};
  return ir.isMergeableObject(pt) && Be$2(pt).forEach(function(ii) {
    ti[ii] = ze$1(pt[ii], ir);
  }), Be$2(yt).forEach(function(ii) {
    (function(ui, ai) {
      return Ge$2(ui, ai) && !(Object.hasOwnProperty.call(ui, ai) && Object.propertyIsEnumerable.call(ui, ai));
    })(pt, ii) || (Ge$2(pt, ii) && ir.isMergeableObject(yt[ii]) ? ti[ii] = (function(ui, ai) {
      if (!ai.customMerge) return Ue$2;
      var li = ai.customMerge(ui);
      return typeof li == "function" ? li : Ue$2;
    })(ii, ir)(pt[ii], yt[ii], ir) : ti[ii] = ze$1(yt[ii], ir));
  }), ti;
}
function Ue$2(pt, yt, ir) {
  (ir = ir || {}).arrayMerge = ir.arrayMerge || We$2, ir.isMergeableObject = ir.isMergeableObject || _e$2, ir.cloneUnlessOtherwiseSpecified = ze$1;
  var ti = Array.isArray(yt);
  return ti === Array.isArray(pt) ? ti ? ir.arrayMerge(pt, yt, ir) : Ve$1(pt, yt, ir) : ze$1(yt, ir);
}
Ue$2.all = function(pt, yt) {
  if (!Array.isArray(pt)) throw new Error("first argument should be an array");
  return pt.reduce(function(ir, ti) {
    return Ue$2(ir, ti, yt);
  }, {});
};
var Ye$2 = Ae$2(Ue$2);
const Ke$2 = { text: { primary: "rgba(0, 0, 0, 0.87)", secondary: "rgba(0, 0, 0, 0.54)", disabled: "rgba(0, 0, 0, 0.38)" }, background: { default: "#FFFFFF" }, context: { background: "#e3f2fd", text: "rgba(0, 0, 0, 0.87)" }, divider: { default: "rgba(0,0,0,.12)" }, button: { default: "rgba(0,0,0,.54)", focus: "rgba(0,0,0,.12)", hover: "rgba(0,0,0,.12)", disabled: "rgba(0, 0, 0, .18)" }, selected: { default: "#e3f2fd", text: "rgba(0, 0, 0, 0.87)" }, highlightOnHover: { default: "#EEEEEE", text: "rgba(0, 0, 0, 0.87)" }, striped: { default: "#FAFAFA", text: "rgba(0, 0, 0, 0.87)" } }, qe$2 = { default: Ke$2, light: Ke$2, dark: { text: { primary: "#FFFFFF", secondary: "rgba(255, 255, 255, 0.7)", disabled: "rgba(0,0,0,.12)" }, background: { default: "#424242" }, context: { background: "#E91E63", text: "#FFFFFF" }, divider: { default: "rgba(81, 81, 81, 1)" }, button: { default: "#FFFFFF", focus: "rgba(255, 255, 255, .54)", hover: "rgba(255, 255, 255, .12)", disabled: "rgba(255, 255, 255, .18)" }, selected: { default: "rgba(0, 0, 0, .7)", text: "#FFFFFF" }, highlightOnHover: { default: "rgba(0, 0, 0, .7)", text: "#FFFFFF" }, striped: { default: "rgba(0, 0, 0, .87)", text: "#FFFFFF" } } };
function Qe$2(pt, yt, ir, ti) {
  const [ii, ui] = React.useState(() => d$1(pt)), [ai, li] = React.useState(""), oi = React.useRef("");
  Me$2(() => {
    ui(d$1(pt));
  }, [pt]);
  const si = React.useCallback((xi) => {
    var Si, Pi, $i;
    const { attributes: Oi } = xi.target, Di = (Si = Oi.getNamedItem("data-column-id")) === null || Si === void 0 ? void 0 : Si.value;
    Di && (oi.current = (($i = (Pi = ii[m$2(ii, Di)]) === null || Pi === void 0 ? void 0 : Pi.id) === null || $i === void 0 ? void 0 : $i.toString()) || "", li(oi.current));
  }, [ii]), di = React.useCallback((xi) => {
    var Si;
    const { attributes: Pi } = xi.target, $i = (Si = Pi.getNamedItem("data-column-id")) === null || Si === void 0 ? void 0 : Si.value;
    if ($i && oi.current && $i !== oi.current) {
      const Oi = m$2(ii, oi.current), Di = m$2(ii, $i), Mi = [...ii];
      Mi[Oi] = ii[Di], Mi[Di] = ii[Oi], ui(Mi), yt(Mi);
    }
  }, [yt, ii]), fi = React.useCallback((xi) => {
    xi.preventDefault();
  }, []), gi = React.useCallback((xi) => {
    xi.preventDefault();
  }, []), mi = React.useCallback((xi) => {
    xi.preventDefault(), oi.current = "", li("");
  }, []), Ti = (function(xi = !1) {
    return xi ? l$1.ASC : l$1.DESC;
  })(ti), vi = React.useMemo(() => ii[m$2(ii, ir == null ? void 0 : ir.toString())] || {}, [ir, ii]);
  return { tableColumns: ii, draggingColumnId: ai, handleDragStart: si, handleDragEnter: di, handleDragOver: fi, handleDragLeave: gi, handleDragEnd: mi, defaultSortDirection: Ti, defaultSortColumn: vi };
}
React.memo(function(pt) {
  const { data: yt = ke$2.data, columns: ir = ke$2.columns, title: ti = ke$2.title, actions: ii = ke$2.actions, keyField: ui = ke$2.keyField, striped: ai = ke$2.striped, highlightOnHover: li = ke$2.highlightOnHover, pointerOnHover: oi = ke$2.pointerOnHover, dense: si = ke$2.dense, selectableRows: di = ke$2.selectableRows, selectableRowsSingle: fi = ke$2.selectableRowsSingle, selectableRowsHighlight: gi = ke$2.selectableRowsHighlight, selectableRowsNoSelectAll: mi = ke$2.selectableRowsNoSelectAll, selectableRowsVisibleOnly: Ti = ke$2.selectableRowsVisibleOnly, selectableRowSelected: vi = ke$2.selectableRowSelected, selectableRowDisabled: xi = ke$2.selectableRowDisabled, selectableRowsComponent: Si = ke$2.selectableRowsComponent, selectableRowsComponentProps: Pi = ke$2.selectableRowsComponentProps, onRowExpandToggled: $i = ke$2.onRowExpandToggled, onSelectedRowsChange: Oi = ke$2.onSelectedRowsChange, expandableIcon: Di = ke$2.expandableIcon, onChangeRowsPerPage: Mi = ke$2.onChangeRowsPerPage, onChangePage: Oo = ke$2.onChangePage, paginationServer: io = ke$2.paginationServer, paginationServerOptions: xo = ke$2.paginationServerOptions, paginationTotalRows: fo = ke$2.paginationTotalRows, paginationDefaultPage: _o = ke$2.paginationDefaultPage, paginationResetDefaultPage: Li = ke$2.paginationResetDefaultPage, paginationPerPage: Co = ke$2.paginationPerPage, paginationRowsPerPageOptions: Ni = ke$2.paginationRowsPerPageOptions, paginationIconLastPage: Yi = ke$2.paginationIconLastPage, paginationIconFirstPage: Vo = ke$2.paginationIconFirstPage, paginationIconNext: No = ke$2.paginationIconNext, paginationIconPrevious: Ui = ke$2.paginationIconPrevious, paginationComponent: jo = ke$2.paginationComponent, paginationComponentOptions: Wi = ke$2.paginationComponentOptions, responsive: ji = ke$2.responsive, progressPending: Hi = ke$2.progressPending, progressComponent: zo = ke$2.progressComponent, persistTableHead: Lo = ke$2.persistTableHead, noDataComponent: sa = ke$2.noDataComponent, disabled: Ko = ke$2.disabled, noTableHead: ca = ke$2.noTableHead, noHeader: pa = ke$2.noHeader, fixedHeader: ga = ke$2.fixedHeader, fixedHeaderScrollHeight: ia = ke$2.fixedHeaderScrollHeight, pagination: ra = ke$2.pagination, subHeader: qo = ke$2.subHeader, subHeaderAlign: xa = ke$2.subHeaderAlign, subHeaderWrap: $a = ke$2.subHeaderWrap, subHeaderComponent: ys = ke$2.subHeaderComponent, noContextMenu: Ss = ke$2.noContextMenu, contextMessage: Xa = ke$2.contextMessage, contextActions: Es = ke$2.contextActions, contextComponent: Rs = ke$2.contextComponent, expandableRows: La = ke$2.expandableRows, onRowClicked: Ja = ke$2.onRowClicked, onRowDoubleClicked: ja = ke$2.onRowDoubleClicked, onRowMouseEnter: Ta = ke$2.onRowMouseEnter, onRowMouseLeave: rs = ke$2.onRowMouseLeave, sortIcon: Qa = ke$2.sortIcon, onSort: Cs = ke$2.onSort, sortFunction: _a = ke$2.sortFunction, sortServer: _s = ke$2.sortServer, expandableRowsComponent: el = ke$2.expandableRowsComponent, expandableRowsComponentProps: Ps = ke$2.expandableRowsComponentProps, expandableRowDisabled: nl = ke$2.expandableRowDisabled, expandableRowsHideExpander: Vs = ke$2.expandableRowsHideExpander, expandOnRowClicked: es = ke$2.expandOnRowClicked, expandOnRowDoubleClicked: Is = ke$2.expandOnRowDoubleClicked, expandableRowExpanded: fl = ke$2.expandableRowExpanded, expandableInheritConditionalStyles: sl = ke$2.expandableInheritConditionalStyles, defaultSortFieldId: Il = ke$2.defaultSortFieldId, defaultSortAsc: Vl = ke$2.defaultSortAsc, clearSelectedRows: Bl = ke$2.clearSelectedRows, conditionalRowStyles: ql = ke$2.conditionalRowStyles, theme: xl = ke$2.theme, customStyles: Ul = ke$2.customStyles, direction: Xl = ke$2.direction, onColumnOrderChange: hu = ke$2.onColumnOrderChange, className: Tu, ariaLabel: Ku } = pt, { tableColumns: Wl, draggingColumnId: uu, handleDragStart: du, handleDragEnter: za, handleDragOver: Ya, handleDragLeave: Ws, handleDragEnd: wl, defaultSortDirection: Gl, defaultSortColumn: bl } = Qe$2(ir, hu, Il, Vl), [{ rowsPerPage: Za, currentPage: rl, selectedRows: zs, allSelected: al, selectedCount: Ol, selectedColumn: $l, sortDirection: Zl, toggleOnSelectedRowsChange: tu }, su] = React.useReducer(w$3, { allSelected: !1, selectedCount: 0, selectedRows: [], selectedColumn: bl, toggleOnSelectedRowsChange: !1, sortDirection: Gl, currentPage: _o, rowsPerPage: Co, selectedRowsFlag: !1, contextMessage: ke$2.contextMessage }), { persistSelectedOnSort: dl = !1, persistSelectedOnPageChange: Su = !1 } = xo, cu = !(!io || !Su && !dl), Ru = ra && !Hi && yt.length > 0, bu = jo || Le$2, Hu = React.useMemo(() => ((Mu = {}, sc = "default", wc = "default") => {
    const Wc = qe$2[sc] ? sc : wc;
    return Ye$2({ table: { style: { color: (Xu = qe$2[Wc]).text.primary, backgroundColor: Xu.background.default } }, tableWrapper: { style: { display: "table" } }, responsiveWrapper: { style: {} }, header: { style: { fontSize: "22px", color: Xu.text.primary, backgroundColor: Xu.background.default, minHeight: "56px", paddingLeft: "16px", paddingRight: "8px" } }, subHeader: { style: { backgroundColor: Xu.background.default, minHeight: "52px" } }, head: { style: { color: Xu.text.primary, fontSize: "12px", fontWeight: 500 } }, headRow: { style: { backgroundColor: Xu.background.default, minHeight: "52px", borderBottomWidth: "1px", borderBottomColor: Xu.divider.default, borderBottomStyle: "solid" }, denseStyle: { minHeight: "32px" } }, headCells: { style: { paddingLeft: "16px", paddingRight: "16px" }, draggingStyle: { cursor: "move" } }, contextMenu: { style: { backgroundColor: Xu.context.background, fontSize: "18px", fontWeight: 400, color: Xu.context.text, paddingLeft: "16px", paddingRight: "8px", transform: "translate3d(0, -100%, 0)", transitionDuration: "125ms", transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)", willChange: "transform" }, activeStyle: { transform: "translate3d(0, 0, 0)" } }, cells: { style: { paddingLeft: "16px", paddingRight: "16px", wordBreak: "break-word" }, draggingStyle: {} }, rows: { style: { fontSize: "13px", fontWeight: 400, color: Xu.text.primary, backgroundColor: Xu.background.default, minHeight: "48px", "&:not(:last-of-type)": { borderBottomStyle: "solid", borderBottomWidth: "1px", borderBottomColor: Xu.divider.default } }, denseStyle: { minHeight: "32px" }, selectedHighlightStyle: { "&:nth-of-type(n)": { color: Xu.selected.text, backgroundColor: Xu.selected.default, borderBottomColor: Xu.background.default } }, highlightOnHoverStyle: { color: Xu.highlightOnHover.text, backgroundColor: Xu.highlightOnHover.default, transitionDuration: "0.15s", transitionProperty: "background-color", borderBottomColor: Xu.background.default, outlineStyle: "solid", outlineWidth: "1px", outlineColor: Xu.background.default }, stripedStyle: { color: Xu.striped.text, backgroundColor: Xu.striped.default } }, expanderRow: { style: { color: Xu.text.primary, backgroundColor: Xu.background.default } }, expanderCell: { style: { flex: "0 0 48px" } }, expanderButton: { style: { color: Xu.button.default, fill: Xu.button.default, backgroundColor: "transparent", borderRadius: "2px", transition: "0.25s", height: "100%", width: "100%", "&:hover:enabled": { cursor: "pointer" }, "&:disabled": { color: Xu.button.disabled }, "&:hover:not(:disabled)": { cursor: "pointer", backgroundColor: Xu.button.hover }, "&:focus": { outline: "none", backgroundColor: Xu.button.focus }, svg: { margin: "auto" } } }, pagination: { style: { color: Xu.text.secondary, fontSize: "13px", minHeight: "56px", backgroundColor: Xu.background.default, borderTopStyle: "solid", borderTopWidth: "1px", borderTopColor: Xu.divider.default }, pageButtonsStyle: { borderRadius: "50%", height: "40px", width: "40px", padding: "8px", margin: "px", cursor: "pointer", transition: "0.4s", color: Xu.button.default, fill: Xu.button.default, backgroundColor: "transparent", "&:disabled": { cursor: "unset", color: Xu.button.disabled, fill: Xu.button.disabled }, "&:hover:not(:disabled)": { backgroundColor: Xu.button.hover }, "&:focus": { outline: "none", backgroundColor: Xu.button.focus } } }, noData: { style: { display: "flex", alignItems: "center", justifyContent: "center", color: Xu.text.primary, backgroundColor: Xu.background.default } }, progress: { style: { display: "flex", alignItems: "center", justifyContent: "center", color: Xu.text.primary, backgroundColor: Xu.background.default } } }, Mu);
    var Xu;
  })(Ul, xl), [Ul, xl]), cc = React.useMemo(() => Object.assign({}, Xl !== "auto" && { dir: Xl }), [Xl]), Tl = React.useMemo(() => {
    if (_s) return yt;
    if ($l != null && $l.sortFunction && typeof $l.sortFunction == "function") {
      const Mu = $l.sortFunction, sc = Zl === l$1.ASC ? Mu : (wc, Wc) => -1 * Mu(wc, Wc);
      return [...yt].sort(sc);
    }
    return (function(Mu, sc, wc, Wc) {
      return sc ? Wc && typeof Wc == "function" ? Wc(Mu.slice(0), sc, wc) : Mu.slice(0).sort((Xu, fd) => {
        const rd = sc(Xu), _c = sc(fd);
        if (wc === "asc") {
          if (rd < _c) return -1;
          if (rd > _c) return 1;
        }
        if (wc === "desc") {
          if (rd > _c) return -1;
          if (rd < _c) return 1;
        }
        return 0;
      }) : Mu;
    })(yt, $l == null ? void 0 : $l.selector, Zl, _a);
  }, [_s, $l, Zl, yt, _a]), Yl = React.useMemo(() => {
    if (ra && !io) {
      const Mu = rl * Za, sc = Mu - Za;
      return Tl.slice(sc, Mu);
    }
    return Tl;
  }, [rl, ra, io, Za, Tl]), Dl = React.useCallback((Mu) => {
    su(Mu);
  }, []), Cl = React.useCallback((Mu) => {
    su(Mu);
  }, []), Hl = React.useCallback((Mu) => {
    su(Mu);
  }, []), Gu = React.useCallback((Mu, sc) => Ja(Mu, sc), [Ja]), xu = React.useCallback((Mu, sc) => ja(Mu, sc), [ja]), ac = React.useCallback((Mu, sc) => Ta(Mu, sc), [Ta]), hc = React.useCallback((Mu, sc) => rs(Mu, sc), [rs]), mc = React.useCallback((Mu) => su({ type: "CHANGE_PAGE", page: Mu, paginationServer: io, visibleOnly: Ti, persistSelectedOnPageChange: Su }), [io, Su, Ti]), jc = React.useCallback((Mu) => {
    const sc = c$4(fo || Yl.length, Mu), wc = g$1(rl, sc);
    io || mc(wc), su({ type: "CHANGE_ROWS_PER_PAGE", page: wc, rowsPerPage: Mu });
  }, [rl, mc, io, fo, Yl.length]);
  if (ra && !io && Tl.length > 0 && Yl.length === 0) {
    const Mu = c$4(Tl.length, Za), sc = g$1(rl, Mu);
    mc(sc);
  }
  Me$2(() => {
    Oi({ allSelected: al, selectedCount: Ol, selectedRows: zs.slice(0) });
  }, [tu]), Me$2(() => {
    Cs($l, Zl, Tl.slice(0));
  }, [$l, Zl]), Me$2(() => {
    Oo(rl, fo || Tl.length);
  }, [rl]), Me$2(() => {
    Mi(Za, rl);
  }, [Za]), Me$2(() => {
    mc(_o);
  }, [_o, Li]), Me$2(() => {
    if (ra && io && fo > 0) {
      const Mu = c$4(fo, Za), sc = g$1(rl, Mu);
      rl !== sc && mc(sc);
    }
  }, [fo]), React.useEffect(() => {
    su({ type: "CLEAR_SELECTED_ROWS", selectedRowsFlag: Bl });
  }, [fi, Bl]), React.useEffect(() => {
    if (!vi) return;
    const Mu = Tl.filter((wc) => vi(wc)), sc = fi ? Mu.slice(0, 1) : Mu;
    su({ type: "SELECT_MULTIPLE_ROWS", keyField: ui, selectedRows: sc, totalRows: Tl.length, mergeSelections: cu });
  }, [yt, vi]);
  const iu = Ti ? Yl : Tl, yc = Su || fi || mi;
  return React.createElement(et$1, { theme: Hu }, !pa && (!!ti || !!ii) && React.createElement(pe$1, { title: ti, actions: ii, showMenu: !Ss, selectedCount: Ol, direction: Xl, contextActions: Es, contextComponent: Rs, contextMessage: Xa }), qo && React.createElement(we$2, { align: xa, wrapContent: $a }, ys), React.createElement(xe$2, Object.assign({ $responsive: ji, $fixedHeader: ga, $fixedHeaderScrollHeight: ia, className: Tu }, cc), React.createElement(ye$1, null, Hi && !Lo && React.createElement(Ce$1, null, zo), React.createElement(x$5, Object.assign({ disabled: Ko, className: "rdt_Table", role: "table" }, Ku && { "aria-label": Ku }), !ca && (!!Lo || Tl.length > 0 && !Hi) && React.createElement(y$4, { className: "rdt_TableHead", role: "rowgroup", $fixedHeader: ga }, React.createElement(R$3, { className: "rdt_TableHeadRow", role: "row", $dense: si }, di && (yc ? React.createElement($$4, { style: { flex: "0 0 48px" } }) : React.createElement(ae$2, { allSelected: al, selectedRows: zs, selectableRowsComponent: Si, selectableRowsComponentProps: Pi, selectableRowDisabled: xi, rowData: iu, keyField: ui, mergeSelections: cu, onSelectAllRows: Cl })), La && !Vs && React.createElement(Re$2, null), Wl.map((Mu) => React.createElement(ne, { key: Mu.id, column: Mu, selectedColumn: $l, disabled: Hi || Tl.length === 0, pagination: ra, paginationServer: io, persistSelectedOnSort: dl, selectableRowsVisibleOnly: Ti, sortDirection: Zl, sortIcon: Qa, sortServer: _s, onSort: Dl, onDragStart: du, onDragOver: Ya, onDragEnd: wl, onDragEnter: za, onDragLeave: Ws, draggingColumnId: uu })))), !Tl.length && !Hi && React.createElement(ve$2, null, sa), Hi && Lo && React.createElement(Ce$1, null, zo), !Hi && Tl.length > 0 && React.createElement(fe$2, { className: "rdt_TableBody", role: "rowgroup" }, Yl.map((Mu, sc) => {
    const wc = r$3(Mu, ui), Wc = (function(_c = "") {
      return typeof _c != "number" && (!_c || _c.length === 0);
    })(wc) ? sc : wc, Xu = b$4(Mu, zs, ui), fd = !!(La && fl && fl(Mu)), rd = !!(La && nl && nl(Mu));
    return React.createElement(q$4, { id: Wc, key: Wc, keyField: ui, "data-row-id": Wc, columns: Wl, row: Mu, rowCount: Tl.length, rowIndex: sc, selectableRows: di, expandableRows: La, expandableIcon: Di, highlightOnHover: li, pointerOnHover: oi, dense: si, expandOnRowClicked: es, expandOnRowDoubleClicked: Is, expandableRowsComponent: el, expandableRowsComponentProps: Ps, expandableRowsHideExpander: Vs, defaultExpanderDisabled: rd, defaultExpanded: fd, expandableInheritConditionalStyles: sl, conditionalRowStyles: ql, selected: Xu, selectableRowsHighlight: gi, selectableRowsComponent: Si, selectableRowsComponentProps: Pi, selectableRowDisabled: xi, selectableRowsSingle: fi, striped: ai, onRowExpandToggled: $i, onRowClicked: Gu, onRowDoubleClicked: xu, onRowMouseEnter: ac, onRowMouseLeave: hc, onSelectedRow: Hl, draggingColumnId: uu, onDragStart: du, onDragOver: Ya, onDragEnd: wl, onDragEnter: za, onDragLeave: Ws });
  }))))), Ru && React.createElement("div", null, React.createElement(bu, { onChangePage: mc, onChangeRowsPerPage: jc, rowCount: fo || Tl.length, currentPage: rl, rowsPerPage: Za, direction: Xl, paginationRowsPerPageOptions: Ni, paginationIconLastPage: Yi, paginationIconFirstPage: Vo, paginationIconNext: No, paginationIconPrevious: Ui, paginationComponentOptions: Wi })));
});
var reactIs$3 = { exports: {} }, reactIs_production$2 = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production$2;
function requireReactIs_production$2() {
  if (hasRequiredReactIs_production$2) return reactIs_production$2;
  hasRequiredReactIs_production$2 = 1;
  var pt = Symbol.for("react.transitional.element"), yt = Symbol.for("react.portal"), ir = Symbol.for("react.fragment"), ti = Symbol.for("react.strict_mode"), ii = Symbol.for("react.profiler"), ui = Symbol.for("react.consumer"), ai = Symbol.for("react.context"), li = Symbol.for("react.forward_ref"), oi = Symbol.for("react.suspense"), si = Symbol.for("react.suspense_list"), di = Symbol.for("react.memo"), fi = Symbol.for("react.lazy"), gi = Symbol.for("react.view_transition"), mi = Symbol.for("react.client.reference");
  function Ti(vi) {
    if (typeof vi == "object" && vi !== null) {
      var xi = vi.$$typeof;
      switch (xi) {
        case pt:
          switch (vi = vi.type, vi) {
            case ir:
            case ii:
            case ti:
            case oi:
            case si:
            case gi:
              return vi;
            default:
              switch (vi = vi && vi.$$typeof, vi) {
                case ai:
                case li:
                case fi:
                case di:
                  return vi;
                case ui:
                  return vi;
                default:
                  return xi;
              }
          }
        case yt:
          return xi;
      }
    }
  }
  return reactIs_production$2.ContextConsumer = ui, reactIs_production$2.ContextProvider = ai, reactIs_production$2.Element = pt, reactIs_production$2.ForwardRef = li, reactIs_production$2.Fragment = ir, reactIs_production$2.Lazy = fi, reactIs_production$2.Memo = di, reactIs_production$2.Portal = yt, reactIs_production$2.Profiler = ii, reactIs_production$2.StrictMode = ti, reactIs_production$2.Suspense = oi, reactIs_production$2.SuspenseList = si, reactIs_production$2.isContextConsumer = function(vi) {
    return Ti(vi) === ui;
  }, reactIs_production$2.isContextProvider = function(vi) {
    return Ti(vi) === ai;
  }, reactIs_production$2.isElement = function(vi) {
    return typeof vi == "object" && vi !== null && vi.$$typeof === pt;
  }, reactIs_production$2.isForwardRef = function(vi) {
    return Ti(vi) === li;
  }, reactIs_production$2.isFragment = function(vi) {
    return Ti(vi) === ir;
  }, reactIs_production$2.isLazy = function(vi) {
    return Ti(vi) === fi;
  }, reactIs_production$2.isMemo = function(vi) {
    return Ti(vi) === di;
  }, reactIs_production$2.isPortal = function(vi) {
    return Ti(vi) === yt;
  }, reactIs_production$2.isProfiler = function(vi) {
    return Ti(vi) === ii;
  }, reactIs_production$2.isStrictMode = function(vi) {
    return Ti(vi) === ti;
  }, reactIs_production$2.isSuspense = function(vi) {
    return Ti(vi) === oi;
  }, reactIs_production$2.isSuspenseList = function(vi) {
    return Ti(vi) === si;
  }, reactIs_production$2.isValidElementType = function(vi) {
    return typeof vi == "string" || typeof vi == "function" || vi === ir || vi === ii || vi === ti || vi === oi || vi === si || typeof vi == "object" && vi !== null && (vi.$$typeof === fi || vi.$$typeof === di || vi.$$typeof === ai || vi.$$typeof === ui || vi.$$typeof === li || vi.$$typeof === mi || vi.getModuleId !== void 0);
  }, reactIs_production$2.typeOf = Ti, reactIs_production$2;
}
var reactIs_development$3 = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development$3;
function requireReactIs_development$3() {
  return hasRequiredReactIs_development$3 || (hasRequiredReactIs_development$3 = 1, process.env.NODE_ENV !== "production" && (function() {
    function pt(vi) {
      if (typeof vi == "object" && vi !== null) {
        var xi = vi.$$typeof;
        switch (xi) {
          case yt:
            switch (vi = vi.type, vi) {
              case ti:
              case ui:
              case ii:
              case si:
              case di:
              case mi:
                return vi;
              default:
                switch (vi = vi && vi.$$typeof, vi) {
                  case li:
                  case oi:
                  case gi:
                  case fi:
                    return vi;
                  case ai:
                    return vi;
                  default:
                    return xi;
                }
            }
          case ir:
            return xi;
        }
      }
    }
    var yt = Symbol.for("react.transitional.element"), ir = Symbol.for("react.portal"), ti = Symbol.for("react.fragment"), ii = Symbol.for("react.strict_mode"), ui = Symbol.for("react.profiler"), ai = Symbol.for("react.consumer"), li = Symbol.for("react.context"), oi = Symbol.for("react.forward_ref"), si = Symbol.for("react.suspense"), di = Symbol.for("react.suspense_list"), fi = Symbol.for("react.memo"), gi = Symbol.for("react.lazy"), mi = Symbol.for("react.view_transition"), Ti = Symbol.for("react.client.reference");
    reactIs_development$3.ContextConsumer = ai, reactIs_development$3.ContextProvider = li, reactIs_development$3.Element = yt, reactIs_development$3.ForwardRef = oi, reactIs_development$3.Fragment = ti, reactIs_development$3.Lazy = gi, reactIs_development$3.Memo = fi, reactIs_development$3.Portal = ir, reactIs_development$3.Profiler = ui, reactIs_development$3.StrictMode = ii, reactIs_development$3.Suspense = si, reactIs_development$3.SuspenseList = di, reactIs_development$3.isContextConsumer = function(vi) {
      return pt(vi) === ai;
    }, reactIs_development$3.isContextProvider = function(vi) {
      return pt(vi) === li;
    }, reactIs_development$3.isElement = function(vi) {
      return typeof vi == "object" && vi !== null && vi.$$typeof === yt;
    }, reactIs_development$3.isForwardRef = function(vi) {
      return pt(vi) === oi;
    }, reactIs_development$3.isFragment = function(vi) {
      return pt(vi) === ti;
    }, reactIs_development$3.isLazy = function(vi) {
      return pt(vi) === gi;
    }, reactIs_development$3.isMemo = function(vi) {
      return pt(vi) === fi;
    }, reactIs_development$3.isPortal = function(vi) {
      return pt(vi) === ir;
    }, reactIs_development$3.isProfiler = function(vi) {
      return pt(vi) === ui;
    }, reactIs_development$3.isStrictMode = function(vi) {
      return pt(vi) === ii;
    }, reactIs_development$3.isSuspense = function(vi) {
      return pt(vi) === si;
    }, reactIs_development$3.isSuspenseList = function(vi) {
      return pt(vi) === di;
    }, reactIs_development$3.isValidElementType = function(vi) {
      return typeof vi == "string" || typeof vi == "function" || vi === ti || vi === ui || vi === ii || vi === si || vi === di || typeof vi == "object" && vi !== null && (vi.$$typeof === gi || vi.$$typeof === fi || vi.$$typeof === li || vi.$$typeof === ai || vi.$$typeof === oi || vi.$$typeof === Ti || vi.getModuleId !== void 0);
    }, reactIs_development$3.typeOf = pt;
  })()), reactIs_development$3;
}
var hasRequiredReactIs$3;
function requireReactIs$3() {
  return hasRequiredReactIs$3 || (hasRequiredReactIs$3 = 1, process.env.NODE_ENV === "production" ? reactIs$3.exports = /* @__PURE__ */ requireReactIs_production$2() : reactIs$3.exports = /* @__PURE__ */ requireReactIs_development$3()), reactIs$3.exports;
}
var reactIsExports$1 = /* @__PURE__ */ requireReactIs$3();
const reflow$1 = (pt) => pt.scrollTop;
function getTransitionProps$1(pt, yt) {
  const {
    timeout: ir,
    easing: ti,
    style: ii = {}
  } = pt;
  return {
    duration: ii.transitionDuration ?? (typeof ir == "number" ? ir : ir[yt.mode] || 0),
    easing: ii.transitionTimingFunction ?? (typeof ti == "object" ? ti[yt.mode] : ti),
    delay: ii.transitionDelay
  };
}
function getTypeByValue$1(pt) {
  const yt = typeof pt;
  switch (yt) {
    case "number":
      return Number.isNaN(pt) ? "NaN" : Number.isFinite(pt) ? pt !== Math.floor(pt) ? "float" : "number" : "Infinity";
    case "object":
      return pt === null ? "null" : pt.constructor.name;
    default:
      return yt;
  }
}
function requiredInteger$1(pt, yt, ir, ti) {
  const ii = pt[yt];
  if (ii == null || !Number.isInteger(ii)) {
    const ui = getTypeByValue$1(ii);
    return new RangeError(`Invalid ${ti} \`${yt}\` of type \`${ui}\` supplied to \`${ir}\`, expected \`integer\`.`);
  }
  return null;
}
function validator$1(pt, yt, ir, ti) {
  return pt[yt] === void 0 ? null : requiredInteger$1(pt, yt, ir, ti);
}
function validatorNoop$1() {
  return null;
}
validator$1.isRequired = requiredInteger$1;
validatorNoop$1.isRequired = validatorNoop$1;
const integerPropType$1 = process.env.NODE_ENV === "production" ? validatorNoop$1 : validator$1;
function getPaperUtilityClass$1(pt) {
  return generateUtilityClass$2("MuiPaper", pt);
}
generateUtilityClasses$2("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const useUtilityClasses$p = (pt) => {
  const {
    square: yt,
    elevation: ir,
    variant: ti,
    classes: ii
  } = pt, ui = {
    root: ["root", ti, !yt && "rounded", ti === "elevation" && `elevation${ir}`]
  };
  return composeClasses$2(ui, getPaperUtilityClass$1, ii);
}, PaperRoot$1 = styled$3("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (pt, yt) => {
    const {
      ownerState: ir
    } = pt;
    return [yt.root, yt[ir.variant], !ir.square && yt.rounded, ir.variant === "elevation" && yt[`elevation${ir.elevation}`]];
  }
})(memoTheme$1(({
  theme: pt
}) => ({
  backgroundColor: (pt.vars || pt).palette.background.paper,
  color: (pt.vars || pt).palette.text.primary,
  transition: pt.transitions.create("box-shadow"),
  variants: [{
    props: ({
      ownerState: yt
    }) => !yt.square,
    style: {
      borderRadius: pt.shape.borderRadius
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      border: `1px solid ${(pt.vars || pt).palette.divider}`
    }
  }, {
    props: {
      variant: "elevation"
    },
    style: {
      boxShadow: "var(--Paper-shadow)",
      backgroundImage: "var(--Paper-overlay)"
    }
  }]
}))), Paper$1 = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  var ir;
  const ti = useDefaultProps$2({
    props: pt,
    name: "MuiPaper"
  }), ii = useTheme$3(), {
    className: ui,
    component: ai = "div",
    elevation: li = 1,
    square: oi = !1,
    variant: si = "elevation",
    ...di
  } = ti, fi = {
    ...ti,
    component: ai,
    elevation: li,
    square: oi,
    variant: si
  }, gi = useUtilityClasses$p(fi);
  return process.env.NODE_ENV !== "production" && ii.shadows[li] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${li}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${li}]\` is defined.`].join(`
`)), /* @__PURE__ */ jsxRuntimeExports.jsx(PaperRoot$1, {
    as: ai,
    ownerState: fi,
    className: clsx$1(gi.root, ui),
    ref: yt,
    ...di,
    style: {
      ...si === "elevation" && {
        "--Paper-shadow": (ii.vars || ii).shadows[li],
        ...ii.vars && {
          "--Paper-overlay": (ir = ii.vars.overlays) == null ? void 0 : ir[li]
        },
        ...!ii.vars && ii.palette.mode === "dark" && {
          "--Paper-overlay": `linear-gradient(${alpha$1("#fff", getOverlayAlpha$1(li))}, ${alpha$1("#fff", getOverlayAlpha$1(li))})`
        }
      },
      ...di.style
    }
  });
});
process.env.NODE_ENV !== "production" && (Paper$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: chainPropTypes$2(integerPropType$1, (pt) => {
    const {
      elevation: yt,
      variant: ir
    } = pt;
    return yt > 0 && ir === "outlined" ? new Error(`MUI: Combining \`elevation={${yt}}\` with \`variant="${ir}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: PropTypes.bool,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["elevation", "outlined"]), PropTypes.string])
});
function getCircularProgressUtilityClass(pt) {
  return generateUtilityClass$2("MuiCircularProgress", pt);
}
generateUtilityClasses$2("MuiCircularProgress", ["root", "determinate", "indeterminate", "colorPrimary", "colorSecondary", "svg", "track", "circle", "circleDeterminate", "circleIndeterminate", "circleDisableShrink"]);
const SIZE$1 = 44, circularRotateKeyframe = keyframes$1`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`, circularDashKeyframe = keyframes$1`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`, rotateAnimation = typeof circularRotateKeyframe != "string" ? css$1`
        animation: ${circularRotateKeyframe} 1.4s linear infinite;
      ` : null, dashAnimation = typeof circularDashKeyframe != "string" ? css$1`
        animation: ${circularDashKeyframe} 1.4s ease-in-out infinite;
      ` : null, useUtilityClasses$o = (pt) => {
  const {
    classes: yt,
    variant: ir,
    color: ti,
    disableShrink: ii
  } = pt, ui = {
    root: ["root", ir, `color${capitalize$1(ti)}`],
    svg: ["svg"],
    track: ["track"],
    circle: ["circle", `circle${capitalize$1(ir)}`, ii && "circleDisableShrink"]
  };
  return composeClasses$2(ui, getCircularProgressUtilityClass, yt);
}, CircularProgressRoot = styled$3("span", {
  name: "MuiCircularProgress",
  slot: "Root",
  overridesResolver: (pt, yt) => {
    const {
      ownerState: ir
    } = pt;
    return [yt.root, yt[ir.variant], yt[`color${capitalize$1(ir.color)}`]];
  }
})(memoTheme$1(({
  theme: pt
}) => ({
  display: "inline-block",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: pt.transitions.create("transform")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: rotateAnimation || {
      animation: `${circularRotateKeyframe} 1.4s linear infinite`
    }
  }, ...Object.entries(pt.palette).filter(createSimplePaletteValueFilter$1()).map(([yt]) => ({
    props: {
      color: yt
    },
    style: {
      color: (pt.vars || pt).palette[yt].main
    }
  }))]
}))), CircularProgressSVG = styled$3("svg", {
  name: "MuiCircularProgress",
  slot: "Svg"
})({
  display: "block"
  // Keeps the progress centered
}), CircularProgressCircle = styled$3("circle", {
  name: "MuiCircularProgress",
  slot: "Circle",
  overridesResolver: (pt, yt) => {
    const {
      ownerState: ir
    } = pt;
    return [yt.circle, yt[`circle${capitalize$1(ir.variant)}`], ir.disableShrink && yt.circleDisableShrink];
  }
})(memoTheme$1(({
  theme: pt
}) => ({
  stroke: "currentColor",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: pt.transitions.create("stroke-dashoffset")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: {
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: "80px, 200px",
      strokeDashoffset: 0
      // Add the unit to fix a Edge 16 and below bug.
    }
  }, {
    props: ({
      ownerState: yt
    }) => yt.variant === "indeterminate" && !yt.disableShrink,
    style: dashAnimation || {
      // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
      animation: `${circularDashKeyframe} 1.4s ease-in-out infinite`
    }
  }]
}))), CircularProgressTrack = styled$3("circle", {
  name: "MuiCircularProgress",
  slot: "Track"
})(memoTheme$1(({
  theme: pt
}) => ({
  stroke: "currentColor",
  opacity: (pt.vars || pt).palette.action.activatedOpacity
}))), CircularProgress = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const ir = useDefaultProps$2({
    props: pt,
    name: "MuiCircularProgress"
  }), {
    className: ti,
    color: ii = "primary",
    disableShrink: ui = !1,
    enableTrackSlot: ai = !1,
    size: li = 40,
    style: oi,
    thickness: si = 3.6,
    value: di = 0,
    variant: fi = "indeterminate",
    ...gi
  } = ir, mi = {
    ...ir,
    color: ii,
    disableShrink: ui,
    size: li,
    thickness: si,
    value: di,
    variant: fi,
    enableTrackSlot: ai
  }, Ti = useUtilityClasses$o(mi), vi = {}, xi = {}, Si = {};
  if (fi === "determinate") {
    const Pi = 2 * Math.PI * ((SIZE$1 - si) / 2);
    vi.strokeDasharray = Pi.toFixed(3), Si["aria-valuenow"] = Math.round(di), vi.strokeDashoffset = `${((100 - di) / 100 * Pi).toFixed(3)}px`, xi.transform = "rotate(-90deg)";
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgressRoot, {
    className: clsx$1(Ti.root, ti),
    style: {
      width: li,
      height: li,
      ...xi,
      ...oi
    },
    ownerState: mi,
    ref: yt,
    role: "progressbar",
    ...Si,
    ...gi,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(CircularProgressSVG, {
      className: Ti.svg,
      ownerState: mi,
      viewBox: `${SIZE$1 / 2} ${SIZE$1 / 2} ${SIZE$1} ${SIZE$1}`,
      children: [ai ? /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgressTrack, {
        className: Ti.track,
        ownerState: mi,
        cx: SIZE$1,
        cy: SIZE$1,
        r: (SIZE$1 - si) / 2,
        fill: "none",
        strokeWidth: si,
        "aria-hidden": "true"
      }) : null, /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgressCircle, {
        className: Ti.circle,
        style: vi,
        ownerState: mi,
        cx: SIZE$1,
        cy: SIZE$1,
        r: (SIZE$1 - si) / 2,
        fill: "none",
        strokeWidth: si
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (CircularProgress.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */
  disableShrink: chainPropTypes$2(PropTypes.bool, (pt) => pt.disableShrink && pt.variant && pt.variant !== "indeterminate" ? new Error("MUI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.") : null),
  /**
   * If `true`, a track circle slot is mounted to show a subtle background for the progress.
   * The `size` and `thickness` apply to the track slot to be consistent with the progress circle.
   * @default false
   */
  enableTrackSlot: PropTypes.bool,
  /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, for example '3rem'.
   * @default 40
   */
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The thickness of the circle.
   * @default 3.6
   */
  thickness: PropTypes.number,
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: PropTypes.number,
  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */
  variant: PropTypes.oneOf(["determinate", "indeterminate"])
});
function getIconButtonUtilityClass(pt) {
  return generateUtilityClass$2("MuiIconButton", pt);
}
const iconButtonClasses = generateUtilityClasses$2("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge", "loading", "loadingIndicator", "loadingWrapper"]), useUtilityClasses$n = (pt) => {
  const {
    classes: yt,
    disabled: ir,
    color: ti,
    edge: ii,
    size: ui,
    loading: ai
  } = pt, li = {
    root: ["root", ai && "loading", ir && "disabled", ti !== "default" && `color${capitalize$1(ti)}`, ii && `edge${capitalize$1(ii)}`, `size${capitalize$1(ui)}`],
    loadingIndicator: ["loadingIndicator"],
    loadingWrapper: ["loadingWrapper"]
  };
  return composeClasses$2(li, getIconButtonUtilityClass, yt);
}, IconButtonRoot = styled$3(ButtonBase$1, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (pt, yt) => {
    const {
      ownerState: ir
    } = pt;
    return [yt.root, ir.loading && yt.loading, ir.color !== "default" && yt[`color${capitalize$1(ir.color)}`], ir.edge && yt[`edge${capitalize$1(ir.edge)}`], yt[`size${capitalize$1(ir.size)}`]];
  }
})(memoTheme$1(({
  theme: pt
}) => ({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: pt.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  color: (pt.vars || pt).palette.action.active,
  transition: pt.transitions.create("background-color", {
    duration: pt.transitions.duration.shortest
  }),
  variants: [{
    props: (yt) => !yt.disableRipple,
    style: {
      "--IconButton-hoverBg": pt.alpha((pt.vars || pt).palette.action.active, (pt.vars || pt).palette.action.hoverOpacity),
      "&:hover": {
        backgroundColor: "var(--IconButton-hoverBg)",
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }, {
    props: {
      edge: "start"
    },
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: {
      edge: "end"
    },
    style: {
      marginRight: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }]
})), memoTheme$1(({
  theme: pt
}) => ({
  variants: [{
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }, ...Object.entries(pt.palette).filter(createSimplePaletteValueFilter$1()).map(([yt]) => ({
    props: {
      color: yt
    },
    style: {
      color: (pt.vars || pt).palette[yt].main
    }
  })), ...Object.entries(pt.palette).filter(createSimplePaletteValueFilter$1()).map(([yt]) => ({
    props: {
      color: yt
    },
    style: {
      "--IconButton-hoverBg": pt.alpha((pt.vars || pt).palette[yt].main, (pt.vars || pt).palette.action.hoverOpacity)
    }
  })), {
    props: {
      size: "small"
    },
    style: {
      padding: 5,
      fontSize: pt.typography.pxToRem(18)
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      padding: 12,
      fontSize: pt.typography.pxToRem(28)
    }
  }],
  [`&.${iconButtonClasses.disabled}`]: {
    backgroundColor: "transparent",
    color: (pt.vars || pt).palette.action.disabled
  },
  [`&.${iconButtonClasses.loading}`]: {
    color: "transparent"
  }
}))), IconButtonLoadingIndicator = styled$3("span", {
  name: "MuiIconButton",
  slot: "LoadingIndicator"
})(({
  theme: pt
}) => ({
  display: "none",
  position: "absolute",
  visibility: "visible",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  color: (pt.vars || pt).palette.action.disabled,
  variants: [{
    props: {
      loading: !0
    },
    style: {
      display: "flex"
    }
  }]
})), IconButton = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const ir = useDefaultProps$2({
    props: pt,
    name: "MuiIconButton"
  }), {
    edge: ti = !1,
    children: ii,
    className: ui,
    color: ai = "default",
    disabled: li = !1,
    disableFocusRipple: oi = !1,
    size: si = "medium",
    id: di,
    loading: fi = null,
    loadingIndicator: gi,
    ...mi
  } = ir, Ti = useId$1(di), vi = gi ?? /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgress, {
    "aria-labelledby": Ti,
    color: "inherit",
    size: 16
  }), xi = {
    ...ir,
    edge: ti,
    color: ai,
    disabled: li,
    disableFocusRipple: oi,
    loading: fi,
    loadingIndicator: vi,
    size: si
  }, Si = useUtilityClasses$n(xi);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(IconButtonRoot, {
    id: fi ? Ti : di,
    className: clsx$1(Si.root, ui),
    centerRipple: !0,
    focusRipple: !oi,
    disabled: li || fi,
    ref: yt,
    ...mi,
    ownerState: xi,
    children: [typeof fi == "boolean" && // use plain HTML span to minimize the runtime overhead
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      className: Si.loadingWrapper,
      style: {
        display: "contents"
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconButtonLoadingIndicator, {
        className: Si.loadingIndicator,
        ownerState: xi,
        children: fi && vi
      })
    }), ii]
  });
});
process.env.NODE_ENV !== "production" && (IconButton.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The icon to display.
   */
  children: chainPropTypes$2(PropTypes.node, (pt) => React.Children.toArray(pt.children).some((yt) => /* @__PURE__ */ React.isValidElement(yt) && yt.props.onClick) ? new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join(`
`)) : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: PropTypes.oneOf(["end", "start", !1]),
  /**
   * @ignore
   */
  id: PropTypes.string,
  /**
   * If `true`, the loading indicator is visible and the button is disabled.
   * If `true | false`, the loading wrapper is always rendered before the children to prevent [Google Translation Crash](https://github.com/mui/material-ui/issues/27853).
   * @default null
   */
  loading: PropTypes.bool,
  /**
   * Element placed before the children if the button is in loading state.
   * The node should contain an element with `role="progressbar"` with an accessible name.
   * By default, it renders a `CircularProgress` that is labeled by the button itself.
   * @default <CircularProgress color="inherit" size={16} />
   */
  loadingIndicator: PropTypes.node,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["small", "medium", "large"]), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function usePreviousProps(pt) {
  const yt = React.useRef({});
  return React.useEffect(() => {
    yt.current = pt;
  }), yt.current;
}
function HTMLElementType$2(pt, yt, ir, ti, ii) {
  if (process.env.NODE_ENV === "production")
    return null;
  const ui = pt[yt], ai = ii || yt;
  return ui == null ? null : ui && ui.nodeType !== 1 ? new Error(`Invalid ${ti} \`${ai}\` supplied to \`${ir}\`. Expected an HTMLElement.`) : null;
}
function useSlotProps$2(pt) {
  var yt;
  const {
    elementType: ir,
    externalSlotProps: ti,
    ownerState: ii,
    skipResolvingSlotProps: ui = !1,
    ...ai
  } = pt, li = ui ? {} : resolveComponentProps$2(ti, ii), {
    props: oi,
    internalRef: si
  } = mergeSlotProps$1$1({
    ...ai,
    externalSlotProps: li
  }), di = useForkRef$2(si, li == null ? void 0 : li.ref, (yt = pt.additionalProps) == null ? void 0 : yt.ref);
  return appendOwnerState$2(ir, {
    ...oi,
    ref: di
  }, ii);
}
function isLayoutSupported$1() {
  return !(/jsdom|HappyDOM/.test(window.navigator.userAgent) || // TODO(v9): Remove the test environment check
  // eslint-disable-next-line mui/consistent-production-guard
  process.env.NODE_ENV === "test");
}
function getReactElementRef$2(pt) {
  var yt;
  return parseInt(React.version, 10) >= 19 ? ((yt = pt == null ? void 0 : pt.props) == null ? void 0 : yt.ref) || null : (pt == null ? void 0 : pt.ref) || null;
}
function getContainer$1$1(pt) {
  return typeof pt == "function" ? pt() : pt;
}
const Portal$2 = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const {
    children: ir,
    container: ti,
    disablePortal: ii = !1
  } = pt, [ui, ai] = React.useState(null), li = useForkRef$2(/* @__PURE__ */ React.isValidElement(ir) ? getReactElementRef$2(ir) : null, yt);
  if (useEnhancedEffect$2(() => {
    ii || ai(getContainer$1$1(ti) || document.body);
  }, [ti, ii]), useEnhancedEffect$2(() => {
    if (ui && !ii)
      return setRef$2(yt, ui), () => {
        setRef$2(yt, null);
      };
  }, [yt, ui, ii]), ii) {
    if (/* @__PURE__ */ React.isValidElement(ir)) {
      const oi = {
        ref: li
      };
      return /* @__PURE__ */ React.cloneElement(ir, oi);
    }
    return ir;
  }
  return ui && /* @__PURE__ */ ReactDOM.createPortal(ir, ui);
});
process.env.NODE_ENV !== "production" && (Portal$2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: PropTypes.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType$2, PropTypes.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool
});
process.env.NODE_ENV !== "production" && (Portal$2.propTypes = exactProp$2(Portal$2.propTypes));
function getStyleValue$2(pt) {
  return parseInt(pt, 10) || 0;
}
const styles$2 = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
};
function isObjectEmpty$3(pt) {
  for (const yt in pt)
    return !1;
  return !0;
}
function isEmpty$1(pt) {
  return isObjectEmpty$3(pt) || pt.outerHeightStyle === 0 && !pt.overflowing;
}
const TextareaAutosize = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const {
    onChange: ir,
    maxRows: ti,
    minRows: ii = 1,
    style: ui,
    value: ai,
    ...li
  } = pt, {
    current: oi
  } = React.useRef(ai != null), si = React.useRef(null), di = useForkRef$2(yt, si), fi = React.useRef(null), gi = React.useRef(null), mi = React.useCallback(() => {
    const Pi = si.current, $i = gi.current;
    if (!Pi || !$i)
      return;
    const Oi = ownerWindow$2(Pi).getComputedStyle(Pi);
    if (Oi.width === "0px")
      return {
        outerHeightStyle: 0,
        overflowing: !1
      };
    $i.style.width = Oi.width, $i.value = Pi.value || pt.placeholder || "x", $i.value.slice(-1) === `
` && ($i.value += " ");
    const Di = Oi.boxSizing, Mi = getStyleValue$2(Oi.paddingBottom) + getStyleValue$2(Oi.paddingTop), Oo = getStyleValue$2(Oi.borderBottomWidth) + getStyleValue$2(Oi.borderTopWidth), io = $i.scrollHeight;
    $i.value = "x";
    const xo = $i.scrollHeight;
    let fo = io;
    ii && (fo = Math.max(Number(ii) * xo, fo)), ti && (fo = Math.min(Number(ti) * xo, fo)), fo = Math.max(fo, xo);
    const _o = fo + (Di === "border-box" ? Mi + Oo : 0), Li = Math.abs(fo - io) <= 1;
    return {
      outerHeightStyle: _o,
      overflowing: Li
    };
  }, [ti, ii, pt.placeholder]), Ti = useEventCallback$2(() => {
    const Pi = si.current, $i = mi();
    if (!Pi || !$i || isEmpty$1($i))
      return !1;
    const Oi = $i.outerHeightStyle;
    return fi.current != null && fi.current !== Oi;
  }), vi = React.useCallback(() => {
    const Pi = si.current, $i = mi();
    if (!Pi || !$i || isEmpty$1($i))
      return;
    const Oi = $i.outerHeightStyle;
    fi.current !== Oi && (fi.current = Oi, Pi.style.height = `${Oi}px`), Pi.style.overflow = $i.overflowing ? "hidden" : "";
  }, [mi]), xi = React.useRef(-1);
  useEnhancedEffect$2(() => {
    const Pi = debounce$2(vi), $i = si == null ? void 0 : si.current;
    if (!$i)
      return;
    const Oi = ownerWindow$2($i);
    Oi.addEventListener("resize", Pi);
    let Di;
    return typeof ResizeObserver < "u" && (Di = new ResizeObserver(() => {
      Ti() && (Di.unobserve($i), cancelAnimationFrame(xi.current), vi(), xi.current = requestAnimationFrame(() => {
        Di.observe($i);
      }));
    }), Di.observe($i)), () => {
      Pi.clear(), cancelAnimationFrame(xi.current), Oi.removeEventListener("resize", Pi), Di && Di.disconnect();
    };
  }, [mi, vi, Ti]), useEnhancedEffect$2(() => {
    vi();
  });
  const Si = (Pi) => {
    oi || vi();
    const $i = Pi.target, Oi = $i.value.length, Di = $i.value.endsWith(`
`), Mi = $i.selectionStart === Oi;
    Di && Mi && $i.setSelectionRange(Oi, Oi), ir && ir(Pi);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx("textarea", {
      value: ai,
      onChange: Si,
      ref: di,
      rows: ii,
      style: ui,
      ...li
    }), /* @__PURE__ */ jsxRuntimeExports.jsx("textarea", {
      "aria-hidden": !0,
      className: pt.className,
      readOnly: !0,
      ref: gi,
      tabIndex: -1,
      style: {
        ...styles$2.shadow,
        ...ui,
        paddingTop: 0,
        paddingBottom: 0
      }
    })]
  });
});
process.env.NODE_ENV !== "production" && (TextareaAutosize.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * Maximum number of rows to display.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display.
   * @default 1
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * @ignore
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  placeholder: PropTypes.string,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * @ignore
   */
  value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.number, PropTypes.string])
});
function getInputBaseUtilityClass(pt) {
  return generateUtilityClass$2("MuiInputBase", pt);
}
const inputBaseClasses = generateUtilityClasses$2("MuiInputBase", ["root", "formControl", "focused", "disabled", "adornedStart", "adornedEnd", "error", "sizeSmall", "multiline", "colorSecondary", "fullWidth", "hiddenLabel", "readOnly", "input", "inputSizeSmall", "inputMultiline", "inputTypeSearch", "inputAdornedStart", "inputAdornedEnd", "inputHiddenLabel"]);
var _InputGlobalStyles;
const rootOverridesResolver = (pt, yt) => {
  const {
    ownerState: ir
  } = pt;
  return [yt.root, ir.formControl && yt.formControl, ir.startAdornment && yt.adornedStart, ir.endAdornment && yt.adornedEnd, ir.error && yt.error, ir.size === "small" && yt.sizeSmall, ir.multiline && yt.multiline, ir.color && yt[`color${capitalize$1(ir.color)}`], ir.fullWidth && yt.fullWidth, ir.hiddenLabel && yt.hiddenLabel];
}, inputOverridesResolver = (pt, yt) => {
  const {
    ownerState: ir
  } = pt;
  return [yt.input, ir.size === "small" && yt.inputSizeSmall, ir.multiline && yt.inputMultiline, ir.type === "search" && yt.inputTypeSearch, ir.startAdornment && yt.inputAdornedStart, ir.endAdornment && yt.inputAdornedEnd, ir.hiddenLabel && yt.inputHiddenLabel];
}, useUtilityClasses$m = (pt) => {
  const {
    classes: yt,
    color: ir,
    disabled: ti,
    error: ii,
    endAdornment: ui,
    focused: ai,
    formControl: li,
    fullWidth: oi,
    hiddenLabel: si,
    multiline: di,
    readOnly: fi,
    size: gi,
    startAdornment: mi,
    type: Ti
  } = pt, vi = {
    root: ["root", `color${capitalize$1(ir)}`, ti && "disabled", ii && "error", oi && "fullWidth", ai && "focused", li && "formControl", gi && gi !== "medium" && `size${capitalize$1(gi)}`, di && "multiline", mi && "adornedStart", ui && "adornedEnd", si && "hiddenLabel", fi && "readOnly"],
    input: ["input", ti && "disabled", Ti === "search" && "inputTypeSearch", di && "inputMultiline", gi === "small" && "inputSizeSmall", si && "inputHiddenLabel", mi && "inputAdornedStart", ui && "inputAdornedEnd", fi && "readOnly"]
  };
  return composeClasses$2(vi, getInputBaseUtilityClass, yt);
}, InputBaseRoot = styled$3("div", {
  name: "MuiInputBase",
  slot: "Root",
  overridesResolver: rootOverridesResolver
})(memoTheme$1(({
  theme: pt
}) => ({
  ...pt.typography.body1,
  color: (pt.vars || pt).palette.text.primary,
  lineHeight: "1.4375em",
  // 23px
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  position: "relative",
  cursor: "text",
  display: "inline-flex",
  alignItems: "center",
  [`&.${inputBaseClasses.disabled}`]: {
    color: (pt.vars || pt).palette.text.disabled,
    cursor: "default"
  },
  variants: [{
    props: ({
      ownerState: yt
    }) => yt.multiline,
    style: {
      padding: "4px 0 5px"
    }
  }, {
    props: ({
      ownerState: yt,
      size: ir
    }) => yt.multiline && ir === "small",
    style: {
      paddingTop: 1
    }
  }, {
    props: ({
      ownerState: yt
    }) => yt.fullWidth,
    style: {
      width: "100%"
    }
  }]
}))), InputBaseInput = styled$3("input", {
  name: "MuiInputBase",
  slot: "Input",
  overridesResolver: inputOverridesResolver
})(memoTheme$1(({
  theme: pt
}) => {
  const yt = pt.palette.mode === "light", ir = {
    color: "currentColor",
    ...pt.vars ? {
      opacity: pt.vars.opacity.inputPlaceholder
    } : {
      opacity: yt ? 0.42 : 0.5
    },
    transition: pt.transitions.create("opacity", {
      duration: pt.transitions.duration.shorter
    })
  }, ti = {
    opacity: "0 !important"
  }, ii = pt.vars ? {
    opacity: pt.vars.opacity.inputPlaceholder
  } : {
    opacity: yt ? 0.42 : 0.5
  };
  return {
    font: "inherit",
    letterSpacing: "inherit",
    color: "currentColor",
    padding: "4px 0 5px",
    border: 0,
    boxSizing: "content-box",
    background: "none",
    height: "1.4375em",
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: "transparent",
    display: "block",
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: "100%",
    "&::-webkit-input-placeholder": ir,
    "&::-moz-placeholder": ir,
    // Firefox 19+
    "&::-ms-input-placeholder": ir,
    // Edge
    "&:focus": {
      outline: 0
    },
    // Reset Firefox invalid required input style
    "&:invalid": {
      boxShadow: "none"
    },
    "&::-webkit-search-decoration": {
      // Remove the padding when type=search.
      WebkitAppearance: "none"
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${inputBaseClasses.formControl} &`]: {
      "&::-webkit-input-placeholder": ti,
      "&::-moz-placeholder": ti,
      // Firefox 19+
      "&::-ms-input-placeholder": ti,
      // Edge
      "&:focus::-webkit-input-placeholder": ii,
      "&:focus::-moz-placeholder": ii,
      // Firefox 19+
      "&:focus::-ms-input-placeholder": ii
      // Edge
    },
    [`&.${inputBaseClasses.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (pt.vars || pt).palette.text.disabled
      // Fix opacity Safari bug
    },
    variants: [{
      props: ({
        ownerState: ui
      }) => !ui.disableInjectingGlobalStyles,
      style: {
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&:-webkit-autofill": {
          animationDuration: "5000s",
          animationName: "mui-auto-fill"
        }
      }
    }, {
      props: {
        size: "small"
      },
      style: {
        paddingTop: 1
      }
    }, {
      props: ({
        ownerState: ui
      }) => ui.multiline,
      style: {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
      }
    }, {
      props: {
        type: "search"
      },
      style: {
        MozAppearance: "textfield"
        // Improve type search style.
      }
    }]
  };
})), InputGlobalStyles = globalCss({
  "@keyframes mui-auto-fill": {
    from: {
      display: "block"
    }
  },
  "@keyframes mui-auto-fill-cancel": {
    from: {
      display: "block"
    }
  }
}), InputBase = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const ir = useDefaultProps$2({
    props: pt,
    name: "MuiInputBase"
  }), {
    "aria-describedby": ti,
    autoComplete: ii,
    autoFocus: ui,
    className: ai,
    color: li,
    components: oi = {},
    componentsProps: si = {},
    defaultValue: di,
    disabled: fi,
    disableInjectingGlobalStyles: gi,
    endAdornment: mi,
    error: Ti,
    fullWidth: vi = !1,
    id: xi,
    inputComponent: Si = "input",
    inputProps: Pi = {},
    inputRef: $i,
    margin: Oi,
    maxRows: Di,
    minRows: Mi,
    multiline: Oo = !1,
    name: io,
    onBlur: xo,
    onChange: fo,
    onClick: _o,
    onFocus: Li,
    onKeyDown: Co,
    onKeyUp: Ni,
    placeholder: Yi,
    readOnly: Vo,
    renderSuffix: No,
    rows: Ui,
    size: jo,
    slotProps: Wi = {},
    slots: ji = {},
    startAdornment: Hi,
    type: zo = "text",
    value: Lo,
    ...sa
  } = ir, Ko = Pi.value != null ? Pi.value : Lo, {
    current: ca
  } = React.useRef(Ko != null), pa = React.useRef(), ga = React.useCallback((Ps) => {
    process.env.NODE_ENV !== "production" && Ps && Ps.nodeName !== "INPUT" && !Ps.focus && console.error(["MUI: You have provided a `inputComponent` to the input component", "that does not correctly handle the `ref` prop.", "Make sure the `ref` prop is called with a HTMLInputElement."].join(`
`));
  }, []), ia = useForkRef$2(pa, $i, Pi.ref, ga), [ra, qo] = React.useState(!1), xa = useFormControl();
  process.env.NODE_ENV !== "production" && React.useEffect(() => {
    if (xa)
      return xa.registerEffect();
  }, [xa]);
  const $a = formControlState({
    props: ir,
    muiFormControl: xa,
    states: ["color", "disabled", "error", "hiddenLabel", "size", "required", "filled"]
  });
  $a.focused = xa ? xa.focused : ra, React.useEffect(() => {
    !xa && fi && ra && (qo(!1), xo && xo());
  }, [xa, fi, ra, xo]);
  const ys = xa && xa.onFilled, Ss = xa && xa.onEmpty, Xa = React.useCallback((Ps) => {
    isFilled(Ps) ? ys && ys() : Ss && Ss();
  }, [ys, Ss]);
  useEnhancedEffect$2(() => {
    ca && Xa({
      value: Ko
    });
  }, [Ko, Xa, ca]);
  const Es = (Ps) => {
    Li && Li(Ps), Pi.onFocus && Pi.onFocus(Ps), xa && xa.onFocus ? xa.onFocus(Ps) : qo(!0);
  }, Rs = (Ps) => {
    xo && xo(Ps), Pi.onBlur && Pi.onBlur(Ps), xa && xa.onBlur ? xa.onBlur(Ps) : qo(!1);
  }, La = (Ps, ...nl) => {
    if (!ca) {
      const Vs = Ps.target || pa.current;
      if (Vs == null)
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : formatMuiErrorMessage$2(1));
      Xa({
        value: Vs.value
      });
    }
    Pi.onChange && Pi.onChange(Ps, ...nl), fo && fo(Ps, ...nl);
  };
  React.useEffect(() => {
    Xa(pa.current);
  }, []);
  const Ja = (Ps) => {
    pa.current && Ps.currentTarget === Ps.target && pa.current.focus(), _o && _o(Ps);
  };
  let ja = Si, Ta = Pi;
  Oo && ja === "input" && (Ui ? (process.env.NODE_ENV !== "production" && (Mi || Di) && console.warn("MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set."), Ta = {
    type: void 0,
    minRows: Ui,
    maxRows: Ui,
    ...Ta
  }) : Ta = {
    type: void 0,
    maxRows: Di,
    minRows: Mi,
    ...Ta
  }, ja = TextareaAutosize);
  const rs = (Ps) => {
    Xa(Ps.animationName === "mui-auto-fill-cancel" ? pa.current : {
      value: "x"
    });
  };
  React.useEffect(() => {
    xa && xa.setAdornedStart(!!Hi);
  }, [xa, Hi]);
  const Qa = {
    ...ir,
    color: $a.color || "primary",
    disabled: $a.disabled,
    endAdornment: mi,
    error: $a.error,
    focused: $a.focused,
    formControl: xa,
    fullWidth: vi,
    hiddenLabel: $a.hiddenLabel,
    multiline: Oo,
    size: $a.size,
    startAdornment: Hi,
    type: zo
  }, Cs = useUtilityClasses$m(Qa), _a = ji.root || oi.Root || InputBaseRoot, _s = Wi.root || si.root || {}, el = ji.input || oi.Input || InputBaseInput;
  return Ta = {
    ...Ta,
    ...Wi.input ?? si.input
  }, /* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
    children: [!gi && typeof InputGlobalStyles == "function" && // For Emotion/Styled-components, InputGlobalStyles will be a function
    // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
    (_InputGlobalStyles || (_InputGlobalStyles = /* @__PURE__ */ jsxRuntimeExports.jsx(InputGlobalStyles, {}))), /* @__PURE__ */ jsxRuntimeExports.jsxs(_a, {
      ..._s,
      ref: yt,
      onClick: Ja,
      ...sa,
      ...!isHostComponent$3(_a) && {
        ownerState: {
          ...Qa,
          ..._s.ownerState
        }
      },
      className: clsx$1(Cs.root, _s.className, ai, Vo && "MuiInputBase-readOnly"),
      children: [Hi, /* @__PURE__ */ jsxRuntimeExports.jsx(FormControlContext.Provider, {
        value: null,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(el, {
          "aria-invalid": $a.error,
          "aria-describedby": ti,
          autoComplete: ii,
          autoFocus: ui,
          defaultValue: di,
          disabled: $a.disabled,
          id: xi,
          onAnimationStart: rs,
          name: io,
          placeholder: Yi,
          readOnly: Vo,
          required: $a.required,
          rows: Ui,
          value: Ko,
          onKeyDown: Co,
          onKeyUp: Ni,
          type: zo,
          ...Ta,
          ...!isHostComponent$3(el) && {
            as: ja,
            ownerState: {
              ...Qa,
              ...Ta.ownerState
            }
          },
          ref: ia,
          className: clsx$1(Cs.input, Ta.className, Vo && "MuiInputBase-readOnly"),
          onBlur: Rs,
          onChange: La,
          onFocus: Es
        })
      }), mi, No ? No({
        ...$a,
        startAdornment: Hi
      }) : null]
    })]
  });
});
process.env.NODE_ENV !== "production" && (InputBase.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  "aria-describedby": PropTypes.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */
  disableInjectingGlobalStyles: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: elementTypeAcceptingRef$1$1,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$2,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */
  onInvalid: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * @ignore
   */
  renderSuffix: PropTypes.func,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The size of the component.
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#input_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
});
function getInputUtilityClass(pt) {
  return generateUtilityClass$2("MuiInput", pt);
}
const inputClasses = {
  ...inputBaseClasses,
  ...generateUtilityClasses$2("MuiInput", ["root", "underline", "input"])
};
function getOutlinedInputUtilityClass(pt) {
  return generateUtilityClass$2("MuiOutlinedInput", pt);
}
const outlinedInputClasses = {
  ...inputBaseClasses,
  ...generateUtilityClasses$2("MuiOutlinedInput", ["root", "notchedOutline", "input"])
};
function getFilledInputUtilityClass(pt) {
  return generateUtilityClass$2("MuiFilledInput", pt);
}
const filledInputClasses = {
  ...inputBaseClasses,
  ...generateUtilityClasses$2("MuiFilledInput", ["root", "underline", "input", "adornedStart", "adornedEnd", "sizeSmall", "multiline", "hiddenLabel"])
}, ArrowDropDownIcon = createSvgIcon$1(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
function isClassComponent$3(pt) {
  const {
    prototype: yt = {}
  } = pt;
  return !!yt.isReactComponent;
}
function acceptingRef$2(pt, yt, ir, ti, ii) {
  const ui = pt[yt], ai = ii || yt;
  if (ui == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let li;
  const oi = ui.type;
  return typeof oi == "function" && !isClassComponent$3(oi) && (li = "Did you accidentally use a plain function component for an element instead?"), li !== void 0 ? new Error(`Invalid ${ti} \`${ai}\` supplied to \`${ir}\`. Expected an element that can hold a ref. ${li} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const elementAcceptingRef$2 = chainPropTypes$2(PropTypes.element, acceptingRef$2);
elementAcceptingRef$2.isRequired = chainPropTypes$2(PropTypes.element.isRequired, acceptingRef$2);
const styles$1$1 = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, Fade$1 = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const ir = useTheme$3(), ti = {
    enter: ir.transitions.duration.enteringScreen,
    exit: ir.transitions.duration.leavingScreen
  }, {
    addEndListener: ii,
    appear: ui = !0,
    children: ai,
    easing: li,
    in: oi,
    onEnter: si,
    onEntered: di,
    onEntering: fi,
    onExit: gi,
    onExited: mi,
    onExiting: Ti,
    style: vi,
    timeout: xi = ti,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: Si = Transition$1,
    ...Pi
  } = pt, $i = React.useRef(null), Oi = useForkRef$2($i, getReactElementRef$2(ai), yt), Di = (Co) => (Ni) => {
    if (Co) {
      const Yi = $i.current;
      Ni === void 0 ? Co(Yi) : Co(Yi, Ni);
    }
  }, Mi = Di(fi), Oo = Di((Co, Ni) => {
    reflow$1(Co);
    const Yi = getTransitionProps$1({
      style: vi,
      timeout: xi,
      easing: li
    }, {
      mode: "enter"
    });
    Co.style.webkitTransition = ir.transitions.create("opacity", Yi), Co.style.transition = ir.transitions.create("opacity", Yi), si && si(Co, Ni);
  }), io = Di(di), xo = Di(Ti), fo = Di((Co) => {
    const Ni = getTransitionProps$1({
      style: vi,
      timeout: xi,
      easing: li
    }, {
      mode: "exit"
    });
    Co.style.webkitTransition = ir.transitions.create("opacity", Ni), Co.style.transition = ir.transitions.create("opacity", Ni), gi && gi(Co);
  }), _o = Di(mi), Li = (Co) => {
    ii && ii($i.current, Co);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Si, {
    appear: ui,
    in: oi,
    nodeRef: $i,
    onEnter: Oo,
    onEntered: io,
    onEntering: Mi,
    onExit: fo,
    onExited: _o,
    onExiting: xo,
    addEndListener: Li,
    timeout: xi,
    ...Pi,
    children: (Co, {
      ownerState: Ni,
      ...Yi
    }) => /* @__PURE__ */ React.cloneElement(ai, {
      style: {
        opacity: 0,
        visibility: Co === "exited" && !oi ? "hidden" : void 0,
        ...styles$1$1[Co],
        ...vi,
        ...ai.props.style
      },
      ref: Oi,
      ...Yi
    })
  });
});
process.env.NODE_ENV !== "production" && (Fade$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: PropTypes.bool,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef$2.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes.func,
  /**
   * @ignore
   */
  onEntered: PropTypes.func,
  /**
   * @ignore
   */
  onEntering: PropTypes.func,
  /**
   * @ignore
   */
  onExit: PropTypes.func,
  /**
   * @ignore
   */
  onExited: PropTypes.func,
  /**
   * @ignore
   */
  onExiting: PropTypes.func,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
});
function getBackdropUtilityClass$1(pt) {
  return generateUtilityClass$2("MuiBackdrop", pt);
}
generateUtilityClasses$2("MuiBackdrop", ["root", "invisible"]);
const useUtilityClasses$l = (pt) => {
  const {
    classes: yt,
    invisible: ir
  } = pt;
  return composeClasses$2({
    root: ["root", ir && "invisible"]
  }, getBackdropUtilityClass$1, yt);
}, BackdropRoot$1 = styled$3("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (pt, yt) => {
    const {
      ownerState: ir
    } = pt;
    return [yt.root, ir.invisible && yt.invisible];
  }
})({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent",
  variants: [{
    props: {
      invisible: !0
    },
    style: {
      backgroundColor: "transparent"
    }
  }]
}), Backdrop$1 = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const ir = useDefaultProps$2({
    props: pt,
    name: "MuiBackdrop"
  }), {
    children: ti,
    className: ii,
    component: ui = "div",
    invisible: ai = !1,
    open: li,
    components: oi = {},
    componentsProps: si = {},
    slotProps: di = {},
    slots: fi = {},
    TransitionComponent: gi,
    transitionDuration: mi,
    ...Ti
  } = ir, vi = {
    ...ir,
    component: ui,
    invisible: ai
  }, xi = useUtilityClasses$l(vi), Si = {
    transition: gi,
    root: oi.Root,
    ...fi
  }, Pi = {
    ...si,
    ...di
  }, $i = {
    component: ui,
    slots: Si,
    slotProps: Pi
  }, [Oi, Di] = useSlot$1("root", {
    elementType: BackdropRoot$1,
    externalForwardedProps: $i,
    className: clsx$1(xi.root, ii),
    ownerState: vi
  }), [Mi, Oo] = useSlot$1("transition", {
    elementType: Fade$1,
    externalForwardedProps: $i,
    ownerState: vi
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Mi, {
    in: li,
    timeout: mi,
    ...Ti,
    ...Oo,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(Oi, {
      "aria-hidden": !0,
      ...Di,
      ref: yt,
      children: ti
    })
  });
});
process.env.NODE_ENV !== "production" && (Backdrop$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    root: PropTypes.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: PropTypes.bool,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    transition: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType,
    transition: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   * @deprecated Use `slots.transition` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
});
function useBadge(pt) {
  const {
    badgeContent: yt,
    invisible: ir = !1,
    max: ti = 99,
    showZero: ii = !1
  } = pt, ui = usePreviousProps({
    badgeContent: yt,
    max: ti
  });
  let ai = ir;
  ir === !1 && yt === 0 && !ii && (ai = !0);
  const {
    badgeContent: li,
    max: oi = ti
  } = ai ? ui : pt, si = li && Number(li) > oi ? `${oi}+` : li;
  return {
    badgeContent: li,
    invisible: ai,
    max: oi,
    displayValue: si
  };
}
function getBadgeUtilityClass(pt) {
  return generateUtilityClass$2("MuiBadge", pt);
}
const badgeClasses = generateUtilityClasses$2("MuiBadge", [
  "root",
  "badge",
  "dot",
  "standard",
  "anchorOriginTopRight",
  "anchorOriginBottomRight",
  "anchorOriginTopLeft",
  "anchorOriginBottomLeft",
  "invisible",
  "colorError",
  "colorInfo",
  "colorPrimary",
  "colorSecondary",
  "colorSuccess",
  "colorWarning",
  "overlapRectangular",
  "overlapCircular",
  // TODO: v6 remove the overlap value from these class keys
  "anchorOriginTopLeftCircular",
  "anchorOriginTopLeftRectangular",
  "anchorOriginTopRightCircular",
  "anchorOriginTopRightRectangular",
  "anchorOriginBottomLeftCircular",
  "anchorOriginBottomLeftRectangular",
  "anchorOriginBottomRightCircular",
  "anchorOriginBottomRightRectangular"
]), RADIUS_STANDARD = 10, RADIUS_DOT = 4, useUtilityClasses$k = (pt) => {
  const {
    color: yt,
    anchorOrigin: ir,
    invisible: ti,
    overlap: ii,
    variant: ui,
    classes: ai = {}
  } = pt, li = {
    root: ["root"],
    badge: ["badge", ui, ti && "invisible", `anchorOrigin${capitalize$1(ir.vertical)}${capitalize$1(ir.horizontal)}`, `anchorOrigin${capitalize$1(ir.vertical)}${capitalize$1(ir.horizontal)}${capitalize$1(ii)}`, `overlap${capitalize$1(ii)}`, yt !== "default" && `color${capitalize$1(yt)}`]
  };
  return composeClasses$2(li, getBadgeUtilityClass, ai);
}, BadgeRoot = styled$3("span", {
  name: "MuiBadge",
  slot: "Root"
})({
  position: "relative",
  display: "inline-flex",
  // For correct alignment with the text.
  verticalAlign: "middle",
  flexShrink: 0
}), BadgeBadge = styled$3("span", {
  name: "MuiBadge",
  slot: "Badge",
  overridesResolver: (pt, yt) => {
    const {
      ownerState: ir
    } = pt;
    return [yt.badge, yt[ir.variant], yt[`anchorOrigin${capitalize$1(ir.anchorOrigin.vertical)}${capitalize$1(ir.anchorOrigin.horizontal)}${capitalize$1(ir.overlap)}`], ir.color !== "default" && yt[`color${capitalize$1(ir.color)}`], ir.invisible && yt.invisible];
  }
})(memoTheme$1(({
  theme: pt
}) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  justifyContent: "center",
  alignContent: "center",
  alignItems: "center",
  position: "absolute",
  boxSizing: "border-box",
  fontFamily: pt.typography.fontFamily,
  fontWeight: pt.typography.fontWeightMedium,
  fontSize: pt.typography.pxToRem(12),
  minWidth: RADIUS_STANDARD * 2,
  lineHeight: 1,
  padding: "0 6px",
  height: RADIUS_STANDARD * 2,
  borderRadius: RADIUS_STANDARD,
  zIndex: 1,
  // Render the badge on top of potential ripples.
  transition: pt.transitions.create("transform", {
    easing: pt.transitions.easing.easeInOut,
    duration: pt.transitions.duration.enteringScreen
  }),
  variants: [...Object.entries(pt.palette).filter(createSimplePaletteValueFilter$1(["contrastText"])).map(([yt]) => ({
    props: {
      color: yt
    },
    style: {
      backgroundColor: (pt.vars || pt).palette[yt].main,
      color: (pt.vars || pt).palette[yt].contrastText
    }
  })), {
    props: {
      variant: "dot"
    },
    style: {
      borderRadius: RADIUS_DOT,
      height: RADIUS_DOT * 2,
      minWidth: RADIUS_DOT * 2,
      padding: 0
    }
  }, {
    props: {
      invisible: !0
    },
    style: {
      transition: pt.transitions.create("transform", {
        easing: pt.transitions.easing.easeInOut,
        duration: pt.transitions.duration.leavingScreen
      })
    }
  }, {
    style: ({
      ownerState: yt
    }) => {
      const {
        vertical: ir,
        horizontal: ti
      } = yt.anchorOrigin, ii = yt.overlap === "circular" ? "14%" : 0;
      return {
        "--Badge-translateX": ti === "right" ? "50%" : "-50%",
        "--Badge-translateY": ir === "top" ? "-50%" : "50%",
        top: ir === "top" ? ii : "initial",
        bottom: ir === "bottom" ? ii : "initial",
        right: ti === "right" ? ii : "initial",
        left: ti === "left" ? ii : "initial",
        transform: "scale(1) translate(var(--Badge-translateX), var(--Badge-translateY))",
        transformOrigin: `${ti === "right" ? "100%" : "0%"} ${ir === "top" ? "0%" : "100%"}`,
        [`&.${badgeClasses.invisible}`]: {
          transform: "scale(0) translate(var(--Badge-translateX), var(--Badge-translateY))"
        }
      };
    }
  }]
})));
function getAnchorOrigin(pt) {
  return {
    vertical: (pt == null ? void 0 : pt.vertical) ?? "top",
    horizontal: (pt == null ? void 0 : pt.horizontal) ?? "right"
  };
}
const Badge$1 = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const ir = useDefaultProps$2({
    props: pt,
    name: "MuiBadge"
  }), {
    anchorOrigin: ti,
    className: ii,
    classes: ui,
    component: ai,
    components: li = {},
    componentsProps: oi = {},
    children: si,
    overlap: di = "rectangular",
    color: fi = "default",
    invisible: gi = !1,
    max: mi = 99,
    badgeContent: Ti,
    slots: vi,
    slotProps: xi,
    showZero: Si = !1,
    variant: Pi = "standard",
    ...$i
  } = ir, {
    badgeContent: Oi,
    invisible: Di,
    max: Mi,
    displayValue: Oo
  } = useBadge({
    max: mi,
    invisible: gi,
    badgeContent: Ti,
    showZero: Si
  }), io = usePreviousProps({
    anchorOrigin: getAnchorOrigin(ti),
    color: fi,
    overlap: di,
    variant: Pi,
    badgeContent: Ti
  }), xo = Di || Oi == null && Pi !== "dot", {
    color: fo = fi,
    overlap: _o = di,
    anchorOrigin: Li,
    variant: Co = Pi
  } = xo ? io : ir, Ni = getAnchorOrigin(Li), Yi = Co !== "dot" ? Oo : void 0, Vo = {
    ...ir,
    badgeContent: Oi,
    invisible: xo,
    max: Mi,
    displayValue: Yi,
    showZero: Si,
    anchorOrigin: Ni,
    color: fo,
    overlap: _o,
    variant: Co
  }, No = useUtilityClasses$k(Vo), Ui = {
    slots: {
      root: (vi == null ? void 0 : vi.root) ?? li.Root,
      badge: (vi == null ? void 0 : vi.badge) ?? li.Badge
    },
    slotProps: {
      root: (xi == null ? void 0 : xi.root) ?? oi.root,
      badge: (xi == null ? void 0 : xi.badge) ?? oi.badge
    }
  }, [jo, Wi] = useSlot$1("root", {
    elementType: BadgeRoot,
    externalForwardedProps: {
      ...Ui,
      ...$i
    },
    ownerState: Vo,
    className: clsx$1(No.root, ii),
    ref: yt,
    additionalProps: {
      as: ai
    }
  }), [ji, Hi] = useSlot$1("badge", {
    elementType: BadgeBadge,
    externalForwardedProps: Ui,
    ownerState: Vo,
    className: No.badge
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jo, {
    ...Wi,
    children: [si, /* @__PURE__ */ jsxRuntimeExports.jsx(ji, {
      ...Hi,
      children: Yi
    })]
  });
});
process.env.NODE_ENV !== "production" && (Badge$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The anchor of the badge.
   * @default {
   *   vertical: 'top',
   *   horizontal: 'right',
   * }
   */
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOf(["left", "right"]),
    vertical: PropTypes.oneOf(["bottom", "top"])
  }),
  /**
   * The content rendered within the badge.
   */
  badgeContent: PropTypes.node,
  /**
   * The badge will be added relative to this node.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Badge: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    badge: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * If `true`, the badge is invisible.
   * @default false
   */
  invisible: PropTypes.bool,
  /**
   * Max count to show.
   * @default 99
   */
  max: PropTypes.number,
  /**
   * Wrapped shape the badge should overlap.
   * @default 'rectangular'
   */
  overlap: PropTypes.oneOf(["circular", "rectangular"]),
  /**
   * Controls whether the badge is hidden when `badgeContent` is zero.
   * @default false
   */
  showZero: PropTypes.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    badge: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    badge: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["dot", "standard"]), PropTypes.string])
});
function getScrollbarSize$2(pt = window) {
  const yt = pt.document.documentElement.clientWidth;
  return pt.innerWidth - yt;
}
function isOverflowing$2(pt) {
  const yt = ownerDocument$2(pt);
  return yt.body === pt ? ownerWindow$2(pt).innerWidth > yt.documentElement.clientWidth : pt.scrollHeight > pt.clientHeight;
}
function ariaHidden$2(pt, yt) {
  yt ? pt.setAttribute("aria-hidden", "true") : pt.removeAttribute("aria-hidden");
}
function getPaddingRight$2(pt) {
  return parseFloat(ownerWindow$2(pt).getComputedStyle(pt).paddingRight) || 0;
}
function isAriaHiddenForbiddenOnElement$2(pt) {
  const yt = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].includes(pt.tagName), ir = pt.tagName === "INPUT" && pt.getAttribute("type") === "hidden";
  return yt || ir;
}
function ariaHiddenSiblings$2(pt, yt, ir, ti, ii) {
  const ui = [yt, ir, ...ti];
  [].forEach.call(pt.children, (ai) => {
    const li = !ui.includes(ai), oi = !isAriaHiddenForbiddenOnElement$2(ai);
    li && oi && ariaHidden$2(ai, ii);
  });
}
function findIndexOf$2(pt, yt) {
  let ir = -1;
  return pt.some((ti, ii) => yt(ti) ? (ir = ii, !0) : !1), ir;
}
function handleContainer$2(pt, yt) {
  const ir = [], ti = pt.container;
  if (!yt.disableScrollLock) {
    if (isOverflowing$2(ti)) {
      const ui = getScrollbarSize$2(ownerWindow$2(ti));
      ir.push({
        value: ti.style.paddingRight,
        property: "padding-right",
        el: ti
      }), ti.style.paddingRight = `${getPaddingRight$2(ti) + ui}px`;
      const ai = ownerDocument$2(ti).querySelectorAll(".mui-fixed");
      [].forEach.call(ai, (li) => {
        ir.push({
          value: li.style.paddingRight,
          property: "padding-right",
          el: li
        }), li.style.paddingRight = `${getPaddingRight$2(li) + ui}px`;
      });
    }
    let ii;
    if (ti.parentNode instanceof DocumentFragment)
      ii = ownerDocument$2(ti).body;
    else {
      const ui = ti.parentElement, ai = ownerWindow$2(ti);
      ii = (ui == null ? void 0 : ui.nodeName) === "HTML" && ai.getComputedStyle(ui).overflowY === "scroll" ? ui : ti;
    }
    ir.push({
      value: ii.style.overflow,
      property: "overflow",
      el: ii
    }, {
      value: ii.style.overflowX,
      property: "overflow-x",
      el: ii
    }, {
      value: ii.style.overflowY,
      property: "overflow-y",
      el: ii
    }), ii.style.overflow = "hidden";
  }
  return () => {
    ir.forEach(({
      value: ii,
      el: ui,
      property: ai
    }) => {
      ii ? ui.style.setProperty(ai, ii) : ui.style.removeProperty(ai);
    });
  };
}
function getHiddenSiblings$2(pt) {
  const yt = [];
  return [].forEach.call(pt.children, (ir) => {
    ir.getAttribute("aria-hidden") === "true" && yt.push(ir);
  }), yt;
}
let ModalManager$2 = class {
  constructor() {
    this.modals = [], this.containers = [];
  }
  add(yt, ir) {
    let ti = this.modals.indexOf(yt);
    if (ti !== -1)
      return ti;
    ti = this.modals.length, this.modals.push(yt), yt.modalRef && ariaHidden$2(yt.modalRef, !1);
    const ii = getHiddenSiblings$2(ir);
    ariaHiddenSiblings$2(ir, yt.mount, yt.modalRef, ii, !0);
    const ui = findIndexOf$2(this.containers, (ai) => ai.container === ir);
    return ui !== -1 ? (this.containers[ui].modals.push(yt), ti) : (this.containers.push({
      modals: [yt],
      container: ir,
      restore: null,
      hiddenSiblings: ii
    }), ti);
  }
  mount(yt, ir) {
    const ti = findIndexOf$2(this.containers, (ui) => ui.modals.includes(yt)), ii = this.containers[ti];
    ii.restore || (ii.restore = handleContainer$2(ii, ir));
  }
  remove(yt, ir = !0) {
    const ti = this.modals.indexOf(yt);
    if (ti === -1)
      return ti;
    const ii = findIndexOf$2(this.containers, (ai) => ai.modals.includes(yt)), ui = this.containers[ii];
    if (ui.modals.splice(ui.modals.indexOf(yt), 1), this.modals.splice(ti, 1), ui.modals.length === 0)
      ui.restore && ui.restore(), yt.modalRef && ariaHidden$2(yt.modalRef, ir), ariaHiddenSiblings$2(ui.container, yt.mount, yt.modalRef, ui.hiddenSiblings, !1), this.containers.splice(ii, 1);
    else {
      const ai = ui.modals[ui.modals.length - 1];
      ai.modalRef && ariaHidden$2(ai.modalRef, !1);
    }
    return ti;
  }
  isTopModal(yt) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === yt;
  }
};
function activeElement$1(pt) {
  var yt;
  let ir = pt.activeElement;
  for (; ((yt = ir == null ? void 0 : ir.shadowRoot) == null ? void 0 : yt.activeElement) != null; )
    ir = ir.shadowRoot.activeElement;
  return ir;
}
const candidatesSelector$2 = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function getTabIndex$2(pt) {
  const yt = parseInt(pt.getAttribute("tabindex") || "", 10);
  return Number.isNaN(yt) ? pt.contentEditable === "true" || (pt.nodeName === "AUDIO" || pt.nodeName === "VIDEO" || pt.nodeName === "DETAILS") && pt.getAttribute("tabindex") === null ? 0 : pt.tabIndex : yt;
}
function isNonTabbableRadio$2(pt) {
  if (pt.tagName !== "INPUT" || pt.type !== "radio" || !pt.name)
    return !1;
  const yt = (ti) => pt.ownerDocument.querySelector(`input[type="radio"]${ti}`);
  let ir = yt(`[name="${pt.name}"]:checked`);
  return ir || (ir = yt(`[name="${pt.name}"]`)), ir !== pt;
}
function isNodeMatchingSelectorFocusable$2(pt) {
  return !(pt.disabled || pt.tagName === "INPUT" && pt.type === "hidden" || isNonTabbableRadio$2(pt));
}
function defaultGetTabbable$2(pt) {
  const yt = [], ir = [];
  return Array.from(pt.querySelectorAll(candidatesSelector$2)).forEach((ti, ii) => {
    const ui = getTabIndex$2(ti);
    ui === -1 || !isNodeMatchingSelectorFocusable$2(ti) || (ui === 0 ? yt.push(ti) : ir.push({
      documentOrder: ii,
      tabIndex: ui,
      node: ti
    }));
  }), ir.sort((ti, ii) => ti.tabIndex === ii.tabIndex ? ti.documentOrder - ii.documentOrder : ti.tabIndex - ii.tabIndex).map((ti) => ti.node).concat(yt);
}
function defaultIsEnabled$2() {
  return !0;
}
function FocusTrap$2(pt) {
  const {
    children: yt,
    disableAutoFocus: ir = !1,
    disableEnforceFocus: ti = !1,
    disableRestoreFocus: ii = !1,
    getTabbable: ui = defaultGetTabbable$2,
    isEnabled: ai = defaultIsEnabled$2,
    open: li
  } = pt, oi = React.useRef(!1), si = React.useRef(null), di = React.useRef(null), fi = React.useRef(null), gi = React.useRef(null), mi = React.useRef(!1), Ti = React.useRef(null), vi = useForkRef$2(getReactElementRef$2(yt), Ti), xi = React.useRef(null);
  React.useEffect(() => {
    !li || !Ti.current || (mi.current = !ir);
  }, [ir, li]), React.useEffect(() => {
    if (!li || !Ti.current)
      return;
    const $i = ownerDocument$2(Ti.current), Oi = activeElement$1($i);
    return Ti.current.contains(Oi) || (Ti.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), Ti.current.setAttribute("tabIndex", "-1")), mi.current && Ti.current.focus()), () => {
      ii || (fi.current && fi.current.focus && (oi.current = !0, fi.current.focus()), fi.current = null);
    };
  }, [li]), React.useEffect(() => {
    if (!li || !Ti.current)
      return;
    const $i = ownerDocument$2(Ti.current), Oi = (Oo) => {
      xi.current = Oo, !(ti || !ai() || Oo.key !== "Tab") && activeElement$1($i) === Ti.current && Oo.shiftKey && (oi.current = !0, di.current && di.current.focus());
    }, Di = () => {
      var Oo, io;
      const xo = Ti.current;
      if (xo === null)
        return;
      const fo = activeElement$1($i);
      if (!$i.hasFocus() || !ai() || oi.current) {
        oi.current = !1;
        return;
      }
      if (xo.contains(fo) || ti && fo !== si.current && fo !== di.current)
        return;
      if (fo !== gi.current)
        gi.current = null;
      else if (gi.current !== null)
        return;
      if (!mi.current)
        return;
      let _o = [];
      if ((fo === si.current || fo === di.current) && (_o = ui(Ti.current)), _o.length > 0) {
        const Li = !!((Oo = xi.current) != null && Oo.shiftKey && ((io = xi.current) == null ? void 0 : io.key) === "Tab"), Co = _o[0], Ni = _o[_o.length - 1];
        typeof Co != "string" && typeof Ni != "string" && (Li ? Ni.focus() : Co.focus());
      } else
        xo.focus();
    };
    $i.addEventListener("focusin", Di), $i.addEventListener("keydown", Oi, !0);
    const Mi = setInterval(() => {
      const Oo = activeElement$1($i);
      Oo && Oo.tagName === "BODY" && Di();
    }, 50);
    return () => {
      clearInterval(Mi), $i.removeEventListener("focusin", Di), $i.removeEventListener("keydown", Oi, !0);
    };
  }, [ir, ti, ii, ai, li, ui]);
  const Si = ($i) => {
    fi.current === null && (fi.current = $i.relatedTarget), mi.current = !0, gi.current = $i.target;
    const Oi = yt.props.onFocus;
    Oi && Oi($i);
  }, Pi = ($i) => {
    fi.current === null && (fi.current = $i.relatedTarget), mi.current = !0;
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      tabIndex: li ? 0 : -1,
      onFocus: Pi,
      ref: si,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ React.cloneElement(yt, {
      ref: vi,
      onFocus: Si
    }), /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      tabIndex: li ? 0 : -1,
      onFocus: Pi,
      ref: di,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" && (FocusTrap$2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: elementAcceptingRef$2,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: PropTypes.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: PropTypes.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: PropTypes.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: PropTypes.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: PropTypes.func,
  /**
   * If `true`, focus is locked.
   */
  open: PropTypes.bool.isRequired
});
process.env.NODE_ENV !== "production" && (FocusTrap$2.propTypes = exactProp$2(FocusTrap$2.propTypes));
function getContainer$4(pt) {
  return typeof pt == "function" ? pt() : pt;
}
function getHasTransition$2(pt) {
  return pt ? pt.props.hasOwnProperty("in") : !1;
}
const noop$4 = () => {
}, manager$1 = new ModalManager$2();
function useModal$2(pt) {
  const {
    container: yt,
    disableEscapeKeyDown: ir = !1,
    disableScrollLock: ti = !1,
    closeAfterTransition: ii = !1,
    onTransitionEnter: ui,
    onTransitionExited: ai,
    children: li,
    onClose: oi,
    open: si,
    rootRef: di
  } = pt, fi = React.useRef({}), gi = React.useRef(null), mi = React.useRef(null), Ti = useForkRef$2(mi, di), [vi, xi] = React.useState(!si), Si = getHasTransition$2(li);
  let Pi = !0;
  (pt["aria-hidden"] === "false" || pt["aria-hidden"] === !1) && (Pi = !1);
  const $i = () => ownerDocument$2(gi.current), Oi = () => (fi.current.modalRef = mi.current, fi.current.mount = gi.current, fi.current), Di = () => {
    manager$1.mount(Oi(), {
      disableScrollLock: ti
    }), mi.current && (mi.current.scrollTop = 0);
  }, Mi = useEventCallback$2(() => {
    const Li = getContainer$4(yt) || $i().body;
    manager$1.add(Oi(), Li), mi.current && Di();
  }), Oo = () => manager$1.isTopModal(Oi()), io = useEventCallback$2((Li) => {
    gi.current = Li, Li && (si && Oo() ? Di() : mi.current && ariaHidden$2(mi.current, Pi));
  }), xo = React.useCallback(() => {
    manager$1.remove(Oi(), Pi);
  }, [Pi]);
  React.useEffect(() => () => {
    xo();
  }, [xo]), React.useEffect(() => {
    si ? Mi() : (!Si || !ii) && xo();
  }, [si, xo, Si, ii, Mi]);
  const fo = (Li) => (Co) => {
    var Ni;
    (Ni = Li.onKeyDown) == null || Ni.call(Li, Co), !(Co.key !== "Escape" || Co.which === 229 || // Wait until IME is settled.
    !Oo()) && (ir || (Co.stopPropagation(), oi && oi(Co, "escapeKeyDown")));
  }, _o = (Li) => (Co) => {
    var Ni;
    (Ni = Li.onClick) == null || Ni.call(Li, Co), Co.target === Co.currentTarget && oi && oi(Co, "backdropClick");
  };
  return {
    getRootProps: (Li = {}) => {
      const Co = extractEventHandlers$2(pt);
      delete Co.onTransitionEnter, delete Co.onTransitionExited;
      const Ni = {
        ...Co,
        ...Li
      };
      return {
        /*
         * Marking an element with the role presentation indicates to assistive technology
         * that this element should be ignored; it exists to support the web application and
         * is not meant for humans to interact with directly.
         * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
         */
        role: "presentation",
        ...Ni,
        onKeyDown: fo(Ni),
        ref: Ti
      };
    },
    getBackdropProps: (Li = {}) => {
      const Co = Li;
      return {
        "aria-hidden": !0,
        ...Co,
        onClick: _o(Co),
        open: si
      };
    },
    getTransitionProps: () => {
      const Li = () => {
        xi(!1), ui && ui();
      }, Co = () => {
        xi(!0), ai && ai(), ii && xo();
      };
      return {
        onEnter: createChainedFunction$2(Li, (li == null ? void 0 : li.props.onEnter) ?? noop$4),
        onExited: createChainedFunction$2(Co, (li == null ? void 0 : li.props.onExited) ?? noop$4)
      };
    },
    rootRef: Ti,
    portalRef: io,
    isTopModal: Oo,
    exited: vi,
    hasTransition: Si
  };
}
function getModalUtilityClass$2(pt) {
  return generateUtilityClass$2("MuiModal", pt);
}
generateUtilityClasses$2("MuiModal", ["root", "hidden", "backdrop"]);
const useUtilityClasses$j = (pt) => {
  const {
    open: yt,
    exited: ir,
    classes: ti
  } = pt;
  return composeClasses$2({
    root: ["root", !yt && ir && "hidden"],
    backdrop: ["backdrop"]
  }, getModalUtilityClass$2, ti);
}, ModalRoot$1 = styled$3("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (pt, yt) => {
    const {
      ownerState: ir
    } = pt;
    return [yt.root, !ir.open && ir.exited && yt.hidden];
  }
})(memoTheme$1(({
  theme: pt
}) => ({
  position: "fixed",
  zIndex: (pt.vars || pt).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  variants: [{
    props: ({
      ownerState: yt
    }) => !yt.open && yt.exited,
    style: {
      visibility: "hidden"
    }
  }]
}))), ModalBackdrop$1 = styled$3(Backdrop$1, {
  name: "MuiModal",
  slot: "Backdrop"
})({
  zIndex: -1
}), Modal$1 = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const ir = useDefaultProps$2({
    name: "MuiModal",
    props: pt
  }), {
    BackdropComponent: ti = ModalBackdrop$1,
    BackdropProps: ii,
    classes: ui,
    className: ai,
    closeAfterTransition: li = !1,
    children: oi,
    container: si,
    component: di,
    components: fi = {},
    componentsProps: gi = {},
    disableAutoFocus: mi = !1,
    disableEnforceFocus: Ti = !1,
    disableEscapeKeyDown: vi = !1,
    disablePortal: xi = !1,
    disableRestoreFocus: Si = !1,
    disableScrollLock: Pi = !1,
    hideBackdrop: $i = !1,
    keepMounted: Oi = !1,
    onClose: Di,
    onTransitionEnter: Mi,
    onTransitionExited: Oo,
    open: io,
    slotProps: xo = {},
    slots: fo = {},
    // eslint-disable-next-line react/prop-types
    theme: _o,
    ...Li
  } = ir, Co = {
    ...ir,
    closeAfterTransition: li,
    disableAutoFocus: mi,
    disableEnforceFocus: Ti,
    disableEscapeKeyDown: vi,
    disablePortal: xi,
    disableRestoreFocus: Si,
    disableScrollLock: Pi,
    hideBackdrop: $i,
    keepMounted: Oi
  }, {
    getRootProps: Ni,
    getBackdropProps: Yi,
    getTransitionProps: Vo,
    portalRef: No,
    isTopModal: Ui,
    exited: jo,
    hasTransition: Wi
  } = useModal$2({
    ...Co,
    rootRef: yt
  }), ji = {
    ...Co,
    exited: jo
  }, Hi = useUtilityClasses$j(ji), zo = {};
  if (oi.props.tabIndex === void 0 && (zo.tabIndex = "-1"), Wi) {
    const {
      onEnter: ga,
      onExited: ia
    } = Vo();
    zo.onEnter = ga, zo.onExited = ia;
  }
  const Lo = {
    slots: {
      root: fi.Root,
      backdrop: fi.Backdrop,
      ...fo
    },
    slotProps: {
      ...gi,
      ...xo
    }
  }, [sa, Ko] = useSlot$1("root", {
    ref: yt,
    elementType: ModalRoot$1,
    externalForwardedProps: {
      ...Lo,
      ...Li,
      component: di
    },
    getSlotProps: Ni,
    ownerState: ji,
    className: clsx$1(ai, Hi == null ? void 0 : Hi.root, !ji.open && ji.exited && (Hi == null ? void 0 : Hi.hidden))
  }), [ca, pa] = useSlot$1("backdrop", {
    ref: ii == null ? void 0 : ii.ref,
    elementType: ti,
    externalForwardedProps: Lo,
    shouldForwardComponentProp: !0,
    additionalProps: ii,
    getSlotProps: (ga) => Yi({
      ...ga,
      onClick: (ia) => {
        ga != null && ga.onClick && ga.onClick(ia);
      }
    }),
    className: clsx$1(ii == null ? void 0 : ii.className, Hi == null ? void 0 : Hi.backdrop),
    ownerState: ji
  });
  return !Oi && !io && (!Wi || jo) ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(Portal$2, {
    ref: No,
    container: si,
    disablePortal: xi,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(sa, {
      ...Ko,
      children: [!$i && ti ? /* @__PURE__ */ jsxRuntimeExports.jsx(ca, {
        ...pa
      }) : null, /* @__PURE__ */ jsxRuntimeExports.jsx(FocusTrap$2, {
        disableEnforceFocus: Ti,
        disableAutoFocus: mi,
        disableRestoreFocus: Si,
        isEnabled: Ui,
        open: io,
        children: /* @__PURE__ */ React.cloneElement(oi, zo)
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (Modal$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: PropTypes.elementType,
  /**
   * Props applied to the [`Backdrop`](https://mui.com/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: PropTypes.object,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef$2.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: PropTypes.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Backdrop: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    backdrop: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType$2, PropTypes.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: PropTypes.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: PropTypes.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: PropTypes.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: PropTypes.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: PropTypes.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: PropTypes.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: PropTypes.bool,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: PropTypes.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: PropTypes.shape({
    backdrop: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    backdrop: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function getDividerUtilityClass(pt) {
  return generateUtilityClass$2("MuiDivider", pt);
}
const dividerClasses$1 = generateUtilityClasses$2("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]), useUtilityClasses$i = (pt) => {
  const {
    absolute: yt,
    children: ir,
    classes: ti,
    flexItem: ii,
    light: ui,
    orientation: ai,
    textAlign: li,
    variant: oi
  } = pt;
  return composeClasses$2({
    root: ["root", yt && "absolute", oi, ui && "light", ai === "vertical" && "vertical", ii && "flexItem", ir && "withChildren", ir && ai === "vertical" && "withChildrenVertical", li === "right" && ai !== "vertical" && "textAlignRight", li === "left" && ai !== "vertical" && "textAlignLeft"],
    wrapper: ["wrapper", ai === "vertical" && "wrapperVertical"]
  }, getDividerUtilityClass, ti);
}, DividerRoot = styled$3("div", {
  name: "MuiDivider",
  slot: "Root",
  overridesResolver: (pt, yt) => {
    const {
      ownerState: ir
    } = pt;
    return [yt.root, ir.absolute && yt.absolute, yt[ir.variant], ir.light && yt.light, ir.orientation === "vertical" && yt.vertical, ir.flexItem && yt.flexItem, ir.children && yt.withChildren, ir.children && ir.orientation === "vertical" && yt.withChildrenVertical, ir.textAlign === "right" && ir.orientation !== "vertical" && yt.textAlignRight, ir.textAlign === "left" && ir.orientation !== "vertical" && yt.textAlignLeft];
  }
})(memoTheme$1(({
  theme: pt
}) => ({
  margin: 0,
  // Reset browser default style.
  flexShrink: 0,
  borderWidth: 0,
  borderStyle: "solid",
  borderColor: (pt.vars || pt).palette.divider,
  borderBottomWidth: "thin",
  variants: [{
    props: {
      absolute: !0
    },
    style: {
      position: "absolute",
      bottom: 0,
      left: 0,
      width: "100%"
    }
  }, {
    props: {
      light: !0
    },
    style: {
      borderColor: pt.alpha((pt.vars || pt).palette.divider, 0.08)
    }
  }, {
    props: {
      variant: "inset"
    },
    style: {
      marginLeft: 72
    }
  }, {
    props: {
      variant: "middle",
      orientation: "horizontal"
    },
    style: {
      marginLeft: pt.spacing(2),
      marginRight: pt.spacing(2)
    }
  }, {
    props: {
      variant: "middle",
      orientation: "vertical"
    },
    style: {
      marginTop: pt.spacing(1),
      marginBottom: pt.spacing(1)
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      height: "100%",
      borderBottomWidth: 0,
      borderRightWidth: "thin"
    }
  }, {
    props: {
      flexItem: !0
    },
    style: {
      alignSelf: "stretch",
      height: "auto"
    }
  }, {
    props: ({
      ownerState: yt
    }) => !!yt.children,
    style: {
      display: "flex",
      textAlign: "center",
      border: 0,
      borderTopStyle: "solid",
      borderLeftStyle: "solid",
      "&::before, &::after": {
        content: '""',
        alignSelf: "center"
      }
    }
  }, {
    props: ({
      ownerState: yt
    }) => yt.children && yt.orientation !== "vertical",
    style: {
      "&::before, &::after": {
        width: "100%",
        borderTop: `thin solid ${(pt.vars || pt).palette.divider}`,
        borderTopStyle: "inherit"
      }
    }
  }, {
    props: ({
      ownerState: yt
    }) => yt.orientation === "vertical" && yt.children,
    style: {
      flexDirection: "column",
      "&::before, &::after": {
        height: "100%",
        borderLeft: `thin solid ${(pt.vars || pt).palette.divider}`,
        borderLeftStyle: "inherit"
      }
    }
  }, {
    props: ({
      ownerState: yt
    }) => yt.textAlign === "right" && yt.orientation !== "vertical",
    style: {
      "&::before": {
        width: "90%"
      },
      "&::after": {
        width: "10%"
      }
    }
  }, {
    props: ({
      ownerState: yt
    }) => yt.textAlign === "left" && yt.orientation !== "vertical",
    style: {
      "&::before": {
        width: "10%"
      },
      "&::after": {
        width: "90%"
      }
    }
  }]
}))), DividerWrapper = styled$3("span", {
  name: "MuiDivider",
  slot: "Wrapper",
  overridesResolver: (pt, yt) => {
    const {
      ownerState: ir
    } = pt;
    return [yt.wrapper, ir.orientation === "vertical" && yt.wrapperVertical];
  }
})(memoTheme$1(({
  theme: pt
}) => ({
  display: "inline-block",
  paddingLeft: `calc(${pt.spacing(1)} * 1.2)`,
  paddingRight: `calc(${pt.spacing(1)} * 1.2)`,
  whiteSpace: "nowrap",
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      paddingTop: `calc(${pt.spacing(1)} * 1.2)`,
      paddingBottom: `calc(${pt.spacing(1)} * 1.2)`
    }
  }]
}))), Divider = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const ir = useDefaultProps$2({
    props: pt,
    name: "MuiDivider"
  }), {
    absolute: ti = !1,
    children: ii,
    className: ui,
    orientation: ai = "horizontal",
    component: li = ii || ai === "vertical" ? "div" : "hr",
    flexItem: oi = !1,
    light: si = !1,
    role: di = li !== "hr" ? "separator" : void 0,
    textAlign: fi = "center",
    variant: gi = "fullWidth",
    ...mi
  } = ir, Ti = {
    ...ir,
    absolute: ti,
    component: li,
    flexItem: oi,
    light: si,
    orientation: ai,
    role: di,
    textAlign: fi,
    variant: gi
  }, vi = useUtilityClasses$i(Ti);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DividerRoot, {
    as: li,
    className: clsx$1(vi.root, ui),
    role: di,
    ref: yt,
    ownerState: Ti,
    "aria-orientation": di === "separator" && (li !== "hr" || ai === "vertical") ? ai : void 0,
    ...mi,
    children: ii ? /* @__PURE__ */ jsxRuntimeExports.jsx(DividerWrapper, {
      className: vi.wrapper,
      ownerState: Ti,
      children: ii
    }) : null
  });
});
Divider && (Divider.muiSkipListHighlight = !0);
process.env.NODE_ENV !== "production" && (Divider.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Absolutely position the element.
   * @default false
   */
  absolute: PropTypes.bool,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   * @default false
   */
  flexItem: PropTypes.bool,
  /**
   * If `true`, the divider will have a lighter color.
   * @default false
   * @deprecated Use <Divider sx={{ opacity: 0.6 }} /> (or any opacity or color) instead. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  light: PropTypes.bool,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  role: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The text alignment.
   * @default 'center'
   */
  textAlign: PropTypes.oneOf(["center", "left", "right"]),
  /**
   * The variant to use.
   * @default 'fullWidth'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["fullWidth", "inset", "middle"]), PropTypes.string])
});
const useUtilityClasses$h = (pt) => {
  const {
    classes: yt,
    disableUnderline: ir,
    startAdornment: ti,
    endAdornment: ii,
    size: ui,
    hiddenLabel: ai,
    multiline: li
  } = pt, oi = {
    root: ["root", !ir && "underline", ti && "adornedStart", ii && "adornedEnd", ui === "small" && `size${capitalize$1(ui)}`, ai && "hiddenLabel", li && "multiline"],
    input: ["input"]
  }, si = composeClasses$2(oi, getFilledInputUtilityClass, yt);
  return {
    ...yt,
    // forward classes to the InputBase
    ...si
  };
}, FilledInputRoot = styled$3(InputBaseRoot, {
  shouldForwardProp: (pt) => rootShouldForwardProp$1(pt) || pt === "classes",
  name: "MuiFilledInput",
  slot: "Root",
  overridesResolver: (pt, yt) => {
    const {
      ownerState: ir
    } = pt;
    return [...rootOverridesResolver(pt, yt), !ir.disableUnderline && yt.underline];
  }
})(memoTheme$1(({
  theme: pt
}) => {
  const yt = pt.palette.mode === "light", ir = yt ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", ti = yt ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", ii = yt ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", ui = yt ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return {
    position: "relative",
    backgroundColor: pt.vars ? pt.vars.palette.FilledInput.bg : ti,
    borderTopLeftRadius: (pt.vars || pt).shape.borderRadius,
    borderTopRightRadius: (pt.vars || pt).shape.borderRadius,
    transition: pt.transitions.create("background-color", {
      duration: pt.transitions.duration.shorter,
      easing: pt.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: pt.vars ? pt.vars.palette.FilledInput.hoverBg : ii,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: pt.vars ? pt.vars.palette.FilledInput.bg : ti
      }
    },
    [`&.${filledInputClasses.focused}`]: {
      backgroundColor: pt.vars ? pt.vars.palette.FilledInput.bg : ti
    },
    [`&.${filledInputClasses.disabled}`]: {
      backgroundColor: pt.vars ? pt.vars.palette.FilledInput.disabledBg : ui
    },
    variants: [{
      props: ({
        ownerState: ai
      }) => !ai.disableUnderline,
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: pt.transitions.create("transform", {
            duration: pt.transitions.duration.shorter,
            easing: pt.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${filledInputClasses.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${filledInputClasses.error}`]: {
          "&::before, &::after": {
            borderBottomColor: (pt.vars || pt).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${pt.vars ? pt.alpha(pt.vars.palette.common.onBackground, pt.vars.opacity.inputUnderline) : ir}`,
          left: 0,
          bottom: 0,
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: pt.transitions.create("border-bottom-color", {
            duration: pt.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${filledInputClasses.disabled}, .${filledInputClasses.error}):before`]: {
          borderBottom: `1px solid ${(pt.vars || pt).palette.text.primary}`
        },
        [`&.${filledInputClasses.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, ...Object.entries(pt.palette).filter(createSimplePaletteValueFilter$1()).map(([ai]) => {
      var li;
      return {
        props: {
          disableUnderline: !1,
          color: ai
        },
        style: {
          "&::after": {
            borderBottom: `2px solid ${(li = (pt.vars || pt).palette[ai]) == null ? void 0 : li.main}`
          }
        }
      };
    }), {
      props: ({
        ownerState: ai
      }) => ai.startAdornment,
      style: {
        paddingLeft: 12
      }
    }, {
      props: ({
        ownerState: ai
      }) => ai.endAdornment,
      style: {
        paddingRight: 12
      }
    }, {
      props: ({
        ownerState: ai
      }) => ai.multiline,
      style: {
        padding: "25px 12px 8px"
      }
    }, {
      props: ({
        ownerState: ai,
        size: li
      }) => ai.multiline && li === "small",
      style: {
        paddingTop: 21,
        paddingBottom: 4
      }
    }, {
      props: ({
        ownerState: ai
      }) => ai.multiline && ai.hiddenLabel,
      style: {
        paddingTop: 16,
        paddingBottom: 17
      }
    }, {
      props: ({
        ownerState: ai
      }) => ai.multiline && ai.hiddenLabel && ai.size === "small",
      style: {
        paddingTop: 8,
        paddingBottom: 9
      }
    }]
  };
})), FilledInputInput = styled$3(InputBaseInput, {
  name: "MuiFilledInput",
  slot: "Input",
  overridesResolver: inputOverridesResolver
})(memoTheme$1(({
  theme: pt
}) => ({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12,
  ...!pt.vars && {
    "&:-webkit-autofill": {
      WebkitBoxShadow: pt.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
      WebkitTextFillColor: pt.palette.mode === "light" ? null : "#fff",
      caretColor: pt.palette.mode === "light" ? null : "#fff",
      borderTopLeftRadius: "inherit",
      borderTopRightRadius: "inherit"
    }
  },
  ...pt.vars && {
    "&:-webkit-autofill": {
      borderTopLeftRadius: "inherit",
      borderTopRightRadius: "inherit"
    },
    [pt.getColorSchemeSelector("dark")]: {
      "&:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 100px #266798 inset",
        WebkitTextFillColor: "#fff",
        caretColor: "#fff"
      }
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      paddingTop: 21,
      paddingBottom: 4
    }
  }, {
    props: ({
      ownerState: yt
    }) => yt.hiddenLabel,
    style: {
      paddingTop: 16,
      paddingBottom: 17
    }
  }, {
    props: ({
      ownerState: yt
    }) => yt.startAdornment,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      ownerState: yt
    }) => yt.endAdornment,
    style: {
      paddingRight: 0
    }
  }, {
    props: ({
      ownerState: yt
    }) => yt.hiddenLabel && yt.size === "small",
    style: {
      paddingTop: 8,
      paddingBottom: 9
    }
  }, {
    props: ({
      ownerState: yt
    }) => yt.multiline,
    style: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0
    }
  }]
}))), FilledInput = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const ir = useDefaultProps$2({
    props: pt,
    name: "MuiFilledInput"
  }), {
    disableUnderline: ti = !1,
    components: ii = {},
    componentsProps: ui,
    fullWidth: ai = !1,
    hiddenLabel: li,
    // declare here to prevent spreading to DOM
    inputComponent: oi = "input",
    multiline: si = !1,
    slotProps: di,
    slots: fi = {},
    type: gi = "text",
    ...mi
  } = ir, Ti = {
    ...ir,
    disableUnderline: ti,
    fullWidth: ai,
    inputComponent: oi,
    multiline: si,
    type: gi
  }, vi = useUtilityClasses$h(ir), xi = {
    root: {
      ownerState: Ti
    },
    input: {
      ownerState: Ti
    }
  }, Si = di ?? ui ? deepmerge$1(xi, di ?? ui) : xi, Pi = fi.root ?? ii.Root ?? FilledInputRoot, $i = fi.input ?? ii.Input ?? FilledInputInput;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(InputBase, {
    slots: {
      root: Pi,
      input: $i
    },
    slotProps: Si,
    fullWidth: ai,
    inputComponent: oi,
    multiline: si,
    ref: yt,
    type: gi,
    ...mi,
    classes: vi
  });
});
process.env.NODE_ENV !== "production" && (FilledInput.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the input will not have an underline.
   * @default false
   */
  disableUnderline: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: PropTypes.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$2,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#input_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
});
FilledInput.muiName = "Input";
function getScale$2(pt) {
  return `scale(${pt}, ${pt ** 2})`;
}
const styles$3 = {
  entering: {
    opacity: 1,
    transform: getScale$2(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, isWebKit154$1 = typeof navigator < "u" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), Grow$1 = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const {
    addEndListener: ir,
    appear: ti = !0,
    children: ii,
    easing: ui,
    in: ai,
    onEnter: li,
    onEntered: oi,
    onEntering: si,
    onExit: di,
    onExited: fi,
    onExiting: gi,
    style: mi,
    timeout: Ti = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: vi = Transition$1,
    ...xi
  } = pt, Si = useTimeout$1(), Pi = React.useRef(), $i = useTheme$3(), Oi = React.useRef(null), Di = useForkRef$2(Oi, getReactElementRef$2(ii), yt), Mi = (Ni) => (Yi) => {
    if (Ni) {
      const Vo = Oi.current;
      Yi === void 0 ? Ni(Vo) : Ni(Vo, Yi);
    }
  }, Oo = Mi(si), io = Mi((Ni, Yi) => {
    reflow$1(Ni);
    const {
      duration: Vo,
      delay: No,
      easing: Ui
    } = getTransitionProps$1({
      style: mi,
      timeout: Ti,
      easing: ui
    }, {
      mode: "enter"
    });
    let jo;
    Ti === "auto" ? (jo = $i.transitions.getAutoHeightDuration(Ni.clientHeight), Pi.current = jo) : jo = Vo, Ni.style.transition = [$i.transitions.create("opacity", {
      duration: jo,
      delay: No
    }), $i.transitions.create("transform", {
      duration: isWebKit154$1 ? jo : jo * 0.666,
      delay: No,
      easing: Ui
    })].join(","), li && li(Ni, Yi);
  }), xo = Mi(oi), fo = Mi(gi), _o = Mi((Ni) => {
    const {
      duration: Yi,
      delay: Vo,
      easing: No
    } = getTransitionProps$1({
      style: mi,
      timeout: Ti,
      easing: ui
    }, {
      mode: "exit"
    });
    let Ui;
    Ti === "auto" ? (Ui = $i.transitions.getAutoHeightDuration(Ni.clientHeight), Pi.current = Ui) : Ui = Yi, Ni.style.transition = [$i.transitions.create("opacity", {
      duration: Ui,
      delay: Vo
    }), $i.transitions.create("transform", {
      duration: isWebKit154$1 ? Ui : Ui * 0.666,
      delay: isWebKit154$1 ? Vo : Vo || Ui * 0.333,
      easing: No
    })].join(","), Ni.style.opacity = 0, Ni.style.transform = getScale$2(0.75), di && di(Ni);
  }), Li = Mi(fi), Co = (Ni) => {
    Ti === "auto" && Si.start(Pi.current || 0, Ni), ir && ir(Oi.current, Ni);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(vi, {
    appear: ti,
    in: ai,
    nodeRef: Oi,
    onEnter: io,
    onEntered: xo,
    onEntering: Oo,
    onExit: _o,
    onExited: Li,
    onExiting: fo,
    addEndListener: Co,
    timeout: Ti === "auto" ? null : Ti,
    ...xi,
    children: (Ni, {
      ownerState: Yi,
      ...Vo
    }) => /* @__PURE__ */ React.cloneElement(ii, {
      style: {
        opacity: 0,
        transform: getScale$2(0.75),
        visibility: Ni === "exited" && !ai ? "hidden" : void 0,
        ...styles$3[Ni],
        ...mi,
        ...ii.props.style
      },
      ref: Di,
      ...Vo
    })
  });
});
process.env.NODE_ENV !== "production" && (Grow$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: PropTypes.bool,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef$2.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes.func,
  /**
   * @ignore
   */
  onEntered: PropTypes.func,
  /**
   * @ignore
   */
  onEntering: PropTypes.func,
  /**
   * @ignore
   */
  onExit: PropTypes.func,
  /**
   * @ignore
   */
  onExited: PropTypes.func,
  /**
   * @ignore
   */
  onExiting: PropTypes.func,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
});
Grow$1 && (Grow$1.muiSupportAuto = !0);
const useUtilityClasses$g = (pt) => {
  const {
    classes: yt,
    disableUnderline: ir
  } = pt, ti = composeClasses$2({
    root: ["root", !ir && "underline"],
    input: ["input"]
  }, getInputUtilityClass, yt);
  return {
    ...yt,
    // forward classes to the InputBase
    ...ti
  };
}, InputRoot = styled$3(InputBaseRoot, {
  shouldForwardProp: (pt) => rootShouldForwardProp$1(pt) || pt === "classes",
  name: "MuiInput",
  slot: "Root",
  overridesResolver: (pt, yt) => {
    const {
      ownerState: ir
    } = pt;
    return [...rootOverridesResolver(pt, yt), !ir.disableUnderline && yt.underline];
  }
})(memoTheme$1(({
  theme: pt
}) => {
  let yt = pt.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return pt.vars && (yt = pt.alpha(pt.vars.palette.common.onBackground, pt.vars.opacity.inputUnderline)), {
    position: "relative",
    variants: [{
      props: ({
        ownerState: ir
      }) => ir.formControl,
      style: {
        "label + &": {
          marginTop: 16
        }
      }
    }, {
      props: ({
        ownerState: ir
      }) => !ir.disableUnderline,
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: pt.transitions.create("transform", {
            duration: pt.transitions.duration.shorter,
            easing: pt.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${inputClasses.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${inputClasses.error}`]: {
          "&::before, &::after": {
            borderBottomColor: (pt.vars || pt).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${yt}`,
          left: 0,
          bottom: 0,
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: pt.transitions.create("border-bottom-color", {
            duration: pt.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${inputClasses.disabled}, .${inputClasses.error}):before`]: {
          borderBottom: `2px solid ${(pt.vars || pt).palette.text.primary}`,
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            borderBottom: `1px solid ${yt}`
          }
        },
        [`&.${inputClasses.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, ...Object.entries(pt.palette).filter(createSimplePaletteValueFilter$1()).map(([ir]) => ({
      props: {
        color: ir,
        disableUnderline: !1
      },
      style: {
        "&::after": {
          borderBottom: `2px solid ${(pt.vars || pt).palette[ir].main}`
        }
      }
    }))]
  };
})), InputInput = styled$3(InputBaseInput, {
  name: "MuiInput",
  slot: "Input",
  overridesResolver: inputOverridesResolver
})({}), Input = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const ir = useDefaultProps$2({
    props: pt,
    name: "MuiInput"
  }), {
    disableUnderline: ti = !1,
    components: ii = {},
    componentsProps: ui,
    fullWidth: ai = !1,
    inputComponent: li = "input",
    multiline: oi = !1,
    slotProps: si,
    slots: di = {},
    type: fi = "text",
    ...gi
  } = ir, mi = useUtilityClasses$g(ir), Ti = {
    root: {
      ownerState: {
        disableUnderline: ti
      }
    }
  }, vi = si ?? ui ? deepmerge$1(si ?? ui, Ti) : Ti, xi = di.root ?? ii.Root ?? InputRoot, Si = di.input ?? ii.Input ?? InputInput;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(InputBase, {
    slots: {
      root: xi,
      input: Si
    },
    slotProps: vi,
    fullWidth: ai,
    inputComponent: li,
    multiline: oi,
    ref: yt,
    type: fi,
    ...gi,
    classes: mi
  });
});
process.env.NODE_ENV !== "production" && (Input.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the `input` will not have an underline.
   * @default false
   */
  disableUnderline: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: PropTypes.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$2,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#input_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
});
Input.muiName = "Input";
const ListContext$2 = /* @__PURE__ */ React.createContext({});
process.env.NODE_ENV !== "production" && (ListContext$2.displayName = "ListContext");
function getListUtilityClass$1(pt) {
  return generateUtilityClass$2("MuiList", pt);
}
generateUtilityClasses$2("MuiList", ["root", "padding", "dense", "subheader"]);
const useUtilityClasses$f = (pt) => {
  const {
    classes: yt,
    disablePadding: ir,
    dense: ti,
    subheader: ii
  } = pt;
  return composeClasses$2({
    root: ["root", !ir && "padding", ti && "dense", ii && "subheader"]
  }, getListUtilityClass$1, yt);
}, ListRoot$1 = styled$3("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (pt, yt) => {
    const {
      ownerState: ir
    } = pt;
    return [yt.root, !ir.disablePadding && yt.padding, ir.dense && yt.dense, ir.subheader && yt.subheader];
  }
})({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative",
  variants: [{
    props: ({
      ownerState: pt
    }) => !pt.disablePadding,
    style: {
      paddingTop: 8,
      paddingBottom: 8
    }
  }, {
    props: ({
      ownerState: pt
    }) => pt.subheader,
    style: {
      paddingTop: 0
    }
  }]
}), List$1 = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const ir = useDefaultProps$2({
    props: pt,
    name: "MuiList"
  }), {
    children: ti,
    className: ii,
    component: ui = "ul",
    dense: ai = !1,
    disablePadding: li = !1,
    subheader: oi,
    ...si
  } = ir, di = React.useMemo(() => ({
    dense: ai
  }), [ai]), fi = {
    ...ir,
    component: ui,
    dense: ai,
    disablePadding: li
  }, gi = useUtilityClasses$f(fi);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ListContext$2.Provider, {
    value: di,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ListRoot$1, {
      as: ui,
      className: clsx$1(gi.root, ii),
      ref: yt,
      ownerState: fi,
      ...si,
      children: [oi, ti]
    })
  });
});
process.env.NODE_ENV !== "production" && (List$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: PropTypes.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: PropTypes.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const listItemIconClasses$1 = generateUtilityClasses$2("MuiListItemIcon", ["root", "alignItemsFlexStart"]), listItemTextClasses$1 = generateUtilityClasses$2("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]);
function nextItem$1(pt, yt, ir) {
  return pt === yt ? pt.firstChild : yt && yt.nextElementSibling ? yt.nextElementSibling : ir ? null : pt.firstChild;
}
function previousItem$1(pt, yt, ir) {
  return pt === yt ? ir ? pt.firstChild : pt.lastChild : yt && yt.previousElementSibling ? yt.previousElementSibling : ir ? null : pt.lastChild;
}
function textCriteriaMatches$2(pt, yt) {
  if (yt === void 0)
    return !0;
  let ir = pt.innerText;
  return ir === void 0 && (ir = pt.textContent), ir = ir.trim().toLowerCase(), ir.length === 0 ? !1 : yt.repeating ? ir[0] === yt.keys[0] : ir.startsWith(yt.keys.join(""));
}
function moveFocus$1(pt, yt, ir, ti, ii, ui) {
  let ai = !1, li = ii(pt, yt, yt ? ir : !1);
  for (; li; ) {
    if (li === pt.firstChild) {
      if (ai)
        return !1;
      ai = !0;
    }
    const oi = ti ? !1 : li.disabled || li.getAttribute("aria-disabled") === "true";
    if (!li.hasAttribute("tabindex") || !textCriteriaMatches$2(li, ui) || oi)
      li = ii(pt, li, ir);
    else
      return li.focus(), !0;
  }
  return !1;
}
const MenuList$1 = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: ir,
    autoFocus: ti = !1,
    autoFocusItem: ii = !1,
    children: ui,
    className: ai,
    disabledItemsFocusable: li = !1,
    disableListWrap: oi = !1,
    onKeyDown: si,
    variant: di = "selectedMenu",
    ...fi
  } = pt, gi = React.useRef(null), mi = React.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  useEnhancedEffect$2(() => {
    ti && gi.current.focus();
  }, [ti]), React.useImperativeHandle(ir, () => ({
    adjustStyleForScrollbar: (Pi, {
      direction: $i
    }) => {
      const Oi = !gi.current.style.width;
      if (Pi.clientHeight < gi.current.clientHeight && Oi) {
        const Di = `${getScrollbarSize$2(ownerWindow$2(Pi))}px`;
        gi.current.style[$i === "rtl" ? "paddingLeft" : "paddingRight"] = Di, gi.current.style.width = `calc(100% + ${Di})`;
      }
      return gi.current;
    }
  }), []);
  const Ti = (Pi) => {
    const $i = gi.current, Oi = Pi.key;
    if (Pi.ctrlKey || Pi.metaKey || Pi.altKey) {
      si && si(Pi);
      return;
    }
    const Di = activeElement$1(ownerDocument$2($i));
    if (Oi === "ArrowDown")
      Pi.preventDefault(), moveFocus$1($i, Di, oi, li, nextItem$1);
    else if (Oi === "ArrowUp")
      Pi.preventDefault(), moveFocus$1($i, Di, oi, li, previousItem$1);
    else if (Oi === "Home")
      Pi.preventDefault(), moveFocus$1($i, null, oi, li, nextItem$1);
    else if (Oi === "End")
      Pi.preventDefault(), moveFocus$1($i, null, oi, li, previousItem$1);
    else if (Oi.length === 1) {
      const Mi = mi.current, Oo = Oi.toLowerCase(), io = performance.now();
      Mi.keys.length > 0 && (io - Mi.lastTime > 500 ? (Mi.keys = [], Mi.repeating = !0, Mi.previousKeyMatched = !0) : Mi.repeating && Oo !== Mi.keys[0] && (Mi.repeating = !1)), Mi.lastTime = io, Mi.keys.push(Oo);
      const xo = Di && !Mi.repeating && textCriteriaMatches$2(Di, Mi);
      Mi.previousKeyMatched && (xo || moveFocus$1($i, Di, !1, li, nextItem$1, Mi)) ? Pi.preventDefault() : Mi.previousKeyMatched = !1;
    }
    si && si(Pi);
  }, vi = useForkRef$2(gi, yt);
  let xi = -1;
  React.Children.forEach(ui, (Pi, $i) => {
    if (!/* @__PURE__ */ React.isValidElement(Pi)) {
      xi === $i && (xi += 1, xi >= ui.length && (xi = -1));
      return;
    }
    process.env.NODE_ENV !== "production" && reactIsExports$1.isFragment(Pi) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), Pi.props.disabled || (di === "selectedMenu" && Pi.props.selected || xi === -1) && (xi = $i), xi === $i && (Pi.props.disabled || Pi.props.muiSkipListHighlight || Pi.type.muiSkipListHighlight) && (xi += 1, xi >= ui.length && (xi = -1));
  });
  const Si = React.Children.map(ui, (Pi, $i) => {
    if ($i === xi) {
      const Oi = {};
      return ii && (Oi.autoFocus = !0), Pi.props.tabIndex === void 0 && di === "selectedMenu" && (Oi.tabIndex = 0), /* @__PURE__ */ React.cloneElement(Pi, Oi);
    }
    return Pi;
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(List$1, {
    role: "menu",
    ref: vi,
    className: ai,
    onKeyDown: Ti,
    tabIndex: ti ? 0 : -1,
    ...fi,
    children: Si
  });
});
process.env.NODE_ENV !== "production" && (MenuList$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: PropTypes.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: PropTypes.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: PropTypes.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: PropTypes.bool,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: PropTypes.oneOf(["menu", "selectedMenu"])
});
function getPopoverUtilityClass$1(pt) {
  return generateUtilityClass$2("MuiPopover", pt);
}
generateUtilityClasses$2("MuiPopover", ["root", "paper"]);
function getOffsetTop$1(pt, yt) {
  let ir = 0;
  return typeof yt == "number" ? ir = yt : yt === "center" ? ir = pt.height / 2 : yt === "bottom" && (ir = pt.height), ir;
}
function getOffsetLeft$1(pt, yt) {
  let ir = 0;
  return typeof yt == "number" ? ir = yt : yt === "center" ? ir = pt.width / 2 : yt === "right" && (ir = pt.width), ir;
}
function getTransformOriginValue$1(pt) {
  return [pt.horizontal, pt.vertical].map((yt) => typeof yt == "number" ? `${yt}px` : yt).join(" ");
}
function resolveAnchorEl$1(pt) {
  return typeof pt == "function" ? pt() : pt;
}
const useUtilityClasses$e = (pt) => {
  const {
    classes: yt
  } = pt;
  return composeClasses$2({
    root: ["root"],
    paper: ["paper"]
  }, getPopoverUtilityClass$1, yt);
}, PopoverRoot$1 = styled$3(Modal$1, {
  name: "MuiPopover",
  slot: "Root"
})({}), PopoverPaper$1 = styled$3(Paper$1, {
  name: "MuiPopover",
  slot: "Paper"
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), Popover$1 = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const ir = useDefaultProps$2({
    props: pt,
    name: "MuiPopover"
  }), {
    action: ti,
    anchorEl: ii,
    anchorOrigin: ui = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: ai,
    anchorReference: li = "anchorEl",
    children: oi,
    className: si,
    container: di,
    elevation: fi = 8,
    marginThreshold: gi = 16,
    open: mi,
    PaperProps: Ti = {},
    // TODO: remove in v7
    slots: vi = {},
    slotProps: xi = {},
    transformOrigin: Si = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: Pi,
    // TODO: remove in v7
    transitionDuration: $i = "auto",
    TransitionProps: Oi = {},
    // TODO: remove in v7
    disableScrollLock: Di = !1,
    ...Mi
  } = ir, Oo = React.useRef(), io = {
    ...ir,
    anchorOrigin: ui,
    anchorReference: li,
    elevation: fi,
    marginThreshold: gi,
    transformOrigin: Si,
    TransitionComponent: Pi,
    transitionDuration: $i,
    TransitionProps: Oi
  }, xo = useUtilityClasses$e(io), fo = React.useCallback(() => {
    if (li === "anchorPosition")
      return process.env.NODE_ENV !== "production" && (ai || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), ai;
    const ga = resolveAnchorEl$1(ii), ia = ga && ga.nodeType === 1 ? ga : ownerDocument$2(Oo.current).body, ra = ia.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      const qo = ia.getBoundingClientRect();
      isLayoutSupported$1() && qo.top === 0 && qo.left === 0 && qo.right === 0 && qo.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: ra.top + getOffsetTop$1(ra, ui.vertical),
      left: ra.left + getOffsetLeft$1(ra, ui.horizontal)
    };
  }, [ii, ui.horizontal, ui.vertical, ai, li]), _o = React.useCallback((ga) => ({
    vertical: getOffsetTop$1(ga, Si.vertical),
    horizontal: getOffsetLeft$1(ga, Si.horizontal)
  }), [Si.horizontal, Si.vertical]), Li = React.useCallback((ga) => {
    const ia = {
      width: ga.offsetWidth,
      height: ga.offsetHeight
    }, ra = _o(ia);
    if (li === "none")
      return {
        top: null,
        left: null,
        transformOrigin: getTransformOriginValue$1(ra)
      };
    const qo = fo();
    let xa = qo.top - ra.vertical, $a = qo.left - ra.horizontal;
    const ys = xa + ia.height, Ss = $a + ia.width, Xa = ownerWindow$2(resolveAnchorEl$1(ii)), Es = Xa.innerHeight - gi, Rs = Xa.innerWidth - gi;
    if (gi !== null && xa < gi) {
      const La = xa - gi;
      xa -= La, ra.vertical += La;
    } else if (gi !== null && ys > Es) {
      const La = ys - Es;
      xa -= La, ra.vertical += La;
    }
    if (process.env.NODE_ENV !== "production" && ia.height > Es && ia.height && Es && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${ia.height - Es}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), gi !== null && $a < gi) {
      const La = $a - gi;
      $a -= La, ra.horizontal += La;
    } else if (Ss > Rs) {
      const La = Ss - Rs;
      $a -= La, ra.horizontal += La;
    }
    return {
      top: `${Math.round(xa)}px`,
      left: `${Math.round($a)}px`,
      transformOrigin: getTransformOriginValue$1(ra)
    };
  }, [ii, li, fo, _o, gi]), [Co, Ni] = React.useState(mi), Yi = React.useCallback(() => {
    const ga = Oo.current;
    if (!ga)
      return;
    const ia = Li(ga);
    ia.top !== null && ga.style.setProperty("top", ia.top), ia.left !== null && (ga.style.left = ia.left), ga.style.transformOrigin = ia.transformOrigin, Ni(!0);
  }, [Li]);
  React.useEffect(() => (Di && window.addEventListener("scroll", Yi), () => window.removeEventListener("scroll", Yi)), [ii, Di, Yi]);
  const Vo = () => {
    Yi();
  }, No = () => {
    Ni(!1);
  };
  React.useEffect(() => {
    mi && Yi();
  }), React.useImperativeHandle(ti, () => mi ? {
    updatePosition: () => {
      Yi();
    }
  } : null, [mi, Yi]), React.useEffect(() => {
    if (!mi)
      return;
    const ga = debounce$2(() => {
      Yi();
    }), ia = ownerWindow$2(resolveAnchorEl$1(ii));
    return ia.addEventListener("resize", ga), () => {
      ga.clear(), ia.removeEventListener("resize", ga);
    };
  }, [ii, mi, Yi]);
  let Ui = $i;
  const jo = {
    slots: {
      transition: Pi,
      ...vi
    },
    slotProps: {
      transition: Oi,
      paper: Ti,
      ...xi
    }
  }, [Wi, ji] = useSlot$1("transition", {
    elementType: Grow$1,
    externalForwardedProps: jo,
    ownerState: io,
    getSlotProps: (ga) => ({
      ...ga,
      onEntering: (ia, ra) => {
        var qo;
        (qo = ga.onEntering) == null || qo.call(ga, ia, ra), Vo();
      },
      onExited: (ia) => {
        var ra;
        (ra = ga.onExited) == null || ra.call(ga, ia), No();
      }
    }),
    additionalProps: {
      appear: !0,
      in: mi
    }
  });
  $i === "auto" && !Wi.muiSupportAuto && (Ui = void 0);
  const Hi = di || (ii ? ownerDocument$2(resolveAnchorEl$1(ii)).body : void 0), [zo, {
    slots: Lo,
    slotProps: sa,
    ...Ko
  }] = useSlot$1("root", {
    ref: yt,
    elementType: PopoverRoot$1,
    externalForwardedProps: {
      ...jo,
      ...Mi
    },
    shouldForwardComponentProp: !0,
    additionalProps: {
      slots: {
        backdrop: vi.backdrop
      },
      slotProps: {
        backdrop: mergeSlotProps$3(typeof xi.backdrop == "function" ? xi.backdrop(io) : xi.backdrop, {
          invisible: !0
        })
      },
      container: Hi,
      open: mi
    },
    ownerState: io,
    className: clsx$1(xo.root, si)
  }), [ca, pa] = useSlot$1("paper", {
    ref: Oo,
    className: xo.paper,
    elementType: PopoverPaper$1,
    externalForwardedProps: jo,
    shouldForwardComponentProp: !0,
    additionalProps: {
      elevation: fi,
      style: Co ? void 0 : {
        opacity: 0
      }
    },
    ownerState: io
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(zo, {
    ...Ko,
    ...!isHostComponent$3(zo) && {
      slots: Lo,
      slotProps: sa,
      disableScrollLock: Di
    },
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(Wi, {
      ...ji,
      timeout: Ui,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(ca, {
        ...pa,
        children: oi
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (Popover$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: refType$2,
  /**
   * An HTML element, [PopoverVirtualElement](https://mui.com/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: chainPropTypes$2(PropTypes.oneOfType([HTMLElementType$2, PropTypes.func]), (pt) => {
    if (pt.open && (!pt.anchorReference || pt.anchorReference === "anchorEl")) {
      const yt = resolveAnchorEl$1(pt.anchorEl);
      if (yt && yt.nodeType === 1) {
        const ir = yt.getBoundingClientRect();
        if (process.env.NODE_ENV !== "production" && isLayoutSupported$1() && ir.top === 0 && ir.left === 0 && ir.right === 0 && ir.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${yt}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.oneOf(["center", "left", "right"]), PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.oneOf(["bottom", "center", "top"]), PropTypes.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: PropTypes.shape({
    left: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: PropTypes.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: PropTypes.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  BackdropProps: PropTypes.object,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType$2, PropTypes.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: PropTypes.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: integerPropType$1,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: PropTypes.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overridden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: PropTypes.shape({
    component: elementTypeAcceptingRef$1$1
  }),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    backdrop: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    paper: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    transition: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    backdrop: PropTypes.elementType,
    paper: PropTypes.elementType,
    root: PropTypes.elementType,
    transition: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.oneOf(["center", "left", "right"]), PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.oneOf(["bottom", "center", "top"]), PropTypes.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated use the `slots.transition` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default Grow
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: PropTypes.object
});
function getMenuUtilityClass$2(pt) {
  return generateUtilityClass$2("MuiMenu", pt);
}
generateUtilityClasses$2("MuiMenu", ["root", "paper", "list"]);
const RTL_ORIGIN$1 = {
  vertical: "top",
  horizontal: "right"
}, LTR_ORIGIN$1 = {
  vertical: "top",
  horizontal: "left"
}, useUtilityClasses$d = (pt) => {
  const {
    classes: yt
  } = pt;
  return composeClasses$2({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, getMenuUtilityClass$2, yt);
}, MenuRoot$1 = styled$3(Popover$1, {
  shouldForwardProp: (pt) => rootShouldForwardProp$1(pt) || pt === "classes",
  name: "MuiMenu",
  slot: "Root"
})({}), MenuPaper$1 = styled$3(PopoverPaper$1, {
  name: "MuiMenu",
  slot: "Paper"
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), MenuMenuList$1 = styled$3(MenuList$1, {
  name: "MuiMenu",
  slot: "List"
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), Menu$2 = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const ir = useDefaultProps$2({
    props: pt,
    name: "MuiMenu"
  }), {
    autoFocus: ti = !0,
    children: ii,
    className: ui,
    disableAutoFocusItem: ai = !1,
    MenuListProps: li = {},
    onClose: oi,
    open: si,
    PaperProps: di = {},
    PopoverClasses: fi,
    transitionDuration: gi = "auto",
    TransitionProps: {
      onEntering: mi,
      ...Ti
    } = {},
    variant: vi = "selectedMenu",
    slots: xi = {},
    slotProps: Si = {},
    ...Pi
  } = ir, $i = useRtl$1(), Oi = {
    ...ir,
    autoFocus: ti,
    disableAutoFocusItem: ai,
    MenuListProps: li,
    onEntering: mi,
    PaperProps: di,
    transitionDuration: gi,
    TransitionProps: Ti,
    variant: vi
  }, Di = useUtilityClasses$d(Oi), Mi = ti && !ai && si, Oo = React.useRef(null), io = (Ui, jo) => {
    Oo.current && Oo.current.adjustStyleForScrollbar(Ui, {
      direction: $i ? "rtl" : "ltr"
    }), mi && mi(Ui, jo);
  }, xo = (Ui) => {
    Ui.key === "Tab" && (Ui.preventDefault(), oi && oi(Ui, "tabKeyDown"));
  };
  let fo = -1;
  React.Children.map(ii, (Ui, jo) => {
    /* @__PURE__ */ React.isValidElement(Ui) && (process.env.NODE_ENV !== "production" && reactIsExports$1.isFragment(Ui) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), Ui.props.disabled || (vi === "selectedMenu" && Ui.props.selected || fo === -1) && (fo = jo));
  });
  const _o = {
    slots: xi,
    slotProps: {
      list: li,
      transition: Ti,
      paper: di,
      ...Si
    }
  }, Li = useSlotProps$2({
    elementType: xi.root,
    externalSlotProps: Si.root,
    ownerState: Oi,
    className: [Di.root, ui]
  }), [Co, Ni] = useSlot$1("paper", {
    className: Di.paper,
    elementType: MenuPaper$1,
    externalForwardedProps: _o,
    shouldForwardComponentProp: !0,
    ownerState: Oi
  }), [Yi, Vo] = useSlot$1("list", {
    className: clsx$1(Di.list, li.className),
    elementType: MenuMenuList$1,
    shouldForwardComponentProp: !0,
    externalForwardedProps: _o,
    getSlotProps: (Ui) => ({
      ...Ui,
      onKeyDown: (jo) => {
        var Wi;
        xo(jo), (Wi = Ui.onKeyDown) == null || Wi.call(Ui, jo);
      }
    }),
    ownerState: Oi
  }), No = typeof _o.slotProps.transition == "function" ? _o.slotProps.transition(Oi) : _o.slotProps.transition;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MenuRoot$1, {
    onClose: oi,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: $i ? "right" : "left"
    },
    transformOrigin: $i ? RTL_ORIGIN$1 : LTR_ORIGIN$1,
    slots: {
      root: xi.root,
      paper: Co,
      backdrop: xi.backdrop,
      ...xi.transition && {
        // TODO: pass `slots.transition` directly once `TransitionComponent` is removed from Popover
        transition: xi.transition
      }
    },
    slotProps: {
      root: Li,
      paper: Ni,
      backdrop: typeof Si.backdrop == "function" ? Si.backdrop(Oi) : Si.backdrop,
      transition: {
        ...No,
        onEntering: (...Ui) => {
          var jo;
          io(...Ui), (jo = No == null ? void 0 : No.onEntering) == null || jo.call(No, ...Ui);
        }
      }
    },
    open: si,
    ref: yt,
    transitionDuration: gi,
    ownerState: Oi,
    ...Pi,
    classes: fi,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(Yi, {
      actions: Oo,
      autoFocus: ti && (fo === -1 || ai),
      autoFocusItem: Mi,
      variant: vi,
      ...Vo,
      children: ii
    })
  });
});
process.env.NODE_ENV !== "production" && (Menu$2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: PropTypes.oneOfType([HTMLElementType$2, PropTypes.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: PropTypes.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: PropTypes.bool,
  /**
   * Props applied to the [`MenuList`](https://mui.com/material-ui/api/menu-list/) element.
   * @deprecated use the `slotProps.list` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  MenuListProps: PropTypes.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: PropTypes.object,
  /**
   * `classes` prop applied to the [`Popover`](https://mui.com/material-ui/api/popover/) element.
   */
  PopoverClasses: PropTypes.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    backdrop: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    list: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    paper: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    transition: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    backdrop: PropTypes.elementType,
    list: PropTypes.elementType,
    paper: PropTypes.elementType,
    root: PropTypes.elementType,
    transition: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: PropTypes.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: PropTypes.oneOf(["menu", "selectedMenu"])
});
function getMenuItemUtilityClass$1(pt) {
  return generateUtilityClass$2("MuiMenuItem", pt);
}
const menuItemClasses$1 = generateUtilityClasses$2("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]), overridesResolver$1$1 = (pt, yt) => {
  const {
    ownerState: ir
  } = pt;
  return [yt.root, ir.dense && yt.dense, ir.divider && yt.divider, !ir.disableGutters && yt.gutters];
}, useUtilityClasses$c = (pt) => {
  const {
    disabled: yt,
    dense: ir,
    divider: ti,
    disableGutters: ii,
    selected: ui,
    classes: ai
  } = pt, li = composeClasses$2({
    root: ["root", ir && "dense", yt && "disabled", !ii && "gutters", ti && "divider", ui && "selected"]
  }, getMenuItemUtilityClass$1, ai);
  return {
    ...ai,
    ...li
  };
}, MenuItemRoot$1 = styled$3(ButtonBase$1, {
  shouldForwardProp: (pt) => rootShouldForwardProp$1(pt) || pt === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver: overridesResolver$1$1
})(memoTheme$1(({
  theme: pt
}) => ({
  ...pt.typography.body1,
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap",
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (pt.vars || pt).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${menuItemClasses$1.selected}`]: {
    backgroundColor: pt.alpha((pt.vars || pt).palette.primary.main, (pt.vars || pt).palette.action.selectedOpacity),
    [`&.${menuItemClasses$1.focusVisible}`]: {
      backgroundColor: pt.alpha((pt.vars || pt).palette.primary.main, `${(pt.vars || pt).palette.action.selectedOpacity} + ${(pt.vars || pt).palette.action.focusOpacity}`)
    }
  },
  [`&.${menuItemClasses$1.selected}:hover`]: {
    backgroundColor: pt.alpha((pt.vars || pt).palette.primary.main, `${(pt.vars || pt).palette.action.selectedOpacity} + ${(pt.vars || pt).palette.action.hoverOpacity}`),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: pt.alpha((pt.vars || pt).palette.primary.main, (pt.vars || pt).palette.action.selectedOpacity)
    }
  },
  [`&.${menuItemClasses$1.focusVisible}`]: {
    backgroundColor: (pt.vars || pt).palette.action.focus
  },
  [`&.${menuItemClasses$1.disabled}`]: {
    opacity: (pt.vars || pt).palette.action.disabledOpacity
  },
  [`& + .${dividerClasses$1.root}`]: {
    marginTop: pt.spacing(1),
    marginBottom: pt.spacing(1)
  },
  [`& + .${dividerClasses$1.inset}`]: {
    marginLeft: 52
  },
  [`& .${listItemTextClasses$1.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${listItemTextClasses$1.inset}`]: {
    paddingLeft: 36
  },
  [`& .${listItemIconClasses$1.root}`]: {
    minWidth: 36
  },
  variants: [{
    props: ({
      ownerState: yt
    }) => !yt.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: yt
    }) => yt.divider,
    style: {
      borderBottom: `1px solid ${(pt.vars || pt).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: ({
      ownerState: yt
    }) => !yt.dense,
    style: {
      [pt.breakpoints.up("sm")]: {
        minHeight: "auto"
      }
    }
  }, {
    props: ({
      ownerState: yt
    }) => yt.dense,
    style: {
      minHeight: 32,
      // https://m2.material.io/components/menus#specs > Dense
      paddingTop: 4,
      paddingBottom: 4,
      ...pt.typography.body2,
      [`& .${listItemIconClasses$1.root} svg`]: {
        fontSize: "1.25rem"
      }
    }
  }]
}))), MenuItem$1 = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const ir = useDefaultProps$2({
    props: pt,
    name: "MuiMenuItem"
  }), {
    autoFocus: ti = !1,
    component: ii = "li",
    dense: ui = !1,
    divider: ai = !1,
    disableGutters: li = !1,
    focusVisibleClassName: oi,
    role: si = "menuitem",
    tabIndex: di,
    className: fi,
    ...gi
  } = ir, mi = React.useContext(ListContext$2), Ti = React.useMemo(() => ({
    dense: ui || mi.dense || !1,
    disableGutters: li
  }), [mi.dense, ui, li]), vi = React.useRef(null);
  useEnhancedEffect$2(() => {
    ti && (vi.current ? vi.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered."));
  }, [ti]);
  const xi = {
    ...ir,
    dense: Ti.dense,
    divider: ai,
    disableGutters: li
  }, Si = useUtilityClasses$c(ir), Pi = useForkRef$2(vi, yt);
  let $i;
  return ir.disabled || ($i = di !== void 0 ? di : -1), /* @__PURE__ */ jsxRuntimeExports.jsx(ListContext$2.Provider, {
    value: Ti,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItemRoot$1, {
      ref: Pi,
      role: si,
      tabIndex: $i,
      component: ii,
      focusVisibleClassName: clsx$1(Si.focusVisible, oi),
      className: clsx$1(Si.root, fi),
      ...gi,
      ownerState: xi,
      classes: Si
    })
  });
});
process.env.NODE_ENV !== "production" && (MenuItem$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: PropTypes.bool,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: PropTypes.bool,
  /**
   * @ignore
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: PropTypes.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: PropTypes.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * @ignore
   */
  role: PropTypes.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @default 0
   */
  tabIndex: PropTypes.number
});
function getNativeSelectUtilityClasses(pt) {
  return generateUtilityClass$2("MuiNativeSelect", pt);
}
const nativeSelectClasses = generateUtilityClasses$2("MuiNativeSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]), useUtilityClasses$b = (pt) => {
  const {
    classes: yt,
    variant: ir,
    disabled: ti,
    multiple: ii,
    open: ui,
    error: ai
  } = pt, li = {
    select: ["select", ir, ti && "disabled", ii && "multiple", ai && "error"],
    icon: ["icon", `icon${capitalize$1(ir)}`, ui && "iconOpen", ti && "disabled"]
  };
  return composeClasses$2(li, getNativeSelectUtilityClasses, yt);
}, StyledSelectSelect = styled$3("select", {
  name: "MuiNativeSelect"
})(({
  theme: pt
}) => ({
  // Reset
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: "none",
  // Reset
  borderRadius: 0,
  cursor: "pointer",
  "&:focus": {
    // Reset Chrome style
    borderRadius: 0
  },
  [`&.${nativeSelectClasses.disabled}`]: {
    cursor: "default"
  },
  "&[multiple]": {
    height: "auto"
  },
  "&:not([multiple]) option, &:not([multiple]) optgroup": {
    backgroundColor: (pt.vars || pt).palette.background.paper
  },
  variants: [{
    props: ({
      ownerState: yt
    }) => yt.variant !== "filled" && yt.variant !== "outlined",
    style: {
      // Bump specificity to allow extending custom inputs
      "&&&": {
        paddingRight: 24,
        minWidth: 16
        // So it doesn't collapse.
      }
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      "&&&": {
        paddingRight: 32
      }
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      borderRadius: (pt.vars || pt).shape.borderRadius,
      "&:focus": {
        borderRadius: (pt.vars || pt).shape.borderRadius
        // Reset the reset for Chrome style
      },
      "&&&": {
        paddingRight: 32
      }
    }
  }]
})), NativeSelectSelect = styled$3(StyledSelectSelect, {
  name: "MuiNativeSelect",
  slot: "Select",
  shouldForwardProp: rootShouldForwardProp$1,
  overridesResolver: (pt, yt) => {
    const {
      ownerState: ir
    } = pt;
    return [yt.select, yt[ir.variant], ir.error && yt.error, {
      [`&.${nativeSelectClasses.multiple}`]: yt.multiple
    }];
  }
})({}), StyledSelectIcon = styled$3("svg", {
  name: "MuiNativeSelect"
})(({
  theme: pt
}) => ({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: "absolute",
  right: 0,
  // Center vertically, height is 1em
  top: "calc(50% - .5em)",
  // Don't block pointer events on the select under the icon.
  pointerEvents: "none",
  color: (pt.vars || pt).palette.action.active,
  [`&.${nativeSelectClasses.disabled}`]: {
    color: (pt.vars || pt).palette.action.disabled
  },
  variants: [{
    props: ({
      ownerState: yt
    }) => yt.open,
    style: {
      transform: "rotate(180deg)"
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      right: 7
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      right: 7
    }
  }]
})), NativeSelectIcon = styled$3(StyledSelectIcon, {
  name: "MuiNativeSelect",
  slot: "Icon",
  overridesResolver: (pt, yt) => {
    const {
      ownerState: ir
    } = pt;
    return [yt.icon, ir.variant && yt[`icon${capitalize$1(ir.variant)}`], ir.open && yt.iconOpen];
  }
})({}), NativeSelectInput = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const {
    className: ir,
    disabled: ti,
    error: ii,
    IconComponent: ui,
    inputRef: ai,
    variant: li = "standard",
    ...oi
  } = pt, si = {
    ...pt,
    disabled: ti,
    variant: li,
    error: ii
  }, di = useUtilityClasses$b(si);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(NativeSelectSelect, {
      ownerState: si,
      className: clsx$1(di.select, ir),
      disabled: ti,
      ref: ai || yt,
      ...oi
    }), pt.multiple ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(NativeSelectIcon, {
      as: ui,
      ownerState: si,
      className: di.icon
    })]
  });
});
process.env.NODE_ENV !== "production" && (NativeSelectInput.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The CSS class name of the select element.
   */
  className: PropTypes.string,
  /**
   * If `true`, the select is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: PropTypes.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType.isRequired,
  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: refType$2,
  /**
   * @ignore
   */
  multiple: PropTypes.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The input value.
   */
  value: PropTypes.any,
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(["standard", "outlined", "filled"])
});
var _span$1;
const NotchedOutlineRoot$1 = styled$3("fieldset", {
  name: "MuiNotchedOutlined",
  shouldForwardProp: rootShouldForwardProp$1
})({
  textAlign: "left",
  position: "absolute",
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: "0 8px",
  pointerEvents: "none",
  borderRadius: "inherit",
  borderStyle: "solid",
  borderWidth: 1,
  overflow: "hidden",
  minWidth: "0%"
}), NotchedOutlineLegend = styled$3("legend", {
  name: "MuiNotchedOutlined",
  shouldForwardProp: rootShouldForwardProp$1
})(memoTheme$1(({
  theme: pt
}) => ({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden",
  // Fix Horizontal scroll when label too long
  variants: [{
    props: ({
      ownerState: yt
    }) => !yt.withLabel,
    style: {
      padding: 0,
      lineHeight: "11px",
      // sync with `height` in `legend` styles
      transition: pt.transitions.create("width", {
        duration: 150,
        easing: pt.transitions.easing.easeOut
      })
    }
  }, {
    props: ({
      ownerState: yt
    }) => yt.withLabel,
    style: {
      display: "block",
      // Fix conflict with normalize.css and sanitize.css
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: "0.75em",
      visibility: "hidden",
      maxWidth: 0.01,
      transition: pt.transitions.create("max-width", {
        duration: 50,
        easing: pt.transitions.easing.easeOut
      }),
      whiteSpace: "nowrap",
      "& > span": {
        paddingLeft: 5,
        paddingRight: 5,
        display: "inline-block",
        opacity: 0,
        visibility: "visible"
      }
    }
  }, {
    props: ({
      ownerState: yt
    }) => yt.withLabel && yt.notched,
    style: {
      maxWidth: "100%",
      transition: pt.transitions.create("max-width", {
        duration: 100,
        easing: pt.transitions.easing.easeOut,
        delay: 50
      })
    }
  }]
})));
function NotchedOutline(pt) {
  const {
    children: yt,
    classes: ir,
    className: ti,
    label: ii,
    notched: ui,
    ...ai
  } = pt, li = ii != null && ii !== "", oi = {
    ...pt,
    notched: ui,
    withLabel: li
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(NotchedOutlineRoot$1, {
    "aria-hidden": !0,
    className: ti,
    ownerState: oi,
    ...ai,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(NotchedOutlineLegend, {
      ownerState: oi,
      children: li ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
        children: ii
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        _span$1 || (_span$1 = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
          className: "notranslate",
          "aria-hidden": !0,
          children: "​"
        }))
      )
    })
  });
}
process.env.NODE_ENV !== "production" && (NotchedOutline.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The label.
   */
  label: PropTypes.node,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: PropTypes.bool.isRequired,
  /**
   * @ignore
   */
  style: PropTypes.object
});
const useUtilityClasses$a$1 = (pt) => {
  const {
    classes: yt
  } = pt, ir = composeClasses$2({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, getOutlinedInputUtilityClass, yt);
  return {
    ...yt,
    // forward classes to the InputBase
    ...ir
  };
}, OutlinedInputRoot = styled$3(InputBaseRoot, {
  shouldForwardProp: (pt) => rootShouldForwardProp$1(pt) || pt === "classes",
  name: "MuiOutlinedInput",
  slot: "Root",
  overridesResolver: rootOverridesResolver
})(memoTheme$1(({
  theme: pt
}) => {
  const yt = pt.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    position: "relative",
    borderRadius: (pt.vars || pt).shape.borderRadius,
    [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
      borderColor: (pt.vars || pt).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
        borderColor: pt.vars ? pt.alpha(pt.vars.palette.common.onBackground, 0.23) : yt
      }
    },
    [`&.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: {
      borderWidth: 2
    },
    variants: [...Object.entries(pt.palette).filter(createSimplePaletteValueFilter$1()).map(([ir]) => ({
      props: {
        color: ir
      },
      style: {
        [`&.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: {
          borderColor: (pt.vars || pt).palette[ir].main
        }
      }
    })), {
      props: {},
      // to override the above style
      style: {
        [`&.${outlinedInputClasses.error} .${outlinedInputClasses.notchedOutline}`]: {
          borderColor: (pt.vars || pt).palette.error.main
        },
        [`&.${outlinedInputClasses.disabled} .${outlinedInputClasses.notchedOutline}`]: {
          borderColor: (pt.vars || pt).palette.action.disabled
        }
      }
    }, {
      props: ({
        ownerState: ir
      }) => ir.startAdornment,
      style: {
        paddingLeft: 14
      }
    }, {
      props: ({
        ownerState: ir
      }) => ir.endAdornment,
      style: {
        paddingRight: 14
      }
    }, {
      props: ({
        ownerState: ir
      }) => ir.multiline,
      style: {
        padding: "16.5px 14px"
      }
    }, {
      props: ({
        ownerState: ir,
        size: ti
      }) => ir.multiline && ti === "small",
      style: {
        padding: "8.5px 14px"
      }
    }]
  };
})), NotchedOutlineRoot = styled$3(NotchedOutline, {
  name: "MuiOutlinedInput",
  slot: "NotchedOutline"
})(memoTheme$1(({
  theme: pt
}) => {
  const yt = pt.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    borderColor: pt.vars ? pt.alpha(pt.vars.palette.common.onBackground, 0.23) : yt
  };
})), OutlinedInputInput = styled$3(InputBaseInput, {
  name: "MuiOutlinedInput",
  slot: "Input",
  overridesResolver: inputOverridesResolver
})(memoTheme$1(({
  theme: pt
}) => ({
  padding: "16.5px 14px",
  ...!pt.vars && {
    "&:-webkit-autofill": {
      WebkitBoxShadow: pt.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
      WebkitTextFillColor: pt.palette.mode === "light" ? null : "#fff",
      caretColor: pt.palette.mode === "light" ? null : "#fff",
      borderRadius: "inherit"
    }
  },
  ...pt.vars && {
    "&:-webkit-autofill": {
      borderRadius: "inherit"
    },
    [pt.getColorSchemeSelector("dark")]: {
      "&:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 100px #266798 inset",
        WebkitTextFillColor: "#fff",
        caretColor: "#fff"
      }
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      padding: "8.5px 14px"
    }
  }, {
    props: ({
      ownerState: yt
    }) => yt.multiline,
    style: {
      padding: 0
    }
  }, {
    props: ({
      ownerState: yt
    }) => yt.startAdornment,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      ownerState: yt
    }) => yt.endAdornment,
    style: {
      paddingRight: 0
    }
  }]
}))), OutlinedInput = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const ir = useDefaultProps$2({
    props: pt,
    name: "MuiOutlinedInput"
  }), {
    components: ti = {},
    fullWidth: ii = !1,
    inputComponent: ui = "input",
    label: ai,
    multiline: li = !1,
    notched: oi,
    slots: si = {},
    slotProps: di = {},
    type: fi = "text",
    ...gi
  } = ir, mi = useUtilityClasses$a$1(ir), Ti = useFormControl(), vi = formControlState({
    props: ir,
    muiFormControl: Ti,
    states: ["color", "disabled", "error", "focused", "hiddenLabel", "size", "required"]
  }), xi = {
    ...ir,
    color: vi.color || "primary",
    disabled: vi.disabled,
    error: vi.error,
    focused: vi.focused,
    formControl: Ti,
    fullWidth: ii,
    hiddenLabel: vi.hiddenLabel,
    multiline: li,
    size: vi.size,
    type: fi
  }, Si = si.root ?? ti.Root ?? OutlinedInputRoot, Pi = si.input ?? ti.Input ?? OutlinedInputInput, [$i, Oi] = useSlot$1("notchedOutline", {
    elementType: NotchedOutlineRoot,
    className: mi.notchedOutline,
    shouldForwardComponentProp: !0,
    ownerState: xi,
    externalForwardedProps: {
      slots: si,
      slotProps: di
    },
    additionalProps: {
      label: ai != null && ai !== "" && vi.required ? /* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
        children: [ai, " ", "*"]
      }) : ai
    }
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(InputBase, {
    slots: {
      root: Si,
      input: Pi
    },
    slotProps: di,
    renderSuffix: (Di) => /* @__PURE__ */ jsxRuntimeExports.jsx($i, {
      ...Oi,
      notched: typeof oi < "u" ? oi : !!(Di.startAdornment || Di.filled || Di.focused)
    }),
    fullWidth: ii,
    inputComponent: ui,
    multiline: li,
    ref: yt,
    type: fi,
    ...gi,
    classes: {
      ...mi,
      notchedOutline: null
    }
  });
});
process.env.NODE_ENV !== "production" && (OutlinedInput.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: PropTypes.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType$2,
  /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */
  label: PropTypes.node,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: PropTypes.bool,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.object,
    notchedOutline: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    notchedOutline: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#input_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
});
OutlinedInput.muiName = "Input";
function getPaginationUtilityClass$1(pt) {
  return generateUtilityClass$2("MuiPagination", pt);
}
generateUtilityClasses$2("MuiPagination", ["root", "ul", "outlined", "text"]);
function usePagination$1(pt = {}) {
  const {
    boundaryCount: yt = 1,
    componentName: ir = "usePagination",
    count: ti = 1,
    defaultPage: ii = 1,
    disabled: ui = !1,
    hideNextButton: ai = !1,
    hidePrevButton: li = !1,
    onChange: oi,
    page: si,
    showFirstButton: di = !1,
    showLastButton: fi = !1,
    siblingCount: gi = 1,
    ...mi
  } = pt, [Ti, vi] = useControlled$2({
    controlled: si,
    default: ii,
    name: ir,
    state: "page"
  }), xi = (io, xo) => {
    si || vi(xo), oi && oi(io, xo);
  }, Si = (io, xo) => {
    const fo = xo - io + 1;
    return Array.from({
      length: fo
    }, (_o, Li) => io + Li);
  }, Pi = Si(1, Math.min(yt, ti)), $i = Si(Math.max(ti - yt + 1, yt + 1), ti), Oi = Math.max(
    Math.min(
      // Natural start
      Ti - gi,
      // Lower boundary when page is high
      ti - yt - gi * 2 - 1
    ),
    // Greater than startPages
    yt + 2
  ), Di = Math.min(
    Math.max(
      // Natural end
      Ti + gi,
      // Upper boundary when page is low
      yt + gi * 2 + 2
    ),
    // Less than endPages
    ti - yt - 1
  ), Mi = [
    ...di ? ["first"] : [],
    ...li ? [] : ["previous"],
    ...Pi,
    // Start ellipsis
    // eslint-disable-next-line no-nested-ternary
    ...Oi > yt + 2 ? ["start-ellipsis"] : yt + 1 < ti - yt ? [yt + 1] : [],
    // Sibling pages
    ...Si(Oi, Di),
    // End ellipsis
    // eslint-disable-next-line no-nested-ternary
    ...Di < ti - yt - 1 ? ["end-ellipsis"] : ti - yt > yt ? [ti - yt] : [],
    ...$i,
    ...ai ? [] : ["next"],
    ...fi ? ["last"] : []
  ], Oo = (io) => {
    switch (io) {
      case "first":
        return 1;
      case "previous":
        return Ti - 1;
      case "next":
        return Ti + 1;
      case "last":
        return ti;
      default:
        return null;
    }
  };
  return {
    items: Mi.map((io) => typeof io == "number" ? {
      onClick: (xo) => {
        xi(xo, io);
      },
      type: "page",
      page: io,
      selected: io === Ti,
      disabled: ui,
      "aria-current": io === Ti ? "page" : void 0
    } : {
      onClick: (xo) => {
        xi(xo, Oo(io));
      },
      type: io,
      page: Oo(io),
      selected: !1,
      disabled: ui || !io.includes("ellipsis") && (io === "next" || io === "last" ? Ti >= ti : Ti <= 1)
    }),
    ...mi
  };
}
function getPaginationItemUtilityClass$1(pt) {
  return generateUtilityClass$2("MuiPaginationItem", pt);
}
const paginationItemClasses$1 = generateUtilityClasses$2("MuiPaginationItem", ["root", "page", "sizeSmall", "sizeLarge", "text", "textPrimary", "textSecondary", "outlined", "outlinedPrimary", "outlinedSecondary", "rounded", "ellipsis", "firstLast", "previousNext", "focusVisible", "disabled", "selected", "icon", "colorPrimary", "colorSecondary"]), FirstPageIconDefault$1 = createSvgIcon$1(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), "FirstPage"), LastPageIconDefault$1 = createSvgIcon$1(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), "LastPage"), NavigateBeforeIcon$1 = createSvgIcon$1(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "NavigateBefore"), NavigateNextIcon$1 = createSvgIcon$1(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "NavigateNext"), overridesResolver$2 = (pt, yt) => {
  const {
    ownerState: ir
  } = pt;
  return [yt.root, yt[ir.variant], yt[`size${capitalize$1(ir.size)}`], ir.variant === "text" && yt[`text${capitalize$1(ir.color)}`], ir.variant === "outlined" && yt[`outlined${capitalize$1(ir.color)}`], ir.shape === "rounded" && yt.rounded, ir.type === "page" && yt.page, (ir.type === "start-ellipsis" || ir.type === "end-ellipsis") && yt.ellipsis, (ir.type === "previous" || ir.type === "next") && yt.previousNext, (ir.type === "first" || ir.type === "last") && yt.firstLast];
}, useUtilityClasses$9$1 = (pt) => {
  const {
    classes: yt,
    color: ir,
    disabled: ti,
    selected: ii,
    size: ui,
    shape: ai,
    type: li,
    variant: oi
  } = pt, si = {
    root: ["root", `size${capitalize$1(ui)}`, oi, ai, ir !== "standard" && `color${capitalize$1(ir)}`, ir !== "standard" && `${oi}${capitalize$1(ir)}`, ti && "disabled", ii && "selected", {
      page: "page",
      first: "firstLast",
      last: "firstLast",
      "start-ellipsis": "ellipsis",
      "end-ellipsis": "ellipsis",
      previous: "previousNext",
      next: "previousNext"
    }[li]],
    icon: ["icon"]
  };
  return composeClasses$2(si, getPaginationItemUtilityClass$1, yt);
}, PaginationItemEllipsis$1 = styled$3("div", {
  name: "MuiPaginationItem",
  slot: "Root",
  overridesResolver: overridesResolver$2
})(memoTheme$1(({
  theme: pt
}) => ({
  ...pt.typography.body2,
  borderRadius: 32 / 2,
  textAlign: "center",
  boxSizing: "border-box",
  minWidth: 32,
  padding: "0 6px",
  margin: "0 3px",
  color: (pt.vars || pt).palette.text.primary,
  height: "auto",
  [`&.${paginationItemClasses$1.disabled}`]: {
    opacity: (pt.vars || pt).palette.action.disabledOpacity
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      minWidth: 26,
      borderRadius: 26 / 2,
      margin: "0 1px",
      padding: "0 4px"
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      minWidth: 40,
      borderRadius: 40 / 2,
      padding: "0 10px",
      fontSize: pt.typography.pxToRem(15)
    }
  }]
}))), PaginationItemPage$1 = styled$3(ButtonBase$1, {
  name: "MuiPaginationItem",
  slot: "Root",
  overridesResolver: overridesResolver$2
})(memoTheme$1(({
  theme: pt
}) => ({
  ...pt.typography.body2,
  borderRadius: 32 / 2,
  textAlign: "center",
  boxSizing: "border-box",
  minWidth: 32,
  height: 32,
  padding: "0 6px",
  margin: "0 3px",
  color: (pt.vars || pt).palette.text.primary,
  [`&.${paginationItemClasses$1.focusVisible}`]: {
    backgroundColor: (pt.vars || pt).palette.action.focus
  },
  [`&.${paginationItemClasses$1.disabled}`]: {
    opacity: (pt.vars || pt).palette.action.disabledOpacity
  },
  transition: pt.transitions.create(["color", "background-color"], {
    duration: pt.transitions.duration.short
  }),
  "&:hover": {
    backgroundColor: (pt.vars || pt).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${paginationItemClasses$1.selected}`]: {
    backgroundColor: (pt.vars || pt).palette.action.selected,
    "&:hover": {
      backgroundColor: pt.alpha((pt.vars || pt).palette.action.selected, `${(pt.vars || pt).palette.action.selectedOpacity} + ${(pt.vars || pt).palette.action.hoverOpacity}`),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (pt.vars || pt).palette.action.selected
      }
    },
    [`&.${paginationItemClasses$1.focusVisible}`]: {
      backgroundColor: pt.alpha((pt.vars || pt).palette.action.selected, `${(pt.vars || pt).palette.action.selectedOpacity} + ${(pt.vars || pt).palette.action.focusOpacity}`)
    },
    [`&.${paginationItemClasses$1.disabled}`]: {
      opacity: 1,
      color: (pt.vars || pt).palette.action.disabled,
      backgroundColor: (pt.vars || pt).palette.action.selected
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      minWidth: 26,
      height: 26,
      borderRadius: 26 / 2,
      margin: "0 1px",
      padding: "0 4px"
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      minWidth: 40,
      height: 40,
      borderRadius: 40 / 2,
      padding: "0 10px",
      fontSize: pt.typography.pxToRem(15)
    }
  }, {
    props: {
      shape: "rounded"
    },
    style: {
      borderRadius: (pt.vars || pt).shape.borderRadius
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      border: pt.vars ? `1px solid ${pt.alpha(pt.vars.palette.common.onBackground, 0.23)}` : `1px solid ${pt.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
      [`&.${paginationItemClasses$1.selected}`]: {
        [`&.${paginationItemClasses$1.disabled}`]: {
          borderColor: (pt.vars || pt).palette.action.disabledBackground,
          color: (pt.vars || pt).palette.action.disabled
        }
      }
    }
  }, {
    props: {
      variant: "text"
    },
    style: {
      [`&.${paginationItemClasses$1.selected}`]: {
        [`&.${paginationItemClasses$1.disabled}`]: {
          color: (pt.vars || pt).palette.action.disabled
        }
      }
    }
  }, ...Object.entries(pt.palette).filter(createSimplePaletteValueFilter$1(["dark", "contrastText"])).map(([yt]) => ({
    props: {
      variant: "text",
      color: yt
    },
    style: {
      [`&.${paginationItemClasses$1.selected}`]: {
        color: (pt.vars || pt).palette[yt].contrastText,
        backgroundColor: (pt.vars || pt).palette[yt].main,
        "&:hover": {
          backgroundColor: (pt.vars || pt).palette[yt].dark,
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            backgroundColor: (pt.vars || pt).palette[yt].main
          }
        },
        [`&.${paginationItemClasses$1.focusVisible}`]: {
          backgroundColor: (pt.vars || pt).palette[yt].dark
        },
        [`&.${paginationItemClasses$1.disabled}`]: {
          color: (pt.vars || pt).palette.action.disabled
        }
      }
    }
  })), ...Object.entries(pt.palette).filter(createSimplePaletteValueFilter$1(["light"])).map(([yt]) => ({
    props: {
      variant: "outlined",
      color: yt
    },
    style: {
      [`&.${paginationItemClasses$1.selected}`]: {
        color: (pt.vars || pt).palette[yt].main,
        border: `1px solid ${pt.alpha((pt.vars || pt).palette[yt].main, 0.5)}`,
        backgroundColor: pt.alpha((pt.vars || pt).palette[yt].main, (pt.vars || pt).palette.action.activatedOpacity),
        "&:hover": {
          backgroundColor: pt.alpha((pt.vars || pt).palette[yt].main, `${(pt.vars || pt).palette.action.activatedOpacity} + ${(pt.vars || pt).palette.action.focusOpacity}`),
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            backgroundColor: "transparent"
          }
        },
        [`&.${paginationItemClasses$1.focusVisible}`]: {
          backgroundColor: pt.alpha((pt.vars || pt).palette[yt].main, `${(pt.vars || pt).palette.action.activatedOpacity} + ${(pt.vars || pt).palette.action.focusOpacity}`)
        }
      }
    }
  }))]
}))), PaginationItemPageIcon$1 = styled$3("div", {
  name: "MuiPaginationItem",
  slot: "Icon"
})(memoTheme$1(({
  theme: pt
}) => ({
  fontSize: pt.typography.pxToRem(20),
  margin: "0 -8px",
  variants: [{
    props: {
      size: "small"
    },
    style: {
      fontSize: pt.typography.pxToRem(18)
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      fontSize: pt.typography.pxToRem(22)
    }
  }]
}))), PaginationItem$1 = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const ir = useDefaultProps$2({
    props: pt,
    name: "MuiPaginationItem"
  }), {
    className: ti,
    color: ii = "standard",
    component: ui,
    components: ai = {},
    disabled: li = !1,
    page: oi,
    selected: si = !1,
    shape: di = "circular",
    size: fi = "medium",
    slots: gi = {},
    slotProps: mi = {},
    type: Ti = "page",
    variant: vi = "text",
    ...xi
  } = ir, Si = {
    ...ir,
    color: ii,
    disabled: li,
    selected: si,
    shape: di,
    size: fi,
    type: Ti,
    variant: vi
  }, Pi = useRtl$1(), $i = useUtilityClasses$9$1(Si), Oi = {
    slots: {
      previous: gi.previous ?? ai.previous,
      next: gi.next ?? ai.next,
      first: gi.first ?? ai.first,
      last: gi.last ?? ai.last
    },
    slotProps: mi
  }, [Di, Mi] = useSlot$1("previous", {
    elementType: NavigateBeforeIcon$1,
    externalForwardedProps: Oi,
    ownerState: Si
  }), [Oo, io] = useSlot$1("next", {
    elementType: NavigateNextIcon$1,
    externalForwardedProps: Oi,
    ownerState: Si
  }), [xo, fo] = useSlot$1("first", {
    elementType: FirstPageIconDefault$1,
    externalForwardedProps: Oi,
    ownerState: Si
  }), [_o, Li] = useSlot$1("last", {
    elementType: LastPageIconDefault$1,
    externalForwardedProps: Oi,
    ownerState: Si
  }), Co = Pi ? {
    previous: "next",
    next: "previous",
    first: "last",
    last: "first"
  }[Ti] : Ti, Ni = {
    previous: Di,
    next: Oo,
    first: xo,
    last: _o
  }[Co], Yi = {
    previous: Mi,
    next: io,
    first: fo,
    last: Li
  }[Co];
  return Ti === "start-ellipsis" || Ti === "end-ellipsis" ? /* @__PURE__ */ jsxRuntimeExports.jsx(PaginationItemEllipsis$1, {
    ref: yt,
    ownerState: Si,
    className: clsx$1($i.root, ti),
    children: "…"
  }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(PaginationItemPage$1, {
    ref: yt,
    ownerState: Si,
    component: ui,
    disabled: li,
    className: clsx$1($i.root, ti),
    ...xi,
    children: [Ti === "page" && oi, Ni ? /* @__PURE__ */ jsxRuntimeExports.jsx(PaginationItemPageIcon$1, {
      ...Yi,
      className: $i.icon,
      as: Ni
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (PaginationItem$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary", "standard"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  components: PropTypes.shape({
    first: PropTypes.elementType,
    last: PropTypes.elementType,
    next: PropTypes.elementType,
    previous: PropTypes.elementType
  }),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * The current page number.
   */
  page: PropTypes.node,
  /**
   * If `true` the pagination item is selected.
   * @default false
   */
  selected: PropTypes.bool,
  /**
   * The shape of the pagination item.
   * @default 'circular'
   */
  shape: PropTypes.oneOf(["circular", "rounded"]),
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["small", "medium", "large"]), PropTypes.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    first: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    last: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    next: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    previous: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    first: PropTypes.elementType,
    last: PropTypes.elementType,
    next: PropTypes.elementType,
    previous: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The type of pagination item.
   * @default 'page'
   */
  type: PropTypes.oneOf(["end-ellipsis", "first", "last", "next", "page", "previous", "start-ellipsis"]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["outlined", "text"]), PropTypes.string])
});
const useUtilityClasses$8$1 = (pt) => {
  const {
    classes: yt,
    variant: ir
  } = pt;
  return composeClasses$2({
    root: ["root", ir],
    ul: ["ul"]
  }, getPaginationUtilityClass$1, yt);
}, PaginationRoot$1 = styled$3("nav", {
  name: "MuiPagination",
  slot: "Root",
  overridesResolver: (pt, yt) => {
    const {
      ownerState: ir
    } = pt;
    return [yt.root, yt[ir.variant]];
  }
})({}), PaginationUl$1 = styled$3("ul", {
  name: "MuiPagination",
  slot: "Ul"
})({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  padding: 0,
  margin: 0,
  listStyle: "none"
});
function defaultGetAriaLabel$1(pt, yt, ir) {
  return pt === "page" ? `${ir ? "" : "Go to "}page ${yt}` : `Go to ${pt} page`;
}
const Pagination$1$1 = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const ir = useDefaultProps$2({
    props: pt,
    name: "MuiPagination"
  }), {
    boundaryCount: ti = 1,
    className: ii,
    color: ui = "standard",
    count: ai = 1,
    defaultPage: li = 1,
    disabled: oi = !1,
    getItemAriaLabel: si = defaultGetAriaLabel$1,
    hideNextButton: di = !1,
    hidePrevButton: fi = !1,
    onChange: gi,
    page: mi,
    renderItem: Ti = (xo) => /* @__PURE__ */ jsxRuntimeExports.jsx(PaginationItem$1, {
      ...xo
    }),
    shape: vi = "circular",
    showFirstButton: xi = !1,
    showLastButton: Si = !1,
    siblingCount: Pi = 1,
    size: $i = "medium",
    variant: Oi = "text",
    ...Di
  } = ir, {
    items: Mi
  } = usePagination$1({
    ...ir,
    componentName: "Pagination"
  }), Oo = {
    ...ir,
    boundaryCount: ti,
    color: ui,
    count: ai,
    defaultPage: li,
    disabled: oi,
    getItemAriaLabel: si,
    hideNextButton: di,
    hidePrevButton: fi,
    renderItem: Ti,
    shape: vi,
    showFirstButton: xi,
    showLastButton: Si,
    siblingCount: Pi,
    size: $i,
    variant: Oi
  }, io = useUtilityClasses$8$1(Oo);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PaginationRoot$1, {
    "aria-label": "pagination navigation",
    className: clsx$1(io.root, ii),
    ownerState: Oo,
    ref: yt,
    ...Di,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(PaginationUl$1, {
      className: io.ul,
      ownerState: Oo,
      children: Mi.map((xo, fo) => /* @__PURE__ */ jsxRuntimeExports.jsx("li", {
        children: Ti({
          ...xo,
          color: ui,
          "aria-label": si(xo.type, xo.page, xo.selected),
          shape: vi,
          size: $i,
          variant: Oi
        })
      }, fo))
    })
  });
});
process.env.NODE_ENV !== "production" && (Pagination$1$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Number of always visible pages at the beginning and end.
   * @default 1
   */
  boundaryCount: integerPropType$1,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary", "standard"]), PropTypes.string]),
  /**
   * The total number of pages.
   * @default 1
   */
  count: integerPropType$1,
  /**
   * The page selected by default when the component is uncontrolled.
   * @default 1
   */
  defaultPage: integerPropType$1,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous' | 'start-ellipsis' | 'end-ellipsis'). Defaults to 'page'.
   * @param {number | null} page The page number to format.
   * @param {boolean} selected If true, the current page is selected.
   * @returns {string}
   */
  getItemAriaLabel: PropTypes.func,
  /**
   * If `true`, hide the next-page button.
   * @default false
   */
  hideNextButton: PropTypes.bool,
  /**
   * If `true`, hide the previous-page button.
   * @default false
   */
  hidePrevButton: PropTypes.bool,
  /**
   * Callback fired when the page is changed.
   *
   * @param {React.ChangeEvent<unknown>} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onChange: PropTypes.func,
  /**
   * The current page. Unlike `TablePagination`, which starts numbering from `0`, this pagination starts from `1`.
   */
  page: integerPropType$1,
  /**
   * Render the item.
   * @param {PaginationRenderItemParams} params The props to spread on a PaginationItem.
   * @returns {ReactNode}
   * @default (item) => <PaginationItem {...item} />
   */
  renderItem: PropTypes.func,
  /**
   * The shape of the pagination items.
   * @default 'circular'
   */
  shape: PropTypes.oneOf(["circular", "rounded"]),
  /**
   * If `true`, show the first-page button.
   * @default false
   */
  showFirstButton: PropTypes.bool,
  /**
   * If `true`, show the last-page button.
   * @default false
   */
  showLastButton: PropTypes.bool,
  /**
   * Number of always visible pages before and after the current page.
   * @default 1
   */
  siblingCount: integerPropType$1,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["small", "medium", "large"]), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["outlined", "text"]), PropTypes.string])
});
function getSelectUtilityClasses(pt) {
  return generateUtilityClass$2("MuiSelect", pt);
}
const selectClasses = generateUtilityClasses$2("MuiSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "focused", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]);
var _span;
const SelectSelect = styled$3(StyledSelectSelect, {
  name: "MuiSelect",
  slot: "Select",
  overridesResolver: (pt, yt) => {
    const {
      ownerState: ir
    } = pt;
    return [
      // Win specificity over the input base
      {
        [`&.${selectClasses.select}`]: yt.select
      },
      {
        [`&.${selectClasses.select}`]: yt[ir.variant]
      },
      {
        [`&.${selectClasses.error}`]: yt.error
      },
      {
        [`&.${selectClasses.multiple}`]: yt.multiple
      }
    ];
  }
})({
  // Win specificity over the input base
  [`&.${selectClasses.select}`]: {
    height: "auto",
    // Resets for multiple select with chips
    minHeight: "1.4375em",
    // Required for select\text-field height consistency
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }
}), SelectIcon = styled$3(StyledSelectIcon, {
  name: "MuiSelect",
  slot: "Icon",
  overridesResolver: (pt, yt) => {
    const {
      ownerState: ir
    } = pt;
    return [yt.icon, ir.variant && yt[`icon${capitalize$1(ir.variant)}`], ir.open && yt.iconOpen];
  }
})({}), SelectNativeInput = styled$3("input", {
  shouldForwardProp: (pt) => slotShouldForwardProp$1(pt) && pt !== "classes",
  name: "MuiSelect",
  slot: "NativeInput"
})({
  bottom: 0,
  left: 0,
  position: "absolute",
  opacity: 0,
  pointerEvents: "none",
  width: "100%",
  boxSizing: "border-box"
});
function areEqualValues(pt, yt) {
  return typeof yt == "object" && yt !== null ? pt === yt : String(pt) === String(yt);
}
function isEmpty(pt) {
  return pt == null || typeof pt == "string" && !pt.trim();
}
const useUtilityClasses$7$1 = (pt) => {
  const {
    classes: yt,
    variant: ir,
    disabled: ti,
    multiple: ii,
    open: ui,
    error: ai
  } = pt, li = {
    select: ["select", ir, ti && "disabled", ii && "multiple", ai && "error"],
    icon: ["icon", `icon${capitalize$1(ir)}`, ui && "iconOpen", ti && "disabled"],
    nativeInput: ["nativeInput"]
  };
  return composeClasses$2(li, getSelectUtilityClasses, yt);
}, SelectInput = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  var ir, ti, ii, ui;
  const {
    "aria-describedby": ai,
    "aria-label": li,
    autoFocus: oi,
    autoWidth: si,
    children: di,
    className: fi,
    defaultOpen: gi,
    defaultValue: mi,
    disabled: Ti,
    displayEmpty: vi,
    error: xi = !1,
    IconComponent: Si,
    inputRef: Pi,
    labelId: $i,
    MenuProps: Oi = {},
    multiple: Di,
    name: Mi,
    onBlur: Oo,
    onChange: io,
    onClose: xo,
    onFocus: fo,
    // eslint-disable-next-line react/prop-types
    onKeyDown: _o,
    // eslint-disable-next-line react/prop-types
    onMouseDown: Li,
    onOpen: Co,
    open: Ni,
    readOnly: Yi,
    renderValue: Vo,
    required: No,
    SelectDisplayProps: Ui = {},
    tabIndex: jo,
    // catching `type` from Input which makes no sense for SelectInput
    type: Wi,
    value: ji,
    variant: Hi = "standard",
    ...zo
  } = pt, [Lo, sa] = useControlled$2({
    controlled: ji,
    default: mi,
    name: "Select"
  }), [Ko, ca] = useControlled$2({
    controlled: Ni,
    default: gi,
    name: "Select"
  }), pa = React.useRef(null), ga = React.useRef(null), [ia, ra] = React.useState(null), {
    current: qo
  } = React.useRef(Ni != null), [xa, $a] = React.useState(), ys = useForkRef$2(yt, Pi), Ss = React.useCallback((xl) => {
    ga.current = xl, xl && ra(xl);
  }, []), Xa = ia == null ? void 0 : ia.parentNode;
  React.useImperativeHandle(ys, () => ({
    focus: () => {
      ga.current.focus();
    },
    node: pa.current,
    value: Lo
  }), [Lo]);
  const Es = ia !== null && Ko;
  React.useEffect(() => {
    if (!Es || !Xa || si || typeof ResizeObserver > "u")
      return;
    const xl = new ResizeObserver(() => {
      $a(Xa.clientWidth);
    });
    return xl.observe(Xa), () => {
      xl.disconnect();
    };
  }, [Es, Xa, si]), React.useEffect(() => {
    gi && Ko && ia && !qo && ($a(si ? null : Xa.clientWidth), ga.current.focus());
  }, [ia, si]), React.useEffect(() => {
    oi && ga.current.focus();
  }, [oi]), React.useEffect(() => {
    if (!$i)
      return;
    const xl = ownerDocument$2(ga.current).getElementById($i);
    if (xl) {
      const Ul = () => {
        getSelection().isCollapsed && ga.current.focus();
      };
      return xl.addEventListener("click", Ul), () => {
        xl.removeEventListener("click", Ul);
      };
    }
  }, [$i]);
  const Rs = (xl, Ul) => {
    xl ? Co && Co(Ul) : xo && xo(Ul), qo || ($a(si ? null : Xa.clientWidth), ca(xl));
  }, La = (xl) => {
    Li == null || Li(xl), xl.button === 0 && (xl.preventDefault(), ga.current.focus(), Rs(!0, xl));
  }, Ja = (xl) => {
    Rs(!1, xl);
  }, ja = React.Children.toArray(di), Ta = (xl) => {
    const Ul = ja.find((Xl) => Xl.props.value === xl.target.value);
    Ul !== void 0 && (sa(Ul.props.value), io && io(xl, Ul));
  }, rs = (xl) => (Ul) => {
    let Xl;
    if (Ul.currentTarget.hasAttribute("tabindex")) {
      if (Di) {
        Xl = Array.isArray(Lo) ? Lo.slice() : [];
        const hu = Lo.indexOf(xl.props.value);
        hu === -1 ? Xl.push(xl.props.value) : Xl.splice(hu, 1);
      } else
        Xl = xl.props.value;
      if (xl.props.onClick && xl.props.onClick(Ul), Lo !== Xl && (sa(Xl), io)) {
        const hu = Ul.nativeEvent || Ul, Tu = new hu.constructor(hu.type, hu);
        Object.defineProperty(Tu, "target", {
          writable: !0,
          value: {
            value: Xl,
            name: Mi
          }
        }), io(Tu, xl);
      }
      Di || Rs(!1, Ul);
    }
  }, Qa = (xl) => {
    Yi || ([
      " ",
      "ArrowUp",
      "ArrowDown",
      // The native select doesn't respond to enter on macOS, but it's recommended by
      // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
      "Enter"
    ].includes(xl.key) && (xl.preventDefault(), Rs(!0, xl)), _o == null || _o(xl));
  }, Cs = (xl) => {
    !Es && Oo && (Object.defineProperty(xl, "target", {
      writable: !0,
      value: {
        value: Lo,
        name: Mi
      }
    }), Oo(xl));
  };
  delete zo["aria-invalid"];
  let _a, _s;
  const el = [];
  let Ps = !1, nl = !1;
  (isFilled({
    value: Lo
  }) || vi) && (Vo ? _a = Vo(Lo) : Ps = !0);
  const Vs = ja.map((xl) => {
    if (!/* @__PURE__ */ React.isValidElement(xl))
      return null;
    process.env.NODE_ENV !== "production" && reactIsExports$1.isFragment(xl) && console.error(["MUI: The Select component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    let Ul;
    if (Di) {
      if (!Array.isArray(Lo))
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: The `value` prop must be an array when using the `Select` component with `multiple`." : formatMuiErrorMessage$2(2));
      Ul = Lo.some((Xl) => areEqualValues(Xl, xl.props.value)), Ul && Ps && el.push(xl.props.children);
    } else
      Ul = areEqualValues(Lo, xl.props.value), Ul && Ps && (_s = xl.props.children);
    return Ul && (nl = !0), /* @__PURE__ */ React.cloneElement(xl, {
      "aria-selected": Ul ? "true" : "false",
      onClick: rs(xl),
      onKeyUp: (Xl) => {
        Xl.key === " " && Xl.preventDefault(), xl.props.onKeyUp && xl.props.onKeyUp(Xl);
      },
      role: "option",
      selected: Ul,
      value: void 0,
      // The value is most likely not a valid HTML attribute.
      "data-value": xl.props.value
      // Instead, we provide it as a data attribute.
    });
  });
  process.env.NODE_ENV !== "production" && React.useEffect(() => {
    if (!nl && !Di && Lo !== "") {
      const xl = ja.map((Ul) => Ul.props.value);
      console.warn([`MUI: You have provided an out-of-range value \`${Lo}\` for the select ${Mi ? `(name="${Mi}") ` : ""}component.`, "Consider providing a value that matches one of the available options or ''.", `The available values are ${xl.filter((Ul) => Ul != null).map((Ul) => `\`${Ul}\``).join(", ") || '""'}.`].join(`
`));
    }
  }, [nl, ja, Di, Mi, Lo]), Ps && (Di ? el.length === 0 ? _a = null : _a = el.reduce((xl, Ul, Xl) => (xl.push(Ul), Xl < el.length - 1 && xl.push(", "), xl), []) : _a = _s);
  let es = xa;
  !si && qo && ia && (es = Xa.clientWidth);
  let Is;
  typeof jo < "u" ? Is = jo : Is = Ti ? null : 0;
  const fl = Ui.id || (Mi ? `mui-component-select-${Mi}` : void 0), sl = {
    ...pt,
    variant: Hi,
    value: Lo,
    open: Es,
    error: xi
  }, Il = useUtilityClasses$7$1(sl), Vl = {
    ...Oi.PaperProps,
    ...typeof ((ir = Oi.slotProps) == null ? void 0 : ir.paper) == "function" ? Oi.slotProps.paper(sl) : (ti = Oi.slotProps) == null ? void 0 : ti.paper
  }, Bl = {
    ...Oi.MenuListProps,
    ...typeof ((ii = Oi.slotProps) == null ? void 0 : ii.list) == "function" ? Oi.slotProps.list(sl) : (ui = Oi.slotProps) == null ? void 0 : ui.list
  }, ql = useId$1();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(SelectSelect, {
      as: "div",
      ref: Ss,
      tabIndex: Is,
      role: "combobox",
      "aria-controls": Es ? ql : void 0,
      "aria-disabled": Ti ? "true" : void 0,
      "aria-expanded": Es ? "true" : "false",
      "aria-haspopup": "listbox",
      "aria-label": li,
      "aria-labelledby": [$i, fl].filter(Boolean).join(" ") || void 0,
      "aria-describedby": ai,
      "aria-required": No ? "true" : void 0,
      "aria-invalid": xi ? "true" : void 0,
      onKeyDown: Qa,
      onMouseDown: Ti || Yi ? null : La,
      onBlur: Cs,
      onFocus: fo,
      ...Ui,
      ownerState: sl,
      className: clsx$1(Ui.className, Il.select, fi),
      id: fl,
      children: isEmpty(_a) ? (
        // notranslate needed while Google Translate will not fix zero-width space issue
        _span || (_span = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
          className: "notranslate",
          "aria-hidden": !0,
          children: "​"
        }))
      ) : _a
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(SelectNativeInput, {
      "aria-invalid": xi,
      value: Array.isArray(Lo) ? Lo.join(",") : Lo,
      name: Mi,
      ref: pa,
      "aria-hidden": !0,
      onChange: Ta,
      tabIndex: -1,
      disabled: Ti,
      className: Il.nativeInput,
      autoFocus: oi,
      required: No,
      ...zo,
      ownerState: sl
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(SelectIcon, {
      as: Si,
      className: Il.icon,
      ownerState: sl
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(Menu$2, {
      id: `menu-${Mi || ""}`,
      anchorEl: Xa,
      open: Es,
      onClose: Ja,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      },
      ...Oi,
      slotProps: {
        ...Oi.slotProps,
        list: {
          "aria-labelledby": $i,
          role: "listbox",
          "aria-multiselectable": Di ? "true" : void 0,
          disableListWrap: !0,
          id: ql,
          ...Bl
        },
        paper: {
          ...Vl,
          style: {
            minWidth: es,
            ...Vl != null ? Vl.style : null
          }
        }
      },
      children: Vs
    })]
  });
});
process.env.NODE_ENV !== "production" && (SelectInput.propTypes = {
  /**
   * @ignore
   */
  "aria-describedby": PropTypes.string,
  /**
   * @ignore
   */
  "aria-label": PropTypes.string,
  /**
   * @ignore
   */
  autoFocus: PropTypes.bool,
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: PropTypes.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The CSS class name of the select element.
   */
  className: PropTypes.string,
  /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */
  defaultOpen: PropTypes.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the select is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: PropTypes.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: PropTypes.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType.isRequired,
  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: refType$2,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: PropTypes.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: PropTypes.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: PropTypes.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: PropTypes.string,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool,
  /**
   * @ignore
   */
  readOnly: PropTypes.bool,
  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: PropTypes.func,
  /**
   * If `true`, the component is required.
   */
  required: PropTypes.bool,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: PropTypes.object,
  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * @ignore
   */
  type: PropTypes.any,
  /**
   * The input value.
   */
  value: PropTypes.any,
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(["standard", "outlined", "filled"])
});
const useUtilityClasses$6$1 = (pt) => {
  const {
    classes: yt
  } = pt, ir = composeClasses$2({
    root: ["root"]
  }, getSelectUtilityClasses, yt);
  return {
    ...yt,
    ...ir
  };
}, styledRootConfig = {
  name: "MuiSelect",
  slot: "Root",
  shouldForwardProp: (pt) => rootShouldForwardProp$1(pt) && pt !== "variant"
}, StyledInput = styled$3(Input, styledRootConfig)(""), StyledOutlinedInput = styled$3(OutlinedInput, styledRootConfig)(""), StyledFilledInput = styled$3(FilledInput, styledRootConfig)(""), Select$1 = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const ir = useDefaultProps$2({
    name: "MuiSelect",
    props: pt
  }), {
    autoWidth: ti = !1,
    children: ii,
    classes: ui = {},
    className: ai,
    defaultOpen: li = !1,
    displayEmpty: oi = !1,
    IconComponent: si = ArrowDropDownIcon,
    id: di,
    input: fi,
    inputProps: gi,
    label: mi,
    labelId: Ti,
    MenuProps: vi,
    multiple: xi = !1,
    native: Si = !1,
    onClose: Pi,
    onOpen: $i,
    open: Oi,
    renderValue: Di,
    SelectDisplayProps: Mi,
    variant: Oo = "outlined",
    ...io
  } = ir, xo = Si ? NativeSelectInput : SelectInput, fo = useFormControl(), _o = formControlState({
    props: ir,
    muiFormControl: fo,
    states: ["variant", "error"]
  }), Li = _o.variant || Oo, Co = {
    ...ir,
    variant: Li,
    classes: ui
  }, Ni = useUtilityClasses$6$1(Co), {
    root: Yi,
    ...Vo
  } = Ni, No = fi || {
    standard: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInput, {
      ownerState: Co
    }),
    outlined: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledOutlinedInput, {
      label: mi,
      ownerState: Co
    }),
    filled: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFilledInput, {
      ownerState: Co
    })
  }[Li], Ui = useForkRef$2(yt, getReactElementRef$2(No));
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React.Fragment, {
    children: /* @__PURE__ */ React.cloneElement(No, {
      // Most of the logic is implemented in `SelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: xo,
      inputProps: {
        children: ii,
        error: _o.error,
        IconComponent: si,
        variant: Li,
        type: void 0,
        // We render a select. We can ignore the type provided by the `Input`.
        multiple: xi,
        ...Si ? {
          id: di
        } : {
          autoWidth: ti,
          defaultOpen: li,
          displayEmpty: oi,
          labelId: Ti,
          MenuProps: vi,
          onClose: Pi,
          onOpen: $i,
          open: Oi,
          renderValue: Di,
          SelectDisplayProps: {
            id: di,
            ...Mi
          }
        },
        ...gi,
        classes: gi ? deepmerge$1(Vo, gi.classes) : Vo,
        ...fi ? fi.props.inputProps : {}
      },
      ...(xi && Si || oi) && Li === "outlined" ? {
        notched: !0
      } : {},
      ref: Ui,
      className: clsx$1(No.props.className, ai, Ni.root),
      // If a custom input is provided via 'input' prop, do not allow 'variant' to be propagated to it's root element. See https://github.com/mui/material-ui/issues/33894.
      ...!fi && {
        variant: Li
      },
      ...io
    })
  });
});
process.env.NODE_ENV !== "production" && (Select$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */
  autoWidth: PropTypes.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */
  defaultOpen: PropTypes.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */
  displayEmpty: PropTypes.bool,
  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: PropTypes.elementType,
  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: PropTypes.string,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: PropTypes.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: PropTypes.object,
  /**
   * See [OutlinedInput#label](https://mui.com/material-ui/api/outlined-input/#props)
   */
  label: PropTypes.node,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: PropTypes.string,
  /**
   * Props applied to the [`Menu`](https://mui.com/material-ui/api/menu/) element.
   */
  MenuProps: PropTypes.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: PropTypes.bool,
  /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */
  native: PropTypes.bool,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<Value>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,
  /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: PropTypes.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: PropTypes.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: PropTypes.oneOfType([PropTypes.oneOf([""]), PropTypes.any]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
});
Select$1.muiName = "Select";
const StepperContext = /* @__PURE__ */ React.createContext({});
process.env.NODE_ENV !== "production" && (StepperContext.displayName = "StepperContext");
const StepContext = /* @__PURE__ */ React.createContext({});
process.env.NODE_ENV !== "production" && (StepContext.displayName = "StepContext");
function getStepUtilityClass(pt) {
  return generateUtilityClass$2("MuiStep", pt);
}
generateUtilityClasses$2("MuiStep", ["root", "horizontal", "vertical", "alternativeLabel", "completed"]);
const useUtilityClasses$5$1 = (pt) => {
  const {
    classes: yt,
    orientation: ir,
    alternativeLabel: ti,
    completed: ii
  } = pt;
  return composeClasses$2({
    root: ["root", ir, ti && "alternativeLabel", ii && "completed"]
  }, getStepUtilityClass, yt);
}, StepRoot = styled$3("div", {
  name: "MuiStep",
  slot: "Root",
  overridesResolver: (pt, yt) => {
    const {
      ownerState: ir
    } = pt;
    return [yt.root, yt[ir.orientation], ir.alternativeLabel && yt.alternativeLabel, ir.completed && yt.completed];
  }
})({
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      paddingLeft: 8,
      paddingRight: 8
    }
  }, {
    props: {
      alternativeLabel: !0
    },
    style: {
      flex: 1,
      position: "relative"
    }
  }]
}), Step$1 = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const ir = useDefaultProps$2({
    props: pt,
    name: "MuiStep"
  }), {
    active: ti,
    children: ii,
    className: ui,
    component: ai = "div",
    completed: li,
    disabled: oi,
    expanded: si = !1,
    index: di,
    last: fi,
    ...gi
  } = ir, {
    activeStep: mi,
    connector: Ti,
    alternativeLabel: vi,
    orientation: xi,
    nonLinear: Si
  } = React.useContext(StepperContext);
  let [Pi = !1, $i = !1, Oi = !1] = [ti, li, oi];
  mi === di ? Pi = ti !== void 0 ? ti : !0 : !Si && mi > di ? $i = li !== void 0 ? li : !0 : !Si && mi < di && (Oi = oi !== void 0 ? oi : !0);
  const Di = React.useMemo(() => ({
    index: di,
    last: fi,
    expanded: si,
    icon: di + 1,
    active: Pi,
    completed: $i,
    disabled: Oi
  }), [di, fi, si, Pi, $i, Oi]), Mi = {
    ...ir,
    active: Pi,
    orientation: xi,
    alternativeLabel: vi,
    completed: $i,
    disabled: Oi,
    expanded: si,
    component: ai
  }, Oo = useUtilityClasses$5$1(Mi), io = /* @__PURE__ */ jsxRuntimeExports.jsxs(StepRoot, {
    as: ai,
    className: clsx$1(Oo.root, ui),
    ref: yt,
    ownerState: Mi,
    ...gi,
    children: [Ti && vi && di !== 0 ? Ti : null, ii]
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StepContext.Provider, {
    value: Di,
    children: Ti && !vi && di !== 0 ? /* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, {
      children: [Ti, io]
    }) : io
  });
});
process.env.NODE_ENV !== "production" && (Step$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Sets the step as active. Is passed to child components.
   */
  active: PropTypes.bool,
  /**
   * Should be `Step` sub-components such as `StepLabel`, `StepContent`.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the step is disabled, will also disable the button if
   * `StepButton` is a child of `Step`. Is passed to child components.
   */
  disabled: PropTypes.bool,
  /**
   * Expand the step.
   * @default false
   */
  expanded: PropTypes.bool,
  /**
   * The position of the step.
   * The prop defaults to the value inherited from the parent Stepper component.
   */
  index: integerPropType$1,
  /**
   * If `true`, the Step is displayed as rendered last.
   * The prop defaults to the value inherited from the parent Stepper component.
   */
  last: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const CheckCircle = createSvgIcon$1(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
}), "CheckCircle"), Warning = createSvgIcon$1(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), "Warning");
function getStepIconUtilityClass(pt) {
  return generateUtilityClass$2("MuiStepIcon", pt);
}
const stepIconClasses = generateUtilityClasses$2("MuiStepIcon", ["root", "active", "completed", "error", "text"]);
var _circle;
const useUtilityClasses$4$1 = (pt) => {
  const {
    classes: yt,
    active: ir,
    completed: ti,
    error: ii
  } = pt;
  return composeClasses$2({
    root: ["root", ir && "active", ti && "completed", ii && "error"],
    text: ["text"]
  }, getStepIconUtilityClass, yt);
}, StepIconRoot = styled$3(SvgIcon$1, {
  name: "MuiStepIcon",
  slot: "Root"
})(memoTheme$1(({
  theme: pt
}) => ({
  display: "block",
  transition: pt.transitions.create("color", {
    duration: pt.transitions.duration.shortest
  }),
  color: (pt.vars || pt).palette.text.disabled,
  [`&.${stepIconClasses.completed}, &.${stepIconClasses.active}`]: {
    color: (pt.vars || pt).palette.primary.main
  },
  [`&.${stepIconClasses.error}`]: {
    color: (pt.vars || pt).palette.error.main
  }
}))), StepIconText = styled$3("text", {
  name: "MuiStepIcon",
  slot: "Text"
})(memoTheme$1(({
  theme: pt
}) => ({
  fill: (pt.vars || pt).palette.primary.contrastText,
  fontSize: pt.typography.caption.fontSize,
  fontFamily: pt.typography.fontFamily
}))), StepIcon = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const ir = useDefaultProps$2({
    props: pt,
    name: "MuiStepIcon"
  }), {
    active: ti = !1,
    className: ii,
    completed: ui = !1,
    error: ai = !1,
    icon: li,
    ...oi
  } = ir, si = {
    ...ir,
    active: ti,
    completed: ui,
    error: ai
  }, di = useUtilityClasses$4$1(si);
  if (typeof li == "number" || typeof li == "string") {
    const fi = clsx$1(ii, di.root);
    return ai ? /* @__PURE__ */ jsxRuntimeExports.jsx(StepIconRoot, {
      as: Warning,
      className: fi,
      ref: yt,
      ownerState: si,
      ...oi
    }) : ui ? /* @__PURE__ */ jsxRuntimeExports.jsx(StepIconRoot, {
      as: CheckCircle,
      className: fi,
      ref: yt,
      ownerState: si,
      ...oi
    }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(StepIconRoot, {
      className: fi,
      ref: yt,
      ownerState: si,
      ...oi,
      children: [_circle || (_circle = /* @__PURE__ */ jsxRuntimeExports.jsx("circle", {
        cx: "12",
        cy: "12",
        r: "12"
      })), /* @__PURE__ */ jsxRuntimeExports.jsx(StepIconText, {
        className: di.text,
        x: "12",
        y: "12",
        textAnchor: "middle",
        dominantBaseline: "central",
        ownerState: si,
        children: li
      })]
    });
  }
  return li;
});
process.env.NODE_ENV !== "production" && (StepIcon.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
  /**
   * If `true`, the step is marked as failed.
   * @default false
   */
  error: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function getStepLabelUtilityClass(pt) {
  return generateUtilityClass$2("MuiStepLabel", pt);
}
const stepLabelClasses = generateUtilityClasses$2("MuiStepLabel", ["root", "horizontal", "vertical", "label", "active", "completed", "error", "disabled", "iconContainer", "alternativeLabel", "labelContainer"]), useUtilityClasses$3$1 = (pt) => {
  const {
    classes: yt,
    orientation: ir,
    active: ti,
    completed: ii,
    error: ui,
    disabled: ai,
    alternativeLabel: li
  } = pt;
  return composeClasses$2({
    root: ["root", ir, ui && "error", ai && "disabled", li && "alternativeLabel"],
    label: ["label", ti && "active", ii && "completed", ui && "error", ai && "disabled", li && "alternativeLabel"],
    iconContainer: ["iconContainer", ti && "active", ii && "completed", ui && "error", ai && "disabled", li && "alternativeLabel"],
    labelContainer: ["labelContainer", li && "alternativeLabel"]
  }, getStepLabelUtilityClass, yt);
}, StepLabelRoot = styled$3("span", {
  name: "MuiStepLabel",
  slot: "Root",
  overridesResolver: (pt, yt) => {
    const {
      ownerState: ir
    } = pt;
    return [yt.root, yt[ir.orientation]];
  }
})({
  display: "flex",
  alignItems: "center",
  [`&.${stepLabelClasses.alternativeLabel}`]: {
    flexDirection: "column"
  },
  [`&.${stepLabelClasses.disabled}`]: {
    cursor: "default"
  },
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      textAlign: "left",
      padding: "8px 0"
    }
  }]
}), StepLabelLabel = styled$3("span", {
  name: "MuiStepLabel",
  slot: "Label"
})(memoTheme$1(({
  theme: pt
}) => ({
  ...pt.typography.body2,
  display: "block",
  transition: pt.transitions.create("color", {
    duration: pt.transitions.duration.shortest
  }),
  [`&.${stepLabelClasses.active}, &.${stepLabelClasses.completed}`]: {
    color: (pt.vars || pt).palette.text.primary,
    fontWeight: 500
  },
  [`&.${stepLabelClasses.alternativeLabel}`]: {
    marginTop: 16
  },
  [`&.${stepLabelClasses.error}`]: {
    color: (pt.vars || pt).palette.error.main
  }
}))), StepLabelIconContainer = styled$3("span", {
  name: "MuiStepLabel",
  slot: "IconContainer"
})({
  flexShrink: 0,
  display: "flex",
  paddingRight: 8,
  [`&.${stepLabelClasses.alternativeLabel}`]: {
    paddingRight: 0
  }
}), StepLabelLabelContainer = styled$3("span", {
  name: "MuiStepLabel",
  slot: "LabelContainer"
})(memoTheme$1(({
  theme: pt
}) => ({
  width: "100%",
  color: (pt.vars || pt).palette.text.secondary,
  [`&.${stepLabelClasses.alternativeLabel}`]: {
    textAlign: "center"
  }
}))), StepLabel = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const ir = useDefaultProps$2({
    props: pt,
    name: "MuiStepLabel"
  }), {
    children: ti,
    className: ii,
    componentsProps: ui = {},
    error: ai = !1,
    icon: li,
    optional: oi,
    slots: si = {},
    slotProps: di = {},
    StepIconComponent: fi,
    StepIconProps: gi,
    ...mi
  } = ir, {
    alternativeLabel: Ti,
    orientation: vi
  } = React.useContext(StepperContext), {
    active: xi,
    disabled: Si,
    completed: Pi,
    icon: $i
  } = React.useContext(StepContext), Oi = li || $i;
  let Di = fi;
  Oi && !Di && (Di = StepIcon);
  const Mi = {
    ...ir,
    active: xi,
    alternativeLabel: Ti,
    completed: Pi,
    disabled: Si,
    error: ai,
    orientation: vi
  }, Oo = useUtilityClasses$3$1(Mi), io = {
    slots: si,
    slotProps: {
      stepIcon: gi,
      ...ui,
      ...di
    }
  }, [xo, fo] = useSlot$1("root", {
    elementType: StepLabelRoot,
    externalForwardedProps: {
      ...io,
      ...mi
    },
    ownerState: Mi,
    ref: yt,
    className: clsx$1(Oo.root, ii)
  }), [_o, Li] = useSlot$1("label", {
    elementType: StepLabelLabel,
    externalForwardedProps: io,
    ownerState: Mi
  }), [Co, Ni] = useSlot$1("stepIcon", {
    elementType: Di,
    externalForwardedProps: io,
    ownerState: Mi
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(xo, {
    ...fo,
    children: [Oi || Co ? /* @__PURE__ */ jsxRuntimeExports.jsx(StepLabelIconContainer, {
      className: Oo.iconContainer,
      ownerState: Mi,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Co, {
        completed: Pi,
        active: xi,
        error: ai,
        icon: Oi,
        ...Ni
      })
    }) : null, /* @__PURE__ */ jsxRuntimeExports.jsxs(StepLabelLabelContainer, {
      className: Oo.labelContainer,
      ownerState: Mi,
      children: [ti ? /* @__PURE__ */ jsxRuntimeExports.jsx(_o, {
        ...Li,
        className: clsx$1(Oo.label, Li == null ? void 0 : Li.className),
        children: ti
      }) : null, oi]
    })]
  });
});
process.env.NODE_ENV !== "production" && (StepLabel.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * In most cases will simply be a string containing a title for the label.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The props used for each slot inside.
   * @default {}
   * @deprecated use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  componentsProps: PropTypes.shape({
    label: PropTypes.object
  }),
  /**
   * If `true`, the step is marked as failed.
   * @default false
   */
  error: PropTypes.bool,
  /**
   * Override the default label of the step icon.
   */
  icon: PropTypes.node,
  /**
   * The optional node to display.
   */
  optional: PropTypes.node,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    stepIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    label: PropTypes.elementType,
    root: PropTypes.elementType,
    stepIcon: PropTypes.elementType
  }),
  /**
   * The component to render in place of the [`StepIcon`](https://mui.com/material-ui/api/step-icon/).
   * @deprecated Use `slots.stepIcon` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  StepIconComponent: PropTypes.elementType,
  /**
   * Props applied to the [`StepIcon`](https://mui.com/material-ui/api/step-icon/) element.
   * @deprecated Use `slotProps.stepIcon` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  StepIconProps: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
StepLabel.muiName = "StepLabel";
function getStepConnectorUtilityClass(pt) {
  return generateUtilityClass$2("MuiStepConnector", pt);
}
generateUtilityClasses$2("MuiStepConnector", ["root", "horizontal", "vertical", "alternativeLabel", "active", "completed", "disabled", "line", "lineHorizontal", "lineVertical"]);
const useUtilityClasses$2$1 = (pt) => {
  const {
    classes: yt,
    orientation: ir,
    alternativeLabel: ti,
    active: ii,
    completed: ui,
    disabled: ai
  } = pt, li = {
    root: ["root", ir, ti && "alternativeLabel", ii && "active", ui && "completed", ai && "disabled"],
    line: ["line", `line${capitalize$1(ir)}`]
  };
  return composeClasses$2(li, getStepConnectorUtilityClass, yt);
}, StepConnectorRoot = styled$3("div", {
  name: "MuiStepConnector",
  slot: "Root",
  overridesResolver: (pt, yt) => {
    const {
      ownerState: ir
    } = pt;
    return [yt.root, yt[ir.orientation], ir.alternativeLabel && yt.alternativeLabel, ir.completed && yt.completed];
  }
})({
  flex: "1 1 auto",
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      marginLeft: 12
      // half icon
    }
  }, {
    props: {
      alternativeLabel: !0
    },
    style: {
      position: "absolute",
      top: 12,
      left: "calc(-50% + 20px)",
      right: "calc(50% + 20px)"
    }
  }]
}), StepConnectorLine = styled$3("span", {
  name: "MuiStepConnector",
  slot: "Line",
  overridesResolver: (pt, yt) => {
    const {
      ownerState: ir
    } = pt;
    return [yt.line, yt[`line${capitalize$1(ir.orientation)}`]];
  }
})(memoTheme$1(({
  theme: pt
}) => {
  const yt = pt.palette.mode === "light" ? pt.palette.grey[400] : pt.palette.grey[600];
  return {
    display: "block",
    borderColor: pt.vars ? pt.vars.palette.StepConnector.border : yt,
    variants: [{
      props: {
        orientation: "horizontal"
      },
      style: {
        borderTopStyle: "solid",
        borderTopWidth: 1
      }
    }, {
      props: {
        orientation: "vertical"
      },
      style: {
        borderLeftStyle: "solid",
        borderLeftWidth: 1,
        minHeight: 24
      }
    }]
  };
})), StepConnector = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const ir = useDefaultProps$2({
    props: pt,
    name: "MuiStepConnector"
  }), {
    className: ti,
    ...ii
  } = ir, {
    alternativeLabel: ui,
    orientation: ai = "horizontal"
  } = React.useContext(StepperContext), {
    active: li,
    disabled: oi,
    completed: si
  } = React.useContext(StepContext), di = {
    ...ir,
    alternativeLabel: ui,
    orientation: ai,
    active: li,
    completed: si,
    disabled: oi
  }, fi = useUtilityClasses$2$1(di);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StepConnectorRoot, {
    className: clsx$1(fi.root, ti),
    ref: yt,
    ownerState: di,
    ...ii,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(StepConnectorLine, {
      className: fi.line,
      ownerState: di
    })
  });
});
process.env.NODE_ENV !== "production" && (StepConnector.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function getStepperUtilityClass(pt) {
  return generateUtilityClass$2("MuiStepper", pt);
}
generateUtilityClasses$2("MuiStepper", ["root", "horizontal", "vertical", "nonLinear", "alternativeLabel"]);
const useUtilityClasses$1$1 = (pt) => {
  const {
    orientation: yt,
    nonLinear: ir,
    alternativeLabel: ti,
    classes: ii
  } = pt;
  return composeClasses$2({
    root: ["root", yt, ir && "nonLinear", ti && "alternativeLabel"]
  }, getStepperUtilityClass, ii);
}, StepperRoot = styled$3("div", {
  name: "MuiStepper",
  slot: "Root",
  overridesResolver: (pt, yt) => {
    const {
      ownerState: ir
    } = pt;
    return [yt.root, yt[ir.orientation], ir.alternativeLabel && yt.alternativeLabel, ir.nonLinear && yt.nonLinear];
  }
})({
  display: "flex",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      flexDirection: "row",
      alignItems: "center"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      flexDirection: "column"
    }
  }, {
    props: {
      alternativeLabel: !0
    },
    style: {
      alignItems: "flex-start"
    }
  }]
}), defaultConnector = /* @__PURE__ */ jsxRuntimeExports.jsx(StepConnector, {}), Stepper$1 = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const ir = useDefaultProps$2({
    props: pt,
    name: "MuiStepper"
  }), {
    activeStep: ti = 0,
    alternativeLabel: ii = !1,
    children: ui,
    className: ai,
    component: li = "div",
    connector: oi = defaultConnector,
    nonLinear: si = !1,
    orientation: di = "horizontal",
    ...fi
  } = ir, gi = {
    ...ir,
    nonLinear: si,
    alternativeLabel: ii,
    orientation: di,
    component: li
  }, mi = useUtilityClasses$1$1(gi), Ti = React.Children.toArray(ui).filter(Boolean), vi = Ti.map((Si, Pi) => /* @__PURE__ */ React.cloneElement(Si, {
    index: Pi,
    last: Pi + 1 === Ti.length,
    ...Si.props
  })), xi = React.useMemo(() => ({
    activeStep: ti,
    alternativeLabel: ii,
    connector: oi,
    nonLinear: si,
    orientation: di
  }), [ti, ii, oi, si, di]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StepperContext.Provider, {
    value: xi,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(StepperRoot, {
      as: li,
      ownerState: gi,
      className: clsx$1(mi.root, ai),
      ref: yt,
      ...fi,
      children: vi
    })
  });
});
process.env.NODE_ENV !== "production" && (Stepper$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the active step (zero based index).
   * Set to -1 to disable all the steps.
   * @default 0
   */
  activeStep: integerPropType$1,
  /**
   * If set to 'true' and orientation is horizontal,
   * then the step label will be positioned under the icon.
   * @default false
   */
  alternativeLabel: PropTypes.bool,
  /**
   * Two or more `<Step />` components.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * An element to be placed between each step.
   * @default <StepConnector />
   */
  connector: PropTypes.element,
  /**
   * If set the `Stepper` will not assist in controlling steps for linear flow.
   * @default false
   */
  nonLinear: PropTypes.bool,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function getSwitchUtilityClass(pt) {
  return generateUtilityClass$2("MuiSwitch", pt);
}
const switchClasses = generateUtilityClasses$2("MuiSwitch", ["root", "edgeStart", "edgeEnd", "switchBase", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium", "checked", "disabled", "input", "thumb", "track"]), useUtilityClasses$I = (pt) => {
  const {
    classes: yt,
    edge: ir,
    size: ti,
    color: ii,
    checked: ui,
    disabled: ai
  } = pt, li = {
    root: ["root", ir && `edge${capitalize$1(ir)}`, `size${capitalize$1(ti)}`],
    switchBase: ["switchBase", `color${capitalize$1(ii)}`, ui && "checked", ai && "disabled"],
    thumb: ["thumb"],
    track: ["track"],
    input: ["input"]
  }, oi = composeClasses$2(li, getSwitchUtilityClass, yt);
  return {
    ...yt,
    // forward the disabled and checked classes to the SwitchBase
    ...oi
  };
}, SwitchRoot = styled$3("span", {
  name: "MuiSwitch",
  slot: "Root",
  overridesResolver: (pt, yt) => {
    const {
      ownerState: ir
    } = pt;
    return [yt.root, ir.edge && yt[`edge${capitalize$1(ir.edge)}`], yt[`size${capitalize$1(ir.size)}`]];
  }
})({
  display: "inline-flex",
  width: 58,
  height: 38,
  overflow: "hidden",
  padding: 12,
  boxSizing: "border-box",
  position: "relative",
  flexShrink: 0,
  zIndex: 0,
  // Reset the stacking context.
  verticalAlign: "middle",
  // For correct alignment with the text.
  "@media print": {
    colorAdjust: "exact"
  },
  variants: [{
    props: {
      edge: "start"
    },
    style: {
      marginLeft: -8
    }
  }, {
    props: {
      edge: "end"
    },
    style: {
      marginRight: -8
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      width: 40,
      height: 24,
      padding: 7,
      [`& .${switchClasses.thumb}`]: {
        width: 16,
        height: 16
      },
      [`& .${switchClasses.switchBase}`]: {
        padding: 4,
        [`&.${switchClasses.checked}`]: {
          transform: "translateX(16px)"
        }
      }
    }
  }]
}), SwitchSwitchBase = styled$3(SwitchBase, {
  name: "MuiSwitch",
  slot: "SwitchBase",
  overridesResolver: (pt, yt) => {
    const {
      ownerState: ir
    } = pt;
    return [yt.switchBase, {
      [`& .${switchClasses.input}`]: yt.input
    }, ir.color !== "default" && yt[`color${capitalize$1(ir.color)}`]];
  }
})(memoTheme$1(({
  theme: pt
}) => ({
  position: "absolute",
  top: 0,
  left: 0,
  zIndex: 1,
  // Render above the focus ripple.
  color: pt.vars ? pt.vars.palette.Switch.defaultColor : `${pt.palette.mode === "light" ? pt.palette.common.white : pt.palette.grey[300]}`,
  transition: pt.transitions.create(["left", "transform"], {
    duration: pt.transitions.duration.shortest
  }),
  [`&.${switchClasses.checked}`]: {
    transform: "translateX(20px)"
  },
  [`&.${switchClasses.disabled}`]: {
    color: pt.vars ? pt.vars.palette.Switch.defaultDisabledColor : `${pt.palette.mode === "light" ? pt.palette.grey[100] : pt.palette.grey[600]}`
  },
  [`&.${switchClasses.checked} + .${switchClasses.track}`]: {
    opacity: 0.5
  },
  [`&.${switchClasses.disabled} + .${switchClasses.track}`]: {
    opacity: pt.vars ? pt.vars.opacity.switchTrackDisabled : `${pt.palette.mode === "light" ? 0.12 : 0.2}`
  },
  [`& .${switchClasses.input}`]: {
    left: "-100%",
    width: "300%"
  }
})), memoTheme$1(({
  theme: pt
}) => ({
  "&:hover": {
    backgroundColor: pt.alpha((pt.vars || pt).palette.action.active, (pt.vars || pt).palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  variants: [...Object.entries(pt.palette).filter(createSimplePaletteValueFilter$1(["light"])).map(([yt]) => ({
    props: {
      color: yt
    },
    style: {
      [`&.${switchClasses.checked}`]: {
        color: (pt.vars || pt).palette[yt].main,
        "&:hover": {
          backgroundColor: pt.alpha((pt.vars || pt).palette[yt].main, (pt.vars || pt).palette.action.hoverOpacity),
          "@media (hover: none)": {
            backgroundColor: "transparent"
          }
        },
        [`&.${switchClasses.disabled}`]: {
          color: pt.vars ? pt.vars.palette.Switch[`${yt}DisabledColor`] : `${pt.palette.mode === "light" ? pt.lighten(pt.palette[yt].main, 0.62) : pt.darken(pt.palette[yt].main, 0.55)}`
        }
      },
      [`&.${switchClasses.checked} + .${switchClasses.track}`]: {
        backgroundColor: (pt.vars || pt).palette[yt].main
      }
    }
  }))]
}))), SwitchTrack = styled$3("span", {
  name: "MuiSwitch",
  slot: "Track"
})(memoTheme$1(({
  theme: pt
}) => ({
  height: "100%",
  width: "100%",
  borderRadius: 14 / 2,
  zIndex: -1,
  transition: pt.transitions.create(["opacity", "background-color"], {
    duration: pt.transitions.duration.shortest
  }),
  backgroundColor: pt.vars ? pt.vars.palette.common.onBackground : `${pt.palette.mode === "light" ? pt.palette.common.black : pt.palette.common.white}`,
  opacity: pt.vars ? pt.vars.opacity.switchTrack : `${pt.palette.mode === "light" ? 0.38 : 0.3}`
}))), SwitchThumb = styled$3("span", {
  name: "MuiSwitch",
  slot: "Thumb"
})(memoTheme$1(({
  theme: pt
}) => ({
  boxShadow: (pt.vars || pt).shadows[1],
  backgroundColor: "currentColor",
  width: 20,
  height: 20,
  borderRadius: "50%"
}))), Switch = /* @__PURE__ */ React.forwardRef(function(pt, yt) {
  const ir = useDefaultProps$2({
    props: pt,
    name: "MuiSwitch"
  }), {
    className: ti,
    color: ii = "primary",
    edge: ui = !1,
    size: ai = "medium",
    sx: li,
    slots: oi = {},
    slotProps: si = {},
    ...di
  } = ir, fi = {
    ...ir,
    color: ii,
    edge: ui,
    size: ai
  }, gi = useUtilityClasses$I(fi), mi = {
    slots: oi,
    slotProps: si
  }, [Ti, vi] = useSlot$1("root", {
    className: clsx$1(gi.root, ti),
    elementType: SwitchRoot,
    externalForwardedProps: mi,
    ownerState: fi,
    additionalProps: {
      sx: li
    }
  }), [xi, Si] = useSlot$1("thumb", {
    className: gi.thumb,
    elementType: SwitchThumb,
    externalForwardedProps: mi,
    ownerState: fi
  }), Pi = /* @__PURE__ */ jsxRuntimeExports.jsx(xi, {
    ...Si
  }), [$i, Oi] = useSlot$1("track", {
    className: gi.track,
    elementType: SwitchTrack,
    externalForwardedProps: mi,
    ownerState: fi
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Ti, {
    ...vi,
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(SwitchSwitchBase, {
      type: "checkbox",
      icon: Pi,
      checkedIcon: Pi,
      ref: yt,
      ownerState: fi,
      ...di,
      classes: {
        ...gi,
        root: gi.switchBase
      },
      slots: {
        ...oi.switchBase && {
          root: oi.switchBase
        },
        ...oi.input && {
          input: oi.input
        }
      },
      slotProps: {
        ...si.switchBase && {
          root: typeof si.switchBase == "function" ? si.switchBase(fi) : si.switchBase
        },
        input: {
          role: "switch"
        },
        ...si.input && {
          input: typeof si.input == "function" ? si.input(fi) : si.input
        }
      }
    }), /* @__PURE__ */ jsxRuntimeExports.jsx($i, {
      ...Oi
    })]
  });
});
process.env.NODE_ENV !== "production" && (Switch.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: PropTypes.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: PropTypes.node,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input#attributes) applied to the `input` element.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   * @deprecated Use `slotProps.input.ref` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputRef: refType$2,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense switch styling.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    switchBase: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    thumb: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    track: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType,
    switchBase: PropTypes.elementType,
    thumb: PropTypes.elementType,
    track: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: PropTypes.any
});
PropTypes.number.isRequired, PropTypes.number.isRequired, PropTypes.arrayOf(PropTypes.number).isRequired, PropTypes.func.isRequired, PropTypes.func.isRequired, PropTypes.number.isRequired;
var is_1, hasRequiredIs;
function requireIs() {
  if (hasRequiredIs) return is_1;
  hasRequiredIs = 1;
  /**!
   * is
   * the definitive JavaScript type testing library
   *
   * @copyright 2013-2014 Enrico Marino / Jordan Harband
   * @license MIT
   */
  var pt = Object.prototype, yt = pt.hasOwnProperty, ir = pt.toString, ti;
  typeof Symbol == "function" && (ti = Symbol.prototype.valueOf);
  var ii;
  typeof BigInt == "function" && (ii = BigInt.prototype.valueOf);
  var ui = function(di) {
    return di !== di;
  }, ai = {
    boolean: 1,
    number: 1,
    string: 1,
    undefined: 1
  }, li = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$/, oi = /^[A-Fa-f0-9]+$/, si = {};
  return si.a = si.type = function(di, fi) {
    return typeof di === fi;
  }, si.defined = function(di) {
    return typeof di < "u";
  }, si.empty = function(di) {
    var fi = ir.call(di), gi;
    if (fi === "[object Array]" || fi === "[object Arguments]" || fi === "[object String]")
      return di.length === 0;
    if (fi === "[object Object]") {
      for (gi in di)
        if (yt.call(di, gi))
          return !1;
      return !0;
    }
    return !di;
  }, si.equal = function(di, fi) {
    if (di === fi)
      return !0;
    var gi = ir.call(di), mi;
    if (gi !== ir.call(fi))
      return !1;
    if (gi === "[object Object]") {
      for (mi in di)
        if (!si.equal(di[mi], fi[mi]) || !(mi in fi))
          return !1;
      for (mi in fi)
        if (!si.equal(di[mi], fi[mi]) || !(mi in di))
          return !1;
      return !0;
    }
    if (gi === "[object Array]") {
      if (mi = di.length, mi !== fi.length)
        return !1;
      for (; mi--; )
        if (!si.equal(di[mi], fi[mi]))
          return !1;
      return !0;
    }
    return gi === "[object Function]" ? di.prototype === fi.prototype : gi === "[object Date]" ? di.getTime() === fi.getTime() : !1;
  }, si.hosted = function(di, fi) {
    var gi = typeof fi[di];
    return gi === "object" ? !!fi[di] : !ai[gi];
  }, si.instance = si.instanceof = function(di, fi) {
    return di instanceof fi;
  }, si.nil = si.null = function(di) {
    return di === null;
  }, si.undef = si.undefined = function(di) {
    return typeof di > "u";
  }, si.args = si.arguments = function(di) {
    var fi = ir.call(di) === "[object Arguments]", gi = !si.array(di) && si.arraylike(di) && si.object(di) && si.fn(di.callee);
    return fi || gi;
  }, si.array = Array.isArray || function(di) {
    return ir.call(di) === "[object Array]";
  }, si.args.empty = function(di) {
    return si.args(di) && di.length === 0;
  }, si.array.empty = function(di) {
    return si.array(di) && di.length === 0;
  }, si.arraylike = function(di) {
    return !!di && !si.bool(di) && yt.call(di, "length") && isFinite(di.length) && si.number(di.length) && di.length >= 0;
  }, si.bool = si.boolean = function(di) {
    return ir.call(di) === "[object Boolean]";
  }, si.false = function(di) {
    return si.bool(di) && !Number(di);
  }, si.true = function(di) {
    return si.bool(di) && !!Number(di);
  }, si.date = function(di) {
    return ir.call(di) === "[object Date]";
  }, si.date.valid = function(di) {
    return si.date(di) && !isNaN(Number(di));
  }, si.element = function(di) {
    return di !== void 0 && typeof HTMLElement < "u" && di instanceof HTMLElement && di.nodeType === 1;
  }, si.error = function(di) {
    return ir.call(di) === "[object Error]";
  }, si.fn = si.function = function(di) {
    var fi = typeof window < "u" && di === window.alert;
    if (fi)
      return !0;
    var gi = ir.call(di);
    return gi === "[object Function]" || gi === "[object GeneratorFunction]" || gi === "[object AsyncFunction]";
  }, si.number = function(di) {
    return ir.call(di) === "[object Number]";
  }, si.infinite = function(di) {
    return di === 1 / 0 || di === -1 / 0;
  }, si.decimal = function(di) {
    return si.number(di) && !ui(di) && !si.infinite(di) && di % 1 !== 0;
  }, si.divisibleBy = function(di, fi) {
    var gi = si.infinite(di), mi = si.infinite(fi), Ti = si.number(di) && !ui(di) && si.number(fi) && !ui(fi) && fi !== 0;
    return gi || mi || Ti && di % fi === 0;
  }, si.integer = si.int = function(di) {
    return si.number(di) && !ui(di) && di % 1 === 0;
  }, si.maximum = function(di, fi) {
    if (ui(di))
      throw new TypeError("NaN is not a valid value");
    if (!si.arraylike(fi))
      throw new TypeError("second argument must be array-like");
    for (var gi = fi.length; --gi >= 0; )
      if (di < fi[gi])
        return !1;
    return !0;
  }, si.minimum = function(di, fi) {
    if (ui(di))
      throw new TypeError("NaN is not a valid value");
    if (!si.arraylike(fi))
      throw new TypeError("second argument must be array-like");
    for (var gi = fi.length; --gi >= 0; )
      if (di > fi[gi])
        return !1;
    return !0;
  }, si.nan = function(di) {
    return !si.number(di) || di !== di;
  }, si.even = function(di) {
    return si.infinite(di) || si.number(di) && di === di && di % 2 === 0;
  }, si.odd = function(di) {
    return si.infinite(di) || si.number(di) && di === di && di % 2 !== 0;
  }, si.ge = function(di, fi) {
    if (ui(di) || ui(fi))
      throw new TypeError("NaN is not a valid value");
    return !si.infinite(di) && !si.infinite(fi) && di >= fi;
  }, si.gt = function(di, fi) {
    if (ui(di) || ui(fi))
      throw new TypeError("NaN is not a valid value");
    return !si.infinite(di) && !si.infinite(fi) && di > fi;
  }, si.le = function(di, fi) {
    if (ui(di) || ui(fi))
      throw new TypeError("NaN is not a valid value");
    return !si.infinite(di) && !si.infinite(fi) && di <= fi;
  }, si.lt = function(di, fi) {
    if (ui(di) || ui(fi))
      throw new TypeError("NaN is not a valid value");
    return !si.infinite(di) && !si.infinite(fi) && di < fi;
  }, si.within = function(di, fi, gi) {
    if (ui(di) || ui(fi) || ui(gi))
      throw new TypeError("NaN is not a valid value");
    if (!si.number(di) || !si.number(fi) || !si.number(gi))
      throw new TypeError("all arguments must be numbers");
    var mi = si.infinite(di) || si.infinite(fi) || si.infinite(gi);
    return mi || di >= fi && di <= gi;
  }, si.object = function(di) {
    return ir.call(di) === "[object Object]";
  }, si.primitive = function(di) {
    return di ? !(typeof di == "object" || si.object(di) || si.fn(di) || si.array(di)) : !0;
  }, si.hash = function(di) {
    return si.object(di) && di.constructor === Object && !di.nodeType && !di.setInterval;
  }, si.regexp = function(di) {
    return ir.call(di) === "[object RegExp]";
  }, si.string = function(di) {
    return ir.call(di) === "[object String]";
  }, si.base64 = function(di) {
    return si.string(di) && (!di.length || li.test(di));
  }, si.hex = function(di) {
    return si.string(di) && (!di.length || oi.test(di));
  }, si.symbol = function(di) {
    return typeof Symbol == "function" && ir.call(di) === "[object Symbol]" && typeof ti.call(di) == "symbol";
  }, si.bigint = function(di) {
    return typeof BigInt == "function" && ir.call(di) === "[object BigInt]" && typeof ii.call(di) == "bigint";
  }, is_1 = si, is_1;
}
var isExports = requireIs();
function urlToObject(pt) {
  return {
    href: pt.href,
    protocol: pt.protocol,
    username: pt.username,
    password: pt.password,
    host: pt.host,
    hostname: pt.hostname,
    port: pt.port,
    pathname: pt.pathname,
    search: pt.search,
    searchParams: [...pt.searchParams].map(([yt, ir]) => ({ key: yt, value: ir })),
    hash: pt.hash,
    origin: pt.origin
  };
}
const prettyLogStyles = {
  reset: [0, 0],
  bold: [1, 22],
  dim: [2, 22],
  italic: [3, 23],
  underline: [4, 24],
  overline: [53, 55],
  inverse: [7, 27],
  hidden: [8, 28],
  strikethrough: [9, 29],
  black: [30, 39],
  red: [31, 39],
  green: [32, 39],
  yellow: [33, 39],
  blue: [34, 39],
  magenta: [35, 39],
  cyan: [36, 39],
  white: [37, 39],
  blackBright: [90, 39],
  redBright: [91, 39],
  greenBright: [92, 39],
  yellowBright: [93, 39],
  blueBright: [94, 39],
  magentaBright: [95, 39],
  cyanBright: [96, 39],
  whiteBright: [97, 39],
  bgBlack: [40, 49],
  bgRed: [41, 49],
  bgGreen: [42, 49],
  bgYellow: [43, 49],
  bgBlue: [44, 49],
  bgMagenta: [45, 49],
  bgCyan: [46, 49],
  bgWhite: [47, 49],
  bgBlackBright: [100, 49],
  bgRedBright: [101, 49],
  bgGreenBright: [102, 49],
  bgYellowBright: [103, 49],
  bgBlueBright: [104, 49],
  bgMagentaBright: [105, 49],
  bgCyanBright: [106, 49],
  bgWhiteBright: [107, 49]
};
function formatTemplate(pt, yt, ir, ti = !1) {
  const ii = String(yt), ui = (oi, si) => `\x1B[${si[0]}m${oi}\x1B[${si[1]}m`, ai = (oi, si) => si != null && typeof si == "string" ? ui(oi, prettyLogStyles[si]) : si != null && Array.isArray(si) ? si.reduce((di, fi) => ai(di, fi), oi) : si != null && si[oi.trim()] != null ? ai(oi, si[oi.trim()]) : si != null && si["*"] != null ? ai(oi, si["*"]) : oi, li = null;
  return ii.replace(/{{(.+?)}}/g, (oi, si) => {
    var di;
    const fi = ir[si] != null ? String(ir[si]) : ti ? "" : oi;
    return pt.stylePrettyLogs ? ai(fi, ((di = pt == null ? void 0 : pt.prettyLogStyles) == null ? void 0 : di[si]) ?? li) + ui("", prettyLogStyles.reset) : fi;
  });
}
function formatNumberAddZeros(pt, yt = 2, ir = 0) {
  return pt != null && isNaN(pt) ? "" : (pt = pt != null ? pt + ir : pt, yt === 2 ? pt == null ? "--" : pt < 10 ? "0" + pt : pt.toString() : pt == null ? "---" : pt < 10 ? "00" + pt : pt < 100 ? "0" + pt : pt.toString());
}
function buildPrettyMeta(pt, yt) {
  var ir, ti, ii, ui, ai, li, oi, si, di, fi, gi, mi, Ti, vi, xi, Si, Pi, $i, Oi;
  if (yt == null)
    return {
      text: "",
      template: pt.prettyLogTemplate,
      placeholders: {}
    };
  let Di = pt.prettyLogTemplate;
  const Mi = {};
  Di.includes("{{yyyy}}.{{mm}}.{{dd}} {{hh}}:{{MM}}:{{ss}}:{{ms}}") ? Di = Di.replace("{{yyyy}}.{{mm}}.{{dd}} {{hh}}:{{MM}}:{{ss}}:{{ms}}", "{{dateIsoStr}}") : pt.prettyLogTimeZone === "UTC" ? (Mi.yyyy = ((ir = yt.date) == null ? void 0 : ir.getUTCFullYear()) ?? "----", Mi.mm = formatNumberAddZeros((ti = yt.date) == null ? void 0 : ti.getUTCMonth(), 2, 1), Mi.dd = formatNumberAddZeros((ii = yt.date) == null ? void 0 : ii.getUTCDate(), 2), Mi.hh = formatNumberAddZeros((ui = yt.date) == null ? void 0 : ui.getUTCHours(), 2), Mi.MM = formatNumberAddZeros((ai = yt.date) == null ? void 0 : ai.getUTCMinutes(), 2), Mi.ss = formatNumberAddZeros((li = yt.date) == null ? void 0 : li.getUTCSeconds(), 2), Mi.ms = formatNumberAddZeros((oi = yt.date) == null ? void 0 : oi.getUTCMilliseconds(), 3)) : (Mi.yyyy = ((si = yt.date) == null ? void 0 : si.getFullYear()) ?? "----", Mi.mm = formatNumberAddZeros((di = yt.date) == null ? void 0 : di.getMonth(), 2, 1), Mi.dd = formatNumberAddZeros((fi = yt.date) == null ? void 0 : fi.getDate(), 2), Mi.hh = formatNumberAddZeros((gi = yt.date) == null ? void 0 : gi.getHours(), 2), Mi.MM = formatNumberAddZeros((mi = yt.date) == null ? void 0 : mi.getMinutes(), 2), Mi.ss = formatNumberAddZeros((Ti = yt.date) == null ? void 0 : Ti.getSeconds(), 2), Mi.ms = formatNumberAddZeros((vi = yt.date) == null ? void 0 : vi.getMilliseconds(), 3));
  const Oo = pt.prettyLogTimeZone === "UTC" ? yt.date : yt.date != null ? new Date(yt.date.getTime() - yt.date.getTimezoneOffset() * 6e4) : void 0;
  Mi.rawIsoStr = (Oo == null ? void 0 : Oo.toISOString()) ?? "", Mi.dateIsoStr = (Oo == null ? void 0 : Oo.toISOString().replace("T", " ").replace("Z", "")) ?? "", Mi.logLevelName = yt.logLevelName, Mi.fileNameWithLine = ((xi = yt.path) == null ? void 0 : xi.fileNameWithLine) ?? "", Mi.filePathWithLine = ((Si = yt.path) == null ? void 0 : Si.filePathWithLine) ?? "", Mi.fullFilePath = ((Pi = yt.path) == null ? void 0 : Pi.fullFilePath) ?? "";
  let io = ($i = pt.parentNames) == null ? void 0 : $i.join(pt.prettyErrorParentNamesSeparator);
  io = io != null && yt.name != null ? io + pt.prettyErrorParentNamesSeparator : void 0;
  const xo = yt.name != null || io != null ? `${io ?? ""}${yt.name ?? ""}` : "";
  return Mi.name = xo, Mi.nameWithDelimiterPrefix = xo.length > 0 ? pt.prettyErrorLoggerNameDelimiter + xo : "", Mi.nameWithDelimiterSuffix = xo.length > 0 ? xo + pt.prettyErrorLoggerNameDelimiter : "", ((Oi = pt.overwrite) == null ? void 0 : Oi.addPlaceholders) != null && pt.overwrite.addPlaceholders(yt, Mi), {
    text: formatTemplate(pt, Di, Mi),
    template: Di,
    placeholders: Mi
  };
}
const DEFAULT_IGNORE_PATTERNS = [
  /(?:^|[\\/])node_modules[\\/].*tslog/i,
  /(?:^|[\\/])deps[\\/].*tslog/i,
  /tslog[\\/]+src[\\/]+internal[\\/]/i,
  /tslog[\\/]+src[\\/]BaseLogger/i,
  /tslog[\\/]+src[\\/]index/i
];
function splitStackLines(pt) {
  const yt = typeof (pt == null ? void 0 : pt.stack) == "string" ? pt.stack : void 0;
  return yt == null || yt.length === 0 ? [] : yt.split(`
`).map((ir) => ir.trimEnd());
}
function sanitizeStackLines(pt) {
  return pt.filter((yt) => yt.length > 0 && !/^\s*Error\b/.test(yt));
}
function toStackFrames(pt, yt) {
  const ir = [];
  for (const ti of pt) {
    const ii = yt(ti);
    ii != null && ir.push(ii);
  }
  return ir;
}
function findFirstExternalFrameIndex(pt, yt = DEFAULT_IGNORE_PATTERNS) {
  for (let ir = 0; ir < pt.length; ir += 1) {
    const ti = pt[ir], ii = ti.filePath ?? "", ui = ti.fullFilePath ?? "";
    if (!yt.some((ai) => ai.test(ii) || ai.test(ui)))
      return ir;
  }
  return 0;
}
function getCleanStackLines(pt) {
  return sanitizeStackLines(splitStackLines(pt));
}
function buildStackTrace(pt, yt) {
  return toStackFrames(getCleanStackLines(pt), yt);
}
function clampIndex(pt, yt) {
  return pt < 0 ? 0 : pt >= yt ? Math.max(0, yt - 1) : pt;
}
function getDefaultIgnorePatterns() {
  return [...DEFAULT_IGNORE_PATTERNS];
}
const DEFAULT_CAUSE_DEPTH = 5;
function collectErrorCauses(pt, yt = {}) {
  const ir = yt.maxDepth ?? DEFAULT_CAUSE_DEPTH, ti = [], ii = /* @__PURE__ */ new Set();
  let ui = pt, ai = 0;
  for (; ui != null && ai < ir; ) {
    const li = ui == null ? void 0 : ui.cause;
    if (li == null || ii.has(li))
      break;
    ii.add(li), ti.push(toError(li)), ui = li, ai += 1;
  }
  return ti;
}
function toError(pt) {
  if (pt instanceof Error)
    return pt;
  const yt = new Error(typeof pt == "string" ? pt : JSON.stringify(pt));
  return typeof pt == "object" && pt != null && Object.assign(yt, pt), yt;
}
function jsonStringifyRecursive(pt) {
  const yt = /* @__PURE__ */ new Set();
  return JSON.stringify(pt, (ir, ti) => {
    if (typeof ti == "object" && ti !== null) {
      if (yt.has(ti))
        return "[Circular]";
      yt.add(ti);
    }
    return typeof ti == "bigint" ? `${ti}` : typeof ti > "u" ? "[undefined]" : ti;
  });
}
function inspect(pt, yt) {
  const ir = {
    seen: [],
    stylize: stylizeNoColor
  };
  return yt != null && _extend(ir, yt), isUndefined(ir.showHidden) && (ir.showHidden = !1), isUndefined(ir.depth) && (ir.depth = 2), isUndefined(ir.colors) && (ir.colors = !0), isUndefined(ir.customInspect) && (ir.customInspect = !0), ir.colors && (ir.stylize = stylizeWithColor), formatValue(ir, pt, ir.depth);
}
inspect.colors = prettyLogStyles;
inspect.styles = {
  special: "cyan",
  number: "yellow",
  boolean: "yellow",
  undefined: "grey",
  null: "bold",
  string: "green",
  date: "magenta",
  regexp: "red"
};
function isBoolean$2(pt) {
  return typeof pt == "boolean";
}
function isUndefined(pt) {
  return pt === void 0;
}
function stylizeNoColor(pt) {
  return pt;
}
function stylizeWithColor(pt, yt) {
  var ir, ti, ii, ui;
  const ai = inspect.styles[yt];
  return ai != null && ((ti = (ir = inspect == null ? void 0 : inspect.colors) == null ? void 0 : ir[ai]) == null ? void 0 : ti[0]) != null && ((ui = (ii = inspect == null ? void 0 : inspect.colors) == null ? void 0 : ii[ai]) == null ? void 0 : ui[1]) != null ? "\x1B[" + inspect.colors[ai][0] + "m" + pt + "\x1B[" + inspect.colors[ai][1] + "m" : pt;
}
function isFunction$1(pt) {
  return typeof pt == "function";
}
function isString(pt) {
  return typeof pt == "string";
}
function isNumber$1(pt) {
  return typeof pt == "number";
}
function isNull(pt) {
  return pt === null;
}
function hasOwn$2(pt, yt) {
  return Object.prototype.hasOwnProperty.call(pt, yt);
}
function isRegExp(pt) {
  return isObject$1(pt) && objectToString(pt) === "[object RegExp]";
}
function isObject$1(pt) {
  return typeof pt == "object" && pt !== null;
}
function isError$1(pt) {
  return isObject$1(pt) && (objectToString(pt) === "[object Error]" || pt instanceof Error);
}
function isDate$1(pt) {
  return isObject$1(pt) && objectToString(pt) === "[object Date]";
}
function objectToString(pt) {
  return Object.prototype.toString.call(pt);
}
function arrayToHash(pt) {
  const yt = {};
  return pt.forEach((ir) => {
    yt[ir] = !0;
  }), yt;
}
function formatArray(pt, yt, ir, ti, ii) {
  const ui = [];
  for (let ai = 0, li = yt.length; ai < li; ++ai)
    hasOwn$2(yt, String(ai)) ? ui.push(formatProperty(pt, yt, ir, ti, String(ai), !0)) : ui.push("");
  return ii.forEach((ai) => {
    ai.match(/^\d+$/) || ui.push(formatProperty(pt, yt, ir, ti, ai, !0));
  }), ui;
}
function formatError(pt) {
  return "[" + Error.prototype.toString.call(pt) + "]";
}
function formatValue(pt, yt, ir = 0) {
  if (pt.customInspect && yt != null && isFunction$1(yt) && (yt == null ? void 0 : yt.inspect) !== inspect && !(yt != null && yt.constructor && (yt == null ? void 0 : yt.constructor.prototype) === yt)) {
    if (typeof yt.inspect != "function" && yt.toString != null)
      return yt.toString();
    let di = yt == null ? void 0 : yt.inspect(ir, pt);
    return isString(di) || (di = formatValue(pt, di, ir)), di;
  }
  const ti = formatPrimitive(pt, yt);
  if (ti)
    return ti;
  let ii = Object.keys(yt);
  const ui = arrayToHash(ii);
  try {
    pt.showHidden && Object.getOwnPropertyNames && (ii = Object.getOwnPropertyNames(yt));
  } catch {
  }
  if (isError$1(yt) && (ii.indexOf("message") >= 0 || ii.indexOf("description") >= 0))
    return formatError(yt);
  if (ii.length === 0)
    if (isFunction$1(pt.stylize)) {
      if (isFunction$1(yt)) {
        const di = yt.name ? ": " + yt.name : "";
        return pt.stylize("[Function" + di + "]", "special");
      }
      if (isRegExp(yt))
        return pt.stylize(RegExp.prototype.toString.call(yt), "regexp");
      if (isDate$1(yt))
        return pt.stylize(Date.prototype.toISOString.call(yt), "date");
      if (isError$1(yt))
        return formatError(yt);
    } else
      return yt;
  let ai = "", li = !1, oi = [`{
`, `
}`];
  if (Array.isArray(yt) && (li = !0, oi = [`[
`, `
]`]), isFunction$1(yt) && (ai = " [Function" + (yt.name ? ": " + yt.name : "") + "]"), isRegExp(yt) && (ai = " " + RegExp.prototype.toString.call(yt)), isDate$1(yt) && (ai = " " + Date.prototype.toUTCString.call(yt)), isError$1(yt) && (ai = " " + formatError(yt)), ii.length === 0 && (!li || yt.length == 0))
    return oi[0] + ai + oi[1];
  if (ir < 0)
    return isRegExp(yt) ? pt.stylize(RegExp.prototype.toString.call(yt), "regexp") : pt.stylize("[Object]", "special");
  pt.seen.push(yt);
  let si;
  return li ? si = formatArray(pt, yt, ir, ui, ii) : si = ii.map((di) => formatProperty(pt, yt, ir, ui, di, li)), pt.seen.pop(), reduceToSingleString(si, ai, oi);
}
function formatProperty(pt, yt, ir, ti, ii, ui) {
  let ai, li, oi = { value: void 0 };
  try {
    oi.value = yt[ii];
  } catch {
  }
  try {
    Object.getOwnPropertyDescriptor && (oi = Object.getOwnPropertyDescriptor(yt, ii) || oi);
  } catch {
  }
  if (oi.get ? oi.set ? li = pt.stylize("[Getter/Setter]", "special") : li = pt.stylize("[Getter]", "special") : oi.set && (li = pt.stylize("[Setter]", "special")), hasOwn$2(ti, ii) || (ai = "[" + ii + "]"), li || (pt.seen.indexOf(oi.value) < 0 ? (isNull(ir) ? li = formatValue(pt, oi.value, void 0) : li = formatValue(pt, oi.value, ir - 1), li.indexOf(`
`) > -1 && (ui ? li = li.split(`
`).map((si) => "  " + si).join(`
`).substr(2) : li = `
` + li.split(`
`).map((si) => "   " + si).join(`
`))) : li = pt.stylize("[Circular]", "special")), isUndefined(ai)) {
    if (ui && ii.match(/^\d+$/))
      return li;
    ai = JSON.stringify("" + ii), ai.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (ai = ai.substr(1, ai.length - 2), ai = pt.stylize(ai, "name")) : (ai = ai.replace(/'/g, "\\'").replace(/\\"/g, "\\'").replace(/(^"|"$)/g, "'"), ai = pt.stylize(ai, "string"));
  }
  return ai + ": " + li;
}
function formatPrimitive(pt, yt) {
  if (isUndefined(yt))
    return pt.stylize("undefined", "undefined");
  if (isString(yt)) {
    const ir = "'" + JSON.stringify(yt).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, "\\'") + "'";
    return pt.stylize(ir, "string");
  }
  if (isNumber$1(yt))
    return pt.stylize("" + yt, "number");
  if (isBoolean$2(yt))
    return pt.stylize("" + yt, "boolean");
  if (isNull(yt))
    return pt.stylize("null", "null");
}
function reduceToSingleString(pt, yt, ir) {
  return ir[0] + (yt === "" ? "" : yt + `
`) + "  " + pt.join(`,
  `) + " " + ir[1];
}
function _extend(pt, yt) {
  const ir = { ...pt };
  if (!yt || !isObject$1(yt))
    return pt;
  const ti = { ...yt }, ii = Object.keys(yt);
  let ui = ii.length;
  for (; ui--; )
    ir[ii[ui]] = ti[ii[ui]];
  return ir;
}
function formatWithOptions(pt, ...yt) {
  const ir = {
    seen: [],
    stylize: stylizeNoColor
  };
  pt != null && _extend(ir, pt);
  const ti = yt[0];
  let ii = 0, ui = "", ai = "";
  if (typeof ti == "string") {
    if (yt.length === 1)
      return ti;
    let li, oi = 0;
    for (let si = 0; si < ti.length - 1; si++)
      if (ti.charCodeAt(si) === 37) {
        const di = ti.charCodeAt(++si);
        if (ii + 1 !== yt.length) {
          switch (di) {
            case 115: {
              const fi = yt[++ii];
              typeof fi == "number" || typeof fi == "bigint" ? li = formatPrimitive(ir, fi) : typeof fi != "object" || fi === null ? li = String(fi) : li = inspect(fi, {
                ...pt,
                compact: 3,
                colors: !1,
                depth: 0
              });
              break;
            }
            case 106:
              li = jsonStringifyRecursive(yt[++ii]);
              break;
            case 100: {
              const fi = yt[++ii];
              typeof fi == "bigint" ? li = formatPrimitive(ir, fi) : typeof fi == "symbol" ? li = "NaN" : li = formatPrimitive(ir, fi);
              break;
            }
            case 79:
              li = inspect(yt[++ii], pt);
              break;
            case 111:
              li = inspect(yt[++ii], {
                ...pt,
                showHidden: !0,
                showProxy: !0,
                depth: 4
              });
              break;
            case 105: {
              const fi = yt[++ii];
              typeof fi == "bigint" ? li = formatPrimitive(ir, fi) : typeof fi == "symbol" ? li = "NaN" : li = formatPrimitive(ir, parseInt(li));
              break;
            }
            case 102: {
              const fi = yt[++ii];
              typeof fi == "symbol" ? li = "NaN" : li = formatPrimitive(ir, parseInt(fi));
              break;
            }
            case 99:
              ii += 1, li = "";
              break;
            case 37:
              ui += ti.slice(oi, si), oi = si + 1;
              continue;
            default:
              continue;
          }
          oi !== si - 1 && (ui += ti.slice(oi, si - 1)), ui += li, oi = si + 1;
        } else di === 37 && (ui += ti.slice(oi, si), oi = si + 1);
      }
    oi !== 0 && (ii++, ai = " ", oi < ti.length && (ui += ti.slice(oi)));
  }
  for (; ii < yt.length; ) {
    const li = yt[ii];
    ui += ai, ui += typeof li != "string" ? inspect(li, pt) : li, ai = " ", ii++;
  }
  return ui;
}
function safeGetCwd() {
  try {
    const pt = globalThis == null ? void 0 : globalThis.process;
    if (typeof (pt == null ? void 0 : pt.cwd) == "function")
      return pt.cwd();
  } catch {
  }
  try {
    const pt = globalThis == null ? void 0 : globalThis.Deno;
    if (typeof (pt == null ? void 0 : pt.cwd) == "function")
      return pt.cwd();
  } catch {
  }
}
function isBrowserEnvironment() {
  return typeof window < "u" && typeof document < "u";
}
function consoleSupportsCssStyling() {
  var pt, yt;
  if (!isBrowserEnvironment())
    return !1;
  const ir = globalThis == null ? void 0 : globalThis.navigator, ti = (ir == null ? void 0 : ir.userAgent) ?? "";
  if (/firefox/i.test(ti))
    return !0;
  const ii = globalThis;
  return (yt = (pt = ii == null ? void 0 : ii.CSS) == null ? void 0 : pt.supports) != null && yt.call(pt, "color", "#000") ? !0 : /safari/i.test(ti) && !/chrome/i.test(ti);
}
function createLoggerEnvironment() {
  const pt = io(), yt = Oi(pt), ir = pt.name === "browser" || pt.name === "worker", ti = ir ? [...getDefaultIgnorePatterns(), /node_modules[\\/].*tslog/i] : [...getDefaultIgnorePatterns(), /node:(?:internal|vm)/i, /\binternal[\\/]/i];
  let ii;
  const ui = {
    getMeta(Co, Ni, Yi, Vo, No, Ui) {
      return Object.assign({}, yt, {
        name: No,
        parentNames: Ui,
        date: /* @__PURE__ */ new Date(),
        logLevelId: Co,
        logLevelName: Ni,
        path: Vo ? void 0 : ui.getCallerStackFrame(Yi)
      });
    },
    getCallerStackFrame(Co, Ni = new Error()) {
      const Yi = buildStackTrace(Ni, (jo) => ai(jo));
      if (Yi.length === 0)
        return {};
      const Vo = findFirstExternalFrameIndex(Yi, ti), No = Number.isFinite(Co) && Co >= 0, Ui = clampIndex(No ? Co : Vo, Yi.length);
      return Yi[Ui] ?? {};
    },
    getErrorTrace(Co) {
      return buildStackTrace(Co, (Ni) => ai(Ni));
    },
    isError(Co) {
      return Li(Co);
    },
    isBuffer(Co) {
      return typeof Buffer < "u" && typeof Buffer.isBuffer == "function" ? Buffer.isBuffer(Co) : !1;
    },
    prettyFormatLogObj(Co, Ni) {
      return Co.reduce((Yi, Vo) => (ui.isError(Vo) ? Yi.errors.push(ui.prettyFormatErrorObj(Vo, Ni)) : Yi.args.push(Vo), Yi), { args: [], errors: [] });
    },
    prettyFormatErrorObj(Co, Ni) {
      const Yi = si(ui.getErrorTrace(Co), Ni), Vo = collectErrorCauses(Co).map((Ui, jo) => {
        const Wi = `Caused by (${jo + 1}): ${Ui.name ?? "Error"}${Ui.message ? `: ${Ui.message}` : ""}`, ji = si(buildStackTrace(Ui, (Hi) => ai(Hi)), Ni);
        return [Wi, ...ji].join(`
`);
      }), No = {
        errorName: ` ${Co.name} `,
        errorMessage: di(Co),
        errorStack: [...Yi, ...Vo].join(`
`)
      };
      return formatTemplate(Ni, Ni.prettyErrorTemplate, No);
    },
    transportFormatted(Co, Ni, Yi, Vo, No) {
      const Ui = No.stylePrettyLogs !== !1, jo = (Yi.length > 0 && Ni.length > 0 ? `
` : "") + Yi.join(`
`), Wi = gi(Co), ji = Ui ? Co : Wi;
      if (fi(Ui)) {
        No.prettyInspectOptions.colors = !1;
        const zo = Di(No.prettyInspectOptions, Ni), Lo = Vo != null ? mi(No, Vo) : { text: Wi, styles: [] }, sa = Lo.text.length > 0 && Lo.styles.length > 0, Ko = (sa ? Lo.text : Wi) + zo + jo;
        sa ? console.log(Ko, ...Lo.styles) : console.log(Ko);
        return;
      }
      No.prettyInspectOptions.colors = Ui;
      const Hi = Di(No.prettyInspectOptions, Ni);
      console.log(ji + Hi + jo);
    },
    transportJSON(Co) {
      console.log(jsonStringifyRecursive(Co));
    }
  };
  return _o() === "test" && (ui.__resetWorkingDirectoryCacheForTests = () => {
    ii = void 0;
  }), ui;
  function ai(Co) {
    return ir ? oi(Co) : li(Co);
  }
  function li(Co) {
    if (typeof Co != "string" || Co.length === 0)
      return;
    const Ni = Co.trim();
    if (!Ni.includes(" at ") && !Ni.startsWith("at "))
      return;
    const Yi = Ni.replace(/^at\s+/, "");
    let Vo, No = Yi;
    const Ui = Yi.match(/^(.*?)\s+\((.*)\)$/);
    Ui && (Vo = Ui[1], No = Ui[2]);
    const jo = No.replace(/^\(/, "").replace(/\)$/, ""), Wi = jo.replace(/\?.*$/, "");
    let ji, Hi, zo = Wi;
    const Lo = Wi.split(":");
    Lo.length >= 3 && /^\d+$/.test(Lo[Lo.length - 1] ?? "") ? (Hi = Lo.pop(), ji = Lo.pop(), zo = Lo.join(":")) : Lo.length >= 2 && /^\d+$/.test(Lo[Lo.length - 1] ?? "") && (ji = Lo.pop(), zo = Lo.join(":"));
    let sa = zo.replace(/^file:\/\//, "");
    const Ko = Si();
    Ko != null && sa.startsWith(Ko) && (sa = sa.slice(Ko.length), sa = sa.replace(/^[\\/]/, "")), sa.length === 0 && (sa = zo);
    const ca = Oo(sa), pa = ca.length > 0 ? ca : sa, ga = pa.split(/\\|\//), ia = ga[ga.length - 1], ra = ia && ji ? `${ia}:${ji}` : void 0, qo = pa && ji ? `${pa}:${ji}` : void 0;
    return {
      fullFilePath: jo,
      fileName: ia,
      fileNameWithLine: ra,
      fileColumn: Hi,
      fileLine: ji,
      filePath: pa,
      filePathWithLine: qo,
      method: Vo
    };
  }
  function oi(Co) {
    var Ni, Yi;
    const Vo = (Ni = globalThis.location) == null ? void 0 : Ni.origin;
    if (Co == null)
      return;
    const No = Co.match(BROWSER_PATH_REGEX);
    if (!No)
      return;
    const Ui = (Yi = No[1]) == null ? void 0 : Yi.replace(/\?.*$/, "");
    if (Ui == null)
      return;
    const jo = Ui.split("/"), Wi = No[2], ji = No[3], Hi = jo[jo.length - 1];
    return {
      fullFilePath: Vo ? `${Vo}${Ui}` : Ui,
      fileName: Hi,
      fileNameWithLine: Hi && Wi ? `${Hi}:${Wi}` : void 0,
      fileColumn: ji,
      fileLine: Wi,
      filePath: Ui,
      filePathWithLine: Wi ? `${Ui}:${Wi}` : void 0,
      method: void 0
    };
  }
  function si(Co, Ni) {
    return Co.map((Yi) => formatTemplate(Ni, Ni.prettyErrorStackTemplate, { ...Yi }, !0));
  }
  function di(Co) {
    return Object.getOwnPropertyNames(Co).filter((Ni) => Ni !== "stack" && Ni !== "cause").reduce((Ni, Yi) => {
      const Vo = Co[Yi];
      return typeof Vo == "function" || Ni.push(String(Vo)), Ni;
    }, []).join(", ");
  }
  function fi(Co) {
    return Co && (pt.name === "browser" || pt.name === "worker") && consoleSupportsCssStyling();
  }
  function gi(Co) {
    return Co.replace(ANSI_REGEX, "");
  }
  function mi(Co, Ni) {
    var Yi;
    if (Ni == null)
      return { text: "", styles: [] };
    const { template: Vo, placeholders: No } = buildPrettyMeta(Co, Ni), Ui = [], jo = [];
    let Wi = 0;
    const ji = /{{(.+?)}}/g;
    let Hi;
    for (; (Hi = ji.exec(Vo)) != null; ) {
      Hi.index > Wi && Ui.push(Vo.slice(Wi, Hi.index));
      const zo = Hi[1], Lo = No[zo] != null ? String(No[zo]) : "", sa = Ti((Yi = Co.prettyLogStyles) == null ? void 0 : Yi[zo], Lo), Ko = vi(sa);
      Ko.length > 0 ? (Ui.push(`%c${Lo}%c`), jo.push(Ko, "")) : Ui.push(Lo), Wi = ji.lastIndex;
    }
    return Wi < Vo.length && Ui.push(Vo.slice(Wi)), {
      text: Ui.join(""),
      styles: jo
    };
  }
  function Ti(Co, Ni) {
    if (Co == null)
      return [];
    if (typeof Co == "string")
      return [Co];
    if (Array.isArray(Co))
      return Co.flatMap((Yi) => Ti(Yi, Ni));
    if (typeof Co == "object") {
      const Yi = Ni.trim(), Vo = Co[Yi] ?? Co["*"];
      return Vo == null ? [] : Ti(Vo, Ni);
    }
    return [];
  }
  function vi(Co) {
    const Ni = /* @__PURE__ */ new Set(), Yi = [];
    for (const Vo of Co) {
      const No = xi(Vo);
      No != null && No.length > 0 && !Ni.has(No) && (Ni.add(No), Yi.push(No));
    }
    return Yi.join("; ");
  }
  function xi(Co) {
    const Ni = COLOR_TOKENS[Co];
    if (Ni != null)
      return `color: ${Ni}`;
    const Yi = BACKGROUND_TOKENS[Co];
    if (Yi != null)
      return `background-color: ${Yi}`;
    switch (Co) {
      case "bold":
        return "font-weight: bold";
      case "dim":
        return "opacity: 0.75";
      case "italic":
        return "font-style: italic";
      case "underline":
        return "text-decoration: underline";
      case "overline":
        return "text-decoration: overline";
      case "inverse":
        return "filter: invert(1)";
      case "hidden":
        return "visibility: hidden";
      case "strikethrough":
        return "text-decoration: line-through";
      default:
        return;
    }
  }
  function Si() {
    return ii === void 0 && (ii = safeGetCwd() ?? null), ii ?? void 0;
  }
  function Pi() {
    return pt.name === "node" || pt.name === "deno" || pt.name === "bun";
  }
  function $i() {
    return pt.name === "node" || pt.name === "deno" || pt.name === "bun";
  }
  function Oi(Co) {
    if (Co.name === "browser" || Co.name === "worker")
      return {
        runtime: Co.name,
        browser: Co.userAgent
      };
    const Ni = {
      runtime: Co.name
    };
    return $i() && (Ni.runtimeVersion = Co.version ?? "unknown"), Pi() && (Ni.hostname = Co.hostname ?? "unknown"), Ni;
  }
  function Di(Co, Ni) {
    try {
      return formatWithOptions(Co, ...Ni);
    } catch {
      return Ni.map(Mi).join(" ");
    }
  }
  function Mi(Co) {
    if (typeof Co == "string")
      return Co;
    try {
      return JSON.stringify(Co);
    } catch {
      return String(Co);
    }
  }
  function Oo(Co) {
    if (typeof Co != "string" || Co.length === 0)
      return Co;
    const Ni = Co.replace(/\\+/g, "\\").replace(/\\/g, "/"), Yi = Ni.startsWith("//"), Vo = Ni.startsWith("/") && !Yi, No = Ni.match(/^[A-Za-z]:/), Ui = No ? No[0] : "", jo = (Ui ? Ni.slice(Ui.length) : Ni).split("/"), Wi = [];
    for (const Hi of jo)
      if (!(Hi === "" || Hi === ".")) {
        if (Hi === "..") {
          Wi.length > 0 && Wi.pop();
          continue;
        }
        Wi.push(Hi);
      }
    let ji = Wi.join("/");
    return Yi ? ji = `//${ji}` : Vo ? ji = `/${ji}` : Ui !== "" && (ji = `${Ui}${ji.length > 0 ? `/${ji}` : ""}`), ji.length === 0 ? Co : ji;
  }
  function io() {
    var Co, Ni, Yi, Vo, No, Ui, jo, Wi, ji;
    if (isBrowserEnvironment()) {
      const Lo = globalThis.navigator;
      return {
        name: "browser",
        userAgent: Lo == null ? void 0 : Lo.userAgent
      };
    }
    const Hi = globalThis;
    if (typeof Hi.importScripts == "function")
      return {
        name: "worker",
        userAgent: (Co = Hi.navigator) == null ? void 0 : Co.userAgent
      };
    const zo = globalThis;
    if (zo.Bun != null) {
      const Lo = zo.Bun.version;
      return {
        name: "bun",
        version: Lo != null ? `bun/${Lo}` : void 0,
        hostname: xo(zo.process, zo.Deno, zo.Bun, zo.location)
      };
    }
    if (zo.Deno != null) {
      const Lo = fo(zo.Deno), sa = (Yi = (Ni = zo.Deno) == null ? void 0 : Ni.version) == null ? void 0 : Yi.deno;
      return {
        name: "deno",
        version: sa != null ? `deno/${sa}` : void 0,
        hostname: Lo ?? xo(zo.process, zo.Deno, zo.Bun, zo.location)
      };
    }
    return ((No = (Vo = zo.process) == null ? void 0 : Vo.versions) == null ? void 0 : No.node) != null || ((Ui = zo.process) == null ? void 0 : Ui.version) != null ? {
      name: "node",
      version: ((Wi = (jo = zo.process) == null ? void 0 : jo.versions) == null ? void 0 : Wi.node) ?? ((ji = zo.process) == null ? void 0 : ji.version),
      hostname: xo(zo.process, zo.Deno, zo.Bun, zo.location)
    } : zo.process != null ? {
      name: "node",
      version: "unknown",
      hostname: xo(zo.process, zo.Deno, zo.Bun, zo.location)
    } : {
      name: "unknown"
    };
  }
  function xo(Co, Ni, Yi, Vo) {
    var No, Ui, jo, Wi, ji, Hi, zo;
    const Lo = ((No = Co == null ? void 0 : Co.env) == null ? void 0 : No.HOSTNAME) ?? ((Ui = Co == null ? void 0 : Co.env) == null ? void 0 : Ui.HOST) ?? ((jo = Co == null ? void 0 : Co.env) == null ? void 0 : jo.COMPUTERNAME);
    if (Lo != null && Lo.length > 0)
      return Lo;
    const sa = ((Wi = Yi == null ? void 0 : Yi.env) == null ? void 0 : Wi.HOSTNAME) ?? ((ji = Yi == null ? void 0 : Yi.env) == null ? void 0 : ji.HOST) ?? ((Hi = Yi == null ? void 0 : Yi.env) == null ? void 0 : Hi.COMPUTERNAME);
    if (sa != null && sa.length > 0)
      return sa;
    try {
      const Ko = (zo = Ni == null ? void 0 : Ni.env) == null ? void 0 : zo.get;
      if (typeof Ko == "function") {
        const ca = Ko("HOSTNAME");
        if (ca != null && ca.length > 0)
          return ca;
      }
    } catch {
    }
    if ((Vo == null ? void 0 : Vo.hostname) != null && Vo.hostname.length > 0)
      return Vo.hostname;
  }
  function fo(Co) {
    var Ni;
    try {
      if (typeof (Co == null ? void 0 : Co.hostname) == "function") {
        const Vo = Co.hostname();
        if (Vo != null && Vo.length > 0)
          return Vo;
      }
    } catch {
    }
    const Yi = (Ni = globalThis.location) == null ? void 0 : Ni.hostname;
    if (Yi != null && Yi.length > 0)
      return Yi;
  }
  function _o() {
    var Co;
    const Ni = globalThis == null ? void 0 : globalThis.process;
    return (Co = Ni == null ? void 0 : Ni.env) == null ? void 0 : Co.NODE_ENV;
  }
  function Li(Co) {
    if (Co instanceof Error)
      return !0;
    if (Co != null && typeof Co == "object") {
      const Ni = Object.prototype.toString.call(Co);
      if (/\[object .*Error\]/.test(Ni))
        return !0;
      const Yi = Co.name;
      if (typeof Yi == "string" && Yi.endsWith("Error"))
        return !0;
    }
    return !1;
  }
}
const ANSI_REGEX = /\u001b\[[0-9;]*m/g, COLOR_TOKENS = {
  black: "#000000",
  red: "#ef5350",
  green: "#66bb6a",
  yellow: "#fdd835",
  blue: "#42a5f5",
  magenta: "#ab47bc",
  cyan: "#26c6da",
  white: "#fafafa",
  blackBright: "#424242",
  redBright: "#ff7043",
  greenBright: "#81c784",
  yellowBright: "#ffe082",
  blueBright: "#64b5f6",
  magentaBright: "#ce93d8",
  cyanBright: "#4dd0e1",
  whiteBright: "#ffffff"
}, BACKGROUND_TOKENS = {
  bgBlack: "#000000",
  bgRed: "#ef5350",
  bgGreen: "#66bb6a",
  bgYellow: "#fdd835",
  bgBlue: "#42a5f5",
  bgMagenta: "#ab47bc",
  bgCyan: "#26c6da",
  bgWhite: "#fafafa",
  bgBlackBright: "#424242",
  bgRedBright: "#ff7043",
  bgGreenBright: "#81c784",
  bgYellowBright: "#ffe082",
  bgBlueBright: "#64b5f6",
  bgMagentaBright: "#ce93d8",
  bgCyanBright: "#4dd0e1",
  bgWhiteBright: "#ffffff"
}, BROWSER_PATH_REGEX = /(?:(?:file|https?|global code|[^@]+)@)?(?:file:)?((?:\/[^:/]+){2,})(?::(\d+))?(?::(\d+))?/, runtime = createLoggerEnvironment();
class BaseLogger {
  constructor(yt, ir, ti = Number.NaN) {
    var ii, ui, ai, li, oi, si, di, fi;
    this.logObj = ir, this.stackDepthLevel = ti, this.runtime = runtime, this.maxErrorCauseDepth = 5, this.settings = {
      type: (yt == null ? void 0 : yt.type) ?? "pretty",
      name: yt == null ? void 0 : yt.name,
      parentNames: yt == null ? void 0 : yt.parentNames,
      minLevel: (yt == null ? void 0 : yt.minLevel) ?? 0,
      argumentsArrayName: yt == null ? void 0 : yt.argumentsArrayName,
      hideLogPositionForProduction: (yt == null ? void 0 : yt.hideLogPositionForProduction) ?? !1,
      prettyLogTemplate: (yt == null ? void 0 : yt.prettyLogTemplate) ?? "{{yyyy}}.{{mm}}.{{dd}} {{hh}}:{{MM}}:{{ss}}:{{ms}}	{{logLevelName}}	{{filePathWithLine}}{{nameWithDelimiterPrefix}}	",
      prettyErrorTemplate: (yt == null ? void 0 : yt.prettyErrorTemplate) ?? `
{{errorName}} {{errorMessage}}
error stack:
{{errorStack}}`,
      prettyErrorStackTemplate: (yt == null ? void 0 : yt.prettyErrorStackTemplate) ?? `  • {{fileName}}	{{method}}
	{{filePathWithLine}}`,
      prettyErrorParentNamesSeparator: (yt == null ? void 0 : yt.prettyErrorParentNamesSeparator) ?? ":",
      prettyErrorLoggerNameDelimiter: (yt == null ? void 0 : yt.prettyErrorLoggerNameDelimiter) ?? "	",
      stylePrettyLogs: (yt == null ? void 0 : yt.stylePrettyLogs) ?? !0,
      prettyLogTimeZone: (yt == null ? void 0 : yt.prettyLogTimeZone) ?? "UTC",
      prettyLogStyles: (yt == null ? void 0 : yt.prettyLogStyles) ?? {
        logLevelName: {
          "*": ["bold", "black", "bgWhiteBright", "dim"],
          SILLY: ["bold", "white"],
          TRACE: ["bold", "whiteBright"],
          DEBUG: ["bold", "green"],
          INFO: ["bold", "blue"],
          WARN: ["bold", "yellow"],
          ERROR: ["bold", "red"],
          FATAL: ["bold", "redBright"]
        },
        dateIsoStr: "white",
        filePathWithLine: "white",
        name: ["white", "bold"],
        nameWithDelimiterPrefix: ["white", "bold"],
        nameWithDelimiterSuffix: ["white", "bold"],
        errorName: ["bold", "bgRedBright", "whiteBright"],
        fileName: ["yellow"],
        fileNameWithLine: "white"
      },
      prettyInspectOptions: (yt == null ? void 0 : yt.prettyInspectOptions) ?? {
        colors: !0,
        compact: !1,
        depth: 1 / 0
      },
      metaProperty: (yt == null ? void 0 : yt.metaProperty) ?? "_meta",
      maskPlaceholder: (yt == null ? void 0 : yt.maskPlaceholder) ?? "[***]",
      maskValuesOfKeys: (yt == null ? void 0 : yt.maskValuesOfKeys) ?? ["password"],
      maskValuesOfKeysCaseInsensitive: (yt == null ? void 0 : yt.maskValuesOfKeysCaseInsensitive) ?? !1,
      maskValuesRegEx: yt == null ? void 0 : yt.maskValuesRegEx,
      prefix: [...(yt == null ? void 0 : yt.prefix) ?? []],
      attachedTransports: [...(yt == null ? void 0 : yt.attachedTransports) ?? []],
      overwrite: {
        mask: (ii = yt == null ? void 0 : yt.overwrite) == null ? void 0 : ii.mask,
        toLogObj: (ui = yt == null ? void 0 : yt.overwrite) == null ? void 0 : ui.toLogObj,
        addMeta: (ai = yt == null ? void 0 : yt.overwrite) == null ? void 0 : ai.addMeta,
        addPlaceholders: (li = yt == null ? void 0 : yt.overwrite) == null ? void 0 : li.addPlaceholders,
        formatMeta: (oi = yt == null ? void 0 : yt.overwrite) == null ? void 0 : oi.formatMeta,
        formatLogObj: (si = yt == null ? void 0 : yt.overwrite) == null ? void 0 : si.formatLogObj,
        transportFormatted: (di = yt == null ? void 0 : yt.overwrite) == null ? void 0 : di.transportFormatted,
        transportJSON: (fi = yt == null ? void 0 : yt.overwrite) == null ? void 0 : fi.transportJSON
      }
    }, this.captureStackForMeta = this._shouldCaptureStack();
  }
  log(yt, ir, ...ti) {
    var ii, ui, ai, li, oi, si, di, fi, gi, mi, Ti, vi;
    if (yt < this.settings.minLevel)
      return;
    const xi = this._resolveLogArguments(ti), Si = [...this.settings.prefix, ...xi], Pi = ((ii = this.settings.overwrite) == null ? void 0 : ii.mask) != null ? (ui = this.settings.overwrite) == null ? void 0 : ui.mask(Si) : this.settings.maskValuesOfKeys != null && this.settings.maskValuesOfKeys.length > 0 ? this._mask(Si) : Si, $i = this.logObj != null ? this._recursiveCloneAndExecuteFunctions(this.logObj) : void 0, Oi = ((ai = this.settings.overwrite) == null ? void 0 : ai.toLogObj) != null ? (li = this.settings.overwrite) == null ? void 0 : li.toLogObj(Pi, $i) : this._toLogObj(Pi, $i), Di = ((oi = this.settings.overwrite) == null ? void 0 : oi.addMeta) != null ? (si = this.settings.overwrite) == null ? void 0 : si.addMeta(Oi, yt, ir) : this._addMetaToLogObj(Oi, yt, ir), Mi = Di == null ? void 0 : Di[this.settings.metaProperty];
    let Oo, io;
    if (((di = this.settings.overwrite) == null ? void 0 : di.formatMeta) != null && (Oo = (fi = this.settings.overwrite) == null ? void 0 : fi.formatMeta(Di == null ? void 0 : Di[this.settings.metaProperty])), ((gi = this.settings.overwrite) == null ? void 0 : gi.formatLogObj) != null && (io = (mi = this.settings.overwrite) == null ? void 0 : mi.formatLogObj(Pi, this.settings)), this.settings.type === "pretty" && (Oo = Oo ?? this._prettyFormatLogObjMeta(Di == null ? void 0 : Di[this.settings.metaProperty]), io = io ?? runtime.prettyFormatLogObj(Pi, this.settings)), Oo != null && io != null)
      if (((Ti = this.settings.overwrite) == null ? void 0 : Ti.transportFormatted) != null) {
        const xo = this.settings.overwrite.transportFormatted, fo = xo.length;
        fo < 4 ? xo(Oo, io.args, io.errors) : fo === 4 ? xo(Oo, io.args, io.errors, Mi) : xo(Oo, io.args, io.errors, Mi, this.settings);
      } else
        runtime.transportFormatted(Oo, io.args, io.errors, Mi, this.settings);
    else
      ((vi = this.settings.overwrite) == null ? void 0 : vi.transportJSON) != null ? this.settings.overwrite.transportJSON(Di) : this.settings.type !== "hidden" && runtime.transportJSON(Di);
    return this.settings.attachedTransports != null && this.settings.attachedTransports.length > 0 && this.settings.attachedTransports.forEach((xo) => {
      xo(Di);
    }), Di;
  }
  attachTransport(yt) {
    this.settings.attachedTransports.push(yt);
  }
  getSubLogger(yt, ir) {
    var ti, ii, ui;
    const ai = {
      ...this.settings,
      ...yt,
      parentNames: ((ti = this.settings) == null ? void 0 : ti.parentNames) != null && ((ii = this.settings) == null ? void 0 : ii.name) != null ? [...this.settings.parentNames, this.settings.name] : ((ui = this.settings) == null ? void 0 : ui.name) != null ? [this.settings.name] : void 0,
      prefix: [...this.settings.prefix, ...(yt == null ? void 0 : yt.prefix) ?? []]
    };
    return new this.constructor(ai, ir ?? this.logObj, this.stackDepthLevel);
  }
  _mask(yt) {
    const ir = this._getMaskKeys();
    return yt == null ? void 0 : yt.map((ti) => this._recursiveCloneAndMaskValuesOfKeys(ti, ir));
  }
  _getMaskKeys() {
    var yt;
    const ir = this.settings.maskValuesOfKeys ?? [], ti = ir.map(String).join("|");
    if (this.settings.maskValuesOfKeysCaseInsensitive === !0) {
      if (((yt = this.maskKeysCache) == null ? void 0 : yt.source) === ir && this.maskKeysCache.caseInsensitive === !0 && this.maskKeysCache.signature === ti)
        return this.maskKeysCache.normalized;
      const ii = ir.map((ui) => typeof ui == "string" ? ui.toLowerCase() : String(ui).toLowerCase());
      return this.maskKeysCache = {
        source: ir,
        caseInsensitive: !0,
        normalized: ii,
        signature: ti
      }, ii;
    }
    return this.maskKeysCache = {
      source: ir,
      caseInsensitive: !1,
      normalized: ir,
      signature: ti
    }, ir;
  }
  _resolveLogArguments(yt) {
    if (yt.length === 1 && typeof yt[0] == "function") {
      const ir = yt[0];
      if (ir.length === 0) {
        const ti = ir();
        return Array.isArray(ti) ? ti : [ti];
      }
    }
    return yt;
  }
  _recursiveCloneAndMaskValuesOfKeys(yt, ir, ti = []) {
    var ii, ui;
    if (ti.includes(yt))
      return { ...yt };
    if (typeof yt == "object" && yt !== null && ti.push(yt), runtime.isError(yt) || runtime.isBuffer(yt))
      return yt;
    if (yt instanceof Map)
      return new Map(yt);
    if (yt instanceof Set)
      return new Set(yt);
    if (Array.isArray(yt))
      return yt.map((ai) => this._recursiveCloneAndMaskValuesOfKeys(ai, ir, ti));
    if (yt instanceof Date)
      return new Date(yt.getTime());
    if (yt instanceof URL)
      return urlToObject(yt);
    if (yt !== null && typeof yt == "object") {
      const ai = runtime.isError(yt) ? this._cloneError(yt) : Object.create(Object.getPrototypeOf(yt));
      return Object.getOwnPropertyNames(yt).reduce((li, oi) => {
        var si;
        const di = ((si = this.settings) == null ? void 0 : si.maskValuesOfKeysCaseInsensitive) !== !0 ? oi : typeof oi == "string" ? oi.toLowerCase() : String(oi).toLowerCase();
        return li[oi] = ir.includes(di) ? this.settings.maskPlaceholder : (() => {
          try {
            return this._recursiveCloneAndMaskValuesOfKeys(yt[oi], ir, ti);
          } catch {
            return null;
          }
        })(), li;
      }, ai);
    } else {
      if (typeof yt == "string") {
        let ai = yt;
        for (const li of ((ii = this.settings) == null ? void 0 : ii.maskValuesRegEx) || [])
          ai = ai.replace(li, ((ui = this.settings) == null ? void 0 : ui.maskPlaceholder) || "");
        return ai;
      }
      return yt;
    }
  }
  _recursiveCloneAndExecuteFunctions(yt, ir = []) {
    return this.isObjectOrArray(yt) && ir.includes(yt) ? this.shallowCopy(yt) : (this.isObjectOrArray(yt) && ir.push(yt), Array.isArray(yt) ? yt.map((ti) => this._recursiveCloneAndExecuteFunctions(ti, ir)) : yt instanceof Date ? new Date(yt.getTime()) : this.isObject(yt) ? Object.getOwnPropertyNames(yt).reduce((ti, ii) => {
      const ui = Object.getOwnPropertyDescriptor(yt, ii);
      if (ui) {
        Object.defineProperty(ti, ii, ui);
        const ai = yt[ii];
        ti[ii] = typeof ai == "function" ? ai() : this._recursiveCloneAndExecuteFunctions(ai, ir);
      }
      return ti;
    }, Object.create(Object.getPrototypeOf(yt))) : yt);
  }
  isObjectOrArray(yt) {
    return typeof yt == "object" && yt !== null;
  }
  isObject(yt) {
    return typeof yt == "object" && !Array.isArray(yt) && yt !== null;
  }
  shallowCopy(yt) {
    return Array.isArray(yt) ? [...yt] : { ...yt };
  }
  _toLogObj(yt, ir = {}) {
    return yt = yt == null ? void 0 : yt.map((ti) => runtime.isError(ti) ? this._toErrorObject(ti) : ti), this.settings.argumentsArrayName == null ? yt.length === 1 && !Array.isArray(yt[0]) && runtime.isBuffer(yt[0]) !== !0 && !(yt[0] instanceof Date) ? ir = typeof yt[0] == "object" && yt[0] != null ? { ...yt[0], ...ir } : { 0: yt[0], ...ir } : ir = { ...ir, ...yt } : ir = {
      ...ir,
      [this.settings.argumentsArrayName]: yt
    }, ir;
  }
  _cloneError(yt) {
    const ir = new yt.constructor();
    return Object.getOwnPropertyNames(yt).forEach((ti) => {
      ir[ti] = yt[ti];
    }), ir;
  }
  _toErrorObject(yt, ir = 0, ti = /* @__PURE__ */ new Set()) {
    ti.has(yt) || ti.add(yt);
    const ii = {
      nativeError: yt,
      name: yt.name ?? "Error",
      message: yt.message,
      stack: runtime.getErrorTrace(yt)
    };
    if (ir >= this.maxErrorCauseDepth)
      return ii;
    const ui = yt.cause;
    if (ui != null) {
      const ai = toError(ui);
      ti.has(ai) || (ii.cause = this._toErrorObject(ai, ir + 1, ti));
    }
    return ii;
  }
  _addMetaToLogObj(yt, ir, ti) {
    return {
      ...yt,
      [this.settings.metaProperty]: runtime.getMeta(ir, ti, this.stackDepthLevel, !this.captureStackForMeta, this.settings.name, this.settings.parentNames)
    };
  }
  _shouldCaptureStack() {
    if (this.settings.hideLogPositionForProduction)
      return !1;
    if (this.settings.type === "json")
      return !0;
    const yt = this.settings.prettyLogTemplate ?? "";
    return !!/{{\s*(file(Name|Path|Line|PathWithLine|NameWithLine)|fullFilePath)\s*}}/.test(yt);
  }
  _prettyFormatLogObjMeta(yt) {
    return buildPrettyMeta(this.settings, yt).text;
  }
}
class Logger extends BaseLogger {
  constructor(yt, ir) {
    const ti = typeof window < "u" && typeof document < "u", ii = { ...yt ?? {} };
    ti && (ii.stylePrettyLogs = (yt == null ? void 0 : yt.stylePrettyLogs) ?? !0), super(ii, ir, Number.NaN);
  }
  log(yt, ir, ...ti) {
    return super.log(yt, ir, ...ti);
  }
  silly(...yt) {
    return super.log(0, "SILLY", ...yt);
  }
  trace(...yt) {
    return super.log(1, "TRACE", ...yt);
  }
  debug(...yt) {
    return super.log(2, "DEBUG", ...yt);
  }
  info(...yt) {
    return super.log(3, "INFO", ...yt);
  }
  warn(...yt) {
    return super.log(4, "WARN", ...yt);
  }
  error(...yt) {
    return super.log(5, "ERROR", ...yt);
  }
  fatal(...yt) {
    return super.log(6, "FATAL", ...yt);
  }
  getSubLogger(yt, ir) {
    return super.getSubLogger(yt, ir);
  }
}
const log$3 = new Logger({ name: "numbers" }), ensureIsNumber = (pt, yt) => isExports.number(pt) ? pt : isExports.number(yt) ? (log$3.warn(`ensureIsNumber: ${pt} is not a number - returning default value.`), yt) : (log$3.warn("ensureIsNumber: default value is not a number - returning Number.NaN"), Number.NaN);
new Logger({ name: "utils:func" });
PropTypes.boolean, PropTypes.arrayOf(
  PropTypes.oneOfType([
    PropTypes.shape({
      onSelect: PropTypes.func,
      key: PropTypes.string,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired
    }),
    PropTypes.node
  ])
).isRequired, PropTypes.string, PropTypes.node;
PropTypes.arrayOf(
  PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool
  ])
), PropTypes.shape({
  field: PropTypes.string.isRequired,
  headerName: PropTypes.string,
  selector: PropTypes.func
}).isRequired, PropTypes.arrayOf(
  PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool
      ]).isRequired
    })
  ])
), PropTypes.func.isRequired, PropTypes.arrayOf(PropTypes.object).isRequired;
PropTypes.string, PropTypes.bool, PropTypes.shape({
  field: PropTypes.string.isRequired,
  // Field that holds the data to display
  headerName: PropTypes.string,
  // Column header title
  cell: PropTypes.func,
  // Custom cell rendering function
  minWidth: PropTypes.number,
  // Column minimum width
  maxWidth: PropTypes.number,
  // Column maximum width
  filterable: PropTypes.bool,
  // Whether the column shows a filter dropdown
  filterOptions: PropTypes.array,
  // Explicit filter options (overrides deriving from row data)
  filterMatcher: PropTypes.func,
  // Custom match fn: (value, selectedValues) => bool
  flex: PropTypes.number,
  // Column flex (mapped to grow)
  selector: PropTypes.func,
  sortable: PropTypes.bool,
  // Whether the column is sortable
  omit: PropTypes.bool
}), PropTypes.arrayOf(
  PropTypes.shape({
    field: PropTypes.string.isRequired,
    // Field that holds the data to display
    headerName: PropTypes.string,
    // Column header title
    cell: PropTypes.func,
    // Custom cell rendering function
    minWidth: PropTypes.number,
    // Column minimum width
    maxWidth: PropTypes.number,
    // Column maximum width
    filterable: PropTypes.bool,
    // Whether the column shows a filter dropdown
    filterOptions: PropTypes.array,
    // Explicit filter options (overrides deriving from row data)
    filterMatcher: PropTypes.func,
    // Custom match fn: (value, selectedValues) => bool
    flex: PropTypes.number,
    // Column flex (mapped to grow)
    sortable: PropTypes.bool
    // Whether the column is sortable
  })
), PropTypes.bool, PropTypes.bool, PropTypes.func, PropTypes.func, PropTypes.arrayOf(PropTypes.string), PropTypes.bool, PropTypes.string, PropTypes.number, PropTypes.arrayOf(PropTypes.number), PropTypes.number, PropTypes.bool, PropTypes.number, PropTypes.bool, PropTypes.func, PropTypes.func, PropTypes.func, PropTypes.func, PropTypes.func, PropTypes.func, PropTypes.func, PropTypes.object, PropTypes.arrayOf(PropTypes.object), PropTypes.string, PropTypes.arrayOf(PropTypes.string), PropTypes.string.isRequired, PropTypes.oneOf(["asc", "desc"]);
PropTypes.bool, PropTypes.func, PropTypes.array, PropTypes.array.isRequired, PropTypes.oneOf(["tablist", "menu"]), PropTypes.array, PropTypes.array, PropTypes.array, PropTypes.array;
PropTypes.bool, PropTypes.bool, PropTypes.oneOfType([PropTypes.string, PropTypes.node]), PropTypes.oneOf([
  "headerCenter",
  "headerLeft",
  "headerRight"
]), PropTypes.string, PropTypes.shape({ content: PropTypes.func }), PropTypes.func.isRequired;
PropTypes.oneOfType([PropTypes.string, PropTypes.number]), PropTypes.string, PropTypes.node, PropTypes.bool, PropTypes.func, PropTypes.node, PropTypes.bool, PropTypes.object;
function c$3(pt, yt, ir, ti) {
  var ii = this, ui = useRef(null), ai = useRef(0), li = useRef(0), oi = useRef(null), si = useRef([]), di = useRef(), fi = useRef(), gi = useRef(pt), mi = useRef(!0), Ti = useRef(), vi = useRef();
  gi.current = pt;
  var xi = typeof window < "u", Si = !yt && yt !== 0 && xi;
  if (typeof pt != "function") throw new TypeError("Expected a function");
  yt = +yt || 0;
  var Pi = !!(ir = ir || {}).leading, $i = !("trailing" in ir) || !!ir.trailing, Oi = !!ir.flushOnExit && $i, Di = "maxWait" in ir, Mi = "debounceOnServer" in ir && !!ir.debounceOnServer, Oo = Di ? Math.max(+ir.maxWait || 0, yt) : null, io = useMemo(function() {
    var xo = function(Vo) {
      var No = si.current, Ui = di.current;
      return si.current = di.current = null, ai.current = Vo, li.current = li.current || Vo, fi.current = gi.current.apply(Ui, No);
    }, fo = function(Vo, No) {
      Si && cancelAnimationFrame(oi.current), oi.current = Si ? requestAnimationFrame(Vo) : setTimeout(Vo, No);
    }, _o = function(Vo) {
      if (!mi.current) return !1;
      var No = Vo - ui.current;
      return !ui.current || No >= yt || No < 0 || Di && Vo - ai.current >= Oo;
    }, Li = function(Vo) {
      return oi.current = null, $i && si.current ? xo(Vo) : (si.current = di.current = null, fi.current);
    }, Co = function Vo() {
      var No = Date.now();
      if (Pi && li.current === ai.current && Ni(), _o(No)) return Li(No);
      if (mi.current) {
        var Ui = yt - (No - ui.current), jo = Di ? Math.min(Ui, Oo - (No - ai.current)) : Ui;
        fo(Vo, jo);
      }
    }, Ni = function() {
    }, Yi = function() {
      if (xi || Mi) {
        var Vo, No = Date.now(), Ui = _o(No);
        if (si.current = [].slice.call(arguments), di.current = ii, ui.current = No, Oi && !Ti.current && (Ti.current = function() {
          var jo;
          ((jo = globalThis.document) == null ? void 0 : jo.visibilityState) === "hidden" && vi.current.flush();
        }, (Vo = globalThis.document) == null || Vo.addEventListener == null || Vo.addEventListener("visibilitychange", Ti.current)), Ui) {
          if (!oi.current && mi.current) return ai.current = ui.current, fo(Co, yt), Pi ? xo(ui.current) : fi.current;
          if (Di) return fo(Co, yt), xo(ui.current);
        }
        return oi.current || fo(Co, yt), fi.current;
      }
    };
    return Yi.cancel = function() {
      var Vo = oi.current;
      Vo && (Si ? cancelAnimationFrame(oi.current) : clearTimeout(oi.current)), ai.current = 0, si.current = ui.current = di.current = oi.current = null;
    }, Yi.isPending = function() {
      return !!oi.current;
    }, Yi.flush = function() {
      return oi.current ? Li(Date.now()) : fi.current;
    }, Yi;
  }, [Pi, Di, yt, Oo, $i, Oi, Si, xi, Mi, ti]);
  return vi.current = io, useEffect(function() {
    return mi.current = !0, function() {
      var xo;
      Oi && vi.current.flush(), Ti.current && ((xo = globalThis.document) == null || xo.removeEventListener == null || xo.removeEventListener("visibilitychange", Ti.current), Ti.current = null), mi.current = !1;
    };
  }, [Oi]), io;
}
function Slot(pt) {
  let {
    type: yt = "div",
    children: ir = [],
    className: ti = "",
    ...ii
  } = pt || {}, ui, ai;
  yt === void 0 && (yt = "div"), Array.isArray(ir) || (ir = [ir]);
  const li = {};
  for (const [oi, si] of Object.entries(ii)) {
    const di = oi.startsWith("on") ? oi.toLocaleLowerCase() : oi.replace(new RegExp("(?<=[a-z])[A-Z]+(?!$)", "g"), (fi) => `-${fi.toLowerCase()}`);
    li[di] = si;
  }
  return isExports.string(ti) && !isExports.empty(ti) && (li.class = ti), pt && isExports.function(pt.onClick) && !isExports.empty(pt.onClick) && (ui = pt.onClick), pt && isExports.function(pt.onKeyDown) && !isExports.empty(pt.onKeyDown) && (ai = pt.onKeyDown), createElement(
    yt,
    {
      ...li,
      onClick: ui,
      onKeyDown: ai
    },
    ...ir
  );
}
function Results(pt) {
  let {
    type: yt = "alc-search-bar-results",
    className: ir = "",
    children: ti,
    ...ii
  } = pt ?? {};
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Slot,
    {
      type: yt,
      className: [ir].join(" ").trim(),
      ...ii,
      children: ti
    }
  );
}
function ResultsTitle(pt) {
  let {
    type: yt = "alc-search-bar-results-title",
    className: ir = "",
    children: ti,
    ...ii
  } = pt ?? {};
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Slot,
    {
      type: yt,
      className: [ir].join(" ").trim(),
      ...ii,
      children: ti
    }
  );
}
function ResultsCount(pt) {
  let {
    type: yt = "alc-search-bar-results-title-count",
    className: ir = "",
    children: ti,
    ...ii
  } = pt ?? {};
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Slot,
    {
      type: yt,
      className: [ir].join(" ").trim(),
      ...ii,
      children: ti
    }
  );
}
function ResultsMessage(pt) {
  let {
    type: yt = "alc-search-bar-results-message",
    className: ir = "",
    children: ti,
    ...ii
  } = pt ?? {};
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Slot,
    {
      type: yt,
      className: [ir].join(" ").trim(),
      ...ii,
      children: ti
    }
  );
}
function ResultsItems(pt) {
  let {
    type: yt = "alc-search-bar-results-list",
    className: ir = "",
    children: ti,
    ...ii
  } = pt ?? {};
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Slot,
    {
      type: yt,
      className: [ir].join(" ").trim(),
      role: "listbox",
      ...ii,
      children: ti
    }
  );
}
function ResultsItem(pt) {
  let {
    type: yt = "alc-search-bar-results-listitem",
    className: ir = "",
    children: ti,
    ...ii
  } = pt ?? {};
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Slot,
    {
      type: yt,
      className: [ir].join(" ").trim(),
      role: "option",
      ...ii,
      children: ti
    }
  );
}
const Pagination$2 = (pt) => {
  var yt, ir, ti, ii, ui, ai, li, oi, si, di, fi, gi, mi, Ti, vi, xi;
  const {
    currentPage: Si,
    pages: Pi,
    lastPage: $i,
    onPageChange: Oi,
    addFirstPageButton: Di = !1,
    addLastPageButton: Mi = !1,
    alignment: Oo = "centered",
    render: io = !0,
    slots: xo = {}
  } = pt ?? {}, fo = [Oo, ((yt = xo == null ? void 0 : xo.root) == null ? void 0 : yt.className) ?? ""].join(" ").trim();
  return io ? !isExports.array(Pi) || isExports.empty(Pi) ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {}) : /* @__PURE__ */ jsxRuntimeExports.jsxs(Slot, { type: ((ir = xo == null ? void 0 : xo.root) == null ? void 0 : ir.element) ?? "alc-pagination", className: fo, ...(ti = xo == null ? void 0 : xo.root) == null ? void 0 : ti.attributes, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Slot, { type: ((ui = (ii = xo == null ? void 0 : xo.buttons) == null ? void 0 : ii.leftColumn) == null ? void 0 : ui.element) ?? "alc-pagination-left-column", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "button",
        {
          onClick: (_o) => Oi(1, _o),
          className: Di && Si !== 1 ? "" : "hidden",
          "aria-hidden": !Di && Si !== 1,
          "aria-label": "Go to first page",
          "data-test-id": "first-page-button",
          tabIndex: 0,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx("i", { "aria-hidden": "true", className: ((li = (ai = xo == null ? void 0 : xo.buttons) == null ? void 0 : ai.firstPage) == null ? void 0 : li.icon) ?? "fa-solid fa-chevron-double-left" })
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "button",
        {
          onClick: (_o) => Oi(Si - 1, _o),
          className: Si == 1 || !isExports.array(Pi) ? "hidden" : "",
          "aria-hidden": Si == 1,
          "aria-label": "Go to previous page",
          "data-test-id": "previous-page-button",
          tabIndex: 0,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx("i", { "aria-hidden": "true", className: ((si = (oi = xo == null ? void 0 : xo.buttons) == null ? void 0 : oi.prevPage) == null ? void 0 : si.icon) ?? "fa-solid fa-chevron-left" })
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Slot, { type: ((di = xo == null ? void 0 : xo.buttons) == null ? void 0 : di.element) ?? "alc-pagination-pages", children: isExports.array(Pi) && Pi.filter((_o) => isExports.number(_o)).map((_o, Li) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      "button",
      {
        onClick: (Co) => Oi(_o, Co),
        className: ["page-button", _o === Si ? "active" : ""].join(" ").trim(),
        "aria-label": `Go to page ${_o}`,
        "data-test-id": `page-button-${_o}`,
        tabIndex: 0,
        children: _o
      },
      Li
    )) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Slot, { type: ((gi = (fi = xo == null ? void 0 : xo.buttons) == null ? void 0 : fi.rightColumn) == null ? void 0 : gi.element) ?? "alc-pagination-right-column", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "button",
        {
          onClick: (_o) => Oi(Si + 1, _o),
          type: "text",
          className: Si === $i || !isExports.array(Pi) ? "hidden" : "",
          "aria-hidden": Si === $i,
          "aria-label": "Go to next page",
          "data-test-id": "next-page-button",
          tabIndex: 0,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx("i", { className: ((Ti = (mi = xo == null ? void 0 : xo.buttons) == null ? void 0 : mi.nextPage) == null ? void 0 : Ti.icon) ?? "fa-solid fa-chevron-right", "aria-hidden": "true" })
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "button",
        {
          onClick: (_o) => Oi($i, _o),
          type: "text",
          className: !Mi || Si === $i ? "hidden" : "",
          "aria-hidden": !Mi || Si === $i,
          "aria-label": "Go to last page",
          tabIndex: 0,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx("i", { className: ((xi = (vi = xo == null ? void 0 : xo.buttons) == null ? void 0 : vi.lastPage) == null ? void 0 : xi.icon) ?? "fa-solid fa-chevron-double-right", "aria-hidden": "true" })
        }
      )
    ] })
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
};
Pagination$2.propTypes = {
  /**
   * The current page being displayed.
   *
   * Is used to indicate the page being shown in the pagination row. Minimum should be 1.
   */
  currentPage: PropTypes.number,
  /**
   * A list of page numbers to display in the pagination row.
   *
   * Any non-numbers will be ignored and the pages will be displayed in the order they appear in the list.
   */
  pages: PropTypes.arrayOf(PropTypes.number),
  /**
   * The last available page for the pagination.
   *
   * Used to know when to stop showing the next and last page buttons.
   */
  lastPage: PropTypes.number,
  /**
   * Function to execute when the one of the pagination buttons is clicked, or a page button is clicked.
   *
   * The function will always provide the currently selected page as the first argument and a object of options as
   * the second argument. The contents of the argument changes with the type selected:
   * - event (Event): The Event object provided. (This is always provided)
   * - items (object[]): The objects to be displayed for the selected page. (Only provided for 'local' type)
   */
  onPageChange: PropTypes.func.isRequired,
  /**
   * Indicates that a button to go directly to the first page should be displayed.
   *
   * Defaults to 'false'.
   */
  addFirstPageButton: PropTypes.bool,
  /**
   * Indicates that a button to go directly to the last page should be displayed.
   *
   * Defaults to 'false'.
   */
  addLastPageButton: PropTypes.bool,
  /**
   * Positions the pagination buttons within the pagination row.
   *
   * Accepted values:
   * - 'center': The pagination buttons are centered in the row. This is the default.
   * - 'left-aligned': The pagination buttons are aligned to the left of the row.
   * - 'right-aligned': The pagination buttons are aligned to the right of the row.
   * - 'space-around': The pagination buttons are evenly distributed in the line with equal space around them.
   */
  alignment: PropTypes.oneOf([
    "centered",
    "left-aligned",
    "right-aligned",
    "space-around"
  ]),
  /**
   * The maximum number of pages to show at one time. This should be an odd number and will be increased to the
   * next odd number if it isn't.
   */
  viewportSize: PropTypes.number,
  /**
   * The number of pages that need to be iterated over.
   */
  totalPages: PropTypes.number,
  /**
   * Custom attributes used to modify specific elements/components and/or attributes of components.
   *
   * The shape of slots for this component is thus:
   * {
   *   root: { // affects the root element of the pagination row.
   *     element: the name of the element to render. Defaults to 'alc-pagination',
   *     className: additional classes to add to the element. Defaults to '',
   *     attributes: additional attributes to add to the element.,
   *   },
   *   buttons: { // affects the pagination row buttons.
   *     leftColumn: { // affects the container for the first and prev buttons
   *       element: the name of the element to render. Defaults to 'alc-pagination-left-column'
   *     },
   *     rightColumn: { // affects the container for the last and nxt buttons
   *       element: the name of the element to render. Defaults to 'alc-pagination-right-column'
   *     },
   *     firstPage: { // affects the first page button, if displayed
   *       icon: the font-awesome icon to show as the first button. Defaults to 'fa-solid fa-chevrons-left'.
   *     },
   *     prevPage: { // affects the previous page button
   *       icon: the font-awesome icon to show as the previous button. Defaults to 'fa-solid fa-chevron-left'.
   *     },
   *     current: { // affects the currently selected page button
   *       backgroundColor: the background color of the current / active page button. Defaults to
   *       'var(--vp-bright-blue)'.
   *       color: the color of the page number text of the current / active page button. Defaults to 'var(--vp-white)'.
   *     },
   *     nextPage: { // affects the next page button, if displayed
   *       icon: the font-awesome icon to show as the next button. Defaults to 'fa-solid fa-chevron-right'.
   *     },
   *     lastPage: { // affects the first page button, if displayed
   *       icon: the font-awesome icon to show as the first button. Defaults to 'fa-solid fa-chevrons-right'.
   *     },
   *     backgroundColor: the background color of the other page buttons. Defaults to 'transparent'.
   *     color: the color of the page number text of the page buttons. Defaults to 'var(--vp-dark-blue)'.
   *   }
   * }
   */
  slots: PropTypes.shape({
    root: PropTypes.shape({
      element: PropTypes.string,
      className: PropTypes.string,
      attributes: PropTypes.object
    }),
    buttons: PropTypes.shape({
      leftColumn: PropTypes.shape({
        element: PropTypes.string
      }),
      rightColumn: PropTypes.shape({
        element: PropTypes.string
      }),
      firstPage: PropTypes.shape({
        icon: PropTypes.string
      }),
      prevPage: PropTypes.shape({
        icon: PropTypes.string
      }),
      nextPage: PropTypes.shape({
        icon: PropTypes.string
      }),
      lastPage: PropTypes.shape({
        icon: PropTypes.string
      }),
      current: PropTypes.shape({
        backgroundColor: PropTypes.string,
        color: PropTypes.string
      }),
      backgroundColor: PropTypes.string,
      color: PropTypes.string
    })
  })
};
const log$2 = new Logger({ name: "SearchBar logger" }), SearchBar$1 = (pt) => {
  const {
    accessibleLabel: yt,
    // eslint-disable-next-line
    children: ir,
    disabled: ti,
    enableFilterOnInput: ii = !0,
    endAdornment: ui = {},
    errorMessage: ai,
    filterStartLength: li = 0,
    gridElement: oi,
    handleSearch: si,
    helperText: di,
    identifier: fi = `search-bar-${Math.random().toString(36).substring(2, 9)}`,
    inputBackgroundColor: gi = "var(--vp-bg-grey-blue)",
    inputBorderStyle: mi = "var(--vp-border-line-secondary-dark-grey)",
    inputColor: Ti = "var(--vp-skyline-blue)",
    labelTitle: vi,
    noResultsText: xi = "No matching data.",
    onBlur: Si,
    onClick: Pi,
    onClickResultsItem: $i,
    paginationConfig: Oi = {},
    results: Di = null,
    resultsItem: Mi = null,
    resultsMessage: Oo = null,
    searchDelay: io = 2e3,
    selectedResult: xo,
    slots: fo = {},
    totalResults: _o = 0,
    useWarning: Li,
    warningMessage: Co,
    ...Ni
  } = pt, Yi = "This field is required.", [Vo, No] = useState(xo || ""), Ui = Oi.pagination, [jo, Wi] = useState(!1), [ji, Hi] = useState(!1), zo = () => {
    const ra = [];
    return di && ra.push(`${fi}-helper`), Li && Co && ra.push(`${fi}-warning`), (ai || jo) && ra.push(`${fi}-error`), ra.length > 0 ? ra.join(" ") : void 0;
  }, [Lo, sa] = useState(!1), Ko = (ra) => {
    var qo, xa;
    const $a = ra.relatedTarget;
    Hi(!1);
    const ys = $a && $a.closest(".results-container"), Ss = $a && ($a.getAttribute("aria-label") === "Delete Input" || $a.closest('button[aria-label="Delete Input"]'));
    ys || Ss || (Wi(((xa = (qo = ra == null ? void 0 : ra.target) == null ? void 0 : qo.value) == null ? void 0 : xa.length) === 0 && Ni.required), Si && Si(ra));
  }, ca = (ra) => {
    ra.stopPropagation();
    const qo = ra.target.value, xa = (ra == null ? void 0 : ra.type) === "click" || (ra == null ? void 0 : ra.type) === "focus";
    if ((ra == null ? void 0 : ra.type) === "click" || (ra == null ? void 0 : ra.type) === "focus" ? Hi(!0) : Hi(!Lo), !isExports.string(qo)) {
      log$2.warn("Target element value property is not a string.");
      return;
    }
    Wi(!xa && qo.length === 0 && Ni.required), No(qo), (xa || qo) && Pi && Pi(ra), ii && pa(ra);
  }, pa = c$3((ra) => {
    ra.target.value.length >= li && ga(ra);
  }, io);
  useEffect(() => {
    Vo === "" && ga("");
  }, [Vo]), useEffect(() => {
    ti && xo && Wi(!1);
  }, [ti, xo]);
  function ga(ra) {
    var qo;
    if (!isExports.function(si) || !ii) {
      log$2.warn("handleSearch is not a function.");
      return;
    }
    const xa = isExports.undefined((qo = ra == null ? void 0 : ra.target) == null ? void 0 : qo.value) ? Vo : ra.target.value, $a = ra.type === "click" || ra.type === "focus";
    si(xa, ra, $a);
  }
  const ia = (ra) => {
    ra.preventDefault(), No(""), !isExports.undefined(ui) && !isExports.null(ui) && !isExports.empty(ui) && ui.handleAdornmentClick(ra);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "alc-search-bar",
    {
      class: [jo || ai ? "errorContainer" : "", Li ? "warningContainer" : ""].join(" ").replace(/\s+/g, " ").trim(),
      "data-testid": "alc-search-bar",
      children: [
        ir && /* @__PURE__ */ jsxRuntimeExports.jsx(
          "label",
          {
            htmlFor: `${fi}`,
            className: "search-label",
            title: `Search${vi ? ` ${vi}` : ""}`,
            children: ir
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "inputContainer", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "inputColumn", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Input$2,
            {
              id: fi,
              "aria-label": ir ? void 0 : ti ? `Selected ${xo}` : yt ? `Search for ${yt}` : `Search ${fi}`,
              className: "search-input",
              style: {
                border: jo ? "var(--vp-border-error-red)" : mi,
                backgroundColor: jo ? "var(--vp-bg-grey-blue)" : gi,
                color: jo ? "var(--vp-warning-red)" : Ti,
                fontFamily: jo ? "var(--vp-font-open-sans-semibold)" : "var(--vp-font-open-sans)",
                outline: ji ? "var(--vp-border-input-focus)" : "none"
              },
              error: jo,
              type: "text",
              title: ti ? `Selected ${xo}` : ii && li > 0 ? `You must type ${li} characters to start the search` : "",
              endAdornment: !isExports.undefined(ui) && !isExports.empty(ui) ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                "button",
                {
                  "aria-label": ui.label,
                  title: ui.title,
                  onClick: ia,
                  children: /* @__PURE__ */ jsxRuntimeExports.jsx("i", { className: ui.iconName })
                }
              ) : isExports.empty(Vo) ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                "i",
                {
                  id: `search-input-${fi}`,
                  "aria-hidden": "true",
                  title: "Search Input",
                  className: "fa-regular fa-magnifying-glass"
                }
              ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
                "button",
                {
                  "aria-label": "Delete Input",
                  title: "Remove text",
                  onClick: ia,
                  children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    "i",
                    {
                      "aria-hidden": "true",
                      className: "fa-solid fa-circle-xmark",
                      style: { color: "var(--vp-action-blue)" }
                    }
                  )
                }
              ),
              onChange: (ra) => ca(ra),
              onClick: (ra) => ca(ra),
              onFocus: (ra) => ca(ra),
              onBlur: Ko,
              disabled: Li || ti,
              value: ti ? xo : Vo,
              "aria-describedby": zo(),
              ...Ni,
              onMouseOver: () => sa(!0),
              onMouseOut: () => sa(!1)
            }
          ),
          di && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: `${fi}-helper`, className: "helperText", children: di }),
          ai && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: `${fi}-error`, className: "errorMessage", children: ai }),
          jo && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: `${fi}-error`, className: "errorMessage", children: Yi }),
          Li && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { id: `${fi}-warning`, className: "warningMessage", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("i", { "aria-hidden": "true", className: "fa-solid fa-circle-exclamation" }),
            Co
          ] }),
          !(isExports.nil(Di) || isExports.undefined(Di)) && /* @__PURE__ */ jsxRuntimeExports.jsxs(Results, { ...fo.results, className: "results-container", children: [
            isExports.array(Di) && !isExports.empty(Di) && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs(ResultsTitle, { ...fo.resultsTitle, children: [
                /* @__PURE__ */ jsxRuntimeExports.jsxs(
                  ResultsCount,
                  {
                    ...fo.resultCount,
                    "aria-label": `${_o} result${_o > 1 ? "s" : ""}`,
                    children: [
                      _o,
                      " result",
                      _o > 1 ? "s." : ".",
                      " "
                    ]
                  }
                ),
                Oo && /* @__PURE__ */ jsxRuntimeExports.jsx(ResultsMessage, { ...fo.resultsMessage, children: Oo })
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(ResultsItems, { ...fo.resultsItems, children: Di.map((ra, qo) => /* @__PURE__ */ createElement(
                ResultsItem,
                {
                  ...fo.resultsItem,
                  title: ra == null ? void 0 : ra.name,
                  className: isExports.undefined($i) ? "" : "clickable",
                  onClick: () => !isExports.undefined($i) && $i(ra),
                  onKeyUp: (xa) => {
                    xa.key === "Enter" && (xa.preventDefault(), isExports.undefined($i) || $i(ra));
                  },
                  key: qo,
                  tabIndex: 0
                },
                Mi(ra, qo, Di.length)
              )) })
            ] }),
            isExports.array(Di) && isExports.empty(Di) && /* @__PURE__ */ jsxRuntimeExports.jsx(ResultsMessage, { ...fo.emptyResultsMessage, children: xi }),
            !isExports.array(Di) && /* @__PURE__ */ jsxRuntimeExports.jsx(ResultsMessage, { ...fo.otherResultsMessage, children: Di }),
            (Oi == null ? void 0 : Oi.enabled) && isExports.array(Di) && !isExports.empty(Di) && /* @__PURE__ */ jsxRuntimeExports.jsx(
              Pagination$2,
              {
                firstPage: 1,
                lastPage: Ui.lastPage(),
                currentPage: Ui.getPage(),
                alignment: (Oi == null ? void 0 : Oi.alignment) ?? "center",
                onPageChange: (ra, qo) => {
                  qo.preventDefault();
                  const xa = Math.max(
                    ensureIsNumber(Oi == null ? void 0 : Oi.itemsPerPage, 5),
                    1
                  ), $a = (ra - 1) * xa;
                  Ui.goToPage(ra), Oi == null || Oi.onPageChange(
                    $a,
                    $a + xa,
                    ra
                  );
                },
                pages: Ui.getViewport()
              }
            )
          ] }),
          oi && oi
        ] }) })
      ]
    }
  );
};
SearchBar$1.propTypes = {
  /**
   * Adds "for xxx" to 'Search' for the aria-label and title on button hover
   */
  accessibleLabel: PropTypes.string,
  /**
   * Whether input is disabled or not (after result is selected)
   */
  disabled: PropTypes.bool,
  /**
   * Whether to initiate the filter/search before clicking the button.
   * Set `filterStartLength` to set the number of characters to start the filter from
   */
  enableFilterOnInput: PropTypes.bool,
  /**
   * Custom end adornment properties if the default should be overriden
   */
  endAdornment: PropTypes.shape({
    handleAdornmentClick: PropTypes.func,
    iconName: PropTypes.string,
    label: PropTypes.string,
    title: PropTypes.string
  }),
  /**
   * The message that should be displayed when there's an error
   */
  errorMessage: PropTypes.string,
  /**
   * The number of characters required to be entered before a filter/search starts
   */
  filterStartLength: PropTypes.number,
  /**
   * Elements to stay inline with the pagination dropdown
   */
  gridElement: PropTypes.node,
  /**
   * Callback to handle click of custom adornment
   */
  handleAdornmentClick: PropTypes.func,
  /**
   * Callback when search button is clicked or when more than the characters
   * defined with 'filterStartLength' are entered in the search bar.
   * The arguments passed to this function are the event's target value and the event itself
   */
  handleSearch: PropTypes.func.isRequired,
  /**
   * Helper text displayed below the search input.
   */
  helperText: PropTypes.string,
  /**
   * Identifier used as the input 'id' and label 'for' attributes.
   * Keeping this optional for the time being but is highly recommended for best UX.
   */
  identifier: PropTypes.string,
  /**
  * Background color of the search input bar
  */
  inputBackgroundColor: PropTypes.string,
  /**
   * Style around the border of the search input bar
   */
  inputBorderStyle: PropTypes.string,
  /**
   * Text color of the search input bar
   */
  inputColor: PropTypes.string,
  /**
   * Text added to the label title to make it more descriptive
   */
  labelTitle: PropTypes.string,
  /**
   * The text to display if results is an empty array.
   *
   * Only valid if results are provided.
   *
   * Defaults to 'No matching data.'.
   */
  noResultsText: PropTypes.string,
  /**
   * Callback function when state of element changes focus
   */
  onBlur: PropTypes.func,
  /**
   * Callback function when state of element is clicked
   */
  onClick: PropTypes.func,
  /**
   * Callback when a results item is clicked.
   * The argument passed to this function is the item itself
   */
  onClickResultsItem: PropTypes.func,
  /**
   * Whether the search input field is required or not
   */
  required: PropTypes.bool,
  /**
   * A set of results to display under the search bar.
   */
  results: PropTypes.array,
  /**
   * A function to provide data to render from the results.
   *
   * Required if results are provided.
   */
  resultsItem: PropTypes.func,
  /**
   * A message to display above the results.
   */
  resultsMessage: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node
  ]),
  /**
   * Sets the delay in milliseconds for when keyboard input is being
   *
   * Defaults to 2000.
   */
  searchDelay: PropTypes.number,
  /**
   * Passes through selected value after a search
   */
  selectedResult: PropTypes.string,
  /**
   * The total number of results found during the search.
   *
   * Only rendered if results are provided.
   */
  totalResults: PropTypes.number,
  /**
   * Provides to ability to configure the results section of the SearchBar.
   *
   * Each slots entry has the same shape:
   * - element (string): The name of tag to be rendered for the component.
   * - className (string): A space delimited string whose value will be used for the class attribute for the rendered
   * tag. If the className is empty, the class attribute will not be added to the tag.
   * - attributes: An object of extra attributes to be added to the tag. All attribute names will be converted from
   * camel case (ariaLabel) to kebab case (aria-label) before being added to the tag.
   *
   * These are the elements that may be modified:
   * - results: The root container element for the results.
   *   - element defaults to 'alc-search-bar-results'.
   *   - classname defaults to empty string.
   *   - attributes defaults to empty object.
   * - resultsTitle: The container for the count and message for results.
   *   - element defaults to 'alc-search-bar-results-title'.
   *   - classname defaults to empty string.
   *   - attributes defaults to empty object.
   * - resultsCount: The container for the display of the number of results retrieved.
   *   - element defaults to 'alc-search-bar-results-title-count'.
   *   - classname defaults to empty string.
   *   - attributes defaults to empty object.
   * - resultsMessage: The container for the explanatory message shown with the count.
   *   - element defaults to 'alc-search-bar-results-message'.
   *   - classname defaults to empty string.
   *   - attributes defaults to empty object.
   * - resultsItems: The container for the displayed results.
   *   - element defaults to 'alc-search-bar-results-list'.
   *   - classname defaults to empty string.
   *   - attributes defaults to empty object.
   * - resultsItem: The container for the individual results.
   *   - element defaults to 'alc-search-bar-results-listitem'.
   *   - classname defaults to empty string.
   *   - attributes defaults to empty object.
   * - resultsEmptyResultsMessage: The container for the message displayed if there are no results.
   *   - element defaults to 'alc-search-bar-results-message'.
   *   - classname defaults to empty string.
   *   - attributes defaults to empty object.
   * - resultsOtherResultsMessage: The container for when results is not a list of items, but is also provided something
   * (i.e. A react component to display for loading purposed).
   *   - element defaults to 'alc-search-bar-results-message'.
   *   - classname defaults to empty string.
   *   - attributes defaults to empty object.
   */
  slots: PropTypes.shape({
    results: PropTypes.shape({
      element: PropTypes.string,
      className: PropTypes.string,
      attributes: PropTypes.object
    }),
    resultsTitle: PropTypes.shape({
      element: PropTypes.string,
      className: PropTypes.string,
      attributes: PropTypes.object
    }),
    resultsCount: PropTypes.shape({
      element: PropTypes.string,
      className: PropTypes.string,
      attributes: PropTypes.object
    }),
    resultsMessage: PropTypes.shape({
      element: PropTypes.string,
      className: PropTypes.string,
      attributes: PropTypes.object
    }),
    resultsItems: PropTypes.shape({
      element: PropTypes.string,
      className: PropTypes.string,
      attributes: PropTypes.object
    }),
    resultsItem: PropTypes.shape({
      element: PropTypes.string,
      className: PropTypes.string,
      attributes: PropTypes.object
    }),
    resultsEmptyResultsMessage: PropTypes.shape({
      element: PropTypes.string,
      className: PropTypes.string,
      attributes: PropTypes.object
    }),
    resultsOtherResultsMessage: PropTypes.shape({
      element: PropTypes.string,
      className: PropTypes.string,
      attributes: PropTypes.object
    })
  }),
  /**
   * Configuration object for pagination with the following properties:
   * - enabled (boolean): indicates that pagination will be shown when there are results.
   * - viewportSize (number): the number of pages to show in the page bar.
   * - itemsPerPage (number): the number of items to show on each page; helps with determining the number of pages
   * - onPageChange (function): the function to execute when a new page is selected. This function will be provided
   * with the beginning index of the items to display, the end index of the items to display (non-inclusive), and
   * the current page.
   * - alignment (one of: centered, right-aligned, left-aligned): where the pagination
   * - pagination (object | class): expected to be a pagination Interface implementation. This means that the provided
   * property should have the following properties and methods:
   *   - lastPage (function): provides the last page of the pagination
   *   - getPage (function): returns the current page of the pagination
   *   - goToPage (function): sets the viewport to center on the page passed as the first argument
   *   - getViewport (function: returns the list of page numbers to display.
   *   This is normally added using the useClientSideSearch() hook.
   */
  paginationConfig: PropTypes.shape({
    enabled: PropTypes.bool,
    itemsPerPage: PropTypes.number,
    viewportSize: PropTypes.number,
    onPageChange: PropTypes.func,
    alignment: PropTypes.oneOf([
      "centered",
      "right-aligned",
      "left-aligned"
    ]),
    pagination: PropTypes.shape({
      lastPage: PropTypes.func,
      goToPage: PropTypes.func,
      getPage: PropTypes.func,
      getViewport: PropTypes.func
    })
  }),
  /**
   * Whether the input validation has a warning pattern.
   */
  useWarning: PropTypes.bool,
  /**
   * The message that should be displayed when there's a warning.
   */
  warningMessage: PropTypes.string
};
PropTypes.oneOfType([PropTypes.func, PropTypes.node]), PropTypes.oneOfType([PropTypes.string, PropTypes.number]), PropTypes.bool.isRequired, PropTypes.oneOf([
  "bottom-end",
  "bottom-start",
  "bottom",
  "left-end",
  "left-start",
  "left",
  "right-end",
  "right-start",
  "right",
  "top-end",
  "top-start",
  "top"
]), PropTypes.oneOf([
  "menu-bottom-left",
  "icon-button",
  "menu-size-equal-to-parent",
  "nested-menu"
]), PropTypes.func.isRequired, PropTypes.node;
const styleTypes = [
  "center",
  "start",
  "end",
  "flex-start",
  "flex-end",
  "left",
  "right",
  "normal",
  "space-between",
  "space-around",
  "space-evenly",
  "inherit",
  "initial",
  "revert",
  "revert-layer",
  "unset"
];
PropTypes.node, PropTypes.array, PropTypes.oneOf(styleTypes), PropTypes.string.isRequired, PropTypes.array, PropTypes.oneOf(styleTypes);
var EventKeys = ["dangerouslySetInnerHTML", "onCopy", "onCopyCapture", "onCut", "onCutCapture", "onPaste", "onPasteCapture", "onCompositionEnd", "onCompositionEndCapture", "onCompositionStart", "onCompositionStartCapture", "onCompositionUpdate", "onCompositionUpdateCapture", "onFocus", "onFocusCapture", "onBlur", "onBlurCapture", "onChange", "onChangeCapture", "onBeforeInput", "onBeforeInputCapture", "onInput", "onInputCapture", "onReset", "onResetCapture", "onSubmit", "onSubmitCapture", "onInvalid", "onInvalidCapture", "onLoad", "onLoadCapture", "onError", "onErrorCapture", "onKeyDown", "onKeyDownCapture", "onKeyPress", "onKeyPressCapture", "onKeyUp", "onKeyUpCapture", "onAbort", "onAbortCapture", "onCanPlay", "onCanPlayCapture", "onCanPlayThrough", "onCanPlayThroughCapture", "onDurationChange", "onDurationChangeCapture", "onEmptied", "onEmptiedCapture", "onEncrypted", "onEncryptedCapture", "onEnded", "onEndedCapture", "onLoadedData", "onLoadedDataCapture", "onLoadedMetadata", "onLoadedMetadataCapture", "onLoadStart", "onLoadStartCapture", "onPause", "onPauseCapture", "onPlay", "onPlayCapture", "onPlaying", "onPlayingCapture", "onProgress", "onProgressCapture", "onRateChange", "onRateChangeCapture", "onSeeked", "onSeekedCapture", "onSeeking", "onSeekingCapture", "onStalled", "onStalledCapture", "onSuspend", "onSuspendCapture", "onTimeUpdate", "onTimeUpdateCapture", "onVolumeChange", "onVolumeChangeCapture", "onWaiting", "onWaitingCapture", "onAuxClick", "onAuxClickCapture", "onClick", "onClickCapture", "onContextMenu", "onContextMenuCapture", "onDoubleClick", "onDoubleClickCapture", "onDrag", "onDragCapture", "onDragEnd", "onDragEndCapture", "onDragEnter", "onDragEnterCapture", "onDragExit", "onDragExitCapture", "onDragLeave", "onDragLeaveCapture", "onDragOver", "onDragOverCapture", "onDragStart", "onDragStartCapture", "onDrop", "onDropCapture", "onMouseDown", "onMouseDownCapture", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseMoveCapture", "onMouseOut", "onMouseOutCapture", "onMouseOver", "onMouseOverCapture", "onMouseUp", "onMouseUpCapture", "onSelect", "onSelectCapture", "onTouchCancel", "onTouchCancelCapture", "onTouchEnd", "onTouchEndCapture", "onTouchMove", "onTouchMoveCapture", "onTouchStart", "onTouchStartCapture", "onPointerDown", "onPointerDownCapture", "onPointerMove", "onPointerMoveCapture", "onPointerUp", "onPointerUpCapture", "onPointerCancel", "onPointerCancelCapture", "onPointerEnter", "onPointerEnterCapture", "onPointerLeave", "onPointerLeaveCapture", "onPointerOver", "onPointerOverCapture", "onPointerOut", "onPointerOutCapture", "onGotPointerCapture", "onGotPointerCaptureCapture", "onLostPointerCapture", "onLostPointerCaptureCapture", "onScroll", "onScrollCapture", "onWheel", "onWheelCapture", "onAnimationStart", "onAnimationStartCapture", "onAnimationEnd", "onAnimationEndCapture", "onAnimationIteration", "onAnimationIterationCapture", "onTransitionEnd", "onTransitionEndCapture"];
function isEventKey(pt) {
  if (typeof pt != "string")
    return !1;
  var yt = EventKeys;
  return yt.includes(pt);
}
var SVGElementPropKeys = [
  "aria-activedescendant",
  "aria-atomic",
  "aria-autocomplete",
  "aria-busy",
  "aria-checked",
  "aria-colcount",
  "aria-colindex",
  "aria-colspan",
  "aria-controls",
  "aria-current",
  "aria-describedby",
  "aria-details",
  "aria-disabled",
  "aria-errormessage",
  "aria-expanded",
  "aria-flowto",
  "aria-haspopup",
  "aria-hidden",
  "aria-invalid",
  "aria-keyshortcuts",
  "aria-label",
  "aria-labelledby",
  "aria-level",
  "aria-live",
  "aria-modal",
  "aria-multiline",
  "aria-multiselectable",
  "aria-orientation",
  "aria-owns",
  "aria-placeholder",
  "aria-posinset",
  "aria-pressed",
  "aria-readonly",
  "aria-relevant",
  "aria-required",
  "aria-roledescription",
  "aria-rowcount",
  "aria-rowindex",
  "aria-rowspan",
  "aria-selected",
  "aria-setsize",
  "aria-sort",
  "aria-valuemax",
  "aria-valuemin",
  "aria-valuenow",
  "aria-valuetext",
  "className",
  "color",
  "height",
  "id",
  "lang",
  "max",
  "media",
  "method",
  "min",
  "name",
  "style",
  /*
   * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
   * that can use it, and it conflicts with the recharts prop 'type'
   * https://github.com/recharts/recharts/pull/3327
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
   */
  // 'type',
  "target",
  "width",
  "role",
  "tabIndex",
  "accentHeight",
  "accumulate",
  "additive",
  "alignmentBaseline",
  "allowReorder",
  "alphabetic",
  "amplitude",
  "arabicForm",
  "ascent",
  "attributeName",
  "attributeType",
  "autoReverse",
  "azimuth",
  "baseFrequency",
  "baselineShift",
  "baseProfile",
  "bbox",
  "begin",
  "bias",
  "by",
  "calcMode",
  "capHeight",
  "clip",
  "clipPath",
  "clipPathUnits",
  "clipRule",
  "colorInterpolation",
  "colorInterpolationFilters",
  "colorProfile",
  "colorRendering",
  "contentScriptType",
  "contentStyleType",
  "cursor",
  "cx",
  "cy",
  "d",
  "decelerate",
  "descent",
  "diffuseConstant",
  "direction",
  "display",
  "divisor",
  "dominantBaseline",
  "dur",
  "dx",
  "dy",
  "edgeMode",
  "elevation",
  "enableBackground",
  "end",
  "exponent",
  "externalResourcesRequired",
  "fill",
  "fillOpacity",
  "fillRule",
  "filter",
  "filterRes",
  "filterUnits",
  "floodColor",
  "floodOpacity",
  "focusable",
  "fontFamily",
  "fontSize",
  "fontSizeAdjust",
  "fontStretch",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "format",
  "from",
  "fx",
  "fy",
  "g1",
  "g2",
  "glyphName",
  "glyphOrientationHorizontal",
  "glyphOrientationVertical",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "hanging",
  "horizAdvX",
  "horizOriginX",
  "href",
  "ideographic",
  "imageRendering",
  "in2",
  "in",
  "intercept",
  "k1",
  "k2",
  "k3",
  "k4",
  "k",
  "kernelMatrix",
  "kernelUnitLength",
  "kerning",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "letterSpacing",
  "lightingColor",
  "limitingConeAngle",
  "local",
  "markerEnd",
  "markerHeight",
  "markerMid",
  "markerStart",
  "markerUnits",
  "markerWidth",
  "mask",
  "maskContentUnits",
  "maskUnits",
  "mathematical",
  "mode",
  "numOctaves",
  "offset",
  "opacity",
  "operator",
  "order",
  "orient",
  "orientation",
  "origin",
  "overflow",
  "overlinePosition",
  "overlineThickness",
  "paintOrder",
  "panose1",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointerEvents",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "r",
  "radius",
  "refX",
  "refY",
  "renderingIntent",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "restart",
  "result",
  "rotate",
  "rx",
  "ry",
  "seed",
  "shapeRendering",
  "slope",
  "spacing",
  "specularConstant",
  "specularExponent",
  "speed",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stemh",
  "stemv",
  "stitchTiles",
  "stopColor",
  "stopOpacity",
  "strikethroughPosition",
  "strikethroughThickness",
  "string",
  "stroke",
  "strokeDasharray",
  "strokeDashoffset",
  "strokeLinecap",
  "strokeLinejoin",
  "strokeMiterlimit",
  "strokeOpacity",
  "strokeWidth",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textAnchor",
  "textDecoration",
  "textLength",
  "textRendering",
  "to",
  "transform",
  "u1",
  "u2",
  "underlinePosition",
  "underlineThickness",
  "unicode",
  "unicodeBidi",
  "unicodeRange",
  "unitsPerEm",
  "vAlphabetic",
  "values",
  "vectorEffect",
  "version",
  "vertAdvY",
  "vertOriginX",
  "vertOriginY",
  "vHanging",
  "vIdeographic",
  "viewTarget",
  "visibility",
  "vMathematical",
  "widths",
  "wordSpacing",
  "writingMode",
  "x1",
  "x2",
  "x",
  "xChannelSelector",
  "xHeight",
  "xlinkActuate",
  "xlinkArcrole",
  "xlinkHref",
  "xlinkRole",
  "xlinkShow",
  "xlinkTitle",
  "xlinkType",
  "xmlBase",
  "xmlLang",
  "xmlns",
  "xmlnsXlink",
  "xmlSpace",
  "y1",
  "y2",
  "y",
  "yChannelSelector",
  "z",
  "zoomAndPan",
  "ref",
  "key",
  "angle"
], SVGElementPropKeySet = new Set(SVGElementPropKeys);
function isSvgElementPropKey(pt) {
  return typeof pt != "string" ? !1 : SVGElementPropKeySet.has(pt);
}
function isDataAttribute(pt) {
  return typeof pt == "string" && pt.startsWith("data-");
}
function svgPropertiesNoEvents(pt) {
  if (typeof pt != "object" || pt === null)
    return {};
  var yt = {};
  for (var ir in pt)
    Object.prototype.hasOwnProperty.call(pt, ir) && (isSvgElementPropKey(ir) || isDataAttribute(ir)) && (yt[ir] = pt[ir]);
  return yt;
}
function svgPropertiesNoEventsFromUnknown(pt) {
  if (pt == null)
    return null;
  if (/* @__PURE__ */ isValidElement(pt) && typeof pt.props == "object" && pt.props !== null) {
    var yt = pt.props;
    return svgPropertiesNoEvents(yt);
  }
  return typeof pt == "object" && !Array.isArray(pt) ? svgPropertiesNoEvents(pt) : null;
}
function svgPropertiesAndEvents(pt) {
  var yt = {};
  for (var ir in pt)
    Object.prototype.hasOwnProperty.call(pt, ir) && (isSvgElementPropKey(ir) || isDataAttribute(ir) || isEventKey(ir)) && (yt[ir] = pt[ir]);
  return yt;
}
var _excluded$k = ["children", "width", "height", "viewBox", "className", "style", "title", "desc"];
function _extends$p() {
  return _extends$p = Object.assign ? Object.assign.bind() : function(pt) {
    for (var yt = 1; yt < arguments.length; yt++) {
      var ir = arguments[yt];
      for (var ti in ir) ({}).hasOwnProperty.call(ir, ti) && (pt[ti] = ir[ti]);
    }
    return pt;
  }, _extends$p.apply(null, arguments);
}
function _objectWithoutProperties$k(pt, yt) {
  if (pt == null) return {};
  var ir, ti, ii = _objectWithoutPropertiesLoose$k(pt, yt);
  if (Object.getOwnPropertySymbols) {
    var ui = Object.getOwnPropertySymbols(pt);
    for (ti = 0; ti < ui.length; ti++) ir = ui[ti], yt.indexOf(ir) === -1 && {}.propertyIsEnumerable.call(pt, ir) && (ii[ir] = pt[ir]);
  }
  return ii;
}
function _objectWithoutPropertiesLoose$k(pt, yt) {
  if (pt == null) return {};
  var ir = {};
  for (var ti in pt) if ({}.hasOwnProperty.call(pt, ti)) {
    if (yt.indexOf(ti) !== -1) continue;
    ir[ti] = pt[ti];
  }
  return ir;
}
var Surface = /* @__PURE__ */ forwardRef((pt, yt) => {
  var {
    children: ir,
    width: ti,
    height: ii,
    viewBox: ui,
    className: ai,
    style: li,
    title: oi,
    desc: si
  } = pt, di = _objectWithoutProperties$k(pt, _excluded$k), fi = ui || {
    width: ti,
    height: ii,
    x: 0,
    y: 0
  }, gi = clsx$1("recharts-surface", ai);
  return /* @__PURE__ */ React.createElement("svg", _extends$p({}, svgPropertiesAndEvents(di), {
    className: gi,
    width: ti,
    height: ii,
    style: li,
    viewBox: "".concat(fi.x, " ").concat(fi.y, " ").concat(fi.width, " ").concat(fi.height),
    ref: yt
  }), /* @__PURE__ */ React.createElement("title", null, oi), /* @__PURE__ */ React.createElement("desc", null, si), ir);
}), _excluded$j = ["children", "className"];
function _extends$o() {
  return _extends$o = Object.assign ? Object.assign.bind() : function(pt) {
    for (var yt = 1; yt < arguments.length; yt++) {
      var ir = arguments[yt];
      for (var ti in ir) ({}).hasOwnProperty.call(ir, ti) && (pt[ti] = ir[ti]);
    }
    return pt;
  }, _extends$o.apply(null, arguments);
}
function _objectWithoutProperties$j(pt, yt) {
  if (pt == null) return {};
  var ir, ti, ii = _objectWithoutPropertiesLoose$j(pt, yt);
  if (Object.getOwnPropertySymbols) {
    var ui = Object.getOwnPropertySymbols(pt);
    for (ti = 0; ti < ui.length; ti++) ir = ui[ti], yt.indexOf(ir) === -1 && {}.propertyIsEnumerable.call(pt, ir) && (ii[ir] = pt[ir]);
  }
  return ii;
}
function _objectWithoutPropertiesLoose$j(pt, yt) {
  if (pt == null) return {};
  var ir = {};
  for (var ti in pt) if ({}.hasOwnProperty.call(pt, ti)) {
    if (yt.indexOf(ti) !== -1) continue;
    ir[ti] = pt[ti];
  }
  return ir;
}
var Layer = /* @__PURE__ */ React.forwardRef((pt, yt) => {
  var {
    children: ir,
    className: ti
  } = pt, ii = _objectWithoutProperties$j(pt, _excluded$j), ui = clsx$1("recharts-layer", ti);
  return /* @__PURE__ */ React.createElement("g", _extends$o({
    className: ui
  }, svgPropertiesAndEvents(ii), {
    ref: yt
  }), ir);
}), LegendPortalContext = /* @__PURE__ */ createContext(null), useLegendPortal = () => useContext(LegendPortalContext);
function constant$1(pt) {
  return function() {
    return pt;
  };
}
const cos = Math.cos, sin = Math.sin, sqrt$1 = Math.sqrt, pi$1 = Math.PI, tau$1 = 2 * pi$1, pi = Math.PI, tau = 2 * pi, epsilon = 1e-6, tauEpsilon = tau - epsilon;
function append$3(pt) {
  this._ += pt[0];
  for (let yt = 1, ir = pt.length; yt < ir; ++yt)
    this._ += arguments[yt] + pt[yt];
}
function appendRound(pt) {
  let yt = Math.floor(pt);
  if (!(yt >= 0)) throw new Error(`invalid digits: ${pt}`);
  if (yt > 15) return append$3;
  const ir = 10 ** yt;
  return function(ti) {
    this._ += ti[0];
    for (let ii = 1, ui = ti.length; ii < ui; ++ii)
      this._ += Math.round(arguments[ii] * ir) / ir + ti[ii];
  };
}
class Path {
  constructor(yt) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = yt == null ? append$3 : appendRound(yt);
  }
  moveTo(yt, ir) {
    this._append`M${this._x0 = this._x1 = +yt},${this._y0 = this._y1 = +ir}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(yt, ir) {
    this._append`L${this._x1 = +yt},${this._y1 = +ir}`;
  }
  quadraticCurveTo(yt, ir, ti, ii) {
    this._append`Q${+yt},${+ir},${this._x1 = +ti},${this._y1 = +ii}`;
  }
  bezierCurveTo(yt, ir, ti, ii, ui, ai) {
    this._append`C${+yt},${+ir},${+ti},${+ii},${this._x1 = +ui},${this._y1 = +ai}`;
  }
  arcTo(yt, ir, ti, ii, ui) {
    if (yt = +yt, ir = +ir, ti = +ti, ii = +ii, ui = +ui, ui < 0) throw new Error(`negative radius: ${ui}`);
    let ai = this._x1, li = this._y1, oi = ti - yt, si = ii - ir, di = ai - yt, fi = li - ir, gi = di * di + fi * fi;
    if (this._x1 === null)
      this._append`M${this._x1 = yt},${this._y1 = ir}`;
    else if (gi > epsilon) if (!(Math.abs(fi * oi - si * di) > epsilon) || !ui)
      this._append`L${this._x1 = yt},${this._y1 = ir}`;
    else {
      let mi = ti - ai, Ti = ii - li, vi = oi * oi + si * si, xi = mi * mi + Ti * Ti, Si = Math.sqrt(vi), Pi = Math.sqrt(gi), $i = ui * Math.tan((pi - Math.acos((vi + gi - xi) / (2 * Si * Pi))) / 2), Oi = $i / Pi, Di = $i / Si;
      Math.abs(Oi - 1) > epsilon && this._append`L${yt + Oi * di},${ir + Oi * fi}`, this._append`A${ui},${ui},0,0,${+(fi * mi > di * Ti)},${this._x1 = yt + Di * oi},${this._y1 = ir + Di * si}`;
    }
  }
  arc(yt, ir, ti, ii, ui, ai) {
    if (yt = +yt, ir = +ir, ti = +ti, ai = !!ai, ti < 0) throw new Error(`negative radius: ${ti}`);
    let li = ti * Math.cos(ii), oi = ti * Math.sin(ii), si = yt + li, di = ir + oi, fi = 1 ^ ai, gi = ai ? ii - ui : ui - ii;
    this._x1 === null ? this._append`M${si},${di}` : (Math.abs(this._x1 - si) > epsilon || Math.abs(this._y1 - di) > epsilon) && this._append`L${si},${di}`, ti && (gi < 0 && (gi = gi % tau + tau), gi > tauEpsilon ? this._append`A${ti},${ti},0,1,${fi},${yt - li},${ir - oi}A${ti},${ti},0,1,${fi},${this._x1 = si},${this._y1 = di}` : gi > epsilon && this._append`A${ti},${ti},0,${+(gi >= pi)},${fi},${this._x1 = yt + ti * Math.cos(ui)},${this._y1 = ir + ti * Math.sin(ui)}`);
  }
  rect(yt, ir, ti, ii) {
    this._append`M${this._x0 = this._x1 = +yt},${this._y0 = this._y1 = +ir}h${ti = +ti}v${+ii}h${-ti}Z`;
  }
  toString() {
    return this._;
  }
}
function withPath(pt) {
  let yt = 3;
  return pt.digits = function(ir) {
    if (!arguments.length) return yt;
    if (ir == null)
      yt = null;
    else {
      const ti = Math.floor(ir);
      if (!(ti >= 0)) throw new RangeError(`invalid digits: ${ir}`);
      yt = ti;
    }
    return pt;
  }, () => new Path(yt);
}
function array(pt) {
  return typeof pt == "object" && "length" in pt ? pt : Array.from(pt);
}
function Linear(pt) {
  this._context = pt;
}
Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(pt, yt) {
    switch (pt = +pt, yt = +yt, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(pt, yt) : this._context.moveTo(pt, yt);
        break;
      case 1:
        this._point = 2;
      // falls through
      default:
        this._context.lineTo(pt, yt);
        break;
    }
  }
};
function curveLinear(pt) {
  return new Linear(pt);
}
function x$4(pt) {
  return pt[0];
}
function y$3(pt) {
  return pt[1];
}
function shapeLine(pt, yt) {
  var ir = constant$1(!0), ti = null, ii = curveLinear, ui = null, ai = withPath(li);
  pt = typeof pt == "function" ? pt : pt === void 0 ? x$4 : constant$1(pt), yt = typeof yt == "function" ? yt : yt === void 0 ? y$3 : constant$1(yt);
  function li(oi) {
    var si, di = (oi = array(oi)).length, fi, gi = !1, mi;
    for (ti == null && (ui = ii(mi = ai())), si = 0; si <= di; ++si)
      !(si < di && ir(fi = oi[si], si, oi)) === gi && ((gi = !gi) ? ui.lineStart() : ui.lineEnd()), gi && ui.point(+pt(fi, si, oi), +yt(fi, si, oi));
    if (mi) return ui = null, mi + "" || null;
  }
  return li.x = function(oi) {
    return arguments.length ? (pt = typeof oi == "function" ? oi : constant$1(+oi), li) : pt;
  }, li.y = function(oi) {
    return arguments.length ? (yt = typeof oi == "function" ? oi : constant$1(+oi), li) : yt;
  }, li.defined = function(oi) {
    return arguments.length ? (ir = typeof oi == "function" ? oi : constant$1(!!oi), li) : ir;
  }, li.curve = function(oi) {
    return arguments.length ? (ii = oi, ti != null && (ui = ii(ti)), li) : ii;
  }, li.context = function(oi) {
    return arguments.length ? (oi == null ? ti = ui = null : ui = ii(ti = oi), li) : ti;
  }, li;
}
function shapeArea(pt, yt, ir) {
  var ti = null, ii = constant$1(!0), ui = null, ai = curveLinear, li = null, oi = withPath(si);
  pt = typeof pt == "function" ? pt : pt === void 0 ? x$4 : constant$1(+pt), yt = typeof yt == "function" ? yt : constant$1(yt === void 0 ? 0 : +yt), ir = typeof ir == "function" ? ir : ir === void 0 ? y$3 : constant$1(+ir);
  function si(fi) {
    var gi, mi, Ti, vi = (fi = array(fi)).length, xi, Si = !1, Pi, $i = new Array(vi), Oi = new Array(vi);
    for (ui == null && (li = ai(Pi = oi())), gi = 0; gi <= vi; ++gi) {
      if (!(gi < vi && ii(xi = fi[gi], gi, fi)) === Si)
        if (Si = !Si)
          mi = gi, li.areaStart(), li.lineStart();
        else {
          for (li.lineEnd(), li.lineStart(), Ti = gi - 1; Ti >= mi; --Ti)
            li.point($i[Ti], Oi[Ti]);
          li.lineEnd(), li.areaEnd();
        }
      Si && ($i[gi] = +pt(xi, gi, fi), Oi[gi] = +yt(xi, gi, fi), li.point(ti ? +ti(xi, gi, fi) : $i[gi], ir ? +ir(xi, gi, fi) : Oi[gi]));
    }
    if (Pi) return li = null, Pi + "" || null;
  }
  function di() {
    return shapeLine().defined(ii).curve(ai).context(ui);
  }
  return si.x = function(fi) {
    return arguments.length ? (pt = typeof fi == "function" ? fi : constant$1(+fi), ti = null, si) : pt;
  }, si.x0 = function(fi) {
    return arguments.length ? (pt = typeof fi == "function" ? fi : constant$1(+fi), si) : pt;
  }, si.x1 = function(fi) {
    return arguments.length ? (ti = fi == null ? null : typeof fi == "function" ? fi : constant$1(+fi), si) : ti;
  }, si.y = function(fi) {
    return arguments.length ? (yt = typeof fi == "function" ? fi : constant$1(+fi), ir = null, si) : yt;
  }, si.y0 = function(fi) {
    return arguments.length ? (yt = typeof fi == "function" ? fi : constant$1(+fi), si) : yt;
  }, si.y1 = function(fi) {
    return arguments.length ? (ir = fi == null ? null : typeof fi == "function" ? fi : constant$1(+fi), si) : ir;
  }, si.lineX0 = si.lineY0 = function() {
    return di().x(pt).y(yt);
  }, si.lineY1 = function() {
    return di().x(pt).y(ir);
  }, si.lineX1 = function() {
    return di().x(ti).y(yt);
  }, si.defined = function(fi) {
    return arguments.length ? (ii = typeof fi == "function" ? fi : constant$1(!!fi), si) : ii;
  }, si.curve = function(fi) {
    return arguments.length ? (ai = fi, ui != null && (li = ai(ui)), si) : ai;
  }, si.context = function(fi) {
    return arguments.length ? (fi == null ? ui = li = null : li = ai(ui = fi), si) : ui;
  }, si;
}
class Bump {
  constructor(yt, ir) {
    this._context = yt, this._x = ir;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  }
  point(yt, ir) {
    switch (yt = +yt, ir = +ir, this._point) {
      case 0: {
        this._point = 1, this._line ? this._context.lineTo(yt, ir) : this._context.moveTo(yt, ir);
        break;
      }
      case 1:
        this._point = 2;
      // falls through
      default: {
        this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + yt) / 2, this._y0, this._x0, ir, yt, ir) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + ir) / 2, yt, this._y0, yt, ir);
        break;
      }
    }
    this._x0 = yt, this._y0 = ir;
  }
}
function bumpX(pt) {
  return new Bump(pt, !0);
}
function bumpY(pt) {
  return new Bump(pt, !1);
}
const symbolCircle = {
  draw(pt, yt) {
    const ir = sqrt$1(yt / pi$1);
    pt.moveTo(ir, 0), pt.arc(0, 0, ir, 0, tau$1);
  }
}, symbolCross = {
  draw(pt, yt) {
    const ir = sqrt$1(yt / 5) / 2;
    pt.moveTo(-3 * ir, -ir), pt.lineTo(-ir, -ir), pt.lineTo(-ir, -3 * ir), pt.lineTo(ir, -3 * ir), pt.lineTo(ir, -ir), pt.lineTo(3 * ir, -ir), pt.lineTo(3 * ir, ir), pt.lineTo(ir, ir), pt.lineTo(ir, 3 * ir), pt.lineTo(-ir, 3 * ir), pt.lineTo(-ir, ir), pt.lineTo(-3 * ir, ir), pt.closePath();
  }
}, tan30 = sqrt$1(1 / 3), tan30_2 = tan30 * 2, symbolDiamond = {
  draw(pt, yt) {
    const ir = sqrt$1(yt / tan30_2), ti = ir * tan30;
    pt.moveTo(0, -ir), pt.lineTo(ti, 0), pt.lineTo(0, ir), pt.lineTo(-ti, 0), pt.closePath();
  }
}, symbolSquare = {
  draw(pt, yt) {
    const ir = sqrt$1(yt), ti = -ir / 2;
    pt.rect(ti, ti, ir, ir);
  }
}, ka = 0.8908130915292852, kr$2 = sin(pi$1 / 10) / sin(7 * pi$1 / 10), kx = sin(tau$1 / 10) * kr$2, ky = -cos(tau$1 / 10) * kr$2, symbolStar = {
  draw(pt, yt) {
    const ir = sqrt$1(yt * ka), ti = kx * ir, ii = ky * ir;
    pt.moveTo(0, -ir), pt.lineTo(ti, ii);
    for (let ui = 1; ui < 5; ++ui) {
      const ai = tau$1 * ui / 5, li = cos(ai), oi = sin(ai);
      pt.lineTo(oi * ir, -li * ir), pt.lineTo(li * ti - oi * ii, oi * ti + li * ii);
    }
    pt.closePath();
  }
}, sqrt3 = sqrt$1(3), symbolTriangle = {
  draw(pt, yt) {
    const ir = -sqrt$1(yt / (sqrt3 * 3));
    pt.moveTo(0, ir * 2), pt.lineTo(-sqrt3 * ir, -ir), pt.lineTo(sqrt3 * ir, -ir), pt.closePath();
  }
}, c$2 = -0.5, s$4 = sqrt$1(3) / 2, k$4 = 1 / sqrt$1(12), a$3 = (k$4 / 2 + 1) * 3, symbolWye = {
  draw(pt, yt) {
    const ir = sqrt$1(yt / a$3), ti = ir / 2, ii = ir * k$4, ui = ti, ai = ir * k$4 + ir, li = -ui, oi = ai;
    pt.moveTo(ti, ii), pt.lineTo(ui, ai), pt.lineTo(li, oi), pt.lineTo(c$2 * ti - s$4 * ii, s$4 * ti + c$2 * ii), pt.lineTo(c$2 * ui - s$4 * ai, s$4 * ui + c$2 * ai), pt.lineTo(c$2 * li - s$4 * oi, s$4 * li + c$2 * oi), pt.lineTo(c$2 * ti + s$4 * ii, c$2 * ii - s$4 * ti), pt.lineTo(c$2 * ui + s$4 * ai, c$2 * ai - s$4 * ui), pt.lineTo(c$2 * li + s$4 * oi, c$2 * oi - s$4 * li), pt.closePath();
  }
};
function Symbol$1(pt, yt) {
  let ir = null, ti = withPath(ii);
  pt = typeof pt == "function" ? pt : constant$1(pt || symbolCircle), yt = typeof yt == "function" ? yt : constant$1(yt === void 0 ? 64 : +yt);
  function ii() {
    let ui;
    if (ir || (ir = ui = ti()), pt.apply(this, arguments).draw(ir, +yt.apply(this, arguments)), ui) return ir = null, ui + "" || null;
  }
  return ii.type = function(ui) {
    return arguments.length ? (pt = typeof ui == "function" ? ui : constant$1(ui), ii) : pt;
  }, ii.size = function(ui) {
    return arguments.length ? (yt = typeof ui == "function" ? ui : constant$1(+ui), ii) : yt;
  }, ii.context = function(ui) {
    return arguments.length ? (ir = ui ?? null, ii) : ir;
  }, ii;
}
function noop$3() {
}
function point$2(pt, yt, ir) {
  pt._context.bezierCurveTo(
    (2 * pt._x0 + pt._x1) / 3,
    (2 * pt._y0 + pt._y1) / 3,
    (pt._x0 + 2 * pt._x1) / 3,
    (pt._y0 + 2 * pt._y1) / 3,
    (pt._x0 + 4 * pt._x1 + yt) / 6,
    (pt._y0 + 4 * pt._y1 + ir) / 6
  );
}
function Basis(pt) {
  this._context = pt;
}
Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        point$2(this, this._x1, this._y1);
      // falls through
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(pt, yt) {
    switch (pt = +pt, yt = +yt, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(pt, yt) : this._context.moveTo(pt, yt);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      // falls through
      default:
        point$2(this, pt, yt);
        break;
    }
    this._x0 = this._x1, this._x1 = pt, this._y0 = this._y1, this._y1 = yt;
  }
};
function curveBasis(pt) {
  return new Basis(pt);
}
function BasisClosed(pt) {
  this._context = pt;
}
BasisClosed.prototype = {
  areaStart: noop$3,
  areaEnd: noop$3,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(pt, yt) {
    switch (pt = +pt, yt = +yt, this._point) {
      case 0:
        this._point = 1, this._x2 = pt, this._y2 = yt;
        break;
      case 1:
        this._point = 2, this._x3 = pt, this._y3 = yt;
        break;
      case 2:
        this._point = 3, this._x4 = pt, this._y4 = yt, this._context.moveTo((this._x0 + 4 * this._x1 + pt) / 6, (this._y0 + 4 * this._y1 + yt) / 6);
        break;
      default:
        point$2(this, pt, yt);
        break;
    }
    this._x0 = this._x1, this._x1 = pt, this._y0 = this._y1, this._y1 = yt;
  }
};
function curveBasisClosed(pt) {
  return new BasisClosed(pt);
}
function BasisOpen(pt) {
  this._context = pt;
}
BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(pt, yt) {
    switch (pt = +pt, yt = +yt, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var ir = (this._x0 + 4 * this._x1 + pt) / 6, ti = (this._y0 + 4 * this._y1 + yt) / 6;
        this._line ? this._context.lineTo(ir, ti) : this._context.moveTo(ir, ti);
        break;
      case 3:
        this._point = 4;
      // falls through
      default:
        point$2(this, pt, yt);
        break;
    }
    this._x0 = this._x1, this._x1 = pt, this._y0 = this._y1, this._y1 = yt;
  }
};
function curveBasisOpen(pt) {
  return new BasisOpen(pt);
}
function LinearClosed(pt) {
  this._context = pt;
}
LinearClosed.prototype = {
  areaStart: noop$3,
  areaEnd: noop$3,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(pt, yt) {
    pt = +pt, yt = +yt, this._point ? this._context.lineTo(pt, yt) : (this._point = 1, this._context.moveTo(pt, yt));
  }
};
function curveLinearClosed(pt) {
  return new LinearClosed(pt);
}
function sign(pt) {
  return pt < 0 ? -1 : 1;
}
function slope3(pt, yt, ir) {
  var ti = pt._x1 - pt._x0, ii = yt - pt._x1, ui = (pt._y1 - pt._y0) / (ti || ii < 0 && -0), ai = (ir - pt._y1) / (ii || ti < 0 && -0), li = (ui * ii + ai * ti) / (ti + ii);
  return (sign(ui) + sign(ai)) * Math.min(Math.abs(ui), Math.abs(ai), 0.5 * Math.abs(li)) || 0;
}
function slope2(pt, yt) {
  var ir = pt._x1 - pt._x0;
  return ir ? (3 * (pt._y1 - pt._y0) / ir - yt) / 2 : yt;
}
function point$1(pt, yt, ir) {
  var ti = pt._x0, ii = pt._y0, ui = pt._x1, ai = pt._y1, li = (ui - ti) / 3;
  pt._context.bezierCurveTo(ti + li, ii + li * yt, ui - li, ai - li * ir, ui, ai);
}
function MonotoneX(pt) {
  this._context = pt;
}
MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        point$1(this, this._t0, slope2(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(pt, yt) {
    var ir = NaN;
    if (pt = +pt, yt = +yt, !(pt === this._x1 && yt === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(pt, yt) : this._context.moveTo(pt, yt);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, point$1(this, slope2(this, ir = slope3(this, pt, yt)), ir);
          break;
        default:
          point$1(this, this._t0, ir = slope3(this, pt, yt));
          break;
      }
      this._x0 = this._x1, this._x1 = pt, this._y0 = this._y1, this._y1 = yt, this._t0 = ir;
    }
  }
};
function MonotoneY(pt) {
  this._context = new ReflectContext(pt);
}
(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(pt, yt) {
  MonotoneX.prototype.point.call(this, yt, pt);
};
function ReflectContext(pt) {
  this._context = pt;
}
ReflectContext.prototype = {
  moveTo: function(pt, yt) {
    this._context.moveTo(yt, pt);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(pt, yt) {
    this._context.lineTo(yt, pt);
  },
  bezierCurveTo: function(pt, yt, ir, ti, ii, ui) {
    this._context.bezierCurveTo(yt, pt, ti, ir, ui, ii);
  }
};
function monotoneX(pt) {
  return new MonotoneX(pt);
}
function monotoneY(pt) {
  return new MonotoneY(pt);
}
function Natural(pt) {
  this._context = pt;
}
Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var pt = this._x, yt = this._y, ir = pt.length;
    if (ir)
      if (this._line ? this._context.lineTo(pt[0], yt[0]) : this._context.moveTo(pt[0], yt[0]), ir === 2)
        this._context.lineTo(pt[1], yt[1]);
      else
        for (var ti = controlPoints(pt), ii = controlPoints(yt), ui = 0, ai = 1; ai < ir; ++ui, ++ai)
          this._context.bezierCurveTo(ti[0][ui], ii[0][ui], ti[1][ui], ii[1][ui], pt[ai], yt[ai]);
    (this._line || this._line !== 0 && ir === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(pt, yt) {
    this._x.push(+pt), this._y.push(+yt);
  }
};
function controlPoints(pt) {
  var yt, ir = pt.length - 1, ti, ii = new Array(ir), ui = new Array(ir), ai = new Array(ir);
  for (ii[0] = 0, ui[0] = 2, ai[0] = pt[0] + 2 * pt[1], yt = 1; yt < ir - 1; ++yt) ii[yt] = 1, ui[yt] = 4, ai[yt] = 4 * pt[yt] + 2 * pt[yt + 1];
  for (ii[ir - 1] = 2, ui[ir - 1] = 7, ai[ir - 1] = 8 * pt[ir - 1] + pt[ir], yt = 1; yt < ir; ++yt) ti = ii[yt] / ui[yt - 1], ui[yt] -= ti, ai[yt] -= ti * ai[yt - 1];
  for (ii[ir - 1] = ai[ir - 1] / ui[ir - 1], yt = ir - 2; yt >= 0; --yt) ii[yt] = (ai[yt] - ii[yt + 1]) / ui[yt];
  for (ui[ir - 1] = (pt[ir] + ii[ir - 1]) / 2, yt = 0; yt < ir - 1; ++yt) ui[yt] = 2 * pt[yt + 1] - ii[yt + 1];
  return [ii, ui];
}
function curveNatural(pt) {
  return new Natural(pt);
}
function Step(pt, yt) {
  this._context = pt, this._t = yt;
}
Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(pt, yt) {
    switch (pt = +pt, yt = +yt, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(pt, yt) : this._context.moveTo(pt, yt);
        break;
      case 1:
        this._point = 2;
      // falls through
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, yt), this._context.lineTo(pt, yt);
        else {
          var ir = this._x * (1 - this._t) + pt * this._t;
          this._context.lineTo(ir, this._y), this._context.lineTo(ir, yt);
        }
        break;
      }
    }
    this._x = pt, this._y = yt;
  }
};
function curveStep(pt) {
  return new Step(pt, 0.5);
}
function stepBefore(pt) {
  return new Step(pt, 0);
}
function stepAfter(pt) {
  return new Step(pt, 1);
}
function stackOffsetNone(pt, yt) {
  if ((ai = pt.length) > 1)
    for (var ir = 1, ti, ii, ui = pt[yt[0]], ai, li = ui.length; ir < ai; ++ir)
      for (ii = ui, ui = pt[yt[ir]], ti = 0; ti < li; ++ti)
        ui[ti][1] += ui[ti][0] = isNaN(ii[ti][1]) ? ii[ti][0] : ii[ti][1];
}
function stackOrderNone(pt) {
  for (var yt = pt.length, ir = new Array(yt); --yt >= 0; ) ir[yt] = yt;
  return ir;
}
function stackValue(pt, yt) {
  return pt[yt];
}
function stackSeries(pt) {
  const yt = [];
  return yt.key = pt, yt;
}
function shapeStack() {
  var pt = constant$1([]), yt = stackOrderNone, ir = stackOffsetNone, ti = stackValue;
  function ii(ui) {
    var ai = Array.from(pt.apply(this, arguments), stackSeries), li, oi = ai.length, si = -1, di;
    for (const fi of ui)
      for (li = 0, ++si; li < oi; ++li)
        (ai[li][si] = [0, +ti(fi, ai[li].key, si, ui)]).data = fi;
    for (li = 0, di = array(yt(ai)); li < oi; ++li)
      ai[di[li]].index = li;
    return ir(ai, di), ai;
  }
  return ii.keys = function(ui) {
    return arguments.length ? (pt = typeof ui == "function" ? ui : constant$1(Array.from(ui)), ii) : pt;
  }, ii.value = function(ui) {
    return arguments.length ? (ti = typeof ui == "function" ? ui : constant$1(+ui), ii) : ti;
  }, ii.order = function(ui) {
    return arguments.length ? (yt = ui == null ? stackOrderNone : typeof ui == "function" ? ui : constant$1(Array.from(ui)), ii) : yt;
  }, ii.offset = function(ui) {
    return arguments.length ? (ir = ui ?? stackOffsetNone, ii) : ir;
  }, ii;
}
function stackOffsetExpand(pt, yt) {
  if ((ti = pt.length) > 0) {
    for (var ir, ti, ii = 0, ui = pt[0].length, ai; ii < ui; ++ii) {
      for (ai = ir = 0; ir < ti; ++ir) ai += pt[ir][ii][1] || 0;
      if (ai) for (ir = 0; ir < ti; ++ir) pt[ir][ii][1] /= ai;
    }
    stackOffsetNone(pt, yt);
  }
}
function stackOffsetSilhouette(pt, yt) {
  if ((ii = pt.length) > 0) {
    for (var ir = 0, ti = pt[yt[0]], ii, ui = ti.length; ir < ui; ++ir) {
      for (var ai = 0, li = 0; ai < ii; ++ai) li += pt[ai][ir][1] || 0;
      ti[ir][1] += ti[ir][0] = -li / 2;
    }
    stackOffsetNone(pt, yt);
  }
}
function stackOffsetWiggle(pt, yt) {
  if (!(!((ai = pt.length) > 0) || !((ui = (ii = pt[yt[0]]).length) > 0))) {
    for (var ir = 0, ti = 1, ii, ui, ai; ti < ui; ++ti) {
      for (var li = 0, oi = 0, si = 0; li < ai; ++li) {
        for (var di = pt[yt[li]], fi = di[ti][1] || 0, gi = di[ti - 1][1] || 0, mi = (fi - gi) / 2, Ti = 0; Ti < li; ++Ti) {
          var vi = pt[yt[Ti]], xi = vi[ti][1] || 0, Si = vi[ti - 1][1] || 0;
          mi += xi - Si;
        }
        oi += fi, si += mi * fi;
      }
      ii[ti - 1][1] += ii[ti - 1][0] = ir, oi && (ir -= si / oi);
    }
    ii[ti - 1][1] += ii[ti - 1][0] = ir, stackOffsetNone(pt, yt);
  }
}
var get$3 = {}, isUnsafeProperty = {}, hasRequiredIsUnsafeProperty;
function requireIsUnsafeProperty() {
  return hasRequiredIsUnsafeProperty || (hasRequiredIsUnsafeProperty = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    function yt(ir) {
      return ir === "__proto__";
    }
    pt.isUnsafeProperty = yt;
  })(isUnsafeProperty)), isUnsafeProperty;
}
var isDeepKey = {}, hasRequiredIsDeepKey;
function requireIsDeepKey() {
  return hasRequiredIsDeepKey || (hasRequiredIsDeepKey = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    function yt(ir) {
      switch (typeof ir) {
        case "number":
        case "symbol":
          return !1;
        case "string":
          return ir.includes(".") || ir.includes("[") || ir.includes("]");
      }
    }
    pt.isDeepKey = yt;
  })(isDeepKey)), isDeepKey;
}
var toKey = {}, hasRequiredToKey;
function requireToKey() {
  return hasRequiredToKey || (hasRequiredToKey = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    function yt(ir) {
      var ti;
      return typeof ir == "string" || typeof ir == "symbol" ? ir : Object.is((ti = ir == null ? void 0 : ir.valueOf) == null ? void 0 : ti.call(ir), -0) ? "-0" : String(ir);
    }
    pt.toKey = yt;
  })(toKey)), toKey;
}
var toPath = {}, toString$1 = {}, hasRequiredToString;
function requireToString() {
  return hasRequiredToString || (hasRequiredToString = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    function yt(ir) {
      if (ir == null)
        return "";
      if (typeof ir == "string")
        return ir;
      if (Array.isArray(ir))
        return ir.map(yt).join(",");
      const ti = String(ir);
      return ti === "0" && Object.is(Number(ir), -0) ? "-0" : ti;
    }
    pt.toString = yt;
  })(toString$1)), toString$1;
}
var hasRequiredToPath;
function requireToPath() {
  return hasRequiredToPath || (hasRequiredToPath = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    const yt = /* @__PURE__ */ requireToString(), ir = /* @__PURE__ */ requireToKey();
    function ti(ii) {
      if (Array.isArray(ii))
        return ii.map(ir.toKey);
      if (typeof ii == "symbol")
        return [ii];
      ii = yt.toString(ii);
      const ui = [], ai = ii.length;
      if (ai === 0)
        return ui;
      let li = 0, oi = "", si = "", di = !1;
      for (ii.charCodeAt(0) === 46 && (ui.push(""), li++); li < ai; ) {
        const fi = ii[li];
        si ? fi === "\\" && li + 1 < ai ? (li++, oi += ii[li]) : fi === si ? si = "" : oi += fi : di ? fi === '"' || fi === "'" ? si = fi : fi === "]" ? (di = !1, ui.push(oi), oi = "") : oi += fi : fi === "[" ? (di = !0, oi && (ui.push(oi), oi = "")) : fi === "." ? oi && (ui.push(oi), oi = "") : oi += fi, li++;
      }
      return oi && ui.push(oi), ui;
    }
    pt.toPath = ti;
  })(toPath)), toPath;
}
var hasRequiredGet$1;
function requireGet$1() {
  return hasRequiredGet$1 || (hasRequiredGet$1 = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    const yt = /* @__PURE__ */ requireIsUnsafeProperty(), ir = /* @__PURE__ */ requireIsDeepKey(), ti = /* @__PURE__ */ requireToKey(), ii = /* @__PURE__ */ requireToPath();
    function ui(li, oi, si) {
      if (li == null)
        return si;
      switch (typeof oi) {
        case "string": {
          if (yt.isUnsafeProperty(oi))
            return si;
          const di = li[oi];
          return di === void 0 ? ir.isDeepKey(oi) ? ui(li, ii.toPath(oi), si) : si : di;
        }
        case "number":
        case "symbol": {
          typeof oi == "number" && (oi = ti.toKey(oi));
          const di = li[oi];
          return di === void 0 ? si : di;
        }
        default: {
          if (Array.isArray(oi))
            return ai(li, oi, si);
          if (Object.is(oi == null ? void 0 : oi.valueOf(), -0) ? oi = "-0" : oi = String(oi), yt.isUnsafeProperty(oi))
            return si;
          const di = li[oi];
          return di === void 0 ? si : di;
        }
      }
    }
    function ai(li, oi, si) {
      if (oi.length === 0)
        return si;
      let di = li;
      for (let fi = 0; fi < oi.length; fi++) {
        if (di == null || yt.isUnsafeProperty(oi[fi]))
          return si;
        di = di[oi[fi]];
      }
      return di === void 0 ? si : di;
    }
    pt.get = ui;
  })(get$3)), get$3;
}
var get$2, hasRequiredGet;
function requireGet() {
  return hasRequiredGet || (hasRequiredGet = 1, get$2 = requireGet$1().get), get$2;
}
var getExports = /* @__PURE__ */ requireGet();
const get$1 = /* @__PURE__ */ getDefaultExportFromCjs(getExports);
var defaultRoundPrecision = 4;
function round$1(pt) {
  var yt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultRoundPrecision, ir = 10 ** yt, ti = Math.round(pt * ir) / ir;
  return Object.is(ti, -0) ? 0 : ti;
}
function roundTemplateLiteral(pt) {
  for (var yt = arguments.length, ir = new Array(yt > 1 ? yt - 1 : 0), ti = 1; ti < yt; ti++)
    ir[ti - 1] = arguments[ti];
  return pt.reduce((ii, ui, ai) => {
    var li = ir[ai - 1];
    return typeof li == "string" ? ii + li + ui : li !== void 0 ? ii + round$1(li) + ui : ii + ui;
  }, "");
}
var mathSign = (pt) => pt === 0 ? 0 : pt > 0 ? 1 : -1, isNan = (pt) => typeof pt == "number" && pt != +pt, isPercent = (pt) => typeof pt == "string" && pt.indexOf("%") === pt.length - 1, isNumber = (pt) => (typeof pt == "number" || pt instanceof Number) && !isNan(pt), isNumOrStr = (pt) => isNumber(pt) || typeof pt == "string", idCounter = 0, uniqueId = (pt) => {
  var yt = ++idCounter;
  return "".concat(pt || "").concat(yt);
}, getPercentValue = function(pt, yt) {
  var ir = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, ti = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (!isNumber(pt) && typeof pt != "string")
    return ir;
  var ii;
  if (isPercent(pt)) {
    if (yt == null)
      return ir;
    var ui = pt.indexOf("%");
    ii = yt * parseFloat(pt.slice(0, ui)) / 100;
  } else
    ii = +pt;
  return isNan(ii) && (ii = ir), ti && yt != null && ii > yt && (ii = yt), ii;
}, hasDuplicate = (pt) => {
  if (!Array.isArray(pt))
    return !1;
  for (var yt = pt.length, ir = {}, ti = 0; ti < yt; ti++)
    if (!ir[String(pt[ti])])
      ir[String(pt[ti])] = !0;
    else
      return !0;
  return !1;
};
function interpolate$1(pt, yt, ir) {
  return isNumber(pt) && isNumber(yt) ? round$1(pt + ir * (yt - pt)) : yt;
}
function findEntryInArray(pt, yt, ir) {
  if (!(!pt || !pt.length))
    return pt.find((ti) => ti && (typeof yt == "function" ? yt(ti) : get$1(ti, yt)) === ir);
}
var isNullish = (pt) => pt === null || typeof pt > "u", upperFirst = (pt) => isNullish(pt) ? pt : "".concat(pt.charAt(0).toUpperCase()).concat(pt.slice(1));
function isNotNil(pt) {
  return pt != null;
}
function noop$2() {
}
var _excluded$i = ["type", "size", "sizeType"];
function _extends$n() {
  return _extends$n = Object.assign ? Object.assign.bind() : function(pt) {
    for (var yt = 1; yt < arguments.length; yt++) {
      var ir = arguments[yt];
      for (var ti in ir) ({}).hasOwnProperty.call(ir, ti) && (pt[ti] = ir[ti]);
    }
    return pt;
  }, _extends$n.apply(null, arguments);
}
function ownKeys$D(pt, yt) {
  var ir = Object.keys(pt);
  if (Object.getOwnPropertySymbols) {
    var ti = Object.getOwnPropertySymbols(pt);
    yt && (ti = ti.filter(function(ii) {
      return Object.getOwnPropertyDescriptor(pt, ii).enumerable;
    })), ir.push.apply(ir, ti);
  }
  return ir;
}
function _objectSpread$D(pt) {
  for (var yt = 1; yt < arguments.length; yt++) {
    var ir = arguments[yt] != null ? arguments[yt] : {};
    yt % 2 ? ownKeys$D(Object(ir), !0).forEach(function(ti) {
      _defineProperty$F(pt, ti, ir[ti]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(pt, Object.getOwnPropertyDescriptors(ir)) : ownKeys$D(Object(ir)).forEach(function(ti) {
      Object.defineProperty(pt, ti, Object.getOwnPropertyDescriptor(ir, ti));
    });
  }
  return pt;
}
function _defineProperty$F(pt, yt, ir) {
  return (yt = _toPropertyKey$F(yt)) in pt ? Object.defineProperty(pt, yt, { value: ir, enumerable: !0, configurable: !0, writable: !0 }) : pt[yt] = ir, pt;
}
function _toPropertyKey$F(pt) {
  var yt = _toPrimitive$F(pt, "string");
  return typeof yt == "symbol" ? yt : yt + "";
}
function _toPrimitive$F(pt, yt) {
  if (typeof pt != "object" || !pt) return pt;
  var ir = pt[Symbol.toPrimitive];
  if (ir !== void 0) {
    var ti = ir.call(pt, yt);
    if (typeof ti != "object") return ti;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (yt === "string" ? String : Number)(pt);
}
function _objectWithoutProperties$i(pt, yt) {
  if (pt == null) return {};
  var ir, ti, ii = _objectWithoutPropertiesLoose$i(pt, yt);
  if (Object.getOwnPropertySymbols) {
    var ui = Object.getOwnPropertySymbols(pt);
    for (ti = 0; ti < ui.length; ti++) ir = ui[ti], yt.indexOf(ir) === -1 && {}.propertyIsEnumerable.call(pt, ir) && (ii[ir] = pt[ir]);
  }
  return ii;
}
function _objectWithoutPropertiesLoose$i(pt, yt) {
  if (pt == null) return {};
  var ir = {};
  for (var ti in pt) if ({}.hasOwnProperty.call(pt, ti)) {
    if (yt.indexOf(ti) !== -1) continue;
    ir[ti] = pt[ti];
  }
  return ir;
}
var symbolFactories = {
  symbolCircle,
  symbolCross,
  symbolDiamond,
  symbolSquare,
  symbolStar,
  symbolTriangle,
  symbolWye
}, RADIAN$1 = Math.PI / 180, getSymbolFactory = (pt) => {
  var yt = "symbol".concat(upperFirst(pt));
  return symbolFactories[yt] || symbolCircle;
}, calculateAreaSize = (pt, yt, ir) => {
  if (yt === "area")
    return pt;
  switch (ir) {
    case "cross":
      return 5 * pt * pt / 9;
    case "diamond":
      return 0.5 * pt * pt / Math.sqrt(3);
    case "square":
      return pt * pt;
    case "star": {
      var ti = 18 * RADIAN$1;
      return 1.25 * pt * pt * (Math.tan(ti) - Math.tan(ti * 2) * Math.tan(ti) ** 2);
    }
    case "triangle":
      return Math.sqrt(3) * pt * pt / 4;
    case "wye":
      return (21 - 10 * Math.sqrt(3)) * pt * pt / 8;
    default:
      return Math.PI * pt * pt / 4;
  }
}, registerSymbol = (pt, yt) => {
  symbolFactories["symbol".concat(upperFirst(pt))] = yt;
}, Symbols = (pt) => {
  var {
    type: yt = "circle",
    size: ir = 64,
    sizeType: ti = "area"
  } = pt, ii = _objectWithoutProperties$i(pt, _excluded$i), ui = _objectSpread$D(_objectSpread$D({}, ii), {}, {
    type: yt,
    size: ir,
    sizeType: ti
  }), ai = "circle";
  typeof yt == "string" && (ai = yt);
  var li = () => {
    var gi = getSymbolFactory(ai), mi = Symbol$1().type(gi).size(calculateAreaSize(ir, ti, ai)), Ti = mi();
    if (Ti !== null)
      return Ti;
  }, {
    className: oi,
    cx: si,
    cy: di
  } = ui, fi = svgPropertiesAndEvents(ui);
  return isNumber(si) && isNumber(di) && isNumber(ir) ? /* @__PURE__ */ React.createElement("path", _extends$n({}, fi, {
    className: clsx$1("recharts-symbols", oi),
    transform: "translate(".concat(si, ", ").concat(di, ")"),
    d: li()
  })) : null;
};
Symbols.registerSymbol = registerSymbol;
var adaptEventHandlers = (pt, yt) => {
  if (!pt || typeof pt == "function" || typeof pt == "boolean")
    return null;
  var ir = pt;
  if (/* @__PURE__ */ isValidElement(pt) && (ir = pt.props), typeof ir != "object" && typeof ir != "function")
    return null;
  var ti = {};
  return Object.keys(ir).forEach((ii) => {
    isEventKey(ii) && typeof ir[ii] == "function" && (ti[ii] = (ui) => ir[ii](ir, ui));
  }), ti;
}, getEventHandlerOfChild = (pt, yt, ir) => (ti) => (pt(yt, ir, ti), null), adaptEventsOfChild = (pt, yt, ir) => {
  if (pt === null || typeof pt != "object" && typeof pt != "function")
    return null;
  var ti = null;
  return Object.keys(pt).forEach((ii) => {
    var ui = pt[ii];
    isEventKey(ii) && typeof ui == "function" && (ti || (ti = {}), ti[ii] = getEventHandlerOfChild(ui, yt, ir));
  }), ti;
};
function ownKeys$C(pt, yt) {
  var ir = Object.keys(pt);
  if (Object.getOwnPropertySymbols) {
    var ti = Object.getOwnPropertySymbols(pt);
    yt && (ti = ti.filter(function(ii) {
      return Object.getOwnPropertyDescriptor(pt, ii).enumerable;
    })), ir.push.apply(ir, ti);
  }
  return ir;
}
function _objectSpread$C(pt) {
  for (var yt = 1; yt < arguments.length; yt++) {
    var ir = arguments[yt] != null ? arguments[yt] : {};
    yt % 2 ? ownKeys$C(Object(ir), !0).forEach(function(ti) {
      _defineProperty$E(pt, ti, ir[ti]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(pt, Object.getOwnPropertyDescriptors(ir)) : ownKeys$C(Object(ir)).forEach(function(ti) {
      Object.defineProperty(pt, ti, Object.getOwnPropertyDescriptor(ir, ti));
    });
  }
  return pt;
}
function _defineProperty$E(pt, yt, ir) {
  return (yt = _toPropertyKey$E(yt)) in pt ? Object.defineProperty(pt, yt, { value: ir, enumerable: !0, configurable: !0, writable: !0 }) : pt[yt] = ir, pt;
}
function _toPropertyKey$E(pt) {
  var yt = _toPrimitive$E(pt, "string");
  return typeof yt == "symbol" ? yt : yt + "";
}
function _toPrimitive$E(pt, yt) {
  if (typeof pt != "object" || !pt) return pt;
  var ir = pt[Symbol.toPrimitive];
  if (ir !== void 0) {
    var ti = ir.call(pt, yt);
    if (typeof ti != "object") return ti;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (yt === "string" ? String : Number)(pt);
}
function resolveDefaultProps(pt, yt) {
  var ir = _objectSpread$C({}, pt), ti = yt, ii = Object.keys(yt), ui = ii.reduce((ai, li) => (ai[li] === void 0 && ti[li] !== void 0 && (ai[li] = ti[li]), ai), ir);
  return ui;
}
function _extends$m() {
  return _extends$m = Object.assign ? Object.assign.bind() : function(pt) {
    for (var yt = 1; yt < arguments.length; yt++) {
      var ir = arguments[yt];
      for (var ti in ir) ({}).hasOwnProperty.call(ir, ti) && (pt[ti] = ir[ti]);
    }
    return pt;
  }, _extends$m.apply(null, arguments);
}
function ownKeys$B(pt, yt) {
  var ir = Object.keys(pt);
  if (Object.getOwnPropertySymbols) {
    var ti = Object.getOwnPropertySymbols(pt);
    yt && (ti = ti.filter(function(ii) {
      return Object.getOwnPropertyDescriptor(pt, ii).enumerable;
    })), ir.push.apply(ir, ti);
  }
  return ir;
}
function _objectSpread$B(pt) {
  for (var yt = 1; yt < arguments.length; yt++) {
    var ir = arguments[yt] != null ? arguments[yt] : {};
    yt % 2 ? ownKeys$B(Object(ir), !0).forEach(function(ti) {
      _defineProperty$D(pt, ti, ir[ti]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(pt, Object.getOwnPropertyDescriptors(ir)) : ownKeys$B(Object(ir)).forEach(function(ti) {
      Object.defineProperty(pt, ti, Object.getOwnPropertyDescriptor(ir, ti));
    });
  }
  return pt;
}
function _defineProperty$D(pt, yt, ir) {
  return (yt = _toPropertyKey$D(yt)) in pt ? Object.defineProperty(pt, yt, { value: ir, enumerable: !0, configurable: !0, writable: !0 }) : pt[yt] = ir, pt;
}
function _toPropertyKey$D(pt) {
  var yt = _toPrimitive$D(pt, "string");
  return typeof yt == "symbol" ? yt : yt + "";
}
function _toPrimitive$D(pt, yt) {
  if (typeof pt != "object" || !pt) return pt;
  var ir = pt[Symbol.toPrimitive];
  if (ir !== void 0) {
    var ti = ir.call(pt, yt);
    if (typeof ti != "object") return ti;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (yt === "string" ? String : Number)(pt);
}
var SIZE = 32, defaultLegendContentDefaultProps = {
  align: "center",
  iconSize: 14,
  inactiveColor: "#ccc",
  layout: "horizontal",
  verticalAlign: "middle",
  labelStyle: {}
};
function getStrokeDasharray(pt) {
  if (typeof pt == "object" && pt !== null && "strokeDasharray" in pt)
    return String(pt.strokeDasharray);
}
function Icon(pt) {
  var {
    data: yt,
    iconType: ir,
    inactiveColor: ti
  } = pt, ii = SIZE / 2, ui = SIZE / 6, ai = SIZE / 3, li = yt.inactive ? ti : yt.color, oi = ir ?? yt.type;
  if (oi === "none")
    return null;
  if (oi === "plainline")
    return /* @__PURE__ */ React.createElement("line", {
      strokeWidth: 4,
      fill: "none",
      stroke: li,
      strokeDasharray: getStrokeDasharray(yt.payload),
      x1: 0,
      y1: ii,
      x2: SIZE,
      y2: ii,
      className: "recharts-legend-icon"
    });
  if (oi === "line")
    return /* @__PURE__ */ React.createElement("path", {
      strokeWidth: 4,
      fill: "none",
      stroke: li,
      d: "M0,".concat(ii, "h").concat(ai, `
            A`).concat(ui, ",").concat(ui, ",0,1,1,").concat(2 * ai, ",").concat(ii, `
            H`).concat(SIZE, "M").concat(2 * ai, ",").concat(ii, `
            A`).concat(ui, ",").concat(ui, ",0,1,1,").concat(ai, ",").concat(ii),
      className: "recharts-legend-icon"
    });
  if (oi === "rect")
    return /* @__PURE__ */ React.createElement("path", {
      stroke: "none",
      fill: li,
      d: "M0,".concat(SIZE / 8, "h").concat(SIZE, "v").concat(SIZE * 3 / 4, "h").concat(-SIZE, "z"),
      className: "recharts-legend-icon"
    });
  if (/* @__PURE__ */ React.isValidElement(yt.legendIcon)) {
    var si = _objectSpread$B({}, yt);
    return delete si.legendIcon, /* @__PURE__ */ React.cloneElement(yt.legendIcon, si);
  }
  return /* @__PURE__ */ React.createElement(Symbols, {
    fill: li,
    cx: ii,
    cy: ii,
    size: SIZE,
    sizeType: "diameter",
    type: oi
  });
}
function Items(pt) {
  var {
    payload: yt,
    iconSize: ir,
    layout: ti,
    formatter: ii,
    inactiveColor: ui,
    iconType: ai,
    labelStyle: li
  } = pt, oi = {
    x: 0,
    y: 0,
    width: SIZE,
    height: SIZE
  }, si = {
    display: ti === "horizontal" ? "inline-block" : "block",
    marginRight: 10
  }, di = {
    display: "inline-block",
    verticalAlign: "middle",
    marginRight: 4
  };
  return yt.map((fi, gi) => {
    var mi = fi.formatter || ii, Ti = clsx$1({
      "recharts-legend-item": !0,
      ["legend-item-".concat(gi)]: !0,
      inactive: fi.inactive
    });
    if (fi.type === "none")
      return null;
    var vi = typeof li == "object" ? _objectSpread$B({}, li) : {};
    vi.color = fi.inactive ? ui : vi.color || fi.color;
    var xi = mi ? mi(fi.value, fi, gi) : fi.value;
    return /* @__PURE__ */ React.createElement("li", _extends$m({
      className: Ti,
      style: si,
      key: "legend-item-".concat(gi)
    }, adaptEventsOfChild(pt, fi, gi)), /* @__PURE__ */ React.createElement(Surface, {
      width: ir,
      height: ir,
      viewBox: oi,
      style: di,
      "aria-label": "".concat(fi.value, " legend icon")
    }, /* @__PURE__ */ React.createElement(Icon, {
      data: fi,
      iconType: ai,
      inactiveColor: ui
    })), /* @__PURE__ */ React.createElement("span", {
      className: "recharts-legend-item-text",
      style: vi
    }, xi));
  });
}
var DefaultLegendContent = (pt) => {
  var yt = resolveDefaultProps(pt, defaultLegendContentDefaultProps), {
    payload: ir,
    layout: ti,
    align: ii
  } = yt;
  if (!ir || !ir.length)
    return null;
  var ui = {
    padding: 0,
    margin: 0,
    textAlign: ti === "horizontal" ? ii : "left"
  };
  return /* @__PURE__ */ React.createElement("ul", {
    className: "recharts-default-legend",
    style: ui
  }, /* @__PURE__ */ React.createElement(Items, _extends$m({}, yt, {
    payload: ir
  })));
}, uniqBy$3 = {}, uniqBy$2 = {}, hasRequiredUniqBy$2;
function requireUniqBy$2() {
  return hasRequiredUniqBy$2 || (hasRequiredUniqBy$2 = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    function yt(ir, ti) {
      const ii = /* @__PURE__ */ new Map();
      for (let ui = 0; ui < ir.length; ui++) {
        const ai = ir[ui], li = ti(ai, ui, ir);
        ii.has(li) || ii.set(li, ai);
      }
      return Array.from(ii.values());
    }
    pt.uniqBy = yt;
  })(uniqBy$2)), uniqBy$2;
}
var ary = {}, hasRequiredAry;
function requireAry() {
  return hasRequiredAry || (hasRequiredAry = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    function yt(ir, ti) {
      return function(...ii) {
        return ir.apply(this, ii.slice(0, ti));
      };
    }
    pt.ary = yt;
  })(ary)), ary;
}
var identity$3 = {}, hasRequiredIdentity;
function requireIdentity() {
  return hasRequiredIdentity || (hasRequiredIdentity = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    function yt(ir) {
      return ir;
    }
    pt.identity = yt;
  })(identity$3)), identity$3;
}
var isArrayLikeObject = {}, isArrayLike = {}, isLength = {}, hasRequiredIsLength;
function requireIsLength() {
  return hasRequiredIsLength || (hasRequiredIsLength = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    function yt(ir) {
      return Number.isSafeInteger(ir) && ir >= 0;
    }
    pt.isLength = yt;
  })(isLength)), isLength;
}
var hasRequiredIsArrayLike;
function requireIsArrayLike() {
  return hasRequiredIsArrayLike || (hasRequiredIsArrayLike = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    const yt = /* @__PURE__ */ requireIsLength();
    function ir(ti) {
      return ti != null && typeof ti != "function" && yt.isLength(ti.length);
    }
    pt.isArrayLike = ir;
  })(isArrayLike)), isArrayLike;
}
var isObjectLike = {}, hasRequiredIsObjectLike;
function requireIsObjectLike() {
  return hasRequiredIsObjectLike || (hasRequiredIsObjectLike = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    function yt(ir) {
      return typeof ir == "object" && ir !== null;
    }
    pt.isObjectLike = yt;
  })(isObjectLike)), isObjectLike;
}
var hasRequiredIsArrayLikeObject;
function requireIsArrayLikeObject() {
  return hasRequiredIsArrayLikeObject || (hasRequiredIsArrayLikeObject = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    const yt = /* @__PURE__ */ requireIsArrayLike(), ir = /* @__PURE__ */ requireIsObjectLike();
    function ti(ii) {
      return ir.isObjectLike(ii) && yt.isArrayLike(ii);
    }
    pt.isArrayLikeObject = ti;
  })(isArrayLikeObject)), isArrayLikeObject;
}
var iteratee = {}, property = {}, hasRequiredProperty;
function requireProperty() {
  return hasRequiredProperty || (hasRequiredProperty = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    const yt = /* @__PURE__ */ requireGet$1();
    function ir(ti) {
      return function(ii) {
        return yt.get(ii, ti);
      };
    }
    pt.property = ir;
  })(property)), property;
}
var matches = {}, isMatch = {}, isMatchWith = {}, isObject = {}, hasRequiredIsObject;
function requireIsObject() {
  return hasRequiredIsObject || (hasRequiredIsObject = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    function yt(ir) {
      return ir !== null && (typeof ir == "object" || typeof ir == "function");
    }
    pt.isObject = yt;
  })(isObject)), isObject;
}
var isPrimitive = {}, hasRequiredIsPrimitive;
function requireIsPrimitive() {
  return hasRequiredIsPrimitive || (hasRequiredIsPrimitive = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    function yt(ir) {
      return ir == null || typeof ir != "object" && typeof ir != "function";
    }
    pt.isPrimitive = yt;
  })(isPrimitive)), isPrimitive;
}
var isEqualsSameValueZero = {}, hasRequiredIsEqualsSameValueZero;
function requireIsEqualsSameValueZero() {
  return hasRequiredIsEqualsSameValueZero || (hasRequiredIsEqualsSameValueZero = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    function yt(ir, ti) {
      return ir === ti || Number.isNaN(ir) && Number.isNaN(ti);
    }
    pt.isEqualsSameValueZero = yt;
  })(isEqualsSameValueZero)), isEqualsSameValueZero;
}
var hasRequiredIsMatchWith;
function requireIsMatchWith() {
  return hasRequiredIsMatchWith || (hasRequiredIsMatchWith = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    const yt = /* @__PURE__ */ requireIsObject(), ir = /* @__PURE__ */ requireIsPrimitive(), ti = /* @__PURE__ */ requireIsEqualsSameValueZero();
    function ii(di, fi, gi) {
      return typeof gi != "function" ? ii(di, fi, () => {
      }) : ui(di, fi, function mi(Ti, vi, xi, Si, Pi, $i) {
        const Oi = gi(Ti, vi, xi, Si, Pi, $i);
        return Oi !== void 0 ? !!Oi : ui(Ti, vi, mi, $i);
      }, /* @__PURE__ */ new Map());
    }
    function ui(di, fi, gi, mi) {
      if (fi === di)
        return !0;
      switch (typeof fi) {
        case "object":
          return ai(di, fi, gi, mi);
        case "function":
          return Object.keys(fi).length > 0 ? ui(di, { ...fi }, gi, mi) : ti.isEqualsSameValueZero(di, fi);
        default:
          return yt.isObject(di) ? typeof fi == "string" ? fi === "" : !0 : ti.isEqualsSameValueZero(di, fi);
      }
    }
    function ai(di, fi, gi, mi) {
      if (fi == null)
        return !0;
      if (Array.isArray(fi))
        return oi(di, fi, gi, mi);
      if (fi instanceof Map)
        return li(di, fi, gi, mi);
      if (fi instanceof Set)
        return si(di, fi, gi, mi);
      const Ti = Object.keys(fi);
      if (di == null || ir.isPrimitive(di))
        return Ti.length === 0;
      if (Ti.length === 0)
        return !0;
      if (mi != null && mi.has(fi))
        return mi.get(fi) === di;
      mi == null || mi.set(fi, di);
      try {
        for (let vi = 0; vi < Ti.length; vi++) {
          const xi = Ti[vi];
          if (!ir.isPrimitive(di) && !(xi in di) || fi[xi] === void 0 && di[xi] !== void 0 || fi[xi] === null && di[xi] !== null || !gi(di[xi], fi[xi], xi, di, fi, mi))
            return !1;
        }
        return !0;
      } finally {
        mi == null || mi.delete(fi);
      }
    }
    function li(di, fi, gi, mi) {
      if (fi.size === 0)
        return !0;
      if (!(di instanceof Map))
        return !1;
      for (const [Ti, vi] of fi.entries()) {
        const xi = di.get(Ti);
        if (gi(xi, vi, Ti, di, fi, mi) === !1)
          return !1;
      }
      return !0;
    }
    function oi(di, fi, gi, mi) {
      if (fi.length === 0)
        return !0;
      if (!Array.isArray(di))
        return !1;
      const Ti = /* @__PURE__ */ new Set();
      for (let vi = 0; vi < fi.length; vi++) {
        const xi = fi[vi];
        let Si = !1;
        for (let Pi = 0; Pi < di.length; Pi++) {
          if (Ti.has(Pi))
            continue;
          const $i = di[Pi];
          let Oi = !1;
          if (gi($i, xi, vi, di, fi, mi) && (Oi = !0), Oi) {
            Ti.add(Pi), Si = !0;
            break;
          }
        }
        if (!Si)
          return !1;
      }
      return !0;
    }
    function si(di, fi, gi, mi) {
      return fi.size === 0 ? !0 : di instanceof Set ? oi([...di], [...fi], gi, mi) : !1;
    }
    pt.isMatchWith = ii, pt.isSetMatch = si;
  })(isMatchWith)), isMatchWith;
}
var hasRequiredIsMatch;
function requireIsMatch() {
  return hasRequiredIsMatch || (hasRequiredIsMatch = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    const yt = /* @__PURE__ */ requireIsMatchWith();
    function ir(ti, ii) {
      return yt.isMatchWith(ti, ii, () => {
      });
    }
    pt.isMatch = ir;
  })(isMatch)), isMatch;
}
var cloneDeep$1 = {}, cloneDeepWith$1 = {}, getSymbols = {}, hasRequiredGetSymbols;
function requireGetSymbols() {
  return hasRequiredGetSymbols || (hasRequiredGetSymbols = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    function yt(ir) {
      return Object.getOwnPropertySymbols(ir).filter((ti) => Object.prototype.propertyIsEnumerable.call(ir, ti));
    }
    pt.getSymbols = yt;
  })(getSymbols)), getSymbols;
}
var getTag = {}, hasRequiredGetTag;
function requireGetTag() {
  return hasRequiredGetTag || (hasRequiredGetTag = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    function yt(ir) {
      return ir == null ? ir === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(ir);
    }
    pt.getTag = yt;
  })(getTag)), getTag;
}
var tags$2 = {}, hasRequiredTags;
function requireTags() {
  return hasRequiredTags || (hasRequiredTags = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    const yt = "[object RegExp]", ir = "[object String]", ti = "[object Number]", ii = "[object Boolean]", ui = "[object Arguments]", ai = "[object Symbol]", li = "[object Date]", oi = "[object Map]", si = "[object Set]", di = "[object Array]", fi = "[object Function]", gi = "[object ArrayBuffer]", mi = "[object Object]", Ti = "[object Error]", vi = "[object DataView]", xi = "[object Uint8Array]", Si = "[object Uint8ClampedArray]", Pi = "[object Uint16Array]", $i = "[object Uint32Array]", Oi = "[object BigUint64Array]", Di = "[object Int8Array]", Mi = "[object Int16Array]", Oo = "[object Int32Array]", io = "[object BigInt64Array]", xo = "[object Float32Array]", fo = "[object Float64Array]";
    pt.argumentsTag = ui, pt.arrayBufferTag = gi, pt.arrayTag = di, pt.bigInt64ArrayTag = io, pt.bigUint64ArrayTag = Oi, pt.booleanTag = ii, pt.dataViewTag = vi, pt.dateTag = li, pt.errorTag = Ti, pt.float32ArrayTag = xo, pt.float64ArrayTag = fo, pt.functionTag = fi, pt.int16ArrayTag = Mi, pt.int32ArrayTag = Oo, pt.int8ArrayTag = Di, pt.mapTag = oi, pt.numberTag = ti, pt.objectTag = mi, pt.regexpTag = yt, pt.setTag = si, pt.stringTag = ir, pt.symbolTag = ai, pt.uint16ArrayTag = Pi, pt.uint32ArrayTag = $i, pt.uint8ArrayTag = xi, pt.uint8ClampedArrayTag = Si;
  })(tags$2)), tags$2;
}
var isTypedArray = {}, hasRequiredIsTypedArray;
function requireIsTypedArray() {
  return hasRequiredIsTypedArray || (hasRequiredIsTypedArray = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    function yt(ir) {
      return ArrayBuffer.isView(ir) && !(ir instanceof DataView);
    }
    pt.isTypedArray = yt;
  })(isTypedArray)), isTypedArray;
}
var hasRequiredCloneDeepWith$1;
function requireCloneDeepWith$1() {
  return hasRequiredCloneDeepWith$1 || (hasRequiredCloneDeepWith$1 = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    const yt = /* @__PURE__ */ requireGetSymbols(), ir = /* @__PURE__ */ requireGetTag(), ti = /* @__PURE__ */ requireTags(), ii = /* @__PURE__ */ requireIsPrimitive(), ui = /* @__PURE__ */ requireIsTypedArray();
    function ai(di, fi) {
      return li(di, void 0, di, /* @__PURE__ */ new Map(), fi);
    }
    function li(di, fi, gi, mi = /* @__PURE__ */ new Map(), Ti = void 0) {
      const vi = Ti == null ? void 0 : Ti(di, fi, gi, mi);
      if (vi !== void 0)
        return vi;
      if (ii.isPrimitive(di))
        return di;
      if (mi.has(di))
        return mi.get(di);
      if (Array.isArray(di)) {
        const xi = new Array(di.length);
        mi.set(di, xi);
        for (let Si = 0; Si < di.length; Si++)
          xi[Si] = li(di[Si], Si, gi, mi, Ti);
        return Object.hasOwn(di, "index") && (xi.index = di.index), Object.hasOwn(di, "input") && (xi.input = di.input), xi;
      }
      if (di instanceof Date)
        return new Date(di.getTime());
      if (di instanceof RegExp) {
        const xi = new RegExp(di.source, di.flags);
        return xi.lastIndex = di.lastIndex, xi;
      }
      if (di instanceof Map) {
        const xi = /* @__PURE__ */ new Map();
        mi.set(di, xi);
        for (const [Si, Pi] of di)
          xi.set(Si, li(Pi, Si, gi, mi, Ti));
        return xi;
      }
      if (di instanceof Set) {
        const xi = /* @__PURE__ */ new Set();
        mi.set(di, xi);
        for (const Si of di)
          xi.add(li(Si, void 0, gi, mi, Ti));
        return xi;
      }
      if (typeof Buffer < "u" && Buffer.isBuffer(di))
        return di.subarray();
      if (ui.isTypedArray(di)) {
        const xi = new (Object.getPrototypeOf(di)).constructor(di.length);
        mi.set(di, xi);
        for (let Si = 0; Si < di.length; Si++)
          xi[Si] = li(di[Si], Si, gi, mi, Ti);
        return xi;
      }
      if (di instanceof ArrayBuffer || typeof SharedArrayBuffer < "u" && di instanceof SharedArrayBuffer)
        return di.slice(0);
      if (di instanceof DataView) {
        const xi = new DataView(di.buffer.slice(0), di.byteOffset, di.byteLength);
        return mi.set(di, xi), oi(xi, di, gi, mi, Ti), xi;
      }
      if (typeof File < "u" && di instanceof File) {
        const xi = new File([di], di.name, {
          type: di.type
        });
        return mi.set(di, xi), oi(xi, di, gi, mi, Ti), xi;
      }
      if (typeof Blob < "u" && di instanceof Blob) {
        const xi = new Blob([di], { type: di.type });
        return mi.set(di, xi), oi(xi, di, gi, mi, Ti), xi;
      }
      if (di instanceof Error) {
        const xi = structuredClone(di);
        return mi.set(di, xi), xi.message = di.message, xi.name = di.name, xi.stack = di.stack, xi.cause = di.cause, xi.constructor = di.constructor, oi(xi, di, gi, mi, Ti), xi;
      }
      if (di instanceof Boolean) {
        const xi = new Boolean(di.valueOf());
        return mi.set(di, xi), oi(xi, di, gi, mi, Ti), xi;
      }
      if (di instanceof Number) {
        const xi = new Number(di.valueOf());
        return mi.set(di, xi), oi(xi, di, gi, mi, Ti), xi;
      }
      if (di instanceof String) {
        const xi = new String(di.valueOf());
        return mi.set(di, xi), oi(xi, di, gi, mi, Ti), xi;
      }
      if (typeof di == "object" && si(di)) {
        const xi = Object.create(Object.getPrototypeOf(di));
        return mi.set(di, xi), oi(xi, di, gi, mi, Ti), xi;
      }
      return di;
    }
    function oi(di, fi, gi = di, mi, Ti) {
      const vi = [...Object.keys(fi), ...yt.getSymbols(fi)];
      for (let xi = 0; xi < vi.length; xi++) {
        const Si = vi[xi], Pi = Object.getOwnPropertyDescriptor(di, Si);
        (Pi == null || Pi.writable) && (di[Si] = li(fi[Si], Si, gi, mi, Ti));
      }
    }
    function si(di) {
      switch (ir.getTag(di)) {
        case ti.argumentsTag:
        case ti.arrayTag:
        case ti.arrayBufferTag:
        case ti.dataViewTag:
        case ti.booleanTag:
        case ti.dateTag:
        case ti.float32ArrayTag:
        case ti.float64ArrayTag:
        case ti.int8ArrayTag:
        case ti.int16ArrayTag:
        case ti.int32ArrayTag:
        case ti.mapTag:
        case ti.numberTag:
        case ti.objectTag:
        case ti.regexpTag:
        case ti.setTag:
        case ti.stringTag:
        case ti.symbolTag:
        case ti.uint8ArrayTag:
        case ti.uint8ClampedArrayTag:
        case ti.uint16ArrayTag:
        case ti.uint32ArrayTag:
          return !0;
        default:
          return !1;
      }
    }
    pt.cloneDeepWith = ai, pt.cloneDeepWithImpl = li, pt.copyProperties = oi;
  })(cloneDeepWith$1)), cloneDeepWith$1;
}
var hasRequiredCloneDeep$1;
function requireCloneDeep$1() {
  return hasRequiredCloneDeep$1 || (hasRequiredCloneDeep$1 = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    const yt = /* @__PURE__ */ requireCloneDeepWith$1();
    function ir(ti) {
      return yt.cloneDeepWithImpl(ti, void 0, ti, /* @__PURE__ */ new Map(), void 0);
    }
    pt.cloneDeep = ir;
  })(cloneDeep$1)), cloneDeep$1;
}
var hasRequiredMatches;
function requireMatches() {
  return hasRequiredMatches || (hasRequiredMatches = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    const yt = /* @__PURE__ */ requireIsMatch(), ir = /* @__PURE__ */ requireCloneDeep$1();
    function ti(ii) {
      return ii = ir.cloneDeep(ii), (ui) => yt.isMatch(ui, ii);
    }
    pt.matches = ti;
  })(matches)), matches;
}
var matchesProperty = {}, cloneDeep = {}, cloneDeepWith = {}, hasRequiredCloneDeepWith;
function requireCloneDeepWith() {
  return hasRequiredCloneDeepWith || (hasRequiredCloneDeepWith = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    const yt = /* @__PURE__ */ requireCloneDeepWith$1(), ir = /* @__PURE__ */ requireGetTag(), ti = /* @__PURE__ */ requireTags();
    function ii(ui, ai) {
      return yt.cloneDeepWith(ui, (li, oi, si, di) => {
        const fi = ai == null ? void 0 : ai(li, oi, si, di);
        if (fi !== void 0)
          return fi;
        if (typeof ui == "object") {
          if (ir.getTag(ui) === ti.objectTag && typeof ui.constructor != "function") {
            const gi = {};
            return di.set(ui, gi), yt.copyProperties(gi, ui, si, di), gi;
          }
          switch (Object.prototype.toString.call(ui)) {
            case ti.numberTag:
            case ti.stringTag:
            case ti.booleanTag: {
              const gi = new ui.constructor(ui == null ? void 0 : ui.valueOf());
              return yt.copyProperties(gi, ui), gi;
            }
            case ti.argumentsTag: {
              const gi = {};
              return yt.copyProperties(gi, ui), gi.length = ui.length, gi[Symbol.iterator] = ui[Symbol.iterator], gi;
            }
            default:
              return;
          }
        }
      });
    }
    pt.cloneDeepWith = ii;
  })(cloneDeepWith)), cloneDeepWith;
}
var hasRequiredCloneDeep;
function requireCloneDeep() {
  return hasRequiredCloneDeep || (hasRequiredCloneDeep = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    const yt = /* @__PURE__ */ requireCloneDeepWith();
    function ir(ti) {
      return yt.cloneDeepWith(ti);
    }
    pt.cloneDeep = ir;
  })(cloneDeep)), cloneDeep;
}
var has$2 = {}, isIndex = {}, hasRequiredIsIndex;
function requireIsIndex() {
  return hasRequiredIsIndex || (hasRequiredIsIndex = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    const yt = /^(?:0|[1-9]\d*)$/;
    function ir(ti, ii = Number.MAX_SAFE_INTEGER) {
      switch (typeof ti) {
        case "number":
          return Number.isInteger(ti) && ti >= 0 && ti < ii;
        case "symbol":
          return !1;
        case "string":
          return yt.test(ti);
      }
    }
    pt.isIndex = ir;
  })(isIndex)), isIndex;
}
var isArguments = {}, hasRequiredIsArguments;
function requireIsArguments() {
  return hasRequiredIsArguments || (hasRequiredIsArguments = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    const yt = /* @__PURE__ */ requireGetTag();
    function ir(ti) {
      return ti !== null && typeof ti == "object" && yt.getTag(ti) === "[object Arguments]";
    }
    pt.isArguments = ir;
  })(isArguments)), isArguments;
}
var hasRequiredHas;
function requireHas() {
  return hasRequiredHas || (hasRequiredHas = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    const yt = /* @__PURE__ */ requireIsDeepKey(), ir = /* @__PURE__ */ requireIsIndex(), ti = /* @__PURE__ */ requireIsArguments(), ii = /* @__PURE__ */ requireToPath();
    function ui(ai, li) {
      let oi;
      if (Array.isArray(li) ? oi = li : typeof li == "string" && yt.isDeepKey(li) && (ai == null ? void 0 : ai[li]) == null ? oi = ii.toPath(li) : oi = [li], oi.length === 0)
        return !1;
      let si = ai;
      for (let di = 0; di < oi.length; di++) {
        const fi = oi[di];
        if ((si == null || !Object.hasOwn(si, fi)) && !((Array.isArray(si) || ti.isArguments(si)) && ir.isIndex(fi) && fi < si.length))
          return !1;
        si = si[fi];
      }
      return !0;
    }
    pt.has = ui;
  })(has$2)), has$2;
}
var hasRequiredMatchesProperty;
function requireMatchesProperty() {
  return hasRequiredMatchesProperty || (hasRequiredMatchesProperty = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    const yt = /* @__PURE__ */ requireIsMatch(), ir = /* @__PURE__ */ requireToKey(), ti = /* @__PURE__ */ requireCloneDeep(), ii = /* @__PURE__ */ requireGet$1(), ui = /* @__PURE__ */ requireHas();
    function ai(li, oi) {
      switch (typeof li) {
        case "object": {
          Object.is(li == null ? void 0 : li.valueOf(), -0) && (li = "-0");
          break;
        }
        case "number": {
          li = ir.toKey(li);
          break;
        }
      }
      return oi = ti.cloneDeep(oi), function(si) {
        const di = ii.get(si, li);
        return di === void 0 ? ui.has(si, li) : oi === void 0 ? di === void 0 : yt.isMatch(di, oi);
      };
    }
    pt.matchesProperty = ai;
  })(matchesProperty)), matchesProperty;
}
var hasRequiredIteratee;
function requireIteratee() {
  return hasRequiredIteratee || (hasRequiredIteratee = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    const yt = /* @__PURE__ */ requireIdentity(), ir = /* @__PURE__ */ requireProperty(), ti = /* @__PURE__ */ requireMatches(), ii = /* @__PURE__ */ requireMatchesProperty();
    function ui(ai) {
      if (ai == null)
        return yt.identity;
      switch (typeof ai) {
        case "function":
          return ai;
        case "object":
          return Array.isArray(ai) && ai.length === 2 ? ii.matchesProperty(ai[0], ai[1]) : ti.matches(ai);
        case "string":
        case "symbol":
        case "number":
          return ir.property(ai);
      }
    }
    pt.iteratee = ui;
  })(iteratee)), iteratee;
}
var hasRequiredUniqBy$1;
function requireUniqBy$1() {
  return hasRequiredUniqBy$1 || (hasRequiredUniqBy$1 = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    const yt = /* @__PURE__ */ requireUniqBy$2(), ir = /* @__PURE__ */ requireAry(), ti = /* @__PURE__ */ requireIdentity(), ii = /* @__PURE__ */ requireIsArrayLikeObject(), ui = /* @__PURE__ */ requireIteratee();
    function ai(li, oi = ti.identity) {
      return ii.isArrayLikeObject(li) ? yt.uniqBy(Array.from(li), ir.ary(ui.iteratee(oi), 1)) : [];
    }
    pt.uniqBy = ai;
  })(uniqBy$3)), uniqBy$3;
}
var uniqBy$1, hasRequiredUniqBy;
function requireUniqBy() {
  return hasRequiredUniqBy || (hasRequiredUniqBy = 1, uniqBy$1 = requireUniqBy$1().uniqBy), uniqBy$1;
}
var uniqByExports = /* @__PURE__ */ requireUniqBy();
const uniqBy = /* @__PURE__ */ getDefaultExportFromCjs(uniqByExports);
function getUniqPayload(pt, yt, ir) {
  return yt === !0 ? uniqBy(pt, ir) : typeof yt == "function" ? uniqBy(pt, yt) : pt;
}
var withSelector$1 = { exports: {} }, withSelector_production = {}, shim = { exports: {} }, useSyncExternalStoreShim_production = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredUseSyncExternalStoreShim_production;
function requireUseSyncExternalStoreShim_production() {
  if (hasRequiredUseSyncExternalStoreShim_production) return useSyncExternalStoreShim_production;
  hasRequiredUseSyncExternalStoreShim_production = 1;
  var pt = React__default;
  function yt(fi, gi) {
    return fi === gi && (fi !== 0 || 1 / fi === 1 / gi) || fi !== fi && gi !== gi;
  }
  var ir = typeof Object.is == "function" ? Object.is : yt, ti = pt.useState, ii = pt.useEffect, ui = pt.useLayoutEffect, ai = pt.useDebugValue;
  function li(fi, gi) {
    var mi = gi(), Ti = ti({ inst: { value: mi, getSnapshot: gi } }), vi = Ti[0].inst, xi = Ti[1];
    return ui(
      function() {
        vi.value = mi, vi.getSnapshot = gi, oi(vi) && xi({ inst: vi });
      },
      [fi, mi, gi]
    ), ii(
      function() {
        return oi(vi) && xi({ inst: vi }), fi(function() {
          oi(vi) && xi({ inst: vi });
        });
      },
      [fi]
    ), ai(mi), mi;
  }
  function oi(fi) {
    var gi = fi.getSnapshot;
    fi = fi.value;
    try {
      var mi = gi();
      return !ir(fi, mi);
    } catch {
      return !0;
    }
  }
  function si(fi, gi) {
    return gi();
  }
  var di = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? si : li;
  return useSyncExternalStoreShim_production.useSyncExternalStore = pt.useSyncExternalStore !== void 0 ? pt.useSyncExternalStore : di, useSyncExternalStoreShim_production;
}
var useSyncExternalStoreShim_development = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredUseSyncExternalStoreShim_development;
function requireUseSyncExternalStoreShim_development() {
  return hasRequiredUseSyncExternalStoreShim_development || (hasRequiredUseSyncExternalStoreShim_development = 1, process.env.NODE_ENV !== "production" && (function() {
    function pt(mi, Ti) {
      return mi === Ti && (mi !== 0 || 1 / mi === 1 / Ti) || mi !== mi && Ti !== Ti;
    }
    function yt(mi, Ti) {
      di || ii.startTransition === void 0 || (di = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var vi = Ti();
      if (!fi) {
        var xi = Ti();
        ui(vi, xi) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), fi = !0);
      }
      xi = ai({
        inst: { value: vi, getSnapshot: Ti }
      });
      var Si = xi[0].inst, Pi = xi[1];
      return oi(
        function() {
          Si.value = vi, Si.getSnapshot = Ti, ir(Si) && Pi({ inst: Si });
        },
        [mi, vi, Ti]
      ), li(
        function() {
          return ir(Si) && Pi({ inst: Si }), mi(function() {
            ir(Si) && Pi({ inst: Si });
          });
        },
        [mi]
      ), si(vi), vi;
    }
    function ir(mi) {
      var Ti = mi.getSnapshot;
      mi = mi.value;
      try {
        var vi = Ti();
        return !ui(mi, vi);
      } catch {
        return !0;
      }
    }
    function ti(mi, Ti) {
      return Ti();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var ii = React__default, ui = typeof Object.is == "function" ? Object.is : pt, ai = ii.useState, li = ii.useEffect, oi = ii.useLayoutEffect, si = ii.useDebugValue, di = !1, fi = !1, gi = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? ti : yt;
    useSyncExternalStoreShim_development.useSyncExternalStore = ii.useSyncExternalStore !== void 0 ? ii.useSyncExternalStore : gi, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), useSyncExternalStoreShim_development;
}
var hasRequiredShim;
function requireShim() {
  return hasRequiredShim || (hasRequiredShim = 1, process.env.NODE_ENV === "production" ? shim.exports = requireUseSyncExternalStoreShim_production() : shim.exports = requireUseSyncExternalStoreShim_development()), shim.exports;
}
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredWithSelector_production;
function requireWithSelector_production() {
  if (hasRequiredWithSelector_production) return withSelector_production;
  hasRequiredWithSelector_production = 1;
  var pt = React__default, yt = requireShim();
  function ir(si, di) {
    return si === di && (si !== 0 || 1 / si === 1 / di) || si !== si && di !== di;
  }
  var ti = typeof Object.is == "function" ? Object.is : ir, ii = yt.useSyncExternalStore, ui = pt.useRef, ai = pt.useEffect, li = pt.useMemo, oi = pt.useDebugValue;
  return withSelector_production.useSyncExternalStoreWithSelector = function(si, di, fi, gi, mi) {
    var Ti = ui(null);
    if (Ti.current === null) {
      var vi = { hasValue: !1, value: null };
      Ti.current = vi;
    } else vi = Ti.current;
    Ti = li(
      function() {
        function Si(Mi) {
          if (!Pi) {
            if (Pi = !0, $i = Mi, Mi = gi(Mi), mi !== void 0 && vi.hasValue) {
              var Oo = vi.value;
              if (mi(Oo, Mi))
                return Oi = Oo;
            }
            return Oi = Mi;
          }
          if (Oo = Oi, ti($i, Mi)) return Oo;
          var io = gi(Mi);
          return mi !== void 0 && mi(Oo, io) ? ($i = Mi, Oo) : ($i = Mi, Oi = io);
        }
        var Pi = !1, $i, Oi, Di = fi === void 0 ? null : fi;
        return [
          function() {
            return Si(di());
          },
          Di === null ? void 0 : function() {
            return Si(Di());
          }
        ];
      },
      [di, fi, gi, mi]
    );
    var xi = ii(si, Ti[0], Ti[1]);
    return ai(
      function() {
        vi.hasValue = !0, vi.value = xi;
      },
      [xi]
    ), oi(xi), xi;
  }, withSelector_production;
}
var withSelector_development = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredWithSelector_development;
function requireWithSelector_development() {
  return hasRequiredWithSelector_development || (hasRequiredWithSelector_development = 1, process.env.NODE_ENV !== "production" && (function() {
    function pt(si, di) {
      return si === di && (si !== 0 || 1 / si === 1 / di) || si !== si && di !== di;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var yt = React__default, ir = requireShim(), ti = typeof Object.is == "function" ? Object.is : pt, ii = ir.useSyncExternalStore, ui = yt.useRef, ai = yt.useEffect, li = yt.useMemo, oi = yt.useDebugValue;
    withSelector_development.useSyncExternalStoreWithSelector = function(si, di, fi, gi, mi) {
      var Ti = ui(null);
      if (Ti.current === null) {
        var vi = { hasValue: !1, value: null };
        Ti.current = vi;
      } else vi = Ti.current;
      Ti = li(
        function() {
          function Si(Mi) {
            if (!Pi) {
              if (Pi = !0, $i = Mi, Mi = gi(Mi), mi !== void 0 && vi.hasValue) {
                var Oo = vi.value;
                if (mi(Oo, Mi))
                  return Oi = Oo;
              }
              return Oi = Mi;
            }
            if (Oo = Oi, ti($i, Mi))
              return Oo;
            var io = gi(Mi);
            return mi !== void 0 && mi(Oo, io) ? ($i = Mi, Oo) : ($i = Mi, Oi = io);
          }
          var Pi = !1, $i, Oi, Di = fi === void 0 ? null : fi;
          return [
            function() {
              return Si(di());
            },
            Di === null ? void 0 : function() {
              return Si(Di());
            }
          ];
        },
        [di, fi, gi, mi]
      );
      var xi = ii(si, Ti[0], Ti[1]);
      return ai(
        function() {
          vi.hasValue = !0, vi.value = xi;
        },
        [xi]
      ), oi(xi), xi;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), withSelector_development;
}
var hasRequiredWithSelector$1;
function requireWithSelector$1() {
  return hasRequiredWithSelector$1 || (hasRequiredWithSelector$1 = 1, process.env.NODE_ENV === "production" ? withSelector$1.exports = requireWithSelector_production() : withSelector$1.exports = requireWithSelector_development()), withSelector$1.exports;
}
var withSelectorExports = requireWithSelector$1(), RechartsReduxContext = /* @__PURE__ */ createContext(null), noopDispatch = (pt) => pt, useAppDispatch = () => {
  var pt = useContext(RechartsReduxContext);
  return pt ? pt.store.dispatch : noopDispatch;
}, noop$1$1 = () => {
}, addNestedSubNoop = () => noop$1$1, refEquality = (pt, yt) => pt === yt;
function useAppSelector(pt) {
  var yt = useContext(RechartsReduxContext), ir = useMemo(() => yt ? (ti) => {
    if (ti != null)
      return pt(ti);
  } : noop$1$1, [yt, pt]);
  return withSelectorExports.useSyncExternalStoreWithSelector(yt ? yt.subscription.addNestedSub : addNestedSubNoop, yt ? yt.store.getState : noop$1$1, yt ? yt.store.getState : noop$1$1, ir, refEquality);
}
var runIdentityFunctionCheck = (pt, yt, ir) => {
  if (yt.length === 1 && yt[0] === ir) {
    let ti = !1;
    try {
      const ii = {};
      pt(ii) === ii && (ti = !0);
    } catch {
    }
    if (ti) {
      let ii;
      try {
        throw new Error();
      } catch (ui) {
        ({ stack: ii } = ui);
      }
      console.warn(
        `The result function returned its own inputs without modification. e.g
\`createSelector([state => state.todos], todos => todos)\`
This could lead to inefficient memoization and unnecessary re-renders.
Ensure transformation logic is in the result function, and extraction logic is in the input selectors.`,
        { stack: ii }
      );
    }
  }
}, runInputStabilityCheck = (pt, yt, ir) => {
  const { memoize: ti, memoizeOptions: ii } = yt, { inputSelectorResults: ui, inputSelectorResultsCopy: ai } = pt, li = ti(() => ({}), ...ii);
  if (li.apply(null, ui) !== li.apply(null, ai)) {
    let oi;
    try {
      throw new Error();
    } catch (si) {
      ({ stack: oi } = si);
    }
    console.warn(
      `An input selector returned a different result when passed same arguments.
This means your output selector will likely run more frequently than intended.
Avoid returning a new reference inside your input selector, e.g.
\`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)\``,
      {
        arguments: ir,
        firstInputs: ui,
        secondInputs: ai,
        stack: oi
      }
    );
  }
}, globalDevModeChecks = {
  inputStabilityCheck: "once",
  identityFunctionCheck: "once"
};
function assertIsFunction(pt, yt = `expected a function, instead received ${typeof pt}`) {
  if (typeof pt != "function")
    throw new TypeError(yt);
}
function assertIsObject(pt, yt = `expected an object, instead received ${typeof pt}`) {
  if (typeof pt != "object")
    throw new TypeError(yt);
}
function assertIsArrayOfFunctions(pt, yt = "expected all items to be functions, instead received the following types: ") {
  if (!pt.every((ir) => typeof ir == "function")) {
    const ir = pt.map(
      (ti) => typeof ti == "function" ? `function ${ti.name || "unnamed"}()` : typeof ti
    ).join(", ");
    throw new TypeError(`${yt}[${ir}]`);
  }
}
var ensureIsArray = (pt) => Array.isArray(pt) ? pt : [pt];
function getDependencies(pt) {
  const yt = Array.isArray(pt[0]) ? pt[0] : pt;
  return assertIsArrayOfFunctions(
    yt,
    "createSelector expects all input-selectors to be functions, but received the following types: "
  ), yt;
}
function collectInputSelectorResults(pt, yt) {
  const ir = [], { length: ti } = pt;
  for (let ii = 0; ii < ti; ii++)
    ir.push(pt[ii].apply(null, yt));
  return ir;
}
var getDevModeChecksExecutionInfo = (pt, yt) => {
  const { identityFunctionCheck: ir, inputStabilityCheck: ti } = {
    ...globalDevModeChecks,
    ...yt
  };
  return {
    identityFunctionCheck: {
      shouldRun: ir === "always" || ir === "once" && pt,
      run: runIdentityFunctionCheck
    },
    inputStabilityCheck: {
      shouldRun: ti === "always" || ti === "once" && pt,
      run: runInputStabilityCheck
    }
  };
}, StrongRef = class {
  constructor(pt) {
    this.value = pt;
  }
  deref() {
    return this.value;
  }
}, Ref = typeof WeakRef < "u" ? WeakRef : StrongRef, UNTERMINATED = 0, TERMINATED = 1;
function createCacheNode() {
  return {
    s: UNTERMINATED,
    v: void 0,
    o: null,
    p: null
  };
}
function weakMapMemoize(pt, yt = {}) {
  let ir = createCacheNode();
  const { resultEqualityCheck: ti } = yt;
  let ii, ui = 0;
  function ai() {
    var li;
    let oi = ir;
    const { length: si } = arguments;
    for (let gi = 0, mi = si; gi < mi; gi++) {
      const Ti = arguments[gi];
      if (typeof Ti == "function" || typeof Ti == "object" && Ti !== null) {
        let vi = oi.o;
        vi === null && (oi.o = vi = /* @__PURE__ */ new WeakMap());
        const xi = vi.get(Ti);
        xi === void 0 ? (oi = createCacheNode(), vi.set(Ti, oi)) : oi = xi;
      } else {
        let vi = oi.p;
        vi === null && (oi.p = vi = /* @__PURE__ */ new Map());
        const xi = vi.get(Ti);
        xi === void 0 ? (oi = createCacheNode(), vi.set(Ti, oi)) : oi = xi;
      }
    }
    const di = oi;
    let fi;
    if (oi.s === TERMINATED)
      fi = oi.v;
    else if (fi = pt.apply(null, arguments), ui++, ti) {
      const gi = ((li = ii == null ? void 0 : ii.deref) == null ? void 0 : li.call(ii)) ?? ii;
      gi != null && ti(gi, fi) && (fi = gi, ui !== 0 && ui--), ii = typeof fi == "object" && fi !== null || typeof fi == "function" ? new Ref(fi) : fi;
    }
    return di.s = TERMINATED, di.v = fi, fi;
  }
  return ai.clearCache = () => {
    ir = createCacheNode(), ai.resetResultsCount();
  }, ai.resultsCount = () => ui, ai.resetResultsCount = () => {
    ui = 0;
  }, ai;
}
function createSelectorCreator(pt, ...yt) {
  const ir = typeof pt == "function" ? {
    memoize: pt,
    memoizeOptions: yt
  } : pt, ti = (...ii) => {
    let ui = 0, ai = 0, li, oi = {}, si = ii.pop();
    typeof si == "object" && (oi = si, si = ii.pop()), assertIsFunction(
      si,
      `createSelector expects an output function after the inputs, but received: [${typeof si}]`
    );
    const di = {
      ...ir,
      ...oi
    }, {
      memoize: fi,
      memoizeOptions: gi = [],
      argsMemoize: mi = weakMapMemoize,
      argsMemoizeOptions: Ti = [],
      devModeChecks: vi = {}
    } = di, xi = ensureIsArray(gi), Si = ensureIsArray(Ti), Pi = getDependencies(ii), $i = fi(function() {
      return ui++, si.apply(
        null,
        arguments
      );
    }, ...xi);
    let Oi = !0;
    const Di = mi(function() {
      ai++;
      const Mi = collectInputSelectorResults(
        Pi,
        arguments
      );
      if (li = $i.apply(null, Mi), process.env.NODE_ENV !== "production") {
        const { identityFunctionCheck: Oo, inputStabilityCheck: io } = getDevModeChecksExecutionInfo(Oi, vi);
        if (Oo.shouldRun && Oo.run(
          si,
          Mi,
          li
        ), io.shouldRun) {
          const xo = collectInputSelectorResults(
            Pi,
            arguments
          );
          io.run(
            { inputSelectorResults: Mi, inputSelectorResultsCopy: xo },
            { memoize: fi, memoizeOptions: xi },
            arguments
          );
        }
        Oi && (Oi = !1);
      }
      return li;
    }, ...Si);
    return Object.assign(Di, {
      resultFunc: si,
      memoizedResultFunc: $i,
      dependencies: Pi,
      dependencyRecomputations: () => ai,
      resetDependencyRecomputations: () => {
        ai = 0;
      },
      lastResult: () => li,
      recomputations: () => ui,
      resetRecomputations: () => {
        ui = 0;
      },
      memoize: fi,
      argsMemoize: mi
    });
  };
  return Object.assign(ti, {
    withTypes: () => ti
  }), ti;
}
var createSelector = /* @__PURE__ */ createSelectorCreator(weakMapMemoize), createStructuredSelector = Object.assign(
  (pt, yt = createSelector) => {
    assertIsObject(
      pt,
      `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof pt}`
    );
    const ir = Object.keys(pt), ti = ir.map(
      (ii) => pt[ii]
    );
    return yt(
      ti,
      (...ii) => ii.reduce((ui, ai, li) => (ui[ir[li]] = ai, ui), {})
    );
  },
  { withTypes: () => createStructuredSelector }
), sortBy$3 = {}, orderBy = {}, compareValues = {}, hasRequiredCompareValues;
function requireCompareValues() {
  return hasRequiredCompareValues || (hasRequiredCompareValues = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    function yt(ti) {
      return typeof ti == "symbol" ? 1 : ti === null ? 2 : ti === void 0 ? 3 : ti !== ti ? 4 : 0;
    }
    const ir = (ti, ii, ui) => {
      if (ti !== ii) {
        const ai = yt(ti), li = yt(ii);
        if (ai === li && ai === 0) {
          if (ti < ii)
            return ui === "desc" ? 1 : -1;
          if (ti > ii)
            return ui === "desc" ? -1 : 1;
        }
        return ui === "desc" ? li - ai : ai - li;
      }
      return 0;
    };
    pt.compareValues = ir;
  })(compareValues)), compareValues;
}
var isKey = {}, isSymbol = {}, hasRequiredIsSymbol;
function requireIsSymbol() {
  return hasRequiredIsSymbol || (hasRequiredIsSymbol = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    function yt(ir) {
      return typeof ir == "symbol" || ir instanceof Symbol;
    }
    pt.isSymbol = yt;
  })(isSymbol)), isSymbol;
}
var hasRequiredIsKey;
function requireIsKey() {
  return hasRequiredIsKey || (hasRequiredIsKey = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    const yt = /* @__PURE__ */ requireIsSymbol(), ir = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, ti = /^\w*$/;
    function ii(ui, ai) {
      return Array.isArray(ui) ? !1 : typeof ui == "number" || typeof ui == "boolean" || ui == null || yt.isSymbol(ui) ? !0 : typeof ui == "string" && (ti.test(ui) || !ir.test(ui)) || ai != null && Object.hasOwn(ai, ui);
    }
    pt.isKey = ii;
  })(isKey)), isKey;
}
var hasRequiredOrderBy;
function requireOrderBy() {
  return hasRequiredOrderBy || (hasRequiredOrderBy = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    const yt = /* @__PURE__ */ requireCompareValues(), ir = /* @__PURE__ */ requireIsKey(), ti = /* @__PURE__ */ requireToPath();
    function ii(ui, ai, li, oi) {
      if (ui == null)
        return [];
      li = oi ? void 0 : li, Array.isArray(ui) || (ui = Object.values(ui)), Array.isArray(ai) || (ai = ai == null ? [null] : [ai]), ai.length === 0 && (ai = [null]), Array.isArray(li) || (li = li == null ? [] : [li]), li = li.map((gi) => String(gi));
      const si = (gi, mi) => {
        let Ti = gi;
        for (let vi = 0; vi < mi.length && Ti != null; ++vi)
          Ti = Ti[mi[vi]];
        return Ti;
      }, di = (gi, mi) => mi == null || gi == null ? mi : typeof gi == "object" && "key" in gi ? Object.hasOwn(mi, gi.key) ? mi[gi.key] : si(mi, gi.path) : typeof gi == "function" ? gi(mi) : Array.isArray(gi) ? si(mi, gi) : typeof mi == "object" ? mi[gi] : mi, fi = ai.map((gi) => (Array.isArray(gi) && gi.length === 1 && (gi = gi[0]), gi == null || typeof gi == "function" || Array.isArray(gi) || ir.isKey(gi) ? gi : { key: gi, path: ti.toPath(gi) }));
      return ui.map((gi) => ({
        original: gi,
        criteria: fi.map((mi) => di(mi, gi))
      })).slice().sort((gi, mi) => {
        for (let Ti = 0; Ti < fi.length; Ti++) {
          const vi = yt.compareValues(gi.criteria[Ti], mi.criteria[Ti], li[Ti]);
          if (vi !== 0)
            return vi;
        }
        return 0;
      }).map((gi) => gi.original);
    }
    pt.orderBy = ii;
  })(orderBy)), orderBy;
}
var flatten = {}, hasRequiredFlatten;
function requireFlatten() {
  return hasRequiredFlatten || (hasRequiredFlatten = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    function yt(ir, ti = 1) {
      const ii = [], ui = Math.floor(ti), ai = (li, oi) => {
        for (let si = 0; si < li.length; si++) {
          const di = li[si];
          Array.isArray(di) && oi < ui ? ai(di, oi + 1) : ii.push(di);
        }
      };
      return ai(ir, 0), ii;
    }
    pt.flatten = yt;
  })(flatten)), flatten;
}
var isIterateeCall = {}, hasRequiredIsIterateeCall;
function requireIsIterateeCall() {
  return hasRequiredIsIterateeCall || (hasRequiredIsIterateeCall = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    const yt = /* @__PURE__ */ requireIsIndex(), ir = /* @__PURE__ */ requireIsArrayLike(), ti = /* @__PURE__ */ requireIsObject(), ii = /* @__PURE__ */ requireIsEqualsSameValueZero();
    function ui(ai, li, oi) {
      return ti.isObject(oi) && (typeof li == "number" && ir.isArrayLike(oi) && yt.isIndex(li) && li < oi.length || typeof li == "string" && li in oi) ? ii.isEqualsSameValueZero(oi[li], ai) : !1;
    }
    pt.isIterateeCall = ui;
  })(isIterateeCall)), isIterateeCall;
}
var hasRequiredSortBy$1;
function requireSortBy$1() {
  return hasRequiredSortBy$1 || (hasRequiredSortBy$1 = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    const yt = /* @__PURE__ */ requireOrderBy(), ir = /* @__PURE__ */ requireFlatten(), ti = /* @__PURE__ */ requireIsIterateeCall();
    function ii(ui, ...ai) {
      const li = ai.length;
      return li > 1 && ti.isIterateeCall(ui, ai[0], ai[1]) ? ai = [] : li > 2 && ti.isIterateeCall(ai[0], ai[1], ai[2]) && (ai = [ai[0]]), yt.orderBy(ui, ir.flatten(ai), ["asc"]);
    }
    pt.sortBy = ii;
  })(sortBy$3)), sortBy$3;
}
var sortBy$2, hasRequiredSortBy;
function requireSortBy() {
  return hasRequiredSortBy || (hasRequiredSortBy = 1, sortBy$2 = requireSortBy$1().sortBy), sortBy$2;
}
var sortByExports = /* @__PURE__ */ requireSortBy();
const sortBy$1 = /* @__PURE__ */ getDefaultExportFromCjs(sortByExports);
var selectLegendSettings = (pt) => pt.legend.settings, selectLegendSize = (pt) => pt.legend.size, selectAllLegendPayload2DArray = (pt) => pt.legend.payload, selectLegendPayload = createSelector([selectAllLegendPayload2DArray, selectLegendSettings], (pt, yt) => {
  var {
    itemSorter: ir
  } = yt, ti = pt.flat(1);
  return ir ? sortBy$1(ti, ir) : ti;
});
function useLegendPayload() {
  return useAppSelector(selectLegendPayload);
}
var EPS = 1;
function useElementOffset() {
  var pt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], [yt, ir] = useState({
    height: 0,
    left: 0,
    top: 0,
    width: 0
  }), ti = useCallback(
    (ii) => {
      if (ii != null) {
        var ui = ii.getBoundingClientRect(), ai = {
          height: ui.height,
          left: ui.left,
          top: ui.top,
          width: ui.width
        };
        (Math.abs(ai.height - yt.height) > EPS || Math.abs(ai.left - yt.left) > EPS || Math.abs(ai.top - yt.top) > EPS || Math.abs(ai.width - yt.width) > EPS) && ir({
          height: ai.height,
          left: ai.left,
          top: ai.top,
          width: ai.width
        });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [yt.width, yt.height, yt.top, yt.left, ...pt]
  );
  return [yt, ti];
}
function formatProdErrorMessage$1(pt) {
  return `Minified Redux error #${pt}; visit https://redux.js.org/Errors?code=${pt} for the full message or use the non-minified dev environment for full errors. `;
}
var randomString = () => Math.random().toString(36).substring(7).split("").join("."), ActionTypes = {
  INIT: `@@redux/INIT${/* @__PURE__ */ randomString()}`,
  REPLACE: `@@redux/REPLACE${/* @__PURE__ */ randomString()}`,
  PROBE_UNKNOWN_ACTION: () => `@@redux/PROBE_UNKNOWN_ACTION${randomString()}`
}, actionTypes_default = ActionTypes;
function isPlainObject$5(pt) {
  if (typeof pt != "object" || pt === null)
    return !1;
  let yt = pt;
  for (; Object.getPrototypeOf(yt) !== null; )
    yt = Object.getPrototypeOf(yt);
  return Object.getPrototypeOf(pt) === yt || Object.getPrototypeOf(pt) === null;
}
function miniKindOf(pt) {
  if (pt === void 0)
    return "undefined";
  if (pt === null)
    return "null";
  const yt = typeof pt;
  switch (yt) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return yt;
  }
  if (Array.isArray(pt))
    return "array";
  if (isDate(pt))
    return "date";
  if (isError(pt))
    return "error";
  const ir = ctorName(pt);
  switch (ir) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return ir;
  }
  return Object.prototype.toString.call(pt).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function ctorName(pt) {
  return typeof pt.constructor == "function" ? pt.constructor.name : null;
}
function isError(pt) {
  return pt instanceof Error || typeof pt.message == "string" && pt.constructor && typeof pt.constructor.stackTraceLimit == "number";
}
function isDate(pt) {
  return pt instanceof Date ? !0 : typeof pt.toDateString == "function" && typeof pt.getDate == "function" && typeof pt.setDate == "function";
}
function kindOf(pt) {
  let yt = typeof pt;
  return process.env.NODE_ENV !== "production" && (yt = miniKindOf(pt)), yt;
}
function warning(pt) {
  typeof console < "u" && typeof console.error == "function" && console.error(pt);
  try {
    throw new Error(pt);
  } catch {
  }
}
function getUnexpectedStateShapeWarningMessage(pt, yt, ir, ti) {
  const ii = Object.keys(yt), ui = ir && ir.type === actionTypes_default.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (ii.length === 0)
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  if (!isPlainObject$5(pt))
    return `The ${ui} has unexpected type of "${kindOf(pt)}". Expected argument to be an object with the following keys: "${ii.join('", "')}"`;
  const ai = Object.keys(pt).filter((li) => !yt.hasOwnProperty(li) && !ti[li]);
  if (ai.forEach((li) => {
    ti[li] = !0;
  }), !(ir && ir.type === actionTypes_default.REPLACE) && ai.length > 0)
    return `Unexpected ${ai.length > 1 ? "keys" : "key"} "${ai.join('", "')}" found in ${ui}. Expected to find one of the known reducer keys instead: "${ii.join('", "')}". Unexpected keys will be ignored.`;
}
function assertReducerShape(pt) {
  Object.keys(pt).forEach((yt) => {
    const ir = pt[yt];
    if (typeof ir(void 0, {
      type: actionTypes_default.INIT
    }) > "u")
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(12) : `The slice reducer for key "${yt}" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.`);
    if (typeof ir(void 0, {
      type: actionTypes_default.PROBE_UNKNOWN_ACTION()
    }) > "u")
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(13) : `The slice reducer for key "${yt}" returned undefined when probed with a random type. Don't try to handle '${actionTypes_default.INIT}' or other actions in "redux/*" namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.`);
  });
}
function combineReducers(pt) {
  const yt = Object.keys(pt), ir = {};
  for (let ai = 0; ai < yt.length; ai++) {
    const li = yt[ai];
    process.env.NODE_ENV !== "production" && typeof pt[li] > "u" && warning(`No reducer provided for key "${li}"`), typeof pt[li] == "function" && (ir[li] = pt[li]);
  }
  const ti = Object.keys(ir);
  let ii;
  process.env.NODE_ENV !== "production" && (ii = {});
  let ui;
  try {
    assertReducerShape(ir);
  } catch (ai) {
    ui = ai;
  }
  return function(ai = {}, li) {
    if (ui)
      throw ui;
    if (process.env.NODE_ENV !== "production") {
      const di = getUnexpectedStateShapeWarningMessage(ai, ir, li, ii);
      di && warning(di);
    }
    let oi = !1;
    const si = {};
    for (let di = 0; di < ti.length; di++) {
      const fi = ti[di], gi = ir[fi], mi = ai[fi], Ti = gi(mi, li);
      if (typeof Ti > "u") {
        const vi = li && li.type;
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(14) : `When called with an action of type ${vi ? `"${String(vi)}"` : "(unknown type)"}, the slice reducer for key "${fi}" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.`);
      }
      si[fi] = Ti, oi = oi || Ti !== mi;
    }
    return oi = oi || ti.length !== Object.keys(ai).length, oi ? si : ai;
  };
}
function isAction(pt) {
  return isPlainObject$5(pt) && "type" in pt && typeof pt.type == "string";
}
var NOTHING$1 = Symbol.for("immer-nothing"), DRAFTABLE$1 = Symbol.for("immer-draftable"), DRAFT_STATE$1 = Symbol.for("immer-state"), errors$1 = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(pt) {
    return `The plugin for '${pt}' has not been loaded into Immer. To enable the plugin, import and call \`enable${pt}()\` when initializing your application.`;
  },
  function(pt) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${pt}'`;
  },
  "This object has been frozen and should not be mutated",
  function(pt) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + pt;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(pt) {
    return `'current' expects a draft, got: ${pt}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(pt) {
    return `'original' expects a draft, got: ${pt}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function die$1(pt, ...yt) {
  if (process.env.NODE_ENV !== "production") {
    const ir = errors$1[pt], ti = isFunction(ir) ? ir.apply(null, yt) : ir;
    throw new Error(`[Immer] ${ti}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${pt}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var O$3 = Object, getPrototypeOf$1 = O$3.getPrototypeOf, CONSTRUCTOR = "constructor", PROTOTYPE = "prototype", CONFIGURABLE = "configurable", ENUMERABLE = "enumerable", WRITABLE = "writable", VALUE = "value", isDraft$1 = (pt) => !!pt && !!pt[DRAFT_STATE$1];
function isDraftable$1(pt) {
  var yt;
  return pt ? isPlainObject$4(pt) || isArray(pt) || !!pt[DRAFTABLE$1] || !!((yt = pt[CONSTRUCTOR]) != null && yt[DRAFTABLE$1]) || isMap$1(pt) || isSet$1(pt) : !1;
}
var objectCtorString$1 = O$3[PROTOTYPE][CONSTRUCTOR].toString(), cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function isPlainObject$4(pt) {
  if (!pt || !isObjectish(pt))
    return !1;
  const yt = getPrototypeOf$1(pt);
  if (yt === null || yt === O$3[PROTOTYPE])
    return !0;
  const ir = O$3.hasOwnProperty.call(yt, CONSTRUCTOR) && yt[CONSTRUCTOR];
  if (ir === Object)
    return !0;
  if (!isFunction(ir))
    return !1;
  let ti = cachedCtorStrings.get(ir);
  return ti === void 0 && (ti = Function.toString.call(ir), cachedCtorStrings.set(ir, ti)), ti === objectCtorString$1;
}
function each$1(pt, yt, ir = !0) {
  getArchtype$1(pt) === 0 ? (ir ? Reflect.ownKeys(pt) : O$3.keys(pt)).forEach((ti) => {
    yt(ti, pt[ti], pt);
  }) : pt.forEach((ti, ii) => yt(ii, ti, pt));
}
function getArchtype$1(pt) {
  const yt = pt[DRAFT_STATE$1];
  return yt ? yt.type_ : isArray(pt) ? 1 : isMap$1(pt) ? 2 : isSet$1(pt) ? 3 : 0;
}
var has$1 = (pt, yt, ir = getArchtype$1(pt)) => ir === 2 ? pt.has(yt) : O$3[PROTOTYPE].hasOwnProperty.call(pt, yt), get = (pt, yt, ir = getArchtype$1(pt)) => (
  // @ts-ignore
  ir === 2 ? pt.get(yt) : pt[yt]
), set$1 = (pt, yt, ir, ti = getArchtype$1(pt)) => {
  ti === 2 ? pt.set(yt, ir) : ti === 3 ? pt.add(ir) : pt[yt] = ir;
};
function is$3(pt, yt) {
  return pt === yt ? pt !== 0 || 1 / pt === 1 / yt : pt !== pt && yt !== yt;
}
var isArray = Array.isArray, isMap$1 = (pt) => pt instanceof Map, isSet$1 = (pt) => pt instanceof Set, isObjectish = (pt) => typeof pt == "object", isFunction = (pt) => typeof pt == "function", isBoolean$1 = (pt) => typeof pt == "boolean";
function isArrayIndex(pt) {
  const yt = +pt;
  return Number.isInteger(yt) && String(yt) === pt;
}
var latest$1 = (pt) => pt.copy_ || pt.base_, getFinalValue = (pt) => pt.modified_ ? pt.copy_ : pt.base_;
function shallowCopy$1(pt, yt) {
  if (isMap$1(pt))
    return new Map(pt);
  if (isSet$1(pt))
    return new Set(pt);
  if (isArray(pt))
    return Array[PROTOTYPE].slice.call(pt);
  const ir = isPlainObject$4(pt);
  if (yt === !0 || yt === "class_only" && !ir) {
    const ti = O$3.getOwnPropertyDescriptors(pt);
    delete ti[DRAFT_STATE$1];
    let ii = Reflect.ownKeys(ti);
    for (let ui = 0; ui < ii.length; ui++) {
      const ai = ii[ui], li = ti[ai];
      li[WRITABLE] === !1 && (li[WRITABLE] = !0, li[CONFIGURABLE] = !0), (li.get || li.set) && (ti[ai] = {
        [CONFIGURABLE]: !0,
        [WRITABLE]: !0,
        // could live with !!desc.set as well here...
        [ENUMERABLE]: li[ENUMERABLE],
        [VALUE]: pt[ai]
      });
    }
    return O$3.create(getPrototypeOf$1(pt), ti);
  } else {
    const ti = getPrototypeOf$1(pt);
    if (ti !== null && ir)
      return { ...pt };
    const ii = O$3.create(ti);
    return O$3.assign(ii, pt);
  }
}
function freeze$1(pt, yt = !1) {
  return isFrozen$1(pt) || isDraft$1(pt) || !isDraftable$1(pt) || (getArchtype$1(pt) > 1 && O$3.defineProperties(pt, {
    set: dontMutateMethodOverride,
    add: dontMutateMethodOverride,
    clear: dontMutateMethodOverride,
    delete: dontMutateMethodOverride
  }), O$3.freeze(pt), yt && each$1(
    pt,
    (ir, ti) => {
      freeze$1(ti, !0);
    },
    !1
  )), pt;
}
function dontMutateFrozenCollections$1() {
  die$1(2);
}
var dontMutateMethodOverride = {
  [VALUE]: dontMutateFrozenCollections$1
};
function isFrozen$1(pt) {
  return pt === null || !isObjectish(pt) ? !0 : O$3.isFrozen(pt);
}
var PluginMapSet = "MapSet", PluginPatches = "Patches", PluginArrayMethods = "ArrayMethods", plugins$1 = {};
function getPlugin$1(pt) {
  const yt = plugins$1[pt];
  return yt || die$1(0, pt), yt;
}
var isPluginLoaded = (pt) => !!plugins$1[pt], currentScope$1, getCurrentScope$1 = () => currentScope$1, createScope$1 = (pt, yt) => ({
  drafts_: [],
  parent_: pt,
  immer_: yt,
  // Whenever the modified draft contains a draft from another scope, we
  // need to prevent auto-freezing so the unowned draft can be finalized.
  canAutoFreeze_: !0,
  unfinalizedDrafts_: 0,
  handledSet_: /* @__PURE__ */ new Set(),
  processedForPatches_: /* @__PURE__ */ new Set(),
  mapSetPlugin_: isPluginLoaded(PluginMapSet) ? getPlugin$1(PluginMapSet) : void 0,
  arrayMethodsPlugin_: isPluginLoaded(PluginArrayMethods) ? getPlugin$1(PluginArrayMethods) : void 0
});
function usePatchesInScope$1(pt, yt) {
  yt && (pt.patchPlugin_ = getPlugin$1(PluginPatches), pt.patches_ = [], pt.inversePatches_ = [], pt.patchListener_ = yt);
}
function revokeScope$1(pt) {
  leaveScope$1(pt), pt.drafts_.forEach(revokeDraft$1), pt.drafts_ = null;
}
function leaveScope$1(pt) {
  pt === currentScope$1 && (currentScope$1 = pt.parent_);
}
var enterScope$1 = (pt) => currentScope$1 = createScope$1(currentScope$1, pt);
function revokeDraft$1(pt) {
  const yt = pt[DRAFT_STATE$1];
  yt.type_ === 0 || yt.type_ === 1 ? yt.revoke_() : yt.revoked_ = !0;
}
function processResult$1(pt, yt) {
  yt.unfinalizedDrafts_ = yt.drafts_.length;
  const ir = yt.drafts_[0];
  if (pt !== void 0 && pt !== ir) {
    ir[DRAFT_STATE$1].modified_ && (revokeScope$1(yt), die$1(4)), isDraftable$1(pt) && (pt = finalize$1(yt, pt));
    const { patchPlugin_: ti } = yt;
    ti && ti.generateReplacementPatches_(
      ir[DRAFT_STATE$1].base_,
      pt,
      yt
    );
  } else
    pt = finalize$1(yt, ir);
  return maybeFreeze$1(yt, pt, !0), revokeScope$1(yt), yt.patches_ && yt.patchListener_(yt.patches_, yt.inversePatches_), pt !== NOTHING$1 ? pt : void 0;
}
function finalize$1(pt, yt) {
  if (isFrozen$1(yt))
    return yt;
  const ir = yt[DRAFT_STATE$1];
  if (!ir)
    return handleValue(yt, pt.handledSet_, pt);
  if (!isSameScope(ir, pt))
    return yt;
  if (!ir.modified_)
    return ir.base_;
  if (!ir.finalized_) {
    const { callbacks_: ti } = ir;
    if (ti)
      for (; ti.length > 0; )
        ti.pop()(pt);
    generatePatchesAndFinalize(ir, pt);
  }
  return ir.copy_;
}
function maybeFreeze$1(pt, yt, ir = !1) {
  !pt.parent_ && pt.immer_.autoFreeze_ && pt.canAutoFreeze_ && freeze$1(yt, ir);
}
function markStateFinalized(pt) {
  pt.finalized_ = !0, pt.scope_.unfinalizedDrafts_--;
}
var isSameScope = (pt, yt) => pt.scope_ === yt, EMPTY_LOCATIONS_RESULT = [];
function updateDraftInParent(pt, yt, ir, ti) {
  const ii = latest$1(pt), ui = pt.type_;
  if (ti !== void 0 && get(ii, ti, ui) === yt) {
    set$1(ii, ti, ir, ui);
    return;
  }
  if (!pt.draftLocations_) {
    const li = pt.draftLocations_ = /* @__PURE__ */ new Map();
    each$1(ii, (oi, si) => {
      if (isDraft$1(si)) {
        const di = li.get(si) || [];
        di.push(oi), li.set(si, di);
      }
    });
  }
  const ai = pt.draftLocations_.get(yt) ?? EMPTY_LOCATIONS_RESULT;
  for (const li of ai)
    set$1(ii, li, ir, ui);
}
function registerChildFinalizationCallback(pt, yt, ir) {
  pt.callbacks_.push(function(ti) {
    var ii;
    const ui = yt;
    if (!ui || !isSameScope(ui, ti))
      return;
    (ii = ti.mapSetPlugin_) == null || ii.fixSetContents(ui);
    const ai = getFinalValue(ui);
    updateDraftInParent(pt, ui.draft_ ?? ui, ai, ir), generatePatchesAndFinalize(ui, ti);
  });
}
function generatePatchesAndFinalize(pt, yt) {
  var ir;
  if (pt.modified_ && !pt.finalized_ && (pt.type_ === 3 || pt.type_ === 1 && pt.allIndicesReassigned_ || (((ir = pt.assigned_) == null ? void 0 : ir.size) ?? 0) > 0)) {
    const { patchPlugin_: ti } = yt;
    if (ti) {
      const ii = ti.getPath(pt);
      ii && ti.generatePatches_(pt, ii, yt);
    }
    markStateFinalized(pt);
  }
}
function handleCrossReference(pt, yt, ir) {
  const { scope_: ti } = pt;
  if (isDraft$1(ir)) {
    const ii = ir[DRAFT_STATE$1];
    isSameScope(ii, ti) && ii.callbacks_.push(function() {
      prepareCopy$1(pt);
      const ui = getFinalValue(ii);
      updateDraftInParent(pt, ir, ui, yt);
    });
  } else isDraftable$1(ir) && pt.callbacks_.push(function() {
    const ii = latest$1(pt);
    pt.type_ === 3 ? ii.has(ir) && handleValue(ir, ti.handledSet_, ti) : get(ii, yt, pt.type_) === ir && ti.drafts_.length > 1 && (pt.assigned_.get(yt) ?? !1) === !0 && pt.copy_ && handleValue(
      get(pt.copy_, yt, pt.type_),
      ti.handledSet_,
      ti
    );
  });
}
function handleValue(pt, yt, ir) {
  return !ir.immer_.autoFreeze_ && ir.unfinalizedDrafts_ < 1 || isDraft$1(pt) || yt.has(pt) || !isDraftable$1(pt) || isFrozen$1(pt) || (yt.add(pt), each$1(pt, (ti, ii) => {
    if (isDraft$1(ii)) {
      const ui = ii[DRAFT_STATE$1];
      if (isSameScope(ui, ir)) {
        const ai = getFinalValue(ui);
        set$1(pt, ti, ai, pt.type_), markStateFinalized(ui);
      }
    } else isDraftable$1(ii) && handleValue(ii, yt, ir);
  })), pt;
}
function createProxyProxy$1(pt, yt) {
  const ir = isArray(pt), ti = {
    type_: ir ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: yt ? yt.scope_ : getCurrentScope$1(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    // actually instantiated in `prepareCopy()`
    assigned_: void 0,
    // The parent draft state.
    parent_: yt,
    // The base state.
    base_: pt,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1,
    // `callbacks` actually gets assigned in `createProxy`
    callbacks_: void 0
  };
  let ii = ti, ui = objectTraps$1;
  ir && (ii = [ti], ui = arrayTraps$1);
  const { revoke: ai, proxy: li } = Proxy.revocable(ii, ui);
  return ti.draft_ = li, ti.revoke_ = ai, [li, ti];
}
var objectTraps$1 = {
  get(pt, yt) {
    if (yt === DRAFT_STATE$1)
      return pt;
    let ir = pt.scope_.arrayMethodsPlugin_;
    const ti = pt.type_ === 1 && typeof yt == "string";
    if (ti && ir != null && ir.isArrayOperationMethod(yt))
      return ir.createMethodInterceptor(pt, yt);
    const ii = latest$1(pt);
    if (!has$1(ii, yt, pt.type_))
      return readPropFromProto$1(pt, ii, yt);
    const ui = ii[yt];
    if (pt.finalized_ || !isDraftable$1(ui) || ti && pt.operationMethod && ir != null && ir.isMutatingArrayMethod(
      pt.operationMethod
    ) && isArrayIndex(yt))
      return ui;
    if (ui === peek$1(pt.base_, yt)) {
      prepareCopy$1(pt);
      const ai = pt.type_ === 1 ? +yt : yt, li = createProxy$1(pt.scope_, ui, pt, ai);
      return pt.copy_[ai] = li;
    }
    return ui;
  },
  has(pt, yt) {
    return yt in latest$1(pt);
  },
  ownKeys(pt) {
    return Reflect.ownKeys(latest$1(pt));
  },
  set(pt, yt, ir) {
    const ti = getDescriptorFromProto$1(latest$1(pt), yt);
    if (ti != null && ti.set)
      return ti.set.call(pt.draft_, ir), !0;
    if (!pt.modified_) {
      const ii = peek$1(latest$1(pt), yt), ui = ii == null ? void 0 : ii[DRAFT_STATE$1];
      if (ui && ui.base_ === ir)
        return pt.copy_[yt] = ir, pt.assigned_.set(yt, !1), !0;
      if (is$3(ir, ii) && (ir !== void 0 || has$1(pt.base_, yt, pt.type_)))
        return !0;
      prepareCopy$1(pt), markChanged$1(pt);
    }
    return pt.copy_[yt] === ir && // special case: handle new props with value 'undefined'
    (ir !== void 0 || yt in pt.copy_) || // special case: NaN
    Number.isNaN(ir) && Number.isNaN(pt.copy_[yt]) || (pt.copy_[yt] = ir, pt.assigned_.set(yt, !0), handleCrossReference(pt, yt, ir)), !0;
  },
  deleteProperty(pt, yt) {
    return prepareCopy$1(pt), peek$1(pt.base_, yt) !== void 0 || yt in pt.base_ ? (pt.assigned_.set(yt, !1), markChanged$1(pt)) : pt.assigned_.delete(yt), pt.copy_ && delete pt.copy_[yt], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(pt, yt) {
    const ir = latest$1(pt), ti = Reflect.getOwnPropertyDescriptor(ir, yt);
    return ti && {
      [WRITABLE]: !0,
      [CONFIGURABLE]: pt.type_ !== 1 || yt !== "length",
      [ENUMERABLE]: ti[ENUMERABLE],
      [VALUE]: ir[yt]
    };
  },
  defineProperty() {
    die$1(11);
  },
  getPrototypeOf(pt) {
    return getPrototypeOf$1(pt.base_);
  },
  setPrototypeOf() {
    die$1(12);
  }
}, arrayTraps$1 = {};
for (let pt in objectTraps$1) {
  let yt = objectTraps$1[pt];
  arrayTraps$1[pt] = function() {
    const ir = arguments;
    return ir[0] = ir[0][0], yt.apply(this, ir);
  };
}
arrayTraps$1.deleteProperty = function(pt, yt) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(yt)) && die$1(13), arrayTraps$1.set.call(this, pt, yt, void 0);
};
arrayTraps$1.set = function(pt, yt, ir) {
  return process.env.NODE_ENV !== "production" && yt !== "length" && isNaN(parseInt(yt)) && die$1(14), objectTraps$1.set.call(this, pt[0], yt, ir, pt[0]);
};
function peek$1(pt, yt) {
  const ir = pt[DRAFT_STATE$1];
  return (ir ? latest$1(ir) : pt)[yt];
}
function readPropFromProto$1(pt, yt, ir) {
  var ti;
  const ii = getDescriptorFromProto$1(yt, ir);
  return ii ? VALUE in ii ? ii[VALUE] : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (ti = ii.get) == null ? void 0 : ti.call(pt.draft_)
  ) : void 0;
}
function getDescriptorFromProto$1(pt, yt) {
  if (!(yt in pt))
    return;
  let ir = getPrototypeOf$1(pt);
  for (; ir; ) {
    const ti = Object.getOwnPropertyDescriptor(ir, yt);
    if (ti)
      return ti;
    ir = getPrototypeOf$1(ir);
  }
}
function markChanged$1(pt) {
  pt.modified_ || (pt.modified_ = !0, pt.parent_ && markChanged$1(pt.parent_));
}
function prepareCopy$1(pt) {
  pt.copy_ || (pt.assigned_ = /* @__PURE__ */ new Map(), pt.copy_ = shallowCopy$1(
    pt.base_,
    pt.scope_.immer_.useStrictShallowCopy_
  ));
}
var Immer2$1 = class {
  constructor(pt) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.useStrictIteration_ = !1, this.produce = (yt, ir, ti) => {
      if (isFunction(yt) && !isFunction(ir)) {
        const ui = ir;
        ir = yt;
        const ai = this;
        return function(li = ui, ...oi) {
          return ai.produce(li, (si) => ir.call(this, si, ...oi));
        };
      }
      isFunction(ir) || die$1(6), ti !== void 0 && !isFunction(ti) && die$1(7);
      let ii;
      if (isDraftable$1(yt)) {
        const ui = enterScope$1(this), ai = createProxy$1(ui, yt, void 0);
        let li = !0;
        try {
          ii = ir(ai), li = !1;
        } finally {
          li ? revokeScope$1(ui) : leaveScope$1(ui);
        }
        return usePatchesInScope$1(ui, ti), processResult$1(ii, ui);
      } else if (!yt || !isObjectish(yt)) {
        if (ii = ir(yt), ii === void 0 && (ii = yt), ii === NOTHING$1 && (ii = void 0), this.autoFreeze_ && freeze$1(ii, !0), ti) {
          const ui = [], ai = [];
          getPlugin$1(PluginPatches).generateReplacementPatches_(yt, ii, {
            patches_: ui,
            inversePatches_: ai
          }), ti(ui, ai);
        }
        return ii;
      } else
        die$1(1, yt);
    }, this.produceWithPatches = (yt, ir) => {
      if (isFunction(yt))
        return (ui, ...ai) => this.produceWithPatches(ui, (li) => yt(li, ...ai));
      let ti, ii;
      return [this.produce(yt, ir, (ui, ai) => {
        ti = ui, ii = ai;
      }), ti, ii];
    }, isBoolean$1(pt == null ? void 0 : pt.autoFreeze) && this.setAutoFreeze(pt.autoFreeze), isBoolean$1(pt == null ? void 0 : pt.useStrictShallowCopy) && this.setUseStrictShallowCopy(pt.useStrictShallowCopy), isBoolean$1(pt == null ? void 0 : pt.useStrictIteration) && this.setUseStrictIteration(pt.useStrictIteration);
  }
  createDraft(pt) {
    isDraftable$1(pt) || die$1(8), isDraft$1(pt) && (pt = current$1(pt));
    const yt = enterScope$1(this), ir = createProxy$1(yt, pt, void 0);
    return ir[DRAFT_STATE$1].isManual_ = !0, leaveScope$1(yt), ir;
  }
  finishDraft(pt, yt) {
    const ir = pt && pt[DRAFT_STATE$1];
    (!ir || !ir.isManual_) && die$1(9);
    const { scope_: ti } = ir;
    return usePatchesInScope$1(ti, yt), processResult$1(void 0, ti);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(pt) {
    this.autoFreeze_ = pt;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(pt) {
    this.useStrictShallowCopy_ = pt;
  }
  /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */
  setUseStrictIteration(pt) {
    this.useStrictIteration_ = pt;
  }
  shouldUseStrictIteration() {
    return this.useStrictIteration_;
  }
  applyPatches(pt, yt) {
    let ir;
    for (ir = yt.length - 1; ir >= 0; ir--) {
      const ii = yt[ir];
      if (ii.path.length === 0 && ii.op === "replace") {
        pt = ii.value;
        break;
      }
    }
    ir > -1 && (yt = yt.slice(ir + 1));
    const ti = getPlugin$1(PluginPatches).applyPatches_;
    return isDraft$1(pt) ? ti(pt, yt) : this.produce(
      pt,
      (ii) => ti(ii, yt)
    );
  }
};
function createProxy$1(pt, yt, ir, ti) {
  const [ii, ui] = isMap$1(yt) ? getPlugin$1(PluginMapSet).proxyMap_(yt, ir) : isSet$1(yt) ? getPlugin$1(PluginMapSet).proxySet_(yt, ir) : createProxyProxy$1(yt, ir);
  return ((ir == null ? void 0 : ir.scope_) ?? getCurrentScope$1()).drafts_.push(ii), ui.callbacks_ = (ir == null ? void 0 : ir.callbacks_) ?? [], ui.key_ = ti, ir && ti !== void 0 ? registerChildFinalizationCallback(ir, ui, ti) : ui.callbacks_.push(function(ai) {
    var li;
    (li = ai.mapSetPlugin_) == null || li.fixSetContents(ui);
    const { patchPlugin_: oi } = ai;
    ui.modified_ && oi && oi.generatePatches_(ui, [], ai);
  }), ii;
}
function current$1(pt) {
  return isDraft$1(pt) || die$1(10, pt), currentImpl$1(pt);
}
function currentImpl$1(pt) {
  if (!isDraftable$1(pt) || isFrozen$1(pt))
    return pt;
  const yt = pt[DRAFT_STATE$1];
  let ir, ti = !0;
  if (yt) {
    if (!yt.modified_)
      return yt.base_;
    yt.finalized_ = !0, ir = shallowCopy$1(pt, yt.scope_.immer_.useStrictShallowCopy_), ti = yt.scope_.immer_.shouldUseStrictIteration();
  } else
    ir = shallowCopy$1(pt, !0);
  return each$1(
    ir,
    (ii, ui) => {
      set$1(ir, ii, currentImpl$1(ui));
    },
    ti
  ), yt && (yt.finalized_ = !1), ir;
}
var immer$1 = new Immer2$1(), produce = immer$1.produce;
function createAction(pt, yt) {
  function ir(...ti) {
    if (yt) {
      let ii = yt(...ti);
      if (!ii)
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(0) : "prepareAction did not return an object");
      return {
        type: pt,
        payload: ii.payload,
        ..."meta" in ii && {
          meta: ii.meta
        },
        ..."error" in ii && {
          error: ii.error
        }
      };
    }
    return {
      type: pt,
      payload: ti[0]
    };
  }
  return ir.toString = () => `${pt}`, ir.type = pt, ir.match = (ti) => isAction(ti) && ti.type === pt, ir;
}
function freezeDraftable(pt) {
  return isDraftable$1(pt) ? produce(pt, () => {
  }) : pt;
}
function getOrInsertComputed(pt, yt, ir) {
  return pt.has(yt) ? pt.get(yt) : pt.set(yt, ir(yt)).get(yt);
}
var SHOULD_AUTOBATCH = "RTK_autoBatch", prepareAutoBatched = () => (pt) => ({
  payload: pt,
  meta: {
    [SHOULD_AUTOBATCH]: !0
  }
});
function executeReducerBuilderCallback(pt) {
  const yt = {}, ir = [];
  let ti;
  const ii = {
    addCase(ui, ai) {
      if (process.env.NODE_ENV !== "production") {
        if (ir.length > 0)
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(26) : "`builder.addCase` should only be called before calling `builder.addMatcher`");
        if (ti)
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(27) : "`builder.addCase` should only be called before calling `builder.addDefaultCase`");
      }
      const li = typeof ui == "string" ? ui : ui.type;
      if (!li)
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(28) : "`builder.addCase` cannot be called with an empty action type");
      if (li in yt)
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(29) : `\`builder.addCase\` cannot be called with two reducers for the same action type '${li}'`);
      return yt[li] = ai, ii;
    },
    addAsyncThunk(ui, ai) {
      if (process.env.NODE_ENV !== "production" && ti)
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(43) : "`builder.addAsyncThunk` should only be called before calling `builder.addDefaultCase`");
      return ai.pending && (yt[ui.pending.type] = ai.pending), ai.rejected && (yt[ui.rejected.type] = ai.rejected), ai.fulfilled && (yt[ui.fulfilled.type] = ai.fulfilled), ai.settled && ir.push({
        matcher: ui.settled,
        reducer: ai.settled
      }), ii;
    },
    addMatcher(ui, ai) {
      if (process.env.NODE_ENV !== "production" && ti)
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(30) : "`builder.addMatcher` should only be called before calling `builder.addDefaultCase`");
      return ir.push({
        matcher: ui,
        reducer: ai
      }), ii;
    },
    addDefaultCase(ui) {
      if (process.env.NODE_ENV !== "production" && ti)
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(31) : "`builder.addDefaultCase` can only be called once");
      return ti = ui, ii;
    }
  };
  return pt(ii), [yt, ir, ti];
}
function isStateFunction(pt) {
  return typeof pt == "function";
}
function createReducer(pt, yt) {
  if (process.env.NODE_ENV !== "production" && typeof yt == "object")
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(8) : "The object notation for `createReducer` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createReducer");
  let [ir, ti, ii] = executeReducerBuilderCallback(yt), ui;
  if (isStateFunction(pt))
    ui = () => freezeDraftable(pt());
  else {
    const li = freezeDraftable(pt);
    ui = () => li;
  }
  function ai(li = ui(), oi) {
    let si = [ir[oi.type], ...ti.filter(({
      matcher: di
    }) => di(oi)).map(({
      reducer: di
    }) => di)];
    return si.filter((di) => !!di).length === 0 && (si = [ii]), si.reduce((di, fi) => {
      if (fi)
        if (isDraft$1(di)) {
          const gi = fi(di, oi);
          return gi === void 0 ? di : gi;
        } else {
          if (isDraftable$1(di))
            return produce(di, (gi) => fi(gi, oi));
          {
            const gi = fi(di, oi);
            if (gi === void 0) {
              if (di === null)
                return di;
              throw Error("A case reducer on a non-draftable value must not return undefined");
            }
            return gi;
          }
        }
      return di;
    }, li);
  }
  return ai.getInitialState = ui, ai;
}
var urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW", nanoid = (pt = 21) => {
  let yt = "", ir = pt;
  for (; ir--; )
    yt += urlAlphabet[Math.random() * 64 | 0];
  return yt;
}, asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
function getType(pt, yt) {
  return `${pt}/${yt}`;
}
function buildCreateSlice({
  creators: pt
} = {}) {
  var yt;
  const ir = (yt = pt == null ? void 0 : pt.asyncThunk) == null ? void 0 : yt[asyncThunkSymbol];
  return function(ti) {
    const {
      name: ii,
      reducerPath: ui = ii
    } = ti;
    if (!ii)
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(11) : "`name` is a required option for createSlice");
    typeof process < "u" && process.env.NODE_ENV === "development" && ti.initialState === void 0 && console.error("You must provide an `initialState` value that is not `undefined`. You may have misspelled `initialState`");
    const ai = (typeof ti.reducers == "function" ? ti.reducers(buildReducerCreators()) : ti.reducers) || {}, li = Object.keys(ai), oi = {
      sliceCaseReducersByName: {},
      sliceCaseReducersByType: {},
      actionCreators: {},
      sliceMatchers: []
    }, si = {
      addCase($i, Oi) {
        const Di = typeof $i == "string" ? $i : $i.type;
        if (!Di)
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(12) : "`context.addCase` cannot be called with an empty action type");
        if (Di in oi.sliceCaseReducersByType)
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(13) : "`context.addCase` cannot be called with two reducers for the same action type: " + Di);
        return oi.sliceCaseReducersByType[Di] = Oi, si;
      },
      addMatcher($i, Oi) {
        return oi.sliceMatchers.push({
          matcher: $i,
          reducer: Oi
        }), si;
      },
      exposeAction($i, Oi) {
        return oi.actionCreators[$i] = Oi, si;
      },
      exposeCaseReducer($i, Oi) {
        return oi.sliceCaseReducersByName[$i] = Oi, si;
      }
    };
    li.forEach(($i) => {
      const Oi = ai[$i], Di = {
        reducerName: $i,
        type: getType(ii, $i),
        createNotation: typeof ti.reducers == "function"
      };
      isAsyncThunkSliceReducerDefinition(Oi) ? handleThunkCaseReducerDefinition(Di, Oi, si, ir) : handleNormalReducerDefinition(Di, Oi, si);
    });
    function di() {
      if (process.env.NODE_ENV !== "production" && typeof ti.extraReducers == "object")
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(14) : "The object notation for `createSlice.extraReducers` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createSlice");
      const [$i = {}, Oi = [], Di = void 0] = typeof ti.extraReducers == "function" ? executeReducerBuilderCallback(ti.extraReducers) : [ti.extraReducers], Mi = {
        ...$i,
        ...oi.sliceCaseReducersByType
      };
      return createReducer(ti.initialState, (Oo) => {
        for (let io in Mi)
          Oo.addCase(io, Mi[io]);
        for (let io of oi.sliceMatchers)
          Oo.addMatcher(io.matcher, io.reducer);
        for (let io of Oi)
          Oo.addMatcher(io.matcher, io.reducer);
        Di && Oo.addDefaultCase(Di);
      });
    }
    const fi = ($i) => $i, gi = /* @__PURE__ */ new Map(), mi = /* @__PURE__ */ new WeakMap();
    let Ti;
    function vi($i, Oi) {
      return Ti || (Ti = di()), Ti($i, Oi);
    }
    function xi() {
      return Ti || (Ti = di()), Ti.getInitialState();
    }
    function Si($i, Oi = !1) {
      function Di(Oo) {
        let io = Oo[$i];
        if (typeof io > "u") {
          if (Oi)
            io = getOrInsertComputed(mi, Di, xi);
          else if (process.env.NODE_ENV !== "production")
            throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(15) : "selectSlice returned undefined for an uninjected slice reducer");
        }
        return io;
      }
      function Mi(Oo = fi) {
        const io = getOrInsertComputed(gi, Oi, () => /* @__PURE__ */ new WeakMap());
        return getOrInsertComputed(io, Oo, () => {
          const xo = {};
          for (const [fo, _o] of Object.entries(ti.selectors ?? {}))
            xo[fo] = wrapSelector(_o, Oo, () => getOrInsertComputed(mi, Oo, xi), Oi);
          return xo;
        });
      }
      return {
        reducerPath: $i,
        getSelectors: Mi,
        get selectors() {
          return Mi(Di);
        },
        selectSlice: Di
      };
    }
    const Pi = {
      name: ii,
      reducer: vi,
      actions: oi.actionCreators,
      caseReducers: oi.sliceCaseReducersByName,
      getInitialState: xi,
      ...Si(ui),
      injectInto($i, {
        reducerPath: Oi,
        ...Di
      } = {}) {
        const Mi = Oi ?? ui;
        return $i.inject({
          reducerPath: Mi,
          reducer: vi
        }, Di), {
          ...Pi,
          ...Si(Mi, !0)
        };
      }
    };
    return Pi;
  };
}
function wrapSelector(pt, yt, ir, ti) {
  function ii(ui, ...ai) {
    let li = yt(ui);
    if (typeof li > "u") {
      if (ti)
        li = ir();
      else if (process.env.NODE_ENV !== "production")
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(16) : "selectState returned undefined for an uninjected slice reducer");
    }
    return pt(li, ...ai);
  }
  return ii.unwrapped = pt, ii;
}
var createSlice = /* @__PURE__ */ buildCreateSlice();
function buildReducerCreators() {
  function pt(yt, ir) {
    return {
      _reducerDefinitionType: "asyncThunk",
      payloadCreator: yt,
      ...ir
    };
  }
  return pt.withTypes = () => pt, {
    reducer(yt) {
      return Object.assign({
        // hack so the wrapping function has the same name as the original
        // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
        [yt.name](...ir) {
          return yt(...ir);
        }
      }[yt.name], {
        _reducerDefinitionType: "reducer"
        /* reducer */
      });
    },
    preparedReducer(yt, ir) {
      return {
        _reducerDefinitionType: "reducerWithPrepare",
        prepare: yt,
        reducer: ir
      };
    },
    asyncThunk: pt
  };
}
function handleNormalReducerDefinition({
  type: pt,
  reducerName: yt,
  createNotation: ir
}, ti, ii) {
  let ui, ai;
  if ("reducer" in ti) {
    if (ir && !isCaseReducerWithPrepareDefinition(ti))
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(17) : "Please use the `create.preparedReducer` notation for prepared action creators with the `create` notation.");
    ui = ti.reducer, ai = ti.prepare;
  } else
    ui = ti;
  ii.addCase(pt, ui).exposeCaseReducer(yt, ui).exposeAction(yt, ai ? createAction(pt, ai) : createAction(pt));
}
function isAsyncThunkSliceReducerDefinition(pt) {
  return pt._reducerDefinitionType === "asyncThunk";
}
function isCaseReducerWithPrepareDefinition(pt) {
  return pt._reducerDefinitionType === "reducerWithPrepare";
}
function handleThunkCaseReducerDefinition({
  type: pt,
  reducerName: yt
}, ir, ti, ii) {
  if (!ii)
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(18) : "Cannot use `create.asyncThunk` in the built-in `createSlice`. Use `buildCreateSlice({ creators: { asyncThunk: asyncThunkCreator } })` to create a customised version of `createSlice`.");
  const {
    payloadCreator: ui,
    fulfilled: ai,
    pending: li,
    rejected: oi,
    settled: si,
    options: di
  } = ir, fi = ii(pt, ui, di);
  ti.exposeAction(yt, fi), ai && ti.addCase(fi.fulfilled, ai), li && ti.addCase(fi.pending, li), oi && ti.addCase(fi.rejected, oi), si && ti.addMatcher(fi.settled, si), ti.exposeCaseReducer(yt, {
    fulfilled: ai || noop$7,
    pending: li || noop$7,
    rejected: oi || noop$7,
    settled: si || noop$7
  });
}
function noop$7() {
}
var task = "task", listener = "listener", completed = "completed", cancelled = "cancelled", taskCancelled = `task-${cancelled}`, taskCompleted = `task-${completed}`, listenerCancelled = `${listener}-${cancelled}`, listenerCompleted = `${listener}-${completed}`, TaskAbortError = class {
  constructor(pt) {
    Ga(this, "name", "TaskAbortError"), Ga(this, "message"), this.code = pt, this.message = `${task} ${cancelled} (reason: ${pt})`;
  }
}, assertFunction = (pt, yt) => {
  if (typeof pt != "function")
    throw new TypeError(process.env.NODE_ENV === "production" ? formatProdErrorMessage(32) : `${yt} is not a function`);
}, noop2 = () => {
}, catchRejection = (pt, yt = noop2) => (pt.catch(yt), pt), addAbortSignalListener = (pt, yt) => (pt.addEventListener("abort", yt, {
  once: !0
}), () => pt.removeEventListener("abort", yt)), validateActive = (pt) => {
  if (pt.aborted)
    throw new TaskAbortError(pt.reason);
};
function raceWithSignal(pt, yt) {
  let ir = noop2;
  return new Promise((ti, ii) => {
    const ui = () => ii(new TaskAbortError(pt.reason));
    if (pt.aborted) {
      ui();
      return;
    }
    ir = addAbortSignalListener(pt, ui), yt.finally(() => ir()).then(ti, ii);
  }).finally(() => {
    ir = noop2;
  });
}
var runTask = async (pt, yt) => {
  try {
    return await Promise.resolve(), {
      status: "ok",
      value: await pt()
    };
  } catch (ir) {
    return {
      status: ir instanceof TaskAbortError ? "cancelled" : "rejected",
      error: ir
    };
  } finally {
    yt == null || yt();
  }
}, createPause = (pt) => (yt) => catchRejection(raceWithSignal(pt, yt).then((ir) => (validateActive(pt), ir))), createDelay = (pt) => {
  const yt = createPause(pt);
  return (ir) => yt(new Promise((ti) => setTimeout(ti, ir)));
}, {
  assign: assign$3
} = Object, INTERNAL_NIL_TOKEN = {}, alm = "listenerMiddleware", createFork = (pt, yt) => {
  const ir = (ti) => addAbortSignalListener(pt, () => ti.abort(pt.reason));
  return (ti, ii) => {
    assertFunction(ti, "taskExecutor");
    const ui = new AbortController();
    ir(ui);
    const ai = runTask(async () => {
      validateActive(pt), validateActive(ui.signal);
      const li = await ti({
        pause: createPause(ui.signal),
        delay: createDelay(ui.signal),
        signal: ui.signal
      });
      return validateActive(ui.signal), li;
    }, () => ui.abort(taskCompleted));
    return ii != null && ii.autoJoin && yt.push(ai.catch(noop2)), {
      result: createPause(pt)(ai),
      cancel() {
        ui.abort(taskCancelled);
      }
    };
  };
}, createTakePattern = (pt, yt) => {
  const ir = async (ti, ii) => {
    validateActive(yt);
    let ui = () => {
    };
    const ai = [new Promise((li, oi) => {
      let si = pt({
        predicate: ti,
        effect: (di, fi) => {
          fi.unsubscribe(), li([di, fi.getState(), fi.getOriginalState()]);
        }
      });
      ui = () => {
        si(), oi();
      };
    })];
    ii != null && ai.push(new Promise((li) => setTimeout(li, ii, null)));
    try {
      const li = await raceWithSignal(yt, Promise.race(ai));
      return validateActive(yt), li;
    } finally {
      ui();
    }
  };
  return (ti, ii) => catchRejection(ir(ti, ii));
}, getListenerEntryPropsFrom = (pt) => {
  let {
    type: yt,
    actionCreator: ir,
    matcher: ti,
    predicate: ii,
    effect: ui
  } = pt;
  if (yt)
    ii = createAction(yt).match;
  else if (ir)
    yt = ir.type, ii = ir.match;
  else if (ti)
    ii = ti;
  else if (!ii) throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(21) : "Creating or removing a listener requires one of the known fields for matching an action");
  return assertFunction(ui, "options.listener"), {
    predicate: ii,
    type: yt,
    effect: ui
  };
}, createListenerEntry = /* @__PURE__ */ assign$3((pt) => {
  const {
    type: yt,
    predicate: ir,
    effect: ti
  } = getListenerEntryPropsFrom(pt);
  return {
    id: nanoid(),
    effect: ti,
    type: yt,
    predicate: ir,
    pending: /* @__PURE__ */ new Set(),
    unsubscribe: () => {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(22) : "Unsubscribe not initialized");
    }
  };
}, {
  withTypes: () => createListenerEntry
}), findListenerEntry = (pt, yt) => {
  const {
    type: ir,
    effect: ti,
    predicate: ii
  } = getListenerEntryPropsFrom(yt);
  return Array.from(pt.values()).find((ui) => (typeof ir == "string" ? ui.type === ir : ui.predicate === ii) && ui.effect === ti);
}, cancelActiveListeners = (pt) => {
  pt.pending.forEach((yt) => {
    yt.abort(listenerCancelled);
  });
}, createClearListenerMiddleware = (pt, yt) => () => {
  for (const ir of yt.keys())
    cancelActiveListeners(ir);
  pt.clear();
}, safelyNotifyError = (pt, yt, ir) => {
  try {
    pt(yt, ir);
  } catch (ti) {
    setTimeout(() => {
      throw ti;
    }, 0);
  }
}, addListener = /* @__PURE__ */ assign$3(/* @__PURE__ */ createAction(`${alm}/add`), {
  withTypes: () => addListener
}), clearAllListeners = /* @__PURE__ */ createAction(`${alm}/removeAll`), removeListener = /* @__PURE__ */ assign$3(/* @__PURE__ */ createAction(`${alm}/remove`), {
  withTypes: () => removeListener
}), defaultErrorHandler = (...pt) => {
  console.error(`${alm}/error`, ...pt);
}, createListenerMiddleware = (pt = {}) => {
  const yt = /* @__PURE__ */ new Map(), ir = /* @__PURE__ */ new Map(), ti = (gi) => {
    const mi = ir.get(gi) ?? 0;
    ir.set(gi, mi + 1);
  }, ii = (gi) => {
    const mi = ir.get(gi) ?? 1;
    mi === 1 ? ir.delete(gi) : ir.set(gi, mi - 1);
  }, {
    extra: ui,
    onError: ai = defaultErrorHandler
  } = pt;
  assertFunction(ai, "onError");
  const li = (gi) => (gi.unsubscribe = () => yt.delete(gi.id), yt.set(gi.id, gi), (mi) => {
    gi.unsubscribe(), mi != null && mi.cancelActive && cancelActiveListeners(gi);
  }), oi = (gi) => {
    const mi = findListenerEntry(yt, gi) ?? createListenerEntry(gi);
    return li(mi);
  };
  assign$3(oi, {
    withTypes: () => oi
  });
  const si = (gi) => {
    const mi = findListenerEntry(yt, gi);
    return mi && (mi.unsubscribe(), gi.cancelActive && cancelActiveListeners(mi)), !!mi;
  };
  assign$3(si, {
    withTypes: () => si
  });
  const di = async (gi, mi, Ti, vi) => {
    const xi = new AbortController(), Si = createTakePattern(oi, xi.signal), Pi = [];
    try {
      gi.pending.add(xi), ti(gi), await Promise.resolve(gi.effect(
        mi,
        // Use assign() rather than ... to avoid extra helper functions added to bundle
        assign$3({}, Ti, {
          getOriginalState: vi,
          condition: ($i, Oi) => Si($i, Oi).then(Boolean),
          take: Si,
          delay: createDelay(xi.signal),
          pause: createPause(xi.signal),
          extra: ui,
          signal: xi.signal,
          fork: createFork(xi.signal, Pi),
          unsubscribe: gi.unsubscribe,
          subscribe: () => {
            yt.set(gi.id, gi);
          },
          cancelActiveListeners: () => {
            gi.pending.forEach(($i, Oi, Di) => {
              $i !== xi && ($i.abort(listenerCancelled), Di.delete($i));
            });
          },
          cancel: () => {
            xi.abort(listenerCancelled), gi.pending.delete(xi);
          },
          throwIfCancelled: () => {
            validateActive(xi.signal);
          }
        })
      ));
    } catch ($i) {
      $i instanceof TaskAbortError || safelyNotifyError(ai, $i, {
        raisedBy: "effect"
      });
    } finally {
      await Promise.all(Pi), xi.abort(listenerCompleted), ii(gi), gi.pending.delete(xi);
    }
  }, fi = createClearListenerMiddleware(yt, ir);
  return {
    middleware: (gi) => (mi) => (Ti) => {
      if (!isAction(Ti))
        return mi(Ti);
      if (addListener.match(Ti))
        return oi(Ti.payload);
      if (clearAllListeners.match(Ti)) {
        fi();
        return;
      }
      if (removeListener.match(Ti))
        return si(Ti.payload);
      let vi = gi.getState();
      const xi = () => {
        if (vi === INTERNAL_NIL_TOKEN)
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(23) : `${alm}: getOriginalState can only be called synchronously`);
        return vi;
      };
      let Si;
      try {
        if (Si = mi(Ti), yt.size > 0) {
          const Pi = gi.getState(), $i = Array.from(yt.values());
          for (const Oi of $i) {
            let Di = !1;
            try {
              Di = Oi.predicate(Ti, Pi, vi);
            } catch (Mi) {
              Di = !1, safelyNotifyError(ai, Mi, {
                raisedBy: "predicate"
              });
            }
            Di && di(Oi, Ti, gi, xi);
          }
        }
      } finally {
        vi = INTERNAL_NIL_TOKEN;
      }
      return Si;
    },
    startListening: oi,
    stopListening: si,
    clearListeners: fi
  };
};
function formatProdErrorMessage(pt) {
  return `Minified Redux Toolkit error #${pt}; visit https://redux-toolkit.js.org/Errors?code=${pt} for the full message or use the non-minified dev environment for full errors. `;
}
var initialState$d = {
  layoutType: "horizontal",
  width: 0,
  height: 0,
  margin: {
    top: 5,
    right: 5,
    bottom: 5,
    left: 5
  },
  scale: 1
}, chartLayoutSlice = createSlice({
  name: "chartLayout",
  initialState: initialState$d,
  reducers: {
    setLayout(pt, yt) {
      pt.layoutType = yt.payload;
    },
    setChartSize(pt, yt) {
      pt.width = yt.payload.width, pt.height = yt.payload.height;
    },
    setMargin(pt, yt) {
      var ir, ti, ii, ui;
      pt.margin.top = (ir = yt.payload.top) !== null && ir !== void 0 ? ir : 0, pt.margin.right = (ti = yt.payload.right) !== null && ti !== void 0 ? ti : 0, pt.margin.bottom = (ii = yt.payload.bottom) !== null && ii !== void 0 ? ii : 0, pt.margin.left = (ui = yt.payload.left) !== null && ui !== void 0 ? ui : 0;
    },
    setScale(pt, yt) {
      pt.scale = yt.payload;
    }
  }
}), {
  setMargin,
  setLayout,
  setChartSize,
  setScale
} = chartLayoutSlice.actions, chartLayoutReducer = chartLayoutSlice.reducer;
function getSliced(pt, yt, ir) {
  return Array.isArray(pt) && pt && yt + ir !== 0 ? pt.slice(yt, ir + 1) : pt;
}
function isWellBehavedNumber(pt) {
  return Number.isFinite(pt);
}
function ownKeys$A(pt, yt) {
  var ir = Object.keys(pt);
  if (Object.getOwnPropertySymbols) {
    var ti = Object.getOwnPropertySymbols(pt);
    yt && (ti = ti.filter(function(ii) {
      return Object.getOwnPropertyDescriptor(pt, ii).enumerable;
    })), ir.push.apply(ir, ti);
  }
  return ir;
}
function _objectSpread$A(pt) {
  for (var yt = 1; yt < arguments.length; yt++) {
    var ir = arguments[yt] != null ? arguments[yt] : {};
    yt % 2 ? ownKeys$A(Object(ir), !0).forEach(function(ti) {
      _defineProperty$C(pt, ti, ir[ti]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(pt, Object.getOwnPropertyDescriptors(ir)) : ownKeys$A(Object(ir)).forEach(function(ti) {
      Object.defineProperty(pt, ti, Object.getOwnPropertyDescriptor(ir, ti));
    });
  }
  return pt;
}
function _defineProperty$C(pt, yt, ir) {
  return (yt = _toPropertyKey$C(yt)) in pt ? Object.defineProperty(pt, yt, { value: ir, enumerable: !0, configurable: !0, writable: !0 }) : pt[yt] = ir, pt;
}
function _toPropertyKey$C(pt) {
  var yt = _toPrimitive$C(pt, "string");
  return typeof yt == "symbol" ? yt : yt + "";
}
function _toPrimitive$C(pt, yt) {
  if (typeof pt != "object" || !pt) return pt;
  var ir = pt[Symbol.toPrimitive];
  if (ir !== void 0) {
    var ti = ir.call(pt, yt);
    if (typeof ti != "object") return ti;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (yt === "string" ? String : Number)(pt);
}
function getValueByDataKey(pt, yt, ir) {
  return isNullish(pt) || isNullish(yt) ? ir : isNumOrStr(yt) ? get$1(pt, yt, ir) : typeof yt == "function" ? yt(pt) : ir;
}
var appendOffsetOfLegend = (pt, yt, ir) => {
  if (yt && ir) {
    var {
      width: ti,
      height: ii
    } = ir, {
      align: ui,
      verticalAlign: ai,
      layout: li
    } = yt;
    if ((li === "vertical" || li === "horizontal" && ai === "middle") && ui !== "center" && isNumber(pt[ui]))
      return _objectSpread$A(_objectSpread$A({}, pt), {}, {
        [ui]: pt[ui] + (ti || 0)
      });
    if ((li === "horizontal" || li === "vertical" && ui === "center") && ai !== "middle" && isNumber(pt[ai]))
      return _objectSpread$A(_objectSpread$A({}, pt), {}, {
        [ai]: pt[ai] + (ii || 0)
      });
  }
  return pt;
}, isCategoricalAxis = (pt, yt) => pt === "horizontal" && yt === "xAxis" || pt === "vertical" && yt === "yAxis" || pt === "centric" && yt === "angleAxis" || pt === "radial" && yt === "radiusAxis", truncateByDomain = (pt, yt) => {
  if (!yt || yt.length !== 2 || !isNumber(yt[0]) || !isNumber(yt[1]))
    return pt;
  var ir = Math.min(yt[0], yt[1]), ti = Math.max(yt[0], yt[1]), ii = [pt[0], pt[1]];
  return (!isNumber(pt[0]) || pt[0] < ir) && (ii[0] = ir), (!isNumber(pt[1]) || pt[1] > ti) && (ii[1] = ti), ii[0] > ti && (ii[0] = ti), ii[1] < ir && (ii[1] = ir), ii;
}, offsetSign = (pt) => {
  var yt, ir = pt.length;
  if (!(ir <= 0)) {
    var ti = (yt = pt[0]) === null || yt === void 0 ? void 0 : yt.length;
    if (!(ti == null || ti <= 0))
      for (var ii = 0; ii < ti; ++ii)
        for (var ui = 0, ai = 0, li = 0; li < ir; ++li) {
          var oi = pt[li], si = oi == null ? void 0 : oi[ii];
          if (si != null) {
            var di = si[1], fi = si[0], gi = isNan(di) ? fi : di;
            gi >= 0 ? (si[0] = ui, ui += gi, si[1] = ui) : (si[0] = ai, ai += gi, si[1] = ai);
          }
        }
  }
}, offsetPositive = (pt) => {
  var yt, ir = pt.length;
  if (!(ir <= 0)) {
    var ti = (yt = pt[0]) === null || yt === void 0 ? void 0 : yt.length;
    if (!(ti == null || ti <= 0))
      for (var ii = 0; ii < ti; ++ii)
        for (var ui = 0, ai = 0; ai < ir; ++ai) {
          var li = pt[ai], oi = li == null ? void 0 : li[ii];
          if (oi != null) {
            var si = isNan(oi[1]) ? oi[0] : oi[1];
            si >= 0 ? (oi[0] = ui, ui += si, oi[1] = ui) : (oi[0] = 0, oi[1] = 0);
          }
        }
  }
}, STACK_OFFSET_MAP = {
  sign: offsetSign,
  // @ts-expect-error definitelytyped types are incorrect
  expand: stackOffsetExpand,
  // @ts-expect-error definitelytyped types are incorrect
  none: stackOffsetNone,
  // @ts-expect-error definitelytyped types are incorrect
  silhouette: stackOffsetSilhouette,
  // @ts-expect-error definitelytyped types are incorrect
  wiggle: stackOffsetWiggle,
  positive: offsetPositive
}, getStackedData = (pt, yt, ir) => {
  var ti, ii = (ti = STACK_OFFSET_MAP[ir]) !== null && ti !== void 0 ? ti : stackOffsetNone, ui = shapeStack().keys(yt).value((li, oi) => Number(getValueByDataKey(li, oi, 0))).order(stackOrderNone).offset(ii), ai = ui(pt);
  return ai.forEach((li, oi) => {
    li.forEach((si, di) => {
      var fi = getValueByDataKey(pt[di], yt[oi], 0);
      Array.isArray(fi) && fi.length === 2 && isNumber(fi[0]) && isNumber(fi[1]) && (si[0] = fi[0], si[1] = fi[1]);
    });
  }), ai;
};
function getNormalizedStackId(pt) {
  return pt == null ? void 0 : String(pt);
}
var getCateCoordinateOfBar = (pt) => {
  var {
    axis: yt,
    ticks: ir,
    offset: ti,
    bandSize: ii,
    entry: ui,
    index: ai
  } = pt;
  if (yt.type === "category")
    return ir[ai] ? ir[ai].coordinate + ti : null;
  var li = getValueByDataKey(ui, yt.dataKey, yt.scale.domain()[ai]);
  if (isNullish(li))
    return null;
  var oi = yt.scale.map(li);
  return isNumber(oi) ? oi - ii / 2 + ti : null;
}, getBaseValueOfBar = (pt) => {
  var {
    numericAxis: yt
  } = pt, ir = yt.scale.domain();
  if (yt.type === "number") {
    var ti = Math.min(ir[0], ir[1]), ii = Math.max(ir[0], ir[1]);
    return ti <= 0 && ii >= 0 ? 0 : ii < 0 ? ii : ti;
  }
  return ir[0];
}, getDomainOfSingle = (pt) => {
  var yt = pt.flat(2).filter(isNumber);
  return [Math.min(...yt), Math.max(...yt)];
}, makeDomainFinite = (pt) => [pt[0] === 1 / 0 ? 0 : pt[0], pt[1] === -1 / 0 ? 0 : pt[1]], getDomainOfStackGroups = (pt, yt, ir) => {
  if (pt != null)
    return makeDomainFinite(Object.keys(pt).reduce((ti, ii) => {
      var ui = pt[ii];
      if (!ui)
        return ti;
      var {
        stackedData: ai
      } = ui, li = ai.reduce((oi, si) => {
        var di = getSliced(si, yt, ir), fi = getDomainOfSingle(di);
        return !isWellBehavedNumber(fi[0]) || !isWellBehavedNumber(fi[1]) ? oi : [Math.min(oi[0], fi[0]), Math.max(oi[1], fi[1])];
      }, [1 / 0, -1 / 0]);
      return [Math.min(li[0], ti[0]), Math.max(li[1], ti[1])];
    }, [1 / 0, -1 / 0]));
}, MIN_VALUE_REG = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, MAX_VALUE_REG = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, getBandSizeOfAxis = (pt, yt, ir) => {
  if (pt && pt.scale && pt.scale.bandwidth) {
    var ti = pt.scale.bandwidth();
    if (!ir || ti > 0)
      return ti;
  }
  if (pt && yt && yt.length >= 2) {
    for (var ii = sortBy$1(yt, (di) => di.coordinate), ui = 1 / 0, ai = 1, li = ii.length; ai < li; ai++) {
      var oi = ii[ai], si = ii[ai - 1];
      ui = Math.min(((oi == null ? void 0 : oi.coordinate) || 0) - ((si == null ? void 0 : si.coordinate) || 0), ui);
    }
    return ui === 1 / 0 ? 0 : ui;
  }
  return ir ? void 0 : 0;
};
function getTooltipEntry(pt) {
  var {
    tooltipEntrySettings: yt,
    dataKey: ir,
    payload: ti,
    value: ii,
    name: ui
  } = pt;
  return _objectSpread$A(_objectSpread$A({}, yt), {}, {
    dataKey: ir,
    payload: ti,
    value: ii,
    name: ui
  });
}
function getTooltipNameProp(pt, yt) {
  if (pt)
    return String(pt);
  if (typeof yt == "string")
    return yt;
}
var calculateCartesianTooltipPos = (pt, yt) => {
  if (yt === "horizontal")
    return pt.relativeX;
  if (yt === "vertical")
    return pt.relativeY;
}, calculatePolarTooltipPos = (pt, yt) => yt === "centric" ? pt.angle : pt.radius, selectChartWidth = (pt) => pt.layout.width, selectChartHeight = (pt) => pt.layout.height, selectMargin = (pt) => pt.layout.margin, selectAllXAxes = createSelector((pt) => pt.cartesianAxis.xAxis, (pt) => Object.values(pt)), selectAllYAxes = createSelector((pt) => pt.cartesianAxis.yAxis, (pt) => Object.values(pt)), DATA_ITEM_INDEX_ATTRIBUTE_NAME = "data-recharts-item-index", DATA_ITEM_GRAPHICAL_ITEM_ID_ATTRIBUTE_NAME = "data-recharts-item-id", DEFAULT_Y_AXIS_WIDTH = 60;
function ownKeys$z(pt, yt) {
  var ir = Object.keys(pt);
  if (Object.getOwnPropertySymbols) {
    var ti = Object.getOwnPropertySymbols(pt);
    yt && (ti = ti.filter(function(ii) {
      return Object.getOwnPropertyDescriptor(pt, ii).enumerable;
    })), ir.push.apply(ir, ti);
  }
  return ir;
}
function _objectSpread$z(pt) {
  for (var yt = 1; yt < arguments.length; yt++) {
    var ir = arguments[yt] != null ? arguments[yt] : {};
    yt % 2 ? ownKeys$z(Object(ir), !0).forEach(function(ti) {
      _defineProperty$B(pt, ti, ir[ti]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(pt, Object.getOwnPropertyDescriptors(ir)) : ownKeys$z(Object(ir)).forEach(function(ti) {
      Object.defineProperty(pt, ti, Object.getOwnPropertyDescriptor(ir, ti));
    });
  }
  return pt;
}
function _defineProperty$B(pt, yt, ir) {
  return (yt = _toPropertyKey$B(yt)) in pt ? Object.defineProperty(pt, yt, { value: ir, enumerable: !0, configurable: !0, writable: !0 }) : pt[yt] = ir, pt;
}
function _toPropertyKey$B(pt) {
  var yt = _toPrimitive$B(pt, "string");
  return typeof yt == "symbol" ? yt : yt + "";
}
function _toPrimitive$B(pt, yt) {
  if (typeof pt != "object" || !pt) return pt;
  var ir = pt[Symbol.toPrimitive];
  if (ir !== void 0) {
    var ti = ir.call(pt, yt);
    if (typeof ti != "object") return ti;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (yt === "string" ? String : Number)(pt);
}
var selectBrushHeight = (pt) => pt.brush.height;
function selectLeftAxesOffset(pt) {
  var yt = selectAllYAxes(pt);
  return yt.reduce((ir, ti) => {
    if (ti.orientation === "left" && !ti.mirror && !ti.hide) {
      var ii = typeof ti.width == "number" ? ti.width : DEFAULT_Y_AXIS_WIDTH;
      return ir + ii;
    }
    return ir;
  }, 0);
}
function selectRightAxesOffset(pt) {
  var yt = selectAllYAxes(pt);
  return yt.reduce((ir, ti) => {
    if (ti.orientation === "right" && !ti.mirror && !ti.hide) {
      var ii = typeof ti.width == "number" ? ti.width : DEFAULT_Y_AXIS_WIDTH;
      return ir + ii;
    }
    return ir;
  }, 0);
}
function selectTopAxesOffset(pt) {
  var yt = selectAllXAxes(pt);
  return yt.reduce((ir, ti) => ti.orientation === "top" && !ti.mirror && !ti.hide ? ir + ti.height : ir, 0);
}
function selectBottomAxesOffset(pt) {
  var yt = selectAllXAxes(pt);
  return yt.reduce((ir, ti) => ti.orientation === "bottom" && !ti.mirror && !ti.hide ? ir + ti.height : ir, 0);
}
var selectChartOffsetInternal = createSelector([selectChartWidth, selectChartHeight, selectMargin, selectBrushHeight, selectLeftAxesOffset, selectRightAxesOffset, selectTopAxesOffset, selectBottomAxesOffset, selectLegendSettings, selectLegendSize], (pt, yt, ir, ti, ii, ui, ai, li, oi, si) => {
  var di = {
    left: (ir.left || 0) + ii,
    right: (ir.right || 0) + ui
  }, fi = {
    top: (ir.top || 0) + ai,
    bottom: (ir.bottom || 0) + li
  }, gi = _objectSpread$z(_objectSpread$z({}, fi), di), mi = gi.bottom;
  gi.bottom += ti, gi = appendOffsetOfLegend(gi, oi, si);
  var Ti = pt - gi.left - gi.right, vi = yt - gi.top - gi.bottom;
  return _objectSpread$z(_objectSpread$z({
    brushBottom: mi
  }, gi), {}, {
    // never return negative values for height and width
    width: Math.max(Ti, 0),
    height: Math.max(vi, 0)
  });
}), selectChartViewBox = createSelector(selectChartOffsetInternal, (pt) => ({
  x: pt.left,
  y: pt.top,
  width: pt.width,
  height: pt.height
})), selectAxisViewBox = createSelector(selectChartWidth, selectChartHeight, (pt, yt) => ({
  x: 0,
  y: 0,
  width: pt,
  height: yt
})), PanoramaContext = /* @__PURE__ */ createContext(null), useIsPanorama = () => useContext(PanoramaContext) != null, selectBrushSettings = (pt) => pt.brush, selectBrushDimensions = createSelector([selectBrushSettings, selectChartOffsetInternal, selectMargin], (pt, yt, ir) => ({
  height: pt.height,
  x: isNumber(pt.x) ? pt.x : yt.left,
  y: isNumber(pt.y) ? pt.y : yt.top + yt.height + yt.brushBottom - ((ir == null ? void 0 : ir.bottom) || 0),
  width: isNumber(pt.width) ? pt.width : yt.width
}));
function cartesianViewBoxToTrapezoid(pt) {
  if (pt)
    return {
      x: pt.x,
      y: pt.y,
      upperWidth: "upperWidth" in pt ? pt.upperWidth : pt.width,
      lowerWidth: "lowerWidth" in pt ? pt.lowerWidth : pt.width,
      width: pt.width,
      height: pt.height
    };
}
var useViewBox = () => {
  var pt, yt = useIsPanorama(), ir = useAppSelector(selectChartViewBox), ti = useAppSelector(selectBrushDimensions), ii = (pt = useAppSelector(selectBrushSettings)) === null || pt === void 0 ? void 0 : pt.padding;
  return !yt || !ti || !ii ? ir : {
    width: ti.width - ii.left - ii.right,
    height: ti.height - ii.top - ii.bottom,
    x: ii.left,
    y: ii.top
  };
}, useChartWidth = () => useAppSelector(selectChartWidth), useChartHeight = () => useAppSelector(selectChartHeight), useMargin = () => useAppSelector((pt) => pt.layout.margin), selectChartLayout = (pt) => pt.layout.layoutType, useChartLayout = () => useAppSelector(selectChartLayout), useCartesianChartLayout = () => {
  var pt = useChartLayout();
  if (pt === "horizontal" || pt === "vertical")
    return pt;
}, selectPolarChartLayout = (pt) => {
  var yt = pt.layout.layoutType;
  if (yt === "centric" || yt === "radial")
    return yt;
}, useIsInChartContext = () => {
  var pt = useChartLayout();
  return pt !== void 0;
}, NOTHING = Symbol.for("immer-nothing"), DRAFTABLE = Symbol.for("immer-draftable"), DRAFT_STATE = Symbol.for("immer-state"), errors = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(pt) {
    return `The plugin for '${pt}' has not been loaded into Immer. To enable the plugin, import and call \`enable${pt}()\` when initializing your application.`;
  },
  function(pt) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${pt}'`;
  },
  "This object has been frozen and should not be mutated",
  function(pt) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + pt;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(pt) {
    return `'current' expects a draft, got: ${pt}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(pt) {
    return `'original' expects a draft, got: ${pt}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function die(pt, ...yt) {
  if (process.env.NODE_ENV !== "production") {
    const ir = errors[pt], ti = typeof ir == "function" ? ir.apply(null, yt) : ir;
    throw new Error(`[Immer] ${ti}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${pt}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var getPrototypeOf = Object.getPrototypeOf;
function isDraft(pt) {
  return !!pt && !!pt[DRAFT_STATE];
}
function isDraftable(pt) {
  var yt;
  return pt ? isPlainObject$3(pt) || Array.isArray(pt) || !!pt[DRAFTABLE] || !!((yt = pt.constructor) != null && yt[DRAFTABLE]) || isMap(pt) || isSet(pt) : !1;
}
var objectCtorString = Object.prototype.constructor.toString();
function isPlainObject$3(pt) {
  if (!pt || typeof pt != "object")
    return !1;
  const yt = getPrototypeOf(pt);
  if (yt === null)
    return !0;
  const ir = Object.hasOwnProperty.call(yt, "constructor") && yt.constructor;
  return ir === Object ? !0 : typeof ir == "function" && Function.toString.call(ir) === objectCtorString;
}
function each(pt, yt) {
  getArchtype(pt) === 0 ? Reflect.ownKeys(pt).forEach((ir) => {
    yt(ir, pt[ir], pt);
  }) : pt.forEach((ir, ti) => yt(ti, ir, pt));
}
function getArchtype(pt) {
  const yt = pt[DRAFT_STATE];
  return yt ? yt.type_ : Array.isArray(pt) ? 1 : isMap(pt) ? 2 : isSet(pt) ? 3 : 0;
}
function has(pt, yt) {
  return getArchtype(pt) === 2 ? pt.has(yt) : Object.prototype.hasOwnProperty.call(pt, yt);
}
function set(pt, yt, ir) {
  const ti = getArchtype(pt);
  ti === 2 ? pt.set(yt, ir) : ti === 3 ? pt.add(ir) : pt[yt] = ir;
}
function is$2(pt, yt) {
  return pt === yt ? pt !== 0 || 1 / pt === 1 / yt : pt !== pt && yt !== yt;
}
function isMap(pt) {
  return pt instanceof Map;
}
function isSet(pt) {
  return pt instanceof Set;
}
function latest(pt) {
  return pt.copy_ || pt.base_;
}
function shallowCopy(pt, yt) {
  if (isMap(pt))
    return new Map(pt);
  if (isSet(pt))
    return new Set(pt);
  if (Array.isArray(pt))
    return Array.prototype.slice.call(pt);
  const ir = isPlainObject$3(pt);
  if (yt === !0 || yt === "class_only" && !ir) {
    const ti = Object.getOwnPropertyDescriptors(pt);
    delete ti[DRAFT_STATE];
    let ii = Reflect.ownKeys(ti);
    for (let ui = 0; ui < ii.length; ui++) {
      const ai = ii[ui], li = ti[ai];
      li.writable === !1 && (li.writable = !0, li.configurable = !0), (li.get || li.set) && (ti[ai] = {
        configurable: !0,
        writable: !0,
        // could live with !!desc.set as well here...
        enumerable: li.enumerable,
        value: pt[ai]
      });
    }
    return Object.create(getPrototypeOf(pt), ti);
  } else {
    const ti = getPrototypeOf(pt);
    if (ti !== null && ir)
      return { ...pt };
    const ii = Object.create(ti);
    return Object.assign(ii, pt);
  }
}
function freeze(pt, yt = !1) {
  return isFrozen(pt) || isDraft(pt) || !isDraftable(pt) || (getArchtype(pt) > 1 && (pt.set = pt.add = pt.clear = pt.delete = dontMutateFrozenCollections), Object.freeze(pt), yt && Object.entries(pt).forEach(([ir, ti]) => freeze(ti, !0))), pt;
}
function dontMutateFrozenCollections() {
  die(2);
}
function isFrozen(pt) {
  return Object.isFrozen(pt);
}
var plugins = {};
function getPlugin(pt) {
  const yt = plugins[pt];
  return yt || die(0, pt), yt;
}
var currentScope;
function getCurrentScope() {
  return currentScope;
}
function createScope(pt, yt) {
  return {
    drafts_: [],
    parent_: pt,
    immer_: yt,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function usePatchesInScope(pt, yt) {
  yt && (getPlugin("Patches"), pt.patches_ = [], pt.inversePatches_ = [], pt.patchListener_ = yt);
}
function revokeScope(pt) {
  leaveScope(pt), pt.drafts_.forEach(revokeDraft), pt.drafts_ = null;
}
function leaveScope(pt) {
  pt === currentScope && (currentScope = pt.parent_);
}
function enterScope(pt) {
  return currentScope = createScope(currentScope, pt);
}
function revokeDraft(pt) {
  const yt = pt[DRAFT_STATE];
  yt.type_ === 0 || yt.type_ === 1 ? yt.revoke_() : yt.revoked_ = !0;
}
function processResult(pt, yt) {
  yt.unfinalizedDrafts_ = yt.drafts_.length;
  const ir = yt.drafts_[0];
  return pt !== void 0 && pt !== ir ? (ir[DRAFT_STATE].modified_ && (revokeScope(yt), die(4)), isDraftable(pt) && (pt = finalize(yt, pt), yt.parent_ || maybeFreeze(yt, pt)), yt.patches_ && getPlugin("Patches").generateReplacementPatches_(
    ir[DRAFT_STATE].base_,
    pt,
    yt.patches_,
    yt.inversePatches_
  )) : pt = finalize(yt, ir, []), revokeScope(yt), yt.patches_ && yt.patchListener_(yt.patches_, yt.inversePatches_), pt !== NOTHING ? pt : void 0;
}
function finalize(pt, yt, ir) {
  if (isFrozen(yt))
    return yt;
  const ti = yt[DRAFT_STATE];
  if (!ti)
    return each(
      yt,
      (ii, ui) => finalizeProperty(pt, ti, yt, ii, ui, ir)
    ), yt;
  if (ti.scope_ !== pt)
    return yt;
  if (!ti.modified_)
    return maybeFreeze(pt, ti.base_, !0), ti.base_;
  if (!ti.finalized_) {
    ti.finalized_ = !0, ti.scope_.unfinalizedDrafts_--;
    const ii = ti.copy_;
    let ui = ii, ai = !1;
    ti.type_ === 3 && (ui = new Set(ii), ii.clear(), ai = !0), each(
      ui,
      (li, oi) => finalizeProperty(pt, ti, ii, li, oi, ir, ai)
    ), maybeFreeze(pt, ii, !1), ir && pt.patches_ && getPlugin("Patches").generatePatches_(
      ti,
      ir,
      pt.patches_,
      pt.inversePatches_
    );
  }
  return ti.copy_;
}
function finalizeProperty(pt, yt, ir, ti, ii, ui, ai) {
  if (process.env.NODE_ENV !== "production" && ii === ir && die(5), isDraft(ii)) {
    const li = ui && yt && yt.type_ !== 3 && // Set objects are atomic since they have no keys.
    !has(yt.assigned_, ti) ? ui.concat(ti) : void 0, oi = finalize(pt, ii, li);
    if (set(ir, ti, oi), isDraft(oi))
      pt.canAutoFreeze_ = !1;
    else
      return;
  } else ai && ir.add(ii);
  if (isDraftable(ii) && !isFrozen(ii)) {
    if (!pt.immer_.autoFreeze_ && pt.unfinalizedDrafts_ < 1)
      return;
    finalize(pt, ii), (!yt || !yt.scope_.parent_) && typeof ti != "symbol" && Object.prototype.propertyIsEnumerable.call(ir, ti) && maybeFreeze(pt, ii);
  }
}
function maybeFreeze(pt, yt, ir = !1) {
  !pt.parent_ && pt.immer_.autoFreeze_ && pt.canAutoFreeze_ && freeze(yt, ir);
}
function createProxyProxy(pt, yt) {
  const ir = Array.isArray(pt), ti = {
    type_: ir ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: yt ? yt.scope_ : getCurrentScope(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: yt,
    // The base state.
    base_: pt,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let ii = ti, ui = objectTraps;
  ir && (ii = [ti], ui = arrayTraps);
  const { revoke: ai, proxy: li } = Proxy.revocable(ii, ui);
  return ti.draft_ = li, ti.revoke_ = ai, li;
}
var objectTraps = {
  get(pt, yt) {
    if (yt === DRAFT_STATE)
      return pt;
    const ir = latest(pt);
    if (!has(ir, yt))
      return readPropFromProto(pt, ir, yt);
    const ti = ir[yt];
    return pt.finalized_ || !isDraftable(ti) ? ti : ti === peek$4(pt.base_, yt) ? (prepareCopy(pt), pt.copy_[yt] = createProxy(ti, pt)) : ti;
  },
  has(pt, yt) {
    return yt in latest(pt);
  },
  ownKeys(pt) {
    return Reflect.ownKeys(latest(pt));
  },
  set(pt, yt, ir) {
    const ti = getDescriptorFromProto(latest(pt), yt);
    if (ti != null && ti.set)
      return ti.set.call(pt.draft_, ir), !0;
    if (!pt.modified_) {
      const ii = peek$4(latest(pt), yt), ui = ii == null ? void 0 : ii[DRAFT_STATE];
      if (ui && ui.base_ === ir)
        return pt.copy_[yt] = ir, pt.assigned_[yt] = !1, !0;
      if (is$2(ir, ii) && (ir !== void 0 || has(pt.base_, yt)))
        return !0;
      prepareCopy(pt), markChanged(pt);
    }
    return pt.copy_[yt] === ir && // special case: handle new props with value 'undefined'
    (ir !== void 0 || yt in pt.copy_) || // special case: NaN
    Number.isNaN(ir) && Number.isNaN(pt.copy_[yt]) || (pt.copy_[yt] = ir, pt.assigned_[yt] = !0), !0;
  },
  deleteProperty(pt, yt) {
    return peek$4(pt.base_, yt) !== void 0 || yt in pt.base_ ? (pt.assigned_[yt] = !1, prepareCopy(pt), markChanged(pt)) : delete pt.assigned_[yt], pt.copy_ && delete pt.copy_[yt], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(pt, yt) {
    const ir = latest(pt), ti = Reflect.getOwnPropertyDescriptor(ir, yt);
    return ti && {
      writable: !0,
      configurable: pt.type_ !== 1 || yt !== "length",
      enumerable: ti.enumerable,
      value: ir[yt]
    };
  },
  defineProperty() {
    die(11);
  },
  getPrototypeOf(pt) {
    return getPrototypeOf(pt.base_);
  },
  setPrototypeOf() {
    die(12);
  }
}, arrayTraps = {};
each(objectTraps, (pt, yt) => {
  arrayTraps[pt] = function() {
    return arguments[0] = arguments[0][0], yt.apply(this, arguments);
  };
});
arrayTraps.deleteProperty = function(pt, yt) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(yt)) && die(13), arrayTraps.set.call(this, pt, yt, void 0);
};
arrayTraps.set = function(pt, yt, ir) {
  return process.env.NODE_ENV !== "production" && yt !== "length" && isNaN(parseInt(yt)) && die(14), objectTraps.set.call(this, pt[0], yt, ir, pt[0]);
};
function peek$4(pt, yt) {
  const ir = pt[DRAFT_STATE];
  return (ir ? latest(ir) : pt)[yt];
}
function readPropFromProto(pt, yt, ir) {
  var ti;
  const ii = getDescriptorFromProto(yt, ir);
  return ii ? "value" in ii ? ii.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (ti = ii.get) == null ? void 0 : ti.call(pt.draft_)
  ) : void 0;
}
function getDescriptorFromProto(pt, yt) {
  if (!(yt in pt))
    return;
  let ir = getPrototypeOf(pt);
  for (; ir; ) {
    const ti = Object.getOwnPropertyDescriptor(ir, yt);
    if (ti)
      return ti;
    ir = getPrototypeOf(ir);
  }
}
function markChanged(pt) {
  pt.modified_ || (pt.modified_ = !0, pt.parent_ && markChanged(pt.parent_));
}
function prepareCopy(pt) {
  pt.copy_ || (pt.copy_ = shallowCopy(
    pt.base_,
    pt.scope_.immer_.useStrictShallowCopy_
  ));
}
var Immer2 = class {
  constructor(pt) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.produce = (yt, ir, ti) => {
      if (typeof yt == "function" && typeof ir != "function") {
        const ui = ir;
        ir = yt;
        const ai = this;
        return function(li = ui, ...oi) {
          return ai.produce(li, (si) => ir.call(this, si, ...oi));
        };
      }
      typeof ir != "function" && die(6), ti !== void 0 && typeof ti != "function" && die(7);
      let ii;
      if (isDraftable(yt)) {
        const ui = enterScope(this), ai = createProxy(yt, void 0);
        let li = !0;
        try {
          ii = ir(ai), li = !1;
        } finally {
          li ? revokeScope(ui) : leaveScope(ui);
        }
        return usePatchesInScope(ui, ti), processResult(ii, ui);
      } else if (!yt || typeof yt != "object") {
        if (ii = ir(yt), ii === void 0 && (ii = yt), ii === NOTHING && (ii = void 0), this.autoFreeze_ && freeze(ii, !0), ti) {
          const ui = [], ai = [];
          getPlugin("Patches").generateReplacementPatches_(yt, ii, ui, ai), ti(ui, ai);
        }
        return ii;
      } else
        die(1, yt);
    }, this.produceWithPatches = (yt, ir) => {
      if (typeof yt == "function")
        return (ui, ...ai) => this.produceWithPatches(ui, (li) => yt(li, ...ai));
      let ti, ii;
      return [this.produce(yt, ir, (ui, ai) => {
        ti = ui, ii = ai;
      }), ti, ii];
    }, typeof (pt == null ? void 0 : pt.autoFreeze) == "boolean" && this.setAutoFreeze(pt.autoFreeze), typeof (pt == null ? void 0 : pt.useStrictShallowCopy) == "boolean" && this.setUseStrictShallowCopy(pt.useStrictShallowCopy);
  }
  createDraft(pt) {
    isDraftable(pt) || die(8), isDraft(pt) && (pt = current(pt));
    const yt = enterScope(this), ir = createProxy(pt, void 0);
    return ir[DRAFT_STATE].isManual_ = !0, leaveScope(yt), ir;
  }
  finishDraft(pt, yt) {
    const ir = pt && pt[DRAFT_STATE];
    (!ir || !ir.isManual_) && die(9);
    const { scope_: ti } = ir;
    return usePatchesInScope(ti, yt), processResult(void 0, ti);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(pt) {
    this.autoFreeze_ = pt;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(pt) {
    this.useStrictShallowCopy_ = pt;
  }
  applyPatches(pt, yt) {
    let ir;
    for (ir = yt.length - 1; ir >= 0; ir--) {
      const ii = yt[ir];
      if (ii.path.length === 0 && ii.op === "replace") {
        pt = ii.value;
        break;
      }
    }
    ir > -1 && (yt = yt.slice(ir + 1));
    const ti = getPlugin("Patches").applyPatches_;
    return isDraft(pt) ? ti(pt, yt) : this.produce(
      pt,
      (ii) => ti(ii, yt)
    );
  }
};
function createProxy(pt, yt) {
  const ir = isMap(pt) ? getPlugin("MapSet").proxyMap_(pt, yt) : isSet(pt) ? getPlugin("MapSet").proxySet_(pt, yt) : createProxyProxy(pt, yt);
  return (yt ? yt.scope_ : getCurrentScope()).drafts_.push(ir), ir;
}
function current(pt) {
  return isDraft(pt) || die(10, pt), currentImpl(pt);
}
function currentImpl(pt) {
  if (!isDraftable(pt) || isFrozen(pt))
    return pt;
  const yt = pt[DRAFT_STATE];
  let ir;
  if (yt) {
    if (!yt.modified_)
      return yt.base_;
    yt.finalized_ = !0, ir = shallowCopy(pt, yt.scope_.immer_.useStrictShallowCopy_);
  } else
    ir = shallowCopy(pt, !0);
  return each(ir, (ti, ii) => {
    set(ir, ti, currentImpl(ii));
  }), yt && (yt.finalized_ = !1), ir;
}
var immer = new Immer2();
immer.produce;
immer.produceWithPatches.bind(
  immer
);
immer.setAutoFreeze.bind(immer);
immer.setUseStrictShallowCopy.bind(immer);
immer.applyPatches.bind(immer);
immer.createDraft.bind(immer);
immer.finishDraft.bind(immer);
var initialState$c = {
  settings: {
    layout: "horizontal",
    align: "center",
    verticalAlign: "middle",
    itemSorter: "value"
  },
  size: {
    width: 0,
    height: 0
  },
  payload: []
}, legendSlice = createSlice({
  name: "legend",
  initialState: initialState$c,
  reducers: {
    setLegendSize(pt, yt) {
      pt.size.width = yt.payload.width, pt.size.height = yt.payload.height;
    },
    setLegendSettings(pt, yt) {
      pt.settings.align = yt.payload.align, pt.settings.layout = yt.payload.layout, pt.settings.verticalAlign = yt.payload.verticalAlign, pt.settings.itemSorter = yt.payload.itemSorter;
    },
    addLegendPayload: {
      reducer(pt, yt) {
        pt.payload.push(yt.payload);
      },
      prepare: prepareAutoBatched()
    },
    replaceLegendPayload: {
      reducer(pt, yt) {
        var {
          prev: ir,
          next: ti
        } = yt.payload, ii = current$1(pt).payload.indexOf(ir);
        ii > -1 && (pt.payload[ii] = ti);
      },
      prepare: prepareAutoBatched()
    },
    removeLegendPayload: {
      reducer(pt, yt) {
        var ir = current$1(pt).payload.indexOf(yt.payload);
        ir > -1 && pt.payload.splice(ir, 1);
      },
      prepare: prepareAutoBatched()
    }
  }
}), {
  setLegendSize,
  setLegendSettings,
  addLegendPayload,
  replaceLegendPayload,
  removeLegendPayload
} = legendSlice.actions, legendReducer = legendSlice.reducer, withSelector = { exports: {} }, useSyncExternalStoreWithSelector_production = {};
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredUseSyncExternalStoreWithSelector_production;
function requireUseSyncExternalStoreWithSelector_production() {
  if (hasRequiredUseSyncExternalStoreWithSelector_production) return useSyncExternalStoreWithSelector_production;
  hasRequiredUseSyncExternalStoreWithSelector_production = 1;
  var pt = React__default;
  function yt(oi, si) {
    return oi === si && (oi !== 0 || 1 / oi === 1 / si) || oi !== oi && si !== si;
  }
  var ir = typeof Object.is == "function" ? Object.is : yt, ti = pt.useSyncExternalStore, ii = pt.useRef, ui = pt.useEffect, ai = pt.useMemo, li = pt.useDebugValue;
  return useSyncExternalStoreWithSelector_production.useSyncExternalStoreWithSelector = function(oi, si, di, fi, gi) {
    var mi = ii(null);
    if (mi.current === null) {
      var Ti = { hasValue: !1, value: null };
      mi.current = Ti;
    } else Ti = mi.current;
    mi = ai(
      function() {
        function xi(Di) {
          if (!Si) {
            if (Si = !0, Pi = Di, Di = fi(Di), gi !== void 0 && Ti.hasValue) {
              var Mi = Ti.value;
              if (gi(Mi, Di))
                return $i = Mi;
            }
            return $i = Di;
          }
          if (Mi = $i, ir(Pi, Di)) return Mi;
          var Oo = fi(Di);
          return gi !== void 0 && gi(Mi, Oo) ? (Pi = Di, Mi) : (Pi = Di, $i = Oo);
        }
        var Si = !1, Pi, $i, Oi = di === void 0 ? null : di;
        return [
          function() {
            return xi(si());
          },
          Oi === null ? void 0 : function() {
            return xi(Oi());
          }
        ];
      },
      [si, di, fi, gi]
    );
    var vi = ti(oi, mi[0], mi[1]);
    return ui(
      function() {
        Ti.hasValue = !0, Ti.value = vi;
      },
      [vi]
    ), li(vi), vi;
  }, useSyncExternalStoreWithSelector_production;
}
var useSyncExternalStoreWithSelector_development = {};
/**
 * @license React
 * use-sync-external-store-with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredUseSyncExternalStoreWithSelector_development;
function requireUseSyncExternalStoreWithSelector_development() {
  return hasRequiredUseSyncExternalStoreWithSelector_development || (hasRequiredUseSyncExternalStoreWithSelector_development = 1, process.env.NODE_ENV !== "production" && (function() {
    function pt(oi, si) {
      return oi === si && (oi !== 0 || 1 / oi === 1 / si) || oi !== oi && si !== si;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var yt = React__default, ir = typeof Object.is == "function" ? Object.is : pt, ti = yt.useSyncExternalStore, ii = yt.useRef, ui = yt.useEffect, ai = yt.useMemo, li = yt.useDebugValue;
    useSyncExternalStoreWithSelector_development.useSyncExternalStoreWithSelector = function(oi, si, di, fi, gi) {
      var mi = ii(null);
      if (mi.current === null) {
        var Ti = { hasValue: !1, value: null };
        mi.current = Ti;
      } else Ti = mi.current;
      mi = ai(
        function() {
          function xi(Di) {
            if (!Si) {
              if (Si = !0, Pi = Di, Di = fi(Di), gi !== void 0 && Ti.hasValue) {
                var Mi = Ti.value;
                if (gi(Mi, Di))
                  return $i = Mi;
              }
              return $i = Di;
            }
            if (Mi = $i, ir(Pi, Di))
              return Mi;
            var Oo = fi(Di);
            return gi !== void 0 && gi(Mi, Oo) ? (Pi = Di, Mi) : (Pi = Di, $i = Oo);
          }
          var Si = !1, Pi, $i, Oi = di === void 0 ? null : di;
          return [
            function() {
              return xi(si());
            },
            Oi === null ? void 0 : function() {
              return xi(Oi());
            }
          ];
        },
        [si, di, fi, gi]
      );
      var vi = ti(oi, mi[0], mi[1]);
      return ui(
        function() {
          Ti.hasValue = !0, Ti.value = vi;
        },
        [vi]
      ), li(vi), vi;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), useSyncExternalStoreWithSelector_development;
}
var hasRequiredWithSelector;
function requireWithSelector() {
  return hasRequiredWithSelector || (hasRequiredWithSelector = 1, process.env.NODE_ENV === "production" ? withSelector.exports = requireUseSyncExternalStoreWithSelector_production() : withSelector.exports = requireUseSyncExternalStoreWithSelector_development()), withSelector.exports;
}
requireWithSelector();
function is$1(pt, yt) {
  return pt === yt ? pt !== 0 || yt !== 0 || 1 / pt === 1 / yt : pt !== pt && yt !== yt;
}
function shallowEqual(pt, yt) {
  if (is$1(pt, yt)) return !0;
  if (typeof pt != "object" || pt === null || typeof yt != "object" || yt === null)
    return !1;
  const ir = Object.keys(pt), ti = Object.keys(yt);
  if (ir.length !== ti.length) return !1;
  for (let ii = 0; ii < ir.length; ii++)
    if (!Object.prototype.hasOwnProperty.call(yt, ir[ii]) || !is$1(pt[ir[ii]], yt[ir[ii]]))
      return !1;
  return !0;
}
var propsToShallowCompare = /* @__PURE__ */ new Set([
  "axisLine",
  "tickLine",
  "activeBar",
  "activeDot",
  "activeLabel",
  "activeShape",
  "allowEscapeViewBox",
  "background",
  "cursor",
  "dot",
  "label",
  "line",
  "margin",
  "padding",
  "position",
  "shape",
  "style",
  "tick",
  "wrapperStyle",
  // radius can be an array of 4 numbers, easy to compare shallowly
  "radius",
  "throttledEvents"
]);
function sameValueZero(pt, yt) {
  return pt == null && yt == null ? !0 : typeof pt == "number" && typeof yt == "number" ? pt === yt || pt !== pt && yt !== yt : pt === yt;
}
function propsAreEqual(pt, yt) {
  var ir = /* @__PURE__ */ new Set([...Object.keys(pt), ...Object.keys(yt)]);
  for (var ti of ir)
    if (propsToShallowCompare.has(ti)) {
      if (pt[ti] == null && yt[ti] == null)
        continue;
      if (!shallowEqual(pt[ti], yt[ti]))
        return !1;
    } else if (!sameValueZero(pt[ti], yt[ti]))
      return !1;
  return !0;
}
var _excluded$h = ["contextPayload"];
function _extends$k() {
  return _extends$k = Object.assign ? Object.assign.bind() : function(pt) {
    for (var yt = 1; yt < arguments.length; yt++) {
      var ir = arguments[yt];
      for (var ti in ir) ({}).hasOwnProperty.call(ir, ti) && (pt[ti] = ir[ti]);
    }
    return pt;
  }, _extends$k.apply(null, arguments);
}
function ownKeys$x(pt, yt) {
  var ir = Object.keys(pt);
  if (Object.getOwnPropertySymbols) {
    var ti = Object.getOwnPropertySymbols(pt);
    yt && (ti = ti.filter(function(ii) {
      return Object.getOwnPropertyDescriptor(pt, ii).enumerable;
    })), ir.push.apply(ir, ti);
  }
  return ir;
}
function _objectSpread$x(pt) {
  for (var yt = 1; yt < arguments.length; yt++) {
    var ir = arguments[yt] != null ? arguments[yt] : {};
    yt % 2 ? ownKeys$x(Object(ir), !0).forEach(function(ti) {
      _defineProperty$z(pt, ti, ir[ti]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(pt, Object.getOwnPropertyDescriptors(ir)) : ownKeys$x(Object(ir)).forEach(function(ti) {
      Object.defineProperty(pt, ti, Object.getOwnPropertyDescriptor(ir, ti));
    });
  }
  return pt;
}
function _defineProperty$z(pt, yt, ir) {
  return (yt = _toPropertyKey$z(yt)) in pt ? Object.defineProperty(pt, yt, { value: ir, enumerable: !0, configurable: !0, writable: !0 }) : pt[yt] = ir, pt;
}
function _toPropertyKey$z(pt) {
  var yt = _toPrimitive$z(pt, "string");
  return typeof yt == "symbol" ? yt : yt + "";
}
function _toPrimitive$z(pt, yt) {
  if (typeof pt != "object" || !pt) return pt;
  var ir = pt[Symbol.toPrimitive];
  if (ir !== void 0) {
    var ti = ir.call(pt, yt);
    if (typeof ti != "object") return ti;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (yt === "string" ? String : Number)(pt);
}
function _objectWithoutProperties$h(pt, yt) {
  if (pt == null) return {};
  var ir, ti, ii = _objectWithoutPropertiesLoose$h(pt, yt);
  if (Object.getOwnPropertySymbols) {
    var ui = Object.getOwnPropertySymbols(pt);
    for (ti = 0; ti < ui.length; ti++) ir = ui[ti], yt.indexOf(ir) === -1 && {}.propertyIsEnumerable.call(pt, ir) && (ii[ir] = pt[ir]);
  }
  return ii;
}
function _objectWithoutPropertiesLoose$h(pt, yt) {
  if (pt == null) return {};
  var ir = {};
  for (var ti in pt) if ({}.hasOwnProperty.call(pt, ti)) {
    if (yt.indexOf(ti) !== -1) continue;
    ir[ti] = pt[ti];
  }
  return ir;
}
function defaultUniqBy$1(pt) {
  return pt.value;
}
function LegendContent(pt) {
  var {
    contextPayload: yt
  } = pt, ir = _objectWithoutProperties$h(pt, _excluded$h), ti = getUniqPayload(yt, pt.payloadUniqBy, defaultUniqBy$1), ii = _objectSpread$x(_objectSpread$x({}, ir), {}, {
    payload: ti
  });
  return /* @__PURE__ */ React.isValidElement(pt.content) ? /* @__PURE__ */ React.cloneElement(pt.content, ii) : typeof pt.content == "function" ? /* @__PURE__ */ React.createElement(pt.content, ii) : /* @__PURE__ */ React.createElement(DefaultLegendContent, ii);
}
function getDefaultPosition(pt, yt, ir, ti, ii, ui) {
  var {
    layout: ai,
    align: li,
    verticalAlign: oi
  } = yt, si, di;
  return (!pt || (pt.left === void 0 || pt.left === null) && (pt.right === void 0 || pt.right === null)) && (li === "center" && ai === "vertical" ? si = {
    left: ((ti || 0) - ui.width) / 2
  } : si = li === "right" ? {
    right: ir && ir.right || 0
  } : {
    left: ir && ir.left || 0
  }), (!pt || (pt.top === void 0 || pt.top === null) && (pt.bottom === void 0 || pt.bottom === null)) && (oi === "middle" ? di = {
    top: ((ii || 0) - ui.height) / 2
  } : di = oi === "bottom" ? {
    bottom: ir && ir.bottom || 0
  } : {
    top: ir && ir.top || 0
  }), _objectSpread$x(_objectSpread$x({}, si), di);
}
function LegendSettingsDispatcher(pt) {
  var yt = useAppDispatch();
  return useEffect(() => {
    yt(setLegendSettings(pt));
  }, [yt, pt]), null;
}
function LegendSizeDispatcher(pt) {
  var yt = useAppDispatch();
  return useEffect(() => (yt(setLegendSize(pt)), () => {
    yt(setLegendSize({
      width: 0,
      height: 0
    }));
  }), [yt, pt]), null;
}
function getWidthOrHeight(pt, yt, ir, ti) {
  return pt === "vertical" && yt != null ? {
    height: yt
  } : pt === "horizontal" ? {
    width: ir || ti
  } : null;
}
var legendDefaultProps = {
  align: "center",
  iconSize: 14,
  inactiveColor: "#ccc",
  itemSorter: "value",
  layout: "horizontal",
  verticalAlign: "bottom"
};
function LegendImpl(pt) {
  var yt = resolveDefaultProps(pt, legendDefaultProps), ir = useLegendPayload(), ti = useLegendPortal(), ii = useMargin(), {
    width: ui,
    height: ai,
    wrapperStyle: li,
    portal: oi
  } = yt, [si, di] = useElementOffset([ir]), fi = useChartWidth(), gi = useChartHeight();
  if (fi == null || gi == null)
    return null;
  var mi = fi - ((ii == null ? void 0 : ii.left) || 0) - ((ii == null ? void 0 : ii.right) || 0), Ti = getWidthOrHeight(yt.layout, ai, ui, mi), vi = oi ? li : _objectSpread$x(_objectSpread$x({
    position: "absolute",
    width: (Ti == null ? void 0 : Ti.width) || ui || "auto",
    height: (Ti == null ? void 0 : Ti.height) || ai || "auto"
  }, getDefaultPosition(li, yt, ii, fi, gi, si)), li), xi = oi ?? ti;
  if (xi == null || ir == null)
    return null;
  var Si = /* @__PURE__ */ React.createElement("div", {
    className: "recharts-legend-wrapper",
    style: vi,
    ref: di
  }, /* @__PURE__ */ React.createElement(LegendSettingsDispatcher, {
    layout: yt.layout,
    align: yt.align,
    verticalAlign: yt.verticalAlign,
    itemSorter: yt.itemSorter
  }), !oi && /* @__PURE__ */ React.createElement(LegendSizeDispatcher, {
    width: si.width,
    height: si.height
  }), /* @__PURE__ */ React.createElement(LegendContent, _extends$k({}, yt, Ti, {
    margin: ii,
    chartWidth: fi,
    chartHeight: gi,
    contextPayload: ir
  })));
  return /* @__PURE__ */ createPortal(Si, xi);
}
var Legend = /* @__PURE__ */ React.memo(LegendImpl, propsAreEqual);
Legend.displayName = "Legend";
var parseIsSsrByDefault = () => !(typeof window < "u" && window.document && window.document.createElement && window.setTimeout), Global = {
  isSsr: parseIsSsrByDefault()
};
function usePrefersReducedMotion() {
  var [pt, yt] = useState(() => Global.isSsr || !window.matchMedia ? !1 : window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  return useEffect(() => {
    if (window.matchMedia) {
      var ir = window.matchMedia("(prefers-reduced-motion: reduce)"), ti = () => {
        yt(ir.matches);
      };
      return ir.addEventListener("change", ti), () => {
        ir.removeEventListener("change", ti);
      };
    }
  }, []), pt;
}
function _extends$i() {
  return _extends$i = Object.assign ? Object.assign.bind() : function(pt) {
    for (var yt = 1; yt < arguments.length; yt++) {
      var ir = arguments[yt];
      for (var ti in ir) ({}).hasOwnProperty.call(ir, ti) && (pt[ti] = ir[ti]);
    }
    return pt;
  }, _extends$i.apply(null, arguments);
}
function ownKeys$u(pt, yt) {
  var ir = Object.keys(pt);
  if (Object.getOwnPropertySymbols) {
    var ti = Object.getOwnPropertySymbols(pt);
    yt && (ti = ti.filter(function(ii) {
      return Object.getOwnPropertyDescriptor(pt, ii).enumerable;
    })), ir.push.apply(ir, ti);
  }
  return ir;
}
function _objectSpread$u(pt) {
  for (var yt = 1; yt < arguments.length; yt++) {
    var ir = arguments[yt] != null ? arguments[yt] : {};
    yt % 2 ? ownKeys$u(Object(ir), !0).forEach(function(ti) {
      _defineProperty$w(pt, ti, ir[ti]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(pt, Object.getOwnPropertyDescriptors(ir)) : ownKeys$u(Object(ir)).forEach(function(ti) {
      Object.defineProperty(pt, ti, Object.getOwnPropertyDescriptor(ir, ti));
    });
  }
  return pt;
}
function _defineProperty$w(pt, yt, ir) {
  return (yt = _toPropertyKey$w(yt)) in pt ? Object.defineProperty(pt, yt, { value: ir, enumerable: !0, configurable: !0, writable: !0 }) : pt[yt] = ir, pt;
}
function _toPropertyKey$w(pt) {
  var yt = _toPrimitive$w(pt, "string");
  return typeof yt == "symbol" ? yt : yt + "";
}
function _toPrimitive$w(pt, yt) {
  if (typeof pt != "object" || !pt) return pt;
  var ir = pt[Symbol.toPrimitive];
  if (ir !== void 0) {
    var ti = ir.call(pt, yt);
    if (typeof ti != "object") return ti;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (yt === "string" ? String : Number)(pt);
}
var CURVE_FACTORIES = {
  curveBasisClosed,
  curveBasisOpen,
  curveBasis,
  curveBumpX: bumpX,
  curveBumpY: bumpY,
  curveLinearClosed,
  curveLinear,
  curveMonotoneX: monotoneX,
  curveMonotoneY: monotoneY,
  curveNatural,
  curveStep,
  curveStepAfter: stepAfter,
  curveStepBefore: stepBefore
}, defined = (pt) => isWellBehavedNumber(pt.x) && isWellBehavedNumber(pt.y), areaDefined = (pt) => pt.base != null && defined(pt.base) && defined(pt), getX = (pt) => pt.x, getY = (pt) => pt.y, getCurveFactory = (pt, yt) => {
  if (typeof pt == "function")
    return pt;
  var ir = "curve".concat(upperFirst(pt));
  if ((ir === "curveMonotone" || ir === "curveBump") && yt) {
    var ti = CURVE_FACTORIES["".concat(ir).concat(yt === "vertical" ? "Y" : "X")];
    if (ti)
      return ti;
  }
  return CURVE_FACTORIES[ir] || curveLinear;
}, defaultCurveProps = {
  connectNulls: !1,
  type: "linear"
}, getPath$1 = (pt) => {
  var {
    type: yt = defaultCurveProps.type,
    points: ir = [],
    baseLine: ti,
    layout: ii,
    connectNulls: ui = defaultCurveProps.connectNulls
  } = pt, ai = getCurveFactory(yt, ii), li = ui ? ir.filter(defined) : ir;
  if (Array.isArray(ti)) {
    var oi, si = ir.map((Ti, vi) => _objectSpread$u(_objectSpread$u({}, Ti), {}, {
      base: ti[vi]
    }));
    ii === "vertical" ? oi = shapeArea().y(getY).x1(getX).x0((Ti) => Ti.base.x) : oi = shapeArea().x(getX).y1(getY).y0((Ti) => Ti.base.y);
    var di = oi.defined(areaDefined).curve(ai), fi = ui ? si.filter(areaDefined) : si;
    return di(fi);
  }
  var gi;
  ii === "vertical" && isNumber(ti) ? gi = shapeArea().y(getY).x1(getX).x0(ti) : isNumber(ti) ? gi = shapeArea().x(getX).y1(getY).y0(ti) : gi = shapeLine().x(getX).y(getY);
  var mi = gi.defined(defined).curve(ai);
  return mi(li);
}, Curve = (pt) => {
  var {
    className: yt,
    points: ir,
    path: ti,
    pathRef: ii
  } = pt, ui = useChartLayout();
  if ((!ir || !ir.length) && !ti)
    return null;
  var ai = {
    type: pt.type,
    points: pt.points,
    baseLine: pt.baseLine,
    layout: pt.layout || ui,
    connectNulls: pt.connectNulls
  }, li = ir && ir.length ? getPath$1(ai) : ti;
  return /* @__PURE__ */ React.createElement("path", _extends$i({}, svgPropertiesNoEvents(pt), adaptEventHandlers(pt), {
    className: clsx$1("recharts-curve", yt),
    d: li === null ? void 0 : li,
    ref: ii
  }));
};
function ownKeys$s(pt, yt) {
  var ir = Object.keys(pt);
  if (Object.getOwnPropertySymbols) {
    var ti = Object.getOwnPropertySymbols(pt);
    yt && (ti = ti.filter(function(ii) {
      return Object.getOwnPropertyDescriptor(pt, ii).enumerable;
    })), ir.push.apply(ir, ti);
  }
  return ir;
}
function _objectSpread$s(pt) {
  for (var yt = 1; yt < arguments.length; yt++) {
    var ir = arguments[yt] != null ? arguments[yt] : {};
    yt % 2 ? ownKeys$s(Object(ir), !0).forEach(function(ti) {
      _defineProperty$u(pt, ti, ir[ti]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(pt, Object.getOwnPropertyDescriptors(ir)) : ownKeys$s(Object(ir)).forEach(function(ti) {
      Object.defineProperty(pt, ti, Object.getOwnPropertyDescriptor(ir, ti));
    });
  }
  return pt;
}
function _defineProperty$u(pt, yt, ir) {
  return (yt = _toPropertyKey$u(yt)) in pt ? Object.defineProperty(pt, yt, { value: ir, enumerable: !0, configurable: !0, writable: !0 }) : pt[yt] = ir, pt;
}
function _toPropertyKey$u(pt) {
  var yt = _toPrimitive$u(pt, "string");
  return typeof yt == "symbol" ? yt : yt + "";
}
function _toPrimitive$u(pt, yt) {
  if (typeof pt != "object" || !pt) return pt;
  var ir = pt[Symbol.toPrimitive];
  if (ir !== void 0) {
    var ti = ir.call(pt, yt);
    if (typeof ti != "object") return ti;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (yt === "string" ? String : Number)(pt);
}
var getDashCase = (pt) => pt.replace(/([A-Z])/g, (yt) => "-".concat(yt.toLowerCase())), getTransitionVal = (pt, yt, ir) => pt.map((ti) => "".concat(getDashCase(ti), " ").concat(yt, "ms ").concat(ir)).join(","), getIntersectionKeys = (pt, yt) => [Object.keys(pt), Object.keys(yt)].reduce((ir, ti) => ir.filter((ii) => ti.includes(ii))), mapObject = (pt, yt) => Object.keys(yt).reduce((ir, ti) => _objectSpread$s(_objectSpread$s({}, ir), {}, {
  [ti]: pt(ti, yt[ti])
}), {});
function ownKeys$r(pt, yt) {
  var ir = Object.keys(pt);
  if (Object.getOwnPropertySymbols) {
    var ti = Object.getOwnPropertySymbols(pt);
    yt && (ti = ti.filter(function(ii) {
      return Object.getOwnPropertyDescriptor(pt, ii).enumerable;
    })), ir.push.apply(ir, ti);
  }
  return ir;
}
function _objectSpread$r(pt) {
  for (var yt = 1; yt < arguments.length; yt++) {
    var ir = arguments[yt] != null ? arguments[yt] : {};
    yt % 2 ? ownKeys$r(Object(ir), !0).forEach(function(ti) {
      _defineProperty$t(pt, ti, ir[ti]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(pt, Object.getOwnPropertyDescriptors(ir)) : ownKeys$r(Object(ir)).forEach(function(ti) {
      Object.defineProperty(pt, ti, Object.getOwnPropertyDescriptor(ir, ti));
    });
  }
  return pt;
}
function _defineProperty$t(pt, yt, ir) {
  return (yt = _toPropertyKey$t(yt)) in pt ? Object.defineProperty(pt, yt, { value: ir, enumerable: !0, configurable: !0, writable: !0 }) : pt[yt] = ir, pt;
}
function _toPropertyKey$t(pt) {
  var yt = _toPrimitive$t(pt, "string");
  return typeof yt == "symbol" ? yt : yt + "";
}
function _toPrimitive$t(pt, yt) {
  if (typeof pt != "object" || !pt) return pt;
  var ir = pt[Symbol.toPrimitive];
  if (ir !== void 0) {
    var ti = ir.call(pt, yt);
    if (typeof ti != "object") return ti;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (yt === "string" ? String : Number)(pt);
}
var alpha$2 = (pt, yt, ir) => pt + (yt - pt) * ir, needContinue = (pt) => {
  var {
    from: yt,
    to: ir
  } = pt;
  return yt !== ir;
}, calStepperVals = (pt, yt, ir) => {
  var ti = mapObject((ii, ui) => {
    if (needContinue(ui)) {
      var [ai, li] = pt(ui.from, ui.to, ui.velocity);
      return _objectSpread$r(_objectSpread$r({}, ui), {}, {
        from: ai,
        velocity: li
      });
    }
    return ui;
  }, yt);
  return ir < 1 ? mapObject((ii, ui) => needContinue(ui) && ti[ii] != null ? _objectSpread$r(_objectSpread$r({}, ui), {}, {
    velocity: alpha$2(ui.velocity, ti[ii].velocity, ir),
    from: alpha$2(ui.from, ti[ii].from, ir)
  }) : ui, yt) : calStepperVals(pt, ti, ir - 1);
};
function createStepperUpdate(pt, yt, ir, ti, ii, ui) {
  var ai, li = ti.reduce((gi, mi) => _objectSpread$r(_objectSpread$r({}, gi), {}, {
    [mi]: {
      from: pt[mi],
      velocity: 0,
      to: yt[mi]
    }
  }), {}), oi = () => mapObject((gi, mi) => mi.from, li), si = () => !Object.values(li).filter(needContinue).length, di = null, fi = (gi) => {
    ai || (ai = gi);
    var mi = gi - ai, Ti = mi / ir.dt;
    li = calStepperVals(ir, li, Ti), ii(_objectSpread$r(_objectSpread$r(_objectSpread$r({}, pt), yt), oi())), ai = gi, si() || (di = ui.setTimeout(fi));
  };
  return () => (di = ui.setTimeout(fi), () => {
    var gi;
    (gi = di) === null || gi === void 0 || gi();
  });
}
function createTimingUpdate(pt, yt, ir, ti, ii, ui, ai) {
  var li = null, oi = ii.reduce((fi, gi) => {
    var mi = pt[gi], Ti = yt[gi];
    return mi == null || Ti == null ? fi : _objectSpread$r(_objectSpread$r({}, fi), {}, {
      [gi]: [mi, Ti]
    });
  }, {}), si, di = (fi) => {
    si || (si = fi);
    var gi = (fi - si) / ti, mi = mapObject((vi, xi) => alpha$2(...xi, ir(gi)), oi);
    if (ui(_objectSpread$r(_objectSpread$r(_objectSpread$r({}, pt), yt), mi)), gi < 1)
      li = ai.setTimeout(di);
    else {
      var Ti = mapObject((vi, xi) => alpha$2(...xi, ir(1)), oi);
      ui(_objectSpread$r(_objectSpread$r(_objectSpread$r({}, pt), yt), Ti));
    }
  };
  return () => (li = ai.setTimeout(di), () => {
    var fi;
    (fi = li) === null || fi === void 0 || fi();
  });
}
const configUpdate = (pt, yt, ir, ti, ii, ui) => {
  var ai = getIntersectionKeys(pt, yt);
  return ir == null ? () => (ii(_objectSpread$r(_objectSpread$r({}, pt), yt)), () => {
  }) : ir.isStepper === !0 ? createStepperUpdate(pt, yt, ir, ai, ii, ui) : createTimingUpdate(pt, yt, ir, ti, ai, ii, ui);
};
var ACCURACY = 1e-4, cubicBezierFactor = (pt, yt) => [0, 3 * pt, 3 * yt - 6 * pt, 3 * pt - 3 * yt + 1], evaluatePolynomial = (pt, yt) => pt.map((ir, ti) => ir * yt ** ti).reduce((ir, ti) => ir + ti), cubicBezier = (pt, yt) => (ir) => {
  var ti = cubicBezierFactor(pt, yt);
  return evaluatePolynomial(ti, ir);
}, derivativeCubicBezier = (pt, yt) => (ir) => {
  var ti = cubicBezierFactor(pt, yt), ii = [...ti.map((ui, ai) => ui * ai).slice(1), 0];
  return evaluatePolynomial(ii, ir);
}, parseCubicBezier = (pt) => {
  var yt, ir = pt.split("(");
  if (ir.length !== 2 || ir[0] !== "cubic-bezier")
    return null;
  var ti = (yt = ir[1]) === null || yt === void 0 || (yt = yt.split(")")[0]) === null || yt === void 0 ? void 0 : yt.split(",");
  if (ti == null || ti.length !== 4)
    return null;
  var ii = ti.map((ui) => parseFloat(ui));
  return [ii[0], ii[1], ii[2], ii[3]];
}, getBezierCoordinates = function() {
  for (var pt = arguments.length, yt = new Array(pt), ir = 0; ir < pt; ir++)
    yt[ir] = arguments[ir];
  if (yt.length === 1)
    switch (yt[0]) {
      case "linear":
        return [0, 0, 1, 1];
      case "ease":
        return [0.25, 0.1, 0.25, 1];
      case "ease-in":
        return [0.42, 0, 1, 1];
      case "ease-out":
        return [0.42, 0, 0.58, 1];
      case "ease-in-out":
        return [0, 0, 0.58, 1];
      default: {
        var ti = parseCubicBezier(yt[0]);
        if (ti)
          return ti;
      }
    }
  return yt.length === 4 ? yt : [0, 0, 1, 1];
}, createBezierEasing = (pt, yt, ir, ti) => {
  var ii = cubicBezier(pt, ir), ui = cubicBezier(yt, ti), ai = derivativeCubicBezier(pt, ir), li = (si) => si > 1 ? 1 : si < 0 ? 0 : si, oi = (si) => {
    for (var di = si > 1 ? 1 : si, fi = di, gi = 0; gi < 8; ++gi) {
      var mi = ii(fi) - di, Ti = ai(fi);
      if (Math.abs(mi - di) < ACCURACY || Ti < ACCURACY)
        return ui(fi);
      fi = li(fi - mi / Ti);
    }
    return ui(fi);
  };
  return oi.isStepper = !1, oi;
}, configBezier = function() {
  return createBezierEasing(...getBezierCoordinates(...arguments));
}, configSpring = function() {
  var pt = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, {
    stiff: yt = 100,
    damping: ir = 8,
    dt: ti = 17
  } = pt, ii = (ui, ai, li) => {
    var oi = -(ui - ai) * yt, si = li * ir, di = li + (oi - si) * ti / 1e3, fi = li * ti / 1e3 + ui;
    return Math.abs(fi - ai) < ACCURACY && Math.abs(di) < ACCURACY ? [ai, 0] : [fi, di];
  };
  return ii.isStepper = !0, ii.dt = ti, ii;
}, configEasing = (pt) => {
  if (typeof pt == "string")
    switch (pt) {
      case "ease":
      case "ease-in-out":
      case "ease-out":
      case "ease-in":
      case "linear":
        return configBezier(pt);
      case "spring":
        return configSpring();
      default:
        if (pt.split("(")[0] === "cubic-bezier")
          return configBezier(pt);
    }
  return typeof pt == "function" ? pt : null;
};
function createAnimateManager(pt) {
  var yt, ir = () => null, ti = !1, ii = null, ui = (ai) => {
    if (!ti) {
      if (Array.isArray(ai)) {
        if (!ai.length)
          return;
        var li = ai, [oi, ...si] = li;
        if (typeof oi == "number") {
          ii = pt.setTimeout(ui.bind(null, si), oi);
          return;
        }
        ui(oi), ii = pt.setTimeout(ui.bind(null, si));
        return;
      }
      typeof ai == "string" && (yt = ai, ir(yt)), typeof ai == "object" && (yt = ai, ir(yt)), typeof ai == "function" && ai();
    }
  };
  return {
    stop: () => {
      ti = !0;
    },
    start: (ai) => {
      ti = !1, ii && (ii(), ii = null), ui(ai);
    },
    subscribe: (ai) => (ir = ai, () => {
      ir = () => null;
    }),
    getTimeoutController: () => pt
  };
}
class RequestAnimationFrameTimeoutController {
  setTimeout(yt) {
    var ir = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, ti = performance.now(), ii = null, ui = (ai) => {
      ai - ti >= ir ? yt(ai) : typeof requestAnimationFrame == "function" && (ii = requestAnimationFrame(ui));
    };
    return ii = requestAnimationFrame(ui), () => {
      ii != null && cancelAnimationFrame(ii);
    };
  }
}
function createDefaultAnimationManager() {
  return createAnimateManager(new RequestAnimationFrameTimeoutController());
}
var AnimationManagerContext = /* @__PURE__ */ createContext(createDefaultAnimationManager);
function useAnimationManager(pt, yt) {
  var ir = useContext(AnimationManagerContext);
  return useMemo(() => yt ?? ir(pt), [pt, yt, ir]);
}
var defaultJavascriptAnimateProps = {
  begin: 0,
  duration: 1e3,
  easing: "ease",
  isActive: !0,
  canBegin: !0,
  onAnimationEnd: () => {
  },
  onAnimationStart: () => {
  }
}, from$3 = {
  t: 0
}, to$2 = {
  t: 1
};
function JavascriptAnimate(pt) {
  var yt = resolveDefaultProps(pt, defaultJavascriptAnimateProps), {
    isActive: ir,
    canBegin: ti,
    duration: ii,
    easing: ui,
    begin: ai,
    onAnimationEnd: li,
    onAnimationStart: oi,
    children: si
  } = yt, di = usePrefersReducedMotion(), fi = ir === "auto" ? !Global.isSsr && !di : ir, gi = useAnimationManager(yt.animationId, yt.animationManager), [mi, Ti] = useState(fi ? from$3 : to$2), vi = useRef(null);
  return useEffect(() => {
    fi || Ti(to$2);
  }, [fi]), useEffect(() => {
    if (!fi || !ti)
      return noop$2;
    var xi = configUpdate(from$3, to$2, configEasing(ui), ii, Ti, gi.getTimeoutController()), Si = () => {
      vi.current = xi();
    };
    return gi.start([oi, ai, Si, ii, li]), () => {
      gi.stop(), vi.current && vi.current(), li();
    };
  }, [fi, ti, ii, ui, ai, oi, li, gi]), si(mi.t);
}
function useAnimationId(pt) {
  var yt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "animation-", ir = useRef(uniqueId(yt)), ti = useRef(pt);
  return ti.current !== pt && (ir.current = uniqueId(yt), ti.current = pt), ir.current;
}
var _excluded$f = ["radius"], _excluded2$8 = ["radius"], _templateObject$2, _templateObject2$2, _templateObject3$2, _templateObject4$2, _templateObject5$2, _templateObject6$1, _templateObject7$1, _templateObject8, _templateObject9, _templateObject0;
function ownKeys$q(pt, yt) {
  var ir = Object.keys(pt);
  if (Object.getOwnPropertySymbols) {
    var ti = Object.getOwnPropertySymbols(pt);
    yt && (ti = ti.filter(function(ii) {
      return Object.getOwnPropertyDescriptor(pt, ii).enumerable;
    })), ir.push.apply(ir, ti);
  }
  return ir;
}
function _objectSpread$q(pt) {
  for (var yt = 1; yt < arguments.length; yt++) {
    var ir = arguments[yt] != null ? arguments[yt] : {};
    yt % 2 ? ownKeys$q(Object(ir), !0).forEach(function(ti) {
      _defineProperty$s(pt, ti, ir[ti]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(pt, Object.getOwnPropertyDescriptors(ir)) : ownKeys$q(Object(ir)).forEach(function(ti) {
      Object.defineProperty(pt, ti, Object.getOwnPropertyDescriptor(ir, ti));
    });
  }
  return pt;
}
function _defineProperty$s(pt, yt, ir) {
  return (yt = _toPropertyKey$s(yt)) in pt ? Object.defineProperty(pt, yt, { value: ir, enumerable: !0, configurable: !0, writable: !0 }) : pt[yt] = ir, pt;
}
function _toPropertyKey$s(pt) {
  var yt = _toPrimitive$s(pt, "string");
  return typeof yt == "symbol" ? yt : yt + "";
}
function _toPrimitive$s(pt, yt) {
  if (typeof pt != "object" || !pt) return pt;
  var ir = pt[Symbol.toPrimitive];
  if (ir !== void 0) {
    var ti = ir.call(pt, yt);
    if (typeof ti != "object") return ti;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (yt === "string" ? String : Number)(pt);
}
function _extends$g() {
  return _extends$g = Object.assign ? Object.assign.bind() : function(pt) {
    for (var yt = 1; yt < arguments.length; yt++) {
      var ir = arguments[yt];
      for (var ti in ir) ({}).hasOwnProperty.call(ir, ti) && (pt[ti] = ir[ti]);
    }
    return pt;
  }, _extends$g.apply(null, arguments);
}
function _objectWithoutProperties$f(pt, yt) {
  if (pt == null) return {};
  var ir, ti, ii = _objectWithoutPropertiesLoose$f(pt, yt);
  if (Object.getOwnPropertySymbols) {
    var ui = Object.getOwnPropertySymbols(pt);
    for (ti = 0; ti < ui.length; ti++) ir = ui[ti], yt.indexOf(ir) === -1 && {}.propertyIsEnumerable.call(pt, ir) && (ii[ir] = pt[ir]);
  }
  return ii;
}
function _objectWithoutPropertiesLoose$f(pt, yt) {
  if (pt == null) return {};
  var ir = {};
  for (var ti in pt) if ({}.hasOwnProperty.call(pt, ti)) {
    if (yt.indexOf(ti) !== -1) continue;
    ir[ti] = pt[ti];
  }
  return ir;
}
function _taggedTemplateLiteral$2(pt, yt) {
  return yt || (yt = pt.slice(0)), Object.freeze(Object.defineProperties(pt, { raw: { value: Object.freeze(yt) } }));
}
var getRectanglePath = (pt, yt, ir, ti, ii) => {
  var ui = round$1(ir), ai = round$1(ti), li = Math.min(Math.abs(ui) / 2, Math.abs(ai) / 2), oi = ai >= 0 ? 1 : -1, si = ui >= 0 ? 1 : -1, di = ai >= 0 && ui >= 0 || ai < 0 && ui < 0 ? 1 : 0, fi;
  if (li > 0 && Array.isArray(ii)) {
    for (var gi = [0, 0, 0, 0], mi = 0, Ti = 4; mi < Ti; mi++) {
      var vi, xi = (vi = ii[mi]) !== null && vi !== void 0 ? vi : 0;
      gi[mi] = xi > li ? li : xi;
    }
    fi = roundTemplateLiteral(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral$2(["M", ",", ""])), pt, yt + oi * gi[0]), gi[0] > 0 && (fi += roundTemplateLiteral(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral$2(["A ", ",", ",0,0,", ",", ",", ""])), gi[0], gi[0], di, pt + si * gi[0], yt)), fi += roundTemplateLiteral(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral$2(["L ", ",", ""])), pt + ir - si * gi[1], yt), gi[1] > 0 && (fi += roundTemplateLiteral(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteral$2(["A ", ",", ",0,0,", `,
        `, ",", ""])), gi[1], gi[1], di, pt + ir, yt + oi * gi[1])), fi += roundTemplateLiteral(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteral$2(["L ", ",", ""])), pt + ir, yt + ti - oi * gi[2]), gi[2] > 0 && (fi += roundTemplateLiteral(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral$2(["A ", ",", ",0,0,", `,
        `, ",", ""])), gi[2], gi[2], di, pt + ir - si * gi[2], yt + ti)), fi += roundTemplateLiteral(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteral$2(["L ", ",", ""])), pt + si * gi[3], yt + ti), gi[3] > 0 && (fi += roundTemplateLiteral(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral$2(["A ", ",", ",0,0,", `,
        `, ",", ""])), gi[3], gi[3], di, pt, yt + ti - oi * gi[3])), fi += "Z";
  } else if (li > 0 && ii === +ii && ii > 0) {
    var Si = Math.min(li, ii);
    fi = roundTemplateLiteral(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral$2(["M ", ",", `
            A `, ",", ",0,0,", ",", ",", `
            L `, ",", `
            A `, ",", ",0,0,", ",", ",", `
            L `, ",", `
            A `, ",", ",0,0,", ",", ",", `
            L `, ",", `
            A `, ",", ",0,0,", ",", ",", " Z"])), pt, yt + oi * Si, Si, Si, di, pt + si * Si, yt, pt + ir - si * Si, yt, Si, Si, di, pt + ir, yt + oi * Si, pt + ir, yt + ti - oi * Si, Si, Si, di, pt + ir - si * Si, yt + ti, pt + si * Si, yt + ti, Si, Si, di, pt, yt + ti - oi * Si);
  } else
    fi = roundTemplateLiteral(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral$2(["M ", ",", " h ", " v ", " h ", " Z"])), pt, yt, ir, ti, -ir);
  return fi;
}, defaultRectangleProps = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  radius: 0,
  isAnimationActive: !1,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, Rectangle = (pt) => {
  var yt = resolveDefaultProps(pt, defaultRectangleProps), ir = useRef(null), [ti, ii] = useState(-1);
  useEffect(() => {
    if (ir.current && ir.current.getTotalLength)
      try {
        var No = ir.current.getTotalLength();
        No && ii(No);
      } catch {
      }
  }, []);
  var {
    x: ui,
    y: ai,
    width: li,
    height: oi,
    radius: si,
    className: di
  } = yt, {
    animationEasing: fi,
    animationDuration: gi,
    animationBegin: mi,
    isAnimationActive: Ti,
    isUpdateAnimationActive: vi
  } = yt, xi = useRef(li), Si = useRef(oi), Pi = useRef(ui), $i = useRef(ai), Oi = useMemo(() => ({
    x: ui,
    y: ai,
    width: li,
    height: oi,
    radius: si
  }), [ui, ai, li, oi, si]), Di = useAnimationId(Oi, "rectangle-");
  if (ui !== +ui || ai !== +ai || li !== +li || oi !== +oi || li === 0 || oi === 0)
    return null;
  var Mi = clsx$1("recharts-rectangle", di);
  if (!vi) {
    var Oo = svgPropertiesAndEvents(yt), {
      radius: io
    } = Oo, xo = _objectWithoutProperties$f(Oo, _excluded$f);
    return /* @__PURE__ */ React.createElement("path", _extends$g({}, xo, {
      x: round$1(ui),
      y: round$1(ai),
      width: round$1(li),
      height: round$1(oi),
      radius: typeof si == "number" ? si : void 0,
      className: Mi,
      d: getRectanglePath(ui, ai, li, oi, si)
    }));
  }
  var fo = xi.current, _o = Si.current, Li = Pi.current, Co = $i.current, Ni = "0px ".concat(ti === -1 ? 1 : ti, "px"), Yi = "".concat(ti, "px ").concat(ti, "px"), Vo = getTransitionVal(["strokeDasharray"], gi, typeof fi == "string" ? fi : defaultRectangleProps.animationEasing);
  return /* @__PURE__ */ React.createElement(JavascriptAnimate, {
    animationId: Di,
    key: Di,
    canBegin: ti > 0,
    duration: gi,
    easing: fi,
    isActive: vi,
    begin: mi
  }, (No) => {
    var Ui = interpolate$1(fo, li, No), jo = interpolate$1(_o, oi, No), Wi = interpolate$1(Li, ui, No), ji = interpolate$1(Co, ai, No);
    ir.current && (xi.current = Ui, Si.current = jo, Pi.current = Wi, $i.current = ji);
    var Hi;
    Ti ? No > 0 ? Hi = {
      transition: Vo,
      strokeDasharray: Yi
    } : Hi = {
      strokeDasharray: Ni
    } : Hi = {
      strokeDasharray: Yi
    };
    var zo = svgPropertiesAndEvents(yt), {
      radius: Lo
    } = zo, sa = _objectWithoutProperties$f(zo, _excluded2$8);
    return /* @__PURE__ */ React.createElement("path", _extends$g({}, sa, {
      radius: typeof si == "number" ? si : void 0,
      className: Mi,
      d: getRectanglePath(Wi, ji, Ui, jo, si),
      ref: ir,
      style: _objectSpread$q(_objectSpread$q({}, Hi), yt.style)
    }));
  });
};
function ownKeys$p(pt, yt) {
  var ir = Object.keys(pt);
  if (Object.getOwnPropertySymbols) {
    var ti = Object.getOwnPropertySymbols(pt);
    yt && (ti = ti.filter(function(ii) {
      return Object.getOwnPropertyDescriptor(pt, ii).enumerable;
    })), ir.push.apply(ir, ti);
  }
  return ir;
}
function _objectSpread$p(pt) {
  for (var yt = 1; yt < arguments.length; yt++) {
    var ir = arguments[yt] != null ? arguments[yt] : {};
    yt % 2 ? ownKeys$p(Object(ir), !0).forEach(function(ti) {
      _defineProperty$r(pt, ti, ir[ti]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(pt, Object.getOwnPropertyDescriptors(ir)) : ownKeys$p(Object(ir)).forEach(function(ti) {
      Object.defineProperty(pt, ti, Object.getOwnPropertyDescriptor(ir, ti));
    });
  }
  return pt;
}
function _defineProperty$r(pt, yt, ir) {
  return (yt = _toPropertyKey$r(yt)) in pt ? Object.defineProperty(pt, yt, { value: ir, enumerable: !0, configurable: !0, writable: !0 }) : pt[yt] = ir, pt;
}
function _toPropertyKey$r(pt) {
  var yt = _toPrimitive$r(pt, "string");
  return typeof yt == "symbol" ? yt : yt + "";
}
function _toPrimitive$r(pt, yt) {
  if (typeof pt != "object" || !pt) return pt;
  var ir = pt[Symbol.toPrimitive];
  if (ir !== void 0) {
    var ti = ir.call(pt, yt);
    if (typeof ti != "object") return ti;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (yt === "string" ? String : Number)(pt);
}
var RADIAN = Math.PI / 180, radianToDegree = (pt) => pt * 180 / Math.PI, polarToCartesian = (pt, yt, ir, ti) => ({
  x: pt + Math.cos(-RADIAN * ti) * ir,
  y: yt + Math.sin(-RADIAN * ti) * ir
}), getMaxRadius = function(pt, yt) {
  var ir = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  return Math.min(Math.abs(pt - (ir.left || 0) - (ir.right || 0)), Math.abs(yt - (ir.top || 0) - (ir.bottom || 0))) / 2;
}, distanceBetweenPoints = (pt, yt) => {
  var {
    x: ir,
    y: ti
  } = pt, {
    x: ii,
    y: ui
  } = yt;
  return Math.sqrt((ir - ii) ** 2 + (ti - ui) ** 2);
}, getAngleOfPoint = (pt, yt) => {
  var {
    x: ir,
    y: ti
  } = pt, {
    cx: ii,
    cy: ui
  } = yt, ai = distanceBetweenPoints({
    x: ir,
    y: ti
  }, {
    x: ii,
    y: ui
  });
  if (ai <= 0)
    return {
      radius: ai,
      angle: 0
    };
  var li = (ir - ii) / ai, oi = Math.acos(li);
  return ti > ui && (oi = 2 * Math.PI - oi), {
    radius: ai,
    angle: radianToDegree(oi),
    angleInRadian: oi
  };
}, formatAngleOfSector = (pt) => {
  var {
    startAngle: yt,
    endAngle: ir
  } = pt, ti = Math.floor(yt / 360), ii = Math.floor(ir / 360), ui = Math.min(ti, ii);
  return {
    startAngle: yt - ui * 360,
    endAngle: ir - ui * 360
  };
}, reverseFormatAngleOfSector = (pt, yt) => {
  var {
    startAngle: ir,
    endAngle: ti
  } = yt, ii = Math.floor(ir / 360), ui = Math.floor(ti / 360), ai = Math.min(ii, ui);
  return pt + ai * 360;
}, inRangeOfSector = (pt, yt) => {
  var {
    relativeX: ir,
    relativeY: ti
  } = pt, {
    radius: ii,
    angle: ui
  } = getAngleOfPoint({
    x: ir,
    y: ti
  }, yt), {
    innerRadius: ai,
    outerRadius: li
  } = yt;
  if (ii < ai || ii > li || ii === 0)
    return null;
  var {
    startAngle: oi,
    endAngle: si
  } = formatAngleOfSector(yt), di = ui, fi;
  if (oi <= si) {
    for (; di > si; )
      di -= 360;
    for (; di < oi; )
      di += 360;
    fi = di >= oi && di <= si;
  } else {
    for (; di > oi; )
      di -= 360;
    for (; di < si; )
      di += 360;
    fi = di >= si && di <= oi;
  }
  return fi ? _objectSpread$p(_objectSpread$p({}, yt), {}, {
    radius: ii,
    angle: reverseFormatAngleOfSector(di, yt)
  }) : null;
}, _templateObject$1, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5$1, _templateObject6, _templateObject7;
function _extends$f() {
  return _extends$f = Object.assign ? Object.assign.bind() : function(pt) {
    for (var yt = 1; yt < arguments.length; yt++) {
      var ir = arguments[yt];
      for (var ti in ir) ({}).hasOwnProperty.call(ir, ti) && (pt[ti] = ir[ti]);
    }
    return pt;
  }, _extends$f.apply(null, arguments);
}
function _taggedTemplateLiteral$1(pt, yt) {
  return yt || (yt = pt.slice(0)), Object.freeze(Object.defineProperties(pt, { raw: { value: Object.freeze(yt) } }));
}
var getDeltaAngle$1 = (pt, yt) => {
  var ir = mathSign(yt - pt), ti = Math.min(Math.abs(yt - pt), 359.999);
  return ir * ti;
}, getTangentCircle = (pt) => {
  var {
    cx: yt,
    cy: ir,
    radius: ti,
    angle: ii,
    sign: ui,
    isExternal: ai,
    cornerRadius: li,
    cornerIsExternal: oi
  } = pt, si = li * (ai ? 1 : -1) + ti, di = Math.asin(li / si) / RADIAN, fi = oi ? ii : ii + ui * di, gi = polarToCartesian(yt, ir, si, fi), mi = polarToCartesian(yt, ir, ti, fi), Ti = oi ? ii - ui * di : ii, vi = polarToCartesian(yt, ir, si * Math.cos(di * RADIAN), Ti);
  return {
    center: gi,
    circleTangency: mi,
    lineTangency: vi,
    theta: di
  };
}, getSectorPath = (pt) => {
  var {
    cx: yt,
    cy: ir,
    innerRadius: ti,
    outerRadius: ii,
    startAngle: ui,
    endAngle: ai
  } = pt, li = getDeltaAngle$1(ui, ai), oi = ui + li, si = polarToCartesian(yt, ir, ii, ui), di = polarToCartesian(yt, ir, ii, oi), fi = roundTemplateLiteral(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral$1(["M ", ",", `
    A `, ",", `,0,
    `, ",", `,
    `, ",", `
  `])), si.x, si.y, ii, ii, +(Math.abs(li) > 180), +(ui > oi), di.x, di.y);
  if (ti > 0) {
    var gi = polarToCartesian(yt, ir, ti, ui), mi = polarToCartesian(yt, ir, ti, oi);
    fi += roundTemplateLiteral(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral$1(["L ", ",", `
            A `, ",", `,0,
            `, ",", `,
            `, ",", " Z"])), mi.x, mi.y, ti, ti, +(Math.abs(li) > 180), +(ui <= oi), gi.x, gi.y);
  } else
    fi += roundTemplateLiteral(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral$1(["L ", ",", " Z"])), yt, ir);
  return fi;
}, getSectorWithCorner = (pt) => {
  var {
    cx: yt,
    cy: ir,
    innerRadius: ti,
    outerRadius: ii,
    cornerRadius: ui,
    forceCornerRadius: ai,
    cornerIsExternal: li,
    startAngle: oi,
    endAngle: si
  } = pt, di = mathSign(si - oi), {
    circleTangency: fi,
    lineTangency: gi,
    theta: mi
  } = getTangentCircle({
    cx: yt,
    cy: ir,
    radius: ii,
    angle: oi,
    sign: di,
    cornerRadius: ui,
    cornerIsExternal: li
  }), {
    circleTangency: Ti,
    lineTangency: vi,
    theta: xi
  } = getTangentCircle({
    cx: yt,
    cy: ir,
    radius: ii,
    angle: si,
    sign: -di,
    cornerRadius: ui,
    cornerIsExternal: li
  }), Si = li ? Math.abs(oi - si) : Math.abs(oi - si) - mi - xi;
  if (Si < 0)
    return ai ? roundTemplateLiteral(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral$1(["M ", ",", `
        a`, ",", ",0,0,1,", `,0
        a`, ",", ",0,0,1,", `,0
      `])), gi.x, gi.y, ui, ui, ui * 2, ui, ui, -ui * 2) : getSectorPath({
      cx: yt,
      cy: ir,
      innerRadius: ti,
      outerRadius: ii,
      startAngle: oi,
      endAngle: si
    });
  var Pi = roundTemplateLiteral(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral$1(["M ", ",", `
    A`, ",", ",0,0,", ",", ",", `
    A`, ",", ",0,", ",", ",", ",", `
    A`, ",", ",0,0,", ",", ",", `
  `])), gi.x, gi.y, ui, ui, +(di < 0), fi.x, fi.y, ii, ii, +(Si > 180), +(di < 0), Ti.x, Ti.y, ui, ui, +(di < 0), vi.x, vi.y);
  if (ti > 0) {
    var {
      circleTangency: $i,
      lineTangency: Oi,
      theta: Di
    } = getTangentCircle({
      cx: yt,
      cy: ir,
      radius: ti,
      angle: oi,
      sign: di,
      isExternal: !0,
      cornerRadius: ui,
      cornerIsExternal: li
    }), {
      circleTangency: Mi,
      lineTangency: Oo,
      theta: io
    } = getTangentCircle({
      cx: yt,
      cy: ir,
      radius: ti,
      angle: si,
      sign: -di,
      isExternal: !0,
      cornerRadius: ui,
      cornerIsExternal: li
    }), xo = li ? Math.abs(oi - si) : Math.abs(oi - si) - Di - io;
    if (xo < 0 && ui === 0)
      return "".concat(Pi, "L").concat(yt, ",").concat(ir, "Z");
    Pi += roundTemplateLiteral(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral$1(["L", ",", `
      A`, ",", ",0,0,", ",", ",", `
      A`, ",", ",0,", ",", ",", ",", `
      A`, ",", ",0,0,", ",", ",", "Z"])), Oo.x, Oo.y, ui, ui, +(di < 0), Mi.x, Mi.y, ti, ti, +(xo > 180), +(di > 0), $i.x, $i.y, ui, ui, +(di < 0), Oi.x, Oi.y);
  } else
    Pi += roundTemplateLiteral(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral$1(["L", ",", "Z"])), yt, ir);
  return Pi;
}, defaultSectorProps = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: !1,
  cornerIsExternal: !1
}, Sector = (pt) => {
  var yt = resolveDefaultProps(pt, defaultSectorProps), {
    cx: ir,
    cy: ti,
    innerRadius: ii,
    outerRadius: ui,
    cornerRadius: ai,
    forceCornerRadius: li,
    cornerIsExternal: oi,
    startAngle: si,
    endAngle: di,
    className: fi
  } = yt;
  if (ui < ii || si === di)
    return null;
  var gi = clsx$1("recharts-sector", fi), mi = ui - ii, Ti = getPercentValue(ai, mi, 0, !0), vi;
  return Ti > 0 && Math.abs(si - di) < 360 ? vi = getSectorWithCorner({
    cx: ir,
    cy: ti,
    innerRadius: ii,
    outerRadius: ui,
    cornerRadius: Math.min(Ti, mi / 2),
    forceCornerRadius: li,
    cornerIsExternal: oi,
    startAngle: si,
    endAngle: di
  }) : vi = getSectorPath({
    cx: ir,
    cy: ti,
    innerRadius: ii,
    outerRadius: ui,
    startAngle: si,
    endAngle: di
  }), /* @__PURE__ */ React.createElement("path", _extends$f({}, svgPropertiesAndEvents(yt), {
    className: gi,
    d: vi
  }));
}, range$3 = {}, toFinite = {}, toNumber = {}, hasRequiredToNumber;
function requireToNumber() {
  return hasRequiredToNumber || (hasRequiredToNumber = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    const yt = /* @__PURE__ */ requireIsSymbol();
    function ir(ti) {
      return yt.isSymbol(ti) ? NaN : Number(ti);
    }
    pt.toNumber = ir;
  })(toNumber)), toNumber;
}
var hasRequiredToFinite;
function requireToFinite() {
  return hasRequiredToFinite || (hasRequiredToFinite = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    const yt = /* @__PURE__ */ requireToNumber();
    function ir(ti) {
      return ti ? (ti = yt.toNumber(ti), ti === 1 / 0 || ti === -1 / 0 ? (ti < 0 ? -1 : 1) * Number.MAX_VALUE : ti === ti ? ti : 0) : ti === 0 ? ti : 0;
    }
    pt.toFinite = ir;
  })(toFinite)), toFinite;
}
var hasRequiredRange$1;
function requireRange$1() {
  return hasRequiredRange$1 || (hasRequiredRange$1 = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    const yt = /* @__PURE__ */ requireIsIterateeCall(), ir = /* @__PURE__ */ requireToFinite();
    function ti(ii, ui, ai) {
      ai && typeof ai != "number" && yt.isIterateeCall(ii, ui, ai) && (ui = ai = void 0), ii = ir.toFinite(ii), ui === void 0 ? (ui = ii, ii = 0) : ui = ir.toFinite(ui), ai = ai === void 0 ? ii < ui ? 1 : -1 : ir.toFinite(ai);
      const li = Math.max(Math.ceil((ui - ii) / (ai || 1)), 0), oi = new Array(li);
      for (let si = 0; si < li; si++)
        oi[si] = ii, ii += ai;
      return oi;
    }
    pt.range = ti;
  })(range$3)), range$3;
}
var range$2, hasRequiredRange;
function requireRange() {
  return hasRequiredRange || (hasRequiredRange = 1, range$2 = requireRange$1().range), range$2;
}
var rangeExports = /* @__PURE__ */ requireRange();
const range$1 = /* @__PURE__ */ getDefaultExportFromCjs(rangeExports);
var selectChartDataWithIndexes = (pt) => pt.chartData, selectChartDataAndAlwaysIgnoreIndexes = createSelector([selectChartDataWithIndexes], (pt) => {
  var yt = pt.chartData != null ? pt.chartData.length - 1 : 0;
  return {
    chartData: pt.chartData,
    computedData: pt.computedData,
    dataEndIndex: yt,
    dataStartIndex: 0
  };
}), selectChartDataWithIndexesIfNotInPanoramaPosition4 = (pt, yt, ir, ti) => ti ? selectChartDataAndAlwaysIgnoreIndexes(pt) : selectChartDataWithIndexes(pt), selectChartDataWithIndexesIfNotInPanoramaPosition3 = (pt, yt, ir) => ir ? selectChartDataAndAlwaysIgnoreIndexes(pt) : selectChartDataWithIndexes(pt), selectChartDataSliceIfNotInPanorama = createSelector([selectChartDataWithIndexesIfNotInPanoramaPosition4], (pt) => {
  var {
    chartData: yt,
    dataStartIndex: ir,
    dataEndIndex: ti
  } = pt;
  return yt != null ? yt.slice(ir, ti + 1) : [];
});
createSelector([selectChartDataAndAlwaysIgnoreIndexes], (pt) => {
  var {
    chartData: yt,
    dataStartIndex: ir,
    dataEndIndex: ti
  } = pt;
  return yt != null ? yt.slice(ir, ti + 1) : [];
});
var selectChartDataSliceWithIndexes = createSelector([selectChartDataWithIndexes], (pt) => {
  var {
    chartData: yt,
    dataStartIndex: ir,
    dataEndIndex: ti
  } = pt;
  return yt != null ? yt.slice(ir, ti + 1) : [];
});
function isWellFormedNumberDomain(pt) {
  if (Array.isArray(pt) && pt.length === 2) {
    var [yt, ir] = pt;
    if (isWellBehavedNumber(yt) && isWellBehavedNumber(ir))
      return !0;
  }
  return !1;
}
function extendDomain(pt, yt, ir) {
  return ir ? pt : [Math.min(pt[0], yt[0]), Math.max(pt[1], yt[1])];
}
function numericalDomainSpecifiedWithoutRequiringData(pt, yt) {
  if (yt && typeof pt != "function" && Array.isArray(pt) && pt.length === 2) {
    var [ir, ti] = pt, ii, ui;
    if (isWellBehavedNumber(ir))
      ii = ir;
    else if (typeof ir == "function")
      return;
    if (isWellBehavedNumber(ti))
      ui = ti;
    else if (typeof ti == "function")
      return;
    var ai = [ii, ui];
    if (isWellFormedNumberDomain(ai))
      return ai;
  }
}
function parseNumericalUserDomain(pt, yt, ir) {
  if (!(!ir && yt == null)) {
    if (typeof pt == "function" && yt != null)
      try {
        var ti = pt(yt, ir);
        if (isWellFormedNumberDomain(ti))
          return extendDomain(ti, yt, ir);
      } catch {
      }
    if (Array.isArray(pt) && pt.length === 2) {
      var [ii, ui] = pt, ai, li;
      if (ii === "auto")
        yt != null && (ai = Math.min(...yt));
      else if (isNumber(ii))
        ai = ii;
      else if (typeof ii == "function")
        try {
          yt != null && (ai = ii(yt == null ? void 0 : yt[0]));
        } catch {
        }
      else if (typeof ii == "string" && MIN_VALUE_REG.test(ii)) {
        var oi = MIN_VALUE_REG.exec(ii);
        if (oi == null || oi[1] == null || yt == null)
          ai = void 0;
        else {
          var si = +oi[1];
          ai = yt[0] - si;
        }
      } else
        ai = yt == null ? void 0 : yt[0];
      if (ui === "auto")
        yt != null && (li = Math.max(...yt));
      else if (isNumber(ui))
        li = ui;
      else if (typeof ui == "function")
        try {
          yt != null && (li = ui(yt == null ? void 0 : yt[1]));
        } catch {
        }
      else if (typeof ui == "string" && MAX_VALUE_REG.test(ui)) {
        var di = MAX_VALUE_REG.exec(ui);
        if (di == null || di[1] == null || yt == null)
          li = void 0;
        else {
          var fi = +di[1];
          li = yt[1] + fi;
        }
      } else
        li = yt == null ? void 0 : yt[1];
      var gi = [ai, li];
      if (isWellFormedNumberDomain(gi))
        return yt == null ? gi : extendDomain(gi, yt, ir);
    }
  }
}
var MAX_DIGITS = 1e9, defaults = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed during run-time using `Decimal.config`.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
  // `toFixed`, `toPrecision` and `toSignificantDigits`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -MAX_E
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to MAX_E
  // The natural logarithm of 10.
  // 115 digits
  LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
}, Decimal, external = !0, decimalError = "[DecimalError] ", invalidArgument = decimalError + "Invalid argument: ", exponentOutOfRange = decimalError + "Exponent out of range: ", mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), P$5 = {};
P$5.absoluteValue = P$5.abs = function() {
  var pt = new this.constructor(this);
  return pt.s && (pt.s = 1), pt;
};
P$5.comparedTo = P$5.cmp = function(pt) {
  var yt, ir, ti, ii, ui = this;
  if (pt = new ui.constructor(pt), ui.s !== pt.s) return ui.s || -pt.s;
  if (ui.e !== pt.e) return ui.e > pt.e ^ ui.s < 0 ? 1 : -1;
  for (ti = ui.d.length, ii = pt.d.length, yt = 0, ir = ti < ii ? ti : ii; yt < ir; ++yt)
    if (ui.d[yt] !== pt.d[yt]) return ui.d[yt] > pt.d[yt] ^ ui.s < 0 ? 1 : -1;
  return ti === ii ? 0 : ti > ii ^ ui.s < 0 ? 1 : -1;
};
P$5.decimalPlaces = P$5.dp = function() {
  var pt = this, yt = pt.d.length - 1, ir = (yt - pt.e) * LOG_BASE;
  if (yt = pt.d[yt], yt) for (; yt % 10 == 0; yt /= 10) ir--;
  return ir < 0 ? 0 : ir;
};
P$5.dividedBy = P$5.div = function(pt) {
  return divide(this, new this.constructor(pt));
};
P$5.dividedToIntegerBy = P$5.idiv = function(pt) {
  var yt = this, ir = yt.constructor;
  return round$4(divide(yt, new ir(pt), 0, 1), ir.precision);
};
P$5.equals = P$5.eq = function(pt) {
  return !this.cmp(pt);
};
P$5.exponent = function() {
  return getBase10Exponent(this);
};
P$5.greaterThan = P$5.gt = function(pt) {
  return this.cmp(pt) > 0;
};
P$5.greaterThanOrEqualTo = P$5.gte = function(pt) {
  return this.cmp(pt) >= 0;
};
P$5.isInteger = P$5.isint = function() {
  return this.e > this.d.length - 2;
};
P$5.isNegative = P$5.isneg = function() {
  return this.s < 0;
};
P$5.isPositive = P$5.ispos = function() {
  return this.s > 0;
};
P$5.isZero = function() {
  return this.s === 0;
};
P$5.lessThan = P$5.lt = function(pt) {
  return this.cmp(pt) < 0;
};
P$5.lessThanOrEqualTo = P$5.lte = function(pt) {
  return this.cmp(pt) < 1;
};
P$5.logarithm = P$5.log = function(pt) {
  var yt, ir = this, ti = ir.constructor, ii = ti.precision, ui = ii + 5;
  if (pt === void 0)
    pt = new ti(10);
  else if (pt = new ti(pt), pt.s < 1 || pt.eq(ONE)) throw Error(decimalError + "NaN");
  if (ir.s < 1) throw Error(decimalError + (ir.s ? "NaN" : "-Infinity"));
  return ir.eq(ONE) ? new ti(0) : (external = !1, yt = divide(ln$1(ir, ui), ln$1(pt, ui), ui), external = !0, round$4(yt, ii));
};
P$5.minus = P$5.sub = function(pt) {
  var yt = this;
  return pt = new yt.constructor(pt), yt.s == pt.s ? subtract(yt, pt) : add(yt, (pt.s = -pt.s, pt));
};
P$5.modulo = P$5.mod = function(pt) {
  var yt, ir = this, ti = ir.constructor, ii = ti.precision;
  if (pt = new ti(pt), !pt.s) throw Error(decimalError + "NaN");
  return ir.s ? (external = !1, yt = divide(ir, pt, 0, 1).times(pt), external = !0, ir.minus(yt)) : round$4(new ti(ir), ii);
};
P$5.naturalExponential = P$5.exp = function() {
  return exp(this);
};
P$5.naturalLogarithm = P$5.ln = function() {
  return ln$1(this);
};
P$5.negated = P$5.neg = function() {
  var pt = new this.constructor(this);
  return pt.s = -pt.s || 0, pt;
};
P$5.plus = P$5.add = function(pt) {
  var yt = this;
  return pt = new yt.constructor(pt), yt.s == pt.s ? add(yt, pt) : subtract(yt, (pt.s = -pt.s, pt));
};
P$5.precision = P$5.sd = function(pt) {
  var yt, ir, ti, ii = this;
  if (pt !== void 0 && pt !== !!pt && pt !== 1 && pt !== 0) throw Error(invalidArgument + pt);
  if (yt = getBase10Exponent(ii) + 1, ti = ii.d.length - 1, ir = ti * LOG_BASE + 1, ti = ii.d[ti], ti) {
    for (; ti % 10 == 0; ti /= 10) ir--;
    for (ti = ii.d[0]; ti >= 10; ti /= 10) ir++;
  }
  return pt && yt > ir ? yt : ir;
};
P$5.squareRoot = P$5.sqrt = function() {
  var pt, yt, ir, ti, ii, ui, ai, li = this, oi = li.constructor;
  if (li.s < 1) {
    if (!li.s) return new oi(0);
    throw Error(decimalError + "NaN");
  }
  for (pt = getBase10Exponent(li), external = !1, ii = Math.sqrt(+li), ii == 0 || ii == 1 / 0 ? (yt = digitsToString(li.d), (yt.length + pt) % 2 == 0 && (yt += "0"), ii = Math.sqrt(yt), pt = mathfloor((pt + 1) / 2) - (pt < 0 || pt % 2), ii == 1 / 0 ? yt = "5e" + pt : (yt = ii.toExponential(), yt = yt.slice(0, yt.indexOf("e") + 1) + pt), ti = new oi(yt)) : ti = new oi(ii.toString()), ir = oi.precision, ii = ai = ir + 3; ; )
    if (ui = ti, ti = ui.plus(divide(li, ui, ai + 2)).times(0.5), digitsToString(ui.d).slice(0, ai) === (yt = digitsToString(ti.d)).slice(0, ai)) {
      if (yt = yt.slice(ai - 3, ai + 1), ii == ai && yt == "4999") {
        if (round$4(ui, ir + 1, 0), ui.times(ui).eq(li)) {
          ti = ui;
          break;
        }
      } else if (yt != "9999")
        break;
      ai += 4;
    }
  return external = !0, round$4(ti, ir);
};
P$5.times = P$5.mul = function(pt) {
  var yt, ir, ti, ii, ui, ai, li, oi, si, di = this, fi = di.constructor, gi = di.d, mi = (pt = new fi(pt)).d;
  if (!di.s || !pt.s) return new fi(0);
  for (pt.s *= di.s, ir = di.e + pt.e, oi = gi.length, si = mi.length, oi < si && (ui = gi, gi = mi, mi = ui, ai = oi, oi = si, si = ai), ui = [], ai = oi + si, ti = ai; ti--; ) ui.push(0);
  for (ti = si; --ti >= 0; ) {
    for (yt = 0, ii = oi + ti; ii > ti; )
      li = ui[ii] + mi[ti] * gi[ii - ti - 1] + yt, ui[ii--] = li % BASE | 0, yt = li / BASE | 0;
    ui[ii] = (ui[ii] + yt) % BASE | 0;
  }
  for (; !ui[--ai]; ) ui.pop();
  return yt ? ++ir : ui.shift(), pt.d = ui, pt.e = ir, external ? round$4(pt, fi.precision) : pt;
};
P$5.toDecimalPlaces = P$5.todp = function(pt, yt) {
  var ir = this, ti = ir.constructor;
  return ir = new ti(ir), pt === void 0 ? ir : (checkInt32(pt, 0, MAX_DIGITS), yt === void 0 ? yt = ti.rounding : checkInt32(yt, 0, 8), round$4(ir, pt + getBase10Exponent(ir) + 1, yt));
};
P$5.toExponential = function(pt, yt) {
  var ir, ti = this, ii = ti.constructor;
  return pt === void 0 ? ir = toString(ti, !0) : (checkInt32(pt, 0, MAX_DIGITS), yt === void 0 ? yt = ii.rounding : checkInt32(yt, 0, 8), ti = round$4(new ii(ti), pt + 1, yt), ir = toString(ti, !0, pt + 1)), ir;
};
P$5.toFixed = function(pt, yt) {
  var ir, ti, ii = this, ui = ii.constructor;
  return pt === void 0 ? toString(ii) : (checkInt32(pt, 0, MAX_DIGITS), yt === void 0 ? yt = ui.rounding : checkInt32(yt, 0, 8), ti = round$4(new ui(ii), pt + getBase10Exponent(ii) + 1, yt), ir = toString(ti.abs(), !1, pt + getBase10Exponent(ti) + 1), ii.isneg() && !ii.isZero() ? "-" + ir : ir);
};
P$5.toInteger = P$5.toint = function() {
  var pt = this, yt = pt.constructor;
  return round$4(new yt(pt), getBase10Exponent(pt) + 1, yt.rounding);
};
P$5.toNumber = function() {
  return +this;
};
P$5.toPower = P$5.pow = function(pt) {
  var yt, ir, ti, ii, ui, ai, li = this, oi = li.constructor, si = 12, di = +(pt = new oi(pt));
  if (!pt.s) return new oi(ONE);
  if (li = new oi(li), !li.s) {
    if (pt.s < 1) throw Error(decimalError + "Infinity");
    return li;
  }
  if (li.eq(ONE)) return li;
  if (ti = oi.precision, pt.eq(ONE)) return round$4(li, ti);
  if (yt = pt.e, ir = pt.d.length - 1, ai = yt >= ir, ui = li.s, ai) {
    if ((ir = di < 0 ? -di : di) <= MAX_SAFE_INTEGER) {
      for (ii = new oi(ONE), yt = Math.ceil(ti / LOG_BASE + 4), external = !1; ir % 2 && (ii = ii.times(li), truncate(ii.d, yt)), ir = mathfloor(ir / 2), ir !== 0; )
        li = li.times(li), truncate(li.d, yt);
      return external = !0, pt.s < 0 ? new oi(ONE).div(ii) : round$4(ii, ti);
    }
  } else if (ui < 0) throw Error(decimalError + "NaN");
  return ui = ui < 0 && pt.d[Math.max(yt, ir)] & 1 ? -1 : 1, li.s = 1, external = !1, ii = pt.times(ln$1(li, ti + si)), external = !0, ii = exp(ii), ii.s = ui, ii;
};
P$5.toPrecision = function(pt, yt) {
  var ir, ti, ii = this, ui = ii.constructor;
  return pt === void 0 ? (ir = getBase10Exponent(ii), ti = toString(ii, ir <= ui.toExpNeg || ir >= ui.toExpPos)) : (checkInt32(pt, 1, MAX_DIGITS), yt === void 0 ? yt = ui.rounding : checkInt32(yt, 0, 8), ii = round$4(new ui(ii), pt, yt), ir = getBase10Exponent(ii), ti = toString(ii, pt <= ir || ir <= ui.toExpNeg, pt)), ti;
};
P$5.toSignificantDigits = P$5.tosd = function(pt, yt) {
  var ir = this, ti = ir.constructor;
  return pt === void 0 ? (pt = ti.precision, yt = ti.rounding) : (checkInt32(pt, 1, MAX_DIGITS), yt === void 0 ? yt = ti.rounding : checkInt32(yt, 0, 8)), round$4(new ti(ir), pt, yt);
};
P$5.toString = P$5.valueOf = P$5.val = P$5.toJSON = P$5[Symbol.for("nodejs.util.inspect.custom")] = function() {
  var pt = this, yt = getBase10Exponent(pt), ir = pt.constructor;
  return toString(pt, yt <= ir.toExpNeg || yt >= ir.toExpPos);
};
function add(pt, yt) {
  var ir, ti, ii, ui, ai, li, oi, si, di = pt.constructor, fi = di.precision;
  if (!pt.s || !yt.s)
    return yt.s || (yt = new di(pt)), external ? round$4(yt, fi) : yt;
  if (oi = pt.d, si = yt.d, ai = pt.e, ii = yt.e, oi = oi.slice(), ui = ai - ii, ui) {
    for (ui < 0 ? (ti = oi, ui = -ui, li = si.length) : (ti = si, ii = ai, li = oi.length), ai = Math.ceil(fi / LOG_BASE), li = ai > li ? ai + 1 : li + 1, ui > li && (ui = li, ti.length = 1), ti.reverse(); ui--; ) ti.push(0);
    ti.reverse();
  }
  for (li = oi.length, ui = si.length, li - ui < 0 && (ui = li, ti = si, si = oi, oi = ti), ir = 0; ui; )
    ir = (oi[--ui] = oi[ui] + si[ui] + ir) / BASE | 0, oi[ui] %= BASE;
  for (ir && (oi.unshift(ir), ++ii), li = oi.length; oi[--li] == 0; ) oi.pop();
  return yt.d = oi, yt.e = ii, external ? round$4(yt, fi) : yt;
}
function checkInt32(pt, yt, ir) {
  if (pt !== ~~pt || pt < yt || pt > ir)
    throw Error(invalidArgument + pt);
}
function digitsToString(pt) {
  var yt, ir, ti, ii = pt.length - 1, ui = "", ai = pt[0];
  if (ii > 0) {
    for (ui += ai, yt = 1; yt < ii; yt++)
      ti = pt[yt] + "", ir = LOG_BASE - ti.length, ir && (ui += getZeroString(ir)), ui += ti;
    ai = pt[yt], ti = ai + "", ir = LOG_BASE - ti.length, ir && (ui += getZeroString(ir));
  } else if (ai === 0)
    return "0";
  for (; ai % 10 === 0; ) ai /= 10;
  return ui + ai;
}
var divide = /* @__PURE__ */ (function() {
  function pt(ti, ii) {
    var ui, ai = 0, li = ti.length;
    for (ti = ti.slice(); li--; )
      ui = ti[li] * ii + ai, ti[li] = ui % BASE | 0, ai = ui / BASE | 0;
    return ai && ti.unshift(ai), ti;
  }
  function yt(ti, ii, ui, ai) {
    var li, oi;
    if (ui != ai)
      oi = ui > ai ? 1 : -1;
    else
      for (li = oi = 0; li < ui; li++)
        if (ti[li] != ii[li]) {
          oi = ti[li] > ii[li] ? 1 : -1;
          break;
        }
    return oi;
  }
  function ir(ti, ii, ui) {
    for (var ai = 0; ui--; )
      ti[ui] -= ai, ai = ti[ui] < ii[ui] ? 1 : 0, ti[ui] = ai * BASE + ti[ui] - ii[ui];
    for (; !ti[0] && ti.length > 1; ) ti.shift();
  }
  return function(ti, ii, ui, ai) {
    var li, oi, si, di, fi, gi, mi, Ti, vi, xi, Si, Pi, $i, Oi, Di, Mi, Oo, io, xo = ti.constructor, fo = ti.s == ii.s ? 1 : -1, _o = ti.d, Li = ii.d;
    if (!ti.s) return new xo(ti);
    if (!ii.s) throw Error(decimalError + "Division by zero");
    for (oi = ti.e - ii.e, Oo = Li.length, Di = _o.length, mi = new xo(fo), Ti = mi.d = [], si = 0; Li[si] == (_o[si] || 0); ) ++si;
    if (Li[si] > (_o[si] || 0) && --oi, ui == null ? Pi = ui = xo.precision : ai ? Pi = ui + (getBase10Exponent(ti) - getBase10Exponent(ii)) + 1 : Pi = ui, Pi < 0) return new xo(0);
    if (Pi = Pi / LOG_BASE + 2 | 0, si = 0, Oo == 1)
      for (di = 0, Li = Li[0], Pi++; (si < Di || di) && Pi--; si++)
        $i = di * BASE + (_o[si] || 0), Ti[si] = $i / Li | 0, di = $i % Li | 0;
    else {
      for (di = BASE / (Li[0] + 1) | 0, di > 1 && (Li = pt(Li, di), _o = pt(_o, di), Oo = Li.length, Di = _o.length), Oi = Oo, vi = _o.slice(0, Oo), xi = vi.length; xi < Oo; ) vi[xi++] = 0;
      io = Li.slice(), io.unshift(0), Mi = Li[0], Li[1] >= BASE / 2 && ++Mi;
      do
        di = 0, li = yt(Li, vi, Oo, xi), li < 0 ? (Si = vi[0], Oo != xi && (Si = Si * BASE + (vi[1] || 0)), di = Si / Mi | 0, di > 1 ? (di >= BASE && (di = BASE - 1), fi = pt(Li, di), gi = fi.length, xi = vi.length, li = yt(fi, vi, gi, xi), li == 1 && (di--, ir(fi, Oo < gi ? io : Li, gi))) : (di == 0 && (li = di = 1), fi = Li.slice()), gi = fi.length, gi < xi && fi.unshift(0), ir(vi, fi, xi), li == -1 && (xi = vi.length, li = yt(Li, vi, Oo, xi), li < 1 && (di++, ir(vi, Oo < xi ? io : Li, xi))), xi = vi.length) : li === 0 && (di++, vi = [0]), Ti[si++] = di, li && vi[0] ? vi[xi++] = _o[Oi] || 0 : (vi = [_o[Oi]], xi = 1);
      while ((Oi++ < Di || vi[0] !== void 0) && Pi--);
    }
    return Ti[0] || Ti.shift(), mi.e = oi, round$4(mi, ai ? ui + getBase10Exponent(mi) + 1 : ui);
  };
})();
function exp(pt, yt) {
  var ir, ti, ii, ui, ai, li, oi = 0, si = 0, di = pt.constructor, fi = di.precision;
  if (getBase10Exponent(pt) > 16) throw Error(exponentOutOfRange + getBase10Exponent(pt));
  if (!pt.s) return new di(ONE);
  for (external = !1, li = fi, ai = new di(0.03125); pt.abs().gte(0.1); )
    pt = pt.times(ai), si += 5;
  for (ti = Math.log(mathpow(2, si)) / Math.LN10 * 2 + 5 | 0, li += ti, ir = ii = ui = new di(ONE), di.precision = li; ; ) {
    if (ii = round$4(ii.times(pt), li), ir = ir.times(++oi), ai = ui.plus(divide(ii, ir, li)), digitsToString(ai.d).slice(0, li) === digitsToString(ui.d).slice(0, li)) {
      for (; si--; ) ui = round$4(ui.times(ui), li);
      return di.precision = fi, yt == null ? (external = !0, round$4(ui, fi)) : ui;
    }
    ui = ai;
  }
}
function getBase10Exponent(pt) {
  for (var yt = pt.e * LOG_BASE, ir = pt.d[0]; ir >= 10; ir /= 10) yt++;
  return yt;
}
function getLn10(pt, yt, ir) {
  if (yt > pt.LN10.sd())
    throw external = !0, ir && (pt.precision = ir), Error(decimalError + "LN10 precision limit exceeded");
  return round$4(new pt(pt.LN10), yt);
}
function getZeroString(pt) {
  for (var yt = ""; pt--; ) yt += "0";
  return yt;
}
function ln$1(pt, yt) {
  var ir, ti, ii, ui, ai, li, oi, si, di, fi = 1, gi = 10, mi = pt, Ti = mi.d, vi = mi.constructor, xi = vi.precision;
  if (mi.s < 1) throw Error(decimalError + (mi.s ? "NaN" : "-Infinity"));
  if (mi.eq(ONE)) return new vi(0);
  if (yt == null ? (external = !1, si = xi) : si = yt, mi.eq(10))
    return yt == null && (external = !0), getLn10(vi, si);
  if (si += gi, vi.precision = si, ir = digitsToString(Ti), ti = ir.charAt(0), ui = getBase10Exponent(mi), Math.abs(ui) < 15e14) {
    for (; ti < 7 && ti != 1 || ti == 1 && ir.charAt(1) > 3; )
      mi = mi.times(pt), ir = digitsToString(mi.d), ti = ir.charAt(0), fi++;
    ui = getBase10Exponent(mi), ti > 1 ? (mi = new vi("0." + ir), ui++) : mi = new vi(ti + "." + ir.slice(1));
  } else
    return oi = getLn10(vi, si + 2, xi).times(ui + ""), mi = ln$1(new vi(ti + "." + ir.slice(1)), si - gi).plus(oi), vi.precision = xi, yt == null ? (external = !0, round$4(mi, xi)) : mi;
  for (li = ai = mi = divide(mi.minus(ONE), mi.plus(ONE), si), di = round$4(mi.times(mi), si), ii = 3; ; ) {
    if (ai = round$4(ai.times(di), si), oi = li.plus(divide(ai, new vi(ii), si)), digitsToString(oi.d).slice(0, si) === digitsToString(li.d).slice(0, si))
      return li = li.times(2), ui !== 0 && (li = li.plus(getLn10(vi, si + 2, xi).times(ui + ""))), li = divide(li, new vi(fi), si), vi.precision = xi, yt == null ? (external = !0, round$4(li, xi)) : li;
    li = oi, ii += 2;
  }
}
function parseDecimal(pt, yt) {
  var ir, ti, ii;
  for ((ir = yt.indexOf(".")) > -1 && (yt = yt.replace(".", "")), (ti = yt.search(/e/i)) > 0 ? (ir < 0 && (ir = ti), ir += +yt.slice(ti + 1), yt = yt.substring(0, ti)) : ir < 0 && (ir = yt.length), ti = 0; yt.charCodeAt(ti) === 48; ) ++ti;
  for (ii = yt.length; yt.charCodeAt(ii - 1) === 48; ) --ii;
  if (yt = yt.slice(ti, ii), yt) {
    if (ii -= ti, ir = ir - ti - 1, pt.e = mathfloor(ir / LOG_BASE), pt.d = [], ti = (ir + 1) % LOG_BASE, ir < 0 && (ti += LOG_BASE), ti < ii) {
      for (ti && pt.d.push(+yt.slice(0, ti)), ii -= LOG_BASE; ti < ii; ) pt.d.push(+yt.slice(ti, ti += LOG_BASE));
      yt = yt.slice(ti), ti = LOG_BASE - yt.length;
    } else
      ti -= ii;
    for (; ti--; ) yt += "0";
    if (pt.d.push(+yt), external && (pt.e > MAX_E || pt.e < -MAX_E)) throw Error(exponentOutOfRange + ir);
  } else
    pt.s = 0, pt.e = 0, pt.d = [0];
  return pt;
}
function round$4(pt, yt, ir) {
  var ti, ii, ui, ai, li, oi, si, di, fi = pt.d;
  for (ai = 1, ui = fi[0]; ui >= 10; ui /= 10) ai++;
  if (ti = yt - ai, ti < 0)
    ti += LOG_BASE, ii = yt, si = fi[di = 0];
  else {
    if (di = Math.ceil((ti + 1) / LOG_BASE), ui = fi.length, di >= ui) return pt;
    for (si = ui = fi[di], ai = 1; ui >= 10; ui /= 10) ai++;
    ti %= LOG_BASE, ii = ti - LOG_BASE + ai;
  }
  if (ir !== void 0 && (ui = mathpow(10, ai - ii - 1), li = si / ui % 10 | 0, oi = yt < 0 || fi[di + 1] !== void 0 || si % ui, oi = ir < 4 ? (li || oi) && (ir == 0 || ir == (pt.s < 0 ? 3 : 2)) : li > 5 || li == 5 && (ir == 4 || oi || ir == 6 && // Check whether the digit to the left of the rounding digit is odd.
  (ti > 0 ? ii > 0 ? si / mathpow(10, ai - ii) : 0 : fi[di - 1]) % 10 & 1 || ir == (pt.s < 0 ? 8 : 7))), yt < 1 || !fi[0])
    return oi ? (ui = getBase10Exponent(pt), fi.length = 1, yt = yt - ui - 1, fi[0] = mathpow(10, (LOG_BASE - yt % LOG_BASE) % LOG_BASE), pt.e = mathfloor(-yt / LOG_BASE) || 0) : (fi.length = 1, fi[0] = pt.e = pt.s = 0), pt;
  if (ti == 0 ? (fi.length = di, ui = 1, di--) : (fi.length = di + 1, ui = mathpow(10, LOG_BASE - ti), fi[di] = ii > 0 ? (si / mathpow(10, ai - ii) % mathpow(10, ii) | 0) * ui : 0), oi)
    for (; ; )
      if (di == 0) {
        (fi[0] += ui) == BASE && (fi[0] = 1, ++pt.e);
        break;
      } else {
        if (fi[di] += ui, fi[di] != BASE) break;
        fi[di--] = 0, ui = 1;
      }
  for (ti = fi.length; fi[--ti] === 0; ) fi.pop();
  if (external && (pt.e > MAX_E || pt.e < -MAX_E))
    throw Error(exponentOutOfRange + getBase10Exponent(pt));
  return pt;
}
function subtract(pt, yt) {
  var ir, ti, ii, ui, ai, li, oi, si, di, fi, gi = pt.constructor, mi = gi.precision;
  if (!pt.s || !yt.s)
    return yt.s ? yt.s = -yt.s : yt = new gi(pt), external ? round$4(yt, mi) : yt;
  if (oi = pt.d, fi = yt.d, ti = yt.e, si = pt.e, oi = oi.slice(), ai = si - ti, ai) {
    for (di = ai < 0, di ? (ir = oi, ai = -ai, li = fi.length) : (ir = fi, ti = si, li = oi.length), ii = Math.max(Math.ceil(mi / LOG_BASE), li) + 2, ai > ii && (ai = ii, ir.length = 1), ir.reverse(), ii = ai; ii--; ) ir.push(0);
    ir.reverse();
  } else {
    for (ii = oi.length, li = fi.length, di = ii < li, di && (li = ii), ii = 0; ii < li; ii++)
      if (oi[ii] != fi[ii]) {
        di = oi[ii] < fi[ii];
        break;
      }
    ai = 0;
  }
  for (di && (ir = oi, oi = fi, fi = ir, yt.s = -yt.s), li = oi.length, ii = fi.length - li; ii > 0; --ii) oi[li++] = 0;
  for (ii = fi.length; ii > ai; ) {
    if (oi[--ii] < fi[ii]) {
      for (ui = ii; ui && oi[--ui] === 0; ) oi[ui] = BASE - 1;
      --oi[ui], oi[ii] += BASE;
    }
    oi[ii] -= fi[ii];
  }
  for (; oi[--li] === 0; ) oi.pop();
  for (; oi[0] === 0; oi.shift()) --ti;
  return oi[0] ? (yt.d = oi, yt.e = ti, external ? round$4(yt, mi) : yt) : new gi(0);
}
function toString(pt, yt, ir) {
  var ti, ii = getBase10Exponent(pt), ui = digitsToString(pt.d), ai = ui.length;
  return yt ? (ir && (ti = ir - ai) > 0 ? ui = ui.charAt(0) + "." + ui.slice(1) + getZeroString(ti) : ai > 1 && (ui = ui.charAt(0) + "." + ui.slice(1)), ui = ui + (ii < 0 ? "e" : "e+") + ii) : ii < 0 ? (ui = "0." + getZeroString(-ii - 1) + ui, ir && (ti = ir - ai) > 0 && (ui += getZeroString(ti))) : ii >= ai ? (ui += getZeroString(ii + 1 - ai), ir && (ti = ir - ii - 1) > 0 && (ui = ui + "." + getZeroString(ti))) : ((ti = ii + 1) < ai && (ui = ui.slice(0, ti) + "." + ui.slice(ti)), ir && (ti = ir - ai) > 0 && (ii + 1 === ai && (ui += "."), ui += getZeroString(ti))), pt.s < 0 ? "-" + ui : ui;
}
function truncate(pt, yt) {
  if (pt.length > yt)
    return pt.length = yt, !0;
}
function clone(pt) {
  var yt, ir, ti;
  function ii(ui) {
    var ai = this;
    if (!(ai instanceof ii)) return new ii(ui);
    if (ai.constructor = ii, ui instanceof ii) {
      ai.s = ui.s, ai.e = ui.e, ai.d = (ui = ui.d) ? ui.slice() : ui;
      return;
    }
    if (typeof ui == "number") {
      if (ui * 0 !== 0)
        throw Error(invalidArgument + ui);
      if (ui > 0)
        ai.s = 1;
      else if (ui < 0)
        ui = -ui, ai.s = -1;
      else {
        ai.s = 0, ai.e = 0, ai.d = [0];
        return;
      }
      if (ui === ~~ui && ui < 1e7) {
        ai.e = 0, ai.d = [ui];
        return;
      }
      return parseDecimal(ai, ui.toString());
    } else if (typeof ui != "string")
      throw Error(invalidArgument + ui);
    if (ui.charCodeAt(0) === 45 ? (ui = ui.slice(1), ai.s = -1) : ai.s = 1, isDecimal.test(ui)) parseDecimal(ai, ui);
    else throw Error(invalidArgument + ui);
  }
  if (ii.prototype = P$5, ii.ROUND_UP = 0, ii.ROUND_DOWN = 1, ii.ROUND_CEIL = 2, ii.ROUND_FLOOR = 3, ii.ROUND_HALF_UP = 4, ii.ROUND_HALF_DOWN = 5, ii.ROUND_HALF_EVEN = 6, ii.ROUND_HALF_CEIL = 7, ii.ROUND_HALF_FLOOR = 8, ii.clone = clone, ii.config = ii.set = config$1, pt === void 0 && (pt = {}), pt)
    for (ti = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"], yt = 0; yt < ti.length; ) pt.hasOwnProperty(ir = ti[yt++]) || (pt[ir] = this[ir]);
  return ii.config(pt), ii;
}
function config$1(pt) {
  if (!pt || typeof pt != "object")
    throw Error(decimalError + "Object expected");
  var yt, ir, ti, ii = [
    "precision",
    1,
    MAX_DIGITS,
    "rounding",
    0,
    8,
    "toExpNeg",
    -1 / 0,
    0,
    "toExpPos",
    0,
    1 / 0
  ];
  for (yt = 0; yt < ii.length; yt += 3)
    if ((ti = pt[ir = ii[yt]]) !== void 0)
      if (mathfloor(ti) === ti && ti >= ii[yt + 1] && ti <= ii[yt + 2]) this[ir] = ti;
      else throw Error(invalidArgument + ir + ": " + ti);
  if ((ti = pt[ir = "LN10"]) !== void 0)
    if (ti == Math.LN10) this[ir] = new this(ti);
    else throw Error(invalidArgument + ir + ": " + ti);
  return this;
}
var Decimal = clone(defaults);
ONE = new Decimal(1);
const Decimal$1 = Decimal;
function getDigitCount(pt) {
  var yt;
  return pt === 0 ? yt = 1 : yt = Math.floor(new Decimal$1(pt).abs().log(10).toNumber()) + 1, yt;
}
function rangeStep(pt, yt, ir) {
  for (var ti = new Decimal$1(pt), ii = 0, ui = []; ti.lt(yt) && ii < 1e5; )
    ui.push(ti.toNumber()), ti = ti.add(ir), ii++;
  return ui;
}
var getValidInterval = (pt) => {
  var [yt, ir] = pt, [ti, ii] = [yt, ir];
  return yt > ir && ([ti, ii] = [ir, yt]), [ti, ii];
}, getAdaptiveStep = (pt, yt, ir) => {
  if (pt.lte(0))
    return new Decimal$1(0);
  var ti = getDigitCount(pt.toNumber()), ii = new Decimal$1(10).pow(ti), ui = pt.div(ii), ai = ti !== 1 ? 0.05 : 0.1, li = new Decimal$1(Math.ceil(ui.div(ai).toNumber())).add(ir).mul(ai), oi = li.mul(ii);
  return yt ? new Decimal$1(oi.toNumber()) : new Decimal$1(Math.ceil(oi.toNumber()));
}, getSnap125Step = (pt, yt, ir) => {
  var ti;
  if (pt.lte(0))
    return new Decimal$1(0);
  var ii = [1, 2, 2.5, 5], ui = pt.toNumber(), ai = Math.floor(new Decimal$1(ui).abs().log(10).toNumber()), li = new Decimal$1(10).pow(ai), oi = pt.div(li).toNumber(), si = ii.findIndex((mi) => mi >= oi - 1e-10);
  if (si === -1 && (li = li.mul(10), si = 0), si += ir, si >= ii.length) {
    var di = Math.floor(si / ii.length);
    si %= ii.length, li = li.mul(new Decimal$1(10).pow(di));
  }
  var fi = (ti = ii[si]) !== null && ti !== void 0 ? ti : 1, gi = new Decimal$1(fi).mul(li);
  return yt ? gi : new Decimal$1(Math.ceil(gi.toNumber()));
}, getTickOfSingleValue = (pt, yt, ir) => {
  var ti = new Decimal$1(1), ii = new Decimal$1(pt);
  if (!ii.isint() && ir) {
    var ui = Math.abs(pt);
    ui < 1 ? (ti = new Decimal$1(10).pow(getDigitCount(pt) - 1), ii = new Decimal$1(Math.floor(ii.div(ti).toNumber())).mul(ti)) : ui > 1 && (ii = new Decimal$1(Math.floor(pt)));
  } else pt === 0 ? ii = new Decimal$1(Math.floor((yt - 1) / 2)) : ir || (ii = new Decimal$1(Math.floor(pt)));
  for (var ai = Math.floor((yt - 1) / 2), li = [], oi = 0; oi < yt; oi++)
    li.push(ii.add(new Decimal$1(oi - ai).mul(ti)).toNumber());
  return li;
}, _calculateStep = function(pt, yt, ir, ti) {
  var ii = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, ui = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : getAdaptiveStep;
  if (!Number.isFinite((yt - pt) / (ir - 1)))
    return {
      step: new Decimal$1(0),
      tickMin: new Decimal$1(0),
      tickMax: new Decimal$1(0)
    };
  var ai = ui(new Decimal$1(yt).sub(pt).div(ir - 1), ti, ii), li;
  pt <= 0 && yt >= 0 ? li = new Decimal$1(0) : (li = new Decimal$1(pt).add(yt).div(2), li = li.sub(new Decimal$1(li).mod(ai)));
  var oi = Math.ceil(li.sub(pt).div(ai).toNumber()), si = Math.ceil(new Decimal$1(yt).sub(li).div(ai).toNumber()), di = oi + si + 1;
  return di > ir ? _calculateStep(pt, yt, ir, ti, ii + 1, ui) : (di < ir && (si = yt > 0 ? si + (ir - di) : si, oi = yt > 0 ? oi : oi + (ir - di)), {
    step: ai,
    tickMin: li.sub(new Decimal$1(oi).mul(ai)),
    tickMax: li.add(new Decimal$1(si).mul(ai))
  });
}, getNiceTickValues = function(pt) {
  var [yt, ir] = pt, ti = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, ii = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, ui = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "auto", ai = Math.max(ti, 2), [li, oi] = getValidInterval([yt, ir]);
  if (li === -1 / 0 || oi === 1 / 0) {
    var si = oi === 1 / 0 ? [li, ...Array(ti - 1).fill(1 / 0)] : [...Array(ti - 1).fill(-1 / 0), oi];
    return yt > ir ? si.reverse() : si;
  }
  if (li === oi)
    return getTickOfSingleValue(li, ti, ii);
  var di = ui === "snap125" ? getSnap125Step : getAdaptiveStep, {
    step: fi,
    tickMin: gi,
    tickMax: mi
  } = _calculateStep(li, oi, ai, ii, 0, di), Ti = rangeStep(gi, mi.add(new Decimal$1(0.1).mul(fi)), fi);
  return yt > ir ? Ti.reverse() : Ti;
}, getTickValuesFixedDomain = function(pt, yt) {
  var [ir, ti] = pt, ii = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, ui = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "auto", [ai, li] = getValidInterval([ir, ti]);
  if (ai === -1 / 0 || li === 1 / 0)
    return [ir, ti];
  if (ai === li)
    return [ai];
  var oi = ui === "snap125" ? getSnap125Step : getAdaptiveStep, si = Math.max(yt, 2), di = oi(new Decimal$1(li).sub(ai).div(si - 1), ii, 0), fi = [...rangeStep(new Decimal$1(ai), new Decimal$1(li), di), li];
  return ii === !1 && (fi = fi.map((gi) => Math.round(gi))), ir > ti ? fi.reverse() : fi;
}, selectRootMaxBarSize = (pt) => pt.rootProps.maxBarSize, selectBarGap = (pt) => pt.rootProps.barGap, selectBarCategoryGap = (pt) => pt.rootProps.barCategoryGap, selectRootBarSize = (pt) => pt.rootProps.barSize, selectStackOffsetType = (pt) => pt.rootProps.stackOffset, selectReverseStackOrder = (pt) => pt.rootProps.reverseStackOrder, selectChartName = (pt) => pt.options.chartName, DefaultZIndexes = {
  /**
   * CartesianGrid and PolarGrid
   */
  grid: -100,
  /**
   * Background of Bar and RadialBar.
   * This is not visible by default but can be enabled by setting background={true} on Bar or RadialBar.
   */
  barBackground: -50,
  /*
   * other chart elements or custom elements without specific zIndex
   * render in here, at zIndex 0
   */
  /**
   * Area, Pie, Radar, and ReferenceArea
   */
  area: 100,
  /**
   * Cursor is embedded inside Tooltip and controlled by it.
   * The Tooltip itself has a separate portal and is not included in the zIndex system;
   * Cursor is the decoration inside the chart area. CursorRectangle is a rectangle box.
   * It renders below bar so that in a stacked bar chart the cursor rectangle does not hide the other bars.
   */
  cursorRectangle: 200,
  /**
   * Bar and RadialBar
   */
  bar: 300,
  /**
   * Line and ReferenceLine, and ErrorBor
   */
  line: 400,
  /**
   * XAxis and YAxis and PolarAngleAxis and PolarRadiusAxis ticks and lines and children
   */
  axis: 500,
  /**
   * Scatter and ReferenceDot,
   * and Dots of Line and Area and Radar if they have dot=true
   */
  scatter: 600,
  /**
   * Hovering over a Bar or RadialBar renders a highlight rectangle
   */
  activeBar: 1e3,
  /**
   * Cursor is embedded inside Tooltip and controlled by it.
   * The Tooltip itself has a separate portal and is not included in the zIndex system;
   * Cursor is the decoration inside the chart area, usually a cross or a box.
   * CursorLine is a line cursor rendered in Line, Area, Scatter, Radar charts.
   * It renders above the Line and Scatter so that it is always visible.
   * It renders below active dot so that the dot is always visible and shows the current point.
   * We're also assuming that the active dot is small enough that it does not fully cover the cursor line.
   *
   * This also applies to the radial cursor in RadialBarChart.
   */
  cursorLine: 1100,
  /**
   * Hovering over a Point in Line, Area, Scatter, Radar renders a highlight dot
   */
  activeDot: 1200,
  /**
   * LabelList and Label, including Axis labels
   */
  label: 2e3
}, defaultPolarAngleAxisProps = {
  allowDecimals: !1,
  // if I set this to false then Tooltip synchronisation stops working in Radar, wtf
  allowDataOverflow: !1,
  angleAxisId: 0,
  reversed: !1,
  scale: "auto",
  tick: !0,
  type: "auto"
}, defaultPolarRadiusAxisProps = {
  allowDataOverflow: !1,
  allowDecimals: !1,
  allowDuplicatedCategory: !0,
  includeHidden: !1,
  radiusAxisId: 0,
  reversed: !1,
  scale: "auto",
  tick: !0,
  tickCount: 5,
  type: "auto"
}, combineAxisRangeWithReverse = (pt, yt) => {
  if (!(!pt || !yt))
    return pt != null && pt.reversed ? [yt[1], yt[0]] : yt;
};
function getAxisTypeBasedOnLayout(pt, yt, ir) {
  if (ir !== "auto")
    return ir;
  if (pt != null)
    return isCategoricalAxis(pt, yt) ? "category" : "number";
}
function ownKeys$o(pt, yt) {
  var ir = Object.keys(pt);
  if (Object.getOwnPropertySymbols) {
    var ti = Object.getOwnPropertySymbols(pt);
    yt && (ti = ti.filter(function(ii) {
      return Object.getOwnPropertyDescriptor(pt, ii).enumerable;
    })), ir.push.apply(ir, ti);
  }
  return ir;
}
function _objectSpread$o(pt) {
  for (var yt = 1; yt < arguments.length; yt++) {
    var ir = arguments[yt] != null ? arguments[yt] : {};
    yt % 2 ? ownKeys$o(Object(ir), !0).forEach(function(ti) {
      _defineProperty$q(pt, ti, ir[ti]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(pt, Object.getOwnPropertyDescriptors(ir)) : ownKeys$o(Object(ir)).forEach(function(ti) {
      Object.defineProperty(pt, ti, Object.getOwnPropertyDescriptor(ir, ti));
    });
  }
  return pt;
}
function _defineProperty$q(pt, yt, ir) {
  return (yt = _toPropertyKey$q(yt)) in pt ? Object.defineProperty(pt, yt, { value: ir, enumerable: !0, configurable: !0, writable: !0 }) : pt[yt] = ir, pt;
}
function _toPropertyKey$q(pt) {
  var yt = _toPrimitive$q(pt, "string");
  return typeof yt == "symbol" ? yt : yt + "";
}
function _toPrimitive$q(pt, yt) {
  if (typeof pt != "object" || !pt) return pt;
  var ir = pt[Symbol.toPrimitive];
  if (ir !== void 0) {
    var ti = ir.call(pt, yt);
    if (typeof ti != "object") return ti;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (yt === "string" ? String : Number)(pt);
}
var implicitAngleAxis = {
  allowDataOverflow: defaultPolarAngleAxisProps.allowDataOverflow,
  allowDecimals: defaultPolarAngleAxisProps.allowDecimals,
  allowDuplicatedCategory: !1,
  // defaultPolarAngleAxisProps.allowDuplicatedCategory has it set to true but the actual axis rendering ignores the prop because reasons,
  dataKey: void 0,
  domain: void 0,
  id: defaultPolarAngleAxisProps.angleAxisId,
  includeHidden: !1,
  name: void 0,
  reversed: defaultPolarAngleAxisProps.reversed,
  scale: defaultPolarAngleAxisProps.scale,
  tick: defaultPolarAngleAxisProps.tick,
  tickCount: void 0,
  ticks: void 0,
  type: defaultPolarAngleAxisProps.type,
  unit: void 0,
  niceTicks: "auto"
}, implicitRadiusAxis = {
  allowDataOverflow: defaultPolarRadiusAxisProps.allowDataOverflow,
  allowDecimals: defaultPolarRadiusAxisProps.allowDecimals,
  allowDuplicatedCategory: defaultPolarRadiusAxisProps.allowDuplicatedCategory,
  dataKey: void 0,
  domain: void 0,
  id: defaultPolarRadiusAxisProps.radiusAxisId,
  includeHidden: defaultPolarRadiusAxisProps.includeHidden,
  name: void 0,
  reversed: defaultPolarRadiusAxisProps.reversed,
  scale: defaultPolarRadiusAxisProps.scale,
  tick: defaultPolarRadiusAxisProps.tick,
  tickCount: defaultPolarRadiusAxisProps.tickCount,
  ticks: void 0,
  type: defaultPolarRadiusAxisProps.type,
  unit: void 0,
  niceTicks: "auto"
}, selectAngleAxisNoDefaults = (pt, yt) => {
  if (yt != null)
    return pt.polarAxis.angleAxis[yt];
}, selectAngleAxis = createSelector([selectAngleAxisNoDefaults, selectPolarChartLayout], (pt, yt) => {
  var ir;
  if (pt != null)
    return pt;
  var ti = (ir = getAxisTypeBasedOnLayout(yt, "angleAxis", implicitAngleAxis.type)) !== null && ir !== void 0 ? ir : "category";
  return _objectSpread$o(_objectSpread$o({}, implicitAngleAxis), {}, {
    type: ti
  });
}), selectRadiusAxisNoDefaults = (pt, yt) => pt.polarAxis.radiusAxis[yt], selectRadiusAxis = createSelector([selectRadiusAxisNoDefaults, selectPolarChartLayout], (pt, yt) => {
  var ir;
  if (pt != null)
    return pt;
  var ti = (ir = getAxisTypeBasedOnLayout(yt, "radiusAxis", implicitRadiusAxis.type)) !== null && ir !== void 0 ? ir : "category";
  return _objectSpread$o(_objectSpread$o({}, implicitRadiusAxis), {}, {
    type: ti
  });
}), selectPolarOptions = (pt) => pt.polarOptions, selectMaxRadius = createSelector([selectChartWidth, selectChartHeight, selectChartOffsetInternal], getMaxRadius), selectInnerRadius = createSelector([selectPolarOptions, selectMaxRadius], (pt, yt) => {
  if (pt != null)
    return getPercentValue(pt.innerRadius, yt, 0);
}), selectOuterRadius = createSelector([selectPolarOptions, selectMaxRadius], (pt, yt) => {
  if (pt != null)
    return getPercentValue(pt.outerRadius, yt, yt * 0.8);
}), combineAngleAxisRange = (pt) => {
  if (pt == null)
    return [0, 0];
  var {
    startAngle: yt,
    endAngle: ir
  } = pt;
  return [yt, ir];
}, selectAngleAxisRange = createSelector([selectPolarOptions], combineAngleAxisRange);
createSelector([selectAngleAxis, selectAngleAxisRange], combineAxisRangeWithReverse);
var selectRadiusAxisRange = createSelector([selectMaxRadius, selectInnerRadius, selectOuterRadius], (pt, yt, ir) => {
  if (!(pt == null || yt == null || ir == null))
    return [yt, ir];
});
createSelector([selectRadiusAxis, selectRadiusAxisRange], combineAxisRangeWithReverse);
var selectPolarViewBox = createSelector([selectChartLayout, selectPolarOptions, selectInnerRadius, selectOuterRadius, selectChartWidth, selectChartHeight], (pt, yt, ir, ti, ii, ui) => {
  if (!(pt !== "centric" && pt !== "radial" || yt == null || ir == null || ti == null)) {
    var {
      cx: ai,
      cy: li,
      startAngle: oi,
      endAngle: si
    } = yt;
    return {
      cx: getPercentValue(ai, ii, ii / 2),
      cy: getPercentValue(li, ui, ui / 2),
      innerRadius: ir,
      outerRadius: ti,
      startAngle: oi,
      endAngle: si,
      clockWise: !1
      // this property look useful, why not use it?
    };
  }
}), pickAxisType = (pt, yt) => yt, pickAxisId = (pt, yt, ir) => ir;
function getStackSeriesIdentifier(pt) {
  return pt == null ? void 0 : pt.id;
}
function combineDisplayedStackedData(pt, yt, ir) {
  var {
    chartData: ti = []
  } = yt, {
    allowDuplicatedCategory: ii,
    dataKey: ui
  } = ir, ai = /* @__PURE__ */ new Map();
  return pt.forEach((li) => {
    var oi, si = (oi = li.data) !== null && oi !== void 0 ? oi : ti;
    if (!(si == null || si.length === 0)) {
      var di = getStackSeriesIdentifier(li);
      si.forEach((fi, gi) => {
        var mi = ui == null || ii ? gi : String(getValueByDataKey(fi, ui, null)), Ti = getValueByDataKey(fi, li.dataKey, 0), vi;
        ai.has(mi) ? vi = ai.get(mi) : vi = {}, Object.assign(vi, {
          [di]: Ti
        }), ai.set(mi, vi);
      });
    }
  }), Array.from(ai.values());
}
function isStacked(pt) {
  return "stackId" in pt && pt.stackId != null && pt.dataKey != null;
}
var numberDomainEqualityCheck = (pt, yt) => pt === yt ? !0 : pt == null || yt == null ? !1 : pt[0] === yt[0] && pt[1] === yt[1];
function emptyArraysAreEqualCheck(pt, yt) {
  return Array.isArray(pt) && Array.isArray(yt) && pt.length === 0 && yt.length === 0 ? !0 : pt === yt;
}
function arrayContentsAreEqualCheck(pt, yt) {
  if (pt.length === yt.length) {
    for (var ir = 0; ir < pt.length; ir++)
      if (pt[ir] !== yt[ir])
        return !1;
    return !0;
  }
  return !1;
}
var selectTooltipAxisType = (pt) => {
  var yt = selectChartLayout(pt);
  return yt === "horizontal" ? "xAxis" : yt === "vertical" ? "yAxis" : yt === "centric" ? "angleAxis" : "radiusAxis";
}, selectTooltipAxisId = (pt) => pt.tooltip.settings.axisId;
function rechartsScaleFactory(pt) {
  if (pt != null) {
    var yt = pt.ticks, ir = pt.bandwidth, ti = pt.range(), ii = [Math.min(...ti), Math.max(...ti)];
    return {
      domain: () => pt.domain(),
      range: (function(ui) {
        function ai() {
          return ui.apply(this, arguments);
        }
        return ai.toString = function() {
          return ui.toString();
        }, ai;
      })(() => ii),
      rangeMin: () => ii[0],
      rangeMax: () => ii[1],
      isInRange(ui) {
        var ai = ii[0], li = ii[1];
        return ai <= li ? ui >= ai && ui <= li : ui >= li && ui <= ai;
      },
      bandwidth: ir ? () => ir.call(pt) : void 0,
      ticks: yt ? (ui) => yt.call(pt, ui) : void 0,
      map: (ui, ai) => {
        var li = pt(ui);
        if (li != null) {
          if (pt.bandwidth && ai !== null && ai !== void 0 && ai.position) {
            var oi = pt.bandwidth();
            switch (ai.position) {
              case "middle":
                li += oi / 2;
                break;
              case "end":
                li += oi;
                break;
            }
          }
          return li;
        }
      }
    };
  }
}
var combineCheckedDomain = (pt, yt) => {
  if (yt != null)
    switch (pt) {
      case "linear": {
        if (!isWellFormedNumberDomain(yt)) {
          for (var ir, ti, ii = 0; ii < yt.length; ii++) {
            var ui = yt[ii];
            isWellBehavedNumber(ui) && ((ir === void 0 || ui < ir) && (ir = ui), (ti === void 0 || ui > ti) && (ti = ui));
          }
          return ir !== void 0 && ti !== void 0 ? [ir, ti] : void 0;
        }
        return yt;
      }
      default:
        return yt;
    }
};
function ascending(pt, yt) {
  return pt == null || yt == null ? NaN : pt < yt ? -1 : pt > yt ? 1 : pt >= yt ? 0 : NaN;
}
function descending(pt, yt) {
  return pt == null || yt == null ? NaN : yt < pt ? -1 : yt > pt ? 1 : yt >= pt ? 0 : NaN;
}
function bisector(pt) {
  let yt, ir, ti;
  pt.length !== 2 ? (yt = ascending, ir = (li, oi) => ascending(pt(li), oi), ti = (li, oi) => pt(li) - oi) : (yt = pt === ascending || pt === descending ? pt : zero$1, ir = pt, ti = pt);
  function ii(li, oi, si = 0, di = li.length) {
    if (si < di) {
      if (yt(oi, oi) !== 0) return di;
      do {
        const fi = si + di >>> 1;
        ir(li[fi], oi) < 0 ? si = fi + 1 : di = fi;
      } while (si < di);
    }
    return si;
  }
  function ui(li, oi, si = 0, di = li.length) {
    if (si < di) {
      if (yt(oi, oi) !== 0) return di;
      do {
        const fi = si + di >>> 1;
        ir(li[fi], oi) <= 0 ? si = fi + 1 : di = fi;
      } while (si < di);
    }
    return si;
  }
  function ai(li, oi, si = 0, di = li.length) {
    const fi = ii(li, oi, si, di - 1);
    return fi > si && ti(li[fi - 1], oi) > -ti(li[fi], oi) ? fi - 1 : fi;
  }
  return { left: ii, center: ai, right: ui };
}
function zero$1() {
  return 0;
}
function number$2(pt) {
  return pt === null ? NaN : +pt;
}
function* numbers(pt, yt) {
  for (let ir of pt)
    ir != null && (ir = +ir) >= ir && (yield ir);
}
const ascendingBisect = bisector(ascending), bisectRight = ascendingBisect.right;
bisector(number$2).center;
class InternMap extends Map {
  constructor(yt, ir = keyof) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: ir } }), yt != null) for (const [ti, ii] of yt) this.set(ti, ii);
  }
  get(yt) {
    return super.get(intern_get(this, yt));
  }
  has(yt) {
    return super.has(intern_get(this, yt));
  }
  set(yt, ir) {
    return super.set(intern_set(this, yt), ir);
  }
  delete(yt) {
    return super.delete(intern_delete(this, yt));
  }
}
function intern_get({ _intern: pt, _key: yt }, ir) {
  const ti = yt(ir);
  return pt.has(ti) ? pt.get(ti) : ir;
}
function intern_set({ _intern: pt, _key: yt }, ir) {
  const ti = yt(ir);
  return pt.has(ti) ? pt.get(ti) : (pt.set(ti, ir), ir);
}
function intern_delete({ _intern: pt, _key: yt }, ir) {
  const ti = yt(ir);
  return pt.has(ti) && (ir = pt.get(ti), pt.delete(ti)), ir;
}
function keyof(pt) {
  return pt !== null && typeof pt == "object" ? pt.valueOf() : pt;
}
function compareDefined(pt = ascending) {
  if (pt === ascending) return ascendingDefined;
  if (typeof pt != "function") throw new TypeError("compare is not a function");
  return (yt, ir) => {
    const ti = pt(yt, ir);
    return ti || ti === 0 ? ti : (pt(ir, ir) === 0) - (pt(yt, yt) === 0);
  };
}
function ascendingDefined(pt, yt) {
  return (pt == null || !(pt >= pt)) - (yt == null || !(yt >= yt)) || (pt < yt ? -1 : pt > yt ? 1 : 0);
}
const e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
function tickSpec(pt, yt, ir) {
  const ti = (yt - pt) / Math.max(0, ir), ii = Math.floor(Math.log10(ti)), ui = ti / Math.pow(10, ii), ai = ui >= e10 ? 10 : ui >= e5 ? 5 : ui >= e2 ? 2 : 1;
  let li, oi, si;
  return ii < 0 ? (si = Math.pow(10, -ii) / ai, li = Math.round(pt * si), oi = Math.round(yt * si), li / si < pt && ++li, oi / si > yt && --oi, si = -si) : (si = Math.pow(10, ii) * ai, li = Math.round(pt / si), oi = Math.round(yt / si), li * si < pt && ++li, oi * si > yt && --oi), oi < li && 0.5 <= ir && ir < 2 ? tickSpec(pt, yt, ir * 2) : [li, oi, si];
}
function ticks(pt, yt, ir) {
  if (yt = +yt, pt = +pt, ir = +ir, !(ir > 0)) return [];
  if (pt === yt) return [pt];
  const ti = yt < pt, [ii, ui, ai] = ti ? tickSpec(yt, pt, ir) : tickSpec(pt, yt, ir);
  if (!(ui >= ii)) return [];
  const li = ui - ii + 1, oi = new Array(li);
  if (ti)
    if (ai < 0) for (let si = 0; si < li; ++si) oi[si] = (ui - si) / -ai;
    else for (let si = 0; si < li; ++si) oi[si] = (ui - si) * ai;
  else if (ai < 0) for (let si = 0; si < li; ++si) oi[si] = (ii + si) / -ai;
  else for (let si = 0; si < li; ++si) oi[si] = (ii + si) * ai;
  return oi;
}
function tickIncrement(pt, yt, ir) {
  return yt = +yt, pt = +pt, ir = +ir, tickSpec(pt, yt, ir)[2];
}
function tickStep(pt, yt, ir) {
  yt = +yt, pt = +pt, ir = +ir;
  const ti = yt < pt, ii = ti ? tickIncrement(yt, pt, ir) : tickIncrement(pt, yt, ir);
  return (ti ? -1 : 1) * (ii < 0 ? 1 / -ii : ii);
}
function max(pt, yt) {
  let ir;
  for (const ti of pt)
    ti != null && (ir < ti || ir === void 0 && ti >= ti) && (ir = ti);
  return ir;
}
function min(pt, yt) {
  let ir;
  for (const ti of pt)
    ti != null && (ir > ti || ir === void 0 && ti >= ti) && (ir = ti);
  return ir;
}
function quickselect(pt, yt, ir = 0, ti = 1 / 0, ii) {
  if (yt = Math.floor(yt), ir = Math.floor(Math.max(0, ir)), ti = Math.floor(Math.min(pt.length - 1, ti)), !(ir <= yt && yt <= ti)) return pt;
  for (ii = ii === void 0 ? ascendingDefined : compareDefined(ii); ti > ir; ) {
    if (ti - ir > 600) {
      const oi = ti - ir + 1, si = yt - ir + 1, di = Math.log(oi), fi = 0.5 * Math.exp(2 * di / 3), gi = 0.5 * Math.sqrt(di * fi * (oi - fi) / oi) * (si - oi / 2 < 0 ? -1 : 1), mi = Math.max(ir, Math.floor(yt - si * fi / oi + gi)), Ti = Math.min(ti, Math.floor(yt + (oi - si) * fi / oi + gi));
      quickselect(pt, yt, mi, Ti, ii);
    }
    const ui = pt[yt];
    let ai = ir, li = ti;
    for (swap(pt, ir, yt), ii(pt[ti], ui) > 0 && swap(pt, ir, ti); ai < li; ) {
      for (swap(pt, ai, li), ++ai, --li; ii(pt[ai], ui) < 0; ) ++ai;
      for (; ii(pt[li], ui) > 0; ) --li;
    }
    ii(pt[ir], ui) === 0 ? swap(pt, ir, li) : (++li, swap(pt, li, ti)), li <= yt && (ir = li + 1), yt <= li && (ti = li - 1);
  }
  return pt;
}
function swap(pt, yt, ir) {
  const ti = pt[yt];
  pt[yt] = pt[ir], pt[ir] = ti;
}
function quantile$1(pt, yt, ir) {
  if (pt = Float64Array.from(numbers(pt)), !(!(ti = pt.length) || isNaN(yt = +yt))) {
    if (yt <= 0 || ti < 2) return min(pt);
    if (yt >= 1) return max(pt);
    var ti, ii = (ti - 1) * yt, ui = Math.floor(ii), ai = max(quickselect(pt, ui).subarray(0, ui + 1)), li = min(pt.subarray(ui + 1));
    return ai + (li - ai) * (ii - ui);
  }
}
function quantileSorted(pt, yt, ir = number$2) {
  if (!(!(ti = pt.length) || isNaN(yt = +yt))) {
    if (yt <= 0 || ti < 2) return +ir(pt[0], 0, pt);
    if (yt >= 1) return +ir(pt[ti - 1], ti - 1, pt);
    var ti, ii = (ti - 1) * yt, ui = Math.floor(ii), ai = +ir(pt[ui], ui, pt), li = +ir(pt[ui + 1], ui + 1, pt);
    return ai + (li - ai) * (ii - ui);
  }
}
function range(pt, yt, ir) {
  pt = +pt, yt = +yt, ir = (ii = arguments.length) < 2 ? (yt = pt, pt = 0, 1) : ii < 3 ? 1 : +ir;
  for (var ti = -1, ii = Math.max(0, Math.ceil((yt - pt) / ir)) | 0, ui = new Array(ii); ++ti < ii; )
    ui[ti] = pt + ti * ir;
  return ui;
}
function initRange(pt, yt) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(pt);
      break;
    default:
      this.range(yt).domain(pt);
      break;
  }
  return this;
}
function initInterpolator(pt, yt) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof pt == "function" ? this.interpolator(pt) : this.range(pt);
      break;
    }
    default: {
      this.domain(pt), typeof yt == "function" ? this.interpolator(yt) : this.range(yt);
      break;
    }
  }
  return this;
}
const implicit = Symbol("implicit");
function ordinal() {
  var pt = new InternMap(), yt = [], ir = [], ti = implicit;
  function ii(ui) {
    let ai = pt.get(ui);
    if (ai === void 0) {
      if (ti !== implicit) return ti;
      pt.set(ui, ai = yt.push(ui) - 1);
    }
    return ir[ai % ir.length];
  }
  return ii.domain = function(ui) {
    if (!arguments.length) return yt.slice();
    yt = [], pt = new InternMap();
    for (const ai of ui)
      pt.has(ai) || pt.set(ai, yt.push(ai) - 1);
    return ii;
  }, ii.range = function(ui) {
    return arguments.length ? (ir = Array.from(ui), ii) : ir.slice();
  }, ii.unknown = function(ui) {
    return arguments.length ? (ti = ui, ii) : ti;
  }, ii.copy = function() {
    return ordinal(yt, ir).unknown(ti);
  }, initRange.apply(ii, arguments), ii;
}
function band() {
  var pt = ordinal().unknown(void 0), yt = pt.domain, ir = pt.range, ti = 0, ii = 1, ui, ai, li = !1, oi = 0, si = 0, di = 0.5;
  delete pt.unknown;
  function fi() {
    var gi = yt().length, mi = ii < ti, Ti = mi ? ii : ti, vi = mi ? ti : ii;
    ui = (vi - Ti) / Math.max(1, gi - oi + si * 2), li && (ui = Math.floor(ui)), Ti += (vi - Ti - ui * (gi - oi)) * di, ai = ui * (1 - oi), li && (Ti = Math.round(Ti), ai = Math.round(ai));
    var xi = range(gi).map(function(Si) {
      return Ti + ui * Si;
    });
    return ir(mi ? xi.reverse() : xi);
  }
  return pt.domain = function(gi) {
    return arguments.length ? (yt(gi), fi()) : yt();
  }, pt.range = function(gi) {
    return arguments.length ? ([ti, ii] = gi, ti = +ti, ii = +ii, fi()) : [ti, ii];
  }, pt.rangeRound = function(gi) {
    return [ti, ii] = gi, ti = +ti, ii = +ii, li = !0, fi();
  }, pt.bandwidth = function() {
    return ai;
  }, pt.step = function() {
    return ui;
  }, pt.round = function(gi) {
    return arguments.length ? (li = !!gi, fi()) : li;
  }, pt.padding = function(gi) {
    return arguments.length ? (oi = Math.min(1, si = +gi), fi()) : oi;
  }, pt.paddingInner = function(gi) {
    return arguments.length ? (oi = Math.min(1, gi), fi()) : oi;
  }, pt.paddingOuter = function(gi) {
    return arguments.length ? (si = +gi, fi()) : si;
  }, pt.align = function(gi) {
    return arguments.length ? (di = Math.max(0, Math.min(1, gi)), fi()) : di;
  }, pt.copy = function() {
    return band(yt(), [ti, ii]).round(li).paddingInner(oi).paddingOuter(si).align(di);
  }, initRange.apply(fi(), arguments);
}
function pointish(pt) {
  var yt = pt.copy;
  return pt.padding = pt.paddingOuter, delete pt.paddingInner, delete pt.paddingOuter, pt.copy = function() {
    return pointish(yt());
  }, pt;
}
function point() {
  return pointish(band.apply(null, arguments).paddingInner(1));
}
function define$1(pt, yt, ir) {
  pt.prototype = yt.prototype = ir, ir.constructor = pt;
}
function extend(pt, yt) {
  var ir = Object.create(pt.prototype);
  for (var ti in yt) ir[ti] = yt[ti];
  return ir;
}
function Color() {
}
var darker = 0.7, brighter = 1 / darker, reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`), named = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
define$1(Color, color$2, {
  copy(pt) {
    return Object.assign(new this.constructor(), this, pt);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: color_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHex8: color_formatHex8,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});
function color_formatHex() {
  return this.rgb().formatHex();
}
function color_formatHex8() {
  return this.rgb().formatHex8();
}
function color_formatHsl() {
  return hslConvert(this).formatHsl();
}
function color_formatRgb() {
  return this.rgb().formatRgb();
}
function color$2(pt) {
  var yt, ir;
  return pt = (pt + "").trim().toLowerCase(), (yt = reHex.exec(pt)) ? (ir = yt[1].length, yt = parseInt(yt[1], 16), ir === 6 ? rgbn(yt) : ir === 3 ? new Rgb(yt >> 8 & 15 | yt >> 4 & 240, yt >> 4 & 15 | yt & 240, (yt & 15) << 4 | yt & 15, 1) : ir === 8 ? rgba(yt >> 24 & 255, yt >> 16 & 255, yt >> 8 & 255, (yt & 255) / 255) : ir === 4 ? rgba(yt >> 12 & 15 | yt >> 8 & 240, yt >> 8 & 15 | yt >> 4 & 240, yt >> 4 & 15 | yt & 240, ((yt & 15) << 4 | yt & 15) / 255) : null) : (yt = reRgbInteger.exec(pt)) ? new Rgb(yt[1], yt[2], yt[3], 1) : (yt = reRgbPercent.exec(pt)) ? new Rgb(yt[1] * 255 / 100, yt[2] * 255 / 100, yt[3] * 255 / 100, 1) : (yt = reRgbaInteger.exec(pt)) ? rgba(yt[1], yt[2], yt[3], yt[4]) : (yt = reRgbaPercent.exec(pt)) ? rgba(yt[1] * 255 / 100, yt[2] * 255 / 100, yt[3] * 255 / 100, yt[4]) : (yt = reHslPercent.exec(pt)) ? hsla(yt[1], yt[2] / 100, yt[3] / 100, 1) : (yt = reHslaPercent.exec(pt)) ? hsla(yt[1], yt[2] / 100, yt[3] / 100, yt[4]) : named.hasOwnProperty(pt) ? rgbn(named[pt]) : pt === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(pt) {
  return new Rgb(pt >> 16 & 255, pt >> 8 & 255, pt & 255, 1);
}
function rgba(pt, yt, ir, ti) {
  return ti <= 0 && (pt = yt = ir = NaN), new Rgb(pt, yt, ir, ti);
}
function rgbConvert(pt) {
  return pt instanceof Color || (pt = color$2(pt)), pt ? (pt = pt.rgb(), new Rgb(pt.r, pt.g, pt.b, pt.opacity)) : new Rgb();
}
function rgb$1(pt, yt, ir, ti) {
  return arguments.length === 1 ? rgbConvert(pt) : new Rgb(pt, yt, ir, ti ?? 1);
}
function Rgb(pt, yt, ir, ti) {
  this.r = +pt, this.g = +yt, this.b = +ir, this.opacity = +ti;
}
define$1(Rgb, rgb$1, extend(Color, {
  brighter(pt) {
    return pt = pt == null ? brighter : Math.pow(brighter, pt), new Rgb(this.r * pt, this.g * pt, this.b * pt, this.opacity);
  },
  darker(pt) {
    return pt = pt == null ? darker : Math.pow(darker, pt), new Rgb(this.r * pt, this.g * pt, this.b * pt, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: rgb_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatHex8: rgb_formatHex8,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));
function rgb_formatHex() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
  const pt = clampa(this.opacity);
  return `${pt === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${pt === 1 ? ")" : `, ${pt})`}`;
}
function clampa(pt) {
  return isNaN(pt) ? 1 : Math.max(0, Math.min(1, pt));
}
function clampi(pt) {
  return Math.max(0, Math.min(255, Math.round(pt) || 0));
}
function hex(pt) {
  return pt = clampi(pt), (pt < 16 ? "0" : "") + pt.toString(16);
}
function hsla(pt, yt, ir, ti) {
  return ti <= 0 ? pt = yt = ir = NaN : ir <= 0 || ir >= 1 ? pt = yt = NaN : yt <= 0 && (pt = NaN), new Hsl(pt, yt, ir, ti);
}
function hslConvert(pt) {
  if (pt instanceof Hsl) return new Hsl(pt.h, pt.s, pt.l, pt.opacity);
  if (pt instanceof Color || (pt = color$2(pt)), !pt) return new Hsl();
  if (pt instanceof Hsl) return pt;
  pt = pt.rgb();
  var yt = pt.r / 255, ir = pt.g / 255, ti = pt.b / 255, ii = Math.min(yt, ir, ti), ui = Math.max(yt, ir, ti), ai = NaN, li = ui - ii, oi = (ui + ii) / 2;
  return li ? (yt === ui ? ai = (ir - ti) / li + (ir < ti) * 6 : ir === ui ? ai = (ti - yt) / li + 2 : ai = (yt - ir) / li + 4, li /= oi < 0.5 ? ui + ii : 2 - ui - ii, ai *= 60) : li = oi > 0 && oi < 1 ? 0 : ai, new Hsl(ai, li, oi, pt.opacity);
}
function hsl(pt, yt, ir, ti) {
  return arguments.length === 1 ? hslConvert(pt) : new Hsl(pt, yt, ir, ti ?? 1);
}
function Hsl(pt, yt, ir, ti) {
  this.h = +pt, this.s = +yt, this.l = +ir, this.opacity = +ti;
}
define$1(Hsl, hsl, extend(Color, {
  brighter(pt) {
    return pt = pt == null ? brighter : Math.pow(brighter, pt), new Hsl(this.h, this.s, this.l * pt, this.opacity);
  },
  darker(pt) {
    return pt = pt == null ? darker : Math.pow(darker, pt), new Hsl(this.h, this.s, this.l * pt, this.opacity);
  },
  rgb() {
    var pt = this.h % 360 + (this.h < 0) * 360, yt = isNaN(pt) || isNaN(this.s) ? 0 : this.s, ir = this.l, ti = ir + (ir < 0.5 ? ir : 1 - ir) * yt, ii = 2 * ir - ti;
    return new Rgb(
      hsl2rgb(pt >= 240 ? pt - 240 : pt + 120, ii, ti),
      hsl2rgb(pt, ii, ti),
      hsl2rgb(pt < 120 ? pt + 240 : pt - 120, ii, ti),
      this.opacity
    );
  },
  clamp() {
    return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const pt = clampa(this.opacity);
    return `${pt === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${pt === 1 ? ")" : `, ${pt})`}`;
  }
}));
function clamph(pt) {
  return pt = (pt || 0) % 360, pt < 0 ? pt + 360 : pt;
}
function clampt(pt) {
  return Math.max(0, Math.min(1, pt || 0));
}
function hsl2rgb(pt, yt, ir) {
  return (pt < 60 ? yt + (ir - yt) * pt / 60 : pt < 180 ? ir : pt < 240 ? yt + (ir - yt) * (240 - pt) / 60 : yt) * 255;
}
const constant = (pt) => () => pt;
function linear$1(pt, yt) {
  return function(ir) {
    return pt + ir * yt;
  };
}
function exponential(pt, yt, ir) {
  return pt = Math.pow(pt, ir), yt = Math.pow(yt, ir) - pt, ir = 1 / ir, function(ti) {
    return Math.pow(pt + ti * yt, ir);
  };
}
function gamma(pt) {
  return (pt = +pt) == 1 ? nogamma : function(yt, ir) {
    return ir - yt ? exponential(yt, ir, pt) : constant(isNaN(yt) ? ir : yt);
  };
}
function nogamma(pt, yt) {
  var ir = yt - pt;
  return ir ? linear$1(pt, ir) : constant(isNaN(pt) ? yt : pt);
}
const rgb = (function pt(yt) {
  var ir = gamma(yt);
  function ti(ii, ui) {
    var ai = ir((ii = rgb$1(ii)).r, (ui = rgb$1(ui)).r), li = ir(ii.g, ui.g), oi = ir(ii.b, ui.b), si = nogamma(ii.opacity, ui.opacity);
    return function(di) {
      return ii.r = ai(di), ii.g = li(di), ii.b = oi(di), ii.opacity = si(di), ii + "";
    };
  }
  return ti.gamma = pt, ti;
})(1);
function numberArray(pt, yt) {
  yt || (yt = []);
  var ir = pt ? Math.min(yt.length, pt.length) : 0, ti = yt.slice(), ii;
  return function(ui) {
    for (ii = 0; ii < ir; ++ii) ti[ii] = pt[ii] * (1 - ui) + yt[ii] * ui;
    return ti;
  };
}
function isNumberArray(pt) {
  return ArrayBuffer.isView(pt) && !(pt instanceof DataView);
}
function genericArray(pt, yt) {
  var ir = yt ? yt.length : 0, ti = pt ? Math.min(ir, pt.length) : 0, ii = new Array(ti), ui = new Array(ir), ai;
  for (ai = 0; ai < ti; ++ai) ii[ai] = interpolate(pt[ai], yt[ai]);
  for (; ai < ir; ++ai) ui[ai] = yt[ai];
  return function(li) {
    for (ai = 0; ai < ti; ++ai) ui[ai] = ii[ai](li);
    return ui;
  };
}
function date$1(pt, yt) {
  var ir = /* @__PURE__ */ new Date();
  return pt = +pt, yt = +yt, function(ti) {
    return ir.setTime(pt * (1 - ti) + yt * ti), ir;
  };
}
function interpolateNumber(pt, yt) {
  return pt = +pt, yt = +yt, function(ir) {
    return pt * (1 - ir) + yt * ir;
  };
}
function object(pt, yt) {
  var ir = {}, ti = {}, ii;
  (pt === null || typeof pt != "object") && (pt = {}), (yt === null || typeof yt != "object") && (yt = {});
  for (ii in yt)
    ii in pt ? ir[ii] = interpolate(pt[ii], yt[ii]) : ti[ii] = yt[ii];
  return function(ui) {
    for (ii in ir) ti[ii] = ir[ii](ui);
    return ti;
  };
}
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero(pt) {
  return function() {
    return pt;
  };
}
function one(pt) {
  return function(yt) {
    return pt(yt) + "";
  };
}
function string(pt, yt) {
  var ir = reA.lastIndex = reB.lastIndex = 0, ti, ii, ui, ai = -1, li = [], oi = [];
  for (pt = pt + "", yt = yt + ""; (ti = reA.exec(pt)) && (ii = reB.exec(yt)); )
    (ui = ii.index) > ir && (ui = yt.slice(ir, ui), li[ai] ? li[ai] += ui : li[++ai] = ui), (ti = ti[0]) === (ii = ii[0]) ? li[ai] ? li[ai] += ii : li[++ai] = ii : (li[++ai] = null, oi.push({ i: ai, x: interpolateNumber(ti, ii) })), ir = reB.lastIndex;
  return ir < yt.length && (ui = yt.slice(ir), li[ai] ? li[ai] += ui : li[++ai] = ui), li.length < 2 ? oi[0] ? one(oi[0].x) : zero(yt) : (yt = oi.length, function(si) {
    for (var di = 0, fi; di < yt; ++di) li[(fi = oi[di]).i] = fi.x(si);
    return li.join("");
  });
}
function interpolate(pt, yt) {
  var ir = typeof yt, ti;
  return yt == null || ir === "boolean" ? constant(yt) : (ir === "number" ? interpolateNumber : ir === "string" ? (ti = color$2(yt)) ? (yt = ti, rgb) : string : yt instanceof color$2 ? rgb : yt instanceof Date ? date$1 : isNumberArray(yt) ? numberArray : Array.isArray(yt) ? genericArray : typeof yt.valueOf != "function" && typeof yt.toString != "function" || isNaN(yt) ? object : interpolateNumber)(pt, yt);
}
function interpolateRound(pt, yt) {
  return pt = +pt, yt = +yt, function(ir) {
    return Math.round(pt * (1 - ir) + yt * ir);
  };
}
function piecewise(pt, yt) {
  yt === void 0 && (yt = pt, pt = interpolate);
  for (var ir = 0, ti = yt.length - 1, ii = yt[0], ui = new Array(ti < 0 ? 0 : ti); ir < ti; ) ui[ir] = pt(ii, ii = yt[++ir]);
  return function(ai) {
    var li = Math.max(0, Math.min(ti - 1, Math.floor(ai *= ti)));
    return ui[li](ai - li);
  };
}
function constants(pt) {
  return function() {
    return pt;
  };
}
function number$1(pt) {
  return +pt;
}
var unit = [0, 1];
function identity$2(pt) {
  return pt;
}
function normalize(pt, yt) {
  return (yt -= pt = +pt) ? function(ir) {
    return (ir - pt) / yt;
  } : constants(isNaN(yt) ? NaN : 0.5);
}
function clamper(pt, yt) {
  var ir;
  return pt > yt && (ir = pt, pt = yt, yt = ir), function(ti) {
    return Math.max(pt, Math.min(yt, ti));
  };
}
function bimap(pt, yt, ir) {
  var ti = pt[0], ii = pt[1], ui = yt[0], ai = yt[1];
  return ii < ti ? (ti = normalize(ii, ti), ui = ir(ai, ui)) : (ti = normalize(ti, ii), ui = ir(ui, ai)), function(li) {
    return ui(ti(li));
  };
}
function polymap(pt, yt, ir) {
  var ti = Math.min(pt.length, yt.length) - 1, ii = new Array(ti), ui = new Array(ti), ai = -1;
  for (pt[ti] < pt[0] && (pt = pt.slice().reverse(), yt = yt.slice().reverse()); ++ai < ti; )
    ii[ai] = normalize(pt[ai], pt[ai + 1]), ui[ai] = ir(yt[ai], yt[ai + 1]);
  return function(li) {
    var oi = bisectRight(pt, li, 1, ti) - 1;
    return ui[oi](ii[oi](li));
  };
}
function copy$1(pt, yt) {
  return yt.domain(pt.domain()).range(pt.range()).interpolate(pt.interpolate()).clamp(pt.clamp()).unknown(pt.unknown());
}
function transformer$2() {
  var pt = unit, yt = unit, ir = interpolate, ti, ii, ui, ai = identity$2, li, oi, si;
  function di() {
    var gi = Math.min(pt.length, yt.length);
    return ai !== identity$2 && (ai = clamper(pt[0], pt[gi - 1])), li = gi > 2 ? polymap : bimap, oi = si = null, fi;
  }
  function fi(gi) {
    return gi == null || isNaN(gi = +gi) ? ui : (oi || (oi = li(pt.map(ti), yt, ir)))(ti(ai(gi)));
  }
  return fi.invert = function(gi) {
    return ai(ii((si || (si = li(yt, pt.map(ti), interpolateNumber)))(gi)));
  }, fi.domain = function(gi) {
    return arguments.length ? (pt = Array.from(gi, number$1), di()) : pt.slice();
  }, fi.range = function(gi) {
    return arguments.length ? (yt = Array.from(gi), di()) : yt.slice();
  }, fi.rangeRound = function(gi) {
    return yt = Array.from(gi), ir = interpolateRound, di();
  }, fi.clamp = function(gi) {
    return arguments.length ? (ai = gi ? !0 : identity$2, di()) : ai !== identity$2;
  }, fi.interpolate = function(gi) {
    return arguments.length ? (ir = gi, di()) : ir;
  }, fi.unknown = function(gi) {
    return arguments.length ? (ui = gi, fi) : ui;
  }, function(gi, mi) {
    return ti = gi, ii = mi, di();
  };
}
function continuous() {
  return transformer$2()(identity$2, identity$2);
}
function formatDecimal(pt) {
  return Math.abs(pt = Math.round(pt)) >= 1e21 ? pt.toLocaleString("en").replace(/,/g, "") : pt.toString(10);
}
function formatDecimalParts(pt, yt) {
  if ((ir = (pt = yt ? pt.toExponential(yt - 1) : pt.toExponential()).indexOf("e")) < 0) return null;
  var ir, ti = pt.slice(0, ir);
  return [
    ti.length > 1 ? ti[0] + ti.slice(2) : ti,
    +pt.slice(ir + 1)
  ];
}
function exponent(pt) {
  return pt = formatDecimalParts(Math.abs(pt)), pt ? pt[1] : NaN;
}
function formatGroup(pt, yt) {
  return function(ir, ti) {
    for (var ii = ir.length, ui = [], ai = 0, li = pt[0], oi = 0; ii > 0 && li > 0 && (oi + li + 1 > ti && (li = Math.max(1, ti - oi)), ui.push(ir.substring(ii -= li, ii + li)), !((oi += li + 1) > ti)); )
      li = pt[ai = (ai + 1) % pt.length];
    return ui.reverse().join(yt);
  };
}
function formatNumerals(pt) {
  return function(yt) {
    return yt.replace(/[0-9]/g, function(ir) {
      return pt[+ir];
    });
  };
}
var re$2 = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(pt) {
  if (!(yt = re$2.exec(pt))) throw new Error("invalid format: " + pt);
  var yt;
  return new FormatSpecifier({
    fill: yt[1],
    align: yt[2],
    sign: yt[3],
    symbol: yt[4],
    zero: yt[5],
    width: yt[6],
    comma: yt[7],
    precision: yt[8] && yt[8].slice(1),
    trim: yt[9],
    type: yt[10]
  });
}
formatSpecifier.prototype = FormatSpecifier.prototype;
function FormatSpecifier(pt) {
  this.fill = pt.fill === void 0 ? " " : pt.fill + "", this.align = pt.align === void 0 ? ">" : pt.align + "", this.sign = pt.sign === void 0 ? "-" : pt.sign + "", this.symbol = pt.symbol === void 0 ? "" : pt.symbol + "", this.zero = !!pt.zero, this.width = pt.width === void 0 ? void 0 : +pt.width, this.comma = !!pt.comma, this.precision = pt.precision === void 0 ? void 0 : +pt.precision, this.trim = !!pt.trim, this.type = pt.type === void 0 ? "" : pt.type + "";
}
FormatSpecifier.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function formatTrim(pt) {
  e: for (var yt = pt.length, ir = 1, ti = -1, ii; ir < yt; ++ir)
    switch (pt[ir]) {
      case ".":
        ti = ii = ir;
        break;
      case "0":
        ti === 0 && (ti = ir), ii = ir;
        break;
      default:
        if (!+pt[ir]) break e;
        ti > 0 && (ti = 0);
        break;
    }
  return ti > 0 ? pt.slice(0, ti) + pt.slice(ii + 1) : pt;
}
var prefixExponent;
function formatPrefixAuto(pt, yt) {
  var ir = formatDecimalParts(pt, yt);
  if (!ir) return pt + "";
  var ti = ir[0], ii = ir[1], ui = ii - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(ii / 3))) * 3) + 1, ai = ti.length;
  return ui === ai ? ti : ui > ai ? ti + new Array(ui - ai + 1).join("0") : ui > 0 ? ti.slice(0, ui) + "." + ti.slice(ui) : "0." + new Array(1 - ui).join("0") + formatDecimalParts(pt, Math.max(0, yt + ui - 1))[0];
}
function formatRounded(pt, yt) {
  var ir = formatDecimalParts(pt, yt);
  if (!ir) return pt + "";
  var ti = ir[0], ii = ir[1];
  return ii < 0 ? "0." + new Array(-ii).join("0") + ti : ti.length > ii + 1 ? ti.slice(0, ii + 1) + "." + ti.slice(ii + 1) : ti + new Array(ii - ti.length + 2).join("0");
}
const formatTypes = {
  "%": (pt, yt) => (pt * 100).toFixed(yt),
  b: (pt) => Math.round(pt).toString(2),
  c: (pt) => pt + "",
  d: formatDecimal,
  e: (pt, yt) => pt.toExponential(yt),
  f: (pt, yt) => pt.toFixed(yt),
  g: (pt, yt) => pt.toPrecision(yt),
  o: (pt) => Math.round(pt).toString(8),
  p: (pt, yt) => formatRounded(pt * 100, yt),
  r: formatRounded,
  s: formatPrefixAuto,
  X: (pt) => Math.round(pt).toString(16).toUpperCase(),
  x: (pt) => Math.round(pt).toString(16)
};
function identity$1(pt) {
  return pt;
}
var map = Array.prototype.map, prefixes = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function formatLocale$1(pt) {
  var yt = pt.grouping === void 0 || pt.thousands === void 0 ? identity$1 : formatGroup(map.call(pt.grouping, Number), pt.thousands + ""), ir = pt.currency === void 0 ? "" : pt.currency[0] + "", ti = pt.currency === void 0 ? "" : pt.currency[1] + "", ii = pt.decimal === void 0 ? "." : pt.decimal + "", ui = pt.numerals === void 0 ? identity$1 : formatNumerals(map.call(pt.numerals, String)), ai = pt.percent === void 0 ? "%" : pt.percent + "", li = pt.minus === void 0 ? "−" : pt.minus + "", oi = pt.nan === void 0 ? "NaN" : pt.nan + "";
  function si(fi) {
    fi = formatSpecifier(fi);
    var gi = fi.fill, mi = fi.align, Ti = fi.sign, vi = fi.symbol, xi = fi.zero, Si = fi.width, Pi = fi.comma, $i = fi.precision, Oi = fi.trim, Di = fi.type;
    Di === "n" ? (Pi = !0, Di = "g") : formatTypes[Di] || ($i === void 0 && ($i = 12), Oi = !0, Di = "g"), (xi || gi === "0" && mi === "=") && (xi = !0, gi = "0", mi = "=");
    var Mi = vi === "$" ? ir : vi === "#" && /[boxX]/.test(Di) ? "0" + Di.toLowerCase() : "", Oo = vi === "$" ? ti : /[%p]/.test(Di) ? ai : "", io = formatTypes[Di], xo = /[defgprs%]/.test(Di);
    $i = $i === void 0 ? 6 : /[gprs]/.test(Di) ? Math.max(1, Math.min(21, $i)) : Math.max(0, Math.min(20, $i));
    function fo(_o) {
      var Li = Mi, Co = Oo, Ni, Yi, Vo;
      if (Di === "c")
        Co = io(_o) + Co, _o = "";
      else {
        _o = +_o;
        var No = _o < 0 || 1 / _o < 0;
        if (_o = isNaN(_o) ? oi : io(Math.abs(_o), $i), Oi && (_o = formatTrim(_o)), No && +_o == 0 && Ti !== "+" && (No = !1), Li = (No ? Ti === "(" ? Ti : li : Ti === "-" || Ti === "(" ? "" : Ti) + Li, Co = (Di === "s" ? prefixes[8 + prefixExponent / 3] : "") + Co + (No && Ti === "(" ? ")" : ""), xo) {
          for (Ni = -1, Yi = _o.length; ++Ni < Yi; )
            if (Vo = _o.charCodeAt(Ni), 48 > Vo || Vo > 57) {
              Co = (Vo === 46 ? ii + _o.slice(Ni + 1) : _o.slice(Ni)) + Co, _o = _o.slice(0, Ni);
              break;
            }
        }
      }
      Pi && !xi && (_o = yt(_o, 1 / 0));
      var Ui = Li.length + _o.length + Co.length, jo = Ui < Si ? new Array(Si - Ui + 1).join(gi) : "";
      switch (Pi && xi && (_o = yt(jo + _o, jo.length ? Si - Co.length : 1 / 0), jo = ""), mi) {
        case "<":
          _o = Li + _o + Co + jo;
          break;
        case "=":
          _o = Li + jo + _o + Co;
          break;
        case "^":
          _o = jo.slice(0, Ui = jo.length >> 1) + Li + _o + Co + jo.slice(Ui);
          break;
        default:
          _o = jo + Li + _o + Co;
          break;
      }
      return ui(_o);
    }
    return fo.toString = function() {
      return fi + "";
    }, fo;
  }
  function di(fi, gi) {
    var mi = si((fi = formatSpecifier(fi), fi.type = "f", fi)), Ti = Math.max(-8, Math.min(8, Math.floor(exponent(gi) / 3))) * 3, vi = Math.pow(10, -Ti), xi = prefixes[8 + Ti / 3];
    return function(Si) {
      return mi(vi * Si) + xi;
    };
  }
  return {
    format: si,
    formatPrefix: di
  };
}
var locale$1, format, formatPrefix;
defaultLocale$1({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function defaultLocale$1(pt) {
  return locale$1 = formatLocale$1(pt), format = locale$1.format, formatPrefix = locale$1.formatPrefix, locale$1;
}
function precisionFixed(pt) {
  return Math.max(0, -exponent(Math.abs(pt)));
}
function precisionPrefix(pt, yt) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(yt) / 3))) * 3 - exponent(Math.abs(pt)));
}
function precisionRound(pt, yt) {
  return pt = Math.abs(pt), yt = Math.abs(yt) - pt, Math.max(0, exponent(yt) - exponent(pt)) + 1;
}
function tickFormat(pt, yt, ir, ti) {
  var ii = tickStep(pt, yt, ir), ui;
  switch (ti = formatSpecifier(ti ?? ",f"), ti.type) {
    case "s": {
      var ai = Math.max(Math.abs(pt), Math.abs(yt));
      return ti.precision == null && !isNaN(ui = precisionPrefix(ii, ai)) && (ti.precision = ui), formatPrefix(ti, ai);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      ti.precision == null && !isNaN(ui = precisionRound(ii, Math.max(Math.abs(pt), Math.abs(yt)))) && (ti.precision = ui - (ti.type === "e"));
      break;
    }
    case "f":
    case "%": {
      ti.precision == null && !isNaN(ui = precisionFixed(ii)) && (ti.precision = ui - (ti.type === "%") * 2);
      break;
    }
  }
  return format(ti);
}
function linearish(pt) {
  var yt = pt.domain;
  return pt.ticks = function(ir) {
    var ti = yt();
    return ticks(ti[0], ti[ti.length - 1], ir ?? 10);
  }, pt.tickFormat = function(ir, ti) {
    var ii = yt();
    return tickFormat(ii[0], ii[ii.length - 1], ir ?? 10, ti);
  }, pt.nice = function(ir) {
    ir == null && (ir = 10);
    var ti = yt(), ii = 0, ui = ti.length - 1, ai = ti[ii], li = ti[ui], oi, si, di = 10;
    for (li < ai && (si = ai, ai = li, li = si, si = ii, ii = ui, ui = si); di-- > 0; ) {
      if (si = tickIncrement(ai, li, ir), si === oi)
        return ti[ii] = ai, ti[ui] = li, yt(ti);
      if (si > 0)
        ai = Math.floor(ai / si) * si, li = Math.ceil(li / si) * si;
      else if (si < 0)
        ai = Math.ceil(ai * si) / si, li = Math.floor(li * si) / si;
      else
        break;
      oi = si;
    }
    return pt;
  }, pt;
}
function linear() {
  var pt = continuous();
  return pt.copy = function() {
    return copy$1(pt, linear());
  }, initRange.apply(pt, arguments), linearish(pt);
}
function identity(pt) {
  var yt;
  function ir(ti) {
    return ti == null || isNaN(ti = +ti) ? yt : ti;
  }
  return ir.invert = ir, ir.domain = ir.range = function(ti) {
    return arguments.length ? (pt = Array.from(ti, number$1), ir) : pt.slice();
  }, ir.unknown = function(ti) {
    return arguments.length ? (yt = ti, ir) : yt;
  }, ir.copy = function() {
    return identity(pt).unknown(yt);
  }, pt = arguments.length ? Array.from(pt, number$1) : [0, 1], linearish(ir);
}
function nice(pt, yt) {
  pt = pt.slice();
  var ir = 0, ti = pt.length - 1, ii = pt[ir], ui = pt[ti], ai;
  return ui < ii && (ai = ir, ir = ti, ti = ai, ai = ii, ii = ui, ui = ai), pt[ir] = yt.floor(ii), pt[ti] = yt.ceil(ui), pt;
}
function transformLog(pt) {
  return Math.log(pt);
}
function transformExp(pt) {
  return Math.exp(pt);
}
function transformLogn(pt) {
  return -Math.log(-pt);
}
function transformExpn(pt) {
  return -Math.exp(-pt);
}
function pow10(pt) {
  return isFinite(pt) ? +("1e" + pt) : pt < 0 ? 0 : pt;
}
function powp(pt) {
  return pt === 10 ? pow10 : pt === Math.E ? Math.exp : (yt) => Math.pow(pt, yt);
}
function logp(pt) {
  return pt === Math.E ? Math.log : pt === 10 && Math.log10 || pt === 2 && Math.log2 || (pt = Math.log(pt), (yt) => Math.log(yt) / pt);
}
function reflect(pt) {
  return (yt, ir) => -pt(-yt, ir);
}
function loggish(pt) {
  const yt = pt(transformLog, transformExp), ir = yt.domain;
  let ti = 10, ii, ui;
  function ai() {
    return ii = logp(ti), ui = powp(ti), ir()[0] < 0 ? (ii = reflect(ii), ui = reflect(ui), pt(transformLogn, transformExpn)) : pt(transformLog, transformExp), yt;
  }
  return yt.base = function(li) {
    return arguments.length ? (ti = +li, ai()) : ti;
  }, yt.domain = function(li) {
    return arguments.length ? (ir(li), ai()) : ir();
  }, yt.ticks = (li) => {
    const oi = ir();
    let si = oi[0], di = oi[oi.length - 1];
    const fi = di < si;
    fi && ([si, di] = [di, si]);
    let gi = ii(si), mi = ii(di), Ti, vi;
    const xi = li == null ? 10 : +li;
    let Si = [];
    if (!(ti % 1) && mi - gi < xi) {
      if (gi = Math.floor(gi), mi = Math.ceil(mi), si > 0) {
        for (; gi <= mi; ++gi)
          for (Ti = 1; Ti < ti; ++Ti)
            if (vi = gi < 0 ? Ti / ui(-gi) : Ti * ui(gi), !(vi < si)) {
              if (vi > di) break;
              Si.push(vi);
            }
      } else for (; gi <= mi; ++gi)
        for (Ti = ti - 1; Ti >= 1; --Ti)
          if (vi = gi > 0 ? Ti / ui(-gi) : Ti * ui(gi), !(vi < si)) {
            if (vi > di) break;
            Si.push(vi);
          }
      Si.length * 2 < xi && (Si = ticks(si, di, xi));
    } else
      Si = ticks(gi, mi, Math.min(mi - gi, xi)).map(ui);
    return fi ? Si.reverse() : Si;
  }, yt.tickFormat = (li, oi) => {
    if (li == null && (li = 10), oi == null && (oi = ti === 10 ? "s" : ","), typeof oi != "function" && (!(ti % 1) && (oi = formatSpecifier(oi)).precision == null && (oi.trim = !0), oi = format(oi)), li === 1 / 0) return oi;
    const si = Math.max(1, ti * li / yt.ticks().length);
    return (di) => {
      let fi = di / ui(Math.round(ii(di)));
      return fi * ti < ti - 0.5 && (fi *= ti), fi <= si ? oi(di) : "";
    };
  }, yt.nice = () => ir(nice(ir(), {
    floor: (li) => ui(Math.floor(ii(li))),
    ceil: (li) => ui(Math.ceil(ii(li)))
  })), yt;
}
function log$1() {
  const pt = loggish(transformer$2()).domain([1, 10]);
  return pt.copy = () => copy$1(pt, log$1()).base(pt.base()), initRange.apply(pt, arguments), pt;
}
function transformSymlog(pt) {
  return function(yt) {
    return Math.sign(yt) * Math.log1p(Math.abs(yt / pt));
  };
}
function transformSymexp(pt) {
  return function(yt) {
    return Math.sign(yt) * Math.expm1(Math.abs(yt)) * pt;
  };
}
function symlogish(pt) {
  var yt = 1, ir = pt(transformSymlog(yt), transformSymexp(yt));
  return ir.constant = function(ti) {
    return arguments.length ? pt(transformSymlog(yt = +ti), transformSymexp(yt)) : yt;
  }, linearish(ir);
}
function symlog() {
  var pt = symlogish(transformer$2());
  return pt.copy = function() {
    return copy$1(pt, symlog()).constant(pt.constant());
  }, initRange.apply(pt, arguments);
}
function transformPow(pt) {
  return function(yt) {
    return yt < 0 ? -Math.pow(-yt, pt) : Math.pow(yt, pt);
  };
}
function transformSqrt(pt) {
  return pt < 0 ? -Math.sqrt(-pt) : Math.sqrt(pt);
}
function transformSquare(pt) {
  return pt < 0 ? -pt * pt : pt * pt;
}
function powish(pt) {
  var yt = pt(identity$2, identity$2), ir = 1;
  function ti() {
    return ir === 1 ? pt(identity$2, identity$2) : ir === 0.5 ? pt(transformSqrt, transformSquare) : pt(transformPow(ir), transformPow(1 / ir));
  }
  return yt.exponent = function(ii) {
    return arguments.length ? (ir = +ii, ti()) : ir;
  }, linearish(yt);
}
function pow() {
  var pt = powish(transformer$2());
  return pt.copy = function() {
    return copy$1(pt, pow()).exponent(pt.exponent());
  }, initRange.apply(pt, arguments), pt;
}
function sqrt() {
  return pow.apply(null, arguments).exponent(0.5);
}
function square(pt) {
  return Math.sign(pt) * pt * pt;
}
function unsquare(pt) {
  return Math.sign(pt) * Math.sqrt(Math.abs(pt));
}
function radial() {
  var pt = continuous(), yt = [0, 1], ir = !1, ti;
  function ii(ui) {
    var ai = unsquare(pt(ui));
    return isNaN(ai) ? ti : ir ? Math.round(ai) : ai;
  }
  return ii.invert = function(ui) {
    return pt.invert(square(ui));
  }, ii.domain = function(ui) {
    return arguments.length ? (pt.domain(ui), ii) : pt.domain();
  }, ii.range = function(ui) {
    return arguments.length ? (pt.range((yt = Array.from(ui, number$1)).map(square)), ii) : yt.slice();
  }, ii.rangeRound = function(ui) {
    return ii.range(ui).round(!0);
  }, ii.round = function(ui) {
    return arguments.length ? (ir = !!ui, ii) : ir;
  }, ii.clamp = function(ui) {
    return arguments.length ? (pt.clamp(ui), ii) : pt.clamp();
  }, ii.unknown = function(ui) {
    return arguments.length ? (ti = ui, ii) : ti;
  }, ii.copy = function() {
    return radial(pt.domain(), yt).round(ir).clamp(pt.clamp()).unknown(ti);
  }, initRange.apply(ii, arguments), linearish(ii);
}
function quantile() {
  var pt = [], yt = [], ir = [], ti;
  function ii() {
    var ai = 0, li = Math.max(1, yt.length);
    for (ir = new Array(li - 1); ++ai < li; ) ir[ai - 1] = quantileSorted(pt, ai / li);
    return ui;
  }
  function ui(ai) {
    return ai == null || isNaN(ai = +ai) ? ti : yt[bisectRight(ir, ai)];
  }
  return ui.invertExtent = function(ai) {
    var li = yt.indexOf(ai);
    return li < 0 ? [NaN, NaN] : [
      li > 0 ? ir[li - 1] : pt[0],
      li < ir.length ? ir[li] : pt[pt.length - 1]
    ];
  }, ui.domain = function(ai) {
    if (!arguments.length) return pt.slice();
    pt = [];
    for (let li of ai) li != null && !isNaN(li = +li) && pt.push(li);
    return pt.sort(ascending), ii();
  }, ui.range = function(ai) {
    return arguments.length ? (yt = Array.from(ai), ii()) : yt.slice();
  }, ui.unknown = function(ai) {
    return arguments.length ? (ti = ai, ui) : ti;
  }, ui.quantiles = function() {
    return ir.slice();
  }, ui.copy = function() {
    return quantile().domain(pt).range(yt).unknown(ti);
  }, initRange.apply(ui, arguments);
}
function quantize() {
  var pt = 0, yt = 1, ir = 1, ti = [0.5], ii = [0, 1], ui;
  function ai(oi) {
    return oi != null && oi <= oi ? ii[bisectRight(ti, oi, 0, ir)] : ui;
  }
  function li() {
    var oi = -1;
    for (ti = new Array(ir); ++oi < ir; ) ti[oi] = ((oi + 1) * yt - (oi - ir) * pt) / (ir + 1);
    return ai;
  }
  return ai.domain = function(oi) {
    return arguments.length ? ([pt, yt] = oi, pt = +pt, yt = +yt, li()) : [pt, yt];
  }, ai.range = function(oi) {
    return arguments.length ? (ir = (ii = Array.from(oi)).length - 1, li()) : ii.slice();
  }, ai.invertExtent = function(oi) {
    var si = ii.indexOf(oi);
    return si < 0 ? [NaN, NaN] : si < 1 ? [pt, ti[0]] : si >= ir ? [ti[ir - 1], yt] : [ti[si - 1], ti[si]];
  }, ai.unknown = function(oi) {
    return arguments.length && (ui = oi), ai;
  }, ai.thresholds = function() {
    return ti.slice();
  }, ai.copy = function() {
    return quantize().domain([pt, yt]).range(ii).unknown(ui);
  }, initRange.apply(linearish(ai), arguments);
}
function threshold() {
  var pt = [0.5], yt = [0, 1], ir, ti = 1;
  function ii(ui) {
    return ui != null && ui <= ui ? yt[bisectRight(pt, ui, 0, ti)] : ir;
  }
  return ii.domain = function(ui) {
    return arguments.length ? (pt = Array.from(ui), ti = Math.min(pt.length, yt.length - 1), ii) : pt.slice();
  }, ii.range = function(ui) {
    return arguments.length ? (yt = Array.from(ui), ti = Math.min(pt.length, yt.length - 1), ii) : yt.slice();
  }, ii.invertExtent = function(ui) {
    var ai = yt.indexOf(ui);
    return [pt[ai - 1], pt[ai]];
  }, ii.unknown = function(ui) {
    return arguments.length ? (ir = ui, ii) : ir;
  }, ii.copy = function() {
    return threshold().domain(pt).range(yt).unknown(ir);
  }, initRange.apply(ii, arguments);
}
const t0 = /* @__PURE__ */ new Date(), t1 = /* @__PURE__ */ new Date();
function timeInterval(pt, yt, ir, ti) {
  function ii(ui) {
    return pt(ui = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+ui)), ui;
  }
  return ii.floor = (ui) => (pt(ui = /* @__PURE__ */ new Date(+ui)), ui), ii.ceil = (ui) => (pt(ui = new Date(ui - 1)), yt(ui, 1), pt(ui), ui), ii.round = (ui) => {
    const ai = ii(ui), li = ii.ceil(ui);
    return ui - ai < li - ui ? ai : li;
  }, ii.offset = (ui, ai) => (yt(ui = /* @__PURE__ */ new Date(+ui), ai == null ? 1 : Math.floor(ai)), ui), ii.range = (ui, ai, li) => {
    const oi = [];
    if (ui = ii.ceil(ui), li = li == null ? 1 : Math.floor(li), !(ui < ai) || !(li > 0)) return oi;
    let si;
    do
      oi.push(si = /* @__PURE__ */ new Date(+ui)), yt(ui, li), pt(ui);
    while (si < ui && ui < ai);
    return oi;
  }, ii.filter = (ui) => timeInterval((ai) => {
    if (ai >= ai) for (; pt(ai), !ui(ai); ) ai.setTime(ai - 1);
  }, (ai, li) => {
    if (ai >= ai)
      if (li < 0) for (; ++li <= 0; )
        for (; yt(ai, -1), !ui(ai); )
          ;
      else for (; --li >= 0; )
        for (; yt(ai, 1), !ui(ai); )
          ;
  }), ir && (ii.count = (ui, ai) => (t0.setTime(+ui), t1.setTime(+ai), pt(t0), pt(t1), Math.floor(ir(t0, t1))), ii.every = (ui) => (ui = Math.floor(ui), !isFinite(ui) || !(ui > 0) ? null : ui > 1 ? ii.filter(ti ? (ai) => ti(ai) % ui === 0 : (ai) => ii.count(0, ai) % ui === 0) : ii)), ii;
}
const millisecond = timeInterval(() => {
}, (pt, yt) => {
  pt.setTime(+pt + yt);
}, (pt, yt) => yt - pt);
millisecond.every = (pt) => (pt = Math.floor(pt), !isFinite(pt) || !(pt > 0) ? null : pt > 1 ? timeInterval((yt) => {
  yt.setTime(Math.floor(yt / pt) * pt);
}, (yt, ir) => {
  yt.setTime(+yt + ir * pt);
}, (yt, ir) => (ir - yt) / pt) : millisecond);
millisecond.range;
const durationSecond = 1e3, durationMinute = durationSecond * 60, durationHour = durationMinute * 60, durationDay = durationHour * 24, durationWeek = durationDay * 7, durationMonth = durationDay * 30, durationYear = durationDay * 365, second = timeInterval((pt) => {
  pt.setTime(pt - pt.getMilliseconds());
}, (pt, yt) => {
  pt.setTime(+pt + yt * durationSecond);
}, (pt, yt) => (yt - pt) / durationSecond, (pt) => pt.getUTCSeconds());
second.range;
const timeMinute = timeInterval((pt) => {
  pt.setTime(pt - pt.getMilliseconds() - pt.getSeconds() * durationSecond);
}, (pt, yt) => {
  pt.setTime(+pt + yt * durationMinute);
}, (pt, yt) => (yt - pt) / durationMinute, (pt) => pt.getMinutes());
timeMinute.range;
const utcMinute = timeInterval((pt) => {
  pt.setUTCSeconds(0, 0);
}, (pt, yt) => {
  pt.setTime(+pt + yt * durationMinute);
}, (pt, yt) => (yt - pt) / durationMinute, (pt) => pt.getUTCMinutes());
utcMinute.range;
const timeHour = timeInterval((pt) => {
  pt.setTime(pt - pt.getMilliseconds() - pt.getSeconds() * durationSecond - pt.getMinutes() * durationMinute);
}, (pt, yt) => {
  pt.setTime(+pt + yt * durationHour);
}, (pt, yt) => (yt - pt) / durationHour, (pt) => pt.getHours());
timeHour.range;
const utcHour = timeInterval((pt) => {
  pt.setUTCMinutes(0, 0, 0);
}, (pt, yt) => {
  pt.setTime(+pt + yt * durationHour);
}, (pt, yt) => (yt - pt) / durationHour, (pt) => pt.getUTCHours());
utcHour.range;
const timeDay = timeInterval(
  (pt) => pt.setHours(0, 0, 0, 0),
  (pt, yt) => pt.setDate(pt.getDate() + yt),
  (pt, yt) => (yt - pt - (yt.getTimezoneOffset() - pt.getTimezoneOffset()) * durationMinute) / durationDay,
  (pt) => pt.getDate() - 1
);
timeDay.range;
const utcDay = timeInterval((pt) => {
  pt.setUTCHours(0, 0, 0, 0);
}, (pt, yt) => {
  pt.setUTCDate(pt.getUTCDate() + yt);
}, (pt, yt) => (yt - pt) / durationDay, (pt) => pt.getUTCDate() - 1);
utcDay.range;
const unixDay = timeInterval((pt) => {
  pt.setUTCHours(0, 0, 0, 0);
}, (pt, yt) => {
  pt.setUTCDate(pt.getUTCDate() + yt);
}, (pt, yt) => (yt - pt) / durationDay, (pt) => Math.floor(pt / durationDay));
unixDay.range;
function timeWeekday(pt) {
  return timeInterval((yt) => {
    yt.setDate(yt.getDate() - (yt.getDay() + 7 - pt) % 7), yt.setHours(0, 0, 0, 0);
  }, (yt, ir) => {
    yt.setDate(yt.getDate() + ir * 7);
  }, (yt, ir) => (ir - yt - (ir.getTimezoneOffset() - yt.getTimezoneOffset()) * durationMinute) / durationWeek);
}
const timeSunday = timeWeekday(0), timeMonday = timeWeekday(1), timeTuesday = timeWeekday(2), timeWednesday = timeWeekday(3), timeThursday = timeWeekday(4), timeFriday = timeWeekday(5), timeSaturday = timeWeekday(6);
timeSunday.range;
timeMonday.range;
timeTuesday.range;
timeWednesday.range;
timeThursday.range;
timeFriday.range;
timeSaturday.range;
function utcWeekday(pt) {
  return timeInterval((yt) => {
    yt.setUTCDate(yt.getUTCDate() - (yt.getUTCDay() + 7 - pt) % 7), yt.setUTCHours(0, 0, 0, 0);
  }, (yt, ir) => {
    yt.setUTCDate(yt.getUTCDate() + ir * 7);
  }, (yt, ir) => (ir - yt) / durationWeek);
}
const utcSunday = utcWeekday(0), utcMonday = utcWeekday(1), utcTuesday = utcWeekday(2), utcWednesday = utcWeekday(3), utcThursday = utcWeekday(4), utcFriday = utcWeekday(5), utcSaturday = utcWeekday(6);
utcSunday.range;
utcMonday.range;
utcTuesday.range;
utcWednesday.range;
utcThursday.range;
utcFriday.range;
utcSaturday.range;
const timeMonth = timeInterval((pt) => {
  pt.setDate(1), pt.setHours(0, 0, 0, 0);
}, (pt, yt) => {
  pt.setMonth(pt.getMonth() + yt);
}, (pt, yt) => yt.getMonth() - pt.getMonth() + (yt.getFullYear() - pt.getFullYear()) * 12, (pt) => pt.getMonth());
timeMonth.range;
const utcMonth = timeInterval((pt) => {
  pt.setUTCDate(1), pt.setUTCHours(0, 0, 0, 0);
}, (pt, yt) => {
  pt.setUTCMonth(pt.getUTCMonth() + yt);
}, (pt, yt) => yt.getUTCMonth() - pt.getUTCMonth() + (yt.getUTCFullYear() - pt.getUTCFullYear()) * 12, (pt) => pt.getUTCMonth());
utcMonth.range;
const timeYear = timeInterval((pt) => {
  pt.setMonth(0, 1), pt.setHours(0, 0, 0, 0);
}, (pt, yt) => {
  pt.setFullYear(pt.getFullYear() + yt);
}, (pt, yt) => yt.getFullYear() - pt.getFullYear(), (pt) => pt.getFullYear());
timeYear.every = (pt) => !isFinite(pt = Math.floor(pt)) || !(pt > 0) ? null : timeInterval((yt) => {
  yt.setFullYear(Math.floor(yt.getFullYear() / pt) * pt), yt.setMonth(0, 1), yt.setHours(0, 0, 0, 0);
}, (yt, ir) => {
  yt.setFullYear(yt.getFullYear() + ir * pt);
});
timeYear.range;
const utcYear = timeInterval((pt) => {
  pt.setUTCMonth(0, 1), pt.setUTCHours(0, 0, 0, 0);
}, (pt, yt) => {
  pt.setUTCFullYear(pt.getUTCFullYear() + yt);
}, (pt, yt) => yt.getUTCFullYear() - pt.getUTCFullYear(), (pt) => pt.getUTCFullYear());
utcYear.every = (pt) => !isFinite(pt = Math.floor(pt)) || !(pt > 0) ? null : timeInterval((yt) => {
  yt.setUTCFullYear(Math.floor(yt.getUTCFullYear() / pt) * pt), yt.setUTCMonth(0, 1), yt.setUTCHours(0, 0, 0, 0);
}, (yt, ir) => {
  yt.setUTCFullYear(yt.getUTCFullYear() + ir * pt);
});
utcYear.range;
function ticker(pt, yt, ir, ti, ii, ui) {
  const ai = [
    [second, 1, durationSecond],
    [second, 5, 5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [ui, 1, durationMinute],
    [ui, 5, 5 * durationMinute],
    [ui, 15, 15 * durationMinute],
    [ui, 30, 30 * durationMinute],
    [ii, 1, durationHour],
    [ii, 3, 3 * durationHour],
    [ii, 6, 6 * durationHour],
    [ii, 12, 12 * durationHour],
    [ti, 1, durationDay],
    [ti, 2, 2 * durationDay],
    [ir, 1, durationWeek],
    [yt, 1, durationMonth],
    [yt, 3, 3 * durationMonth],
    [pt, 1, durationYear]
  ];
  function li(si, di, fi) {
    const gi = di < si;
    gi && ([si, di] = [di, si]);
    const mi = fi && typeof fi.range == "function" ? fi : oi(si, di, fi), Ti = mi ? mi.range(si, +di + 1) : [];
    return gi ? Ti.reverse() : Ti;
  }
  function oi(si, di, fi) {
    const gi = Math.abs(di - si) / fi, mi = bisector(([, , xi]) => xi).right(ai, gi);
    if (mi === ai.length) return pt.every(tickStep(si / durationYear, di / durationYear, fi));
    if (mi === 0) return millisecond.every(Math.max(tickStep(si, di, fi), 1));
    const [Ti, vi] = ai[gi / ai[mi - 1][2] < ai[mi][2] / gi ? mi - 1 : mi];
    return Ti.every(vi);
  }
  return [li, oi];
}
const [utcTicks, utcTickInterval] = ticker(utcYear, utcMonth, utcSunday, unixDay, utcHour, utcMinute), [timeTicks, timeTickInterval] = ticker(timeYear, timeMonth, timeSunday, timeDay, timeHour, timeMinute);
function localDate(pt) {
  if (0 <= pt.y && pt.y < 100) {
    var yt = new Date(-1, pt.m, pt.d, pt.H, pt.M, pt.S, pt.L);
    return yt.setFullYear(pt.y), yt;
  }
  return new Date(pt.y, pt.m, pt.d, pt.H, pt.M, pt.S, pt.L);
}
function utcDate(pt) {
  if (0 <= pt.y && pt.y < 100) {
    var yt = new Date(Date.UTC(-1, pt.m, pt.d, pt.H, pt.M, pt.S, pt.L));
    return yt.setUTCFullYear(pt.y), yt;
  }
  return new Date(Date.UTC(pt.y, pt.m, pt.d, pt.H, pt.M, pt.S, pt.L));
}
function newDate(pt, yt, ir) {
  return { y: pt, m: yt, d: ir, H: 0, M: 0, S: 0, L: 0 };
}
function formatLocale(pt) {
  var yt = pt.dateTime, ir = pt.date, ti = pt.time, ii = pt.periods, ui = pt.days, ai = pt.shortDays, li = pt.months, oi = pt.shortMonths, si = formatRe(ii), di = formatLookup(ii), fi = formatRe(ui), gi = formatLookup(ui), mi = formatRe(ai), Ti = formatLookup(ai), vi = formatRe(li), xi = formatLookup(li), Si = formatRe(oi), Pi = formatLookup(oi), $i = {
    a: No,
    A: Ui,
    b: jo,
    B: Wi,
    c: null,
    d: formatDayOfMonth,
    e: formatDayOfMonth,
    f: formatMicroseconds,
    g: formatYearISO,
    G: formatFullYearISO,
    H: formatHour24,
    I: formatHour12,
    j: formatDayOfYear,
    L: formatMilliseconds,
    m: formatMonthNumber,
    M: formatMinutes,
    p: ji,
    q: Hi,
    Q: formatUnixTimestamp,
    s: formatUnixTimestampSeconds,
    S: formatSeconds,
    u: formatWeekdayNumberMonday,
    U: formatWeekNumberSunday,
    V: formatWeekNumberISO,
    w: formatWeekdayNumberSunday,
    W: formatWeekNumberMonday,
    x: null,
    X: null,
    y: formatYear,
    Y: formatFullYear,
    Z: formatZone,
    "%": formatLiteralPercent
  }, Oi = {
    a: zo,
    A: Lo,
    b: sa,
    B: Ko,
    c: null,
    d: formatUTCDayOfMonth,
    e: formatUTCDayOfMonth,
    f: formatUTCMicroseconds,
    g: formatUTCYearISO,
    G: formatUTCFullYearISO,
    H: formatUTCHour24,
    I: formatUTCHour12,
    j: formatUTCDayOfYear,
    L: formatUTCMilliseconds,
    m: formatUTCMonthNumber,
    M: formatUTCMinutes,
    p: ca,
    q: pa,
    Q: formatUnixTimestamp,
    s: formatUnixTimestampSeconds,
    S: formatUTCSeconds,
    u: formatUTCWeekdayNumberMonday,
    U: formatUTCWeekNumberSunday,
    V: formatUTCWeekNumberISO,
    w: formatUTCWeekdayNumberSunday,
    W: formatUTCWeekNumberMonday,
    x: null,
    X: null,
    y: formatUTCYear,
    Y: formatUTCFullYear,
    Z: formatUTCZone,
    "%": formatLiteralPercent
  }, Di = {
    a: fo,
    A: _o,
    b: Li,
    B: Co,
    c: Ni,
    d: parseDayOfMonth,
    e: parseDayOfMonth,
    f: parseMicroseconds,
    g: parseYear,
    G: parseFullYear,
    H: parseHour24,
    I: parseHour24,
    j: parseDayOfYear,
    L: parseMilliseconds,
    m: parseMonthNumber,
    M: parseMinutes,
    p: xo,
    q: parseQuarter,
    Q: parseUnixTimestamp,
    s: parseUnixTimestampSeconds,
    S: parseSeconds,
    u: parseWeekdayNumberMonday,
    U: parseWeekNumberSunday,
    V: parseWeekNumberISO,
    w: parseWeekdayNumberSunday,
    W: parseWeekNumberMonday,
    x: Yi,
    X: Vo,
    y: parseYear,
    Y: parseFullYear,
    Z: parseZone,
    "%": parseLiteralPercent
  };
  $i.x = Mi(ir, $i), $i.X = Mi(ti, $i), $i.c = Mi(yt, $i), Oi.x = Mi(ir, Oi), Oi.X = Mi(ti, Oi), Oi.c = Mi(yt, Oi);
  function Mi(ga, ia) {
    return function(ra) {
      var qo = [], xa = -1, $a = 0, ys = ga.length, Ss, Xa, Es;
      for (ra instanceof Date || (ra = /* @__PURE__ */ new Date(+ra)); ++xa < ys; )
        ga.charCodeAt(xa) === 37 && (qo.push(ga.slice($a, xa)), (Xa = pads[Ss = ga.charAt(++xa)]) != null ? Ss = ga.charAt(++xa) : Xa = Ss === "e" ? " " : "0", (Es = ia[Ss]) && (Ss = Es(ra, Xa)), qo.push(Ss), $a = xa + 1);
      return qo.push(ga.slice($a, xa)), qo.join("");
    };
  }
  function Oo(ga, ia) {
    return function(ra) {
      var qo = newDate(1900, void 0, 1), xa = io(qo, ga, ra += "", 0), $a, ys;
      if (xa != ra.length) return null;
      if ("Q" in qo) return new Date(qo.Q);
      if ("s" in qo) return new Date(qo.s * 1e3 + ("L" in qo ? qo.L : 0));
      if (ia && !("Z" in qo) && (qo.Z = 0), "p" in qo && (qo.H = qo.H % 12 + qo.p * 12), qo.m === void 0 && (qo.m = "q" in qo ? qo.q : 0), "V" in qo) {
        if (qo.V < 1 || qo.V > 53) return null;
        "w" in qo || (qo.w = 1), "Z" in qo ? ($a = utcDate(newDate(qo.y, 0, 1)), ys = $a.getUTCDay(), $a = ys > 4 || ys === 0 ? utcMonday.ceil($a) : utcMonday($a), $a = utcDay.offset($a, (qo.V - 1) * 7), qo.y = $a.getUTCFullYear(), qo.m = $a.getUTCMonth(), qo.d = $a.getUTCDate() + (qo.w + 6) % 7) : ($a = localDate(newDate(qo.y, 0, 1)), ys = $a.getDay(), $a = ys > 4 || ys === 0 ? timeMonday.ceil($a) : timeMonday($a), $a = timeDay.offset($a, (qo.V - 1) * 7), qo.y = $a.getFullYear(), qo.m = $a.getMonth(), qo.d = $a.getDate() + (qo.w + 6) % 7);
      } else ("W" in qo || "U" in qo) && ("w" in qo || (qo.w = "u" in qo ? qo.u % 7 : "W" in qo ? 1 : 0), ys = "Z" in qo ? utcDate(newDate(qo.y, 0, 1)).getUTCDay() : localDate(newDate(qo.y, 0, 1)).getDay(), qo.m = 0, qo.d = "W" in qo ? (qo.w + 6) % 7 + qo.W * 7 - (ys + 5) % 7 : qo.w + qo.U * 7 - (ys + 6) % 7);
      return "Z" in qo ? (qo.H += qo.Z / 100 | 0, qo.M += qo.Z % 100, utcDate(qo)) : localDate(qo);
    };
  }
  function io(ga, ia, ra, qo) {
    for (var xa = 0, $a = ia.length, ys = ra.length, Ss, Xa; xa < $a; ) {
      if (qo >= ys) return -1;
      if (Ss = ia.charCodeAt(xa++), Ss === 37) {
        if (Ss = ia.charAt(xa++), Xa = Di[Ss in pads ? ia.charAt(xa++) : Ss], !Xa || (qo = Xa(ga, ra, qo)) < 0) return -1;
      } else if (Ss != ra.charCodeAt(qo++))
        return -1;
    }
    return qo;
  }
  function xo(ga, ia, ra) {
    var qo = si.exec(ia.slice(ra));
    return qo ? (ga.p = di.get(qo[0].toLowerCase()), ra + qo[0].length) : -1;
  }
  function fo(ga, ia, ra) {
    var qo = mi.exec(ia.slice(ra));
    return qo ? (ga.w = Ti.get(qo[0].toLowerCase()), ra + qo[0].length) : -1;
  }
  function _o(ga, ia, ra) {
    var qo = fi.exec(ia.slice(ra));
    return qo ? (ga.w = gi.get(qo[0].toLowerCase()), ra + qo[0].length) : -1;
  }
  function Li(ga, ia, ra) {
    var qo = Si.exec(ia.slice(ra));
    return qo ? (ga.m = Pi.get(qo[0].toLowerCase()), ra + qo[0].length) : -1;
  }
  function Co(ga, ia, ra) {
    var qo = vi.exec(ia.slice(ra));
    return qo ? (ga.m = xi.get(qo[0].toLowerCase()), ra + qo[0].length) : -1;
  }
  function Ni(ga, ia, ra) {
    return io(ga, yt, ia, ra);
  }
  function Yi(ga, ia, ra) {
    return io(ga, ir, ia, ra);
  }
  function Vo(ga, ia, ra) {
    return io(ga, ti, ia, ra);
  }
  function No(ga) {
    return ai[ga.getDay()];
  }
  function Ui(ga) {
    return ui[ga.getDay()];
  }
  function jo(ga) {
    return oi[ga.getMonth()];
  }
  function Wi(ga) {
    return li[ga.getMonth()];
  }
  function ji(ga) {
    return ii[+(ga.getHours() >= 12)];
  }
  function Hi(ga) {
    return 1 + ~~(ga.getMonth() / 3);
  }
  function zo(ga) {
    return ai[ga.getUTCDay()];
  }
  function Lo(ga) {
    return ui[ga.getUTCDay()];
  }
  function sa(ga) {
    return oi[ga.getUTCMonth()];
  }
  function Ko(ga) {
    return li[ga.getUTCMonth()];
  }
  function ca(ga) {
    return ii[+(ga.getUTCHours() >= 12)];
  }
  function pa(ga) {
    return 1 + ~~(ga.getUTCMonth() / 3);
  }
  return {
    format: function(ga) {
      var ia = Mi(ga += "", $i);
      return ia.toString = function() {
        return ga;
      }, ia;
    },
    parse: function(ga) {
      var ia = Oo(ga += "", !1);
      return ia.toString = function() {
        return ga;
      }, ia;
    },
    utcFormat: function(ga) {
      var ia = Mi(ga += "", Oi);
      return ia.toString = function() {
        return ga;
      }, ia;
    },
    utcParse: function(ga) {
      var ia = Oo(ga += "", !0);
      return ia.toString = function() {
        return ga;
      }, ia;
    }
  };
}
var pads = { "-": "", _: " ", 0: "0" }, numberRe = /^\s*\d+/, percentRe = /^%/, requoteRe = /[\\^$*+?|[\]().{}]/g;
function pad(pt, yt, ir) {
  var ti = pt < 0 ? "-" : "", ii = (ti ? -pt : pt) + "", ui = ii.length;
  return ti + (ui < ir ? new Array(ir - ui + 1).join(yt) + ii : ii);
}
function requote(pt) {
  return pt.replace(requoteRe, "\\$&");
}
function formatRe(pt) {
  return new RegExp("^(?:" + pt.map(requote).join("|") + ")", "i");
}
function formatLookup(pt) {
  return new Map(pt.map((yt, ir) => [yt.toLowerCase(), ir]));
}
function parseWeekdayNumberSunday(pt, yt, ir) {
  var ti = numberRe.exec(yt.slice(ir, ir + 1));
  return ti ? (pt.w = +ti[0], ir + ti[0].length) : -1;
}
function parseWeekdayNumberMonday(pt, yt, ir) {
  var ti = numberRe.exec(yt.slice(ir, ir + 1));
  return ti ? (pt.u = +ti[0], ir + ti[0].length) : -1;
}
function parseWeekNumberSunday(pt, yt, ir) {
  var ti = numberRe.exec(yt.slice(ir, ir + 2));
  return ti ? (pt.U = +ti[0], ir + ti[0].length) : -1;
}
function parseWeekNumberISO(pt, yt, ir) {
  var ti = numberRe.exec(yt.slice(ir, ir + 2));
  return ti ? (pt.V = +ti[0], ir + ti[0].length) : -1;
}
function parseWeekNumberMonday(pt, yt, ir) {
  var ti = numberRe.exec(yt.slice(ir, ir + 2));
  return ti ? (pt.W = +ti[0], ir + ti[0].length) : -1;
}
function parseFullYear(pt, yt, ir) {
  var ti = numberRe.exec(yt.slice(ir, ir + 4));
  return ti ? (pt.y = +ti[0], ir + ti[0].length) : -1;
}
function parseYear(pt, yt, ir) {
  var ti = numberRe.exec(yt.slice(ir, ir + 2));
  return ti ? (pt.y = +ti[0] + (+ti[0] > 68 ? 1900 : 2e3), ir + ti[0].length) : -1;
}
function parseZone(pt, yt, ir) {
  var ti = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(yt.slice(ir, ir + 6));
  return ti ? (pt.Z = ti[1] ? 0 : -(ti[2] + (ti[3] || "00")), ir + ti[0].length) : -1;
}
function parseQuarter(pt, yt, ir) {
  var ti = numberRe.exec(yt.slice(ir, ir + 1));
  return ti ? (pt.q = ti[0] * 3 - 3, ir + ti[0].length) : -1;
}
function parseMonthNumber(pt, yt, ir) {
  var ti = numberRe.exec(yt.slice(ir, ir + 2));
  return ti ? (pt.m = ti[0] - 1, ir + ti[0].length) : -1;
}
function parseDayOfMonth(pt, yt, ir) {
  var ti = numberRe.exec(yt.slice(ir, ir + 2));
  return ti ? (pt.d = +ti[0], ir + ti[0].length) : -1;
}
function parseDayOfYear(pt, yt, ir) {
  var ti = numberRe.exec(yt.slice(ir, ir + 3));
  return ti ? (pt.m = 0, pt.d = +ti[0], ir + ti[0].length) : -1;
}
function parseHour24(pt, yt, ir) {
  var ti = numberRe.exec(yt.slice(ir, ir + 2));
  return ti ? (pt.H = +ti[0], ir + ti[0].length) : -1;
}
function parseMinutes(pt, yt, ir) {
  var ti = numberRe.exec(yt.slice(ir, ir + 2));
  return ti ? (pt.M = +ti[0], ir + ti[0].length) : -1;
}
function parseSeconds(pt, yt, ir) {
  var ti = numberRe.exec(yt.slice(ir, ir + 2));
  return ti ? (pt.S = +ti[0], ir + ti[0].length) : -1;
}
function parseMilliseconds(pt, yt, ir) {
  var ti = numberRe.exec(yt.slice(ir, ir + 3));
  return ti ? (pt.L = +ti[0], ir + ti[0].length) : -1;
}
function parseMicroseconds(pt, yt, ir) {
  var ti = numberRe.exec(yt.slice(ir, ir + 6));
  return ti ? (pt.L = Math.floor(ti[0] / 1e3), ir + ti[0].length) : -1;
}
function parseLiteralPercent(pt, yt, ir) {
  var ti = percentRe.exec(yt.slice(ir, ir + 1));
  return ti ? ir + ti[0].length : -1;
}
function parseUnixTimestamp(pt, yt, ir) {
  var ti = numberRe.exec(yt.slice(ir));
  return ti ? (pt.Q = +ti[0], ir + ti[0].length) : -1;
}
function parseUnixTimestampSeconds(pt, yt, ir) {
  var ti = numberRe.exec(yt.slice(ir));
  return ti ? (pt.s = +ti[0], ir + ti[0].length) : -1;
}
function formatDayOfMonth(pt, yt) {
  return pad(pt.getDate(), yt, 2);
}
function formatHour24(pt, yt) {
  return pad(pt.getHours(), yt, 2);
}
function formatHour12(pt, yt) {
  return pad(pt.getHours() % 12 || 12, yt, 2);
}
function formatDayOfYear(pt, yt) {
  return pad(1 + timeDay.count(timeYear(pt), pt), yt, 3);
}
function formatMilliseconds(pt, yt) {
  return pad(pt.getMilliseconds(), yt, 3);
}
function formatMicroseconds(pt, yt) {
  return formatMilliseconds(pt, yt) + "000";
}
function formatMonthNumber(pt, yt) {
  return pad(pt.getMonth() + 1, yt, 2);
}
function formatMinutes(pt, yt) {
  return pad(pt.getMinutes(), yt, 2);
}
function formatSeconds(pt, yt) {
  return pad(pt.getSeconds(), yt, 2);
}
function formatWeekdayNumberMonday(pt) {
  var yt = pt.getDay();
  return yt === 0 ? 7 : yt;
}
function formatWeekNumberSunday(pt, yt) {
  return pad(timeSunday.count(timeYear(pt) - 1, pt), yt, 2);
}
function dISO(pt) {
  var yt = pt.getDay();
  return yt >= 4 || yt === 0 ? timeThursday(pt) : timeThursday.ceil(pt);
}
function formatWeekNumberISO(pt, yt) {
  return pt = dISO(pt), pad(timeThursday.count(timeYear(pt), pt) + (timeYear(pt).getDay() === 4), yt, 2);
}
function formatWeekdayNumberSunday(pt) {
  return pt.getDay();
}
function formatWeekNumberMonday(pt, yt) {
  return pad(timeMonday.count(timeYear(pt) - 1, pt), yt, 2);
}
function formatYear(pt, yt) {
  return pad(pt.getFullYear() % 100, yt, 2);
}
function formatYearISO(pt, yt) {
  return pt = dISO(pt), pad(pt.getFullYear() % 100, yt, 2);
}
function formatFullYear(pt, yt) {
  return pad(pt.getFullYear() % 1e4, yt, 4);
}
function formatFullYearISO(pt, yt) {
  var ir = pt.getDay();
  return pt = ir >= 4 || ir === 0 ? timeThursday(pt) : timeThursday.ceil(pt), pad(pt.getFullYear() % 1e4, yt, 4);
}
function formatZone(pt) {
  var yt = pt.getTimezoneOffset();
  return (yt > 0 ? "-" : (yt *= -1, "+")) + pad(yt / 60 | 0, "0", 2) + pad(yt % 60, "0", 2);
}
function formatUTCDayOfMonth(pt, yt) {
  return pad(pt.getUTCDate(), yt, 2);
}
function formatUTCHour24(pt, yt) {
  return pad(pt.getUTCHours(), yt, 2);
}
function formatUTCHour12(pt, yt) {
  return pad(pt.getUTCHours() % 12 || 12, yt, 2);
}
function formatUTCDayOfYear(pt, yt) {
  return pad(1 + utcDay.count(utcYear(pt), pt), yt, 3);
}
function formatUTCMilliseconds(pt, yt) {
  return pad(pt.getUTCMilliseconds(), yt, 3);
}
function formatUTCMicroseconds(pt, yt) {
  return formatUTCMilliseconds(pt, yt) + "000";
}
function formatUTCMonthNumber(pt, yt) {
  return pad(pt.getUTCMonth() + 1, yt, 2);
}
function formatUTCMinutes(pt, yt) {
  return pad(pt.getUTCMinutes(), yt, 2);
}
function formatUTCSeconds(pt, yt) {
  return pad(pt.getUTCSeconds(), yt, 2);
}
function formatUTCWeekdayNumberMonday(pt) {
  var yt = pt.getUTCDay();
  return yt === 0 ? 7 : yt;
}
function formatUTCWeekNumberSunday(pt, yt) {
  return pad(utcSunday.count(utcYear(pt) - 1, pt), yt, 2);
}
function UTCdISO(pt) {
  var yt = pt.getUTCDay();
  return yt >= 4 || yt === 0 ? utcThursday(pt) : utcThursday.ceil(pt);
}
function formatUTCWeekNumberISO(pt, yt) {
  return pt = UTCdISO(pt), pad(utcThursday.count(utcYear(pt), pt) + (utcYear(pt).getUTCDay() === 4), yt, 2);
}
function formatUTCWeekdayNumberSunday(pt) {
  return pt.getUTCDay();
}
function formatUTCWeekNumberMonday(pt, yt) {
  return pad(utcMonday.count(utcYear(pt) - 1, pt), yt, 2);
}
function formatUTCYear(pt, yt) {
  return pad(pt.getUTCFullYear() % 100, yt, 2);
}
function formatUTCYearISO(pt, yt) {
  return pt = UTCdISO(pt), pad(pt.getUTCFullYear() % 100, yt, 2);
}
function formatUTCFullYear(pt, yt) {
  return pad(pt.getUTCFullYear() % 1e4, yt, 4);
}
function formatUTCFullYearISO(pt, yt) {
  var ir = pt.getUTCDay();
  return pt = ir >= 4 || ir === 0 ? utcThursday(pt) : utcThursday.ceil(pt), pad(pt.getUTCFullYear() % 1e4, yt, 4);
}
function formatUTCZone() {
  return "+0000";
}
function formatLiteralPercent() {
  return "%";
}
function formatUnixTimestamp(pt) {
  return +pt;
}
function formatUnixTimestampSeconds(pt) {
  return Math.floor(+pt / 1e3);
}
var locale, timeFormat, utcFormat;
defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function defaultLocale(pt) {
  return locale = formatLocale(pt), timeFormat = locale.format, locale.parse, utcFormat = locale.utcFormat, locale.utcParse, locale;
}
function date(pt) {
  return new Date(pt);
}
function number(pt) {
  return pt instanceof Date ? +pt : +/* @__PURE__ */ new Date(+pt);
}
function calendar(pt, yt, ir, ti, ii, ui, ai, li, oi, si) {
  var di = continuous(), fi = di.invert, gi = di.domain, mi = si(".%L"), Ti = si(":%S"), vi = si("%I:%M"), xi = si("%I %p"), Si = si("%a %d"), Pi = si("%b %d"), $i = si("%B"), Oi = si("%Y");
  function Di(Mi) {
    return (oi(Mi) < Mi ? mi : li(Mi) < Mi ? Ti : ai(Mi) < Mi ? vi : ui(Mi) < Mi ? xi : ti(Mi) < Mi ? ii(Mi) < Mi ? Si : Pi : ir(Mi) < Mi ? $i : Oi)(Mi);
  }
  return di.invert = function(Mi) {
    return new Date(fi(Mi));
  }, di.domain = function(Mi) {
    return arguments.length ? gi(Array.from(Mi, number)) : gi().map(date);
  }, di.ticks = function(Mi) {
    var Oo = gi();
    return pt(Oo[0], Oo[Oo.length - 1], Mi ?? 10);
  }, di.tickFormat = function(Mi, Oo) {
    return Oo == null ? Di : si(Oo);
  }, di.nice = function(Mi) {
    var Oo = gi();
    return (!Mi || typeof Mi.range != "function") && (Mi = yt(Oo[0], Oo[Oo.length - 1], Mi ?? 10)), Mi ? gi(nice(Oo, Mi)) : di;
  }, di.copy = function() {
    return copy$1(di, calendar(pt, yt, ir, ti, ii, ui, ai, li, oi, si));
  }, di;
}
function time() {
  return initRange.apply(calendar(timeTicks, timeTickInterval, timeYear, timeMonth, timeSunday, timeDay, timeHour, timeMinute, second, timeFormat).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function utcTime() {
  return initRange.apply(calendar(utcTicks, utcTickInterval, utcYear, utcMonth, utcSunday, utcDay, utcHour, utcMinute, second, utcFormat).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function transformer$1() {
  var pt = 0, yt = 1, ir, ti, ii, ui, ai = identity$2, li = !1, oi;
  function si(fi) {
    return fi == null || isNaN(fi = +fi) ? oi : ai(ii === 0 ? 0.5 : (fi = (ui(fi) - ir) * ii, li ? Math.max(0, Math.min(1, fi)) : fi));
  }
  si.domain = function(fi) {
    return arguments.length ? ([pt, yt] = fi, ir = ui(pt = +pt), ti = ui(yt = +yt), ii = ir === ti ? 0 : 1 / (ti - ir), si) : [pt, yt];
  }, si.clamp = function(fi) {
    return arguments.length ? (li = !!fi, si) : li;
  }, si.interpolator = function(fi) {
    return arguments.length ? (ai = fi, si) : ai;
  };
  function di(fi) {
    return function(gi) {
      var mi, Ti;
      return arguments.length ? ([mi, Ti] = gi, ai = fi(mi, Ti), si) : [ai(0), ai(1)];
    };
  }
  return si.range = di(interpolate), si.rangeRound = di(interpolateRound), si.unknown = function(fi) {
    return arguments.length ? (oi = fi, si) : oi;
  }, function(fi) {
    return ui = fi, ir = fi(pt), ti = fi(yt), ii = ir === ti ? 0 : 1 / (ti - ir), si;
  };
}
function copy$4(pt, yt) {
  return yt.domain(pt.domain()).interpolator(pt.interpolator()).clamp(pt.clamp()).unknown(pt.unknown());
}
function sequential() {
  var pt = linearish(transformer$1()(identity$2));
  return pt.copy = function() {
    return copy$4(pt, sequential());
  }, initInterpolator.apply(pt, arguments);
}
function sequentialLog() {
  var pt = loggish(transformer$1()).domain([1, 10]);
  return pt.copy = function() {
    return copy$4(pt, sequentialLog()).base(pt.base());
  }, initInterpolator.apply(pt, arguments);
}
function sequentialSymlog() {
  var pt = symlogish(transformer$1());
  return pt.copy = function() {
    return copy$4(pt, sequentialSymlog()).constant(pt.constant());
  }, initInterpolator.apply(pt, arguments);
}
function sequentialPow() {
  var pt = powish(transformer$1());
  return pt.copy = function() {
    return copy$4(pt, sequentialPow()).exponent(pt.exponent());
  }, initInterpolator.apply(pt, arguments);
}
function sequentialSqrt() {
  return sequentialPow.apply(null, arguments).exponent(0.5);
}
function sequentialQuantile() {
  var pt = [], yt = identity$2;
  function ir(ti) {
    if (ti != null && !isNaN(ti = +ti)) return yt((bisectRight(pt, ti, 1) - 1) / (pt.length - 1));
  }
  return ir.domain = function(ti) {
    if (!arguments.length) return pt.slice();
    pt = [];
    for (let ii of ti) ii != null && !isNaN(ii = +ii) && pt.push(ii);
    return pt.sort(ascending), ir;
  }, ir.interpolator = function(ti) {
    return arguments.length ? (yt = ti, ir) : yt;
  }, ir.range = function() {
    return pt.map((ti, ii) => yt(ii / (pt.length - 1)));
  }, ir.quantiles = function(ti) {
    return Array.from({ length: ti + 1 }, (ii, ui) => quantile$1(pt, ui / ti));
  }, ir.copy = function() {
    return sequentialQuantile(yt).domain(pt);
  }, initInterpolator.apply(ir, arguments);
}
function transformer() {
  var pt = 0, yt = 0.5, ir = 1, ti = 1, ii, ui, ai, li, oi, si = identity$2, di, fi = !1, gi;
  function mi(vi) {
    return isNaN(vi = +vi) ? gi : (vi = 0.5 + ((vi = +di(vi)) - ui) * (ti * vi < ti * ui ? li : oi), si(fi ? Math.max(0, Math.min(1, vi)) : vi));
  }
  mi.domain = function(vi) {
    return arguments.length ? ([pt, yt, ir] = vi, ii = di(pt = +pt), ui = di(yt = +yt), ai = di(ir = +ir), li = ii === ui ? 0 : 0.5 / (ui - ii), oi = ui === ai ? 0 : 0.5 / (ai - ui), ti = ui < ii ? -1 : 1, mi) : [pt, yt, ir];
  }, mi.clamp = function(vi) {
    return arguments.length ? (fi = !!vi, mi) : fi;
  }, mi.interpolator = function(vi) {
    return arguments.length ? (si = vi, mi) : si;
  };
  function Ti(vi) {
    return function(xi) {
      var Si, Pi, $i;
      return arguments.length ? ([Si, Pi, $i] = xi, si = piecewise(vi, [Si, Pi, $i]), mi) : [si(0), si(0.5), si(1)];
    };
  }
  return mi.range = Ti(interpolate), mi.rangeRound = Ti(interpolateRound), mi.unknown = function(vi) {
    return arguments.length ? (gi = vi, mi) : gi;
  }, function(vi) {
    return di = vi, ii = vi(pt), ui = vi(yt), ai = vi(ir), li = ii === ui ? 0 : 0.5 / (ui - ii), oi = ui === ai ? 0 : 0.5 / (ai - ui), ti = ui < ii ? -1 : 1, mi;
  };
}
function diverging() {
  var pt = linearish(transformer()(identity$2));
  return pt.copy = function() {
    return copy$4(pt, diverging());
  }, initInterpolator.apply(pt, arguments);
}
function divergingLog() {
  var pt = loggish(transformer()).domain([0.1, 1, 10]);
  return pt.copy = function() {
    return copy$4(pt, divergingLog()).base(pt.base());
  }, initInterpolator.apply(pt, arguments);
}
function divergingSymlog() {
  var pt = symlogish(transformer());
  return pt.copy = function() {
    return copy$4(pt, divergingSymlog()).constant(pt.constant());
  }, initInterpolator.apply(pt, arguments);
}
function divergingPow() {
  var pt = powish(transformer());
  return pt.copy = function() {
    return copy$4(pt, divergingPow()).exponent(pt.exponent());
  }, initInterpolator.apply(pt, arguments);
}
function divergingSqrt() {
  return divergingPow.apply(null, arguments).exponent(0.5);
}
const d3Scales = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: band,
  scaleDiverging: diverging,
  scaleDivergingLog: divergingLog,
  scaleDivergingPow: divergingPow,
  scaleDivergingSqrt: divergingSqrt,
  scaleDivergingSymlog: divergingSymlog,
  scaleIdentity: identity,
  scaleImplicit: implicit,
  scaleLinear: linear,
  scaleLog: log$1,
  scaleOrdinal: ordinal,
  scalePoint: point,
  scalePow: pow,
  scaleQuantile: quantile,
  scaleQuantize: quantize,
  scaleRadial: radial,
  scaleSequential: sequential,
  scaleSequentialLog: sequentialLog,
  scaleSequentialPow: sequentialPow,
  scaleSequentialQuantile: sequentialQuantile,
  scaleSequentialSqrt: sequentialSqrt,
  scaleSequentialSymlog: sequentialSymlog,
  scaleSqrt: sqrt,
  scaleSymlog: symlog,
  scaleThreshold: threshold,
  scaleTime: time,
  scaleUtc: utcTime,
  tickFormat
}, Symbol.toStringTag, { value: "Module" }));
function getD3ScaleFromType(pt) {
  var yt = d3Scales;
  if (pt in yt && typeof yt[pt] == "function")
    return yt[pt]();
  var ir = "scale".concat(upperFirst(pt));
  if (ir in yt && typeof yt[ir] == "function")
    return yt[ir]();
}
function combineConfiguredScaleInternal(pt, yt, ir) {
  if (typeof pt == "function")
    return pt.copy().domain(yt).range(ir);
  if (pt != null) {
    var ti = getD3ScaleFromType(pt);
    if (ti != null)
      return ti.domain(yt).range(ir), ti;
  }
}
function combineConfiguredScale(pt, yt, ir, ti) {
  if (!(ir == null || ti == null))
    return typeof pt.scale == "function" ? combineConfiguredScaleInternal(pt.scale, ir, ti) : combineConfiguredScaleInternal(yt, ir, ti);
}
function getD3ScaleName(pt) {
  return "scale".concat(upperFirst(pt));
}
function isSupportedScaleName(pt) {
  return getD3ScaleName(pt) in d3Scales;
}
var combineRealScaleType = (pt, yt, ir) => {
  if (pt != null) {
    var {
      scale: ti,
      type: ii
    } = pt;
    if (ti === "auto")
      return ii === "category" && ir && (ir.indexOf("LineChart") >= 0 || ir.indexOf("AreaChart") >= 0 || ir.indexOf("ComposedChart") >= 0 && !yt) ? "point" : ii === "category" ? "band" : "linear";
    if (typeof ti == "string")
      return isSupportedScaleName(ti) ? ti : "point";
  }
};
function bisect(pt, yt) {
  for (var ir = 0, ti = pt.length, ii = pt[0] < pt[pt.length - 1]; ir < ti; ) {
    var ui = Math.floor((ir + ti) / 2);
    (ii ? pt[ui] < yt : pt[ui] > yt) ? ir = ui + 1 : ti = ui;
  }
  return ir;
}
function createCategoricalInverse(pt, yt) {
  if (pt) {
    var ir = yt ?? pt.domain(), ti = ir.map((ui) => {
      var ai;
      return (ai = pt(ui)) !== null && ai !== void 0 ? ai : 0;
    }), ii = pt.range();
    if (!(ir.length === 0 || ii.length < 2))
      return (ui) => {
        var ai, li, oi = bisect(ti, ui);
        if (oi <= 0)
          return ir[0];
        if (oi >= ir.length)
          return ir[ir.length - 1];
        var si = (ai = ti[oi - 1]) !== null && ai !== void 0 ? ai : 0, di = (li = ti[oi]) !== null && li !== void 0 ? li : 0;
        return Math.abs(ui - si) <= Math.abs(ui - di) ? ir[oi - 1] : ir[oi];
      };
  }
}
function combineInverseScaleFunction(pt) {
  if (pt != null)
    return "invert" in pt && typeof pt.invert == "function" ? pt.invert.bind(pt) : createCategoricalInverse(pt, void 0);
}
function ownKeys$n(pt, yt) {
  var ir = Object.keys(pt);
  if (Object.getOwnPropertySymbols) {
    var ti = Object.getOwnPropertySymbols(pt);
    yt && (ti = ti.filter(function(ii) {
      return Object.getOwnPropertyDescriptor(pt, ii).enumerable;
    })), ir.push.apply(ir, ti);
  }
  return ir;
}
function _objectSpread$n(pt) {
  for (var yt = 1; yt < arguments.length; yt++) {
    var ir = arguments[yt] != null ? arguments[yt] : {};
    yt % 2 ? ownKeys$n(Object(ir), !0).forEach(function(ti) {
      _defineProperty$p(pt, ti, ir[ti]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(pt, Object.getOwnPropertyDescriptors(ir)) : ownKeys$n(Object(ir)).forEach(function(ti) {
      Object.defineProperty(pt, ti, Object.getOwnPropertyDescriptor(ir, ti));
    });
  }
  return pt;
}
function _defineProperty$p(pt, yt, ir) {
  return (yt = _toPropertyKey$p(yt)) in pt ? Object.defineProperty(pt, yt, { value: ir, enumerable: !0, configurable: !0, writable: !0 }) : pt[yt] = ir, pt;
}
function _toPropertyKey$p(pt) {
  var yt = _toPrimitive$p(pt, "string");
  return typeof yt == "symbol" ? yt : yt + "";
}
function _toPrimitive$p(pt, yt) {
  if (typeof pt != "object" || !pt) return pt;
  var ir = pt[Symbol.toPrimitive];
  if (ir !== void 0) {
    var ti = ir.call(pt, yt);
    if (typeof ti != "object") return ti;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (yt === "string" ? String : Number)(pt);
}
var defaultNumericDomain = [0, "auto"], implicitXAxis = {
  allowDataOverflow: !1,
  allowDecimals: !0,
  allowDuplicatedCategory: !0,
  angle: 0,
  dataKey: void 0,
  domain: void 0,
  height: 30,
  hide: !0,
  id: 0,
  includeHidden: !1,
  interval: "preserveEnd",
  minTickGap: 5,
  mirror: !1,
  name: void 0,
  orientation: "bottom",
  padding: {
    left: 0,
    right: 0
  },
  reversed: !1,
  scale: "auto",
  tick: !0,
  tickCount: 5,
  tickFormatter: void 0,
  ticks: void 0,
  type: "category",
  unit: void 0,
  niceTicks: "auto"
}, selectXAxisSettingsNoDefaults = (pt, yt) => pt.cartesianAxis.xAxis[yt], selectXAxisSettings = (pt, yt) => {
  var ir = selectXAxisSettingsNoDefaults(pt, yt);
  return ir ?? implicitXAxis;
}, implicitYAxis = {
  allowDataOverflow: !1,
  allowDecimals: !0,
  allowDuplicatedCategory: !0,
  angle: 0,
  dataKey: void 0,
  domain: defaultNumericDomain,
  hide: !0,
  id: 0,
  includeHidden: !1,
  interval: "preserveEnd",
  minTickGap: 5,
  mirror: !1,
  name: void 0,
  orientation: "left",
  padding: {
    top: 0,
    bottom: 0
  },
  reversed: !1,
  scale: "auto",
  tick: !0,
  tickCount: 5,
  tickFormatter: void 0,
  ticks: void 0,
  type: "number",
  unit: void 0,
  niceTicks: "auto",
  width: DEFAULT_Y_AXIS_WIDTH
}, selectYAxisSettingsNoDefaults = (pt, yt) => pt.cartesianAxis.yAxis[yt], selectYAxisSettings = (pt, yt) => {
  var ir = selectYAxisSettingsNoDefaults(pt, yt);
  return ir ?? implicitYAxis;
}, implicitZAxis = {
  domain: [0, "auto"],
  includeHidden: !1,
  reversed: !1,
  allowDataOverflow: !1,
  allowDuplicatedCategory: !1,
  dataKey: void 0,
  id: 0,
  name: "",
  range: [64, 64],
  scale: "auto",
  type: "number",
  unit: ""
}, selectZAxisSettings = (pt, yt) => {
  var ir = pt.cartesianAxis.zAxis[yt];
  return ir ?? implicitZAxis;
}, selectBaseAxis = (pt, yt, ir) => {
  switch (yt) {
    case "xAxis":
      return selectXAxisSettings(pt, ir);
    case "yAxis":
      return selectYAxisSettings(pt, ir);
    case "zAxis":
      return selectZAxisSettings(pt, ir);
    case "angleAxis":
      return selectAngleAxis(pt, ir);
    case "radiusAxis":
      return selectRadiusAxis(pt, ir);
    default:
      throw new Error("Unexpected axis type: ".concat(yt));
  }
}, selectCartesianAxisSettings = (pt, yt, ir) => {
  switch (yt) {
    case "xAxis":
      return selectXAxisSettings(pt, ir);
    case "yAxis":
      return selectYAxisSettings(pt, ir);
    default:
      throw new Error("Unexpected axis type: ".concat(yt));
  }
}, selectRenderableAxisSettings = (pt, yt, ir) => {
  switch (yt) {
    case "xAxis":
      return selectXAxisSettings(pt, ir);
    case "yAxis":
      return selectYAxisSettings(pt, ir);
    case "angleAxis":
      return selectAngleAxis(pt, ir);
    case "radiusAxis":
      return selectRadiusAxis(pt, ir);
    default:
      throw new Error("Unexpected axis type: ".concat(yt));
  }
}, selectHasBar = (pt) => pt.graphicalItems.cartesianItems.some((yt) => yt.type === "bar") || pt.graphicalItems.polarItems.some((yt) => yt.type === "radialBar");
function itemAxisPredicate(pt, yt) {
  return (ir) => {
    switch (pt) {
      case "xAxis":
        return "xAxisId" in ir && ir.xAxisId === yt;
      case "yAxis":
        return "yAxisId" in ir && ir.yAxisId === yt;
      case "zAxis":
        return "zAxisId" in ir && ir.zAxisId === yt;
      case "angleAxis":
        return "angleAxisId" in ir && ir.angleAxisId === yt;
      case "radiusAxis":
        return "radiusAxisId" in ir && ir.radiusAxisId === yt;
      default:
        return !1;
    }
  };
}
var selectUnfilteredCartesianItems = (pt) => pt.graphicalItems.cartesianItems, selectAxisPredicate = createSelector([pickAxisType, pickAxisId], itemAxisPredicate), combineGraphicalItemsSettings = (pt, yt, ir) => pt.filter(ir).filter((ti) => (yt == null ? void 0 : yt.includeHidden) === !0 ? !0 : !ti.hide), selectCartesianItemsSettings = createSelector([selectUnfilteredCartesianItems, selectBaseAxis, selectAxisPredicate], combineGraphicalItemsSettings, {
  memoizeOptions: {
    resultEqualityCheck: emptyArraysAreEqualCheck
  }
}), selectStackedCartesianItemsSettings = createSelector([selectCartesianItemsSettings], (pt) => pt.filter((yt) => yt.type === "area" || yt.type === "bar").filter(isStacked)), filterGraphicalNotStackedItems = (pt) => pt.filter((yt) => !("stackId" in yt) || yt.stackId === void 0), selectCartesianItemsSettingsExceptStacked = createSelector([selectCartesianItemsSettings], filterGraphicalNotStackedItems), combineGraphicalItemsData = (pt) => pt.map((yt) => yt.data).filter(Boolean).flat(1), selectAnyCartesianItemsUsesChartData = createSelector([selectCartesianItemsSettings], (pt) => pt.some((yt) => !yt.data)), selectCartesianGraphicalItemsData = createSelector([selectCartesianItemsSettings], combineGraphicalItemsData, {
  memoizeOptions: {
    resultEqualityCheck: emptyArraysAreEqualCheck
  }
}), combineDisplayedData = (pt, yt) => {
  var {
    chartData: ir = [],
    dataStartIndex: ti,
    dataEndIndex: ii
  } = yt;
  return pt.length > 0 ? pt : ir.slice(ti, ii + 1);
}, selectDisplayedData = createSelector([selectCartesianGraphicalItemsData, selectChartDataWithIndexesIfNotInPanoramaPosition4], combineDisplayedData), combineAppliedValues = (pt, yt, ir) => (yt == null ? void 0 : yt.dataKey) != null ? pt.map((ti) => ({
  value: getValueByDataKey(ti, yt.dataKey)
})) : ir.length > 0 ? ir.map((ti) => ti.dataKey).flatMap((ti) => pt.map((ii) => ({
  value: getValueByDataKey(ii, ti)
}))) : pt.map((ti) => ({
  value: ti
})), combineAllAppliedValues = (pt, yt, ir, ti, ii, ui) => {
  var {
    chartData: ai = [],
    dataStartIndex: li,
    dataEndIndex: oi
  } = ti, si = combineAppliedValues(pt, yt, ir);
  if (ii && (yt == null ? void 0 : yt.dataKey) != null && ui.length > 0) {
    var di = ai.slice(li, oi + 1), fi = di.map((gi) => ({
      value: getValueByDataKey(gi, yt.dataKey)
    })).filter((gi) => gi.value != null);
    return [...fi, ...si];
  }
  return si;
}, selectAllAppliedValues = createSelector([selectDisplayedData, selectBaseAxis, selectCartesianItemsSettings, selectChartDataWithIndexesIfNotInPanoramaPosition4, selectAnyCartesianItemsUsesChartData, selectCartesianGraphicalItemsData], combineAllAppliedValues);
function makeNumber(pt) {
  if (isNumOrStr(pt) || pt instanceof Date) {
    var yt = Number(pt);
    if (isWellBehavedNumber(yt))
      return yt;
  }
}
function makeDomain(pt) {
  if (Array.isArray(pt)) {
    var yt = [makeNumber(pt[0]), makeNumber(pt[1])];
    return isWellFormedNumberDomain(yt) ? yt : void 0;
  }
  var ir = makeNumber(pt);
  if (ir != null)
    return [ir, ir];
}
function onlyAllowNumbers(pt) {
  return pt.map(makeNumber).filter(isNotNil);
}
function sortBy(pt, yt) {
  var ir = makeNumber(pt), ti = makeNumber(yt);
  return ir == null && ti == null ? 0 : ir == null ? -1 : ti == null ? 1 : ir - ti;
}
var selectSortedDataPoints = createSelector([selectAllAppliedValues], (pt) => pt == null ? void 0 : pt.map((yt) => yt.value).sort(sortBy));
function isErrorBarRelevantForAxisType(pt, yt) {
  switch (pt) {
    case "xAxis":
      return yt.direction === "x";
    case "yAxis":
      return yt.direction === "y";
    default:
      return !1;
  }
}
function getErrorDomainByDataKey(pt, yt, ir) {
  if (!ir)
    return [];
  if (!ir.length)
    return [];
  var ti;
  if (typeof yt == "number" && !isNan(yt))
    ti = yt;
  else if (Array.isArray(yt)) {
    var ii = onlyAllowNumbers(yt);
    ii.length > 0 && (ti = Math.max(...ii));
  }
  return ti == null ? [] : onlyAllowNumbers(ir.flatMap((ui) => {
    var ai = getValueByDataKey(pt, ui.dataKey), li, oi;
    if (Array.isArray(ai) ? [li, oi] = ai : li = oi = ai, !(!isWellBehavedNumber(li) || !isWellBehavedNumber(oi)))
      return [ti - li, ti + oi];
  }));
}
var selectTooltipAxis = (pt) => {
  var yt = selectTooltipAxisType(pt), ir = selectTooltipAxisId(pt);
  return selectRenderableAxisSettings(pt, yt, ir);
}, selectTooltipAxisDataKey = createSelector([selectTooltipAxis], (pt) => pt == null ? void 0 : pt.dataKey), selectDisplayedStackedData = createSelector([selectStackedCartesianItemsSettings, selectChartDataWithIndexesIfNotInPanoramaPosition4, selectTooltipAxis], combineDisplayedStackedData), combineStackGroups = (pt, yt, ir, ti) => {
  var ii = {}, ui = yt.reduce((ai, li) => {
    if (li.stackId == null)
      return ai;
    var oi = ai[li.stackId];
    return oi == null && (oi = []), oi.push(li), ai[li.stackId] = oi, ai;
  }, ii);
  return Object.fromEntries(Object.entries(ui).map((ai) => {
    var [li, oi] = ai, si = ti ? [...oi].reverse() : oi, di = si.map(getStackSeriesIdentifier);
    return [li, {
      // @ts-expect-error getStackedData requires that the input is array of objects, Recharts does not test for that
      stackedData: getStackedData(pt, di, ir),
      graphicalItems: si
    }];
  }));
}, selectStackGroups = createSelector([selectDisplayedStackedData, selectStackedCartesianItemsSettings, selectStackOffsetType, selectReverseStackOrder], combineStackGroups), combineDomainOfStackGroups = (pt, yt, ir, ti) => {
  var {
    dataStartIndex: ii,
    dataEndIndex: ui
  } = yt;
  if (ti == null && ir !== "zAxis") {
    var ai = getDomainOfStackGroups(pt, ii, ui);
    if (!(ai != null && ai[0] === 0 && ai[1] === 0))
      return ai;
  }
}, selectAllowsDataOverflow = createSelector([selectBaseAxis], (pt) => pt.allowDataOverflow), getDomainDefinition = (pt) => {
  var yt;
  if (pt == null || !("domain" in pt))
    return defaultNumericDomain;
  if (pt.domain != null)
    return pt.domain;
  if ("ticks" in pt && pt.ticks != null) {
    if (pt.type === "number") {
      var ir = onlyAllowNumbers(pt.ticks);
      return [Math.min(...ir), Math.max(...ir)];
    }
    if (pt.type === "category")
      return pt.ticks.map(String);
  }
  return (yt = pt == null ? void 0 : pt.domain) !== null && yt !== void 0 ? yt : defaultNumericDomain;
}, selectDomainDefinition = createSelector([selectBaseAxis], getDomainDefinition), selectDomainFromUserPreference = createSelector([selectDomainDefinition, selectAllowsDataOverflow], numericalDomainSpecifiedWithoutRequiringData), selectDomainOfStackGroups = createSelector([selectStackGroups, selectChartDataWithIndexes, pickAxisType, selectDomainFromUserPreference], combineDomainOfStackGroups, {
  memoizeOptions: {
    resultEqualityCheck: numberDomainEqualityCheck
  }
}), selectAllErrorBarSettings = (pt) => pt.errorBars, combineRelevantErrorBarSettings = (pt, yt, ir) => pt.flatMap((ti) => yt[ti.id]).filter(Boolean).filter((ti) => isErrorBarRelevantForAxisType(ir, ti)), mergeDomains = function() {
  for (var pt = arguments.length, yt = new Array(pt), ir = 0; ir < pt; ir++)
    yt[ir] = arguments[ir];
  var ti = yt.filter(Boolean);
  if (ti.length !== 0) {
    var ii = ti.flat(), ui = Math.min(...ii), ai = Math.max(...ii);
    return [ui, ai];
  }
}, combineDomainOfAllAppliedNumericalValuesIncludingErrorValues = function(pt, yt, ir, ti, ii) {
  var ui = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : [], ai, li;
  if (ir.length > 0 && ir.forEach((oi) => {
    var si, di = oi.data != null ? [...oi.data] : ui, fi = (si = ti[oi.id]) === null || si === void 0 ? void 0 : si.filter((gi) => isErrorBarRelevantForAxisType(ii, gi));
    di.forEach((gi) => {
      var mi, Ti = getValueByDataKey(gi, (mi = yt.dataKey) !== null && mi !== void 0 ? mi : oi.dataKey), vi = getErrorDomainByDataKey(gi, Ti, fi);
      if (vi.length >= 2) {
        var xi = Math.min(...vi), Si = Math.max(...vi);
        (ai == null || xi < ai) && (ai = xi), (li == null || Si > li) && (li = Si);
      }
      var Pi = makeDomain(Ti);
      Pi != null && (ai = ai == null ? Pi[0] : Math.min(ai, Pi[0]), li = li == null ? Pi[1] : Math.max(li, Pi[1]));
    });
  }), (yt == null ? void 0 : yt.dataKey) != null && ir.length === 0 && pt.forEach((oi) => {
    var si = makeDomain(getValueByDataKey(oi, yt.dataKey));
    si != null && (ai = ai == null ? si[0] : Math.min(ai, si[0]), li = li == null ? si[1] : Math.max(li, si[1]));
  }), isWellBehavedNumber(ai) && isWellBehavedNumber(li))
    return [ai, li];
}, selectDomainOfAllAppliedNumericalValuesIncludingErrorValues$1 = createSelector([selectDisplayedData, selectBaseAxis, selectCartesianItemsSettingsExceptStacked, selectAllErrorBarSettings, pickAxisType, selectChartDataSliceIfNotInPanorama], combineDomainOfAllAppliedNumericalValuesIncludingErrorValues, {
  memoizeOptions: {
    resultEqualityCheck: numberDomainEqualityCheck
  }
});
function onlyAllowNumbersAndStringsAndDates(pt) {
  var {
    value: yt
  } = pt;
  if (isNumOrStr(yt) || yt instanceof Date)
    return yt;
}
var computeDomainOfTypeCategory = (pt, yt, ir) => {
  var ti = pt.map(onlyAllowNumbersAndStringsAndDates).filter((ii) => ii != null);
  return ir && (yt.dataKey == null || yt.allowDuplicatedCategory && hasDuplicate(ti)) ? range$1(0, pt.length) : yt.allowDuplicatedCategory ? ti : Array.from(new Set(ti));
}, selectReferenceDots = (pt) => pt.referenceElements.dots, filterReferenceElements = (pt, yt, ir) => pt.filter((ti) => ti.ifOverflow === "extendDomain").filter((ti) => yt === "xAxis" ? ti.xAxisId === ir : ti.yAxisId === ir), selectReferenceDotsByAxis = createSelector([selectReferenceDots, pickAxisType, pickAxisId], filterReferenceElements), selectReferenceAreas = (pt) => pt.referenceElements.areas, selectReferenceAreasByAxis = createSelector([selectReferenceAreas, pickAxisType, pickAxisId], filterReferenceElements), selectReferenceLines = (pt) => pt.referenceElements.lines, selectReferenceLinesByAxis = createSelector([selectReferenceLines, pickAxisType, pickAxisId], filterReferenceElements), combineDotsDomain = (pt, yt) => {
  if (pt != null) {
    var ir = onlyAllowNumbers(pt.map((ti) => yt === "xAxis" ? ti.x : ti.y));
    if (ir.length !== 0)
      return [Math.min(...ir), Math.max(...ir)];
  }
}, selectReferenceDotsDomain = createSelector(selectReferenceDotsByAxis, pickAxisType, combineDotsDomain), combineAreasDomain = (pt, yt) => {
  if (pt != null) {
    var ir = onlyAllowNumbers(pt.flatMap((ti) => [yt === "xAxis" ? ti.x1 : ti.y1, yt === "xAxis" ? ti.x2 : ti.y2]));
    if (ir.length !== 0)
      return [Math.min(...ir), Math.max(...ir)];
  }
}, selectReferenceAreasDomain = createSelector([selectReferenceAreasByAxis, pickAxisType], combineAreasDomain);
function extractXCoordinates(pt) {
  var yt;
  if (pt.x != null)
    return onlyAllowNumbers([pt.x]);
  var ir = (yt = pt.segment) === null || yt === void 0 ? void 0 : yt.map((ti) => ti.x);
  return ir == null || ir.length === 0 ? [] : onlyAllowNumbers(ir);
}
function extractYCoordinates(pt) {
  var yt;
  if (pt.y != null)
    return onlyAllowNumbers([pt.y]);
  var ir = (yt = pt.segment) === null || yt === void 0 ? void 0 : yt.map((ti) => ti.y);
  return ir == null || ir.length === 0 ? [] : onlyAllowNumbers(ir);
}
var combineLinesDomain = (pt, yt) => {
  if (pt != null) {
    var ir = pt.flatMap((ti) => yt === "xAxis" ? extractXCoordinates(ti) : extractYCoordinates(ti));
    if (ir.length !== 0)
      return [Math.min(...ir), Math.max(...ir)];
  }
}, selectReferenceLinesDomain = createSelector([selectReferenceLinesByAxis, pickAxisType], combineLinesDomain), selectReferenceElementsDomain = createSelector(selectReferenceDotsDomain, selectReferenceLinesDomain, selectReferenceAreasDomain, (pt, yt, ir) => mergeDomains(pt, ir, yt)), combineNumericalDomain = (pt, yt, ir, ti, ii, ui, ai, li) => {
  if (ir != null)
    return ir;
  var oi = ai === "vertical" && li === "xAxis" || ai === "horizontal" && li === "yAxis", si = oi ? mergeDomains(ti, ui, ii) : mergeDomains(ui, ii);
  return parseNumericalUserDomain(yt, si, pt.allowDataOverflow);
}, selectNumericalDomain = createSelector([selectBaseAxis, selectDomainDefinition, selectDomainFromUserPreference, selectDomainOfStackGroups, selectDomainOfAllAppliedNumericalValuesIncludingErrorValues$1, selectReferenceElementsDomain, selectChartLayout, pickAxisType], combineNumericalDomain, {
  memoizeOptions: {
    resultEqualityCheck: numberDomainEqualityCheck
  }
}), expandDomain = [0, 1], combineAxisDomain = (pt, yt, ir, ti, ii, ui, ai) => {
  if (!((pt == null || ir == null || ir.length === 0) && ai === void 0)) {
    var {
      dataKey: li,
      type: oi
    } = pt, si = isCategoricalAxis(yt, ui);
    if (si && li == null) {
      var di;
      return range$1(0, (di = ir == null ? void 0 : ir.length) !== null && di !== void 0 ? di : 0);
    }
    return oi === "category" ? computeDomainOfTypeCategory(ti, pt, si) : ii === "expand" && !si ? expandDomain : ai;
  }
}, selectAxisDomain = createSelector([selectBaseAxis, selectChartLayout, selectDisplayedData, selectAllAppliedValues, selectStackOffsetType, pickAxisType, selectNumericalDomain], combineAxisDomain), selectRealScaleType = createSelector([selectBaseAxis, selectHasBar, selectChartName], combineRealScaleType), combineNiceTicks = (pt, yt, ir) => {
  var {
    niceTicks: ti
  } = yt;
  if (ti !== "none") {
    var ii = getDomainDefinition(yt), ui = Array.isArray(ii) && (ii[0] === "auto" || ii[1] === "auto");
    if ((ti === "snap125" || ti === "adaptive") && yt != null && yt.tickCount && isWellFormedNumberDomain(pt)) {
      if (ui)
        return getNiceTickValues(pt, yt.tickCount, yt.allowDecimals, ti);
      if (yt.type === "number")
        return getTickValuesFixedDomain(pt, yt.tickCount, yt.allowDecimals, ti);
    }
    if (ti === "auto" && ir === "linear" && yt != null && yt.tickCount) {
      if (ui && isWellFormedNumberDomain(pt))
        return getNiceTickValues(pt, yt.tickCount, yt.allowDecimals, "adaptive");
      if (yt.type === "number" && isWellFormedNumberDomain(pt))
        return getTickValuesFixedDomain(pt, yt.tickCount, yt.allowDecimals, "adaptive");
    }
  }
}, selectNiceTicks = createSelector([selectAxisDomain, selectRenderableAxisSettings, selectRealScaleType], combineNiceTicks), combineAxisDomainWithNiceTicks = (pt, yt, ir, ti) => {
  if (
    /*
     * Angle axis for some reason uses nice ticks when rendering axis tick labels,
     * but doesn't use nice ticks for extending domain like all the other axes do.
     * Not really sure why? Is there a good reason,
     * or is it just because someone added support for nice ticks to the other axes and forgot this one?
     */
    ti !== "angleAxis" && (pt == null ? void 0 : pt.type) === "number" && isWellFormedNumberDomain(yt) && Array.isArray(ir) && ir.length > 0
  ) {
    var ii, ui, ai = yt[0], li = (ii = ir[0]) !== null && ii !== void 0 ? ii : 0, oi = yt[1], si = (ui = ir[ir.length - 1]) !== null && ui !== void 0 ? ui : 0;
    return [Math.min(ai, li), Math.max(oi, si)];
  }
  return yt;
}, selectAxisDomainIncludingNiceTicks = createSelector([selectBaseAxis, selectAxisDomain, selectNiceTicks, pickAxisType], combineAxisDomainWithNiceTicks), selectSmallestDistanceBetweenValues = createSelector(selectAllAppliedValues, selectBaseAxis, (pt, yt) => {
  if (!(!yt || yt.type !== "number")) {
    var ir = 1 / 0, ti = Array.from(onlyAllowNumbers(pt.map((fi) => fi.value))).sort((fi, gi) => fi - gi), ii = ti[0], ui = ti[ti.length - 1];
    if (ii == null || ui == null)
      return 1 / 0;
    var ai = ui - ii;
    if (ai === 0)
      return 1 / 0;
    for (var li = 0; li < ti.length - 1; li++) {
      var oi = ti[li], si = ti[li + 1];
      if (!(oi == null || si == null)) {
        var di = si - oi;
        ir = Math.min(ir, di);
      }
    }
    return ir / ai;
  }
}), selectCalculatedPadding = createSelector(selectSmallestDistanceBetweenValues, selectChartLayout, selectBarCategoryGap, selectChartOffsetInternal, (pt, yt, ir, ti, ii) => ii, (pt, yt, ir, ti, ii) => {
  if (!isWellBehavedNumber(pt))
    return 0;
  var ui = yt === "vertical" ? ti.height : ti.width;
  if (ii === "gap")
    return pt * ui / 2;
  if (ii === "no-gap") {
    var ai = getPercentValue(ir, pt * ui), li = pt * ui / 2;
    return li - ai - (li - ai) / ui * ai;
  }
  return 0;
}), selectCalculatedXAxisPadding = (pt, yt, ir) => {
  var ti = selectXAxisSettings(pt, yt);
  return ti == null || typeof ti.padding != "string" ? 0 : selectCalculatedPadding(pt, "xAxis", yt, ir, ti.padding);
}, selectCalculatedYAxisPadding = (pt, yt, ir) => {
  var ti = selectYAxisSettings(pt, yt);
  return ti == null || typeof ti.padding != "string" ? 0 : selectCalculatedPadding(pt, "yAxis", yt, ir, ti.padding);
}, selectXAxisPadding = createSelector(selectXAxisSettings, selectCalculatedXAxisPadding, (pt, yt) => {
  var ir, ti;
  if (pt == null)
    return {
      left: 0,
      right: 0
    };
  var {
    padding: ii
  } = pt;
  return typeof ii == "string" ? {
    left: yt,
    right: yt
  } : {
    left: ((ir = ii.left) !== null && ir !== void 0 ? ir : 0) + yt,
    right: ((ti = ii.right) !== null && ti !== void 0 ? ti : 0) + yt
  };
}), selectYAxisPadding = createSelector(selectYAxisSettings, selectCalculatedYAxisPadding, (pt, yt) => {
  var ir, ti;
  if (pt == null)
    return {
      top: 0,
      bottom: 0
    };
  var {
    padding: ii
  } = pt;
  return typeof ii == "string" ? {
    top: yt,
    bottom: yt
  } : {
    top: ((ir = ii.top) !== null && ir !== void 0 ? ir : 0) + yt,
    bottom: ((ti = ii.bottom) !== null && ti !== void 0 ? ti : 0) + yt
  };
}), selectXAxisRange = createSelector([selectChartOffsetInternal, selectXAxisPadding, selectBrushDimensions, selectBrushSettings, (pt, yt, ir) => ir], (pt, yt, ir, ti, ii) => {
  var {
    padding: ui
  } = ti;
  return ii ? [ui.left, ir.width - ui.right] : [pt.left + yt.left, pt.left + pt.width - yt.right];
}), selectYAxisRange = createSelector([selectChartOffsetInternal, selectChartLayout, selectYAxisPadding, selectBrushDimensions, selectBrushSettings, (pt, yt, ir) => ir], (pt, yt, ir, ti, ii, ui) => {
  var {
    padding: ai
  } = ii;
  return ui ? [ti.height - ai.bottom, ai.top] : yt === "horizontal" ? [pt.top + pt.height - ir.bottom, pt.top + ir.top] : [pt.top + ir.top, pt.top + pt.height - ir.bottom];
}), selectAxisRange = (pt, yt, ir, ti) => {
  var ii;
  switch (yt) {
    case "xAxis":
      return selectXAxisRange(pt, ir, ti);
    case "yAxis":
      return selectYAxisRange(pt, ir, ti);
    case "zAxis":
      return (ii = selectZAxisSettings(pt, ir)) === null || ii === void 0 ? void 0 : ii.range;
    case "angleAxis":
      return selectAngleAxisRange(pt);
    case "radiusAxis":
      return selectRadiusAxisRange(pt, ir);
    default:
      return;
  }
}, selectAxisRangeWithReverse = createSelector([selectBaseAxis, selectAxisRange], combineAxisRangeWithReverse), selectCheckedAxisDomain = createSelector([selectRealScaleType, selectAxisDomainIncludingNiceTicks], combineCheckedDomain), selectConfiguredScale = createSelector([selectBaseAxis, selectRealScaleType, selectCheckedAxisDomain, selectAxisRangeWithReverse], combineConfiguredScale), combineCategoricalDomain = (pt, yt, ir, ti) => {
  if (!(ir == null || ir.dataKey == null)) {
    var {
      type: ii,
      scale: ui
    } = ir, ai = isCategoricalAxis(pt, ti);
    if (ai && (ii === "number" || ui !== "auto"))
      return yt.map((li) => li.value);
  }
}, selectCategoricalDomain = createSelector([selectChartLayout, selectAllAppliedValues, selectRenderableAxisSettings, pickAxisType], combineCategoricalDomain), selectAxisScale = createSelector([selectConfiguredScale], rechartsScaleFactory);
createSelector([selectConfiguredScale], combineInverseScaleFunction);
createSelector([selectConfiguredScale, selectSortedDataPoints], createCategoricalInverse);
createSelector([selectCartesianItemsSettings, selectAllErrorBarSettings, pickAxisType], combineRelevantErrorBarSettings);
function compareIds(pt, yt) {
  return pt.id < yt.id ? -1 : pt.id > yt.id ? 1 : 0;
}
var pickAxisOrientation = (pt, yt) => yt, pickMirror = (pt, yt, ir) => ir, selectAllXAxesWithOffsetType = createSelector(selectAllXAxes, pickAxisOrientation, pickMirror, (pt, yt, ir) => pt.filter((ti) => ti.orientation === yt).filter((ti) => ti.mirror === ir).sort(compareIds)), selectAllYAxesWithOffsetType = createSelector(selectAllYAxes, pickAxisOrientation, pickMirror, (pt, yt, ir) => pt.filter((ti) => ti.orientation === yt).filter((ti) => ti.mirror === ir).sort(compareIds)), getXAxisSize = (pt, yt) => ({
  width: pt.width,
  height: yt.height
}), getYAxisSize = (pt, yt) => {
  var ir = typeof yt.width == "number" ? yt.width : DEFAULT_Y_AXIS_WIDTH;
  return {
    width: ir,
    height: pt.height
  };
}, selectXAxisSize = createSelector(selectChartOffsetInternal, selectXAxisSettings, getXAxisSize), combineXAxisPositionStartingPoint = (pt, yt, ir) => {
  switch (yt) {
    case "top":
      return pt.top;
    case "bottom":
      return ir - pt.bottom;
    default:
      return 0;
  }
}, combineYAxisPositionStartingPoint = (pt, yt, ir) => {
  switch (yt) {
    case "left":
      return pt.left;
    case "right":
      return ir - pt.right;
    default:
      return 0;
  }
}, selectAllXAxesOffsetSteps = createSelector(selectChartHeight, selectChartOffsetInternal, selectAllXAxesWithOffsetType, pickAxisOrientation, pickMirror, (pt, yt, ir, ti, ii) => {
  var ui = {}, ai;
  return ir.forEach((li) => {
    var oi = getXAxisSize(yt, li);
    ai == null && (ai = combineXAxisPositionStartingPoint(yt, ti, pt));
    var si = ti === "top" && !ii || ti === "bottom" && ii;
    ui[li.id] = ai - Number(si) * oi.height, ai += (si ? -1 : 1) * oi.height;
  }), ui;
}), selectAllYAxesOffsetSteps = createSelector(selectChartWidth, selectChartOffsetInternal, selectAllYAxesWithOffsetType, pickAxisOrientation, pickMirror, (pt, yt, ir, ti, ii) => {
  var ui = {}, ai;
  return ir.forEach((li) => {
    var oi = getYAxisSize(yt, li);
    ai == null && (ai = combineYAxisPositionStartingPoint(yt, ti, pt));
    var si = ti === "left" && !ii || ti === "right" && ii;
    ui[li.id] = ai - Number(si) * oi.width, ai += (si ? -1 : 1) * oi.width;
  }), ui;
}), selectXAxisOffsetSteps = (pt, yt) => {
  var ir = selectXAxisSettings(pt, yt);
  if (ir != null)
    return selectAllXAxesOffsetSteps(pt, ir.orientation, ir.mirror);
}, selectXAxisPosition = createSelector([selectChartOffsetInternal, selectXAxisSettings, selectXAxisOffsetSteps, (pt, yt) => yt], (pt, yt, ir, ti) => {
  if (yt != null) {
    var ii = ir == null ? void 0 : ir[ti];
    return ii == null ? {
      x: pt.left,
      y: 0
    } : {
      x: pt.left,
      y: ii
    };
  }
}), selectYAxisOffsetSteps = (pt, yt) => {
  var ir = selectYAxisSettings(pt, yt);
  if (ir != null)
    return selectAllYAxesOffsetSteps(pt, ir.orientation, ir.mirror);
}, selectYAxisPosition = createSelector([selectChartOffsetInternal, selectYAxisSettings, selectYAxisOffsetSteps, (pt, yt) => yt], (pt, yt, ir, ti) => {
  if (yt != null) {
    var ii = ir == null ? void 0 : ir[ti];
    return ii == null ? {
      x: 0,
      y: pt.top
    } : {
      x: ii,
      y: pt.top
    };
  }
}), selectYAxisSize = createSelector(selectChartOffsetInternal, selectYAxisSettings, (pt, yt) => {
  var ir = typeof yt.width == "number" ? yt.width : DEFAULT_Y_AXIS_WIDTH;
  return {
    width: ir,
    height: pt.height
  };
}), selectCartesianAxisSize = (pt, yt, ir) => {
  switch (yt) {
    case "xAxis":
      return selectXAxisSize(pt, ir).width;
    case "yAxis":
      return selectYAxisSize(pt, ir).height;
    default:
      return;
  }
}, combineDuplicateDomain = (pt, yt, ir, ti) => {
  if (ir != null) {
    var {
      allowDuplicatedCategory: ii,
      type: ui,
      dataKey: ai
    } = ir, li = isCategoricalAxis(pt, ti), oi = yt.map((di) => di.value), si = oi.filter((di) => di != null);
    if (ai && li && ui === "category" && ii && hasDuplicate(si))
      return oi;
  }
}, selectDuplicateDomain = createSelector([selectChartLayout, selectAllAppliedValues, selectBaseAxis, pickAxisType], combineDuplicateDomain);
createSelector([selectChartLayout, selectCartesianAxisSettings, selectRealScaleType, selectAxisScale, selectDuplicateDomain, selectCategoricalDomain, selectAxisRange, selectNiceTicks, pickAxisType], (pt, yt, ir, ti, ii, ui, ai, li, oi) => {
  if (yt != null) {
    var si = isCategoricalAxis(pt, oi);
    return {
      angle: yt.angle,
      interval: yt.interval,
      minTickGap: yt.minTickGap,
      orientation: yt.orientation,
      tick: yt.tick,
      tickCount: yt.tickCount,
      tickFormatter: yt.tickFormatter,
      ticks: yt.ticks,
      type: yt.type,
      unit: yt.unit,
      axisType: oi,
      categoricalDomain: ui,
      duplicateDomain: ii,
      isCategorical: si,
      niceTicks: li,
      range: ai,
      realScaleType: ir,
      scale: ti
    };
  }
});
var combineAxisTicks = (pt, yt, ir, ti, ii, ui, ai, li, oi) => {
  if (!(yt == null || ti == null)) {
    var si = isCategoricalAxis(pt, oi), {
      type: di,
      ticks: fi,
      tickCount: gi
    } = yt, mi = (
      // @ts-expect-error This is testing for `scaleBand` but for band axis the type is reported as `band` so this looks like a dead code with a workaround elsewhere?
      ir === "scaleBand" && typeof ti.bandwidth == "function" ? ti.bandwidth() / 2 : 2
    ), Ti = di === "category" && ti.bandwidth ? ti.bandwidth() / mi : 0;
    Ti = oi === "angleAxis" && ui != null && ui.length >= 2 ? mathSign(ui[0] - ui[1]) * 2 * Ti : Ti;
    var vi = fi || ii;
    return vi ? vi.map((xi, Si) => {
      var Pi = ai ? ai.indexOf(xi) : xi, $i = ti.map(Pi);
      return isWellBehavedNumber($i) ? {
        index: Si,
        coordinate: $i + Ti,
        value: xi,
        offset: Ti
      } : null;
    }).filter(isNotNil) : si && li ? li.map((xi, Si) => {
      var Pi = ti.map(xi);
      return isWellBehavedNumber(Pi) ? {
        coordinate: Pi + Ti,
        value: xi,
        index: Si,
        offset: Ti
      } : null;
    }).filter(isNotNil) : ti.ticks ? ti.ticks(gi).map((xi, Si) => {
      var Pi = ti.map(xi);
      return isWellBehavedNumber(Pi) ? {
        coordinate: Pi + Ti,
        value: xi,
        index: Si,
        offset: Ti
      } : null;
    }).filter(isNotNil) : ti.domain().map((xi, Si) => {
      var Pi = ti.map(xi);
      return isWellBehavedNumber(Pi) ? {
        coordinate: Pi + Ti,
        // @ts-expect-error can't use Date as index
        value: ai ? ai[xi] : xi,
        index: Si,
        offset: Ti
      } : null;
    }).filter(isNotNil);
  }
}, selectTicksOfAxis = createSelector([selectChartLayout, selectRenderableAxisSettings, selectRealScaleType, selectAxisScale, selectNiceTicks, selectAxisRange, selectDuplicateDomain, selectCategoricalDomain, pickAxisType], combineAxisTicks), combineGraphicalItemTicks = (pt, yt, ir, ti, ii, ui, ai) => {
  if (!(yt == null || ir == null || ti == null || ti[0] === ti[1])) {
    var li = isCategoricalAxis(pt, ai), {
      tickCount: oi
    } = yt, si = 0;
    return si = ai === "angleAxis" && (ti == null ? void 0 : ti.length) >= 2 ? mathSign(ti[0] - ti[1]) * 2 * si : si, li && ui ? ui.map((di, fi) => {
      var gi = ir.map(di);
      return isWellBehavedNumber(gi) ? {
        coordinate: gi + si,
        value: di,
        index: fi,
        offset: si
      } : null;
    }).filter(isNotNil) : ir.ticks ? ir.ticks(oi).map((di, fi) => {
      var gi = ir.map(di);
      return isWellBehavedNumber(gi) ? {
        coordinate: gi + si,
        value: di,
        index: fi,
        offset: si
      } : null;
    }).filter(isNotNil) : ir.domain().map((di, fi) => {
      var gi = ir.map(di);
      return isWellBehavedNumber(gi) ? {
        coordinate: gi + si,
        // @ts-expect-error can't use unknown as index
        value: ii ? ii[di] : di,
        index: fi,
        offset: si
      } : null;
    }).filter(isNotNil);
  }
}, selectTicksOfGraphicalItem = createSelector([selectChartLayout, selectRenderableAxisSettings, selectAxisScale, selectAxisRange, selectDuplicateDomain, selectCategoricalDomain, pickAxisType], combineGraphicalItemTicks), selectAxisWithScale = createSelector(selectBaseAxis, selectAxisScale, (pt, yt) => {
  if (!(pt == null || yt == null))
    return _objectSpread$n(_objectSpread$n({}, pt), {}, {
      scale: yt
    });
}), selectZAxisConfiguredScale = createSelector([selectBaseAxis, selectRealScaleType, selectAxisDomain, selectAxisRangeWithReverse], combineConfiguredScale), selectZAxisScale = createSelector([selectZAxisConfiguredScale], rechartsScaleFactory);
createSelector((pt, yt, ir) => selectZAxisSettings(pt, ir), selectZAxisScale, (pt, yt) => {
  if (!(pt == null || yt == null))
    return _objectSpread$n(_objectSpread$n({}, pt), {}, {
      scale: yt
    });
});
var selectChartDirection = createSelector([selectChartLayout, selectAllXAxes, selectAllYAxes], (pt, yt, ir) => {
  switch (pt) {
    case "horizontal":
      return yt.some((ti) => ti.reversed) ? "right-to-left" : "left-to-right";
    case "vertical":
      return ir.some((ti) => ti.reversed) ? "bottom-to-top" : "top-to-bottom";
    // TODO: make this better. For now, right arrow triggers "forward", left arrow "back"
    // however, the tooltip moves an unintuitive direction because of how the indices are rendered
    case "centric":
    case "radial":
      return "left-to-right";
    default:
      return;
  }
}), selectRenderedTicksOfAxis = (pt, yt, ir) => {
  var ti;
  return (ti = pt.renderedTicks[yt]) === null || ti === void 0 ? void 0 : ti[ir];
};
createSelector([selectRenderedTicksOfAxis], (pt) => {
  if (!(!pt || pt.length === 0))
    return (yt) => {
      var ir, ti = 1 / 0, ii = pt[0];
      for (var ui of pt) {
        var ai = Math.abs(ui.coordinate - yt);
        ai < ti && (ti = ai, ii = ui);
      }
      return (ir = ii) === null || ir === void 0 ? void 0 : ir.value;
    };
});
var selectDefaultTooltipEventType = (pt) => pt.options.defaultTooltipEventType, selectValidateTooltipEventTypes = (pt) => pt.options.validateTooltipEventTypes;
function combineTooltipEventType(pt, yt, ir) {
  if (pt == null)
    return yt;
  var ti = pt ? "axis" : "item";
  return ir == null ? yt : ir.includes(ti) ? ti : yt;
}
function selectTooltipEventType$1(pt, yt) {
  var ir = selectDefaultTooltipEventType(pt), ti = selectValidateTooltipEventTypes(pt);
  return combineTooltipEventType(yt, ir, ti);
}
var combineActiveLabel = (pt, yt) => {
  var ir, ti = Number(yt);
  if (!(isNan(ti) || yt == null))
    return ti >= 0 ? pt == null || (ir = pt[ti]) === null || ir === void 0 ? void 0 : ir.value : void 0;
}, selectTooltipSettings = (pt) => pt.tooltip.settings, noInteraction = {
  active: !1,
  index: null,
  dataKey: void 0,
  graphicalItemId: void 0,
  coordinate: void 0
}, initialState$b = {
  itemInteraction: {
    click: noInteraction,
    hover: noInteraction
  },
  axisInteraction: {
    click: noInteraction,
    hover: noInteraction
  },
  keyboardInteraction: noInteraction,
  syncInteraction: {
    active: !1,
    index: null,
    dataKey: void 0,
    label: void 0,
    coordinate: void 0,
    sourceViewBox: void 0,
    graphicalItemId: void 0
  },
  tooltipItemPayloads: [],
  settings: {
    shared: void 0,
    trigger: "hover",
    axisId: 0,
    active: !1,
    defaultIndex: void 0
  }
}, tooltipSlice = createSlice({
  name: "tooltip",
  initialState: initialState$b,
  reducers: {
    addTooltipEntrySettings: {
      reducer(pt, yt) {
        pt.tooltipItemPayloads.push(yt.payload);
      },
      prepare: prepareAutoBatched()
    },
    replaceTooltipEntrySettings: {
      reducer(pt, yt) {
        var {
          prev: ir,
          next: ti
        } = yt.payload, ii = current$1(pt).tooltipItemPayloads.indexOf(ir);
        ii > -1 && (pt.tooltipItemPayloads[ii] = ti);
      },
      prepare: prepareAutoBatched()
    },
    removeTooltipEntrySettings: {
      reducer(pt, yt) {
        var ir = current$1(pt).tooltipItemPayloads.indexOf(yt.payload);
        ir > -1 && pt.tooltipItemPayloads.splice(ir, 1);
      },
      prepare: prepareAutoBatched()
    },
    setTooltipSettingsState(pt, yt) {
      pt.settings = yt.payload;
    },
    setActiveMouseOverItemIndex(pt, yt) {
      pt.syncInteraction.active = !1, pt.syncInteraction.sourceViewBox = void 0, pt.keyboardInteraction.active = !1, pt.itemInteraction.hover.active = !0, pt.itemInteraction.hover.index = yt.payload.activeIndex, pt.itemInteraction.hover.dataKey = yt.payload.activeDataKey, pt.itemInteraction.hover.graphicalItemId = yt.payload.activeGraphicalItemId, pt.itemInteraction.hover.coordinate = yt.payload.activeCoordinate;
    },
    mouseLeaveChart(pt) {
      pt.itemInteraction.hover.active = !1, pt.axisInteraction.hover.active = !1;
    },
    mouseLeaveItem(pt) {
      pt.itemInteraction.hover.active = !1;
    },
    setActiveClickItemIndex(pt, yt) {
      pt.syncInteraction.active = !1, pt.syncInteraction.sourceViewBox = void 0, pt.itemInteraction.click.active = !0, pt.keyboardInteraction.active = !1, pt.itemInteraction.click.index = yt.payload.activeIndex, pt.itemInteraction.click.dataKey = yt.payload.activeDataKey, pt.itemInteraction.click.graphicalItemId = yt.payload.activeGraphicalItemId, pt.itemInteraction.click.coordinate = yt.payload.activeCoordinate;
    },
    setMouseOverAxisIndex(pt, yt) {
      pt.syncInteraction.active = !1, pt.syncInteraction.sourceViewBox = void 0, pt.axisInteraction.hover.active = !0, pt.keyboardInteraction.active = !1, pt.axisInteraction.hover.index = yt.payload.activeIndex, pt.axisInteraction.hover.dataKey = yt.payload.activeDataKey, pt.axisInteraction.hover.coordinate = yt.payload.activeCoordinate;
    },
    setMouseClickAxisIndex(pt, yt) {
      pt.syncInteraction.active = !1, pt.syncInteraction.sourceViewBox = void 0, pt.keyboardInteraction.active = !1, pt.axisInteraction.click.active = !0, pt.axisInteraction.click.index = yt.payload.activeIndex, pt.axisInteraction.click.dataKey = yt.payload.activeDataKey, pt.axisInteraction.click.coordinate = yt.payload.activeCoordinate;
    },
    setSyncInteraction(pt, yt) {
      pt.syncInteraction = yt.payload;
    },
    setKeyboardInteraction(pt, yt) {
      pt.keyboardInteraction.active = yt.payload.active, pt.keyboardInteraction.index = yt.payload.activeIndex, pt.keyboardInteraction.coordinate = yt.payload.activeCoordinate;
    }
  }
}), {
  addTooltipEntrySettings,
  replaceTooltipEntrySettings,
  removeTooltipEntrySettings,
  setTooltipSettingsState,
  setActiveMouseOverItemIndex,
  mouseLeaveItem,
  mouseLeaveChart,
  setActiveClickItemIndex,
  setMouseOverAxisIndex,
  setMouseClickAxisIndex,
  setSyncInteraction,
  setKeyboardInteraction
} = tooltipSlice.actions, tooltipReducer = tooltipSlice.reducer;
function ownKeys$m(pt, yt) {
  var ir = Object.keys(pt);
  if (Object.getOwnPropertySymbols) {
    var ti = Object.getOwnPropertySymbols(pt);
    yt && (ti = ti.filter(function(ii) {
      return Object.getOwnPropertyDescriptor(pt, ii).enumerable;
    })), ir.push.apply(ir, ti);
  }
  return ir;
}
function _objectSpread$m(pt) {
  for (var yt = 1; yt < arguments.length; yt++) {
    var ir = arguments[yt] != null ? arguments[yt] : {};
    yt % 2 ? ownKeys$m(Object(ir), !0).forEach(function(ti) {
      _defineProperty$o(pt, ti, ir[ti]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(pt, Object.getOwnPropertyDescriptors(ir)) : ownKeys$m(Object(ir)).forEach(function(ti) {
      Object.defineProperty(pt, ti, Object.getOwnPropertyDescriptor(ir, ti));
    });
  }
  return pt;
}
function _defineProperty$o(pt, yt, ir) {
  return (yt = _toPropertyKey$o(yt)) in pt ? Object.defineProperty(pt, yt, { value: ir, enumerable: !0, configurable: !0, writable: !0 }) : pt[yt] = ir, pt;
}
function _toPropertyKey$o(pt) {
  var yt = _toPrimitive$o(pt, "string");
  return typeof yt == "symbol" ? yt : yt + "";
}
function _toPrimitive$o(pt, yt) {
  if (typeof pt != "object" || !pt) return pt;
  var ir = pt[Symbol.toPrimitive];
  if (ir !== void 0) {
    var ti = ir.call(pt, yt);
    if (typeof ti != "object") return ti;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (yt === "string" ? String : Number)(pt);
}
function chooseAppropriateMouseInteraction(pt, yt, ir) {
  return yt === "axis" ? ir === "click" ? pt.axisInteraction.click : pt.axisInteraction.hover : ir === "click" ? pt.itemInteraction.click : pt.itemInteraction.hover;
}
function hasBeenActivePreviously(pt) {
  return pt.index != null;
}
var combineTooltipInteractionState = (pt, yt, ir, ti) => {
  if (yt == null)
    return noInteraction;
  var ii = chooseAppropriateMouseInteraction(pt, yt, ir);
  if (ii == null)
    return noInteraction;
  if (ii.active)
    return ii;
  if (pt.keyboardInteraction.active)
    return pt.keyboardInteraction;
  if (pt.syncInteraction.active && pt.syncInteraction.index != null)
    return pt.syncInteraction;
  var ui = pt.settings.active === !0;
  if (hasBeenActivePreviously(ii)) {
    if (ui)
      return _objectSpread$m(_objectSpread$m({}, ii), {}, {
        active: !0
      });
  } else if (ti != null)
    return {
      active: !0,
      coordinate: void 0,
      dataKey: void 0,
      index: ti,
      graphicalItemId: void 0
    };
  return _objectSpread$m(_objectSpread$m({}, noInteraction), {}, {
    coordinate: ii.coordinate
  });
};
function toFiniteNumber(pt) {
  if (typeof pt == "number")
    return Number.isFinite(pt) ? pt : void 0;
  if (pt instanceof Date) {
    var yt = pt.valueOf();
    return Number.isFinite(yt) ? yt : void 0;
  }
  var ir = Number(pt);
  return Number.isFinite(ir) ? ir : void 0;
}
function isValueWithinNumberDomain(pt, yt) {
  var ir = toFiniteNumber(pt), ti = yt[0], ii = yt[1];
  if (ir === void 0)
    return !1;
  var ui = Math.min(ti, ii), ai = Math.max(ti, ii);
  return ir >= ui && ir <= ai;
}
function isValueWithinDomain(pt, yt, ir) {
  if (ir == null || yt == null)
    return !0;
  var ti = getValueByDataKey(pt, yt);
  return ti == null || !isWellFormedNumberDomain(ir) ? !0 : isValueWithinNumberDomain(ti, ir);
}
var combineActiveTooltipIndex = (pt, yt, ir, ti) => {
  var ii = pt == null ? void 0 : pt.index;
  if (ii == null)
    return null;
  var ui = Number(ii);
  if (!isWellBehavedNumber(ui))
    return ii;
  var ai = 0, li = 1 / 0;
  yt.length > 0 && (li = yt.length - 1);
  var oi = Math.max(ai, Math.min(ui, li)), si = yt[oi];
  return si == null || isValueWithinDomain(si, ir, ti) ? String(oi) : null;
}, combineCoordinateForDefaultIndex = (pt, yt, ir, ti, ii, ui, ai) => {
  if (ui != null) {
    var li = ai[0], oi = li == null ? void 0 : li.getPosition(ui);
    if (oi != null)
      return oi;
    var si = ii == null ? void 0 : ii[Number(ui)];
    if (si)
      switch (ir) {
        case "horizontal":
          return {
            x: si.coordinate,
            y: (ti.top + yt) / 2
          };
        default:
          return {
            x: (ti.left + pt) / 2,
            y: si.coordinate
          };
      }
  }
}, combineTooltipPayloadConfigurations = (pt, yt, ir, ti) => {
  if (yt === "axis")
    return pt.tooltipItemPayloads;
  if (pt.tooltipItemPayloads.length === 0)
    return [];
  var ii;
  if (ir === "hover" ? ii = pt.itemInteraction.hover.graphicalItemId : ii = pt.itemInteraction.click.graphicalItemId, pt.syncInteraction.active && ii == null)
    return pt.tooltipItemPayloads;
  if (ii == null && (ti != null || pt.keyboardInteraction.active)) {
    var ui = pt.tooltipItemPayloads[0];
    return ui != null ? [ui] : [];
  }
  return pt.tooltipItemPayloads.filter((ai) => {
    var li;
    return ((li = ai.settings) === null || li === void 0 ? void 0 : li.graphicalItemId) === ii;
  });
}, selectTooltipPayloadSearcher = (pt) => pt.options.tooltipPayloadSearcher, selectTooltipState = (pt) => pt.tooltip;
function ownKeys$l(pt, yt) {
  var ir = Object.keys(pt);
  if (Object.getOwnPropertySymbols) {
    var ti = Object.getOwnPropertySymbols(pt);
    yt && (ti = ti.filter(function(ii) {
      return Object.getOwnPropertyDescriptor(pt, ii).enumerable;
    })), ir.push.apply(ir, ti);
  }
  return ir;
}
function _objectSpread$l(pt) {
  for (var yt = 1; yt < arguments.length; yt++) {
    var ir = arguments[yt] != null ? arguments[yt] : {};
    yt % 2 ? ownKeys$l(Object(ir), !0).forEach(function(ti) {
      _defineProperty$n(pt, ti, ir[ti]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(pt, Object.getOwnPropertyDescriptors(ir)) : ownKeys$l(Object(ir)).forEach(function(ti) {
      Object.defineProperty(pt, ti, Object.getOwnPropertyDescriptor(ir, ti));
    });
  }
  return pt;
}
function _defineProperty$n(pt, yt, ir) {
  return (yt = _toPropertyKey$n(yt)) in pt ? Object.defineProperty(pt, yt, { value: ir, enumerable: !0, configurable: !0, writable: !0 }) : pt[yt] = ir, pt;
}
function _toPropertyKey$n(pt) {
  var yt = _toPrimitive$n(pt, "string");
  return typeof yt == "symbol" ? yt : yt + "";
}
function _toPrimitive$n(pt, yt) {
  if (typeof pt != "object" || !pt) return pt;
  var ir = pt[Symbol.toPrimitive];
  if (ir !== void 0) {
    var ti = ir.call(pt, yt);
    if (typeof ti != "object") return ti;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (yt === "string" ? String : Number)(pt);
}
function parseName(pt) {
  if (typeof pt == "string" || typeof pt == "number")
    return pt;
}
function parseUnit(pt) {
  if (typeof pt == "string" || typeof pt == "number" || typeof pt == "boolean")
    return pt;
}
function parseDataKey(pt) {
  if (typeof pt == "string" || typeof pt == "number")
    return pt;
  if (typeof pt == "function")
    return (yt) => pt(yt);
}
function parseColor(pt) {
  if (typeof pt == "string")
    return pt;
}
function parseTooltipPayloadItem(pt) {
  if (!(pt == null || typeof pt != "object")) {
    var yt = "name" in pt ? parseName(pt.name) : void 0, ir = "unit" in pt ? parseUnit(pt.unit) : void 0, ti = "dataKey" in pt ? parseDataKey(pt.dataKey) : void 0, ii = "payload" in pt ? pt.payload : void 0, ui = "color" in pt ? parseColor(pt.color) : void 0, ai = "fill" in pt ? parseColor(pt.fill) : void 0;
    return {
      name: yt,
      unit: ir,
      dataKey: ti,
      payload: ii,
      color: ui,
      fill: ai
    };
  }
}
function selectFinalData(pt, yt) {
  return pt ?? yt;
}
var combineTooltipPayload = (pt, yt, ir, ti, ii, ui, ai) => {
  if (!(yt == null || ui == null)) {
    var {
      chartData: li,
      computedData: oi,
      dataStartIndex: si,
      dataEndIndex: di
    } = ir, fi = [];
    return pt.reduce((gi, mi) => {
      var Ti, {
        dataDefinedOnItem: vi,
        settings: xi
      } = mi, Si = selectFinalData(vi, li), Pi = Array.isArray(Si) ? getSliced(Si, si, di) : Si, $i = (Ti = xi == null ? void 0 : xi.dataKey) !== null && Ti !== void 0 ? Ti : ti, Oi = xi == null ? void 0 : xi.nameKey, Di;
      if (ti && Array.isArray(Pi) && /*
      * findEntryInArray won't work for Scatter because Scatter provides an array of arrays
      * as tooltip payloads and findEntryInArray is not prepared to handle that.
      * Sad but also ScatterChart only allows 'item' tooltipEventType
      * and also this is only a problem if there are multiple Scatters and each has its own data array
      * so let's fix that some other time.
      */
      !Array.isArray(Pi[0]) && /*
      * If the tooltipEventType is 'axis', we should search for the dataKey in the sliced data
      * because thanks to allowDuplicatedCategory=false, the order of elements in the array
      * no longer matches the order of elements in the original data
      * and so we need to search by the active dataKey + label rather than by index.
      *
      * The same happens if multiple graphical items are present in the chart
      * and each of them has its own data array. Those arrays get concatenated
      * and again the tooltip index no longer matches the original data.
      *
      * On the other hand the tooltipEventType 'item' should always search by index
      * because we get the index from interacting over the individual elements
      * which is always accurate, irrespective of the allowDuplicatedCategory setting.
      */
      ai === "axis" ? Di = findEntryInArray(Pi, ti, ii) : Di = ui(Pi, yt, oi, Oi), Array.isArray(Di))
        Di.forEach((Oo) => {
          var io, xo, fo = parseTooltipPayloadItem(Oo), _o = fo == null ? void 0 : fo.name, Li = fo == null ? void 0 : fo.dataKey, Co = fo == null ? void 0 : fo.payload, Ni = _objectSpread$l(_objectSpread$l({}, xi), {}, {
            name: _o,
            unit: fo == null ? void 0 : fo.unit,
            // Preserve item-level color/fill from graphical items.
            color: (io = fo == null ? void 0 : fo.color) !== null && io !== void 0 ? io : xi == null ? void 0 : xi.color,
            fill: (xo = fo == null ? void 0 : fo.fill) !== null && xo !== void 0 ? xo : xi == null ? void 0 : xi.fill
          });
          gi.push(getTooltipEntry({
            tooltipEntrySettings: Ni,
            dataKey: Li,
            payload: Co,
            value: getValueByDataKey(Co, Li),
            name: _o == null ? void 0 : String(_o)
          }));
        });
      else {
        var Mi;
        gi.push(getTooltipEntry({
          tooltipEntrySettings: xi,
          dataKey: $i,
          payload: Di,
          // getValueByDataKey does not validate the output type
          value: getValueByDataKey(Di, $i),
          // getValueByDataKey does not validate the output type
          name: (Mi = getValueByDataKey(Di, Oi)) !== null && Mi !== void 0 ? Mi : xi == null ? void 0 : xi.name
        }));
      }
      return gi;
    }, fi);
  }
}, selectTooltipAxisRealScaleType = createSelector([selectTooltipAxis, selectHasBar, selectChartName], combineRealScaleType), selectAllUnfilteredGraphicalItems = createSelector([(pt) => pt.graphicalItems.cartesianItems, (pt) => pt.graphicalItems.polarItems], (pt, yt) => [...pt, ...yt]), selectTooltipAxisPredicate = createSelector([selectTooltipAxisType, selectTooltipAxisId], itemAxisPredicate), selectAllGraphicalItemsSettings = createSelector([selectAllUnfilteredGraphicalItems, selectTooltipAxis, selectTooltipAxisPredicate], combineGraphicalItemsSettings, {
  memoizeOptions: {
    resultEqualityCheck: emptyArraysAreEqualCheck
  }
}), selectAllStackedGraphicalItemsSettings = createSelector([selectAllGraphicalItemsSettings], (pt) => pt.filter(isStacked)), selectTooltipGraphicalItemsData = createSelector([selectAllGraphicalItemsSettings], combineGraphicalItemsData, {
  memoizeOptions: {
    resultEqualityCheck: emptyArraysAreEqualCheck
  }
}), selectAnyTooltipItemUsesChartData = createSelector([selectAllGraphicalItemsSettings], (pt) => pt.some((yt) => !yt.data)), selectTooltipDisplayedData = createSelector([selectTooltipGraphicalItemsData, selectChartDataWithIndexes], combineDisplayedData), selectTooltipStackedData = createSelector([selectAllStackedGraphicalItemsSettings, selectChartDataWithIndexes, selectTooltipAxis], combineDisplayedStackedData), selectAllTooltipAppliedValues = createSelector([selectTooltipDisplayedData, selectTooltipAxis, selectAllGraphicalItemsSettings, selectChartDataWithIndexes, selectAnyTooltipItemUsesChartData, selectTooltipGraphicalItemsData], combineAllAppliedValues), selectTooltipAxisDomainDefinition = createSelector([selectTooltipAxis], getDomainDefinition), selectTooltipDataOverflow = createSelector([selectTooltipAxis], (pt) => pt.allowDataOverflow), selectTooltipDomainFromUserPreferences = createSelector([selectTooltipAxisDomainDefinition, selectTooltipDataOverflow], numericalDomainSpecifiedWithoutRequiringData), selectAllStackedGraphicalItems = createSelector([selectAllGraphicalItemsSettings], (pt) => pt.filter(isStacked)), selectTooltipStackGroups = createSelector([selectTooltipStackedData, selectAllStackedGraphicalItems, selectStackOffsetType, selectReverseStackOrder], combineStackGroups), selectTooltipDomainOfStackGroups = createSelector([selectTooltipStackGroups, selectChartDataWithIndexes, selectTooltipAxisType, selectTooltipDomainFromUserPreferences], combineDomainOfStackGroups), selectTooltipItemsSettingsExceptStacked = createSelector([selectAllGraphicalItemsSettings], filterGraphicalNotStackedItems), selectDomainOfAllAppliedNumericalValuesIncludingErrorValues = createSelector([selectTooltipDisplayedData, selectTooltipAxis, selectTooltipItemsSettingsExceptStacked, selectAllErrorBarSettings, selectTooltipAxisType, selectChartDataSliceWithIndexes], combineDomainOfAllAppliedNumericalValuesIncludingErrorValues, {
  memoizeOptions: {
    resultEqualityCheck: numberDomainEqualityCheck
  }
}), selectReferenceDotsByTooltipAxis = createSelector([selectReferenceDots, selectTooltipAxisType, selectTooltipAxisId], filterReferenceElements), selectTooltipReferenceDotsDomain = createSelector([selectReferenceDotsByTooltipAxis, selectTooltipAxisType], combineDotsDomain), selectReferenceAreasByTooltipAxis = createSelector([selectReferenceAreas, selectTooltipAxisType, selectTooltipAxisId], filterReferenceElements), selectTooltipReferenceAreasDomain = createSelector([selectReferenceAreasByTooltipAxis, selectTooltipAxisType], combineAreasDomain), selectReferenceLinesByTooltipAxis = createSelector([selectReferenceLines, selectTooltipAxisType, selectTooltipAxisId], filterReferenceElements), selectTooltipReferenceLinesDomain = createSelector([selectReferenceLinesByTooltipAxis, selectTooltipAxisType], combineLinesDomain), selectTooltipReferenceElementsDomain = createSelector([selectTooltipReferenceDotsDomain, selectTooltipReferenceLinesDomain, selectTooltipReferenceAreasDomain], mergeDomains), selectTooltipNumericalDomain = createSelector([selectTooltipAxis, selectTooltipAxisDomainDefinition, selectTooltipDomainFromUserPreferences, selectTooltipDomainOfStackGroups, selectDomainOfAllAppliedNumericalValuesIncludingErrorValues, selectTooltipReferenceElementsDomain, selectChartLayout, selectTooltipAxisType], combineNumericalDomain), selectTooltipAxisDomain = createSelector([selectTooltipAxis, selectChartLayout, selectTooltipDisplayedData, selectAllTooltipAppliedValues, selectStackOffsetType, selectTooltipAxisType, selectTooltipNumericalDomain], combineAxisDomain), selectTooltipNiceTicks = createSelector([selectTooltipAxisDomain, selectTooltipAxis, selectTooltipAxisRealScaleType], combineNiceTicks), selectTooltipAxisDomainIncludingNiceTicks = createSelector([selectTooltipAxis, selectTooltipAxisDomain, selectTooltipNiceTicks, selectTooltipAxisType], combineAxisDomainWithNiceTicks), selectTooltipAxisRange = (pt) => {
  var yt = selectTooltipAxisType(pt), ir = selectTooltipAxisId(pt), ti = !1;
  return selectAxisRange(pt, yt, ir, ti);
}, selectTooltipAxisRangeWithReverse = createSelector([selectTooltipAxis, selectTooltipAxisRange], combineAxisRangeWithReverse), selectTooltipConfiguredScale = createSelector([selectTooltipAxis, selectTooltipAxisRealScaleType, selectTooltipAxisDomainIncludingNiceTicks, selectTooltipAxisRangeWithReverse], combineConfiguredScale), selectTooltipAxisScale = createSelector([selectTooltipConfiguredScale], rechartsScaleFactory), selectTooltipDuplicateDomain = createSelector([selectChartLayout, selectAllTooltipAppliedValues, selectTooltipAxis, selectTooltipAxisType], combineDuplicateDomain), selectTooltipCategoricalDomain = createSelector([selectChartLayout, selectAllTooltipAppliedValues, selectTooltipAxis, selectTooltipAxisType], combineCategoricalDomain), combineTicksOfTooltipAxis = (pt, yt, ir, ti, ii, ui, ai, li) => {
  if (yt) {
    var {
      type: oi
    } = yt, si = isCategoricalAxis(pt, li);
    if (ti) {
      var di = ir === "scaleBand" && ti.bandwidth ? ti.bandwidth() / 2 : 2, fi = oi === "category" && ti.bandwidth ? ti.bandwidth() / di : 0;
      return fi = li === "angleAxis" && ii != null && (ii == null ? void 0 : ii.length) >= 2 ? mathSign(ii[0] - ii[1]) * 2 * fi : fi, si && ai ? ai.map((gi, mi) => {
        var Ti = ti.map(gi);
        return isWellBehavedNumber(Ti) ? {
          coordinate: Ti + fi,
          value: gi,
          index: mi,
          offset: fi
        } : null;
      }).filter(isNotNil) : ti.domain().map((gi, mi) => {
        var Ti = ti.map(gi);
        return isWellBehavedNumber(Ti) ? {
          coordinate: Ti + fi,
          // @ts-expect-error can't use Date as an index
          value: ui ? ui[gi] : gi,
          index: mi,
          offset: fi
        } : null;
      }).filter(isNotNil);
    }
  }
}, selectTooltipAxisTicks = createSelector([selectChartLayout, selectTooltipAxis, selectTooltipAxisRealScaleType, selectTooltipAxisScale, selectTooltipAxisRange, selectTooltipDuplicateDomain, selectTooltipCategoricalDomain, selectTooltipAxisType], combineTicksOfTooltipAxis), selectTooltipEventType = createSelector([selectDefaultTooltipEventType, selectValidateTooltipEventTypes, selectTooltipSettings], (pt, yt, ir) => combineTooltipEventType(ir.shared, pt, yt)), selectTooltipTrigger = (pt) => pt.tooltip.settings.trigger, selectDefaultIndex = (pt) => pt.tooltip.settings.defaultIndex, selectTooltipInteractionState$1 = createSelector([selectTooltipState, selectTooltipEventType, selectTooltipTrigger, selectDefaultIndex], combineTooltipInteractionState), selectActiveTooltipIndex = createSelector([selectTooltipInteractionState$1, selectTooltipDisplayedData, selectTooltipAxisDataKey, selectTooltipAxisDomain], combineActiveTooltipIndex), selectActiveLabel$1 = createSelector([selectTooltipAxisTicks, selectActiveTooltipIndex], combineActiveLabel), selectActiveTooltipDataKey = createSelector([selectTooltipInteractionState$1], (pt) => {
  if (pt)
    return pt.dataKey;
});
createSelector([selectTooltipInteractionState$1], (pt) => {
  if (pt)
    return pt.graphicalItemId;
});
var selectTooltipPayloadConfigurations$1 = createSelector([selectTooltipState, selectTooltipEventType, selectTooltipTrigger, selectDefaultIndex], combineTooltipPayloadConfigurations), selectTooltipCoordinateForDefaultIndex = createSelector([selectChartWidth, selectChartHeight, selectChartLayout, selectChartOffsetInternal, selectTooltipAxisTicks, selectDefaultIndex, selectTooltipPayloadConfigurations$1], combineCoordinateForDefaultIndex), selectActiveTooltipCoordinate = createSelector([selectTooltipInteractionState$1, selectTooltipCoordinateForDefaultIndex], (pt, yt) => pt != null && pt.coordinate ? pt.coordinate : yt), selectIsTooltipActive$1 = createSelector([selectTooltipInteractionState$1], (pt) => {
  var yt;
  return (yt = pt == null ? void 0 : pt.active) !== null && yt !== void 0 ? yt : !1;
}), selectActiveTooltipPayload = createSelector([selectTooltipPayloadConfigurations$1, selectActiveTooltipIndex, selectChartDataWithIndexes, selectTooltipAxisDataKey, selectActiveLabel$1, selectTooltipPayloadSearcher, selectTooltipEventType], combineTooltipPayload);
createSelector([selectActiveTooltipPayload], (pt) => {
  if (pt != null) {
    var yt = pt.map((ir) => ir.payload).filter((ir) => ir != null);
    return Array.from(new Set(yt));
  }
});
function ownKeys$j(pt, yt) {
  var ir = Object.keys(pt);
  if (Object.getOwnPropertySymbols) {
    var ti = Object.getOwnPropertySymbols(pt);
    yt && (ti = ti.filter(function(ii) {
      return Object.getOwnPropertyDescriptor(pt, ii).enumerable;
    })), ir.push.apply(ir, ti);
  }
  return ir;
}
function _objectSpread$j(pt) {
  for (var yt = 1; yt < arguments.length; yt++) {
    var ir = arguments[yt] != null ? arguments[yt] : {};
    yt % 2 ? ownKeys$j(Object(ir), !0).forEach(function(ti) {
      _defineProperty$l(pt, ti, ir[ti]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(pt, Object.getOwnPropertyDescriptors(ir)) : ownKeys$j(Object(ir)).forEach(function(ti) {
      Object.defineProperty(pt, ti, Object.getOwnPropertyDescriptor(ir, ti));
    });
  }
  return pt;
}
function _defineProperty$l(pt, yt, ir) {
  return (yt = _toPropertyKey$l(yt)) in pt ? Object.defineProperty(pt, yt, { value: ir, enumerable: !0, configurable: !0, writable: !0 }) : pt[yt] = ir, pt;
}
function _toPropertyKey$l(pt) {
  var yt = _toPrimitive$l(pt, "string");
  return typeof yt == "symbol" ? yt : yt + "";
}
function _toPrimitive$l(pt, yt) {
  if (typeof pt != "object" || !pt) return pt;
  var ir = pt[Symbol.toPrimitive];
  if (ir !== void 0) {
    var ti = ir.call(pt, yt);
    if (typeof ti != "object") return ti;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (yt === "string" ? String : Number)(pt);
}
var getActiveCartesianCoordinate = (pt, yt, ir, ti) => {
  var ii = yt.find((ui) => ui && ui.index === ir);
  if (ii) {
    if (pt === "horizontal")
      return {
        x: ii.coordinate,
        y: ti.relativeY
      };
    if (pt === "vertical")
      return {
        x: ti.relativeX,
        y: ii.coordinate
      };
  }
  return {
    x: 0,
    y: 0
  };
}, getActivePolarCoordinate = (pt, yt, ir, ti) => {
  var ii = yt.find((si) => si && si.index === ir);
  if (ii) {
    if (pt === "centric") {
      var ui = ii.coordinate, {
        radius: ai
      } = ti;
      return _objectSpread$j(_objectSpread$j(_objectSpread$j({}, ti), polarToCartesian(ti.cx, ti.cy, ai, ui)), {}, {
        angle: ui,
        radius: ai
      });
    }
    var li = ii.coordinate, {
      angle: oi
    } = ti;
    return _objectSpread$j(_objectSpread$j(_objectSpread$j({}, ti), polarToCartesian(ti.cx, ti.cy, li, oi)), {}, {
      angle: oi,
      radius: li
    });
  }
  return {
    angle: 0,
    clockWise: !1,
    cx: 0,
    cy: 0,
    endAngle: 0,
    innerRadius: 0,
    outerRadius: 0,
    radius: 0,
    startAngle: 0,
    x: 0,
    y: 0
  };
};
function isInCartesianRange(pt, yt) {
  var {
    relativeX: ir,
    relativeY: ti
  } = pt;
  return ir >= yt.left && ir <= yt.left + yt.width && ti >= yt.top && ti <= yt.top + yt.height;
}
var calculateActiveTickIndex = (pt, yt, ir, ti, ii) => {
  var ui, ai = (ui = yt == null ? void 0 : yt.length) !== null && ui !== void 0 ? ui : 0;
  if (ai <= 1 || pt == null)
    return 0;
  if (ti === "angleAxis" && ii != null && Math.abs(Math.abs(ii[1] - ii[0]) - 360) <= 1e-6)
    for (var li = 0; li < ai; li++) {
      var oi, si, di, fi, gi, mi = li > 0 ? (oi = ir[li - 1]) === null || oi === void 0 ? void 0 : oi.coordinate : (si = ir[ai - 1]) === null || si === void 0 ? void 0 : si.coordinate, Ti = (di = ir[li]) === null || di === void 0 ? void 0 : di.coordinate, vi = li >= ai - 1 ? (fi = ir[0]) === null || fi === void 0 ? void 0 : fi.coordinate : (gi = ir[li + 1]) === null || gi === void 0 ? void 0 : gi.coordinate, xi = void 0;
      if (!(mi == null || Ti == null || vi == null))
        if (mathSign(Ti - mi) !== mathSign(vi - Ti)) {
          var Si = [];
          if (mathSign(vi - Ti) === mathSign(ii[1] - ii[0])) {
            xi = vi;
            var Pi = Ti + ii[1] - ii[0];
            Si[0] = Math.min(Pi, (Pi + mi) / 2), Si[1] = Math.max(Pi, (Pi + mi) / 2);
          } else {
            xi = mi;
            var $i = vi + ii[1] - ii[0];
            Si[0] = Math.min(Ti, ($i + Ti) / 2), Si[1] = Math.max(Ti, ($i + Ti) / 2);
          }
          var Oi = [Math.min(Ti, (xi + Ti) / 2), Math.max(Ti, (xi + Ti) / 2)];
          if (pt > Oi[0] && pt <= Oi[1] || pt >= Si[0] && pt <= Si[1]) {
            var Di;
            return (Di = ir[li]) === null || Di === void 0 ? void 0 : Di.index;
          }
        } else {
          var Mi = Math.min(mi, vi), Oo = Math.max(mi, vi);
          if (pt > (Mi + Ti) / 2 && pt <= (Oo + Ti) / 2) {
            var io;
            return (io = ir[li]) === null || io === void 0 ? void 0 : io.index;
          }
        }
    }
  else if (yt)
    for (var xo = 0; xo < ai; xo++) {
      var fo = yt[xo];
      if (fo != null) {
        var _o = yt[xo + 1], Li = yt[xo - 1];
        if (xo === 0 && _o != null && pt <= (fo.coordinate + _o.coordinate) / 2 || xo === ai - 1 && Li != null && pt > (fo.coordinate + Li.coordinate) / 2 || xo > 0 && xo < ai - 1 && Li != null && _o != null && pt > (fo.coordinate + Li.coordinate) / 2 && pt <= (fo.coordinate + _o.coordinate) / 2)
          return fo.index;
      }
    }
  return -1;
}, pickTooltipEventType = (pt, yt) => yt, pickTrigger = (pt, yt, ir) => ir, pickDefaultIndex = (pt, yt, ir, ti) => ti, selectOrderedTooltipTicks = createSelector(selectTooltipAxisTicks, (pt) => sortBy$1(pt, (yt) => yt.coordinate)), selectTooltipInteractionState = createSelector([selectTooltipState, pickTooltipEventType, pickTrigger, pickDefaultIndex], combineTooltipInteractionState), selectActiveIndex = createSelector([selectTooltipInteractionState, selectTooltipDisplayedData, selectTooltipAxisDataKey, selectTooltipAxisDomain], combineActiveTooltipIndex), selectTooltipPayloadConfigurations = createSelector([selectTooltipState, pickTooltipEventType, pickTrigger, pickDefaultIndex], combineTooltipPayloadConfigurations), selectCoordinateForDefaultIndex = createSelector([selectChartWidth, selectChartHeight, selectChartLayout, selectChartOffsetInternal, selectTooltipAxisTicks, pickDefaultIndex, selectTooltipPayloadConfigurations], combineCoordinateForDefaultIndex);
createSelector([selectTooltipInteractionState, selectCoordinateForDefaultIndex], (pt, yt) => {
  var ir;
  return (ir = pt.coordinate) !== null && ir !== void 0 ? ir : yt;
});
var selectActiveLabel = createSelector([selectTooltipAxisTicks, selectActiveIndex], combineActiveLabel);
createSelector([selectTooltipPayloadConfigurations, selectActiveIndex, selectChartDataWithIndexes, selectTooltipAxisDataKey, selectActiveLabel, selectTooltipPayloadSearcher, pickTooltipEventType], combineTooltipPayload);
createSelector([selectTooltipInteractionState, selectActiveIndex], (pt, yt) => ({
  isActive: pt.active && yt != null,
  activeIndex: yt
}));
var combineActiveCartesianProps = (pt, yt, ir, ti, ii, ui, ai) => {
  if (!(!pt || !ir || !ti || !ii) && isInCartesianRange(pt, ai)) {
    var li = calculateCartesianTooltipPos(pt, yt), oi = calculateActiveTickIndex(li, ui, ii, ir, ti), si = getActiveCartesianCoordinate(yt, ii, oi, pt);
    return {
      activeIndex: String(oi),
      activeCoordinate: si
    };
  }
}, combineActivePolarProps = (pt, yt, ir, ti, ii, ui, ai) => {
  if (!(!pt || !ti || !ii || !ui || !ir)) {
    var li = inRangeOfSector(pt, ir);
    if (li) {
      var oi = calculatePolarTooltipPos(li, yt), si = calculateActiveTickIndex(oi, ai, ui, ti, ii), di = getActivePolarCoordinate(yt, ui, si, li);
      return {
        activeIndex: String(si),
        activeCoordinate: di
      };
    }
  }
}, combineActiveProps = (pt, yt, ir, ti, ii, ui, ai, li) => {
  if (!(!pt || !yt || !ti || !ii || !ui))
    return yt === "horizontal" || yt === "vertical" ? combineActiveCartesianProps(pt, yt, ti, ii, ui, ai, li) : combineActivePolarProps(pt, yt, ir, ti, ii, ui, ai);
}, selectZIndexPortalElement = createSelector((pt) => pt.zIndex.zIndexMap, (pt, yt) => yt, (pt, yt, ir) => ir, (pt, yt, ir) => {
  if (yt != null) {
    var ti = pt[yt];
    if (ti != null)
      return ir ? ti.panoramaElement : ti.element;
  }
});
createSelector((pt) => pt.zIndex.zIndexMap, (pt) => {
  var yt = Object.keys(pt).map((ti) => parseInt(ti, 10)).concat(Object.values(DefaultZIndexes)), ir = Array.from(new Set(yt));
  return ir.sort((ti, ii) => ti - ii);
}, {
  memoizeOptions: {
    resultEqualityCheck: arrayContentsAreEqualCheck
  }
});
function ownKeys$i(pt, yt) {
  var ir = Object.keys(pt);
  if (Object.getOwnPropertySymbols) {
    var ti = Object.getOwnPropertySymbols(pt);
    yt && (ti = ti.filter(function(ii) {
      return Object.getOwnPropertyDescriptor(pt, ii).enumerable;
    })), ir.push.apply(ir, ti);
  }
  return ir;
}
function _objectSpread$i(pt) {
  for (var yt = 1; yt < arguments.length; yt++) {
    var ir = arguments[yt] != null ? arguments[yt] : {};
    yt % 2 ? ownKeys$i(Object(ir), !0).forEach(function(ti) {
      _defineProperty$k(pt, ti, ir[ti]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(pt, Object.getOwnPropertyDescriptors(ir)) : ownKeys$i(Object(ir)).forEach(function(ti) {
      Object.defineProperty(pt, ti, Object.getOwnPropertyDescriptor(ir, ti));
    });
  }
  return pt;
}
function _defineProperty$k(pt, yt, ir) {
  return (yt = _toPropertyKey$k(yt)) in pt ? Object.defineProperty(pt, yt, { value: ir, enumerable: !0, configurable: !0, writable: !0 }) : pt[yt] = ir, pt;
}
function _toPropertyKey$k(pt) {
  var yt = _toPrimitive$k(pt, "string");
  return typeof yt == "symbol" ? yt : yt + "";
}
function _toPrimitive$k(pt, yt) {
  if (typeof pt != "object" || !pt) return pt;
  var ir = pt[Symbol.toPrimitive];
  if (ir !== void 0) {
    var ti = ir.call(pt, yt);
    if (typeof ti != "object") return ti;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (yt === "string" ? String : Number)(pt);
}
var seed = {}, initialState$a = {
  zIndexMap: Object.values(DefaultZIndexes).reduce((pt, yt) => _objectSpread$i(_objectSpread$i({}, pt), {}, {
    [yt]: {
      element: void 0,
      panoramaElement: void 0,
      consumers: 0
    }
  }), seed)
}, defaultZIndexSet = new Set(Object.values(DefaultZIndexes));
function isDefaultZIndex(pt) {
  return defaultZIndexSet.has(pt);
}
var zIndexSlice = createSlice({
  name: "zIndex",
  initialState: initialState$a,
  reducers: {
    registerZIndexPortal: {
      reducer: (pt, yt) => {
        var {
          zIndex: ir
        } = yt.payload;
        pt.zIndexMap[ir] ? pt.zIndexMap[ir].consumers += 1 : pt.zIndexMap[ir] = {
          consumers: 1,
          element: void 0,
          panoramaElement: void 0
        };
      },
      prepare: prepareAutoBatched()
    },
    unregisterZIndexPortal: {
      reducer: (pt, yt) => {
        var {
          zIndex: ir
        } = yt.payload;
        pt.zIndexMap[ir] && (pt.zIndexMap[ir].consumers -= 1, pt.zIndexMap[ir].consumers <= 0 && !isDefaultZIndex(ir) && delete pt.zIndexMap[ir]);
      },
      prepare: prepareAutoBatched()
    },
    registerZIndexPortalElement: {
      reducer: (pt, yt) => {
        var {
          zIndex: ir,
          element: ti,
          isPanorama: ii
        } = yt.payload;
        pt.zIndexMap[ir] ? ii ? pt.zIndexMap[ir].panoramaElement = ti : pt.zIndexMap[ir].element = ti : pt.zIndexMap[ir] = {
          consumers: 0,
          element: ii ? void 0 : ti,
          panoramaElement: ii ? ti : void 0
        };
      },
      prepare: prepareAutoBatched()
    },
    unregisterZIndexPortalElement: {
      reducer: (pt, yt) => {
        var {
          zIndex: ir
        } = yt.payload;
        pt.zIndexMap[ir] && (yt.payload.isPanorama ? pt.zIndexMap[ir].panoramaElement = void 0 : pt.zIndexMap[ir].element = void 0);
      },
      prepare: prepareAutoBatched()
    }
  }
}), {
  registerZIndexPortal,
  unregisterZIndexPortal,
  registerZIndexPortalElement,
  unregisterZIndexPortalElement
} = zIndexSlice.actions, zIndexReducer = zIndexSlice.reducer;
function ZIndexLayer(pt) {
  var {
    zIndex: yt,
    children: ir
  } = pt, ti = useIsInChartContext(), ii = ti && yt !== void 0 && yt !== 0, ui = useIsPanorama(), ai = useRef(void 0), li = useRef(/* @__PURE__ */ new Set()), oi = useAppDispatch(), si = useAppSelector((fi) => selectZIndexPortalElement(fi, yt, ui));
  if (useLayoutEffect(() => {
    if (!ii) {
      var fi = li.current;
      fi.forEach((mi) => {
        oi(unregisterZIndexPortal({
          zIndex: mi
        }));
      }), fi.clear(), ai.current = void 0;
      return;
    }
    if (li.current.has(yt) || (oi(registerZIndexPortal({
      zIndex: yt
    })), li.current.add(yt)), si) {
      ai.current = si;
      var gi = li.current;
      gi.forEach((mi) => {
        mi !== yt && (oi(unregisterZIndexPortal({
          zIndex: mi
        })), gi.delete(mi));
      });
    }
  }, [oi, yt, ii, si]), useLayoutEffect(() => {
    var fi = li.current;
    return () => {
      fi.forEach((gi) => {
        oi(unregisterZIndexPortal({
          zIndex: gi
        }));
      }), fi.clear();
    };
  }, [oi]), !ii)
    return ir;
  var di = si ?? ai.current;
  return di ? /* @__PURE__ */ createPortal(ir, di) : null;
}
var eventemitter3 = { exports: {} }, hasRequiredEventemitter3;
function requireEventemitter3() {
  return hasRequiredEventemitter3 || (hasRequiredEventemitter3 = 1, (function(pt) {
    var yt = Object.prototype.hasOwnProperty, ir = "~";
    function ti() {
    }
    Object.create && (ti.prototype = /* @__PURE__ */ Object.create(null), new ti().__proto__ || (ir = !1));
    function ii(oi, si, di) {
      this.fn = oi, this.context = si, this.once = di || !1;
    }
    function ui(oi, si, di, fi, gi) {
      if (typeof di != "function")
        throw new TypeError("The listener must be a function");
      var mi = new ii(di, fi || oi, gi), Ti = ir ? ir + si : si;
      return oi._events[Ti] ? oi._events[Ti].fn ? oi._events[Ti] = [oi._events[Ti], mi] : oi._events[Ti].push(mi) : (oi._events[Ti] = mi, oi._eventsCount++), oi;
    }
    function ai(oi, si) {
      --oi._eventsCount === 0 ? oi._events = new ti() : delete oi._events[si];
    }
    function li() {
      this._events = new ti(), this._eventsCount = 0;
    }
    li.prototype.eventNames = function() {
      var oi = [], si, di;
      if (this._eventsCount === 0) return oi;
      for (di in si = this._events)
        yt.call(si, di) && oi.push(ir ? di.slice(1) : di);
      return Object.getOwnPropertySymbols ? oi.concat(Object.getOwnPropertySymbols(si)) : oi;
    }, li.prototype.listeners = function(oi) {
      var si = ir ? ir + oi : oi, di = this._events[si];
      if (!di) return [];
      if (di.fn) return [di.fn];
      for (var fi = 0, gi = di.length, mi = new Array(gi); fi < gi; fi++)
        mi[fi] = di[fi].fn;
      return mi;
    }, li.prototype.listenerCount = function(oi) {
      var si = ir ? ir + oi : oi, di = this._events[si];
      return di ? di.fn ? 1 : di.length : 0;
    }, li.prototype.emit = function(oi, si, di, fi, gi, mi) {
      var Ti = ir ? ir + oi : oi;
      if (!this._events[Ti]) return !1;
      var vi = this._events[Ti], xi = arguments.length, Si, Pi;
      if (vi.fn) {
        switch (vi.once && this.removeListener(oi, vi.fn, void 0, !0), xi) {
          case 1:
            return vi.fn.call(vi.context), !0;
          case 2:
            return vi.fn.call(vi.context, si), !0;
          case 3:
            return vi.fn.call(vi.context, si, di), !0;
          case 4:
            return vi.fn.call(vi.context, si, di, fi), !0;
          case 5:
            return vi.fn.call(vi.context, si, di, fi, gi), !0;
          case 6:
            return vi.fn.call(vi.context, si, di, fi, gi, mi), !0;
        }
        for (Pi = 1, Si = new Array(xi - 1); Pi < xi; Pi++)
          Si[Pi - 1] = arguments[Pi];
        vi.fn.apply(vi.context, Si);
      } else {
        var $i = vi.length, Oi;
        for (Pi = 0; Pi < $i; Pi++)
          switch (vi[Pi].once && this.removeListener(oi, vi[Pi].fn, void 0, !0), xi) {
            case 1:
              vi[Pi].fn.call(vi[Pi].context);
              break;
            case 2:
              vi[Pi].fn.call(vi[Pi].context, si);
              break;
            case 3:
              vi[Pi].fn.call(vi[Pi].context, si, di);
              break;
            case 4:
              vi[Pi].fn.call(vi[Pi].context, si, di, fi);
              break;
            default:
              if (!Si) for (Oi = 1, Si = new Array(xi - 1); Oi < xi; Oi++)
                Si[Oi - 1] = arguments[Oi];
              vi[Pi].fn.apply(vi[Pi].context, Si);
          }
      }
      return !0;
    }, li.prototype.on = function(oi, si, di) {
      return ui(this, oi, si, di, !1);
    }, li.prototype.once = function(oi, si, di) {
      return ui(this, oi, si, di, !0);
    }, li.prototype.removeListener = function(oi, si, di, fi) {
      var gi = ir ? ir + oi : oi;
      if (!this._events[gi]) return this;
      if (!si)
        return ai(this, gi), this;
      var mi = this._events[gi];
      if (mi.fn)
        mi.fn === si && (!fi || mi.once) && (!di || mi.context === di) && ai(this, gi);
      else {
        for (var Ti = 0, vi = [], xi = mi.length; Ti < xi; Ti++)
          (mi[Ti].fn !== si || fi && !mi[Ti].once || di && mi[Ti].context !== di) && vi.push(mi[Ti]);
        vi.length ? this._events[gi] = vi.length === 1 ? vi[0] : vi : ai(this, gi);
      }
      return this;
    }, li.prototype.removeAllListeners = function(oi) {
      var si;
      return oi ? (si = ir ? ir + oi : oi, this._events[si] && ai(this, si)) : (this._events = new ti(), this._eventsCount = 0), this;
    }, li.prototype.off = li.prototype.removeListener, li.prototype.addListener = li.prototype.on, li.prefixed = ir, li.EventEmitter = li, pt.exports = li;
  })(eventemitter3)), eventemitter3.exports;
}
var eventemitter3Exports = requireEventemitter3();
const EventEmitter = /* @__PURE__ */ getDefaultExportFromCjs(eventemitter3Exports);
new EventEmitter();
var initialState$9 = {
  chartName: "",
  tooltipPayloadSearcher: () => {
  },
  eventEmitter: void 0,
  defaultTooltipEventType: "axis"
}, optionsSlice = createSlice({
  name: "options",
  initialState: initialState$9,
  reducers: {
    createEventEmitter: (pt) => {
      pt.eventEmitter == null && (pt.eventEmitter = Symbol("rechartsEventEmitter"));
    }
  }
}), optionsReducer = optionsSlice.reducer, {
  createEventEmitter
} = optionsSlice.actions, initialChartDataState = {
  chartData: void 0,
  computedData: void 0,
  dataStartIndex: 0,
  dataEndIndex: 0
}, chartDataSlice = createSlice({
  name: "chartData",
  initialState: initialChartDataState,
  reducers: {
    setChartData(pt, yt) {
      if (pt.chartData = yt.payload, yt.payload == null) {
        pt.dataStartIndex = 0, pt.dataEndIndex = 0;
        return;
      }
      yt.payload.length > 0 && pt.dataEndIndex !== yt.payload.length - 1 && (pt.dataEndIndex = yt.payload.length - 1);
    },
    setComputedData(pt, yt) {
      pt.computedData = yt.payload;
    },
    setDataStartEndIndexes(pt, yt) {
      var {
        startIndex: ir,
        endIndex: ti
      } = yt.payload;
      ir != null && (pt.dataStartIndex = ir), ti != null && (pt.dataEndIndex = ti);
    }
  }
}), {
  setChartData,
  setDataStartEndIndexes,
  setComputedData
} = chartDataSlice.actions, chartDataReducer = chartDataSlice.reducer, Cell = (pt) => null;
Cell.displayName = "Cell";
function _defineProperty$g(pt, yt, ir) {
  return (yt = _toPropertyKey$g(yt)) in pt ? Object.defineProperty(pt, yt, { value: ir, enumerable: !0, configurable: !0, writable: !0 }) : pt[yt] = ir, pt;
}
function _toPropertyKey$g(pt) {
  var yt = _toPrimitive$g(pt, "string");
  return typeof yt == "symbol" ? yt : yt + "";
}
function _toPrimitive$g(pt, yt) {
  if (typeof pt != "object" || !pt) return pt;
  var ir = pt[Symbol.toPrimitive];
  if (ir !== void 0) {
    var ti = ir.call(pt, yt);
    if (typeof ti != "object") return ti;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (yt === "string" ? String : Number)(pt);
}
class LRUCache {
  constructor(yt) {
    _defineProperty$g(this, "cache", /* @__PURE__ */ new Map()), this.maxSize = yt;
  }
  get(yt) {
    var ir = this.cache.get(yt);
    return ir !== void 0 && (this.cache.delete(yt), this.cache.set(yt, ir)), ir;
  }
  set(yt, ir) {
    if (this.cache.has(yt))
      this.cache.delete(yt);
    else if (this.cache.size >= this.maxSize) {
      var ti = this.cache.keys().next().value;
      ti != null && this.cache.delete(ti);
    }
    this.cache.set(yt, ir);
  }
  clear() {
    this.cache.clear();
  }
  size() {
    return this.cache.size;
  }
}
function ownKeys$e(pt, yt) {
  var ir = Object.keys(pt);
  if (Object.getOwnPropertySymbols) {
    var ti = Object.getOwnPropertySymbols(pt);
    yt && (ti = ti.filter(function(ii) {
      return Object.getOwnPropertyDescriptor(pt, ii).enumerable;
    })), ir.push.apply(ir, ti);
  }
  return ir;
}
function _objectSpread$e(pt) {
  for (var yt = 1; yt < arguments.length; yt++) {
    var ir = arguments[yt] != null ? arguments[yt] : {};
    yt % 2 ? ownKeys$e(Object(ir), !0).forEach(function(ti) {
      _defineProperty$f(pt, ti, ir[ti]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(pt, Object.getOwnPropertyDescriptors(ir)) : ownKeys$e(Object(ir)).forEach(function(ti) {
      Object.defineProperty(pt, ti, Object.getOwnPropertyDescriptor(ir, ti));
    });
  }
  return pt;
}
function _defineProperty$f(pt, yt, ir) {
  return (yt = _toPropertyKey$f(yt)) in pt ? Object.defineProperty(pt, yt, { value: ir, enumerable: !0, configurable: !0, writable: !0 }) : pt[yt] = ir, pt;
}
function _toPropertyKey$f(pt) {
  var yt = _toPrimitive$f(pt, "string");
  return typeof yt == "symbol" ? yt : yt + "";
}
function _toPrimitive$f(pt, yt) {
  if (typeof pt != "object" || !pt) return pt;
  var ir = pt[Symbol.toPrimitive];
  if (ir !== void 0) {
    var ti = ir.call(pt, yt);
    if (typeof ti != "object") return ti;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (yt === "string" ? String : Number)(pt);
}
var defaultConfig = {
  cacheSize: 2e3,
  enableCache: !0
}, currentConfig = _objectSpread$e({}, defaultConfig), stringCache = new LRUCache(currentConfig.cacheSize), SPAN_STYLE = {
  position: "absolute",
  top: "-20000px",
  left: 0,
  padding: 0,
  margin: 0,
  border: "none",
  whiteSpace: "pre"
}, MEASUREMENT_SPAN_ID = "recharts_measurement_span";
function createCacheKey(pt, yt) {
  var ir = yt.fontSize || "", ti = yt.fontFamily || "", ii = yt.fontWeight || "", ui = yt.fontStyle || "", ai = yt.letterSpacing || "", li = yt.textTransform || "";
  return "".concat(pt, "|").concat(ir, "|").concat(ti, "|").concat(ii, "|").concat(ui, "|").concat(ai, "|").concat(li);
}
var measureTextWithDOM = (pt, yt) => {
  try {
    var ir = document.getElementById(MEASUREMENT_SPAN_ID);
    ir || (ir = document.createElement("span"), ir.setAttribute("id", MEASUREMENT_SPAN_ID), ir.setAttribute("aria-hidden", "true"), document.body.appendChild(ir)), Object.assign(ir.style, SPAN_STYLE, yt), ir.textContent = "".concat(pt);
    var ti = ir.getBoundingClientRect();
    return {
      width: ti.width,
      height: ti.height
    };
  } catch {
    return {
      width: 0,
      height: 0
    };
  }
}, getStringSize = function(pt) {
  var yt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (pt == null || Global.isSsr)
    return {
      width: 0,
      height: 0
    };
  if (!currentConfig.enableCache)
    return measureTextWithDOM(pt, yt);
  var ir = createCacheKey(pt, yt), ti = stringCache.get(ir);
  if (ti)
    return ti;
  var ii = measureTextWithDOM(pt, yt);
  return stringCache.set(ir, ii), ii;
}, _DecimalCSS;
function _defineProperty$e(pt, yt, ir) {
  return (yt = _toPropertyKey$e(yt)) in pt ? Object.defineProperty(pt, yt, { value: ir, enumerable: !0, configurable: !0, writable: !0 }) : pt[yt] = ir, pt;
}
function _toPropertyKey$e(pt) {
  var yt = _toPrimitive$e(pt, "string");
  return typeof yt == "symbol" ? yt : yt + "";
}
function _toPrimitive$e(pt, yt) {
  if (typeof pt != "object" || !pt) return pt;
  var ir = pt[Symbol.toPrimitive];
  if (ir !== void 0) {
    var ti = ir.call(pt, yt);
    if (typeof ti != "object") return ti;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (yt === "string" ? String : Number)(pt);
}
var MULTIPLY_OR_DIVIDE_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, ADD_OR_SUBTRACT_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, CSS_LENGTH_UNIT_REGEX = /^(px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q)$/, NUM_SPLIT_REGEX = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/, CONVERSION_RATES = {
  cm: 96 / 2.54,
  mm: 96 / 25.4,
  pt: 96 / 72,
  pc: 96 / 6,
  in: 96,
  Q: 96 / (2.54 * 40),
  px: 1
}, FIXED_CSS_LENGTH_UNITS = ["cm", "mm", "pt", "pc", "in", "Q", "px"];
function isSupportedUnit(pt) {
  return FIXED_CSS_LENGTH_UNITS.includes(pt);
}
var STR_NAN = "NaN";
function convertToPx(pt, yt) {
  return pt * CONVERSION_RATES[yt];
}
class DecimalCSS {
  static parse(yt) {
    var ir, [, ti, ii] = (ir = NUM_SPLIT_REGEX.exec(yt)) !== null && ir !== void 0 ? ir : [];
    return ti == null ? DecimalCSS.NaN : new DecimalCSS(parseFloat(ti), ii ?? "");
  }
  constructor(yt, ir) {
    this.num = yt, this.unit = ir, this.num = yt, this.unit = ir, isNan(yt) && (this.unit = ""), ir !== "" && !CSS_LENGTH_UNIT_REGEX.test(ir) && (this.num = NaN, this.unit = ""), isSupportedUnit(ir) && (this.num = convertToPx(yt, ir), this.unit = "px");
  }
  add(yt) {
    return this.unit !== yt.unit ? new DecimalCSS(NaN, "") : new DecimalCSS(this.num + yt.num, this.unit);
  }
  subtract(yt) {
    return this.unit !== yt.unit ? new DecimalCSS(NaN, "") : new DecimalCSS(this.num - yt.num, this.unit);
  }
  multiply(yt) {
    return this.unit !== "" && yt.unit !== "" && this.unit !== yt.unit ? new DecimalCSS(NaN, "") : new DecimalCSS(this.num * yt.num, this.unit || yt.unit);
  }
  divide(yt) {
    return this.unit !== "" && yt.unit !== "" && this.unit !== yt.unit ? new DecimalCSS(NaN, "") : new DecimalCSS(this.num / yt.num, this.unit || yt.unit);
  }
  toString() {
    return "".concat(this.num).concat(this.unit);
  }
  isNaN() {
    return isNan(this.num);
  }
}
_DecimalCSS = DecimalCSS;
_defineProperty$e(DecimalCSS, "NaN", new _DecimalCSS(NaN, ""));
function calculateArithmetic(pt) {
  if (pt == null || pt.includes(STR_NAN))
    return STR_NAN;
  for (var yt = pt; yt.includes("*") || yt.includes("/"); ) {
    var ir, [, ti, ii, ui] = (ir = MULTIPLY_OR_DIVIDE_REGEX.exec(yt)) !== null && ir !== void 0 ? ir : [], ai = DecimalCSS.parse(ti ?? ""), li = DecimalCSS.parse(ui ?? ""), oi = ii === "*" ? ai.multiply(li) : ai.divide(li);
    if (oi.isNaN())
      return STR_NAN;
    yt = yt.replace(MULTIPLY_OR_DIVIDE_REGEX, oi.toString());
  }
  for (; yt.includes("+") || /.-\d+(?:\.\d+)?/.test(yt); ) {
    var si, [, di, fi, gi] = (si = ADD_OR_SUBTRACT_REGEX.exec(yt)) !== null && si !== void 0 ? si : [], mi = DecimalCSS.parse(di ?? ""), Ti = DecimalCSS.parse(gi ?? ""), vi = fi === "+" ? mi.add(Ti) : mi.subtract(Ti);
    if (vi.isNaN())
      return STR_NAN;
    yt = yt.replace(ADD_OR_SUBTRACT_REGEX, vi.toString());
  }
  return yt;
}
var PARENTHESES_REGEX = /\(([^()]*)\)/;
function calculateParentheses(pt) {
  for (var yt = pt, ir; (ir = PARENTHESES_REGEX.exec(yt)) != null; ) {
    var [, ti] = ir;
    yt = yt.replace(PARENTHESES_REGEX, calculateArithmetic(ti));
  }
  return yt;
}
function evaluateExpression(pt) {
  var yt = pt.replace(/\s+/g, "");
  return yt = calculateParentheses(yt), yt = calculateArithmetic(yt), yt;
}
function safeEvaluateExpression(pt) {
  try {
    return evaluateExpression(pt);
  } catch {
    return STR_NAN;
  }
}
function reduceCSSCalc(pt) {
  var yt = safeEvaluateExpression(pt.slice(5, -1));
  return yt === STR_NAN ? "" : yt;
}
var _excluded$d = ["x", "y", "lineHeight", "capHeight", "fill", "scaleToFit", "textAnchor", "verticalAnchor"], _excluded2$7 = ["dx", "dy", "angle", "className", "breakAll"];
function _extends$d() {
  return _extends$d = Object.assign ? Object.assign.bind() : function(pt) {
    for (var yt = 1; yt < arguments.length; yt++) {
      var ir = arguments[yt];
      for (var ti in ir) ({}).hasOwnProperty.call(ir, ti) && (pt[ti] = ir[ti]);
    }
    return pt;
  }, _extends$d.apply(null, arguments);
}
function _objectWithoutProperties$d(pt, yt) {
  if (pt == null) return {};
  var ir, ti, ii = _objectWithoutPropertiesLoose$d(pt, yt);
  if (Object.getOwnPropertySymbols) {
    var ui = Object.getOwnPropertySymbols(pt);
    for (ti = 0; ti < ui.length; ti++) ir = ui[ti], yt.indexOf(ir) === -1 && {}.propertyIsEnumerable.call(pt, ir) && (ii[ir] = pt[ir]);
  }
  return ii;
}
function _objectWithoutPropertiesLoose$d(pt, yt) {
  if (pt == null) return {};
  var ir = {};
  for (var ti in pt) if ({}.hasOwnProperty.call(pt, ti)) {
    if (yt.indexOf(ti) !== -1) continue;
    ir[ti] = pt[ti];
  }
  return ir;
}
var BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/, calculateWordWidths = (pt) => {
  var {
    children: yt,
    breakAll: ir,
    style: ti
  } = pt;
  try {
    var ii = [];
    isNullish(yt) || (ir ? ii = yt.toString().split("") : ii = yt.toString().split(BREAKING_SPACES));
    var ui = ii.map((li) => ({
      word: li,
      width: getStringSize(li, ti).width
    })), ai = ir ? 0 : getStringSize(" ", ti).width;
    return {
      wordsWithComputedWidth: ui,
      spaceWidth: ai
    };
  } catch {
    return null;
  }
};
function isValidTextAnchor(pt) {
  return pt === "start" || pt === "middle" || pt === "end" || pt === "inherit";
}
function isRenderableText(pt) {
  return isNullish(pt) || typeof pt == "string" || typeof pt == "number" || typeof pt == "boolean";
}
var calculate = (pt, yt, ir, ti) => pt.reduce((ii, ui) => {
  var {
    word: ai,
    width: li
  } = ui, oi = ii[ii.length - 1];
  if (oi && li != null && (yt == null || ti || oi.width + li + ir < Number(yt)))
    oi.words.push(ai), oi.width += li + ir;
  else {
    var si = {
      words: [ai],
      width: li
    };
    ii.push(si);
  }
  return ii;
}, []), findLongestLine = (pt) => pt.reduce((yt, ir) => yt.width > ir.width ? yt : ir), suffix = "…", checkOverflow = (pt, yt, ir, ti, ii, ui, ai, li) => {
  var oi = pt.slice(0, yt), si = calculateWordWidths({
    breakAll: ir,
    style: ti,
    children: oi + suffix
  });
  if (!si)
    return [!1, []];
  var di = calculate(si.wordsWithComputedWidth, ui, ai, li), fi = di.length > ii || findLongestLine(di).width > Number(ui);
  return [fi, di];
}, calculateWordsByLines = (pt, yt, ir, ti, ii) => {
  var {
    maxLines: ui,
    children: ai,
    style: li,
    breakAll: oi
  } = pt, si = isNumber(ui), di = String(ai), fi = calculate(yt, ti, ir, ii);
  if (!si || ii)
    return fi;
  var gi = fi.length > ui || findLongestLine(fi).width > Number(ti);
  if (!gi)
    return fi;
  for (var mi = 0, Ti = di.length - 1, vi = 0, xi; mi <= Ti && vi <= di.length - 1; ) {
    var Si = Math.floor((mi + Ti) / 2), Pi = Si - 1, [$i, Oi] = checkOverflow(di, Pi, oi, li, ui, ti, ir, ii), [Di] = checkOverflow(di, Si, oi, li, ui, ti, ir, ii);
    if (!$i && !Di && (mi = Si + 1), $i && Di && (Ti = Si - 1), !$i && Di) {
      xi = Oi;
      break;
    }
    vi++;
  }
  return xi || fi;
}, getWordsWithoutCalculate = (pt) => {
  var yt = isNullish(pt) ? [] : pt.toString().split(BREAKING_SPACES);
  return [{
    words: yt,
    width: void 0
  }];
}, getWordsByLines = (pt) => {
  var {
    width: yt,
    scaleToFit: ir,
    children: ti,
    style: ii,
    breakAll: ui,
    maxLines: ai
  } = pt;
  if ((yt || ir) && !Global.isSsr) {
    var li, oi, si = calculateWordWidths({
      breakAll: ui,
      children: ti,
      style: ii
    });
    if (si) {
      var {
        wordsWithComputedWidth: di,
        spaceWidth: fi
      } = si;
      li = di, oi = fi;
    } else
      return getWordsWithoutCalculate(ti);
    return calculateWordsByLines({
      breakAll: ui,
      children: ti,
      maxLines: ai,
      style: ii
    }, li, oi, yt, !!ir);
  }
  return getWordsWithoutCalculate(ti);
}, DEFAULT_FILL = "#808080", textDefaultProps = {
  angle: 0,
  breakAll: !1,
  // Magic number from d3
  capHeight: "0.71em",
  fill: DEFAULT_FILL,
  lineHeight: "1em",
  scaleToFit: !1,
  textAnchor: "start",
  // Maintain compat with existing charts / default SVG behavior
  verticalAnchor: "end",
  x: 0,
  y: 0
}, Text = /* @__PURE__ */ forwardRef((pt, yt) => {
  var ir = resolveDefaultProps(pt, textDefaultProps), {
    x: ti,
    y: ii,
    lineHeight: ui,
    capHeight: ai,
    fill: li,
    scaleToFit: oi,
    textAnchor: si,
    verticalAnchor: di
  } = ir, fi = _objectWithoutProperties$d(ir, _excluded$d), gi = useMemo(() => getWordsByLines({
    breakAll: fi.breakAll,
    children: fi.children,
    maxLines: fi.maxLines,
    scaleToFit: oi,
    style: fi.style,
    width: fi.width
  }), [fi.breakAll, fi.children, fi.maxLines, oi, fi.style, fi.width]), {
    dx: mi,
    dy: Ti,
    angle: vi,
    className: xi,
    breakAll: Si
  } = fi, Pi = _objectWithoutProperties$d(fi, _excluded2$7);
  if (!isNumOrStr(ti) || !isNumOrStr(ii) || gi.length === 0)
    return null;
  var $i = Number(ti) + (isNumber(mi) ? mi : 0), Oi = Number(ii) + (isNumber(Ti) ? Ti : 0);
  if (!isWellBehavedNumber($i) || !isWellBehavedNumber(Oi))
    return null;
  var Di;
  switch (di) {
    case "start":
      Di = reduceCSSCalc("calc(".concat(ai, ")"));
      break;
    case "middle":
      Di = reduceCSSCalc("calc(".concat((gi.length - 1) / 2, " * -").concat(ui, " + (").concat(ai, " / 2))"));
      break;
    default:
      Di = reduceCSSCalc("calc(".concat(gi.length - 1, " * -").concat(ui, ")"));
      break;
  }
  var Mi = [], Oo = gi[0];
  if (oi && Oo != null) {
    var io = Oo.width, {
      width: xo
    } = fi;
    Mi.push("scale(".concat(isNumber(xo) && isNumber(io) ? xo / io : 1, ")"));
  }
  return vi && Mi.push("rotate(".concat(vi, ", ").concat($i, ", ").concat(Oi, ")")), Mi.length && (Pi.transform = Mi.join(" ")), /* @__PURE__ */ React.createElement("text", _extends$d({}, svgPropertiesAndEvents(Pi), {
    ref: yt,
    x: $i,
    y: Oi,
    className: clsx$1("recharts-text", xi),
    textAnchor: si,
    fill: li.includes("url") ? DEFAULT_FILL : li
  }), gi.map((fo, _o) => {
    var Li = fo.words.join(Si ? "" : " ");
    return (
      // duplicate words will cause duplicate keys which is why we add the array index here
      /* @__PURE__ */ React.createElement("tspan", {
        x: $i,
        dy: _o === 0 ? Di : ui,
        key: "".concat(Li, "-").concat(_o)
      }, Li)
    );
  }));
});
Text.displayName = "Text";
function ownKeys$d(pt, yt) {
  var ir = Object.keys(pt);
  if (Object.getOwnPropertySymbols) {
    var ti = Object.getOwnPropertySymbols(pt);
    yt && (ti = ti.filter(function(ii) {
      return Object.getOwnPropertyDescriptor(pt, ii).enumerable;
    })), ir.push.apply(ir, ti);
  }
  return ir;
}
function _objectSpread$d(pt) {
  for (var yt = 1; yt < arguments.length; yt++) {
    var ir = arguments[yt] != null ? arguments[yt] : {};
    yt % 2 ? ownKeys$d(Object(ir), !0).forEach(function(ti) {
      _defineProperty$d(pt, ti, ir[ti]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(pt, Object.getOwnPropertyDescriptors(ir)) : ownKeys$d(Object(ir)).forEach(function(ti) {
      Object.defineProperty(pt, ti, Object.getOwnPropertyDescriptor(ir, ti));
    });
  }
  return pt;
}
function _defineProperty$d(pt, yt, ir) {
  return (yt = _toPropertyKey$d(yt)) in pt ? Object.defineProperty(pt, yt, { value: ir, enumerable: !0, configurable: !0, writable: !0 }) : pt[yt] = ir, pt;
}
function _toPropertyKey$d(pt) {
  var yt = _toPrimitive$d(pt, "string");
  return typeof yt == "symbol" ? yt : yt + "";
}
function _toPrimitive$d(pt, yt) {
  if (typeof pt != "object" || !pt) return pt;
  var ir = pt[Symbol.toPrimitive];
  if (ir !== void 0) {
    var ti = ir.call(pt, yt);
    if (typeof ti != "object") return ti;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (yt === "string" ? String : Number)(pt);
}
var getCartesianPosition = (pt) => {
  var {
    viewBox: yt,
    position: ir,
    offset: ti = 0,
    parentViewBox: ii
  } = pt, {
    x: ui,
    y: ai,
    height: li,
    upperWidth: oi,
    lowerWidth: si
  } = cartesianViewBoxToTrapezoid(yt), di = ui, fi = ui + (oi - si) / 2, gi = (di + fi) / 2, mi = (oi + si) / 2, Ti = di + oi / 2, vi = li >= 0 ? 1 : -1, xi = vi * ti, Si = vi > 0 ? "end" : "start", Pi = vi > 0 ? "start" : "end", $i = oi >= 0 ? 1 : -1, Oi = $i * ti, Di = $i > 0 ? "end" : "start", Mi = $i > 0 ? "start" : "end", Oo = ii;
  if (ir === "top") {
    var io = {
      x: di + oi / 2,
      y: ai - xi,
      horizontalAnchor: "middle",
      verticalAnchor: Si
    };
    return Oo && (io.height = Math.max(ai - Oo.y, 0), io.width = oi), io;
  }
  if (ir === "bottom") {
    var xo = {
      x: fi + si / 2,
      y: ai + li + xi,
      horizontalAnchor: "middle",
      verticalAnchor: Pi
    };
    return Oo && (xo.height = Math.max(Oo.y + Oo.height - (ai + li), 0), xo.width = si), xo;
  }
  if (ir === "left") {
    var fo = {
      x: gi - Oi,
      y: ai + li / 2,
      horizontalAnchor: Di,
      verticalAnchor: "middle"
    };
    return Oo && (fo.width = Math.max(fo.x - Oo.x, 0), fo.height = li), fo;
  }
  if (ir === "right") {
    var _o = {
      x: gi + mi + Oi,
      y: ai + li / 2,
      horizontalAnchor: Mi,
      verticalAnchor: "middle"
    };
    return Oo && (_o.width = Math.max(Oo.x + Oo.width - _o.x, 0), _o.height = li), _o;
  }
  var Li = Oo ? {
    width: mi,
    height: li
  } : {};
  return ir === "insideLeft" ? _objectSpread$d({
    x: gi + Oi,
    y: ai + li / 2,
    horizontalAnchor: Mi,
    verticalAnchor: "middle"
  }, Li) : ir === "insideRight" ? _objectSpread$d({
    x: gi + mi - Oi,
    y: ai + li / 2,
    horizontalAnchor: Di,
    verticalAnchor: "middle"
  }, Li) : ir === "insideTop" ? _objectSpread$d({
    x: di + oi / 2,
    y: ai + xi,
    horizontalAnchor: "middle",
    verticalAnchor: Pi
  }, Li) : ir === "insideBottom" ? _objectSpread$d({
    x: fi + si / 2,
    y: ai + li - xi,
    horizontalAnchor: "middle",
    verticalAnchor: Si
  }, Li) : ir === "insideTopLeft" ? _objectSpread$d({
    x: di + Oi,
    y: ai + xi,
    horizontalAnchor: Mi,
    verticalAnchor: Pi
  }, Li) : ir === "insideTopRight" ? _objectSpread$d({
    x: di + oi - Oi,
    y: ai + xi,
    horizontalAnchor: Di,
    verticalAnchor: Pi
  }, Li) : ir === "insideBottomLeft" ? _objectSpread$d({
    x: fi + Oi,
    y: ai + li - xi,
    horizontalAnchor: Mi,
    verticalAnchor: Si
  }, Li) : ir === "insideBottomRight" ? _objectSpread$d({
    x: fi + si - Oi,
    y: ai + li - xi,
    horizontalAnchor: Di,
    verticalAnchor: Si
  }, Li) : ir && typeof ir == "object" && (isNumber(ir.x) || isPercent(ir.x)) && (isNumber(ir.y) || isPercent(ir.y)) ? _objectSpread$d({
    x: ui + getPercentValue(ir.x, mi),
    y: ai + getPercentValue(ir.y, li),
    horizontalAnchor: "end",
    verticalAnchor: "end"
  }, Li) : _objectSpread$d({
    x: Ti,
    y: ai + li / 2,
    horizontalAnchor: "middle",
    verticalAnchor: "middle"
  }, Li);
}, _excluded$c = ["labelRef"], _excluded2$6 = ["content"];
function _objectWithoutProperties$c(pt, yt) {
  if (pt == null) return {};
  var ir, ti, ii = _objectWithoutPropertiesLoose$c(pt, yt);
  if (Object.getOwnPropertySymbols) {
    var ui = Object.getOwnPropertySymbols(pt);
    for (ti = 0; ti < ui.length; ti++) ir = ui[ti], yt.indexOf(ir) === -1 && {}.propertyIsEnumerable.call(pt, ir) && (ii[ir] = pt[ir]);
  }
  return ii;
}
function _objectWithoutPropertiesLoose$c(pt, yt) {
  if (pt == null) return {};
  var ir = {};
  for (var ti in pt) if ({}.hasOwnProperty.call(pt, ti)) {
    if (yt.indexOf(ti) !== -1) continue;
    ir[ti] = pt[ti];
  }
  return ir;
}
function ownKeys$c(pt, yt) {
  var ir = Object.keys(pt);
  if (Object.getOwnPropertySymbols) {
    var ti = Object.getOwnPropertySymbols(pt);
    yt && (ti = ti.filter(function(ii) {
      return Object.getOwnPropertyDescriptor(pt, ii).enumerable;
    })), ir.push.apply(ir, ti);
  }
  return ir;
}
function _objectSpread$c(pt) {
  for (var yt = 1; yt < arguments.length; yt++) {
    var ir = arguments[yt] != null ? arguments[yt] : {};
    yt % 2 ? ownKeys$c(Object(ir), !0).forEach(function(ti) {
      _defineProperty$c(pt, ti, ir[ti]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(pt, Object.getOwnPropertyDescriptors(ir)) : ownKeys$c(Object(ir)).forEach(function(ti) {
      Object.defineProperty(pt, ti, Object.getOwnPropertyDescriptor(ir, ti));
    });
  }
  return pt;
}
function _defineProperty$c(pt, yt, ir) {
  return (yt = _toPropertyKey$c(yt)) in pt ? Object.defineProperty(pt, yt, { value: ir, enumerable: !0, configurable: !0, writable: !0 }) : pt[yt] = ir, pt;
}
function _toPropertyKey$c(pt) {
  var yt = _toPrimitive$c(pt, "string");
  return typeof yt == "symbol" ? yt : yt + "";
}
function _toPrimitive$c(pt, yt) {
  if (typeof pt != "object" || !pt) return pt;
  var ir = pt[Symbol.toPrimitive];
  if (ir !== void 0) {
    var ti = ir.call(pt, yt);
    if (typeof ti != "object") return ti;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (yt === "string" ? String : Number)(pt);
}
function _extends$c() {
  return _extends$c = Object.assign ? Object.assign.bind() : function(pt) {
    for (var yt = 1; yt < arguments.length; yt++) {
      var ir = arguments[yt];
      for (var ti in ir) ({}).hasOwnProperty.call(ir, ti) && (pt[ti] = ir[ti]);
    }
    return pt;
  }, _extends$c.apply(null, arguments);
}
var CartesianLabelContext = /* @__PURE__ */ createContext(null), CartesianLabelContextProvider = (pt) => {
  var {
    x: yt,
    y: ir,
    upperWidth: ti,
    lowerWidth: ii,
    width: ui,
    height: ai,
    children: li
  } = pt, oi = useMemo(() => ({
    x: yt,
    y: ir,
    upperWidth: ti,
    lowerWidth: ii,
    width: ui,
    height: ai
  }), [yt, ir, ti, ii, ui, ai]);
  return /* @__PURE__ */ React.createElement(CartesianLabelContext.Provider, {
    value: oi
  }, li);
}, useCartesianLabelContext = () => {
  var pt = useContext(CartesianLabelContext), yt = useViewBox();
  return pt || (yt ? cartesianViewBoxToTrapezoid(yt) : void 0);
}, PolarLabelContext = /* @__PURE__ */ createContext(null), usePolarLabelContext = () => {
  var pt = useContext(PolarLabelContext), yt = useAppSelector(selectPolarViewBox);
  return pt || yt;
}, getLabel = (pt) => {
  var {
    value: yt,
    formatter: ir
  } = pt, ti = isNullish(pt.children) ? yt : pt.children;
  return typeof ir == "function" ? ir(ti) : ti;
}, isLabelContentAFunction = (pt) => pt != null && typeof pt == "function", getDeltaAngle = (pt, yt) => {
  var ir = mathSign(yt - pt), ti = Math.min(Math.abs(yt - pt), 360);
  return ir * ti;
}, renderRadialLabel = (pt, yt, ir, ti, ii) => {
  var {
    offset: ui,
    className: ai
  } = pt, {
    cx: li,
    cy: oi,
    innerRadius: si,
    outerRadius: di,
    startAngle: fi,
    endAngle: gi,
    clockWise: mi
  } = ii, Ti = (si + di) / 2, vi = getDeltaAngle(fi, gi), xi = vi >= 0 ? 1 : -1, Si, Pi;
  switch (yt) {
    case "insideStart":
      Si = fi + xi * ui, Pi = mi;
      break;
    case "insideEnd":
      Si = gi - xi * ui, Pi = !mi;
      break;
    case "end":
      Si = gi + xi * ui, Pi = mi;
      break;
    default:
      throw new Error("Unsupported position ".concat(yt));
  }
  Pi = vi <= 0 ? Pi : !Pi;
  var $i = polarToCartesian(li, oi, Ti, Si), Oi = polarToCartesian(li, oi, Ti, Si + (Pi ? 1 : -1) * 359), Di = "M".concat($i.x, ",").concat($i.y, `
    A`).concat(Ti, ",").concat(Ti, ",0,1,").concat(Pi ? 0 : 1, `,
    `).concat(Oi.x, ",").concat(Oi.y), Mi = isNullish(pt.id) ? uniqueId("recharts-radial-line-") : pt.id;
  return /* @__PURE__ */ React.createElement("text", _extends$c({}, ti, {
    dominantBaseline: "central",
    className: clsx$1("recharts-radial-bar-label", ai)
  }), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("path", {
    id: Mi,
    d: Di
  })), /* @__PURE__ */ React.createElement("textPath", {
    xlinkHref: "#".concat(Mi)
  }, ir));
}, getAttrsOfPolarLabel = (pt, yt, ir) => {
  var {
    cx: ti,
    cy: ii,
    innerRadius: ui,
    outerRadius: ai,
    startAngle: li,
    endAngle: oi
  } = pt, si = (li + oi) / 2;
  if (ir === "outside") {
    var {
      x: di,
      y: fi
    } = polarToCartesian(ti, ii, ai + yt, si);
    return {
      x: di,
      y: fi,
      textAnchor: di >= ti ? "start" : "end",
      verticalAnchor: "middle"
    };
  }
  if (ir === "center")
    return {
      x: ti,
      y: ii,
      textAnchor: "middle",
      verticalAnchor: "middle"
    };
  if (ir === "centerTop")
    return {
      x: ti,
      y: ii,
      textAnchor: "middle",
      verticalAnchor: "start"
    };
  if (ir === "centerBottom")
    return {
      x: ti,
      y: ii,
      textAnchor: "middle",
      verticalAnchor: "end"
    };
  var gi = (ui + ai) / 2, {
    x: mi,
    y: Ti
  } = polarToCartesian(ti, ii, gi, si);
  return {
    x: mi,
    y: Ti,
    textAnchor: "middle",
    verticalAnchor: "middle"
  };
}, isPolar = (pt) => pt != null && "cx" in pt && isNumber(pt.cx), defaultLabelProps = {
  angle: 0,
  offset: 5,
  zIndex: DefaultZIndexes.label,
  position: "middle",
  textBreakAll: !1
};
function polarViewBoxToTrapezoid(pt) {
  if (!isPolar(pt))
    return pt;
  var {
    cx: yt,
    cy: ir,
    outerRadius: ti
  } = pt, ii = ti * 2;
  return {
    x: yt - ti,
    y: ir - ti,
    width: ii,
    upperWidth: ii,
    lowerWidth: ii,
    height: ii
  };
}
function Label(pt) {
  var yt = resolveDefaultProps(pt, defaultLabelProps), {
    viewBox: ir,
    parentViewBox: ti,
    position: ii,
    value: ui,
    children: ai,
    content: li,
    className: oi = "",
    textBreakAll: si,
    labelRef: di
  } = yt, fi = usePolarLabelContext(), gi = useCartesianLabelContext(), mi = ii === "center" ? gi : fi ?? gi, Ti, vi, xi;
  ir == null ? Ti = mi : isPolar(ir) ? Ti = ir : Ti = cartesianViewBoxToTrapezoid(ir);
  var Si = polarViewBoxToTrapezoid(Ti);
  if (!Ti || isNullish(ui) && isNullish(ai) && !/* @__PURE__ */ isValidElement(li) && typeof li != "function")
    return null;
  var Pi = _objectSpread$c(_objectSpread$c({}, yt), {}, {
    viewBox: Ti
  });
  if (/* @__PURE__ */ isValidElement(li)) {
    var {
      labelRef: $i
    } = Pi, Oi = _objectWithoutProperties$c(Pi, _excluded$c);
    return /* @__PURE__ */ cloneElement(li, Oi);
  }
  if (typeof li == "function") {
    var {
      content: Di
    } = Pi, Mi = _objectWithoutProperties$c(Pi, _excluded2$6);
    if (vi = /* @__PURE__ */ createElement(li, Mi), /* @__PURE__ */ isValidElement(vi))
      return vi;
  } else
    vi = getLabel(yt);
  var Oo = svgPropertiesAndEvents(yt);
  if (isPolar(Ti)) {
    if (ii === "insideStart" || ii === "insideEnd" || ii === "end")
      return renderRadialLabel(yt, ii, vi, Oo, Ti);
    xi = getAttrsOfPolarLabel(Ti, yt.offset, yt.position);
  } else {
    if (!Si)
      return null;
    var io = getCartesianPosition({
      viewBox: Si,
      position: ii,
      offset: yt.offset,
      parentViewBox: isPolar(ti) ? void 0 : ti
    });
    xi = _objectSpread$c(_objectSpread$c({
      x: io.x,
      y: io.y,
      textAnchor: io.horizontalAnchor,
      verticalAnchor: io.verticalAnchor
    }, io.width !== void 0 ? {
      width: io.width
    } : {}), io.height !== void 0 ? {
      height: io.height
    } : {});
  }
  return /* @__PURE__ */ React.createElement(ZIndexLayer, {
    zIndex: yt.zIndex
  }, /* @__PURE__ */ React.createElement(Text, _extends$c({
    ref: di,
    className: clsx$1("recharts-label", oi)
  }, Oo, xi, {
    /*
     * textAnchor is decided by default based on the `position`
     * but we allow overriding via props for precise control.
     */
    textAnchor: isValidTextAnchor(Oo.textAnchor) ? Oo.textAnchor : xi.textAnchor,
    breakAll: si
  }), vi));
}
Label.displayName = "Label";
var parseLabel = (pt, yt, ir) => {
  if (!pt)
    return null;
  var ti = {
    viewBox: yt,
    labelRef: ir
  };
  return pt === !0 ? /* @__PURE__ */ React.createElement(Label, _extends$c({
    key: "label-implicit"
  }, ti)) : isNumOrStr(pt) ? /* @__PURE__ */ React.createElement(Label, _extends$c({
    key: "label-implicit",
    value: pt
  }, ti)) : /* @__PURE__ */ isValidElement(pt) ? pt.type === Label ? /* @__PURE__ */ cloneElement(pt, _objectSpread$c({
    key: "label-implicit"
  }, ti)) : /* @__PURE__ */ React.createElement(Label, _extends$c({
    key: "label-implicit",
    content: pt
  }, ti)) : isLabelContentAFunction(pt) ? /* @__PURE__ */ React.createElement(Label, _extends$c({
    key: "label-implicit",
    content: pt
  }, ti)) : pt && typeof pt == "object" ? /* @__PURE__ */ React.createElement(Label, _extends$c({}, pt, {
    key: "label-implicit"
  }, ti)) : null;
};
function CartesianLabelFromLabelProp(pt) {
  var {
    label: yt,
    labelRef: ir
  } = pt, ti = useCartesianLabelContext();
  return parseLabel(yt, ti, ir) || null;
}
var _excluded$b = ["valueAccessor"], _excluded2$5 = ["dataKey", "clockWise", "id", "textBreakAll", "zIndex"];
function _extends$b() {
  return _extends$b = Object.assign ? Object.assign.bind() : function(pt) {
    for (var yt = 1; yt < arguments.length; yt++) {
      var ir = arguments[yt];
      for (var ti in ir) ({}).hasOwnProperty.call(ir, ti) && (pt[ti] = ir[ti]);
    }
    return pt;
  }, _extends$b.apply(null, arguments);
}
function _objectWithoutProperties$b(pt, yt) {
  if (pt == null) return {};
  var ir, ti, ii = _objectWithoutPropertiesLoose$b(pt, yt);
  if (Object.getOwnPropertySymbols) {
    var ui = Object.getOwnPropertySymbols(pt);
    for (ti = 0; ti < ui.length; ti++) ir = ui[ti], yt.indexOf(ir) === -1 && {}.propertyIsEnumerable.call(pt, ir) && (ii[ir] = pt[ir]);
  }
  return ii;
}
function _objectWithoutPropertiesLoose$b(pt, yt) {
  if (pt == null) return {};
  var ir = {};
  for (var ti in pt) if ({}.hasOwnProperty.call(pt, ti)) {
    if (yt.indexOf(ti) !== -1) continue;
    ir[ti] = pt[ti];
  }
  return ir;
}
var defaultAccessor = (pt) => {
  var yt = Array.isArray(pt.value) ? pt.value[pt.value.length - 1] : pt.value;
  if (isRenderableText(yt))
    return yt;
}, CartesianLabelListContext = /* @__PURE__ */ createContext(void 0), CartesianLabelListContextProvider = CartesianLabelListContext.Provider, PolarLabelListContext = /* @__PURE__ */ createContext(void 0);
PolarLabelListContext.Provider;
function useCartesianLabelListContext() {
  return useContext(CartesianLabelListContext);
}
function usePolarLabelListContext() {
  return useContext(PolarLabelListContext);
}
function LabelList(pt) {
  var {
    valueAccessor: yt = defaultAccessor
  } = pt, ir = _objectWithoutProperties$b(pt, _excluded$b), {
    dataKey: ti,
    clockWise: ii,
    id: ui,
    textBreakAll: ai,
    zIndex: li
  } = ir, oi = _objectWithoutProperties$b(ir, _excluded2$5), si = useCartesianLabelListContext(), di = usePolarLabelListContext(), fi = si || di;
  return !fi || !fi.length ? null : /* @__PURE__ */ React.createElement(ZIndexLayer, {
    zIndex: li ?? DefaultZIndexes.label
  }, /* @__PURE__ */ React.createElement(Layer, {
    className: "recharts-label-list"
  }, fi.map((gi, mi) => {
    var Ti, vi = isNullish(ti) ? yt(gi, mi) : getValueByDataKey(gi.payload, ti), xi = isNullish(ui) ? {} : {
      id: "".concat(ui, "-").concat(mi)
    };
    return /* @__PURE__ */ React.createElement(Label, _extends$b({
      key: "label-".concat(mi)
    }, svgPropertiesAndEvents(gi), oi, xi, {
      /*
       * Prefer to use the explicit fill from LabelList props.
       * Only in an absence of that, fall back to the fill of the entry.
       * The entry fill can be quite difficult to see especially in Bar, Pie, RadialBar in inside positions.
       * On the other hand it's quite convenient in Scatter, Line, or when the position is outside the Bar, Pie filled shapes.
       */
      fill: (Ti = ir.fill) !== null && Ti !== void 0 ? Ti : gi.fill,
      parentViewBox: gi.parentViewBox,
      value: vi,
      textBreakAll: ai,
      viewBox: gi.viewBox,
      index: mi,
      zIndex: 0
    }));
  })));
}
LabelList.displayName = "LabelList";
function LabelListFromLabelProp(pt) {
  var {
    label: yt
  } = pt;
  return yt ? yt === !0 ? /* @__PURE__ */ React.createElement(LabelList, {
    key: "labelList-implicit"
  }) : /* @__PURE__ */ React.isValidElement(yt) || isLabelContentAFunction(yt) ? /* @__PURE__ */ React.createElement(LabelList, {
    key: "labelList-implicit",
    content: yt
  }) : typeof yt == "object" ? /* @__PURE__ */ React.createElement(LabelList, _extends$b({
    key: "labelList-implicit"
  }, yt, {
    type: String(yt.type)
  })) : null : null;
}
var initialState$8 = {
  radiusAxis: {},
  angleAxis: {}
}, polarAxisSlice = createSlice({
  name: "polarAxis",
  initialState: initialState$8,
  reducers: {
    addRadiusAxis(pt, yt) {
      pt.radiusAxis[yt.payload.id] = yt.payload;
    },
    removeRadiusAxis(pt, yt) {
      delete pt.radiusAxis[yt.payload.id];
    },
    addAngleAxis(pt, yt) {
      pt.angleAxis[yt.payload.id] = yt.payload;
    },
    removeAngleAxis(pt, yt) {
      delete pt.angleAxis[yt.payload.id];
    }
  }
}), {
  addRadiusAxis,
  removeRadiusAxis,
  addAngleAxis,
  removeAngleAxis
} = polarAxisSlice.actions, polarAxisReducer = polarAxisSlice.reducer;
function getClassNameFromUnknown(pt) {
  return pt && typeof pt == "object" && "className" in pt && typeof pt.className == "string" ? pt.className : "";
}
var reactIsExports$3 = requireReactIs$2(), getDisplayName$2 = (pt) => typeof pt == "string" ? pt : pt ? pt.displayName || pt.name || "Component" : "", lastChildren = null, lastResult = null, toArray = (pt) => {
  if (pt === lastChildren && Array.isArray(lastResult))
    return lastResult;
  var yt = [];
  return Children.forEach(pt, (ir) => {
    isNullish(ir) || (reactIsExports$3.isFragment(ir) ? yt = yt.concat(toArray(ir.props.children)) : yt.push(ir));
  }), lastResult = yt, lastChildren = pt, yt;
};
function findAllByType(pt, yt) {
  var ir = [], ti = [];
  return Array.isArray(yt) ? ti = yt.map((ii) => getDisplayName$2(ii)) : ti = [getDisplayName$2(yt)], toArray(pt).forEach((ii) => {
    var ui = get$1(ii, "type.displayName") || get$1(ii, "type.name");
    ui && ti.indexOf(ui) !== -1 && ir.push(ii);
  }), ir;
}
var isPlainObject$2 = {}, hasRequiredIsPlainObject$1;
function requireIsPlainObject$1() {
  return hasRequiredIsPlainObject$1 || (hasRequiredIsPlainObject$1 = 1, (function(pt) {
    Object.defineProperty(pt, Symbol.toStringTag, { value: "Module" });
    function yt(ir) {
      var ti;
      if (typeof ir != "object" || ir == null)
        return !1;
      if (Object.getPrototypeOf(ir) === null)
        return !0;
      if (Object.prototype.toString.call(ir) !== "[object Object]") {
        const ui = ir[Symbol.toStringTag];
        return ui == null || !((ti = Object.getOwnPropertyDescriptor(ir, Symbol.toStringTag)) != null && ti.writable) ? !1 : ir.toString() === `[object ${ui}]`;
      }
      let ii = ir;
      for (; Object.getPrototypeOf(ii) !== null; )
        ii = Object.getPrototypeOf(ii);
      return Object.getPrototypeOf(ir) === ii;
    }
    pt.isPlainObject = yt;
  })(isPlainObject$2)), isPlainObject$2;
}
var isPlainObject$1, hasRequiredIsPlainObject;
function requireIsPlainObject() {
  return hasRequiredIsPlainObject || (hasRequiredIsPlainObject = 1, isPlainObject$1 = requireIsPlainObject$1().isPlainObject), isPlainObject$1;
}
var isPlainObjectExports = /* @__PURE__ */ requireIsPlainObject();
const isPlainObject$7 = /* @__PURE__ */ getDefaultExportFromCjs(isPlainObjectExports);
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function ownKeys$b(pt, yt) {
  var ir = Object.keys(pt);
  if (Object.getOwnPropertySymbols) {
    var ti = Object.getOwnPropertySymbols(pt);
    yt && (ti = ti.filter(function(ii) {
      return Object.getOwnPropertyDescriptor(pt, ii).enumerable;
    })), ir.push.apply(ir, ti);
  }
  return ir;
}
function _objectSpread$b(pt) {
  for (var yt = 1; yt < arguments.length; yt++) {
    var ir = arguments[yt] != null ? arguments[yt] : {};
    yt % 2 ? ownKeys$b(Object(ir), !0).forEach(function(ti) {
      _defineProperty$b(pt, ti, ir[ti]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(pt, Object.getOwnPropertyDescriptors(ir)) : ownKeys$b(Object(ir)).forEach(function(ti) {
      Object.defineProperty(pt, ti, Object.getOwnPropertyDescriptor(ir, ti));
    });
  }
  return pt;
}
function _defineProperty$b(pt, yt, ir) {
  return (yt = _toPropertyKey$b(yt)) in pt ? Object.defineProperty(pt, yt, { value: ir, enumerable: !0, configurable: !0, writable: !0 }) : pt[yt] = ir, pt;
}
function _toPropertyKey$b(pt) {
  var yt = _toPrimitive$b(pt, "string");
  return typeof yt == "symbol" ? yt : yt + "";
}
function _toPrimitive$b(pt, yt) {
  if (typeof pt != "object" || !pt) return pt;
  var ir = pt[Symbol.toPrimitive];
  if (ir !== void 0) {
    var ti = ir.call(pt, yt);
    if (typeof ti != "object") return ti;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (yt === "string" ? String : Number)(pt);
}
function _extends$a() {
  return _extends$a = Object.assign ? Object.assign.bind() : function(pt) {
    for (var yt = 1; yt < arguments.length; yt++) {
      var ir = arguments[yt];
      for (var ti in ir) ({}).hasOwnProperty.call(ir, ti) && (pt[ti] = ir[ti]);
    }
    return pt;
  }, _extends$a.apply(null, arguments);
}
function _taggedTemplateLiteral(pt, yt) {
  return yt || (yt = pt.slice(0)), Object.freeze(Object.defineProperties(pt, { raw: { value: Object.freeze(yt) } }));
}
var getTrapezoidPath = (pt, yt, ir, ti, ii) => {
  var ui = ir - ti, ai;
  return ai = roundTemplateLiteral(_templateObject || (_templateObject = _taggedTemplateLiteral(["M ", ",", ""])), pt, yt), ai += roundTemplateLiteral(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["L ", ",", ""])), pt + ir, yt), ai += roundTemplateLiteral(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["L ", ",", ""])), pt + ir - ui / 2, yt + ii), ai += roundTemplateLiteral(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["L ", ",", ""])), pt + ir - ui / 2 - ti, yt + ii), ai += roundTemplateLiteral(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["L ", ",", " Z"])), pt, yt), ai;
}, defaultTrapezoidProps = {
  x: 0,
  y: 0,
  upperWidth: 0,
  lowerWidth: 0,
  height: 0,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, Trapezoid = (pt) => {
  var yt = resolveDefaultProps(pt, defaultTrapezoidProps), {
    x: ir,
    y: ti,
    upperWidth: ii,
    lowerWidth: ui,
    height: ai,
    className: li
  } = yt, {
    animationEasing: oi,
    animationDuration: si,
    animationBegin: di,
    isUpdateAnimationActive: fi
  } = yt, gi = useRef(null), [mi, Ti] = useState(-1), vi = useRef(ii), xi = useRef(ui), Si = useRef(ai), Pi = useRef(ir), $i = useRef(ti), Oi = useAnimationId(pt, "trapezoid-");
  if (useEffect(() => {
    if (gi.current && gi.current.getTotalLength)
      try {
        var Ni = gi.current.getTotalLength();
        Ni && Ti(Ni);
      } catch {
      }
  }, []), ir !== +ir || ti !== +ti || ii !== +ii || ui !== +ui || ai !== +ai || ii === 0 && ui === 0 || ai === 0)
    return null;
  var Di = clsx$1("recharts-trapezoid", li);
  if (!fi)
    return /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", _extends$a({}, svgPropertiesAndEvents(yt), {
      className: Di,
      d: getTrapezoidPath(ir, ti, ii, ui, ai)
    })));
  var Mi = vi.current, Oo = xi.current, io = Si.current, xo = Pi.current, fo = $i.current, _o = "0px ".concat(mi === -1 ? 1 : mi, "px"), Li = "".concat(mi, "px ").concat(mi, "px"), Co = getTransitionVal(["strokeDasharray"], si, oi);
  return /* @__PURE__ */ React.createElement(JavascriptAnimate, {
    animationId: Oi,
    key: Oi,
    canBegin: mi > 0,
    duration: si,
    easing: oi,
    isActive: fi,
    begin: di
  }, (Ni) => {
    var Yi = interpolate$1(Mi, ii, Ni), Vo = interpolate$1(Oo, ui, Ni), No = interpolate$1(io, ai, Ni), Ui = interpolate$1(xo, ir, Ni), jo = interpolate$1(fo, ti, Ni);
    gi.current && (vi.current = Yi, xi.current = Vo, Si.current = No, Pi.current = Ui, $i.current = jo);
    var Wi = Ni > 0 ? {
      transition: Co,
      strokeDasharray: Li
    } : {
      strokeDasharray: _o
    };
    return /* @__PURE__ */ React.createElement("path", _extends$a({}, svgPropertiesAndEvents(yt), {
      className: Di,
      d: getTrapezoidPath(Ui, jo, Yi, Vo, No),
      ref: gi,
      style: _objectSpread$b(_objectSpread$b({}, Wi), yt.style)
    }));
  });
}, _excluded$a = ["option", "shapeType", "activeClassName", "inActiveClassName"];
function _objectWithoutProperties$a(pt, yt) {
  if (pt == null) return {};
  var ir, ti, ii = _objectWithoutPropertiesLoose$a(pt, yt);
  if (Object.getOwnPropertySymbols) {
    var ui = Object.getOwnPropertySymbols(pt);
    for (ti = 0; ti < ui.length; ti++) ir = ui[ti], yt.indexOf(ir) === -1 && {}.propertyIsEnumerable.call(pt, ir) && (ii[ir] = pt[ir]);
  }
  return ii;
}
function _objectWithoutPropertiesLoose$a(pt, yt) {
  if (pt == null) return {};
  var ir = {};
  for (var ti in pt) if ({}.hasOwnProperty.call(pt, ti)) {
    if (yt.indexOf(ti) !== -1) continue;
    ir[ti] = pt[ti];
  }
  return ir;
}
function ownKeys$a(pt, yt) {
  var ir = Object.keys(pt);
  if (Object.getOwnPropertySymbols) {
    var ti = Object.getOwnPropertySymbols(pt);
    yt && (ti = ti.filter(function(ii) {
      return Object.getOwnPropertyDescriptor(pt, ii).enumerable;
    })), ir.push.apply(ir, ti);
  }
  return ir;
}
function _objectSpread$a(pt) {
  for (var yt = 1; yt < arguments.length; yt++) {
    var ir = arguments[yt] != null ? arguments[yt] : {};
    yt % 2 ? ownKeys$a(Object(ir), !0).forEach(function(ti) {
      _defineProperty$a(pt, ti, ir[ti]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(pt, Object.getOwnPropertyDescriptors(ir)) : ownKeys$a(Object(ir)).forEach(function(ti) {
      Object.defineProperty(pt, ti, Object.getOwnPropertyDescriptor(ir, ti));
    });
  }
  return pt;
}
function _defineProperty$a(pt, yt, ir) {
  return (yt = _toPropertyKey$a(yt)) in pt ? Object.defineProperty(pt, yt, { value: ir, enumerable: !0, configurable: !0, writable: !0 }) : pt[yt] = ir, pt;
}
function _toPropertyKey$a(pt) {
  var yt = _toPrimitive$a(pt, "string");
  return typeof yt == "symbol" ? yt : yt + "";
}
function _toPrimitive$a(pt, yt) {
  if (typeof pt != "object" || !pt) return pt;
  var ir = pt[Symbol.toPrimitive];
  if (ir !== void 0) {
    var ti = ir.call(pt, yt);
    if (typeof ti != "object") return ti;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (yt === "string" ? String : Number)(pt);
}
function defaultPropTransformer(pt, yt) {
  return _objectSpread$a(_objectSpread$a({}, yt), pt);
}
function isSymbolsProps(pt, yt) {
  return pt === "symbols";
}
function ShapeSelector(pt) {
  var {
    shapeType: yt,
    elementProps: ir
  } = pt;
  switch (yt) {
    case "rectangle":
      return /* @__PURE__ */ React.createElement(Rectangle, ir);
    case "trapezoid":
      return /* @__PURE__ */ React.createElement(Trapezoid, ir);
    case "sector":
      return /* @__PURE__ */ React.createElement(Sector, ir);
    case "symbols":
      if (isSymbolsProps(yt))
        return /* @__PURE__ */ React.createElement(Symbols, ir);
      break;
    case "curve":
      return /* @__PURE__ */ React.createElement(Curve, ir);
    default:
      return null;
  }
}
function getPropsFromShapeOption(pt) {
  return /* @__PURE__ */ isValidElement(pt) ? pt.props : pt;
}
function Shape(pt) {
  var {
    option: yt,
    shapeType: ir,
    activeClassName: ti = "recharts-active-shape",
    inActiveClassName: ii = "recharts-shape"
  } = pt, ui = _objectWithoutProperties$a(pt, _excluded$a), ai;
  if (/* @__PURE__ */ isValidElement(yt))
    ai = /* @__PURE__ */ cloneElement(yt, _objectSpread$a(_objectSpread$a({}, ui), getPropsFromShapeOption(yt)));
  else if (typeof yt == "function")
    ai = yt(ui, ui.index);
  else if (isPlainObject$7(yt) && typeof yt != "boolean") {
    var li = defaultPropTransformer(yt, ui);
    ai = /* @__PURE__ */ React.createElement(ShapeSelector, {
      shapeType: ir,
      elementProps: li
    });
  } else {
    var oi = ui;
    ai = /* @__PURE__ */ React.createElement(ShapeSelector, {
      shapeType: ir,
      elementProps: oi
    });
  }
  return ui.isActive ? /* @__PURE__ */ React.createElement(Layer, {
    className: ti
  }, ai) : /* @__PURE__ */ React.createElement(Layer, {
    className: ii
  }, ai);
}
var useMouseEnterItemDispatch = (pt, yt, ir) => {
  var ti = useAppDispatch();
  return (ii, ui) => (ai) => {
    pt == null || pt(ii, ui, ai), ti(setActiveMouseOverItemIndex({
      activeIndex: String(ui),
      activeDataKey: yt,
      activeCoordinate: ii.tooltipPosition,
      activeGraphicalItemId: ir
    }));
  };
}, useMouseLeaveItemDispatch = (pt) => {
  var yt = useAppDispatch();
  return (ir, ti) => (ii) => {
    pt == null || pt(ir, ti, ii), yt(mouseLeaveItem());
  };
}, useMouseClickItemDispatch = (pt, yt, ir) => {
  var ti = useAppDispatch();
  return (ii, ui) => (ai) => {
    pt == null || pt(ii, ui, ai), ti(setActiveClickItemIndex({
      activeIndex: String(ui),
      activeDataKey: yt,
      activeCoordinate: ii.tooltipPosition,
      activeGraphicalItemId: ir
    }));
  };
};
function SetTooltipEntrySettings(pt) {
  var {
    tooltipEntrySettings: yt
  } = pt, ir = useAppDispatch(), ti = useIsPanorama(), ii = useRef(null);
  return useLayoutEffect(() => {
    ti || (ii.current === null ? ir(addTooltipEntrySettings(yt)) : ii.current !== yt && ir(replaceTooltipEntrySettings({
      prev: ii.current,
      next: yt
    })), ii.current = yt);
  }, [yt, ir, ti]), useLayoutEffect(() => () => {
    ii.current && (ir(removeTooltipEntrySettings(ii.current)), ii.current = null);
  }, [ir]), null;
}
function SetLegendPayload(pt) {
  var {
    legendPayload: yt
  } = pt, ir = useAppDispatch(), ti = useIsPanorama(), ii = useRef(null);
  return useLayoutEffect(() => {
    ti || (ii.current === null ? ir(addLegendPayload(yt)) : ii.current !== yt && ir(replaceLegendPayload({
      prev: ii.current,
      next: yt
    })), ii.current = yt);
  }, [ir, ti, yt]), useLayoutEffect(() => () => {
    ii.current && (ir(removeLegendPayload(ii.current)), ii.current = null);
  }, [ir]), null;
}
var _ref, useIdFallback = () => {
  var [pt] = React.useState(() => uniqueId("uid-"));
  return pt;
}, useId = (_ref = React.useId) !== null && _ref !== void 0 ? _ref : useIdFallback;
function useUniqueId(pt, yt) {
  var ir = useId();
  return yt || (pt ? "".concat(pt, "-").concat(ir) : ir);
}
var GraphicalItemIdContext = /* @__PURE__ */ createContext(void 0), RegisterGraphicalItemId = (pt) => {
  var {
    id: yt,
    type: ir,
    children: ti
  } = pt, ii = useUniqueId("recharts-".concat(ir), yt);
  return /* @__PURE__ */ React.createElement(GraphicalItemIdContext.Provider, {
    value: ii
  }, ti(ii));
}, initialState$7 = {
  cartesianItems: [],
  polarItems: []
}, graphicalItemsSlice = createSlice({
  name: "graphicalItems",
  initialState: initialState$7,
  reducers: {
    addCartesianGraphicalItem: {
      reducer(pt, yt) {
        pt.cartesianItems.push(yt.payload);
      },
      prepare: prepareAutoBatched()
    },
    replaceCartesianGraphicalItem: {
      reducer(pt, yt) {
        var {
          prev: ir,
          next: ti
        } = yt.payload, ii = current$1(pt).cartesianItems.indexOf(ir);
        ii > -1 && (pt.cartesianItems[ii] = ti);
      },
      prepare: prepareAutoBatched()
    },
    removeCartesianGraphicalItem: {
      reducer(pt, yt) {
        var ir = current$1(pt).cartesianItems.indexOf(yt.payload);
        ir > -1 && pt.cartesianItems.splice(ir, 1);
      },
      prepare: prepareAutoBatched()
    },
    addPolarGraphicalItem: {
      reducer(pt, yt) {
        pt.polarItems.push(yt.payload);
      },
      prepare: prepareAutoBatched()
    },
    removePolarGraphicalItem: {
      reducer(pt, yt) {
        var ir = current$1(pt).polarItems.indexOf(yt.payload);
        ir > -1 && pt.polarItems.splice(ir, 1);
      },
      prepare: prepareAutoBatched()
    },
    replacePolarGraphicalItem: {
      reducer(pt, yt) {
        var {
          prev: ir,
          next: ti
        } = yt.payload, ii = current$1(pt).polarItems.indexOf(ir);
        ii > -1 && (pt.polarItems[ii] = ti);
      },
      prepare: prepareAutoBatched()
    }
  }
}), {
  addCartesianGraphicalItem,
  replaceCartesianGraphicalItem,
  removeCartesianGraphicalItem,
  addPolarGraphicalItem,
  removePolarGraphicalItem,
  replacePolarGraphicalItem
} = graphicalItemsSlice.actions, graphicalItemsReducer = graphicalItemsSlice.reducer, SetCartesianGraphicalItemImpl = (pt) => {
  var yt = useAppDispatch(), ir = useRef(null);
  return useLayoutEffect(() => {
    ir.current === null ? yt(addCartesianGraphicalItem(pt)) : ir.current !== pt && yt(replaceCartesianGraphicalItem({
      prev: ir.current,
      next: pt
    })), ir.current = pt;
  }, [yt, pt]), useLayoutEffect(() => () => {
    ir.current && (yt(removeCartesianGraphicalItem(ir.current)), ir.current = null);
  }, [yt]), null;
}, SetCartesianGraphicalItem = /* @__PURE__ */ memo(SetCartesianGraphicalItemImpl);
function ownKeys$9(pt, yt) {
  var ir = Object.keys(pt);
  if (Object.getOwnPropertySymbols) {
    var ti = Object.getOwnPropertySymbols(pt);
    yt && (ti = ti.filter(function(ii) {
      return Object.getOwnPropertyDescriptor(pt, ii).enumerable;
    })), ir.push.apply(ir, ti);
  }
  return ir;
}
function _objectSpread$9(pt) {
  for (var yt = 1; yt < arguments.length; yt++) {
    var ir = arguments[yt] != null ? arguments[yt] : {};
    yt % 2 ? ownKeys$9(Object(ir), !0).forEach(function(ti) {
      _defineProperty$9(pt, ti, ir[ti]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(pt, Object.getOwnPropertyDescriptors(ir)) : ownKeys$9(Object(ir)).forEach(function(ti) {
      Object.defineProperty(pt, ti, Object.getOwnPropertyDescriptor(ir, ti));
    });
  }
  return pt;
}
function _defineProperty$9(pt, yt, ir) {
  return (yt = _toPropertyKey$9(yt)) in pt ? Object.defineProperty(pt, yt, { value: ir, enumerable: !0, configurable: !0, writable: !0 }) : pt[yt] = ir, pt;
}
function _toPropertyKey$9(pt) {
  var yt = _toPrimitive$9(pt, "string");
  return typeof yt == "symbol" ? yt : yt + "";
}
function _toPrimitive$9(pt, yt) {
  if (typeof pt != "object" || !pt) return pt;
  var ir = pt[Symbol.toPrimitive];
  if (ir !== void 0) {
    var ti = ir.call(pt, yt);
    if (typeof ti != "object") return ti;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (yt === "string" ? String : Number)(pt);
}
var defaultAxisId = 0, initialState$6 = {
  xAxis: {},
  yAxis: {},
  zAxis: {}
}, cartesianAxisSlice = createSlice({
  name: "cartesianAxis",
  initialState: initialState$6,
  reducers: {
    addXAxis: {
      reducer(pt, yt) {
        pt.xAxis[yt.payload.id] = yt.payload;
      },
      prepare: prepareAutoBatched()
    },
    replaceXAxis: {
      reducer(pt, yt) {
        var {
          prev: ir,
          next: ti
        } = yt.payload;
        pt.xAxis[ir.id] !== void 0 && (ir.id !== ti.id && delete pt.xAxis[ir.id], pt.xAxis[ti.id] = ti);
      },
      prepare: prepareAutoBatched()
    },
    removeXAxis: {
      reducer(pt, yt) {
        delete pt.xAxis[yt.payload.id];
      },
      prepare: prepareAutoBatched()
    },
    addYAxis: {
      reducer(pt, yt) {
        pt.yAxis[yt.payload.id] = yt.payload;
      },
      prepare: prepareAutoBatched()
    },
    replaceYAxis: {
      reducer(pt, yt) {
        var {
          prev: ir,
          next: ti
        } = yt.payload;
        pt.yAxis[ir.id] !== void 0 && (ir.id !== ti.id && delete pt.yAxis[ir.id], pt.yAxis[ti.id] = ti);
      },
      prepare: prepareAutoBatched()
    },
    removeYAxis: {
      reducer(pt, yt) {
        delete pt.yAxis[yt.payload.id];
      },
      prepare: prepareAutoBatched()
    },
    addZAxis: {
      reducer(pt, yt) {
        pt.zAxis[yt.payload.id] = yt.payload;
      },
      prepare: prepareAutoBatched()
    },
    replaceZAxis: {
      reducer(pt, yt) {
        var {
          prev: ir,
          next: ti
        } = yt.payload;
        pt.zAxis[ir.id] !== void 0 && (ir.id !== ti.id && delete pt.zAxis[ir.id], pt.zAxis[ti.id] = ti);
      },
      prepare: prepareAutoBatched()
    },
    removeZAxis: {
      reducer(pt, yt) {
        delete pt.zAxis[yt.payload.id];
      },
      prepare: prepareAutoBatched()
    },
    updateYAxisWidth(pt, yt) {
      var {
        id: ir,
        width: ti
      } = yt.payload, ii = pt.yAxis[ir];
      if (ii) {
        var ui, ai = ii.widthHistory || [];
        if (ai.length === 3 && ai[0] === ai[2] && ti === ai[1] && ti !== ii.width && Math.abs(ti - ((ui = ai[0]) !== null && ui !== void 0 ? ui : 0)) <= 1)
          return;
        var li = [...ai, ti].slice(-3);
        pt.yAxis[ir] = _objectSpread$9(_objectSpread$9({}, ii), {}, {
          width: ti,
          widthHistory: li
        });
      }
    }
  }
}), {
  addXAxis,
  replaceXAxis,
  removeXAxis,
  addYAxis,
  replaceYAxis,
  removeYAxis,
  addZAxis,
  replaceZAxis,
  removeZAxis,
  updateYAxisWidth
} = cartesianAxisSlice.actions, cartesianAxisReducer = cartesianAxisSlice.reducer, selectChartOffset = createSelector([selectChartOffsetInternal], (pt) => ({
  top: pt.top,
  bottom: pt.bottom,
  left: pt.left,
  right: pt.right
})), selectPlotArea = createSelector([selectChartOffset, selectChartWidth, selectChartHeight], (pt, yt, ir) => {
  if (!(!pt || yt == null || ir == null))
    return {
      x: pt.left,
      y: pt.top,
      width: Math.max(0, yt - pt.left - pt.right),
      height: Math.max(0, ir - pt.top - pt.bottom)
    };
}), usePlotArea = () => useAppSelector(selectPlotArea), getBarSize = (pt, yt, ir) => {
  var ti = ir ?? pt;
  if (!isNullish(ti))
    return getPercentValue(ti, yt, 0);
}, combineBarSizeList = (pt, yt, ir) => {
  var ti = {}, ii = pt.filter(isStacked), ui = pt.filter((si) => si.stackId == null), ai = ii.reduce((si, di) => {
    var fi = si[di.stackId];
    return fi == null && (fi = []), fi.push(di), si[di.stackId] = fi, si;
  }, ti), li = Object.entries(ai).map((si) => {
    var di, [fi, gi] = si, mi = gi.map((vi) => vi.dataKey), Ti = getBarSize(yt, ir, (di = gi[0]) === null || di === void 0 ? void 0 : di.barSize);
    return {
      stackId: fi,
      dataKeys: mi,
      barSize: Ti
    };
  }), oi = ui.map((si) => {
    var di = [si.dataKey].filter((gi) => gi != null), fi = getBarSize(yt, ir, si.barSize);
    return {
      stackId: void 0,
      dataKeys: di,
      barSize: fi
    };
  });
  return [...li, ...oi];
};
function ownKeys$8(pt, yt) {
  var ir = Object.keys(pt);
  if (Object.getOwnPropertySymbols) {
    var ti = Object.getOwnPropertySymbols(pt);
    yt && (ti = ti.filter(function(ii) {
      return Object.getOwnPropertyDescriptor(pt, ii).enumerable;
    })), ir.push.apply(ir, ti);
  }
  return ir;
}
function _objectSpread$8(pt) {
  for (var yt = 1; yt < arguments.length; yt++) {
    var ir = arguments[yt] != null ? arguments[yt] : {};
    yt % 2 ? ownKeys$8(Object(ir), !0).forEach(function(ti) {
      _defineProperty$8(pt, ti, ir[ti]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(pt, Object.getOwnPropertyDescriptors(ir)) : ownKeys$8(Object(ir)).forEach(function(ti) {
      Object.defineProperty(pt, ti, Object.getOwnPropertyDescriptor(ir, ti));
    });
  }
  return pt;
}
function _defineProperty$8(pt, yt, ir) {
  return (yt = _toPropertyKey$8(yt)) in pt ? Object.defineProperty(pt, yt, { value: ir, enumerable: !0, configurable: !0, writable: !0 }) : pt[yt] = ir, pt;
}
function _toPropertyKey$8(pt) {
  var yt = _toPrimitive$8(pt, "string");
  return typeof yt == "symbol" ? yt : yt + "";
}
function _toPrimitive$8(pt, yt) {
  if (typeof pt != "object" || !pt) return pt;
  var ir = pt[Symbol.toPrimitive];
  if (ir !== void 0) {
    var ti = ir.call(pt, yt);
    if (typeof ti != "object") return ti;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (yt === "string" ? String : Number)(pt);
}
function getBarPositions(pt, yt, ir, ti, ii) {
  var ui, ai = ti.length;
  if (!(ai < 1)) {
    var li = getPercentValue(pt, ir, 0, !0), oi, si = [];
    if (isWellBehavedNumber((ui = ti[0]) === null || ui === void 0 ? void 0 : ui.barSize)) {
      var di = !1, fi = ir / ai, gi = ti.reduce((Pi, $i) => Pi + ($i.barSize || 0), 0);
      gi += (ai - 1) * li, gi >= ir && (gi -= (ai - 1) * li, li = 0), gi >= ir && fi > 0 && (di = !0, fi *= 0.9, gi = ai * fi);
      var mi = (ir - gi) / 2 >> 0, Ti = {
        offset: mi - li,
        size: 0
      };
      oi = ti.reduce((Pi, $i) => {
        var Oi, Di = {
          stackId: $i.stackId,
          dataKeys: $i.dataKeys,
          position: {
            offset: Ti.offset + Ti.size + li,
            size: di ? fi : (Oi = $i.barSize) !== null && Oi !== void 0 ? Oi : 0
          }
        }, Mi = [...Pi, Di];
        return Ti = Di.position, Mi;
      }, si);
    } else {
      var vi = getPercentValue(yt, ir, 0, !0);
      ir - 2 * vi - (ai - 1) * li <= 0 && (li = 0);
      var xi = (ir - 2 * vi - (ai - 1) * li) / ai;
      xi > 1 && (xi >>= 0);
      var Si = isWellBehavedNumber(ii) ? Math.min(xi, ii) : xi;
      oi = ti.reduce((Pi, $i, Oi) => [...Pi, {
        stackId: $i.stackId,
        dataKeys: $i.dataKeys,
        position: {
          offset: vi + (xi + li) * Oi + (xi - Si) / 2,
          size: Si
        }
      }], si);
    }
    return oi;
  }
}
var combineAllBarPositions = (pt, yt, ir, ti, ii, ui, ai) => {
  var li = isNullish(ai) ? yt : ai, oi = getBarPositions(ir, ti, ii !== ui ? ii : ui, pt, li);
  return ii !== ui && oi != null && (oi = oi.map((si) => _objectSpread$8(_objectSpread$8({}, si), {}, {
    position: _objectSpread$8(_objectSpread$8({}, si.position), {}, {
      offset: si.position.offset - ii / 2
    })
  }))), oi;
}, combineStackedData = (pt, yt) => {
  var ir = getStackSeriesIdentifier(yt);
  if (!(!pt || ir == null || yt == null)) {
    var {
      stackId: ti
    } = yt;
    if (ti != null) {
      var ii = pt[ti];
      if (ii) {
        var {
          stackedData: ui
        } = ii;
        if (ui)
          return ui.find((ai) => ai.key === ir);
      }
    }
  }
}, combineBarPosition = (pt, yt) => {
  if (!(pt == null || yt == null)) {
    var ir = pt.find((ti) => ti.stackId === yt.stackId && yt.dataKey != null && ti.dataKeys.includes(yt.dataKey));
    if (ir != null)
      return ir.position;
  }
};
function getZIndexFromUnknown(pt, yt) {
  return pt && typeof pt == "object" && "zIndex" in pt && typeof pt.zIndex == "number" && isWellBehavedNumber(pt.zIndex) ? pt.zIndex : yt;
}
var initialState$5 = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  padding: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }
}, brushSlice = createSlice({
  name: "brush",
  initialState: initialState$5,
  reducers: {
    setBrushSettings(pt, yt) {
      return yt.payload == null ? initialState$5 : yt.payload;
    }
  }
}), {
  setBrushSettings
} = brushSlice.actions, brushReducer = brushSlice.reducer;
function normalizeAngle(pt) {
  return (pt % 180 + 180) % 180;
}
var getAngledRectangleWidth = function(pt) {
  var {
    width: yt,
    height: ir
  } = pt, ti = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, ii = normalizeAngle(ti), ui = ii * Math.PI / 180, ai = Math.atan(ir / yt), li = ui > ai && ui < Math.PI - ai ? ir / Math.sin(ui) : yt / Math.cos(ui);
  return Math.abs(li);
}, initialState$4 = {
  dots: [],
  areas: [],
  lines: []
}, referenceElementsSlice = createSlice({
  name: "referenceElements",
  initialState: initialState$4,
  reducers: {
    addDot: (pt, yt) => {
      pt.dots.push(yt.payload);
    },
    removeDot: (pt, yt) => {
      var ir = current$1(pt).dots.findIndex((ti) => ti === yt.payload);
      ir !== -1 && pt.dots.splice(ir, 1);
    },
    addArea: (pt, yt) => {
      pt.areas.push(yt.payload);
    },
    removeArea: (pt, yt) => {
      var ir = current$1(pt).areas.findIndex((ti) => ti === yt.payload);
      ir !== -1 && pt.areas.splice(ir, 1);
    },
    addLine: (pt, yt) => {
      pt.lines.push(yt.payload);
    },
    removeLine: (pt, yt) => {
      var ir = current$1(pt).lines.findIndex((ti) => ti === yt.payload);
      ir !== -1 && pt.lines.splice(ir, 1);
    }
  }
}), {
  addDot,
  removeDot,
  addArea,
  removeArea,
  addLine,
  removeLine
} = referenceElementsSlice.actions, referenceElementsReducer = referenceElementsSlice.reducer;
function getEveryNth(pt, yt) {
  if (yt < 1)
    return [];
  if (yt === 1)
    return pt;
  for (var ir = [], ti = 0; ti < pt.length; ti += yt) {
    var ii = pt[ti];
    ii !== void 0 && ir.push(ii);
  }
  return ir;
}
function getAngledTickWidth(pt, yt, ir) {
  var ti = {
    width: pt.width + yt.width,
    height: pt.height + yt.height
  };
  return getAngledRectangleWidth(ti, ir);
}
function getTickBoundaries(pt, yt, ir) {
  var ti = ir === "width", {
    x: ii,
    y: ui,
    width: ai,
    height: li
  } = pt;
  return yt === 1 ? {
    start: ti ? ii : ui,
    end: ti ? ii + ai : ui + li
  } : {
    start: ti ? ii + ai : ui + li,
    end: ti ? ii : ui
  };
}
function isVisible(pt, yt, ir, ti, ii) {
  if (pt * yt < pt * ti || pt * yt > pt * ii)
    return !1;
  var ui = ir();
  return pt * (yt - pt * ui / 2 - ti) >= 0 && pt * (yt + pt * ui / 2 - ii) <= 0;
}
function getNumberIntervalTicks(pt, yt) {
  return getEveryNth(pt, yt + 1);
}
function getEquidistantTicks(pt, yt, ir, ti, ii) {
  for (var ui = (ti || []).slice(), {
    start: ai,
    end: li
  } = yt, oi = 0, si = 1, di = ai, fi = function() {
    var mi = ti == null ? void 0 : ti[oi];
    if (mi === void 0)
      return {
        v: getEveryNth(ti, si)
      };
    var Ti = oi, vi, xi = () => (vi === void 0 && (vi = ir(mi, Ti)), vi), Si = mi.coordinate, Pi = oi === 0 || isVisible(pt, Si, xi, di, li);
    Pi || (oi = 0, di = ai, si += 1), Pi && (di = Si + pt * (xi() / 2 + ii), oi += si);
  }, gi; si <= ui.length; )
    if (gi = fi(), gi) return gi.v;
  return [];
}
function getEquidistantPreserveEndTicks(pt, yt, ir, ti, ii) {
  var ui = (ti || []).slice(), ai = ui.length;
  if (ai === 0)
    return [];
  for (var {
    start: li,
    end: oi
  } = yt, si = 1; si <= ai; si++) {
    for (var di = (ai - 1) % si, fi = li, gi = !0, mi = function() {
      var $i = ti[vi];
      if ($i == null)
        return 0;
      var Oi = vi, Di, Mi = () => (Di === void 0 && (Di = ir($i, Oi)), Di), Oo = $i.coordinate, io = vi === di || isVisible(pt, Oo, Mi, fi, oi);
      if (!io)
        return gi = !1, 1;
      io && (fi = Oo + pt * (Mi() / 2 + ii));
    }, Ti, vi = di; vi < ai && (Ti = mi(), !(Ti !== 0 && Ti === 1)); vi += si)
      ;
    if (gi) {
      for (var xi = [], Si = di; Si < ai; Si += si) {
        var Pi = ti[Si];
        Pi != null && xi.push(Pi);
      }
      return xi;
    }
  }
  return [];
}
function ownKeys$7(pt, yt) {
  var ir = Object.keys(pt);
  if (Object.getOwnPropertySymbols) {
    var ti = Object.getOwnPropertySymbols(pt);
    yt && (ti = ti.filter(function(ii) {
      return Object.getOwnPropertyDescriptor(pt, ii).enumerable;
    })), ir.push.apply(ir, ti);
  }
  return ir;
}
function _objectSpread$7(pt) {
  for (var yt = 1; yt < arguments.length; yt++) {
    var ir = arguments[yt] != null ? arguments[yt] : {};
    yt % 2 ? ownKeys$7(Object(ir), !0).forEach(function(ti) {
      _defineProperty$7(pt, ti, ir[ti]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(pt, Object.getOwnPropertyDescriptors(ir)) : ownKeys$7(Object(ir)).forEach(function(ti) {
      Object.defineProperty(pt, ti, Object.getOwnPropertyDescriptor(ir, ti));
    });
  }
  return pt;
}
function _defineProperty$7(pt, yt, ir) {
  return (yt = _toPropertyKey$7(yt)) in pt ? Object.defineProperty(pt, yt, { value: ir, enumerable: !0, configurable: !0, writable: !0 }) : pt[yt] = ir, pt;
}
function _toPropertyKey$7(pt) {
  var yt = _toPrimitive$7(pt, "string");
  return typeof yt == "symbol" ? yt : yt + "";
}
function _toPrimitive$7(pt, yt) {
  if (typeof pt != "object" || !pt) return pt;
  var ir = pt[Symbol.toPrimitive];
  if (ir !== void 0) {
    var ti = ir.call(pt, yt);
    if (typeof ti != "object") return ti;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (yt === "string" ? String : Number)(pt);
}
function getTicksEnd(pt, yt, ir, ti, ii) {
  for (var ui = (ti || []).slice(), ai = ui.length, {
    start: li
  } = yt, {
    end: oi
  } = yt, si = function(fi) {
    var gi = ui[fi];
    if (gi == null)
      return 1;
    var mi = gi, Ti, vi = () => (Ti === void 0 && (Ti = ir(gi, fi)), Ti);
    if (fi === ai - 1) {
      var xi = pt * (mi.coordinate + pt * vi() / 2 - oi);
      ui[fi] = mi = _objectSpread$7(_objectSpread$7({}, mi), {}, {
        tickCoord: xi > 0 ? mi.coordinate - xi * pt : mi.coordinate
      });
    } else
      ui[fi] = mi = _objectSpread$7(_objectSpread$7({}, mi), {}, {
        tickCoord: mi.coordinate
      });
    if (mi.tickCoord != null) {
      var Si = isVisible(pt, mi.tickCoord, vi, li, oi);
      Si && (oi = mi.tickCoord - pt * (vi() / 2 + ii), ui[fi] = _objectSpread$7(_objectSpread$7({}, mi), {}, {
        isShow: !0
      }));
    }
  }, di = ai - 1; di >= 0; di--)
    si(di);
  return ui;
}
function getTicksStart(pt, yt, ir, ti, ii, ui) {
  var ai = (ti || []).slice(), li = ai.length, {
    start: oi,
    end: si
  } = yt;
  if (ui) {
    var di = ti[li - 1];
    if (di != null) {
      var fi = ir(di, li - 1), gi = pt * (di.coordinate + pt * fi / 2 - si);
      if (ai[li - 1] = di = _objectSpread$7(_objectSpread$7({}, di), {}, {
        tickCoord: gi > 0 ? di.coordinate - gi * pt : di.coordinate
      }), di.tickCoord != null) {
        var mi = isVisible(pt, di.tickCoord, () => fi, oi, si);
        mi && (si = di.tickCoord - pt * (fi / 2 + ii), ai[li - 1] = _objectSpread$7(_objectSpread$7({}, di), {}, {
          isShow: !0
        }));
      }
    }
  }
  for (var Ti = ui ? li - 1 : li, vi = function(Si) {
    var Pi = ai[Si];
    if (Pi == null)
      return 1;
    var $i = Pi, Oi, Di = () => (Oi === void 0 && (Oi = ir(Pi, Si)), Oi);
    if (Si === 0) {
      var Mi = pt * ($i.coordinate - pt * Di() / 2 - oi);
      ai[Si] = $i = _objectSpread$7(_objectSpread$7({}, $i), {}, {
        tickCoord: Mi < 0 ? $i.coordinate - Mi * pt : $i.coordinate
      });
    } else
      ai[Si] = $i = _objectSpread$7(_objectSpread$7({}, $i), {}, {
        tickCoord: $i.coordinate
      });
    if ($i.tickCoord != null) {
      var Oo = isVisible(pt, $i.tickCoord, Di, oi, si);
      Oo && (oi = $i.tickCoord + pt * (Di() / 2 + ii), ai[Si] = _objectSpread$7(_objectSpread$7({}, $i), {}, {
        isShow: !0
      }));
    }
  }, xi = 0; xi < Ti; xi++)
    vi(xi);
  return ai;
}
function getTicks(pt, yt, ir) {
  var {
    tick: ti,
    ticks: ii,
    viewBox: ui,
    minTickGap: ai,
    orientation: li,
    interval: oi,
    tickFormatter: si,
    unit: di,
    angle: fi
  } = pt;
  if (!ii || !ii.length || !ti)
    return [];
  if (isNumber(oi) || Global.isSsr) {
    var gi;
    return (gi = getNumberIntervalTicks(ii, isNumber(oi) ? oi : 0)) !== null && gi !== void 0 ? gi : [];
  }
  var mi = [], Ti = li === "top" || li === "bottom" ? "width" : "height", vi = di && Ti === "width" ? getStringSize(di, {
    fontSize: yt,
    letterSpacing: ir
  }) : {
    width: 0,
    height: 0
  }, xi = (Di, Mi) => {
    var Oo = typeof si == "function" ? si(Di.value, Mi) : Di.value;
    return Ti === "width" ? getAngledTickWidth(getStringSize(Oo, {
      fontSize: yt,
      letterSpacing: ir
    }), vi, fi) : getStringSize(Oo, {
      fontSize: yt,
      letterSpacing: ir
    })[Ti];
  }, Si = ii[0], Pi = ii[1], $i = ii.length >= 2 && Si != null && Pi != null ? mathSign(Pi.coordinate - Si.coordinate) : 1, Oi = getTickBoundaries(ui, $i, Ti);
  return oi === "equidistantPreserveStart" ? getEquidistantTicks($i, Oi, xi, ii, ai) : oi === "equidistantPreserveEnd" ? getEquidistantPreserveEndTicks($i, Oi, xi, ii, ai) : (oi === "preserveStart" || oi === "preserveStartEnd" ? mi = getTicksStart($i, Oi, xi, ii, ai, oi === "preserveStartEnd") : mi = getTicksEnd($i, Oi, xi, ii, ai), mi.filter((Di) => Di.isShow));
}
var getCalculatedYAxisWidth = (pt) => {
  var {
    ticks: yt,
    label: ir,
    labelGapWithTick: ti = 5,
    // Default gap between label and tick
    tickSize: ii = 0,
    tickMargin: ui = 0
  } = pt, ai = 0;
  if (yt) {
    Array.from(yt).forEach((di) => {
      if (di) {
        var fi = di.getBoundingClientRect();
        fi.width > ai && (ai = fi.width);
      }
    });
    var li = ir ? ir.getBoundingClientRect().width : 0, oi = ii + ui, si = ai + oi + li + (ir ? ti : 0);
    return Math.round(si);
  }
  return 0;
}, initialState$3 = {
  xAxis: {},
  yAxis: {}
}, renderedTicksSlice = createSlice({
  name: "renderedTicks",
  initialState: initialState$3,
  reducers: {
    setRenderedTicks: (pt, yt) => {
      var {
        axisType: ir,
        axisId: ti,
        ticks: ii
      } = yt.payload;
      pt[ir][ti] = ii;
    },
    removeRenderedTicks: (pt, yt) => {
      var {
        axisType: ir,
        axisId: ti
      } = yt.payload;
      delete pt[ir][ti];
    }
  }
}), {
  setRenderedTicks,
  removeRenderedTicks
} = renderedTicksSlice.actions, renderedTicksReducer = renderedTicksSlice.reducer, _excluded$9 = ["axisLine", "width", "height", "className", "hide", "ticks", "axisType", "axisId"];
function _objectWithoutProperties$9(pt, yt) {
  if (pt == null) return {};
  var ir, ti, ii = _objectWithoutPropertiesLoose$9(pt, yt);
  if (Object.getOwnPropertySymbols) {
    var ui = Object.getOwnPropertySymbols(pt);
    for (ti = 0; ti < ui.length; ti++) ir = ui[ti], yt.indexOf(ir) === -1 && {}.propertyIsEnumerable.call(pt, ir) && (ii[ir] = pt[ir]);
  }
  return ii;
}
function _objectWithoutPropertiesLoose$9(pt, yt) {
  if (pt == null) return {};
  var ir = {};
  for (var ti in pt) if ({}.hasOwnProperty.call(pt, ti)) {
    if (yt.indexOf(ti) !== -1) continue;
    ir[ti] = pt[ti];
  }
  return ir;
}
function _extends$9() {
  return _extends$9 = Object.assign ? Object.assign.bind() : function(pt) {
    for (var yt = 1; yt < arguments.length; yt++) {
      var ir = arguments[yt];
      for (var ti in ir) ({}).hasOwnProperty.call(ir, ti) && (pt[ti] = ir[ti]);
    }
    return pt;
  }, _extends$9.apply(null, arguments);
}
function ownKeys$6(pt, yt) {
  var ir = Object.keys(pt);
  if (Object.getOwnPropertySymbols) {
    var ti = Object.getOwnPropertySymbols(pt);
    yt && (ti = ti.filter(function(ii) {
      return Object.getOwnPropertyDescriptor(pt, ii).enumerable;
    })), ir.push.apply(ir, ti);
  }
  return ir;
}
function _objectSpread$6(pt) {
  for (var yt = 1; yt < arguments.length; yt++) {
    var ir = arguments[yt] != null ? arguments[yt] : {};
    yt % 2 ? ownKeys$6(Object(ir), !0).forEach(function(ti) {
      _defineProperty$6(pt, ti, ir[ti]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(pt, Object.getOwnPropertyDescriptors(ir)) : ownKeys$6(Object(ir)).forEach(function(ti) {
      Object.defineProperty(pt, ti, Object.getOwnPropertyDescriptor(ir, ti));
    });
  }
  return pt;
}
function _defineProperty$6(pt, yt, ir) {
  return (yt = _toPropertyKey$6(yt)) in pt ? Object.defineProperty(pt, yt, { value: ir, enumerable: !0, configurable: !0, writable: !0 }) : pt[yt] = ir, pt;
}
function _toPropertyKey$6(pt) {
  var yt = _toPrimitive$6(pt, "string");
  return typeof yt == "symbol" ? yt : yt + "";
}
function _toPrimitive$6(pt, yt) {
  if (typeof pt != "object" || !pt) return pt;
  var ir = pt[Symbol.toPrimitive];
  if (ir !== void 0) {
    var ti = ir.call(pt, yt);
    if (typeof ti != "object") return ti;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (yt === "string" ? String : Number)(pt);
}
var defaultCartesianAxisProps = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  // The orientation of axis
  orientation: "bottom",
  // The ticks
  ticks: [],
  stroke: "#666",
  tickLine: !0,
  axisLine: !0,
  tick: !0,
  mirror: !1,
  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  tickMargin: 2,
  interval: "preserveEnd",
  zIndex: DefaultZIndexes.axis
};
function AxisLine(pt) {
  var {
    x: yt,
    y: ir,
    width: ti,
    height: ii,
    orientation: ui,
    mirror: ai,
    axisLine: li,
    otherSvgProps: oi
  } = pt;
  if (!li)
    return null;
  var si = _objectSpread$6(_objectSpread$6(_objectSpread$6({}, oi), svgPropertiesNoEvents(li)), {}, {
    fill: "none"
  });
  if (ui === "top" || ui === "bottom") {
    var di = +(ui === "top" && !ai || ui === "bottom" && ai);
    si = _objectSpread$6(_objectSpread$6({}, si), {}, {
      x1: yt,
      y1: ir + di * ii,
      x2: yt + ti,
      y2: ir + di * ii
    });
  } else {
    var fi = +(ui === "left" && !ai || ui === "right" && ai);
    si = _objectSpread$6(_objectSpread$6({}, si), {}, {
      x1: yt + fi * ti,
      y1: ir,
      x2: yt + fi * ti,
      y2: ir + ii
    });
  }
  return /* @__PURE__ */ React.createElement("line", _extends$9({}, si, {
    className: clsx$1("recharts-cartesian-axis-line", get$1(li, "className"))
  }));
}
function getTickLineCoord(pt, yt, ir, ti, ii, ui, ai, li, oi) {
  var si, di, fi, gi, mi, Ti, vi = li ? -1 : 1, xi = pt.tickSize || ai, Si = isNumber(pt.tickCoord) ? pt.tickCoord : pt.coordinate;
  switch (ui) {
    case "top":
      si = di = pt.coordinate, gi = ir + +!li * ii, fi = gi - vi * xi, Ti = fi - vi * oi, mi = Si;
      break;
    case "left":
      fi = gi = pt.coordinate, di = yt + +!li * ti, si = di - vi * xi, mi = si - vi * oi, Ti = Si;
      break;
    case "right":
      fi = gi = pt.coordinate, di = yt + +li * ti, si = di + vi * xi, mi = si + vi * oi, Ti = Si;
      break;
    default:
      si = di = pt.coordinate, gi = ir + +li * ii, fi = gi + vi * xi, Ti = fi + vi * oi, mi = Si;
      break;
  }
  return {
    line: {
      x1: si,
      y1: fi,
      x2: di,
      y2: gi
    },
    tick: {
      x: mi,
      y: Ti
    }
  };
}
function getTickTextAnchor(pt, yt) {
  switch (pt) {
    case "left":
      return yt ? "start" : "end";
    case "right":
      return yt ? "end" : "start";
    default:
      return "middle";
  }
}
function getTickVerticalAnchor(pt, yt) {
  switch (pt) {
    case "left":
    case "right":
      return "middle";
    case "top":
      return yt ? "start" : "end";
    default:
      return yt ? "end" : "start";
  }
}
function TickItem(pt) {
  var {
    option: yt,
    tickProps: ir,
    value: ti
  } = pt, ii, ui = clsx$1(ir.className, "recharts-cartesian-axis-tick-value");
  if (/* @__PURE__ */ React.isValidElement(yt))
    ii = /* @__PURE__ */ React.cloneElement(yt, _objectSpread$6(_objectSpread$6({}, ir), {}, {
      className: ui
    }));
  else if (typeof yt == "function")
    ii = yt(_objectSpread$6(_objectSpread$6({}, ir), {}, {
      className: ui
    }));
  else {
    var ai = "recharts-cartesian-axis-tick-value";
    typeof yt != "boolean" && (ai = clsx$1(ai, getClassNameFromUnknown(yt))), ii = /* @__PURE__ */ React.createElement(Text, _extends$9({}, ir, {
      className: ai
    }), ti);
  }
  return ii;
}
function RenderedTicksReporter(pt) {
  var {
    ticks: yt,
    axisType: ir,
    axisId: ti
  } = pt, ii = useAppDispatch();
  return useEffect(() => {
    if (ti == null || ir == null)
      return noop$2;
    var ui = yt.map((ai) => ({
      value: ai.value,
      coordinate: ai.coordinate,
      offset: ai.offset,
      index: ai.index
    }));
    return ii(setRenderedTicks({
      ticks: ui,
      axisId: ti,
      axisType: ir
    })), () => {
      ii(removeRenderedTicks({
        axisId: ti,
        axisType: ir
      }));
    };
  }, [ii, yt, ti, ir]), null;
}
var Ticks = /* @__PURE__ */ forwardRef((pt, yt) => {
  var {
    ticks: ir = [],
    tick: ti,
    tickLine: ii,
    stroke: ui,
    tickFormatter: ai,
    unit: li,
    padding: oi,
    tickTextProps: si,
    orientation: di,
    mirror: fi,
    x: gi,
    y: mi,
    width: Ti,
    height: vi,
    tickSize: xi,
    tickMargin: Si,
    fontSize: Pi,
    letterSpacing: $i,
    getTicksConfig: Oi,
    events: Di,
    axisType: Mi,
    axisId: Oo
  } = pt, io = getTicks(_objectSpread$6(_objectSpread$6({}, Oi), {}, {
    ticks: ir
  }), Pi, $i), xo = svgPropertiesNoEvents(Oi), fo = svgPropertiesNoEventsFromUnknown(ti), _o = isValidTextAnchor(xo.textAnchor) ? xo.textAnchor : getTickTextAnchor(di, fi), Li = getTickVerticalAnchor(di, fi), Co = {};
  typeof ii == "object" && (Co = ii);
  var Ni = _objectSpread$6(_objectSpread$6({}, xo), {}, {
    fill: "none"
  }, Co), Yi = io.map((Ui) => _objectSpread$6({
    entry: Ui
  }, getTickLineCoord(Ui, gi, mi, Ti, vi, di, xi, fi, Si))), Vo = Yi.map((Ui) => {
    var {
      entry: jo,
      line: Wi
    } = Ui;
    return /* @__PURE__ */ React.createElement(Layer, {
      className: "recharts-cartesian-axis-tick",
      key: "tick-".concat(jo.value, "-").concat(jo.coordinate, "-").concat(jo.tickCoord)
    }, ii && /* @__PURE__ */ React.createElement("line", _extends$9({}, Ni, Wi, {
      className: clsx$1("recharts-cartesian-axis-tick-line", get$1(ii, "className"))
    })));
  }), No = Yi.map((Ui, jo) => {
    var Wi, ji, {
      entry: Hi,
      tick: zo
    } = Ui, Lo = _objectSpread$6(_objectSpread$6(_objectSpread$6(_objectSpread$6({
      verticalAnchor: Li
    }, xo), {}, {
      textAnchor: _o,
      stroke: "none",
      fill: ui
    }, zo), {}, {
      index: jo,
      payload: Hi,
      visibleTicksCount: io.length,
      tickFormatter: ai,
      padding: oi
    }, si), {}, {
      angle: (Wi = (ji = si == null ? void 0 : si.angle) !== null && ji !== void 0 ? ji : xo.angle) !== null && Wi !== void 0 ? Wi : 0
    }), sa = _objectSpread$6(_objectSpread$6({}, Lo), fo);
    return /* @__PURE__ */ React.createElement(Layer, _extends$9({
      className: "recharts-cartesian-axis-tick-label",
      key: "tick-label-".concat(Hi.value, "-").concat(Hi.coordinate, "-").concat(Hi.tickCoord)
    }, adaptEventsOfChild(Di, Hi, jo)), ti && /* @__PURE__ */ React.createElement(TickItem, {
      option: ti,
      tickProps: sa,
      value: "".concat(typeof ai == "function" ? ai(Hi.value, jo) : Hi.value).concat(li || "")
    }));
  });
  return /* @__PURE__ */ React.createElement("g", {
    className: "recharts-cartesian-axis-ticks recharts-".concat(Mi, "-ticks")
  }, /* @__PURE__ */ React.createElement(RenderedTicksReporter, {
    ticks: io,
    axisId: Oo,
    axisType: Mi
  }), No.length > 0 && /* @__PURE__ */ React.createElement(ZIndexLayer, {
    zIndex: DefaultZIndexes.label
  }, /* @__PURE__ */ React.createElement("g", {
    className: "recharts-cartesian-axis-tick-labels recharts-".concat(Mi, "-tick-labels"),
    ref: yt
  }, No)), Vo.length > 0 && /* @__PURE__ */ React.createElement("g", {
    className: "recharts-cartesian-axis-tick-lines recharts-".concat(Mi, "-tick-lines")
  }, Vo));
}), CartesianAxisComponent = /* @__PURE__ */ forwardRef((pt, yt) => {
  var {
    axisLine: ir,
    width: ti,
    height: ii,
    className: ui,
    hide: ai,
    ticks: li,
    axisType: oi,
    axisId: si
  } = pt, di = _objectWithoutProperties$9(pt, _excluded$9), [fi, gi] = useState(""), [mi, Ti] = useState(""), vi = useRef(null);
  useImperativeHandle(yt, () => ({
    getCalculatedWidth: () => {
      var Si;
      return getCalculatedYAxisWidth({
        ticks: vi.current,
        label: (Si = pt.labelRef) === null || Si === void 0 ? void 0 : Si.current,
        labelGapWithTick: 5,
        tickSize: pt.tickSize,
        tickMargin: pt.tickMargin
      });
    }
  }));
  var xi = useCallback((Si) => {
    if (Si) {
      var Pi = Si.getElementsByClassName("recharts-cartesian-axis-tick-value");
      vi.current = Pi;
      var $i = Pi[0];
      if ($i) {
        var Oi = window.getComputedStyle($i), Di = Oi.fontSize, Mi = Oi.letterSpacing;
        (Di !== fi || Mi !== mi) && (gi(Di), Ti(Mi));
      }
    }
  }, [fi, mi]);
  return ai || ti != null && ti <= 0 || ii != null && ii <= 0 ? null : /* @__PURE__ */ React.createElement(ZIndexLayer, {
    zIndex: pt.zIndex
  }, /* @__PURE__ */ React.createElement(Layer, {
    className: clsx$1("recharts-cartesian-axis", ui)
  }, /* @__PURE__ */ React.createElement(AxisLine, {
    x: pt.x,
    y: pt.y,
    width: ti,
    height: ii,
    orientation: pt.orientation,
    mirror: pt.mirror,
    axisLine: ir,
    otherSvgProps: svgPropertiesNoEvents(pt)
  }), /* @__PURE__ */ React.createElement(Ticks, {
    ref: xi,
    axisType: oi,
    events: di,
    fontSize: fi,
    getTicksConfig: pt,
    height: pt.height,
    letterSpacing: mi,
    mirror: pt.mirror,
    orientation: pt.orientation,
    padding: pt.padding,
    stroke: pt.stroke,
    tick: pt.tick,
    tickFormatter: pt.tickFormatter,
    tickLine: pt.tickLine,
    tickMargin: pt.tickMargin,
    tickSize: pt.tickSize,
    tickTextProps: pt.tickTextProps,
    ticks: li,
    unit: pt.unit,
    width: pt.width,
    x: pt.x,
    y: pt.y,
    axisId: si
  }), /* @__PURE__ */ React.createElement(CartesianLabelContextProvider, {
    x: pt.x,
    y: pt.y,
    width: pt.width,
    height: pt.height,
    lowerWidth: pt.width,
    upperWidth: pt.width
  }, /* @__PURE__ */ React.createElement(CartesianLabelFromLabelProp, {
    label: pt.label,
    labelRef: pt.labelRef
  }), pt.children)));
}), CartesianAxis = /* @__PURE__ */ React.forwardRef((pt, yt) => {
  var ir = resolveDefaultProps(pt, defaultCartesianAxisProps);
  return /* @__PURE__ */ React.createElement(CartesianAxisComponent, _extends$9({}, ir, {
    ref: yt
  }));
});
CartesianAxis.displayName = "CartesianAxis";
var initialState$2 = {}, errorBarSlice = createSlice({
  name: "errorBars",
  initialState: initialState$2,
  reducers: {
    addErrorBar: (pt, yt) => {
      var {
        itemId: ir,
        errorBar: ti
      } = yt.payload;
      pt[ir] || (pt[ir] = []), pt[ir].push(ti);
    },
    replaceErrorBar: (pt, yt) => {
      var {
        itemId: ir,
        prev: ti,
        next: ii
      } = yt.payload;
      pt[ir] && (pt[ir] = pt[ir].map((ui) => ui.dataKey === ti.dataKey && ui.direction === ti.direction ? ii : ui));
    },
    removeErrorBar: (pt, yt) => {
      var {
        itemId: ir,
        errorBar: ti
      } = yt.payload;
      pt[ir] && (pt[ir] = pt[ir].filter((ii) => ii.dataKey !== ti.dataKey || ii.direction !== ti.direction));
    }
  }
}), {
  addErrorBar,
  replaceErrorBar,
  removeErrorBar
} = errorBarSlice.actions, errorBarReducer = errorBarSlice.reducer, _excluded$7 = ["children"];
function _objectWithoutProperties$7(pt, yt) {
  if (pt == null) return {};
  var ir, ti, ii = _objectWithoutPropertiesLoose$7(pt, yt);
  if (Object.getOwnPropertySymbols) {
    var ui = Object.getOwnPropertySymbols(pt);
    for (ti = 0; ti < ui.length; ti++) ir = ui[ti], yt.indexOf(ir) === -1 && {}.propertyIsEnumerable.call(pt, ir) && (ii[ir] = pt[ir]);
  }
  return ii;
}
function _objectWithoutPropertiesLoose$7(pt, yt) {
  if (pt == null) return {};
  var ir = {};
  for (var ti in pt) if ({}.hasOwnProperty.call(pt, ti)) {
    if (yt.indexOf(ti) !== -1) continue;
    ir[ti] = pt[ti];
  }
  return ir;
}
var initialContextState = {
  data: [],
  xAxisId: "xAxis-0",
  yAxisId: "yAxis-0",
  dataPointFormatter: () => ({
    x: 0,
    y: 0,
    value: 0
  }),
  errorBarOffset: 0
}, ErrorBarContext = /* @__PURE__ */ createContext(initialContextState);
function SetErrorBarContext(pt) {
  var {
    children: yt
  } = pt, ir = _objectWithoutProperties$7(pt, _excluded$7);
  return /* @__PURE__ */ React.createElement(ErrorBarContext.Provider, {
    value: ir
  }, yt);
}
function useNeedsClip(pt, yt) {
  var ir, ti, ii = useAppSelector((si) => selectXAxisSettings(si, pt)), ui = useAppSelector((si) => selectYAxisSettings(si, yt)), ai = (ir = ii == null ? void 0 : ii.allowDataOverflow) !== null && ir !== void 0 ? ir : implicitXAxis.allowDataOverflow, li = (ti = ui == null ? void 0 : ui.allowDataOverflow) !== null && ti !== void 0 ? ti : implicitYAxis.allowDataOverflow, oi = ai || li;
  return {
    needClip: oi,
    needClipX: ai,
    needClipY: li
  };
}
function GraphicalItemClipPath(pt) {
  var {
    xAxisId: yt,
    yAxisId: ir,
    clipPathId: ti
  } = pt, ii = usePlotArea(), {
    needClipX: ui,
    needClipY: ai,
    needClip: li
  } = useNeedsClip(yt, ir);
  if (!li || !ii)
    return null;
  var {
    x: oi,
    y: si,
    width: di,
    height: fi
  } = ii;
  return /* @__PURE__ */ React.createElement("clipPath", {
    id: "clipPath-".concat(ti)
  }, /* @__PURE__ */ React.createElement("rect", {
    x: ui ? oi : oi - di / 2,
    y: ai ? si : si - fi / 2,
    width: ui ? di : di * 2,
    height: ai ? fi : fi * 2
  }));
}
function selectXAxisIdFromGraphicalItemId(pt, yt) {
  var ir, ti;
  return (ir = (ti = pt.graphicalItems.cartesianItems.find((ii) => ii.id === yt)) === null || ti === void 0 ? void 0 : ti.xAxisId) !== null && ir !== void 0 ? ir : defaultAxisId;
}
function selectYAxisIdFromGraphicalItemId(pt, yt) {
  var ir, ti;
  return (ir = (ti = pt.graphicalItems.cartesianItems.find((ii) => ii.id === yt)) === null || ti === void 0 ? void 0 : ti.yAxisId) !== null && ir !== void 0 ? ir : defaultAxisId;
}
var isProduction = process.env.NODE_ENV === "production", prefix$3 = "Invariant failed";
function invariant(pt, yt) {
  if (isProduction)
    throw new Error(prefix$3);
  var ir = typeof yt == "function" ? yt() : yt, ti = ir ? "".concat(prefix$3, ": ").concat(ir) : prefix$3;
  throw new Error(ti);
}
function _extends$7() {
  return _extends$7 = Object.assign ? Object.assign.bind() : function(pt) {
    for (var yt = 1; yt < arguments.length; yt++) {
      var ir = arguments[yt];
      for (var ti in ir) ({}).hasOwnProperty.call(ir, ti) && (pt[ti] = ir[ti]);
    }
    return pt;
  }, _extends$7.apply(null, arguments);
}
function BarRectangle(pt) {
  return /* @__PURE__ */ React.createElement(Shape, _extends$7({
    shapeType: "rectangle",
    activeClassName: "recharts-active-bar",
    inActiveClassName: "recharts-inactive-bar"
  }, pt));
}
var minPointSizeCallback = function(pt) {
  var yt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return (ir, ti) => {
    if (isNumber(pt)) return pt;
    var ii = isNumber(ir) || isNullish(ir);
    return ii ? pt(ir, ti) : (ii || invariant(!1, "minPointSize callback function received a value with type of ".concat(typeof ir, ". Currently only numbers or null/undefined are supported.")), yt);
  };
}, pickIsPanorama = (pt, yt, ir) => ir, pickBarId = (pt, yt) => yt, selectSynchronisedBarSettings = createSelector([selectUnfilteredCartesianItems, pickBarId], (pt, yt) => pt.filter((ir) => ir.type === "bar").find((ir) => ir.id === yt)), selectMaxBarSize = createSelector([selectSynchronisedBarSettings], (pt) => pt == null ? void 0 : pt.maxBarSize), pickCells = (pt, yt, ir, ti) => ti, selectAllVisibleBars = createSelector([selectChartLayout, selectUnfilteredCartesianItems, selectXAxisIdFromGraphicalItemId, selectYAxisIdFromGraphicalItemId, pickIsPanorama], (pt, yt, ir, ti, ii) => yt.filter((ui) => pt === "horizontal" ? ui.xAxisId === ir : ui.yAxisId === ti).filter((ui) => ui.isPanorama === ii).filter((ui) => ui.hide === !1).filter((ui) => ui.type === "bar")), selectBarStackGroups = (pt, yt, ir) => {
  var ti = selectChartLayout(pt), ii = selectXAxisIdFromGraphicalItemId(pt, yt), ui = selectYAxisIdFromGraphicalItemId(pt, yt);
  if (!(ii == null || ui == null))
    return ti === "horizontal" ? selectStackGroups(pt, "yAxis", ui, ir) : selectStackGroups(pt, "xAxis", ii, ir);
}, selectBarCartesianAxisSize = (pt, yt) => {
  var ir = selectChartLayout(pt), ti = selectXAxisIdFromGraphicalItemId(pt, yt), ii = selectYAxisIdFromGraphicalItemId(pt, yt);
  if (!(ti == null || ii == null))
    return ir === "horizontal" ? selectCartesianAxisSize(pt, "xAxis", ti) : selectCartesianAxisSize(pt, "yAxis", ii);
}, selectBarSizeList = createSelector([selectAllVisibleBars, selectRootBarSize, selectBarCartesianAxisSize], combineBarSizeList), selectBarBandSize = (pt, yt, ir) => {
  var ti, ii, ui = selectSynchronisedBarSettings(pt, yt);
  if (ui == null)
    return 0;
  var ai = selectXAxisIdFromGraphicalItemId(pt, yt), li = selectYAxisIdFromGraphicalItemId(pt, yt);
  if (ai == null || li == null)
    return 0;
  var oi = selectChartLayout(pt), si = selectRootMaxBarSize(pt), {
    maxBarSize: di
  } = ui, fi = isNullish(di) ? si : di, gi, mi;
  return oi === "horizontal" ? (gi = selectAxisWithScale(pt, "xAxis", ai, ir), mi = selectTicksOfGraphicalItem(pt, "xAxis", ai, ir)) : (gi = selectAxisWithScale(pt, "yAxis", li, ir), mi = selectTicksOfGraphicalItem(pt, "yAxis", li, ir)), (ti = (ii = getBandSizeOfAxis(gi, mi, !0)) !== null && ii !== void 0 ? ii : fi) !== null && ti !== void 0 ? ti : 0;
}, selectAxisBandSize = (pt, yt, ir) => {
  var ti = selectChartLayout(pt), ii = selectXAxisIdFromGraphicalItemId(pt, yt), ui = selectYAxisIdFromGraphicalItemId(pt, yt);
  if (!(ii == null || ui == null)) {
    var ai, li;
    return ti === "horizontal" ? (ai = selectAxisWithScale(pt, "xAxis", ii, ir), li = selectTicksOfGraphicalItem(pt, "xAxis", ii, ir)) : (ai = selectAxisWithScale(pt, "yAxis", ui, ir), li = selectTicksOfGraphicalItem(pt, "yAxis", ui, ir)), getBandSizeOfAxis(ai, li);
  }
}, selectAllBarPositions = createSelector([selectBarSizeList, selectRootMaxBarSize, selectBarGap, selectBarCategoryGap, selectBarBandSize, selectAxisBandSize, selectMaxBarSize], combineAllBarPositions), selectXAxisWithScale = (pt, yt, ir) => {
  var ti = selectXAxisIdFromGraphicalItemId(pt, yt);
  if (ti != null)
    return selectAxisWithScale(pt, "xAxis", ti, ir);
}, selectYAxisWithScale = (pt, yt, ir) => {
  var ti = selectYAxisIdFromGraphicalItemId(pt, yt);
  if (ti != null)
    return selectAxisWithScale(pt, "yAxis", ti, ir);
}, selectXAxisTicks = (pt, yt, ir) => {
  var ti = selectXAxisIdFromGraphicalItemId(pt, yt);
  if (ti != null)
    return selectTicksOfGraphicalItem(pt, "xAxis", ti, ir);
}, selectYAxisTicks = (pt, yt, ir) => {
  var ti = selectYAxisIdFromGraphicalItemId(pt, yt);
  if (ti != null)
    return selectTicksOfGraphicalItem(pt, "yAxis", ti, ir);
}, selectBarPosition = createSelector([selectAllBarPositions, selectSynchronisedBarSettings], combineBarPosition), selectStackedDataOfItem = createSelector([selectBarStackGroups, selectSynchronisedBarSettings], combineStackedData), selectBarRectangles = createSelector([selectChartOffsetInternal, selectAxisViewBox, selectXAxisWithScale, selectYAxisWithScale, selectXAxisTicks, selectYAxisTicks, selectBarPosition, selectChartLayout, selectChartDataWithIndexesIfNotInPanoramaPosition3, selectAxisBandSize, selectStackedDataOfItem, selectSynchronisedBarSettings, pickCells], (pt, yt, ir, ti, ii, ui, ai, li, oi, si, di, fi, gi) => {
  var {
    chartData: mi,
    dataStartIndex: Ti,
    dataEndIndex: vi
  } = oi;
  if (!(fi == null || ai == null || yt == null || li !== "horizontal" && li !== "vertical" || ir == null || ti == null || ii == null || ui == null || si == null)) {
    var {
      data: xi
    } = fi, Si;
    if (xi != null && xi.length > 0 ? Si = xi : Si = mi == null ? void 0 : mi.slice(Ti, vi + 1), Si != null)
      return computeBarRectangles({
        layout: li,
        barSettings: fi,
        pos: ai,
        parentViewBox: yt,
        bandSize: si,
        xAxis: ir,
        yAxis: ti,
        xAxisTicks: ii,
        yAxisTicks: ui,
        stackedData: di,
        displayedData: Si,
        offset: pt,
        cells: gi,
        dataStartIndex: Ti
      });
  }
}), _excluded$6 = ["index"];
function _extends$6() {
  return _extends$6 = Object.assign ? Object.assign.bind() : function(pt) {
    for (var yt = 1; yt < arguments.length; yt++) {
      var ir = arguments[yt];
      for (var ti in ir) ({}).hasOwnProperty.call(ir, ti) && (pt[ti] = ir[ti]);
    }
    return pt;
  }, _extends$6.apply(null, arguments);
}
function _objectWithoutProperties$6(pt, yt) {
  if (pt == null) return {};
  var ir, ti, ii = _objectWithoutPropertiesLoose$6(pt, yt);
  if (Object.getOwnPropertySymbols) {
    var ui = Object.getOwnPropertySymbols(pt);
    for (ti = 0; ti < ui.length; ti++) ir = ui[ti], yt.indexOf(ir) === -1 && {}.propertyIsEnumerable.call(pt, ir) && (ii[ir] = pt[ir]);
  }
  return ii;
}
function _objectWithoutPropertiesLoose$6(pt, yt) {
  if (pt == null) return {};
  var ir = {};
  for (var ti in pt) if ({}.hasOwnProperty.call(pt, ti)) {
    if (yt.indexOf(ti) !== -1) continue;
    ir[ti] = pt[ti];
  }
  return ir;
}
var BarStackContext = /* @__PURE__ */ createContext(void 0), useStackId = (pt) => {
  var yt = useContext(BarStackContext);
  if (yt != null)
    return yt.stackId;
  if (pt != null)
    return getNormalizedStackId(pt);
}, getClipPathId = (pt, yt) => "recharts-bar-stack-clip-path-".concat(pt, "-").concat(yt), useBarStackClipPathUrl = (pt) => {
  var yt = useContext(BarStackContext);
  if (yt != null) {
    var {
      stackId: ir
    } = yt;
    return "url(#".concat(getClipPathId(ir, pt), ")");
  }
}, BarStackClipLayer = (pt) => {
  var {
    index: yt
  } = pt, ir = _objectWithoutProperties$6(pt, _excluded$6), ti = useBarStackClipPathUrl(yt);
  return /* @__PURE__ */ React.createElement(Layer, _extends$6({
    className: "recharts-bar-stack-layer",
    clipPath: ti
  }, ir));
}, _excluded$5 = ["onMouseEnter", "onMouseLeave", "onClick"], _excluded2$3 = ["value", "background", "tooltipPosition"], _excluded3$2 = ["id"], _excluded4 = ["onMouseEnter", "onClick", "onMouseLeave"];
function _extends$5() {
  return _extends$5 = Object.assign ? Object.assign.bind() : function(pt) {
    for (var yt = 1; yt < arguments.length; yt++) {
      var ir = arguments[yt];
      for (var ti in ir) ({}).hasOwnProperty.call(ir, ti) && (pt[ti] = ir[ti]);
    }
    return pt;
  }, _extends$5.apply(null, arguments);
}
function ownKeys$4(pt, yt) {
  var ir = Object.keys(pt);
  if (Object.getOwnPropertySymbols) {
    var ti = Object.getOwnPropertySymbols(pt);
    yt && (ti = ti.filter(function(ii) {
      return Object.getOwnPropertyDescriptor(pt, ii).enumerable;
    })), ir.push.apply(ir, ti);
  }
  return ir;
}
function _objectSpread$4(pt) {
  for (var yt = 1; yt < arguments.length; yt++) {
    var ir = arguments[yt] != null ? arguments[yt] : {};
    yt % 2 ? ownKeys$4(Object(ir), !0).forEach(function(ti) {
      _defineProperty$4(pt, ti, ir[ti]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(pt, Object.getOwnPropertyDescriptors(ir)) : ownKeys$4(Object(ir)).forEach(function(ti) {
      Object.defineProperty(pt, ti, Object.getOwnPropertyDescriptor(ir, ti));
    });
  }
  return pt;
}
function _defineProperty$4(pt, yt, ir) {
  return (yt = _toPropertyKey$4(yt)) in pt ? Object.defineProperty(pt, yt, { value: ir, enumerable: !0, configurable: !0, writable: !0 }) : pt[yt] = ir, pt;
}
function _toPropertyKey$4(pt) {
  var yt = _toPrimitive$4(pt, "string");
  return typeof yt == "symbol" ? yt : yt + "";
}
function _toPrimitive$4(pt, yt) {
  if (typeof pt != "object" || !pt) return pt;
  var ir = pt[Symbol.toPrimitive];
  if (ir !== void 0) {
    var ti = ir.call(pt, yt);
    if (typeof ti != "object") return ti;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (yt === "string" ? String : Number)(pt);
}
function _objectWithoutProperties$5(pt, yt) {
  if (pt == null) return {};
  var ir, ti, ii = _objectWithoutPropertiesLoose$5(pt, yt);
  if (Object.getOwnPropertySymbols) {
    var ui = Object.getOwnPropertySymbols(pt);
    for (ti = 0; ti < ui.length; ti++) ir = ui[ti], yt.indexOf(ir) === -1 && {}.propertyIsEnumerable.call(pt, ir) && (ii[ir] = pt[ir]);
  }
  return ii;
}
function _objectWithoutPropertiesLoose$5(pt, yt) {
  if (pt == null) return {};
  var ir = {};
  for (var ti in pt) if ({}.hasOwnProperty.call(pt, ti)) {
    if (yt.indexOf(ti) !== -1) continue;
    ir[ti] = pt[ti];
  }
  return ir;
}
var computeLegendPayloadFromBarData = (pt) => {
  var {
    dataKey: yt,
    name: ir,
    fill: ti,
    legendType: ii,
    hide: ui
  } = pt;
  return [{
    inactive: ui,
    dataKey: yt,
    type: ii,
    color: ti,
    value: getTooltipNameProp(ir, yt),
    payload: pt
  }];
}, SetBarTooltipEntrySettings = /* @__PURE__ */ React.memo((pt) => {
  var {
    dataKey: yt,
    stroke: ir,
    strokeWidth: ti,
    fill: ii,
    name: ui,
    hide: ai,
    unit: li,
    tooltipType: oi,
    id: si
  } = pt, di = {
    dataDefinedOnItem: void 0,
    getPosition: noop$2,
    settings: {
      stroke: ir,
      strokeWidth: ti,
      fill: ii,
      dataKey: yt,
      nameKey: void 0,
      name: getTooltipNameProp(ui, yt),
      hide: ai,
      type: oi,
      color: ii,
      unit: li,
      graphicalItemId: si
    }
  };
  return /* @__PURE__ */ React.createElement(SetTooltipEntrySettings, {
    tooltipEntrySettings: di
  });
});
function BarBackground(pt) {
  var yt = useAppSelector(selectActiveTooltipIndex), {
    data: ir,
    dataKey: ti,
    background: ii,
    allOtherBarProps: ui
  } = pt, {
    onMouseEnter: ai,
    onMouseLeave: li,
    onClick: oi
  } = ui, si = _objectWithoutProperties$5(ui, _excluded$5), di = useMouseEnterItemDispatch(ai, ti, ui.id), fi = useMouseLeaveItemDispatch(li), gi = useMouseClickItemDispatch(oi, ti, ui.id);
  if (!ii || ir == null)
    return null;
  var mi = svgPropertiesNoEventsFromUnknown(ii);
  return /* @__PURE__ */ React.createElement(ZIndexLayer, {
    zIndex: getZIndexFromUnknown(ii, DefaultZIndexes.barBackground)
  }, ir.map((Ti, vi) => {
    var {
      value: xi,
      background: Si,
      tooltipPosition: Pi
    } = Ti, $i = _objectWithoutProperties$5(Ti, _excluded2$3);
    if (!Si)
      return null;
    var Oi = di(Ti, vi), Di = fi(Ti, vi), Mi = gi(Ti, vi), Oo = _objectSpread$4(_objectSpread$4(_objectSpread$4(_objectSpread$4(_objectSpread$4({
      option: ii,
      isActive: String(vi) === yt
    }, $i), {}, {
      // @ts-expect-error backgroundProps is contributing unknown props
      fill: "#eee"
    }, Si), mi), adaptEventsOfChild(si, Ti, vi)), {}, {
      onMouseEnter: Oi,
      onMouseLeave: Di,
      onClick: Mi,
      dataKey: ti,
      index: vi,
      className: "recharts-bar-background-rectangle"
    });
    return /* @__PURE__ */ React.createElement(BarRectangle, _extends$5({
      key: "background-bar-".concat(vi)
    }, Oo));
  }));
}
function BarLabelListProvider(pt) {
  var {
    showLabels: yt,
    children: ir,
    rects: ti
  } = pt, ii = ti == null ? void 0 : ti.map((ui) => {
    var ai = {
      x: ui.x,
      y: ui.y,
      width: ui.width,
      lowerWidth: ui.width,
      upperWidth: ui.width,
      height: ui.height
    };
    return _objectSpread$4(_objectSpread$4({}, ai), {}, {
      value: ui.value,
      payload: ui.payload,
      parentViewBox: ui.parentViewBox,
      viewBox: ai,
      fill: ui.fill
    });
  });
  return /* @__PURE__ */ React.createElement(CartesianLabelListContextProvider, {
    value: yt ? ii : void 0
  }, ir);
}
function BarRectangleWithActiveState(pt) {
  var {
    shape: yt,
    activeBar: ir,
    baseProps: ti,
    entry: ii,
    index: ui,
    dataKey: ai
  } = pt, li = useAppSelector(selectActiveTooltipIndex), oi = useAppSelector(selectActiveTooltipDataKey), si = ir && String(ii.originalDataIndex) === li && (oi == null || ai === oi), [di, fi] = useState(!1), [gi, mi] = useState(!1);
  useEffect(() => {
    var $i;
    return si ? (fi(!0), $i = requestAnimationFrame(() => {
      mi(!0);
    })) : mi(!1), () => {
      cancelAnimationFrame($i);
    };
  }, [si]);
  var Ti = useCallback(() => {
    si || fi(!1);
  }, [si]), vi = si && gi, xi = si || di, Si;
  si ? ir === !0 ? Si = yt : Si = ir : Si = yt;
  var Pi = /* @__PURE__ */ React.createElement(BarRectangle, _extends$5({}, ti, {
    name: String(ti.name)
  }, ii, {
    isActive: vi,
    option: Si,
    index: ui,
    dataKey: ai,
    onTransitionEnd: Ti
  }));
  return xi ? /* @__PURE__ */ React.createElement(ZIndexLayer, {
    zIndex: DefaultZIndexes.activeBar
  }, /* @__PURE__ */ React.createElement(BarStackClipLayer, {
    index: ii.originalDataIndex
  }, Pi)) : Pi;
}
function BarRectangleNeverActive(pt) {
  var {
    shape: yt,
    baseProps: ir,
    entry: ti,
    index: ii,
    dataKey: ui
  } = pt;
  return /* @__PURE__ */ React.createElement(BarRectangle, _extends$5({}, ir, {
    name: String(ir.name)
  }, ti, {
    isActive: !1,
    option: yt,
    index: ii,
    dataKey: ui
  }));
}
function BarRectangles(pt) {
  var yt, {
    data: ir,
    props: ti
  } = pt, ii = (yt = svgPropertiesNoEvents(ti)) !== null && yt !== void 0 ? yt : {}, {
    id: ui
  } = ii, ai = _objectWithoutProperties$5(ii, _excluded3$2), {
    shape: li,
    dataKey: oi,
    activeBar: si
  } = ti, {
    onMouseEnter: di,
    onClick: fi,
    onMouseLeave: gi
  } = ti, mi = _objectWithoutProperties$5(ti, _excluded4), Ti = useMouseEnterItemDispatch(di, oi, ui), vi = useMouseLeaveItemDispatch(gi), xi = useMouseClickItemDispatch(fi, oi, ui);
  return ir ? /* @__PURE__ */ React.createElement(React.Fragment, null, ir.map((Si, Pi) => /* @__PURE__ */ React.createElement(BarStackClipLayer, _extends$5({
    index: Si.originalDataIndex,
    key: "rectangle-".concat(Si == null ? void 0 : Si.x, "-").concat(Si == null ? void 0 : Si.y, "-").concat(Si == null ? void 0 : Si.value, "-").concat(Pi),
    className: "recharts-bar-rectangle"
  }, adaptEventsOfChild(mi, Si, Pi), {
    onMouseEnter: Ti(Si, Pi),
    onMouseLeave: vi(Si, Pi),
    onClick: xi(Si, Pi)
  }), si ? /* @__PURE__ */ React.createElement(BarRectangleWithActiveState, {
    shape: li,
    activeBar: si,
    baseProps: ai,
    entry: Si,
    index: Pi,
    dataKey: oi
  }) : (
    /*
     * If the `activeBar` prop is falsy, then let's call the variant without hooks.
     * Using the `selectActiveTooltipIndex` selector is usually fast
     * but in charts with large-ish amount of data even the few nanoseconds add up to a noticeable jank.
     * If the activeBar is false then we don't need to know which index is active - because we won't use it anyway.
     * So let's just skip the hooks altogether. That way, React can skip rendering the component,
     * and can skip the tree reconciliation for its children too.
     * Because we can't call hooks conditionally, we need to have a separate component for that.
     */
    /* @__PURE__ */ React.createElement(BarRectangleNeverActive, {
      shape: li,
      baseProps: ai,
      entry: Si,
      index: Pi,
      dataKey: oi
    })
  )))) : null;
}
function RectanglesWithAnimation(pt) {
  var {
    props: yt,
    previousRectanglesRef: ir
  } = pt, {
    data: ti,
    layout: ii,
    isAnimationActive: ui,
    animationBegin: ai,
    animationDuration: li,
    animationEasing: oi,
    onAnimationEnd: si,
    onAnimationStart: di
  } = yt, fi = ir.current, gi = useAnimationId(yt, "recharts-bar-"), [mi, Ti] = useState(!1), vi = !mi, xi = useCallback(() => {
    typeof si == "function" && si(), Ti(!1);
  }, [si]), Si = useCallback(() => {
    typeof di == "function" && di(), Ti(!0);
  }, [di]);
  return /* @__PURE__ */ React.createElement(BarLabelListProvider, {
    showLabels: vi,
    rects: ti
  }, /* @__PURE__ */ React.createElement(JavascriptAnimate, {
    animationId: gi,
    begin: ai,
    duration: li,
    isActive: ui,
    easing: oi,
    onAnimationEnd: xi,
    onAnimationStart: Si,
    key: gi
  }, (Pi) => {
    var $i = Pi === 1 ? ti : ti == null ? void 0 : ti.map((Oi, Di) => {
      var Mi = fi && fi[Di];
      if (Mi)
        return _objectSpread$4(_objectSpread$4({}, Oi), {}, {
          x: interpolate$1(Mi.x, Oi.x, Pi),
          y: interpolate$1(Mi.y, Oi.y, Pi),
          width: interpolate$1(Mi.width, Oi.width, Pi),
          height: interpolate$1(Mi.height, Oi.height, Pi)
        });
      if (ii === "horizontal") {
        var Oo = interpolate$1(0, Oi.height, Pi), io = interpolate$1(Oi.stackedBarStart, Oi.y, Pi);
        return _objectSpread$4(_objectSpread$4({}, Oi), {}, {
          y: io,
          height: Oo
        });
      }
      var xo = interpolate$1(0, Oi.width, Pi), fo = interpolate$1(Oi.stackedBarStart, Oi.x, Pi);
      return _objectSpread$4(_objectSpread$4({}, Oi), {}, {
        width: xo,
        x: fo
      });
    });
    return Pi > 0 && (ir.current = $i ?? null), $i == null ? null : /* @__PURE__ */ React.createElement(Layer, null, /* @__PURE__ */ React.createElement(BarRectangles, {
      props: yt,
      data: $i
    }));
  }), /* @__PURE__ */ React.createElement(LabelListFromLabelProp, {
    label: yt.label
  }), yt.children);
}
function RenderRectangles(pt) {
  var yt = useRef(null);
  return /* @__PURE__ */ React.createElement(RectanglesWithAnimation, {
    previousRectanglesRef: yt,
    props: pt
  });
}
var defaultMinPointSize = 0, errorBarDataPointFormatter = (pt, yt) => {
  var ir = Array.isArray(pt.value) ? pt.value[1] : pt.value;
  return {
    x: pt.x,
    y: pt.y,
    value: ir,
    // getValueByDataKey does not validate the output type
    errorVal: getValueByDataKey(pt, yt)
  };
};
class BarWithState extends PureComponent {
  render() {
    var {
      hide: yt,
      data: ir,
      dataKey: ti,
      className: ii,
      xAxisId: ui,
      yAxisId: ai,
      needClip: li,
      background: oi,
      id: si
    } = this.props;
    if (yt || ir == null)
      return null;
    var di = clsx$1("recharts-bar", ii), fi = si;
    return /* @__PURE__ */ React.createElement(Layer, {
      className: di,
      id: si
    }, li && /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement(GraphicalItemClipPath, {
      clipPathId: fi,
      xAxisId: ui,
      yAxisId: ai
    })), /* @__PURE__ */ React.createElement(Layer, {
      className: "recharts-bar-rectangles",
      clipPath: li ? "url(#clipPath-".concat(fi, ")") : void 0
    }, /* @__PURE__ */ React.createElement(BarBackground, {
      data: ir,
      dataKey: ti,
      background: oi,
      allOtherBarProps: this.props
    }), /* @__PURE__ */ React.createElement(RenderRectangles, this.props)));
  }
}
var defaultBarProps = {
  activeBar: !1,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "ease",
  background: !1,
  hide: !1,
  isAnimationActive: "auto",
  label: !1,
  legendType: "rect",
  minPointSize: defaultMinPointSize,
  xAxisId: 0,
  yAxisId: 0,
  zIndex: DefaultZIndexes.bar
};
function BarImpl(pt) {
  var {
    xAxisId: yt,
    yAxisId: ir,
    hide: ti,
    legendType: ii,
    minPointSize: ui,
    activeBar: ai,
    animationBegin: li,
    animationDuration: oi,
    animationEasing: si,
    isAnimationActive: di
  } = pt, {
    needClip: fi
  } = useNeedsClip(yt, ir), gi = useChartLayout(), mi = useIsPanorama(), Ti = findAllByType(pt.children, Cell), vi = useAppSelector((Pi) => selectBarRectangles(Pi, pt.id, mi, Ti));
  if (gi !== "vertical" && gi !== "horizontal")
    return null;
  var xi, Si = vi == null ? void 0 : vi[0];
  return Si == null || Si.height == null || Si.width == null ? xi = 0 : xi = gi === "vertical" ? Si.height / 2 : Si.width / 2, /* @__PURE__ */ React.createElement(SetErrorBarContext, {
    xAxisId: yt,
    yAxisId: ir,
    data: vi,
    dataPointFormatter: errorBarDataPointFormatter,
    errorBarOffset: xi
  }, /* @__PURE__ */ React.createElement(BarWithState, _extends$5({}, pt, {
    layout: gi,
    needClip: fi,
    data: vi,
    xAxisId: yt,
    yAxisId: ir,
    hide: ti,
    legendType: ii,
    minPointSize: ui,
    activeBar: ai,
    animationBegin: li,
    animationDuration: oi,
    animationEasing: si,
    isAnimationActive: di
  })));
}
function computeBarRectangles(pt) {
  var {
    layout: yt,
    barSettings: {
      dataKey: ir,
      minPointSize: ti,
      hasCustomShape: ii
    },
    pos: ui,
    bandSize: ai,
    xAxis: li,
    yAxis: oi,
    xAxisTicks: si,
    yAxisTicks: di,
    stackedData: fi,
    displayedData: gi,
    offset: mi,
    cells: Ti,
    parentViewBox: vi,
    dataStartIndex: xi
  } = pt, Si = yt === "horizontal" ? oi : li, Pi = fi ? Si.scale.domain() : null, $i = getBaseValueOfBar({
    numericAxis: Si
  }), Oi = Si.scale.map($i);
  return gi.map((Di, Mi) => {
    var Oo, io, xo, fo, _o, Li;
    if (fi) {
      var Co = fi[Mi + xi];
      if (Co == null)
        return null;
      Oo = truncateByDomain(Co, Pi);
    } else
      Oo = getValueByDataKey(Di, ir), Array.isArray(Oo) || (Oo = [$i, Oo]);
    var Ni = minPointSizeCallback(ti, defaultMinPointSize)(Oo[1], Mi);
    if (yt === "horizontal") {
      var Yi, Vo = oi.scale.map(Oo[0]), No = oi.scale.map(Oo[1]);
      if (Vo == null || No == null)
        return null;
      io = getCateCoordinateOfBar({
        axis: li,
        ticks: si,
        bandSize: ai,
        offset: ui.offset,
        entry: Di,
        index: Mi
      }), xo = (Yi = No ?? Vo) !== null && Yi !== void 0 ? Yi : void 0, fo = ui.size;
      var Ui = Vo - No;
      if (_o = isNan(Ui) ? 0 : Ui, Li = {
        x: io,
        y: mi.top,
        width: fo,
        height: mi.height
      }, Math.abs(Ni) > 0 && Math.abs(_o) < Math.abs(Ni)) {
        var jo = mathSign(_o || Ni) * (Math.abs(Ni) - Math.abs(_o));
        xo -= jo, _o += jo;
      }
    } else {
      var Wi = li.scale.map(Oo[0]), ji = li.scale.map(Oo[1]);
      if (Wi == null || ji == null)
        return null;
      if (io = Wi, xo = getCateCoordinateOfBar({
        axis: oi,
        ticks: di,
        bandSize: ai,
        offset: ui.offset,
        entry: Di,
        index: Mi
      }), fo = ji - Wi, _o = ui.size, Li = {
        x: mi.left,
        y: xo,
        width: mi.width,
        height: _o
      }, Math.abs(Ni) > 0 && Math.abs(fo) < Math.abs(Ni)) {
        var Hi = mathSign(fo || Ni) * (Math.abs(Ni) - Math.abs(fo));
        fo += Hi;
      }
    }
    if (io == null || xo == null || fo == null || _o == null || !ii && (fo === 0 || _o === 0))
      return null;
    var zo = _objectSpread$4(_objectSpread$4({}, Di), {}, {
      stackedBarStart: Oi,
      x: io,
      y: xo,
      width: fo,
      height: _o,
      value: fi ? Oo : Oo[1],
      payload: Di,
      background: Li,
      tooltipPosition: {
        x: io + fo / 2,
        y: xo + _o / 2
      },
      parentViewBox: vi,
      originalDataIndex: Mi
    }, Ti && Ti[Mi] && Ti[Mi].props);
    return zo;
  }).filter(Boolean);
}
function BarFn(pt) {
  var yt = resolveDefaultProps(pt, defaultBarProps), ir = useStackId(yt.stackId), ti = useIsPanorama();
  return /* @__PURE__ */ React.createElement(RegisterGraphicalItemId, {
    id: yt.id,
    type: "bar"
  }, (ii) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(SetLegendPayload, {
    legendPayload: computeLegendPayloadFromBarData(yt)
  }), /* @__PURE__ */ React.createElement(SetBarTooltipEntrySettings, {
    dataKey: yt.dataKey,
    stroke: yt.stroke,
    strokeWidth: yt.strokeWidth,
    fill: yt.fill,
    name: yt.name,
    hide: yt.hide,
    unit: yt.unit,
    tooltipType: yt.tooltipType,
    id: ii
  }), /* @__PURE__ */ React.createElement(SetCartesianGraphicalItem, {
    type: "bar",
    id: ii,
    data: void 0,
    xAxisId: yt.xAxisId,
    yAxisId: yt.yAxisId,
    zAxisId: 0,
    dataKey: yt.dataKey,
    stackId: ir,
    hide: yt.hide,
    barSize: yt.barSize,
    minPointSize: yt.minPointSize,
    maxBarSize: yt.maxBarSize,
    isPanorama: ti,
    hasCustomShape: yt.shape != null
  }), /* @__PURE__ */ React.createElement(ZIndexLayer, {
    zIndex: yt.zIndex
  }, /* @__PURE__ */ React.createElement(BarImpl, _extends$5({}, yt, {
    id: ii
  })))));
}
var Bar = /* @__PURE__ */ React.memo(BarFn, propsAreEqual);
Bar.displayName = "Bar";
var _excluded$4 = ["domain", "range"], _excluded2$2 = ["domain", "range"];
function _objectWithoutProperties$4(pt, yt) {
  if (pt == null) return {};
  var ir, ti, ii = _objectWithoutPropertiesLoose$4(pt, yt);
  if (Object.getOwnPropertySymbols) {
    var ui = Object.getOwnPropertySymbols(pt);
    for (ti = 0; ti < ui.length; ti++) ir = ui[ti], yt.indexOf(ir) === -1 && {}.propertyIsEnumerable.call(pt, ir) && (ii[ir] = pt[ir]);
  }
  return ii;
}
function _objectWithoutPropertiesLoose$4(pt, yt) {
  if (pt == null) return {};
  var ir = {};
  for (var ti in pt) if ({}.hasOwnProperty.call(pt, ti)) {
    if (yt.indexOf(ti) !== -1) continue;
    ir[ti] = pt[ti];
  }
  return ir;
}
function shortArraysAreEqual(pt, yt) {
  return pt === yt ? !0 : Array.isArray(pt) && pt.length === 2 && Array.isArray(yt) && yt.length === 2 ? pt[0] === yt[0] && pt[1] === yt[1] : !1;
}
function axisPropsAreEqual(pt, yt) {
  if (pt === yt)
    return !0;
  var {
    domain: ir,
    range: ti
  } = pt, ii = _objectWithoutProperties$4(pt, _excluded$4), {
    domain: ui,
    range: ai
  } = yt, li = _objectWithoutProperties$4(yt, _excluded2$2);
  return !shortArraysAreEqual(ir, ui) || !shortArraysAreEqual(ti, ai) ? !1 : propsAreEqual(ii, li);
}
var _excluded$3 = ["type"], _excluded2$1 = ["dangerouslySetInnerHTML", "ticks", "scale"], _excluded3$1 = ["id", "scale"];
function _extends$4() {
  return _extends$4 = Object.assign ? Object.assign.bind() : function(pt) {
    for (var yt = 1; yt < arguments.length; yt++) {
      var ir = arguments[yt];
      for (var ti in ir) ({}).hasOwnProperty.call(ir, ti) && (pt[ti] = ir[ti]);
    }
    return pt;
  }, _extends$4.apply(null, arguments);
}
function ownKeys$3(pt, yt) {
  var ir = Object.keys(pt);
  if (Object.getOwnPropertySymbols) {
    var ti = Object.getOwnPropertySymbols(pt);
    yt && (ti = ti.filter(function(ii) {
      return Object.getOwnPropertyDescriptor(pt, ii).enumerable;
    })), ir.push.apply(ir, ti);
  }
  return ir;
}
function _objectSpread$3(pt) {
  for (var yt = 1; yt < arguments.length; yt++) {
    var ir = arguments[yt] != null ? arguments[yt] : {};
    yt % 2 ? ownKeys$3(Object(ir), !0).forEach(function(ti) {
      _defineProperty$3(pt, ti, ir[ti]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(pt, Object.getOwnPropertyDescriptors(ir)) : ownKeys$3(Object(ir)).forEach(function(ti) {
      Object.defineProperty(pt, ti, Object.getOwnPropertyDescriptor(ir, ti));
    });
  }
  return pt;
}
function _defineProperty$3(pt, yt, ir) {
  return (yt = _toPropertyKey$3(yt)) in pt ? Object.defineProperty(pt, yt, { value: ir, enumerable: !0, configurable: !0, writable: !0 }) : pt[yt] = ir, pt;
}
function _toPropertyKey$3(pt) {
  var yt = _toPrimitive$3(pt, "string");
  return typeof yt == "symbol" ? yt : yt + "";
}
function _toPrimitive$3(pt, yt) {
  if (typeof pt != "object" || !pt) return pt;
  var ir = pt[Symbol.toPrimitive];
  if (ir !== void 0) {
    var ti = ir.call(pt, yt);
    if (typeof ti != "object") return ti;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (yt === "string" ? String : Number)(pt);
}
function _objectWithoutProperties$3(pt, yt) {
  if (pt == null) return {};
  var ir, ti, ii = _objectWithoutPropertiesLoose$3(pt, yt);
  if (Object.getOwnPropertySymbols) {
    var ui = Object.getOwnPropertySymbols(pt);
    for (ti = 0; ti < ui.length; ti++) ir = ui[ti], yt.indexOf(ir) === -1 && {}.propertyIsEnumerable.call(pt, ir) && (ii[ir] = pt[ir]);
  }
  return ii;
}
function _objectWithoutPropertiesLoose$3(pt, yt) {
  if (pt == null) return {};
  var ir = {};
  for (var ti in pt) if ({}.hasOwnProperty.call(pt, ti)) {
    if (yt.indexOf(ti) !== -1) continue;
    ir[ti] = pt[ti];
  }
  return ir;
}
function SetXAxisSettings(pt) {
  var yt = useAppDispatch(), ir = useRef(null), ti = useCartesianChartLayout(), {
    type: ii
  } = pt, ui = _objectWithoutProperties$3(pt, _excluded$3), ai = getAxisTypeBasedOnLayout(ti, "xAxis", ii), li = useMemo(() => {
    if (ai != null)
      return _objectSpread$3(_objectSpread$3({}, ui), {}, {
        type: ai
      });
  }, [ui, ai]);
  return useLayoutEffect(() => {
    li != null && (ir.current === null ? yt(addXAxis(li)) : ir.current !== li && yt(replaceXAxis({
      prev: ir.current,
      next: li
    })), ir.current = li);
  }, [li, yt]), useLayoutEffect(() => () => {
    ir.current && (yt(removeXAxis(ir.current)), ir.current = null);
  }, [yt]), null;
}
var XAxisImpl = (pt) => {
  var {
    xAxisId: yt,
    className: ir
  } = pt, ti = useAppSelector(selectAxisViewBox), ii = useIsPanorama(), ui = "xAxis", ai = useAppSelector((Si) => selectTicksOfAxis(Si, ui, yt, ii)), li = useAppSelector((Si) => selectXAxisSize(Si, yt)), oi = useAppSelector((Si) => selectXAxisPosition(Si, yt)), si = useAppSelector((Si) => selectXAxisSettingsNoDefaults(Si, yt));
  if (li == null || oi == null || si == null)
    return null;
  var {
    dangerouslySetInnerHTML: di,
    ticks: fi,
    scale: gi
  } = pt, mi = _objectWithoutProperties$3(pt, _excluded2$1), {
    id: Ti,
    scale: vi
  } = si, xi = _objectWithoutProperties$3(si, _excluded3$1);
  return /* @__PURE__ */ React.createElement(CartesianAxis, _extends$4({}, mi, xi, {
    x: oi.x,
    y: oi.y,
    width: li.width,
    height: li.height,
    className: clsx$1("recharts-".concat(ui, " ").concat(ui), ir),
    viewBox: ti,
    ticks: ai,
    axisType: ui,
    axisId: yt
  }));
}, xAxisDefaultProps = {
  allowDataOverflow: implicitXAxis.allowDataOverflow,
  allowDecimals: implicitXAxis.allowDecimals,
  allowDuplicatedCategory: implicitXAxis.allowDuplicatedCategory,
  angle: implicitXAxis.angle,
  axisLine: defaultCartesianAxisProps.axisLine,
  height: implicitXAxis.height,
  hide: !1,
  includeHidden: implicitXAxis.includeHidden,
  interval: implicitXAxis.interval,
  label: !1,
  minTickGap: implicitXAxis.minTickGap,
  mirror: implicitXAxis.mirror,
  orientation: implicitXAxis.orientation,
  padding: implicitXAxis.padding,
  reversed: implicitXAxis.reversed,
  scale: implicitXAxis.scale,
  tick: implicitXAxis.tick,
  tickCount: implicitXAxis.tickCount,
  tickLine: defaultCartesianAxisProps.tickLine,
  tickSize: defaultCartesianAxisProps.tickSize,
  type: implicitXAxis.type,
  niceTicks: implicitXAxis.niceTicks,
  xAxisId: 0
}, XAxisSettingsDispatcher = (pt) => {
  var yt = resolveDefaultProps(pt, xAxisDefaultProps);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(SetXAxisSettings, {
    allowDataOverflow: yt.allowDataOverflow,
    allowDecimals: yt.allowDecimals,
    allowDuplicatedCategory: yt.allowDuplicatedCategory,
    angle: yt.angle,
    dataKey: yt.dataKey,
    domain: yt.domain,
    height: yt.height,
    hide: yt.hide,
    id: yt.xAxisId,
    includeHidden: yt.includeHidden,
    interval: yt.interval,
    minTickGap: yt.minTickGap,
    mirror: yt.mirror,
    name: yt.name,
    orientation: yt.orientation,
    padding: yt.padding,
    reversed: yt.reversed,
    scale: yt.scale,
    tick: yt.tick,
    tickCount: yt.tickCount,
    tickFormatter: yt.tickFormatter,
    ticks: yt.ticks,
    type: yt.type,
    unit: yt.unit,
    niceTicks: yt.niceTicks
  }), /* @__PURE__ */ React.createElement(XAxisImpl, yt));
}, XAxis = /* @__PURE__ */ React.memo(XAxisSettingsDispatcher, axisPropsAreEqual);
XAxis.displayName = "XAxis";
var _excluded$2 = ["type"], _excluded2 = ["dangerouslySetInnerHTML", "ticks", "scale"], _excluded3 = ["id", "scale"];
function _extends$3() {
  return _extends$3 = Object.assign ? Object.assign.bind() : function(pt) {
    for (var yt = 1; yt < arguments.length; yt++) {
      var ir = arguments[yt];
      for (var ti in ir) ({}).hasOwnProperty.call(ir, ti) && (pt[ti] = ir[ti]);
    }
    return pt;
  }, _extends$3.apply(null, arguments);
}
function ownKeys$2(pt, yt) {
  var ir = Object.keys(pt);
  if (Object.getOwnPropertySymbols) {
    var ti = Object.getOwnPropertySymbols(pt);
    yt && (ti = ti.filter(function(ii) {
      return Object.getOwnPropertyDescriptor(pt, ii).enumerable;
    })), ir.push.apply(ir, ti);
  }
  return ir;
}
function _objectSpread$2(pt) {
  for (var yt = 1; yt < arguments.length; yt++) {
    var ir = arguments[yt] != null ? arguments[yt] : {};
    yt % 2 ? ownKeys$2(Object(ir), !0).forEach(function(ti) {
      _defineProperty$2(pt, ti, ir[ti]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(pt, Object.getOwnPropertyDescriptors(ir)) : ownKeys$2(Object(ir)).forEach(function(ti) {
      Object.defineProperty(pt, ti, Object.getOwnPropertyDescriptor(ir, ti));
    });
  }
  return pt;
}
function _defineProperty$2(pt, yt, ir) {
  return (yt = _toPropertyKey$2(yt)) in pt ? Object.defineProperty(pt, yt, { value: ir, enumerable: !0, configurable: !0, writable: !0 }) : pt[yt] = ir, pt;
}
function _toPropertyKey$2(pt) {
  var yt = _toPrimitive$2(pt, "string");
  return typeof yt == "symbol" ? yt : yt + "";
}
function _toPrimitive$2(pt, yt) {
  if (typeof pt != "object" || !pt) return pt;
  var ir = pt[Symbol.toPrimitive];
  if (ir !== void 0) {
    var ti = ir.call(pt, yt);
    if (typeof ti != "object") return ti;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (yt === "string" ? String : Number)(pt);
}
function _objectWithoutProperties$2(pt, yt) {
  if (pt == null) return {};
  var ir, ti, ii = _objectWithoutPropertiesLoose$2(pt, yt);
  if (Object.getOwnPropertySymbols) {
    var ui = Object.getOwnPropertySymbols(pt);
    for (ti = 0; ti < ui.length; ti++) ir = ui[ti], yt.indexOf(ir) === -1 && {}.propertyIsEnumerable.call(pt, ir) && (ii[ir] = pt[ir]);
  }
  return ii;
}
function _objectWithoutPropertiesLoose$2(pt, yt) {
  if (pt == null) return {};
  var ir = {};
  for (var ti in pt) if ({}.hasOwnProperty.call(pt, ti)) {
    if (yt.indexOf(ti) !== -1) continue;
    ir[ti] = pt[ti];
  }
  return ir;
}
function SetYAxisSettings(pt) {
  var yt = useAppDispatch(), ir = useRef(null), ti = useCartesianChartLayout(), {
    type: ii
  } = pt, ui = _objectWithoutProperties$2(pt, _excluded$2), ai = getAxisTypeBasedOnLayout(ti, "yAxis", ii), li = useMemo(() => {
    if (ai != null)
      return _objectSpread$2(_objectSpread$2({}, ui), {}, {
        type: ai
      });
  }, [ai, ui]);
  return useLayoutEffect(() => {
    li != null && (ir.current === null ? yt(addYAxis(li)) : ir.current !== li && yt(replaceYAxis({
      prev: ir.current,
      next: li
    })), ir.current = li);
  }, [li, yt]), useLayoutEffect(() => () => {
    ir.current && (yt(removeYAxis(ir.current)), ir.current = null);
  }, [yt]), null;
}
function YAxisImpl(pt) {
  var {
    yAxisId: yt,
    className: ir,
    width: ti,
    label: ii
  } = pt, ui = useRef(null), ai = useRef(null), li = useAppSelector(selectAxisViewBox), oi = useIsPanorama(), si = useAppDispatch(), di = "yAxis", fi = useAppSelector((Mi) => selectYAxisSize(Mi, yt)), gi = useAppSelector((Mi) => selectYAxisPosition(Mi, yt)), mi = useAppSelector((Mi) => selectTicksOfAxis(Mi, di, yt, oi)), Ti = useAppSelector((Mi) => selectYAxisSettingsNoDefaults(Mi, yt));
  if (useLayoutEffect(() => {
    if (!(ti !== "auto" || !fi || isLabelContentAFunction(ii) || /* @__PURE__ */ isValidElement(ii) || Ti == null)) {
      var Mi = ui.current;
      if (Mi) {
        var Oo = Mi.getCalculatedWidth();
        Math.round(fi.width) !== Math.round(Oo) && si(updateYAxisWidth({
          id: yt,
          width: Oo
        }));
      }
    }
  }, [
    // The dependency on cartesianAxisRef.current is not needed because useLayoutEffect will run after every render.
    // The ref will be populated by then.
    // To re-run this effect when ticks change, we can depend on the ticks array from the store.
    mi,
    fi,
    si,
    ii,
    yt,
    ti,
    Ti
  ]), fi == null || gi == null || Ti == null)
    return null;
  var {
    dangerouslySetInnerHTML: vi,
    ticks: xi,
    scale: Si
  } = pt, Pi = _objectWithoutProperties$2(pt, _excluded2), {
    id: $i,
    scale: Oi
  } = Ti, Di = _objectWithoutProperties$2(Ti, _excluded3);
  return /* @__PURE__ */ React.createElement(CartesianAxis, _extends$3({}, Pi, Di, {
    ref: ui,
    labelRef: ai,
    x: gi.x,
    y: gi.y,
    tickTextProps: ti === "auto" ? {
      width: void 0
    } : {
      width: ti
    },
    width: fi.width,
    height: fi.height,
    className: clsx$1("recharts-".concat(di, " ").concat(di), ir),
    viewBox: li,
    ticks: mi,
    axisType: di,
    axisId: yt
  }));
}
var yAxisDefaultProps = {
  allowDataOverflow: implicitYAxis.allowDataOverflow,
  allowDecimals: implicitYAxis.allowDecimals,
  allowDuplicatedCategory: implicitYAxis.allowDuplicatedCategory,
  angle: implicitYAxis.angle,
  axisLine: defaultCartesianAxisProps.axisLine,
  hide: !1,
  includeHidden: implicitYAxis.includeHidden,
  interval: implicitYAxis.interval,
  label: !1,
  minTickGap: implicitYAxis.minTickGap,
  mirror: implicitYAxis.mirror,
  orientation: implicitYAxis.orientation,
  padding: implicitYAxis.padding,
  reversed: implicitYAxis.reversed,
  scale: implicitYAxis.scale,
  tick: implicitYAxis.tick,
  tickCount: implicitYAxis.tickCount,
  tickLine: defaultCartesianAxisProps.tickLine,
  tickSize: defaultCartesianAxisProps.tickSize,
  type: implicitYAxis.type,
  niceTicks: implicitYAxis.niceTicks,
  width: implicitYAxis.width,
  yAxisId: 0
}, YAxisSettingsDispatcher = (pt) => {
  var yt = resolveDefaultProps(pt, yAxisDefaultProps);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(SetYAxisSettings, {
    interval: yt.interval,
    id: yt.yAxisId,
    scale: yt.scale,
    type: yt.type,
    domain: yt.domain,
    allowDataOverflow: yt.allowDataOverflow,
    dataKey: yt.dataKey,
    allowDuplicatedCategory: yt.allowDuplicatedCategory,
    allowDecimals: yt.allowDecimals,
    tickCount: yt.tickCount,
    padding: yt.padding,
    includeHidden: yt.includeHidden,
    reversed: yt.reversed,
    ticks: yt.ticks,
    width: yt.width,
    orientation: yt.orientation,
    mirror: yt.mirror,
    hide: yt.hide,
    unit: yt.unit,
    name: yt.name,
    angle: yt.angle,
    minTickGap: yt.minTickGap,
    tick: yt.tick,
    tickFormatter: yt.tickFormatter,
    niceTicks: yt.niceTicks
  }), /* @__PURE__ */ React.createElement(YAxisImpl, yt));
}, YAxis = /* @__PURE__ */ React.memo(YAxisSettingsDispatcher, axisPropsAreEqual);
YAxis.displayName = "YAxis";
var pickChartPointer = (pt, yt) => yt, selectActivePropsFromChartPointer = createSelector([pickChartPointer, selectChartLayout, selectPolarViewBox, selectTooltipAxisType, selectTooltipAxisRangeWithReverse, selectTooltipAxisTicks, selectOrderedTooltipTicks, selectChartOffsetInternal], combineActiveProps);
function isSvgPointer(pt) {
  return "getBBox" in pt.currentTarget && typeof pt.currentTarget.getBBox == "function";
}
function getRelativeCoordinate(pt) {
  var yt = pt.currentTarget.getBoundingClientRect(), ir, ti;
  if (isSvgPointer(pt)) {
    var ii = pt.currentTarget.getBBox();
    ir = ii.width > 0 ? yt.width / ii.width : 1, ti = ii.height > 0 ? yt.height / ii.height : 1;
  } else {
    var ui = pt.currentTarget;
    ir = ui.offsetWidth > 0 ? yt.width / ui.offsetWidth : 1, ti = ui.offsetHeight > 0 ? yt.height / ui.offsetHeight : 1;
  }
  var ai = (li, oi) => ({
    /*
     * Here it's important to use:
     * - event.clientX and event.clientY to get the mouse position relative to the viewport, including scroll.
     * - pageX and pageY are not used because they are relative to the whole document, and ignore scroll.
     * - rect.left and rect.top are used to get the position of the chart relative to the viewport.
     * - offsetX and offsetY are not used because they are relative to the offset parent
     *  which may or may not be the same as the clientX and clientY, depending on the position of the chart in the DOM
     *  and surrounding element styles. CSS position: relative, absolute, fixed, will change the offset parent.
     * - scaleX and scaleY are necessary for when the chart element is scaled using CSS `transform: scale(N)`.
     */
    relativeX: Math.round((li - yt.left) / ir),
    relativeY: Math.round((oi - yt.top) / ti)
  });
  return "touches" in pt ? Array.from(pt.touches).map((li) => ai(li.clientX, li.clientY)) : ai(pt.clientX, pt.clientY);
}
var mouseClickAction = createAction("mouseClick"), mouseClickMiddleware = createListenerMiddleware();
mouseClickMiddleware.startListening({
  actionCreator: mouseClickAction,
  effect: (pt, yt) => {
    var ir = pt.payload, ti = selectActivePropsFromChartPointer(yt.getState(), getRelativeCoordinate(ir));
    (ti == null ? void 0 : ti.activeIndex) != null && yt.dispatch(setMouseClickAxisIndex({
      activeIndex: ti.activeIndex,
      activeDataKey: void 0,
      activeCoordinate: ti.activeCoordinate
    }));
  }
});
var mouseMoveAction = createAction("mouseMove"), mouseMoveMiddleware = createListenerMiddleware(), rafId$2 = null, timeoutId$2 = null, latestChartPointer = null;
mouseMoveMiddleware.startListening({
  actionCreator: mouseMoveAction,
  effect: (pt, yt) => {
    var ir = pt.payload, ti = yt.getState(), {
      throttleDelay: ii,
      throttledEvents: ui
    } = ti.eventSettings, ai = ui === "all" || (ui == null ? void 0 : ui.includes("mousemove"));
    rafId$2 !== null && (cancelAnimationFrame(rafId$2), rafId$2 = null), timeoutId$2 !== null && (typeof ii != "number" || !ai) && (clearTimeout(timeoutId$2), timeoutId$2 = null), latestChartPointer = getRelativeCoordinate(ir);
    var li = () => {
      var oi = yt.getState(), si = selectTooltipEventType$1(oi, oi.tooltip.settings.shared);
      if (!latestChartPointer) {
        rafId$2 = null, timeoutId$2 = null;
        return;
      }
      if (si === "axis") {
        var di = selectActivePropsFromChartPointer(oi, latestChartPointer);
        (di == null ? void 0 : di.activeIndex) != null ? yt.dispatch(setMouseOverAxisIndex({
          activeIndex: di.activeIndex,
          activeDataKey: void 0,
          activeCoordinate: di.activeCoordinate
        })) : yt.dispatch(mouseLeaveChart());
      }
      rafId$2 = null, timeoutId$2 = null;
    };
    if (!ai) {
      li();
      return;
    }
    ii === "raf" ? rafId$2 = requestAnimationFrame(li) : typeof ii == "number" && timeoutId$2 === null && (timeoutId$2 = setTimeout(li, ii));
  }
});
var initialState$1 = {
  accessibilityLayer: !0,
  barCategoryGap: "10%",
  barGap: 4,
  barSize: void 0,
  className: void 0,
  maxBarSize: void 0,
  stackOffset: "none",
  syncId: void 0,
  syncMethod: "index",
  baseValue: void 0,
  reverseStackOrder: !1
}, rootPropsSlice = createSlice({
  name: "rootProps",
  initialState: initialState$1,
  reducers: {
    updateOptions: (pt, yt) => {
      var ir;
      pt.accessibilityLayer = yt.payload.accessibilityLayer, pt.barCategoryGap = yt.payload.barCategoryGap, pt.barGap = (ir = yt.payload.barGap) !== null && ir !== void 0 ? ir : initialState$1.barGap, pt.barSize = yt.payload.barSize, pt.maxBarSize = yt.payload.maxBarSize, pt.stackOffset = yt.payload.stackOffset, pt.syncId = yt.payload.syncId, pt.syncMethod = yt.payload.syncMethod, pt.className = yt.payload.className, pt.baseValue = yt.payload.baseValue, pt.reverseStackOrder = yt.payload.reverseStackOrder;
    }
  }
}), rootPropsReducer = rootPropsSlice.reducer, {
  updateOptions
} = rootPropsSlice.actions, initialState = null, reducers = {
  updatePolarOptions: (pt, yt) => pt === null ? yt.payload : (pt.startAngle = yt.payload.startAngle, pt.endAngle = yt.payload.endAngle, pt.cx = yt.payload.cx, pt.cy = yt.payload.cy, pt.innerRadius = yt.payload.innerRadius, pt.outerRadius = yt.payload.outerRadius, pt)
}, polarOptionsSlice = createSlice({
  name: "polarOptions",
  initialState,
  reducers
}), {
  updatePolarOptions
} = polarOptionsSlice.actions, polarOptionsReducer = polarOptionsSlice.reducer, keyDownAction = createAction("keyDown"), focusAction = createAction("focus"), blurAction = createAction("blur"), keyboardEventsMiddleware = createListenerMiddleware(), rafId$1 = null, timeoutId$1 = null, latestKeyboardActionPayload = null;
keyboardEventsMiddleware.startListening({
  actionCreator: keyDownAction,
  effect: (pt, yt) => {
    latestKeyboardActionPayload = pt.payload, rafId$1 !== null && (cancelAnimationFrame(rafId$1), rafId$1 = null);
    var ir = yt.getState(), {
      throttleDelay: ti,
      throttledEvents: ii
    } = ir.eventSettings, ui = ii === "all" || ii.includes("keydown");
    timeoutId$1 !== null && (typeof ti != "number" || !ui) && (clearTimeout(timeoutId$1), timeoutId$1 = null);
    var ai = () => {
      try {
        var li = yt.getState(), oi = li.rootProps.accessibilityLayer !== !1;
        if (!oi)
          return;
        var {
          keyboardInteraction: si
        } = li.tooltip, di = latestKeyboardActionPayload;
        if (di !== "ArrowRight" && di !== "ArrowLeft" && di !== "Enter")
          return;
        var fi = combineActiveTooltipIndex(si, selectTooltipDisplayedData(li), selectTooltipAxisDataKey(li), selectTooltipAxisDomain(li)), gi = fi == null ? -1 : Number(fi), mi = !Number.isFinite(gi) || gi < 0, Ti = selectTooltipAxisTicks(li), vi = selectTooltipDisplayedData(li), xi = selectTooltipEventType$1(li, li.tooltip.settings.shared);
        if (di === "Enter") {
          if (mi)
            return;
          var Si = selectCoordinateForDefaultIndex(li, xi, "hover", String(si.index));
          yt.dispatch(setKeyboardInteraction({
            active: !si.active,
            activeIndex: si.index,
            activeCoordinate: Si
          }));
          return;
        }
        var Pi = selectChartDirection(li), $i = Pi === "left-to-right" ? 1 : -1, Oi = di === "ArrowRight" ? 1 : -1, Di;
        if (mi) {
          var Mi = selectTooltipAxisDataKey(li), Oo = selectTooltipAxisDomain(li), io = Oi * $i, xo = (Ni) => ({
            active: !1,
            index: String(Ni),
            dataKey: void 0,
            graphicalItemId: void 0,
            coordinate: void 0
          });
          if (Di = -1, io > 0) {
            for (var fo = 0; fo < vi.length; fo++)
              if (combineActiveTooltipIndex(xo(fo), vi, Mi, Oo) != null) {
                Di = fo;
                break;
              }
          } else
            for (var _o = vi.length - 1; _o >= 0; _o--)
              if (combineActiveTooltipIndex(xo(_o), vi, Mi, Oo) != null) {
                Di = _o;
                break;
              }
          if (Di < 0)
            return;
        } else {
          Di = gi + Oi * $i;
          var Li = (Ti == null ? void 0 : Ti.length) || vi.length;
          if (Li === 0 || Di >= Li || Di < 0)
            return;
        }
        var Co = selectCoordinateForDefaultIndex(li, xi, "hover", String(Di));
        yt.dispatch(setKeyboardInteraction({
          active: !0,
          activeIndex: Di.toString(),
          activeCoordinate: Co
        }));
      } finally {
        rafId$1 = null, timeoutId$1 = null;
      }
    };
    if (!ui) {
      ai();
      return;
    }
    ti === "raf" ? rafId$1 = requestAnimationFrame(ai) : typeof ti == "number" && timeoutId$1 === null && (ai(), latestKeyboardActionPayload = null, timeoutId$1 = setTimeout(() => {
      latestKeyboardActionPayload ? ai() : (timeoutId$1 = null, rafId$1 = null);
    }, ti));
  }
});
keyboardEventsMiddleware.startListening({
  actionCreator: focusAction,
  effect: (pt, yt) => {
    var ir = yt.getState(), ti = ir.rootProps.accessibilityLayer !== !1;
    if (ti) {
      var {
        keyboardInteraction: ii
      } = ir.tooltip;
      if (!ii.active && ii.index == null) {
        var ui = "0", ai = selectTooltipEventType$1(ir, ir.tooltip.settings.shared), li = selectCoordinateForDefaultIndex(ir, ai, "hover", String(ui));
        yt.dispatch(setKeyboardInteraction({
          active: !0,
          activeIndex: ui,
          activeCoordinate: li
        }));
      }
    }
  }
});
keyboardEventsMiddleware.startListening({
  actionCreator: blurAction,
  effect: (pt, yt) => {
    var ir = yt.getState(), ti = ir.rootProps.accessibilityLayer !== !1;
    if (ti) {
      var {
        keyboardInteraction: ii
      } = ir.tooltip;
      ii.active && yt.dispatch(setKeyboardInteraction({
        active: !1,
        activeIndex: ii.index,
        activeCoordinate: ii.coordinate
      }));
    }
  }
});
function createEventProxy(pt) {
  pt.persist();
  var {
    currentTarget: yt
  } = pt;
  return new Proxy(pt, {
    get: (ir, ti) => {
      if (ti === "currentTarget")
        return yt;
      var ii = Reflect.get(ir, ti);
      return typeof ii == "function" ? ii.bind(ir) : ii;
    }
  });
}
var externalEventAction = createAction("externalEvent"), externalEventsMiddleware = createListenerMiddleware(), rafIdMap = /* @__PURE__ */ new Map(), timeoutIdMap = /* @__PURE__ */ new Map(), latestEventMap = /* @__PURE__ */ new Map();
externalEventsMiddleware.startListening({
  actionCreator: externalEventAction,
  effect: (pt, yt) => {
    var {
      handler: ir,
      reactEvent: ti
    } = pt.payload;
    if (ir != null) {
      var ii = ti.type, ui = createEventProxy(ti);
      latestEventMap.set(ii, {
        handler: ir,
        reactEvent: ui
      });
      var ai = rafIdMap.get(ii);
      ai !== void 0 && (cancelAnimationFrame(ai), rafIdMap.delete(ii));
      var li = yt.getState(), {
        throttleDelay: oi,
        throttledEvents: si
      } = li.eventSettings, di = si, fi = di === "all" || (di == null ? void 0 : di.includes(ii)), gi = timeoutIdMap.get(ii);
      gi !== void 0 && (typeof oi != "number" || !fi) && (clearTimeout(gi), timeoutIdMap.delete(ii));
      var mi = () => {
        var xi = latestEventMap.get(ii);
        try {
          if (!xi)
            return;
          var {
            handler: Si,
            reactEvent: Pi
          } = xi, $i = yt.getState(), Oi = {
            activeCoordinate: selectActiveTooltipCoordinate($i),
            activeDataKey: selectActiveTooltipDataKey($i),
            activeIndex: selectActiveTooltipIndex($i),
            activeLabel: selectActiveLabel$1($i),
            activeTooltipIndex: selectActiveTooltipIndex($i),
            isTooltipActive: selectIsTooltipActive$1($i)
          };
          Si && Si(Oi, Pi);
        } finally {
          rafIdMap.delete(ii), timeoutIdMap.delete(ii), latestEventMap.delete(ii);
        }
      };
      if (!fi) {
        mi();
        return;
      }
      if (oi === "raf") {
        var Ti = requestAnimationFrame(mi);
        rafIdMap.set(ii, Ti);
      } else if (typeof oi == "number") {
        if (!timeoutIdMap.has(ii)) {
          mi();
          var vi = setTimeout(mi, oi);
          timeoutIdMap.set(ii, vi);
        }
      } else
        mi();
    }
  }
});
var selectAllTooltipPayloadConfiguration = createSelector([selectTooltipState], (pt) => pt.tooltipItemPayloads), selectTooltipCoordinate = createSelector([selectAllTooltipPayloadConfiguration, (pt, yt) => yt, (pt, yt, ir) => ir], (pt, yt, ir) => {
  if (yt != null) {
    var ti = pt.find((ui) => ui.settings.graphicalItemId === ir);
    if (ti != null) {
      var {
        getPosition: ii
      } = ti;
      if (ii != null)
        return ii(yt);
    }
  }
}), touchEventAction = createAction("touchMove"), touchEventMiddleware = createListenerMiddleware(), rafId = null, timeoutId = null, latestChartPointers = null, latestTouchEvent = null;
touchEventMiddleware.startListening({
  actionCreator: touchEventAction,
  effect: (pt, yt) => {
    var ir = pt.payload;
    if (!(ir.touches == null || ir.touches.length === 0)) {
      latestTouchEvent = createEventProxy(ir);
      var ti = yt.getState(), {
        throttleDelay: ii,
        throttledEvents: ui
      } = ti.eventSettings, ai = ui === "all" || ui.includes("touchmove");
      rafId !== null && (cancelAnimationFrame(rafId), rafId = null), timeoutId !== null && (typeof ii != "number" || !ai) && (clearTimeout(timeoutId), timeoutId = null), latestChartPointers = Array.from(ir.touches).map((oi) => getRelativeCoordinate({
        clientX: oi.clientX,
        clientY: oi.clientY,
        currentTarget: ir.currentTarget
      }));
      var li = () => {
        if (latestTouchEvent != null) {
          var oi = yt.getState(), si = selectTooltipEventType$1(oi, oi.tooltip.settings.shared);
          if (si === "axis") {
            var di, fi = (di = latestChartPointers) === null || di === void 0 ? void 0 : di[0];
            if (fi == null) {
              rafId = null, timeoutId = null;
              return;
            }
            var gi = selectActivePropsFromChartPointer(oi, fi);
            (gi == null ? void 0 : gi.activeIndex) != null && yt.dispatch(setMouseOverAxisIndex({
              activeIndex: gi.activeIndex,
              activeDataKey: void 0,
              activeCoordinate: gi.activeCoordinate
            }));
          } else if (si === "item") {
            var mi, Ti = latestTouchEvent.touches[0];
            if (document.elementFromPoint == null || Ti == null)
              return;
            var vi = document.elementFromPoint(Ti.clientX, Ti.clientY);
            if (!vi || !vi.getAttribute)
              return;
            var xi = vi.getAttribute(DATA_ITEM_INDEX_ATTRIBUTE_NAME), Si = (mi = vi.getAttribute(DATA_ITEM_GRAPHICAL_ITEM_ID_ATTRIBUTE_NAME)) !== null && mi !== void 0 ? mi : void 0, Pi = selectAllGraphicalItemsSettings(oi).find((Di) => Di.id === Si);
            if (xi == null || Pi == null || Si == null)
              return;
            var {
              dataKey: $i
            } = Pi, Oi = selectTooltipCoordinate(oi, xi, Si);
            yt.dispatch(setActiveMouseOverItemIndex({
              activeDataKey: $i,
              activeIndex: xi,
              activeCoordinate: Oi,
              activeGraphicalItemId: Si
            }));
          }
          rafId = null, timeoutId = null;
        }
      };
      if (!ai) {
        li();
        return;
      }
      ii === "raf" ? rafId = requestAnimationFrame(li) : typeof ii == "number" && timeoutId === null && (li(), latestTouchEvent = null, timeoutId = setTimeout(() => {
        latestTouchEvent ? li() : (timeoutId = null, rafId = null);
      }, ii));
    }
  }
});
var initialEventSettingsState = {
  throttleDelay: "raf",
  throttledEvents: ["mousemove", "touchmove", "pointermove", "scroll", "wheel"]
}, eventSettingsSlice = createSlice({
  name: "eventSettings",
  initialState: initialEventSettingsState,
  reducers: {
    setEventSettings: (pt, yt) => {
      yt.payload.throttleDelay != null && (pt.throttleDelay = yt.payload.throttleDelay), yt.payload.throttledEvents != null && (pt.throttledEvents = yt.payload.throttledEvents);
    }
  }
}), {
  setEventSettings
} = eventSettingsSlice.actions, eventSettingsReducer = eventSettingsSlice.reducer;
combineReducers({
  brush: brushReducer,
  cartesianAxis: cartesianAxisReducer,
  chartData: chartDataReducer,
  errorBars: errorBarReducer,
  eventSettings: eventSettingsReducer,
  graphicalItems: graphicalItemsReducer,
  layout: chartLayoutReducer,
  legend: legendReducer,
  options: optionsReducer,
  polarAxis: polarAxisReducer,
  polarOptions: polarOptionsReducer,
  referenceElements: referenceElementsReducer,
  renderedTicks: renderedTicksReducer,
  rootProps: rootPropsReducer,
  tooltip: tooltipReducer,
  zIndex: zIndexReducer
});
function ownKeys(pt, yt) {
  var ir = Object.keys(pt);
  if (Object.getOwnPropertySymbols) {
    var ti = Object.getOwnPropertySymbols(pt);
    yt && (ti = ti.filter(function(ii) {
      return Object.getOwnPropertyDescriptor(pt, ii).enumerable;
    })), ir.push.apply(ir, ti);
  }
  return ir;
}
function _objectSpread(pt) {
  for (var yt = 1; yt < arguments.length; yt++) {
    var ir = arguments[yt] != null ? arguments[yt] : {};
    yt % 2 ? ownKeys(Object(ir), !0).forEach(function(ti) {
      _defineProperty(pt, ti, ir[ti]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(pt, Object.getOwnPropertyDescriptors(ir)) : ownKeys(Object(ir)).forEach(function(ti) {
      Object.defineProperty(pt, ti, Object.getOwnPropertyDescriptor(ir, ti));
    });
  }
  return pt;
}
function _defineProperty(pt, yt, ir) {
  return (yt = _toPropertyKey(yt)) in pt ? Object.defineProperty(pt, yt, { value: ir, enumerable: !0, configurable: !0, writable: !0 }) : pt[yt] = ir, pt;
}
function _toPropertyKey(pt) {
  var yt = _toPrimitive(pt, "string");
  return typeof yt == "symbol" ? yt : yt + "";
}
function _toPrimitive(pt, yt) {
  if (typeof pt != "object" || !pt) return pt;
  var ir = pt[Symbol.toPrimitive];
  if (ir !== void 0) {
    var ti = ir.call(pt, yt);
    if (typeof ti != "object") return ti;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (yt === "string" ? String : Number)(pt);
}
var defaultMargin = {
  top: 5,
  right: 5,
  bottom: 5,
  left: 5
};
_objectSpread({
  accessibilityLayer: !0,
  barCategoryGap: "10%",
  barGap: 4,
  layout: "horizontal",
  margin: defaultMargin,
  responsive: !1,
  reverseStackOrder: !1,
  stackOffset: "none",
  syncMethod: "index"
}, initialEventSettingsState);
const isHexColor = (pt, yt, ir) => {
  const ti = /^#(?:[A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, ii = pt[yt];
  return ii ? ti.test(ii) ? null : new Error(`Invalid value passed to attribute ${yt} in ${ir}. Expected valid hex-color notation.`) : null;
};
PropTypes.number, PropTypes.number, PropTypes.shape({
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}), PropTypes.number;
PropTypes.bool, PropTypes.arrayOf(PropTypes.shape({
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
})), PropTypes.string, PropTypes.arrayOf(PropTypes.string), PropTypes.shape({
  x: PropTypes.number,
  y: PropTypes.number
}), PropTypes.shape({ current: PropTypes.instanceOf(Element) }), PropTypes.bool, PropTypes.bool;
PropTypes.string, PropTypes.string, PropTypes.string.isRequired, PropTypes.oneOf(["number", "category"]), PropTypes.arrayOf(isHexColor), PropTypes.arrayOf(PropTypes.object.isRequired).isRequired, PropTypes.arrayOf(PropTypes.string.isRequired).isRequired, PropTypes.bool, PropTypes.bool, PropTypes.shape({
  chart: PropTypes.object,
  xAxis: PropTypes.object,
  yAxis: PropTypes.object,
  bars: PropTypes.object,
  legend: PropTypes.object,
  tooltip: PropTypes.object,
  title: PropTypes.object,
  root: PropTypes.object
}), PropTypes.string, PropTypes.number;
PropTypes.shape({
  horizontal: PropTypes.oneOf(["left", "right"]),
  vertical: PropTypes.oneOf(["bottom", "top"])
}), PropTypes.oneOfType([
  PropTypes.array,
  PropTypes.string,
  PropTypes.number,
  PropTypes.element
]), PropTypes.string.isRequired, PropTypes.string, PropTypes.string, PropTypes.node, PropTypes.string, PropTypes.string, PropTypes.number, PropTypes.bool, PropTypes.oneOf([
  "single",
  "single-square",
  "double",
  "doubleWithText",
  "doubleWithText-square"
]);
var u$1 = Object.defineProperty, a$2 = (pt, yt) => u$1(pt, "name", { value: yt, configurable: !0 }), y$2 = (() => {
  let pt;
  return typeof window < "u" ? pt = window : typeof globalThis < "u" ? pt = globalThis : typeof global < "u" ? pt = global : typeof self < "u" ? pt = self : pt = {}, pt;
})(), { LOGLEVEL: b$3 } = y$2, t$2 = {
  trace: 1,
  debug: 2,
  info: 3,
  warn: 4,
  error: 5,
  silent: 10
}, L$4 = b$3, i$1 = t$2[L$4] || t$2.info, s$3 = {
  trace: /* @__PURE__ */ a$2((pt, ...yt) => {
    i$1 <= t$2.trace && console.trace(pt, ...yt);
  }, "trace"),
  debug: /* @__PURE__ */ a$2((pt, ...yt) => {
    i$1 <= t$2.debug && console.debug(pt, ...yt);
  }, "debug"),
  info: /* @__PURE__ */ a$2((pt, ...yt) => {
    i$1 <= t$2.info && console.info(pt, ...yt);
  }, "info"),
  warn: /* @__PURE__ */ a$2((pt, ...yt) => {
    i$1 <= t$2.warn && console.warn(pt, ...yt);
  }, "warn"),
  error: /* @__PURE__ */ a$2((pt, ...yt) => {
    i$1 <= t$2.error && console.error(pt, ...yt);
  }, "error"),
  log: /* @__PURE__ */ a$2((pt, ...yt) => {
    i$1 < t$2.silent && console.log(pt, ...yt);
  }, "log")
}, c$1 = /* @__PURE__ */ new Set(), n$1 = /* @__PURE__ */ a$2((pt) => (yt, ...ir) => {
  if (!c$1.has(yt))
    return c$1.add(yt), s$3[pt](yt, ...ir);
}, "once");
n$1.clear = () => c$1.clear();
n$1.trace = n$1("trace");
n$1.debug = n$1("debug");
n$1.info = n$1("info");
n$1.warn = n$1("warn");
n$1.error = n$1("error");
n$1.log = n$1("log");
var m$1 = n$1("warn"), r$2 = /* @__PURE__ */ a$2((pt) => (...yt) => {
  let ir = [];
  if (yt.length) {
    let ti = /<span\s+style=(['"])([^'"]*)\1\s*>/gi, ii = /<\/span>/gi, ui;
    for (ir.push(yt[0].replace(ti, "%c").replace(ii, "%c")); ui = ti.exec(yt[0]); )
      ir.push(ui[2]), ir.push("");
    for (let ai = 1; ai < yt.length; ai++)
      ir.push(yt[ai]);
  }
  s$3[pt].apply(s$3, ir);
}, "pretty");
r$2.trace = r$2("trace");
r$2.debug = r$2("debug");
r$2.info = r$2("info");
r$2.warn = r$2("warn");
r$2.error = r$2("error");
var R$2 = /* @__PURE__ */ ((pt) => (pt.CHANNEL_WS_DISCONNECT = "channelWSDisconnect", pt.CHANNEL_CREATED = "channelCreated", pt.CONFIG_ERROR = "configError", pt.STORY_INDEX_INVALIDATED = "storyIndexInvalidated", pt.STORY_SPECIFIED = "storySpecified", pt.SET_CONFIG = "setConfig", pt.SET_STORIES = "setStories", pt.SET_INDEX = "setIndex", pt.SET_CURRENT_STORY = "setCurrentStory", pt.CURRENT_STORY_WAS_SET = "currentStoryWasSet", pt.FORCE_RE_RENDER = "forceReRender", pt.FORCE_REMOUNT = "forceRemount", pt.PRELOAD_ENTRIES = "preloadStories", pt.STORY_PREPARED = "storyPrepared", pt.DOCS_PREPARED = "docsPrepared", pt.STORY_CHANGED = "storyChanged", pt.STORY_UNCHANGED = "storyUnchanged", pt.STORY_RENDERED = "storyRendered", pt.STORY_FINISHED = "storyFinished", pt.STORY_MISSING = "storyMissing", pt.STORY_ERRORED = "storyErrored", pt.STORY_THREW_EXCEPTION = "storyThrewException", pt.STORY_RENDER_PHASE_CHANGED = "storyRenderPhaseChanged", pt.PLAY_FUNCTION_THREW_EXCEPTION = "playFunctionThrewException", pt.UNHANDLED_ERRORS_WHILE_PLAYING = "unhandledErrorsWhilePlaying", pt.UPDATE_STORY_ARGS = "updateStoryArgs", pt.STORY_ARGS_UPDATED = "storyArgsUpdated", pt.RESET_STORY_ARGS = "resetStoryArgs", pt.SET_FILTER = "setFilter", pt.SET_GLOBALS = "setGlobals", pt.UPDATE_GLOBALS = "updateGlobals", pt.GLOBALS_UPDATED = "globalsUpdated", pt.REGISTER_SUBSCRIPTION = "registerSubscription", pt.PREVIEW_KEYDOWN = "previewKeydown", pt.PREVIEW_BUILDER_PROGRESS = "preview_builder_progress", pt.SELECT_STORY = "selectStory", pt.STORIES_COLLAPSE_ALL = "storiesCollapseAll", pt.STORIES_EXPAND_ALL = "storiesExpandAll", pt.DOCS_RENDERED = "docsRendered", pt.SHARED_STATE_CHANGED = "sharedStateChanged", pt.SHARED_STATE_SET = "sharedStateSet", pt.NAVIGATE_URL = "navigateUrl", pt.UPDATE_QUERY_PARAMS = "updateQueryParams", pt.REQUEST_WHATS_NEW_DATA = "requestWhatsNewData", pt.RESULT_WHATS_NEW_DATA = "resultWhatsNewData", pt.SET_WHATS_NEW_CACHE = "setWhatsNewCache", pt.TOGGLE_WHATS_NEW_NOTIFICATIONS = "toggleWhatsNewNotifications", pt.TELEMETRY_ERROR = "telemetryError", pt.FILE_COMPONENT_SEARCH_REQUEST = "fileComponentSearchRequest", pt.FILE_COMPONENT_SEARCH_RESPONSE = "fileComponentSearchResponse", pt.SAVE_STORY_REQUEST = "saveStoryRequest", pt.SAVE_STORY_RESPONSE = "saveStoryResponse", pt.ARGTYPES_INFO_REQUEST = "argtypesInfoRequest", pt.ARGTYPES_INFO_RESPONSE = "argtypesInfoResponse", pt.CREATE_NEW_STORYFILE_REQUEST = "createNewStoryfileRequest", pt.CREATE_NEW_STORYFILE_RESPONSE = "createNewStoryfileResponse", pt.TESTING_MODULE_CRASH_REPORT = "testingModuleCrashReport", pt.TESTING_MODULE_PROGRESS_REPORT = "testingModuleProgressReport", pt.TESTING_MODULE_RUN_REQUEST = "testingModuleRunRequest", pt.TESTING_MODULE_RUN_ALL_REQUEST = "testingModuleRunAllRequest", pt.TESTING_MODULE_CANCEL_TEST_RUN_REQUEST = "testingModuleCancelTestRunRequest", pt.TESTING_MODULE_CANCEL_TEST_RUN_RESPONSE = "testingModuleCancelTestRunResponse", pt))(R$2 || {}), _$2 = R$2, {
  CHANNEL_WS_DISCONNECT: S$3,
  CHANNEL_CREATED: T$3,
  CONFIG_ERROR: N$1,
  CREATE_NEW_STORYFILE_REQUEST: O$2,
  CREATE_NEW_STORYFILE_RESPONSE: A$1,
  CURRENT_STORY_WAS_SET: r$1,
  DOCS_PREPARED: D$2,
  DOCS_RENDERED: I$3,
  FILE_COMPONENT_SEARCH_REQUEST: o$1,
  FILE_COMPONENT_SEARCH_RESPONSE: C$2,
  FORCE_RE_RENDER: L$3,
  FORCE_REMOUNT: P$4,
  GLOBALS_UPDATED: U$3,
  NAVIGATE_URL: G$3,
  PLAY_FUNCTION_THREW_EXCEPTION: a$1,
  UNHANDLED_ERRORS_WHILE_PLAYING: Y$3,
  PRELOAD_ENTRIES: t$1,
  PREVIEW_BUILDER_PROGRESS: d,
  PREVIEW_KEYDOWN: e,
  REGISTER_SUBSCRIPTION: H$3,
  RESET_STORY_ARGS: W$3,
  SELECT_STORY: l,
  SET_CONFIG: i,
  SET_CURRENT_STORY: p$1,
  SET_FILTER: F$3,
  SET_GLOBALS: u,
  SET_INDEX: M$2,
  SET_STORIES: s$2,
  SHARED_STATE_CHANGED: y$1,
  SHARED_STATE_SET: c,
  STORIES_COLLAPSE_ALL: g,
  STORIES_EXPAND_ALL: h$1,
  STORY_ARGS_UPDATED: f$2,
  STORY_CHANGED: Q$1,
  STORY_ERRORED: x$3,
  STORY_INDEX_INVALIDATED: m,
  STORY_MISSING: V$3,
  STORY_PREPARED: w$2,
  STORY_RENDER_PHASE_CHANGED: B$1,
  STORY_RENDERED: X$2,
  STORY_FINISHED: q$3,
  STORY_SPECIFIED: b$2,
  STORY_THREW_EXCEPTION: K$3,
  STORY_UNCHANGED: j$3,
  UPDATE_GLOBALS: k$3,
  UPDATE_QUERY_PARAMS: n,
  UPDATE_STORY_ARGS: z$2,
  REQUEST_WHATS_NEW_DATA: J$3,
  RESULT_WHATS_NEW_DATA: Z$1,
  SET_WHATS_NEW_CACHE: $$3,
  TOGGLE_WHATS_NEW_NOTIFICATIONS: v$2,
  TELEMETRY_ERROR: EE,
  SAVE_STORY_REQUEST: RE,
  SAVE_STORY_RESPONSE: _E,
  ARGTYPES_INFO_REQUEST: SE,
  ARGTYPES_INFO_RESPONSE: TE,
  TESTING_MODULE_CRASH_REPORT: NE,
  TESTING_MODULE_PROGRESS_REPORT: OE,
  TESTING_MODULE_RUN_REQUEST: AE,
  TESTING_MODULE_RUN_ALL_REQUEST: rE,
  TESTING_MODULE_CANCEL_TEST_RUN_REQUEST: DE,
  TESTING_MODULE_CANCEL_TEST_RUN_RESPONSE: IE
} = R$2;
const so$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ARGTYPES_INFO_REQUEST: SE,
  ARGTYPES_INFO_RESPONSE: TE,
  CHANNEL_CREATED: T$3,
  CHANNEL_WS_DISCONNECT: S$3,
  CONFIG_ERROR: N$1,
  CREATE_NEW_STORYFILE_REQUEST: O$2,
  CREATE_NEW_STORYFILE_RESPONSE: A$1,
  CURRENT_STORY_WAS_SET: r$1,
  DOCS_PREPARED: D$2,
  DOCS_RENDERED: I$3,
  FILE_COMPONENT_SEARCH_REQUEST: o$1,
  FILE_COMPONENT_SEARCH_RESPONSE: C$2,
  FORCE_REMOUNT: P$4,
  FORCE_RE_RENDER: L$3,
  GLOBALS_UPDATED: U$3,
  NAVIGATE_URL: G$3,
  PLAY_FUNCTION_THREW_EXCEPTION: a$1,
  PRELOAD_ENTRIES: t$1,
  PREVIEW_BUILDER_PROGRESS: d,
  PREVIEW_KEYDOWN: e,
  REGISTER_SUBSCRIPTION: H$3,
  REQUEST_WHATS_NEW_DATA: J$3,
  RESET_STORY_ARGS: W$3,
  RESULT_WHATS_NEW_DATA: Z$1,
  SAVE_STORY_REQUEST: RE,
  SAVE_STORY_RESPONSE: _E,
  SELECT_STORY: l,
  SET_CONFIG: i,
  SET_CURRENT_STORY: p$1,
  SET_FILTER: F$3,
  SET_GLOBALS: u,
  SET_INDEX: M$2,
  SET_STORIES: s$2,
  SET_WHATS_NEW_CACHE: $$3,
  SHARED_STATE_CHANGED: y$1,
  SHARED_STATE_SET: c,
  STORIES_COLLAPSE_ALL: g,
  STORIES_EXPAND_ALL: h$1,
  STORY_ARGS_UPDATED: f$2,
  STORY_CHANGED: Q$1,
  STORY_ERRORED: x$3,
  STORY_FINISHED: q$3,
  STORY_INDEX_INVALIDATED: m,
  STORY_MISSING: V$3,
  STORY_PREPARED: w$2,
  STORY_RENDERED: X$2,
  STORY_RENDER_PHASE_CHANGED: B$1,
  STORY_SPECIFIED: b$2,
  STORY_THREW_EXCEPTION: K$3,
  STORY_UNCHANGED: j$3,
  TELEMETRY_ERROR: EE,
  TESTING_MODULE_CANCEL_TEST_RUN_REQUEST: DE,
  TESTING_MODULE_CANCEL_TEST_RUN_RESPONSE: IE,
  TESTING_MODULE_CRASH_REPORT: NE,
  TESTING_MODULE_PROGRESS_REPORT: OE,
  TESTING_MODULE_RUN_ALL_REQUEST: rE,
  TESTING_MODULE_RUN_REQUEST: AE,
  TOGGLE_WHATS_NEW_NOTIFICATIONS: v$2,
  UNHANDLED_ERRORS_WHILE_PLAYING: Y$3,
  UPDATE_GLOBALS: k$3,
  UPDATE_QUERY_PARAMS: n,
  UPDATE_STORY_ARGS: z$2,
  default: _$2
}, Symbol.toStringTag, { value: "Module" }));
var ae$1 = Object.create, ut$1 = Object.defineProperty, se$1 = Object.getOwnPropertyDescriptor, le$1 = Object.getOwnPropertyNames, ce$1 = Object.getPrototypeOf, pe = Object.prototype.hasOwnProperty, a = (pt, yt) => ut$1(pt, "name", { value: yt, configurable: !0 }), H$2 = /* @__PURE__ */ ((pt) => typeof require < "u" ? require : typeof Proxy < "u" ? new Proxy(pt, {
  get: (yt, ir) => (typeof require < "u" ? require : yt)[ir]
}) : pt)(function(pt) {
  if (typeof require < "u") return require.apply(this, arguments);
  throw Error('Dynamic require of "' + pt + '" is not supported');
}), ue = (pt, yt) => () => (yt || pt((yt = { exports: {} }).exports, yt), yt.exports), fe$1 = (pt, yt, ir, ti) => {
  if (yt && typeof yt == "object" || typeof yt == "function")
    for (let ii of le$1(yt))
      !pe.call(pt, ii) && ii !== ir && ut$1(pt, ii, { get: () => yt[ii], enumerable: !(ti = se$1(yt, ii)) || ti.enumerable });
  return pt;
}, he$1 = (pt, yt, ir) => (ir = pt != null ? ae$1(ce$1(pt)) : {}, fe$1(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  ut$1(ir, "default", { value: pt, enumerable: !0 }),
  pt
)), xt$1 = ue((pt, yt) => {
  (function(ir) {
    if (typeof pt == "object" && typeof yt < "u")
      yt.exports = ir();
    else if (typeof define == "function" && define.amd)
      define([], ir);
    else {
      var ti;
      typeof window < "u" ? ti = window : typeof global < "u" ? ti = global : typeof self < "u" ? ti = self : ti = this, ti.memoizerific = ir();
    }
  })(function() {
    return (/* @__PURE__ */ a(function ir(ti, ii, ui) {
      function ai(si, di) {
        if (!ii[si]) {
          if (!ti[si]) {
            var fi = typeof H$2 == "function" && H$2;
            if (!di && fi) return fi(si, !0);
            if (li) return li(si, !0);
            var gi = new Error("Cannot find module '" + si + "'");
            throw gi.code = "MODULE_NOT_FOUND", gi;
          }
          var mi = ii[si] = { exports: {} };
          ti[si][0].call(mi.exports, function(Ti) {
            var vi = ti[si][1][Ti];
            return ai(vi || Ti);
          }, mi, mi.exports, ir, ti, ii, ui);
        }
        return ii[si].exports;
      }
      a(ai, "s");
      for (var li = typeof H$2 == "function" && H$2, oi = 0; oi < ui.length; oi++) ai(ui[oi]);
      return ai;
    }, "e"))({ 1: [function(ir, ti, ii) {
      ti.exports = function(ui) {
        if (typeof Map != "function" || ui) {
          var ai = ir("./similar");
          return new ai();
        } else
          return /* @__PURE__ */ new Map();
      };
    }, { "./similar": 2 }], 2: [function(ir, ti, ii) {
      function ui() {
        return this.list = [], this.lastItem = void 0, this.size = 0, this;
      }
      a(ui, "Similar"), ui.prototype.get = function(ai) {
        var li;
        if (this.lastItem && this.isEqual(this.lastItem.key, ai))
          return this.lastItem.val;
        if (li = this.indexOf(ai), li >= 0)
          return this.lastItem = this.list[li], this.list[li].val;
      }, ui.prototype.set = function(ai, li) {
        var oi;
        return this.lastItem && this.isEqual(this.lastItem.key, ai) ? (this.lastItem.val = li, this) : (oi = this.indexOf(ai), oi >= 0 ? (this.lastItem = this.list[oi], this.list[oi].val = li, this) : (this.lastItem = { key: ai, val: li }, this.list.push(this.lastItem), this.size++, this));
      }, ui.prototype.delete = function(ai) {
        var li;
        if (this.lastItem && this.isEqual(this.lastItem.key, ai) && (this.lastItem = void 0), li = this.indexOf(ai), li >= 0)
          return this.size--, this.list.splice(li, 1)[0];
      }, ui.prototype.has = function(ai) {
        var li;
        return this.lastItem && this.isEqual(this.lastItem.key, ai) ? !0 : (li = this.indexOf(ai), li >= 0 ? (this.lastItem = this.list[li], !0) : !1);
      }, ui.prototype.forEach = function(ai, li) {
        var oi;
        for (oi = 0; oi < this.size; oi++)
          ai.call(li || this, this.list[oi].val, this.list[oi].key, this);
      }, ui.prototype.indexOf = function(ai) {
        var li;
        for (li = 0; li < this.size; li++)
          if (this.isEqual(this.list[li].key, ai))
            return li;
        return -1;
      }, ui.prototype.isEqual = function(ai, li) {
        return ai === li || ai !== ai && li !== li;
      }, ti.exports = ui;
    }, {}], 3: [function(ir, ti, ii) {
      var ui = ir("map-or-similar");
      ti.exports = function(si) {
        var di = new ui(!1), fi = [];
        return function(gi) {
          var mi = /* @__PURE__ */ a(function() {
            var Ti = di, vi, xi, Si = arguments.length - 1, Pi = Array(Si + 1), $i = !0, Oi;
            if ((mi.numArgs || mi.numArgs === 0) && mi.numArgs !== Si + 1)
              throw new Error("Memoizerific functions should always be called with the same number of arguments");
            for (Oi = 0; Oi < Si; Oi++) {
              if (Pi[Oi] = {
                cacheItem: Ti,
                arg: arguments[Oi]
              }, Ti.has(arguments[Oi])) {
                Ti = Ti.get(arguments[Oi]);
                continue;
              }
              $i = !1, vi = new ui(!1), Ti.set(arguments[Oi], vi), Ti = vi;
            }
            return $i && (Ti.has(arguments[Si]) ? xi = Ti.get(arguments[Si]) : $i = !1), $i || (xi = gi.apply(null, arguments), Ti.set(arguments[Si], xi)), si > 0 && (Pi[Si] = {
              cacheItem: Ti,
              arg: arguments[Si]
            }, $i ? ai(fi, Pi) : fi.push(Pi), fi.length > si && li(fi.shift())), mi.wasMemoized = $i, mi.numArgs = Si + 1, xi;
          }, "memoizerific");
          return mi.limit = si, mi.wasMemoized = !1, mi.cache = di, mi.lru = fi, mi;
        };
      };
      function ai(si, di) {
        var fi = si.length, gi = di.length, mi, Ti, vi;
        for (Ti = 0; Ti < fi; Ti++) {
          for (mi = !0, vi = 0; vi < gi; vi++)
            if (!oi(si[Ti][vi].arg, di[vi].arg)) {
              mi = !1;
              break;
            }
          if (mi)
            break;
        }
        si.push(si.splice(Ti, 1)[0]);
      }
      a(ai, "moveToMostRecentLru");
      function li(si) {
        var di = si.length, fi = si[di - 1], gi, mi;
        for (fi.cacheItem.delete(fi.arg), mi = di - 2; mi >= 0 && (fi = si[mi], gi = fi.cacheItem.get(fi.arg), !gi || !gi.size); mi--)
          fi.cacheItem.delete(fi.arg);
      }
      a(li, "removeCachedResult");
      function oi(si, di) {
        return si === di || si !== si && di !== di;
      }
      a(oi, "isEqual");
    }, { "map-or-similar": 1 }] }, {}, [3])(3);
  });
}), S$2 = (() => {
  let pt;
  return typeof window < "u" ? pt = window : typeof globalThis < "u" ? pt = globalThis : typeof global < "u" ? pt = global : typeof self < "u" ? pt = self : pt = {}, pt;
})();
function F$2(pt) {
  for (var yt = [], ir = 1; ir < arguments.length; ir++)
    yt[ir - 1] = arguments[ir];
  var ti = Array.from(typeof pt == "string" ? [pt] : pt);
  ti[ti.length - 1] = ti[ti.length - 1].replace(/\r?\n([\t ]*)$/, "");
  var ii = ti.reduce(function(li, oi) {
    var si = oi.match(/\n([\t ]+|(?!\s).)/g);
    return si ? li.concat(si.map(function(di) {
      var fi, gi;
      return (gi = (fi = di.match(/[\t ]/g)) === null || fi === void 0 ? void 0 : fi.length) !== null && gi !== void 0 ? gi : 0;
    })) : li;
  }, []);
  if (ii.length) {
    var ui = new RegExp(`
[	 ]{` + Math.min.apply(Math, ii) + "}", "g");
    ti = ti.map(function(li) {
      return li.replace(ui, `
`);
    });
  }
  ti[0] = ti[0].replace(/^\r?\n/, "");
  var ai = ti[0];
  return yt.forEach(function(li, oi) {
    var si = ai.match(/(?:^|\n)( *)$/), di = si ? si[1] : "", fi = li;
    typeof li == "string" && li.includes(`
`) && (fi = String(li).split(`
`).map(function(gi, mi) {
      return mi === 0 ? gi : "" + di + gi;
    }).join(`
`)), ai += fi + ti[oi + 1];
  }), ai;
}
a(F$2, "dedent");
var ft = /* @__PURE__ */ new Map(), ye = "UNIVERSAL_STORE:", x$2 = {
  PENDING: "PENDING",
  RESOLVED: "RESOLVED",
  REJECTED: "REJECTED"
}, h = class dc {
  constructor(yt, ir) {
    if (this.debugging = !1, this.listeners = /* @__PURE__ */ new Map([["*", /* @__PURE__ */ new Set()]]), this.getState = /* @__PURE__ */ a(() => (this.debug("getState", { state: this.state }), this.state), "getState"), this.subscribe = /* @__PURE__ */ a((ti, ii) => {
      let ui = typeof ti == "function", ai = ui ? "*" : ti, li = ui ? ti : ii;
      if (this.debug("subscribe", { eventType: ai, listener: li }), !li)
        throw new TypeError(
          `Missing first subscribe argument, or second if first is the event type, when subscribing to a UniversalStore with id '${this.id}'`
        );
      return this.listeners.has(ai) || this.listeners.set(ai, /* @__PURE__ */ new Set()), this.listeners.get(ai).add(li), () => {
        var oi;
        this.debug("unsubscribe", { eventType: ai, listener: li }), this.listeners.has(ai) && (this.listeners.get(ai).delete(li), ((oi = this.listeners.get(ai)) == null ? void 0 : oi.size) === 0 && this.listeners.delete(ai));
      };
    }, "subscribe"), this.send = /* @__PURE__ */ a((ti) => {
      if (this.debug("send", { event: ti }), this.status !== dc.Status.READY)
        throw new TypeError(
          F$2`Cannot send event before store is ready. You can get the current status with store.status,
        or await store.readyPromise to wait for the store to be ready before sending events.
        ${JSON.stringify(
            {
              event: ti,
              id: this.id,
              actor: this.actor,
              environment: this.environment
            },
            null,
            2
          )}`
        );
      this.emitToListeners(ti, { actor: this.actor }), this.emitToChannel(ti, { actor: this.actor });
    }, "send"), this.debugging = yt.debug ?? !1, !dc.isInternalConstructing)
      throw new TypeError(
        "UniversalStore is not constructable - use UniversalStore.create() instead"
      );
    if (dc.isInternalConstructing = !1, this.id = yt.id, this.actorId = Date.now().toString(36) + Math.random().toString(36).substring(2), this.actorType = yt.leader ? dc.ActorType.LEADER : dc.ActorType.FOLLOWER, this.state = yt.initialState, this.channelEventName = `${ye}${this.id}`, this.debug("constructor", {
      options: yt,
      environmentOverrides: ir,
      channelEventName: this.channelEventName
    }), this.actor.type === dc.ActorType.LEADER)
      this.syncing = {
        state: x$2.RESOLVED,
        promise: Promise.resolve()
      };
    else {
      let ti, ii, ui = new Promise((ai, li) => {
        ti = /* @__PURE__ */ a(() => {
          this.syncing.state === x$2.PENDING && (this.syncing.state = x$2.RESOLVED, ai());
        }, "syncingResolve"), ii = /* @__PURE__ */ a((oi) => {
          this.syncing.state === x$2.PENDING && (this.syncing.state = x$2.REJECTED, li(oi));
        }, "syncingReject");
      });
      this.syncing = {
        state: x$2.PENDING,
        promise: ui,
        resolve: ti,
        reject: ii
      };
    }
    this.getState = this.getState.bind(this), this.setState = this.setState.bind(this), this.subscribe = this.subscribe.bind(this), this.onStateChange = this.onStateChange.bind(this), this.send = this.send.bind(this), this.emitToChannel = this.emitToChannel.bind(this), this.prepareThis = this.prepareThis.bind(this), this.emitToListeners = this.emitToListeners.bind(this), this.handleChannelEvents = this.handleChannelEvents.bind(
      this
    ), this.debug = this.debug.bind(this), this.channel = (ir == null ? void 0 : ir.channel) ?? dc.preparation.channel, this.environment = (ir == null ? void 0 : ir.environment) ?? dc.preparation.environment, this.channel && this.environment ? this.prepareThis({ channel: this.channel, environment: this.environment }) : dc.preparation.promise.then(this.prepareThis);
  }
  static setupPreparationPromise() {
    let yt, ir, ti = new Promise(
      (ii, ui) => {
        yt = /* @__PURE__ */ a((ai) => {
          ii(ai);
        }, "resolveRef"), ir = /* @__PURE__ */ a((...ai) => {
          ui(ai);
        }, "rejectRef");
      }
    );
    dc.preparation = {
      resolve: yt,
      reject: ir,
      promise: ti
    };
  }
  /** The actor object representing the store instance with a unique ID and a type */
  get actor() {
    return Object.freeze({
      id: this.actorId,
      type: this.actorType,
      environment: this.environment ?? dc.Environment.UNKNOWN
    });
  }
  /**
   * The current state of the store, that signals both if the store is prepared by Storybook and
   * also - in the case of a follower - if the state has been synced with the leader's state.
   */
  get status() {
    var yt;
    if (!this.channel || !this.environment)
      return dc.Status.UNPREPARED;
    switch ((yt = this.syncing) == null ? void 0 : yt.state) {
      case x$2.PENDING:
      case void 0:
        return dc.Status.SYNCING;
      case x$2.REJECTED:
        return dc.Status.ERROR;
      case x$2.RESOLVED:
      default:
        return dc.Status.READY;
    }
  }
  /**
   * A promise that resolves when the store is fully ready. A leader will be ready when the store
   * has been prepared by Storybook, which is almost instantly.
   *
   * A follower will be ready when the state has been synced with the leader's state, within a few
   * hundred milliseconds.
   */
  untilReady() {
    var yt;
    return Promise.all([dc.preparation.promise, (yt = this.syncing) == null ? void 0 : yt.promise]);
  }
  /** Creates a new instance of UniversalStore */
  static create(yt) {
    if (!yt || typeof (yt == null ? void 0 : yt.id) != "string")
      throw new TypeError("id is required and must be a string, when creating a UniversalStore");
    yt.debug && console.debug(
      F$2`[UniversalStore]
        create`,
      { options: yt }
    );
    let ir = ft.get(yt.id);
    if (ir)
      return console.warn(F$2`UniversalStore with id "${yt.id}" already exists in this environment, re-using existing.
        You should reuse the existing instance instead of trying to create a new one.`), ir;
    dc.isInternalConstructing = !0;
    let ti = new dc(yt);
    return ft.set(yt.id, ti), ti;
  }
  /**
   * Used by Storybook to set the channel for all instances of UniversalStore in the given
   * environment.
   *
   * @internal
   */
  static __prepare(yt, ir) {
    dc.preparation.channel = yt, dc.preparation.environment = ir, dc.preparation.resolve({ channel: yt, environment: ir });
  }
  /**
   * Updates the store's state
   *
   * Either a new state or a state updater function can be passed to the method.
   */
  setState(yt) {
    let ir = this.state, ti = typeof yt == "function" ? yt(ir) : yt;
    if (this.debug("setState", { newState: ti, previousState: ir, updater: yt }), this.status !== dc.Status.READY)
      throw new TypeError(
        F$2`Cannot set state before store is ready. You can get the current status with store.status,
        or await store.readyPromise to wait for the store to be ready before sending events.
        ${JSON.stringify(
          {
            newState: ti,
            id: this.id,
            actor: this.actor,
            environment: this.environment
          },
          null,
          2
        )}`
      );
    this.state = ti;
    let ii = {
      type: dc.InternalEventType.SET_STATE,
      payload: {
        state: ti,
        previousState: ir
      }
    };
    this.emitToChannel(ii, { actor: this.actor }), this.emitToListeners(ii, { actor: this.actor });
  }
  /**
   * Subscribes to state changes
   *
   * @returns Unsubscribe function
   */
  onStateChange(yt) {
    return this.debug("onStateChange", { listener: yt }), this.subscribe(
      dc.InternalEventType.SET_STATE,
      ({ payload: ir }, ti) => {
        yt(ir.state, ir.previousState, ti);
      }
    );
  }
  emitToChannel(yt, ir) {
    var ti;
    this.debug("emitToChannel", { event: yt, eventInfo: ir, channel: this.channel }), (ti = this.channel) == null || ti.emit(this.channelEventName, {
      event: yt,
      eventInfo: ir
    });
  }
  prepareThis({
    channel: yt,
    environment: ir
  }) {
    this.channel = yt, this.environment = ir, this.debug("prepared", { channel: yt, environment: ir }), this.channel.on(this.channelEventName, this.handleChannelEvents), this.actor.type === dc.ActorType.LEADER ? this.emitToChannel(
      { type: dc.InternalEventType.LEADER_CREATED },
      { actor: this.actor }
    ) : (this.emitToChannel(
      { type: dc.InternalEventType.FOLLOWER_CREATED },
      { actor: this.actor }
    ), this.emitToChannel(
      { type: dc.InternalEventType.EXISTING_STATE_REQUEST },
      { actor: this.actor }
    ), setTimeout(() => {
      this.syncing.reject(
        new TypeError(
          `No existing state found for follower with id: '${this.id}'. Make sure a leader with the same id exists before creating a follower.`
        )
      );
    }, 1e3));
  }
  emitToListeners(yt, ir) {
    let ti = this.listeners.get(yt.type), ii = this.listeners.get("*");
    this.debug("emitToListeners", {
      event: yt,
      eventInfo: ir,
      eventTypeListeners: ti,
      everythingListeners: ii
    }), [...ti ?? [], ...ii ?? []].forEach(
      (ui) => ui(yt, ir)
    );
  }
  handleChannelEvents(yt) {
    var ir, ti, ii, ui, ai;
    let { event: li, eventInfo: oi } = yt;
    if ([oi.actor.id, (ir = oi.forwardingActor) == null ? void 0 : ir.id].includes(this.actor.id)) {
      this.debug("handleChannelEvents: Ignoring event from self", { channelEvent: yt });
      return;
    } else if (((ti = this.syncing) == null ? void 0 : ti.state) === x$2.PENDING && li.type !== dc.InternalEventType.EXISTING_STATE_RESPONSE) {
      this.debug("handleChannelEvents: Ignoring event while syncing", { channelEvent: yt });
      return;
    }
    if (this.debug("handleChannelEvents", { channelEvent: yt }), this.actor.type === dc.ActorType.LEADER) {
      let si = !0;
      switch (li.type) {
        case dc.InternalEventType.EXISTING_STATE_REQUEST:
          si = !1;
          let di = {
            type: dc.InternalEventType.EXISTING_STATE_RESPONSE,
            payload: this.state
          };
          this.debug("handleChannelEvents: responding to existing state request", {
            responseEvent: di
          }), this.emitToChannel(di, { actor: this.actor });
          break;
        case dc.InternalEventType.LEADER_CREATED:
          si = !1, this.syncing.state = x$2.REJECTED, this.debug("handleChannelEvents: erroring due to second leader being created", {
            event: li
          }), console.error(
            F$2`Detected multiple UniversalStore leaders created with the same id "${this.id}".
            Only one leader can exists at a time, your stores are now in an invalid state.
            Leaders detected:
            this: ${JSON.stringify(this.actor, null, 2)}
            other: ${JSON.stringify(oi.actor, null, 2)}`
          );
          break;
      }
      si && (this.debug("handleChannelEvents: forwarding event", { channelEvent: yt }), this.emitToChannel(li, { actor: oi.actor, forwardingActor: this.actor }));
    }
    if (this.actor.type === dc.ActorType.FOLLOWER)
      switch (li.type) {
        case dc.InternalEventType.EXISTING_STATE_RESPONSE:
          if (this.debug("handleChannelEvents: Setting state from leader's existing state response", {
            event: li
          }), ((ii = this.syncing) == null ? void 0 : ii.state) !== x$2.PENDING)
            break;
          (ai = (ui = this.syncing).resolve) == null || ai.call(ui);
          let si = {
            type: dc.InternalEventType.SET_STATE,
            payload: {
              state: li.payload,
              previousState: this.state
            }
          };
          this.state = li.payload, this.emitToListeners(si, oi);
          break;
      }
    switch (li.type) {
      case dc.InternalEventType.SET_STATE:
        this.debug("handleChannelEvents: Setting state", { event: li }), this.state = li.payload.state;
        break;
    }
    this.emitToListeners(li, { actor: oi.actor });
  }
  debug(yt, ir) {
    this.debugging && console.debug(
      F$2`[UniversalStore::${this.id}::${this.environment ?? dc.Environment.UNKNOWN}]
        ${yt}`,
      JSON.stringify(
        {
          data: ir,
          actor: this.actor,
          state: this.state,
          status: this.status
        },
        null,
        2
      )
    );
  }
  /**
   * Used to reset the static fields of the UniversalStore class when cleaning up tests
   *
   * @internal
   */
  static __reset() {
    dc.preparation.reject(new Error("reset")), dc.setupPreparationPromise(), dc.isInternalConstructing = !1;
  }
};
a(h, "UniversalStore"), /**
* Defines the possible actor types in the store system
*
* @readonly
*/
h.ActorType = {
  LEADER: "LEADER",
  FOLLOWER: "FOLLOWER"
}, /**
* Defines the possible environments the store can run in
*
* @readonly
*/
h.Environment = {
  SERVER: "SERVER",
  MANAGER: "MANAGER",
  PREVIEW: "PREVIEW",
  UNKNOWN: "UNKNOWN",
  MOCK: "MOCK"
}, /**
* Internal event types used for store synchronization
*
* @readonly
*/
h.InternalEventType = {
  EXISTING_STATE_REQUEST: "__EXISTING_STATE_REQUEST",
  EXISTING_STATE_RESPONSE: "__EXISTING_STATE_RESPONSE",
  SET_STATE: "__SET_STATE",
  LEADER_CREATED: "__LEADER_CREATED",
  FOLLOWER_CREATED: "__FOLLOWER_CREATED"
}, h.Status = {
  UNPREPARED: "UNPREPARED",
  SYNCING: "SYNCING",
  READY: "READY",
  ERROR: "ERROR"
}, // This is used to check if constructor was called from the static factory create()
h.isInternalConstructing = !1, h.setupPreparationPromise();
var $$2 = h, de = /* @__PURE__ */ a((pt) => pt.transports !== void 0, "isMulti"), ge$1 = /* @__PURE__ */ a(() => Math.random().toString(16).slice(2), "generateRandomId"), ht$1 = class {
  constructor(pt = {}) {
    this.sender = ge$1(), this.events = {}, this.data = {}, this.transports = [], this.isAsync = pt.async || !1, de(pt) ? (this.transports = pt.transports || [], this.transports.forEach((yt) => {
      yt.setHandler((ir) => this.handleEvent(ir));
    })) : this.transports = pt.transport ? [pt.transport] : [], this.transports.forEach((yt) => {
      yt.setHandler((ir) => this.handleEvent(ir));
    });
  }
  get hasTransport() {
    return this.transports.length > 0;
  }
  addListener(pt, yt) {
    this.events[pt] = this.events[pt] || [], this.events[pt].push(yt);
  }
  emit(pt, ...yt) {
    let ir = { type: pt, args: yt, from: this.sender }, ti = {};
    yt.length >= 1 && yt[0] && yt[0].options && (ti = yt[0].options);
    let ii = /* @__PURE__ */ a(() => {
      this.transports.forEach((ui) => {
        ui.send(ir, ti);
      }), this.handleEvent(ir);
    }, "handler");
    this.isAsync ? setImmediate(ii) : ii();
  }
  last(pt) {
    return this.data[pt];
  }
  eventNames() {
    return Object.keys(this.events);
  }
  listenerCount(pt) {
    let yt = this.listeners(pt);
    return yt ? yt.length : 0;
  }
  listeners(pt) {
    return this.events[pt] || void 0;
  }
  once(pt, yt) {
    let ir = this.onceListener(pt, yt);
    this.addListener(pt, ir);
  }
  removeAllListeners(pt) {
    pt ? this.events[pt] && delete this.events[pt] : this.events = {};
  }
  removeListener(pt, yt) {
    let ir = this.listeners(pt);
    ir && (this.events[pt] = ir.filter((ti) => ti !== yt));
  }
  on(pt, yt) {
    this.addListener(pt, yt);
  }
  off(pt, yt) {
    this.removeListener(pt, yt);
  }
  handleEvent(pt) {
    let yt = this.listeners(pt.type);
    yt && yt.length && yt.forEach((ir) => {
      ir.apply(pt, pt.args);
    }), this.data[pt.type] = pt.args;
  }
  onceListener(pt, yt) {
    let ir = /* @__PURE__ */ a((...ti) => (this.removeListener(pt, ir), yt(...ti)), "onceListener");
    return ir;
  }
};
a(ht$1, "Channel");
var B = ht$1, ve$1 = Object.create, Ot$1 = Object.defineProperty, me$1 = Object.getOwnPropertyDescriptor, Ct$1 = Object.getOwnPropertyNames, Ee$1 = Object.getPrototypeOf, be$1 = Object.prototype.hasOwnProperty, P$3 = /* @__PURE__ */ a((pt, yt) => /* @__PURE__ */ a(function() {
  return yt || (0, pt[Ct$1(pt)[0]])((yt = { exports: {} }).exports, yt), yt.exports;
}, "__require"), "__commonJS"), Se$1 = /* @__PURE__ */ a((pt, yt, ir, ti) => {
  if (yt && typeof yt == "object" || typeof yt == "function")
    for (let ii of Ct$1(yt))
      !be$1.call(pt, ii) && ii !== ir && Ot$1(pt, ii, { get: /* @__PURE__ */ a(() => yt[ii], "get"), enumerable: !(ti = me$1(yt, ii)) || ti.enumerable });
  return pt;
}, "__copyProps"), ot$1 = /* @__PURE__ */ a((pt, yt, ir) => (ir = pt != null ? ve$1(Ee$1(pt)) : {}, Se$1(
  yt || !pt || !pt.__esModule ? Ot$1(ir, "default", { value: pt, enumerable: !0 }) : ir,
  pt
)), "__toESM"), _e$1 = [
  "bubbles",
  "cancelBubble",
  "cancelable",
  "composed",
  "currentTarget",
  "defaultPrevented",
  "eventPhase",
  "isTrusted",
  "returnValue",
  "srcElement",
  "target",
  "timeStamp",
  "type"
], Te$1 = ["detail"];
function Pt(pt) {
  let yt = _e$1.filter((ir) => pt[ir] !== void 0).reduce((ir, ti) => ({ ...ir, [ti]: pt[ti] }), {});
  return pt instanceof CustomEvent && Te$1.filter((ir) => pt[ir] !== void 0).forEach((ir) => {
    yt[ir] = pt[ir];
  }), yt;
}
a(Pt, "extractEventHiddenProperties");
var Bt$1 = he$1(xt$1()), Ft = P$3({
  "node_modules/has-symbols/shams.js"(pt, yt) {
    yt.exports = /* @__PURE__ */ a(function() {
      if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
        return !1;
      if (typeof Symbol.iterator == "symbol")
        return !0;
      var ir = {}, ti = Symbol("test"), ii = Object(ti);
      if (typeof ti == "string" || Object.prototype.toString.call(ti) !== "[object Symbol]" || Object.prototype.toString.call(ii) !== "[object Symbol]")
        return !1;
      var ui = 42;
      ir[ti] = ui;
      for (ti in ir)
        return !1;
      if (typeof Object.keys == "function" && Object.keys(ir).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(
        ir
      ).length !== 0)
        return !1;
      var ai = Object.getOwnPropertySymbols(ir);
      if (ai.length !== 1 || ai[0] !== ti || !Object.prototype.propertyIsEnumerable.call(ir, ti))
        return !1;
      if (typeof Object.getOwnPropertyDescriptor == "function") {
        var li = Object.getOwnPropertyDescriptor(ir, ti);
        if (li.value !== ui || li.enumerable !== !0)
          return !1;
      }
      return !0;
    }, "hasSymbols");
  }
}), Mt$1 = P$3({
  "node_modules/has-symbols/index.js"(pt, yt) {
    var ir = typeof Symbol < "u" && Symbol, ti = Ft();
    yt.exports = /* @__PURE__ */ a(function() {
      return typeof ir != "function" || typeof Symbol != "function" || typeof ir("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : ti();
    }, "hasNativeSymbols");
  }
}), Ae$1 = P$3({
  "node_modules/function-bind/implementation.js"(pt, yt) {
    var ir = "Function.prototype.bind called on incompatible ", ti = Array.prototype.slice, ii = Object.prototype.toString, ui = "[object Function]";
    yt.exports = /* @__PURE__ */ a(function(ai) {
      var li = this;
      if (typeof li != "function" || ii.call(li) !== ui)
        throw new TypeError(ir + li);
      for (var oi = ti.call(arguments, 1), si, di = /* @__PURE__ */ a(function() {
        if (this instanceof si) {
          var vi = li.apply(
            this,
            oi.concat(ti.call(arguments))
          );
          return Object(vi) === vi ? vi : this;
        } else
          return li.apply(
            ai,
            oi.concat(ti.call(arguments))
          );
      }, "binder"), fi = Math.max(0, li.length - oi.length), gi = [], mi = 0; mi < fi; mi++)
        gi.push("$" + mi);
      if (si = Function("binder", "return function (" + gi.join(",") + "){ return binder.apply(this,arguments); }")(di), li.prototype) {
        var Ti = /* @__PURE__ */ a(function() {
        }, "Empty2");
        Ti.prototype = li.prototype, si.prototype = new Ti(), Ti.prototype = null;
      }
      return si;
    }, "bind");
  }
}), gt$1 = P$3({
  "node_modules/function-bind/index.js"(pt, yt) {
    var ir = Ae$1();
    yt.exports = Function.prototype.bind || ir;
  }
}), we$1 = P$3({
  "node_modules/has/src/index.js"(pt, yt) {
    var ir = gt$1();
    yt.exports = ir.call(Function.call, Object.prototype.hasOwnProperty);
  }
}), $t$1 = P$3({
  "node_modules/get-intrinsic/index.js"(pt, yt) {
    var ir, ti = SyntaxError, ii = Function, ui = TypeError, ai = /* @__PURE__ */ a(function(Li) {
      try {
        return ii('"use strict"; return (' + Li + ").constructor;")();
      } catch {
      }
    }, "getEvalledConstructor"), li = Object.getOwnPropertyDescriptor;
    if (li)
      try {
        li({}, "");
      } catch {
        li = null;
      }
    var oi = /* @__PURE__ */ a(function() {
      throw new ui();
    }, "throwTypeError"), si = li ? (function() {
      try {
        return arguments.callee, oi;
      } catch {
        try {
          return li(arguments, "callee").get;
        } catch {
          return oi;
        }
      }
    })() : oi, di = Mt$1()(), fi = Object.getPrototypeOf || function(Li) {
      return Li.__proto__;
    }, gi = {}, mi = typeof Uint8Array > "u" ? ir : fi(Uint8Array), Ti = {
      "%AggregateError%": typeof AggregateError > "u" ? ir : AggregateError,
      "%Array%": Array,
      "%ArrayBuffer%": typeof ArrayBuffer > "u" ? ir : ArrayBuffer,
      "%ArrayIteratorPrototype%": di ? fi([][Symbol.iterator]()) : ir,
      "%AsyncFromSyncIteratorPrototype%": ir,
      "%AsyncFunction%": gi,
      "%AsyncGenerator%": gi,
      "%AsyncGeneratorFunction%": gi,
      "%AsyncIteratorPrototype%": gi,
      "%Atomics%": typeof Atomics > "u" ? ir : Atomics,
      "%BigInt%": typeof BigInt > "u" ? ir : BigInt,
      "%Boolean%": Boolean,
      "%DataView%": typeof DataView > "u" ? ir : DataView,
      "%Date%": Date,
      "%decodeURI%": decodeURI,
      "%decodeURIComponent%": decodeURIComponent,
      "%encodeURI%": encodeURI,
      "%encodeURIComponent%": encodeURIComponent,
      "%Error%": Error,
      "%eval%": eval,
      "%EvalError%": EvalError,
      "%Float32Array%": typeof Float32Array > "u" ? ir : Float32Array,
      "%Float64Array%": typeof Float64Array > "u" ? ir : Float64Array,
      "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? ir : FinalizationRegistry,
      "%Function%": ii,
      "%GeneratorFunction%": gi,
      "%Int8Array%": typeof Int8Array > "u" ? ir : Int8Array,
      "%Int16Array%": typeof Int16Array > "u" ? ir : Int16Array,
      "%Int32Array%": typeof Int32Array > "u" ? ir : Int32Array,
      "%isFinite%": isFinite,
      "%isNaN%": isNaN,
      "%IteratorPrototype%": di ? fi(fi([][Symbol.iterator]())) : ir,
      "%JSON%": typeof JSON == "object" ? JSON : ir,
      "%Map%": typeof Map > "u" ? ir : Map,
      "%MapIteratorPrototype%": typeof Map > "u" || !di ? ir : fi((/* @__PURE__ */ new Map())[Symbol.iterator]()),
      "%Math%": Math,
      "%Number%": Number,
      "%Object%": Object,
      "%parseFloat%": parseFloat,
      "%parseInt%": parseInt,
      "%Promise%": typeof Promise > "u" ? ir : Promise,
      "%Proxy%": typeof Proxy > "u" ? ir : Proxy,
      "%RangeError%": RangeError,
      "%ReferenceError%": ReferenceError,
      "%Reflect%": typeof Reflect > "u" ? ir : Reflect,
      "%RegExp%": RegExp,
      "%Set%": typeof Set > "u" ? ir : Set,
      "%SetIteratorPrototype%": typeof Set > "u" || !di ? ir : fi((/* @__PURE__ */ new Set())[Symbol.iterator]()),
      "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? ir : SharedArrayBuffer,
      "%String%": String,
      "%StringIteratorPrototype%": di ? fi(""[Symbol.iterator]()) : ir,
      "%Symbol%": di ? Symbol : ir,
      "%SyntaxError%": ti,
      "%ThrowTypeError%": si,
      "%TypedArray%": mi,
      "%TypeError%": ui,
      "%Uint8Array%": typeof Uint8Array > "u" ? ir : Uint8Array,
      "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? ir : Uint8ClampedArray,
      "%Uint16Array%": typeof Uint16Array > "u" ? ir : Uint16Array,
      "%Uint32Array%": typeof Uint32Array > "u" ? ir : Uint32Array,
      "%URIError%": URIError,
      "%WeakMap%": typeof WeakMap > "u" ? ir : WeakMap,
      "%WeakRef%": typeof WeakRef > "u" ? ir : WeakRef,
      "%WeakSet%": typeof WeakSet > "u" ? ir : WeakSet
    }, vi = /* @__PURE__ */ a(function Li(Co) {
      var Ni;
      if (Co === "%AsyncFunction%")
        Ni = ai("async function () {}");
      else if (Co === "%GeneratorFunction%")
        Ni = ai("function* () {}");
      else if (Co === "%AsyncGeneratorFunction%")
        Ni = ai("async function* () {}");
      else if (Co === "%AsyncGenerator%") {
        var Yi = Li("%AsyncGeneratorFunction%");
        Yi && (Ni = Yi.prototype);
      } else if (Co === "%AsyncIteratorPrototype%") {
        var Vo = Li("%AsyncGenerator%");
        Vo && (Ni = fi(Vo.prototype));
      }
      return Ti[Co] = Ni, Ni;
    }, "doEval2"), xi = {
      "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
      "%ArrayPrototype%": ["Array", "prototype"],
      "%ArrayProto_entries%": ["Array", "prototype", "entries"],
      "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
      "%ArrayProto_keys%": ["Array", "prototype", "keys"],
      "%ArrayProto_values%": ["Array", "prototype", "values"],
      "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
      "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
      "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
      "%BooleanPrototype%": ["Boolean", "prototype"],
      "%DataViewPrototype%": ["DataView", "prototype"],
      "%DatePrototype%": ["Date", "prototype"],
      "%ErrorPrototype%": ["Error", "prototype"],
      "%EvalErrorPrototype%": ["EvalError", "prototype"],
      "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
      "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
      "%FunctionPrototype%": ["Function", "prototype"],
      "%Generator%": ["GeneratorFunction", "prototype"],
      "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
      "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
      "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
      "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
      "%JSONParse%": ["JSON", "parse"],
      "%JSONStringify%": ["JSON", "stringify"],
      "%MapPrototype%": ["Map", "prototype"],
      "%NumberPrototype%": ["Number", "prototype"],
      "%ObjectPrototype%": ["Object", "prototype"],
      "%ObjProto_toString%": ["Object", "prototype", "toString"],
      "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
      "%PromisePrototype%": ["Promise", "prototype"],
      "%PromiseProto_then%": ["Promise", "prototype", "then"],
      "%Promise_all%": ["Promise", "all"],
      "%Promise_reject%": ["Promise", "reject"],
      "%Promise_resolve%": ["Promise", "resolve"],
      "%RangeErrorPrototype%": ["RangeError", "prototype"],
      "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
      "%RegExpPrototype%": ["RegExp", "prototype"],
      "%SetPrototype%": ["Set", "prototype"],
      "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
      "%StringPrototype%": ["String", "prototype"],
      "%SymbolPrototype%": ["Symbol", "prototype"],
      "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
      "%TypedArrayPrototype%": ["TypedArray", "prototype"],
      "%TypeErrorPrototype%": ["TypeError", "prototype"],
      "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
      "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
      "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
      "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
      "%URIErrorPrototype%": ["URIError", "prototype"],
      "%WeakMapPrototype%": ["WeakMap", "prototype"],
      "%WeakSetPrototype%": ["WeakSet", "prototype"]
    }, Si = gt$1(), Pi = we$1(), $i = Si.call(Function.call, Array.prototype.concat), Oi = Si.call(Function.apply, Array.prototype.splice), Di = Si.call(
      Function.call,
      String.prototype.replace
    ), Mi = Si.call(Function.call, String.prototype.slice), Oo = Si.call(Function.call, RegExp.prototype.exec), io = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, xo = /\\(\\)?/g, fo = /* @__PURE__ */ a(
      function(Li) {
        var Co = Mi(Li, 0, 1), Ni = Mi(Li, -1);
        if (Co === "%" && Ni !== "%")
          throw new ti("invalid intrinsic syntax, expected closing `%`");
        if (Ni === "%" && Co !== "%")
          throw new ti("invalid intrinsic syntax, expected opening `%`");
        var Yi = [];
        return Di(Li, io, function(Vo, No, Ui, jo) {
          Yi[Yi.length] = Ui ? Di(jo, xo, "$1") : No || Vo;
        }), Yi;
      },
      "stringToPath3"
    ), _o = /* @__PURE__ */ a(function(Li, Co) {
      var Ni = Li, Yi;
      if (Pi(xi, Ni) && (Yi = xi[Ni], Ni = "%" + Yi[0] + "%"), Pi(Ti, Ni)) {
        var Vo = Ti[Ni];
        if (Vo === gi && (Vo = vi(Ni)), typeof Vo > "u" && !Co)
          throw new ui("intrinsic " + Li + " exists, but is not available. Please file an issue!");
        return {
          alias: Yi,
          name: Ni,
          value: Vo
        };
      }
      throw new ti("intrinsic " + Li + " does not exist!");
    }, "getBaseIntrinsic2");
    yt.exports = /* @__PURE__ */ a(function(Li, Co) {
      if (typeof Li != "string" || Li.length === 0)
        throw new ui("intrinsic name must be a non-empty string");
      if (arguments.length > 1 && typeof Co != "boolean")
        throw new ui('"allowMissing" argument must be a boolean');
      if (Oo(/^%?[^%]*%?$/, Li) === null)
        throw new ti("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
      var Ni = fo(Li), Yi = Ni.length > 0 ? Ni[0] : "", Vo = _o("%" + Yi + "%", Co), No = Vo.name, Ui = Vo.value, jo = !1, Wi = Vo.alias;
      Wi && (Yi = Wi[0], Oi(Ni, $i([0, 1], Wi)));
      for (var ji = 1, Hi = !0; ji < Ni.length; ji += 1) {
        var zo = Ni[ji], Lo = Mi(zo, 0, 1), sa = Mi(zo, -1);
        if ((Lo === '"' || Lo === "'" || Lo === "`" || sa === '"' || sa === "'" || sa === "`") && Lo !== sa)
          throw new ti("property names with quotes must have matching quotes");
        if ((zo === "constructor" || !Hi) && (jo = !0), Yi += "." + zo, No = "%" + Yi + "%", Pi(Ti, No))
          Ui = Ti[No];
        else if (Ui != null) {
          if (!(zo in Ui)) {
            if (!Co)
              throw new ui("base intrinsic for " + Li + " exists, but the property is not available.");
            return;
          }
          if (li && ji + 1 >= Ni.length) {
            var Ko = li(Ui, zo);
            Hi = !!Ko, Hi && "get" in Ko && !("originalValue" in Ko.get) ? Ui = Ko.get : Ui = Ui[zo];
          } else
            Hi = Pi(Ui, zo), Ui = Ui[zo];
          Hi && !jo && (Ti[No] = Ui);
        }
      }
      return Ui;
    }, "GetIntrinsic");
  }
}), Oe$1 = P$3({
  "node_modules/call-bind/index.js"(pt, yt) {
    var ir = gt$1(), ti = $t$1(), ii = ti("%Function.prototype.apply%"), ui = ti("%Function.prototype.call%"), ai = ti("%Reflect.apply%", !0) || ir.call(
      ui,
      ii
    ), li = ti("%Object.getOwnPropertyDescriptor%", !0), oi = ti("%Object.defineProperty%", !0), si = ti("%Math.max%");
    if (oi)
      try {
        oi({}, "a", { value: 1 });
      } catch {
        oi = null;
      }
    yt.exports = /* @__PURE__ */ a(function(fi) {
      var gi = ai(ir, ui, arguments);
      if (li && oi) {
        var mi = li(gi, "length");
        mi.configurable && oi(
          gi,
          "length",
          { value: 1 + si(0, fi.length - (arguments.length - 1)) }
        );
      }
      return gi;
    }, "callBind");
    var di = /* @__PURE__ */ a(function() {
      return ai(ir, ii, arguments);
    }, "applyBind2");
    oi ? oi(yt.exports, "apply", { value: di }) : yt.exports.apply = di;
  }
}), Ce = P$3({
  "node_modules/call-bind/callBound.js"(pt, yt) {
    var ir = $t$1(), ti = Oe$1(), ii = ti(ir("String.prototype.indexOf"));
    yt.exports = /* @__PURE__ */ a(function(ui, ai) {
      var li = ir(ui, !!ai);
      return typeof li == "function" && ii(ui, ".prototype.") > -1 ? ti(li) : li;
    }, "callBoundIntrinsic");
  }
}), Pe = P$3({
  "node_modules/has-tostringtag/shams.js"(pt, yt) {
    var ir = Ft();
    yt.exports = /* @__PURE__ */ a(function() {
      return ir() && !!Symbol.toStringTag;
    }, "hasToStringTagShams");
  }
}), Ie = P$3({
  "node_modules/is-regex/index.js"(pt, yt) {
    var ir = Ce(), ti = Pe()(), ii, ui, ai, li;
    ti && (ii = ir("Object.prototype.hasOwnProperty"), ui = ir("RegExp.prototype.exec"), ai = {}, oi = /* @__PURE__ */ a(function() {
      throw ai;
    }, "throwRegexMarker"), li = {
      toString: oi,
      valueOf: oi
    }, typeof Symbol.toPrimitive == "symbol" && (li[Symbol.toPrimitive] = oi));
    var oi, si = ir("Object.prototype.toString"), di = Object.getOwnPropertyDescriptor, fi = "[object RegExp]";
    yt.exports = /* @__PURE__ */ a(ti ? function(gi) {
      if (!gi || typeof gi != "object")
        return !1;
      var mi = di(gi, "lastIndex"), Ti = mi && ii(mi, "value");
      if (!Ti)
        return !1;
      try {
        ui(gi, li);
      } catch (vi) {
        return vi === ai;
      }
    } : function(gi) {
      return !gi || typeof gi != "object" && typeof gi != "function" ? !1 : si(gi) === fi;
    }, "isRegex");
  }
}), xe$1 = P$3({
  "node_modules/is-function/index.js"(pt, yt) {
    yt.exports = ti;
    var ir = Object.prototype.toString;
    function ti(ii) {
      if (!ii)
        return !1;
      var ui = ir.call(ii);
      return ui === "[object Function]" || typeof ii == "function" && ui !== "[object RegExp]" || typeof window < "u" && (ii === window.setTimeout || ii === window.alert || ii === window.confirm || ii === window.prompt);
    }
    a(ti, "isFunction3");
  }
}), Re$1 = P$3({
  "node_modules/is-symbol/index.js"(pt, yt) {
    var ir = Object.prototype.toString, ti = Mt$1()();
    ti ? (ii = Symbol.prototype.toString, ui = /^Symbol\(.*\)$/, ai = /* @__PURE__ */ a(function(li) {
      return typeof li.valueOf() != "symbol" ? !1 : ui.test(ii.call(li));
    }, "isRealSymbolObject"), yt.exports = /* @__PURE__ */ a(function(li) {
      if (typeof li == "symbol")
        return !0;
      if (ir.call(li) !== "[object Symbol]")
        return !1;
      try {
        return ai(li);
      } catch {
        return !1;
      }
    }, "isSymbol3")) : yt.exports = /* @__PURE__ */ a(function(li) {
      return !1;
    }, "isSymbol3");
    var ii, ui, ai;
  }
}), Ne$1 = ot$1(Ie()), je$1 = ot$1(xe$1()), Le$1 = ot$1(Re$1());
function De$1(pt) {
  return pt != null && typeof pt == "object" && Array.isArray(pt) === !1;
}
a(De$1, "isObject");
var Fe$1 = typeof global == "object" && global && global.Object === Object && global, Me$1 = Fe$1, $e$1 = typeof self == "object" && self && self.Object === Object && self, Ue$1 = Me$1 || $e$1 || Function("return this")(), vt$1 = Ue$1, ke$1 = vt$1.Symbol, U$2 = ke$1, Ut$1 = Object.prototype, Ge$1 = Ut$1.hasOwnProperty, We$1 = Ut$1.toString, q$2 = U$2 ? U$2.toStringTag : void 0;
function ze(pt) {
  var yt = Ge$1.call(pt, q$2), ir = pt[q$2];
  try {
    pt[q$2] = void 0;
    var ti = !0;
  } catch {
  }
  var ii = We$1.call(pt);
  return ti && (yt ? pt[q$2] = ir : delete pt[q$2]), ii;
}
a(ze, "getRawTag");
var He$1 = ze, Be$1 = Object.prototype, qe$1 = Be$1.toString;
function Ve(pt) {
  return qe$1.call(pt);
}
a(Ve, "objectToString");
var Je$1 = Ve, Ke$1 = "[object Null]", Ye$1 = "[object Undefined]", Rt = U$2 ? U$2.toStringTag : void 0;
function Xe$1(pt) {
  return pt == null ? pt === void 0 ? Ye$1 : Ke$1 : Rt && Rt in Object(pt) ? He$1(pt) : Je$1(pt);
}
a(Xe$1, "baseGetTag");
var kt$1 = Xe$1;
function Qe$1(pt) {
  return pt != null && typeof pt == "object";
}
a(Qe$1, "isObjectLike");
var Ze$1 = Qe$1, tr$1 = "[object Symbol]";
function er$1(pt) {
  return typeof pt == "symbol" || Ze$1(pt) && kt$1(pt) == tr$1;
}
a(er$1, "isSymbol");
var mt$1 = er$1;
function rr$1(pt, yt) {
  for (var ir = -1, ti = pt == null ? 0 : pt.length, ii = Array(ti); ++ir < ti; )
    ii[ir] = yt(pt[ir], ir, pt);
  return ii;
}
a(rr$1, "arrayMap");
var nr = rr$1, or$1 = Array.isArray, Et$1 = or$1, Nt$1 = U$2 ? U$2.prototype : void 0, jt$1 = Nt$1 ? Nt$1.toString : void 0;
function Gt$1(pt) {
  if (typeof pt == "string")
    return pt;
  if (Et$1(pt))
    return nr(pt, Gt$1) + "";
  if (mt$1(pt))
    return jt$1 ? jt$1.call(pt) : "";
  var yt = pt + "";
  return yt == "0" && 1 / pt == -1 / 0 ? "-0" : yt;
}
a(Gt$1, "baseToString");
var ar = Gt$1;
function sr$1(pt) {
  var yt = typeof pt;
  return pt != null && (yt == "object" || yt == "function");
}
a(sr$1, "isObject2");
var Wt$1 = sr$1, lr = "[object AsyncFunction]", cr$1 = "[object Function]", pr = "[object GeneratorFunction]", ur = "[object Proxy]";
function fr(pt) {
  if (!Wt$1(pt))
    return !1;
  var yt = kt$1(pt);
  return yt == cr$1 || yt == pr || yt == lr || yt == ur;
}
a(fr, "isFunction");
var hr = fr, yr = vt$1["__core-js_shared__"], dt$1 = yr, Lt$1 = (function() {
  var pt = /[^.]+$/.exec(dt$1 && dt$1.keys && dt$1.keys.IE_PROTO || "");
  return pt ? "Symbol(src)_1." + pt : "";
})();
function dr(pt) {
  return !!Lt$1 && Lt$1 in pt;
}
a(dr, "isMasked");
var gr = dr, vr$1 = Function.prototype, mr = vr$1.toString;
function Er$1(pt) {
  if (pt != null) {
    try {
      return mr.call(pt);
    } catch {
    }
    try {
      return pt + "";
    } catch {
    }
  }
  return "";
}
a(Er$1, "toSource");
var br$1 = Er$1, Sr$1 = /[\\^$.*+?()[\]{}|]/g, _r$1 = /^\[object .+?Constructor\]$/, Tr$1 = Function.prototype, Ar$1 = Object.prototype, wr$1 = Tr$1.toString, Or$1 = Ar$1.hasOwnProperty, Cr$1 = RegExp(
  "^" + wr$1.call(Or$1).replace(Sr$1, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Pr$1(pt) {
  if (!Wt$1(pt) || gr(pt))
    return !1;
  var yt = hr(pt) ? Cr$1 : _r$1;
  return yt.test(br$1(pt));
}
a(Pr$1, "baseIsNative");
var Ir$1 = Pr$1;
function xr$1(pt, yt) {
  return pt == null ? void 0 : pt[yt];
}
a(xr$1, "getValue");
var Rr$1 = xr$1;
function Nr(pt, yt) {
  var ir = Rr$1(pt, yt);
  return Ir$1(ir) ? ir : void 0;
}
a(Nr, "getNative");
var zt$1 = Nr;
function jr$1(pt, yt) {
  return pt === yt || pt !== pt && yt !== yt;
}
a(jr$1, "eq");
var Lr$1 = jr$1, Dr$1 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Fr$1 = /^\w*$/;
function Mr(pt, yt) {
  if (Et$1(pt))
    return !1;
  var ir = typeof pt;
  return ir == "number" || ir == "symbol" || ir == "boolean" || pt == null || mt$1(pt) ? !0 : Fr$1.test(pt) || !Dr$1.test(pt) || yt != null && pt in Object(
    yt
  );
}
a(Mr, "isKey");
var $r$1 = Mr, Ur$1 = zt$1(Object, "create"), V$2 = Ur$1;
function kr$1() {
  this.__data__ = V$2 ? V$2(null) : {}, this.size = 0;
}
a(kr$1, "hashClear");
var Gr$1 = kr$1;
function Wr$1(pt) {
  var yt = this.has(pt) && delete this.__data__[pt];
  return this.size -= yt ? 1 : 0, yt;
}
a(Wr$1, "hashDelete");
var zr$1 = Wr$1, Hr$1 = "__lodash_hash_undefined__", Br$1 = Object.prototype, qr = Br$1.hasOwnProperty;
function Vr$1(pt) {
  var yt = this.__data__;
  if (V$2) {
    var ir = yt[pt];
    return ir === Hr$1 ? void 0 : ir;
  }
  return qr.call(yt, pt) ? yt[pt] : void 0;
}
a(Vr$1, "hashGet");
var Jr$1 = Vr$1, Kr$1 = Object.prototype, Yr$1 = Kr$1.hasOwnProperty;
function Xr$1(pt) {
  var yt = this.__data__;
  return V$2 ? yt[pt] !== void 0 : Yr$1.call(yt, pt);
}
a(Xr$1, "hashHas");
var Qr$1 = Xr$1, Zr$1 = "__lodash_hash_undefined__";
function tn$1(pt, yt) {
  var ir = this.__data__;
  return this.size += this.has(pt) ? 0 : 1, ir[pt] = V$2 && yt === void 0 ? Zr$1 : yt, this;
}
a(tn$1, "hashSet");
var en$1 = tn$1;
function k$2(pt) {
  var yt = -1, ir = pt == null ? 0 : pt.length;
  for (this.clear(); ++yt < ir; ) {
    var ti = pt[yt];
    this.set(ti[0], ti[1]);
  }
}
a(k$2, "Hash");
k$2.prototype.clear = Gr$1;
k$2.prototype.delete = zr$1;
k$2.prototype.get = Jr$1;
k$2.prototype.has = Qr$1;
k$2.prototype.set = en$1;
var Dt$1 = k$2;
function rn$1() {
  this.__data__ = [], this.size = 0;
}
a(rn$1, "listCacheClear");
var nn$1 = rn$1;
function on$1(pt, yt) {
  for (var ir = pt.length; ir--; )
    if (Lr$1(pt[ir][0], yt))
      return ir;
  return -1;
}
a(on$1, "assocIndexOf");
var at$1 = on$1, an$1 = Array.prototype, sn$1 = an$1.splice;
function ln(pt) {
  var yt = this.__data__, ir = at$1(yt, pt);
  if (ir < 0)
    return !1;
  var ti = yt.length - 1;
  return ir == ti ? yt.pop() : sn$1.call(yt, ir, 1), --this.size, !0;
}
a(ln, "listCacheDelete");
var cn$1 = ln;
function pn(pt) {
  var yt = this.__data__, ir = at$1(yt, pt);
  return ir < 0 ? void 0 : yt[ir][1];
}
a(pn, "listCacheGet");
var un = pn;
function fn(pt) {
  return at$1(this.__data__, pt) > -1;
}
a(fn, "listCacheHas");
var hn = fn;
function yn(pt, yt) {
  var ir = this.__data__, ti = at$1(ir, pt);
  return ti < 0 ? (++this.size, ir.push([pt, yt])) : ir[ti][1] = yt, this;
}
a(yn, "listCacheSet");
var dn = yn;
function G$2(pt) {
  var yt = -1, ir = pt == null ? 0 : pt.length;
  for (this.clear(); ++yt < ir; ) {
    var ti = pt[yt];
    this.set(ti[0], ti[1]);
  }
}
a(G$2, "ListCache");
G$2.prototype.clear = nn$1;
G$2.prototype.delete = cn$1;
G$2.prototype.get = un;
G$2.prototype.has = hn;
G$2.prototype.set = dn;
var gn = G$2, vn = zt$1(vt$1, "Map"), mn = vn;
function En() {
  this.size = 0, this.__data__ = {
    hash: new Dt$1(),
    map: new (mn || gn)(),
    string: new Dt$1()
  };
}
a(En, "mapCacheClear");
var bn = En;
function Sn(pt) {
  var yt = typeof pt;
  return yt == "string" || yt == "number" || yt == "symbol" || yt == "boolean" ? pt !== "__proto__" : pt === null;
}
a(Sn, "isKeyable");
var _n$1 = Sn;
function Tn(pt, yt) {
  var ir = pt.__data__;
  return _n$1(yt) ? ir[typeof yt == "string" ? "string" : "hash"] : ir.map;
}
a(Tn, "getMapData");
var st$1 = Tn;
function An(pt) {
  var yt = st$1(this, pt).delete(pt);
  return this.size -= yt ? 1 : 0, yt;
}
a(An, "mapCacheDelete");
var wn = An;
function On(pt) {
  return st$1(this, pt).get(pt);
}
a(On, "mapCacheGet");
var Cn = On;
function Pn(pt) {
  return st$1(this, pt).has(pt);
}
a(Pn, "mapCacheHas");
var In = Pn;
function xn$1(pt, yt) {
  var ir = st$1(this, pt), ti = ir.size;
  return ir.set(pt, yt), this.size += ir.size == ti ? 0 : 1, this;
}
a(xn$1, "mapCacheSet");
var Rn = xn$1;
function W$2(pt) {
  var yt = -1, ir = pt == null ? 0 : pt.length;
  for (this.clear(); ++yt < ir; ) {
    var ti = pt[yt];
    this.set(ti[0], ti[1]);
  }
}
a(W$2, "MapCache");
W$2.prototype.clear = bn;
W$2.prototype.delete = wn;
W$2.prototype.get = Cn;
W$2.prototype.has = In;
W$2.prototype.set = Rn;
var Ht$1 = W$2, Nn$1 = "Expected a function";
function bt$1(pt, yt) {
  if (typeof pt != "function" || yt != null && typeof yt != "function")
    throw new TypeError(Nn$1);
  var ir = /* @__PURE__ */ a(function() {
    var ti = arguments, ii = yt ? yt.apply(this, ti) : ti[0], ui = ir.cache;
    if (ui.has(ii))
      return ui.get(ii);
    var ai = pt.apply(this, ti);
    return ir.cache = ui.set(ii, ai) || ui, ai;
  }, "memoized");
  return ir.cache = new (bt$1.Cache || Ht$1)(), ir;
}
a(bt$1, "memoize");
bt$1.Cache = Ht$1;
var jn$1 = bt$1, Ln$1 = 500;
function Dn(pt) {
  var yt = jn$1(pt, function(ti) {
    return ir.size === Ln$1 && ir.clear(), ti;
  }), ir = yt.cache;
  return yt;
}
a(Dn, "memoizeCapped");
var Fn = Dn, Mn$1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, $n$1 = /\\(\\)?/g, Un$1 = Fn(
  function(pt) {
    var yt = [];
    return pt.charCodeAt(0) === 46 && yt.push(""), pt.replace(Mn$1, function(ir, ti, ii, ui) {
      yt.push(ii ? ui.replace($n$1, "$1") : ti || ir);
    }), yt;
  }
), kn = Un$1;
function Gn$1(pt) {
  return pt == null ? "" : ar(pt);
}
a(Gn$1, "toString");
var Wn$1 = Gn$1;
function zn$1(pt, yt) {
  return Et$1(pt) ? pt : $r$1(pt, yt) ? [pt] : kn(Wn$1(pt));
}
a(zn$1, "castPath");
var Hn$1 = zn$1;
function qn$1(pt) {
  if (typeof pt == "string" || mt$1(pt))
    return pt;
  var yt = pt + "";
  return yt == "0" && 1 / pt == -1 / 0 ? "-0" : yt;
}
a(qn$1, "toKey");
var Vn$1 = qn$1;
function Jn$1(pt, yt) {
  yt = Hn$1(yt, pt);
  for (var ir = 0, ti = yt.length; pt != null && ir < ti; )
    pt = pt[Vn$1(yt[ir++])];
  return ir && ir == ti ? pt : void 0;
}
a(Jn$1, "baseGet");
var Kn = Jn$1;
function Yn$1(pt, yt, ir) {
  var ti = pt == null ? void 0 : Kn(pt, yt);
  return ti === void 0 ? ir : ti;
}
a(Yn$1, "get");
var Xn$1 = Yn$1, it = De$1, Qn = /* @__PURE__ */ a((pt) => {
  let yt = null, ir = !1, ti = !1, ii = !1, ui = "";
  if (pt.indexOf("//") >= 0 || pt.indexOf("/*") >= 0)
    for (let ai = 0; ai < pt.length; ai += 1)
      !yt && !ir && !ti && !ii ? pt[ai] === '"' || pt[ai] === "'" || pt[ai] === "`" ? yt = pt[ai] : pt[ai] === "/" && pt[ai + 1] === "*" ? ir = !0 : pt[ai] === "/" && pt[ai + 1] === "/" ? ti = !0 : pt[ai] === "/" && pt[ai + 1] !== "/" && (ii = !0) : (yt && (pt[ai] === yt && pt[ai - 1] !== "\\" || pt[ai] === `
` && yt !== "`") && (yt = null), ii && (pt[ai] === "/" && pt[ai - 1] !== "\\" || pt[ai] === `
`) && (ii = !1), ir && pt[ai - 1] === "/" && pt[ai - 2] === "*" && (ir = !1), ti && pt[ai] === `
` && (ti = !1)), !ir && !ti && (ui += pt[ai]);
  else
    ui = pt;
  return ui;
}, "removeCodeComments"), Zn = (0, Bt$1.default)(1e4)(
  (pt) => Qn(pt).replace(/\n\s*/g, "").trim()
), to$1 = /* @__PURE__ */ a(function(pt, yt) {
  let ir = yt.slice(0, yt.indexOf("{")), ti = yt.slice(yt.indexOf("{"));
  if (ir.includes("=>") || ir.includes("function"))
    return yt;
  let ii = ir;
  return ii = ii.replace(pt, "function"), ii + ti;
}, "convertShorthandMethods2"), eo$1 = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/, J$2 = /* @__PURE__ */ a(
  (pt) => pt.match(/^[\[\{\"\}].*[\]\}\"]$/),
  "isJSON"
);
function qt$1(pt) {
  if (!it(pt))
    return pt;
  let yt = pt, ir = !1;
  return typeof Event < "u" && pt instanceof Event && (yt = Pt(yt), ir = !0), yt = Object.keys(yt).reduce((ti, ii) => {
    try {
      yt[ii] && yt[ii].toJSON, ti[ii] = yt[ii];
    } catch {
      ir = !0;
    }
    return ti;
  }, {}), ir ? yt : pt;
}
a(qt$1, "convertUnconventionalData");
var ro$1 = /* @__PURE__ */ a(function(pt) {
  let yt, ir, ti, ii;
  return /* @__PURE__ */ a(function(ui, ai) {
    try {
      if (ui === "")
        return ii = [], yt = /* @__PURE__ */ new Map([[ai, "[]"]]), ir = /* @__PURE__ */ new Map(), ti = [], ai;
      let li = ir.get(this) || this;
      for (; ti.length && li !== ti[0]; )
        ti.shift(), ii.pop();
      if (typeof ai == "boolean")
        return ai;
      if (ai === void 0)
        return pt.allowUndefined ? "_undefined_" : void 0;
      if (ai === null)
        return null;
      if (typeof ai == "number")
        return ai === -1 / 0 ? "_-Infinity_" : ai === 1 / 0 ? "_Infinity_" : Number.isNaN(ai) ? "_NaN_" : ai;
      if (typeof ai == "bigint")
        return `_bigint_${ai.toString()}`;
      if (typeof ai == "string")
        return eo$1.test(ai) ? pt.allowDate ? `_date_${ai}` : void 0 : ai;
      if ((0, Ne$1.default)(ai))
        return pt.allowRegExp ? `_regexp_${ai.flags}|${ai.source}` : void 0;
      if ((0, je$1.default)(ai)) {
        if (!pt.allowFunction)
          return;
        let { name: si } = ai, di = ai.toString();
        return di.match(
          /(\[native code\]|WEBPACK_IMPORTED_MODULE|__webpack_exports__|__webpack_require__)/
        ) ? `_function_${si}|${(() => {
        }).toString()}` : `_function_${si}|${Zn(to$1(ui, di))}`;
      }
      if ((0, Le$1.default)(ai)) {
        if (!pt.allowSymbol)
          return;
        let si = Symbol.keyFor(ai);
        return si !== void 0 ? `_gsymbol_${si}` : `_symbol_${ai.toString().slice(7, -1)}`;
      }
      if (ti.length >= pt.maxDepth)
        return Array.isArray(ai) ? `[Array(${ai.length})]` : "[Object]";
      if (ai === this)
        return `_duplicate_${JSON.stringify(ii)}`;
      if (ai instanceof Error && pt.allowError)
        return {
          __isConvertedError__: !0,
          errorProperties: {
            ...ai.cause ? { cause: ai.cause } : {},
            ...ai,
            name: ai.name,
            message: ai.message,
            stack: ai.stack,
            "_constructor-name_": ai.constructor.name
          }
        };
      if (ai.constructor && ai.constructor.name && ai.constructor.name !== "Object" && !Array.isArray(ai) && !pt.allowClass)
        return;
      let oi = yt.get(ai);
      if (!oi) {
        let si = Array.isArray(ai) ? ai : qt$1(ai);
        if (ai.constructor && ai.constructor.name && ai.constructor.name !== "Object" && !Array.isArray(ai) && pt.allowClass)
          try {
            Object.assign(si, { "_constructor-name_": ai.constructor.name });
          } catch {
          }
        return ii.push(ui), ti.unshift(si), yt.set(ai, JSON.stringify(ii)), ai !== si && ir.set(ai, si), si;
      }
      return `_duplicate_${oi}`;
    } catch {
      return;
    }
  }, "replace");
}, "replacer2"), no$1 = /* @__PURE__ */ a(function reviver(options) {
  let refs = [], root;
  return /* @__PURE__ */ a(function revive(key, value) {
    if (key === "" && (root = value, refs.forEach(({ target: pt, container: yt, replacement: ir }) => {
      let ti = J$2(ir) ? JSON.parse(ir) : ir.split(".");
      ti.length === 0 ? yt[pt] = root : yt[pt] = Xn$1(root, ti);
    })), key === "_constructor-name_")
      return value;
    if (it(value) && value.__isConvertedError__) {
      let { message: pt, ...yt } = value.errorProperties, ir = new Error(pt);
      return Object.assign(ir, yt), ir;
    }
    if (it(value) && value["_constructor-name_"] && options.allowFunction) {
      let pt = value["_constructor-name_"];
      if (pt !== "Object") {
        let yt = new Function(`return function ${pt.replace(/[^a-zA-Z0-9$_]+/g, "")}(){}`)();
        Object.setPrototypeOf(value, new yt());
      }
      return delete value["_constructor-name_"], value;
    }
    if (typeof value == "string" && value.startsWith("_function_") && options.allowFunction) {
      let [, name, source] = value.match(/_function_([^|]*)\|(.*)/) || [], sourceSanitized = source.replace(/[(\(\))|\\| |\]|`]*$/, "");
      if (!options.lazyEval)
        return eval(`(${sourceSanitized})`);
      let result = /* @__PURE__ */ a((...args) => {
        let f = eval(`(${sourceSanitized})`);
        return f(...args);
      }, "result");
      return Object.defineProperty(result, "toString", {
        value: /* @__PURE__ */ a(() => sourceSanitized, "value")
      }), Object.defineProperty(result, "name", {
        value: name
      }), result;
    }
    if (typeof value == "string" && value.startsWith("_regexp_") && options.allowRegExp) {
      let [, pt, yt] = value.match(/_regexp_([^|]*)\|(.*)/) || [];
      return new RegExp(yt, pt);
    }
    return typeof value == "string" && value.startsWith("_date_") && options.allowDate ? new Date(value.replace("_date_", "")) : typeof value == "string" && value.startsWith("_duplicate_") ? (refs.push({ target: key, container: this, replacement: value.replace(/^_duplicate_/, "") }), null) : typeof value == "string" && value.startsWith("_symbol_") && options.allowSymbol ? Symbol(value.replace("_symbol_", "")) : typeof value == "string" && value.startsWith("_gsymbol_") && options.allowSymbol ? Symbol.for(value.replace("_gsymbol_", "")) : typeof value == "string" && value === "_-Infinity_" ? -1 / 0 : typeof value == "string" && value === "_Infinity_" ? 1 / 0 : typeof value == "string" && value === "_NaN_" ? NaN : typeof value == "string" && value.startsWith("_bigint_") && typeof BigInt == "function" ? BigInt(value.replace("_bigint_", "")) : value;
  }, "revive");
}, "reviver"), Vt$1 = {
  maxDepth: 10,
  space: void 0,
  allowFunction: !0,
  allowRegExp: !0,
  allowDate: !0,
  allowClass: !0,
  allowError: !0,
  allowUndefined: !0,
  allowSymbol: !0,
  lazyEval: !0
}, lt$1 = /* @__PURE__ */ a((pt, yt = {}) => {
  let ir = { ...Vt$1, ...yt };
  return JSON.stringify(qt$1(pt), ro$1(ir), yt.space);
}, "stringify"), oo$1 = /* @__PURE__ */ a(() => {
  let pt = /* @__PURE__ */ new Map();
  return /* @__PURE__ */ a(function yt(ir) {
    it(ir) && Object.entries(ir).forEach(([ti, ii]) => {
      ii === "_undefined_" ? ir[ti] = void 0 : pt.get(ii) || (pt.set(ii, !0), yt(ii));
    }), Array.isArray(ir) && ir.forEach((ti, ii) => {
      ti === "_undefined_" ? (pt.set(ti, !0), ir[ii] = void 0) : pt.get(ti) || (pt.set(ti, !0), yt(ti));
    });
  }, "mutateUndefined");
}, "mutator"), ct = /* @__PURE__ */ a((pt, yt = {}) => {
  let ir = { ...Vt$1, ...yt }, ti = JSON.parse(pt, no$1(ir));
  return oo$1()(ti), ti;
}, "parse"), St$1 = "Invariant failed";
function K$2(pt, yt) {
  if (!pt) {
    var ir = typeof yt == "function" ? yt() : yt, ti = ir ? "".concat(St$1, ": ").concat(ir) : St$1;
    throw new Error(ti);
  }
}
a(K$2, "invariant");
var Jt$1 = /* @__PURE__ */ a((pt) => {
  let yt = Array.from(
    document.querySelectorAll("iframe[data-is-storybook]")
  ), [ir, ...ti] = yt.filter((ui) => {
    var ai, li;
    try {
      return ((ai = ui.contentWindow) == null ? void 0 : ai.location.origin) === pt.source.location.origin && ((li = ui.contentWindow) == null ? void 0 : li.location.pathname) === pt.source.location.pathname;
    } catch {
    }
    try {
      return ui.contentWindow === pt.source;
    } catch {
    }
    let oi = ui.getAttribute("src"), si;
    try {
      if (!oi)
        return !1;
      ({ origin: si } = new URL(oi, document.location.toString()));
    } catch {
      return !1;
    }
    return si === pt.origin;
  }), ii = ir == null ? void 0 : ir.getAttribute("src");
  if (ii && ti.length === 0) {
    let { protocol: ui, host: ai, pathname: li } = new URL(ii, document.location.toString());
    return `${ui}//${ai}${li}`;
  }
  return ti.length > 0 && s$3.error("found multiple candidates for event source"), null;
}, "getEventSourceUrl"), { document: _t$1, location: Tt } = S$2, Xt$1 = "storybook-channel", lo$1 = { allowFunction: !1, maxDepth: 25 }, At$1 = class {
  constructor(pt) {
    if (this.config = pt, this.connected = !1, this.buffer = [], typeof (S$2 == null ? void 0 : S$2.addEventListener) == "function" && S$2.addEventListener("message", this.handleEvent.bind(this), !1), pt.page !== "manager" && pt.page !== "preview")
      throw new Error(`postmsg-channel: "config.page" cannot be "${pt.page}"`);
  }
  setHandler(pt) {
    this.handler = (...yt) => {
      pt.apply(this, yt), !this.connected && this.getLocalFrame().length && (this.flush(), this.connected = !0);
    };
  }
  /**
   * Sends `event` to the associated window. If the window does not yet exist the event will be
   * stored in a buffer and sent when the window exists.
   *
   * @param event
   */
  send(pt, yt) {
    let {
      target: ir,
      // telejson options
      allowRegExp: ti,
      allowFunction: ii,
      allowSymbol: ui,
      allowDate: ai,
      allowError: li,
      allowUndefined: oi,
      allowClass: si,
      maxDepth: di,
      space: fi,
      lazyEval: gi
    } = yt || {}, mi = Object.fromEntries(
      Object.entries({
        allowRegExp: ti,
        allowFunction: ii,
        allowSymbol: ui,
        allowDate: ai,
        allowError: li,
        allowUndefined: oi,
        allowClass: si,
        maxDepth: di,
        space: fi,
        lazyEval: gi
      }).filter(([Pi, $i]) => typeof $i < "u")
    ), Ti = {
      ...lo$1,
      ...S$2.CHANNEL_OPTIONS || {},
      ...mi
    }, vi = this.getFrames(ir), xi = new URLSearchParams((Tt == null ? void 0 : Tt.search) || ""), Si = lt$1(
      {
        key: Xt$1,
        event: pt,
        refId: xi.get("refId")
      },
      Ti
    );
    return vi.length ? (this.buffer.length && this.flush(), vi.forEach((Pi) => {
      try {
        Pi.postMessage(Si, "*");
      } catch {
        s$3.error("sending over postmessage fail");
      }
    }), Promise.resolve(null)) : new Promise((Pi, $i) => {
      this.buffer.push({ event: pt, resolve: Pi, reject: $i });
    });
  }
  flush() {
    let { buffer: pt } = this;
    this.buffer = [], pt.forEach((yt) => {
      this.send(yt.event).then(yt.resolve).catch(yt.reject);
    });
  }
  getFrames(pt) {
    if (this.config.page === "manager") {
      let yt = Array.from(
        _t$1.querySelectorAll("iframe[data-is-storybook][data-is-loaded]")
      ).flatMap((ir) => {
        try {
          return ir.contentWindow && ir.dataset.isStorybook !== void 0 && ir.id === pt ? [ir.contentWindow] : [];
        } catch {
          return [];
        }
      });
      return yt != null && yt.length ? yt : this.getCurrentFrames();
    }
    return S$2 && S$2.parent && S$2.parent !== S$2.self ? [S$2.parent] : [];
  }
  getCurrentFrames() {
    return this.config.page === "manager" ? Array.from(
      _t$1.querySelectorAll('[data-is-storybook="true"]')
    ).flatMap((pt) => pt.contentWindow ? [pt.contentWindow] : []) : S$2 && S$2.parent ? [S$2.parent] : [];
  }
  getLocalFrame() {
    return this.config.page === "manager" ? Array.from(
      _t$1.querySelectorAll("#storybook-preview-iframe")
    ).flatMap((pt) => pt.contentWindow ? [pt.contentWindow] : []) : S$2 && S$2.parent ? [S$2.parent] : [];
  }
  handleEvent(pt) {
    try {
      let { data: yt } = pt, { key: ir, event: ti, refId: ii } = typeof yt == "string" && J$2(yt) ? ct(yt, S$2.CHANNEL_OPTIONS || {}) : yt;
      if (ir === Xt$1) {
        let ui = this.config.page === "manager" ? '<span style="color: #37D5D3; background: black"> manager </span>' : '<span style="color: #1EA7FD; background: black"> preview </span>', ai = Object.values(so$1).includes(ti.type) ? `<span style="color: #FF4785">${ti.type}</span>` : `<span style="color: #FFAE00">${ti.type}</span>`;
        if (ii && (ti.refId = ii), ti.source = this.config.page === "preview" ? pt.origin : Jt$1(pt), !ti.source) {
          r$2.error(
            `${ui} received ${ai} but was unable to determine the source of the event`
          );
          return;
        }
        let li = `${ui} received ${ai} (${yt.length})`;
        r$2.debug(
          Tt.origin !== ti.source ? li : `${li} <span style="color: gray">(on ${Tt.origin} from ${ti.source})</span>`,
          ...ti.args
        ), K$2(this.handler, "ChannelHandler should be set"), this.handler(ti);
      }
    } catch (yt) {
      s$3.error(yt);
    }
  }
};
a(At$1, "PostMessageTransport");
var Y$2 = At$1, { WebSocket: co$1 } = S$2, Zt$1 = 15e3, te$2 = 5e3, wt$1 = class {
  constructor({ url: pt, onError: yt, page: ir }) {
    this.buffer = [], this.isReady = !1, this.isClosed = !1, this.pingTimeout = 0, this.socket = new co$1(pt), this.socket.onopen = () => {
      this.isReady = !0, this.heartbeat(), this.flush();
    }, this.socket.onmessage = ({ data: ti }) => {
      let ii = typeof ti == "string" && J$2(ti) ? ct(ti) : ti;
      K$2(this.handler, "WebsocketTransport handler should be set"), this.handler(ii), ii.type === "ping" && (this.heartbeat(), this.send({ type: "pong" }));
    }, this.socket.onerror = (ti) => {
      yt && yt(ti);
    }, this.socket.onclose = (ti) => {
      K$2(this.handler, "WebsocketTransport handler should be set"), this.handler({
        type: S$3,
        args: [{ reason: ti.reason, code: ti.code }],
        from: ir || "preview"
      }), this.isClosed = !0, clearTimeout(this.pingTimeout);
    };
  }
  heartbeat() {
    clearTimeout(this.pingTimeout), this.pingTimeout = setTimeout(() => {
      this.socket.close(3008, "timeout");
    }, Zt$1 + te$2);
  }
  setHandler(pt) {
    this.handler = pt;
  }
  send(pt) {
    this.isClosed || (this.isReady ? this.sendNow(pt) : this.sendLater(pt));
  }
  sendLater(pt) {
    this.buffer.push(pt);
  }
  sendNow(pt) {
    let yt = lt$1(pt, {
      maxDepth: 15,
      allowFunction: !1,
      ...S$2.CHANNEL_OPTIONS
    });
    this.socket.send(yt);
  }
  flush() {
    let { buffer: pt } = this;
    this.buffer = [], pt.forEach((yt) => this.send(yt));
  }
};
a(wt$1, "WebsocketTransport");
var X$1 = wt$1, { CHANNEL_OPTIONS: po$1, CONFIG_TYPE: uo } = S$2;
function Zo$1({ page: pt, extraTransports: yt = [] }) {
  let ir = [new Y$2({ page: pt }), ...yt];
  if (uo === "DEVELOPMENT") {
    let ii = window.location.protocol === "http:" ? "ws" : "wss", { hostname: ui, port: ai } = window.location, { wsToken: li } = po$1 || {}, oi = `${ii}://${ui}:${ai}/storybook-server-channel?token=${li}`;
    ir.push(new X$1({ url: oi, onError: /* @__PURE__ */ a(() => {
    }, "onError"), page: pt }));
  }
  let ti = new B({ transports: ir });
  return $$2.__prepare(
    ti,
    pt === "manager" ? $$2.Environment.MANAGER : $$2.Environment.PREVIEW
  ), ti;
}
a(Zo$1, "createBrowserChannel");
var oe$1 = Object.defineProperty, t = (pt, yt) => oe$1(pt, "name", { value: yt, configurable: !0 });
function r$5(pt) {
  for (var yt = [], ir = 1; ir < arguments.length; ir++)
    yt[ir - 1] = arguments[ir];
  var ti = Array.from(typeof pt == "string" ? [pt] : pt);
  ti[ti.length - 1] = ti[ti.length - 1].replace(/\r?\n([\t ]*)$/, "");
  var ii = ti.reduce(function(li, oi) {
    var si = oi.match(/\n([\t ]+|(?!\s).)/g);
    return si ? li.concat(si.map(function(di) {
      var fi, gi;
      return (gi = (fi = di.match(/[\t ]/g)) === null || fi === void 0 ? void 0 : fi.length) !== null && gi !== void 0 ? gi : 0;
    })) : li;
  }, []);
  if (ii.length) {
    var ui = new RegExp(`
[	 ]{` + Math.min.apply(Math, ii) + "}", "g");
    ti = ti.map(function(li) {
      return li.replace(ui, `
`);
    });
  }
  ti[0] = ti[0].replace(/^\r?\n/, "");
  var ai = ti[0];
  return yt.forEach(function(li, oi) {
    var si = ai.match(/(?:^|\n)( *)$/), di = si ? si[1] : "", fi = li;
    typeof li == "string" && li.includes(`
`) && (fi = String(li).split(`
`).map(function(gi, mi) {
      return mi === 0 ? gi : "" + di + gi;
    }).join(`
`)), ai += fi + ti[oi + 1];
  }), ai;
}
t(r$5, "dedent");
function C$1({
  code: pt,
  category: yt
}) {
  let ir = String(pt).padStart(4, "0");
  return `SB_${yt}_${ir}`;
}
t(C$1, "parseErrorCode");
var p = class sb extends Error {
  constructor(yt) {
    super(sb.getFullMessage(yt)), this.data = {}, this.fromStorybook = !0, this.category = yt.category, this.documentation = yt.documentation ?? !1, this.code = yt.code;
  }
  get fullErrorCode() {
    return C$1({ code: this.code, category: this.category });
  }
  /** Overrides the default `Error.name` property in the format: SB_<CATEGORY>_<CODE>. */
  get name() {
    let yt = this.constructor.name;
    return `${this.fullErrorCode} (${yt})`;
  }
  /** Generates the error message along with additional documentation link (if applicable). */
  static getFullMessage({
    documentation: yt,
    code: ir,
    category: ti,
    message: ii
  }) {
    let ui;
    return yt === !0 ? ui = `https://storybook.js.org/error/${C$1({ code: ir, category: ti })}` : typeof yt == "string" ? ui = yt : Array.isArray(yt) && (ui = `
${yt.map((ai) => `	- ${ai}`).join(`
`)}`), `${ii}${ui != null ? `

More info: ${ui}
` : ""}`;
  }
};
t(p, "StorybookError");
var o = p, f$1 = class extends o {
  constructor(pt) {
    super({
      category: "PREVIEW_API",
      code: 1,
      message: r$5`
        Couldn't find story matching id '${pt.storyId}' after HMR.
        - Did you just rename a story?
        - Did you remove it from your CSF file?
        - Are you sure a story with the id '${pt.storyId}' exists?
        - Please check the values in the stories field of your main.js config and see if they would match your CSF File.
        - Also check the browser console and terminal for potential error messages.`
    }), this.data = pt;
  }
};
t(f$1, "MissingStoryAfterHmrError");
var D$1 = f$1, R$1 = class extends o {
  constructor(pt) {
    super({
      category: "PREVIEW_API",
      code: 2,
      documentation: "https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#using-implicit-actions-during-rendering-is-deprecated-for-example-in-the-play-function",
      message: r$5`
        We detected that you use an implicit action arg while ${pt.phase} of your story.  
        ${pt.deprecated ? `
This is deprecated and won't work in Storybook 8 anymore.
` : ""}
        Please provide an explicit spy to your args like this:
          import { fn } from '@storybook/test';
          ... 
          args: {
           ${pt.name}: fn()
          }`
    }), this.data = pt;
  }
};
t(R$1, "ImplicitActionsDuringRendering");
var j$2 = R$1, b$1 = class extends o {
  constructor() {
    super({
      category: "PREVIEW_API",
      code: 3,
      message: r$5`
        Cannot call \`storyStore.extract()\` without calling \`storyStore.cacheAllCsfFiles()\` first.

        You probably meant to call \`await preview.extract()\` which does the above for you.`
    });
  }
};
t(b$1, "CalledExtractOnStoreError");
var L$2 = b$1, I$2 = class extends o {
  constructor() {
    super({
      category: "PREVIEW_API",
      code: 4,
      message: r$5`
        Expected your framework's preset to export a \`renderToCanvas\` field.

        Perhaps it needs to be upgraded for Storybook 7.0?`,
      documentation: "https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#mainjs-framework-field"
    });
  }
};
t(I$2, "MissingRenderToCanvasError");
var G$1 = I$2, P$2 = class extends o {
  constructor(pt) {
    super({
      category: "PREVIEW_API",
      code: 5,
      message: r$5`
        Called \`Preview.${pt.methodName}()\` before initialization.
        
        The preview needs to load the story index before most methods can be called. If you want
        to call \`${pt.methodName}\`, try \`await preview.initializationPromise;\` first.
        
        If you didn't call the above code, then likely it was called by an addon that needs to
        do the above.`
    }), this.data = pt;
  }
};
t(P$2, "CalledPreviewMethodBeforeInitializationError");
var Y$1 = P$2, x$1 = class extends o {
  constructor(pt) {
    super({
      category: "PREVIEW_API",
      code: 6,
      message: r$5`
        Error fetching \`/index.json\`:
        
        ${pt.text}

        If you are in development, this likely indicates a problem with your Storybook process,
        check the terminal for errors.

        If you are in a deployed Storybook, there may have been an issue deploying the full Storybook
        build.`
    }), this.data = pt;
  }
};
t(x$1, "StoryIndexFetchError");
var M$1 = x$1, T$2 = class extends o {
  constructor(pt) {
    super({
      category: "PREVIEW_API",
      code: 7,
      message: r$5`
        Tried to render docs entry ${pt.storyId} but it is a MDX file that has no CSF
        references, or autodocs for a CSF file that some doesn't refer to itself.
        
        This likely is an internal error in Storybook's indexing, or you've attached the
        \`attached-mdx\` tag to an MDX file that is not attached.`
    }), this.data = pt;
  }
};
t(T$2, "MdxFileWithNoCsfReferencesError");
var H$1 = T$2, w$1 = class extends o {
  constructor() {
    super({
      category: "PREVIEW_API",
      code: 8,
      message: r$5`
        Couldn't find any stories in your Storybook.

        - Please check your stories field of your main.js config: does it match correctly?
        - Also check the browser console and terminal for error messages.`
    });
  }
};
t(w$1, "EmptyIndexError");
var F$1 = w$1, k$1 = class extends o {
  constructor(pt) {
    super({
      category: "PREVIEW_API",
      code: 9,
      message: r$5`
        Couldn't find story matching '${pt.storySpecifier}'.

        - Are you sure a story with that id exists?
        - Please check your stories field of your main.js config.
        - Also check the browser console and terminal for error messages.`
    }), this.data = pt;
  }
};
t(k$1, "NoStoryMatchError");
var K$1 = k$1, S$1 = class extends o {
  constructor(pt) {
    super({
      category: "PREVIEW_API",
      code: 10,
      message: r$5`
        Couldn't find story matching id '${pt.storyId}' after importing a CSF file.

        The file was indexed as if the story was there, but then after importing the file in the browser
        we didn't find the story. Possible reasons:
        - You are using a custom story indexer that is misbehaving.
        - You have a custom file loader that is removing or renaming exports.

        Please check your browser console and terminal for errors that may explain the issue.`
    }), this.data = pt;
  }
};
t(S$1, "MissingStoryFromCsfFileError");
var X = S$1, v$1 = class extends o {
  constructor() {
    super({
      category: "PREVIEW_API",
      code: 11,
      message: r$5`
        Cannot access the Story Store until the index is ready.

        It is not recommended to use methods directly on the Story Store anyway, in Storybook 9 we will
        remove access to the store entirely`
    });
  }
};
t(v$1, "StoryStoreAccessedBeforeInitializationError");
var U$1 = v$1, _$1 = class extends o {
  constructor(pt) {
    super({
      category: "PREVIEW_API",
      code: 12,
      message: r$5`
      Incorrect use of mount in the play function.
      
      To use mount in the play function, you must satisfy the following two requirements: 
      
      1. You *must* destructure the mount property from the \`context\` (the argument passed to your play function). 
         This makes sure that Storybook does not start rendering the story before the play function begins.
      
      2. Your Storybook framework or builder must be configured to transpile to ES2017 or newer. 
         This is because destructuring statements and async/await usages are otherwise transpiled away, 
         which prevents Storybook from recognizing your usage of \`mount\`.
      
      Note that Angular is not supported. As async/await is transpiled to support the zone.js polyfill. 
      
      More info: https://storybook.js.org/docs/writing-tests/interaction-testing#run-code-before-the-component-gets-rendered
      
      Received the following play function:
      ${pt.playFunction}`
    }), this.data = pt;
  }
};
t(_$1, "MountMustBeDestructuredError");
var J$1 = _$1, V$1 = class extends o {
  constructor(pt) {
    super({
      category: "PREVIEW_API",
      code: 14,
      message: r$5`
        No render function available for storyId '${pt.id}'
      `
    }), this.data = pt;
  }
};
t(V$1, "NoRenderFunctionError");
var q$1 = V$1, N = class extends o {
  constructor() {
    super({
      category: "PREVIEW_API",
      code: 15,
      message: r$5`
        No component is mounted in your story.
        
        This usually occurs when you destructure mount in the play function, but forget to call it.
        
        For example:

        async play({ mount, canvasElement }) {
          // 👈 mount should be called: await mount(); 
          const canvas = within(canvasElement);
          const button = await canvas.findByRole('button');
          await userEvent.click(button);
        };

        Make sure to either remove it or call mount in your play function.
      `
    });
  }
};
t(N, "NoStoryMountedError");
var z$1 = N, A = class extends o {
  constructor() {
    super({
      category: "FRAMEWORK_NEXTJS",
      code: 1,
      documentation: "https://storybook.js.org/docs/get-started/nextjs#faq",
      message: r$5`
      You are importing avif images, but you don't have sharp installed.

      You have to install sharp in order to use image optimization features in Next.js.
      `
    });
  }
};
t(A, "NextJsSharpError");
var W$1 = class extends o {
  constructor(pt) {
    super({
      category: "FRAMEWORK_NEXTJS",
      code: 2,
      message: r$5`
        Tried to access router mocks from "${pt.importType}" but they were not created yet. You might be running code in an unsupported environment.
      `
    }), this.data = pt;
  }
};
t(W$1, "NextjsRouterMocksNotAvailable");
var $$1 = class extends o {
  constructor(pt) {
    super({
      category: "DOCS-TOOLS",
      code: 1,
      documentation: "https://github.com/storybookjs/storybook/issues/26606",
      message: r$5`
        There was a failure when generating detailed ArgTypes in ${pt.language} for:
        ${JSON.stringify(pt.type, null, 2)} 
        
        Storybook will fall back to use a generic type description instead.

        This type is either not supported or it is a bug in the docgen generation in Storybook.
        If you think this is a bug, please detail it as much as possible in the Github issue.
      `
    }), this.data = pt;
  }
};
t($$1, "UnknownArgTypesError");
var O$1 = class extends o {
  constructor(pt) {
    super({
      category: "ADDON_VITEST",
      code: 1,
      // TODO: Add documentation about viewports support
      // documentation: '',
      message: r$5`
        Encountered an unsupported value "${pt.value}" when setting the viewport ${pt.dimension} dimension.
        
        The Storybook plugin only supports values in the following units:
        - px, vh, vw, em, rem and %.
        
        You can either change the viewport for this story to use one of the supported units or skip the test by adding '!test' to the story's tags per https://storybook.js.org/docs/writing-stories/tags
      `
    }), this.data = pt;
  }
};
t(O$1, "UnsupportedViewportDimensionError");
var b = Object.create, f = Object.defineProperty, v = Object.getOwnPropertyDescriptor, P$1 = Object.getOwnPropertyNames, O = Object.getPrototypeOf, _ = Object.prototype.hasOwnProperty, s$1 = (pt, yt) => f(pt, "name", { value: yt, configurable: !0 }), $ = (pt, yt) => () => (yt || pt((yt = { exports: {} }).exports, yt), yt.exports), j$1 = (pt, yt, ir, ti) => {
  if (yt && typeof yt == "object" || typeof yt == "function")
    for (let ii of P$1(yt))
      !_.call(pt, ii) && ii !== ir && f(pt, ii, { get: () => yt[ii], enumerable: !(ti = v(yt, ii)) || ti.enumerable });
  return pt;
}, C = (pt, yt, ir) => (ir = pt != null ? b(O(pt)) : {}, j$1(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  f(ir, "default", { value: pt, enumerable: !0 }),
  pt
)), T$1 = $((pt) => {
  Object.defineProperty(pt, "__esModule", { value: !0 }), pt.isEqual = /* @__PURE__ */ (function() {
    var yt = Object.prototype.toString, ir = Object.getPrototypeOf, ti = Object.getOwnPropertySymbols ? function(ii) {
      return Object.keys(ii).concat(Object.getOwnPropertySymbols(ii));
    } : Object.keys;
    return function(ii, ui) {
      return (/* @__PURE__ */ s$1(function ai(li, oi, si) {
        var di, fi, gi, mi = yt.call(li), Ti = yt.call(oi);
        if (li === oi) return !0;
        if (li == null || oi == null) return !1;
        if (si.indexOf(li) > -1 && si.indexOf(oi) > -1) return !0;
        if (si.push(li, oi), mi != Ti || (di = ti(li), fi = ti(oi), di.length != fi.length || di.some(function(vi) {
          return !ai(li[vi], oi[vi], si);
        }))) return !1;
        switch (mi.slice(8, -1)) {
          case "Symbol":
            return li.valueOf() == oi.valueOf();
          case "Date":
          case "Number":
            return +li == +oi || +li != +li && +oi != +oi;
          case "RegExp":
          case "Function":
          case "String":
          case "Boolean":
            return "" + li == "" + oi;
          case "Set":
          case "Map":
            di = li.entries(), fi = oi.entries();
            do
              if (!ai((gi = di.next()).value, fi.next().value, si)) return !1;
            while (!gi.done);
            return !0;
          case "ArrayBuffer":
            li = new Uint8Array(li), oi = new Uint8Array(oi);
          case "DataView":
            li = new Uint8Array(li.buffer), oi = new Uint8Array(oi.buffer);
          case "Float32Array":
          case "Float64Array":
          case "Int8Array":
          case "Int16Array":
          case "Int32Array":
          case "Uint8Array":
          case "Uint16Array":
          case "Uint32Array":
          case "Uint8ClampedArray":
          case "Arguments":
          case "Array":
            if (li.length != oi.length) return !1;
            for (gi = 0; gi < li.length; gi++) if ((gi in li || gi in oi) && (gi in li != gi in oi || !ai(li[gi], oi[gi], si))) return !1;
            return !0;
          case "Object":
            return ai(ir(li), ir(oi), si);
          default:
            return !1;
        }
      }, "n"))(ii, ui, []);
    };
  })();
});
function R(pt) {
  return pt.replace(/_/g, " ").replace(/-/g, " ").replace(/\./g, " ").replace(/([^\n])([A-Z])([a-z])/g, (yt, ir, ti, ii) => `${ir} ${ti}${ii}`).replace(
    /([a-z])([A-Z])/g,
    (yt, ir, ti) => `${ir} ${ti}`
  ).replace(/([a-z])([0-9])/gi, (yt, ir, ti) => `${ir} ${ti}`).replace(/([0-9])([a-z])/gi, (yt, ir, ti) => `${ir} ${ti}`).replace(/(\s|^)(\w)/g, (yt, ir, ti) => `${ir}${ti.toUpperCase()}`).replace(/ +/g, " ").trim();
}
s$1(R, "toStartCaseStr");
var y = C(T$1()), x = /* @__PURE__ */ s$1((pt) => pt.map((yt) => typeof yt < "u").filter(Boolean).length, "count"), E = /* @__PURE__ */ s$1((pt, yt) => {
  let { exists: ir, eq: ti, neq: ii, truthy: ui } = pt;
  if (x([ir, ti, ii, ui]) > 1)
    throw new Error(`Invalid conditional test ${JSON.stringify({ exists: ir, eq: ti, neq: ii })}`);
  if (typeof ti < "u")
    return (0, y.isEqual)(yt, ti);
  if (typeof ii < "u")
    return !(0, y.isEqual)(yt, ii);
  if (typeof ir < "u") {
    let ai = typeof yt < "u";
    return ir ? ai : !ai;
  }
  return typeof ui > "u" || ui ? !!yt : !yt;
}, "testValue"), z = /* @__PURE__ */ s$1((pt, yt, ir) => {
  if (!pt.if)
    return !0;
  let { arg: ti, global: ii } = pt.if;
  if (x([ti, ii]) !== 1)
    throw new Error(`Invalid conditional value ${JSON.stringify({ arg: ti, global: ii })}`);
  let ui = ti ? yt[ti] : ir[ii];
  return E(pt.if, ui);
}, "includeConditionalArg");
function L$1(pt) {
  let yt, ir = {
    _tag: "Preview",
    input: pt,
    get composed() {
      if (yt)
        return yt;
      let { addons: ti, ...ii } = pt;
      return yt = be(Ee([...ti ?? [], ii])), yt;
    },
    meta(ti) {
      return I$1(ti, this);
    }
  };
  return globalThis.globalProjectAnnotations = ir.composed, ir;
}
s$1(L$1, "__definePreview");
function W(pt) {
  return pt != null && typeof pt == "object" && "_tag" in pt && (pt == null ? void 0 : pt._tag) === "Preview";
}
s$1(W, "isPreview");
function H(pt) {
  return pt != null && typeof pt == "object" && "_tag" in pt && (pt == null ? void 0 : pt._tag) === "Meta";
}
s$1(H, "isMeta");
function I$1(pt, yt) {
  return {
    _tag: "Meta",
    input: pt,
    preview: yt,
    get composed() {
      throw new Error("Not implemented");
    },
    story(ir) {
      return U(ir, this);
    }
  };
}
s$1(I$1, "defineMeta");
function U(pt, yt) {
  return {
    _tag: "Story",
    input: pt,
    meta: yt,
    get composed() {
      throw new Error("Not implemented");
    }
  };
}
s$1(U, "defineStory");
function K(pt) {
  return pt != null && typeof pt == "object" && "_tag" in pt && (pt == null ? void 0 : pt._tag) === "Story";
}
s$1(K, "isStory");
var D = /* @__PURE__ */ s$1((pt) => pt.toLowerCase().replace(/[ ’–—―′¿'`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, "-").replace(
  /-+/g,
  "-"
).replace(/^-+/, "").replace(/-+$/, ""), "sanitize"), w = /* @__PURE__ */ s$1((pt, yt) => {
  let ir = D(pt);
  if (ir === "")
    throw new Error(`Invalid ${yt} '${pt}', must include alphanumeric characters`);
  return ir;
}, "sanitizeSafe"), ee$1 = /* @__PURE__ */ s$1((pt, yt) => `${w(pt, "kind")}${yt ? `--${w(yt, "name")}` : ""}`, "toId"), re$1 = /* @__PURE__ */ s$1((pt) => R(
  pt
), "storyNameFromExport");
function S(pt, yt) {
  return Array.isArray(yt) ? yt.includes(pt) : pt.match(yt);
}
s$1(S, "matches");
function te$1(pt, { includeStories: yt, excludeStories: ir }) {
  return (
    // https://babeljs.io/docs/en/babel-plugin-transform-modules-commonjs
    pt !== "__esModule" && (!yt || S(pt, yt)) && (!ir || !S(pt, ir))
  );
}
s$1(te$1, "isExportStory");
var oe = /* @__PURE__ */ s$1((...pt) => {
  let yt = pt.reduce((ir, ti) => (ti.startsWith("!") ? ir.delete(ti.slice(1)) : ir.add(ti), ir), /* @__PURE__ */ new Set());
  return Array.from(yt);
}, "combineTags"), zn = Object.create, br = Object.defineProperty, Vn = Object.getOwnPropertyDescriptor, Hn = Object.getOwnPropertyNames, Wn = Object.getPrototypeOf, $n = Object.prototype.hasOwnProperty, s = (pt, yt) => br(pt, "name", { value: yt, configurable: !0 }), Fe = /* @__PURE__ */ ((pt) => typeof require < "u" ? require : typeof Proxy < "u" ? new Proxy(pt, {
  get: (yt, ir) => (typeof require < "u" ? require : yt)[ir]
}) : pt)(function(pt) {
  if (typeof require < "u") return require.apply(this, arguments);
  throw Error('Dynamic require of "' + pt + '" is not supported');
}), k = (pt, yt) => () => (yt || pt((yt = { exports: {} }).exports, yt), yt.exports), Yn = (pt, yt, ir, ti) => {
  if (yt && typeof yt == "object" || typeof yt == "function")
    for (let ii of Hn(yt))
      !$n.call(pt, ii) && ii !== ir && br(pt, ii, { get: () => yt[ii], enumerable: !(ti = Vn(yt, ii)) || ti.enumerable });
  return pt;
}, he = (pt, yt, ir) => (ir = pt != null ? zn(Wn(pt)) : {}, Yn(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  br(ir, "default", { value: pt, enumerable: !0 }),
  pt
)), _r = k((pt, yt) => {
  (function(ir) {
    if (typeof pt == "object" && typeof yt < "u")
      yt.exports = ir();
    else if (typeof define == "function" && define.amd)
      define([], ir);
    else {
      var ti;
      typeof window < "u" ? ti = window : typeof global < "u" ? ti = global : typeof self < "u" ? ti = self : ti = this, ti.memoizerific = ir();
    }
  })(function() {
    return (/* @__PURE__ */ s(function ir(ti, ii, ui) {
      function ai(si, di) {
        if (!ii[si]) {
          if (!ti[si]) {
            var fi = typeof Fe == "function" && Fe;
            if (!di && fi) return fi(si, !0);
            if (li) return li(si, !0);
            var gi = new Error("Cannot find module '" + si + "'");
            throw gi.code = "MODULE_NOT_FOUND", gi;
          }
          var mi = ii[si] = { exports: {} };
          ti[si][0].call(mi.exports, function(Ti) {
            var vi = ti[si][1][Ti];
            return ai(vi || Ti);
          }, mi, mi.exports, ir, ti, ii, ui);
        }
        return ii[si].exports;
      }
      s(ai, "s");
      for (var li = typeof Fe == "function" && Fe, oi = 0; oi < ui.length; oi++) ai(ui[oi]);
      return ai;
    }, "e"))({ 1: [function(ir, ti, ii) {
      ti.exports = function(ui) {
        if (typeof Map != "function" || ui) {
          var ai = ir("./similar");
          return new ai();
        } else
          return /* @__PURE__ */ new Map();
      };
    }, { "./similar": 2 }], 2: [function(ir, ti, ii) {
      function ui() {
        return this.list = [], this.lastItem = void 0, this.size = 0, this;
      }
      s(ui, "Similar"), ui.prototype.get = function(ai) {
        var li;
        if (this.lastItem && this.isEqual(this.lastItem.key, ai))
          return this.lastItem.val;
        if (li = this.indexOf(ai), li >= 0)
          return this.lastItem = this.list[li], this.list[li].val;
      }, ui.prototype.set = function(ai, li) {
        var oi;
        return this.lastItem && this.isEqual(this.lastItem.key, ai) ? (this.lastItem.val = li, this) : (oi = this.indexOf(ai), oi >= 0 ? (this.lastItem = this.list[oi], this.list[oi].val = li, this) : (this.lastItem = { key: ai, val: li }, this.list.push(this.lastItem), this.size++, this));
      }, ui.prototype.delete = function(ai) {
        var li;
        if (this.lastItem && this.isEqual(this.lastItem.key, ai) && (this.lastItem = void 0), li = this.indexOf(ai), li >= 0)
          return this.size--, this.list.splice(li, 1)[0];
      }, ui.prototype.has = function(ai) {
        var li;
        return this.lastItem && this.isEqual(this.lastItem.key, ai) ? !0 : (li = this.indexOf(ai), li >= 0 ? (this.lastItem = this.list[li], !0) : !1);
      }, ui.prototype.forEach = function(ai, li) {
        var oi;
        for (oi = 0; oi < this.size; oi++)
          ai.call(li || this, this.list[oi].val, this.list[oi].key, this);
      }, ui.prototype.indexOf = function(ai) {
        var li;
        for (li = 0; li < this.size; li++)
          if (this.isEqual(this.list[li].key, ai))
            return li;
        return -1;
      }, ui.prototype.isEqual = function(ai, li) {
        return ai === li || ai !== ai && li !== li;
      }, ti.exports = ui;
    }, {}], 3: [function(ir, ti, ii) {
      var ui = ir("map-or-similar");
      ti.exports = function(si) {
        var di = new ui(!1), fi = [];
        return function(gi) {
          var mi = /* @__PURE__ */ s(function() {
            var Ti = di, vi, xi, Si = arguments.length - 1, Pi = Array(Si + 1), $i = !0, Oi;
            if ((mi.numArgs || mi.numArgs === 0) && mi.numArgs !== Si + 1)
              throw new Error("Memoizerific functions should always be called with the same number of arguments");
            for (Oi = 0; Oi < Si; Oi++) {
              if (Pi[Oi] = {
                cacheItem: Ti,
                arg: arguments[Oi]
              }, Ti.has(arguments[Oi])) {
                Ti = Ti.get(arguments[Oi]);
                continue;
              }
              $i = !1, vi = new ui(!1), Ti.set(arguments[Oi], vi), Ti = vi;
            }
            return $i && (Ti.has(arguments[Si]) ? xi = Ti.get(arguments[Si]) : $i = !1), $i || (xi = gi.apply(null, arguments), Ti.set(arguments[Si], xi)), si > 0 && (Pi[Si] = {
              cacheItem: Ti,
              arg: arguments[Si]
            }, $i ? ai(fi, Pi) : fi.push(Pi), fi.length > si && li(fi.shift())), mi.wasMemoized = $i, mi.numArgs = Si + 1, xi;
          }, "memoizerific");
          return mi.limit = si, mi.wasMemoized = !1, mi.cache = di, mi.lru = fi, mi;
        };
      };
      function ai(si, di) {
        var fi = si.length, gi = di.length, mi, Ti, vi;
        for (Ti = 0; Ti < fi; Ti++) {
          for (mi = !0, vi = 0; vi < gi; vi++)
            if (!oi(si[Ti][vi].arg, di[vi].arg)) {
              mi = !1;
              break;
            }
          if (mi)
            break;
        }
        si.push(si.splice(Ti, 1)[0]);
      }
      s(ai, "moveToMostRecentLru");
      function li(si) {
        var di = si.length, fi = si[di - 1], gi, mi;
        for (fi.cacheItem.delete(fi.arg), mi = di - 2; mi >= 0 && (fi = si[mi], gi = fi.cacheItem.get(fi.arg), !gi || !gi.size); mi--)
          fi.cacheItem.delete(fi.arg);
      }
      s(li, "removeCachedResult");
      function oi(si, di) {
        return si === di || si !== si && di !== di;
      }
      s(oi, "isEqual");
    }, { "map-or-similar": 1 }] }, {}, [3])(3);
  });
}), dt = k((pt) => {
  Object.defineProperty(pt, "__esModule", { value: !0 }), pt.encodeString = ti;
  var yt = Array.from({ length: 256 }, (ii, ui) => "%" + ((ui < 16 ? "0" : "") + ui.toString(16)).toUpperCase()), ir = new Int8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    0
  ]);
  function ti(ii) {
    let ui = ii.length;
    if (ui === 0)
      return "";
    let ai = "", li = 0, oi = 0;
    e: for (; oi < ui; oi++) {
      let si = ii.charCodeAt(oi);
      for (; si < 128; ) {
        if (ir[si] !== 1 && (li < oi && (ai += ii.slice(li, oi)), li = oi + 1, ai += yt[si]), ++oi === ui)
          break e;
        si = ii.charCodeAt(oi);
      }
      if (li < oi && (ai += ii.slice(li, oi)), si < 2048) {
        li = oi + 1, ai += yt[192 | si >> 6] + yt[128 | si & 63];
        continue;
      }
      if (si < 55296 || si >= 57344) {
        li = oi + 1, ai += yt[224 | si >> 12] + yt[128 | si >> 6 & 63] + yt[128 | si & 63];
        continue;
      }
      if (++oi, oi >= ui)
        throw new Error("URI malformed");
      let di = ii.charCodeAt(oi) & 1023;
      li = oi + 1, si = 65536 + ((si & 1023) << 10 | di), ai += yt[240 | si >> 18] + yt[128 | si >> 12 & 63] + yt[128 | si >> 6 & 63] + yt[128 | si & 63];
    }
    return li === 0 ? ii : li < ui ? ai + ii.slice(li) : ai;
  }
  s(ti, "encodeString");
}), sr = k((pt) => {
  Object.defineProperty(pt, "__esModule", { value: !0 }), pt.defaultOptions = pt.defaultShouldSerializeObject = pt.defaultValueSerializer = void 0;
  var yt = dt(), ir = /* @__PURE__ */ s((ui) => {
    switch (typeof ui) {
      case "string":
        return (0, yt.encodeString)(ui);
      case "bigint":
      case "boolean":
        return "" + ui;
      case "number":
        if (Number.isFinite(ui))
          return ui < 1e21 ? "" + ui : (0, yt.encodeString)("" + ui);
        break;
    }
    return ui instanceof Date ? (0, yt.encodeString)(ui.toISOString()) : "";
  }, "defaultValueSerializer");
  pt.defaultValueSerializer = ir;
  var ti = /* @__PURE__ */ s((ui) => ui instanceof Date, "defaultShouldSerializeObject");
  pt.defaultShouldSerializeObject = ti;
  var ii = /* @__PURE__ */ s((ui) => ui, "identityFunc");
  pt.defaultOptions = {
    nesting: !0,
    nestingSyntax: "dot",
    arrayRepeat: !1,
    arrayRepeatSyntax: "repeat",
    delimiter: 38,
    valueDeserializer: ii,
    valueSerializer: pt.defaultValueSerializer,
    keyDeserializer: ii,
    shouldSerializeObject: pt.defaultShouldSerializeObject
  };
}), ut = k((pt) => {
  Object.defineProperty(pt, "__esModule", { value: !0 }), pt.getDeepObject = ii, pt.stringifyObject = di;
  var yt = sr(), ir = dt();
  function ti(fi) {
    return fi === "__proto__" || fi === "constructor" || fi === "prototype";
  }
  s(ti, "isPrototypeKey");
  function ii(fi, gi, mi, Ti, vi) {
    if (ti(gi))
      return fi;
    let xi = fi[gi];
    return typeof xi == "object" && xi !== null ? xi : !Ti && (vi || typeof mi == "number" || typeof mi == "string" && mi * 0 === 0 && mi.indexOf(".") === -1) ? fi[gi] = [] : fi[gi] = {};
  }
  s(ii, "getDeepObject");
  var ui = 20, ai = "[]", li = "[", oi = "]", si = ".";
  function di(fi, gi, mi = 0, Ti, vi) {
    let { nestingSyntax: xi = yt.defaultOptions.nestingSyntax, arrayRepeat: Si = yt.defaultOptions.arrayRepeat, arrayRepeatSyntax: Pi = yt.defaultOptions.arrayRepeatSyntax, nesting: $i = yt.defaultOptions.nesting, delimiter: Oi = yt.defaultOptions.delimiter, valueSerializer: Di = yt.defaultOptions.valueSerializer, shouldSerializeObject: Mi = yt.defaultOptions.shouldSerializeObject } = gi, Oo = typeof Oi == "number" ? String.fromCharCode(
      Oi
    ) : Oi, io = vi === !0 && Si, xo = xi === "dot" || xi === "js" && !vi;
    if (mi > ui)
      return "";
    let fo = "", _o = !0, Li = !1;
    for (let Co in fi) {
      let Ni = fi[Co], Yi;
      Ti ? (Yi = Ti, io ? Pi === "bracket" && (Yi += ai) : xo ? (Yi += si, Yi += Co) : (Yi += li, Yi += Co, Yi += oi)) : Yi = Co, _o || (fo += Oo), typeof Ni == "object" && Ni !== null && !Mi(Ni) ? (Li = Ni.pop !== void 0, ($i || Si && Li) && (fo += di(Ni, gi, mi + 1, Yi, Li))) : (fo += (0, ir.encodeString)(Yi), fo += "=", fo += Di(Ni, Co)), _o && (_o = !1);
    }
    return fo;
  }
  s(di, "stringifyObject");
}), $o = k((pt, yt) => {
  var ir = 12, ti = 0, ii = [
    // The first part of the table maps bytes to character to a transition.
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    4,
    4,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    6,
    7,
    7,
    7,
    7,
    7,
    7,
    7,
    7,
    7,
    7,
    7,
    7,
    8,
    7,
    7,
    10,
    9,
    9,
    9,
    11,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    // The second part of the table maps a state to a new state when adding a
    // transition.
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    12,
    0,
    0,
    0,
    0,
    24,
    36,
    48,
    60,
    72,
    84,
    96,
    0,
    12,
    12,
    12,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    24,
    24,
    24,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    24,
    24,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    48,
    48,
    48,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    48,
    48,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    48,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    // The third part maps the current transition to a mask that needs to apply
    // to the byte.
    127,
    63,
    63,
    63,
    0,
    31,
    15,
    15,
    15,
    7,
    7,
    7
  ];
  function ui(oi) {
    var si = oi.indexOf("%");
    if (si === -1) return oi;
    for (var di = oi.length, fi = "", gi = 0, mi = 0, Ti = si, vi = ir; si > -1 && si < di; ) {
      var xi = li(oi[si + 1], 4), Si = li(oi[si + 2], 0), Pi = xi | Si, $i = ii[Pi];
      if (vi = ii[256 + vi + $i], mi = mi << 6 | Pi & ii[364 + $i], vi === ir)
        fi += oi.slice(gi, Ti), fi += mi <= 65535 ? String.fromCharCode(mi) : String.fromCharCode(
          55232 + (mi >> 10),
          56320 + (mi & 1023)
        ), mi = 0, gi = si + 3, si = Ti = oi.indexOf("%", gi);
      else {
        if (vi === ti)
          return null;
        if (si += 3, si < di && oi.charCodeAt(si) === 37) continue;
        return null;
      }
    }
    return fi + oi.slice(gi);
  }
  s(ui, "decodeURIComponent");
  var ai = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    a: 10,
    A: 10,
    b: 11,
    B: 11,
    c: 12,
    C: 12,
    d: 13,
    D: 13,
    e: 14,
    E: 14,
    f: 15,
    F: 15
  };
  function li(oi, si) {
    var di = ai[oi];
    return di === void 0 ? 255 : di << si;
  }
  s(li, "hexCodeToInt"), yt.exports = ui;
}), Jo = k((pt) => {
  var yt = pt && pt.__importDefault || function(fi) {
    return fi && fi.__esModule ? fi : { default: fi };
  };
  Object.defineProperty(pt, "__esModule", { value: !0 }), pt.numberValueDeserializer = pt.numberKeyDeserializer = void 0, pt.parse = di;
  var ir = ut(), ti = sr(), ii = yt($o()), ui = /* @__PURE__ */ s((fi) => {
    let gi = Number(fi);
    return Number.isNaN(gi) ? fi : gi;
  }, "numberKeyDeserializer");
  pt.numberKeyDeserializer = ui;
  var ai = /* @__PURE__ */ s((fi) => {
    let gi = Number(fi);
    return Number.isNaN(gi) ? fi : gi;
  }, "numberValueDeserializer");
  pt.numberValueDeserializer = ai;
  var li = /\+/g, oi = /* @__PURE__ */ s(function() {
  }, "Empty");
  oi.prototype = /* @__PURE__ */ Object.create(null);
  function si(fi, gi, mi, Ti, vi) {
    let xi = fi.substring(gi, mi);
    return Ti && (xi = xi.replace(li, " ")), vi && (xi = (0, ii.default)(xi) || xi), xi;
  }
  s(si, "computeKeySlice");
  function di(fi, gi) {
    let { valueDeserializer: mi = ti.defaultOptions.valueDeserializer, keyDeserializer: Ti = ti.defaultOptions.keyDeserializer, arrayRepeatSyntax: vi = ti.defaultOptions.arrayRepeatSyntax, nesting: xi = ti.defaultOptions.nesting, arrayRepeat: Si = ti.defaultOptions.arrayRepeat, nestingSyntax: Pi = ti.defaultOptions.nestingSyntax, delimiter: $i = ti.defaultOptions.delimiter } = gi ?? {}, Oi = typeof $i == "string" ? $i.charCodeAt(0) : $i, Di = Pi === "js", Mi = new oi();
    if (typeof fi != "string")
      return Mi;
    let Oo = fi.length, io = "", xo = -1, fo = -1, _o = -1, Li = Mi, Co, Ni = "", Yi = "", Vo = !1, No = !1, Ui = !1, jo = !1, Wi = !1, ji = !1, Hi = !1, zo = 0, Lo = -1, sa = -1, Ko = -1;
    for (let ca = 0; ca < Oo + 1; ca++) {
      if (zo = ca !== Oo ? fi.charCodeAt(ca) : Oi, zo === Oi) {
        if (Hi = fo > xo, Hi || (fo = ca), _o !== fo - 1 && (Yi = si(fi, _o + 1, Lo > -1 ? Lo : fo, Ui, Vo), Ni = Ti(Yi), Co !== void 0 && (Li = (0, ir.getDeepObject)(
          Li,
          Co,
          Ni,
          Di && Wi,
          Di && ji
        ))), Hi || Ni !== "") {
          Hi && (io = fi.slice(fo + 1, ca), jo && (io = io.replace(li, " ")), No && (io = (0, ii.default)(io) || io));
          let pa = mi(io, Ni);
          if (Si) {
            let ga = Li[Ni];
            ga === void 0 ? Lo > -1 ? Li[Ni] = [pa] : Li[Ni] = pa : ga.pop ? ga.push(pa) : Li[Ni] = [ga, pa];
          } else
            Li[Ni] = pa;
        }
        io = "", xo = ca, fo = ca, Vo = !1, No = !1, Ui = !1, jo = !1, Wi = !1, ji = !1, Lo = -1, _o = ca, Li = Mi, Co = void 0, Ni = "";
      } else zo === 93 ? (Si && vi === "bracket" && Ko === 91 && (Lo = sa), xi && (Pi === "index" || Di) && fo <= xo && (_o !== sa && (Yi = si(
        fi,
        _o + 1,
        ca,
        Ui,
        Vo
      ), Ni = Ti(Yi), Co !== void 0 && (Li = (0, ir.getDeepObject)(Li, Co, Ni, void 0, Di)), Co = Ni, Ui = !1, Vo = !1), _o = ca, ji = !0, Wi = !1)) : zo === 46 ? xi && (Pi === "dot" || Di) && fo <= xo && (_o !== sa && (Yi = si(fi, _o + 1, ca, Ui, Vo), Ni = Ti(Yi), Co !== void 0 && (Li = (0, ir.getDeepObject)(
        Li,
        Co,
        Ni,
        Di
      )), Co = Ni, Ui = !1, Vo = !1), Wi = !0, ji = !1, _o = ca) : zo === 91 ? xi && (Pi === "index" || Di) && fo <= xo && (_o !== sa && (Yi = si(
        fi,
        _o + 1,
        ca,
        Ui,
        Vo
      ), Ni = Ti(Yi), Di && Co !== void 0 && (Li = (0, ir.getDeepObject)(Li, Co, Ni, Di)), Co = Ni, Ui = !1, Vo = !1, Wi = !1, ji = !0), _o = ca) : zo === 61 ? fo <= xo ? fo = ca : No = !0 : zo === 43 ? fo > xo ? jo = !0 : Ui = !0 : zo === 37 && (fo > xo ? No = !0 : Vo = !0);
      sa = ca, Ko = zo;
    }
    return Mi;
  }
  s(di, "parse");
}), Qo = k((pt) => {
  Object.defineProperty(pt, "__esModule", { value: !0 }), pt.stringify = ir;
  var yt = ut();
  function ir(ti, ii) {
    if (ti === null || typeof ti != "object")
      return "";
    let ui = ii ?? {};
    return (0, yt.stringifyObject)(ti, ui);
  }
  s(ir, "stringify");
}), cr = k((pt) => {
  var yt = pt && pt.__createBinding || (Object.create ? function(ui, ai, li, oi) {
    oi === void 0 && (oi = li);
    var si = Object.getOwnPropertyDescriptor(ai, li);
    (!si || ("get" in si ? !ai.__esModule : si.writable || si.configurable)) && (si = { enumerable: !0, get: /* @__PURE__ */ s(function() {
      return ai[li];
    }, "get") }), Object.defineProperty(ui, oi, si);
  } : function(ui, ai, li, oi) {
    oi === void 0 && (oi = li), ui[oi] = ai[li];
  }), ir = pt && pt.__exportStar || function(ui, ai) {
    for (var li in ui) li !== "default" && !Object.prototype.hasOwnProperty.call(ai, li) && yt(ai, ui, li);
  };
  Object.defineProperty(pt, "__esModule", { value: !0 }), pt.stringify = pt.parse = void 0;
  var ti = Jo();
  Object.defineProperty(pt, "parse", { enumerable: !0, get: /* @__PURE__ */ s(function() {
    return ti.parse;
  }, "get") });
  var ii = Qo();
  Object.defineProperty(pt, "stringify", { enumerable: !0, get: /* @__PURE__ */ s(function() {
    return ii.stringify;
  }, "get") }), ir(sr(), pt);
}), St = k((pt, yt) => {
  yt.exports = {
    Aacute: "Á",
    aacute: "á",
    Abreve: "Ă",
    abreve: "ă",
    ac: "∾",
    acd: "∿",
    acE: "∾̳",
    Acirc: "Â",
    acirc: "â",
    acute: "´",
    Acy: "А",
    acy: "а",
    AElig: "Æ",
    aelig: "æ",
    af: "⁡",
    Afr: "𝔄",
    afr: "𝔞",
    Agrave: "À",
    agrave: "à",
    alefsym: "ℵ",
    aleph: "ℵ",
    Alpha: "Α",
    alpha: "α",
    Amacr: "Ā",
    amacr: "ā",
    amalg: "⨿",
    amp: "&",
    AMP: "&",
    andand: "⩕",
    And: "⩓",
    and: "∧",
    andd: "⩜",
    andslope: "⩘",
    andv: "⩚",
    ang: "∠",
    ange: "⦤",
    angle: "∠",
    angmsdaa: "⦨",
    angmsdab: "⦩",
    angmsdac: "⦪",
    angmsdad: "⦫",
    angmsdae: "⦬",
    angmsdaf: "⦭",
    angmsdag: "⦮",
    angmsdah: "⦯",
    angmsd: "∡",
    angrt: "∟",
    angrtvb: "⊾",
    angrtvbd: "⦝",
    angsph: "∢",
    angst: "Å",
    angzarr: "⍼",
    Aogon: "Ą",
    aogon: "ą",
    Aopf: "𝔸",
    aopf: "𝕒",
    apacir: "⩯",
    ap: "≈",
    apE: "⩰",
    ape: "≊",
    apid: "≋",
    apos: "'",
    ApplyFunction: "⁡",
    approx: "≈",
    approxeq: "≊",
    Aring: "Å",
    aring: "å",
    Ascr: "𝒜",
    ascr: "𝒶",
    Assign: "≔",
    ast: "*",
    asymp: "≈",
    asympeq: "≍",
    Atilde: "Ã",
    atilde: "ã",
    Auml: "Ä",
    auml: "ä",
    awconint: "∳",
    awint: "⨑",
    backcong: "≌",
    backepsilon: "϶",
    backprime: "‵",
    backsim: "∽",
    backsimeq: "⋍",
    Backslash: "∖",
    Barv: "⫧",
    barvee: "⊽",
    barwed: "⌅",
    Barwed: "⌆",
    barwedge: "⌅",
    bbrk: "⎵",
    bbrktbrk: "⎶",
    bcong: "≌",
    Bcy: "Б",
    bcy: "б",
    bdquo: "„",
    becaus: "∵",
    because: "∵",
    Because: "∵",
    bemptyv: "⦰",
    bepsi: "϶",
    bernou: "ℬ",
    Bernoullis: "ℬ",
    Beta: "Β",
    beta: "β",
    beth: "ℶ",
    between: "≬",
    Bfr: "𝔅",
    bfr: "𝔟",
    bigcap: "⋂",
    bigcirc: "◯",
    bigcup: "⋃",
    bigodot: "⨀",
    bigoplus: "⨁",
    bigotimes: "⨂",
    bigsqcup: "⨆",
    bigstar: "★",
    bigtriangledown: "▽",
    bigtriangleup: "△",
    biguplus: "⨄",
    bigvee: "⋁",
    bigwedge: "⋀",
    bkarow: "⤍",
    blacklozenge: "⧫",
    blacksquare: "▪",
    blacktriangle: "▴",
    blacktriangledown: "▾",
    blacktriangleleft: "◂",
    blacktriangleright: "▸",
    blank: "␣",
    blk12: "▒",
    blk14: "░",
    blk34: "▓",
    block: "█",
    bne: "=⃥",
    bnequiv: "≡⃥",
    bNot: "⫭",
    bnot: "⌐",
    Bopf: "𝔹",
    bopf: "𝕓",
    bot: "⊥",
    bottom: "⊥",
    bowtie: "⋈",
    boxbox: "⧉",
    boxdl: "┐",
    boxdL: "╕",
    boxDl: "╖",
    boxDL: "╗",
    boxdr: "┌",
    boxdR: "╒",
    boxDr: "╓",
    boxDR: "╔",
    boxh: "─",
    boxH: "═",
    boxhd: "┬",
    boxHd: "╤",
    boxhD: "╥",
    boxHD: "╦",
    boxhu: "┴",
    boxHu: "╧",
    boxhU: "╨",
    boxHU: "╩",
    boxminus: "⊟",
    boxplus: "⊞",
    boxtimes: "⊠",
    boxul: "┘",
    boxuL: "╛",
    boxUl: "╜",
    boxUL: "╝",
    boxur: "└",
    boxuR: "╘",
    boxUr: "╙",
    boxUR: "╚",
    boxv: "│",
    boxV: "║",
    boxvh: "┼",
    boxvH: "╪",
    boxVh: "╫",
    boxVH: "╬",
    boxvl: "┤",
    boxvL: "╡",
    boxVl: "╢",
    boxVL: "╣",
    boxvr: "├",
    boxvR: "╞",
    boxVr: "╟",
    boxVR: "╠",
    bprime: "‵",
    breve: "˘",
    Breve: "˘",
    brvbar: "¦",
    bscr: "𝒷",
    Bscr: "ℬ",
    bsemi: "⁏",
    bsim: "∽",
    bsime: "⋍",
    bsolb: "⧅",
    bsol: "\\",
    bsolhsub: "⟈",
    bull: "•",
    bullet: "•",
    bump: "≎",
    bumpE: "⪮",
    bumpe: "≏",
    Bumpeq: "≎",
    bumpeq: "≏",
    Cacute: "Ć",
    cacute: "ć",
    capand: "⩄",
    capbrcup: "⩉",
    capcap: "⩋",
    cap: "∩",
    Cap: "⋒",
    capcup: "⩇",
    capdot: "⩀",
    CapitalDifferentialD: "ⅅ",
    caps: "∩︀",
    caret: "⁁",
    caron: "ˇ",
    Cayleys: "ℭ",
    ccaps: "⩍",
    Ccaron: "Č",
    ccaron: "č",
    Ccedil: "Ç",
    ccedil: "ç",
    Ccirc: "Ĉ",
    ccirc: "ĉ",
    Cconint: "∰",
    ccups: "⩌",
    ccupssm: "⩐",
    Cdot: "Ċ",
    cdot: "ċ",
    cedil: "¸",
    Cedilla: "¸",
    cemptyv: "⦲",
    cent: "¢",
    centerdot: "·",
    CenterDot: "·",
    cfr: "𝔠",
    Cfr: "ℭ",
    CHcy: "Ч",
    chcy: "ч",
    check: "✓",
    checkmark: "✓",
    Chi: "Χ",
    chi: "χ",
    circ: "ˆ",
    circeq: "≗",
    circlearrowleft: "↺",
    circlearrowright: "↻",
    circledast: "⊛",
    circledcirc: "⊚",
    circleddash: "⊝",
    CircleDot: "⊙",
    circledR: "®",
    circledS: "Ⓢ",
    CircleMinus: "⊖",
    CirclePlus: "⊕",
    CircleTimes: "⊗",
    cir: "○",
    cirE: "⧃",
    cire: "≗",
    cirfnint: "⨐",
    cirmid: "⫯",
    cirscir: "⧂",
    ClockwiseContourIntegral: "∲",
    CloseCurlyDoubleQuote: "”",
    CloseCurlyQuote: "’",
    clubs: "♣",
    clubsuit: "♣",
    colon: ":",
    Colon: "∷",
    Colone: "⩴",
    colone: "≔",
    coloneq: "≔",
    comma: ",",
    commat: "@",
    comp: "∁",
    compfn: "∘",
    complement: "∁",
    complexes: "ℂ",
    cong: "≅",
    congdot: "⩭",
    Congruent: "≡",
    conint: "∮",
    Conint: "∯",
    ContourIntegral: "∮",
    copf: "𝕔",
    Copf: "ℂ",
    coprod: "∐",
    Coproduct: "∐",
    copy: "©",
    COPY: "©",
    copysr: "℗",
    CounterClockwiseContourIntegral: "∳",
    crarr: "↵",
    cross: "✗",
    Cross: "⨯",
    Cscr: "𝒞",
    cscr: "𝒸",
    csub: "⫏",
    csube: "⫑",
    csup: "⫐",
    csupe: "⫒",
    ctdot: "⋯",
    cudarrl: "⤸",
    cudarrr: "⤵",
    cuepr: "⋞",
    cuesc: "⋟",
    cularr: "↶",
    cularrp: "⤽",
    cupbrcap: "⩈",
    cupcap: "⩆",
    CupCap: "≍",
    cup: "∪",
    Cup: "⋓",
    cupcup: "⩊",
    cupdot: "⊍",
    cupor: "⩅",
    cups: "∪︀",
    curarr: "↷",
    curarrm: "⤼",
    curlyeqprec: "⋞",
    curlyeqsucc: "⋟",
    curlyvee: "⋎",
    curlywedge: "⋏",
    curren: "¤",
    curvearrowleft: "↶",
    curvearrowright: "↷",
    cuvee: "⋎",
    cuwed: "⋏",
    cwconint: "∲",
    cwint: "∱",
    cylcty: "⌭",
    dagger: "†",
    Dagger: "‡",
    daleth: "ℸ",
    darr: "↓",
    Darr: "↡",
    dArr: "⇓",
    dash: "‐",
    Dashv: "⫤",
    dashv: "⊣",
    dbkarow: "⤏",
    dblac: "˝",
    Dcaron: "Ď",
    dcaron: "ď",
    Dcy: "Д",
    dcy: "д",
    ddagger: "‡",
    ddarr: "⇊",
    DD: "ⅅ",
    dd: "ⅆ",
    DDotrahd: "⤑",
    ddotseq: "⩷",
    deg: "°",
    Del: "∇",
    Delta: "Δ",
    delta: "δ",
    demptyv: "⦱",
    dfisht: "⥿",
    Dfr: "𝔇",
    dfr: "𝔡",
    dHar: "⥥",
    dharl: "⇃",
    dharr: "⇂",
    DiacriticalAcute: "´",
    DiacriticalDot: "˙",
    DiacriticalDoubleAcute: "˝",
    DiacriticalGrave: "`",
    DiacriticalTilde: "˜",
    diam: "⋄",
    diamond: "⋄",
    Diamond: "⋄",
    diamondsuit: "♦",
    diams: "♦",
    die: "¨",
    DifferentialD: "ⅆ",
    digamma: "ϝ",
    disin: "⋲",
    div: "÷",
    divide: "÷",
    divideontimes: "⋇",
    divonx: "⋇",
    DJcy: "Ђ",
    djcy: "ђ",
    dlcorn: "⌞",
    dlcrop: "⌍",
    dollar: "$",
    Dopf: "𝔻",
    dopf: "𝕕",
    Dot: "¨",
    dot: "˙",
    DotDot: "⃜",
    doteq: "≐",
    doteqdot: "≑",
    DotEqual: "≐",
    dotminus: "∸",
    dotplus: "∔",
    dotsquare: "⊡",
    doublebarwedge: "⌆",
    DoubleContourIntegral: "∯",
    DoubleDot: "¨",
    DoubleDownArrow: "⇓",
    DoubleLeftArrow: "⇐",
    DoubleLeftRightArrow: "⇔",
    DoubleLeftTee: "⫤",
    DoubleLongLeftArrow: "⟸",
    DoubleLongLeftRightArrow: "⟺",
    DoubleLongRightArrow: "⟹",
    DoubleRightArrow: "⇒",
    DoubleRightTee: "⊨",
    DoubleUpArrow: "⇑",
    DoubleUpDownArrow: "⇕",
    DoubleVerticalBar: "∥",
    DownArrowBar: "⤓",
    downarrow: "↓",
    DownArrow: "↓",
    Downarrow: "⇓",
    DownArrowUpArrow: "⇵",
    DownBreve: "̑",
    downdownarrows: "⇊",
    downharpoonleft: "⇃",
    downharpoonright: "⇂",
    DownLeftRightVector: "⥐",
    DownLeftTeeVector: "⥞",
    DownLeftVectorBar: "⥖",
    DownLeftVector: "↽",
    DownRightTeeVector: "⥟",
    DownRightVectorBar: "⥗",
    DownRightVector: "⇁",
    DownTeeArrow: "↧",
    DownTee: "⊤",
    drbkarow: "⤐",
    drcorn: "⌟",
    drcrop: "⌌",
    Dscr: "𝒟",
    dscr: "𝒹",
    DScy: "Ѕ",
    dscy: "ѕ",
    dsol: "⧶",
    Dstrok: "Đ",
    dstrok: "đ",
    dtdot: "⋱",
    dtri: "▿",
    dtrif: "▾",
    duarr: "⇵",
    duhar: "⥯",
    dwangle: "⦦",
    DZcy: "Џ",
    dzcy: "џ",
    dzigrarr: "⟿",
    Eacute: "É",
    eacute: "é",
    easter: "⩮",
    Ecaron: "Ě",
    ecaron: "ě",
    Ecirc: "Ê",
    ecirc: "ê",
    ecir: "≖",
    ecolon: "≕",
    Ecy: "Э",
    ecy: "э",
    eDDot: "⩷",
    Edot: "Ė",
    edot: "ė",
    eDot: "≑",
    ee: "ⅇ",
    efDot: "≒",
    Efr: "𝔈",
    efr: "𝔢",
    eg: "⪚",
    Egrave: "È",
    egrave: "è",
    egs: "⪖",
    egsdot: "⪘",
    el: "⪙",
    Element: "∈",
    elinters: "⏧",
    ell: "ℓ",
    els: "⪕",
    elsdot: "⪗",
    Emacr: "Ē",
    emacr: "ē",
    empty: "∅",
    emptyset: "∅",
    EmptySmallSquare: "◻",
    emptyv: "∅",
    EmptyVerySmallSquare: "▫",
    emsp13: " ",
    emsp14: " ",
    emsp: " ",
    ENG: "Ŋ",
    eng: "ŋ",
    ensp: " ",
    Eogon: "Ę",
    eogon: "ę",
    Eopf: "𝔼",
    eopf: "𝕖",
    epar: "⋕",
    eparsl: "⧣",
    eplus: "⩱",
    epsi: "ε",
    Epsilon: "Ε",
    epsilon: "ε",
    epsiv: "ϵ",
    eqcirc: "≖",
    eqcolon: "≕",
    eqsim: "≂",
    eqslantgtr: "⪖",
    eqslantless: "⪕",
    Equal: "⩵",
    equals: "=",
    EqualTilde: "≂",
    equest: "≟",
    Equilibrium: "⇌",
    equiv: "≡",
    equivDD: "⩸",
    eqvparsl: "⧥",
    erarr: "⥱",
    erDot: "≓",
    escr: "ℯ",
    Escr: "ℰ",
    esdot: "≐",
    Esim: "⩳",
    esim: "≂",
    Eta: "Η",
    eta: "η",
    ETH: "Ð",
    eth: "ð",
    Euml: "Ë",
    euml: "ë",
    euro: "€",
    excl: "!",
    exist: "∃",
    Exists: "∃",
    expectation: "ℰ",
    exponentiale: "ⅇ",
    ExponentialE: "ⅇ",
    fallingdotseq: "≒",
    Fcy: "Ф",
    fcy: "ф",
    female: "♀",
    ffilig: "ﬃ",
    fflig: "ﬀ",
    ffllig: "ﬄ",
    Ffr: "𝔉",
    ffr: "𝔣",
    filig: "ﬁ",
    FilledSmallSquare: "◼",
    FilledVerySmallSquare: "▪",
    fjlig: "fj",
    flat: "♭",
    fllig: "ﬂ",
    fltns: "▱",
    fnof: "ƒ",
    Fopf: "𝔽",
    fopf: "𝕗",
    forall: "∀",
    ForAll: "∀",
    fork: "⋔",
    forkv: "⫙",
    Fouriertrf: "ℱ",
    fpartint: "⨍",
    frac12: "½",
    frac13: "⅓",
    frac14: "¼",
    frac15: "⅕",
    frac16: "⅙",
    frac18: "⅛",
    frac23: "⅔",
    frac25: "⅖",
    frac34: "¾",
    frac35: "⅗",
    frac38: "⅜",
    frac45: "⅘",
    frac56: "⅚",
    frac58: "⅝",
    frac78: "⅞",
    frasl: "⁄",
    frown: "⌢",
    fscr: "𝒻",
    Fscr: "ℱ",
    gacute: "ǵ",
    Gamma: "Γ",
    gamma: "γ",
    Gammad: "Ϝ",
    gammad: "ϝ",
    gap: "⪆",
    Gbreve: "Ğ",
    gbreve: "ğ",
    Gcedil: "Ģ",
    Gcirc: "Ĝ",
    gcirc: "ĝ",
    Gcy: "Г",
    gcy: "г",
    Gdot: "Ġ",
    gdot: "ġ",
    ge: "≥",
    gE: "≧",
    gEl: "⪌",
    gel: "⋛",
    geq: "≥",
    geqq: "≧",
    geqslant: "⩾",
    gescc: "⪩",
    ges: "⩾",
    gesdot: "⪀",
    gesdoto: "⪂",
    gesdotol: "⪄",
    gesl: "⋛︀",
    gesles: "⪔",
    Gfr: "𝔊",
    gfr: "𝔤",
    gg: "≫",
    Gg: "⋙",
    ggg: "⋙",
    gimel: "ℷ",
    GJcy: "Ѓ",
    gjcy: "ѓ",
    gla: "⪥",
    gl: "≷",
    glE: "⪒",
    glj: "⪤",
    gnap: "⪊",
    gnapprox: "⪊",
    gne: "⪈",
    gnE: "≩",
    gneq: "⪈",
    gneqq: "≩",
    gnsim: "⋧",
    Gopf: "𝔾",
    gopf: "𝕘",
    grave: "`",
    GreaterEqual: "≥",
    GreaterEqualLess: "⋛",
    GreaterFullEqual: "≧",
    GreaterGreater: "⪢",
    GreaterLess: "≷",
    GreaterSlantEqual: "⩾",
    GreaterTilde: "≳",
    Gscr: "𝒢",
    gscr: "ℊ",
    gsim: "≳",
    gsime: "⪎",
    gsiml: "⪐",
    gtcc: "⪧",
    gtcir: "⩺",
    gt: ">",
    GT: ">",
    Gt: "≫",
    gtdot: "⋗",
    gtlPar: "⦕",
    gtquest: "⩼",
    gtrapprox: "⪆",
    gtrarr: "⥸",
    gtrdot: "⋗",
    gtreqless: "⋛",
    gtreqqless: "⪌",
    gtrless: "≷",
    gtrsim: "≳",
    gvertneqq: "≩︀",
    gvnE: "≩︀",
    Hacek: "ˇ",
    hairsp: " ",
    half: "½",
    hamilt: "ℋ",
    HARDcy: "Ъ",
    hardcy: "ъ",
    harrcir: "⥈",
    harr: "↔",
    hArr: "⇔",
    harrw: "↭",
    Hat: "^",
    hbar: "ℏ",
    Hcirc: "Ĥ",
    hcirc: "ĥ",
    hearts: "♥",
    heartsuit: "♥",
    hellip: "…",
    hercon: "⊹",
    hfr: "𝔥",
    Hfr: "ℌ",
    HilbertSpace: "ℋ",
    hksearow: "⤥",
    hkswarow: "⤦",
    hoarr: "⇿",
    homtht: "∻",
    hookleftarrow: "↩",
    hookrightarrow: "↪",
    hopf: "𝕙",
    Hopf: "ℍ",
    horbar: "―",
    HorizontalLine: "─",
    hscr: "𝒽",
    Hscr: "ℋ",
    hslash: "ℏ",
    Hstrok: "Ħ",
    hstrok: "ħ",
    HumpDownHump: "≎",
    HumpEqual: "≏",
    hybull: "⁃",
    hyphen: "‐",
    Iacute: "Í",
    iacute: "í",
    ic: "⁣",
    Icirc: "Î",
    icirc: "î",
    Icy: "И",
    icy: "и",
    Idot: "İ",
    IEcy: "Е",
    iecy: "е",
    iexcl: "¡",
    iff: "⇔",
    ifr: "𝔦",
    Ifr: "ℑ",
    Igrave: "Ì",
    igrave: "ì",
    ii: "ⅈ",
    iiiint: "⨌",
    iiint: "∭",
    iinfin: "⧜",
    iiota: "℩",
    IJlig: "Ĳ",
    ijlig: "ĳ",
    Imacr: "Ī",
    imacr: "ī",
    image: "ℑ",
    ImaginaryI: "ⅈ",
    imagline: "ℐ",
    imagpart: "ℑ",
    imath: "ı",
    Im: "ℑ",
    imof: "⊷",
    imped: "Ƶ",
    Implies: "⇒",
    incare: "℅",
    in: "∈",
    infin: "∞",
    infintie: "⧝",
    inodot: "ı",
    intcal: "⊺",
    int: "∫",
    Int: "∬",
    integers: "ℤ",
    Integral: "∫",
    intercal: "⊺",
    Intersection: "⋂",
    intlarhk: "⨗",
    intprod: "⨼",
    InvisibleComma: "⁣",
    InvisibleTimes: "⁢",
    IOcy: "Ё",
    iocy: "ё",
    Iogon: "Į",
    iogon: "į",
    Iopf: "𝕀",
    iopf: "𝕚",
    Iota: "Ι",
    iota: "ι",
    iprod: "⨼",
    iquest: "¿",
    iscr: "𝒾",
    Iscr: "ℐ",
    isin: "∈",
    isindot: "⋵",
    isinE: "⋹",
    isins: "⋴",
    isinsv: "⋳",
    isinv: "∈",
    it: "⁢",
    Itilde: "Ĩ",
    itilde: "ĩ",
    Iukcy: "І",
    iukcy: "і",
    Iuml: "Ï",
    iuml: "ï",
    Jcirc: "Ĵ",
    jcirc: "ĵ",
    Jcy: "Й",
    jcy: "й",
    Jfr: "𝔍",
    jfr: "𝔧",
    jmath: "ȷ",
    Jopf: "𝕁",
    jopf: "𝕛",
    Jscr: "𝒥",
    jscr: "𝒿",
    Jsercy: "Ј",
    jsercy: "ј",
    Jukcy: "Є",
    jukcy: "є",
    Kappa: "Κ",
    kappa: "κ",
    kappav: "ϰ",
    Kcedil: "Ķ",
    kcedil: "ķ",
    Kcy: "К",
    kcy: "к",
    Kfr: "𝔎",
    kfr: "𝔨",
    kgreen: "ĸ",
    KHcy: "Х",
    khcy: "х",
    KJcy: "Ќ",
    kjcy: "ќ",
    Kopf: "𝕂",
    kopf: "𝕜",
    Kscr: "𝒦",
    kscr: "𝓀",
    lAarr: "⇚",
    Lacute: "Ĺ",
    lacute: "ĺ",
    laemptyv: "⦴",
    lagran: "ℒ",
    Lambda: "Λ",
    lambda: "λ",
    lang: "⟨",
    Lang: "⟪",
    langd: "⦑",
    langle: "⟨",
    lap: "⪅",
    Laplacetrf: "ℒ",
    laquo: "«",
    larrb: "⇤",
    larrbfs: "⤟",
    larr: "←",
    Larr: "↞",
    lArr: "⇐",
    larrfs: "⤝",
    larrhk: "↩",
    larrlp: "↫",
    larrpl: "⤹",
    larrsim: "⥳",
    larrtl: "↢",
    latail: "⤙",
    lAtail: "⤛",
    lat: "⪫",
    late: "⪭",
    lates: "⪭︀",
    lbarr: "⤌",
    lBarr: "⤎",
    lbbrk: "❲",
    lbrace: "{",
    lbrack: "[",
    lbrke: "⦋",
    lbrksld: "⦏",
    lbrkslu: "⦍",
    Lcaron: "Ľ",
    lcaron: "ľ",
    Lcedil: "Ļ",
    lcedil: "ļ",
    lceil: "⌈",
    lcub: "{",
    Lcy: "Л",
    lcy: "л",
    ldca: "⤶",
    ldquo: "“",
    ldquor: "„",
    ldrdhar: "⥧",
    ldrushar: "⥋",
    ldsh: "↲",
    le: "≤",
    lE: "≦",
    LeftAngleBracket: "⟨",
    LeftArrowBar: "⇤",
    leftarrow: "←",
    LeftArrow: "←",
    Leftarrow: "⇐",
    LeftArrowRightArrow: "⇆",
    leftarrowtail: "↢",
    LeftCeiling: "⌈",
    LeftDoubleBracket: "⟦",
    LeftDownTeeVector: "⥡",
    LeftDownVectorBar: "⥙",
    LeftDownVector: "⇃",
    LeftFloor: "⌊",
    leftharpoondown: "↽",
    leftharpoonup: "↼",
    leftleftarrows: "⇇",
    leftrightarrow: "↔",
    LeftRightArrow: "↔",
    Leftrightarrow: "⇔",
    leftrightarrows: "⇆",
    leftrightharpoons: "⇋",
    leftrightsquigarrow: "↭",
    LeftRightVector: "⥎",
    LeftTeeArrow: "↤",
    LeftTee: "⊣",
    LeftTeeVector: "⥚",
    leftthreetimes: "⋋",
    LeftTriangleBar: "⧏",
    LeftTriangle: "⊲",
    LeftTriangleEqual: "⊴",
    LeftUpDownVector: "⥑",
    LeftUpTeeVector: "⥠",
    LeftUpVectorBar: "⥘",
    LeftUpVector: "↿",
    LeftVectorBar: "⥒",
    LeftVector: "↼",
    lEg: "⪋",
    leg: "⋚",
    leq: "≤",
    leqq: "≦",
    leqslant: "⩽",
    lescc: "⪨",
    les: "⩽",
    lesdot: "⩿",
    lesdoto: "⪁",
    lesdotor: "⪃",
    lesg: "⋚︀",
    lesges: "⪓",
    lessapprox: "⪅",
    lessdot: "⋖",
    lesseqgtr: "⋚",
    lesseqqgtr: "⪋",
    LessEqualGreater: "⋚",
    LessFullEqual: "≦",
    LessGreater: "≶",
    lessgtr: "≶",
    LessLess: "⪡",
    lesssim: "≲",
    LessSlantEqual: "⩽",
    LessTilde: "≲",
    lfisht: "⥼",
    lfloor: "⌊",
    Lfr: "𝔏",
    lfr: "𝔩",
    lg: "≶",
    lgE: "⪑",
    lHar: "⥢",
    lhard: "↽",
    lharu: "↼",
    lharul: "⥪",
    lhblk: "▄",
    LJcy: "Љ",
    ljcy: "љ",
    llarr: "⇇",
    ll: "≪",
    Ll: "⋘",
    llcorner: "⌞",
    Lleftarrow: "⇚",
    llhard: "⥫",
    lltri: "◺",
    Lmidot: "Ŀ",
    lmidot: "ŀ",
    lmoustache: "⎰",
    lmoust: "⎰",
    lnap: "⪉",
    lnapprox: "⪉",
    lne: "⪇",
    lnE: "≨",
    lneq: "⪇",
    lneqq: "≨",
    lnsim: "⋦",
    loang: "⟬",
    loarr: "⇽",
    lobrk: "⟦",
    longleftarrow: "⟵",
    LongLeftArrow: "⟵",
    Longleftarrow: "⟸",
    longleftrightarrow: "⟷",
    LongLeftRightArrow: "⟷",
    Longleftrightarrow: "⟺",
    longmapsto: "⟼",
    longrightarrow: "⟶",
    LongRightArrow: "⟶",
    Longrightarrow: "⟹",
    looparrowleft: "↫",
    looparrowright: "↬",
    lopar: "⦅",
    Lopf: "𝕃",
    lopf: "𝕝",
    loplus: "⨭",
    lotimes: "⨴",
    lowast: "∗",
    lowbar: "_",
    LowerLeftArrow: "↙",
    LowerRightArrow: "↘",
    loz: "◊",
    lozenge: "◊",
    lozf: "⧫",
    lpar: "(",
    lparlt: "⦓",
    lrarr: "⇆",
    lrcorner: "⌟",
    lrhar: "⇋",
    lrhard: "⥭",
    lrm: "‎",
    lrtri: "⊿",
    lsaquo: "‹",
    lscr: "𝓁",
    Lscr: "ℒ",
    lsh: "↰",
    Lsh: "↰",
    lsim: "≲",
    lsime: "⪍",
    lsimg: "⪏",
    lsqb: "[",
    lsquo: "‘",
    lsquor: "‚",
    Lstrok: "Ł",
    lstrok: "ł",
    ltcc: "⪦",
    ltcir: "⩹",
    lt: "<",
    LT: "<",
    Lt: "≪",
    ltdot: "⋖",
    lthree: "⋋",
    ltimes: "⋉",
    ltlarr: "⥶",
    ltquest: "⩻",
    ltri: "◃",
    ltrie: "⊴",
    ltrif: "◂",
    ltrPar: "⦖",
    lurdshar: "⥊",
    luruhar: "⥦",
    lvertneqq: "≨︀",
    lvnE: "≨︀",
    macr: "¯",
    male: "♂",
    malt: "✠",
    maltese: "✠",
    Map: "⤅",
    map: "↦",
    mapsto: "↦",
    mapstodown: "↧",
    mapstoleft: "↤",
    mapstoup: "↥",
    marker: "▮",
    mcomma: "⨩",
    Mcy: "М",
    mcy: "м",
    mdash: "—",
    mDDot: "∺",
    measuredangle: "∡",
    MediumSpace: " ",
    Mellintrf: "ℳ",
    Mfr: "𝔐",
    mfr: "𝔪",
    mho: "℧",
    micro: "µ",
    midast: "*",
    midcir: "⫰",
    mid: "∣",
    middot: "·",
    minusb: "⊟",
    minus: "−",
    minusd: "∸",
    minusdu: "⨪",
    MinusPlus: "∓",
    mlcp: "⫛",
    mldr: "…",
    mnplus: "∓",
    models: "⊧",
    Mopf: "𝕄",
    mopf: "𝕞",
    mp: "∓",
    mscr: "𝓂",
    Mscr: "ℳ",
    mstpos: "∾",
    Mu: "Μ",
    mu: "μ",
    multimap: "⊸",
    mumap: "⊸",
    nabla: "∇",
    Nacute: "Ń",
    nacute: "ń",
    nang: "∠⃒",
    nap: "≉",
    napE: "⩰̸",
    napid: "≋̸",
    napos: "ŉ",
    napprox: "≉",
    natural: "♮",
    naturals: "ℕ",
    natur: "♮",
    nbsp: " ",
    nbump: "≎̸",
    nbumpe: "≏̸",
    ncap: "⩃",
    Ncaron: "Ň",
    ncaron: "ň",
    Ncedil: "Ņ",
    ncedil: "ņ",
    ncong: "≇",
    ncongdot: "⩭̸",
    ncup: "⩂",
    Ncy: "Н",
    ncy: "н",
    ndash: "–",
    nearhk: "⤤",
    nearr: "↗",
    neArr: "⇗",
    nearrow: "↗",
    ne: "≠",
    nedot: "≐̸",
    NegativeMediumSpace: "​",
    NegativeThickSpace: "​",
    NegativeThinSpace: "​",
    NegativeVeryThinSpace: "​",
    nequiv: "≢",
    nesear: "⤨",
    nesim: "≂̸",
    NestedGreaterGreater: "≫",
    NestedLessLess: "≪",
    NewLine: `
`,
    nexist: "∄",
    nexists: "∄",
    Nfr: "𝔑",
    nfr: "𝔫",
    ngE: "≧̸",
    nge: "≱",
    ngeq: "≱",
    ngeqq: "≧̸",
    ngeqslant: "⩾̸",
    nges: "⩾̸",
    nGg: "⋙̸",
    ngsim: "≵",
    nGt: "≫⃒",
    ngt: "≯",
    ngtr: "≯",
    nGtv: "≫̸",
    nharr: "↮",
    nhArr: "⇎",
    nhpar: "⫲",
    ni: "∋",
    nis: "⋼",
    nisd: "⋺",
    niv: "∋",
    NJcy: "Њ",
    njcy: "њ",
    nlarr: "↚",
    nlArr: "⇍",
    nldr: "‥",
    nlE: "≦̸",
    nle: "≰",
    nleftarrow: "↚",
    nLeftarrow: "⇍",
    nleftrightarrow: "↮",
    nLeftrightarrow: "⇎",
    nleq: "≰",
    nleqq: "≦̸",
    nleqslant: "⩽̸",
    nles: "⩽̸",
    nless: "≮",
    nLl: "⋘̸",
    nlsim: "≴",
    nLt: "≪⃒",
    nlt: "≮",
    nltri: "⋪",
    nltrie: "⋬",
    nLtv: "≪̸",
    nmid: "∤",
    NoBreak: "⁠",
    NonBreakingSpace: " ",
    nopf: "𝕟",
    Nopf: "ℕ",
    Not: "⫬",
    not: "¬",
    NotCongruent: "≢",
    NotCupCap: "≭",
    NotDoubleVerticalBar: "∦",
    NotElement: "∉",
    NotEqual: "≠",
    NotEqualTilde: "≂̸",
    NotExists: "∄",
    NotGreater: "≯",
    NotGreaterEqual: "≱",
    NotGreaterFullEqual: "≧̸",
    NotGreaterGreater: "≫̸",
    NotGreaterLess: "≹",
    NotGreaterSlantEqual: "⩾̸",
    NotGreaterTilde: "≵",
    NotHumpDownHump: "≎̸",
    NotHumpEqual: "≏̸",
    notin: "∉",
    notindot: "⋵̸",
    notinE: "⋹̸",
    notinva: "∉",
    notinvb: "⋷",
    notinvc: "⋶",
    NotLeftTriangleBar: "⧏̸",
    NotLeftTriangle: "⋪",
    NotLeftTriangleEqual: "⋬",
    NotLess: "≮",
    NotLessEqual: "≰",
    NotLessGreater: "≸",
    NotLessLess: "≪̸",
    NotLessSlantEqual: "⩽̸",
    NotLessTilde: "≴",
    NotNestedGreaterGreater: "⪢̸",
    NotNestedLessLess: "⪡̸",
    notni: "∌",
    notniva: "∌",
    notnivb: "⋾",
    notnivc: "⋽",
    NotPrecedes: "⊀",
    NotPrecedesEqual: "⪯̸",
    NotPrecedesSlantEqual: "⋠",
    NotReverseElement: "∌",
    NotRightTriangleBar: "⧐̸",
    NotRightTriangle: "⋫",
    NotRightTriangleEqual: "⋭",
    NotSquareSubset: "⊏̸",
    NotSquareSubsetEqual: "⋢",
    NotSquareSuperset: "⊐̸",
    NotSquareSupersetEqual: "⋣",
    NotSubset: "⊂⃒",
    NotSubsetEqual: "⊈",
    NotSucceeds: "⊁",
    NotSucceedsEqual: "⪰̸",
    NotSucceedsSlantEqual: "⋡",
    NotSucceedsTilde: "≿̸",
    NotSuperset: "⊃⃒",
    NotSupersetEqual: "⊉",
    NotTilde: "≁",
    NotTildeEqual: "≄",
    NotTildeFullEqual: "≇",
    NotTildeTilde: "≉",
    NotVerticalBar: "∤",
    nparallel: "∦",
    npar: "∦",
    nparsl: "⫽⃥",
    npart: "∂̸",
    npolint: "⨔",
    npr: "⊀",
    nprcue: "⋠",
    nprec: "⊀",
    npreceq: "⪯̸",
    npre: "⪯̸",
    nrarrc: "⤳̸",
    nrarr: "↛",
    nrArr: "⇏",
    nrarrw: "↝̸",
    nrightarrow: "↛",
    nRightarrow: "⇏",
    nrtri: "⋫",
    nrtrie: "⋭",
    nsc: "⊁",
    nsccue: "⋡",
    nsce: "⪰̸",
    Nscr: "𝒩",
    nscr: "𝓃",
    nshortmid: "∤",
    nshortparallel: "∦",
    nsim: "≁",
    nsime: "≄",
    nsimeq: "≄",
    nsmid: "∤",
    nspar: "∦",
    nsqsube: "⋢",
    nsqsupe: "⋣",
    nsub: "⊄",
    nsubE: "⫅̸",
    nsube: "⊈",
    nsubset: "⊂⃒",
    nsubseteq: "⊈",
    nsubseteqq: "⫅̸",
    nsucc: "⊁",
    nsucceq: "⪰̸",
    nsup: "⊅",
    nsupE: "⫆̸",
    nsupe: "⊉",
    nsupset: "⊃⃒",
    nsupseteq: "⊉",
    nsupseteqq: "⫆̸",
    ntgl: "≹",
    Ntilde: "Ñ",
    ntilde: "ñ",
    ntlg: "≸",
    ntriangleleft: "⋪",
    ntrianglelefteq: "⋬",
    ntriangleright: "⋫",
    ntrianglerighteq: "⋭",
    Nu: "Ν",
    nu: "ν",
    num: "#",
    numero: "№",
    numsp: " ",
    nvap: "≍⃒",
    nvdash: "⊬",
    nvDash: "⊭",
    nVdash: "⊮",
    nVDash: "⊯",
    nvge: "≥⃒",
    nvgt: ">⃒",
    nvHarr: "⤄",
    nvinfin: "⧞",
    nvlArr: "⤂",
    nvle: "≤⃒",
    nvlt: "<⃒",
    nvltrie: "⊴⃒",
    nvrArr: "⤃",
    nvrtrie: "⊵⃒",
    nvsim: "∼⃒",
    nwarhk: "⤣",
    nwarr: "↖",
    nwArr: "⇖",
    nwarrow: "↖",
    nwnear: "⤧",
    Oacute: "Ó",
    oacute: "ó",
    oast: "⊛",
    Ocirc: "Ô",
    ocirc: "ô",
    ocir: "⊚",
    Ocy: "О",
    ocy: "о",
    odash: "⊝",
    Odblac: "Ő",
    odblac: "ő",
    odiv: "⨸",
    odot: "⊙",
    odsold: "⦼",
    OElig: "Œ",
    oelig: "œ",
    ofcir: "⦿",
    Ofr: "𝔒",
    ofr: "𝔬",
    ogon: "˛",
    Ograve: "Ò",
    ograve: "ò",
    ogt: "⧁",
    ohbar: "⦵",
    ohm: "Ω",
    oint: "∮",
    olarr: "↺",
    olcir: "⦾",
    olcross: "⦻",
    oline: "‾",
    olt: "⧀",
    Omacr: "Ō",
    omacr: "ō",
    Omega: "Ω",
    omega: "ω",
    Omicron: "Ο",
    omicron: "ο",
    omid: "⦶",
    ominus: "⊖",
    Oopf: "𝕆",
    oopf: "𝕠",
    opar: "⦷",
    OpenCurlyDoubleQuote: "“",
    OpenCurlyQuote: "‘",
    operp: "⦹",
    oplus: "⊕",
    orarr: "↻",
    Or: "⩔",
    or: "∨",
    ord: "⩝",
    order: "ℴ",
    orderof: "ℴ",
    ordf: "ª",
    ordm: "º",
    origof: "⊶",
    oror: "⩖",
    orslope: "⩗",
    orv: "⩛",
    oS: "Ⓢ",
    Oscr: "𝒪",
    oscr: "ℴ",
    Oslash: "Ø",
    oslash: "ø",
    osol: "⊘",
    Otilde: "Õ",
    otilde: "õ",
    otimesas: "⨶",
    Otimes: "⨷",
    otimes: "⊗",
    Ouml: "Ö",
    ouml: "ö",
    ovbar: "⌽",
    OverBar: "‾",
    OverBrace: "⏞",
    OverBracket: "⎴",
    OverParenthesis: "⏜",
    para: "¶",
    parallel: "∥",
    par: "∥",
    parsim: "⫳",
    parsl: "⫽",
    part: "∂",
    PartialD: "∂",
    Pcy: "П",
    pcy: "п",
    percnt: "%",
    period: ".",
    permil: "‰",
    perp: "⊥",
    pertenk: "‱",
    Pfr: "𝔓",
    pfr: "𝔭",
    Phi: "Φ",
    phi: "φ",
    phiv: "ϕ",
    phmmat: "ℳ",
    phone: "☎",
    Pi: "Π",
    pi: "π",
    pitchfork: "⋔",
    piv: "ϖ",
    planck: "ℏ",
    planckh: "ℎ",
    plankv: "ℏ",
    plusacir: "⨣",
    plusb: "⊞",
    pluscir: "⨢",
    plus: "+",
    plusdo: "∔",
    plusdu: "⨥",
    pluse: "⩲",
    PlusMinus: "±",
    plusmn: "±",
    plussim: "⨦",
    plustwo: "⨧",
    pm: "±",
    Poincareplane: "ℌ",
    pointint: "⨕",
    popf: "𝕡",
    Popf: "ℙ",
    pound: "£",
    prap: "⪷",
    Pr: "⪻",
    pr: "≺",
    prcue: "≼",
    precapprox: "⪷",
    prec: "≺",
    preccurlyeq: "≼",
    Precedes: "≺",
    PrecedesEqual: "⪯",
    PrecedesSlantEqual: "≼",
    PrecedesTilde: "≾",
    preceq: "⪯",
    precnapprox: "⪹",
    precneqq: "⪵",
    precnsim: "⋨",
    pre: "⪯",
    prE: "⪳",
    precsim: "≾",
    prime: "′",
    Prime: "″",
    primes: "ℙ",
    prnap: "⪹",
    prnE: "⪵",
    prnsim: "⋨",
    prod: "∏",
    Product: "∏",
    profalar: "⌮",
    profline: "⌒",
    profsurf: "⌓",
    prop: "∝",
    Proportional: "∝",
    Proportion: "∷",
    propto: "∝",
    prsim: "≾",
    prurel: "⊰",
    Pscr: "𝒫",
    pscr: "𝓅",
    Psi: "Ψ",
    psi: "ψ",
    puncsp: " ",
    Qfr: "𝔔",
    qfr: "𝔮",
    qint: "⨌",
    qopf: "𝕢",
    Qopf: "ℚ",
    qprime: "⁗",
    Qscr: "𝒬",
    qscr: "𝓆",
    quaternions: "ℍ",
    quatint: "⨖",
    quest: "?",
    questeq: "≟",
    quot: '"',
    QUOT: '"',
    rAarr: "⇛",
    race: "∽̱",
    Racute: "Ŕ",
    racute: "ŕ",
    radic: "√",
    raemptyv: "⦳",
    rang: "⟩",
    Rang: "⟫",
    rangd: "⦒",
    range: "⦥",
    rangle: "⟩",
    raquo: "»",
    rarrap: "⥵",
    rarrb: "⇥",
    rarrbfs: "⤠",
    rarrc: "⤳",
    rarr: "→",
    Rarr: "↠",
    rArr: "⇒",
    rarrfs: "⤞",
    rarrhk: "↪",
    rarrlp: "↬",
    rarrpl: "⥅",
    rarrsim: "⥴",
    Rarrtl: "⤖",
    rarrtl: "↣",
    rarrw: "↝",
    ratail: "⤚",
    rAtail: "⤜",
    ratio: "∶",
    rationals: "ℚ",
    rbarr: "⤍",
    rBarr: "⤏",
    RBarr: "⤐",
    rbbrk: "❳",
    rbrace: "}",
    rbrack: "]",
    rbrke: "⦌",
    rbrksld: "⦎",
    rbrkslu: "⦐",
    Rcaron: "Ř",
    rcaron: "ř",
    Rcedil: "Ŗ",
    rcedil: "ŗ",
    rceil: "⌉",
    rcub: "}",
    Rcy: "Р",
    rcy: "р",
    rdca: "⤷",
    rdldhar: "⥩",
    rdquo: "”",
    rdquor: "”",
    rdsh: "↳",
    real: "ℜ",
    realine: "ℛ",
    realpart: "ℜ",
    reals: "ℝ",
    Re: "ℜ",
    rect: "▭",
    reg: "®",
    REG: "®",
    ReverseElement: "∋",
    ReverseEquilibrium: "⇋",
    ReverseUpEquilibrium: "⥯",
    rfisht: "⥽",
    rfloor: "⌋",
    rfr: "𝔯",
    Rfr: "ℜ",
    rHar: "⥤",
    rhard: "⇁",
    rharu: "⇀",
    rharul: "⥬",
    Rho: "Ρ",
    rho: "ρ",
    rhov: "ϱ",
    RightAngleBracket: "⟩",
    RightArrowBar: "⇥",
    rightarrow: "→",
    RightArrow: "→",
    Rightarrow: "⇒",
    RightArrowLeftArrow: "⇄",
    rightarrowtail: "↣",
    RightCeiling: "⌉",
    RightDoubleBracket: "⟧",
    RightDownTeeVector: "⥝",
    RightDownVectorBar: "⥕",
    RightDownVector: "⇂",
    RightFloor: "⌋",
    rightharpoondown: "⇁",
    rightharpoonup: "⇀",
    rightleftarrows: "⇄",
    rightleftharpoons: "⇌",
    rightrightarrows: "⇉",
    rightsquigarrow: "↝",
    RightTeeArrow: "↦",
    RightTee: "⊢",
    RightTeeVector: "⥛",
    rightthreetimes: "⋌",
    RightTriangleBar: "⧐",
    RightTriangle: "⊳",
    RightTriangleEqual: "⊵",
    RightUpDownVector: "⥏",
    RightUpTeeVector: "⥜",
    RightUpVectorBar: "⥔",
    RightUpVector: "↾",
    RightVectorBar: "⥓",
    RightVector: "⇀",
    ring: "˚",
    risingdotseq: "≓",
    rlarr: "⇄",
    rlhar: "⇌",
    rlm: "‏",
    rmoustache: "⎱",
    rmoust: "⎱",
    rnmid: "⫮",
    roang: "⟭",
    roarr: "⇾",
    robrk: "⟧",
    ropar: "⦆",
    ropf: "𝕣",
    Ropf: "ℝ",
    roplus: "⨮",
    rotimes: "⨵",
    RoundImplies: "⥰",
    rpar: ")",
    rpargt: "⦔",
    rppolint: "⨒",
    rrarr: "⇉",
    Rrightarrow: "⇛",
    rsaquo: "›",
    rscr: "𝓇",
    Rscr: "ℛ",
    rsh: "↱",
    Rsh: "↱",
    rsqb: "]",
    rsquo: "’",
    rsquor: "’",
    rthree: "⋌",
    rtimes: "⋊",
    rtri: "▹",
    rtrie: "⊵",
    rtrif: "▸",
    rtriltri: "⧎",
    RuleDelayed: "⧴",
    ruluhar: "⥨",
    rx: "℞",
    Sacute: "Ś",
    sacute: "ś",
    sbquo: "‚",
    scap: "⪸",
    Scaron: "Š",
    scaron: "š",
    Sc: "⪼",
    sc: "≻",
    sccue: "≽",
    sce: "⪰",
    scE: "⪴",
    Scedil: "Ş",
    scedil: "ş",
    Scirc: "Ŝ",
    scirc: "ŝ",
    scnap: "⪺",
    scnE: "⪶",
    scnsim: "⋩",
    scpolint: "⨓",
    scsim: "≿",
    Scy: "С",
    scy: "с",
    sdotb: "⊡",
    sdot: "⋅",
    sdote: "⩦",
    searhk: "⤥",
    searr: "↘",
    seArr: "⇘",
    searrow: "↘",
    sect: "§",
    semi: ";",
    seswar: "⤩",
    setminus: "∖",
    setmn: "∖",
    sext: "✶",
    Sfr: "𝔖",
    sfr: "𝔰",
    sfrown: "⌢",
    sharp: "♯",
    SHCHcy: "Щ",
    shchcy: "щ",
    SHcy: "Ш",
    shcy: "ш",
    ShortDownArrow: "↓",
    ShortLeftArrow: "←",
    shortmid: "∣",
    shortparallel: "∥",
    ShortRightArrow: "→",
    ShortUpArrow: "↑",
    shy: "­",
    Sigma: "Σ",
    sigma: "σ",
    sigmaf: "ς",
    sigmav: "ς",
    sim: "∼",
    simdot: "⩪",
    sime: "≃",
    simeq: "≃",
    simg: "⪞",
    simgE: "⪠",
    siml: "⪝",
    simlE: "⪟",
    simne: "≆",
    simplus: "⨤",
    simrarr: "⥲",
    slarr: "←",
    SmallCircle: "∘",
    smallsetminus: "∖",
    smashp: "⨳",
    smeparsl: "⧤",
    smid: "∣",
    smile: "⌣",
    smt: "⪪",
    smte: "⪬",
    smtes: "⪬︀",
    SOFTcy: "Ь",
    softcy: "ь",
    solbar: "⌿",
    solb: "⧄",
    sol: "/",
    Sopf: "𝕊",
    sopf: "𝕤",
    spades: "♠",
    spadesuit: "♠",
    spar: "∥",
    sqcap: "⊓",
    sqcaps: "⊓︀",
    sqcup: "⊔",
    sqcups: "⊔︀",
    Sqrt: "√",
    sqsub: "⊏",
    sqsube: "⊑",
    sqsubset: "⊏",
    sqsubseteq: "⊑",
    sqsup: "⊐",
    sqsupe: "⊒",
    sqsupset: "⊐",
    sqsupseteq: "⊒",
    square: "□",
    Square: "□",
    SquareIntersection: "⊓",
    SquareSubset: "⊏",
    SquareSubsetEqual: "⊑",
    SquareSuperset: "⊐",
    SquareSupersetEqual: "⊒",
    SquareUnion: "⊔",
    squarf: "▪",
    squ: "□",
    squf: "▪",
    srarr: "→",
    Sscr: "𝒮",
    sscr: "𝓈",
    ssetmn: "∖",
    ssmile: "⌣",
    sstarf: "⋆",
    Star: "⋆",
    star: "☆",
    starf: "★",
    straightepsilon: "ϵ",
    straightphi: "ϕ",
    strns: "¯",
    sub: "⊂",
    Sub: "⋐",
    subdot: "⪽",
    subE: "⫅",
    sube: "⊆",
    subedot: "⫃",
    submult: "⫁",
    subnE: "⫋",
    subne: "⊊",
    subplus: "⪿",
    subrarr: "⥹",
    subset: "⊂",
    Subset: "⋐",
    subseteq: "⊆",
    subseteqq: "⫅",
    SubsetEqual: "⊆",
    subsetneq: "⊊",
    subsetneqq: "⫋",
    subsim: "⫇",
    subsub: "⫕",
    subsup: "⫓",
    succapprox: "⪸",
    succ: "≻",
    succcurlyeq: "≽",
    Succeeds: "≻",
    SucceedsEqual: "⪰",
    SucceedsSlantEqual: "≽",
    SucceedsTilde: "≿",
    succeq: "⪰",
    succnapprox: "⪺",
    succneqq: "⪶",
    succnsim: "⋩",
    succsim: "≿",
    SuchThat: "∋",
    sum: "∑",
    Sum: "∑",
    sung: "♪",
    sup1: "¹",
    sup2: "²",
    sup3: "³",
    sup: "⊃",
    Sup: "⋑",
    supdot: "⪾",
    supdsub: "⫘",
    supE: "⫆",
    supe: "⊇",
    supedot: "⫄",
    Superset: "⊃",
    SupersetEqual: "⊇",
    suphsol: "⟉",
    suphsub: "⫗",
    suplarr: "⥻",
    supmult: "⫂",
    supnE: "⫌",
    supne: "⊋",
    supplus: "⫀",
    supset: "⊃",
    Supset: "⋑",
    supseteq: "⊇",
    supseteqq: "⫆",
    supsetneq: "⊋",
    supsetneqq: "⫌",
    supsim: "⫈",
    supsub: "⫔",
    supsup: "⫖",
    swarhk: "⤦",
    swarr: "↙",
    swArr: "⇙",
    swarrow: "↙",
    swnwar: "⤪",
    szlig: "ß",
    Tab: "	",
    target: "⌖",
    Tau: "Τ",
    tau: "τ",
    tbrk: "⎴",
    Tcaron: "Ť",
    tcaron: "ť",
    Tcedil: "Ţ",
    tcedil: "ţ",
    Tcy: "Т",
    tcy: "т",
    tdot: "⃛",
    telrec: "⌕",
    Tfr: "𝔗",
    tfr: "𝔱",
    there4: "∴",
    therefore: "∴",
    Therefore: "∴",
    Theta: "Θ",
    theta: "θ",
    thetasym: "ϑ",
    thetav: "ϑ",
    thickapprox: "≈",
    thicksim: "∼",
    ThickSpace: "  ",
    ThinSpace: " ",
    thinsp: " ",
    thkap: "≈",
    thksim: "∼",
    THORN: "Þ",
    thorn: "þ",
    tilde: "˜",
    Tilde: "∼",
    TildeEqual: "≃",
    TildeFullEqual: "≅",
    TildeTilde: "≈",
    timesbar: "⨱",
    timesb: "⊠",
    times: "×",
    timesd: "⨰",
    tint: "∭",
    toea: "⤨",
    topbot: "⌶",
    topcir: "⫱",
    top: "⊤",
    Topf: "𝕋",
    topf: "𝕥",
    topfork: "⫚",
    tosa: "⤩",
    tprime: "‴",
    trade: "™",
    TRADE: "™",
    triangle: "▵",
    triangledown: "▿",
    triangleleft: "◃",
    trianglelefteq: "⊴",
    triangleq: "≜",
    triangleright: "▹",
    trianglerighteq: "⊵",
    tridot: "◬",
    trie: "≜",
    triminus: "⨺",
    TripleDot: "⃛",
    triplus: "⨹",
    trisb: "⧍",
    tritime: "⨻",
    trpezium: "⏢",
    Tscr: "𝒯",
    tscr: "𝓉",
    TScy: "Ц",
    tscy: "ц",
    TSHcy: "Ћ",
    tshcy: "ћ",
    Tstrok: "Ŧ",
    tstrok: "ŧ",
    twixt: "≬",
    twoheadleftarrow: "↞",
    twoheadrightarrow: "↠",
    Uacute: "Ú",
    uacute: "ú",
    uarr: "↑",
    Uarr: "↟",
    uArr: "⇑",
    Uarrocir: "⥉",
    Ubrcy: "Ў",
    ubrcy: "ў",
    Ubreve: "Ŭ",
    ubreve: "ŭ",
    Ucirc: "Û",
    ucirc: "û",
    Ucy: "У",
    ucy: "у",
    udarr: "⇅",
    Udblac: "Ű",
    udblac: "ű",
    udhar: "⥮",
    ufisht: "⥾",
    Ufr: "𝔘",
    ufr: "𝔲",
    Ugrave: "Ù",
    ugrave: "ù",
    uHar: "⥣",
    uharl: "↿",
    uharr: "↾",
    uhblk: "▀",
    ulcorn: "⌜",
    ulcorner: "⌜",
    ulcrop: "⌏",
    ultri: "◸",
    Umacr: "Ū",
    umacr: "ū",
    uml: "¨",
    UnderBar: "_",
    UnderBrace: "⏟",
    UnderBracket: "⎵",
    UnderParenthesis: "⏝",
    Union: "⋃",
    UnionPlus: "⊎",
    Uogon: "Ų",
    uogon: "ų",
    Uopf: "𝕌",
    uopf: "𝕦",
    UpArrowBar: "⤒",
    uparrow: "↑",
    UpArrow: "↑",
    Uparrow: "⇑",
    UpArrowDownArrow: "⇅",
    updownarrow: "↕",
    UpDownArrow: "↕",
    Updownarrow: "⇕",
    UpEquilibrium: "⥮",
    upharpoonleft: "↿",
    upharpoonright: "↾",
    uplus: "⊎",
    UpperLeftArrow: "↖",
    UpperRightArrow: "↗",
    upsi: "υ",
    Upsi: "ϒ",
    upsih: "ϒ",
    Upsilon: "Υ",
    upsilon: "υ",
    UpTeeArrow: "↥",
    UpTee: "⊥",
    upuparrows: "⇈",
    urcorn: "⌝",
    urcorner: "⌝",
    urcrop: "⌎",
    Uring: "Ů",
    uring: "ů",
    urtri: "◹",
    Uscr: "𝒰",
    uscr: "𝓊",
    utdot: "⋰",
    Utilde: "Ũ",
    utilde: "ũ",
    utri: "▵",
    utrif: "▴",
    uuarr: "⇈",
    Uuml: "Ü",
    uuml: "ü",
    uwangle: "⦧",
    vangrt: "⦜",
    varepsilon: "ϵ",
    varkappa: "ϰ",
    varnothing: "∅",
    varphi: "ϕ",
    varpi: "ϖ",
    varpropto: "∝",
    varr: "↕",
    vArr: "⇕",
    varrho: "ϱ",
    varsigma: "ς",
    varsubsetneq: "⊊︀",
    varsubsetneqq: "⫋︀",
    varsupsetneq: "⊋︀",
    varsupsetneqq: "⫌︀",
    vartheta: "ϑ",
    vartriangleleft: "⊲",
    vartriangleright: "⊳",
    vBar: "⫨",
    Vbar: "⫫",
    vBarv: "⫩",
    Vcy: "В",
    vcy: "в",
    vdash: "⊢",
    vDash: "⊨",
    Vdash: "⊩",
    VDash: "⊫",
    Vdashl: "⫦",
    veebar: "⊻",
    vee: "∨",
    Vee: "⋁",
    veeeq: "≚",
    vellip: "⋮",
    verbar: "|",
    Verbar: "‖",
    vert: "|",
    Vert: "‖",
    VerticalBar: "∣",
    VerticalLine: "|",
    VerticalSeparator: "❘",
    VerticalTilde: "≀",
    VeryThinSpace: " ",
    Vfr: "𝔙",
    vfr: "𝔳",
    vltri: "⊲",
    vnsub: "⊂⃒",
    vnsup: "⊃⃒",
    Vopf: "𝕍",
    vopf: "𝕧",
    vprop: "∝",
    vrtri: "⊳",
    Vscr: "𝒱",
    vscr: "𝓋",
    vsubnE: "⫋︀",
    vsubne: "⊊︀",
    vsupnE: "⫌︀",
    vsupne: "⊋︀",
    Vvdash: "⊪",
    vzigzag: "⦚",
    Wcirc: "Ŵ",
    wcirc: "ŵ",
    wedbar: "⩟",
    wedge: "∧",
    Wedge: "⋀",
    wedgeq: "≙",
    weierp: "℘",
    Wfr: "𝔚",
    wfr: "𝔴",
    Wopf: "𝕎",
    wopf: "𝕨",
    wp: "℘",
    wr: "≀",
    wreath: "≀",
    Wscr: "𝒲",
    wscr: "𝓌",
    xcap: "⋂",
    xcirc: "◯",
    xcup: "⋃",
    xdtri: "▽",
    Xfr: "𝔛",
    xfr: "𝔵",
    xharr: "⟷",
    xhArr: "⟺",
    Xi: "Ξ",
    xi: "ξ",
    xlarr: "⟵",
    xlArr: "⟸",
    xmap: "⟼",
    xnis: "⋻",
    xodot: "⨀",
    Xopf: "𝕏",
    xopf: "𝕩",
    xoplus: "⨁",
    xotime: "⨂",
    xrarr: "⟶",
    xrArr: "⟹",
    Xscr: "𝒳",
    xscr: "𝓍",
    xsqcup: "⨆",
    xuplus: "⨄",
    xutri: "△",
    xvee: "⋁",
    xwedge: "⋀",
    Yacute: "Ý",
    yacute: "ý",
    YAcy: "Я",
    yacy: "я",
    Ycirc: "Ŷ",
    ycirc: "ŷ",
    Ycy: "Ы",
    ycy: "ы",
    yen: "¥",
    Yfr: "𝔜",
    yfr: "𝔶",
    YIcy: "Ї",
    yicy: "ї",
    Yopf: "𝕐",
    yopf: "𝕪",
    Yscr: "𝒴",
    yscr: "𝓎",
    YUcy: "Ю",
    yucy: "ю",
    yuml: "ÿ",
    Yuml: "Ÿ",
    Zacute: "Ź",
    zacute: "ź",
    Zcaron: "Ž",
    zcaron: "ž",
    Zcy: "З",
    zcy: "з",
    Zdot: "Ż",
    zdot: "ż",
    zeetrf: "ℨ",
    ZeroWidthSpace: "​",
    Zeta: "Ζ",
    zeta: "ζ",
    zfr: "𝔷",
    Zfr: "ℨ",
    ZHcy: "Ж",
    zhcy: "ж",
    zigrarr: "⇝",
    zopf: "𝕫",
    Zopf: "ℤ",
    Zscr: "𝒵",
    zscr: "𝓏",
    zwj: "‍",
    zwnj: "‌"
  };
}), sn = k((pt, yt) => {
  yt.exports = {
    Aacute: "Á",
    aacute: "á",
    Acirc: "Â",
    acirc: "â",
    acute: "´",
    AElig: "Æ",
    aelig: "æ",
    Agrave: "À",
    agrave: "à",
    amp: "&",
    AMP: "&",
    Aring: "Å",
    aring: "å",
    Atilde: "Ã",
    atilde: "ã",
    Auml: "Ä",
    auml: "ä",
    brvbar: "¦",
    Ccedil: "Ç",
    ccedil: "ç",
    cedil: "¸",
    cent: "¢",
    copy: "©",
    COPY: "©",
    curren: "¤",
    deg: "°",
    divide: "÷",
    Eacute: "É",
    eacute: "é",
    Ecirc: "Ê",
    ecirc: "ê",
    Egrave: "È",
    egrave: "è",
    ETH: "Ð",
    eth: "ð",
    Euml: "Ë",
    euml: "ë",
    frac12: "½",
    frac14: "¼",
    frac34: "¾",
    gt: ">",
    GT: ">",
    Iacute: "Í",
    iacute: "í",
    Icirc: "Î",
    icirc: "î",
    iexcl: "¡",
    Igrave: "Ì",
    igrave: "ì",
    iquest: "¿",
    Iuml: "Ï",
    iuml: "ï",
    laquo: "«",
    lt: "<",
    LT: "<",
    macr: "¯",
    micro: "µ",
    middot: "·",
    nbsp: " ",
    not: "¬",
    Ntilde: "Ñ",
    ntilde: "ñ",
    Oacute: "Ó",
    oacute: "ó",
    Ocirc: "Ô",
    ocirc: "ô",
    Ograve: "Ò",
    ograve: "ò",
    ordf: "ª",
    ordm: "º",
    Oslash: "Ø",
    oslash: "ø",
    Otilde: "Õ",
    otilde: "õ",
    Ouml: "Ö",
    ouml: "ö",
    para: "¶",
    plusmn: "±",
    pound: "£",
    quot: '"',
    QUOT: '"',
    raquo: "»",
    reg: "®",
    REG: "®",
    sect: "§",
    shy: "­",
    sup1: "¹",
    sup2: "²",
    sup3: "³",
    szlig: "ß",
    THORN: "Þ",
    thorn: "þ",
    times: "×",
    Uacute: "Ú",
    uacute: "ú",
    Ucirc: "Û",
    ucirc: "û",
    Ugrave: "Ù",
    ugrave: "ù",
    uml: "¨",
    Uuml: "Ü",
    uuml: "ü",
    Yacute: "Ý",
    yacute: "ý",
    yen: "¥",
    yuml: "ÿ"
  };
}), bt = k((pt, yt) => {
  yt.exports = { amp: "&", apos: "'", gt: ">", lt: "<", quot: '"' };
}), an = k((pt, yt) => {
  yt.exports = {
    0: 65533,
    128: 8364,
    130: 8218,
    131: 402,
    132: 8222,
    133: 8230,
    134: 8224,
    135: 8225,
    136: 710,
    137: 8240,
    138: 352,
    139: 8249,
    140: 338,
    142: 381,
    145: 8216,
    146: 8217,
    147: 8220,
    148: 8221,
    149: 8226,
    150: 8211,
    151: 8212,
    152: 732,
    153: 8482,
    154: 353,
    155: 8250,
    156: 339,
    158: 382,
    159: 376
  };
}), cn = k((pt) => {
  var yt = pt && pt.__importDefault || function(ui) {
    return ui && ui.__esModule ? ui : { default: ui };
  };
  Object.defineProperty(pt, "__esModule", { value: !0 });
  var ir = yt(an()), ti = (
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    String.fromCodePoint || function(ui) {
      var ai = "";
      return ui > 65535 && (ui -= 65536, ai += String.fromCharCode(ui >>> 10 & 1023 | 55296), ui = 56320 | ui & 1023), ai += String.fromCharCode(ui), ai;
    }
  );
  function ii(ui) {
    return ui >= 55296 && ui <= 57343 || ui > 1114111 ? "�" : (ui in ir.default && (ui = ir.default[ui]), ti(ui));
  }
  s(ii, "decodeCodePoint"), pt.default = ii;
}), Et = k((pt) => {
  var yt = pt && pt.__importDefault || function(di) {
    return di && di.__esModule ? di : { default: di };
  };
  Object.defineProperty(pt, "__esModule", { value: !0 }), pt.decodeHTML = pt.decodeHTMLStrict = pt.decodeXML = void 0;
  var ir = yt(St()), ti = yt(sn()), ii = yt(bt()), ui = yt(cn()), ai = /&(?:[a-zA-Z0-9]+|#[xX][\da-fA-F]+|#\d+);/g;
  pt.decodeXML = li(ii.default), pt.decodeHTMLStrict = li(ir.default);
  function li(di) {
    var fi = si(di);
    return function(gi) {
      return String(gi).replace(ai, fi);
    };
  }
  s(li, "getStrictDecoder");
  var oi = /* @__PURE__ */ s(function(di, fi) {
    return di < fi ? 1 : -1;
  }, "sorter");
  pt.decodeHTML = (function() {
    for (var di = Object.keys(ti.default).sort(oi), fi = Object.keys(ir.default).sort(oi), gi = 0, mi = 0; gi < fi.length; gi++)
      di[mi] === fi[gi] ? (fi[gi] += ";?", mi++) : fi[gi] += ";";
    var Ti = new RegExp("&(?:" + fi.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"), vi = si(ir.default);
    function xi(Si) {
      return Si.substr(-1) !== ";" && (Si += ";"), vi(Si);
    }
    return s(xi, "replacer"), function(Si) {
      return String(Si).replace(Ti, xi);
    };
  })();
  function si(di) {
    return /* @__PURE__ */ s(function(fi) {
      if (fi.charAt(1) === "#") {
        var gi = fi.charAt(2);
        return gi === "X" || gi === "x" ? ui.default(parseInt(fi.substr(3), 16)) : ui.default(parseInt(fi.substr(2), 10));
      }
      return di[fi.slice(1, -1)] || fi;
    }, "replace");
  }
  s(si, "getReplacer");
}), xt = k((pt) => {
  var yt = pt && pt.__importDefault || function(Pi) {
    return Pi && Pi.__esModule ? Pi : { default: Pi };
  };
  Object.defineProperty(pt, "__esModule", { value: !0 }), pt.escapeUTF8 = pt.escape = pt.encodeNonAsciiHTML = pt.encodeHTML = pt.encodeXML = void 0;
  var ir = yt(bt()), ti = oi(ir.default), ii = si(ti);
  pt.encodeXML = Si(ti);
  var ui = yt(St()), ai = oi(ui.default), li = si(ai);
  pt.encodeHTML = mi(ai, li), pt.encodeNonAsciiHTML = Si(ai);
  function oi(Pi) {
    return Object.keys(Pi).sort().reduce(function($i, Oi) {
      return $i[Pi[Oi]] = "&" + Oi + ";", $i;
    }, {});
  }
  s(oi, "getInverseObj");
  function si(Pi) {
    for (var $i = [], Oi = [], Di = 0, Mi = Object.keys(Pi); Di < Mi.length; Di++) {
      var Oo = Mi[Di];
      Oo.length === 1 ? $i.push("\\" + Oo) : Oi.push(Oo);
    }
    $i.sort();
    for (var io = 0; io < $i.length - 1; io++) {
      for (var xo = io; xo < $i.length - 1 && $i[xo].charCodeAt(1) + 1 === $i[xo + 1].charCodeAt(1); )
        xo += 1;
      var fo = 1 + xo - io;
      fo < 3 || $i.splice(io, fo, $i[io] + "-" + $i[xo]);
    }
    return Oi.unshift("[" + $i.join("") + "]"), new RegExp(Oi.join("|"), "g");
  }
  s(si, "getInverseReplacer");
  var di = /(?:[\x80-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g, fi = (
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    String.prototype.codePointAt != null ? (
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      (function(Pi) {
        return Pi.codePointAt(0);
      })
    ) : (
      // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
      (function(Pi) {
        return (Pi.charCodeAt(0) - 55296) * 1024 + Pi.charCodeAt(1) - 56320 + 65536;
      })
    )
  );
  function gi(Pi) {
    return "&#x" + (Pi.length > 1 ? fi(Pi) : Pi.charCodeAt(0)).toString(16).toUpperCase() + ";";
  }
  s(gi, "singleCharReplacer");
  function mi(Pi, $i) {
    return function(Oi) {
      return Oi.replace($i, function(Di) {
        return Pi[Di];
      }).replace(di, gi);
    };
  }
  s(mi, "getInverse");
  var Ti = new RegExp(ii.source + "|" + di.source, "g");
  function vi(Pi) {
    return Pi.replace(Ti, gi);
  }
  s(vi, "escape"), pt.escape = vi;
  function xi(Pi) {
    return Pi.replace(ii, gi);
  }
  s(xi, "escapeUTF8"), pt.escapeUTF8 = xi;
  function Si(Pi) {
    return function($i) {
      return $i.replace(Ti, function(Oi) {
        return Pi[Oi] || gi(Oi);
      });
    };
  }
  s(Si, "getASCIIEncoder");
}), xn = k((pt) => {
  Object.defineProperty(pt, "__esModule", { value: !0 }), pt.decodeXMLStrict = pt.decodeHTML5Strict = pt.decodeHTML4Strict = pt.decodeHTML5 = pt.decodeHTML4 = pt.decodeHTMLStrict = pt.decodeHTML = pt.decodeXML = pt.encodeHTML5 = pt.encodeHTML4 = pt.escapeUTF8 = pt.escape = pt.encodeNonAsciiHTML = pt.encodeHTML = pt.encodeXML = pt.encode = pt.decodeStrict = pt.decode = void 0;
  var yt = Et(), ir = xt();
  function ti(oi, si) {
    return (!si || si <= 0 ? yt.decodeXML : yt.decodeHTML)(oi);
  }
  s(ti, "decode"), pt.decode = ti;
  function ii(oi, si) {
    return (!si || si <= 0 ? yt.decodeXML : yt.decodeHTMLStrict)(oi);
  }
  s(ii, "decodeStrict"), pt.decodeStrict = ii;
  function ui(oi, si) {
    return (!si || si <= 0 ? ir.encodeXML : ir.encodeHTML)(oi);
  }
  s(ui, "encode"), pt.encode = ui;
  var ai = xt();
  Object.defineProperty(pt, "encodeXML", { enumerable: !0, get: /* @__PURE__ */ s(function() {
    return ai.encodeXML;
  }, "get") }), Object.defineProperty(pt, "encodeHTML", { enumerable: !0, get: /* @__PURE__ */ s(function() {
    return ai.encodeHTML;
  }, "get") }), Object.defineProperty(pt, "encodeNonAsciiHTML", { enumerable: !0, get: /* @__PURE__ */ s(function() {
    return ai.encodeNonAsciiHTML;
  }, "get") }), Object.defineProperty(pt, "escape", { enumerable: !0, get: /* @__PURE__ */ s(function() {
    return ai.escape;
  }, "get") }), Object.defineProperty(pt, "escapeUTF8", { enumerable: !0, get: /* @__PURE__ */ s(function() {
    return ai.escapeUTF8;
  }, "get") }), Object.defineProperty(pt, "encodeHTML4", { enumerable: !0, get: /* @__PURE__ */ s(function() {
    return ai.encodeHTML;
  }, "get") }), Object.defineProperty(pt, "encodeHTML5", { enumerable: !0, get: /* @__PURE__ */ s(function() {
    return ai.encodeHTML;
  }, "get") });
  var li = Et();
  Object.defineProperty(pt, "decodeXML", { enumerable: !0, get: /* @__PURE__ */ s(function() {
    return li.decodeXML;
  }, "get") }), Object.defineProperty(pt, "decodeHTML", { enumerable: !0, get: /* @__PURE__ */ s(function() {
    return li.decodeHTML;
  }, "get") }), Object.defineProperty(pt, "decodeHTMLStrict", { enumerable: !0, get: /* @__PURE__ */ s(function() {
    return li.decodeHTMLStrict;
  }, "get") }), Object.defineProperty(pt, "decodeHTML4", { enumerable: !0, get: /* @__PURE__ */ s(function() {
    return li.decodeHTML;
  }, "get") }), Object.defineProperty(pt, "decodeHTML5", { enumerable: !0, get: /* @__PURE__ */ s(function() {
    return li.decodeHTML;
  }, "get") }), Object.defineProperty(pt, "decodeHTML4Strict", { enumerable: !0, get: /* @__PURE__ */ s(function() {
    return li.decodeHTMLStrict;
  }, "get") }), Object.defineProperty(pt, "decodeHTML5Strict", { enumerable: !0, get: /* @__PURE__ */ s(function() {
    return li.decodeHTMLStrict;
  }, "get") }), Object.defineProperty(pt, "decodeXMLStrict", { enumerable: !0, get: /* @__PURE__ */ s(function() {
    return li.decodeXML;
  }, "get") });
}), jn = k((pt, yt) => {
  function ir(Ni, Yi) {
    if (!(Ni instanceof Yi))
      throw new TypeError("Cannot call a class as a function");
  }
  s(ir, "_classCallCheck");
  function ti(Ni, Yi) {
    for (var Vo = 0; Vo < Yi.length; Vo++) {
      var No = Yi[Vo];
      No.enumerable = No.enumerable || !1, No.configurable = !0, "value" in No && (No.writable = !0), Object.defineProperty(Ni, No.key, No);
    }
  }
  s(ti, "_defineProperties");
  function ii(Ni, Yi, Vo) {
    return Yi && ti(Ni.prototype, Yi), Vo && ti(Ni, Vo), Ni;
  }
  s(ii, "_createClass");
  function ui(Ni, Yi) {
    var Vo = typeof Symbol < "u" && Ni[Symbol.iterator] || Ni["@@iterator"];
    if (!Vo) {
      if (Array.isArray(Ni) || (Vo = ai(Ni)) || Yi && Ni && typeof Ni.length == "number") {
        Vo && (Ni = Vo);
        var No = 0, Ui = /* @__PURE__ */ s(function() {
        }, "F");
        return { s: Ui, n: /* @__PURE__ */ s(function() {
          return No >= Ni.length ? { done: !0 } : { done: !1, value: Ni[No++] };
        }, "n"), e: /* @__PURE__ */ s(function(Hi) {
          throw Hi;
        }, "e"), f: Ui };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var jo = !0, Wi = !1, ji;
    return { s: /* @__PURE__ */ s(function() {
      Vo = Vo.call(Ni);
    }, "s"), n: /* @__PURE__ */ s(function() {
      var Hi = Vo.next();
      return jo = Hi.done, Hi;
    }, "n"), e: /* @__PURE__ */ s(function(Hi) {
      Wi = !0, ji = Hi;
    }, "e"), f: /* @__PURE__ */ s(function() {
      try {
        !jo && Vo.return != null && Vo.return();
      } finally {
        if (Wi) throw ji;
      }
    }, "f") };
  }
  s(ui, "_createForOfIteratorHelper");
  function ai(Ni, Yi) {
    if (Ni) {
      if (typeof Ni == "string") return li(Ni, Yi);
      var Vo = Object.prototype.toString.call(Ni).slice(8, -1);
      if (Vo === "Object" && Ni.constructor && (Vo = Ni.constructor.name), Vo === "Map" || Vo === "Set") return Array.from(Ni);
      if (Vo === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Vo)) return li(Ni, Yi);
    }
  }
  s(ai, "_unsupportedIterableToArray");
  function li(Ni, Yi) {
    (Yi == null || Yi > Ni.length) && (Yi = Ni.length);
    for (var Vo = 0, No = new Array(Yi); Vo < Yi; Vo++)
      No[Vo] = Ni[Vo];
    return No;
  }
  s(li, "_arrayLikeToArray");
  var oi = xn(), si = {
    fg: "#FFF",
    bg: "#000",
    newline: !1,
    escapeXML: !1,
    stream: !1,
    colors: di()
  };
  function di() {
    var Ni = {
      0: "#000",
      1: "#A00",
      2: "#0A0",
      3: "#A50",
      4: "#00A",
      5: "#A0A",
      6: "#0AA",
      7: "#AAA",
      8: "#555",
      9: "#F55",
      10: "#5F5",
      11: "#FF5",
      12: "#55F",
      13: "#F5F",
      14: "#5FF",
      15: "#FFF"
    };
    return Pi(0, 5).forEach(function(Yi) {
      Pi(0, 5).forEach(function(Vo) {
        Pi(0, 5).forEach(function(No) {
          return fi(Yi, Vo, No, Ni);
        });
      });
    }), Pi(0, 23).forEach(function(Yi) {
      var Vo = Yi + 232, No = gi(Yi * 10 + 8);
      Ni[Vo] = "#" + No + No + No;
    }), Ni;
  }
  s(di, "getDefaultColors");
  function fi(Ni, Yi, Vo, No) {
    var Ui = 16 + Ni * 36 + Yi * 6 + Vo, jo = Ni > 0 ? Ni * 40 + 55 : 0, Wi = Yi > 0 ? Yi * 40 + 55 : 0, ji = Vo > 0 ? Vo * 40 + 55 : 0;
    No[Ui] = mi([jo, Wi, ji]);
  }
  s(fi, "setStyleColor");
  function gi(Ni) {
    for (var Yi = Ni.toString(16); Yi.length < 2; )
      Yi = "0" + Yi;
    return Yi;
  }
  s(gi, "toHexString");
  function mi(Ni) {
    var Yi = [], Vo = ui(Ni), No;
    try {
      for (Vo.s(); !(No = Vo.n()).done; ) {
        var Ui = No.value;
        Yi.push(gi(Ui));
      }
    } catch (jo) {
      Vo.e(jo);
    } finally {
      Vo.f();
    }
    return "#" + Yi.join("");
  }
  s(mi, "toColorHexString");
  function Ti(Ni, Yi, Vo, No) {
    var Ui;
    return Yi === "text" ? Ui = Di(Vo, No) : Yi === "display" ? Ui = xi(Ni, Vo, No) : Yi === "xterm256Foreground" ? Ui = io(Ni, No.colors[Vo]) : Yi === "xterm256Background" ? Ui = xo(Ni, No.colors[Vo]) : Yi === "rgb" && (Ui = vi(Ni, Vo)), Ui;
  }
  s(Ti, "generateOutput");
  function vi(Ni, Yi) {
    Yi = Yi.substring(2).slice(0, -1);
    var Vo = +Yi.substr(0, 2), No = Yi.substring(5).split(";"), Ui = No.map(function(jo) {
      return ("0" + Number(jo).toString(16)).substr(-2);
    }).join("");
    return Oo(Ni, (Vo === 38 ? "color:#" : "background-color:#") + Ui);
  }
  s(vi, "handleRgb");
  function xi(Ni, Yi, Vo) {
    Yi = parseInt(Yi, 10);
    var No = {
      "-1": /* @__PURE__ */ s(function() {
        return "<br/>";
      }, "_"),
      0: /* @__PURE__ */ s(function() {
        return Ni.length && Si(Ni);
      }, "_"),
      1: /* @__PURE__ */ s(function() {
        return Mi(Ni, "b");
      }, "_"),
      3: /* @__PURE__ */ s(function() {
        return Mi(Ni, "i");
      }, "_"),
      4: /* @__PURE__ */ s(function() {
        return Mi(Ni, "u");
      }, "_"),
      8: /* @__PURE__ */ s(function() {
        return Oo(Ni, "display:none");
      }, "_"),
      9: /* @__PURE__ */ s(function() {
        return Mi(Ni, "strike");
      }, "_"),
      22: /* @__PURE__ */ s(function() {
        return Oo(Ni, "font-weight:normal;text-decoration:none;font-style:normal");
      }, "_"),
      23: /* @__PURE__ */ s(function() {
        return fo(Ni, "i");
      }, "_"),
      24: /* @__PURE__ */ s(function() {
        return fo(Ni, "u");
      }, "_"),
      39: /* @__PURE__ */ s(function() {
        return io(Ni, Vo.fg);
      }, "_"),
      49: /* @__PURE__ */ s(function() {
        return xo(Ni, Vo.bg);
      }, "_"),
      53: /* @__PURE__ */ s(function() {
        return Oo(Ni, "text-decoration:overline");
      }, "_")
    }, Ui;
    return No[Yi] ? Ui = No[Yi]() : 4 < Yi && Yi < 7 ? Ui = Mi(Ni, "blink") : 29 < Yi && Yi < 38 ? Ui = io(Ni, Vo.colors[Yi - 30]) : 39 < Yi && Yi < 48 ? Ui = xo(Ni, Vo.colors[Yi - 40]) : 89 < Yi && Yi < 98 ? Ui = io(Ni, Vo.colors[8 + (Yi - 90)]) : 99 < Yi && Yi < 108 && (Ui = xo(Ni, Vo.colors[8 + (Yi - 100)])), Ui;
  }
  s(xi, "handleDisplay");
  function Si(Ni) {
    var Yi = Ni.slice(0);
    return Ni.length = 0, Yi.reverse().map(function(Vo) {
      return "</" + Vo + ">";
    }).join("");
  }
  s(Si, "resetStyles");
  function Pi(Ni, Yi) {
    for (var Vo = [], No = Ni; No <= Yi; No++)
      Vo.push(No);
    return Vo;
  }
  s(Pi, "range");
  function $i(Ni) {
    return function(Yi) {
      return (Ni === null || Yi.category !== Ni) && Ni !== "all";
    };
  }
  s($i, "notCategory");
  function Oi(Ni) {
    Ni = parseInt(Ni, 10);
    var Yi = null;
    return Ni === 0 ? Yi = "all" : Ni === 1 ? Yi = "bold" : 2 < Ni && Ni < 5 ? Yi = "underline" : 4 < Ni && Ni < 7 ? Yi = "blink" : Ni === 8 ? Yi = "hide" : Ni === 9 ? Yi = "strike" : 29 < Ni && Ni < 38 || Ni === 39 || 89 < Ni && Ni < 98 ? Yi = "foreground-color" : (39 < Ni && Ni < 48 || Ni === 49 || 99 < Ni && Ni < 108) && (Yi = "background-color"), Yi;
  }
  s(Oi, "categoryForCode");
  function Di(Ni, Yi) {
    return Yi.escapeXML ? oi.encodeXML(Ni) : Ni;
  }
  s(Di, "pushText");
  function Mi(Ni, Yi, Vo) {
    return Vo || (Vo = ""), Ni.push(Yi), "<".concat(Yi).concat(Vo ? ' style="'.concat(Vo, '"') : "", ">");
  }
  s(Mi, "pushTag");
  function Oo(Ni, Yi) {
    return Mi(Ni, "span", Yi);
  }
  s(Oo, "pushStyle");
  function io(Ni, Yi) {
    return Mi(Ni, "span", "color:" + Yi);
  }
  s(io, "pushForegroundColor");
  function xo(Ni, Yi) {
    return Mi(Ni, "span", "background-color:" + Yi);
  }
  s(xo, "pushBackgroundColor");
  function fo(Ni, Yi) {
    var Vo;
    if (Ni.slice(-1)[0] === Yi && (Vo = Ni.pop()), Vo)
      return "</" + Yi + ">";
  }
  s(fo, "closeTag");
  function _o(Ni, Yi, Vo) {
    var No = !1, Ui = 3;
    function jo() {
      return "";
    }
    s(jo, "remove");
    function Wi(ys, Ss) {
      return Vo("xterm256Foreground", Ss), "";
    }
    s(Wi, "removeXterm256Foreground");
    function ji(ys, Ss) {
      return Vo("xterm256Background", Ss), "";
    }
    s(ji, "removeXterm256Background");
    function Hi(ys) {
      return Yi.newline ? Vo("display", -1) : Vo("text", ys), "";
    }
    s(Hi, "newline");
    function zo(ys, Ss) {
      No = !0, Ss.trim().length === 0 && (Ss = "0"), Ss = Ss.trimRight(";").split(";");
      var Xa = ui(Ss), Es;
      try {
        for (Xa.s(); !(Es = Xa.n()).done; ) {
          var Rs = Es.value;
          Vo("display", Rs);
        }
      } catch (La) {
        Xa.e(La);
      } finally {
        Xa.f();
      }
      return "";
    }
    s(zo, "ansiMess");
    function Lo(ys) {
      return Vo("text", ys), "";
    }
    s(Lo, "realText");
    function sa(ys) {
      return Vo("rgb", ys), "";
    }
    s(sa, "rgb");
    var Ko = [{
      pattern: /^\x08+/,
      sub: jo
    }, {
      pattern: /^\x1b\[[012]?K/,
      sub: jo
    }, {
      pattern: /^\x1b\[\(B/,
      sub: jo
    }, {
      pattern: /^\x1b\[[34]8;2;\d+;\d+;\d+m/,
      sub: sa
    }, {
      pattern: /^\x1b\[38;5;(\d+)m/,
      sub: Wi
    }, {
      pattern: /^\x1b\[48;5;(\d+)m/,
      sub: ji
    }, {
      pattern: /^\n/,
      sub: Hi
    }, {
      pattern: /^\r+\n/,
      sub: Hi
    }, {
      pattern: /^\r/,
      sub: Hi
    }, {
      pattern: /^\x1b\[((?:\d{1,3};?)+|)m/,
      sub: zo
    }, {
      // CSI n J
      // ED - Erase in Display Clears part of the screen.
      // If n is 0 (or missing), clear from cursor to end of screen.
      // If n is 1, clear from cursor to beginning of the screen.
      // If n is 2, clear entire screen (and moves cursor to upper left on DOS ANSI.SYS).
      // If n is 3, clear entire screen and delete all lines saved in the scrollback buffer
      //   (this feature was added for xterm and is supported by other terminal applications).
      pattern: /^\x1b\[\d?J/,
      sub: jo
    }, {
      // CSI n ; m f
      // HVP - Horizontal Vertical Position Same as CUP
      pattern: /^\x1b\[\d{0,3};\d{0,3}f/,
      sub: jo
    }, {
      // catch-all for CSI sequences?
      pattern: /^\x1b\[?[\d;]{0,3}/,
      sub: jo
    }, {
      /**
       * extracts real text - not containing:
       * - `\x1b' - ESC - escape (Ascii 27)
       * - '\x08' - BS - backspace (Ascii 8)
       * - `\n` - Newline - linefeed (LF) (ascii 10)
       * - `\r` - Windows Carriage Return (CR)
       */
      pattern: /^(([^\x1b\x08\r\n])+)/,
      sub: Lo
    }];
    function ca(ys, Ss) {
      Ss > Ui && No || (No = !1, Ni = Ni.replace(ys.pattern, ys.sub));
    }
    s(ca, "process");
    var pa = [], ga = Ni, ia = ga.length;
    e: for (; ia > 0; ) {
      for (var ra = 0, qo = 0, xa = Ko.length; qo < xa; ra = ++qo) {
        var $a = Ko[ra];
        if (ca($a, ra), Ni.length !== ia) {
          ia = Ni.length;
          continue e;
        }
      }
      if (Ni.length === ia)
        break;
      pa.push(0), ia = Ni.length;
    }
    return pa;
  }
  s(_o, "tokenize");
  function Li(Ni, Yi, Vo) {
    return Yi !== "text" && (Ni = Ni.filter($i(Oi(Vo))), Ni.push({
      token: Yi,
      data: Vo,
      category: Oi(Vo)
    })), Ni;
  }
  s(Li, "updateStickyStack");
  var Co = /* @__PURE__ */ (function() {
    function Ni(Yi) {
      ir(this, Ni), Yi = Yi || {}, Yi.colors && (Yi.colors = Object.assign({}, si.colors, Yi.colors)), this.options = Object.assign({}, si, Yi), this.stack = [], this.stickyStack = [];
    }
    return s(Ni, "Filter"), ii(Ni, [{
      key: "toHtml",
      value: /* @__PURE__ */ s(function(Yi) {
        var Vo = this;
        Yi = typeof Yi == "string" ? [Yi] : Yi;
        var No = this.stack, Ui = this.options, jo = [];
        return this.stickyStack.forEach(function(Wi) {
          var ji = Ti(No, Wi.token, Wi.data, Ui);
          ji && jo.push(ji);
        }), _o(Yi.join(""), Ui, function(Wi, ji) {
          var Hi = Ti(No, Wi, ji, Ui);
          Hi && jo.push(Hi), Ui.stream && (Vo.stickyStack = Li(Vo.stickyStack, Wi, ji));
        }), No.length && jo.push(Si(No)), jo.join("");
      }, "toHtml")
    }]), Ni;
  })();
  yt.exports = Co;
}), I = (() => {
  let pt;
  return typeof window < "u" ? pt = window : typeof globalThis < "u" ? pt = globalThis : typeof global < "u" ? pt = global : typeof self < "u" ? pt = self : pt = {}, pt;
})();
function Tr() {
  let pt = {
    setHandler: /* @__PURE__ */ s(() => {
    }, "setHandler"),
    send: /* @__PURE__ */ s(() => {
    }, "send")
  };
  return new B({ transport: pt });
}
s(Tr, "mockChannel");
var xr = class {
  constructor() {
    this.getChannel = /* @__PURE__ */ s(() => {
      if (!this.channel) {
        let pt = Tr();
        return this.setChannel(pt), pt;
      }
      return this.channel;
    }, "getChannel"), this.ready = /* @__PURE__ */ s(() => this.promise, "ready"), this.hasChannel = /* @__PURE__ */ s(() => !!this.channel, "hasChannel"), this.setChannel = /* @__PURE__ */ s((pt) => {
      this.channel = pt, this.resolve();
    }, "setChannel"), this.promise = new Promise((pt) => {
      this.resolve = () => pt(this.getChannel());
    });
  }
};
s(xr, "AddonStore");
var Rr = xr, Er = "__STORYBOOK_ADDONS_PREVIEW";
function Xn() {
  return I[Er] || (I[Er] = new Rr()), I[Er];
}
s(Xn, "getAddonsStore");
var V = Xn();
function Jn(pt) {
  return pt;
}
s(Jn, "definePreview");
var Pr = class {
  constructor() {
    this.hookListsMap = void 0, this.mountedDecorators = void 0, this.prevMountedDecorators = void 0, this.currentHooks = void 0, this.nextHookIndex = void 0, this.currentPhase = void 0, this.currentEffects = void 0, this.prevEffects = void 0, this.currentDecoratorName = void 0, this.hasUpdates = void 0, this.currentContext = void 0, this.renderListener = /* @__PURE__ */ s((pt) => {
      var yt;
      pt === ((yt = this.currentContext) == null ? void 0 : yt.id) && (this.triggerEffects(), this.currentContext = null, this.removeRenderListeners());
    }, "renderListener"), this.init();
  }
  init() {
    this.hookListsMap = /* @__PURE__ */ new WeakMap(), this.mountedDecorators = /* @__PURE__ */ new Set(), this.prevMountedDecorators = /* @__PURE__ */ new Set(), this.currentHooks = [], this.nextHookIndex = 0, this.currentPhase = "NONE", this.currentEffects = [], this.prevEffects = [], this.currentDecoratorName = null, this.hasUpdates = !1, this.currentContext = null;
  }
  clean() {
    this.prevEffects.forEach((pt) => {
      pt.destroy && pt.destroy();
    }), this.init(), this.removeRenderListeners();
  }
  getNextHook() {
    let pt = this.currentHooks[this.nextHookIndex];
    return this.nextHookIndex += 1, pt;
  }
  triggerEffects() {
    this.prevEffects.forEach((pt) => {
      !this.currentEffects.includes(pt) && pt.destroy && pt.destroy();
    }), this.currentEffects.forEach((pt) => {
      this.prevEffects.includes(pt) || (pt.destroy = pt.create());
    }), this.prevEffects = this.currentEffects, this.currentEffects = [];
  }
  addRenderListeners() {
    this.removeRenderListeners(), V.getChannel().on(X$2, this.renderListener);
  }
  removeRenderListeners() {
    V.getChannel().removeListener(X$2, this.renderListener);
  }
};
s(Pr, "HooksContext");
var se = Pr;
function It(pt) {
  let yt = /* @__PURE__ */ s((...ir) => {
    let { hooks: ti } = typeof ir[0] == "function" ? ir[1] : ir[0], ii = ti.currentPhase, ui = ti.currentHooks, ai = ti.nextHookIndex, li = ti.currentDecoratorName;
    ti.currentDecoratorName = pt.name, ti.prevMountedDecorators.has(pt) ? (ti.currentPhase = "UPDATE", ti.currentHooks = ti.hookListsMap.get(pt) || []) : (ti.currentPhase = "MOUNT", ti.currentHooks = [], ti.hookListsMap.set(pt, ti.currentHooks), ti.prevMountedDecorators.add(pt)), ti.nextHookIndex = 0;
    let oi = I.STORYBOOK_HOOKS_CONTEXT;
    I.STORYBOOK_HOOKS_CONTEXT = ti;
    let si = pt(...ir);
    if (I.STORYBOOK_HOOKS_CONTEXT = oi, ti.currentPhase === "UPDATE" && ti.getNextHook() != null)
      throw new Error(
        "Rendered fewer hooks than expected. This may be caused by an accidental early return statement."
      );
    return ti.currentPhase = ii, ti.currentHooks = ui, ti.nextHookIndex = ai, ti.currentDecoratorName = li, si;
  }, "hookified");
  return yt.originalFn = pt, yt;
}
s(It, "hookify");
var wr = 0, ts = 25, vr = /* @__PURE__ */ s((pt) => (yt, ir) => {
  let ti = pt(
    It(yt),
    ir.map((ii) => It(ii))
  );
  return (ii) => {
    let { hooks: ui } = ii;
    ui.prevMountedDecorators ?? (ui.prevMountedDecorators = /* @__PURE__ */ new Set()), ui.mountedDecorators = /* @__PURE__ */ new Set([yt, ...ir]), ui.currentContext = ii, ui.hasUpdates = !1;
    let ai = ti(ii);
    for (wr = 1; ui.hasUpdates; )
      if (ui.hasUpdates = !1, ui.currentEffects = [], ai = ti(ii), wr += 1, wr > ts)
        throw new Error(
          "Too many re-renders. Storybook limits the number of renders to prevent an infinite loop."
        );
    return ui.addRenderListeners(), ai;
  };
}, "applyHooks"), os = /* @__PURE__ */ s((pt, yt) => pt.length === yt.length && pt.every((ir, ti) => ir === yt[ti]), "areDepsEqual"), Ar = /* @__PURE__ */ s(
  () => new Error("Storybook preview hooks can only be called inside decorators and story functions."),
  "invalidHooksError"
);
function Ot() {
  return I.STORYBOOK_HOOKS_CONTEXT || null;
}
s(Ot, "getHooksContextOrNull");
function Cr() {
  let pt = Ot();
  if (pt == null)
    throw Ar();
  return pt;
}
s(Cr, "getHooksContextOrThrow");
function ns(pt, yt, ir) {
  let ti = Cr();
  if (ti.currentPhase === "MOUNT") {
    ir != null && !Array.isArray(ir) && s$3.warn(
      `${pt} received a final argument that is not an array (instead, received ${ir}). When specified, the final argument must be an array.`
    );
    let ii = { name: pt, deps: ir };
    return ti.currentHooks.push(ii), yt(ii), ii;
  }
  if (ti.currentPhase === "UPDATE") {
    let ii = ti.getNextHook();
    if (ii == null)
      throw new Error("Rendered more hooks than during the previous render.");
    return ii.name !== pt && s$3.warn(
      `Storybook has detected a change in the order of Hooks${ti.currentDecoratorName ? ` called by ${ti.currentDecoratorName}` : ""}. This will lead to bugs and errors if not fixed.`
    ), ir != null && ii.deps == null && s$3.warn(
      `${pt} received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.`
    ), ir != null && ii.deps != null && ir.length !== ii.deps.length && s$3.warn(`The final argument passed to ${pt} changed size between renders. The order and size of this array must remain constant.
Previous: ${ii.deps}
Incoming: ${ir}`), (ir == null || ii.deps == null || !os(ir, ii.deps)) && (yt(ii), ii.deps = ir), ii;
  }
  throw Ar();
}
s(ns, "useHook");
function He(pt, yt, ir) {
  let { memoizedState: ti } = ns(
    pt,
    (ii) => {
      ii.memoizedState = yt();
    },
    ir
  );
  return ti;
}
s(He, "useMemoLike");
function ss(pt, yt) {
  return He("useMemo", pt, yt);
}
s(ss, "useMemo");
function Oe(pt, yt) {
  return He("useCallback", () => pt, yt);
}
s(Oe, "useCallback");
function Dt(pt, yt) {
  return He(pt, () => ({ current: yt }), []);
}
s(Dt, "useRefLike");
function is(pt) {
  return Dt("useRef", pt);
}
s(is, "useRef");
function as() {
  let pt = Ot();
  if (pt != null && pt.currentPhase !== "NONE")
    pt.hasUpdates = !0;
  else
    try {
      V.getChannel().emit(L$3);
    } catch {
      s$3.warn("State updates of Storybook preview hooks work only in browser");
    }
}
s(as, "triggerUpdate");
function kt(pt, yt) {
  let ir = Dt(
    pt,
    // @ts-expect-error S type should never be function, but there's no way to tell that to TypeScript
    typeof yt == "function" ? yt() : yt
  ), ti = /* @__PURE__ */ s((ii) => {
    ir.current = typeof ii == "function" ? ii(ir.current) : ii, as();
  }, "setState");
  return [ir.current, ti];
}
s(kt, "useStateLike");
function ls(pt) {
  return kt("useState", pt);
}
s(ls, "useState");
function cs(pt, yt, ir) {
  let ti = ir != null ? () => ir(yt) : yt, [ii, ui] = kt("useReducer", ti);
  return [ii, /* @__PURE__ */ s((ai) => ui((li) => pt(li, ai)), "dispatch")];
}
s(cs, "useReducer");
function jt(pt, yt) {
  let ir = Cr(), ti = He("useEffect", () => ({ create: pt }), yt);
  ir.currentEffects.includes(ti) || ir.currentEffects.push(ti);
}
s(jt, "useEffect");
function ds(pt, yt = []) {
  let ir = V.getChannel();
  return jt(() => (Object.entries(pt).forEach(([ti, ii]) => ir.on(ti, ii)), () => {
    Object.entries(pt).forEach(
      ([ti, ii]) => ir.removeListener(ti, ii)
    );
  }), [...Object.keys(pt), ...yt]), Oe(ir.emit.bind(ir), [ir]);
}
s(ds, "useChannel");
function We() {
  let { currentContext: pt } = Cr();
  if (pt == null)
    throw Ar();
  return pt;
}
s(We, "useStoryContext");
function ps(pt, yt) {
  let { parameters: ir } = We();
  if (pt)
    return ir[pt] ?? yt;
}
s(ps, "useParameter");
function us() {
  let pt = V.getChannel(), { id: yt, args: ir } = We(), ti = Oe(
    (ui) => pt.emit(z$2, { storyId: yt, updatedArgs: ui }),
    [pt, yt]
  ), ii = Oe(
    (ui) => pt.emit(W$3, { storyId: yt, argNames: ui }),
    [pt, yt]
  );
  return [ir, ti, ii];
}
s(us, "useArgs");
function fs() {
  let pt = V.getChannel(), { globals: yt } = We(), ir = Oe(
    (ti) => pt.emit(k$3, { globals: ti }),
    [pt]
  );
  return [yt, ir];
}
s(fs, "useGlobals");
function P(pt) {
  for (var yt = [], ir = 1; ir < arguments.length; ir++)
    yt[ir - 1] = arguments[ir];
  var ti = Array.from(typeof pt == "string" ? [pt] : pt);
  ti[ti.length - 1] = ti[ti.length - 1].replace(/\r?\n([\t ]*)$/, "");
  var ii = ti.reduce(function(li, oi) {
    var si = oi.match(/\n([\t ]+|(?!\s).)/g);
    return si ? li.concat(si.map(function(di) {
      var fi, gi;
      return (gi = (fi = di.match(/[\t ]/g)) === null || fi === void 0 ? void 0 : fi.length) !== null && gi !== void 0 ? gi : 0;
    })) : li;
  }, []);
  if (ii.length) {
    var ui = new RegExp(`
[	 ]{` + Math.min.apply(Math, ii) + "}", "g");
    ti = ti.map(function(li) {
      return li.replace(ui, `
`);
    });
  }
  ti[0] = ti[0].replace(/^\r?\n/, "");
  var ai = ti[0];
  return yt.forEach(function(li, oi) {
    var si = ai.match(/(?:^|\n)( *)$/), di = si ? si[1] : "", fi = li;
    typeof li == "string" && li.includes(`
`) && (fi = String(li).split(`
`).map(function(gi, mi) {
      return mi === 0 ? gi : "" + di + gi;
    }).join(`
`)), ai += fi + ti[oi + 1];
  }), ai;
}
s(P, "dedent");
var Lt = P, Fr = /* @__PURE__ */ new Map(), hs = "UNIVERSAL_STORE:", q = {
  PENDING: "PENDING",
  RESOLVED: "RESOLVED",
  REJECTED: "REJECTED"
}, T = class fc {
  constructor(yt, ir) {
    if (this.debugging = !1, this.listeners = /* @__PURE__ */ new Map([["*", /* @__PURE__ */ new Set()]]), this.getState = /* @__PURE__ */ s(() => (this.debug("getState", { state: this.state }), this.state), "getState"), this.subscribe = /* @__PURE__ */ s((ti, ii) => {
      let ui = typeof ti == "function", ai = ui ? "*" : ti, li = ui ? ti : ii;
      if (this.debug("subscribe", { eventType: ai, listener: li }), !li)
        throw new TypeError(
          `Missing first subscribe argument, or second if first is the event type, when subscribing to a UniversalStore with id '${this.id}'`
        );
      return this.listeners.has(ai) || this.listeners.set(ai, /* @__PURE__ */ new Set()), this.listeners.get(ai).add(li), () => {
        var oi;
        this.debug("unsubscribe", { eventType: ai, listener: li }), this.listeners.has(ai) && (this.listeners.get(ai).delete(li), ((oi = this.listeners.get(ai)) == null ? void 0 : oi.size) === 0 && this.listeners.delete(ai));
      };
    }, "subscribe"), this.send = /* @__PURE__ */ s((ti) => {
      if (this.debug("send", { event: ti }), this.status !== fc.Status.READY)
        throw new TypeError(
          P`Cannot send event before store is ready. You can get the current status with store.status,
        or await store.readyPromise to wait for the store to be ready before sending events.
        ${JSON.stringify(
            {
              event: ti,
              id: this.id,
              actor: this.actor,
              environment: this.environment
            },
            null,
            2
          )}`
        );
      this.emitToListeners(ti, { actor: this.actor }), this.emitToChannel(ti, { actor: this.actor });
    }, "send"), this.debugging = yt.debug ?? !1, !fc.isInternalConstructing)
      throw new TypeError(
        "UniversalStore is not constructable - use UniversalStore.create() instead"
      );
    if (fc.isInternalConstructing = !1, this.id = yt.id, this.actorId = Date.now().toString(36) + Math.random().toString(36).substring(2), this.actorType = yt.leader ? fc.ActorType.LEADER : fc.ActorType.FOLLOWER, this.state = yt.initialState, this.channelEventName = `${hs}${this.id}`, this.debug("constructor", {
      options: yt,
      environmentOverrides: ir,
      channelEventName: this.channelEventName
    }), this.actor.type === fc.ActorType.LEADER)
      this.syncing = {
        state: q.RESOLVED,
        promise: Promise.resolve()
      };
    else {
      let ti, ii, ui = new Promise((ai, li) => {
        ti = /* @__PURE__ */ s(() => {
          this.syncing.state === q.PENDING && (this.syncing.state = q.RESOLVED, ai());
        }, "syncingResolve"), ii = /* @__PURE__ */ s((oi) => {
          this.syncing.state === q.PENDING && (this.syncing.state = q.REJECTED, li(oi));
        }, "syncingReject");
      });
      this.syncing = {
        state: q.PENDING,
        promise: ui,
        resolve: ti,
        reject: ii
      };
    }
    this.getState = this.getState.bind(this), this.setState = this.setState.bind(this), this.subscribe = this.subscribe.bind(this), this.onStateChange = this.onStateChange.bind(this), this.send = this.send.bind(this), this.emitToChannel = this.emitToChannel.bind(this), this.prepareThis = this.prepareThis.bind(this), this.emitToListeners = this.emitToListeners.bind(this), this.handleChannelEvents = this.handleChannelEvents.bind(
      this
    ), this.debug = this.debug.bind(this), this.channel = (ir == null ? void 0 : ir.channel) ?? fc.preparation.channel, this.environment = (ir == null ? void 0 : ir.environment) ?? fc.preparation.environment, this.channel && this.environment ? this.prepareThis({ channel: this.channel, environment: this.environment }) : fc.preparation.promise.then(this.prepareThis);
  }
  static setupPreparationPromise() {
    let yt, ir, ti = new Promise(
      (ii, ui) => {
        yt = /* @__PURE__ */ s((ai) => {
          ii(ai);
        }, "resolveRef"), ir = /* @__PURE__ */ s((...ai) => {
          ui(ai);
        }, "rejectRef");
      }
    );
    fc.preparation = {
      resolve: yt,
      reject: ir,
      promise: ti
    };
  }
  /** The actor object representing the store instance with a unique ID and a type */
  get actor() {
    return Object.freeze({
      id: this.actorId,
      type: this.actorType,
      environment: this.environment ?? fc.Environment.UNKNOWN
    });
  }
  /**
   * The current state of the store, that signals both if the store is prepared by Storybook and
   * also - in the case of a follower - if the state has been synced with the leader's state.
   */
  get status() {
    var yt;
    if (!this.channel || !this.environment)
      return fc.Status.UNPREPARED;
    switch ((yt = this.syncing) == null ? void 0 : yt.state) {
      case q.PENDING:
      case void 0:
        return fc.Status.SYNCING;
      case q.REJECTED:
        return fc.Status.ERROR;
      case q.RESOLVED:
      default:
        return fc.Status.READY;
    }
  }
  /**
   * A promise that resolves when the store is fully ready. A leader will be ready when the store
   * has been prepared by Storybook, which is almost instantly.
   *
   * A follower will be ready when the state has been synced with the leader's state, within a few
   * hundred milliseconds.
   */
  untilReady() {
    var yt;
    return Promise.all([fc.preparation.promise, (yt = this.syncing) == null ? void 0 : yt.promise]);
  }
  /** Creates a new instance of UniversalStore */
  static create(yt) {
    if (!yt || typeof (yt == null ? void 0 : yt.id) != "string")
      throw new TypeError("id is required and must be a string, when creating a UniversalStore");
    yt.debug && console.debug(
      P`[UniversalStore]
        create`,
      { options: yt }
    );
    let ir = Fr.get(yt.id);
    if (ir)
      return console.warn(P`UniversalStore with id "${yt.id}" already exists in this environment, re-using existing.
        You should reuse the existing instance instead of trying to create a new one.`), ir;
    fc.isInternalConstructing = !0;
    let ti = new fc(yt);
    return Fr.set(yt.id, ti), ti;
  }
  /**
   * Used by Storybook to set the channel for all instances of UniversalStore in the given
   * environment.
   *
   * @internal
   */
  static __prepare(yt, ir) {
    fc.preparation.channel = yt, fc.preparation.environment = ir, fc.preparation.resolve({ channel: yt, environment: ir });
  }
  /**
   * Updates the store's state
   *
   * Either a new state or a state updater function can be passed to the method.
   */
  setState(yt) {
    let ir = this.state, ti = typeof yt == "function" ? yt(ir) : yt;
    if (this.debug("setState", { newState: ti, previousState: ir, updater: yt }), this.status !== fc.Status.READY)
      throw new TypeError(
        P`Cannot set state before store is ready. You can get the current status with store.status,
        or await store.readyPromise to wait for the store to be ready before sending events.
        ${JSON.stringify(
          {
            newState: ti,
            id: this.id,
            actor: this.actor,
            environment: this.environment
          },
          null,
          2
        )}`
      );
    this.state = ti;
    let ii = {
      type: fc.InternalEventType.SET_STATE,
      payload: {
        state: ti,
        previousState: ir
      }
    };
    this.emitToChannel(ii, { actor: this.actor }), this.emitToListeners(ii, { actor: this.actor });
  }
  /**
   * Subscribes to state changes
   *
   * @returns Unsubscribe function
   */
  onStateChange(yt) {
    return this.debug("onStateChange", { listener: yt }), this.subscribe(
      fc.InternalEventType.SET_STATE,
      ({ payload: ir }, ti) => {
        yt(ir.state, ir.previousState, ti);
      }
    );
  }
  emitToChannel(yt, ir) {
    var ti;
    this.debug("emitToChannel", { event: yt, eventInfo: ir, channel: this.channel }), (ti = this.channel) == null || ti.emit(this.channelEventName, {
      event: yt,
      eventInfo: ir
    });
  }
  prepareThis({
    channel: yt,
    environment: ir
  }) {
    this.channel = yt, this.environment = ir, this.debug("prepared", { channel: yt, environment: ir }), this.channel.on(this.channelEventName, this.handleChannelEvents), this.actor.type === fc.ActorType.LEADER ? this.emitToChannel(
      { type: fc.InternalEventType.LEADER_CREATED },
      { actor: this.actor }
    ) : (this.emitToChannel(
      { type: fc.InternalEventType.FOLLOWER_CREATED },
      { actor: this.actor }
    ), this.emitToChannel(
      { type: fc.InternalEventType.EXISTING_STATE_REQUEST },
      { actor: this.actor }
    ), setTimeout(() => {
      this.syncing.reject(
        new TypeError(
          `No existing state found for follower with id: '${this.id}'. Make sure a leader with the same id exists before creating a follower.`
        )
      );
    }, 1e3));
  }
  emitToListeners(yt, ir) {
    let ti = this.listeners.get(yt.type), ii = this.listeners.get("*");
    this.debug("emitToListeners", {
      event: yt,
      eventInfo: ir,
      eventTypeListeners: ti,
      everythingListeners: ii
    }), [...ti ?? [], ...ii ?? []].forEach(
      (ui) => ui(yt, ir)
    );
  }
  handleChannelEvents(yt) {
    var ir, ti, ii, ui, ai;
    let { event: li, eventInfo: oi } = yt;
    if ([oi.actor.id, (ir = oi.forwardingActor) == null ? void 0 : ir.id].includes(this.actor.id)) {
      this.debug("handleChannelEvents: Ignoring event from self", { channelEvent: yt });
      return;
    } else if (((ti = this.syncing) == null ? void 0 : ti.state) === q.PENDING && li.type !== fc.InternalEventType.EXISTING_STATE_RESPONSE) {
      this.debug("handleChannelEvents: Ignoring event while syncing", { channelEvent: yt });
      return;
    }
    if (this.debug("handleChannelEvents", { channelEvent: yt }), this.actor.type === fc.ActorType.LEADER) {
      let si = !0;
      switch (li.type) {
        case fc.InternalEventType.EXISTING_STATE_REQUEST:
          si = !1;
          let di = {
            type: fc.InternalEventType.EXISTING_STATE_RESPONSE,
            payload: this.state
          };
          this.debug("handleChannelEvents: responding to existing state request", {
            responseEvent: di
          }), this.emitToChannel(di, { actor: this.actor });
          break;
        case fc.InternalEventType.LEADER_CREATED:
          si = !1, this.syncing.state = q.REJECTED, this.debug("handleChannelEvents: erroring due to second leader being created", {
            event: li
          }), console.error(
            P`Detected multiple UniversalStore leaders created with the same id "${this.id}".
            Only one leader can exists at a time, your stores are now in an invalid state.
            Leaders detected:
            this: ${JSON.stringify(this.actor, null, 2)}
            other: ${JSON.stringify(oi.actor, null, 2)}`
          );
          break;
      }
      si && (this.debug("handleChannelEvents: forwarding event", { channelEvent: yt }), this.emitToChannel(li, { actor: oi.actor, forwardingActor: this.actor }));
    }
    if (this.actor.type === fc.ActorType.FOLLOWER)
      switch (li.type) {
        case fc.InternalEventType.EXISTING_STATE_RESPONSE:
          if (this.debug("handleChannelEvents: Setting state from leader's existing state response", {
            event: li
          }), ((ii = this.syncing) == null ? void 0 : ii.state) !== q.PENDING)
            break;
          (ai = (ui = this.syncing).resolve) == null || ai.call(ui);
          let si = {
            type: fc.InternalEventType.SET_STATE,
            payload: {
              state: li.payload,
              previousState: this.state
            }
          };
          this.state = li.payload, this.emitToListeners(si, oi);
          break;
      }
    switch (li.type) {
      case fc.InternalEventType.SET_STATE:
        this.debug("handleChannelEvents: Setting state", { event: li }), this.state = li.payload.state;
        break;
    }
    this.emitToListeners(li, { actor: oi.actor });
  }
  debug(yt, ir) {
    this.debugging && console.debug(
      P`[UniversalStore::${this.id}::${this.environment ?? fc.Environment.UNKNOWN}]
        ${yt}`,
      JSON.stringify(
        {
          data: ir,
          actor: this.actor,
          state: this.state,
          status: this.status
        },
        null,
        2
      )
    );
  }
  /**
   * Used to reset the static fields of the UniversalStore class when cleaning up tests
   *
   * @internal
   */
  static __reset() {
    fc.preparation.reject(new Error("reset")), fc.setupPreparationPromise(), fc.isInternalConstructing = !1;
  }
};
s(T, "UniversalStore"), /**
* Defines the possible actor types in the store system
*
* @readonly
*/
T.ActorType = {
  LEADER: "LEADER",
  FOLLOWER: "FOLLOWER"
}, /**
* Defines the possible environments the store can run in
*
* @readonly
*/
T.Environment = {
  SERVER: "SERVER",
  MANAGER: "MANAGER",
  PREVIEW: "PREVIEW",
  UNKNOWN: "UNKNOWN",
  MOCK: "MOCK"
}, /**
* Internal event types used for store synchronization
*
* @readonly
*/
T.InternalEventType = {
  EXISTING_STATE_REQUEST: "__EXISTING_STATE_REQUEST",
  EXISTING_STATE_RESPONSE: "__EXISTING_STATE_RESPONSE",
  SET_STATE: "__SET_STATE",
  LEADER_CREATED: "__LEADER_CREATED",
  FOLLOWER_CREATED: "__FOLLOWER_CREATED"
}, T.Status = {
  UNPREPARED: "UNPREPARED",
  SYNCING: "SYNCING",
  READY: "READY",
  ERROR: "ERROR"
}, // This is used to check if constructor was called from the static factory create()
T.isInternalConstructing = !1, T.setupPreparationPromise();
var J = T;
function Ir(pt, yt) {
  let ir = {}, ti = Object.entries(pt);
  for (let ii = 0; ii < ti.length; ii++) {
    let [ui, ai] = ti[ii];
    yt(ai, ui) || (ir[ui] = ai);
  }
  return ir;
}
s(Ir, "omitBy");
function Or(pt, yt) {
  let ir = {};
  for (let ti = 0; ti < yt.length; ti++) {
    let ii = yt[ti];
    Object.prototype.hasOwnProperty.call(pt, ii) && (ir[ii] = pt[ii]);
  }
  return ir;
}
s(Or, "pick");
function Dr(pt, yt) {
  let ir = {}, ti = Object.entries(pt);
  for (let ii = 0; ii < ti.length; ii++) {
    let [ui, ai] = ti[ii];
    yt(ai, ui) && (ir[ui] = ai);
  }
  return ir;
}
s(Dr, "pickBy");
function L(pt) {
  if (typeof pt != "object" || pt == null)
    return !1;
  if (Object.getPrototypeOf(pt) === null)
    return !0;
  if (pt.toString() !== "[object Object]")
    return !1;
  let yt = pt;
  for (; Object.getPrototypeOf(yt) !== null; )
    yt = Object.getPrototypeOf(yt);
  return Object.getPrototypeOf(pt) === yt;
}
s(L, "isPlainObject");
function G(pt, yt) {
  let ir = {}, ti = Object.keys(pt);
  for (let ii = 0; ii < ti.length; ii++) {
    let ui = ti[ii], ai = pt[ui];
    ir[ui] = yt(ai, ui, pt);
  }
  return ir;
}
s(G, "mapValues");
var Nt = "[object RegExp]", Mt = "[object String]", _t = "[object Number]", qt = "[object Boolean]", kr = "[object Arguments]", Ut = "[object Symbol]", Gt = "[object Date]", Bt = "[object Map]", zt = "[object Set]", Vt = "[object Array]", Ht = "[object Function]", Wt = "[object ArrayBuffer]", $e = "[object Object]", $t = "[object Error]", Yt = "[object DataView]", Kt = "[object Uint8Array]", Xt = "[object Uint8ClampedArray]", Jt = "[object Uint16Array]", Qt = "[object Uint32Array]", Zt = "[object BigUint64Array]", eo = "[object Int8Array]", ro = "[object Int16Array]", to = "[object Int32Array]", oo = "[object BigInt64Array]", no = "[object Float32Array]", so = "[object Float64Array]";
function jr(pt) {
  return Object.getOwnPropertySymbols(pt).filter((yt) => Object.prototype.propertyIsEnumerable.call(pt, yt));
}
s(jr, "getSymbols");
function Lr(pt) {
  return pt == null ? pt === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(pt);
}
s(Lr, "getTag");
function De(pt, yt) {
  if (typeof pt == typeof yt)
    switch (typeof pt) {
      case "bigint":
      case "string":
      case "boolean":
      case "symbol":
      case "undefined":
        return pt === yt;
      case "number":
        return pt === yt || Object.is(pt, yt);
      case "function":
        return pt === yt;
      case "object":
        return Y(pt, yt);
    }
  return Y(pt, yt);
}
s(De, "isEqual");
function Y(pt, yt, ir) {
  if (Object.is(pt, yt))
    return !0;
  let ti = Lr(pt), ii = Lr(yt);
  if (ti === kr && (ti = $e), ii === kr && (ii = $e), ti !== ii)
    return !1;
  switch (ti) {
    case Mt:
      return pt.toString() === yt.toString();
    case _t: {
      let li = pt.valueOf(), oi = yt.valueOf();
      return li === oi || Number.isNaN(li) && Number.isNaN(oi);
    }
    case qt:
    case Gt:
    case Ut:
      return Object.is(pt.valueOf(), yt.valueOf());
    case Nt:
      return pt.source === yt.source && pt.flags === yt.flags;
    case Ht:
      return pt === yt;
  }
  ir = ir ?? /* @__PURE__ */ new Map();
  let ui = ir.get(pt), ai = ir.get(yt);
  if (ui != null && ai != null)
    return ui === yt;
  ir.set(pt, yt), ir.set(yt, pt);
  try {
    switch (ti) {
      case Bt: {
        if (pt.size !== yt.size)
          return !1;
        for (let [li, oi] of pt.entries())
          if (!yt.has(li) || !Y(oi, yt.get(li), ir))
            return !1;
        return !0;
      }
      case zt: {
        if (pt.size !== yt.size)
          return !1;
        let li = Array.from(pt.values()), oi = Array.from(yt.values());
        for (let si = 0; si < li.length; si++) {
          let di = li[si], fi = oi.findIndex((gi) => Y(di, gi, ir));
          if (fi === -1)
            return !1;
          oi.splice(fi, 1);
        }
        return !0;
      }
      case Vt:
      case Kt:
      case Xt:
      case Jt:
      case Qt:
      case Zt:
      case eo:
      case ro:
      case to:
      case oo:
      case no:
      case so: {
        if (typeof Buffer < "u" && Buffer.isBuffer(pt) !== Buffer.isBuffer(yt) || pt.length !== yt.length)
          return !1;
        for (let li = 0; li < pt.length; li++)
          if (!Y(pt[li], yt[li], ir))
            return !1;
        return !0;
      }
      case Wt:
        return pt.byteLength !== yt.byteLength ? !1 : Y(new Uint8Array(pt), new Uint8Array(yt), ir);
      case Yt:
        return pt.byteLength !== yt.byteLength || pt.byteOffset !== yt.byteOffset ? !1 : Y(pt.buffer, yt.buffer, ir);
      case $t:
        return pt.name === yt.name && pt.message === yt.message;
      case $e: {
        if (!(Y(pt.constructor, yt.constructor, ir) || L(pt) && L(yt)))
          return !1;
        let li = [...Object.keys(pt), ...jr(pt)], oi = [...Object.keys(yt), ...jr(yt)];
        if (li.length !== oi.length)
          return !1;
        for (let si = 0; si < li.length; si++) {
          let di = li[si], fi = pt[di];
          if (!Object.prototype.hasOwnProperty.call(yt, di))
            return !1;
          let gi = yt[di];
          if (!Y(fi, gi, ir))
            return !1;
        }
        return !0;
      }
      default:
        return !1;
    }
  } finally {
    ir.delete(pt), ir.delete(yt);
  }
}
s(Y, "areObjectsEqual");
var Ye = class lb extends J {
  constructor(yt, ir) {
    J.isInternalConstructing = !0, super(
      { ...yt, leader: !0 },
      { channel: new B({}), environment: J.Environment.MOCK }
    ), J.isInternalConstructing = !1, typeof (ir == null ? void 0 : ir.fn) == "function" && (this.testUtils = ir, this.getState = ir.fn(this.getState), this.setState = ir.fn(this.setState), this.subscribe = ir.fn(this.subscribe), this.onStateChange = ir.fn(this.onStateChange), this.send = ir.fn(this.send));
  }
  /** Create a mock universal store. This is just an alias for the constructor */
  static create(yt, ir) {
    return new lb(yt, ir);
  }
  unsubscribeAll() {
    var yt, ir;
    if (!this.testUtils)
      throw new Error(
        Lt`Cannot call unsubscribeAll on a store that does not have testUtils.
        Please provide testUtils as the second argument when creating the store.`
      );
    let ti = /* @__PURE__ */ s((ii) => {
      try {
        ii.value();
      } catch {
      }
    }, "callReturnedUnsubscribeFn");
    (yt = this.subscribe.mock) == null || yt.results.forEach(ti), (ir = this.onStateChange.mock) == null || ir.results.forEach(ti);
  }
};
s(Ye, "MockUniversalStore");
var tr = he(_r()), me = Symbol("incompatible"), Ur = /* @__PURE__ */ s((pt, yt) => {
  let ir = yt.type;
  if (pt == null || !ir || yt.mapping)
    return pt;
  switch (ir.name) {
    case "string":
      return String(pt);
    case "enum":
      return pt;
    case "number":
      return Number(pt);
    case "boolean":
      return String(pt) === "true";
    case "array":
      return !ir.value || !Array.isArray(pt) ? me : pt.reduce((ti, ii, ui) => {
        let ai = Ur(ii, { type: ir.value });
        return ai !== me && (ti[ui] = ai), ti;
      }, new Array(pt.length));
    case "object":
      return typeof pt == "string" || typeof pt == "number" ? pt : !ir.value || typeof pt != "object" ? me : Object.entries(pt).reduce((ti, [ii, ui]) => {
        let ai = Ur(ui, { type: ir.value[ii] });
        return ai === me ? ti : Object.assign(ti, { [ii]: ai });
      }, {});
    default:
      return me;
  }
}, "map"), ao = /* @__PURE__ */ s((pt, yt) => Object.entries(pt).reduce((ir, [ti, ii]) => {
  if (!yt[ti])
    return ir;
  let ui = Ur(ii, yt[ti]);
  return ui === me ? ir : Object.assign(ir, { [ti]: ui });
}, {}), "mapArgsToTypes"), ke = /* @__PURE__ */ s((pt, yt) => Array.isArray(pt) && Array.isArray(yt) ? yt.reduce(
  (ir, ti, ii) => (ir[ii] = ke(pt[ii], yt[ii]), ir),
  [...pt]
).filter((ir) => ir !== void 0) : !L(pt) || !L(yt) ? yt : Object.keys({ ...pt, ...yt }).reduce((ir, ti) => {
  if (ti in yt) {
    let ii = ke(pt[ti], yt[ti]);
    ii !== void 0 && (ir[ti] = ii);
  } else
    ir[ti] = pt[ti];
  return ir;
}, {}), "combineArgs"), lo = /* @__PURE__ */ s((pt, yt) => Object.entries(yt).reduce((ir, [ti, { options: ii }]) => {
  function ui() {
    return ti in pt && (ir[ti] = pt[ti]), ir;
  }
  if (s(ui, "allowArg"), !ii)
    return ui();
  if (!Array.isArray(ii))
    return n$1.error(P`
        Invalid argType: '${ti}.options' should be an array.

        More info: https://storybook.js.org/docs/api/arg-types
      `), ui();
  if (ii.some((fi) => fi && ["object", "function"].includes(typeof fi)))
    return n$1.error(P`
        Invalid argType: '${ti}.options' should only contain primitives. Use a 'mapping' for complex values.

        More info: https://storybook.js.org/docs/writing-stories/args#mapping-to-complex-arg-values
      `), ui();
  let ai = Array.isArray(pt[ti]), li = ai && pt[ti].findIndex((fi) => !ii.includes(fi)), oi = ai && li === -1;
  if (pt[ti] === void 0 || ii.includes(pt[ti]) || oi)
    return ui();
  let si = ai ? `${ti}[${li}]` : ti, di = ii.map((fi) => typeof fi == "string" ? `'${fi}'` : String(fi)).join(", ");
  return n$1.warn(`Received illegal value for '${si}'. Supported options: ${di}`), ir;
}, {}), "validateOptions"), ie = Symbol("Deeply equal"), ge = /* @__PURE__ */ s((pt, yt) => {
  if (typeof pt != typeof yt)
    return yt;
  if (De(pt, yt))
    return ie;
  if (Array.isArray(pt) && Array.isArray(yt)) {
    let ir = yt.reduce((ti, ii, ui) => {
      let ai = ge(pt[ui], ii);
      return ai !== ie && (ti[ui] = ai), ti;
    }, new Array(yt.length));
    return yt.length >= pt.length ? ir : ir.concat(new Array(pt.length - yt.length).fill(void 0));
  }
  return L(pt) && L(yt) ? Object.keys({ ...pt, ...yt }).reduce((ir, ti) => {
    let ii = ge(pt == null ? void 0 : pt[ti], yt == null ? void 0 : yt[ti]);
    return ii === ie ? ir : Object.assign(ir, { [ti]: ii });
  }, {}) : yt;
}, "deepDiff"), Gr = "UNTARGETED";
function co({
  args: pt,
  argTypes: yt
}) {
  let ir = {};
  return Object.entries(pt).forEach(([ti, ii]) => {
    let { target: ui = Gr } = yt[ti] || {};
    ir[ui] = ir[ui] || {}, ir[ui][ti] = ii;
  }), ir;
}
s(co, "groupArgsByTarget");
function Ts(pt) {
  return Object.keys(pt).forEach((yt) => pt[yt] === void 0 && delete pt[yt]), pt;
}
s(Ts, "deleteUndefined");
var Br = class {
  constructor() {
    this.initialArgsByStoryId = {}, this.argsByStoryId = {};
  }
  get(pt) {
    if (!(pt in this.argsByStoryId))
      throw new Error(`No args known for ${pt} -- has it been rendered yet?`);
    return this.argsByStoryId[pt];
  }
  setInitial(pt) {
    if (!this.initialArgsByStoryId[pt.id])
      this.initialArgsByStoryId[pt.id] = pt.initialArgs, this.argsByStoryId[pt.id] = pt.initialArgs;
    else if (this.initialArgsByStoryId[pt.id] !== pt.initialArgs) {
      let yt = ge(this.initialArgsByStoryId[pt.id], this.argsByStoryId[pt.id]);
      this.initialArgsByStoryId[pt.id] = pt.initialArgs, this.argsByStoryId[pt.id] = pt.initialArgs, yt !== ie && this.updateFromDelta(pt, yt);
    }
  }
  updateFromDelta(pt, yt) {
    let ir = lo(yt, pt.argTypes);
    this.argsByStoryId[pt.id] = ke(this.argsByStoryId[pt.id], ir);
  }
  updateFromPersisted(pt, yt) {
    let ir = ao(yt, pt.argTypes);
    return this.updateFromDelta(pt, ir);
  }
  update(pt, yt) {
    if (!(pt in this.argsByStoryId))
      throw new Error(`No args known for ${pt} -- has it been rendered yet?`);
    this.argsByStoryId[pt] = Ts({
      ...this.argsByStoryId[pt],
      ...yt
    });
  }
};
s(Br, "ArgsStore");
var Ke = Br, Xe = /* @__PURE__ */ s((pt = {}) => Object.entries(pt).reduce((yt, [ir, { defaultValue: ti }]) => (typeof ti < "u" && (yt[ir] = ti), yt), {}), "getValuesFromArgTypes"), zr = class {
  constructor({
    globals: pt = {},
    globalTypes: yt = {}
  }) {
    this.set({ globals: pt, globalTypes: yt });
  }
  set({ globals: pt = {}, globalTypes: yt = {} }) {
    let ir = this.initialGlobals && ge(this.initialGlobals, this.globals);
    this.allowedGlobalNames = /* @__PURE__ */ new Set([...Object.keys(pt), ...Object.keys(yt)]);
    let ti = Xe(yt);
    this.initialGlobals = { ...ti, ...pt }, this.globals = this.initialGlobals, ir && ir !== ie && this.updateFromPersisted(ir);
  }
  filterAllowedGlobals(pt) {
    return Object.entries(pt).reduce((yt, [ir, ti]) => (this.allowedGlobalNames.has(ir) ? yt[ir] = ti : s$3.warn(
      `Attempted to set a global (${ir}) that is not defined in initial globals or globalTypes`
    ), yt), {});
  }
  updateFromPersisted(pt) {
    let yt = this.filterAllowedGlobals(pt);
    this.globals = { ...this.globals, ...yt };
  }
  get() {
    return this.globals;
  }
  update(pt) {
    this.globals = { ...this.globals, ...this.filterAllowedGlobals(pt) };
  }
};
s(zr, "GlobalsStore");
var Je = zr, po = he(_r()), xs = (0, po.default)(1)(
  (pt) => Object.values(pt).reduce(
    (yt, ir) => (yt[ir.importPath] = yt[ir.importPath] || ir, yt),
    {}
  )
), Vr = class {
  constructor({ entries: pt } = { v: 5, entries: {} }) {
    this.entries = pt;
  }
  entryFromSpecifier(pt) {
    let yt = Object.values(this.entries);
    if (pt === "*")
      return yt[0];
    if (typeof pt == "string")
      return this.entries[pt] ? this.entries[pt] : yt.find((ii) => ii.id.startsWith(pt));
    let { name: ir, title: ti } = pt;
    return yt.find((ii) => ii.name === ir && ii.title === ti);
  }
  storyIdToEntry(pt) {
    let yt = this.entries[pt];
    if (!yt)
      throw new D$1({ storyId: pt });
    return yt;
  }
  importPathToEntry(pt) {
    return xs(this.entries)[pt];
  }
};
s(Vr, "StoryIndexStore");
var Qe = Vr, ws = /* @__PURE__ */ s((pt) => typeof pt == "string" ? { name: pt } : pt, "normalizeType"), vs = /* @__PURE__ */ s((pt) => typeof pt == "string" ? { type: pt } : pt, "normalizeControl"), As = /* @__PURE__ */ s((pt, yt) => {
  let { type: ir, control: ti, ...ii } = pt, ui = {
    name: yt,
    ...ii
  };
  return ir && (ui.type = ws(ir)), ti ? ui.control = vs(ti) : ti === !1 && (ui.control = { disable: !0 }), ui;
}, "normalizeInputType"), ae = /* @__PURE__ */ s((pt) => G(pt, As), "normalizeInputTypes"), F = /* @__PURE__ */ s((pt) => Array.isArray(pt) ? pt : pt ? [pt] : [], "normalizeArrays"), Os = P`
CSF .story annotations deprecated; annotate story functions directly:
- StoryFn.story.name => StoryFn.storyName
- StoryFn.story.(parameters|decorators) => StoryFn.(parameters|decorators)
See https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#hoisted-csf-annotations for details and codemod.
`;
function Se(pt, yt, ir) {
  let ti = yt, ii = typeof yt == "function" ? yt : null, { story: ui } = ti;
  ui && (s$3.debug("deprecated story", ui), m$1(Os));
  let ai = re$1(pt), li = typeof ti != "function" && ti.name || ti.storyName || (ui == null ? void 0 : ui.name) || ai, oi = [
    ...F(ti.decorators),
    ...F(ui == null ? void 0 : ui.decorators)
  ], si = { ...ui == null ? void 0 : ui.parameters, ...ti.parameters }, di = { ...ui == null ? void 0 : ui.args, ...ti.args }, fi = { ...ui == null ? void 0 : ui.argTypes, ...ti.argTypes }, gi = [...F(ti.loaders), ...F(
    ui == null ? void 0 : ui.loaders
  )], mi = [
    ...F(ti.beforeEach),
    ...F(ui == null ? void 0 : ui.beforeEach)
  ], Ti = [
    ...F(ti.experimental_afterEach),
    ...F(ui == null ? void 0 : ui.experimental_afterEach)
  ], { render: vi, play: xi, tags: Si = [], globals: Pi = {} } = ti, $i = si.__id || ee$1(ir.id, ai);
  return {
    moduleExport: yt,
    id: $i,
    name: li,
    tags: Si,
    decorators: oi,
    parameters: si,
    args: di,
    argTypes: ae(fi),
    loaders: gi,
    beforeEach: mi,
    experimental_afterEach: Ti,
    globals: Pi,
    ...vi && { render: vi },
    ...ii && { userStoryFn: ii },
    ...xi && { play: xi }
  };
}
s(Se, "normalizeStory");
function je(pt, yt = pt.title, ir) {
  let { id: ti, argTypes: ii } = pt;
  return {
    id: D(ti || yt),
    ...pt,
    title: yt,
    ...ii && { argTypes: ae(ii) },
    parameters: {
      fileName: ir,
      ...pt.parameters
    }
  };
}
s(je, "normalizeComponentAnnotations");
var js = /* @__PURE__ */ s((pt) => {
  let { globals: yt, globalTypes: ir } = pt;
  (yt || ir) && s$3.error(
    "Global args/argTypes can only be set globally",
    JSON.stringify({
      globals: yt,
      globalTypes: ir
    })
  );
}, "checkGlobals"), Ls = /* @__PURE__ */ s((pt) => {
  let { options: yt } = pt;
  yt != null && yt.storySort && s$3.error("The storySort option parameter can only be set globally");
}, "checkStorySort"), Ze = /* @__PURE__ */ s((pt) => {
  pt && (js(pt), Ls(pt));
}, "checkDisallowedParameters");
function yo(pt, yt, ir) {
  let { default: ti, __namedExportsOrder: ii, ...ui } = pt, ai = Object.values(ui)[0];
  if (K(ai)) {
    let si = je(ai.meta.input, ir, yt);
    Ze(si.parameters);
    let di = { meta: si, stories: {}, moduleExports: pt };
    return Object.keys(ui).forEach((fi) => {
      if (te$1(fi, si)) {
        let gi = Se(fi, ui[fi].input, si);
        Ze(gi.parameters), di.stories[gi.id] = gi;
      }
    }), di.projectAnnotations = ai.meta.preview.composed, di;
  }
  let li = je(
    ti,
    ir,
    yt
  );
  Ze(li.parameters);
  let oi = { meta: li, stories: {}, moduleExports: pt };
  return Object.keys(ui).forEach((si) => {
    if (te$1(si, li)) {
      let di = Se(si, ui[si], li);
      Ze(di.parameters), oi.stories[di.id] = di;
    }
  }), oi;
}
s(yo, "processCSFFile");
function mo(pt) {
  return pt != null && Ns(pt).includes("mount");
}
s(mo, "mountDestructured");
function Ns(pt) {
  let yt = pt.toString().match(/[^(]*\(([^)]*)/);
  if (!yt)
    return [];
  let ir = ho(yt[1]);
  if (!ir.length)
    return [];
  let ti = ir[0];
  return ti.startsWith("{") && ti.endsWith("}") ? ho(ti.slice(1, -1).replace(/\s/g, "")).map((ii) => ii.replace(/:.*|=.*/g, "")) : [];
}
s(Ns, "getUsedProps");
function ho(pt) {
  let yt = [], ir = [], ti = 0;
  for (let ui = 0; ui < pt.length; ui++)
    if (pt[ui] === "{" || pt[ui] === "[")
      ir.push(pt[ui] === "{" ? "}" : "]");
    else if (pt[ui] === ir[ir.length - 1])
      ir.pop();
    else if (!ir.length && pt[ui] === ",") {
      let ai = pt.substring(ti, ui).trim();
      ai && yt.push(ai), ti = ui + 1;
    }
  let ii = pt.substring(ti).trim();
  return ii && yt.push(ii), yt;
}
s(ho, "splitByComma");
function go(pt, yt, ir) {
  let ti = ir(pt);
  return (ii) => yt(ti, ii);
}
s(go, "decorateStory");
function So({
  componentId: pt,
  title: yt,
  kind: ir,
  id: ti,
  name: ii,
  story: ui,
  parameters: ai,
  initialArgs: li,
  argTypes: oi,
  ...si
} = {}) {
  return si;
}
s(So, "sanitizeStoryContextUpdate");
function Hr(pt, yt) {
  let ir = {}, ti = /* @__PURE__ */ s((ui) => (ai) => {
    if (!ir.value)
      throw new Error("Decorated function called without init");
    return ir.value = {
      ...ir.value,
      ...So(ai)
    }, ui(ir.value);
  }, "bindWithContext"), ii = yt.reduce(
    (ui, ai) => go(ui, ai, ti),
    pt
  );
  return (ui) => (ir.value = ui, ii(ui));
}
s(Hr, "defaultDecorateStory");
var M = /* @__PURE__ */ s((...pt) => {
  let yt = {}, ir = pt.filter(Boolean), ti = ir.reduce((ii, ui) => (Object.entries(ui).forEach(([ai, li]) => {
    let oi = ii[ai];
    Array.isArray(li) || typeof oi > "u" ? ii[ai] = li : L(li) && L(oi) ? yt[ai] = !0 : typeof li < "u" && (ii[ai] = li);
  }), ii), {});
  return Object.keys(yt).forEach((ii) => {
    let ui = ir.filter(Boolean).map((ai) => ai[ii]).filter((ai) => typeof ai < "u");
    ui.every((ai) => L(ai)) ? ti[ii] = M(...ui) : ti[ii] = ui[ui.length - 1];
  }), ti;
}, "combineParameters");
function Le(pt, yt, ir) {
  let { moduleExport: ti, id: ii, name: ui } = pt || {}, ai = bo(
    pt,
    yt,
    ir
  ), li = /* @__PURE__ */ s(async (Mi) => {
    let Oo = {};
    for (let io of [
      ..."__STORYBOOK_TEST_LOADERS__" in I && Array.isArray(I.__STORYBOOK_TEST_LOADERS__) ? [I.__STORYBOOK_TEST_LOADERS__] : [],
      F(ir.loaders),
      F(yt.loaders),
      F(pt.loaders)
    ]) {
      if (Mi.abortSignal.aborted)
        return Oo;
      let xo = await Promise.all(io.map((fo) => fo(Mi)));
      Object.assign(Oo, ...xo);
    }
    return Oo;
  }, "applyLoaders"), oi = /* @__PURE__ */ s(async (Mi) => {
    let Oo = new Array();
    for (let io of [
      ...F(ir.beforeEach),
      ...F(yt.beforeEach),
      ...F(pt.beforeEach)
    ]) {
      if (Mi.abortSignal.aborted)
        return Oo;
      let xo = await io(Mi);
      xo && Oo.push(xo);
    }
    return Oo;
  }, "applyBeforeEach"), si = /* @__PURE__ */ s(async (Mi) => {
    let Oo = [
      ...F(ir.experimental_afterEach),
      ...F(yt.experimental_afterEach),
      ...F(pt.experimental_afterEach)
    ].reverse();
    for (let io of Oo) {
      if (Mi.abortSignal.aborted)
        return;
      await io(Mi);
    }
  }, "applyAfterEach"), di = /* @__PURE__ */ s((Mi) => Mi.originalStoryFn(Mi.args, Mi), "undecoratedStoryFn"), { applyDecorators: fi = Hr, runStep: gi } = ir, mi = [
    ...F(pt == null ? void 0 : pt.decorators),
    ...F(yt == null ? void 0 : yt.decorators),
    ...F(ir == null ? void 0 : ir.decorators)
  ], Ti = (pt == null ? void 0 : pt.userStoryFn) || (pt == null ? void 0 : pt.render) || yt.render || ir.render, vi = vr(fi)(di, mi), xi = /* @__PURE__ */ s((Mi) => vi(Mi), "unboundStoryFn"), Si = (pt == null ? void 0 : pt.play) ?? (yt == null ? void 0 : yt.play), Pi = mo(Si);
  if (!Ti && !Pi)
    throw new q$1({ id: ii });
  let $i = /* @__PURE__ */ s((Mi) => async () => (await Mi.renderToCanvas(), Mi.canvas), "defaultMount"), Oi = pt.mount ?? yt.mount ?? ir.mount ?? $i, Di = ir.testingLibraryRender;
  return {
    storyGlobals: {},
    ...ai,
    moduleExport: ti,
    id: ii,
    name: ui,
    story: ui,
    originalStoryFn: Ti,
    undecoratedStoryFn: di,
    unboundStoryFn: xi,
    applyLoaders: li,
    applyBeforeEach: oi,
    applyAfterEach: si,
    playFunction: Si,
    runStep: gi,
    mount: Oi,
    testingLibraryRender: Di,
    renderToCanvas: ir.renderToCanvas,
    usesMount: Pi
  };
}
s(Le, "prepareStory");
function Wr(pt, yt, ir) {
  return {
    ...bo(void 0, pt, yt),
    moduleExport: ir
  };
}
s(Wr, "prepareMeta");
function bo(pt, yt, ir) {
  var ti;
  let ii = ["dev", "test"], ui = ((ti = I.DOCS_OPTIONS) == null ? void 0 : ti.autodocs) === !0 ? ["autodocs"] : [], ai = oe(
    ...ii,
    ...ui,
    ...ir.tags ?? [],
    ...yt.tags ?? [],
    ...(pt == null ? void 0 : pt.tags) ?? []
  ), li = M(
    ir.parameters,
    yt.parameters,
    pt == null ? void 0 : pt.parameters
  ), { argTypesEnhancers: oi = [], argsEnhancers: si = [] } = ir, di = M(
    ir.argTypes,
    yt.argTypes,
    pt == null ? void 0 : pt.argTypes
  );
  if (pt) {
    let Pi = (pt == null ? void 0 : pt.userStoryFn) || (pt == null ? void 0 : pt.render) || yt.render || ir.render;
    li.__isArgsStory = Pi && Pi.length > 0;
  }
  let fi = {
    ...ir.args,
    ...yt.args,
    ...pt == null ? void 0 : pt.args
  }, gi = {
    ...yt.globals,
    ...pt == null ? void 0 : pt.globals
  }, mi = {
    componentId: yt.id,
    title: yt.title,
    kind: yt.title,
    // Back compat
    id: (pt == null ? void 0 : pt.id) || yt.id,
    // if there's no story name, we create a fake one since enhancers expect a name
    name: (pt == null ? void 0 : pt.name) || "__meta",
    story: (pt == null ? void 0 : pt.name) || "__meta",
    // Back compat
    component: yt.component,
    subcomponents: yt.subcomponents,
    tags: ai,
    parameters: li,
    initialArgs: fi,
    argTypes: di,
    storyGlobals: gi
  };
  mi.argTypes = oi.reduce(
    (Pi, $i) => $i({ ...mi, argTypes: Pi }),
    mi.argTypes
  );
  let Ti = { ...fi };
  mi.initialArgs = si.reduce(
    (Pi, $i) => ({
      ...Pi,
      ...$i({
        ...mi,
        initialArgs: Pi
      })
    }),
    Ti
  );
  let { name: vi, story: xi, ...Si } = mi;
  return Si;
}
s(bo, "preparePartialAnnotations");
function er(pt) {
  var yt;
  let { args: ir } = pt, ti = {
    ...pt,
    allArgs: void 0,
    argsByTarget: void 0
  };
  if ((yt = I.FEATURES) != null && yt.argTypeTargetsV7) {
    let ai = co(pt);
    ti = {
      ...pt,
      allArgs: pt.args,
      argsByTarget: ai,
      args: ai[Gr] || {}
    };
  }
  let ii = Object.entries(ti.args).reduce((ai, [li, oi]) => {
    var si;
    if (!((si = ti.argTypes[li]) != null && si.mapping))
      return ai[li] = oi, ai;
    let di = /* @__PURE__ */ s((fi) => {
      let gi = ti.argTypes[li].mapping;
      return gi && fi in gi ? gi[fi] : fi;
    }, "mappingFn");
    return ai[li] = Array.isArray(oi) ? oi.map(di) : di(oi), ai;
  }, {}), ui = Object.entries(ii).reduce((ai, [li, oi]) => {
    let si = ti.argTypes[li] || {};
    return z(si, ii, ti.globals) && (ai[li] = oi), ai;
  }, {});
  return { ...ti, unmappedArgs: ir, args: ui };
}
s(er, "prepareContext");
var $r = /* @__PURE__ */ s((pt, yt, ir) => {
  let ti = typeof pt;
  switch (ti) {
    case "boolean":
    case "string":
    case "number":
    case "function":
    case "symbol":
      return { name: ti };
  }
  return pt ? ir.has(pt) ? (s$3.warn(P`
        We've detected a cycle in arg '${yt}'. Args should be JSON-serializable.

        Consider using the mapping feature or fully custom args:
        - Mapping: https://storybook.js.org/docs/writing-stories/args#mapping-to-complex-arg-values
        - Custom args: https://storybook.js.org/docs/essentials/controls#fully-custom-args
      `), { name: "other", value: "cyclic object" }) : (ir.add(pt), Array.isArray(pt) ? { name: "array", value: pt.length > 0 ? $r(pt[0], yt, new Set(
    ir
  )) : { name: "other", value: "unknown" } } : { name: "object", value: G(pt, (ii) => $r(ii, yt, new Set(ir))) }) : { name: "object", value: {} };
}, "inferType"), Yr = /* @__PURE__ */ s((pt) => {
  let { id: yt, argTypes: ir = {}, initialArgs: ti = {} } = pt, ii = G(ti, (ai, li) => ({
    name: li,
    type: $r(ai, `${yt}.${li}`, /* @__PURE__ */ new Set())
  })), ui = G(ir, (ai, li) => ({
    name: li
  }));
  return M(ii, ui, ir);
}, "inferArgTypes");
Yr.secondPass = !0;
var To = /* @__PURE__ */ s((pt, yt) => Array.isArray(yt) ? yt.includes(pt) : pt.match(yt), "matches"), rr = /* @__PURE__ */ s((pt, yt, ir) => !yt && !ir ? pt : pt && Dr(pt, (ti, ii) => {
  let ui = ti.name || ii.toString();
  return !!(!yt || To(ui, yt)) && (!ir || !To(ui, ir));
}), "filterArgTypes"), Bs = /* @__PURE__ */ s((pt, yt, ir) => {
  let { type: ti, options: ii } = pt;
  if (ti) {
    if (ir.color && ir.color.test(yt)) {
      let ui = ti.name;
      if (ui === "string")
        return { control: { type: "color" } };
      ui !== "enum" && s$3.warn(
        `Addon controls: Control of type color only supports string, received "${ui}" instead`
      );
    }
    if (ir.date && ir.date.test(yt))
      return { control: { type: "date" } };
    switch (ti.name) {
      case "array":
        return { control: { type: "object" } };
      case "boolean":
        return { control: { type: "boolean" } };
      case "string":
        return { control: { type: "text" } };
      case "number":
        return { control: { type: "number" } };
      case "enum": {
        let { value: ui } = ti;
        return { control: { type: (ui == null ? void 0 : ui.length) <= 5 ? "radio" : "select" }, options: ui };
      }
      case "function":
      case "symbol":
        return null;
      default:
        return { control: { type: ii ? "select" : "object" } };
    }
  }
}, "inferControl"), Ne = /* @__PURE__ */ s((pt) => {
  let {
    argTypes: yt,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    parameters: { __isArgsStory: ir, controls: { include: ti = null, exclude: ii = null, matchers: ui = {} } = {} }
  } = pt;
  if (!ir)
    return yt;
  let ai = rr(yt, ti, ii), li = G(ai, (oi, si) => (oi == null ? void 0 : oi.type) && Bs(oi, si.toString(), ui));
  return M(li, ai);
}, "inferControls");
Ne.secondPass = !0;
function be({
  argTypes: pt,
  globalTypes: yt,
  argTypesEnhancers: ir,
  decorators: ti,
  loaders: ii,
  beforeEach: ui,
  experimental_afterEach: ai,
  globals: li,
  initialGlobals: oi,
  ...si
}) {
  return li && Object.keys(li).length > 0 && m$1(P`
      The preview.js 'globals' field is deprecated and will be removed in Storybook 9.0.
      Please use 'initialGlobals' instead. Learn more:

      https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#previewjs-globals-renamed-to-initialglobals
    `), {
    ...pt && { argTypes: ae(pt) },
    ...yt && { globalTypes: ae(yt) },
    decorators: F(ti),
    loaders: F(ii),
    beforeEach: F(ui),
    experimental_afterEach: F(ai),
    argTypesEnhancers: [
      ...ir || [],
      Yr,
      // inferControls technically should only run if the user is using the controls addon,
      // and so should be added by a preset there. However, as it seems some code relies on controls
      // annotations (in particular the angular implementation's `cleanArgsDecorator`), for backwards
      // compatibility reasons, we will leave this in the store until 7.0
      Ne
    ],
    initialGlobals: M(oi, li),
    ...si
  };
}
s(be, "normalizeProjectAnnotations");
var Eo = /* @__PURE__ */ s((pt) => async () => {
  let yt = [];
  for (let ir of pt) {
    let ti = await ir();
    ti && yt.unshift(ti);
  }
  return async () => {
    for (let ir of yt)
      await ir();
  };
}, "composeBeforeAllHooks");
function Kr(pt) {
  return async (yt, ir, ti) => {
    await pt.reduceRight(
      (ii, ui) => async () => ui(yt, ii, ti),
      async () => ir(ti)
    )();
  };
}
s(Kr, "composeStepRunners");
function _e(pt, yt) {
  return pt.map((ir) => {
    var ti;
    return ((ti = ir.default) == null ? void 0 : ti[yt]) ?? ir[yt];
  }).filter(Boolean);
}
s(_e, "getField");
function Q(pt, yt, ir = {}) {
  return _e(pt, yt).reduce((ti, ii) => {
    let ui = F(ii);
    return ir.reverseFileOrder ? [...ui, ...ti] : [...ti, ...ui];
  }, []);
}
s(Q, "getArrayField");
function Me(pt, yt) {
  return Object.assign({}, ..._e(pt, yt));
}
s(Me, "getObjectField");
function Te(pt, yt) {
  return _e(pt, yt).pop();
}
s(Te, "getSingletonField");
function Ee(pt) {
  var yt;
  let ir = Q(pt, "argTypesEnhancers"), ti = _e(pt, "runStep"), ii = Q(pt, "beforeAll");
  return {
    parameters: M(..._e(pt, "parameters")),
    decorators: Q(pt, "decorators", {
      reverseFileOrder: !(((yt = I.FEATURES) == null ? void 0 : yt.legacyDecoratorFileOrder) ?? !1)
    }),
    args: Me(pt, "args"),
    argsEnhancers: Q(pt, "argsEnhancers"),
    argTypes: Me(pt, "argTypes"),
    argTypesEnhancers: [
      ...ir.filter((ui) => !ui.secondPass),
      ...ir.filter((ui) => ui.secondPass)
    ],
    globals: Me(pt, "globals"),
    initialGlobals: Me(pt, "initialGlobals"),
    globalTypes: Me(pt, "globalTypes"),
    loaders: Q(pt, "loaders"),
    beforeAll: Eo(ii),
    beforeEach: Q(pt, "beforeEach"),
    experimental_afterEach: Q(pt, "experimental_afterEach"),
    render: Te(pt, "render"),
    renderToCanvas: Te(pt, "renderToCanvas"),
    renderToDOM: Te(pt, "renderToDOM"),
    // deprecated
    applyDecorators: Te(pt, "applyDecorators"),
    runStep: Kr(ti),
    tags: Q(pt, "tags"),
    mount: Te(pt, "mount"),
    testingLibraryRender: Te(pt, "testingLibraryRender")
  };
}
s(Ee, "composeConfigs");
var Xr = class {
  constructor() {
    this.reports = [];
  }
  async addReport(pt) {
    this.reports.push(pt);
  }
};
s(Xr, "ReporterAPI");
var le = Xr;
function Jr(pt, yt, ir) {
  return K(pt) ? {
    story: pt.input,
    meta: pt.meta.input,
    preview: pt.meta.preview.composed
  } : { story: pt, meta: yt, preview: ir };
}
s(Jr, "getCsfFactoryAnnotations");
function $s(pt) {
  globalThis.defaultProjectAnnotations = pt;
}
s($s, "setDefaultProjectAnnotations");
var Ys = "ComposedStory", Ks = "Unnamed Story";
function Xs(pt) {
  return pt ? Ee([pt]) : {};
}
s(Xs, "extractAnnotation");
function Js(pt) {
  let yt = Array.isArray(pt) ? pt : [pt];
  return globalThis.globalProjectAnnotations = Ee([
    globalThis.defaultProjectAnnotations ?? {},
    Ee(yt.map(Xs))
  ]), globalThis.globalProjectAnnotations ?? {};
}
s(Js, "setProjectAnnotations");
var Z = [];
function Ro(pt, yt, ir, ti, ii) {
  var ui;
  if (pt === void 0)
    throw new Error("Expected a story but received undefined.");
  yt.title = yt.title ?? Ys;
  let ai = je(yt), li = ii || pt.storyName || ((ui = pt.story) == null ? void 0 : ui.name) || pt.name || Ks, oi = Se(
    li,
    pt,
    ai
  ), si = be(
    Ee([
      ti ?? globalThis.globalProjectAnnotations ?? {},
      ir ?? {}
    ])
  ), di = Le(
    oi,
    ai,
    si
  ), fi = {
    // TODO: remove loading from globalTypes in 9.0
    ...Xe(si.globalTypes),
    ...si.initialGlobals,
    ...di.storyGlobals
  }, gi = new le(), mi = /* @__PURE__ */ s(() => {
    let Pi = er({
      hooks: new se(),
      globals: fi,
      args: { ...di.initialArgs },
      viewMode: "story",
      reporting: gi,
      loaded: {},
      abortSignal: new AbortController().signal,
      step: /* @__PURE__ */ s(($i, Oi) => di.runStep($i, Oi, Pi), "step"),
      canvasElement: null,
      canvas: {},
      globalTypes: si.globalTypes,
      ...di,
      context: null,
      mount: null
    });
    return Pi.parameters.__isPortableStory = !0, Pi.context = Pi, di.renderToCanvas && (Pi.renderToCanvas = async () => {
      var $i;
      let Oi = await (($i = di.renderToCanvas) == null ? void 0 : $i.call(
        di,
        {
          componentId: di.componentId,
          title: di.title,
          id: di.id,
          name: di.name,
          tags: di.tags,
          showMain: /* @__PURE__ */ s(() => {
          }, "showMain"),
          showError: /* @__PURE__ */ s((Di) => {
            throw new Error(`${Di.title}
${Di.description}`);
          }, "showError"),
          showException: /* @__PURE__ */ s((Di) => {
            throw Di;
          }, "showException"),
          forceRemount: !0,
          storyContext: Pi,
          storyFn: /* @__PURE__ */ s(() => di.unboundStoryFn(Pi), "storyFn"),
          unboundStoryFn: di.unboundStoryFn
        },
        Pi.canvasElement
      ));
      Oi && Z.push(Oi);
    }), Pi.mount = di.mount(Pi), Pi;
  }, "initializeContext"), Ti, vi = /* @__PURE__ */ s(async (Pi) => {
    var $i;
    let Oi = mi();
    return Oi.canvasElement ?? (Oi.canvasElement = ($i = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : $i.body), Ti && (Oi.loaded = Ti.loaded), Object.assign(Oi, Pi), di.playFunction(Oi);
  }, "play"), xi = /* @__PURE__ */ s((Pi) => {
    let $i = mi();
    return Object.assign($i, Pi), ri(di, $i);
  }, "run"), Si = di.playFunction ? vi : void 0;
  return Object.assign(
    /* @__PURE__ */ s(function(Pi) {
      let $i = mi();
      return Ti && ($i.loaded = Ti.loaded), $i.args = {
        ...$i.initialArgs,
        ...Pi
      }, di.unboundStoryFn($i);
    }, "storyFn"),
    {
      id: di.id,
      storyName: li,
      load: /* @__PURE__ */ s(async () => {
        for (let $i of [...Z].reverse())
          await $i();
        Z.length = 0;
        let Pi = mi();
        Pi.loaded = await di.applyLoaders(Pi), Z.push(...(await di.applyBeforeEach(Pi)).filter(Boolean)), Ti = Pi;
      }, "load"),
      globals: fi,
      args: di.initialArgs,
      parameters: di.parameters,
      argTypes: di.argTypes,
      play: Si,
      run: xi,
      reporting: gi,
      tags: di.tags
    }
  );
}
s(Ro, "composeStory");
var Qs = /* @__PURE__ */ s((pt, yt, ir, ti) => Ro(pt, yt, ir, {}, ti), "defaultComposeStory");
function Zs(pt, yt, ir = Qs) {
  let { default: ti, __esModule: ii, __namedExportsOrder: ui, ...ai } = pt, li = ti;
  return Object.entries(ai).reduce(
    (oi, [si, di]) => {
      let { story: fi, meta: gi } = Jr(di);
      return !li && gi && (li = gi), te$1(si, li) ? Object.assign(oi, {
        [si]: ir(fi, li, yt, si)
      }) : oi;
    },
    {}
  );
}
s(Zs, "composeStories");
function ei(pt) {
  return pt.extend({
    mount: /* @__PURE__ */ s(async ({ mount: yt, page: ir }, ti) => {
      await ti(async (ii, ...ui) => {
        if (!("__pw_type" in ii) || "__pw_type" in ii && ii.__pw_type !== "jsx")
          throw new Error(P`
              Portable stories in Playwright CT only work when referencing JSX elements.
              Please use JSX format for your components such as:

              instead of:
              await mount(MyComponent, { props: { foo: 'bar' } })

              do:
              await mount(<MyComponent foo="bar"/>)

              More info: https://storybook.js.org/docs/api/portable-stories-playwright
            `);
        await ir.evaluate(async (li) => {
          var oi, si, di;
          let fi = await ((oi = globalThis.__pwUnwrapObject) == null ? void 0 : oi.call(globalThis, li));
          return (di = (si = "__pw_type" in fi ? fi.type : fi) == null ? void 0 : si.load) == null ? void 0 : di.call(si);
        }, ii);
        let ai = await yt(ii, ...ui);
        return await ir.evaluate(async (li) => {
          var oi, si;
          let di = await ((oi = globalThis.__pwUnwrapObject) == null ? void 0 : oi.call(globalThis, li)), fi = "__pw_type" in di ? di.type : di, gi = document.querySelector("#root");
          return (si = fi == null ? void 0 : fi.play) == null ? void 0 : si.call(fi, { canvasElement: gi });
        }, ii), ai;
      });
    }, "mount")
  });
}
s(ei, "createPlaywrightTest");
async function ri(pt, yt) {
  var ir, ti;
  for (let ai of [...Z].reverse())
    await ai();
  if (Z.length = 0, !yt.canvasElement) {
    let ai = document.createElement("div");
    (ti = (ir = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : ir.body) == null || ti.appendChild(ai), yt.canvasElement = ai, Z.push(() => {
      var li, oi, si, di;
      (oi = (li = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : li.body) != null && oi.contains(ai) && ((di = (si = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : si.body) == null || di.removeChild(ai));
    });
  }
  if (yt.loaded = await pt.applyLoaders(yt), yt.abortSignal.aborted)
    return;
  Z.push(...(await pt.applyBeforeEach(yt)).filter(Boolean));
  let ii = pt.playFunction, ui = pt.usesMount;
  ui || await yt.mount(), !yt.abortSignal.aborted && (ii && (ui || (yt.mount = async () => {
    throw new J$1({ playFunction: ii.toString() });
  }), await ii(yt)), await pt.applyAfterEach(yt));
}
s(ri, "runStory");
function wo(pt, yt) {
  return Ir(Or(pt, yt), (ir) => ir === void 0);
}
s(wo, "picky");
var vo = 1e3, ni = 1e4, Qr = class {
  constructor(pt, yt, ir) {
    this.importFn = yt, this.getStoriesJsonData = /* @__PURE__ */ s(() => {
      let ui = this.getSetStoriesPayload(), ai = ["fileName", "docsOnly", "framework", "__id", "__isArgsStory"];
      return {
        v: 3,
        stories: G(ui.stories, (li) => {
          let { importPath: oi } = this.storyIndex.entries[li.id];
          return {
            ...wo(li, ["id", "name", "title"]),
            importPath: oi,
            // These 3 fields were going to be dropped in v7, but instead we will keep them for the
            // 7.x cycle so that v7 Storybooks can be composed successfully in v6 Storybook.
            // In v8 we will (likely) completely drop support for `extract` and `getStoriesJsonData`
            kind: li.title,
            story: li.name,
            parameters: {
              ...wo(li.parameters, ai),
              fileName: oi
            }
          };
        })
      };
    }, "getStoriesJsonData"), this.storyIndex = new Qe(pt), this.projectAnnotations = be(ir);
    let { initialGlobals: ti, globalTypes: ii } = this.projectAnnotations;
    this.args = new Ke(), this.userGlobals = new Je({ globals: ti, globalTypes: ii }), this.hooks = {}, this.cleanupCallbacks = {}, this.processCSFFileWithCache = (0, tr.default)(vo)(yo), this.prepareMetaWithCache = (0, tr.default)(vo)(Wr), this.prepareStoryWithCache = (0, tr.default)(ni)(Le);
  }
  setProjectAnnotations(pt) {
    this.projectAnnotations = be(pt);
    let { initialGlobals: yt, globalTypes: ir } = pt;
    this.userGlobals.set({ globals: yt, globalTypes: ir });
  }
  // This means that one of the CSF files has changed.
  // If the `importFn` has changed, we will invalidate both caches.
  // If the `storyIndex` data has changed, we may or may not invalidate the caches, depending
  // on whether we've loaded the relevant files yet.
  async onStoriesChanged({
    importFn: pt,
    storyIndex: yt
  }) {
    pt && (this.importFn = pt), yt && (this.storyIndex.entries = yt.entries), this.cachedCSFFiles && await this.cacheAllCSFFiles();
  }
  // Get an entry from the index, waiting on initialization if necessary
  async storyIdToEntry(pt) {
    return this.storyIndex.storyIdToEntry(pt);
  }
  // To load a single CSF file to service a story we need to look up the importPath in the index
  async loadCSFFileByStoryId(pt) {
    let { importPath: yt, title: ir } = this.storyIndex.storyIdToEntry(pt), ti = await this.importFn(yt);
    return this.processCSFFileWithCache(ti, yt, ir);
  }
  async loadAllCSFFiles() {
    let pt = {};
    return Object.entries(this.storyIndex.entries).forEach(([yt, { importPath: ir }]) => {
      pt[ir] = yt;
    }), (await Promise.all(
      Object.entries(pt).map(async ([yt, ir]) => ({
        importPath: yt,
        csfFile: await this.loadCSFFileByStoryId(ir)
      }))
    )).reduce(
      (yt, { importPath: ir, csfFile: ti }) => (yt[ir] = ti, yt),
      {}
    );
  }
  async cacheAllCSFFiles() {
    this.cachedCSFFiles = await this.loadAllCSFFiles();
  }
  preparedMetaFromCSFFile({ csfFile: pt }) {
    let yt = pt.meta;
    return this.prepareMetaWithCache(
      yt,
      this.projectAnnotations,
      pt.moduleExports.default
    );
  }
  // Load the CSF file for a story and prepare the story from it and the project annotations.
  async loadStory({ storyId: pt }) {
    let yt = await this.loadCSFFileByStoryId(pt);
    return this.storyFromCSFFile({ storyId: pt, csfFile: yt });
  }
  // This function is synchronous for convenience -- often times if you have a CSF file already
  // it is easier not to have to await `loadStory`.
  storyFromCSFFile({
    storyId: pt,
    csfFile: yt
  }) {
    let ir = yt.stories[pt];
    if (!ir)
      throw new X({ storyId: pt });
    let ti = yt.meta, ii = this.prepareStoryWithCache(
      ir,
      ti,
      yt.projectAnnotations ?? this.projectAnnotations
    );
    return this.args.setInitial(ii), this.hooks[ii.id] = this.hooks[ii.id] || new se(), ii;
  }
  // If we have a CSF file we can get all the stories from it synchronously
  componentStoriesFromCSFFile({
    csfFile: pt
  }) {
    return Object.keys(this.storyIndex.entries).filter((yt) => !!pt.stories[yt]).map((yt) => this.storyFromCSFFile({ storyId: yt, csfFile: pt }));
  }
  async loadEntry(pt) {
    let yt = await this.storyIdToEntry(pt), ir = yt.type === "docs" ? yt.storiesImports : [], [ti, ...ii] = await Promise.all([
      this.importFn(yt.importPath),
      ...ir.map((ui) => {
        let ai = this.storyIndex.importPathToEntry(ui);
        return this.loadCSFFileByStoryId(ai.id);
      })
    ]);
    return { entryExports: ti, csfFiles: ii };
  }
  // A prepared story does not include args, globals or hooks. These are stored in the story store
  // and updated separtely to the (immutable) story.
  getStoryContext(pt, { forceInitialArgs: yt = !1 } = {}) {
    let ir = this.userGlobals.get(), { initialGlobals: ti } = this.userGlobals, ii = new le();
    return er({
      ...pt,
      args: yt ? pt.initialArgs : this.args.get(pt.id),
      initialGlobals: ti,
      globalTypes: this.projectAnnotations.globalTypes,
      userGlobals: ir,
      reporting: ii,
      globals: {
        ...ir,
        ...pt.storyGlobals
      },
      hooks: this.hooks[pt.id]
    });
  }
  addCleanupCallbacks(pt, yt) {
    this.cleanupCallbacks[pt.id] = yt;
  }
  async cleanupStory(pt) {
    this.hooks[pt.id].clean();
    let yt = this.cleanupCallbacks[pt.id];
    if (yt)
      for (let ir of [...yt].reverse())
        await ir();
    delete this.cleanupCallbacks[pt.id];
  }
  extract(pt = { includeDocsOnly: !1 }) {
    let { cachedCSFFiles: yt } = this;
    if (!yt)
      throw new L$2();
    return Object.entries(this.storyIndex.entries).reduce(
      (ir, [ti, { type: ii, importPath: ui }]) => {
        if (ii === "docs")
          return ir;
        let ai = yt[ui], li = this.storyFromCSFFile({ storyId: ti, csfFile: ai });
        return !pt.includeDocsOnly && li.parameters.docsOnly || (ir[ti] = Object.entries(li).reduce(
          (oi, [si, di]) => si === "moduleExport" || typeof di == "function" ? oi : Array.isArray(di) ? Object.assign(oi, { [si]: di.slice().sort() }) : Object.assign(oi, { [si]: di }),
          {
            //
            args: li.initialArgs,
            globals: {
              ...this.userGlobals.initialGlobals,
              ...this.userGlobals.globals,
              ...li.storyGlobals
            }
          }
        )), ir;
      },
      {}
    );
  }
  // TODO: Remove in 9.0
  getSetStoriesPayload() {
    let pt = this.extract({ includeDocsOnly: !0 }), yt = Object.values(pt).reduce(
      (ir, { title: ti }) => (ir[ti] = {}, ir),
      {}
    );
    return {
      v: 2,
      globals: this.userGlobals.get(),
      globalParameters: {},
      kindParameters: yt,
      stories: pt
    };
  }
  raw() {
    return m$1(
      "StoryStore.raw() is deprecated and will be removed in 9.0, please use extract() instead"
    ), Object.values(this.extract()).map(({ id: pt }) => this.fromId(pt)).filter(Boolean);
  }
  fromId(pt) {
    if (m$1(
      "StoryStore.fromId() is deprecated and will be removed in 9.0, please use loadStory() instead"
    ), !this.cachedCSFFiles)
      throw new Error("Cannot call fromId/raw() unless you call cacheAllCSFFiles() first.");
    let yt;
    try {
      ({ importPath: yt } = this.storyIndex.storyIdToEntry(pt));
    } catch {
      return null;
    }
    let ir = this.cachedCSFFiles[yt], ti = this.storyFromCSFFile({ storyId: pt, csfFile: ir });
    return {
      ...ti,
      storyFn: /* @__PURE__ */ s((ii) => {
        let ui = {
          ...this.getStoryContext(ti),
          abortSignal: new AbortController().signal,
          canvasElement: null,
          loaded: {},
          step: /* @__PURE__ */ s((ai, li) => ti.runStep(ai, li, ui), "step"),
          context: null,
          mount: null,
          canvas: {},
          viewMode: "story"
        };
        return ti.unboundStoryFn({ ...ui, ...ii });
      }, "storyFn")
    };
  }
};
s(Qr, "StoryStore");
var Re = Qr;
function Zr(pt) {
  return pt.startsWith("\\\\?\\") ? pt : pt.replace(/\\/g, "/");
}
s(Zr, "slash");
function Ao(pt) {
  return pt.flatMap((yt) => yt.split("/")).filter(Boolean).join("/");
}
s(Ao, "pathJoin");
var ee = new Error("prepareAborted"), { AbortController: Do } = globalThis;
function ko(pt) {
  try {
    let { name: yt = "Error", message: ir = String(pt), stack: ti } = pt;
    return { name: yt, message: ir, stack: ti };
  } catch {
    return { name: "Error", message: String(pt) };
  }
}
s(ko, "serializeError");
var et = class {
  constructor(pt, yt, ir, ti, ii, ui, ai = { autoplay: !0, forceInitialArgs: !1 }, li) {
    this.channel = pt, this.store = yt, this.renderToScreen = ir, this.callbacks = ti, this.id = ii, this.viewMode = ui, this.renderOptions = ai, this.type = "story", this.notYetRendered = !0, this.rerenderEnqueued = !1, this.disableKeyListeners = !1, this.teardownRender = /* @__PURE__ */ s(() => {
    }, "teardownRender"), this.torndown = !1, this.abortController = new Do(), li && (this.story = li, this.phase = "preparing");
  }
  async runPhase(pt, yt, ir) {
    this.phase = yt, this.channel.emit(B$1, { newPhase: this.phase, storyId: this.id }), ir && (await ir(), this.checkIfAborted(pt));
  }
  checkIfAborted(pt) {
    return pt.aborted ? (this.phase = "aborted", this.channel.emit(B$1, { newPhase: this.phase, storyId: this.id }), !0) : !1;
  }
  async prepare() {
    if (await this.runPhase(this.abortController.signal, "preparing", async () => {
      this.story = await this.store.loadStory({ storyId: this.id });
    }), this.abortController.signal.aborted)
      throw await this.store.cleanupStory(this.story), ee;
  }
  // The two story "renders" are equal and have both loaded the same story
  isEqual(pt) {
    return !!(this.id === pt.id && this.story && this.story === pt.story);
  }
  isPreparing() {
    return ["preparing"].includes(this.phase);
  }
  isPending() {
    return ["loading", "beforeEach", "rendering", "playing", "afterEach"].includes(
      this.phase
    );
  }
  async renderToElement(pt) {
    return this.canvasElement = pt, this.render({ initial: !0, forceRemount: !0 });
  }
  storyContext() {
    if (!this.story)
      throw new Error("Cannot call storyContext before preparing");
    let { forceInitialArgs: pt } = this.renderOptions;
    return this.store.getStoryContext(this.story, { forceInitialArgs: pt });
  }
  async render({
    initial: pt = !1,
    forceRemount: yt = !1
  } = {}) {
    var ir, ti, ii, ui;
    let { canvasElement: ai } = this;
    if (!this.story)
      throw new Error("cannot render when not prepared");
    let li = this.story;
    if (!ai)
      throw new Error("cannot render when canvasElement is unset");
    let {
      id: oi,
      componentId: si,
      title: di,
      name: fi,
      tags: gi,
      applyLoaders: mi,
      applyBeforeEach: Ti,
      applyAfterEach: vi,
      unboundStoryFn: xi,
      playFunction: Si,
      runStep: Pi
    } = li;
    yt && !pt && (this.cancelRender(), this.abortController = new Do());
    let $i = this.abortController.signal, Oi = !1, Di = li.usesMount;
    try {
      let Mi = {
        ...this.storyContext(),
        viewMode: this.viewMode,
        abortSignal: $i,
        canvasElement: ai,
        loaded: {},
        step: /* @__PURE__ */ s((Yi, Vo) => Pi(Yi, Vo, Mi), "step"),
        context: null,
        canvas: {},
        renderToCanvas: /* @__PURE__ */ s(async () => {
          let Yi = await this.renderToScreen(Oo, ai);
          this.teardownRender = Yi || (() => {
          }), Oi = !0;
        }, "renderToCanvas"),
        // The story provides (set in a renderer) a mount function that is a higher order function
        // (context) => (...args) => Canvas
        //
        // Before assigning it to the context, we resolve the context dependency,
        // so that a user can just call it as await mount(...args) in their play function.
        mount: /* @__PURE__ */ s(async (...Yi) => {
          var Vo, No;
          (No = (Vo = this.callbacks).showStoryDuringRender) == null || No.call(Vo);
          let Ui = null;
          return await this.runPhase($i, "rendering", async () => {
            Ui = await li.mount(Mi)(...Yi);
          }), Di && await this.runPhase($i, "playing"), Ui;
        }, "mount")
      };
      Mi.context = Mi;
      let Oo = {
        componentId: si,
        title: di,
        kind: di,
        id: oi,
        name: fi,
        story: fi,
        tags: gi,
        ...this.callbacks,
        showError: /* @__PURE__ */ s((Yi) => (this.phase = "errored", this.callbacks.showError(Yi)), "showError"),
        showException: /* @__PURE__ */ s((Yi) => (this.phase = "errored", this.callbacks.showException(Yi)), "showException"),
        forceRemount: yt || this.notYetRendered,
        storyContext: Mi,
        storyFn: /* @__PURE__ */ s(() => xi(Mi), "storyFn"),
        unboundStoryFn: xi
      };
      if (await this.runPhase($i, "loading", async () => {
        Mi.loaded = await mi(Mi);
      }), $i.aborted)
        return;
      let io = await Ti(Mi);
      if (this.store.addCleanupCallbacks(li, io), this.checkIfAborted($i) || (!Oi && !Di && await Mi.mount(), this.notYetRendered = !1, $i.aborted))
        return;
      let xo = ((ti = (ir = this.story.parameters) == null ? void 0 : ir.test) == null ? void 0 : ti.dangerouslyIgnoreUnhandledErrors) === !0, fo = /* @__PURE__ */ new Set(), _o = /* @__PURE__ */ s((Yi) => fo.add("error" in Yi ? Yi.error : Yi.reason), "onError");
      if (this.renderOptions.autoplay && yt && Si && this.phase !== "errored") {
        window.addEventListener("error", _o), window.addEventListener("unhandledrejection", _o), this.disableKeyListeners = !0;
        try {
          if (Di ? await Si(Mi) : (Mi.mount = async () => {
            throw new J$1({ playFunction: Si.toString() });
          }, await this.runPhase($i, "playing", async () => Si(Mi))), !Oi)
            throw new z$1();
          this.checkIfAborted($i), !xo && fo.size > 0 ? await this.runPhase($i, "errored") : await this.runPhase($i, "played");
        } catch (Yi) {
          if ((ui = (ii = this.callbacks).showStoryDuringRender) == null || ui.call(ii), await this.runPhase($i, "errored", async () => {
            this.channel.emit(a$1, ko(Yi));
          }), this.story.parameters.throwPlayFunctionExceptions !== !1)
            throw Yi;
          console.error(Yi);
        }
        if (!xo && fo.size > 0 && this.channel.emit(
          Y$3,
          Array.from(fo).map(ko)
        ), this.disableKeyListeners = !1, window.removeEventListener("unhandledrejection", _o), window.removeEventListener("error", _o), $i.aborted)
          return;
      }
      await this.runPhase(
        $i,
        "completed",
        async () => this.channel.emit(X$2, oi)
      ), this.phase !== "errored" && await this.runPhase($i, "afterEach", async () => {
        await vi(Mi);
      });
      let Li = !xo && fo.size > 0, Co = Mi.reporting.reports.some(
        (Yi) => Yi.status === "failed"
      ), Ni = Li || Co;
      await this.runPhase(
        $i,
        "finished",
        async () => this.channel.emit(q$3, {
          storyId: oi,
          status: Ni ? "error" : "success",
          reporters: Mi.reporting.reports
        })
      );
    } catch (Mi) {
      this.phase = "errored", this.callbacks.showException(Mi), await this.runPhase(
        $i,
        "finished",
        async () => this.channel.emit(q$3, {
          storyId: oi,
          status: "error",
          reporters: []
        })
      );
    }
    this.rerenderEnqueued && (this.rerenderEnqueued = !1, this.render());
  }
  /**
   * Rerender the story. If the story is currently pending (loading/rendering), the rerender will be
   * enqueued, and will be executed after the current render is completed. Rerendering while playing
   * will not be enqueued, and will be executed immediately, to support rendering args changes while
   * playing.
   */
  async rerender() {
    if (this.isPending() && this.phase !== "playing")
      this.rerenderEnqueued = !0;
    else
      return this.render();
  }
  async remount() {
    return await this.teardown(), this.render({ forceRemount: !0 });
  }
  // If the story is torn down (either a new story is rendered or the docs page removes it)
  // we need to consider the fact that the initial render may not be finished
  // (possibly the loaders or the play function are still running). We use the controller
  // as a method to abort them, ASAP, but this is not foolproof as we cannot control what
  // happens inside the user's code.
  cancelRender() {
    var pt;
    (pt = this.abortController) == null || pt.abort();
  }
  async teardown() {
    this.torndown = !0, this.cancelRender(), this.story && await this.store.cleanupStory(this.story);
    for (let pt = 0; pt < 3; pt += 1) {
      if (!this.isPending()) {
        await this.teardownRender();
        return;
      }
      await new Promise((yt) => setTimeout(yt, 0));
    }
    window.location.reload(), await new Promise(() => {
    });
  }
};
s(et, "StoryRender");
var ce = et, { fetch: Fi } = I, Ii = "./index.json", rt = class {
  constructor(pt, yt, ir = V.getChannel(), ti = !0) {
    this.importFn = pt, this.getProjectAnnotations = yt, this.channel = ir, this.storyRenders = [], this.storeInitializationPromise = new Promise((ii, ui) => {
      this.resolveStoreInitializationPromise = ii, this.rejectStoreInitializationPromise = ui;
    }), ti && this.initialize();
  }
  // Create a proxy object for `__STORYBOOK_STORY_STORE__` and `__STORYBOOK_PREVIEW__.storyStore`
  // That proxies through to the store once ready, and errors beforehand. This means we can set
  // `__STORYBOOK_STORY_STORE__ = __STORYBOOK_PREVIEW__.storyStore` without having to wait, and
  // similarly integrators can access the `storyStore` on the preview at any time, although
  // it is considered deprecated and we will no longer allow access in 9.0
  get storyStore() {
    return new Proxy(
      {},
      {
        get: /* @__PURE__ */ s((pt, yt) => {
          if (this.storyStoreValue)
            return m$1("Accessing the Story Store is deprecated and will be removed in 9.0"), this.storyStoreValue[yt];
          throw new U$1();
        }, "get")
      }
    );
  }
  // INITIALIZATION
  async initialize() {
    this.setupListeners();
    try {
      let pt = await this.getProjectAnnotationsOrRenderError();
      await this.runBeforeAllHook(pt), await this.initializeWithProjectAnnotations(pt);
    } catch (pt) {
      this.rejectStoreInitializationPromise(pt);
    }
  }
  ready() {
    return this.storeInitializationPromise;
  }
  setupListeners() {
    this.channel.on(m, this.onStoryIndexChanged.bind(this)), this.channel.on(k$3, this.onUpdateGlobals.bind(this)), this.channel.on(z$2, this.onUpdateArgs.bind(this)), this.channel.on(SE, this.onRequestArgTypesInfo.bind(this)), this.channel.on(W$3, this.onResetArgs.bind(this)), this.channel.on(L$3, this.onForceReRender.bind(this)), this.channel.on(P$4, this.onForceRemount.bind(this));
  }
  async getProjectAnnotationsOrRenderError() {
    try {
      let pt = await this.getProjectAnnotations();
      if (this.renderToCanvas = pt.renderToCanvas, !this.renderToCanvas)
        throw new G$1();
      return pt;
    } catch (pt) {
      throw this.renderPreviewEntryError("Error reading preview.js:", pt), pt;
    }
  }
  // If initialization gets as far as project annotations, this function runs.
  async initializeWithProjectAnnotations(pt) {
    this.projectAnnotationsBeforeInitialization = pt;
    try {
      let yt = await this.getStoryIndexFromServer();
      return this.initializeWithStoryIndex(yt);
    } catch (yt) {
      throw this.renderPreviewEntryError("Error loading story index:", yt), yt;
    }
  }
  async runBeforeAllHook(pt) {
    var yt, ir;
    try {
      await ((yt = this.beforeAllCleanup) == null ? void 0 : yt.call(this)), this.beforeAllCleanup = await ((ir = pt.beforeAll) == null ? void 0 : ir.call(pt));
    } catch (ti) {
      throw this.renderPreviewEntryError("Error in beforeAll hook:", ti), ti;
    }
  }
  async getStoryIndexFromServer() {
    let pt = await Fi(Ii);
    if (pt.status === 200)
      return pt.json();
    throw new M$1({ text: await pt.text() });
  }
  // If initialization gets as far as the story index, this function runs.
  initializeWithStoryIndex(pt) {
    if (!this.projectAnnotationsBeforeInitialization)
      throw new Error("Cannot call initializeWithStoryIndex until project annotations resolve");
    this.storyStoreValue = new Re(
      pt,
      this.importFn,
      this.projectAnnotationsBeforeInitialization
    ), delete this.projectAnnotationsBeforeInitialization, this.setInitialGlobals(), this.resolveStoreInitializationPromise();
  }
  async setInitialGlobals() {
    this.emitGlobals();
  }
  emitGlobals() {
    if (!this.storyStoreValue)
      throw new Y$1({ methodName: "emitGlobals" });
    let pt = {
      globals: this.storyStoreValue.userGlobals.get() || {},
      globalTypes: this.storyStoreValue.projectAnnotations.globalTypes || {}
    };
    this.channel.emit(u, pt);
  }
  // EVENT HANDLERS
  // This happens when a config file gets reloaded
  async onGetProjectAnnotationsChanged({
    getProjectAnnotations: pt
  }) {
    delete this.previewEntryError, this.getProjectAnnotations = pt;
    let yt = await this.getProjectAnnotationsOrRenderError();
    if (await this.runBeforeAllHook(yt), !this.storyStoreValue) {
      await this.initializeWithProjectAnnotations(yt);
      return;
    }
    this.storyStoreValue.setProjectAnnotations(yt), this.emitGlobals();
  }
  async onStoryIndexChanged() {
    if (delete this.previewEntryError, !(!this.storyStoreValue && !this.projectAnnotationsBeforeInitialization))
      try {
        let pt = await this.getStoryIndexFromServer();
        if (this.projectAnnotationsBeforeInitialization) {
          this.initializeWithStoryIndex(pt);
          return;
        }
        await this.onStoriesChanged({ storyIndex: pt });
      } catch (pt) {
        throw this.renderPreviewEntryError("Error loading story index:", pt), pt;
      }
  }
  // This happens when a glob gets HMR-ed
  async onStoriesChanged({
    importFn: pt,
    storyIndex: yt
  }) {
    if (!this.storyStoreValue)
      throw new Y$1({ methodName: "onStoriesChanged" });
    await this.storyStoreValue.onStoriesChanged({ importFn: pt, storyIndex: yt });
  }
  async onUpdateGlobals({
    globals: pt,
    currentStory: yt
  }) {
    if (this.storyStoreValue || await this.storeInitializationPromise, !this.storyStoreValue)
      throw new Y$1({ methodName: "onUpdateGlobals" });
    if (this.storyStoreValue.userGlobals.update(pt), yt) {
      let { initialGlobals: ir, storyGlobals: ti, userGlobals: ii, globals: ui } = this.storyStoreValue.getStoryContext(yt);
      this.channel.emit(U$3, {
        initialGlobals: ir,
        userGlobals: ii,
        storyGlobals: ti,
        globals: ui
      });
    } else {
      let { initialGlobals: ir, globals: ti } = this.storyStoreValue.userGlobals;
      this.channel.emit(U$3, {
        initialGlobals: ir,
        userGlobals: ti,
        storyGlobals: {},
        globals: ti
      });
    }
    await Promise.all(this.storyRenders.map((ir) => ir.rerender()));
  }
  async onUpdateArgs({ storyId: pt, updatedArgs: yt }) {
    if (!this.storyStoreValue)
      throw new Y$1({ methodName: "onUpdateArgs" });
    this.storyStoreValue.args.update(pt, yt), await Promise.all(
      this.storyRenders.filter((ir) => ir.id === pt && !ir.renderOptions.forceInitialArgs).map(
        (ir) => (
          // We only run the play function, with in a force remount.
          // But when mount is destructured, the rendering happens inside of the play function.
          ir.story && ir.story.usesMount ? ir.remount() : ir.rerender()
        )
      )
    ), this.channel.emit(f$2, {
      storyId: pt,
      args: this.storyStoreValue.args.get(pt)
    });
  }
  async onRequestArgTypesInfo({ id: pt, payload: yt }) {
    var ir;
    try {
      await this.storeInitializationPromise;
      let ti = await ((ir = this.storyStoreValue) == null ? void 0 : ir.loadStory(yt));
      this.channel.emit(TE, {
        id: pt,
        success: !0,
        payload: { argTypes: (ti == null ? void 0 : ti.argTypes) || {} },
        error: null
      });
    } catch (ti) {
      this.channel.emit(TE, {
        id: pt,
        success: !1,
        error: ti == null ? void 0 : ti.message
      });
    }
  }
  async onResetArgs({ storyId: pt, argNames: yt }) {
    var ir;
    if (!this.storyStoreValue)
      throw new Y$1({ methodName: "onResetArgs" });
    let ti = ((ir = this.storyRenders.find((ui) => ui.id === pt)) == null ? void 0 : ir.story) || await this.storyStoreValue.loadStory({ storyId: pt }), ii = (yt || [
      .../* @__PURE__ */ new Set([
        ...Object.keys(ti.initialArgs),
        ...Object.keys(this.storyStoreValue.args.get(pt))
      ])
    ]).reduce((ui, ai) => (ui[ai] = ti.initialArgs[ai], ui), {});
    await this.onUpdateArgs({ storyId: pt, updatedArgs: ii });
  }
  // ForceReRender does not include a story id, so we simply must
  // re-render all stories in case they are relevant
  async onForceReRender() {
    await Promise.all(this.storyRenders.map((pt) => pt.rerender()));
  }
  async onForceRemount({ storyId: pt }) {
    await Promise.all(this.storyRenders.filter((yt) => yt.id === pt).map((yt) => yt.remount()));
  }
  // Used by docs to render a story to a given element
  // Note this short-circuits the `prepare()` phase of the StoryRender,
  // main to be consistent with the previous behaviour. In the future,
  // we will change it to go ahead and load the story, which will end up being
  // "instant", although async.
  renderStoryToElement(pt, yt, ir, ti) {
    if (!this.renderToCanvas || !this.storyStoreValue)
      throw new Y$1({
        methodName: "renderStoryToElement"
      });
    let ii = new ce(
      this.channel,
      this.storyStoreValue,
      this.renderToCanvas,
      ir,
      pt.id,
      "docs",
      ti,
      pt
    );
    return ii.renderToElement(yt), this.storyRenders.push(ii), async () => {
      await this.teardownRender(ii);
    };
  }
  async teardownRender(pt, { viewModeChanged: yt } = {}) {
    var ir;
    this.storyRenders = this.storyRenders.filter((ti) => ti !== pt), await ((ir = pt == null ? void 0 : pt.teardown) == null ? void 0 : ir.call(pt, { viewModeChanged: yt }));
  }
  // API
  async loadStory({ storyId: pt }) {
    if (!this.storyStoreValue)
      throw new Y$1({ methodName: "loadStory" });
    return this.storyStoreValue.loadStory({ storyId: pt });
  }
  getStoryContext(pt, { forceInitialArgs: yt = !1 } = {}) {
    if (!this.storyStoreValue)
      throw new Y$1({ methodName: "getStoryContext" });
    return this.storyStoreValue.getStoryContext(pt, { forceInitialArgs: yt });
  }
  async extract(pt) {
    if (!this.storyStoreValue)
      throw new Y$1({ methodName: "extract" });
    if (this.previewEntryError)
      throw this.previewEntryError;
    return await this.storyStoreValue.cacheAllCSFFiles(), this.storyStoreValue.extract(pt);
  }
  // UTILITIES
  renderPreviewEntryError(pt, yt) {
    this.previewEntryError = yt, s$3.error(pt), s$3.error(yt), this.channel.emit(N$1, yt);
  }
};
s(rt, "Preview");
var xe = rt, tt = "Invariant failed";
function or(pt, yt) {
  if (!pt) {
    var ir = typeof yt == "function" ? yt() : yt, ti = ir ? "".concat(tt, ": ").concat(ir) : tt;
    throw new Error(ti);
  }
}
s(or, "invariant");
var ot = class {
  constructor(pt, yt, ir, ti) {
    this.channel = pt, this.store = yt, this.renderStoryToElement = ir, this.storyIdByName = /* @__PURE__ */ s((ii) => {
      let ui = this.nameToStoryId.get(ii);
      if (ui)
        return ui;
      throw new Error(`No story found with that name: ${ii}`);
    }, "storyIdByName"), this.componentStories = /* @__PURE__ */ s(() => this.componentStoriesValue, "componentStories"), this.componentStoriesFromCSFFile = /* @__PURE__ */ s((ii) => this.store.componentStoriesFromCSFFile({ csfFile: ii }), "componentStoriesFromCSFFile"), this.storyById = /* @__PURE__ */ s((ii) => {
      if (!ii) {
        if (!this.primaryStory)
          throw new Error(
            "No primary story defined for docs entry. Did you forget to use `<Meta>`?"
          );
        return this.primaryStory;
      }
      let ui = this.storyIdToCSFFile.get(ii);
      if (!ui)
        throw new Error(`Called \`storyById\` for story that was never loaded: ${ii}`);
      return this.store.storyFromCSFFile({ storyId: ii, csfFile: ui });
    }, "storyById"), this.getStoryContext = /* @__PURE__ */ s((ii) => ({
      ...this.store.getStoryContext(ii),
      loaded: {},
      viewMode: "docs"
    }), "getStoryContext"), this.loadStory = /* @__PURE__ */ s((ii) => this.store.loadStory({ storyId: ii }), "loadStory"), this.componentStoriesValue = [], this.storyIdToCSFFile = /* @__PURE__ */ new Map(), this.exportToStory = /* @__PURE__ */ new Map(), this.exportsToCSFFile = /* @__PURE__ */ new Map(), this.nameToStoryId = /* @__PURE__ */ new Map(), this.attachedCSFFiles = /* @__PURE__ */ new Set(), ti.forEach((ii, ui) => {
      this.referenceCSFFile(ii);
    });
  }
  // This docs entry references this CSF file and can synchronously load the stories, as well
  // as reference them by module export. If the CSF is part of the "component" stories, they
  // can also be referenced by name and are in the componentStories list.
  referenceCSFFile(pt) {
    this.exportsToCSFFile.set(pt.moduleExports, pt), this.exportsToCSFFile.set(pt.moduleExports.default, pt), this.store.componentStoriesFromCSFFile(
      { csfFile: pt }
    ).forEach((yt) => {
      let ir = pt.stories[yt.id];
      this.storyIdToCSFFile.set(ir.id, pt), this.exportToStory.set(ir.moduleExport, yt);
    });
  }
  attachCSFFile(pt) {
    if (!this.exportsToCSFFile.has(pt.moduleExports))
      throw new Error("Cannot attach a CSF file that has not been referenced");
    this.attachedCSFFiles.has(pt) || (this.attachedCSFFiles.add(pt), this.store.componentStoriesFromCSFFile({ csfFile: pt }).forEach((yt) => {
      this.nameToStoryId.set(yt.name, yt.id), this.componentStoriesValue.push(yt), this.primaryStory || (this.primaryStory = yt);
    }));
  }
  referenceMeta(pt, yt) {
    let ir = this.resolveModuleExport(pt);
    if (ir.type !== "meta")
      throw new Error(
        "<Meta of={} /> must reference a CSF file module export or meta export. Did you mistakenly reference your component instead of your CSF file?"
      );
    yt && this.attachCSFFile(ir.csfFile);
  }
  get projectAnnotations() {
    let { projectAnnotations: pt } = this.store;
    if (!pt)
      throw new Error("Can't get projectAnnotations from DocsContext before they are initialized");
    return pt;
  }
  resolveAttachedModuleExportType(pt) {
    if (pt === "story") {
      if (!this.primaryStory)
        throw new Error(
          "No primary story attached to this docs file, did you forget to use <Meta of={} />?"
        );
      return { type: "story", story: this.primaryStory };
    }
    if (this.attachedCSFFiles.size === 0)
      throw new Error(
        "No CSF file attached to this docs file, did you forget to use <Meta of={} />?"
      );
    let yt = Array.from(this.attachedCSFFiles)[0];
    if (pt === "meta")
      return { type: "meta", csfFile: yt };
    let { component: ir } = yt.meta;
    if (!ir)
      throw new Error(
        "Attached CSF file does not defined a component, did you forget to export one?"
      );
    return { type: "component", component: ir };
  }
  resolveModuleExport(pt) {
    let yt = this.exportsToCSFFile.get(pt);
    if (yt)
      return { type: "meta", csfFile: yt };
    let ir = this.exportToStory.get(
      K(pt) ? pt.input : pt
    );
    return ir ? { type: "story", story: ir } : { type: "component", component: pt };
  }
  resolveOf(pt, yt = []) {
    let ir;
    if (["component", "meta", "story"].includes(pt)) {
      let ti = pt;
      ir = this.resolveAttachedModuleExportType(ti);
    } else
      ir = this.resolveModuleExport(pt);
    if (yt.length && !yt.includes(ir.type)) {
      let ti = ir.type === "component" ? "component or unknown" : ir.type;
      throw new Error(P`Invalid value passed to the 'of' prop. The value was resolved to a '${ti}' type but the only types for this block are: ${yt.join(
        ", "
      )}.
        - Did you pass a component to the 'of' prop when the block only supports a story or a meta?
        - ... or vice versa?
        - Did you pass a story, CSF file or meta to the 'of' prop that is not indexed, ie. is not targeted by the 'stories' globs in the main configuration?`);
    }
    switch (ir.type) {
      case "component":
        return {
          ...ir,
          projectAnnotations: this.projectAnnotations
        };
      case "meta":
        return {
          ...ir,
          preparedMeta: this.store.preparedMetaFromCSFFile({ csfFile: ir.csfFile })
        };
      case "story":
      default:
        return ir;
    }
  }
};
s(ot, "DocsContext");
var re = ot, nt = class {
  constructor(pt, yt, ir, ti) {
    this.channel = pt, this.store = yt, this.entry = ir, this.callbacks = ti, this.type = "docs", this.subtype = "csf", this.torndown = !1, this.disableKeyListeners = !1, this.preparing = !1, this.id = ir.id;
  }
  isPreparing() {
    return this.preparing;
  }
  async prepare() {
    this.preparing = !0;
    let { entryExports: pt, csfFiles: yt = [] } = await this.store.loadEntry(this.id);
    if (this.torndown)
      throw ee;
    let { importPath: ir, title: ti } = this.entry, ii = this.store.processCSFFileWithCache(
      pt,
      ir,
      ti
    ), ui = Object.keys(ii.stories)[0];
    this.story = this.store.storyFromCSFFile({ storyId: ui, csfFile: ii }), this.csfFiles = [ii, ...yt], this.preparing = !1;
  }
  isEqual(pt) {
    return !!(this.id === pt.id && this.story && this.story === pt.story);
  }
  docsContext(pt) {
    if (!this.csfFiles)
      throw new Error("Cannot render docs before preparing");
    let yt = new re(
      this.channel,
      this.store,
      pt,
      this.csfFiles
    );
    return this.csfFiles.forEach((ir) => yt.attachCSFFile(ir)), yt;
  }
  async renderToElement(pt, yt) {
    if (!this.story || !this.csfFiles)
      throw new Error("Cannot render docs before preparing");
    let ir = this.docsContext(yt), { docs: ti } = this.story.parameters || {};
    if (!ti)
      throw new Error(
        "Cannot render a story in viewMode=docs if `@storybook/addon-docs` is not installed"
      );
    let ii = await ti.renderer(), { render: ui } = ii, ai = /* @__PURE__ */ s(async () => {
      try {
        await ui(ir, ti, pt), this.channel.emit(I$3, this.id);
      } catch (li) {
        this.callbacks.showException(li);
      }
    }, "renderDocs");
    return this.rerender = async () => ai(), this.teardownRender = async ({ viewModeChanged: li }) => {
      !li || !pt || ii.unmount(pt);
    }, ai();
  }
  async teardown({ viewModeChanged: pt } = {}) {
    var yt;
    (yt = this.teardownRender) == null || yt.call(this, { viewModeChanged: pt }), this.torndown = !0;
  }
};
s(nt, "CsfDocsRender");
var qe = nt, st = class {
  constructor(pt, yt, ir, ti) {
    this.channel = pt, this.store = yt, this.entry = ir, this.callbacks = ti, this.type = "docs", this.subtype = "mdx", this.torndown = !1, this.disableKeyListeners = !1, this.preparing = !1, this.id = ir.id;
  }
  isPreparing() {
    return this.preparing;
  }
  async prepare() {
    this.preparing = !0;
    let { entryExports: pt, csfFiles: yt = [] } = await this.store.loadEntry(this.id);
    if (this.torndown)
      throw ee;
    this.csfFiles = yt, this.exports = pt, this.preparing = !1;
  }
  isEqual(pt) {
    return !!(this.id === pt.id && this.exports && this.exports === pt.exports);
  }
  docsContext(pt) {
    if (!this.csfFiles)
      throw new Error("Cannot render docs before preparing");
    return new re(
      this.channel,
      this.store,
      pt,
      this.csfFiles
    );
  }
  async renderToElement(pt, yt) {
    if (!this.exports || !this.csfFiles || !this.store.projectAnnotations)
      throw new Error("Cannot render docs before preparing");
    let ir = this.docsContext(yt), { docs: ti } = this.store.projectAnnotations.parameters || {};
    if (!ti)
      throw new Error(
        "Cannot render a story in viewMode=docs if `@storybook/addon-docs` is not installed"
      );
    let ii = { ...ti, page: this.exports.default }, ui = await ti.renderer(), { render: ai } = ui, li = /* @__PURE__ */ s(async () => {
      try {
        await ai(ir, ii, pt), this.channel.emit(I$3, this.id);
      } catch (oi) {
        this.callbacks.showException(oi);
      }
    }, "renderDocs");
    return this.rerender = async () => li(), this.teardownRender = async ({ viewModeChanged: oi } = {}) => {
      !oi || !pt || (ui.unmount(pt), this.torndown = !0);
    }, li();
  }
  async teardown({ viewModeChanged: pt } = {}) {
    var yt;
    (yt = this.teardownRender) == null || yt.call(this, { viewModeChanged: pt }), this.torndown = !0;
  }
};
s(st, "MdxDocsRender");
var Ue = st, Ki = globalThis;
function Xi(pt) {
  let yt = pt.composedPath && pt.composedPath()[0] || pt.target;
  return /input|textarea/i.test(yt.tagName) || yt.getAttribute("contenteditable") !== null;
}
s(Xi, "focusInInput");
var Go = "attached-mdx", Ji = "unattached-mdx";
function Qi({ tags: pt }) {
  return (pt == null ? void 0 : pt.includes(Ji)) || (pt == null ? void 0 : pt.includes(Go));
}
s(Qi, "isMdxEntry");
function at(pt) {
  return pt.type === "story";
}
s(at, "isStoryRender");
function Zi(pt) {
  return pt.type === "docs";
}
s(Zi, "isDocsRender");
function ea(pt) {
  return Zi(pt) && pt.subtype === "csf";
}
s(ea, "isCsfDocsRender");
var lt = class extends xe {
  constructor(pt, yt, ir, ti) {
    super(pt, yt, void 0, !1), this.importFn = pt, this.getProjectAnnotations = yt, this.selectionStore = ir, this.view = ti, this.initialize();
  }
  setupListeners() {
    super.setupListeners(), Ki.onkeydown = this.onKeydown.bind(this), this.channel.on(p$1, this.onSetCurrentStory.bind(this)), this.channel.on(
      n,
      this.onUpdateQueryParams.bind(this)
    ), this.channel.on(t$1, this.onPreloadStories.bind(this));
  }
  async setInitialGlobals() {
    if (!this.storyStoreValue)
      throw new Y$1({ methodName: "setInitialGlobals" });
    let { globals: pt } = this.selectionStore.selectionSpecifier || {};
    pt && this.storyStoreValue.userGlobals.updateFromPersisted(pt), this.emitGlobals();
  }
  // If initialization gets as far as the story index, this function runs.
  async initializeWithStoryIndex(pt) {
    return await super.initializeWithStoryIndex(pt), this.selectSpecifiedStory();
  }
  // Use the selection specifier to choose a story, then render it
  async selectSpecifiedStory() {
    if (!this.storyStoreValue)
      throw new Y$1({
        methodName: "selectSpecifiedStory"
      });
    if (this.selectionStore.selection) {
      await this.renderSelection();
      return;
    }
    if (!this.selectionStore.selectionSpecifier) {
      this.renderMissingStory();
      return;
    }
    let { storySpecifier: pt, args: yt } = this.selectionStore.selectionSpecifier, ir = this.storyStoreValue.storyIndex.entryFromSpecifier(pt);
    if (!ir) {
      pt === "*" ? this.renderStoryLoadingException(pt, new F$1()) : this.renderStoryLoadingException(
        pt,
        new K$1({ storySpecifier: pt.toString() })
      );
      return;
    }
    let { id: ti, type: ii } = ir;
    this.selectionStore.setSelection({ storyId: ti, viewMode: ii }), this.channel.emit(b$2, this.selectionStore.selection), this.channel.emit(
      r$1,
      this.selectionStore.selection
    ), await this.renderSelection({ persistedArgs: yt });
  }
  // EVENT HANDLERS
  // This happens when a config file gets reloaded
  async onGetProjectAnnotationsChanged({
    getProjectAnnotations: pt
  }) {
    await super.onGetProjectAnnotationsChanged({ getProjectAnnotations: pt }), this.selectionStore.selection && this.renderSelection();
  }
  // This happens when a glob gets HMR-ed
  async onStoriesChanged({
    importFn: pt,
    storyIndex: yt
  }) {
    await super.onStoriesChanged({ importFn: pt, storyIndex: yt }), this.selectionStore.selection ? await this.renderSelection() : await this.selectSpecifiedStory();
  }
  onKeydown(pt) {
    if (!this.storyRenders.find((yt) => yt.disableKeyListeners) && !Xi(pt)) {
      let { altKey: yt, ctrlKey: ir, metaKey: ti, shiftKey: ii, key: ui, code: ai, keyCode: li } = pt;
      this.channel.emit(e, {
        event: { altKey: yt, ctrlKey: ir, metaKey: ti, shiftKey: ii, key: ui, code: ai, keyCode: li }
      });
    }
  }
  async onSetCurrentStory(pt) {
    this.selectionStore.setSelection({ viewMode: "story", ...pt }), await this.storeInitializationPromise, this.channel.emit(r$1, this.selectionStore.selection), this.renderSelection();
  }
  onUpdateQueryParams(pt) {
    this.selectionStore.setQueryParams(pt);
  }
  async onUpdateGlobals({ globals: pt }) {
    var yt, ir;
    let ti = this.currentRender instanceof ce && this.currentRender.story || void 0;
    super.onUpdateGlobals({ globals: pt, currentStory: ti }), (this.currentRender instanceof Ue || this.currentRender instanceof qe) && await ((ir = (yt = this.currentRender).rerender) == null ? void 0 : ir.call(yt));
  }
  async onUpdateArgs({ storyId: pt, updatedArgs: yt }) {
    super.onUpdateArgs({ storyId: pt, updatedArgs: yt });
  }
  async onPreloadStories({ ids: pt }) {
    await this.storeInitializationPromise, this.storyStoreValue && await Promise.allSettled(pt.map((yt) => {
      var ir;
      return (ir = this.storyStoreValue) == null ? void 0 : ir.loadEntry(yt);
    }));
  }
  // RENDERING
  // We can either have:
  // - a story selected in "story" viewMode,
  //     in which case we render it to the root element, OR
  // - a story selected in "docs" viewMode,
  //     in which case we render the docsPage for that story
  async renderSelection({ persistedArgs: pt } = {}) {
    var yt, ir, ti, ii;
    let { renderToCanvas: ui } = this;
    if (!this.storyStoreValue || !ui)
      throw new Y$1({ methodName: "renderSelection" });
    let { selection: ai } = this.selectionStore;
    if (!ai)
      throw new Error("Cannot call renderSelection as no selection was made");
    let { storyId: li } = ai, oi;
    try {
      oi = await this.storyStoreValue.storyIdToEntry(li);
    } catch (vi) {
      this.currentRender && await this.teardownRender(this.currentRender), this.renderStoryLoadingException(li, vi);
      return;
    }
    let si = ((yt = this.currentSelection) == null ? void 0 : yt.storyId) !== li, di = ((ir = this.currentRender) == null ? void 0 : ir.type) !== oi.type;
    oi.type === "story" ? this.view.showPreparingStory({ immediate: di }) : this.view.showPreparingDocs({ immediate: di }), (ti = this.currentRender) != null && ti.isPreparing() && await this.teardownRender(this.currentRender);
    let fi;
    oi.type === "story" ? fi = new ce(
      this.channel,
      this.storyStoreValue,
      ui,
      this.mainStoryCallbacks(li),
      li,
      "story"
    ) : Qi(oi) ? fi = new Ue(
      this.channel,
      this.storyStoreValue,
      oi,
      this.mainStoryCallbacks(li)
    ) : fi = new qe(
      this.channel,
      this.storyStoreValue,
      oi,
      this.mainStoryCallbacks(li)
    );
    let gi = this.currentSelection;
    this.currentSelection = ai;
    let mi = this.currentRender;
    this.currentRender = fi;
    try {
      await fi.prepare();
    } catch (vi) {
      mi && await this.teardownRender(mi), vi !== ee && this.renderStoryLoadingException(li, vi);
      return;
    }
    let Ti = !si && mi && !fi.isEqual(mi);
    if (pt && at(fi) && (or(!!fi.story), this.storyStoreValue.args.updateFromPersisted(fi.story, pt)), mi && !mi.torndown && !si && !Ti && !di) {
      this.currentRender = mi, this.channel.emit(j$3, li), this.view.showMain();
      return;
    }
    if (mi && await this.teardownRender(mi, { viewModeChanged: di }), gi && (si || di) && this.channel.emit(Q$1, li), at(fi)) {
      or(!!fi.story);
      let {
        parameters: vi,
        initialArgs: xi,
        argTypes: Si,
        unmappedArgs: Pi,
        initialGlobals: $i,
        userGlobals: Oi,
        storyGlobals: Di,
        globals: Mi
      } = this.storyStoreValue.getStoryContext(fi.story);
      this.channel.emit(w$2, {
        id: li,
        parameters: vi,
        initialArgs: xi,
        argTypes: Si,
        args: Pi
      }), this.channel.emit(U$3, { userGlobals: Oi, storyGlobals: Di, globals: Mi, initialGlobals: $i });
    } else {
      let { parameters: vi } = this.storyStoreValue.projectAnnotations, { initialGlobals: xi, globals: Si } = this.storyStoreValue.userGlobals;
      if (this.channel.emit(U$3, {
        globals: Si,
        initialGlobals: xi,
        storyGlobals: {},
        userGlobals: Si
      }), ea(fi) || ((ii = fi.entry.tags) == null ? void 0 : ii.includes(Go))) {
        if (!fi.csfFiles)
          throw new H$1({ storyId: li });
        ({ parameters: vi } = this.storyStoreValue.preparedMetaFromCSFFile({
          csfFile: fi.csfFiles[0]
        }));
      }
      this.channel.emit(D$2, {
        id: li,
        parameters: vi
      });
    }
    at(fi) ? (or(!!fi.story), this.storyRenders.push(fi), this.currentRender.renderToElement(
      this.view.prepareForStory(fi.story)
    )) : this.currentRender.renderToElement(
      this.view.prepareForDocs(),
      // This argument is used for docs, which is currently only compatible with HTMLElements
      this.renderStoryToElement.bind(this)
    );
  }
  async teardownRender(pt, { viewModeChanged: yt = !1 } = {}) {
    var ir;
    this.storyRenders = this.storyRenders.filter((ti) => ti !== pt), await ((ir = pt == null ? void 0 : pt.teardown) == null ? void 0 : ir.call(pt, { viewModeChanged: yt }));
  }
  // UTILITIES
  mainStoryCallbacks(pt) {
    return {
      showStoryDuringRender: /* @__PURE__ */ s(() => this.view.showStoryDuringRender(), "showStoryDuringRender"),
      showMain: /* @__PURE__ */ s(() => this.view.showMain(), "showMain"),
      showError: /* @__PURE__ */ s((yt) => this.renderError(pt, yt), "showError"),
      showException: /* @__PURE__ */ s((yt) => this.renderException(pt, yt), "showException")
    };
  }
  renderPreviewEntryError(pt, yt) {
    super.renderPreviewEntryError(pt, yt), this.view.showErrorDisplay(yt);
  }
  renderMissingStory() {
    this.view.showNoPreview(), this.channel.emit(V$3);
  }
  renderStoryLoadingException(pt, yt) {
    s$3.error(yt), this.view.showErrorDisplay(yt), this.channel.emit(V$3, pt);
  }
  // renderException is used if we fail to render the story and it is uncaught by the app layer
  renderException(pt, yt) {
    let { name: ir = "Error", message: ti = String(yt), stack: ii } = yt;
    this.channel.emit(K$3, { name: ir, message: ti, stack: ii }), this.channel.emit(B$1, { newPhase: "errored", storyId: pt }), this.view.showErrorDisplay(
      yt
    ), s$3.error(`Error rendering story '${pt}':`), s$3.error(yt);
  }
  // renderError is used by the various app layers to inform the user they have done something
  // wrong -- for instance returned the wrong thing from a story
  renderError(pt, { title: yt, description: ir }) {
    s$3.error(`Error rendering story ${yt}: ${ir}`), this.channel.emit(x$3, { title: yt, description: ir }), this.channel.emit(B$1, { newPhase: "errored", storyId: pt }), this.view.showErrorDisplay({
      message: yt,
      stack: ir
    });
  }
};
s(lt, "PreviewWithSelection");
var we = lt, Be = he(cr()), en = he(cr()), Zo = /^[a-zA-Z0-9 _-]*$/, rn = /^-?[0-9]+(\.[0-9]+)?$/, Ca = /^#([a-f0-9]{3,4}|[a-f0-9]{6}|[a-f0-9]{8})$/i, tn = /^(rgba?|hsla?)\(([0-9]{1,3}),\s?([0-9]{1,3})%?,\s?([0-9]{1,3})%?,?\s?([0-9](\.[0-9]{1,2})?)?\)$/i, ht = /* @__PURE__ */ s((pt = "", yt) => pt === null || pt === "" || !Zo.test(pt) ? !1 : yt == null || yt instanceof Date || typeof yt == "number" || typeof yt == "boolean" ? !0 : typeof yt == "string" ? Zo.test(yt) || rn.test(yt) || Ca.test(yt) || tn.test(yt) : Array.isArray(yt) ? yt.every((ir) => ht(
  pt,
  ir
)) : L(yt) ? Object.entries(yt).every(([ir, ti]) => ht(ir, ti)) : !1, "validateArgs"), Pa = {
  delimiter: ";",
  // we're parsing a single query param
  nesting: !0,
  arrayRepeat: !0,
  arrayRepeatSyntax: "bracket",
  nestingSyntax: "js",
  // objects are encoded using dot notation
  valueDeserializer(pt) {
    if (pt.startsWith("!")) {
      if (pt === "!undefined")
        return;
      if (pt === "!null")
        return null;
      if (pt === "!true")
        return !0;
      if (pt === "!false")
        return !1;
      if (pt.startsWith("!date(") && pt.endsWith(")"))
        return new Date(pt.replaceAll(" ", "+").slice(6, -1));
      if (pt.startsWith("!hex(") && pt.endsWith(")"))
        return `#${pt.slice(5, -1)}`;
      let yt = pt.slice(1).match(tn);
      if (yt)
        return pt.startsWith("!rgba") || pt.startsWith("!RGBA") ? `${yt[1]}(${yt[2]}, ${yt[3]}, ${yt[4]}, ${yt[5]})` : pt.startsWith("!hsla") || pt.startsWith(
          "!HSLA"
        ) ? `${yt[1]}(${yt[2]}, ${yt[3]}%, ${yt[4]}%, ${yt[5]})` : pt.startsWith("!rgb") || pt.startsWith("!RGB") ? `${yt[1]}(${yt[2]}, ${yt[3]}, ${yt[4]})` : `${yt[1]}(${yt[2]}, ${yt[3]}%, ${yt[4]}%)`;
    }
    return rn.test(pt) ? Number(pt) : pt;
  }
}, mt = /* @__PURE__ */ s((pt) => {
  let yt = pt.split(";").map((ir) => ir.replace("=", "~").replace(":", "="));
  return Object.entries((0, en.parse)(yt.join(";"), Pa)).reduce((ir, [ti, ii]) => ht(ti, ii) ? Object.assign(ir, { [ti]: ii }) : (n$1.warn(P`
      Omitted potentially unsafe URL args.

      More info: https://storybook.js.org/docs/writing-stories/args#setting-args-through-the-url
    `), ir), {});
}, "parseArgsParam"), { history: on, document: te } = I;
function Fa(pt) {
  let yt = (pt || "").match(/^\/story\/(.+)/);
  if (!yt)
    throw new Error(`Invalid path '${pt}',  must start with '/story/'`);
  return yt[1];
}
s(Fa, "pathToId");
var nn = /* @__PURE__ */ s(({
  selection: pt,
  extraParams: yt
}) => {
  let ir = te == null ? void 0 : te.location.search.slice(1), { path: ti, selectedKind: ii, selectedStory: ui, ...ai } = (0, Be.parse)(ir);
  return `?${(0, Be.stringify)({
    ...ai,
    ...yt,
    ...pt && { id: pt.storyId, viewMode: pt.viewMode }
  })}`;
}, "getQueryString"), Ia = /* @__PURE__ */ s((pt) => {
  if (!pt)
    return;
  let yt = nn({ selection: pt }), { hash: ir = "" } = te.location;
  te.title = pt.storyId, on.replaceState({}, "", `${te.location.pathname}${yt}${ir}`);
}, "setPath"), Oa = /* @__PURE__ */ s((pt) => pt != null && typeof pt == "object" && Array.isArray(pt) === !1, "isObject"), Ge = /* @__PURE__ */ s(
  (pt) => {
    if (pt !== void 0) {
      if (typeof pt == "string")
        return pt;
      if (Array.isArray(pt))
        return Ge(pt[0]);
      if (Oa(pt))
        return Ge(
          Object.values(pt).filter(Boolean)
        );
    }
  },
  "getFirstString"
), Da = /* @__PURE__ */ s(() => {
  if (typeof te < "u") {
    let pt = te.location.search.slice(1), yt = (0, Be.parse)(pt), ir = typeof yt.args == "string" ? mt(yt.args) : void 0, ti = typeof yt.globals == "string" ? mt(yt.globals) : void 0, ii = Ge(yt.viewMode);
    (typeof ii != "string" || !ii.match(/docs|story/)) && (ii = "story");
    let ui = Ge(yt.path), ai = ui ? Fa(ui) : Ge(yt.id);
    if (ai)
      return { storySpecifier: ai, args: ir, globals: ti, viewMode: ii };
  }
  return null;
}, "getSelectionSpecifierFromPath"), gt = class {
  constructor() {
    this.selectionSpecifier = Da();
  }
  setSelection(pt) {
    this.selection = pt, Ia(this.selection);
  }
  setQueryParams(pt) {
    let yt = nn({ extraParams: pt }), { hash: ir = "" } = te.location;
    on.replaceState({}, "", `${te.location.pathname}${yt}${ir}`);
  }
};
s(gt, "UrlStore");
var ve = gt, Mn = he(jn()), _n = he(cr()), { document: j } = I, Ln = 100, qn = /* @__PURE__ */ ((pt) => (pt.MAIN = "MAIN", pt.NOPREVIEW = "NOPREVIEW", pt.PREPARING_STORY = "PREPARING_STORY", pt.PREPARING_DOCS = "PREPARING_DOCS", pt.ERROR = "ERROR", pt))(qn || {}), wt = {
  PREPARING_STORY: "sb-show-preparing-story",
  PREPARING_DOCS: "sb-show-preparing-docs",
  MAIN: "sb-show-main",
  NOPREVIEW: "sb-show-nopreview",
  ERROR: "sb-show-errordisplay"
}, vt = {
  centered: "sb-main-centered",
  fullscreen: "sb-main-fullscreen",
  padded: "sb-main-padded"
}, Nn = new Mn.default({
  escapeXML: !0
}), At = class {
  constructor() {
    if (this.testing = !1, typeof j < "u") {
      let { __SPECIAL_TEST_PARAMETER__: pt } = (0, _n.parse)(j.location.search.slice(1));
      switch (pt) {
        case "preparing-story": {
          this.showPreparingStory(), this.testing = !0;
          break;
        }
        case "preparing-docs": {
          this.showPreparingDocs(), this.testing = !0;
          break;
        }
      }
    }
  }
  // Get ready to render a story, returning the element to render to
  prepareForStory(pt) {
    return this.showStory(), this.applyLayout(pt.parameters.layout), j.documentElement.scrollTop = 0, j.documentElement.scrollLeft = 0, this.storyRoot();
  }
  storyRoot() {
    return j.getElementById("storybook-root");
  }
  prepareForDocs() {
    return this.showMain(), this.showDocs(), this.applyLayout("fullscreen"), j.documentElement.scrollTop = 0, j.documentElement.scrollLeft = 0, this.docsRoot();
  }
  docsRoot() {
    return j.getElementById("storybook-docs");
  }
  applyLayout(pt = "padded") {
    if (pt === "none") {
      j.body.classList.remove(this.currentLayoutClass), this.currentLayoutClass = null;
      return;
    }
    this.checkIfLayoutExists(pt);
    let yt = vt[pt];
    j.body.classList.remove(this.currentLayoutClass), j.body.classList.add(yt), this.currentLayoutClass = yt;
  }
  checkIfLayoutExists(pt) {
    vt[pt] || s$3.warn(
      P`
          The desired layout: ${pt} is not a valid option.
          The possible options are: ${Object.keys(vt).join(", ")}, none.
        `
    );
  }
  showMode(pt) {
    clearTimeout(this.preparingTimeout), Object.keys(qn).forEach((yt) => {
      yt === pt ? j.body.classList.add(wt[yt]) : j.body.classList.remove(wt[yt]);
    });
  }
  showErrorDisplay({ message: pt = "", stack: yt = "" }) {
    let ir = pt, ti = yt, ii = pt.split(`
`);
    ii.length > 1 && ([ir] = ii, ti = ii.slice(1).join(`
`).replace(/^\n/, "")), j.getElementById("error-message").innerHTML = Nn.toHtml(ir), j.getElementById("error-stack").innerHTML = Nn.toHtml(ti), this.showMode("ERROR");
  }
  showNoPreview() {
    var pt, yt;
    this.testing || (this.showMode("NOPREVIEW"), (pt = this.storyRoot()) == null || pt.setAttribute("hidden", "true"), (yt = this.docsRoot()) == null || yt.setAttribute("hidden", "true"));
  }
  showPreparingStory({ immediate: pt = !1 } = {}) {
    clearTimeout(this.preparingTimeout), pt ? this.showMode("PREPARING_STORY") : this.preparingTimeout = setTimeout(
      () => this.showMode("PREPARING_STORY"),
      Ln
    );
  }
  showPreparingDocs({ immediate: pt = !1 } = {}) {
    clearTimeout(this.preparingTimeout), pt ? this.showMode("PREPARING_DOCS") : this.preparingTimeout = setTimeout(() => this.showMode("PREPARING_DOCS"), Ln);
  }
  showMain() {
    this.showMode("MAIN");
  }
  showDocs() {
    this.storyRoot().setAttribute("hidden", "true"), this.docsRoot().removeAttribute("hidden");
  }
  showStory() {
    this.docsRoot().setAttribute("hidden", "true"), this.storyRoot().removeAttribute("hidden");
  }
  showStoryDuringRender() {
    j.body.classList.add(wt.MAIN);
  }
};
s(At, "WebView");
var Ae = At, Ct = class extends we {
  constructor(pt, yt) {
    super(pt, yt, new ve(), new Ae()), this.importFn = pt, this.getProjectAnnotations = yt, I.__STORYBOOK_PREVIEW__ = this;
  }
};
s(Ct, "PreviewWeb");
var { document: fe } = I, yl = [
  "application/javascript",
  "application/ecmascript",
  "application/x-ecmascript",
  "application/x-javascript",
  "text/ecmascript",
  "text/javascript",
  "text/javascript1.0",
  "text/javascript1.1",
  "text/javascript1.2",
  "text/javascript1.3",
  "text/javascript1.4",
  "text/javascript1.5",
  "text/jscript",
  "text/livescript",
  "text/x-ecmascript",
  "text/x-javascript",
  // Support modern javascript
  "module"
], hl = "script", Un = "scripts-root";
function Sr() {
  let pt = fe.createEvent("Event");
  pt.initEvent("DOMContentLoaded", !0, !0), fe.dispatchEvent(pt);
}
s(Sr, "simulateDOMContentLoaded");
function ml(pt, yt, ir) {
  let ti = fe.createElement("script");
  ti.type = pt.type === "module" ? "module" : "text/javascript", pt.src ? (ti.onload = yt, ti.onerror = yt, ti.src = pt.src) : ti.textContent = pt.innerText, ir ? ir.appendChild(ti) : fe.head.appendChild(ti), pt.parentNode.removeChild(pt), pt.src || yt();
}
s(ml, "insertScript");
function Gn(pt, yt, ir = 0) {
  pt[ir](() => {
    ir++, ir === pt.length ? yt() : Gn(pt, yt, ir);
  });
}
s(Gn, "insertScriptsSequentially");
function Bn(pt) {
  let yt = fe.getElementById(Un);
  yt ? yt.innerHTML = "" : (yt = fe.createElement("div"), yt.id = Un, fe.body.appendChild(yt));
  let ir = Array.from(pt.querySelectorAll(hl));
  if (ir.length) {
    let ti = [];
    ir.forEach((ii) => {
      let ui = ii.getAttribute("type");
      (!ui || yl.includes(ui)) && ti.push((ai) => ml(ii, ai, yt));
    }), ti.length && Gn(ti, Sr, void 0);
  } else
    Sr();
}
s(Bn, "simulatePageLoad");
var scope = (() => {
  let pt;
  return typeof window < "u" ? pt = window : typeof globalThis < "u" ? pt = globalThis : typeof global < "u" ? pt = global : typeof self < "u" ? pt = self : pt = {}, pt;
})();
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues && (getRandomValues = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !getRandomValues))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return getRandomValues(rnds8);
}
const byteToHex = [];
for (let pt = 0; pt < 256; ++pt)
  byteToHex.push((pt + 256).toString(16).slice(1));
function unsafeStringify(pt, yt = 0) {
  return byteToHex[pt[yt + 0]] + byteToHex[pt[yt + 1]] + byteToHex[pt[yt + 2]] + byteToHex[pt[yt + 3]] + "-" + byteToHex[pt[yt + 4]] + byteToHex[pt[yt + 5]] + "-" + byteToHex[pt[yt + 6]] + byteToHex[pt[yt + 7]] + "-" + byteToHex[pt[yt + 8]] + byteToHex[pt[yt + 9]] + "-" + byteToHex[pt[yt + 10]] + byteToHex[pt[yt + 11]] + byteToHex[pt[yt + 12]] + byteToHex[pt[yt + 13]] + byteToHex[pt[yt + 14]] + byteToHex[pt[yt + 15]];
}
const randomUUID = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), native = {
  randomUUID
};
function v4(pt, yt, ir) {
  if (native.randomUUID && !pt)
    return native.randomUUID();
  pt = pt || {};
  const ti = pt.random || (pt.rng || rng)();
  return ti[6] = ti[6] & 15 | 64, ti[8] = ti[8] & 63 | 128, unsafeStringify(ti);
}
var __defProp = Object.defineProperty, __export = (pt, yt) => {
  for (var ir in yt) __defProp(pt, ir, { get: yt[ir], enumerable: !0 });
}, ADDON_ID = "storybook/actions", EVENT_ID = `${ADDON_ID}/action-event`, config$3 = { depth: 10, clearOnStoryChange: !0, limit: 50 }, findProto = (pt, yt) => {
  let ir = Object.getPrototypeOf(pt);
  return !ir || yt(ir) ? ir : findProto(ir, yt);
}, isReactSyntheticEvent = (pt) => !!(typeof pt == "object" && pt && findProto(pt, (yt) => /^Synthetic(?:Base)?Event$/.test(yt.constructor.name)) && typeof pt.persist == "function"), serializeArg = (pt) => {
  if (isReactSyntheticEvent(pt)) {
    let yt = Object.create(pt.constructor.prototype, Object.getOwnPropertyDescriptors(pt));
    yt.persist();
    let ir = Object.getOwnPropertyDescriptor(yt, "view"), ti = ir == null ? void 0 : ir.value;
    return typeof ti == "object" && (ti == null ? void 0 : ti.constructor.name) === "Window" && Object.defineProperty(yt, "view", { ...ir, value: Object.create(ti.constructor.prototype) }), yt;
  }
  return pt;
}, generateId = () => typeof crypto == "object" && typeof crypto.getRandomValues == "function" ? v4() : Date.now().toString(36) + Math.random().toString(36).substring(2);
function action(pt, yt = {}) {
  let ir = { ...config$3, ...yt }, ti = function(...ii) {
    var ui, ai;
    if (yt.implicit) {
      let mi = (ui = "__STORYBOOK_PREVIEW__" in scope ? scope.__STORYBOOK_PREVIEW__ : void 0) == null ? void 0 : ui.storyRenders.find((Ti) => Ti.phase === "playing" || Ti.phase === "rendering");
      if (mi) {
        let Ti = !((ai = globalThis == null ? void 0 : globalThis.FEATURES) != null && ai.disallowImplicitActionsInRenderV8), vi = new j$2({ phase: mi.phase, name: pt, deprecated: Ti });
        if (Ti) console.warn(vi);
        else throw vi;
      }
    }
    let li = V.getChannel(), oi = generateId(), si = 5, di = ii.map(serializeArg), fi = ii.length > 1 ? di : di[0], gi = { id: oi, count: 0, data: { name: pt, args: fi }, options: { ...ir, maxDepth: si + (ir.depth || 3), allowFunction: ir.allowFunction || !1 } };
    li.emit(EVENT_ID, gi);
  };
  return ti.isAction = !0, ti.implicit = yt.implicit, ti;
}
var preview_exports = {};
__export(preview_exports, { argsEnhancers: () => argsEnhancers, loaders: () => loaders });
var isInInitialArgs = (pt, yt) => typeof yt[pt] > "u" && !(pt in yt), inferActionsFromArgTypesRegex = (pt) => {
  let { initialArgs: yt, argTypes: ir, id: ti, parameters: { actions: ii } } = pt;
  if (!ii || ii.disable || !ii.argTypesRegex || !ir) return {};
  let ui = new RegExp(ii.argTypesRegex);
  return Object.entries(ir).filter(([ai]) => !!ui.test(ai)).reduce((ai, [li, oi]) => (isInInitialArgs(li, yt) && (ai[li] = action(li, { implicit: !0, id: ti })), ai), {});
}, addActionsFromArgTypes = (pt) => {
  let { initialArgs: yt, argTypes: ir, parameters: { actions: ti } } = pt;
  return ti != null && ti.disable || !ir ? {} : Object.entries(ir).filter(([ii, ui]) => !!ui.action).reduce((ii, [ui, ai]) => (isInInitialArgs(ui, yt) && (ii[ui] = action(typeof ai.action == "string" ? ai.action : ui)), ii), {});
}, argsEnhancers = [addActionsFromArgTypes, inferActionsFromArgTypesRegex], subscribed = !1, logActionsWhenMockCalled = (pt) => {
  let { parameters: { actions: yt } } = pt;
  if (!(yt != null && yt.disable) && !subscribed && "__STORYBOOK_TEST_ON_MOCK_CALL__" in scope && typeof scope.__STORYBOOK_TEST_ON_MOCK_CALL__ == "function") {
    let ir = scope.__STORYBOOK_TEST_ON_MOCK_CALL__;
    ir((ti, ii) => {
      let ui = ti.getMockName();
      ui !== "spy" && (!/^next\/.*::/.test(ui) || ["next/router::useRouter()", "next/navigation::useRouter()", "next/navigation::redirect", "next/cache::", "next/headers::cookies().set", "next/headers::cookies().delete", "next/headers::headers().set", "next/headers::headers().delete"].some((ai) => ui.startsWith(ai))) && action(ui)(ii);
    }), subscribed = !0;
  }
}, loaders = [logActionsWhenMockCalled];
action("console-log");
PropTypes.string.isRequired, PropTypes.string.isRequired, PropTypes.object, PropTypes.string, PropTypes.string, PropTypes.number, PropTypes.string, PropTypes.string, PropTypes.number, PropTypes.string, PropTypes.bool, PropTypes.oneOf([
  "double",
  "doubleWithText",
  "doubleWithText-square"
]), PropTypes.shape({
  vertical: PropTypes.oneOf(["top", "bottom"]),
  horizontal: PropTypes.oneOf(["left", "right"])
});
PropTypes.number, PropTypes.string.isRequired, PropTypes.string.isRequired, PropTypes.oneOf(["clsp", "clsps"]);
PropTypes.string.isRequired, PropTypes.bool, PropTypes.bool, PropTypes.object, PropTypes.string, PropTypes.string, PropTypes.string, PropTypes.oneOf(["overlay", "bottom"]), PropTypes.shape({
  title: PropTypes.object
});
PropTypes.string.isRequired, PropTypes.string, PropTypes.oneOf([
  "clsp",
  "clsps",
  "hls"
]).isRequired;
PropTypes.string, PropTypes.string, PropTypes.node, PropTypes.node, PropTypes.string, PropTypes.func, PropTypes.string, PropTypes.string, PropTypes.string;
PropTypes.bool, PropTypes.bool, PropTypes.func, PropTypes.string, PropTypes.string, PropTypes.string, PropTypes.oneOf([
  "top",
  "start",
  "bottom",
  "end"
]), PropTypes.string, PropTypes.bool, PropTypes.string, PropTypes.bool, PropTypes.string;
const DetailList = (pt) => {
  const {
    keyValuePair: yt,
    separator: ir = ":"
  } = pt, ti = (ii) => {
    const ui = Array.isArray(ii) ? ii : Object.entries(ii), ai = [];
    for (let li = 0; li < ui.length; li++) {
      const [oi, si] = ui[li], di = si ? typeof si == "string" ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { title: si, children: si }) : si : " ";
      ai.push(
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Fragment, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("dt", { children: [
            oi,
            ir
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("dd", { children: di })
        ] }, typeof oi == "string" ? `${oi}-${si}` : `entry-${li}`)
      );
    }
    return ai;
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("alc-detail-list", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("dl", { children: ti(yt) }) });
};
DetailList.propTypes = {
  /**
   * An object containing the item label as keys and the details as the value,
   * OR an array of [label, value] tuples where labels can be strings or nodes.
   * The details can either be a string or an element/node.
   */
  keyValuePair: PropTypes.oneOfType([
    PropTypes.objectOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.node])
    ),
    PropTypes.arrayOf(PropTypes.array)
  ]).isRequired,
  /**
   * An object separating the key from the value
   */
  separator: PropTypes.string
};
PropTypes.node, PropTypes.node, PropTypes.bool, PropTypes.bool, PropTypes.func, PropTypes.bool, PropTypes.arrayOf(PropTypes.shape({
  /**
   * The content that is in the step
   */
  component: PropTypes.node,
  /**
   * Name displayed under the steps progress bar
   */
  label: PropTypes.string
}));
new Logger({ name: "useClientSideSearch " });
PropTypes.func, PropTypes.string, PropTypes.object, PropTypes.string, PropTypes.func, PropTypes.bool, PropTypes.bool, PropTypes.node, PropTypes.func, PropTypes.bool, PropTypes.bool, PropTypes.string;
PropTypes.bool, PropTypes.string, PropTypes.string, PropTypes.oneOfType([PropTypes.string, PropTypes.node]), PropTypes.string, PropTypes.func, PropTypes.func, PropTypes.string;
PropTypes.shape([{ trigger: PropTypes.node, panel: PropTypes.node }]), PropTypes.string, PropTypes.string, PropTypes.string;
const SearchBar = ({ onChange: pt }) => {
  const yt = (ir) => {
    pt == null || pt(ir);
  };
  return /* @__PURE__ */ jsxRuntimeExports$1.jsx("sky-search-bar", { children: /* @__PURE__ */ jsxRuntimeExports$1.jsx(
    SearchBar$1,
    {
      handleSearch: yt,
      searchDelay: 500,
      inputBackgroundColor: "var(--vp-white)",
      children: "Search"
    }
  ) });
};
SearchBar.propTypes = {
  /**
   * Handler for input change events
   */
  onChange: PropTypes$1.func
};
const common = {
  black: "#000",
  white: "#fff"
}, red = {
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  700: "#d32f2f",
  800: "#c62828"
}, purple = {
  50: "#f3e5f5",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  700: "#7b1fa2"
}, blue = {
  50: "#e3f2fd",
  200: "#90caf9",
  400: "#42a5f5",
  700: "#1976d2",
  800: "#1565c0"
}, lightBlue = {
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  700: "#0288d1",
  900: "#01579b"
}, green = {
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20"
}, orange = {
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  700: "#f57c00",
  900: "#e65100"
}, grey = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
};
function formatMuiErrorMessage(pt, ...yt) {
  const ir = new URL(`https://mui.com/production-error/?code=${pt}`);
  return yt.forEach((ti) => ir.searchParams.append("args[]", ti)), `Minified MUI error #${pt}; visit ${ir} for the full message.`;
}
const THEME_ID = "$$material";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(pt) {
    for (var yt = 1; yt < arguments.length; yt++) {
      var ir = arguments[yt];
      for (var ti in ir) ({}).hasOwnProperty.call(ir, ti) && (pt[ti] = ir[ti]);
    }
    return pt;
  }, _extends.apply(null, arguments);
}
function sheetForTag(pt) {
  if (pt.sheet)
    return pt.sheet;
  for (var yt = 0; yt < document.styleSheets.length; yt++)
    if (document.styleSheets[yt].ownerNode === pt)
      return document.styleSheets[yt];
}
function createStyleElement(pt) {
  var yt = document.createElement("style");
  return yt.setAttribute("data-emotion", pt.key), pt.nonce !== void 0 && yt.setAttribute("nonce", pt.nonce), yt.appendChild(document.createTextNode("")), yt.setAttribute("data-s", ""), yt;
}
var StyleSheet = /* @__PURE__ */ (function() {
  function pt(ir) {
    var ti = this;
    this._insertTag = function(ii) {
      var ui;
      ti.tags.length === 0 ? ti.insertionPoint ? ui = ti.insertionPoint.nextSibling : ti.prepend ? ui = ti.container.firstChild : ui = ti.before : ui = ti.tags[ti.tags.length - 1].nextSibling, ti.container.insertBefore(ii, ui), ti.tags.push(ii);
    }, this.isSpeedy = ir.speedy === void 0 ? !0 : ir.speedy, this.tags = [], this.ctr = 0, this.nonce = ir.nonce, this.key = ir.key, this.container = ir.container, this.prepend = ir.prepend, this.insertionPoint = ir.insertionPoint, this.before = null;
  }
  var yt = pt.prototype;
  return yt.hydrate = function(ti) {
    ti.forEach(this._insertTag);
  }, yt.insert = function(ti) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(createStyleElement(this));
    var ii = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var ui = sheetForTag(ii);
      try {
        ui.insertRule(ti, ui.cssRules.length);
      } catch {
      }
    } else
      ii.appendChild(document.createTextNode(ti));
    this.ctr++;
  }, yt.flush = function() {
    this.tags.forEach(function(ti) {
      var ii;
      return (ii = ti.parentNode) == null ? void 0 : ii.removeChild(ti);
    }), this.tags = [], this.ctr = 0;
  }, pt;
})(), MS = "-ms-", MOZ = "-moz-", WEBKIT = "-webkit-", COMMENT = "comm", RULESET = "rule", DECLARATION = "decl", IMPORT = "@import", KEYFRAMES = "@keyframes", LAYER = "@layer", abs = Math.abs, from = String.fromCharCode, assign = Object.assign;
function hash(pt, yt) {
  return charat(pt, 0) ^ 45 ? (((yt << 2 ^ charat(pt, 0)) << 2 ^ charat(pt, 1)) << 2 ^ charat(pt, 2)) << 2 ^ charat(pt, 3) : 0;
}
function trim(pt) {
  return pt.trim();
}
function match(pt, yt) {
  return (pt = yt.exec(pt)) ? pt[0] : pt;
}
function replace(pt, yt, ir) {
  return pt.replace(yt, ir);
}
function indexof(pt, yt) {
  return pt.indexOf(yt);
}
function charat(pt, yt) {
  return pt.charCodeAt(yt) | 0;
}
function substr(pt, yt, ir) {
  return pt.slice(yt, ir);
}
function strlen(pt) {
  return pt.length;
}
function sizeof(pt) {
  return pt.length;
}
function append(pt, yt) {
  return yt.push(pt), pt;
}
function combine(pt, yt) {
  return pt.map(yt).join("");
}
var line = 1, column = 1, length = 0, position = 0, character = 0, characters = "";
function node(pt, yt, ir, ti, ii, ui, ai) {
  return { value: pt, root: yt, parent: ir, type: ti, props: ii, children: ui, line, column, length: ai, return: "" };
}
function copy(pt, yt) {
  return assign(node("", null, null, "", null, null, 0), pt, { length: -pt.length }, yt);
}
function char() {
  return character;
}
function prev() {
  return character = position > 0 ? charat(characters, --position) : 0, column--, character === 10 && (column = 1, line--), character;
}
function next() {
  return character = position < length ? charat(characters, position++) : 0, column++, character === 10 && (column = 1, line++), character;
}
function peek() {
  return charat(characters, position);
}
function caret() {
  return position;
}
function slice(pt, yt) {
  return substr(characters, pt, yt);
}
function token(pt) {
  switch (pt) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(pt) {
  return line = column = 1, length = strlen(characters = pt), position = 0, [];
}
function dealloc(pt) {
  return characters = "", pt;
}
function delimit(pt) {
  return trim(slice(position - 1, delimiter(pt === 91 ? pt + 2 : pt === 40 ? pt + 1 : pt)));
}
function whitespace(pt) {
  for (; (character = peek()) && character < 33; )
    next();
  return token(pt) > 2 || token(character) > 3 ? "" : " ";
}
function escaping(pt, yt) {
  for (; --yt && next() && !(character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97); )
    ;
  return slice(pt, caret() + (yt < 6 && peek() == 32 && next() == 32));
}
function delimiter(pt) {
  for (; next(); )
    switch (character) {
      // ] ) " '
      case pt:
        return position;
      // " '
      case 34:
      case 39:
        pt !== 34 && pt !== 39 && delimiter(character);
        break;
      // (
      case 40:
        pt === 41 && delimiter(pt);
        break;
      // \
      case 92:
        next();
        break;
    }
  return position;
}
function commenter(pt, yt) {
  for (; next() && pt + character !== 57; )
    if (pt + character === 84 && peek() === 47)
      break;
  return "/*" + slice(yt, position - 1) + "*" + from(pt === 47 ? pt : next());
}
function identifier(pt) {
  for (; !token(peek()); )
    next();
  return slice(pt, position);
}
function compile(pt) {
  return dealloc(parse("", null, null, null, [""], pt = alloc(pt), 0, [0], pt));
}
function parse(pt, yt, ir, ti, ii, ui, ai, li, oi) {
  for (var si = 0, di = 0, fi = ai, gi = 0, mi = 0, Ti = 0, vi = 1, xi = 1, Si = 1, Pi = 0, $i = "", Oi = ii, Di = ui, Mi = ti, Oo = $i; xi; )
    switch (Ti = Pi, Pi = next()) {
      // (
      case 40:
        if (Ti != 108 && charat(Oo, fi - 1) == 58) {
          indexof(Oo += replace(delimit(Pi), "&", "&\f"), "&\f") != -1 && (Si = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        Oo += delimit(Pi);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        Oo += whitespace(Ti);
        break;
      // \
      case 92:
        Oo += escaping(caret() - 1, 7);
        continue;
      // /
      case 47:
        switch (peek()) {
          case 42:
          case 47:
            append(comment(commenter(next(), caret()), yt, ir), oi);
            break;
          default:
            Oo += "/";
        }
        break;
      // {
      case 123 * vi:
        li[si++] = strlen(Oo) * Si;
      // } ; \0
      case 125 * vi:
      case 59:
      case 0:
        switch (Pi) {
          // \0 }
          case 0:
          case 125:
            xi = 0;
          // ;
          case 59 + di:
            Si == -1 && (Oo = replace(Oo, /\f/g, "")), mi > 0 && strlen(Oo) - fi && append(mi > 32 ? declaration(Oo + ";", ti, ir, fi - 1) : declaration(replace(Oo, " ", "") + ";", ti, ir, fi - 2), oi);
            break;
          // @ ;
          case 59:
            Oo += ";";
          // { rule/at-rule
          default:
            if (append(Mi = ruleset(Oo, yt, ir, si, di, ii, li, $i, Oi = [], Di = [], fi), ui), Pi === 123)
              if (di === 0)
                parse(Oo, yt, Mi, Mi, Oi, ui, fi, li, Di);
              else
                switch (gi === 99 && charat(Oo, 3) === 110 ? 100 : gi) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    parse(pt, Mi, Mi, ti && append(ruleset(pt, Mi, Mi, 0, 0, ii, li, $i, ii, Oi = [], fi), Di), ii, Di, fi, li, ti ? Oi : Di);
                    break;
                  default:
                    parse(Oo, Mi, Mi, Mi, [""], Di, 0, li, Di);
                }
        }
        si = di = mi = 0, vi = Si = 1, $i = Oo = "", fi = ai;
        break;
      // :
      case 58:
        fi = 1 + strlen(Oo), mi = Ti;
      default:
        if (vi < 1) {
          if (Pi == 123)
            --vi;
          else if (Pi == 125 && vi++ == 0 && prev() == 125)
            continue;
        }
        switch (Oo += from(Pi), Pi * vi) {
          // &
          case 38:
            Si = di > 0 ? 1 : (Oo += "\f", -1);
            break;
          // ,
          case 44:
            li[si++] = (strlen(Oo) - 1) * Si, Si = 1;
            break;
          // @
          case 64:
            peek() === 45 && (Oo += delimit(next())), gi = peek(), di = fi = strlen($i = Oo += identifier(caret())), Pi++;
            break;
          // -
          case 45:
            Ti === 45 && strlen(Oo) == 2 && (vi = 0);
        }
    }
  return ui;
}
function ruleset(pt, yt, ir, ti, ii, ui, ai, li, oi, si, di) {
  for (var fi = ii - 1, gi = ii === 0 ? ui : [""], mi = sizeof(gi), Ti = 0, vi = 0, xi = 0; Ti < ti; ++Ti)
    for (var Si = 0, Pi = substr(pt, fi + 1, fi = abs(vi = ai[Ti])), $i = pt; Si < mi; ++Si)
      ($i = trim(vi > 0 ? gi[Si] + " " + Pi : replace(Pi, /&\f/g, gi[Si]))) && (oi[xi++] = $i);
  return node(pt, yt, ir, ii === 0 ? RULESET : li, oi, si, di);
}
function comment(pt, yt, ir) {
  return node(pt, yt, ir, COMMENT, from(char()), substr(pt, 2, -2), 0);
}
function declaration(pt, yt, ir, ti) {
  return node(pt, yt, ir, DECLARATION, substr(pt, 0, ti), substr(pt, ti + 1, -1), ti);
}
function serialize(pt, yt) {
  for (var ir = "", ti = sizeof(pt), ii = 0; ii < ti; ii++)
    ir += yt(pt[ii], ii, pt, yt) || "";
  return ir;
}
function stringify(pt, yt, ir, ti) {
  switch (pt.type) {
    case LAYER:
      if (pt.children.length) break;
    case IMPORT:
    case DECLARATION:
      return pt.return = pt.return || pt.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return pt.return = pt.value + "{" + serialize(pt.children, ti) + "}";
    case RULESET:
      pt.value = pt.props.join(",");
  }
  return strlen(ir = serialize(pt.children, ti)) ? pt.return = pt.value + "{" + ir + "}" : "";
}
function middleware(pt) {
  var yt = sizeof(pt);
  return function(ir, ti, ii, ui) {
    for (var ai = "", li = 0; li < yt; li++)
      ai += pt[li](ir, ti, ii, ui) || "";
    return ai;
  };
}
function rulesheet(pt) {
  return function(yt) {
    yt.root || (yt = yt.return) && pt(yt);
  };
}
function memoize$1(pt) {
  var yt = /* @__PURE__ */ Object.create(null);
  return function(ir) {
    return yt[ir] === void 0 && (yt[ir] = pt(ir)), yt[ir];
  };
}
var identifierWithPointTracking = function pt(yt, ir, ti) {
  for (var ii = 0, ui = 0; ii = ui, ui = peek(), ii === 38 && ui === 12 && (ir[ti] = 1), !token(ui); )
    next();
  return slice(yt, position);
}, toRules = function pt(yt, ir) {
  var ti = -1, ii = 44;
  do
    switch (token(ii)) {
      case 0:
        ii === 38 && peek() === 12 && (ir[ti] = 1), yt[ti] += identifierWithPointTracking(position - 1, ir, ti);
        break;
      case 2:
        yt[ti] += delimit(ii);
        break;
      case 4:
        if (ii === 44) {
          yt[++ti] = peek() === 58 ? "&\f" : "", ir[ti] = yt[ti].length;
          break;
        }
      // fallthrough
      default:
        yt[ti] += from(ii);
    }
  while (ii = next());
  return yt;
}, getRules = function pt(yt, ir) {
  return dealloc(toRules(alloc(yt), ir));
}, fixedElements = /* @__PURE__ */ new WeakMap(), compat = function pt(yt) {
  if (!(yt.type !== "rule" || !yt.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  yt.length < 1)) {
    for (var ir = yt.value, ti = yt.parent, ii = yt.column === ti.column && yt.line === ti.line; ti.type !== "rule"; )
      if (ti = ti.parent, !ti) return;
    if (!(yt.props.length === 1 && ir.charCodeAt(0) !== 58 && !fixedElements.get(ti)) && !ii) {
      fixedElements.set(yt, !0);
      for (var ui = [], ai = getRules(ir, ui), li = ti.props, oi = 0, si = 0; oi < ai.length; oi++)
        for (var di = 0; di < li.length; di++, si++)
          yt.props[si] = ui[oi] ? ai[oi].replace(/&\f/g, li[di]) : li[di] + " " + ai[oi];
    }
  }
}, removeLabel = function pt(yt) {
  if (yt.type === "decl") {
    var ir = yt.value;
    // charcode for l
    ir.charCodeAt(0) === 108 && // charcode for b
    ir.charCodeAt(2) === 98 && (yt.return = "", yt.value = "");
  }
};
function prefix(pt, yt) {
  switch (hash(pt, yt)) {
    // color-adjust
    case 5103:
      return WEBKIT + "print-" + pt + pt;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + pt + pt;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + pt + MOZ + pt + MS + pt + pt;
    // flex, flex-direction
    case 6828:
    case 4268:
      return WEBKIT + pt + MS + pt + pt;
    // order
    case 6165:
      return WEBKIT + pt + MS + "flex-" + pt + pt;
    // align-items
    case 5187:
      return WEBKIT + pt + replace(pt, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + pt;
    // align-self
    case 5443:
      return WEBKIT + pt + MS + "flex-item-" + replace(pt, /flex-|-self/, "") + pt;
    // align-content
    case 4675:
      return WEBKIT + pt + MS + "flex-line-pack" + replace(pt, /align-content|flex-|-self/, "") + pt;
    // flex-shrink
    case 5548:
      return WEBKIT + pt + MS + replace(pt, "shrink", "negative") + pt;
    // flex-basis
    case 5292:
      return WEBKIT + pt + MS + replace(pt, "basis", "preferred-size") + pt;
    // flex-grow
    case 6060:
      return WEBKIT + "box-" + replace(pt, "-grow", "") + WEBKIT + pt + MS + replace(pt, "grow", "positive") + pt;
    // transition
    case 4554:
      return WEBKIT + replace(pt, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + pt;
    // cursor
    case 6187:
      return replace(replace(replace(pt, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), pt, "") + pt;
    // background, background-image
    case 5495:
    case 3959:
      return replace(pt, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    // justify-content
    case 4968:
      return replace(replace(pt, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + pt + pt;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(pt, /(.+)-inline(.+)/, WEBKIT + "$1$2") + pt;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen(pt) - 1 - yt > 6) switch (charat(pt, yt + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          if (charat(pt, yt + 4) !== 45) break;
        // (f)ill-available, (f)it-content
        case 102:
          return replace(pt, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(pt, yt + 3) == 108 ? "$3" : "$2-$3")) + pt;
        // (s)tretch
        case 115:
          return ~indexof(pt, "stretch") ? prefix(replace(pt, "stretch", "fill-available"), yt) + pt : pt;
      }
      break;
    // position: sticky
    case 4949:
      if (charat(pt, yt + 1) !== 115) break;
    // display: (flex|inline-flex)
    case 6444:
      switch (charat(pt, strlen(pt) - 3 - (~indexof(pt, "!important") && 10))) {
        // stic(k)y
        case 107:
          return replace(pt, ":", ":" + WEBKIT) + pt;
        // (inline-)?fl(e)x
        case 101:
          return replace(pt, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(pt, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + pt;
      }
      break;
    // writing-mode
    case 5936:
      switch (charat(pt, yt + 11)) {
        // vertical-l(r)
        case 114:
          return WEBKIT + pt + MS + replace(pt, /[svh]\w+-[tblr]{2}/, "tb") + pt;
        // vertical-r(l)
        case 108:
          return WEBKIT + pt + MS + replace(pt, /[svh]\w+-[tblr]{2}/, "tb-rl") + pt;
        // horizontal(-)tb
        case 45:
          return WEBKIT + pt + MS + replace(pt, /[svh]\w+-[tblr]{2}/, "lr") + pt;
      }
      return WEBKIT + pt + MS + pt + pt;
  }
  return pt;
}
var prefixer = function pt(yt, ir, ti, ii) {
  if (yt.length > -1 && !yt.return) switch (yt.type) {
    case DECLARATION:
      yt.return = prefix(yt.value, yt.length);
      break;
    case KEYFRAMES:
      return serialize([copy(yt, {
        value: replace(yt.value, "@", "@" + WEBKIT)
      })], ii);
    case RULESET:
      if (yt.length) return combine(yt.props, function(ui) {
        switch (match(ui, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ":read-only":
          case ":read-write":
            return serialize([copy(yt, {
              props: [replace(ui, /:(read-\w+)/, ":" + MOZ + "$1")]
            })], ii);
          // :placeholder
          case "::placeholder":
            return serialize([copy(yt, {
              props: [replace(ui, /:(plac\w+)/, ":" + WEBKIT + "input-$1")]
            }), copy(yt, {
              props: [replace(ui, /:(plac\w+)/, ":" + MOZ + "$1")]
            }), copy(yt, {
              props: [replace(ui, /:(plac\w+)/, MS + "input-$1")]
            })], ii);
        }
        return "";
      });
  }
}, defaultStylisPlugins = [prefixer], createCache = function pt(yt) {
  var ir = yt.key;
  if (ir === "css") {
    var ti = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(ti, function(vi) {
      var xi = vi.getAttribute("data-emotion");
      xi.indexOf(" ") !== -1 && (document.head.appendChild(vi), vi.setAttribute("data-s", ""));
    });
  }
  var ii = yt.stylisPlugins || defaultStylisPlugins, ui = {}, ai, li = [];
  ai = yt.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + ir + ' "]'),
    function(vi) {
      for (var xi = vi.getAttribute("data-emotion").split(" "), Si = 1; Si < xi.length; Si++)
        ui[xi[Si]] = !0;
      li.push(vi);
    }
  );
  var oi, si = [compat, removeLabel];
  {
    var di, fi = [stringify, rulesheet(function(vi) {
      di.insert(vi);
    })], gi = middleware(si.concat(ii, fi)), mi = function(xi) {
      return serialize(compile(xi), gi);
    };
    oi = function(xi, Si, Pi, $i) {
      di = Pi, mi(xi ? xi + "{" + Si.styles + "}" : Si.styles), $i && (Ti.inserted[Si.name] = !0);
    };
  }
  var Ti = {
    key: ir,
    sheet: new StyleSheet({
      key: ir,
      container: ai,
      nonce: yt.nonce,
      speedy: yt.speedy,
      prepend: yt.prepend,
      insertionPoint: yt.insertionPoint
    }),
    nonce: yt.nonce,
    inserted: ui,
    registered: {},
    insert: oi
  };
  return Ti.sheet.hydrate(li), Ti;
}, reactIs$1 = { exports: {} }, reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var pt = typeof Symbol == "function" && Symbol.for, yt = pt ? Symbol.for("react.element") : 60103, ir = pt ? Symbol.for("react.portal") : 60106, ti = pt ? Symbol.for("react.fragment") : 60107, ii = pt ? Symbol.for("react.strict_mode") : 60108, ui = pt ? Symbol.for("react.profiler") : 60114, ai = pt ? Symbol.for("react.provider") : 60109, li = pt ? Symbol.for("react.context") : 60110, oi = pt ? Symbol.for("react.async_mode") : 60111, si = pt ? Symbol.for("react.concurrent_mode") : 60111, di = pt ? Symbol.for("react.forward_ref") : 60112, fi = pt ? Symbol.for("react.suspense") : 60113, gi = pt ? Symbol.for("react.suspense_list") : 60120, mi = pt ? Symbol.for("react.memo") : 60115, Ti = pt ? Symbol.for("react.lazy") : 60116, vi = pt ? Symbol.for("react.block") : 60121, xi = pt ? Symbol.for("react.fundamental") : 60117, Si = pt ? Symbol.for("react.responder") : 60118, Pi = pt ? Symbol.for("react.scope") : 60119;
  function $i(Di) {
    if (typeof Di == "object" && Di !== null) {
      var Mi = Di.$$typeof;
      switch (Mi) {
        case yt:
          switch (Di = Di.type, Di) {
            case oi:
            case si:
            case ti:
            case ui:
            case ii:
            case fi:
              return Di;
            default:
              switch (Di = Di && Di.$$typeof, Di) {
                case li:
                case di:
                case Ti:
                case mi:
                case ai:
                  return Di;
                default:
                  return Mi;
              }
          }
        case ir:
          return Mi;
      }
    }
  }
  function Oi(Di) {
    return $i(Di) === si;
  }
  return reactIs_production_min.AsyncMode = oi, reactIs_production_min.ConcurrentMode = si, reactIs_production_min.ContextConsumer = li, reactIs_production_min.ContextProvider = ai, reactIs_production_min.Element = yt, reactIs_production_min.ForwardRef = di, reactIs_production_min.Fragment = ti, reactIs_production_min.Lazy = Ti, reactIs_production_min.Memo = mi, reactIs_production_min.Portal = ir, reactIs_production_min.Profiler = ui, reactIs_production_min.StrictMode = ii, reactIs_production_min.Suspense = fi, reactIs_production_min.isAsyncMode = function(Di) {
    return Oi(Di) || $i(Di) === oi;
  }, reactIs_production_min.isConcurrentMode = Oi, reactIs_production_min.isContextConsumer = function(Di) {
    return $i(Di) === li;
  }, reactIs_production_min.isContextProvider = function(Di) {
    return $i(Di) === ai;
  }, reactIs_production_min.isElement = function(Di) {
    return typeof Di == "object" && Di !== null && Di.$$typeof === yt;
  }, reactIs_production_min.isForwardRef = function(Di) {
    return $i(Di) === di;
  }, reactIs_production_min.isFragment = function(Di) {
    return $i(Di) === ti;
  }, reactIs_production_min.isLazy = function(Di) {
    return $i(Di) === Ti;
  }, reactIs_production_min.isMemo = function(Di) {
    return $i(Di) === mi;
  }, reactIs_production_min.isPortal = function(Di) {
    return $i(Di) === ir;
  }, reactIs_production_min.isProfiler = function(Di) {
    return $i(Di) === ui;
  }, reactIs_production_min.isStrictMode = function(Di) {
    return $i(Di) === ii;
  }, reactIs_production_min.isSuspense = function(Di) {
    return $i(Di) === fi;
  }, reactIs_production_min.isValidElementType = function(Di) {
    return typeof Di == "string" || typeof Di == "function" || Di === ti || Di === si || Di === ui || Di === ii || Di === fi || Di === gi || typeof Di == "object" && Di !== null && (Di.$$typeof === Ti || Di.$$typeof === mi || Di.$$typeof === ai || Di.$$typeof === li || Di.$$typeof === di || Di.$$typeof === xi || Di.$$typeof === Si || Di.$$typeof === Pi || Di.$$typeof === vi);
  }, reactIs_production_min.typeOf = $i, reactIs_production_min;
}
var reactIs_development$1 = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development$1;
function requireReactIs_development$1() {
  return hasRequiredReactIs_development$1 || (hasRequiredReactIs_development$1 = 1, process.env.NODE_ENV !== "production" && (function() {
    var pt = typeof Symbol == "function" && Symbol.for, yt = pt ? Symbol.for("react.element") : 60103, ir = pt ? Symbol.for("react.portal") : 60106, ti = pt ? Symbol.for("react.fragment") : 60107, ii = pt ? Symbol.for("react.strict_mode") : 60108, ui = pt ? Symbol.for("react.profiler") : 60114, ai = pt ? Symbol.for("react.provider") : 60109, li = pt ? Symbol.for("react.context") : 60110, oi = pt ? Symbol.for("react.async_mode") : 60111, si = pt ? Symbol.for("react.concurrent_mode") : 60111, di = pt ? Symbol.for("react.forward_ref") : 60112, fi = pt ? Symbol.for("react.suspense") : 60113, gi = pt ? Symbol.for("react.suspense_list") : 60120, mi = pt ? Symbol.for("react.memo") : 60115, Ti = pt ? Symbol.for("react.lazy") : 60116, vi = pt ? Symbol.for("react.block") : 60121, xi = pt ? Symbol.for("react.fundamental") : 60117, Si = pt ? Symbol.for("react.responder") : 60118, Pi = pt ? Symbol.for("react.scope") : 60119;
    function $i(qo) {
      return typeof qo == "string" || typeof qo == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      qo === ti || qo === si || qo === ui || qo === ii || qo === fi || qo === gi || typeof qo == "object" && qo !== null && (qo.$$typeof === Ti || qo.$$typeof === mi || qo.$$typeof === ai || qo.$$typeof === li || qo.$$typeof === di || qo.$$typeof === xi || qo.$$typeof === Si || qo.$$typeof === Pi || qo.$$typeof === vi);
    }
    function Oi(qo) {
      if (typeof qo == "object" && qo !== null) {
        var xa = qo.$$typeof;
        switch (xa) {
          case yt:
            var $a = qo.type;
            switch ($a) {
              case oi:
              case si:
              case ti:
              case ui:
              case ii:
              case fi:
                return $a;
              default:
                var ys = $a && $a.$$typeof;
                switch (ys) {
                  case li:
                  case di:
                  case Ti:
                  case mi:
                  case ai:
                    return ys;
                  default:
                    return xa;
                }
            }
          case ir:
            return xa;
        }
      }
    }
    var Di = oi, Mi = si, Oo = li, io = ai, xo = yt, fo = di, _o = ti, Li = Ti, Co = mi, Ni = ir, Yi = ui, Vo = ii, No = fi, Ui = !1;
    function jo(qo) {
      return Ui || (Ui = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), Wi(qo) || Oi(qo) === oi;
    }
    function Wi(qo) {
      return Oi(qo) === si;
    }
    function ji(qo) {
      return Oi(qo) === li;
    }
    function Hi(qo) {
      return Oi(qo) === ai;
    }
    function zo(qo) {
      return typeof qo == "object" && qo !== null && qo.$$typeof === yt;
    }
    function Lo(qo) {
      return Oi(qo) === di;
    }
    function sa(qo) {
      return Oi(qo) === ti;
    }
    function Ko(qo) {
      return Oi(qo) === Ti;
    }
    function ca(qo) {
      return Oi(qo) === mi;
    }
    function pa(qo) {
      return Oi(qo) === ir;
    }
    function ga(qo) {
      return Oi(qo) === ui;
    }
    function ia(qo) {
      return Oi(qo) === ii;
    }
    function ra(qo) {
      return Oi(qo) === fi;
    }
    reactIs_development$1.AsyncMode = Di, reactIs_development$1.ConcurrentMode = Mi, reactIs_development$1.ContextConsumer = Oo, reactIs_development$1.ContextProvider = io, reactIs_development$1.Element = xo, reactIs_development$1.ForwardRef = fo, reactIs_development$1.Fragment = _o, reactIs_development$1.Lazy = Li, reactIs_development$1.Memo = Co, reactIs_development$1.Portal = Ni, reactIs_development$1.Profiler = Yi, reactIs_development$1.StrictMode = Vo, reactIs_development$1.Suspense = No, reactIs_development$1.isAsyncMode = jo, reactIs_development$1.isConcurrentMode = Wi, reactIs_development$1.isContextConsumer = ji, reactIs_development$1.isContextProvider = Hi, reactIs_development$1.isElement = zo, reactIs_development$1.isForwardRef = Lo, reactIs_development$1.isFragment = sa, reactIs_development$1.isLazy = Ko, reactIs_development$1.isMemo = ca, reactIs_development$1.isPortal = pa, reactIs_development$1.isProfiler = ga, reactIs_development$1.isStrictMode = ia, reactIs_development$1.isSuspense = ra, reactIs_development$1.isValidElementType = $i, reactIs_development$1.typeOf = Oi;
  })()), reactIs_development$1;
}
var hasRequiredReactIs$1;
function requireReactIs$1() {
  return hasRequiredReactIs$1 || (hasRequiredReactIs$1 = 1, process.env.NODE_ENV === "production" ? reactIs$1.exports = requireReactIs_production_min() : reactIs$1.exports = requireReactIs_development$1()), reactIs$1.exports;
}
var hoistNonReactStatics_cjs, hasRequiredHoistNonReactStatics_cjs;
function requireHoistNonReactStatics_cjs() {
  if (hasRequiredHoistNonReactStatics_cjs) return hoistNonReactStatics_cjs;
  hasRequiredHoistNonReactStatics_cjs = 1;
  var pt = requireReactIs$1(), yt = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, ir = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, ti = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, ii = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, ui = {};
  ui[pt.ForwardRef] = ti, ui[pt.Memo] = ii;
  function ai(Ti) {
    return pt.isMemo(Ti) ? ii : ui[Ti.$$typeof] || yt;
  }
  var li = Object.defineProperty, oi = Object.getOwnPropertyNames, si = Object.getOwnPropertySymbols, di = Object.getOwnPropertyDescriptor, fi = Object.getPrototypeOf, gi = Object.prototype;
  function mi(Ti, vi, xi) {
    if (typeof vi != "string") {
      if (gi) {
        var Si = fi(vi);
        Si && Si !== gi && mi(Ti, Si, xi);
      }
      var Pi = oi(vi);
      si && (Pi = Pi.concat(si(vi)));
      for (var $i = ai(Ti), Oi = ai(vi), Di = 0; Di < Pi.length; ++Di) {
        var Mi = Pi[Di];
        if (!ir[Mi] && !(xi && xi[Mi]) && !(Oi && Oi[Mi]) && !($i && $i[Mi])) {
          var Oo = di(vi, Mi);
          try {
            li(Ti, Mi, Oo);
          } catch {
          }
        }
      }
    }
    return Ti;
  }
  return hoistNonReactStatics_cjs = mi, hoistNonReactStatics_cjs;
}
requireHoistNonReactStatics_cjs();
var isBrowser = !0;
function getRegisteredStyles(pt, yt, ir) {
  var ti = "";
  return ir.split(" ").forEach(function(ii) {
    pt[ii] !== void 0 ? yt.push(pt[ii] + ";") : ii && (ti += ii + " ");
  }), ti;
}
var registerStyles = function pt(yt, ir, ti) {
  var ii = yt.key + "-" + ir.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (ti === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === !1) && yt.registered[ii] === void 0 && (yt.registered[ii] = ir.styles);
}, insertStyles = function pt(yt, ir, ti) {
  registerStyles(yt, ir, ti);
  var ii = yt.key + "-" + ir.name;
  if (yt.inserted[ir.name] === void 0) {
    var ui = ir;
    do
      yt.insert(ir === ui ? "." + ii : "", ui, yt.sheet, !0), ui = ui.next;
    while (ui !== void 0);
  }
};
function murmur2(pt) {
  for (var yt = 0, ir, ti = 0, ii = pt.length; ii >= 4; ++ti, ii -= 4)
    ir = pt.charCodeAt(ti) & 255 | (pt.charCodeAt(++ti) & 255) << 8 | (pt.charCodeAt(++ti) & 255) << 16 | (pt.charCodeAt(++ti) & 255) << 24, ir = /* Math.imul(k, m): */
    (ir & 65535) * 1540483477 + ((ir >>> 16) * 59797 << 16), ir ^= /* k >>> r: */
    ir >>> 24, yt = /* Math.imul(k, m): */
    (ir & 65535) * 1540483477 + ((ir >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (yt & 65535) * 1540483477 + ((yt >>> 16) * 59797 << 16);
  switch (ii) {
    case 3:
      yt ^= (pt.charCodeAt(ti + 2) & 255) << 16;
    case 2:
      yt ^= (pt.charCodeAt(ti + 1) & 255) << 8;
    case 1:
      yt ^= pt.charCodeAt(ti) & 255, yt = /* Math.imul(h, m): */
      (yt & 65535) * 1540483477 + ((yt >>> 16) * 59797 << 16);
  }
  return yt ^= yt >>> 13, yt = /* Math.imul(h, m): */
  (yt & 65535) * 1540483477 + ((yt >>> 16) * 59797 << 16), ((yt ^ yt >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, hyphenateRegex = /[A-Z]|^ms/g, animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g, isCustomProperty = function pt(yt) {
  return yt.charCodeAt(1) === 45;
}, isProcessableValue = function pt(yt) {
  return yt != null && typeof yt != "boolean";
}, processStyleName = /* @__PURE__ */ memoize$1(function(pt) {
  return isCustomProperty(pt) ? pt : pt.replace(hyphenateRegex, "-$&").toLowerCase();
}), processStyleValue = function pt(yt, ir) {
  switch (yt) {
    case "animation":
    case "animationName":
      if (typeof ir == "string")
        return ir.replace(animationRegex, function(ti, ii, ui) {
          return cursor = {
            name: ii,
            styles: ui,
            next: cursor
          }, ii;
        });
  }
  return unitlessKeys[yt] !== 1 && !isCustomProperty(yt) && typeof ir == "number" && ir !== 0 ? ir + "px" : ir;
};
function handleInterpolation(pt, yt, ir) {
  if (ir == null)
    return "";
  var ti = ir;
  if (ti.__emotion_styles !== void 0)
    return ti;
  switch (typeof ir) {
    case "boolean":
      return "";
    case "object": {
      var ii = ir;
      if (ii.anim === 1)
        return cursor = {
          name: ii.name,
          styles: ii.styles,
          next: cursor
        }, ii.name;
      var ui = ir;
      if (ui.styles !== void 0) {
        var ai = ui.next;
        if (ai !== void 0)
          for (; ai !== void 0; )
            cursor = {
              name: ai.name,
              styles: ai.styles,
              next: cursor
            }, ai = ai.next;
        var li = ui.styles + ";";
        return li;
      }
      return createStringFromObject(pt, yt, ir);
    }
    case "function": {
      if (pt !== void 0) {
        var oi = cursor, si = ir(pt);
        return cursor = oi, handleInterpolation(pt, yt, si);
      }
      break;
    }
  }
  var di = ir;
  if (yt == null)
    return di;
  var fi = yt[di];
  return fi !== void 0 ? fi : di;
}
function createStringFromObject(pt, yt, ir) {
  var ti = "";
  if (Array.isArray(ir))
    for (var ii = 0; ii < ir.length; ii++)
      ti += handleInterpolation(pt, yt, ir[ii]) + ";";
  else
    for (var ui in ir) {
      var ai = ir[ui];
      if (typeof ai != "object") {
        var li = ai;
        yt != null && yt[li] !== void 0 ? ti += ui + "{" + yt[li] + "}" : isProcessableValue(li) && (ti += processStyleName(ui) + ":" + processStyleValue(ui, li) + ";");
      } else if (Array.isArray(ai) && typeof ai[0] == "string" && (yt == null || yt[ai[0]] === void 0))
        for (var oi = 0; oi < ai.length; oi++)
          isProcessableValue(ai[oi]) && (ti += processStyleName(ui) + ":" + processStyleValue(ui, ai[oi]) + ";");
      else {
        var si = handleInterpolation(pt, yt, ai);
        switch (ui) {
          case "animation":
          case "animationName": {
            ti += processStyleName(ui) + ":" + si + ";";
            break;
          }
          default:
            ti += ui + "{" + si + "}";
        }
      }
    }
  return ti;
}
var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g, cursor;
function serializeStyles(pt, yt, ir) {
  if (pt.length === 1 && typeof pt[0] == "object" && pt[0] !== null && pt[0].styles !== void 0)
    return pt[0];
  var ti = !0, ii = "";
  cursor = void 0;
  var ui = pt[0];
  if (ui == null || ui.raw === void 0)
    ti = !1, ii += handleInterpolation(ir, yt, ui);
  else {
    var ai = ui;
    ii += ai[0];
  }
  for (var li = 1; li < pt.length; li++)
    if (ii += handleInterpolation(ir, yt, pt[li]), ti) {
      var oi = ui;
      ii += oi[li];
    }
  labelPattern.lastIndex = 0;
  for (var si = "", di; (di = labelPattern.exec(ii)) !== null; )
    si += "-" + di[1];
  var fi = murmur2(ii) + si;
  return {
    name: fi,
    styles: ii,
    next: cursor
  };
}
var syncFallback = function pt(yt) {
  return yt();
}, useInsertionEffect = React.useInsertionEffect ? React.useInsertionEffect : !1, useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback, EmotionCacheContext = /* @__PURE__ */ React.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ createCache({
    key: "css"
  }) : null
);
EmotionCacheContext.Provider;
var withEmotionCache = function pt(yt) {
  return /* @__PURE__ */ forwardRef(function(ir, ti) {
    var ii = useContext(EmotionCacheContext);
    return yt(ir, ii, ti);
  });
}, ThemeContext = /* @__PURE__ */ React.createContext({}), hasOwn = {}.hasOwnProperty, typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", createEmotionProps = function pt(yt, ir) {
  var ti = {};
  for (var ii in ir)
    hasOwn.call(ir, ii) && (ti[ii] = ir[ii]);
  return ti[typePropName] = yt, ti;
}, Insertion$1 = function pt(yt) {
  var ir = yt.cache, ti = yt.serialized, ii = yt.isStringTag;
  return registerStyles(ir, ti, ii), useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(ir, ti, ii);
  }), null;
}, Emotion = /* @__PURE__ */ withEmotionCache(function(pt, yt, ir) {
  var ti = pt.css;
  typeof ti == "string" && yt.registered[ti] !== void 0 && (ti = yt.registered[ti]);
  var ii = pt[typePropName], ui = [ti], ai = "";
  typeof pt.className == "string" ? ai = getRegisteredStyles(yt.registered, ui, pt.className) : pt.className != null && (ai = pt.className + " ");
  var li = serializeStyles(ui, void 0, React.useContext(ThemeContext));
  ai += yt.key + "-" + li.name;
  var oi = {};
  for (var si in pt)
    hasOwn.call(pt, si) && si !== "css" && si !== typePropName && (oi[si] = pt[si]);
  return oi.className = ai, ir && (oi.ref = ir), /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Insertion$1, {
    cache: yt,
    serialized: li,
    isStringTag: typeof ii == "string"
  }), /* @__PURE__ */ React.createElement(ii, oi));
}), Emotion$1 = Emotion, jsx = function pt(yt, ir) {
  var ti = arguments;
  if (ir == null || !hasOwn.call(ir, "css"))
    return React.createElement.apply(void 0, ti);
  var ii = ti.length, ui = new Array(ii);
  ui[0] = Emotion$1, ui[1] = createEmotionProps(yt, ir);
  for (var ai = 2; ai < ii; ai++)
    ui[ai] = ti[ai];
  return React.createElement.apply(null, ui);
};
(function(pt) {
  var yt;
  yt || (yt = pt.JSX || (pt.JSX = {}));
})(jsx || (jsx = {}));
function css() {
  for (var pt = arguments.length, yt = new Array(pt), ir = 0; ir < pt; ir++)
    yt[ir] = arguments[ir];
  return serializeStyles(yt);
}
function keyframes() {
  var pt = css.apply(void 0, arguments), yt = "animation-" + pt.name;
  return {
    name: yt,
    styles: "@keyframes " + yt + "{" + pt.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, isPropValid = /* @__PURE__ */ memoize$1(
  function(pt) {
    return reactPropsRegex.test(pt) || pt.charCodeAt(0) === 111 && pt.charCodeAt(1) === 110 && pt.charCodeAt(2) < 91;
  }
  /* Z+1 */
), testOmitPropsOnStringTag = isPropValid, testOmitPropsOnComponent = function pt(yt) {
  return yt !== "theme";
}, getDefaultShouldForwardProp = function pt(yt) {
  return typeof yt == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  yt.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
}, composeShouldForwardProps = function pt(yt, ir, ti) {
  var ii;
  if (ir) {
    var ui = ir.shouldForwardProp;
    ii = yt.__emotion_forwardProp && ui ? function(ai) {
      return yt.__emotion_forwardProp(ai) && ui(ai);
    } : ui;
  }
  return typeof ii != "function" && ti && (ii = yt.__emotion_forwardProp), ii;
}, Insertion = function pt(yt) {
  var ir = yt.cache, ti = yt.serialized, ii = yt.isStringTag;
  return registerStyles(ir, ti, ii), useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(ir, ti, ii);
  }), null;
}, createStyled$1 = function pt(yt, ir) {
  var ti = yt.__emotion_real === yt, ii = ti && yt.__emotion_base || yt, ui, ai;
  ir !== void 0 && (ui = ir.label, ai = ir.target);
  var li = composeShouldForwardProps(yt, ir, ti), oi = li || getDefaultShouldForwardProp(ii), si = !oi("as");
  return function() {
    var di = arguments, fi = ti && yt.__emotion_styles !== void 0 ? yt.__emotion_styles.slice(0) : [];
    if (ui !== void 0 && fi.push("label:" + ui + ";"), di[0] == null || di[0].raw === void 0)
      fi.push.apply(fi, di);
    else {
      var gi = di[0];
      fi.push(gi[0]);
      for (var mi = di.length, Ti = 1; Ti < mi; Ti++)
        fi.push(di[Ti], gi[Ti]);
    }
    var vi = withEmotionCache(function(xi, Si, Pi) {
      var $i = si && xi.as || ii, Oi = "", Di = [], Mi = xi;
      if (xi.theme == null) {
        Mi = {};
        for (var Oo in xi)
          Mi[Oo] = xi[Oo];
        Mi.theme = React.useContext(ThemeContext);
      }
      typeof xi.className == "string" ? Oi = getRegisteredStyles(Si.registered, Di, xi.className) : xi.className != null && (Oi = xi.className + " ");
      var io = serializeStyles(fi.concat(Di), Si.registered, Mi);
      Oi += Si.key + "-" + io.name, ai !== void 0 && (Oi += " " + ai);
      var xo = si && li === void 0 ? getDefaultShouldForwardProp($i) : oi, fo = {};
      for (var _o in xi)
        si && _o === "as" || xo(_o) && (fo[_o] = xi[_o]);
      return fo.className = Oi, Pi && (fo.ref = Pi), /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Insertion, {
        cache: Si,
        serialized: io,
        isStringTag: typeof $i == "string"
      }), /* @__PURE__ */ React.createElement($i, fo));
    });
    return vi.displayName = ui !== void 0 ? ui : "Styled(" + (typeof ii == "string" ? ii : ii.displayName || ii.name || "Component") + ")", vi.defaultProps = yt.defaultProps, vi.__emotion_real = vi, vi.__emotion_base = ii, vi.__emotion_styles = fi, vi.__emotion_forwardProp = li, Object.defineProperty(vi, "toString", {
      value: function() {
        return "." + ai;
      }
    }), vi.withComponent = function(xi, Si) {
      var Pi = pt(xi, _extends({}, ir, Si, {
        shouldForwardProp: composeShouldForwardProps(vi, Si, !0)
      }));
      return Pi.apply(void 0, fi);
    }, vi;
  };
}, tags = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], styled$2 = createStyled$1.bind(null);
tags.forEach(function(pt) {
  styled$2[pt] = styled$2(pt);
});
/**
 * @mui/styled-engine v7.3.9
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function styled$1(pt, yt) {
  const ir = styled$2(pt, yt);
  return process.env.NODE_ENV !== "production" ? (...ti) => {
    const ii = typeof pt == "string" ? `"${pt}"` : "component";
    return ti.length === 0 ? console.error([`MUI: Seems like you called \`styled(${ii})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : ti.some((ui) => ui === void 0) && console.error(`MUI: the styled(${ii})(...args) API requires all its args to be defined.`), ir(...ti);
  } : ir;
}
function internal_mutateStyles(pt, yt) {
  Array.isArray(pt.__emotion_styles) && (pt.__emotion_styles = yt(pt.__emotion_styles));
}
const wrapper = [];
function internal_serializeStyles(pt) {
  return wrapper[0] = pt, serializeStyles(wrapper);
}
var reactIs = { exports: {} }, reactIs_production = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production;
function requireReactIs_production() {
  if (hasRequiredReactIs_production) return reactIs_production;
  hasRequiredReactIs_production = 1;
  var pt = Symbol.for("react.transitional.element"), yt = Symbol.for("react.portal"), ir = Symbol.for("react.fragment"), ti = Symbol.for("react.strict_mode"), ii = Symbol.for("react.profiler"), ui = Symbol.for("react.consumer"), ai = Symbol.for("react.context"), li = Symbol.for("react.forward_ref"), oi = Symbol.for("react.suspense"), si = Symbol.for("react.suspense_list"), di = Symbol.for("react.memo"), fi = Symbol.for("react.lazy"), gi = Symbol.for("react.view_transition"), mi = Symbol.for("react.client.reference");
  function Ti(vi) {
    if (typeof vi == "object" && vi !== null) {
      var xi = vi.$$typeof;
      switch (xi) {
        case pt:
          switch (vi = vi.type, vi) {
            case ir:
            case ii:
            case ti:
            case oi:
            case si:
            case gi:
              return vi;
            default:
              switch (vi = vi && vi.$$typeof, vi) {
                case ai:
                case li:
                case fi:
                case di:
                  return vi;
                case ui:
                  return vi;
                default:
                  return xi;
              }
          }
        case yt:
          return xi;
      }
    }
  }
  return reactIs_production.ContextConsumer = ui, reactIs_production.ContextProvider = ai, reactIs_production.Element = pt, reactIs_production.ForwardRef = li, reactIs_production.Fragment = ir, reactIs_production.Lazy = fi, reactIs_production.Memo = di, reactIs_production.Portal = yt, reactIs_production.Profiler = ii, reactIs_production.StrictMode = ti, reactIs_production.Suspense = oi, reactIs_production.SuspenseList = si, reactIs_production.isContextConsumer = function(vi) {
    return Ti(vi) === ui;
  }, reactIs_production.isContextProvider = function(vi) {
    return Ti(vi) === ai;
  }, reactIs_production.isElement = function(vi) {
    return typeof vi == "object" && vi !== null && vi.$$typeof === pt;
  }, reactIs_production.isForwardRef = function(vi) {
    return Ti(vi) === li;
  }, reactIs_production.isFragment = function(vi) {
    return Ti(vi) === ir;
  }, reactIs_production.isLazy = function(vi) {
    return Ti(vi) === fi;
  }, reactIs_production.isMemo = function(vi) {
    return Ti(vi) === di;
  }, reactIs_production.isPortal = function(vi) {
    return Ti(vi) === yt;
  }, reactIs_production.isProfiler = function(vi) {
    return Ti(vi) === ii;
  }, reactIs_production.isStrictMode = function(vi) {
    return Ti(vi) === ti;
  }, reactIs_production.isSuspense = function(vi) {
    return Ti(vi) === oi;
  }, reactIs_production.isSuspenseList = function(vi) {
    return Ti(vi) === si;
  }, reactIs_production.isValidElementType = function(vi) {
    return typeof vi == "string" || typeof vi == "function" || vi === ir || vi === ii || vi === ti || vi === oi || vi === si || typeof vi == "object" && vi !== null && (vi.$$typeof === fi || vi.$$typeof === di || vi.$$typeof === ai || vi.$$typeof === ui || vi.$$typeof === li || vi.$$typeof === mi || vi.getModuleId !== void 0);
  }, reactIs_production.typeOf = Ti, reactIs_production;
}
var reactIs_development = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  return hasRequiredReactIs_development || (hasRequiredReactIs_development = 1, process.env.NODE_ENV !== "production" && (function() {
    function pt(vi) {
      if (typeof vi == "object" && vi !== null) {
        var xi = vi.$$typeof;
        switch (xi) {
          case yt:
            switch (vi = vi.type, vi) {
              case ti:
              case ui:
              case ii:
              case si:
              case di:
              case mi:
                return vi;
              default:
                switch (vi = vi && vi.$$typeof, vi) {
                  case li:
                  case oi:
                  case gi:
                  case fi:
                    return vi;
                  case ai:
                    return vi;
                  default:
                    return xi;
                }
            }
          case ir:
            return xi;
        }
      }
    }
    var yt = Symbol.for("react.transitional.element"), ir = Symbol.for("react.portal"), ti = Symbol.for("react.fragment"), ii = Symbol.for("react.strict_mode"), ui = Symbol.for("react.profiler"), ai = Symbol.for("react.consumer"), li = Symbol.for("react.context"), oi = Symbol.for("react.forward_ref"), si = Symbol.for("react.suspense"), di = Symbol.for("react.suspense_list"), fi = Symbol.for("react.memo"), gi = Symbol.for("react.lazy"), mi = Symbol.for("react.view_transition"), Ti = Symbol.for("react.client.reference");
    reactIs_development.ContextConsumer = ai, reactIs_development.ContextProvider = li, reactIs_development.Element = yt, reactIs_development.ForwardRef = oi, reactIs_development.Fragment = ti, reactIs_development.Lazy = gi, reactIs_development.Memo = fi, reactIs_development.Portal = ir, reactIs_development.Profiler = ui, reactIs_development.StrictMode = ii, reactIs_development.Suspense = si, reactIs_development.SuspenseList = di, reactIs_development.isContextConsumer = function(vi) {
      return pt(vi) === ai;
    }, reactIs_development.isContextProvider = function(vi) {
      return pt(vi) === li;
    }, reactIs_development.isElement = function(vi) {
      return typeof vi == "object" && vi !== null && vi.$$typeof === yt;
    }, reactIs_development.isForwardRef = function(vi) {
      return pt(vi) === oi;
    }, reactIs_development.isFragment = function(vi) {
      return pt(vi) === ti;
    }, reactIs_development.isLazy = function(vi) {
      return pt(vi) === gi;
    }, reactIs_development.isMemo = function(vi) {
      return pt(vi) === fi;
    }, reactIs_development.isPortal = function(vi) {
      return pt(vi) === ir;
    }, reactIs_development.isProfiler = function(vi) {
      return pt(vi) === ui;
    }, reactIs_development.isStrictMode = function(vi) {
      return pt(vi) === ii;
    }, reactIs_development.isSuspense = function(vi) {
      return pt(vi) === si;
    }, reactIs_development.isSuspenseList = function(vi) {
      return pt(vi) === di;
    }, reactIs_development.isValidElementType = function(vi) {
      return typeof vi == "string" || typeof vi == "function" || vi === ti || vi === ui || vi === ii || vi === si || vi === di || typeof vi == "object" && vi !== null && (vi.$$typeof === gi || vi.$$typeof === fi || vi.$$typeof === li || vi.$$typeof === ai || vi.$$typeof === oi || vi.$$typeof === Ti || vi.getModuleId !== void 0);
    }, reactIs_development.typeOf = pt;
  })()), reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  return hasRequiredReactIs || (hasRequiredReactIs = 1, process.env.NODE_ENV === "production" ? reactIs.exports = /* @__PURE__ */ requireReactIs_production() : reactIs.exports = /* @__PURE__ */ requireReactIs_development()), reactIs.exports;
}
var reactIsExports = /* @__PURE__ */ requireReactIs();
function isPlainObject(pt) {
  if (typeof pt != "object" || pt === null)
    return !1;
  const yt = Object.getPrototypeOf(pt);
  return (yt === null || yt === Object.prototype || Object.getPrototypeOf(yt) === null) && !(Symbol.toStringTag in pt) && !(Symbol.iterator in pt);
}
function deepClone(pt) {
  if (/* @__PURE__ */ React.isValidElement(pt) || reactIsExports.isValidElementType(pt) || !isPlainObject(pt))
    return pt;
  const yt = {};
  return Object.keys(pt).forEach((ir) => {
    yt[ir] = deepClone(pt[ir]);
  }), yt;
}
function deepmerge(pt, yt, ir = {
  clone: !0
}) {
  const ti = ir.clone ? {
    ...pt
  } : pt;
  return isPlainObject(pt) && isPlainObject(yt) && Object.keys(yt).forEach((ii) => {
    /* @__PURE__ */ React.isValidElement(yt[ii]) || reactIsExports.isValidElementType(yt[ii]) ? ti[ii] = yt[ii] : isPlainObject(yt[ii]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(pt, ii) && isPlainObject(pt[ii]) ? ti[ii] = deepmerge(pt[ii], yt[ii], ir) : ir.clone ? ti[ii] = isPlainObject(yt[ii]) ? deepClone(yt[ii]) : yt[ii] : ti[ii] = yt[ii];
  }), ti;
}
const sortBreakpointsValues = (pt) => {
  const yt = Object.keys(pt).map((ir) => ({
    key: ir,
    val: pt[ir]
  })) || [];
  return yt.sort((ir, ti) => ir.val - ti.val), yt.reduce((ir, ti) => ({
    ...ir,
    [ti.key]: ti.val
  }), {});
};
function createBreakpoints(pt) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: yt = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: ir = "px",
    step: ti = 5,
    ...ii
  } = pt, ui = sortBreakpointsValues(yt), ai = Object.keys(ui);
  function li(gi) {
    return `@media (min-width:${typeof yt[gi] == "number" ? yt[gi] : gi}${ir})`;
  }
  function oi(gi) {
    return `@media (max-width:${(typeof yt[gi] == "number" ? yt[gi] : gi) - ti / 100}${ir})`;
  }
  function si(gi, mi) {
    const Ti = ai.indexOf(mi);
    return `@media (min-width:${typeof yt[gi] == "number" ? yt[gi] : gi}${ir}) and (max-width:${(Ti !== -1 && typeof yt[ai[Ti]] == "number" ? yt[ai[Ti]] : mi) - ti / 100}${ir})`;
  }
  function di(gi) {
    return ai.indexOf(gi) + 1 < ai.length ? si(gi, ai[ai.indexOf(gi) + 1]) : li(gi);
  }
  function fi(gi) {
    const mi = ai.indexOf(gi);
    return mi === 0 ? li(ai[1]) : mi === ai.length - 1 ? oi(ai[mi]) : si(gi, ai[ai.indexOf(gi) + 1]).replace("@media", "@media not all and");
  }
  return {
    keys: ai,
    values: ui,
    up: li,
    down: oi,
    between: si,
    only: di,
    not: fi,
    unit: ir,
    ...ii
  };
}
function sortContainerQueries(pt, yt) {
  if (!pt.containerQueries)
    return yt;
  const ir = Object.keys(yt).filter((ti) => ti.startsWith("@container")).sort((ti, ii) => {
    var ai, li;
    const ui = /min-width:\s*([0-9.]+)/;
    return +(((ai = ti.match(ui)) == null ? void 0 : ai[1]) || 0) - +(((li = ii.match(ui)) == null ? void 0 : li[1]) || 0);
  });
  return ir.length ? ir.reduce((ti, ii) => {
    const ui = yt[ii];
    return delete ti[ii], ti[ii] = ui, ti;
  }, {
    ...yt
  }) : yt;
}
function isCqShorthand(pt, yt) {
  return yt === "@" || yt.startsWith("@") && (pt.some((ir) => yt.startsWith(`@${ir}`)) || !!yt.match(/^@\d/));
}
function getContainerQuery(pt, yt) {
  const ir = yt.match(/^@([^/]+)?\/?(.+)?$/);
  if (!ir) {
    if (process.env.NODE_ENV !== "production")
      throw (
        /* minify-error */
        new Error(`MUI: The provided shorthand ${`(${yt})`} is invalid. The format should be \`@<breakpoint | number>\` or \`@<breakpoint | number>/<container>\`.
For example, \`@sm\` or \`@600\` or \`@40rem/sidebar\`.`)
      );
    return null;
  }
  const [, ti, ii] = ir, ui = Number.isNaN(+ti) ? ti || 0 : +ti;
  return pt.containerQueries(ii).up(ui);
}
function cssContainerQueries(pt) {
  const yt = (ui, ai) => ui.replace("@media", ai ? `@container ${ai}` : "@container");
  function ir(ui, ai) {
    ui.up = (...li) => yt(pt.breakpoints.up(...li), ai), ui.down = (...li) => yt(pt.breakpoints.down(...li), ai), ui.between = (...li) => yt(pt.breakpoints.between(...li), ai), ui.only = (...li) => yt(pt.breakpoints.only(...li), ai), ui.not = (...li) => {
      const oi = yt(pt.breakpoints.not(...li), ai);
      return oi.includes("not all and") ? oi.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or") : oi;
    };
  }
  const ti = {}, ii = (ui) => (ir(ti, ui), ti);
  return ir(ii), {
    ...pt,
    containerQueries: ii
  };
}
const shape = {
  borderRadius: 4
}, responsivePropType = process.env.NODE_ENV !== "production" ? PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.string, PropTypes$1.object, PropTypes$1.array]) : {};
function merge(pt, yt) {
  return yt ? deepmerge(pt, yt, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : pt;
}
const values$1 = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (pt) => `@media (min-width:${values$1[pt]}px)`
}, defaultContainerQueries = {
  containerQueries: (pt) => ({
    up: (yt) => {
      let ir = typeof yt == "number" ? yt : values$1[yt] || yt;
      return typeof ir == "number" && (ir = `${ir}px`), pt ? `@container ${pt} (min-width:${ir})` : `@container (min-width:${ir})`;
    }
  })
};
function handleBreakpoints(pt, yt, ir) {
  const ti = pt.theme || {};
  if (Array.isArray(yt)) {
    const ui = ti.breakpoints || defaultBreakpoints;
    return yt.reduce((ai, li, oi) => (ai[ui.up(ui.keys[oi])] = ir(yt[oi]), ai), {});
  }
  if (typeof yt == "object") {
    const ui = ti.breakpoints || defaultBreakpoints;
    return Object.keys(yt).reduce((ai, li) => {
      if (isCqShorthand(ui.keys, li)) {
        const oi = getContainerQuery(ti.containerQueries ? ti : defaultContainerQueries, li);
        oi && (ai[oi] = ir(yt[li], li));
      } else if (Object.keys(ui.values || values$1).includes(li)) {
        const oi = ui.up(li);
        ai[oi] = ir(yt[li], li);
      } else {
        const oi = li;
        ai[oi] = yt[oi];
      }
      return ai;
    }, {});
  }
  return ir(yt);
}
function createEmptyBreakpointObject(pt = {}) {
  var ir;
  return ((ir = pt.keys) == null ? void 0 : ir.reduce((ti, ii) => {
    const ui = pt.up(ii);
    return ti[ui] = {}, ti;
  }, {})) || {};
}
function removeUnusedBreakpoints(pt, yt) {
  return pt.reduce((ir, ti) => {
    const ii = ir[ti];
    return (!ii || Object.keys(ii).length === 0) && delete ir[ti], ir;
  }, yt);
}
function capitalize(pt) {
  if (typeof pt != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : formatMuiErrorMessage(7));
  return pt.charAt(0).toUpperCase() + pt.slice(1);
}
function getPath(pt, yt, ir = !0) {
  if (!yt || typeof yt != "string")
    return null;
  if (pt && pt.vars && ir) {
    const ti = `vars.${yt}`.split(".").reduce((ii, ui) => ii && ii[ui] ? ii[ui] : null, pt);
    if (ti != null)
      return ti;
  }
  return yt.split(".").reduce((ti, ii) => ti && ti[ii] != null ? ti[ii] : null, pt);
}
function getStyleValue(pt, yt, ir, ti = ir) {
  let ii;
  return typeof pt == "function" ? ii = pt(ir) : Array.isArray(pt) ? ii = pt[ir] || ti : ii = getPath(pt, ir) || ti, yt && (ii = yt(ii, ti, pt)), ii;
}
function style$1(pt) {
  const {
    prop: yt,
    cssProperty: ir = pt.prop,
    themeKey: ti,
    transform: ii
  } = pt, ui = (ai) => {
    if (ai[yt] == null)
      return null;
    const li = ai[yt], oi = ai.theme, si = getPath(oi, ti) || {};
    return handleBreakpoints(ai, li, (fi) => {
      let gi = getStyleValue(si, ii, fi);
      return fi === gi && typeof fi == "string" && (gi = getStyleValue(si, ii, `${yt}${fi === "default" ? "" : capitalize(fi)}`, fi)), ir === !1 ? gi : {
        [ir]: gi
      };
    });
  };
  return ui.propTypes = process.env.NODE_ENV !== "production" ? {
    [yt]: responsivePropType
  } : {}, ui.filterProps = [yt], ui;
}
function memoize(pt) {
  const yt = {};
  return (ir) => (yt[ir] === void 0 && (yt[ir] = pt(ir)), yt[ir]);
}
const properties = {
  m: "margin",
  p: "padding"
}, directions = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, aliases = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, getCssProperties = memoize((pt) => {
  if (pt.length > 2)
    if (aliases[pt])
      pt = aliases[pt];
    else
      return [pt];
  const [yt, ir] = pt.split(""), ti = properties[yt], ii = directions[ir] || "";
  return Array.isArray(ii) ? ii.map((ui) => ti + ui) : [ti + ii];
}), marginKeys = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], paddingKeys = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], spacingKeys = [...marginKeys, ...paddingKeys];
function createUnaryUnit(pt, yt, ir, ti) {
  const ii = getPath(pt, yt, !0) ?? ir;
  return typeof ii == "number" || typeof ii == "string" ? (ui) => typeof ui == "string" ? ui : (process.env.NODE_ENV !== "production" && typeof ui != "number" && console.error(`MUI: Expected ${ti} argument to be a number or a string, got ${ui}.`), typeof ii == "string" ? ii.startsWith("var(") && ui === 0 ? 0 : ii.startsWith("var(") && ui === 1 ? ii : `calc(${ui} * ${ii})` : ii * ui) : Array.isArray(ii) ? (ui) => {
    if (typeof ui == "string")
      return ui;
    const ai = Math.abs(ui);
    process.env.NODE_ENV !== "production" && (Number.isInteger(ai) ? ai > ii.length - 1 && console.error([`MUI: The value provided (${ai}) overflows.`, `The supported values are: ${JSON.stringify(ii)}.`, `${ai} > ${ii.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${yt}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${yt}\` as a number.`].join(`
`)));
    const li = ii[ai];
    return ui >= 0 ? li : typeof li == "number" ? -li : typeof li == "string" && li.startsWith("var(") ? `calc(-1 * ${li})` : `-${li}`;
  } : typeof ii == "function" ? ii : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${yt}\` value (${ii}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function createUnarySpacing(pt) {
  return createUnaryUnit(pt, "spacing", 8, "spacing");
}
function getValue(pt, yt) {
  return typeof yt == "string" || yt == null ? yt : pt(yt);
}
function getStyleFromPropValue(pt, yt) {
  return (ir) => pt.reduce((ti, ii) => (ti[ii] = getValue(yt, ir), ti), {});
}
function resolveCssProperty(pt, yt, ir, ti) {
  if (!yt.includes(ir))
    return null;
  const ii = getCssProperties(ir), ui = getStyleFromPropValue(ii, ti), ai = pt[ir];
  return handleBreakpoints(pt, ai, ui);
}
function style(pt, yt) {
  const ir = createUnarySpacing(pt.theme);
  return Object.keys(pt).map((ti) => resolveCssProperty(pt, yt, ti, ir)).reduce(merge, {});
}
function margin(pt) {
  return style(pt, marginKeys);
}
margin.propTypes = process.env.NODE_ENV !== "production" ? marginKeys.reduce((pt, yt) => (pt[yt] = responsivePropType, pt), {}) : {};
margin.filterProps = marginKeys;
function padding(pt) {
  return style(pt, paddingKeys);
}
padding.propTypes = process.env.NODE_ENV !== "production" ? paddingKeys.reduce((pt, yt) => (pt[yt] = responsivePropType, pt), {}) : {};
padding.filterProps = paddingKeys;
process.env.NODE_ENV !== "production" && spacingKeys.reduce((pt, yt) => (pt[yt] = responsivePropType, pt), {});
function createSpacing(pt = 8, yt = createUnarySpacing({
  spacing: pt
})) {
  if (pt.mui)
    return pt;
  const ir = (...ti) => (process.env.NODE_ENV !== "production" && (ti.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${ti.length}`)), (ti.length === 0 ? [1] : ti).map((ui) => {
    const ai = yt(ui);
    return typeof ai == "number" ? `${ai}px` : ai;
  }).join(" "));
  return ir.mui = !0, ir;
}
function compose(...pt) {
  const yt = pt.reduce((ti, ii) => (ii.filterProps.forEach((ui) => {
    ti[ui] = ii;
  }), ti), {}), ir = (ti) => Object.keys(ti).reduce((ii, ui) => yt[ui] ? merge(ii, yt[ui](ti)) : ii, {});
  return ir.propTypes = process.env.NODE_ENV !== "production" ? pt.reduce((ti, ii) => Object.assign(ti, ii.propTypes), {}) : {}, ir.filterProps = pt.reduce((ti, ii) => ti.concat(ii.filterProps), []), ir;
}
function borderTransform(pt) {
  return typeof pt != "number" ? pt : `${pt}px solid`;
}
function createBorderStyle(pt, yt) {
  return style$1({
    prop: pt,
    themeKey: "borders",
    transform: yt
  });
}
const border = createBorderStyle("border", borderTransform), borderTop = createBorderStyle("borderTop", borderTransform), borderRight = createBorderStyle("borderRight", borderTransform), borderBottom = createBorderStyle("borderBottom", borderTransform), borderLeft = createBorderStyle("borderLeft", borderTransform), borderColor = createBorderStyle("borderColor"), borderTopColor = createBorderStyle("borderTopColor"), borderRightColor = createBorderStyle("borderRightColor"), borderBottomColor = createBorderStyle("borderBottomColor"), borderLeftColor = createBorderStyle("borderLeftColor"), outline = createBorderStyle("outline", borderTransform), outlineColor = createBorderStyle("outlineColor"), borderRadius = (pt) => {
  if (pt.borderRadius !== void 0 && pt.borderRadius !== null) {
    const yt = createUnaryUnit(pt.theme, "shape.borderRadius", 4, "borderRadius"), ir = (ti) => ({
      borderRadius: getValue(yt, ti)
    });
    return handleBreakpoints(pt, pt.borderRadius, ir);
  }
  return null;
};
borderRadius.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: responsivePropType
} : {};
borderRadius.filterProps = ["borderRadius"];
compose(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius, outline, outlineColor);
const gap = (pt) => {
  if (pt.gap !== void 0 && pt.gap !== null) {
    const yt = createUnaryUnit(pt.theme, "spacing", 8, "gap"), ir = (ti) => ({
      gap: getValue(yt, ti)
    });
    return handleBreakpoints(pt, pt.gap, ir);
  }
  return null;
};
gap.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: responsivePropType
} : {};
gap.filterProps = ["gap"];
const columnGap = (pt) => {
  if (pt.columnGap !== void 0 && pt.columnGap !== null) {
    const yt = createUnaryUnit(pt.theme, "spacing", 8, "columnGap"), ir = (ti) => ({
      columnGap: getValue(yt, ti)
    });
    return handleBreakpoints(pt, pt.columnGap, ir);
  }
  return null;
};
columnGap.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: responsivePropType
} : {};
columnGap.filterProps = ["columnGap"];
const rowGap = (pt) => {
  if (pt.rowGap !== void 0 && pt.rowGap !== null) {
    const yt = createUnaryUnit(pt.theme, "spacing", 8, "rowGap"), ir = (ti) => ({
      rowGap: getValue(yt, ti)
    });
    return handleBreakpoints(pt, pt.rowGap, ir);
  }
  return null;
};
rowGap.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: responsivePropType
} : {};
rowGap.filterProps = ["rowGap"];
const gridColumn = style$1({
  prop: "gridColumn"
}), gridRow = style$1({
  prop: "gridRow"
}), gridAutoFlow = style$1({
  prop: "gridAutoFlow"
}), gridAutoColumns = style$1({
  prop: "gridAutoColumns"
}), gridAutoRows = style$1({
  prop: "gridAutoRows"
}), gridTemplateColumns = style$1({
  prop: "gridTemplateColumns"
}), gridTemplateRows = style$1({
  prop: "gridTemplateRows"
}), gridTemplateAreas = style$1({
  prop: "gridTemplateAreas"
}), gridArea = style$1({
  prop: "gridArea"
});
compose(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
function paletteTransform(pt, yt) {
  return yt === "grey" ? yt : pt;
}
const color = style$1({
  prop: "color",
  themeKey: "palette",
  transform: paletteTransform
}), bgcolor = style$1({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: paletteTransform
}), backgroundColor = style$1({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: paletteTransform
});
compose(color, bgcolor, backgroundColor);
function sizingTransform(pt) {
  return pt <= 1 && pt !== 0 ? `${pt * 100}%` : pt;
}
const width = style$1({
  prop: "width",
  transform: sizingTransform
}), maxWidth = (pt) => {
  if (pt.maxWidth !== void 0 && pt.maxWidth !== null) {
    const yt = (ir) => {
      var ii, ui, ai, li, oi;
      const ti = ((ai = (ui = (ii = pt.theme) == null ? void 0 : ii.breakpoints) == null ? void 0 : ui.values) == null ? void 0 : ai[ir]) || values$1[ir];
      return ti ? ((oi = (li = pt.theme) == null ? void 0 : li.breakpoints) == null ? void 0 : oi.unit) !== "px" ? {
        maxWidth: `${ti}${pt.theme.breakpoints.unit}`
      } : {
        maxWidth: ti
      } : {
        maxWidth: sizingTransform(ir)
      };
    };
    return handleBreakpoints(pt, pt.maxWidth, yt);
  }
  return null;
};
maxWidth.filterProps = ["maxWidth"];
const minWidth = style$1({
  prop: "minWidth",
  transform: sizingTransform
}), height = style$1({
  prop: "height",
  transform: sizingTransform
}), maxHeight = style$1({
  prop: "maxHeight",
  transform: sizingTransform
}), minHeight = style$1({
  prop: "minHeight",
  transform: sizingTransform
});
style$1({
  prop: "size",
  cssProperty: "width",
  transform: sizingTransform
});
style$1({
  prop: "size",
  cssProperty: "height",
  transform: sizingTransform
});
const boxSizing = style$1({
  prop: "boxSizing"
});
compose(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
const defaultSxConfig = {
  // borders
  border: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderTop: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderRight: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderBottom: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderLeft: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: borderTransform
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: borderRadius
  },
  // palette
  color: {
    themeKey: "palette",
    transform: paletteTransform
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: paletteTransform
  },
  backgroundColor: {
    themeKey: "palette",
    transform: paletteTransform
  },
  // spacing
  p: {
    style: padding
  },
  pt: {
    style: padding
  },
  pr: {
    style: padding
  },
  pb: {
    style: padding
  },
  pl: {
    style: padding
  },
  px: {
    style: padding
  },
  py: {
    style: padding
  },
  padding: {
    style: padding
  },
  paddingTop: {
    style: padding
  },
  paddingRight: {
    style: padding
  },
  paddingBottom: {
    style: padding
  },
  paddingLeft: {
    style: padding
  },
  paddingX: {
    style: padding
  },
  paddingY: {
    style: padding
  },
  paddingInline: {
    style: padding
  },
  paddingInlineStart: {
    style: padding
  },
  paddingInlineEnd: {
    style: padding
  },
  paddingBlock: {
    style: padding
  },
  paddingBlockStart: {
    style: padding
  },
  paddingBlockEnd: {
    style: padding
  },
  m: {
    style: margin
  },
  mt: {
    style: margin
  },
  mr: {
    style: margin
  },
  mb: {
    style: margin
  },
  ml: {
    style: margin
  },
  mx: {
    style: margin
  },
  my: {
    style: margin
  },
  margin: {
    style: margin
  },
  marginTop: {
    style: margin
  },
  marginRight: {
    style: margin
  },
  marginBottom: {
    style: margin
  },
  marginLeft: {
    style: margin
  },
  marginX: {
    style: margin
  },
  marginY: {
    style: margin
  },
  marginInline: {
    style: margin
  },
  marginInlineStart: {
    style: margin
  },
  marginInlineEnd: {
    style: margin
  },
  marginBlock: {
    style: margin
  },
  marginBlockStart: {
    style: margin
  },
  marginBlockEnd: {
    style: margin
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (pt) => ({
      "@media print": {
        display: pt
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: gap
  },
  rowGap: {
    style: rowGap
  },
  columnGap: {
    style: columnGap
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: sizingTransform
  },
  maxWidth: {
    style: maxWidth
  },
  minWidth: {
    transform: sizingTransform
  },
  height: {
    transform: sizingTransform
  },
  maxHeight: {
    transform: sizingTransform
  },
  minHeight: {
    transform: sizingTransform
  },
  boxSizing: {},
  // typography
  font: {
    themeKey: "font"
  },
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function objectsHaveSameKeys(...pt) {
  const yt = pt.reduce((ti, ii) => ti.concat(Object.keys(ii)), []), ir = new Set(yt);
  return pt.every((ti) => ir.size === Object.keys(ti).length);
}
function callIfFn(pt, yt) {
  return typeof pt == "function" ? pt(yt) : pt;
}
function unstable_createStyleFunctionSx() {
  function pt(ir, ti, ii, ui) {
    const ai = {
      [ir]: ti,
      theme: ii
    }, li = ui[ir];
    if (!li)
      return {
        [ir]: ti
      };
    const {
      cssProperty: oi = ir,
      themeKey: si,
      transform: di,
      style: fi
    } = li;
    if (ti == null)
      return null;
    if (si === "typography" && ti === "inherit")
      return {
        [ir]: ti
      };
    const gi = getPath(ii, si) || {};
    return fi ? fi(ai) : handleBreakpoints(ai, ti, (Ti) => {
      let vi = getStyleValue(gi, di, Ti);
      return Ti === vi && typeof Ti == "string" && (vi = getStyleValue(gi, di, `${ir}${Ti === "default" ? "" : capitalize(Ti)}`, Ti)), oi === !1 ? vi : {
        [oi]: vi
      };
    });
  }
  function yt(ir) {
    const {
      sx: ti,
      theme: ii = {},
      nested: ui
    } = ir || {};
    if (!ti)
      return null;
    const ai = ii.unstable_sxConfig ?? defaultSxConfig;
    function li(oi) {
      let si = oi;
      if (typeof oi == "function")
        si = oi(ii);
      else if (typeof oi != "object")
        return oi;
      if (!si)
        return null;
      const di = createEmptyBreakpointObject(ii.breakpoints), fi = Object.keys(di);
      let gi = di;
      return Object.keys(si).forEach((mi) => {
        const Ti = callIfFn(si[mi], ii);
        if (Ti != null)
          if (typeof Ti == "object")
            if (ai[mi])
              gi = merge(gi, pt(mi, Ti, ii, ai));
            else {
              const vi = handleBreakpoints({
                theme: ii
              }, Ti, (xi) => ({
                [mi]: xi
              }));
              objectsHaveSameKeys(vi, Ti) ? gi[mi] = yt({
                sx: Ti,
                theme: ii,
                nested: !0
              }) : gi = merge(gi, vi);
            }
          else
            gi = merge(gi, pt(mi, Ti, ii, ai));
      }), !ui && ii.modularCssLayers ? {
        "@layer sx": sortContainerQueries(ii, removeUnusedBreakpoints(fi, gi))
      } : sortContainerQueries(ii, removeUnusedBreakpoints(fi, gi));
    }
    return Array.isArray(ti) ? ti.map(li) : li(ti);
  }
  return yt;
}
const styleFunctionSx = unstable_createStyleFunctionSx();
styleFunctionSx.filterProps = ["sx"];
function applyStyles(pt, yt) {
  var ti;
  const ir = this;
  if (ir.vars) {
    if (!((ti = ir.colorSchemes) != null && ti[pt]) || typeof ir.getColorSchemeSelector != "function")
      return {};
    let ii = ir.getColorSchemeSelector(pt);
    return ii === "&" ? yt : ((ii.includes("data-") || ii.includes(".")) && (ii = `*:where(${ii.replace(/\s*&$/, "")}) &`), {
      [ii]: yt
    });
  }
  return ir.palette.mode === pt ? yt : {};
}
function createTheme$1(pt = {}, ...yt) {
  const {
    breakpoints: ir = {},
    palette: ti = {},
    spacing: ii,
    shape: ui = {},
    ...ai
  } = pt, li = createBreakpoints(ir), oi = createSpacing(ii);
  let si = deepmerge({
    breakpoints: li,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: {
      mode: "light",
      ...ti
    },
    spacing: oi,
    shape: {
      ...shape,
      ...ui
    }
  }, ai);
  return si = cssContainerQueries(si), si.applyStyles = applyStyles, si = yt.reduce((di, fi) => deepmerge(di, fi), si), si.unstable_sxConfig = {
    ...defaultSxConfig,
    ...ai == null ? void 0 : ai.unstable_sxConfig
  }, si.unstable_sx = function(fi) {
    return styleFunctionSx({
      sx: fi,
      theme: this
    });
  }, si;
}
function isObjectEmpty$1(pt) {
  return Object.keys(pt).length === 0;
}
function useTheme$2(pt = null) {
  const yt = React.useContext(ThemeContext);
  return !yt || isObjectEmpty$1(yt) ? pt : yt;
}
const systemDefaultTheme$1 = createTheme$1();
function useTheme$1(pt = systemDefaultTheme$1) {
  return useTheme$2(pt);
}
const defaultGenerator = (pt) => pt, createClassNameGenerator = () => {
  let pt = defaultGenerator;
  return {
    configure(yt) {
      pt = yt;
    },
    generate(yt) {
      return pt(yt);
    },
    reset() {
      pt = defaultGenerator;
    }
  };
}, ClassNameGenerator = createClassNameGenerator();
function r(pt) {
  var yt, ir, ti = "";
  if (typeof pt == "string" || typeof pt == "number") ti += pt;
  else if (typeof pt == "object") if (Array.isArray(pt)) {
    var ii = pt.length;
    for (yt = 0; yt < ii; yt++) pt[yt] && (ir = r(pt[yt])) && (ti && (ti += " "), ti += ir);
  } else for (ir in pt) pt[ir] && (ti && (ti += " "), ti += ir);
  return ti;
}
function clsx() {
  for (var pt, yt, ir = 0, ti = "", ii = arguments.length; ir < ii; ir++) (pt = arguments[ir]) && (yt = r(pt)) && (ti && (ti += " "), ti += yt);
  return ti;
}
const globalStateClasses = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function generateUtilityClass(pt, yt, ir = "Mui") {
  const ti = globalStateClasses[yt];
  return ti ? `${ir}-${ti}` : `${ClassNameGenerator.generate(pt)}-${yt}`;
}
function generateUtilityClasses(pt, yt, ir = "Mui") {
  const ti = {};
  return yt.forEach((ii) => {
    ti[ii] = generateUtilityClass(pt, ii, ir);
  }), ti;
}
function getFunctionComponentName(pt, yt = "") {
  return pt.displayName || pt.name || yt;
}
function getWrappedName(pt, yt, ir) {
  const ti = getFunctionComponentName(yt);
  return pt.displayName || (ti !== "" ? `${ir}(${ti})` : ir);
}
function getDisplayName(pt) {
  if (pt != null) {
    if (typeof pt == "string")
      return pt;
    if (typeof pt == "function")
      return getFunctionComponentName(pt, "Component");
    if (typeof pt == "object")
      switch (pt.$$typeof) {
        case reactIsExports.ForwardRef:
          return getWrappedName(pt, pt.render, "ForwardRef");
        case reactIsExports.Memo:
          return getWrappedName(pt, pt.type, "memo");
        default:
          return;
      }
  }
}
function preprocessStyles(pt) {
  const {
    variants: yt,
    ...ir
  } = pt, ti = {
    variants: yt,
    style: internal_serializeStyles(ir),
    isProcessed: !0
  };
  return ti.style === ir || yt && yt.forEach((ii) => {
    typeof ii.style != "function" && (ii.style = internal_serializeStyles(ii.style));
  }), ti;
}
const systemDefaultTheme = createTheme$1();
function shouldForwardProp(pt) {
  return pt !== "ownerState" && pt !== "theme" && pt !== "sx" && pt !== "as";
}
function shallowLayer(pt, yt) {
  return yt && pt && typeof pt == "object" && pt.styles && !pt.styles.startsWith("@layer") && (pt.styles = `@layer ${yt}{${String(pt.styles)}}`), pt;
}
function defaultOverridesResolver(pt) {
  return pt ? (yt, ir) => ir[pt] : null;
}
function attachTheme(pt, yt, ir) {
  pt.theme = isObjectEmpty(pt.theme) ? ir : pt.theme[yt] || pt.theme;
}
function processStyle(pt, yt, ir) {
  const ti = typeof yt == "function" ? yt(pt) : yt;
  if (Array.isArray(ti))
    return ti.flatMap((ii) => processStyle(pt, ii, ir));
  if (Array.isArray(ti == null ? void 0 : ti.variants)) {
    let ii;
    if (ti.isProcessed)
      ii = ir ? shallowLayer(ti.style, ir) : ti.style;
    else {
      const {
        variants: ui,
        ...ai
      } = ti;
      ii = ir ? shallowLayer(internal_serializeStyles(ai), ir) : ai;
    }
    return processStyleVariants(pt, ti.variants, [ii], ir);
  }
  return ti != null && ti.isProcessed ? ir ? shallowLayer(internal_serializeStyles(ti.style), ir) : ti.style : ir ? shallowLayer(internal_serializeStyles(ti), ir) : ti;
}
function processStyleVariants(pt, yt, ir = [], ti = void 0) {
  var ui;
  let ii;
  e: for (let ai = 0; ai < yt.length; ai += 1) {
    const li = yt[ai];
    if (typeof li.props == "function") {
      if (ii ?? (ii = {
        ...pt,
        ...pt.ownerState,
        ownerState: pt.ownerState
      }), !li.props(ii))
        continue;
    } else
      for (const oi in li.props)
        if (pt[oi] !== li.props[oi] && ((ui = pt.ownerState) == null ? void 0 : ui[oi]) !== li.props[oi])
          continue e;
    typeof li.style == "function" ? (ii ?? (ii = {
      ...pt,
      ...pt.ownerState,
      ownerState: pt.ownerState
    }), ir.push(ti ? shallowLayer(internal_serializeStyles(li.style(ii)), ti) : li.style(ii))) : ir.push(ti ? shallowLayer(internal_serializeStyles(li.style), ti) : li.style);
  }
  return ir;
}
function createStyled(pt = {}) {
  const {
    themeId: yt,
    defaultTheme: ir = systemDefaultTheme,
    rootShouldForwardProp: ti = shouldForwardProp,
    slotShouldForwardProp: ii = shouldForwardProp
  } = pt;
  function ui(li) {
    attachTheme(li, yt, ir);
  }
  return (li, oi = {}) => {
    internal_mutateStyles(li, (Mi) => Mi.filter((Oo) => Oo !== styleFunctionSx));
    const {
      name: si,
      slot: di,
      skipVariantsResolver: fi,
      skipSx: gi,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: mi = defaultOverridesResolver(lowercaseFirstLetter(di)),
      ...Ti
    } = oi, vi = si && si.startsWith("Mui") || di ? "components" : "custom", xi = fi !== void 0 ? fi : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      di && di !== "Root" && di !== "root" || !1
    ), Si = gi || !1;
    let Pi = shouldForwardProp;
    di === "Root" || di === "root" ? Pi = ti : di ? Pi = ii : isStringTag(li) && (Pi = void 0);
    const $i = styled$1(li, {
      shouldForwardProp: Pi,
      label: generateStyledLabel(si, di),
      ...Ti
    }), Oi = (Mi) => {
      if (Mi.__emotion_real === Mi)
        return Mi;
      if (typeof Mi == "function")
        return function(io) {
          return processStyle(io, Mi, io.theme.modularCssLayers ? vi : void 0);
        };
      if (isPlainObject(Mi)) {
        const Oo = preprocessStyles(Mi);
        return function(xo) {
          return Oo.variants ? processStyle(xo, Oo, xo.theme.modularCssLayers ? vi : void 0) : xo.theme.modularCssLayers ? shallowLayer(Oo.style, vi) : Oo.style;
        };
      }
      return Mi;
    }, Di = (...Mi) => {
      const Oo = [], io = Mi.map(Oi), xo = [];
      if (Oo.push(ui), si && mi && xo.push(function(Co) {
        var No, Ui;
        const Yi = (Ui = (No = Co.theme.components) == null ? void 0 : No[si]) == null ? void 0 : Ui.styleOverrides;
        if (!Yi)
          return null;
        const Vo = {};
        for (const jo in Yi)
          Vo[jo] = processStyle(Co, Yi[jo], Co.theme.modularCssLayers ? "theme" : void 0);
        return mi(Co, Vo);
      }), si && !xi && xo.push(function(Co) {
        var Vo, No;
        const Ni = Co.theme, Yi = (No = (Vo = Ni == null ? void 0 : Ni.components) == null ? void 0 : Vo[si]) == null ? void 0 : No.variants;
        return Yi ? processStyleVariants(Co, Yi, [], Co.theme.modularCssLayers ? "theme" : void 0) : null;
      }), Si || xo.push(styleFunctionSx), Array.isArray(io[0])) {
        const Li = io.shift(), Co = new Array(Oo.length).fill(""), Ni = new Array(xo.length).fill("");
        let Yi;
        Yi = [...Co, ...Li, ...Ni], Yi.raw = [...Co, ...Li.raw, ...Ni], Oo.unshift(Yi);
      }
      const fo = [...Oo, ...io, ...xo], _o = $i(...fo);
      return li.muiName && (_o.muiName = li.muiName), process.env.NODE_ENV !== "production" && (_o.displayName = generateDisplayName(si, di, li)), _o;
    };
    return $i.withConfig && (Di.withConfig = $i.withConfig), Di;
  };
}
function generateDisplayName(pt, yt, ir) {
  return pt ? `${pt}${capitalize(yt || "")}` : `Styled(${getDisplayName(ir)})`;
}
function generateStyledLabel(pt, yt) {
  let ir;
  return process.env.NODE_ENV !== "production" && pt && (ir = `${pt}-${lowercaseFirstLetter(yt || "Root")}`), ir;
}
function isObjectEmpty(pt) {
  for (const yt in pt)
    return !1;
  return !0;
}
function isStringTag(pt) {
  return typeof pt == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  pt.charCodeAt(0) > 96;
}
function lowercaseFirstLetter(pt) {
  return pt && pt.charAt(0).toLowerCase() + pt.slice(1);
}
function resolveProps(pt, yt, ir = !1) {
  const ti = {
    ...yt
  };
  for (const ii in pt)
    if (Object.prototype.hasOwnProperty.call(pt, ii)) {
      const ui = ii;
      if (ui === "components" || ui === "slots")
        ti[ui] = {
          ...pt[ui],
          ...ti[ui]
        };
      else if (ui === "componentsProps" || ui === "slotProps") {
        const ai = pt[ui], li = yt[ui];
        if (!li)
          ti[ui] = ai || {};
        else if (!ai)
          ti[ui] = li;
        else {
          ti[ui] = {
            ...li
          };
          for (const oi in ai)
            if (Object.prototype.hasOwnProperty.call(ai, oi)) {
              const si = oi;
              ti[ui][si] = resolveProps(ai[si], li[si], ir);
            }
        }
      } else ui === "className" && ir && yt.className ? ti.className = clsx(pt == null ? void 0 : pt.className, yt == null ? void 0 : yt.className) : ui === "style" && ir && yt.style ? ti.style = {
        ...pt == null ? void 0 : pt.style,
        ...yt == null ? void 0 : yt.style
      } : ti[ui] === void 0 && (ti[ui] = pt[ui]);
    }
  return ti;
}
const useEnhancedEffect = typeof window < "u" ? React.useLayoutEffect : React.useEffect;
function clamp(pt, yt = Number.MIN_SAFE_INTEGER, ir = Number.MAX_SAFE_INTEGER) {
  return Math.max(yt, Math.min(pt, ir));
}
function clampWrapper(pt, yt = 0, ir = 1) {
  return process.env.NODE_ENV !== "production" && (pt < yt || pt > ir) && console.error(`MUI: The value provided ${pt} is out of range [${yt}, ${ir}].`), clamp(pt, yt, ir);
}
function hexToRgb(pt) {
  pt = pt.slice(1);
  const yt = new RegExp(`.{1,${pt.length >= 6 ? 2 : 1}}`, "g");
  let ir = pt.match(yt);
  return ir && ir[0].length === 1 && (ir = ir.map((ti) => ti + ti)), process.env.NODE_ENV !== "production" && pt.length !== pt.trim().length && console.error(`MUI: The color: "${pt}" is invalid. Make sure the color input doesn't contain leading/trailing space.`), ir ? `rgb${ir.length === 4 ? "a" : ""}(${ir.map((ti, ii) => ii < 3 ? parseInt(ti, 16) : Math.round(parseInt(ti, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function decomposeColor(pt) {
  if (pt.type)
    return pt;
  if (pt.charAt(0) === "#")
    return decomposeColor(hexToRgb(pt));
  const yt = pt.indexOf("("), ir = pt.substring(0, yt);
  if (!["rgb", "rgba", "hsl", "hsla", "color"].includes(ir))
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${pt}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : formatMuiErrorMessage(9, pt));
  let ti = pt.substring(yt + 1, pt.length - 1), ii;
  if (ir === "color") {
    if (ti = ti.split(" "), ii = ti.shift(), ti.length === 4 && ti[3].charAt(0) === "/" && (ti[3] = ti[3].slice(1)), !["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].includes(ii))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${ii}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : formatMuiErrorMessage(10, ii));
  } else
    ti = ti.split(",");
  return ti = ti.map((ui) => parseFloat(ui)), {
    type: ir,
    values: ti,
    colorSpace: ii
  };
}
const colorChannel = (pt) => {
  const yt = decomposeColor(pt);
  return yt.values.slice(0, 3).map((ir, ti) => yt.type.includes("hsl") && ti !== 0 ? `${ir}%` : ir).join(" ");
}, private_safeColorChannel = (pt, yt) => {
  try {
    return colorChannel(pt);
  } catch {
    return yt && process.env.NODE_ENV !== "production" && console.warn(yt), pt;
  }
};
function recomposeColor(pt) {
  const {
    type: yt,
    colorSpace: ir
  } = pt;
  let {
    values: ti
  } = pt;
  return yt.includes("rgb") ? ti = ti.map((ii, ui) => ui < 3 ? parseInt(ii, 10) : ii) : yt.includes("hsl") && (ti[1] = `${ti[1]}%`, ti[2] = `${ti[2]}%`), yt.includes("color") ? ti = `${ir} ${ti.join(" ")}` : ti = `${ti.join(", ")}`, `${yt}(${ti})`;
}
function hslToRgb(pt) {
  pt = decomposeColor(pt);
  const {
    values: yt
  } = pt, ir = yt[0], ti = yt[1] / 100, ii = yt[2] / 100, ui = ti * Math.min(ii, 1 - ii), ai = (si, di = (si + ir / 30) % 12) => ii - ui * Math.max(Math.min(di - 3, 9 - di, 1), -1);
  let li = "rgb";
  const oi = [Math.round(ai(0) * 255), Math.round(ai(8) * 255), Math.round(ai(4) * 255)];
  return pt.type === "hsla" && (li += "a", oi.push(yt[3])), recomposeColor({
    type: li,
    values: oi
  });
}
function getLuminance(pt) {
  pt = decomposeColor(pt);
  let yt = pt.type === "hsl" || pt.type === "hsla" ? decomposeColor(hslToRgb(pt)).values : pt.values;
  return yt = yt.map((ir) => (pt.type !== "color" && (ir /= 255), ir <= 0.03928 ? ir / 12.92 : ((ir + 0.055) / 1.055) ** 2.4)), Number((0.2126 * yt[0] + 0.7152 * yt[1] + 0.0722 * yt[2]).toFixed(3));
}
function getContrastRatio(pt, yt) {
  const ir = getLuminance(pt), ti = getLuminance(yt);
  return (Math.max(ir, ti) + 0.05) / (Math.min(ir, ti) + 0.05);
}
function alpha(pt, yt) {
  return pt = decomposeColor(pt), yt = clampWrapper(yt), (pt.type === "rgb" || pt.type === "hsl") && (pt.type += "a"), pt.type === "color" ? pt.values[3] = `/${yt}` : pt.values[3] = yt, recomposeColor(pt);
}
function private_safeAlpha(pt, yt, ir) {
  try {
    return alpha(pt, yt);
  } catch {
    return ir && process.env.NODE_ENV !== "production" && console.warn(ir), pt;
  }
}
function darken(pt, yt) {
  if (pt = decomposeColor(pt), yt = clampWrapper(yt), pt.type.includes("hsl"))
    pt.values[2] *= 1 - yt;
  else if (pt.type.includes("rgb") || pt.type.includes("color"))
    for (let ir = 0; ir < 3; ir += 1)
      pt.values[ir] *= 1 - yt;
  return recomposeColor(pt);
}
function private_safeDarken(pt, yt, ir) {
  try {
    return darken(pt, yt);
  } catch {
    return ir && process.env.NODE_ENV !== "production" && console.warn(ir), pt;
  }
}
function lighten(pt, yt) {
  if (pt = decomposeColor(pt), yt = clampWrapper(yt), pt.type.includes("hsl"))
    pt.values[2] += (100 - pt.values[2]) * yt;
  else if (pt.type.includes("rgb"))
    for (let ir = 0; ir < 3; ir += 1)
      pt.values[ir] += (255 - pt.values[ir]) * yt;
  else if (pt.type.includes("color"))
    for (let ir = 0; ir < 3; ir += 1)
      pt.values[ir] += (1 - pt.values[ir]) * yt;
  return recomposeColor(pt);
}
function private_safeLighten(pt, yt, ir) {
  try {
    return lighten(pt, yt);
  } catch {
    return ir && process.env.NODE_ENV !== "production" && console.warn(ir), pt;
  }
}
function emphasize(pt, yt = 0.15) {
  return getLuminance(pt) > 0.5 ? darken(pt, yt) : lighten(pt, yt);
}
function private_safeEmphasize(pt, yt, ir) {
  try {
    return emphasize(pt, yt);
  } catch {
    return pt;
  }
}
const specialProperty = "exact-prop: ​";
function exactProp(pt) {
  return process.env.NODE_ENV === "production" ? pt : {
    ...pt,
    [specialProperty]: (yt) => {
      const ir = Object.keys(yt).filter((ti) => !pt.hasOwnProperty(ti));
      return ir.length > 0 ? new Error(`The following props are not supported: ${ir.map((ti) => `\`${ti}\``).join(", ")}. Please remove them.`) : null;
    }
  };
}
const RtlContext = /* @__PURE__ */ React.createContext();
process.env.NODE_ENV !== "production" && (PropTypes$1.node, PropTypes$1.bool);
const useRtl = () => React.useContext(RtlContext) ?? !1, PropsContext = /* @__PURE__ */ React.createContext(void 0);
process.env.NODE_ENV !== "production" && (PropTypes$1.node, PropTypes$1.object);
function getThemeProps(pt) {
  const {
    theme: yt,
    name: ir,
    props: ti
  } = pt;
  if (!yt || !yt.components || !yt.components[ir])
    return ti;
  const ii = yt.components[ir];
  return ii.defaultProps ? resolveProps(ii.defaultProps, ti, yt.components.mergeClassNameAndStyle) : !ii.styleOverrides && !ii.variants ? resolveProps(ii, ti, yt.components.mergeClassNameAndStyle) : ti;
}
function useDefaultProps$1({
  props: pt,
  name: yt
}) {
  const ir = React.useContext(PropsContext);
  return getThemeProps({
    props: pt,
    name: yt,
    theme: {
      components: ir
    }
  });
}
const arg = {
  theme: void 0
};
function unstable_memoTheme(pt) {
  let yt, ir;
  return function(ii) {
    let ui = yt;
    return (ui === void 0 || ii.theme !== ir) && (arg.theme = ii.theme, ui = preprocessStyles(pt(arg)), yt = ui, ir = ii.theme), ui;
  };
}
function createGetCssVar$1(pt = "") {
  function yt(...ti) {
    if (!ti.length)
      return "";
    const ii = ti[0];
    return typeof ii == "string" && !ii.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/) ? `, var(--${pt ? `${pt}-` : ""}${ii}${yt(...ti.slice(1))})` : `, ${ii}`;
  }
  return (ti, ...ii) => `var(--${pt ? `${pt}-` : ""}${ti}${yt(...ii)})`;
}
const assignNestedKeys = (pt, yt, ir, ti = []) => {
  let ii = pt;
  yt.forEach((ui, ai) => {
    ai === yt.length - 1 ? Array.isArray(ii) ? ii[Number(ui)] = ir : ii && typeof ii == "object" && (ii[ui] = ir) : ii && typeof ii == "object" && (ii[ui] || (ii[ui] = ti.includes(ui) ? [] : {}), ii = ii[ui]);
  });
}, walkObjectDeep = (pt, yt, ir) => {
  function ti(ii, ui = [], ai = []) {
    Object.entries(ii).forEach(([li, oi]) => {
      (!ir || ir && !ir([...ui, li])) && oi != null && (typeof oi == "object" && Object.keys(oi).length > 0 ? ti(oi, [...ui, li], Array.isArray(oi) ? [...ai, li] : ai) : yt([...ui, li], oi, ai));
    });
  }
  ti(pt);
}, getCssValue = (pt, yt) => typeof yt == "number" ? ["lineHeight", "fontWeight", "opacity", "zIndex"].some((ti) => pt.includes(ti)) || pt[pt.length - 1].toLowerCase().includes("opacity") ? yt : `${yt}px` : yt;
function cssVarsParser(pt, yt) {
  const {
    prefix: ir,
    shouldSkipGeneratingVar: ti
  } = yt || {}, ii = {}, ui = {}, ai = {};
  return walkObjectDeep(
    pt,
    (li, oi, si) => {
      if ((typeof oi == "string" || typeof oi == "number") && (!ti || !ti(li, oi))) {
        const di = `--${ir ? `${ir}-` : ""}${li.join("-")}`, fi = getCssValue(li, oi);
        Object.assign(ii, {
          [di]: fi
        }), assignNestedKeys(ui, li, `var(${di})`, si), assignNestedKeys(ai, li, `var(${di}, ${fi})`, si);
      }
    },
    (li) => li[0] === "vars"
    // skip 'vars/*' paths
  ), {
    css: ii,
    vars: ui,
    varsWithDefaults: ai
  };
}
function prepareCssVars(pt, yt = {}) {
  const {
    getSelector: ir = Si,
    disableCssColorScheme: ti,
    colorSchemeSelector: ii,
    enableContrastVars: ui
  } = yt, {
    colorSchemes: ai = {},
    components: li,
    defaultColorScheme: oi = "light",
    ...si
  } = pt, {
    vars: di,
    css: fi,
    varsWithDefaults: gi
  } = cssVarsParser(si, yt);
  let mi = gi;
  const Ti = {}, {
    [oi]: vi,
    ...xi
  } = ai;
  if (Object.entries(xi || {}).forEach(([Oi, Di]) => {
    const {
      vars: Mi,
      css: Oo,
      varsWithDefaults: io
    } = cssVarsParser(Di, yt);
    mi = deepmerge(mi, io), Ti[Oi] = {
      css: Oo,
      vars: Mi
    };
  }), vi) {
    const {
      css: Oi,
      vars: Di,
      varsWithDefaults: Mi
    } = cssVarsParser(vi, yt);
    mi = deepmerge(mi, Mi), Ti[oi] = {
      css: Oi,
      vars: Di
    };
  }
  function Si(Oi, Di) {
    var Oo, io;
    let Mi = ii;
    if (ii === "class" && (Mi = ".%s"), ii === "data" && (Mi = "[data-%s]"), ii != null && ii.startsWith("data-") && !ii.includes("%s") && (Mi = `[${ii}="%s"]`), Oi) {
      if (Mi === "media")
        return pt.defaultColorScheme === Oi ? ":root" : {
          [`@media (prefers-color-scheme: ${((io = (Oo = ai[Oi]) == null ? void 0 : Oo.palette) == null ? void 0 : io.mode) || Oi})`]: {
            ":root": Di
          }
        };
      if (Mi)
        return pt.defaultColorScheme === Oi ? `:root, ${Mi.replace("%s", String(Oi))}` : Mi.replace("%s", String(Oi));
    }
    return ":root";
  }
  return {
    vars: mi,
    generateThemeVars: () => {
      let Oi = {
        ...di
      };
      return Object.entries(Ti).forEach(([, {
        vars: Di
      }]) => {
        Oi = deepmerge(Oi, Di);
      }), Oi;
    },
    generateStyleSheets: () => {
      var xo, fo;
      const Oi = [], Di = pt.defaultColorScheme || "light";
      function Mi(_o, Li) {
        Object.keys(Li).length && Oi.push(typeof _o == "string" ? {
          [_o]: {
            ...Li
          }
        } : _o);
      }
      Mi(ir(void 0, {
        ...fi
      }), fi);
      const {
        [Di]: Oo,
        ...io
      } = Ti;
      if (Oo) {
        const {
          css: _o
        } = Oo, Li = (fo = (xo = ai[Di]) == null ? void 0 : xo.palette) == null ? void 0 : fo.mode, Co = !ti && Li ? {
          colorScheme: Li,
          ..._o
        } : {
          ..._o
        };
        Mi(ir(Di, {
          ...Co
        }), Co);
      }
      return Object.entries(io).forEach(([_o, {
        css: Li
      }]) => {
        var Yi, Vo;
        const Co = (Vo = (Yi = ai[_o]) == null ? void 0 : Yi.palette) == null ? void 0 : Vo.mode, Ni = !ti && Co ? {
          colorScheme: Co,
          ...Li
        } : {
          ...Li
        };
        Mi(ir(_o, {
          ...Ni
        }), Ni);
      }), ui && Oi.push({
        ":root": {
          // use double underscore to indicate that these are private variables
          "--__l-threshold": "0.7",
          "--__l": "clamp(0, (l / var(--__l-threshold) - 1) * -infinity, 1)",
          "--__a": "clamp(0.87, (l / var(--__l-threshold) - 1) * -infinity, 1)"
          // 0.87 is the default alpha value for black text.
        }
      }), Oi;
    }
  };
}
function createGetColorSchemeSelector(pt) {
  return function(ir) {
    return pt === "media" ? (process.env.NODE_ENV !== "production" && ir !== "light" && ir !== "dark" && console.error(`MUI: @media (prefers-color-scheme) supports only 'light' or 'dark', but receive '${ir}'.`), `@media (prefers-color-scheme: ${ir})`) : pt ? pt.startsWith("data-") && !pt.includes("%s") ? `[${pt}="${ir}"] &` : pt === "class" ? `.${ir} &` : pt === "data" ? `[data-${ir}] &` : `${pt.replace("%s", ir)} &` : "&";
  };
}
function composeClasses(pt, yt, ir = void 0) {
  const ti = {};
  for (const ii in pt) {
    const ui = pt[ii];
    let ai = "", li = !0;
    for (let oi = 0; oi < ui.length; oi += 1) {
      const si = ui[oi];
      si && (ai += (li === !0 ? "" : " ") + yt(si), li = !1, ir && ir[si] && (ai += " " + ir[si]));
    }
    ti[ii] = ai;
  }
  return ti;
}
function getLight() {
  return {
    // The colors used to style the text.
    text: {
      // The most important text.
      primary: "rgba(0, 0, 0, 0.87)",
      // Secondary text.
      secondary: "rgba(0, 0, 0, 0.6)",
      // Disabled text have even lower visual prominence.
      disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
      paper: common.white,
      default: common.white
    },
    // The colors used to style the action elements.
    action: {
      // The color of an active action like an icon button.
      active: "rgba(0, 0, 0, 0.54)",
      // The color of an hovered action.
      hover: "rgba(0, 0, 0, 0.04)",
      hoverOpacity: 0.04,
      // The color of a selected action.
      selected: "rgba(0, 0, 0, 0.08)",
      selectedOpacity: 0.08,
      // The color of a disabled action.
      disabled: "rgba(0, 0, 0, 0.26)",
      // The background color of a disabled action.
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(0, 0, 0, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.12
    }
  };
}
const light = getLight();
function getDark() {
  return {
    text: {
      primary: common.white,
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
      paper: "#121212",
      default: "#121212"
    },
    action: {
      active: common.white,
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: 0.08,
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: 0.16,
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.24
    }
  };
}
const dark = getDark();
function addLightOrDark(pt, yt, ir, ti) {
  const ii = ti.light || ti, ui = ti.dark || ti * 1.5;
  pt[yt] || (pt.hasOwnProperty(ir) ? pt[yt] = pt[ir] : yt === "light" ? pt.light = lighten(pt.main, ii) : yt === "dark" && (pt.dark = darken(pt.main, ui)));
}
function mixLightOrDark(pt, yt, ir, ti, ii) {
  const ui = ii.light || ii, ai = ii.dark || ii * 1.5;
  yt[ir] || (yt.hasOwnProperty(ti) ? yt[ir] = yt[ti] : ir === "light" ? yt.light = `color-mix(in ${pt}, ${yt.main}, #fff ${(ui * 100).toFixed(0)}%)` : ir === "dark" && (yt.dark = `color-mix(in ${pt}, ${yt.main}, #000 ${(ai * 100).toFixed(0)}%)`));
}
function getDefaultPrimary(pt = "light") {
  return pt === "dark" ? {
    main: blue[200],
    light: blue[50],
    dark: blue[400]
  } : {
    main: blue[700],
    light: blue[400],
    dark: blue[800]
  };
}
function getDefaultSecondary(pt = "light") {
  return pt === "dark" ? {
    main: purple[200],
    light: purple[50],
    dark: purple[400]
  } : {
    main: purple[500],
    light: purple[300],
    dark: purple[700]
  };
}
function getDefaultError(pt = "light") {
  return pt === "dark" ? {
    main: red[500],
    light: red[300],
    dark: red[700]
  } : {
    main: red[700],
    light: red[400],
    dark: red[800]
  };
}
function getDefaultInfo(pt = "light") {
  return pt === "dark" ? {
    main: lightBlue[400],
    light: lightBlue[300],
    dark: lightBlue[700]
  } : {
    main: lightBlue[700],
    light: lightBlue[500],
    dark: lightBlue[900]
  };
}
function getDefaultSuccess(pt = "light") {
  return pt === "dark" ? {
    main: green[400],
    light: green[300],
    dark: green[700]
  } : {
    main: green[800],
    light: green[500],
    dark: green[900]
  };
}
function getDefaultWarning(pt = "light") {
  return pt === "dark" ? {
    main: orange[400],
    light: orange[300],
    dark: orange[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: orange[500],
    dark: orange[900]
  };
}
function contrastColor(pt) {
  return `oklch(from ${pt} var(--__l) 0 h / var(--__a))`;
}
function createPalette(pt) {
  const {
    mode: yt = "light",
    contrastThreshold: ir = 3,
    tonalOffset: ti = 0.2,
    colorSpace: ii,
    ...ui
  } = pt, ai = pt.primary || getDefaultPrimary(yt), li = pt.secondary || getDefaultSecondary(yt), oi = pt.error || getDefaultError(yt), si = pt.info || getDefaultInfo(yt), di = pt.success || getDefaultSuccess(yt), fi = pt.warning || getDefaultWarning(yt);
  function gi(xi) {
    if (ii)
      return contrastColor(xi);
    const Si = getContrastRatio(xi, dark.text.primary) >= ir ? dark.text.primary : light.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const Pi = getContrastRatio(xi, Si);
      Pi < 3 && console.error([`MUI: The contrast ratio of ${Pi}:1 for ${Si} on ${xi}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return Si;
  }
  const mi = ({
    color: xi,
    name: Si,
    mainShade: Pi = 500,
    lightShade: $i = 300,
    darkShade: Oi = 700
  }) => {
    if (xi = {
      ...xi
    }, !xi.main && xi[Pi] && (xi.main = xi[Pi]), !xi.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${Si ? ` (${Si})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${Pi}\` property.` : formatMuiErrorMessage(11, Si ? ` (${Si})` : "", Pi));
    if (typeof xi.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${Si ? ` (${Si})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(xi.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : formatMuiErrorMessage(12, Si ? ` (${Si})` : "", JSON.stringify(xi.main)));
    return ii ? (mixLightOrDark(ii, xi, "light", $i, ti), mixLightOrDark(ii, xi, "dark", Oi, ti)) : (addLightOrDark(xi, "light", $i, ti), addLightOrDark(xi, "dark", Oi, ti)), xi.contrastText || (xi.contrastText = gi(xi.main)), xi;
  };
  let Ti;
  return yt === "light" ? Ti = getLight() : yt === "dark" && (Ti = getDark()), process.env.NODE_ENV !== "production" && (Ti || console.error(`MUI: The palette mode \`${yt}\` is not supported.`)), deepmerge({
    // A collection of common colors.
    common: {
      ...common
    },
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: yt,
    // The colors used to represent primary interface elements for a user.
    primary: mi({
      color: ai,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: mi({
      color: li,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: mi({
      color: oi,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: mi({
      color: fi,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: mi({
      color: si,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: mi({
      color: di,
      name: "success"
    }),
    // The grey colors.
    grey,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: ir,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: gi,
    // Generate a rich color object.
    augmentColor: mi,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: ti,
    // The light and dark mode object.
    ...Ti
  }, ui);
}
function prepareTypographyVars(pt) {
  const yt = {};
  return Object.entries(pt).forEach((ti) => {
    const [ii, ui] = ti;
    typeof ui == "object" && (yt[ii] = `${ui.fontStyle ? `${ui.fontStyle} ` : ""}${ui.fontVariant ? `${ui.fontVariant} ` : ""}${ui.fontWeight ? `${ui.fontWeight} ` : ""}${ui.fontStretch ? `${ui.fontStretch} ` : ""}${ui.fontSize || ""}${ui.lineHeight ? `/${ui.lineHeight} ` : ""}${ui.fontFamily || ""}`);
  }), yt;
}
function createMixins(pt, yt) {
  return {
    toolbar: {
      minHeight: 56,
      [pt.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [pt.up("sm")]: {
        minHeight: 64
      }
    },
    ...yt
  };
}
function round(pt) {
  return Math.round(pt * 1e5) / 1e5;
}
const caseAllCaps = {
  textTransform: "uppercase"
}, defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function createTypography(pt, yt) {
  const {
    fontFamily: ir = defaultFontFamily,
    // The default font size of the Material Specification.
    fontSize: ti = 14,
    // px
    fontWeightLight: ii = 300,
    fontWeightRegular: ui = 400,
    fontWeightMedium: ai = 500,
    fontWeightBold: li = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: oi = 16,
    // Apply the CSS properties to all the variants.
    allVariants: si,
    pxToRem: di,
    ...fi
  } = typeof yt == "function" ? yt(pt) : yt;
  process.env.NODE_ENV !== "production" && (typeof ti != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof oi != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const gi = ti / 14, mi = di || ((xi) => `${xi / oi * gi}rem`), Ti = (xi, Si, Pi, $i, Oi) => ({
    fontFamily: ir,
    fontWeight: xi,
    fontSize: mi(Si),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: Pi,
    // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
    // across font-families can cause issues with the kerning.
    ...ir === defaultFontFamily ? {
      letterSpacing: `${round($i / Si)}em`
    } : {},
    ...Oi,
    ...si
  }), vi = {
    h1: Ti(ii, 96, 1.167, -1.5),
    h2: Ti(ii, 60, 1.2, -0.5),
    h3: Ti(ui, 48, 1.167, 0),
    h4: Ti(ui, 34, 1.235, 0.25),
    h5: Ti(ui, 24, 1.334, 0),
    h6: Ti(ai, 20, 1.6, 0.15),
    subtitle1: Ti(ui, 16, 1.75, 0.15),
    subtitle2: Ti(ai, 14, 1.57, 0.1),
    body1: Ti(ui, 16, 1.5, 0.15),
    body2: Ti(ui, 14, 1.43, 0.15),
    button: Ti(ai, 14, 1.75, 0.4, caseAllCaps),
    caption: Ti(ui, 12, 1.66, 0.4),
    overline: Ti(ui, 12, 2.66, 1, caseAllCaps),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return deepmerge({
    htmlFontSize: oi,
    pxToRem: mi,
    fontFamily: ir,
    fontSize: ti,
    fontWeightLight: ii,
    fontWeightRegular: ui,
    fontWeightMedium: ai,
    fontWeightBold: li,
    ...vi
  }, fi, {
    clone: !1
    // No need to clone deep
  });
}
const shadowKeyUmbraOpacity = 0.2, shadowKeyPenumbraOpacity = 0.14, shadowAmbientShadowOpacity = 0.12;
function createShadow(...pt) {
  return [`${pt[0]}px ${pt[1]}px ${pt[2]}px ${pt[3]}px rgba(0,0,0,${shadowKeyUmbraOpacity})`, `${pt[4]}px ${pt[5]}px ${pt[6]}px ${pt[7]}px rgba(0,0,0,${shadowKeyPenumbraOpacity})`, `${pt[8]}px ${pt[9]}px ${pt[10]}px ${pt[11]}px rgba(0,0,0,${shadowAmbientShadowOpacity})`].join(",");
}
const shadows = ["none", createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], easing = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function formatMs(pt) {
  return `${Math.round(pt)}ms`;
}
function getAutoHeightDuration(pt) {
  if (!pt)
    return 0;
  const yt = pt / 36;
  return Math.min(Math.round((4 + 15 * yt ** 0.25 + yt / 5) * 10), 3e3);
}
function createTransitions(pt) {
  const yt = {
    ...easing,
    ...pt.easing
  }, ir = {
    ...duration,
    ...pt.duration
  };
  return {
    getAutoHeightDuration,
    create: (ii = ["all"], ui = {}) => {
      const {
        duration: ai = ir.standard,
        easing: li = yt.easeInOut,
        delay: oi = 0,
        ...si
      } = ui;
      if (process.env.NODE_ENV !== "production") {
        const di = (gi) => typeof gi == "string", fi = (gi) => !Number.isNaN(parseFloat(gi));
        !di(ii) && !Array.isArray(ii) && console.error('MUI: Argument "props" must be a string or Array.'), !fi(ai) && !di(ai) && console.error(`MUI: Argument "duration" must be a number or a string but found ${ai}.`), di(li) || console.error('MUI: Argument "easing" must be a string.'), !fi(oi) && !di(oi) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof ui != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(si).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(si).join(",")}].`);
      }
      return (Array.isArray(ii) ? ii : [ii]).map((di) => `${di} ${typeof ai == "string" ? ai : formatMs(ai)} ${li} ${typeof oi == "string" ? oi : formatMs(oi)}`).join(",");
    },
    ...pt,
    easing: yt,
    duration: ir
  };
}
const zIndex = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
function isSerializable(pt) {
  return isPlainObject(pt) || typeof pt > "u" || typeof pt == "string" || typeof pt == "boolean" || typeof pt == "number" || Array.isArray(pt);
}
function stringifyTheme(pt = {}) {
  const yt = {
    ...pt
  };
  function ir(ti) {
    const ii = Object.entries(ti);
    for (let ui = 0; ui < ii.length; ui++) {
      const [ai, li] = ii[ui];
      !isSerializable(li) || ai.startsWith("unstable_") ? delete ti[ai] : isPlainObject(li) && (ti[ai] = {
        ...li
      }, ir(ti[ai]));
    }
  }
  return ir(yt), `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(yt, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}
function coefficientToPercentage(pt) {
  return typeof pt == "number" ? `${(pt * 100).toFixed(0)}%` : `calc((${pt}) * 100%)`;
}
const parseAddition = (pt) => {
  if (!Number.isNaN(+pt))
    return +pt;
  const yt = pt.match(/\d*\.?\d+/g);
  if (!yt)
    return 0;
  let ir = 0;
  for (let ti = 0; ti < yt.length; ti += 1)
    ir += +yt[ti];
  return ir;
};
function attachColorManipulators(pt) {
  Object.assign(pt, {
    alpha(yt, ir) {
      const ti = this || pt;
      return ti.colorSpace ? `oklch(from ${yt} l c h / ${typeof ir == "string" ? `calc(${ir})` : ir})` : ti.vars ? `rgba(${yt.replace(/var\(--([^,\s)]+)(?:,[^)]+)?\)+/g, "var(--$1Channel)")} / ${typeof ir == "string" ? `calc(${ir})` : ir})` : alpha(yt, parseAddition(ir));
    },
    lighten(yt, ir) {
      const ti = this || pt;
      return ti.colorSpace ? `color-mix(in ${ti.colorSpace}, ${yt}, #fff ${coefficientToPercentage(ir)})` : lighten(yt, ir);
    },
    darken(yt, ir) {
      const ti = this || pt;
      return ti.colorSpace ? `color-mix(in ${ti.colorSpace}, ${yt}, #000 ${coefficientToPercentage(ir)})` : darken(yt, ir);
    }
  });
}
function createThemeNoVars(pt = {}, ...yt) {
  const {
    breakpoints: ir,
    mixins: ti = {},
    spacing: ii,
    palette: ui = {},
    transitions: ai = {},
    typography: li = {},
    shape: oi,
    colorSpace: si,
    ...di
  } = pt;
  if (pt.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
  // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
  pt.generateThemeVars === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name or follow the [docs](https://mui.com/material-ui/customization/css-theme-variables/usage/) to enable the feature." : formatMuiErrorMessage(20));
  const fi = createPalette({
    ...ui,
    colorSpace: si
  }), gi = createTheme$1(pt);
  let mi = deepmerge(gi, {
    mixins: createMixins(gi.breakpoints, ti),
    palette: fi,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: shadows.slice(),
    typography: createTypography(fi, li),
    transitions: createTransitions(ai),
    zIndex: {
      ...zIndex
    }
  });
  if (mi = deepmerge(mi, di), mi = yt.reduce((Ti, vi) => deepmerge(Ti, vi), mi), process.env.NODE_ENV !== "production") {
    const Ti = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], vi = (xi, Si) => {
      let Pi;
      for (Pi in xi) {
        const $i = xi[Pi];
        if (Ti.includes(Pi) && Object.keys($i).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const Oi = generateUtilityClass("", Pi);
            console.error([`MUI: The \`${Si}\` component increases the CSS specificity of the \`${Pi}\` internal state.`, "You can not override it like this: ", JSON.stringify(xi, null, 2), "", `Instead, you need to use the '&.${Oi}' syntax:`, JSON.stringify({
              root: {
                [`&.${Oi}`]: $i
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          xi[Pi] = {};
        }
      }
    };
    Object.keys(mi.components).forEach((xi) => {
      const Si = mi.components[xi].styleOverrides;
      Si && xi.startsWith("Mui") && vi(Si, xi);
    });
  }
  return mi.unstable_sxConfig = {
    ...defaultSxConfig,
    ...di == null ? void 0 : di.unstable_sxConfig
  }, mi.unstable_sx = function(vi) {
    return styleFunctionSx({
      sx: vi,
      theme: this
    });
  }, mi.toRuntimeSource = stringifyTheme, attachColorManipulators(mi), mi;
}
function getOverlayAlpha(pt) {
  let yt;
  return pt < 1 ? yt = 5.11916 * pt ** 2 : yt = 4.5 * Math.log(pt + 1) + 2, Math.round(yt * 10) / 1e3;
}
const defaultDarkOverlays = [...Array(25)].map((pt, yt) => {
  if (yt === 0)
    return "none";
  const ir = getOverlayAlpha(yt);
  return `linear-gradient(rgba(255 255 255 / ${ir}), rgba(255 255 255 / ${ir}))`;
});
function getOpacity(pt) {
  return {
    inputPlaceholder: pt === "dark" ? 0.5 : 0.42,
    inputUnderline: pt === "dark" ? 0.7 : 0.42,
    switchTrackDisabled: pt === "dark" ? 0.2 : 0.12,
    switchTrack: pt === "dark" ? 0.3 : 0.38
  };
}
function getOverlays(pt) {
  return pt === "dark" ? defaultDarkOverlays : [];
}
function createColorScheme(pt) {
  const {
    palette: yt = {
      mode: "light"
    },
    // need to cast to avoid module augmentation test
    opacity: ir,
    overlays: ti,
    colorSpace: ii,
    ...ui
  } = pt, ai = createPalette({
    ...yt,
    colorSpace: ii
  });
  return {
    palette: ai,
    opacity: {
      ...getOpacity(ai.mode),
      ...ir
    },
    overlays: ti || getOverlays(ai.mode),
    ...ui
  };
}
function shouldSkipGeneratingVar(pt) {
  var yt;
  return !!pt[0].match(/(cssVarPrefix|colorSchemeSelector|modularCssLayers|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!pt[0].match(/sxConfig$/) || // ends with sxConfig
  pt[0] === "palette" && !!((yt = pt[1]) != null && yt.match(/(mode|contrastThreshold|tonalOffset)/));
}
const excludeVariablesFromRoot = (pt) => [...[...Array(25)].map((yt, ir) => `--${pt ? `${pt}-` : ""}overlays-${ir}`), `--${pt ? `${pt}-` : ""}palette-AppBar-darkBg`, `--${pt ? `${pt}-` : ""}palette-AppBar-darkColor`], defaultGetSelector = (pt) => (yt, ir) => {
  const ti = pt.rootSelector || ":root", ii = pt.colorSchemeSelector;
  let ui = ii;
  if (ii === "class" && (ui = ".%s"), ii === "data" && (ui = "[data-%s]"), ii != null && ii.startsWith("data-") && !ii.includes("%s") && (ui = `[${ii}="%s"]`), pt.defaultColorScheme === yt) {
    if (yt === "dark") {
      const ai = {};
      return excludeVariablesFromRoot(pt.cssVarPrefix).forEach((li) => {
        ai[li] = ir[li], delete ir[li];
      }), ui === "media" ? {
        [ti]: ir,
        "@media (prefers-color-scheme: dark)": {
          [ti]: ai
        }
      } : ui ? {
        [ui.replace("%s", yt)]: ai,
        [`${ti}, ${ui.replace("%s", yt)}`]: ir
      } : {
        [ti]: {
          ...ir,
          ...ai
        }
      };
    }
    if (ui && ui !== "media")
      return `${ti}, ${ui.replace("%s", String(yt))}`;
  } else if (yt) {
    if (ui === "media")
      return {
        [`@media (prefers-color-scheme: ${String(yt)})`]: {
          [ti]: ir
        }
      };
    if (ui)
      return ui.replace("%s", String(yt));
  }
  return ti;
};
function assignNode(pt, yt) {
  yt.forEach((ir) => {
    pt[ir] || (pt[ir] = {});
  });
}
function setColor(pt, yt, ir) {
  !pt[yt] && ir && (pt[yt] = ir);
}
function toRgb(pt) {
  return typeof pt != "string" || !pt.startsWith("hsl") ? pt : hslToRgb(pt);
}
function setColorChannel(pt, yt) {
  `${yt}Channel` in pt || (pt[`${yt}Channel`] = private_safeColorChannel(toRgb(pt[yt]), `MUI: Can't create \`palette.${yt}Channel\` because \`palette.${yt}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().
To suppress this warning, you need to explicitly provide the \`palette.${yt}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`));
}
function getSpacingVal(pt) {
  return typeof pt == "number" ? `${pt}px` : typeof pt == "string" || typeof pt == "function" || Array.isArray(pt) ? pt : "8px";
}
const silent = (pt) => {
  try {
    return pt();
  } catch {
  }
}, createGetCssVar = (pt = "mui") => createGetCssVar$1(pt);
function attachColorScheme$1(pt, yt, ir, ti, ii) {
  if (!ir)
    return;
  ir = ir === !0 ? {} : ir;
  const ui = ii === "dark" ? "dark" : "light";
  if (!ti) {
    yt[ii] = createColorScheme({
      ...ir,
      palette: {
        mode: ui,
        ...ir == null ? void 0 : ir.palette
      },
      colorSpace: pt
    });
    return;
  }
  const {
    palette: ai,
    ...li
  } = createThemeNoVars({
    ...ti,
    palette: {
      mode: ui,
      ...ir == null ? void 0 : ir.palette
    },
    colorSpace: pt
  });
  return yt[ii] = {
    ...ir,
    palette: ai,
    opacity: {
      ...getOpacity(ui),
      ...ir == null ? void 0 : ir.opacity
    },
    overlays: (ir == null ? void 0 : ir.overlays) || getOverlays(ui)
  }, li;
}
function createThemeWithVars(pt = {}, ...yt) {
  const {
    colorSchemes: ir = {
      light: !0
    },
    defaultColorScheme: ti,
    disableCssColorScheme: ii = !1,
    cssVarPrefix: ui = "mui",
    nativeColor: ai = !1,
    shouldSkipGeneratingVar: li = shouldSkipGeneratingVar,
    colorSchemeSelector: oi = ir.light && ir.dark ? "media" : void 0,
    rootSelector: si = ":root",
    ...di
  } = pt, fi = Object.keys(ir)[0], gi = ti || (ir.light && fi !== "light" ? "light" : fi), mi = createGetCssVar(ui), {
    [gi]: Ti,
    light: vi,
    dark: xi,
    ...Si
  } = ir, Pi = {
    ...Si
  };
  let $i = Ti;
  if ((gi === "dark" && !("dark" in ir) || gi === "light" && !("light" in ir)) && ($i = !0), !$i)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The \`colorSchemes.${gi}\` option is either missing or invalid.` : formatMuiErrorMessage(21, gi));
  let Oi;
  ai && (Oi = "oklch");
  const Di = attachColorScheme$1(Oi, Pi, $i, di, gi);
  vi && !Pi.light && attachColorScheme$1(Oi, Pi, vi, void 0, "light"), xi && !Pi.dark && attachColorScheme$1(Oi, Pi, xi, void 0, "dark");
  let Mi = {
    defaultColorScheme: gi,
    ...Di,
    cssVarPrefix: ui,
    colorSchemeSelector: oi,
    rootSelector: si,
    getCssVar: mi,
    colorSchemes: Pi,
    font: {
      ...prepareTypographyVars(Di.typography),
      ...Di.font
    },
    spacing: getSpacingVal(di.spacing)
  };
  Object.keys(Mi.colorSchemes).forEach((_o) => {
    const Li = Mi.colorSchemes[_o].palette, Co = (Yi) => {
      const Vo = Yi.split("-"), No = Vo[1], Ui = Vo[2];
      return mi(Yi, Li[No][Ui]);
    };
    Li.mode === "light" && (setColor(Li.common, "background", "#fff"), setColor(Li.common, "onBackground", "#000")), Li.mode === "dark" && (setColor(Li.common, "background", "#000"), setColor(Li.common, "onBackground", "#fff"));
    function Ni(Yi, Vo, No) {
      if (Oi) {
        let Ui;
        return Yi === private_safeAlpha && (Ui = `transparent ${((1 - No) * 100).toFixed(0)}%`), Yi === private_safeDarken && (Ui = `#000 ${(No * 100).toFixed(0)}%`), Yi === private_safeLighten && (Ui = `#fff ${(No * 100).toFixed(0)}%`), `color-mix(in ${Oi}, ${Vo}, ${Ui})`;
      }
      return Yi(Vo, No);
    }
    if (assignNode(Li, ["Alert", "AppBar", "Avatar", "Button", "Chip", "FilledInput", "LinearProgress", "Skeleton", "Slider", "SnackbarContent", "SpeedDialAction", "StepConnector", "StepContent", "Switch", "TableCell", "Tooltip"]), Li.mode === "light") {
      setColor(Li.Alert, "errorColor", Ni(private_safeDarken, ai ? mi("palette-error-light") : Li.error.light, 0.6)), setColor(Li.Alert, "infoColor", Ni(private_safeDarken, ai ? mi("palette-info-light") : Li.info.light, 0.6)), setColor(Li.Alert, "successColor", Ni(private_safeDarken, ai ? mi("palette-success-light") : Li.success.light, 0.6)), setColor(Li.Alert, "warningColor", Ni(private_safeDarken, ai ? mi("palette-warning-light") : Li.warning.light, 0.6)), setColor(Li.Alert, "errorFilledBg", Co("palette-error-main")), setColor(Li.Alert, "infoFilledBg", Co("palette-info-main")), setColor(Li.Alert, "successFilledBg", Co("palette-success-main")), setColor(Li.Alert, "warningFilledBg", Co("palette-warning-main")), setColor(Li.Alert, "errorFilledColor", silent(() => Li.getContrastText(Li.error.main))), setColor(Li.Alert, "infoFilledColor", silent(() => Li.getContrastText(Li.info.main))), setColor(Li.Alert, "successFilledColor", silent(() => Li.getContrastText(Li.success.main))), setColor(Li.Alert, "warningFilledColor", silent(() => Li.getContrastText(Li.warning.main))), setColor(Li.Alert, "errorStandardBg", Ni(private_safeLighten, ai ? mi("palette-error-light") : Li.error.light, 0.9)), setColor(Li.Alert, "infoStandardBg", Ni(private_safeLighten, ai ? mi("palette-info-light") : Li.info.light, 0.9)), setColor(Li.Alert, "successStandardBg", Ni(private_safeLighten, ai ? mi("palette-success-light") : Li.success.light, 0.9)), setColor(Li.Alert, "warningStandardBg", Ni(private_safeLighten, ai ? mi("palette-warning-light") : Li.warning.light, 0.9)), setColor(Li.Alert, "errorIconColor", Co("palette-error-main")), setColor(Li.Alert, "infoIconColor", Co("palette-info-main")), setColor(Li.Alert, "successIconColor", Co("palette-success-main")), setColor(Li.Alert, "warningIconColor", Co("palette-warning-main")), setColor(Li.AppBar, "defaultBg", Co("palette-grey-100")), setColor(Li.Avatar, "defaultBg", Co("palette-grey-400")), setColor(Li.Button, "inheritContainedBg", Co("palette-grey-300")), setColor(Li.Button, "inheritContainedHoverBg", Co("palette-grey-A100")), setColor(Li.Chip, "defaultBorder", Co("palette-grey-400")), setColor(Li.Chip, "defaultAvatarColor", Co("palette-grey-700")), setColor(Li.Chip, "defaultIconColor", Co("palette-grey-700")), setColor(Li.FilledInput, "bg", "rgba(0, 0, 0, 0.06)"), setColor(Li.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)"), setColor(Li.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)"), setColor(Li.LinearProgress, "primaryBg", Ni(private_safeLighten, ai ? mi("palette-primary-main") : Li.primary.main, 0.62)), setColor(Li.LinearProgress, "secondaryBg", Ni(private_safeLighten, ai ? mi("palette-secondary-main") : Li.secondary.main, 0.62)), setColor(Li.LinearProgress, "errorBg", Ni(private_safeLighten, ai ? mi("palette-error-main") : Li.error.main, 0.62)), setColor(Li.LinearProgress, "infoBg", Ni(private_safeLighten, ai ? mi("palette-info-main") : Li.info.main, 0.62)), setColor(Li.LinearProgress, "successBg", Ni(private_safeLighten, ai ? mi("palette-success-main") : Li.success.main, 0.62)), setColor(Li.LinearProgress, "warningBg", Ni(private_safeLighten, ai ? mi("palette-warning-light") : Li.warning.main, 0.62)), setColor(Li.Skeleton, "bg", Oi ? Ni(private_safeAlpha, ai ? mi("palette-text-primary") : Li.text.primary, 0.11) : `rgba(${Co("palette-text-primaryChannel")} / 0.11)`), setColor(Li.Slider, "primaryTrack", Ni(private_safeLighten, ai ? mi("palette-primary-main") : Li.primary.main, 0.62)), setColor(Li.Slider, "secondaryTrack", Ni(private_safeLighten, ai ? mi("palette-secondary-main") : Li.secondary.main, 0.62)), setColor(Li.Slider, "errorTrack", Ni(private_safeLighten, ai ? mi("palette-error-main") : Li.error.main, 0.62)), setColor(Li.Slider, "infoTrack", Ni(private_safeLighten, ai ? mi("palette-info-main") : Li.info.main, 0.62)), setColor(Li.Slider, "successTrack", Ni(private_safeLighten, ai ? mi("palette-success-main") : Li.success.main, 0.62)), setColor(Li.Slider, "warningTrack", Ni(private_safeLighten, ai ? mi("palette-warning-main") : Li.warning.main, 0.62));
      const Yi = Oi ? Ni(private_safeDarken, ai ? mi("palette-background-default") : Li.background.default, 0.6825) : private_safeEmphasize(Li.background.default, 0.8);
      setColor(Li.SnackbarContent, "bg", Yi), setColor(Li.SnackbarContent, "color", silent(() => Oi ? dark.text.primary : Li.getContrastText(Yi))), setColor(Li.SpeedDialAction, "fabHoverBg", private_safeEmphasize(Li.background.paper, 0.15)), setColor(Li.StepConnector, "border", Co("palette-grey-400")), setColor(Li.StepContent, "border", Co("palette-grey-400")), setColor(Li.Switch, "defaultColor", Co("palette-common-white")), setColor(Li.Switch, "defaultDisabledColor", Co("palette-grey-100")), setColor(Li.Switch, "primaryDisabledColor", Ni(private_safeLighten, ai ? mi("palette-primary-main") : Li.primary.main, 0.62)), setColor(Li.Switch, "secondaryDisabledColor", Ni(private_safeLighten, ai ? mi("palette-secondary-main") : Li.secondary.main, 0.62)), setColor(Li.Switch, "errorDisabledColor", Ni(private_safeLighten, ai ? mi("palette-error-main") : Li.error.main, 0.62)), setColor(Li.Switch, "infoDisabledColor", Ni(private_safeLighten, ai ? mi("palette-info-main") : Li.info.main, 0.62)), setColor(Li.Switch, "successDisabledColor", Ni(private_safeLighten, ai ? mi("palette-success-main") : Li.success.main, 0.62)), setColor(Li.Switch, "warningDisabledColor", Ni(private_safeLighten, ai ? mi("palette-warning-main") : Li.warning.main, 0.62)), setColor(Li.TableCell, "border", Ni(private_safeLighten, private_safeAlpha(ai ? mi("palette-divider") : Li.divider, 1), 0.88)), setColor(Li.Tooltip, "bg", Ni(private_safeAlpha, ai ? mi("palette-grey-700") : Li.grey[700], 0.92));
    }
    if (Li.mode === "dark") {
      setColor(Li.Alert, "errorColor", Ni(private_safeLighten, ai ? mi("palette-error-light") : Li.error.light, 0.6)), setColor(Li.Alert, "infoColor", Ni(private_safeLighten, ai ? mi("palette-info-light") : Li.info.light, 0.6)), setColor(Li.Alert, "successColor", Ni(private_safeLighten, ai ? mi("palette-success-light") : Li.success.light, 0.6)), setColor(Li.Alert, "warningColor", Ni(private_safeLighten, ai ? mi("palette-warning-light") : Li.warning.light, 0.6)), setColor(Li.Alert, "errorFilledBg", Co("palette-error-dark")), setColor(Li.Alert, "infoFilledBg", Co("palette-info-dark")), setColor(Li.Alert, "successFilledBg", Co("palette-success-dark")), setColor(Li.Alert, "warningFilledBg", Co("palette-warning-dark")), setColor(Li.Alert, "errorFilledColor", silent(() => Li.getContrastText(Li.error.dark))), setColor(Li.Alert, "infoFilledColor", silent(() => Li.getContrastText(Li.info.dark))), setColor(Li.Alert, "successFilledColor", silent(() => Li.getContrastText(Li.success.dark))), setColor(Li.Alert, "warningFilledColor", silent(() => Li.getContrastText(Li.warning.dark))), setColor(Li.Alert, "errorStandardBg", Ni(private_safeDarken, ai ? mi("palette-error-light") : Li.error.light, 0.9)), setColor(Li.Alert, "infoStandardBg", Ni(private_safeDarken, ai ? mi("palette-info-light") : Li.info.light, 0.9)), setColor(Li.Alert, "successStandardBg", Ni(private_safeDarken, ai ? mi("palette-success-light") : Li.success.light, 0.9)), setColor(Li.Alert, "warningStandardBg", Ni(private_safeDarken, ai ? mi("palette-warning-light") : Li.warning.light, 0.9)), setColor(Li.Alert, "errorIconColor", Co("palette-error-main")), setColor(Li.Alert, "infoIconColor", Co("palette-info-main")), setColor(Li.Alert, "successIconColor", Co("palette-success-main")), setColor(Li.Alert, "warningIconColor", Co("palette-warning-main")), setColor(Li.AppBar, "defaultBg", Co("palette-grey-900")), setColor(Li.AppBar, "darkBg", Co("palette-background-paper")), setColor(Li.AppBar, "darkColor", Co("palette-text-primary")), setColor(Li.Avatar, "defaultBg", Co("palette-grey-600")), setColor(Li.Button, "inheritContainedBg", Co("palette-grey-800")), setColor(Li.Button, "inheritContainedHoverBg", Co("palette-grey-700")), setColor(Li.Chip, "defaultBorder", Co("palette-grey-700")), setColor(Li.Chip, "defaultAvatarColor", Co("palette-grey-300")), setColor(Li.Chip, "defaultIconColor", Co("palette-grey-300")), setColor(Li.FilledInput, "bg", "rgba(255, 255, 255, 0.09)"), setColor(Li.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)"), setColor(Li.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)"), setColor(Li.LinearProgress, "primaryBg", Ni(private_safeDarken, ai ? mi("palette-primary-main") : Li.primary.main, 0.5)), setColor(Li.LinearProgress, "secondaryBg", Ni(private_safeDarken, ai ? mi("palette-secondary-main") : Li.secondary.main, 0.5)), setColor(Li.LinearProgress, "errorBg", Ni(private_safeDarken, ai ? mi("palette-error-main") : Li.error.main, 0.5)), setColor(Li.LinearProgress, "infoBg", Ni(private_safeDarken, ai ? mi("palette-info-main") : Li.info.main, 0.5)), setColor(Li.LinearProgress, "successBg", Ni(private_safeDarken, ai ? mi("palette-success-main") : Li.success.main, 0.5)), setColor(Li.LinearProgress, "warningBg", Ni(private_safeDarken, ai ? mi("palette-warning-main") : Li.warning.main, 0.5)), setColor(Li.Skeleton, "bg", Oi ? Ni(private_safeAlpha, ai ? mi("palette-text-primary") : Li.text.primary, 0.13) : `rgba(${Co("palette-text-primaryChannel")} / 0.13)`), setColor(Li.Slider, "primaryTrack", Ni(private_safeDarken, ai ? mi("palette-primary-main") : Li.primary.main, 0.5)), setColor(Li.Slider, "secondaryTrack", Ni(private_safeDarken, ai ? mi("palette-secondary-main") : Li.secondary.main, 0.5)), setColor(Li.Slider, "errorTrack", Ni(private_safeDarken, ai ? mi("palette-error-main") : Li.error.main, 0.5)), setColor(Li.Slider, "infoTrack", Ni(private_safeDarken, ai ? mi("palette-info-main") : Li.info.main, 0.5)), setColor(Li.Slider, "successTrack", Ni(private_safeDarken, ai ? mi("palette-success-main") : Li.success.main, 0.5)), setColor(Li.Slider, "warningTrack", Ni(private_safeDarken, ai ? mi("palette-warning-light") : Li.warning.main, 0.5));
      const Yi = Oi ? Ni(private_safeLighten, ai ? mi("palette-background-default") : Li.background.default, 0.985) : private_safeEmphasize(Li.background.default, 0.98);
      setColor(Li.SnackbarContent, "bg", Yi), setColor(Li.SnackbarContent, "color", silent(() => Oi ? light.text.primary : Li.getContrastText(Yi))), setColor(Li.SpeedDialAction, "fabHoverBg", private_safeEmphasize(Li.background.paper, 0.15)), setColor(Li.StepConnector, "border", Co("palette-grey-600")), setColor(Li.StepContent, "border", Co("palette-grey-600")), setColor(Li.Switch, "defaultColor", Co("palette-grey-300")), setColor(Li.Switch, "defaultDisabledColor", Co("palette-grey-600")), setColor(Li.Switch, "primaryDisabledColor", Ni(private_safeDarken, ai ? mi("palette-primary-main") : Li.primary.main, 0.55)), setColor(Li.Switch, "secondaryDisabledColor", Ni(private_safeDarken, ai ? mi("palette-secondary-main") : Li.secondary.main, 0.55)), setColor(Li.Switch, "errorDisabledColor", Ni(private_safeDarken, ai ? mi("palette-error-main") : Li.error.main, 0.55)), setColor(Li.Switch, "infoDisabledColor", Ni(private_safeDarken, ai ? mi("palette-info-main") : Li.info.main, 0.55)), setColor(Li.Switch, "successDisabledColor", Ni(private_safeDarken, ai ? mi("palette-success-main") : Li.success.main, 0.55)), setColor(Li.Switch, "warningDisabledColor", Ni(private_safeDarken, ai ? mi("palette-warning-light") : Li.warning.main, 0.55)), setColor(Li.TableCell, "border", Ni(private_safeDarken, private_safeAlpha(ai ? mi("palette-divider") : Li.divider, 1), 0.68)), setColor(Li.Tooltip, "bg", Ni(private_safeAlpha, ai ? mi("palette-grey-700") : Li.grey[700], 0.92));
    }
    setColorChannel(Li.background, "default"), setColorChannel(Li.background, "paper"), setColorChannel(Li.common, "background"), setColorChannel(Li.common, "onBackground"), setColorChannel(Li, "divider"), Object.keys(Li).forEach((Yi) => {
      const Vo = Li[Yi];
      Yi !== "tonalOffset" && Vo && typeof Vo == "object" && (Vo.main && setColor(Li[Yi], "mainChannel", private_safeColorChannel(toRgb(Vo.main))), Vo.light && setColor(Li[Yi], "lightChannel", private_safeColorChannel(toRgb(Vo.light))), Vo.dark && setColor(Li[Yi], "darkChannel", private_safeColorChannel(toRgb(Vo.dark))), Vo.contrastText && setColor(Li[Yi], "contrastTextChannel", private_safeColorChannel(toRgb(Vo.contrastText))), Yi === "text" && (setColorChannel(Li[Yi], "primary"), setColorChannel(Li[Yi], "secondary")), Yi === "action" && (Vo.active && setColorChannel(Li[Yi], "active"), Vo.selected && setColorChannel(Li[Yi], "selected")));
    });
  }), Mi = yt.reduce((_o, Li) => deepmerge(_o, Li), Mi);
  const Oo = {
    prefix: ui,
    disableCssColorScheme: ii,
    shouldSkipGeneratingVar: li,
    getSelector: defaultGetSelector(Mi),
    enableContrastVars: ai
  }, {
    vars: io,
    generateThemeVars: xo,
    generateStyleSheets: fo
  } = prepareCssVars(Mi, Oo);
  return Mi.vars = io, Object.entries(Mi.colorSchemes[Mi.defaultColorScheme]).forEach(([_o, Li]) => {
    Mi[_o] = Li;
  }), Mi.generateThemeVars = xo, Mi.generateStyleSheets = fo, Mi.generateSpacing = function() {
    return createSpacing(di.spacing, createUnarySpacing(this));
  }, Mi.getColorSchemeSelector = createGetColorSchemeSelector(oi), Mi.spacing = Mi.generateSpacing(), Mi.shouldSkipGeneratingVar = li, Mi.unstable_sxConfig = {
    ...defaultSxConfig,
    ...di == null ? void 0 : di.unstable_sxConfig
  }, Mi.unstable_sx = function(Li) {
    return styleFunctionSx({
      sx: Li,
      theme: this
    });
  }, Mi.toRuntimeSource = stringifyTheme, Mi;
}
function attachColorScheme(pt, yt, ir) {
  pt.colorSchemes && ir && (pt.colorSchemes[yt] = {
    ...ir !== !0 && ir,
    palette: createPalette({
      ...ir === !0 ? {} : ir.palette,
      mode: yt
    })
    // cast type to skip module augmentation test
  });
}
function createTheme(pt = {}, ...yt) {
  const {
    palette: ir,
    cssVariables: ti = !1,
    colorSchemes: ii = ir ? void 0 : {
      light: !0
    },
    defaultColorScheme: ui = ir == null ? void 0 : ir.mode,
    ...ai
  } = pt, li = ui || "light", oi = ii == null ? void 0 : ii[li], si = {
    ...ii,
    ...ir ? {
      [li]: {
        ...typeof oi != "boolean" && oi,
        palette: ir
      }
    } : void 0
  };
  if (ti === !1) {
    if (!("colorSchemes" in pt))
      return createThemeNoVars(pt, ...yt);
    let di = ir;
    "palette" in pt || si[li] && (si[li] !== !0 ? di = si[li].palette : li === "dark" && (di = {
      mode: "dark"
    }));
    const fi = createThemeNoVars({
      ...pt,
      palette: di
    }, ...yt);
    return fi.defaultColorScheme = li, fi.colorSchemes = si, fi.palette.mode === "light" && (fi.colorSchemes.light = {
      ...si.light !== !0 && si.light,
      palette: fi.palette
    }, attachColorScheme(fi, "dark", si.dark)), fi.palette.mode === "dark" && (fi.colorSchemes.dark = {
      ...si.dark !== !0 && si.dark,
      palette: fi.palette
    }, attachColorScheme(fi, "light", si.light)), fi;
  }
  return !ir && !("light" in si) && li === "light" && (si.light = !0), createThemeWithVars({
    ...ai,
    colorSchemes: si,
    defaultColorScheme: li,
    ...typeof ti != "boolean" && ti
  }, ...yt);
}
const defaultTheme = createTheme();
function useTheme() {
  const pt = useTheme$1(defaultTheme);
  return process.env.NODE_ENV !== "production" && React.useDebugValue(pt), pt[THEME_ID] || pt;
}
function slotShouldForwardProp(pt) {
  return pt !== "ownerState" && pt !== "theme" && pt !== "sx" && pt !== "as";
}
const rootShouldForwardProp = (pt) => slotShouldForwardProp(pt) && pt !== "classes", styled = createStyled({
  themeId: THEME_ID,
  defaultTheme,
  rootShouldForwardProp
});
function createChainedFunction(...pt) {
  return pt.reduce((yt, ir) => ir == null ? yt : function(...ii) {
    yt.apply(this, ii), ir.apply(this, ii);
  }, () => {
  });
}
const memoTheme = unstable_memoTheme;
process.env.NODE_ENV !== "production" && (PropTypes$1.node, PropTypes$1.object.isRequired);
function useDefaultProps(pt) {
  return useDefaultProps$1(pt);
}
function getSvgIconUtilityClass(pt) {
  return generateUtilityClass("MuiSvgIcon", pt);
}
generateUtilityClasses("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const useUtilityClasses$a = (pt) => {
  const {
    color: yt,
    fontSize: ir,
    classes: ti
  } = pt, ii = {
    root: ["root", yt !== "inherit" && `color${capitalize(yt)}`, `fontSize${capitalize(ir)}`]
  };
  return composeClasses(ii, getSvgIconUtilityClass, ti);
}, SvgIconRoot = styled("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (pt, yt) => {
    const {
      ownerState: ir
    } = pt;
    return [yt.root, ir.color !== "inherit" && yt[`color${capitalize(ir.color)}`], yt[`fontSize${capitalize(ir.fontSize)}`]];
  }
})(memoTheme(({
  theme: pt
}) => {
  var yt, ir, ti, ii, ui, ai, li, oi, si, di, fi, gi, mi, Ti;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    flexShrink: 0,
    transition: (ii = (yt = pt.transitions) == null ? void 0 : yt.create) == null ? void 0 : ii.call(yt, "fill", {
      duration: (ti = (ir = (pt.vars ?? pt).transitions) == null ? void 0 : ir.duration) == null ? void 0 : ti.shorter
    }),
    variants: [
      {
        props: (vi) => !vi.hasSvgAsChild,
        style: {
          // the <svg> will define the property that has `currentColor`
          // for example heroicons uses fill="none" and stroke="currentColor"
          fill: "currentColor"
        }
      },
      {
        props: {
          fontSize: "inherit"
        },
        style: {
          fontSize: "inherit"
        }
      },
      {
        props: {
          fontSize: "small"
        },
        style: {
          fontSize: ((ai = (ui = pt.typography) == null ? void 0 : ui.pxToRem) == null ? void 0 : ai.call(ui, 20)) || "1.25rem"
        }
      },
      {
        props: {
          fontSize: "medium"
        },
        style: {
          fontSize: ((oi = (li = pt.typography) == null ? void 0 : li.pxToRem) == null ? void 0 : oi.call(li, 24)) || "1.5rem"
        }
      },
      {
        props: {
          fontSize: "large"
        },
        style: {
          fontSize: ((di = (si = pt.typography) == null ? void 0 : si.pxToRem) == null ? void 0 : di.call(si, 35)) || "2.1875rem"
        }
      },
      // TODO v5 deprecate color prop, v6 remove for sx
      ...Object.entries((pt.vars ?? pt).palette).filter(([, vi]) => vi && vi.main).map(([vi]) => {
        var xi, Si;
        return {
          props: {
            color: vi
          },
          style: {
            color: (Si = (xi = (pt.vars ?? pt).palette) == null ? void 0 : xi[vi]) == null ? void 0 : Si.main
          }
        };
      }),
      {
        props: {
          color: "action"
        },
        style: {
          color: (gi = (fi = (pt.vars ?? pt).palette) == null ? void 0 : fi.action) == null ? void 0 : gi.active
        }
      },
      {
        props: {
          color: "disabled"
        },
        style: {
          color: (Ti = (mi = (pt.vars ?? pt).palette) == null ? void 0 : mi.action) == null ? void 0 : Ti.disabled
        }
      },
      {
        props: {
          color: "inherit"
        },
        style: {
          color: void 0
        }
      }
    ]
  };
})), SvgIcon = /* @__PURE__ */ React.forwardRef(function pt(yt, ir) {
  const ti = useDefaultProps({
    props: yt,
    name: "MuiSvgIcon"
  }), {
    children: ii,
    className: ui,
    color: ai = "inherit",
    component: li = "svg",
    fontSize: oi = "medium",
    htmlColor: si,
    inheritViewBox: di = !1,
    titleAccess: fi,
    viewBox: gi = "0 0 24 24",
    ...mi
  } = ti, Ti = /* @__PURE__ */ React.isValidElement(ii) && ii.type === "svg", vi = {
    ...ti,
    color: ai,
    component: li,
    fontSize: oi,
    instanceFontSize: yt.fontSize,
    inheritViewBox: di,
    viewBox: gi,
    hasSvgAsChild: Ti
  }, xi = {};
  di || (xi.viewBox = gi);
  const Si = useUtilityClasses$a(vi);
  return /* @__PURE__ */ jsxRuntimeExports$1.jsxs(SvgIconRoot, {
    as: li,
    className: clsx(Si.root, ui),
    focusable: "false",
    color: si,
    "aria-hidden": fi ? void 0 : !0,
    role: fi ? "img" : void 0,
    ref: ir,
    ...xi,
    ...mi,
    ...Ti && ii.props,
    ownerState: vi,
    children: [Ti ? ii.props.children : ii, fi ? /* @__PURE__ */ jsxRuntimeExports$1.jsx("title", {
      children: fi
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (SvgIcon.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: PropTypes$1.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,
  /**
   * @ignore
   */
  className: PropTypes$1.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: PropTypes$1.oneOfType([PropTypes$1.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes$1.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: PropTypes$1.oneOfType([PropTypes$1.oneOf(["inherit", "large", "medium", "small"]), PropTypes$1.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: PropTypes$1.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: PropTypes$1.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Reference/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: PropTypes$1.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: PropTypes$1.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: PropTypes$1.string
});
SvgIcon.muiName = "SvgIcon";
function createSvgIcon(pt, yt) {
  function ir(ti, ii) {
    return /* @__PURE__ */ jsxRuntimeExports$1.jsx(SvgIcon, {
      "data-testid": process.env.NODE_ENV !== "production" ? `${yt}Icon` : void 0,
      ref: ii,
      ...ti,
      children: pt
    });
  }
  return process.env.NODE_ENV !== "production" && (ir.displayName = `${yt}Icon`), ir.muiName = SvgIcon.muiName, /* @__PURE__ */ React.memo(/* @__PURE__ */ React.forwardRef(ir));
}
function debounce(pt, yt = 166) {
  let ir;
  function ti(...ii) {
    const ui = () => {
      pt.apply(this, ii);
    };
    clearTimeout(ir), ir = setTimeout(ui, yt);
  }
  return ti.clear = () => {
    clearTimeout(ir);
  }, ti;
}
function ownerDocument(pt) {
  return pt && pt.ownerDocument || document;
}
function ownerWindow(pt) {
  return ownerDocument(pt).defaultView || window;
}
function setRef(pt, yt) {
  typeof pt == "function" ? pt(yt) : pt && (pt.current = yt);
}
function useControlled(pt) {
  const {
    controlled: yt,
    default: ir,
    name: ti,
    state: ii = "value"
  } = pt, {
    current: ui
  } = React.useRef(yt !== void 0), [ai, li] = React.useState(ir), oi = ui ? yt : ai;
  if (process.env.NODE_ENV !== "production") {
    React.useEffect(() => {
      ui !== (yt !== void 0) && console.error([`MUI: A component is changing the ${ui ? "" : "un"}controlled ${ii} state of ${ti} to be ${ui ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${ti} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [ii, ti, yt]);
    const {
      current: di
    } = React.useRef(ir);
    React.useEffect(() => {
      !ui && JSON.stringify(ir) !== JSON.stringify(di) && console.error([`MUI: A component is changing the default ${ii} state of an uncontrolled ${ti} after being initialized. To suppress this warning opt to use a controlled ${ti}.`].join(`
`));
    }, [JSON.stringify(ir)]);
  }
  const si = React.useCallback((di) => {
    ui || li(di);
  }, []);
  return [oi, si];
}
function useEventCallback(pt) {
  const yt = React.useRef(pt);
  return useEnhancedEffect(() => {
    yt.current = pt;
  }), React.useRef((...ir) => (
    // @ts-expect-error hide `this`
    (0, yt.current)(...ir)
  )).current;
}
function useForkRef(...pt) {
  const yt = React.useRef(void 0), ir = React.useCallback((ti) => {
    const ii = pt.map((ui) => {
      if (ui == null)
        return null;
      if (typeof ui == "function") {
        const ai = ui, li = ai(ti);
        return typeof li == "function" ? li : () => {
          ai(null);
        };
      }
      return ui.current = ti, () => {
        ui.current = null;
      };
    });
    return () => {
      ii.forEach((ui) => ui == null ? void 0 : ui());
    };
  }, pt);
  return React.useMemo(() => pt.every((ti) => ti == null) ? null : (ti) => {
    yt.current && (yt.current(), yt.current = void 0), ti != null && (yt.current = ir(ti));
  }, pt);
}
function isEventHandler(pt, yt) {
  const ir = pt.charCodeAt(2);
  return pt[0] === "o" && pt[1] === "n" && ir >= 65 && ir <= 90 && typeof yt == "function";
}
function mergeSlotProps$1(pt, yt) {
  if (!pt)
    return yt;
  function ir(ai, li) {
    const oi = {};
    return Object.keys(li).forEach((si) => {
      isEventHandler(si, li[si]) && typeof ai[si] == "function" && (oi[si] = (...di) => {
        ai[si](...di), li[si](...di);
      });
    }), oi;
  }
  if (typeof pt == "function" || typeof yt == "function")
    return (ai) => {
      const li = typeof yt == "function" ? yt(ai) : yt, oi = typeof pt == "function" ? pt({
        ...ai,
        ...li
      }) : pt, si = clsx(ai == null ? void 0 : ai.className, li == null ? void 0 : li.className, oi == null ? void 0 : oi.className), di = ir(oi, li);
      return {
        ...li,
        ...oi,
        ...di,
        ...!!si && {
          className: si
        },
        ...(li == null ? void 0 : li.style) && (oi == null ? void 0 : oi.style) && {
          style: {
            ...li.style,
            ...oi.style
          }
        },
        ...(li == null ? void 0 : li.sx) && (oi == null ? void 0 : oi.sx) && {
          sx: [...Array.isArray(li.sx) ? li.sx : [li.sx], ...Array.isArray(oi.sx) ? oi.sx : [oi.sx]]
        }
      };
    };
  const ti = yt, ii = ir(pt, ti), ui = clsx(ti == null ? void 0 : ti.className, pt == null ? void 0 : pt.className);
  return {
    ...yt,
    ...pt,
    ...ii,
    ...!!ui && {
      className: ui
    },
    ...(ti == null ? void 0 : ti.style) && (pt == null ? void 0 : pt.style) && {
      style: {
        ...ti.style,
        ...pt.style
      }
    },
    ...(ti == null ? void 0 : ti.sx) && (pt == null ? void 0 : pt.sx) && {
      sx: [...Array.isArray(ti.sx) ? ti.sx : [ti.sx], ...Array.isArray(pt.sx) ? pt.sx : [pt.sx]]
    }
  };
}
function chainPropTypes(pt, yt) {
  return process.env.NODE_ENV === "production" ? () => null : function(...ti) {
    return pt(...ti) || yt(...ti);
  };
}
function _objectWithoutPropertiesLoose(pt, yt) {
  if (pt == null) return {};
  var ir = {};
  for (var ti in pt) if ({}.hasOwnProperty.call(pt, ti)) {
    if (yt.indexOf(ti) !== -1) continue;
    ir[ti] = pt[ti];
  }
  return ir;
}
function _setPrototypeOf(pt, yt) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(ir, ti) {
    return ir.__proto__ = ti, ir;
  }, _setPrototypeOf(pt, yt);
}
function _inheritsLoose(pt, yt) {
  pt.prototype = Object.create(yt.prototype), pt.prototype.constructor = pt, _setPrototypeOf(pt, yt);
}
const config = {
  disabled: !1
};
var timeoutsShape = process.env.NODE_ENV !== "production" ? PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.shape({
  enter: PropTypes$1.number,
  exit: PropTypes$1.number,
  appear: PropTypes$1.number
}).isRequired]) : null;
process.env.NODE_ENV !== "production" && PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.shape({
  enter: PropTypes$1.string,
  exit: PropTypes$1.string,
  active: PropTypes$1.string
}), PropTypes$1.shape({
  enter: PropTypes$1.string,
  enterDone: PropTypes$1.string,
  enterActive: PropTypes$1.string,
  exit: PropTypes$1.string,
  exitDone: PropTypes$1.string,
  exitActive: PropTypes$1.string
})]);
const TransitionGroupContext = React__default.createContext(null);
var forceReflow = function pt(yt) {
  return yt.scrollTop;
}, UNMOUNTED = "unmounted", EXITED = "exited", ENTERING = "entering", ENTERED = "entered", EXITING = "exiting", Transition = /* @__PURE__ */ (function(pt) {
  _inheritsLoose(yt, pt);
  function yt(ti, ii) {
    var ui;
    ui = pt.call(this, ti, ii) || this;
    var ai = ii, li = ai && !ai.isMounting ? ti.enter : ti.appear, oi;
    return ui.appearStatus = null, ti.in ? li ? (oi = EXITED, ui.appearStatus = ENTERING) : oi = ENTERED : ti.unmountOnExit || ti.mountOnEnter ? oi = UNMOUNTED : oi = EXITED, ui.state = {
      status: oi
    }, ui.nextCallback = null, ui;
  }
  yt.getDerivedStateFromProps = function(ii, ui) {
    var ai = ii.in;
    return ai && ui.status === UNMOUNTED ? {
      status: EXITED
    } : null;
  };
  var ir = yt.prototype;
  return ir.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, ir.componentDidUpdate = function(ii) {
    var ui = null;
    if (ii !== this.props) {
      var ai = this.state.status;
      this.props.in ? ai !== ENTERING && ai !== ENTERED && (ui = ENTERING) : (ai === ENTERING || ai === ENTERED) && (ui = EXITING);
    }
    this.updateStatus(!1, ui);
  }, ir.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, ir.getTimeouts = function() {
    var ii = this.props.timeout, ui, ai, li;
    return ui = ai = li = ii, ii != null && typeof ii != "number" && (ui = ii.exit, ai = ii.enter, li = ii.appear !== void 0 ? ii.appear : ai), {
      exit: ui,
      enter: ai,
      appear: li
    };
  }, ir.updateStatus = function(ii, ui) {
    if (ii === void 0 && (ii = !1), ui !== null)
      if (this.cancelNextCallback(), ui === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var ai = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this);
          ai && forceReflow(ai);
        }
        this.performEnter(ii);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === EXITED && this.setState({
      status: UNMOUNTED
    });
  }, ir.performEnter = function(ii) {
    var ui = this, ai = this.props.enter, li = this.context ? this.context.isMounting : ii, oi = this.props.nodeRef ? [li] : [ReactDOM__default.findDOMNode(this), li], si = oi[0], di = oi[1], fi = this.getTimeouts(), gi = li ? fi.appear : fi.enter;
    if (!ii && !ai || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function() {
        ui.props.onEntered(si);
      });
      return;
    }
    this.props.onEnter(si, di), this.safeSetState({
      status: ENTERING
    }, function() {
      ui.props.onEntering(si, di), ui.onTransitionEnd(gi, function() {
        ui.safeSetState({
          status: ENTERED
        }, function() {
          ui.props.onEntered(si, di);
        });
      });
    });
  }, ir.performExit = function() {
    var ii = this, ui = this.props.exit, ai = this.getTimeouts(), li = this.props.nodeRef ? void 0 : ReactDOM__default.findDOMNode(this);
    if (!ui || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function() {
        ii.props.onExited(li);
      });
      return;
    }
    this.props.onExit(li), this.safeSetState({
      status: EXITING
    }, function() {
      ii.props.onExiting(li), ii.onTransitionEnd(ai.exit, function() {
        ii.safeSetState({
          status: EXITED
        }, function() {
          ii.props.onExited(li);
        });
      });
    });
  }, ir.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, ir.safeSetState = function(ii, ui) {
    ui = this.setNextCallback(ui), this.setState(ii, ui);
  }, ir.setNextCallback = function(ii) {
    var ui = this, ai = !0;
    return this.nextCallback = function(li) {
      ai && (ai = !1, ui.nextCallback = null, ii(li));
    }, this.nextCallback.cancel = function() {
      ai = !1;
    }, this.nextCallback;
  }, ir.onTransitionEnd = function(ii, ui) {
    this.setNextCallback(ui);
    var ai = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this), li = ii == null && !this.props.addEndListener;
    if (!ai || li) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var oi = this.props.nodeRef ? [this.nextCallback] : [ai, this.nextCallback], si = oi[0], di = oi[1];
      this.props.addEndListener(si, di);
    }
    ii != null && setTimeout(this.nextCallback, ii);
  }, ir.render = function() {
    var ii = this.state.status;
    if (ii === UNMOUNTED)
      return null;
    var ui = this.props, ai = ui.children;
    ui.in, ui.mountOnEnter, ui.unmountOnExit, ui.appear, ui.enter, ui.exit, ui.timeout, ui.addEndListener, ui.onEnter, ui.onEntering, ui.onEntered, ui.onExit, ui.onExiting, ui.onExited, ui.nodeRef;
    var li = _objectWithoutPropertiesLoose(ui, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof ai == "function" ? ai(ii, li) : React__default.cloneElement(React__default.Children.only(ai), li))
    );
  }, yt;
})(React__default.Component);
Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes$1.shape({
    current: typeof Element > "u" ? PropTypes$1.any : function(pt, yt, ir, ti, ii, ui) {
      var ai = pt[yt];
      return PropTypes$1.instanceOf(ai && "ownerDocument" in ai ? ai.ownerDocument.defaultView.Element : Element)(pt, yt, ir, ti, ii, ui);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes$1.oneOfType([PropTypes$1.func.isRequired, PropTypes$1.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes$1.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes$1.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes$1.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes$1.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes$1.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes$1.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function pt(yt) {
    var ir = timeoutsShape;
    yt.addEndListener || (ir = ir.isRequired);
    for (var ti = arguments.length, ii = new Array(ti > 1 ? ti - 1 : 0), ui = 1; ui < ti; ui++)
      ii[ui - 1] = arguments[ui];
    return ir.apply(void 0, [yt].concat(ii));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes$1.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes$1.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes$1.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes$1.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes$1.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes$1.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes$1.func
} : {};
function noop$1() {
}
Transition.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: noop$1,
  onEntering: noop$1,
  onEntered: noop$1,
  onExit: noop$1,
  onExiting: noop$1,
  onExited: noop$1
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
function _assertThisInitialized(pt) {
  if (pt === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return pt;
}
function getChildMapping(pt, yt) {
  var ir = function(ui) {
    return yt && isValidElement(ui) ? yt(ui) : ui;
  }, ti = /* @__PURE__ */ Object.create(null);
  return pt && Children.map(pt, function(ii) {
    return ii;
  }).forEach(function(ii) {
    ti[ii.key] = ir(ii);
  }), ti;
}
function mergeChildMappings(pt, yt) {
  pt = pt || {}, yt = yt || {};
  function ir(di) {
    return di in yt ? yt[di] : pt[di];
  }
  var ti = /* @__PURE__ */ Object.create(null), ii = [];
  for (var ui in pt)
    ui in yt ? ii.length && (ti[ui] = ii, ii = []) : ii.push(ui);
  var ai, li = {};
  for (var oi in yt) {
    if (ti[oi])
      for (ai = 0; ai < ti[oi].length; ai++) {
        var si = ti[oi][ai];
        li[ti[oi][ai]] = ir(si);
      }
    li[oi] = ir(oi);
  }
  for (ai = 0; ai < ii.length; ai++)
    li[ii[ai]] = ir(ii[ai]);
  return li;
}
function getProp(pt, yt, ir) {
  return ir[yt] != null ? ir[yt] : pt.props[yt];
}
function getInitialChildMapping(pt, yt) {
  return getChildMapping(pt.children, function(ir) {
    return cloneElement(ir, {
      onExited: yt.bind(null, ir),
      in: !0,
      appear: getProp(ir, "appear", pt),
      enter: getProp(ir, "enter", pt),
      exit: getProp(ir, "exit", pt)
    });
  });
}
function getNextChildMapping(pt, yt, ir) {
  var ti = getChildMapping(pt.children), ii = mergeChildMappings(yt, ti);
  return Object.keys(ii).forEach(function(ui) {
    var ai = ii[ui];
    if (isValidElement(ai)) {
      var li = ui in yt, oi = ui in ti, si = yt[ui], di = isValidElement(si) && !si.props.in;
      oi && (!li || di) ? ii[ui] = cloneElement(ai, {
        onExited: ir.bind(null, ai),
        in: !0,
        exit: getProp(ai, "exit", pt),
        enter: getProp(ai, "enter", pt)
      }) : !oi && li && !di ? ii[ui] = cloneElement(ai, {
        in: !1
      }) : oi && li && isValidElement(si) && (ii[ui] = cloneElement(ai, {
        onExited: ir.bind(null, ai),
        in: si.props.in,
        exit: getProp(ai, "exit", pt),
        enter: getProp(ai, "enter", pt)
      }));
    }
  }), ii;
}
var values = Object.values || function(pt) {
  return Object.keys(pt).map(function(yt) {
    return pt[yt];
  });
}, defaultProps = {
  component: "div",
  childFactory: function pt(yt) {
    return yt;
  }
}, TransitionGroup = /* @__PURE__ */ (function(pt) {
  _inheritsLoose(yt, pt);
  function yt(ti, ii) {
    var ui;
    ui = pt.call(this, ti, ii) || this;
    var ai = ui.handleExited.bind(_assertThisInitialized(ui));
    return ui.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: ai,
      firstRender: !0
    }, ui;
  }
  var ir = yt.prototype;
  return ir.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, ir.componentWillUnmount = function() {
    this.mounted = !1;
  }, yt.getDerivedStateFromProps = function(ii, ui) {
    var ai = ui.children, li = ui.handleExited, oi = ui.firstRender;
    return {
      children: oi ? getInitialChildMapping(ii, li) : getNextChildMapping(ii, ai, li),
      firstRender: !1
    };
  }, ir.handleExited = function(ii, ui) {
    var ai = getChildMapping(this.props.children);
    ii.key in ai || (ii.props.onExited && ii.props.onExited(ui), this.mounted && this.setState(function(li) {
      var oi = _extends({}, li.children);
      return delete oi[ii.key], {
        children: oi
      };
    }));
  }, ir.render = function() {
    var ii = this.props, ui = ii.component, ai = ii.childFactory, li = _objectWithoutPropertiesLoose(ii, ["component", "childFactory"]), oi = this.state.contextValue, si = values(this.state.children).map(ai);
    return delete li.appear, delete li.enter, delete li.exit, ui === null ? /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
      value: oi
    }, si) : /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
      value: oi
    }, /* @__PURE__ */ React__default.createElement(ui, li, si));
  }, yt;
})(React__default.Component);
TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes$1.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes$1.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes$1.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes$1.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes$1.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes$1.func
} : {};
TransitionGroup.defaultProps = defaultProps;
const UNINITIALIZED = {};
function useLazyRef(pt, yt) {
  const ir = React.useRef(UNINITIALIZED);
  return ir.current === UNINITIALIZED && (ir.current = pt(yt)), ir;
}
const EMPTY = [];
function useOnMount(pt) {
  React.useEffect(pt, EMPTY);
}
class Timeout {
  constructor() {
    Hm(this, "currentId", null);
    Hm(this, "clear", () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    });
    Hm(this, "disposeEffect", () => this.clear);
  }
  static create() {
    return new Timeout();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(yt, ir) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, ir();
    }, yt);
  }
}
function useTimeout() {
  const pt = useLazyRef(Timeout.create).current;
  return useOnMount(pt.disposeEffect), pt;
}
function isClassComponent$1(pt) {
  const {
    prototype: yt = {}
  } = pt;
  return !!yt.isReactComponent;
}
function elementTypeAcceptingRef(pt, yt, ir, ti, ii) {
  const ui = pt[yt], ai = ii || yt;
  if (ui == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let li;
  return typeof ui == "function" && !isClassComponent$1(ui) && (li = "Did you accidentally provide a plain function component instead?"), ui === React.Fragment && (li = "Did you accidentally provide a React.Fragment instead?"), li !== void 0 ? new Error(`Invalid ${ti} \`${ai}\` supplied to \`${ir}\`. Expected an element type that can hold a ref. ${li} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const elementTypeAcceptingRef$1 = chainPropTypes(PropTypes$1.elementType, elementTypeAcceptingRef), reflow = (pt) => pt.scrollTop;
function getTransitionProps(pt, yt) {
  const {
    timeout: ir,
    easing: ti,
    style: ii = {}
  } = pt;
  return {
    duration: ii.transitionDuration ?? (typeof ir == "number" ? ir : ir[yt.mode] || 0),
    easing: ii.transitionTimingFunction ?? (typeof ti == "object" ? ti[yt.mode] : ti),
    delay: ii.transitionDelay
  };
}
function isHostComponent(pt) {
  return typeof pt == "string";
}
function appendOwnerState(pt, yt, ir) {
  return pt === void 0 || isHostComponent(pt) ? yt : {
    ...yt,
    ownerState: {
      ...yt.ownerState,
      ...ir
    }
  };
}
function resolveComponentProps(pt, yt, ir) {
  return typeof pt == "function" ? pt(yt, ir) : pt;
}
function extractEventHandlers(pt, yt = []) {
  if (pt === void 0)
    return {};
  const ir = {};
  return Object.keys(pt).filter((ti) => ti.match(/^on[A-Z]/) && typeof pt[ti] == "function" && !yt.includes(ti)).forEach((ti) => {
    ir[ti] = pt[ti];
  }), ir;
}
function omitEventHandlers(pt) {
  if (pt === void 0)
    return {};
  const yt = {};
  return Object.keys(pt).filter((ir) => !(ir.match(/^on[A-Z]/) && typeof pt[ir] == "function")).forEach((ir) => {
    yt[ir] = pt[ir];
  }), yt;
}
function mergeSlotProps(pt) {
  const {
    getSlotProps: yt,
    additionalProps: ir,
    externalSlotProps: ti,
    externalForwardedProps: ii,
    className: ui
  } = pt;
  if (!yt) {
    const mi = clsx(ir == null ? void 0 : ir.className, ui, ii == null ? void 0 : ii.className, ti == null ? void 0 : ti.className), Ti = {
      ...ir == null ? void 0 : ir.style,
      ...ii == null ? void 0 : ii.style,
      ...ti == null ? void 0 : ti.style
    }, vi = {
      ...ir,
      ...ii,
      ...ti
    };
    return mi.length > 0 && (vi.className = mi), Object.keys(Ti).length > 0 && (vi.style = Ti), {
      props: vi,
      internalRef: void 0
    };
  }
  const ai = extractEventHandlers({
    ...ii,
    ...ti
  }), li = omitEventHandlers(ti), oi = omitEventHandlers(ii), si = yt(ai), di = clsx(si == null ? void 0 : si.className, ir == null ? void 0 : ir.className, ui, ii == null ? void 0 : ii.className, ti == null ? void 0 : ti.className), fi = {
    ...si == null ? void 0 : si.style,
    ...ir == null ? void 0 : ir.style,
    ...ii == null ? void 0 : ii.style,
    ...ti == null ? void 0 : ti.style
  }, gi = {
    ...si,
    ...ir,
    ...oi,
    ...li
  };
  return di.length > 0 && (gi.className = di), Object.keys(fi).length > 0 && (gi.style = fi), {
    props: gi,
    internalRef: si.ref
  };
}
function useSlot(pt, yt) {
  const {
    className: ir,
    elementType: ti,
    ownerState: ii,
    externalForwardedProps: ui,
    internalForwardedProps: ai,
    shouldForwardComponentProp: li = !1,
    ...oi
  } = yt, {
    component: si,
    slots: di = {
      [pt]: void 0
    },
    slotProps: fi = {
      [pt]: void 0
    },
    ...gi
  } = ui, mi = di[pt] || ti, Ti = resolveComponentProps(fi[pt], ii), {
    props: {
      component: vi,
      ...xi
    },
    internalRef: Si
  } = mergeSlotProps({
    className: ir,
    ...oi,
    externalForwardedProps: pt === "root" ? gi : void 0,
    externalSlotProps: Ti
  }), Pi = useForkRef(Si, Ti == null ? void 0 : Ti.ref, yt.ref), $i = pt === "root" ? vi || si : vi, Oi = appendOwnerState(mi, {
    ...pt === "root" && !si && !di[pt] && ai,
    ...pt !== "root" && !di[pt] && ai,
    ...xi,
    ...$i && !li && {
      as: $i
    },
    ...$i && li && {
      component: $i
    },
    ref: Pi
  }, ii);
  return [mi, Oi];
}
function getTypeByValue(pt) {
  const yt = typeof pt;
  switch (yt) {
    case "number":
      return Number.isNaN(pt) ? "NaN" : Number.isFinite(pt) ? pt !== Math.floor(pt) ? "float" : "number" : "Infinity";
    case "object":
      return pt === null ? "null" : pt.constructor.name;
    default:
      return yt;
  }
}
function requiredInteger(pt, yt, ir, ti) {
  const ii = pt[yt];
  if (ii == null || !Number.isInteger(ii)) {
    const ui = getTypeByValue(ii);
    return new RangeError(`Invalid ${ti} \`${yt}\` of type \`${ui}\` supplied to \`${ir}\`, expected \`integer\`.`);
  }
  return null;
}
function validator(pt, yt, ir, ti) {
  return pt[yt] === void 0 ? null : requiredInteger(pt, yt, ir, ti);
}
function validatorNoop() {
  return null;
}
validator.isRequired = requiredInteger;
validatorNoop.isRequired = validatorNoop;
const integerPropType = process.env.NODE_ENV === "production" ? validatorNoop : validator;
function getPaperUtilityClass(pt) {
  return generateUtilityClass("MuiPaper", pt);
}
generateUtilityClasses("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const useUtilityClasses$9 = (pt) => {
  const {
    square: yt,
    elevation: ir,
    variant: ti,
    classes: ii
  } = pt, ui = {
    root: ["root", ti, !yt && "rounded", ti === "elevation" && `elevation${ir}`]
  };
  return composeClasses(ui, getPaperUtilityClass, ii);
}, PaperRoot = styled("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (pt, yt) => {
    const {
      ownerState: ir
    } = pt;
    return [yt.root, yt[ir.variant], !ir.square && yt.rounded, ir.variant === "elevation" && yt[`elevation${ir.elevation}`]];
  }
})(memoTheme(({
  theme: pt
}) => ({
  backgroundColor: (pt.vars || pt).palette.background.paper,
  color: (pt.vars || pt).palette.text.primary,
  transition: pt.transitions.create("box-shadow"),
  variants: [{
    props: ({
      ownerState: yt
    }) => !yt.square,
    style: {
      borderRadius: pt.shape.borderRadius
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      border: `1px solid ${(pt.vars || pt).palette.divider}`
    }
  }, {
    props: {
      variant: "elevation"
    },
    style: {
      boxShadow: "var(--Paper-shadow)",
      backgroundImage: "var(--Paper-overlay)"
    }
  }]
}))), Paper = /* @__PURE__ */ React.forwardRef(function pt(yt, ir) {
  var mi;
  const ti = useDefaultProps({
    props: yt,
    name: "MuiPaper"
  }), ii = useTheme(), {
    className: ui,
    component: ai = "div",
    elevation: li = 1,
    square: oi = !1,
    variant: si = "elevation",
    ...di
  } = ti, fi = {
    ...ti,
    component: ai,
    elevation: li,
    square: oi,
    variant: si
  }, gi = useUtilityClasses$9(fi);
  return process.env.NODE_ENV !== "production" && ii.shadows[li] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${li}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${li}]\` is defined.`].join(`
`)), /* @__PURE__ */ jsxRuntimeExports$1.jsx(PaperRoot, {
    as: ai,
    ownerState: fi,
    className: clsx(gi.root, ui),
    ref: ir,
    ...di,
    style: {
      ...si === "elevation" && {
        "--Paper-shadow": (ii.vars || ii).shadows[li],
        ...ii.vars && {
          "--Paper-overlay": (mi = ii.vars.overlays) == null ? void 0 : mi[li]
        },
        ...!ii.vars && ii.palette.mode === "dark" && {
          "--Paper-overlay": `linear-gradient(${alpha("#fff", getOverlayAlpha(li))}, ${alpha("#fff", getOverlayAlpha(li))})`
        }
      },
      ...di.style
    }
  });
});
process.env.NODE_ENV !== "production" && (Paper.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes$1.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,
  /**
   * @ignore
   */
  className: PropTypes$1.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: chainPropTypes(integerPropType, (pt) => {
    const {
      elevation: yt,
      variant: ir
    } = pt;
    return yt > 0 && ir === "outlined" ? new Error(`MUI: Combining \`elevation={${yt}}\` with \`variant="${ir}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: PropTypes$1.bool,
  /**
   * @ignore
   */
  style: PropTypes$1.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: PropTypes$1.oneOfType([PropTypes$1.oneOf(["elevation", "outlined"]), PropTypes$1.string])
});
const refType = PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object]);
function isFocusVisible(pt) {
  try {
    return pt.matches(":focus-visible");
  } catch {
    process.env.NODE_ENV !== "production" && !window.navigator.userAgent.includes("jsdom") && console.warn(["MUI: The `:focus-visible` pseudo class is not supported in this browser.", "Some components rely on this feature to work properly."].join(`
`));
  }
  return !1;
}
class LazyRipple {
  constructor() {
    Hm(this, "mountEffect", () => {
      this.shouldMount && !this.didMount && this.ref.current !== null && (this.didMount = !0, this.mounted.resolve());
    });
    this.ref = {
      current: null
    }, this.mounted = null, this.didMount = !1, this.shouldMount = !1, this.setShouldMount = null;
  }
  /** React ref to the ripple instance */
  /** If the ripple component should be mounted */
  /** Promise that resolves when the ripple component is mounted */
  /** If the ripple component has been mounted */
  /** React state hook setter */
  static create() {
    return new LazyRipple();
  }
  static use() {
    const yt = useLazyRef(LazyRipple.create).current, [ir, ti] = React.useState(!1);
    return yt.shouldMount = ir, yt.setShouldMount = ti, React.useEffect(yt.mountEffect, [ir]), yt;
  }
  mount() {
    return this.mounted || (this.mounted = createControlledPromise(), this.shouldMount = !0, this.setShouldMount(this.shouldMount)), this.mounted;
  }
  /* Ripple API */
  start(...yt) {
    this.mount().then(() => {
      var ir;
      return (ir = this.ref.current) == null ? void 0 : ir.start(...yt);
    });
  }
  stop(...yt) {
    this.mount().then(() => {
      var ir;
      return (ir = this.ref.current) == null ? void 0 : ir.stop(...yt);
    });
  }
  pulsate(...yt) {
    this.mount().then(() => {
      var ir;
      return (ir = this.ref.current) == null ? void 0 : ir.pulsate(...yt);
    });
  }
}
function useLazyRipple() {
  return LazyRipple.use();
}
function createControlledPromise() {
  let pt, yt;
  const ir = new Promise((ti, ii) => {
    pt = ti, yt = ii;
  });
  return ir.resolve = pt, ir.reject = yt, ir;
}
function Ripple(pt) {
  const {
    className: yt,
    classes: ir,
    pulsate: ti = !1,
    rippleX: ii,
    rippleY: ui,
    rippleSize: ai,
    in: li,
    onExited: oi,
    timeout: si
  } = pt, [di, fi] = React.useState(!1), gi = clsx(yt, ir.ripple, ir.rippleVisible, ti && ir.ripplePulsate), mi = {
    width: ai,
    height: ai,
    top: -(ai / 2) + ui,
    left: -(ai / 2) + ii
  }, Ti = clsx(ir.child, di && ir.childLeaving, ti && ir.childPulsate);
  return !li && !di && fi(!0), React.useEffect(() => {
    if (!li && oi != null) {
      const vi = setTimeout(oi, si);
      return () => {
        clearTimeout(vi);
      };
    }
  }, [oi, li, si]), /* @__PURE__ */ jsxRuntimeExports$1.jsx("span", {
    className: gi,
    style: mi,
    children: /* @__PURE__ */ jsxRuntimeExports$1.jsx("span", {
      className: Ti
    })
  });
}
process.env.NODE_ENV !== "production" && (Ripple.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object.isRequired,
  className: PropTypes$1.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: PropTypes$1.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: PropTypes$1.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: PropTypes$1.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: PropTypes$1.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: PropTypes$1.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: PropTypes$1.number,
  /**
   * exit delay
   */
  timeout: PropTypes$1.number.isRequired
});
const touchRippleClasses = generateUtilityClasses("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), DURATION = 550, DELAY_RIPPLE = 80, enterKeyframe = keyframes`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`, exitKeyframe = keyframes`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`, pulsateKeyframe = keyframes`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`, TouchRippleRoot = styled("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), TouchRippleRipple = styled(Ripple, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})`
  opacity: 0;
  position: absolute;

  &.${touchRippleClasses.rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${enterKeyframe};
    animation-duration: ${DURATION}ms;
    animation-timing-function: ${({
  theme: pt
}) => pt.transitions.easing.easeInOut};
  }

  &.${touchRippleClasses.ripplePulsate} {
    animation-duration: ${({
  theme: pt
}) => pt.transitions.duration.shorter}ms;
  }

  & .${touchRippleClasses.child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${touchRippleClasses.childLeaving} {
    opacity: 0;
    animation-name: ${exitKeyframe};
    animation-duration: ${DURATION}ms;
    animation-timing-function: ${({
  theme: pt
}) => pt.transitions.easing.easeInOut};
  }

  & .${touchRippleClasses.childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${pulsateKeyframe};
    animation-duration: 2500ms;
    animation-timing-function: ${({
  theme: pt
}) => pt.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`, TouchRipple = /* @__PURE__ */ React.forwardRef(function pt(yt, ir) {
  const ti = useDefaultProps({
    props: yt,
    name: "MuiTouchRipple"
  }), {
    center: ii = !1,
    classes: ui = {},
    className: ai,
    ...li
  } = ti, [oi, si] = React.useState([]), di = React.useRef(0), fi = React.useRef(null);
  React.useEffect(() => {
    fi.current && (fi.current(), fi.current = null);
  }, [oi]);
  const gi = React.useRef(!1), mi = useTimeout(), Ti = React.useRef(null), vi = React.useRef(null), xi = React.useCallback((Oi) => {
    const {
      pulsate: Di,
      rippleX: Mi,
      rippleY: Oo,
      rippleSize: io,
      cb: xo
    } = Oi;
    si((fo) => [...fo, /* @__PURE__ */ jsxRuntimeExports$1.jsx(TouchRippleRipple, {
      classes: {
        ripple: clsx(ui.ripple, touchRippleClasses.ripple),
        rippleVisible: clsx(ui.rippleVisible, touchRippleClasses.rippleVisible),
        ripplePulsate: clsx(ui.ripplePulsate, touchRippleClasses.ripplePulsate),
        child: clsx(ui.child, touchRippleClasses.child),
        childLeaving: clsx(ui.childLeaving, touchRippleClasses.childLeaving),
        childPulsate: clsx(ui.childPulsate, touchRippleClasses.childPulsate)
      },
      timeout: DURATION,
      pulsate: Di,
      rippleX: Mi,
      rippleY: Oo,
      rippleSize: io
    }, di.current)]), di.current += 1, fi.current = xo;
  }, [ui]), Si = React.useCallback((Oi = {}, Di = {}, Mi = () => {
  }) => {
    const {
      pulsate: Oo = !1,
      center: io = ii || Di.pulsate,
      fakeElement: xo = !1
      // For test purposes
    } = Di;
    if ((Oi == null ? void 0 : Oi.type) === "mousedown" && gi.current) {
      gi.current = !1;
      return;
    }
    (Oi == null ? void 0 : Oi.type) === "touchstart" && (gi.current = !0);
    const fo = xo ? null : vi.current, _o = fo ? fo.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let Li, Co, Ni;
    if (io || Oi === void 0 || Oi.clientX === 0 && Oi.clientY === 0 || !Oi.clientX && !Oi.touches)
      Li = Math.round(_o.width / 2), Co = Math.round(_o.height / 2);
    else {
      const {
        clientX: Yi,
        clientY: Vo
      } = Oi.touches && Oi.touches.length > 0 ? Oi.touches[0] : Oi;
      Li = Math.round(Yi - _o.left), Co = Math.round(Vo - _o.top);
    }
    if (io)
      Ni = Math.sqrt((2 * _o.width ** 2 + _o.height ** 2) / 3), Ni % 2 === 0 && (Ni += 1);
    else {
      const Yi = Math.max(Math.abs((fo ? fo.clientWidth : 0) - Li), Li) * 2 + 2, Vo = Math.max(Math.abs((fo ? fo.clientHeight : 0) - Co), Co) * 2 + 2;
      Ni = Math.sqrt(Yi ** 2 + Vo ** 2);
    }
    Oi != null && Oi.touches ? Ti.current === null && (Ti.current = () => {
      xi({
        pulsate: Oo,
        rippleX: Li,
        rippleY: Co,
        rippleSize: Ni,
        cb: Mi
      });
    }, mi.start(DELAY_RIPPLE, () => {
      Ti.current && (Ti.current(), Ti.current = null);
    })) : xi({
      pulsate: Oo,
      rippleX: Li,
      rippleY: Co,
      rippleSize: Ni,
      cb: Mi
    });
  }, [ii, xi, mi]), Pi = React.useCallback(() => {
    Si({}, {
      pulsate: !0
    });
  }, [Si]), $i = React.useCallback((Oi, Di) => {
    if (mi.clear(), (Oi == null ? void 0 : Oi.type) === "touchend" && Ti.current) {
      Ti.current(), Ti.current = null, mi.start(0, () => {
        $i(Oi, Di);
      });
      return;
    }
    Ti.current = null, si((Mi) => Mi.length > 0 ? Mi.slice(1) : Mi), fi.current = Di;
  }, [mi]);
  return React.useImperativeHandle(ir, () => ({
    pulsate: Pi,
    start: Si,
    stop: $i
  }), [Pi, Si, $i]), /* @__PURE__ */ jsxRuntimeExports$1.jsx(TouchRippleRoot, {
    className: clsx(touchRippleClasses.root, ui.root, ai),
    ref: vi,
    ...li,
    children: /* @__PURE__ */ jsxRuntimeExports$1.jsx(TransitionGroup, {
      component: null,
      exit: !0,
      children: oi
    })
  });
});
process.env.NODE_ENV !== "production" && (TouchRipple.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: PropTypes$1.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,
  /**
   * @ignore
   */
  className: PropTypes$1.string
});
function getButtonBaseUtilityClass(pt) {
  return generateUtilityClass("MuiButtonBase", pt);
}
const buttonBaseClasses = generateUtilityClasses("MuiButtonBase", ["root", "disabled", "focusVisible"]), useUtilityClasses$8 = (pt) => {
  const {
    disabled: yt,
    focusVisible: ir,
    focusVisibleClassName: ti,
    classes: ii
  } = pt, ai = composeClasses({
    root: ["root", yt && "disabled", ir && "focusVisible"]
  }, getButtonBaseUtilityClass, ii);
  return ir && ti && (ai.root += ` ${ti}`), ai;
}, ButtonBaseRoot = styled("button", {
  name: "MuiButtonBase",
  slot: "Root"
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${buttonBaseClasses.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), ButtonBase = /* @__PURE__ */ React.forwardRef(function pt(yt, ir) {
  const ti = useDefaultProps({
    props: yt,
    name: "MuiButtonBase"
  }), {
    action: ii,
    centerRipple: ui = !1,
    children: ai,
    className: li,
    component: oi = "button",
    disabled: si = !1,
    disableRipple: di = !1,
    disableTouchRipple: fi = !1,
    focusRipple: gi = !1,
    focusVisibleClassName: mi,
    LinkComponent: Ti = "a",
    onBlur: vi,
    onClick: xi,
    onContextMenu: Si,
    onDragLeave: Pi,
    onFocus: $i,
    onFocusVisible: Oi,
    onKeyDown: Di,
    onKeyUp: Mi,
    onMouseDown: Oo,
    onMouseLeave: io,
    onMouseUp: xo,
    onTouchEnd: fo,
    onTouchMove: _o,
    onTouchStart: Li,
    tabIndex: Co = 0,
    TouchRippleProps: Ni,
    touchRippleRef: Yi,
    type: Vo,
    ...No
  } = ti, Ui = React.useRef(null), jo = useLazyRipple(), Wi = useForkRef(jo.ref, Yi), [ji, Hi] = React.useState(!1);
  si && ji && Hi(!1), React.useImperativeHandle(ii, () => ({
    focusVisible: () => {
      Hi(!0), Ui.current.focus();
    }
  }), []);
  const zo = jo.shouldMount && !di && !si;
  React.useEffect(() => {
    ji && gi && !di && jo.pulsate();
  }, [di, gi, ji, jo]);
  const Lo = useRippleHandler(jo, "start", Oo, fi), sa = useRippleHandler(jo, "stop", Si, fi), Ko = useRippleHandler(jo, "stop", Pi, fi), ca = useRippleHandler(jo, "stop", xo, fi), pa = useRippleHandler(jo, "stop", (ja) => {
    ji && ja.preventDefault(), io && io(ja);
  }, fi), ga = useRippleHandler(jo, "start", Li, fi), ia = useRippleHandler(jo, "stop", fo, fi), ra = useRippleHandler(jo, "stop", _o, fi), qo = useRippleHandler(jo, "stop", (ja) => {
    isFocusVisible(ja.target) || Hi(!1), vi && vi(ja);
  }, !1), xa = useEventCallback((ja) => {
    Ui.current || (Ui.current = ja.currentTarget), isFocusVisible(ja.target) && (Hi(!0), Oi && Oi(ja)), $i && $i(ja);
  }), $a = () => {
    const ja = Ui.current;
    return oi && oi !== "button" && !(ja.tagName === "A" && ja.href);
  }, ys = useEventCallback((ja) => {
    gi && !ja.repeat && ji && ja.key === " " && jo.stop(ja, () => {
      jo.start(ja);
    }), ja.target === ja.currentTarget && $a() && ja.key === " " && ja.preventDefault(), Di && Di(ja), ja.target === ja.currentTarget && $a() && ja.key === "Enter" && !si && (ja.preventDefault(), xi && xi(ja));
  }), Ss = useEventCallback((ja) => {
    gi && ja.key === " " && ji && !ja.defaultPrevented && jo.stop(ja, () => {
      jo.pulsate(ja);
    }), Mi && Mi(ja), xi && ja.target === ja.currentTarget && $a() && ja.key === " " && !ja.defaultPrevented && xi(ja);
  });
  let Xa = oi;
  Xa === "button" && (No.href || No.to) && (Xa = Ti);
  const Es = {};
  if (Xa === "button") {
    const ja = !!No.formAction;
    Es.type = Vo === void 0 && !ja ? "button" : Vo, Es.disabled = si;
  } else
    !No.href && !No.to && (Es.role = "button"), si && (Es["aria-disabled"] = si);
  const Rs = useForkRef(ir, Ui), La = {
    ...ti,
    centerRipple: ui,
    component: oi,
    disabled: si,
    disableRipple: di,
    disableTouchRipple: fi,
    focusRipple: gi,
    tabIndex: Co,
    focusVisible: ji
  }, Ja = useUtilityClasses$8(La);
  return /* @__PURE__ */ jsxRuntimeExports$1.jsxs(ButtonBaseRoot, {
    as: Xa,
    className: clsx(Ja.root, li),
    ownerState: La,
    onBlur: qo,
    onClick: xi,
    onContextMenu: sa,
    onFocus: xa,
    onKeyDown: ys,
    onKeyUp: Ss,
    onMouseDown: Lo,
    onMouseLeave: pa,
    onMouseUp: ca,
    onDragLeave: Ko,
    onTouchEnd: ia,
    onTouchMove: ra,
    onTouchStart: ga,
    ref: Rs,
    tabIndex: si ? -1 : Co,
    type: Vo,
    ...Es,
    ...No,
    children: [ai, zo ? /* @__PURE__ */ jsxRuntimeExports$1.jsx(TouchRipple, {
      ref: Wi,
      center: ui,
      ...Ni
    }) : null]
  });
});
function useRippleHandler(pt, yt, ir, ti = !1) {
  return useEventCallback((ii) => (ir && ir(ii), ti || pt[yt](ii), !0));
}
process.env.NODE_ENV !== "production" && (ButtonBase.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: refType,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: PropTypes$1.bool,
  /**
   * The content of the component.
   */
  children: PropTypes$1.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,
  /**
   * @ignore
   */
  className: PropTypes$1.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef$1,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes$1.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes$1.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: PropTypes$1.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: PropTypes$1.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes$1.string,
  /**
   * @ignore
   */
  formAction: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.string]),
  /**
   * @ignore
   */
  href: PropTypes$1.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: PropTypes$1.elementType,
  /**
   * @ignore
   */
  onBlur: PropTypes$1.func,
  /**
   * @ignore
   */
  onClick: PropTypes$1.func,
  /**
   * @ignore
   */
  onContextMenu: PropTypes$1.func,
  /**
   * @ignore
   */
  onDragLeave: PropTypes$1.func,
  /**
   * @ignore
   */
  onFocus: PropTypes$1.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: PropTypes$1.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes$1.func,
  /**
   * @ignore
   */
  onKeyUp: PropTypes$1.func,
  /**
   * @ignore
   */
  onMouseDown: PropTypes$1.func,
  /**
   * @ignore
   */
  onMouseLeave: PropTypes$1.func,
  /**
   * @ignore
   */
  onMouseUp: PropTypes$1.func,
  /**
   * @ignore
   */
  onTouchEnd: PropTypes$1.func,
  /**
   * @ignore
   */
  onTouchMove: PropTypes$1.func,
  /**
   * @ignore
   */
  onTouchStart: PropTypes$1.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),
  /**
   * @default 0
   */
  tabIndex: PropTypes$1.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: PropTypes$1.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.shape({
    current: PropTypes$1.shape({
      pulsate: PropTypes$1.func.isRequired,
      start: PropTypes$1.func.isRequired,
      stop: PropTypes$1.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: PropTypes$1.oneOfType([PropTypes$1.oneOf(["button", "reset", "submit"]), PropTypes$1.string])
});
function hasCorrectMainProperty(pt) {
  return typeof pt.main == "string";
}
function checkSimplePaletteColorValues(pt, yt = []) {
  if (!hasCorrectMainProperty(pt))
    return !1;
  for (const ir of yt)
    if (!pt.hasOwnProperty(ir) || typeof pt[ir] != "string")
      return !1;
  return !0;
}
function createSimplePaletteValueFilter(pt = []) {
  return ([, yt]) => yt && checkSimplePaletteColorValues(yt, pt);
}
function HTMLElementType(pt, yt, ir, ti, ii) {
  if (process.env.NODE_ENV === "production")
    return null;
  const ui = pt[yt], ai = ii || yt;
  return ui == null ? null : ui && ui.nodeType !== 1 ? new Error(`Invalid ${ti} \`${ai}\` supplied to \`${ir}\`. Expected an HTMLElement.`) : null;
}
function useSlotProps(pt) {
  var fi;
  const {
    elementType: yt,
    externalSlotProps: ir,
    ownerState: ti,
    skipResolvingSlotProps: ii = !1,
    ...ui
  } = pt, ai = ii ? {} : resolveComponentProps(ir, ti), {
    props: li,
    internalRef: oi
  } = mergeSlotProps({
    ...ui,
    externalSlotProps: ai
  }), si = useForkRef(oi, ai == null ? void 0 : ai.ref, (fi = pt.additionalProps) == null ? void 0 : fi.ref);
  return appendOwnerState(yt, {
    ...li,
    ref: si
  }, ti);
}
function isLayoutSupported() {
  return !(/jsdom|HappyDOM/.test(window.navigator.userAgent) || // TODO(v9): Remove the test environment check
  // eslint-disable-next-line mui/consistent-production-guard
  process.env.NODE_ENV === "test");
}
function getReactElementRef(pt) {
  var yt;
  return parseInt(React.version, 10) >= 19 ? ((yt = pt == null ? void 0 : pt.props) == null ? void 0 : yt.ref) || null : (pt == null ? void 0 : pt.ref) || null;
}
function getContainer$1(pt) {
  return typeof pt == "function" ? pt() : pt;
}
const Portal = /* @__PURE__ */ React.forwardRef(function pt(yt, ir) {
  const {
    children: ti,
    container: ii,
    disablePortal: ui = !1
  } = yt, [ai, li] = React.useState(null), oi = useForkRef(/* @__PURE__ */ React.isValidElement(ti) ? getReactElementRef(ti) : null, ir);
  if (useEnhancedEffect(() => {
    ui || li(getContainer$1(ii) || document.body);
  }, [ii, ui]), useEnhancedEffect(() => {
    if (ai && !ui)
      return setRef(ir, ai), () => {
        setRef(ir, null);
      };
  }, [ir, ai, ui]), ui) {
    if (/* @__PURE__ */ React.isValidElement(ti)) {
      const si = {
        ref: oi
      };
      return /* @__PURE__ */ React.cloneElement(ti, si);
    }
    return ti;
  }
  return ai && /* @__PURE__ */ ReactDOM.createPortal(ti, ai);
});
process.env.NODE_ENV !== "production" && (Portal.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: PropTypes$1.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes$1.oneOfType([HTMLElementType, PropTypes$1.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes$1.bool
});
process.env.NODE_ENV !== "production" && (Portal.propTypes = exactProp(Portal.propTypes));
function isClassComponent(pt) {
  const {
    prototype: yt = {}
  } = pt;
  return !!yt.isReactComponent;
}
function acceptingRef(pt, yt, ir, ti, ii) {
  const ui = pt[yt], ai = ii || yt;
  if (ui == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let li;
  const oi = ui.type;
  return typeof oi == "function" && !isClassComponent(oi) && (li = "Did you accidentally use a plain function component for an element instead?"), li !== void 0 ? new Error(`Invalid ${ti} \`${ai}\` supplied to \`${ir}\`. Expected an element that can hold a ref. ${li} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const elementAcceptingRef = chainPropTypes(PropTypes$1.element, acceptingRef);
elementAcceptingRef.isRequired = chainPropTypes(PropTypes$1.element.isRequired, acceptingRef);
const styles$1 = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, Fade = /* @__PURE__ */ React.forwardRef(function pt(yt, ir) {
  const ti = useTheme(), ii = {
    enter: ti.transitions.duration.enteringScreen,
    exit: ti.transitions.duration.leavingScreen
  }, {
    addEndListener: ui,
    appear: ai = !0,
    children: li,
    easing: oi,
    in: si,
    onEnter: di,
    onEntered: fi,
    onEntering: gi,
    onExit: mi,
    onExited: Ti,
    onExiting: vi,
    style: xi,
    timeout: Si = ii,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: Pi = Transition,
    ...$i
  } = yt, Oi = React.useRef(null), Di = useForkRef(Oi, getReactElementRef(li), ir), Mi = (Ni) => (Yi) => {
    if (Ni) {
      const Vo = Oi.current;
      Yi === void 0 ? Ni(Vo) : Ni(Vo, Yi);
    }
  }, Oo = Mi(gi), io = Mi((Ni, Yi) => {
    reflow(Ni);
    const Vo = getTransitionProps({
      style: xi,
      timeout: Si,
      easing: oi
    }, {
      mode: "enter"
    });
    Ni.style.webkitTransition = ti.transitions.create("opacity", Vo), Ni.style.transition = ti.transitions.create("opacity", Vo), di && di(Ni, Yi);
  }), xo = Mi(fi), fo = Mi(vi), _o = Mi((Ni) => {
    const Yi = getTransitionProps({
      style: xi,
      timeout: Si,
      easing: oi
    }, {
      mode: "exit"
    });
    Ni.style.webkitTransition = ti.transitions.create("opacity", Yi), Ni.style.transition = ti.transitions.create("opacity", Yi), mi && mi(Ni);
  }), Li = Mi(Ti), Co = (Ni) => {
    ui && ui(Oi.current, Ni);
  };
  return /* @__PURE__ */ jsxRuntimeExports$1.jsx(Pi, {
    appear: ai,
    in: si,
    nodeRef: Oi,
    onEnter: io,
    onEntered: xo,
    onEntering: Oo,
    onExit: _o,
    onExited: Li,
    onExiting: fo,
    addEndListener: Co,
    timeout: Si,
    ...$i,
    children: (Ni, {
      ownerState: Yi,
      ...Vo
    }) => /* @__PURE__ */ React.cloneElement(li, {
      style: {
        opacity: 0,
        visibility: Ni === "exited" && !si ? "hidden" : void 0,
        ...styles$1[Ni],
        ...xi,
        ...li.props.style
      },
      ref: Di,
      ...Vo
    })
  });
});
process.env.NODE_ENV !== "production" && (Fade.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes$1.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: PropTypes$1.bool,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: PropTypes$1.oneOfType([PropTypes$1.shape({
    enter: PropTypes$1.string,
    exit: PropTypes$1.string
  }), PropTypes$1.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes$1.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes$1.func,
  /**
   * @ignore
   */
  onEntered: PropTypes$1.func,
  /**
   * @ignore
   */
  onEntering: PropTypes$1.func,
  /**
   * @ignore
   */
  onExit: PropTypes$1.func,
  /**
   * @ignore
   */
  onExited: PropTypes$1.func,
  /**
   * @ignore
   */
  onExiting: PropTypes$1.func,
  /**
   * @ignore
   */
  style: PropTypes$1.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.shape({
    appear: PropTypes$1.number,
    enter: PropTypes$1.number,
    exit: PropTypes$1.number
  })])
});
function getBackdropUtilityClass(pt) {
  return generateUtilityClass("MuiBackdrop", pt);
}
generateUtilityClasses("MuiBackdrop", ["root", "invisible"]);
const useUtilityClasses$7 = (pt) => {
  const {
    classes: yt,
    invisible: ir
  } = pt;
  return composeClasses({
    root: ["root", ir && "invisible"]
  }, getBackdropUtilityClass, yt);
}, BackdropRoot = styled("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (pt, yt) => {
    const {
      ownerState: ir
    } = pt;
    return [yt.root, ir.invisible && yt.invisible];
  }
})({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent",
  variants: [{
    props: {
      invisible: !0
    },
    style: {
      backgroundColor: "transparent"
    }
  }]
}), Backdrop = /* @__PURE__ */ React.forwardRef(function pt(yt, ir) {
  const ti = useDefaultProps({
    props: yt,
    name: "MuiBackdrop"
  }), {
    children: ii,
    className: ui,
    component: ai = "div",
    invisible: li = !1,
    open: oi,
    components: si = {},
    componentsProps: di = {},
    slotProps: fi = {},
    slots: gi = {},
    TransitionComponent: mi,
    transitionDuration: Ti,
    ...vi
  } = ti, xi = {
    ...ti,
    component: ai,
    invisible: li
  }, Si = useUtilityClasses$7(xi), Pi = {
    transition: mi,
    root: si.Root,
    ...gi
  }, $i = {
    ...di,
    ...fi
  }, Oi = {
    component: ai,
    slots: Pi,
    slotProps: $i
  }, [Di, Mi] = useSlot("root", {
    elementType: BackdropRoot,
    externalForwardedProps: Oi,
    className: clsx(Si.root, ui),
    ownerState: xi
  }), [Oo, io] = useSlot("transition", {
    elementType: Fade,
    externalForwardedProps: Oi,
    ownerState: xi
  });
  return /* @__PURE__ */ jsxRuntimeExports$1.jsx(Oo, {
    in: oi,
    timeout: Ti,
    ...vi,
    ...io,
    children: /* @__PURE__ */ jsxRuntimeExports$1.jsx(Di, {
      "aria-hidden": !0,
      ...Mi,
      ref: ir,
      children: ii
    })
  });
});
process.env.NODE_ENV !== "production" && (Backdrop.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes$1.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,
  /**
   * @ignore
   */
  className: PropTypes$1.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: PropTypes$1.shape({
    Root: PropTypes$1.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: PropTypes$1.shape({
    root: PropTypes$1.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: PropTypes$1.bool,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes$1.bool.isRequired,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes$1.shape({
    root: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object]),
    transition: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes$1.shape({
    root: PropTypes$1.elementType,
    transition: PropTypes$1.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   * @deprecated Use `slots.transition` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: PropTypes$1.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes$1.oneOfType([PropTypes$1.number, PropTypes$1.shape({
    appear: PropTypes$1.number,
    enter: PropTypes$1.number,
    exit: PropTypes$1.number
  })])
});
function getScrollbarSize(pt = window) {
  const yt = pt.document.documentElement.clientWidth;
  return pt.innerWidth - yt;
}
function isOverflowing(pt) {
  const yt = ownerDocument(pt);
  return yt.body === pt ? ownerWindow(pt).innerWidth > yt.documentElement.clientWidth : pt.scrollHeight > pt.clientHeight;
}
function ariaHidden(pt, yt) {
  yt ? pt.setAttribute("aria-hidden", "true") : pt.removeAttribute("aria-hidden");
}
function getPaddingRight(pt) {
  return parseFloat(ownerWindow(pt).getComputedStyle(pt).paddingRight) || 0;
}
function isAriaHiddenForbiddenOnElement(pt) {
  const ir = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].includes(pt.tagName), ti = pt.tagName === "INPUT" && pt.getAttribute("type") === "hidden";
  return ir || ti;
}
function ariaHiddenSiblings(pt, yt, ir, ti, ii) {
  const ui = [yt, ir, ...ti];
  [].forEach.call(pt.children, (ai) => {
    const li = !ui.includes(ai), oi = !isAriaHiddenForbiddenOnElement(ai);
    li && oi && ariaHidden(ai, ii);
  });
}
function findIndexOf(pt, yt) {
  let ir = -1;
  return pt.some((ti, ii) => yt(ti) ? (ir = ii, !0) : !1), ir;
}
function handleContainer(pt, yt) {
  const ir = [], ti = pt.container;
  if (!yt.disableScrollLock) {
    if (isOverflowing(ti)) {
      const ai = getScrollbarSize(ownerWindow(ti));
      ir.push({
        value: ti.style.paddingRight,
        property: "padding-right",
        el: ti
      }), ti.style.paddingRight = `${getPaddingRight(ti) + ai}px`;
      const li = ownerDocument(ti).querySelectorAll(".mui-fixed");
      [].forEach.call(li, (oi) => {
        ir.push({
          value: oi.style.paddingRight,
          property: "padding-right",
          el: oi
        }), oi.style.paddingRight = `${getPaddingRight(oi) + ai}px`;
      });
    }
    let ui;
    if (ti.parentNode instanceof DocumentFragment)
      ui = ownerDocument(ti).body;
    else {
      const ai = ti.parentElement, li = ownerWindow(ti);
      ui = (ai == null ? void 0 : ai.nodeName) === "HTML" && li.getComputedStyle(ai).overflowY === "scroll" ? ai : ti;
    }
    ir.push({
      value: ui.style.overflow,
      property: "overflow",
      el: ui
    }, {
      value: ui.style.overflowX,
      property: "overflow-x",
      el: ui
    }, {
      value: ui.style.overflowY,
      property: "overflow-y",
      el: ui
    }), ui.style.overflow = "hidden";
  }
  return () => {
    ir.forEach(({
      value: ui,
      el: ai,
      property: li
    }) => {
      ui ? ai.style.setProperty(li, ui) : ai.style.removeProperty(li);
    });
  };
}
function getHiddenSiblings(pt) {
  const yt = [];
  return [].forEach.call(pt.children, (ir) => {
    ir.getAttribute("aria-hidden") === "true" && yt.push(ir);
  }), yt;
}
class ModalManager {
  constructor() {
    this.modals = [], this.containers = [];
  }
  add(yt, ir) {
    let ti = this.modals.indexOf(yt);
    if (ti !== -1)
      return ti;
    ti = this.modals.length, this.modals.push(yt), yt.modalRef && ariaHidden(yt.modalRef, !1);
    const ii = getHiddenSiblings(ir);
    ariaHiddenSiblings(ir, yt.mount, yt.modalRef, ii, !0);
    const ui = findIndexOf(this.containers, (ai) => ai.container === ir);
    return ui !== -1 ? (this.containers[ui].modals.push(yt), ti) : (this.containers.push({
      modals: [yt],
      container: ir,
      restore: null,
      hiddenSiblings: ii
    }), ti);
  }
  mount(yt, ir) {
    const ti = findIndexOf(this.containers, (ui) => ui.modals.includes(yt)), ii = this.containers[ti];
    ii.restore || (ii.restore = handleContainer(ii, ir));
  }
  remove(yt, ir = !0) {
    const ti = this.modals.indexOf(yt);
    if (ti === -1)
      return ti;
    const ii = findIndexOf(this.containers, (ai) => ai.modals.includes(yt)), ui = this.containers[ii];
    if (ui.modals.splice(ui.modals.indexOf(yt), 1), this.modals.splice(ti, 1), ui.modals.length === 0)
      ui.restore && ui.restore(), yt.modalRef && ariaHidden(yt.modalRef, ir), ariaHiddenSiblings(ui.container, yt.mount, yt.modalRef, ui.hiddenSiblings, !1), this.containers.splice(ii, 1);
    else {
      const ai = ui.modals[ui.modals.length - 1];
      ai.modalRef && ariaHidden(ai.modalRef, !1);
    }
    return ti;
  }
  isTopModal(yt) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === yt;
  }
}
function activeElement(pt) {
  var ir;
  let yt = pt.activeElement;
  for (; ((ir = yt == null ? void 0 : yt.shadowRoot) == null ? void 0 : ir.activeElement) != null; )
    yt = yt.shadowRoot.activeElement;
  return yt;
}
const candidatesSelector = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function getTabIndex(pt) {
  const yt = parseInt(pt.getAttribute("tabindex") || "", 10);
  return Number.isNaN(yt) ? pt.contentEditable === "true" || (pt.nodeName === "AUDIO" || pt.nodeName === "VIDEO" || pt.nodeName === "DETAILS") && pt.getAttribute("tabindex") === null ? 0 : pt.tabIndex : yt;
}
function isNonTabbableRadio(pt) {
  if (pt.tagName !== "INPUT" || pt.type !== "radio" || !pt.name)
    return !1;
  const yt = (ti) => pt.ownerDocument.querySelector(`input[type="radio"]${ti}`);
  let ir = yt(`[name="${pt.name}"]:checked`);
  return ir || (ir = yt(`[name="${pt.name}"]`)), ir !== pt;
}
function isNodeMatchingSelectorFocusable(pt) {
  return !(pt.disabled || pt.tagName === "INPUT" && pt.type === "hidden" || isNonTabbableRadio(pt));
}
function defaultGetTabbable(pt) {
  const yt = [], ir = [];
  return Array.from(pt.querySelectorAll(candidatesSelector)).forEach((ti, ii) => {
    const ui = getTabIndex(ti);
    ui === -1 || !isNodeMatchingSelectorFocusable(ti) || (ui === 0 ? yt.push(ti) : ir.push({
      documentOrder: ii,
      tabIndex: ui,
      node: ti
    }));
  }), ir.sort((ti, ii) => ti.tabIndex === ii.tabIndex ? ti.documentOrder - ii.documentOrder : ti.tabIndex - ii.tabIndex).map((ti) => ti.node).concat(yt);
}
function defaultIsEnabled() {
  return !0;
}
function FocusTrap(pt) {
  const {
    children: yt,
    disableAutoFocus: ir = !1,
    disableEnforceFocus: ti = !1,
    disableRestoreFocus: ii = !1,
    getTabbable: ui = defaultGetTabbable,
    isEnabled: ai = defaultIsEnabled,
    open: li
  } = pt, oi = React.useRef(!1), si = React.useRef(null), di = React.useRef(null), fi = React.useRef(null), gi = React.useRef(null), mi = React.useRef(!1), Ti = React.useRef(null), vi = useForkRef(getReactElementRef(yt), Ti), xi = React.useRef(null);
  React.useEffect(() => {
    !li || !Ti.current || (mi.current = !ir);
  }, [ir, li]), React.useEffect(() => {
    if (!li || !Ti.current)
      return;
    const $i = ownerDocument(Ti.current), Oi = activeElement($i);
    return Ti.current.contains(Oi) || (Ti.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), Ti.current.setAttribute("tabIndex", "-1")), mi.current && Ti.current.focus()), () => {
      ii || (fi.current && fi.current.focus && (oi.current = !0, fi.current.focus()), fi.current = null);
    };
  }, [li]), React.useEffect(() => {
    if (!li || !Ti.current)
      return;
    const $i = ownerDocument(Ti.current), Oi = (Oo) => {
      if (xi.current = Oo, ti || !ai() || Oo.key !== "Tab")
        return;
      activeElement($i) === Ti.current && Oo.shiftKey && (oi.current = !0, di.current && di.current.focus());
    }, Di = () => {
      var fo, _o;
      const Oo = Ti.current;
      if (Oo === null)
        return;
      const io = activeElement($i);
      if (!$i.hasFocus() || !ai() || oi.current) {
        oi.current = !1;
        return;
      }
      if (Oo.contains(io) || ti && io !== si.current && io !== di.current)
        return;
      if (io !== gi.current)
        gi.current = null;
      else if (gi.current !== null)
        return;
      if (!mi.current)
        return;
      let xo = [];
      if ((io === si.current || io === di.current) && (xo = ui(Ti.current)), xo.length > 0) {
        const Li = !!((fo = xi.current) != null && fo.shiftKey && ((_o = xi.current) == null ? void 0 : _o.key) === "Tab"), Co = xo[0], Ni = xo[xo.length - 1];
        typeof Co != "string" && typeof Ni != "string" && (Li ? Ni.focus() : Co.focus());
      } else
        Oo.focus();
    };
    $i.addEventListener("focusin", Di), $i.addEventListener("keydown", Oi, !0);
    const Mi = setInterval(() => {
      const Oo = activeElement($i);
      Oo && Oo.tagName === "BODY" && Di();
    }, 50);
    return () => {
      clearInterval(Mi), $i.removeEventListener("focusin", Di), $i.removeEventListener("keydown", Oi, !0);
    };
  }, [ir, ti, ii, ai, li, ui]);
  const Si = ($i) => {
    fi.current === null && (fi.current = $i.relatedTarget), mi.current = !0, gi.current = $i.target;
    const Oi = yt.props.onFocus;
    Oi && Oi($i);
  }, Pi = ($i) => {
    fi.current === null && (fi.current = $i.relatedTarget), mi.current = !0;
  };
  return /* @__PURE__ */ jsxRuntimeExports$1.jsxs(React.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports$1.jsx("div", {
      tabIndex: li ? 0 : -1,
      onFocus: Pi,
      ref: si,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ React.cloneElement(yt, {
      ref: vi,
      onFocus: Si
    }), /* @__PURE__ */ jsxRuntimeExports$1.jsx("div", {
      tabIndex: li ? 0 : -1,
      onFocus: Pi,
      ref: di,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" && (FocusTrap.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: elementAcceptingRef,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: PropTypes$1.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: PropTypes$1.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: PropTypes$1.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: PropTypes$1.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: PropTypes$1.func,
  /**
   * If `true`, focus is locked.
   */
  open: PropTypes$1.bool.isRequired
});
process.env.NODE_ENV !== "production" && (FocusTrap.propTypes = exactProp(FocusTrap.propTypes));
function getContainer(pt) {
  return typeof pt == "function" ? pt() : pt;
}
function getHasTransition(pt) {
  return pt ? pt.props.hasOwnProperty("in") : !1;
}
const noop = () => {
}, manager = new ModalManager();
function useModal(pt) {
  const {
    container: yt,
    disableEscapeKeyDown: ir = !1,
    disableScrollLock: ti = !1,
    closeAfterTransition: ii = !1,
    onTransitionEnter: ui,
    onTransitionExited: ai,
    children: li,
    onClose: oi,
    open: si,
    rootRef: di
  } = pt, fi = React.useRef({}), gi = React.useRef(null), mi = React.useRef(null), Ti = useForkRef(mi, di), [vi, xi] = React.useState(!si), Si = getHasTransition(li);
  let Pi = !0;
  (pt["aria-hidden"] === "false" || pt["aria-hidden"] === !1) && (Pi = !1);
  const $i = () => ownerDocument(gi.current), Oi = () => (fi.current.modalRef = mi.current, fi.current.mount = gi.current, fi.current), Di = () => {
    manager.mount(Oi(), {
      disableScrollLock: ti
    }), mi.current && (mi.current.scrollTop = 0);
  }, Mi = useEventCallback(() => {
    const Yi = getContainer(yt) || $i().body;
    manager.add(Oi(), Yi), mi.current && Di();
  }), Oo = () => manager.isTopModal(Oi()), io = useEventCallback((Yi) => {
    gi.current = Yi, Yi && (si && Oo() ? Di() : mi.current && ariaHidden(mi.current, Pi));
  }), xo = React.useCallback(() => {
    manager.remove(Oi(), Pi);
  }, [Pi]);
  React.useEffect(() => () => {
    xo();
  }, [xo]), React.useEffect(() => {
    si ? Mi() : (!Si || !ii) && xo();
  }, [si, xo, Si, ii, Mi]);
  const fo = (Yi) => (Vo) => {
    var No;
    (No = Yi.onKeyDown) == null || No.call(Yi, Vo), !(Vo.key !== "Escape" || Vo.which === 229 || // Wait until IME is settled.
    !Oo()) && (ir || (Vo.stopPropagation(), oi && oi(Vo, "escapeKeyDown")));
  }, _o = (Yi) => (Vo) => {
    var No;
    (No = Yi.onClick) == null || No.call(Yi, Vo), Vo.target === Vo.currentTarget && oi && oi(Vo, "backdropClick");
  };
  return {
    getRootProps: (Yi = {}) => {
      const Vo = extractEventHandlers(pt);
      delete Vo.onTransitionEnter, delete Vo.onTransitionExited;
      const No = {
        ...Vo,
        ...Yi
      };
      return {
        /*
         * Marking an element with the role presentation indicates to assistive technology
         * that this element should be ignored; it exists to support the web application and
         * is not meant for humans to interact with directly.
         * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
         */
        role: "presentation",
        ...No,
        onKeyDown: fo(No),
        ref: Ti
      };
    },
    getBackdropProps: (Yi = {}) => {
      const Vo = Yi;
      return {
        "aria-hidden": !0,
        ...Vo,
        onClick: _o(Vo),
        open: si
      };
    },
    getTransitionProps: () => {
      const Yi = () => {
        xi(!1), ui && ui();
      }, Vo = () => {
        xi(!0), ai && ai(), ii && xo();
      };
      return {
        onEnter: createChainedFunction(Yi, (li == null ? void 0 : li.props.onEnter) ?? noop),
        onExited: createChainedFunction(Vo, (li == null ? void 0 : li.props.onExited) ?? noop)
      };
    },
    rootRef: Ti,
    portalRef: io,
    isTopModal: Oo,
    exited: vi,
    hasTransition: Si
  };
}
function getModalUtilityClass(pt) {
  return generateUtilityClass("MuiModal", pt);
}
generateUtilityClasses("MuiModal", ["root", "hidden", "backdrop"]);
const useUtilityClasses$6 = (pt) => {
  const {
    open: yt,
    exited: ir,
    classes: ti
  } = pt;
  return composeClasses({
    root: ["root", !yt && ir && "hidden"],
    backdrop: ["backdrop"]
  }, getModalUtilityClass, ti);
}, ModalRoot = styled("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (pt, yt) => {
    const {
      ownerState: ir
    } = pt;
    return [yt.root, !ir.open && ir.exited && yt.hidden];
  }
})(memoTheme(({
  theme: pt
}) => ({
  position: "fixed",
  zIndex: (pt.vars || pt).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  variants: [{
    props: ({
      ownerState: yt
    }) => !yt.open && yt.exited,
    style: {
      visibility: "hidden"
    }
  }]
}))), ModalBackdrop = styled(Backdrop, {
  name: "MuiModal",
  slot: "Backdrop"
})({
  zIndex: -1
}), Modal = /* @__PURE__ */ React.forwardRef(function pt(yt, ir) {
  const ti = useDefaultProps({
    name: "MuiModal",
    props: yt
  }), {
    BackdropComponent: ii = ModalBackdrop,
    BackdropProps: ui,
    classes: ai,
    className: li,
    closeAfterTransition: oi = !1,
    children: si,
    container: di,
    component: fi,
    components: gi = {},
    componentsProps: mi = {},
    disableAutoFocus: Ti = !1,
    disableEnforceFocus: vi = !1,
    disableEscapeKeyDown: xi = !1,
    disablePortal: Si = !1,
    disableRestoreFocus: Pi = !1,
    disableScrollLock: $i = !1,
    hideBackdrop: Oi = !1,
    keepMounted: Di = !1,
    onClose: Mi,
    onTransitionEnter: Oo,
    onTransitionExited: io,
    open: xo,
    slotProps: fo = {},
    slots: _o = {},
    // eslint-disable-next-line react/prop-types
    theme: Li,
    ...Co
  } = ti, Ni = {
    ...ti,
    closeAfterTransition: oi,
    disableAutoFocus: Ti,
    disableEnforceFocus: vi,
    disableEscapeKeyDown: xi,
    disablePortal: Si,
    disableRestoreFocus: Pi,
    disableScrollLock: $i,
    hideBackdrop: Oi,
    keepMounted: Di
  }, {
    getRootProps: Yi,
    getBackdropProps: Vo,
    getTransitionProps: No,
    portalRef: Ui,
    isTopModal: jo,
    exited: Wi,
    hasTransition: ji
  } = useModal({
    ...Ni,
    rootRef: ir
  }), Hi = {
    ...Ni,
    exited: Wi
  }, zo = useUtilityClasses$6(Hi), Lo = {};
  if (si.props.tabIndex === void 0 && (Lo.tabIndex = "-1"), ji) {
    const {
      onEnter: ia,
      onExited: ra
    } = No();
    Lo.onEnter = ia, Lo.onExited = ra;
  }
  const sa = {
    slots: {
      root: gi.Root,
      backdrop: gi.Backdrop,
      ..._o
    },
    slotProps: {
      ...mi,
      ...fo
    }
  }, [Ko, ca] = useSlot("root", {
    ref: ir,
    elementType: ModalRoot,
    externalForwardedProps: {
      ...sa,
      ...Co,
      component: fi
    },
    getSlotProps: Yi,
    ownerState: Hi,
    className: clsx(li, zo == null ? void 0 : zo.root, !Hi.open && Hi.exited && (zo == null ? void 0 : zo.hidden))
  }), [pa, ga] = useSlot("backdrop", {
    ref: ui == null ? void 0 : ui.ref,
    elementType: ii,
    externalForwardedProps: sa,
    shouldForwardComponentProp: !0,
    additionalProps: ui,
    getSlotProps: (ia) => Vo({
      ...ia,
      onClick: (ra) => {
        ia != null && ia.onClick && ia.onClick(ra);
      }
    }),
    className: clsx(ui == null ? void 0 : ui.className, zo == null ? void 0 : zo.backdrop),
    ownerState: Hi
  });
  return !Di && !xo && (!ji || Wi) ? null : /* @__PURE__ */ jsxRuntimeExports$1.jsx(Portal, {
    ref: Ui,
    container: di,
    disablePortal: Si,
    children: /* @__PURE__ */ jsxRuntimeExports$1.jsxs(Ko, {
      ...ca,
      children: [!Oi && ii ? /* @__PURE__ */ jsxRuntimeExports$1.jsx(pa, {
        ...ga
      }) : null, /* @__PURE__ */ jsxRuntimeExports$1.jsx(FocusTrap, {
        disableEnforceFocus: vi,
        disableAutoFocus: Ti,
        disableRestoreFocus: Pi,
        isEnabled: jo,
        open: xo,
        children: /* @__PURE__ */ React.cloneElement(si, Lo)
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (Modal.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: PropTypes$1.elementType,
  /**
   * Props applied to the [`Backdrop`](https://mui.com/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: PropTypes$1.object,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,
  /**
   * @ignore
   */
  className: PropTypes$1.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: PropTypes$1.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: PropTypes$1.shape({
    Backdrop: PropTypes$1.elementType,
    Root: PropTypes$1.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: PropTypes$1.shape({
    backdrop: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object]),
    root: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes$1.oneOfType([HTMLElementType, PropTypes$1.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: PropTypes$1.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: PropTypes$1.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: PropTypes$1.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes$1.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: PropTypes$1.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: PropTypes$1.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: PropTypes$1.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: PropTypes$1.bool,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes$1.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: PropTypes$1.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: PropTypes$1.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes$1.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: PropTypes$1.shape({
    backdrop: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object]),
    root: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes$1.shape({
    backdrop: PropTypes$1.elementType,
    root: PropTypes$1.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object])
});
const dividerClasses = generateUtilityClasses("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]);
function getScale(pt) {
  return `scale(${pt}, ${pt ** 2})`;
}
const styles = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, isWebKit154 = typeof navigator < "u" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), Grow = /* @__PURE__ */ React.forwardRef(function pt(yt, ir) {
  const {
    addEndListener: ti,
    appear: ii = !0,
    children: ui,
    easing: ai,
    in: li,
    onEnter: oi,
    onEntered: si,
    onEntering: di,
    onExit: fi,
    onExited: gi,
    onExiting: mi,
    style: Ti,
    timeout: vi = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: xi = Transition,
    ...Si
  } = yt, Pi = useTimeout(), $i = React.useRef(), Oi = useTheme(), Di = React.useRef(null), Mi = useForkRef(Di, getReactElementRef(ui), ir), Oo = (Yi) => (Vo) => {
    if (Yi) {
      const No = Di.current;
      Vo === void 0 ? Yi(No) : Yi(No, Vo);
    }
  }, io = Oo(di), xo = Oo((Yi, Vo) => {
    reflow(Yi);
    const {
      duration: No,
      delay: Ui,
      easing: jo
    } = getTransitionProps({
      style: Ti,
      timeout: vi,
      easing: ai
    }, {
      mode: "enter"
    });
    let Wi;
    vi === "auto" ? (Wi = Oi.transitions.getAutoHeightDuration(Yi.clientHeight), $i.current = Wi) : Wi = No, Yi.style.transition = [Oi.transitions.create("opacity", {
      duration: Wi,
      delay: Ui
    }), Oi.transitions.create("transform", {
      duration: isWebKit154 ? Wi : Wi * 0.666,
      delay: Ui,
      easing: jo
    })].join(","), oi && oi(Yi, Vo);
  }), fo = Oo(si), _o = Oo(mi), Li = Oo((Yi) => {
    const {
      duration: Vo,
      delay: No,
      easing: Ui
    } = getTransitionProps({
      style: Ti,
      timeout: vi,
      easing: ai
    }, {
      mode: "exit"
    });
    let jo;
    vi === "auto" ? (jo = Oi.transitions.getAutoHeightDuration(Yi.clientHeight), $i.current = jo) : jo = Vo, Yi.style.transition = [Oi.transitions.create("opacity", {
      duration: jo,
      delay: No
    }), Oi.transitions.create("transform", {
      duration: isWebKit154 ? jo : jo * 0.666,
      delay: isWebKit154 ? No : No || jo * 0.333,
      easing: Ui
    })].join(","), Yi.style.opacity = 0, Yi.style.transform = getScale(0.75), fi && fi(Yi);
  }), Co = Oo(gi), Ni = (Yi) => {
    vi === "auto" && Pi.start($i.current || 0, Yi), ti && ti(Di.current, Yi);
  };
  return /* @__PURE__ */ jsxRuntimeExports$1.jsx(xi, {
    appear: ii,
    in: li,
    nodeRef: Di,
    onEnter: xo,
    onEntered: fo,
    onEntering: io,
    onExit: Li,
    onExited: Co,
    onExiting: _o,
    addEndListener: Ni,
    timeout: vi === "auto" ? null : vi,
    ...Si,
    children: (Yi, {
      ownerState: Vo,
      ...No
    }) => /* @__PURE__ */ React.cloneElement(ui, {
      style: {
        opacity: 0,
        transform: getScale(0.75),
        visibility: Yi === "exited" && !li ? "hidden" : void 0,
        ...styles[Yi],
        ...Ti,
        ...ui.props.style
      },
      ref: Mi,
      ...No
    })
  });
});
process.env.NODE_ENV !== "production" && (Grow.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes$1.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: PropTypes$1.bool,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: PropTypes$1.oneOfType([PropTypes$1.shape({
    enter: PropTypes$1.string,
    exit: PropTypes$1.string
  }), PropTypes$1.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes$1.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes$1.func,
  /**
   * @ignore
   */
  onEntered: PropTypes$1.func,
  /**
   * @ignore
   */
  onEntering: PropTypes$1.func,
  /**
   * @ignore
   */
  onExit: PropTypes$1.func,
  /**
   * @ignore
   */
  onExited: PropTypes$1.func,
  /**
   * @ignore
   */
  onExiting: PropTypes$1.func,
  /**
   * @ignore
   */
  style: PropTypes$1.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: PropTypes$1.oneOfType([PropTypes$1.oneOf(["auto"]), PropTypes$1.number, PropTypes$1.shape({
    appear: PropTypes$1.number,
    enter: PropTypes$1.number,
    exit: PropTypes$1.number
  })])
});
Grow && (Grow.muiSupportAuto = !0);
const ListContext = /* @__PURE__ */ React.createContext({});
process.env.NODE_ENV !== "production" && (ListContext.displayName = "ListContext");
function getListUtilityClass(pt) {
  return generateUtilityClass("MuiList", pt);
}
generateUtilityClasses("MuiList", ["root", "padding", "dense", "subheader"]);
const useUtilityClasses$5 = (pt) => {
  const {
    classes: yt,
    disablePadding: ir,
    dense: ti,
    subheader: ii
  } = pt;
  return composeClasses({
    root: ["root", !ir && "padding", ti && "dense", ii && "subheader"]
  }, getListUtilityClass, yt);
}, ListRoot = styled("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (pt, yt) => {
    const {
      ownerState: ir
    } = pt;
    return [yt.root, !ir.disablePadding && yt.padding, ir.dense && yt.dense, ir.subheader && yt.subheader];
  }
})({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative",
  variants: [{
    props: ({
      ownerState: pt
    }) => !pt.disablePadding,
    style: {
      paddingTop: 8,
      paddingBottom: 8
    }
  }, {
    props: ({
      ownerState: pt
    }) => pt.subheader,
    style: {
      paddingTop: 0
    }
  }]
}), List = /* @__PURE__ */ React.forwardRef(function pt(yt, ir) {
  const ti = useDefaultProps({
    props: yt,
    name: "MuiList"
  }), {
    children: ii,
    className: ui,
    component: ai = "ul",
    dense: li = !1,
    disablePadding: oi = !1,
    subheader: si,
    ...di
  } = ti, fi = React.useMemo(() => ({
    dense: li
  }), [li]), gi = {
    ...ti,
    component: ai,
    dense: li,
    disablePadding: oi
  }, mi = useUtilityClasses$5(gi);
  return /* @__PURE__ */ jsxRuntimeExports$1.jsx(ListContext.Provider, {
    value: fi,
    children: /* @__PURE__ */ jsxRuntimeExports$1.jsxs(ListRoot, {
      as: ai,
      className: clsx(mi.root, ui),
      ref: ir,
      ownerState: gi,
      ...di,
      children: [si, ii]
    })
  });
});
process.env.NODE_ENV !== "production" && (List.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes$1.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,
  /**
   * @ignore
   */
  className: PropTypes$1.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: PropTypes$1.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: PropTypes$1.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: PropTypes$1.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object])
});
const listItemIconClasses = generateUtilityClasses("MuiListItemIcon", ["root", "alignItemsFlexStart"]), listItemTextClasses = generateUtilityClasses("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]);
function nextItem(pt, yt, ir) {
  return pt === yt ? pt.firstChild : yt && yt.nextElementSibling ? yt.nextElementSibling : ir ? null : pt.firstChild;
}
function previousItem(pt, yt, ir) {
  return pt === yt ? ir ? pt.firstChild : pt.lastChild : yt && yt.previousElementSibling ? yt.previousElementSibling : ir ? null : pt.lastChild;
}
function textCriteriaMatches(pt, yt) {
  if (yt === void 0)
    return !0;
  let ir = pt.innerText;
  return ir === void 0 && (ir = pt.textContent), ir = ir.trim().toLowerCase(), ir.length === 0 ? !1 : yt.repeating ? ir[0] === yt.keys[0] : ir.startsWith(yt.keys.join(""));
}
function moveFocus(pt, yt, ir, ti, ii, ui) {
  let ai = !1, li = ii(pt, yt, yt ? ir : !1);
  for (; li; ) {
    if (li === pt.firstChild) {
      if (ai)
        return !1;
      ai = !0;
    }
    const oi = ti ? !1 : li.disabled || li.getAttribute("aria-disabled") === "true";
    if (!li.hasAttribute("tabindex") || !textCriteriaMatches(li, ui) || oi)
      li = ii(pt, li, ir);
    else
      return li.focus(), !0;
  }
  return !1;
}
const MenuList = /* @__PURE__ */ React.forwardRef(function pt(yt, ir) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: ti,
    autoFocus: ii = !1,
    autoFocusItem: ui = !1,
    children: ai,
    className: li,
    disabledItemsFocusable: oi = !1,
    disableListWrap: si = !1,
    onKeyDown: di,
    variant: fi = "selectedMenu",
    ...gi
  } = yt, mi = React.useRef(null), Ti = React.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  useEnhancedEffect(() => {
    ii && mi.current.focus();
  }, [ii]), React.useImperativeHandle(ti, () => ({
    adjustStyleForScrollbar: ($i, {
      direction: Oi
    }) => {
      const Di = !mi.current.style.width;
      if ($i.clientHeight < mi.current.clientHeight && Di) {
        const Mi = `${getScrollbarSize(ownerWindow($i))}px`;
        mi.current.style[Oi === "rtl" ? "paddingLeft" : "paddingRight"] = Mi, mi.current.style.width = `calc(100% + ${Mi})`;
      }
      return mi.current;
    }
  }), []);
  const vi = ($i) => {
    const Oi = mi.current, Di = $i.key;
    if ($i.ctrlKey || $i.metaKey || $i.altKey) {
      di && di($i);
      return;
    }
    const Oo = activeElement(ownerDocument(Oi));
    if (Di === "ArrowDown")
      $i.preventDefault(), moveFocus(Oi, Oo, si, oi, nextItem);
    else if (Di === "ArrowUp")
      $i.preventDefault(), moveFocus(Oi, Oo, si, oi, previousItem);
    else if (Di === "Home")
      $i.preventDefault(), moveFocus(Oi, null, si, oi, nextItem);
    else if (Di === "End")
      $i.preventDefault(), moveFocus(Oi, null, si, oi, previousItem);
    else if (Di.length === 1) {
      const io = Ti.current, xo = Di.toLowerCase(), fo = performance.now();
      io.keys.length > 0 && (fo - io.lastTime > 500 ? (io.keys = [], io.repeating = !0, io.previousKeyMatched = !0) : io.repeating && xo !== io.keys[0] && (io.repeating = !1)), io.lastTime = fo, io.keys.push(xo);
      const _o = Oo && !io.repeating && textCriteriaMatches(Oo, io);
      io.previousKeyMatched && (_o || moveFocus(Oi, Oo, !1, oi, nextItem, io)) ? $i.preventDefault() : io.previousKeyMatched = !1;
    }
    di && di($i);
  }, xi = useForkRef(mi, ir);
  let Si = -1;
  React.Children.forEach(ai, ($i, Oi) => {
    if (!/* @__PURE__ */ React.isValidElement($i)) {
      Si === Oi && (Si += 1, Si >= ai.length && (Si = -1));
      return;
    }
    process.env.NODE_ENV !== "production" && reactIsExports.isFragment($i) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), $i.props.disabled || (fi === "selectedMenu" && $i.props.selected || Si === -1) && (Si = Oi), Si === Oi && ($i.props.disabled || $i.props.muiSkipListHighlight || $i.type.muiSkipListHighlight) && (Si += 1, Si >= ai.length && (Si = -1));
  });
  const Pi = React.Children.map(ai, ($i, Oi) => {
    if (Oi === Si) {
      const Di = {};
      return ui && (Di.autoFocus = !0), $i.props.tabIndex === void 0 && fi === "selectedMenu" && (Di.tabIndex = 0), /* @__PURE__ */ React.cloneElement($i, Di);
    }
    return $i;
  });
  return /* @__PURE__ */ jsxRuntimeExports$1.jsx(List, {
    role: "menu",
    ref: xi,
    className: li,
    onKeyDown: vi,
    tabIndex: ii ? 0 : -1,
    ...gi,
    children: Pi
  });
});
process.env.NODE_ENV !== "production" && (MenuList.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: PropTypes$1.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: PropTypes$1.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: PropTypes$1.node,
  /**
   * @ignore
   */
  className: PropTypes$1.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: PropTypes$1.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: PropTypes$1.bool,
  /**
   * @ignore
   */
  onKeyDown: PropTypes$1.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: PropTypes$1.oneOf(["menu", "selectedMenu"])
});
function getPopoverUtilityClass(pt) {
  return generateUtilityClass("MuiPopover", pt);
}
generateUtilityClasses("MuiPopover", ["root", "paper"]);
function getOffsetTop(pt, yt) {
  let ir = 0;
  return typeof yt == "number" ? ir = yt : yt === "center" ? ir = pt.height / 2 : yt === "bottom" && (ir = pt.height), ir;
}
function getOffsetLeft(pt, yt) {
  let ir = 0;
  return typeof yt == "number" ? ir = yt : yt === "center" ? ir = pt.width / 2 : yt === "right" && (ir = pt.width), ir;
}
function getTransformOriginValue(pt) {
  return [pt.horizontal, pt.vertical].map((yt) => typeof yt == "number" ? `${yt}px` : yt).join(" ");
}
function resolveAnchorEl(pt) {
  return typeof pt == "function" ? pt() : pt;
}
const useUtilityClasses$4 = (pt) => {
  const {
    classes: yt
  } = pt;
  return composeClasses({
    root: ["root"],
    paper: ["paper"]
  }, getPopoverUtilityClass, yt);
}, PopoverRoot = styled(Modal, {
  name: "MuiPopover",
  slot: "Root"
})({}), PopoverPaper = styled(Paper, {
  name: "MuiPopover",
  slot: "Paper"
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), Popover = /* @__PURE__ */ React.forwardRef(function pt(yt, ir) {
  const ti = useDefaultProps({
    props: yt,
    name: "MuiPopover"
  }), {
    action: ii,
    anchorEl: ui,
    anchorOrigin: ai = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: li,
    anchorReference: oi = "anchorEl",
    children: si,
    className: di,
    container: fi,
    elevation: gi = 8,
    marginThreshold: mi = 16,
    open: Ti,
    PaperProps: vi = {},
    // TODO: remove in v7
    slots: xi = {},
    slotProps: Si = {},
    transformOrigin: Pi = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: $i,
    // TODO: remove in v7
    transitionDuration: Oi = "auto",
    TransitionProps: Di = {},
    // TODO: remove in v7
    disableScrollLock: Mi = !1,
    ...Oo
  } = ti, io = React.useRef(), xo = {
    ...ti,
    anchorOrigin: ai,
    anchorReference: oi,
    elevation: gi,
    marginThreshold: mi,
    transformOrigin: Pi,
    TransitionComponent: $i,
    transitionDuration: Oi,
    TransitionProps: Di
  }, fo = useUtilityClasses$4(xo), _o = React.useCallback(() => {
    if (oi === "anchorPosition")
      return process.env.NODE_ENV !== "production" && (li || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), li;
    const ia = resolveAnchorEl(ui), ra = ia && ia.nodeType === 1 ? ia : ownerDocument(io.current).body, qo = ra.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      const xa = ra.getBoundingClientRect();
      isLayoutSupported() && xa.top === 0 && xa.left === 0 && xa.right === 0 && xa.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: qo.top + getOffsetTop(qo, ai.vertical),
      left: qo.left + getOffsetLeft(qo, ai.horizontal)
    };
  }, [ui, ai.horizontal, ai.vertical, li, oi]), Li = React.useCallback((ia) => ({
    vertical: getOffsetTop(ia, Pi.vertical),
    horizontal: getOffsetLeft(ia, Pi.horizontal)
  }), [Pi.horizontal, Pi.vertical]), Co = React.useCallback((ia) => {
    const ra = {
      width: ia.offsetWidth,
      height: ia.offsetHeight
    }, qo = Li(ra);
    if (oi === "none")
      return {
        top: null,
        left: null,
        transformOrigin: getTransformOriginValue(qo)
      };
    const xa = _o();
    let $a = xa.top - qo.vertical, ys = xa.left - qo.horizontal;
    const Ss = $a + ra.height, Xa = ys + ra.width, Es = ownerWindow(resolveAnchorEl(ui)), Rs = Es.innerHeight - mi, La = Es.innerWidth - mi;
    if (mi !== null && $a < mi) {
      const Ja = $a - mi;
      $a -= Ja, qo.vertical += Ja;
    } else if (mi !== null && Ss > Rs) {
      const Ja = Ss - Rs;
      $a -= Ja, qo.vertical += Ja;
    }
    if (process.env.NODE_ENV !== "production" && ra.height > Rs && ra.height && Rs && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${ra.height - Rs}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), mi !== null && ys < mi) {
      const Ja = ys - mi;
      ys -= Ja, qo.horizontal += Ja;
    } else if (Xa > La) {
      const Ja = Xa - La;
      ys -= Ja, qo.horizontal += Ja;
    }
    return {
      top: `${Math.round($a)}px`,
      left: `${Math.round(ys)}px`,
      transformOrigin: getTransformOriginValue(qo)
    };
  }, [ui, oi, _o, Li, mi]), [Ni, Yi] = React.useState(Ti), Vo = React.useCallback(() => {
    const ia = io.current;
    if (!ia)
      return;
    const ra = Co(ia);
    ra.top !== null && ia.style.setProperty("top", ra.top), ra.left !== null && (ia.style.left = ra.left), ia.style.transformOrigin = ra.transformOrigin, Yi(!0);
  }, [Co]);
  React.useEffect(() => (Mi && window.addEventListener("scroll", Vo), () => window.removeEventListener("scroll", Vo)), [ui, Mi, Vo]);
  const No = () => {
    Vo();
  }, Ui = () => {
    Yi(!1);
  };
  React.useEffect(() => {
    Ti && Vo();
  }), React.useImperativeHandle(ii, () => Ti ? {
    updatePosition: () => {
      Vo();
    }
  } : null, [Ti, Vo]), React.useEffect(() => {
    if (!Ti)
      return;
    const ia = debounce(() => {
      Vo();
    }), ra = ownerWindow(resolveAnchorEl(ui));
    return ra.addEventListener("resize", ia), () => {
      ia.clear(), ra.removeEventListener("resize", ia);
    };
  }, [ui, Ti, Vo]);
  let jo = Oi;
  const Wi = {
    slots: {
      transition: $i,
      ...xi
    },
    slotProps: {
      transition: Di,
      paper: vi,
      ...Si
    }
  }, [ji, Hi] = useSlot("transition", {
    elementType: Grow,
    externalForwardedProps: Wi,
    ownerState: xo,
    getSlotProps: (ia) => ({
      ...ia,
      onEntering: (ra, qo) => {
        var xa;
        (xa = ia.onEntering) == null || xa.call(ia, ra, qo), No();
      },
      onExited: (ra) => {
        var qo;
        (qo = ia.onExited) == null || qo.call(ia, ra), Ui();
      }
    }),
    additionalProps: {
      appear: !0,
      in: Ti
    }
  });
  Oi === "auto" && !ji.muiSupportAuto && (jo = void 0);
  const zo = fi || (ui ? ownerDocument(resolveAnchorEl(ui)).body : void 0), [Lo, {
    slots: sa,
    slotProps: Ko,
    ...ca
  }] = useSlot("root", {
    ref: ir,
    elementType: PopoverRoot,
    externalForwardedProps: {
      ...Wi,
      ...Oo
    },
    shouldForwardComponentProp: !0,
    additionalProps: {
      slots: {
        backdrop: xi.backdrop
      },
      slotProps: {
        backdrop: mergeSlotProps$1(typeof Si.backdrop == "function" ? Si.backdrop(xo) : Si.backdrop, {
          invisible: !0
        })
      },
      container: zo,
      open: Ti
    },
    ownerState: xo,
    className: clsx(fo.root, di)
  }), [pa, ga] = useSlot("paper", {
    ref: io,
    className: fo.paper,
    elementType: PopoverPaper,
    externalForwardedProps: Wi,
    shouldForwardComponentProp: !0,
    additionalProps: {
      elevation: gi,
      style: Ni ? void 0 : {
        opacity: 0
      }
    },
    ownerState: xo
  });
  return /* @__PURE__ */ jsxRuntimeExports$1.jsx(Lo, {
    ...ca,
    ...!isHostComponent(Lo) && {
      slots: sa,
      slotProps: Ko,
      disableScrollLock: Mi
    },
    children: /* @__PURE__ */ jsxRuntimeExports$1.jsx(ji, {
      ...Hi,
      timeout: jo,
      children: /* @__PURE__ */ jsxRuntimeExports$1.jsx(pa, {
        ...ga,
        children: si
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (Popover.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: refType,
  /**
   * An HTML element, [PopoverVirtualElement](https://mui.com/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: chainPropTypes(PropTypes$1.oneOfType([HTMLElementType, PropTypes$1.func]), (pt) => {
    if (pt.open && (!pt.anchorReference || pt.anchorReference === "anchorEl")) {
      const yt = resolveAnchorEl(pt.anchorEl);
      if (yt && yt.nodeType === 1) {
        const ir = yt.getBoundingClientRect();
        if (process.env.NODE_ENV !== "production" && isLayoutSupported() && ir.top === 0 && ir.left === 0 && ir.right === 0 && ir.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${yt}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: PropTypes$1.shape({
    horizontal: PropTypes$1.oneOfType([PropTypes$1.oneOf(["center", "left", "right"]), PropTypes$1.number]).isRequired,
    vertical: PropTypes$1.oneOfType([PropTypes$1.oneOf(["bottom", "center", "top"]), PropTypes$1.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: PropTypes$1.shape({
    left: PropTypes$1.number.isRequired,
    top: PropTypes$1.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: PropTypes$1.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: PropTypes$1.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  BackdropProps: PropTypes$1.object,
  /**
   * The content of the component.
   */
  children: PropTypes$1.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,
  /**
   * @ignore
   */
  className: PropTypes$1.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes$1.oneOfType([HTMLElementType, PropTypes$1.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: PropTypes$1.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: integerPropType,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: PropTypes$1.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: PropTypes$1.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes$1.bool.isRequired,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overridden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: PropTypes$1.shape({
    component: elementTypeAcceptingRef$1
  }),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes$1.shape({
    backdrop: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object]),
    paper: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object]),
    root: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object]),
    transition: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes$1.shape({
    backdrop: PropTypes$1.elementType,
    paper: PropTypes$1.elementType,
    root: PropTypes$1.elementType,
    transition: PropTypes$1.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: PropTypes$1.shape({
    horizontal: PropTypes$1.oneOfType([PropTypes$1.oneOf(["center", "left", "right"]), PropTypes$1.number]).isRequired,
    vertical: PropTypes$1.oneOfType([PropTypes$1.oneOf(["bottom", "center", "top"]), PropTypes$1.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated use the `slots.transition` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default Grow
   */
  TransitionComponent: PropTypes$1.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: PropTypes$1.oneOfType([PropTypes$1.oneOf(["auto"]), PropTypes$1.number, PropTypes$1.shape({
    appear: PropTypes$1.number,
    enter: PropTypes$1.number,
    exit: PropTypes$1.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: PropTypes$1.object
});
function getMenuUtilityClass(pt) {
  return generateUtilityClass("MuiMenu", pt);
}
generateUtilityClasses("MuiMenu", ["root", "paper", "list"]);
const RTL_ORIGIN = {
  vertical: "top",
  horizontal: "right"
}, LTR_ORIGIN = {
  vertical: "top",
  horizontal: "left"
}, useUtilityClasses$3 = (pt) => {
  const {
    classes: yt
  } = pt;
  return composeClasses({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, getMenuUtilityClass, yt);
}, MenuRoot = styled(Popover, {
  shouldForwardProp: (pt) => rootShouldForwardProp(pt) || pt === "classes",
  name: "MuiMenu",
  slot: "Root"
})({}), MenuPaper = styled(PopoverPaper, {
  name: "MuiMenu",
  slot: "Paper"
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), MenuMenuList = styled(MenuList, {
  name: "MuiMenu",
  slot: "List"
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), Menu = /* @__PURE__ */ React.forwardRef(function pt(yt, ir) {
  const ti = useDefaultProps({
    props: yt,
    name: "MuiMenu"
  }), {
    autoFocus: ii = !0,
    children: ui,
    className: ai,
    disableAutoFocusItem: li = !1,
    MenuListProps: oi = {},
    onClose: si,
    open: di,
    PaperProps: fi = {},
    PopoverClasses: gi,
    transitionDuration: mi = "auto",
    TransitionProps: {
      onEntering: Ti,
      ...vi
    } = {},
    variant: xi = "selectedMenu",
    slots: Si = {},
    slotProps: Pi = {},
    ...$i
  } = ti, Oi = useRtl(), Di = {
    ...ti,
    autoFocus: ii,
    disableAutoFocusItem: li,
    MenuListProps: oi,
    onEntering: Ti,
    PaperProps: fi,
    transitionDuration: mi,
    TransitionProps: vi,
    variant: xi
  }, Mi = useUtilityClasses$3(Di), Oo = ii && !li && di, io = React.useRef(null), xo = (jo, Wi) => {
    io.current && io.current.adjustStyleForScrollbar(jo, {
      direction: Oi ? "rtl" : "ltr"
    }), Ti && Ti(jo, Wi);
  }, fo = (jo) => {
    jo.key === "Tab" && (jo.preventDefault(), si && si(jo, "tabKeyDown"));
  };
  let _o = -1;
  React.Children.map(ui, (jo, Wi) => {
    /* @__PURE__ */ React.isValidElement(jo) && (process.env.NODE_ENV !== "production" && reactIsExports.isFragment(jo) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), jo.props.disabled || (xi === "selectedMenu" && jo.props.selected || _o === -1) && (_o = Wi));
  });
  const Li = {
    slots: Si,
    slotProps: {
      list: oi,
      transition: vi,
      paper: fi,
      ...Pi
    }
  }, Co = useSlotProps({
    elementType: Si.root,
    externalSlotProps: Pi.root,
    ownerState: Di,
    className: [Mi.root, ai]
  }), [Ni, Yi] = useSlot("paper", {
    className: Mi.paper,
    elementType: MenuPaper,
    externalForwardedProps: Li,
    shouldForwardComponentProp: !0,
    ownerState: Di
  }), [Vo, No] = useSlot("list", {
    className: clsx(Mi.list, oi.className),
    elementType: MenuMenuList,
    shouldForwardComponentProp: !0,
    externalForwardedProps: Li,
    getSlotProps: (jo) => ({
      ...jo,
      onKeyDown: (Wi) => {
        var ji;
        fo(Wi), (ji = jo.onKeyDown) == null || ji.call(jo, Wi);
      }
    }),
    ownerState: Di
  }), Ui = typeof Li.slotProps.transition == "function" ? Li.slotProps.transition(Di) : Li.slotProps.transition;
  return /* @__PURE__ */ jsxRuntimeExports$1.jsx(MenuRoot, {
    onClose: si,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: Oi ? "right" : "left"
    },
    transformOrigin: Oi ? RTL_ORIGIN : LTR_ORIGIN,
    slots: {
      root: Si.root,
      paper: Ni,
      backdrop: Si.backdrop,
      ...Si.transition && {
        // TODO: pass `slots.transition` directly once `TransitionComponent` is removed from Popover
        transition: Si.transition
      }
    },
    slotProps: {
      root: Co,
      paper: Yi,
      backdrop: typeof Pi.backdrop == "function" ? Pi.backdrop(Di) : Pi.backdrop,
      transition: {
        ...Ui,
        onEntering: (...jo) => {
          var Wi;
          xo(...jo), (Wi = Ui == null ? void 0 : Ui.onEntering) == null || Wi.call(Ui, ...jo);
        }
      }
    },
    open: di,
    ref: ir,
    transitionDuration: mi,
    ownerState: Di,
    ...$i,
    classes: gi,
    children: /* @__PURE__ */ jsxRuntimeExports$1.jsx(Vo, {
      actions: io,
      autoFocus: ii && (_o === -1 || li),
      autoFocusItem: Oo,
      variant: xi,
      ...No,
      children: ui
    })
  });
});
process.env.NODE_ENV !== "production" && (Menu.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: PropTypes$1.oneOfType([HTMLElementType, PropTypes$1.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: PropTypes$1.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: PropTypes$1.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,
  /**
   * @ignore
   */
  className: PropTypes$1.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: PropTypes$1.bool,
  /**
   * Props applied to the [`MenuList`](https://mui.com/material-ui/api/menu-list/) element.
   * @deprecated use the `slotProps.list` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  MenuListProps: PropTypes$1.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: PropTypes$1.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes$1.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: PropTypes$1.object,
  /**
   * `classes` prop applied to the [`Popover`](https://mui.com/material-ui/api/popover/) element.
   */
  PopoverClasses: PropTypes$1.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes$1.shape({
    backdrop: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object]),
    list: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object]),
    paper: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object]),
    root: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object]),
    transition: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes$1.shape({
    backdrop: PropTypes$1.elementType,
    list: PropTypes$1.elementType,
    paper: PropTypes$1.elementType,
    root: PropTypes$1.elementType,
    transition: PropTypes$1.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: PropTypes$1.oneOfType([PropTypes$1.oneOf(["auto"]), PropTypes$1.number, PropTypes$1.shape({
    appear: PropTypes$1.number,
    enter: PropTypes$1.number,
    exit: PropTypes$1.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: PropTypes$1.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: PropTypes$1.oneOf(["menu", "selectedMenu"])
});
function getMenuItemUtilityClass(pt) {
  return generateUtilityClass("MuiMenuItem", pt);
}
const menuItemClasses = generateUtilityClasses("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]), overridesResolver$1 = (pt, yt) => {
  const {
    ownerState: ir
  } = pt;
  return [yt.root, ir.dense && yt.dense, ir.divider && yt.divider, !ir.disableGutters && yt.gutters];
}, useUtilityClasses$2 = (pt) => {
  const {
    disabled: yt,
    dense: ir,
    divider: ti,
    disableGutters: ii,
    selected: ui,
    classes: ai
  } = pt, oi = composeClasses({
    root: ["root", ir && "dense", yt && "disabled", !ii && "gutters", ti && "divider", ui && "selected"]
  }, getMenuItemUtilityClass, ai);
  return {
    ...ai,
    ...oi
  };
}, MenuItemRoot = styled(ButtonBase, {
  shouldForwardProp: (pt) => rootShouldForwardProp(pt) || pt === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver: overridesResolver$1
})(memoTheme(({
  theme: pt
}) => ({
  ...pt.typography.body1,
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap",
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (pt.vars || pt).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${menuItemClasses.selected}`]: {
    backgroundColor: pt.alpha((pt.vars || pt).palette.primary.main, (pt.vars || pt).palette.action.selectedOpacity),
    [`&.${menuItemClasses.focusVisible}`]: {
      backgroundColor: pt.alpha((pt.vars || pt).palette.primary.main, `${(pt.vars || pt).palette.action.selectedOpacity} + ${(pt.vars || pt).palette.action.focusOpacity}`)
    }
  },
  [`&.${menuItemClasses.selected}:hover`]: {
    backgroundColor: pt.alpha((pt.vars || pt).palette.primary.main, `${(pt.vars || pt).palette.action.selectedOpacity} + ${(pt.vars || pt).palette.action.hoverOpacity}`),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: pt.alpha((pt.vars || pt).palette.primary.main, (pt.vars || pt).palette.action.selectedOpacity)
    }
  },
  [`&.${menuItemClasses.focusVisible}`]: {
    backgroundColor: (pt.vars || pt).palette.action.focus
  },
  [`&.${menuItemClasses.disabled}`]: {
    opacity: (pt.vars || pt).palette.action.disabledOpacity
  },
  [`& + .${dividerClasses.root}`]: {
    marginTop: pt.spacing(1),
    marginBottom: pt.spacing(1)
  },
  [`& + .${dividerClasses.inset}`]: {
    marginLeft: 52
  },
  [`& .${listItemTextClasses.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${listItemTextClasses.inset}`]: {
    paddingLeft: 36
  },
  [`& .${listItemIconClasses.root}`]: {
    minWidth: 36
  },
  variants: [{
    props: ({
      ownerState: yt
    }) => !yt.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: yt
    }) => yt.divider,
    style: {
      borderBottom: `1px solid ${(pt.vars || pt).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: ({
      ownerState: yt
    }) => !yt.dense,
    style: {
      [pt.breakpoints.up("sm")]: {
        minHeight: "auto"
      }
    }
  }, {
    props: ({
      ownerState: yt
    }) => yt.dense,
    style: {
      minHeight: 32,
      // https://m2.material.io/components/menus#specs > Dense
      paddingTop: 4,
      paddingBottom: 4,
      ...pt.typography.body2,
      [`& .${listItemIconClasses.root} svg`]: {
        fontSize: "1.25rem"
      }
    }
  }]
}))), MenuItem = /* @__PURE__ */ React.forwardRef(function pt(yt, ir) {
  const ti = useDefaultProps({
    props: yt,
    name: "MuiMenuItem"
  }), {
    autoFocus: ii = !1,
    component: ui = "li",
    dense: ai = !1,
    divider: li = !1,
    disableGutters: oi = !1,
    focusVisibleClassName: si,
    role: di = "menuitem",
    tabIndex: fi,
    className: gi,
    ...mi
  } = ti, Ti = React.useContext(ListContext), vi = React.useMemo(() => ({
    dense: ai || Ti.dense || !1,
    disableGutters: oi
  }), [Ti.dense, ai, oi]), xi = React.useRef(null);
  useEnhancedEffect(() => {
    ii && (xi.current ? xi.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered."));
  }, [ii]);
  const Si = {
    ...ti,
    dense: vi.dense,
    divider: li,
    disableGutters: oi
  }, Pi = useUtilityClasses$2(ti), $i = useForkRef(xi, ir);
  let Oi;
  return ti.disabled || (Oi = fi !== void 0 ? fi : -1), /* @__PURE__ */ jsxRuntimeExports$1.jsx(ListContext.Provider, {
    value: vi,
    children: /* @__PURE__ */ jsxRuntimeExports$1.jsx(MenuItemRoot, {
      ref: $i,
      role: di,
      tabIndex: Oi,
      component: ui,
      focusVisibleClassName: clsx(Pi.focusVisible, si),
      className: clsx(Pi.root, gi),
      ...mi,
      ownerState: Si,
      classes: Pi
    })
  });
});
process.env.NODE_ENV !== "production" && (MenuItem.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: PropTypes$1.bool,
  /**
   * The content of the component.
   */
  children: PropTypes$1.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,
  /**
   * @ignore
   */
  className: PropTypes$1.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: PropTypes$1.bool,
  /**
   * @ignore
   */
  disabled: PropTypes$1.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: PropTypes$1.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: PropTypes$1.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes$1.string,
  /**
   * @ignore
   */
  role: PropTypes$1.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: PropTypes$1.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),
  /**
   * @default 0
   */
  tabIndex: PropTypes$1.number
});
function getPaginationUtilityClass(pt) {
  return generateUtilityClass("MuiPagination", pt);
}
generateUtilityClasses("MuiPagination", ["root", "ul", "outlined", "text"]);
function usePagination(pt = {}) {
  const {
    boundaryCount: yt = 1,
    componentName: ir = "usePagination",
    count: ti = 1,
    defaultPage: ii = 1,
    disabled: ui = !1,
    hideNextButton: ai = !1,
    hidePrevButton: li = !1,
    onChange: oi,
    page: si,
    showFirstButton: di = !1,
    showLastButton: fi = !1,
    siblingCount: gi = 1,
    ...mi
  } = pt, [Ti, vi] = useControlled({
    controlled: si,
    default: ii,
    name: ir,
    state: "page"
  }), xi = (xo, fo) => {
    si || vi(fo), oi && oi(xo, fo);
  }, Si = (xo, fo) => {
    const _o = fo - xo + 1;
    return Array.from({
      length: _o
    }, (Li, Co) => xo + Co);
  }, Pi = Si(1, Math.min(yt, ti)), $i = Si(Math.max(ti - yt + 1, yt + 1), ti), Oi = Math.max(
    Math.min(
      // Natural start
      Ti - gi,
      // Lower boundary when page is high
      ti - yt - gi * 2 - 1
    ),
    // Greater than startPages
    yt + 2
  ), Di = Math.min(
    Math.max(
      // Natural end
      Ti + gi,
      // Upper boundary when page is low
      yt + gi * 2 + 2
    ),
    // Less than endPages
    ti - yt - 1
  ), Mi = [
    ...di ? ["first"] : [],
    ...li ? [] : ["previous"],
    ...Pi,
    // Start ellipsis
    // eslint-disable-next-line no-nested-ternary
    ...Oi > yt + 2 ? ["start-ellipsis"] : yt + 1 < ti - yt ? [yt + 1] : [],
    // Sibling pages
    ...Si(Oi, Di),
    // End ellipsis
    // eslint-disable-next-line no-nested-ternary
    ...Di < ti - yt - 1 ? ["end-ellipsis"] : ti - yt > yt ? [ti - yt] : [],
    ...$i,
    ...ai ? [] : ["next"],
    ...fi ? ["last"] : []
  ], Oo = (xo) => {
    switch (xo) {
      case "first":
        return 1;
      case "previous":
        return Ti - 1;
      case "next":
        return Ti + 1;
      case "last":
        return ti;
      default:
        return null;
    }
  };
  return {
    items: Mi.map((xo) => typeof xo == "number" ? {
      onClick: (fo) => {
        xi(fo, xo);
      },
      type: "page",
      page: xo,
      selected: xo === Ti,
      disabled: ui,
      "aria-current": xo === Ti ? "page" : void 0
    } : {
      onClick: (fo) => {
        xi(fo, Oo(xo));
      },
      type: xo,
      page: Oo(xo),
      selected: !1,
      disabled: ui || !xo.includes("ellipsis") && (xo === "next" || xo === "last" ? Ti >= ti : Ti <= 1)
    }),
    ...mi
  };
}
function getPaginationItemUtilityClass(pt) {
  return generateUtilityClass("MuiPaginationItem", pt);
}
const paginationItemClasses = generateUtilityClasses("MuiPaginationItem", ["root", "page", "sizeSmall", "sizeLarge", "text", "textPrimary", "textSecondary", "outlined", "outlinedPrimary", "outlinedSecondary", "rounded", "ellipsis", "firstLast", "previousNext", "focusVisible", "disabled", "selected", "icon", "colorPrimary", "colorSecondary"]), FirstPageIconDefault = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports$1.jsx("path", {
  d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), "FirstPage"), LastPageIconDefault = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports$1.jsx("path", {
  d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), "LastPage"), NavigateBeforeIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports$1.jsx("path", {
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "NavigateBefore"), NavigateNextIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports$1.jsx("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "NavigateNext"), overridesResolver = (pt, yt) => {
  const {
    ownerState: ir
  } = pt;
  return [yt.root, yt[ir.variant], yt[`size${capitalize(ir.size)}`], ir.variant === "text" && yt[`text${capitalize(ir.color)}`], ir.variant === "outlined" && yt[`outlined${capitalize(ir.color)}`], ir.shape === "rounded" && yt.rounded, ir.type === "page" && yt.page, (ir.type === "start-ellipsis" || ir.type === "end-ellipsis") && yt.ellipsis, (ir.type === "previous" || ir.type === "next") && yt.previousNext, (ir.type === "first" || ir.type === "last") && yt.firstLast];
}, useUtilityClasses$1 = (pt) => {
  const {
    classes: yt,
    color: ir,
    disabled: ti,
    selected: ii,
    size: ui,
    shape: ai,
    type: li,
    variant: oi
  } = pt, si = {
    root: ["root", `size${capitalize(ui)}`, oi, ai, ir !== "standard" && `color${capitalize(ir)}`, ir !== "standard" && `${oi}${capitalize(ir)}`, ti && "disabled", ii && "selected", {
      page: "page",
      first: "firstLast",
      last: "firstLast",
      "start-ellipsis": "ellipsis",
      "end-ellipsis": "ellipsis",
      previous: "previousNext",
      next: "previousNext"
    }[li]],
    icon: ["icon"]
  };
  return composeClasses(si, getPaginationItemUtilityClass, yt);
}, PaginationItemEllipsis = styled("div", {
  name: "MuiPaginationItem",
  slot: "Root",
  overridesResolver
})(memoTheme(({
  theme: pt
}) => ({
  ...pt.typography.body2,
  borderRadius: 32 / 2,
  textAlign: "center",
  boxSizing: "border-box",
  minWidth: 32,
  padding: "0 6px",
  margin: "0 3px",
  color: (pt.vars || pt).palette.text.primary,
  height: "auto",
  [`&.${paginationItemClasses.disabled}`]: {
    opacity: (pt.vars || pt).palette.action.disabledOpacity
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      minWidth: 26,
      borderRadius: 26 / 2,
      margin: "0 1px",
      padding: "0 4px"
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      minWidth: 40,
      borderRadius: 40 / 2,
      padding: "0 10px",
      fontSize: pt.typography.pxToRem(15)
    }
  }]
}))), PaginationItemPage = styled(ButtonBase, {
  name: "MuiPaginationItem",
  slot: "Root",
  overridesResolver
})(memoTheme(({
  theme: pt
}) => ({
  ...pt.typography.body2,
  borderRadius: 32 / 2,
  textAlign: "center",
  boxSizing: "border-box",
  minWidth: 32,
  height: 32,
  padding: "0 6px",
  margin: "0 3px",
  color: (pt.vars || pt).palette.text.primary,
  [`&.${paginationItemClasses.focusVisible}`]: {
    backgroundColor: (pt.vars || pt).palette.action.focus
  },
  [`&.${paginationItemClasses.disabled}`]: {
    opacity: (pt.vars || pt).palette.action.disabledOpacity
  },
  transition: pt.transitions.create(["color", "background-color"], {
    duration: pt.transitions.duration.short
  }),
  "&:hover": {
    backgroundColor: (pt.vars || pt).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${paginationItemClasses.selected}`]: {
    backgroundColor: (pt.vars || pt).palette.action.selected,
    "&:hover": {
      backgroundColor: pt.alpha((pt.vars || pt).palette.action.selected, `${(pt.vars || pt).palette.action.selectedOpacity} + ${(pt.vars || pt).palette.action.hoverOpacity}`),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (pt.vars || pt).palette.action.selected
      }
    },
    [`&.${paginationItemClasses.focusVisible}`]: {
      backgroundColor: pt.alpha((pt.vars || pt).palette.action.selected, `${(pt.vars || pt).palette.action.selectedOpacity} + ${(pt.vars || pt).palette.action.focusOpacity}`)
    },
    [`&.${paginationItemClasses.disabled}`]: {
      opacity: 1,
      color: (pt.vars || pt).palette.action.disabled,
      backgroundColor: (pt.vars || pt).palette.action.selected
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      minWidth: 26,
      height: 26,
      borderRadius: 26 / 2,
      margin: "0 1px",
      padding: "0 4px"
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      minWidth: 40,
      height: 40,
      borderRadius: 40 / 2,
      padding: "0 10px",
      fontSize: pt.typography.pxToRem(15)
    }
  }, {
    props: {
      shape: "rounded"
    },
    style: {
      borderRadius: (pt.vars || pt).shape.borderRadius
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      border: pt.vars ? `1px solid ${pt.alpha(pt.vars.palette.common.onBackground, 0.23)}` : `1px solid ${pt.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
      [`&.${paginationItemClasses.selected}`]: {
        [`&.${paginationItemClasses.disabled}`]: {
          borderColor: (pt.vars || pt).palette.action.disabledBackground,
          color: (pt.vars || pt).palette.action.disabled
        }
      }
    }
  }, {
    props: {
      variant: "text"
    },
    style: {
      [`&.${paginationItemClasses.selected}`]: {
        [`&.${paginationItemClasses.disabled}`]: {
          color: (pt.vars || pt).palette.action.disabled
        }
      }
    }
  }, ...Object.entries(pt.palette).filter(createSimplePaletteValueFilter(["dark", "contrastText"])).map(([yt]) => ({
    props: {
      variant: "text",
      color: yt
    },
    style: {
      [`&.${paginationItemClasses.selected}`]: {
        color: (pt.vars || pt).palette[yt].contrastText,
        backgroundColor: (pt.vars || pt).palette[yt].main,
        "&:hover": {
          backgroundColor: (pt.vars || pt).palette[yt].dark,
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            backgroundColor: (pt.vars || pt).palette[yt].main
          }
        },
        [`&.${paginationItemClasses.focusVisible}`]: {
          backgroundColor: (pt.vars || pt).palette[yt].dark
        },
        [`&.${paginationItemClasses.disabled}`]: {
          color: (pt.vars || pt).palette.action.disabled
        }
      }
    }
  })), ...Object.entries(pt.palette).filter(createSimplePaletteValueFilter(["light"])).map(([yt]) => ({
    props: {
      variant: "outlined",
      color: yt
    },
    style: {
      [`&.${paginationItemClasses.selected}`]: {
        color: (pt.vars || pt).palette[yt].main,
        border: `1px solid ${pt.alpha((pt.vars || pt).palette[yt].main, 0.5)}`,
        backgroundColor: pt.alpha((pt.vars || pt).palette[yt].main, (pt.vars || pt).palette.action.activatedOpacity),
        "&:hover": {
          backgroundColor: pt.alpha((pt.vars || pt).palette[yt].main, `${(pt.vars || pt).palette.action.activatedOpacity} + ${(pt.vars || pt).palette.action.focusOpacity}`),
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            backgroundColor: "transparent"
          }
        },
        [`&.${paginationItemClasses.focusVisible}`]: {
          backgroundColor: pt.alpha((pt.vars || pt).palette[yt].main, `${(pt.vars || pt).palette.action.activatedOpacity} + ${(pt.vars || pt).palette.action.focusOpacity}`)
        }
      }
    }
  }))]
}))), PaginationItemPageIcon = styled("div", {
  name: "MuiPaginationItem",
  slot: "Icon"
})(memoTheme(({
  theme: pt
}) => ({
  fontSize: pt.typography.pxToRem(20),
  margin: "0 -8px",
  variants: [{
    props: {
      size: "small"
    },
    style: {
      fontSize: pt.typography.pxToRem(18)
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      fontSize: pt.typography.pxToRem(22)
    }
  }]
}))), PaginationItem = /* @__PURE__ */ React.forwardRef(function pt(yt, ir) {
  const ti = useDefaultProps({
    props: yt,
    name: "MuiPaginationItem"
  }), {
    className: ii,
    color: ui = "standard",
    component: ai,
    components: li = {},
    disabled: oi = !1,
    page: si,
    selected: di = !1,
    shape: fi = "circular",
    size: gi = "medium",
    slots: mi = {},
    slotProps: Ti = {},
    type: vi = "page",
    variant: xi = "text",
    ...Si
  } = ti, Pi = {
    ...ti,
    color: ui,
    disabled: oi,
    selected: di,
    shape: fi,
    size: gi,
    type: vi,
    variant: xi
  }, $i = useRtl(), Oi = useUtilityClasses$1(Pi), Di = {
    slots: {
      previous: mi.previous ?? li.previous,
      next: mi.next ?? li.next,
      first: mi.first ?? li.first,
      last: mi.last ?? li.last
    },
    slotProps: Ti
  }, [Mi, Oo] = useSlot("previous", {
    elementType: NavigateBeforeIcon,
    externalForwardedProps: Di,
    ownerState: Pi
  }), [io, xo] = useSlot("next", {
    elementType: NavigateNextIcon,
    externalForwardedProps: Di,
    ownerState: Pi
  }), [fo, _o] = useSlot("first", {
    elementType: FirstPageIconDefault,
    externalForwardedProps: Di,
    ownerState: Pi
  }), [Li, Co] = useSlot("last", {
    elementType: LastPageIconDefault,
    externalForwardedProps: Di,
    ownerState: Pi
  }), Ni = $i ? {
    previous: "next",
    next: "previous",
    first: "last",
    last: "first"
  }[vi] : vi, Yi = {
    previous: Mi,
    next: io,
    first: fo,
    last: Li
  }[Ni], Vo = {
    previous: Oo,
    next: xo,
    first: _o,
    last: Co
  }[Ni];
  return vi === "start-ellipsis" || vi === "end-ellipsis" ? /* @__PURE__ */ jsxRuntimeExports$1.jsx(PaginationItemEllipsis, {
    ref: ir,
    ownerState: Pi,
    className: clsx(Oi.root, ii),
    children: "…"
  }) : /* @__PURE__ */ jsxRuntimeExports$1.jsxs(PaginationItemPage, {
    ref: ir,
    ownerState: Pi,
    component: ai,
    disabled: oi,
    className: clsx(Oi.root, ii),
    ...Si,
    children: [vi === "page" && si, Yi ? /* @__PURE__ */ jsxRuntimeExports$1.jsx(PaginationItemPageIcon, {
      ...Vo,
      className: Oi.icon,
      as: Yi
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (PaginationItem.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: PropTypes$1.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,
  /**
   * @ignore
   */
  className: PropTypes$1.string,
  /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */
  color: PropTypes$1.oneOfType([PropTypes$1.oneOf(["primary", "secondary", "standard"]), PropTypes$1.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes$1.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   * @deprecated use the `slots` prop instead. This prop will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  components: PropTypes$1.shape({
    first: PropTypes$1.elementType,
    last: PropTypes$1.elementType,
    next: PropTypes$1.elementType,
    previous: PropTypes$1.elementType
  }),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes$1.bool,
  /**
   * The current page number.
   */
  page: PropTypes$1.node,
  /**
   * If `true` the pagination item is selected.
   * @default false
   */
  selected: PropTypes$1.bool,
  /**
   * The shape of the pagination item.
   * @default 'circular'
   */
  shape: PropTypes$1.oneOf(["circular", "rounded"]),
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes$1.oneOfType([PropTypes$1.oneOf(["small", "medium", "large"]), PropTypes$1.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes$1.shape({
    first: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object]),
    last: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object]),
    next: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object]),
    previous: PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes$1.shape({
    first: PropTypes$1.elementType,
    last: PropTypes$1.elementType,
    next: PropTypes$1.elementType,
    previous: PropTypes$1.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),
  /**
   * The type of pagination item.
   * @default 'page'
   */
  type: PropTypes$1.oneOf(["end-ellipsis", "first", "last", "next", "page", "previous", "start-ellipsis"]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: PropTypes$1.oneOfType([PropTypes$1.oneOf(["outlined", "text"]), PropTypes$1.string])
});
const useUtilityClasses = (pt) => {
  const {
    classes: yt,
    variant: ir
  } = pt;
  return composeClasses({
    root: ["root", ir],
    ul: ["ul"]
  }, getPaginationUtilityClass, yt);
}, PaginationRoot = styled("nav", {
  name: "MuiPagination",
  slot: "Root",
  overridesResolver: (pt, yt) => {
    const {
      ownerState: ir
    } = pt;
    return [yt.root, yt[ir.variant]];
  }
})({}), PaginationUl = styled("ul", {
  name: "MuiPagination",
  slot: "Ul"
})({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  padding: 0,
  margin: 0,
  listStyle: "none"
});
function defaultGetAriaLabel(pt, yt, ir) {
  return pt === "page" ? `${ir ? "" : "Go to "}page ${yt}` : `Go to ${pt} page`;
}
const Pagination$1 = /* @__PURE__ */ React.forwardRef(function pt(yt, ir) {
  const ti = useDefaultProps({
    props: yt,
    name: "MuiPagination"
  }), {
    boundaryCount: ii = 1,
    className: ui,
    color: ai = "standard",
    count: li = 1,
    defaultPage: oi = 1,
    disabled: si = !1,
    getItemAriaLabel: di = defaultGetAriaLabel,
    hideNextButton: fi = !1,
    hidePrevButton: gi = !1,
    onChange: mi,
    page: Ti,
    renderItem: vi = (fo) => /* @__PURE__ */ jsxRuntimeExports$1.jsx(PaginationItem, {
      ...fo
    }),
    shape: xi = "circular",
    showFirstButton: Si = !1,
    showLastButton: Pi = !1,
    siblingCount: $i = 1,
    size: Oi = "medium",
    variant: Di = "text",
    ...Mi
  } = ti, {
    items: Oo
  } = usePagination({
    ...ti,
    componentName: "Pagination"
  }), io = {
    ...ti,
    boundaryCount: ii,
    color: ai,
    count: li,
    defaultPage: oi,
    disabled: si,
    getItemAriaLabel: di,
    hideNextButton: fi,
    hidePrevButton: gi,
    renderItem: vi,
    shape: xi,
    showFirstButton: Si,
    showLastButton: Pi,
    siblingCount: $i,
    size: Oi,
    variant: Di
  }, xo = useUtilityClasses(io);
  return /* @__PURE__ */ jsxRuntimeExports$1.jsx(PaginationRoot, {
    "aria-label": "pagination navigation",
    className: clsx(xo.root, ui),
    ownerState: io,
    ref: ir,
    ...Mi,
    children: /* @__PURE__ */ jsxRuntimeExports$1.jsx(PaginationUl, {
      className: xo.ul,
      ownerState: io,
      children: Oo.map((fo, _o) => /* @__PURE__ */ jsxRuntimeExports$1.jsx("li", {
        children: vi({
          ...fo,
          color: ai,
          "aria-label": di(fo.type, fo.page, fo.selected),
          shape: xi,
          size: Oi,
          variant: Di
        })
      }, _o))
    })
  });
});
process.env.NODE_ENV !== "production" && (Pagination$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Number of always visible pages at the beginning and end.
   * @default 1
   */
  boundaryCount: integerPropType,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes$1.object,
  /**
   * @ignore
   */
  className: PropTypes$1.string,
  /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */
  color: PropTypes$1.oneOfType([PropTypes$1.oneOf(["primary", "secondary", "standard"]), PropTypes$1.string]),
  /**
   * The total number of pages.
   * @default 1
   */
  count: integerPropType,
  /**
   * The page selected by default when the component is uncontrolled.
   * @default 1
   */
  defaultPage: integerPropType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes$1.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous' | 'start-ellipsis' | 'end-ellipsis'). Defaults to 'page'.
   * @param {number | null} page The page number to format.
   * @param {boolean} selected If true, the current page is selected.
   * @returns {string}
   */
  getItemAriaLabel: PropTypes$1.func,
  /**
   * If `true`, hide the next-page button.
   * @default false
   */
  hideNextButton: PropTypes$1.bool,
  /**
   * If `true`, hide the previous-page button.
   * @default false
   */
  hidePrevButton: PropTypes$1.bool,
  /**
   * Callback fired when the page is changed.
   *
   * @param {React.ChangeEvent<unknown>} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onChange: PropTypes$1.func,
  /**
   * The current page. Unlike `TablePagination`, which starts numbering from `0`, this pagination starts from `1`.
   */
  page: integerPropType,
  /**
   * Render the item.
   * @param {PaginationRenderItemParams} params The props to spread on a PaginationItem.
   * @returns {ReactNode}
   * @default (item) => <PaginationItem {...item} />
   */
  renderItem: PropTypes$1.func,
  /**
   * The shape of the pagination items.
   * @default 'circular'
   */
  shape: PropTypes$1.oneOf(["circular", "rounded"]),
  /**
   * If `true`, show the first-page button.
   * @default false
   */
  showFirstButton: PropTypes$1.bool,
  /**
   * If `true`, show the last-page button.
   * @default false
   */
  showLastButton: PropTypes$1.bool,
  /**
   * Number of always visible pages before and after the current page.
   * @default 1
   */
  siblingCount: integerPropType,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes$1.oneOfType([PropTypes$1.oneOf(["small", "medium", "large"]), PropTypes$1.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes$1.oneOfType([PropTypes$1.arrayOf(PropTypes$1.oneOfType([PropTypes$1.func, PropTypes$1.object, PropTypes$1.bool])), PropTypes$1.func, PropTypes$1.object]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: PropTypes$1.oneOfType([PropTypes$1.oneOf(["outlined", "text"]), PropTypes$1.string])
});
const STATUSES = [
  { key: "Good Confidence (above 90%)", value: "good" },
  { key: "Bad Confidence (below 90%)", value: "bad" },
  { key: "Missing Result", value: "fail" }
], StatusFilter = ({ filters: pt, onChange: yt }) => {
  const [ir, ti] = useState(!1), ii = useRef(null), ui = useMemo(() => STATUSES.map((li) => li.value), []);
  useEffect(() => {
    (!pt || pt.length === 0) && (yt == null || yt(ui));
  }, []);
  const ai = (li) => {
    const oi = pt.includes(li) ? pt.filter((si) => si !== li) : [...pt, li];
    yt == null || yt(oi);
  };
  return /* @__PURE__ */ jsxRuntimeExports$1.jsxs("sky-status-filter", { children: [
    /* @__PURE__ */ jsxRuntimeExports$1.jsx(
      Button,
      {
        ref: ii,
        label: "Filters",
        type: "text",
        iconRight: ir ? "fa fa-angle-up" : "fa fa-angle-down",
        onClick: () => ti((li) => !li),
        "aria-haspopup": "menu",
        "aria-expanded": ir ? "true" : "false"
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports$1.jsx(
      Menu,
      {
        anchorEl: ii.current,
        open: ir,
        onClose: () => ti(!1),
        PopoverClasses: { paper: "sky-status-filter" },
        children: STATUSES.map(({ key: li, value: oi }) => /* @__PURE__ */ jsxRuntimeExports$1.jsx(MenuItem, { onClick: (si) => {
          si.preventDefault(), ai(oi);
        }, children: /* @__PURE__ */ jsxRuntimeExports$1.jsx(
          Checkbox,
          {
            label: li,
            labelPlacement: "end",
            checked: pt.includes(oi),
            value: oi
          }
        ) }, oi))
      }
    )
  ] });
};
StatusFilter.propTypes = {
  filters: PropTypes$1.arrayOf(PropTypes$1.string),
  onChange: PropTypes$1.func.isRequired
};
const SORT_FIELDS = [
  { key: "Confidence", value: "confidence" },
  { key: "Name", value: "name" }
], StreamSort = ({ value: pt, onChange: yt, onSortOrderToggle: ir, sortOrder: ti }) => {
  const [ii, ui] = useState(!1), [ai, li] = useState(null), oi = (di, fi) => {
    di.stopPropagation(), fi !== pt && (yt == null || yt(fi)), ir();
  }, si = (di) => /* @__PURE__ */ jsxRuntimeExports$1.jsxs(jsxRuntimeExports$1.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports$1.jsx(
      "i",
      {
        className: `fa-solid fa-caret-${di === "asc" ? "up" : "down"}`,
        "aria-hidden": "true"
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports$1.jsx("span", { className: "visually-hidden", children: di === "asc" ? "ascending" : "descending" })
  ] });
  return /* @__PURE__ */ jsxRuntimeExports$1.jsxs("sky-stream-sort", { children: [
    /* @__PURE__ */ jsxRuntimeExports$1.jsx(
      Button,
      {
        ref: li,
        type: "text",
        iconRight: ii ? "fa fa-angle-up" : "fa fa-angle-down",
        id: "sky-sort",
        onClick: () => ui((di) => !di),
        onKeyDown: (di) => di.stopPropagation(),
        "aria-haspopup": "menu",
        "aria-expanded": ii,
        children: "Sort"
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports$1.jsx(
      Menu,
      {
        anchorEl: ai,
        open: ii,
        onClose: () => ui(!1),
        PopoverClasses: { paper: "sky-sort-by" },
        children: SORT_FIELDS.map(({ key: di, value: fi }) => /* @__PURE__ */ jsxRuntimeExports$1.jsxs(
          MenuItem,
          {
            onClick: (gi) => oi(gi, fi),
            selected: fi === pt,
            role: "menuitemradio",
            "aria-checked": fi === pt,
            className: "sort-option",
            children: [
              /* @__PURE__ */ jsxRuntimeExports$1.jsx("span", { className: "sort-option-label", children: di }),
              pt === fi && si(ti)
            ]
          },
          fi
        ))
      }
    )
  ] });
};
StreamSort.propTypes = {
  value: PropTypes$1.string.isRequired,
  // 'confidence' | 'name' | etc.
  onChange: PropTypes$1.func.isRequired,
  onSortOrderToggle: PropTypes$1.func.isRequired,
  sortOrder: PropTypes$1.oneOf(["asc", "desc"]).isRequired
};
const Toolbar = ({
  searchValue: pt,
  onSearchChange: yt,
  filters: ir,
  onFiltersChange: ti,
  sortBy: ii,
  sortOrder: ui,
  onSortByChange: ai,
  onSortOrderToggle: li
}) => /* @__PURE__ */ jsxRuntimeExports$1.jsxs("sky-toolbar", { children: [
  /* @__PURE__ */ jsxRuntimeExports$1.jsx(
    StatusFilter,
    {
      filters: ir,
      onChange: ti
    }
  ),
  /* @__PURE__ */ jsxRuntimeExports$1.jsx("div", { className: "sort-controls", children: /* @__PURE__ */ jsxRuntimeExports$1.jsx(
    StreamSort,
    {
      value: ii,
      onChange: ai,
      onSortOrderToggle: li,
      sortOrder: ui
    }
  ) }),
  /* @__PURE__ */ jsxRuntimeExports$1.jsx(
    SearchBar,
    {
      onChange: yt,
      value: pt
    }
  )
] });
Toolbar.propTypes = {
  searchValue: PropTypes$1.string,
  onSearchChange: PropTypes$1.func.isRequired,
  filters: PropTypes$1.arrayOf(PropTypes$1.string),
  onFiltersChange: PropTypes$1.func.isRequired,
  sortBy: PropTypes$1.string.isRequired,
  sortOrder: PropTypes$1.string.isRequired,
  onSortByChange: PropTypes$1.func.isRequired,
  onSortOrderToggle: PropTypes$1.func.isRequired
};
const Navigator = ({ index: pt, total: yt, onPageChange: ir }) => {
  const ti = pt + 1, ii = yt, ui = () => {
    ir(Math.max(0, pt - 1));
  }, ai = () => {
    ir(Math.min(yt - 1, pt + 1));
  };
  return ii <= 1 ? null : (
    // Role should only be navigation when this component is used for navigating between distinct pages of content.
    // Since it is used for navigating between items within the same page, region is more appropriate (WCAG 4.1.2).
    /* @__PURE__ */ jsxRuntimeExports$1.jsxs("sky-navigator", { role: "region", "aria-label": "Navigation controls", children: [
      /* @__PURE__ */ jsxRuntimeExports$1.jsx(
        Button,
        {
          onClick: ui,
          disabled: pt === 0,
          variant: "outline",
          children: "Previous"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports$1.jsxs("span", { className: "page-count", children: [
        ti,
        " / ",
        ii
      ] }),
      /* @__PURE__ */ jsxRuntimeExports$1.jsx(
        Button,
        {
          onClick: ai,
          disabled: pt >= yt - 1,
          variant: "outline",
          children: "Next"
        }
      )
    ] })
  );
};
Navigator.propTypes = {
  index: PropTypes$1.number.isRequired,
  total: PropTypes$1.number.isRequired,
  onPageChange: PropTypes$1.func.isRequired
};
function mapStreamDetails(pt) {
  if (!pt || typeof pt != "object") return {};
  const yt = (ti) => ti ?? "--", ir = {
    ID: yt(pt.id),
    "Last Run": yt(new Date(pt.timestamp).toLocaleString()),
    Direction: yt(pt.direction),
    MRM: yt(pt.mrm),
    Jurisdiction: yt(pt.jurisdiction),
    "Device ID": yt(pt.deviceId),
    "RTMP URL": yt(pt.rtmp_url),
    "iOS URL": yt(pt.ios_url),
    "RTSP URL": yt(pt.rtsp_url),
    "HTTPS URL": yt(pt.https_url),
    "CLSPS URL": yt(pt.clsps_url),
    "Image URL": yt(pt.image_url),
    Active: yt(pt.active ? "Yes" : "No"),
    "Problem Stream": yt(pt.problem_stream ? "Yes" : "No"),
    Source: yt(pt.source),
    // Commenting out SOAR functionality for MVP
    // 'Ticket Note': toDisplayValue(stream.ticketNote),
    // 'Ticket Summary': toDisplayValue(stream.ticketSummary),
    "Snapshot Server Response": yt(pt.snapshot_server_response),
    "FFmpeg Snapshot": yt(pt.ffmpeg_snapshot),
    // ✅ typo corrected
    Status: yt(pt.status),
    Path: yt(pt.path)
  };
  return Array.isArray(pt.labels) && pt.labels.forEach((ti, ii) => {
    var li, oi;
    const ui = (ti == null ? void 0 : ti.Name) ?? `Label ${ii + 1}`, ai = (ti == null ? void 0 : ti.Confidence) ?? "--";
    if (ir[`Detected: ${ui}`] = `${Math.round(ai)}%`, (li = ti == null ? void 0 : ti.Instances) != null && li.length) {
      const si = ti.Instances.map((di, fi) => {
        if (typeof di == "object" && di !== null) {
          const gi = di.BoundingBox ? `Box: ${JSON.stringify(di.BoundingBox)}` : "", mi = di.Confidence ? `Confidence: ${Math.round(di.Confidence)}%` : "";
          return [gi, mi].filter(Boolean).join(", ") || `Instance ${fi + 1}`;
        }
        return String(di);
      }).join("; ");
      ir[`${ui} - Instances`] = si;
    }
    if ((oi = ti == null ? void 0 : ti.Parents) != null && oi.length) {
      const si = ti.Parents.map((di, fi) => typeof di == "object" && di !== null ? di.Name || `Parent ${fi + 1}` : String(di)).join(", ");
      ir[`${ui} - Parents`] = si;
    }
  }), ir;
}
const DetailsPanel = ({ stream: pt }) => pt ? /* @__PURE__ */ jsxRuntimeExports$1.jsxs("sky-details-panel", { children: [
  /* @__PURE__ */ jsxRuntimeExports$1.jsx("h3", { children: "Details" }),
  /* @__PURE__ */ jsxRuntimeExports$1.jsx(DetailList, { keyValuePair: mapStreamDetails(pt) ?? {} })
] }) : null;
DetailsPanel.propTypes = {
  /**
   * stream metadata object
   */
  stream: PropTypes$1.object.isRequired
};
const ImageViewer = ({
  src: pt,
  alt: yt = "",
  onLoad: ir,
  onError: ti,
  stream: ii,
  nullConfidence: ui = !1,
  ...ai
}) => {
  const [li, oi] = useState(!ui), [si, di] = useState(!1), fi = useRef(), gi = ii == null ? void 0 : ii.image_url, mi = (ii == null ? void 0 : ii.description) || (ii == null ? void 0 : ii.name) || "stream", Ti = (ii == null ? void 0 : ii.description) || (ii == null ? void 0 : ii.name) || yt, vi = (Si) => {
    oi(!1), di(!1), ir == null || ir(Si);
  }, xi = (Si) => {
    oi(!1), di(!0), ti == null || ti(Si);
  };
  return /* @__PURE__ */ jsxRuntimeExports$1.jsxs("sky-image-viewer", { ref: fi, "aria-busy": li ? "true" : "false", children: [
    li && /* @__PURE__ */ jsxRuntimeExports$1.jsx(
      "div",
      {
        className: "loading-indicator",
        role: "status",
        "aria-live": "polite",
        "aria-label": `Loading ${mi}`
      }
    ),
    si ? /* @__PURE__ */ jsxRuntimeExports$1.jsx("div", { className: "fallback", role: "alert", children: "Image failed to load" }) : ui ? /* @__PURE__ */ jsxRuntimeExports$1.jsx("div", { className: "fail", role: "alert", children: "Status Check Failed" }) : /* @__PURE__ */ jsxRuntimeExports$1.jsx(
      "img",
      {
        src: ii ? gi : pt,
        alt: Ti,
        onLoad: vi,
        onError: xi,
        tabIndex: 0,
        "aria-label": `Play live video for ${mi}`,
        "aria-pressed": "false",
        style: { display: li ? "none" : "block" },
        ...ai
      }
    )
  ] });
};
ImageViewer.propTypes = {
  src: PropTypes$1.string,
  alt: PropTypes$1.string,
  onLoad: PropTypes$1.func,
  onError: PropTypes$1.func,
  stream: PropTypes$1.object,
  isPlaying: PropTypes$1.bool,
  onPlayToggle: PropTypes$1.func
};
var skylinePlayer = { exports: {} }, hasRequiredSkylinePlayer;
function requireSkylinePlayer() {
  return hasRequiredSkylinePlayer || (hasRequiredSkylinePlayer = 1, (function(pt, yt) {
    (function(ti, ii) {
      pt.exports = ii();
    })(self, () => (
      /******/
      (() => {
        var ir = {
          /***/
          "./node_modules/@skylineos/videojs-clsp/dist/videojs-clsp.min.js": (
            /*!***********************************************************************!*\
              !*** ./node_modules/@skylineos/videojs-clsp/dist/videojs-clsp.min.js ***!
              \***********************************************************************/
            /***/
            (() => {
              (() => {
                var ai = {
                  /***/
                  478: (
                    /***/
                    ((si, di, fi) => {
                      function gi(Oo) {
                        "@babel/helpers - typeof";
                        return gi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(io) {
                          return typeof io;
                        } : function(io) {
                          return io && typeof Symbol == "function" && io.constructor === Symbol && io !== Symbol.prototype ? "symbol" : typeof io;
                        }, gi(Oo);
                      }
                      function mi(Oo, io) {
                        var xo = Object.keys(Oo);
                        if (Object.getOwnPropertySymbols) {
                          var fo = Object.getOwnPropertySymbols(Oo);
                          io && (fo = fo.filter(function(_o) {
                            return Object.getOwnPropertyDescriptor(Oo, _o).enumerable;
                          })), xo.push.apply(xo, fo);
                        }
                        return xo;
                      }
                      function Ti(Oo) {
                        for (var io = 1; io < arguments.length; io++) {
                          var xo = arguments[io] != null ? arguments[io] : {};
                          io % 2 ? mi(Object(xo), !0).forEach(function(fo) {
                            vi(Oo, fo, xo[fo]);
                          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Oo, Object.getOwnPropertyDescriptors(xo)) : mi(Object(xo)).forEach(function(fo) {
                            Object.defineProperty(Oo, fo, Object.getOwnPropertyDescriptor(xo, fo));
                          });
                        }
                        return Oo;
                      }
                      function vi(Oo, io, xo) {
                        return (io = xi(io)) in Oo ? Object.defineProperty(Oo, io, { value: xo, enumerable: !0, configurable: !0, writable: !0 }) : Oo[io] = xo, Oo;
                      }
                      function xi(Oo) {
                        var io = Si(Oo, "string");
                        return gi(io) == "symbol" ? io : io + "";
                      }
                      function Si(Oo, io) {
                        if (gi(Oo) != "object" || !Oo) return Oo;
                        var xo = Oo[Symbol.toPrimitive];
                        if (xo !== void 0) {
                          var fo = xo.call(Oo, io);
                          if (gi(fo) != "object") return fo;
                          throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return (io === "string" ? String : Number)(Oo);
                      }
                      var Pi = fi(863), $i = fi(764), Oi = fi(330), Di = Oi.version, Mi = Oi.name;
                      si.exports = Ti({}, Pi, {
                        version: Di,
                        name: Mi.split("/").pop(),
                        // The name that will be used to register this plugin with videojs, which in
                        // practice will be used as `player.clsp()`
                        pluginName: "clsp",
                        Logger: $i,
                        // This gives us access to the clsp player version and name (and of course, it
                        // duplicates the utils)
                        clspPlayerUtils: Pi
                      });
                    })
                  ),
                  /***/
                  764: (
                    /***/
                    ((si) => {
                      si.exports = function(di, fi, gi) {
                        function mi(Oi, Di) {
                          if (fi === void 0 && typeof window < "u") {
                            var Mi = window.localStorage.getItem("skylineos.clsp-player.version");
                            Mi !== di && (window.localStorage.setItem("skylineos.clsp-player.logLevel", 0), window.localStorage.setItem("skylineos.clsp-player.version", di));
                            var Oo = Number(window.localStorage.getItem("skylineos.clsp-player.logLevel"));
                            fi = isNaN(Oo) || Oo < 0 ? 0 : Oo, window.localStorage.setItem("skylineos.clsp-player.logLevel", fi);
                          }
                          this.logLevel = fi, this.prefix = Oi, this.prefixStyle = Di;
                        }
                        mi.logLevels = ["critical", "error", "warn", "info", "debug", "silly"], mi.factory = function(Oi, Di) {
                          return new mi(Oi || "", Di);
                        }, mi.prototype._constructMessage = function(Oi, Di) {
                          var Mi = "(" + Oi + ") --> " + Di;
                          return this.prefix && this.prefixStyle && this.logLevel > 1 ? ["%c" + this.prefix, this.prefixStyle, Mi] : this.prefix ? [this.prefix, Mi] : [Mi];
                        };
                        var Ti = 5, vi = 4, xi = 3, Si = 2, Pi = 1, $i = 0;
                        return mi.prototype.silly = function(Oi) {
                          this.logLevel < Ti || gi || console.log.apply(console, this._constructMessage(mi.logLevels[Ti], Oi));
                        }, mi.prototype.debug = function(Oi) {
                          this.logLevel < vi || gi || console.log.apply(console, this._constructMessage(mi.logLevels[vi], Oi));
                        }, mi.prototype.info = function(Oi) {
                          this.logLevel < xi || gi || console.log.apply(console, this._constructMessage(mi.logLevels[xi], Oi));
                        }, mi.prototype.warn = function(Oi) {
                          this.logLevel < Si || gi || console.warn.apply(console, this._constructMessage(mi.logLevels[Si], Oi));
                        }, mi.prototype.error = function(Oi) {
                          this.logLevel < Pi || gi || console.error.apply(console, this._constructMessage(mi.logLevels[Pi], Oi));
                        }, mi.prototype.critical = function(Oi) {
                          gi || console.error.apply(console, this._constructMessage(mi.logLevels[$i], Oi));
                        }, mi;
                      };
                    })
                  ),
                  /***/
                  863: (
                    /***/
                    ((si, di, fi) => {
                      var gi = fi(814), mi = fi(764), Ti = !0, vi = 80, xi = 443, Si = {
                        clsp: vi,
                        clsps: xi
                      }, Pi = gi.name.split("/").pop(), $i = gi.version, Oi = mi($i).factory(), Di = 53, Mi = "video/mp4; codecs='avc1.42E01E'", Oo = 20;
                      function io() {
                        if (window.MediaSource = window.MediaSource || window.WebKitMediaSource, !window.MediaSource)
                          return console.error("Media Source Extensions not supported in your browser, unable to load CLSP Player"), !1;
                        var jo = navigator.userAgent.toLowerCase().indexOf("trident") > -1;
                        if (jo)
                          return Oi.debug("Detected Internet Explorer browser, which is not supported."), !1;
                        var Wi = navigator.userAgent.toLowerCase().indexOf("edge") > -1;
                        if (Wi)
                          return Oi.debug("Detected older Edge browser, which is not supported"), !1;
                        var ji = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
                        if (ji)
                          return Oi.debug("Detected Firefox browser"), !0;
                        var Hi = !!window.chrome;
                        if (!Hi)
                          return !1;
                        try {
                          var zo = parseInt(navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./)[2], 10);
                          return Oi.debug("Detected Chrome version ".concat(zo)), zo >= Di;
                        } catch (Lo) {
                          return Oi.critical("Unable to detect Chrome version"), Oi.critical(Lo), !1;
                        }
                      }
                      function xo(jo) {
                        return jo === Mi;
                      }
                      function fo() {
                        return Oi.debug("Determining Page_Visibility_API property names."), typeof document > "u" ? {
                          hiddenStateName: "",
                          visibilityChangeEventName: ""
                        } : typeof document.hidden < "u" ? (Oi.debug("Using standard Page_Visibility_API property names."), {
                          hiddenStateName: "hidden",
                          visibilityChangeEventName: "visibilitychange"
                        }) : typeof document.msHidden < "u" ? (Oi.debug("Using Microsoft Page_Visibility_API property names."), {
                          hiddenStateName: "msHidden",
                          visibilityChangeEventName: "msvisibilitychange"
                        }) : typeof document.webkitHidden < "u" ? (Oi.debug("Using Webkit Page_Visibility_API property names."), {
                          hiddenStateName: "webkitHidden",
                          visibilityChangeEventName: "webkitvisibilitychange"
                        }) : (Oi.critical("Unable to use the page visibility api - switching tabs and minimizing the page may result in slow downs and page crashes."), {
                          hiddenStateName: "",
                          visibilityChangeEventName: ""
                        });
                      }
                      function _o(jo) {
                        return Si[jo];
                      }
                      function Li(jo, Wi) {
                        Si[jo] = Wi;
                      }
                      function Co() {
                        Ti = !0;
                      }
                      function Ni() {
                        Ti = !1;
                      }
                      function Yi() {
                        return !Ti;
                      }
                      var Vo = fo();
                      function No() {
                        return document[Vo.hiddenStateName];
                      }
                      function Ui() {
                        return window.navigator.onLine;
                      }
                      si.exports = {
                        name: Pi,
                        version: $i,
                        MINIMUM_CHROME_VERSION: Di,
                        SUPPORTED_MIME_TYPE: Mi,
                        DEFAULT_STREAM_TIMEOUT: Oo,
                        supported: io,
                        isSupportedMimeType: xo,
                        windowStateNames: Vo,
                        isDocumentHidden: No,
                        isOnline: Ui,
                        getDefaultStreamPort: _o,
                        setDefaultStreamPort: Li,
                        enablePlayerLogging: Co,
                        disablePlayerLogging: Ni,
                        isPlayerLoggingDisabled: Yi
                      };
                    })
                  ),
                  /***/
                  228: (
                    /***/
                    ((si) => {
                      var di = Object.prototype.hasOwnProperty, fi = "~";
                      function gi() {
                      }
                      Object.create && (gi.prototype = /* @__PURE__ */ Object.create(null), new gi().__proto__ || (fi = !1));
                      function mi(Si, Pi, $i) {
                        this.fn = Si, this.context = Pi, this.once = $i || !1;
                      }
                      function Ti(Si, Pi, $i, Oi, Di) {
                        if (typeof $i != "function")
                          throw new TypeError("The listener must be a function");
                        var Mi = new mi($i, Oi || Si, Di), Oo = fi ? fi + Pi : Pi;
                        return Si._events[Oo] ? Si._events[Oo].fn ? Si._events[Oo] = [Si._events[Oo], Mi] : Si._events[Oo].push(Mi) : (Si._events[Oo] = Mi, Si._eventsCount++), Si;
                      }
                      function vi(Si, Pi) {
                        --Si._eventsCount === 0 ? Si._events = new gi() : delete Si._events[Pi];
                      }
                      function xi() {
                        this._events = new gi(), this._eventsCount = 0;
                      }
                      xi.prototype.eventNames = function() {
                        var Pi = [], $i, Oi;
                        if (this._eventsCount === 0) return Pi;
                        for (Oi in $i = this._events)
                          di.call($i, Oi) && Pi.push(fi ? Oi.slice(1) : Oi);
                        return Object.getOwnPropertySymbols ? Pi.concat(Object.getOwnPropertySymbols($i)) : Pi;
                      }, xi.prototype.listeners = function(Pi) {
                        var $i = fi ? fi + Pi : Pi, Oi = this._events[$i];
                        if (!Oi) return [];
                        if (Oi.fn) return [Oi.fn];
                        for (var Di = 0, Mi = Oi.length, Oo = new Array(Mi); Di < Mi; Di++)
                          Oo[Di] = Oi[Di].fn;
                        return Oo;
                      }, xi.prototype.listenerCount = function(Pi) {
                        var $i = fi ? fi + Pi : Pi, Oi = this._events[$i];
                        return Oi ? Oi.fn ? 1 : Oi.length : 0;
                      }, xi.prototype.emit = function(Pi, $i, Oi, Di, Mi, Oo) {
                        var io = fi ? fi + Pi : Pi;
                        if (!this._events[io]) return !1;
                        var xo = this._events[io], fo = arguments.length, _o, Li;
                        if (xo.fn) {
                          switch (xo.once && this.removeListener(Pi, xo.fn, void 0, !0), fo) {
                            case 1:
                              return xo.fn.call(xo.context), !0;
                            case 2:
                              return xo.fn.call(xo.context, $i), !0;
                            case 3:
                              return xo.fn.call(xo.context, $i, Oi), !0;
                            case 4:
                              return xo.fn.call(xo.context, $i, Oi, Di), !0;
                            case 5:
                              return xo.fn.call(xo.context, $i, Oi, Di, Mi), !0;
                            case 6:
                              return xo.fn.call(xo.context, $i, Oi, Di, Mi, Oo), !0;
                          }
                          for (Li = 1, _o = new Array(fo - 1); Li < fo; Li++)
                            _o[Li - 1] = arguments[Li];
                          xo.fn.apply(xo.context, _o);
                        } else {
                          var Co = xo.length, Ni;
                          for (Li = 0; Li < Co; Li++)
                            switch (xo[Li].once && this.removeListener(Pi, xo[Li].fn, void 0, !0), fo) {
                              case 1:
                                xo[Li].fn.call(xo[Li].context);
                                break;
                              case 2:
                                xo[Li].fn.call(xo[Li].context, $i);
                                break;
                              case 3:
                                xo[Li].fn.call(xo[Li].context, $i, Oi);
                                break;
                              case 4:
                                xo[Li].fn.call(xo[Li].context, $i, Oi, Di);
                                break;
                              default:
                                if (!_o) for (Ni = 1, _o = new Array(fo - 1); Ni < fo; Ni++)
                                  _o[Ni - 1] = arguments[Ni];
                                xo[Li].fn.apply(xo[Li].context, _o);
                            }
                        }
                        return !0;
                      }, xi.prototype.on = function(Pi, $i, Oi) {
                        return Ti(this, Pi, $i, Oi, !1);
                      }, xi.prototype.once = function(Pi, $i, Oi) {
                        return Ti(this, Pi, $i, Oi, !0);
                      }, xi.prototype.removeListener = function(Pi, $i, Oi, Di) {
                        var Mi = fi ? fi + Pi : Pi;
                        if (!this._events[Mi]) return this;
                        if (!$i)
                          return vi(this, Mi), this;
                        var Oo = this._events[Mi];
                        if (Oo.fn)
                          Oo.fn === $i && (!Di || Oo.once) && (!Oi || Oo.context === Oi) && vi(this, Mi);
                        else {
                          for (var io = 0, xo = [], fo = Oo.length; io < fo; io++)
                            (Oo[io].fn !== $i || Di && !Oo[io].once || Oi && Oo[io].context !== Oi) && xo.push(Oo[io]);
                          xo.length ? this._events[Mi] = xo.length === 1 ? xo[0] : xo : vi(this, Mi);
                        }
                        return this;
                      }, xi.prototype.removeAllListeners = function(Pi) {
                        var $i;
                        return Pi ? ($i = fi ? fi + Pi : Pi, this._events[$i] && vi(this, $i)) : (this._events = new gi(), this._eventsCount = 0), this;
                      }, xi.prototype.off = xi.prototype.removeListener, xi.prototype.addListener = xi.prototype.on, xi.prefixed = fi, xi.EventEmitter = xi, si.exports = xi;
                    })
                  ),
                  /***/
                  973: (
                    /***/
                    ((si) => {
                      function di(mi) {
                        return mi != null && typeof mi.then == "function";
                      }
                      function fi(mi, Ti, vi = {}) {
                        gi(mi, Ti, vi);
                        const Si = Object.assign({
                          iterations: 1 / 0,
                          stopOnError: !0
                        }, vi);
                        return new Promise((Pi, $i) => {
                          const Oi = (Di) => {
                            let Mi = !1;
                            const Oo = () => {
                              Mi = !0;
                            }, io = () => {
                              if (Di === Si.iterations || Mi) {
                                Pi();
                                return;
                              }
                              Oi(Di + 1);
                            }, xo = typeof Ti == "function" ? Ti(Di) : Ti;
                            if (typeof Ti == "function" && (!Number.isInteger(xo) || xo < 0)) {
                              $i(new Error('Function for "intervalLength" argument must return a non-negative integer.'));
                              return;
                            }
                            setTimeout(() => {
                              const fo = mi(Di, Oo);
                              if (!di(fo)) {
                                $i(new Error('Return value of "func" must be a Promise.'));
                                return;
                              }
                              fo.then(io).catch((_o) => {
                                if (!Si.stopOnError) {
                                  io();
                                  return;
                                }
                                $i(_o);
                              });
                            }, xo);
                          };
                          Oi(1);
                        });
                      }
                      function gi(mi, Ti, vi) {
                        if (typeof mi != "function")
                          throw new TypeError('Argument 1, "func", must be a function.');
                        if (typeof Ti == "number") {
                          if (!Number.isInteger(Ti) || Ti < 0)
                            throw new TypeError('Argument 2, "intervalLength", must be a non-negative integer or a function that returns a non-negative integer.');
                        } else if (typeof Ti != "function")
                          throw new TypeError('Argument 2, "intervalLength", must be a non-negative integer or a function that returns a non-negative integer.');
                        if (typeof vi != "object")
                          throw new TypeError('Argument 3, "options", must be an object.');
                        const xi = ["iterations", "stopOnError"];
                        if (Object.keys(vi).forEach((Si) => {
                          if (!xi.includes(Si))
                            throw new TypeError('Option "' + Si + '" is not a valid option.');
                        }), typeof vi.iterations < "u" && vi.iterations !== 1 / 0 && (!Number.isInteger(vi.iterations) || vi.iterations < 1))
                          throw new TypeError('Option "iterations" must be Infinity or an integer greater than 0.');
                        if (typeof vi.stopOnError < "u" && typeof vi.stopOnError != "boolean")
                          throw new TypeError('Option "stopOnError" must be a boolean.');
                      }
                      si.exports = fi;
                    })
                  ),
                  /***/
                  843: (
                    /***/
                    ((si) => {
                      function di(fi) {
                        return fi == null;
                      }
                      si.exports = di;
                    })
                  ),
                  /***/
                  543: (
                    /***/
                    (function(si) {
                      (function(fi, gi) {
                        si.exports = gi();
                      })(this, function() {
                        var fi = (function(gi) {
                          var mi = "@VERSION@-@BUILDLEVEL@", Ti = gi.localStorage || /* @__PURE__ */ (function() {
                            var ji = {};
                            return {
                              setItem: function(Hi, zo) {
                                ji[Hi] = zo;
                              },
                              getItem: function(Hi) {
                                return ji[Hi];
                              },
                              removeItem: function(Hi) {
                                delete ji[Hi];
                              }
                            };
                          })(), vi = {
                            CONNECT: 1,
                            CONNACK: 2,
                            PUBLISH: 3,
                            PUBACK: 4,
                            PUBREC: 5,
                            PUBREL: 6,
                            PUBCOMP: 7,
                            SUBSCRIBE: 8,
                            SUBACK: 9,
                            UNSUBSCRIBE: 10,
                            UNSUBACK: 11,
                            PINGREQ: 12,
                            PINGRESP: 13,
                            DISCONNECT: 14
                          }, xi = function(ji, Hi) {
                            for (var zo in ji)
                              if (ji.hasOwnProperty(zo))
                                if (Hi.hasOwnProperty(zo)) {
                                  if (typeof ji[zo] !== Hi[zo])
                                    throw new Error(Oi(Pi.INVALID_TYPE, [typeof ji[zo], zo]));
                                } else {
                                  var Lo = "Unknown property, " + zo + ". Valid properties are:";
                                  for (var sa in Hi)
                                    Hi.hasOwnProperty(sa) && (Lo = Lo + " " + sa);
                                  throw new Error(Lo);
                                }
                          }, Si = function(ji, Hi) {
                            return function() {
                              return ji.apply(Hi, arguments);
                            };
                          }, Pi = {
                            OK: { code: 0, text: "AMQJSC0000I OK." },
                            CONNECT_TIMEOUT: { code: 1, text: "AMQJSC0001E Connect timed out." },
                            SUBSCRIBE_TIMEOUT: { code: 2, text: "AMQJS0002E Subscribe timed out." },
                            UNSUBSCRIBE_TIMEOUT: { code: 3, text: "AMQJS0003E Unsubscribe timed out." },
                            PING_TIMEOUT: { code: 4, text: "AMQJS0004E Ping timed out." },
                            INTERNAL_ERROR: { code: 5, text: "AMQJS0005E Internal error. Error Message: {0}, Stack trace: {1}" },
                            CONNACK_RETURNCODE: { code: 6, text: "AMQJS0006E Bad Connack return code:{0} {1}." },
                            SOCKET_ERROR: { code: 7, text: "AMQJS0007E Socket error:{0}." },
                            SOCKET_CLOSE: { code: 8, text: "AMQJS0008I Socket closed." },
                            MALFORMED_UTF: { code: 9, text: "AMQJS0009E Malformed UTF data:{0} {1} {2}." },
                            UNSUPPORTED: { code: 10, text: "AMQJS0010E {0} is not supported by this browser." },
                            INVALID_STATE: { code: 11, text: "AMQJS0011E Invalid state {0}." },
                            INVALID_TYPE: { code: 12, text: "AMQJS0012E Invalid type {0} for {1}." },
                            INVALID_ARGUMENT: { code: 13, text: "AMQJS0013E Invalid argument {0} for {1}." },
                            UNSUPPORTED_OPERATION: { code: 14, text: "AMQJS0014E Unsupported operation." },
                            INVALID_STORED_DATA: { code: 15, text: "AMQJS0015E Invalid data in local storage key={0} value={1}." },
                            INVALID_MQTT_MESSAGE_TYPE: { code: 16, text: "AMQJS0016E Invalid MQTT message type {0}." },
                            MALFORMED_UNICODE: { code: 17, text: "AMQJS0017E Malformed Unicode string:{0} {1}." },
                            BUFFER_FULL: { code: 18, text: "AMQJS0018E Message buffer is full, maximum buffer size: {0}." }
                          }, $i = {
                            0: "Connection Accepted",
                            1: "Connection Refused: unacceptable protocol version",
                            2: "Connection Refused: identifier rejected",
                            3: "Connection Refused: server unavailable",
                            4: "Connection Refused: bad user name or password",
                            5: "Connection Refused: not authorized"
                          }, Oi = function(ji, Hi) {
                            var zo = ji.text;
                            if (Hi) {
                              for (var Lo, sa, Ko = 0; Ko < Hi.length; Ko++)
                                if (Lo = "{" + Ko + "}", sa = zo.indexOf(Lo), sa > 0) {
                                  var ca = zo.substring(0, sa), pa = zo.substring(sa + Lo.length);
                                  zo = ca + Hi[Ko] + pa;
                                }
                            }
                            return zo;
                          }, Di = [0, 6, 77, 81, 73, 115, 100, 112, 3], Mi = [0, 4, 77, 81, 84, 84, 4], Oo = function(ji, Hi) {
                            this.type = ji;
                            for (var zo in Hi)
                              Hi.hasOwnProperty(zo) && (this[zo] = Hi[zo]);
                          };
                          Oo.prototype.encode = function() {
                            var ji = (this.type & 15) << 4, Hi = 0, zo = [], Lo = 0, sa;
                            switch (this.messageIdentifier !== void 0 && (Hi += 2), this.type) {
                              // If this a Connect then we need to include 12 bytes for its header
                              case vi.CONNECT:
                                switch (this.mqttVersion) {
                                  case 3:
                                    Hi += Di.length + 3;
                                    break;
                                  case 4:
                                    Hi += Mi.length + 3;
                                    break;
                                }
                                Hi += Co(this.clientId) + 2, this.willMessage !== void 0 && (Hi += Co(this.willMessage.destinationName) + 2, sa = this.willMessage.payloadBytes, sa instanceof Uint8Array || (sa = new Uint8Array(ca)), Hi += sa.byteLength + 2), this.userName !== void 0 && (Hi += Co(this.userName) + 2), this.password !== void 0 && (Hi += Co(this.password) + 2);
                                break;
                              // Subscribe, Unsubscribe can both contain topic strings
                              case vi.SUBSCRIBE:
                                ji |= 2;
                                for (var Ko = 0; Ko < this.topics.length; Ko++)
                                  zo[Ko] = Co(this.topics[Ko]), Hi += zo[Ko] + 2;
                                Hi += this.requestedQos.length;
                                break;
                              case vi.UNSUBSCRIBE:
                                ji |= 2;
                                for (var Ko = 0; Ko < this.topics.length; Ko++)
                                  zo[Ko] = Co(this.topics[Ko]), Hi += zo[Ko] + 2;
                                break;
                              case vi.PUBREL:
                                ji |= 2;
                                break;
                              case vi.PUBLISH:
                                this.payloadMessage.duplicate && (ji |= 8), ji = ji |= this.payloadMessage.qos << 1, this.payloadMessage.retained && (ji |= 1), Lo = Co(this.payloadMessage.destinationName), Hi += Lo + 2;
                                var ca = this.payloadMessage.payloadBytes;
                                Hi += ca.byteLength, ca instanceof ArrayBuffer ? ca = new Uint8Array(ca) : ca instanceof Uint8Array || (ca = new Uint8Array(ca.buffer));
                                break;
                            }
                            var pa = Li(Hi), ga = pa.length + 1, ia = new ArrayBuffer(Hi + ga), ra = new Uint8Array(ia);
                            if (ra[0] = ji, ra.set(pa, 1), this.type == vi.PUBLISH)
                              ga = fo(this.payloadMessage.destinationName, Lo, ra, ga);
                            else if (this.type == vi.CONNECT) {
                              switch (this.mqttVersion) {
                                case 3:
                                  ra.set(Di, ga), ga += Di.length;
                                  break;
                                case 4:
                                  ra.set(Mi, ga), ga += Mi.length;
                                  break;
                              }
                              var qo = 0;
                              this.cleanSession && (qo = 2), this.willMessage !== void 0 && (qo |= 4, qo |= this.willMessage.qos << 3, this.willMessage.retained && (qo |= 32)), this.userName !== void 0 && (qo |= 128), this.password !== void 0 && (qo |= 64), ra[ga++] = qo, ga = xo(this.keepAliveInterval, ra, ga);
                            }
                            switch (this.messageIdentifier !== void 0 && (ga = xo(this.messageIdentifier, ra, ga)), this.type) {
                              case vi.CONNECT:
                                ga = fo(this.clientId, Co(this.clientId), ra, ga), this.willMessage !== void 0 && (ga = fo(this.willMessage.destinationName, Co(this.willMessage.destinationName), ra, ga), ga = xo(sa.byteLength, ra, ga), ra.set(sa, ga), ga += sa.byteLength), this.userName !== void 0 && (ga = fo(this.userName, Co(this.userName), ra, ga)), this.password !== void 0 && (ga = fo(this.password, Co(this.password), ra, ga));
                                break;
                              case vi.PUBLISH:
                                ra.set(ca, ga);
                                break;
                              //    	    case MESSAGE_TYPE.PUBREC:
                              //    	    case MESSAGE_TYPE.PUBREL:
                              //    	    case MESSAGE_TYPE.PUBCOMP:
                              //    	    	break;
                              case vi.SUBSCRIBE:
                                for (var Ko = 0; Ko < this.topics.length; Ko++)
                                  ga = fo(this.topics[Ko], zo[Ko], ra, ga), ra[ga++] = this.requestedQos[Ko];
                                break;
                              case vi.UNSUBSCRIBE:
                                for (var Ko = 0; Ko < this.topics.length; Ko++)
                                  ga = fo(this.topics[Ko], zo[Ko], ra, ga);
                                break;
                            }
                            return ia;
                          };
                          function io(ji, Hi) {
                            var zo = Hi, Lo = ji[Hi], sa = Lo >> 4, Ko = Lo &= 15;
                            Hi += 1;
                            var ca, pa = 0, ga = 1;
                            do {
                              if (Hi == ji.length)
                                return [null, zo];
                              ca = ji[Hi++], pa += (ca & 127) * ga, ga *= 128;
                            } while ((ca & 128) !== 0);
                            var ia = Hi + pa;
                            if (ia > ji.length)
                              return [null, zo];
                            var ra = new Oo(sa);
                            switch (sa) {
                              case vi.CONNACK:
                                var qo = ji[Hi++];
                                qo & 1 && (ra.sessionPresent = !0), ra.returnCode = ji[Hi++];
                                break;
                              case vi.PUBLISH:
                                var xa = Ko >> 1 & 3, $a = _o(ji, Hi);
                                Hi += 2;
                                var ys = Yi(ji, Hi, $a);
                                Hi += $a, xa > 0 && (ra.messageIdentifier = _o(ji, Hi), Hi += 2);
                                var Ss = new Wi(ji.subarray(Hi, ia));
                                (Ko & 1) == 1 && (Ss.retained = !0), (Ko & 8) == 8 && (Ss.duplicate = !0), Ss.qos = xa, Ss.destinationName = ys, ra.payloadMessage = Ss;
                                break;
                              case vi.PUBACK:
                              case vi.PUBREC:
                              case vi.PUBREL:
                              case vi.PUBCOMP:
                              case vi.UNSUBACK:
                                ra.messageIdentifier = _o(ji, Hi);
                                break;
                              case vi.SUBACK:
                                ra.messageIdentifier = _o(ji, Hi), Hi += 2, ra.returnCode = ji.subarray(Hi, ia);
                                break;
                            }
                            return [ra, ia];
                          }
                          function xo(ji, Hi, zo) {
                            return Hi[zo++] = ji >> 8, Hi[zo++] = ji % 256, zo;
                          }
                          function fo(ji, Hi, zo, Lo) {
                            return Lo = xo(Hi, zo, Lo), Ni(ji, zo, Lo), Lo + Hi;
                          }
                          function _o(ji, Hi) {
                            return 256 * ji[Hi] + ji[Hi + 1];
                          }
                          function Li(ji) {
                            var Hi = new Array(1), zo = 0;
                            do {
                              var Lo = ji % 128;
                              ji = ji >> 7, ji > 0 && (Lo |= 128), Hi[zo++] = Lo;
                            } while (ji > 0 && zo < 4);
                            return Hi;
                          }
                          function Co(ji) {
                            for (var Hi = 0, zo = 0; zo < ji.length; zo++) {
                              var Lo = ji.charCodeAt(zo);
                              Lo > 2047 ? (55296 <= Lo && Lo <= 56319 && (zo++, Hi++), Hi += 3) : Lo > 127 ? Hi += 2 : Hi++;
                            }
                            return Hi;
                          }
                          function Ni(ji, Hi, zo) {
                            for (var Lo = zo, sa = 0; sa < ji.length; sa++) {
                              var Ko = ji.charCodeAt(sa);
                              if (55296 <= Ko && Ko <= 56319) {
                                var ca = ji.charCodeAt(++sa);
                                if (isNaN(ca))
                                  throw new Error(Oi(Pi.MALFORMED_UNICODE, [Ko, ca]));
                                Ko = (Ko - 55296 << 10) + (ca - 56320) + 65536;
                              }
                              Ko <= 127 ? Hi[Lo++] = Ko : Ko <= 2047 ? (Hi[Lo++] = Ko >> 6 & 31 | 192, Hi[Lo++] = Ko & 63 | 128) : Ko <= 65535 ? (Hi[Lo++] = Ko >> 12 & 15 | 224, Hi[Lo++] = Ko >> 6 & 63 | 128, Hi[Lo++] = Ko & 63 | 128) : (Hi[Lo++] = Ko >> 18 & 7 | 240, Hi[Lo++] = Ko >> 12 & 63 | 128, Hi[Lo++] = Ko >> 6 & 63 | 128, Hi[Lo++] = Ko & 63 | 128);
                            }
                            return Hi;
                          }
                          function Yi(ji, Hi, zo) {
                            for (var Lo = "", sa, Ko = Hi; Ko < Hi + zo; ) {
                              var ca = ji[Ko++];
                              if (ca < 128)
                                sa = ca;
                              else {
                                var pa = ji[Ko++] - 128;
                                if (pa < 0)
                                  throw new Error(Oi(Pi.MALFORMED_UTF, [ca.toString(16), pa.toString(16), ""]));
                                if (ca < 224)
                                  sa = 64 * (ca - 192) + pa;
                                else {
                                  var ga = ji[Ko++] - 128;
                                  if (ga < 0)
                                    throw new Error(Oi(Pi.MALFORMED_UTF, [ca.toString(16), pa.toString(16), ga.toString(16)]));
                                  if (ca < 240)
                                    sa = 4096 * (ca - 224) + 64 * pa + ga;
                                  else {
                                    var ia = ji[Ko++] - 128;
                                    if (ia < 0)
                                      throw new Error(Oi(Pi.MALFORMED_UTF, [ca.toString(16), pa.toString(16), ga.toString(16), ia.toString(16)]));
                                    if (ca < 248)
                                      sa = 262144 * (ca - 240) + 4096 * pa + 64 * ga + ia;
                                    else
                                      throw new Error(Oi(Pi.MALFORMED_UTF, [ca.toString(16), pa.toString(16), ga.toString(16), ia.toString(16)]));
                                  }
                                }
                              }
                              sa > 65535 && (sa -= 65536, Lo += String.fromCharCode(55296 + (sa >> 10)), sa = 56320 + (sa & 1023)), Lo += String.fromCharCode(sa);
                            }
                            return Lo;
                          }
                          var Vo = function(ji, Hi) {
                            this._client = ji, this._keepAliveInterval = Hi * 1e3, this.isReset = !1;
                            var zo = new Oo(vi.PINGREQ).encode(), Lo = function(Ko) {
                              return function() {
                                return sa.apply(Ko);
                              };
                            }, sa = function() {
                              this.isReset ? (this.isReset = !1, this._client._trace("Pinger.doPing", "send PINGREQ"), this._client.socket.send(zo), this.timeout = setTimeout(Lo(this), this._keepAliveInterval)) : (this._client._trace("Pinger.doPing", "Timed out"), this._client._disconnected(Pi.PING_TIMEOUT.code, Oi(Pi.PING_TIMEOUT)));
                            };
                            this.reset = function() {
                              this.isReset = !0, clearTimeout(this.timeout), this._keepAliveInterval > 0 && (this.timeout = setTimeout(Lo(this), this._keepAliveInterval));
                            }, this.cancel = function() {
                              clearTimeout(this.timeout);
                            };
                          }, No = function(ji, Hi, zo, Lo) {
                            Hi || (Hi = 30);
                            var sa = function(Ko, ca, pa) {
                              return function() {
                                return Ko.apply(ca, pa);
                              };
                            };
                            this.timeout = setTimeout(sa(zo, ji, Lo), Hi * 1e3), this.cancel = function() {
                              clearTimeout(this.timeout);
                            };
                          }, Ui = function(ji, Hi, zo, Lo, sa) {
                            if (!("WebSocket" in gi && gi.WebSocket !== null))
                              throw new Error(Oi(Pi.UNSUPPORTED, ["WebSocket"]));
                            if (!("ArrayBuffer" in gi && gi.ArrayBuffer !== null))
                              throw new Error(Oi(Pi.UNSUPPORTED, ["ArrayBuffer"]));
                            this._trace("Paho.Client", ji, Hi, zo, Lo, sa), this.host = Hi, this.port = zo, this.path = Lo, this.uri = ji, this.clientId = sa, this._wsuri = null, this._localKey = Hi + ":" + zo + (Lo != "/mqtt" ? ":" + Lo : "") + ":" + sa + ":", this._msg_queue = [], this._buffered_msg_queue = [], this._sentMessages = {}, this._receivedMessages = {}, this._notify_msg_sent = {}, this._message_identifier = 1, this._sequence = 0;
                            for (var Ko in Ti)
                              (Ko.indexOf("Sent:" + this._localKey) === 0 || Ko.indexOf("Received:" + this._localKey) === 0) && this.restore(Ko);
                          };
                          Ui.prototype.host = null, Ui.prototype.port = null, Ui.prototype.path = null, Ui.prototype.uri = null, Ui.prototype.clientId = null, Ui.prototype.socket = null, Ui.prototype.connected = !1, Ui.prototype.maxMessageIdentifier = 65536, Ui.prototype.connectOptions = null, Ui.prototype.hostIndex = null, Ui.prototype.onConnected = null, Ui.prototype.onConnectionLost = null, Ui.prototype.onMessageDelivered = null, Ui.prototype.onMessageArrived = null, Ui.prototype.traceFunction = null, Ui.prototype._msg_queue = null, Ui.prototype._buffered_msg_queue = null, Ui.prototype._connectTimeout = null, Ui.prototype.sendPinger = null, Ui.prototype.receivePinger = null, Ui.prototype._reconnectInterval = 1, Ui.prototype._reconnecting = !1, Ui.prototype._reconnectTimeout = null, Ui.prototype.disconnectedPublishing = !1, Ui.prototype.disconnectedBufferSize = 5e3, Ui.prototype.receiveBuffer = null, Ui.prototype._traceBuffer = null, Ui.prototype._MAX_TRACE_ENTRIES = 100, Ui.prototype.connect = function(ji) {
                            var Hi = this._traceMask(ji, "password");
                            if (this._trace("Client.connect", Hi, this.socket, this.connected), this.connected)
                              throw new Error(Oi(Pi.INVALID_STATE, ["already connected"]));
                            if (this.socket)
                              throw new Error(Oi(Pi.INVALID_STATE, ["already connected"]));
                            this._reconnecting && (this._reconnectTimeout.cancel(), this._reconnectTimeout = null, this._reconnecting = !1), this.connectOptions = ji, this._reconnectInterval = 1, this._reconnecting = !1, ji.uris ? (this.hostIndex = 0, this._doConnect(ji.uris[0])) : this._doConnect(this.uri);
                          }, Ui.prototype.subscribe = function(ji, Hi) {
                            if (this._trace("Client.subscribe", ji, Hi), !this.connected)
                              throw new Error(Oi(Pi.INVALID_STATE, ["not connected"]));
                            var zo = new Oo(vi.SUBSCRIBE);
                            zo.topics = ji.constructor === Array ? ji : [ji], Hi.qos === void 0 && (Hi.qos = 0), zo.requestedQos = [];
                            for (var Lo = 0; Lo < zo.topics.length; Lo++)
                              zo.requestedQos[Lo] = Hi.qos;
                            Hi.onSuccess && (zo.onSuccess = function(sa) {
                              Hi.onSuccess({ invocationContext: Hi.invocationContext, grantedQos: sa });
                            }), Hi.onFailure && (zo.onFailure = function(sa) {
                              Hi.onFailure({ invocationContext: Hi.invocationContext, errorCode: sa, errorMessage: Oi(sa) });
                            }), Hi.timeout && (zo.timeOut = new No(
                              this,
                              Hi.timeout,
                              Hi.onFailure,
                              [{
                                invocationContext: Hi.invocationContext,
                                errorCode: Pi.SUBSCRIBE_TIMEOUT.code,
                                errorMessage: Oi(Pi.SUBSCRIBE_TIMEOUT)
                              }]
                            )), this._requires_ack(zo), this._schedule_message(zo);
                          }, Ui.prototype.unsubscribe = function(ji, Hi) {
                            if (this._trace("Client.unsubscribe", ji, Hi), !this.connected)
                              throw new Error(Oi(Pi.INVALID_STATE, ["not connected"]));
                            var zo = new Oo(vi.UNSUBSCRIBE);
                            zo.topics = ji.constructor === Array ? ji : [ji], Hi.onSuccess && (zo.callback = function() {
                              Hi.onSuccess({ invocationContext: Hi.invocationContext });
                            }), Hi.timeout && (zo.timeOut = new No(
                              this,
                              Hi.timeout,
                              Hi.onFailure,
                              [{
                                invocationContext: Hi.invocationContext,
                                errorCode: Pi.UNSUBSCRIBE_TIMEOUT.code,
                                errorMessage: Oi(Pi.UNSUBSCRIBE_TIMEOUT)
                              }]
                            )), this._requires_ack(zo), this._schedule_message(zo);
                          }, Ui.prototype.send = function(ji) {
                            this._trace("Client.send", ji);
                            var Hi = new Oo(vi.PUBLISH);
                            if (Hi.payloadMessage = ji, this.connected)
                              ji.qos > 0 ? this._requires_ack(Hi) : this.onMessageDelivered && (this._notify_msg_sent[Hi] = this.onMessageDelivered(Hi.payloadMessage)), this._schedule_message(Hi);
                            else if (this._reconnecting && this.disconnectedPublishing) {
                              var zo = Object.keys(this._sentMessages).length + this._buffered_msg_queue.length;
                              if (zo > this.disconnectedBufferSize)
                                throw new Error(Oi(Pi.BUFFER_FULL, [this.disconnectedBufferSize]));
                              ji.qos > 0 ? this._requires_ack(Hi) : (Hi.sequence = ++this._sequence, this._buffered_msg_queue.unshift(Hi));
                            } else
                              throw new Error(Oi(Pi.INVALID_STATE, ["not connected"]));
                          }, Ui.prototype.disconnect = function() {
                            if (this._trace("Client.disconnect"), this._reconnecting && (this._reconnectTimeout.cancel(), this._reconnectTimeout = null, this._reconnecting = !1), !this.socket)
                              throw new Error(Oi(Pi.INVALID_STATE, ["not connecting or connected"]));
                            var ji = new Oo(vi.DISCONNECT);
                            this._notify_msg_sent[ji] = Si(this._disconnected, this), this._schedule_message(ji);
                          }, Ui.prototype.getTraceLog = function() {
                            if (this._traceBuffer !== null) {
                              this._trace("Client.getTraceLog", /* @__PURE__ */ new Date()), this._trace("Client.getTraceLog in flight messages", this._sentMessages.length);
                              for (var ji in this._sentMessages)
                                this._trace("_sentMessages ", ji, this._sentMessages[ji]);
                              for (var ji in this._receivedMessages)
                                this._trace("_receivedMessages ", ji, this._receivedMessages[ji]);
                              return this._traceBuffer;
                            }
                          }, Ui.prototype.startTrace = function() {
                            this._traceBuffer === null && (this._traceBuffer = []), this._trace("Client.startTrace", /* @__PURE__ */ new Date(), mi);
                          }, Ui.prototype.stopTrace = function() {
                            delete this._traceBuffer;
                          }, Ui.prototype._doConnect = function(ji) {
                            if (this.connectOptions.useSSL) {
                              var Hi = ji.split(":");
                              Hi[0] = "wss", ji = Hi.join(":");
                            }
                            this._wsuri = ji, this.connected = !1, this.connectOptions.mqttVersion < 4 ? this.socket = new WebSocket(ji, ["mqttv3.1"]) : this.socket = new WebSocket(ji, ["mqtt"]), this.socket.binaryType = "arraybuffer", this.socket.onopen = Si(this._on_socket_open, this), this.socket.onmessage = Si(this._on_socket_message, this), this.socket.onerror = Si(this._on_socket_error, this), this.socket.onclose = Si(this._on_socket_close, this), this.sendPinger = new Vo(this, this.connectOptions.keepAliveInterval), this.receivePinger = new Vo(this, this.connectOptions.keepAliveInterval), this._connectTimeout && (this._connectTimeout.cancel(), this._connectTimeout = null), this._connectTimeout = new No(this, this.connectOptions.timeout, this._disconnected, [Pi.CONNECT_TIMEOUT.code, Oi(Pi.CONNECT_TIMEOUT)]);
                          }, Ui.prototype._schedule_message = function(ji) {
                            this._msg_queue.unshift(ji), this.connected && this._process_queue();
                          }, Ui.prototype.store = function(ji, Hi) {
                            var zo = { type: Hi.type, messageIdentifier: Hi.messageIdentifier, version: 1 };
                            switch (Hi.type) {
                              case vi.PUBLISH:
                                Hi.pubRecReceived && (zo.pubRecReceived = !0), zo.payloadMessage = {};
                                for (var Lo = "", sa = Hi.payloadMessage.payloadBytes, Ko = 0; Ko < sa.length; Ko++)
                                  sa[Ko] <= 15 ? Lo = Lo + "0" + sa[Ko].toString(16) : Lo = Lo + sa[Ko].toString(16);
                                zo.payloadMessage.payloadHex = Lo, zo.payloadMessage.qos = Hi.payloadMessage.qos, zo.payloadMessage.destinationName = Hi.payloadMessage.destinationName, Hi.payloadMessage.duplicate && (zo.payloadMessage.duplicate = !0), Hi.payloadMessage.retained && (zo.payloadMessage.retained = !0), ji.indexOf("Sent:") === 0 && (Hi.sequence === void 0 && (Hi.sequence = ++this._sequence), zo.sequence = Hi.sequence);
                                break;
                              default:
                                throw Error(Oi(Pi.INVALID_STORED_DATA, [ji + this._localKey + Hi.messageIdentifier, zo]));
                            }
                            Ti.setItem(ji + this._localKey + Hi.messageIdentifier, JSON.stringify(zo));
                          }, Ui.prototype.restore = function(ji) {
                            var Hi = Ti.getItem(ji), zo = JSON.parse(Hi), Lo = new Oo(zo.type, zo);
                            switch (zo.type) {
                              case vi.PUBLISH:
                                for (var sa = zo.payloadMessage.payloadHex, Ko = new ArrayBuffer(sa.length / 2), ca = new Uint8Array(Ko), pa = 0; sa.length >= 2; ) {
                                  var ga = parseInt(sa.substring(0, 2), 16);
                                  sa = sa.substring(2, sa.length), ca[pa++] = ga;
                                }
                                var ia = new Wi(ca);
                                ia.qos = zo.payloadMessage.qos, ia.destinationName = zo.payloadMessage.destinationName, zo.payloadMessage.duplicate && (ia.duplicate = !0), zo.payloadMessage.retained && (ia.retained = !0), Lo.payloadMessage = ia;
                                break;
                              default:
                                throw Error(Oi(Pi.INVALID_STORED_DATA, [ji, Hi]));
                            }
                            ji.indexOf("Sent:" + this._localKey) === 0 ? (Lo.payloadMessage.duplicate = !0, this._sentMessages[Lo.messageIdentifier] = Lo) : ji.indexOf("Received:" + this._localKey) === 0 && (this._receivedMessages[Lo.messageIdentifier] = Lo);
                          }, Ui.prototype._process_queue = function() {
                            for (var ji = null; ji = this._msg_queue.pop(); )
                              this._socket_send(ji), this._notify_msg_sent[ji] && (this._notify_msg_sent[ji](), delete this._notify_msg_sent[ji]);
                          }, Ui.prototype._requires_ack = function(ji) {
                            var Hi = Object.keys(this._sentMessages).length;
                            if (Hi > this.maxMessageIdentifier)
                              throw Error("Too many messages:" + Hi);
                            for (; this._sentMessages[this._message_identifier] !== void 0; )
                              this._message_identifier++;
                            ji.messageIdentifier = this._message_identifier, this._sentMessages[ji.messageIdentifier] = ji, ji.type === vi.PUBLISH && this.store("Sent:", ji), this._message_identifier === this.maxMessageIdentifier && (this._message_identifier = 1);
                          }, Ui.prototype._on_socket_open = function() {
                            var ji = new Oo(vi.CONNECT, this.connectOptions);
                            ji.clientId = this.clientId, this._socket_send(ji);
                          }, Ui.prototype._on_socket_message = function(ji) {
                            this._trace("Client._on_socket_message", ji.data);
                            for (var Hi = this._deframeMessages(ji.data), zo = 0; zo < Hi.length; zo += 1)
                              this._handleMessage(Hi[zo]);
                          }, Ui.prototype._deframeMessages = function(ji) {
                            var Hi = new Uint8Array(ji), zo = [];
                            if (this.receiveBuffer) {
                              var Lo = new Uint8Array(this.receiveBuffer.length + Hi.length);
                              Lo.set(this.receiveBuffer), Lo.set(Hi, this.receiveBuffer.length), Hi = Lo, delete this.receiveBuffer;
                            }
                            try {
                              for (var sa = 0; sa < Hi.length; ) {
                                var Ko = io(Hi, sa), ca = Ko[0];
                                if (sa = Ko[1], ca !== null)
                                  zo.push(ca);
                                else
                                  break;
                              }
                              sa < Hi.length && (this.receiveBuffer = Hi.subarray(sa));
                            } catch (ga) {
                              var pa = ga.hasOwnProperty("stack") == "undefined" ? ga.stack.toString() : "No Error Stack Available";
                              this._disconnected(Pi.INTERNAL_ERROR.code, Oi(Pi.INTERNAL_ERROR, [ga.message, pa]));
                              return;
                            }
                            return zo;
                          }, Ui.prototype._handleMessage = function(ji) {
                            this._trace("Client._handleMessage", ji);
                            try {
                              switch (ji.type) {
                                case vi.CONNACK:
                                  if (this._connectTimeout.cancel(), this._reconnectTimeout && this._reconnectTimeout.cancel(), this.connectOptions.cleanSession) {
                                    for (var Hi in this._sentMessages) {
                                      var qo = this._sentMessages[Hi];
                                      Ti.removeItem("Sent:" + this._localKey + qo.messageIdentifier);
                                    }
                                    this._sentMessages = {};
                                    for (var Hi in this._receivedMessages) {
                                      var ia = this._receivedMessages[Hi];
                                      Ti.removeItem("Received:" + this._localKey + ia.messageIdentifier);
                                    }
                                    this._receivedMessages = {};
                                  }
                                  if (ji.returnCode === 0)
                                    this.connected = !0, this.connectOptions.uris && (this.hostIndex = this.connectOptions.uris.length);
                                  else {
                                    this._disconnected(Pi.CONNACK_RETURNCODE.code, Oi(Pi.CONNACK_RETURNCODE, [ji.returnCode, $i[ji.returnCode]]));
                                    break;
                                  }
                                  var sa = [];
                                  for (var zo in this._sentMessages)
                                    this._sentMessages.hasOwnProperty(zo) && sa.push(this._sentMessages[zo]);
                                  if (this._buffered_msg_queue.length > 0)
                                    for (var Lo = null; Lo = this._buffered_msg_queue.pop(); )
                                      sa.push(Lo), this.onMessageDelivered && (this._notify_msg_sent[Lo] = this.onMessageDelivered(Lo.payloadMessage));
                                  for (var sa = sa.sort(function($a, ys) {
                                    return $a.sequence - ys.sequence;
                                  }), Ko = 0, ca = sa.length; Ko < ca; Ko++) {
                                    var qo = sa[Ko];
                                    if (qo.type == vi.PUBLISH && qo.pubRecReceived) {
                                      var pa = new Oo(vi.PUBREL, { messageIdentifier: qo.messageIdentifier });
                                      this._schedule_message(pa);
                                    } else
                                      this._schedule_message(qo);
                                  }
                                  this.connectOptions.onSuccess && this.connectOptions.onSuccess({ invocationContext: this.connectOptions.invocationContext });
                                  var ga = !1;
                                  this._reconnecting && (ga = !0, this._reconnectInterval = 1, this._reconnecting = !1), this._connected(ga, this._wsuri), this._process_queue();
                                  break;
                                case vi.PUBLISH:
                                  this._receivePublish(ji);
                                  break;
                                case vi.PUBACK:
                                  var qo = this._sentMessages[ji.messageIdentifier];
                                  qo && (delete this._sentMessages[ji.messageIdentifier], Ti.removeItem("Sent:" + this._localKey + ji.messageIdentifier), this.onMessageDelivered && this.onMessageDelivered(qo.payloadMessage));
                                  break;
                                case vi.PUBREC:
                                  var qo = this._sentMessages[ji.messageIdentifier];
                                  if (qo) {
                                    qo.pubRecReceived = !0;
                                    var pa = new Oo(vi.PUBREL, { messageIdentifier: ji.messageIdentifier });
                                    this.store("Sent:", qo), this._schedule_message(pa);
                                  }
                                  break;
                                case vi.PUBREL:
                                  var ia = this._receivedMessages[ji.messageIdentifier];
                                  Ti.removeItem("Received:" + this._localKey + ji.messageIdentifier), ia && (this._receiveMessage(ia), delete this._receivedMessages[ji.messageIdentifier]);
                                  var ra = new Oo(vi.PUBCOMP, { messageIdentifier: ji.messageIdentifier });
                                  this._schedule_message(ra);
                                  break;
                                case vi.PUBCOMP:
                                  var qo = this._sentMessages[ji.messageIdentifier];
                                  delete this._sentMessages[ji.messageIdentifier], Ti.removeItem("Sent:" + this._localKey + ji.messageIdentifier), this.onMessageDelivered && this.onMessageDelivered(qo.payloadMessage);
                                  break;
                                case vi.SUBACK:
                                  var qo = this._sentMessages[ji.messageIdentifier];
                                  qo && (qo.timeOut && qo.timeOut.cancel(), ji.returnCode[0] === 128 ? qo.onFailure && qo.onFailure(ji.returnCode) : qo.onSuccess && qo.onSuccess(ji.returnCode), delete this._sentMessages[ji.messageIdentifier]);
                                  break;
                                case vi.UNSUBACK:
                                  var qo = this._sentMessages[ji.messageIdentifier];
                                  qo && (qo.timeOut && qo.timeOut.cancel(), qo.callback && qo.callback(), delete this._sentMessages[ji.messageIdentifier]);
                                  break;
                                case vi.PINGRESP:
                                  this.sendPinger.reset();
                                  break;
                                case vi.DISCONNECT:
                                  this._disconnected(Pi.INVALID_MQTT_MESSAGE_TYPE.code, Oi(Pi.INVALID_MQTT_MESSAGE_TYPE, [ji.type]));
                                  break;
                                default:
                                  this._disconnected(Pi.INVALID_MQTT_MESSAGE_TYPE.code, Oi(Pi.INVALID_MQTT_MESSAGE_TYPE, [ji.type]));
                              }
                            } catch ($a) {
                              var xa = $a.hasOwnProperty("stack") == "undefined" ? $a.stack.toString() : "No Error Stack Available";
                              this._disconnected(Pi.INTERNAL_ERROR.code, Oi(Pi.INTERNAL_ERROR, [$a.message, xa]));
                              return;
                            }
                          }, Ui.prototype._on_socket_error = function(ji) {
                            this._reconnecting || this._disconnected(Pi.SOCKET_ERROR.code, Oi(Pi.SOCKET_ERROR, [ji.data]));
                          }, Ui.prototype._on_socket_close = function() {
                            this._reconnecting || this._disconnected(Pi.SOCKET_CLOSE.code, Oi(Pi.SOCKET_CLOSE));
                          }, Ui.prototype._socket_send = function(ji) {
                            if (ji.type == 1) {
                              var Hi = this._traceMask(ji, "password");
                              this._trace("Client._socket_send", Hi);
                            } else this._trace("Client._socket_send", ji);
                            this.socket.send(ji.encode()), this.sendPinger.reset();
                          }, Ui.prototype._receivePublish = function(ji) {
                            switch (ji.payloadMessage.qos) {
                              case "undefined":
                              case 0:
                                this._receiveMessage(ji);
                                break;
                              case 1:
                                var Hi = new Oo(vi.PUBACK, { messageIdentifier: ji.messageIdentifier });
                                this._schedule_message(Hi), this._receiveMessage(ji);
                                break;
                              case 2:
                                this._receivedMessages[ji.messageIdentifier] = ji, this.store("Received:", ji);
                                var zo = new Oo(vi.PUBREC, { messageIdentifier: ji.messageIdentifier });
                                this._schedule_message(zo);
                                break;
                              default:
                                throw Error("Invaild qos=" + ji.payloadMessage.qos);
                            }
                          }, Ui.prototype._receiveMessage = function(ji) {
                            this.onMessageArrived && this.onMessageArrived(ji.payloadMessage);
                          }, Ui.prototype._connected = function(ji, Hi) {
                            this.onConnected && this.onConnected(ji, Hi);
                          }, Ui.prototype._reconnect = function() {
                            this._trace("Client._reconnect"), this.connected || (this._reconnecting = !0, this.sendPinger.cancel(), this.receivePinger.cancel(), this._reconnectInterval < 128 && (this._reconnectInterval = this._reconnectInterval * 2), this.connectOptions.uris ? (this.hostIndex = 0, this._doConnect(this.connectOptions.uris[0])) : this._doConnect(this.uri));
                          }, Ui.prototype._disconnected = function(ji, Hi) {
                            if (this._trace("Client._disconnected", ji, Hi), ji !== void 0 && this._reconnecting) {
                              this._reconnectTimeout = new No(this, this._reconnectInterval, this._reconnect);
                              return;
                            }
                            if (this.sendPinger.cancel(), this.receivePinger.cancel(), this._connectTimeout && (this._connectTimeout.cancel(), this._connectTimeout = null), this._msg_queue = [], this._buffered_msg_queue = [], this._notify_msg_sent = {}, this.socket && (this.socket.onopen = null, this.socket.onmessage = null, this.socket.onerror = null, this.socket.onclose = null, this.socket.readyState === 1 && this.socket.close(), delete this.socket), this.connectOptions.uris && this.hostIndex < this.connectOptions.uris.length - 1)
                              this.hostIndex++, this._doConnect(this.connectOptions.uris[this.hostIndex]);
                            else if (ji === void 0 && (ji = Pi.OK.code, Hi = Oi(Pi.OK)), this.connected) {
                              if (this.connected = !1, this.onConnectionLost && this.onConnectionLost({ errorCode: ji, errorMessage: Hi, reconnect: this.connectOptions.reconnect, uri: this._wsuri }), ji !== Pi.OK.code && this.connectOptions.reconnect) {
                                this._reconnectInterval = 1, this._reconnect();
                                return;
                              }
                            } else
                              this.connectOptions.mqttVersion === 4 && this.connectOptions.mqttVersionExplicit === !1 ? (this._trace("Failed to connect V4, dropping back to V3"), this.connectOptions.mqttVersion = 3, this.connectOptions.uris ? (this.hostIndex = 0, this._doConnect(this.connectOptions.uris[0])) : this._doConnect(this.uri)) : this.connectOptions.onFailure && this.connectOptions.onFailure({ invocationContext: this.connectOptions.invocationContext, errorCode: ji, errorMessage: Hi });
                          }, Ui.prototype._trace = function() {
                            if (this.traceFunction) {
                              var ji = Array.prototype.slice.call(arguments);
                              for (var Hi in ji)
                                typeof ji[Hi] < "u" && ji.splice(Hi, 1, JSON.stringify(ji[Hi]));
                              var zo = ji.join("");
                              this.traceFunction({ severity: "Debug", message: zo });
                            }
                            if (this._traceBuffer !== null)
                              for (var Hi = 0, Lo = arguments.length; Hi < Lo; Hi++)
                                this._traceBuffer.length == this._MAX_TRACE_ENTRIES && this._traceBuffer.shift(), Hi === 0 ? this._traceBuffer.push(arguments[Hi]) : typeof arguments[Hi] > "u" ? this._traceBuffer.push(arguments[Hi]) : this._traceBuffer.push("  " + JSON.stringify(arguments[Hi]));
                          }, Ui.prototype._traceMask = function(ji, Hi) {
                            var zo = {};
                            for (var Lo in ji)
                              ji.hasOwnProperty(Lo) && (Lo == Hi ? zo[Lo] = "******" : zo[Lo] = ji[Lo]);
                            return zo;
                          };
                          var jo = function(ji, Hi, zo, Lo) {
                            var sa;
                            if (typeof ji != "string")
                              throw new Error(Oi(Pi.INVALID_TYPE, [typeof ji, "host"]));
                            if (arguments.length == 2) {
                              Lo = Hi, sa = ji;
                              var Ko = sa.match(/^(wss?):\/\/((\[(.+)\])|([^\/]+?))(:(\d+))?(\/.*)$/);
                              if (Ko)
                                ji = Ko[4] || Ko[2], Hi = parseInt(Ko[7]), zo = Ko[8];
                              else
                                throw new Error(Oi(Pi.INVALID_ARGUMENT, [ji, "host"]));
                            } else {
                              if (arguments.length == 3 && (Lo = zo, zo = "/mqtt"), typeof Hi != "number" || Hi < 0)
                                throw new Error(Oi(Pi.INVALID_TYPE, [typeof Hi, "port"]));
                              if (typeof zo != "string")
                                throw new Error(Oi(Pi.INVALID_TYPE, [typeof zo, "path"]));
                              var ca = ji.indexOf(":") !== -1 && ji.slice(0, 1) !== "[" && ji.slice(-1) !== "]";
                              sa = "ws://" + (ca ? "[" + ji + "]" : ji) + ":" + Hi + zo;
                            }
                            for (var pa = 0, ga = 0; ga < Lo.length; ga++) {
                              var ia = Lo.charCodeAt(ga);
                              55296 <= ia && ia <= 56319 && ga++, pa++;
                            }
                            if (typeof Lo != "string" || pa > 65535)
                              throw new Error(Oi(Pi.INVALID_ARGUMENT, [Lo, "clientId"]));
                            var ra = new Ui(sa, ji, Hi, zo, Lo);
                            Object.defineProperties(this, {
                              host: {
                                get: function() {
                                  return ji;
                                },
                                set: function() {
                                  throw new Error(Oi(Pi.UNSUPPORTED_OPERATION));
                                }
                              },
                              port: {
                                get: function() {
                                  return Hi;
                                },
                                set: function() {
                                  throw new Error(Oi(Pi.UNSUPPORTED_OPERATION));
                                }
                              },
                              path: {
                                get: function() {
                                  return zo;
                                },
                                set: function() {
                                  throw new Error(Oi(Pi.UNSUPPORTED_OPERATION));
                                }
                              },
                              uri: {
                                get: function() {
                                  return sa;
                                },
                                set: function() {
                                  throw new Error(Oi(Pi.UNSUPPORTED_OPERATION));
                                }
                              },
                              clientId: {
                                get: function() {
                                  return ra.clientId;
                                },
                                set: function() {
                                  throw new Error(Oi(Pi.UNSUPPORTED_OPERATION));
                                }
                              },
                              onConnected: {
                                get: function() {
                                  return ra.onConnected;
                                },
                                set: function(qo) {
                                  if (typeof qo == "function")
                                    ra.onConnected = qo;
                                  else
                                    throw new Error(Oi(Pi.INVALID_TYPE, [typeof qo, "onConnected"]));
                                }
                              },
                              disconnectedPublishing: {
                                get: function() {
                                  return ra.disconnectedPublishing;
                                },
                                set: function(qo) {
                                  ra.disconnectedPublishing = qo;
                                }
                              },
                              disconnectedBufferSize: {
                                get: function() {
                                  return ra.disconnectedBufferSize;
                                },
                                set: function(qo) {
                                  ra.disconnectedBufferSize = qo;
                                }
                              },
                              onConnectionLost: {
                                get: function() {
                                  return ra.onConnectionLost;
                                },
                                set: function(qo) {
                                  if (typeof qo == "function")
                                    ra.onConnectionLost = qo;
                                  else
                                    throw new Error(Oi(Pi.INVALID_TYPE, [typeof qo, "onConnectionLost"]));
                                }
                              },
                              onMessageDelivered: {
                                get: function() {
                                  return ra.onMessageDelivered;
                                },
                                set: function(qo) {
                                  if (typeof qo == "function")
                                    ra.onMessageDelivered = qo;
                                  else
                                    throw new Error(Oi(Pi.INVALID_TYPE, [typeof qo, "onMessageDelivered"]));
                                }
                              },
                              onMessageArrived: {
                                get: function() {
                                  return ra.onMessageArrived;
                                },
                                set: function(qo) {
                                  if (typeof qo == "function")
                                    ra.onMessageArrived = qo;
                                  else
                                    throw new Error(Oi(Pi.INVALID_TYPE, [typeof qo, "onMessageArrived"]));
                                }
                              },
                              trace: {
                                get: function() {
                                  return ra.traceFunction;
                                },
                                set: function(qo) {
                                  if (typeof qo == "function")
                                    ra.traceFunction = qo;
                                  else
                                    throw new Error(Oi(Pi.INVALID_TYPE, [typeof qo, "onTrace"]));
                                }
                              }
                            }), this.connect = function(qo) {
                              if (qo = qo || {}, xi(qo, {
                                timeout: "number",
                                userName: "string",
                                password: "string",
                                willMessage: "object",
                                keepAliveInterval: "number",
                                cleanSession: "boolean",
                                useSSL: "boolean",
                                invocationContext: "object",
                                onSuccess: "function",
                                onFailure: "function",
                                hosts: "object",
                                ports: "object",
                                reconnect: "boolean",
                                mqttVersion: "number",
                                mqttVersionExplicit: "boolean",
                                uris: "object"
                              }), qo.keepAliveInterval === void 0 && (qo.keepAliveInterval = 60), qo.mqttVersion > 4 || qo.mqttVersion < 3)
                                throw new Error(Oi(Pi.INVALID_ARGUMENT, [qo.mqttVersion, "connectOptions.mqttVersion"]));
                              if (qo.mqttVersion === void 0 ? (qo.mqttVersionExplicit = !1, qo.mqttVersion = 4) : qo.mqttVersionExplicit = !0, qo.password !== void 0 && qo.userName === void 0)
                                throw new Error(Oi(Pi.INVALID_ARGUMENT, [qo.password, "connectOptions.password"]));
                              if (qo.willMessage) {
                                if (!(qo.willMessage instanceof Wi))
                                  throw new Error(Oi(Pi.INVALID_TYPE, [qo.willMessage, "connectOptions.willMessage"]));
                                if (qo.willMessage.stringPayload = null, typeof qo.willMessage.destinationName > "u")
                                  throw new Error(Oi(Pi.INVALID_TYPE, [typeof qo.willMessage.destinationName, "connectOptions.willMessage.destinationName"]));
                              }
                              if (typeof qo.cleanSession > "u" && (qo.cleanSession = !0), qo.hosts) {
                                if (!(qo.hosts instanceof Array))
                                  throw new Error(Oi(Pi.INVALID_ARGUMENT, [qo.hosts, "connectOptions.hosts"]));
                                if (qo.hosts.length < 1)
                                  throw new Error(Oi(Pi.INVALID_ARGUMENT, [qo.hosts, "connectOptions.hosts"]));
                                for (var xa = !1, $a = 0; $a < qo.hosts.length; $a++) {
                                  if (typeof qo.hosts[$a] != "string")
                                    throw new Error(Oi(Pi.INVALID_TYPE, [typeof qo.hosts[$a], "connectOptions.hosts[" + $a + "]"]));
                                  if (/^(wss?):\/\/((\[(.+)\])|([^\/]+?))(:(\d+))?(\/.*)$/.test(qo.hosts[$a])) {
                                    if ($a === 0)
                                      xa = !0;
                                    else if (!xa)
                                      throw new Error(Oi(Pi.INVALID_ARGUMENT, [qo.hosts[$a], "connectOptions.hosts[" + $a + "]"]));
                                  } else if (xa)
                                    throw new Error(Oi(Pi.INVALID_ARGUMENT, [qo.hosts[$a], "connectOptions.hosts[" + $a + "]"]));
                                }
                                if (xa)
                                  qo.uris = qo.hosts;
                                else {
                                  if (!qo.ports)
                                    throw new Error(Oi(Pi.INVALID_ARGUMENT, [qo.ports, "connectOptions.ports"]));
                                  if (!(qo.ports instanceof Array))
                                    throw new Error(Oi(Pi.INVALID_ARGUMENT, [qo.ports, "connectOptions.ports"]));
                                  if (qo.hosts.length !== qo.ports.length)
                                    throw new Error(Oi(Pi.INVALID_ARGUMENT, [qo.ports, "connectOptions.ports"]));
                                  qo.uris = [];
                                  for (var $a = 0; $a < qo.hosts.length; $a++) {
                                    if (typeof qo.ports[$a] != "number" || qo.ports[$a] < 0)
                                      throw new Error(Oi(Pi.INVALID_TYPE, [typeof qo.ports[$a], "connectOptions.ports[" + $a + "]"]));
                                    var ys = qo.hosts[$a], Ss = qo.ports[$a], Xa = ys.indexOf(":") !== -1;
                                    sa = "ws://" + (Xa ? "[" + ys + "]" : ys) + ":" + Ss + zo, qo.uris.push(sa);
                                  }
                                }
                              }
                              ra.connect(qo);
                            }, this.subscribe = function(qo, xa) {
                              if (typeof qo != "string" && qo.constructor !== Array)
                                throw new Error("Invalid argument:" + qo);
                              if (xa = xa || {}, xi(xa, {
                                qos: "number",
                                invocationContext: "object",
                                onSuccess: "function",
                                onFailure: "function",
                                timeout: "number"
                              }), xa.timeout && !xa.onFailure)
                                throw new Error("subscribeOptions.timeout specified with no onFailure callback.");
                              if (typeof xa.qos < "u" && !(xa.qos === 0 || xa.qos === 1 || xa.qos === 2))
                                throw new Error(Oi(Pi.INVALID_ARGUMENT, [xa.qos, "subscribeOptions.qos"]));
                              ra.subscribe(qo, xa);
                            }, this.unsubscribe = function(qo, xa) {
                              if (typeof qo != "string" && qo.constructor !== Array)
                                throw new Error("Invalid argument:" + qo);
                              if (xa = xa || {}, xi(xa, {
                                invocationContext: "object",
                                onSuccess: "function",
                                onFailure: "function",
                                timeout: "number"
                              }), xa.timeout && !xa.onFailure)
                                throw new Error("unsubscribeOptions.timeout specified with no onFailure callback.");
                              ra.unsubscribe(qo, xa);
                            }, this.send = function(qo, xa, $a, ys) {
                              var Ss;
                              if (arguments.length === 0)
                                throw new Error("Invalid argument.length");
                              if (arguments.length == 1) {
                                if (!(qo instanceof Wi) && typeof qo != "string")
                                  throw new Error("Invalid argument:" + typeof qo);
                                if (Ss = qo, typeof Ss.destinationName > "u")
                                  throw new Error(Oi(Pi.INVALID_ARGUMENT, [Ss.destinationName, "Message.destinationName"]));
                                ra.send(Ss);
                              } else
                                Ss = new Wi(xa), Ss.destinationName = qo, arguments.length >= 3 && (Ss.qos = $a), arguments.length >= 4 && (Ss.retained = ys), ra.send(Ss);
                            }, this.publish = function(qo, xa, $a, ys) {
                              var Ss;
                              if (arguments.length === 0)
                                throw new Error("Invalid argument.length");
                              if (arguments.length == 1) {
                                if (!(qo instanceof Wi) && typeof qo != "string")
                                  throw new Error("Invalid argument:" + typeof qo);
                                if (Ss = qo, typeof Ss.destinationName > "u")
                                  throw new Error(Oi(Pi.INVALID_ARGUMENT, [Ss.destinationName, "Message.destinationName"]));
                                ra.send(Ss);
                              } else
                                Ss = new Wi(xa), Ss.destinationName = qo, arguments.length >= 3 && (Ss.qos = $a), arguments.length >= 4 && (Ss.retained = ys), ra.send(Ss);
                            }, this.disconnect = function() {
                              ra.disconnect();
                            }, this.getTraceLog = function() {
                              return ra.getTraceLog();
                            }, this.startTrace = function() {
                              ra.startTrace();
                            }, this.stopTrace = function() {
                              ra.stopTrace();
                            }, this.isConnected = function() {
                              return ra.connected;
                            };
                          }, Wi = function(ji) {
                            var Hi;
                            if (typeof ji == "string" || ji instanceof ArrayBuffer || ArrayBuffer.isView(ji) && !(ji instanceof DataView))
                              Hi = ji;
                            else
                              throw Oi(Pi.INVALID_ARGUMENT, [ji, "newPayload"]);
                            var zo, Lo = 0, sa = !1, Ko = !1;
                            Object.defineProperties(this, {
                              payloadString: {
                                enumerable: !0,
                                get: function() {
                                  return typeof Hi == "string" ? Hi : Yi(Hi, 0, Hi.length);
                                }
                              },
                              payloadBytes: {
                                enumerable: !0,
                                get: function() {
                                  if (typeof Hi == "string") {
                                    var ca = new ArrayBuffer(Co(Hi)), pa = new Uint8Array(ca);
                                    return Ni(Hi, pa, 0), pa;
                                  } else
                                    return Hi;
                                }
                              },
                              destinationName: {
                                enumerable: !0,
                                get: function() {
                                  return zo;
                                },
                                set: function(ca) {
                                  if (typeof ca == "string")
                                    zo = ca;
                                  else
                                    throw new Error(Oi(Pi.INVALID_ARGUMENT, [ca, "newDestinationName"]));
                                }
                              },
                              qos: {
                                enumerable: !0,
                                get: function() {
                                  return Lo;
                                },
                                set: function(ca) {
                                  if (ca === 0 || ca === 1 || ca === 2)
                                    Lo = ca;
                                  else
                                    throw new Error("Invalid argument:" + ca);
                                }
                              },
                              retained: {
                                enumerable: !0,
                                get: function() {
                                  return sa;
                                },
                                set: function(ca) {
                                  if (typeof ca == "boolean")
                                    sa = ca;
                                  else
                                    throw new Error(Oi(Pi.INVALID_ARGUMENT, [ca, "newRetained"]));
                                }
                              },
                              topic: {
                                enumerable: !0,
                                get: function() {
                                  return zo;
                                },
                                set: function(ca) {
                                  zo = ca;
                                }
                              },
                              duplicate: {
                                enumerable: !0,
                                get: function() {
                                  return Ko;
                                },
                                set: function(ca) {
                                  Ko = ca;
                                }
                              }
                            });
                          };
                          return {
                            Client: jo,
                            Message: Wi
                          };
                        })(typeof self < "u" ? self : typeof window < "u" ? window : {});
                        return fi;
                      });
                    })
                  ),
                  /***/
                  320: (
                    /***/
                    ((si) => {
                      var di;
                      si.exports.w = function(fi, gi) {
                        var mi = new di(), Ti;
                        return Promise.race([
                          fi,
                          new Promise(function(vi, xi) {
                            Ti = setTimeout(function() {
                              xi(mi);
                            }, gi);
                          })
                        ]).then(function(vi) {
                          return clearTimeout(Ti), vi;
                        }, function(vi) {
                          throw clearTimeout(Ti), vi;
                        });
                      }, di = function() {
                        Error.call(this), this.stack = Error().stack, this.message = "Timeout";
                      }, di.prototype = Object.create(Error.prototype), di.prototype.name = "TimeoutError";
                    })
                  ),
                  /***/
                  655: (
                    /***/
                    (function(si, di, fi) {
                      si = fi.nmd(si);
                      var gi;
                      /*! https://mths.be/punycode v1.3.2 by @mathias */
                      (function(mi) {
                        di && di.nodeType, si && si.nodeType;
                        var Ti, vi = 2147483647, xi = 36, Si = 1, Pi = 26, $i = 38, Oi = 700, Di = 72, Mi = 128, Oo = "-", io = /^xn--/, xo = /[^\x20-\x7E]/, fo = /[\x2E\u3002\uFF0E\uFF61]/g, _o = {
                          overflow: "Overflow: input needs wider integers to process",
                          "not-basic": "Illegal input >= 0x80 (not a basic code point)",
                          "invalid-input": "Invalid input"
                        }, Li = xi - Si, Co = Math.floor, Ni = String.fromCharCode;
                        function Yi(ca) {
                          throw RangeError(_o[ca]);
                        }
                        function Vo(ca, pa) {
                          for (var ga = ca.length, ia = []; ga--; )
                            ia[ga] = pa(ca[ga]);
                          return ia;
                        }
                        function No(ca, pa) {
                          var ga = ca.split("@"), ia = "";
                          ga.length > 1 && (ia = ga[0] + "@", ca = ga[1]), ca = ca.replace(fo, ".");
                          var ra = ca.split("."), qo = Vo(ra, pa).join(".");
                          return ia + qo;
                        }
                        function Ui(ca) {
                          for (var pa = [], ga = 0, ia = ca.length, ra, qo; ga < ia; )
                            ra = ca.charCodeAt(ga++), ra >= 55296 && ra <= 56319 && ga < ia ? (qo = ca.charCodeAt(ga++), (qo & 64512) == 56320 ? pa.push(((ra & 1023) << 10) + (qo & 1023) + 65536) : (pa.push(ra), ga--)) : pa.push(ra);
                          return pa;
                        }
                        function jo(ca) {
                          return Vo(ca, function(pa) {
                            var ga = "";
                            return pa > 65535 && (pa -= 65536, ga += Ni(pa >>> 10 & 1023 | 55296), pa = 56320 | pa & 1023), ga += Ni(pa), ga;
                          }).join("");
                        }
                        function Wi(ca) {
                          return ca - 48 < 10 ? ca - 22 : ca - 65 < 26 ? ca - 65 : ca - 97 < 26 ? ca - 97 : xi;
                        }
                        function ji(ca, pa) {
                          return ca + 22 + 75 * (ca < 26) - ((pa != 0) << 5);
                        }
                        function Hi(ca, pa, ga) {
                          var ia = 0;
                          for (ca = ga ? Co(ca / Oi) : ca >> 1, ca += Co(ca / pa); ca > Li * Pi >> 1; ia += xi)
                            ca = Co(ca / Li);
                          return Co(ia + (Li + 1) * ca / (ca + $i));
                        }
                        function zo(ca) {
                          var pa = [], ga = ca.length, ia, ra = 0, qo = Mi, xa = Di, $a, ys, Ss, Xa, Es, Rs, La, Ja, ja;
                          for ($a = ca.lastIndexOf(Oo), $a < 0 && ($a = 0), ys = 0; ys < $a; ++ys)
                            ca.charCodeAt(ys) >= 128 && Yi("not-basic"), pa.push(ca.charCodeAt(ys));
                          for (Ss = $a > 0 ? $a + 1 : 0; Ss < ga; ) {
                            for (Xa = ra, Es = 1, Rs = xi; Ss >= ga && Yi("invalid-input"), La = Wi(ca.charCodeAt(Ss++)), (La >= xi || La > Co((vi - ra) / Es)) && Yi("overflow"), ra += La * Es, Ja = Rs <= xa ? Si : Rs >= xa + Pi ? Pi : Rs - xa, !(La < Ja); Rs += xi)
                              ja = xi - Ja, Es > Co(vi / ja) && Yi("overflow"), Es *= ja;
                            ia = pa.length + 1, xa = Hi(ra - Xa, ia, Xa == 0), Co(ra / ia) > vi - qo && Yi("overflow"), qo += Co(ra / ia), ra %= ia, pa.splice(ra++, 0, qo);
                          }
                          return jo(pa);
                        }
                        function Lo(ca) {
                          var pa, ga, ia, ra, qo, xa, $a, ys, Ss, Xa, Es, Rs = [], La, Ja, ja, Ta;
                          for (ca = Ui(ca), La = ca.length, pa = Mi, ga = 0, qo = Di, xa = 0; xa < La; ++xa)
                            Es = ca[xa], Es < 128 && Rs.push(Ni(Es));
                          for (ia = ra = Rs.length, ra && Rs.push(Oo); ia < La; ) {
                            for ($a = vi, xa = 0; xa < La; ++xa)
                              Es = ca[xa], Es >= pa && Es < $a && ($a = Es);
                            for (Ja = ia + 1, $a - pa > Co((vi - ga) / Ja) && Yi("overflow"), ga += ($a - pa) * Ja, pa = $a, xa = 0; xa < La; ++xa)
                              if (Es = ca[xa], Es < pa && ++ga > vi && Yi("overflow"), Es == pa) {
                                for (ys = ga, Ss = xi; Xa = Ss <= qo ? Si : Ss >= qo + Pi ? Pi : Ss - qo, !(ys < Xa); Ss += xi)
                                  Ta = ys - Xa, ja = xi - Xa, Rs.push(
                                    Ni(ji(Xa + Ta % ja, 0))
                                  ), ys = Co(Ta / ja);
                                Rs.push(Ni(ji(ys, 0))), qo = Hi(ga, Ja, ia == ra), ga = 0, ++ia;
                              }
                            ++ga, ++pa;
                          }
                          return Rs.join("");
                        }
                        function sa(ca) {
                          return No(ca, function(pa) {
                            return io.test(pa) ? zo(pa.slice(4).toLowerCase()) : pa;
                          });
                        }
                        function Ko(ca) {
                          return No(ca, function(pa) {
                            return xo.test(pa) ? "xn--" + Lo(pa) : pa;
                          });
                        }
                        Ti = {
                          /**
                           * A string representing the current Punycode.js version number.
                           * @memberOf punycode
                           * @type String
                           */
                          version: "1.3.2",
                          /**
                           * An object of methods to convert from JavaScript's internal character
                           * representation (UCS-2) to Unicode code points, and back.
                           * @see <https://mathiasbynens.be/notes/javascript-encoding>
                           * @memberOf punycode
                           * @type Object
                           */
                          ucs2: {
                            decode: Ui,
                            encode: jo
                          },
                          decode: zo,
                          encode: Lo,
                          toASCII: Ko,
                          toUnicode: sa
                        }, gi = (function() {
                          return Ti;
                        }).call(di, fi, di, si), gi !== void 0 && (si.exports = gi);
                      })();
                    })
                  ),
                  /***/
                  630: (
                    /***/
                    ((si) => {
                      function di(fi, gi) {
                        return Object.prototype.hasOwnProperty.call(fi, gi);
                      }
                      si.exports = function(fi, gi, mi, Ti) {
                        gi = gi || "&", mi = mi || "=";
                        var vi = {};
                        if (typeof fi != "string" || fi.length === 0)
                          return vi;
                        var xi = /\+/g;
                        fi = fi.split(gi);
                        var Si = 1e3;
                        Ti && typeof Ti.maxKeys == "number" && (Si = Ti.maxKeys);
                        var Pi = fi.length;
                        Si > 0 && Pi > Si && (Pi = Si);
                        for (var $i = 0; $i < Pi; ++$i) {
                          var Oi = fi[$i].replace(xi, "%20"), Di = Oi.indexOf(mi), Mi, Oo, io, xo;
                          Di >= 0 ? (Mi = Oi.substr(0, Di), Oo = Oi.substr(Di + 1)) : (Mi = Oi, Oo = ""), io = decodeURIComponent(Mi), xo = decodeURIComponent(Oo), di(vi, io) ? Array.isArray(vi[io]) ? vi[io].push(xo) : vi[io] = [vi[io], xo] : vi[io] = xo;
                        }
                        return vi;
                      };
                    })
                  ),
                  /***/
                  106: (
                    /***/
                    ((si) => {
                      var di = function(fi) {
                        switch (typeof fi) {
                          case "string":
                            return fi;
                          case "boolean":
                            return fi ? "true" : "false";
                          case "number":
                            return isFinite(fi) ? fi : "";
                          default:
                            return "";
                        }
                      };
                      si.exports = function(fi, gi, mi, Ti) {
                        return gi = gi || "&", mi = mi || "=", fi === null && (fi = void 0), typeof fi == "object" ? Object.keys(fi).map(function(vi) {
                          var xi = encodeURIComponent(di(vi)) + mi;
                          return Array.isArray(fi[vi]) ? fi[vi].map(function(Si) {
                            return xi + encodeURIComponent(di(Si));
                          }).join(gi) : xi + encodeURIComponent(di(fi[vi]));
                        }).join(gi) : Ti ? encodeURIComponent(di(Ti)) + mi + encodeURIComponent(di(fi)) : "";
                      };
                    })
                  ),
                  /***/
                  186: (
                    /***/
                    ((si, di, fi) => {
                      di.decode = di.parse = fi(630), di.encode = di.stringify = fi(106);
                    })
                  ),
                  /***/
                  224: (
                    /***/
                    (function(si, di) {
                      var fi = this && this.__awaiter || function(Si, Pi, $i, Oi) {
                        function Di(Mi) {
                          return Mi instanceof $i ? Mi : new $i(function(Oo) {
                            Oo(Mi);
                          });
                        }
                        return new ($i || ($i = Promise))(function(Mi, Oo) {
                          function io(_o) {
                            try {
                              fo(Oi.next(_o));
                            } catch (Li) {
                              Oo(Li);
                            }
                          }
                          function xo(_o) {
                            try {
                              fo(Oi.throw(_o));
                            } catch (Li) {
                              Oo(Li);
                            }
                          }
                          function fo(_o) {
                            _o.done ? Mi(_o.value) : Di(_o.value).then(io, xo);
                          }
                          fo((Oi = Oi.apply(Si, Pi || [])).next());
                        });
                      };
                      Object.defineProperty(di, "__esModule", { value: !0 });
                      const gi = (Si) => fi(void 0, void 0, void 0, function* () {
                        return new Promise((Pi) => setTimeout(() => Pi(Si), Si));
                      });
                      di.sleep = gi, di.sleepMilliseconds = gi;
                      const mi = (Si) => fi(void 0, void 0, void 0, function* () {
                        return gi(Si * 1e3);
                      });
                      di.sleepSeconds = mi;
                      const Ti = (Si) => fi(void 0, void 0, void 0, function* () {
                        return mi(Si * 60);
                      });
                      di.sleepMinutes = Ti;
                      const vi = (Si) => fi(void 0, void 0, void 0, function* () {
                        return Ti(Si * 60);
                      });
                      di.sleepHours = vi;
                      const xi = (Si) => fi(void 0, void 0, void 0, function* () {
                        return vi(Si * 24);
                      });
                      di.sleepDays = xi;
                    })
                  ),
                  /***/
                  835: (
                    /***/
                    ((si, di, fi) => {
                      var gi = fi(655), mi = fi(268);
                      di.parse = Ni, di.resolve = Vo, di.resolveObject = No, di.format = Yi, di.Url = Ti;
                      function Ti() {
                        this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
                      }
                      var vi = /^([a-z0-9.+-]+:)/i, xi = /:[0-9]*$/, Si = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, Pi = ["<", ">", '"', "`", " ", "\r", `
`, "	"], $i = ["{", "}", "|", "\\", "^", "`"].concat(Pi), Oi = ["'"].concat($i), Di = ["%", "/", "?", ";", "#"].concat(Oi), Mi = ["/", "?", "#"], Oo = 255, io = /^[+a-z0-9A-Z_-]{0,63}$/, xo = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, fo = {
                        javascript: !0,
                        "javascript:": !0
                      }, _o = {
                        javascript: !0,
                        "javascript:": !0
                      }, Li = {
                        http: !0,
                        https: !0,
                        ftp: !0,
                        gopher: !0,
                        file: !0,
                        "http:": !0,
                        "https:": !0,
                        "ftp:": !0,
                        "gopher:": !0,
                        "file:": !0
                      }, Co = fi(186);
                      function Ni(Ui, jo, Wi) {
                        if (Ui && mi.isObject(Ui) && Ui instanceof Ti) return Ui;
                        var ji = new Ti();
                        return ji.parse(Ui, jo, Wi), ji;
                      }
                      Ti.prototype.parse = function(Ui, jo, Wi) {
                        if (!mi.isString(Ui))
                          throw new TypeError("Parameter 'url' must be a string, not " + typeof Ui);
                        var ji = Ui.indexOf("?"), Hi = ji !== -1 && ji < Ui.indexOf("#") ? "?" : "#", zo = Ui.split(Hi), Lo = /\\/g;
                        zo[0] = zo[0].replace(Lo, "/"), Ui = zo.join(Hi);
                        var sa = Ui;
                        if (sa = sa.trim(), !Wi && Ui.split("#").length === 1) {
                          var Ko = Si.exec(sa);
                          if (Ko)
                            return this.path = sa, this.href = sa, this.pathname = Ko[1], Ko[2] ? (this.search = Ko[2], jo ? this.query = Co.parse(this.search.substr(1)) : this.query = this.search.substr(1)) : jo && (this.search = "", this.query = {}), this;
                        }
                        var ca = vi.exec(sa);
                        if (ca) {
                          ca = ca[0];
                          var pa = ca.toLowerCase();
                          this.protocol = pa, sa = sa.substr(ca.length);
                        }
                        if (Wi || ca || sa.match(/^\/\/[^@\/]+@[^@\/]+/)) {
                          var ga = sa.substr(0, 2) === "//";
                          ga && !(ca && _o[ca]) && (sa = sa.substr(2), this.slashes = !0);
                        }
                        if (!_o[ca] && (ga || ca && !Li[ca])) {
                          for (var ia = -1, ra = 0; ra < Mi.length; ra++) {
                            var qo = sa.indexOf(Mi[ra]);
                            qo !== -1 && (ia === -1 || qo < ia) && (ia = qo);
                          }
                          var xa, $a;
                          ia === -1 ? $a = sa.lastIndexOf("@") : $a = sa.lastIndexOf("@", ia), $a !== -1 && (xa = sa.slice(0, $a), sa = sa.slice($a + 1), this.auth = decodeURIComponent(xa)), ia = -1;
                          for (var ra = 0; ra < Di.length; ra++) {
                            var qo = sa.indexOf(Di[ra]);
                            qo !== -1 && (ia === -1 || qo < ia) && (ia = qo);
                          }
                          ia === -1 && (ia = sa.length), this.host = sa.slice(0, ia), sa = sa.slice(ia), this.parseHost(), this.hostname = this.hostname || "";
                          var ys = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
                          if (!ys)
                            for (var Ss = this.hostname.split(/\./), ra = 0, Xa = Ss.length; ra < Xa; ra++) {
                              var Es = Ss[ra];
                              if (Es && !Es.match(io)) {
                                for (var Rs = "", La = 0, Ja = Es.length; La < Ja; La++)
                                  Es.charCodeAt(La) > 127 ? Rs += "x" : Rs += Es[La];
                                if (!Rs.match(io)) {
                                  var ja = Ss.slice(0, ra), Ta = Ss.slice(ra + 1), rs = Es.match(xo);
                                  rs && (ja.push(rs[1]), Ta.unshift(rs[2])), Ta.length && (sa = "/" + Ta.join(".") + sa), this.hostname = ja.join(".");
                                  break;
                                }
                              }
                            }
                          this.hostname.length > Oo ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), ys || (this.hostname = gi.toASCII(this.hostname));
                          var Qa = this.port ? ":" + this.port : "", Cs = this.hostname || "";
                          this.host = Cs + Qa, this.href += this.host, ys && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), sa[0] !== "/" && (sa = "/" + sa));
                        }
                        if (!fo[pa])
                          for (var ra = 0, Xa = Oi.length; ra < Xa; ra++) {
                            var _a = Oi[ra];
                            if (sa.indexOf(_a) !== -1) {
                              var _s = encodeURIComponent(_a);
                              _s === _a && (_s = escape(_a)), sa = sa.split(_a).join(_s);
                            }
                          }
                        var el = sa.indexOf("#");
                        el !== -1 && (this.hash = sa.substr(el), sa = sa.slice(0, el));
                        var Ps = sa.indexOf("?");
                        if (Ps !== -1 ? (this.search = sa.substr(Ps), this.query = sa.substr(Ps + 1), jo && (this.query = Co.parse(this.query)), sa = sa.slice(0, Ps)) : jo && (this.search = "", this.query = {}), sa && (this.pathname = sa), Li[pa] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
                          var Qa = this.pathname || "", nl = this.search || "";
                          this.path = Qa + nl;
                        }
                        return this.href = this.format(), this;
                      };
                      function Yi(Ui) {
                        return mi.isString(Ui) && (Ui = Ni(Ui)), Ui instanceof Ti ? Ui.format() : Ti.prototype.format.call(Ui);
                      }
                      Ti.prototype.format = function() {
                        var Ui = this.auth || "";
                        Ui && (Ui = encodeURIComponent(Ui), Ui = Ui.replace(/%3A/i, ":"), Ui += "@");
                        var jo = this.protocol || "", Wi = this.pathname || "", ji = this.hash || "", Hi = !1, zo = "";
                        this.host ? Hi = Ui + this.host : this.hostname && (Hi = Ui + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]"), this.port && (Hi += ":" + this.port)), this.query && mi.isObject(this.query) && Object.keys(this.query).length && (zo = Co.stringify(this.query));
                        var Lo = this.search || zo && "?" + zo || "";
                        return jo && jo.substr(-1) !== ":" && (jo += ":"), this.slashes || (!jo || Li[jo]) && Hi !== !1 ? (Hi = "//" + (Hi || ""), Wi && Wi.charAt(0) !== "/" && (Wi = "/" + Wi)) : Hi || (Hi = ""), ji && ji.charAt(0) !== "#" && (ji = "#" + ji), Lo && Lo.charAt(0) !== "?" && (Lo = "?" + Lo), Wi = Wi.replace(/[?#]/g, function(sa) {
                          return encodeURIComponent(sa);
                        }), Lo = Lo.replace("#", "%23"), jo + Hi + Wi + Lo + ji;
                      };
                      function Vo(Ui, jo) {
                        return Ni(Ui, !1, !0).resolve(jo);
                      }
                      Ti.prototype.resolve = function(Ui) {
                        return this.resolveObject(Ni(Ui, !1, !0)).format();
                      };
                      function No(Ui, jo) {
                        return Ui ? Ni(Ui, !1, !0).resolveObject(jo) : jo;
                      }
                      Ti.prototype.resolveObject = function(Ui) {
                        if (mi.isString(Ui)) {
                          var jo = new Ti();
                          jo.parse(Ui, !1, !0), Ui = jo;
                        }
                        for (var Wi = new Ti(), ji = Object.keys(this), Hi = 0; Hi < ji.length; Hi++) {
                          var zo = ji[Hi];
                          Wi[zo] = this[zo];
                        }
                        if (Wi.hash = Ui.hash, Ui.href === "")
                          return Wi.href = Wi.format(), Wi;
                        if (Ui.slashes && !Ui.protocol) {
                          for (var Lo = Object.keys(Ui), sa = 0; sa < Lo.length; sa++) {
                            var Ko = Lo[sa];
                            Ko !== "protocol" && (Wi[Ko] = Ui[Ko]);
                          }
                          return Li[Wi.protocol] && Wi.hostname && !Wi.pathname && (Wi.path = Wi.pathname = "/"), Wi.href = Wi.format(), Wi;
                        }
                        if (Ui.protocol && Ui.protocol !== Wi.protocol) {
                          if (!Li[Ui.protocol]) {
                            for (var ca = Object.keys(Ui), pa = 0; pa < ca.length; pa++) {
                              var ga = ca[pa];
                              Wi[ga] = Ui[ga];
                            }
                            return Wi.href = Wi.format(), Wi;
                          }
                          if (Wi.protocol = Ui.protocol, !Ui.host && !_o[Ui.protocol]) {
                            for (var Xa = (Ui.pathname || "").split("/"); Xa.length && !(Ui.host = Xa.shift()); ) ;
                            Ui.host || (Ui.host = ""), Ui.hostname || (Ui.hostname = ""), Xa[0] !== "" && Xa.unshift(""), Xa.length < 2 && Xa.unshift(""), Wi.pathname = Xa.join("/");
                          } else
                            Wi.pathname = Ui.pathname;
                          if (Wi.search = Ui.search, Wi.query = Ui.query, Wi.host = Ui.host || "", Wi.auth = Ui.auth, Wi.hostname = Ui.hostname || Ui.host, Wi.port = Ui.port, Wi.pathname || Wi.search) {
                            var ia = Wi.pathname || "", ra = Wi.search || "";
                            Wi.path = ia + ra;
                          }
                          return Wi.slashes = Wi.slashes || Ui.slashes, Wi.href = Wi.format(), Wi;
                        }
                        var qo = Wi.pathname && Wi.pathname.charAt(0) === "/", xa = Ui.host || Ui.pathname && Ui.pathname.charAt(0) === "/", $a = xa || qo || Wi.host && Ui.pathname, ys = $a, Ss = Wi.pathname && Wi.pathname.split("/") || [], Xa = Ui.pathname && Ui.pathname.split("/") || [], Es = Wi.protocol && !Li[Wi.protocol];
                        if (Es && (Wi.hostname = "", Wi.port = null, Wi.host && (Ss[0] === "" ? Ss[0] = Wi.host : Ss.unshift(Wi.host)), Wi.host = "", Ui.protocol && (Ui.hostname = null, Ui.port = null, Ui.host && (Xa[0] === "" ? Xa[0] = Ui.host : Xa.unshift(Ui.host)), Ui.host = null), $a = $a && (Xa[0] === "" || Ss[0] === "")), xa)
                          Wi.host = Ui.host || Ui.host === "" ? Ui.host : Wi.host, Wi.hostname = Ui.hostname || Ui.hostname === "" ? Ui.hostname : Wi.hostname, Wi.search = Ui.search, Wi.query = Ui.query, Ss = Xa;
                        else if (Xa.length)
                          Ss || (Ss = []), Ss.pop(), Ss = Ss.concat(Xa), Wi.search = Ui.search, Wi.query = Ui.query;
                        else if (!mi.isNullOrUndefined(Ui.search)) {
                          if (Es) {
                            Wi.hostname = Wi.host = Ss.shift();
                            var Rs = Wi.host && Wi.host.indexOf("@") > 0 ? Wi.host.split("@") : !1;
                            Rs && (Wi.auth = Rs.shift(), Wi.host = Wi.hostname = Rs.shift());
                          }
                          return Wi.search = Ui.search, Wi.query = Ui.query, (!mi.isNull(Wi.pathname) || !mi.isNull(Wi.search)) && (Wi.path = (Wi.pathname ? Wi.pathname : "") + (Wi.search ? Wi.search : "")), Wi.href = Wi.format(), Wi;
                        }
                        if (!Ss.length)
                          return Wi.pathname = null, Wi.search ? Wi.path = "/" + Wi.search : Wi.path = null, Wi.href = Wi.format(), Wi;
                        for (var La = Ss.slice(-1)[0], Ja = (Wi.host || Ui.host || Ss.length > 1) && (La === "." || La === "..") || La === "", ja = 0, Ta = Ss.length; Ta >= 0; Ta--)
                          La = Ss[Ta], La === "." ? Ss.splice(Ta, 1) : La === ".." ? (Ss.splice(Ta, 1), ja++) : ja && (Ss.splice(Ta, 1), ja--);
                        if (!$a && !ys)
                          for (; ja--; ja)
                            Ss.unshift("..");
                        $a && Ss[0] !== "" && (!Ss[0] || Ss[0].charAt(0) !== "/") && Ss.unshift(""), Ja && Ss.join("/").substr(-1) !== "/" && Ss.push("");
                        var rs = Ss[0] === "" || Ss[0] && Ss[0].charAt(0) === "/";
                        if (Es) {
                          Wi.hostname = Wi.host = rs ? "" : Ss.length ? Ss.shift() : "";
                          var Rs = Wi.host && Wi.host.indexOf("@") > 0 ? Wi.host.split("@") : !1;
                          Rs && (Wi.auth = Rs.shift(), Wi.host = Wi.hostname = Rs.shift());
                        }
                        return $a = $a || Wi.host && Ss.length, $a && !rs && Ss.unshift(""), Ss.length ? Wi.pathname = Ss.join("/") : (Wi.pathname = null, Wi.path = null), (!mi.isNull(Wi.pathname) || !mi.isNull(Wi.search)) && (Wi.path = (Wi.pathname ? Wi.pathname : "") + (Wi.search ? Wi.search : "")), Wi.auth = Ui.auth || Wi.auth, Wi.slashes = Wi.slashes || Ui.slashes, Wi.href = Wi.format(), Wi;
                      }, Ti.prototype.parseHost = function() {
                        var Ui = this.host, jo = xi.exec(Ui);
                        jo && (jo = jo[0], jo !== ":" && (this.port = jo.substr(1)), Ui = Ui.substr(0, Ui.length - jo.length)), Ui && (this.hostname = Ui);
                      };
                    })
                  ),
                  /***/
                  268: (
                    /***/
                    ((si) => {
                      si.exports = {
                        isString: function(di) {
                          return typeof di == "string";
                        },
                        isObject: function(di) {
                          return typeof di == "object" && di !== null;
                        },
                        isNull: function(di) {
                          return di === null;
                        },
                        isNullOrUndefined: function(di) {
                          return di == null;
                        }
                      };
                    })
                  ),
                  /***/
                  814: (
                    /***/
                    ((si) => {
                      si.exports = /* @__PURE__ */ JSON.parse(`{"name":"@skylineos/clsp-player","title":"Skyline CLSP Player","version":"0.23.15","description":"Skyline Technology Solutions' CLSP Video Player.  Stream video in near-real-time in modern browsers.","keywords":["html5","clsp","video","player","skyline"],"license":"MIT","repository":"https://github.com/skylineos/clsp-player.git","main":"dist/clsp-player.min.js","scripts":{"build":"./scripts/build/build.sh","serve":"./scripts/serve/serve.sh","lint":"eslint .","lint-fix":"eslint . --fix","prepack":"NODE_ENV=production yarn run build","postpack":"./scripts/build/pre-build.sh","preversion":"./scripts/version.sh --pre","version":"./scripts/version.sh","postversion":"./scripts/version.sh --post","test:jest":"jest && ./test/jest/scripts/echo-coverage-hyperlink.sh","test":"yarn run test:jest","test:dev":"jest --coverage=false","test:watch":"yarn run test:dev --watch","test:wdio":"start-server-and-test serve http://localhost:8080 wdio","validate:ts":"tsc index.d.ts","wdio":"wdio run wdio.conf.js"},"dependencies":{"@babel/runtime-corejs3":"7.26.10","eventemitter3":"4.0.7","interval-promise":"1.4.0","lodash":"4.17.21","paho-mqtt":"1.1.0","promise-timeout":"1.3.0","sleepjs":"4.0.2","srcdoc-polyfill":"1.0.0","url":"0.11.0","uuid":"8.3.0"},"devDependencies":{"@babel/core":"^7.26.10","@babel/eslint-parser":"^7.26.0","@babel/eslint-plugin":"^7.26.0","@babel/plugin-transform-class-properties":"7.25.9","@babel/plugin-transform-object-rest-spread":"7.25.9","@babel/plugin-transform-runtime":"^7.26.0","@babel/preset-env":"^7.26.0","@babel/register":"^7.16.5","@eslint/eslintrc":"^3.3.0","@eslint/js":"^9.22.0","@wdio/cli":"^9.12.1","@wdio/local-runner":"^9.12.1","@wdio/mocha-framework":"^9.12.1","@wdio/spec-reporter":"^9.11.0","babel-loader":"^9.2.1","chalk":"4.1.0","chromedriver":"^134.0.0","css-loader":"7.1.2","eslint":"^9.17.0","eslint-config-standard":"^17.1.0","eslint-plugin-import":"2.31.0","eslint-plugin-jest":"28.11.0","eslint-plugin-n":"^17.16.2","eslint-plugin-node":"11.1.0","eslint-plugin-promise":"7.2.1","globals":"^16.0.0","humanize":"0.0.9","jest":"29.7.0","jest-environment-jsdom":"^29.7.0","jest-extended":"4.0.2","jest-mock-console":"2.0.0","jquery":"3.5.1","mini-css-extract-plugin":"2.7.6","moment":"2.29.4","progress-bar-webpack-plugin":"2.1.0","standard":"14.3.4","start-server-and-test":"^2.0.11","style-loader":"1.2.1","typescript":"4.0.3","url-loader":"4.1.0","wdio-chromedriver-service":"^8.1.1","webpack":"5.95.0","webpack-bundle-analyzer":"4.10.0","webpack-dev-server":"5.2.0","write-file-webpack-plugin":"4.5.1"},"packageManager":"yarn@1.22.22+sha512.a6b2f7906b721bba3d67d4aff083df04dad64c399707841b7acf00f6b133b7ac24255f2652fa22ae3534329dc6180534e98d17432037ff6fd140556e2bb3137e"}`);
                    })
                  ),
                  /***/
                  330: (
                    /***/
                    ((si) => {
                      si.exports = /* @__PURE__ */ JSON.parse(`{"name":"@skylineos/videojs-clsp","title":"Skyline CLSP VideoJS Plugin","version":"0.19.14","description":"Video JS plugin for Skyline Technology Solutions' CLSP Player - https://github.com/skylineos/clsp-player","keywords":["html5","clsp","video","player","videojs","videojs-plugin","skyline"],"license":"MIT","repository":"https://github.com/skylineos/videojs-clsp.git","main":"dist/videojs-clsp.min.js","scripts":{"build":"./scripts/build/build.sh","serve":"./scripts/serve/serve.sh","lint":"./scripts/lint.sh","lint-fix":"./scripts/lint.sh --fix","prepack":"yarn run build","postpack":"./scripts/build/pre-build.sh","preversion":"./scripts/version.sh --pre","version":"./scripts/version.sh","postversion":"./scripts/version.sh --post"},"dependencies":{"@skylineos/clsp-player":"0.23.15","uuid":"7.0.3"},"devDependencies":{"@babel/core":"^7.26.10","@babel/plugin-proposal-class-properties":"7.8.3","@babel/plugin-proposal-object-rest-spread":"7.9.0","@babel/plugin-syntax-dynamic-import":"7.8.3","@babel/plugin-transform-private-methods":"^7.24.1","@babel/polyfill":"7.8.7","@babel/preset-env":"7.9.0","babel-eslint":"10.1.0","babel-loader":"^9.2.1","chalk":"4.0.0","css-loader":"7.1.2","eslint":"6.8.0","eslint-config-standard":"14.1.1","eslint-plugin-import":"2.20.2","eslint-plugin-node":"11.1.0","eslint-plugin-promise":"4.2.1","eslint-plugin-standard":"4.0.1","humanize":"0.0.9","jquery":"3.5.0","mini-css-extract-plugin":"2.7.6","moment":"2.29.4","pify":"5.0.0","progress-bar-webpack-plugin":"2.1.0","standard":"14.3.3","style-loader":"1.2.1","url-loader":"4.1.0","video.js":"7.21.7","videojs-errors":"4.3.2","webpack":"5.95.0","webpack-bundle-analyzer":"4.10.0","webpack-dev-server":"5.2.0","write-file-webpack-plugin":"4.5.1"},"packageManager":"yarn@1.22.22+sha512.a6b2f7906b721bba3d67d4aff083df04dad64c399707841b7acf00f6b133b7ac24255f2652fa22ae3534329dc6180534e98d17432037ff6fd140556e2bb3137e"}`);
                    })
                  )
                  /******/
                }, li = {};
                function oi(si) {
                  var di = li[si];
                  if (di !== void 0)
                    return di.exports;
                  var fi = li[si] = {
                    /******/
                    id: si,
                    /******/
                    loaded: !1,
                    /******/
                    exports: {}
                    /******/
                  };
                  return ai[si].call(fi.exports, fi, fi.exports, oi), fi.loaded = !0, fi.exports;
                }
                oi.n = (si) => {
                  var di = si && si.__esModule ? (
                    /******/
                    () => si.default
                  ) : (
                    /******/
                    () => si
                  );
                  return oi.d(di, { a: di }), di;
                }, oi.d = (si, di) => {
                  for (var fi in di)
                    oi.o(di, fi) && !oi.o(si, fi) && Object.defineProperty(si, fi, { enumerable: !0, get: di[fi] });
                }, oi.o = (si, di) => Object.prototype.hasOwnProperty.call(si, di), oi.nmd = (si) => (si.paths = [], si.children || (si.children = []), si), (() => {
                  const si = videojs;
                  var di = /* @__PURE__ */ oi.n(si), fi = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), gi = new Uint8Array(16);
                  function mi() {
                    if (!fi)
                      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
                    return fi(gi);
                  }
                  for (var Ti = [], vi = 0; vi < 256; ++vi)
                    Ti[vi] = (vi + 256).toString(16).substr(1);
                  function xi(Ai, _i) {
                    var Po = _i || 0, Gi = Ti;
                    return [Gi[Ai[Po++]], Gi[Ai[Po++]], Gi[Ai[Po++]], Gi[Ai[Po++]], "-", Gi[Ai[Po++]], Gi[Ai[Po++]], "-", Gi[Ai[Po++]], Gi[Ai[Po++]], "-", Gi[Ai[Po++]], Gi[Ai[Po++]], "-", Gi[Ai[Po++]], Gi[Ai[Po++]], Gi[Ai[Po++]], Gi[Ai[Po++]], Gi[Ai[Po++]], Gi[Ai[Po++]]].join("");
                  }
                  const Si = xi;
                  function Pi(Ai, _i, Po) {
                    var Gi = _i && Po || 0;
                    typeof Ai == "string" && (_i = Ai === "binary" ? new Array(16) : null, Ai = null), Ai = Ai || {};
                    var na = Ai.random || (Ai.rng || mi)();
                    if (na[6] = na[6] & 15 | 64, na[8] = na[8] & 63 | 128, _i)
                      for (var ta = 0; ta < 16; ++ta)
                        _i[Gi + ta] = na[ta];
                    return _i || Si(na);
                  }
                  const $i = Pi;
                  var Oi = oi(843), Di = /* @__PURE__ */ oi.n(Oi), Mi = oi(224), Oo = oi(863), io = /* @__PURE__ */ oi.n(Oo), xo = oi(228), fo = /* @__PURE__ */ oi.n(xo), _o = oi(764), Li = /* @__PURE__ */ oi.n(_o);
                  function Co() {
                    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
                    Co = function() {
                      return _i;
                    };
                    var Ai, _i = {}, Po = Object.prototype, Gi = Po.hasOwnProperty, na = Object.defineProperty || function(Bi, Ci, ki) {
                      Bi[Ci] = ki.value;
                    }, ta = typeof Symbol == "function" ? Symbol : {}, Fo = ta.iterator || "@@iterator", Wa = ta.asyncIterator || "@@asyncIterator", Va = ta.toStringTag || "@@toStringTag";
                    function wa(Bi, Ci, ki) {
                      return Object.defineProperty(Bi, Ci, { value: ki, enumerable: !0, configurable: !0, writable: !0 }), Bi[Ci];
                    }
                    try {
                      wa({}, "");
                    } catch {
                      wa = function(ki, Mo, Xo) {
                        return ki[Mo] = Xo;
                      };
                    }
                    function il(Bi, Ci, ki, Mo) {
                      var Xo = Ci && Ci.prototype instanceof pu ? Ci : pu, Uo = Object.create(Xo.prototype), qa = new ku(Mo || []);
                      return na(Uo, "_invoke", { value: pc(Bi, ki, qa) }), Uo;
                    }
                    function ol(Bi, Ci, ki) {
                      try {
                        return { type: "normal", arg: Bi.call(Ci, ki) };
                      } catch (Mo) {
                        return { type: "throw", arg: Mo };
                      }
                    }
                    _i.wrap = il;
                    var Ql = "suspendedStart", Uu = "suspendedYield", Wu = "executing", Kl = "completed", pl = {};
                    function pu() {
                    }
                    function lu() {
                    }
                    function Nl() {
                    }
                    var Eu = {};
                    wa(Eu, Fo, function() {
                      return this;
                    });
                    var wu = Object.getPrototypeOf, yu = wu && wu(wu(Nu([])));
                    yu && yu !== Po && Gi.call(yu, Fo) && (Eu = yu);
                    var zl = Nl.prototype = pu.prototype = Object.create(Eu);
                    function Qu(Bi) {
                      ["next", "throw", "return"].forEach(function(Ci) {
                        wa(Bi, Ci, function(ki) {
                          return this._invoke(Ci, ki);
                        });
                      });
                    }
                    function gu(Bi, Ci) {
                      function ki(Xo, Uo, qa, Us) {
                        var Hs = ol(Bi[Xo], Bi, Uo);
                        if (Hs.type !== "throw") {
                          var jl = Hs.arg, Al = jl.value;
                          return Al && typeof Al == "object" && Gi.call(Al, "__await") ? Ci.resolve(Al.__await).then(function(Ml) {
                            ki("next", Ml, qa, Us);
                          }, function(Ml) {
                            ki("throw", Ml, qa, Us);
                          }) : Ci.resolve(Al).then(function(Ml) {
                            jl.value = Ml, qa(jl);
                          }, function(Ml) {
                            return ki("throw", Ml, qa, Us);
                          });
                        }
                        Us(Hs.arg);
                      }
                      var Mo;
                      na(this, "_invoke", { value: function(Uo, qa) {
                        function Us() {
                          return new Ci(function(Hs, jl) {
                            ki(Uo, qa, Hs, jl);
                          });
                        }
                        return Mo = Mo ? Mo.then(Us, Us) : Us();
                      } });
                    }
                    function pc(Bi, Ci, ki) {
                      var Mo = Ql;
                      return function(Xo, Uo) {
                        if (Mo === Wu) throw Error("Generator is already running");
                        if (Mo === Kl) {
                          if (Xo === "throw") throw Uo;
                          return { value: Ai, done: !0 };
                        }
                        for (ki.method = Xo, ki.arg = Uo; ; ) {
                          var qa = ki.delegate;
                          if (qa) {
                            var Us = Zu(qa, ki);
                            if (Us) {
                              if (Us === pl) continue;
                              return Us;
                            }
                          }
                          if (ki.method === "next") ki.sent = ki._sent = ki.arg;
                          else if (ki.method === "throw") {
                            if (Mo === Ql) throw Mo = Kl, ki.arg;
                            ki.dispatchException(ki.arg);
                          } else ki.method === "return" && ki.abrupt("return", ki.arg);
                          Mo = Wu;
                          var Hs = ol(Bi, Ci, ki);
                          if (Hs.type === "normal") {
                            if (Mo = ki.done ? Kl : Uu, Hs.arg === pl) continue;
                            return { value: Hs.arg, done: ki.done };
                          }
                          Hs.type === "throw" && (Mo = Kl, ki.method = "throw", ki.arg = Hs.arg);
                        }
                      };
                    }
                    function Zu(Bi, Ci) {
                      var ki = Ci.method, Mo = Bi.iterator[ki];
                      if (Mo === Ai) return Ci.delegate = null, ki === "throw" && Bi.iterator.return && (Ci.method = "return", Ci.arg = Ai, Zu(Bi, Ci), Ci.method === "throw") || ki !== "return" && (Ci.method = "throw", Ci.arg = new TypeError("The iterator does not provide a '" + ki + "' method")), pl;
                      var Xo = ol(Mo, Bi.iterator, Ci.arg);
                      if (Xo.type === "throw") return Ci.method = "throw", Ci.arg = Xo.arg, Ci.delegate = null, pl;
                      var Uo = Xo.arg;
                      return Uo ? Uo.done ? (Ci[Bi.resultName] = Uo.value, Ci.next = Bi.nextLoc, Ci.method !== "return" && (Ci.method = "next", Ci.arg = Ai), Ci.delegate = null, pl) : Uo : (Ci.method = "throw", Ci.arg = new TypeError("iterator result is not an object"), Ci.delegate = null, pl);
                    }
                    function gc(Bi) {
                      var Ci = { tryLoc: Bi[0] };
                      1 in Bi && (Ci.catchLoc = Bi[1]), 2 in Bi && (Ci.finallyLoc = Bi[2], Ci.afterLoc = Bi[3]), this.tryEntries.push(Ci);
                    }
                    function Du(Bi) {
                      var Ci = Bi.completion || {};
                      Ci.type = "normal", delete Ci.arg, Bi.completion = Ci;
                    }
                    function ku(Bi) {
                      this.tryEntries = [{ tryLoc: "root" }], Bi.forEach(gc, this), this.reset(!0);
                    }
                    function Nu(Bi) {
                      if (Bi || Bi === "") {
                        var Ci = Bi[Fo];
                        if (Ci) return Ci.call(Bi);
                        if (typeof Bi.next == "function") return Bi;
                        if (!isNaN(Bi.length)) {
                          var ki = -1, Mo = function Xo() {
                            for (; ++ki < Bi.length; ) if (Gi.call(Bi, ki)) return Xo.value = Bi[ki], Xo.done = !1, Xo;
                            return Xo.value = Ai, Xo.done = !0, Xo;
                          };
                          return Mo.next = Mo;
                        }
                      }
                      throw new TypeError(typeof Bi + " is not iterable");
                    }
                    return lu.prototype = Nl, na(zl, "constructor", { value: Nl, configurable: !0 }), na(Nl, "constructor", { value: lu, configurable: !0 }), lu.displayName = wa(Nl, Va, "GeneratorFunction"), _i.isGeneratorFunction = function(Bi) {
                      var Ci = typeof Bi == "function" && Bi.constructor;
                      return !!Ci && (Ci === lu || (Ci.displayName || Ci.name) === "GeneratorFunction");
                    }, _i.mark = function(Bi) {
                      return Object.setPrototypeOf ? Object.setPrototypeOf(Bi, Nl) : (Bi.__proto__ = Nl, wa(Bi, Va, "GeneratorFunction")), Bi.prototype = Object.create(zl), Bi;
                    }, _i.awrap = function(Bi) {
                      return { __await: Bi };
                    }, Qu(gu.prototype), wa(gu.prototype, Wa, function() {
                      return this;
                    }), _i.AsyncIterator = gu, _i.async = function(Bi, Ci, ki, Mo, Xo) {
                      Xo === void 0 && (Xo = Promise);
                      var Uo = new gu(il(Bi, Ci, ki, Mo), Xo);
                      return _i.isGeneratorFunction(Ci) ? Uo : Uo.next().then(function(qa) {
                        return qa.done ? qa.value : Uo.next();
                      });
                    }, Qu(zl), wa(zl, Va, "Generator"), wa(zl, Fo, function() {
                      return this;
                    }), wa(zl, "toString", function() {
                      return "[object Generator]";
                    }), _i.keys = function(Bi) {
                      var Ci = Object(Bi), ki = [];
                      for (var Mo in Ci) ki.push(Mo);
                      return ki.reverse(), function Xo() {
                        for (; ki.length; ) {
                          var Uo = ki.pop();
                          if (Uo in Ci) return Xo.value = Uo, Xo.done = !1, Xo;
                        }
                        return Xo.done = !0, Xo;
                      };
                    }, _i.values = Nu, ku.prototype = { constructor: ku, reset: function(Ci) {
                      if (this.prev = 0, this.next = 0, this.sent = this._sent = Ai, this.done = !1, this.delegate = null, this.method = "next", this.arg = Ai, this.tryEntries.forEach(Du), !Ci) for (var ki in this) ki.charAt(0) === "t" && Gi.call(this, ki) && !isNaN(+ki.slice(1)) && (this[ki] = Ai);
                    }, stop: function() {
                      this.done = !0;
                      var Ci = this.tryEntries[0].completion;
                      if (Ci.type === "throw") throw Ci.arg;
                      return this.rval;
                    }, dispatchException: function(Ci) {
                      if (this.done) throw Ci;
                      var ki = this;
                      function Mo(jl, Al) {
                        return qa.type = "throw", qa.arg = Ci, ki.next = jl, Al && (ki.method = "next", ki.arg = Ai), !!Al;
                      }
                      for (var Xo = this.tryEntries.length - 1; Xo >= 0; --Xo) {
                        var Uo = this.tryEntries[Xo], qa = Uo.completion;
                        if (Uo.tryLoc === "root") return Mo("end");
                        if (Uo.tryLoc <= this.prev) {
                          var Us = Gi.call(Uo, "catchLoc"), Hs = Gi.call(Uo, "finallyLoc");
                          if (Us && Hs) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          } else if (Us) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                          } else {
                            if (!Hs) throw Error("try statement without catch or finally");
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          }
                        }
                      }
                    }, abrupt: function(Ci, ki) {
                      for (var Mo = this.tryEntries.length - 1; Mo >= 0; --Mo) {
                        var Xo = this.tryEntries[Mo];
                        if (Xo.tryLoc <= this.prev && Gi.call(Xo, "finallyLoc") && this.prev < Xo.finallyLoc) {
                          var Uo = Xo;
                          break;
                        }
                      }
                      Uo && (Ci === "break" || Ci === "continue") && Uo.tryLoc <= ki && ki <= Uo.finallyLoc && (Uo = null);
                      var qa = Uo ? Uo.completion : {};
                      return qa.type = Ci, qa.arg = ki, Uo ? (this.method = "next", this.next = Uo.finallyLoc, pl) : this.complete(qa);
                    }, complete: function(Ci, ki) {
                      if (Ci.type === "throw") throw Ci.arg;
                      return Ci.type === "break" || Ci.type === "continue" ? this.next = Ci.arg : Ci.type === "return" ? (this.rval = this.arg = Ci.arg, this.method = "return", this.next = "end") : Ci.type === "normal" && ki && (this.next = ki), pl;
                    }, finish: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.finallyLoc === Ci) return this.complete(Mo.completion, Mo.afterLoc), Du(Mo), pl;
                      }
                    }, catch: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.tryLoc === Ci) {
                          var Xo = Mo.completion;
                          if (Xo.type === "throw") {
                            var Uo = Xo.arg;
                            Du(Mo);
                          }
                          return Uo;
                        }
                      }
                      throw Error("illegal catch attempt");
                    }, delegateYield: function(Ci, ki, Mo) {
                      return this.delegate = { iterator: Nu(Ci), resultName: ki, nextLoc: Mo }, this.method === "next" && (this.arg = Ai), pl;
                    } }, _i;
                  }
                  function Ni(Ai, _i, Po, Gi, na, ta, Fo) {
                    try {
                      var Wa = Ai[ta](Fo), Va = Wa.value;
                    } catch (wa) {
                      return void Po(wa);
                    }
                    Wa.done ? _i(Va) : Promise.resolve(Va).then(Gi, na);
                  }
                  function Yi(Ai) {
                    return function() {
                      var _i = this, Po = arguments;
                      return new Promise(function(Gi, na) {
                        var ta = Ai.apply(_i, Po);
                        function Fo(Va) {
                          Ni(ta, Gi, na, Fo, Wa, "next", Va);
                        }
                        function Wa(Va) {
                          Ni(ta, Gi, na, Fo, Wa, "throw", Va);
                        }
                        Fo(void 0);
                      });
                    };
                  }
                  function Vo(Ai, _i) {
                    if (!(Ai instanceof _i)) throw new TypeError("Cannot call a class as a function");
                  }
                  function No(Ai, _i) {
                    for (var Po = 0; Po < _i.length; Po++) {
                      var Gi = _i[Po];
                      Gi.enumerable = Gi.enumerable || !1, Gi.configurable = !0, "value" in Gi && (Gi.writable = !0), Object.defineProperty(Ai, Wi(Gi.key), Gi);
                    }
                  }
                  function Ui(Ai, _i, Po) {
                    return _i && No(Ai.prototype, _i), Object.defineProperty(Ai, "prototype", { writable: !1 }), Ai;
                  }
                  function jo(Ai, _i, Po) {
                    return (_i = Wi(_i)) in Ai ? Object.defineProperty(Ai, _i, { value: Po, enumerable: !0, configurable: !0, writable: !0 }) : Ai[_i] = Po, Ai;
                  }
                  function Wi(Ai) {
                    var _i = ji(Ai, "string");
                    return typeof _i == "symbol" ? _i : _i + "";
                  }
                  function ji(Ai, _i) {
                    if (typeof Ai != "object" || !Ai) return Ai;
                    var Po = Ai[Symbol.toPrimitive];
                    if (Po !== void 0) {
                      var Gi = Po.call(Ai, _i);
                      if (typeof Gi != "object") return Gi;
                      throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(Ai);
                  }
                  var Hi = /* @__PURE__ */ (function() {
                    function Ai(_i) {
                      if (Vo(this, Ai), jo(this, "logId", null), jo(this, "isDestroyed", !1), jo(this, "isDestroyComplete", !1), !_i)
                        throw new Error("Logging options are required");
                      if (typeof _i == "object" && (this.logId = _i.id, this.logColor = _i.color), typeof _i == "string" && (this.logId = _i), !this.logId)
                        throw new Error("`logId` is required to construct a new ".concat(this.constructor.name));
                      this.logColor || (this.logColor = "black"), this.logger = Li()(io().version).factory("".concat(this.constructor.name, " ").concat(this.logId), "color: ".concat(this.logColor, ";")), this.logger.info("Constructing new ".concat(this.constructor.name, " instance"));
                    }
                    return Ui(Ai, [{
                      key: "_reset",
                      value: (function() {
                        var _i = Yi(/* @__PURE__ */ Co().mark(function Gi() {
                          return Co().wrap(function(ta) {
                            for (; ; ) switch (ta.prev = ta.next) {
                              case 0:
                              case "end":
                                return ta.stop();
                            }
                          }, Gi);
                        }));
                        function Po() {
                          return _i.apply(this, arguments);
                        }
                        return Po;
                      })()
                    }, {
                      key: "reset",
                      value: (function() {
                        var _i = Yi(/* @__PURE__ */ Co().mark(function Gi() {
                          return Co().wrap(function(ta) {
                            for (; ; ) switch (ta.prev = ta.next) {
                              case 0:
                                return this.logger.info("Resetting..."), this.isDestroyed = !1, this.isDestroyComplete = !1, ta.next = 5, this._reset();
                              case 5:
                                this.logger.info("Reset complete");
                              case 6:
                              case "end":
                                return ta.stop();
                            }
                          }, Gi, this);
                        }));
                        function Po() {
                          return _i.apply(this, arguments);
                        }
                        return Po;
                      })()
                      /**
                       * Put your class's destroy logic in this method.
                       *
                       * @todo - should this be private?
                       */
                    }, {
                      key: "_destroy",
                      value: (function() {
                        var _i = Yi(/* @__PURE__ */ Co().mark(function Gi() {
                          return Co().wrap(function(ta) {
                            for (; ; ) switch (ta.prev = ta.next) {
                              case 0:
                              case "end":
                                return ta.stop();
                            }
                          }, Gi);
                        }));
                        function Po() {
                          return _i.apply(this, arguments);
                        }
                        return Po;
                      })()
                    }, {
                      key: "destroy",
                      value: (function() {
                        var _i = Yi(/* @__PURE__ */ Co().mark(function Gi() {
                          return Co().wrap(function(ta) {
                            for (; ; ) switch (ta.prev = ta.next) {
                              case 0:
                                if (!this.isDestroyed) {
                                  ta.next = 3;
                                  break;
                                }
                                return this.logger.info("Already destroyed"), ta.abrupt("return");
                              case 3:
                                return this.isDestroyed = !0, this.logger.info("Destroying..."), ta.next = 7, this._destroy();
                              case 7:
                                this.isDestroyComplete = !0, this.logger.info("Destroy complete");
                              case 9:
                              case "end":
                                return ta.stop();
                            }
                          }, Gi, this);
                        }));
                        function Po() {
                          return _i.apply(this, arguments);
                        }
                        return Po;
                      })()
                    }]);
                  })();
                  function zo() {
                    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
                    zo = function() {
                      return _i;
                    };
                    var Ai, _i = {}, Po = Object.prototype, Gi = Po.hasOwnProperty, na = Object.defineProperty || function(Bi, Ci, ki) {
                      Bi[Ci] = ki.value;
                    }, ta = typeof Symbol == "function" ? Symbol : {}, Fo = ta.iterator || "@@iterator", Wa = ta.asyncIterator || "@@asyncIterator", Va = ta.toStringTag || "@@toStringTag";
                    function wa(Bi, Ci, ki) {
                      return Object.defineProperty(Bi, Ci, { value: ki, enumerable: !0, configurable: !0, writable: !0 }), Bi[Ci];
                    }
                    try {
                      wa({}, "");
                    } catch {
                      wa = function(ki, Mo, Xo) {
                        return ki[Mo] = Xo;
                      };
                    }
                    function il(Bi, Ci, ki, Mo) {
                      var Xo = Ci && Ci.prototype instanceof pu ? Ci : pu, Uo = Object.create(Xo.prototype), qa = new ku(Mo || []);
                      return na(Uo, "_invoke", { value: pc(Bi, ki, qa) }), Uo;
                    }
                    function ol(Bi, Ci, ki) {
                      try {
                        return { type: "normal", arg: Bi.call(Ci, ki) };
                      } catch (Mo) {
                        return { type: "throw", arg: Mo };
                      }
                    }
                    _i.wrap = il;
                    var Ql = "suspendedStart", Uu = "suspendedYield", Wu = "executing", Kl = "completed", pl = {};
                    function pu() {
                    }
                    function lu() {
                    }
                    function Nl() {
                    }
                    var Eu = {};
                    wa(Eu, Fo, function() {
                      return this;
                    });
                    var wu = Object.getPrototypeOf, yu = wu && wu(wu(Nu([])));
                    yu && yu !== Po && Gi.call(yu, Fo) && (Eu = yu);
                    var zl = Nl.prototype = pu.prototype = Object.create(Eu);
                    function Qu(Bi) {
                      ["next", "throw", "return"].forEach(function(Ci) {
                        wa(Bi, Ci, function(ki) {
                          return this._invoke(Ci, ki);
                        });
                      });
                    }
                    function gu(Bi, Ci) {
                      function ki(Xo, Uo, qa, Us) {
                        var Hs = ol(Bi[Xo], Bi, Uo);
                        if (Hs.type !== "throw") {
                          var jl = Hs.arg, Al = jl.value;
                          return Al && typeof Al == "object" && Gi.call(Al, "__await") ? Ci.resolve(Al.__await).then(function(Ml) {
                            ki("next", Ml, qa, Us);
                          }, function(Ml) {
                            ki("throw", Ml, qa, Us);
                          }) : Ci.resolve(Al).then(function(Ml) {
                            jl.value = Ml, qa(jl);
                          }, function(Ml) {
                            return ki("throw", Ml, qa, Us);
                          });
                        }
                        Us(Hs.arg);
                      }
                      var Mo;
                      na(this, "_invoke", { value: function(Uo, qa) {
                        function Us() {
                          return new Ci(function(Hs, jl) {
                            ki(Uo, qa, Hs, jl);
                          });
                        }
                        return Mo = Mo ? Mo.then(Us, Us) : Us();
                      } });
                    }
                    function pc(Bi, Ci, ki) {
                      var Mo = Ql;
                      return function(Xo, Uo) {
                        if (Mo === Wu) throw Error("Generator is already running");
                        if (Mo === Kl) {
                          if (Xo === "throw") throw Uo;
                          return { value: Ai, done: !0 };
                        }
                        for (ki.method = Xo, ki.arg = Uo; ; ) {
                          var qa = ki.delegate;
                          if (qa) {
                            var Us = Zu(qa, ki);
                            if (Us) {
                              if (Us === pl) continue;
                              return Us;
                            }
                          }
                          if (ki.method === "next") ki.sent = ki._sent = ki.arg;
                          else if (ki.method === "throw") {
                            if (Mo === Ql) throw Mo = Kl, ki.arg;
                            ki.dispatchException(ki.arg);
                          } else ki.method === "return" && ki.abrupt("return", ki.arg);
                          Mo = Wu;
                          var Hs = ol(Bi, Ci, ki);
                          if (Hs.type === "normal") {
                            if (Mo = ki.done ? Kl : Uu, Hs.arg === pl) continue;
                            return { value: Hs.arg, done: ki.done };
                          }
                          Hs.type === "throw" && (Mo = Kl, ki.method = "throw", ki.arg = Hs.arg);
                        }
                      };
                    }
                    function Zu(Bi, Ci) {
                      var ki = Ci.method, Mo = Bi.iterator[ki];
                      if (Mo === Ai) return Ci.delegate = null, ki === "throw" && Bi.iterator.return && (Ci.method = "return", Ci.arg = Ai, Zu(Bi, Ci), Ci.method === "throw") || ki !== "return" && (Ci.method = "throw", Ci.arg = new TypeError("The iterator does not provide a '" + ki + "' method")), pl;
                      var Xo = ol(Mo, Bi.iterator, Ci.arg);
                      if (Xo.type === "throw") return Ci.method = "throw", Ci.arg = Xo.arg, Ci.delegate = null, pl;
                      var Uo = Xo.arg;
                      return Uo ? Uo.done ? (Ci[Bi.resultName] = Uo.value, Ci.next = Bi.nextLoc, Ci.method !== "return" && (Ci.method = "next", Ci.arg = Ai), Ci.delegate = null, pl) : Uo : (Ci.method = "throw", Ci.arg = new TypeError("iterator result is not an object"), Ci.delegate = null, pl);
                    }
                    function gc(Bi) {
                      var Ci = { tryLoc: Bi[0] };
                      1 in Bi && (Ci.catchLoc = Bi[1]), 2 in Bi && (Ci.finallyLoc = Bi[2], Ci.afterLoc = Bi[3]), this.tryEntries.push(Ci);
                    }
                    function Du(Bi) {
                      var Ci = Bi.completion || {};
                      Ci.type = "normal", delete Ci.arg, Bi.completion = Ci;
                    }
                    function ku(Bi) {
                      this.tryEntries = [{ tryLoc: "root" }], Bi.forEach(gc, this), this.reset(!0);
                    }
                    function Nu(Bi) {
                      if (Bi || Bi === "") {
                        var Ci = Bi[Fo];
                        if (Ci) return Ci.call(Bi);
                        if (typeof Bi.next == "function") return Bi;
                        if (!isNaN(Bi.length)) {
                          var ki = -1, Mo = function Xo() {
                            for (; ++ki < Bi.length; ) if (Gi.call(Bi, ki)) return Xo.value = Bi[ki], Xo.done = !1, Xo;
                            return Xo.value = Ai, Xo.done = !0, Xo;
                          };
                          return Mo.next = Mo;
                        }
                      }
                      throw new TypeError(typeof Bi + " is not iterable");
                    }
                    return lu.prototype = Nl, na(zl, "constructor", { value: Nl, configurable: !0 }), na(Nl, "constructor", { value: lu, configurable: !0 }), lu.displayName = wa(Nl, Va, "GeneratorFunction"), _i.isGeneratorFunction = function(Bi) {
                      var Ci = typeof Bi == "function" && Bi.constructor;
                      return !!Ci && (Ci === lu || (Ci.displayName || Ci.name) === "GeneratorFunction");
                    }, _i.mark = function(Bi) {
                      return Object.setPrototypeOf ? Object.setPrototypeOf(Bi, Nl) : (Bi.__proto__ = Nl, wa(Bi, Va, "GeneratorFunction")), Bi.prototype = Object.create(zl), Bi;
                    }, _i.awrap = function(Bi) {
                      return { __await: Bi };
                    }, Qu(gu.prototype), wa(gu.prototype, Wa, function() {
                      return this;
                    }), _i.AsyncIterator = gu, _i.async = function(Bi, Ci, ki, Mo, Xo) {
                      Xo === void 0 && (Xo = Promise);
                      var Uo = new gu(il(Bi, Ci, ki, Mo), Xo);
                      return _i.isGeneratorFunction(Ci) ? Uo : Uo.next().then(function(qa) {
                        return qa.done ? qa.value : Uo.next();
                      });
                    }, Qu(zl), wa(zl, Va, "Generator"), wa(zl, Fo, function() {
                      return this;
                    }), wa(zl, "toString", function() {
                      return "[object Generator]";
                    }), _i.keys = function(Bi) {
                      var Ci = Object(Bi), ki = [];
                      for (var Mo in Ci) ki.push(Mo);
                      return ki.reverse(), function Xo() {
                        for (; ki.length; ) {
                          var Uo = ki.pop();
                          if (Uo in Ci) return Xo.value = Uo, Xo.done = !1, Xo;
                        }
                        return Xo.done = !0, Xo;
                      };
                    }, _i.values = Nu, ku.prototype = { constructor: ku, reset: function(Ci) {
                      if (this.prev = 0, this.next = 0, this.sent = this._sent = Ai, this.done = !1, this.delegate = null, this.method = "next", this.arg = Ai, this.tryEntries.forEach(Du), !Ci) for (var ki in this) ki.charAt(0) === "t" && Gi.call(this, ki) && !isNaN(+ki.slice(1)) && (this[ki] = Ai);
                    }, stop: function() {
                      this.done = !0;
                      var Ci = this.tryEntries[0].completion;
                      if (Ci.type === "throw") throw Ci.arg;
                      return this.rval;
                    }, dispatchException: function(Ci) {
                      if (this.done) throw Ci;
                      var ki = this;
                      function Mo(jl, Al) {
                        return qa.type = "throw", qa.arg = Ci, ki.next = jl, Al && (ki.method = "next", ki.arg = Ai), !!Al;
                      }
                      for (var Xo = this.tryEntries.length - 1; Xo >= 0; --Xo) {
                        var Uo = this.tryEntries[Xo], qa = Uo.completion;
                        if (Uo.tryLoc === "root") return Mo("end");
                        if (Uo.tryLoc <= this.prev) {
                          var Us = Gi.call(Uo, "catchLoc"), Hs = Gi.call(Uo, "finallyLoc");
                          if (Us && Hs) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          } else if (Us) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                          } else {
                            if (!Hs) throw Error("try statement without catch or finally");
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          }
                        }
                      }
                    }, abrupt: function(Ci, ki) {
                      for (var Mo = this.tryEntries.length - 1; Mo >= 0; --Mo) {
                        var Xo = this.tryEntries[Mo];
                        if (Xo.tryLoc <= this.prev && Gi.call(Xo, "finallyLoc") && this.prev < Xo.finallyLoc) {
                          var Uo = Xo;
                          break;
                        }
                      }
                      Uo && (Ci === "break" || Ci === "continue") && Uo.tryLoc <= ki && ki <= Uo.finallyLoc && (Uo = null);
                      var qa = Uo ? Uo.completion : {};
                      return qa.type = Ci, qa.arg = ki, Uo ? (this.method = "next", this.next = Uo.finallyLoc, pl) : this.complete(qa);
                    }, complete: function(Ci, ki) {
                      if (Ci.type === "throw") throw Ci.arg;
                      return Ci.type === "break" || Ci.type === "continue" ? this.next = Ci.arg : Ci.type === "return" ? (this.rval = this.arg = Ci.arg, this.method = "return", this.next = "end") : Ci.type === "normal" && ki && (this.next = ki), pl;
                    }, finish: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.finallyLoc === Ci) return this.complete(Mo.completion, Mo.afterLoc), Du(Mo), pl;
                      }
                    }, catch: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.tryLoc === Ci) {
                          var Xo = Mo.completion;
                          if (Xo.type === "throw") {
                            var Uo = Xo.arg;
                            Du(Mo);
                          }
                          return Uo;
                        }
                      }
                      throw Error("illegal catch attempt");
                    }, delegateYield: function(Ci, ki, Mo) {
                      return this.delegate = { iterator: Nu(Ci), resultName: ki, nextLoc: Mo }, this.method === "next" && (this.arg = Ai), pl;
                    } }, _i;
                  }
                  function Lo(Ai, _i, Po, Gi, na, ta, Fo) {
                    try {
                      var Wa = Ai[ta](Fo), Va = Wa.value;
                    } catch (wa) {
                      return void Po(wa);
                    }
                    Wa.done ? _i(Va) : Promise.resolve(Va).then(Gi, na);
                  }
                  function sa(Ai) {
                    return function() {
                      var _i = this, Po = arguments;
                      return new Promise(function(Gi, na) {
                        var ta = Ai.apply(_i, Po);
                        function Fo(Va) {
                          Lo(ta, Gi, na, Fo, Wa, "next", Va);
                        }
                        function Wa(Va) {
                          Lo(ta, Gi, na, Fo, Wa, "throw", Va);
                        }
                        Fo(void 0);
                      });
                    };
                  }
                  function Ko(Ai, _i) {
                    if (!(Ai instanceof _i)) throw new TypeError("Cannot call a class as a function");
                  }
                  function ca(Ai, _i) {
                    for (var Po = 0; Po < _i.length; Po++) {
                      var Gi = _i[Po];
                      Gi.enumerable = Gi.enumerable || !1, Gi.configurable = !0, "value" in Gi && (Gi.writable = !0), Object.defineProperty(Ai, La(Gi.key), Gi);
                    }
                  }
                  function pa(Ai, _i, Po) {
                    return _i && ca(Ai.prototype, _i), Object.defineProperty(Ai, "prototype", { writable: !1 }), Ai;
                  }
                  function ga(Ai, _i, Po) {
                    return _i = Ss(_i), ia(Ai, qo() ? Reflect.construct(_i, Po || [], Ss(Ai).constructor) : _i.apply(Ai, Po));
                  }
                  function ia(Ai, _i) {
                    if (_i && (typeof _i == "object" || typeof _i == "function")) return _i;
                    if (_i !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return ra(Ai);
                  }
                  function ra(Ai) {
                    if (Ai === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return Ai;
                  }
                  function qo() {
                    try {
                      var Ai = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                      }));
                    } catch {
                    }
                    return (qo = function() {
                      return !!Ai;
                    })();
                  }
                  function xa(Ai, _i, Po, Gi) {
                    var na = $a(Ss(Ai.prototype), _i, Po);
                    return 2 & Gi && typeof na == "function" ? function(ta) {
                      return na.apply(Po, ta);
                    } : na;
                  }
                  function $a() {
                    return $a = typeof Reflect < "u" && Reflect.get ? Reflect.get.bind() : function(Ai, _i, Po) {
                      var Gi = ys(Ai, _i);
                      if (Gi) {
                        var na = Object.getOwnPropertyDescriptor(Gi, _i);
                        return na.get ? na.get.call(arguments.length < 3 ? Ai : Po) : na.value;
                      }
                    }, $a.apply(null, arguments);
                  }
                  function ys(Ai, _i) {
                    for (; !{}.hasOwnProperty.call(Ai, _i) && (Ai = Ss(Ai)) !== null; ) ;
                    return Ai;
                  }
                  function Ss(Ai) {
                    return Ss = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(_i) {
                      return _i.__proto__ || Object.getPrototypeOf(_i);
                    }, Ss(Ai);
                  }
                  function Xa(Ai, _i) {
                    if (typeof _i != "function" && _i !== null) throw new TypeError("Super expression must either be null or a function");
                    Ai.prototype = Object.create(_i && _i.prototype, { constructor: { value: Ai, writable: !0, configurable: !0 } }), Object.defineProperty(Ai, "prototype", { writable: !1 }), _i && Es(Ai, _i);
                  }
                  function Es(Ai, _i) {
                    return Es = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(Po, Gi) {
                      return Po.__proto__ = Gi, Po;
                    }, Es(Ai, _i);
                  }
                  function Rs(Ai, _i, Po) {
                    return (_i = La(_i)) in Ai ? Object.defineProperty(Ai, _i, { value: Po, enumerable: !0, configurable: !0, writable: !0 }) : Ai[_i] = Po, Ai;
                  }
                  function La(Ai) {
                    var _i = Ja(Ai, "string");
                    return typeof _i == "symbol" ? _i : _i + "";
                  }
                  function Ja(Ai, _i) {
                    if (typeof Ai != "object" || !Ai) return Ai;
                    var Po = Ai[Symbol.toPrimitive];
                    if (Po !== void 0) {
                      var Gi = Po.call(Ai, _i);
                      if (typeof Gi != "object") return Gi;
                      throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (_i === "string" ? String : Number)(Ai);
                  }
                  var ja = /* @__PURE__ */ (function(Ai) {
                    function _i(Po) {
                      var Gi;
                      return Ko(this, _i), Gi = ga(this, _i, [Po]), Rs(Gi, "events", null), Gi.events = new (fo())(), Gi;
                    }
                    return Xa(_i, Ai), pa(_i, [{
                      key: "on",
                      value: function(Gi, na) {
                        var ta = Object.values(this.constructor.events);
                        if (!ta.includes(Gi))
                          throw new Error('Unable to register listener for unknown event "'.concat(Gi, '"'));
                        if (!na)
                          throw new Error('Unable to register for event "'.concat(Gi, '" without a handler'));
                        return this.isDestroyed ? (this.logger.error('Tried to register handler for event "'.concat(Gi, '" while destroyed!')), this) : (this.events.on(Gi, na), this);
                      }
                      // @todo - should this be a private field?
                    }, {
                      key: "emit",
                      value: function(Gi, na) {
                        if (this.isDestroyed) {
                          this.logger.error('Tried to emit "'.concat(Gi, '" while destroyed!'));
                          return;
                        }
                        this.events.emit(Gi, na);
                      }
                    }, {
                      key: "_reset",
                      value: (function() {
                        var Po = sa(/* @__PURE__ */ zo().mark(function na() {
                          return zo().wrap(function(Fo) {
                            for (; ; ) switch (Fo.prev = Fo.next) {
                              case 0:
                                return this.events = new (fo())(), Fo.next = 3, xa(_i, "_reset", this, 3)([]);
                              case 3:
                              case "end":
                                return Fo.stop();
                            }
                          }, na, this);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "_destroy",
                      value: (function() {
                        var Po = sa(/* @__PURE__ */ zo().mark(function na() {
                          return zo().wrap(function(Fo) {
                            for (; ; ) switch (Fo.prev = Fo.next) {
                              case 0:
                                return this.events.removeAllListeners(), this.events = null, Fo.next = 4, xa(_i, "_destroy", this, 3)([]);
                              case 4:
                              case "end":
                                return Fo.stop();
                            }
                          }, na, this);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }]);
                  })(Hi);
                  Rs(ja, "events", {});
                  var Ta = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), rs = new Uint8Array(16);
                  function Qa() {
                    if (!Ta)
                      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
                    return Ta(rs);
                  }
                  const Cs = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
                  function _a(Ai) {
                    return typeof Ai == "string" && Cs.test(Ai);
                  }
                  const _s = _a;
                  for (var el = [], Ps = 0; Ps < 256; ++Ps)
                    el.push((Ps + 256).toString(16).substr(1));
                  function nl(Ai) {
                    var _i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, Po = (el[Ai[_i + 0]] + el[Ai[_i + 1]] + el[Ai[_i + 2]] + el[Ai[_i + 3]] + "-" + el[Ai[_i + 4]] + el[Ai[_i + 5]] + "-" + el[Ai[_i + 6]] + el[Ai[_i + 7]] + "-" + el[Ai[_i + 8]] + el[Ai[_i + 9]] + "-" + el[Ai[_i + 10]] + el[Ai[_i + 11]] + el[Ai[_i + 12]] + el[Ai[_i + 13]] + el[Ai[_i + 14]] + el[Ai[_i + 15]]).toLowerCase();
                    if (!_s(Po))
                      throw TypeError("Stringified UUID is invalid");
                    return Po;
                  }
                  const Vs = nl;
                  function es(Ai, _i, Po) {
                    Ai = Ai || {};
                    var Gi = Ai.random || (Ai.rng || Qa)();
                    if (Gi[6] = Gi[6] & 15 | 64, Gi[8] = Gi[8] & 63 | 128, _i) {
                      Po = Po || 0;
                      for (var na = 0; na < 16; ++na)
                        _i[Po + na] = Gi[na];
                      return _i;
                    }
                    return Vs(Gi);
                  }
                  const Is = es;
                  function fl(Ai) {
                    function _i(Po, Gi, na, ta, Fo, Wa) {
                      _i.constructorArgumentsBouncer(Po, Gi, na, ta, Fo, Wa), this.logId = Po;
                      try {
                        this.logger = Wa.Logger.factory("Router ".concat(this.logId), "color: maroon;");
                      } catch (wa) {
                        throw console.error(wa), new Error("Error while constructing Logger!");
                      }
                      this.clientId = Gi, this.host = na, this.port = ta, this.useSSL = Fo, this.logger.debug("Constructing..."), this.Reconnect = null;
                      try {
                        this.clspClient = new Ai.MQTT.Client(this.host, this.port, "/mqtt", this.clientId);
                      } catch (wa) {
                        var Va = new Error("Error while constructing Paho Client!");
                        throw this.logger.critical(Va), this.logger.critical(wa), Va;
                      }
                      this.clspClient.onConnectionLost = this._onConnectionLost.bind(this), this.clspClient.onMessageArrived = this._onMessageArrived.bind(this), this.clspClient.onMessageDelivered = this._onMessageDelivered.bind(this), this.boundWindowMessageEventHandler = this._windowMessageEventHandler.bind(this), window.addEventListener("message", this.boundWindowMessageEventHandler, !1), this.CONNECTION_TIMEOUT = Wa.CONNECTION_TIMEOUT, this.KEEP_ALIVE_INTERVAL = Wa.KEEP_ALIVE_INTERVAL, this.PUBLISH_TIMEOUT = Wa.PUBLISH_TIMEOUT, this.isDestroyed = !1, this.isDestroyComplete = !1;
                    }
                    return _i.constructorArgumentsBouncer = function(Po, Gi, na, ta, Fo, Wa) {
                      if (typeof Ai != "object")
                        throw new Error("Paho is required to construct a Router");
                      if (typeof Ai.MQTT != "object")
                        throw new Error("Paho.MQTT is required to construct a Router");
                      if (typeof Ai.MQTT.Client != "function")
                        throw new Error("Paho.MQTT.Client is required to construct a Router");
                      if (typeof Ai.MQTT.Message != "function")
                        throw new Error("Paho.MQTT.Message is required to construct a Router");
                      if (Po === void 0)
                        throw new Error("`logId` is required to construct a Router");
                      if (Gi === void 0)
                        throw new Error("`clientId` is required to construct a Router");
                      if (na === void 0)
                        throw new Error("`host` is required to construct a Router");
                      if (ta === void 0)
                        throw new Error("`port` is required to construct a Router");
                      if (Fo === void 0)
                        throw new Error("`useSSL` is required to construct a Router");
                      if (typeof Wa != "object")
                        throw new Error("`options` is required to construct a Router");
                      if (Wa.Logger === void 0)
                        throw new Error("`options.Logger` is required to construct a Router");
                      if (Wa.CONNECTION_TIMEOUT === void 0)
                        throw new Error("`options.CONNECTION_TIMEOUT` is required to construct a Router");
                      if (Wa.KEEP_ALIVE_INTERVAL === void 0)
                        throw new Error("`options.KEEP_ALIVE_INTERVAL` is required to construct a Router");
                      if (Wa.PUBLISH_TIMEOUT === void 0)
                        throw new Error("`options.PUBLISH_TIMEOUT` is required to construct a Router");
                    }, _i.pahoErrorCodes = {
                      NOT_CONNECTED: "AMQJS0011E",
                      ALREADY_CONNECTED: "AMQJS0011E"
                    }, _i.events = {
                      // Triggered when the Router is successfully instantiated.
                      // Can only be triggered at time of router instantiation.
                      CREATE_SUCCESS: "clsp_router_create_success",
                      // Triggered when there is an error during Router instantiation.
                      // Can only be triggered at time of router instantiation.
                      CREATE_FAILURE: "clsp_router_create_failure",
                      // Triggered when the connection to the CLSP server is established.
                      // Can only be triggered at time of connection.
                      CONNECT_SUCCESS: "clsp_router_connect_success",
                      // Triggered when trying to connect to the CLSP server fails.
                      // Can only be triggered at time of connection.
                      CONNECT_FAILURE: "clsp_router_connect_failure",
                      // Triggered when the connection to the CLSP server has been established, but is later lost.
                      // Can be triggered for as long as the connection is open.
                      CONNECTION_LOST: "clsp_router_connection_lost",
                      // Triggered when the connection to the CLSP server is terminated normally.
                      // Can only be triggered at time of disconnection.
                      DISCONNECT_SUCCESS: "clsp_router_disconnect_success",
                      DISCONNECT_FAILURE: "clsp_router_disconnect_failure",
                      // Triggered when a message is successfully published to the server
                      // Can only be triggered on publish
                      PUBLISH_SUCCESS: "clsp_router_publish_success",
                      // Triggered when a message fails to be published to the server
                      // Can only be triggered on publish
                      PUBLISH_FAILURE: "clsp_router_publish_failure",
                      // Triggered when trying to subscribe to a topic fails.
                      // Can only be triggered when a subscribe is attempted.
                      SUBSCRIBE_FAILURE: "clsp_router_subscribe_failure",
                      // When successfully unsubscribed from a topic
                      // Can only be triggered when an unsubscribe is attempted.
                      UNSUBSCRIBE_SUCCESS: "clsp_router_unsubscribe_success",
                      // When trying to unsubscribe from a topic fails.
                      // Can only be triggered when an unsubscribe is attempted.
                      UNSUBSCRIBE_FAILURE: "clsp_router_unsubscribe_failure",
                      // Triggered when a segment / moof is transmitted.
                      // Can be triggered for as long as the connection is open.
                      MESSAGE_ARRIVED: "clsp_router_message_arrived",
                      // Triggered when an error is encountered while processing window messages.
                      // Can be triggered any time.
                      WINDOW_MESSAGE_FAIL: "clsp_router_window_message_fail"
                    }, _i.commands = {
                      CONNECT: "connect",
                      DISCONNECT: "disconnect",
                      PUBLISH: "publish",
                      SUBSCRIBE: "subscribe",
                      UNSUBSCRIBE: "unsubscribe",
                      SEND: "send"
                    }, _i.factory = function(Po, Gi, na, ta, Fo, Wa) {
                      return new _i(Po, Gi, na, ta, Fo, Wa);
                    }, _i.prototype._sendToParentWindow = function(Po) {
                      if (this.logger.debug("Sending message to parent window..."), !this.isDestroyed) {
                        if (typeof Po != "object")
                          throw new Error("_sendToParentWindow must be passed an object");
                        switch (Po.clientId = this.clientId, Po.event) {
                          case _i.events.CREATE_SUCCESS:
                          case _i.events.CONNECT_SUCCESS:
                          case _i.events.DISCONNECT_SUCCESS:
                            break;
                          case _i.events.MESSAGE_ARRIVED: {
                            if (!Object.prototype.hasOwnProperty.call(Po, "destinationName") || !Object.prototype.hasOwnProperty.call(Po, "payloadString") || !Object.prototype.hasOwnProperty.call(Po, "payloadBytes"))
                              throw new Error('improperly formatted "data" message sent to _sendToParentWindow');
                            break;
                          }
                          case _i.events.UNSUBSCRIBE_SUCCESS: {
                            if (!Object.prototype.hasOwnProperty.call(Po, "event") || !Object.prototype.hasOwnProperty.call(Po, "topic") || !Object.prototype.hasOwnProperty.call(Po, "response"))
                              throw new Error('improperly formatted "unsubscribe success" message sent to _sendToParentWindow');
                            break;
                          }
                          case _i.events.CONNECT_FAILURE:
                          case _i.events.CONNECTION_LOST:
                          case _i.events.SUBSCRIBE_FAILURE:
                          case _i.events.UNSUBSCRIBE_FAILURE:
                          case _i.events.WINDOW_MESSAGE_FAIL: {
                            if (!Object.prototype.hasOwnProperty.call(Po, "reason"))
                              throw new Error('improperly formatted "fail" message sent to _sendToParentWindow');
                            break;
                          }
                          case _i.events.PUBLISH_SUCCESS: {
                            if (!Po.publishId)
                              throw new Error("publish message must contain a publishId");
                            if (!Po.topic)
                              throw new Error("publish message must contain a topic");
                            break;
                          }
                          case _i.events.PUBLISH_FAILURE: {
                            if (!Po.publishId)
                              throw new Error("publish message must contain a publishId");
                            if (!Object.prototype.hasOwnProperty.call(Po, "reason"))
                              throw new Error('improperly formatted "fail" message sent to _sendToParentWindow');
                            break;
                          }
                          default:
                            throw new Error("Unknown event " + Po.event + " sent to _sendToParentWindow");
                        }
                        try {
                          window.parent.postMessage(Po, "*");
                        } catch (Gi) {
                          console.error(Gi);
                        }
                      }
                    }, _i.prototype._onMessageArrived = function(Po) {
                      this.logger.debug("Received CLSP message...");
                      try {
                        var Gi = "";
                        try {
                          Gi = Po.payloadString;
                        } catch {
                        }
                        this._sendToParentWindow({
                          event: _i.events.MESSAGE_ARRIVED,
                          destinationName: Po.destinationName,
                          payloadString: Gi,
                          // @todo - why is this necessary when it doesn't exist?
                          payloadBytes: Po.payloadBytes || null
                        });
                      } catch (na) {
                        this.logger.error(na);
                      }
                    }, _i.prototype._onMessageDelivered = function(Po) {
                      this.logger.debug("Delivered CLSP message..."), Po._onDelivered && Po._onDelivered();
                    }, _i.prototype._onCommandReceived = function(Po, Gi, na) {
                      switch (Po) {
                        case _i.commands.SUBSCRIBE: {
                          this._subscribe(Gi.topic);
                          break;
                        }
                        case _i.commands.UNSUBSCRIBE: {
                          this._unsubscribe(Gi.topic);
                          break;
                        }
                        case _i.commands.PUBLISH: {
                          var ta = null;
                          try {
                            ta = JSON.stringify(Gi.data);
                          } catch {
                            this.logger.error('ERROR: Unable to handle the "publish" window message event!'), this.logger.error("json stringify error: " + Gi.data);
                            return;
                          }
                          this._publish(Gi.publishId, Gi.topic, ta);
                          break;
                        }
                        case _i.commands.CONNECT: {
                          this.connect();
                          break;
                        }
                        case _i.commands.DISCONNECT: {
                          this.disconnect();
                          break;
                        }
                        case _i.commands.SEND: {
                          this._publish(Gi.publishId, Gi.topic, Gi.byteArray);
                          break;
                        }
                        default:
                          this.logger.error('Unknown Command: "' + Po + '"');
                      }
                    }, _i.prototype._windowMessageEventHandler = function(Po) {
                      var Gi = Po.data;
                      if (Gi) {
                        var na = Gi.method;
                        if (na) {
                          this.logger.debug('Handling incoming window message for "' + na + '"...');
                          try {
                            this._onCommandReceived(na, Gi, Po);
                          } catch (ta) {
                            this.logger.error(ta), this._sendToParentWindow({
                              event: _i.events.WINDOW_MESSAGE_FAIL,
                              reason: "window message event failure"
                            });
                          }
                        }
                      }
                    }, _i.prototype._connect_onSuccess = function(Po) {
                      this.logger.info("Successfully established CLSP connection"), this._sendToParentWindow({
                        event: _i.events.CONNECT_SUCCESS
                      });
                    }, _i.prototype._connect_onFailure = function(Po) {
                      this.logger.info("CLSP Connection Failure!"), this._sendToParentWindow({
                        event: _i.events.CONNECT_FAILURE,
                        reason: "Connection Failed - Error code " + parseInt(Po.errorCode) + ": " + Po.errorMessage
                      });
                    }, _i.prototype._onConnectionLost = function(Po) {
                      var Gi = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                      this.logger.debug("CLSP connection lost");
                      var na = parseInt(Po.errorCode);
                      if (na === 0) {
                        this._sendToParentWindow({
                          event: _i.events.DISCONNECT_SUCCESS,
                          data: Gi
                        });
                        return;
                      }
                      this.logger.warn("CLSP connection lost improperly!"), this._sendToParentWindow({
                        event: _i.events.CONNECTION_LOST,
                        reason: 'connection lost error code "' + na + '" with message: ' + Po.errorMessage,
                        data: Gi
                      });
                    }, _i.prototype._connectionWasLost = function(Po) {
                      this.logger.debug("CLSP Connection was lost while trying to perform another action");
                      var Gi = {
                        errorCode: 0
                      };
                      this._onConnectionLost(Gi, Po);
                    }, _i.prototype._subscribe_onSuccess = function(Po, Gi) {
                      this.logger.debug('Successfully subscribed to topic "' + Po + '"');
                    }, _i.prototype._subscribe_onFailure = function(Po, Gi) {
                      this.logger.error('Failed to subscribe to topic "' + Po + '"'), this._sendToParentWindow({
                        event: _i.events.SUBSCRIBE_FAILURE,
                        reason: "Subscribe Failed - Error code " + parseInt(Gi.errorCode) + ": " + Gi.errorMessage
                      });
                    }, _i.prototype._subscribe = function(Po) {
                      if (this.logger.debug('Subscribing to topic "' + Po + '"'), !Po)
                        throw new Error("topic is a required argument when subscribing");
                      this.clspClient.subscribe(Po, {
                        onSuccess: this._subscribe_onSuccess.bind(this, Po),
                        onFailure: this._subscribe_onFailure.bind(this, Po)
                      });
                    }, _i.prototype._unsubscribe_onSuccess = function(Po, Gi) {
                      this.logger.info('Successfully unsubscribed from topic "' + Po + '"'), this._sendToParentWindow({
                        event: _i.events.UNSUBSCRIBE_SUCCESS,
                        topic: Po,
                        response: Gi
                      });
                    }, _i.prototype._unsubscribe_onFailure = function(Po, Gi) {
                      this.logger.warn('Failed to unsubscribe from topic "' + Po + '"'), this._sendToParentWindow({
                        event: _i.events.UNSUBSCRIBE_FAILURE,
                        reason: "Unsubscribe Failed - Error code " + parseInt(Gi.errorCode) + ": " + Gi.errorMessage
                      });
                    }, _i.prototype._unsubscribe = function(Po) {
                      if (this.logger.info('Unsubscribing from topic "' + Po + '"'), !Po)
                        throw new Error("topic is a required argument when unsubscribing");
                      if (!this.clspClient.isConnected())
                        return this._unsubscribe_onSuccess(Po);
                      this.clspClient.unsubscribe(Po, {
                        onSuccess: this._unsubscribe_onSuccess.bind(this, Po),
                        onFailure: this._unsubscribe_onFailure.bind(this, Po)
                      });
                    }, _i.prototype._publish_onSuccess = function(Po, Gi) {
                      this.logger.info('Successfully published topic "' + Gi + '" with id "' + Po + '"'), this._sendToParentWindow({
                        event: _i.events.PUBLISH_SUCCESS,
                        publishId: Po,
                        topic: Gi
                      });
                    }, _i.prototype._publish_onFailure = function(Po, Gi, na) {
                      this.logger.info('Successfully published topic "' + Gi + '" with id "' + Po + '"'), this._sendToParentWindow({
                        event: _i.events.PUBLISH_FAILURE,
                        publishId: Po,
                        reason: na
                      });
                    }, _i.prototype._publish = function(Po, Gi, na) {
                      if (this.logger.debug('Publishing to topic "' + Gi + '"'), !na)
                        throw new Error("payload is a required argument when publishing");
                      if (!Gi)
                        throw new Error("topic is a required argument when publishing");
                      if (!this.clspClient.isConnected())
                        return this._publish_onSuccess(Po, Gi);
                      var ta = this, Fo = new Ai.MQTT.Message(na);
                      Fo.destinationName = Gi;
                      var Wa = setTimeout(function() {
                        clearTimeout(Wa), Wa = null;
                        var Va = 'publish operation for "' + Gi + '" timed out after ' + ta.PUBLISH_TIMEOUT + " seconds.";
                        ta._publish_onFailure(Po, Gi, Va);
                      }, this.PUBLISH_TIMEOUT * 1e3);
                      Fo._onDelivered = function(Va) {
                        Wa && (clearTimeout(Wa), Wa = null, ta._publish_onSuccess(Po, Gi));
                      }, this.clspClient.publish(Fo);
                    }, _i.prototype.connect = function() {
                      this.logger.info("Connecting...");
                      var Po = new Ai.MQTT.Message(JSON.stringify({
                        clientId: this.clientId
                      }));
                      Po.destinationName = "iov/clientDisconnect";
                      var Gi = {
                        timeout: this.CONNECTION_TIMEOUT,
                        keepAliveInterval: this.KEEP_ALIVE_INTERVAL,
                        onSuccess: this._connect_onSuccess.bind(this),
                        onFailure: this._connect_onFailure.bind(this),
                        willMessage: Po
                        // @todo - should `reconnect` be set here?
                      };
                      this.useSSL === !0 && (Gi.useSSL = !0);
                      try {
                        this.clspClient.connect(Gi), this.logger.info("Connected");
                      } catch (na) {
                        if (na.message.startsWith(_i.pahoErrorCodes.ALREADY_CONNECTED))
                          return;
                        this.logger.error("Failed to connect", na), this._sendToParentWindow({
                          event: _i.events.CONNECT_FAILURE,
                          reason: "General error when trying to connect."
                        });
                      }
                    }, _i.prototype.disconnect = function() {
                      this.logger.info("Disconnecting");
                      try {
                        this.clspClient.isConnected() ? this.clspClient.disconnect() : this._connectionWasLost();
                      } catch (Po) {
                        if (Po.message.startsWith(_i.pahoErrorCodes.NOT_CONNECTED))
                          return;
                        throw this.logger.error("ERROR while disconnecting"), this.logger.error(Po), Po;
                      }
                    }, _i.prototype.destroy = function() {
                      this.logger.info("Destroying..."), !this.isDestroyed && (this.isDestroyed = !0, window.removeEventListener("message", this.boundWindowMessageEventHandler), this.boundWindowMessageEventHandler = null, this.disconnect(), this.clspClient = null, this.isDestroyComplete = !1, this.logger.info("destroy complete"));
                    }, _i;
                  }
                  function sl(Ai, _i, Po) {
                    return Object.defineProperty(Ai, "prototype", { writable: !1 }), Ai;
                  }
                  function Il(Ai, _i) {
                    if (!(Ai instanceof _i)) throw new TypeError("Cannot call a class as a function");
                  }
                  function Vl(Ai, _i, Po) {
                    return _i = Ul(_i), Bl(Ai, xl() ? Reflect.construct(_i, Po || [], Ul(Ai).constructor) : _i.apply(Ai, Po));
                  }
                  function Bl(Ai, _i) {
                    if (_i && (typeof _i == "object" || typeof _i == "function")) return _i;
                    if (_i !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return ql(Ai);
                  }
                  function ql(Ai) {
                    if (Ai === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return Ai;
                  }
                  function xl() {
                    try {
                      var Ai = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                      }));
                    } catch {
                    }
                    return (xl = function() {
                      return !!Ai;
                    })();
                  }
                  function Ul(Ai) {
                    return Ul = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(_i) {
                      return _i.__proto__ || Object.getPrototypeOf(_i);
                    }, Ul(Ai);
                  }
                  function Xl(Ai, _i) {
                    if (typeof _i != "function" && _i !== null) throw new TypeError("Super expression must either be null or a function");
                    Ai.prototype = Object.create(_i && _i.prototype, { constructor: { value: Ai, writable: !0, configurable: !0 } }), Object.defineProperty(Ai, "prototype", { writable: !1 }), _i && hu(Ai, _i);
                  }
                  function hu(Ai, _i) {
                    return hu = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(Po, Gi) {
                      return Po.__proto__ = Gi, Po;
                    }, hu(Ai, _i);
                  }
                  function Tu(Ai, _i, Po) {
                    return (_i = Ku(_i)) in Ai ? Object.defineProperty(Ai, _i, { value: Po, enumerable: !0, configurable: !0, writable: !0 }) : Ai[_i] = Po, Ai;
                  }
                  function Ku(Ai) {
                    var _i = Wl(Ai, "string");
                    return typeof _i == "symbol" ? _i : _i + "";
                  }
                  function Wl(Ai, _i) {
                    if (typeof Ai != "object" || !Ai) return Ai;
                    var Po = Ai[Symbol.toPrimitive];
                    if (Po !== void 0) {
                      var Gi = Po.call(Ai, _i);
                      if (typeof Gi != "object") return Gi;
                      throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (_i === "string" ? String : Number)(Ai);
                  }
                  var uu = fl(), du = uu.commands, za = uu.events, Ya = /* @__PURE__ */ (function(Ai) {
                    function _i(Po, Gi) {
                      var na;
                      if (Il(this, _i), na = Vl(this, _i, [Po]), !Po)
                        throw new Error("logId is required to construct a new RouterStatsManager instance.");
                      if (!Gi)
                        throw new Error("clientId is required to construct a new RouterStatsManager instance.");
                      return na.logId = Po, na.clientId = Gi, na;
                    }
                    return Xl(_i, Ai), sl(_i);
                  })(ja);
                  Tu(Ya, "routerCommands", du), Tu(Ya, "routerEvents", za);
                  var Ws = oi(320);
                  function wl() {
                    return {
                      /**
                       * The `onload` event handler for the `<body> onload` event.  This event
                       * handler will instantiate the Router.
                       *
                       * On success or failure, a message will be sent to the parent window to
                       * indicate success or failure.
                       *
                       * @param {string} logId
                       *   a string that identifies this Conduit / Router in log messages
                       * @param {class} Router
                       *   The Router class
                       * @param {object} config
                       *   An object containing all necessary Router config options
                       *
                       * @returns {Router|null}
                       *   The instantiated router, or `null` if an error is encountered
                       */
                      onload: function(_i, Po, Gi, na) {
                        try {
                          var ta = Gi.factory(na.logId, na.clientId, na.host, na.port, na.useSSL, {
                            CONNECTION_TIMEOUT: na.CONNECTION_TIMEOUT,
                            KEEP_ALIVE_INTERVAL: na.KEEP_ALIVE_INTERVAL,
                            PUBLISH_TIMEOUT: na.PUBLISH_TIMEOUT,
                            Logger: na.Logger
                          });
                          return ta._sendToParentWindow({
                            event: Gi.events.CREATE_SUCCESS
                          }), ta.logger.info(_i + " onload - Router created"), ta;
                        } catch (Fo) {
                          return console.error(_i + " onload - Error while loading:"), console.error(Fo), window.parent.postMessage({
                            event: Gi.events.CREATE_FAILURE,
                            reason: Fo
                          }, "*"), null;
                        }
                      },
                      /**
                       * The `onunload` event handler for the `<body> onunload` event.  This
                       * event handler will destroy this iframe's Router if it exists.
                       *
                       * @param {string} logId
                       *   a string that identifies this Conduit / Router in log messages
                       * @param {Router} router
                       *   The router that was instantiated for this iframe
                       *
                       * @returns {void}
                       */
                      onunload: function(_i, Po, Gi) {
                        if (!Gi) {
                          console.warn(_i + " onunload - Router not instantiated, exiting...");
                          return;
                        }
                        try {
                          Gi.logger.info(_i + " onunload - Router being destroyed in onunload..."), Gi.destroy(), Gi.logger.info(_i + " onunload - Router destroyed in onunload");
                        } catch (na) {
                          Gi.logger.error(_i + " onunload - Error while unloading:"), Gi.logger.error(na);
                        }
                      }
                    };
                  }
                  var Gl = oi(835);
                  function bl(Ai, _i) {
                    var Po = Object.keys(Ai);
                    if (Object.getOwnPropertySymbols) {
                      var Gi = Object.getOwnPropertySymbols(Ai);
                      _i && (Gi = Gi.filter(function(na) {
                        return Object.getOwnPropertyDescriptor(Ai, na).enumerable;
                      })), Po.push.apply(Po, Gi);
                    }
                    return Po;
                  }
                  function Za(Ai) {
                    for (var _i = 1; _i < arguments.length; _i++) {
                      var Po = arguments[_i] != null ? arguments[_i] : {};
                      _i % 2 ? bl(Object(Po), !0).forEach(function(Gi) {
                        rl(Ai, Gi, Po[Gi]);
                      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Ai, Object.getOwnPropertyDescriptors(Po)) : bl(Object(Po)).forEach(function(Gi) {
                        Object.defineProperty(Ai, Gi, Object.getOwnPropertyDescriptor(Po, Gi));
                      });
                    }
                    return Ai;
                  }
                  function rl(Ai, _i, Po) {
                    return (_i = cu(_i)) in Ai ? Object.defineProperty(Ai, _i, { value: Po, enumerable: !0, configurable: !0, writable: !0 }) : Ai[_i] = Po, Ai;
                  }
                  function zs(Ai) {
                    return Zl(Ai) || $l(Ai) || Ol(Ai) || al();
                  }
                  function al() {
                    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
                  }
                  function Ol(Ai, _i) {
                    if (Ai) {
                      if (typeof Ai == "string") return tu(Ai, _i);
                      var Po = {}.toString.call(Ai).slice(8, -1);
                      return Po === "Object" && Ai.constructor && (Po = Ai.constructor.name), Po === "Map" || Po === "Set" ? Array.from(Ai) : Po === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Po) ? tu(Ai, _i) : void 0;
                    }
                  }
                  function $l(Ai) {
                    if (typeof Symbol < "u" && Ai[Symbol.iterator] != null || Ai["@@iterator"] != null) return Array.from(Ai);
                  }
                  function Zl(Ai) {
                    if (Array.isArray(Ai)) return tu(Ai);
                  }
                  function tu(Ai, _i) {
                    (_i == null || _i > Ai.length) && (_i = Ai.length);
                    for (var Po = 0, Gi = Array(_i); Po < _i; Po++) Gi[Po] = Ai[Po];
                    return Gi;
                  }
                  function su(Ai, _i) {
                    if (!(Ai instanceof _i)) throw new TypeError("Cannot call a class as a function");
                  }
                  function dl(Ai, _i) {
                    for (var Po = 0; Po < _i.length; Po++) {
                      var Gi = _i[Po];
                      Gi.enumerable = Gi.enumerable || !1, Gi.configurable = !0, "value" in Gi && (Gi.writable = !0), Object.defineProperty(Ai, cu(Gi.key), Gi);
                    }
                  }
                  function Su(Ai, _i, Po) {
                    return _i && dl(Ai.prototype, _i), Po && dl(Ai, Po), Object.defineProperty(Ai, "prototype", { writable: !1 }), Ai;
                  }
                  function cu(Ai) {
                    var _i = Ru(Ai, "string");
                    return typeof _i == "symbol" ? _i : _i + "";
                  }
                  function Ru(Ai, _i) {
                    if (typeof Ai != "object" || !Ai) return Ai;
                    var Po = Ai[Symbol.toPrimitive];
                    if (Po !== void 0) {
                      var Gi = Po.call(Ai, _i);
                      if (typeof Gi != "object") return Gi;
                      throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(Ai);
                  }
                  var bu = /* @__PURE__ */ (function() {
                    function Ai(_i, Po, Gi, na) {
                      var ta = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
                      if (su(this, Ai), !_i)
                        throw new Error("streamName is required to create a stream configuration.");
                      if (!Po)
                        throw new Error("host is required to create a stream configuration.");
                      if (!Gi)
                        throw new Error("port is required to create a stream configuration.");
                      if (!na && na !== !1)
                        throw new Error("useSSL is required to create a stream configuration.");
                      if (!ta || typeof ta != "object")
                        throw new Error("tokenConfig is required to create a stream configuration.");
                      this.streamName = _i, this.host = Po, this.port = Gi, this.useSSL = na, this.tokenConfig = ta, this.isDestroyed = !1, this.isDestroyComplete = !1;
                    }
                    return Su(Ai, [{
                      key: "clone",
                      value: function(Po) {
                        if (!Ai.isStreamConfiguration(Po))
                          throw new Error("Cannot clone with invalid streamConfiguration");
                        var Gi = Ai.factory.apply(Ai, zs(Po.toObject()));
                        return Gi;
                      }
                    }, {
                      key: "toObject",
                      value: function() {
                        return {
                          streamName: this.streamName,
                          host: this.host,
                          port: this.port,
                          useSSL: this.useSSL,
                          tokenConfig: Za({}, this.tokenConfig)
                        };
                      }
                    }, {
                      key: "protocol",
                      get: function() {
                        return this.useSSL ? "clsps" : "clsp";
                      }
                    }, {
                      key: "url",
                      get: function() {
                        return "".concat(this.protocol, "://").concat(this.host, ":").concat(this.port, "/").concat(this.streamName);
                      }
                    }, {
                      key: "destroy",
                      value: function() {
                        this.isDestroyed || (this.isDestroyed = !0, this.streamName = null, this.host = null, this.port = null, this.useSSL = null, this.tokenConfig = null, this.isDestroyComplete = !1, this.logger.info("destroy complete"));
                      }
                    }], [{
                      key: "factory",
                      value: function(Po, Gi, na, ta, Fo) {
                        return new Ai(Po, Gi, na, ta, Fo);
                      }
                    }, {
                      key: "fromObject",
                      value: function(Po) {
                        if (!Po || typeof Po != "object")
                          throw new Error("config must be an object to create a streamConfiguration");
                        return Ai.factory(Po.streamName, Po.host, Po.port, Po.useSSL, Za({}, Po.tokenConfig));
                      }
                    }, {
                      key: "isStreamConfiguration",
                      value: function(Po) {
                        return Po instanceof Ai;
                      }
                    }, {
                      key: "generateConfigFromUrl",
                      value: function(Po) {
                        if (!Po)
                          throw new Error("No source was given to be parsed!");
                        var Gi = Gl.parse(Po), na, ta, Fo = "", Wa = "";
                        if (Gi.protocol = Gi.protocol.toLowerCase(), Gi.protocol === "clsps:")
                          na = !0, ta = io().getDefaultStreamPort("clsps");
                        else if (Gi.protocol === "clsp:")
                          na = !1, ta = io().getDefaultStreamPort("clsp");
                        else
                          throw new Error("The given source is not a clsp url, and therefore cannot be parsed.");
                        var Va = Gi.pathname.split("/"), wa = Va[Va.length - 1], il = Gi.hostname, ol = Gi.port;
                        (!ol || ol.length === 0) && (ol = ta), ol = parseInt(ol), il === "@" && (il = window.location.hostname);
                        for (var Ql = Po.indexOf(Gi.pathname) + Gi.pathname.length, Uu = Po.substr(Ql).split("?")[1] || "", Wu = {}, Kl = Uu.split("&"), pl = 0; pl < Kl.length; pl++) {
                          var pu = Kl[pl].split("=");
                          Wu[decodeURIComponent(pu[0])] = decodeURIComponent(pu[1] || "");
                        }
                        if (typeof Wu.token < "u" && Wu.token.length > 0) {
                          var lu = "".concat(Gi.protocol, "://").concat(il, ":").concat(ol, "/").concat(wa, "?token=").concat(Wu.token);
                          Fo = window.btoa(lu), Wa = Wu.token;
                        }
                        return {
                          streamName: wa,
                          host: il,
                          port: ol,
                          useSSL: na,
                          tokenConfig: {
                            b64HashAccessUrl: Fo,
                            jwt: Wa
                          }
                        };
                      }
                    }, {
                      key: "fromUrl",
                      value: function(Po) {
                        var Gi = Ai.generateConfigFromUrl(Po);
                        return Ai.fromObject(Gi);
                      }
                    }]);
                  })();
                  function Hu(Ai, _i) {
                    var Po = Object.keys(Ai);
                    if (Object.getOwnPropertySymbols) {
                      var Gi = Object.getOwnPropertySymbols(Ai);
                      _i && (Gi = Gi.filter(function(na) {
                        return Object.getOwnPropertyDescriptor(Ai, na).enumerable;
                      })), Po.push.apply(Po, Gi);
                    }
                    return Po;
                  }
                  function cc(Ai) {
                    for (var _i = 1; _i < arguments.length; _i++) {
                      var Po = arguments[_i] != null ? arguments[_i] : {};
                      _i % 2 ? Hu(Object(Po), !0).forEach(function(Gi) {
                        Wc(Ai, Gi, Po[Gi]);
                      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Ai, Object.getOwnPropertyDescriptors(Po)) : Hu(Object(Po)).forEach(function(Gi) {
                        Object.defineProperty(Ai, Gi, Object.getOwnPropertyDescriptor(Po, Gi));
                      });
                    }
                    return Ai;
                  }
                  function Tl() {
                    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
                    Tl = function() {
                      return _i;
                    };
                    var Ai, _i = {}, Po = Object.prototype, Gi = Po.hasOwnProperty, na = Object.defineProperty || function(Bi, Ci, ki) {
                      Bi[Ci] = ki.value;
                    }, ta = typeof Symbol == "function" ? Symbol : {}, Fo = ta.iterator || "@@iterator", Wa = ta.asyncIterator || "@@asyncIterator", Va = ta.toStringTag || "@@toStringTag";
                    function wa(Bi, Ci, ki) {
                      return Object.defineProperty(Bi, Ci, { value: ki, enumerable: !0, configurable: !0, writable: !0 }), Bi[Ci];
                    }
                    try {
                      wa({}, "");
                    } catch {
                      wa = function(ki, Mo, Xo) {
                        return ki[Mo] = Xo;
                      };
                    }
                    function il(Bi, Ci, ki, Mo) {
                      var Xo = Ci && Ci.prototype instanceof pu ? Ci : pu, Uo = Object.create(Xo.prototype), qa = new ku(Mo || []);
                      return na(Uo, "_invoke", { value: pc(Bi, ki, qa) }), Uo;
                    }
                    function ol(Bi, Ci, ki) {
                      try {
                        return { type: "normal", arg: Bi.call(Ci, ki) };
                      } catch (Mo) {
                        return { type: "throw", arg: Mo };
                      }
                    }
                    _i.wrap = il;
                    var Ql = "suspendedStart", Uu = "suspendedYield", Wu = "executing", Kl = "completed", pl = {};
                    function pu() {
                    }
                    function lu() {
                    }
                    function Nl() {
                    }
                    var Eu = {};
                    wa(Eu, Fo, function() {
                      return this;
                    });
                    var wu = Object.getPrototypeOf, yu = wu && wu(wu(Nu([])));
                    yu && yu !== Po && Gi.call(yu, Fo) && (Eu = yu);
                    var zl = Nl.prototype = pu.prototype = Object.create(Eu);
                    function Qu(Bi) {
                      ["next", "throw", "return"].forEach(function(Ci) {
                        wa(Bi, Ci, function(ki) {
                          return this._invoke(Ci, ki);
                        });
                      });
                    }
                    function gu(Bi, Ci) {
                      function ki(Xo, Uo, qa, Us) {
                        var Hs = ol(Bi[Xo], Bi, Uo);
                        if (Hs.type !== "throw") {
                          var jl = Hs.arg, Al = jl.value;
                          return Al && typeof Al == "object" && Gi.call(Al, "__await") ? Ci.resolve(Al.__await).then(function(Ml) {
                            ki("next", Ml, qa, Us);
                          }, function(Ml) {
                            ki("throw", Ml, qa, Us);
                          }) : Ci.resolve(Al).then(function(Ml) {
                            jl.value = Ml, qa(jl);
                          }, function(Ml) {
                            return ki("throw", Ml, qa, Us);
                          });
                        }
                        Us(Hs.arg);
                      }
                      var Mo;
                      na(this, "_invoke", { value: function(Uo, qa) {
                        function Us() {
                          return new Ci(function(Hs, jl) {
                            ki(Uo, qa, Hs, jl);
                          });
                        }
                        return Mo = Mo ? Mo.then(Us, Us) : Us();
                      } });
                    }
                    function pc(Bi, Ci, ki) {
                      var Mo = Ql;
                      return function(Xo, Uo) {
                        if (Mo === Wu) throw Error("Generator is already running");
                        if (Mo === Kl) {
                          if (Xo === "throw") throw Uo;
                          return { value: Ai, done: !0 };
                        }
                        for (ki.method = Xo, ki.arg = Uo; ; ) {
                          var qa = ki.delegate;
                          if (qa) {
                            var Us = Zu(qa, ki);
                            if (Us) {
                              if (Us === pl) continue;
                              return Us;
                            }
                          }
                          if (ki.method === "next") ki.sent = ki._sent = ki.arg;
                          else if (ki.method === "throw") {
                            if (Mo === Ql) throw Mo = Kl, ki.arg;
                            ki.dispatchException(ki.arg);
                          } else ki.method === "return" && ki.abrupt("return", ki.arg);
                          Mo = Wu;
                          var Hs = ol(Bi, Ci, ki);
                          if (Hs.type === "normal") {
                            if (Mo = ki.done ? Kl : Uu, Hs.arg === pl) continue;
                            return { value: Hs.arg, done: ki.done };
                          }
                          Hs.type === "throw" && (Mo = Kl, ki.method = "throw", ki.arg = Hs.arg);
                        }
                      };
                    }
                    function Zu(Bi, Ci) {
                      var ki = Ci.method, Mo = Bi.iterator[ki];
                      if (Mo === Ai) return Ci.delegate = null, ki === "throw" && Bi.iterator.return && (Ci.method = "return", Ci.arg = Ai, Zu(Bi, Ci), Ci.method === "throw") || ki !== "return" && (Ci.method = "throw", Ci.arg = new TypeError("The iterator does not provide a '" + ki + "' method")), pl;
                      var Xo = ol(Mo, Bi.iterator, Ci.arg);
                      if (Xo.type === "throw") return Ci.method = "throw", Ci.arg = Xo.arg, Ci.delegate = null, pl;
                      var Uo = Xo.arg;
                      return Uo ? Uo.done ? (Ci[Bi.resultName] = Uo.value, Ci.next = Bi.nextLoc, Ci.method !== "return" && (Ci.method = "next", Ci.arg = Ai), Ci.delegate = null, pl) : Uo : (Ci.method = "throw", Ci.arg = new TypeError("iterator result is not an object"), Ci.delegate = null, pl);
                    }
                    function gc(Bi) {
                      var Ci = { tryLoc: Bi[0] };
                      1 in Bi && (Ci.catchLoc = Bi[1]), 2 in Bi && (Ci.finallyLoc = Bi[2], Ci.afterLoc = Bi[3]), this.tryEntries.push(Ci);
                    }
                    function Du(Bi) {
                      var Ci = Bi.completion || {};
                      Ci.type = "normal", delete Ci.arg, Bi.completion = Ci;
                    }
                    function ku(Bi) {
                      this.tryEntries = [{ tryLoc: "root" }], Bi.forEach(gc, this), this.reset(!0);
                    }
                    function Nu(Bi) {
                      if (Bi || Bi === "") {
                        var Ci = Bi[Fo];
                        if (Ci) return Ci.call(Bi);
                        if (typeof Bi.next == "function") return Bi;
                        if (!isNaN(Bi.length)) {
                          var ki = -1, Mo = function Xo() {
                            for (; ++ki < Bi.length; ) if (Gi.call(Bi, ki)) return Xo.value = Bi[ki], Xo.done = !1, Xo;
                            return Xo.value = Ai, Xo.done = !0, Xo;
                          };
                          return Mo.next = Mo;
                        }
                      }
                      throw new TypeError(typeof Bi + " is not iterable");
                    }
                    return lu.prototype = Nl, na(zl, "constructor", { value: Nl, configurable: !0 }), na(Nl, "constructor", { value: lu, configurable: !0 }), lu.displayName = wa(Nl, Va, "GeneratorFunction"), _i.isGeneratorFunction = function(Bi) {
                      var Ci = typeof Bi == "function" && Bi.constructor;
                      return !!Ci && (Ci === lu || (Ci.displayName || Ci.name) === "GeneratorFunction");
                    }, _i.mark = function(Bi) {
                      return Object.setPrototypeOf ? Object.setPrototypeOf(Bi, Nl) : (Bi.__proto__ = Nl, wa(Bi, Va, "GeneratorFunction")), Bi.prototype = Object.create(zl), Bi;
                    }, _i.awrap = function(Bi) {
                      return { __await: Bi };
                    }, Qu(gu.prototype), wa(gu.prototype, Wa, function() {
                      return this;
                    }), _i.AsyncIterator = gu, _i.async = function(Bi, Ci, ki, Mo, Xo) {
                      Xo === void 0 && (Xo = Promise);
                      var Uo = new gu(il(Bi, Ci, ki, Mo), Xo);
                      return _i.isGeneratorFunction(Ci) ? Uo : Uo.next().then(function(qa) {
                        return qa.done ? qa.value : Uo.next();
                      });
                    }, Qu(zl), wa(zl, Va, "Generator"), wa(zl, Fo, function() {
                      return this;
                    }), wa(zl, "toString", function() {
                      return "[object Generator]";
                    }), _i.keys = function(Bi) {
                      var Ci = Object(Bi), ki = [];
                      for (var Mo in Ci) ki.push(Mo);
                      return ki.reverse(), function Xo() {
                        for (; ki.length; ) {
                          var Uo = ki.pop();
                          if (Uo in Ci) return Xo.value = Uo, Xo.done = !1, Xo;
                        }
                        return Xo.done = !0, Xo;
                      };
                    }, _i.values = Nu, ku.prototype = { constructor: ku, reset: function(Ci) {
                      if (this.prev = 0, this.next = 0, this.sent = this._sent = Ai, this.done = !1, this.delegate = null, this.method = "next", this.arg = Ai, this.tryEntries.forEach(Du), !Ci) for (var ki in this) ki.charAt(0) === "t" && Gi.call(this, ki) && !isNaN(+ki.slice(1)) && (this[ki] = Ai);
                    }, stop: function() {
                      this.done = !0;
                      var Ci = this.tryEntries[0].completion;
                      if (Ci.type === "throw") throw Ci.arg;
                      return this.rval;
                    }, dispatchException: function(Ci) {
                      if (this.done) throw Ci;
                      var ki = this;
                      function Mo(jl, Al) {
                        return qa.type = "throw", qa.arg = Ci, ki.next = jl, Al && (ki.method = "next", ki.arg = Ai), !!Al;
                      }
                      for (var Xo = this.tryEntries.length - 1; Xo >= 0; --Xo) {
                        var Uo = this.tryEntries[Xo], qa = Uo.completion;
                        if (Uo.tryLoc === "root") return Mo("end");
                        if (Uo.tryLoc <= this.prev) {
                          var Us = Gi.call(Uo, "catchLoc"), Hs = Gi.call(Uo, "finallyLoc");
                          if (Us && Hs) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          } else if (Us) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                          } else {
                            if (!Hs) throw Error("try statement without catch or finally");
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          }
                        }
                      }
                    }, abrupt: function(Ci, ki) {
                      for (var Mo = this.tryEntries.length - 1; Mo >= 0; --Mo) {
                        var Xo = this.tryEntries[Mo];
                        if (Xo.tryLoc <= this.prev && Gi.call(Xo, "finallyLoc") && this.prev < Xo.finallyLoc) {
                          var Uo = Xo;
                          break;
                        }
                      }
                      Uo && (Ci === "break" || Ci === "continue") && Uo.tryLoc <= ki && ki <= Uo.finallyLoc && (Uo = null);
                      var qa = Uo ? Uo.completion : {};
                      return qa.type = Ci, qa.arg = ki, Uo ? (this.method = "next", this.next = Uo.finallyLoc, pl) : this.complete(qa);
                    }, complete: function(Ci, ki) {
                      if (Ci.type === "throw") throw Ci.arg;
                      return Ci.type === "break" || Ci.type === "continue" ? this.next = Ci.arg : Ci.type === "return" ? (this.rval = this.arg = Ci.arg, this.method = "return", this.next = "end") : Ci.type === "normal" && ki && (this.next = ki), pl;
                    }, finish: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.finallyLoc === Ci) return this.complete(Mo.completion, Mo.afterLoc), Du(Mo), pl;
                      }
                    }, catch: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.tryLoc === Ci) {
                          var Xo = Mo.completion;
                          if (Xo.type === "throw") {
                            var Uo = Xo.arg;
                            Du(Mo);
                          }
                          return Uo;
                        }
                      }
                      throw Error("illegal catch attempt");
                    }, delegateYield: function(Ci, ki, Mo) {
                      return this.delegate = { iterator: Nu(Ci), resultName: ki, nextLoc: Mo }, this.method === "next" && (this.arg = Ai), pl;
                    } }, _i;
                  }
                  function Yl(Ai, _i, Po, Gi, na, ta, Fo) {
                    try {
                      var Wa = Ai[ta](Fo), Va = Wa.value;
                    } catch (wa) {
                      return void Po(wa);
                    }
                    Wa.done ? _i(Va) : Promise.resolve(Va).then(Gi, na);
                  }
                  function Dl(Ai) {
                    return function() {
                      var _i = this, Po = arguments;
                      return new Promise(function(Gi, na) {
                        var ta = Ai.apply(_i, Po);
                        function Fo(Va) {
                          Yl(ta, Gi, na, Fo, Wa, "next", Va);
                        }
                        function Wa(Va) {
                          Yl(ta, Gi, na, Fo, Wa, "throw", Va);
                        }
                        Fo(void 0);
                      });
                    };
                  }
                  function Cl(Ai, _i) {
                    if (!(Ai instanceof _i)) throw new TypeError("Cannot call a class as a function");
                  }
                  function Hl(Ai, _i) {
                    for (var Po = 0; Po < _i.length; Po++) {
                      var Gi = _i[Po];
                      Gi.enumerable = Gi.enumerable || !1, Gi.configurable = !0, "value" in Gi && (Gi.writable = !0), Object.defineProperty(Ai, Xu(Gi.key), Gi);
                    }
                  }
                  function Gu(Ai, _i, Po) {
                    return _i && Hl(Ai.prototype, _i), Po && Hl(Ai, Po), Object.defineProperty(Ai, "prototype", { writable: !1 }), Ai;
                  }
                  function xu(Ai, _i, Po) {
                    return _i = Mu(_i), ac(Ai, mc() ? Reflect.construct(_i, Po || [], Mu(Ai).constructor) : _i.apply(Ai, Po));
                  }
                  function ac(Ai, _i) {
                    if (_i && (typeof _i == "object" || typeof _i == "function")) return _i;
                    if (_i !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return hc(Ai);
                  }
                  function hc(Ai) {
                    if (Ai === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return Ai;
                  }
                  function mc() {
                    try {
                      var Ai = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                      }));
                    } catch {
                    }
                    return (mc = function() {
                      return !!Ai;
                    })();
                  }
                  function jc(Ai, _i, Po, Gi) {
                    var na = iu(Mu(Ai.prototype), _i, Po);
                    return 2 & Gi && typeof na == "function" ? function(ta) {
                      return na.apply(Po, ta);
                    } : na;
                  }
                  function iu() {
                    return iu = typeof Reflect < "u" && Reflect.get ? Reflect.get.bind() : function(Ai, _i, Po) {
                      var Gi = yc(Ai, _i);
                      if (Gi) {
                        var na = Object.getOwnPropertyDescriptor(Gi, _i);
                        return na.get ? na.get.call(arguments.length < 3 ? Ai : Po) : na.value;
                      }
                    }, iu.apply(null, arguments);
                  }
                  function yc(Ai, _i) {
                    for (; !{}.hasOwnProperty.call(Ai, _i) && (Ai = Mu(Ai)) !== null; ) ;
                    return Ai;
                  }
                  function Mu(Ai) {
                    return Mu = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(_i) {
                      return _i.__proto__ || Object.getPrototypeOf(_i);
                    }, Mu(Ai);
                  }
                  function sc(Ai, _i) {
                    if (typeof _i != "function" && _i !== null) throw new TypeError("Super expression must either be null or a function");
                    Ai.prototype = Object.create(_i && _i.prototype, { constructor: { value: Ai, writable: !0, configurable: !0 } }), Object.defineProperty(Ai, "prototype", { writable: !1 }), _i && wc(Ai, _i);
                  }
                  function wc(Ai, _i) {
                    return wc = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(Po, Gi) {
                      return Po.__proto__ = Gi, Po;
                    }, wc(Ai, _i);
                  }
                  function Wc(Ai, _i, Po) {
                    return (_i = Xu(_i)) in Ai ? Object.defineProperty(Ai, _i, { value: Po, enumerable: !0, configurable: !0, writable: !0 }) : Ai[_i] = Po, Ai;
                  }
                  function Xu(Ai) {
                    var _i = fd(Ai, "string");
                    return typeof _i == "symbol" ? _i : _i + "";
                  }
                  function fd(Ai, _i) {
                    if (typeof Ai != "object" || !Ai) return Ai;
                    var Po = Ai[Symbol.toPrimitive];
                    if (Po !== void 0) {
                      var Gi = Po.call(Ai, _i);
                      if (typeof Gi != "object") return Gi;
                      throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (_i === "string" ? String : Number)(Ai);
                  }
                  var rd = 120, _c = 30, dh = io().DEFAULT_STREAM_TIMEOUT, Bd = /* @__PURE__ */ (function(Ai) {
                    function _i(Po, Gi, na, ta) {
                      var Fo;
                      if (Cl(this, _i), Fo = xu(this, _i, [Po, Gi]), !bu.isStreamConfiguration(na))
                        throw new Error("invalid streamConfiguration passed to Router Iframe Manager constructor");
                      if (!ta)
                        throw new Error("containerElement is required to construct a new Router Iframe Manager instance");
                      return Fo.streamConfiguration = na, Fo.containerElement = ta, Fo.iframe = null, Fo.isCreated = !1, Fo.hasIframeDestroyedExternallyEventBeenEmitted = !1, Fo.ROUTER_CONNECTION_TIMEOUT = rd, Fo.ROUTER_KEEP_ALIVE_INTERVAL = _c, Fo.ROUTER_PUBLISH_TIMEOUT = dh, Fo;
                    }
                    return sc(_i, Ai), Gu(_i, [{
                      key: "create",
                      value: (function() {
                        var Po = Dl(/* @__PURE__ */ Tl().mark(function na() {
                          return Tl().wrap(function(Fo) {
                            for (; ; ) switch (Fo.prev = Fo.next) {
                              case 0:
                                if (!this.isDestroyed) {
                                  Fo.next = 2;
                                  break;
                                }
                                throw new Error("Tried to create a destroyed Router Iframe Manager!");
                              case 2:
                                if (!this.isCreated) {
                                  Fo.next = 5;
                                  break;
                                }
                                return this.logger.warn("Router Iframe Manager already created..."), Fo.abrupt("return");
                              case 5:
                                return this.logger.debug("Initializing..."), Fo.prev = 6, Fo.next = 9, (0, Ws.w)(this._create(), 2e3);
                              case 9:
                                this.logger.info("Router created successfully"), this.isCreated = !0, Fo.next = 17;
                                break;
                              case 13:
                                Fo.prev = 13, Fo.t0 = Fo.catch(6), this.logger.error("Failed to create the Iframe/Router!"), this.logger.error(Fo.t0);
                              case 17:
                              case "end":
                                return Fo.stop();
                            }
                          }, na, this, [[6, 13]]);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "_create",
                      value: function() {
                        var Gi = this;
                        return new Promise(function(na, ta) {
                          Gi._onRouterCreated = function(Fo) {
                            if (Fo)
                              return ta(Fo);
                            na();
                          }, Gi.iframe = Gi._generateIframe(), Gi.containerElement.appendChild(Gi.iframe);
                        });
                      }
                    }, {
                      key: "_handleRouterCreatedEvent",
                      value: function(Gi, na) {
                        if (this.isDestroyed)
                          throw new Error("Tried to create a Router for a destroyed Router Iframe Manager!");
                        if (!this._onRouterCreated)
                          throw new Error("Tried to create Router prior to initialization!");
                        if (this.isCreated)
                          throw new Error("Tried to create Router after initialization!");
                        switch (Gi) {
                          case _i.routerEvents.CREATE_SUCCESS: {
                            this._onRouterCreated();
                            break;
                          }
                          case _i.routerEvents.CREATE_FAILURE: {
                            this._onRouterCreated(new Error(na.data.reason));
                            break;
                          }
                          default:
                            throw new Error("Unknown eventType: ".concat(Gi));
                        }
                      }
                      /**
                       * @private
                       *
                       * Generate an iframe with an embedded CLSP Router.
                       *
                       * @returns Element
                       */
                    }, {
                      key: "_generateIframe",
                      value: function() {
                        this.logger.debug("Generating Iframe...");
                        var Gi = document.createElement("iframe");
                        return Gi.setAttribute("id", this.clientId), Gi.width = 0, Gi.height = 0, Gi.setAttribute("style", "display:none;"), Gi.srcdoc = `
      <html>
        <head>
          <script type="text/javascript">

            // Configure the CLSP properties
            window.clspRouterConfig = {
              logId: '`.concat(this.logId, `',
              clientId: '`).concat(this.clientId, `',
              host: '`).concat(this.streamConfiguration.host, `',
              port: `).concat(this.streamConfiguration.port, `,
              useSSL: `).concat(this.streamConfiguration.useSSL, `,
              CONNECTION_TIMEOUT: `).concat(this.ROUTER_CONNECTION_TIMEOUT, `,
              KEEP_ALIVE_INTERVAL: `).concat(this.ROUTER_KEEP_ALIVE_INTERVAL, `,
              PUBLISH_TIMEOUT: `).concat(this.ROUTER_PUBLISH_TIMEOUT, `,
              Logger: (`).concat(Li().toString(), ')("').concat(io().version, `"),
            };

            window.Router = `).concat(fl.toString(), `(window.parent.Paho);
            window.iframeEventHandlers = `).concat(wl.toString(), `();
          <\/script>
        </head>
        <body
          onload="window.router = window.iframeEventHandlers.onload(
            '`).concat(this.logId, `',
            '`).concat(this.clientId, `',
            window.Router,
            window.clspRouterConfig
          );"
          onunload="window.iframeEventHandlers.onunload(
            '`).concat(this.logId, `',
            '`).concat(this.clientId, `',
            window.router
          );"
        >
          <div id="message"></div>
        </body>
      </html>
    `), Gi;
                      }
                    }, {
                      key: "wasIframeDestroyedExternally",
                      value: function() {
                        return !this.iframe.contentWindow;
                      }
                      /**
                       * @private
                       *
                       * Pass a Router command to the iframe.  Should only ever be invoked in
                       * response to a Router Manager command event.
                       *
                       * @param {Object} message
                       *   The message / event data to send with the command
                       */
                    }, {
                      key: "command",
                      value: function(Gi, na) {
                        if (this.logger.debug("Sending a message to the iframe..."), this.isDestroyComplete) {
                          this.logger.warn("Cannot send message via destroyed iframe", Gi, na);
                          return;
                        }
                        if (this.wasIframeDestroyedExternally()) {
                          if (this.isDestroyed) {
                            this.logger.info("Iframe was destroyed externally while in process of destroying");
                            return;
                          }
                          if (this.logger.info("Cannot process command because the iframe is destroyed."), this.hasIframeDestroyedExternallyEventBeenEmitted)
                            return;
                          this.hasIframeDestroyedExternallyEventBeenEmitted = !0, this.logger.info("Iframe destroyed externally!"), this.emit(_i.events.IFRAME_DESTROYED_EXTERNALLY);
                          return;
                        }
                        try {
                          var ta = cc({
                            method: Gi
                          }, na);
                          this.iframe.contentWindow.postMessage(ta, "*");
                        } catch (Fo) {
                          this.logger.error("Failed while trying to execute command ".concat(Fo)), this.logger.error(Fo);
                        }
                      }
                    }, {
                      key: "_destroyIframe",
                      value: function() {
                        this.isDestroyComplete || (this.iframe.parentNode.removeChild(this.iframe), this.iframe.srcdoc = "", this.iframe = null);
                      }
                    }, {
                      key: "_destroy",
                      value: (function() {
                        var Po = Dl(/* @__PURE__ */ Tl().mark(function na() {
                          return Tl().wrap(function(Fo) {
                            for (; ; ) switch (Fo.prev = Fo.next) {
                              case 0:
                                return this._destroyIframe(), this.streamConfiguration = null, this.containerElement = null, Fo.next = 5, jc(_i, "_destroy", this, 3)([]);
                              case 5:
                              case "end":
                                return Fo.stop();
                            }
                          }, na, this);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }], [{
                      key: "factory",
                      value: function(Gi, na, ta, Fo) {
                        return new _i(Gi, na, ta, Fo);
                      }
                    }]);
                  })(Ya);
                  Wc(Bd, "events", {
                    IFRAME_DESTROYED_EXTERNALLY: "iframe-destroyed-externally"
                  }), Wc(Bd, "routerEvents", {
                    CREATE_SUCCESS: Ya.routerEvents.CREATE_SUCCESS,
                    CREATE_FAILURE: Ya.routerEvents.CREATE_FAILURE
                  });
                  function Jc() {
                    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
                    Jc = function() {
                      return _i;
                    };
                    var Ai, _i = {}, Po = Object.prototype, Gi = Po.hasOwnProperty, na = Object.defineProperty || function(Bi, Ci, ki) {
                      Bi[Ci] = ki.value;
                    }, ta = typeof Symbol == "function" ? Symbol : {}, Fo = ta.iterator || "@@iterator", Wa = ta.asyncIterator || "@@asyncIterator", Va = ta.toStringTag || "@@toStringTag";
                    function wa(Bi, Ci, ki) {
                      return Object.defineProperty(Bi, Ci, { value: ki, enumerable: !0, configurable: !0, writable: !0 }), Bi[Ci];
                    }
                    try {
                      wa({}, "");
                    } catch {
                      wa = function(ki, Mo, Xo) {
                        return ki[Mo] = Xo;
                      };
                    }
                    function il(Bi, Ci, ki, Mo) {
                      var Xo = Ci && Ci.prototype instanceof pu ? Ci : pu, Uo = Object.create(Xo.prototype), qa = new ku(Mo || []);
                      return na(Uo, "_invoke", { value: pc(Bi, ki, qa) }), Uo;
                    }
                    function ol(Bi, Ci, ki) {
                      try {
                        return { type: "normal", arg: Bi.call(Ci, ki) };
                      } catch (Mo) {
                        return { type: "throw", arg: Mo };
                      }
                    }
                    _i.wrap = il;
                    var Ql = "suspendedStart", Uu = "suspendedYield", Wu = "executing", Kl = "completed", pl = {};
                    function pu() {
                    }
                    function lu() {
                    }
                    function Nl() {
                    }
                    var Eu = {};
                    wa(Eu, Fo, function() {
                      return this;
                    });
                    var wu = Object.getPrototypeOf, yu = wu && wu(wu(Nu([])));
                    yu && yu !== Po && Gi.call(yu, Fo) && (Eu = yu);
                    var zl = Nl.prototype = pu.prototype = Object.create(Eu);
                    function Qu(Bi) {
                      ["next", "throw", "return"].forEach(function(Ci) {
                        wa(Bi, Ci, function(ki) {
                          return this._invoke(Ci, ki);
                        });
                      });
                    }
                    function gu(Bi, Ci) {
                      function ki(Xo, Uo, qa, Us) {
                        var Hs = ol(Bi[Xo], Bi, Uo);
                        if (Hs.type !== "throw") {
                          var jl = Hs.arg, Al = jl.value;
                          return Al && typeof Al == "object" && Gi.call(Al, "__await") ? Ci.resolve(Al.__await).then(function(Ml) {
                            ki("next", Ml, qa, Us);
                          }, function(Ml) {
                            ki("throw", Ml, qa, Us);
                          }) : Ci.resolve(Al).then(function(Ml) {
                            jl.value = Ml, qa(jl);
                          }, function(Ml) {
                            return ki("throw", Ml, qa, Us);
                          });
                        }
                        Us(Hs.arg);
                      }
                      var Mo;
                      na(this, "_invoke", { value: function(Uo, qa) {
                        function Us() {
                          return new Ci(function(Hs, jl) {
                            ki(Uo, qa, Hs, jl);
                          });
                        }
                        return Mo = Mo ? Mo.then(Us, Us) : Us();
                      } });
                    }
                    function pc(Bi, Ci, ki) {
                      var Mo = Ql;
                      return function(Xo, Uo) {
                        if (Mo === Wu) throw Error("Generator is already running");
                        if (Mo === Kl) {
                          if (Xo === "throw") throw Uo;
                          return { value: Ai, done: !0 };
                        }
                        for (ki.method = Xo, ki.arg = Uo; ; ) {
                          var qa = ki.delegate;
                          if (qa) {
                            var Us = Zu(qa, ki);
                            if (Us) {
                              if (Us === pl) continue;
                              return Us;
                            }
                          }
                          if (ki.method === "next") ki.sent = ki._sent = ki.arg;
                          else if (ki.method === "throw") {
                            if (Mo === Ql) throw Mo = Kl, ki.arg;
                            ki.dispatchException(ki.arg);
                          } else ki.method === "return" && ki.abrupt("return", ki.arg);
                          Mo = Wu;
                          var Hs = ol(Bi, Ci, ki);
                          if (Hs.type === "normal") {
                            if (Mo = ki.done ? Kl : Uu, Hs.arg === pl) continue;
                            return { value: Hs.arg, done: ki.done };
                          }
                          Hs.type === "throw" && (Mo = Kl, ki.method = "throw", ki.arg = Hs.arg);
                        }
                      };
                    }
                    function Zu(Bi, Ci) {
                      var ki = Ci.method, Mo = Bi.iterator[ki];
                      if (Mo === Ai) return Ci.delegate = null, ki === "throw" && Bi.iterator.return && (Ci.method = "return", Ci.arg = Ai, Zu(Bi, Ci), Ci.method === "throw") || ki !== "return" && (Ci.method = "throw", Ci.arg = new TypeError("The iterator does not provide a '" + ki + "' method")), pl;
                      var Xo = ol(Mo, Bi.iterator, Ci.arg);
                      if (Xo.type === "throw") return Ci.method = "throw", Ci.arg = Xo.arg, Ci.delegate = null, pl;
                      var Uo = Xo.arg;
                      return Uo ? Uo.done ? (Ci[Bi.resultName] = Uo.value, Ci.next = Bi.nextLoc, Ci.method !== "return" && (Ci.method = "next", Ci.arg = Ai), Ci.delegate = null, pl) : Uo : (Ci.method = "throw", Ci.arg = new TypeError("iterator result is not an object"), Ci.delegate = null, pl);
                    }
                    function gc(Bi) {
                      var Ci = { tryLoc: Bi[0] };
                      1 in Bi && (Ci.catchLoc = Bi[1]), 2 in Bi && (Ci.finallyLoc = Bi[2], Ci.afterLoc = Bi[3]), this.tryEntries.push(Ci);
                    }
                    function Du(Bi) {
                      var Ci = Bi.completion || {};
                      Ci.type = "normal", delete Ci.arg, Bi.completion = Ci;
                    }
                    function ku(Bi) {
                      this.tryEntries = [{ tryLoc: "root" }], Bi.forEach(gc, this), this.reset(!0);
                    }
                    function Nu(Bi) {
                      if (Bi || Bi === "") {
                        var Ci = Bi[Fo];
                        if (Ci) return Ci.call(Bi);
                        if (typeof Bi.next == "function") return Bi;
                        if (!isNaN(Bi.length)) {
                          var ki = -1, Mo = function Xo() {
                            for (; ++ki < Bi.length; ) if (Gi.call(Bi, ki)) return Xo.value = Bi[ki], Xo.done = !1, Xo;
                            return Xo.value = Ai, Xo.done = !0, Xo;
                          };
                          return Mo.next = Mo;
                        }
                      }
                      throw new TypeError(typeof Bi + " is not iterable");
                    }
                    return lu.prototype = Nl, na(zl, "constructor", { value: Nl, configurable: !0 }), na(Nl, "constructor", { value: lu, configurable: !0 }), lu.displayName = wa(Nl, Va, "GeneratorFunction"), _i.isGeneratorFunction = function(Bi) {
                      var Ci = typeof Bi == "function" && Bi.constructor;
                      return !!Ci && (Ci === lu || (Ci.displayName || Ci.name) === "GeneratorFunction");
                    }, _i.mark = function(Bi) {
                      return Object.setPrototypeOf ? Object.setPrototypeOf(Bi, Nl) : (Bi.__proto__ = Nl, wa(Bi, Va, "GeneratorFunction")), Bi.prototype = Object.create(zl), Bi;
                    }, _i.awrap = function(Bi) {
                      return { __await: Bi };
                    }, Qu(gu.prototype), wa(gu.prototype, Wa, function() {
                      return this;
                    }), _i.AsyncIterator = gu, _i.async = function(Bi, Ci, ki, Mo, Xo) {
                      Xo === void 0 && (Xo = Promise);
                      var Uo = new gu(il(Bi, Ci, ki, Mo), Xo);
                      return _i.isGeneratorFunction(Ci) ? Uo : Uo.next().then(function(qa) {
                        return qa.done ? qa.value : Uo.next();
                      });
                    }, Qu(zl), wa(zl, Va, "Generator"), wa(zl, Fo, function() {
                      return this;
                    }), wa(zl, "toString", function() {
                      return "[object Generator]";
                    }), _i.keys = function(Bi) {
                      var Ci = Object(Bi), ki = [];
                      for (var Mo in Ci) ki.push(Mo);
                      return ki.reverse(), function Xo() {
                        for (; ki.length; ) {
                          var Uo = ki.pop();
                          if (Uo in Ci) return Xo.value = Uo, Xo.done = !1, Xo;
                        }
                        return Xo.done = !0, Xo;
                      };
                    }, _i.values = Nu, ku.prototype = { constructor: ku, reset: function(Ci) {
                      if (this.prev = 0, this.next = 0, this.sent = this._sent = Ai, this.done = !1, this.delegate = null, this.method = "next", this.arg = Ai, this.tryEntries.forEach(Du), !Ci) for (var ki in this) ki.charAt(0) === "t" && Gi.call(this, ki) && !isNaN(+ki.slice(1)) && (this[ki] = Ai);
                    }, stop: function() {
                      this.done = !0;
                      var Ci = this.tryEntries[0].completion;
                      if (Ci.type === "throw") throw Ci.arg;
                      return this.rval;
                    }, dispatchException: function(Ci) {
                      if (this.done) throw Ci;
                      var ki = this;
                      function Mo(jl, Al) {
                        return qa.type = "throw", qa.arg = Ci, ki.next = jl, Al && (ki.method = "next", ki.arg = Ai), !!Al;
                      }
                      for (var Xo = this.tryEntries.length - 1; Xo >= 0; --Xo) {
                        var Uo = this.tryEntries[Xo], qa = Uo.completion;
                        if (Uo.tryLoc === "root") return Mo("end");
                        if (Uo.tryLoc <= this.prev) {
                          var Us = Gi.call(Uo, "catchLoc"), Hs = Gi.call(Uo, "finallyLoc");
                          if (Us && Hs) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          } else if (Us) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                          } else {
                            if (!Hs) throw Error("try statement without catch or finally");
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          }
                        }
                      }
                    }, abrupt: function(Ci, ki) {
                      for (var Mo = this.tryEntries.length - 1; Mo >= 0; --Mo) {
                        var Xo = this.tryEntries[Mo];
                        if (Xo.tryLoc <= this.prev && Gi.call(Xo, "finallyLoc") && this.prev < Xo.finallyLoc) {
                          var Uo = Xo;
                          break;
                        }
                      }
                      Uo && (Ci === "break" || Ci === "continue") && Uo.tryLoc <= ki && ki <= Uo.finallyLoc && (Uo = null);
                      var qa = Uo ? Uo.completion : {};
                      return qa.type = Ci, qa.arg = ki, Uo ? (this.method = "next", this.next = Uo.finallyLoc, pl) : this.complete(qa);
                    }, complete: function(Ci, ki) {
                      if (Ci.type === "throw") throw Ci.arg;
                      return Ci.type === "break" || Ci.type === "continue" ? this.next = Ci.arg : Ci.type === "return" ? (this.rval = this.arg = Ci.arg, this.method = "return", this.next = "end") : Ci.type === "normal" && ki && (this.next = ki), pl;
                    }, finish: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.finallyLoc === Ci) return this.complete(Mo.completion, Mo.afterLoc), Du(Mo), pl;
                      }
                    }, catch: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.tryLoc === Ci) {
                          var Xo = Mo.completion;
                          if (Xo.type === "throw") {
                            var Uo = Xo.arg;
                            Du(Mo);
                          }
                          return Uo;
                        }
                      }
                      throw Error("illegal catch attempt");
                    }, delegateYield: function(Ci, ki, Mo) {
                      return this.delegate = { iterator: Nu(Ci), resultName: ki, nextLoc: Mo }, this.method === "next" && (this.arg = Ai), pl;
                    } }, _i;
                  }
                  function ep(Ai, _i, Po, Gi, na, ta, Fo) {
                    try {
                      var Wa = Ai[ta](Fo), Va = Wa.value;
                    } catch (wa) {
                      return void Po(wa);
                    }
                    Wa.done ? _i(Va) : Promise.resolve(Va).then(Gi, na);
                  }
                  function Mf(Ai) {
                    return function() {
                      var _i = this, Po = arguments;
                      return new Promise(function(Gi, na) {
                        var ta = Ai.apply(_i, Po);
                        function Fo(Va) {
                          ep(ta, Gi, na, Fo, Wa, "next", Va);
                        }
                        function Wa(Va) {
                          ep(ta, Gi, na, Fo, Wa, "throw", Va);
                        }
                        Fo(void 0);
                      });
                    };
                  }
                  function Kh(Ai, _i) {
                    if (!(Ai instanceof _i)) throw new TypeError("Cannot call a class as a function");
                  }
                  function pd(Ai, _i) {
                    for (var Po = 0; Po < _i.length; Po++) {
                      var Gi = _i[Po];
                      Gi.enumerable = Gi.enumerable || !1, Gi.configurable = !0, "value" in Gi && (Gi.writable = !0), Object.defineProperty(Ai, Vd(Gi.key), Gi);
                    }
                  }
                  function Cc(Ai, _i, Po) {
                    return _i && pd(Ai.prototype, _i), Po && pd(Ai, Po), Object.defineProperty(Ai, "prototype", { writable: !1 }), Ai;
                  }
                  function jf(Ai, _i, Po) {
                    return _i = Ff(_i), tp(Ai, fh() ? Reflect.construct(_i, Po || [], Ff(Ai).constructor) : _i.apply(Ai, Po));
                  }
                  function tp(Ai, _i) {
                    if (_i && (typeof _i == "object" || typeof _i == "function")) return _i;
                    if (_i !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return Fp(Ai);
                  }
                  function Fp(Ai) {
                    if (Ai === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return Ai;
                  }
                  function fh() {
                    try {
                      var Ai = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                      }));
                    } catch {
                    }
                    return (fh = function() {
                      return !!Ai;
                    })();
                  }
                  function Qc(Ai, _i, Po, Gi) {
                    var na = Tc(Ff(Ai.prototype), _i, Po);
                    return 2 & Gi && typeof na == "function" ? function(ta) {
                      return na.apply(Po, ta);
                    } : na;
                  }
                  function Tc() {
                    return Tc = typeof Reflect < "u" && Reflect.get ? Reflect.get.bind() : function(Ai, _i, Po) {
                      var Gi = Ud(Ai, _i);
                      if (Gi) {
                        var na = Object.getOwnPropertyDescriptor(Gi, _i);
                        return na.get ? na.get.call(arguments.length < 3 ? Ai : Po) : na.value;
                      }
                    }, Tc.apply(null, arguments);
                  }
                  function Ud(Ai, _i) {
                    for (; !{}.hasOwnProperty.call(Ai, _i) && (Ai = Ff(Ai)) !== null; ) ;
                    return Ai;
                  }
                  function Ff(Ai) {
                    return Ff = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(_i) {
                      return _i.__proto__ || Object.getPrototypeOf(_i);
                    }, Ff(Ai);
                  }
                  function Kc(Ai, _i) {
                    if (typeof _i != "function" && _i !== null) throw new TypeError("Super expression must either be null or a function");
                    Ai.prototype = Object.create(_i && _i.prototype, { constructor: { value: Ai, writable: !0, configurable: !0 } }), Object.defineProperty(Ai, "prototype", { writable: !1 }), _i && vf(Ai, _i);
                  }
                  function vf(Ai, _i) {
                    return vf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(Po, Gi) {
                      return Po.__proto__ = Gi, Po;
                    }, vf(Ai, _i);
                  }
                  function mp(Ai, _i, Po) {
                    return (_i = Vd(_i)) in Ai ? Object.defineProperty(Ai, _i, { value: Po, enumerable: !0, configurable: !0, writable: !0 }) : Ai[_i] = Po, Ai;
                  }
                  function Vd(Ai) {
                    var _i = Wd(Ai, "string");
                    return typeof _i == "symbol" ? _i : _i + "";
                  }
                  function Wd(Ai, _i) {
                    if (typeof Ai != "object" || !Ai) return Ai;
                    var Po = Ai[Symbol.toPrimitive];
                    if (Po !== void 0) {
                      var Gi = Po.call(Ai, _i);
                      if (typeof Gi != "object") return Gi;
                      throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (_i === "string" ? String : Number)(Ai);
                  }
                  var Bp = 5, $d = /* @__PURE__ */ (function(Ai) {
                    function _i(Po, Gi, na) {
                      var ta;
                      if (Kh(this, _i), ta = jf(this, _i, [Po, Gi, na]), !na)
                        throw new Error("Tried to instantiate a RouterTransactionManager without a routerIframeManager!");
                      return ta.routerIframeManager = na, ta.isHalting = !1, ta.isHalted = !1, ta.iframeWasDestroyedExternally = !1, ta.publishHandlers = {}, ta.pendingTransactions = {}, ta.subscribeHandlers = {}, ta.unsubscribeHandlers = {}, ta.unsubscribesInProgress = {}, ta.TRANSACTION_TIMEOUT = Bp, ta.routerIframeManager.on(Bd.events.IFRAME_DESTROYED_EXTERNALLY, function() {
                        ta.iframeWasDestroyedExternally = !0;
                      }), ta;
                    }
                    return Kc(_i, Ai), Cc(_i, [{
                      key: "issueCommand",
                      value: function(Gi) {
                        var na = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                        if (this.isDestroyed) {
                          this.logger.warn('Cannot issue command "'.concat(Gi, '" to Router after destruction'));
                          return;
                        }
                        this.logger.debug("Issuing command ".concat(Gi, " to Router...")), this.routerIframeManager.command(Gi, na);
                      }
                    }, {
                      key: "_formatTransactionResponsePayload",
                      value: function(Gi) {
                        var na = Gi.payloadString;
                        if (Gi.payloadString)
                          try {
                            Gi.payloadString = JSON.parse(na) || {};
                          } catch (ta) {
                            this.logger.warn("Failed to parse payloadString"), this.logger.warn(ta), Gi.payloadString = na;
                          }
                        return Gi;
                      }
                      /**
                       * Request
                       *
                       * When asking the server for something, we do not get a response right away.
                       * Instead, we must perform the following steps:
                       *
                       * 1. generate a unique string, which will be sent to the server as the "response topic"
                       * 1. subscribe
                       *
                       * @todo - this needs to be refactored to use PromiseTimeout
                       *
                       * @param {String} topic
                       *   The topic to perform a transaction on
                       * @param {Object} messageData
                       *   The data to be published
                       *
                       * @returns {Promise}
                       *   Resolves when the transaction successfully finishes
                       *   Rejects if there is any error or timeout during the transaction
                       */
                    }, {
                      key: "transaction",
                      value: function(Gi) {
                        var na = this, ta = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Fo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.TRANSACTION_TIMEOUT, Wa = arguments.length > 3 ? arguments[3] : void 0;
                        this.logger.debug("transaction for ".concat(Gi, "..."));
                        var Va = Is();
                        return Wa || (Wa = "".concat(this.clientId, "/transaction/").concat(Va), ta.resp_topic = Wa), this.pendingTransactions[Va] = {
                          id: Va,
                          hasTimedOut: !1,
                          timeout: null
                        }, new Promise(/* @__PURE__ */ (function() {
                          var wa = Mf(/* @__PURE__ */ Jc().mark(function il(ol, Ql) {
                            var Uu;
                            return Jc().wrap(function(Kl) {
                              for (; ; ) switch (Kl.prev = Kl.next) {
                                case 0:
                                  return Uu = /* @__PURE__ */ (function() {
                                    var pl = Mf(/* @__PURE__ */ Jc().mark(function pu(lu, Nl) {
                                      return Jc().wrap(function(wu) {
                                        for (; ; ) switch (wu.prev = wu.next) {
                                          case 0:
                                            return wu.prev = 0, wu.next = 3, na.unsubscribe(Wa);
                                          case 3:
                                            if (na.pendingTransactions[Va].timeout && (clearTimeout(na.pendingTransactions[Va].timeout), na.pendingTransactions[Va].timeout = null), !lu) {
                                              wu.next = 6;
                                              break;
                                            }
                                            throw lu;
                                          case 6:
                                            ol(na._formatTransactionResponsePayload(Nl)), wu.next = 12;
                                            break;
                                          case 9:
                                            wu.prev = 9, wu.t0 = wu.catch(0), Ql(wu.t0);
                                          case 12:
                                          case "end":
                                            return wu.stop();
                                        }
                                      }, pu, null, [[0, 9]]);
                                    }));
                                    return function(lu, Nl) {
                                      return pl.apply(this, arguments);
                                    };
                                  })(), Kl.prev = 1, na.pendingTransactions[Va].timeout = setTimeout(function() {
                                    if (!na.pendingTransactions || !na.pendingTransactions[Va]) {
                                      na.logger.warn("Pending transaction for ".concat(Va, " was not cancelled..."));
                                      return;
                                    }
                                    na.pendingTransactions[Va].hasTimedOut || (na.pendingTransactions[Va].hasTimedOut = !0, Uu(new Error("Transaction for ".concat(Gi, " timed out after ").concat(Fo, " seconds"))));
                                  }, Fo * 1e3), na.subscribe(Wa, function(pl) {
                                    Uu(null, pl);
                                  }), Kl.next = 6, na.publish(Gi, ta);
                                case 6:
                                  Kl.next = 11;
                                  break;
                                case 8:
                                  Kl.prev = 8, Kl.t0 = Kl.catch(1), Uu(Kl.t0);
                                case 11:
                                case "end":
                                  return Kl.stop();
                              }
                            }, il, null, [[1, 8]]);
                          }));
                          return function(il, ol) {
                            return wa.apply(this, arguments);
                          };
                        })());
                      }
                      /**
                       * @async
                       *
                       * Publishing something to the CLSP server means that you send a request and
                       * get a confirmation of deliver from Paho.  It's different from the
                       * transaction in that you do not need to subscribe to a topic to get a
                       * response/ack from the server (because you don't expect a response from the
                       * server).  All transactions use publish in addition to sub/unsub.
                       *
                       * Publish actions include:
                       * - stopping a stream
                       * - sending stats
                       *
                       * @param {String} topic
                       *   The topic to publish to
                       * @param {Object} data
                       *   The data to publish
                       *
                       * @returns {Promise}
                       *   Resolves when publish operation is successful
                       *   Rejects when publish operation fails
                       */
                    }, {
                      key: "publish",
                      value: (function() {
                        var Po = Mf(/* @__PURE__ */ Jc().mark(function na(ta, Fo) {
                          var Wa, Va, wa = arguments;
                          return Jc().wrap(function(ol) {
                            for (; ; ) switch (ol.prev = ol.next) {
                              case 0:
                                if (Wa = wa.length > 2 && wa[2] !== void 0 ? wa[2] : this.TRANSACTION_TIMEOUT, !this.isDestroyComplete) {
                                  ol.next = 4;
                                  break;
                                }
                                return this.logger.info('Tried to publish to topic "'.concat(ta, '" while destroyed')), ol.abrupt("return");
                              case 4:
                                return this.logger.debug('Publishing to topic "'.concat(ta, '"')), Va = Is(), ol.prev = 6, ol.next = 9, (0, Ws.w)(this._publish(Va, ta, Fo), Wa * 1e3);
                              case 9:
                                this.logger.info('Successfully published to topic "'.concat(ta, '" with id "').concat(Va, '"')), ol.next = 26;
                                break;
                              case 12:
                                if (ol.prev = 12, ol.t0 = ol.catch(6), !this.isDestroyed) {
                                  ol.next = 17;
                                  break;
                                }
                                return this.logger.info('Publish to topic "'.concat(ta, '" with id "').concat(Va, '" failed while destroying')), ol.abrupt("return");
                              case 17:
                                if (!(this.isHalting || this.isHalted)) {
                                  ol.next = 20;
                                  break;
                                }
                                return this.logger.info('Publish to topic "'.concat(ta, '" with id "').concat(Va, '" failed while halting/halted')), ol.abrupt("return");
                              case 20:
                                if (!this.iframeWasDestroyedExternally) {
                                  ol.next = 23;
                                  break;
                                }
                                return this.logger.info('Publish to topic "'.concat(ta, '" with id "').concat(Va, '" failed while iframe was destroyed externally')), ol.abrupt("return");
                              case 23:
                                throw this.logger.error('Failed to publish to topic "'.concat(ta, '" with id "').concat(Va, '"')), this.logger.error(ol.t0), ol.t0;
                              case 26:
                                return ol.prev = 26, delete this.publishHandlers[Va], ol.finish(26);
                              case 29:
                              case "end":
                                return ol.stop();
                            }
                          }, na, this, [[6, 12, 26, 29]]);
                        }));
                        function Gi(na, ta) {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "_publish",
                      value: function(Gi, na, ta) {
                        var Fo = this;
                        return new Promise(function(Wa, Va) {
                          Fo.publishHandlers[Gi] = function(wa) {
                            if (wa)
                              return Va(wa);
                            Wa();
                          }, Fo.issueCommand(_i.routerCommands.PUBLISH, {
                            publishId: Gi,
                            topic: na,
                            data: ta
                          });
                        });
                      }
                    }, {
                      key: "_handlePublishRouterEvent",
                      value: function(Gi, na) {
                        var ta = na.data.publishId;
                        if (!ta)
                          throw new Error("Cannot handle publish event without publishId");
                        if (!this.publishHandlers[ta]) {
                          this.logger.warn('No handler for publishId "'.concat(ta, '" for publish event "').concat(Gi, '"'));
                          return;
                        }
                        switch (Gi) {
                          case _i.routerEvents.PUBLISH_SUCCESS: {
                            this.publishHandlers[ta]();
                            break;
                          }
                          case _i.routerEvents.PUBLISH_FAILURE: {
                            this.publishHandlers[ta](new Error(na.data.reason));
                            break;
                          }
                          default:
                            throw new Error("Unknown eventType: ".concat(Gi));
                        }
                      }
                      /**
                       * Register a handler that will being listening to a topic until that topic
                       * is unsubscribed from.
                       *
                       * Note that currently, the only use cases for a "persistent" subscription
                       * are stream resync and the actual stream itself.  All other subscribe use
                       * cases are transactional, and therefore use the `transaction` method.  Use
                       * this `subscribe` method cautiously / sparingly.
                       *
                       * @param {String} topic
                       *   The topic to subscribe to
                       * @param {RouterTransactionManager-subscribeHandler} handler
                       *   The callback for the subscribe operation
                       */
                    }, {
                      key: "subscribe",
                      value: function(Gi, na) {
                        this.logger.debug('Subscribing to topic "'.concat(Gi, '"')), this.subscribeHandlers[Gi] = na, this.issueCommand(_i.routerCommands.SUBSCRIBE, {
                          topic: Gi
                        });
                      }
                    }, {
                      key: "_handleMessageArrivedRouterEvent",
                      value: function(Gi, na) {
                        if (this.isDestroyComplete)
                          throw new Error("Tried to handle Router message arrived event after destroy was complete!");
                        var ta = na.data, Fo = ta.destinationName;
                        if (!Fo)
                          throw new Error("Cannot handle subscribe event without a topic");
                        if (!this.subscribeHandlers[Fo]) {
                          this.logger.info('No handler for subscribe topic "'.concat(Fo, '" for message event "').concat(Gi, '"'));
                          return;
                        }
                        switch (Gi) {
                          case _i.routerEvents.MESSAGE_ARRIVED: {
                            this.subscribeHandlers[Fo](ta, na);
                            break;
                          }
                          default:
                            throw new Error("Unknown eventType: ".concat(Gi));
                        }
                      }
                      /**
                       * @async
                       *
                       * Stop listening to a topic
                       *
                       * @param {String} topic
                       *   The topic to unsubscribe from
                       */
                    }, {
                      key: "unsubscribe",
                      value: (function() {
                        var Po = Mf(/* @__PURE__ */ Jc().mark(function na(ta) {
                          var Fo, Wa = arguments;
                          return Jc().wrap(function(wa) {
                            for (; ; ) switch (wa.prev = wa.next) {
                              case 0:
                                if (Fo = Wa.length > 1 && Wa[1] !== void 0 ? Wa[1] : this.TRANSACTION_TIMEOUT, !this.isDestroyComplete) {
                                  wa.next = 4;
                                  break;
                                }
                                return this.logger.info('Tried to unsubscribe from topic "'.concat(ta, '" while destroyed')), wa.abrupt("return");
                              case 4:
                                if (!this.unsubscribesInProgress[ta]) {
                                  wa.next = 7;
                                  break;
                                }
                                return this.logger.info("Already unsubscribing from ".concat(ta)), wa.abrupt("return");
                              case 7:
                                return this.logger.debug('Unsubscribing from topic "'.concat(ta, '"')), wa.prev = 8, delete this.subscribeHandlers[ta], this.unsubscribesInProgress[ta] = !0, wa.next = 13, (0, Ws.w)(this._unsubscribe(ta), Fo * 1e3);
                              case 13:
                                this.logger.info('Successfully unsubscribed from topic "'.concat(ta, '"')), wa.next = 29;
                                break;
                              case 16:
                                if (wa.prev = 16, wa.t0 = wa.catch(8), !this.isDestroyed) {
                                  wa.next = 21;
                                  break;
                                }
                                return this.logger.info('Unsubscribe from topic "'.concat(ta, '" failed while destroying')), wa.abrupt("return");
                              case 21:
                                if (!(this.isHalting || this.isHalted)) {
                                  wa.next = 24;
                                  break;
                                }
                                return this.logger.info('Unsubscribe from topic "'.concat(ta, '" failed while halting/halted')), wa.abrupt("return");
                              case 24:
                                if (!this.iframeWasDestroyedExternally) {
                                  wa.next = 27;
                                  break;
                                }
                                return this.logger.info('Unsubscribe from topic "'.concat(ta, '" failed while iframe was destroyed externally')), wa.abrupt("return");
                              case 27:
                                throw this.logger.info('Failed to unsubscribe from topic "'.concat(ta, '"')), wa.t0;
                              case 29:
                                return wa.prev = 29, delete this.unsubscribesInProgress[ta], delete this.unsubscribeHandlers[ta], wa.finish(29);
                              case 33:
                              case "end":
                                return wa.stop();
                            }
                          }, na, this, [[8, 16, 29, 33]]);
                        }));
                        function Gi(na) {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "_unsubscribe",
                      value: function(Gi) {
                        var na = this;
                        return new Promise(function(ta, Fo) {
                          na.unsubscribeHandlers[Gi] = function(Wa) {
                            if (Wa)
                              return Fo(Wa);
                            ta();
                          }, na.issueCommand(_i.routerCommands.UNSUBSCRIBE, {
                            topic: Gi
                          });
                        });
                      }
                    }, {
                      key: "_handleUnsubscribeRouterEvent",
                      value: function(Gi, na) {
                        var ta = na.data.topic;
                        if (this.isDestroyComplete)
                          throw new Error("Tried to check unsubscribe handler after destroy was complete!");
                        if (!ta)
                          throw new Error("Cannot handle unsubscribe event without a topic");
                        if (!this.unsubscribeHandlers[ta]) {
                          this.logger.warn('No handler for topic "'.concat(ta, '" for unsubscribe event "').concat(Gi, '"'));
                          return;
                        }
                        switch (Gi) {
                          case _i.routerEvents.UNSUBSCRIBE_SUCCESS: {
                            this.unsubscribeHandlers[ta]();
                            break;
                          }
                          case _i.routerEvents.UNSUBSCRIBE_FAILURE: {
                            this.unsubscribeHandlers[ta](new Error(na.data.reason));
                            break;
                          }
                          default:
                            throw new Error("Unknown eventType: ".concat(Gi));
                        }
                      }
                    }, {
                      key: "onRouterEvent",
                      value: function(Gi, na) {
                        if (this.isDestroyComplete)
                          throw new Error("Tried to handle Router event ".concat(Gi, " after destroy was complete!"));
                        switch (Gi) {
                          case _i.routerEvents.PUBLISH_SUCCESS:
                          case _i.routerEvents.PUBLISH_FAILURE: {
                            this._handlePublishRouterEvent(Gi, na);
                            break;
                          }
                          case _i.routerEvents.UNSUBSCRIBE_SUCCESS:
                          case _i.routerEvents.UNSUBSCRIBE_FAILURE: {
                            this._handleUnsubscribeRouterEvent(Gi, na);
                            break;
                          }
                          case _i.routerEvents.MESSAGE_ARRIVED: {
                            this._handleMessageArrivedRouterEvent(Gi, na);
                            break;
                          }
                          default:
                            throw new Error("Unknown eventType: ".concat(Gi));
                        }
                      }
                    }, {
                      key: "halt",
                      value: (function() {
                        var Po = Mf(/* @__PURE__ */ Jc().mark(function na() {
                          var ta = this, Fo, Wa, Va;
                          return Jc().wrap(function(il) {
                            for (; ; ) switch (il.prev = il.next) {
                              case 0:
                                if (!this.isDestroyed) {
                                  il.next = 3;
                                  break;
                                }
                                return this.logger.info("Tried to halt while destroyed"), il.abrupt("return");
                              case 3:
                                if (!(this.isHalting || this.isHalted)) {
                                  il.next = 6;
                                  break;
                                }
                                return this.logger.info("Tried to halt while halting/halted"), il.abrupt("return");
                              case 6:
                                this.logger.info("Halting all handlers..."), this.isHalting = !0;
                                for (Fo in this.pendingTransactions)
                                  Wa = this.pendingTransactions[Fo], Wa.timeout && (clearTimeout(Wa.timeout), Wa.timeout = null);
                                return this.pendingTransactions = {}, this.unsubscribeHandlers = {}, this.publishHandlers = {}, Va = Object.keys(this.subscribeHandlers), il.next = 15, Promise.allSettled(Va.map(function(ol) {
                                  return ta.unsubscribe(ol);
                                }));
                              case 15:
                                this.subscribeHandlers = {}, this.unsubscribesInProgress = {}, this.isHalting = !1, this.isHalted = !0, this.logger.info("Finished halting all handlers");
                              case 20:
                              case "end":
                                return il.stop();
                            }
                          }, na, this);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                      /**
                       * @todo - provide method description
                       *
                       * @todo - return a Promise
                       *
                       * @param {String} topic
                       *   The topic to send to
                       * @param {Array} byteArray
                       *   The raw data to send
                       */
                    }, {
                      key: "directSend",
                      value: function(Gi, na) {
                        this.logger.debug("directSend..."), this.issueCommand(_i.routerCommands.SEND, {
                          topic: Gi,
                          byteArray: na
                        });
                      }
                    }, {
                      key: "_destroy",
                      value: (function() {
                        var Po = Mf(/* @__PURE__ */ Jc().mark(function na() {
                          return Jc().wrap(function(Fo) {
                            for (; ; ) switch (Fo.prev = Fo.next) {
                              case 0:
                                return Fo.next = 2, this.halt();
                              case 2:
                                return this.pendingTransactions = null, this.unsubscribeHandlers = null, this.publishHandlers = null, this.subscribeHandlers = null, this.unsubscribesInProgress = null, Fo.next = 9, Qc(_i, "_destroy", this, 3)([]);
                              case 9:
                              case "end":
                                return Fo.stop();
                            }
                          }, na, this);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }], [{
                      key: "factory",
                      value: function(Gi, na, ta) {
                        return new _i(Gi, na, ta);
                      }
                    }]);
                  })(Ya);
                  mp($d, "routerEvents", {
                    PUBLISH_SUCCESS: Ya.routerEvents.PUBLISH_SUCCESS,
                    PUBLISH_FAILURE: Ya.routerEvents.PUBLISH_FAILURE,
                    UNSUBSCRIBE_SUCCESS: Ya.routerEvents.UNSUBSCRIBE_SUCCESS,
                    UNSUBSCRIBE_FAILURE: Ya.routerEvents.UNSUBSCRIBE_FAILURE,
                    MESSAGE_ARRIVED: Ya.routerEvents.MESSAGE_ARRIVED
                  });
                  function qc() {
                    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
                    qc = function() {
                      return _i;
                    };
                    var Ai, _i = {}, Po = Object.prototype, Gi = Po.hasOwnProperty, na = Object.defineProperty || function(Bi, Ci, ki) {
                      Bi[Ci] = ki.value;
                    }, ta = typeof Symbol == "function" ? Symbol : {}, Fo = ta.iterator || "@@iterator", Wa = ta.asyncIterator || "@@asyncIterator", Va = ta.toStringTag || "@@toStringTag";
                    function wa(Bi, Ci, ki) {
                      return Object.defineProperty(Bi, Ci, { value: ki, enumerable: !0, configurable: !0, writable: !0 }), Bi[Ci];
                    }
                    try {
                      wa({}, "");
                    } catch {
                      wa = function(ki, Mo, Xo) {
                        return ki[Mo] = Xo;
                      };
                    }
                    function il(Bi, Ci, ki, Mo) {
                      var Xo = Ci && Ci.prototype instanceof pu ? Ci : pu, Uo = Object.create(Xo.prototype), qa = new ku(Mo || []);
                      return na(Uo, "_invoke", { value: pc(Bi, ki, qa) }), Uo;
                    }
                    function ol(Bi, Ci, ki) {
                      try {
                        return { type: "normal", arg: Bi.call(Ci, ki) };
                      } catch (Mo) {
                        return { type: "throw", arg: Mo };
                      }
                    }
                    _i.wrap = il;
                    var Ql = "suspendedStart", Uu = "suspendedYield", Wu = "executing", Kl = "completed", pl = {};
                    function pu() {
                    }
                    function lu() {
                    }
                    function Nl() {
                    }
                    var Eu = {};
                    wa(Eu, Fo, function() {
                      return this;
                    });
                    var wu = Object.getPrototypeOf, yu = wu && wu(wu(Nu([])));
                    yu && yu !== Po && Gi.call(yu, Fo) && (Eu = yu);
                    var zl = Nl.prototype = pu.prototype = Object.create(Eu);
                    function Qu(Bi) {
                      ["next", "throw", "return"].forEach(function(Ci) {
                        wa(Bi, Ci, function(ki) {
                          return this._invoke(Ci, ki);
                        });
                      });
                    }
                    function gu(Bi, Ci) {
                      function ki(Xo, Uo, qa, Us) {
                        var Hs = ol(Bi[Xo], Bi, Uo);
                        if (Hs.type !== "throw") {
                          var jl = Hs.arg, Al = jl.value;
                          return Al && typeof Al == "object" && Gi.call(Al, "__await") ? Ci.resolve(Al.__await).then(function(Ml) {
                            ki("next", Ml, qa, Us);
                          }, function(Ml) {
                            ki("throw", Ml, qa, Us);
                          }) : Ci.resolve(Al).then(function(Ml) {
                            jl.value = Ml, qa(jl);
                          }, function(Ml) {
                            return ki("throw", Ml, qa, Us);
                          });
                        }
                        Us(Hs.arg);
                      }
                      var Mo;
                      na(this, "_invoke", { value: function(Uo, qa) {
                        function Us() {
                          return new Ci(function(Hs, jl) {
                            ki(Uo, qa, Hs, jl);
                          });
                        }
                        return Mo = Mo ? Mo.then(Us, Us) : Us();
                      } });
                    }
                    function pc(Bi, Ci, ki) {
                      var Mo = Ql;
                      return function(Xo, Uo) {
                        if (Mo === Wu) throw Error("Generator is already running");
                        if (Mo === Kl) {
                          if (Xo === "throw") throw Uo;
                          return { value: Ai, done: !0 };
                        }
                        for (ki.method = Xo, ki.arg = Uo; ; ) {
                          var qa = ki.delegate;
                          if (qa) {
                            var Us = Zu(qa, ki);
                            if (Us) {
                              if (Us === pl) continue;
                              return Us;
                            }
                          }
                          if (ki.method === "next") ki.sent = ki._sent = ki.arg;
                          else if (ki.method === "throw") {
                            if (Mo === Ql) throw Mo = Kl, ki.arg;
                            ki.dispatchException(ki.arg);
                          } else ki.method === "return" && ki.abrupt("return", ki.arg);
                          Mo = Wu;
                          var Hs = ol(Bi, Ci, ki);
                          if (Hs.type === "normal") {
                            if (Mo = ki.done ? Kl : Uu, Hs.arg === pl) continue;
                            return { value: Hs.arg, done: ki.done };
                          }
                          Hs.type === "throw" && (Mo = Kl, ki.method = "throw", ki.arg = Hs.arg);
                        }
                      };
                    }
                    function Zu(Bi, Ci) {
                      var ki = Ci.method, Mo = Bi.iterator[ki];
                      if (Mo === Ai) return Ci.delegate = null, ki === "throw" && Bi.iterator.return && (Ci.method = "return", Ci.arg = Ai, Zu(Bi, Ci), Ci.method === "throw") || ki !== "return" && (Ci.method = "throw", Ci.arg = new TypeError("The iterator does not provide a '" + ki + "' method")), pl;
                      var Xo = ol(Mo, Bi.iterator, Ci.arg);
                      if (Xo.type === "throw") return Ci.method = "throw", Ci.arg = Xo.arg, Ci.delegate = null, pl;
                      var Uo = Xo.arg;
                      return Uo ? Uo.done ? (Ci[Bi.resultName] = Uo.value, Ci.next = Bi.nextLoc, Ci.method !== "return" && (Ci.method = "next", Ci.arg = Ai), Ci.delegate = null, pl) : Uo : (Ci.method = "throw", Ci.arg = new TypeError("iterator result is not an object"), Ci.delegate = null, pl);
                    }
                    function gc(Bi) {
                      var Ci = { tryLoc: Bi[0] };
                      1 in Bi && (Ci.catchLoc = Bi[1]), 2 in Bi && (Ci.finallyLoc = Bi[2], Ci.afterLoc = Bi[3]), this.tryEntries.push(Ci);
                    }
                    function Du(Bi) {
                      var Ci = Bi.completion || {};
                      Ci.type = "normal", delete Ci.arg, Bi.completion = Ci;
                    }
                    function ku(Bi) {
                      this.tryEntries = [{ tryLoc: "root" }], Bi.forEach(gc, this), this.reset(!0);
                    }
                    function Nu(Bi) {
                      if (Bi || Bi === "") {
                        var Ci = Bi[Fo];
                        if (Ci) return Ci.call(Bi);
                        if (typeof Bi.next == "function") return Bi;
                        if (!isNaN(Bi.length)) {
                          var ki = -1, Mo = function Xo() {
                            for (; ++ki < Bi.length; ) if (Gi.call(Bi, ki)) return Xo.value = Bi[ki], Xo.done = !1, Xo;
                            return Xo.value = Ai, Xo.done = !0, Xo;
                          };
                          return Mo.next = Mo;
                        }
                      }
                      throw new TypeError(typeof Bi + " is not iterable");
                    }
                    return lu.prototype = Nl, na(zl, "constructor", { value: Nl, configurable: !0 }), na(Nl, "constructor", { value: lu, configurable: !0 }), lu.displayName = wa(Nl, Va, "GeneratorFunction"), _i.isGeneratorFunction = function(Bi) {
                      var Ci = typeof Bi == "function" && Bi.constructor;
                      return !!Ci && (Ci === lu || (Ci.displayName || Ci.name) === "GeneratorFunction");
                    }, _i.mark = function(Bi) {
                      return Object.setPrototypeOf ? Object.setPrototypeOf(Bi, Nl) : (Bi.__proto__ = Nl, wa(Bi, Va, "GeneratorFunction")), Bi.prototype = Object.create(zl), Bi;
                    }, _i.awrap = function(Bi) {
                      return { __await: Bi };
                    }, Qu(gu.prototype), wa(gu.prototype, Wa, function() {
                      return this;
                    }), _i.AsyncIterator = gu, _i.async = function(Bi, Ci, ki, Mo, Xo) {
                      Xo === void 0 && (Xo = Promise);
                      var Uo = new gu(il(Bi, Ci, ki, Mo), Xo);
                      return _i.isGeneratorFunction(Ci) ? Uo : Uo.next().then(function(qa) {
                        return qa.done ? qa.value : Uo.next();
                      });
                    }, Qu(zl), wa(zl, Va, "Generator"), wa(zl, Fo, function() {
                      return this;
                    }), wa(zl, "toString", function() {
                      return "[object Generator]";
                    }), _i.keys = function(Bi) {
                      var Ci = Object(Bi), ki = [];
                      for (var Mo in Ci) ki.push(Mo);
                      return ki.reverse(), function Xo() {
                        for (; ki.length; ) {
                          var Uo = ki.pop();
                          if (Uo in Ci) return Xo.value = Uo, Xo.done = !1, Xo;
                        }
                        return Xo.done = !0, Xo;
                      };
                    }, _i.values = Nu, ku.prototype = { constructor: ku, reset: function(Ci) {
                      if (this.prev = 0, this.next = 0, this.sent = this._sent = Ai, this.done = !1, this.delegate = null, this.method = "next", this.arg = Ai, this.tryEntries.forEach(Du), !Ci) for (var ki in this) ki.charAt(0) === "t" && Gi.call(this, ki) && !isNaN(+ki.slice(1)) && (this[ki] = Ai);
                    }, stop: function() {
                      this.done = !0;
                      var Ci = this.tryEntries[0].completion;
                      if (Ci.type === "throw") throw Ci.arg;
                      return this.rval;
                    }, dispatchException: function(Ci) {
                      if (this.done) throw Ci;
                      var ki = this;
                      function Mo(jl, Al) {
                        return qa.type = "throw", qa.arg = Ci, ki.next = jl, Al && (ki.method = "next", ki.arg = Ai), !!Al;
                      }
                      for (var Xo = this.tryEntries.length - 1; Xo >= 0; --Xo) {
                        var Uo = this.tryEntries[Xo], qa = Uo.completion;
                        if (Uo.tryLoc === "root") return Mo("end");
                        if (Uo.tryLoc <= this.prev) {
                          var Us = Gi.call(Uo, "catchLoc"), Hs = Gi.call(Uo, "finallyLoc");
                          if (Us && Hs) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          } else if (Us) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                          } else {
                            if (!Hs) throw Error("try statement without catch or finally");
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          }
                        }
                      }
                    }, abrupt: function(Ci, ki) {
                      for (var Mo = this.tryEntries.length - 1; Mo >= 0; --Mo) {
                        var Xo = this.tryEntries[Mo];
                        if (Xo.tryLoc <= this.prev && Gi.call(Xo, "finallyLoc") && this.prev < Xo.finallyLoc) {
                          var Uo = Xo;
                          break;
                        }
                      }
                      Uo && (Ci === "break" || Ci === "continue") && Uo.tryLoc <= ki && ki <= Uo.finallyLoc && (Uo = null);
                      var qa = Uo ? Uo.completion : {};
                      return qa.type = Ci, qa.arg = ki, Uo ? (this.method = "next", this.next = Uo.finallyLoc, pl) : this.complete(qa);
                    }, complete: function(Ci, ki) {
                      if (Ci.type === "throw") throw Ci.arg;
                      return Ci.type === "break" || Ci.type === "continue" ? this.next = Ci.arg : Ci.type === "return" ? (this.rval = this.arg = Ci.arg, this.method = "return", this.next = "end") : Ci.type === "normal" && ki && (this.next = ki), pl;
                    }, finish: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.finallyLoc === Ci) return this.complete(Mo.completion, Mo.afterLoc), Du(Mo), pl;
                      }
                    }, catch: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.tryLoc === Ci) {
                          var Xo = Mo.completion;
                          if (Xo.type === "throw") {
                            var Uo = Xo.arg;
                            Du(Mo);
                          }
                          return Uo;
                        }
                      }
                      throw Error("illegal catch attempt");
                    }, delegateYield: function(Ci, ki, Mo) {
                      return this.delegate = { iterator: Nu(Ci), resultName: ki, nextLoc: Mo }, this.method === "next" && (this.arg = Ai), pl;
                    } }, _i;
                  }
                  function vp(Ai, _i, Po, Gi, na, ta, Fo) {
                    try {
                      var Wa = Ai[ta](Fo), Va = Wa.value;
                    } catch (wa) {
                      return void Po(wa);
                    }
                    Wa.done ? _i(Va) : Promise.resolve(Va).then(Gi, na);
                  }
                  function Gd(Ai) {
                    return function() {
                      var _i = this, Po = arguments;
                      return new Promise(function(Gi, na) {
                        var ta = Ai.apply(_i, Po);
                        function Fo(Va) {
                          vp(ta, Gi, na, Fo, Wa, "next", Va);
                        }
                        function Wa(Va) {
                          vp(ta, Gi, na, Fo, Wa, "throw", Va);
                        }
                        Fo(void 0);
                      });
                    };
                  }
                  function yf(Ai, _i) {
                    if (!(Ai instanceof _i)) throw new TypeError("Cannot call a class as a function");
                  }
                  function rp(Ai, _i) {
                    for (var Po = 0; Po < _i.length; Po++) {
                      var Gi = _i[Po];
                      Gi.enumerable = Gi.enumerable || !1, Gi.configurable = !0, "value" in Gi && (Gi.writable = !0), Object.defineProperty(Ai, Hd(Gi.key), Gi);
                    }
                  }
                  function Up(Ai, _i, Po) {
                    return _i && rp(Ai.prototype, _i), Po && rp(Ai, Po), Object.defineProperty(Ai, "prototype", { writable: !1 }), Ai;
                  }
                  function ph(Ai, _i, Po) {
                    return _i = Zc(_i), hh(Ai, Ic() ? Reflect.construct(_i, Po || [], Zc(Ai).constructor) : _i.apply(Ai, Po));
                  }
                  function hh(Ai, _i) {
                    if (_i && (typeof _i == "object" || typeof _i == "function")) return _i;
                    if (_i !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return af(Ai);
                  }
                  function af(Ai) {
                    if (Ai === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return Ai;
                  }
                  function Ic() {
                    try {
                      var Ai = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                      }));
                    } catch {
                    }
                    return (Ic = function() {
                      return !!Ai;
                    })();
                  }
                  function qh(Ai, _i, Po, Gi) {
                    var na = Ec(Zc(Ai.prototype), _i, Po);
                    return 2 & Gi && typeof na == "function" ? function(ta) {
                      return na.apply(Po, ta);
                    } : na;
                  }
                  function Ec() {
                    return Ec = typeof Reflect < "u" && Reflect.get ? Reflect.get.bind() : function(Ai, _i, Po) {
                      var Gi = gh(Ai, _i);
                      if (Gi) {
                        var na = Object.getOwnPropertyDescriptor(Gi, _i);
                        return na.get ? na.get.call(arguments.length < 3 ? Ai : Po) : na.value;
                      }
                    }, Ec.apply(null, arguments);
                  }
                  function gh(Ai, _i) {
                    for (; !{}.hasOwnProperty.call(Ai, _i) && (Ai = Zc(Ai)) !== null; ) ;
                    return Ai;
                  }
                  function Zc(Ai) {
                    return Zc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(_i) {
                      return _i.__proto__ || Object.getPrototypeOf(_i);
                    }, Zc(Ai);
                  }
                  function mh(Ai, _i) {
                    if (typeof _i != "function" && _i !== null) throw new TypeError("Super expression must either be null or a function");
                    Ai.prototype = Object.create(_i && _i.prototype, { constructor: { value: Ai, writable: !0, configurable: !0 } }), Object.defineProperty(Ai, "prototype", { writable: !1 }), _i && Bf(Ai, _i);
                  }
                  function Bf(Ai, _i) {
                    return Bf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(Po, Gi) {
                      return Po.__proto__ = Gi, Po;
                    }, Bf(Ai, _i);
                  }
                  function ou(Ai, _i, Po) {
                    return (_i = Hd(_i)) in Ai ? Object.defineProperty(Ai, _i, { value: Po, enumerable: !0, configurable: !0, writable: !0 }) : Ai[_i] = Po, Ai;
                  }
                  function Hd(Ai) {
                    var _i = yp(Ai, "string");
                    return typeof _i == "symbol" ? _i : _i + "";
                  }
                  function yp(Ai, _i) {
                    if (typeof Ai != "object" || !Ai) return Ai;
                    var Po = Ai[Symbol.toPrimitive];
                    if (Po !== void 0) {
                      var Gi = Po.call(Ai, _i);
                      if (typeof Gi != "object") return Gi;
                      throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (_i === "string" ? String : Number)(Ai);
                  }
                  var bf = io().DEFAULT_STREAM_TIMEOUT, Tf = io().DEFAULT_STREAM_TIMEOUT, bp = io().DEFAULT_STREAM_TIMEOUT, od = io().DEFAULT_STREAM_TIMEOUT, ad = /* @__PURE__ */ (function(Ai) {
                    function _i(Po, Gi, na, ta) {
                      var Fo;
                      if (yf(this, _i), Fo = ph(this, _i, [Po, Gi]), !bu.isStreamConfiguration(na))
                        throw new Error("A StreamConfiguration is required to instantiate a RouterStreamManager");
                      if (!ta)
                        throw new Error("A RouterTransactionManager is required to instantiate a RouterStreamManager");
                      return Fo.streamConfiguration = na, Fo.routerTransactionManager = ta, Fo.STREAM_DATA_TIMEOUT_DURATION = bf, Fo.MOOV_TIMEOUT_DURATION = Tf, Fo.FIRST_MOOF_TIMEOUT_DURATION = bp, Fo.MOOF_TIMEOUT_DURATION = od, Fo.streamName = Fo.streamConfiguration.streamName, Fo.moovRequestTopic = "".concat(Fo.clientId, "/init-segment/").concat(parseInt(Math.random() * 1e6)), Fo.guid = null, Fo.firstMoofTimeout = null, Fo.moofTimeout = null, Fo.isPlaying = !1, Fo.isStopping = !1, Fo;
                    }
                    return mh(_i, Ai), Up(_i, [{
                      key: "play",
                      value: (function() {
                        var Po = Gd(/* @__PURE__ */ qc().mark(function na() {
                          var ta = this, Fo, Wa, Va, wa, il;
                          return qc().wrap(function(Ql) {
                            for (; ; ) switch (Ql.prev = Ql.next) {
                              case 0:
                                if (!this.isDestroyed) {
                                  Ql.next = 3;
                                  break;
                                }
                                return this.logger.info("Tried to play from destroyed RouterStreamManager"), Ql.abrupt("return");
                              case 3:
                                if (Ql.prev = 3, !this._hasJWTTokenConfig()) {
                                  Ql.next = 8;
                                  break;
                                }
                                return Ql.next = 7, this._validateJWT();
                              case 7:
                                this.streamName = Ql.sent;
                              case 8:
                                return this.logger.info("Play is requesting stream..."), Ql.next = 11, this._requestStreamData();
                              case 11:
                                return Fo = Ql.sent, Wa = Fo.guid, Va = Fo.mimeCodec, this.guid = Wa, this.routerTransactionManager.subscribe("iov/video/".concat(this.guid, "/resync"), function() {
                                  ta.emit(_i.events.RESYNC_STREAM_COMPLETE, {
                                    guid: ta.guid,
                                    streamName: ta.streamName
                                  });
                                }), Ql.next = 18, this._requestMoov();
                              case 18:
                                return wa = Ql.sent, il = wa.moov, Ql.next = 22, this._requestMoofs();
                              case 22:
                                return this.isPlaying = !0, Ql.abrupt("return", {
                                  guid: Wa,
                                  mimeCodec: Va,
                                  moov: il
                                });
                              case 26:
                                return Ql.prev = 26, Ql.t0 = Ql.catch(3), this.logger.error("Error trying to play stream ".concat(this.streamName)), Ql.next = 31, this.stop();
                              case 31:
                                throw Ql.t0;
                              case 32:
                              case "end":
                                return Ql.stop();
                            }
                          }, na, this, [[3, 26]]);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "stop",
                      value: (function() {
                        var Po = Gd(/* @__PURE__ */ qc().mark(function na() {
                          var ta = this, Fo, Wa;
                          return qc().wrap(function(wa) {
                            for (; ; ) switch (wa.prev = wa.next) {
                              case 0:
                                if (this._clearFirstMoofTimeout(), this._clearMoofTimeout(), !this.isDestroyComplete) {
                                  wa.next = 4;
                                  break;
                                }
                                return wa.abrupt("return");
                              case 4:
                                if (this.isPlaying) {
                                  wa.next = 6;
                                  break;
                                }
                                return wa.abrupt("return");
                              case 6:
                                if (this.guid) {
                                  wa.next = 9;
                                  break;
                                }
                                return this.logger.info("Trying to stop stream ".concat(this.streamName, " with no guid!")), wa.abrupt("return");
                              case 9:
                                return this.isStopping = !0, wa.next = 12, Promise.allSettled([
                                  // Stop listening for the moov
                                  this.routerTransactionManager.unsubscribe(this.moovRequestTopic),
                                  // Stop listening for moofs
                                  this.routerTransactionManager.unsubscribe("iov/video/".concat(this.guid, "/live")),
                                  // Stop listening for resync events
                                  this.routerTransactionManager.unsubscribe("iov/video/".concat(this.guid, "/resync")),
                                  // Tell the server we've stopped
                                  this.routerTransactionManager.publish("iov/video/".concat(this.guid, "/stop"), {
                                    clientId: this.clientId
                                  })
                                ]);
                              case 12:
                                if (Fo = wa.sent, this.guid = null, this.isPlaying = !1, this.isStopping = !1, Wa = Fo.reduce(function(il, ol) {
                                  return ol.status !== "fulfilled" && il.push(ol), il;
                                }, []), !Wa.length) {
                                  wa.next = 21;
                                  break;
                                }
                                throw this.logger.warn("Error(s) encountered while stopping:"), Wa.forEach(function(il) {
                                  ta.logger.error(il.reason);
                                }), Wa[0].reason;
                              case 21:
                              case "end":
                                return wa.stop();
                            }
                          }, na, this);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "getStreamList",
                      value: (function() {
                        var Po = Gd(/* @__PURE__ */ qc().mark(function na() {
                          var ta, Fo;
                          return qc().wrap(function(Va) {
                            for (; ; ) switch (Va.prev = Va.next) {
                              case 0:
                                return this.logger.debug("Getting Stream List..."), Va.next = 3, this.routerTransactionManager.transaction("iov/video/list");
                              case 3:
                                return ta = Va.sent, Fo = ta.payloadString, Va.abrupt("return", Fo);
                              case 6:
                              case "end":
                                return Va.stop();
                            }
                          }, na, this);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "_hasJWTTokenConfig",
                      value: function() {
                        return !!(this.streamConfiguration.tokenConfig && this.streamConfiguration.tokenConfig.jwt && this.streamConfiguration.tokenConfig.jwt.length > 0);
                      }
                      /**
                       * @private
                       *
                       * @async
                       *
                       * Validate the jwt that this instance was constructed with.
                       *
                       * @returns {String}
                       *   the stream name
                       */
                    }, {
                      key: "_validateJWT",
                      value: (function() {
                        var Po = Gd(/* @__PURE__ */ qc().mark(function na() {
                          var ta, Fo, Wa, Va;
                          return qc().wrap(function(il) {
                            for (; ; ) switch (il.prev = il.next) {
                              case 0:
                                return this.logger.debug("Validating JWT..."), il.next = 3, this.routerTransactionManager.transaction("iov/jwtValidate", {
                                  b64HashURL: this.streamConfiguration.tokenConfig.b64HashAccessUrl,
                                  token: this.streamConfiguration.tokenConfig.jwt
                                });
                              case 3:
                                if (ta = il.sent, Fo = ta.payloadString, Fo.error !== "" && this.emit(_i.events.JWT_AUTHORIZATION_FAILURE, {
                                  error: Fo.error
                                }), Fo.status === 200) {
                                  il.next = 8;
                                  break;
                                }
                                throw new Error(Fo.error);
                              case 8:
                                return Wa = Fo.target_url.split("/"), Va = Wa[Wa.length - 1], il.abrupt("return", Va);
                              case 11:
                              case "end":
                                return il.stop();
                            }
                          }, na, this);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "_requestStreamData",
                      value: (function() {
                        var Po = Gd(/* @__PURE__ */ qc().mark(function na() {
                          var ta, Fo, Wa;
                          return qc().wrap(function(wa) {
                            for (; ; ) switch (wa.prev = wa.next) {
                              case 0:
                                return this.logger.debug("Requesting Stream..."), this._hasJWTTokenConfig() ? ta = {
                                  clientId: this.clientId,
                                  token: this.streamConfiguration.tokenConfig.jwt
                                } : ta = {
                                  clientId: this.clientId
                                }, wa.next = 4, this.routerTransactionManager.transaction("iov/video/".concat(window.btoa(this.streamName), "/request"), ta, this.STREAM_DATA_TIMEOUT_DURATION);
                              case 4:
                                if (Fo = wa.sent, Wa = Fo.payloadString, Wa.mimeCodec) {
                                  wa.next = 8;
                                  break;
                                }
                                throw new Error("Error while requesting stream: mimeCodec was not received!");
                              case 8:
                                if (Wa.guid) {
                                  wa.next = 10;
                                  break;
                                }
                                throw new Error("Error while requesting stream: guid was not received!");
                              case 10:
                                return wa.abrupt("return", Wa);
                              case 11:
                              case "end":
                                return wa.stop();
                            }
                          }, na, this);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "_clearFirstMoofTimeout",
                      value: function() {
                        this.firstMoofTimeout && (clearTimeout(this.firstMoofTimeout), this.firstMoofTimeout = null);
                      }
                    }, {
                      key: "_clearMoofTimeout",
                      value: function() {
                        this.moofTimeout && (clearTimeout(this.moofTimeout), this.moofTimeout = null);
                      }
                      /**
                       * @private
                       *
                       * @async
                       *
                       * Request the moov from the SFS
                       *
                       * @returns {Object}
                       *   The moov
                       */
                    }, {
                      key: "_requestMoov",
                      value: (function() {
                        var Po = Gd(/* @__PURE__ */ qc().mark(function na() {
                          var ta, Fo, Wa;
                          return qc().wrap(function(wa) {
                            for (; ; ) switch (wa.prev = wa.next) {
                              case 0:
                                if (!this.isDestroyed) {
                                  wa.next = 2;
                                  break;
                                }
                                throw new Error("Tried to request moov while destroyed");
                              case 2:
                                if (this.logger.info("Requesting the moov..."), this.guid) {
                                  wa.next = 5;
                                  break;
                                }
                                throw new Error("The guid must be set before requesting the moov");
                              case 5:
                                return this._hasJWTTokenConfig() ? ta = {
                                  initSegmentTopic: this.moovRequestTopic,
                                  clientId: this.clientId,
                                  token: this.streamConfiguration.tokenConfig.jwt
                                } : ta = {
                                  initSegmentTopic: this.moovRequestTopic,
                                  clientId: this.clientId
                                }, wa.next = 8, this.routerTransactionManager.transaction(
                                  "iov/video/".concat(this.guid, "/play"),
                                  ta,
                                  this.MOOV_TIMEOUT_DURATION,
                                  // We must override the subscribe topic to get the moov
                                  this.moovRequestTopic
                                );
                              case 8:
                                return Fo = wa.sent, Wa = Fo.payloadBytes, wa.abrupt("return", {
                                  moov: Wa
                                });
                              case 11:
                              case "end":
                                return wa.stop();
                            }
                          }, na, this);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "_requestMoofs",
                      value: (function() {
                        var Po = Gd(/* @__PURE__ */ qc().mark(function na() {
                          var ta = this;
                          return qc().wrap(function(Wa) {
                            for (; ; ) switch (Wa.prev = Wa.next) {
                              case 0:
                                if (!this.isDestroyed) {
                                  Wa.next = 2;
                                  break;
                                }
                                throw new Error("Tried to request moofs while destroyed");
                              case 2:
                                if (this.logger.info("Setting up moof listener..."), this.guid) {
                                  Wa.next = 5;
                                  break;
                                }
                                throw new Error("The guid must be set before requesting moofs");
                              case 5:
                                return Wa.abrupt("return", new Promise(function(Va, wa) {
                                  var il = !1, ol = !1;
                                  ta.firstMoofTimeout = setTimeout(function() {
                                    il || (il = !0, ta._clearFirstMoofTimeout(), wa(new Error("First moof for stream ".concat(ta.streamName, " timed out after ").concat(ta.FIRST_MOOF_TIMEOUT_DURATION, " seconds"))));
                                  }, ta.FIRST_MOOF_TIMEOUT_DURATION * 1e3);
                                  var Ql = "iov/video/".concat(ta.guid, "/live");
                                  ta.routerTransactionManager.subscribe(Ql, function(Uu) {
                                    if (ta.isDestroyed) {
                                      ta.logger.info("Received moof while destroyed!");
                                      return;
                                    }
                                    if (!ol) {
                                      if (il) {
                                        ta.logger.warn("Received first moof, but moofTimeout has already occurred...");
                                        return;
                                      }
                                      ta._clearFirstMoofTimeout(), ol = !0, Va({
                                        moofReceivedTopic: Ql
                                      });
                                    }
                                    ta._clearMoofTimeout(), ta.moofTimeout = setTimeout(function() {
                                      if (ta.isDestroyed) {
                                        ta.logger.info("Moof timeout reached while destroyed");
                                        return;
                                      }
                                      ta.emit(_i.events.VIDEO_SEGMENT_TIMEOUT, {
                                        timeout: ta.MOOF_TIMEOUT_DURATION
                                      });
                                    }, ta.MOOF_TIMEOUT_DURATION * 1e3), ta.emit(_i.events.VIDEO_SEGMENT_RECEIVED, {
                                      clspMessage: Uu
                                    });
                                  });
                                }));
                              case 6:
                              case "end":
                                return Wa.stop();
                            }
                          }, na, this);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "_destroy",
                      value: (function() {
                        var Po = Gd(/* @__PURE__ */ qc().mark(function na() {
                          return qc().wrap(function(Fo) {
                            for (; ; ) switch (Fo.prev = Fo.next) {
                              case 0:
                                return Fo.prev = 0, Fo.next = 3, this.stop();
                              case 3:
                                Fo.next = 9;
                                break;
                              case 5:
                                Fo.prev = 5, Fo.t0 = Fo.catch(0), this.logger.error("Failed to stop when destroying!"), this.logger.error(Fo.t0);
                              case 9:
                                return this.streamConfiguration = null, this.routerTransactionManager = null, this.streamName = null, this.moovRequestTopic = null, this.guid = null, this.firstMoofTimeout = null, this.moofTimeout = null, Fo.next = 18, qh(_i, "_destroy", this, 3)([]);
                              case 18:
                              case "end":
                                return Fo.stop();
                            }
                          }, na, this, [[0, 5]]);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }], [{
                      key: "factory",
                      value: function(Gi, na, ta, Fo) {
                        return new _i(Gi, na, ta, Fo);
                      }
                    }]);
                  })(Ya);
                  ou(ad, "events", {
                    RESYNC_STREAM_COMPLETE: "resync-stream-complete",
                    VIDEO_SEGMENT_RECEIVED: "video-segment-received",
                    VIDEO_SEGMENT_TIMEOUT: "video-segment-timeout",
                    JWT_AUTHORIZATION_FAILURE: "jwt-authorization-failure"
                  }), ou(ad, "routerEvents", {});
                  function Dd() {
                    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
                    Dd = function() {
                      return _i;
                    };
                    var Ai, _i = {}, Po = Object.prototype, Gi = Po.hasOwnProperty, na = Object.defineProperty || function(Bi, Ci, ki) {
                      Bi[Ci] = ki.value;
                    }, ta = typeof Symbol == "function" ? Symbol : {}, Fo = ta.iterator || "@@iterator", Wa = ta.asyncIterator || "@@asyncIterator", Va = ta.toStringTag || "@@toStringTag";
                    function wa(Bi, Ci, ki) {
                      return Object.defineProperty(Bi, Ci, { value: ki, enumerable: !0, configurable: !0, writable: !0 }), Bi[Ci];
                    }
                    try {
                      wa({}, "");
                    } catch {
                      wa = function(ki, Mo, Xo) {
                        return ki[Mo] = Xo;
                      };
                    }
                    function il(Bi, Ci, ki, Mo) {
                      var Xo = Ci && Ci.prototype instanceof pu ? Ci : pu, Uo = Object.create(Xo.prototype), qa = new ku(Mo || []);
                      return na(Uo, "_invoke", { value: pc(Bi, ki, qa) }), Uo;
                    }
                    function ol(Bi, Ci, ki) {
                      try {
                        return { type: "normal", arg: Bi.call(Ci, ki) };
                      } catch (Mo) {
                        return { type: "throw", arg: Mo };
                      }
                    }
                    _i.wrap = il;
                    var Ql = "suspendedStart", Uu = "suspendedYield", Wu = "executing", Kl = "completed", pl = {};
                    function pu() {
                    }
                    function lu() {
                    }
                    function Nl() {
                    }
                    var Eu = {};
                    wa(Eu, Fo, function() {
                      return this;
                    });
                    var wu = Object.getPrototypeOf, yu = wu && wu(wu(Nu([])));
                    yu && yu !== Po && Gi.call(yu, Fo) && (Eu = yu);
                    var zl = Nl.prototype = pu.prototype = Object.create(Eu);
                    function Qu(Bi) {
                      ["next", "throw", "return"].forEach(function(Ci) {
                        wa(Bi, Ci, function(ki) {
                          return this._invoke(Ci, ki);
                        });
                      });
                    }
                    function gu(Bi, Ci) {
                      function ki(Xo, Uo, qa, Us) {
                        var Hs = ol(Bi[Xo], Bi, Uo);
                        if (Hs.type !== "throw") {
                          var jl = Hs.arg, Al = jl.value;
                          return Al && typeof Al == "object" && Gi.call(Al, "__await") ? Ci.resolve(Al.__await).then(function(Ml) {
                            ki("next", Ml, qa, Us);
                          }, function(Ml) {
                            ki("throw", Ml, qa, Us);
                          }) : Ci.resolve(Al).then(function(Ml) {
                            jl.value = Ml, qa(jl);
                          }, function(Ml) {
                            return ki("throw", Ml, qa, Us);
                          });
                        }
                        Us(Hs.arg);
                      }
                      var Mo;
                      na(this, "_invoke", { value: function(Uo, qa) {
                        function Us() {
                          return new Ci(function(Hs, jl) {
                            ki(Uo, qa, Hs, jl);
                          });
                        }
                        return Mo = Mo ? Mo.then(Us, Us) : Us();
                      } });
                    }
                    function pc(Bi, Ci, ki) {
                      var Mo = Ql;
                      return function(Xo, Uo) {
                        if (Mo === Wu) throw Error("Generator is already running");
                        if (Mo === Kl) {
                          if (Xo === "throw") throw Uo;
                          return { value: Ai, done: !0 };
                        }
                        for (ki.method = Xo, ki.arg = Uo; ; ) {
                          var qa = ki.delegate;
                          if (qa) {
                            var Us = Zu(qa, ki);
                            if (Us) {
                              if (Us === pl) continue;
                              return Us;
                            }
                          }
                          if (ki.method === "next") ki.sent = ki._sent = ki.arg;
                          else if (ki.method === "throw") {
                            if (Mo === Ql) throw Mo = Kl, ki.arg;
                            ki.dispatchException(ki.arg);
                          } else ki.method === "return" && ki.abrupt("return", ki.arg);
                          Mo = Wu;
                          var Hs = ol(Bi, Ci, ki);
                          if (Hs.type === "normal") {
                            if (Mo = ki.done ? Kl : Uu, Hs.arg === pl) continue;
                            return { value: Hs.arg, done: ki.done };
                          }
                          Hs.type === "throw" && (Mo = Kl, ki.method = "throw", ki.arg = Hs.arg);
                        }
                      };
                    }
                    function Zu(Bi, Ci) {
                      var ki = Ci.method, Mo = Bi.iterator[ki];
                      if (Mo === Ai) return Ci.delegate = null, ki === "throw" && Bi.iterator.return && (Ci.method = "return", Ci.arg = Ai, Zu(Bi, Ci), Ci.method === "throw") || ki !== "return" && (Ci.method = "throw", Ci.arg = new TypeError("The iterator does not provide a '" + ki + "' method")), pl;
                      var Xo = ol(Mo, Bi.iterator, Ci.arg);
                      if (Xo.type === "throw") return Ci.method = "throw", Ci.arg = Xo.arg, Ci.delegate = null, pl;
                      var Uo = Xo.arg;
                      return Uo ? Uo.done ? (Ci[Bi.resultName] = Uo.value, Ci.next = Bi.nextLoc, Ci.method !== "return" && (Ci.method = "next", Ci.arg = Ai), Ci.delegate = null, pl) : Uo : (Ci.method = "throw", Ci.arg = new TypeError("iterator result is not an object"), Ci.delegate = null, pl);
                    }
                    function gc(Bi) {
                      var Ci = { tryLoc: Bi[0] };
                      1 in Bi && (Ci.catchLoc = Bi[1]), 2 in Bi && (Ci.finallyLoc = Bi[2], Ci.afterLoc = Bi[3]), this.tryEntries.push(Ci);
                    }
                    function Du(Bi) {
                      var Ci = Bi.completion || {};
                      Ci.type = "normal", delete Ci.arg, Bi.completion = Ci;
                    }
                    function ku(Bi) {
                      this.tryEntries = [{ tryLoc: "root" }], Bi.forEach(gc, this), this.reset(!0);
                    }
                    function Nu(Bi) {
                      if (Bi || Bi === "") {
                        var Ci = Bi[Fo];
                        if (Ci) return Ci.call(Bi);
                        if (typeof Bi.next == "function") return Bi;
                        if (!isNaN(Bi.length)) {
                          var ki = -1, Mo = function Xo() {
                            for (; ++ki < Bi.length; ) if (Gi.call(Bi, ki)) return Xo.value = Bi[ki], Xo.done = !1, Xo;
                            return Xo.value = Ai, Xo.done = !0, Xo;
                          };
                          return Mo.next = Mo;
                        }
                      }
                      throw new TypeError(typeof Bi + " is not iterable");
                    }
                    return lu.prototype = Nl, na(zl, "constructor", { value: Nl, configurable: !0 }), na(Nl, "constructor", { value: lu, configurable: !0 }), lu.displayName = wa(Nl, Va, "GeneratorFunction"), _i.isGeneratorFunction = function(Bi) {
                      var Ci = typeof Bi == "function" && Bi.constructor;
                      return !!Ci && (Ci === lu || (Ci.displayName || Ci.name) === "GeneratorFunction");
                    }, _i.mark = function(Bi) {
                      return Object.setPrototypeOf ? Object.setPrototypeOf(Bi, Nl) : (Bi.__proto__ = Nl, wa(Bi, Va, "GeneratorFunction")), Bi.prototype = Object.create(zl), Bi;
                    }, _i.awrap = function(Bi) {
                      return { __await: Bi };
                    }, Qu(gu.prototype), wa(gu.prototype, Wa, function() {
                      return this;
                    }), _i.AsyncIterator = gu, _i.async = function(Bi, Ci, ki, Mo, Xo) {
                      Xo === void 0 && (Xo = Promise);
                      var Uo = new gu(il(Bi, Ci, ki, Mo), Xo);
                      return _i.isGeneratorFunction(Ci) ? Uo : Uo.next().then(function(qa) {
                        return qa.done ? qa.value : Uo.next();
                      });
                    }, Qu(zl), wa(zl, Va, "Generator"), wa(zl, Fo, function() {
                      return this;
                    }), wa(zl, "toString", function() {
                      return "[object Generator]";
                    }), _i.keys = function(Bi) {
                      var Ci = Object(Bi), ki = [];
                      for (var Mo in Ci) ki.push(Mo);
                      return ki.reverse(), function Xo() {
                        for (; ki.length; ) {
                          var Uo = ki.pop();
                          if (Uo in Ci) return Xo.value = Uo, Xo.done = !1, Xo;
                        }
                        return Xo.done = !0, Xo;
                      };
                    }, _i.values = Nu, ku.prototype = { constructor: ku, reset: function(Ci) {
                      if (this.prev = 0, this.next = 0, this.sent = this._sent = Ai, this.done = !1, this.delegate = null, this.method = "next", this.arg = Ai, this.tryEntries.forEach(Du), !Ci) for (var ki in this) ki.charAt(0) === "t" && Gi.call(this, ki) && !isNaN(+ki.slice(1)) && (this[ki] = Ai);
                    }, stop: function() {
                      this.done = !0;
                      var Ci = this.tryEntries[0].completion;
                      if (Ci.type === "throw") throw Ci.arg;
                      return this.rval;
                    }, dispatchException: function(Ci) {
                      if (this.done) throw Ci;
                      var ki = this;
                      function Mo(jl, Al) {
                        return qa.type = "throw", qa.arg = Ci, ki.next = jl, Al && (ki.method = "next", ki.arg = Ai), !!Al;
                      }
                      for (var Xo = this.tryEntries.length - 1; Xo >= 0; --Xo) {
                        var Uo = this.tryEntries[Xo], qa = Uo.completion;
                        if (Uo.tryLoc === "root") return Mo("end");
                        if (Uo.tryLoc <= this.prev) {
                          var Us = Gi.call(Uo, "catchLoc"), Hs = Gi.call(Uo, "finallyLoc");
                          if (Us && Hs) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          } else if (Us) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                          } else {
                            if (!Hs) throw Error("try statement without catch or finally");
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          }
                        }
                      }
                    }, abrupt: function(Ci, ki) {
                      for (var Mo = this.tryEntries.length - 1; Mo >= 0; --Mo) {
                        var Xo = this.tryEntries[Mo];
                        if (Xo.tryLoc <= this.prev && Gi.call(Xo, "finallyLoc") && this.prev < Xo.finallyLoc) {
                          var Uo = Xo;
                          break;
                        }
                      }
                      Uo && (Ci === "break" || Ci === "continue") && Uo.tryLoc <= ki && ki <= Uo.finallyLoc && (Uo = null);
                      var qa = Uo ? Uo.completion : {};
                      return qa.type = Ci, qa.arg = ki, Uo ? (this.method = "next", this.next = Uo.finallyLoc, pl) : this.complete(qa);
                    }, complete: function(Ci, ki) {
                      if (Ci.type === "throw") throw Ci.arg;
                      return Ci.type === "break" || Ci.type === "continue" ? this.next = Ci.arg : Ci.type === "return" ? (this.rval = this.arg = Ci.arg, this.method = "return", this.next = "end") : Ci.type === "normal" && ki && (this.next = ki), pl;
                    }, finish: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.finallyLoc === Ci) return this.complete(Mo.completion, Mo.afterLoc), Du(Mo), pl;
                      }
                    }, catch: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.tryLoc === Ci) {
                          var Xo = Mo.completion;
                          if (Xo.type === "throw") {
                            var Uo = Xo.arg;
                            Du(Mo);
                          }
                          return Uo;
                        }
                      }
                      throw Error("illegal catch attempt");
                    }, delegateYield: function(Ci, ki, Mo) {
                      return this.delegate = { iterator: Nu(Ci), resultName: ki, nextLoc: Mo }, this.method === "next" && (this.arg = Ai), pl;
                    } }, _i;
                  }
                  function wd(Ai, _i, Po, Gi, na, ta, Fo) {
                    try {
                      var Wa = Ai[ta](Fo), Va = Wa.value;
                    } catch (wa) {
                      return void Po(wa);
                    }
                    Wa.done ? _i(Va) : Promise.resolve(Va).then(Gi, na);
                  }
                  function nd(Ai) {
                    return function() {
                      var _i = this, Po = arguments;
                      return new Promise(function(Gi, na) {
                        var ta = Ai.apply(_i, Po);
                        function Fo(Va) {
                          wd(ta, Gi, na, Fo, Wa, "next", Va);
                        }
                        function Wa(Va) {
                          wd(ta, Gi, na, Fo, Wa, "throw", Va);
                        }
                        Fo(void 0);
                      });
                    };
                  }
                  function zd(Ai, _i) {
                    if (!(Ai instanceof _i)) throw new TypeError("Cannot call a class as a function");
                  }
                  function vh(Ai, _i) {
                    for (var Po = 0; Po < _i.length; Po++) {
                      var Gi = _i[Po];
                      Gi.enumerable = Gi.enumerable || !1, Gi.configurable = !0, "value" in Gi && (Gi.writable = !0), Object.defineProperty(Ai, Hp(Gi.key), Gi);
                    }
                  }
                  function Vp(Ai, _i, Po) {
                    return _i && vh(Ai.prototype, _i), Po && vh(Ai, Po), Object.defineProperty(Ai, "prototype", { writable: !1 }), Ai;
                  }
                  function Wp(Ai, _i, Po) {
                    return _i = qd(_i), hd(Ai, lc() ? Reflect.construct(_i, Po || [], qd(Ai).constructor) : _i.apply(Ai, Po));
                  }
                  function hd(Ai, _i) {
                    if (_i && (typeof _i == "object" || typeof _i == "function")) return _i;
                    if (_i !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return Uf(Ai);
                  }
                  function Uf(Ai) {
                    if (Ai === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return Ai;
                  }
                  function lc() {
                    try {
                      var Ai = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                      }));
                    } catch {
                    }
                    return (lc = function() {
                      return !!Ai;
                    })();
                  }
                  function Gp(Ai, _i, Po, Gi) {
                    var na = Kd(qd(Ai.prototype), _i, Po);
                    return 2 & Gi && typeof na == "function" ? function(ta) {
                      return na.apply(Po, ta);
                    } : na;
                  }
                  function Kd() {
                    return Kd = typeof Reflect < "u" && Reflect.get ? Reflect.get.bind() : function(Ai, _i, Po) {
                      var Gi = Tp(Ai, _i);
                      if (Gi) {
                        var na = Object.getOwnPropertyDescriptor(Gi, _i);
                        return na.get ? na.get.call(arguments.length < 3 ? Ai : Po) : na.value;
                      }
                    }, Kd.apply(null, arguments);
                  }
                  function Tp(Ai, _i) {
                    for (; !{}.hasOwnProperty.call(Ai, _i) && (Ai = qd(Ai)) !== null; ) ;
                    return Ai;
                  }
                  function qd(Ai) {
                    return qd = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(_i) {
                      return _i.__proto__ || Object.getPrototypeOf(_i);
                    }, qd(Ai);
                  }
                  function yh(Ai, _i) {
                    if (typeof _i != "function" && _i !== null) throw new TypeError("Super expression must either be null or a function");
                    Ai.prototype = Object.create(_i && _i.prototype, { constructor: { value: Ai, writable: !0, configurable: !0 } }), Object.defineProperty(Ai, "prototype", { writable: !1 }), _i && Vf(Ai, _i);
                  }
                  function Vf(Ai, _i) {
                    return Vf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(Po, Gi) {
                      return Po.__proto__ = Gi, Po;
                    }, Vf(Ai, _i);
                  }
                  function Ep(Ai, _i, Po) {
                    return (_i = Hp(_i)) in Ai ? Object.defineProperty(Ai, _i, { value: Po, enumerable: !0, configurable: !0, writable: !0 }) : Ai[_i] = Po, Ai;
                  }
                  function Hp(Ai) {
                    var _i = Wf(Ai, "string");
                    return typeof _i == "symbol" ? _i : _i + "";
                  }
                  function Wf(Ai, _i) {
                    if (typeof Ai != "object" || !Ai) return Ai;
                    var Po = Ai[Symbol.toPrimitive];
                    if (Po !== void 0) {
                      var Gi = Po.call(Ai, _i);
                      if (typeof Gi != "object") return Gi;
                      throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (_i === "string" ? String : Number)(Ai);
                  }
                  var Sp = 5, Gf = /* @__PURE__ */ (function(Ai) {
                    function _i(Po, Gi, na) {
                      var ta;
                      if (zd(this, _i), ta = Wp(this, _i, [Po, Gi]), !na)
                        throw new Error("A RouterTransactionManager is required to instantiate a RouterStatsManager");
                      return ta.routerTransactionManager = na, ta.statsMsg = {
                        byteCount: 0,
                        inkbps: 0,
                        host: document.location.host,
                        clientId: ta.clientId
                      }, ta.publishInterval = null, ta.isStopped = !0, ta.PUBLISH_STATS_INTERVAL = Sp, ta;
                    }
                    return yh(_i, Ai), Vp(_i, [{
                      key: "updateByteCount",
                      value: function(Gi) {
                        if (this.isDestroyed) {
                          this.logger.info("Tried to updateByteCount while destroyed");
                          return;
                        }
                        this.logger.silly("Updating bytecount..."), this.statsMsg.byteCount += Gi.length;
                      }
                      /**
                       * We have to send stats to the server at least once per minute, or else the
                       * CLSP service will stop streaming to this Router.
                       *
                       * @returns {void}
                       */
                    }, {
                      key: "start",
                      value: function() {
                        var Gi = this;
                        if (this.isDestroyed) {
                          this.logger.info("Tried to start while destroyed");
                          return;
                        }
                        this.publishInterval && this.stop(), this.logger.info("Starting stats publishing..."), this.publishInterval = setInterval(function() {
                          Gi._publishStats();
                        }, this.PUBLISH_STATS_INTERVAL * 1e3), this.isStopped = !1;
                      }
                      /**
                       * Stop publishing stats to the server.  Do this When we no longer want to
                       * stream to the Router.
                       *
                       * @returns {void}
                       */
                    }, {
                      key: "stop",
                      value: function() {
                        if (this.isDestroyComplete) {
                          this.logger.info("Tried to stop while destroyed");
                          return;
                        }
                        this.logger.info("Stopping stats publishing..."), this.publishInterval && (clearInterval(this.publishInterval), this.publishInterval = null), this.isStopped = !0;
                      }
                      /**
                       * @private
                       *
                       * @async
                       *
                       * Send stats to the server.
                       *
                       * @returns {void}
                       */
                    }, {
                      key: "_publishStats",
                      value: (function() {
                        var Po = nd(/* @__PURE__ */ Dd().mark(function na() {
                          return Dd().wrap(function(Fo) {
                            for (; ; ) switch (Fo.prev = Fo.next) {
                              case 0:
                                if (!this.isDestroyed) {
                                  Fo.next = 3;
                                  break;
                                }
                                return this.logger.info("Tried to _publishStats while destroyed"), Fo.abrupt("return");
                              case 3:
                                return this.statsMsg.inkbps = this.statsMsg.byteCount * 8 / 3e4, this.statsMsg.byteCount = 0, Fo.prev = 5, this.logger.info("About to send stats message..."), Fo.next = 9, this.routerTransactionManager.publish("iov/stats", this.statsMsg);
                              case 9:
                                this.logger.debug("iov status", this.statsMsg), Fo.next = 15;
                                break;
                              case 12:
                                Fo.prev = 12, Fo.t0 = Fo.catch(5), this.isStopped || (this.logger.error("Error while publishing stats!"), this.logger.error(Fo.t0), this.emit(_i.events.PUBLISH_FAILURE, {
                                  error: Fo.t0
                                }), this.stop());
                              case 15:
                              case "end":
                                return Fo.stop();
                            }
                          }, na, this, [[5, 12]]);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "_destroy",
                      value: (function() {
                        var Po = nd(/* @__PURE__ */ Dd().mark(function na() {
                          return Dd().wrap(function(Fo) {
                            for (; ; ) switch (Fo.prev = Fo.next) {
                              case 0:
                                return this.stop(), this.statsMsg = null, this.routerTransactionManager = null, Fo.next = 5, Gp(_i, "_destroy", this, 3)([]);
                              case 5:
                              case "end":
                                return Fo.stop();
                            }
                          }, na, this);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }], [{
                      key: "factory",
                      value: function(Gi, na, ta) {
                        return new _i(Gi, na, ta);
                      }
                    }]);
                  })(Ya);
                  Ep(Gf, "events", {
                    PUBLISH_FAILURE: "publish-failed"
                  }), Ep(Gf, "routerEvents", {});
                  function sd() {
                    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
                    sd = function() {
                      return _i;
                    };
                    var Ai, _i = {}, Po = Object.prototype, Gi = Po.hasOwnProperty, na = Object.defineProperty || function(Bi, Ci, ki) {
                      Bi[Ci] = ki.value;
                    }, ta = typeof Symbol == "function" ? Symbol : {}, Fo = ta.iterator || "@@iterator", Wa = ta.asyncIterator || "@@asyncIterator", Va = ta.toStringTag || "@@toStringTag";
                    function wa(Bi, Ci, ki) {
                      return Object.defineProperty(Bi, Ci, { value: ki, enumerable: !0, configurable: !0, writable: !0 }), Bi[Ci];
                    }
                    try {
                      wa({}, "");
                    } catch {
                      wa = function(ki, Mo, Xo) {
                        return ki[Mo] = Xo;
                      };
                    }
                    function il(Bi, Ci, ki, Mo) {
                      var Xo = Ci && Ci.prototype instanceof pu ? Ci : pu, Uo = Object.create(Xo.prototype), qa = new ku(Mo || []);
                      return na(Uo, "_invoke", { value: pc(Bi, ki, qa) }), Uo;
                    }
                    function ol(Bi, Ci, ki) {
                      try {
                        return { type: "normal", arg: Bi.call(Ci, ki) };
                      } catch (Mo) {
                        return { type: "throw", arg: Mo };
                      }
                    }
                    _i.wrap = il;
                    var Ql = "suspendedStart", Uu = "suspendedYield", Wu = "executing", Kl = "completed", pl = {};
                    function pu() {
                    }
                    function lu() {
                    }
                    function Nl() {
                    }
                    var Eu = {};
                    wa(Eu, Fo, function() {
                      return this;
                    });
                    var wu = Object.getPrototypeOf, yu = wu && wu(wu(Nu([])));
                    yu && yu !== Po && Gi.call(yu, Fo) && (Eu = yu);
                    var zl = Nl.prototype = pu.prototype = Object.create(Eu);
                    function Qu(Bi) {
                      ["next", "throw", "return"].forEach(function(Ci) {
                        wa(Bi, Ci, function(ki) {
                          return this._invoke(Ci, ki);
                        });
                      });
                    }
                    function gu(Bi, Ci) {
                      function ki(Xo, Uo, qa, Us) {
                        var Hs = ol(Bi[Xo], Bi, Uo);
                        if (Hs.type !== "throw") {
                          var jl = Hs.arg, Al = jl.value;
                          return Al && typeof Al == "object" && Gi.call(Al, "__await") ? Ci.resolve(Al.__await).then(function(Ml) {
                            ki("next", Ml, qa, Us);
                          }, function(Ml) {
                            ki("throw", Ml, qa, Us);
                          }) : Ci.resolve(Al).then(function(Ml) {
                            jl.value = Ml, qa(jl);
                          }, function(Ml) {
                            return ki("throw", Ml, qa, Us);
                          });
                        }
                        Us(Hs.arg);
                      }
                      var Mo;
                      na(this, "_invoke", { value: function(Uo, qa) {
                        function Us() {
                          return new Ci(function(Hs, jl) {
                            ki(Uo, qa, Hs, jl);
                          });
                        }
                        return Mo = Mo ? Mo.then(Us, Us) : Us();
                      } });
                    }
                    function pc(Bi, Ci, ki) {
                      var Mo = Ql;
                      return function(Xo, Uo) {
                        if (Mo === Wu) throw Error("Generator is already running");
                        if (Mo === Kl) {
                          if (Xo === "throw") throw Uo;
                          return { value: Ai, done: !0 };
                        }
                        for (ki.method = Xo, ki.arg = Uo; ; ) {
                          var qa = ki.delegate;
                          if (qa) {
                            var Us = Zu(qa, ki);
                            if (Us) {
                              if (Us === pl) continue;
                              return Us;
                            }
                          }
                          if (ki.method === "next") ki.sent = ki._sent = ki.arg;
                          else if (ki.method === "throw") {
                            if (Mo === Ql) throw Mo = Kl, ki.arg;
                            ki.dispatchException(ki.arg);
                          } else ki.method === "return" && ki.abrupt("return", ki.arg);
                          Mo = Wu;
                          var Hs = ol(Bi, Ci, ki);
                          if (Hs.type === "normal") {
                            if (Mo = ki.done ? Kl : Uu, Hs.arg === pl) continue;
                            return { value: Hs.arg, done: ki.done };
                          }
                          Hs.type === "throw" && (Mo = Kl, ki.method = "throw", ki.arg = Hs.arg);
                        }
                      };
                    }
                    function Zu(Bi, Ci) {
                      var ki = Ci.method, Mo = Bi.iterator[ki];
                      if (Mo === Ai) return Ci.delegate = null, ki === "throw" && Bi.iterator.return && (Ci.method = "return", Ci.arg = Ai, Zu(Bi, Ci), Ci.method === "throw") || ki !== "return" && (Ci.method = "throw", Ci.arg = new TypeError("The iterator does not provide a '" + ki + "' method")), pl;
                      var Xo = ol(Mo, Bi.iterator, Ci.arg);
                      if (Xo.type === "throw") return Ci.method = "throw", Ci.arg = Xo.arg, Ci.delegate = null, pl;
                      var Uo = Xo.arg;
                      return Uo ? Uo.done ? (Ci[Bi.resultName] = Uo.value, Ci.next = Bi.nextLoc, Ci.method !== "return" && (Ci.method = "next", Ci.arg = Ai), Ci.delegate = null, pl) : Uo : (Ci.method = "throw", Ci.arg = new TypeError("iterator result is not an object"), Ci.delegate = null, pl);
                    }
                    function gc(Bi) {
                      var Ci = { tryLoc: Bi[0] };
                      1 in Bi && (Ci.catchLoc = Bi[1]), 2 in Bi && (Ci.finallyLoc = Bi[2], Ci.afterLoc = Bi[3]), this.tryEntries.push(Ci);
                    }
                    function Du(Bi) {
                      var Ci = Bi.completion || {};
                      Ci.type = "normal", delete Ci.arg, Bi.completion = Ci;
                    }
                    function ku(Bi) {
                      this.tryEntries = [{ tryLoc: "root" }], Bi.forEach(gc, this), this.reset(!0);
                    }
                    function Nu(Bi) {
                      if (Bi || Bi === "") {
                        var Ci = Bi[Fo];
                        if (Ci) return Ci.call(Bi);
                        if (typeof Bi.next == "function") return Bi;
                        if (!isNaN(Bi.length)) {
                          var ki = -1, Mo = function Xo() {
                            for (; ++ki < Bi.length; ) if (Gi.call(Bi, ki)) return Xo.value = Bi[ki], Xo.done = !1, Xo;
                            return Xo.value = Ai, Xo.done = !0, Xo;
                          };
                          return Mo.next = Mo;
                        }
                      }
                      throw new TypeError(typeof Bi + " is not iterable");
                    }
                    return lu.prototype = Nl, na(zl, "constructor", { value: Nl, configurable: !0 }), na(Nl, "constructor", { value: lu, configurable: !0 }), lu.displayName = wa(Nl, Va, "GeneratorFunction"), _i.isGeneratorFunction = function(Bi) {
                      var Ci = typeof Bi == "function" && Bi.constructor;
                      return !!Ci && (Ci === lu || (Ci.displayName || Ci.name) === "GeneratorFunction");
                    }, _i.mark = function(Bi) {
                      return Object.setPrototypeOf ? Object.setPrototypeOf(Bi, Nl) : (Bi.__proto__ = Nl, wa(Bi, Va, "GeneratorFunction")), Bi.prototype = Object.create(zl), Bi;
                    }, _i.awrap = function(Bi) {
                      return { __await: Bi };
                    }, Qu(gu.prototype), wa(gu.prototype, Wa, function() {
                      return this;
                    }), _i.AsyncIterator = gu, _i.async = function(Bi, Ci, ki, Mo, Xo) {
                      Xo === void 0 && (Xo = Promise);
                      var Uo = new gu(il(Bi, Ci, ki, Mo), Xo);
                      return _i.isGeneratorFunction(Ci) ? Uo : Uo.next().then(function(qa) {
                        return qa.done ? qa.value : Uo.next();
                      });
                    }, Qu(zl), wa(zl, Va, "Generator"), wa(zl, Fo, function() {
                      return this;
                    }), wa(zl, "toString", function() {
                      return "[object Generator]";
                    }), _i.keys = function(Bi) {
                      var Ci = Object(Bi), ki = [];
                      for (var Mo in Ci) ki.push(Mo);
                      return ki.reverse(), function Xo() {
                        for (; ki.length; ) {
                          var Uo = ki.pop();
                          if (Uo in Ci) return Xo.value = Uo, Xo.done = !1, Xo;
                        }
                        return Xo.done = !0, Xo;
                      };
                    }, _i.values = Nu, ku.prototype = { constructor: ku, reset: function(Ci) {
                      if (this.prev = 0, this.next = 0, this.sent = this._sent = Ai, this.done = !1, this.delegate = null, this.method = "next", this.arg = Ai, this.tryEntries.forEach(Du), !Ci) for (var ki in this) ki.charAt(0) === "t" && Gi.call(this, ki) && !isNaN(+ki.slice(1)) && (this[ki] = Ai);
                    }, stop: function() {
                      this.done = !0;
                      var Ci = this.tryEntries[0].completion;
                      if (Ci.type === "throw") throw Ci.arg;
                      return this.rval;
                    }, dispatchException: function(Ci) {
                      if (this.done) throw Ci;
                      var ki = this;
                      function Mo(jl, Al) {
                        return qa.type = "throw", qa.arg = Ci, ki.next = jl, Al && (ki.method = "next", ki.arg = Ai), !!Al;
                      }
                      for (var Xo = this.tryEntries.length - 1; Xo >= 0; --Xo) {
                        var Uo = this.tryEntries[Xo], qa = Uo.completion;
                        if (Uo.tryLoc === "root") return Mo("end");
                        if (Uo.tryLoc <= this.prev) {
                          var Us = Gi.call(Uo, "catchLoc"), Hs = Gi.call(Uo, "finallyLoc");
                          if (Us && Hs) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          } else if (Us) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                          } else {
                            if (!Hs) throw Error("try statement without catch or finally");
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          }
                        }
                      }
                    }, abrupt: function(Ci, ki) {
                      for (var Mo = this.tryEntries.length - 1; Mo >= 0; --Mo) {
                        var Xo = this.tryEntries[Mo];
                        if (Xo.tryLoc <= this.prev && Gi.call(Xo, "finallyLoc") && this.prev < Xo.finallyLoc) {
                          var Uo = Xo;
                          break;
                        }
                      }
                      Uo && (Ci === "break" || Ci === "continue") && Uo.tryLoc <= ki && ki <= Uo.finallyLoc && (Uo = null);
                      var qa = Uo ? Uo.completion : {};
                      return qa.type = Ci, qa.arg = ki, Uo ? (this.method = "next", this.next = Uo.finallyLoc, pl) : this.complete(qa);
                    }, complete: function(Ci, ki) {
                      if (Ci.type === "throw") throw Ci.arg;
                      return Ci.type === "break" || Ci.type === "continue" ? this.next = Ci.arg : Ci.type === "return" ? (this.rval = this.arg = Ci.arg, this.method = "return", this.next = "end") : Ci.type === "normal" && ki && (this.next = ki), pl;
                    }, finish: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.finallyLoc === Ci) return this.complete(Mo.completion, Mo.afterLoc), Du(Mo), pl;
                      }
                    }, catch: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.tryLoc === Ci) {
                          var Xo = Mo.completion;
                          if (Xo.type === "throw") {
                            var Uo = Xo.arg;
                            Du(Mo);
                          }
                          return Uo;
                        }
                      }
                      throw Error("illegal catch attempt");
                    }, delegateYield: function(Ci, ki, Mo) {
                      return this.delegate = { iterator: Nu(Ci), resultName: ki, nextLoc: Mo }, this.method === "next" && (this.arg = Ai), pl;
                    } }, _i;
                  }
                  function _d(Ai, _i, Po, Gi, na, ta, Fo) {
                    try {
                      var Wa = Ai[ta](Fo), Va = Wa.value;
                    } catch (wa) {
                      return void Po(wa);
                    }
                    Wa.done ? _i(Va) : Promise.resolve(Va).then(Gi, na);
                  }
                  function Yd(Ai) {
                    return function() {
                      var _i = this, Po = arguments;
                      return new Promise(function(Gi, na) {
                        var ta = Ai.apply(_i, Po);
                        function Fo(Va) {
                          _d(ta, Gi, na, Fo, Wa, "next", Va);
                        }
                        function Wa(Va) {
                          _d(ta, Gi, na, Fo, Wa, "throw", Va);
                        }
                        Fo(void 0);
                      });
                    };
                  }
                  function zp(Ai, _i) {
                    if (!(Ai instanceof _i)) throw new TypeError("Cannot call a class as a function");
                  }
                  function Ef(Ai, _i) {
                    for (var Po = 0; Po < _i.length; Po++) {
                      var Gi = _i[Po];
                      Gi.enumerable = Gi.enumerable || !1, Gi.configurable = !0, "value" in Gi && (Gi.writable = !0), Object.defineProperty(Ai, Sf(Gi.key), Gi);
                    }
                  }
                  function Yh(Ai, _i, Po) {
                    return _i && Ef(Ai.prototype, _i), Po && Ef(Ai, Po), Object.defineProperty(Ai, "prototype", { writable: !1 }), Ai;
                  }
                  function xp(Ai, _i, Po) {
                    return _i = lf(_i), wp(Ai, np() ? Reflect.construct(_i, Po || [], lf(Ai).constructor) : _i.apply(Ai, Po));
                  }
                  function wp(Ai, _i) {
                    if (_i && (typeof _i == "object" || typeof _i == "function")) return _i;
                    if (_i !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return Xd(Ai);
                  }
                  function Xd(Ai) {
                    if (Ai === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return Ai;
                  }
                  function np() {
                    try {
                      var Ai = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                      }));
                    } catch {
                    }
                    return (np = function() {
                      return !!Ai;
                    })();
                  }
                  function sf(Ai, _i, Po, Gi) {
                    var na = _p(lf(Ai.prototype), _i, Po);
                    return 2 & Gi && typeof na == "function" ? function(ta) {
                      return na.apply(Po, ta);
                    } : na;
                  }
                  function _p() {
                    return _p = typeof Reflect < "u" && Reflect.get ? Reflect.get.bind() : function(Ai, _i, Po) {
                      var Gi = Xh(Ai, _i);
                      if (Gi) {
                        var na = Object.getOwnPropertyDescriptor(Gi, _i);
                        return na.get ? na.get.call(arguments.length < 3 ? Ai : Po) : na.value;
                      }
                    }, _p.apply(null, arguments);
                  }
                  function Xh(Ai, _i) {
                    for (; !{}.hasOwnProperty.call(Ai, _i) && (Ai = lf(Ai)) !== null; ) ;
                    return Ai;
                  }
                  function lf(Ai) {
                    return lf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(_i) {
                      return _i.__proto__ || Object.getPrototypeOf(_i);
                    }, lf(Ai);
                  }
                  function bh(Ai, _i) {
                    if (typeof _i != "function" && _i !== null) throw new TypeError("Super expression must either be null or a function");
                    Ai.prototype = Object.create(_i && _i.prototype, { constructor: { value: Ai, writable: !0, configurable: !0 } }), Object.defineProperty(Ai, "prototype", { writable: !1 }), _i && uf(Ai, _i);
                  }
                  function uf(Ai, _i) {
                    return uf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(Po, Gi) {
                      return Po.__proto__ = Gi, Po;
                    }, uf(Ai, _i);
                  }
                  function gd(Ai, _i, Po) {
                    return (_i = Sf(_i)) in Ai ? Object.defineProperty(Ai, _i, { value: Po, enumerable: !0, configurable: !0, writable: !0 }) : Ai[_i] = Po, Ai;
                  }
                  function Sf(Ai) {
                    var _i = Yc(Ai, "string");
                    return typeof _i == "symbol" ? _i : _i + "";
                  }
                  function Yc(Ai, _i) {
                    if (typeof Ai != "object" || !Ai) return Ai;
                    var Po = Ai[Symbol.toPrimitive];
                    if (Po !== void 0) {
                      var Gi = Po.call(Ai, _i);
                      if (typeof Gi != "object") return Gi;
                      throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (_i === "string" ? String : Number)(Ai);
                  }
                  var Kp = 3, Sc = 0, xf = 5, qp = 120, Pp = 30, Pd = /* @__PURE__ */ (function(Ai) {
                    function _i(Po, Gi, na) {
                      var ta;
                      if (zp(this, _i), ta = xp(this, _i, [Po, Gi]), !na)
                        throw new Error("A RouterTransactionManager is required to instantiate a RouterConnectionManager");
                      return ta.routerTransactionManager = na, ta.statsManager = Gf.factory(ta.logId, ta.clientId, ta.routerTransactionManager), ta.statsManager.on(Gf.events.PUBLISH_FAILURE, function(Fo) {
                        ta.logger.warn("Publish stats failure - attempting to reconnect..."), ta.reconnect();
                      }), ta.MAX_RECONNECTION_ATTEMPTS = Kp, ta.MAX_RECONNECTION_TIME = Sc, ta.IMMEDIATE_RECONNECTION_DELAY = xf, ta.IMMEDIATE_RECONNECTION_DURATION = qp, ta.RECONNECTION_DELAY = Pp, ta.isConnected = !1, ta.isConnecting = !1, ta.isDisconnecting = !1, ta.isReconnecting = !1, ta._onConnect = null, ta._onDisconnect = null, ta;
                    }
                    return bh(_i, Ai), Yh(_i, [{
                      key: "connect",
                      value: (function() {
                        var Po = Yd(/* @__PURE__ */ sd().mark(function na() {
                          var ta, Fo = arguments;
                          return sd().wrap(function(Va) {
                            for (; ; ) switch (Va.prev = Va.next) {
                              case 0:
                                return ta = Fo.length > 0 && Fo[0] !== void 0 ? Fo[0] : !0, Va.prev = 1, Va.next = 4, this.reconnect(!1);
                              case 4:
                                if (!this.isDestroyed) {
                                  Va.next = 7;
                                  break;
                                }
                                return this.logger.info("Destroy occurred before the connection finished"), Va.abrupt("return");
                              case 7:
                                if (!this.isDisconnecting) {
                                  Va.next = 10;
                                  break;
                                }
                                return this.logger.info("Disconnection occurred before the connection finished"), Va.abrupt("return");
                              case 10:
                                ta && this.emit(_i.events.CONNECT_SUCCESS), Va.next = 18;
                                break;
                              case 13:
                                Va.prev = 13, Va.t0 = Va.catch(1), this.logger.error("Failed to connect"), this.logger.error(Va.t0), ta && this.emit(_i.events.CONNECT_FAILURE, {
                                  error: Va.t0
                                });
                              case 18:
                              case "end":
                                return Va.stop();
                            }
                          }, na, this, [[1, 13]]);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "_connect",
                      value: function() {
                        var Gi = this;
                        return new Promise(function(na, ta) {
                          Gi._onConnect = function(Fo) {
                            if (Gi._onConnect = null, Fo)
                              return ta(Fo);
                            na();
                          }, Gi.routerTransactionManager.issueCommand(_i.routerCommands.CONNECT);
                        });
                      }
                    }, {
                      key: "_handleConnectRouterEvent",
                      value: function(Gi, na) {
                        switch (Gi) {
                          case _i.routerEvents.CONNECT_SUCCESS: {
                            this._onConnect();
                            break;
                          }
                          case _i.routerEvents.CONNECT_FAILURE: {
                            this._onConnect(new Error(na.data.reason));
                            break;
                          }
                          default:
                            throw new Error("Unknown eventType: ".concat(Gi));
                        }
                      }
                      /**
                       * @async
                       *
                       * Attempt to reconnect a certain number of times
                       *
                       * @returns {Promise}
                       */
                    }, {
                      key: "reconnect",
                      value: (function() {
                        var Po = Yd(/* @__PURE__ */ sd().mark(function na() {
                          var ta, Fo, Wa, Va = arguments;
                          return sd().wrap(function(il) {
                            for (; ; ) switch (il.prev = il.next) {
                              case 0:
                                if (ta = Va.length > 0 && Va[0] !== void 0 ? Va[0] : !0, !this.isDestroyed) {
                                  il.next = 4;
                                  break;
                                }
                                return this.logger.info("Tried to reconnect on destroyed RouterConnectionManager"), il.abrupt("return");
                              case 4:
                                if (!this.isDisconnecting) {
                                  il.next = 7;
                                  break;
                                }
                                return this.logger.info("Tried to reconnect while there was a disconnection in progress"), il.abrupt("return");
                              case 7:
                                if (!this.isConnecting) {
                                  il.next = 10;
                                  break;
                                }
                                return this.logger.info("Connection already in progress"), il.abrupt("return");
                              case 10:
                                if (!this.isReconnecting) {
                                  il.next = 13;
                                  break;
                                }
                                return this.logger.info("A reconnection attempt is already in progress"), il.abrupt("return");
                              case 13:
                                return this.logger.info("Reconnecting..."), this.isConnecting = !0, this.isReconnecting = !0, Fo = Date.now(), Wa = this.MAX_RECONNECTION_TIME ? Fo + this.MAX_RECONNECTION_TIME * 1e3 : 0, il.prev = 18, il.next = 21, this._reconnect(Fo, Wa);
                              case 21:
                                if (!this.isDestroyed) {
                                  il.next = 24;
                                  break;
                                }
                                return this.logger.info("Destruction occurred before the reconnection finished"), il.abrupt("return");
                              case 24:
                                if (!this.isDisconnecting) {
                                  il.next = 27;
                                  break;
                                }
                                return this.logger.info("Disconnection occurred before the reconnection finished"), il.abrupt("return");
                              case 27:
                                this.logger.info("Successfully reconnected!"), ta && this.emit(_i.events.RECONNECT_SUCCESS), il.next = 35;
                                break;
                              case 31:
                                il.prev = 31, il.t0 = il.catch(18), this.logger.error("Failed to reconnect"), ta && this.emit(_i.events.RECONNECT_FAILURE, {
                                  error: il.t0
                                });
                              case 35:
                                return il.prev = 35, this.isConnecting = !1, this.isReconnecting = !1, il.finish(35);
                              case 39:
                              case "end":
                                return il.stop();
                            }
                          }, na, this, [[18, 31, 35, 39]]);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "_reconnect",
                      value: (function() {
                        var Po = Yd(/* @__PURE__ */ sd().mark(function na(ta, Fo) {
                          var Wa, Va, wa = arguments;
                          return sd().wrap(function(ol) {
                            for (; ; ) switch (ol.prev = ol.next) {
                              case 0:
                                if (Wa = wa.length > 2 && wa[2] !== void 0 ? wa[2] : 0, !this.isDestroyed) {
                                  ol.next = 4;
                                  break;
                                }
                                return this.logger.info("Tried to _reconnect on destroyed RouterConnectionManager"), ol.abrupt("return");
                              case 4:
                                if (!this.isDisconnecting) {
                                  ol.next = 7;
                                  break;
                                }
                                return this.logger.info("Tried to _reconnect while there was a disconnection in progress"), ol.abrupt("return");
                              case 7:
                                if (!this.isConnected) {
                                  ol.next = 10;
                                  break;
                                }
                                return this.logger.info("Already connected."), ol.abrupt("return");
                              case 10:
                                if (Wa++, !(this.MAX_RECONNECTION_ATTEMPTS && Wa > this.MAX_RECONNECTION_ATTEMPTS)) {
                                  ol.next = 13;
                                  break;
                                }
                                throw new Error("Failed to reconnect after ".concat(Wa, " attempts."));
                              case 13:
                                if (!(this.MAX_RECONNECTION_TIME && Date.now() > Fo)) {
                                  ol.next = 15;
                                  break;
                                }
                                throw new Error("Failed to reconnect after ".concat(this.MAX_RECONNECTION_TIME, " seconds."));
                              case 15:
                                return Wa > 1 && this.logger.warn("Reconnection attempt #".concat(Wa, "...")), ol.prev = 16, ol.next = 19, this.disconnect(!1);
                              case 19:
                                return ol.next = 21, (0, Ws.w)(this._connect(), this.IMMEDIATE_RECONNECTION_DELAY * 1e3);
                              case 21:
                                this.isConnected = !0, this.statsManager.start(), this.logger.info("Reconnected successfully after ".concat(Wa, " attempts")), ol.next = 35;
                                break;
                              case 26:
                                return ol.prev = 26, ol.t0 = ol.catch(16), this.logger.error("Error while trying to reconnect:"), this.logger.error(ol.t0), Va = Date.now() - ta > this.IMMEDIATE_RECONNECTION_DURATION * 1e3 ? this.RECONNECTION_DELAY : this.IMMEDIATE_RECONNECTION_DELAY, ol.next = 33, (0, Mi.sleepSeconds)(Va);
                              case 33:
                                return ol.next = 35, this._reconnect(ta, Fo, Wa);
                              case 35:
                              case "end":
                                return ol.stop();
                            }
                          }, na, this, [[16, 26]]);
                        }));
                        function Gi(na, ta) {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "disconnect",
                      value: (function() {
                        var Po = Yd(/* @__PURE__ */ sd().mark(function na() {
                          var ta, Fo = arguments;
                          return sd().wrap(function(Va) {
                            for (; ; ) switch (Va.prev = Va.next) {
                              case 0:
                                if (ta = Fo.length > 0 && Fo[0] !== void 0 ? Fo[0] : !0, !this.isDestroyComplete) {
                                  Va.next = 4;
                                  break;
                                }
                                return this.logger.info("Tried to disconnect on a destroyed RouterConnectionManager"), Va.abrupt("return");
                              case 4:
                                if (!this.isDisconnecting) {
                                  Va.next = 7;
                                  break;
                                }
                                return this.logger.info("There is already a disconnection in progress"), Va.abrupt("return");
                              case 7:
                                if (this.isConnected) {
                                  Va.next = 9;
                                  break;
                                }
                                return Va.abrupt("return");
                              case 9:
                                return this.logger.info("Disconnecting..."), this.isDisconnecting = !0, Va.prev = 11, this.statsManager.stop(), Va.next = 15, (0, Ws.w)(this._disconnect(), this.IMMEDIATE_RECONNECTION_DELAY * 1e3);
                              case 15:
                                ta && this.emit(_i.events.DISCONNECT_SUCCESS), Va.next = 28;
                                break;
                              case 18:
                                if (Va.prev = 18, Va.t0 = Va.catch(11), !this.isDestroyComplete) {
                                  Va.next = 23;
                                  break;
                                }
                                return this.logger.info("Disconnect failed while destroyed"), Va.abrupt("return");
                              case 23:
                                if (!this.routerTransactionManager.iframeWasDestroyedExternally) {
                                  Va.next = 26;
                                  break;
                                }
                                return this.logger.info("Disconnect failed while iframe was destroyed externally"), Va.abrupt("return");
                              case 26:
                                throw ta && this.emit(_i.events.DISCONNECT_FAILURE, {
                                  error: Va.t0
                                }), Va.t0;
                              case 28:
                                return Va.prev = 28, this._onDisconnect = null, this.isConnected = !1, this.isDisconnecting = !1, Va.finish(28);
                              case 33:
                              case "end":
                                return Va.stop();
                            }
                          }, na, this, [[11, 18, 28, 33]]);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "_disconnect",
                      value: function() {
                        var Gi = this;
                        return new Promise(function(na, ta) {
                          Gi._onDisconnect = function(Fo) {
                            if (Fo)
                              return ta(Fo);
                            na();
                          }, Gi.routerTransactionManager.issueCommand(_i.routerCommands.DISCONNECT);
                        });
                      }
                    }, {
                      key: "_handleDisconnectRouterEvent",
                      value: function(Gi, na) {
                        switch (Gi) {
                          case _i.routerEvents.DISCONNECT_SUCCESS: {
                            this._onDisconnect();
                            break;
                          }
                          case _i.routerEvents.DISCONNECT_FAILURE: {
                            this._onDisconnect(new Error(na.data.reason));
                            break;
                          }
                          default:
                            throw new Error("Unknown eventType: ".concat(Gi));
                        }
                      }
                      /**
                       * Handler for the CONNECTION_LOST event.  Will stop stats and attempt to
                       * reconnect.
                       *
                       * @param {*} event
                       */
                    }, {
                      key: "_handleConnectionLostRouterEvent",
                      value: function(Gi) {
                        var na = Gi.data.event;
                        this.logger.debug('connection lost "'.concat(na, '" event')), this.isConnected = !1, this.statsManager.stop(), this.reconnect();
                      }
                    }, {
                      key: "onRouterEvent",
                      value: function(Gi, na) {
                        if (this.isDestroyComplete)
                          throw new Error("Tried to handle Router event ".concat(Gi, " after destroy was complete!"));
                        switch (Gi) {
                          case _i.routerEvents.CONNECT_SUCCESS:
                          case _i.routerEvents.CONNECT_FAILURE: {
                            this._handleConnectRouterEvent(Gi, na);
                            break;
                          }
                          case _i.routerEvents.DISCONNECT_SUCCESS:
                          case _i.routerEvents.DISCONNECT_FAILURE: {
                            this._handleDisconnectRouterEvent(Gi, na);
                            break;
                          }
                          case _i.routerEvents.CONNECTION_LOST: {
                            this._handleConnectionLostRouterEvent(na);
                            break;
                          }
                          default:
                            throw new Error("Unknown eventType: ".concat(Gi));
                        }
                      }
                    }, {
                      key: "_destroy",
                      value: (function() {
                        var Po = Yd(/* @__PURE__ */ sd().mark(function na() {
                          return sd().wrap(function(Fo) {
                            for (; ; ) switch (Fo.prev = Fo.next) {
                              case 0:
                                return Fo.prev = 0, Fo.next = 3, this.disconnect();
                              case 3:
                                Fo.next = 9;
                                break;
                              case 5:
                                Fo.prev = 5, Fo.t0 = Fo.catch(0), this.logger.error("Error while disconnecting while destroying:"), this.logger.error(Fo.t0);
                              case 9:
                                return Fo.prev = 9, Fo.next = 12, this.statsManager.destroy();
                              case 12:
                                Fo.next = 18;
                                break;
                              case 14:
                                Fo.prev = 14, Fo.t1 = Fo.catch(9), this.logger.error("Error while destroying statsManager while destroying:"), this.logger.error(Fo.t1);
                              case 18:
                                return this.statsManager = null, this.routerTransactionManager = null, this._onConnect = null, this._onDisconnect = null, Fo.next = 24, sf(_i, "_destroy", this, 3)([]);
                              case 24:
                              case "end":
                                return Fo.stop();
                            }
                          }, na, this, [[0, 5], [9, 14]]);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }], [{
                      key: "factory",
                      value: function(Gi, na, ta) {
                        return new _i(Gi, na, ta);
                      }
                    }]);
                  })(Ya);
                  gd(Pd, "events", {
                    // Emitted when a connection attempt
                    CONNECT_SUCCESS: "connect-success",
                    CONNECT_FAILURE: "connect-failure",
                    RECONNECT_SUCCESS: "reconnect-success",
                    RECONNECT_FAILURE: "reconnect-failure",
                    DISCONNECT_SUCCESS: "disconnect-success",
                    DISCONNECT_FAILURE: "disconnect-failure"
                  }), gd(Pd, "routerEvents", {
                    CONNECT_SUCCESS: Ya.routerEvents.CONNECT_SUCCESS,
                    CONNECT_FAILURE: Ya.routerEvents.CONNECT_FAILURE,
                    DISCONNECT_SUCCESS: Ya.routerEvents.DISCONNECT_SUCCESS,
                    DISCONNECT_FAILURE: Ya.routerEvents.DISCONNECT_FAILURE,
                    CONNECTION_LOST: Ya.routerEvents.CONNECTION_LOST
                  });
                  function Cd() {
                    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
                    Cd = function() {
                      return _i;
                    };
                    var Ai, _i = {}, Po = Object.prototype, Gi = Po.hasOwnProperty, na = Object.defineProperty || function(Bi, Ci, ki) {
                      Bi[Ci] = ki.value;
                    }, ta = typeof Symbol == "function" ? Symbol : {}, Fo = ta.iterator || "@@iterator", Wa = ta.asyncIterator || "@@asyncIterator", Va = ta.toStringTag || "@@toStringTag";
                    function wa(Bi, Ci, ki) {
                      return Object.defineProperty(Bi, Ci, { value: ki, enumerable: !0, configurable: !0, writable: !0 }), Bi[Ci];
                    }
                    try {
                      wa({}, "");
                    } catch {
                      wa = function(ki, Mo, Xo) {
                        return ki[Mo] = Xo;
                      };
                    }
                    function il(Bi, Ci, ki, Mo) {
                      var Xo = Ci && Ci.prototype instanceof pu ? Ci : pu, Uo = Object.create(Xo.prototype), qa = new ku(Mo || []);
                      return na(Uo, "_invoke", { value: pc(Bi, ki, qa) }), Uo;
                    }
                    function ol(Bi, Ci, ki) {
                      try {
                        return { type: "normal", arg: Bi.call(Ci, ki) };
                      } catch (Mo) {
                        return { type: "throw", arg: Mo };
                      }
                    }
                    _i.wrap = il;
                    var Ql = "suspendedStart", Uu = "suspendedYield", Wu = "executing", Kl = "completed", pl = {};
                    function pu() {
                    }
                    function lu() {
                    }
                    function Nl() {
                    }
                    var Eu = {};
                    wa(Eu, Fo, function() {
                      return this;
                    });
                    var wu = Object.getPrototypeOf, yu = wu && wu(wu(Nu([])));
                    yu && yu !== Po && Gi.call(yu, Fo) && (Eu = yu);
                    var zl = Nl.prototype = pu.prototype = Object.create(Eu);
                    function Qu(Bi) {
                      ["next", "throw", "return"].forEach(function(Ci) {
                        wa(Bi, Ci, function(ki) {
                          return this._invoke(Ci, ki);
                        });
                      });
                    }
                    function gu(Bi, Ci) {
                      function ki(Xo, Uo, qa, Us) {
                        var Hs = ol(Bi[Xo], Bi, Uo);
                        if (Hs.type !== "throw") {
                          var jl = Hs.arg, Al = jl.value;
                          return Al && typeof Al == "object" && Gi.call(Al, "__await") ? Ci.resolve(Al.__await).then(function(Ml) {
                            ki("next", Ml, qa, Us);
                          }, function(Ml) {
                            ki("throw", Ml, qa, Us);
                          }) : Ci.resolve(Al).then(function(Ml) {
                            jl.value = Ml, qa(jl);
                          }, function(Ml) {
                            return ki("throw", Ml, qa, Us);
                          });
                        }
                        Us(Hs.arg);
                      }
                      var Mo;
                      na(this, "_invoke", { value: function(Uo, qa) {
                        function Us() {
                          return new Ci(function(Hs, jl) {
                            ki(Uo, qa, Hs, jl);
                          });
                        }
                        return Mo = Mo ? Mo.then(Us, Us) : Us();
                      } });
                    }
                    function pc(Bi, Ci, ki) {
                      var Mo = Ql;
                      return function(Xo, Uo) {
                        if (Mo === Wu) throw Error("Generator is already running");
                        if (Mo === Kl) {
                          if (Xo === "throw") throw Uo;
                          return { value: Ai, done: !0 };
                        }
                        for (ki.method = Xo, ki.arg = Uo; ; ) {
                          var qa = ki.delegate;
                          if (qa) {
                            var Us = Zu(qa, ki);
                            if (Us) {
                              if (Us === pl) continue;
                              return Us;
                            }
                          }
                          if (ki.method === "next") ki.sent = ki._sent = ki.arg;
                          else if (ki.method === "throw") {
                            if (Mo === Ql) throw Mo = Kl, ki.arg;
                            ki.dispatchException(ki.arg);
                          } else ki.method === "return" && ki.abrupt("return", ki.arg);
                          Mo = Wu;
                          var Hs = ol(Bi, Ci, ki);
                          if (Hs.type === "normal") {
                            if (Mo = ki.done ? Kl : Uu, Hs.arg === pl) continue;
                            return { value: Hs.arg, done: ki.done };
                          }
                          Hs.type === "throw" && (Mo = Kl, ki.method = "throw", ki.arg = Hs.arg);
                        }
                      };
                    }
                    function Zu(Bi, Ci) {
                      var ki = Ci.method, Mo = Bi.iterator[ki];
                      if (Mo === Ai) return Ci.delegate = null, ki === "throw" && Bi.iterator.return && (Ci.method = "return", Ci.arg = Ai, Zu(Bi, Ci), Ci.method === "throw") || ki !== "return" && (Ci.method = "throw", Ci.arg = new TypeError("The iterator does not provide a '" + ki + "' method")), pl;
                      var Xo = ol(Mo, Bi.iterator, Ci.arg);
                      if (Xo.type === "throw") return Ci.method = "throw", Ci.arg = Xo.arg, Ci.delegate = null, pl;
                      var Uo = Xo.arg;
                      return Uo ? Uo.done ? (Ci[Bi.resultName] = Uo.value, Ci.next = Bi.nextLoc, Ci.method !== "return" && (Ci.method = "next", Ci.arg = Ai), Ci.delegate = null, pl) : Uo : (Ci.method = "throw", Ci.arg = new TypeError("iterator result is not an object"), Ci.delegate = null, pl);
                    }
                    function gc(Bi) {
                      var Ci = { tryLoc: Bi[0] };
                      1 in Bi && (Ci.catchLoc = Bi[1]), 2 in Bi && (Ci.finallyLoc = Bi[2], Ci.afterLoc = Bi[3]), this.tryEntries.push(Ci);
                    }
                    function Du(Bi) {
                      var Ci = Bi.completion || {};
                      Ci.type = "normal", delete Ci.arg, Bi.completion = Ci;
                    }
                    function ku(Bi) {
                      this.tryEntries = [{ tryLoc: "root" }], Bi.forEach(gc, this), this.reset(!0);
                    }
                    function Nu(Bi) {
                      if (Bi || Bi === "") {
                        var Ci = Bi[Fo];
                        if (Ci) return Ci.call(Bi);
                        if (typeof Bi.next == "function") return Bi;
                        if (!isNaN(Bi.length)) {
                          var ki = -1, Mo = function Xo() {
                            for (; ++ki < Bi.length; ) if (Gi.call(Bi, ki)) return Xo.value = Bi[ki], Xo.done = !1, Xo;
                            return Xo.value = Ai, Xo.done = !0, Xo;
                          };
                          return Mo.next = Mo;
                        }
                      }
                      throw new TypeError(typeof Bi + " is not iterable");
                    }
                    return lu.prototype = Nl, na(zl, "constructor", { value: Nl, configurable: !0 }), na(Nl, "constructor", { value: lu, configurable: !0 }), lu.displayName = wa(Nl, Va, "GeneratorFunction"), _i.isGeneratorFunction = function(Bi) {
                      var Ci = typeof Bi == "function" && Bi.constructor;
                      return !!Ci && (Ci === lu || (Ci.displayName || Ci.name) === "GeneratorFunction");
                    }, _i.mark = function(Bi) {
                      return Object.setPrototypeOf ? Object.setPrototypeOf(Bi, Nl) : (Bi.__proto__ = Nl, wa(Bi, Va, "GeneratorFunction")), Bi.prototype = Object.create(zl), Bi;
                    }, _i.awrap = function(Bi) {
                      return { __await: Bi };
                    }, Qu(gu.prototype), wa(gu.prototype, Wa, function() {
                      return this;
                    }), _i.AsyncIterator = gu, _i.async = function(Bi, Ci, ki, Mo, Xo) {
                      Xo === void 0 && (Xo = Promise);
                      var Uo = new gu(il(Bi, Ci, ki, Mo), Xo);
                      return _i.isGeneratorFunction(Ci) ? Uo : Uo.next().then(function(qa) {
                        return qa.done ? qa.value : Uo.next();
                      });
                    }, Qu(zl), wa(zl, Va, "Generator"), wa(zl, Fo, function() {
                      return this;
                    }), wa(zl, "toString", function() {
                      return "[object Generator]";
                    }), _i.keys = function(Bi) {
                      var Ci = Object(Bi), ki = [];
                      for (var Mo in Ci) ki.push(Mo);
                      return ki.reverse(), function Xo() {
                        for (; ki.length; ) {
                          var Uo = ki.pop();
                          if (Uo in Ci) return Xo.value = Uo, Xo.done = !1, Xo;
                        }
                        return Xo.done = !0, Xo;
                      };
                    }, _i.values = Nu, ku.prototype = { constructor: ku, reset: function(Ci) {
                      if (this.prev = 0, this.next = 0, this.sent = this._sent = Ai, this.done = !1, this.delegate = null, this.method = "next", this.arg = Ai, this.tryEntries.forEach(Du), !Ci) for (var ki in this) ki.charAt(0) === "t" && Gi.call(this, ki) && !isNaN(+ki.slice(1)) && (this[ki] = Ai);
                    }, stop: function() {
                      this.done = !0;
                      var Ci = this.tryEntries[0].completion;
                      if (Ci.type === "throw") throw Ci.arg;
                      return this.rval;
                    }, dispatchException: function(Ci) {
                      if (this.done) throw Ci;
                      var ki = this;
                      function Mo(jl, Al) {
                        return qa.type = "throw", qa.arg = Ci, ki.next = jl, Al && (ki.method = "next", ki.arg = Ai), !!Al;
                      }
                      for (var Xo = this.tryEntries.length - 1; Xo >= 0; --Xo) {
                        var Uo = this.tryEntries[Xo], qa = Uo.completion;
                        if (Uo.tryLoc === "root") return Mo("end");
                        if (Uo.tryLoc <= this.prev) {
                          var Us = Gi.call(Uo, "catchLoc"), Hs = Gi.call(Uo, "finallyLoc");
                          if (Us && Hs) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          } else if (Us) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                          } else {
                            if (!Hs) throw Error("try statement without catch or finally");
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          }
                        }
                      }
                    }, abrupt: function(Ci, ki) {
                      for (var Mo = this.tryEntries.length - 1; Mo >= 0; --Mo) {
                        var Xo = this.tryEntries[Mo];
                        if (Xo.tryLoc <= this.prev && Gi.call(Xo, "finallyLoc") && this.prev < Xo.finallyLoc) {
                          var Uo = Xo;
                          break;
                        }
                      }
                      Uo && (Ci === "break" || Ci === "continue") && Uo.tryLoc <= ki && ki <= Uo.finallyLoc && (Uo = null);
                      var qa = Uo ? Uo.completion : {};
                      return qa.type = Ci, qa.arg = ki, Uo ? (this.method = "next", this.next = Uo.finallyLoc, pl) : this.complete(qa);
                    }, complete: function(Ci, ki) {
                      if (Ci.type === "throw") throw Ci.arg;
                      return Ci.type === "break" || Ci.type === "continue" ? this.next = Ci.arg : Ci.type === "return" ? (this.rval = this.arg = Ci.arg, this.method = "return", this.next = "end") : Ci.type === "normal" && ki && (this.next = ki), pl;
                    }, finish: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.finallyLoc === Ci) return this.complete(Mo.completion, Mo.afterLoc), Du(Mo), pl;
                      }
                    }, catch: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.tryLoc === Ci) {
                          var Xo = Mo.completion;
                          if (Xo.type === "throw") {
                            var Uo = Xo.arg;
                            Du(Mo);
                          }
                          return Uo;
                        }
                      }
                      throw Error("illegal catch attempt");
                    }, delegateYield: function(Ci, ki, Mo) {
                      return this.delegate = { iterator: Nu(Ci), resultName: ki, nextLoc: Mo }, this.method === "next" && (this.arg = Ai), pl;
                    } }, _i;
                  }
                  function Hf(Ai, _i, Po, Gi, na, ta, Fo) {
                    try {
                      var Wa = Ai[ta](Fo), Va = Wa.value;
                    } catch (wa) {
                      return void Po(wa);
                    }
                    Wa.done ? _i(Va) : Promise.resolve(Va).then(Gi, na);
                  }
                  function Zd(Ai) {
                    return function() {
                      var _i = this, Po = arguments;
                      return new Promise(function(Gi, na) {
                        var ta = Ai.apply(_i, Po);
                        function Fo(Va) {
                          Hf(ta, Gi, na, Fo, Wa, "next", Va);
                        }
                        function Wa(Va) {
                          Hf(ta, Gi, na, Fo, Wa, "throw", Va);
                        }
                        Fo(void 0);
                      });
                    };
                  }
                  function ef(Ai, _i) {
                    if (!(Ai instanceof _i)) throw new TypeError("Cannot call a class as a function");
                  }
                  function Yp(Ai, _i) {
                    for (var Po = 0; Po < _i.length; Po++) {
                      var Gi = _i[Po];
                      Gi.enumerable = Gi.enumerable || !1, Gi.configurable = !0, "value" in Gi && (Gi.writable = !0), Object.defineProperty(Ai, Rp(Gi.key), Gi);
                    }
                  }
                  function Th(Ai, _i, Po) {
                    return _i && Yp(Ai.prototype, _i), Po && Yp(Ai, Po), Object.defineProperty(Ai, "prototype", { writable: !1 }), Ai;
                  }
                  function Jh(Ai, _i, Po) {
                    return _i = wf(_i), Eh(Ai, Rd() ? Reflect.construct(_i, Po || [], wf(Ai).constructor) : _i.apply(Ai, Po));
                  }
                  function Eh(Ai, _i) {
                    if (_i && (typeof _i == "object" || typeof _i == "function")) return _i;
                    if (_i !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return Cp(Ai);
                  }
                  function Cp(Ai) {
                    if (Ai === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return Ai;
                  }
                  function Rd() {
                    try {
                      var Ai = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                      }));
                    } catch {
                    }
                    return (Rd = function() {
                      return !!Ai;
                    })();
                  }
                  function Qh(Ai, _i, Po, Gi) {
                    var na = md(wf(Ai.prototype), _i, Po);
                    return 2 & Gi && typeof na == "function" ? function(ta) {
                      return na.apply(Po, ta);
                    } : na;
                  }
                  function md() {
                    return md = typeof Reflect < "u" && Reflect.get ? Reflect.get.bind() : function(Ai, _i, Po) {
                      var Gi = ld(Ai, _i);
                      if (Gi) {
                        var na = Object.getOwnPropertyDescriptor(Gi, _i);
                        return na.get ? na.get.call(arguments.length < 3 ? Ai : Po) : na.value;
                      }
                    }, md.apply(null, arguments);
                  }
                  function ld(Ai, _i) {
                    for (; !{}.hasOwnProperty.call(Ai, _i) && (Ai = wf(Ai)) !== null; ) ;
                    return Ai;
                  }
                  function wf(Ai) {
                    return wf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(_i) {
                      return _i.__proto__ || Object.getPrototypeOf(_i);
                    }, wf(Ai);
                  }
                  function zf(Ai, _i) {
                    if (typeof _i != "function" && _i !== null) throw new TypeError("Super expression must either be null or a function");
                    Ai.prototype = Object.create(_i && _i.prototype, { constructor: { value: Ai, writable: !0, configurable: !0 } }), Object.defineProperty(Ai, "prototype", { writable: !1 }), _i && ip(Ai, _i);
                  }
                  function ip(Ai, _i) {
                    return ip = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(Po, Gi) {
                      return Po.__proto__ = Gi, Po;
                    }, ip(Ai, _i);
                  }
                  function Sh(Ai, _i, Po) {
                    return (_i = Rp(_i)) in Ai ? Object.defineProperty(Ai, _i, { value: Po, enumerable: !0, configurable: !0, writable: !0 }) : Ai[_i] = Po, Ai;
                  }
                  function Rp(Ai) {
                    var _i = xh(Ai, "string");
                    return typeof _i == "symbol" ? _i : _i + "";
                  }
                  function xh(Ai, _i) {
                    if (typeof Ai != "object" || !Ai) return Ai;
                    var Po = Ai[Symbol.toPrimitive];
                    if (Po !== void 0) {
                      var Gi = Po.call(Ai, _i);
                      if (typeof Gi != "object") return Gi;
                      throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (_i === "string" ? String : Number)(Ai);
                  }
                  var Od = /* @__PURE__ */ (function(Ai) {
                    function _i(Po, Gi, na, ta) {
                      var Fo;
                      if (ef(this, _i), Fo = Jh(this, _i, [Po]), !Gi)
                        throw new Error("clientId is required to construct a new Conduit instance.");
                      if (!bu.isStreamConfiguration(na))
                        throw new Error("invalid streamConfiguration passed to Conduit constructor");
                      if (!ta)
                        throw new Error("containerElement is required to construct a new Conduit instance");
                      return Fo.clientId = Gi, Fo.streamConfiguration = na, Fo.containerElement = ta, Fo.isInitialized = !1, Fo.routerIframeManager = Bd.factory(Fo.logId, Fo.clientId, Fo.streamConfiguration, Fo.containerElement), Fo.routerTransactionManager = $d.factory(Fo.logId, Fo.clientId, Fo.routerIframeManager), Fo.routerConnectionManager = Pd.factory(Fo.logId, Fo.clientId, Fo.routerTransactionManager), Fo.routerStreamManager = ad.factory(Fo.logId, Fo.clientId, Fo.streamConfiguration, Fo.routerTransactionManager), Fo;
                    }
                    return zf(_i, Ai), Th(_i, [{
                      key: "initialize",
                      value: (function() {
                        var Po = Zd(/* @__PURE__ */ Cd().mark(function na() {
                          var ta = this;
                          return Cd().wrap(function(Wa) {
                            for (; ; ) switch (Wa.prev = Wa.next) {
                              case 0:
                                return this.routerIframeManager.on(Bd.events.IFRAME_DESTROYED_EXTERNALLY, function() {
                                  if (ta.isDestroyed) {
                                    ta.logger.info("Iframe was destroyed externally while in process of destroying");
                                    return;
                                  }
                                  ta.emit(_i.events.IFRAME_DESTROYED_EXTERNALLY), ta.routerConnectionManager.disconnect();
                                }), this.routerConnectionManager.on(Pd.events.RECONNECT_SUCCESS, function() {
                                  ta.emit(_i.events.RECONNECT_SUCCESS);
                                }), this.routerConnectionManager.on(Pd.events.RECONNECT_FAILURE, function(Va) {
                                  var wa = Va.error;
                                  ta.emit(_i.events.RECONNECT_FAILURE, {
                                    error: wa
                                  });
                                }), this.routerStreamManager.on(ad.events.RESYNC_STREAM_COMPLETE, function(Va) {
                                  ta.emit(_i.events.RESYNC_STREAM_COMPLETE, Va);
                                }), this.routerStreamManager.on(ad.events.VIDEO_SEGMENT_RECEIVED, function(Va) {
                                  ta.emit(_i.events.VIDEO_SEGMENT_RECEIVED, Va);
                                }), this.routerStreamManager.on(ad.events.VIDEO_SEGMENT_TIMEOUT, function(Va) {
                                  ta.logger.warn("Did not receive a video segment for ".concat(ta.routerStreamManager.streamName, " in ").concat(Va.timeout, " seconds, attempting to reconnect...")), ta.routerConnectionManager.reconnect();
                                }), this.routerStreamManager.on(ad.events.JWT_AUTHORIZATION_FAILURE, function(Va) {
                                  ta.emit(_i.events.JWT_AUTHORIZATION_FAILURE, Va);
                                }), Wa.next = 9, this.routerIframeManager.create();
                              case 9:
                                this.isInitialized = !0;
                              case 10:
                              case "end":
                                return Wa.stop();
                            }
                          }, na, this);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                      /**
                       * Play the configured stream.
                       *
                       * @returns {object}
                       *  - guid
                       *  - mimeCodec
                       *  - moov
                       */
                    }, {
                      key: "play",
                      value: (function() {
                        var Po = Zd(/* @__PURE__ */ Cd().mark(function na() {
                          var ta, Fo, Wa, Va;
                          return Cd().wrap(function(il) {
                            for (; ; ) switch (il.prev = il.next) {
                              case 0:
                                if (!this.isDestroyed) {
                                  il.next = 3;
                                  break;
                                }
                                return this.logger.info("Tried to play a stream from a destroyed Conduit"), il.abrupt("return");
                              case 3:
                                if (this.isInitialized) {
                                  il.next = 6;
                                  break;
                                }
                                return this.logger.info("Tried to play a stream without first initializing the Conduit"), il.abrupt("return");
                              case 6:
                                return this.logger.info("Playing..."), il.prev = 7, il.next = 10, this.routerConnectionManager.connect();
                              case 10:
                                il.next = 17;
                                break;
                              case 12:
                                throw il.prev = 12, il.t0 = il.catch(7), this.logger.error("Error while trying to connect before playing:"), this.logger.error(il.t0), il.t0;
                              case 17:
                                return il.prev = 17, il.next = 20, this.routerStreamManager.play();
                              case 20:
                                return ta = il.sent, Fo = ta.guid, Wa = ta.mimeCodec, Va = ta.moov, il.abrupt("return", {
                                  guid: Fo,
                                  mimeCodec: Wa,
                                  moov: Va
                                });
                              case 27:
                                return il.prev = 27, il.t1 = il.catch(17), this.logger.error("Error trying to play stream ".concat(this.routerStreamManager.streamName)), il.next = 32, this.stop();
                              case 32:
                                throw il.t1;
                              case 33:
                              case "end":
                                return il.stop();
                            }
                          }, na, this, [[7, 12], [17, 27]]);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "stop",
                      value: (function() {
                        var Po = Zd(/* @__PURE__ */ Cd().mark(function na() {
                          return Cd().wrap(function(Fo) {
                            for (; ; ) switch (Fo.prev = Fo.next) {
                              case 0:
                                return this.logger.info("Stopping stream..."), Fo.prev = 1, Fo.next = 4, this.routerStreamManager.stop();
                              case 4:
                                Fo.next = 9;
                                break;
                              case 6:
                                Fo.prev = 6, Fo.t0 = Fo.catch(1), this.routerIframeManager.wasIframeDestroyedExternally() || (this.logger.error("Error while stopping while destroying"), this.logger.error(Fo.t0));
                              case 9:
                                return Fo.prev = 9, Fo.next = 12, this.routerConnectionManager.disconnect();
                              case 12:
                                Fo.next = 17;
                                break;
                              case 14:
                                Fo.prev = 14, Fo.t1 = Fo.catch(9), this.routerIframeManager.wasIframeDestroyedExternally() || (this.logger.error("Error while stopping while destroying"), this.logger.error(Fo.t1));
                              case 17:
                              case "end":
                                return Fo.stop();
                            }
                          }, na, this, [[1, 6], [9, 14]]);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "segmentUsed",
                      value: function(Gi) {
                        this.shouldLogSourceBuffer && this.logSourceBufferTopic && this.routerTransactionManager.directSend(this.logSourceBufferTopic, Gi), this.routerConnectionManager.statsManager.updateByteCount(Gi);
                      }
                      /**
                       * When the Router sends a message back from its iframe, the Conduit
                       * Collection handles it.  If the message was meant for this Conduit, the
                       * Conduit Collection will call this method with the event data.
                       *
                       * @param {Object} event
                       *   We expect event to have "data.event", which represents the event that
                       *   occurred relative to the clsp stream.  "ready" means the stream is ready,
                       *   "fail" means there was an error, "data" means a video segment / moof was
                       *   sent.
                       */
                    }, {
                      key: "onRouterEvent",
                      value: function(Gi, na) {
                        this.logger.debug('Message received for "'.concat(Gi, '" event'));
                        try {
                          switch (Gi) {
                            case Bd.routerEvents.CREATE_SUCCESS:
                            case Bd.routerEvents.CREATE_FAILURE: {
                              this.routerIframeManager._handleRouterCreatedEvent(Gi, na);
                              break;
                            }
                            case Pd.routerEvents.CONNECT_SUCCESS:
                            case Pd.routerEvents.CONNECT_FAILURE:
                            case Pd.routerEvents.DISCONNECT_SUCCESS:
                            case Pd.routerEvents.DISCONNECT_FAILURE:
                            case Pd.routerEvents.CONNECTION_LOST: {
                              this.routerConnectionManager.onRouterEvent(Gi, na);
                              break;
                            }
                            case $d.routerEvents.UNSUBSCRIBE_SUCCESS:
                            case $d.routerEvents.UNSUBSCRIBE_FAILURE:
                            case $d.routerEvents.PUBLISH_SUCCESS:
                            case $d.routerEvents.PUBLISH_FAILURE:
                            case $d.routerEvents.MESSAGE_ARRIVED: {
                              this.routerTransactionManager.onRouterEvent(Gi, na);
                              break;
                            }
                            case _i.routerEvents.WINDOW_MESSAGE_FAIL: {
                              this.routerConnectionManager.disconnect();
                              break;
                            }
                            // Log the error, but don't throw
                            default:
                              this.logger.error("No match for event: ".concat(Gi));
                          }
                        } catch (ta) {
                          this.logger.error("onMessageError"), this.logger.error(ta), this.emit(_i.events.ROUTER_EVENT_ERROR, {
                            error: ta
                          });
                        }
                      }
                      /**
                       * @async
                       *
                       * Clean up and dereference the necessary properties.  Will also disconnect
                       * and destroy the iframe.
                       *
                       * @returns {void}
                       */
                    }, {
                      key: "_destroy",
                      value: (function() {
                        var Po = Zd(/* @__PURE__ */ Cd().mark(function na() {
                          return Cd().wrap(function(Fo) {
                            for (; ; ) switch (Fo.prev = Fo.next) {
                              case 0:
                                return Fo.prev = 0, Fo.next = 3, this.stop();
                              case 3:
                                Fo.next = 9;
                                break;
                              case 5:
                                Fo.prev = 5, Fo.t0 = Fo.catch(0), this.logger.error("Error while stopping while destroying"), this.logger.error(Fo.t0);
                              case 9:
                                return Fo.prev = 9, Fo.next = 12, this.routerStreamManager.destroy();
                              case 12:
                                Fo.next = 18;
                                break;
                              case 14:
                                Fo.prev = 14, Fo.t1 = Fo.catch(9), this.logger.error("Error while destroying routerStreamManager while destroying"), this.logger.error(Fo.t1);
                              case 18:
                                return Fo.prev = 18, Fo.next = 21, this.routerConnectionManager.destroy();
                              case 21:
                                Fo.next = 27;
                                break;
                              case 23:
                                Fo.prev = 23, Fo.t2 = Fo.catch(18), this.logger.error("Error while destroying routerConnectionManager while destroying"), this.logger.error(Fo.t2);
                              case 27:
                                return Fo.prev = 27, Fo.next = 30, this.routerTransactionManager.destroy();
                              case 30:
                                Fo.next = 36;
                                break;
                              case 32:
                                Fo.prev = 32, Fo.t3 = Fo.catch(27), this.logger.error("Error while destroying routerTransactionManager while destroying"), this.logger.error(Fo.t3);
                              case 36:
                                return Fo.prev = 36, Fo.next = 39, this.routerIframeManager.destroy();
                              case 39:
                                Fo.next = 45;
                                break;
                              case 41:
                                Fo.prev = 41, Fo.t4 = Fo.catch(36), this.logger.error("Error while destroying routerIframeManager while destroying"), this.logger.error(Fo.t4);
                              case 45:
                                return this.routerStreamManager = null, this.routerConnectionManager = null, this.routerTransactionManager = null, this.routerIframeManager = null, this.clientId = null, this.streamConfiguration = null, this.containerElement = null, Fo.next = 54, Qh(_i, "_destroy", this, 3)([]);
                              case 54:
                              case "end":
                                return Fo.stop();
                            }
                          }, na, this, [[0, 5], [9, 14], [18, 23], [27, 32], [36, 41]]);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }], [{
                      key: "factory",
                      value: function(Gi, na, ta, Fo) {
                        return new _i(Gi, na, ta, Fo);
                      }
                    }]);
                  })(ja);
                  Sh(Od, "events", {
                    ROUTER_EVENT_ERROR: "router-event-error",
                    RECONNECT_SUCCESS: Pd.events.RECONNECT_SUCCESS,
                    RECONNECT_FAILURE: Pd.events.RECONNECT_FAILURE,
                    RESYNC_STREAM_COMPLETE: ad.events.RESYNC_STREAM_COMPLETE,
                    VIDEO_SEGMENT_RECEIVED: ad.events.VIDEO_SEGMENT_RECEIVED,
                    IFRAME_DESTROYED_EXTERNALLY: Bd.events.IFRAME_DESTROYED_EXTERNALLY,
                    JWT_AUTHORIZATION_FAILURE: ad.events.JWT_AUTHORIZATION_FAILURE
                  }), Sh(Od, "routerEvents", Ya.routerEvents);
                  var Kf = oi(543), vc = /* @__PURE__ */ oi.n(Kf);
                  const Op = {
                    Paho: vc(),
                    register: function() {
                      window.Paho || (window.Paho = {
                        MQTT: vc()
                      });
                    }
                  };
                  function _f() {
                    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
                    _f = function() {
                      return _i;
                    };
                    var Ai, _i = {}, Po = Object.prototype, Gi = Po.hasOwnProperty, na = Object.defineProperty || function(Bi, Ci, ki) {
                      Bi[Ci] = ki.value;
                    }, ta = typeof Symbol == "function" ? Symbol : {}, Fo = ta.iterator || "@@iterator", Wa = ta.asyncIterator || "@@asyncIterator", Va = ta.toStringTag || "@@toStringTag";
                    function wa(Bi, Ci, ki) {
                      return Object.defineProperty(Bi, Ci, { value: ki, enumerable: !0, configurable: !0, writable: !0 }), Bi[Ci];
                    }
                    try {
                      wa({}, "");
                    } catch {
                      wa = function(ki, Mo, Xo) {
                        return ki[Mo] = Xo;
                      };
                    }
                    function il(Bi, Ci, ki, Mo) {
                      var Xo = Ci && Ci.prototype instanceof pu ? Ci : pu, Uo = Object.create(Xo.prototype), qa = new ku(Mo || []);
                      return na(Uo, "_invoke", { value: pc(Bi, ki, qa) }), Uo;
                    }
                    function ol(Bi, Ci, ki) {
                      try {
                        return { type: "normal", arg: Bi.call(Ci, ki) };
                      } catch (Mo) {
                        return { type: "throw", arg: Mo };
                      }
                    }
                    _i.wrap = il;
                    var Ql = "suspendedStart", Uu = "suspendedYield", Wu = "executing", Kl = "completed", pl = {};
                    function pu() {
                    }
                    function lu() {
                    }
                    function Nl() {
                    }
                    var Eu = {};
                    wa(Eu, Fo, function() {
                      return this;
                    });
                    var wu = Object.getPrototypeOf, yu = wu && wu(wu(Nu([])));
                    yu && yu !== Po && Gi.call(yu, Fo) && (Eu = yu);
                    var zl = Nl.prototype = pu.prototype = Object.create(Eu);
                    function Qu(Bi) {
                      ["next", "throw", "return"].forEach(function(Ci) {
                        wa(Bi, Ci, function(ki) {
                          return this._invoke(Ci, ki);
                        });
                      });
                    }
                    function gu(Bi, Ci) {
                      function ki(Xo, Uo, qa, Us) {
                        var Hs = ol(Bi[Xo], Bi, Uo);
                        if (Hs.type !== "throw") {
                          var jl = Hs.arg, Al = jl.value;
                          return Al && typeof Al == "object" && Gi.call(Al, "__await") ? Ci.resolve(Al.__await).then(function(Ml) {
                            ki("next", Ml, qa, Us);
                          }, function(Ml) {
                            ki("throw", Ml, qa, Us);
                          }) : Ci.resolve(Al).then(function(Ml) {
                            jl.value = Ml, qa(jl);
                          }, function(Ml) {
                            return ki("throw", Ml, qa, Us);
                          });
                        }
                        Us(Hs.arg);
                      }
                      var Mo;
                      na(this, "_invoke", { value: function(Uo, qa) {
                        function Us() {
                          return new Ci(function(Hs, jl) {
                            ki(Uo, qa, Hs, jl);
                          });
                        }
                        return Mo = Mo ? Mo.then(Us, Us) : Us();
                      } });
                    }
                    function pc(Bi, Ci, ki) {
                      var Mo = Ql;
                      return function(Xo, Uo) {
                        if (Mo === Wu) throw Error("Generator is already running");
                        if (Mo === Kl) {
                          if (Xo === "throw") throw Uo;
                          return { value: Ai, done: !0 };
                        }
                        for (ki.method = Xo, ki.arg = Uo; ; ) {
                          var qa = ki.delegate;
                          if (qa) {
                            var Us = Zu(qa, ki);
                            if (Us) {
                              if (Us === pl) continue;
                              return Us;
                            }
                          }
                          if (ki.method === "next") ki.sent = ki._sent = ki.arg;
                          else if (ki.method === "throw") {
                            if (Mo === Ql) throw Mo = Kl, ki.arg;
                            ki.dispatchException(ki.arg);
                          } else ki.method === "return" && ki.abrupt("return", ki.arg);
                          Mo = Wu;
                          var Hs = ol(Bi, Ci, ki);
                          if (Hs.type === "normal") {
                            if (Mo = ki.done ? Kl : Uu, Hs.arg === pl) continue;
                            return { value: Hs.arg, done: ki.done };
                          }
                          Hs.type === "throw" && (Mo = Kl, ki.method = "throw", ki.arg = Hs.arg);
                        }
                      };
                    }
                    function Zu(Bi, Ci) {
                      var ki = Ci.method, Mo = Bi.iterator[ki];
                      if (Mo === Ai) return Ci.delegate = null, ki === "throw" && Bi.iterator.return && (Ci.method = "return", Ci.arg = Ai, Zu(Bi, Ci), Ci.method === "throw") || ki !== "return" && (Ci.method = "throw", Ci.arg = new TypeError("The iterator does not provide a '" + ki + "' method")), pl;
                      var Xo = ol(Mo, Bi.iterator, Ci.arg);
                      if (Xo.type === "throw") return Ci.method = "throw", Ci.arg = Xo.arg, Ci.delegate = null, pl;
                      var Uo = Xo.arg;
                      return Uo ? Uo.done ? (Ci[Bi.resultName] = Uo.value, Ci.next = Bi.nextLoc, Ci.method !== "return" && (Ci.method = "next", Ci.arg = Ai), Ci.delegate = null, pl) : Uo : (Ci.method = "throw", Ci.arg = new TypeError("iterator result is not an object"), Ci.delegate = null, pl);
                    }
                    function gc(Bi) {
                      var Ci = { tryLoc: Bi[0] };
                      1 in Bi && (Ci.catchLoc = Bi[1]), 2 in Bi && (Ci.finallyLoc = Bi[2], Ci.afterLoc = Bi[3]), this.tryEntries.push(Ci);
                    }
                    function Du(Bi) {
                      var Ci = Bi.completion || {};
                      Ci.type = "normal", delete Ci.arg, Bi.completion = Ci;
                    }
                    function ku(Bi) {
                      this.tryEntries = [{ tryLoc: "root" }], Bi.forEach(gc, this), this.reset(!0);
                    }
                    function Nu(Bi) {
                      if (Bi || Bi === "") {
                        var Ci = Bi[Fo];
                        if (Ci) return Ci.call(Bi);
                        if (typeof Bi.next == "function") return Bi;
                        if (!isNaN(Bi.length)) {
                          var ki = -1, Mo = function Xo() {
                            for (; ++ki < Bi.length; ) if (Gi.call(Bi, ki)) return Xo.value = Bi[ki], Xo.done = !1, Xo;
                            return Xo.value = Ai, Xo.done = !0, Xo;
                          };
                          return Mo.next = Mo;
                        }
                      }
                      throw new TypeError(typeof Bi + " is not iterable");
                    }
                    return lu.prototype = Nl, na(zl, "constructor", { value: Nl, configurable: !0 }), na(Nl, "constructor", { value: lu, configurable: !0 }), lu.displayName = wa(Nl, Va, "GeneratorFunction"), _i.isGeneratorFunction = function(Bi) {
                      var Ci = typeof Bi == "function" && Bi.constructor;
                      return !!Ci && (Ci === lu || (Ci.displayName || Ci.name) === "GeneratorFunction");
                    }, _i.mark = function(Bi) {
                      return Object.setPrototypeOf ? Object.setPrototypeOf(Bi, Nl) : (Bi.__proto__ = Nl, wa(Bi, Va, "GeneratorFunction")), Bi.prototype = Object.create(zl), Bi;
                    }, _i.awrap = function(Bi) {
                      return { __await: Bi };
                    }, Qu(gu.prototype), wa(gu.prototype, Wa, function() {
                      return this;
                    }), _i.AsyncIterator = gu, _i.async = function(Bi, Ci, ki, Mo, Xo) {
                      Xo === void 0 && (Xo = Promise);
                      var Uo = new gu(il(Bi, Ci, ki, Mo), Xo);
                      return _i.isGeneratorFunction(Ci) ? Uo : Uo.next().then(function(qa) {
                        return qa.done ? qa.value : Uo.next();
                      });
                    }, Qu(zl), wa(zl, Va, "Generator"), wa(zl, Fo, function() {
                      return this;
                    }), wa(zl, "toString", function() {
                      return "[object Generator]";
                    }), _i.keys = function(Bi) {
                      var Ci = Object(Bi), ki = [];
                      for (var Mo in Ci) ki.push(Mo);
                      return ki.reverse(), function Xo() {
                        for (; ki.length; ) {
                          var Uo = ki.pop();
                          if (Uo in Ci) return Xo.value = Uo, Xo.done = !1, Xo;
                        }
                        return Xo.done = !0, Xo;
                      };
                    }, _i.values = Nu, ku.prototype = { constructor: ku, reset: function(Ci) {
                      if (this.prev = 0, this.next = 0, this.sent = this._sent = Ai, this.done = !1, this.delegate = null, this.method = "next", this.arg = Ai, this.tryEntries.forEach(Du), !Ci) for (var ki in this) ki.charAt(0) === "t" && Gi.call(this, ki) && !isNaN(+ki.slice(1)) && (this[ki] = Ai);
                    }, stop: function() {
                      this.done = !0;
                      var Ci = this.tryEntries[0].completion;
                      if (Ci.type === "throw") throw Ci.arg;
                      return this.rval;
                    }, dispatchException: function(Ci) {
                      if (this.done) throw Ci;
                      var ki = this;
                      function Mo(jl, Al) {
                        return qa.type = "throw", qa.arg = Ci, ki.next = jl, Al && (ki.method = "next", ki.arg = Ai), !!Al;
                      }
                      for (var Xo = this.tryEntries.length - 1; Xo >= 0; --Xo) {
                        var Uo = this.tryEntries[Xo], qa = Uo.completion;
                        if (Uo.tryLoc === "root") return Mo("end");
                        if (Uo.tryLoc <= this.prev) {
                          var Us = Gi.call(Uo, "catchLoc"), Hs = Gi.call(Uo, "finallyLoc");
                          if (Us && Hs) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          } else if (Us) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                          } else {
                            if (!Hs) throw Error("try statement without catch or finally");
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          }
                        }
                      }
                    }, abrupt: function(Ci, ki) {
                      for (var Mo = this.tryEntries.length - 1; Mo >= 0; --Mo) {
                        var Xo = this.tryEntries[Mo];
                        if (Xo.tryLoc <= this.prev && Gi.call(Xo, "finallyLoc") && this.prev < Xo.finallyLoc) {
                          var Uo = Xo;
                          break;
                        }
                      }
                      Uo && (Ci === "break" || Ci === "continue") && Uo.tryLoc <= ki && ki <= Uo.finallyLoc && (Uo = null);
                      var qa = Uo ? Uo.completion : {};
                      return qa.type = Ci, qa.arg = ki, Uo ? (this.method = "next", this.next = Uo.finallyLoc, pl) : this.complete(qa);
                    }, complete: function(Ci, ki) {
                      if (Ci.type === "throw") throw Ci.arg;
                      return Ci.type === "break" || Ci.type === "continue" ? this.next = Ci.arg : Ci.type === "return" ? (this.rval = this.arg = Ci.arg, this.method = "return", this.next = "end") : Ci.type === "normal" && ki && (this.next = ki), pl;
                    }, finish: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.finallyLoc === Ci) return this.complete(Mo.completion, Mo.afterLoc), Du(Mo), pl;
                      }
                    }, catch: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.tryLoc === Ci) {
                          var Xo = Mo.completion;
                          if (Xo.type === "throw") {
                            var Uo = Xo.arg;
                            Du(Mo);
                          }
                          return Uo;
                        }
                      }
                      throw Error("illegal catch attempt");
                    }, delegateYield: function(Ci, ki, Mo) {
                      return this.delegate = { iterator: Nu(Ci), resultName: ki, nextLoc: Mo }, this.method === "next" && (this.arg = Ai), pl;
                    } }, _i;
                  }
                  function Ap(Ai, _i, Po, Gi, na, ta, Fo) {
                    try {
                      var Wa = Ai[ta](Fo), Va = Wa.value;
                    } catch (wa) {
                      return void Po(wa);
                    }
                    Wa.done ? _i(Va) : Promise.resolve(Va).then(Gi, na);
                  }
                  function op(Ai) {
                    return function() {
                      var _i = this, Po = arguments;
                      return new Promise(function(Gi, na) {
                        var ta = Ai.apply(_i, Po);
                        function Fo(Va) {
                          Ap(ta, Gi, na, Fo, Wa, "next", Va);
                        }
                        function Wa(Va) {
                          Ap(ta, Gi, na, Fo, Wa, "throw", Va);
                        }
                        Fo(void 0);
                      });
                    };
                  }
                  function Sa(Ai, _i) {
                    if (!(Ai instanceof _i)) throw new TypeError("Cannot call a class as a function");
                  }
                  function ma(Ai, _i) {
                    for (var Po = 0; Po < _i.length; Po++) {
                      var Gi = _i[Po];
                      Gi.enumerable = Gi.enumerable || !1, Gi.configurable = !0, "value" in Gi && (Gi.writable = !0), Object.defineProperty(Ai, Ll(Gi.key), Gi);
                    }
                  }
                  function Ho(Ai, _i, Po) {
                    return _i && ma(Ai.prototype, _i), Po && ma(Ai, Po), Object.defineProperty(Ai, "prototype", { writable: !1 }), Ai;
                  }
                  function Io(Ai, _i, Po) {
                    return _i = bs(_i), Ri(Ai, Yo() ? Reflect.construct(_i, Po || [], bs(Ai).constructor) : _i.apply(Ai, Po));
                  }
                  function Ri(Ai, _i) {
                    if (_i && (typeof _i == "object" || typeof _i == "function")) return _i;
                    if (_i !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return qi(Ai);
                  }
                  function qi(Ai) {
                    if (Ai === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return Ai;
                  }
                  function Yo() {
                    try {
                      var Ai = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                      }));
                    } catch {
                    }
                    return (Yo = function() {
                      return !!Ai;
                    })();
                  }
                  function ba(Ai, _i, Po, Gi) {
                    var na = Na(bs(Ai.prototype), _i, Po);
                    return 2 & Gi && typeof na == "function" ? function(ta) {
                      return na.apply(Po, ta);
                    } : na;
                  }
                  function Na() {
                    return Na = typeof Reflect < "u" && Reflect.get ? Reflect.get.bind() : function(Ai, _i, Po) {
                      var Gi = Ma(Ai, _i);
                      if (Gi) {
                        var na = Object.getOwnPropertyDescriptor(Gi, _i);
                        return na.get ? na.get.call(arguments.length < 3 ? Ai : Po) : na.value;
                      }
                    }, Na.apply(null, arguments);
                  }
                  function Ma(Ai, _i) {
                    for (; !{}.hasOwnProperty.call(Ai, _i) && (Ai = bs(Ai)) !== null; ) ;
                    return Ai;
                  }
                  function bs(Ai) {
                    return bs = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(_i) {
                      return _i.__proto__ || Object.getPrototypeOf(_i);
                    }, bs(Ai);
                  }
                  function Ds(Ai, _i) {
                    if (typeof _i != "function" && _i !== null) throw new TypeError("Super expression must either be null or a function");
                    Ai.prototype = Object.create(_i && _i.prototype, { constructor: { value: Ai, writable: !0, configurable: !0 } }), Object.defineProperty(Ai, "prototype", { writable: !1 }), _i && Fs(Ai, _i);
                  }
                  function Fs(Ai, _i) {
                    return Fs = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(Po, Gi) {
                      return Po.__proto__ = Gi, Po;
                    }, Fs(Ai, _i);
                  }
                  function _l(Ai, _i, Po) {
                    return (_i = Ll(_i)) in Ai ? Object.defineProperty(Ai, _i, { value: Po, enumerable: !0, configurable: !0, writable: !0 }) : Ai[_i] = Po, Ai;
                  }
                  function Ll(Ai) {
                    var _i = eu(Ai, "string");
                    return typeof _i == "symbol" ? _i : _i + "";
                  }
                  function eu(Ai, _i) {
                    if (typeof Ai != "object" || !Ai) return Ai;
                    var Po = Ai[Symbol.toPrimitive];
                    if (Po !== void 0) {
                      var Gi = Po.call(Ai, _i);
                      if (typeof Gi != "object") return Gi;
                      throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(Ai);
                  }
                  var fu, Fu = /* @__PURE__ */ (function(Ai) {
                    function _i(Po) {
                      var Gi;
                      return Sa(this, _i), Gi = Io(this, _i, [Po]), _l(Gi, "_routeWindowMessageToTargetConduit", function(na) {
                        var ta = na.data.clientId;
                        if (ta) {
                          Gi.logger.debug("Received Window Message event for ".concat(ta));
                          var Fo = na.data.event;
                          if (!Gi.has(ta)) {
                            if (Fo === "fail")
                              return;
                            if (Gi.deletedConduitClientIds.includes(ta)) {
                              Gi.logger.warn("Received a message for deleted conduit ".concat(ta));
                              return;
                            }
                            throw new Error("Unable to route message of type ".concat(Fo, ' for Conduit with clientId "').concat(ta, '".  A Conduit with that clientId does not exist.'));
                          }
                          Gi.get(ta).onRouterEvent(Fo, na);
                        }
                      }), Gi.totalConduitCount = 0, Gi.conduits = {}, Gi.deletedConduitClientIds = [], Op.register(), window.addEventListener("message", Gi._routeWindowMessageToTargetConduit), Gi;
                    }
                    return Ds(_i, Ai), Ho(_i, [{
                      key: "create",
                      value: (
                        /**
                         * Create a Conduit for a specific stream, and add it to this collection.
                         *
                         * @returns {Conduit}
                         */
                        function(Gi, na, ta, Fo) {
                          this.logger.debug("creating a conduit with logId ".concat(Gi, " and clientId ").concat(na));
                          var Wa = Od.factory(Gi, na, ta, Fo);
                          return this._add(Wa), this.totalConduitCount++, Wa;
                        }
                      )
                      /**
                       * Add a Conduit instance to this collection.
                       *
                       * @private
                       *
                       * @param {Conduit} conduit
                       *   The conduit instance to add
                       *
                       * @returns {this}
                       */
                    }, {
                      key: "_add",
                      value: function(Gi) {
                        var na = Gi.clientId;
                        return this.conduits[na] = Gi, this;
                      }
                      /**
                       * Determine whether or not a Conduit with the passed clientId exists in this
                       * collection.
                       *
                       * @param {String} clientId
                       *   The clientId of the conduit to find
                       *
                       * @returns {Boolean}
                       *   True if the conduit with the given clientId exists
                       *   False if the conduit with the given clientId does not exist
                       */
                    }, {
                      key: "has",
                      value: function(Gi) {
                        return Object.prototype.hasOwnProperty.call(this.conduits, Gi);
                      }
                      /**
                       * Get a Conduit with the passed clientId from this collection.
                       *
                       * @param {String} clientId
                       *   The clientId of the conduit instance to get
                       *
                       * @returns {Conduit|undefined}
                       *   If a Conduit with this clientId doest not exist, undefined is returned.
                       */
                    }, {
                      key: "get",
                      value: function(Gi) {
                        return this.conduits[Gi];
                      }
                      /**
                       * Remove a conduit instance from this collection and destroy it.
                       *
                       * @param {String} clientId
                       *   The clientId of the conduit to remove and destroy
                       *
                       * @returns {this}
                       */
                    }, {
                      key: "remove",
                      value: (function() {
                        var Po = op(/* @__PURE__ */ _f().mark(function na(ta) {
                          var Fo;
                          return _f().wrap(function(Va) {
                            for (; ; ) switch (Va.prev = Va.next) {
                              case 0:
                                if (Fo = this.get(ta), Fo) {
                                  Va.next = 3;
                                  break;
                                }
                                return Va.abrupt("return");
                              case 3:
                                return Va.next = 5, Fo.destroy();
                              case 5:
                                return delete this.conduits[ta], this.deletedConduitClientIds.push(ta), Va.abrupt("return", this);
                              case 8:
                              case "end":
                                return Va.stop();
                            }
                          }, na, this);
                        }));
                        function Gi(na) {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "_destroy",
                      value: (function() {
                        var Po = op(/* @__PURE__ */ _f().mark(function na() {
                          var ta;
                          return _f().wrap(function(Wa) {
                            for (; ; ) switch (Wa.prev = Wa.next) {
                              case 0:
                                window.removeEventListener("message", this._routeWindowMessageToTargetConduit), Wa.t0 = _f().keys(this.conduits);
                              case 2:
                                if ((Wa.t1 = Wa.t0()).done) {
                                  Wa.next = 15;
                                  break;
                                }
                                return ta = Wa.t1.value, Wa.prev = 4, Wa.next = 7, this.remove(ta);
                              case 7:
                                Wa.next = 13;
                                break;
                              case 9:
                                Wa.prev = 9, Wa.t2 = Wa.catch(4), this.logger.error("Error while removing conduit ".concat(ta, " while destroying")), this.logger.error(Wa.t2);
                              case 13:
                                Wa.next = 2;
                                break;
                              case 15:
                                return this.conduits = null, this.deletedConduitClientIds = null, Wa.next = 19, ba(_i, "_destroy", this, 3)([]);
                              case 19:
                              case "end":
                                return Wa.stop();
                            }
                          }, na, this, [[4, 9]]);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }], [{
                      key: "asSingleton",
                      value: function() {
                        return fu || (fu = _i.factory("1")), fu;
                      }
                    }, {
                      key: "factory",
                      value: function(Gi) {
                        return new _i(Gi);
                      }
                    }]);
                  })(Hi);
                  function Ou() {
                    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
                    Ou = function() {
                      return _i;
                    };
                    var Ai, _i = {}, Po = Object.prototype, Gi = Po.hasOwnProperty, na = Object.defineProperty || function(Bi, Ci, ki) {
                      Bi[Ci] = ki.value;
                    }, ta = typeof Symbol == "function" ? Symbol : {}, Fo = ta.iterator || "@@iterator", Wa = ta.asyncIterator || "@@asyncIterator", Va = ta.toStringTag || "@@toStringTag";
                    function wa(Bi, Ci, ki) {
                      return Object.defineProperty(Bi, Ci, { value: ki, enumerable: !0, configurable: !0, writable: !0 }), Bi[Ci];
                    }
                    try {
                      wa({}, "");
                    } catch {
                      wa = function(ki, Mo, Xo) {
                        return ki[Mo] = Xo;
                      };
                    }
                    function il(Bi, Ci, ki, Mo) {
                      var Xo = Ci && Ci.prototype instanceof pu ? Ci : pu, Uo = Object.create(Xo.prototype), qa = new ku(Mo || []);
                      return na(Uo, "_invoke", { value: pc(Bi, ki, qa) }), Uo;
                    }
                    function ol(Bi, Ci, ki) {
                      try {
                        return { type: "normal", arg: Bi.call(Ci, ki) };
                      } catch (Mo) {
                        return { type: "throw", arg: Mo };
                      }
                    }
                    _i.wrap = il;
                    var Ql = "suspendedStart", Uu = "suspendedYield", Wu = "executing", Kl = "completed", pl = {};
                    function pu() {
                    }
                    function lu() {
                    }
                    function Nl() {
                    }
                    var Eu = {};
                    wa(Eu, Fo, function() {
                      return this;
                    });
                    var wu = Object.getPrototypeOf, yu = wu && wu(wu(Nu([])));
                    yu && yu !== Po && Gi.call(yu, Fo) && (Eu = yu);
                    var zl = Nl.prototype = pu.prototype = Object.create(Eu);
                    function Qu(Bi) {
                      ["next", "throw", "return"].forEach(function(Ci) {
                        wa(Bi, Ci, function(ki) {
                          return this._invoke(Ci, ki);
                        });
                      });
                    }
                    function gu(Bi, Ci) {
                      function ki(Xo, Uo, qa, Us) {
                        var Hs = ol(Bi[Xo], Bi, Uo);
                        if (Hs.type !== "throw") {
                          var jl = Hs.arg, Al = jl.value;
                          return Al && typeof Al == "object" && Gi.call(Al, "__await") ? Ci.resolve(Al.__await).then(function(Ml) {
                            ki("next", Ml, qa, Us);
                          }, function(Ml) {
                            ki("throw", Ml, qa, Us);
                          }) : Ci.resolve(Al).then(function(Ml) {
                            jl.value = Ml, qa(jl);
                          }, function(Ml) {
                            return ki("throw", Ml, qa, Us);
                          });
                        }
                        Us(Hs.arg);
                      }
                      var Mo;
                      na(this, "_invoke", { value: function(Uo, qa) {
                        function Us() {
                          return new Ci(function(Hs, jl) {
                            ki(Uo, qa, Hs, jl);
                          });
                        }
                        return Mo = Mo ? Mo.then(Us, Us) : Us();
                      } });
                    }
                    function pc(Bi, Ci, ki) {
                      var Mo = Ql;
                      return function(Xo, Uo) {
                        if (Mo === Wu) throw Error("Generator is already running");
                        if (Mo === Kl) {
                          if (Xo === "throw") throw Uo;
                          return { value: Ai, done: !0 };
                        }
                        for (ki.method = Xo, ki.arg = Uo; ; ) {
                          var qa = ki.delegate;
                          if (qa) {
                            var Us = Zu(qa, ki);
                            if (Us) {
                              if (Us === pl) continue;
                              return Us;
                            }
                          }
                          if (ki.method === "next") ki.sent = ki._sent = ki.arg;
                          else if (ki.method === "throw") {
                            if (Mo === Ql) throw Mo = Kl, ki.arg;
                            ki.dispatchException(ki.arg);
                          } else ki.method === "return" && ki.abrupt("return", ki.arg);
                          Mo = Wu;
                          var Hs = ol(Bi, Ci, ki);
                          if (Hs.type === "normal") {
                            if (Mo = ki.done ? Kl : Uu, Hs.arg === pl) continue;
                            return { value: Hs.arg, done: ki.done };
                          }
                          Hs.type === "throw" && (Mo = Kl, ki.method = "throw", ki.arg = Hs.arg);
                        }
                      };
                    }
                    function Zu(Bi, Ci) {
                      var ki = Ci.method, Mo = Bi.iterator[ki];
                      if (Mo === Ai) return Ci.delegate = null, ki === "throw" && Bi.iterator.return && (Ci.method = "return", Ci.arg = Ai, Zu(Bi, Ci), Ci.method === "throw") || ki !== "return" && (Ci.method = "throw", Ci.arg = new TypeError("The iterator does not provide a '" + ki + "' method")), pl;
                      var Xo = ol(Mo, Bi.iterator, Ci.arg);
                      if (Xo.type === "throw") return Ci.method = "throw", Ci.arg = Xo.arg, Ci.delegate = null, pl;
                      var Uo = Xo.arg;
                      return Uo ? Uo.done ? (Ci[Bi.resultName] = Uo.value, Ci.next = Bi.nextLoc, Ci.method !== "return" && (Ci.method = "next", Ci.arg = Ai), Ci.delegate = null, pl) : Uo : (Ci.method = "throw", Ci.arg = new TypeError("iterator result is not an object"), Ci.delegate = null, pl);
                    }
                    function gc(Bi) {
                      var Ci = { tryLoc: Bi[0] };
                      1 in Bi && (Ci.catchLoc = Bi[1]), 2 in Bi && (Ci.finallyLoc = Bi[2], Ci.afterLoc = Bi[3]), this.tryEntries.push(Ci);
                    }
                    function Du(Bi) {
                      var Ci = Bi.completion || {};
                      Ci.type = "normal", delete Ci.arg, Bi.completion = Ci;
                    }
                    function ku(Bi) {
                      this.tryEntries = [{ tryLoc: "root" }], Bi.forEach(gc, this), this.reset(!0);
                    }
                    function Nu(Bi) {
                      if (Bi || Bi === "") {
                        var Ci = Bi[Fo];
                        if (Ci) return Ci.call(Bi);
                        if (typeof Bi.next == "function") return Bi;
                        if (!isNaN(Bi.length)) {
                          var ki = -1, Mo = function Xo() {
                            for (; ++ki < Bi.length; ) if (Gi.call(Bi, ki)) return Xo.value = Bi[ki], Xo.done = !1, Xo;
                            return Xo.value = Ai, Xo.done = !0, Xo;
                          };
                          return Mo.next = Mo;
                        }
                      }
                      throw new TypeError(typeof Bi + " is not iterable");
                    }
                    return lu.prototype = Nl, na(zl, "constructor", { value: Nl, configurable: !0 }), na(Nl, "constructor", { value: lu, configurable: !0 }), lu.displayName = wa(Nl, Va, "GeneratorFunction"), _i.isGeneratorFunction = function(Bi) {
                      var Ci = typeof Bi == "function" && Bi.constructor;
                      return !!Ci && (Ci === lu || (Ci.displayName || Ci.name) === "GeneratorFunction");
                    }, _i.mark = function(Bi) {
                      return Object.setPrototypeOf ? Object.setPrototypeOf(Bi, Nl) : (Bi.__proto__ = Nl, wa(Bi, Va, "GeneratorFunction")), Bi.prototype = Object.create(zl), Bi;
                    }, _i.awrap = function(Bi) {
                      return { __await: Bi };
                    }, Qu(gu.prototype), wa(gu.prototype, Wa, function() {
                      return this;
                    }), _i.AsyncIterator = gu, _i.async = function(Bi, Ci, ki, Mo, Xo) {
                      Xo === void 0 && (Xo = Promise);
                      var Uo = new gu(il(Bi, Ci, ki, Mo), Xo);
                      return _i.isGeneratorFunction(Ci) ? Uo : Uo.next().then(function(qa) {
                        return qa.done ? qa.value : Uo.next();
                      });
                    }, Qu(zl), wa(zl, Va, "Generator"), wa(zl, Fo, function() {
                      return this;
                    }), wa(zl, "toString", function() {
                      return "[object Generator]";
                    }), _i.keys = function(Bi) {
                      var Ci = Object(Bi), ki = [];
                      for (var Mo in Ci) ki.push(Mo);
                      return ki.reverse(), function Xo() {
                        for (; ki.length; ) {
                          var Uo = ki.pop();
                          if (Uo in Ci) return Xo.value = Uo, Xo.done = !1, Xo;
                        }
                        return Xo.done = !0, Xo;
                      };
                    }, _i.values = Nu, ku.prototype = { constructor: ku, reset: function(Ci) {
                      if (this.prev = 0, this.next = 0, this.sent = this._sent = Ai, this.done = !1, this.delegate = null, this.method = "next", this.arg = Ai, this.tryEntries.forEach(Du), !Ci) for (var ki in this) ki.charAt(0) === "t" && Gi.call(this, ki) && !isNaN(+ki.slice(1)) && (this[ki] = Ai);
                    }, stop: function() {
                      this.done = !0;
                      var Ci = this.tryEntries[0].completion;
                      if (Ci.type === "throw") throw Ci.arg;
                      return this.rval;
                    }, dispatchException: function(Ci) {
                      if (this.done) throw Ci;
                      var ki = this;
                      function Mo(jl, Al) {
                        return qa.type = "throw", qa.arg = Ci, ki.next = jl, Al && (ki.method = "next", ki.arg = Ai), !!Al;
                      }
                      for (var Xo = this.tryEntries.length - 1; Xo >= 0; --Xo) {
                        var Uo = this.tryEntries[Xo], qa = Uo.completion;
                        if (Uo.tryLoc === "root") return Mo("end");
                        if (Uo.tryLoc <= this.prev) {
                          var Us = Gi.call(Uo, "catchLoc"), Hs = Gi.call(Uo, "finallyLoc");
                          if (Us && Hs) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          } else if (Us) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                          } else {
                            if (!Hs) throw Error("try statement without catch or finally");
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          }
                        }
                      }
                    }, abrupt: function(Ci, ki) {
                      for (var Mo = this.tryEntries.length - 1; Mo >= 0; --Mo) {
                        var Xo = this.tryEntries[Mo];
                        if (Xo.tryLoc <= this.prev && Gi.call(Xo, "finallyLoc") && this.prev < Xo.finallyLoc) {
                          var Uo = Xo;
                          break;
                        }
                      }
                      Uo && (Ci === "break" || Ci === "continue") && Uo.tryLoc <= ki && ki <= Uo.finallyLoc && (Uo = null);
                      var qa = Uo ? Uo.completion : {};
                      return qa.type = Ci, qa.arg = ki, Uo ? (this.method = "next", this.next = Uo.finallyLoc, pl) : this.complete(qa);
                    }, complete: function(Ci, ki) {
                      if (Ci.type === "throw") throw Ci.arg;
                      return Ci.type === "break" || Ci.type === "continue" ? this.next = Ci.arg : Ci.type === "return" ? (this.rval = this.arg = Ci.arg, this.method = "return", this.next = "end") : Ci.type === "normal" && ki && (this.next = ki), pl;
                    }, finish: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.finallyLoc === Ci) return this.complete(Mo.completion, Mo.afterLoc), Du(Mo), pl;
                      }
                    }, catch: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.tryLoc === Ci) {
                          var Xo = Mo.completion;
                          if (Xo.type === "throw") {
                            var Uo = Xo.arg;
                            Du(Mo);
                          }
                          return Uo;
                        }
                      }
                      throw Error("illegal catch attempt");
                    }, delegateYield: function(Ci, ki, Mo) {
                      return this.delegate = { iterator: Nu(Ci), resultName: ki, nextLoc: Mo }, this.method === "next" && (this.arg = Ai), pl;
                    } }, _i;
                  }
                  function qu(Ai, _i, Po, Gi, na, ta, Fo) {
                    try {
                      var Wa = Ai[ta](Fo), Va = Wa.value;
                    } catch (wa) {
                      return void Po(wa);
                    }
                    Wa.done ? _i(Va) : Promise.resolve(Va).then(Gi, na);
                  }
                  function Ju(Ai) {
                    return function() {
                      var _i = this, Po = arguments;
                      return new Promise(function(Gi, na) {
                        var ta = Ai.apply(_i, Po);
                        function Fo(Va) {
                          qu(ta, Gi, na, Fo, Wa, "next", Va);
                        }
                        function Wa(Va) {
                          qu(ta, Gi, na, Fo, Wa, "throw", Va);
                        }
                        Fo(void 0);
                      });
                    };
                  }
                  function nc(Ai, _i) {
                    if (!(Ai instanceof _i)) throw new TypeError("Cannot call a class as a function");
                  }
                  function $c(Ai, _i) {
                    for (var Po = 0; Po < _i.length; Po++) {
                      var Gi = _i[Po];
                      Gi.enumerable = Gi.enumerable || !1, Gi.configurable = !0, "value" in Gi && (Gi.writable = !0), Object.defineProperty(Ai, cf(Gi.key), Gi);
                    }
                  }
                  function Rc(Ai, _i, Po) {
                    return _i && $c(Ai.prototype, _i), Po && $c(Ai, Po), Object.defineProperty(Ai, "prototype", { writable: !1 }), Ai;
                  }
                  function xc(Ai, _i, Po) {
                    return _i = Ad(_i), vd(Ai, ic() ? Reflect.construct(_i, Po || [], Ad(Ai).constructor) : _i.apply(Ai, Po));
                  }
                  function vd(Ai, _i) {
                    if (_i && (typeof _i == "object" || typeof _i == "function")) return _i;
                    if (_i !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return zu(Ai);
                  }
                  function zu(Ai) {
                    if (Ai === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return Ai;
                  }
                  function ic() {
                    try {
                      var Ai = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                      }));
                    } catch {
                    }
                    return (ic = function() {
                      return !!Ai;
                    })();
                  }
                  function Fc(Ai, _i, Po, Gi) {
                    var na = kd(Ad(Ai.prototype), _i, Po);
                    return 2 & Gi && typeof na == "function" ? function(ta) {
                      return na.apply(Po, ta);
                    } : na;
                  }
                  function kd() {
                    return kd = typeof Reflect < "u" && Reflect.get ? Reflect.get.bind() : function(Ai, _i, Po) {
                      var Gi = tf(Ai, _i);
                      if (Gi) {
                        var na = Object.getOwnPropertyDescriptor(Gi, _i);
                        return na.get ? na.get.call(arguments.length < 3 ? Ai : Po) : na.value;
                      }
                    }, kd.apply(null, arguments);
                  }
                  function tf(Ai, _i) {
                    for (; !{}.hasOwnProperty.call(Ai, _i) && (Ai = Ad(Ai)) !== null; ) ;
                    return Ai;
                  }
                  function Ad(Ai) {
                    return Ad = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(_i) {
                      return _i.__proto__ || Object.getPrototypeOf(_i);
                    }, Ad(Ai);
                  }
                  function Ip(Ai, _i) {
                    if (typeof _i != "function" && _i !== null) throw new TypeError("Super expression must either be null or a function");
                    Ai.prototype = Object.create(_i && _i.prototype, { constructor: { value: Ai, writable: !0, configurable: !0 } }), Object.defineProperty(Ai, "prototype", { writable: !1 }), _i && Xp(Ai, _i);
                  }
                  function Xp(Ai, _i) {
                    return Xp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(Po, Gi) {
                      return Po.__proto__ = Gi, Po;
                    }, Xp(Ai, _i);
                  }
                  function Pf(Ai, _i, Po) {
                    return (_i = cf(_i)) in Ai ? Object.defineProperty(Ai, _i, { value: Po, enumerable: !0, configurable: !0, writable: !0 }) : Ai[_i] = Po, Ai;
                  }
                  function cf(Ai) {
                    var _i = Jp(Ai, "string");
                    return typeof _i == "symbol" ? _i : _i + "";
                  }
                  function Jp(Ai, _i) {
                    if (typeof Ai != "object" || !Ai) return Ai;
                    var Po = Ai[Symbol.toPrimitive];
                    if (Po !== void 0) {
                      var Gi = Po.call(Ai, _i);
                      if (typeof Gi != "object") return Gi;
                      throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (_i === "string" ? String : Number)(Ai);
                  }
                  var rf = /* @__PURE__ */ (function(Ai) {
                    function _i(Po, Gi, na, ta) {
                      var Fo;
                      return nc(this, _i), Fo = xc(this, _i, [Po]), Fo._constructorArgumentsBouncer(Gi, na, ta), Fo.clientId = Gi, Fo.streamConfiguration = na, Fo.containerElement = ta, Fo.conduit = Fu.asSingleton().create(Fo.logId, Fo.clientId, Fo.streamConfiguration, Fo.containerElement), Fo;
                    }
                    return Ip(_i, Ai), Rc(_i, [{
                      key: "_constructorArgumentsBouncer",
                      value: function(Gi, na, ta) {
                        if (!Gi)
                          throw new Error("clientId is required to construct a new Conduit instance.");
                        if (!bu.isStreamConfiguration(na))
                          throw new Error("invalid streamConfiguration passed to Conduit constructor");
                        if (!ta)
                          throw new Error("containerElement is required to construct a new Conduit instance");
                      }
                    }, {
                      key: "initialize",
                      value: (function() {
                        var Po = Ju(/* @__PURE__ */ Ou().mark(function na() {
                          return Ou().wrap(function(Fo) {
                            for (; ; ) switch (Fo.prev = Fo.next) {
                              case 0:
                                if (!this.isDestroyed) {
                                  Fo.next = 2;
                                  break;
                                }
                                throw new Error("Tried to initialize while destroyed");
                              case 2:
                                return Fo.next = 4, this.conduit.initialize();
                              case 4:
                              case "end":
                                return Fo.stop();
                            }
                          }, na, this);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "_destroy",
                      value: (function() {
                        var Po = Ju(/* @__PURE__ */ Ou().mark(function na() {
                          return Ou().wrap(function(Fo) {
                            for (; ; ) switch (Fo.prev = Fo.next) {
                              case 0:
                                return Fo.next = 2, Fu.asSingleton().remove(this.clientId);
                              case 2:
                                return this.conduit = null, this.streamConfiguration = null, this.containerElement = null, Fo.next = 7, Fc(_i, "_destroy", this, 3)([]);
                              case 7:
                              case "end":
                                return Fo.stop();
                            }
                          }, na, this);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }], [{
                      key: "factory",
                      value: (
                        /**
                         * Create a new CLSP Client
                         *
                         * @param {String} logId
                         *   a string that identifies this router in log messages
                         * @param {String} clientId
                         *   the guid to be used to construct the topic
                         * @param {StreamConfiguration} streamConfiguration
                         *   The stream configuration to pull from the CLSP server / SFS
                         * @param {Element} containerElement
                         *   The container of the video element and where the Conduit's iframe will be
                         *   inserted
                         */
                        function(Gi, na, ta, Fo) {
                          return new _i(Gi, na, ta, Fo);
                        }
                      )
                    }]);
                  })(Hi);
                  Pf(rf, "events", Od.events);
                  var Qp = oi(973), Zh = /* @__PURE__ */ oi.n(Qp);
                  function df() {
                    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
                    df = function() {
                      return _i;
                    };
                    var Ai, _i = {}, Po = Object.prototype, Gi = Po.hasOwnProperty, na = Object.defineProperty || function(Bi, Ci, ki) {
                      Bi[Ci] = ki.value;
                    }, ta = typeof Symbol == "function" ? Symbol : {}, Fo = ta.iterator || "@@iterator", Wa = ta.asyncIterator || "@@asyncIterator", Va = ta.toStringTag || "@@toStringTag";
                    function wa(Bi, Ci, ki) {
                      return Object.defineProperty(Bi, Ci, { value: ki, enumerable: !0, configurable: !0, writable: !0 }), Bi[Ci];
                    }
                    try {
                      wa({}, "");
                    } catch {
                      wa = function(ki, Mo, Xo) {
                        return ki[Mo] = Xo;
                      };
                    }
                    function il(Bi, Ci, ki, Mo) {
                      var Xo = Ci && Ci.prototype instanceof pu ? Ci : pu, Uo = Object.create(Xo.prototype), qa = new ku(Mo || []);
                      return na(Uo, "_invoke", { value: pc(Bi, ki, qa) }), Uo;
                    }
                    function ol(Bi, Ci, ki) {
                      try {
                        return { type: "normal", arg: Bi.call(Ci, ki) };
                      } catch (Mo) {
                        return { type: "throw", arg: Mo };
                      }
                    }
                    _i.wrap = il;
                    var Ql = "suspendedStart", Uu = "suspendedYield", Wu = "executing", Kl = "completed", pl = {};
                    function pu() {
                    }
                    function lu() {
                    }
                    function Nl() {
                    }
                    var Eu = {};
                    wa(Eu, Fo, function() {
                      return this;
                    });
                    var wu = Object.getPrototypeOf, yu = wu && wu(wu(Nu([])));
                    yu && yu !== Po && Gi.call(yu, Fo) && (Eu = yu);
                    var zl = Nl.prototype = pu.prototype = Object.create(Eu);
                    function Qu(Bi) {
                      ["next", "throw", "return"].forEach(function(Ci) {
                        wa(Bi, Ci, function(ki) {
                          return this._invoke(Ci, ki);
                        });
                      });
                    }
                    function gu(Bi, Ci) {
                      function ki(Xo, Uo, qa, Us) {
                        var Hs = ol(Bi[Xo], Bi, Uo);
                        if (Hs.type !== "throw") {
                          var jl = Hs.arg, Al = jl.value;
                          return Al && typeof Al == "object" && Gi.call(Al, "__await") ? Ci.resolve(Al.__await).then(function(Ml) {
                            ki("next", Ml, qa, Us);
                          }, function(Ml) {
                            ki("throw", Ml, qa, Us);
                          }) : Ci.resolve(Al).then(function(Ml) {
                            jl.value = Ml, qa(jl);
                          }, function(Ml) {
                            return ki("throw", Ml, qa, Us);
                          });
                        }
                        Us(Hs.arg);
                      }
                      var Mo;
                      na(this, "_invoke", { value: function(Uo, qa) {
                        function Us() {
                          return new Ci(function(Hs, jl) {
                            ki(Uo, qa, Hs, jl);
                          });
                        }
                        return Mo = Mo ? Mo.then(Us, Us) : Us();
                      } });
                    }
                    function pc(Bi, Ci, ki) {
                      var Mo = Ql;
                      return function(Xo, Uo) {
                        if (Mo === Wu) throw Error("Generator is already running");
                        if (Mo === Kl) {
                          if (Xo === "throw") throw Uo;
                          return { value: Ai, done: !0 };
                        }
                        for (ki.method = Xo, ki.arg = Uo; ; ) {
                          var qa = ki.delegate;
                          if (qa) {
                            var Us = Zu(qa, ki);
                            if (Us) {
                              if (Us === pl) continue;
                              return Us;
                            }
                          }
                          if (ki.method === "next") ki.sent = ki._sent = ki.arg;
                          else if (ki.method === "throw") {
                            if (Mo === Ql) throw Mo = Kl, ki.arg;
                            ki.dispatchException(ki.arg);
                          } else ki.method === "return" && ki.abrupt("return", ki.arg);
                          Mo = Wu;
                          var Hs = ol(Bi, Ci, ki);
                          if (Hs.type === "normal") {
                            if (Mo = ki.done ? Kl : Uu, Hs.arg === pl) continue;
                            return { value: Hs.arg, done: ki.done };
                          }
                          Hs.type === "throw" && (Mo = Kl, ki.method = "throw", ki.arg = Hs.arg);
                        }
                      };
                    }
                    function Zu(Bi, Ci) {
                      var ki = Ci.method, Mo = Bi.iterator[ki];
                      if (Mo === Ai) return Ci.delegate = null, ki === "throw" && Bi.iterator.return && (Ci.method = "return", Ci.arg = Ai, Zu(Bi, Ci), Ci.method === "throw") || ki !== "return" && (Ci.method = "throw", Ci.arg = new TypeError("The iterator does not provide a '" + ki + "' method")), pl;
                      var Xo = ol(Mo, Bi.iterator, Ci.arg);
                      if (Xo.type === "throw") return Ci.method = "throw", Ci.arg = Xo.arg, Ci.delegate = null, pl;
                      var Uo = Xo.arg;
                      return Uo ? Uo.done ? (Ci[Bi.resultName] = Uo.value, Ci.next = Bi.nextLoc, Ci.method !== "return" && (Ci.method = "next", Ci.arg = Ai), Ci.delegate = null, pl) : Uo : (Ci.method = "throw", Ci.arg = new TypeError("iterator result is not an object"), Ci.delegate = null, pl);
                    }
                    function gc(Bi) {
                      var Ci = { tryLoc: Bi[0] };
                      1 in Bi && (Ci.catchLoc = Bi[1]), 2 in Bi && (Ci.finallyLoc = Bi[2], Ci.afterLoc = Bi[3]), this.tryEntries.push(Ci);
                    }
                    function Du(Bi) {
                      var Ci = Bi.completion || {};
                      Ci.type = "normal", delete Ci.arg, Bi.completion = Ci;
                    }
                    function ku(Bi) {
                      this.tryEntries = [{ tryLoc: "root" }], Bi.forEach(gc, this), this.reset(!0);
                    }
                    function Nu(Bi) {
                      if (Bi || Bi === "") {
                        var Ci = Bi[Fo];
                        if (Ci) return Ci.call(Bi);
                        if (typeof Bi.next == "function") return Bi;
                        if (!isNaN(Bi.length)) {
                          var ki = -1, Mo = function Xo() {
                            for (; ++ki < Bi.length; ) if (Gi.call(Bi, ki)) return Xo.value = Bi[ki], Xo.done = !1, Xo;
                            return Xo.value = Ai, Xo.done = !0, Xo;
                          };
                          return Mo.next = Mo;
                        }
                      }
                      throw new TypeError(typeof Bi + " is not iterable");
                    }
                    return lu.prototype = Nl, na(zl, "constructor", { value: Nl, configurable: !0 }), na(Nl, "constructor", { value: lu, configurable: !0 }), lu.displayName = wa(Nl, Va, "GeneratorFunction"), _i.isGeneratorFunction = function(Bi) {
                      var Ci = typeof Bi == "function" && Bi.constructor;
                      return !!Ci && (Ci === lu || (Ci.displayName || Ci.name) === "GeneratorFunction");
                    }, _i.mark = function(Bi) {
                      return Object.setPrototypeOf ? Object.setPrototypeOf(Bi, Nl) : (Bi.__proto__ = Nl, wa(Bi, Va, "GeneratorFunction")), Bi.prototype = Object.create(zl), Bi;
                    }, _i.awrap = function(Bi) {
                      return { __await: Bi };
                    }, Qu(gu.prototype), wa(gu.prototype, Wa, function() {
                      return this;
                    }), _i.AsyncIterator = gu, _i.async = function(Bi, Ci, ki, Mo, Xo) {
                      Xo === void 0 && (Xo = Promise);
                      var Uo = new gu(il(Bi, Ci, ki, Mo), Xo);
                      return _i.isGeneratorFunction(Ci) ? Uo : Uo.next().then(function(qa) {
                        return qa.done ? qa.value : Uo.next();
                      });
                    }, Qu(zl), wa(zl, Va, "Generator"), wa(zl, Fo, function() {
                      return this;
                    }), wa(zl, "toString", function() {
                      return "[object Generator]";
                    }), _i.keys = function(Bi) {
                      var Ci = Object(Bi), ki = [];
                      for (var Mo in Ci) ki.push(Mo);
                      return ki.reverse(), function Xo() {
                        for (; ki.length; ) {
                          var Uo = ki.pop();
                          if (Uo in Ci) return Xo.value = Uo, Xo.done = !1, Xo;
                        }
                        return Xo.done = !0, Xo;
                      };
                    }, _i.values = Nu, ku.prototype = { constructor: ku, reset: function(Ci) {
                      if (this.prev = 0, this.next = 0, this.sent = this._sent = Ai, this.done = !1, this.delegate = null, this.method = "next", this.arg = Ai, this.tryEntries.forEach(Du), !Ci) for (var ki in this) ki.charAt(0) === "t" && Gi.call(this, ki) && !isNaN(+ki.slice(1)) && (this[ki] = Ai);
                    }, stop: function() {
                      this.done = !0;
                      var Ci = this.tryEntries[0].completion;
                      if (Ci.type === "throw") throw Ci.arg;
                      return this.rval;
                    }, dispatchException: function(Ci) {
                      if (this.done) throw Ci;
                      var ki = this;
                      function Mo(jl, Al) {
                        return qa.type = "throw", qa.arg = Ci, ki.next = jl, Al && (ki.method = "next", ki.arg = Ai), !!Al;
                      }
                      for (var Xo = this.tryEntries.length - 1; Xo >= 0; --Xo) {
                        var Uo = this.tryEntries[Xo], qa = Uo.completion;
                        if (Uo.tryLoc === "root") return Mo("end");
                        if (Uo.tryLoc <= this.prev) {
                          var Us = Gi.call(Uo, "catchLoc"), Hs = Gi.call(Uo, "finallyLoc");
                          if (Us && Hs) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          } else if (Us) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                          } else {
                            if (!Hs) throw Error("try statement without catch or finally");
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          }
                        }
                      }
                    }, abrupt: function(Ci, ki) {
                      for (var Mo = this.tryEntries.length - 1; Mo >= 0; --Mo) {
                        var Xo = this.tryEntries[Mo];
                        if (Xo.tryLoc <= this.prev && Gi.call(Xo, "finallyLoc") && this.prev < Xo.finallyLoc) {
                          var Uo = Xo;
                          break;
                        }
                      }
                      Uo && (Ci === "break" || Ci === "continue") && Uo.tryLoc <= ki && ki <= Uo.finallyLoc && (Uo = null);
                      var qa = Uo ? Uo.completion : {};
                      return qa.type = Ci, qa.arg = ki, Uo ? (this.method = "next", this.next = Uo.finallyLoc, pl) : this.complete(qa);
                    }, complete: function(Ci, ki) {
                      if (Ci.type === "throw") throw Ci.arg;
                      return Ci.type === "break" || Ci.type === "continue" ? this.next = Ci.arg : Ci.type === "return" ? (this.rval = this.arg = Ci.arg, this.method = "return", this.next = "end") : Ci.type === "normal" && ki && (this.next = ki), pl;
                    }, finish: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.finallyLoc === Ci) return this.complete(Mo.completion, Mo.afterLoc), Du(Mo), pl;
                      }
                    }, catch: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.tryLoc === Ci) {
                          var Xo = Mo.completion;
                          if (Xo.type === "throw") {
                            var Uo = Xo.arg;
                            Du(Mo);
                          }
                          return Uo;
                        }
                      }
                      throw Error("illegal catch attempt");
                    }, delegateYield: function(Ci, ki, Mo) {
                      return this.delegate = { iterator: Nu(Ci), resultName: ki, nextLoc: Mo }, this.method === "next" && (this.arg = Ai), pl;
                    } }, _i;
                  }
                  function Zp(Ai, _i, Po, Gi, na, ta, Fo) {
                    try {
                      var Wa = Ai[ta](Fo), Va = Wa.value;
                    } catch (wa) {
                      return void Po(wa);
                    }
                    Wa.done ? _i(Va) : Promise.resolve(Va).then(Gi, na);
                  }
                  function ap(Ai) {
                    return function() {
                      var _i = this, Po = arguments;
                      return new Promise(function(Gi, na) {
                        var ta = Ai.apply(_i, Po);
                        function Fo(Va) {
                          Zp(ta, Gi, na, Fo, Wa, "next", Va);
                        }
                        function Wa(Va) {
                          Zp(ta, Gi, na, Fo, Wa, "throw", Va);
                        }
                        Fo(void 0);
                      });
                    };
                  }
                  function Eg(Ai, _i) {
                    if (!(Ai instanceof _i)) throw new TypeError("Cannot call a class as a function");
                  }
                  function sp(Ai, _i) {
                    for (var Po = 0; Po < _i.length; Po++) {
                      var Gi = _i[Po];
                      Gi.enumerable = Gi.enumerable || !1, Gi.configurable = !0, "value" in Gi && (Gi.writable = !0), Object.defineProperty(Ai, eg(Gi.key), Gi);
                    }
                  }
                  function lp(Ai, _i, Po) {
                    return _i && sp(Ai.prototype, _i), Po && sp(Ai, Po), Object.defineProperty(Ai, "prototype", { writable: !1 }), Ai;
                  }
                  function eh(Ai, _i, Po) {
                    return _i = ff(_i), $p(Ai, wh() ? Reflect.construct(_i, Po || [], ff(Ai).constructor) : _i.apply(Ai, Po));
                  }
                  function $p(Ai, _i) {
                    if (_i && (typeof _i == "object" || typeof _i == "function")) return _i;
                    if (_i !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return Sg(Ai);
                  }
                  function Sg(Ai) {
                    if (Ai === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return Ai;
                  }
                  function wh() {
                    try {
                      var Ai = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                      }));
                    } catch {
                    }
                    return (wh = function() {
                      return !!Ai;
                    })();
                  }
                  function _h(Ai, _i, Po, Gi) {
                    var na = th(ff(Ai.prototype), _i, Po);
                    return 2 & Gi && typeof na == "function" ? function(ta) {
                      return na.apply(Po, ta);
                    } : na;
                  }
                  function th() {
                    return th = typeof Reflect < "u" && Reflect.get ? Reflect.get.bind() : function(Ai, _i, Po) {
                      var Gi = Ph(Ai, _i);
                      if (Gi) {
                        var na = Object.getOwnPropertyDescriptor(Gi, _i);
                        return na.get ? na.get.call(arguments.length < 3 ? Ai : Po) : na.value;
                      }
                    }, th.apply(null, arguments);
                  }
                  function Ph(Ai, _i) {
                    for (; !{}.hasOwnProperty.call(Ai, _i) && (Ai = ff(Ai)) !== null; ) ;
                    return Ai;
                  }
                  function ff(Ai) {
                    return ff = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(_i) {
                      return _i.__proto__ || Object.getPrototypeOf(_i);
                    }, ff(Ai);
                  }
                  function xg(Ai, _i) {
                    if (typeof _i != "function" && _i !== null) throw new TypeError("Super expression must either be null or a function");
                    Ai.prototype = Object.create(_i && _i.prototype, { constructor: { value: Ai, writable: !0, configurable: !0 } }), Object.defineProperty(Ai, "prototype", { writable: !1 }), _i && rh(Ai, _i);
                  }
                  function rh(Ai, _i) {
                    return rh = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(Po, Gi) {
                      return Po.__proto__ = Gi, Po;
                    }, rh(Ai, _i);
                  }
                  function Ch(Ai, _i, Po) {
                    Rh(Ai, _i), _i.set(Ai, Po);
                  }
                  function wg(Ai, _i) {
                    Rh(Ai, _i), _i.add(Ai);
                  }
                  function Rh(Ai, _i) {
                    if (_i.has(Ai)) throw new TypeError("Cannot initialize the same private elements twice on an object");
                  }
                  function _g(Ai, _i, Po) {
                    return (_i = eg(_i)) in Ai ? Object.defineProperty(Ai, _i, { value: Po, enumerable: !0, configurable: !0, writable: !0 }) : Ai[_i] = Po, Ai;
                  }
                  function eg(Ai) {
                    var _i = Kg(Ai, "string");
                    return typeof _i == "symbol" ? _i : _i + "";
                  }
                  function Kg(Ai, _i) {
                    if (typeof Ai != "object" || !Ai) return Ai;
                    var Po = Ai[Symbol.toPrimitive];
                    if (Po !== void 0) {
                      var Gi = Po.call(Ai, _i);
                      if (typeof Gi != "object") return Gi;
                      throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (_i === "string" ? String : Number)(Ai);
                  }
                  function Cf(Ai, _i) {
                    return Ai.get(Oh(Ai, _i));
                  }
                  function Oh(Ai, _i, Po) {
                    if (typeof Ai == "function" ? Ai === _i : Ai.has(_i)) return arguments.length < 3 ? _i : Po;
                    throw new TypeError("Private element is not present on this object");
                  }
                  var tg = 10, rg = 0.25, Pg = 1, Ah = /* @__PURE__ */ new WeakSet(), Ih = /* @__PURE__ */ new WeakMap(), nh = /* @__PURE__ */ new WeakMap(), $h = /* @__PURE__ */ new WeakMap(), Ua = /* @__PURE__ */ (function(Ai) {
                    function _i(Po) {
                      var Gi;
                      if (Eg(this, _i), Gi = eh(this, _i, [Po]), wg(Gi, Ah), Ch(Gi, Ih, /* @__PURE__ */ (function() {
                        var na = ap(/* @__PURE__ */ df().mark(function ta(Fo) {
                          return df().wrap(function(Va) {
                            for (; ; ) switch (Va.prev = Va.next) {
                              case 0:
                                return Va.prev = 0, Va.next = 3, Gi.waitUntilReady();
                              case 3:
                                Va.next = 9;
                                break;
                              case 5:
                                return Va.prev = 5, Va.t0 = Va.catch(0), Gi.emit(_i.events.SOURCE_OPEN_ERROR, {
                                  error: Va.t0
                                }), Va.abrupt("return");
                              case 9:
                                Va.prev = 9, Gi.mediaSource.duration = Gi.DURATION, Va.next = 19;
                                break;
                              case 13:
                                return Va.prev = 13, Va.t1 = Va.catch(9), Gi.logger.error('Error while setting mediaSource duration to "'.concat(Gi.DURATION, '"')), Gi.logger.error(Va.t1), Gi.emit(_i.events.SOURCE_OPEN_ERROR, {
                                  error: Va.t1
                                }), Va.abrupt("return");
                              case 19:
                                Gi.emit(_i.events.SOURCE_OPEN, Fo);
                              case 20:
                              case "end":
                                return Va.stop();
                            }
                          }, ta, null, [[0, 5], [9, 13]]);
                        }));
                        return function(ta) {
                          return na.apply(this, arguments);
                        };
                      })()), Ch(Gi, nh, function(na) {
                        Gi.emit(_i.events.SOURCE_ENDED, na);
                      }), Ch(Gi, $h, function(na) {
                        Gi.emit(_i.events.ERROR, na);
                      }), Gi.mediaSource = new window.MediaSource(), !Gi.mediaSource)
                        throw new Error("The video element or mediaSource is not ready!");
                      return Gi.mediaSource.addEventListener("sourceopen", Cf(Ih, Gi)), Gi.mediaSource.addEventListener("sourceended", Cf(nh, Gi)), Gi.mediaSource.addEventListener("error", Cf($h, Gi)), Gi.objectURL = null, Gi.DURATION = tg, Gi.IS_READY_INTERVAL = rg, Gi.IS_READY_TIMEOUT = Pg, Gi;
                    }
                    return xg(_i, Ai), lp(_i, [{
                      key: "isReady",
                      value: function() {
                        return this.isDestroyComplete ? !1 : this.mediaSource.readyState === "open";
                      }
                      /**
                       * @async
                       *
                       * Wait for this MediaSource to become ready.
                       *
                       * @returns {void}
                       */
                    }, {
                      key: "waitUntilReady",
                      value: (function() {
                        var Po = ap(/* @__PURE__ */ df().mark(function na() {
                          var ta = this;
                          return df().wrap(function(Wa) {
                            for (; ; ) switch (Wa.prev = Wa.next) {
                              case 0:
                                if (!this.isDestroyComplete) {
                                  Wa.next = 2;
                                  break;
                                }
                                throw new Error("MediaSource will not become ready because it has already been destroyed");
                              case 2:
                                if (!this.isReady()) {
                                  Wa.next = 4;
                                  break;
                                }
                                return Wa.abrupt("return");
                              case 4:
                                return Wa.next = 6, Zh()(/* @__PURE__ */ (function() {
                                  var Va = ap(/* @__PURE__ */ df().mark(function wa(il, ol) {
                                    return df().wrap(function(Uu) {
                                      for (; ; ) switch (Uu.prev = Uu.next) {
                                        case 0:
                                          ta.isReady() && ol();
                                        case 1:
                                        case "end":
                                          return Uu.stop();
                                      }
                                    }, wa);
                                  }));
                                  return function(wa, il) {
                                    return Va.apply(this, arguments);
                                  };
                                })(), this.IS_READY_INTERVAL * 1e3, {
                                  iterations: this.IS_READY_TIMEOUT / this.IS_READY_INTERVAL
                                });
                              case 6:
                                if (this.isReady()) {
                                  Wa.next = 8;
                                  break;
                                }
                                throw new Error("MediaSource `readyState` timed out waiting to be `open`!");
                              case 8:
                              case "end":
                                return Wa.stop();
                            }
                          }, na, this);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "asObjectURL",
                      value: function() {
                        if (this.isDestroyed)
                          throw new Error("Cannot create objectURL while destroyed");
                        return this.objectURL || (this.objectURL = window.URL.createObjectURL(this.mediaSource)), this.objectURL;
                      }
                    }, {
                      key: "_destroy",
                      value: (function() {
                        var Po = ap(/* @__PURE__ */ df().mark(function na() {
                          return df().wrap(function(Fo) {
                            for (; ; ) switch (Fo.prev = Fo.next) {
                              case 0:
                                return this.mediaSource.removeEventListener("sourceopen", Cf(Ih, this)), this.mediaSource.removeEventListener("sourceended", Cf(nh, this)), this.mediaSource.removeEventListener("error", Cf($h, this)), Fo.prev = 3, Fo.next = 6, this.waitUntilReady();
                              case 6:
                                this.mediaSource.endOfStream(), Fo.next = 13;
                                break;
                              case 9:
                                Fo.prev = 9, Fo.t0 = Fo.catch(3), this.logger.info("MediaSource did not become ready while destroying, continuing destroy anyway..."), this.logger.info(Fo.t0);
                              case 13:
                                return Oh(Ah, this, ya).call(this), Oh(Ah, this, oa).call(this), Fo.next = 17, _h(_i, "_destroy", this, 3)([]);
                              case 17:
                              case "end":
                                return Fo.stop();
                            }
                          }, na, this, [[3, 9]]);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }], [{
                      key: "isMimeCodecSupported",
                      value: (
                        /**
                         * Check to see if the passed mimeCodec is supported by this browser.
                         *
                         * @see - https://developer.mozilla.org/en-US/docs/Web/API/MediaSource/isTypeSupported
                         *
                         * @param {string} mimeCodec
                         *   The mime code to check for support / compatibility
                         *
                         * @returns {boolean}
                         *   - true if the mimeCodec is supported
                         *   - false if the mimeCodec is not supported
                         */
                        function(Gi) {
                          return Gi ? window.MediaSource.isTypeSupported(Gi) : !1;
                        }
                      )
                      /**
                       * Create a new MediaSourceWrapper, which is a wrapper around `window.MediaSource`
                       *
                       * @param {string|object} logId
                       *   a string that identifies this MediaSource in log messages
                       *   @see - src/js/utils/Destroyable
                       */
                    }, {
                      key: "factory",
                      value: function(Gi) {
                        return new _i(Gi);
                      }
                    }]);
                  })(ja);
                  function oa() {
                    this.objectURL && window.URL.revokeObjectURL(this.objectURL), this.objectURL = null;
                  }
                  function ya() {
                    var Ai = this.mediaSource.sourceBuffers;
                    Ai.SourceBuffers && (Ai = Ai.SourceBuffers());
                    for (var _i = 0; _i < Ai.length; _i++) {
                      var Po = Ai[_i];
                      this.mediaSource.removeSourceBuffer(Po);
                    }
                  }
                  _g(Ua, "events", {
                    // --- Custom events
                    SOURCE_OPEN_ERROR: "source-open-error",
                    // --- MSE MediaSource events
                    // @todo - create an event name that makes sense in layman's terms, such
                    // as "INITIALIZED" either here or in MSEWrapper
                    SOURCE_OPEN: "sourceopen",
                    // @todo - create an event name that makes sense in layman's terms, such
                    // as "FINISHED" either here or in MSEWrapper
                    SOURCE_ENDED: "sourceended",
                    ERROR: "error"
                  });
                  function ha() {
                    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
                    ha = function() {
                      return _i;
                    };
                    var Ai, _i = {}, Po = Object.prototype, Gi = Po.hasOwnProperty, na = Object.defineProperty || function(Bi, Ci, ki) {
                      Bi[Ci] = ki.value;
                    }, ta = typeof Symbol == "function" ? Symbol : {}, Fo = ta.iterator || "@@iterator", Wa = ta.asyncIterator || "@@asyncIterator", Va = ta.toStringTag || "@@toStringTag";
                    function wa(Bi, Ci, ki) {
                      return Object.defineProperty(Bi, Ci, { value: ki, enumerable: !0, configurable: !0, writable: !0 }), Bi[Ci];
                    }
                    try {
                      wa({}, "");
                    } catch {
                      wa = function(ki, Mo, Xo) {
                        return ki[Mo] = Xo;
                      };
                    }
                    function il(Bi, Ci, ki, Mo) {
                      var Xo = Ci && Ci.prototype instanceof pu ? Ci : pu, Uo = Object.create(Xo.prototype), qa = new ku(Mo || []);
                      return na(Uo, "_invoke", { value: pc(Bi, ki, qa) }), Uo;
                    }
                    function ol(Bi, Ci, ki) {
                      try {
                        return { type: "normal", arg: Bi.call(Ci, ki) };
                      } catch (Mo) {
                        return { type: "throw", arg: Mo };
                      }
                    }
                    _i.wrap = il;
                    var Ql = "suspendedStart", Uu = "suspendedYield", Wu = "executing", Kl = "completed", pl = {};
                    function pu() {
                    }
                    function lu() {
                    }
                    function Nl() {
                    }
                    var Eu = {};
                    wa(Eu, Fo, function() {
                      return this;
                    });
                    var wu = Object.getPrototypeOf, yu = wu && wu(wu(Nu([])));
                    yu && yu !== Po && Gi.call(yu, Fo) && (Eu = yu);
                    var zl = Nl.prototype = pu.prototype = Object.create(Eu);
                    function Qu(Bi) {
                      ["next", "throw", "return"].forEach(function(Ci) {
                        wa(Bi, Ci, function(ki) {
                          return this._invoke(Ci, ki);
                        });
                      });
                    }
                    function gu(Bi, Ci) {
                      function ki(Xo, Uo, qa, Us) {
                        var Hs = ol(Bi[Xo], Bi, Uo);
                        if (Hs.type !== "throw") {
                          var jl = Hs.arg, Al = jl.value;
                          return Al && typeof Al == "object" && Gi.call(Al, "__await") ? Ci.resolve(Al.__await).then(function(Ml) {
                            ki("next", Ml, qa, Us);
                          }, function(Ml) {
                            ki("throw", Ml, qa, Us);
                          }) : Ci.resolve(Al).then(function(Ml) {
                            jl.value = Ml, qa(jl);
                          }, function(Ml) {
                            return ki("throw", Ml, qa, Us);
                          });
                        }
                        Us(Hs.arg);
                      }
                      var Mo;
                      na(this, "_invoke", { value: function(Uo, qa) {
                        function Us() {
                          return new Ci(function(Hs, jl) {
                            ki(Uo, qa, Hs, jl);
                          });
                        }
                        return Mo = Mo ? Mo.then(Us, Us) : Us();
                      } });
                    }
                    function pc(Bi, Ci, ki) {
                      var Mo = Ql;
                      return function(Xo, Uo) {
                        if (Mo === Wu) throw Error("Generator is already running");
                        if (Mo === Kl) {
                          if (Xo === "throw") throw Uo;
                          return { value: Ai, done: !0 };
                        }
                        for (ki.method = Xo, ki.arg = Uo; ; ) {
                          var qa = ki.delegate;
                          if (qa) {
                            var Us = Zu(qa, ki);
                            if (Us) {
                              if (Us === pl) continue;
                              return Us;
                            }
                          }
                          if (ki.method === "next") ki.sent = ki._sent = ki.arg;
                          else if (ki.method === "throw") {
                            if (Mo === Ql) throw Mo = Kl, ki.arg;
                            ki.dispatchException(ki.arg);
                          } else ki.method === "return" && ki.abrupt("return", ki.arg);
                          Mo = Wu;
                          var Hs = ol(Bi, Ci, ki);
                          if (Hs.type === "normal") {
                            if (Mo = ki.done ? Kl : Uu, Hs.arg === pl) continue;
                            return { value: Hs.arg, done: ki.done };
                          }
                          Hs.type === "throw" && (Mo = Kl, ki.method = "throw", ki.arg = Hs.arg);
                        }
                      };
                    }
                    function Zu(Bi, Ci) {
                      var ki = Ci.method, Mo = Bi.iterator[ki];
                      if (Mo === Ai) return Ci.delegate = null, ki === "throw" && Bi.iterator.return && (Ci.method = "return", Ci.arg = Ai, Zu(Bi, Ci), Ci.method === "throw") || ki !== "return" && (Ci.method = "throw", Ci.arg = new TypeError("The iterator does not provide a '" + ki + "' method")), pl;
                      var Xo = ol(Mo, Bi.iterator, Ci.arg);
                      if (Xo.type === "throw") return Ci.method = "throw", Ci.arg = Xo.arg, Ci.delegate = null, pl;
                      var Uo = Xo.arg;
                      return Uo ? Uo.done ? (Ci[Bi.resultName] = Uo.value, Ci.next = Bi.nextLoc, Ci.method !== "return" && (Ci.method = "next", Ci.arg = Ai), Ci.delegate = null, pl) : Uo : (Ci.method = "throw", Ci.arg = new TypeError("iterator result is not an object"), Ci.delegate = null, pl);
                    }
                    function gc(Bi) {
                      var Ci = { tryLoc: Bi[0] };
                      1 in Bi && (Ci.catchLoc = Bi[1]), 2 in Bi && (Ci.finallyLoc = Bi[2], Ci.afterLoc = Bi[3]), this.tryEntries.push(Ci);
                    }
                    function Du(Bi) {
                      var Ci = Bi.completion || {};
                      Ci.type = "normal", delete Ci.arg, Bi.completion = Ci;
                    }
                    function ku(Bi) {
                      this.tryEntries = [{ tryLoc: "root" }], Bi.forEach(gc, this), this.reset(!0);
                    }
                    function Nu(Bi) {
                      if (Bi || Bi === "") {
                        var Ci = Bi[Fo];
                        if (Ci) return Ci.call(Bi);
                        if (typeof Bi.next == "function") return Bi;
                        if (!isNaN(Bi.length)) {
                          var ki = -1, Mo = function Xo() {
                            for (; ++ki < Bi.length; ) if (Gi.call(Bi, ki)) return Xo.value = Bi[ki], Xo.done = !1, Xo;
                            return Xo.value = Ai, Xo.done = !0, Xo;
                          };
                          return Mo.next = Mo;
                        }
                      }
                      throw new TypeError(typeof Bi + " is not iterable");
                    }
                    return lu.prototype = Nl, na(zl, "constructor", { value: Nl, configurable: !0 }), na(Nl, "constructor", { value: lu, configurable: !0 }), lu.displayName = wa(Nl, Va, "GeneratorFunction"), _i.isGeneratorFunction = function(Bi) {
                      var Ci = typeof Bi == "function" && Bi.constructor;
                      return !!Ci && (Ci === lu || (Ci.displayName || Ci.name) === "GeneratorFunction");
                    }, _i.mark = function(Bi) {
                      return Object.setPrototypeOf ? Object.setPrototypeOf(Bi, Nl) : (Bi.__proto__ = Nl, wa(Bi, Va, "GeneratorFunction")), Bi.prototype = Object.create(zl), Bi;
                    }, _i.awrap = function(Bi) {
                      return { __await: Bi };
                    }, Qu(gu.prototype), wa(gu.prototype, Wa, function() {
                      return this;
                    }), _i.AsyncIterator = gu, _i.async = function(Bi, Ci, ki, Mo, Xo) {
                      Xo === void 0 && (Xo = Promise);
                      var Uo = new gu(il(Bi, Ci, ki, Mo), Xo);
                      return _i.isGeneratorFunction(Ci) ? Uo : Uo.next().then(function(qa) {
                        return qa.done ? qa.value : Uo.next();
                      });
                    }, Qu(zl), wa(zl, Va, "Generator"), wa(zl, Fo, function() {
                      return this;
                    }), wa(zl, "toString", function() {
                      return "[object Generator]";
                    }), _i.keys = function(Bi) {
                      var Ci = Object(Bi), ki = [];
                      for (var Mo in Ci) ki.push(Mo);
                      return ki.reverse(), function Xo() {
                        for (; ki.length; ) {
                          var Uo = ki.pop();
                          if (Uo in Ci) return Xo.value = Uo, Xo.done = !1, Xo;
                        }
                        return Xo.done = !0, Xo;
                      };
                    }, _i.values = Nu, ku.prototype = { constructor: ku, reset: function(Ci) {
                      if (this.prev = 0, this.next = 0, this.sent = this._sent = Ai, this.done = !1, this.delegate = null, this.method = "next", this.arg = Ai, this.tryEntries.forEach(Du), !Ci) for (var ki in this) ki.charAt(0) === "t" && Gi.call(this, ki) && !isNaN(+ki.slice(1)) && (this[ki] = Ai);
                    }, stop: function() {
                      this.done = !0;
                      var Ci = this.tryEntries[0].completion;
                      if (Ci.type === "throw") throw Ci.arg;
                      return this.rval;
                    }, dispatchException: function(Ci) {
                      if (this.done) throw Ci;
                      var ki = this;
                      function Mo(jl, Al) {
                        return qa.type = "throw", qa.arg = Ci, ki.next = jl, Al && (ki.method = "next", ki.arg = Ai), !!Al;
                      }
                      for (var Xo = this.tryEntries.length - 1; Xo >= 0; --Xo) {
                        var Uo = this.tryEntries[Xo], qa = Uo.completion;
                        if (Uo.tryLoc === "root") return Mo("end");
                        if (Uo.tryLoc <= this.prev) {
                          var Us = Gi.call(Uo, "catchLoc"), Hs = Gi.call(Uo, "finallyLoc");
                          if (Us && Hs) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          } else if (Us) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                          } else {
                            if (!Hs) throw Error("try statement without catch or finally");
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          }
                        }
                      }
                    }, abrupt: function(Ci, ki) {
                      for (var Mo = this.tryEntries.length - 1; Mo >= 0; --Mo) {
                        var Xo = this.tryEntries[Mo];
                        if (Xo.tryLoc <= this.prev && Gi.call(Xo, "finallyLoc") && this.prev < Xo.finallyLoc) {
                          var Uo = Xo;
                          break;
                        }
                      }
                      Uo && (Ci === "break" || Ci === "continue") && Uo.tryLoc <= ki && ki <= Uo.finallyLoc && (Uo = null);
                      var qa = Uo ? Uo.completion : {};
                      return qa.type = Ci, qa.arg = ki, Uo ? (this.method = "next", this.next = Uo.finallyLoc, pl) : this.complete(qa);
                    }, complete: function(Ci, ki) {
                      if (Ci.type === "throw") throw Ci.arg;
                      return Ci.type === "break" || Ci.type === "continue" ? this.next = Ci.arg : Ci.type === "return" ? (this.rval = this.arg = Ci.arg, this.method = "return", this.next = "end") : Ci.type === "normal" && ki && (this.next = ki), pl;
                    }, finish: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.finallyLoc === Ci) return this.complete(Mo.completion, Mo.afterLoc), Du(Mo), pl;
                      }
                    }, catch: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.tryLoc === Ci) {
                          var Xo = Mo.completion;
                          if (Xo.type === "throw") {
                            var Uo = Xo.arg;
                            Du(Mo);
                          }
                          return Uo;
                        }
                      }
                      throw Error("illegal catch attempt");
                    }, delegateYield: function(Ci, ki, Mo) {
                      return this.delegate = { iterator: Nu(Ci), resultName: ki, nextLoc: Mo }, this.method === "next" && (this.arg = Ai), pl;
                    } }, _i;
                  }
                  function Aa(Ai, _i, Po, Gi, na, ta, Fo) {
                    try {
                      var Wa = Ai[ta](Fo), Va = Wa.value;
                    } catch (wa) {
                      return void Po(wa);
                    }
                    Wa.done ? _i(Va) : Promise.resolve(Va).then(Gi, na);
                  }
                  function da(Ai) {
                    return function() {
                      var _i = this, Po = arguments;
                      return new Promise(function(Gi, na) {
                        var ta = Ai.apply(_i, Po);
                        function Fo(Va) {
                          Aa(ta, Gi, na, Fo, Wa, "next", Va);
                        }
                        function Wa(Va) {
                          Aa(ta, Gi, na, Fo, Wa, "throw", Va);
                        }
                        Fo(void 0);
                      });
                    };
                  }
                  function fa(Ai, _i) {
                    if (!(Ai instanceof _i)) throw new TypeError("Cannot call a class as a function");
                  }
                  function gs(Ai, _i) {
                    for (var Po = 0; Po < _i.length; Po++) {
                      var Gi = _i[Po];
                      Gi.enumerable = Gi.enumerable || !1, Gi.configurable = !0, "value" in Gi && (Gi.writable = !0), Object.defineProperty(Ai, vu(Gi.key), Gi);
                    }
                  }
                  function Gs(Ai, _i, Po) {
                    return _i && gs(Ai.prototype, _i), Po && gs(Ai, Po), Object.defineProperty(Ai, "prototype", { writable: !1 }), Ai;
                  }
                  function qs(Ai, _i, Po) {
                    return _i = tc(_i), El(Ai, ju() ? Reflect.construct(_i, Po || [], tc(Ai).constructor) : _i.apply(Ai, Po));
                  }
                  function El(Ai, _i) {
                    if (_i && (typeof _i == "object" || typeof _i == "function")) return _i;
                    if (_i !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return kl(Ai);
                  }
                  function kl(Ai) {
                    if (Ai === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return Ai;
                  }
                  function ju() {
                    try {
                      var Ai = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                      }));
                    } catch {
                    }
                    return (ju = function() {
                      return !!Ai;
                    })();
                  }
                  function Yu(Ai, _i, Po, Gi) {
                    var na = Lc(tc(Ai.prototype), _i, Po);
                    return 2 & Gi && typeof na == "function" ? function(ta) {
                      return na.apply(Po, ta);
                    } : na;
                  }
                  function Lc() {
                    return Lc = typeof Reflect < "u" && Reflect.get ? Reflect.get.bind() : function(Ai, _i, Po) {
                      var Gi = Ed(Ai, _i);
                      if (Gi) {
                        var na = Object.getOwnPropertyDescriptor(Gi, _i);
                        return na.get ? na.get.call(arguments.length < 3 ? Ai : Po) : na.value;
                      }
                    }, Lc.apply(null, arguments);
                  }
                  function Ed(Ai, _i) {
                    for (; !{}.hasOwnProperty.call(Ai, _i) && (Ai = tc(Ai)) !== null; ) ;
                    return Ai;
                  }
                  function tc(Ai) {
                    return tc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(_i) {
                      return _i.__proto__ || Object.getPrototypeOf(_i);
                    }, tc(Ai);
                  }
                  function bc(Ai, _i) {
                    if (typeof _i != "function" && _i !== null) throw new TypeError("Super expression must either be null or a function");
                    Ai.prototype = Object.create(_i && _i.prototype, { constructor: { value: Ai, writable: !0, configurable: !0 } }), Object.defineProperty(Ai, "prototype", { writable: !1 }), _i && ud(Ai, _i);
                  }
                  function ud(Ai, _i) {
                    return ud = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(Po, Gi) {
                      return Po.__proto__ = Gi, Po;
                    }, ud(Ai, _i);
                  }
                  function qf(Ai, _i, Po) {
                    yd(Ai, _i), _i.set(Ai, Po);
                  }
                  function yd(Ai, _i) {
                    if (_i.has(Ai)) throw new TypeError("Cannot initialize the same private elements twice on an object");
                  }
                  function Id(Ai, _i, Po) {
                    return (_i = vu(_i)) in Ai ? Object.defineProperty(Ai, _i, { value: Po, enumerable: !0, configurable: !0, writable: !0 }) : Ai[_i] = Po, Ai;
                  }
                  function vu(Ai) {
                    var _i = Cg(Ai, "string");
                    return typeof _i == "symbol" ? _i : _i + "";
                  }
                  function Cg(Ai, _i) {
                    if (typeof Ai != "object" || !Ai) return Ai;
                    var Po = Ai[Symbol.toPrimitive];
                    if (Po !== void 0) {
                      var Gi = Po.call(Ai, _i);
                      if (typeof Gi != "object") return Gi;
                      throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (_i === "string" ? String : Number)(Ai);
                  }
                  function ng(Ai, _i) {
                    return Ai.get(qg(Ai, _i));
                  }
                  function qg(Ai, _i, Po) {
                    if (typeof Ai == "function" ? Ai === _i : Ai.has(_i)) return arguments.length < 3 ? _i : Po;
                    throw new TypeError("Private element is not present on this object");
                  }
                  var Yg = "and cannot free space to append additional buffers", Rg = 0.25, ay = 10, id = 2, ig = 2, Dh = /* @__PURE__ */ new WeakMap(), Dp = /* @__PURE__ */ new WeakMap(), Rf = /* @__PURE__ */ (function(Ai) {
                    function _i(Po, Gi, na) {
                      var ta;
                      if (fa(this, _i), ta = qs(this, _i, [Po]), Id(ta, "mimeCodec", null), Id(ta, "mediaSource", null), Id(ta, "sourceBuffer", null), Id(ta, "timeBuffered", null), qf(ta, Dh, function(Fo) {
                        if (ta.isDestroyComplete)
                          throw new Error("Received `updateend` event while destroyed!");
                        if (ta.lastSourceBufferOp === "remove") {
                          ta.logger.debug("onUpdateEnd ocurred as the result of a remove operation");
                          return;
                        }
                        if (ta.shouldAbortOnNextUpdateEnd)
                          try {
                            ta.metric("sourceBuffer.abort", 1), ta.sourceBuffer.abort(), ta.shouldAbortOnNextUpdateEnd = !1;
                          } catch (Wa) {
                            ta.metric("error.sourceBuffer.abort", 1), ta.emit(_i.events.ABORT_ERROR, {
                              error: Wa
                            });
                          }
                        try {
                          if (ta.sourceBuffer.buffered.length <= 0) {
                            ta.metric("sourceBuffer.updateEnd.bufferLength.empty", 1), ta.logger.debug("After updating, the sourceBuffer has no length!");
                            return;
                          }
                        } catch {
                          ta.metric("sourceBuffer.updateEnd.bufferLength.error", 1), ta.logger.debug("The mediaSource was removed while an update operation was occurring.");
                          return;
                        }
                        ta.emit(_i.events.UPDATE_END, Fo);
                      }), qf(ta, Dp, function(Fo) {
                        ta.emit(_i.events.ERROR, Fo);
                      }), !Gi)
                        throw new Error("`mimeCodec` is required to instantiate a SourceBuffer");
                      if (!na)
                        throw new Error("`mediaSource` is required to instantiate a SourceBuffer");
                      return ta.mimeCodec = Gi, ta.mediaSource = na, ta.sourceBuffer = ta.mediaSource.mediaSource.addSourceBuffer(ta.mimeCodec), ta.sourceBuffer.mode = "sequence", ta.sourceBuffer.addEventListener("updateend", ng(Dh, ta)), ta.sourceBuffer.addEventListener("error", ng(Dp, ta)), ta.IS_READY_INTERVAL = Rg, ta.IS_READY_TIMEOUT = ay, ta.DRIFT_THRESHOLD = id, ta.BUFFER_SIZE_LIMIT = _i.getDefaultBufferSizeLimit(), ta.BUFFER_TRUNCATE_VALUE = parseInt(ta.BUFFER_SIZE_LIMIT / ig), ta;
                    }
                    return bc(_i, Ai), Gs(_i, [{
                      key: "isReady",
                      value: function() {
                        return this.isDestroyComplete ? !1 : this.sourceBuffer.updating === !1;
                      }
                      /**
                       * @async
                       *
                       * Wait for this SourceBuffer to become ready.
                       *
                       * @returns {void}
                       */
                    }, {
                      key: "waitUntilReady",
                      value: (function() {
                        var Po = da(/* @__PURE__ */ ha().mark(function na() {
                          var ta = this;
                          return ha().wrap(function(Wa) {
                            for (; ; ) switch (Wa.prev = Wa.next) {
                              case 0:
                                if (!this.isDestroyComplete) {
                                  Wa.next = 2;
                                  break;
                                }
                                throw new Error("SourceBuffer will not become ready because it has already been destroyed");
                              case 2:
                                if (!this.isReady()) {
                                  Wa.next = 4;
                                  break;
                                }
                                return Wa.abrupt("return");
                              case 4:
                                return Wa.next = 6, Zh()(/* @__PURE__ */ (function() {
                                  var Va = da(/* @__PURE__ */ ha().mark(function wa(il, ol) {
                                    return ha().wrap(function(Uu) {
                                      for (; ; ) switch (Uu.prev = Uu.next) {
                                        case 0:
                                          ta.isReady() && ol();
                                        case 1:
                                        case "end":
                                          return Uu.stop();
                                      }
                                    }, wa);
                                  }));
                                  return function(wa, il) {
                                    return Va.apply(this, arguments);
                                  };
                                })(), this.IS_READY_INTERVAL * 1e3, {
                                  iterations: this.IS_READY_TIMEOUT / this.IS_READY_INTERVAL
                                });
                              case 6:
                                if (this.isReady()) {
                                  Wa.next = 8;
                                  break;
                                }
                                throw new Error("SourceBuffer `updating` timed out!");
                              case 8:
                              case "end":
                                return Wa.stop();
                            }
                          }, na, this);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "append",
                      value: function(Gi) {
                        if (!this.isDestroyComplete) {
                          this.logger.silly("Appending to the sourceBuffer...");
                          var na = Gi.timestamp, ta = Gi.byteArray, Fo = (Date.now() - na) / 1e3;
                          if (Fo > this.DRIFT_THRESHOLD) {
                            this.emit(_i.events.DRIFT_THRESHOLD_EXCEEDED, {
                              estimatedDrift: Fo,
                              driftThreshold: this.DRIFT_THRESHOLD
                            });
                            return;
                          }
                          this.logger.silly("Appending to the buffer with an estimated drift of ".concat(Fo));
                          try {
                            if (this.sourceBuffer.updating) {
                              this.logger.warn("Source buffer is still updating! Cannot append!");
                              return;
                            }
                            this.lastSourceBufferOp = "append", this.sourceBuffer.appendBuffer(ta);
                          } catch (Wa) {
                            try {
                              if (Wa.message && Wa.message.toLowerCase().includes(Yg))
                                this.logger.warn("source buffer is full, about to flush it..."), this.clear();
                              else
                                throw Wa;
                            } finally {
                              this.metric("error.sourceBuffer.append", 1);
                            }
                          }
                        }
                      }
                      /**
                       * Schedule an abort for the next possible time.
                       *
                       * @returns {void}
                       */
                    }, {
                      key: "abort",
                      value: function() {
                        this.shouldAbortOnNextUpdateEnd = !0;
                      }
                      /** Detect a gap in the buffered time ranges */
                    }, {
                      key: "gapInBufferedRanges",
                      value: function(Gi) {
                        var na = this.sourceBuffer.buffered;
                        if (na.length <= 1 || Gi + 1 === na.length)
                          return !1;
                        var ta = na.end(Gi), Fo = na.start(Gi + 1), Wa = Fo - ta;
                        return Wa > 0;
                      }
                      /**
                       * Calculate size and time information about the current state of the buffer.
                       *
                       * @todo - provide better description
                       */
                    }, {
                      key: "getTimes",
                      value: function() {
                        if (this.isDestroyComplete)
                          return null;
                        this.logger.silly("getBufferTimes...");
                        var Gi = [];
                        try {
                          var na = this.timeBuffered, ta = this.sourceBuffer.buffered;
                          this.logger.debug("this.sourceBuffer.buffered length: " + ta.length);
                          for (var Fo = 0; Fo < ta.length; Fo++) {
                            this.logger.info("Range ".concat(Fo, ": ").concat(ta.start(Fo), " to ").concat(ta.end(Fo), " seconds"));
                            var Wa = ta.start(Fo), Va = ta.end(Fo), wa = Va - Wa;
                            Gi.push({
                              previousBufferSize: na,
                              currentBufferSize: wa,
                              bufferTimeStart: Wa,
                              bufferTimeEnd: Va
                            });
                          }
                          var il = ta.length - 1;
                          return this.timeBuffered = ta.end(il) - ta.start(0), this.logger.silly("getBufferTimes finished successfully..."), Gi;
                        } catch {
                          return this.logger.info("Failed to getBufferTimes..."), null;
                        }
                      }
                      /**
                       * Trim the SourceBuffer to help with memory management and to help keep the
                       * video stream near-real time (?)
                       *
                       * @todo - under what circumstances should this be called?  Right now, it is
                       * called after EVERY UPDATE_END event!  Is that correct / necessary? Maybe
                       * it should only be called every other time, or every 5th time...
                       *
                       * @param {object[]|null} info
                       *   optional, SourceBuffer time info
                       * @param {boolean} shouldClear
                       *   optional, defaults to false
                       *   if true, will clear the entire SourceBuffer's internal buffer
                       */
                    }, {
                      key: "trim",
                      value: function() {
                        var Gi = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.getTimes(), na = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                        if (!this.isDestroyComplete) {
                          if (this.logger.debug("time buffered: " + this.timeBuffered), !Gi || Gi.length === 0) {
                            this.logger.debug("Tried to trim buffer, failed to get buffer times...");
                            return;
                          }
                          var ta = Gi.shift();
                          this.logger.silly("trimBuffer..."), this.metric("sourceBuffer.lastKnownBufferSize", this.timeBuffered);
                          var Fo = na || this.timeBuffered > this.BUFFER_SIZE_LIMIT;
                          if (!Fo) {
                            this.logger.debug("No need to trim");
                            return;
                          }
                          if (!this.isReady()) {
                            this.logger.info("Need to trim, but not ready...");
                            return;
                          }
                          try {
                            if (this.metric("sourceBuffer.trim", this.BUFFER_TRUNCATE_VALUE), na)
                              this.logger.debug("Clearing buffer..."), this.sourceBuffer.remove(ta.bufferTimeStart, 1 / 0), this.logger.debug("Successfully cleared buffer...");
                            else {
                              var Wa = ta.bufferTimeStart + this.BUFFER_TRUNCATE_VALUE;
                              this.logger.debug("Trimming buffer..."), this.lastSourceBufferOp = "remove", this.sourceBuffer.remove(ta.bufferTimeStart, Wa), this.logger.debug("Successfully trimmed buffer...");
                            }
                          } catch (Va) {
                            if (Va.constructor.name === "DOMException") {
                              this.logger.info("Encountered DOMException while trying to trim buffer");
                              return;
                            }
                            throw this.logger.debug("trimBuffer failure!"), Va;
                          }
                        }
                      }
                      /**
                       * Completely clear / flush the SourceBuffer's internal buffer.
                       *
                       * To be called when the buffer is full, prior to the destruction of the
                       * parent MediaSource, and during destruction of this SourceBuffer.
                       *
                       * @todo - it would be better if we could either destroy the SourceBuffer
                       * before destroying the parent MediaSource...
                       */
                    }, {
                      key: "clear",
                      value: function() {
                        this.logger.info("Clearing buffer..."), this.trim(void 0, !0);
                      }
                    }, {
                      key: "metric",
                      value: (
                        // @todo @metrics
                        function() {
                        }
                      )
                    }, {
                      key: "_destroy",
                      value: (function() {
                        var Po = da(/* @__PURE__ */ ha().mark(function na() {
                          var ta = this;
                          return ha().wrap(function(Wa) {
                            for (; ; ) switch (Wa.prev = Wa.next) {
                              case 0:
                                return Wa.next = 2, new Promise(function(Va, wa) {
                                  var il = function() {
                                    ta.sourceBuffer.removeEventListener("updateend", il), Va();
                                  };
                                  if (!ta.sourceBuffer)
                                    return Va();
                                  ta.sourceBuffer.addEventListener("updateend", il), ta.abort(), ta.logger.debug("giving sourceBuffer some time to finish updating itself..."), setTimeout(il, 1e3);
                                });
                              case 2:
                                try {
                                  this.clear();
                                } catch (Va) {
                                  this.logger.error("Error while clearing the buffer while destroying, continuing destroy anyway..."), this.logger.error(Va);
                                }
                                return this.sourceBuffer.removeEventListener("updateend", ng(Dh, this)), this.sourceBuffer.removeEventListener("error", ng(Dp, this)), this.mimeCodec = null, this.mediaSource = null, this.sourceBuffer = null, this.timeBuffered = null, Wa.next = 11, Yu(_i, "_destroy", this, 3)([]);
                              case 11:
                              case "end":
                                return Wa.stop();
                            }
                          }, na, this);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }], [{
                      key: "getDefaultBufferSizeLimit",
                      value: function() {
                        return 90 + Math.floor(Math.random() * 200);
                      }
                      /**
                       * Create a new SourceBuffer, which is a wrapper around `window.SourceBuffer`
                       *
                       * @param {string|object} logId
                       *   a string that identifies this SourceBuffer in log messages
                       *   @see - src/js/utils/Destroyable
                       * @param {string} mimeCodec
                       *   The mime codec of the stream
                       * @param {MediaSource} mediaSource
                       *   The MediaSource instance to which this SourceBuffer instance will be
                       *   added
                       */
                    }, {
                      key: "factory",
                      value: function(Gi, na, ta) {
                        return new _i(Gi, na, ta);
                      }
                    }]);
                  })(ja);
                  Id(Rf, "events", {
                    // --- Custom Events
                    ABORT_ERROR: "abort-error",
                    DRIFT_THRESHOLD_EXCEEDED: "drift-threshold-exceeded",
                    // --- MSE Source Buffer Events
                    // @todo - create an event name that makes sense in layman's terms, such
                    // as "???" either here or in MSEWrapper
                    UPDATE_END: "updateend",
                    ERROR: "error"
                  });
                  var ih;
                  function pf() {
                    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
                    pf = function() {
                      return _i;
                    };
                    var Ai, _i = {}, Po = Object.prototype, Gi = Po.hasOwnProperty, na = Object.defineProperty || function(Bi, Ci, ki) {
                      Bi[Ci] = ki.value;
                    }, ta = typeof Symbol == "function" ? Symbol : {}, Fo = ta.iterator || "@@iterator", Wa = ta.asyncIterator || "@@asyncIterator", Va = ta.toStringTag || "@@toStringTag";
                    function wa(Bi, Ci, ki) {
                      return Object.defineProperty(Bi, Ci, { value: ki, enumerable: !0, configurable: !0, writable: !0 }), Bi[Ci];
                    }
                    try {
                      wa({}, "");
                    } catch {
                      wa = function(ki, Mo, Xo) {
                        return ki[Mo] = Xo;
                      };
                    }
                    function il(Bi, Ci, ki, Mo) {
                      var Xo = Ci && Ci.prototype instanceof pu ? Ci : pu, Uo = Object.create(Xo.prototype), qa = new ku(Mo || []);
                      return na(Uo, "_invoke", { value: pc(Bi, ki, qa) }), Uo;
                    }
                    function ol(Bi, Ci, ki) {
                      try {
                        return { type: "normal", arg: Bi.call(Ci, ki) };
                      } catch (Mo) {
                        return { type: "throw", arg: Mo };
                      }
                    }
                    _i.wrap = il;
                    var Ql = "suspendedStart", Uu = "suspendedYield", Wu = "executing", Kl = "completed", pl = {};
                    function pu() {
                    }
                    function lu() {
                    }
                    function Nl() {
                    }
                    var Eu = {};
                    wa(Eu, Fo, function() {
                      return this;
                    });
                    var wu = Object.getPrototypeOf, yu = wu && wu(wu(Nu([])));
                    yu && yu !== Po && Gi.call(yu, Fo) && (Eu = yu);
                    var zl = Nl.prototype = pu.prototype = Object.create(Eu);
                    function Qu(Bi) {
                      ["next", "throw", "return"].forEach(function(Ci) {
                        wa(Bi, Ci, function(ki) {
                          return this._invoke(Ci, ki);
                        });
                      });
                    }
                    function gu(Bi, Ci) {
                      function ki(Xo, Uo, qa, Us) {
                        var Hs = ol(Bi[Xo], Bi, Uo);
                        if (Hs.type !== "throw") {
                          var jl = Hs.arg, Al = jl.value;
                          return Al && typeof Al == "object" && Gi.call(Al, "__await") ? Ci.resolve(Al.__await).then(function(Ml) {
                            ki("next", Ml, qa, Us);
                          }, function(Ml) {
                            ki("throw", Ml, qa, Us);
                          }) : Ci.resolve(Al).then(function(Ml) {
                            jl.value = Ml, qa(jl);
                          }, function(Ml) {
                            return ki("throw", Ml, qa, Us);
                          });
                        }
                        Us(Hs.arg);
                      }
                      var Mo;
                      na(this, "_invoke", { value: function(Uo, qa) {
                        function Us() {
                          return new Ci(function(Hs, jl) {
                            ki(Uo, qa, Hs, jl);
                          });
                        }
                        return Mo = Mo ? Mo.then(Us, Us) : Us();
                      } });
                    }
                    function pc(Bi, Ci, ki) {
                      var Mo = Ql;
                      return function(Xo, Uo) {
                        if (Mo === Wu) throw Error("Generator is already running");
                        if (Mo === Kl) {
                          if (Xo === "throw") throw Uo;
                          return { value: Ai, done: !0 };
                        }
                        for (ki.method = Xo, ki.arg = Uo; ; ) {
                          var qa = ki.delegate;
                          if (qa) {
                            var Us = Zu(qa, ki);
                            if (Us) {
                              if (Us === pl) continue;
                              return Us;
                            }
                          }
                          if (ki.method === "next") ki.sent = ki._sent = ki.arg;
                          else if (ki.method === "throw") {
                            if (Mo === Ql) throw Mo = Kl, ki.arg;
                            ki.dispatchException(ki.arg);
                          } else ki.method === "return" && ki.abrupt("return", ki.arg);
                          Mo = Wu;
                          var Hs = ol(Bi, Ci, ki);
                          if (Hs.type === "normal") {
                            if (Mo = ki.done ? Kl : Uu, Hs.arg === pl) continue;
                            return { value: Hs.arg, done: ki.done };
                          }
                          Hs.type === "throw" && (Mo = Kl, ki.method = "throw", ki.arg = Hs.arg);
                        }
                      };
                    }
                    function Zu(Bi, Ci) {
                      var ki = Ci.method, Mo = Bi.iterator[ki];
                      if (Mo === Ai) return Ci.delegate = null, ki === "throw" && Bi.iterator.return && (Ci.method = "return", Ci.arg = Ai, Zu(Bi, Ci), Ci.method === "throw") || ki !== "return" && (Ci.method = "throw", Ci.arg = new TypeError("The iterator does not provide a '" + ki + "' method")), pl;
                      var Xo = ol(Mo, Bi.iterator, Ci.arg);
                      if (Xo.type === "throw") return Ci.method = "throw", Ci.arg = Xo.arg, Ci.delegate = null, pl;
                      var Uo = Xo.arg;
                      return Uo ? Uo.done ? (Ci[Bi.resultName] = Uo.value, Ci.next = Bi.nextLoc, Ci.method !== "return" && (Ci.method = "next", Ci.arg = Ai), Ci.delegate = null, pl) : Uo : (Ci.method = "throw", Ci.arg = new TypeError("iterator result is not an object"), Ci.delegate = null, pl);
                    }
                    function gc(Bi) {
                      var Ci = { tryLoc: Bi[0] };
                      1 in Bi && (Ci.catchLoc = Bi[1]), 2 in Bi && (Ci.finallyLoc = Bi[2], Ci.afterLoc = Bi[3]), this.tryEntries.push(Ci);
                    }
                    function Du(Bi) {
                      var Ci = Bi.completion || {};
                      Ci.type = "normal", delete Ci.arg, Bi.completion = Ci;
                    }
                    function ku(Bi) {
                      this.tryEntries = [{ tryLoc: "root" }], Bi.forEach(gc, this), this.reset(!0);
                    }
                    function Nu(Bi) {
                      if (Bi || Bi === "") {
                        var Ci = Bi[Fo];
                        if (Ci) return Ci.call(Bi);
                        if (typeof Bi.next == "function") return Bi;
                        if (!isNaN(Bi.length)) {
                          var ki = -1, Mo = function Xo() {
                            for (; ++ki < Bi.length; ) if (Gi.call(Bi, ki)) return Xo.value = Bi[ki], Xo.done = !1, Xo;
                            return Xo.value = Ai, Xo.done = !0, Xo;
                          };
                          return Mo.next = Mo;
                        }
                      }
                      throw new TypeError(typeof Bi + " is not iterable");
                    }
                    return lu.prototype = Nl, na(zl, "constructor", { value: Nl, configurable: !0 }), na(Nl, "constructor", { value: lu, configurable: !0 }), lu.displayName = wa(Nl, Va, "GeneratorFunction"), _i.isGeneratorFunction = function(Bi) {
                      var Ci = typeof Bi == "function" && Bi.constructor;
                      return !!Ci && (Ci === lu || (Ci.displayName || Ci.name) === "GeneratorFunction");
                    }, _i.mark = function(Bi) {
                      return Object.setPrototypeOf ? Object.setPrototypeOf(Bi, Nl) : (Bi.__proto__ = Nl, wa(Bi, Va, "GeneratorFunction")), Bi.prototype = Object.create(zl), Bi;
                    }, _i.awrap = function(Bi) {
                      return { __await: Bi };
                    }, Qu(gu.prototype), wa(gu.prototype, Wa, function() {
                      return this;
                    }), _i.AsyncIterator = gu, _i.async = function(Bi, Ci, ki, Mo, Xo) {
                      Xo === void 0 && (Xo = Promise);
                      var Uo = new gu(il(Bi, Ci, ki, Mo), Xo);
                      return _i.isGeneratorFunction(Ci) ? Uo : Uo.next().then(function(qa) {
                        return qa.done ? qa.value : Uo.next();
                      });
                    }, Qu(zl), wa(zl, Va, "Generator"), wa(zl, Fo, function() {
                      return this;
                    }), wa(zl, "toString", function() {
                      return "[object Generator]";
                    }), _i.keys = function(Bi) {
                      var Ci = Object(Bi), ki = [];
                      for (var Mo in Ci) ki.push(Mo);
                      return ki.reverse(), function Xo() {
                        for (; ki.length; ) {
                          var Uo = ki.pop();
                          if (Uo in Ci) return Xo.value = Uo, Xo.done = !1, Xo;
                        }
                        return Xo.done = !0, Xo;
                      };
                    }, _i.values = Nu, ku.prototype = { constructor: ku, reset: function(Ci) {
                      if (this.prev = 0, this.next = 0, this.sent = this._sent = Ai, this.done = !1, this.delegate = null, this.method = "next", this.arg = Ai, this.tryEntries.forEach(Du), !Ci) for (var ki in this) ki.charAt(0) === "t" && Gi.call(this, ki) && !isNaN(+ki.slice(1)) && (this[ki] = Ai);
                    }, stop: function() {
                      this.done = !0;
                      var Ci = this.tryEntries[0].completion;
                      if (Ci.type === "throw") throw Ci.arg;
                      return this.rval;
                    }, dispatchException: function(Ci) {
                      if (this.done) throw Ci;
                      var ki = this;
                      function Mo(jl, Al) {
                        return qa.type = "throw", qa.arg = Ci, ki.next = jl, Al && (ki.method = "next", ki.arg = Ai), !!Al;
                      }
                      for (var Xo = this.tryEntries.length - 1; Xo >= 0; --Xo) {
                        var Uo = this.tryEntries[Xo], qa = Uo.completion;
                        if (Uo.tryLoc === "root") return Mo("end");
                        if (Uo.tryLoc <= this.prev) {
                          var Us = Gi.call(Uo, "catchLoc"), Hs = Gi.call(Uo, "finallyLoc");
                          if (Us && Hs) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          } else if (Us) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                          } else {
                            if (!Hs) throw Error("try statement without catch or finally");
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          }
                        }
                      }
                    }, abrupt: function(Ci, ki) {
                      for (var Mo = this.tryEntries.length - 1; Mo >= 0; --Mo) {
                        var Xo = this.tryEntries[Mo];
                        if (Xo.tryLoc <= this.prev && Gi.call(Xo, "finallyLoc") && this.prev < Xo.finallyLoc) {
                          var Uo = Xo;
                          break;
                        }
                      }
                      Uo && (Ci === "break" || Ci === "continue") && Uo.tryLoc <= ki && ki <= Uo.finallyLoc && (Uo = null);
                      var qa = Uo ? Uo.completion : {};
                      return qa.type = Ci, qa.arg = ki, Uo ? (this.method = "next", this.next = Uo.finallyLoc, pl) : this.complete(qa);
                    }, complete: function(Ci, ki) {
                      if (Ci.type === "throw") throw Ci.arg;
                      return Ci.type === "break" || Ci.type === "continue" ? this.next = Ci.arg : Ci.type === "return" ? (this.rval = this.arg = Ci.arg, this.method = "return", this.next = "end") : Ci.type === "normal" && ki && (this.next = ki), pl;
                    }, finish: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.finallyLoc === Ci) return this.complete(Mo.completion, Mo.afterLoc), Du(Mo), pl;
                      }
                    }, catch: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.tryLoc === Ci) {
                          var Xo = Mo.completion;
                          if (Xo.type === "throw") {
                            var Uo = Xo.arg;
                            Du(Mo);
                          }
                          return Uo;
                        }
                      }
                      throw Error("illegal catch attempt");
                    }, delegateYield: function(Ci, ki, Mo) {
                      return this.delegate = { iterator: Nu(Ci), resultName: ki, nextLoc: Mo }, this.method === "next" && (this.arg = Ai), pl;
                    } }, _i;
                  }
                  function Xg(Ai, _i, Po, Gi, na, ta, Fo) {
                    try {
                      var Wa = Ai[ta](Fo), Va = Wa.value;
                    } catch (wa) {
                      return void Po(wa);
                    }
                    Wa.done ? _i(Va) : Promise.resolve(Va).then(Gi, na);
                  }
                  function oh(Ai) {
                    return function() {
                      var _i = this, Po = arguments;
                      return new Promise(function(Gi, na) {
                        var ta = Ai.apply(_i, Po);
                        function Fo(Va) {
                          Xg(ta, Gi, na, Fo, Wa, "next", Va);
                        }
                        function Wa(Va) {
                          Xg(ta, Gi, na, Fo, Wa, "throw", Va);
                        }
                        Fo(void 0);
                      });
                    };
                  }
                  function sy(Ai, _i) {
                    if (!(Ai instanceof _i)) throw new TypeError("Cannot call a class as a function");
                  }
                  function Jg(Ai, _i) {
                    for (var Po = 0; Po < _i.length; Po++) {
                      var Gi = _i[Po];
                      Gi.enumerable = Gi.enumerable || !1, Gi.configurable = !0, "value" in Gi && (Gi.writable = !0), Object.defineProperty(Ai, ag(Gi.key), Gi);
                    }
                  }
                  function Yf(Ai, _i, Po) {
                    return _i && Jg(Ai.prototype, _i), Po && Jg(Ai, Po), Object.defineProperty(Ai, "prototype", { writable: !1 }), Ai;
                  }
                  function zm(Ai, _i, Po) {
                    return _i = up(_i), ly(Ai, Rl() ? Reflect.construct(_i, Po || [], up(Ai).constructor) : _i.apply(Ai, Po));
                  }
                  function ly(Ai, _i) {
                    if (_i && (typeof _i == "object" || typeof _i == "function")) return _i;
                    if (_i !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return Km(Ai);
                  }
                  function Km(Ai) {
                    if (Ai === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return Ai;
                  }
                  function Rl() {
                    try {
                      var Ai = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                      }));
                    } catch {
                    }
                    return (Rl = function() {
                      return !!Ai;
                    })();
                  }
                  function Og(Ai, _i, Po, Gi) {
                    var na = og(up(Ai.prototype), _i, Po);
                    return 2 & Gi && typeof na == "function" ? function(ta) {
                      return na.apply(Po, ta);
                    } : na;
                  }
                  function og() {
                    return og = typeof Reflect < "u" && Reflect.get ? Reflect.get.bind() : function(Ai, _i, Po) {
                      var Gi = Of(Ai, _i);
                      if (Gi) {
                        var na = Object.getOwnPropertyDescriptor(Gi, _i);
                        return na.get ? na.get.call(arguments.length < 3 ? Ai : Po) : na.value;
                      }
                    }, og.apply(null, arguments);
                  }
                  function Of(Ai, _i) {
                    for (; !{}.hasOwnProperty.call(Ai, _i) && (Ai = up(Ai)) !== null; ) ;
                    return Ai;
                  }
                  function up(Ai) {
                    return up = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(_i) {
                      return _i.__proto__ || Object.getPrototypeOf(_i);
                    }, up(Ai);
                  }
                  function Af(Ai, _i) {
                    if (typeof _i != "function" && _i !== null) throw new TypeError("Super expression must either be null or a function");
                    Ai.prototype = Object.create(_i && _i.prototype, { constructor: { value: Ai, writable: !0, configurable: !0 } }), Object.defineProperty(Ai, "prototype", { writable: !1 }), _i && Xf(Ai, _i);
                  }
                  function Xf(Ai, _i) {
                    return Xf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(Po, Gi) {
                      return Po.__proto__ = Gi, Po;
                    }, Xf(Ai, _i);
                  }
                  function Jf(Ai, _i) {
                    qm(Ai, _i), _i.add(Ai);
                  }
                  function qm(Ai, _i) {
                    if (_i.has(Ai)) throw new TypeError("Cannot initialize the same private elements twice on an object");
                  }
                  function kh(Ai, _i, Po) {
                    return (_i = ag(_i)) in Ai ? Object.defineProperty(Ai, _i, { value: Po, enumerable: !0, configurable: !0, writable: !0 }) : Ai[_i] = Po, Ai;
                  }
                  function ag(Ai) {
                    var _i = uy(Ai, "string");
                    return typeof _i == "symbol" ? _i : _i + "";
                  }
                  function uy(Ai, _i) {
                    if (typeof Ai != "object" || !Ai) return Ai;
                    var Po = Ai[Symbol.toPrimitive];
                    if (Po !== void 0) {
                      var Gi = Po.call(Ai, _i);
                      if (typeof Gi != "object") return Gi;
                      throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (_i === "string" ? String : Number)(Ai);
                  }
                  function If(Ai, _i, Po) {
                    if (typeof Ai == "function" ? Ai === _i : Ai.has(_i)) return arguments.length < 3 ? _i : Po;
                    throw new TypeError("Private element is not present on this object");
                  }
                  var Ym = 5, hf = /* @__PURE__ */ new WeakSet(), Nd = /* @__PURE__ */ (function(Ai) {
                    function _i(Po) {
                      var Gi;
                      return sy(this, _i), Gi = zm(this, _i, [Po]), Jf(Gi, hf), Gi.segmentQueue = [], Gi.sequenceNumber = 0, Gi.mediaSource = null, Gi.sourceBuffer = null, Gi.appendsSinceTimeEndUpdated = 0, Gi.APPENDS_WITH_SAME_TIME_END_THRESHOLD = Ym, Gi;
                    }
                    return Af(_i, Ai), Yf(_i, [{
                      key: "initialize",
                      value: (function() {
                        var Po = oh(/* @__PURE__ */ pf().mark(function na() {
                          var ta = this;
                          return pf().wrap(function(Wa) {
                            for (; ; ) switch (Wa.prev = Wa.next) {
                              case 0:
                                if (!this.isDestroyed) {
                                  Wa.next = 2;
                                  break;
                                }
                                throw new Error("Tried to initialize while destroyed");
                              case 2:
                                return this.metric("mediaSource.created", 1), Wa.next = 5, this.destroyMediaSource();
                              case 5:
                                this.mediaSource = Ua.factory(this.logId), this.mediaSource.on(Ua.events.ERROR, function(Va) {
                                  ta.emit(_i.events.MEDIA_SOURCE_ERROR, Va);
                                }), this.sourceBuffer && this.sourceBuffer.abort();
                              case 8:
                              case "end":
                                return Wa.stop();
                            }
                          }, na, this);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "initializeSourceBuffer",
                      value: (function() {
                        var Po = oh(/* @__PURE__ */ pf().mark(function na(ta) {
                          var Fo = this;
                          return pf().wrap(function(Va) {
                            for (; ; ) switch (Va.prev = Va.next) {
                              case 0:
                                if (!this.isDestroyed) {
                                  Va.next = 2;
                                  break;
                                }
                                throw new Error("Tried to initialize source buffer while destroyed");
                              case 2:
                                return this.logger.info("initializeSourceBuffer..."), Va.prev = 3, Va.next = 6, this.mediaSource.waitUntilReady();
                              case 6:
                                Va.next = 12;
                                break;
                              case 8:
                                throw Va.prev = 8, Va.t0 = Va.catch(3), this.logger.error("Cannot create the sourceBuffer if the mediaSource is not ready."), Va.t0;
                              case 12:
                                if (!this.sourceBuffer) {
                                  Va.next = 15;
                                  break;
                                }
                                return Va.next = 15, this.sourceBuffer.destroy();
                              case 15:
                                this.sourceBuffer = Rf.factory(this.logId, ta, this.mediaSource), this.metric("sourceBuffer.created", 1), this.sourceBuffer.on(Rf.events.ERROR, function(wa) {
                                  Fo.emit(_i.events.SOURCE_BUFFER_ERROR, wa);
                                }), this.sourceBuffer.on(Rf.events.UPDATE_END, function(wa) {
                                  If(hf, Fo, Jm).call(Fo);
                                }), this.sourceBuffer.on(Rf.events.DRIFT_THRESHOLD_EXCEEDED, function(wa) {
                                  var il = wa.estimatedDrift, ol = wa.driftThreshold;
                                  Fo.logger.info("Estimated drift of ".concat(il, " is above the ").concat(ol, " threshold.  Flushing queue...")), If(hf, Fo, cy).call(Fo);
                                }), this.sourceBuffer.on(Rf.events.ABORT_ERROR, function(wa) {
                                  var il = wa.error;
                                  Fo.logger.error("Error while aborting SourceBuffer!"), Fo.logger.error(il);
                                });
                              case 21:
                              case "end":
                                return Va.stop();
                            }
                          }, na, this, [[3, 8]]);
                        }));
                        function Gi(na) {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "appendMoov",
                      value: function(Gi) {
                        if (!this.isDestroyed) {
                          if (this.logger.info("appendMoov"), !Gi)
                            throw new Error("Must provide a moov to append!");
                          this.metric("sourceBuffer.lastMoovSize", Gi.length), this.metric("queue.appendMoov", 1), If(hf, this, Qg).call(this, Gi), If(hf, this, sg).call(this);
                        }
                      }
                      /**
                       *
                       * @param {*} videoSegment
                       *   The moof / bytearray
                       */
                    }, {
                      key: "showVideoSegment",
                      value: function(Gi) {
                        if (!this.isDestroyed) {
                          if (this.logger.silly("showVideoSegment"), !Gi)
                            throw new Error("Must provide a moof to append!");
                          this.metric("sourceBuffer.lastMoofSize", Gi.length), this.metric("queue.append", 1), If(hf, this, Qg).call(this, If(hf, this, Xm).call(this, Gi)), this.sequenceNumber++, If(hf, this, sg).call(this);
                        }
                      }
                    }, {
                      key: "destroyMediaSource",
                      value: (
                        // @todo - this logic needs to be consolidated into MediaSource or
                        // SourceBuffer
                        (function() {
                          var Po = oh(/* @__PURE__ */ pf().mark(function na() {
                            return pf().wrap(function(Fo) {
                              for (; ; ) switch (Fo.prev = Fo.next) {
                                case 0:
                                  if (this.mediaSource) {
                                    Fo.next = 2;
                                    break;
                                  }
                                  return Fo.abrupt("return");
                                case 2:
                                  this.metric("sourceBuffer.destroyed", 1), this.logger.info("Destroying mediaSource...");
                                  try {
                                    this.sourceBuffer && this.sourceBuffer.clear();
                                  } catch (Wa) {
                                    If(hf, this, Ag).call(this, Wa);
                                  }
                                  if (Fo.prev = 5, !this.sourceBuffer) {
                                    Fo.next = 9;
                                    break;
                                  }
                                  return Fo.next = 9, this.sourceBuffer.waitUntilReady();
                                case 9:
                                  Fo.next = 15;
                                  break;
                                case 11:
                                  Fo.prev = 11, Fo.t0 = Fo.catch(5), this.logger.error("Error: sourceBuffer did not become ready, going to try to destry mediasource anyway!"), this.logger.error(Fo.t0);
                                case 15:
                                  return Fo.next = 17, this.mediaSource.destroy();
                                case 17:
                                  this.sourceBuffer && this.sourceBuffer.abort(), this.metric("mediaSource.destroyed", 1);
                                case 19:
                                case "end":
                                  return Fo.stop();
                              }
                            }, na, this, [[5, 11]]);
                          }));
                          function Gi() {
                            return Po.apply(this, arguments);
                          }
                          return Gi;
                        })()
                      )
                      // @todo @metrics
                    }, {
                      key: "metric",
                      value: function(Gi, na) {
                      }
                    }, {
                      key: "_destroy",
                      value: (function() {
                        var Po = oh(/* @__PURE__ */ pf().mark(function na() {
                          return pf().wrap(function(Fo) {
                            for (; ; ) switch (Fo.prev = Fo.next) {
                              case 0:
                                return Fo.prev = 0, Fo.next = 3, this.destroyMediaSource();
                              case 3:
                                Fo.next = 9;
                                break;
                              case 5:
                                Fo.prev = 5, Fo.t0 = Fo.catch(0), this.logger.error("Error while destroying mediaSource while destroying!"), this.logger.error(Fo.t0);
                              case 9:
                                return Fo.prev = 9, Fo.next = 12, this.sourceBuffer.destroy();
                              case 12:
                                Fo.next = 18;
                                break;
                              case 14:
                                Fo.prev = 14, Fo.t1 = Fo.catch(9), this.logger.error("Error while destroying sourceBuffer while destroying!"), this.logger.error(Fo.t1);
                              case 18:
                                return this.mediaSource = null, this.sourceBuffer = null, this.previousTimeEnd = null, this.segmentQueue = null, Fo.next = 24, Og(_i, "_destroy", this, 3)([]);
                              case 24:
                              case "end":
                                return Fo.stop();
                            }
                          }, na, this, [[0, 5], [9, 14]]);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }], [{
                      key: "factory",
                      value: (
                        // @todo @metrics
                        // static METRIC_TYPES = [
                        //   'mediaSource.created',
                        //   'mediaSource.destroyed',
                        //   'objectURL.created',
                        //   'objectURL.revoked',
                        //   'mediaSource.reinitialized',
                        //   'sourceBuffer.created',
                        //   'sourceBuffer.destroyed',
                        //   'queue.added',
                        //   'queue.removed',
                        //   'sourceBuffer.append',
                        //   'error.sourceBuffer.append',
                        //   'frameDrop.hiddenTab',
                        //   'queue.mediaSourceNotReady',
                        //   'queue.sourceBufferNotReady',
                        //   'queue.shift',
                        //   'queue.append',
                        //   'sourceBuffer.lastKnownBufferSize',
                        //   'sourceBuffer.trim',
                        //   'sourceBuffer.trim.error',
                        //   'sourceBuffer.updateEnd',
                        //   'sourceBuffer.updateEnd.bufferLength.empty',
                        //   'sourceBuffer.updateEnd.bufferLength.error',
                        //   'sourceBuffer.updateEnd.removeEvent',
                        //   'sourceBuffer.updateEnd.appendEvent',
                        //   'sourceBuffer.updateEnd.bufferFrozen',
                        //   'sourceBuffer.abort',
                        //   'error.sourceBuffer.abort',
                        //   'sourceBuffer.lastMoofSize',
                        // ];
                        /**
                         * Create a new SourceBuffer, which is a wrapper around `window.SourceBuffer`
                         *
                         * @param {string|object} logId
                         *   a string that identifies this SourceBuffer in log messages
                         *   @see - src/js/utils/Destroyable
                         */
                        function(Gi) {
                          return new _i(Gi);
                        }
                      )
                    }]);
                  })(ja);
                  ih = Nd;
                  function cy() {
                    this.metric("queue.removed", this.segmentQueue.length + 1), this.segmentQueue = [];
                  }
                  function Qg(Ai) {
                    this.segmentQueue.length ? this.logger.debug("Queueing segment.  The queue currently has ".concat(this.segmentQueue.length, " segments.")) : this.logger.silly("Queueing segment.  The queue is currently empty."), this.metric("queue.added", 1), this.segmentQueue.push({
                      timestamp: Date.now(),
                      byteArray: Ai
                    });
                  }
                  function sg() {
                    if (!this.isDestroyed) {
                      if (this.logger.silly("#processNextInQueue"), this.segmentQueue.length === 0) {
                        this.logger.info("No segments in queue to process");
                        return;
                      }
                      if (io().isDocumentHidden()) {
                        this.logger.debug("Tab not in focus - dropping frame..."), this.metric("frameDrop.hiddenTab", 1), this.metric("queue.cannotProcessNext", 1), this.segmentQueue.shift();
                        return;
                      }
                      if (!this.mediaSource.isReady()) {
                        this.metric("queue.mediaSourceNotReady", 1), this.metric("queue.cannotProcessNext", 1), this.logger.warn("Media source not ready"), this.segmentQueue.shift();
                        return;
                      }
                      if (!this.sourceBuffer) {
                        this.logger.info("Tried to play before the SourceBuffer was initialized");
                        return;
                      }
                      if (!this.sourceBuffer.isReady()) {
                        this.logger.warn("The sourceBuffer is not ready"), this.metric("queue.sourceBufferNotReady", 1), this.metric("queue.cannotProcessNext", 1);
                        return;
                      }
                      this.logger.silly("appending to source buffer"), this.metric("queue.shift", 1), this.metric("queue.canProcessNext", 1), this.segmentQueue.length >= 2 && this.logger.debug("segment queue has " + this.segmentQueue.length + " segments"), this.sourceBuffer.append(this.segmentQueue.shift());
                    }
                  }
                  function Xm(Ai) {
                    return Ai[20] = (this.sequenceNumber & 4278190080) >> 24, Ai[21] = (this.sequenceNumber & 16711680) >> 16, Ai[22] = (this.sequenceNumber & 65280) >> 8, Ai[23] = this.sequenceNumber & 255, Ai;
                  }
                  function Ag(Ai) {
                    this.metric("sourceBuffer.trim.error", 1), this.logger.error("sourceBuffer.remove --> Error while trimming sourceBuffer"), this.logger.error(Ai);
                  }
                  function Zg(Ai) {
                    if (!Ai)
                      throw new Error("Info must be passed to process video segment shown event!");
                    if (this.logger.silly("On video segment shown..."), this.metric("sourceBuffer.updateEnd.appendEvent", 1), this.logger.debug("Appends with same time end: " + this.appendsSinceTimeEndUpdated), Ai.bufferTimeEnd <= this.previousTimeEnd) {
                      this.logger.info("previoustimeend: " + this.previousTimeEnd + ", buffertimeend: " + Ai.bufferTimeEnd), this.appendsSinceTimeEndUpdated += 1, this.metric("sourceBuffer.updateEnd.bufferFrozen", 1), this.appendsSinceTimeEndUpdated > this.APPENDS_WITH_SAME_TIME_END_THRESHOLD && (this.logger.warn("Stream frozen. Reinitializing"), this.emit(ih.events.STREAM_FROZEN));
                      return;
                    }
                    this.appendsSinceTimeEndUpdated = 0, this.previousTimeEnd = Ai.bufferTimeEnd, this.emit(ih.events.VIDEO_SEGMENT_SHOWN, {
                      info: Ai
                    });
                    try {
                      this.sourceBuffer.trim();
                    } catch (_i) {
                      If(hf, this, Ag).call(this, _i);
                    }
                  }
                  function Jm() {
                    this.logger.silly("onUpdateEnd"), this.metric("sourceBuffer.updateEnd", 1);
                    var Ai = this.sourceBuffer.getTimes(), _i = Ai[Ai.length - 1];
                    If(hf, this, Zg).call(this, _i);
                    try {
                      If(hf, this, sg).call(this);
                    } catch (Po) {
                      this.logger.info("Error while showing video segment!"), this.emit(ih.events.SHOW_VIDEO_SEGMENT_ERROR, {
                        error: Po
                      });
                    }
                  }
                  kh(Nd, "events", {
                    METRIC: "metric",
                    STREAM_FROZEN: "stream-frozen",
                    VIDEO_SEGMENT_SHOWN: "video-segment-shown",
                    SHOW_VIDEO_SEGMENT_ERROR: "show-video-segment-error",
                    MEDIA_SOURCE_ERROR: "unexpected-media-source-error",
                    SOURCE_BUFFER_ERROR: "unexpected-source-buffer-error"
                  });
                  var ah;
                  function Mc() {
                    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
                    Mc = function() {
                      return _i;
                    };
                    var Ai, _i = {}, Po = Object.prototype, Gi = Po.hasOwnProperty, na = Object.defineProperty || function(Bi, Ci, ki) {
                      Bi[Ci] = ki.value;
                    }, ta = typeof Symbol == "function" ? Symbol : {}, Fo = ta.iterator || "@@iterator", Wa = ta.asyncIterator || "@@asyncIterator", Va = ta.toStringTag || "@@toStringTag";
                    function wa(Bi, Ci, ki) {
                      return Object.defineProperty(Bi, Ci, { value: ki, enumerable: !0, configurable: !0, writable: !0 }), Bi[Ci];
                    }
                    try {
                      wa({}, "");
                    } catch {
                      wa = function(ki, Mo, Xo) {
                        return ki[Mo] = Xo;
                      };
                    }
                    function il(Bi, Ci, ki, Mo) {
                      var Xo = Ci && Ci.prototype instanceof pu ? Ci : pu, Uo = Object.create(Xo.prototype), qa = new ku(Mo || []);
                      return na(Uo, "_invoke", { value: pc(Bi, ki, qa) }), Uo;
                    }
                    function ol(Bi, Ci, ki) {
                      try {
                        return { type: "normal", arg: Bi.call(Ci, ki) };
                      } catch (Mo) {
                        return { type: "throw", arg: Mo };
                      }
                    }
                    _i.wrap = il;
                    var Ql = "suspendedStart", Uu = "suspendedYield", Wu = "executing", Kl = "completed", pl = {};
                    function pu() {
                    }
                    function lu() {
                    }
                    function Nl() {
                    }
                    var Eu = {};
                    wa(Eu, Fo, function() {
                      return this;
                    });
                    var wu = Object.getPrototypeOf, yu = wu && wu(wu(Nu([])));
                    yu && yu !== Po && Gi.call(yu, Fo) && (Eu = yu);
                    var zl = Nl.prototype = pu.prototype = Object.create(Eu);
                    function Qu(Bi) {
                      ["next", "throw", "return"].forEach(function(Ci) {
                        wa(Bi, Ci, function(ki) {
                          return this._invoke(Ci, ki);
                        });
                      });
                    }
                    function gu(Bi, Ci) {
                      function ki(Xo, Uo, qa, Us) {
                        var Hs = ol(Bi[Xo], Bi, Uo);
                        if (Hs.type !== "throw") {
                          var jl = Hs.arg, Al = jl.value;
                          return Al && typeof Al == "object" && Gi.call(Al, "__await") ? Ci.resolve(Al.__await).then(function(Ml) {
                            ki("next", Ml, qa, Us);
                          }, function(Ml) {
                            ki("throw", Ml, qa, Us);
                          }) : Ci.resolve(Al).then(function(Ml) {
                            jl.value = Ml, qa(jl);
                          }, function(Ml) {
                            return ki("throw", Ml, qa, Us);
                          });
                        }
                        Us(Hs.arg);
                      }
                      var Mo;
                      na(this, "_invoke", { value: function(Uo, qa) {
                        function Us() {
                          return new Ci(function(Hs, jl) {
                            ki(Uo, qa, Hs, jl);
                          });
                        }
                        return Mo = Mo ? Mo.then(Us, Us) : Us();
                      } });
                    }
                    function pc(Bi, Ci, ki) {
                      var Mo = Ql;
                      return function(Xo, Uo) {
                        if (Mo === Wu) throw Error("Generator is already running");
                        if (Mo === Kl) {
                          if (Xo === "throw") throw Uo;
                          return { value: Ai, done: !0 };
                        }
                        for (ki.method = Xo, ki.arg = Uo; ; ) {
                          var qa = ki.delegate;
                          if (qa) {
                            var Us = Zu(qa, ki);
                            if (Us) {
                              if (Us === pl) continue;
                              return Us;
                            }
                          }
                          if (ki.method === "next") ki.sent = ki._sent = ki.arg;
                          else if (ki.method === "throw") {
                            if (Mo === Ql) throw Mo = Kl, ki.arg;
                            ki.dispatchException(ki.arg);
                          } else ki.method === "return" && ki.abrupt("return", ki.arg);
                          Mo = Wu;
                          var Hs = ol(Bi, Ci, ki);
                          if (Hs.type === "normal") {
                            if (Mo = ki.done ? Kl : Uu, Hs.arg === pl) continue;
                            return { value: Hs.arg, done: ki.done };
                          }
                          Hs.type === "throw" && (Mo = Kl, ki.method = "throw", ki.arg = Hs.arg);
                        }
                      };
                    }
                    function Zu(Bi, Ci) {
                      var ki = Ci.method, Mo = Bi.iterator[ki];
                      if (Mo === Ai) return Ci.delegate = null, ki === "throw" && Bi.iterator.return && (Ci.method = "return", Ci.arg = Ai, Zu(Bi, Ci), Ci.method === "throw") || ki !== "return" && (Ci.method = "throw", Ci.arg = new TypeError("The iterator does not provide a '" + ki + "' method")), pl;
                      var Xo = ol(Mo, Bi.iterator, Ci.arg);
                      if (Xo.type === "throw") return Ci.method = "throw", Ci.arg = Xo.arg, Ci.delegate = null, pl;
                      var Uo = Xo.arg;
                      return Uo ? Uo.done ? (Ci[Bi.resultName] = Uo.value, Ci.next = Bi.nextLoc, Ci.method !== "return" && (Ci.method = "next", Ci.arg = Ai), Ci.delegate = null, pl) : Uo : (Ci.method = "throw", Ci.arg = new TypeError("iterator result is not an object"), Ci.delegate = null, pl);
                    }
                    function gc(Bi) {
                      var Ci = { tryLoc: Bi[0] };
                      1 in Bi && (Ci.catchLoc = Bi[1]), 2 in Bi && (Ci.finallyLoc = Bi[2], Ci.afterLoc = Bi[3]), this.tryEntries.push(Ci);
                    }
                    function Du(Bi) {
                      var Ci = Bi.completion || {};
                      Ci.type = "normal", delete Ci.arg, Bi.completion = Ci;
                    }
                    function ku(Bi) {
                      this.tryEntries = [{ tryLoc: "root" }], Bi.forEach(gc, this), this.reset(!0);
                    }
                    function Nu(Bi) {
                      if (Bi || Bi === "") {
                        var Ci = Bi[Fo];
                        if (Ci) return Ci.call(Bi);
                        if (typeof Bi.next == "function") return Bi;
                        if (!isNaN(Bi.length)) {
                          var ki = -1, Mo = function Xo() {
                            for (; ++ki < Bi.length; ) if (Gi.call(Bi, ki)) return Xo.value = Bi[ki], Xo.done = !1, Xo;
                            return Xo.value = Ai, Xo.done = !0, Xo;
                          };
                          return Mo.next = Mo;
                        }
                      }
                      throw new TypeError(typeof Bi + " is not iterable");
                    }
                    return lu.prototype = Nl, na(zl, "constructor", { value: Nl, configurable: !0 }), na(Nl, "constructor", { value: lu, configurable: !0 }), lu.displayName = wa(Nl, Va, "GeneratorFunction"), _i.isGeneratorFunction = function(Bi) {
                      var Ci = typeof Bi == "function" && Bi.constructor;
                      return !!Ci && (Ci === lu || (Ci.displayName || Ci.name) === "GeneratorFunction");
                    }, _i.mark = function(Bi) {
                      return Object.setPrototypeOf ? Object.setPrototypeOf(Bi, Nl) : (Bi.__proto__ = Nl, wa(Bi, Va, "GeneratorFunction")), Bi.prototype = Object.create(zl), Bi;
                    }, _i.awrap = function(Bi) {
                      return { __await: Bi };
                    }, Qu(gu.prototype), wa(gu.prototype, Wa, function() {
                      return this;
                    }), _i.AsyncIterator = gu, _i.async = function(Bi, Ci, ki, Mo, Xo) {
                      Xo === void 0 && (Xo = Promise);
                      var Uo = new gu(il(Bi, Ci, ki, Mo), Xo);
                      return _i.isGeneratorFunction(Ci) ? Uo : Uo.next().then(function(qa) {
                        return qa.done ? qa.value : Uo.next();
                      });
                    }, Qu(zl), wa(zl, Va, "Generator"), wa(zl, Fo, function() {
                      return this;
                    }), wa(zl, "toString", function() {
                      return "[object Generator]";
                    }), _i.keys = function(Bi) {
                      var Ci = Object(Bi), ki = [];
                      for (var Mo in Ci) ki.push(Mo);
                      return ki.reverse(), function Xo() {
                        for (; ki.length; ) {
                          var Uo = ki.pop();
                          if (Uo in Ci) return Xo.value = Uo, Xo.done = !1, Xo;
                        }
                        return Xo.done = !0, Xo;
                      };
                    }, _i.values = Nu, ku.prototype = { constructor: ku, reset: function(Ci) {
                      if (this.prev = 0, this.next = 0, this.sent = this._sent = Ai, this.done = !1, this.delegate = null, this.method = "next", this.arg = Ai, this.tryEntries.forEach(Du), !Ci) for (var ki in this) ki.charAt(0) === "t" && Gi.call(this, ki) && !isNaN(+ki.slice(1)) && (this[ki] = Ai);
                    }, stop: function() {
                      this.done = !0;
                      var Ci = this.tryEntries[0].completion;
                      if (Ci.type === "throw") throw Ci.arg;
                      return this.rval;
                    }, dispatchException: function(Ci) {
                      if (this.done) throw Ci;
                      var ki = this;
                      function Mo(jl, Al) {
                        return qa.type = "throw", qa.arg = Ci, ki.next = jl, Al && (ki.method = "next", ki.arg = Ai), !!Al;
                      }
                      for (var Xo = this.tryEntries.length - 1; Xo >= 0; --Xo) {
                        var Uo = this.tryEntries[Xo], qa = Uo.completion;
                        if (Uo.tryLoc === "root") return Mo("end");
                        if (Uo.tryLoc <= this.prev) {
                          var Us = Gi.call(Uo, "catchLoc"), Hs = Gi.call(Uo, "finallyLoc");
                          if (Us && Hs) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          } else if (Us) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                          } else {
                            if (!Hs) throw Error("try statement without catch or finally");
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          }
                        }
                      }
                    }, abrupt: function(Ci, ki) {
                      for (var Mo = this.tryEntries.length - 1; Mo >= 0; --Mo) {
                        var Xo = this.tryEntries[Mo];
                        if (Xo.tryLoc <= this.prev && Gi.call(Xo, "finallyLoc") && this.prev < Xo.finallyLoc) {
                          var Uo = Xo;
                          break;
                        }
                      }
                      Uo && (Ci === "break" || Ci === "continue") && Uo.tryLoc <= ki && ki <= Uo.finallyLoc && (Uo = null);
                      var qa = Uo ? Uo.completion : {};
                      return qa.type = Ci, qa.arg = ki, Uo ? (this.method = "next", this.next = Uo.finallyLoc, pl) : this.complete(qa);
                    }, complete: function(Ci, ki) {
                      if (Ci.type === "throw") throw Ci.arg;
                      return Ci.type === "break" || Ci.type === "continue" ? this.next = Ci.arg : Ci.type === "return" ? (this.rval = this.arg = Ci.arg, this.method = "return", this.next = "end") : Ci.type === "normal" && ki && (this.next = ki), pl;
                    }, finish: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.finallyLoc === Ci) return this.complete(Mo.completion, Mo.afterLoc), Du(Mo), pl;
                      }
                    }, catch: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.tryLoc === Ci) {
                          var Xo = Mo.completion;
                          if (Xo.type === "throw") {
                            var Uo = Xo.arg;
                            Du(Mo);
                          }
                          return Uo;
                        }
                      }
                      throw Error("illegal catch attempt");
                    }, delegateYield: function(Ci, ki, Mo) {
                      return this.delegate = { iterator: Nu(Ci), resultName: ki, nextLoc: Mo }, this.method === "next" && (this.arg = Ai), pl;
                    } }, _i;
                  }
                  function Qm(Ai, _i, Po, Gi, na, ta, Fo) {
                    try {
                      var Wa = Ai[ta](Fo), Va = Wa.value;
                    } catch (wa) {
                      return void Po(wa);
                    }
                    Wa.done ? _i(Va) : Promise.resolve(Va).then(Gi, na);
                  }
                  function gf(Ai) {
                    return function() {
                      var _i = this, Po = arguments;
                      return new Promise(function(Gi, na) {
                        var ta = Ai.apply(_i, Po);
                        function Fo(Va) {
                          Qm(ta, Gi, na, Fo, Wa, "next", Va);
                        }
                        function Wa(Va) {
                          Qm(ta, Gi, na, Fo, Wa, "throw", Va);
                        }
                        Fo(void 0);
                      });
                    };
                  }
                  function Zm(Ai, _i) {
                    if (!(Ai instanceof _i)) throw new TypeError("Cannot call a class as a function");
                  }
                  function em(Ai, _i) {
                    for (var Po = 0; Po < _i.length; Po++) {
                      var Gi = _i[Po];
                      Gi.enumerable = Gi.enumerable || !1, Gi.configurable = !0, "value" in Gi && (Gi.writable = !0), Object.defineProperty(Ai, Mh(Gi.key), Gi);
                    }
                  }
                  function lg(Ai, _i, Po) {
                    return _i && em(Ai.prototype, _i), Po && em(Ai, Po), Object.defineProperty(Ai, "prototype", { writable: !1 }), Ai;
                  }
                  function ev(Ai, _i, Po) {
                    return _i = Lh(_i), dy(Ai, tm() ? Reflect.construct(_i, Po || [], Lh(Ai).constructor) : _i.apply(Ai, Po));
                  }
                  function dy(Ai, _i) {
                    if (_i && (typeof _i == "object" || typeof _i == "function")) return _i;
                    if (_i !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return fy(Ai);
                  }
                  function fy(Ai) {
                    if (Ai === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return Ai;
                  }
                  function tm() {
                    try {
                      var Ai = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                      }));
                    } catch {
                    }
                    return (tm = function() {
                      return !!Ai;
                    })();
                  }
                  function rm(Ai, _i, Po, Gi) {
                    var na = Nh(Lh(Ai.prototype), _i, Po);
                    return 2 & Gi && typeof na == "function" ? function(ta) {
                      return na.apply(Po, ta);
                    } : na;
                  }
                  function Nh() {
                    return Nh = typeof Reflect < "u" && Reflect.get ? Reflect.get.bind() : function(Ai, _i, Po) {
                      var Gi = py(Ai, _i);
                      if (Gi) {
                        var na = Object.getOwnPropertyDescriptor(Gi, _i);
                        return na.get ? na.get.call(arguments.length < 3 ? Ai : Po) : na.value;
                      }
                    }, Nh.apply(null, arguments);
                  }
                  function py(Ai, _i) {
                    for (; !{}.hasOwnProperty.call(Ai, _i) && (Ai = Lh(Ai)) !== null; ) ;
                    return Ai;
                  }
                  function Lh(Ai) {
                    return Lh = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(_i) {
                      return _i.__proto__ || Object.getPrototypeOf(_i);
                    }, Lh(Ai);
                  }
                  function tv(Ai, _i) {
                    if (typeof _i != "function" && _i !== null) throw new TypeError("Super expression must either be null or a function");
                    Ai.prototype = Object.create(_i && _i.prototype, { constructor: { value: Ai, writable: !0, configurable: !0 } }), Object.defineProperty(Ai, "prototype", { writable: !1 }), _i && nm(Ai, _i);
                  }
                  function nm(Ai, _i) {
                    return nm = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(Po, Gi) {
                      return Po.__proto__ = Gi, Po;
                    }, nm(Ai, _i);
                  }
                  function im(Ai, _i) {
                    om(Ai, _i), _i.add(Ai);
                  }
                  function om(Ai, _i) {
                    if (_i.has(Ai)) throw new TypeError("Cannot initialize the same private elements twice on an object");
                  }
                  function ed(Ai, _i, Po) {
                    return (_i = Mh(_i)) in Ai ? Object.defineProperty(Ai, _i, { value: Po, enumerable: !0, configurable: !0, writable: !0 }) : Ai[_i] = Po, Ai;
                  }
                  function Mh(Ai) {
                    var _i = Jd(Ai, "string");
                    return typeof _i == "symbol" ? _i : _i + "";
                  }
                  function Jd(Ai, _i) {
                    if (typeof Ai != "object" || !Ai) return Ai;
                    var Po = Ai[Symbol.toPrimitive];
                    if (Po !== void 0) {
                      var Gi = Po.call(Ai, _i);
                      if (typeof Gi != "object") return Gi;
                      throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (_i === "string" ? String : Number)(Ai);
                  }
                  function Gc(Ai, _i, Po) {
                    if (typeof Ai == "function" ? Ai === _i : Ai.has(_i)) return arguments.length < 3 ? _i : Po;
                    throw new TypeError("Private element is not present on this object");
                  }
                  var am = !1, hy = 5, gy = 2, Oc = /* @__PURE__ */ new WeakSet(), Bc = /* @__PURE__ */ (function(Ai) {
                    function _i(Po, Gi, na, ta) {
                      var Fo;
                      if (Zm(this, _i), Fo = ev(this, _i, [Po]), im(Fo, Oc), ed(Fo, "isInitialized", !1), ed(Fo, "isInitializing", !1), ed(Fo, "isRestarting", !1), ed(Fo, "isTryingToPlay", !1), ed(Fo, "isStopping", !1), ed(Fo, "isStopped", !1), ed(Fo, "clspClientCount", 0), ed(Fo, "clspClient", null), ed(Fo, "streamConfiguration", null), ed(Fo, "firstFrameShown", !1), ed(Fo, "mseWrapper", null), ed(Fo, "moov", null), ed(Fo, "latestSegmentReceivedAt", null), ed(Fo, "segmentIntervalAverage", null), ed(Fo, "intervalBetweenSegments", null), ed(Fo, "segmentIntervals", []), ed(Fo, "ENABLE_METRICS", am), ed(Fo, "SEGMENT_INTERVAL_SAMPLE_SIZE", hy), ed(Fo, "DRIFT_CORRECTION_CONSTANT", gy), Di()(Gi))
                        throw new Error("Tried to construct without an id");
                      if (!na)
                        throw new Error("Tried to construct without a container element");
                      if (!ta)
                        throw new Error("Tried to construct without a video element");
                      return Fo.id = Gi, Fo.containerElement = na, Fo.videoElement = ta, Fo;
                    }
                    return tv(_i, Ai), lg(_i, [{
                      key: "setStreamConfiguration",
                      value: function(Gi) {
                        if (this.isDestroyed) {
                          this.logger.error("Tried to setStreamConfiguration while destroyed");
                          return;
                        }
                        if (!bu.isStreamConfiguration(Gi))
                          throw new Error("Tried to set invalid streamConfiguration!");
                        this.streamConfiguration = Gi;
                      }
                    }, {
                      key: "initialize",
                      value: (function() {
                        var Po = gf(/* @__PURE__ */ Mc().mark(function na() {
                          var ta = this, Fo, Wa = arguments;
                          return Mc().wrap(function(wa) {
                            for (; ; ) switch (wa.prev = wa.next) {
                              case 0:
                                if (Fo = Wa.length > 0 && Wa[0] !== void 0 ? Wa[0] : !1, !this.isDestroyed) {
                                  wa.next = 4;
                                  break;
                                }
                                return this.logger.error("Tried to initialize while destroyed"), wa.abrupt("return");
                              case 4:
                                if (!this.isInitializing) {
                                  wa.next = 7;
                                  break;
                                }
                                return this.logger.info("Initialization already in progress"), wa.abrupt("return");
                              case 7:
                                if (!(this.isInitialized && !Fo)) {
                                  wa.next = 10;
                                  break;
                                }
                                return this.logger.info("Already initialized"), wa.abrupt("return");
                              case 10:
                                if (this.isInitialized = !1, this.isInitializing = !0, this.logger.info("Initializing with ".concat(this.streamConfiguration.streamName)), wa.prev = 13, this.clientId = _i.generateClientId(), !this.clspClient) {
                                  wa.next = 18;
                                  break;
                                }
                                return wa.next = 18, this.clspClient.destroy();
                              case 18:
                                return this.clspClient = null, this.clspClient = rf.factory(Gc(Oc, this, my).call(this), this.clientId, this.streamConfiguration, this.containerElement), this.clspClient.conduit.on(rf.events.RECONNECT_SUCCESS, /* @__PURE__ */ gf(/* @__PURE__ */ Mc().mark(function il() {
                                  return Mc().wrap(function(Ql) {
                                    for (; ; ) switch (Ql.prev = Ql.next) {
                                      case 0:
                                        return ta.logger.info("ClspClient reconnected, restarting..."), Ql.prev = 1, Ql.next = 4, ta.restart();
                                      case 4:
                                        Ql.next = 11;
                                        break;
                                      case 6:
                                        Ql.prev = 6, Ql.t0 = Ql.catch(1), ta.logger.error("Error while restarting after reconnection!"), ta.logger.error(Ql.t0), ta.emit(_i.events.RECONNECT_FAILURE, {
                                          error: Ql.t0
                                        });
                                      case 11:
                                      case "end":
                                        return Ql.stop();
                                    }
                                  }, il, null, [[1, 6]]);
                                }))), this.clspClient.conduit.on(rf.events.RECONNECT_FAILURE, function(il) {
                                  var ol = il.error;
                                  ta.emit(_i.events.RECONNECT_FAILURE, {
                                    error: ol
                                  });
                                }), this.clspClient.conduit.on(rf.events.ROUTER_EVENT_ERROR, function(il) {
                                  var ol = il.error;
                                  ta.emit(_i.events.ROUTER_EVENT_ERROR, {
                                    error: ol
                                  });
                                }), this.clspClient.conduit.on(rf.events.RESYNC_STREAM_COMPLETE, function(il) {
                                  ta.logger.warn("Resyncing stream ".concat(il.streamName, "...")), ta.emit(_i.events.RECONNECT_FAILURE, {
                                    error: new Error("Resync detected")
                                  });
                                }), this.clspClient.conduit.on(rf.events.VIDEO_SEGMENT_RECEIVED, function(il) {
                                  Gc(Oc, ta, vy).call(ta, il.clspMessage.payloadBytes);
                                }), this.clspClient.conduit.on(rf.events.IFRAME_DESTROYED_EXTERNALLY, function() {
                                  if (ta.isDestroyed) {
                                    ta.logger.info("Iframe was destroyed externally while in process of destroying");
                                    return;
                                  }
                                  ta.emit(_i.events.IFRAME_DESTROYED_EXTERNALLY);
                                }), this.clspClient.conduit.on(rf.events.JWT_AUTHORIZATION_FAILURE, function(il) {
                                  ta.emit(_i.events.JWT_AUTHORIZATION_FAILURE, {
                                    error: il.error,
                                    playerId: ta.id
                                  });
                                }), wa.next = 29, this.clspClient.initialize();
                              case 29:
                                this.isInitialized = !0;
                              case 30:
                                return wa.prev = 30, this.isInitializing = !1, wa.finish(30);
                              case 33:
                              case "end":
                                return wa.stop();
                            }
                          }, na, this, [[13, , 30, 33]]);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "restart",
                      value: (function() {
                        var Po = gf(/* @__PURE__ */ Mc().mark(function na() {
                          var ta;
                          return Mc().wrap(function(Wa) {
                            for (; ; ) switch (Wa.prev = Wa.next) {
                              case 0:
                                if (!this.isDestroyed) {
                                  Wa.next = 3;
                                  break;
                                }
                                return this.logger.error("Tried to restart while destroyed"), Wa.abrupt("return");
                              case 3:
                                if (!this.isRestarting) {
                                  Wa.next = 6;
                                  break;
                                }
                                return this.logger.info("Restart already in progress"), Wa.abrupt("return");
                              case 6:
                                if (!this.isInitializing) {
                                  Wa.next = 9;
                                  break;
                                }
                                return this.logger.info("Cannot restart, initialization already in progress"), Wa.abrupt("return");
                              case 9:
                                return this.logger.info("restart"), this.isRestarting = !0, Wa.prev = 11, ta = !this.videoElement.src, Wa.next = 15, this.stop();
                              case 15:
                                return Wa.next = 17, this.initialize(ta);
                              case 17:
                                return Wa.next = 19, this.play();
                              case 19:
                                if (!ta) {
                                  Wa.next = 29;
                                  break;
                                }
                                return Wa.prev = 20, Wa.next = 23, Gc(Oc, this, ug).call(this);
                              case 23:
                                Wa.next = 29;
                                break;
                              case 25:
                                throw Wa.prev = 25, Wa.t0 = Wa.catch(20), this.logger.error("Error while trying to play CLSP video from video element..."), Wa.t0;
                              case 29:
                                return Wa.prev = 29, this.isRestarting = !1, Wa.finish(29);
                              case 32:
                              case "end":
                                return Wa.stop();
                            }
                          }, na, this, [[11, , 29, 32], [20, 25]]);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                      /**
                       * Note that if an error is thrown during play, the IovPlayer instance should
                       * be destroyed to free resources.
                       */
                    }, {
                      key: "play",
                      value: (function() {
                        var Po = gf(/* @__PURE__ */ Mc().mark(function na() {
                          var ta, Fo, Wa;
                          return Mc().wrap(function(wa) {
                            for (; ; ) switch (wa.prev = wa.next) {
                              case 0:
                                if (!this.isDestroyed) {
                                  wa.next = 3;
                                  break;
                                }
                                return this.logger.info("Tried to play while destroyed"), wa.abrupt("return");
                              case 3:
                                if (!(!this.isInitialized || this.isInitializing)) {
                                  wa.next = 5;
                                  break;
                                }
                                throw new Error("Tried to play before initializing!");
                              case 5:
                                if (this.isStopping, !this.isTryingToPlay) {
                                  wa.next = 9;
                                  break;
                                }
                                return this.logger.info("Already trying to play"), wa.abrupt("return");
                              case 9:
                                return this.logger.info("play"), this.isTryingToPlay = !0, wa.prev = 11, wa.next = 14, this.clspClient.conduit.play();
                              case 14:
                                if (ta = wa.sent, Fo = ta.mimeCodec, Wa = ta.moov, Ua.isMimeCodecSupported(Fo)) {
                                  wa.next = 20;
                                  break;
                                }
                                throw this.emit(_i.events.UNSUPPORTED_MIME_CODEC, {
                                  mimeCodec: Fo
                                }), new Error("Unsupported mime codec: ".concat(Fo));
                              case 20:
                                return this.moov = Wa, this.mimeCodec = Fo, wa.next = 24, Gc(Oc, this, kp).call(this, !1);
                              case 24:
                                this.isPlaying = !0, this.isStopped = !1;
                              case 26:
                                return wa.prev = 26, this.isTryingToPlay = !1, wa.finish(26);
                              case 29:
                              case "end":
                                return wa.stop();
                            }
                          }, na, this, [[11, , 26, 29]]);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "stop",
                      value: (function() {
                        var Po = gf(/* @__PURE__ */ Mc().mark(function na() {
                          return Mc().wrap(function(Fo) {
                            for (; ; ) switch (Fo.prev = Fo.next) {
                              case 0:
                                if (!this.isDestroyComplete) {
                                  Fo.next = 2;
                                  break;
                                }
                                throw new Error("Tried to stop after destroyed!");
                              case 2:
                                if (this.isInitialized) {
                                  Fo.next = 4;
                                  break;
                                }
                                throw new Error("Tried to stop before initializing!");
                              case 4:
                                if (!this.isStopped) {
                                  Fo.next = 7;
                                  break;
                                }
                                return this.logger.info("Already stopped"), Fo.abrupt("return");
                              case 7:
                                if (!this.isStopping) {
                                  Fo.next = 10;
                                  break;
                                }
                                return this.logger.info("Already stopping"), Fo.abrupt("return");
                              case 10:
                                return this.logger.info("stop..."), this.isStopping = !0, this.moov = null, Fo.prev = 13, Fo.prev = 14, Fo.next = 17, this.clspClient.conduit.stop();
                              case 17:
                                Fo.next = 23;
                                break;
                              case 19:
                                Fo.prev = 19, Fo.t0 = Fo.catch(14), this.logger.error("failed to stop the clspClient"), this.logger.error(Fo.t0);
                              case 23:
                                return Fo.prev = 23, Fo.next = 26, Gc(Oc, this, rv).call(this);
                              case 26:
                                Fo.next = 32;
                                break;
                              case 28:
                                Fo.prev = 28, Fo.t1 = Fo.catch(23), this.logger.error("Failed to destroy mseWrapper while stopping, continuing anyway..."), this.logger.error(Fo.t1);
                              case 32:
                                this.logger.info("stop succeeded"), Fo.next = 39;
                                break;
                              case 35:
                                throw Fo.prev = 35, Fo.t2 = Fo.catch(13), this.logger.error("stop failed..."), Fo.t2;
                              case 39:
                                return Fo.prev = 39, this.isStopping = !1, this.isStopped = !0, Fo.finish(39);
                              case 43:
                              case "end":
                                return Fo.stop();
                            }
                          }, na, this, [[13, 35, 39, 43], [14, 19], [23, 28]]);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "_destroy",
                      value: (
                        /**
                         * @async
                         */
                        (function() {
                          var Po = gf(/* @__PURE__ */ Mc().mark(function na() {
                            return Mc().wrap(function(Fo) {
                              for (; ; ) switch (Fo.prev = Fo.next) {
                                case 0:
                                  return Fo.prev = 0, Fo.next = 3, this.stop();
                                case 3:
                                  Fo.next = 9;
                                  break;
                                case 5:
                                  Fo.prev = 5, Fo.t0 = Fo.catch(0), this.logger.error("Error encountered while trying to stop during Iov Player destroy, continuing with destroy..."), this.logger.error(Fo.t0);
                                case 9:
                                  return Fo.next = 11, this.clspClient.destroy();
                                case 11:
                                  return this.clspClient = null, this.streamConfiguration = null, this.firstFrameShown = null, this.moov = null, this.latestSegmentReceivedAt = null, this.segmentIntervalAverage = null, this.intervalBetweenSegments = null, this.segmentIntervals = null, Fo.next = 21, rm(_i, "_destroy", this, 3)([]);
                                case 21:
                                case "end":
                                  return Fo.stop();
                              }
                            }, na, this, [[0, 5]]);
                          }));
                          function Gi() {
                            return Po.apply(this, arguments);
                          }
                          return Gi;
                        })()
                      )
                    }], [{
                      key: "factory",
                      value: (
                        // @todo @metrics
                        // static METRIC_TYPES = [
                        //   'sourceBuffer.bufferTimeEnd',
                        //   'video.currentTime',
                        //   'video.drift',
                        //   'video.driftCorrection',
                        //   'video.intervalBetweenSegments',
                        //   'video.segmentIntervalAverage',
                        // ];
                        /**
                         * Construct a new IovPlayer
                         *
                         * @param {string} logId
                         *   a string that identifies this IovPlayer in log messages
                         * @param {HTMLElement} containerElement
                         *   The container element that will contain the iframe
                         * @param {HTMLElement} videoElement
                         *   The video element that will be used to play the CLSP stream
                         */
                        function(Gi, na, ta, Fo) {
                          return new _i(Gi, na, ta, Fo);
                        }
                      )
                    }, {
                      key: "generateClientId",
                      value: function() {
                        return [io().name, io().version.replace("+", "-build-"), Is()].join("--");
                      }
                    }]);
                  })(ja);
                  ah = Bc;
                  function rv() {
                    return sm.apply(this, arguments);
                  }
                  function sm() {
                    return sm = gf(/* @__PURE__ */ Mc().mark(function Ai() {
                      return Mc().wrap(function(Po) {
                        for (; ; ) switch (Po.prev = Po.next) {
                          case 0:
                            if (!this.mseWrapper) {
                              Po.next = 7;
                              break;
                            }
                            return Po.prev = 1, Po.next = 4, this.mseWrapper.destroy();
                          case 4:
                            return Po.prev = 4, this.mseWrapper = null, Po.finish(4);
                          case 7:
                          case "end":
                            return Po.stop();
                        }
                      }, Ai, this, [[1, , 4, 7]]);
                    })), sm.apply(this, arguments);
                  }
                  function kp() {
                    return Ig.apply(this, arguments);
                  }
                  function Ig() {
                    return Ig = gf(/* @__PURE__ */ Mc().mark(function Ai() {
                      var _i = this, Po, Gi = arguments;
                      return Mc().wrap(function(ta) {
                        for (; ; ) switch (ta.prev = ta.next) {
                          case 0:
                            if (Po = Gi.length > 0 && Gi[0] !== void 0 ? Gi[0] : !0, !this.isDestroyed) {
                              ta.next = 4;
                              break;
                            }
                            return this.logger.warn("Tried to reinitializeMseWrapper while destroyed..."), ta.abrupt("return");
                          case 4:
                            return this.logger.info("reinitializeMseWrapper"), ta.prev = 5, ta.next = 8, Gc(Oc, this, rv).call(this);
                          case 8:
                            ta.next = 14;
                            break;
                          case 10:
                            ta.prev = 10, ta.t0 = ta.catch(5), this.logger.error("Failed to destroy mseWrapper while reinitializing mseWrapper, continuing anyway..."), this.logger.error(ta.t0);
                          case 14:
                            return this.mseWrapper = null, this.mseWrapper = Nd.factory(this.logId, this.videoElement), this.mseWrapper.on(Nd.events.METRIC, function(Fo) {
                              var Wa = Fo.type, Va = Fo.value;
                              Gc(Oc, _i, Np).call(_i, Wa, Va);
                            }), this.mseWrapper.on(Nd.events.SHOW_VIDEO_SEGMENT_ERROR, function(Fo) {
                              var Wa = Fo.error;
                              _i.logger.error("Error while showing video segment!"), _i.logger.error(Wa), Gc(Oc, _i, kp).call(_i);
                            }), this.mseWrapper.on(Nd.events.MEDIA_SOURCE_ERROR, function(Fo) {
                              _i.logger.warn("mediaSource.generic --> mediaSource error"), _i.logger.error(Fo), Gc(Oc, _i, kp).call(_i);
                            }), this.mseWrapper.on(Nd.events.SOURCE_BUFFER_ERROR, function(Fo) {
                              _i.logger.debug("sourceBuffer.generic --> sourceBuffer error"), Gc(Oc, _i, kp).call(_i);
                            }), this.mseWrapper.on(Nd.events.STREAM_FROZEN, function() {
                              _i.logger.info("stream appears to be frozen - reinitializing..."), Gc(Oc, _i, kp).call(_i);
                            }), this.mseWrapper.on(Nd.events.VIDEO_SEGMENT_SHOWN, /* @__PURE__ */ (function() {
                              var Fo = gf(/* @__PURE__ */ Mc().mark(function Wa(Va) {
                                var wa;
                                return Mc().wrap(function(ol) {
                                  for (; ; ) switch (ol.prev = ol.next) {
                                    case 0:
                                      if (wa = Va.info, !_i.isDestroyed) {
                                        ol.next = 4;
                                        break;
                                      }
                                      return _i.logger.warn("Got video segement while destroyed..."), ol.abrupt("return");
                                    case 4:
                                      if (_i.logger.silly("On Append Finish..."), _i.firstFrameShown || (_i.firstFrameShown = !0, _i.videoElement.id = _i.clientId, _i.videoElement.dataset.name = _i.streamConfiguration.streamName, _i.emit(ah.events.FIRST_FRAME_SHOWN)), _i.drift = wa.bufferTimeEnd - _i.videoElement.currentTime, Gc(Oc, _i, Np).call(_i, "sourceBuffer.bufferTimeEnd", wa.bufferTimeEnd), Gc(Oc, _i, Np).call(_i, "video.currentTime", _i.videoElement.currentTime), Gc(Oc, _i, Np).call(_i, "video.drift", _i.drift), _i.drift > _i.segmentIntervalAverage / 1e3 + _i.DRIFT_CORRECTION_CONSTANT && (Gc(Oc, _i, Np).call(_i, "video.driftCorrection", 1), _i.videoElement.currentTime = wa.bufferTimeEnd), _i.videoElement.paused !== !0) {
                                        ol.next = 23;
                                        break;
                                      }
                                      return _i.logger.info("Video is paused!"), ol.prev = 13, ol.next = 16, Gc(Oc, _i, ug).call(_i);
                                    case 16:
                                      ol.next = 23;
                                      break;
                                    case 18:
                                      ol.prev = 18, ol.t0 = ol.catch(13), _i.logger.error("Error while trying to play CLSP video from video element..."), _i.logger.error(ol.t0), Gc(Oc, _i, kp).call(_i);
                                    case 23:
                                    case "end":
                                      return ol.stop();
                                  }
                                }, Wa, null, [[13, 18]]);
                              }));
                              return function(Wa) {
                                return Fo.apply(this, arguments);
                              };
                            })()), ta.prev = 22, ta.next = 25, this.mseWrapper.initialize();
                          case 25:
                            this.videoElement.src = "", this.videoElement.src = this.mseWrapper.mediaSource.asObjectURL(), this.mseWrapper.mediaSource.on(Ua.events.SOURCE_OPEN_ERROR, function(Fo) {
                              var Wa = Fo.error;
                              _i.logger.error('Failed to initialize mediaSource - Error on "sourceopen" event:'), _i.logger.error(Wa), Gc(Oc, _i, kp).call(_i);
                            }), this.mseWrapper.mediaSource.on(Ua.events.SOURCE_OPEN, /* @__PURE__ */ (function() {
                              var Fo = gf(/* @__PURE__ */ Mc().mark(function Wa(Va) {
                                return Mc().wrap(function(il) {
                                  for (; ; ) switch (il.prev = il.next) {
                                    case 0:
                                      return _i.logger.info("on mediaSource sourceopen"), il.prev = 1, il.prev = 2, il.next = 5, _i.mseWrapper.initializeSourceBuffer(_i.mimeCodec);
                                    case 5:
                                      il.next = 11;
                                      break;
                                    case 7:
                                      throw il.prev = 7, il.t0 = il.catch(2), _i.logger.warn("Error while initializing SourceBuffer!"), il.t0;
                                    case 11:
                                      _i.emit(ah.events.VIDEO_INFO_RECEIVED), il.prev = 12, _i.mseWrapper.appendMoov(_i.moov), il.next = 20;
                                      break;
                                    case 16:
                                      throw il.prev = 16, il.t1 = il.catch(12), _i.logger.warn("Error while appending moov!"), il.t1;
                                    case 20:
                                      il.next = 26;
                                      break;
                                    case 22:
                                      il.prev = 22, il.t2 = il.catch(1), _i.logger.warn(il.t2), _i.emit(ah.events.REINITIALZE_ERROR, {
                                        error: il.t2
                                      });
                                    case 26:
                                    case "end":
                                      return il.stop();
                                  }
                                }, Wa, null, [[1, 22], [2, 7], [12, 16]]);
                              }));
                              return function(Wa) {
                                return Fo.apply(this, arguments);
                              };
                            })()), this.mseWrapper.mediaSource.on(Ua.events.SOURCE_ENDED, /* @__PURE__ */ (function() {
                              var Fo = gf(/* @__PURE__ */ Mc().mark(function Wa(Va) {
                                return Mc().wrap(function(il) {
                                  for (; ; ) switch (il.prev = il.next) {
                                    case 0:
                                      return _i.logger.info("on mediaSource sourceended"), il.prev = 1, il.next = 4, _i.stop();
                                    case 4:
                                      il.next = 10;
                                      break;
                                    case 6:
                                      il.prev = 6, il.t0 = il.catch(1), _i.logger.error("Error while stopping in SOURCE_ENDED event!"), _i.logger.error(il.t0);
                                    case 10:
                                    case "end":
                                      return il.stop();
                                  }
                                }, Wa, null, [[1, 6]]);
                              }));
                              return function(Wa) {
                                return Fo.apply(this, arguments);
                              };
                            })()), ta.next = 39;
                            break;
                          case 32:
                            if (ta.prev = 32, ta.t1 = ta.catch(22), !Po) {
                              ta.next = 38;
                              break;
                            }
                            this.emit(ah.events.REINITIALZE_ERROR, {
                              error: ta.t1
                            }), ta.next = 39;
                            break;
                          case 38:
                            throw ta.t1;
                          case 39:
                          case "end":
                            return ta.stop();
                        }
                      }, Ai, this, [[5, 10], [22, 32]]);
                    })), Ig.apply(this, arguments);
                  }
                  function ug() {
                    return lm.apply(this, arguments);
                  }
                  function lm() {
                    return lm = gf(/* @__PURE__ */ Mc().mark(function Ai() {
                      return Mc().wrap(function(Po) {
                        for (; ; ) switch (Po.prev = Po.next) {
                          case 0:
                            return Po.next = 2, this.videoElement.play();
                          case 2:
                          case "end":
                            return Po.stop();
                        }
                      }, Ai, this);
                    })), lm.apply(this, arguments);
                  }
                  function my() {
                    return "".concat(this.logId, ".clspClient:").concat(++this.clspClientCount);
                  }
                  function vy(Ai) {
                    if (!this.isStopped && (this.emit(ah.events.VIDEO_RECEIVED), Gc(Oc, this, yy).call(this), !!this.mseWrapper)) {
                      if (io().isDocumentHidden()) {
                        this.logger.info("Document is in hidden state, not appending moof");
                        return;
                      }
                      try {
                        this.mseWrapper.showVideoSegment(Ai), this.clspClient.conduit.segmentUsed(Ai);
                      } catch (_i) {
                        this.logger.error("Error while trying to show video segment!"), this.logger.error(_i), Gc(Oc, this, kp).call(this);
                      }
                    }
                  }
                  function yy() {
                    if (!this.latestSegmentReceivedAt) {
                      this.latestSegmentReceivedAt = Date.now();
                      return;
                    }
                    var Ai = this.latestSegmentReceivedAt;
                    if (this.latestSegmentReceivedAt = Date.now(), this.intervalBetweenSegments = this.latestSegmentReceivedAt - Ai, !!this.intervalBetweenSegments) {
                      this.segmentIntervals.length >= this.SEGMENT_INTERVAL_SAMPLE_SIZE && this.segmentIntervals.shift(), this.segmentIntervals.push(this.intervalBetweenSegments);
                      for (var _i = 0, Po = 0; Po < this.segmentIntervals.length; Po++)
                        _i += this.segmentIntervals[Po];
                      this.segmentIntervalAverage = _i / this.segmentIntervals.length, Gc(Oc, this, Np).call(this, "video.intervalBetweenSegments", this.intervalBetweenSegments), Gc(Oc, this, Np).call(this, "video.segmentIntervalAverage", this.segmentIntervalAverage);
                    }
                  }
                  function Np(Ai, _i) {
                  }
                  ed(Bc, "events", {
                    METRIC: "metric",
                    UNSUPPORTED_MIME_CODEC: "unsupportedMimeCodec",
                    FIRST_FRAME_SHOWN: "firstFrameShown",
                    VIDEO_RECEIVED: "videoReceived",
                    VIDEO_INFO_RECEIVED: "videoInfoReceived",
                    REINITIALZE_ERROR: "reinitialize-error",
                    IFRAME_DESTROYED_EXTERNALLY: Od.events.IFRAME_DESTROYED_EXTERNALLY,
                    RECONNECT_FAILURE: Od.events.RECONNECT_FAILURE,
                    ROUTER_EVENT_ERROR: Od.events.ROUTER_EVENT_ERROR,
                    JWT_AUTHORIZATION_FAILURE: Od.events.JWT_AUTHORIZATION_FAILURE
                  });
                  var um;
                  function Ac() {
                    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
                    Ac = function() {
                      return _i;
                    };
                    var Ai, _i = {}, Po = Object.prototype, Gi = Po.hasOwnProperty, na = Object.defineProperty || function(Bi, Ci, ki) {
                      Bi[Ci] = ki.value;
                    }, ta = typeof Symbol == "function" ? Symbol : {}, Fo = ta.iterator || "@@iterator", Wa = ta.asyncIterator || "@@asyncIterator", Va = ta.toStringTag || "@@toStringTag";
                    function wa(Bi, Ci, ki) {
                      return Object.defineProperty(Bi, Ci, { value: ki, enumerable: !0, configurable: !0, writable: !0 }), Bi[Ci];
                    }
                    try {
                      wa({}, "");
                    } catch {
                      wa = function(ki, Mo, Xo) {
                        return ki[Mo] = Xo;
                      };
                    }
                    function il(Bi, Ci, ki, Mo) {
                      var Xo = Ci && Ci.prototype instanceof pu ? Ci : pu, Uo = Object.create(Xo.prototype), qa = new ku(Mo || []);
                      return na(Uo, "_invoke", { value: pc(Bi, ki, qa) }), Uo;
                    }
                    function ol(Bi, Ci, ki) {
                      try {
                        return { type: "normal", arg: Bi.call(Ci, ki) };
                      } catch (Mo) {
                        return { type: "throw", arg: Mo };
                      }
                    }
                    _i.wrap = il;
                    var Ql = "suspendedStart", Uu = "suspendedYield", Wu = "executing", Kl = "completed", pl = {};
                    function pu() {
                    }
                    function lu() {
                    }
                    function Nl() {
                    }
                    var Eu = {};
                    wa(Eu, Fo, function() {
                      return this;
                    });
                    var wu = Object.getPrototypeOf, yu = wu && wu(wu(Nu([])));
                    yu && yu !== Po && Gi.call(yu, Fo) && (Eu = yu);
                    var zl = Nl.prototype = pu.prototype = Object.create(Eu);
                    function Qu(Bi) {
                      ["next", "throw", "return"].forEach(function(Ci) {
                        wa(Bi, Ci, function(ki) {
                          return this._invoke(Ci, ki);
                        });
                      });
                    }
                    function gu(Bi, Ci) {
                      function ki(Xo, Uo, qa, Us) {
                        var Hs = ol(Bi[Xo], Bi, Uo);
                        if (Hs.type !== "throw") {
                          var jl = Hs.arg, Al = jl.value;
                          return Al && typeof Al == "object" && Gi.call(Al, "__await") ? Ci.resolve(Al.__await).then(function(Ml) {
                            ki("next", Ml, qa, Us);
                          }, function(Ml) {
                            ki("throw", Ml, qa, Us);
                          }) : Ci.resolve(Al).then(function(Ml) {
                            jl.value = Ml, qa(jl);
                          }, function(Ml) {
                            return ki("throw", Ml, qa, Us);
                          });
                        }
                        Us(Hs.arg);
                      }
                      var Mo;
                      na(this, "_invoke", { value: function(Uo, qa) {
                        function Us() {
                          return new Ci(function(Hs, jl) {
                            ki(Uo, qa, Hs, jl);
                          });
                        }
                        return Mo = Mo ? Mo.then(Us, Us) : Us();
                      } });
                    }
                    function pc(Bi, Ci, ki) {
                      var Mo = Ql;
                      return function(Xo, Uo) {
                        if (Mo === Wu) throw Error("Generator is already running");
                        if (Mo === Kl) {
                          if (Xo === "throw") throw Uo;
                          return { value: Ai, done: !0 };
                        }
                        for (ki.method = Xo, ki.arg = Uo; ; ) {
                          var qa = ki.delegate;
                          if (qa) {
                            var Us = Zu(qa, ki);
                            if (Us) {
                              if (Us === pl) continue;
                              return Us;
                            }
                          }
                          if (ki.method === "next") ki.sent = ki._sent = ki.arg;
                          else if (ki.method === "throw") {
                            if (Mo === Ql) throw Mo = Kl, ki.arg;
                            ki.dispatchException(ki.arg);
                          } else ki.method === "return" && ki.abrupt("return", ki.arg);
                          Mo = Wu;
                          var Hs = ol(Bi, Ci, ki);
                          if (Hs.type === "normal") {
                            if (Mo = ki.done ? Kl : Uu, Hs.arg === pl) continue;
                            return { value: Hs.arg, done: ki.done };
                          }
                          Hs.type === "throw" && (Mo = Kl, ki.method = "throw", ki.arg = Hs.arg);
                        }
                      };
                    }
                    function Zu(Bi, Ci) {
                      var ki = Ci.method, Mo = Bi.iterator[ki];
                      if (Mo === Ai) return Ci.delegate = null, ki === "throw" && Bi.iterator.return && (Ci.method = "return", Ci.arg = Ai, Zu(Bi, Ci), Ci.method === "throw") || ki !== "return" && (Ci.method = "throw", Ci.arg = new TypeError("The iterator does not provide a '" + ki + "' method")), pl;
                      var Xo = ol(Mo, Bi.iterator, Ci.arg);
                      if (Xo.type === "throw") return Ci.method = "throw", Ci.arg = Xo.arg, Ci.delegate = null, pl;
                      var Uo = Xo.arg;
                      return Uo ? Uo.done ? (Ci[Bi.resultName] = Uo.value, Ci.next = Bi.nextLoc, Ci.method !== "return" && (Ci.method = "next", Ci.arg = Ai), Ci.delegate = null, pl) : Uo : (Ci.method = "throw", Ci.arg = new TypeError("iterator result is not an object"), Ci.delegate = null, pl);
                    }
                    function gc(Bi) {
                      var Ci = { tryLoc: Bi[0] };
                      1 in Bi && (Ci.catchLoc = Bi[1]), 2 in Bi && (Ci.finallyLoc = Bi[2], Ci.afterLoc = Bi[3]), this.tryEntries.push(Ci);
                    }
                    function Du(Bi) {
                      var Ci = Bi.completion || {};
                      Ci.type = "normal", delete Ci.arg, Bi.completion = Ci;
                    }
                    function ku(Bi) {
                      this.tryEntries = [{ tryLoc: "root" }], Bi.forEach(gc, this), this.reset(!0);
                    }
                    function Nu(Bi) {
                      if (Bi || Bi === "") {
                        var Ci = Bi[Fo];
                        if (Ci) return Ci.call(Bi);
                        if (typeof Bi.next == "function") return Bi;
                        if (!isNaN(Bi.length)) {
                          var ki = -1, Mo = function Xo() {
                            for (; ++ki < Bi.length; ) if (Gi.call(Bi, ki)) return Xo.value = Bi[ki], Xo.done = !1, Xo;
                            return Xo.value = Ai, Xo.done = !0, Xo;
                          };
                          return Mo.next = Mo;
                        }
                      }
                      throw new TypeError(typeof Bi + " is not iterable");
                    }
                    return lu.prototype = Nl, na(zl, "constructor", { value: Nl, configurable: !0 }), na(Nl, "constructor", { value: lu, configurable: !0 }), lu.displayName = wa(Nl, Va, "GeneratorFunction"), _i.isGeneratorFunction = function(Bi) {
                      var Ci = typeof Bi == "function" && Bi.constructor;
                      return !!Ci && (Ci === lu || (Ci.displayName || Ci.name) === "GeneratorFunction");
                    }, _i.mark = function(Bi) {
                      return Object.setPrototypeOf ? Object.setPrototypeOf(Bi, Nl) : (Bi.__proto__ = Nl, wa(Bi, Va, "GeneratorFunction")), Bi.prototype = Object.create(zl), Bi;
                    }, _i.awrap = function(Bi) {
                      return { __await: Bi };
                    }, Qu(gu.prototype), wa(gu.prototype, Wa, function() {
                      return this;
                    }), _i.AsyncIterator = gu, _i.async = function(Bi, Ci, ki, Mo, Xo) {
                      Xo === void 0 && (Xo = Promise);
                      var Uo = new gu(il(Bi, Ci, ki, Mo), Xo);
                      return _i.isGeneratorFunction(Ci) ? Uo : Uo.next().then(function(qa) {
                        return qa.done ? qa.value : Uo.next();
                      });
                    }, Qu(zl), wa(zl, Va, "Generator"), wa(zl, Fo, function() {
                      return this;
                    }), wa(zl, "toString", function() {
                      return "[object Generator]";
                    }), _i.keys = function(Bi) {
                      var Ci = Object(Bi), ki = [];
                      for (var Mo in Ci) ki.push(Mo);
                      return ki.reverse(), function Xo() {
                        for (; ki.length; ) {
                          var Uo = ki.pop();
                          if (Uo in Ci) return Xo.value = Uo, Xo.done = !1, Xo;
                        }
                        return Xo.done = !0, Xo;
                      };
                    }, _i.values = Nu, ku.prototype = { constructor: ku, reset: function(Ci) {
                      if (this.prev = 0, this.next = 0, this.sent = this._sent = Ai, this.done = !1, this.delegate = null, this.method = "next", this.arg = Ai, this.tryEntries.forEach(Du), !Ci) for (var ki in this) ki.charAt(0) === "t" && Gi.call(this, ki) && !isNaN(+ki.slice(1)) && (this[ki] = Ai);
                    }, stop: function() {
                      this.done = !0;
                      var Ci = this.tryEntries[0].completion;
                      if (Ci.type === "throw") throw Ci.arg;
                      return this.rval;
                    }, dispatchException: function(Ci) {
                      if (this.done) throw Ci;
                      var ki = this;
                      function Mo(jl, Al) {
                        return qa.type = "throw", qa.arg = Ci, ki.next = jl, Al && (ki.method = "next", ki.arg = Ai), !!Al;
                      }
                      for (var Xo = this.tryEntries.length - 1; Xo >= 0; --Xo) {
                        var Uo = this.tryEntries[Xo], qa = Uo.completion;
                        if (Uo.tryLoc === "root") return Mo("end");
                        if (Uo.tryLoc <= this.prev) {
                          var Us = Gi.call(Uo, "catchLoc"), Hs = Gi.call(Uo, "finallyLoc");
                          if (Us && Hs) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          } else if (Us) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                          } else {
                            if (!Hs) throw Error("try statement without catch or finally");
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          }
                        }
                      }
                    }, abrupt: function(Ci, ki) {
                      for (var Mo = this.tryEntries.length - 1; Mo >= 0; --Mo) {
                        var Xo = this.tryEntries[Mo];
                        if (Xo.tryLoc <= this.prev && Gi.call(Xo, "finallyLoc") && this.prev < Xo.finallyLoc) {
                          var Uo = Xo;
                          break;
                        }
                      }
                      Uo && (Ci === "break" || Ci === "continue") && Uo.tryLoc <= ki && ki <= Uo.finallyLoc && (Uo = null);
                      var qa = Uo ? Uo.completion : {};
                      return qa.type = Ci, qa.arg = ki, Uo ? (this.method = "next", this.next = Uo.finallyLoc, pl) : this.complete(qa);
                    }, complete: function(Ci, ki) {
                      if (Ci.type === "throw") throw Ci.arg;
                      return Ci.type === "break" || Ci.type === "continue" ? this.next = Ci.arg : Ci.type === "return" ? (this.rval = this.arg = Ci.arg, this.method = "return", this.next = "end") : Ci.type === "normal" && ki && (this.next = ki), pl;
                    }, finish: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.finallyLoc === Ci) return this.complete(Mo.completion, Mo.afterLoc), Du(Mo), pl;
                      }
                    }, catch: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.tryLoc === Ci) {
                          var Xo = Mo.completion;
                          if (Xo.type === "throw") {
                            var Uo = Xo.arg;
                            Du(Mo);
                          }
                          return Uo;
                        }
                      }
                      throw Error("illegal catch attempt");
                    }, delegateYield: function(Ci, ki, Mo) {
                      return this.delegate = { iterator: Nu(Ci), resultName: ki, nextLoc: Mo }, this.method === "next" && (this.arg = Ai), pl;
                    } }, _i;
                  }
                  function $g(Ai, _i, Po, Gi, na, ta, Fo) {
                    try {
                      var Wa = Ai[ta](Fo), Va = Wa.value;
                    } catch (wa) {
                      return void Po(wa);
                    }
                    Wa.done ? _i(Va) : Promise.resolve(Va).then(Gi, na);
                  }
                  function Ld(Ai) {
                    return function() {
                      var _i = this, Po = arguments;
                      return new Promise(function(Gi, na) {
                        var ta = Ai.apply(_i, Po);
                        function Fo(Va) {
                          $g(ta, Gi, na, Fo, Wa, "next", Va);
                        }
                        function Wa(Va) {
                          $g(ta, Gi, na, Fo, Wa, "throw", Va);
                        }
                        Fo(void 0);
                      });
                    };
                  }
                  function jh(Ai, _i) {
                    if (!(Ai instanceof _i)) throw new TypeError("Cannot call a class as a function");
                  }
                  function nv(Ai, _i) {
                    for (var Po = 0; Po < _i.length; Po++) {
                      var Gi = _i[Po];
                      Gi.enumerable = Gi.enumerable || !1, Gi.configurable = !0, "value" in Gi && (Gi.writable = !0), Object.defineProperty(Ai, fm(Gi.key), Gi);
                    }
                  }
                  function by(Ai, _i, Po) {
                    return _i && nv(Ai.prototype, _i), Po && nv(Ai, Po), Object.defineProperty(Ai, "prototype", { writable: !1 }), Ai;
                  }
                  function cm(Ai, _i, Po) {
                    return _i = kg(_i), iv(Ai, Dg() ? Reflect.construct(_i, Po || [], kg(Ai).constructor) : _i.apply(Ai, Po));
                  }
                  function iv(Ai, _i) {
                    if (_i && (typeof _i == "object" || typeof _i == "function")) return _i;
                    if (_i !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return Ty(Ai);
                  }
                  function Ty(Ai) {
                    if (Ai === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return Ai;
                  }
                  function Dg() {
                    try {
                      var Ai = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                      }));
                    } catch {
                    }
                    return (Dg = function() {
                      return !!Ai;
                    })();
                  }
                  function kg(Ai) {
                    return kg = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(_i) {
                      return _i.__proto__ || Object.getPrototypeOf(_i);
                    }, kg(Ai);
                  }
                  function Ey(Ai, _i) {
                    if (typeof _i != "function" && _i !== null) throw new TypeError("Super expression must either be null or a function");
                    Ai.prototype = Object.create(_i && _i.prototype, { constructor: { value: Ai, writable: !0, configurable: !0 } }), Object.defineProperty(Ai, "prototype", { writable: !1 }), _i && dm(Ai, _i);
                  }
                  function dm(Ai, _i) {
                    return dm = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(Po, Gi) {
                      return Po.__proto__ = Gi, Po;
                    }, dm(Ai, _i);
                  }
                  function ov(Ai, _i) {
                    Ng(Ai, _i), _i.add(Ai);
                  }
                  function Ng(Ai, _i) {
                    if (_i.has(Ai)) throw new TypeError("Cannot initialize the same private elements twice on an object");
                  }
                  function av(Ai, _i, Po) {
                    return (_i = fm(_i)) in Ai ? Object.defineProperty(Ai, _i, { value: Po, enumerable: !0, configurable: !0, writable: !0 }) : Ai[_i] = Po, Ai;
                  }
                  function fm(Ai) {
                    var _i = Sy(Ai, "string");
                    return typeof _i == "symbol" ? _i : _i + "";
                  }
                  function Sy(Ai, _i) {
                    if (typeof Ai != "object" || !Ai) return Ai;
                    var Po = Ai[Symbol.toPrimitive];
                    if (Po !== void 0) {
                      var Gi = Po.call(Ai, _i);
                      if (typeof Gi != "object") return Gi;
                      throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (_i === "string" ? String : Number)(Ai);
                  }
                  function cp(Ai, _i, Po) {
                    if (typeof Ai == "function" ? Ai === _i : Ai.has(_i)) return arguments.length < 3 ? _i : Po;
                    throw new TypeError("Private element is not present on this object");
                  }
                  var xy = 100, $f = /* @__PURE__ */ new WeakSet(), dp = /* @__PURE__ */ (function(Ai) {
                    function _i(Po) {
                      var Gi;
                      return jh(this, _i), Gi = cm(this, _i, [Po]), ov(Gi, $f), Gi.initialize(), Gi.MAX_RETRIES_ON_PLAY_ERROR = xy, Gi;
                    }
                    return Ey(_i, Ai), by(_i, [{
                      key: "initialize",
                      value: function() {
                        this.logger.info("Initializing"), this.players = {}, this.playerStack = [], this.playerLogMessageIds = {}, this.retryAttempts = {}, this.mostRecentlyPlayedId = null, this.mostRecentlyAddedId = null, this.totalPlayersAdded = 0, this.pendingRemoval = {};
                      }
                    }, {
                      key: "generatePlayerLogId",
                      value: function(Gi) {
                        return "".concat(this.logId, ".player:").concat(this.totalPlayersAdded, ":").concat(Gi);
                      }
                    }, {
                      key: "create",
                      value: (function() {
                        var Po = Ld(/* @__PURE__ */ Ac().mark(function na(ta, Fo, Wa) {
                          var Va, wa;
                          return Ac().wrap(function(ol) {
                            for (; ; ) switch (ol.prev = ol.next) {
                              case 0:
                                return Va = this._create(ta, Fo, Wa), wa = Va.id, cp($f, this, ym).call(this, Va), ol.next = 5, cp($f, this, mm).call(this, wa);
                              case 5:
                                return ol.abrupt("return", wa);
                              case 6:
                              case "end":
                                return ol.stop();
                            }
                          }, na, this);
                        }));
                        function Gi(na, ta, Fo) {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "_create",
                      value: function(Gi, na, ta) {
                        var Fo = this;
                        if (!Gi)
                          throw new Error("A container element is required to create an IovPlayer");
                        if (!na)
                          throw new Error("A video element is required to create an IovPlayer");
                        if (!ta)
                          throw new Error("stream configuration is required to create an IovPlayer");
                        this.totalPlayersAdded++;
                        var Wa = Is(), Va = Bc.factory(this.generatePlayerLogId(ta.streamName), Wa, Gi, na);
                        return Va.setStreamConfiguration(ta), Va.on(Bc.events.IFRAME_DESTROYED_EXTERNALLY, function() {
                          if (Fo.isDestroyed) {
                            Fo.logger.info("Iframe was destroyed externally while in process of destroying");
                            return;
                          }
                          Fo.emit(_i.events.IFRAME_DESTROYED_EXTERNALLY, {
                            id: Wa
                          });
                        }), Va.on(Bc.events.VIDEO_RECEIVED, function() {
                          Fo.emit(_i.events.VIDEO_RECEIVED, {
                            id: Wa
                          });
                        }), Va.on(Bc.events.VIDEO_INFO_RECEIVED, function() {
                          Fo.emit(_i.events.VIDEO_INFO_RECEIVED, {
                            id: Wa
                          });
                        }), Va.on(Bc.events.FIRST_FRAME_SHOWN, /* @__PURE__ */ Ld(/* @__PURE__ */ Ac().mark(function wa() {
                          return Ac().wrap(function(ol) {
                            for (; ; ) switch (ol.prev = ol.next) {
                              case 0:
                                Fo.emit(_i.events.FIRST_FRAME_SHOWN, {
                                  id: Wa
                                }), Fo.mostRecentlyPlayedId = Wa;
                                try {
                                  Fo.logger.info("First frame received for ".concat(Fo.playerLogMessageIds[Wa], ", destroying all previous players...")), Fo.destroyAllPreviousPlayers(Wa);
                                } catch (Ql) {
                                  Fo.logger.error("Error while destroying previous players for ".concat(Fo.playerLogMessageIds[Wa])), Fo.logger.error(Ql);
                                }
                              case 3:
                              case "end":
                                return ol.stop();
                            }
                          }, wa);
                        }))), Va.on(Bc.events.RECONNECT_FAILURE, /* @__PURE__ */ Ld(/* @__PURE__ */ Ac().mark(function wa() {
                          return Ac().wrap(function(ol) {
                            for (; ; ) switch (ol.prev = ol.next) {
                              case 0:
                                return ol.prev = 0, Fo.logger.info("Critical player error RECONNECT_FAILURE for player ".concat(Fo.playerLogMessageIds[Wa])), ol.next = 4, cp($f, Fo, pm).call(Fo, Wa, Bc.events.RECONNECT_FAILURE);
                              case 4:
                                ol.next = 10;
                                break;
                              case 6:
                                ol.prev = 6, ol.t0 = ol.catch(0), Fo.logger.error("Error while handling player error RECONNECT_FAILURE for player ".concat(Fo.playerLogMessageIds[Wa])), Fo.logger.error(ol.t0);
                              case 10:
                              case "end":
                                return ol.stop();
                            }
                          }, wa, null, [[0, 6]]);
                        }))), Va.on(Bc.events.ROUTER_EVENT_ERROR, /* @__PURE__ */ Ld(/* @__PURE__ */ Ac().mark(function wa() {
                          return Ac().wrap(function(ol) {
                            for (; ; ) switch (ol.prev = ol.next) {
                              case 0:
                                return ol.prev = 0, Fo.logger.info("Critical player error ROUTER_EVENT_ERROR for player ".concat(Fo.playerLogMessageIds[Wa])), ol.next = 4, cp($f, Fo, pm).call(Fo, Wa, Bc.events.ROUTER_EVENT_ERROR);
                              case 4:
                                ol.next = 10;
                                break;
                              case 6:
                                ol.prev = 6, ol.t0 = ol.catch(0), Fo.logger.error("Error while handling player error ROUTER_EVENT_ERROR for player ".concat(Fo.playerLogMessageIds[Wa])), Fo.logger.error(ol.t0);
                              case 10:
                              case "end":
                                return ol.stop();
                            }
                          }, wa, null, [[0, 6]]);
                        }))), Va.on(Bc.events.REINITIALZE_ERROR, /* @__PURE__ */ Ld(/* @__PURE__ */ Ac().mark(function wa() {
                          return Ac().wrap(function(ol) {
                            for (; ; ) switch (ol.prev = ol.next) {
                              case 0:
                                return ol.prev = 0, Fo.logger.info("Critical player error REINITIALZE_ERROR for player ".concat(Fo.playerLogMessageIds[Wa])), ol.next = 4, cp($f, Fo, pm).call(Fo, Wa, Bc.events.REINITIALZE_ERROR);
                              case 4:
                                ol.next = 10;
                                break;
                              case 6:
                                ol.prev = 6, ol.t0 = ol.catch(0), Fo.logger.error("Error while handling player error REINITIALZE_ERROR for player ".concat(Fo.playerLogMessageIds[Wa])), Fo.logger.error(ol.t0);
                              case 10:
                              case "end":
                                return ol.stop();
                            }
                          }, wa, null, [[0, 6]]);
                        }))), Va.on(Bc.events.JWT_AUTHORIZATION_FAILURE, function(wa) {
                          Fo.logger.error("Critical JWT authorization error: ".concat(wa.error)), Fo.retryAttempts[Wa] = Fo.MAX_RETRIES_ON_PLAY_ERROR + 1;
                        }), Va;
                      }
                    }, {
                      key: "destroyAllPreviousPlayers",
                      value: (function() {
                        var Po = Ld(/* @__PURE__ */ Ac().mark(function na(ta) {
                          var Fo, Wa;
                          return Ac().wrap(function(wa) {
                            for (; ; ) switch (wa.prev = wa.next) {
                              case 0:
                                if (Fo = this.playerStack.indexOf(ta), Fo !== -1) {
                                  wa.next = 3;
                                  break;
                                }
                                return wa.abrupt("return");
                              case 3:
                                return Wa = this.playerStack.slice(0, Fo), wa.prev = 4, wa.next = 7, this.removeMany(Wa);
                              case 7:
                                wa.next = 13;
                                break;
                              case 9:
                                wa.prev = 9, wa.t0 = wa.catch(4), this.logger.error("Error(s) while destroying players before ".concat(this.playerLogMessageIds[ta], ", continuing anyway...")), this.logger.error(wa.t0);
                              case 13:
                              case "end":
                                return wa.stop();
                            }
                          }, na, this, [[4, 9]]);
                        }));
                        function Gi(na) {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "has",
                      value: function(Gi) {
                        return Di()(Gi) || this.pendingRemoval[Gi] ? !1 : Object.prototype.hasOwnProperty.call(this.players, Gi);
                      }
                    }, {
                      key: "get",
                      value: function(Gi) {
                        return this.has(Gi) ? this.players[Gi] : null;
                      }
                    }, {
                      key: "remove",
                      value: (function() {
                        var Po = Ld(/* @__PURE__ */ Ac().mark(function na(ta) {
                          var Fo, Wa, Va, wa;
                          return Ac().wrap(function(ol) {
                            for (; ; ) switch (ol.prev = ol.next) {
                              case 0:
                                if (Fo = this.get(ta), Fo !== null) {
                                  ol.next = 3;
                                  break;
                                }
                                return ol.abrupt("return");
                              case 3:
                                return Fo.logger.info("IovPlayerCollection - removing player..."), Wa = this.playerLogMessageIds[ta], this.pendingRemoval[ta] = !0, this.mostRecentlyPlayedId === ta && (this.mostRecentlyPlayedId = null), Va = this.playerStack.indexOf(ta), Va !== -1 && this.playerStack.splice(Va, 1), this.mostRecentlyAddedId === ta && (wa = this.playerStack.length, wa === 0 ? this.mostRecentlyAddedId = null : this.mostRecentlyAddedId = this.playerStack[wa - 1]), delete this.players[ta], delete this.playerLogMessageIds[ta], delete this.pendingRemoval[ta], ol.prev = 13, ol.next = 16, Fo.destroy();
                              case 16:
                                ol.next = 22;
                                break;
                              case 18:
                                ol.prev = 18, ol.t0 = ol.catch(13), this.logger.error("Error destroying IovPlayer ".concat(Wa, " while removing, continuing anyway")), this.logger.error(ol.t0);
                              case 22:
                              case "end":
                                return ol.stop();
                            }
                          }, na, this, [[13, 18]]);
                        }));
                        function Gi(na) {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "removeMany",
                      value: (function() {
                        var Po = Ld(/* @__PURE__ */ Ac().mark(function na(ta) {
                          var Fo = this, Wa, Va, wa;
                          return Ac().wrap(function(ol) {
                            for (; ; ) switch (ol.prev = ol.next) {
                              case 0:
                                return Wa = ta.map(function(Ql) {
                                  return Fo.remove(Ql);
                                }), ol.next = 3, Promise.allSettled(Wa);
                              case 3:
                                if (Va = ol.sent, wa = Va.reduce(function(Ql, Uu) {
                                  return Uu.status !== "fulfilled" && Ql.push(Uu), Ql;
                                }, []), !wa.length) {
                                  ol.next = 9;
                                  break;
                                }
                                throw this.logger.error("Error(s) encountered while destroying IovPlayer(s) during removeMany..."), wa.forEach(function(Ql) {
                                  Fo.logger.error(Ql.reason);
                                }), wa[0].reason;
                              case 9:
                              case "end":
                                return ol.stop();
                            }
                          }, na, this);
                        }));
                        function Gi(na) {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "removeAll",
                      value: (function() {
                        var Po = Ld(/* @__PURE__ */ Ac().mark(function na() {
                          var ta;
                          return Ac().wrap(function(Wa) {
                            for (; ; ) switch (Wa.prev = Wa.next) {
                              case 0:
                                return ta = Object.keys(this.players), Wa.next = 3, this.removeMany(ta);
                              case 3:
                              case "end":
                                return Wa.stop();
                            }
                          }, na, this);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "_destroy",
                      value: (function() {
                        var Po = Ld(/* @__PURE__ */ Ac().mark(function na() {
                          return Ac().wrap(function(Fo) {
                            for (; ; ) switch (Fo.prev = Fo.next) {
                              case 0:
                                return Fo.prev = 0, Fo.next = 3, this.removeAll();
                              case 3:
                                Fo.next = 9;
                                break;
                              case 5:
                                Fo.prev = 5, Fo.t0 = Fo.catch(0), this.logger.error("Error(s) encountered while removing while destroying, continuing anyway..."), this.logger.error(Fo.t0);
                              case 9:
                                this.players = null, this.playerLogMessageIds = null, this.pendingRemoval = null, this.playerStack = null;
                              case 13:
                              case "end":
                                return Fo.stop();
                            }
                          }, na, this, [[0, 5]]);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }], [{
                      key: "factory",
                      value: function(Gi) {
                        return new _i(Gi);
                      }
                    }]);
                  })(ja);
                  um = dp;
                  function pm(Ai, _i) {
                    return hm.apply(this, arguments);
                  }
                  function hm() {
                    return hm = Ld(/* @__PURE__ */ Ac().mark(function Ai(_i, Po) {
                      return Ac().wrap(function(na) {
                        for (; ; ) switch (na.prev = na.next) {
                          case 0:
                            if (!(_i === this.mostRecentlyPlayedId || _i === this.mostRecentlyAddedId)) {
                              na.next = 12;
                              break;
                            }
                            return this.logger.info("Active IovPlayer ".concat(this.playerLogMessageIds[_i], ' emitted the "').concat(Po, '" event, recreating it...')), na.prev = 2, na.next = 5, cp($f, this, _y).call(this, _i);
                          case 5:
                            na.next = 11;
                            break;
                          case 7:
                            na.prev = 7, na.t0 = na.catch(2), this.logger.error("Error while recreating ".concat(this.playerLogMessageIds[_i])), this.logger.error(na.t0);
                          case 11:
                            return na.abrupt("return");
                          case 12:
                            return this.logger.info("Stale IovPlayer ".concat(this.playerLogMessageIds[_i], ' emitted the "').concat(Po, '" event, destroying it...')), na.prev = 13, na.next = 16, this.remove(_i);
                          case 16:
                            na.next = 22;
                            break;
                          case 18:
                            na.prev = 18, na.t1 = na.catch(13), this.logger.error("Error while removing Stale IovPlayer ".concat(this.playerLogMessageIds[_i], ' during "').concat(Po, '" event, continuing anyway...')), this.logger.error(na.t1);
                          case 22:
                          case "end":
                            return na.stop();
                        }
                      }, Ai, this, [[2, 7], [13, 18]]);
                    })), hm.apply(this, arguments);
                  }
                  function wy(Ai, _i) {
                    var Po = this.playerStack.indexOf(Ai);
                    if (Po === -1)
                      throw new Error("Cannot replace ".concat(this.playerLogMessageIds[Ai], " in stack because it doesn't exist in the stack..."));
                    this.playerStack[Po] = _i;
                  }
                  function _y(Ai) {
                    return gm.apply(this, arguments);
                  }
                  function gm() {
                    return gm = Ld(/* @__PURE__ */ Ac().mark(function Ai(_i) {
                      var Po = this, Gi, na, ta, Fo;
                      return Ac().wrap(function(Va) {
                        for (; ; ) switch (Va.prev = Va.next) {
                          case 0:
                            if (Gi = this.get(_i), Gi !== null) {
                              Va.next = 3;
                              break;
                            }
                            throw new Error("Cannot recreate IovPlayer with non-existent id ".concat(_i));
                          case 3:
                            return na = this.playerLogMessageIds[_i], ta = this._create(Gi.containerElement, Gi.videoElement, Gi.streamConfiguration), Fo = ta.id, this.players[Fo] = ta, this.playerLogMessageIds[Fo] = this.totalPlayersAdded, this.retryAttempts[Fo] = 0, cp($f, this, wy).call(this, _i, Fo), this.mostRecentlyAddedId === _i && (this.mostRecentlyAddedId = Fo), this.mostRecentlyPlayedId === _i && (this.mostRecentlyPlayedId = Fo), this.remove(_i).catch(function(wa) {
                              Po.logger.error("Error while removing player ".concat(na, " while recreating, continuing anyway...")), Po.logger.error(wa);
                            }), Va.next = 15, cp($f, this, mm).call(this, Fo);
                          case 15:
                          case "end":
                            return Va.stop();
                        }
                      }, Ai, this);
                    })), gm.apply(this, arguments);
                  }
                  function mm(Ai) {
                    return vm.apply(this, arguments);
                  }
                  function vm() {
                    return vm = Ld(/* @__PURE__ */ Ac().mark(function Ai(_i) {
                      var Po;
                      return Ac().wrap(function(na) {
                        for (; ; ) switch (na.prev = na.next) {
                          case 0:
                            if (Po = this.get(_i), Po !== null) {
                              na.next = 3;
                              break;
                            }
                            throw new Error("Cannot play - IovPlayer id ".concat(_i, " doesn't exist"));
                          case 3:
                            return na.prev = 3, na.next = 6, Po.initialize();
                          case 6:
                            return na.next = 8, Po.play();
                          case 8:
                            Po.logger.info("Play succeeded!"), na.next = 26;
                            break;
                          case 11:
                            if (na.prev = 11, na.t0 = na.catch(3), this.logger.error("Error while trying to play IovPlayer ".concat(this.playerLogMessageIds[_i], "...")), this.logger.error(na.t0), !(this.MAX_RETRIES_ON_PLAY_ERROR > 0 && this.retryAttempts[_i] <= this.MAX_RETRIES_ON_PLAY_ERROR)) {
                              na.next = 21;
                              break;
                            }
                            return this.logger.warn("Retry play attempt #".concat(this.retryAttempts[_i]++, " for player ").concat(this.playerLogMessageIds[_i], "...")), na.next = 19, cp($f, this, mm).call(this, _i);
                          case 19:
                            na.next = 26;
                            break;
                          case 21:
                            return this.logger.error("Destroying IovPlayer after exhausting play and retry attempts"), this.emit(um.events.DISPLAY_ERROR_MSG, {
                              error: na.t0
                            }), na.next = 25, this.remove(_i);
                          case 25:
                            throw na.t0;
                          case 26:
                          case "end":
                            return na.stop();
                        }
                      }, Ai, this, [[3, 11]]);
                    })), vm.apply(this, arguments);
                  }
                  function ym(Ai) {
                    var _i = Ai.id;
                    if (this.has(_i))
                      throw new Error("Cannot add an iovPlayer without a unique id");
                    this.players[_i] = Ai, this.playerLogMessageIds[_i] = this.totalPlayersAdded, this.retryAttempts[_i] = 0, this.mostRecentlyAddedId = _i, this.playerStack.push(_i);
                  }
                  av(dp, "events", {
                    // Needed for videojs plugin
                    VIDEO_RECEIVED: Bc.events.VIDEO_RECEIVED,
                    // Needed for videojs plugin
                    VIDEO_INFO_RECEIVED: Bc.events.VIDEO_INFO_RECEIVED,
                    FIRST_FRAME_SHOWN: Bc.events.FIRST_FRAME_SHOWN,
                    IFRAME_DESTROYED_EXTERNALLY: Bc.events.IFRAME_DESTROYED_EXTERNALLY,
                    DISPLAY_ERROR_MSG: Bc.events.DISPLAY_ERROR_MSG
                  });
                  function Sd() {
                    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
                    Sd = function() {
                      return _i;
                    };
                    var Ai, _i = {}, Po = Object.prototype, Gi = Po.hasOwnProperty, na = Object.defineProperty || function(Bi, Ci, ki) {
                      Bi[Ci] = ki.value;
                    }, ta = typeof Symbol == "function" ? Symbol : {}, Fo = ta.iterator || "@@iterator", Wa = ta.asyncIterator || "@@asyncIterator", Va = ta.toStringTag || "@@toStringTag";
                    function wa(Bi, Ci, ki) {
                      return Object.defineProperty(Bi, Ci, { value: ki, enumerable: !0, configurable: !0, writable: !0 }), Bi[Ci];
                    }
                    try {
                      wa({}, "");
                    } catch {
                      wa = function(ki, Mo, Xo) {
                        return ki[Mo] = Xo;
                      };
                    }
                    function il(Bi, Ci, ki, Mo) {
                      var Xo = Ci && Ci.prototype instanceof pu ? Ci : pu, Uo = Object.create(Xo.prototype), qa = new ku(Mo || []);
                      return na(Uo, "_invoke", { value: pc(Bi, ki, qa) }), Uo;
                    }
                    function ol(Bi, Ci, ki) {
                      try {
                        return { type: "normal", arg: Bi.call(Ci, ki) };
                      } catch (Mo) {
                        return { type: "throw", arg: Mo };
                      }
                    }
                    _i.wrap = il;
                    var Ql = "suspendedStart", Uu = "suspendedYield", Wu = "executing", Kl = "completed", pl = {};
                    function pu() {
                    }
                    function lu() {
                    }
                    function Nl() {
                    }
                    var Eu = {};
                    wa(Eu, Fo, function() {
                      return this;
                    });
                    var wu = Object.getPrototypeOf, yu = wu && wu(wu(Nu([])));
                    yu && yu !== Po && Gi.call(yu, Fo) && (Eu = yu);
                    var zl = Nl.prototype = pu.prototype = Object.create(Eu);
                    function Qu(Bi) {
                      ["next", "throw", "return"].forEach(function(Ci) {
                        wa(Bi, Ci, function(ki) {
                          return this._invoke(Ci, ki);
                        });
                      });
                    }
                    function gu(Bi, Ci) {
                      function ki(Xo, Uo, qa, Us) {
                        var Hs = ol(Bi[Xo], Bi, Uo);
                        if (Hs.type !== "throw") {
                          var jl = Hs.arg, Al = jl.value;
                          return Al && typeof Al == "object" && Gi.call(Al, "__await") ? Ci.resolve(Al.__await).then(function(Ml) {
                            ki("next", Ml, qa, Us);
                          }, function(Ml) {
                            ki("throw", Ml, qa, Us);
                          }) : Ci.resolve(Al).then(function(Ml) {
                            jl.value = Ml, qa(jl);
                          }, function(Ml) {
                            return ki("throw", Ml, qa, Us);
                          });
                        }
                        Us(Hs.arg);
                      }
                      var Mo;
                      na(this, "_invoke", { value: function(Uo, qa) {
                        function Us() {
                          return new Ci(function(Hs, jl) {
                            ki(Uo, qa, Hs, jl);
                          });
                        }
                        return Mo = Mo ? Mo.then(Us, Us) : Us();
                      } });
                    }
                    function pc(Bi, Ci, ki) {
                      var Mo = Ql;
                      return function(Xo, Uo) {
                        if (Mo === Wu) throw Error("Generator is already running");
                        if (Mo === Kl) {
                          if (Xo === "throw") throw Uo;
                          return { value: Ai, done: !0 };
                        }
                        for (ki.method = Xo, ki.arg = Uo; ; ) {
                          var qa = ki.delegate;
                          if (qa) {
                            var Us = Zu(qa, ki);
                            if (Us) {
                              if (Us === pl) continue;
                              return Us;
                            }
                          }
                          if (ki.method === "next") ki.sent = ki._sent = ki.arg;
                          else if (ki.method === "throw") {
                            if (Mo === Ql) throw Mo = Kl, ki.arg;
                            ki.dispatchException(ki.arg);
                          } else ki.method === "return" && ki.abrupt("return", ki.arg);
                          Mo = Wu;
                          var Hs = ol(Bi, Ci, ki);
                          if (Hs.type === "normal") {
                            if (Mo = ki.done ? Kl : Uu, Hs.arg === pl) continue;
                            return { value: Hs.arg, done: ki.done };
                          }
                          Hs.type === "throw" && (Mo = Kl, ki.method = "throw", ki.arg = Hs.arg);
                        }
                      };
                    }
                    function Zu(Bi, Ci) {
                      var ki = Ci.method, Mo = Bi.iterator[ki];
                      if (Mo === Ai) return Ci.delegate = null, ki === "throw" && Bi.iterator.return && (Ci.method = "return", Ci.arg = Ai, Zu(Bi, Ci), Ci.method === "throw") || ki !== "return" && (Ci.method = "throw", Ci.arg = new TypeError("The iterator does not provide a '" + ki + "' method")), pl;
                      var Xo = ol(Mo, Bi.iterator, Ci.arg);
                      if (Xo.type === "throw") return Ci.method = "throw", Ci.arg = Xo.arg, Ci.delegate = null, pl;
                      var Uo = Xo.arg;
                      return Uo ? Uo.done ? (Ci[Bi.resultName] = Uo.value, Ci.next = Bi.nextLoc, Ci.method !== "return" && (Ci.method = "next", Ci.arg = Ai), Ci.delegate = null, pl) : Uo : (Ci.method = "throw", Ci.arg = new TypeError("iterator result is not an object"), Ci.delegate = null, pl);
                    }
                    function gc(Bi) {
                      var Ci = { tryLoc: Bi[0] };
                      1 in Bi && (Ci.catchLoc = Bi[1]), 2 in Bi && (Ci.finallyLoc = Bi[2], Ci.afterLoc = Bi[3]), this.tryEntries.push(Ci);
                    }
                    function Du(Bi) {
                      var Ci = Bi.completion || {};
                      Ci.type = "normal", delete Ci.arg, Bi.completion = Ci;
                    }
                    function ku(Bi) {
                      this.tryEntries = [{ tryLoc: "root" }], Bi.forEach(gc, this), this.reset(!0);
                    }
                    function Nu(Bi) {
                      if (Bi || Bi === "") {
                        var Ci = Bi[Fo];
                        if (Ci) return Ci.call(Bi);
                        if (typeof Bi.next == "function") return Bi;
                        if (!isNaN(Bi.length)) {
                          var ki = -1, Mo = function Xo() {
                            for (; ++ki < Bi.length; ) if (Gi.call(Bi, ki)) return Xo.value = Bi[ki], Xo.done = !1, Xo;
                            return Xo.value = Ai, Xo.done = !0, Xo;
                          };
                          return Mo.next = Mo;
                        }
                      }
                      throw new TypeError(typeof Bi + " is not iterable");
                    }
                    return lu.prototype = Nl, na(zl, "constructor", { value: Nl, configurable: !0 }), na(Nl, "constructor", { value: lu, configurable: !0 }), lu.displayName = wa(Nl, Va, "GeneratorFunction"), _i.isGeneratorFunction = function(Bi) {
                      var Ci = typeof Bi == "function" && Bi.constructor;
                      return !!Ci && (Ci === lu || (Ci.displayName || Ci.name) === "GeneratorFunction");
                    }, _i.mark = function(Bi) {
                      return Object.setPrototypeOf ? Object.setPrototypeOf(Bi, Nl) : (Bi.__proto__ = Nl, wa(Bi, Va, "GeneratorFunction")), Bi.prototype = Object.create(zl), Bi;
                    }, _i.awrap = function(Bi) {
                      return { __await: Bi };
                    }, Qu(gu.prototype), wa(gu.prototype, Wa, function() {
                      return this;
                    }), _i.AsyncIterator = gu, _i.async = function(Bi, Ci, ki, Mo, Xo) {
                      Xo === void 0 && (Xo = Promise);
                      var Uo = new gu(il(Bi, Ci, ki, Mo), Xo);
                      return _i.isGeneratorFunction(Ci) ? Uo : Uo.next().then(function(qa) {
                        return qa.done ? qa.value : Uo.next();
                      });
                    }, Qu(zl), wa(zl, Va, "Generator"), wa(zl, Fo, function() {
                      return this;
                    }), wa(zl, "toString", function() {
                      return "[object Generator]";
                    }), _i.keys = function(Bi) {
                      var Ci = Object(Bi), ki = [];
                      for (var Mo in Ci) ki.push(Mo);
                      return ki.reverse(), function Xo() {
                        for (; ki.length; ) {
                          var Uo = ki.pop();
                          if (Uo in Ci) return Xo.value = Uo, Xo.done = !1, Xo;
                        }
                        return Xo.done = !0, Xo;
                      };
                    }, _i.values = Nu, ku.prototype = { constructor: ku, reset: function(Ci) {
                      if (this.prev = 0, this.next = 0, this.sent = this._sent = Ai, this.done = !1, this.delegate = null, this.method = "next", this.arg = Ai, this.tryEntries.forEach(Du), !Ci) for (var ki in this) ki.charAt(0) === "t" && Gi.call(this, ki) && !isNaN(+ki.slice(1)) && (this[ki] = Ai);
                    }, stop: function() {
                      this.done = !0;
                      var Ci = this.tryEntries[0].completion;
                      if (Ci.type === "throw") throw Ci.arg;
                      return this.rval;
                    }, dispatchException: function(Ci) {
                      if (this.done) throw Ci;
                      var ki = this;
                      function Mo(jl, Al) {
                        return qa.type = "throw", qa.arg = Ci, ki.next = jl, Al && (ki.method = "next", ki.arg = Ai), !!Al;
                      }
                      for (var Xo = this.tryEntries.length - 1; Xo >= 0; --Xo) {
                        var Uo = this.tryEntries[Xo], qa = Uo.completion;
                        if (Uo.tryLoc === "root") return Mo("end");
                        if (Uo.tryLoc <= this.prev) {
                          var Us = Gi.call(Uo, "catchLoc"), Hs = Gi.call(Uo, "finallyLoc");
                          if (Us && Hs) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          } else if (Us) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                          } else {
                            if (!Hs) throw Error("try statement without catch or finally");
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          }
                        }
                      }
                    }, abrupt: function(Ci, ki) {
                      for (var Mo = this.tryEntries.length - 1; Mo >= 0; --Mo) {
                        var Xo = this.tryEntries[Mo];
                        if (Xo.tryLoc <= this.prev && Gi.call(Xo, "finallyLoc") && this.prev < Xo.finallyLoc) {
                          var Uo = Xo;
                          break;
                        }
                      }
                      Uo && (Ci === "break" || Ci === "continue") && Uo.tryLoc <= ki && ki <= Uo.finallyLoc && (Uo = null);
                      var qa = Uo ? Uo.completion : {};
                      return qa.type = Ci, qa.arg = ki, Uo ? (this.method = "next", this.next = Uo.finallyLoc, pl) : this.complete(qa);
                    }, complete: function(Ci, ki) {
                      if (Ci.type === "throw") throw Ci.arg;
                      return Ci.type === "break" || Ci.type === "continue" ? this.next = Ci.arg : Ci.type === "return" ? (this.rval = this.arg = Ci.arg, this.method = "return", this.next = "end") : Ci.type === "normal" && ki && (this.next = ki), pl;
                    }, finish: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.finallyLoc === Ci) return this.complete(Mo.completion, Mo.afterLoc), Du(Mo), pl;
                      }
                    }, catch: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.tryLoc === Ci) {
                          var Xo = Mo.completion;
                          if (Xo.type === "throw") {
                            var Uo = Xo.arg;
                            Du(Mo);
                          }
                          return Uo;
                        }
                      }
                      throw Error("illegal catch attempt");
                    }, delegateYield: function(Ci, ki, Mo) {
                      return this.delegate = { iterator: Nu(Ci), resultName: ki, nextLoc: Mo }, this.method === "next" && (this.arg = Ai), pl;
                    } }, _i;
                  }
                  function sv(Ai, _i, Po, Gi, na, ta, Fo) {
                    try {
                      var Wa = Ai[ta](Fo), Va = Wa.value;
                    } catch (wa) {
                      return void Po(wa);
                    }
                    Wa.done ? _i(Va) : Promise.resolve(Va).then(Gi, na);
                  }
                  function fp(Ai) {
                    return function() {
                      var _i = this, Po = arguments;
                      return new Promise(function(Gi, na) {
                        var ta = Ai.apply(_i, Po);
                        function Fo(Va) {
                          sv(ta, Gi, na, Fo, Wa, "next", Va);
                        }
                        function Wa(Va) {
                          sv(ta, Gi, na, Fo, Wa, "throw", Va);
                        }
                        Fo(void 0);
                      });
                    };
                  }
                  function lv(Ai, _i) {
                    if (!(Ai instanceof _i)) throw new TypeError("Cannot call a class as a function");
                  }
                  function uv(Ai, _i) {
                    for (var Po = 0; Po < _i.length; Po++) {
                      var Gi = _i[Po];
                      Gi.enumerable = Gi.enumerable || !1, Gi.configurable = !0, "value" in Gi && (Gi.writable = !0), Object.defineProperty(Ai, hv(Gi.key), Gi);
                    }
                  }
                  function Py(Ai, _i, Po) {
                    return _i && uv(Ai.prototype, _i), Po && uv(Ai, Po), Object.defineProperty(Ai, "prototype", { writable: !1 }), Ai;
                  }
                  function Cy(Ai, _i, Po) {
                    return _i = Fh(_i), Ry(Ai, bm() ? Reflect.construct(_i, Po || [], Fh(Ai).constructor) : _i.apply(Ai, Po));
                  }
                  function Ry(Ai, _i) {
                    if (_i && (typeof _i == "object" || typeof _i == "function")) return _i;
                    if (_i !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return Oy(Ai);
                  }
                  function Oy(Ai) {
                    if (Ai === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return Ai;
                  }
                  function bm() {
                    try {
                      var Ai = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                      }));
                    } catch {
                    }
                    return (bm = function() {
                      return !!Ai;
                    })();
                  }
                  function cv(Ai, _i, Po, Gi) {
                    var na = cg(Fh(Ai.prototype), _i, Po);
                    return 2 & Gi && typeof na == "function" ? function(ta) {
                      return na.apply(Po, ta);
                    } : na;
                  }
                  function cg() {
                    return cg = typeof Reflect < "u" && Reflect.get ? Reflect.get.bind() : function(Ai, _i, Po) {
                      var Gi = bd(Ai, _i);
                      if (Gi) {
                        var na = Object.getOwnPropertyDescriptor(Gi, _i);
                        return na.get ? na.get.call(arguments.length < 3 ? Ai : Po) : na.value;
                      }
                    }, cg.apply(null, arguments);
                  }
                  function bd(Ai, _i) {
                    for (; !{}.hasOwnProperty.call(Ai, _i) && (Ai = Fh(Ai)) !== null; ) ;
                    return Ai;
                  }
                  function Fh(Ai) {
                    return Fh = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(_i) {
                      return _i.__proto__ || Object.getPrototypeOf(_i);
                    }, Fh(Ai);
                  }
                  function dv(Ai, _i) {
                    if (typeof _i != "function" && _i !== null) throw new TypeError("Super expression must either be null or a function");
                    Ai.prototype = Object.create(_i && _i.prototype, { constructor: { value: Ai, writable: !0, configurable: !0 } }), Object.defineProperty(Ai, "prototype", { writable: !1 }), _i && Tm(Ai, _i);
                  }
                  function Tm(Ai, _i) {
                    return Tm = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(Po, Gi) {
                      return Po.__proto__ = Gi, Po;
                    }, Tm(Ai, _i);
                  }
                  function fv(Ai, _i) {
                    pv(Ai, _i), _i.add(Ai);
                  }
                  function pv(Ai, _i) {
                    if (_i.has(Ai)) throw new TypeError("Cannot initialize the same private elements twice on an object");
                  }
                  function Df(Ai, _i, Po) {
                    return (_i = hv(_i)) in Ai ? Object.defineProperty(Ai, _i, { value: Po, enumerable: !0, configurable: !0, writable: !0 }) : Ai[_i] = Po, Ai;
                  }
                  function hv(Ai) {
                    var _i = Ay(Ai, "string");
                    return typeof _i == "symbol" ? _i : _i + "";
                  }
                  function Ay(Ai, _i) {
                    if (typeof Ai != "object" || !Ai) return Ai;
                    var Po = Ai[Symbol.toPrimitive];
                    if (Po !== void 0) {
                      var Gi = Po.call(Ai, _i);
                      if (typeof Gi != "object") return Gi;
                      throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (_i === "string" ? String : Number)(Ai);
                  }
                  function gv(Ai, _i, Po) {
                    if (typeof Ai == "function" ? Ai === _i : Ai.has(_i)) return arguments.length < 3 ? _i : Po;
                    throw new TypeError("Private element is not present on this object");
                  }
                  var Iy = !1, $y = 5, Em = "clsp-player-container", Sm = "clsp-player", xm = "clsp-player-loading-animation", wm = "clsp-player-error-msg", _m = /* @__PURE__ */ new WeakSet(), Pm = /* @__PURE__ */ (function(Ai) {
                    function _i(Po, Gi, na) {
                      var ta;
                      if (lv(this, _i), !io().supported())
                        throw new Error("You are using an unsupported browser - Unable to play CLSP video");
                      if (ta = Cy(this, _i, [Po]), fv(ta, _m), Df(ta, "onConnectionChange", /* @__PURE__ */ fp(/* @__PURE__ */ Sd().mark(function Wa() {
                        return Sd().wrap(function(wa) {
                          for (; ; ) switch (wa.prev = wa.next) {
                            case 0:
                              if (!io().isOnline()) {
                                wa.next = 12;
                                break;
                              }
                              return ta.logger.info("Back online..."), wa.prev = 2, wa.next = 5, ta.restart();
                            case 5:
                              wa.next = 11;
                              break;
                            case 7:
                              wa.prev = 7, wa.t0 = wa.catch(2), ta.logger.error("Error while trying to restart during online event"), ta.logger.error(wa.t0);
                            case 11:
                              return wa.abrupt("return");
                            case 12:
                              return ta.logger.info("Offline!"), wa.prev = 13, wa.next = 16, ta.stop();
                            case 16:
                              wa.next = 22;
                              break;
                            case 18:
                              wa.prev = 18, wa.t1 = wa.catch(13), ta.logger.error("Error encountered while stopping during offline event:"), ta.logger.error(wa.t1);
                            case 22:
                            case "end":
                              return wa.stop();
                          }
                        }, Wa, null, [[2, 7], [13, 18]]);
                      }))), Df(ta, "onVisibilityChange", /* @__PURE__ */ fp(/* @__PURE__ */ Sd().mark(function Wa() {
                        return Sd().wrap(function(wa) {
                          for (; ; ) switch (wa.prev = wa.next) {
                            case 0:
                              if (!io().isDocumentHidden()) {
                                wa.next = 11;
                                break;
                              }
                              return wa.prev = 1, wa.next = 4, ta.stop();
                            case 4:
                              wa.next = 10;
                              break;
                            case 6:
                              wa.prev = 6, wa.t0 = wa.catch(1), ta.logger.error("Error while trying to stop during visibilityChange event"), ta.logger.error(wa.t0);
                            case 10:
                              return wa.abrupt("return");
                            case 11:
                              if (ta.logger.info("Back in focus..."), ta.streamConfiguration) {
                                wa.next = 14;
                                break;
                              }
                              return wa.abrupt("return");
                            case 14:
                              return wa.prev = 14, wa.next = 17, ta.restart();
                            case 17:
                              wa.next = 23;
                              break;
                            case 19:
                              wa.prev = 19, wa.t1 = wa.catch(14), ta.logger.error("Error while restarting during onVisibilityChange!"), ta.logger.error(wa.t1);
                            case 23:
                            case "end":
                              return wa.stop();
                          }
                        }, Wa, null, [[1, 6], [14, 19]]);
                      }))), Df(ta, "getErrorMsgContainer", function() {
                        return ta.containerElement.getElementsByClassName(wm)[0];
                      }), Df(ta, "getLoadingAnimation", function() {
                        return ta.containerElement.getElementsByClassName(xm);
                      }), Df(ta, "destroyAllLoadingAnimations", function() {
                        for (var Wa = ta.getLoadingAnimation(), Va = 0; Va < Wa.length; Va++)
                          Wa[Va].remove();
                      }), Df(ta, "createLoadingAnimation", function() {
                        var Wa = ta.getLoadingAnimation();
                        if (!(Wa.length > 0)) {
                          var Va = document.createElement("div");
                          Va.classList.add(xm), ta.containerElement.insertBefore(Va, ta.videoElement);
                        }
                      }), Df(ta, "clearErrorMsg", function() {
                        ta.getErrorMsgContainer().style.display = "none", ta.getErrorMsgContainer().innerHTML = "";
                      }), Df(ta, "displayErrorMsg", function(Wa) {
                        var Va = ta.getErrorMsgContainer();
                        Va.style.display = "block", Va.innerHTML = Wa;
                      }), Df(ta, "initializeErrorMsgContainer", function() {
                        if (ta.getErrorMsgContainer() === void 0) {
                          var Wa = document.createElement("div");
                          Wa.classList.add(wm), ta.containerElement.insertBefore(Wa, ta.videoElement);
                        } else
                          ta.clearErrorMsg();
                      }), Di()(Gi))
                        throw new Error("id is required to construct an Iov");
                      if (!na)
                        throw new Error("Tried to construct without config");
                      ta.id = Gi, ta.shouldRetainVideoElement = !1, ta.containerElement = null, ta.videoElement = null, ta._config = na, gv(_m, ta, mv).call(ta, na);
                      var Fo = io().windowStateNames.visibilityChangeEventName;
                      return Fo && document.addEventListener(Fo, ta.onVisibilityChange, !1), window.addEventListener("online", ta.onConnectionChange, !1), window.addEventListener("offline", ta.onConnectionChange, !1), ta.ENABLE_METRICS = Iy, ta.CONNECTION_CHANGE_PLAY_DELAY = $y, ta.iovPlayerCollection = dp.factory("".concat(ta.logId, ".iovPlayerCollection")), ta.iovPlayerCollection.on(dp.events.FIRST_FRAME_SHOWN, function() {
                        ta.emit(_i.events.FIRST_FRAME_SHOWN);
                      }), ta.iovPlayerCollection.on(dp.events.VIDEO_RECEIVED, function() {
                        ta.emit(_i.events.VIDEO_RECEIVED);
                      }), ta.iovPlayerCollection.on(dp.events.VIDEO_INFO_RECEIVED, function() {
                        ta.emit(_i.events.VIDEO_INFO_RECEIVED);
                      }), ta.iovPlayerCollection.on(dp.events.IFRAME_DESTROYED_EXTERNALLY, function() {
                        if (ta.isDestroyed) {
                          ta.logger.info("Iframe was destroyed externally while in process of destroying");
                          return;
                        }
                        ta.emit(_i.events.IFRAME_DESTROYED_EXTERNALLY);
                      }), ta.iovPlayerCollection.on(dp.events.DISPLAY_ERROR_MSG, function(Wa) {
                        ta.logger.info("Displaying error msg to user"), ta.videoElement.src = "", ta.displayErrorMsg(Wa.error.message);
                      }), ta;
                    }
                    return dv(_i, Ai), Py(_i, [{
                      key: "changeSrc",
                      value: (
                        /**
                         * @param {StreamConfiguration|String} url
                         *   The StreamConfiguration or url of the new stream
                         */
                        (function() {
                          var Po = fp(/* @__PURE__ */ Sd().mark(function na(ta) {
                            var Fo = this, Wa;
                            return Sd().wrap(function(wa) {
                              for (; ; ) switch (wa.prev = wa.next) {
                                case 0:
                                  if (!this.isDestroyed) {
                                    wa.next = 3;
                                    break;
                                  }
                                  return this.logger.info("Tried to changeSrc while destroyed"), wa.abrupt("return");
                                case 3:
                                  if (this.logger.info("Changing Stream..."), ta) {
                                    wa.next = 6;
                                    break;
                                  }
                                  throw new Error("url is required to changeSrc");
                                case 6:
                                  if (this.streamConfiguration = bu.isStreamConfiguration(ta) ? ta : bu.fromUrl(ta), !io().isDocumentHidden()) {
                                    wa.next = 10;
                                    break;
                                  }
                                  return this.logger.info("Tried to changeSrc while tab was hidden!"), wa.abrupt("return");
                                case 10:
                                  if (io().isOnline()) {
                                    wa.next = 13;
                                    break;
                                  }
                                  return this.logger.info("Tried to changeSrc while not connected to the internet!"), wa.abrupt("return");
                                case 13:
                                  return this.createLoadingAnimation(), this.initializeErrorMsgContainer(), wa.next = 17, (0, Mi.sleepSeconds)(Math.random());
                                case 17:
                                  return wa.prev = 17, wa.next = 20, this.iovPlayerCollection.create(this.containerElement, this.videoElement, this.streamConfiguration);
                                case 20:
                                  Wa = wa.sent, wa.next = 29;
                                  break;
                                case 23:
                                  throw wa.prev = 23, wa.t0 = wa.catch(17), this.logger.error("Error while creating / playing the player for stream ".concat(this.streamConfiguration.streamName)), this.logger.error(wa.t0), this.destroyAllLoadingAnimations(), wa.t0;
                                case 29:
                                  if (Wa) {
                                    wa.next = 32;
                                    break;
                                  }
                                  throw this.destroyAllLoadingAnimations(), new Error("IovPlayer was created, but no id was returned");
                                case 32:
                                  return wa.next = 34, new Promise(function(il, ol) {
                                    Fo.iovPlayerCollection.on(dp.events.FIRST_FRAME_SHOWN, /* @__PURE__ */ (function() {
                                      var Ql = fp(/* @__PURE__ */ Sd().mark(function Uu(Wu) {
                                        var Kl;
                                        return Sd().wrap(function(pu) {
                                          for (; ; ) switch (pu.prev = pu.next) {
                                            case 0:
                                              if (Kl = Wu.id, Fo.destroyAllLoadingAnimations(), Wa === Kl) {
                                                pu.next = 4;
                                                break;
                                              }
                                              return pu.abrupt("return");
                                            case 4:
                                              return Fo.logger.info("Next player has received its first frame..."), pu.next = 7, (0, Mi.sleepSeconds)(Fo.SHOW_NEXT_VIDEO_DELAY);
                                            case 7:
                                              if (pu.prev = 7, !Fo.isDestroyed) {
                                                pu.next = 10;
                                                break;
                                              }
                                              throw new Error("Next player received first frame while destroyed!");
                                            case 10:
                                              il(), pu.next = 17;
                                              break;
                                            case 13:
                                              pu.prev = 13, pu.t0 = pu.catch(7), Fo.logger.error("Error while handling first frame shown event!"), ol(pu.t0);
                                            case 17:
                                            case "end":
                                              return pu.stop();
                                          }
                                        }, Uu, null, [[7, 13]]);
                                      }));
                                      return function(Uu) {
                                        return Ql.apply(this, arguments);
                                      };
                                    })());
                                  });
                                case 34:
                                case "end":
                                  return wa.stop();
                              }
                            }, na, this, [[17, 23]]);
                          }));
                          function Gi(na) {
                            return Po.apply(this, arguments);
                          }
                          return Gi;
                        })()
                      )
                    }, {
                      key: "stop",
                      value: (function() {
                        var Po = fp(/* @__PURE__ */ Sd().mark(function na() {
                          return Sd().wrap(function(Fo) {
                            for (; ; ) switch (Fo.prev = Fo.next) {
                              case 0:
                                if (!this.isDestroyComplete) {
                                  Fo.next = 2;
                                  break;
                                }
                                throw new Error("Tried to stop while destroyed");
                              case 2:
                                if (!this.isStopping) {
                                  Fo.next = 5;
                                  break;
                                }
                                return this.logger.info("Already stopping"), Fo.abrupt("return");
                              case 5:
                                return this.isStopping = !0, Fo.prev = 6, Fo.next = 9, this.iovPlayerCollection.removeAll();
                              case 9:
                                return Fo.prev = 9, this.isStopping = !1, Fo.finish(9);
                              case 12:
                              case "end":
                                return Fo.stop();
                            }
                          }, na, this, [[6, , 9, 12]]);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "restart",
                      value: (function() {
                        var Po = fp(/* @__PURE__ */ Sd().mark(function na() {
                          return Sd().wrap(function(Fo) {
                            for (; ; ) switch (Fo.prev = Fo.next) {
                              case 0:
                                if (!this.isDestroyed) {
                                  Fo.next = 2;
                                  break;
                                }
                                throw new Error("Tried to restart while destroyed");
                              case 2:
                                return this.logger.info("Restart"), Fo.prev = 3, Fo.next = 6, this.stop();
                              case 6:
                                Fo.next = 12;
                                break;
                              case 8:
                                Fo.prev = 8, Fo.t0 = Fo.catch(3), this.logger.warn("Failed to stop while restarting, continuing anyway..."), this.logger.error(Fo.t0);
                              case 12:
                                return Fo.prev = 12, Fo.next = 15, this.changeSrc(this.streamConfiguration);
                              case 15:
                                Fo.next = 21;
                                break;
                              case 17:
                                throw Fo.prev = 17, Fo.t1 = Fo.catch(12), this.logger.error("Failed to changeSrc while restarting!"), Fo.t1;
                              case 21:
                              case "end":
                                return Fo.stop();
                            }
                          }, na, this, [[3, 8], [12, 17]]);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "enterFullscreen",
                      value: function() {
                        window.document.fullscreenElement || this.containerElement.requestFullscreen();
                      }
                    }, {
                      key: "exitFullscreen",
                      value: function() {
                        window.document.exitFullscreen && window.document.exitFullscreen();
                      }
                    }, {
                      key: "toggleFullscreen",
                      value: function() {
                        window.document.fullscreenElement ? this.exitFullscreen() : this.enterFullscreen();
                      }
                      // @todo @metrics
                    }, {
                      key: "metric",
                      value: function(Gi, na) {
                      }
                      /**
                       * Dereference the necessary properties, clear any intervals and timeouts, and
                       * remove any listeners.  Will also destroy the player.
                       *
                       * @returns {Promise}
                       */
                    }, {
                      key: "_destroy",
                      value: (function() {
                        var Po = fp(/* @__PURE__ */ Sd().mark(function na() {
                          var ta, Fo, Wa, Va;
                          return Sd().wrap(function(il) {
                            for (; ; ) switch (il.prev = il.next) {
                              case 0:
                                return ta = Date.now(), Fo = io().windowStateNames.visibilityChangeEventName, Fo && document.removeEventListener(Fo, this.onVisibilityChange), window.removeEventListener("online", this.onConnectionChange), window.removeEventListener("offline", this.onConnectionChange), il.prev = 5, il.next = 8, this.stop();
                              case 8:
                                il.next = 14;
                                break;
                              case 10:
                                il.prev = 10, il.t0 = il.catch(5), this.logger.error("Error while stopping while destroying"), this.logger.error(il.t0);
                              case 14:
                                return il.prev = 14, il.next = 17, this.iovPlayerCollection.destroy();
                              case 17:
                                il.next = 23;
                                break;
                              case 19:
                                il.prev = 19, il.t1 = il.catch(14), this.logger.error("Error while destroying IOV Player Collection while destroying"), this.logger.error(il.t1);
                              case 23:
                                return this.streamConfiguration = null, gv(_m, this, Dy).call(this), this._config = null, il.next = 28, cv(_i, "_destroy", this, 3)([]);
                              case 28:
                                Wa = Date.now(), Va = (Wa - ta) / 1e3, this.logger.info("Destroy complete in ".concat(Va, " seconds..."));
                              case 31:
                              case "end":
                                return il.stop();
                            }
                          }, na, this, [[5, 10], [14, 19]]);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "destroy",
                      value: (function() {
                        var Po = fp(/* @__PURE__ */ Sd().mark(function na() {
                          return Sd().wrap(function(Fo) {
                            for (; ; ) switch (Fo.prev = Fo.next) {
                              case 0:
                                return this.emit(_i.events.DESTROYING, {
                                  iov: this
                                }), Fo.next = 3, cv(_i, "destroy", this, 3)([]);
                              case 3:
                              case "end":
                                return Fo.stop();
                            }
                          }, na, this);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }], [{
                      key: "factory",
                      value: function(Gi, na, ta) {
                        return new _i(Gi, na, ta);
                      }
                    }]);
                  })(ja);
                  function mv(Ai) {
                    var _i = Ai.videoElementId, Po = Ai.videoElement, Gi = Ai.containerElementId, na = Ai.containerElement;
                    if (this.logger.info("Initializing elements..."), Gi && (na = document.getElementById(Gi)), this.containerElement = na, (_i || Po) && (this.shouldRetainVideoElement = !0), _i && (Po = document.getElementById(_i)), this.videoElement = Po, this.shouldRetainVideoElement && !this.videoElement)
                      throw _i ? new Error('Unable to get element with id: "'.concat(_i, '"')) : new Error("No video element or id was passed");
                    if (!this.videoElement && !this.containerElement)
                      throw new Error("Must pass at least 1 valid container or video element or id");
                    if (this.videoElement || (Po = document.createElement("video"), na.appendChild(Po), this.videoElement = Po), this.containerElement || (this.containerElement = this.videoElement.parentNode), !this.containerElement || !this.videoElement)
                      throw new Error("Unable to get both the container and video elements");
                    this.containerElement.classList.add(Em), this.videoElement.classList.add(Sm), this.videoElement.muted = !0, this.videoElement.playsinline = !0;
                  }
                  function Dy() {
                    this.logger.info("Unnitializing elements..."), this.destroyAllLoadingAnimations(), this.containerElement.classList.remove(Em), this.videoElement.classList.remove(Sm), this.videoElement.src = "", this.shouldRetainVideoElement || (this.containerElement.removeChild(this.videoElement), this.videoElement.remove()), this.videoElement = null, this.containerElement = null;
                  }
                  Df(Pm, "events", {
                    METRIC: "metric",
                    FIRST_FRAME_SHOWN: Bc.events.FIRST_FRAME_SHOWN,
                    VIDEO_RECEIVED: Bc.events.VIDEO_RECEIVED,
                    VIDEO_INFO_RECEIVED: Bc.events.VIDEO_INFO_RECEIVED,
                    IFRAME_DESTROYED_EXTERNALLY: Bc.events.IFRAME_DESTROYED_EXTERNALLY,
                    DESTROYING: "destroying"
                  });
                  function Qf() {
                    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
                    Qf = function() {
                      return _i;
                    };
                    var Ai, _i = {}, Po = Object.prototype, Gi = Po.hasOwnProperty, na = Object.defineProperty || function(Bi, Ci, ki) {
                      Bi[Ci] = ki.value;
                    }, ta = typeof Symbol == "function" ? Symbol : {}, Fo = ta.iterator || "@@iterator", Wa = ta.asyncIterator || "@@asyncIterator", Va = ta.toStringTag || "@@toStringTag";
                    function wa(Bi, Ci, ki) {
                      return Object.defineProperty(Bi, Ci, { value: ki, enumerable: !0, configurable: !0, writable: !0 }), Bi[Ci];
                    }
                    try {
                      wa({}, "");
                    } catch {
                      wa = function(ki, Mo, Xo) {
                        return ki[Mo] = Xo;
                      };
                    }
                    function il(Bi, Ci, ki, Mo) {
                      var Xo = Ci && Ci.prototype instanceof pu ? Ci : pu, Uo = Object.create(Xo.prototype), qa = new ku(Mo || []);
                      return na(Uo, "_invoke", { value: pc(Bi, ki, qa) }), Uo;
                    }
                    function ol(Bi, Ci, ki) {
                      try {
                        return { type: "normal", arg: Bi.call(Ci, ki) };
                      } catch (Mo) {
                        return { type: "throw", arg: Mo };
                      }
                    }
                    _i.wrap = il;
                    var Ql = "suspendedStart", Uu = "suspendedYield", Wu = "executing", Kl = "completed", pl = {};
                    function pu() {
                    }
                    function lu() {
                    }
                    function Nl() {
                    }
                    var Eu = {};
                    wa(Eu, Fo, function() {
                      return this;
                    });
                    var wu = Object.getPrototypeOf, yu = wu && wu(wu(Nu([])));
                    yu && yu !== Po && Gi.call(yu, Fo) && (Eu = yu);
                    var zl = Nl.prototype = pu.prototype = Object.create(Eu);
                    function Qu(Bi) {
                      ["next", "throw", "return"].forEach(function(Ci) {
                        wa(Bi, Ci, function(ki) {
                          return this._invoke(Ci, ki);
                        });
                      });
                    }
                    function gu(Bi, Ci) {
                      function ki(Xo, Uo, qa, Us) {
                        var Hs = ol(Bi[Xo], Bi, Uo);
                        if (Hs.type !== "throw") {
                          var jl = Hs.arg, Al = jl.value;
                          return Al && typeof Al == "object" && Gi.call(Al, "__await") ? Ci.resolve(Al.__await).then(function(Ml) {
                            ki("next", Ml, qa, Us);
                          }, function(Ml) {
                            ki("throw", Ml, qa, Us);
                          }) : Ci.resolve(Al).then(function(Ml) {
                            jl.value = Ml, qa(jl);
                          }, function(Ml) {
                            return ki("throw", Ml, qa, Us);
                          });
                        }
                        Us(Hs.arg);
                      }
                      var Mo;
                      na(this, "_invoke", { value: function(Uo, qa) {
                        function Us() {
                          return new Ci(function(Hs, jl) {
                            ki(Uo, qa, Hs, jl);
                          });
                        }
                        return Mo = Mo ? Mo.then(Us, Us) : Us();
                      } });
                    }
                    function pc(Bi, Ci, ki) {
                      var Mo = Ql;
                      return function(Xo, Uo) {
                        if (Mo === Wu) throw Error("Generator is already running");
                        if (Mo === Kl) {
                          if (Xo === "throw") throw Uo;
                          return { value: Ai, done: !0 };
                        }
                        for (ki.method = Xo, ki.arg = Uo; ; ) {
                          var qa = ki.delegate;
                          if (qa) {
                            var Us = Zu(qa, ki);
                            if (Us) {
                              if (Us === pl) continue;
                              return Us;
                            }
                          }
                          if (ki.method === "next") ki.sent = ki._sent = ki.arg;
                          else if (ki.method === "throw") {
                            if (Mo === Ql) throw Mo = Kl, ki.arg;
                            ki.dispatchException(ki.arg);
                          } else ki.method === "return" && ki.abrupt("return", ki.arg);
                          Mo = Wu;
                          var Hs = ol(Bi, Ci, ki);
                          if (Hs.type === "normal") {
                            if (Mo = ki.done ? Kl : Uu, Hs.arg === pl) continue;
                            return { value: Hs.arg, done: ki.done };
                          }
                          Hs.type === "throw" && (Mo = Kl, ki.method = "throw", ki.arg = Hs.arg);
                        }
                      };
                    }
                    function Zu(Bi, Ci) {
                      var ki = Ci.method, Mo = Bi.iterator[ki];
                      if (Mo === Ai) return Ci.delegate = null, ki === "throw" && Bi.iterator.return && (Ci.method = "return", Ci.arg = Ai, Zu(Bi, Ci), Ci.method === "throw") || ki !== "return" && (Ci.method = "throw", Ci.arg = new TypeError("The iterator does not provide a '" + ki + "' method")), pl;
                      var Xo = ol(Mo, Bi.iterator, Ci.arg);
                      if (Xo.type === "throw") return Ci.method = "throw", Ci.arg = Xo.arg, Ci.delegate = null, pl;
                      var Uo = Xo.arg;
                      return Uo ? Uo.done ? (Ci[Bi.resultName] = Uo.value, Ci.next = Bi.nextLoc, Ci.method !== "return" && (Ci.method = "next", Ci.arg = Ai), Ci.delegate = null, pl) : Uo : (Ci.method = "throw", Ci.arg = new TypeError("iterator result is not an object"), Ci.delegate = null, pl);
                    }
                    function gc(Bi) {
                      var Ci = { tryLoc: Bi[0] };
                      1 in Bi && (Ci.catchLoc = Bi[1]), 2 in Bi && (Ci.finallyLoc = Bi[2], Ci.afterLoc = Bi[3]), this.tryEntries.push(Ci);
                    }
                    function Du(Bi) {
                      var Ci = Bi.completion || {};
                      Ci.type = "normal", delete Ci.arg, Bi.completion = Ci;
                    }
                    function ku(Bi) {
                      this.tryEntries = [{ tryLoc: "root" }], Bi.forEach(gc, this), this.reset(!0);
                    }
                    function Nu(Bi) {
                      if (Bi || Bi === "") {
                        var Ci = Bi[Fo];
                        if (Ci) return Ci.call(Bi);
                        if (typeof Bi.next == "function") return Bi;
                        if (!isNaN(Bi.length)) {
                          var ki = -1, Mo = function Xo() {
                            for (; ++ki < Bi.length; ) if (Gi.call(Bi, ki)) return Xo.value = Bi[ki], Xo.done = !1, Xo;
                            return Xo.value = Ai, Xo.done = !0, Xo;
                          };
                          return Mo.next = Mo;
                        }
                      }
                      throw new TypeError(typeof Bi + " is not iterable");
                    }
                    return lu.prototype = Nl, na(zl, "constructor", { value: Nl, configurable: !0 }), na(Nl, "constructor", { value: lu, configurable: !0 }), lu.displayName = wa(Nl, Va, "GeneratorFunction"), _i.isGeneratorFunction = function(Bi) {
                      var Ci = typeof Bi == "function" && Bi.constructor;
                      return !!Ci && (Ci === lu || (Ci.displayName || Ci.name) === "GeneratorFunction");
                    }, _i.mark = function(Bi) {
                      return Object.setPrototypeOf ? Object.setPrototypeOf(Bi, Nl) : (Bi.__proto__ = Nl, wa(Bi, Va, "GeneratorFunction")), Bi.prototype = Object.create(zl), Bi;
                    }, _i.awrap = function(Bi) {
                      return { __await: Bi };
                    }, Qu(gu.prototype), wa(gu.prototype, Wa, function() {
                      return this;
                    }), _i.AsyncIterator = gu, _i.async = function(Bi, Ci, ki, Mo, Xo) {
                      Xo === void 0 && (Xo = Promise);
                      var Uo = new gu(il(Bi, Ci, ki, Mo), Xo);
                      return _i.isGeneratorFunction(Ci) ? Uo : Uo.next().then(function(qa) {
                        return qa.done ? qa.value : Uo.next();
                      });
                    }, Qu(zl), wa(zl, Va, "Generator"), wa(zl, Fo, function() {
                      return this;
                    }), wa(zl, "toString", function() {
                      return "[object Generator]";
                    }), _i.keys = function(Bi) {
                      var Ci = Object(Bi), ki = [];
                      for (var Mo in Ci) ki.push(Mo);
                      return ki.reverse(), function Xo() {
                        for (; ki.length; ) {
                          var Uo = ki.pop();
                          if (Uo in Ci) return Xo.value = Uo, Xo.done = !1, Xo;
                        }
                        return Xo.done = !0, Xo;
                      };
                    }, _i.values = Nu, ku.prototype = { constructor: ku, reset: function(Ci) {
                      if (this.prev = 0, this.next = 0, this.sent = this._sent = Ai, this.done = !1, this.delegate = null, this.method = "next", this.arg = Ai, this.tryEntries.forEach(Du), !Ci) for (var ki in this) ki.charAt(0) === "t" && Gi.call(this, ki) && !isNaN(+ki.slice(1)) && (this[ki] = Ai);
                    }, stop: function() {
                      this.done = !0;
                      var Ci = this.tryEntries[0].completion;
                      if (Ci.type === "throw") throw Ci.arg;
                      return this.rval;
                    }, dispatchException: function(Ci) {
                      if (this.done) throw Ci;
                      var ki = this;
                      function Mo(jl, Al) {
                        return qa.type = "throw", qa.arg = Ci, ki.next = jl, Al && (ki.method = "next", ki.arg = Ai), !!Al;
                      }
                      for (var Xo = this.tryEntries.length - 1; Xo >= 0; --Xo) {
                        var Uo = this.tryEntries[Xo], qa = Uo.completion;
                        if (Uo.tryLoc === "root") return Mo("end");
                        if (Uo.tryLoc <= this.prev) {
                          var Us = Gi.call(Uo, "catchLoc"), Hs = Gi.call(Uo, "finallyLoc");
                          if (Us && Hs) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          } else if (Us) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                          } else {
                            if (!Hs) throw Error("try statement without catch or finally");
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          }
                        }
                      }
                    }, abrupt: function(Ci, ki) {
                      for (var Mo = this.tryEntries.length - 1; Mo >= 0; --Mo) {
                        var Xo = this.tryEntries[Mo];
                        if (Xo.tryLoc <= this.prev && Gi.call(Xo, "finallyLoc") && this.prev < Xo.finallyLoc) {
                          var Uo = Xo;
                          break;
                        }
                      }
                      Uo && (Ci === "break" || Ci === "continue") && Uo.tryLoc <= ki && ki <= Uo.finallyLoc && (Uo = null);
                      var qa = Uo ? Uo.completion : {};
                      return qa.type = Ci, qa.arg = ki, Uo ? (this.method = "next", this.next = Uo.finallyLoc, pl) : this.complete(qa);
                    }, complete: function(Ci, ki) {
                      if (Ci.type === "throw") throw Ci.arg;
                      return Ci.type === "break" || Ci.type === "continue" ? this.next = Ci.arg : Ci.type === "return" ? (this.rval = this.arg = Ci.arg, this.method = "return", this.next = "end") : Ci.type === "normal" && ki && (this.next = ki), pl;
                    }, finish: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.finallyLoc === Ci) return this.complete(Mo.completion, Mo.afterLoc), Du(Mo), pl;
                      }
                    }, catch: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.tryLoc === Ci) {
                          var Xo = Mo.completion;
                          if (Xo.type === "throw") {
                            var Uo = Xo.arg;
                            Du(Mo);
                          }
                          return Uo;
                        }
                      }
                      throw Error("illegal catch attempt");
                    }, delegateYield: function(Ci, ki, Mo) {
                      return this.delegate = { iterator: Nu(Ci), resultName: ki, nextLoc: Mo }, this.method === "next" && (this.arg = Ai), pl;
                    } }, _i;
                  }
                  function dg(Ai, _i, Po, Gi, na, ta, Fo) {
                    try {
                      var Wa = Ai[ta](Fo), Va = Wa.value;
                    } catch (wa) {
                      return void Po(wa);
                    }
                    Wa.done ? _i(Va) : Promise.resolve(Va).then(Gi, na);
                  }
                  function mf(Ai) {
                    return function() {
                      var _i = this, Po = arguments;
                      return new Promise(function(Gi, na) {
                        var ta = Ai.apply(_i, Po);
                        function Fo(Va) {
                          dg(ta, Gi, na, Fo, Wa, "next", Va);
                        }
                        function Wa(Va) {
                          dg(ta, Gi, na, Fo, Wa, "throw", Va);
                        }
                        Fo(void 0);
                      });
                    };
                  }
                  function Cm(Ai, _i) {
                    if (!(Ai instanceof _i)) throw new TypeError("Cannot call a class as a function");
                  }
                  function vv(Ai, _i) {
                    for (var Po = 0; Po < _i.length; Po++) {
                      var Gi = _i[Po];
                      Gi.enumerable = Gi.enumerable || !1, Gi.configurable = !0, "value" in Gi && (Gi.writable = !0), Object.defineProperty(Ai, Rm(Gi.key), Gi);
                    }
                  }
                  function Ny(Ai, _i, Po) {
                    return _i && vv(Ai.prototype, _i), Po && vv(Ai, Po), Object.defineProperty(Ai, "prototype", { writable: !1 }), Ai;
                  }
                  function Rm(Ai) {
                    var _i = yv(Ai, "string");
                    return typeof _i == "symbol" ? _i : _i + "";
                  }
                  function yv(Ai, _i) {
                    if (typeof Ai != "object" || !Ai) return Ai;
                    var Po = Ai[Symbol.toPrimitive];
                    if (Po !== void 0) {
                      var Gi = Po.call(Ai, _i);
                      if (typeof Gi != "object") return Gi;
                      throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(Ai);
                  }
                  function bv(Ai, _i, Po) {
                    return _i = Bh(_i), Ly(Ai, Tv() ? Reflect.construct(_i, Po || [], Bh(Ai).constructor) : _i.apply(Ai, Po));
                  }
                  function Ly(Ai, _i) {
                    if (_i && (typeof _i == "object" || typeof _i == "function")) return _i;
                    if (_i !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return My(Ai);
                  }
                  function My(Ai) {
                    if (Ai === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return Ai;
                  }
                  function Tv() {
                    try {
                      var Ai = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                      }));
                    } catch {
                    }
                    return (Tv = function() {
                      return !!Ai;
                    })();
                  }
                  function Ev(Ai, _i, Po, Gi) {
                    var na = Lg(Bh(Ai.prototype), _i, Po);
                    return 2 & Gi && typeof na == "function" ? function(ta) {
                      return na.apply(Po, ta);
                    } : na;
                  }
                  function Lg() {
                    return Lg = typeof Reflect < "u" && Reflect.get ? Reflect.get.bind() : function(Ai, _i, Po) {
                      var Gi = jy(Ai, _i);
                      if (Gi) {
                        var na = Object.getOwnPropertyDescriptor(Gi, _i);
                        return na.get ? na.get.call(arguments.length < 3 ? Ai : Po) : na.value;
                      }
                    }, Lg.apply(null, arguments);
                  }
                  function jy(Ai, _i) {
                    for (; !{}.hasOwnProperty.call(Ai, _i) && (Ai = Bh(Ai)) !== null; ) ;
                    return Ai;
                  }
                  function Bh(Ai) {
                    return Bh = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(_i) {
                      return _i.__proto__ || Object.getPrototypeOf(_i);
                    }, Bh(Ai);
                  }
                  function Fy(Ai, _i) {
                    if (typeof _i != "function" && _i !== null) throw new TypeError("Super expression must either be null or a function");
                    Ai.prototype = Object.create(_i && _i.prototype, { constructor: { value: Ai, writable: !0, configurable: !0 } }), Object.defineProperty(Ai, "prototype", { writable: !1 }), _i && Om(Ai, _i);
                  }
                  function Om(Ai, _i) {
                    return Om = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(Po, Gi) {
                      return Po.__proto__ = Gi, Po;
                    }, Om(Ai, _i);
                  }
                  var Sv = 0, Am, Im = /* @__PURE__ */ (function(Ai) {
                    function _i() {
                      var Po;
                      return Cm(this, _i), Po = bv(this, _i, ["0"]), Po.iovs = {}, Po.pendingRemoval = {}, Po;
                    }
                    return Fy(_i, Ai), Ny(_i, [{
                      key: "create",
                      value: function() {
                        var Gi = this, na = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ta = Sv;
                        Sv++, this.logger.info("Creating Iov ".concat(ta));
                        var Fo = Pm.factory("iov:".concat(ta), ta, na);
                        return this.logger.info("Created Iov ".concat(ta)), Fo.on(Pm.events.IFRAME_DESTROYED_EXTERNALLY, /* @__PURE__ */ mf(/* @__PURE__ */ Qf().mark(function Wa() {
                          return Qf().wrap(function(wa) {
                            for (; ; ) switch (wa.prev = wa.next) {
                              case 0:
                                return Fo.logger.info("IovCollection: iframe was destroyed, removing iov..."), wa.prev = 1, wa.next = 4, Gi.remove(Fo.id);
                              case 4:
                                wa.next = 10;
                                break;
                              case 6:
                                wa.prev = 6, wa.t0 = wa.catch(1), Fo.logger.error("IovCollection: error while removing iov from collection!"), Fo.logger.error(wa.t0);
                              case 10:
                              case "end":
                                return wa.stop();
                            }
                          }, Wa, null, [[1, 6]]);
                        }))), this.add(Fo), Fo;
                      }
                      /**
                       * Add an Iov instance to this collection.  It can then be accessed by its id.
                       *
                       * @param {Iov} iov
                       *   The iov instance to add
                       *
                       * @returns {this}
                       */
                    }, {
                      key: "add",
                      value: function(Gi) {
                        var na = Gi.id;
                        if (Di()(na))
                          throw new Error("Tried to add Iov without id");
                        if (this.has(na))
                          throw new Error("Cannot add an Iov with a previously-used id");
                        return this.logger.info("Adding Iov ".concat(na)), this.iovs[na] = Gi, this;
                      }
                      /**
                       * Determine whether or not an iov with the passed id exists in this
                       * collection.
                       *
                       * @param {String} id
                       *   The id of the iov to find
                       *
                       * @returns {Boolean}
                       *   True if the iov with the given id exists
                       *   False if the iov with the given id does not exist
                       */
                    }, {
                      key: "has",
                      value: function(Gi) {
                        return Di()(Gi) || this.pendingRemoval[Gi] ? !1 : Object.prototype.hasOwnProperty.call(this.iovs, Gi);
                      }
                      /**
                       * Get an iov with the passed id from this collection.
                       *
                       * @param {String} id
                       *   The id of the iov instance to get
                       *
                       * @returns {Iov|null}
                       *   If an iov with this id doest not exist, undefined is returned.
                       */
                    }, {
                      key: "get",
                      value: function(Gi) {
                        return this.has(Gi) ? this.iovs[Gi] : null;
                      }
                      /**
                       * Remove an iov instance from this collection and destroy it.
                       *
                       * @param {String} id
                       *   The id of the iov to remove and destroy
                       *
                       * @returns {this}
                       */
                    }, {
                      key: "remove",
                      value: (function() {
                        var Po = mf(/* @__PURE__ */ Qf().mark(function na(ta) {
                          var Fo;
                          return Qf().wrap(function(Va) {
                            for (; ; ) switch (Va.prev = Va.next) {
                              case 0:
                                if (Fo = this.get(ta), Fo !== null) {
                                  Va.next = 3;
                                  break;
                                }
                                return Va.abrupt("return");
                              case 3:
                                return Va.prev = 3, this.pendingRemoval[ta] = !0, delete this.iovs[ta], Fo.logger.info("IovCollection - removing iov..."), Va.next = 9, Fo.destroy();
                              case 9:
                                Va.next = 15;
                                break;
                              case 11:
                                Va.prev = 11, Va.t0 = Va.catch(3), this.logger.error("Error destroying Iov ".concat(ta, " while removing")), this.logger.error(Va.t0);
                              case 15:
                                return delete this.pendingRemoval[ta], Va.abrupt("return", this);
                              case 17:
                              case "end":
                                return Va.stop();
                            }
                          }, na, this, [[3, 11]]);
                        }));
                        function Gi(na) {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "_destroy",
                      value: (function() {
                        var Po = mf(/* @__PURE__ */ Qf().mark(function na() {
                          var ta;
                          return Qf().wrap(function(Wa) {
                            for (; ; ) switch (Wa.prev = Wa.next) {
                              case 0:
                                Wa.t0 = Qf().keys(this.iovs);
                              case 1:
                                if ((Wa.t1 = Wa.t0()).done) {
                                  Wa.next = 14;
                                  break;
                                }
                                return ta = Wa.t1.value, Wa.prev = 3, Wa.next = 6, this.remove(ta);
                              case 6:
                                Wa.next = 12;
                                break;
                              case 8:
                                Wa.prev = 8, Wa.t2 = Wa.catch(3), this.logger.error("Error while removing IOV ".concat(ta, " while destroying")), this.logger.error(Wa.t2);
                              case 12:
                                Wa.next = 1;
                                break;
                              case 14:
                                return this.iovs = null, this.pendingRemoval = null, Wa.next = 18, Ev(_i, "_destroy", this, 3)([]);
                              case 18:
                              case "end":
                                return Wa.stop();
                            }
                          }, na, this, [[3, 8]]);
                        }));
                        function Gi() {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }], [{
                      key: "asSingleton",
                      value: function() {
                        return Am || (Am = _i.factory()), Am;
                      }
                      /**
                       * @private
                       */
                    }, {
                      key: "factory",
                      value: function() {
                        return new _i();
                      }
                    }]);
                  })(Hi), xv = oi(478), Md = /* @__PURE__ */ oi.n(xv);
                  function kf(Ai) {
                    "@babel/helpers - typeof";
                    return kf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(_i) {
                      return typeof _i;
                    } : function(_i) {
                      return _i && typeof Symbol == "function" && _i.constructor === Symbol && _i !== Symbol.prototype ? "symbol" : typeof _i;
                    }, kf(Ai);
                  }
                  function Mg() {
                    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
                    Mg = function() {
                      return _i;
                    };
                    var Ai, _i = {}, Po = Object.prototype, Gi = Po.hasOwnProperty, na = Object.defineProperty || function(Bi, Ci, ki) {
                      Bi[Ci] = ki.value;
                    }, ta = typeof Symbol == "function" ? Symbol : {}, Fo = ta.iterator || "@@iterator", Wa = ta.asyncIterator || "@@asyncIterator", Va = ta.toStringTag || "@@toStringTag";
                    function wa(Bi, Ci, ki) {
                      return Object.defineProperty(Bi, Ci, { value: ki, enumerable: !0, configurable: !0, writable: !0 }), Bi[Ci];
                    }
                    try {
                      wa({}, "");
                    } catch {
                      wa = function(ki, Mo, Xo) {
                        return ki[Mo] = Xo;
                      };
                    }
                    function il(Bi, Ci, ki, Mo) {
                      var Xo = Ci && Ci.prototype instanceof pu ? Ci : pu, Uo = Object.create(Xo.prototype), qa = new ku(Mo || []);
                      return na(Uo, "_invoke", { value: pc(Bi, ki, qa) }), Uo;
                    }
                    function ol(Bi, Ci, ki) {
                      try {
                        return { type: "normal", arg: Bi.call(Ci, ki) };
                      } catch (Mo) {
                        return { type: "throw", arg: Mo };
                      }
                    }
                    _i.wrap = il;
                    var Ql = "suspendedStart", Uu = "suspendedYield", Wu = "executing", Kl = "completed", pl = {};
                    function pu() {
                    }
                    function lu() {
                    }
                    function Nl() {
                    }
                    var Eu = {};
                    wa(Eu, Fo, function() {
                      return this;
                    });
                    var wu = Object.getPrototypeOf, yu = wu && wu(wu(Nu([])));
                    yu && yu !== Po && Gi.call(yu, Fo) && (Eu = yu);
                    var zl = Nl.prototype = pu.prototype = Object.create(Eu);
                    function Qu(Bi) {
                      ["next", "throw", "return"].forEach(function(Ci) {
                        wa(Bi, Ci, function(ki) {
                          return this._invoke(Ci, ki);
                        });
                      });
                    }
                    function gu(Bi, Ci) {
                      function ki(Xo, Uo, qa, Us) {
                        var Hs = ol(Bi[Xo], Bi, Uo);
                        if (Hs.type !== "throw") {
                          var jl = Hs.arg, Al = jl.value;
                          return Al && kf(Al) == "object" && Gi.call(Al, "__await") ? Ci.resolve(Al.__await).then(function(Ml) {
                            ki("next", Ml, qa, Us);
                          }, function(Ml) {
                            ki("throw", Ml, qa, Us);
                          }) : Ci.resolve(Al).then(function(Ml) {
                            jl.value = Ml, qa(jl);
                          }, function(Ml) {
                            return ki("throw", Ml, qa, Us);
                          });
                        }
                        Us(Hs.arg);
                      }
                      var Mo;
                      na(this, "_invoke", { value: function(Uo, qa) {
                        function Us() {
                          return new Ci(function(Hs, jl) {
                            ki(Uo, qa, Hs, jl);
                          });
                        }
                        return Mo = Mo ? Mo.then(Us, Us) : Us();
                      } });
                    }
                    function pc(Bi, Ci, ki) {
                      var Mo = Ql;
                      return function(Xo, Uo) {
                        if (Mo === Wu) throw Error("Generator is already running");
                        if (Mo === Kl) {
                          if (Xo === "throw") throw Uo;
                          return { value: Ai, done: !0 };
                        }
                        for (ki.method = Xo, ki.arg = Uo; ; ) {
                          var qa = ki.delegate;
                          if (qa) {
                            var Us = Zu(qa, ki);
                            if (Us) {
                              if (Us === pl) continue;
                              return Us;
                            }
                          }
                          if (ki.method === "next") ki.sent = ki._sent = ki.arg;
                          else if (ki.method === "throw") {
                            if (Mo === Ql) throw Mo = Kl, ki.arg;
                            ki.dispatchException(ki.arg);
                          } else ki.method === "return" && ki.abrupt("return", ki.arg);
                          Mo = Wu;
                          var Hs = ol(Bi, Ci, ki);
                          if (Hs.type === "normal") {
                            if (Mo = ki.done ? Kl : Uu, Hs.arg === pl) continue;
                            return { value: Hs.arg, done: ki.done };
                          }
                          Hs.type === "throw" && (Mo = Kl, ki.method = "throw", ki.arg = Hs.arg);
                        }
                      };
                    }
                    function Zu(Bi, Ci) {
                      var ki = Ci.method, Mo = Bi.iterator[ki];
                      if (Mo === Ai) return Ci.delegate = null, ki === "throw" && Bi.iterator.return && (Ci.method = "return", Ci.arg = Ai, Zu(Bi, Ci), Ci.method === "throw") || ki !== "return" && (Ci.method = "throw", Ci.arg = new TypeError("The iterator does not provide a '" + ki + "' method")), pl;
                      var Xo = ol(Mo, Bi.iterator, Ci.arg);
                      if (Xo.type === "throw") return Ci.method = "throw", Ci.arg = Xo.arg, Ci.delegate = null, pl;
                      var Uo = Xo.arg;
                      return Uo ? Uo.done ? (Ci[Bi.resultName] = Uo.value, Ci.next = Bi.nextLoc, Ci.method !== "return" && (Ci.method = "next", Ci.arg = Ai), Ci.delegate = null, pl) : Uo : (Ci.method = "throw", Ci.arg = new TypeError("iterator result is not an object"), Ci.delegate = null, pl);
                    }
                    function gc(Bi) {
                      var Ci = { tryLoc: Bi[0] };
                      1 in Bi && (Ci.catchLoc = Bi[1]), 2 in Bi && (Ci.finallyLoc = Bi[2], Ci.afterLoc = Bi[3]), this.tryEntries.push(Ci);
                    }
                    function Du(Bi) {
                      var Ci = Bi.completion || {};
                      Ci.type = "normal", delete Ci.arg, Bi.completion = Ci;
                    }
                    function ku(Bi) {
                      this.tryEntries = [{ tryLoc: "root" }], Bi.forEach(gc, this), this.reset(!0);
                    }
                    function Nu(Bi) {
                      if (Bi || Bi === "") {
                        var Ci = Bi[Fo];
                        if (Ci) return Ci.call(Bi);
                        if (typeof Bi.next == "function") return Bi;
                        if (!isNaN(Bi.length)) {
                          var ki = -1, Mo = function Xo() {
                            for (; ++ki < Bi.length; ) if (Gi.call(Bi, ki)) return Xo.value = Bi[ki], Xo.done = !1, Xo;
                            return Xo.value = Ai, Xo.done = !0, Xo;
                          };
                          return Mo.next = Mo;
                        }
                      }
                      throw new TypeError(kf(Bi) + " is not iterable");
                    }
                    return lu.prototype = Nl, na(zl, "constructor", { value: Nl, configurable: !0 }), na(Nl, "constructor", { value: lu, configurable: !0 }), lu.displayName = wa(Nl, Va, "GeneratorFunction"), _i.isGeneratorFunction = function(Bi) {
                      var Ci = typeof Bi == "function" && Bi.constructor;
                      return !!Ci && (Ci === lu || (Ci.displayName || Ci.name) === "GeneratorFunction");
                    }, _i.mark = function(Bi) {
                      return Object.setPrototypeOf ? Object.setPrototypeOf(Bi, Nl) : (Bi.__proto__ = Nl, wa(Bi, Va, "GeneratorFunction")), Bi.prototype = Object.create(zl), Bi;
                    }, _i.awrap = function(Bi) {
                      return { __await: Bi };
                    }, Qu(gu.prototype), wa(gu.prototype, Wa, function() {
                      return this;
                    }), _i.AsyncIterator = gu, _i.async = function(Bi, Ci, ki, Mo, Xo) {
                      Xo === void 0 && (Xo = Promise);
                      var Uo = new gu(il(Bi, Ci, ki, Mo), Xo);
                      return _i.isGeneratorFunction(Ci) ? Uo : Uo.next().then(function(qa) {
                        return qa.done ? qa.value : Uo.next();
                      });
                    }, Qu(zl), wa(zl, Va, "Generator"), wa(zl, Fo, function() {
                      return this;
                    }), wa(zl, "toString", function() {
                      return "[object Generator]";
                    }), _i.keys = function(Bi) {
                      var Ci = Object(Bi), ki = [];
                      for (var Mo in Ci) ki.push(Mo);
                      return ki.reverse(), function Xo() {
                        for (; ki.length; ) {
                          var Uo = ki.pop();
                          if (Uo in Ci) return Xo.value = Uo, Xo.done = !1, Xo;
                        }
                        return Xo.done = !0, Xo;
                      };
                    }, _i.values = Nu, ku.prototype = { constructor: ku, reset: function(Ci) {
                      if (this.prev = 0, this.next = 0, this.sent = this._sent = Ai, this.done = !1, this.delegate = null, this.method = "next", this.arg = Ai, this.tryEntries.forEach(Du), !Ci) for (var ki in this) ki.charAt(0) === "t" && Gi.call(this, ki) && !isNaN(+ki.slice(1)) && (this[ki] = Ai);
                    }, stop: function() {
                      this.done = !0;
                      var Ci = this.tryEntries[0].completion;
                      if (Ci.type === "throw") throw Ci.arg;
                      return this.rval;
                    }, dispatchException: function(Ci) {
                      if (this.done) throw Ci;
                      var ki = this;
                      function Mo(jl, Al) {
                        return qa.type = "throw", qa.arg = Ci, ki.next = jl, Al && (ki.method = "next", ki.arg = Ai), !!Al;
                      }
                      for (var Xo = this.tryEntries.length - 1; Xo >= 0; --Xo) {
                        var Uo = this.tryEntries[Xo], qa = Uo.completion;
                        if (Uo.tryLoc === "root") return Mo("end");
                        if (Uo.tryLoc <= this.prev) {
                          var Us = Gi.call(Uo, "catchLoc"), Hs = Gi.call(Uo, "finallyLoc");
                          if (Us && Hs) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          } else if (Us) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                          } else {
                            if (!Hs) throw Error("try statement without catch or finally");
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          }
                        }
                      }
                    }, abrupt: function(Ci, ki) {
                      for (var Mo = this.tryEntries.length - 1; Mo >= 0; --Mo) {
                        var Xo = this.tryEntries[Mo];
                        if (Xo.tryLoc <= this.prev && Gi.call(Xo, "finallyLoc") && this.prev < Xo.finallyLoc) {
                          var Uo = Xo;
                          break;
                        }
                      }
                      Uo && (Ci === "break" || Ci === "continue") && Uo.tryLoc <= ki && ki <= Uo.finallyLoc && (Uo = null);
                      var qa = Uo ? Uo.completion : {};
                      return qa.type = Ci, qa.arg = ki, Uo ? (this.method = "next", this.next = Uo.finallyLoc, pl) : this.complete(qa);
                    }, complete: function(Ci, ki) {
                      if (Ci.type === "throw") throw Ci.arg;
                      return Ci.type === "break" || Ci.type === "continue" ? this.next = Ci.arg : Ci.type === "return" ? (this.rval = this.arg = Ci.arg, this.method = "return", this.next = "end") : Ci.type === "normal" && ki && (this.next = ki), pl;
                    }, finish: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.finallyLoc === Ci) return this.complete(Mo.completion, Mo.afterLoc), Du(Mo), pl;
                      }
                    }, catch: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.tryLoc === Ci) {
                          var Xo = Mo.completion;
                          if (Xo.type === "throw") {
                            var Uo = Xo.arg;
                            Du(Mo);
                          }
                          return Uo;
                        }
                      }
                      throw Error("illegal catch attempt");
                    }, delegateYield: function(Ci, ki, Mo) {
                      return this.delegate = { iterator: Nu(Ci), resultName: ki, nextLoc: Mo }, this.method === "next" && (this.arg = Ai), pl;
                    } }, _i;
                  }
                  function Uh(Ai, _i, Po, Gi, na, ta, Fo) {
                    try {
                      var Wa = Ai[ta](Fo), Va = Wa.value;
                    } catch (wa) {
                      return void Po(wa);
                    }
                    Wa.done ? _i(Va) : Promise.resolve(Va).then(Gi, na);
                  }
                  function jg(Ai) {
                    return function() {
                      var _i = this, Po = arguments;
                      return new Promise(function(Gi, na) {
                        var ta = Ai.apply(_i, Po);
                        function Fo(Va) {
                          Uh(ta, Gi, na, Fo, Wa, "next", Va);
                        }
                        function Wa(Va) {
                          Uh(ta, Gi, na, Fo, Wa, "throw", Va);
                        }
                        Fo(void 0);
                      });
                    };
                  }
                  function wv(Ai, _i) {
                    if (!(Ai instanceof _i)) throw new TypeError("Cannot call a class as a function");
                  }
                  function Fg(Ai, _i) {
                    for (var Po = 0; Po < _i.length; Po++) {
                      var Gi = _i[Po];
                      Gi.enumerable = Gi.enumerable || !1, Gi.configurable = !0, "value" in Gi && (Gi.writable = !0), Object.defineProperty(Ai, Pv(Gi.key), Gi);
                    }
                  }
                  function Vh(Ai, _i, Po) {
                    return _i && Fg(Ai.prototype, _i), Object.defineProperty(Ai, "prototype", { writable: !1 }), Ai;
                  }
                  function $m(Ai, _i, Po) {
                    return _i = Bg(_i), By(Ai, Dm() ? Reflect.construct(_i, Po || [], Bg(Ai).constructor) : _i.apply(Ai, Po));
                  }
                  function By(Ai, _i) {
                    if (_i && (kf(_i) == "object" || typeof _i == "function")) return _i;
                    if (_i !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return _v(Ai);
                  }
                  function _v(Ai) {
                    if (Ai === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return Ai;
                  }
                  function Dm() {
                    try {
                      var Ai = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                      }));
                    } catch {
                    }
                    return (Dm = function() {
                      return !!Ai;
                    })();
                  }
                  function Bg(Ai) {
                    return Bg = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(_i) {
                      return _i.__proto__ || Object.getPrototypeOf(_i);
                    }, Bg(Ai);
                  }
                  function Uy(Ai, _i) {
                    if (typeof _i != "function" && _i !== null) throw new TypeError("Super expression must either be null or a function");
                    Ai.prototype = Object.create(_i && _i.prototype, { constructor: { value: Ai, writable: !0, configurable: !0 } }), Object.defineProperty(Ai, "prototype", { writable: !1 }), _i && km(Ai, _i);
                  }
                  function km(Ai, _i) {
                    return km = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(Po, Gi) {
                      return Po.__proto__ = Gi, Po;
                    }, km(Ai, _i);
                  }
                  function Vy(Ai, _i, Po) {
                    return (_i = Pv(_i)) in Ai ? Object.defineProperty(Ai, _i, { value: Po, enumerable: !0, configurable: !0, writable: !0 }) : Ai[_i] = Po, Ai;
                  }
                  function Pv(Ai) {
                    var _i = Wy(Ai, "string");
                    return kf(_i) == "symbol" ? _i : _i + "";
                  }
                  function Wy(Ai, _i) {
                    if (kf(Ai) != "object" || !Ai) return Ai;
                    var Po = Ai[Symbol.toPrimitive];
                    if (Po !== void 0) {
                      var Gi = Po.call(Ai, _i);
                      if (kf(Gi) != "object") return Gi;
                      throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(Ai);
                  }
                  var Gy = di().getComponent("Component"), Hy = 5, zy = /* @__PURE__ */ (function(Ai) {
                    function _i(Po, Gi, na) {
                      var ta;
                      return wv(this, _i), ta = $m(this, _i, [Gi, na.clsp]), Vy(ta, "onChangeSource", function(Fo, Wa) {
                        var Va = Wa.url;
                        if (ta.logger.debug('changeSource on player "'.concat(ta.id, '""')), !Va)
                          throw new Error("Unable to change source because there is no url!");
                        ta.iov.changeSrc(Va);
                      }), ta.logger = Md().Logger().factory("ClspHandler"), ta.logger.debug("constructor"), ta.tech_ = Gi, ta.source_ = Po, ta.changeSourceMaxWait = (na.changeSourceMaxWait || Hy) * 1e3, ta.iov = null, ta.player = null, ta;
                    }
                    return Uy(_i, Ai), Vh(_i, [{
                      key: "createIov",
                      value: (function() {
                        var Po = jg(/* @__PURE__ */ Mg().mark(function na(ta) {
                          var Fo = this, Wa, Va, wa, il, ol, Ql, Uu;
                          return Mg().wrap(function(Kl) {
                            for (; ; ) switch (Kl.prev = Kl.next) {
                              case 0:
                                return this.logger.debug("createIov"), this.player = ta, Wa = "clsp-video-".concat($i()), Va = this.player.el().firstChild, wa = Va.parentNode, il = wa.id, ol = Va.cloneNode(), ol.setAttribute("id", Wa), wa.insertBefore(ol, Va), Ql = Im.asSingleton(), Kl.next = 12, Ql.create({
                                  videoElement: Va,
                                  videoElementId: Wa,
                                  containerElement: wa,
                                  containerElementId: il
                                });
                              case 12:
                                Uu = Kl.sent, this.player.ready(function() {
                                  if (Fo.onReadyAlreadyCalled) {
                                    Fo.logger.warn("tried to use this player more than once...");
                                    return;
                                  }
                                  Fo.onReadyAlreadyCalled = !0;
                                  var pl = Fo.player.children()[0];
                                  Uu.on("firstFrameShown", function() {
                                    Fo.player.trigger("firstFrameShown"), pl.style.display = "none";
                                  }), Uu.on("videoReceived", function() {
                                    Fo.player.trigger("timeupdate");
                                  }), Uu.on("videoInfoReceived", function() {
                                    Fo.player.trigger("timeupdate");
                                  }), Fo.player.on("changesrc", Fo.onChangeSource);
                                }), this.updateIov(Uu);
                              // @todo - is this functionality needed?  if not, remove this commented
                              // block.  also, this particular event is on the iovPlayer, not the iov
                              // this.iov.on('unsupportedMimeCodec', (error) => {
                              //   this.videoPlayer.errors.extend({
                              //     PLAYER_ERR_Iov: {
                              //       headline: 'Error Playing Stream',
                              //       message: error,
                              //     },
                              //   });
                              //   this.videoPlayer.error({
                              //     code: 'PLAYER_ERR_Iov',
                              //   });
                              // });
                              case 15:
                              case "end":
                                return Kl.stop();
                            }
                          }, na, this);
                        }));
                        function Gi(na) {
                          return Po.apply(this, arguments);
                        }
                        return Gi;
                      })()
                    }, {
                      key: "updateIov",
                      value: function(Gi) {
                        if (this.logger.debug("updateIov"), this.iov) {
                          if (this.iov.id === Gi.id)
                            return;
                          Im.asSingleton().remove(this.iov.id).add(Gi.id, Gi);
                        }
                        this.iov = Gi;
                      }
                    }, {
                      key: "destroy",
                      value: function() {
                        this.logger.debug("destroy"), !this.destroyed && (this.destroyed = !0, this.onReadyAlreadyCalled && this.player.off("changesrc", this.onChangeSource), Im.asSingleton().remove(this.iov.id), this.iov = null, this.player = null);
                      }
                    }]);
                  })(Gy);
                  function fg() {
                    var Ai = Md().Logger().factory("ClspSourceHandler");
                    return function(_i) {
                      var Po = {
                        canHandleSource: function(na) {
                          return Ai.debug("canHandleSource"), na.src ? na.src.startsWith("clsp") ? Po.canPlayType(na.type) : (Ai.debug("srcObj.src is not clsp protocol"), !1) : (Ai.debug("srcObj doesn't contain src"), !1);
                        },
                        handleSource: function(na, ta) {
                          var Fo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                          Ai.debug("handleSource");
                          var Wa = di().mergeOptions(di().options, Fo, {
                            clsp: {
                              mode: _i
                            }
                          });
                          return ta.clsp = new zy(na, ta, Wa), ta.clsp;
                        },
                        canPlayType: function(na) {
                          return Ai.debug("canPlayType"), Md().isSupportedMimeType(na) ? "maybe" : (console.error("clsp type='".concat(na, "' rejected")), "");
                        }
                      };
                      return Po;
                    };
                  }
                  function Lp(Ai) {
                    "@babel/helpers - typeof";
                    return Lp = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(_i) {
                      return typeof _i;
                    } : function(_i) {
                      return _i && typeof Symbol == "function" && _i.constructor === Symbol && _i !== Symbol.prototype ? "symbol" : typeof _i;
                    }, Lp(Ai);
                  }
                  function Cv(Ai, _i) {
                    var Po = Object.keys(Ai);
                    if (Object.getOwnPropertySymbols) {
                      var Gi = Object.getOwnPropertySymbols(Ai);
                      _i && (Gi = Gi.filter(function(na) {
                        return Object.getOwnPropertyDescriptor(Ai, na).enumerable;
                      })), Po.push.apply(Po, Gi);
                    }
                    return Po;
                  }
                  function Rv(Ai) {
                    for (var _i = 1; _i < arguments.length; _i++) {
                      var Po = arguments[_i] != null ? arguments[_i] : {};
                      _i % 2 ? Cv(Object(Po), !0).forEach(function(Gi) {
                        sh(Ai, Gi, Po[Gi]);
                      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Ai, Object.getOwnPropertyDescriptors(Po)) : Cv(Object(Po)).forEach(function(Gi) {
                        Object.defineProperty(Ai, Gi, Object.getOwnPropertyDescriptor(Po, Gi));
                      });
                    }
                    return Ai;
                  }
                  function Nf() {
                    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
                    Nf = function() {
                      return _i;
                    };
                    var Ai, _i = {}, Po = Object.prototype, Gi = Po.hasOwnProperty, na = Object.defineProperty || function(Bi, Ci, ki) {
                      Bi[Ci] = ki.value;
                    }, ta = typeof Symbol == "function" ? Symbol : {}, Fo = ta.iterator || "@@iterator", Wa = ta.asyncIterator || "@@asyncIterator", Va = ta.toStringTag || "@@toStringTag";
                    function wa(Bi, Ci, ki) {
                      return Object.defineProperty(Bi, Ci, { value: ki, enumerable: !0, configurable: !0, writable: !0 }), Bi[Ci];
                    }
                    try {
                      wa({}, "");
                    } catch {
                      wa = function(ki, Mo, Xo) {
                        return ki[Mo] = Xo;
                      };
                    }
                    function il(Bi, Ci, ki, Mo) {
                      var Xo = Ci && Ci.prototype instanceof pu ? Ci : pu, Uo = Object.create(Xo.prototype), qa = new ku(Mo || []);
                      return na(Uo, "_invoke", { value: pc(Bi, ki, qa) }), Uo;
                    }
                    function ol(Bi, Ci, ki) {
                      try {
                        return { type: "normal", arg: Bi.call(Ci, ki) };
                      } catch (Mo) {
                        return { type: "throw", arg: Mo };
                      }
                    }
                    _i.wrap = il;
                    var Ql = "suspendedStart", Uu = "suspendedYield", Wu = "executing", Kl = "completed", pl = {};
                    function pu() {
                    }
                    function lu() {
                    }
                    function Nl() {
                    }
                    var Eu = {};
                    wa(Eu, Fo, function() {
                      return this;
                    });
                    var wu = Object.getPrototypeOf, yu = wu && wu(wu(Nu([])));
                    yu && yu !== Po && Gi.call(yu, Fo) && (Eu = yu);
                    var zl = Nl.prototype = pu.prototype = Object.create(Eu);
                    function Qu(Bi) {
                      ["next", "throw", "return"].forEach(function(Ci) {
                        wa(Bi, Ci, function(ki) {
                          return this._invoke(Ci, ki);
                        });
                      });
                    }
                    function gu(Bi, Ci) {
                      function ki(Xo, Uo, qa, Us) {
                        var Hs = ol(Bi[Xo], Bi, Uo);
                        if (Hs.type !== "throw") {
                          var jl = Hs.arg, Al = jl.value;
                          return Al && Lp(Al) == "object" && Gi.call(Al, "__await") ? Ci.resolve(Al.__await).then(function(Ml) {
                            ki("next", Ml, qa, Us);
                          }, function(Ml) {
                            ki("throw", Ml, qa, Us);
                          }) : Ci.resolve(Al).then(function(Ml) {
                            jl.value = Ml, qa(jl);
                          }, function(Ml) {
                            return ki("throw", Ml, qa, Us);
                          });
                        }
                        Us(Hs.arg);
                      }
                      var Mo;
                      na(this, "_invoke", { value: function(Uo, qa) {
                        function Us() {
                          return new Ci(function(Hs, jl) {
                            ki(Uo, qa, Hs, jl);
                          });
                        }
                        return Mo = Mo ? Mo.then(Us, Us) : Us();
                      } });
                    }
                    function pc(Bi, Ci, ki) {
                      var Mo = Ql;
                      return function(Xo, Uo) {
                        if (Mo === Wu) throw Error("Generator is already running");
                        if (Mo === Kl) {
                          if (Xo === "throw") throw Uo;
                          return { value: Ai, done: !0 };
                        }
                        for (ki.method = Xo, ki.arg = Uo; ; ) {
                          var qa = ki.delegate;
                          if (qa) {
                            var Us = Zu(qa, ki);
                            if (Us) {
                              if (Us === pl) continue;
                              return Us;
                            }
                          }
                          if (ki.method === "next") ki.sent = ki._sent = ki.arg;
                          else if (ki.method === "throw") {
                            if (Mo === Ql) throw Mo = Kl, ki.arg;
                            ki.dispatchException(ki.arg);
                          } else ki.method === "return" && ki.abrupt("return", ki.arg);
                          Mo = Wu;
                          var Hs = ol(Bi, Ci, ki);
                          if (Hs.type === "normal") {
                            if (Mo = ki.done ? Kl : Uu, Hs.arg === pl) continue;
                            return { value: Hs.arg, done: ki.done };
                          }
                          Hs.type === "throw" && (Mo = Kl, ki.method = "throw", ki.arg = Hs.arg);
                        }
                      };
                    }
                    function Zu(Bi, Ci) {
                      var ki = Ci.method, Mo = Bi.iterator[ki];
                      if (Mo === Ai) return Ci.delegate = null, ki === "throw" && Bi.iterator.return && (Ci.method = "return", Ci.arg = Ai, Zu(Bi, Ci), Ci.method === "throw") || ki !== "return" && (Ci.method = "throw", Ci.arg = new TypeError("The iterator does not provide a '" + ki + "' method")), pl;
                      var Xo = ol(Mo, Bi.iterator, Ci.arg);
                      if (Xo.type === "throw") return Ci.method = "throw", Ci.arg = Xo.arg, Ci.delegate = null, pl;
                      var Uo = Xo.arg;
                      return Uo ? Uo.done ? (Ci[Bi.resultName] = Uo.value, Ci.next = Bi.nextLoc, Ci.method !== "return" && (Ci.method = "next", Ci.arg = Ai), Ci.delegate = null, pl) : Uo : (Ci.method = "throw", Ci.arg = new TypeError("iterator result is not an object"), Ci.delegate = null, pl);
                    }
                    function gc(Bi) {
                      var Ci = { tryLoc: Bi[0] };
                      1 in Bi && (Ci.catchLoc = Bi[1]), 2 in Bi && (Ci.finallyLoc = Bi[2], Ci.afterLoc = Bi[3]), this.tryEntries.push(Ci);
                    }
                    function Du(Bi) {
                      var Ci = Bi.completion || {};
                      Ci.type = "normal", delete Ci.arg, Bi.completion = Ci;
                    }
                    function ku(Bi) {
                      this.tryEntries = [{ tryLoc: "root" }], Bi.forEach(gc, this), this.reset(!0);
                    }
                    function Nu(Bi) {
                      if (Bi || Bi === "") {
                        var Ci = Bi[Fo];
                        if (Ci) return Ci.call(Bi);
                        if (typeof Bi.next == "function") return Bi;
                        if (!isNaN(Bi.length)) {
                          var ki = -1, Mo = function Xo() {
                            for (; ++ki < Bi.length; ) if (Gi.call(Bi, ki)) return Xo.value = Bi[ki], Xo.done = !1, Xo;
                            return Xo.value = Ai, Xo.done = !0, Xo;
                          };
                          return Mo.next = Mo;
                        }
                      }
                      throw new TypeError(Lp(Bi) + " is not iterable");
                    }
                    return lu.prototype = Nl, na(zl, "constructor", { value: Nl, configurable: !0 }), na(Nl, "constructor", { value: lu, configurable: !0 }), lu.displayName = wa(Nl, Va, "GeneratorFunction"), _i.isGeneratorFunction = function(Bi) {
                      var Ci = typeof Bi == "function" && Bi.constructor;
                      return !!Ci && (Ci === lu || (Ci.displayName || Ci.name) === "GeneratorFunction");
                    }, _i.mark = function(Bi) {
                      return Object.setPrototypeOf ? Object.setPrototypeOf(Bi, Nl) : (Bi.__proto__ = Nl, wa(Bi, Va, "GeneratorFunction")), Bi.prototype = Object.create(zl), Bi;
                    }, _i.awrap = function(Bi) {
                      return { __await: Bi };
                    }, Qu(gu.prototype), wa(gu.prototype, Wa, function() {
                      return this;
                    }), _i.AsyncIterator = gu, _i.async = function(Bi, Ci, ki, Mo, Xo) {
                      Xo === void 0 && (Xo = Promise);
                      var Uo = new gu(il(Bi, Ci, ki, Mo), Xo);
                      return _i.isGeneratorFunction(Ci) ? Uo : Uo.next().then(function(qa) {
                        return qa.done ? qa.value : Uo.next();
                      });
                    }, Qu(zl), wa(zl, Va, "Generator"), wa(zl, Fo, function() {
                      return this;
                    }), wa(zl, "toString", function() {
                      return "[object Generator]";
                    }), _i.keys = function(Bi) {
                      var Ci = Object(Bi), ki = [];
                      for (var Mo in Ci) ki.push(Mo);
                      return ki.reverse(), function Xo() {
                        for (; ki.length; ) {
                          var Uo = ki.pop();
                          if (Uo in Ci) return Xo.value = Uo, Xo.done = !1, Xo;
                        }
                        return Xo.done = !0, Xo;
                      };
                    }, _i.values = Nu, ku.prototype = { constructor: ku, reset: function(Ci) {
                      if (this.prev = 0, this.next = 0, this.sent = this._sent = Ai, this.done = !1, this.delegate = null, this.method = "next", this.arg = Ai, this.tryEntries.forEach(Du), !Ci) for (var ki in this) ki.charAt(0) === "t" && Gi.call(this, ki) && !isNaN(+ki.slice(1)) && (this[ki] = Ai);
                    }, stop: function() {
                      this.done = !0;
                      var Ci = this.tryEntries[0].completion;
                      if (Ci.type === "throw") throw Ci.arg;
                      return this.rval;
                    }, dispatchException: function(Ci) {
                      if (this.done) throw Ci;
                      var ki = this;
                      function Mo(jl, Al) {
                        return qa.type = "throw", qa.arg = Ci, ki.next = jl, Al && (ki.method = "next", ki.arg = Ai), !!Al;
                      }
                      for (var Xo = this.tryEntries.length - 1; Xo >= 0; --Xo) {
                        var Uo = this.tryEntries[Xo], qa = Uo.completion;
                        if (Uo.tryLoc === "root") return Mo("end");
                        if (Uo.tryLoc <= this.prev) {
                          var Us = Gi.call(Uo, "catchLoc"), Hs = Gi.call(Uo, "finallyLoc");
                          if (Us && Hs) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          } else if (Us) {
                            if (this.prev < Uo.catchLoc) return Mo(Uo.catchLoc, !0);
                          } else {
                            if (!Hs) throw Error("try statement without catch or finally");
                            if (this.prev < Uo.finallyLoc) return Mo(Uo.finallyLoc);
                          }
                        }
                      }
                    }, abrupt: function(Ci, ki) {
                      for (var Mo = this.tryEntries.length - 1; Mo >= 0; --Mo) {
                        var Xo = this.tryEntries[Mo];
                        if (Xo.tryLoc <= this.prev && Gi.call(Xo, "finallyLoc") && this.prev < Xo.finallyLoc) {
                          var Uo = Xo;
                          break;
                        }
                      }
                      Uo && (Ci === "break" || Ci === "continue") && Uo.tryLoc <= ki && ki <= Uo.finallyLoc && (Uo = null);
                      var qa = Uo ? Uo.completion : {};
                      return qa.type = Ci, qa.arg = ki, Uo ? (this.method = "next", this.next = Uo.finallyLoc, pl) : this.complete(qa);
                    }, complete: function(Ci, ki) {
                      if (Ci.type === "throw") throw Ci.arg;
                      return Ci.type === "break" || Ci.type === "continue" ? this.next = Ci.arg : Ci.type === "return" ? (this.rval = this.arg = Ci.arg, this.method = "return", this.next = "end") : Ci.type === "normal" && ki && (this.next = ki), pl;
                    }, finish: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.finallyLoc === Ci) return this.complete(Mo.completion, Mo.afterLoc), Du(Mo), pl;
                      }
                    }, catch: function(Ci) {
                      for (var ki = this.tryEntries.length - 1; ki >= 0; --ki) {
                        var Mo = this.tryEntries[ki];
                        if (Mo.tryLoc === Ci) {
                          var Xo = Mo.completion;
                          if (Xo.type === "throw") {
                            var Uo = Xo.arg;
                            Du(Mo);
                          }
                          return Uo;
                        }
                      }
                      throw Error("illegal catch attempt");
                    }, delegateYield: function(Ci, ki, Mo) {
                      return this.delegate = { iterator: Nu(Ci), resultName: ki, nextLoc: Mo }, this.method === "next" && (this.arg = Ai), pl;
                    } }, _i;
                  }
                  function Ov(Ai, _i, Po, Gi, na, ta, Fo) {
                    try {
                      var Wa = Ai[ta](Fo), Va = Wa.value;
                    } catch (wa) {
                      return void Po(wa);
                    }
                    Wa.done ? _i(Va) : Promise.resolve(Va).then(Gi, na);
                  }
                  function Wh(Ai) {
                    return function() {
                      var _i = this, Po = arguments;
                      return new Promise(function(Gi, na) {
                        var ta = Ai.apply(_i, Po);
                        function Fo(Va) {
                          Ov(ta, Gi, na, Fo, Wa, "next", Va);
                        }
                        function Wa(Va) {
                          Ov(ta, Gi, na, Fo, Wa, "throw", Va);
                        }
                        Fo(void 0);
                      });
                    };
                  }
                  function Ky(Ai, _i) {
                    if (!(Ai instanceof _i)) throw new TypeError("Cannot call a class as a function");
                  }
                  function Gh(Ai, _i) {
                    for (var Po = 0; Po < _i.length; Po++) {
                      var Gi = _i[Po];
                      Gi.enumerable = Gi.enumerable || !1, Gi.configurable = !0, "value" in Gi && (Gi.writable = !0), Object.defineProperty(Ai, Dv(Gi.key), Gi);
                    }
                  }
                  function qy(Ai, _i, Po) {
                    return _i && Gh(Ai.prototype, _i), Po && Gh(Ai, Po), Object.defineProperty(Ai, "prototype", { writable: !1 }), Ai;
                  }
                  function Av(Ai, _i, Po) {
                    return _i = pp(_i), pg(Ai, Iv() ? Reflect.construct(_i, Po || [], pp(Ai).constructor) : _i.apply(Ai, Po));
                  }
                  function pg(Ai, _i) {
                    if (_i && (Lp(_i) == "object" || typeof _i == "function")) return _i;
                    if (_i !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                    return Yy(Ai);
                  }
                  function Yy(Ai) {
                    if (Ai === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return Ai;
                  }
                  function Iv() {
                    try {
                      var Ai = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                      }));
                    } catch {
                    }
                    return (Iv = function() {
                      return !!Ai;
                    })();
                  }
                  function pp(Ai) {
                    return pp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(_i) {
                      return _i.__proto__ || Object.getPrototypeOf(_i);
                    }, pp(Ai);
                  }
                  function $v(Ai, _i) {
                    if (typeof _i != "function" && _i !== null) throw new TypeError("Super expression must either be null or a function");
                    Ai.prototype = Object.create(_i && _i.prototype, { constructor: { value: Ai, writable: !0, configurable: !0 } }), Object.defineProperty(Ai, "prototype", { writable: !1 }), _i && Nm(Ai, _i);
                  }
                  function Nm(Ai, _i) {
                    return Nm = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(Po, Gi) {
                      return Po.__proto__ = Gi, Po;
                    }, Nm(Ai, _i);
                  }
                  function sh(Ai, _i, Po) {
                    return (_i = Dv(_i)) in Ai ? Object.defineProperty(Ai, _i, { value: Po, enumerable: !0, configurable: !0, writable: !0 }) : Ai[_i] = Po, Ai;
                  }
                  function Dv(Ai) {
                    var _i = kv(Ai, "string");
                    return Lp(_i) == "symbol" ? _i : _i + "";
                  }
                  function kv(Ai, _i) {
                    if (Lp(Ai) != "object" || !Ai) return Ai;
                    var Po = Ai[Symbol.toPrimitive];
                    if (Po !== void 0) {
                      var Gi = Po.call(Ai, _i);
                      if (Lp(Gi) != "object") return Gi;
                      throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (_i === "string" ? String : Number)(Ai);
                  }
                  var Xy = di().getPlugin("plugin"), Ug = 1, hp = 20, Nv = Md().Logger().factory("videojs-clsp"), Jy = 0;
                  const Lm = (function() {
                    var Ai, _i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                    return Ai = /* @__PURE__ */ (function(Po) {
                      function Gi(na, ta) {
                        var Fo;
                        Ky(this, Gi), Fo = Av(this, Gi, [na, ta]), sh(Fo, "onVisibilityChange", function() {
                          if (Fo.logger.debug("tab visibility changed..."), document[Md().windowStateNames.hiddenStateName]) {
                            Fo.visibilityChangeInterval = setInterval(/* @__PURE__ */ Wh(/* @__PURE__ */ Nf().mark(function wa() {
                              return Nf().wrap(function(ol) {
                                for (; ; ) switch (ol.prev = ol.next) {
                                  case 0:
                                    Fo.logger.debug("updating time..."), Fo.player.trigger("timeupdate");
                                  case 2:
                                  case "end":
                                    return ol.stop();
                                }
                              }, wa);
                            })), 2e3);
                            return;
                          }
                          Fo.visibilityChangeInterval && clearInterval(Fo.visibilityChangeInterval);
                        }), sh(Fo, "onClspHandlerError", function() {
                          Fo.logger.debug("handling CLSP error...");
                          var wa = Fo.getClspHandler();
                          wa.destroy(), Fo.player.error({
                            // @todo - change the code to 'INSUFFICIENT_RESOURCES'
                            code: 0,
                            type: "INSUFFICIENT_RESOURCES",
                            headline: "Insufficient Resources",
                            message: "The current hardware cannot support the current number of playing streams."
                          });
                        }), Fo.id = ++Jy, Fo.logger = Md().Logger().factory("CLSP VideoJS Plugin ".concat(Fo.id)), Fo.logger.debug("creating plugin instance");
                        var Wa = na.options_;
                        if (Fo.options = di().mergeOptions(Rv({}, Fo.constructor.getDefaultOptions(), {}, _i, {}, Wa.clsp || {}), ta), Fo._playerOptions = Wa, Fo.currentSourceIndex = 0, na.addClass("vjs-clsp"), Fo.options.customClass && na.addClass(Fo.options.customClass), Fo.resetErrors(na), !Md().supported())
                          return pg(Fo, na.error({
                            code: "PLAYER_ERR_NOT_COMPAT",
                            type: "PLAYER_ERR_NOT_COMPAT",
                            dismiss: !1
                          }));
                        Fo.autoplayEnabled = Wa.autoplay || na.getAttribute("autoplay") === "true", na._errorRetriesCount = 0, na._currentTime = Ug, na.currentTime = function() {
                          return na._currentTime > hp ? na._currentTime = Ug : na._currentTime++, na._currentTime;
                        }, na.on("ready", function() {
                          Fo.logger.debug("the player is ready"), Fo.autoplayEnabled && setTimeout(function() {
                            na.play();
                          });
                        }), na.on("error", /* @__PURE__ */ (function() {
                          var wa = Wh(/* @__PURE__ */ Nf().mark(function il(ol) {
                            var Ql, Uu;
                            return Nf().wrap(function(Kl) {
                              for (; ; ) switch (Kl.prev = Kl.next) {
                                case 0:
                                  Fo.logger.debug("the player encountered an error"), Ql = /* @__PURE__ */ (function() {
                                    var pl = Wh(/* @__PURE__ */ Nf().mark(function pu() {
                                      var lu;
                                      return Nf().wrap(function(Eu) {
                                        for (; ; ) switch (Eu.prev = Eu.next) {
                                          case 0:
                                            if (Fo.logger.debug("retrying due to error"), Fo.options.maxRetriesOnError !== 0) {
                                              Eu.next = 3;
                                              break;
                                            }
                                            return Eu.abrupt("return");
                                          case 3:
                                            if (!(Fo.options.maxRetriesOnError < 0 || na._errorRetriesCount <= Fo.options.maxRetriesOnError)) {
                                              Eu.next = 14;
                                              break;
                                            }
                                            if (na._errorRetriesCount++, Fo.resetErrors(na), lu = Fo.getIov(), !(!lu || lu.destroyed)) {
                                              Eu.next = 12;
                                              break;
                                            }
                                            return Eu.next = 10, Fo.initializeIov(na);
                                          case 10:
                                            Eu.next = 14;
                                            break;
                                          case 12:
                                            return Eu.next = 14, lu.restart();
                                          case 14:
                                          case "end":
                                            return Eu.stop();
                                        }
                                      }, pu);
                                    }));
                                    return function() {
                                      return pl.apply(this, arguments);
                                    };
                                  })(), Uu = na.error(), Kl.t0 = Uu.code, Kl.next = Kl.t0 === -2 ? 6 : Kl.t0 === 0 || Kl.t0 === 4 || Kl.t0 === 5 || Kl.t0 === "PLAYER_ERR_Iov" ? 7 : 8;
                                  break;
                                case 6:
                                  return Kl.abrupt("return", Ql());
                                case 7:
                                  return Kl.abrupt("break", 9);
                                case 8:
                                  return Kl.abrupt("return", Ql());
                                case 9:
                                case "end":
                                  return Kl.stop();
                              }
                            }, il);
                          }));
                          return function(il) {
                            return wa.apply(this, arguments);
                          };
                        })()), na.on("play", /* @__PURE__ */ Wh(/* @__PURE__ */ Nf().mark(function wa() {
                          return Nf().wrap(function(ol) {
                            for (; ; ) switch (ol.prev = ol.next) {
                              case 0:
                                return Fo.logger.debug("on player play event"), ol.next = 3, Fo.initializeIov(na);
                              case 3:
                              case "end":
                                return ol.stop();
                            }
                          }, wa);
                        }))), na.on("stop", function() {
                          Fo.logger.debug("on player stop event"), Fo.player.pause(), Fo.getIov().stop();
                        }), na.on("dispose", function() {
                          Fo.logger.debug("on dispose stop event"), Fo.destroy(na);
                        });
                        var Va = Md().windowStateNames.visibilityChangeEventName;
                        return Va && document.addEventListener(Va, Fo.onVisibilityChange, !1), Fo;
                      }
                      return $v(Gi, Po), qy(Gi, [{
                        key: "getVideojsErrorsOptions",
                        value: function() {
                          return this.logger.debug("getting videojs errors options..."), Rv({
                            timeout: 120 * 1e3,
                            errors: {
                              PLAYER_ERR_NOT_COMPAT: {
                                type: "PLAYER_ERR_NOT_COMPAT",
                                headline: "This browser is unsupported.",
                                message: "Chrome ".concat(Md().MINIMUM_CHROME_VERSION, " or greater is required.")
                              }
                            }
                          }, this.options.videojsErrorsOptions);
                        }
                      }, {
                        key: "resetErrors",
                        value: function(ta) {
                          this.logger.debug("resetting errors..."), ta.error(null), ta.errorDisplay.close(), ta.errors && ta.errors(this.getVideojsErrorsOptions());
                        }
                      }, {
                        key: "getClspHandler",
                        value: function() {
                          var ta = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.player;
                          return this.logger.debug("getting CLSP handler Iov..."), ta.tech(!0).clsp;
                        }
                      }, {
                        key: "getIov",
                        value: function() {
                          return this.logger.debug("getting Iov..."), this.getClspHandler().iov;
                        }
                      }, {
                        key: "initializeIov",
                        value: (function() {
                          var na = Wh(/* @__PURE__ */ Nf().mark(function Fo(Wa) {
                            var Va = this, wa, il;
                            return Nf().wrap(function(Ql) {
                              for (; ; ) switch (Ql.prev = Ql.next) {
                                case 0:
                                  if (this.logger.debug("initializing Iov..."), wa = this.getClspHandler(), wa) {
                                    Ql.next = 4;
                                    break;
                                  }
                                  throw new Error("VideoJS Player ".concat(Wa.id(), " does not have CLSP tech!"));
                                case 4:
                                  return wa.off("error", this.onClspHandlerError), wa.on("error", this.onClspHandlerError), Ql.next = 8, wa.createIov(Wa);
                                case 8:
                                  return il = this.getIov(), il.ENABLE_METRICS = this.options.enableMetrics, this.logger.debug('resgistering "firstFrameShown" event'), il.on("firstFrameShown", function() {
                                    Va.logger.debug('about to trigger "firstFrameShown" event on videojs player'), Wa.trigger("firstFrameShown");
                                  }), Ql.next = 14, il.stop();
                                case 14:
                                  return Ql.next = 16, il.changeSrc(wa.source_.src).firstFrameReceivedPromise;
                                case 16:
                                case "end":
                                  return Ql.stop();
                              }
                            }, Fo, this);
                          }));
                          function ta(Fo) {
                            return na.apply(this, arguments);
                          }
                          return ta;
                        })()
                      }, {
                        key: "destroy",
                        value: function() {
                          var ta = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.player;
                          if (this.logger.debug("destroying..."), !ta) {
                            this.logger.warn("Unable to destroy CLSP VideoJS Plugin without the player!");
                            return;
                          }
                          if (this.destroyed) {
                            this.logger.debug("Tried to destroy when already destroyed");
                            return;
                          }
                          this.destroyed = !0;
                          try {
                            var Fo = this.getClspHandler(ta);
                            Fo.destroy(), Fo.off("error", this.onClspHandlerError);
                            var Wa = Md().windowStateNames.visibilityChangeEventName;
                            Wa && (this.logger.debug("removing onVisibilityChange listener..."), document.removeEventListener(Wa, this.onVisibilityChange)), this.visibilityChangeInterval && (this.logger.debug("removing visibilityChangeInterval..."), clearInterval(this.visibilityChangeInterval)), this._playerOptions = null, this.currentSourceIndex = null;
                          } catch (Va) {
                            this.logger.error("Error while destroying CLSP VideoJS Plugin instance!"), this.logger.error(Va);
                          }
                        }
                      }], [{
                        key: "register",
                        value: function() {
                          if (di().getPlugin(Md().name))
                            throw new Error("You can only register the CLSP VideoJS Plugin once, and it has already been registered.");
                          var ta = fg()("html5");
                          return di().getTech("Html5").registerSourceHandler(ta, 0), di().registerPlugin(Md().pluginName, Gi), Nv.debug("plugin registered"), Gi;
                        }
                      }, {
                        key: "getDefaultOptions",
                        value: function() {
                          return {
                            /**
                             * The number of times to retry playing the video when there is an error
                             * that we know we can recover from.
                             *
                             * If a negative number is passed, retry indefinitely
                             * If 0 is passed, never retry
                             * If a positive number is passed, retry that many times
                             */
                            maxRetriesOnError: -1,
                            tourDuration: 10 * 1e3,
                            enableMetrics: !1,
                            videojsErrorsOptions: {}
                          };
                        }
                      }]);
                    })(Xy), sh(Ai, "VERSION", Md().version), sh(Ai, "utils", Md()), sh(Ai, "METRIC_TYPES", ["videojs.errorRetriesCount"]), Ai;
                  });
                  window.clspUtils || (window.clspUtils = Md());
                  var Qy = Lm();
                  Qy.register();
                })();
              })();
            })
          ),
          /***/
          "./node_modules/@videojs/vhs-utils/es/byte-helpers.js": (
            /*!************************************************************!*\
              !*** ./node_modules/@videojs/vhs-utils/es/byte-helpers.js ***!
              \************************************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                ENDIANNESS: () => (
                  /* binding */
                  Mi
                ),
                /* harmony export */
                IS_BIG_ENDIAN: () => (
                  /* binding */
                  Oo
                ),
                /* harmony export */
                IS_LITTLE_ENDIAN: () => (
                  /* binding */
                  io
                ),
                /* harmony export */
                bytesMatch: () => (
                  /* binding */
                  Ni
                ),
                /* harmony export */
                bytesToNumber: () => (
                  /* binding */
                  xo
                ),
                /* harmony export */
                bytesToString: () => (
                  /* binding */
                  _o
                ),
                /* harmony export */
                concatTypedArrays: () => (
                  /* binding */
                  Co
                ),
                /* harmony export */
                countBits: () => (
                  /* binding */
                  gi
                ),
                /* harmony export */
                countBytes: () => (
                  /* binding */
                  mi
                ),
                /* harmony export */
                isArrayBufferView: () => (
                  /* binding */
                  vi
                ),
                /* harmony export */
                isTypedArray: () => (
                  /* binding */
                  xi
                ),
                /* harmony export */
                numberToBytes: () => (
                  /* binding */
                  fo
                ),
                /* harmony export */
                padStart: () => (
                  /* binding */
                  Ti
                ),
                /* harmony export */
                reverseBytes: () => (
                  /* binding */
                  Vo
                ),
                /* harmony export */
                sliceBytes: () => (
                  /* binding */
                  Yi
                ),
                /* harmony export */
                stringToBytes: () => (
                  /* binding */
                  Li
                ),
                /* harmony export */
                toBinaryString: () => (
                  /* binding */
                  $i
                ),
                /* harmony export */
                toHexString: () => (
                  /* binding */
                  Pi
                ),
                /* harmony export */
                toUint8: () => (
                  /* binding */
                  Si
                )
                /* harmony export */
              });
              var si = oi(
                /*! global/window */
                "./node_modules/global/window.js"
              ), di = /* @__PURE__ */ oi.n(si), fi = function(Ui, jo) {
                for (var Wi = ""; jo--; )
                  Wi += Ui;
                return Wi;
              }, gi = function(Ui) {
                return Ui.toString(2).length;
              }, mi = function(Ui) {
                return Math.ceil(gi(Ui) / 8);
              }, Ti = function(Ui, jo, Wi) {
                return Wi === void 0 && (Wi = " "), (fi(Wi, jo) + Ui.toString()).slice(-jo);
              }, vi = function(Ui) {
                return ArrayBuffer.isView === "function" ? ArrayBuffer.isView(Ui) : Ui && Ui.buffer instanceof ArrayBuffer;
              }, xi = function(Ui) {
                return vi(Ui);
              }, Si = function(Ui) {
                return Ui instanceof Uint8Array ? Ui : (!Array.isArray(Ui) && !xi(Ui) && !(Ui instanceof ArrayBuffer) && (typeof Ui != "number" || typeof Ui == "number" && Ui !== Ui ? Ui = 0 : Ui = [Ui]), new Uint8Array(Ui && Ui.buffer || Ui, Ui && Ui.byteOffset || 0, Ui && Ui.byteLength || 0));
              }, Pi = function(Ui) {
                Ui = Si(Ui);
                for (var jo = "", Wi = 0; Wi < Ui.length; Wi++)
                  jo += Ti(Ui[Wi].toString(16), 2, "0");
                return jo;
              }, $i = function(Ui) {
                Ui = Si(Ui);
                for (var jo = "", Wi = 0; Wi < Ui.length; Wi++)
                  jo += Ti(Ui[Wi].toString(2), 8, "0");
                return jo;
              }, Oi = di().BigInt || Number, Di = [Oi("0x1"), Oi("0x100"), Oi("0x10000"), Oi("0x1000000"), Oi("0x100000000"), Oi("0x10000000000"), Oi("0x1000000000000"), Oi("0x100000000000000"), Oi("0x10000000000000000")], Mi = (function() {
                var No = new Uint16Array([65484]), Ui = new Uint8Array(No.buffer, No.byteOffset, No.byteLength);
                return Ui[0] === 255 ? "big" : Ui[0] === 204 ? "little" : "unknown";
              })(), Oo = Mi === "big", io = Mi === "little", xo = function(Ui, jo) {
                var Wi = jo === void 0 ? {} : jo, ji = Wi.signed, Hi = ji === void 0 ? !1 : ji, zo = Wi.le, Lo = zo === void 0 ? !1 : zo;
                Ui = Si(Ui);
                var sa = Lo ? "reduce" : "reduceRight", Ko = Ui[sa] ? Ui[sa] : Array.prototype[sa], ca = Ko.call(Ui, function(ga, ia, ra) {
                  var qo = Lo ? ra : Math.abs(ra + 1 - Ui.length);
                  return ga + Oi(ia) * Di[qo];
                }, Oi(0));
                if (Hi) {
                  var pa = Di[Ui.length] / Oi(2) - Oi(1);
                  ca = Oi(ca), ca > pa && (ca -= pa, ca -= pa, ca -= Oi(2));
                }
                return Number(ca);
              }, fo = function(Ui, jo) {
                var Wi = jo === void 0 ? {} : jo, ji = Wi.le, Hi = ji === void 0 ? !1 : ji;
                (typeof Ui != "bigint" && typeof Ui != "number" || typeof Ui == "number" && Ui !== Ui) && (Ui = 0), Ui = Oi(Ui);
                for (var zo = mi(Ui), Lo = new Uint8Array(new ArrayBuffer(zo)), sa = 0; sa < zo; sa++) {
                  var Ko = Hi ? sa : Math.abs(sa + 1 - Lo.length);
                  Lo[Ko] = Number(Ui / Di[sa] & Oi(255)), Ui < 0 && (Lo[Ko] = Math.abs(~Lo[Ko]), Lo[Ko] -= sa === 0 ? 1 : 2);
                }
                return Lo;
              }, _o = function(Ui) {
                if (!Ui)
                  return "";
                Ui = Array.prototype.slice.call(Ui);
                var jo = String.fromCharCode.apply(null, Si(Ui));
                try {
                  return decodeURIComponent(escape(jo));
                } catch {
                }
                return jo;
              }, Li = function(Ui, jo) {
                if (typeof Ui != "string" && Ui && typeof Ui.toString == "function" && (Ui = Ui.toString()), typeof Ui != "string")
                  return new Uint8Array();
                jo || (Ui = unescape(encodeURIComponent(Ui)));
                for (var Wi = new Uint8Array(Ui.length), ji = 0; ji < Ui.length; ji++)
                  Wi[ji] = Ui.charCodeAt(ji);
                return Wi;
              }, Co = function() {
                for (var Ui = arguments.length, jo = new Array(Ui), Wi = 0; Wi < Ui; Wi++)
                  jo[Wi] = arguments[Wi];
                if (jo = jo.filter(function(Lo) {
                  return Lo && (Lo.byteLength || Lo.length) && typeof Lo != "string";
                }), jo.length <= 1)
                  return Si(jo[0]);
                var ji = jo.reduce(function(Lo, sa, Ko) {
                  return Lo + (sa.byteLength || sa.length);
                }, 0), Hi = new Uint8Array(ji), zo = 0;
                return jo.forEach(function(Lo) {
                  Lo = Si(Lo), Hi.set(Lo, zo), zo += Lo.byteLength;
                }), Hi;
              }, Ni = function(Ui, jo, Wi) {
                var ji = Wi === void 0 ? {} : Wi, Hi = ji.offset, zo = Hi === void 0 ? 0 : Hi, Lo = ji.mask, sa = Lo === void 0 ? [] : Lo;
                Ui = Si(Ui), jo = Si(jo);
                var Ko = jo.every ? jo.every : Array.prototype.every;
                return jo.length && Ui.length - zo >= jo.length && // ie 11 doesn't support every on uin8
                Ko.call(jo, function(ca, pa) {
                  var ga = sa[pa] ? sa[pa] & Ui[zo + pa] : Ui[zo + pa];
                  return ca === ga;
                });
              }, Yi = function(Ui, jo, Wi) {
                return Uint8Array.prototype.slice ? Uint8Array.prototype.slice.call(Ui, jo, Wi) : new Uint8Array(Array.prototype.slice.call(Ui, jo, Wi));
              }, Vo = function(Ui) {
                return Ui.reverse ? Ui.reverse() : Array.prototype.reverse.call(Ui);
              };
            })
          ),
          /***/
          "./node_modules/@videojs/vhs-utils/es/codec-helpers.js": (
            /*!*************************************************************!*\
              !*** ./node_modules/@videojs/vhs-utils/es/codec-helpers.js ***!
              \*************************************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                getAv1Codec: () => (
                  /* binding */
                  di
                ),
                /* harmony export */
                getAvcCodec: () => (
                  /* binding */
                  fi
                ),
                /* harmony export */
                getHvcCodec: () => (
                  /* binding */
                  gi
                )
                /* harmony export */
              });
              var si = oi(
                /*! ./byte-helpers.js */
                "./node_modules/@videojs/vhs-utils/es/byte-helpers.js"
              ), di = function(Ti) {
                var vi = "", xi = Ti[1] >>> 3, Si = Ti[1] & 31, Pi = Ti[2] >>> 7, $i = (Ti[2] & 64) >> 6, Oi = (Ti[2] & 32) >> 5, Di = (Ti[2] & 16) >> 4, Mi = (Ti[2] & 8) >> 3, Oo = (Ti[2] & 4) >> 2, io = Ti[2] & 3;
                vi += xi + "." + (0, si.padStart)(Si, 2, "0"), Pi === 0 ? vi += "M" : Pi === 1 && (vi += "H");
                var xo;
                return xi === 2 && $i ? xo = Oi ? 12 : 10 : xo = $i ? 10 : 8, vi += "." + (0, si.padStart)(xo, 2, "0"), vi += "." + Di, vi += "." + Mi + Oo + io, vi;
              }, fi = function(Ti) {
                var vi = (0, si.toHexString)(Ti[1]), xi = (0, si.toHexString)(Ti[2] & 252), Si = (0, si.toHexString)(Ti[3]);
                return "" + vi + xi + Si;
              }, gi = function(Ti) {
                var vi = "", xi = Ti[1] >> 6, Si = Ti[1] & 31, Pi = (Ti[1] & 32) >> 5, $i = Ti.subarray(2, 6), Oi = Ti.subarray(6, 12), Di = Ti[12];
                xi === 1 ? vi += "A" : xi === 2 ? vi += "B" : xi === 3 && (vi += "C"), vi += Si + ".";
                var Mi = parseInt((0, si.toBinaryString)($i).split("").reverse().join(""), 2);
                Mi > 255 && (Mi = parseInt((0, si.toBinaryString)($i), 2)), vi += Mi.toString(16) + ".", Pi === 0 ? vi += "L" : vi += "H", vi += Di;
                for (var Oo = "", io = 0; io < Oi.length; io++) {
                  var xo = Oi[io];
                  xo && (Oo && (Oo += "."), Oo += xo.toString(16));
                }
                return Oo && (vi += "." + Oo), vi;
              };
            })
          ),
          /***/
          "./node_modules/@videojs/vhs-utils/es/codecs.js": (
            /*!******************************************************!*\
              !*** ./node_modules/@videojs/vhs-utils/es/codecs.js ***!
              \******************************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                DEFAULT_AUDIO_CODEC: () => (
                  /* binding */
                  xo
                ),
                /* harmony export */
                DEFAULT_VIDEO_CODEC: () => (
                  /* binding */
                  fo
                ),
                /* harmony export */
                browserSupportsCodec: () => (
                  /* binding */
                  Oo
                ),
                /* harmony export */
                codecsFromDefault: () => (
                  /* binding */
                  Pi
                ),
                /* harmony export */
                getMimeForCodec: () => (
                  /* binding */
                  Mi
                ),
                /* harmony export */
                isAudioCodec: () => (
                  /* binding */
                  Oi
                ),
                /* harmony export */
                isTextCodec: () => (
                  /* binding */
                  Di
                ),
                /* harmony export */
                isVideoCodec: () => (
                  /* binding */
                  $i
                ),
                /* harmony export */
                mapLegacyAvcCodecs: () => (
                  /* binding */
                  xi
                ),
                /* harmony export */
                muxerSupportsCodec: () => (
                  /* binding */
                  io
                ),
                /* harmony export */
                parseCodecs: () => (
                  /* binding */
                  Si
                ),
                /* harmony export */
                translateLegacyCodec: () => (
                  /* binding */
                  Ti
                ),
                /* harmony export */
                translateLegacyCodecs: () => (
                  /* binding */
                  vi
                )
                /* harmony export */
              });
              var si = oi(
                /*! global/window */
                "./node_modules/global/window.js"
              ), di = /* @__PURE__ */ oi.n(si), fi = {
                // to determine mime types
                mp4: /^(av0?1|avc0?[1234]|vp0?9|flac|opus|mp3|mp4a|mp4v|stpp.ttml.im1t)/,
                webm: /^(vp0?[89]|av0?1|opus|vorbis)/,
                ogg: /^(vp0?[89]|theora|flac|opus|vorbis)/,
                // to determine if a codec is audio or video
                video: /^(av0?1|avc0?[1234]|vp0?[89]|hvc1|hev1|theora|mp4v)/,
                audio: /^(mp4a|flac|vorbis|opus|ac-[34]|ec-3|alac|mp3|speex|aac)/,
                text: /^(stpp.ttml.im1t)/,
                // mux.js support regex
                muxerVideo: /^(avc0?1)/,
                muxerAudio: /^(mp4a)/,
                // match nothing as muxer does not support text right now.
                // there cannot never be a character before the start of a string
                // so this matches nothing.
                muxerText: /a^/
              }, gi = ["video", "audio", "text"], mi = ["Video", "Audio", "Text"], Ti = function(Li) {
                return Li && Li.replace(/avc1\.(\d+)\.(\d+)/i, function(Co, Ni, Yi) {
                  var Vo = ("00" + Number(Ni).toString(16)).slice(-2), No = ("00" + Number(Yi).toString(16)).slice(-2);
                  return "avc1." + Vo + "00" + No;
                });
              }, vi = function(Li) {
                return Li.map(Ti);
              }, xi = function(Li) {
                return Li.replace(/avc1\.(\d+)\.(\d+)/i, function(Co) {
                  return vi([Co])[0];
                });
              }, Si = function(Li) {
                Li === void 0 && (Li = "");
                var Co = Li.split(","), Ni = [];
                return Co.forEach(function(Yi) {
                  Yi = Yi.trim();
                  var Vo;
                  gi.forEach(function(No) {
                    var Ui = fi[No].exec(Yi.toLowerCase());
                    if (!(!Ui || Ui.length <= 1)) {
                      Vo = No;
                      var jo = Yi.substring(0, Ui[1].length), Wi = Yi.replace(jo, "");
                      Ni.push({
                        type: jo,
                        details: Wi,
                        mediaType: No
                      });
                    }
                  }), Vo || Ni.push({
                    type: Yi,
                    details: "",
                    mediaType: "unknown"
                  });
                }), Ni;
              }, Pi = function(Li, Co) {
                if (!Li.mediaGroups.AUDIO || !Co)
                  return null;
                var Ni = Li.mediaGroups.AUDIO[Co];
                if (!Ni)
                  return null;
                for (var Yi in Ni) {
                  var Vo = Ni[Yi];
                  if (Vo.default && Vo.playlists)
                    return Si(Vo.playlists[0].attributes.CODECS);
                }
                return null;
              }, $i = function(Li) {
                return Li === void 0 && (Li = ""), fi.video.test(Li.trim().toLowerCase());
              }, Oi = function(Li) {
                return Li === void 0 && (Li = ""), fi.audio.test(Li.trim().toLowerCase());
              }, Di = function(Li) {
                return Li === void 0 && (Li = ""), fi.text.test(Li.trim().toLowerCase());
              }, Mi = function(Li) {
                if (!(!Li || typeof Li != "string")) {
                  var Co = Li.toLowerCase().split(",").map(function(Vo) {
                    return Ti(Vo.trim());
                  }), Ni = "video";
                  Co.length === 1 && Oi(Co[0]) ? Ni = "audio" : Co.length === 1 && Di(Co[0]) && (Ni = "application");
                  var Yi = "mp4";
                  return Co.every(function(Vo) {
                    return fi.mp4.test(Vo);
                  }) ? Yi = "mp4" : Co.every(function(Vo) {
                    return fi.webm.test(Vo);
                  }) ? Yi = "webm" : Co.every(function(Vo) {
                    return fi.ogg.test(Vo);
                  }) && (Yi = "ogg"), Ni + "/" + Yi + ';codecs="' + Li + '"';
                }
              }, Oo = function(Li) {
                return Li === void 0 && (Li = ""), di().MediaSource && di().MediaSource.isTypeSupported && di().MediaSource.isTypeSupported(Mi(Li)) || !1;
              }, io = function(Li) {
                return Li === void 0 && (Li = ""), Li.toLowerCase().split(",").every(function(Co) {
                  Co = Co.trim();
                  for (var Ni = 0; Ni < mi.length; Ni++) {
                    var Yi = mi[Ni];
                    if (fi["muxer" + Yi].test(Co))
                      return !0;
                  }
                  return !1;
                });
              }, xo = "mp4a.40.2", fo = "avc1.4d400d";
            })
          ),
          /***/
          "./node_modules/@videojs/vhs-utils/es/containers.js": (
            /*!**********************************************************!*\
              !*** ./node_modules/@videojs/vhs-utils/es/containers.js ***!
              \**********************************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                detectContainerForBytes: () => (
                  /* binding */
                  Pi
                ),
                /* harmony export */
                isLikely: () => (
                  /* binding */
                  Si
                ),
                /* harmony export */
                isLikelyFmp4MediaSegment: () => (
                  /* binding */
                  $i
                )
                /* harmony export */
              });
              var si = oi(
                /*! ./byte-helpers.js */
                "./node_modules/@videojs/vhs-utils/es/byte-helpers.js"
              ), di = oi(
                /*! ./mp4-helpers.js */
                "./node_modules/@videojs/vhs-utils/es/mp4-helpers.js"
              ), fi = oi(
                /*! ./ebml-helpers.js */
                "./node_modules/@videojs/vhs-utils/es/ebml-helpers.js"
              ), gi = oi(
                /*! ./id3-helpers.js */
                "./node_modules/@videojs/vhs-utils/es/id3-helpers.js"
              ), mi = oi(
                /*! ./nal-helpers.js */
                "./node_modules/@videojs/vhs-utils/es/nal-helpers.js"
              ), Ti = {
                // "webm" string literal in hex
                webm: (0, si.toUint8)([119, 101, 98, 109]),
                // "matroska" string literal in hex
                matroska: (0, si.toUint8)([109, 97, 116, 114, 111, 115, 107, 97]),
                // "fLaC" string literal in hex
                flac: (0, si.toUint8)([102, 76, 97, 67]),
                // "OggS" string literal in hex
                ogg: (0, si.toUint8)([79, 103, 103, 83]),
                // ac-3 sync byte, also works for ec-3 as that is simply a codec
                // of ac-3
                ac3: (0, si.toUint8)([11, 119]),
                // "RIFF" string literal in hex used for wav and avi
                riff: (0, si.toUint8)([82, 73, 70, 70]),
                // "AVI" string literal in hex
                avi: (0, si.toUint8)([65, 86, 73]),
                // "WAVE" string literal in hex
                wav: (0, si.toUint8)([87, 65, 86, 69]),
                // "ftyp3g" string literal in hex
                "3gp": (0, si.toUint8)([102, 116, 121, 112, 51, 103]),
                // "ftyp" string literal in hex
                mp4: (0, si.toUint8)([102, 116, 121, 112]),
                // "styp" string literal in hex
                fmp4: (0, si.toUint8)([115, 116, 121, 112]),
                // "ftypqt" string literal in hex
                mov: (0, si.toUint8)([102, 116, 121, 112, 113, 116]),
                // moov string literal in hex
                moov: (0, si.toUint8)([109, 111, 111, 118]),
                // moof string literal in hex
                moof: (0, si.toUint8)([109, 111, 111, 102])
              }, vi = {
                aac: function(Di) {
                  var Mi = (0, gi.getId3Offset)(Di);
                  return (0, si.bytesMatch)(Di, [255, 16], {
                    offset: Mi,
                    mask: [255, 22]
                  });
                },
                mp3: function(Di) {
                  var Mi = (0, gi.getId3Offset)(Di);
                  return (0, si.bytesMatch)(Di, [255, 2], {
                    offset: Mi,
                    mask: [255, 6]
                  });
                },
                webm: function(Di) {
                  var Mi = (0, fi.findEbml)(Di, [fi.EBML_TAGS.EBML, fi.EBML_TAGS.DocType])[0];
                  return (0, si.bytesMatch)(Mi, Ti.webm);
                },
                mkv: function(Di) {
                  var Mi = (0, fi.findEbml)(Di, [fi.EBML_TAGS.EBML, fi.EBML_TAGS.DocType])[0];
                  return (0, si.bytesMatch)(Mi, Ti.matroska);
                },
                mp4: function(Di) {
                  if (vi["3gp"](Di) || vi.mov(Di))
                    return !1;
                  if ((0, si.bytesMatch)(Di, Ti.mp4, {
                    offset: 4
                  }) || (0, si.bytesMatch)(Di, Ti.fmp4, {
                    offset: 4
                  }) || (0, si.bytesMatch)(Di, Ti.moof, {
                    offset: 4
                  }) || (0, si.bytesMatch)(Di, Ti.moov, {
                    offset: 4
                  }))
                    return !0;
                },
                mov: function(Di) {
                  return (0, si.bytesMatch)(Di, Ti.mov, {
                    offset: 4
                  });
                },
                "3gp": function(Di) {
                  return (0, si.bytesMatch)(Di, Ti["3gp"], {
                    offset: 4
                  });
                },
                ac3: function(Di) {
                  var Mi = (0, gi.getId3Offset)(Di);
                  return (0, si.bytesMatch)(Di, Ti.ac3, {
                    offset: Mi
                  });
                },
                ts: function(Di) {
                  if (Di.length < 189 && Di.length >= 1)
                    return Di[0] === 71;
                  for (var Mi = 0; Mi + 188 < Di.length && Mi < 188; ) {
                    if (Di[Mi] === 71 && Di[Mi + 188] === 71)
                      return !0;
                    Mi += 1;
                  }
                  return !1;
                },
                flac: function(Di) {
                  var Mi = (0, gi.getId3Offset)(Di);
                  return (0, si.bytesMatch)(Di, Ti.flac, {
                    offset: Mi
                  });
                },
                ogg: function(Di) {
                  return (0, si.bytesMatch)(Di, Ti.ogg);
                },
                avi: function(Di) {
                  return (0, si.bytesMatch)(Di, Ti.riff) && (0, si.bytesMatch)(Di, Ti.avi, {
                    offset: 8
                  });
                },
                wav: function(Di) {
                  return (0, si.bytesMatch)(Di, Ti.riff) && (0, si.bytesMatch)(Di, Ti.wav, {
                    offset: 8
                  });
                },
                h264: function(Di) {
                  return (0, mi.findH264Nal)(Di, 7, 3).length;
                },
                h265: function(Di) {
                  return (0, mi.findH265Nal)(Di, [32, 33], 3).length;
                }
              }, xi = Object.keys(vi).filter(function(Oi) {
                return Oi !== "ts" && Oi !== "h264" && Oi !== "h265";
              }).concat(["ts", "h264", "h265"]);
              xi.forEach(function(Oi) {
                var Di = vi[Oi];
                vi[Oi] = function(Mi) {
                  return Di((0, si.toUint8)(Mi));
                };
              });
              var Si = vi, Pi = function(Di) {
                Di = (0, si.toUint8)(Di);
                for (var Mi = 0; Mi < xi.length; Mi++) {
                  var Oo = xi[Mi];
                  if (Si[Oo](Di))
                    return Oo;
                }
                return "";
              }, $i = function(Di) {
                return (0, di.findBox)(Di, ["moof"]).length > 0;
              };
            })
          ),
          /***/
          "./node_modules/@videojs/vhs-utils/es/decode-b64-to-uint8-array.js": (
            /*!*************************************************************************!*\
              !*** ./node_modules/@videojs/vhs-utils/es/decode-b64-to-uint8-array.js ***!
              \*************************************************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                default: () => (
                  /* binding */
                  gi
                )
                /* harmony export */
              });
              var si = oi(
                /*! global/window */
                "./node_modules/global/window.js"
              ), di = /* @__PURE__ */ oi.n(si), fi = function(Ti) {
                return di().atob ? di().atob(Ti) : Buffer.from(Ti, "base64").toString("binary");
              };
              function gi(mi) {
                for (var Ti = fi(mi), vi = new Uint8Array(Ti.length), xi = 0; xi < Ti.length; xi++)
                  vi[xi] = Ti.charCodeAt(xi);
                return vi;
              }
            })
          ),
          /***/
          "./node_modules/@videojs/vhs-utils/es/ebml-helpers.js": (
            /*!************************************************************!*\
              !*** ./node_modules/@videojs/vhs-utils/es/ebml-helpers.js ***!
              \************************************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                EBML_TAGS: () => (
                  /* binding */
                  fi
                ),
                /* harmony export */
                decodeBlock: () => (
                  /* binding */
                  $i
                ),
                /* harmony export */
                findEbml: () => (
                  /* binding */
                  Pi
                ),
                /* harmony export */
                parseData: () => (
                  /* binding */
                  Mi
                ),
                /* harmony export */
                parseTracks: () => (
                  /* binding */
                  Di
                )
                /* harmony export */
              });
              var si = oi(
                /*! ./byte-helpers */
                "./node_modules/@videojs/vhs-utils/es/byte-helpers.js"
              ), di = oi(
                /*! ./codec-helpers.js */
                "./node_modules/@videojs/vhs-utils/es/codec-helpers.js"
              ), fi = {
                EBML: (0, si.toUint8)([26, 69, 223, 163]),
                DocType: (0, si.toUint8)([66, 130]),
                Segment: (0, si.toUint8)([24, 83, 128, 103]),
                SegmentInfo: (0, si.toUint8)([21, 73, 169, 102]),
                Tracks: (0, si.toUint8)([22, 84, 174, 107]),
                Track: (0, si.toUint8)([174]),
                TrackNumber: (0, si.toUint8)([215]),
                DefaultDuration: (0, si.toUint8)([35, 227, 131]),
                TrackEntry: (0, si.toUint8)([174]),
                TrackType: (0, si.toUint8)([131]),
                FlagDefault: (0, si.toUint8)([136]),
                CodecID: (0, si.toUint8)([134]),
                CodecPrivate: (0, si.toUint8)([99, 162]),
                VideoTrack: (0, si.toUint8)([224]),
                AudioTrack: (0, si.toUint8)([225]),
                // Not used yet, but will be used for live webm/mkv
                // see https://www.matroska.org/technical/basics.html#block-structure
                // see https://www.matroska.org/technical/basics.html#simpleblock-structure
                Cluster: (0, si.toUint8)([31, 67, 182, 117]),
                Timestamp: (0, si.toUint8)([231]),
                TimestampScale: (0, si.toUint8)([42, 215, 177]),
                BlockGroup: (0, si.toUint8)([160]),
                BlockDuration: (0, si.toUint8)([155]),
                Block: (0, si.toUint8)([161]),
                SimpleBlock: (0, si.toUint8)([163])
              }, gi = [128, 64, 32, 16, 8, 4, 2, 1], mi = function(io) {
                for (var xo = 1, fo = 0; fo < gi.length && !(io & gi[fo]); fo++)
                  xo++;
                return xo;
              }, Ti = function(io, xo, fo, _o) {
                fo === void 0 && (fo = !0), _o === void 0 && (_o = !1);
                var Li = mi(io[xo]), Co = io.subarray(xo, xo + Li);
                return fo && (Co = Array.prototype.slice.call(io, xo, xo + Li), Co[0] ^= gi[Li - 1]), {
                  length: Li,
                  value: (0, si.bytesToNumber)(Co, {
                    signed: _o
                  }),
                  bytes: Co
                };
              }, vi = function Oo(io) {
                return typeof io == "string" ? io.match(/.{1,2}/g).map(function(xo) {
                  return Oo(xo);
                }) : typeof io == "number" ? (0, si.numberToBytes)(io) : io;
              }, xi = function(io) {
                return Array.isArray(io) ? io.map(function(xo) {
                  return vi(xo);
                }) : [vi(io)];
              }, Si = function Oo(io, xo, fo) {
                if (fo >= xo.length)
                  return xo.length;
                var _o = Ti(xo, fo, !1);
                if ((0, si.bytesMatch)(io.bytes, _o.bytes))
                  return fo;
                var Li = Ti(xo, fo + _o.length);
                return Oo(io, xo, fo + Li.length + Li.value + _o.length);
              }, Pi = function Oo(io, xo) {
                xo = xi(xo), io = (0, si.toUint8)(io);
                var fo = [];
                if (!xo.length)
                  return fo;
                for (var _o = 0; _o < io.length; ) {
                  var Li = Ti(io, _o, !1), Co = Ti(io, _o + Li.length), Ni = _o + Li.length + Co.length;
                  Co.value === 127 && (Co.value = Si(Li, io, Ni), Co.value !== io.length && (Co.value -= Ni));
                  var Yi = Ni + Co.value > io.length ? io.length : Ni + Co.value, Vo = io.subarray(Ni, Yi);
                  (0, si.bytesMatch)(xo[0], Li.bytes) && (xo.length === 1 ? fo.push(Vo) : fo = fo.concat(Oo(Vo, xo.slice(1))));
                  var No = Li.length + Co.length + Vo.length;
                  _o += No;
                }
                return fo;
              }, $i = function(io, xo, fo, _o) {
                var Li;
                xo === "group" && (Li = Pi(io, [fi.BlockDuration])[0], Li && (Li = (0, si.bytesToNumber)(Li), Li = 1 / fo * Li * fo / 1e3), io = Pi(io, [fi.Block])[0], xo = "block");
                var Co = new DataView(io.buffer, io.byteOffset, io.byteLength), Ni = Ti(io, 0), Yi = Co.getInt16(Ni.length, !1), Vo = io[Ni.length + 2], No = io.subarray(Ni.length + 3), Ui = 1 / fo * (_o + Yi) * fo / 1e3, jo = {
                  duration: Li,
                  trackNumber: Ni.value,
                  keyframe: xo === "simple" && Vo >> 7 === 1,
                  invisible: (Vo & 8) >> 3 === 1,
                  lacing: (Vo & 6) >> 1,
                  discardable: xo === "simple" && (Vo & 1) === 1,
                  frames: [],
                  pts: Ui,
                  dts: Ui,
                  timestamp: Yi
                };
                if (!jo.lacing)
                  return jo.frames.push(No), jo;
                var Wi = No[0] + 1, ji = [], Hi = 1;
                if (jo.lacing === 2)
                  for (var zo = (No.length - Hi) / Wi, Lo = 0; Lo < Wi; Lo++)
                    ji.push(zo);
                if (jo.lacing === 1)
                  for (var sa = 0; sa < Wi - 1; sa++) {
                    var Ko = 0;
                    do
                      Ko += No[Hi], Hi++;
                    while (No[Hi - 1] === 255);
                    ji.push(Ko);
                  }
                if (jo.lacing === 3)
                  for (var ca = 0, pa = 0; pa < Wi - 1; pa++) {
                    var ga = pa === 0 ? Ti(No, Hi) : Ti(No, Hi, !0, !0);
                    ca += ga.value, ji.push(ca), Hi += ga.length;
                  }
                return ji.forEach(function(ia) {
                  jo.frames.push(No.subarray(Hi, Hi + ia)), Hi += ia;
                }), jo;
              }, Oi = function(io) {
                for (var xo = 0, fo = {}; xo < io.length; ) {
                  var _o = io[xo] & 127, Li = io[xo + 1], Co = void 0;
                  Li === 1 ? Co = io[xo + 2] : Co = io.subarray(xo + 2, xo + 2 + Li), _o === 1 ? fo.profile = Co : _o === 2 ? fo.level = Co : _o === 3 ? fo.bitDepth = Co : _o === 4 ? fo.chromaSubsampling = Co : fo[_o] = Co, xo += 2 + Li;
                }
                return fo;
              }, Di = function(io) {
                io = (0, si.toUint8)(io);
                var xo = [], fo = Pi(io, [fi.Segment, fi.Tracks, fi.Track]);
                return fo.length || (fo = Pi(io, [fi.Tracks, fi.Track])), fo.length || (fo = Pi(io, [fi.Track])), fo.length ? (fo.forEach(function(_o) {
                  var Li = Pi(_o, fi.TrackType)[0];
                  if (!(!Li || !Li.length)) {
                    if (Li[0] === 1)
                      Li = "video";
                    else if (Li[0] === 2)
                      Li = "audio";
                    else if (Li[0] === 17)
                      Li = "subtitle";
                    else
                      return;
                    var Co = {
                      rawCodec: (0, si.bytesToString)(Pi(_o, [fi.CodecID])[0]),
                      type: Li,
                      codecPrivate: Pi(_o, [fi.CodecPrivate])[0],
                      number: (0, si.bytesToNumber)(Pi(_o, [fi.TrackNumber])[0]),
                      defaultDuration: (0, si.bytesToNumber)(Pi(_o, [fi.DefaultDuration])[0]),
                      default: Pi(_o, [fi.FlagDefault])[0],
                      rawData: _o
                    }, Ni = "";
                    if (/V_MPEG4\/ISO\/AVC/.test(Co.rawCodec))
                      Ni = "avc1." + (0, di.getAvcCodec)(Co.codecPrivate);
                    else if (/V_MPEGH\/ISO\/HEVC/.test(Co.rawCodec))
                      Ni = "hev1." + (0, di.getHvcCodec)(Co.codecPrivate);
                    else if (/V_MPEG4\/ISO\/ASP/.test(Co.rawCodec))
                      Co.codecPrivate ? Ni = "mp4v.20." + Co.codecPrivate[4].toString() : Ni = "mp4v.20.9";
                    else if (/^V_THEORA/.test(Co.rawCodec))
                      Ni = "theora";
                    else if (/^V_VP8/.test(Co.rawCodec))
                      Ni = "vp8";
                    else if (/^V_VP9/.test(Co.rawCodec))
                      if (Co.codecPrivate) {
                        var Yi = Oi(Co.codecPrivate), Vo = Yi.profile, No = Yi.level, Ui = Yi.bitDepth, jo = Yi.chromaSubsampling;
                        Ni = "vp09.", Ni += (0, si.padStart)(Vo, 2, "0") + ".", Ni += (0, si.padStart)(No, 2, "0") + ".", Ni += (0, si.padStart)(Ui, 2, "0") + ".", Ni += "" + (0, si.padStart)(jo, 2, "0");
                        var Wi = Pi(_o, [224, [85, 176], [85, 177]])[0] || [], ji = Pi(_o, [224, [85, 176], [85, 185]])[0] || [], Hi = Pi(_o, [224, [85, 176], [85, 186]])[0] || [], zo = Pi(_o, [224, [85, 176], [85, 187]])[0] || [];
                        (Wi.length || ji.length || Hi.length || zo.length) && (Ni += "." + (0, si.padStart)(zo[0], 2, "0"), Ni += "." + (0, si.padStart)(Hi[0], 2, "0"), Ni += "." + (0, si.padStart)(Wi[0], 2, "0"), Ni += "." + (0, si.padStart)(ji[0], 2, "0"));
                      } else
                        Ni = "vp9";
                    else /^V_AV1/.test(Co.rawCodec) ? Ni = "av01." + (0, di.getAv1Codec)(Co.codecPrivate) : /A_ALAC/.test(Co.rawCodec) ? Ni = "alac" : /A_MPEG\/L2/.test(Co.rawCodec) ? Ni = "mp2" : /A_MPEG\/L3/.test(Co.rawCodec) ? Ni = "mp3" : /^A_AAC/.test(Co.rawCodec) ? Co.codecPrivate ? Ni = "mp4a.40." + (Co.codecPrivate[0] >>> 3).toString() : Ni = "mp4a.40.2" : /^A_AC3/.test(Co.rawCodec) ? Ni = "ac-3" : /^A_PCM/.test(Co.rawCodec) ? Ni = "pcm" : /^A_MS\/ACM/.test(Co.rawCodec) ? Ni = "speex" : /^A_EAC3/.test(Co.rawCodec) ? Ni = "ec-3" : /^A_VORBIS/.test(Co.rawCodec) ? Ni = "vorbis" : /^A_FLAC/.test(Co.rawCodec) ? Ni = "flac" : /^A_OPUS/.test(Co.rawCodec) && (Ni = "opus");
                    Co.codec = Ni, xo.push(Co);
                  }
                }), xo.sort(function(_o, Li) {
                  return _o.number - Li.number;
                })) : xo;
              }, Mi = function(io, xo) {
                var fo = [], _o = Pi(io, [fi.Segment])[0], Li = Pi(_o, [fi.SegmentInfo, fi.TimestampScale])[0];
                Li && Li.length ? Li = (0, si.bytesToNumber)(Li) : Li = 1e6;
                var Co = Pi(_o, [fi.Cluster]);
                return xo || (xo = Di(_o)), Co.forEach(function(Ni, Yi) {
                  var Vo = Pi(Ni, [fi.SimpleBlock]).map(function(Wi) {
                    return {
                      type: "simple",
                      data: Wi
                    };
                  }), No = Pi(Ni, [fi.BlockGroup]).map(function(Wi) {
                    return {
                      type: "group",
                      data: Wi
                    };
                  }), Ui = Pi(Ni, [fi.Timestamp])[0] || 0;
                  Ui && Ui.length && (Ui = (0, si.bytesToNumber)(Ui));
                  var jo = Vo.concat(No).sort(function(Wi, ji) {
                    return Wi.data.byteOffset - ji.data.byteOffset;
                  });
                  jo.forEach(function(Wi, ji) {
                    var Hi = $i(Wi.data, Wi.type, Li, Ui);
                    fo.push(Hi);
                  });
                }), {
                  tracks: xo,
                  blocks: fo
                };
              };
            })
          ),
          /***/
          "./node_modules/@videojs/vhs-utils/es/id3-helpers.js": (
            /*!***********************************************************!*\
              !*** ./node_modules/@videojs/vhs-utils/es/id3-helpers.js ***!
              \***********************************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                getId3Offset: () => (
                  /* binding */
                  gi
                ),
                /* harmony export */
                getId3Size: () => (
                  /* binding */
                  fi
                )
                /* harmony export */
              });
              var si = oi(
                /*! ./byte-helpers.js */
                "./node_modules/@videojs/vhs-utils/es/byte-helpers.js"
              ), di = (0, si.toUint8)([73, 68, 51]), fi = function(Ti, vi) {
                vi === void 0 && (vi = 0), Ti = (0, si.toUint8)(Ti);
                var xi = Ti[vi + 5], Si = Ti[vi + 6] << 21 | Ti[vi + 7] << 14 | Ti[vi + 8] << 7 | Ti[vi + 9], Pi = (xi & 16) >> 4;
                return Pi ? Si + 20 : Si + 10;
              }, gi = function mi(Ti, vi) {
                return vi === void 0 && (vi = 0), Ti = (0, si.toUint8)(Ti), Ti.length - vi < 10 || !(0, si.bytesMatch)(Ti, di, {
                  offset: vi
                }) ? vi : (vi += fi(Ti, vi), mi(Ti, vi));
              };
            })
          ),
          /***/
          "./node_modules/@videojs/vhs-utils/es/media-groups.js": (
            /*!************************************************************!*\
              !*** ./node_modules/@videojs/vhs-utils/es/media-groups.js ***!
              \************************************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                forEachMediaGroup: () => (
                  /* binding */
                  si
                )
                /* harmony export */
              });
              var si = function(fi, gi, mi) {
                gi.forEach(function(Ti) {
                  for (var vi in fi.mediaGroups[Ti])
                    for (var xi in fi.mediaGroups[Ti][vi]) {
                      var Si = fi.mediaGroups[Ti][vi][xi];
                      mi(Si, Ti, vi, xi);
                    }
                });
              };
            })
          ),
          /***/
          "./node_modules/@videojs/vhs-utils/es/media-types.js": (
            /*!***********************************************************!*\
              !*** ./node_modules/@videojs/vhs-utils/es/media-types.js ***!
              \***********************************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                simpleTypeFromSourceType: () => (
                  /* binding */
                  fi
                )
                /* harmony export */
              });
              var si = /^(audio|video|application)\/(x-|vnd\.apple\.)?mpegurl/i, di = /^application\/dash\+xml/i, fi = function(mi) {
                return si.test(mi) ? "hls" : di.test(mi) ? "dash" : mi === "application/vnd.videojs.vhs+json" ? "vhs-json" : null;
              };
            })
          ),
          /***/
          "./node_modules/@videojs/vhs-utils/es/mp4-helpers.js": (
            /*!***********************************************************!*\
              !*** ./node_modules/@videojs/vhs-utils/es/mp4-helpers.js ***!
              \***********************************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                addSampleDescription: () => (
                  /* binding */
                  Oi
                ),
                /* harmony export */
                buildFrameTable: () => (
                  /* binding */
                  $i
                ),
                /* harmony export */
                findBox: () => (
                  /* binding */
                  xi
                ),
                /* harmony export */
                findNamedBox: () => (
                  /* binding */
                  Si
                ),
                /* harmony export */
                parseDescriptors: () => (
                  /* binding */
                  vi
                ),
                /* harmony export */
                parseMediaInfo: () => (
                  /* binding */
                  Mi
                ),
                /* harmony export */
                parseTracks: () => (
                  /* binding */
                  Di
                )
                /* harmony export */
              });
              var si = oi(
                /*! ./byte-helpers.js */
                "./node_modules/@videojs/vhs-utils/es/byte-helpers.js"
              ), di = oi(
                /*! ./codec-helpers.js */
                "./node_modules/@videojs/vhs-utils/es/codec-helpers.js"
              ), fi = oi(
                /*! ./opus-helpers.js */
                "./node_modules/@videojs/vhs-utils/es/opus-helpers.js"
              ), gi = function(io) {
                return typeof io == "string" ? (0, si.stringToBytes)(io) : io;
              }, mi = function(io) {
                return Array.isArray(io) ? io.map(function(xo) {
                  return gi(xo);
                }) : [gi(io)];
              }, Ti, vi = function(io) {
                io = (0, si.toUint8)(io);
                for (var xo = [], fo = 0; io.length > fo; ) {
                  var _o = io[fo], Li = 0, Co = 0;
                  Co++;
                  var Ni = io[Co];
                  for (Co++; Ni & 128; )
                    Li = (Ni & 127) << 7, Ni = io[Co], Co++;
                  Li += Ni & 127;
                  for (var Yi = 0; Yi < Ti.length; Yi++) {
                    var Vo = Ti[Yi], No = Vo.id, Ui = Vo.parser;
                    if (_o === No) {
                      xo.push(Ui(io.subarray(Co, Co + Li)));
                      break;
                    }
                  }
                  fo += Li + Co;
                }
                return xo;
              };
              Ti = [{
                id: 3,
                parser: function(io) {
                  var xo = {
                    tag: 3,
                    id: io[0] << 8 | io[1],
                    flags: io[2],
                    size: 3,
                    dependsOnEsId: 0,
                    ocrEsId: 0,
                    descriptors: [],
                    url: ""
                  };
                  if (xo.flags & 128 && (xo.dependsOnEsId = io[xo.size] << 8 | io[xo.size + 1], xo.size += 2), xo.flags & 64) {
                    var fo = io[xo.size];
                    xo.url = (0, si.bytesToString)(io.subarray(xo.size + 1, xo.size + 1 + fo)), xo.size += fo;
                  }
                  return xo.flags & 32 && (xo.ocrEsId = io[xo.size] << 8 | io[xo.size + 1], xo.size += 2), xo.descriptors = vi(io.subarray(xo.size)) || [], xo;
                }
              }, {
                id: 4,
                parser: function(io) {
                  var xo = {
                    tag: 4,
                    oti: io[0],
                    streamType: io[1],
                    bufferSize: io[2] << 16 | io[3] << 8 | io[4],
                    maxBitrate: io[5] << 24 | io[6] << 16 | io[7] << 8 | io[8],
                    avgBitrate: io[9] << 24 | io[10] << 16 | io[11] << 8 | io[12],
                    descriptors: vi(io.subarray(13))
                  };
                  return xo;
                }
              }, {
                id: 5,
                parser: function(io) {
                  return {
                    tag: 5,
                    bytes: io
                  };
                }
              }, {
                id: 6,
                parser: function(io) {
                  return {
                    tag: 6,
                    bytes: io
                  };
                }
              }];
              var xi = function Oo(io, xo, fo) {
                fo === void 0 && (fo = !1), xo = mi(xo), io = (0, si.toUint8)(io);
                var _o = [];
                if (!xo.length)
                  return _o;
                for (var Li = 0; Li < io.length; ) {
                  var Co = (io[Li] << 24 | io[Li + 1] << 16 | io[Li + 2] << 8 | io[Li + 3]) >>> 0, Ni = io.subarray(Li + 4, Li + 8);
                  if (Co === 0)
                    break;
                  var Yi = Li + Co;
                  if (Yi > io.length) {
                    if (fo)
                      break;
                    Yi = io.length;
                  }
                  var Vo = io.subarray(Li + 8, Yi);
                  (0, si.bytesMatch)(Ni, xo[0]) && (xo.length === 1 ? _o.push(Vo) : _o.push.apply(_o, Oo(Vo, xo.slice(1), fo))), Li = Yi;
                }
                return _o;
              }, Si = function(io, xo) {
                if (xo = gi(xo), !xo.length)
                  return io.subarray(io.length);
                for (var fo = 0; fo < io.length; ) {
                  if ((0, si.bytesMatch)(io.subarray(fo, fo + xo.length), xo)) {
                    var _o = (io[fo - 4] << 24 | io[fo - 3] << 16 | io[fo - 2] << 8 | io[fo - 1]) >>> 0, Li = _o > 1 ? fo + _o : io.byteLength;
                    return io.subarray(fo + 4, Li);
                  }
                  fo++;
                }
                return io.subarray(io.length);
              }, Pi = function(io, xo, fo) {
                xo === void 0 && (xo = 4), fo === void 0 && (fo = function(Yi) {
                  return (0, si.bytesToNumber)(Yi);
                });
                var _o = [];
                if (!io || !io.length)
                  return _o;
                for (var Li = (0, si.bytesToNumber)(io.subarray(4, 8)), Co = 8; Li; Co += xo, Li--)
                  _o.push(fo(io.subarray(Co, Co + xo)));
                return _o;
              }, $i = function(io, xo) {
                for (var fo = Pi(xi(io, ["stss"])[0]), _o = Pi(xi(io, ["stco"])[0]), Li = Pi(xi(io, ["stts"])[0], 8, function(qo) {
                  return {
                    sampleCount: (0, si.bytesToNumber)(qo.subarray(0, 4)),
                    sampleDelta: (0, si.bytesToNumber)(qo.subarray(4, 8))
                  };
                }), Co = Pi(xi(io, ["stsc"])[0], 12, function(qo) {
                  return {
                    firstChunk: (0, si.bytesToNumber)(qo.subarray(0, 4)),
                    samplesPerChunk: (0, si.bytesToNumber)(qo.subarray(4, 8)),
                    sampleDescriptionIndex: (0, si.bytesToNumber)(qo.subarray(8, 12))
                  };
                }), Ni = xi(io, ["stsz"])[0], Yi = Pi(Ni && Ni.length && Ni.subarray(4) || null), Vo = [], No = 0; No < _o.length; No++) {
                  for (var Ui = void 0, jo = 0; jo < Co.length; jo++) {
                    var Wi = Co[jo], ji = No + 1 >= Wi.firstChunk && (jo + 1 >= Co.length || No + 1 < Co[jo + 1].firstChunk);
                    if (ji) {
                      Ui = Wi.samplesPerChunk;
                      break;
                    }
                  }
                  for (var Hi = _o[No], zo = 0; zo < Ui; zo++) {
                    var Lo = Yi[Vo.length], sa = !fo.length;
                    fo.length && fo.indexOf(Vo.length + 1) !== -1 && (sa = !0);
                    for (var Ko = {
                      keyframe: sa,
                      start: Hi,
                      end: Hi + Lo
                    }, ca = 0; ca < Li.length; ca++) {
                      var pa = Li[ca], ga = pa.sampleCount, ia = pa.sampleDelta;
                      if (Vo.length <= ga) {
                        var ra = Vo.length ? Vo[Vo.length - 1].timestamp : 0;
                        Ko.timestamp = ra + ia / xo * 1e3, Ko.duration = ia;
                        break;
                      }
                    }
                    Vo.push(Ko), Hi += Lo;
                  }
                }
                return Vo;
              }, Oi = function(io, xo) {
                var fo = (0, si.bytesToString)(xo.subarray(0, 4));
                if (io.type === "video" ? (io.info = io.info || {}, io.info.width = xo[28] << 8 | xo[29], io.info.height = xo[30] << 8 | xo[31]) : io.type === "audio" && (io.info = io.info || {}, io.info.channels = xo[20] << 8 | xo[21], io.info.bitDepth = xo[22] << 8 | xo[23], io.info.sampleRate = xo[28] << 8 | xo[29]), fo === "avc1") {
                  var _o = Si(xo, "avcC");
                  fo += "." + (0, di.getAvcCodec)(_o), io.info.avcC = _o;
                } else if (fo === "hvc1" || fo === "hev1")
                  fo += "." + (0, di.getHvcCodec)(Si(xo, "hvcC"));
                else if (fo === "mp4a" || fo === "mp4v") {
                  var Li = Si(xo, "esds"), Co = vi(Li.subarray(4))[0], Ni = Co && Co.descriptors.filter(function(sa) {
                    var Ko = sa.tag;
                    return Ko === 4;
                  })[0];
                  Ni ? (fo += "." + (0, si.toHexString)(Ni.oti), Ni.oti === 64 ? fo += "." + (Ni.descriptors[0].bytes[0] >> 3).toString() : Ni.oti === 32 ? fo += "." + Ni.descriptors[0].bytes[4].toString() : Ni.oti === 221 && (fo = "vorbis")) : io.type === "audio" ? fo += ".40.2" : fo += ".20.9";
                } else if (fo === "av01")
                  fo += "." + (0, di.getAv1Codec)(Si(xo, "av1C"));
                else if (fo === "vp09") {
                  var Yi = Si(xo, "vpcC"), Vo = Yi[0], No = Yi[1], Ui = Yi[2] >> 4, jo = (Yi[2] & 15) >> 1, Wi = (Yi[2] & 15) >> 3, ji = Yi[3], Hi = Yi[4], zo = Yi[5];
                  fo += "." + (0, si.padStart)(Vo, 2, "0"), fo += "." + (0, si.padStart)(No, 2, "0"), fo += "." + (0, si.padStart)(Ui, 2, "0"), fo += "." + (0, si.padStart)(jo, 2, "0"), fo += "." + (0, si.padStart)(ji, 2, "0"), fo += "." + (0, si.padStart)(Hi, 2, "0"), fo += "." + (0, si.padStart)(zo, 2, "0"), fo += "." + (0, si.padStart)(Wi, 2, "0");
                } else if (fo === "theo")
                  fo = "theora";
                else if (fo === "spex")
                  fo = "speex";
                else if (fo === ".mp3")
                  fo = "mp4a.40.34";
                else if (fo === "msVo")
                  fo = "vorbis";
                else if (fo === "Opus") {
                  fo = "opus";
                  var Lo = Si(xo, "dOps");
                  io.info.opus = (0, fi.parseOpusHead)(Lo), io.info.codecDelay = 65e5;
                } else
                  fo = fo.toLowerCase();
                io.codec = fo;
              }, Di = function(io, xo) {
                xo === void 0 && (xo = !0), io = (0, si.toUint8)(io);
                var fo = xi(io, ["moov", "trak"], !0), _o = [];
                return fo.forEach(function(Li) {
                  var Co = {
                    bytes: Li
                  }, Ni = xi(Li, ["mdia"])[0], Yi = xi(Ni, ["hdlr"])[0], Vo = (0, si.bytesToString)(Yi.subarray(8, 12));
                  Vo === "soun" ? Co.type = "audio" : Vo === "vide" ? Co.type = "video" : Co.type = Vo;
                  var No = xi(Li, ["tkhd"])[0];
                  if (No) {
                    var Ui = new DataView(No.buffer, No.byteOffset, No.byteLength), jo = Ui.getUint8(0);
                    Co.number = jo === 0 ? Ui.getUint32(12) : Ui.getUint32(20);
                  }
                  var Wi = xi(Ni, ["mdhd"])[0];
                  if (Wi) {
                    var ji = Wi[0], Hi = ji === 0 ? 12 : 20;
                    Co.timescale = (Wi[Hi] << 24 | Wi[Hi + 1] << 16 | Wi[Hi + 2] << 8 | Wi[Hi + 3]) >>> 0;
                  }
                  for (var zo = xi(Ni, ["minf", "stbl"])[0], Lo = xi(zo, ["stsd"])[0], sa = (0, si.bytesToNumber)(Lo.subarray(4, 8)), Ko = 8; sa--; ) {
                    var ca = (0, si.bytesToNumber)(Lo.subarray(Ko, Ko + 4)), pa = Lo.subarray(Ko + 4, Ko + 4 + ca);
                    Oi(Co, pa), Ko += 4 + ca;
                  }
                  xo && (Co.frameTable = $i(zo, Co.timescale)), _o.push(Co);
                }), _o;
              }, Mi = function(io) {
                var xo = xi(io, ["moov", "mvhd"], !0)[0];
                if (!(!xo || !xo.length)) {
                  var fo = {};
                  return xo[0] === 1 ? (fo.timestampScale = (0, si.bytesToNumber)(xo.subarray(20, 24)), fo.duration = (0, si.bytesToNumber)(xo.subarray(24, 32))) : (fo.timestampScale = (0, si.bytesToNumber)(xo.subarray(12, 16)), fo.duration = (0, si.bytesToNumber)(xo.subarray(16, 20))), fo.bytes = xo, fo;
                }
              };
            })
          ),
          /***/
          "./node_modules/@videojs/vhs-utils/es/nal-helpers.js": (
            /*!***********************************************************!*\
              !*** ./node_modules/@videojs/vhs-utils/es/nal-helpers.js ***!
              \***********************************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                EMULATION_PREVENTION: () => (
                  /* binding */
                  gi
                ),
                /* harmony export */
                NAL_TYPE_ONE: () => (
                  /* binding */
                  di
                ),
                /* harmony export */
                NAL_TYPE_TWO: () => (
                  /* binding */
                  fi
                ),
                /* harmony export */
                discardEmulationPreventionBytes: () => (
                  /* binding */
                  mi
                ),
                /* harmony export */
                findH264Nal: () => (
                  /* binding */
                  vi
                ),
                /* harmony export */
                findH265Nal: () => (
                  /* binding */
                  xi
                ),
                /* harmony export */
                findNal: () => (
                  /* binding */
                  Ti
                )
                /* harmony export */
              });
              var si = oi(
                /*! ./byte-helpers.js */
                "./node_modules/@videojs/vhs-utils/es/byte-helpers.js"
              ), di = (0, si.toUint8)([0, 0, 0, 1]), fi = (0, si.toUint8)([0, 0, 1]), gi = (0, si.toUint8)([0, 0, 3]), mi = function(Pi) {
                for (var $i = [], Oi = 1; Oi < Pi.length - 2; )
                  (0, si.bytesMatch)(Pi.subarray(Oi, Oi + 3), gi) && ($i.push(Oi + 2), Oi++), Oi++;
                if ($i.length === 0)
                  return Pi;
                var Di = Pi.length - $i.length, Mi = new Uint8Array(Di), Oo = 0;
                for (Oi = 0; Oi < Di; Oo++, Oi++)
                  Oo === $i[0] && (Oo++, $i.shift()), Mi[Oi] = Pi[Oo];
                return Mi;
              }, Ti = function(Pi, $i, Oi, Di) {
                Di === void 0 && (Di = 1 / 0), Pi = (0, si.toUint8)(Pi), Oi = [].concat(Oi);
                for (var Mi = 0, Oo, io = 0; Mi < Pi.length && (io < Di || Oo); ) {
                  var xo = void 0;
                  if ((0, si.bytesMatch)(Pi.subarray(Mi), di) ? xo = 4 : (0, si.bytesMatch)(Pi.subarray(Mi), fi) && (xo = 3), !xo) {
                    Mi++;
                    continue;
                  }
                  if (io++, Oo)
                    return mi(Pi.subarray(Oo, Mi));
                  var fo = void 0;
                  $i === "h264" ? fo = Pi[Mi + xo] & 31 : $i === "h265" && (fo = Pi[Mi + xo] >> 1 & 63), Oi.indexOf(fo) !== -1 && (Oo = Mi + xo), Mi += xo + ($i === "h264" ? 1 : 2);
                }
                return Pi.subarray(0, 0);
              }, vi = function(Pi, $i, Oi) {
                return Ti(Pi, "h264", $i, Oi);
              }, xi = function(Pi, $i, Oi) {
                return Ti(Pi, "h265", $i, Oi);
              };
            })
          ),
          /***/
          "./node_modules/@videojs/vhs-utils/es/opus-helpers.js": (
            /*!************************************************************!*\
              !*** ./node_modules/@videojs/vhs-utils/es/opus-helpers.js ***!
              \************************************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                OPUS_HEAD: () => (
                  /* binding */
                  si
                ),
                /* harmony export */
                parseOpusHead: () => (
                  /* binding */
                  di
                ),
                /* harmony export */
                setOpusHead: () => (
                  /* binding */
                  fi
                )
                /* harmony export */
              });
              var si = new Uint8Array([
                // O, p, u, s
                79,
                112,
                117,
                115,
                // H, e, a, d
                72,
                101,
                97,
                100
              ]), di = function(mi) {
                var Ti = new DataView(mi.buffer, mi.byteOffset, mi.byteLength), vi = Ti.getUint8(0), xi = vi !== 0, Si = {
                  version: vi,
                  channels: Ti.getUint8(1),
                  preSkip: Ti.getUint16(2, xi),
                  sampleRate: Ti.getUint32(4, xi),
                  outputGain: Ti.getUint16(8, xi),
                  channelMappingFamily: Ti.getUint8(10)
                };
                if (Si.channelMappingFamily > 0 && mi.length > 10) {
                  Si.streamCount = Ti.getUint8(11), Si.twoChannelStreamCount = Ti.getUint8(12), Si.channelMapping = [];
                  for (var Pi = 0; Pi < Si.channels; Pi++)
                    Si.channelMapping.push(Ti.getUint8(13 + Pi));
                }
                return Si;
              }, fi = function(mi) {
                var Ti = mi.channelMappingFamily <= 0 ? 11 : 12 + mi.channels, vi = new DataView(new ArrayBuffer(Ti)), xi = mi.version !== 0;
                return vi.setUint8(0, mi.version), vi.setUint8(1, mi.channels), vi.setUint16(2, mi.preSkip, xi), vi.setUint32(4, mi.sampleRate, xi), vi.setUint16(8, mi.outputGain, xi), vi.setUint8(10, mi.channelMappingFamily), mi.channelMappingFamily > 0 && (vi.setUint8(11, mi.streamCount), mi.channelMapping.foreach(function(Si, Pi) {
                  vi.setUint8(12 + Pi, Si);
                })), new Uint8Array(vi.buffer);
              };
            })
          ),
          /***/
          "./node_modules/@videojs/vhs-utils/es/resolve-url.js": (
            /*!***********************************************************!*\
              !*** ./node_modules/@videojs/vhs-utils/es/resolve-url.js ***!
              \***********************************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                default: () => vi
                /* harmony export */
              });
              var si = oi(
                /*! url-toolkit */
                "./node_modules/url-toolkit/src/url-toolkit.js"
              ), di = /* @__PURE__ */ oi.n(si), fi = oi(
                /*! global/window */
                "./node_modules/global/window.js"
              ), gi = /* @__PURE__ */ oi.n(fi), mi = "http://example.com", Ti = function(Si, Pi) {
                if (/^[a-z]+:/i.test(Pi))
                  return Pi;
                /^data:/.test(Si) && (Si = gi().location && gi().location.href || "");
                var $i = typeof gi().URL == "function", Oi = /^\/\//.test(Si), Di = !gi().location && !/\/\//i.test(Si);
                if ($i ? Si = new (gi()).URL(Si, gi().location || mi) : /\/\//i.test(Si) || (Si = di().buildAbsoluteURL(gi().location && gi().location.href || "", Si)), $i) {
                  var Mi = new URL(Pi, Si);
                  return Di ? Mi.href.slice(mi.length) : Oi ? Mi.href.slice(Mi.protocol.length) : Mi.href;
                }
                return di().buildAbsoluteURL(Si, Pi);
              };
              const vi = Ti;
            })
          ),
          /***/
          "./node_modules/@videojs/vhs-utils/es/stream.js": (
            /*!******************************************************!*\
              !*** ./node_modules/@videojs/vhs-utils/es/stream.js ***!
              \******************************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                default: () => (
                  /* binding */
                  si
                )
                /* harmony export */
              });
              var si = /* @__PURE__ */ (function() {
                function di() {
                  this.listeners = {};
                }
                var fi = di.prototype;
                return fi.on = function(mi, Ti) {
                  this.listeners[mi] || (this.listeners[mi] = []), this.listeners[mi].push(Ti);
                }, fi.off = function(mi, Ti) {
                  if (!this.listeners[mi])
                    return !1;
                  var vi = this.listeners[mi].indexOf(Ti);
                  return this.listeners[mi] = this.listeners[mi].slice(0), this.listeners[mi].splice(vi, 1), vi > -1;
                }, fi.trigger = function(mi) {
                  var Ti = this.listeners[mi];
                  if (Ti)
                    if (arguments.length === 2)
                      for (var vi = Ti.length, xi = 0; xi < vi; ++xi)
                        Ti[xi].call(this, arguments[1]);
                    else
                      for (var Si = Array.prototype.slice.call(arguments, 1), Pi = Ti.length, $i = 0; $i < Pi; ++$i)
                        Ti[$i].apply(this, Si);
                }, fi.dispose = function() {
                  this.listeners = {};
                }, fi.pipe = function(mi) {
                  this.on("data", function(Ti) {
                    mi.push(Ti);
                  });
                }, di;
              })();
            })
          ),
          /***/
          "./node_modules/@videojs/xhr/lib/http-handler.js": (
            /*!*******************************************************!*\
              !*** ./node_modules/@videojs/xhr/lib/http-handler.js ***!
              \*******************************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! global/window */
                "./node_modules/global/window.js"
              ), di = function(mi, Ti) {
                return Ti === void 0 && (Ti = !1), function(vi, xi, Si) {
                  if (vi) {
                    mi(vi);
                    return;
                  }
                  if (xi.statusCode >= 400 && xi.statusCode <= 599) {
                    var Pi = Si;
                    if (Ti)
                      if (si.TextDecoder) {
                        var $i = fi(xi.headers && xi.headers["content-type"]);
                        try {
                          Pi = new TextDecoder($i).decode(Si);
                        } catch {
                        }
                      } else
                        Pi = String.fromCharCode.apply(null, new Uint8Array(Si));
                    mi({
                      cause: Pi
                    });
                    return;
                  }
                  mi(null, Si);
                };
              };
              function fi(gi) {
                return gi === void 0 && (gi = ""), gi.toLowerCase().split(";").reduce(function(mi, Ti) {
                  var vi = Ti.split("="), xi = vi[0], Si = vi[1];
                  return xi.trim() === "charset" ? Si.trim() : mi;
                }, "utf-8");
              }
              ai.exports = di;
            })
          ),
          /***/
          "./node_modules/@videojs/xhr/lib/index.js": (
            /*!************************************************!*\
              !*** ./node_modules/@videojs/xhr/lib/index.js ***!
              \************************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! global/window */
                "./node_modules/global/window.js"
              ), di = oi(
                /*! @babel/runtime/helpers/extends */
                "./node_modules/@babel/runtime/helpers/extends.js"
              ), fi = oi(
                /*! is-function */
                "./node_modules/is-function/index.js"
              );
              xi.httpHandler = oi(
                /*! ./http-handler.js */
                "./node_modules/@videojs/xhr/lib/http-handler.js"
              );
              /**
               * @license
               * slighly modified parse-headers 2.0.2 <https://github.com/kesla/parse-headers/>
               * Copyright (c) 2014 David Björklund
               * Available under the MIT license
               * <https://github.com/kesla/parse-headers/blob/master/LICENCE>
               */
              var gi = function(Di) {
                var Mi = {};
                return Di && Di.trim().split(`
`).forEach(function(Oo) {
                  var io = Oo.indexOf(":"), xo = Oo.slice(0, io).trim().toLowerCase(), fo = Oo.slice(io + 1).trim();
                  typeof Mi[xo] > "u" ? Mi[xo] = fo : Array.isArray(Mi[xo]) ? Mi[xo].push(fo) : Mi[xo] = [Mi[xo], fo];
                }), Mi;
              };
              ai.exports = xi, ai.exports.default = xi, xi.XMLHttpRequest = si.XMLHttpRequest || $i, xi.XDomainRequest = "withCredentials" in new xi.XMLHttpRequest() ? xi.XMLHttpRequest : si.XDomainRequest, mi(["get", "put", "post", "patch", "head", "delete"], function(Oi) {
                xi[Oi === "delete" ? "del" : Oi] = function(Di, Mi, Oo) {
                  return Mi = vi(Di, Mi, Oo), Mi.method = Oi.toUpperCase(), Si(Mi);
                };
              });
              function mi(Oi, Di) {
                for (var Mi = 0; Mi < Oi.length; Mi++)
                  Di(Oi[Mi]);
              }
              function Ti(Oi) {
                for (var Di in Oi)
                  if (Oi.hasOwnProperty(Di)) return !1;
                return !0;
              }
              function vi(Oi, Di, Mi) {
                var Oo = Oi;
                return fi(Di) ? (Mi = Di, typeof Oi == "string" && (Oo = {
                  uri: Oi
                })) : Oo = di({}, Di, {
                  uri: Oi
                }), Oo.callback = Mi, Oo;
              }
              function xi(Oi, Di, Mi) {
                return Di = vi(Oi, Di, Mi), Si(Di);
              }
              function Si(Oi) {
                if (typeof Oi.callback > "u")
                  throw new Error("callback argument missing");
                var Di = !1, Mi = function(zo, Lo, sa) {
                  Di || (Di = !0, Oi.callback(zo, Lo, sa));
                };
                function Oo() {
                  _o.readyState === 4 && setTimeout(fo, 0);
                }
                function io() {
                  var Hi = void 0;
                  if (_o.response ? Hi = _o.response : Hi = _o.responseText || Pi(_o), jo)
                    try {
                      Hi = JSON.parse(Hi);
                    } catch {
                    }
                  return Hi;
                }
                function xo(Hi) {
                  return clearTimeout(Wi), Hi instanceof Error || (Hi = new Error("" + (Hi || "Unknown XMLHttpRequest Error"))), Hi.statusCode = 0, Mi(Hi, ji);
                }
                function fo() {
                  if (!Co) {
                    var Hi;
                    clearTimeout(Wi), Oi.useXDR && _o.status === void 0 ? Hi = 200 : Hi = _o.status === 1223 ? 204 : _o.status;
                    var zo = ji, Lo = null;
                    return Hi !== 0 ? (zo = {
                      body: io(),
                      statusCode: Hi,
                      method: Yi,
                      headers: {},
                      url: Ni,
                      rawRequest: _o
                    }, _o.getAllResponseHeaders && (zo.headers = gi(_o.getAllResponseHeaders()))) : Lo = new Error("Internal XMLHttpRequest Error"), Mi(Lo, zo, zo.body);
                  }
                }
                var _o = Oi.xhr || null;
                _o || (Oi.cors || Oi.useXDR ? _o = new xi.XDomainRequest() : _o = new xi.XMLHttpRequest());
                var Li, Co, Ni = _o.url = Oi.uri || Oi.url, Yi = _o.method = Oi.method || "GET", Vo = Oi.body || Oi.data, No = _o.headers = Oi.headers || {}, Ui = !!Oi.sync, jo = !1, Wi, ji = {
                  body: void 0,
                  headers: {},
                  statusCode: 0,
                  method: Yi,
                  url: Ni,
                  rawRequest: _o
                };
                if ("json" in Oi && Oi.json !== !1 && (jo = !0, No.accept || No.Accept || (No.Accept = "application/json"), Yi !== "GET" && Yi !== "HEAD" && (No["content-type"] || No["Content-Type"] || (No["Content-Type"] = "application/json"), Vo = JSON.stringify(Oi.json === !0 ? Vo : Oi.json))), _o.onreadystatechange = Oo, _o.onload = fo, _o.onerror = xo, _o.onprogress = function() {
                }, _o.onabort = function() {
                  Co = !0;
                }, _o.ontimeout = xo, _o.open(Yi, Ni, !Ui, Oi.username, Oi.password), Ui || (_o.withCredentials = !!Oi.withCredentials), !Ui && Oi.timeout > 0 && (Wi = setTimeout(function() {
                  if (!Co) {
                    Co = !0, _o.abort("timeout");
                    var Hi = new Error("XMLHttpRequest timeout");
                    Hi.code = "ETIMEDOUT", xo(Hi);
                  }
                }, Oi.timeout)), _o.setRequestHeader)
                  for (Li in No)
                    No.hasOwnProperty(Li) && _o.setRequestHeader(Li, No[Li]);
                else if (Oi.headers && !Ti(Oi.headers))
                  throw new Error("Headers cannot be set on an XDomainRequest object");
                return "responseType" in Oi && (_o.responseType = Oi.responseType), "beforeSend" in Oi && typeof Oi.beforeSend == "function" && Oi.beforeSend(_o), _o.send(Vo || null), _o;
              }
              function Pi(Oi) {
                try {
                  if (Oi.responseType === "document")
                    return Oi.responseXML;
                  var Di = Oi.responseXML && Oi.responseXML.documentElement.nodeName === "parsererror";
                  if (Oi.responseType === "" && !Di)
                    return Oi.responseXML;
                } catch {
                }
                return null;
              }
              function $i() {
              }
            })
          ),
          /***/
          "./node_modules/@xmldom/xmldom/lib/conventions.js": (
            /*!********************************************************!*\
              !*** ./node_modules/@xmldom/xmldom/lib/conventions.js ***!
              \********************************************************/
            /***/
            ((ai, li) => {
              function oi(mi, Ti, vi) {
                if (vi === void 0 && (vi = Array.prototype), mi && typeof vi.find == "function")
                  return vi.find.call(mi, Ti);
                for (var xi = 0; xi < mi.length; xi++)
                  if (Object.prototype.hasOwnProperty.call(mi, xi)) {
                    var Si = mi[xi];
                    if (Ti.call(void 0, Si, xi, mi))
                      return Si;
                  }
              }
              function si(mi, Ti) {
                return Ti === void 0 && (Ti = Object), Ti && typeof Ti.freeze == "function" ? Ti.freeze(mi) : mi;
              }
              function di(mi, Ti) {
                if (mi === null || typeof mi != "object")
                  throw new TypeError("target is not an object");
                for (var vi in Ti)
                  Object.prototype.hasOwnProperty.call(Ti, vi) && (mi[vi] = Ti[vi]);
                return mi;
              }
              var fi = si({
                /**
                 * `text/html`, the only mime type that triggers treating an XML document as HTML.
                 *
                 * @see DOMParser.SupportedType.isHTML
                 * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
                 * @see https://en.wikipedia.org/wiki/HTML Wikipedia
                 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
                 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring WHATWG HTML Spec
                 */
                HTML: "text/html",
                /**
                 * Helper method to check a mime type if it indicates an HTML document
                 *
                 * @param {string} [value]
                 * @returns {boolean}
                 *
                 * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
                 * @see https://en.wikipedia.org/wiki/HTML Wikipedia
                 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
                 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring 	 */
                isHTML: function(mi) {
                  return mi === fi.HTML;
                },
                /**
                 * `application/xml`, the standard mime type for XML documents.
                 *
                 * @see https://www.iana.org/assignments/media-types/application/xml IANA MimeType registration
                 * @see https://tools.ietf.org/html/rfc7303#section-9.1 RFC 7303
                 * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
                 */
                XML_APPLICATION: "application/xml",
                /**
                 * `text/html`, an alias for `application/xml`.
                 *
                 * @see https://tools.ietf.org/html/rfc7303#section-9.2 RFC 7303
                 * @see https://www.iana.org/assignments/media-types/text/xml IANA MimeType registration
                 * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
                 */
                XML_TEXT: "text/xml",
                /**
                 * `application/xhtml+xml`, indicates an XML document that has the default HTML namespace,
                 * but is parsed as an XML document.
                 *
                 * @see https://www.iana.org/assignments/media-types/application/xhtml+xml IANA MimeType registration
                 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument WHATWG DOM Spec
                 * @see https://en.wikipedia.org/wiki/XHTML Wikipedia
                 */
                XML_XHTML_APPLICATION: "application/xhtml+xml",
                /**
                 * `image/svg+xml`,
                 *
                 * @see https://www.iana.org/assignments/media-types/image/svg+xml IANA MimeType registration
                 * @see https://www.w3.org/TR/SVG11/ W3C SVG 1.1
                 * @see https://en.wikipedia.org/wiki/Scalable_Vector_Graphics Wikipedia
                 */
                XML_SVG_IMAGE: "image/svg+xml"
              }), gi = si({
                /**
                 * The XHTML namespace.
                 *
                 * @see http://www.w3.org/1999/xhtml
                 */
                HTML: "http://www.w3.org/1999/xhtml",
                /**
                 * Checks if `uri` equals `NAMESPACE.HTML`.
                 *
                 * @param {string} [uri]
                 *
                 * @see NAMESPACE.HTML
                 */
                isHTML: function(mi) {
                  return mi === gi.HTML;
                },
                /**
                 * The SVG namespace.
                 *
                 * @see http://www.w3.org/2000/svg
                 */
                SVG: "http://www.w3.org/2000/svg",
                /**
                 * The `xml:` namespace.
                 *
                 * @see http://www.w3.org/XML/1998/namespace
                 */
                XML: "http://www.w3.org/XML/1998/namespace",
                /**
                 * The `xmlns:` namespace
                 *
                 * @see https://www.w3.org/2000/xmlns/
                 */
                XMLNS: "http://www.w3.org/2000/xmlns/"
              });
              li.assign = di, li.find = oi, li.freeze = si, li.MIME_TYPE = fi, li.NAMESPACE = gi;
            })
          ),
          /***/
          "./node_modules/@xmldom/xmldom/lib/dom-parser.js": (
            /*!*******************************************************!*\
              !*** ./node_modules/@xmldom/xmldom/lib/dom-parser.js ***!
              \*******************************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! ./conventions */
                "./node_modules/@xmldom/xmldom/lib/conventions.js"
              ), di = oi(
                /*! ./dom */
                "./node_modules/@xmldom/xmldom/lib/dom.js"
              ), fi = oi(
                /*! ./entities */
                "./node_modules/@xmldom/xmldom/lib/entities.js"
              ), gi = oi(
                /*! ./sax */
                "./node_modules/@xmldom/xmldom/lib/sax.js"
              ), mi = di.DOMImplementation, Ti = si.NAMESPACE, vi = gi.ParseError, xi = gi.XMLReader;
              function Si(xo) {
                return xo.replace(/\r[\n\u0085]/g, `
`).replace(/[\r\u0085\u2028]/g, `
`);
              }
              function Pi(xo) {
                this.options = xo || { locator: {} };
              }
              Pi.prototype.parseFromString = function(xo, fo) {
                var _o = this.options, Li = new xi(), Co = _o.domBuilder || new Oi(), Ni = _o.errorHandler, Yi = _o.locator, Vo = _o.xmlns || {}, No = /\/x?html?$/.test(fo), Ui = No ? fi.HTML_ENTITIES : fi.XML_ENTITIES;
                Yi && Co.setDocumentLocator(Yi), Li.errorHandler = $i(Ni, Co, Yi), Li.domBuilder = _o.domBuilder || Co, No && (Vo[""] = Ti.HTML), Vo.xml = Vo.xml || Ti.XML;
                var jo = _o.normalizeLineEndings || Si;
                return xo && typeof xo == "string" ? Li.parse(
                  jo(xo),
                  Vo,
                  Ui
                ) : Li.errorHandler.error("invalid doc source"), Co.doc;
              };
              function $i(xo, fo, _o) {
                if (!xo) {
                  if (fo instanceof Oi)
                    return fo;
                  xo = fo;
                }
                var Li = {}, Co = xo instanceof Function;
                _o = _o || {};
                function Ni(Yi) {
                  var Vo = xo[Yi];
                  !Vo && Co && (Vo = xo.length == 2 ? function(No) {
                    xo(Yi, No);
                  } : xo), Li[Yi] = Vo && function(No) {
                    Vo("[xmldom " + Yi + "]	" + No + Mi(_o));
                  } || function() {
                  };
                }
                return Ni("warning"), Ni("error"), Ni("fatalError"), Li;
              }
              function Oi() {
                this.cdata = !1;
              }
              function Di(xo, fo) {
                fo.lineNumber = xo.lineNumber, fo.columnNumber = xo.columnNumber;
              }
              Oi.prototype = {
                startDocument: function() {
                  this.doc = new mi().createDocument(null, null, null), this.locator && (this.doc.documentURI = this.locator.systemId);
                },
                startElement: function(xo, fo, _o, Li) {
                  var Co = this.doc, Ni = Co.createElementNS(xo, _o || fo), Yi = Li.length;
                  io(this, Ni), this.currentElement = Ni, this.locator && Di(this.locator, Ni);
                  for (var Vo = 0; Vo < Yi; Vo++) {
                    var xo = Li.getURI(Vo), No = Li.getValue(Vo), _o = Li.getQName(Vo), Ui = Co.createAttributeNS(xo, _o);
                    this.locator && Di(Li.getLocator(Vo), Ui), Ui.value = Ui.nodeValue = No, Ni.setAttributeNode(Ui);
                  }
                },
                endElement: function(xo, fo, _o) {
                  var Li = this.currentElement;
                  Li.tagName, this.currentElement = Li.parentNode;
                },
                startPrefixMapping: function(xo, fo) {
                },
                endPrefixMapping: function(xo) {
                },
                processingInstruction: function(xo, fo) {
                  var _o = this.doc.createProcessingInstruction(xo, fo);
                  this.locator && Di(this.locator, _o), io(this, _o);
                },
                ignorableWhitespace: function(xo, fo, _o) {
                },
                characters: function(xo, fo, _o) {
                  if (xo = Oo.apply(this, arguments), xo) {
                    if (this.cdata)
                      var Li = this.doc.createCDATASection(xo);
                    else
                      var Li = this.doc.createTextNode(xo);
                    this.currentElement ? this.currentElement.appendChild(Li) : /^\s*$/.test(xo) && this.doc.appendChild(Li), this.locator && Di(this.locator, Li);
                  }
                },
                skippedEntity: function(xo) {
                },
                endDocument: function() {
                  this.doc.normalize();
                },
                setDocumentLocator: function(xo) {
                  (this.locator = xo) && (xo.lineNumber = 0);
                },
                //LexicalHandler
                comment: function(xo, fo, _o) {
                  xo = Oo.apply(this, arguments);
                  var Li = this.doc.createComment(xo);
                  this.locator && Di(this.locator, Li), io(this, Li);
                },
                startCDATA: function() {
                  this.cdata = !0;
                },
                endCDATA: function() {
                  this.cdata = !1;
                },
                startDTD: function(xo, fo, _o) {
                  var Li = this.doc.implementation;
                  if (Li && Li.createDocumentType) {
                    var Co = Li.createDocumentType(xo, fo, _o);
                    this.locator && Di(this.locator, Co), io(this, Co), this.doc.doctype = Co;
                  }
                },
                /**
                 * @see org.xml.sax.ErrorHandler
                 * @link http://www.saxproject.org/apidoc/org/xml/sax/ErrorHandler.html
                 */
                warning: function(xo) {
                  console.warn("[xmldom warning]	" + xo, Mi(this.locator));
                },
                error: function(xo) {
                  console.error("[xmldom error]	" + xo, Mi(this.locator));
                },
                fatalError: function(xo) {
                  throw new vi(xo, this.locator);
                }
              };
              function Mi(xo) {
                if (xo)
                  return `
@` + (xo.systemId || "") + "#[line:" + xo.lineNumber + ",col:" + xo.columnNumber + "]";
              }
              function Oo(xo, fo, _o) {
                return typeof xo == "string" ? xo.substr(fo, _o) : xo.length >= fo + _o || fo ? new java.lang.String(xo, fo, _o) + "" : xo;
              }
              "endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g, function(xo) {
                Oi.prototype[xo] = function() {
                  return null;
                };
              });
              function io(xo, fo) {
                xo.currentElement ? xo.currentElement.appendChild(fo) : xo.doc.appendChild(fo);
              }
              li.__DOMHandler = Oi, li.normalizeLineEndings = Si, li.DOMParser = Pi;
            })
          ),
          /***/
          "./node_modules/@xmldom/xmldom/lib/dom.js": (
            /*!************************************************!*\
              !*** ./node_modules/@xmldom/xmldom/lib/dom.js ***!
              \************************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! ./conventions */
                "./node_modules/@xmldom/xmldom/lib/conventions.js"
              ), di = si.find, fi = si.NAMESPACE;
              function gi(za) {
                return za !== "";
              }
              function mi(za) {
                return za ? za.split(/[\t\n\f\r ]+/).filter(gi) : [];
              }
              function Ti(za, Ya) {
                return za.hasOwnProperty(Ya) || (za[Ya] = !0), za;
              }
              function vi(za) {
                if (!za) return [];
                var Ya = mi(za);
                return Object.keys(Ya.reduce(Ti, {}));
              }
              function xi(za) {
                return function(Ya) {
                  return za && za.indexOf(Ya) !== -1;
                };
              }
              function Si(za, Ya) {
                for (var Ws in za)
                  Object.prototype.hasOwnProperty.call(za, Ws) && (Ya[Ws] = za[Ws]);
              }
              function Pi(za, Ya) {
                var Ws = za.prototype;
                if (!(Ws instanceof Ya)) {
                  let wl = function() {
                  };
                  wl.prototype = Ya.prototype, wl = new wl(), Si(Ws, wl), za.prototype = Ws = wl;
                }
                Ws.constructor != za && (typeof za != "function" && console.error("unknown Class:" + za), Ws.constructor = za);
              }
              var $i = {}, Oi = $i.ELEMENT_NODE = 1, Di = $i.ATTRIBUTE_NODE = 2, Mi = $i.TEXT_NODE = 3, Oo = $i.CDATA_SECTION_NODE = 4, io = $i.ENTITY_REFERENCE_NODE = 5, xo = $i.ENTITY_NODE = 6, fo = $i.PROCESSING_INSTRUCTION_NODE = 7, _o = $i.COMMENT_NODE = 8, Li = $i.DOCUMENT_NODE = 9, Co = $i.DOCUMENT_TYPE_NODE = 10, Ni = $i.DOCUMENT_FRAGMENT_NODE = 11, Yi = $i.NOTATION_NODE = 12, Vo = {}, No = {};
              Vo.INDEX_SIZE_ERR = (No[1] = "Index size error", 1), Vo.DOMSTRING_SIZE_ERR = (No[2] = "DOMString size error", 2);
              var Ui = Vo.HIERARCHY_REQUEST_ERR = (No[3] = "Hierarchy request error", 3);
              Vo.WRONG_DOCUMENT_ERR = (No[4] = "Wrong document", 4), Vo.INVALID_CHARACTER_ERR = (No[5] = "Invalid character", 5), Vo.NO_DATA_ALLOWED_ERR = (No[6] = "No data allowed", 6), Vo.NO_MODIFICATION_ALLOWED_ERR = (No[7] = "No modification allowed", 7);
              var jo = Vo.NOT_FOUND_ERR = (No[8] = "Not found", 8);
              Vo.NOT_SUPPORTED_ERR = (No[9] = "Not supported", 9);
              var Wi = Vo.INUSE_ATTRIBUTE_ERR = (No[10] = "Attribute in use", 10);
              Vo.INVALID_STATE_ERR = (No[11] = "Invalid state", 11), Vo.SYNTAX_ERR = (No[12] = "Syntax error", 12), Vo.INVALID_MODIFICATION_ERR = (No[13] = "Invalid modification", 13), Vo.NAMESPACE_ERR = (No[14] = "Invalid namespace", 14), Vo.INVALID_ACCESS_ERR = (No[15] = "Invalid access", 15);
              function ji(za, Ya) {
                if (Ya instanceof Error)
                  var Ws = Ya;
                else
                  Ws = this, Error.call(this, No[za]), this.message = No[za], Error.captureStackTrace && Error.captureStackTrace(this, ji);
                return Ws.code = za, Ya && (this.message = this.message + ": " + Ya), Ws;
              }
              ji.prototype = Error.prototype, Si(Vo, ji);
              function Hi() {
              }
              Hi.prototype = {
                /**
                 * The number of nodes in the list. The range of valid child node indices is 0 to length-1 inclusive.
                 * @standard level1
                 */
                length: 0,
                /**
                 * Returns the indexth item in the collection. If index is greater than or equal to the number of nodes in the list, this returns null.
                 * @standard level1
                 * @param index  unsigned long
                 *   Index into the collection.
                 * @return Node
                 * 	The node at the indexth position in the NodeList, or null if that is not a valid index.
                 */
                item: function(za) {
                  return za >= 0 && za < this.length ? this[za] : null;
                },
                toString: function(za, Ya) {
                  for (var Ws = [], wl = 0; wl < this.length; wl++)
                    Ku(this[wl], Ws, za, Ya);
                  return Ws.join("");
                },
                /**
                 * @private
                 * @param {function (Node):boolean} predicate
                 * @returns {Node[]}
                 */
                filter: function(za) {
                  return Array.prototype.filter.call(this, za);
                },
                /**
                 * @private
                 * @param {Node} item
                 * @returns {number}
                 */
                indexOf: function(za) {
                  return Array.prototype.indexOf.call(this, za);
                }
              };
              function zo(za, Ya) {
                this._node = za, this._refresh = Ya, Lo(this);
              }
              function Lo(za) {
                var Ya = za._node._inc || za._node.ownerDocument._inc;
                if (za._inc !== Ya) {
                  var Ws = za._refresh(za._node);
                  if (du(za, "length", Ws.length), !za.$$length || Ws.length < za.$$length)
                    for (var wl = Ws.length; wl in za; wl++)
                      Object.prototype.hasOwnProperty.call(za, wl) && delete za[wl];
                  Si(Ws, za), za._inc = Ya;
                }
              }
              zo.prototype.item = function(za) {
                return Lo(this), this[za] || null;
              }, Pi(zo, Hi);
              function sa() {
              }
              function Ko(za, Ya) {
                for (var Ws = za.length; Ws--; )
                  if (za[Ws] === Ya)
                    return Ws;
              }
              function ca(za, Ya, Ws, wl) {
                if (wl ? Ya[Ko(Ya, wl)] = Ws : Ya[Ya.length++] = Ws, za) {
                  Ws.ownerElement = za;
                  var Gl = za.ownerDocument;
                  Gl && (wl && ys(Gl, za, wl), $a(Gl, za, Ws));
                }
              }
              function pa(za, Ya, Ws) {
                var wl = Ko(Ya, Ws);
                if (wl >= 0) {
                  for (var Gl = Ya.length - 1; wl < Gl; )
                    Ya[wl] = Ya[++wl];
                  if (Ya.length = Gl, za) {
                    var bl = za.ownerDocument;
                    bl && (ys(bl, za, Ws), Ws.ownerElement = null);
                  }
                } else
                  throw new ji(jo, new Error(za.tagName + "@" + Ws));
              }
              sa.prototype = {
                length: 0,
                item: Hi.prototype.item,
                getNamedItem: function(za) {
                  for (var Ya = this.length; Ya--; ) {
                    var Ws = this[Ya];
                    if (Ws.nodeName == za)
                      return Ws;
                  }
                },
                setNamedItem: function(za) {
                  var Ya = za.ownerElement;
                  if (Ya && Ya != this._ownerElement)
                    throw new ji(Wi);
                  var Ws = this.getNamedItem(za.nodeName);
                  return ca(this._ownerElement, this, za, Ws), Ws;
                },
                /* returns Node */
                setNamedItemNS: function(za) {
                  var Ya = za.ownerElement, Ws;
                  if (Ya && Ya != this._ownerElement)
                    throw new ji(Wi);
                  return Ws = this.getNamedItemNS(za.namespaceURI, za.localName), ca(this._ownerElement, this, za, Ws), Ws;
                },
                /* returns Node */
                removeNamedItem: function(za) {
                  var Ya = this.getNamedItem(za);
                  return pa(this._ownerElement, this, Ya), Ya;
                },
                // raises: NOT_FOUND_ERR,NO_MODIFICATION_ALLOWED_ERR
                //for level2
                removeNamedItemNS: function(za, Ya) {
                  var Ws = this.getNamedItemNS(za, Ya);
                  return pa(this._ownerElement, this, Ws), Ws;
                },
                getNamedItemNS: function(za, Ya) {
                  for (var Ws = this.length; Ws--; ) {
                    var wl = this[Ws];
                    if (wl.localName == Ya && wl.namespaceURI == za)
                      return wl;
                  }
                  return null;
                }
              };
              function ga() {
              }
              ga.prototype = {
                /**
                 * The DOMImplementation.hasFeature() method returns a Boolean flag indicating if a given feature is supported.
                 * The different implementations fairly diverged in what kind of features were reported.
                 * The latest version of the spec settled to force this method to always return true, where the functionality was accurate and in use.
                 *
                 * @deprecated It is deprecated and modern browsers return true in all cases.
                 *
                 * @param {string} feature
                 * @param {string} [version]
                 * @returns {boolean} always true
                 *
                 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/hasFeature MDN
                 * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-5CED94D7 DOM Level 1 Core
                 * @see https://dom.spec.whatwg.org/#dom-domimplementation-hasfeature DOM Living Standard
                 */
                hasFeature: function(za, Ya) {
                  return !0;
                },
                /**
                 * Creates an XML Document object of the specified type with its document element.
                 *
                 * __It behaves slightly different from the description in the living standard__:
                 * - There is no interface/class `XMLDocument`, it returns a `Document` instance.
                 * - `contentType`, `encoding`, `mode`, `origin`, `url` fields are currently not declared.
                 * - this implementation is not validating names or qualified names
                 *   (when parsing XML strings, the SAX parser takes care of that)
                 *
                 * @param {string|null} namespaceURI
                 * @param {string} qualifiedName
                 * @param {DocumentType=null} doctype
                 * @returns {Document}
                 *
                 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocument MDN
                 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocument DOM Level 2 Core (initial)
                 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument  DOM Level 2 Core
                 *
                 * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
                 * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
                 * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
                 */
                createDocument: function(za, Ya, Ws) {
                  var wl = new xa();
                  if (wl.implementation = this, wl.childNodes = new Hi(), wl.doctype = Ws || null, Ws && wl.appendChild(Ws), Ya) {
                    var Gl = wl.createElementNS(za, Ya);
                    wl.appendChild(Gl);
                  }
                  return wl;
                },
                /**
                 * Returns a doctype, with the given `qualifiedName`, `publicId`, and `systemId`.
                 *
                 * __This behavior is slightly different from the in the specs__:
                 * - this implementation is not validating names or qualified names
                 *   (when parsing XML strings, the SAX parser takes care of that)
                 *
                 * @param {string} qualifiedName
                 * @param {string} [publicId]
                 * @param {string} [systemId]
                 * @returns {DocumentType} which can either be used with `DOMImplementation.createDocument` upon document creation
                 * 				  or can be put into the document via methods like `Node.insertBefore()` or `Node.replaceChild()`
                 *
                 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocumentType MDN
                 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocType DOM Level 2 Core
                 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocumenttype DOM Living Standard
                 *
                 * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
                 * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
                 * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
                 */
                createDocumentType: function(za, Ya, Ws) {
                  var wl = new sl();
                  return wl.name = za, wl.nodeName = za, wl.publicId = Ya || "", wl.systemId = Ws || "", wl;
                }
              };
              function ia() {
              }
              ia.prototype = {
                firstChild: null,
                lastChild: null,
                previousSibling: null,
                nextSibling: null,
                attributes: null,
                parentNode: null,
                childNodes: null,
                ownerDocument: null,
                nodeValue: null,
                namespaceURI: null,
                prefix: null,
                localName: null,
                // Modified in DOM Level 2:
                insertBefore: function(za, Ya) {
                  return _s(this, za, Ya);
                },
                replaceChild: function(za, Ya) {
                  _s(this, za, Ya, _a), Ya && this.removeChild(Ya);
                },
                removeChild: function(za) {
                  return Xa(this, za);
                },
                appendChild: function(za) {
                  return this.insertBefore(za, null);
                },
                hasChildNodes: function() {
                  return this.firstChild != null;
                },
                cloneNode: function(za) {
                  return uu(this.ownerDocument || this, this, za);
                },
                // Modified in DOM Level 2:
                normalize: function() {
                  for (var za = this.firstChild; za; ) {
                    var Ya = za.nextSibling;
                    Ya && Ya.nodeType == Mi && za.nodeType == Mi ? (this.removeChild(Ya), za.appendData(Ya.data)) : (za.normalize(), za = Ya);
                  }
                },
                // Introduced in DOM Level 2:
                isSupported: function(za, Ya) {
                  return this.ownerDocument.implementation.hasFeature(za, Ya);
                },
                // Introduced in DOM Level 2:
                hasAttributes: function() {
                  return this.attributes.length > 0;
                },
                /**
                 * Look up the prefix associated to the given namespace URI, starting from this node.
                 * **The default namespace declarations are ignored by this method.**
                 * See Namespace Prefix Lookup for details on the algorithm used by this method.
                 *
                 * _Note: The implementation seems to be incomplete when compared to the algorithm described in the specs._
                 *
                 * @param {string | null} namespaceURI
                 * @returns {string | null}
                 * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#Node3-lookupNamespacePrefix
                 * @see https://www.w3.org/TR/DOM-Level-3-Core/namespaces-algorithms.html#lookupNamespacePrefixAlgo
                 * @see https://dom.spec.whatwg.org/#dom-node-lookupprefix
                 * @see https://github.com/xmldom/xmldom/issues/322
                 */
                lookupPrefix: function(za) {
                  for (var Ya = this; Ya; ) {
                    var Ws = Ya._nsMap;
                    if (Ws) {
                      for (var wl in Ws)
                        if (Object.prototype.hasOwnProperty.call(Ws, wl) && Ws[wl] === za)
                          return wl;
                    }
                    Ya = Ya.nodeType == Di ? Ya.ownerDocument : Ya.parentNode;
                  }
                  return null;
                },
                // Introduced in DOM Level 3:
                lookupNamespaceURI: function(za) {
                  for (var Ya = this; Ya; ) {
                    var Ws = Ya._nsMap;
                    if (Ws && Object.prototype.hasOwnProperty.call(Ws, za))
                      return Ws[za];
                    Ya = Ya.nodeType == Di ? Ya.ownerDocument : Ya.parentNode;
                  }
                  return null;
                },
                // Introduced in DOM Level 3:
                isDefaultNamespace: function(za) {
                  var Ya = this.lookupPrefix(za);
                  return Ya == null;
                }
              };
              function ra(za) {
                return za == "<" && "&lt;" || za == ">" && "&gt;" || za == "&" && "&amp;" || za == '"' && "&quot;" || "&#" + za.charCodeAt() + ";";
              }
              Si($i, ia), Si($i, ia.prototype);
              function qo(za, Ya) {
                if (Ya(za))
                  return !0;
                if (za = za.firstChild)
                  do
                    if (qo(za, Ya))
                      return !0;
                  while (za = za.nextSibling);
              }
              function xa() {
                this.ownerDocument = this;
              }
              function $a(za, Ya, Ws) {
                za && za._inc++;
                var wl = Ws.namespaceURI;
                wl === fi.XMLNS && (Ya._nsMap[Ws.prefix ? Ws.localName : ""] = Ws.value);
              }
              function ys(za, Ya, Ws, wl) {
                za && za._inc++;
                var Gl = Ws.namespaceURI;
                Gl === fi.XMLNS && delete Ya._nsMap[Ws.prefix ? Ws.localName : ""];
              }
              function Ss(za, Ya, Ws) {
                if (za && za._inc) {
                  za._inc++;
                  var wl = Ya.childNodes;
                  if (Ws)
                    wl[wl.length++] = Ws;
                  else {
                    for (var Gl = Ya.firstChild, bl = 0; Gl; )
                      wl[bl++] = Gl, Gl = Gl.nextSibling;
                    wl.length = bl, delete wl[wl.length];
                  }
                }
              }
              function Xa(za, Ya) {
                var Ws = Ya.previousSibling, wl = Ya.nextSibling;
                return Ws ? Ws.nextSibling = wl : za.firstChild = wl, wl ? wl.previousSibling = Ws : za.lastChild = Ws, Ya.parentNode = null, Ya.previousSibling = null, Ya.nextSibling = null, Ss(za.ownerDocument, za), Ya;
              }
              function Es(za) {
                return za && (za.nodeType === ia.DOCUMENT_NODE || za.nodeType === ia.DOCUMENT_FRAGMENT_NODE || za.nodeType === ia.ELEMENT_NODE);
              }
              function Rs(za) {
                return za && (Ja(za) || ja(za) || La(za) || za.nodeType === ia.DOCUMENT_FRAGMENT_NODE || za.nodeType === ia.COMMENT_NODE || za.nodeType === ia.PROCESSING_INSTRUCTION_NODE);
              }
              function La(za) {
                return za && za.nodeType === ia.DOCUMENT_TYPE_NODE;
              }
              function Ja(za) {
                return za && za.nodeType === ia.ELEMENT_NODE;
              }
              function ja(za) {
                return za && za.nodeType === ia.TEXT_NODE;
              }
              function Ta(za, Ya) {
                var Ws = za.childNodes || [];
                if (di(Ws, Ja) || La(Ya))
                  return !1;
                var wl = di(Ws, La);
                return !(Ya && wl && Ws.indexOf(wl) > Ws.indexOf(Ya));
              }
              function rs(za, Ya) {
                var Ws = za.childNodes || [];
                function wl(bl) {
                  return Ja(bl) && bl !== Ya;
                }
                if (di(Ws, wl))
                  return !1;
                var Gl = di(Ws, La);
                return !(Ya && Gl && Ws.indexOf(Gl) > Ws.indexOf(Ya));
              }
              function Qa(za, Ya, Ws) {
                if (!Es(za))
                  throw new ji(Ui, "Unexpected parent node type " + za.nodeType);
                if (Ws && Ws.parentNode !== za)
                  throw new ji(jo, "child not in parent");
                if (
                  // 4. If `node` is not a DocumentFragment, DocumentType, Element, or CharacterData node, then throw a "HierarchyRequestError" DOMException.
                  !Rs(Ya) || // 5. If either `node` is a Text node and `parent` is a document,
                  // the sax parser currently adds top level text nodes, this will be fixed in 0.9.0
                  // || (node.nodeType === Node.TEXT_NODE && parent.nodeType === Node.DOCUMENT_NODE)
                  // or `node` is a doctype and `parent` is not a document, then throw a "HierarchyRequestError" DOMException.
                  La(Ya) && za.nodeType !== ia.DOCUMENT_NODE
                )
                  throw new ji(
                    Ui,
                    "Unexpected node type " + Ya.nodeType + " for parent node type " + za.nodeType
                  );
              }
              function Cs(za, Ya, Ws) {
                var wl = za.childNodes || [], Gl = Ya.childNodes || [];
                if (Ya.nodeType === ia.DOCUMENT_FRAGMENT_NODE) {
                  var bl = Gl.filter(Ja);
                  if (bl.length > 1 || di(Gl, ja))
                    throw new ji(Ui, "More than one element or text in fragment");
                  if (bl.length === 1 && !Ta(za, Ws))
                    throw new ji(Ui, "Element in fragment can not be inserted before doctype");
                }
                if (Ja(Ya) && !Ta(za, Ws))
                  throw new ji(Ui, "Only one element can be added and only after doctype");
                if (La(Ya)) {
                  if (di(wl, La))
                    throw new ji(Ui, "Only one doctype is allowed");
                  var Za = di(wl, Ja);
                  if (Ws && wl.indexOf(Za) < wl.indexOf(Ws))
                    throw new ji(Ui, "Doctype can only be inserted before an element");
                  if (!Ws && Za)
                    throw new ji(Ui, "Doctype can not be appended since element is present");
                }
              }
              function _a(za, Ya, Ws) {
                var wl = za.childNodes || [], Gl = Ya.childNodes || [];
                if (Ya.nodeType === ia.DOCUMENT_FRAGMENT_NODE) {
                  var bl = Gl.filter(Ja);
                  if (bl.length > 1 || di(Gl, ja))
                    throw new ji(Ui, "More than one element or text in fragment");
                  if (bl.length === 1 && !rs(za, Ws))
                    throw new ji(Ui, "Element in fragment can not be inserted before doctype");
                }
                if (Ja(Ya) && !rs(za, Ws))
                  throw new ji(Ui, "Only one element can be added and only after doctype");
                if (La(Ya)) {
                  if (di(wl, function(zs) {
                    return La(zs) && zs !== Ws;
                  }))
                    throw new ji(Ui, "Only one doctype is allowed");
                  var Za = di(wl, Ja);
                  if (Ws && wl.indexOf(Za) < wl.indexOf(Ws))
                    throw new ji(Ui, "Doctype can only be inserted before an element");
                }
              }
              function _s(za, Ya, Ws, wl) {
                Qa(za, Ya, Ws), za.nodeType === ia.DOCUMENT_NODE && (wl || Cs)(za, Ya, Ws);
                var Gl = Ya.parentNode;
                if (Gl && Gl.removeChild(Ya), Ya.nodeType === Ni) {
                  var bl = Ya.firstChild;
                  if (bl == null)
                    return Ya;
                  var Za = Ya.lastChild;
                } else
                  bl = Za = Ya;
                var rl = Ws ? Ws.previousSibling : za.lastChild;
                bl.previousSibling = rl, Za.nextSibling = Ws, rl ? rl.nextSibling = bl : za.firstChild = bl, Ws == null ? za.lastChild = Za : Ws.previousSibling = Za;
                do
                  bl.parentNode = za;
                while (bl !== Za && (bl = bl.nextSibling));
                return Ss(za.ownerDocument || za, za), Ya.nodeType == Ni && (Ya.firstChild = Ya.lastChild = null), Ya;
              }
              function el(za, Ya) {
                return Ya.parentNode && Ya.parentNode.removeChild(Ya), Ya.parentNode = za, Ya.previousSibling = za.lastChild, Ya.nextSibling = null, Ya.previousSibling ? Ya.previousSibling.nextSibling = Ya : za.firstChild = Ya, za.lastChild = Ya, Ss(za.ownerDocument, za, Ya), Ya;
              }
              xa.prototype = {
                //implementation : null,
                nodeName: "#document",
                nodeType: Li,
                /**
                 * The DocumentType node of the document.
                 *
                 * @readonly
                 * @type DocumentType
                 */
                doctype: null,
                documentElement: null,
                _inc: 1,
                insertBefore: function(za, Ya) {
                  if (za.nodeType == Ni) {
                    for (var Ws = za.firstChild; Ws; ) {
                      var wl = Ws.nextSibling;
                      this.insertBefore(Ws, Ya), Ws = wl;
                    }
                    return za;
                  }
                  return _s(this, za, Ya), za.ownerDocument = this, this.documentElement === null && za.nodeType === Oi && (this.documentElement = za), za;
                },
                removeChild: function(za) {
                  return this.documentElement == za && (this.documentElement = null), Xa(this, za);
                },
                replaceChild: function(za, Ya) {
                  _s(this, za, Ya, _a), za.ownerDocument = this, Ya && this.removeChild(Ya), Ja(za) && (this.documentElement = za);
                },
                // Introduced in DOM Level 2:
                importNode: function(za, Ya) {
                  return Wl(this, za, Ya);
                },
                // Introduced in DOM Level 2:
                getElementById: function(za) {
                  var Ya = null;
                  return qo(this.documentElement, function(Ws) {
                    if (Ws.nodeType == Oi && Ws.getAttribute("id") == za)
                      return Ya = Ws, !0;
                  }), Ya;
                },
                /**
                 * The `getElementsByClassName` method of `Document` interface returns an array-like object
                 * of all child elements which have **all** of the given class name(s).
                 *
                 * Returns an empty list if `classeNames` is an empty string or only contains HTML white space characters.
                 *
                 *
                 * Warning: This is a live LiveNodeList.
                 * Changes in the DOM will reflect in the array as the changes occur.
                 * If an element selected by this array no longer qualifies for the selector,
                 * it will automatically be removed. Be aware of this for iteration purposes.
                 *
                 * @param {string} classNames is a string representing the class name(s) to match; multiple class names are separated by (ASCII-)whitespace
                 *
                 * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/getElementsByClassName
                 * @see https://dom.spec.whatwg.org/#concept-getelementsbyclassname
                 */
                getElementsByClassName: function(za) {
                  var Ya = vi(za);
                  return new zo(this, function(Ws) {
                    var wl = [];
                    return Ya.length > 0 && qo(Ws.documentElement, function(Gl) {
                      if (Gl !== Ws && Gl.nodeType === Oi) {
                        var bl = Gl.getAttribute("class");
                        if (bl) {
                          var Za = za === bl;
                          if (!Za) {
                            var rl = vi(bl);
                            Za = Ya.every(xi(rl));
                          }
                          Za && wl.push(Gl);
                        }
                      }
                    }), wl;
                  });
                },
                //document factory method:
                createElement: function(za) {
                  var Ya = new Ps();
                  Ya.ownerDocument = this, Ya.nodeName = za, Ya.tagName = za, Ya.localName = za, Ya.childNodes = new Hi();
                  var Ws = Ya.attributes = new sa();
                  return Ws._ownerElement = Ya, Ya;
                },
                createDocumentFragment: function() {
                  var za = new ql();
                  return za.ownerDocument = this, za.childNodes = new Hi(), za;
                },
                createTextNode: function(za) {
                  var Ya = new es();
                  return Ya.ownerDocument = this, Ya.appendData(za), Ya;
                },
                createComment: function(za) {
                  var Ya = new Is();
                  return Ya.ownerDocument = this, Ya.appendData(za), Ya;
                },
                createCDATASection: function(za) {
                  var Ya = new fl();
                  return Ya.ownerDocument = this, Ya.appendData(za), Ya;
                },
                createProcessingInstruction: function(za, Ya) {
                  var Ws = new xl();
                  return Ws.ownerDocument = this, Ws.tagName = Ws.nodeName = Ws.target = za, Ws.nodeValue = Ws.data = Ya, Ws;
                },
                createAttribute: function(za) {
                  var Ya = new nl();
                  return Ya.ownerDocument = this, Ya.name = za, Ya.nodeName = za, Ya.localName = za, Ya.specified = !0, Ya;
                },
                createEntityReference: function(za) {
                  var Ya = new Bl();
                  return Ya.ownerDocument = this, Ya.nodeName = za, Ya;
                },
                // Introduced in DOM Level 2:
                createElementNS: function(za, Ya) {
                  var Ws = new Ps(), wl = Ya.split(":"), Gl = Ws.attributes = new sa();
                  return Ws.childNodes = new Hi(), Ws.ownerDocument = this, Ws.nodeName = Ya, Ws.tagName = Ya, Ws.namespaceURI = za, wl.length == 2 ? (Ws.prefix = wl[0], Ws.localName = wl[1]) : Ws.localName = Ya, Gl._ownerElement = Ws, Ws;
                },
                // Introduced in DOM Level 2:
                createAttributeNS: function(za, Ya) {
                  var Ws = new nl(), wl = Ya.split(":");
                  return Ws.ownerDocument = this, Ws.nodeName = Ya, Ws.name = Ya, Ws.namespaceURI = za, Ws.specified = !0, wl.length == 2 ? (Ws.prefix = wl[0], Ws.localName = wl[1]) : Ws.localName = Ya, Ws;
                }
              }, Pi(xa, ia);
              function Ps() {
                this._nsMap = {};
              }
              Ps.prototype = {
                nodeType: Oi,
                hasAttribute: function(za) {
                  return this.getAttributeNode(za) != null;
                },
                getAttribute: function(za) {
                  var Ya = this.getAttributeNode(za);
                  return Ya && Ya.value || "";
                },
                getAttributeNode: function(za) {
                  return this.attributes.getNamedItem(za);
                },
                setAttribute: function(za, Ya) {
                  var Ws = this.ownerDocument.createAttribute(za);
                  Ws.value = Ws.nodeValue = "" + Ya, this.setAttributeNode(Ws);
                },
                removeAttribute: function(za) {
                  var Ya = this.getAttributeNode(za);
                  Ya && this.removeAttributeNode(Ya);
                },
                //four real opeartion method
                appendChild: function(za) {
                  return za.nodeType === Ni ? this.insertBefore(za, null) : el(this, za);
                },
                setAttributeNode: function(za) {
                  return this.attributes.setNamedItem(za);
                },
                setAttributeNodeNS: function(za) {
                  return this.attributes.setNamedItemNS(za);
                },
                removeAttributeNode: function(za) {
                  return this.attributes.removeNamedItem(za.nodeName);
                },
                //get real attribute name,and remove it by removeAttributeNode
                removeAttributeNS: function(za, Ya) {
                  var Ws = this.getAttributeNodeNS(za, Ya);
                  Ws && this.removeAttributeNode(Ws);
                },
                hasAttributeNS: function(za, Ya) {
                  return this.getAttributeNodeNS(za, Ya) != null;
                },
                getAttributeNS: function(za, Ya) {
                  var Ws = this.getAttributeNodeNS(za, Ya);
                  return Ws && Ws.value || "";
                },
                setAttributeNS: function(za, Ya, Ws) {
                  var wl = this.ownerDocument.createAttributeNS(za, Ya);
                  wl.value = wl.nodeValue = "" + Ws, this.setAttributeNode(wl);
                },
                getAttributeNodeNS: function(za, Ya) {
                  return this.attributes.getNamedItemNS(za, Ya);
                },
                getElementsByTagName: function(za) {
                  return new zo(this, function(Ya) {
                    var Ws = [];
                    return qo(Ya, function(wl) {
                      wl !== Ya && wl.nodeType == Oi && (za === "*" || wl.tagName == za) && Ws.push(wl);
                    }), Ws;
                  });
                },
                getElementsByTagNameNS: function(za, Ya) {
                  return new zo(this, function(Ws) {
                    var wl = [];
                    return qo(Ws, function(Gl) {
                      Gl !== Ws && Gl.nodeType === Oi && (za === "*" || Gl.namespaceURI === za) && (Ya === "*" || Gl.localName == Ya) && wl.push(Gl);
                    }), wl;
                  });
                }
              }, xa.prototype.getElementsByTagName = Ps.prototype.getElementsByTagName, xa.prototype.getElementsByTagNameNS = Ps.prototype.getElementsByTagNameNS, Pi(Ps, ia);
              function nl() {
              }
              nl.prototype.nodeType = Di, Pi(nl, ia);
              function Vs() {
              }
              Vs.prototype = {
                data: "",
                substringData: function(za, Ya) {
                  return this.data.substring(za, za + Ya);
                },
                appendData: function(za) {
                  za = this.data + za, this.nodeValue = this.data = za, this.length = za.length;
                },
                insertData: function(za, Ya) {
                  this.replaceData(za, 0, Ya);
                },
                appendChild: function(za) {
                  throw new Error(No[Ui]);
                },
                deleteData: function(za, Ya) {
                  this.replaceData(za, Ya, "");
                },
                replaceData: function(za, Ya, Ws) {
                  var wl = this.data.substring(0, za), Gl = this.data.substring(za + Ya);
                  Ws = wl + Ws + Gl, this.nodeValue = this.data = Ws, this.length = Ws.length;
                }
              }, Pi(Vs, ia);
              function es() {
              }
              es.prototype = {
                nodeName: "#text",
                nodeType: Mi,
                splitText: function(za) {
                  var Ya = this.data, Ws = Ya.substring(za);
                  Ya = Ya.substring(0, za), this.data = this.nodeValue = Ya, this.length = Ya.length;
                  var wl = this.ownerDocument.createTextNode(Ws);
                  return this.parentNode && this.parentNode.insertBefore(wl, this.nextSibling), wl;
                }
              }, Pi(es, Vs);
              function Is() {
              }
              Is.prototype = {
                nodeName: "#comment",
                nodeType: _o
              }, Pi(Is, Vs);
              function fl() {
              }
              fl.prototype = {
                nodeName: "#cdata-section",
                nodeType: Oo
              }, Pi(fl, Vs);
              function sl() {
              }
              sl.prototype.nodeType = Co, Pi(sl, ia);
              function Il() {
              }
              Il.prototype.nodeType = Yi, Pi(Il, ia);
              function Vl() {
              }
              Vl.prototype.nodeType = xo, Pi(Vl, ia);
              function Bl() {
              }
              Bl.prototype.nodeType = io, Pi(Bl, ia);
              function ql() {
              }
              ql.prototype.nodeName = "#document-fragment", ql.prototype.nodeType = Ni, Pi(ql, ia);
              function xl() {
              }
              xl.prototype.nodeType = fo, Pi(xl, ia);
              function Ul() {
              }
              Ul.prototype.serializeToString = function(za, Ya, Ws) {
                return Xl.call(za, Ya, Ws);
              }, ia.prototype.toString = Xl;
              function Xl(za, Ya) {
                var Ws = [], wl = this.nodeType == 9 && this.documentElement || this, Gl = wl.prefix, bl = wl.namespaceURI;
                if (bl && Gl == null) {
                  var Gl = wl.lookupPrefix(bl);
                  if (Gl == null)
                    var Za = [
                      { namespace: bl, prefix: null }
                      //{namespace:uri,prefix:''}
                    ];
                }
                return Ku(this, Ws, za, Ya, Za), Ws.join("");
              }
              function hu(za, Ya, Ws) {
                var wl = za.prefix || "", Gl = za.namespaceURI;
                if (!Gl || wl === "xml" && Gl === fi.XML || Gl === fi.XMLNS)
                  return !1;
                for (var bl = Ws.length; bl--; ) {
                  var Za = Ws[bl];
                  if (Za.prefix === wl)
                    return Za.namespace !== Gl;
                }
                return !0;
              }
              function Tu(za, Ya, Ws) {
                za.push(" ", Ya, '="', Ws.replace(/[<>&"\t\n\r]/g, ra), '"');
              }
              function Ku(za, Ya, Ws, wl, Gl) {
                if (Gl || (Gl = []), wl)
                  if (za = wl(za), za) {
                    if (typeof za == "string") {
                      Ya.push(za);
                      return;
                    }
                  } else
                    return;
                switch (za.nodeType) {
                  case Oi:
                    var bl = za.attributes, Za = bl.length, cu = za.firstChild, rl = za.tagName;
                    Ws = fi.isHTML(za.namespaceURI) || Ws;
                    var zs = rl;
                    if (!Ws && !za.prefix && za.namespaceURI) {
                      for (var al, Ol = 0; Ol < bl.length; Ol++)
                        if (bl.item(Ol).name === "xmlns") {
                          al = bl.item(Ol).value;
                          break;
                        }
                      if (!al)
                        for (var $l = Gl.length - 1; $l >= 0; $l--) {
                          var Zl = Gl[$l];
                          if (Zl.prefix === "" && Zl.namespace === za.namespaceURI) {
                            al = Zl.namespace;
                            break;
                          }
                        }
                      if (al !== za.namespaceURI)
                        for (var $l = Gl.length - 1; $l >= 0; $l--) {
                          var Zl = Gl[$l];
                          if (Zl.namespace === za.namespaceURI) {
                            Zl.prefix && (zs = Zl.prefix + ":" + rl);
                            break;
                          }
                        }
                    }
                    Ya.push("<", zs);
                    for (var tu = 0; tu < Za; tu++) {
                      var su = bl.item(tu);
                      su.prefix == "xmlns" ? Gl.push({ prefix: su.localName, namespace: su.value }) : su.nodeName == "xmlns" && Gl.push({ prefix: "", namespace: su.value });
                    }
                    for (var tu = 0; tu < Za; tu++) {
                      var su = bl.item(tu);
                      if (hu(su, Ws, Gl)) {
                        var dl = su.prefix || "", Su = su.namespaceURI;
                        Tu(Ya, dl ? "xmlns:" + dl : "xmlns", Su), Gl.push({ prefix: dl, namespace: Su });
                      }
                      Ku(su, Ya, Ws, wl, Gl);
                    }
                    if (rl === zs && hu(za, Ws, Gl)) {
                      var dl = za.prefix || "", Su = za.namespaceURI;
                      Tu(Ya, dl ? "xmlns:" + dl : "xmlns", Su), Gl.push({ prefix: dl, namespace: Su });
                    }
                    if (cu || Ws && !/^(?:meta|link|img|br|hr|input)$/i.test(rl)) {
                      if (Ya.push(">"), Ws && /^script$/i.test(rl))
                        for (; cu; )
                          cu.data ? Ya.push(cu.data) : Ku(cu, Ya, Ws, wl, Gl.slice()), cu = cu.nextSibling;
                      else
                        for (; cu; )
                          Ku(cu, Ya, Ws, wl, Gl.slice()), cu = cu.nextSibling;
                      Ya.push("</", zs, ">");
                    } else
                      Ya.push("/>");
                    return;
                  case Li:
                  case Ni:
                    for (var cu = za.firstChild; cu; )
                      Ku(cu, Ya, Ws, wl, Gl.slice()), cu = cu.nextSibling;
                    return;
                  case Di:
                    return Tu(Ya, za.name, za.value);
                  case Mi:
                    return Ya.push(
                      za.data.replace(/[<&>]/g, ra)
                    );
                  case Oo:
                    return Ya.push("<![CDATA[", za.data, "]]>");
                  case _o:
                    return Ya.push("<!--", za.data, "-->");
                  case Co:
                    var Ru = za.publicId, bu = za.systemId;
                    if (Ya.push("<!DOCTYPE ", za.name), Ru)
                      Ya.push(" PUBLIC ", Ru), bu && bu != "." && Ya.push(" ", bu), Ya.push(">");
                    else if (bu && bu != ".")
                      Ya.push(" SYSTEM ", bu, ">");
                    else {
                      var Hu = za.internalSubset;
                      Hu && Ya.push(" [", Hu, "]"), Ya.push(">");
                    }
                    return;
                  case fo:
                    return Ya.push("<?", za.target, " ", za.data, "?>");
                  case io:
                    return Ya.push("&", za.nodeName, ";");
                  //case ENTITY_NODE:
                  //case NOTATION_NODE:
                  default:
                    Ya.push("??", za.nodeName);
                }
              }
              function Wl(za, Ya, Ws) {
                var wl;
                switch (Ya.nodeType) {
                  case Oi:
                    wl = Ya.cloneNode(!1), wl.ownerDocument = za;
                  //var attrs = node2.attributes;
                  //var len = attrs.length;
                  //for(var i=0;i<len;i++){
                  //node2.setAttributeNodeNS(importNode(doc,attrs.item(i),deep));
                  //}
                  case Ni:
                    break;
                  case Di:
                    Ws = !0;
                    break;
                }
                if (wl || (wl = Ya.cloneNode(!1)), wl.ownerDocument = za, wl.parentNode = null, Ws)
                  for (var Gl = Ya.firstChild; Gl; )
                    wl.appendChild(Wl(za, Gl, Ws)), Gl = Gl.nextSibling;
                return wl;
              }
              function uu(za, Ya, Ws) {
                var wl = new Ya.constructor();
                for (var Gl in Ya)
                  if (Object.prototype.hasOwnProperty.call(Ya, Gl)) {
                    var bl = Ya[Gl];
                    typeof bl != "object" && bl != wl[Gl] && (wl[Gl] = bl);
                  }
                switch (Ya.childNodes && (wl.childNodes = new Hi()), wl.ownerDocument = za, wl.nodeType) {
                  case Oi:
                    var Za = Ya.attributes, rl = wl.attributes = new sa(), zs = Za.length;
                    rl._ownerElement = wl;
                    for (var al = 0; al < zs; al++)
                      wl.setAttributeNode(uu(za, Za.item(al), !0));
                    break;
                  case Di:
                    Ws = !0;
                }
                if (Ws)
                  for (var Ol = Ya.firstChild; Ol; )
                    wl.appendChild(uu(za, Ol, Ws)), Ol = Ol.nextSibling;
                return wl;
              }
              function du(za, Ya, Ws) {
                za[Ya] = Ws;
              }
              try {
                if (Object.defineProperty) {
                  let za = function(Ya) {
                    switch (Ya.nodeType) {
                      case Oi:
                      case Ni:
                        var Ws = [];
                        for (Ya = Ya.firstChild; Ya; )
                          Ya.nodeType !== 7 && Ya.nodeType !== 8 && Ws.push(za(Ya)), Ya = Ya.nextSibling;
                        return Ws.join("");
                      default:
                        return Ya.nodeValue;
                    }
                  };
                  Object.defineProperty(zo.prototype, "length", {
                    get: function() {
                      return Lo(this), this.$$length;
                    }
                  }), Object.defineProperty(ia.prototype, "textContent", {
                    get: function() {
                      return za(this);
                    },
                    set: function(Ya) {
                      switch (this.nodeType) {
                        case Oi:
                        case Ni:
                          for (; this.firstChild; )
                            this.removeChild(this.firstChild);
                          (Ya || String(Ya)) && this.appendChild(this.ownerDocument.createTextNode(Ya));
                          break;
                        default:
                          this.data = Ya, this.value = Ya, this.nodeValue = Ya;
                      }
                    }
                  }), du = function(Ya, Ws, wl) {
                    Ya["$$" + Ws] = wl;
                  };
                }
              } catch {
              }
              li.DocumentType = sl, li.DOMException = ji, li.DOMImplementation = ga, li.Element = Ps, li.Node = ia, li.NodeList = Hi, li.XMLSerializer = Ul;
            })
          ),
          /***/
          "./node_modules/@xmldom/xmldom/lib/entities.js": (
            /*!*****************************************************!*\
              !*** ./node_modules/@xmldom/xmldom/lib/entities.js ***!
              \*****************************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! ./conventions */
                "./node_modules/@xmldom/xmldom/lib/conventions.js"
              ).freeze;
              li.XML_ENTITIES = si({
                amp: "&",
                apos: "'",
                gt: ">",
                lt: "<",
                quot: '"'
              }), li.HTML_ENTITIES = si({
                Aacute: "Á",
                aacute: "á",
                Abreve: "Ă",
                abreve: "ă",
                ac: "∾",
                acd: "∿",
                acE: "∾̳",
                Acirc: "Â",
                acirc: "â",
                acute: "´",
                Acy: "А",
                acy: "а",
                AElig: "Æ",
                aelig: "æ",
                af: "⁡",
                Afr: "𝔄",
                afr: "𝔞",
                Agrave: "À",
                agrave: "à",
                alefsym: "ℵ",
                aleph: "ℵ",
                Alpha: "Α",
                alpha: "α",
                Amacr: "Ā",
                amacr: "ā",
                amalg: "⨿",
                AMP: "&",
                amp: "&",
                And: "⩓",
                and: "∧",
                andand: "⩕",
                andd: "⩜",
                andslope: "⩘",
                andv: "⩚",
                ang: "∠",
                ange: "⦤",
                angle: "∠",
                angmsd: "∡",
                angmsdaa: "⦨",
                angmsdab: "⦩",
                angmsdac: "⦪",
                angmsdad: "⦫",
                angmsdae: "⦬",
                angmsdaf: "⦭",
                angmsdag: "⦮",
                angmsdah: "⦯",
                angrt: "∟",
                angrtvb: "⊾",
                angrtvbd: "⦝",
                angsph: "∢",
                angst: "Å",
                angzarr: "⍼",
                Aogon: "Ą",
                aogon: "ą",
                Aopf: "𝔸",
                aopf: "𝕒",
                ap: "≈",
                apacir: "⩯",
                apE: "⩰",
                ape: "≊",
                apid: "≋",
                apos: "'",
                ApplyFunction: "⁡",
                approx: "≈",
                approxeq: "≊",
                Aring: "Å",
                aring: "å",
                Ascr: "𝒜",
                ascr: "𝒶",
                Assign: "≔",
                ast: "*",
                asymp: "≈",
                asympeq: "≍",
                Atilde: "Ã",
                atilde: "ã",
                Auml: "Ä",
                auml: "ä",
                awconint: "∳",
                awint: "⨑",
                backcong: "≌",
                backepsilon: "϶",
                backprime: "‵",
                backsim: "∽",
                backsimeq: "⋍",
                Backslash: "∖",
                Barv: "⫧",
                barvee: "⊽",
                Barwed: "⌆",
                barwed: "⌅",
                barwedge: "⌅",
                bbrk: "⎵",
                bbrktbrk: "⎶",
                bcong: "≌",
                Bcy: "Б",
                bcy: "б",
                bdquo: "„",
                becaus: "∵",
                Because: "∵",
                because: "∵",
                bemptyv: "⦰",
                bepsi: "϶",
                bernou: "ℬ",
                Bernoullis: "ℬ",
                Beta: "Β",
                beta: "β",
                beth: "ℶ",
                between: "≬",
                Bfr: "𝔅",
                bfr: "𝔟",
                bigcap: "⋂",
                bigcirc: "◯",
                bigcup: "⋃",
                bigodot: "⨀",
                bigoplus: "⨁",
                bigotimes: "⨂",
                bigsqcup: "⨆",
                bigstar: "★",
                bigtriangledown: "▽",
                bigtriangleup: "△",
                biguplus: "⨄",
                bigvee: "⋁",
                bigwedge: "⋀",
                bkarow: "⤍",
                blacklozenge: "⧫",
                blacksquare: "▪",
                blacktriangle: "▴",
                blacktriangledown: "▾",
                blacktriangleleft: "◂",
                blacktriangleright: "▸",
                blank: "␣",
                blk12: "▒",
                blk14: "░",
                blk34: "▓",
                block: "█",
                bne: "=⃥",
                bnequiv: "≡⃥",
                bNot: "⫭",
                bnot: "⌐",
                Bopf: "𝔹",
                bopf: "𝕓",
                bot: "⊥",
                bottom: "⊥",
                bowtie: "⋈",
                boxbox: "⧉",
                boxDL: "╗",
                boxDl: "╖",
                boxdL: "╕",
                boxdl: "┐",
                boxDR: "╔",
                boxDr: "╓",
                boxdR: "╒",
                boxdr: "┌",
                boxH: "═",
                boxh: "─",
                boxHD: "╦",
                boxHd: "╤",
                boxhD: "╥",
                boxhd: "┬",
                boxHU: "╩",
                boxHu: "╧",
                boxhU: "╨",
                boxhu: "┴",
                boxminus: "⊟",
                boxplus: "⊞",
                boxtimes: "⊠",
                boxUL: "╝",
                boxUl: "╜",
                boxuL: "╛",
                boxul: "┘",
                boxUR: "╚",
                boxUr: "╙",
                boxuR: "╘",
                boxur: "└",
                boxV: "║",
                boxv: "│",
                boxVH: "╬",
                boxVh: "╫",
                boxvH: "╪",
                boxvh: "┼",
                boxVL: "╣",
                boxVl: "╢",
                boxvL: "╡",
                boxvl: "┤",
                boxVR: "╠",
                boxVr: "╟",
                boxvR: "╞",
                boxvr: "├",
                bprime: "‵",
                Breve: "˘",
                breve: "˘",
                brvbar: "¦",
                Bscr: "ℬ",
                bscr: "𝒷",
                bsemi: "⁏",
                bsim: "∽",
                bsime: "⋍",
                bsol: "\\",
                bsolb: "⧅",
                bsolhsub: "⟈",
                bull: "•",
                bullet: "•",
                bump: "≎",
                bumpE: "⪮",
                bumpe: "≏",
                Bumpeq: "≎",
                bumpeq: "≏",
                Cacute: "Ć",
                cacute: "ć",
                Cap: "⋒",
                cap: "∩",
                capand: "⩄",
                capbrcup: "⩉",
                capcap: "⩋",
                capcup: "⩇",
                capdot: "⩀",
                CapitalDifferentialD: "ⅅ",
                caps: "∩︀",
                caret: "⁁",
                caron: "ˇ",
                Cayleys: "ℭ",
                ccaps: "⩍",
                Ccaron: "Č",
                ccaron: "č",
                Ccedil: "Ç",
                ccedil: "ç",
                Ccirc: "Ĉ",
                ccirc: "ĉ",
                Cconint: "∰",
                ccups: "⩌",
                ccupssm: "⩐",
                Cdot: "Ċ",
                cdot: "ċ",
                cedil: "¸",
                Cedilla: "¸",
                cemptyv: "⦲",
                cent: "¢",
                CenterDot: "·",
                centerdot: "·",
                Cfr: "ℭ",
                cfr: "𝔠",
                CHcy: "Ч",
                chcy: "ч",
                check: "✓",
                checkmark: "✓",
                Chi: "Χ",
                chi: "χ",
                cir: "○",
                circ: "ˆ",
                circeq: "≗",
                circlearrowleft: "↺",
                circlearrowright: "↻",
                circledast: "⊛",
                circledcirc: "⊚",
                circleddash: "⊝",
                CircleDot: "⊙",
                circledR: "®",
                circledS: "Ⓢ",
                CircleMinus: "⊖",
                CirclePlus: "⊕",
                CircleTimes: "⊗",
                cirE: "⧃",
                cire: "≗",
                cirfnint: "⨐",
                cirmid: "⫯",
                cirscir: "⧂",
                ClockwiseContourIntegral: "∲",
                CloseCurlyDoubleQuote: "”",
                CloseCurlyQuote: "’",
                clubs: "♣",
                clubsuit: "♣",
                Colon: "∷",
                colon: ":",
                Colone: "⩴",
                colone: "≔",
                coloneq: "≔",
                comma: ",",
                commat: "@",
                comp: "∁",
                compfn: "∘",
                complement: "∁",
                complexes: "ℂ",
                cong: "≅",
                congdot: "⩭",
                Congruent: "≡",
                Conint: "∯",
                conint: "∮",
                ContourIntegral: "∮",
                Copf: "ℂ",
                copf: "𝕔",
                coprod: "∐",
                Coproduct: "∐",
                COPY: "©",
                copy: "©",
                copysr: "℗",
                CounterClockwiseContourIntegral: "∳",
                crarr: "↵",
                Cross: "⨯",
                cross: "✗",
                Cscr: "𝒞",
                cscr: "𝒸",
                csub: "⫏",
                csube: "⫑",
                csup: "⫐",
                csupe: "⫒",
                ctdot: "⋯",
                cudarrl: "⤸",
                cudarrr: "⤵",
                cuepr: "⋞",
                cuesc: "⋟",
                cularr: "↶",
                cularrp: "⤽",
                Cup: "⋓",
                cup: "∪",
                cupbrcap: "⩈",
                CupCap: "≍",
                cupcap: "⩆",
                cupcup: "⩊",
                cupdot: "⊍",
                cupor: "⩅",
                cups: "∪︀",
                curarr: "↷",
                curarrm: "⤼",
                curlyeqprec: "⋞",
                curlyeqsucc: "⋟",
                curlyvee: "⋎",
                curlywedge: "⋏",
                curren: "¤",
                curvearrowleft: "↶",
                curvearrowright: "↷",
                cuvee: "⋎",
                cuwed: "⋏",
                cwconint: "∲",
                cwint: "∱",
                cylcty: "⌭",
                Dagger: "‡",
                dagger: "†",
                daleth: "ℸ",
                Darr: "↡",
                dArr: "⇓",
                darr: "↓",
                dash: "‐",
                Dashv: "⫤",
                dashv: "⊣",
                dbkarow: "⤏",
                dblac: "˝",
                Dcaron: "Ď",
                dcaron: "ď",
                Dcy: "Д",
                dcy: "д",
                DD: "ⅅ",
                dd: "ⅆ",
                ddagger: "‡",
                ddarr: "⇊",
                DDotrahd: "⤑",
                ddotseq: "⩷",
                deg: "°",
                Del: "∇",
                Delta: "Δ",
                delta: "δ",
                demptyv: "⦱",
                dfisht: "⥿",
                Dfr: "𝔇",
                dfr: "𝔡",
                dHar: "⥥",
                dharl: "⇃",
                dharr: "⇂",
                DiacriticalAcute: "´",
                DiacriticalDot: "˙",
                DiacriticalDoubleAcute: "˝",
                DiacriticalGrave: "`",
                DiacriticalTilde: "˜",
                diam: "⋄",
                Diamond: "⋄",
                diamond: "⋄",
                diamondsuit: "♦",
                diams: "♦",
                die: "¨",
                DifferentialD: "ⅆ",
                digamma: "ϝ",
                disin: "⋲",
                div: "÷",
                divide: "÷",
                divideontimes: "⋇",
                divonx: "⋇",
                DJcy: "Ђ",
                djcy: "ђ",
                dlcorn: "⌞",
                dlcrop: "⌍",
                dollar: "$",
                Dopf: "𝔻",
                dopf: "𝕕",
                Dot: "¨",
                dot: "˙",
                DotDot: "⃜",
                doteq: "≐",
                doteqdot: "≑",
                DotEqual: "≐",
                dotminus: "∸",
                dotplus: "∔",
                dotsquare: "⊡",
                doublebarwedge: "⌆",
                DoubleContourIntegral: "∯",
                DoubleDot: "¨",
                DoubleDownArrow: "⇓",
                DoubleLeftArrow: "⇐",
                DoubleLeftRightArrow: "⇔",
                DoubleLeftTee: "⫤",
                DoubleLongLeftArrow: "⟸",
                DoubleLongLeftRightArrow: "⟺",
                DoubleLongRightArrow: "⟹",
                DoubleRightArrow: "⇒",
                DoubleRightTee: "⊨",
                DoubleUpArrow: "⇑",
                DoubleUpDownArrow: "⇕",
                DoubleVerticalBar: "∥",
                DownArrow: "↓",
                Downarrow: "⇓",
                downarrow: "↓",
                DownArrowBar: "⤓",
                DownArrowUpArrow: "⇵",
                DownBreve: "̑",
                downdownarrows: "⇊",
                downharpoonleft: "⇃",
                downharpoonright: "⇂",
                DownLeftRightVector: "⥐",
                DownLeftTeeVector: "⥞",
                DownLeftVector: "↽",
                DownLeftVectorBar: "⥖",
                DownRightTeeVector: "⥟",
                DownRightVector: "⇁",
                DownRightVectorBar: "⥗",
                DownTee: "⊤",
                DownTeeArrow: "↧",
                drbkarow: "⤐",
                drcorn: "⌟",
                drcrop: "⌌",
                Dscr: "𝒟",
                dscr: "𝒹",
                DScy: "Ѕ",
                dscy: "ѕ",
                dsol: "⧶",
                Dstrok: "Đ",
                dstrok: "đ",
                dtdot: "⋱",
                dtri: "▿",
                dtrif: "▾",
                duarr: "⇵",
                duhar: "⥯",
                dwangle: "⦦",
                DZcy: "Џ",
                dzcy: "џ",
                dzigrarr: "⟿",
                Eacute: "É",
                eacute: "é",
                easter: "⩮",
                Ecaron: "Ě",
                ecaron: "ě",
                ecir: "≖",
                Ecirc: "Ê",
                ecirc: "ê",
                ecolon: "≕",
                Ecy: "Э",
                ecy: "э",
                eDDot: "⩷",
                Edot: "Ė",
                eDot: "≑",
                edot: "ė",
                ee: "ⅇ",
                efDot: "≒",
                Efr: "𝔈",
                efr: "𝔢",
                eg: "⪚",
                Egrave: "È",
                egrave: "è",
                egs: "⪖",
                egsdot: "⪘",
                el: "⪙",
                Element: "∈",
                elinters: "⏧",
                ell: "ℓ",
                els: "⪕",
                elsdot: "⪗",
                Emacr: "Ē",
                emacr: "ē",
                empty: "∅",
                emptyset: "∅",
                EmptySmallSquare: "◻",
                emptyv: "∅",
                EmptyVerySmallSquare: "▫",
                emsp: " ",
                emsp13: " ",
                emsp14: " ",
                ENG: "Ŋ",
                eng: "ŋ",
                ensp: " ",
                Eogon: "Ę",
                eogon: "ę",
                Eopf: "𝔼",
                eopf: "𝕖",
                epar: "⋕",
                eparsl: "⧣",
                eplus: "⩱",
                epsi: "ε",
                Epsilon: "Ε",
                epsilon: "ε",
                epsiv: "ϵ",
                eqcirc: "≖",
                eqcolon: "≕",
                eqsim: "≂",
                eqslantgtr: "⪖",
                eqslantless: "⪕",
                Equal: "⩵",
                equals: "=",
                EqualTilde: "≂",
                equest: "≟",
                Equilibrium: "⇌",
                equiv: "≡",
                equivDD: "⩸",
                eqvparsl: "⧥",
                erarr: "⥱",
                erDot: "≓",
                Escr: "ℰ",
                escr: "ℯ",
                esdot: "≐",
                Esim: "⩳",
                esim: "≂",
                Eta: "Η",
                eta: "η",
                ETH: "Ð",
                eth: "ð",
                Euml: "Ë",
                euml: "ë",
                euro: "€",
                excl: "!",
                exist: "∃",
                Exists: "∃",
                expectation: "ℰ",
                ExponentialE: "ⅇ",
                exponentiale: "ⅇ",
                fallingdotseq: "≒",
                Fcy: "Ф",
                fcy: "ф",
                female: "♀",
                ffilig: "ﬃ",
                fflig: "ﬀ",
                ffllig: "ﬄ",
                Ffr: "𝔉",
                ffr: "𝔣",
                filig: "ﬁ",
                FilledSmallSquare: "◼",
                FilledVerySmallSquare: "▪",
                fjlig: "fj",
                flat: "♭",
                fllig: "ﬂ",
                fltns: "▱",
                fnof: "ƒ",
                Fopf: "𝔽",
                fopf: "𝕗",
                ForAll: "∀",
                forall: "∀",
                fork: "⋔",
                forkv: "⫙",
                Fouriertrf: "ℱ",
                fpartint: "⨍",
                frac12: "½",
                frac13: "⅓",
                frac14: "¼",
                frac15: "⅕",
                frac16: "⅙",
                frac18: "⅛",
                frac23: "⅔",
                frac25: "⅖",
                frac34: "¾",
                frac35: "⅗",
                frac38: "⅜",
                frac45: "⅘",
                frac56: "⅚",
                frac58: "⅝",
                frac78: "⅞",
                frasl: "⁄",
                frown: "⌢",
                Fscr: "ℱ",
                fscr: "𝒻",
                gacute: "ǵ",
                Gamma: "Γ",
                gamma: "γ",
                Gammad: "Ϝ",
                gammad: "ϝ",
                gap: "⪆",
                Gbreve: "Ğ",
                gbreve: "ğ",
                Gcedil: "Ģ",
                Gcirc: "Ĝ",
                gcirc: "ĝ",
                Gcy: "Г",
                gcy: "г",
                Gdot: "Ġ",
                gdot: "ġ",
                gE: "≧",
                ge: "≥",
                gEl: "⪌",
                gel: "⋛",
                geq: "≥",
                geqq: "≧",
                geqslant: "⩾",
                ges: "⩾",
                gescc: "⪩",
                gesdot: "⪀",
                gesdoto: "⪂",
                gesdotol: "⪄",
                gesl: "⋛︀",
                gesles: "⪔",
                Gfr: "𝔊",
                gfr: "𝔤",
                Gg: "⋙",
                gg: "≫",
                ggg: "⋙",
                gimel: "ℷ",
                GJcy: "Ѓ",
                gjcy: "ѓ",
                gl: "≷",
                gla: "⪥",
                glE: "⪒",
                glj: "⪤",
                gnap: "⪊",
                gnapprox: "⪊",
                gnE: "≩",
                gne: "⪈",
                gneq: "⪈",
                gneqq: "≩",
                gnsim: "⋧",
                Gopf: "𝔾",
                gopf: "𝕘",
                grave: "`",
                GreaterEqual: "≥",
                GreaterEqualLess: "⋛",
                GreaterFullEqual: "≧",
                GreaterGreater: "⪢",
                GreaterLess: "≷",
                GreaterSlantEqual: "⩾",
                GreaterTilde: "≳",
                Gscr: "𝒢",
                gscr: "ℊ",
                gsim: "≳",
                gsime: "⪎",
                gsiml: "⪐",
                Gt: "≫",
                GT: ">",
                gt: ">",
                gtcc: "⪧",
                gtcir: "⩺",
                gtdot: "⋗",
                gtlPar: "⦕",
                gtquest: "⩼",
                gtrapprox: "⪆",
                gtrarr: "⥸",
                gtrdot: "⋗",
                gtreqless: "⋛",
                gtreqqless: "⪌",
                gtrless: "≷",
                gtrsim: "≳",
                gvertneqq: "≩︀",
                gvnE: "≩︀",
                Hacek: "ˇ",
                hairsp: " ",
                half: "½",
                hamilt: "ℋ",
                HARDcy: "Ъ",
                hardcy: "ъ",
                hArr: "⇔",
                harr: "↔",
                harrcir: "⥈",
                harrw: "↭",
                Hat: "^",
                hbar: "ℏ",
                Hcirc: "Ĥ",
                hcirc: "ĥ",
                hearts: "♥",
                heartsuit: "♥",
                hellip: "…",
                hercon: "⊹",
                Hfr: "ℌ",
                hfr: "𝔥",
                HilbertSpace: "ℋ",
                hksearow: "⤥",
                hkswarow: "⤦",
                hoarr: "⇿",
                homtht: "∻",
                hookleftarrow: "↩",
                hookrightarrow: "↪",
                Hopf: "ℍ",
                hopf: "𝕙",
                horbar: "―",
                HorizontalLine: "─",
                Hscr: "ℋ",
                hscr: "𝒽",
                hslash: "ℏ",
                Hstrok: "Ħ",
                hstrok: "ħ",
                HumpDownHump: "≎",
                HumpEqual: "≏",
                hybull: "⁃",
                hyphen: "‐",
                Iacute: "Í",
                iacute: "í",
                ic: "⁣",
                Icirc: "Î",
                icirc: "î",
                Icy: "И",
                icy: "и",
                Idot: "İ",
                IEcy: "Е",
                iecy: "е",
                iexcl: "¡",
                iff: "⇔",
                Ifr: "ℑ",
                ifr: "𝔦",
                Igrave: "Ì",
                igrave: "ì",
                ii: "ⅈ",
                iiiint: "⨌",
                iiint: "∭",
                iinfin: "⧜",
                iiota: "℩",
                IJlig: "Ĳ",
                ijlig: "ĳ",
                Im: "ℑ",
                Imacr: "Ī",
                imacr: "ī",
                image: "ℑ",
                ImaginaryI: "ⅈ",
                imagline: "ℐ",
                imagpart: "ℑ",
                imath: "ı",
                imof: "⊷",
                imped: "Ƶ",
                Implies: "⇒",
                in: "∈",
                incare: "℅",
                infin: "∞",
                infintie: "⧝",
                inodot: "ı",
                Int: "∬",
                int: "∫",
                intcal: "⊺",
                integers: "ℤ",
                Integral: "∫",
                intercal: "⊺",
                Intersection: "⋂",
                intlarhk: "⨗",
                intprod: "⨼",
                InvisibleComma: "⁣",
                InvisibleTimes: "⁢",
                IOcy: "Ё",
                iocy: "ё",
                Iogon: "Į",
                iogon: "į",
                Iopf: "𝕀",
                iopf: "𝕚",
                Iota: "Ι",
                iota: "ι",
                iprod: "⨼",
                iquest: "¿",
                Iscr: "ℐ",
                iscr: "𝒾",
                isin: "∈",
                isindot: "⋵",
                isinE: "⋹",
                isins: "⋴",
                isinsv: "⋳",
                isinv: "∈",
                it: "⁢",
                Itilde: "Ĩ",
                itilde: "ĩ",
                Iukcy: "І",
                iukcy: "і",
                Iuml: "Ï",
                iuml: "ï",
                Jcirc: "Ĵ",
                jcirc: "ĵ",
                Jcy: "Й",
                jcy: "й",
                Jfr: "𝔍",
                jfr: "𝔧",
                jmath: "ȷ",
                Jopf: "𝕁",
                jopf: "𝕛",
                Jscr: "𝒥",
                jscr: "𝒿",
                Jsercy: "Ј",
                jsercy: "ј",
                Jukcy: "Є",
                jukcy: "є",
                Kappa: "Κ",
                kappa: "κ",
                kappav: "ϰ",
                Kcedil: "Ķ",
                kcedil: "ķ",
                Kcy: "К",
                kcy: "к",
                Kfr: "𝔎",
                kfr: "𝔨",
                kgreen: "ĸ",
                KHcy: "Х",
                khcy: "х",
                KJcy: "Ќ",
                kjcy: "ќ",
                Kopf: "𝕂",
                kopf: "𝕜",
                Kscr: "𝒦",
                kscr: "𝓀",
                lAarr: "⇚",
                Lacute: "Ĺ",
                lacute: "ĺ",
                laemptyv: "⦴",
                lagran: "ℒ",
                Lambda: "Λ",
                lambda: "λ",
                Lang: "⟪",
                lang: "⟨",
                langd: "⦑",
                langle: "⟨",
                lap: "⪅",
                Laplacetrf: "ℒ",
                laquo: "«",
                Larr: "↞",
                lArr: "⇐",
                larr: "←",
                larrb: "⇤",
                larrbfs: "⤟",
                larrfs: "⤝",
                larrhk: "↩",
                larrlp: "↫",
                larrpl: "⤹",
                larrsim: "⥳",
                larrtl: "↢",
                lat: "⪫",
                lAtail: "⤛",
                latail: "⤙",
                late: "⪭",
                lates: "⪭︀",
                lBarr: "⤎",
                lbarr: "⤌",
                lbbrk: "❲",
                lbrace: "{",
                lbrack: "[",
                lbrke: "⦋",
                lbrksld: "⦏",
                lbrkslu: "⦍",
                Lcaron: "Ľ",
                lcaron: "ľ",
                Lcedil: "Ļ",
                lcedil: "ļ",
                lceil: "⌈",
                lcub: "{",
                Lcy: "Л",
                lcy: "л",
                ldca: "⤶",
                ldquo: "“",
                ldquor: "„",
                ldrdhar: "⥧",
                ldrushar: "⥋",
                ldsh: "↲",
                lE: "≦",
                le: "≤",
                LeftAngleBracket: "⟨",
                LeftArrow: "←",
                Leftarrow: "⇐",
                leftarrow: "←",
                LeftArrowBar: "⇤",
                LeftArrowRightArrow: "⇆",
                leftarrowtail: "↢",
                LeftCeiling: "⌈",
                LeftDoubleBracket: "⟦",
                LeftDownTeeVector: "⥡",
                LeftDownVector: "⇃",
                LeftDownVectorBar: "⥙",
                LeftFloor: "⌊",
                leftharpoondown: "↽",
                leftharpoonup: "↼",
                leftleftarrows: "⇇",
                LeftRightArrow: "↔",
                Leftrightarrow: "⇔",
                leftrightarrow: "↔",
                leftrightarrows: "⇆",
                leftrightharpoons: "⇋",
                leftrightsquigarrow: "↭",
                LeftRightVector: "⥎",
                LeftTee: "⊣",
                LeftTeeArrow: "↤",
                LeftTeeVector: "⥚",
                leftthreetimes: "⋋",
                LeftTriangle: "⊲",
                LeftTriangleBar: "⧏",
                LeftTriangleEqual: "⊴",
                LeftUpDownVector: "⥑",
                LeftUpTeeVector: "⥠",
                LeftUpVector: "↿",
                LeftUpVectorBar: "⥘",
                LeftVector: "↼",
                LeftVectorBar: "⥒",
                lEg: "⪋",
                leg: "⋚",
                leq: "≤",
                leqq: "≦",
                leqslant: "⩽",
                les: "⩽",
                lescc: "⪨",
                lesdot: "⩿",
                lesdoto: "⪁",
                lesdotor: "⪃",
                lesg: "⋚︀",
                lesges: "⪓",
                lessapprox: "⪅",
                lessdot: "⋖",
                lesseqgtr: "⋚",
                lesseqqgtr: "⪋",
                LessEqualGreater: "⋚",
                LessFullEqual: "≦",
                LessGreater: "≶",
                lessgtr: "≶",
                LessLess: "⪡",
                lesssim: "≲",
                LessSlantEqual: "⩽",
                LessTilde: "≲",
                lfisht: "⥼",
                lfloor: "⌊",
                Lfr: "𝔏",
                lfr: "𝔩",
                lg: "≶",
                lgE: "⪑",
                lHar: "⥢",
                lhard: "↽",
                lharu: "↼",
                lharul: "⥪",
                lhblk: "▄",
                LJcy: "Љ",
                ljcy: "љ",
                Ll: "⋘",
                ll: "≪",
                llarr: "⇇",
                llcorner: "⌞",
                Lleftarrow: "⇚",
                llhard: "⥫",
                lltri: "◺",
                Lmidot: "Ŀ",
                lmidot: "ŀ",
                lmoust: "⎰",
                lmoustache: "⎰",
                lnap: "⪉",
                lnapprox: "⪉",
                lnE: "≨",
                lne: "⪇",
                lneq: "⪇",
                lneqq: "≨",
                lnsim: "⋦",
                loang: "⟬",
                loarr: "⇽",
                lobrk: "⟦",
                LongLeftArrow: "⟵",
                Longleftarrow: "⟸",
                longleftarrow: "⟵",
                LongLeftRightArrow: "⟷",
                Longleftrightarrow: "⟺",
                longleftrightarrow: "⟷",
                longmapsto: "⟼",
                LongRightArrow: "⟶",
                Longrightarrow: "⟹",
                longrightarrow: "⟶",
                looparrowleft: "↫",
                looparrowright: "↬",
                lopar: "⦅",
                Lopf: "𝕃",
                lopf: "𝕝",
                loplus: "⨭",
                lotimes: "⨴",
                lowast: "∗",
                lowbar: "_",
                LowerLeftArrow: "↙",
                LowerRightArrow: "↘",
                loz: "◊",
                lozenge: "◊",
                lozf: "⧫",
                lpar: "(",
                lparlt: "⦓",
                lrarr: "⇆",
                lrcorner: "⌟",
                lrhar: "⇋",
                lrhard: "⥭",
                lrm: "‎",
                lrtri: "⊿",
                lsaquo: "‹",
                Lscr: "ℒ",
                lscr: "𝓁",
                Lsh: "↰",
                lsh: "↰",
                lsim: "≲",
                lsime: "⪍",
                lsimg: "⪏",
                lsqb: "[",
                lsquo: "‘",
                lsquor: "‚",
                Lstrok: "Ł",
                lstrok: "ł",
                Lt: "≪",
                LT: "<",
                lt: "<",
                ltcc: "⪦",
                ltcir: "⩹",
                ltdot: "⋖",
                lthree: "⋋",
                ltimes: "⋉",
                ltlarr: "⥶",
                ltquest: "⩻",
                ltri: "◃",
                ltrie: "⊴",
                ltrif: "◂",
                ltrPar: "⦖",
                lurdshar: "⥊",
                luruhar: "⥦",
                lvertneqq: "≨︀",
                lvnE: "≨︀",
                macr: "¯",
                male: "♂",
                malt: "✠",
                maltese: "✠",
                Map: "⤅",
                map: "↦",
                mapsto: "↦",
                mapstodown: "↧",
                mapstoleft: "↤",
                mapstoup: "↥",
                marker: "▮",
                mcomma: "⨩",
                Mcy: "М",
                mcy: "м",
                mdash: "—",
                mDDot: "∺",
                measuredangle: "∡",
                MediumSpace: " ",
                Mellintrf: "ℳ",
                Mfr: "𝔐",
                mfr: "𝔪",
                mho: "℧",
                micro: "µ",
                mid: "∣",
                midast: "*",
                midcir: "⫰",
                middot: "·",
                minus: "−",
                minusb: "⊟",
                minusd: "∸",
                minusdu: "⨪",
                MinusPlus: "∓",
                mlcp: "⫛",
                mldr: "…",
                mnplus: "∓",
                models: "⊧",
                Mopf: "𝕄",
                mopf: "𝕞",
                mp: "∓",
                Mscr: "ℳ",
                mscr: "𝓂",
                mstpos: "∾",
                Mu: "Μ",
                mu: "μ",
                multimap: "⊸",
                mumap: "⊸",
                nabla: "∇",
                Nacute: "Ń",
                nacute: "ń",
                nang: "∠⃒",
                nap: "≉",
                napE: "⩰̸",
                napid: "≋̸",
                napos: "ŉ",
                napprox: "≉",
                natur: "♮",
                natural: "♮",
                naturals: "ℕ",
                nbsp: " ",
                nbump: "≎̸",
                nbumpe: "≏̸",
                ncap: "⩃",
                Ncaron: "Ň",
                ncaron: "ň",
                Ncedil: "Ņ",
                ncedil: "ņ",
                ncong: "≇",
                ncongdot: "⩭̸",
                ncup: "⩂",
                Ncy: "Н",
                ncy: "н",
                ndash: "–",
                ne: "≠",
                nearhk: "⤤",
                neArr: "⇗",
                nearr: "↗",
                nearrow: "↗",
                nedot: "≐̸",
                NegativeMediumSpace: "​",
                NegativeThickSpace: "​",
                NegativeThinSpace: "​",
                NegativeVeryThinSpace: "​",
                nequiv: "≢",
                nesear: "⤨",
                nesim: "≂̸",
                NestedGreaterGreater: "≫",
                NestedLessLess: "≪",
                NewLine: `
`,
                nexist: "∄",
                nexists: "∄",
                Nfr: "𝔑",
                nfr: "𝔫",
                ngE: "≧̸",
                nge: "≱",
                ngeq: "≱",
                ngeqq: "≧̸",
                ngeqslant: "⩾̸",
                nges: "⩾̸",
                nGg: "⋙̸",
                ngsim: "≵",
                nGt: "≫⃒",
                ngt: "≯",
                ngtr: "≯",
                nGtv: "≫̸",
                nhArr: "⇎",
                nharr: "↮",
                nhpar: "⫲",
                ni: "∋",
                nis: "⋼",
                nisd: "⋺",
                niv: "∋",
                NJcy: "Њ",
                njcy: "њ",
                nlArr: "⇍",
                nlarr: "↚",
                nldr: "‥",
                nlE: "≦̸",
                nle: "≰",
                nLeftarrow: "⇍",
                nleftarrow: "↚",
                nLeftrightarrow: "⇎",
                nleftrightarrow: "↮",
                nleq: "≰",
                nleqq: "≦̸",
                nleqslant: "⩽̸",
                nles: "⩽̸",
                nless: "≮",
                nLl: "⋘̸",
                nlsim: "≴",
                nLt: "≪⃒",
                nlt: "≮",
                nltri: "⋪",
                nltrie: "⋬",
                nLtv: "≪̸",
                nmid: "∤",
                NoBreak: "⁠",
                NonBreakingSpace: " ",
                Nopf: "ℕ",
                nopf: "𝕟",
                Not: "⫬",
                not: "¬",
                NotCongruent: "≢",
                NotCupCap: "≭",
                NotDoubleVerticalBar: "∦",
                NotElement: "∉",
                NotEqual: "≠",
                NotEqualTilde: "≂̸",
                NotExists: "∄",
                NotGreater: "≯",
                NotGreaterEqual: "≱",
                NotGreaterFullEqual: "≧̸",
                NotGreaterGreater: "≫̸",
                NotGreaterLess: "≹",
                NotGreaterSlantEqual: "⩾̸",
                NotGreaterTilde: "≵",
                NotHumpDownHump: "≎̸",
                NotHumpEqual: "≏̸",
                notin: "∉",
                notindot: "⋵̸",
                notinE: "⋹̸",
                notinva: "∉",
                notinvb: "⋷",
                notinvc: "⋶",
                NotLeftTriangle: "⋪",
                NotLeftTriangleBar: "⧏̸",
                NotLeftTriangleEqual: "⋬",
                NotLess: "≮",
                NotLessEqual: "≰",
                NotLessGreater: "≸",
                NotLessLess: "≪̸",
                NotLessSlantEqual: "⩽̸",
                NotLessTilde: "≴",
                NotNestedGreaterGreater: "⪢̸",
                NotNestedLessLess: "⪡̸",
                notni: "∌",
                notniva: "∌",
                notnivb: "⋾",
                notnivc: "⋽",
                NotPrecedes: "⊀",
                NotPrecedesEqual: "⪯̸",
                NotPrecedesSlantEqual: "⋠",
                NotReverseElement: "∌",
                NotRightTriangle: "⋫",
                NotRightTriangleBar: "⧐̸",
                NotRightTriangleEqual: "⋭",
                NotSquareSubset: "⊏̸",
                NotSquareSubsetEqual: "⋢",
                NotSquareSuperset: "⊐̸",
                NotSquareSupersetEqual: "⋣",
                NotSubset: "⊂⃒",
                NotSubsetEqual: "⊈",
                NotSucceeds: "⊁",
                NotSucceedsEqual: "⪰̸",
                NotSucceedsSlantEqual: "⋡",
                NotSucceedsTilde: "≿̸",
                NotSuperset: "⊃⃒",
                NotSupersetEqual: "⊉",
                NotTilde: "≁",
                NotTildeEqual: "≄",
                NotTildeFullEqual: "≇",
                NotTildeTilde: "≉",
                NotVerticalBar: "∤",
                npar: "∦",
                nparallel: "∦",
                nparsl: "⫽⃥",
                npart: "∂̸",
                npolint: "⨔",
                npr: "⊀",
                nprcue: "⋠",
                npre: "⪯̸",
                nprec: "⊀",
                npreceq: "⪯̸",
                nrArr: "⇏",
                nrarr: "↛",
                nrarrc: "⤳̸",
                nrarrw: "↝̸",
                nRightarrow: "⇏",
                nrightarrow: "↛",
                nrtri: "⋫",
                nrtrie: "⋭",
                nsc: "⊁",
                nsccue: "⋡",
                nsce: "⪰̸",
                Nscr: "𝒩",
                nscr: "𝓃",
                nshortmid: "∤",
                nshortparallel: "∦",
                nsim: "≁",
                nsime: "≄",
                nsimeq: "≄",
                nsmid: "∤",
                nspar: "∦",
                nsqsube: "⋢",
                nsqsupe: "⋣",
                nsub: "⊄",
                nsubE: "⫅̸",
                nsube: "⊈",
                nsubset: "⊂⃒",
                nsubseteq: "⊈",
                nsubseteqq: "⫅̸",
                nsucc: "⊁",
                nsucceq: "⪰̸",
                nsup: "⊅",
                nsupE: "⫆̸",
                nsupe: "⊉",
                nsupset: "⊃⃒",
                nsupseteq: "⊉",
                nsupseteqq: "⫆̸",
                ntgl: "≹",
                Ntilde: "Ñ",
                ntilde: "ñ",
                ntlg: "≸",
                ntriangleleft: "⋪",
                ntrianglelefteq: "⋬",
                ntriangleright: "⋫",
                ntrianglerighteq: "⋭",
                Nu: "Ν",
                nu: "ν",
                num: "#",
                numero: "№",
                numsp: " ",
                nvap: "≍⃒",
                nVDash: "⊯",
                nVdash: "⊮",
                nvDash: "⊭",
                nvdash: "⊬",
                nvge: "≥⃒",
                nvgt: ">⃒",
                nvHarr: "⤄",
                nvinfin: "⧞",
                nvlArr: "⤂",
                nvle: "≤⃒",
                nvlt: "<⃒",
                nvltrie: "⊴⃒",
                nvrArr: "⤃",
                nvrtrie: "⊵⃒",
                nvsim: "∼⃒",
                nwarhk: "⤣",
                nwArr: "⇖",
                nwarr: "↖",
                nwarrow: "↖",
                nwnear: "⤧",
                Oacute: "Ó",
                oacute: "ó",
                oast: "⊛",
                ocir: "⊚",
                Ocirc: "Ô",
                ocirc: "ô",
                Ocy: "О",
                ocy: "о",
                odash: "⊝",
                Odblac: "Ő",
                odblac: "ő",
                odiv: "⨸",
                odot: "⊙",
                odsold: "⦼",
                OElig: "Œ",
                oelig: "œ",
                ofcir: "⦿",
                Ofr: "𝔒",
                ofr: "𝔬",
                ogon: "˛",
                Ograve: "Ò",
                ograve: "ò",
                ogt: "⧁",
                ohbar: "⦵",
                ohm: "Ω",
                oint: "∮",
                olarr: "↺",
                olcir: "⦾",
                olcross: "⦻",
                oline: "‾",
                olt: "⧀",
                Omacr: "Ō",
                omacr: "ō",
                Omega: "Ω",
                omega: "ω",
                Omicron: "Ο",
                omicron: "ο",
                omid: "⦶",
                ominus: "⊖",
                Oopf: "𝕆",
                oopf: "𝕠",
                opar: "⦷",
                OpenCurlyDoubleQuote: "“",
                OpenCurlyQuote: "‘",
                operp: "⦹",
                oplus: "⊕",
                Or: "⩔",
                or: "∨",
                orarr: "↻",
                ord: "⩝",
                order: "ℴ",
                orderof: "ℴ",
                ordf: "ª",
                ordm: "º",
                origof: "⊶",
                oror: "⩖",
                orslope: "⩗",
                orv: "⩛",
                oS: "Ⓢ",
                Oscr: "𝒪",
                oscr: "ℴ",
                Oslash: "Ø",
                oslash: "ø",
                osol: "⊘",
                Otilde: "Õ",
                otilde: "õ",
                Otimes: "⨷",
                otimes: "⊗",
                otimesas: "⨶",
                Ouml: "Ö",
                ouml: "ö",
                ovbar: "⌽",
                OverBar: "‾",
                OverBrace: "⏞",
                OverBracket: "⎴",
                OverParenthesis: "⏜",
                par: "∥",
                para: "¶",
                parallel: "∥",
                parsim: "⫳",
                parsl: "⫽",
                part: "∂",
                PartialD: "∂",
                Pcy: "П",
                pcy: "п",
                percnt: "%",
                period: ".",
                permil: "‰",
                perp: "⊥",
                pertenk: "‱",
                Pfr: "𝔓",
                pfr: "𝔭",
                Phi: "Φ",
                phi: "φ",
                phiv: "ϕ",
                phmmat: "ℳ",
                phone: "☎",
                Pi: "Π",
                pi: "π",
                pitchfork: "⋔",
                piv: "ϖ",
                planck: "ℏ",
                planckh: "ℎ",
                plankv: "ℏ",
                plus: "+",
                plusacir: "⨣",
                plusb: "⊞",
                pluscir: "⨢",
                plusdo: "∔",
                plusdu: "⨥",
                pluse: "⩲",
                PlusMinus: "±",
                plusmn: "±",
                plussim: "⨦",
                plustwo: "⨧",
                pm: "±",
                Poincareplane: "ℌ",
                pointint: "⨕",
                Popf: "ℙ",
                popf: "𝕡",
                pound: "£",
                Pr: "⪻",
                pr: "≺",
                prap: "⪷",
                prcue: "≼",
                prE: "⪳",
                pre: "⪯",
                prec: "≺",
                precapprox: "⪷",
                preccurlyeq: "≼",
                Precedes: "≺",
                PrecedesEqual: "⪯",
                PrecedesSlantEqual: "≼",
                PrecedesTilde: "≾",
                preceq: "⪯",
                precnapprox: "⪹",
                precneqq: "⪵",
                precnsim: "⋨",
                precsim: "≾",
                Prime: "″",
                prime: "′",
                primes: "ℙ",
                prnap: "⪹",
                prnE: "⪵",
                prnsim: "⋨",
                prod: "∏",
                Product: "∏",
                profalar: "⌮",
                profline: "⌒",
                profsurf: "⌓",
                prop: "∝",
                Proportion: "∷",
                Proportional: "∝",
                propto: "∝",
                prsim: "≾",
                prurel: "⊰",
                Pscr: "𝒫",
                pscr: "𝓅",
                Psi: "Ψ",
                psi: "ψ",
                puncsp: " ",
                Qfr: "𝔔",
                qfr: "𝔮",
                qint: "⨌",
                Qopf: "ℚ",
                qopf: "𝕢",
                qprime: "⁗",
                Qscr: "𝒬",
                qscr: "𝓆",
                quaternions: "ℍ",
                quatint: "⨖",
                quest: "?",
                questeq: "≟",
                QUOT: '"',
                quot: '"',
                rAarr: "⇛",
                race: "∽̱",
                Racute: "Ŕ",
                racute: "ŕ",
                radic: "√",
                raemptyv: "⦳",
                Rang: "⟫",
                rang: "⟩",
                rangd: "⦒",
                range: "⦥",
                rangle: "⟩",
                raquo: "»",
                Rarr: "↠",
                rArr: "⇒",
                rarr: "→",
                rarrap: "⥵",
                rarrb: "⇥",
                rarrbfs: "⤠",
                rarrc: "⤳",
                rarrfs: "⤞",
                rarrhk: "↪",
                rarrlp: "↬",
                rarrpl: "⥅",
                rarrsim: "⥴",
                Rarrtl: "⤖",
                rarrtl: "↣",
                rarrw: "↝",
                rAtail: "⤜",
                ratail: "⤚",
                ratio: "∶",
                rationals: "ℚ",
                RBarr: "⤐",
                rBarr: "⤏",
                rbarr: "⤍",
                rbbrk: "❳",
                rbrace: "}",
                rbrack: "]",
                rbrke: "⦌",
                rbrksld: "⦎",
                rbrkslu: "⦐",
                Rcaron: "Ř",
                rcaron: "ř",
                Rcedil: "Ŗ",
                rcedil: "ŗ",
                rceil: "⌉",
                rcub: "}",
                Rcy: "Р",
                rcy: "р",
                rdca: "⤷",
                rdldhar: "⥩",
                rdquo: "”",
                rdquor: "”",
                rdsh: "↳",
                Re: "ℜ",
                real: "ℜ",
                realine: "ℛ",
                realpart: "ℜ",
                reals: "ℝ",
                rect: "▭",
                REG: "®",
                reg: "®",
                ReverseElement: "∋",
                ReverseEquilibrium: "⇋",
                ReverseUpEquilibrium: "⥯",
                rfisht: "⥽",
                rfloor: "⌋",
                Rfr: "ℜ",
                rfr: "𝔯",
                rHar: "⥤",
                rhard: "⇁",
                rharu: "⇀",
                rharul: "⥬",
                Rho: "Ρ",
                rho: "ρ",
                rhov: "ϱ",
                RightAngleBracket: "⟩",
                RightArrow: "→",
                Rightarrow: "⇒",
                rightarrow: "→",
                RightArrowBar: "⇥",
                RightArrowLeftArrow: "⇄",
                rightarrowtail: "↣",
                RightCeiling: "⌉",
                RightDoubleBracket: "⟧",
                RightDownTeeVector: "⥝",
                RightDownVector: "⇂",
                RightDownVectorBar: "⥕",
                RightFloor: "⌋",
                rightharpoondown: "⇁",
                rightharpoonup: "⇀",
                rightleftarrows: "⇄",
                rightleftharpoons: "⇌",
                rightrightarrows: "⇉",
                rightsquigarrow: "↝",
                RightTee: "⊢",
                RightTeeArrow: "↦",
                RightTeeVector: "⥛",
                rightthreetimes: "⋌",
                RightTriangle: "⊳",
                RightTriangleBar: "⧐",
                RightTriangleEqual: "⊵",
                RightUpDownVector: "⥏",
                RightUpTeeVector: "⥜",
                RightUpVector: "↾",
                RightUpVectorBar: "⥔",
                RightVector: "⇀",
                RightVectorBar: "⥓",
                ring: "˚",
                risingdotseq: "≓",
                rlarr: "⇄",
                rlhar: "⇌",
                rlm: "‏",
                rmoust: "⎱",
                rmoustache: "⎱",
                rnmid: "⫮",
                roang: "⟭",
                roarr: "⇾",
                robrk: "⟧",
                ropar: "⦆",
                Ropf: "ℝ",
                ropf: "𝕣",
                roplus: "⨮",
                rotimes: "⨵",
                RoundImplies: "⥰",
                rpar: ")",
                rpargt: "⦔",
                rppolint: "⨒",
                rrarr: "⇉",
                Rrightarrow: "⇛",
                rsaquo: "›",
                Rscr: "ℛ",
                rscr: "𝓇",
                Rsh: "↱",
                rsh: "↱",
                rsqb: "]",
                rsquo: "’",
                rsquor: "’",
                rthree: "⋌",
                rtimes: "⋊",
                rtri: "▹",
                rtrie: "⊵",
                rtrif: "▸",
                rtriltri: "⧎",
                RuleDelayed: "⧴",
                ruluhar: "⥨",
                rx: "℞",
                Sacute: "Ś",
                sacute: "ś",
                sbquo: "‚",
                Sc: "⪼",
                sc: "≻",
                scap: "⪸",
                Scaron: "Š",
                scaron: "š",
                sccue: "≽",
                scE: "⪴",
                sce: "⪰",
                Scedil: "Ş",
                scedil: "ş",
                Scirc: "Ŝ",
                scirc: "ŝ",
                scnap: "⪺",
                scnE: "⪶",
                scnsim: "⋩",
                scpolint: "⨓",
                scsim: "≿",
                Scy: "С",
                scy: "с",
                sdot: "⋅",
                sdotb: "⊡",
                sdote: "⩦",
                searhk: "⤥",
                seArr: "⇘",
                searr: "↘",
                searrow: "↘",
                sect: "§",
                semi: ";",
                seswar: "⤩",
                setminus: "∖",
                setmn: "∖",
                sext: "✶",
                Sfr: "𝔖",
                sfr: "𝔰",
                sfrown: "⌢",
                sharp: "♯",
                SHCHcy: "Щ",
                shchcy: "щ",
                SHcy: "Ш",
                shcy: "ш",
                ShortDownArrow: "↓",
                ShortLeftArrow: "←",
                shortmid: "∣",
                shortparallel: "∥",
                ShortRightArrow: "→",
                ShortUpArrow: "↑",
                shy: "­",
                Sigma: "Σ",
                sigma: "σ",
                sigmaf: "ς",
                sigmav: "ς",
                sim: "∼",
                simdot: "⩪",
                sime: "≃",
                simeq: "≃",
                simg: "⪞",
                simgE: "⪠",
                siml: "⪝",
                simlE: "⪟",
                simne: "≆",
                simplus: "⨤",
                simrarr: "⥲",
                slarr: "←",
                SmallCircle: "∘",
                smallsetminus: "∖",
                smashp: "⨳",
                smeparsl: "⧤",
                smid: "∣",
                smile: "⌣",
                smt: "⪪",
                smte: "⪬",
                smtes: "⪬︀",
                SOFTcy: "Ь",
                softcy: "ь",
                sol: "/",
                solb: "⧄",
                solbar: "⌿",
                Sopf: "𝕊",
                sopf: "𝕤",
                spades: "♠",
                spadesuit: "♠",
                spar: "∥",
                sqcap: "⊓",
                sqcaps: "⊓︀",
                sqcup: "⊔",
                sqcups: "⊔︀",
                Sqrt: "√",
                sqsub: "⊏",
                sqsube: "⊑",
                sqsubset: "⊏",
                sqsubseteq: "⊑",
                sqsup: "⊐",
                sqsupe: "⊒",
                sqsupset: "⊐",
                sqsupseteq: "⊒",
                squ: "□",
                Square: "□",
                square: "□",
                SquareIntersection: "⊓",
                SquareSubset: "⊏",
                SquareSubsetEqual: "⊑",
                SquareSuperset: "⊐",
                SquareSupersetEqual: "⊒",
                SquareUnion: "⊔",
                squarf: "▪",
                squf: "▪",
                srarr: "→",
                Sscr: "𝒮",
                sscr: "𝓈",
                ssetmn: "∖",
                ssmile: "⌣",
                sstarf: "⋆",
                Star: "⋆",
                star: "☆",
                starf: "★",
                straightepsilon: "ϵ",
                straightphi: "ϕ",
                strns: "¯",
                Sub: "⋐",
                sub: "⊂",
                subdot: "⪽",
                subE: "⫅",
                sube: "⊆",
                subedot: "⫃",
                submult: "⫁",
                subnE: "⫋",
                subne: "⊊",
                subplus: "⪿",
                subrarr: "⥹",
                Subset: "⋐",
                subset: "⊂",
                subseteq: "⊆",
                subseteqq: "⫅",
                SubsetEqual: "⊆",
                subsetneq: "⊊",
                subsetneqq: "⫋",
                subsim: "⫇",
                subsub: "⫕",
                subsup: "⫓",
                succ: "≻",
                succapprox: "⪸",
                succcurlyeq: "≽",
                Succeeds: "≻",
                SucceedsEqual: "⪰",
                SucceedsSlantEqual: "≽",
                SucceedsTilde: "≿",
                succeq: "⪰",
                succnapprox: "⪺",
                succneqq: "⪶",
                succnsim: "⋩",
                succsim: "≿",
                SuchThat: "∋",
                Sum: "∑",
                sum: "∑",
                sung: "♪",
                Sup: "⋑",
                sup: "⊃",
                sup1: "¹",
                sup2: "²",
                sup3: "³",
                supdot: "⪾",
                supdsub: "⫘",
                supE: "⫆",
                supe: "⊇",
                supedot: "⫄",
                Superset: "⊃",
                SupersetEqual: "⊇",
                suphsol: "⟉",
                suphsub: "⫗",
                suplarr: "⥻",
                supmult: "⫂",
                supnE: "⫌",
                supne: "⊋",
                supplus: "⫀",
                Supset: "⋑",
                supset: "⊃",
                supseteq: "⊇",
                supseteqq: "⫆",
                supsetneq: "⊋",
                supsetneqq: "⫌",
                supsim: "⫈",
                supsub: "⫔",
                supsup: "⫖",
                swarhk: "⤦",
                swArr: "⇙",
                swarr: "↙",
                swarrow: "↙",
                swnwar: "⤪",
                szlig: "ß",
                Tab: "	",
                target: "⌖",
                Tau: "Τ",
                tau: "τ",
                tbrk: "⎴",
                Tcaron: "Ť",
                tcaron: "ť",
                Tcedil: "Ţ",
                tcedil: "ţ",
                Tcy: "Т",
                tcy: "т",
                tdot: "⃛",
                telrec: "⌕",
                Tfr: "𝔗",
                tfr: "𝔱",
                there4: "∴",
                Therefore: "∴",
                therefore: "∴",
                Theta: "Θ",
                theta: "θ",
                thetasym: "ϑ",
                thetav: "ϑ",
                thickapprox: "≈",
                thicksim: "∼",
                ThickSpace: "  ",
                thinsp: " ",
                ThinSpace: " ",
                thkap: "≈",
                thksim: "∼",
                THORN: "Þ",
                thorn: "þ",
                Tilde: "∼",
                tilde: "˜",
                TildeEqual: "≃",
                TildeFullEqual: "≅",
                TildeTilde: "≈",
                times: "×",
                timesb: "⊠",
                timesbar: "⨱",
                timesd: "⨰",
                tint: "∭",
                toea: "⤨",
                top: "⊤",
                topbot: "⌶",
                topcir: "⫱",
                Topf: "𝕋",
                topf: "𝕥",
                topfork: "⫚",
                tosa: "⤩",
                tprime: "‴",
                TRADE: "™",
                trade: "™",
                triangle: "▵",
                triangledown: "▿",
                triangleleft: "◃",
                trianglelefteq: "⊴",
                triangleq: "≜",
                triangleright: "▹",
                trianglerighteq: "⊵",
                tridot: "◬",
                trie: "≜",
                triminus: "⨺",
                TripleDot: "⃛",
                triplus: "⨹",
                trisb: "⧍",
                tritime: "⨻",
                trpezium: "⏢",
                Tscr: "𝒯",
                tscr: "𝓉",
                TScy: "Ц",
                tscy: "ц",
                TSHcy: "Ћ",
                tshcy: "ћ",
                Tstrok: "Ŧ",
                tstrok: "ŧ",
                twixt: "≬",
                twoheadleftarrow: "↞",
                twoheadrightarrow: "↠",
                Uacute: "Ú",
                uacute: "ú",
                Uarr: "↟",
                uArr: "⇑",
                uarr: "↑",
                Uarrocir: "⥉",
                Ubrcy: "Ў",
                ubrcy: "ў",
                Ubreve: "Ŭ",
                ubreve: "ŭ",
                Ucirc: "Û",
                ucirc: "û",
                Ucy: "У",
                ucy: "у",
                udarr: "⇅",
                Udblac: "Ű",
                udblac: "ű",
                udhar: "⥮",
                ufisht: "⥾",
                Ufr: "𝔘",
                ufr: "𝔲",
                Ugrave: "Ù",
                ugrave: "ù",
                uHar: "⥣",
                uharl: "↿",
                uharr: "↾",
                uhblk: "▀",
                ulcorn: "⌜",
                ulcorner: "⌜",
                ulcrop: "⌏",
                ultri: "◸",
                Umacr: "Ū",
                umacr: "ū",
                uml: "¨",
                UnderBar: "_",
                UnderBrace: "⏟",
                UnderBracket: "⎵",
                UnderParenthesis: "⏝",
                Union: "⋃",
                UnionPlus: "⊎",
                Uogon: "Ų",
                uogon: "ų",
                Uopf: "𝕌",
                uopf: "𝕦",
                UpArrow: "↑",
                Uparrow: "⇑",
                uparrow: "↑",
                UpArrowBar: "⤒",
                UpArrowDownArrow: "⇅",
                UpDownArrow: "↕",
                Updownarrow: "⇕",
                updownarrow: "↕",
                UpEquilibrium: "⥮",
                upharpoonleft: "↿",
                upharpoonright: "↾",
                uplus: "⊎",
                UpperLeftArrow: "↖",
                UpperRightArrow: "↗",
                Upsi: "ϒ",
                upsi: "υ",
                upsih: "ϒ",
                Upsilon: "Υ",
                upsilon: "υ",
                UpTee: "⊥",
                UpTeeArrow: "↥",
                upuparrows: "⇈",
                urcorn: "⌝",
                urcorner: "⌝",
                urcrop: "⌎",
                Uring: "Ů",
                uring: "ů",
                urtri: "◹",
                Uscr: "𝒰",
                uscr: "𝓊",
                utdot: "⋰",
                Utilde: "Ũ",
                utilde: "ũ",
                utri: "▵",
                utrif: "▴",
                uuarr: "⇈",
                Uuml: "Ü",
                uuml: "ü",
                uwangle: "⦧",
                vangrt: "⦜",
                varepsilon: "ϵ",
                varkappa: "ϰ",
                varnothing: "∅",
                varphi: "ϕ",
                varpi: "ϖ",
                varpropto: "∝",
                vArr: "⇕",
                varr: "↕",
                varrho: "ϱ",
                varsigma: "ς",
                varsubsetneq: "⊊︀",
                varsubsetneqq: "⫋︀",
                varsupsetneq: "⊋︀",
                varsupsetneqq: "⫌︀",
                vartheta: "ϑ",
                vartriangleleft: "⊲",
                vartriangleright: "⊳",
                Vbar: "⫫",
                vBar: "⫨",
                vBarv: "⫩",
                Vcy: "В",
                vcy: "в",
                VDash: "⊫",
                Vdash: "⊩",
                vDash: "⊨",
                vdash: "⊢",
                Vdashl: "⫦",
                Vee: "⋁",
                vee: "∨",
                veebar: "⊻",
                veeeq: "≚",
                vellip: "⋮",
                Verbar: "‖",
                verbar: "|",
                Vert: "‖",
                vert: "|",
                VerticalBar: "∣",
                VerticalLine: "|",
                VerticalSeparator: "❘",
                VerticalTilde: "≀",
                VeryThinSpace: " ",
                Vfr: "𝔙",
                vfr: "𝔳",
                vltri: "⊲",
                vnsub: "⊂⃒",
                vnsup: "⊃⃒",
                Vopf: "𝕍",
                vopf: "𝕧",
                vprop: "∝",
                vrtri: "⊳",
                Vscr: "𝒱",
                vscr: "𝓋",
                vsubnE: "⫋︀",
                vsubne: "⊊︀",
                vsupnE: "⫌︀",
                vsupne: "⊋︀",
                Vvdash: "⊪",
                vzigzag: "⦚",
                Wcirc: "Ŵ",
                wcirc: "ŵ",
                wedbar: "⩟",
                Wedge: "⋀",
                wedge: "∧",
                wedgeq: "≙",
                weierp: "℘",
                Wfr: "𝔚",
                wfr: "𝔴",
                Wopf: "𝕎",
                wopf: "𝕨",
                wp: "℘",
                wr: "≀",
                wreath: "≀",
                Wscr: "𝒲",
                wscr: "𝓌",
                xcap: "⋂",
                xcirc: "◯",
                xcup: "⋃",
                xdtri: "▽",
                Xfr: "𝔛",
                xfr: "𝔵",
                xhArr: "⟺",
                xharr: "⟷",
                Xi: "Ξ",
                xi: "ξ",
                xlArr: "⟸",
                xlarr: "⟵",
                xmap: "⟼",
                xnis: "⋻",
                xodot: "⨀",
                Xopf: "𝕏",
                xopf: "𝕩",
                xoplus: "⨁",
                xotime: "⨂",
                xrArr: "⟹",
                xrarr: "⟶",
                Xscr: "𝒳",
                xscr: "𝓍",
                xsqcup: "⨆",
                xuplus: "⨄",
                xutri: "△",
                xvee: "⋁",
                xwedge: "⋀",
                Yacute: "Ý",
                yacute: "ý",
                YAcy: "Я",
                yacy: "я",
                Ycirc: "Ŷ",
                ycirc: "ŷ",
                Ycy: "Ы",
                ycy: "ы",
                yen: "¥",
                Yfr: "𝔜",
                yfr: "𝔶",
                YIcy: "Ї",
                yicy: "ї",
                Yopf: "𝕐",
                yopf: "𝕪",
                Yscr: "𝒴",
                yscr: "𝓎",
                YUcy: "Ю",
                yucy: "ю",
                Yuml: "Ÿ",
                yuml: "ÿ",
                Zacute: "Ź",
                zacute: "ź",
                Zcaron: "Ž",
                zcaron: "ž",
                Zcy: "З",
                zcy: "з",
                Zdot: "Ż",
                zdot: "ż",
                zeetrf: "ℨ",
                ZeroWidthSpace: "​",
                Zeta: "Ζ",
                zeta: "ζ",
                Zfr: "ℨ",
                zfr: "𝔷",
                ZHcy: "Ж",
                zhcy: "ж",
                zigrarr: "⇝",
                Zopf: "ℤ",
                zopf: "𝕫",
                Zscr: "𝒵",
                zscr: "𝓏",
                zwj: "‍",
                zwnj: "‌"
              }), li.entityMap = li.HTML_ENTITIES;
            })
          ),
          /***/
          "./node_modules/@xmldom/xmldom/lib/index.js": (
            /*!**************************************************!*\
              !*** ./node_modules/@xmldom/xmldom/lib/index.js ***!
              \**************************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! ./dom */
                "./node_modules/@xmldom/xmldom/lib/dom.js"
              );
              li.DOMImplementation = si.DOMImplementation, li.XMLSerializer = si.XMLSerializer, li.DOMParser = oi(
                /*! ./dom-parser */
                "./node_modules/@xmldom/xmldom/lib/dom-parser.js"
              ).DOMParser;
            })
          ),
          /***/
          "./node_modules/@xmldom/xmldom/lib/sax.js": (
            /*!************************************************!*\
              !*** ./node_modules/@xmldom/xmldom/lib/sax.js ***!
              \************************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! ./conventions */
                "./node_modules/@xmldom/xmldom/lib/conventions.js"
              ).NAMESPACE, di = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, fi = new RegExp("[\\-\\.0-9" + di.source.slice(1, -1) + "\\u00B7\\u0300-\\u036F\\u203F-\\u2040]"), gi = new RegExp("^" + di.source + fi.source + "*(?::" + di.source + fi.source + "*)?$"), mi = 0, Ti = 1, vi = 2, xi = 3, Si = 4, Pi = 5, $i = 6, Oi = 7;
              function Di(Ui, jo) {
                this.message = Ui, this.locator = jo, Error.captureStackTrace && Error.captureStackTrace(this, Di);
              }
              Di.prototype = new Error(), Di.prototype.name = Di.name;
              function Mi() {
              }
              Mi.prototype = {
                parse: function(Ui, jo, Wi) {
                  var ji = this.domBuilder;
                  ji.startDocument(), Co(jo, jo = {}), Oo(
                    Ui,
                    jo,
                    Wi,
                    ji,
                    this.errorHandler
                  ), ji.endDocument();
                }
              };
              function Oo(Ui, jo, Wi, ji, Hi) {
                function zo(Ps) {
                  if (Ps > 65535) {
                    Ps -= 65536;
                    var nl = 55296 + (Ps >> 10), Vs = 56320 + (Ps & 1023);
                    return String.fromCharCode(nl, Vs);
                  } else
                    return String.fromCharCode(Ps);
                }
                function Lo(Ps) {
                  var nl = Ps.slice(1, -1);
                  return Object.hasOwnProperty.call(Wi, nl) ? Wi[nl] : nl.charAt(0) === "#" ? zo(parseInt(nl.substr(1).replace("x", "0x"))) : (Hi.error("entity not found:" + Ps), Ps);
                }
                function sa(Ps) {
                  if (Ps > xa) {
                    var nl = Ui.substring(xa, Ps).replace(/&#?\w+;/g, Lo);
                    ia && Ko(xa), ji.characters(nl, 0, Ps - xa), xa = Ps;
                  }
                }
                function Ko(Ps, nl) {
                  for (; Ps >= pa && (nl = ga.exec(Ui)); )
                    ca = nl.index, pa = ca + nl[0].length, ia.lineNumber++;
                  ia.columnNumber = Ps - ca + 1;
                }
                for (var ca = 0, pa = 0, ga = /.*(?:\r\n?|\n)|.*$/g, ia = ji.locator, ra = [{ currentNSMap: jo }], qo = {}, xa = 0; ; ) {
                  try {
                    var $a = Ui.indexOf("<", xa);
                    if ($a < 0) {
                      if (!Ui.substr(xa).match(/^\s*$/)) {
                        var ys = ji.doc, Ss = ys.createTextNode(Ui.substr(xa));
                        ys.appendChild(Ss), ji.currentElement = Ss;
                      }
                      return;
                    }
                    switch ($a > xa && sa($a), Ui.charAt($a + 1)) {
                      case "/":
                        var Qa = Ui.indexOf(">", $a + 3), Xa = Ui.substring($a + 2, Qa).replace(/[ \t\n\r]+$/g, ""), Es = ra.pop();
                        Qa < 0 ? (Xa = Ui.substring($a + 2).replace(/[\s<].*/, ""), Hi.error("end tag name: " + Xa + " is not complete:" + Es.tagName), Qa = $a + 1 + Xa.length) : Xa.match(/\s</) && (Xa = Xa.replace(/[\s<].*/, ""), Hi.error("end tag name: " + Xa + " maybe not complete"), Qa = $a + 1 + Xa.length);
                        var Rs = Es.localNSMap, La = Es.tagName == Xa, Ja = La || Es.tagName && Es.tagName.toLowerCase() == Xa.toLowerCase();
                        if (Ja) {
                          if (ji.endElement(Es.uri, Es.localName, Xa), Rs)
                            for (var ja in Rs)
                              Object.prototype.hasOwnProperty.call(Rs, ja) && ji.endPrefixMapping(ja);
                          La || Hi.fatalError("end tag name: " + Xa + " is not match the current start tagName:" + Es.tagName);
                        } else
                          ra.push(Es);
                        Qa++;
                        break;
                      // end elment
                      case "?":
                        ia && Ko($a), Qa = Yi(Ui, $a, ji);
                        break;
                      case "!":
                        ia && Ko($a), Qa = Ni(Ui, $a, ji, Hi);
                        break;
                      default:
                        ia && Ko($a);
                        var Ta = new Vo(), rs = ra[ra.length - 1].currentNSMap, Qa = xo(Ui, $a, Ta, rs, Lo, Hi), Cs = Ta.length;
                        if (!Ta.closed && Li(Ui, Qa, Ta.tagName, qo) && (Ta.closed = !0, Wi.nbsp || Hi.warning("unclosed xml attribute")), ia && Cs) {
                          for (var _a = io(ia, {}), _s = 0; _s < Cs; _s++) {
                            var el = Ta[_s];
                            Ko(el.offset), el.locator = io(ia, {});
                          }
                          ji.locator = _a, fo(Ta, ji, rs) && ra.push(Ta), ji.locator = ia;
                        } else
                          fo(Ta, ji, rs) && ra.push(Ta);
                        si.isHTML(Ta.uri) && !Ta.closed ? Qa = _o(Ui, Qa, Ta.tagName, Lo, ji) : Qa++;
                    }
                  } catch (Ps) {
                    if (Ps instanceof Di)
                      throw Ps;
                    Hi.error("element parse error: " + Ps), Qa = -1;
                  }
                  Qa > xa ? xa = Qa : sa(Math.max($a, xa) + 1);
                }
              }
              function io(Ui, jo) {
                return jo.lineNumber = Ui.lineNumber, jo.columnNumber = Ui.columnNumber, jo;
              }
              function xo(Ui, jo, Wi, ji, Hi, zo) {
                function Lo(ia, ra, qo) {
                  Wi.attributeNames.hasOwnProperty(ia) && zo.fatalError("Attribute " + ia + " redefined"), Wi.addValue(
                    ia,
                    // @see https://www.w3.org/TR/xml/#AVNormalize
                    // since the xmldom sax parser does not "interpret" DTD the following is not implemented:
                    // - recursive replacement of (DTD) entity references
                    // - trimming and collapsing multiple spaces into a single one for attributes that are not of type CDATA
                    ra.replace(/[\t\n\r]/g, " ").replace(/&#?\w+;/g, Hi),
                    qo
                  );
                }
                for (var sa, Ko, ca = ++jo, pa = mi; ; ) {
                  var ga = Ui.charAt(ca);
                  switch (ga) {
                    case "=":
                      if (pa === Ti)
                        sa = Ui.slice(jo, ca), pa = xi;
                      else if (pa === vi)
                        pa = xi;
                      else
                        throw new Error("attribute equal must after attrName");
                      break;
                    case "'":
                    case '"':
                      if (pa === xi || pa === Ti)
                        if (pa === Ti && (zo.warning('attribute value must after "="'), sa = Ui.slice(jo, ca)), jo = ca + 1, ca = Ui.indexOf(ga, jo), ca > 0)
                          Ko = Ui.slice(jo, ca), Lo(sa, Ko, jo - 1), pa = Pi;
                        else
                          throw new Error("attribute value no end '" + ga + "' match");
                      else if (pa == Si)
                        Ko = Ui.slice(jo, ca), Lo(sa, Ko, jo), zo.warning('attribute "' + sa + '" missed start quot(' + ga + ")!!"), jo = ca + 1, pa = Pi;
                      else
                        throw new Error('attribute value must after "="');
                      break;
                    case "/":
                      switch (pa) {
                        case mi:
                          Wi.setTagName(Ui.slice(jo, ca));
                        case Pi:
                        case $i:
                        case Oi:
                          pa = Oi, Wi.closed = !0;
                        case Si:
                        case Ti:
                          break;
                        case vi:
                          Wi.closed = !0;
                          break;
                        //case S_EQ:
                        default:
                          throw new Error("attribute invalid close char('/')");
                      }
                      break;
                    case "":
                      return zo.error("unexpected end of input"), pa == mi && Wi.setTagName(Ui.slice(jo, ca)), ca;
                    case ">":
                      switch (pa) {
                        case mi:
                          Wi.setTagName(Ui.slice(jo, ca));
                        case Pi:
                        case $i:
                        case Oi:
                          break;
                        //normal
                        case Si:
                        //Compatible state
                        case Ti:
                          Ko = Ui.slice(jo, ca), Ko.slice(-1) === "/" && (Wi.closed = !0, Ko = Ko.slice(0, -1));
                        case vi:
                          pa === vi && (Ko = sa), pa == Si ? (zo.warning('attribute "' + Ko + '" missed quot(")!'), Lo(sa, Ko, jo)) : ((!si.isHTML(ji[""]) || !Ko.match(/^(?:disabled|checked|selected)$/i)) && zo.warning('attribute "' + Ko + '" missed value!! "' + Ko + '" instead!!'), Lo(Ko, Ko, jo));
                          break;
                        case xi:
                          throw new Error("attribute value missed!!");
                      }
                      return ca;
                    /*xml space '\x20' | #x9 | #xD | #xA; */
                    case "":
                      ga = " ";
                    default:
                      if (ga <= " ")
                        switch (pa) {
                          case mi:
                            Wi.setTagName(Ui.slice(jo, ca)), pa = $i;
                            break;
                          case Ti:
                            sa = Ui.slice(jo, ca), pa = vi;
                            break;
                          case Si:
                            var Ko = Ui.slice(jo, ca);
                            zo.warning('attribute "' + Ko + '" missed quot(")!!'), Lo(sa, Ko, jo);
                          case Pi:
                            pa = $i;
                            break;
                        }
                      else
                        switch (pa) {
                          //case S_TAG:void();break;
                          //case S_ATTR:void();break;
                          //case S_ATTR_NOQUOT_VALUE:void();break;
                          case vi:
                            Wi.tagName, (!si.isHTML(ji[""]) || !sa.match(/^(?:disabled|checked|selected)$/i)) && zo.warning('attribute "' + sa + '" missed value!! "' + sa + '" instead2!!'), Lo(sa, sa, jo), jo = ca, pa = Ti;
                            break;
                          case Pi:
                            zo.warning('attribute space is required"' + sa + '"!!');
                          case $i:
                            pa = Ti, jo = ca;
                            break;
                          case xi:
                            pa = Si, jo = ca;
                            break;
                          case Oi:
                            throw new Error("elements closed character '/' and '>' must be connected to");
                        }
                  }
                  ca++;
                }
              }
              function fo(Ui, jo, Wi) {
                for (var ji = Ui.tagName, Hi = null, ga = Ui.length; ga--; ) {
                  var zo = Ui[ga], Lo = zo.qName, sa = zo.value, ia = Lo.indexOf(":");
                  if (ia > 0)
                    var Ko = zo.prefix = Lo.slice(0, ia), ca = Lo.slice(ia + 1), pa = Ko === "xmlns" && ca;
                  else
                    ca = Lo, Ko = null, pa = Lo === "xmlns" && "";
                  zo.localName = ca, pa !== !1 && (Hi == null && (Hi = {}, Co(Wi, Wi = {})), Wi[pa] = Hi[pa] = sa, zo.uri = si.XMLNS, jo.startPrefixMapping(pa, sa));
                }
                for (var ga = Ui.length; ga--; ) {
                  zo = Ui[ga];
                  var Ko = zo.prefix;
                  Ko && (Ko === "xml" && (zo.uri = si.XML), Ko !== "xmlns" && (zo.uri = Wi[Ko || ""]));
                }
                var ia = ji.indexOf(":");
                ia > 0 ? (Ko = Ui.prefix = ji.slice(0, ia), ca = Ui.localName = ji.slice(ia + 1)) : (Ko = null, ca = Ui.localName = ji);
                var ra = Ui.uri = Wi[Ko || ""];
                if (jo.startElement(ra, ca, ji, Ui), Ui.closed) {
                  if (jo.endElement(ra, ca, ji), Hi)
                    for (Ko in Hi)
                      Object.prototype.hasOwnProperty.call(Hi, Ko) && jo.endPrefixMapping(Ko);
                } else
                  return Ui.currentNSMap = Wi, Ui.localNSMap = Hi, !0;
              }
              function _o(Ui, jo, Wi, ji, Hi) {
                if (/^(?:script|textarea)$/i.test(Wi)) {
                  var zo = Ui.indexOf("</" + Wi + ">", jo), Lo = Ui.substring(jo + 1, zo);
                  if (/[&<]/.test(Lo))
                    return /^script$/i.test(Wi) ? (Hi.characters(Lo, 0, Lo.length), zo) : (Lo = Lo.replace(/&#?\w+;/g, ji), Hi.characters(Lo, 0, Lo.length), zo);
                }
                return jo + 1;
              }
              function Li(Ui, jo, Wi, ji) {
                var Hi = ji[Wi];
                return Hi == null && (Hi = Ui.lastIndexOf("</" + Wi + ">"), Hi < jo && (Hi = Ui.lastIndexOf("</" + Wi)), ji[Wi] = Hi), Hi < jo;
              }
              function Co(Ui, jo) {
                for (var Wi in Ui)
                  Object.prototype.hasOwnProperty.call(Ui, Wi) && (jo[Wi] = Ui[Wi]);
              }
              function Ni(Ui, jo, Wi, ji) {
                var Hi = Ui.charAt(jo + 2);
                switch (Hi) {
                  case "-":
                    if (Ui.charAt(jo + 3) === "-") {
                      var zo = Ui.indexOf("-->", jo + 4);
                      return zo > jo ? (Wi.comment(Ui, jo + 4, zo - jo - 4), zo + 3) : (ji.error("Unclosed comment"), -1);
                    } else
                      return -1;
                  default:
                    if (Ui.substr(jo + 3, 6) == "CDATA[") {
                      var zo = Ui.indexOf("]]>", jo + 9);
                      return Wi.startCDATA(), Wi.characters(Ui, jo + 9, zo - jo - 9), Wi.endCDATA(), zo + 3;
                    }
                    var Lo = No(Ui, jo), sa = Lo.length;
                    if (sa > 1 && /!doctype/i.test(Lo[0][0])) {
                      var Ko = Lo[1][0], ca = !1, pa = !1;
                      sa > 3 && (/^public$/i.test(Lo[2][0]) ? (ca = Lo[3][0], pa = sa > 4 && Lo[4][0]) : /^system$/i.test(Lo[2][0]) && (pa = Lo[3][0]));
                      var ga = Lo[sa - 1];
                      return Wi.startDTD(Ko, ca, pa), Wi.endDTD(), ga.index + ga[0].length;
                    }
                }
                return -1;
              }
              function Yi(Ui, jo, Wi) {
                var ji = Ui.indexOf("?>", jo);
                if (ji) {
                  var Hi = Ui.substring(jo, ji).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
                  return Hi ? (Hi[0].length, Wi.processingInstruction(Hi[1], Hi[2]), ji + 2) : -1;
                }
                return -1;
              }
              function Vo() {
                this.attributeNames = {};
              }
              Vo.prototype = {
                setTagName: function(Ui) {
                  if (!gi.test(Ui))
                    throw new Error("invalid tagName:" + Ui);
                  this.tagName = Ui;
                },
                addValue: function(Ui, jo, Wi) {
                  if (!gi.test(Ui))
                    throw new Error("invalid attribute:" + Ui);
                  this.attributeNames[Ui] = this.length, this[this.length++] = { qName: Ui, value: jo, offset: Wi };
                },
                length: 0,
                getLocalName: function(Ui) {
                  return this[Ui].localName;
                },
                getLocator: function(Ui) {
                  return this[Ui].locator;
                },
                getQName: function(Ui) {
                  return this[Ui].qName;
                },
                getURI: function(Ui) {
                  return this[Ui].uri;
                },
                getValue: function(Ui) {
                  return this[Ui].value;
                }
                //	,getIndex:function(uri, localName)){
                //		if(localName){
                //
                //		}else{
                //			var qName = uri
                //		}
                //	},
                //	getValue:function(){return this.getValue(this.getIndex.apply(this,arguments))},
                //	getType:function(uri,localName){}
                //	getType:function(i){},
              };
              function No(Ui, jo) {
                var Wi, ji = [], Hi = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
                for (Hi.lastIndex = jo, Hi.exec(Ui); Wi = Hi.exec(Ui); )
                  if (ji.push(Wi), Wi[1]) return ji;
              }
              li.XMLReader = Mi, li.ParseError = Di;
            })
          ),
          /***/
          "./node_modules/assert/build/assert.js": (
            /*!*********************************************!*\
              !*** ./node_modules/assert/build/assert.js ***!
              \*********************************************/
            /***/
            ((ai, li, oi) => {
              function si(xa) {
                "@babel/helpers - typeof";
                return si = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function($a) {
                  return typeof $a;
                } : function($a) {
                  return $a && typeof Symbol == "function" && $a.constructor === Symbol && $a !== Symbol.prototype ? "symbol" : typeof $a;
                }, si(xa);
              }
              function di(xa, $a, ys) {
                return Object.defineProperty(xa, "prototype", { writable: !1 }), xa;
              }
              function fi(xa, $a) {
                if (!(xa instanceof $a))
                  throw new TypeError("Cannot call a class as a function");
              }
              var gi = oi(
                /*! ./internal/errors */
                "./node_modules/assert/build/internal/errors.js"
              ), mi = gi.codes, Ti = mi.ERR_AMBIGUOUS_ARGUMENT, vi = mi.ERR_INVALID_ARG_TYPE, xi = mi.ERR_INVALID_ARG_VALUE, Si = mi.ERR_INVALID_RETURN_VALUE, Pi = mi.ERR_MISSING_ARGS, $i = oi(
                /*! ./internal/assert/assertion_error */
                "./node_modules/assert/build/internal/assert/assertion_error.js"
              ), Oi = oi(
                /*! util/ */
                "./node_modules/util/util.js"
              ), Di = Oi.inspect, Mi = oi(
                /*! util/ */
                "./node_modules/util/util.js"
              ).types, Oo = Mi.isPromise, io = Mi.isRegExp, xo = oi(
                /*! object.assign/polyfill */
                "./node_modules/object.assign/polyfill.js"
              )(), fo = oi(
                /*! object-is/polyfill */
                "./node_modules/object-is/polyfill.js"
              )(), _o = oi(
                /*! call-bind/callBound */
                "./node_modules/call-bind/callBound.js"
              )("RegExp.prototype.test"), Li, Co;
              function Ni() {
                var xa = oi(
                  /*! ./internal/util/comparisons */
                  "./node_modules/assert/build/internal/util/comparisons.js"
                );
                Li = xa.isDeepEqual, Co = xa.isDeepStrictEqual;
              }
              var Yi = !1, Vo = ai.exports = ji, No = {};
              function Ui(xa) {
                throw xa.message instanceof Error ? xa.message : new $i(xa);
              }
              function jo(xa, $a, ys, Ss, Xa) {
                var Es = arguments.length, Rs;
                if (Es === 0)
                  Rs = "Failed";
                else if (Es === 1)
                  ys = xa, xa = void 0;
                else {
                  if (Yi === !1) {
                    Yi = !0;
                    var La = process.emitWarning ? process.emitWarning : console.warn.bind(console);
                    La("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094");
                  }
                  Es === 2 && (Ss = "!=");
                }
                if (ys instanceof Error) throw ys;
                var Ja = {
                  actual: xa,
                  expected: $a,
                  operator: Ss === void 0 ? "fail" : Ss,
                  stackStartFn: Xa || jo
                };
                ys !== void 0 && (Ja.message = ys);
                var ja = new $i(Ja);
                throw Rs && (ja.message = Rs, ja.generatedMessage = !0), ja;
              }
              Vo.fail = jo, Vo.AssertionError = $i;
              function Wi(xa, $a, ys, Ss) {
                if (!ys) {
                  var Xa = !1;
                  if ($a === 0)
                    Xa = !0, Ss = "No value argument passed to `assert.ok()`";
                  else if (Ss instanceof Error)
                    throw Ss;
                  var Es = new $i({
                    actual: ys,
                    expected: !0,
                    message: Ss,
                    operator: "==",
                    stackStartFn: xa
                  });
                  throw Es.generatedMessage = Xa, Es;
                }
              }
              function ji() {
                for (var xa = arguments.length, $a = new Array(xa), ys = 0; ys < xa; ys++)
                  $a[ys] = arguments[ys];
                Wi.apply(void 0, [ji, $a.length].concat($a));
              }
              Vo.ok = ji, Vo.equal = function xa($a, ys, Ss) {
                if (arguments.length < 2)
                  throw new Pi("actual", "expected");
                $a != ys && Ui({
                  actual: $a,
                  expected: ys,
                  message: Ss,
                  operator: "==",
                  stackStartFn: xa
                });
              }, Vo.notEqual = function xa($a, ys, Ss) {
                if (arguments.length < 2)
                  throw new Pi("actual", "expected");
                $a == ys && Ui({
                  actual: $a,
                  expected: ys,
                  message: Ss,
                  operator: "!=",
                  stackStartFn: xa
                });
              }, Vo.deepEqual = function xa($a, ys, Ss) {
                if (arguments.length < 2)
                  throw new Pi("actual", "expected");
                Li === void 0 && Ni(), Li($a, ys) || Ui({
                  actual: $a,
                  expected: ys,
                  message: Ss,
                  operator: "deepEqual",
                  stackStartFn: xa
                });
              }, Vo.notDeepEqual = function xa($a, ys, Ss) {
                if (arguments.length < 2)
                  throw new Pi("actual", "expected");
                Li === void 0 && Ni(), Li($a, ys) && Ui({
                  actual: $a,
                  expected: ys,
                  message: Ss,
                  operator: "notDeepEqual",
                  stackStartFn: xa
                });
              }, Vo.deepStrictEqual = function xa($a, ys, Ss) {
                if (arguments.length < 2)
                  throw new Pi("actual", "expected");
                Li === void 0 && Ni(), Co($a, ys) || Ui({
                  actual: $a,
                  expected: ys,
                  message: Ss,
                  operator: "deepStrictEqual",
                  stackStartFn: xa
                });
              }, Vo.notDeepStrictEqual = Hi;
              function Hi(xa, $a, ys) {
                if (arguments.length < 2)
                  throw new Pi("actual", "expected");
                Li === void 0 && Ni(), Co(xa, $a) && Ui({
                  actual: xa,
                  expected: $a,
                  message: ys,
                  operator: "notDeepStrictEqual",
                  stackStartFn: Hi
                });
              }
              Vo.strictEqual = function xa($a, ys, Ss) {
                if (arguments.length < 2)
                  throw new Pi("actual", "expected");
                fo($a, ys) || Ui({
                  actual: $a,
                  expected: ys,
                  message: Ss,
                  operator: "strictEqual",
                  stackStartFn: xa
                });
              }, Vo.notStrictEqual = function xa($a, ys, Ss) {
                if (arguments.length < 2)
                  throw new Pi("actual", "expected");
                fo($a, ys) && Ui({
                  actual: $a,
                  expected: ys,
                  message: Ss,
                  operator: "notStrictEqual",
                  stackStartFn: xa
                });
              };
              var zo = /* @__PURE__ */ di(function xa($a, ys, Ss) {
                var Xa = this;
                fi(this, xa), ys.forEach(function(Es) {
                  Es in $a && (Ss !== void 0 && typeof Ss[Es] == "string" && io($a[Es]) && _o($a[Es], Ss[Es]) ? Xa[Es] = Ss[Es] : Xa[Es] = $a[Es]);
                });
              });
              function Lo(xa, $a, ys, Ss, Xa, Es) {
                if (!(ys in xa) || !Co(xa[ys], $a[ys])) {
                  if (!Ss) {
                    var Rs = new zo(xa, Xa), La = new zo($a, Xa, xa), Ja = new $i({
                      actual: Rs,
                      expected: La,
                      operator: "deepStrictEqual",
                      stackStartFn: Es
                    });
                    throw Ja.actual = xa, Ja.expected = $a, Ja.operator = Es.name, Ja;
                  }
                  Ui({
                    actual: xa,
                    expected: $a,
                    message: Ss,
                    operator: Es.name,
                    stackStartFn: Es
                  });
                }
              }
              function sa(xa, $a, ys, Ss) {
                if (typeof $a != "function") {
                  if (io($a)) return _o($a, xa);
                  if (arguments.length === 2)
                    throw new vi("expected", ["Function", "RegExp"], $a);
                  if (si(xa) !== "object" || xa === null) {
                    var Xa = new $i({
                      actual: xa,
                      expected: $a,
                      message: ys,
                      operator: "deepStrictEqual",
                      stackStartFn: Ss
                    });
                    throw Xa.operator = Ss.name, Xa;
                  }
                  var Es = Object.keys($a);
                  if ($a instanceof Error)
                    Es.push("name", "message");
                  else if (Es.length === 0)
                    throw new xi("error", $a, "may not be an empty object");
                  return Li === void 0 && Ni(), Es.forEach(function(Rs) {
                    typeof xa[Rs] == "string" && io($a[Rs]) && _o($a[Rs], xa[Rs]) || Lo(xa, $a, Rs, ys, Es, Ss);
                  }), !0;
                }
                return $a.prototype !== void 0 && xa instanceof $a ? !0 : Error.isPrototypeOf($a) ? !1 : $a.call({}, xa) === !0;
              }
              function Ko(xa) {
                if (typeof xa != "function")
                  throw new vi("fn", "Function", xa);
                try {
                  xa();
                } catch ($a) {
                  return $a;
                }
                return No;
              }
              function ca(xa) {
                return Oo(xa) || xa !== null && si(xa) === "object" && typeof xa.then == "function" && typeof xa.catch == "function";
              }
              function pa(xa) {
                return Promise.resolve().then(function() {
                  var $a;
                  if (typeof xa == "function") {
                    if ($a = xa(), !ca($a))
                      throw new Si("instance of Promise", "promiseFn", $a);
                  } else if (ca(xa))
                    $a = xa;
                  else
                    throw new vi("promiseFn", ["Function", "Promise"], xa);
                  return Promise.resolve().then(function() {
                    return $a;
                  }).then(function() {
                    return No;
                  }).catch(function(ys) {
                    return ys;
                  });
                });
              }
              function ga(xa, $a, ys, Ss) {
                if (typeof ys == "string") {
                  if (arguments.length === 4)
                    throw new vi("error", ["Object", "Error", "Function", "RegExp"], ys);
                  if (si($a) === "object" && $a !== null) {
                    if ($a.message === ys)
                      throw new Ti("error/message", 'The error message "'.concat($a.message, '" is identical to the message.'));
                  } else if ($a === ys)
                    throw new Ti("error/message", 'The error "'.concat($a, '" is identical to the message.'));
                  Ss = ys, ys = void 0;
                } else if (ys != null && si(ys) !== "object" && typeof ys != "function")
                  throw new vi("error", ["Object", "Error", "Function", "RegExp"], ys);
                if ($a === No) {
                  var Xa = "";
                  ys && ys.name && (Xa += " (".concat(ys.name, ")")), Xa += Ss ? ": ".concat(Ss) : ".";
                  var Es = xa.name === "rejects" ? "rejection" : "exception";
                  Ui({
                    actual: void 0,
                    expected: ys,
                    operator: xa.name,
                    message: "Missing expected ".concat(Es).concat(Xa),
                    stackStartFn: xa
                  });
                }
                if (ys && !sa($a, ys, Ss, xa))
                  throw $a;
              }
              function ia(xa, $a, ys, Ss) {
                if ($a !== No) {
                  if (typeof ys == "string" && (Ss = ys, ys = void 0), !ys || sa($a, ys)) {
                    var Xa = Ss ? ": ".concat(Ss) : ".", Es = xa.name === "doesNotReject" ? "rejection" : "exception";
                    Ui({
                      actual: $a,
                      expected: ys,
                      operator: xa.name,
                      message: "Got unwanted ".concat(Es).concat(Xa, `
`) + 'Actual message: "'.concat($a && $a.message, '"'),
                      stackStartFn: xa
                    });
                  }
                  throw $a;
                }
              }
              Vo.throws = function xa($a) {
                for (var ys = arguments.length, Ss = new Array(ys > 1 ? ys - 1 : 0), Xa = 1; Xa < ys; Xa++)
                  Ss[Xa - 1] = arguments[Xa];
                ga.apply(void 0, [xa, Ko($a)].concat(Ss));
              }, Vo.rejects = function xa($a) {
                for (var ys = arguments.length, Ss = new Array(ys > 1 ? ys - 1 : 0), Xa = 1; Xa < ys; Xa++)
                  Ss[Xa - 1] = arguments[Xa];
                return pa($a).then(function(Es) {
                  return ga.apply(void 0, [xa, Es].concat(Ss));
                });
              }, Vo.doesNotThrow = function xa($a) {
                for (var ys = arguments.length, Ss = new Array(ys > 1 ? ys - 1 : 0), Xa = 1; Xa < ys; Xa++)
                  Ss[Xa - 1] = arguments[Xa];
                ia.apply(void 0, [xa, Ko($a)].concat(Ss));
              }, Vo.doesNotReject = function xa($a) {
                for (var ys = arguments.length, Ss = new Array(ys > 1 ? ys - 1 : 0), Xa = 1; Xa < ys; Xa++)
                  Ss[Xa - 1] = arguments[Xa];
                return pa($a).then(function(Es) {
                  return ia.apply(void 0, [xa, Es].concat(Ss));
                });
              }, Vo.ifError = function xa($a) {
                if ($a != null) {
                  var ys = "ifError got unwanted exception: ";
                  si($a) === "object" && typeof $a.message == "string" ? $a.message.length === 0 && $a.constructor ? ys += $a.constructor.name : ys += $a.message : ys += Di($a);
                  var Ss = new $i({
                    actual: $a,
                    expected: null,
                    operator: "ifError",
                    message: ys,
                    stackStartFn: xa
                  }), Xa = $a.stack;
                  if (typeof Xa == "string") {
                    var Es = Xa.split(`
`);
                    Es.shift();
                    for (var Rs = Ss.stack.split(`
`), La = 0; La < Es.length; La++) {
                      var Ja = Rs.indexOf(Es[La]);
                      if (Ja !== -1) {
                        Rs = Rs.slice(0, Ja);
                        break;
                      }
                    }
                    Ss.stack = "".concat(Rs.join(`
`), `
`).concat(Es.join(`
`));
                  }
                  throw Ss;
                }
              };
              function ra(xa, $a, ys, Ss, Xa) {
                if (!io($a))
                  throw new vi("regexp", "RegExp", $a);
                var Es = Xa === "match";
                if (typeof xa != "string" || _o($a, xa) !== Es) {
                  if (ys instanceof Error)
                    throw ys;
                  var Rs = !ys;
                  ys = ys || (typeof xa != "string" ? 'The "string" argument must be of type string. Received type ' + "".concat(si(xa), " (").concat(Di(xa), ")") : (Es ? "The input did not match the regular expression " : "The input was expected to not match the regular expression ") + "".concat(Di($a), `. Input:

`).concat(Di(xa), `
`));
                  var La = new $i({
                    actual: xa,
                    expected: $a,
                    message: ys,
                    operator: Xa,
                    stackStartFn: Ss
                  });
                  throw La.generatedMessage = Rs, La;
                }
              }
              Vo.match = function xa($a, ys, Ss) {
                ra($a, ys, Ss, xa, "match");
              }, Vo.doesNotMatch = function xa($a, ys, Ss) {
                ra($a, ys, Ss, xa, "doesNotMatch");
              };
              function qo() {
                for (var xa = arguments.length, $a = new Array(xa), ys = 0; ys < xa; ys++)
                  $a[ys] = arguments[ys];
                Wi.apply(void 0, [qo, $a.length].concat($a));
              }
              Vo.strict = xo(qo, Vo, {
                equal: Vo.strictEqual,
                deepEqual: Vo.deepStrictEqual,
                notEqual: Vo.notStrictEqual,
                notDeepEqual: Vo.notDeepStrictEqual
              }), Vo.strict.strict = Vo.strict;
            })
          ),
          /***/
          "./node_modules/assert/build/internal/assert/assertion_error.js": (
            /*!**********************************************************************!*\
              !*** ./node_modules/assert/build/internal/assert/assertion_error.js ***!
              \**********************************************************************/
            /***/
            ((ai, li, oi) => {
              function si(pa, ga) {
                var ia = Object.keys(pa);
                if (Object.getOwnPropertySymbols) {
                  var ra = Object.getOwnPropertySymbols(pa);
                  ga && (ra = ra.filter(function(qo) {
                    return Object.getOwnPropertyDescriptor(pa, qo).enumerable;
                  })), ia.push.apply(ia, ra);
                }
                return ia;
              }
              function di(pa) {
                for (var ga = 1; ga < arguments.length; ga++) {
                  var ia = arguments[ga] != null ? arguments[ga] : {};
                  ga % 2 ? si(Object(ia), !0).forEach(function(ra) {
                    fi(pa, ra, ia[ra]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(pa, Object.getOwnPropertyDescriptors(ia)) : si(Object(ia)).forEach(function(ra) {
                    Object.defineProperty(pa, ra, Object.getOwnPropertyDescriptor(ia, ra));
                  });
                }
                return pa;
              }
              function fi(pa, ga, ia) {
                return ga = vi(ga), ga in pa ? Object.defineProperty(pa, ga, { value: ia, enumerable: !0, configurable: !0, writable: !0 }) : pa[ga] = ia, pa;
              }
              function gi(pa, ga) {
                if (!(pa instanceof ga))
                  throw new TypeError("Cannot call a class as a function");
              }
              function mi(pa, ga) {
                for (var ia = 0; ia < ga.length; ia++) {
                  var ra = ga[ia];
                  ra.enumerable = ra.enumerable || !1, ra.configurable = !0, "value" in ra && (ra.writable = !0), Object.defineProperty(pa, vi(ra.key), ra);
                }
              }
              function Ti(pa, ga, ia) {
                return ga && mi(pa.prototype, ga), Object.defineProperty(pa, "prototype", { writable: !1 }), pa;
              }
              function vi(pa) {
                var ga = xi(pa, "string");
                return _o(ga) === "symbol" ? ga : String(ga);
              }
              function xi(pa, ga) {
                if (_o(pa) !== "object" || pa === null) return pa;
                var ia = pa[Symbol.toPrimitive];
                if (ia !== void 0) {
                  var ra = ia.call(pa, ga);
                  if (_o(ra) !== "object") return ra;
                  throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(pa);
              }
              function Si(pa, ga) {
                if (typeof ga != "function" && ga !== null)
                  throw new TypeError("Super expression must either be null or a function");
                pa.prototype = Object.create(ga && ga.prototype, { constructor: { value: pa, writable: !0, configurable: !0 } }), Object.defineProperty(pa, "prototype", { writable: !1 }), ga && xo(pa, ga);
              }
              function Pi(pa) {
                var ga = Oo();
                return function() {
                  var ra = fo(pa), qo;
                  if (ga) {
                    var xa = fo(this).constructor;
                    qo = Reflect.construct(ra, arguments, xa);
                  } else
                    qo = ra.apply(this, arguments);
                  return $i(this, qo);
                };
              }
              function $i(pa, ga) {
                if (ga && (_o(ga) === "object" || typeof ga == "function"))
                  return ga;
                if (ga !== void 0)
                  throw new TypeError("Derived constructors may only return object or undefined");
                return Oi(pa);
              }
              function Oi(pa) {
                if (pa === void 0)
                  throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return pa;
              }
              function Di(pa) {
                var ga = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
                return Di = function(ra) {
                  if (ra === null || !io(ra)) return ra;
                  if (typeof ra != "function")
                    throw new TypeError("Super expression must either be null or a function");
                  if (typeof ga < "u") {
                    if (ga.has(ra)) return ga.get(ra);
                    ga.set(ra, qo);
                  }
                  function qo() {
                    return Mi(ra, arguments, fo(this).constructor);
                  }
                  return qo.prototype = Object.create(ra.prototype, { constructor: { value: qo, enumerable: !1, writable: !0, configurable: !0 } }), xo(qo, ra);
                }, Di(pa);
              }
              function Mi(pa, ga, ia) {
                return Oo() ? Mi = Reflect.construct.bind() : Mi = function(qo, xa, $a) {
                  var ys = [null];
                  ys.push.apply(ys, xa);
                  var Ss = Function.bind.apply(qo, ys), Xa = new Ss();
                  return $a && xo(Xa, $a.prototype), Xa;
                }, Mi.apply(null, arguments);
              }
              function Oo() {
                if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
                if (typeof Proxy == "function") return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                  })), !0;
                } catch {
                  return !1;
                }
              }
              function io(pa) {
                return Function.toString.call(pa).indexOf("[native code]") !== -1;
              }
              function xo(pa, ga) {
                return xo = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(ra, qo) {
                  return ra.__proto__ = qo, ra;
                }, xo(pa, ga);
              }
              function fo(pa) {
                return fo = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(ia) {
                  return ia.__proto__ || Object.getPrototypeOf(ia);
                }, fo(pa);
              }
              function _o(pa) {
                "@babel/helpers - typeof";
                return _o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ga) {
                  return typeof ga;
                } : function(ga) {
                  return ga && typeof Symbol == "function" && ga.constructor === Symbol && ga !== Symbol.prototype ? "symbol" : typeof ga;
                }, _o(pa);
              }
              var Li = oi(
                /*! util/ */
                "./node_modules/util/util.js"
              ), Co = Li.inspect, Ni = oi(
                /*! ../errors */
                "./node_modules/assert/build/internal/errors.js"
              ), Yi = Ni.codes.ERR_INVALID_ARG_TYPE;
              function Vo(pa, ga, ia) {
                return (ia === void 0 || ia > pa.length) && (ia = pa.length), pa.substring(ia - ga.length, ia) === ga;
              }
              function No(pa, ga) {
                if (ga = Math.floor(ga), pa.length == 0 || ga == 0) return "";
                var ia = pa.length * ga;
                for (ga = Math.floor(Math.log(ga) / Math.log(2)); ga; )
                  pa += pa, ga--;
                return pa += pa.substring(0, ia - pa.length), pa;
              }
              var Ui = "", jo = "", Wi = "", ji = "", Hi = {
                deepStrictEqual: "Expected values to be strictly deep-equal:",
                strictEqual: "Expected values to be strictly equal:",
                strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
                deepEqual: "Expected values to be loosely deep-equal:",
                equal: "Expected values to be loosely equal:",
                notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
                notStrictEqual: 'Expected "actual" to be strictly unequal to:',
                notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
                notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
                notEqual: 'Expected "actual" to be loosely unequal to:',
                notIdentical: "Values identical but not reference-equal:"
              }, zo = 10;
              function Lo(pa) {
                var ga = Object.keys(pa), ia = Object.create(Object.getPrototypeOf(pa));
                return ga.forEach(function(ra) {
                  ia[ra] = pa[ra];
                }), Object.defineProperty(ia, "message", {
                  value: pa.message
                }), ia;
              }
              function sa(pa) {
                return Co(pa, {
                  compact: !1,
                  customInspect: !1,
                  depth: 1e3,
                  maxArrayLength: 1 / 0,
                  // Assert compares only enumerable properties (with a few exceptions).
                  showHidden: !1,
                  // Having a long line as error is better than wrapping the line for
                  // comparison for now.
                  // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
                  // have meta information about the inspected properties (i.e., know where
                  // in what line the property starts and ends).
                  breakLength: 1 / 0,
                  // Assert does not detect proxies currently.
                  showProxy: !1,
                  sorted: !0,
                  // Inspect getters as we also check them when comparing entries.
                  getters: !0
                });
              }
              function Ko(pa, ga, ia) {
                var ra = "", qo = "", xa = 0, $a = "", ys = !1, Ss = sa(pa), Xa = Ss.split(`
`), Es = sa(ga).split(`
`), Rs = 0, La = "";
                if (ia === "strictEqual" && _o(pa) === "object" && _o(ga) === "object" && pa !== null && ga !== null && (ia = "strictEqualObject"), Xa.length === 1 && Es.length === 1 && Xa[0] !== Es[0]) {
                  var Ja = Xa[0].length + Es[0].length;
                  if (Ja <= zo) {
                    if ((_o(pa) !== "object" || pa === null) && (_o(ga) !== "object" || ga === null) && (pa !== 0 || ga !== 0))
                      return "".concat(Hi[ia], `

`) + "".concat(Xa[0], " !== ").concat(Es[0], `
`);
                  } else if (ia !== "strictEqualObject") {
                    var ja = process.stderr && process.stderr.isTTY ? process.stderr.columns : 80;
                    if (Ja < ja) {
                      for (; Xa[0][Rs] === Es[0][Rs]; )
                        Rs++;
                      Rs > 2 && (La = `
  `.concat(No(" ", Rs), "^"), Rs = 0);
                    }
                  }
                }
                for (var Ta = Xa[Xa.length - 1], rs = Es[Es.length - 1]; Ta === rs && (Rs++ < 2 ? $a = `
  `.concat(Ta).concat($a) : ra = Ta, Xa.pop(), Es.pop(), !(Xa.length === 0 || Es.length === 0)); )
                  Ta = Xa[Xa.length - 1], rs = Es[Es.length - 1];
                var Qa = Math.max(Xa.length, Es.length);
                if (Qa === 0) {
                  var Cs = Ss.split(`
`);
                  if (Cs.length > 30)
                    for (Cs[26] = "".concat(Ui, "...").concat(ji); Cs.length > 27; )
                      Cs.pop();
                  return "".concat(Hi.notIdentical, `

`).concat(Cs.join(`
`), `
`);
                }
                Rs > 3 && ($a = `
`.concat(Ui, "...").concat(ji).concat($a), ys = !0), ra !== "" && ($a = `
  `.concat(ra).concat($a), ra = "");
                var _a = 0, _s = Hi[ia] + `
`.concat(jo, "+ actual").concat(ji, " ").concat(Wi, "- expected").concat(ji), el = " ".concat(Ui, "...").concat(ji, " Lines skipped");
                for (Rs = 0; Rs < Qa; Rs++) {
                  var Ps = Rs - xa;
                  if (Xa.length < Rs + 1)
                    Ps > 1 && Rs > 2 && (Ps > 4 ? (qo += `
`.concat(Ui, "...").concat(ji), ys = !0) : Ps > 3 && (qo += `
  `.concat(Es[Rs - 2]), _a++), qo += `
  `.concat(Es[Rs - 1]), _a++), xa = Rs, ra += `
`.concat(Wi, "-").concat(ji, " ").concat(Es[Rs]), _a++;
                  else if (Es.length < Rs + 1)
                    Ps > 1 && Rs > 2 && (Ps > 4 ? (qo += `
`.concat(Ui, "...").concat(ji), ys = !0) : Ps > 3 && (qo += `
  `.concat(Xa[Rs - 2]), _a++), qo += `
  `.concat(Xa[Rs - 1]), _a++), xa = Rs, qo += `
`.concat(jo, "+").concat(ji, " ").concat(Xa[Rs]), _a++;
                  else {
                    var nl = Es[Rs], Vs = Xa[Rs], es = Vs !== nl && (!Vo(Vs, ",") || Vs.slice(0, -1) !== nl);
                    es && Vo(nl, ",") && nl.slice(0, -1) === Vs && (es = !1, Vs += ","), es ? (Ps > 1 && Rs > 2 && (Ps > 4 ? (qo += `
`.concat(Ui, "...").concat(ji), ys = !0) : Ps > 3 && (qo += `
  `.concat(Xa[Rs - 2]), _a++), qo += `
  `.concat(Xa[Rs - 1]), _a++), xa = Rs, qo += `
`.concat(jo, "+").concat(ji, " ").concat(Vs), ra += `
`.concat(Wi, "-").concat(ji, " ").concat(nl), _a += 2) : (qo += ra, ra = "", (Ps === 1 || Rs === 0) && (qo += `
  `.concat(Vs), _a++));
                  }
                  if (_a > 20 && Rs < Qa - 2)
                    return "".concat(_s).concat(el, `
`).concat(qo, `
`).concat(Ui, "...").concat(ji).concat(ra, `
`) + "".concat(Ui, "...").concat(ji);
                }
                return "".concat(_s).concat(ys ? el : "", `
`).concat(qo).concat(ra).concat($a).concat(La);
              }
              var ca = /* @__PURE__ */ (function(pa, ga) {
                Si(ra, pa);
                var ia = Pi(ra);
                function ra(qo) {
                  var xa;
                  if (gi(this, ra), _o(qo) !== "object" || qo === null)
                    throw new Yi("options", "Object", qo);
                  var $a = qo.message, ys = qo.operator, Ss = qo.stackStartFn, Xa = qo.actual, Es = qo.expected, Rs = Error.stackTraceLimit;
                  if (Error.stackTraceLimit = 0, $a != null)
                    xa = ia.call(this, String($a));
                  else if (process.stderr && process.stderr.isTTY && (process.stderr && process.stderr.getColorDepth && process.stderr.getColorDepth() !== 1 ? (Ui = "\x1B[34m", jo = "\x1B[32m", ji = "\x1B[39m", Wi = "\x1B[31m") : (Ui = "", jo = "", ji = "", Wi = "")), _o(Xa) === "object" && Xa !== null && _o(Es) === "object" && Es !== null && "stack" in Xa && Xa instanceof Error && "stack" in Es && Es instanceof Error && (Xa = Lo(Xa), Es = Lo(Es)), ys === "deepStrictEqual" || ys === "strictEqual")
                    xa = ia.call(this, Ko(Xa, Es, ys));
                  else if (ys === "notDeepStrictEqual" || ys === "notStrictEqual") {
                    var La = Hi[ys], Ja = sa(Xa).split(`
`);
                    if (ys === "notStrictEqual" && _o(Xa) === "object" && Xa !== null && (La = Hi.notStrictEqualObject), Ja.length > 30)
                      for (Ja[26] = "".concat(Ui, "...").concat(ji); Ja.length > 27; )
                        Ja.pop();
                    Ja.length === 1 ? xa = ia.call(this, "".concat(La, " ").concat(Ja[0])) : xa = ia.call(this, "".concat(La, `

`).concat(Ja.join(`
`), `
`));
                  } else {
                    var ja = sa(Xa), Ta = "", rs = Hi[ys];
                    ys === "notDeepEqual" || ys === "notEqual" ? (ja = "".concat(Hi[ys], `

`).concat(ja), ja.length > 1024 && (ja = "".concat(ja.slice(0, 1021), "..."))) : (Ta = "".concat(sa(Es)), ja.length > 512 && (ja = "".concat(ja.slice(0, 509), "...")), Ta.length > 512 && (Ta = "".concat(Ta.slice(0, 509), "...")), ys === "deepEqual" || ys === "equal" ? ja = "".concat(rs, `

`).concat(ja, `

should equal

`) : Ta = " ".concat(ys, " ").concat(Ta)), xa = ia.call(this, "".concat(ja).concat(Ta));
                  }
                  return Error.stackTraceLimit = Rs, xa.generatedMessage = !$a, Object.defineProperty(Oi(xa), "name", {
                    value: "AssertionError [ERR_ASSERTION]",
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                  }), xa.code = "ERR_ASSERTION", xa.actual = Xa, xa.expected = Es, xa.operator = ys, Error.captureStackTrace && Error.captureStackTrace(Oi(xa), Ss), xa.stack, xa.name = "AssertionError", $i(xa);
                }
                return Ti(ra, [{
                  key: "toString",
                  value: function() {
                    return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
                  }
                }, {
                  key: ga,
                  value: function(xa, $a) {
                    return Co(this, di(di({}, $a), {}, {
                      customInspect: !1,
                      depth: 0
                    }));
                  }
                }]), ra;
              })(/* @__PURE__ */ Di(Error), Co.custom);
              ai.exports = ca;
            })
          ),
          /***/
          "./node_modules/assert/build/internal/errors.js": (
            /*!******************************************************!*\
              !*** ./node_modules/assert/build/internal/errors.js ***!
              \******************************************************/
            /***/
            ((ai, li, oi) => {
              function si(_o) {
                "@babel/helpers - typeof";
                return si = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Li) {
                  return typeof Li;
                } : function(Li) {
                  return Li && typeof Symbol == "function" && Li.constructor === Symbol && Li !== Symbol.prototype ? "symbol" : typeof Li;
                }, si(_o);
              }
              function di(_o, Li, Co) {
                return Object.defineProperty(_o, "prototype", { writable: !1 }), _o;
              }
              function fi(_o, Li) {
                if (!(_o instanceof Li))
                  throw new TypeError("Cannot call a class as a function");
              }
              function gi(_o, Li) {
                if (typeof Li != "function" && Li !== null)
                  throw new TypeError("Super expression must either be null or a function");
                _o.prototype = Object.create(Li && Li.prototype, { constructor: { value: _o, writable: !0, configurable: !0 } }), Object.defineProperty(_o, "prototype", { writable: !1 }), Li && mi(_o, Li);
              }
              function mi(_o, Li) {
                return mi = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(Ni, Yi) {
                  return Ni.__proto__ = Yi, Ni;
                }, mi(_o, Li);
              }
              function Ti(_o) {
                var Li = Si();
                return function() {
                  var Ni = Pi(_o), Yi;
                  if (Li) {
                    var Vo = Pi(this).constructor;
                    Yi = Reflect.construct(Ni, arguments, Vo);
                  } else
                    Yi = Ni.apply(this, arguments);
                  return vi(this, Yi);
                };
              }
              function vi(_o, Li) {
                if (Li && (si(Li) === "object" || typeof Li == "function"))
                  return Li;
                if (Li !== void 0)
                  throw new TypeError("Derived constructors may only return object or undefined");
                return xi(_o);
              }
              function xi(_o) {
                if (_o === void 0)
                  throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return _o;
              }
              function Si() {
                if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
                if (typeof Proxy == "function") return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                  })), !0;
                } catch {
                  return !1;
                }
              }
              function Pi(_o) {
                return Pi = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(Co) {
                  return Co.__proto__ || Object.getPrototypeOf(Co);
                }, Pi(_o);
              }
              var $i = {}, Oi, Di;
              function Mi(_o, Li, Co) {
                Co || (Co = Error);
                function Ni(Vo, No, Ui) {
                  return typeof Li == "string" ? Li : Li(Vo, No, Ui);
                }
                var Yi = /* @__PURE__ */ (function(Vo) {
                  gi(Ui, Vo);
                  var No = Ti(Ui);
                  function Ui(jo, Wi, ji) {
                    var Hi;
                    return fi(this, Ui), Hi = No.call(this, Ni(jo, Wi, ji)), Hi.code = _o, Hi;
                  }
                  return di(Ui);
                })(Co);
                $i[_o] = Yi;
              }
              function Oo(_o, Li) {
                if (Array.isArray(_o)) {
                  var Co = _o.length;
                  return _o = _o.map(function(Ni) {
                    return String(Ni);
                  }), Co > 2 ? "one of ".concat(Li, " ").concat(_o.slice(0, Co - 1).join(", "), ", or ") + _o[Co - 1] : Co === 2 ? "one of ".concat(Li, " ").concat(_o[0], " or ").concat(_o[1]) : "of ".concat(Li, " ").concat(_o[0]);
                } else
                  return "of ".concat(Li, " ").concat(String(_o));
              }
              function io(_o, Li, Co) {
                return _o.substr(0, Li.length) === Li;
              }
              function xo(_o, Li, Co) {
                return (Co === void 0 || Co > _o.length) && (Co = _o.length), _o.substring(Co - Li.length, Co) === Li;
              }
              function fo(_o, Li, Co) {
                return typeof Co != "number" && (Co = 0), Co + Li.length > _o.length ? !1 : _o.indexOf(Li, Co) !== -1;
              }
              Mi("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError), Mi("ERR_INVALID_ARG_TYPE", function(_o, Li, Co) {
                Oi === void 0 && (Oi = oi(
                  /*! ../assert */
                  "./node_modules/assert/build/assert.js"
                )), Oi(typeof _o == "string", "'name' must be a string");
                var Ni;
                typeof Li == "string" && io(Li, "not ") ? (Ni = "must not be", Li = Li.replace(/^not /, "")) : Ni = "must be";
                var Yi;
                if (xo(_o, " argument"))
                  Yi = "The ".concat(_o, " ").concat(Ni, " ").concat(Oo(Li, "type"));
                else {
                  var Vo = fo(_o, ".") ? "property" : "argument";
                  Yi = 'The "'.concat(_o, '" ').concat(Vo, " ").concat(Ni, " ").concat(Oo(Li, "type"));
                }
                return Yi += ". Received type ".concat(si(Co)), Yi;
              }, TypeError), Mi("ERR_INVALID_ARG_VALUE", function(_o, Li) {
                var Co = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "is invalid";
                Di === void 0 && (Di = oi(
                  /*! util/ */
                  "./node_modules/util/util.js"
                ));
                var Ni = Di.inspect(Li);
                return Ni.length > 128 && (Ni = "".concat(Ni.slice(0, 128), "...")), "The argument '".concat(_o, "' ").concat(Co, ". Received ").concat(Ni);
              }, TypeError), Mi("ERR_INVALID_RETURN_VALUE", function(_o, Li, Co) {
                var Ni;
                return Co && Co.constructor && Co.constructor.name ? Ni = "instance of ".concat(Co.constructor.name) : Ni = "type ".concat(si(Co)), "Expected ".concat(_o, ' to be returned from the "').concat(Li, '"') + " function but got ".concat(Ni, ".");
              }, TypeError), Mi("ERR_MISSING_ARGS", function() {
                for (var _o = arguments.length, Li = new Array(_o), Co = 0; Co < _o; Co++)
                  Li[Co] = arguments[Co];
                Oi === void 0 && (Oi = oi(
                  /*! ../assert */
                  "./node_modules/assert/build/assert.js"
                )), Oi(Li.length > 0, "At least one arg needs to be specified");
                var Ni = "The ", Yi = Li.length;
                switch (Li = Li.map(function(Vo) {
                  return '"'.concat(Vo, '"');
                }), Yi) {
                  case 1:
                    Ni += "".concat(Li[0], " argument");
                    break;
                  case 2:
                    Ni += "".concat(Li[0], " and ").concat(Li[1], " arguments");
                    break;
                  default:
                    Ni += Li.slice(0, Yi - 1).join(", "), Ni += ", and ".concat(Li[Yi - 1], " arguments");
                    break;
                }
                return "".concat(Ni, " must be specified");
              }, TypeError), ai.exports.codes = $i;
            })
          ),
          /***/
          "./node_modules/assert/build/internal/util/comparisons.js": (
            /*!****************************************************************!*\
              !*** ./node_modules/assert/build/internal/util/comparisons.js ***!
              \****************************************************************/
            /***/
            ((ai, li, oi) => {
              function si(es, Is) {
                return Ti(es) || mi(es, Is) || fi(es, Is) || di();
              }
              function di() {
                throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              function fi(es, Is) {
                if (es) {
                  if (typeof es == "string") return gi(es, Is);
                  var fl = Object.prototype.toString.call(es).slice(8, -1);
                  if (fl === "Object" && es.constructor && (fl = es.constructor.name), fl === "Map" || fl === "Set") return Array.from(es);
                  if (fl === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(fl)) return gi(es, Is);
                }
              }
              function gi(es, Is) {
                (Is == null || Is > es.length) && (Is = es.length);
                for (var fl = 0, sl = new Array(Is); fl < Is; fl++) sl[fl] = es[fl];
                return sl;
              }
              function mi(es, Is) {
                var fl = es == null ? null : typeof Symbol < "u" && es[Symbol.iterator] || es["@@iterator"];
                if (fl != null) {
                  var sl, Il, Vl, Bl, ql = [], xl = !0, Ul = !1;
                  try {
                    if (Vl = (fl = fl.call(es)).next, Is !== 0) for (; !(xl = (sl = Vl.call(fl)).done) && (ql.push(sl.value), ql.length !== Is); xl = !0) ;
                  } catch (Xl) {
                    Ul = !0, Il = Xl;
                  } finally {
                    try {
                      if (!xl && fl.return != null && (Bl = fl.return(), Object(Bl) !== Bl)) return;
                    } finally {
                      if (Ul) throw Il;
                    }
                  }
                  return ql;
                }
              }
              function Ti(es) {
                if (Array.isArray(es)) return es;
              }
              function vi(es) {
                "@babel/helpers - typeof";
                return vi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Is) {
                  return typeof Is;
                } : function(Is) {
                  return Is && typeof Symbol == "function" && Is.constructor === Symbol && Is !== Symbol.prototype ? "symbol" : typeof Is;
                }, vi(es);
              }
              var xi = /a/g.flags !== void 0, Si = function(Is) {
                var fl = [];
                return Is.forEach(function(sl) {
                  return fl.push(sl);
                }), fl;
              }, Pi = function(Is) {
                var fl = [];
                return Is.forEach(function(sl, Il) {
                  return fl.push([Il, sl]);
                }), fl;
              }, $i = Object.is ? Object.is : oi(
                /*! object-is */
                "./node_modules/object-is/index.js"
              ), Oi = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
                return [];
              }, Di = Number.isNaN ? Number.isNaN : oi(
                /*! is-nan */
                "./node_modules/is-nan/index.js"
              );
              function Mi(es) {
                return es.call.bind(es);
              }
              var Oo = Mi(Object.prototype.hasOwnProperty), io = Mi(Object.prototype.propertyIsEnumerable), xo = Mi(Object.prototype.toString), fo = oi(
                /*! util/ */
                "./node_modules/util/util.js"
              ).types, _o = fo.isAnyArrayBuffer, Li = fo.isArrayBufferView, Co = fo.isDate, Ni = fo.isMap, Yi = fo.isRegExp, Vo = fo.isSet, No = fo.isNativeError, Ui = fo.isBoxedPrimitive, jo = fo.isNumberObject, Wi = fo.isStringObject, ji = fo.isBooleanObject, Hi = fo.isBigIntObject, zo = fo.isSymbolObject, Lo = fo.isFloat32Array, sa = fo.isFloat64Array;
              function Ko(es) {
                if (es.length === 0 || es.length > 10) return !0;
                for (var Is = 0; Is < es.length; Is++) {
                  var fl = es.charCodeAt(Is);
                  if (fl < 48 || fl > 57) return !0;
                }
                return es.length === 10 && es >= Math.pow(2, 32);
              }
              function ca(es) {
                return Object.keys(es).filter(Ko).concat(Oi(es).filter(Object.prototype.propertyIsEnumerable.bind(es)));
              }
              /*!
               * The buffer module from node.js, for the browser.
               *
               * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
               * @license  MIT
               */
              function pa(es, Is) {
                if (es === Is)
                  return 0;
                for (var fl = es.length, sl = Is.length, Il = 0, Vl = Math.min(fl, sl); Il < Vl; ++Il)
                  if (es[Il] !== Is[Il]) {
                    fl = es[Il], sl = Is[Il];
                    break;
                  }
                return fl < sl ? -1 : sl < fl ? 1 : 0;
              }
              var ga = !0, ia = !1, ra = 0, qo = 1, xa = 2, $a = 3;
              function ys(es, Is) {
                return xi ? es.source === Is.source && es.flags === Is.flags : RegExp.prototype.toString.call(es) === RegExp.prototype.toString.call(Is);
              }
              function Ss(es, Is) {
                if (es.byteLength !== Is.byteLength)
                  return !1;
                for (var fl = 0; fl < es.byteLength; fl++)
                  if (es[fl] !== Is[fl])
                    return !1;
                return !0;
              }
              function Xa(es, Is) {
                return es.byteLength !== Is.byteLength ? !1 : pa(new Uint8Array(es.buffer, es.byteOffset, es.byteLength), new Uint8Array(Is.buffer, Is.byteOffset, Is.byteLength)) === 0;
              }
              function Es(es, Is) {
                return es.byteLength === Is.byteLength && pa(new Uint8Array(es), new Uint8Array(Is)) === 0;
              }
              function Rs(es, Is) {
                return jo(es) ? jo(Is) && $i(Number.prototype.valueOf.call(es), Number.prototype.valueOf.call(Is)) : Wi(es) ? Wi(Is) && String.prototype.valueOf.call(es) === String.prototype.valueOf.call(Is) : ji(es) ? ji(Is) && Boolean.prototype.valueOf.call(es) === Boolean.prototype.valueOf.call(Is) : Hi(es) ? Hi(Is) && BigInt.prototype.valueOf.call(es) === BigInt.prototype.valueOf.call(Is) : zo(Is) && Symbol.prototype.valueOf.call(es) === Symbol.prototype.valueOf.call(Is);
              }
              function La(es, Is, fl, sl) {
                if (es === Is)
                  return es !== 0 ? !0 : fl ? $i(es, Is) : !0;
                if (fl) {
                  if (vi(es) !== "object")
                    return typeof es == "number" && Di(es) && Di(Is);
                  if (vi(Is) !== "object" || es === null || Is === null || Object.getPrototypeOf(es) !== Object.getPrototypeOf(Is))
                    return !1;
                } else {
                  if (es === null || vi(es) !== "object")
                    return Is === null || vi(Is) !== "object" ? es == Is : !1;
                  if (Is === null || vi(Is) !== "object")
                    return !1;
                }
                var Il = xo(es), Vl = xo(Is);
                if (Il !== Vl)
                  return !1;
                if (Array.isArray(es)) {
                  if (es.length !== Is.length)
                    return !1;
                  var Bl = ca(es), ql = ca(Is);
                  return Bl.length !== ql.length ? !1 : ja(es, Is, fl, sl, qo, Bl);
                }
                if (Il === "[object Object]" && (!Ni(es) && Ni(Is) || !Vo(es) && Vo(Is)))
                  return !1;
                if (Co(es)) {
                  if (!Co(Is) || Date.prototype.getTime.call(es) !== Date.prototype.getTime.call(Is))
                    return !1;
                } else if (Yi(es)) {
                  if (!Yi(Is) || !ys(es, Is))
                    return !1;
                } else if (No(es) || es instanceof Error) {
                  if (es.message !== Is.message || es.name !== Is.name)
                    return !1;
                } else if (Li(es)) {
                  if (!fl && (Lo(es) || sa(es))) {
                    if (!Ss(es, Is))
                      return !1;
                  } else if (!Xa(es, Is))
                    return !1;
                  var xl = ca(es), Ul = ca(Is);
                  return xl.length !== Ul.length ? !1 : ja(es, Is, fl, sl, ra, xl);
                } else {
                  if (Vo(es))
                    return !Vo(Is) || es.size !== Is.size ? !1 : ja(es, Is, fl, sl, xa);
                  if (Ni(es))
                    return !Ni(Is) || es.size !== Is.size ? !1 : ja(es, Is, fl, sl, $a);
                  if (_o(es)) {
                    if (!Es(es, Is))
                      return !1;
                  } else if (Ui(es) && !Rs(es, Is))
                    return !1;
                }
                return ja(es, Is, fl, sl, ra);
              }
              function Ja(es, Is) {
                return Is.filter(function(fl) {
                  return io(es, fl);
                });
              }
              function ja(es, Is, fl, sl, Il, Vl) {
                if (arguments.length === 5) {
                  Vl = Object.keys(es);
                  var Bl = Object.keys(Is);
                  if (Vl.length !== Bl.length)
                    return !1;
                }
                for (var ql = 0; ql < Vl.length; ql++)
                  if (!Oo(Is, Vl[ql]))
                    return !1;
                if (fl && arguments.length === 5) {
                  var xl = Oi(es);
                  if (xl.length !== 0) {
                    var Ul = 0;
                    for (ql = 0; ql < xl.length; ql++) {
                      var Xl = xl[ql];
                      if (io(es, Xl)) {
                        if (!io(Is, Xl))
                          return !1;
                        Vl.push(Xl), Ul++;
                      } else if (io(Is, Xl))
                        return !1;
                    }
                    var hu = Oi(Is);
                    if (xl.length !== hu.length && Ja(Is, hu).length !== Ul)
                      return !1;
                  } else {
                    var Tu = Oi(Is);
                    if (Tu.length !== 0 && Ja(Is, Tu).length !== 0)
                      return !1;
                  }
                }
                if (Vl.length === 0 && (Il === ra || Il === qo && es.length === 0 || es.size === 0))
                  return !0;
                if (sl === void 0)
                  sl = {
                    val1: /* @__PURE__ */ new Map(),
                    val2: /* @__PURE__ */ new Map(),
                    position: 0
                  };
                else {
                  var Ku = sl.val1.get(es);
                  if (Ku !== void 0) {
                    var Wl = sl.val2.get(Is);
                    if (Wl !== void 0)
                      return Ku === Wl;
                  }
                  sl.position++;
                }
                sl.val1.set(es, sl.position), sl.val2.set(Is, sl.position);
                var uu = Ps(es, Is, fl, Vl, sl, Il);
                return sl.val1.delete(es), sl.val2.delete(Is), uu;
              }
              function Ta(es, Is, fl, sl) {
                for (var Il = Si(es), Vl = 0; Vl < Il.length; Vl++) {
                  var Bl = Il[Vl];
                  if (La(Is, Bl, fl, sl))
                    return es.delete(Bl), !0;
                }
                return !1;
              }
              function rs(es) {
                switch (vi(es)) {
                  case "undefined":
                    return null;
                  case "object":
                    return;
                  case "symbol":
                    return !1;
                  case "string":
                    es = +es;
                  // Loose equal entries exist only if the string is possible to convert to
                  // a regular number and not NaN.
                  // Fall through
                  case "number":
                    if (Di(es))
                      return !1;
                }
                return !0;
              }
              function Qa(es, Is, fl) {
                var sl = rs(fl);
                return sl ?? (Is.has(sl) && !es.has(sl));
              }
              function Cs(es, Is, fl, sl, Il) {
                var Vl = rs(fl);
                if (Vl != null)
                  return Vl;
                var Bl = Is.get(Vl);
                return Bl === void 0 && !Is.has(Vl) || !La(sl, Bl, !1, Il) ? !1 : !es.has(Vl) && La(sl, Bl, !1, Il);
              }
              function _a(es, Is, fl, sl) {
                for (var Il = null, Vl = Si(es), Bl = 0; Bl < Vl.length; Bl++) {
                  var ql = Vl[Bl];
                  if (vi(ql) === "object" && ql !== null)
                    Il === null && (Il = /* @__PURE__ */ new Set()), Il.add(ql);
                  else if (!Is.has(ql)) {
                    if (fl || !Qa(es, Is, ql))
                      return !1;
                    Il === null && (Il = /* @__PURE__ */ new Set()), Il.add(ql);
                  }
                }
                if (Il !== null) {
                  for (var xl = Si(Is), Ul = 0; Ul < xl.length; Ul++) {
                    var Xl = xl[Ul];
                    if (vi(Xl) === "object" && Xl !== null) {
                      if (!Ta(Il, Xl, fl, sl)) return !1;
                    } else if (!fl && !es.has(Xl) && !Ta(Il, Xl, fl, sl))
                      return !1;
                  }
                  return Il.size === 0;
                }
                return !0;
              }
              function _s(es, Is, fl, sl, Il, Vl) {
                for (var Bl = Si(es), ql = 0; ql < Bl.length; ql++) {
                  var xl = Bl[ql];
                  if (La(fl, xl, Il, Vl) && La(sl, Is.get(xl), Il, Vl))
                    return es.delete(xl), !0;
                }
                return !1;
              }
              function el(es, Is, fl, sl) {
                for (var Il = null, Vl = Pi(es), Bl = 0; Bl < Vl.length; Bl++) {
                  var ql = si(Vl[Bl], 2), xl = ql[0], Ul = ql[1];
                  if (vi(xl) === "object" && xl !== null)
                    Il === null && (Il = /* @__PURE__ */ new Set()), Il.add(xl);
                  else {
                    var Xl = Is.get(xl);
                    if (Xl === void 0 && !Is.has(xl) || !La(Ul, Xl, fl, sl)) {
                      if (fl || !Cs(es, Is, xl, Ul, sl)) return !1;
                      Il === null && (Il = /* @__PURE__ */ new Set()), Il.add(xl);
                    }
                  }
                }
                if (Il !== null) {
                  for (var hu = Pi(Is), Tu = 0; Tu < hu.length; Tu++) {
                    var Ku = si(hu[Tu], 2), Wl = Ku[0], uu = Ku[1];
                    if (vi(Wl) === "object" && Wl !== null) {
                      if (!_s(Il, es, Wl, uu, fl, sl)) return !1;
                    } else if (!fl && (!es.has(Wl) || !La(es.get(Wl), uu, !1, sl)) && !_s(Il, es, Wl, uu, !1, sl))
                      return !1;
                  }
                  return Il.size === 0;
                }
                return !0;
              }
              function Ps(es, Is, fl, sl, Il, Vl) {
                var Bl = 0;
                if (Vl === xa) {
                  if (!_a(es, Is, fl, Il))
                    return !1;
                } else if (Vl === $a) {
                  if (!el(es, Is, fl, Il))
                    return !1;
                } else if (Vl === qo)
                  for (; Bl < es.length; Bl++)
                    if (Oo(es, Bl)) {
                      if (!Oo(Is, Bl) || !La(es[Bl], Is[Bl], fl, Il))
                        return !1;
                    } else {
                      if (Oo(Is, Bl))
                        return !1;
                      for (var ql = Object.keys(es); Bl < ql.length; Bl++) {
                        var xl = ql[Bl];
                        if (!Oo(Is, xl) || !La(es[xl], Is[xl], fl, Il))
                          return !1;
                      }
                      return ql.length === Object.keys(Is).length;
                    }
                for (Bl = 0; Bl < sl.length; Bl++) {
                  var Ul = sl[Bl];
                  if (!La(es[Ul], Is[Ul], fl, Il))
                    return !1;
                }
                return !0;
              }
              function nl(es, Is) {
                return La(es, Is, ia);
              }
              function Vs(es, Is) {
                return La(es, Is, ga);
              }
              ai.exports = {
                isDeepEqual: nl,
                isDeepStrictEqual: Vs
              };
            })
          ),
          /***/
          "./node_modules/debug/src/browser.js": (
            /*!*******************************************!*\
              !*** ./node_modules/debug/src/browser.js ***!
              \*******************************************/
            /***/
            ((ai, li, oi) => {
              function si(Si) {
                "@babel/helpers - typeof";
                return si = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Pi) {
                  return typeof Pi;
                } : function(Pi) {
                  return Pi && typeof Symbol == "function" && Pi.constructor === Symbol && Pi !== Symbol.prototype ? "symbol" : typeof Pi;
                }, si(Si);
              }
              li.log = gi, li.formatArgs = fi, li.save = mi, li.load = Ti, li.useColors = di, li.storage = vi(), li.colors = ["#0000CC", "#0000FF", "#0033CC", "#0033FF", "#0066CC", "#0066FF", "#0099CC", "#0099FF", "#00CC00", "#00CC33", "#00CC66", "#00CC99", "#00CCCC", "#00CCFF", "#3300CC", "#3300FF", "#3333CC", "#3333FF", "#3366CC", "#3366FF", "#3399CC", "#3399FF", "#33CC00", "#33CC33", "#33CC66", "#33CC99", "#33CCCC", "#33CCFF", "#6600CC", "#6600FF", "#6633CC", "#6633FF", "#66CC00", "#66CC33", "#9900CC", "#9900FF", "#9933CC", "#9933FF", "#99CC00", "#99CC33", "#CC0000", "#CC0033", "#CC0066", "#CC0099", "#CC00CC", "#CC00FF", "#CC3300", "#CC3333", "#CC3366", "#CC3399", "#CC33CC", "#CC33FF", "#CC6600", "#CC6633", "#CC9900", "#CC9933", "#CCCC00", "#CCCC33", "#FF0000", "#FF0033", "#FF0066", "#FF0099", "#FF00CC", "#FF00FF", "#FF3300", "#FF3333", "#FF3366", "#FF3399", "#FF33CC", "#FF33FF", "#FF6600", "#FF6633", "#FF9900", "#FF9933", "#FFCC00", "#FFCC33"];
              function di() {
                return typeof window < "u" && window.process && (window.process.type === "renderer" || window.process.__nwjs) ? !0 : typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/) ? !1 : typeof document < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
                typeof window < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
                // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
                typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
                typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
              }
              function fi(Si) {
                if (Si[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + Si[0] + (this.useColors ? "%c " : " ") + "+" + ai.exports.humanize(this.diff), !!this.useColors) {
                  var Pi = "color: " + this.color;
                  Si.splice(1, 0, Pi, "color: inherit");
                  var $i = 0, Oi = 0;
                  Si[0].replace(/%[a-zA-Z%]/g, function(Di) {
                    Di !== "%%" && ($i++, Di === "%c" && (Oi = $i));
                  }), Si.splice(Oi, 0, Pi);
                }
              }
              function gi() {
                var Si;
                return (typeof console > "u" ? "undefined" : si(console)) === "object" && console.log && (Si = console).log.apply(Si, arguments);
              }
              function mi(Si) {
                try {
                  Si ? li.storage.setItem("debug", Si) : li.storage.removeItem("debug");
                } catch {
                }
              }
              function Ti() {
                var Si;
                try {
                  Si = li.storage.getItem("debug");
                } catch {
                }
                return !Si && typeof process < "u" && "env" in process && (Si = {}.DEBUG), Si;
              }
              function vi() {
                try {
                  return localStorage;
                } catch {
                }
              }
              ai.exports = oi(
                /*! ./common */
                "./node_modules/debug/src/common.js"
              )(li);
              var xi = ai.exports.formatters;
              xi.j = function(Si) {
                try {
                  return JSON.stringify(Si);
                } catch (Pi) {
                  return "[UnexpectedJSONParseError]: " + Pi.message;
                }
              };
            })
          ),
          /***/
          "./node_modules/debug/src/common.js": (
            /*!******************************************!*\
              !*** ./node_modules/debug/src/common.js ***!
              \******************************************/
            /***/
            ((ai, li, oi) => {
              function si(xi) {
                return mi(xi) || gi(xi) || fi(xi) || di();
              }
              function di() {
                throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              function fi(xi, Si) {
                if (xi) {
                  if (typeof xi == "string") return Ti(xi, Si);
                  var Pi = {}.toString.call(xi).slice(8, -1);
                  return Pi === "Object" && xi.constructor && (Pi = xi.constructor.name), Pi === "Map" || Pi === "Set" ? Array.from(xi) : Pi === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Pi) ? Ti(xi, Si) : void 0;
                }
              }
              function gi(xi) {
                if (typeof Symbol < "u" && xi[Symbol.iterator] != null || xi["@@iterator"] != null) return Array.from(xi);
              }
              function mi(xi) {
                if (Array.isArray(xi)) return Ti(xi);
              }
              function Ti(xi, Si) {
                (Si == null || Si > xi.length) && (Si = xi.length);
                for (var Pi = 0, $i = Array(Si); Pi < Si; Pi++) $i[Pi] = xi[Pi];
                return $i;
              }
              function vi(xi) {
                Pi.debug = Pi, Pi.default = Pi, Pi.coerce = xo, Pi.disable = Mi, Pi.enable = Di, Pi.enabled = Oo, Pi.humanize = oi(
                  /*! ms */
                  "./node_modules/ms/index.js"
                ), Object.keys(xi).forEach(function(fo) {
                  Pi[fo] = xi[fo];
                }), Pi.instances = [], Pi.names = [], Pi.skips = [], Pi.formatters = {};
                function Si(fo) {
                  for (var _o = 0, Li = 0; Li < fo.length; Li++)
                    _o = (_o << 5) - _o + fo.charCodeAt(Li), _o |= 0;
                  return Pi.colors[Math.abs(_o) % Pi.colors.length];
                }
                Pi.selectColor = Si;
                function Pi(fo) {
                  var _o;
                  function Li() {
                    for (var Co = arguments.length, Ni = new Array(Co), Yi = 0; Yi < Co; Yi++)
                      Ni[Yi] = arguments[Yi];
                    if (Li.enabled) {
                      var Vo = Li, No = Number(/* @__PURE__ */ new Date()), Ui = No - (_o || No);
                      Vo.diff = Ui, Vo.prev = _o, Vo.curr = No, _o = No, Ni[0] = Pi.coerce(Ni[0]), typeof Ni[0] != "string" && Ni.unshift("%O");
                      var jo = 0;
                      Ni[0] = Ni[0].replace(/%([a-zA-Z%])/g, function(ji, Hi) {
                        if (ji === "%%")
                          return ji;
                        jo++;
                        var zo = Pi.formatters[Hi];
                        if (typeof zo == "function") {
                          var Lo = Ni[jo];
                          ji = zo.call(Vo, Lo), Ni.splice(jo, 1), jo--;
                        }
                        return ji;
                      }), Pi.formatArgs.call(Vo, Ni);
                      var Wi = Vo.log || Pi.log;
                      Wi.apply(Vo, Ni);
                    }
                  }
                  return Li.namespace = fo, Li.enabled = Pi.enabled(fo), Li.useColors = Pi.useColors(), Li.color = Si(fo), Li.destroy = $i, Li.extend = Oi, typeof Pi.init == "function" && Pi.init(Li), Pi.instances.push(Li), Li;
                }
                function $i() {
                  var fo = Pi.instances.indexOf(this);
                  return fo !== -1 ? (Pi.instances.splice(fo, 1), !0) : !1;
                }
                function Oi(fo, _o) {
                  var Li = Pi(this.namespace + (typeof _o > "u" ? ":" : _o) + fo);
                  return Li.log = this.log, Li;
                }
                function Di(fo) {
                  Pi.save(fo), Pi.names = [], Pi.skips = [];
                  var _o, Li = (typeof fo == "string" ? fo : "").split(/[\s,]+/), Co = Li.length;
                  for (_o = 0; _o < Co; _o++)
                    Li[_o] && (fo = Li[_o].replace(/\*/g, ".*?"), fo[0] === "-" ? Pi.skips.push(new RegExp("^" + fo.substr(1) + "$")) : Pi.names.push(new RegExp("^" + fo + "$")));
                  for (_o = 0; _o < Pi.instances.length; _o++) {
                    var Ni = Pi.instances[_o];
                    Ni.enabled = Pi.enabled(Ni.namespace);
                  }
                }
                function Mi() {
                  var fo = [].concat(si(Pi.names.map(io)), si(Pi.skips.map(io).map(function(_o) {
                    return "-" + _o;
                  }))).join(",");
                  return Pi.enable(""), fo;
                }
                function Oo(fo) {
                  if (fo[fo.length - 1] === "*")
                    return !0;
                  var _o, Li;
                  for (_o = 0, Li = Pi.skips.length; _o < Li; _o++)
                    if (Pi.skips[_o].test(fo))
                      return !1;
                  for (_o = 0, Li = Pi.names.length; _o < Li; _o++)
                    if (Pi.names[_o].test(fo))
                      return !0;
                  return !1;
                }
                function io(fo) {
                  return fo.toString().substring(2, fo.toString().length - 2).replace(/\.\*\?$/, "*");
                }
                function xo(fo) {
                  return fo instanceof Error ? fo.stack || fo.message : fo;
                }
                return Pi.enable(Pi.load()), Pi;
              }
              ai.exports = vi;
            })
          ),
          /***/
          "./node_modules/proxy-polyfill/src/proxy.js": (
            /*!**************************************************!*\
              !*** ./node_modules/proxy-polyfill/src/proxy.js ***!
              \**************************************************/
            /***/
            ((ai) => {
              function li(oi) {
                "@babel/helpers - typeof";
                return li = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(si) {
                  return typeof si;
                } : function(si) {
                  return si && typeof Symbol == "function" && si.constructor === Symbol && si !== Symbol.prototype ? "symbol" : typeof si;
                }, li(oi);
              }
              ai.exports = function() {
                var si = null, di;
                function fi(gi) {
                  return gi ? li(gi) === "object" || typeof gi == "function" : !1;
                }
                return di = function(mi, Ti) {
                  if (!fi(mi) || !fi(Ti))
                    throw new TypeError("Cannot create proxy with a non-object as target or handler");
                  var vi = function() {
                  };
                  si = function() {
                    mi = null, vi = function(Co) {
                      throw new TypeError("Cannot perform '".concat(Co, "' on a proxy that has been revoked"));
                    };
                  }, setTimeout(function() {
                    si = null;
                  }, 0);
                  var xi = Ti;
                  Ti = {
                    get: null,
                    set: null,
                    apply: null,
                    construct: null
                  };
                  for (var Si in xi) {
                    if (!(Si in Ti))
                      throw new TypeError("Proxy polyfill does not support trap '".concat(Si, "'"));
                    Ti[Si] = xi[Si];
                  }
                  typeof xi == "function" && (Ti.apply = xi.apply.bind(xi));
                  var Pi = this, $i = !1, Oi = !1;
                  typeof mi == "function" ? (Pi = function() {
                    var Li = this && this.constructor === Pi, Co = Array.prototype.slice.call(arguments);
                    if (vi(Li ? "construct" : "apply"), Li && Ti.construct)
                      return Ti.construct.call(this, mi, Co);
                    if (!Li && Ti.apply)
                      return Ti.apply(mi, this, Co);
                    if (Li) {
                      Co.unshift(mi);
                      var Ni = (
                        /** @type {!Function} */
                        mi.bind.apply(mi, Co)
                      );
                      return new Ni();
                    }
                    return mi.apply(this, Co);
                  }, $i = !0) : mi instanceof Array && (Pi = [], Oi = !0);
                  var Di = Ti.get ? function(_o) {
                    return vi("get"), Ti.get(this, _o, Pi);
                  } : function(_o) {
                    return vi("get"), this[_o];
                  }, Mi = Ti.set ? function(_o, Li) {
                    vi("set"), Ti.set(this, _o, Li, Pi);
                  } : function(_o, Li) {
                    vi("set"), this[_o] = Li;
                  }, Oo = Object.getOwnPropertyNames(mi), io = {};
                  Oo.forEach(function(_o) {
                    if (!(($i || Oi) && _o in Pi)) {
                      var Li = Object.getOwnPropertyDescriptor(mi, _o), Co = {
                        enumerable: !!Li.enumerable,
                        get: Di.bind(mi, _o),
                        set: Mi.bind(mi, _o)
                      };
                      Object.defineProperty(Pi, _o, Co), io[_o] = !0;
                    }
                  });
                  var xo = !0;
                  if (Object.setPrototypeOf ? Object.setPrototypeOf(Pi, Object.getPrototypeOf(mi)) : Pi.__proto__ ? Pi.__proto__ = mi.__proto__ : xo = !1, Ti.get || !xo)
                    for (var fo in mi)
                      io[fo] || Object.defineProperty(Pi, fo, {
                        get: Di.bind(mi, fo)
                      });
                  return Object.seal(mi), Object.seal(Pi), Pi;
                }, di.revocable = function(gi, mi) {
                  var Ti = new di(gi, mi);
                  return {
                    proxy: Ti,
                    revoke: si
                  };
                }, di;
              };
            })
          ),
          /***/
          "./src/defaults.js": (
            /*!*************************!*\
              !*** ./src/defaults.js ***!
              \*************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                BLACKLISTED_FEATURES: () => (
                  /* binding */
                  mi
                ),
                /* harmony export */
                CUSTOM_TECH: () => (
                  /* binding */
                  Pi
                ),
                /* harmony export */
                DEFAULT_OPTIONS: () => (
                  /* binding */
                  Si
                ),
                /* harmony export */
                DEFAULT_PLAYER_FEATURES: () => (
                  /* binding */
                  gi
                ),
                /* harmony export */
                DEFAULT_PLAYER_OPTIONS: () => (
                  /* binding */
                  fi
                ),
                /* harmony export */
                DEFAULT_PLAYER_TIMEOUT: () => (
                  /* binding */
                  si
                ),
                /* harmony export */
                DEFAULT_TECH_ORDER: () => (
                  /* binding */
                  $i
                ),
                /* harmony export */
                DEFAULT_VIDEO_ELEMENT_CLASSES: () => (
                  /* binding */
                  Oi
                ),
                /* harmony export */
                DISABLE_OPTIONS: () => (
                  /* binding */
                  Ti
                ),
                /* harmony export */
                MINIMUM_REFERSH_RATE: () => (
                  /* binding */
                  di
                ),
                /* harmony export */
                NOOP: () => (
                  /* binding */
                  vi
                ),
                /* harmony export */
                PROTOCOL_MAPPING: () => (
                  /* binding */
                  xi
                )
                /* harmony export */
              });
              var si = 125 * 1e3, di = 10 * 1e3, fi = {
                autoplay: !0,
                muted: !0,
                playsinline: !0,
                controls: !0,
                preload: "auto",
                flash: {
                  swf: "/assets/video-js-buffer3.swf",
                  flashVars: {
                    rtmpBufferTime: 3
                  }
                }
              }, gi = [
                /**
                 * The Media Loader is the component that decides which playback technology to load when the player is initialized.
                 * @see http://docs.videojs.com/docs/api/loader.html
                 */
                "mediaLoader",
                // required to load videos - blacklisted
                /**
                 * A `ClickableComponent` that handles showing the poster image for the player.
                 * @see video.js/src/js/poster-image.js
                 */
                "posterImage",
                /**
                 * The component for displaying text track cues
                 * Video.js offers a cross-browser implementation of text tracks.
                 * @see http://docs.videojs.com/tutorial-text-tracks.html
                 */
                "textTrackDisplay",
                /**
                 * Loading spinner for waiting events
                 * @see http://docs.videojs.com/docs/api/loading-spinner.html
                 */
                "loadingSpinner",
                /**
                 * Initial play button. Shows before the video has played.
                 * The hiding of the big play button is done via CSS and player states.
                 * @see http://docs.videojs.com/docs/api/big-play-button.html
                 */
                "bigPlayButton",
                /**
                 * Container of main controls
                 * @see http://docs.videojs.com/docs/api/control-bar.html
                 */
                "controlBar",
                /**
                 * Display that an error has occurred making the video unplayable.
                 * @see http://docs.videojs.com/docs/api/error-display.html
                 */
                "errorDisplay",
                /**
                 * Manipulate settings of texttracks
                 * @see http://docs.videojs.com/docs/api/text-track-settings.html
                 */
                "textTrackSettings"
              ], mi = ["mediaLoader"], Ti = {
                get pauseOnClick() {
                  return "pauseOnClick";
                }
              }, vi = function() {
              }, xi = {
                rtmp: "video/rtmp/mp4",
                // RTSP support removed on 09/12/2018 per Karen
                http: "application/x-mpegURL",
                clsp: "video/mp4; codecs='avc1.42E01E'",
                https: "application/x-mpegURL",
                clsps: "video/mp4; codecs='avc1.42E01E'",
                // this is not a protocol, but a tech.
                html5: "application/x-mpegURL"
              }, Si = {
                rtmpRetry: !1,
                rtmpRetryDelay: 500,
                usingSkylineSFS: !0,
                useTLSStreaming: !0
              }, Pi = ["clsp"], $i = ["clsp", "flash", "html5"], Oi = ["video-js"];
            })
          ),
          /***/
          "./src/utils.js": (
            /*!**********************!*\
              !*** ./src/utils.js ***!
              \**********************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                collate: () => (
                  /* binding */
                  fo
                ),
                /* harmony export */
                difference: () => (
                  /* binding */
                  xo
                ),
                /* harmony export */
                log: () => (
                  /* binding */
                  Yi
                ),
                /* harmony export */
                pathParser: () => (
                  /* binding */
                  Ni
                )
                /* harmony export */
              });
              var si = oi(
                /*! debug */
                "./node_modules/debug/src/browser.js"
              ), di = /* @__PURE__ */ oi.n(si), fi = oi(
                /*! assert */
                "./node_modules/assert/build/assert.js"
              ), gi = /* @__PURE__ */ oi.n(fi), mi = oi(
                /*! proxy-polyfill/src/proxy */
                "./node_modules/proxy-polyfill/src/proxy.js"
              ), Ti = /* @__PURE__ */ oi.n(mi);
              function vi(Vo, No) {
                var Ui = typeof Symbol < "u" && Vo[Symbol.iterator] || Vo["@@iterator"];
                if (!Ui) {
                  if (Array.isArray(Vo) || (Ui = Pi(Vo)) || No) {
                    Ui && (Vo = Ui);
                    var jo = 0, Wi = function() {
                    };
                    return { s: Wi, n: function() {
                      return jo >= Vo.length ? { done: !0 } : { done: !1, value: Vo[jo++] };
                    }, e: function(sa) {
                      throw sa;
                    }, f: Wi };
                  }
                  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
                }
                var ji, Hi = !0, zo = !1;
                return { s: function() {
                  Ui = Ui.call(Vo);
                }, n: function() {
                  var sa = Ui.next();
                  return Hi = sa.done, sa;
                }, e: function(sa) {
                  zo = !0, ji = sa;
                }, f: function() {
                  try {
                    Hi || Ui.return == null || Ui.return();
                  } finally {
                    if (zo) throw ji;
                  }
                } };
              }
              function xi(Vo) {
                return Oi(Vo) || $i(Vo) || Pi(Vo) || Si();
              }
              function Si() {
                throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
              }
              function Pi(Vo, No) {
                if (Vo) {
                  if (typeof Vo == "string") return Di(Vo, No);
                  var Ui = {}.toString.call(Vo).slice(8, -1);
                  return Ui === "Object" && Vo.constructor && (Ui = Vo.constructor.name), Ui === "Map" || Ui === "Set" ? Array.from(Vo) : Ui === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Ui) ? Di(Vo, No) : void 0;
                }
              }
              function $i(Vo) {
                if (typeof Symbol < "u" && Vo[Symbol.iterator] != null || Vo["@@iterator"] != null) return Array.from(Vo);
              }
              function Oi(Vo) {
                if (Array.isArray(Vo)) return Di(Vo);
              }
              function Di(Vo, No) {
                (No == null || No > Vo.length) && (No = Vo.length);
                for (var Ui = 0, jo = Array(No); Ui < No; Ui++) jo[Ui] = Vo[Ui];
                return jo;
              }
              function Mi(Vo) {
                "@babel/helpers - typeof";
                return Mi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(No) {
                  return typeof No;
                } : function(No) {
                  return No && typeof Symbol == "function" && No.constructor === Symbol && No !== Symbol.prototype ? "symbol" : typeof No;
                }, Mi(Vo);
              }
              var Oo = di()("skyline:skyline-player:utils"), io = function() {
              };
              function xo() {
                for (var Vo = arguments.length, No = new Array(Vo), Ui = 0; Ui < Vo; Ui++)
                  No[Ui] = arguments[Ui];
                if (No.length < 2)
                  throw new TypeError("difference() requires at least 2 parameters to be passed to it.");
                var jo = fo(No.shift());
                return !Array.isArray(jo) || jo.length === 0 ? [] : No.reduce(function(Wi, ji) {
                  if (Mi(ji) !== "object")
                    return Wi;
                  var Hi = fo(ji);
                  return Wi.length === 0 ? Hi : Wi.filter(function(zo) {
                    return !Hi.includes(zo);
                  });
                }, jo);
              }
              function fo() {
                for (var Vo = arguments.length, No = new Array(Vo), Ui = 0; Ui < Vo; Ui++)
                  No[Ui] = arguments[Ui];
                return No.reduce(function(jo, Wi) {
                  return Mi(Wi) !== "object" ? (jo.push(Wi), jo) : Array.isArray(Wi) ? (jo.push.apply(jo, xi(Wi)), jo) : (console.warn('object passed to toArray() - using keys with "truthy" values to create array'), jo.push.apply(jo, xi(Object.keys(Wi).filter(function(ji) {
                    return !!ji;
                  }))), jo);
                }, []);
              }
              var _o = {
                pathParser: "?."
              }, Li = function(No) {
                return Mi(No) === "object" && !Array.isArray(No);
              }, Co = {
                pathParser: {
                  get: function(No, Ui) {
                    var jo = Ui.split(_o.pathParser);
                    if (jo.length === 1) {
                      var Wi = No[Ui];
                      return Wi;
                    }
                    var ji = jo.pop();
                    if (ji === "")
                      throw TypeError("Blank step found in path.");
                    var Hi = !1;
                    if (ji === "()" && (Hi = !0, ji = jo.pop(), ji === ""))
                      throw TypeError("Blank step found in path.");
                    var zo = No, Lo = vi(jo), sa;
                    try {
                      for (Lo.s(); !(sa = Lo.n()).done; ) {
                        var Ko = sa.value;
                        if (Ko === "")
                          throw TypeError("Blank step found in path.");
                        if (zo[Ko] === void 0)
                          return Hi ? io : void 0;
                        zo = zo[Ko];
                      }
                    } catch (pa) {
                      Lo.e(pa);
                    } finally {
                      Lo.f();
                    }
                    var ca = zo[ji];
                    return Hi ? typeof ca == "function" ? ca.bind(zo) : io : ca;
                  },
                  /**
                   * Inspects the property value passed to the get() method for the
                   * delimiter '?.'. If it finds any, it will iterate through path:
                   * if it finds a property that doesn't exist, the property will be
                   * created.
                   *
                   * The final property will be given the value provided.
                   */
                  set: function(No, Ui, jo) {
                    var Wi = Ui.split(_o.pathParser);
                    if (Wi.length === 1)
                      return No[Ui] = jo, !0;
                    var ji = Wi.pop();
                    if (ji === "")
                      throw TypeError("Blank step found in path.");
                    var Hi = No, zo = vi(Wi), Lo;
                    try {
                      for (zo.s(); !(Lo = zo.n()).done; ) {
                        var sa = Lo.value;
                        if (sa === "")
                          throw TypeError("Blank step found in path.");
                        if (Array.isArray(Hi[sa]) === !1 && (Hi[sa] = {}), !Li(Hi[sa]))
                          return !1;
                        Hi = Hi[sa];
                      }
                    } catch (Ko) {
                      zo.e(Ko);
                    } finally {
                      zo.f();
                    }
                    return Hi[ji] = jo, !0;
                  }
                }
              };
              function Ni(Vo) {
                return gi()(Li(Vo), "Passed paraemter to pathParser must be a plain object"), window.Proxy ? new Proxy(Vo, Co.pathParser) : new (Ti())(Vo, Co.pathParser);
              }
              function Yi(Vo, No) {
                (typeof Vo != "string" || Vo.length === 0) && (Vo = "log");
                var Ui = ["log", "error", "warn"];
                if (!Ui.includes(Vo))
                  throw new Error("console only accepts ".concat(Ui, " methods currently"));
                Oo(No);
              }
              Yi.debug = function(Vo) {
                Yi("log", Vo);
              }, Yi.error = function(Vo) {
                Yi("error", Vo);
              }, Yi.warn = function(Vo) {
                Yi("warn", Vo);
              };
            })
          ),
          /***/
          "./node_modules/call-bind-apply-helpers/actualApply.js": (
            /*!*************************************************************!*\
              !*** ./node_modules/call-bind-apply-helpers/actualApply.js ***!
              \*************************************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! function-bind */
                "./node_modules/function-bind/index.js"
              ), di = oi(
                /*! ./functionApply */
                "./node_modules/call-bind-apply-helpers/functionApply.js"
              ), fi = oi(
                /*! ./functionCall */
                "./node_modules/call-bind-apply-helpers/functionCall.js"
              ), gi = oi(
                /*! ./reflectApply */
                "./node_modules/call-bind-apply-helpers/reflectApply.js"
              );
              ai.exports = gi || si.call(fi, di);
            })
          ),
          /***/
          "./node_modules/call-bind-apply-helpers/applyBind.js": (
            /*!***********************************************************!*\
              !*** ./node_modules/call-bind-apply-helpers/applyBind.js ***!
              \***********************************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! function-bind */
                "./node_modules/function-bind/index.js"
              ), di = oi(
                /*! ./functionApply */
                "./node_modules/call-bind-apply-helpers/functionApply.js"
              ), fi = oi(
                /*! ./actualApply */
                "./node_modules/call-bind-apply-helpers/actualApply.js"
              );
              ai.exports = function() {
                return fi(si, di, arguments);
              };
            })
          ),
          /***/
          "./node_modules/call-bind-apply-helpers/functionApply.js": (
            /*!***************************************************************!*\
              !*** ./node_modules/call-bind-apply-helpers/functionApply.js ***!
              \***************************************************************/
            /***/
            ((ai) => {
              ai.exports = Function.prototype.apply;
            })
          ),
          /***/
          "./node_modules/call-bind-apply-helpers/functionCall.js": (
            /*!**************************************************************!*\
              !*** ./node_modules/call-bind-apply-helpers/functionCall.js ***!
              \**************************************************************/
            /***/
            ((ai) => {
              ai.exports = Function.prototype.call;
            })
          ),
          /***/
          "./node_modules/call-bind-apply-helpers/index.js": (
            /*!*******************************************************!*\
              !*** ./node_modules/call-bind-apply-helpers/index.js ***!
              \*******************************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! function-bind */
                "./node_modules/function-bind/index.js"
              ), di = oi(
                /*! es-errors/type */
                "./node_modules/es-errors/type.js"
              ), fi = oi(
                /*! ./functionCall */
                "./node_modules/call-bind-apply-helpers/functionCall.js"
              ), gi = oi(
                /*! ./actualApply */
                "./node_modules/call-bind-apply-helpers/actualApply.js"
              );
              ai.exports = function(Ti) {
                if (Ti.length < 1 || typeof Ti[0] != "function")
                  throw new di("a function is required");
                return gi(si, fi, Ti);
              };
            })
          ),
          /***/
          "./node_modules/call-bind-apply-helpers/reflectApply.js": (
            /*!**************************************************************!*\
              !*** ./node_modules/call-bind-apply-helpers/reflectApply.js ***!
              \**************************************************************/
            /***/
            ((ai) => {
              ai.exports = typeof Reflect < "u" && Reflect && Reflect.apply;
            })
          ),
          /***/
          "./node_modules/call-bind/callBound.js": (
            /*!*********************************************!*\
              !*** ./node_modules/call-bind/callBound.js ***!
              \*********************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! get-intrinsic */
                "./node_modules/get-intrinsic/index.js"
              ), di = oi(
                /*! ./ */
                "./node_modules/call-bind/index.js"
              ), fi = di(si("String.prototype.indexOf"));
              ai.exports = function(mi, Ti) {
                var vi = si(mi, !!Ti);
                return typeof vi == "function" && fi(mi, ".prototype.") > -1 ? di(vi) : vi;
              };
            })
          ),
          /***/
          "./node_modules/call-bind/index.js": (
            /*!*****************************************!*\
              !*** ./node_modules/call-bind/index.js ***!
              \*****************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! set-function-length */
                "./node_modules/set-function-length/index.js"
              ), di = oi(
                /*! es-define-property */
                "./node_modules/es-define-property/index.js"
              ), fi = oi(
                /*! call-bind-apply-helpers */
                "./node_modules/call-bind-apply-helpers/index.js"
              ), gi = oi(
                /*! call-bind-apply-helpers/applyBind */
                "./node_modules/call-bind-apply-helpers/applyBind.js"
              );
              ai.exports = function(Ti) {
                var vi = fi(arguments), xi = Ti.length - (arguments.length - 1);
                return si(
                  vi,
                  1 + (xi > 0 ? xi : 0),
                  !0
                );
              }, di ? di(ai.exports, "apply", { value: gi }) : ai.exports.apply = gi;
            })
          ),
          /***/
          "./node_modules/call-bound/index.js": (
            /*!******************************************!*\
              !*** ./node_modules/call-bound/index.js ***!
              \******************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! get-intrinsic */
                "./node_modules/get-intrinsic/index.js"
              ), di = oi(
                /*! call-bind-apply-helpers */
                "./node_modules/call-bind-apply-helpers/index.js"
              ), fi = di([si("%String.prototype.indexOf%")]);
              ai.exports = function(mi, Ti) {
                var vi = (
                  /** @type {(this: unknown, ...args: unknown[]) => unknown} */
                  si(mi, !!Ti)
                );
                return typeof vi == "function" && fi(mi, ".prototype.") > -1 ? di(
                  /** @type {const} */
                  [vi]
                ) : vi;
              };
            })
          ),
          /***/
          "./node_modules/define-data-property/index.js": (
            /*!****************************************************!*\
              !*** ./node_modules/define-data-property/index.js ***!
              \****************************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! es-define-property */
                "./node_modules/es-define-property/index.js"
              ), di = oi(
                /*! es-errors/syntax */
                "./node_modules/es-errors/syntax.js"
              ), fi = oi(
                /*! es-errors/type */
                "./node_modules/es-errors/type.js"
              ), gi = oi(
                /*! gopd */
                "./node_modules/gopd/index.js"
              );
              ai.exports = function(Ti, vi, xi) {
                if (!Ti || typeof Ti != "object" && typeof Ti != "function")
                  throw new fi("`obj` must be an object or a function`");
                if (typeof vi != "string" && typeof vi != "symbol")
                  throw new fi("`property` must be a string or a symbol`");
                if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
                  throw new fi("`nonEnumerable`, if provided, must be a boolean or null");
                if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
                  throw new fi("`nonWritable`, if provided, must be a boolean or null");
                if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
                  throw new fi("`nonConfigurable`, if provided, must be a boolean or null");
                if (arguments.length > 6 && typeof arguments[6] != "boolean")
                  throw new fi("`loose`, if provided, must be a boolean");
                var Si = arguments.length > 3 ? arguments[3] : null, Pi = arguments.length > 4 ? arguments[4] : null, $i = arguments.length > 5 ? arguments[5] : null, Oi = arguments.length > 6 ? arguments[6] : !1, Di = !!gi && gi(Ti, vi);
                if (si)
                  si(Ti, vi, {
                    configurable: $i === null && Di ? Di.configurable : !$i,
                    enumerable: Si === null && Di ? Di.enumerable : !Si,
                    value: xi,
                    writable: Pi === null && Di ? Di.writable : !Pi
                  });
                else if (Oi || !Si && !Pi && !$i)
                  Ti[vi] = xi;
                else
                  throw new di("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
              };
            })
          ),
          /***/
          "./node_modules/define-properties/index.js": (
            /*!*************************************************!*\
              !*** ./node_modules/define-properties/index.js ***!
              \*************************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! object-keys */
                "./node_modules/object-keys/index.js"
              ), di = typeof Symbol == "function" && typeof Symbol("foo") == "symbol", fi = Object.prototype.toString, gi = Array.prototype.concat, mi = oi(
                /*! define-data-property */
                "./node_modules/define-data-property/index.js"
              ), Ti = function(Pi) {
                return typeof Pi == "function" && fi.call(Pi) === "[object Function]";
              }, vi = oi(
                /*! has-property-descriptors */
                "./node_modules/has-property-descriptors/index.js"
              )(), xi = function(Pi, $i, Oi, Di) {
                if ($i in Pi) {
                  if (Di === !0) {
                    if (Pi[$i] === Oi)
                      return;
                  } else if (!Ti(Di) || !Di())
                    return;
                }
                vi ? mi(Pi, $i, Oi, !0) : mi(Pi, $i, Oi);
              }, Si = function(Pi, $i) {
                var Oi = arguments.length > 2 ? arguments[2] : {}, Di = si($i);
                di && (Di = gi.call(Di, Object.getOwnPropertySymbols($i)));
                for (var Mi = 0; Mi < Di.length; Mi += 1)
                  xi(Pi, Di[Mi], $i[Di[Mi]], Oi[Di[Mi]]);
              };
              Si.supportsDescriptors = !!vi, ai.exports = Si;
            })
          ),
          /***/
          "./node_modules/dunder-proto/get.js": (
            /*!******************************************!*\
              !*** ./node_modules/dunder-proto/get.js ***!
              \******************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! call-bind-apply-helpers */
                "./node_modules/call-bind-apply-helpers/index.js"
              ), di = oi(
                /*! gopd */
                "./node_modules/gopd/index.js"
              ), fi;
              try {
                fi = /** @type {{ __proto__?: typeof Array.prototype }} */
                [].__proto__ === Array.prototype;
              } catch (vi) {
                if (!vi || typeof vi != "object" || !("code" in vi) || vi.code !== "ERR_PROTO_ACCESS")
                  throw vi;
              }
              var gi = !!fi && di && di(
                Object.prototype,
                /** @type {keyof typeof Object.prototype} */
                "__proto__"
              ), mi = Object, Ti = mi.getPrototypeOf;
              ai.exports = gi && typeof gi.get == "function" ? si([gi.get]) : typeof Ti == "function" ? (
                /** @type {import('./get')} */
                function(xi) {
                  return Ti(xi == null ? xi : mi(xi));
                }
              ) : !1;
            })
          ),
          /***/
          "./node_modules/es-define-property/index.js": (
            /*!**************************************************!*\
              !*** ./node_modules/es-define-property/index.js ***!
              \**************************************************/
            /***/
            ((ai) => {
              var li = Object.defineProperty || !1;
              if (li)
                try {
                  li({}, "a", { value: 1 });
                } catch {
                  li = !1;
                }
              ai.exports = li;
            })
          ),
          /***/
          "./node_modules/es-errors/eval.js": (
            /*!****************************************!*\
              !*** ./node_modules/es-errors/eval.js ***!
              \****************************************/
            /***/
            ((ai) => {
              ai.exports = EvalError;
            })
          ),
          /***/
          "./node_modules/es-errors/index.js": (
            /*!*****************************************!*\
              !*** ./node_modules/es-errors/index.js ***!
              \*****************************************/
            /***/
            ((ai) => {
              ai.exports = Error;
            })
          ),
          /***/
          "./node_modules/es-errors/range.js": (
            /*!*****************************************!*\
              !*** ./node_modules/es-errors/range.js ***!
              \*****************************************/
            /***/
            ((ai) => {
              ai.exports = RangeError;
            })
          ),
          /***/
          "./node_modules/es-errors/ref.js": (
            /*!***************************************!*\
              !*** ./node_modules/es-errors/ref.js ***!
              \***************************************/
            /***/
            ((ai) => {
              ai.exports = ReferenceError;
            })
          ),
          /***/
          "./node_modules/es-errors/syntax.js": (
            /*!******************************************!*\
              !*** ./node_modules/es-errors/syntax.js ***!
              \******************************************/
            /***/
            ((ai) => {
              ai.exports = SyntaxError;
            })
          ),
          /***/
          "./node_modules/es-errors/type.js": (
            /*!****************************************!*\
              !*** ./node_modules/es-errors/type.js ***!
              \****************************************/
            /***/
            ((ai) => {
              ai.exports = TypeError;
            })
          ),
          /***/
          "./node_modules/es-errors/uri.js": (
            /*!***************************************!*\
              !*** ./node_modules/es-errors/uri.js ***!
              \***************************************/
            /***/
            ((ai) => {
              ai.exports = URIError;
            })
          ),
          /***/
          "./node_modules/es-object-atoms/index.js": (
            /*!***********************************************!*\
              !*** ./node_modules/es-object-atoms/index.js ***!
              \***********************************************/
            /***/
            ((ai) => {
              ai.exports = Object;
            })
          ),
          /***/
          "./node_modules/videojs-swf/dist/video-js.swf": (
            /*!****************************************************!*\
              !*** ./node_modules/videojs-swf/dist/video-js.swf ***!
              \****************************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                default: () => si
                /* harmony export */
              });
              const si = oi.p + "video-js.swf";
            })
          ),
          /***/
          "./src/assets/video-js-buffer3-exactfit.swf": (
            /*!**************************************************!*\
              !*** ./src/assets/video-js-buffer3-exactfit.swf ***!
              \**************************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                default: () => si
                /* harmony export */
              });
              const si = oi.p + "video-js-buffer3-exactfit.swf";
            })
          ),
          /***/
          "./src/assets/video-js-buffer3.swf": (
            /*!*****************************************!*\
              !*** ./src/assets/video-js-buffer3.swf ***!
              \*****************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                default: () => si
                /* harmony export */
              });
              const si = oi.p + "video-js-buffer3.swf";
            })
          ),
          /***/
          "./src/assets/video-js-buffer5.swf": (
            /*!*****************************************!*\
              !*** ./src/assets/video-js-buffer5.swf ***!
              \*****************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                default: () => si
                /* harmony export */
              });
              const si = oi.p + "video-js-buffer5.swf";
            })
          ),
          /***/
          "./src/assets/PreRoll1_Full.mp4": (
            /*!**************************************!*\
              !*** ./src/assets/PreRoll1_Full.mp4 ***!
              \**************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                default: () => si
                /* harmony export */
              });
              const si = oi.p + "PreRoll1_Full.mp4";
            })
          ),
          /***/
          "./src/assets/PreRoll2_Full.mp4": (
            /*!**************************************!*\
              !*** ./src/assets/PreRoll2_Full.mp4 ***!
              \**************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                default: () => si
                /* harmony export */
              });
              const si = oi.p + "PreRoll2_Full.mp4";
            })
          ),
          /***/
          "./src/assets/PreRoll3_Full.mp4": (
            /*!**************************************!*\
              !*** ./src/assets/PreRoll3_Full.mp4 ***!
              \**************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                default: () => si
                /* harmony export */
              });
              const si = oi.p + "PreRoll3_Full.mp4";
            })
          ),
          /***/
          "./src/assets/dog.mp4": (
            /*!****************************!*\
              !*** ./src/assets/dog.mp4 ***!
              \****************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                default: () => si
                /* harmony export */
              });
              const si = oi.p + "dog.mp4";
            })
          ),
          /***/
          "./node_modules/for-each/index.js": (
            /*!****************************************!*\
              !*** ./node_modules/for-each/index.js ***!
              \****************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! is-callable */
                "./node_modules/is-callable/index.js"
              ), di = Object.prototype.toString, fi = Object.prototype.hasOwnProperty, gi = function(Si, Pi, $i) {
                for (var Oi = 0, Di = Si.length; Oi < Di; Oi++)
                  fi.call(Si, Oi) && ($i == null ? Pi(Si[Oi], Oi, Si) : Pi.call($i, Si[Oi], Oi, Si));
              }, mi = function(Si, Pi, $i) {
                for (var Oi = 0, Di = Si.length; Oi < Di; Oi++)
                  $i == null ? Pi(Si.charAt(Oi), Oi, Si) : Pi.call($i, Si.charAt(Oi), Oi, Si);
              }, Ti = function(Si, Pi, $i) {
                for (var Oi in Si)
                  fi.call(Si, Oi) && ($i == null ? Pi(Si[Oi], Oi, Si) : Pi.call($i, Si[Oi], Oi, Si));
              };
              function vi(xi) {
                return di.call(xi) === "[object Array]";
              }
              ai.exports = function(Si, Pi, $i) {
                if (!si(Pi))
                  throw new TypeError("iterator must be a function");
                var Oi;
                arguments.length >= 3 && (Oi = $i), vi(Si) ? gi(Si, Pi, Oi) : typeof Si == "string" ? mi(Si, Pi, Oi) : Ti(Si, Pi, Oi);
              };
            })
          ),
          /***/
          "./node_modules/function-bind/implementation.js": (
            /*!******************************************************!*\
              !*** ./node_modules/function-bind/implementation.js ***!
              \******************************************************/
            /***/
            ((ai) => {
              var li = "Function.prototype.bind called on incompatible ", oi = Object.prototype.toString, si = Math.max, di = "[object Function]", fi = function(vi, xi) {
                for (var Si = [], Pi = 0; Pi < vi.length; Pi += 1)
                  Si[Pi] = vi[Pi];
                for (var $i = 0; $i < xi.length; $i += 1)
                  Si[$i + vi.length] = xi[$i];
                return Si;
              }, gi = function(vi, xi) {
                for (var Si = [], Pi = xi, $i = 0; Pi < vi.length; Pi += 1, $i += 1)
                  Si[$i] = vi[Pi];
                return Si;
              }, mi = function(Ti, vi) {
                for (var xi = "", Si = 0; Si < Ti.length; Si += 1)
                  xi += Ti[Si], Si + 1 < Ti.length && (xi += vi);
                return xi;
              };
              ai.exports = function(vi) {
                var xi = this;
                if (typeof xi != "function" || oi.apply(xi) !== di)
                  throw new TypeError(li + xi);
                for (var Si = gi(arguments, 1), Pi, $i = function() {
                  if (this instanceof Pi) {
                    var io = xi.apply(
                      this,
                      fi(Si, arguments)
                    );
                    return Object(io) === io ? io : this;
                  }
                  return xi.apply(
                    vi,
                    fi(Si, arguments)
                  );
                }, Oi = si(0, xi.length - Si.length), Di = [], Mi = 0; Mi < Oi; Mi++)
                  Di[Mi] = "$" + Mi;
                if (Pi = Function("binder", "return function (" + mi(Di, ",") + "){ return binder.apply(this,arguments); }")($i), xi.prototype) {
                  var Oo = function() {
                  };
                  Oo.prototype = xi.prototype, Pi.prototype = new Oo(), Oo.prototype = null;
                }
                return Pi;
              };
            })
          ),
          /***/
          "./node_modules/function-bind/index.js": (
            /*!*********************************************!*\
              !*** ./node_modules/function-bind/index.js ***!
              \*********************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! ./implementation */
                "./node_modules/function-bind/implementation.js"
              );
              ai.exports = Function.prototype.bind || si;
            })
          ),
          /***/
          "./node_modules/get-intrinsic/index.js": (
            /*!*********************************************!*\
              !*** ./node_modules/get-intrinsic/index.js ***!
              \*********************************************/
            /***/
            ((ai, li, oi) => {
              var si, di = oi(
                /*! es-object-atoms */
                "./node_modules/es-object-atoms/index.js"
              ), fi = oi(
                /*! es-errors */
                "./node_modules/es-errors/index.js"
              ), gi = oi(
                /*! es-errors/eval */
                "./node_modules/es-errors/eval.js"
              ), mi = oi(
                /*! es-errors/range */
                "./node_modules/es-errors/range.js"
              ), Ti = oi(
                /*! es-errors/ref */
                "./node_modules/es-errors/ref.js"
              ), vi = oi(
                /*! es-errors/syntax */
                "./node_modules/es-errors/syntax.js"
              ), xi = oi(
                /*! es-errors/type */
                "./node_modules/es-errors/type.js"
              ), Si = oi(
                /*! es-errors/uri */
                "./node_modules/es-errors/uri.js"
              ), Pi = oi(
                /*! math-intrinsics/abs */
                "./node_modules/math-intrinsics/abs.js"
              ), $i = oi(
                /*! math-intrinsics/floor */
                "./node_modules/math-intrinsics/floor.js"
              ), Oi = oi(
                /*! math-intrinsics/max */
                "./node_modules/math-intrinsics/max.js"
              ), Di = oi(
                /*! math-intrinsics/min */
                "./node_modules/math-intrinsics/min.js"
              ), Mi = oi(
                /*! math-intrinsics/pow */
                "./node_modules/math-intrinsics/pow.js"
              ), Oo = oi(
                /*! math-intrinsics/round */
                "./node_modules/math-intrinsics/round.js"
              ), io = oi(
                /*! math-intrinsics/sign */
                "./node_modules/math-intrinsics/sign.js"
              ), xo = Function, fo = function(Es) {
                try {
                  return xo('"use strict"; return (' + Es + ").constructor;")();
                } catch {
                }
              }, _o = oi(
                /*! gopd */
                "./node_modules/gopd/index.js"
              ), Li = oi(
                /*! es-define-property */
                "./node_modules/es-define-property/index.js"
              ), Co = function() {
                throw new xi();
              }, Ni = _o ? (function() {
                try {
                  return arguments.callee, Co;
                } catch {
                  try {
                    return _o(arguments, "callee").get;
                  } catch {
                    return Co;
                  }
                }
              })() : Co, Yi = oi(
                /*! has-symbols */
                "./node_modules/has-symbols/index.js"
              )(), Vo = oi(
                /*! get-proto */
                "./node_modules/get-proto/index.js"
              ), No = oi(
                /*! get-proto/Object.getPrototypeOf */
                "./node_modules/get-proto/Object.getPrototypeOf.js"
              ), Ui = oi(
                /*! get-proto/Reflect.getPrototypeOf */
                "./node_modules/get-proto/Reflect.getPrototypeOf.js"
              ), jo = oi(
                /*! call-bind-apply-helpers/functionApply */
                "./node_modules/call-bind-apply-helpers/functionApply.js"
              ), Wi = oi(
                /*! call-bind-apply-helpers/functionCall */
                "./node_modules/call-bind-apply-helpers/functionCall.js"
              ), ji = {}, Hi = typeof Uint8Array > "u" || !Vo ? si : Vo(Uint8Array), zo = {
                __proto__: null,
                "%AggregateError%": typeof AggregateError > "u" ? si : AggregateError,
                "%Array%": Array,
                "%ArrayBuffer%": typeof ArrayBuffer > "u" ? si : ArrayBuffer,
                "%ArrayIteratorPrototype%": Yi && Vo ? Vo([][Symbol.iterator]()) : si,
                "%AsyncFromSyncIteratorPrototype%": si,
                "%AsyncFunction%": ji,
                "%AsyncGenerator%": ji,
                "%AsyncGeneratorFunction%": ji,
                "%AsyncIteratorPrototype%": ji,
                "%Atomics%": typeof Atomics > "u" ? si : Atomics,
                "%BigInt%": typeof BigInt > "u" ? si : BigInt,
                "%BigInt64Array%": typeof BigInt64Array > "u" ? si : BigInt64Array,
                "%BigUint64Array%": typeof BigUint64Array > "u" ? si : BigUint64Array,
                "%Boolean%": Boolean,
                "%DataView%": typeof DataView > "u" ? si : DataView,
                "%Date%": Date,
                "%decodeURI%": decodeURI,
                "%decodeURIComponent%": decodeURIComponent,
                "%encodeURI%": encodeURI,
                "%encodeURIComponent%": encodeURIComponent,
                "%Error%": fi,
                "%eval%": eval,
                // eslint-disable-line no-eval
                "%EvalError%": gi,
                "%Float16Array%": typeof Float16Array > "u" ? si : Float16Array,
                "%Float32Array%": typeof Float32Array > "u" ? si : Float32Array,
                "%Float64Array%": typeof Float64Array > "u" ? si : Float64Array,
                "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? si : FinalizationRegistry,
                "%Function%": xo,
                "%GeneratorFunction%": ji,
                "%Int8Array%": typeof Int8Array > "u" ? si : Int8Array,
                "%Int16Array%": typeof Int16Array > "u" ? si : Int16Array,
                "%Int32Array%": typeof Int32Array > "u" ? si : Int32Array,
                "%isFinite%": isFinite,
                "%isNaN%": isNaN,
                "%IteratorPrototype%": Yi && Vo ? Vo(Vo([][Symbol.iterator]())) : si,
                "%JSON%": typeof JSON == "object" ? JSON : si,
                "%Map%": typeof Map > "u" ? si : Map,
                "%MapIteratorPrototype%": typeof Map > "u" || !Yi || !Vo ? si : Vo((/* @__PURE__ */ new Map())[Symbol.iterator]()),
                "%Math%": Math,
                "%Number%": Number,
                "%Object%": di,
                "%Object.getOwnPropertyDescriptor%": _o,
                "%parseFloat%": parseFloat,
                "%parseInt%": parseInt,
                "%Promise%": typeof Promise > "u" ? si : Promise,
                "%Proxy%": typeof Proxy > "u" ? si : Proxy,
                "%RangeError%": mi,
                "%ReferenceError%": Ti,
                "%Reflect%": typeof Reflect > "u" ? si : Reflect,
                "%RegExp%": RegExp,
                "%Set%": typeof Set > "u" ? si : Set,
                "%SetIteratorPrototype%": typeof Set > "u" || !Yi || !Vo ? si : Vo((/* @__PURE__ */ new Set())[Symbol.iterator]()),
                "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? si : SharedArrayBuffer,
                "%String%": String,
                "%StringIteratorPrototype%": Yi && Vo ? Vo(""[Symbol.iterator]()) : si,
                "%Symbol%": Yi ? Symbol : si,
                "%SyntaxError%": vi,
                "%ThrowTypeError%": Ni,
                "%TypedArray%": Hi,
                "%TypeError%": xi,
                "%Uint8Array%": typeof Uint8Array > "u" ? si : Uint8Array,
                "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? si : Uint8ClampedArray,
                "%Uint16Array%": typeof Uint16Array > "u" ? si : Uint16Array,
                "%Uint32Array%": typeof Uint32Array > "u" ? si : Uint32Array,
                "%URIError%": Si,
                "%WeakMap%": typeof WeakMap > "u" ? si : WeakMap,
                "%WeakRef%": typeof WeakRef > "u" ? si : WeakRef,
                "%WeakSet%": typeof WeakSet > "u" ? si : WeakSet,
                "%Function.prototype.call%": Wi,
                "%Function.prototype.apply%": jo,
                "%Object.defineProperty%": Li,
                "%Object.getPrototypeOf%": No,
                "%Math.abs%": Pi,
                "%Math.floor%": $i,
                "%Math.max%": Oi,
                "%Math.min%": Di,
                "%Math.pow%": Mi,
                "%Math.round%": Oo,
                "%Math.sign%": io,
                "%Reflect.getPrototypeOf%": Ui
              };
              if (Vo)
                try {
                  null.error;
                } catch (Es) {
                  var Lo = Vo(Vo(Es));
                  zo["%Error.prototype%"] = Lo;
                }
              var sa = function Es(Rs) {
                var La;
                if (Rs === "%AsyncFunction%")
                  La = fo("async function () {}");
                else if (Rs === "%GeneratorFunction%")
                  La = fo("function* () {}");
                else if (Rs === "%AsyncGeneratorFunction%")
                  La = fo("async function* () {}");
                else if (Rs === "%AsyncGenerator%") {
                  var Ja = Es("%AsyncGeneratorFunction%");
                  Ja && (La = Ja.prototype);
                } else if (Rs === "%AsyncIteratorPrototype%") {
                  var ja = Es("%AsyncGenerator%");
                  ja && Vo && (La = Vo(ja.prototype));
                }
                return zo[Rs] = La, La;
              }, Ko = {
                __proto__: null,
                "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
                "%ArrayPrototype%": ["Array", "prototype"],
                "%ArrayProto_entries%": ["Array", "prototype", "entries"],
                "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
                "%ArrayProto_keys%": ["Array", "prototype", "keys"],
                "%ArrayProto_values%": ["Array", "prototype", "values"],
                "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
                "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
                "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
                "%BooleanPrototype%": ["Boolean", "prototype"],
                "%DataViewPrototype%": ["DataView", "prototype"],
                "%DatePrototype%": ["Date", "prototype"],
                "%ErrorPrototype%": ["Error", "prototype"],
                "%EvalErrorPrototype%": ["EvalError", "prototype"],
                "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
                "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
                "%FunctionPrototype%": ["Function", "prototype"],
                "%Generator%": ["GeneratorFunction", "prototype"],
                "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
                "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
                "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
                "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
                "%JSONParse%": ["JSON", "parse"],
                "%JSONStringify%": ["JSON", "stringify"],
                "%MapPrototype%": ["Map", "prototype"],
                "%NumberPrototype%": ["Number", "prototype"],
                "%ObjectPrototype%": ["Object", "prototype"],
                "%ObjProto_toString%": ["Object", "prototype", "toString"],
                "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
                "%PromisePrototype%": ["Promise", "prototype"],
                "%PromiseProto_then%": ["Promise", "prototype", "then"],
                "%Promise_all%": ["Promise", "all"],
                "%Promise_reject%": ["Promise", "reject"],
                "%Promise_resolve%": ["Promise", "resolve"],
                "%RangeErrorPrototype%": ["RangeError", "prototype"],
                "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
                "%RegExpPrototype%": ["RegExp", "prototype"],
                "%SetPrototype%": ["Set", "prototype"],
                "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
                "%StringPrototype%": ["String", "prototype"],
                "%SymbolPrototype%": ["Symbol", "prototype"],
                "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
                "%TypedArrayPrototype%": ["TypedArray", "prototype"],
                "%TypeErrorPrototype%": ["TypeError", "prototype"],
                "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
                "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
                "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
                "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
                "%URIErrorPrototype%": ["URIError", "prototype"],
                "%WeakMapPrototype%": ["WeakMap", "prototype"],
                "%WeakSetPrototype%": ["WeakSet", "prototype"]
              }, ca = oi(
                /*! function-bind */
                "./node_modules/function-bind/index.js"
              ), pa = oi(
                /*! hasown */
                "./node_modules/hasown/index.js"
              ), ga = ca.call(Wi, Array.prototype.concat), ia = ca.call(jo, Array.prototype.splice), ra = ca.call(Wi, String.prototype.replace), qo = ca.call(Wi, String.prototype.slice), xa = ca.call(Wi, RegExp.prototype.exec), $a = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, ys = /\\(\\)?/g, Ss = function(Rs) {
                var La = qo(Rs, 0, 1), Ja = qo(Rs, -1);
                if (La === "%" && Ja !== "%")
                  throw new vi("invalid intrinsic syntax, expected closing `%`");
                if (Ja === "%" && La !== "%")
                  throw new vi("invalid intrinsic syntax, expected opening `%`");
                var ja = [];
                return ra(Rs, $a, function(Ta, rs, Qa, Cs) {
                  ja[ja.length] = Qa ? ra(Cs, ys, "$1") : rs || Ta;
                }), ja;
              }, Xa = function(Rs, La) {
                var Ja = Rs, ja;
                if (pa(Ko, Ja) && (ja = Ko[Ja], Ja = "%" + ja[0] + "%"), pa(zo, Ja)) {
                  var Ta = zo[Ja];
                  if (Ta === ji && (Ta = sa(Ja)), typeof Ta > "u" && !La)
                    throw new xi("intrinsic " + Rs + " exists, but is not available. Please file an issue!");
                  return {
                    alias: ja,
                    name: Ja,
                    value: Ta
                  };
                }
                throw new vi("intrinsic " + Rs + " does not exist!");
              };
              ai.exports = function(Rs, La) {
                if (typeof Rs != "string" || Rs.length === 0)
                  throw new xi("intrinsic name must be a non-empty string");
                if (arguments.length > 1 && typeof La != "boolean")
                  throw new xi('"allowMissing" argument must be a boolean');
                if (xa(/^%?[^%]*%?$/, Rs) === null)
                  throw new vi("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
                var Ja = Ss(Rs), ja = Ja.length > 0 ? Ja[0] : "", Ta = Xa("%" + ja + "%", La), rs = Ta.name, Qa = Ta.value, Cs = !1, _a = Ta.alias;
                _a && (ja = _a[0], ia(Ja, ga([0, 1], _a)));
                for (var _s = 1, el = !0; _s < Ja.length; _s += 1) {
                  var Ps = Ja[_s], nl = qo(Ps, 0, 1), Vs = qo(Ps, -1);
                  if ((nl === '"' || nl === "'" || nl === "`" || Vs === '"' || Vs === "'" || Vs === "`") && nl !== Vs)
                    throw new vi("property names with quotes must have matching quotes");
                  if ((Ps === "constructor" || !el) && (Cs = !0), ja += "." + Ps, rs = "%" + ja + "%", pa(zo, rs))
                    Qa = zo[rs];
                  else if (Qa != null) {
                    if (!(Ps in Qa)) {
                      if (!La)
                        throw new xi("base intrinsic for " + Rs + " exists, but the property is not available.");
                      return;
                    }
                    if (_o && _s + 1 >= Ja.length) {
                      var es = _o(Qa, Ps);
                      el = !!es, el && "get" in es && !("originalValue" in es.get) ? Qa = es.get : Qa = Qa[Ps];
                    } else
                      el = pa(Qa, Ps), Qa = Qa[Ps];
                    el && !Cs && (zo[rs] = Qa);
                  }
                }
                return Qa;
              };
            })
          ),
          /***/
          "./node_modules/get-proto/Object.getPrototypeOf.js": (
            /*!*********************************************************!*\
              !*** ./node_modules/get-proto/Object.getPrototypeOf.js ***!
              \*********************************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! es-object-atoms */
                "./node_modules/es-object-atoms/index.js"
              );
              ai.exports = si.getPrototypeOf || null;
            })
          ),
          /***/
          "./node_modules/get-proto/Reflect.getPrototypeOf.js": (
            /*!**********************************************************!*\
              !*** ./node_modules/get-proto/Reflect.getPrototypeOf.js ***!
              \**********************************************************/
            /***/
            ((ai) => {
              ai.exports = typeof Reflect < "u" && Reflect.getPrototypeOf || null;
            })
          ),
          /***/
          "./node_modules/get-proto/index.js": (
            /*!*****************************************!*\
              !*** ./node_modules/get-proto/index.js ***!
              \*****************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! ./Reflect.getPrototypeOf */
                "./node_modules/get-proto/Reflect.getPrototypeOf.js"
              ), di = oi(
                /*! ./Object.getPrototypeOf */
                "./node_modules/get-proto/Object.getPrototypeOf.js"
              ), fi = oi(
                /*! dunder-proto/get */
                "./node_modules/dunder-proto/get.js"
              );
              ai.exports = si ? function(mi) {
                return si(mi);
              } : di ? function(mi) {
                if (!mi || typeof mi != "object" && typeof mi != "function")
                  throw new TypeError("getProto: not an object");
                return di(mi);
              } : fi ? function(mi) {
                return fi(mi);
              } : null;
            })
          ),
          /***/
          "./node_modules/global/document.js": (
            /*!*****************************************!*\
              !*** ./node_modules/global/document.js ***!
              \*****************************************/
            /***/
            ((ai, li, oi) => {
              var si = typeof oi.g < "u" ? oi.g : typeof window < "u" ? window : {}, di = oi(
                /*! min-document */
                "?34aa"
              ), fi;
              typeof document < "u" ? fi = document : (fi = si["__GLOBAL_DOCUMENT_CACHE@4"], fi || (fi = si["__GLOBAL_DOCUMENT_CACHE@4"] = di)), ai.exports = fi;
            })
          ),
          /***/
          "./node_modules/global/window.js": (
            /*!***************************************!*\
              !*** ./node_modules/global/window.js ***!
              \***************************************/
            /***/
            ((ai, li, oi) => {
              var si;
              typeof window < "u" ? si = window : typeof oi.g < "u" ? si = oi.g : typeof self < "u" ? si = self : si = {}, ai.exports = si;
            })
          ),
          /***/
          "./node_modules/gopd/gOPD.js": (
            /*!***********************************!*\
              !*** ./node_modules/gopd/gOPD.js ***!
              \***********************************/
            /***/
            ((ai) => {
              ai.exports = Object.getOwnPropertyDescriptor;
            })
          ),
          /***/
          "./node_modules/gopd/index.js": (
            /*!************************************!*\
              !*** ./node_modules/gopd/index.js ***!
              \************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! ./gOPD */
                "./node_modules/gopd/gOPD.js"
              );
              if (si)
                try {
                  si([], "length");
                } catch {
                  si = null;
                }
              ai.exports = si;
            })
          ),
          /***/
          "./node_modules/has-property-descriptors/index.js": (
            /*!********************************************************!*\
              !*** ./node_modules/has-property-descriptors/index.js ***!
              \********************************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! es-define-property */
                "./node_modules/es-define-property/index.js"
              ), di = function() {
                return !!si;
              };
              di.hasArrayLengthDefineBug = function() {
                if (!si)
                  return null;
                try {
                  return si([], "length", { value: 1 }).length !== 1;
                } catch {
                  return !0;
                }
              }, ai.exports = di;
            })
          ),
          /***/
          "./node_modules/has-symbols/index.js": (
            /*!*******************************************!*\
              !*** ./node_modules/has-symbols/index.js ***!
              \*******************************************/
            /***/
            ((ai, li, oi) => {
              var si = typeof Symbol < "u" && Symbol, di = oi(
                /*! ./shams */
                "./node_modules/has-symbols/shams.js"
              );
              ai.exports = function() {
                return typeof si != "function" || typeof Symbol != "function" || typeof si("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : di();
              };
            })
          ),
          /***/
          "./node_modules/has-symbols/shams.js": (
            /*!*******************************************!*\
              !*** ./node_modules/has-symbols/shams.js ***!
              \*******************************************/
            /***/
            ((ai) => {
              ai.exports = function() {
                if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
                  return !1;
                if (typeof Symbol.iterator == "symbol")
                  return !0;
                var oi = {}, si = Symbol("test"), di = Object(si);
                if (typeof si == "string" || Object.prototype.toString.call(si) !== "[object Symbol]" || Object.prototype.toString.call(di) !== "[object Symbol]")
                  return !1;
                var fi = 42;
                oi[si] = fi;
                for (var gi in oi)
                  return !1;
                if (typeof Object.keys == "function" && Object.keys(oi).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(oi).length !== 0)
                  return !1;
                var mi = Object.getOwnPropertySymbols(oi);
                if (mi.length !== 1 || mi[0] !== si || !Object.prototype.propertyIsEnumerable.call(oi, si))
                  return !1;
                if (typeof Object.getOwnPropertyDescriptor == "function") {
                  var Ti = (
                    /** @type {PropertyDescriptor} */
                    Object.getOwnPropertyDescriptor(oi, si)
                  );
                  if (Ti.value !== fi || Ti.enumerable !== !0)
                    return !1;
                }
                return !0;
              };
            })
          ),
          /***/
          "./node_modules/has-tostringtag/shams.js": (
            /*!***********************************************!*\
              !*** ./node_modules/has-tostringtag/shams.js ***!
              \***********************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! has-symbols/shams */
                "./node_modules/has-symbols/shams.js"
              );
              ai.exports = function() {
                return si() && !!Symbol.toStringTag;
              };
            })
          ),
          /***/
          "./node_modules/hasown/index.js": (
            /*!**************************************!*\
              !*** ./node_modules/hasown/index.js ***!
              \**************************************/
            /***/
            ((ai, li, oi) => {
              var si = Function.prototype.call, di = Object.prototype.hasOwnProperty, fi = oi(
                /*! function-bind */
                "./node_modules/function-bind/index.js"
              );
              ai.exports = fi.call(si, di);
            })
          ),
          /***/
          "./node_modules/inherits/inherits_browser.js": (
            /*!***************************************************!*\
              !*** ./node_modules/inherits/inherits_browser.js ***!
              \***************************************************/
            /***/
            ((ai) => {
              typeof Object.create == "function" ? ai.exports = function(oi, si) {
                si && (oi.super_ = si, oi.prototype = Object.create(si.prototype, {
                  constructor: {
                    value: oi,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                  }
                }));
              } : ai.exports = function(oi, si) {
                if (si) {
                  oi.super_ = si;
                  var di = function() {
                  };
                  di.prototype = si.prototype, oi.prototype = new di(), oi.prototype.constructor = oi;
                }
              };
            })
          ),
          /***/
          "./node_modules/is-arguments/index.js": (
            /*!********************************************!*\
              !*** ./node_modules/is-arguments/index.js ***!
              \********************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! has-tostringtag/shams */
                "./node_modules/has-tostringtag/shams.js"
              )(), di = oi(
                /*! call-bound */
                "./node_modules/call-bound/index.js"
              ), fi = di("Object.prototype.toString"), gi = function(xi) {
                return si && xi && typeof xi == "object" && Symbol.toStringTag in xi ? !1 : fi(xi) === "[object Arguments]";
              }, mi = function(xi) {
                return gi(xi) ? !0 : xi !== null && typeof xi == "object" && "length" in xi && typeof xi.length == "number" && xi.length >= 0 && fi(xi) !== "[object Array]" && "callee" in xi && fi(xi.callee) === "[object Function]";
              }, Ti = (function() {
                return gi(arguments);
              })();
              gi.isLegacyArguments = mi, ai.exports = Ti ? gi : mi;
            })
          ),
          /***/
          "./node_modules/is-callable/index.js": (
            /*!*******************************************!*\
              !*** ./node_modules/is-callable/index.js ***!
              \*******************************************/
            /***/
            ((ai) => {
              var li = Function.prototype.toString, oi = typeof Reflect == "object" && Reflect !== null && Reflect.apply, si, di;
              if (typeof oi == "function" && typeof Object.defineProperty == "function")
                try {
                  si = Object.defineProperty({}, "length", {
                    get: function() {
                      throw di;
                    }
                  }), di = {}, oi(function() {
                    throw 42;
                  }, null, si);
                } catch (xo) {
                  xo !== di && (oi = null);
                }
              else
                oi = null;
              var fi = /^\s*class\b/, gi = function(fo) {
                try {
                  var _o = li.call(fo);
                  return fi.test(_o);
                } catch {
                  return !1;
                }
              }, mi = function(fo) {
                try {
                  return gi(fo) ? !1 : (li.call(fo), !0);
                } catch {
                  return !1;
                }
              }, Ti = Object.prototype.toString, vi = "[object Object]", xi = "[object Function]", Si = "[object GeneratorFunction]", Pi = "[object HTMLAllCollection]", $i = "[object HTML document.all class]", Oi = "[object HTMLCollection]", Di = typeof Symbol == "function" && !!Symbol.toStringTag, Mi = !(0 in [,]), Oo = function() {
                return !1;
              };
              if (typeof document == "object") {
                var io = document.all;
                Ti.call(io) === Ti.call(document.all) && (Oo = function(fo) {
                  if ((Mi || !fo) && (typeof fo > "u" || typeof fo == "object"))
                    try {
                      var _o = Ti.call(fo);
                      return (_o === Pi || _o === $i || _o === Oi || _o === vi) && fo("") == null;
                    } catch {
                    }
                  return !1;
                });
              }
              ai.exports = oi ? function(fo) {
                if (Oo(fo))
                  return !0;
                if (!fo || typeof fo != "function" && typeof fo != "object")
                  return !1;
                try {
                  oi(fo, null, si);
                } catch (_o) {
                  if (_o !== di)
                    return !1;
                }
                return !gi(fo) && mi(fo);
              } : function(fo) {
                if (Oo(fo))
                  return !0;
                if (!fo || typeof fo != "function" && typeof fo != "object")
                  return !1;
                if (Di)
                  return mi(fo);
                if (gi(fo))
                  return !1;
                var _o = Ti.call(fo);
                return _o !== xi && _o !== Si && !/^\[object HTML/.test(_o) ? !1 : mi(fo);
              };
            })
          ),
          /***/
          "./node_modules/is-function/index.js": (
            /*!*******************************************!*\
              !*** ./node_modules/is-function/index.js ***!
              \*******************************************/
            /***/
            ((ai) => {
              ai.exports = oi;
              var li = Object.prototype.toString;
              function oi(si) {
                if (!si)
                  return !1;
                var di = li.call(si);
                return di === "[object Function]" || typeof si == "function" && di !== "[object RegExp]" || typeof window < "u" && // IE8 and below
                (si === window.setTimeout || si === window.alert || si === window.confirm || si === window.prompt);
              }
            })
          ),
          /***/
          "./node_modules/is-generator-function/index.js": (
            /*!*****************************************************!*\
              !*** ./node_modules/is-generator-function/index.js ***!
              \*****************************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! call-bound */
                "./node_modules/call-bound/index.js"
              ), di = oi(
                /*! safe-regex-test */
                "./node_modules/safe-regex-test/index.js"
              ), fi = di(/^\s*(?:function)?\*/), gi = oi(
                /*! has-tostringtag/shams */
                "./node_modules/has-tostringtag/shams.js"
              )(), mi = oi(
                /*! get-proto */
                "./node_modules/get-proto/index.js"
              ), Ti = si("Object.prototype.toString"), vi = si("Function.prototype.toString"), xi = function() {
                if (!gi)
                  return !1;
                try {
                  return Function("return function*() {}")();
                } catch {
                }
              }, Si;
              ai.exports = function($i) {
                if (typeof $i != "function")
                  return !1;
                if (fi(vi($i)))
                  return !0;
                if (!gi) {
                  var Oi = Ti($i);
                  return Oi === "[object GeneratorFunction]";
                }
                if (!mi)
                  return !1;
                if (typeof Si > "u") {
                  var Di = xi();
                  Si = Di ? (
                    /** @type {GeneratorFunctionConstructor} */
                    mi(Di)
                  ) : !1;
                }
                return mi($i) === Si;
              };
            })
          ),
          /***/
          "./node_modules/is-nan/implementation.js": (
            /*!***********************************************!*\
              !*** ./node_modules/is-nan/implementation.js ***!
              \***********************************************/
            /***/
            ((ai) => {
              ai.exports = function(oi) {
                return oi !== oi;
              };
            })
          ),
          /***/
          "./node_modules/is-nan/index.js": (
            /*!**************************************!*\
              !*** ./node_modules/is-nan/index.js ***!
              \**************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! call-bind */
                "./node_modules/call-bind/index.js"
              ), di = oi(
                /*! define-properties */
                "./node_modules/define-properties/index.js"
              ), fi = oi(
                /*! ./implementation */
                "./node_modules/is-nan/implementation.js"
              ), gi = oi(
                /*! ./polyfill */
                "./node_modules/is-nan/polyfill.js"
              ), mi = oi(
                /*! ./shim */
                "./node_modules/is-nan/shim.js"
              ), Ti = si(gi(), Number);
              di(Ti, {
                getPolyfill: gi,
                implementation: fi,
                shim: mi
              }), ai.exports = Ti;
            })
          ),
          /***/
          "./node_modules/is-nan/polyfill.js": (
            /*!*****************************************!*\
              !*** ./node_modules/is-nan/polyfill.js ***!
              \*****************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! ./implementation */
                "./node_modules/is-nan/implementation.js"
              );
              ai.exports = function() {
                return Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a") ? Number.isNaN : si;
              };
            })
          ),
          /***/
          "./node_modules/is-nan/shim.js": (
            /*!*************************************!*\
              !*** ./node_modules/is-nan/shim.js ***!
              \*************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! define-properties */
                "./node_modules/define-properties/index.js"
              ), di = oi(
                /*! ./polyfill */
                "./node_modules/is-nan/polyfill.js"
              );
              ai.exports = function() {
                var gi = di();
                return si(Number, { isNaN: gi }, {
                  isNaN: function() {
                    return Number.isNaN !== gi;
                  }
                }), gi;
              };
            })
          ),
          /***/
          "./node_modules/is-regex/index.js": (
            /*!****************************************!*\
              !*** ./node_modules/is-regex/index.js ***!
              \****************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! call-bound */
                "./node_modules/call-bound/index.js"
              ), di = oi(
                /*! has-tostringtag/shams */
                "./node_modules/has-tostringtag/shams.js"
              )(), fi = oi(
                /*! hasown */
                "./node_modules/hasown/index.js"
              ), gi = oi(
                /*! gopd */
                "./node_modules/gopd/index.js"
              ), mi;
              if (di) {
                var Ti = si("RegExp.prototype.exec"), vi = {}, xi = function() {
                  throw vi;
                }, Si = {
                  toString: xi,
                  valueOf: xi
                };
                typeof Symbol.toPrimitive == "symbol" && (Si[Symbol.toPrimitive] = xi), mi = function(Di) {
                  if (!Di || typeof Di != "object")
                    return !1;
                  var Mi = (
                    /** @type {NonNullable<typeof gOPD>} */
                    gi(
                      /** @type {{ lastIndex?: unknown }} */
                      Di,
                      "lastIndex"
                    )
                  ), Oo = Mi && fi(Mi, "value");
                  if (!Oo)
                    return !1;
                  try {
                    Ti(
                      Di,
                      /** @type {string} */
                      /** @type {unknown} */
                      Si
                    );
                  } catch (io) {
                    return io === vi;
                  }
                };
              } else {
                var Pi = si("Object.prototype.toString"), $i = "[object RegExp]";
                mi = function(Di) {
                  return !Di || typeof Di != "object" && typeof Di != "function" ? !1 : Pi(Di) === $i;
                };
              }
              ai.exports = mi;
            })
          ),
          /***/
          "./node_modules/is-typed-array/index.js": (
            /*!**********************************************!*\
              !*** ./node_modules/is-typed-array/index.js ***!
              \**********************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! which-typed-array */
                "./node_modules/which-typed-array/index.js"
              );
              ai.exports = function(fi) {
                return !!si(fi);
              };
            })
          ),
          /***/
          "./node_modules/keycode/index.js": (
            /*!***************************************!*\
              !*** ./node_modules/keycode/index.js ***!
              \***************************************/
            /***/
            ((ai, li) => {
              function oi(Ti) {
                if (Ti && typeof Ti == "object") {
                  var vi = Ti.which || Ti.keyCode || Ti.charCode;
                  vi && (Ti = vi);
                }
                if (typeof Ti == "number") return gi[Ti];
                var xi = String(Ti), Si = si[xi.toLowerCase()];
                if (Si) return Si;
                var Si = di[xi.toLowerCase()];
                if (Si) return Si;
                if (xi.length === 1) return xi.charCodeAt(0);
              }
              oi.isEventKey = function(vi, xi) {
                if (vi && typeof vi == "object") {
                  var Si = vi.which || vi.keyCode || vi.charCode;
                  if (Si == null)
                    return !1;
                  if (typeof xi == "string") {
                    var Pi = si[xi.toLowerCase()];
                    if (Pi)
                      return Pi === Si;
                    var Pi = di[xi.toLowerCase()];
                    if (Pi)
                      return Pi === Si;
                  } else if (typeof xi == "number")
                    return xi === Si;
                  return !1;
                }
              }, li = ai.exports = oi;
              var si = li.code = li.codes = {
                backspace: 8,
                tab: 9,
                enter: 13,
                shift: 16,
                ctrl: 17,
                alt: 18,
                "pause/break": 19,
                "caps lock": 20,
                esc: 27,
                space: 32,
                "page up": 33,
                "page down": 34,
                end: 35,
                home: 36,
                left: 37,
                up: 38,
                right: 39,
                down: 40,
                insert: 45,
                delete: 46,
                command: 91,
                "left command": 91,
                "right command": 93,
                "numpad *": 106,
                "numpad +": 107,
                "numpad -": 109,
                "numpad .": 110,
                "numpad /": 111,
                "num lock": 144,
                "scroll lock": 145,
                "my computer": 182,
                "my calculator": 183,
                ";": 186,
                "=": 187,
                ",": 188,
                "-": 189,
                ".": 190,
                "/": 191,
                "`": 192,
                "[": 219,
                "\\": 220,
                "]": 221,
                "'": 222
              }, di = li.aliases = {
                windows: 91,
                "⇧": 16,
                "⌥": 18,
                "⌃": 17,
                "⌘": 91,
                ctl: 17,
                control: 17,
                option: 18,
                pause: 19,
                break: 19,
                caps: 20,
                return: 13,
                escape: 27,
                spc: 32,
                spacebar: 32,
                pgup: 33,
                pgdn: 34,
                ins: 45,
                del: 46,
                cmd: 91
              };
              /*!
               * Programatically add the following
               */
              for (fi = 97; fi < 123; fi++) si[String.fromCharCode(fi)] = fi - 32;
              for (var fi = 48; fi < 58; fi++) si[fi - 48] = fi;
              for (fi = 1; fi < 13; fi++) si["f" + fi] = fi + 111;
              for (fi = 0; fi < 10; fi++) si["numpad " + fi] = fi + 96;
              var gi = li.names = li.title = {};
              for (fi in si) gi[si[fi]] = fi;
              for (var mi in di)
                si[mi] = di[mi];
            })
          ),
          /***/
          "./node_modules/lodash.debounce/index.js": (
            /*!***********************************************!*\
              !*** ./node_modules/lodash.debounce/index.js ***!
              \***********************************************/
            /***/
            ((ai, li, oi) => {
              var si = "Expected a function", di = NaN, fi = "[object Symbol]", gi = /^\s+|\s+$/g, mi = /^[-+]0x[0-9a-f]+$/i, Ti = /^0b[01]+$/i, vi = /^0o[0-7]+$/i, xi = parseInt, Si = typeof oi.g == "object" && oi.g && oi.g.Object === Object && oi.g, Pi = typeof self == "object" && self && self.Object === Object && self, $i = Si || Pi || Function("return this")(), Oi = Object.prototype, Di = Oi.toString, Mi = Math.max, Oo = Math.min, io = function() {
                return $i.Date.now();
              };
              function xo(Ni, Yi, Vo) {
                var No, Ui, jo, Wi, ji, Hi, zo = 0, Lo = !1, sa = !1, Ko = !0;
                if (typeof Ni != "function")
                  throw new TypeError(si);
                Yi = Co(Yi) || 0, fo(Vo) && (Lo = !!Vo.leading, sa = "maxWait" in Vo, jo = sa ? Mi(Co(Vo.maxWait) || 0, Yi) : jo, Ko = "trailing" in Vo ? !!Vo.trailing : Ko);
                function ca(Ss) {
                  var Xa = No, Es = Ui;
                  return No = Ui = void 0, zo = Ss, Wi = Ni.apply(Es, Xa), Wi;
                }
                function pa(Ss) {
                  return zo = Ss, ji = setTimeout(ra, Yi), Lo ? ca(Ss) : Wi;
                }
                function ga(Ss) {
                  var Xa = Ss - Hi, Es = Ss - zo, Rs = Yi - Xa;
                  return sa ? Oo(Rs, jo - Es) : Rs;
                }
                function ia(Ss) {
                  var Xa = Ss - Hi, Es = Ss - zo;
                  return Hi === void 0 || Xa >= Yi || Xa < 0 || sa && Es >= jo;
                }
                function ra() {
                  var Ss = io();
                  if (ia(Ss))
                    return qo(Ss);
                  ji = setTimeout(ra, ga(Ss));
                }
                function qo(Ss) {
                  return ji = void 0, Ko && No ? ca(Ss) : (No = Ui = void 0, Wi);
                }
                function xa() {
                  ji !== void 0 && clearTimeout(ji), zo = 0, No = Hi = Ui = ji = void 0;
                }
                function $a() {
                  return ji === void 0 ? Wi : qo(io());
                }
                function ys() {
                  var Ss = io(), Xa = ia(Ss);
                  if (No = arguments, Ui = this, Hi = Ss, Xa) {
                    if (ji === void 0)
                      return pa(Hi);
                    if (sa)
                      return ji = setTimeout(ra, Yi), ca(Hi);
                  }
                  return ji === void 0 && (ji = setTimeout(ra, Yi)), Wi;
                }
                return ys.cancel = xa, ys.flush = $a, ys;
              }
              function fo(Ni) {
                var Yi = typeof Ni;
                return !!Ni && (Yi == "object" || Yi == "function");
              }
              function _o(Ni) {
                return !!Ni && typeof Ni == "object";
              }
              function Li(Ni) {
                return typeof Ni == "symbol" || _o(Ni) && Di.call(Ni) == fi;
              }
              function Co(Ni) {
                if (typeof Ni == "number")
                  return Ni;
                if (Li(Ni))
                  return di;
                if (fo(Ni)) {
                  var Yi = typeof Ni.valueOf == "function" ? Ni.valueOf() : Ni;
                  Ni = fo(Yi) ? Yi + "" : Yi;
                }
                if (typeof Ni != "string")
                  return Ni === 0 ? Ni : +Ni;
                Ni = Ni.replace(gi, "");
                var Vo = Ti.test(Ni);
                return Vo || vi.test(Ni) ? xi(Ni.slice(2), Vo ? 2 : 8) : mi.test(Ni) ? di : +Ni;
              }
              ai.exports = xo;
            })
          ),
          /***/
          "./node_modules/m3u8-parser/dist/m3u8-parser.es.js": (
            /*!*********************************************************!*\
              !*** ./node_modules/m3u8-parser/dist/m3u8-parser.es.js ***!
              \*********************************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                LineStream: () => (
                  /* binding */
                  Ti
                ),
                /* harmony export */
                ParseStream: () => (
                  /* binding */
                  $i
                ),
                /* harmony export */
                Parser: () => (
                  /* binding */
                  Oo
                )
                /* harmony export */
              });
              var si = oi(
                /*! @babel/runtime/helpers/inheritsLoose */
                "./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js"
              ), di = oi(
                /*! @videojs/vhs-utils/es/stream.js */
                "./node_modules/@videojs/vhs-utils/es/stream.js"
              ), fi = oi(
                /*! @babel/runtime/helpers/extends */
                "./node_modules/@babel/runtime/helpers/esm/extends.js"
              ), gi = oi(
                /*! @babel/runtime/helpers/assertThisInitialized */
                "./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js"
              ), mi = oi(
                /*! @videojs/vhs-utils/es/decode-b64-to-uint8-array.js */
                "./node_modules/@videojs/vhs-utils/es/decode-b64-to-uint8-array.js"
              );
              /*! @name m3u8-parser @version 4.8.0 @license Apache-2.0 */
              var Ti = /* @__PURE__ */ (function(io) {
                (0, si.default)(xo, io);
                function xo() {
                  var _o;
                  return _o = io.call(this) || this, _o.buffer = "", _o;
                }
                var fo = xo.prototype;
                return fo.push = function(Li) {
                  var Co;
                  for (this.buffer += Li, Co = this.buffer.indexOf(`
`); Co > -1; Co = this.buffer.indexOf(`
`))
                    this.trigger("data", this.buffer.substring(0, Co)), this.buffer = this.buffer.substring(Co + 1);
                }, xo;
              })(di.default), vi = "	", xi = function(xo) {
                var fo = /([0-9.]*)?@?([0-9.]*)?/.exec(xo || ""), _o = {};
                return fo[1] && (_o.length = parseInt(fo[1], 10)), fo[2] && (_o.offset = parseInt(fo[2], 10)), _o;
              }, Si = function() {
                var xo = "[^=]*", fo = '"[^"]*"|[^,]*', _o = "(?:" + xo + ")=(?:" + fo + ")";
                return new RegExp("(?:^|,)(" + _o + ")");
              }, Pi = function(xo) {
                for (var fo = xo.split(Si()), _o = {}, Li = fo.length, Co; Li--; )
                  fo[Li] !== "" && (Co = /([^=]*)=(.*)/.exec(fo[Li]).slice(1), Co[0] = Co[0].replace(/^\s+|\s+$/g, ""), Co[1] = Co[1].replace(/^\s+|\s+$/g, ""), Co[1] = Co[1].replace(/^['"](.*)['"]$/g, "$1"), _o[Co[0]] = Co[1]);
                return _o;
              }, $i = /* @__PURE__ */ (function(io) {
                (0, si.default)(xo, io);
                function xo() {
                  var _o;
                  return _o = io.call(this) || this, _o.customParsers = [], _o.tagMappers = [], _o;
                }
                var fo = xo.prototype;
                return fo.push = function(Li) {
                  var Co = this, Ni, Yi;
                  if (Li = Li.trim(), Li.length !== 0) {
                    if (Li[0] !== "#") {
                      this.trigger("data", {
                        type: "uri",
                        uri: Li
                      });
                      return;
                    }
                    var Vo = this.tagMappers.reduce(function(No, Ui) {
                      var jo = Ui(Li);
                      return jo === Li ? No : No.concat([jo]);
                    }, [Li]);
                    Vo.forEach(function(No) {
                      for (var Ui = 0; Ui < Co.customParsers.length; Ui++)
                        if (Co.customParsers[Ui].call(Co, No))
                          return;
                      if (No.indexOf("#EXT") !== 0) {
                        Co.trigger("data", {
                          type: "comment",
                          text: No.slice(1)
                        });
                        return;
                      }
                      if (No = No.replace("\r", ""), Ni = /^#EXTM3U/.exec(No), Ni) {
                        Co.trigger("data", {
                          type: "tag",
                          tagType: "m3u"
                        });
                        return;
                      }
                      if (Ni = /^#EXTINF:?([0-9\.]*)?,?(.*)?$/.exec(No), Ni) {
                        Yi = {
                          type: "tag",
                          tagType: "inf"
                        }, Ni[1] && (Yi.duration = parseFloat(Ni[1])), Ni[2] && (Yi.title = Ni[2]), Co.trigger("data", Yi);
                        return;
                      }
                      if (Ni = /^#EXT-X-TARGETDURATION:?([0-9.]*)?/.exec(No), Ni) {
                        Yi = {
                          type: "tag",
                          tagType: "targetduration"
                        }, Ni[1] && (Yi.duration = parseInt(Ni[1], 10)), Co.trigger("data", Yi);
                        return;
                      }
                      if (Ni = /^#EXT-X-VERSION:?([0-9.]*)?/.exec(No), Ni) {
                        Yi = {
                          type: "tag",
                          tagType: "version"
                        }, Ni[1] && (Yi.version = parseInt(Ni[1], 10)), Co.trigger("data", Yi);
                        return;
                      }
                      if (Ni = /^#EXT-X-MEDIA-SEQUENCE:?(\-?[0-9.]*)?/.exec(No), Ni) {
                        Yi = {
                          type: "tag",
                          tagType: "media-sequence"
                        }, Ni[1] && (Yi.number = parseInt(Ni[1], 10)), Co.trigger("data", Yi);
                        return;
                      }
                      if (Ni = /^#EXT-X-DISCONTINUITY-SEQUENCE:?(\-?[0-9.]*)?/.exec(No), Ni) {
                        Yi = {
                          type: "tag",
                          tagType: "discontinuity-sequence"
                        }, Ni[1] && (Yi.number = parseInt(Ni[1], 10)), Co.trigger("data", Yi);
                        return;
                      }
                      if (Ni = /^#EXT-X-PLAYLIST-TYPE:?(.*)?$/.exec(No), Ni) {
                        Yi = {
                          type: "tag",
                          tagType: "playlist-type"
                        }, Ni[1] && (Yi.playlistType = Ni[1]), Co.trigger("data", Yi);
                        return;
                      }
                      if (Ni = /^#EXT-X-BYTERANGE:?(.*)?$/.exec(No), Ni) {
                        Yi = (0, fi.default)(xi(Ni[1]), {
                          type: "tag",
                          tagType: "byterange"
                        }), Co.trigger("data", Yi);
                        return;
                      }
                      if (Ni = /^#EXT-X-ALLOW-CACHE:?(YES|NO)?/.exec(No), Ni) {
                        Yi = {
                          type: "tag",
                          tagType: "allow-cache"
                        }, Ni[1] && (Yi.allowed = !/NO/.test(Ni[1])), Co.trigger("data", Yi);
                        return;
                      }
                      if (Ni = /^#EXT-X-MAP:?(.*)$/.exec(No), Ni) {
                        if (Yi = {
                          type: "tag",
                          tagType: "map"
                        }, Ni[1]) {
                          var jo = Pi(Ni[1]);
                          jo.URI && (Yi.uri = jo.URI), jo.BYTERANGE && (Yi.byterange = xi(jo.BYTERANGE));
                        }
                        Co.trigger("data", Yi);
                        return;
                      }
                      if (Ni = /^#EXT-X-STREAM-INF:?(.*)$/.exec(No), Ni) {
                        if (Yi = {
                          type: "tag",
                          tagType: "stream-inf"
                        }, Ni[1]) {
                          if (Yi.attributes = Pi(Ni[1]), Yi.attributes.RESOLUTION) {
                            var Wi = Yi.attributes.RESOLUTION.split("x"), ji = {};
                            Wi[0] && (ji.width = parseInt(Wi[0], 10)), Wi[1] && (ji.height = parseInt(Wi[1], 10)), Yi.attributes.RESOLUTION = ji;
                          }
                          Yi.attributes.BANDWIDTH && (Yi.attributes.BANDWIDTH = parseInt(Yi.attributes.BANDWIDTH, 10)), Yi.attributes["FRAME-RATE"] && (Yi.attributes["FRAME-RATE"] = parseFloat(Yi.attributes["FRAME-RATE"])), Yi.attributes["PROGRAM-ID"] && (Yi.attributes["PROGRAM-ID"] = parseInt(Yi.attributes["PROGRAM-ID"], 10));
                        }
                        Co.trigger("data", Yi);
                        return;
                      }
                      if (Ni = /^#EXT-X-MEDIA:?(.*)$/.exec(No), Ni) {
                        Yi = {
                          type: "tag",
                          tagType: "media"
                        }, Ni[1] && (Yi.attributes = Pi(Ni[1])), Co.trigger("data", Yi);
                        return;
                      }
                      if (Ni = /^#EXT-X-ENDLIST/.exec(No), Ni) {
                        Co.trigger("data", {
                          type: "tag",
                          tagType: "endlist"
                        });
                        return;
                      }
                      if (Ni = /^#EXT-X-DISCONTINUITY/.exec(No), Ni) {
                        Co.trigger("data", {
                          type: "tag",
                          tagType: "discontinuity"
                        });
                        return;
                      }
                      if (Ni = /^#EXT-X-PROGRAM-DATE-TIME:?(.*)$/.exec(No), Ni) {
                        Yi = {
                          type: "tag",
                          tagType: "program-date-time"
                        }, Ni[1] && (Yi.dateTimeString = Ni[1], Yi.dateTimeObject = new Date(Ni[1])), Co.trigger("data", Yi);
                        return;
                      }
                      if (Ni = /^#EXT-X-KEY:?(.*)$/.exec(No), Ni) {
                        Yi = {
                          type: "tag",
                          tagType: "key"
                        }, Ni[1] && (Yi.attributes = Pi(Ni[1]), Yi.attributes.IV && (Yi.attributes.IV.substring(0, 2).toLowerCase() === "0x" && (Yi.attributes.IV = Yi.attributes.IV.substring(2)), Yi.attributes.IV = Yi.attributes.IV.match(/.{8}/g), Yi.attributes.IV[0] = parseInt(Yi.attributes.IV[0], 16), Yi.attributes.IV[1] = parseInt(Yi.attributes.IV[1], 16), Yi.attributes.IV[2] = parseInt(Yi.attributes.IV[2], 16), Yi.attributes.IV[3] = parseInt(Yi.attributes.IV[3], 16), Yi.attributes.IV = new Uint32Array(Yi.attributes.IV))), Co.trigger("data", Yi);
                        return;
                      }
                      if (Ni = /^#EXT-X-START:?(.*)$/.exec(No), Ni) {
                        Yi = {
                          type: "tag",
                          tagType: "start"
                        }, Ni[1] && (Yi.attributes = Pi(Ni[1]), Yi.attributes["TIME-OFFSET"] = parseFloat(Yi.attributes["TIME-OFFSET"]), Yi.attributes.PRECISE = /YES/.test(Yi.attributes.PRECISE)), Co.trigger("data", Yi);
                        return;
                      }
                      if (Ni = /^#EXT-X-CUE-OUT-CONT:?(.*)?$/.exec(No), Ni) {
                        Yi = {
                          type: "tag",
                          tagType: "cue-out-cont"
                        }, Ni[1] ? Yi.data = Ni[1] : Yi.data = "", Co.trigger("data", Yi);
                        return;
                      }
                      if (Ni = /^#EXT-X-CUE-OUT:?(.*)?$/.exec(No), Ni) {
                        Yi = {
                          type: "tag",
                          tagType: "cue-out"
                        }, Ni[1] ? Yi.data = Ni[1] : Yi.data = "", Co.trigger("data", Yi);
                        return;
                      }
                      if (Ni = /^#EXT-X-CUE-IN:?(.*)?$/.exec(No), Ni) {
                        Yi = {
                          type: "tag",
                          tagType: "cue-in"
                        }, Ni[1] ? Yi.data = Ni[1] : Yi.data = "", Co.trigger("data", Yi);
                        return;
                      }
                      if (Ni = /^#EXT-X-SKIP:(.*)$/.exec(No), Ni && Ni[1]) {
                        Yi = {
                          type: "tag",
                          tagType: "skip"
                        }, Yi.attributes = Pi(Ni[1]), Yi.attributes.hasOwnProperty("SKIPPED-SEGMENTS") && (Yi.attributes["SKIPPED-SEGMENTS"] = parseInt(Yi.attributes["SKIPPED-SEGMENTS"], 10)), Yi.attributes.hasOwnProperty("RECENTLY-REMOVED-DATERANGES") && (Yi.attributes["RECENTLY-REMOVED-DATERANGES"] = Yi.attributes["RECENTLY-REMOVED-DATERANGES"].split(vi)), Co.trigger("data", Yi);
                        return;
                      }
                      if (Ni = /^#EXT-X-PART:(.*)$/.exec(No), Ni && Ni[1]) {
                        Yi = {
                          type: "tag",
                          tagType: "part"
                        }, Yi.attributes = Pi(Ni[1]), ["DURATION"].forEach(function(Hi) {
                          Yi.attributes.hasOwnProperty(Hi) && (Yi.attributes[Hi] = parseFloat(Yi.attributes[Hi]));
                        }), ["INDEPENDENT", "GAP"].forEach(function(Hi) {
                          Yi.attributes.hasOwnProperty(Hi) && (Yi.attributes[Hi] = /YES/.test(Yi.attributes[Hi]));
                        }), Yi.attributes.hasOwnProperty("BYTERANGE") && (Yi.attributes.byterange = xi(Yi.attributes.BYTERANGE)), Co.trigger("data", Yi);
                        return;
                      }
                      if (Ni = /^#EXT-X-SERVER-CONTROL:(.*)$/.exec(No), Ni && Ni[1]) {
                        Yi = {
                          type: "tag",
                          tagType: "server-control"
                        }, Yi.attributes = Pi(Ni[1]), ["CAN-SKIP-UNTIL", "PART-HOLD-BACK", "HOLD-BACK"].forEach(function(Hi) {
                          Yi.attributes.hasOwnProperty(Hi) && (Yi.attributes[Hi] = parseFloat(Yi.attributes[Hi]));
                        }), ["CAN-SKIP-DATERANGES", "CAN-BLOCK-RELOAD"].forEach(function(Hi) {
                          Yi.attributes.hasOwnProperty(Hi) && (Yi.attributes[Hi] = /YES/.test(Yi.attributes[Hi]));
                        }), Co.trigger("data", Yi);
                        return;
                      }
                      if (Ni = /^#EXT-X-PART-INF:(.*)$/.exec(No), Ni && Ni[1]) {
                        Yi = {
                          type: "tag",
                          tagType: "part-inf"
                        }, Yi.attributes = Pi(Ni[1]), ["PART-TARGET"].forEach(function(Hi) {
                          Yi.attributes.hasOwnProperty(Hi) && (Yi.attributes[Hi] = parseFloat(Yi.attributes[Hi]));
                        }), Co.trigger("data", Yi);
                        return;
                      }
                      if (Ni = /^#EXT-X-PRELOAD-HINT:(.*)$/.exec(No), Ni && Ni[1]) {
                        Yi = {
                          type: "tag",
                          tagType: "preload-hint"
                        }, Yi.attributes = Pi(Ni[1]), ["BYTERANGE-START", "BYTERANGE-LENGTH"].forEach(function(Hi) {
                          if (Yi.attributes.hasOwnProperty(Hi)) {
                            Yi.attributes[Hi] = parseInt(Yi.attributes[Hi], 10);
                            var zo = Hi === "BYTERANGE-LENGTH" ? "length" : "offset";
                            Yi.attributes.byterange = Yi.attributes.byterange || {}, Yi.attributes.byterange[zo] = Yi.attributes[Hi], delete Yi.attributes[Hi];
                          }
                        }), Co.trigger("data", Yi);
                        return;
                      }
                      if (Ni = /^#EXT-X-RENDITION-REPORT:(.*)$/.exec(No), Ni && Ni[1]) {
                        Yi = {
                          type: "tag",
                          tagType: "rendition-report"
                        }, Yi.attributes = Pi(Ni[1]), ["LAST-MSN", "LAST-PART"].forEach(function(Hi) {
                          Yi.attributes.hasOwnProperty(Hi) && (Yi.attributes[Hi] = parseInt(Yi.attributes[Hi], 10));
                        }), Co.trigger("data", Yi);
                        return;
                      }
                      Co.trigger("data", {
                        type: "tag",
                        data: No.slice(4)
                      });
                    });
                  }
                }, fo.addParser = function(Li) {
                  var Co = this, Ni = Li.expression, Yi = Li.customType, Vo = Li.dataParser, No = Li.segment;
                  typeof Vo != "function" && (Vo = function(jo) {
                    return jo;
                  }), this.customParsers.push(function(Ui) {
                    var jo = Ni.exec(Ui);
                    if (jo)
                      return Co.trigger("data", {
                        type: "custom",
                        data: Vo(Ui),
                        customType: Yi,
                        segment: No
                      }), !0;
                  });
                }, fo.addTagMapper = function(Li) {
                  var Co = Li.expression, Ni = Li.map, Yi = function(No) {
                    return Co.test(No) ? Ni(No) : No;
                  };
                  this.tagMappers.push(Yi);
                }, xo;
              })(di.default), Oi = function(xo) {
                return xo.toLowerCase().replace(/-(\w)/g, function(fo) {
                  return fo[1].toUpperCase();
                });
              }, Di = function(xo) {
                var fo = {};
                return Object.keys(xo).forEach(function(_o) {
                  fo[Oi(_o)] = xo[_o];
                }), fo;
              }, Mi = function(xo) {
                var fo = xo.serverControl, _o = xo.targetDuration, Li = xo.partTargetDuration;
                if (fo) {
                  var Co = "#EXT-X-SERVER-CONTROL", Ni = "holdBack", Yi = "partHoldBack", Vo = _o && _o * 3, No = Li && Li * 2;
                  _o && !fo.hasOwnProperty(Ni) && (fo[Ni] = Vo, this.trigger("info", {
                    message: Co + " defaulting HOLD-BACK to targetDuration * 3 (" + Vo + ")."
                  })), Vo && fo[Ni] < Vo && (this.trigger("warn", {
                    message: Co + " clamping HOLD-BACK (" + fo[Ni] + ") to targetDuration * 3 (" + Vo + ")"
                  }), fo[Ni] = Vo), Li && !fo.hasOwnProperty(Yi) && (fo[Yi] = Li * 3, this.trigger("info", {
                    message: Co + " defaulting PART-HOLD-BACK to partTargetDuration * 3 (" + fo[Yi] + ")."
                  })), Li && fo[Yi] < No && (this.trigger("warn", {
                    message: Co + " clamping PART-HOLD-BACK (" + fo[Yi] + ") to partTargetDuration * 2 (" + No + ")."
                  }), fo[Yi] = No);
                }
              }, Oo = /* @__PURE__ */ (function(io) {
                (0, si.default)(xo, io);
                function xo() {
                  var _o;
                  _o = io.call(this) || this, _o.lineStream = new Ti(), _o.parseStream = new $i(), _o.lineStream.pipe(_o.parseStream);
                  var Li = (0, gi.default)(_o), Co = [], Ni = {}, Yi, Vo, No = !1, Ui = function() {
                  }, jo = {
                    AUDIO: {},
                    VIDEO: {},
                    "CLOSED-CAPTIONS": {},
                    SUBTITLES: {}
                  }, Wi = "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed", ji = 0;
                  _o.manifest = {
                    allowCache: !0,
                    discontinuityStarts: [],
                    segments: []
                  };
                  var Hi = 0, zo = 0;
                  return _o.on("end", function() {
                    Ni.uri || !Ni.parts && !Ni.preloadHints || (!Ni.map && Yi && (Ni.map = Yi), !Ni.key && Vo && (Ni.key = Vo), !Ni.timeline && typeof ji == "number" && (Ni.timeline = ji), _o.manifest.preloadSegment = Ni);
                  }), _o.parseStream.on("data", function(Lo) {
                    var sa, Ko;
                    ({
                      tag: function() {
                        ({
                          version: function() {
                            Lo.version && (this.manifest.version = Lo.version);
                          },
                          "allow-cache": function() {
                            this.manifest.allowCache = Lo.allowed, "allowed" in Lo || (this.trigger("info", {
                              message: "defaulting allowCache to YES"
                            }), this.manifest.allowCache = !0);
                          },
                          byterange: function() {
                            var ga = {};
                            "length" in Lo && (Ni.byterange = ga, ga.length = Lo.length, "offset" in Lo || (Lo.offset = Hi)), "offset" in Lo && (Ni.byterange = ga, ga.offset = Lo.offset), Hi = ga.offset + ga.length;
                          },
                          endlist: function() {
                            this.manifest.endList = !0;
                          },
                          inf: function() {
                            "mediaSequence" in this.manifest || (this.manifest.mediaSequence = 0, this.trigger("info", {
                              message: "defaulting media sequence to zero"
                            })), "discontinuitySequence" in this.manifest || (this.manifest.discontinuitySequence = 0, this.trigger("info", {
                              message: "defaulting discontinuity sequence to zero"
                            })), Lo.duration > 0 && (Ni.duration = Lo.duration), Lo.duration === 0 && (Ni.duration = 0.01, this.trigger("info", {
                              message: "updating zero segment duration to a small value"
                            })), this.manifest.segments = Co;
                          },
                          key: function() {
                            if (!Lo.attributes) {
                              this.trigger("warn", {
                                message: "ignoring key declaration without attribute list"
                              });
                              return;
                            }
                            if (Lo.attributes.METHOD === "NONE") {
                              Vo = null;
                              return;
                            }
                            if (!Lo.attributes.URI) {
                              this.trigger("warn", {
                                message: "ignoring key declaration without URI"
                              });
                              return;
                            }
                            if (Lo.attributes.KEYFORMAT === "com.apple.streamingkeydelivery") {
                              this.manifest.contentProtection = this.manifest.contentProtection || {}, this.manifest.contentProtection["com.apple.fps.1_0"] = {
                                attributes: Lo.attributes
                              };
                              return;
                            }
                            if (Lo.attributes.KEYFORMAT === "com.microsoft.playready") {
                              this.manifest.contentProtection = this.manifest.contentProtection || {}, this.manifest.contentProtection["com.microsoft.playready"] = {
                                uri: Lo.attributes.URI
                              };
                              return;
                            }
                            if (Lo.attributes.KEYFORMAT === Wi) {
                              var ga = ["SAMPLE-AES", "SAMPLE-AES-CTR", "SAMPLE-AES-CENC"];
                              if (ga.indexOf(Lo.attributes.METHOD) === -1) {
                                this.trigger("warn", {
                                  message: "invalid key method provided for Widevine"
                                });
                                return;
                              }
                              if (Lo.attributes.METHOD === "SAMPLE-AES-CENC" && this.trigger("warn", {
                                message: "SAMPLE-AES-CENC is deprecated, please use SAMPLE-AES-CTR instead"
                              }), Lo.attributes.URI.substring(0, 23) !== "data:text/plain;base64,") {
                                this.trigger("warn", {
                                  message: "invalid key URI provided for Widevine"
                                });
                                return;
                              }
                              if (!(Lo.attributes.KEYID && Lo.attributes.KEYID.substring(0, 2) === "0x")) {
                                this.trigger("warn", {
                                  message: "invalid key ID provided for Widevine"
                                });
                                return;
                              }
                              this.manifest.contentProtection = this.manifest.contentProtection || {}, this.manifest.contentProtection["com.widevine.alpha"] = {
                                attributes: {
                                  schemeIdUri: Lo.attributes.KEYFORMAT,
                                  // remove '0x' from the key id string
                                  keyId: Lo.attributes.KEYID.substring(2)
                                },
                                // decode the base64-encoded PSSH box
                                pssh: (0, mi.default)(Lo.attributes.URI.split(",")[1])
                              };
                              return;
                            }
                            Lo.attributes.METHOD || this.trigger("warn", {
                              message: "defaulting key method to AES-128"
                            }), Vo = {
                              method: Lo.attributes.METHOD || "AES-128",
                              uri: Lo.attributes.URI
                            }, typeof Lo.attributes.IV < "u" && (Vo.iv = Lo.attributes.IV);
                          },
                          "media-sequence": function() {
                            if (!isFinite(Lo.number)) {
                              this.trigger("warn", {
                                message: "ignoring invalid media sequence: " + Lo.number
                              });
                              return;
                            }
                            this.manifest.mediaSequence = Lo.number;
                          },
                          "discontinuity-sequence": function() {
                            if (!isFinite(Lo.number)) {
                              this.trigger("warn", {
                                message: "ignoring invalid discontinuity sequence: " + Lo.number
                              });
                              return;
                            }
                            this.manifest.discontinuitySequence = Lo.number, ji = Lo.number;
                          },
                          "playlist-type": function() {
                            if (!/VOD|EVENT/.test(Lo.playlistType)) {
                              this.trigger("warn", {
                                message: "ignoring unknown playlist type: " + Lo.playlist
                              });
                              return;
                            }
                            this.manifest.playlistType = Lo.playlistType;
                          },
                          map: function() {
                            Yi = {}, Lo.uri && (Yi.uri = Lo.uri), Lo.byterange && (Yi.byterange = Lo.byterange), Vo && (Yi.key = Vo);
                          },
                          "stream-inf": function() {
                            if (this.manifest.playlists = Co, this.manifest.mediaGroups = this.manifest.mediaGroups || jo, !Lo.attributes) {
                              this.trigger("warn", {
                                message: "ignoring empty stream-inf attributes"
                              });
                              return;
                            }
                            Ni.attributes || (Ni.attributes = {}), (0, fi.default)(Ni.attributes, Lo.attributes);
                          },
                          media: function() {
                            if (this.manifest.mediaGroups = this.manifest.mediaGroups || jo, !(Lo.attributes && Lo.attributes.TYPE && Lo.attributes["GROUP-ID"] && Lo.attributes.NAME)) {
                              this.trigger("warn", {
                                message: "ignoring incomplete or missing media group"
                              });
                              return;
                            }
                            var ga = this.manifest.mediaGroups[Lo.attributes.TYPE];
                            ga[Lo.attributes["GROUP-ID"]] = ga[Lo.attributes["GROUP-ID"]] || {}, sa = ga[Lo.attributes["GROUP-ID"]], Ko = {
                              default: /yes/i.test(Lo.attributes.DEFAULT)
                            }, Ko.default ? Ko.autoselect = !0 : Ko.autoselect = /yes/i.test(Lo.attributes.AUTOSELECT), Lo.attributes.LANGUAGE && (Ko.language = Lo.attributes.LANGUAGE), Lo.attributes.URI && (Ko.uri = Lo.attributes.URI), Lo.attributes["INSTREAM-ID"] && (Ko.instreamId = Lo.attributes["INSTREAM-ID"]), Lo.attributes.CHARACTERISTICS && (Ko.characteristics = Lo.attributes.CHARACTERISTICS), Lo.attributes.FORCED && (Ko.forced = /yes/i.test(Lo.attributes.FORCED)), sa[Lo.attributes.NAME] = Ko;
                          },
                          discontinuity: function() {
                            ji += 1, Ni.discontinuity = !0, this.manifest.discontinuityStarts.push(Co.length);
                          },
                          "program-date-time": function() {
                            typeof this.manifest.dateTimeString > "u" && (this.manifest.dateTimeString = Lo.dateTimeString, this.manifest.dateTimeObject = Lo.dateTimeObject), Ni.dateTimeString = Lo.dateTimeString, Ni.dateTimeObject = Lo.dateTimeObject;
                          },
                          targetduration: function() {
                            if (!isFinite(Lo.duration) || Lo.duration < 0) {
                              this.trigger("warn", {
                                message: "ignoring invalid target duration: " + Lo.duration
                              });
                              return;
                            }
                            this.manifest.targetDuration = Lo.duration, Mi.call(this, this.manifest);
                          },
                          start: function() {
                            if (!Lo.attributes || isNaN(Lo.attributes["TIME-OFFSET"])) {
                              this.trigger("warn", {
                                message: "ignoring start declaration without appropriate attribute list"
                              });
                              return;
                            }
                            this.manifest.start = {
                              timeOffset: Lo.attributes["TIME-OFFSET"],
                              precise: Lo.attributes.PRECISE
                            };
                          },
                          "cue-out": function() {
                            Ni.cueOut = Lo.data;
                          },
                          "cue-out-cont": function() {
                            Ni.cueOutCont = Lo.data;
                          },
                          "cue-in": function() {
                            Ni.cueIn = Lo.data;
                          },
                          skip: function() {
                            this.manifest.skip = Di(Lo.attributes), this.warnOnMissingAttributes_("#EXT-X-SKIP", Lo.attributes, ["SKIPPED-SEGMENTS"]);
                          },
                          part: function() {
                            var ga = this;
                            No = !0;
                            var ia = this.manifest.segments.length, ra = Di(Lo.attributes);
                            Ni.parts = Ni.parts || [], Ni.parts.push(ra), ra.byterange && (ra.byterange.hasOwnProperty("offset") || (ra.byterange.offset = zo), zo = ra.byterange.offset + ra.byterange.length);
                            var qo = Ni.parts.length - 1;
                            this.warnOnMissingAttributes_("#EXT-X-PART #" + qo + " for segment #" + ia, Lo.attributes, ["URI", "DURATION"]), this.manifest.renditionReports && this.manifest.renditionReports.forEach(function(xa, $a) {
                              xa.hasOwnProperty("lastPart") || ga.trigger("warn", {
                                message: "#EXT-X-RENDITION-REPORT #" + $a + " lacks required attribute(s): LAST-PART"
                              });
                            });
                          },
                          "server-control": function() {
                            var ga = this.manifest.serverControl = Di(Lo.attributes);
                            ga.hasOwnProperty("canBlockReload") || (ga.canBlockReload = !1, this.trigger("info", {
                              message: "#EXT-X-SERVER-CONTROL defaulting CAN-BLOCK-RELOAD to false"
                            })), Mi.call(this, this.manifest), ga.canSkipDateranges && !ga.hasOwnProperty("canSkipUntil") && this.trigger("warn", {
                              message: "#EXT-X-SERVER-CONTROL lacks required attribute CAN-SKIP-UNTIL which is required when CAN-SKIP-DATERANGES is set"
                            });
                          },
                          "preload-hint": function() {
                            var ga = this.manifest.segments.length, ia = Di(Lo.attributes), ra = ia.type && ia.type === "PART";
                            Ni.preloadHints = Ni.preloadHints || [], Ni.preloadHints.push(ia), ia.byterange && (ia.byterange.hasOwnProperty("offset") || (ia.byterange.offset = ra ? zo : 0, ra && (zo = ia.byterange.offset + ia.byterange.length)));
                            var qo = Ni.preloadHints.length - 1;
                            if (this.warnOnMissingAttributes_("#EXT-X-PRELOAD-HINT #" + qo + " for segment #" + ga, Lo.attributes, ["TYPE", "URI"]), !!ia.type)
                              for (var xa = 0; xa < Ni.preloadHints.length - 1; xa++) {
                                var $a = Ni.preloadHints[xa];
                                $a.type && $a.type === ia.type && this.trigger("warn", {
                                  message: "#EXT-X-PRELOAD-HINT #" + qo + " for segment #" + ga + " has the same TYPE " + ia.type + " as preload hint #" + xa
                                });
                              }
                          },
                          "rendition-report": function() {
                            var ga = Di(Lo.attributes);
                            this.manifest.renditionReports = this.manifest.renditionReports || [], this.manifest.renditionReports.push(ga);
                            var ia = this.manifest.renditionReports.length - 1, ra = ["LAST-MSN", "URI"];
                            No && ra.push("LAST-PART"), this.warnOnMissingAttributes_("#EXT-X-RENDITION-REPORT #" + ia, Lo.attributes, ra);
                          },
                          "part-inf": function() {
                            this.manifest.partInf = Di(Lo.attributes), this.warnOnMissingAttributes_("#EXT-X-PART-INF", Lo.attributes, ["PART-TARGET"]), this.manifest.partInf.partTarget && (this.manifest.partTargetDuration = this.manifest.partInf.partTarget), Mi.call(this, this.manifest);
                          }
                        }[Lo.tagType] || Ui).call(Li);
                      },
                      uri: function() {
                        Ni.uri = Lo.uri, Co.push(Ni), this.manifest.targetDuration && !("duration" in Ni) && (this.trigger("warn", {
                          message: "defaulting segment duration to the target duration"
                        }), Ni.duration = this.manifest.targetDuration), Vo && (Ni.key = Vo), Ni.timeline = ji, Yi && (Ni.map = Yi), zo = 0, Ni = {};
                      },
                      comment: function() {
                      },
                      custom: function() {
                        Lo.segment ? (Ni.custom = Ni.custom || {}, Ni.custom[Lo.customType] = Lo.data) : (this.manifest.custom = this.manifest.custom || {}, this.manifest.custom[Lo.customType] = Lo.data);
                      }
                    })[Lo.type].call(Li);
                  }), _o;
                }
                var fo = xo.prototype;
                return fo.warnOnMissingAttributes_ = function(Li, Co, Ni) {
                  var Yi = [];
                  Ni.forEach(function(Vo) {
                    Co.hasOwnProperty(Vo) || Yi.push(Vo);
                  }), Yi.length && this.trigger("warn", {
                    message: Li + " lacks required attribute(s): " + Yi.join(", ")
                  });
                }, fo.push = function(Li) {
                  this.lineStream.push(Li);
                }, fo.end = function() {
                  this.lineStream.push(`
`), this.trigger("end");
                }, fo.addParser = function(Li) {
                  this.parseStream.addParser(Li);
                }, fo.addTagMapper = function(Li) {
                  this.parseStream.addTagMapper(Li);
                }, xo;
              })(di.default);
            })
          ),
          /***/
          "./node_modules/math-intrinsics/abs.js": (
            /*!*********************************************!*\
              !*** ./node_modules/math-intrinsics/abs.js ***!
              \*********************************************/
            /***/
            ((ai) => {
              ai.exports = Math.abs;
            })
          ),
          /***/
          "./node_modules/math-intrinsics/floor.js": (
            /*!***********************************************!*\
              !*** ./node_modules/math-intrinsics/floor.js ***!
              \***********************************************/
            /***/
            ((ai) => {
              ai.exports = Math.floor;
            })
          ),
          /***/
          "./node_modules/math-intrinsics/isNaN.js": (
            /*!***********************************************!*\
              !*** ./node_modules/math-intrinsics/isNaN.js ***!
              \***********************************************/
            /***/
            ((ai) => {
              ai.exports = Number.isNaN || function(oi) {
                return oi !== oi;
              };
            })
          ),
          /***/
          "./node_modules/math-intrinsics/max.js": (
            /*!*********************************************!*\
              !*** ./node_modules/math-intrinsics/max.js ***!
              \*********************************************/
            /***/
            ((ai) => {
              ai.exports = Math.max;
            })
          ),
          /***/
          "./node_modules/math-intrinsics/min.js": (
            /*!*********************************************!*\
              !*** ./node_modules/math-intrinsics/min.js ***!
              \*********************************************/
            /***/
            ((ai) => {
              ai.exports = Math.min;
            })
          ),
          /***/
          "./node_modules/math-intrinsics/pow.js": (
            /*!*********************************************!*\
              !*** ./node_modules/math-intrinsics/pow.js ***!
              \*********************************************/
            /***/
            ((ai) => {
              ai.exports = Math.pow;
            })
          ),
          /***/
          "./node_modules/math-intrinsics/round.js": (
            /*!***********************************************!*\
              !*** ./node_modules/math-intrinsics/round.js ***!
              \***********************************************/
            /***/
            ((ai) => {
              ai.exports = Math.round;
            })
          ),
          /***/
          "./node_modules/math-intrinsics/sign.js": (
            /*!**********************************************!*\
              !*** ./node_modules/math-intrinsics/sign.js ***!
              \**********************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! ./isNaN */
                "./node_modules/math-intrinsics/isNaN.js"
              );
              ai.exports = function(fi) {
                return si(fi) || fi === 0 ? fi : fi < 0 ? -1 : 1;
              };
            })
          ),
          /***/
          "./src/skyline-player.scss": (
            /*!*********************************!*\
              !*** ./src/skyline-player.scss ***!
              \*********************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li);
            })
          ),
          /***/
          "./node_modules/mpd-parser/dist/mpd-parser.es.js": (
            /*!*******************************************************!*\
              !*** ./node_modules/mpd-parser/dist/mpd-parser.es.js ***!
              \*******************************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                VERSION: () => (
                  /* binding */
                  Ws
                ),
                /* harmony export */
                addSidxSegmentsToPlaylist: () => (
                  /* binding */
                  No
                ),
                /* harmony export */
                generateSidxKey: () => (
                  /* binding */
                  Ko
                ),
                /* harmony export */
                inheritAttributes: () => (
                  /* binding */
                  du
                ),
                /* harmony export */
                parse: () => (
                  /* binding */
                  wl
                ),
                /* harmony export */
                parseUTCTiming: () => (
                  /* binding */
                  Gl
                ),
                /* harmony export */
                stringToMpdXml: () => (
                  /* binding */
                  za
                ),
                /* harmony export */
                toM3u8: () => (
                  /* binding */
                  Ja
                ),
                /* harmony export */
                toPlaylists: () => (
                  /* binding */
                  Vs
                )
                /* harmony export */
              });
              var si = oi(
                /*! @videojs/vhs-utils/es/resolve-url */
                "./node_modules/@videojs/vhs-utils/es/resolve-url.js"
              ), di = oi(
                /*! global/window */
                "./node_modules/global/window.js"
              ), fi = /* @__PURE__ */ oi.n(di), gi = oi(
                /*! @videojs/vhs-utils/es/media-groups */
                "./node_modules/@videojs/vhs-utils/es/media-groups.js"
              ), mi = oi(
                /*! @videojs/vhs-utils/es/decode-b64-to-uint8-array */
                "./node_modules/@videojs/vhs-utils/es/decode-b64-to-uint8-array.js"
              ), Ti = oi(
                /*! @xmldom/xmldom */
                "./node_modules/@xmldom/xmldom/lib/index.js"
              );
              /*! @name mpd-parser @version 0.22.1 @license Apache-2.0 */
              var vi = "0.22.1", xi = function(Za) {
                return !!Za && typeof Za == "object";
              }, Si = function bl() {
                for (var Za = arguments.length, rl = new Array(Za), zs = 0; zs < Za; zs++)
                  rl[zs] = arguments[zs];
                return rl.reduce(function(al, Ol) {
                  return typeof Ol != "object" || Object.keys(Ol).forEach(function($l) {
                    Array.isArray(al[$l]) && Array.isArray(Ol[$l]) ? al[$l] = al[$l].concat(Ol[$l]) : xi(al[$l]) && xi(Ol[$l]) ? al[$l] = bl(al[$l], Ol[$l]) : al[$l] = Ol[$l];
                  }), al;
                }, {});
              }, Pi = function(Za) {
                return Object.keys(Za).map(function(rl) {
                  return Za[rl];
                });
              }, $i = function(Za, rl) {
                for (var zs = [], al = Za; al < rl; al++)
                  zs.push(al);
                return zs;
              }, Oi = function(Za) {
                return Za.reduce(function(rl, zs) {
                  return rl.concat(zs);
                }, []);
              }, Di = function(Za) {
                if (!Za.length)
                  return [];
                for (var rl = [], zs = 0; zs < Za.length; zs++)
                  rl.push(Za[zs]);
                return rl;
              }, Mi = function(Za, rl) {
                return Za.reduce(function(zs, al, Ol) {
                  return al[rl] && zs.push(Ol), zs;
                }, []);
              }, Oo = function(Za, rl) {
                for (var zs = 0; zs < Za.length; zs++)
                  if (rl(Za[zs]))
                    return zs;
                return -1;
              }, io = function(Za, rl) {
                return Pi(Za.reduce(function(zs, al) {
                  return al.forEach(function(Ol) {
                    zs[rl(Ol)] = Ol;
                  }), zs;
                }, {}));
              }, xo = {
                INVALID_NUMBER_OF_PERIOD: "INVALID_NUMBER_OF_PERIOD",
                DASH_EMPTY_MANIFEST: "DASH_EMPTY_MANIFEST",
                DASH_INVALID_XML: "DASH_INVALID_XML",
                NO_BASE_URL: "NO_BASE_URL",
                SEGMENT_TIME_UNSPECIFIED: "SEGMENT_TIME_UNSPECIFIED",
                UNSUPPORTED_UTC_TIMING_SCHEME: "UNSUPPORTED_UTC_TIMING_SCHEME"
              }, fo = function(Za) {
                var rl = Za.baseUrl, zs = rl === void 0 ? "" : rl, al = Za.source, Ol = al === void 0 ? "" : al, $l = Za.range, Zl = $l === void 0 ? "" : $l, tu = Za.indexRange, su = tu === void 0 ? "" : tu, dl = {
                  uri: Ol,
                  resolvedUri: (0, si.default)(zs || "", Ol)
                };
                if (Zl || su) {
                  var Su = Zl || su, cu = Su.split("-"), Ru = fi().BigInt ? fi().BigInt(cu[0]) : parseInt(cu[0], 10), bu = fi().BigInt ? fi().BigInt(cu[1]) : parseInt(cu[1], 10);
                  Ru < Number.MAX_SAFE_INTEGER && typeof Ru == "bigint" && (Ru = Number(Ru)), bu < Number.MAX_SAFE_INTEGER && typeof bu == "bigint" && (bu = Number(bu));
                  var Hu;
                  typeof bu == "bigint" || typeof Ru == "bigint" ? Hu = fi().BigInt(bu) - fi().BigInt(Ru) + fi().BigInt(1) : Hu = bu - Ru + 1, typeof Hu == "bigint" && Hu < Number.MAX_SAFE_INTEGER && (Hu = Number(Hu)), dl.byterange = {
                    length: Hu,
                    offset: Ru
                  };
                }
                return dl;
              }, _o = function(Za) {
                var rl;
                return typeof Za.offset == "bigint" || typeof Za.length == "bigint" ? rl = fi().BigInt(Za.offset) + fi().BigInt(Za.length) - fi().BigInt(1) : rl = Za.offset + Za.length - 1, Za.offset + "-" + rl;
              }, Li = function(Za) {
                return Za && typeof Za != "number" && (Za = parseInt(Za, 10)), isNaN(Za) ? null : Za;
              }, Co = {
                /**
                 * Returns the entire range of available segments for a static MPD
                 *
                 * @param {Object} attributes
                 *        Inheritied MPD attributes
                 * @return {{ start: number, end: number }}
                 *         The start and end numbers for available segments
                 */
                static: function(Za) {
                  var rl = Za.duration, zs = Za.timescale, al = zs === void 0 ? 1 : zs, Ol = Za.sourceDuration, $l = Za.periodDuration, Zl = Li(Za.endNumber), tu = rl / al;
                  return typeof Zl == "number" ? {
                    start: 0,
                    end: Zl
                  } : typeof $l == "number" ? {
                    start: 0,
                    end: $l / tu
                  } : {
                    start: 0,
                    end: Ol / tu
                  };
                },
                /**
                 * Returns the current live window range of available segments for a dynamic MPD
                 *
                 * @param {Object} attributes
                 *        Inheritied MPD attributes
                 * @return {{ start: number, end: number }}
                 *         The start and end numbers for available segments
                 */
                dynamic: function(Za) {
                  var rl = Za.NOW, zs = Za.clientOffset, al = Za.availabilityStartTime, Ol = Za.timescale, $l = Ol === void 0 ? 1 : Ol, Zl = Za.duration, tu = Za.periodStart, su = tu === void 0 ? 0 : tu, dl = Za.minimumUpdatePeriod, Su = dl === void 0 ? 0 : dl, cu = Za.timeShiftBufferDepth, Ru = cu === void 0 ? 1 / 0 : cu, bu = Li(Za.endNumber), Hu = (rl + zs) / 1e3, cc = al + su, Tl = Hu + Su, Yl = Tl - cc, Dl = Math.ceil(Yl * $l / Zl), Cl = Math.floor((Hu - cc - Ru) * $l / Zl), Hl = Math.floor((Hu - cc) * $l / Zl);
                  return {
                    start: Math.max(0, Cl),
                    end: typeof bu == "number" ? bu : Math.min(Dl, Hl)
                  };
                }
              }, Ni = function(Za) {
                return function(rl) {
                  var zs = Za.duration, al = Za.timescale, Ol = al === void 0 ? 1 : al, $l = Za.periodStart, Zl = Za.startNumber, tu = Zl === void 0 ? 1 : Zl;
                  return {
                    number: tu + rl,
                    duration: zs / Ol,
                    timeline: $l,
                    time: rl * zs
                  };
                };
              }, Yi = function(Za) {
                var rl = Za.type, zs = Za.duration, al = Za.timescale, Ol = al === void 0 ? 1 : al, $l = Za.periodDuration, Zl = Za.sourceDuration, tu = Co[rl](Za), su = tu.start, dl = tu.end, Su = $i(su, dl).map(Ni(Za));
                if (rl === "static") {
                  var cu = Su.length - 1, Ru = typeof $l == "number" ? $l : Zl;
                  Su[cu].duration = Ru - zs / Ol * cu;
                }
                return Su;
              }, Vo = function(Za) {
                var rl = Za.baseUrl, zs = Za.initialization, al = zs === void 0 ? {} : zs, Ol = Za.sourceDuration, $l = Za.indexRange, Zl = $l === void 0 ? "" : $l, tu = Za.periodStart, su = Za.presentationTime, dl = Za.number, Su = dl === void 0 ? 0 : dl, cu = Za.duration;
                if (!rl)
                  throw new Error(xo.NO_BASE_URL);
                var Ru = fo({
                  baseUrl: rl,
                  source: al.sourceURL,
                  range: al.range
                }), bu = fo({
                  baseUrl: rl,
                  source: rl,
                  indexRange: Zl
                });
                if (bu.map = Ru, cu) {
                  var Hu = Yi(Za);
                  Hu.length && (bu.duration = Hu[0].duration, bu.timeline = Hu[0].timeline);
                } else Ol && (bu.duration = Ol, bu.timeline = tu);
                return bu.presentationTime = su || tu, bu.number = Su, [bu];
              }, No = function(Za, rl, zs) {
                var al = Za.sidx.map ? Za.sidx.map : null, Ol = Za.sidx.duration, $l = Za.timeline || 0, Zl = Za.sidx.byterange, tu = Zl.offset + Zl.length, su = rl.timescale, dl = rl.references.filter(function(hc) {
                  return hc.referenceType !== 1;
                }), Su = [], cu = Za.endList ? "static" : "dynamic", Ru = Za.sidx.timeline, bu = Ru, Hu = Za.mediaSequence || 0, cc;
                typeof rl.firstOffset == "bigint" ? cc = fi().BigInt(tu) + rl.firstOffset : cc = tu + rl.firstOffset;
                for (var Tl = 0; Tl < dl.length; Tl++) {
                  var Yl = rl.references[Tl], Dl = Yl.referencedSize, Cl = Yl.subsegmentDuration, Hl = void 0;
                  typeof cc == "bigint" ? Hl = cc + fi().BigInt(Dl) - fi().BigInt(1) : Hl = cc + Dl - 1;
                  var Gu = cc + "-" + Hl, xu = {
                    baseUrl: zs,
                    timescale: su,
                    timeline: $l,
                    periodStart: Ru,
                    presentationTime: bu,
                    number: Hu,
                    duration: Cl,
                    sourceDuration: Ol,
                    indexRange: Gu,
                    type: cu
                  }, ac = Vo(xu)[0];
                  al && (ac.map = al), Su.push(ac), typeof cc == "bigint" ? cc += fi().BigInt(Dl) : cc += Dl, bu += Cl / su, Hu++;
                }
                return Za.segments = Su, Za;
              }, Ui = ["AUDIO", "SUBTITLES"], jo = 1 / 60, Wi = function(Za) {
                return io(Za, function(rl) {
                  var zs = rl.timeline;
                  return zs;
                }).sort(function(rl, zs) {
                  return rl.timeline > zs.timeline ? 1 : -1;
                });
              }, ji = function(Za, rl) {
                for (var zs = 0; zs < Za.length; zs++)
                  if (Za[zs].attributes.NAME === rl)
                    return Za[zs];
                return null;
              }, Hi = function(Za) {
                var rl = [];
                return (0, gi.forEachMediaGroup)(Za, Ui, function(zs, al, Ol, $l) {
                  rl = rl.concat(zs.playlists || []);
                }), rl;
              }, zo = function(Za) {
                var rl = Za.playlist, zs = Za.mediaSequence;
                rl.mediaSequence = zs, rl.segments.forEach(function(al, Ol) {
                  al.number = rl.mediaSequence + Ol;
                });
              }, Lo = function(Za) {
                var rl = Za.oldPlaylists, zs = Za.newPlaylists, al = Za.timelineStarts;
                zs.forEach(function(Ol) {
                  Ol.discontinuitySequence = Oo(al, function(dl) {
                    var Su = dl.timeline;
                    return Su === Ol.timeline;
                  });
                  var $l = ji(rl, Ol.attributes.NAME);
                  if ($l && !Ol.sidx) {
                    var Zl = Ol.segments[0], tu = Oo($l.segments, function(dl) {
                      return Math.abs(dl.presentationTime - Zl.presentationTime) < jo;
                    });
                    if (tu === -1) {
                      zo({
                        playlist: Ol,
                        mediaSequence: $l.mediaSequence + $l.segments.length
                      }), Ol.segments[0].discontinuity = !0, Ol.discontinuityStarts.unshift(0), (!$l.segments.length && Ol.timeline > $l.timeline || $l.segments.length && Ol.timeline > $l.segments[$l.segments.length - 1].timeline) && Ol.discontinuitySequence--;
                      return;
                    }
                    var su = $l.segments[tu];
                    su.discontinuity && !Zl.discontinuity && (Zl.discontinuity = !0, Ol.discontinuityStarts.unshift(0), Ol.discontinuitySequence--), zo({
                      playlist: Ol,
                      mediaSequence: $l.segments[tu].number
                    });
                  }
                });
              }, sa = function(Za) {
                var rl = Za.oldManifest, zs = Za.newManifest, al = rl.playlists.concat(Hi(rl)), Ol = zs.playlists.concat(Hi(zs));
                return zs.timelineStarts = Wi([rl.timelineStarts, zs.timelineStarts]), Lo({
                  oldPlaylists: al,
                  newPlaylists: Ol,
                  timelineStarts: zs.timelineStarts
                }), zs;
              }, Ko = function(Za) {
                return Za && Za.uri + "-" + _o(Za.byterange);
              }, ca = function(Za) {
                var rl = Pi(Za.reduce(function(zs, al) {
                  var Ol = al.attributes.id + (al.attributes.lang || "");
                  if (!zs[Ol])
                    zs[Ol] = al, zs[Ol].attributes.timelineStarts = [];
                  else {
                    if (al.segments) {
                      var $l;
                      al.segments[0] && (al.segments[0].discontinuity = !0), ($l = zs[Ol].segments).push.apply($l, al.segments);
                    }
                    al.attributes.contentProtection && (zs[Ol].attributes.contentProtection = al.attributes.contentProtection);
                  }
                  return zs[Ol].attributes.timelineStarts.push({
                    // Although they represent the same number, it's important to have both to make it
                    // compatible with HLS potentially having a similar attribute.
                    start: al.attributes.periodStart,
                    timeline: al.attributes.periodStart
                  }), zs;
                }, {}));
                return rl.map(function(zs) {
                  return zs.discontinuityStarts = Mi(zs.segments || [], "discontinuity"), zs;
                });
              }, pa = function(Za, rl) {
                var zs = Ko(Za.sidx), al = zs && rl[zs] && rl[zs].sidx;
                return al && No(Za, al, Za.sidx.resolvedUri), Za;
              }, ga = function(Za, rl) {
                if (rl === void 0 && (rl = {}), !Object.keys(rl).length)
                  return Za;
                for (var zs in Za)
                  Za[zs] = pa(Za[zs], rl);
                return Za;
              }, ia = function(Za, rl) {
                var zs, al = Za.attributes, Ol = Za.segments, $l = Za.sidx, Zl = Za.mediaSequence, tu = Za.discontinuitySequence, su = Za.discontinuityStarts, dl = {
                  attributes: (zs = {
                    NAME: al.id,
                    BANDWIDTH: al.bandwidth,
                    CODECS: al.codecs
                  }, zs["PROGRAM-ID"] = 1, zs),
                  uri: "",
                  endList: al.type === "static",
                  timeline: al.periodStart,
                  resolvedUri: "",
                  targetDuration: al.duration,
                  discontinuitySequence: tu,
                  discontinuityStarts: su,
                  timelineStarts: al.timelineStarts,
                  mediaSequence: Zl,
                  segments: Ol
                };
                return al.contentProtection && (dl.contentProtection = al.contentProtection), $l && (dl.sidx = $l), rl && (dl.attributes.AUDIO = "audio", dl.attributes.SUBTITLES = "subs"), dl;
              }, ra = function(Za) {
                var rl, zs = Za.attributes, al = Za.segments, Ol = Za.mediaSequence, $l = Za.discontinuityStarts, Zl = Za.discontinuitySequence;
                typeof al > "u" && (al = [{
                  uri: zs.baseUrl,
                  timeline: zs.periodStart,
                  resolvedUri: zs.baseUrl || "",
                  duration: zs.sourceDuration,
                  number: 0
                }], zs.duration = zs.sourceDuration);
                var tu = (rl = {
                  NAME: zs.id,
                  BANDWIDTH: zs.bandwidth
                }, rl["PROGRAM-ID"] = 1, rl);
                return zs.codecs && (tu.CODECS = zs.codecs), {
                  attributes: tu,
                  uri: "",
                  endList: zs.type === "static",
                  timeline: zs.periodStart,
                  resolvedUri: zs.baseUrl || "",
                  targetDuration: zs.duration,
                  timelineStarts: zs.timelineStarts,
                  discontinuityStarts: $l,
                  discontinuitySequence: Zl,
                  mediaSequence: Ol,
                  segments: al
                };
              }, qo = function(Za, rl, zs) {
                rl === void 0 && (rl = {}), zs === void 0 && (zs = !1);
                var al, Ol = Za.reduce(function(Zl, tu) {
                  var su = tu.attributes.role && tu.attributes.role.value || "", dl = tu.attributes.lang || "", Su = tu.attributes.label || "main";
                  if (dl && !tu.attributes.label) {
                    var cu = su ? " (" + su + ")" : "";
                    Su = "" + tu.attributes.lang + cu;
                  }
                  Zl[Su] || (Zl[Su] = {
                    language: dl,
                    autoselect: !0,
                    default: su === "main",
                    playlists: [],
                    uri: ""
                  });
                  var Ru = pa(ia(tu, zs), rl);
                  return Zl[Su].playlists.push(Ru), typeof al > "u" && su === "main" && (al = tu, al.default = !0), Zl;
                }, {});
                if (!al) {
                  var $l = Object.keys(Ol)[0];
                  Ol[$l].default = !0;
                }
                return Ol;
              }, xa = function(Za, rl) {
                return rl === void 0 && (rl = {}), Za.reduce(function(zs, al) {
                  var Ol = al.attributes.lang || "text";
                  return zs[Ol] || (zs[Ol] = {
                    language: Ol,
                    default: !1,
                    autoselect: !1,
                    playlists: [],
                    uri: ""
                  }), zs[Ol].playlists.push(pa(ra(al), rl)), zs;
                }, {});
              }, $a = function(Za) {
                return Za.reduce(function(rl, zs) {
                  return zs && zs.forEach(function(al) {
                    var Ol = al.channel, $l = al.language;
                    rl[$l] = {
                      autoselect: !1,
                      default: !1,
                      instreamId: Ol,
                      language: $l
                    }, al.hasOwnProperty("aspectRatio") && (rl[$l].aspectRatio = al.aspectRatio), al.hasOwnProperty("easyReader") && (rl[$l].easyReader = al.easyReader), al.hasOwnProperty("3D") && (rl[$l]["3D"] = al["3D"]);
                  }), rl;
                }, {});
              }, ys = function(Za) {
                var rl, zs = Za.attributes, al = Za.segments, Ol = Za.sidx, $l = Za.discontinuityStarts, Zl = {
                  attributes: (rl = {
                    NAME: zs.id,
                    AUDIO: "audio",
                    SUBTITLES: "subs",
                    RESOLUTION: {
                      width: zs.width,
                      height: zs.height
                    },
                    CODECS: zs.codecs,
                    BANDWIDTH: zs.bandwidth
                  }, rl["PROGRAM-ID"] = 1, rl),
                  uri: "",
                  endList: zs.type === "static",
                  timeline: zs.periodStart,
                  resolvedUri: "",
                  targetDuration: zs.duration,
                  discontinuityStarts: $l,
                  timelineStarts: zs.timelineStarts,
                  segments: al
                };
                return zs.frameRate && (Zl.attributes["FRAME-RATE"] = zs.frameRate), zs.contentProtection && (Zl.contentProtection = zs.contentProtection), Ol && (Zl.sidx = Ol), Zl;
              }, Ss = function(Za) {
                var rl = Za.attributes;
                return rl.mimeType === "video/mp4" || rl.mimeType === "video/webm" || rl.contentType === "video";
              }, Xa = function(Za) {
                var rl = Za.attributes;
                return rl.mimeType === "audio/mp4" || rl.mimeType === "audio/webm" || rl.contentType === "audio";
              }, Es = function(Za) {
                var rl = Za.attributes;
                return rl.mimeType === "text/vtt" || rl.contentType === "text";
              }, Rs = function(Za, rl) {
                Za.forEach(function(zs) {
                  zs.mediaSequence = 0, zs.discontinuitySequence = Oo(rl, function(al) {
                    var Ol = al.timeline;
                    return Ol === zs.timeline;
                  }), zs.segments && zs.segments.forEach(function(al, Ol) {
                    al.number = Ol;
                  });
                });
              }, La = function(Za) {
                return Za ? Object.keys(Za).reduce(function(rl, zs) {
                  var al = Za[zs];
                  return rl.concat(al.playlists);
                }, []) : [];
              }, Ja = function(Za) {
                var rl, zs = Za.dashPlaylists, al = Za.locations, Ol = Za.sidxMapping, $l = Ol === void 0 ? {} : Ol, Zl = Za.previousManifest;
                if (!zs.length)
                  return {};
                var tu = zs[0].attributes, su = tu.sourceDuration, dl = tu.type, Su = tu.suggestedPresentationDelay, cu = tu.minimumUpdatePeriod, Ru = ca(zs.filter(Ss)).map(ys), bu = ca(zs.filter(Xa)), Hu = ca(zs.filter(Es)), cc = zs.map(function(xu) {
                  return xu.attributes.captionServices;
                }).filter(Boolean), Tl = {
                  allowCache: !0,
                  discontinuityStarts: [],
                  segments: [],
                  endList: !0,
                  mediaGroups: (rl = {
                    AUDIO: {},
                    VIDEO: {}
                  }, rl["CLOSED-CAPTIONS"] = {}, rl.SUBTITLES = {}, rl),
                  uri: "",
                  duration: su,
                  playlists: ga(Ru, $l)
                };
                cu >= 0 && (Tl.minimumUpdatePeriod = cu * 1e3), al && (Tl.locations = al), dl === "dynamic" && (Tl.suggestedPresentationDelay = Su);
                var Yl = Tl.playlists.length === 0, Dl = bu.length ? qo(bu, $l, Yl) : null, Cl = Hu.length ? xa(Hu, $l) : null, Hl = Ru.concat(La(Dl), La(Cl)), Gu = Hl.map(function(xu) {
                  var ac = xu.timelineStarts;
                  return ac;
                });
                return Tl.timelineStarts = Wi(Gu), Rs(Hl, Tl.timelineStarts), Dl && (Tl.mediaGroups.AUDIO.audio = Dl), Cl && (Tl.mediaGroups.SUBTITLES.subs = Cl), cc.length && (Tl.mediaGroups["CLOSED-CAPTIONS"].cc = $a(cc)), Zl ? sa({
                  oldManifest: Zl,
                  newManifest: Tl
                }) : Tl;
              }, ja = function(Za, rl, zs) {
                var al = Za.NOW, Ol = Za.clientOffset, $l = Za.availabilityStartTime, Zl = Za.timescale, tu = Zl === void 0 ? 1 : Zl, su = Za.periodStart, dl = su === void 0 ? 0 : su, Su = Za.minimumUpdatePeriod, cu = Su === void 0 ? 0 : Su, Ru = (al + Ol) / 1e3, bu = $l + dl, Hu = Ru + cu, cc = Hu - bu;
                return Math.ceil((cc * tu - rl) / zs);
              }, Ta = function(Za, rl) {
                for (var zs = Za.type, al = Za.minimumUpdatePeriod, Ol = al === void 0 ? 0 : al, $l = Za.media, Zl = $l === void 0 ? "" : $l, tu = Za.sourceDuration, su = Za.timescale, dl = su === void 0 ? 1 : su, Su = Za.startNumber, cu = Su === void 0 ? 1 : Su, Ru = Za.periodStart, bu = [], Hu = -1, cc = 0; cc < rl.length; cc++) {
                  var Tl = rl[cc], Yl = Tl.d, Dl = Tl.r || 0, Cl = Tl.t || 0;
                  Hu < 0 && (Hu = Cl), Cl && Cl > Hu && (Hu = Cl);
                  var Hl = void 0;
                  if (Dl < 0) {
                    var Gu = cc + 1;
                    Gu === rl.length ? zs === "dynamic" && Ol > 0 && Zl.indexOf("$Number$") > 0 ? Hl = ja(Za, Hu, Yl) : Hl = (tu * dl - Hu) / Yl : Hl = (rl[Gu].t - Hu) / Yl;
                  } else
                    Hl = Dl + 1;
                  for (var xu = cu + bu.length + Hl, ac = cu + bu.length; ac < xu; )
                    bu.push({
                      number: ac,
                      duration: Yl / dl,
                      time: Hu,
                      timeline: Ru
                    }), Hu += Yl, ac++;
                }
                return bu;
              }, rs = /\$([A-z]*)(?:(%0)([0-9]+)d)?\$/g, Qa = function(Za) {
                return function(rl, zs, al, Ol) {
                  if (rl === "$$")
                    return "$";
                  if (typeof Za[zs] > "u")
                    return rl;
                  var $l = "" + Za[zs];
                  return zs === "RepresentationID" || (al ? Ol = parseInt(Ol, 10) : Ol = 1, $l.length >= Ol) ? $l : "" + new Array(Ol - $l.length + 1).join("0") + $l;
                };
              }, Cs = function(Za, rl) {
                return Za.replace(rs, Qa(rl));
              }, _a = function(Za, rl) {
                return !Za.duration && !rl ? [{
                  number: Za.startNumber || 1,
                  duration: Za.sourceDuration,
                  time: 0,
                  timeline: Za.periodStart
                }] : Za.duration ? Yi(Za) : Ta(Za, rl);
              }, _s = function(Za, rl) {
                var zs = {
                  RepresentationID: Za.id,
                  Bandwidth: Za.bandwidth || 0
                }, al = Za.initialization, Ol = al === void 0 ? {
                  sourceURL: "",
                  range: ""
                } : al, $l = fo({
                  baseUrl: Za.baseUrl,
                  source: Cs(Ol.sourceURL, zs),
                  range: Ol.range
                }), Zl = _a(Za, rl);
                return Zl.map(function(tu) {
                  zs.Number = tu.number, zs.Time = tu.time;
                  var su = Cs(Za.media || "", zs), dl = Za.timescale || 1, Su = Za.presentationTimeOffset || 0, cu = (
                    // Even if the @t attribute is not specified for the segment, segment.time is
                    // calculated in mpd-parser prior to this, so it's assumed to be available.
                    Za.periodStart + (tu.time - Su) / dl
                  ), Ru = {
                    uri: su,
                    timeline: tu.timeline,
                    duration: tu.duration,
                    resolvedUri: (0, si.default)(Za.baseUrl || "", su),
                    map: $l,
                    number: tu.number,
                    presentationTime: cu
                  };
                  return Ru;
                });
              }, el = function(Za, rl) {
                var zs = Za.baseUrl, al = Za.initialization, Ol = al === void 0 ? {} : al, $l = fo({
                  baseUrl: zs,
                  source: Ol.sourceURL,
                  range: Ol.range
                }), Zl = fo({
                  baseUrl: zs,
                  source: rl.media,
                  range: rl.mediaRange
                });
                return Zl.map = $l, Zl;
              }, Ps = function(Za, rl) {
                var zs = Za.duration, al = Za.segmentUrls, Ol = al === void 0 ? [] : al, $l = Za.periodStart;
                if (!zs && !rl || zs && rl)
                  throw new Error(xo.SEGMENT_TIME_UNSPECIFIED);
                var Zl = Ol.map(function(dl) {
                  return el(Za, dl);
                }), tu;
                zs && (tu = Yi(Za)), rl && (tu = Ta(Za, rl));
                var su = tu.map(function(dl, Su) {
                  if (Zl[Su]) {
                    var cu = Zl[Su], Ru = Za.timescale || 1, bu = Za.presentationTimeOffset || 0;
                    return cu.timeline = dl.timeline, cu.duration = dl.duration, cu.number = dl.number, cu.presentationTime = $l + (dl.time - bu) / Ru, cu;
                  }
                }).filter(function(dl) {
                  return dl;
                });
                return su;
              }, nl = function(Za) {
                var rl = Za.attributes, zs = Za.segmentInfo, al, Ol;
                zs.template ? (Ol = _s, al = Si(rl, zs.template)) : zs.base ? (Ol = Vo, al = Si(rl, zs.base)) : zs.list && (Ol = Ps, al = Si(rl, zs.list));
                var $l = {
                  attributes: rl
                };
                if (!Ol)
                  return $l;
                var Zl = Ol(al, zs.segmentTimeline);
                if (al.duration) {
                  var tu = al, su = tu.duration, dl = tu.timescale, Su = dl === void 0 ? 1 : dl;
                  al.duration = su / Su;
                } else Zl.length ? al.duration = Zl.reduce(function(cu, Ru) {
                  return Math.max(cu, Math.ceil(Ru.duration));
                }, 0) : al.duration = 0;
                return $l.attributes = al, $l.segments = Zl, zs.base && al.indexRange && ($l.sidx = Zl[0], $l.segments = []), $l;
              }, Vs = function(Za) {
                return Za.map(nl);
              }, es = function(Za, rl) {
                return Di(Za.childNodes).filter(function(zs) {
                  var al = zs.tagName;
                  return al === rl;
                });
              }, Is = function(Za) {
                return Za.textContent.trim();
              }, fl = function(Za) {
                return parseFloat(Za.split("/").reduce(function(rl, zs) {
                  return rl / zs;
                }));
              }, sl = function(Za) {
                var rl = 31536e3, zs = 720 * 60 * 60, al = 1440 * 60, Ol = 3600, $l = 60, Zl = /P(?:(\d*)Y)?(?:(\d*)M)?(?:(\d*)D)?(?:T(?:(\d*)H)?(?:(\d*)M)?(?:([\d.]*)S)?)?/, tu = Zl.exec(Za);
                if (!tu)
                  return 0;
                var su = tu.slice(1), dl = su[0], Su = su[1], cu = su[2], Ru = su[3], bu = su[4], Hu = su[5];
                return parseFloat(dl || 0) * rl + parseFloat(Su || 0) * zs + parseFloat(cu || 0) * al + parseFloat(Ru || 0) * Ol + parseFloat(bu || 0) * $l + parseFloat(Hu || 0);
              }, Il = function(Za) {
                var rl = /^\d+-\d+-\d+T\d+:\d+:\d+(\.\d+)?$/;
                return rl.test(Za) && (Za += "Z"), Date.parse(Za);
              }, Vl = {
                /**
                 * Specifies the duration of the entire Media Presentation. Format is a duration string
                 * as specified in ISO 8601
                 *
                 * @param {string} value
                 *        value of attribute as a string
                 * @return {number}
                 *         The duration in seconds
                 */
                mediaPresentationDuration: function(Za) {
                  return sl(Za);
                },
                /**
                 * Specifies the Segment availability start time for all Segments referred to in this
                 * MPD. For a dynamic manifest, it specifies the anchor for the earliest availability
                 * time. Format is a date string as specified in ISO 8601
                 *
                 * @param {string} value
                 *        value of attribute as a string
                 * @return {number}
                 *         The date as seconds from unix epoch
                 */
                availabilityStartTime: function(Za) {
                  return Il(Za) / 1e3;
                },
                /**
                 * Specifies the smallest period between potential changes to the MPD. Format is a
                 * duration string as specified in ISO 8601
                 *
                 * @param {string} value
                 *        value of attribute as a string
                 * @return {number}
                 *         The duration in seconds
                 */
                minimumUpdatePeriod: function(Za) {
                  return sl(Za);
                },
                /**
                 * Specifies the suggested presentation delay. Format is a
                 * duration string as specified in ISO 8601
                 *
                 * @param {string} value
                 *        value of attribute as a string
                 * @return {number}
                 *         The duration in seconds
                 */
                suggestedPresentationDelay: function(Za) {
                  return sl(Za);
                },
                /**
                 * specifices the type of mpd. Can be either "static" or "dynamic"
                 *
                 * @param {string} value
                 *        value of attribute as a string
                 *
                 * @return {string}
                 *         The type as a string
                 */
                type: function(Za) {
                  return Za;
                },
                /**
                 * Specifies the duration of the smallest time shifting buffer for any Representation
                 * in the MPD. Format is a duration string as specified in ISO 8601
                 *
                 * @param {string} value
                 *        value of attribute as a string
                 * @return {number}
                 *         The duration in seconds
                 */
                timeShiftBufferDepth: function(Za) {
                  return sl(Za);
                },
                /**
                 * Specifies the PeriodStart time of the Period relative to the availabilityStarttime.
                 * Format is a duration string as specified in ISO 8601
                 *
                 * @param {string} value
                 *        value of attribute as a string
                 * @return {number}
                 *         The duration in seconds
                 */
                start: function(Za) {
                  return sl(Za);
                },
                /**
                 * Specifies the width of the visual presentation
                 *
                 * @param {string} value
                 *        value of attribute as a string
                 * @return {number}
                 *         The parsed width
                 */
                width: function(Za) {
                  return parseInt(Za, 10);
                },
                /**
                 * Specifies the height of the visual presentation
                 *
                 * @param {string} value
                 *        value of attribute as a string
                 * @return {number}
                 *         The parsed height
                 */
                height: function(Za) {
                  return parseInt(Za, 10);
                },
                /**
                 * Specifies the bitrate of the representation
                 *
                 * @param {string} value
                 *        value of attribute as a string
                 * @return {number}
                 *         The parsed bandwidth
                 */
                bandwidth: function(Za) {
                  return parseInt(Za, 10);
                },
                /**
                 * Specifies the frame rate of the representation
                 *
                 * @param {string} value
                 *        value of attribute as a string
                 * @return {number}
                 *         The parsed frame rate
                 */
                frameRate: function(Za) {
                  return fl(Za);
                },
                /**
                 * Specifies the number of the first Media Segment in this Representation in the Period
                 *
                 * @param {string} value
                 *        value of attribute as a string
                 * @return {number}
                 *         The parsed number
                 */
                startNumber: function(Za) {
                  return parseInt(Za, 10);
                },
                /**
                 * Specifies the timescale in units per seconds
                 *
                 * @param {string} value
                 *        value of attribute as a string
                 * @return {number}
                 *         The parsed timescale
                 */
                timescale: function(Za) {
                  return parseInt(Za, 10);
                },
                /**
                 * Specifies the presentationTimeOffset.
                 *
                 * @param {string} value
                 *        value of the attribute as a string
                 *
                 * @return {number}
                 *         The parsed presentationTimeOffset
                 */
                presentationTimeOffset: function(Za) {
                  return parseInt(Za, 10);
                },
                /**
                 * Specifies the constant approximate Segment duration
                 * NOTE: The <Period> element also contains an @duration attribute. This duration
                 *       specifies the duration of the Period. This attribute is currently not
                 *       supported by the rest of the parser, however we still check for it to prevent
                 *       errors.
                 *
                 * @param {string} value
                 *        value of attribute as a string
                 * @return {number}
                 *         The parsed duration
                 */
                duration: function(Za) {
                  var rl = parseInt(Za, 10);
                  return isNaN(rl) ? sl(Za) : rl;
                },
                /**
                 * Specifies the Segment duration, in units of the value of the @timescale.
                 *
                 * @param {string} value
                 *        value of attribute as a string
                 * @return {number}
                 *         The parsed duration
                 */
                d: function(Za) {
                  return parseInt(Za, 10);
                },
                /**
                 * Specifies the MPD start time, in @timescale units, the first Segment in the series
                 * starts relative to the beginning of the Period
                 *
                 * @param {string} value
                 *        value of attribute as a string
                 * @return {number}
                 *         The parsed time
                 */
                t: function(Za) {
                  return parseInt(Za, 10);
                },
                /**
                 * Specifies the repeat count of the number of following contiguous Segments with the
                 * same duration expressed by the value of @d
                 *
                 * @param {string} value
                 *        value of attribute as a string
                 * @return {number}
                 *         The parsed number
                 */
                r: function(Za) {
                  return parseInt(Za, 10);
                },
                /**
                 * Default parser for all other attributes. Acts as a no-op and just returns the value
                 * as a string
                 *
                 * @param {string} value
                 *        value of attribute as a string
                 * @return {string}
                 *         Unparsed value
                 */
                DEFAULT: function(Za) {
                  return Za;
                }
              }, Bl = function(Za) {
                return Za && Za.attributes ? Di(Za.attributes).reduce(function(rl, zs) {
                  var al = Vl[zs.name] || Vl.DEFAULT;
                  return rl[zs.name] = al(zs.value), rl;
                }, {}) : {};
              }, ql = {
                "urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b": "org.w3.clearkey",
                "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed": "com.widevine.alpha",
                "urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95": "com.microsoft.playready",
                "urn:uuid:f239e769-efa3-4850-9c16-a903c6932efb": "com.adobe.primetime"
              }, xl = function(Za, rl) {
                return rl.length ? Oi(Za.map(function(zs) {
                  return rl.map(function(al) {
                    return (0, si.default)(zs, Is(al));
                  });
                })) : Za;
              }, Ul = function(Za) {
                var rl = es(Za, "SegmentTemplate")[0], zs = es(Za, "SegmentList")[0], al = zs && es(zs, "SegmentURL").map(function(cu) {
                  return Si({
                    tag: "SegmentURL"
                  }, Bl(cu));
                }), Ol = es(Za, "SegmentBase")[0], $l = zs || rl, Zl = $l && es($l, "SegmentTimeline")[0], tu = zs || Ol || rl, su = tu && es(tu, "Initialization")[0], dl = rl && Bl(rl);
                dl && su ? dl.initialization = su && Bl(su) : dl && dl.initialization && (dl.initialization = {
                  sourceURL: dl.initialization
                });
                var Su = {
                  template: dl,
                  segmentTimeline: Zl && es(Zl, "S").map(function(cu) {
                    return Bl(cu);
                  }),
                  list: zs && Si(Bl(zs), {
                    segmentUrls: al,
                    initialization: Bl(su)
                  }),
                  base: Ol && Si(Bl(Ol), {
                    initialization: Bl(su)
                  })
                };
                return Object.keys(Su).forEach(function(cu) {
                  Su[cu] || delete Su[cu];
                }), Su;
              }, Xl = function(Za, rl, zs) {
                return function(al) {
                  var Ol = es(al, "BaseURL"), $l = xl(rl, Ol), Zl = Si(Za, Bl(al)), tu = Ul(al);
                  return $l.map(function(su) {
                    return {
                      segmentInfo: Si(zs, tu),
                      attributes: Si(Zl, {
                        baseUrl: su
                      })
                    };
                  });
                };
              }, hu = function(Za) {
                return Za.reduce(function(rl, zs) {
                  var al = Bl(zs);
                  al.schemeIdUri && (al.schemeIdUri = al.schemeIdUri.toLowerCase());
                  var Ol = ql[al.schemeIdUri];
                  if (Ol) {
                    rl[Ol] = {
                      attributes: al
                    };
                    var $l = es(zs, "cenc:pssh")[0];
                    if ($l) {
                      var Zl = Is($l);
                      rl[Ol].pssh = Zl && (0, mi.default)(Zl);
                    }
                  }
                  return rl;
                }, {});
              }, Tu = function(Za) {
                if (Za.schemeIdUri === "urn:scte:dash:cc:cea-608:2015") {
                  var rl = typeof Za.value != "string" ? [] : Za.value.split(";");
                  return rl.map(function(al) {
                    var Ol, $l;
                    if ($l = al, /^CC\d=/.test(al)) {
                      var Zl = al.split("=");
                      Ol = Zl[0], $l = Zl[1];
                    } else /^CC\d$/.test(al) && (Ol = al);
                    return {
                      channel: Ol,
                      language: $l
                    };
                  });
                } else if (Za.schemeIdUri === "urn:scte:dash:cc:cea-708:2015") {
                  var zs = typeof Za.value != "string" ? [] : Za.value.split(";");
                  return zs.map(function(al) {
                    var Ol = {
                      // service or channel number 1-63
                      channel: void 0,
                      // language is a 3ALPHA per ISO 639.2/B
                      // field is required
                      language: void 0,
                      // BIT 1/0 or ?
                      // default value is 1, meaning 16:9 aspect ratio, 0 is 4:3, ? is unknown
                      aspectRatio: 1,
                      // BIT 1/0
                      // easy reader flag indicated the text is tailed to the needs of beginning readers
                      // default 0, or off
                      easyReader: 0,
                      // BIT 1/0
                      // If 3d metadata is present (CEA-708.1) then 1
                      // default 0
                      "3D": 0
                    };
                    if (/=/.test(al)) {
                      var $l = al.split("="), Zl = $l[0], tu = $l[1], su = tu === void 0 ? "" : tu;
                      Ol.channel = Zl, Ol.language = al, su.split(",").forEach(function(dl) {
                        var Su = dl.split(":"), cu = Su[0], Ru = Su[1];
                        cu === "lang" ? Ol.language = Ru : cu === "er" ? Ol.easyReader = Number(Ru) : cu === "war" ? Ol.aspectRatio = Number(Ru) : cu === "3D" && (Ol["3D"] = Number(Ru));
                      });
                    } else
                      Ol.language = al;
                    return Ol.channel && (Ol.channel = "SERVICE" + Ol.channel), Ol;
                  });
                }
              }, Ku = function(Za, rl, zs) {
                return function(al) {
                  var Ol = Bl(al), $l = xl(rl, es(al, "BaseURL")), Zl = es(al, "Role")[0], tu = {
                    role: Bl(Zl)
                  }, su = Si(Za, Ol, tu), dl = es(al, "Accessibility")[0], Su = Tu(Bl(dl));
                  Su && (su = Si(su, {
                    captionServices: Su
                  }));
                  var cu = es(al, "Label")[0];
                  if (cu && cu.childNodes.length) {
                    var Ru = cu.childNodes[0].nodeValue.trim();
                    su = Si(su, {
                      label: Ru
                    });
                  }
                  var bu = hu(es(al, "ContentProtection"));
                  Object.keys(bu).length && (su = Si(su, {
                    contentProtection: bu
                  }));
                  var Hu = Ul(al), cc = es(al, "Representation"), Tl = Si(zs, Hu);
                  return Oi(cc.map(Xl(su, $l, Tl)));
                };
              }, Wl = function(Za, rl) {
                return function(zs, al) {
                  var Ol = xl(rl, es(zs.node, "BaseURL")), $l = Si(Za, {
                    periodStart: zs.attributes.start
                  });
                  typeof zs.attributes.duration == "number" && ($l.periodDuration = zs.attributes.duration);
                  var Zl = es(zs.node, "AdaptationSet"), tu = Ul(zs.node);
                  return Oi(Zl.map(Ku($l, Ol, tu)));
                };
              }, uu = function(Za) {
                var rl = Za.attributes, zs = Za.priorPeriodAttributes, al = Za.mpdType;
                return typeof rl.start == "number" ? rl.start : zs && typeof zs.start == "number" && typeof zs.duration == "number" ? zs.start + zs.duration : !zs && al === "static" ? 0 : null;
              }, du = function(Za, rl) {
                rl === void 0 && (rl = {});
                var zs = rl, al = zs.manifestUri, Ol = al === void 0 ? "" : al, $l = zs.NOW, Zl = $l === void 0 ? Date.now() : $l, tu = zs.clientOffset, su = tu === void 0 ? 0 : tu, dl = es(Za, "Period");
                if (!dl.length)
                  throw new Error(xo.INVALID_NUMBER_OF_PERIOD);
                var Su = es(Za, "Location"), cu = Bl(Za), Ru = xl([Ol], es(Za, "BaseURL"));
                cu.type = cu.type || "static", cu.sourceDuration = cu.mediaPresentationDuration || 0, cu.NOW = Zl, cu.clientOffset = su, Su.length && (cu.locations = Su.map(Is));
                var bu = [];
                return dl.forEach(function(Hu, cc) {
                  var Tl = Bl(Hu), Yl = bu[cc - 1];
                  Tl.start = uu({
                    attributes: Tl,
                    priorPeriodAttributes: Yl ? Yl.attributes : null,
                    mpdType: cu.type
                  }), bu.push({
                    node: Hu,
                    attributes: Tl
                  });
                }), {
                  locations: cu.locations,
                  representationInfo: Oi(bu.map(Wl(cu, Ru)))
                };
              }, za = function(Za) {
                if (Za === "")
                  throw new Error(xo.DASH_EMPTY_MANIFEST);
                var rl = new Ti.DOMParser(), zs, al;
                try {
                  zs = rl.parseFromString(Za, "application/xml"), al = zs && zs.documentElement.tagName === "MPD" ? zs.documentElement : null;
                } catch {
                }
                if (!al || al && al.getElementsByTagName("parsererror").length > 0)
                  throw new Error(xo.DASH_INVALID_XML);
                return al;
              }, Ya = function(Za) {
                var rl = es(Za, "UTCTiming")[0];
                if (!rl)
                  return null;
                var zs = Bl(rl);
                switch (zs.schemeIdUri) {
                  case "urn:mpeg:dash:utc:http-head:2014":
                  case "urn:mpeg:dash:utc:http-head:2012":
                    zs.method = "HEAD";
                    break;
                  case "urn:mpeg:dash:utc:http-xsdate:2014":
                  case "urn:mpeg:dash:utc:http-iso:2014":
                  case "urn:mpeg:dash:utc:http-xsdate:2012":
                  case "urn:mpeg:dash:utc:http-iso:2012":
                    zs.method = "GET";
                    break;
                  case "urn:mpeg:dash:utc:direct:2014":
                  case "urn:mpeg:dash:utc:direct:2012":
                    zs.method = "DIRECT", zs.value = Date.parse(zs.value);
                    break;
                  case "urn:mpeg:dash:utc:http-ntp:2014":
                  case "urn:mpeg:dash:utc:ntp:2014":
                  case "urn:mpeg:dash:utc:sntp:2014":
                  default:
                    throw new Error(xo.UNSUPPORTED_UTC_TIMING_SCHEME);
                }
                return zs;
              }, Ws = vi, wl = function(Za, rl) {
                rl === void 0 && (rl = {});
                var zs = du(za(Za), rl), al = Vs(zs.representationInfo);
                return Ja({
                  dashPlaylists: al,
                  locations: zs.locations,
                  sidxMapping: rl.sidxMapping,
                  previousManifest: rl.previousManifest
                });
              }, Gl = function(Za) {
                return Ya(za(Za));
              };
            })
          ),
          /***/
          "./node_modules/ms/index.js": (
            /*!**********************************!*\
              !*** ./node_modules/ms/index.js ***!
              \**********************************/
            /***/
            ((ai) => {
              var li = 1e3, oi = li * 60, si = oi * 60, di = si * 24, fi = di * 7, gi = di * 365.25;
              ai.exports = function(Si, Pi) {
                Pi = Pi || {};
                var $i = typeof Si;
                if ($i === "string" && Si.length > 0)
                  return mi(Si);
                if ($i === "number" && isFinite(Si))
                  return Pi.long ? vi(Si) : Ti(Si);
                throw new Error(
                  "val is not a non-empty string or a valid number. val=" + JSON.stringify(Si)
                );
              };
              function mi(Si) {
                if (Si = String(Si), !(Si.length > 100)) {
                  var Pi = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
                    Si
                  );
                  if (Pi) {
                    var $i = parseFloat(Pi[1]), Oi = (Pi[2] || "ms").toLowerCase();
                    switch (Oi) {
                      case "years":
                      case "year":
                      case "yrs":
                      case "yr":
                      case "y":
                        return $i * gi;
                      case "weeks":
                      case "week":
                      case "w":
                        return $i * fi;
                      case "days":
                      case "day":
                      case "d":
                        return $i * di;
                      case "hours":
                      case "hour":
                      case "hrs":
                      case "hr":
                      case "h":
                        return $i * si;
                      case "minutes":
                      case "minute":
                      case "mins":
                      case "min":
                      case "m":
                        return $i * oi;
                      case "seconds":
                      case "second":
                      case "secs":
                      case "sec":
                      case "s":
                        return $i * li;
                      case "milliseconds":
                      case "millisecond":
                      case "msecs":
                      case "msec":
                      case "ms":
                        return $i;
                      default:
                        return;
                    }
                  }
                }
              }
              function Ti(Si) {
                var Pi = Math.abs(Si);
                return Pi >= di ? Math.round(Si / di) + "d" : Pi >= si ? Math.round(Si / si) + "h" : Pi >= oi ? Math.round(Si / oi) + "m" : Pi >= li ? Math.round(Si / li) + "s" : Si + "ms";
              }
              function vi(Si) {
                var Pi = Math.abs(Si);
                return Pi >= di ? xi(Si, Pi, di, "day") : Pi >= si ? xi(Si, Pi, si, "hour") : Pi >= oi ? xi(Si, Pi, oi, "minute") : Pi >= li ? xi(Si, Pi, li, "second") : Si + " ms";
              }
              function xi(Si, Pi, $i, Oi) {
                var Di = Pi >= $i * 1.5;
                return Math.round(Si / $i) + " " + Oi + (Di ? "s" : "");
              }
            })
          ),
          /***/
          "./node_modules/mux.js/lib/tools/parse-sidx.js": (
            /*!*****************************************************!*\
              !*** ./node_modules/mux.js/lib/tools/parse-sidx.js ***!
              \*****************************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! ../utils/numbers.js */
                "./node_modules/mux.js/lib/utils/numbers.js"
              ).getUint64, di = function(fi) {
                var gi = new DataView(fi.buffer, fi.byteOffset, fi.byteLength), mi = {
                  version: fi[0],
                  flags: new Uint8Array(fi.subarray(1, 4)),
                  references: [],
                  referenceId: gi.getUint32(4),
                  timescale: gi.getUint32(8)
                }, Ti = 12;
                mi.version === 0 ? (mi.earliestPresentationTime = gi.getUint32(Ti), mi.firstOffset = gi.getUint32(Ti + 4), Ti += 8) : (mi.earliestPresentationTime = si(fi.subarray(Ti)), mi.firstOffset = si(fi.subarray(Ti + 8)), Ti += 16), Ti += 2;
                var vi = gi.getUint16(Ti);
                for (Ti += 2; vi > 0; Ti += 12, vi--)
                  mi.references.push({
                    referenceType: (fi[Ti] & 128) >>> 7,
                    referencedSize: gi.getUint32(Ti) & 2147483647,
                    subsegmentDuration: gi.getUint32(Ti + 4),
                    startsWithSap: !!(fi[Ti + 8] & 128),
                    sapType: (fi[Ti + 8] & 112) >>> 4,
                    sapDeltaTime: gi.getUint32(Ti + 8) & 268435455
                  });
                return mi;
              };
              ai.exports = di;
            })
          ),
          /***/
          "./node_modules/mux.js/lib/utils/clock.js": (
            /*!************************************************!*\
              !*** ./node_modules/mux.js/lib/utils/clock.js ***!
              \************************************************/
            /***/
            ((ai) => {
              var li = 9e4, oi, si, di, fi, gi, mi, Ti;
              oi = function(vi) {
                return vi * li;
              }, si = function(vi, xi) {
                return vi * xi;
              }, di = function(vi) {
                return vi / li;
              }, fi = function(vi, xi) {
                return vi / xi;
              }, gi = function(vi, xi) {
                return oi(fi(vi, xi));
              }, mi = function(vi, xi) {
                return si(di(vi), xi);
              }, Ti = function(vi, xi, Si) {
                return di(Si ? vi : vi - xi);
              }, ai.exports = {
                ONE_SECOND_IN_TS: li,
                secondsToVideoTs: oi,
                secondsToAudioTs: si,
                videoTsToSeconds: di,
                audioTsToSeconds: fi,
                audioTsToVideoTs: gi,
                videoTsToAudioTs: mi,
                metadataTsToSeconds: Ti
              };
            })
          ),
          /***/
          "./node_modules/mux.js/lib/utils/numbers.js": (
            /*!**************************************************!*\
              !*** ./node_modules/mux.js/lib/utils/numbers.js ***!
              \**************************************************/
            /***/
            ((ai) => {
              var li = Math.pow(2, 32), oi = function(si) {
                var di = new DataView(si.buffer, si.byteOffset, si.byteLength), fi;
                return di.getBigUint64 ? (fi = di.getBigUint64(0), fi < Number.MAX_SAFE_INTEGER ? Number(fi) : fi) : di.getUint32(0) * li + di.getUint32(4);
              };
              ai.exports = {
                getUint64: oi,
                MAX_UINT32: li
              };
            })
          ),
          /***/
          "./node_modules/object-is/implementation.js": (
            /*!**************************************************!*\
              !*** ./node_modules/object-is/implementation.js ***!
              \**************************************************/
            /***/
            ((ai) => {
              var li = function(oi) {
                return oi !== oi;
              };
              ai.exports = function(si, di) {
                return si === 0 && di === 0 ? 1 / si === 1 / di : !!(si === di || li(si) && li(di));
              };
            })
          ),
          /***/
          "./node_modules/object-is/index.js": (
            /*!*****************************************!*\
              !*** ./node_modules/object-is/index.js ***!
              \*****************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! define-properties */
                "./node_modules/define-properties/index.js"
              ), di = oi(
                /*! call-bind */
                "./node_modules/call-bind/index.js"
              ), fi = oi(
                /*! ./implementation */
                "./node_modules/object-is/implementation.js"
              ), gi = oi(
                /*! ./polyfill */
                "./node_modules/object-is/polyfill.js"
              ), mi = oi(
                /*! ./shim */
                "./node_modules/object-is/shim.js"
              ), Ti = di(gi(), Object);
              si(Ti, {
                getPolyfill: gi,
                implementation: fi,
                shim: mi
              }), ai.exports = Ti;
            })
          ),
          /***/
          "./node_modules/object-is/polyfill.js": (
            /*!********************************************!*\
              !*** ./node_modules/object-is/polyfill.js ***!
              \********************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! ./implementation */
                "./node_modules/object-is/implementation.js"
              );
              ai.exports = function() {
                return typeof Object.is == "function" ? Object.is : si;
              };
            })
          ),
          /***/
          "./node_modules/object-is/shim.js": (
            /*!****************************************!*\
              !*** ./node_modules/object-is/shim.js ***!
              \****************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! ./polyfill */
                "./node_modules/object-is/polyfill.js"
              ), di = oi(
                /*! define-properties */
                "./node_modules/define-properties/index.js"
              );
              ai.exports = function() {
                var gi = si();
                return di(Object, { is: gi }, {
                  is: function() {
                    return Object.is !== gi;
                  }
                }), gi;
              };
            })
          ),
          /***/
          "./node_modules/object-keys/implementation.js": (
            /*!****************************************************!*\
              !*** ./node_modules/object-keys/implementation.js ***!
              \****************************************************/
            /***/
            ((ai, li, oi) => {
              var si;
              if (!Object.keys) {
                var di = Object.prototype.hasOwnProperty, fi = Object.prototype.toString, gi = oi(
                  /*! ./isArguments */
                  "./node_modules/object-keys/isArguments.js"
                ), mi = Object.prototype.propertyIsEnumerable, Ti = !mi.call({ toString: null }, "toString"), vi = mi.call(function() {
                }, "prototype"), xi = [
                  "toString",
                  "toLocaleString",
                  "valueOf",
                  "hasOwnProperty",
                  "isPrototypeOf",
                  "propertyIsEnumerable",
                  "constructor"
                ], Si = function(Di) {
                  var Mi = Di.constructor;
                  return Mi && Mi.prototype === Di;
                }, Pi = {
                  $applicationCache: !0,
                  $console: !0,
                  $external: !0,
                  $frame: !0,
                  $frameElement: !0,
                  $frames: !0,
                  $innerHeight: !0,
                  $innerWidth: !0,
                  $onmozfullscreenchange: !0,
                  $onmozfullscreenerror: !0,
                  $outerHeight: !0,
                  $outerWidth: !0,
                  $pageXOffset: !0,
                  $pageYOffset: !0,
                  $parent: !0,
                  $scrollLeft: !0,
                  $scrollTop: !0,
                  $scrollX: !0,
                  $scrollY: !0,
                  $self: !0,
                  $webkitIndexedDB: !0,
                  $webkitStorageInfo: !0,
                  $window: !0
                }, $i = (function() {
                  if (typeof window > "u")
                    return !1;
                  for (var Di in window)
                    try {
                      if (!Pi["$" + Di] && di.call(window, Di) && window[Di] !== null && typeof window[Di] == "object")
                        try {
                          Si(window[Di]);
                        } catch {
                          return !0;
                        }
                    } catch {
                      return !0;
                    }
                  return !1;
                })(), Oi = function(Di) {
                  if (typeof window > "u" || !$i)
                    return Si(Di);
                  try {
                    return Si(Di);
                  } catch {
                    return !1;
                  }
                };
                si = function(Mi) {
                  var Oo = Mi !== null && typeof Mi == "object", io = fi.call(Mi) === "[object Function]", xo = gi(Mi), fo = Oo && fi.call(Mi) === "[object String]", _o = [];
                  if (!Oo && !io && !xo)
                    throw new TypeError("Object.keys called on a non-object");
                  var Li = vi && io;
                  if (fo && Mi.length > 0 && !di.call(Mi, 0))
                    for (var Co = 0; Co < Mi.length; ++Co)
                      _o.push(String(Co));
                  if (xo && Mi.length > 0)
                    for (var Ni = 0; Ni < Mi.length; ++Ni)
                      _o.push(String(Ni));
                  else
                    for (var Yi in Mi)
                      !(Li && Yi === "prototype") && di.call(Mi, Yi) && _o.push(String(Yi));
                  if (Ti)
                    for (var Vo = Oi(Mi), No = 0; No < xi.length; ++No)
                      !(Vo && xi[No] === "constructor") && di.call(Mi, xi[No]) && _o.push(xi[No]);
                  return _o;
                };
              }
              ai.exports = si;
            })
          ),
          /***/
          "./node_modules/object-keys/index.js": (
            /*!*******************************************!*\
              !*** ./node_modules/object-keys/index.js ***!
              \*******************************************/
            /***/
            ((ai, li, oi) => {
              var si = Array.prototype.slice, di = oi(
                /*! ./isArguments */
                "./node_modules/object-keys/isArguments.js"
              ), fi = Object.keys, gi = fi ? function(vi) {
                return fi(vi);
              } : oi(
                /*! ./implementation */
                "./node_modules/object-keys/implementation.js"
              ), mi = Object.keys;
              gi.shim = function() {
                if (Object.keys) {
                  var vi = (function() {
                    var xi = Object.keys(arguments);
                    return xi && xi.length === arguments.length;
                  })(1, 2);
                  vi || (Object.keys = function(Si) {
                    return di(Si) ? mi(si.call(Si)) : mi(Si);
                  });
                } else
                  Object.keys = gi;
                return Object.keys || gi;
              }, ai.exports = gi;
            })
          ),
          /***/
          "./node_modules/object-keys/isArguments.js": (
            /*!*************************************************!*\
              !*** ./node_modules/object-keys/isArguments.js ***!
              \*************************************************/
            /***/
            ((ai) => {
              var li = Object.prototype.toString;
              ai.exports = function(si) {
                var di = li.call(si), fi = di === "[object Arguments]";
                return fi || (fi = di !== "[object Array]" && si !== null && typeof si == "object" && typeof si.length == "number" && si.length >= 0 && li.call(si.callee) === "[object Function]"), fi;
              };
            })
          ),
          /***/
          "./node_modules/object.assign/implementation.js": (
            /*!******************************************************!*\
              !*** ./node_modules/object.assign/implementation.js ***!
              \******************************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! object-keys */
                "./node_modules/object-keys/index.js"
              ), di = oi(
                /*! has-symbols/shams */
                "./node_modules/has-symbols/shams.js"
              )(), fi = oi(
                /*! call-bound */
                "./node_modules/call-bound/index.js"
              ), gi = oi(
                /*! es-object-atoms */
                "./node_modules/es-object-atoms/index.js"
              ), mi = fi("Array.prototype.push"), Ti = fi("Object.prototype.propertyIsEnumerable"), vi = di ? gi.getOwnPropertySymbols : null;
              ai.exports = function(Si, Pi) {
                if (Si == null)
                  throw new TypeError("target must be an object");
                var $i = gi(Si);
                if (arguments.length === 1)
                  return $i;
                for (var Oi = 1; Oi < arguments.length; ++Oi) {
                  var Di = gi(arguments[Oi]), Mi = si(Di), Oo = di && (gi.getOwnPropertySymbols || vi);
                  if (Oo)
                    for (var io = Oo(Di), xo = 0; xo < io.length; ++xo) {
                      var fo = io[xo];
                      Ti(Di, fo) && mi(Mi, fo);
                    }
                  for (var _o = 0; _o < Mi.length; ++_o) {
                    var Li = Mi[_o];
                    if (Ti(Di, Li)) {
                      var Co = Di[Li];
                      $i[Li] = Co;
                    }
                  }
                }
                return $i;
              };
            })
          ),
          /***/
          "./node_modules/object.assign/polyfill.js": (
            /*!************************************************!*\
              !*** ./node_modules/object.assign/polyfill.js ***!
              \************************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! ./implementation */
                "./node_modules/object.assign/implementation.js"
              ), di = function() {
                if (!Object.assign)
                  return !1;
                for (var gi = "abcdefghijklmnopqrst", mi = gi.split(""), Ti = {}, vi = 0; vi < mi.length; ++vi)
                  Ti[mi[vi]] = mi[vi];
                var xi = Object.assign({}, Ti), Si = "";
                for (var Pi in xi)
                  Si += Pi;
                return gi !== Si;
              }, fi = function() {
                if (!Object.assign || !Object.preventExtensions)
                  return !1;
                var gi = Object.preventExtensions({ 1: 2 });
                try {
                  Object.assign(gi, "xy");
                } catch {
                  return gi[1] === "y";
                }
                return !1;
              };
              ai.exports = function() {
                return !Object.assign || di() || fi() ? si : Object.assign;
              };
            })
          ),
          /***/
          "./node_modules/possible-typed-array-names/index.js": (
            /*!**********************************************************!*\
              !*** ./node_modules/possible-typed-array-names/index.js ***!
              \**********************************************************/
            /***/
            ((ai) => {
              ai.exports = [
                "Float16Array",
                "Float32Array",
                "Float64Array",
                "Int8Array",
                "Int16Array",
                "Int32Array",
                "Uint8Array",
                "Uint8ClampedArray",
                "Uint16Array",
                "Uint32Array",
                "BigInt64Array",
                "BigUint64Array"
              ];
            })
          ),
          /***/
          "./node_modules/safe-json-parse/tuple.js": (
            /*!***********************************************!*\
              !*** ./node_modules/safe-json-parse/tuple.js ***!
              \***********************************************/
            /***/
            ((ai) => {
              ai.exports = li;
              function li(oi, si) {
                var di, fi = null;
                try {
                  di = JSON.parse(oi, si);
                } catch (gi) {
                  fi = gi;
                }
                return [fi, di];
              }
            })
          ),
          /***/
          "./node_modules/safe-regex-test/index.js": (
            /*!***********************************************!*\
              !*** ./node_modules/safe-regex-test/index.js ***!
              \***********************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! call-bound */
                "./node_modules/call-bound/index.js"
              ), di = oi(
                /*! is-regex */
                "./node_modules/is-regex/index.js"
              ), fi = si("RegExp.prototype.exec"), gi = oi(
                /*! es-errors/type */
                "./node_modules/es-errors/type.js"
              );
              ai.exports = function(Ti) {
                if (!di(Ti))
                  throw new gi("`regex` must be a RegExp");
                return function(xi) {
                  return fi(Ti, xi) !== null;
                };
              };
            })
          ),
          /***/
          "./node_modules/set-function-length/index.js": (
            /*!***************************************************!*\
              !*** ./node_modules/set-function-length/index.js ***!
              \***************************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! get-intrinsic */
                "./node_modules/get-intrinsic/index.js"
              ), di = oi(
                /*! define-data-property */
                "./node_modules/define-data-property/index.js"
              ), fi = oi(
                /*! has-property-descriptors */
                "./node_modules/has-property-descriptors/index.js"
              )(), gi = oi(
                /*! gopd */
                "./node_modules/gopd/index.js"
              ), mi = oi(
                /*! es-errors/type */
                "./node_modules/es-errors/type.js"
              ), Ti = si("%Math.floor%");
              ai.exports = function(xi, Si) {
                if (typeof xi != "function")
                  throw new mi("`fn` is not a function");
                if (typeof Si != "number" || Si < 0 || Si > 4294967295 || Ti(Si) !== Si)
                  throw new mi("`length` must be a positive 32-bit integer");
                var Pi = arguments.length > 2 && !!arguments[2], $i = !0, Oi = !0;
                if ("length" in xi && gi) {
                  var Di = gi(xi, "length");
                  Di && !Di.configurable && ($i = !1), Di && !Di.writable && (Oi = !1);
                }
                return ($i || Oi || !Pi) && (fi ? di(
                  /** @type {Parameters<define>[0]} */
                  xi,
                  "length",
                  Si,
                  !0,
                  !0
                ) : di(
                  /** @type {Parameters<define>[0]} */
                  xi,
                  "length",
                  Si
                )), xi;
              };
            })
          ),
          /***/
          "./node_modules/url-toolkit/src/url-toolkit.js": (
            /*!*****************************************************!*\
              !*** ./node_modules/url-toolkit/src/url-toolkit.js ***!
              \*****************************************************/
            /***/
            (function(ai) {
              (function(li) {
                var oi = /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/, si = /^(?=([^\/?#]*))\1([^]*)$/, di = /(?:\/|^)\.(?=\/)/g, fi = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g, gi = {
                  // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
                  // E.g
                  // With opts.alwaysNormalize = false (default, spec compliant)
                  // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
                  // With opts.alwaysNormalize = true (not spec compliant)
                  // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
                  buildAbsoluteURL: function(mi, Ti, vi) {
                    if (vi = vi || {}, mi = mi.trim(), Ti = Ti.trim(), !Ti) {
                      if (!vi.alwaysNormalize)
                        return mi;
                      var xi = gi.parseURL(mi);
                      if (!xi)
                        throw new Error("Error trying to parse base URL.");
                      return xi.path = gi.normalizePath(
                        xi.path
                      ), gi.buildURLFromParts(xi);
                    }
                    var Si = gi.parseURL(Ti);
                    if (!Si)
                      throw new Error("Error trying to parse relative URL.");
                    if (Si.scheme)
                      return vi.alwaysNormalize ? (Si.path = gi.normalizePath(Si.path), gi.buildURLFromParts(Si)) : Ti;
                    var Pi = gi.parseURL(mi);
                    if (!Pi)
                      throw new Error("Error trying to parse base URL.");
                    if (!Pi.netLoc && Pi.path && Pi.path[0] !== "/") {
                      var $i = si.exec(Pi.path);
                      Pi.netLoc = $i[1], Pi.path = $i[2];
                    }
                    Pi.netLoc && !Pi.path && (Pi.path = "/");
                    var Oi = {
                      // 2c) Otherwise, the embedded URL inherits the scheme of
                      // the base URL.
                      scheme: Pi.scheme,
                      netLoc: Si.netLoc,
                      path: null,
                      params: Si.params,
                      query: Si.query,
                      fragment: Si.fragment
                    };
                    if (!Si.netLoc && (Oi.netLoc = Pi.netLoc, Si.path[0] !== "/"))
                      if (!Si.path)
                        Oi.path = Pi.path, Si.params || (Oi.params = Pi.params, Si.query || (Oi.query = Pi.query));
                      else {
                        var Di = Pi.path, Mi = Di.substring(0, Di.lastIndexOf("/") + 1) + Si.path;
                        Oi.path = gi.normalizePath(Mi);
                      }
                    return Oi.path === null && (Oi.path = vi.alwaysNormalize ? gi.normalizePath(Si.path) : Si.path), gi.buildURLFromParts(Oi);
                  },
                  parseURL: function(mi) {
                    var Ti = oi.exec(mi);
                    return Ti ? {
                      scheme: Ti[1] || "",
                      netLoc: Ti[2] || "",
                      path: Ti[3] || "",
                      params: Ti[4] || "",
                      query: Ti[5] || "",
                      fragment: Ti[6] || ""
                    } : null;
                  },
                  normalizePath: function(mi) {
                    for (mi = mi.split("").reverse().join("").replace(di, ""); mi.length !== (mi = mi.replace(fi, "")).length; )
                      ;
                    return mi.split("").reverse().join("");
                  },
                  buildURLFromParts: function(mi) {
                    return mi.scheme + mi.netLoc + mi.path + mi.params + mi.query + mi.fragment;
                  }
                };
                ai.exports = gi;
              })();
            })
          ),
          /***/
          "./node_modules/util/support/isBufferBrowser.js": (
            /*!******************************************************!*\
              !*** ./node_modules/util/support/isBufferBrowser.js ***!
              \******************************************************/
            /***/
            ((ai) => {
              ai.exports = function(oi) {
                return oi && typeof oi == "object" && typeof oi.copy == "function" && typeof oi.fill == "function" && typeof oi.readUInt8 == "function";
              };
            })
          ),
          /***/
          "./node_modules/util/support/types.js": (
            /*!********************************************!*\
              !*** ./node_modules/util/support/types.js ***!
              \********************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! is-arguments */
                "./node_modules/is-arguments/index.js"
              ), di = oi(
                /*! is-generator-function */
                "./node_modules/is-generator-function/index.js"
              ), fi = oi(
                /*! which-typed-array */
                "./node_modules/which-typed-array/index.js"
              ), gi = oi(
                /*! is-typed-array */
                "./node_modules/is-typed-array/index.js"
              );
              function mi(_a) {
                return _a.call.bind(_a);
              }
              var Ti = typeof BigInt < "u", vi = typeof Symbol < "u", xi = mi(Object.prototype.toString), Si = mi(Number.prototype.valueOf), Pi = mi(String.prototype.valueOf), $i = mi(Boolean.prototype.valueOf);
              if (Ti)
                var Oi = mi(BigInt.prototype.valueOf);
              if (vi)
                var Di = mi(Symbol.prototype.valueOf);
              function Mi(_a, _s) {
                if (typeof _a != "object")
                  return !1;
                try {
                  return _s(_a), !0;
                } catch {
                  return !1;
                }
              }
              li.isArgumentsObject = si, li.isGeneratorFunction = di, li.isTypedArray = gi;
              function Oo(_a) {
                return typeof Promise < "u" && _a instanceof Promise || _a !== null && typeof _a == "object" && typeof _a.then == "function" && typeof _a.catch == "function";
              }
              li.isPromise = Oo;
              function io(_a) {
                return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(_a) : gi(_a) || ra(_a);
              }
              li.isArrayBufferView = io;
              function xo(_a) {
                return fi(_a) === "Uint8Array";
              }
              li.isUint8Array = xo;
              function fo(_a) {
                return fi(_a) === "Uint8ClampedArray";
              }
              li.isUint8ClampedArray = fo;
              function _o(_a) {
                return fi(_a) === "Uint16Array";
              }
              li.isUint16Array = _o;
              function Li(_a) {
                return fi(_a) === "Uint32Array";
              }
              li.isUint32Array = Li;
              function Co(_a) {
                return fi(_a) === "Int8Array";
              }
              li.isInt8Array = Co;
              function Ni(_a) {
                return fi(_a) === "Int16Array";
              }
              li.isInt16Array = Ni;
              function Yi(_a) {
                return fi(_a) === "Int32Array";
              }
              li.isInt32Array = Yi;
              function Vo(_a) {
                return fi(_a) === "Float32Array";
              }
              li.isFloat32Array = Vo;
              function No(_a) {
                return fi(_a) === "Float64Array";
              }
              li.isFloat64Array = No;
              function Ui(_a) {
                return fi(_a) === "BigInt64Array";
              }
              li.isBigInt64Array = Ui;
              function jo(_a) {
                return fi(_a) === "BigUint64Array";
              }
              li.isBigUint64Array = jo;
              function Wi(_a) {
                return xi(_a) === "[object Map]";
              }
              Wi.working = typeof Map < "u" && Wi(/* @__PURE__ */ new Map());
              function ji(_a) {
                return typeof Map > "u" ? !1 : Wi.working ? Wi(_a) : _a instanceof Map;
              }
              li.isMap = ji;
              function Hi(_a) {
                return xi(_a) === "[object Set]";
              }
              Hi.working = typeof Set < "u" && Hi(/* @__PURE__ */ new Set());
              function zo(_a) {
                return typeof Set > "u" ? !1 : Hi.working ? Hi(_a) : _a instanceof Set;
              }
              li.isSet = zo;
              function Lo(_a) {
                return xi(_a) === "[object WeakMap]";
              }
              Lo.working = typeof WeakMap < "u" && Lo(/* @__PURE__ */ new WeakMap());
              function sa(_a) {
                return typeof WeakMap > "u" ? !1 : Lo.working ? Lo(_a) : _a instanceof WeakMap;
              }
              li.isWeakMap = sa;
              function Ko(_a) {
                return xi(_a) === "[object WeakSet]";
              }
              Ko.working = typeof WeakSet < "u" && Ko(/* @__PURE__ */ new WeakSet());
              function ca(_a) {
                return Ko(_a);
              }
              li.isWeakSet = ca;
              function pa(_a) {
                return xi(_a) === "[object ArrayBuffer]";
              }
              pa.working = typeof ArrayBuffer < "u" && pa(new ArrayBuffer());
              function ga(_a) {
                return typeof ArrayBuffer > "u" ? !1 : pa.working ? pa(_a) : _a instanceof ArrayBuffer;
              }
              li.isArrayBuffer = ga;
              function ia(_a) {
                return xi(_a) === "[object DataView]";
              }
              ia.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && ia(new DataView(new ArrayBuffer(1), 0, 1));
              function ra(_a) {
                return typeof DataView > "u" ? !1 : ia.working ? ia(_a) : _a instanceof DataView;
              }
              li.isDataView = ra;
              var qo = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
              function xa(_a) {
                return xi(_a) === "[object SharedArrayBuffer]";
              }
              function $a(_a) {
                return typeof qo > "u" ? !1 : (typeof xa.working > "u" && (xa.working = xa(new qo())), xa.working ? xa(_a) : _a instanceof qo);
              }
              li.isSharedArrayBuffer = $a;
              function ys(_a) {
                return xi(_a) === "[object AsyncFunction]";
              }
              li.isAsyncFunction = ys;
              function Ss(_a) {
                return xi(_a) === "[object Map Iterator]";
              }
              li.isMapIterator = Ss;
              function Xa(_a) {
                return xi(_a) === "[object Set Iterator]";
              }
              li.isSetIterator = Xa;
              function Es(_a) {
                return xi(_a) === "[object Generator]";
              }
              li.isGeneratorObject = Es;
              function Rs(_a) {
                return xi(_a) === "[object WebAssembly.Module]";
              }
              li.isWebAssemblyCompiledModule = Rs;
              function La(_a) {
                return Mi(_a, Si);
              }
              li.isNumberObject = La;
              function Ja(_a) {
                return Mi(_a, Pi);
              }
              li.isStringObject = Ja;
              function ja(_a) {
                return Mi(_a, $i);
              }
              li.isBooleanObject = ja;
              function Ta(_a) {
                return Ti && Mi(_a, Oi);
              }
              li.isBigIntObject = Ta;
              function rs(_a) {
                return vi && Mi(_a, Di);
              }
              li.isSymbolObject = rs;
              function Qa(_a) {
                return La(_a) || Ja(_a) || ja(_a) || Ta(_a) || rs(_a);
              }
              li.isBoxedPrimitive = Qa;
              function Cs(_a) {
                return typeof Uint8Array < "u" && (ga(_a) || $a(_a));
              }
              li.isAnyArrayBuffer = Cs, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(_a) {
                Object.defineProperty(li, _a, {
                  enumerable: !1,
                  value: function() {
                    throw new Error(_a + " is not supported in userland");
                  }
                });
              });
            })
          ),
          /***/
          "./node_modules/util/util.js": (
            /*!***********************************!*\
              !*** ./node_modules/util/util.js ***!
              \***********************************/
            /***/
            ((ai, li, oi) => {
              var si = Object.getOwnPropertyDescriptors || function(ra) {
                for (var qo = Object.keys(ra), xa = {}, $a = 0; $a < qo.length; $a++)
                  xa[qo[$a]] = Object.getOwnPropertyDescriptor(ra, qo[$a]);
                return xa;
              }, di = /%[sdj%]/g;
              li.format = function(ia) {
                if (!Co(ia)) {
                  for (var ra = [], qo = 0; qo < arguments.length; qo++)
                    ra.push(Ti(arguments[qo]));
                  return ra.join(" ");
                }
                for (var qo = 1, xa = arguments, $a = xa.length, ys = String(ia).replace(di, function(Xa) {
                  if (Xa === "%%") return "%";
                  if (qo >= $a) return Xa;
                  switch (Xa) {
                    case "%s":
                      return String(xa[qo++]);
                    case "%d":
                      return Number(xa[qo++]);
                    case "%j":
                      try {
                        return JSON.stringify(xa[qo++]);
                      } catch {
                        return "[Circular]";
                      }
                    default:
                      return Xa;
                  }
                }), Ss = xa[qo]; qo < $a; Ss = xa[++qo])
                  fo(Ss) || !No(Ss) ? ys += " " + Ss : ys += " " + Ti(Ss);
                return ys;
              }, li.deprecate = function(ia, ra) {
                if (typeof process < "u" && process.noDeprecation === !0)
                  return ia;
                if (typeof process > "u")
                  return function() {
                    return li.deprecate(ia, ra).apply(this, arguments);
                  };
                var qo = !1;
                function xa() {
                  if (!qo) {
                    if (process.throwDeprecation)
                      throw new Error(ra);
                    process.traceDeprecation ? console.trace(ra) : console.error(ra), qo = !0;
                  }
                  return ia.apply(this, arguments);
                }
                return xa;
              };
              var fi = {}, gi = /^$/;
              if ({}.NODE_DEBUG) {
                var mi = {}.NODE_DEBUG;
                mi = mi.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), gi = new RegExp("^" + mi + "$", "i");
              }
              li.debuglog = function(ia) {
                if (ia = ia.toUpperCase(), !fi[ia])
                  if (gi.test(ia)) {
                    var ra = process.pid;
                    fi[ia] = function() {
                      var qo = li.format.apply(li, arguments);
                      console.error("%s %d: %s", ia, ra, qo);
                    };
                  } else
                    fi[ia] = function() {
                    };
                return fi[ia];
              };
              function Ti(ia, ra) {
                var qo = {
                  seen: [],
                  stylize: xi
                };
                return arguments.length >= 3 && (qo.depth = arguments[2]), arguments.length >= 4 && (qo.colors = arguments[3]), xo(ra) ? qo.showHidden = ra : ra && li._extend(qo, ra), Yi(qo.showHidden) && (qo.showHidden = !1), Yi(qo.depth) && (qo.depth = 2), Yi(qo.colors) && (qo.colors = !1), Yi(qo.customInspect) && (qo.customInspect = !0), qo.colors && (qo.stylize = vi), Pi(qo, ia, qo.depth);
              }
              li.inspect = Ti, Ti.colors = {
                bold: [1, 22],
                italic: [3, 23],
                underline: [4, 24],
                inverse: [7, 27],
                white: [37, 39],
                grey: [90, 39],
                black: [30, 39],
                blue: [34, 39],
                cyan: [36, 39],
                green: [32, 39],
                magenta: [35, 39],
                red: [31, 39],
                yellow: [33, 39]
              }, Ti.styles = {
                special: "cyan",
                number: "yellow",
                boolean: "yellow",
                undefined: "grey",
                null: "bold",
                string: "green",
                date: "magenta",
                // "name": intentionally not styling
                regexp: "red"
              };
              function vi(ia, ra) {
                var qo = Ti.styles[ra];
                return qo ? "\x1B[" + Ti.colors[qo][0] + "m" + ia + "\x1B[" + Ti.colors[qo][1] + "m" : ia;
              }
              function xi(ia, ra) {
                return ia;
              }
              function Si(ia) {
                var ra = {};
                return ia.forEach(function(qo, xa) {
                  ra[qo] = !0;
                }), ra;
              }
              function Pi(ia, ra, qo) {
                if (ia.customInspect && ra && Wi(ra.inspect) && // Filter out the util module, it's inspect function is special
                ra.inspect !== li.inspect && // Also filter out any prototype objects using the circular check.
                !(ra.constructor && ra.constructor.prototype === ra)) {
                  var xa = ra.inspect(qo, ia);
                  return Co(xa) || (xa = Pi(ia, xa, qo)), xa;
                }
                var $a = $i(ia, ra);
                if ($a)
                  return $a;
                var ys = Object.keys(ra), Ss = Si(ys);
                if (ia.showHidden && (ys = Object.getOwnPropertyNames(ra)), jo(ra) && (ys.indexOf("message") >= 0 || ys.indexOf("description") >= 0))
                  return Oi(ra);
                if (ys.length === 0) {
                  if (Wi(ra)) {
                    var Xa = ra.name ? ": " + ra.name : "";
                    return ia.stylize("[Function" + Xa + "]", "special");
                  }
                  if (Vo(ra))
                    return ia.stylize(RegExp.prototype.toString.call(ra), "regexp");
                  if (Ui(ra))
                    return ia.stylize(Date.prototype.toString.call(ra), "date");
                  if (jo(ra))
                    return Oi(ra);
                }
                var Es = "", Rs = !1, La = ["{", "}"];
                if (io(ra) && (Rs = !0, La = ["[", "]"]), Wi(ra)) {
                  var Ja = ra.name ? ": " + ra.name : "";
                  Es = " [Function" + Ja + "]";
                }
                if (Vo(ra) && (Es = " " + RegExp.prototype.toString.call(ra)), Ui(ra) && (Es = " " + Date.prototype.toUTCString.call(ra)), jo(ra) && (Es = " " + Oi(ra)), ys.length === 0 && (!Rs || ra.length == 0))
                  return La[0] + Es + La[1];
                if (qo < 0)
                  return Vo(ra) ? ia.stylize(RegExp.prototype.toString.call(ra), "regexp") : ia.stylize("[Object]", "special");
                ia.seen.push(ra);
                var ja;
                return Rs ? ja = Di(ia, ra, qo, Ss, ys) : ja = ys.map(function(Ta) {
                  return Mi(ia, ra, qo, Ss, Ta, Rs);
                }), ia.seen.pop(), Oo(ja, Es, La);
              }
              function $i(ia, ra) {
                if (Yi(ra))
                  return ia.stylize("undefined", "undefined");
                if (Co(ra)) {
                  var qo = "'" + JSON.stringify(ra).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
                  return ia.stylize(qo, "string");
                }
                if (Li(ra))
                  return ia.stylize("" + ra, "number");
                if (xo(ra))
                  return ia.stylize("" + ra, "boolean");
                if (fo(ra))
                  return ia.stylize("null", "null");
              }
              function Oi(ia) {
                return "[" + Error.prototype.toString.call(ia) + "]";
              }
              function Di(ia, ra, qo, xa, $a) {
                for (var ys = [], Ss = 0, Xa = ra.length; Ss < Xa; ++Ss)
                  Ko(ra, String(Ss)) ? ys.push(Mi(
                    ia,
                    ra,
                    qo,
                    xa,
                    String(Ss),
                    !0
                  )) : ys.push("");
                return $a.forEach(function(Es) {
                  Es.match(/^\d+$/) || ys.push(Mi(
                    ia,
                    ra,
                    qo,
                    xa,
                    Es,
                    !0
                  ));
                }), ys;
              }
              function Mi(ia, ra, qo, xa, $a, ys) {
                var Ss, Xa, Es;
                if (Es = Object.getOwnPropertyDescriptor(ra, $a) || { value: ra[$a] }, Es.get ? Es.set ? Xa = ia.stylize("[Getter/Setter]", "special") : Xa = ia.stylize("[Getter]", "special") : Es.set && (Xa = ia.stylize("[Setter]", "special")), Ko(xa, $a) || (Ss = "[" + $a + "]"), Xa || (ia.seen.indexOf(Es.value) < 0 ? (fo(qo) ? Xa = Pi(ia, Es.value, null) : Xa = Pi(ia, Es.value, qo - 1), Xa.indexOf(`
`) > -1 && (ys ? Xa = Xa.split(`
`).map(function(Rs) {
                  return "  " + Rs;
                }).join(`
`).slice(2) : Xa = `
` + Xa.split(`
`).map(function(Rs) {
                  return "   " + Rs;
                }).join(`
`))) : Xa = ia.stylize("[Circular]", "special")), Yi(Ss)) {
                  if (ys && $a.match(/^\d+$/))
                    return Xa;
                  Ss = JSON.stringify("" + $a), Ss.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (Ss = Ss.slice(1, -1), Ss = ia.stylize(Ss, "name")) : (Ss = Ss.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), Ss = ia.stylize(Ss, "string"));
                }
                return Ss + ": " + Xa;
              }
              function Oo(ia, ra, qo) {
                var xa = ia.reduce(function($a, ys) {
                  return ys.indexOf(`
`) >= 0, $a + ys.replace(/\u001b\[\d\d?m/g, "").length + 1;
                }, 0);
                return xa > 60 ? qo[0] + (ra === "" ? "" : ra + `
 `) + " " + ia.join(`,
  `) + " " + qo[1] : qo[0] + ra + " " + ia.join(", ") + " " + qo[1];
              }
              li.types = oi(
                /*! ./support/types */
                "./node_modules/util/support/types.js"
              );
              function io(ia) {
                return Array.isArray(ia);
              }
              li.isArray = io;
              function xo(ia) {
                return typeof ia == "boolean";
              }
              li.isBoolean = xo;
              function fo(ia) {
                return ia === null;
              }
              li.isNull = fo;
              function _o(ia) {
                return ia == null;
              }
              li.isNullOrUndefined = _o;
              function Li(ia) {
                return typeof ia == "number";
              }
              li.isNumber = Li;
              function Co(ia) {
                return typeof ia == "string";
              }
              li.isString = Co;
              function Ni(ia) {
                return typeof ia == "symbol";
              }
              li.isSymbol = Ni;
              function Yi(ia) {
                return ia === void 0;
              }
              li.isUndefined = Yi;
              function Vo(ia) {
                return No(ia) && Hi(ia) === "[object RegExp]";
              }
              li.isRegExp = Vo, li.types.isRegExp = Vo;
              function No(ia) {
                return typeof ia == "object" && ia !== null;
              }
              li.isObject = No;
              function Ui(ia) {
                return No(ia) && Hi(ia) === "[object Date]";
              }
              li.isDate = Ui, li.types.isDate = Ui;
              function jo(ia) {
                return No(ia) && (Hi(ia) === "[object Error]" || ia instanceof Error);
              }
              li.isError = jo, li.types.isNativeError = jo;
              function Wi(ia) {
                return typeof ia == "function";
              }
              li.isFunction = Wi;
              function ji(ia) {
                return ia === null || typeof ia == "boolean" || typeof ia == "number" || typeof ia == "string" || typeof ia == "symbol" || // ES6 symbol
                typeof ia > "u";
              }
              li.isPrimitive = ji, li.isBuffer = oi(
                /*! ./support/isBuffer */
                "./node_modules/util/support/isBufferBrowser.js"
              );
              function Hi(ia) {
                return Object.prototype.toString.call(ia);
              }
              function zo(ia) {
                return ia < 10 ? "0" + ia.toString(10) : ia.toString(10);
              }
              var Lo = [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
              ];
              function sa() {
                var ia = /* @__PURE__ */ new Date(), ra = [
                  zo(ia.getHours()),
                  zo(ia.getMinutes()),
                  zo(ia.getSeconds())
                ].join(":");
                return [ia.getDate(), Lo[ia.getMonth()], ra].join(" ");
              }
              li.log = function() {
                console.log("%s - %s", sa(), li.format.apply(li, arguments));
              }, li.inherits = oi(
                /*! inherits */
                "./node_modules/inherits/inherits_browser.js"
              ), li._extend = function(ia, ra) {
                if (!ra || !No(ra)) return ia;
                for (var qo = Object.keys(ra), xa = qo.length; xa--; )
                  ia[qo[xa]] = ra[qo[xa]];
                return ia;
              };
              function Ko(ia, ra) {
                return Object.prototype.hasOwnProperty.call(ia, ra);
              }
              var ca = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
              li.promisify = function(ra) {
                if (typeof ra != "function")
                  throw new TypeError('The "original" argument must be of type Function');
                if (ca && ra[ca]) {
                  var qo = ra[ca];
                  if (typeof qo != "function")
                    throw new TypeError('The "util.promisify.custom" argument must be of type Function');
                  return Object.defineProperty(qo, ca, {
                    value: qo,
                    enumerable: !1,
                    writable: !1,
                    configurable: !0
                  }), qo;
                }
                function qo() {
                  for (var xa, $a, ys = new Promise(function(Es, Rs) {
                    xa = Es, $a = Rs;
                  }), Ss = [], Xa = 0; Xa < arguments.length; Xa++)
                    Ss.push(arguments[Xa]);
                  Ss.push(function(Es, Rs) {
                    Es ? $a(Es) : xa(Rs);
                  });
                  try {
                    ra.apply(this, Ss);
                  } catch (Es) {
                    $a(Es);
                  }
                  return ys;
                }
                return Object.setPrototypeOf(qo, Object.getPrototypeOf(ra)), ca && Object.defineProperty(qo, ca, {
                  value: qo,
                  enumerable: !1,
                  writable: !1,
                  configurable: !0
                }), Object.defineProperties(
                  qo,
                  si(ra)
                );
              }, li.promisify.custom = ca;
              function pa(ia, ra) {
                if (!ia) {
                  var qo = new Error("Promise was rejected with a falsy value");
                  qo.reason = ia, ia = qo;
                }
                return ra(ia);
              }
              function ga(ia) {
                if (typeof ia != "function")
                  throw new TypeError('The "original" argument must be of type Function');
                function ra() {
                  for (var qo = [], xa = 0; xa < arguments.length; xa++)
                    qo.push(arguments[xa]);
                  var $a = qo.pop();
                  if (typeof $a != "function")
                    throw new TypeError("The last argument must be of type Function");
                  var ys = this, Ss = function() {
                    return $a.apply(ys, arguments);
                  };
                  ia.apply(this, qo).then(
                    function(Xa) {
                      process.nextTick(Ss.bind(null, null, Xa));
                    },
                    function(Xa) {
                      process.nextTick(pa.bind(null, Xa, Ss));
                    }
                  );
                }
                return Object.setPrototypeOf(ra, Object.getPrototypeOf(ia)), Object.defineProperties(
                  ra,
                  si(ia)
                ), ra;
              }
              li.callbackify = ga;
            })
          ),
          /***/
          "./node_modules/video.js/dist/video.es.js": (
            /*!************************************************!*\
              !*** ./node_modules/video.js/dist/video.es.js ***!
              \************************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                default: () => Cb
                /* harmony export */
              });
              var si = oi(
                /*! global/window */
                "./node_modules/global/window.js"
              ), di = /* @__PURE__ */ oi.n(si), fi = oi(
                /*! global/document */
                "./node_modules/global/document.js"
              ), gi = /* @__PURE__ */ oi.n(fi), mi = oi(
                /*! @babel/runtime/helpers/extends */
                "./node_modules/@babel/runtime/helpers/esm/extends.js"
              ), Ti = oi(
                /*! keycode */
                "./node_modules/keycode/index.js"
              ), vi = /* @__PURE__ */ oi.n(Ti), xi = oi(
                /*! @babel/runtime/helpers/assertThisInitialized */
                "./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js"
              ), Si = oi(
                /*! @babel/runtime/helpers/inheritsLoose */
                "./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js"
              ), Pi = oi(
                /*! safe-json-parse/tuple */
                "./node_modules/safe-json-parse/tuple.js"
              ), $i = /* @__PURE__ */ oi.n(Pi), Oi = oi(
                /*! @videojs/xhr */
                "./node_modules/@videojs/xhr/lib/index.js"
              ), Di = /* @__PURE__ */ oi.n(Oi), Mi = oi(
                /*! videojs-vtt.js */
                "./node_modules/videojs-vtt.js/lib/browser-index.js"
              ), Oo = /* @__PURE__ */ oi.n(Mi), io = oi(
                /*! @babel/runtime/helpers/construct */
                "./node_modules/@babel/runtime/helpers/esm/construct.js"
              ), xo = oi(
                /*! @babel/runtime/helpers/inherits */
                "./node_modules/@babel/runtime/helpers/esm/inherits.js"
              ), fo = oi(
                /*! @videojs/vhs-utils/es/resolve-url.js */
                "./node_modules/@videojs/vhs-utils/es/resolve-url.js"
              ), _o = oi(
                /*! m3u8-parser */
                "./node_modules/m3u8-parser/dist/m3u8-parser.es.js"
              ), Li = oi(
                /*! @videojs/vhs-utils/es/codecs.js */
                "./node_modules/@videojs/vhs-utils/es/codecs.js"
              ), Co = oi(
                /*! @videojs/vhs-utils/es/media-types.js */
                "./node_modules/@videojs/vhs-utils/es/media-types.js"
              ), Ni = oi(
                /*! @videojs/vhs-utils/es/byte-helpers */
                "./node_modules/@videojs/vhs-utils/es/byte-helpers.js"
              ), Yi = oi(
                /*! mpd-parser */
                "./node_modules/mpd-parser/dist/mpd-parser.es.js"
              ), Vo = oi(
                /*! mux.js/lib/tools/parse-sidx */
                "./node_modules/mux.js/lib/tools/parse-sidx.js"
              ), No = /* @__PURE__ */ oi.n(Vo), Ui = oi(
                /*! @videojs/vhs-utils/es/id3-helpers */
                "./node_modules/@videojs/vhs-utils/es/id3-helpers.js"
              ), jo = oi(
                /*! @videojs/vhs-utils/es/containers */
                "./node_modules/@videojs/vhs-utils/es/containers.js"
              ), Wi = oi(
                /*! mux.js/lib/utils/clock */
                "./node_modules/mux.js/lib/utils/clock.js"
              ), ji = oi(
                /*! @babel/runtime/helpers/wrapNativeSuper */
                "./node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js"
              );
              /**
               * @license
               * Video.js 7.21.7 <http://videojs.com/>
               * Copyright Brightcove, Inc. <https://www.brightcove.com/>
               * Available under Apache License Version 2.0
               * <https://github.com/videojs/video.js/blob/main/LICENSE>
               *
               * Includes vtt.js <https://github.com/mozilla/vtt.js>
               * Available under Apache License Version 2.0
               * <https://github.com/mozilla/vtt.js/blob/main/LICENSE>
               */
              for (var Hi = "7.21.7", zo = {}, Lo = function(Ei, bi) {
                return zo[Ei] = zo[Ei] || [], bi && (zo[Ei] = zo[Ei].concat(bi)), zo[Ei];
              }, sa = function(Ei, bi) {
                Lo(Ei, bi);
              }, Ko = function(Ei, bi) {
                var yi = Lo(Ei).indexOf(bi);
                return yi <= -1 ? !1 : (zo[Ei] = zo[Ei].slice(), zo[Ei].splice(yi, 1), !0);
              }, ca = function(Ei, bi) {
                Lo(Ei, [].concat(bi).map(function(yi) {
                  var ci = function hi() {
                    return Ko(Ei, hi), yi.apply(void 0, arguments);
                  };
                  return ci;
                }));
              }, pa = {
                prefixed: !0
              }, ga = [
                ["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror", "fullscreen"],
                // WebKit
                ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror", "-webkit-full-screen"],
                // Mozilla
                ["mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozFullScreenEnabled", "mozfullscreenchange", "mozfullscreenerror", "-moz-full-screen"],
                // Microsoft
                ["msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "msFullscreenEnabled", "MSFullscreenChange", "MSFullscreenError", "-ms-fullscreen"]
              ], ia = ga[0], ra, qo = 0; qo < ga.length; qo++)
                if (ga[qo][1] in gi()) {
                  ra = ga[qo];
                  break;
                }
              if (ra) {
                for (var xa = 0; xa < ra.length; xa++)
                  pa[ia[xa]] = ra[xa];
                pa.prefixed = ra[0] !== ia[0];
              }
              var $a = [], ys = function(Ei, bi) {
                return function(yi, ci, hi) {
                  var wi = bi.levels[ci], zi = new RegExp("^(" + wi + ")$");
                  if (yi !== "log" && hi.unshift(yi.toUpperCase() + ":"), hi.unshift(Ei + ":"), $a) {
                    $a.push([].concat(hi));
                    var Wo = $a.length - 1e3;
                    $a.splice(0, Wo > 0 ? Wo : 0);
                  }
                  if (di().console) {
                    var aa = di().console[yi];
                    !aa && yi === "debug" && (aa = di().console.info || di().console.log), !(!aa || !wi || !zi.test(yi)) && aa[Array.isArray(hi) ? "apply" : "call"](di().console, hi);
                  }
                };
              };
              function Ss(Vi) {
                var Ei = "info", bi, yi = function() {
                  for (var hi = arguments.length, wi = new Array(hi), zi = 0; zi < hi; zi++)
                    wi[zi] = arguments[zi];
                  bi("log", Ei, wi);
                };
                return bi = ys(Vi, yi), yi.createLogger = function(ci) {
                  return Ss(Vi + ": " + ci);
                }, yi.levels = {
                  all: "debug|log|warn|error",
                  off: "",
                  debug: "debug|log|warn|error",
                  info: "log|warn|error",
                  warn: "warn|error",
                  error: "error",
                  DEFAULT: Ei
                }, yi.level = function(ci) {
                  if (typeof ci == "string") {
                    if (!yi.levels.hasOwnProperty(ci))
                      throw new Error('"' + ci + '" in not a valid log level');
                    Ei = ci;
                  }
                  return Ei;
                }, yi.history = function() {
                  return $a ? [].concat($a) : [];
                }, yi.history.filter = function(ci) {
                  return ($a || []).filter(function(hi) {
                    return new RegExp(".*" + ci + ".*").test(hi[0]);
                  });
                }, yi.history.clear = function() {
                  $a && ($a.length = 0);
                }, yi.history.disable = function() {
                  $a !== null && ($a.length = 0, $a = null);
                }, yi.history.enable = function() {
                  $a === null && ($a = []);
                }, yi.error = function() {
                  for (var ci = arguments.length, hi = new Array(ci), wi = 0; wi < ci; wi++)
                    hi[wi] = arguments[wi];
                  return bi("error", Ei, hi);
                }, yi.warn = function() {
                  for (var ci = arguments.length, hi = new Array(ci), wi = 0; wi < ci; wi++)
                    hi[wi] = arguments[wi];
                  return bi("warn", Ei, hi);
                }, yi.debug = function() {
                  for (var ci = arguments.length, hi = new Array(ci), wi = 0; wi < ci; wi++)
                    hi[wi] = arguments[wi];
                  return bi("debug", Ei, hi);
                }, yi;
              }
              var Xa = Ss("VIDEOJS"), Es = Xa.createLogger, Rs = Object.prototype.toString, La = function(Ei) {
                return rs(Ei) ? Object.keys(Ei) : [];
              };
              function Ja(Vi, Ei) {
                La(Vi).forEach(function(bi) {
                  return Ei(Vi[bi], bi);
                });
              }
              function ja(Vi, Ei, bi) {
                return bi === void 0 && (bi = 0), La(Vi).reduce(function(yi, ci) {
                  return Ei(yi, Vi[ci], ci);
                }, bi);
              }
              function Ta(Vi) {
                for (var Ei = arguments.length, bi = new Array(Ei > 1 ? Ei - 1 : 0), yi = 1; yi < Ei; yi++)
                  bi[yi - 1] = arguments[yi];
                return Object.assign ? mi.default.apply(void 0, [Vi].concat(bi)) : (bi.forEach(function(ci) {
                  ci && Ja(ci, function(hi, wi) {
                    Vi[wi] = hi;
                  });
                }), Vi);
              }
              function rs(Vi) {
                return !!Vi && typeof Vi == "object";
              }
              function Qa(Vi) {
                return rs(Vi) && Rs.call(Vi) === "[object Object]" && Vi.constructor === Object;
              }
              function Cs(Vi, Ei) {
                if (!Vi || !Ei)
                  return "";
                if (typeof di().getComputedStyle == "function") {
                  var bi;
                  try {
                    bi = di().getComputedStyle(Vi);
                  } catch {
                    return "";
                  }
                  return bi ? bi.getPropertyValue(Ei) || bi[Ei] : "";
                }
                return "";
              }
              var _a = di().navigator && di().navigator.userAgent || "", _s = /AppleWebKit\/([\d.]+)/i.exec(_a), el = _s ? parseFloat(_s.pop()) : null, Ps = /iPod/i.test(_a), nl = (function() {
                var Vi = _a.match(/OS (\d+)_/i);
                return Vi && Vi[1] ? Vi[1] : null;
              })(), Vs = /Android/i.test(_a), es = (function() {
                var Vi = _a.match(/Android (\d+)(?:\.(\d+))?(?:\.(\d+))*/i);
                if (!Vi)
                  return null;
                var Ei = Vi[1] && parseFloat(Vi[1]), bi = Vi[2] && parseFloat(Vi[2]);
                return Ei && bi ? parseFloat(Vi[1] + "." + Vi[2]) : Ei || null;
              })(), Is = Vs && es < 5 && el < 537, fl = /Firefox/i.test(_a), sl = /Edg/i.test(_a), Il = !sl && (/Chrome/i.test(_a) || /CriOS/i.test(_a)), Vl = (function() {
                var Vi = _a.match(/(Chrome|CriOS)\/(\d+)/);
                return Vi && Vi[2] ? parseFloat(Vi[2]) : null;
              })(), Bl = (function() {
                var Vi = /MSIE\s(\d+)\.\d/.exec(_a), Ei = Vi && parseFloat(Vi[1]);
                return !Ei && /Trident\/7.0/i.test(_a) && /rv:11.0/.test(_a) && (Ei = 11), Ei;
              })(), ql = /Safari/i.test(_a) && !Il && !Vs && !sl, xl = /Windows/i.test(_a), Ul = !!(Ya() && ("ontouchstart" in di() || di().navigator.maxTouchPoints || di().DocumentTouch && di().document instanceof di().DocumentTouch)), Xl = /iPad/i.test(_a) || ql && Ul && !/iPhone/i.test(_a), hu = /iPhone/i.test(_a) && !Xl, Tu = hu || Xl || Ps, Ku = (ql || Tu) && !Il, Wl = /* @__PURE__ */ Object.freeze({
                __proto__: null,
                IS_IPOD: Ps,
                IOS_VERSION: nl,
                IS_ANDROID: Vs,
                ANDROID_VERSION: es,
                IS_NATIVE_ANDROID: Is,
                IS_FIREFOX: fl,
                IS_EDGE: sl,
                IS_CHROME: Il,
                CHROME_VERSION: Vl,
                IE_VERSION: Bl,
                IS_SAFARI: ql,
                IS_WINDOWS: xl,
                TOUCH_ENABLED: Ul,
                IS_IPAD: Xl,
                IS_IPHONE: hu,
                IS_IOS: Tu,
                IS_ANY_SAFARI: Ku
              });
              function uu(Vi) {
                return typeof Vi == "string" && !!Vi.trim();
              }
              function du(Vi) {
                if (Vi.indexOf(" ") >= 0)
                  throw new Error("class has illegal whitespace characters");
              }
              function za(Vi) {
                return new RegExp("(^|\\s)" + Vi + "($|\\s)");
              }
              function Ya() {
                return gi() === di().document;
              }
              function Ws(Vi) {
                return rs(Vi) && Vi.nodeType === 1;
              }
              function wl() {
                try {
                  return di().parent !== di().self;
                } catch {
                  return !0;
                }
              }
              function Gl(Vi) {
                return function(Ei, bi) {
                  if (!uu(Ei))
                    return gi()[Vi](null);
                  uu(bi) && (bi = gi().querySelector(bi));
                  var yi = Ws(bi) ? bi : gi();
                  return yi[Vi] && yi[Vi](Ei);
                };
              }
              function bl(Vi, Ei, bi, yi) {
                Vi === void 0 && (Vi = "div"), Ei === void 0 && (Ei = {}), bi === void 0 && (bi = {});
                var ci = gi().createElement(Vi);
                return Object.getOwnPropertyNames(Ei).forEach(function(hi) {
                  var wi = Ei[hi];
                  hi.indexOf("aria-") !== -1 || hi === "role" || hi === "type" ? (Xa.warn(`Setting attributes in the second argument of createEl()
has been deprecated. Use the third argument instead.
` + ("createEl(type, properties, attributes). Attempting to set " + hi + " to " + wi + ".")), ci.setAttribute(hi, wi)) : hi === "textContent" ? Za(ci, wi) : (ci[hi] !== wi || hi === "tabIndex") && (ci[hi] = wi);
                }), Object.getOwnPropertyNames(bi).forEach(function(hi) {
                  ci.setAttribute(hi, bi[hi]);
                }), yi && Cl(ci, yi), ci;
              }
              function Za(Vi, Ei) {
                return typeof Vi.textContent > "u" ? Vi.innerText = Ei : Vi.textContent = Ei, Vi;
              }
              function rl(Vi, Ei) {
                Ei.firstChild ? Ei.insertBefore(Vi, Ei.firstChild) : Ei.appendChild(Vi);
              }
              function zs(Vi, Ei) {
                return du(Ei), Vi.classList ? Vi.classList.contains(Ei) : za(Ei).test(Vi.className);
              }
              function al(Vi, Ei) {
                return Vi.classList ? Vi.classList.add(Ei) : zs(Vi, Ei) || (Vi.className = (Vi.className + " " + Ei).trim()), Vi;
              }
              function Ol(Vi, Ei) {
                return Vi ? (Vi.classList ? Vi.classList.remove(Ei) : (du(Ei), Vi.className = Vi.className.split(/\s+/).filter(function(bi) {
                  return bi !== Ei;
                }).join(" ")), Vi) : (Xa.warn("removeClass was called with an element that doesn't exist"), null);
              }
              function $l(Vi, Ei, bi) {
                var yi = zs(Vi, Ei);
                if (typeof bi == "function" && (bi = bi(Vi, Ei)), typeof bi != "boolean" && (bi = !yi), bi !== yi)
                  return bi ? al(Vi, Ei) : Ol(Vi, Ei), Vi;
              }
              function Zl(Vi, Ei) {
                Object.getOwnPropertyNames(Ei).forEach(function(bi) {
                  var yi = Ei[bi];
                  yi === null || typeof yi > "u" || yi === !1 ? Vi.removeAttribute(bi) : Vi.setAttribute(bi, yi === !0 ? "" : yi);
                });
              }
              function tu(Vi) {
                var Ei = {}, bi = ",autoplay,controls,playsinline,loop,muted,default,defaultMuted,";
                if (Vi && Vi.attributes && Vi.attributes.length > 0)
                  for (var yi = Vi.attributes, ci = yi.length - 1; ci >= 0; ci--) {
                    var hi = yi[ci].name, wi = yi[ci].value;
                    (typeof Vi[hi] == "boolean" || bi.indexOf("," + hi + ",") !== -1) && (wi = wi !== null), Ei[hi] = wi;
                  }
                return Ei;
              }
              function su(Vi, Ei) {
                return Vi.getAttribute(Ei);
              }
              function dl(Vi, Ei, bi) {
                Vi.setAttribute(Ei, bi);
              }
              function Su(Vi, Ei) {
                Vi.removeAttribute(Ei);
              }
              function cu() {
                gi().body.focus(), gi().onselectstart = function() {
                  return !1;
                };
              }
              function Ru() {
                gi().onselectstart = function() {
                  return !0;
                };
              }
              function bu(Vi) {
                if (Vi && Vi.getBoundingClientRect && Vi.parentNode) {
                  var Ei = Vi.getBoundingClientRect(), bi = {};
                  return ["bottom", "height", "left", "right", "top", "width"].forEach(function(yi) {
                    Ei[yi] !== void 0 && (bi[yi] = Ei[yi]);
                  }), bi.height || (bi.height = parseFloat(Cs(Vi, "height"))), bi.width || (bi.width = parseFloat(Cs(Vi, "width"))), bi;
                }
              }
              function Hu(Vi) {
                if (!Vi || Vi && !Vi.offsetParent)
                  return {
                    left: 0,
                    top: 0,
                    width: 0,
                    height: 0
                  };
                for (var Ei = Vi.offsetWidth, bi = Vi.offsetHeight, yi = 0, ci = 0; Vi.offsetParent && Vi !== gi()[pa.fullscreenElement]; )
                  yi += Vi.offsetLeft, ci += Vi.offsetTop, Vi = Vi.offsetParent;
                return {
                  left: yi,
                  top: ci,
                  width: Ei,
                  height: bi
                };
              }
              function cc(Vi, Ei) {
                var bi = {
                  x: 0,
                  y: 0
                };
                if (Tu)
                  for (var yi = Vi; yi && yi.nodeName.toLowerCase() !== "html"; ) {
                    var ci = Cs(yi, "transform");
                    if (/^matrix/.test(ci)) {
                      var hi = ci.slice(7, -1).split(/,\s/).map(Number);
                      bi.x += hi[4], bi.y += hi[5];
                    } else if (/^matrix3d/.test(ci)) {
                      var wi = ci.slice(9, -1).split(/,\s/).map(Number);
                      bi.x += wi[12], bi.y += wi[13];
                    }
                    yi = yi.parentNode;
                  }
                var zi = {}, Wo = Hu(Ei.target), aa = Hu(Vi), Ea = aa.width, Ka = aa.height, Ha = Ei.offsetY - (aa.top - Wo.top), ks = Ei.offsetX - (aa.left - Wo.left);
                return Ei.changedTouches && (ks = Ei.changedTouches[0].pageX - aa.left, Ha = Ei.changedTouches[0].pageY + aa.top, Tu && (ks -= bi.x, Ha -= bi.y)), zi.y = 1 - Math.max(0, Math.min(1, Ha / Ka)), zi.x = Math.max(0, Math.min(1, ks / Ea)), zi;
              }
              function Tl(Vi) {
                return rs(Vi) && Vi.nodeType === 3;
              }
              function Yl(Vi) {
                for (; Vi.firstChild; )
                  Vi.removeChild(Vi.firstChild);
                return Vi;
              }
              function Dl(Vi) {
                return typeof Vi == "function" && (Vi = Vi()), (Array.isArray(Vi) ? Vi : [Vi]).map(function(Ei) {
                  if (typeof Ei == "function" && (Ei = Ei()), Ws(Ei) || Tl(Ei))
                    return Ei;
                  if (typeof Ei == "string" && /\S/.test(Ei))
                    return gi().createTextNode(Ei);
                }).filter(function(Ei) {
                  return Ei;
                });
              }
              function Cl(Vi, Ei) {
                return Dl(Ei).forEach(function(bi) {
                  return Vi.appendChild(bi);
                }), Vi;
              }
              function Hl(Vi, Ei) {
                return Cl(Yl(Vi), Ei);
              }
              function Gu(Vi) {
                return Vi.button === void 0 && Vi.buttons === void 0 || Vi.button === 0 && Vi.buttons === void 0 || Vi.type === "mouseup" && Vi.button === 0 && Vi.buttons === 0 ? !0 : !(Vi.button !== 0 || Vi.buttons !== 1);
              }
              var xu = Gl("querySelector"), ac = Gl("querySelectorAll"), hc = /* @__PURE__ */ Object.freeze({
                __proto__: null,
                isReal: Ya,
                isEl: Ws,
                isInFrame: wl,
                createEl: bl,
                textContent: Za,
                prependTo: rl,
                hasClass: zs,
                addClass: al,
                removeClass: Ol,
                toggleClass: $l,
                setAttributes: Zl,
                getAttributes: tu,
                getAttribute: su,
                setAttribute: dl,
                removeAttribute: Su,
                blockTextSelection: cu,
                unblockTextSelection: Ru,
                getBoundingClientRect: bu,
                findPosition: Hu,
                getPointerPosition: cc,
                isTextNode: Tl,
                emptyEl: Yl,
                normalizeContent: Dl,
                appendContent: Cl,
                insertContent: Hl,
                isSingleLeftClick: Gu,
                $: xu,
                $$: ac
              }), mc = !1, jc, iu = function() {
                if (jc.options.autoSetup !== !1) {
                  var Ei = Array.prototype.slice.call(gi().getElementsByTagName("video")), bi = Array.prototype.slice.call(gi().getElementsByTagName("audio")), yi = Array.prototype.slice.call(gi().getElementsByTagName("video-js")), ci = Ei.concat(bi, yi);
                  if (ci && ci.length > 0)
                    for (var hi = 0, wi = ci.length; hi < wi; hi++) {
                      var zi = ci[hi];
                      if (zi && zi.getAttribute) {
                        if (zi.player === void 0) {
                          var Wo = zi.getAttribute("data-setup");
                          Wo !== null && jc(zi);
                        }
                      } else {
                        yc(1);
                        break;
                      }
                    }
                  else mc || yc(1);
                }
              };
              function yc(Vi, Ei) {
                Ya() && (Ei && (jc = Ei), di().setTimeout(iu, Vi));
              }
              function Mu() {
                mc = !0, di().removeEventListener("load", Mu);
              }
              Ya() && (gi().readyState === "complete" ? Mu() : di().addEventListener("load", Mu));
              var sc = function(Ei) {
                var bi = gi().createElement("style");
                return bi.className = Ei, bi;
              }, wc = function(Ei, bi) {
                Ei.styleSheet ? Ei.styleSheet.cssText = bi : Ei.textContent = bi;
              }, Wc = 3, Xu = Wc;
              function fd() {
                return Xu++;
              }
              var rd;
              di().WeakMap || (rd = /* @__PURE__ */ (function() {
                function Vi() {
                  this.vdata = "vdata" + Math.floor(di().performance && di().performance.now() || Date.now()), this.data = {};
                }
                var Ei = Vi.prototype;
                return Ei.set = function(yi, ci) {
                  var hi = yi[this.vdata] || fd();
                  return yi[this.vdata] || (yi[this.vdata] = hi), this.data[hi] = ci, this;
                }, Ei.get = function(yi) {
                  var ci = yi[this.vdata];
                  if (ci)
                    return this.data[ci];
                  Xa("We have no data for this element", yi);
                }, Ei.has = function(yi) {
                  var ci = yi[this.vdata];
                  return ci in this.data;
                }, Ei.delete = function(yi) {
                  var ci = yi[this.vdata];
                  ci && (delete this.data[ci], delete yi[this.vdata]);
                }, Vi;
              })());
              var _c = di().WeakMap ? /* @__PURE__ */ new WeakMap() : new rd();
              function dh(Vi, Ei) {
                if (_c.has(Vi)) {
                  var bi = _c.get(Vi);
                  bi.handlers[Ei].length === 0 && (delete bi.handlers[Ei], Vi.removeEventListener ? Vi.removeEventListener(Ei, bi.dispatcher, !1) : Vi.detachEvent && Vi.detachEvent("on" + Ei, bi.dispatcher)), Object.getOwnPropertyNames(bi.handlers).length <= 0 && (delete bi.handlers, delete bi.dispatcher, delete bi.disabled), Object.getOwnPropertyNames(bi).length === 0 && _c.delete(Vi);
                }
              }
              function Bd(Vi, Ei, bi, yi) {
                bi.forEach(function(ci) {
                  Vi(Ei, ci, yi);
                });
              }
              function Jc(Vi) {
                if (Vi.fixed_)
                  return Vi;
                function Ei() {
                  return !0;
                }
                function bi() {
                  return !1;
                }
                if (!Vi || !Vi.isPropagationStopped || !Vi.isImmediatePropagationStopped) {
                  var yi = Vi || di().event;
                  Vi = {};
                  for (var ci in yi)
                    ci !== "layerX" && ci !== "layerY" && ci !== "keyLocation" && ci !== "webkitMovementX" && ci !== "webkitMovementY" && ci !== "path" && (ci === "returnValue" && yi.preventDefault || (Vi[ci] = yi[ci]));
                  if (Vi.target || (Vi.target = Vi.srcElement || gi()), Vi.relatedTarget || (Vi.relatedTarget = Vi.fromElement === Vi.target ? Vi.toElement : Vi.fromElement), Vi.preventDefault = function() {
                    yi.preventDefault && yi.preventDefault(), Vi.returnValue = !1, yi.returnValue = !1, Vi.defaultPrevented = !0;
                  }, Vi.defaultPrevented = !1, Vi.stopPropagation = function() {
                    yi.stopPropagation && yi.stopPropagation(), Vi.cancelBubble = !0, yi.cancelBubble = !0, Vi.isPropagationStopped = Ei;
                  }, Vi.isPropagationStopped = bi, Vi.stopImmediatePropagation = function() {
                    yi.stopImmediatePropagation && yi.stopImmediatePropagation(), Vi.isImmediatePropagationStopped = Ei, Vi.stopPropagation();
                  }, Vi.isImmediatePropagationStopped = bi, Vi.clientX !== null && Vi.clientX !== void 0) {
                    var hi = gi().documentElement, wi = gi().body;
                    Vi.pageX = Vi.clientX + (hi && hi.scrollLeft || wi && wi.scrollLeft || 0) - (hi && hi.clientLeft || wi && wi.clientLeft || 0), Vi.pageY = Vi.clientY + (hi && hi.scrollTop || wi && wi.scrollTop || 0) - (hi && hi.clientTop || wi && wi.clientTop || 0);
                  }
                  Vi.which = Vi.charCode || Vi.keyCode, Vi.button !== null && Vi.button !== void 0 && (Vi.button = Vi.button & 1 ? 0 : Vi.button & 4 ? 1 : Vi.button & 2 ? 2 : 0);
                }
                return Vi.fixed_ = !0, Vi;
              }
              var ep, Mf = function() {
                if (typeof ep != "boolean") {
                  ep = !1;
                  try {
                    var Ei = Object.defineProperty({}, "passive", {
                      get: function() {
                        ep = !0;
                      }
                    });
                    di().addEventListener("test", null, Ei), di().removeEventListener("test", null, Ei);
                  } catch {
                  }
                }
                return ep;
              }, Kh = ["touchstart", "touchmove"];
              function pd(Vi, Ei, bi) {
                if (Array.isArray(Ei))
                  return Bd(pd, Vi, Ei, bi);
                _c.has(Vi) || _c.set(Vi, {});
                var yi = _c.get(Vi);
                if (yi.handlers || (yi.handlers = {}), yi.handlers[Ei] || (yi.handlers[Ei] = []), bi.guid || (bi.guid = fd()), yi.handlers[Ei].push(bi), yi.dispatcher || (yi.disabled = !1, yi.dispatcher = function(hi, wi) {
                  if (!yi.disabled) {
                    hi = Jc(hi);
                    var zi = yi.handlers[hi.type];
                    if (zi)
                      for (var Wo = zi.slice(0), aa = 0, Ea = Wo.length; aa < Ea && !hi.isImmediatePropagationStopped(); aa++)
                        try {
                          Wo[aa].call(Vi, hi, wi);
                        } catch (Ka) {
                          Xa.error(Ka);
                        }
                  }
                }), yi.handlers[Ei].length === 1)
                  if (Vi.addEventListener) {
                    var ci = !1;
                    Mf() && Kh.indexOf(Ei) > -1 && (ci = {
                      passive: !0
                    }), Vi.addEventListener(Ei, yi.dispatcher, ci);
                  } else Vi.attachEvent && Vi.attachEvent("on" + Ei, yi.dispatcher);
              }
              function Cc(Vi, Ei, bi) {
                if (_c.has(Vi)) {
                  var yi = _c.get(Vi);
                  if (yi.handlers) {
                    if (Array.isArray(Ei))
                      return Bd(Cc, Vi, Ei, bi);
                    var ci = function(aa, Ea) {
                      yi.handlers[Ea] = [], dh(aa, Ea);
                    };
                    if (Ei === void 0) {
                      for (var hi in yi.handlers)
                        Object.prototype.hasOwnProperty.call(yi.handlers || {}, hi) && ci(Vi, hi);
                      return;
                    }
                    var wi = yi.handlers[Ei];
                    if (wi) {
                      if (!bi) {
                        ci(Vi, Ei);
                        return;
                      }
                      if (bi.guid)
                        for (var zi = 0; zi < wi.length; zi++)
                          wi[zi].guid === bi.guid && wi.splice(zi--, 1);
                      dh(Vi, Ei);
                    }
                  }
                }
              }
              function jf(Vi, Ei, bi) {
                var yi = _c.has(Vi) ? _c.get(Vi) : {}, ci = Vi.parentNode || Vi.ownerDocument;
                if (typeof Ei == "string" ? Ei = {
                  type: Ei,
                  target: Vi
                } : Ei.target || (Ei.target = Vi), Ei = Jc(Ei), yi.dispatcher && yi.dispatcher.call(Vi, Ei, bi), ci && !Ei.isPropagationStopped() && Ei.bubbles === !0)
                  jf.call(null, ci, Ei, bi);
                else if (!ci && !Ei.defaultPrevented && Ei.target && Ei.target[Ei.type]) {
                  _c.has(Ei.target) || _c.set(Ei.target, {});
                  var hi = _c.get(Ei.target);
                  Ei.target[Ei.type] && (hi.disabled = !0, typeof Ei.target[Ei.type] == "function" && Ei.target[Ei.type](), hi.disabled = !1);
                }
                return !Ei.defaultPrevented;
              }
              function tp(Vi, Ei, bi) {
                if (Array.isArray(Ei))
                  return Bd(tp, Vi, Ei, bi);
                var yi = function ci() {
                  Cc(Vi, Ei, ci), bi.apply(this, arguments);
                };
                yi.guid = bi.guid = bi.guid || fd(), pd(Vi, Ei, yi);
              }
              function Fp(Vi, Ei, bi) {
                var yi = function ci() {
                  Cc(Vi, Ei, ci), bi.apply(this, arguments);
                };
                yi.guid = bi.guid = bi.guid || fd(), pd(Vi, Ei, yi);
              }
              var fh = /* @__PURE__ */ Object.freeze({
                __proto__: null,
                fixEvent: Jc,
                on: pd,
                off: Cc,
                trigger: jf,
                one: tp,
                any: Fp
              }), Qc = 30, Tc = function(Ei, bi, yi) {
                bi.guid || (bi.guid = fd());
                var ci = bi.bind(Ei);
                return ci.guid = yi ? yi + "_" + bi.guid : bi.guid, ci;
              }, Ud = function(Ei, bi) {
                var yi = di().performance.now(), ci = function() {
                  var wi = di().performance.now();
                  wi - yi >= bi && (Ei.apply(void 0, arguments), yi = wi);
                };
                return ci;
              }, Ff = function(Ei, bi, yi, ci) {
                ci === void 0 && (ci = di());
                var hi, wi = function() {
                  ci.clearTimeout(hi), hi = null;
                }, zi = function() {
                  var aa = this, Ea = arguments, Ka = function() {
                    hi = null, Ka = null, Ei.apply(aa, Ea);
                  };
                  ci.clearTimeout(hi), hi = ci.setTimeout(Ka, bi);
                };
                return zi.cancel = wi, zi;
              }, Kc = function() {
              };
              Kc.prototype.allowedEvents_ = {}, Kc.prototype.on = function(Vi, Ei) {
                var bi = this.addEventListener;
                this.addEventListener = function() {
                }, pd(this, Vi, Ei), this.addEventListener = bi;
              }, Kc.prototype.addEventListener = Kc.prototype.on, Kc.prototype.off = function(Vi, Ei) {
                Cc(this, Vi, Ei);
              }, Kc.prototype.removeEventListener = Kc.prototype.off, Kc.prototype.one = function(Vi, Ei) {
                var bi = this.addEventListener;
                this.addEventListener = function() {
                }, tp(this, Vi, Ei), this.addEventListener = bi;
              }, Kc.prototype.any = function(Vi, Ei) {
                var bi = this.addEventListener;
                this.addEventListener = function() {
                }, Fp(this, Vi, Ei), this.addEventListener = bi;
              }, Kc.prototype.trigger = function(Vi) {
                var Ei = Vi.type || Vi;
                typeof Vi == "string" && (Vi = {
                  type: Ei
                }), Vi = Jc(Vi), this.allowedEvents_[Ei] && this["on" + Ei] && this["on" + Ei](Vi), jf(this, Vi);
              }, Kc.prototype.dispatchEvent = Kc.prototype.trigger;
              var vf;
              Kc.prototype.queueTrigger = function(Vi) {
                var Ei = this;
                vf || (vf = /* @__PURE__ */ new Map());
                var bi = Vi.type || Vi, yi = vf.get(this);
                yi || (yi = /* @__PURE__ */ new Map(), vf.set(this, yi));
                var ci = yi.get(bi);
                yi.delete(bi), di().clearTimeout(ci);
                var hi = di().setTimeout(function() {
                  yi.delete(bi), yi.size === 0 && (yi = null, vf.delete(Ei)), Ei.trigger(Vi);
                }, 0);
                yi.set(bi, hi);
              };
              var mp = function(Ei) {
                return typeof Ei.name == "function" ? Ei.name() : typeof Ei.name == "string" ? Ei.name : Ei.name_ ? Ei.name_ : Ei.constructor && Ei.constructor.name ? Ei.constructor.name : typeof Ei;
              }, Vd = function(Ei) {
                return Ei instanceof Kc || !!Ei.eventBusEl_ && ["on", "one", "off", "trigger"].every(function(bi) {
                  return typeof Ei[bi] == "function";
                });
              }, Wd = function(Ei, bi) {
                Vd(Ei) ? bi() : (Ei.eventedCallbacks || (Ei.eventedCallbacks = []), Ei.eventedCallbacks.push(bi));
              }, Bp = function(Ei) {
                return (
                  // The regex here verifies that the `type` contains at least one non-
                  // whitespace character.
                  typeof Ei == "string" && /\S/.test(Ei) || Array.isArray(Ei) && !!Ei.length
                );
              }, $d = function(Ei, bi, yi) {
                if (!Ei || !Ei.nodeName && !Vd(Ei))
                  throw new Error("Invalid target for " + mp(bi) + "#" + yi + "; must be a DOM node or evented object.");
              }, qc = function(Ei, bi, yi) {
                if (!Bp(Ei))
                  throw new Error("Invalid event type for " + mp(bi) + "#" + yi + "; must be a non-empty string or array.");
              }, vp = function(Ei, bi, yi) {
                if (typeof Ei != "function")
                  throw new Error("Invalid listener for " + mp(bi) + "#" + yi + "; must be a function.");
              }, Gd = function(Ei, bi, yi) {
                var ci = bi.length < 3 || bi[0] === Ei || bi[0] === Ei.eventBusEl_, hi, wi, zi;
                return ci ? (hi = Ei.eventBusEl_, bi.length >= 3 && bi.shift(), wi = bi[0], zi = bi[1]) : (hi = bi[0], wi = bi[1], zi = bi[2]), $d(hi, Ei, yi), qc(wi, Ei, yi), vp(zi, Ei, yi), zi = Tc(Ei, zi), {
                  isTargetingSelf: ci,
                  target: hi,
                  type: wi,
                  listener: zi
                };
              }, yf = function(Ei, bi, yi, ci) {
                $d(Ei, Ei, bi), Ei.nodeName ? fh[bi](Ei, yi, ci) : Ei[bi](yi, ci);
              }, rp = {
                /**
                 * Add a listener to an event (or events) on this object or another evented
                 * object.
                 *
                 * @param  {string|Array|Element|Object} targetOrType
                 *         If this is a string or array, it represents the event type(s)
                 *         that will trigger the listener.
                 *
                 *         Another evented object can be passed here instead, which will
                 *         cause the listener to listen for events on _that_ object.
                 *
                 *         In either case, the listener's `this` value will be bound to
                 *         this object.
                 *
                 * @param  {string|Array|Function} typeOrListener
                 *         If the first argument was a string or array, this should be the
                 *         listener function. Otherwise, this is a string or array of event
                 *         type(s).
                 *
                 * @param  {Function} [listener]
                 *         If the first argument was another evented object, this will be
                 *         the listener function.
                 */
                on: function() {
                  for (var Ei = this, bi = arguments.length, yi = new Array(bi), ci = 0; ci < bi; ci++)
                    yi[ci] = arguments[ci];
                  var hi = Gd(this, yi, "on"), wi = hi.isTargetingSelf, zi = hi.target, Wo = hi.type, aa = hi.listener;
                  if (yf(zi, "on", Wo, aa), !wi) {
                    var Ea = function() {
                      return Ei.off(zi, Wo, aa);
                    };
                    Ea.guid = aa.guid;
                    var Ka = function() {
                      return Ei.off("dispose", Ea);
                    };
                    Ka.guid = aa.guid, yf(this, "on", "dispose", Ea), yf(zi, "on", "dispose", Ka);
                  }
                },
                /**
                 * Add a listener to an event (or events) on this object or another evented
                 * object. The listener will be called once per event and then removed.
                 *
                 * @param  {string|Array|Element|Object} targetOrType
                 *         If this is a string or array, it represents the event type(s)
                 *         that will trigger the listener.
                 *
                 *         Another evented object can be passed here instead, which will
                 *         cause the listener to listen for events on _that_ object.
                 *
                 *         In either case, the listener's `this` value will be bound to
                 *         this object.
                 *
                 * @param  {string|Array|Function} typeOrListener
                 *         If the first argument was a string or array, this should be the
                 *         listener function. Otherwise, this is a string or array of event
                 *         type(s).
                 *
                 * @param  {Function} [listener]
                 *         If the first argument was another evented object, this will be
                 *         the listener function.
                 */
                one: function() {
                  for (var Ei = this, bi = arguments.length, yi = new Array(bi), ci = 0; ci < bi; ci++)
                    yi[ci] = arguments[ci];
                  var hi = Gd(this, yi, "one"), wi = hi.isTargetingSelf, zi = hi.target, Wo = hi.type, aa = hi.listener;
                  if (wi)
                    yf(zi, "one", Wo, aa);
                  else {
                    var Ea = function Ka() {
                      Ei.off(zi, Wo, Ka);
                      for (var Ha = arguments.length, ks = new Array(Ha), gl = 0; gl < Ha; gl++)
                        ks[gl] = arguments[gl];
                      aa.apply(null, ks);
                    };
                    Ea.guid = aa.guid, yf(zi, "one", Wo, Ea);
                  }
                },
                /**
                 * Add a listener to an event (or events) on this object or another evented
                 * object. The listener will only be called once for the first event that is triggered
                 * then removed.
                 *
                 * @param  {string|Array|Element|Object} targetOrType
                 *         If this is a string or array, it represents the event type(s)
                 *         that will trigger the listener.
                 *
                 *         Another evented object can be passed here instead, which will
                 *         cause the listener to listen for events on _that_ object.
                 *
                 *         In either case, the listener's `this` value will be bound to
                 *         this object.
                 *
                 * @param  {string|Array|Function} typeOrListener
                 *         If the first argument was a string or array, this should be the
                 *         listener function. Otherwise, this is a string or array of event
                 *         type(s).
                 *
                 * @param  {Function} [listener]
                 *         If the first argument was another evented object, this will be
                 *         the listener function.
                 */
                any: function() {
                  for (var Ei = this, bi = arguments.length, yi = new Array(bi), ci = 0; ci < bi; ci++)
                    yi[ci] = arguments[ci];
                  var hi = Gd(this, yi, "any"), wi = hi.isTargetingSelf, zi = hi.target, Wo = hi.type, aa = hi.listener;
                  if (wi)
                    yf(zi, "any", Wo, aa);
                  else {
                    var Ea = function Ka() {
                      Ei.off(zi, Wo, Ka);
                      for (var Ha = arguments.length, ks = new Array(Ha), gl = 0; gl < Ha; gl++)
                        ks[gl] = arguments[gl];
                      aa.apply(null, ks);
                    };
                    Ea.guid = aa.guid, yf(zi, "any", Wo, Ea);
                  }
                },
                /**
                 * Removes listener(s) from event(s) on an evented object.
                 *
                 * @param  {string|Array|Element|Object} [targetOrType]
                 *         If this is a string or array, it represents the event type(s).
                 *
                 *         Another evented object can be passed here instead, in which case
                 *         ALL 3 arguments are _required_.
                 *
                 * @param  {string|Array|Function} [typeOrListener]
                 *         If the first argument was a string or array, this may be the
                 *         listener function. Otherwise, this is a string or array of event
                 *         type(s).
                 *
                 * @param  {Function} [listener]
                 *         If the first argument was another evented object, this will be
                 *         the listener function; otherwise, _all_ listeners bound to the
                 *         event type(s) will be removed.
                 */
                off: function(Ei, bi, yi) {
                  if (!Ei || Bp(Ei))
                    Cc(this.eventBusEl_, Ei, bi);
                  else {
                    var ci = Ei, hi = bi;
                    $d(ci, this, "off"), qc(hi, this, "off"), vp(yi, this, "off"), yi = Tc(this, yi), this.off("dispose", yi), ci.nodeName ? (Cc(ci, hi, yi), Cc(ci, "dispose", yi)) : Vd(ci) && (ci.off(hi, yi), ci.off("dispose", yi));
                  }
                },
                /**
                 * Fire an event on this evented object, causing its listeners to be called.
                 *
                 * @param   {string|Object} event
                 *          An event type or an object with a type property.
                 *
                 * @param   {Object} [hash]
                 *          An additional object to pass along to listeners.
                 *
                 * @return {boolean}
                 *          Whether or not the default behavior was prevented.
                 */
                trigger: function(Ei, bi) {
                  $d(this.eventBusEl_, this, "trigger");
                  var yi = Ei && typeof Ei != "string" ? Ei.type : Ei;
                  if (!Bp(yi)) {
                    var ci = "Invalid event type for " + mp(this) + "#trigger; must be a non-empty string or object with a type key that has a non-empty value.";
                    if (Ei)
                      (this.log || Xa).error(ci);
                    else
                      throw new Error(ci);
                  }
                  return jf(this.eventBusEl_, Ei, bi);
                }
              };
              function Up(Vi, Ei) {
                Ei === void 0 && (Ei = {});
                var bi = Ei, yi = bi.eventBusKey;
                if (yi) {
                  if (!Vi[yi].nodeName)
                    throw new Error('The eventBusKey "' + yi + '" does not refer to an element.');
                  Vi.eventBusEl_ = Vi[yi];
                } else
                  Vi.eventBusEl_ = bl("span", {
                    className: "vjs-event-bus"
                  });
                return Ta(Vi, rp), Vi.eventedCallbacks && Vi.eventedCallbacks.forEach(function(ci) {
                  ci();
                }), Vi.on("dispose", function() {
                  Vi.off(), [Vi, Vi.el_, Vi.eventBusEl_].forEach(function(ci) {
                    ci && _c.has(ci) && _c.delete(ci);
                  }), di().setTimeout(function() {
                    Vi.eventBusEl_ = null;
                  }, 0);
                }), Vi;
              }
              var ph = {
                /**
                 * A hash containing arbitrary keys and values representing the state of
                 * the object.
                 *
                 * @type {Object}
                 */
                state: {},
                /**
                 * Set the state of an object by mutating its
                 * {@link module:stateful~StatefulMixin.state|state} object in place.
                 *
                 * @fires   module:stateful~StatefulMixin#statechanged
                 * @param   {Object|Function} stateUpdates
                 *          A new set of properties to shallow-merge into the plugin state.
                 *          Can be a plain object or a function returning a plain object.
                 *
                 * @return {Object|undefined}
                 *          An object containing changes that occurred. If no changes
                 *          occurred, returns `undefined`.
                 */
                setState: function(Ei) {
                  var bi = this;
                  typeof Ei == "function" && (Ei = Ei());
                  var yi;
                  return Ja(Ei, function(ci, hi) {
                    bi.state[hi] !== ci && (yi = yi || {}, yi[hi] = {
                      from: bi.state[hi],
                      to: ci
                    }), bi.state[hi] = ci;
                  }), yi && Vd(this) && this.trigger({
                    changes: yi,
                    type: "statechanged"
                  }), yi;
                }
              };
              function hh(Vi, Ei) {
                return Ta(Vi, ph), Vi.state = Ta({}, Vi.state, Ei), typeof Vi.handleStateChanged == "function" && Vd(Vi) && Vi.on("statechanged", Vi.handleStateChanged), Vi;
              }
              var af = function(Ei) {
                return typeof Ei != "string" ? Ei : Ei.replace(/./, function(bi) {
                  return bi.toLowerCase();
                });
              }, Ic = function(Ei) {
                return typeof Ei != "string" ? Ei : Ei.replace(/./, function(bi) {
                  return bi.toUpperCase();
                });
              }, qh = function(Ei, bi) {
                return Ic(Ei) === Ic(bi);
              };
              function Ec() {
                for (var Vi = {}, Ei = arguments.length, bi = new Array(Ei), yi = 0; yi < Ei; yi++)
                  bi[yi] = arguments[yi];
                return bi.forEach(function(ci) {
                  ci && Ja(ci, function(hi, wi) {
                    if (!Qa(hi)) {
                      Vi[wi] = hi;
                      return;
                    }
                    Qa(Vi[wi]) || (Vi[wi] = {}), Vi[wi] = Ec(Vi[wi], hi);
                  });
                }), Vi;
              }
              var gh = /* @__PURE__ */ (function() {
                function Vi() {
                  this.map_ = {};
                }
                var Ei = Vi.prototype;
                return Ei.has = function(yi) {
                  return yi in this.map_;
                }, Ei.delete = function(yi) {
                  var ci = this.has(yi);
                  return delete this.map_[yi], ci;
                }, Ei.set = function(yi, ci) {
                  return this.map_[yi] = ci, this;
                }, Ei.forEach = function(yi, ci) {
                  for (var hi in this.map_)
                    yi.call(ci, this.map_[hi], hi, this);
                }, Vi;
              })(), Zc = di().Map ? di().Map : gh, mh = /* @__PURE__ */ (function() {
                function Vi() {
                  this.set_ = {};
                }
                var Ei = Vi.prototype;
                return Ei.has = function(yi) {
                  return yi in this.set_;
                }, Ei.delete = function(yi) {
                  var ci = this.has(yi);
                  return delete this.set_[yi], ci;
                }, Ei.add = function(yi) {
                  return this.set_[yi] = 1, this;
                }, Ei.forEach = function(yi, ci) {
                  for (var hi in this.set_)
                    yi.call(ci, hi, hi, this);
                }, Vi;
              })(), Bf = di().Set ? di().Set : mh, ou = /* @__PURE__ */ (function() {
                function Vi(bi, yi, ci) {
                  var hi = this;
                  if (!bi && this.play ? this.player_ = bi = this : this.player_ = bi, this.isDisposed_ = !1, this.parentComponent_ = null, this.options_ = Ec({}, this.options_), yi = this.options_ = Ec(this.options_, yi), this.id_ = yi.id || yi.el && yi.el.id, !this.id_) {
                    var wi = bi && bi.id && bi.id() || "no_player";
                    this.id_ = wi + "_component_" + fd();
                  }
                  this.name_ = yi.name || null, yi.el ? this.el_ = yi.el : yi.createEl !== !1 && (this.el_ = this.createEl()), yi.className && this.el_ && yi.className.split(" ").forEach(function(zi) {
                    return hi.addClass(zi);
                  }), yi.evented !== !1 && (Up(this, {
                    eventBusKey: this.el_ ? "el_" : null
                  }), this.handleLanguagechange = this.handleLanguagechange.bind(this), this.on(this.player_, "languagechange", this.handleLanguagechange)), hh(this, this.constructor.defaultState), this.children_ = [], this.childIndex_ = {}, this.childNameIndex_ = {}, this.setTimeoutIds_ = new Bf(), this.setIntervalIds_ = new Bf(), this.rafIds_ = new Bf(), this.namedRafs_ = new Zc(), this.clearingTimersOnDispose_ = !1, yi.initChildren !== !1 && this.initChildren(), this.ready(ci), yi.reportTouchActivity !== !1 && this.enableTouchActivity();
                }
                var Ei = Vi.prototype;
                return Ei.dispose = function(yi) {
                  if (yi === void 0 && (yi = {}), !this.isDisposed_) {
                    if (this.readyQueue_ && (this.readyQueue_.length = 0), this.trigger({
                      type: "dispose",
                      bubbles: !1
                    }), this.isDisposed_ = !0, this.children_)
                      for (var ci = this.children_.length - 1; ci >= 0; ci--)
                        this.children_[ci].dispose && this.children_[ci].dispose();
                    this.children_ = null, this.childIndex_ = null, this.childNameIndex_ = null, this.parentComponent_ = null, this.el_ && (this.el_.parentNode && (yi.restoreEl ? this.el_.parentNode.replaceChild(yi.restoreEl, this.el_) : this.el_.parentNode.removeChild(this.el_)), this.el_ = null), this.player_ = null;
                  }
                }, Ei.isDisposed = function() {
                  return !!this.isDisposed_;
                }, Ei.player = function() {
                  return this.player_;
                }, Ei.options = function(yi) {
                  return yi ? (this.options_ = Ec(this.options_, yi), this.options_) : this.options_;
                }, Ei.el = function() {
                  return this.el_;
                }, Ei.createEl = function(yi, ci, hi) {
                  return bl(yi, ci, hi);
                }, Ei.localize = function(yi, ci, hi) {
                  hi === void 0 && (hi = yi);
                  var wi = this.player_.language && this.player_.language(), zi = this.player_.languages && this.player_.languages(), Wo = zi && zi[wi], aa = wi && wi.split("-")[0], Ea = zi && zi[aa], Ka = hi;
                  return Wo && Wo[yi] ? Ka = Wo[yi] : Ea && Ea[yi] && (Ka = Ea[yi]), ci && (Ka = Ka.replace(/\{(\d+)\}/g, function(Ha, ks) {
                    var gl = ci[ks - 1], Sl = gl;
                    return typeof gl > "u" && (Sl = Ha), Sl;
                  })), Ka;
                }, Ei.handleLanguagechange = function() {
                }, Ei.contentEl = function() {
                  return this.contentEl_ || this.el_;
                }, Ei.id = function() {
                  return this.id_;
                }, Ei.name = function() {
                  return this.name_;
                }, Ei.children = function() {
                  return this.children_;
                }, Ei.getChildById = function(yi) {
                  return this.childIndex_[yi];
                }, Ei.getChild = function(yi) {
                  if (yi)
                    return this.childNameIndex_[yi];
                }, Ei.getDescendant = function() {
                  for (var yi = arguments.length, ci = new Array(yi), hi = 0; hi < yi; hi++)
                    ci[hi] = arguments[hi];
                  ci = ci.reduce(function(Wo, aa) {
                    return Wo.concat(aa);
                  }, []);
                  for (var wi = this, zi = 0; zi < ci.length; zi++)
                    if (wi = wi.getChild(ci[zi]), !wi || !wi.getChild)
                      return;
                  return wi;
                }, Ei.addChild = function(yi, ci, hi) {
                  ci === void 0 && (ci = {}), hi === void 0 && (hi = this.children_.length);
                  var wi, zi;
                  if (typeof yi == "string") {
                    zi = Ic(yi);
                    var Wo = ci.componentClass || zi;
                    ci.name = zi;
                    var aa = Vi.getComponent(Wo);
                    if (!aa)
                      throw new Error("Component " + Wo + " does not exist");
                    if (typeof aa != "function")
                      return null;
                    wi = new aa(this.player_ || this, ci);
                  } else
                    wi = yi;
                  if (wi.parentComponent_ && wi.parentComponent_.removeChild(wi), this.children_.splice(hi, 0, wi), wi.parentComponent_ = this, typeof wi.id == "function" && (this.childIndex_[wi.id()] = wi), zi = zi || wi.name && Ic(wi.name()), zi && (this.childNameIndex_[zi] = wi, this.childNameIndex_[af(zi)] = wi), typeof wi.el == "function" && wi.el()) {
                    var Ea = null;
                    this.children_[hi + 1] && (this.children_[hi + 1].el_ ? Ea = this.children_[hi + 1].el_ : Ws(this.children_[hi + 1]) && (Ea = this.children_[hi + 1])), this.contentEl().insertBefore(wi.el(), Ea);
                  }
                  return wi;
                }, Ei.removeChild = function(yi) {
                  if (typeof yi == "string" && (yi = this.getChild(yi)), !(!yi || !this.children_)) {
                    for (var ci = !1, hi = this.children_.length - 1; hi >= 0; hi--)
                      if (this.children_[hi] === yi) {
                        ci = !0, this.children_.splice(hi, 1);
                        break;
                      }
                    if (ci) {
                      yi.parentComponent_ = null, this.childIndex_[yi.id()] = null, this.childNameIndex_[Ic(yi.name())] = null, this.childNameIndex_[af(yi.name())] = null;
                      var wi = yi.el();
                      wi && wi.parentNode === this.contentEl() && this.contentEl().removeChild(yi.el());
                    }
                  }
                }, Ei.initChildren = function() {
                  var yi = this, ci = this.options_.children;
                  if (ci) {
                    var hi = this.options_, wi = function(Ea) {
                      var Ka = Ea.name, Ha = Ea.opts;
                      if (hi[Ka] !== void 0 && (Ha = hi[Ka]), Ha !== !1) {
                        Ha === !0 && (Ha = {}), Ha.playerOptions = yi.options_.playerOptions;
                        var ks = yi.addChild(Ka, Ha);
                        ks && (yi[Ka] = ks);
                      }
                    }, zi, Wo = Vi.getComponent("Tech");
                    Array.isArray(ci) ? zi = ci : zi = Object.keys(ci), zi.concat(Object.keys(this.options_).filter(function(aa) {
                      return !zi.some(function(Ea) {
                        return typeof Ea == "string" ? aa === Ea : aa === Ea.name;
                      });
                    })).map(function(aa) {
                      var Ea, Ka;
                      return typeof aa == "string" ? (Ea = aa, Ka = ci[Ea] || yi.options_[Ea] || {}) : (Ea = aa.name, Ka = aa), {
                        name: Ea,
                        opts: Ka
                      };
                    }).filter(function(aa) {
                      var Ea = Vi.getComponent(aa.opts.componentClass || Ic(aa.name));
                      return Ea && !Wo.isTech(Ea);
                    }).forEach(wi);
                  }
                }, Ei.buildCSSClass = function() {
                  return "";
                }, Ei.ready = function(yi, ci) {
                  if (ci === void 0 && (ci = !1), !!yi) {
                    if (!this.isReady_) {
                      this.readyQueue_ = this.readyQueue_ || [], this.readyQueue_.push(yi);
                      return;
                    }
                    ci ? yi.call(this) : this.setTimeout(yi, 1);
                  }
                }, Ei.triggerReady = function() {
                  this.isReady_ = !0, this.setTimeout(function() {
                    var yi = this.readyQueue_;
                    this.readyQueue_ = [], yi && yi.length > 0 && yi.forEach(function(ci) {
                      ci.call(this);
                    }, this), this.trigger("ready");
                  }, 1);
                }, Ei.$ = function(yi, ci) {
                  return xu(yi, ci || this.contentEl());
                }, Ei.$$ = function(yi, ci) {
                  return ac(yi, ci || this.contentEl());
                }, Ei.hasClass = function(yi) {
                  return zs(this.el_, yi);
                }, Ei.addClass = function(yi) {
                  al(this.el_, yi);
                }, Ei.removeClass = function(yi) {
                  Ol(this.el_, yi);
                }, Ei.toggleClass = function(yi, ci) {
                  $l(this.el_, yi, ci);
                }, Ei.show = function() {
                  this.removeClass("vjs-hidden");
                }, Ei.hide = function() {
                  this.addClass("vjs-hidden");
                }, Ei.lockShowing = function() {
                  this.addClass("vjs-lock-showing");
                }, Ei.unlockShowing = function() {
                  this.removeClass("vjs-lock-showing");
                }, Ei.getAttribute = function(yi) {
                  return su(this.el_, yi);
                }, Ei.setAttribute = function(yi, ci) {
                  dl(this.el_, yi, ci);
                }, Ei.removeAttribute = function(yi) {
                  Su(this.el_, yi);
                }, Ei.width = function(yi, ci) {
                  return this.dimension("width", yi, ci);
                }, Ei.height = function(yi, ci) {
                  return this.dimension("height", yi, ci);
                }, Ei.dimensions = function(yi, ci) {
                  this.width(yi, !0), this.height(ci);
                }, Ei.dimension = function(yi, ci, hi) {
                  if (ci !== void 0) {
                    (ci === null || ci !== ci) && (ci = 0), ("" + ci).indexOf("%") !== -1 || ("" + ci).indexOf("px") !== -1 ? this.el_.style[yi] = ci : ci === "auto" ? this.el_.style[yi] = "" : this.el_.style[yi] = ci + "px", hi || this.trigger("componentresize");
                    return;
                  }
                  if (!this.el_)
                    return 0;
                  var wi = this.el_.style[yi], zi = wi.indexOf("px");
                  return parseInt(zi !== -1 ? wi.slice(0, zi) : this.el_["offset" + Ic(yi)], 10);
                }, Ei.currentDimension = function(yi) {
                  var ci = 0;
                  if (yi !== "width" && yi !== "height")
                    throw new Error("currentDimension only accepts width or height value");
                  if (ci = Cs(this.el_, yi), ci = parseFloat(ci), ci === 0 || isNaN(ci)) {
                    var hi = "offset" + Ic(yi);
                    ci = this.el_[hi];
                  }
                  return ci;
                }, Ei.currentDimensions = function() {
                  return {
                    width: this.currentDimension("width"),
                    height: this.currentDimension("height")
                  };
                }, Ei.currentWidth = function() {
                  return this.currentDimension("width");
                }, Ei.currentHeight = function() {
                  return this.currentDimension("height");
                }, Ei.focus = function() {
                  this.el_.focus();
                }, Ei.blur = function() {
                  this.el_.blur();
                }, Ei.handleKeyDown = function(yi) {
                  this.player_ && (vi().isEventKey(yi, "Tab") || yi.stopPropagation(), this.player_.handleKeyDown(yi));
                }, Ei.handleKeyPress = function(yi) {
                  this.handleKeyDown(yi);
                }, Ei.emitTapEvents = function() {
                  var yi = 0, ci = null, hi = 10, wi = 200, zi;
                  this.on("touchstart", function(aa) {
                    aa.touches.length === 1 && (ci = {
                      pageX: aa.touches[0].pageX,
                      pageY: aa.touches[0].pageY
                    }, yi = di().performance.now(), zi = !0);
                  }), this.on("touchmove", function(aa) {
                    if (aa.touches.length > 1)
                      zi = !1;
                    else if (ci) {
                      var Ea = aa.touches[0].pageX - ci.pageX, Ka = aa.touches[0].pageY - ci.pageY, Ha = Math.sqrt(Ea * Ea + Ka * Ka);
                      Ha > hi && (zi = !1);
                    }
                  });
                  var Wo = function() {
                    zi = !1;
                  };
                  this.on("touchleave", Wo), this.on("touchcancel", Wo), this.on("touchend", function(aa) {
                    if (ci = null, zi === !0) {
                      var Ea = di().performance.now() - yi;
                      Ea < wi && (aa.preventDefault(), this.trigger("tap"));
                    }
                  });
                }, Ei.enableTouchActivity = function() {
                  if (!(!this.player() || !this.player().reportUserActivity)) {
                    var yi = Tc(this.player(), this.player().reportUserActivity), ci;
                    this.on("touchstart", function() {
                      yi(), this.clearInterval(ci), ci = this.setInterval(yi, 250);
                    });
                    var hi = function(zi) {
                      yi(), this.clearInterval(ci);
                    };
                    this.on("touchmove", yi), this.on("touchend", hi), this.on("touchcancel", hi);
                  }
                }, Ei.setTimeout = function(yi, ci) {
                  var hi = this, wi;
                  return yi = Tc(this, yi), this.clearTimersOnDispose_(), wi = di().setTimeout(function() {
                    hi.setTimeoutIds_.has(wi) && hi.setTimeoutIds_.delete(wi), yi();
                  }, ci), this.setTimeoutIds_.add(wi), wi;
                }, Ei.clearTimeout = function(yi) {
                  return this.setTimeoutIds_.has(yi) && (this.setTimeoutIds_.delete(yi), di().clearTimeout(yi)), yi;
                }, Ei.setInterval = function(yi, ci) {
                  yi = Tc(this, yi), this.clearTimersOnDispose_();
                  var hi = di().setInterval(yi, ci);
                  return this.setIntervalIds_.add(hi), hi;
                }, Ei.clearInterval = function(yi) {
                  return this.setIntervalIds_.has(yi) && (this.setIntervalIds_.delete(yi), di().clearInterval(yi)), yi;
                }, Ei.requestAnimationFrame = function(yi) {
                  var ci = this;
                  if (!this.supportsRaf_)
                    return this.setTimeout(yi, 1e3 / 60);
                  this.clearTimersOnDispose_();
                  var hi;
                  return yi = Tc(this, yi), hi = di().requestAnimationFrame(function() {
                    ci.rafIds_.has(hi) && ci.rafIds_.delete(hi), yi();
                  }), this.rafIds_.add(hi), hi;
                }, Ei.requestNamedAnimationFrame = function(yi, ci) {
                  var hi = this;
                  if (!this.namedRafs_.has(yi)) {
                    this.clearTimersOnDispose_(), ci = Tc(this, ci);
                    var wi = this.requestAnimationFrame(function() {
                      ci(), hi.namedRafs_.has(yi) && hi.namedRafs_.delete(yi);
                    });
                    return this.namedRafs_.set(yi, wi), yi;
                  }
                }, Ei.cancelNamedAnimationFrame = function(yi) {
                  this.namedRafs_.has(yi) && (this.cancelAnimationFrame(this.namedRafs_.get(yi)), this.namedRafs_.delete(yi));
                }, Ei.cancelAnimationFrame = function(yi) {
                  return this.supportsRaf_ ? (this.rafIds_.has(yi) && (this.rafIds_.delete(yi), di().cancelAnimationFrame(yi)), yi) : this.clearTimeout(yi);
                }, Ei.clearTimersOnDispose_ = function() {
                  var yi = this;
                  this.clearingTimersOnDispose_ || (this.clearingTimersOnDispose_ = !0, this.one("dispose", function() {
                    [["namedRafs_", "cancelNamedAnimationFrame"], ["rafIds_", "cancelAnimationFrame"], ["setTimeoutIds_", "clearTimeout"], ["setIntervalIds_", "clearInterval"]].forEach(function(ci) {
                      var hi = ci[0], wi = ci[1];
                      yi[hi].forEach(function(zi, Wo) {
                        return yi[wi](Wo);
                      });
                    }), yi.clearingTimersOnDispose_ = !1;
                  }));
                }, Vi.registerComponent = function(yi, ci) {
                  if (typeof yi != "string" || !yi)
                    throw new Error('Illegal component name, "' + yi + '"; must be a non-empty string.');
                  var hi = Vi.getComponent("Tech"), wi = hi && hi.isTech(ci), zi = Vi === ci || Vi.prototype.isPrototypeOf(ci.prototype);
                  if (wi || !zi) {
                    var Wo;
                    throw wi ? Wo = "techs must be registered using Tech.registerTech()" : Wo = "must be a Component subclass", new Error('Illegal component, "' + yi + '"; ' + Wo + ".");
                  }
                  yi = Ic(yi), Vi.components_ || (Vi.components_ = {});
                  var aa = Vi.getComponent("Player");
                  if (yi === "Player" && aa && aa.players) {
                    var Ea = aa.players, Ka = Object.keys(Ea);
                    if (Ea && Ka.length > 0 && Ka.map(function(Ha) {
                      return Ea[Ha];
                    }).every(Boolean))
                      throw new Error("Can not register Player component after player has been created.");
                  }
                  return Vi.components_[yi] = ci, Vi.components_[af(yi)] = ci, ci;
                }, Vi.getComponent = function(yi) {
                  if (!(!yi || !Vi.components_))
                    return Vi.components_[yi];
                }, Vi;
              })();
              ou.prototype.supportsRaf_ = typeof di().requestAnimationFrame == "function" && typeof di().cancelAnimationFrame == "function", ou.registerComponent("Component", ou);
              function Hd(Vi, Ei, bi) {
                if (typeof Ei != "number" || Ei < 0 || Ei > bi)
                  throw new Error("Failed to execute '" + Vi + "' on 'TimeRanges': The index provided (" + Ei + ") is non-numeric or out of bounds (0-" + bi + ").");
              }
              function yp(Vi, Ei, bi, yi) {
                return Hd(Vi, yi, bi.length - 1), bi[yi][Ei];
              }
              function bf(Vi) {
                var Ei;
                return Vi === void 0 || Vi.length === 0 ? Ei = {
                  length: 0,
                  start: function() {
                    throw new Error("This TimeRanges object is empty");
                  },
                  end: function() {
                    throw new Error("This TimeRanges object is empty");
                  }
                } : Ei = {
                  length: Vi.length,
                  start: yp.bind(null, "start", 0, Vi),
                  end: yp.bind(null, "end", 1, Vi)
                }, di().Symbol && di().Symbol.iterator && (Ei[di().Symbol.iterator] = function() {
                  return (Vi || []).values();
                }), Ei;
              }
              function Tf(Vi, Ei) {
                return Array.isArray(Vi) ? bf(Vi) : Vi === void 0 || Ei === void 0 ? bf() : bf([[Vi, Ei]]);
              }
              function bp(Vi, Ei) {
                var bi = 0, yi, ci;
                if (!Ei)
                  return 0;
                (!Vi || !Vi.length) && (Vi = Tf(0, 0));
                for (var hi = 0; hi < Vi.length; hi++)
                  yi = Vi.start(hi), ci = Vi.end(hi), ci > Ei && (ci = Ei), bi += ci - yi;
                return bi / Ei;
              }
              function od(Vi) {
                if (Vi instanceof od)
                  return Vi;
                typeof Vi == "number" ? this.code = Vi : typeof Vi == "string" ? this.message = Vi : rs(Vi) && (typeof Vi.code == "number" && (this.code = Vi.code), Ta(this, Vi)), this.message || (this.message = od.defaultMessages[this.code] || "");
              }
              od.prototype.code = 0, od.prototype.message = "", od.prototype.status = null, od.errorTypes = ["MEDIA_ERR_CUSTOM", "MEDIA_ERR_ABORTED", "MEDIA_ERR_NETWORK", "MEDIA_ERR_DECODE", "MEDIA_ERR_SRC_NOT_SUPPORTED", "MEDIA_ERR_ENCRYPTED"], od.defaultMessages = {
                1: "You aborted the media playback",
                2: "A network error caused the media download to fail part-way.",
                3: "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.",
                4: "The media could not be loaded, either because the server or network failed or because the format is not supported.",
                5: "The media is encrypted and we do not have the keys to decrypt it."
              };
              for (var ad = 0; ad < od.errorTypes.length; ad++)
                od[od.errorTypes[ad]] = ad, od.prototype[od.errorTypes[ad]] = ad;
              function Dd(Vi) {
                return Vi != null && typeof Vi.then == "function";
              }
              function wd(Vi) {
                Dd(Vi) && Vi.then(null, function(Ei) {
                });
              }
              var nd = function(Ei) {
                var bi = ["kind", "label", "language", "id", "inBandMetadataTrackDispatchType", "mode", "src"].reduce(function(yi, ci, hi) {
                  return Ei[ci] && (yi[ci] = Ei[ci]), yi;
                }, {
                  cues: Ei.cues && Array.prototype.map.call(Ei.cues, function(yi) {
                    return {
                      startTime: yi.startTime,
                      endTime: yi.endTime,
                      text: yi.text,
                      id: yi.id
                    };
                  })
                });
                return bi;
              }, zd = function(Ei) {
                var bi = Ei.$$("track"), yi = Array.prototype.map.call(bi, function(hi) {
                  return hi.track;
                }), ci = Array.prototype.map.call(bi, function(hi) {
                  var wi = nd(hi.track);
                  return hi.src && (wi.src = hi.src), wi;
                });
                return ci.concat(Array.prototype.filter.call(Ei.textTracks(), function(hi) {
                  return yi.indexOf(hi) === -1;
                }).map(nd));
              }, vh = function(Ei, bi) {
                return Ei.forEach(function(yi) {
                  var ci = bi.addRemoteTextTrack(yi).track;
                  !yi.src && yi.cues && yi.cues.forEach(function(hi) {
                    return ci.addCue(hi);
                  });
                }), bi.textTracks();
              }, Vp = {
                textTracksToJson: zd,
                jsonToTextTracks: vh,
                trackToJson_: nd
              }, Wp = "vjs-modal-dialog", hd = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  return hi = Vi.call(this, yi, ci) || this, hi.handleKeyDown_ = function(wi) {
                    return hi.handleKeyDown(wi);
                  }, hi.close_ = function(wi) {
                    return hi.close(wi);
                  }, hi.opened_ = hi.hasBeenOpened_ = hi.hasBeenFilled_ = !1, hi.closeable(!hi.options_.uncloseable), hi.content(hi.options_.content), hi.contentEl_ = bl("div", {
                    className: Wp + "-content"
                  }, {
                    role: "document"
                  }), hi.descEl_ = bl("p", {
                    className: Wp + "-description vjs-control-text",
                    id: hi.el().getAttribute("aria-describedby")
                  }), Za(hi.descEl_, hi.description()), hi.el_.appendChild(hi.descEl_), hi.el_.appendChild(hi.contentEl_), hi;
                }
                var bi = Ei.prototype;
                return bi.createEl = function() {
                  return Vi.prototype.createEl.call(this, "div", {
                    className: this.buildCSSClass(),
                    tabIndex: -1
                  }, {
                    "aria-describedby": this.id() + "_description",
                    "aria-hidden": "true",
                    "aria-label": this.label(),
                    role: "dialog"
                  });
                }, bi.dispose = function() {
                  this.contentEl_ = null, this.descEl_ = null, this.previouslyActiveEl_ = null, Vi.prototype.dispose.call(this);
                }, bi.buildCSSClass = function() {
                  return Wp + " vjs-hidden " + Vi.prototype.buildCSSClass.call(this);
                }, bi.label = function() {
                  return this.localize(this.options_.label || "Modal Window");
                }, bi.description = function() {
                  var ci = this.options_.description || this.localize("This is a modal window.");
                  return this.closeable() && (ci += " " + this.localize("This modal can be closed by pressing the Escape key or activating the close button.")), ci;
                }, bi.open = function() {
                  if (!this.opened_) {
                    var ci = this.player();
                    this.trigger("beforemodalopen"), this.opened_ = !0, (this.options_.fillAlways || !this.hasBeenOpened_ && !this.hasBeenFilled_) && this.fill(), this.wasPlaying_ = !ci.paused(), this.options_.pauseOnOpen && this.wasPlaying_ && ci.pause(), this.on("keydown", this.handleKeyDown_), this.hadControls_ = ci.controls(), ci.controls(!1), this.show(), this.conditionalFocus_(), this.el().setAttribute("aria-hidden", "false"), this.trigger("modalopen"), this.hasBeenOpened_ = !0;
                  }
                }, bi.opened = function(ci) {
                  return typeof ci == "boolean" && this[ci ? "open" : "close"](), this.opened_;
                }, bi.close = function() {
                  if (this.opened_) {
                    var ci = this.player();
                    this.trigger("beforemodalclose"), this.opened_ = !1, this.wasPlaying_ && this.options_.pauseOnOpen && ci.play(), this.off("keydown", this.handleKeyDown_), this.hadControls_ && ci.controls(!0), this.hide(), this.el().setAttribute("aria-hidden", "true"), this.trigger("modalclose"), this.conditionalBlur_(), this.options_.temporary && this.dispose();
                  }
                }, bi.closeable = function(ci) {
                  if (typeof ci == "boolean") {
                    var hi = this.closeable_ = !!ci, wi = this.getChild("closeButton");
                    if (hi && !wi) {
                      var zi = this.contentEl_;
                      this.contentEl_ = this.el_, wi = this.addChild("closeButton", {
                        controlText: "Close Modal Dialog"
                      }), this.contentEl_ = zi, this.on(wi, "close", this.close_);
                    }
                    !hi && wi && (this.off(wi, "close", this.close_), this.removeChild(wi), wi.dispose());
                  }
                  return this.closeable_;
                }, bi.fill = function() {
                  this.fillWith(this.content());
                }, bi.fillWith = function(ci) {
                  var hi = this.contentEl(), wi = hi.parentNode, zi = hi.nextSibling;
                  this.trigger("beforemodalfill"), this.hasBeenFilled_ = !0, wi.removeChild(hi), this.empty(), Hl(hi, ci), this.trigger("modalfill"), zi ? wi.insertBefore(hi, zi) : wi.appendChild(hi);
                  var Wo = this.getChild("closeButton");
                  Wo && wi.appendChild(Wo.el_);
                }, bi.empty = function() {
                  this.trigger("beforemodalempty"), Yl(this.contentEl()), this.trigger("modalempty");
                }, bi.content = function(ci) {
                  return typeof ci < "u" && (this.content_ = ci), this.content_;
                }, bi.conditionalFocus_ = function() {
                  var ci = gi().activeElement, hi = this.player_.el_;
                  this.previouslyActiveEl_ = null, (hi.contains(ci) || hi === ci) && (this.previouslyActiveEl_ = ci, this.focus());
                }, bi.conditionalBlur_ = function() {
                  this.previouslyActiveEl_ && (this.previouslyActiveEl_.focus(), this.previouslyActiveEl_ = null);
                }, bi.handleKeyDown = function(ci) {
                  if (ci.stopPropagation(), vi().isEventKey(ci, "Escape") && this.closeable()) {
                    ci.preventDefault(), this.close();
                    return;
                  }
                  if (vi().isEventKey(ci, "Tab")) {
                    for (var hi = this.focusableEls_(), wi = this.el_.querySelector(":focus"), zi, Wo = 0; Wo < hi.length; Wo++)
                      if (wi === hi[Wo]) {
                        zi = Wo;
                        break;
                      }
                    gi().activeElement === this.el_ && (zi = 0), ci.shiftKey && zi === 0 ? (hi[hi.length - 1].focus(), ci.preventDefault()) : !ci.shiftKey && zi === hi.length - 1 && (hi[0].focus(), ci.preventDefault());
                  }
                }, bi.focusableEls_ = function() {
                  var ci = this.el_.querySelectorAll("*");
                  return Array.prototype.filter.call(ci, function(hi) {
                    return (hi instanceof di().HTMLAnchorElement || hi instanceof di().HTMLAreaElement) && hi.hasAttribute("href") || (hi instanceof di().HTMLInputElement || hi instanceof di().HTMLSelectElement || hi instanceof di().HTMLTextAreaElement || hi instanceof di().HTMLButtonElement) && !hi.hasAttribute("disabled") || hi instanceof di().HTMLIFrameElement || hi instanceof di().HTMLObjectElement || hi instanceof di().HTMLEmbedElement || hi.hasAttribute("tabindex") && hi.getAttribute("tabindex") !== -1 || hi.hasAttribute("contenteditable");
                  });
                }, Ei;
              })(ou);
              hd.prototype.options_ = {
                pauseOnOpen: !0,
                temporary: !0
              }, ou.registerComponent("ModalDialog", hd);
              var Uf = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi) {
                  var ci;
                  yi === void 0 && (yi = []), ci = Vi.call(this) || this, ci.tracks_ = [], Object.defineProperty((0, xi.default)(ci), "length", {
                    get: function() {
                      return this.tracks_.length;
                    }
                  });
                  for (var hi = 0; hi < yi.length; hi++)
                    ci.addTrack(yi[hi]);
                  return ci;
                }
                var bi = Ei.prototype;
                return bi.addTrack = function(ci) {
                  var hi = this, wi = this.tracks_.length;
                  "" + wi in this || Object.defineProperty(this, wi, {
                    get: function() {
                      return this.tracks_[wi];
                    }
                  }), this.tracks_.indexOf(ci) === -1 && (this.tracks_.push(ci), this.trigger({
                    track: ci,
                    type: "addtrack",
                    target: this
                  })), ci.labelchange_ = function() {
                    hi.trigger({
                      track: ci,
                      type: "labelchange",
                      target: hi
                    });
                  }, Vd(ci) && ci.addEventListener("labelchange", ci.labelchange_);
                }, bi.removeTrack = function(ci) {
                  for (var hi, wi = 0, zi = this.length; wi < zi; wi++)
                    if (this[wi] === ci) {
                      hi = this[wi], hi.off && hi.off(), this.tracks_.splice(wi, 1);
                      break;
                    }
                  hi && this.trigger({
                    track: hi,
                    type: "removetrack",
                    target: this
                  });
                }, bi.getTrackById = function(ci) {
                  for (var hi = null, wi = 0, zi = this.length; wi < zi; wi++) {
                    var Wo = this[wi];
                    if (Wo.id === ci) {
                      hi = Wo;
                      break;
                    }
                  }
                  return hi;
                }, Ei;
              })(Kc);
              Uf.prototype.allowedEvents_ = {
                change: "change",
                addtrack: "addtrack",
                removetrack: "removetrack",
                labelchange: "labelchange"
              };
              for (var lc in Uf.prototype.allowedEvents_)
                Uf.prototype["on" + lc] = null;
              var Gp = function(Ei, bi) {
                for (var yi = 0; yi < Ei.length; yi++)
                  !Object.keys(Ei[yi]).length || bi.id === Ei[yi].id || (Ei[yi].enabled = !1);
              }, Kd = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi) {
                  var ci;
                  yi === void 0 && (yi = []);
                  for (var hi = yi.length - 1; hi >= 0; hi--)
                    if (yi[hi].enabled) {
                      Gp(yi, yi[hi]);
                      break;
                    }
                  return ci = Vi.call(this, yi) || this, ci.changing_ = !1, ci;
                }
                var bi = Ei.prototype;
                return bi.addTrack = function(ci) {
                  var hi = this;
                  ci.enabled && Gp(this, ci), Vi.prototype.addTrack.call(this, ci), ci.addEventListener && (ci.enabledChange_ = function() {
                    hi.changing_ || (hi.changing_ = !0, Gp(hi, ci), hi.changing_ = !1, hi.trigger("change"));
                  }, ci.addEventListener("enabledchange", ci.enabledChange_));
                }, bi.removeTrack = function(ci) {
                  Vi.prototype.removeTrack.call(this, ci), ci.removeEventListener && ci.enabledChange_ && (ci.removeEventListener("enabledchange", ci.enabledChange_), ci.enabledChange_ = null);
                }, Ei;
              })(Uf), Tp = function(Ei, bi) {
                for (var yi = 0; yi < Ei.length; yi++)
                  !Object.keys(Ei[yi]).length || bi.id === Ei[yi].id || (Ei[yi].selected = !1);
              }, qd = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi) {
                  var ci;
                  yi === void 0 && (yi = []);
                  for (var hi = yi.length - 1; hi >= 0; hi--)
                    if (yi[hi].selected) {
                      Tp(yi, yi[hi]);
                      break;
                    }
                  return ci = Vi.call(this, yi) || this, ci.changing_ = !1, Object.defineProperty((0, xi.default)(ci), "selectedIndex", {
                    get: function() {
                      for (var zi = 0; zi < this.length; zi++)
                        if (this[zi].selected)
                          return zi;
                      return -1;
                    },
                    set: function() {
                    }
                  }), ci;
                }
                var bi = Ei.prototype;
                return bi.addTrack = function(ci) {
                  var hi = this;
                  ci.selected && Tp(this, ci), Vi.prototype.addTrack.call(this, ci), ci.addEventListener && (ci.selectedChange_ = function() {
                    hi.changing_ || (hi.changing_ = !0, Tp(hi, ci), hi.changing_ = !1, hi.trigger("change"));
                  }, ci.addEventListener("selectedchange", ci.selectedChange_));
                }, bi.removeTrack = function(ci) {
                  Vi.prototype.removeTrack.call(this, ci), ci.removeEventListener && ci.selectedChange_ && (ci.removeEventListener("selectedchange", ci.selectedChange_), ci.selectedChange_ = null);
                }, Ei;
              })(Uf), yh = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei() {
                  return Vi.apply(this, arguments) || this;
                }
                var bi = Ei.prototype;
                return bi.addTrack = function(ci) {
                  var hi = this;
                  Vi.prototype.addTrack.call(this, ci), this.queueChange_ || (this.queueChange_ = function() {
                    return hi.queueTrigger("change");
                  }), this.triggerSelectedlanguagechange || (this.triggerSelectedlanguagechange_ = function() {
                    return hi.trigger("selectedlanguagechange");
                  }), ci.addEventListener("modechange", this.queueChange_);
                  var wi = ["metadata", "chapters"];
                  wi.indexOf(ci.kind) === -1 && ci.addEventListener("modechange", this.triggerSelectedlanguagechange_);
                }, bi.removeTrack = function(ci) {
                  Vi.prototype.removeTrack.call(this, ci), ci.removeEventListener && (this.queueChange_ && ci.removeEventListener("modechange", this.queueChange_), this.selectedlanguagechange_ && ci.removeEventListener("modechange", this.triggerSelectedlanguagechange_));
                }, Ei;
              })(Uf), Vf = /* @__PURE__ */ (function() {
                function Vi(bi) {
                  bi === void 0 && (bi = []), this.trackElements_ = [], Object.defineProperty(this, "length", {
                    get: function() {
                      return this.trackElements_.length;
                    }
                  });
                  for (var yi = 0, ci = bi.length; yi < ci; yi++)
                    this.addTrackElement_(bi[yi]);
                }
                var Ei = Vi.prototype;
                return Ei.addTrackElement_ = function(yi) {
                  var ci = this.trackElements_.length;
                  "" + ci in this || Object.defineProperty(this, ci, {
                    get: function() {
                      return this.trackElements_[ci];
                    }
                  }), this.trackElements_.indexOf(yi) === -1 && this.trackElements_.push(yi);
                }, Ei.getTrackElementByTrack_ = function(yi) {
                  for (var ci, hi = 0, wi = this.trackElements_.length; hi < wi; hi++)
                    if (yi === this.trackElements_[hi].track) {
                      ci = this.trackElements_[hi];
                      break;
                    }
                  return ci;
                }, Ei.removeTrackElement_ = function(yi) {
                  for (var ci = 0, hi = this.trackElements_.length; ci < hi; ci++)
                    if (yi === this.trackElements_[ci]) {
                      this.trackElements_[ci].track && typeof this.trackElements_[ci].track.off == "function" && this.trackElements_[ci].track.off(), typeof this.trackElements_[ci].off == "function" && this.trackElements_[ci].off(), this.trackElements_.splice(ci, 1);
                      break;
                    }
                }, Vi;
              })(), Ep = /* @__PURE__ */ (function() {
                function Vi(bi) {
                  Vi.prototype.setCues_.call(this, bi), Object.defineProperty(this, "length", {
                    get: function() {
                      return this.length_;
                    }
                  });
                }
                var Ei = Vi.prototype;
                return Ei.setCues_ = function(yi) {
                  var ci = this.length || 0, hi = 0, wi = yi.length;
                  this.cues_ = yi, this.length_ = yi.length;
                  var zi = function(aa) {
                    "" + aa in this || Object.defineProperty(this, "" + aa, {
                      get: function() {
                        return this.cues_[aa];
                      }
                    });
                  };
                  if (ci < wi)
                    for (hi = ci; hi < wi; hi++)
                      zi.call(this, hi);
                }, Ei.getCueById = function(yi) {
                  for (var ci = null, hi = 0, wi = this.length; hi < wi; hi++) {
                    var zi = this[hi];
                    if (zi.id === yi) {
                      ci = zi;
                      break;
                    }
                  }
                  return ci;
                }, Vi;
              })(), Hp = {
                alternative: "alternative",
                captions: "captions",
                main: "main",
                sign: "sign",
                subtitles: "subtitles",
                commentary: "commentary"
              }, Wf = {
                alternative: "alternative",
                descriptions: "descriptions",
                main: "main",
                "main-desc": "main-desc",
                translation: "translation",
                commentary: "commentary"
              }, Sp = {
                subtitles: "subtitles",
                captions: "captions",
                descriptions: "descriptions",
                chapters: "chapters",
                metadata: "metadata"
              }, Gf = {
                disabled: "disabled",
                hidden: "hidden",
                showing: "showing"
              }, sd = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(bi) {
                  var yi;
                  bi === void 0 && (bi = {}), yi = Vi.call(this) || this;
                  var ci = {
                    id: bi.id || "vjs_track_" + fd(),
                    kind: bi.kind || "",
                    language: bi.language || ""
                  }, hi = bi.label || "", wi = function(aa) {
                    Object.defineProperty((0, xi.default)(yi), aa, {
                      get: function() {
                        return ci[aa];
                      },
                      set: function() {
                      }
                    });
                  };
                  for (var zi in ci)
                    wi(zi);
                  return Object.defineProperty((0, xi.default)(yi), "label", {
                    get: function() {
                      return hi;
                    },
                    set: function(aa) {
                      aa !== hi && (hi = aa, this.trigger("labelchange"));
                    }
                  }), yi;
                }
                return Ei;
              })(Kc), _d = function(Ei) {
                var bi = ["protocol", "hostname", "port", "pathname", "search", "hash", "host"], yi = gi().createElement("a");
                yi.href = Ei;
                for (var ci = {}, hi = 0; hi < bi.length; hi++)
                  ci[bi[hi]] = yi[bi[hi]];
                return ci.protocol === "http:" && (ci.host = ci.host.replace(/:80$/, "")), ci.protocol === "https:" && (ci.host = ci.host.replace(/:443$/, "")), ci.protocol || (ci.protocol = di().location.protocol), ci.host || (ci.host = di().location.host), ci;
              }, Yd = function(Ei) {
                if (!Ei.match(/^https?:\/\//)) {
                  var bi = gi().createElement("a");
                  bi.href = Ei, Ei = bi.href;
                }
                return Ei;
              }, zp = function(Ei) {
                if (typeof Ei == "string") {
                  var bi = /^(\/?)([\s\S]*?)((?:\.{1,2}|[^\/]+?)(\.([^\.\/\?]+)))(?:[\/]*|[\?].*)$/, yi = bi.exec(Ei);
                  if (yi)
                    return yi.pop().toLowerCase();
                }
                return "";
              }, Ef = function(Ei, bi) {
                bi === void 0 && (bi = di().location);
                var yi = _d(Ei), ci = yi.protocol === ":" ? bi.protocol : yi.protocol, hi = ci + yi.host !== bi.protocol + bi.host;
                return hi;
              }, Yh = /* @__PURE__ */ Object.freeze({
                __proto__: null,
                parseUrl: _d,
                getAbsoluteURL: Yd,
                getFileExtension: zp,
                isCrossOrigin: Ef
              }), xp = function(Ei, bi) {
                var yi = new (di()).WebVTT.Parser(di(), di().vttjs, di().WebVTT.StringDecoder()), ci = [];
                yi.oncue = function(hi) {
                  bi.addCue(hi);
                }, yi.onparsingerror = function(hi) {
                  ci.push(hi);
                }, yi.onflush = function() {
                  bi.trigger({
                    type: "loadeddata",
                    target: bi
                  });
                }, yi.parse(Ei), ci.length > 0 && (di().console && di().console.groupCollapsed && di().console.groupCollapsed("Text Track parsing errors for " + bi.src), ci.forEach(function(hi) {
                  return Xa.error(hi);
                }), di().console && di().console.groupEnd && di().console.groupEnd()), yi.flush();
              }, wp = function(Ei, bi) {
                var yi = {
                  uri: Ei
                }, ci = Ef(Ei);
                ci && (yi.cors = ci);
                var hi = bi.tech_.crossOrigin() === "use-credentials";
                hi && (yi.withCredentials = hi), Di()(yi, Tc(this, function(wi, zi, Wo) {
                  if (wi)
                    return Xa.error(wi, zi);
                  bi.loaded_ = !0, typeof di().WebVTT != "function" ? bi.tech_ && bi.tech_.any(["vttjsloaded", "vttjserror"], function(aa) {
                    if (aa.type === "vttjserror") {
                      Xa.error("vttjs failed to load, stopping trying to process " + bi.src);
                      return;
                    }
                    return xp(Wo, bi);
                  }) : xp(Wo, bi);
                }));
              }, Xd = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi) {
                  var ci;
                  if (yi === void 0 && (yi = {}), !yi.tech)
                    throw new Error("A tech was not provided.");
                  var hi = Ec(yi, {
                    kind: Sp[yi.kind] || "subtitles",
                    language: yi.language || yi.srclang || ""
                  }), wi = Gf[hi.mode] || "disabled", zi = hi.default;
                  (hi.kind === "metadata" || hi.kind === "chapters") && (wi = "hidden"), ci = Vi.call(this, hi) || this, ci.tech_ = hi.tech, ci.cues_ = [], ci.activeCues_ = [], ci.preload_ = ci.tech_.preloadTextTracks !== !1;
                  var Wo = new Ep(ci.cues_), aa = new Ep(ci.activeCues_), Ea = !1;
                  ci.timeupdateHandler = Tc((0, xi.default)(ci), function(Ha) {
                    if (Ha === void 0 && (Ha = {}), !this.tech_.isDisposed()) {
                      if (!this.tech_.isReady_) {
                        Ha.type !== "timeupdate" && (this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler));
                        return;
                      }
                      this.activeCues = this.activeCues, Ea && (this.trigger("cuechange"), Ea = !1), Ha.type !== "timeupdate" && (this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler));
                    }
                  });
                  var Ka = function() {
                    ci.stopTracking();
                  };
                  return ci.tech_.one("dispose", Ka), wi !== "disabled" && ci.startTracking(), Object.defineProperties((0, xi.default)(ci), {
                    /**
                     * @memberof TextTrack
                     * @member {boolean} default
                     *         If this track was set to be on or off by default. Cannot be changed after
                     *         creation.
                     * @instance
                     *
                     * @readonly
                     */
                    default: {
                      get: function() {
                        return zi;
                      },
                      set: function() {
                      }
                    },
                    /**
                     * @memberof TextTrack
                     * @member {string} mode
                     *         Set the mode of this TextTrack to a valid {@link TextTrack~Mode}. Will
                     *         not be set if setting to an invalid mode.
                     * @instance
                     *
                     * @fires TextTrack#modechange
                     */
                    mode: {
                      get: function() {
                        return wi;
                      },
                      set: function(ks) {
                        Gf[ks] && wi !== ks && (wi = ks, !this.preload_ && wi !== "disabled" && this.cues.length === 0 && wp(this.src, this), this.stopTracking(), wi !== "disabled" && this.startTracking(), this.trigger("modechange"));
                      }
                    },
                    /**
                     * @memberof TextTrack
                     * @member {TextTrackCueList} cues
                     *         The text track cue list for this TextTrack.
                     * @instance
                     */
                    cues: {
                      get: function() {
                        return this.loaded_ ? Wo : null;
                      },
                      set: function() {
                      }
                    },
                    /**
                     * @memberof TextTrack
                     * @member {TextTrackCueList} activeCues
                     *         The list text track cues that are currently active for this TextTrack.
                     * @instance
                     */
                    activeCues: {
                      get: function() {
                        if (!this.loaded_)
                          return null;
                        if (this.cues.length === 0)
                          return aa;
                        for (var ks = this.tech_.currentTime(), gl = [], Sl = 0, Fl = this.cues.length; Sl < Fl; Sl++) {
                          var ru = this.cues[Sl];
                          (ru.startTime <= ks && ru.endTime >= ks || ru.startTime === ru.endTime && ru.startTime <= ks && ru.startTime + 0.5 >= ks) && gl.push(ru);
                        }
                        if (Ea = !1, gl.length !== this.activeCues_.length)
                          Ea = !0;
                        else
                          for (var $u = 0; $u < gl.length; $u++)
                            this.activeCues_.indexOf(gl[$u]) === -1 && (Ea = !0);
                        return this.activeCues_ = gl, aa.setCues_(this.activeCues_), aa;
                      },
                      // /!\ Keep this setter empty (see the timeupdate handler above)
                      set: function() {
                      }
                    }
                  }), hi.src ? (ci.src = hi.src, ci.preload_ || (ci.loaded_ = !0), (ci.preload_ || hi.kind !== "subtitles" && hi.kind !== "captions") && wp(ci.src, (0, xi.default)(ci))) : ci.loaded_ = !0, ci;
                }
                var bi = Ei.prototype;
                return bi.startTracking = function() {
                  this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler), this.tech_.on("timeupdate", this.timeupdateHandler);
                }, bi.stopTracking = function() {
                  this.rvf_ && (this.tech_.cancelVideoFrameCallback(this.rvf_), this.rvf_ = void 0), this.tech_.off("timeupdate", this.timeupdateHandler);
                }, bi.addCue = function(ci) {
                  var hi = ci;
                  if (!("getCueAsHTML" in hi)) {
                    hi = new (di()).vttjs.VTTCue(ci.startTime, ci.endTime, ci.text);
                    for (var wi in ci)
                      wi in hi || (hi[wi] = ci[wi]);
                    hi.id = ci.id, hi.originalCue_ = ci;
                  }
                  for (var zi = this.tech_.textTracks(), Wo = 0; Wo < zi.length; Wo++)
                    zi[Wo] !== this && zi[Wo].removeCue(hi);
                  this.cues_.push(hi), this.cues.setCues_(this.cues_);
                }, bi.removeCue = function(ci) {
                  for (var hi = this.cues_.length; hi--; ) {
                    var wi = this.cues_[hi];
                    if (wi === ci || wi.originalCue_ && wi.originalCue_ === ci) {
                      this.cues_.splice(hi, 1), this.cues.setCues_(this.cues_);
                      break;
                    }
                  }
                }, Ei;
              })(sd);
              Xd.prototype.allowedEvents_ = {
                cuechange: "cuechange"
              };
              var np = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(bi) {
                  var yi;
                  bi === void 0 && (bi = {});
                  var ci = Ec(bi, {
                    kind: Wf[bi.kind] || ""
                  });
                  yi = Vi.call(this, ci) || this;
                  var hi = !1;
                  return Object.defineProperty((0, xi.default)(yi), "enabled", {
                    get: function() {
                      return hi;
                    },
                    set: function(zi) {
                      typeof zi != "boolean" || zi === hi || (hi = zi, this.trigger("enabledchange"));
                    }
                  }), ci.enabled && (yi.enabled = ci.enabled), yi.loaded_ = !0, yi;
                }
                return Ei;
              })(sd), sf = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(bi) {
                  var yi;
                  bi === void 0 && (bi = {});
                  var ci = Ec(bi, {
                    kind: Hp[bi.kind] || ""
                  });
                  yi = Vi.call(this, ci) || this;
                  var hi = !1;
                  return Object.defineProperty((0, xi.default)(yi), "selected", {
                    get: function() {
                      return hi;
                    },
                    set: function(zi) {
                      typeof zi != "boolean" || zi === hi || (hi = zi, this.trigger("selectedchange"));
                    }
                  }), ci.selected && (yi.selected = ci.selected), yi;
                }
                return Ei;
              })(sd), _p = 0, Xh = 1, lf = 2, bh = 3, uf = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(bi) {
                  var yi;
                  bi === void 0 && (bi = {}), yi = Vi.call(this) || this;
                  var ci, hi = new Xd(bi);
                  return yi.kind = hi.kind, yi.src = hi.src, yi.srclang = hi.language, yi.label = hi.label, yi.default = hi.default, Object.defineProperties((0, xi.default)(yi), {
                    /**
                     * @memberof HTMLTrackElement
                     * @member {HTMLTrackElement~ReadyState} readyState
                     *         The current ready state of the track element.
                     * @instance
                     */
                    readyState: {
                      get: function() {
                        return ci;
                      }
                    },
                    /**
                     * @memberof HTMLTrackElement
                     * @member {TextTrack} track
                     *         The underlying TextTrack object.
                     * @instance
                     *
                     */
                    track: {
                      get: function() {
                        return hi;
                      }
                    }
                  }), ci = _p, hi.addEventListener("loadeddata", function() {
                    ci = lf, yi.trigger({
                      type: "load",
                      target: (0, xi.default)(yi)
                    });
                  }), yi;
                }
                return Ei;
              })(Kc);
              uf.prototype.allowedEvents_ = {
                load: "load"
              }, uf.NONE = _p, uf.LOADING = Xh, uf.LOADED = lf, uf.ERROR = bh;
              var gd = {
                audio: {
                  ListClass: Kd,
                  TrackClass: np,
                  capitalName: "Audio"
                },
                video: {
                  ListClass: qd,
                  TrackClass: sf,
                  capitalName: "Video"
                },
                text: {
                  ListClass: yh,
                  TrackClass: Xd,
                  capitalName: "Text"
                }
              };
              Object.keys(gd).forEach(function(Vi) {
                gd[Vi].getterName = Vi + "Tracks", gd[Vi].privateName = Vi + "Tracks_";
              });
              var Sf = {
                remoteText: {
                  ListClass: yh,
                  TrackClass: Xd,
                  capitalName: "RemoteText",
                  getterName: "remoteTextTracks",
                  privateName: "remoteTextTracks_"
                },
                remoteTextEl: {
                  ListClass: Vf,
                  TrackClass: uf,
                  capitalName: "RemoteTextTrackEls",
                  getterName: "remoteTextTrackEls",
                  privateName: "remoteTextTrackEls_"
                }
              }, Yc = (0, mi.default)({}, gd, Sf);
              Sf.names = Object.keys(Sf), gd.names = Object.keys(gd), Yc.names = [].concat(Sf.names).concat(gd.names);
              function Kp(Vi, Ei, bi, yi, ci) {
                ci === void 0 && (ci = {});
                var hi = Vi.textTracks();
                ci.kind = Ei, bi && (ci.label = bi), yi && (ci.language = yi), ci.tech = Vi;
                var wi = new Yc.text.TrackClass(ci);
                return hi.addTrack(wi), wi;
              }
              var Sc = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  return yi === void 0 && (yi = {}), ci === void 0 && (ci = function() {
                  }), yi.reportTouchActivity = !1, hi = Vi.call(this, null, yi, ci) || this, hi.onDurationChange_ = function(wi) {
                    return hi.onDurationChange(wi);
                  }, hi.trackProgress_ = function(wi) {
                    return hi.trackProgress(wi);
                  }, hi.trackCurrentTime_ = function(wi) {
                    return hi.trackCurrentTime(wi);
                  }, hi.stopTrackingCurrentTime_ = function(wi) {
                    return hi.stopTrackingCurrentTime(wi);
                  }, hi.disposeSourceHandler_ = function(wi) {
                    return hi.disposeSourceHandler(wi);
                  }, hi.queuedHanders_ = /* @__PURE__ */ new Set(), hi.hasStarted_ = !1, hi.on("playing", function() {
                    this.hasStarted_ = !0;
                  }), hi.on("loadstart", function() {
                    this.hasStarted_ = !1;
                  }), Yc.names.forEach(function(wi) {
                    var zi = Yc[wi];
                    yi && yi[zi.getterName] && (hi[zi.privateName] = yi[zi.getterName]);
                  }), hi.featuresProgressEvents || hi.manualProgressOn(), hi.featuresTimeupdateEvents || hi.manualTimeUpdatesOn(), ["Text", "Audio", "Video"].forEach(function(wi) {
                    yi["native" + wi + "Tracks"] === !1 && (hi["featuresNative" + wi + "Tracks"] = !1);
                  }), yi.nativeCaptions === !1 || yi.nativeTextTracks === !1 ? hi.featuresNativeTextTracks = !1 : (yi.nativeCaptions === !0 || yi.nativeTextTracks === !0) && (hi.featuresNativeTextTracks = !0), hi.featuresNativeTextTracks || hi.emulateTextTracks(), hi.preloadTextTracks = yi.preloadTextTracks !== !1, hi.autoRemoteTextTracks_ = new Yc.text.ListClass(), hi.initTrackListeners(), yi.nativeControlsForTouch || hi.emitTapEvents(), hi.constructor && (hi.name_ = hi.constructor.name || "Unknown Tech"), hi;
                }
                var bi = Ei.prototype;
                return bi.triggerSourceset = function(ci) {
                  var hi = this;
                  this.isReady_ || this.one("ready", function() {
                    return hi.setTimeout(function() {
                      return hi.triggerSourceset(ci);
                    }, 1);
                  }), this.trigger({
                    src: ci,
                    type: "sourceset"
                  });
                }, bi.manualProgressOn = function() {
                  this.on("durationchange", this.onDurationChange_), this.manualProgress = !0, this.one("ready", this.trackProgress_);
                }, bi.manualProgressOff = function() {
                  this.manualProgress = !1, this.stopTrackingProgress(), this.off("durationchange", this.onDurationChange_);
                }, bi.trackProgress = function(ci) {
                  this.stopTrackingProgress(), this.progressInterval = this.setInterval(Tc(this, function() {
                    var hi = this.bufferedPercent();
                    this.bufferedPercent_ !== hi && this.trigger("progress"), this.bufferedPercent_ = hi, hi === 1 && this.stopTrackingProgress();
                  }), 500);
                }, bi.onDurationChange = function(ci) {
                  this.duration_ = this.duration();
                }, bi.buffered = function() {
                  return Tf(0, 0);
                }, bi.bufferedPercent = function() {
                  return bp(this.buffered(), this.duration_);
                }, bi.stopTrackingProgress = function() {
                  this.clearInterval(this.progressInterval);
                }, bi.manualTimeUpdatesOn = function() {
                  this.manualTimeUpdates = !0, this.on("play", this.trackCurrentTime_), this.on("pause", this.stopTrackingCurrentTime_);
                }, bi.manualTimeUpdatesOff = function() {
                  this.manualTimeUpdates = !1, this.stopTrackingCurrentTime(), this.off("play", this.trackCurrentTime_), this.off("pause", this.stopTrackingCurrentTime_);
                }, bi.trackCurrentTime = function() {
                  this.currentTimeInterval && this.stopTrackingCurrentTime(), this.currentTimeInterval = this.setInterval(function() {
                    this.trigger({
                      type: "timeupdate",
                      target: this,
                      manuallyTriggered: !0
                    });
                  }, 250);
                }, bi.stopTrackingCurrentTime = function() {
                  this.clearInterval(this.currentTimeInterval), this.trigger({
                    type: "timeupdate",
                    target: this,
                    manuallyTriggered: !0
                  });
                }, bi.dispose = function() {
                  this.clearTracks(gd.names), this.manualProgress && this.manualProgressOff(), this.manualTimeUpdates && this.manualTimeUpdatesOff(), Vi.prototype.dispose.call(this);
                }, bi.clearTracks = function(ci) {
                  var hi = this;
                  ci = [].concat(ci), ci.forEach(function(wi) {
                    for (var zi = hi[wi + "Tracks"]() || [], Wo = zi.length; Wo--; ) {
                      var aa = zi[Wo];
                      wi === "text" && hi.removeRemoteTextTrack(aa), zi.removeTrack(aa);
                    }
                  });
                }, bi.cleanupAutoTextTracks = function() {
                  for (var ci = this.autoRemoteTextTracks_ || [], hi = ci.length; hi--; ) {
                    var wi = ci[hi];
                    this.removeRemoteTextTrack(wi);
                  }
                }, bi.reset = function() {
                }, bi.crossOrigin = function() {
                }, bi.setCrossOrigin = function() {
                }, bi.error = function(ci) {
                  return ci !== void 0 && (this.error_ = new od(ci), this.trigger("error")), this.error_;
                }, bi.played = function() {
                  return this.hasStarted_ ? Tf(0, 0) : Tf();
                }, bi.play = function() {
                }, bi.setScrubbing = function() {
                }, bi.scrubbing = function() {
                }, bi.setCurrentTime = function() {
                  this.manualTimeUpdates && this.trigger({
                    type: "timeupdate",
                    target: this,
                    manuallyTriggered: !0
                  });
                }, bi.initTrackListeners = function() {
                  var ci = this;
                  gd.names.forEach(function(hi) {
                    var wi = gd[hi], zi = function() {
                      ci.trigger(hi + "trackchange");
                    }, Wo = ci[wi.getterName]();
                    Wo.addEventListener("removetrack", zi), Wo.addEventListener("addtrack", zi), ci.on("dispose", function() {
                      Wo.removeEventListener("removetrack", zi), Wo.removeEventListener("addtrack", zi);
                    });
                  });
                }, bi.addWebVttScript_ = function() {
                  var ci = this;
                  if (!di().WebVTT)
                    if (gi().body.contains(this.el())) {
                      if (!this.options_["vtt.js"] && Qa(Oo()) && Object.keys(Oo()).length > 0) {
                        this.trigger("vttjsloaded");
                        return;
                      }
                      var hi = gi().createElement("script");
                      hi.src = this.options_["vtt.js"] || "https://vjs.zencdn.net/vttjs/0.14.1/vtt.min.js", hi.onload = function() {
                        ci.trigger("vttjsloaded");
                      }, hi.onerror = function() {
                        ci.trigger("vttjserror");
                      }, this.on("dispose", function() {
                        hi.onload = null, hi.onerror = null;
                      }), di().WebVTT = !0, this.el().parentNode.appendChild(hi);
                    } else
                      this.ready(this.addWebVttScript_);
                }, bi.emulateTextTracks = function() {
                  var ci = this, hi = this.textTracks(), wi = this.remoteTextTracks(), zi = function(Ha) {
                    return hi.addTrack(Ha.track);
                  }, Wo = function(Ha) {
                    return hi.removeTrack(Ha.track);
                  };
                  wi.on("addtrack", zi), wi.on("removetrack", Wo), this.addWebVttScript_();
                  var aa = function() {
                    return ci.trigger("texttrackchange");
                  }, Ea = function() {
                    aa();
                    for (var Ha = 0; Ha < hi.length; Ha++) {
                      var ks = hi[Ha];
                      ks.removeEventListener("cuechange", aa), ks.mode === "showing" && ks.addEventListener("cuechange", aa);
                    }
                  };
                  Ea(), hi.addEventListener("change", Ea), hi.addEventListener("addtrack", Ea), hi.addEventListener("removetrack", Ea), this.on("dispose", function() {
                    wi.off("addtrack", zi), wi.off("removetrack", Wo), hi.removeEventListener("change", Ea), hi.removeEventListener("addtrack", Ea), hi.removeEventListener("removetrack", Ea);
                    for (var Ka = 0; Ka < hi.length; Ka++) {
                      var Ha = hi[Ka];
                      Ha.removeEventListener("cuechange", aa);
                    }
                  });
                }, bi.addTextTrack = function(ci, hi, wi) {
                  if (!ci)
                    throw new Error("TextTrack kind is required but was not provided");
                  return Kp(this, ci, hi, wi);
                }, bi.createRemoteTextTrack = function(ci) {
                  var hi = Ec(ci, {
                    tech: this
                  });
                  return new Sf.remoteTextEl.TrackClass(hi);
                }, bi.addRemoteTextTrack = function(ci, hi) {
                  var wi = this;
                  ci === void 0 && (ci = {});
                  var zi = this.createRemoteTextTrack(ci);
                  return hi !== !0 && hi !== !1 && (Xa.warn('Calling addRemoteTextTrack without explicitly setting the "manualCleanup" parameter to `true` is deprecated and default to `false` in future version of video.js'), hi = !0), this.remoteTextTrackEls().addTrackElement_(zi), this.remoteTextTracks().addTrack(zi.track), hi !== !0 && this.ready(function() {
                    return wi.autoRemoteTextTracks_.addTrack(zi.track);
                  }), zi;
                }, bi.removeRemoteTextTrack = function(ci) {
                  var hi = this.remoteTextTrackEls().getTrackElementByTrack_(ci);
                  this.remoteTextTrackEls().removeTrackElement_(hi), this.remoteTextTracks().removeTrack(ci), this.autoRemoteTextTracks_.removeTrack(ci);
                }, bi.getVideoPlaybackQuality = function() {
                  return {};
                }, bi.requestPictureInPicture = function() {
                  var ci = this.options_.Promise || di().Promise;
                  if (ci)
                    return ci.reject();
                }, bi.disablePictureInPicture = function() {
                  return !0;
                }, bi.setDisablePictureInPicture = function() {
                }, bi.requestVideoFrameCallback = function(ci) {
                  var hi = this, wi = fd();
                  return !this.isReady_ || this.paused() ? (this.queuedHanders_.add(wi), this.one("playing", function() {
                    hi.queuedHanders_.has(wi) && (hi.queuedHanders_.delete(wi), ci());
                  })) : this.requestNamedAnimationFrame(wi, ci), wi;
                }, bi.cancelVideoFrameCallback = function(ci) {
                  this.queuedHanders_.has(ci) ? this.queuedHanders_.delete(ci) : this.cancelNamedAnimationFrame(ci);
                }, bi.setPoster = function() {
                }, bi.playsinline = function() {
                }, bi.setPlaysinline = function() {
                }, bi.overrideNativeAudioTracks = function() {
                }, bi.overrideNativeVideoTracks = function() {
                }, bi.canPlayType = function() {
                  return "";
                }, Ei.canPlayType = function() {
                  return "";
                }, Ei.canPlaySource = function(ci, hi) {
                  return Ei.canPlayType(ci.type);
                }, Ei.isTech = function(ci) {
                  return ci.prototype instanceof Ei || ci instanceof Ei || ci === Ei;
                }, Ei.registerTech = function(ci, hi) {
                  if (Ei.techs_ || (Ei.techs_ = {}), !Ei.isTech(hi))
                    throw new Error("Tech " + ci + " must be a Tech");
                  if (!Ei.canPlayType)
                    throw new Error("Techs must have a static canPlayType method on them");
                  if (!Ei.canPlaySource)
                    throw new Error("Techs must have a static canPlaySource method on them");
                  return ci = Ic(ci), Ei.techs_[ci] = hi, Ei.techs_[af(ci)] = hi, ci !== "Tech" && Ei.defaultTechOrder_.push(ci), hi;
                }, Ei.getTech = function(ci) {
                  if (ci) {
                    if (Ei.techs_ && Ei.techs_[ci])
                      return Ei.techs_[ci];
                    if (ci = Ic(ci), di() && di().videojs && di().videojs[ci])
                      return Xa.warn("The " + ci + " tech was added to the videojs object when it should be registered using videojs.registerTech(name, tech)"), di().videojs[ci];
                  }
                }, Ei;
              })(ou);
              Yc.names.forEach(function(Vi) {
                var Ei = Yc[Vi];
                Sc.prototype[Ei.getterName] = function() {
                  return this[Ei.privateName] = this[Ei.privateName] || new Ei.ListClass(), this[Ei.privateName];
                };
              }), Sc.prototype.featuresVolumeControl = !0, Sc.prototype.featuresMuteControl = !0, Sc.prototype.featuresFullscreenResize = !1, Sc.prototype.featuresPlaybackRate = !1, Sc.prototype.featuresProgressEvents = !1, Sc.prototype.featuresSourceset = !1, Sc.prototype.featuresTimeupdateEvents = !1, Sc.prototype.featuresNativeTextTracks = !1, Sc.prototype.featuresVideoFrameCallback = !1, Sc.withSourceHandlers = function(Vi) {
                Vi.registerSourceHandler = function(bi, yi) {
                  var ci = Vi.sourceHandlers;
                  ci || (ci = Vi.sourceHandlers = []), yi === void 0 && (yi = ci.length), ci.splice(yi, 0, bi);
                }, Vi.canPlayType = function(bi) {
                  for (var yi = Vi.sourceHandlers || [], ci, hi = 0; hi < yi.length; hi++)
                    if (ci = yi[hi].canPlayType(bi), ci)
                      return ci;
                  return "";
                }, Vi.selectSourceHandler = function(bi, yi) {
                  for (var ci = Vi.sourceHandlers || [], hi, wi = 0; wi < ci.length; wi++)
                    if (hi = ci[wi].canHandleSource(bi, yi), hi)
                      return ci[wi];
                  return null;
                }, Vi.canPlaySource = function(bi, yi) {
                  var ci = Vi.selectSourceHandler(bi, yi);
                  return ci ? ci.canHandleSource(bi, yi) : "";
                };
                var Ei = ["seekable", "seeking", "duration"];
                Ei.forEach(function(bi) {
                  var yi = this[bi];
                  typeof yi == "function" && (this[bi] = function() {
                    return this.sourceHandler_ && this.sourceHandler_[bi] ? this.sourceHandler_[bi].apply(this.sourceHandler_, arguments) : yi.apply(this, arguments);
                  });
                }, Vi.prototype), Vi.prototype.setSource = function(bi) {
                  var yi = Vi.selectSourceHandler(bi, this.options_);
                  yi || (Vi.nativeSourceHandler ? yi = Vi.nativeSourceHandler : Xa.error("No source handler found for the current source.")), this.disposeSourceHandler(), this.off("dispose", this.disposeSourceHandler_), yi !== Vi.nativeSourceHandler && (this.currentSource_ = bi), this.sourceHandler_ = yi.handleSource(bi, this, this.options_), this.one("dispose", this.disposeSourceHandler_);
                }, Vi.prototype.disposeSourceHandler = function() {
                  this.currentSource_ && (this.clearTracks(["audio", "video"]), this.currentSource_ = null), this.cleanupAutoTextTracks(), this.sourceHandler_ && (this.sourceHandler_.dispose && this.sourceHandler_.dispose(), this.sourceHandler_ = null);
                };
              }, ou.registerComponent("Tech", Sc), Sc.registerTech("Tech", Sc), Sc.defaultTechOrder_ = [];
              var xf = {}, qp = {}, Pp = {};
              function Pd(Vi, Ei) {
                xf[Vi] = xf[Vi] || [], xf[Vi].push(Ei);
              }
              function Cd(Vi, Ei, bi) {
                Vi.setTimeout(function() {
                  return ld(Ei, xf[Ei.type], bi, Vi);
                }, 1);
              }
              function Hf(Vi, Ei) {
                Vi.forEach(function(bi) {
                  return bi.setTech && bi.setTech(Ei);
                });
              }
              function Zd(Vi, Ei, bi) {
                return Vi.reduceRight(Cp(bi), Ei[bi]());
              }
              function ef(Vi, Ei, bi, yi) {
                return Ei[bi](Vi.reduce(Cp(bi), yi));
              }
              function Yp(Vi, Ei, bi, yi) {
                yi === void 0 && (yi = null);
                var ci = "call" + Ic(bi), hi = Vi.reduce(Cp(ci), yi), wi = hi === Pp, zi = wi ? null : Ei[bi](hi);
                return Rd(Vi, bi, zi, wi), zi;
              }
              var Th = {
                buffered: 1,
                currentTime: 1,
                duration: 1,
                muted: 1,
                played: 1,
                paused: 1,
                seekable: 1,
                volume: 1,
                ended: 1
              }, Jh = {
                setCurrentTime: 1,
                setMuted: 1,
                setVolume: 1
              }, Eh = {
                play: 1,
                pause: 1
              };
              function Cp(Vi) {
                return function(Ei, bi) {
                  return Ei === Pp ? Pp : bi[Vi] ? bi[Vi](Ei) : Ei;
                };
              }
              function Rd(Vi, Ei, bi, yi) {
                for (var ci = Vi.length - 1; ci >= 0; ci--) {
                  var hi = Vi[ci];
                  hi[Ei] && hi[Ei](yi, bi);
                }
              }
              function Qh(Vi) {
                qp[Vi.id()] = null;
              }
              function md(Vi, Ei) {
                var bi = qp[Vi.id()], yi = null;
                if (bi == null)
                  return yi = Ei(Vi), qp[Vi.id()] = [[Ei, yi]], yi;
                for (var ci = 0; ci < bi.length; ci++) {
                  var hi = bi[ci], wi = hi[0], zi = hi[1];
                  wi === Ei && (yi = zi);
                }
                return yi === null && (yi = Ei(Vi), bi.push([Ei, yi])), yi;
              }
              function ld(Vi, Ei, bi, yi, ci, hi) {
                Vi === void 0 && (Vi = {}), Ei === void 0 && (Ei = []), ci === void 0 && (ci = []), hi === void 0 && (hi = !1);
                var wi = Ei, zi = wi[0], Wo = wi.slice(1);
                if (typeof zi == "string")
                  ld(Vi, xf[zi], bi, yi, ci, hi);
                else if (zi) {
                  var aa = md(yi, zi);
                  if (!aa.setSource)
                    return ci.push(aa), ld(Vi, Wo, bi, yi, ci, hi);
                  aa.setSource(Ta({}, Vi), function(Ea, Ka) {
                    if (Ea)
                      return ld(Vi, Wo, bi, yi, ci, hi);
                    ci.push(aa), ld(Ka, Vi.type === Ka.type ? Wo : xf[Ka.type], bi, yi, ci, hi);
                  });
                } else Wo.length ? ld(Vi, Wo, bi, yi, ci, hi) : hi ? bi(Vi, ci) : ld(Vi, xf["*"], bi, yi, ci, !0);
              }
              var wf = {
                opus: "video/ogg",
                ogv: "video/ogg",
                mp4: "video/mp4",
                mov: "video/mp4",
                m4v: "video/mp4",
                mkv: "video/x-matroska",
                m4a: "audio/mp4",
                mp3: "audio/mpeg",
                aac: "audio/aac",
                caf: "audio/x-caf",
                flac: "audio/flac",
                oga: "audio/ogg",
                wav: "audio/wav",
                m3u8: "application/x-mpegURL",
                mpd: "application/dash+xml",
                jpg: "image/jpeg",
                jpeg: "image/jpeg",
                gif: "image/gif",
                png: "image/png",
                svg: "image/svg+xml",
                webp: "image/webp"
              }, zf = function(Ei) {
                Ei === void 0 && (Ei = "");
                var bi = zp(Ei), yi = wf[bi.toLowerCase()];
                return yi || "";
              }, ip = function(Ei, bi) {
                if (!bi)
                  return "";
                if (Ei.cache_.source.src === bi && Ei.cache_.source.type)
                  return Ei.cache_.source.type;
                var yi = Ei.cache_.sources.filter(function(zi) {
                  return zi.src === bi;
                });
                if (yi.length)
                  return yi[0].type;
                for (var ci = Ei.$$("source"), hi = 0; hi < ci.length; hi++) {
                  var wi = ci[hi];
                  if (wi.type && wi.src && wi.src === bi)
                    return wi.type;
                }
                return zf(bi);
              }, Sh = function Vi(Ei) {
                if (Array.isArray(Ei)) {
                  var bi = [];
                  Ei.forEach(function(yi) {
                    yi = Vi(yi), Array.isArray(yi) ? bi = bi.concat(yi) : rs(yi) && bi.push(yi);
                  }), Ei = bi;
                } else typeof Ei == "string" && Ei.trim() ? Ei = [Rp({
                  src: Ei
                })] : rs(Ei) && typeof Ei.src == "string" && Ei.src && Ei.src.trim() ? Ei = [Rp(Ei)] : Ei = [];
                return Ei;
              };
              function Rp(Vi) {
                if (!Vi.type) {
                  var Ei = zf(Vi.src);
                  Ei && (Vi.type = Ei);
                }
                return Vi;
              }
              var xh = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(bi, yi, ci) {
                  var hi, wi = Ec({
                    createEl: !1
                  }, yi);
                  if (hi = Vi.call(this, bi, wi, ci) || this, !yi.playerOptions.sources || yi.playerOptions.sources.length === 0)
                    for (var zi = 0, Wo = yi.playerOptions.techOrder; zi < Wo.length; zi++) {
                      var aa = Ic(Wo[zi]), Ea = Sc.getTech(aa);
                      if (aa || (Ea = ou.getComponent(aa)), Ea && Ea.isSupported()) {
                        bi.loadTech_(aa);
                        break;
                      }
                    }
                  else
                    bi.src(yi.playerOptions.sources);
                  return hi;
                }
                return Ei;
              })(ou);
              ou.registerComponent("MediaLoader", xh);
              var Od = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  return hi = Vi.call(this, yi, ci) || this, hi.options_.controlText && hi.controlText(hi.options_.controlText), hi.handleMouseOver_ = function(wi) {
                    return hi.handleMouseOver(wi);
                  }, hi.handleMouseOut_ = function(wi) {
                    return hi.handleMouseOut(wi);
                  }, hi.handleClick_ = function(wi) {
                    return hi.handleClick(wi);
                  }, hi.handleKeyDown_ = function(wi) {
                    return hi.handleKeyDown(wi);
                  }, hi.emitTapEvents(), hi.enable(), hi;
                }
                var bi = Ei.prototype;
                return bi.createEl = function(ci, hi, wi) {
                  ci === void 0 && (ci = "div"), hi === void 0 && (hi = {}), wi === void 0 && (wi = {}), hi = Ta({
                    className: this.buildCSSClass(),
                    tabIndex: 0
                  }, hi), ci === "button" && Xa.error("Creating a ClickableComponent with an HTML element of " + ci + " is not supported; use a Button instead."), wi = Ta({
                    role: "button"
                  }, wi), this.tabIndex_ = hi.tabIndex;
                  var zi = bl(ci, hi, wi);
                  return zi.appendChild(bl("span", {
                    className: "vjs-icon-placeholder"
                  }, {
                    "aria-hidden": !0
                  })), this.createControlTextEl(zi), zi;
                }, bi.dispose = function() {
                  this.controlTextEl_ = null, Vi.prototype.dispose.call(this);
                }, bi.createControlTextEl = function(ci) {
                  return this.controlTextEl_ = bl("span", {
                    className: "vjs-control-text"
                  }, {
                    // let the screen reader user know that the text of the element may change
                    "aria-live": "polite"
                  }), ci && ci.appendChild(this.controlTextEl_), this.controlText(this.controlText_, ci), this.controlTextEl_;
                }, bi.controlText = function(ci, hi) {
                  if (hi === void 0 && (hi = this.el()), ci === void 0)
                    return this.controlText_ || "Need Text";
                  var wi = this.localize(ci);
                  this.controlText_ = ci, Za(this.controlTextEl_, wi), !this.nonIconControl && !this.player_.options_.noUITitleAttributes && hi.setAttribute("title", wi);
                }, bi.buildCSSClass = function() {
                  return "vjs-control vjs-button " + Vi.prototype.buildCSSClass.call(this);
                }, bi.enable = function() {
                  this.enabled_ || (this.enabled_ = !0, this.removeClass("vjs-disabled"), this.el_.setAttribute("aria-disabled", "false"), typeof this.tabIndex_ < "u" && this.el_.setAttribute("tabIndex", this.tabIndex_), this.on(["tap", "click"], this.handleClick_), this.on("keydown", this.handleKeyDown_));
                }, bi.disable = function() {
                  this.enabled_ = !1, this.addClass("vjs-disabled"), this.el_.setAttribute("aria-disabled", "true"), typeof this.tabIndex_ < "u" && this.el_.removeAttribute("tabIndex"), this.off("mouseover", this.handleMouseOver_), this.off("mouseout", this.handleMouseOut_), this.off(["tap", "click"], this.handleClick_), this.off("keydown", this.handleKeyDown_);
                }, bi.handleLanguagechange = function() {
                  this.controlText(this.controlText_);
                }, bi.handleClick = function(ci) {
                  this.options_.clickHandler && this.options_.clickHandler.call(this, arguments);
                }, bi.handleKeyDown = function(ci) {
                  vi().isEventKey(ci, "Space") || vi().isEventKey(ci, "Enter") ? (ci.preventDefault(), ci.stopPropagation(), this.trigger("click")) : Vi.prototype.handleKeyDown.call(this, ci);
                }, Ei;
              })(ou);
              ou.registerComponent("ClickableComponent", Od);
              var Kf = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  return hi = Vi.call(this, yi, ci) || this, hi.update(), hi.update_ = function(wi) {
                    return hi.update(wi);
                  }, yi.on("posterchange", hi.update_), hi;
                }
                var bi = Ei.prototype;
                return bi.dispose = function() {
                  this.player().off("posterchange", this.update_), Vi.prototype.dispose.call(this);
                }, bi.createEl = function() {
                  var ci = bl("div", {
                    className: "vjs-poster",
                    // Don't want poster to be tabbable.
                    tabIndex: -1
                  });
                  return ci;
                }, bi.update = function(ci) {
                  var hi = this.player().poster();
                  this.setSrc(hi), hi ? this.show() : this.hide();
                }, bi.setSrc = function(ci) {
                  var hi = "";
                  ci && (hi = 'url("' + ci + '")'), this.el_.style.backgroundImage = hi;
                }, bi.handleClick = function(ci) {
                  if (this.player_.controls()) {
                    var hi = this.player_.usingPlugin("eme") && this.player_.eme.sessions && this.player_.eme.sessions.length > 0;
                    this.player_.tech(!0) && // We've observed a bug in IE and Edge when playing back DRM content where
                    // calling .focus() on the video element causes the video to go black,
                    // so we avoid it in that specific case
                    !((Bl || sl) && hi) && this.player_.tech(!0).focus(), this.player_.paused() ? wd(this.player_.play()) : this.player_.pause();
                  }
                }, Ei;
              })(Od);
              ou.registerComponent("PosterImage", Kf);
              var vc = "#222", Op = "#ccc", _f = {
                monospace: "monospace",
                sansSerif: "sans-serif",
                serif: "serif",
                monospaceSansSerif: '"Andale Mono", "Lucida Console", monospace',
                monospaceSerif: '"Courier New", monospace',
                proportionalSansSerif: "sans-serif",
                proportionalSerif: "serif",
                casual: '"Comic Sans MS", Impact, fantasy',
                script: '"Monotype Corsiva", cursive',
                smallcaps: '"Andale Mono", "Lucida Console", monospace, sans-serif'
              };
              function Ap(Vi, Ei) {
                var bi;
                if (Vi.length === 4)
                  bi = Vi[1] + Vi[1] + Vi[2] + Vi[2] + Vi[3] + Vi[3];
                else if (Vi.length === 7)
                  bi = Vi.slice(1);
                else
                  throw new Error("Invalid color code provided, " + Vi + "; must be formatted as e.g. #f0e or #f604e2.");
                return "rgba(" + parseInt(bi.slice(0, 2), 16) + "," + parseInt(bi.slice(2, 4), 16) + "," + parseInt(bi.slice(4, 6), 16) + "," + Ei + ")";
              }
              function op(Vi, Ei, bi) {
                try {
                  Vi.style[Ei] = bi;
                } catch {
                  return;
                }
              }
              var Sa = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci, hi) {
                  var wi;
                  wi = Vi.call(this, yi, ci, hi) || this;
                  var zi = function(aa) {
                    return wi.updateDisplay(aa);
                  };
                  return yi.on("loadstart", function(Wo) {
                    return wi.toggleDisplay(Wo);
                  }), yi.on("texttrackchange", zi), yi.on("loadedmetadata", function(Wo) {
                    return wi.preselectTrack(Wo);
                  }), yi.ready(Tc((0, xi.default)(wi), function() {
                    if (yi.tech_ && yi.tech_.featuresNativeTextTracks) {
                      this.hide();
                      return;
                    }
                    yi.on("fullscreenchange", zi), yi.on("playerresize", zi), di().addEventListener("orientationchange", zi), yi.on("dispose", function() {
                      return di().removeEventListener("orientationchange", zi);
                    });
                    for (var Wo = this.options_.playerOptions.tracks || [], aa = 0; aa < Wo.length; aa++)
                      this.player_.addRemoteTextTrack(Wo[aa], !0);
                    this.preselectTrack();
                  })), wi;
                }
                var bi = Ei.prototype;
                return bi.preselectTrack = function() {
                  for (var ci = {
                    captions: 1,
                    subtitles: 1
                  }, hi = this.player_.textTracks(), wi = this.player_.cache_.selectedLanguage, zi, Wo, aa, Ea = 0; Ea < hi.length; Ea++) {
                    var Ka = hi[Ea];
                    wi && wi.enabled && wi.language && wi.language === Ka.language && Ka.kind in ci ? Ka.kind === wi.kind ? aa = Ka : aa || (aa = Ka) : wi && !wi.enabled ? (aa = null, zi = null, Wo = null) : Ka.default && (Ka.kind === "descriptions" && !zi ? zi = Ka : Ka.kind in ci && !Wo && (Wo = Ka));
                  }
                  aa ? aa.mode = "showing" : Wo ? Wo.mode = "showing" : zi && (zi.mode = "showing");
                }, bi.toggleDisplay = function() {
                  this.player_.tech_ && this.player_.tech_.featuresNativeTextTracks ? this.hide() : this.show();
                }, bi.createEl = function() {
                  return Vi.prototype.createEl.call(this, "div", {
                    className: "vjs-text-track-display"
                  }, {
                    translate: "yes",
                    "aria-live": "off",
                    "aria-atomic": "true"
                  });
                }, bi.clearDisplay = function() {
                  typeof di().WebVTT == "function" && di().WebVTT.processCues(di(), [], this.el_);
                }, bi.updateDisplay = function() {
                  var ci = this.player_.textTracks(), hi = this.options_.allowMultipleShowingTracks;
                  if (this.clearDisplay(), hi) {
                    for (var wi = [], zi = 0; zi < ci.length; ++zi) {
                      var Wo = ci[zi];
                      Wo.mode === "showing" && wi.push(Wo);
                    }
                    this.updateForTrack(wi);
                    return;
                  }
                  for (var aa = null, Ea = null, Ka = ci.length; Ka--; ) {
                    var Ha = ci[Ka];
                    Ha.mode === "showing" && (Ha.kind === "descriptions" ? aa = Ha : Ea = Ha);
                  }
                  Ea ? (this.getAttribute("aria-live") !== "off" && this.setAttribute("aria-live", "off"), this.updateForTrack(Ea)) : aa && (this.getAttribute("aria-live") !== "assertive" && this.setAttribute("aria-live", "assertive"), this.updateForTrack(aa));
                }, bi.updateDisplayState = function(ci) {
                  for (var hi = this.player_.textTrackSettings.getValues(), wi = ci.activeCues, zi = wi.length; zi--; ) {
                    var Wo = wi[zi];
                    if (Wo) {
                      var aa = Wo.displayState;
                      if (hi.color && (aa.firstChild.style.color = hi.color), hi.textOpacity && op(aa.firstChild, "color", Ap(hi.color || "#fff", hi.textOpacity)), hi.backgroundColor && (aa.firstChild.style.backgroundColor = hi.backgroundColor), hi.backgroundOpacity && op(aa.firstChild, "backgroundColor", Ap(hi.backgroundColor || "#000", hi.backgroundOpacity)), hi.windowColor && (hi.windowOpacity ? op(aa, "backgroundColor", Ap(hi.windowColor, hi.windowOpacity)) : aa.style.backgroundColor = hi.windowColor), hi.edgeStyle && (hi.edgeStyle === "dropshadow" ? aa.firstChild.style.textShadow = "2px 2px 3px " + vc + ", 2px 2px 4px " + vc + ", 2px 2px 5px " + vc : hi.edgeStyle === "raised" ? aa.firstChild.style.textShadow = "1px 1px " + vc + ", 2px 2px " + vc + ", 3px 3px " + vc : hi.edgeStyle === "depressed" ? aa.firstChild.style.textShadow = "1px 1px " + Op + ", 0 1px " + Op + ", -1px -1px " + vc + ", 0 -1px " + vc : hi.edgeStyle === "uniform" && (aa.firstChild.style.textShadow = "0 0 4px " + vc + ", 0 0 4px " + vc + ", 0 0 4px " + vc + ", 0 0 4px " + vc)), hi.fontPercent && hi.fontPercent !== 1) {
                        var Ea = di().parseFloat(aa.style.fontSize);
                        aa.style.fontSize = Ea * hi.fontPercent + "px", aa.style.height = "auto", aa.style.top = "auto";
                      }
                      hi.fontFamily && hi.fontFamily !== "default" && (hi.fontFamily === "small-caps" ? aa.firstChild.style.fontVariant = "small-caps" : aa.firstChild.style.fontFamily = _f[hi.fontFamily]);
                    }
                  }
                }, bi.updateForTrack = function(ci) {
                  if (Array.isArray(ci) || (ci = [ci]), !(typeof di().WebVTT != "function" || ci.every(function(ks) {
                    return !ks.activeCues;
                  }))) {
                    for (var hi = [], wi = 0; wi < ci.length; ++wi)
                      for (var zi = ci[wi], Wo = 0; Wo < zi.activeCues.length; ++Wo)
                        hi.push(zi.activeCues[Wo]);
                    di().WebVTT.processCues(di(), hi, this.el_);
                    for (var aa = 0; aa < ci.length; ++aa) {
                      for (var Ea = ci[aa], Ka = 0; Ka < Ea.activeCues.length; ++Ka) {
                        var Ha = Ea.activeCues[Ka].displayState;
                        al(Ha, "vjs-text-track-cue"), al(Ha, "vjs-text-track-cue-" + (Ea.language ? Ea.language : aa)), Ea.language && dl(Ha, "lang", Ea.language);
                      }
                      this.player_.textTrackSettings && this.updateDisplayState(Ea);
                    }
                  }
                }, Ei;
              })(ou);
              ou.registerComponent("TextTrackDisplay", Sa);
              var ma = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei() {
                  return Vi.apply(this, arguments) || this;
                }
                var bi = Ei.prototype;
                return bi.createEl = function() {
                  var ci = this.player_.isAudio(), hi = this.localize(ci ? "Audio Player" : "Video Player"), wi = bl("span", {
                    className: "vjs-control-text",
                    textContent: this.localize("{1} is loading.", [hi])
                  }), zi = Vi.prototype.createEl.call(this, "div", {
                    className: "vjs-loading-spinner",
                    dir: "ltr"
                  });
                  return zi.appendChild(wi), zi;
                }, Ei;
              })(ou);
              ou.registerComponent("LoadingSpinner", ma);
              var Ho = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei() {
                  return Vi.apply(this, arguments) || this;
                }
                var bi = Ei.prototype;
                return bi.createEl = function(ci, hi, wi) {
                  hi === void 0 && (hi = {}), wi === void 0 && (wi = {}), ci = "button", hi = Ta({
                    className: this.buildCSSClass()
                  }, hi), wi = Ta({
                    // Necessary since the default button type is "submit"
                    type: "button"
                  }, wi);
                  var zi = bl(ci, hi, wi);
                  return zi.appendChild(bl("span", {
                    className: "vjs-icon-placeholder"
                  }, {
                    "aria-hidden": !0
                  })), this.createControlTextEl(zi), zi;
                }, bi.addChild = function(ci, hi) {
                  hi === void 0 && (hi = {});
                  var wi = this.constructor.name;
                  return Xa.warn("Adding an actionable (user controllable) child to a Button (" + wi + ") is not supported; use a ClickableComponent instead."), ou.prototype.addChild.call(this, ci, hi);
                }, bi.enable = function() {
                  Vi.prototype.enable.call(this), this.el_.removeAttribute("disabled");
                }, bi.disable = function() {
                  Vi.prototype.disable.call(this), this.el_.setAttribute("disabled", "disabled");
                }, bi.handleKeyDown = function(ci) {
                  if (vi().isEventKey(ci, "Space") || vi().isEventKey(ci, "Enter")) {
                    ci.stopPropagation();
                    return;
                  }
                  Vi.prototype.handleKeyDown.call(this, ci);
                }, Ei;
              })(Od);
              ou.registerComponent("Button", Ho);
              var Io = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  return hi = Vi.call(this, yi, ci) || this, hi.mouseused_ = !1, hi.on("mousedown", function(wi) {
                    return hi.handleMouseDown(wi);
                  }), hi;
                }
                var bi = Ei.prototype;
                return bi.buildCSSClass = function() {
                  return "vjs-big-play-button";
                }, bi.handleClick = function(ci) {
                  var hi = this.player_.play();
                  if (this.mouseused_ && ci.clientX && ci.clientY) {
                    var wi = this.player_.usingPlugin("eme") && this.player_.eme.sessions && this.player_.eme.sessions.length > 0;
                    wd(hi), this.player_.tech(!0) && // We've observed a bug in IE and Edge when playing back DRM content where
                    // calling .focus() on the video element causes the video to go black,
                    // so we avoid it in that specific case
                    !((Bl || sl) && wi) && this.player_.tech(!0).focus();
                    return;
                  }
                  var zi = this.player_.getChild("controlBar"), Wo = zi && zi.getChild("playToggle");
                  if (!Wo) {
                    this.player_.tech(!0).focus();
                    return;
                  }
                  var aa = function() {
                    return Wo.focus();
                  };
                  Dd(hi) ? hi.then(aa, function() {
                  }) : this.setTimeout(aa, 1);
                }, bi.handleKeyDown = function(ci) {
                  this.mouseused_ = !1, Vi.prototype.handleKeyDown.call(this, ci);
                }, bi.handleMouseDown = function(ci) {
                  this.mouseused_ = !0;
                }, Ei;
              })(Ho);
              Io.prototype.controlText_ = "Play Video", ou.registerComponent("BigPlayButton", Io);
              var Ri = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  return hi = Vi.call(this, yi, ci) || this, hi.controlText(ci && ci.controlText || hi.localize("Close")), hi;
                }
                var bi = Ei.prototype;
                return bi.buildCSSClass = function() {
                  return "vjs-close-button " + Vi.prototype.buildCSSClass.call(this);
                }, bi.handleClick = function(ci) {
                  this.trigger({
                    type: "close",
                    bubbles: !1
                  });
                }, bi.handleKeyDown = function(ci) {
                  vi().isEventKey(ci, "Esc") ? (ci.preventDefault(), ci.stopPropagation(), this.trigger("click")) : Vi.prototype.handleKeyDown.call(this, ci);
                }, Ei;
              })(Ho);
              ou.registerComponent("CloseButton", Ri);
              var qi = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  return ci === void 0 && (ci = {}), hi = Vi.call(this, yi, ci) || this, ci.replay = ci.replay === void 0 || ci.replay, hi.on(yi, "play", function(wi) {
                    return hi.handlePlay(wi);
                  }), hi.on(yi, "pause", function(wi) {
                    return hi.handlePause(wi);
                  }), ci.replay && hi.on(yi, "ended", function(wi) {
                    return hi.handleEnded(wi);
                  }), hi;
                }
                var bi = Ei.prototype;
                return bi.buildCSSClass = function() {
                  return "vjs-play-control " + Vi.prototype.buildCSSClass.call(this);
                }, bi.handleClick = function(ci) {
                  this.player_.paused() ? wd(this.player_.play()) : this.player_.pause();
                }, bi.handleSeeked = function(ci) {
                  this.removeClass("vjs-ended"), this.player_.paused() ? this.handlePause(ci) : this.handlePlay(ci);
                }, bi.handlePlay = function(ci) {
                  this.removeClass("vjs-ended"), this.removeClass("vjs-paused"), this.addClass("vjs-playing"), this.controlText("Pause");
                }, bi.handlePause = function(ci) {
                  this.removeClass("vjs-playing"), this.addClass("vjs-paused"), this.controlText("Play");
                }, bi.handleEnded = function(ci) {
                  var hi = this;
                  this.removeClass("vjs-playing"), this.addClass("vjs-ended"), this.controlText("Replay"), this.one(this.player_, "seeked", function(wi) {
                    return hi.handleSeeked(wi);
                  });
                }, Ei;
              })(Ho);
              qi.prototype.controlText_ = "Play", ou.registerComponent("PlayToggle", qi);
              var Yo = function(Ei, bi) {
                Ei = Ei < 0 ? 0 : Ei;
                var yi = Math.floor(Ei % 60), ci = Math.floor(Ei / 60 % 60), hi = Math.floor(Ei / 3600), wi = Math.floor(bi / 60 % 60), zi = Math.floor(bi / 3600);
                return (isNaN(Ei) || Ei === 1 / 0) && (hi = ci = yi = "-"), hi = hi > 0 || zi > 0 ? hi + ":" : "", ci = ((hi || wi >= 10) && ci < 10 ? "0" + ci : ci) + ":", yi = yi < 10 ? "0" + yi : yi, hi + ci + yi;
              }, ba = Yo;
              function Na(Vi) {
                ba = Vi;
              }
              function Ma() {
                ba = Yo;
              }
              function bs(Vi, Ei) {
                return Ei === void 0 && (Ei = Vi), ba(Vi, Ei);
              }
              var Ds = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  return hi = Vi.call(this, yi, ci) || this, hi.on(yi, ["timeupdate", "ended"], function(wi) {
                    return hi.updateContent(wi);
                  }), hi.updateTextNode_(), hi;
                }
                var bi = Ei.prototype;
                return bi.createEl = function() {
                  var ci = this.buildCSSClass(), hi = Vi.prototype.createEl.call(this, "div", {
                    className: ci + " vjs-time-control vjs-control"
                  }), wi = bl("span", {
                    className: "vjs-control-text",
                    textContent: this.localize(this.labelText_) + " "
                  }, {
                    role: "presentation"
                  });
                  return hi.appendChild(wi), this.contentEl_ = bl("span", {
                    className: ci + "-display"
                  }, {
                    // tell screen readers not to automatically read the time as it changes
                    "aria-live": "off",
                    // span elements have no implicit role, but some screen readers (notably VoiceOver)
                    // treat them as a break between items in the DOM when using arrow keys
                    // (or left-to-right swipes on iOS) to read contents of a page. Using
                    // role='presentation' causes VoiceOver to NOT treat this span as a break.
                    role: "presentation"
                  }), hi.appendChild(this.contentEl_), hi;
                }, bi.dispose = function() {
                  this.contentEl_ = null, this.textNode_ = null, Vi.prototype.dispose.call(this);
                }, bi.updateTextNode_ = function(ci) {
                  var hi = this;
                  ci === void 0 && (ci = 0), ci = bs(ci), this.formattedTime_ !== ci && (this.formattedTime_ = ci, this.requestNamedAnimationFrame("TimeDisplay#updateTextNode_", function() {
                    if (hi.contentEl_) {
                      var wi = hi.textNode_;
                      wi && hi.contentEl_.firstChild !== wi && (wi = null, Xa.warn("TimeDisplay#updateTextnode_: Prevented replacement of text node element since it was no longer a child of this node. Appending a new node instead.")), hi.textNode_ = gi().createTextNode(hi.formattedTime_), hi.textNode_ && (wi ? hi.contentEl_.replaceChild(hi.textNode_, wi) : hi.contentEl_.appendChild(hi.textNode_));
                    }
                  }));
                }, bi.updateContent = function(ci) {
                }, Ei;
              })(ou);
              Ds.prototype.labelText_ = "Time", Ds.prototype.controlText_ = "Time", ou.registerComponent("TimeDisplay", Ds);
              var Fs = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei() {
                  return Vi.apply(this, arguments) || this;
                }
                var bi = Ei.prototype;
                return bi.buildCSSClass = function() {
                  return "vjs-current-time";
                }, bi.updateContent = function(ci) {
                  var hi;
                  this.player_.ended() ? hi = this.player_.duration() : hi = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime(), this.updateTextNode_(hi);
                }, Ei;
              })(Ds);
              Fs.prototype.labelText_ = "Current Time", Fs.prototype.controlText_ = "Current Time", ou.registerComponent("CurrentTimeDisplay", Fs);
              var _l = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  hi = Vi.call(this, yi, ci) || this;
                  var wi = function(Wo) {
                    return hi.updateContent(Wo);
                  };
                  return hi.on(yi, "durationchange", wi), hi.on(yi, "loadstart", wi), hi.on(yi, "loadedmetadata", wi), hi;
                }
                var bi = Ei.prototype;
                return bi.buildCSSClass = function() {
                  return "vjs-duration";
                }, bi.updateContent = function(ci) {
                  var hi = this.player_.duration();
                  this.updateTextNode_(hi);
                }, Ei;
              })(Ds);
              _l.prototype.labelText_ = "Duration", _l.prototype.controlText_ = "Duration", ou.registerComponent("DurationDisplay", _l);
              var Ll = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei() {
                  return Vi.apply(this, arguments) || this;
                }
                var bi = Ei.prototype;
                return bi.createEl = function() {
                  var ci = Vi.prototype.createEl.call(this, "div", {
                    className: "vjs-time-control vjs-time-divider"
                  }, {
                    // this element and its contents can be hidden from assistive techs since
                    // it is made extraneous by the announcement of the control text
                    // for the current time and duration displays
                    "aria-hidden": !0
                  }), hi = Vi.prototype.createEl.call(this, "div"), wi = Vi.prototype.createEl.call(this, "span", {
                    textContent: "/"
                  });
                  return hi.appendChild(wi), ci.appendChild(hi), ci;
                }, Ei;
              })(ou);
              ou.registerComponent("TimeDivider", Ll);
              var eu = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  return hi = Vi.call(this, yi, ci) || this, hi.on(yi, "durationchange", function(wi) {
                    return hi.updateContent(wi);
                  }), hi;
                }
                var bi = Ei.prototype;
                return bi.buildCSSClass = function() {
                  return "vjs-remaining-time";
                }, bi.createEl = function() {
                  var ci = Vi.prototype.createEl.call(this);
                  return this.options_.displayNegative !== !1 && ci.insertBefore(bl("span", {}, {
                    "aria-hidden": !0
                  }, "-"), this.contentEl_), ci;
                }, bi.updateContent = function(ci) {
                  if (typeof this.player_.duration() == "number") {
                    var hi;
                    this.player_.ended() ? hi = 0 : this.player_.remainingTimeDisplay ? hi = this.player_.remainingTimeDisplay() : hi = this.player_.remainingTime(), this.updateTextNode_(hi);
                  }
                }, Ei;
              })(Ds);
              eu.prototype.labelText_ = "Remaining Time", eu.prototype.controlText_ = "Remaining Time", ou.registerComponent("RemainingTimeDisplay", eu);
              var fu = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  return hi = Vi.call(this, yi, ci) || this, hi.updateShowing(), hi.on(hi.player(), "durationchange", function(wi) {
                    return hi.updateShowing(wi);
                  }), hi;
                }
                var bi = Ei.prototype;
                return bi.createEl = function() {
                  var ci = Vi.prototype.createEl.call(this, "div", {
                    className: "vjs-live-control vjs-control"
                  });
                  return this.contentEl_ = bl("div", {
                    className: "vjs-live-display"
                  }, {
                    "aria-live": "off"
                  }), this.contentEl_.appendChild(bl("span", {
                    className: "vjs-control-text",
                    textContent: this.localize("Stream Type") + " "
                  })), this.contentEl_.appendChild(gi().createTextNode(this.localize("LIVE"))), ci.appendChild(this.contentEl_), ci;
                }, bi.dispose = function() {
                  this.contentEl_ = null, Vi.prototype.dispose.call(this);
                }, bi.updateShowing = function(ci) {
                  this.player().duration() === 1 / 0 ? this.show() : this.hide();
                }, Ei;
              })(ou);
              ou.registerComponent("LiveDisplay", fu);
              var Fu = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  return hi = Vi.call(this, yi, ci) || this, hi.updateLiveEdgeStatus(), hi.player_.liveTracker && (hi.updateLiveEdgeStatusHandler_ = function(wi) {
                    return hi.updateLiveEdgeStatus(wi);
                  }, hi.on(hi.player_.liveTracker, "liveedgechange", hi.updateLiveEdgeStatusHandler_)), hi;
                }
                var bi = Ei.prototype;
                return bi.createEl = function() {
                  var ci = Vi.prototype.createEl.call(this, "button", {
                    className: "vjs-seek-to-live-control vjs-control"
                  });
                  return this.textEl_ = bl("span", {
                    className: "vjs-seek-to-live-text",
                    textContent: this.localize("LIVE")
                  }, {
                    "aria-hidden": "true"
                  }), ci.appendChild(this.textEl_), ci;
                }, bi.updateLiveEdgeStatus = function() {
                  !this.player_.liveTracker || this.player_.liveTracker.atLiveEdge() ? (this.setAttribute("aria-disabled", !0), this.addClass("vjs-at-live-edge"), this.controlText("Seek to live, currently playing live")) : (this.setAttribute("aria-disabled", !1), this.removeClass("vjs-at-live-edge"), this.controlText("Seek to live, currently behind live"));
                }, bi.handleClick = function() {
                  this.player_.liveTracker.seekToLiveEdge();
                }, bi.dispose = function() {
                  this.player_.liveTracker && this.off(this.player_.liveTracker, "liveedgechange", this.updateLiveEdgeStatusHandler_), this.textEl_ = null, Vi.prototype.dispose.call(this);
                }, Ei;
              })(Ho);
              Fu.prototype.controlText_ = "Seek to live, currently playing live", ou.registerComponent("SeekToLive", Fu);
              var Ou = function(Ei, bi, yi) {
                return Ei = Number(Ei), Math.min(yi, Math.max(bi, isNaN(Ei) ? bi : Ei));
              }, qu = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  return hi = Vi.call(this, yi, ci) || this, hi.handleMouseDown_ = function(wi) {
                    return hi.handleMouseDown(wi);
                  }, hi.handleMouseUp_ = function(wi) {
                    return hi.handleMouseUp(wi);
                  }, hi.handleKeyDown_ = function(wi) {
                    return hi.handleKeyDown(wi);
                  }, hi.handleClick_ = function(wi) {
                    return hi.handleClick(wi);
                  }, hi.handleMouseMove_ = function(wi) {
                    return hi.handleMouseMove(wi);
                  }, hi.update_ = function(wi) {
                    return hi.update(wi);
                  }, hi.bar = hi.getChild(hi.options_.barName), hi.vertical(!!hi.options_.vertical), hi.enable(), hi;
                }
                var bi = Ei.prototype;
                return bi.enabled = function() {
                  return this.enabled_;
                }, bi.enable = function() {
                  this.enabled() || (this.on("mousedown", this.handleMouseDown_), this.on("touchstart", this.handleMouseDown_), this.on("keydown", this.handleKeyDown_), this.on("click", this.handleClick_), this.on(this.player_, "controlsvisible", this.update), this.playerEvent && this.on(this.player_, this.playerEvent, this.update), this.removeClass("disabled"), this.setAttribute("tabindex", 0), this.enabled_ = !0);
                }, bi.disable = function() {
                  if (this.enabled()) {
                    var ci = this.bar.el_.ownerDocument;
                    this.off("mousedown", this.handleMouseDown_), this.off("touchstart", this.handleMouseDown_), this.off("keydown", this.handleKeyDown_), this.off("click", this.handleClick_), this.off(this.player_, "controlsvisible", this.update_), this.off(ci, "mousemove", this.handleMouseMove_), this.off(ci, "mouseup", this.handleMouseUp_), this.off(ci, "touchmove", this.handleMouseMove_), this.off(ci, "touchend", this.handleMouseUp_), this.removeAttribute("tabindex"), this.addClass("disabled"), this.playerEvent && this.off(this.player_, this.playerEvent, this.update), this.enabled_ = !1;
                  }
                }, bi.createEl = function(ci, hi, wi) {
                  return hi === void 0 && (hi = {}), wi === void 0 && (wi = {}), hi.className = hi.className + " vjs-slider", hi = Ta({
                    tabIndex: 0
                  }, hi), wi = Ta({
                    role: "slider",
                    "aria-valuenow": 0,
                    "aria-valuemin": 0,
                    "aria-valuemax": 100,
                    tabIndex: 0
                  }, wi), Vi.prototype.createEl.call(this, ci, hi, wi);
                }, bi.handleMouseDown = function(ci) {
                  var hi = this.bar.el_.ownerDocument;
                  ci.type === "mousedown" && ci.preventDefault(), ci.type === "touchstart" && !Il && ci.preventDefault(), cu(), this.addClass("vjs-sliding"), this.trigger("slideractive"), this.on(hi, "mousemove", this.handleMouseMove_), this.on(hi, "mouseup", this.handleMouseUp_), this.on(hi, "touchmove", this.handleMouseMove_), this.on(hi, "touchend", this.handleMouseUp_), this.handleMouseMove(ci, !0);
                }, bi.handleMouseMove = function(ci) {
                }, bi.handleMouseUp = function() {
                  var ci = this.bar.el_.ownerDocument;
                  Ru(), this.removeClass("vjs-sliding"), this.trigger("sliderinactive"), this.off(ci, "mousemove", this.handleMouseMove_), this.off(ci, "mouseup", this.handleMouseUp_), this.off(ci, "touchmove", this.handleMouseMove_), this.off(ci, "touchend", this.handleMouseUp_), this.update();
                }, bi.update = function() {
                  var ci = this;
                  if (!(!this.el_ || !this.bar)) {
                    var hi = this.getProgress();
                    return hi === this.progress_ || (this.progress_ = hi, this.requestNamedAnimationFrame("Slider#update", function() {
                      var wi = ci.vertical() ? "height" : "width";
                      ci.bar.el().style[wi] = (hi * 100).toFixed(2) + "%";
                    })), hi;
                  }
                }, bi.getProgress = function() {
                  return Number(Ou(this.getPercent(), 0, 1).toFixed(4));
                }, bi.calculateDistance = function(ci) {
                  var hi = cc(this.el_, ci);
                  return this.vertical() ? hi.y : hi.x;
                }, bi.handleKeyDown = function(ci) {
                  vi().isEventKey(ci, "Left") || vi().isEventKey(ci, "Down") ? (ci.preventDefault(), ci.stopPropagation(), this.stepBack()) : vi().isEventKey(ci, "Right") || vi().isEventKey(ci, "Up") ? (ci.preventDefault(), ci.stopPropagation(), this.stepForward()) : Vi.prototype.handleKeyDown.call(this, ci);
                }, bi.handleClick = function(ci) {
                  ci.stopPropagation(), ci.preventDefault();
                }, bi.vertical = function(ci) {
                  if (ci === void 0)
                    return this.vertical_ || !1;
                  this.vertical_ = !!ci, this.vertical_ ? this.addClass("vjs-slider-vertical") : this.addClass("vjs-slider-horizontal");
                }, Ei;
              })(ou);
              ou.registerComponent("Slider", qu);
              var Ju = function(Ei, bi) {
                return Ou(Ei / bi * 100, 0, 100).toFixed(2) + "%";
              }, nc = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  return hi = Vi.call(this, yi, ci) || this, hi.partEls_ = [], hi.on(yi, "progress", function(wi) {
                    return hi.update(wi);
                  }), hi;
                }
                var bi = Ei.prototype;
                return bi.createEl = function() {
                  var ci = Vi.prototype.createEl.call(this, "div", {
                    className: "vjs-load-progress"
                  }), hi = bl("span", {
                    className: "vjs-control-text"
                  }), wi = bl("span", {
                    textContent: this.localize("Loaded")
                  }), zi = gi().createTextNode(": ");
                  return this.percentageEl_ = bl("span", {
                    className: "vjs-control-text-loaded-percentage",
                    textContent: "0%"
                  }), ci.appendChild(hi), hi.appendChild(wi), hi.appendChild(zi), hi.appendChild(this.percentageEl_), ci;
                }, bi.dispose = function() {
                  this.partEls_ = null, this.percentageEl_ = null, Vi.prototype.dispose.call(this);
                }, bi.update = function(ci) {
                  var hi = this;
                  this.requestNamedAnimationFrame("LoadProgressBar#update", function() {
                    var wi = hi.player_.liveTracker, zi = hi.player_.buffered(), Wo = wi && wi.isLive() ? wi.seekableEnd() : hi.player_.duration(), aa = hi.player_.bufferedEnd(), Ea = hi.partEls_, Ka = Ju(aa, Wo);
                    hi.percent_ !== Ka && (hi.el_.style.width = Ka, Za(hi.percentageEl_, Ka), hi.percent_ = Ka);
                    for (var Ha = 0; Ha < zi.length; Ha++) {
                      var ks = zi.start(Ha), gl = zi.end(Ha), Sl = Ea[Ha];
                      Sl || (Sl = hi.el_.appendChild(bl()), Ea[Ha] = Sl), !(Sl.dataset.start === ks && Sl.dataset.end === gl) && (Sl.dataset.start = ks, Sl.dataset.end = gl, Sl.style.left = Ju(ks, aa), Sl.style.width = Ju(gl - ks, aa));
                    }
                    for (var Fl = Ea.length; Fl > zi.length; Fl--)
                      hi.el_.removeChild(Ea[Fl - 1]);
                    Ea.length = zi.length;
                  });
                }, Ei;
              })(ou);
              ou.registerComponent("LoadProgressBar", nc);
              var $c = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  return hi = Vi.call(this, yi, ci) || this, hi.update = Ud(Tc((0, xi.default)(hi), hi.update), Qc), hi;
                }
                var bi = Ei.prototype;
                return bi.createEl = function() {
                  return Vi.prototype.createEl.call(this, "div", {
                    className: "vjs-time-tooltip"
                  }, {
                    "aria-hidden": "true"
                  });
                }, bi.update = function(ci, hi, wi) {
                  var zi = Hu(this.el_), Wo = bu(this.player_.el()), aa = ci.width * hi;
                  if (!(!Wo || !zi)) {
                    var Ea = ci.left - Wo.left + aa, Ka = ci.width - aa + (Wo.right - ci.right), Ha = zi.width / 2;
                    Ea < Ha ? Ha += Ha - Ea : Ka < Ha && (Ha = Ka), Ha < 0 ? Ha = 0 : Ha > zi.width && (Ha = zi.width), Ha = Math.round(Ha), this.el_.style.right = "-" + Ha + "px", this.write(wi);
                  }
                }, bi.write = function(ci) {
                  Za(this.el_, ci);
                }, bi.updateTime = function(ci, hi, wi, zi) {
                  var Wo = this;
                  this.requestNamedAnimationFrame("TimeTooltip#updateTime", function() {
                    var aa, Ea = Wo.player_.duration();
                    if (Wo.player_.liveTracker && Wo.player_.liveTracker.isLive()) {
                      var Ka = Wo.player_.liveTracker.liveWindow(), Ha = Ka - hi * Ka;
                      aa = (Ha < 1 ? "" : "-") + bs(Ha, Ka);
                    } else
                      aa = bs(wi, Ea);
                    Wo.update(ci, hi, aa), zi && zi();
                  });
                }, Ei;
              })(ou);
              ou.registerComponent("TimeTooltip", $c);
              var Rc = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  return hi = Vi.call(this, yi, ci) || this, hi.update = Ud(Tc((0, xi.default)(hi), hi.update), Qc), hi;
                }
                var bi = Ei.prototype;
                return bi.createEl = function() {
                  return Vi.prototype.createEl.call(this, "div", {
                    className: "vjs-play-progress vjs-slider-bar"
                  }, {
                    "aria-hidden": "true"
                  });
                }, bi.update = function(ci, hi) {
                  var wi = this.getChild("timeTooltip");
                  if (wi) {
                    var zi = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
                    wi.updateTime(ci, hi, zi);
                  }
                }, Ei;
              })(ou);
              Rc.prototype.options_ = {
                children: []
              }, !Tu && !Vs && Rc.prototype.options_.children.push("timeTooltip"), ou.registerComponent("PlayProgressBar", Rc);
              var xc = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  return hi = Vi.call(this, yi, ci) || this, hi.update = Ud(Tc((0, xi.default)(hi), hi.update), Qc), hi;
                }
                var bi = Ei.prototype;
                return bi.createEl = function() {
                  return Vi.prototype.createEl.call(this, "div", {
                    className: "vjs-mouse-display"
                  });
                }, bi.update = function(ci, hi) {
                  var wi = this, zi = hi * this.player_.duration();
                  this.getChild("timeTooltip").updateTime(ci, hi, zi, function() {
                    wi.el_.style.left = ci.width * hi + "px";
                  });
                }, Ei;
              })(ou);
              xc.prototype.options_ = {
                children: ["timeTooltip"]
              }, ou.registerComponent("MouseTimeDisplay", xc);
              var vd = 5, zu = 12, ic = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  return hi = Vi.call(this, yi, ci) || this, hi.setEventHandlers_(), hi;
                }
                var bi = Ei.prototype;
                return bi.setEventHandlers_ = function() {
                  var ci = this;
                  this.update_ = Tc(this, this.update), this.update = Ud(this.update_, Qc), this.on(this.player_, ["ended", "durationchange", "timeupdate"], this.update), this.player_.liveTracker && this.on(this.player_.liveTracker, "liveedgechange", this.update), this.updateInterval = null, this.enableIntervalHandler_ = function(hi) {
                    return ci.enableInterval_(hi);
                  }, this.disableIntervalHandler_ = function(hi) {
                    return ci.disableInterval_(hi);
                  }, this.on(this.player_, ["playing"], this.enableIntervalHandler_), this.on(this.player_, ["ended", "pause", "waiting"], this.disableIntervalHandler_), "hidden" in gi() && "visibilityState" in gi() && this.on(gi(), "visibilitychange", this.toggleVisibility_);
                }, bi.toggleVisibility_ = function(ci) {
                  gi().visibilityState === "hidden" ? (this.cancelNamedAnimationFrame("SeekBar#update"), this.cancelNamedAnimationFrame("Slider#update"), this.disableInterval_(ci)) : (!this.player_.ended() && !this.player_.paused() && this.enableInterval_(), this.update());
                }, bi.enableInterval_ = function() {
                  this.updateInterval || (this.updateInterval = this.setInterval(this.update, Qc));
                }, bi.disableInterval_ = function(ci) {
                  this.player_.liveTracker && this.player_.liveTracker.isLive() && ci && ci.type !== "ended" || this.updateInterval && (this.clearInterval(this.updateInterval), this.updateInterval = null);
                }, bi.createEl = function() {
                  return Vi.prototype.createEl.call(this, "div", {
                    className: "vjs-progress-holder"
                  }, {
                    "aria-label": this.localize("Progress Bar")
                  });
                }, bi.update = function(ci) {
                  var hi = this;
                  if (gi().visibilityState !== "hidden") {
                    var wi = Vi.prototype.update.call(this);
                    return this.requestNamedAnimationFrame("SeekBar#update", function() {
                      var zi = hi.player_.ended() ? hi.player_.duration() : hi.getCurrentTime_(), Wo = hi.player_.liveTracker, aa = hi.player_.duration();
                      Wo && Wo.isLive() && (aa = hi.player_.liveTracker.liveCurrentTime()), hi.percent_ !== wi && (hi.el_.setAttribute("aria-valuenow", (wi * 100).toFixed(2)), hi.percent_ = wi), (hi.currentTime_ !== zi || hi.duration_ !== aa) && (hi.el_.setAttribute("aria-valuetext", hi.localize("progress bar timing: currentTime={1} duration={2}", [bs(zi, aa), bs(aa, aa)], "{1} of {2}")), hi.currentTime_ = zi, hi.duration_ = aa), hi.bar && hi.bar.update(bu(hi.el()), hi.getProgress());
                    }), wi;
                  }
                }, bi.userSeek_ = function(ci) {
                  this.player_.liveTracker && this.player_.liveTracker.isLive() && this.player_.liveTracker.nextSeekedFromUser(), this.player_.currentTime(ci);
                }, bi.getCurrentTime_ = function() {
                  return this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
                }, bi.getPercent = function() {
                  var ci = this.getCurrentTime_(), hi, wi = this.player_.liveTracker;
                  return wi && wi.isLive() ? (hi = (ci - wi.seekableStart()) / wi.liveWindow(), wi.atLiveEdge() && (hi = 1)) : hi = ci / this.player_.duration(), hi;
                }, bi.handleMouseDown = function(ci) {
                  Gu(ci) && (ci.stopPropagation(), this.videoWasPlaying = !this.player_.paused(), this.player_.pause(), Vi.prototype.handleMouseDown.call(this, ci));
                }, bi.handleMouseMove = function(ci, hi) {
                  if (hi === void 0 && (hi = !1), !!Gu(ci)) {
                    !hi && !this.player_.scrubbing() && this.player_.scrubbing(!0);
                    var wi, zi = this.calculateDistance(ci), Wo = this.player_.liveTracker;
                    if (!Wo || !Wo.isLive())
                      wi = zi * this.player_.duration(), wi === this.player_.duration() && (wi = wi - 0.1);
                    else {
                      if (zi >= 0.99) {
                        Wo.seekToLiveEdge();
                        return;
                      }
                      var aa = Wo.seekableStart(), Ea = Wo.liveCurrentTime();
                      if (wi = aa + zi * Wo.liveWindow(), wi >= Ea && (wi = Ea), wi <= aa && (wi = aa + 0.1), wi === 1 / 0)
                        return;
                    }
                    this.userSeek_(wi);
                  }
                }, bi.enable = function() {
                  Vi.prototype.enable.call(this);
                  var ci = this.getChild("mouseTimeDisplay");
                  ci && ci.show();
                }, bi.disable = function() {
                  Vi.prototype.disable.call(this);
                  var ci = this.getChild("mouseTimeDisplay");
                  ci && ci.hide();
                }, bi.handleMouseUp = function(ci) {
                  Vi.prototype.handleMouseUp.call(this, ci), ci && ci.stopPropagation(), this.player_.scrubbing(!1), this.player_.trigger({
                    type: "timeupdate",
                    target: this,
                    manuallyTriggered: !0
                  }), this.videoWasPlaying ? wd(this.player_.play()) : this.update_();
                }, bi.stepForward = function() {
                  this.userSeek_(this.player_.currentTime() + vd);
                }, bi.stepBack = function() {
                  this.userSeek_(this.player_.currentTime() - vd);
                }, bi.handleAction = function(ci) {
                  this.player_.paused() ? this.player_.play() : this.player_.pause();
                }, bi.handleKeyDown = function(ci) {
                  var hi = this.player_.liveTracker;
                  if (vi().isEventKey(ci, "Space") || vi().isEventKey(ci, "Enter"))
                    ci.preventDefault(), ci.stopPropagation(), this.handleAction(ci);
                  else if (vi().isEventKey(ci, "Home"))
                    ci.preventDefault(), ci.stopPropagation(), this.userSeek_(0);
                  else if (vi().isEventKey(ci, "End"))
                    ci.preventDefault(), ci.stopPropagation(), hi && hi.isLive() ? this.userSeek_(hi.liveCurrentTime()) : this.userSeek_(this.player_.duration());
                  else if (/^[0-9]$/.test(vi()(ci))) {
                    ci.preventDefault(), ci.stopPropagation();
                    var wi = (vi().codes[vi()(ci)] - vi().codes[0]) * 10 / 100;
                    hi && hi.isLive() ? this.userSeek_(hi.seekableStart() + hi.liveWindow() * wi) : this.userSeek_(this.player_.duration() * wi);
                  } else vi().isEventKey(ci, "PgDn") ? (ci.preventDefault(), ci.stopPropagation(), this.userSeek_(this.player_.currentTime() - vd * zu)) : vi().isEventKey(ci, "PgUp") ? (ci.preventDefault(), ci.stopPropagation(), this.userSeek_(this.player_.currentTime() + vd * zu)) : Vi.prototype.handleKeyDown.call(this, ci);
                }, bi.dispose = function() {
                  this.disableInterval_(), this.off(this.player_, ["ended", "durationchange", "timeupdate"], this.update), this.player_.liveTracker && this.off(this.player_.liveTracker, "liveedgechange", this.update), this.off(this.player_, ["playing"], this.enableIntervalHandler_), this.off(this.player_, ["ended", "pause", "waiting"], this.disableIntervalHandler_), "hidden" in gi() && "visibilityState" in gi() && this.off(gi(), "visibilitychange", this.toggleVisibility_), Vi.prototype.dispose.call(this);
                }, Ei;
              })(qu);
              ic.prototype.options_ = {
                children: ["loadProgressBar", "playProgressBar"],
                barName: "playProgressBar"
              }, !Tu && !Vs && ic.prototype.options_.children.splice(1, 0, "mouseTimeDisplay"), ou.registerComponent("SeekBar", ic);
              var Fc = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  return hi = Vi.call(this, yi, ci) || this, hi.handleMouseMove = Ud(Tc((0, xi.default)(hi), hi.handleMouseMove), Qc), hi.throttledHandleMouseSeek = Ud(Tc((0, xi.default)(hi), hi.handleMouseSeek), Qc), hi.handleMouseUpHandler_ = function(wi) {
                    return hi.handleMouseUp(wi);
                  }, hi.handleMouseDownHandler_ = function(wi) {
                    return hi.handleMouseDown(wi);
                  }, hi.enable(), hi;
                }
                var bi = Ei.prototype;
                return bi.createEl = function() {
                  return Vi.prototype.createEl.call(this, "div", {
                    className: "vjs-progress-control vjs-control"
                  });
                }, bi.handleMouseMove = function(ci) {
                  var hi = this.getChild("seekBar");
                  if (hi) {
                    var wi = hi.getChild("playProgressBar"), zi = hi.getChild("mouseTimeDisplay");
                    if (!(!wi && !zi)) {
                      var Wo = hi.el(), aa = Hu(Wo), Ea = cc(Wo, ci).x;
                      Ea = Ou(Ea, 0, 1), zi && zi.update(aa, Ea), wi && wi.update(aa, hi.getProgress());
                    }
                  }
                }, bi.handleMouseSeek = function(ci) {
                  var hi = this.getChild("seekBar");
                  hi && hi.handleMouseMove(ci);
                }, bi.enabled = function() {
                  return this.enabled_;
                }, bi.disable = function() {
                  if (this.children().forEach(function(hi) {
                    return hi.disable && hi.disable();
                  }), !!this.enabled() && (this.off(["mousedown", "touchstart"], this.handleMouseDownHandler_), this.off(this.el_, "mousemove", this.handleMouseMove), this.removeListenersAddedOnMousedownAndTouchstart(), this.addClass("disabled"), this.enabled_ = !1, this.player_.scrubbing())) {
                    var ci = this.getChild("seekBar");
                    this.player_.scrubbing(!1), ci.videoWasPlaying && wd(this.player_.play());
                  }
                }, bi.enable = function() {
                  this.children().forEach(function(ci) {
                    return ci.enable && ci.enable();
                  }), !this.enabled() && (this.on(["mousedown", "touchstart"], this.handleMouseDownHandler_), this.on(this.el_, "mousemove", this.handleMouseMove), this.removeClass("disabled"), this.enabled_ = !0);
                }, bi.removeListenersAddedOnMousedownAndTouchstart = function() {
                  var ci = this.el_.ownerDocument;
                  this.off(ci, "mousemove", this.throttledHandleMouseSeek), this.off(ci, "touchmove", this.throttledHandleMouseSeek), this.off(ci, "mouseup", this.handleMouseUpHandler_), this.off(ci, "touchend", this.handleMouseUpHandler_);
                }, bi.handleMouseDown = function(ci) {
                  var hi = this.el_.ownerDocument, wi = this.getChild("seekBar");
                  wi && wi.handleMouseDown(ci), this.on(hi, "mousemove", this.throttledHandleMouseSeek), this.on(hi, "touchmove", this.throttledHandleMouseSeek), this.on(hi, "mouseup", this.handleMouseUpHandler_), this.on(hi, "touchend", this.handleMouseUpHandler_);
                }, bi.handleMouseUp = function(ci) {
                  var hi = this.getChild("seekBar");
                  hi && hi.handleMouseUp(ci), this.removeListenersAddedOnMousedownAndTouchstart();
                }, Ei;
              })(ou);
              Fc.prototype.options_ = {
                children: ["seekBar"]
              }, ou.registerComponent("ProgressControl", Fc);
              var kd = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  return hi = Vi.call(this, yi, ci) || this, hi.on(yi, ["enterpictureinpicture", "leavepictureinpicture"], function(wi) {
                    return hi.handlePictureInPictureChange(wi);
                  }), hi.on(yi, ["disablepictureinpicturechanged", "loadedmetadata"], function(wi) {
                    return hi.handlePictureInPictureEnabledChange(wi);
                  }), hi.on(yi, ["loadedmetadata", "audioonlymodechange", "audiopostermodechange"], function() {
                    var wi = yi.currentType().substring(0, 5) === "audio";
                    wi || yi.audioPosterMode() || yi.audioOnlyMode() ? (yi.isInPictureInPicture() && yi.exitPictureInPicture(), hi.hide()) : hi.show();
                  }), hi.disable(), hi;
                }
                var bi = Ei.prototype;
                return bi.buildCSSClass = function() {
                  return "vjs-picture-in-picture-control " + Vi.prototype.buildCSSClass.call(this);
                }, bi.handlePictureInPictureEnabledChange = function() {
                  gi().pictureInPictureEnabled && this.player_.disablePictureInPicture() === !1 ? this.enable() : this.disable();
                }, bi.handlePictureInPictureChange = function(ci) {
                  this.player_.isInPictureInPicture() ? this.controlText("Exit Picture-in-Picture") : this.controlText("Picture-in-Picture"), this.handlePictureInPictureEnabledChange();
                }, bi.handleClick = function(ci) {
                  this.player_.isInPictureInPicture() ? this.player_.exitPictureInPicture() : this.player_.requestPictureInPicture();
                }, Ei;
              })(Ho);
              kd.prototype.controlText_ = "Picture-in-Picture", ou.registerComponent("PictureInPictureToggle", kd);
              var tf = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  return hi = Vi.call(this, yi, ci) || this, hi.on(yi, "fullscreenchange", function(wi) {
                    return hi.handleFullscreenChange(wi);
                  }), gi()[yi.fsApi_.fullscreenEnabled] === !1 && hi.disable(), hi;
                }
                var bi = Ei.prototype;
                return bi.buildCSSClass = function() {
                  return "vjs-fullscreen-control " + Vi.prototype.buildCSSClass.call(this);
                }, bi.handleFullscreenChange = function(ci) {
                  this.player_.isFullscreen() ? this.controlText("Non-Fullscreen") : this.controlText("Fullscreen");
                }, bi.handleClick = function(ci) {
                  this.player_.isFullscreen() ? this.player_.exitFullscreen() : this.player_.requestFullscreen();
                }, Ei;
              })(Ho);
              tf.prototype.controlText_ = "Fullscreen", ou.registerComponent("FullscreenToggle", tf);
              var Ad = function(Ei, bi) {
                bi.tech_ && !bi.tech_.featuresVolumeControl && Ei.addClass("vjs-hidden"), Ei.on(bi, "loadstart", function() {
                  bi.tech_.featuresVolumeControl ? Ei.removeClass("vjs-hidden") : Ei.addClass("vjs-hidden");
                });
              }, Ip = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei() {
                  return Vi.apply(this, arguments) || this;
                }
                var bi = Ei.prototype;
                return bi.createEl = function() {
                  var ci = Vi.prototype.createEl.call(this, "div", {
                    className: "vjs-volume-level"
                  });
                  return ci.appendChild(Vi.prototype.createEl.call(this, "span", {
                    className: "vjs-control-text"
                  })), ci;
                }, Ei;
              })(ou);
              ou.registerComponent("VolumeLevel", Ip);
              var Xp = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  return hi = Vi.call(this, yi, ci) || this, hi.update = Ud(Tc((0, xi.default)(hi), hi.update), Qc), hi;
                }
                var bi = Ei.prototype;
                return bi.createEl = function() {
                  return Vi.prototype.createEl.call(this, "div", {
                    className: "vjs-volume-tooltip"
                  }, {
                    "aria-hidden": "true"
                  });
                }, bi.update = function(ci, hi, wi, zi) {
                  if (!wi) {
                    var Wo = bu(this.el_), aa = bu(this.player_.el()), Ea = ci.width * hi;
                    if (!aa || !Wo)
                      return;
                    var Ka = ci.left - aa.left + Ea, Ha = ci.width - Ea + (aa.right - ci.right), ks = Wo.width / 2;
                    Ka < ks ? ks += ks - Ka : Ha < ks && (ks = Ha), ks < 0 ? ks = 0 : ks > Wo.width && (ks = Wo.width), this.el_.style.right = "-" + ks + "px";
                  }
                  this.write(zi + "%");
                }, bi.write = function(ci) {
                  Za(this.el_, ci);
                }, bi.updateVolume = function(ci, hi, wi, zi, Wo) {
                  var aa = this;
                  this.requestNamedAnimationFrame("VolumeLevelTooltip#updateVolume", function() {
                    aa.update(ci, hi, wi, zi.toFixed(0)), Wo && Wo();
                  });
                }, Ei;
              })(ou);
              ou.registerComponent("VolumeLevelTooltip", Xp);
              var Pf = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  return hi = Vi.call(this, yi, ci) || this, hi.update = Ud(Tc((0, xi.default)(hi), hi.update), Qc), hi;
                }
                var bi = Ei.prototype;
                return bi.createEl = function() {
                  return Vi.prototype.createEl.call(this, "div", {
                    className: "vjs-mouse-display"
                  });
                }, bi.update = function(ci, hi, wi) {
                  var zi = this, Wo = 100 * hi;
                  this.getChild("volumeLevelTooltip").updateVolume(ci, hi, wi, Wo, function() {
                    wi ? zi.el_.style.bottom = ci.height * hi + "px" : zi.el_.style.left = ci.width * hi + "px";
                  });
                }, Ei;
              })(ou);
              Pf.prototype.options_ = {
                children: ["volumeLevelTooltip"]
              }, ou.registerComponent("MouseVolumeLevelDisplay", Pf);
              var cf = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  return hi = Vi.call(this, yi, ci) || this, hi.on("slideractive", function(wi) {
                    return hi.updateLastVolume_(wi);
                  }), hi.on(yi, "volumechange", function(wi) {
                    return hi.updateARIAAttributes(wi);
                  }), yi.ready(function() {
                    return hi.updateARIAAttributes();
                  }), hi;
                }
                var bi = Ei.prototype;
                return bi.createEl = function() {
                  return Vi.prototype.createEl.call(this, "div", {
                    className: "vjs-volume-bar vjs-slider-bar"
                  }, {
                    "aria-label": this.localize("Volume Level"),
                    "aria-live": "polite"
                  });
                }, bi.handleMouseDown = function(ci) {
                  Gu(ci) && Vi.prototype.handleMouseDown.call(this, ci);
                }, bi.handleMouseMove = function(ci) {
                  var hi = this.getChild("mouseVolumeLevelDisplay");
                  if (hi) {
                    var wi = this.el(), zi = bu(wi), Wo = this.vertical(), aa = cc(wi, ci);
                    aa = Wo ? aa.y : aa.x, aa = Ou(aa, 0, 1), hi.update(zi, aa, Wo);
                  }
                  Gu(ci) && (this.checkMuted(), this.player_.volume(this.calculateDistance(ci)));
                }, bi.checkMuted = function() {
                  this.player_.muted() && this.player_.muted(!1);
                }, bi.getPercent = function() {
                  return this.player_.muted() ? 0 : this.player_.volume();
                }, bi.stepForward = function() {
                  this.checkMuted(), this.player_.volume(this.player_.volume() + 0.1);
                }, bi.stepBack = function() {
                  this.checkMuted(), this.player_.volume(this.player_.volume() - 0.1);
                }, bi.updateARIAAttributes = function(ci) {
                  var hi = this.player_.muted() ? 0 : this.volumeAsPercentage_();
                  this.el_.setAttribute("aria-valuenow", hi), this.el_.setAttribute("aria-valuetext", hi + "%");
                }, bi.volumeAsPercentage_ = function() {
                  return Math.round(this.player_.volume() * 100);
                }, bi.updateLastVolume_ = function() {
                  var ci = this, hi = this.player_.volume();
                  this.one("sliderinactive", function() {
                    ci.player_.volume() === 0 && ci.player_.lastVolume_(hi);
                  });
                }, Ei;
              })(qu);
              cf.prototype.options_ = {
                children: ["volumeLevel"],
                barName: "volumeLevel"
              }, !Tu && !Vs && cf.prototype.options_.children.splice(0, 0, "mouseVolumeLevelDisplay"), cf.prototype.playerEvent = "volumechange", ou.registerComponent("VolumeBar", cf);
              var Jp = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  return ci === void 0 && (ci = {}), ci.vertical = ci.vertical || !1, (typeof ci.volumeBar > "u" || Qa(ci.volumeBar)) && (ci.volumeBar = ci.volumeBar || {}, ci.volumeBar.vertical = ci.vertical), hi = Vi.call(this, yi, ci) || this, Ad((0, xi.default)(hi), yi), hi.throttledHandleMouseMove = Ud(Tc((0, xi.default)(hi), hi.handleMouseMove), Qc), hi.handleMouseUpHandler_ = function(wi) {
                    return hi.handleMouseUp(wi);
                  }, hi.on("mousedown", function(wi) {
                    return hi.handleMouseDown(wi);
                  }), hi.on("touchstart", function(wi) {
                    return hi.handleMouseDown(wi);
                  }), hi.on("mousemove", function(wi) {
                    return hi.handleMouseMove(wi);
                  }), hi.on(hi.volumeBar, ["focus", "slideractive"], function() {
                    hi.volumeBar.addClass("vjs-slider-active"), hi.addClass("vjs-slider-active"), hi.trigger("slideractive");
                  }), hi.on(hi.volumeBar, ["blur", "sliderinactive"], function() {
                    hi.volumeBar.removeClass("vjs-slider-active"), hi.removeClass("vjs-slider-active"), hi.trigger("sliderinactive");
                  }), hi;
                }
                var bi = Ei.prototype;
                return bi.createEl = function() {
                  var ci = "vjs-volume-horizontal";
                  return this.options_.vertical && (ci = "vjs-volume-vertical"), Vi.prototype.createEl.call(this, "div", {
                    className: "vjs-volume-control vjs-control " + ci
                  });
                }, bi.handleMouseDown = function(ci) {
                  var hi = this.el_.ownerDocument;
                  this.on(hi, "mousemove", this.throttledHandleMouseMove), this.on(hi, "touchmove", this.throttledHandleMouseMove), this.on(hi, "mouseup", this.handleMouseUpHandler_), this.on(hi, "touchend", this.handleMouseUpHandler_);
                }, bi.handleMouseUp = function(ci) {
                  var hi = this.el_.ownerDocument;
                  this.off(hi, "mousemove", this.throttledHandleMouseMove), this.off(hi, "touchmove", this.throttledHandleMouseMove), this.off(hi, "mouseup", this.handleMouseUpHandler_), this.off(hi, "touchend", this.handleMouseUpHandler_);
                }, bi.handleMouseMove = function(ci) {
                  this.volumeBar.handleMouseMove(ci);
                }, Ei;
              })(ou);
              Jp.prototype.options_ = {
                children: ["volumeBar"]
              }, ou.registerComponent("VolumeControl", Jp);
              var rf = function(Ei, bi) {
                bi.tech_ && !bi.tech_.featuresMuteControl && Ei.addClass("vjs-hidden"), Ei.on(bi, "loadstart", function() {
                  bi.tech_.featuresMuteControl ? Ei.removeClass("vjs-hidden") : Ei.addClass("vjs-hidden");
                });
              }, Qp = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  return hi = Vi.call(this, yi, ci) || this, rf((0, xi.default)(hi), yi), hi.on(yi, ["loadstart", "volumechange"], function(wi) {
                    return hi.update(wi);
                  }), hi;
                }
                var bi = Ei.prototype;
                return bi.buildCSSClass = function() {
                  return "vjs-mute-control " + Vi.prototype.buildCSSClass.call(this);
                }, bi.handleClick = function(ci) {
                  var hi = this.player_.volume(), wi = this.player_.lastVolume_();
                  if (hi === 0) {
                    var zi = wi < 0.1 ? 0.1 : wi;
                    this.player_.volume(zi), this.player_.muted(!1);
                  } else
                    this.player_.muted(!this.player_.muted());
                }, bi.update = function(ci) {
                  this.updateIcon_(), this.updateControlText_();
                }, bi.updateIcon_ = function() {
                  var ci = this.player_.volume(), hi = 3;
                  Tu && this.player_.tech_ && this.player_.tech_.el_ && this.player_.muted(this.player_.tech_.el_.muted), ci === 0 || this.player_.muted() ? hi = 0 : ci < 0.33 ? hi = 1 : ci < 0.67 && (hi = 2);
                  for (var wi = 0; wi < 4; wi++)
                    Ol(this.el_, "vjs-vol-" + wi);
                  al(this.el_, "vjs-vol-" + hi);
                }, bi.updateControlText_ = function() {
                  var ci = this.player_.muted() || this.player_.volume() === 0, hi = ci ? "Unmute" : "Mute";
                  this.controlText() !== hi && this.controlText(hi);
                }, Ei;
              })(Ho);
              Qp.prototype.controlText_ = "Mute", ou.registerComponent("MuteToggle", Qp);
              var Zh = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  return ci === void 0 && (ci = {}), typeof ci.inline < "u" ? ci.inline = ci.inline : ci.inline = !0, (typeof ci.volumeControl > "u" || Qa(ci.volumeControl)) && (ci.volumeControl = ci.volumeControl || {}, ci.volumeControl.vertical = !ci.inline), hi = Vi.call(this, yi, ci) || this, hi.handleKeyPressHandler_ = function(wi) {
                    return hi.handleKeyPress(wi);
                  }, hi.on(yi, ["loadstart"], function(wi) {
                    return hi.volumePanelState_(wi);
                  }), hi.on(hi.muteToggle, "keyup", function(wi) {
                    return hi.handleKeyPress(wi);
                  }), hi.on(hi.volumeControl, "keyup", function(wi) {
                    return hi.handleVolumeControlKeyUp(wi);
                  }), hi.on("keydown", function(wi) {
                    return hi.handleKeyPress(wi);
                  }), hi.on("mouseover", function(wi) {
                    return hi.handleMouseOver(wi);
                  }), hi.on("mouseout", function(wi) {
                    return hi.handleMouseOut(wi);
                  }), hi.on(hi.volumeControl, ["slideractive"], hi.sliderActive_), hi.on(hi.volumeControl, ["sliderinactive"], hi.sliderInactive_), hi;
                }
                var bi = Ei.prototype;
                return bi.sliderActive_ = function() {
                  this.addClass("vjs-slider-active");
                }, bi.sliderInactive_ = function() {
                  this.removeClass("vjs-slider-active");
                }, bi.volumePanelState_ = function() {
                  this.volumeControl.hasClass("vjs-hidden") && this.muteToggle.hasClass("vjs-hidden") && this.addClass("vjs-hidden"), this.volumeControl.hasClass("vjs-hidden") && !this.muteToggle.hasClass("vjs-hidden") && this.addClass("vjs-mute-toggle-only");
                }, bi.createEl = function() {
                  var ci = "vjs-volume-panel-horizontal";
                  return this.options_.inline || (ci = "vjs-volume-panel-vertical"), Vi.prototype.createEl.call(this, "div", {
                    className: "vjs-volume-panel vjs-control " + ci
                  });
                }, bi.dispose = function() {
                  this.handleMouseOut(), Vi.prototype.dispose.call(this);
                }, bi.handleVolumeControlKeyUp = function(ci) {
                  vi().isEventKey(ci, "Esc") && this.muteToggle.focus();
                }, bi.handleMouseOver = function(ci) {
                  this.addClass("vjs-hover"), pd(gi(), "keyup", this.handleKeyPressHandler_);
                }, bi.handleMouseOut = function(ci) {
                  this.removeClass("vjs-hover"), Cc(gi(), "keyup", this.handleKeyPressHandler_);
                }, bi.handleKeyPress = function(ci) {
                  vi().isEventKey(ci, "Esc") && this.handleMouseOut();
                }, Ei;
              })(ou);
              Zh.prototype.options_ = {
                children: ["muteToggle", "volumeControl"]
              }, ou.registerComponent("VolumePanel", Zh);
              var df = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  return hi = Vi.call(this, yi, ci) || this, ci && (hi.menuButton_ = ci.menuButton), hi.focusedChild_ = -1, hi.on("keydown", function(wi) {
                    return hi.handleKeyDown(wi);
                  }), hi.boundHandleBlur_ = function(wi) {
                    return hi.handleBlur(wi);
                  }, hi.boundHandleTapClick_ = function(wi) {
                    return hi.handleTapClick(wi);
                  }, hi;
                }
                var bi = Ei.prototype;
                return bi.addEventListenerForItem = function(ci) {
                  ci instanceof ou && (this.on(ci, "blur", this.boundHandleBlur_), this.on(ci, ["tap", "click"], this.boundHandleTapClick_));
                }, bi.removeEventListenerForItem = function(ci) {
                  ci instanceof ou && (this.off(ci, "blur", this.boundHandleBlur_), this.off(ci, ["tap", "click"], this.boundHandleTapClick_));
                }, bi.removeChild = function(ci) {
                  typeof ci == "string" && (ci = this.getChild(ci)), this.removeEventListenerForItem(ci), Vi.prototype.removeChild.call(this, ci);
                }, bi.addItem = function(ci) {
                  var hi = this.addChild(ci);
                  hi && this.addEventListenerForItem(hi);
                }, bi.createEl = function() {
                  var ci = this.options_.contentElType || "ul";
                  this.contentEl_ = bl(ci, {
                    className: "vjs-menu-content"
                  }), this.contentEl_.setAttribute("role", "menu");
                  var hi = Vi.prototype.createEl.call(this, "div", {
                    append: this.contentEl_,
                    className: "vjs-menu"
                  });
                  return hi.appendChild(this.contentEl_), pd(hi, "click", function(wi) {
                    wi.preventDefault(), wi.stopImmediatePropagation();
                  }), hi;
                }, bi.dispose = function() {
                  this.contentEl_ = null, this.boundHandleBlur_ = null, this.boundHandleTapClick_ = null, Vi.prototype.dispose.call(this);
                }, bi.handleBlur = function(ci) {
                  var hi = ci.relatedTarget || gi().activeElement;
                  if (!this.children().some(function(zi) {
                    return zi.el() === hi;
                  })) {
                    var wi = this.menuButton_;
                    wi && wi.buttonPressed_ && hi !== wi.el().firstChild && wi.unpressButton();
                  }
                }, bi.handleTapClick = function(ci) {
                  if (this.menuButton_) {
                    this.menuButton_.unpressButton();
                    var hi = this.children();
                    if (!Array.isArray(hi))
                      return;
                    var wi = hi.filter(function(zi) {
                      return zi.el() === ci.target;
                    })[0];
                    if (!wi)
                      return;
                    wi.name() !== "CaptionSettingsMenuItem" && this.menuButton_.focus();
                  }
                }, bi.handleKeyDown = function(ci) {
                  vi().isEventKey(ci, "Left") || vi().isEventKey(ci, "Down") ? (ci.preventDefault(), ci.stopPropagation(), this.stepForward()) : (vi().isEventKey(ci, "Right") || vi().isEventKey(ci, "Up")) && (ci.preventDefault(), ci.stopPropagation(), this.stepBack());
                }, bi.stepForward = function() {
                  var ci = 0;
                  this.focusedChild_ !== void 0 && (ci = this.focusedChild_ + 1), this.focus(ci);
                }, bi.stepBack = function() {
                  var ci = 0;
                  this.focusedChild_ !== void 0 && (ci = this.focusedChild_ - 1), this.focus(ci);
                }, bi.focus = function(ci) {
                  ci === void 0 && (ci = 0);
                  var hi = this.children().slice(), wi = hi.length && hi[0].hasClass("vjs-menu-title");
                  wi && hi.shift(), hi.length > 0 && (ci < 0 ? ci = 0 : ci >= hi.length && (ci = hi.length - 1), this.focusedChild_ = ci, hi[ci].el_.focus());
                }, Ei;
              })(ou);
              ou.registerComponent("Menu", df);
              var Zp = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  ci === void 0 && (ci = {}), hi = Vi.call(this, yi, ci) || this, hi.menuButton_ = new Ho(yi, ci), hi.menuButton_.controlText(hi.controlText_), hi.menuButton_.el_.setAttribute("aria-haspopup", "true");
                  var wi = Ho.prototype.buildCSSClass();
                  hi.menuButton_.el_.className = hi.buildCSSClass() + " " + wi, hi.menuButton_.removeClass("vjs-control"), hi.addChild(hi.menuButton_), hi.update(), hi.enabled_ = !0;
                  var zi = function(aa) {
                    return hi.handleClick(aa);
                  };
                  return hi.handleMenuKeyUp_ = function(Wo) {
                    return hi.handleMenuKeyUp(Wo);
                  }, hi.on(hi.menuButton_, "tap", zi), hi.on(hi.menuButton_, "click", zi), hi.on(hi.menuButton_, "keydown", function(Wo) {
                    return hi.handleKeyDown(Wo);
                  }), hi.on(hi.menuButton_, "mouseenter", function() {
                    hi.addClass("vjs-hover"), hi.menu.show(), pd(gi(), "keyup", hi.handleMenuKeyUp_);
                  }), hi.on("mouseleave", function(Wo) {
                    return hi.handleMouseLeave(Wo);
                  }), hi.on("keydown", function(Wo) {
                    return hi.handleSubmenuKeyDown(Wo);
                  }), hi;
                }
                var bi = Ei.prototype;
                return bi.update = function() {
                  var ci = this.createMenu();
                  this.menu && (this.menu.dispose(), this.removeChild(this.menu)), this.menu = ci, this.addChild(ci), this.buttonPressed_ = !1, this.menuButton_.el_.setAttribute("aria-expanded", "false"), this.items && this.items.length <= this.hideThreshold_ ? (this.hide(), this.menu.contentEl_.removeAttribute("role")) : (this.show(), this.menu.contentEl_.setAttribute("role", "menu"));
                }, bi.createMenu = function() {
                  var ci = new df(this.player_, {
                    menuButton: this
                  });
                  if (this.hideThreshold_ = 0, this.options_.title) {
                    var hi = bl("li", {
                      className: "vjs-menu-title",
                      textContent: Ic(this.options_.title),
                      tabIndex: -1
                    }), wi = new ou(this.player_, {
                      el: hi
                    });
                    ci.addItem(wi);
                  }
                  if (this.items = this.createItems(), this.items)
                    for (var zi = 0; zi < this.items.length; zi++)
                      ci.addItem(this.items[zi]);
                  return ci;
                }, bi.createItems = function() {
                }, bi.createEl = function() {
                  return Vi.prototype.createEl.call(this, "div", {
                    className: this.buildWrapperCSSClass()
                  }, {});
                }, bi.buildWrapperCSSClass = function() {
                  var ci = "vjs-menu-button";
                  this.options_.inline === !0 ? ci += "-inline" : ci += "-popup";
                  var hi = Ho.prototype.buildCSSClass();
                  return "vjs-menu-button " + ci + " " + hi + " " + Vi.prototype.buildCSSClass.call(this);
                }, bi.buildCSSClass = function() {
                  var ci = "vjs-menu-button";
                  return this.options_.inline === !0 ? ci += "-inline" : ci += "-popup", "vjs-menu-button " + ci + " " + Vi.prototype.buildCSSClass.call(this);
                }, bi.controlText = function(ci, hi) {
                  return hi === void 0 && (hi = this.menuButton_.el()), this.menuButton_.controlText(ci, hi);
                }, bi.dispose = function() {
                  this.handleMouseLeave(), Vi.prototype.dispose.call(this);
                }, bi.handleClick = function(ci) {
                  this.buttonPressed_ ? this.unpressButton() : this.pressButton();
                }, bi.handleMouseLeave = function(ci) {
                  this.removeClass("vjs-hover"), Cc(gi(), "keyup", this.handleMenuKeyUp_);
                }, bi.focus = function() {
                  this.menuButton_.focus();
                }, bi.blur = function() {
                  this.menuButton_.blur();
                }, bi.handleKeyDown = function(ci) {
                  vi().isEventKey(ci, "Esc") || vi().isEventKey(ci, "Tab") ? (this.buttonPressed_ && this.unpressButton(), vi().isEventKey(ci, "Tab") || (ci.preventDefault(), this.menuButton_.focus())) : (vi().isEventKey(ci, "Up") || vi().isEventKey(ci, "Down")) && (this.buttonPressed_ || (ci.preventDefault(), this.pressButton()));
                }, bi.handleMenuKeyUp = function(ci) {
                  (vi().isEventKey(ci, "Esc") || vi().isEventKey(ci, "Tab")) && this.removeClass("vjs-hover");
                }, bi.handleSubmenuKeyPress = function(ci) {
                  this.handleSubmenuKeyDown(ci);
                }, bi.handleSubmenuKeyDown = function(ci) {
                  (vi().isEventKey(ci, "Esc") || vi().isEventKey(ci, "Tab")) && (this.buttonPressed_ && this.unpressButton(), vi().isEventKey(ci, "Tab") || (ci.preventDefault(), this.menuButton_.focus()));
                }, bi.pressButton = function() {
                  if (this.enabled_) {
                    if (this.buttonPressed_ = !0, this.menu.show(), this.menu.lockShowing(), this.menuButton_.el_.setAttribute("aria-expanded", "true"), Tu && wl())
                      return;
                    this.menu.focus();
                  }
                }, bi.unpressButton = function() {
                  this.enabled_ && (this.buttonPressed_ = !1, this.menu.unlockShowing(), this.menu.hide(), this.menuButton_.el_.setAttribute("aria-expanded", "false"));
                }, bi.disable = function() {
                  this.unpressButton(), this.enabled_ = !1, this.addClass("vjs-disabled"), this.menuButton_.disable();
                }, bi.enable = function() {
                  this.enabled_ = !0, this.removeClass("vjs-disabled"), this.menuButton_.enable();
                }, Ei;
              })(ou);
              ou.registerComponent("MenuButton", Zp);
              var ap = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(bi, yi) {
                  var ci, hi = yi.tracks;
                  if (ci = Vi.call(this, bi, yi) || this, ci.items.length <= 1 && ci.hide(), !hi)
                    return (0, xi.default)(ci);
                  var wi = Tc((0, xi.default)(ci), ci.update);
                  return hi.addEventListener("removetrack", wi), hi.addEventListener("addtrack", wi), hi.addEventListener("labelchange", wi), ci.player_.on("ready", wi), ci.player_.on("dispose", function() {
                    hi.removeEventListener("removetrack", wi), hi.removeEventListener("addtrack", wi), hi.removeEventListener("labelchange", wi);
                  }), ci;
                }
                return Ei;
              })(Zp);
              ou.registerComponent("TrackButton", ap);
              var Eg = ["Tab", "Esc", "Up", "Down", "Right", "Left"], sp = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  return hi = Vi.call(this, yi, ci) || this, hi.selectable = ci.selectable, hi.isSelected_ = ci.selected || !1, hi.multiSelectable = ci.multiSelectable, hi.selected(hi.isSelected_), hi.selectable ? hi.multiSelectable ? hi.el_.setAttribute("role", "menuitemcheckbox") : hi.el_.setAttribute("role", "menuitemradio") : hi.el_.setAttribute("role", "menuitem"), hi;
                }
                var bi = Ei.prototype;
                return bi.createEl = function(ci, hi, wi) {
                  this.nonIconControl = !0;
                  var zi = Vi.prototype.createEl.call(this, "li", Ta({
                    className: "vjs-menu-item",
                    tabIndex: -1
                  }, hi), wi);
                  return zi.replaceChild(bl("span", {
                    className: "vjs-menu-item-text",
                    textContent: this.localize(this.options_.label)
                  }), zi.querySelector(".vjs-icon-placeholder")), zi;
                }, bi.handleKeyDown = function(ci) {
                  Eg.some(function(hi) {
                    return vi().isEventKey(ci, hi);
                  }) || Vi.prototype.handleKeyDown.call(this, ci);
                }, bi.handleClick = function(ci) {
                  this.selected(!0);
                }, bi.selected = function(ci) {
                  this.selectable && (ci ? (this.addClass("vjs-selected"), this.el_.setAttribute("aria-checked", "true"), this.controlText(", selected"), this.isSelected_ = !0) : (this.removeClass("vjs-selected"), this.el_.setAttribute("aria-checked", "false"), this.controlText(""), this.isSelected_ = !1));
                }, Ei;
              })(Od);
              ou.registerComponent("MenuItem", sp);
              var lp = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi, wi = ci.track, zi = yi.textTracks();
                  ci.label = wi.label || wi.language || "Unknown", ci.selected = wi.mode === "showing", hi = Vi.call(this, yi, ci) || this, hi.track = wi, hi.kinds = (ci.kinds || [ci.kind || hi.track.kind]).filter(Boolean);
                  var Wo = function() {
                    for (var Ha = arguments.length, ks = new Array(Ha), gl = 0; gl < Ha; gl++)
                      ks[gl] = arguments[gl];
                    hi.handleTracksChange.apply((0, xi.default)(hi), ks);
                  }, aa = function() {
                    for (var Ha = arguments.length, ks = new Array(Ha), gl = 0; gl < Ha; gl++)
                      ks[gl] = arguments[gl];
                    hi.handleSelectedLanguageChange.apply((0, xi.default)(hi), ks);
                  };
                  if (yi.on(["loadstart", "texttrackchange"], Wo), zi.addEventListener("change", Wo), zi.addEventListener("selectedlanguagechange", aa), hi.on("dispose", function() {
                    yi.off(["loadstart", "texttrackchange"], Wo), zi.removeEventListener("change", Wo), zi.removeEventListener("selectedlanguagechange", aa);
                  }), zi.onchange === void 0) {
                    var Ea;
                    hi.on(["tap", "click"], function() {
                      if (typeof di().Event != "object")
                        try {
                          Ea = new (di()).Event("change");
                        } catch {
                        }
                      Ea || (Ea = gi().createEvent("Event"), Ea.initEvent("change", !0, !0)), zi.dispatchEvent(Ea);
                    });
                  }
                  return hi.handleTracksChange(), hi;
                }
                var bi = Ei.prototype;
                return bi.handleClick = function(ci) {
                  var hi = this.track, wi = this.player_.textTracks();
                  if (Vi.prototype.handleClick.call(this, ci), !!wi)
                    for (var zi = 0; zi < wi.length; zi++) {
                      var Wo = wi[zi];
                      this.kinds.indexOf(Wo.kind) !== -1 && (Wo === hi ? Wo.mode !== "showing" && (Wo.mode = "showing") : Wo.mode !== "disabled" && (Wo.mode = "disabled"));
                    }
                }, bi.handleTracksChange = function(ci) {
                  var hi = this.track.mode === "showing";
                  hi !== this.isSelected_ && this.selected(hi);
                }, bi.handleSelectedLanguageChange = function(ci) {
                  if (this.track.mode === "showing") {
                    var hi = this.player_.cache_.selectedLanguage;
                    if (hi && hi.enabled && hi.language === this.track.language && hi.kind !== this.track.kind)
                      return;
                    this.player_.cache_.selectedLanguage = {
                      enabled: !0,
                      language: this.track.language,
                      kind: this.track.kind
                    };
                  }
                }, bi.dispose = function() {
                  this.track = null, Vi.prototype.dispose.call(this);
                }, Ei;
              })(sp);
              ou.registerComponent("TextTrackMenuItem", lp);
              var eh = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  return ci.track = {
                    player: yi,
                    // it is no longer necessary to store `kind` or `kinds` on the track itself
                    // since they are now stored in the `kinds` property of all instances of
                    // TextTrackMenuItem, but this will remain for backwards compatibility
                    kind: ci.kind,
                    kinds: ci.kinds,
                    default: !1,
                    mode: "disabled"
                  }, ci.kinds || (ci.kinds = [ci.kind]), ci.label ? ci.track.label = ci.label : ci.track.label = ci.kinds.join(" and ") + " off", ci.selectable = !0, ci.multiSelectable = !1, Vi.call(this, yi, ci) || this;
                }
                var bi = Ei.prototype;
                return bi.handleTracksChange = function(ci) {
                  for (var hi = this.player().textTracks(), wi = !0, zi = 0, Wo = hi.length; zi < Wo; zi++) {
                    var aa = hi[zi];
                    if (this.options_.kinds.indexOf(aa.kind) > -1 && aa.mode === "showing") {
                      wi = !1;
                      break;
                    }
                  }
                  wi !== this.isSelected_ && this.selected(wi);
                }, bi.handleSelectedLanguageChange = function(ci) {
                  for (var hi = this.player().textTracks(), wi = !0, zi = 0, Wo = hi.length; zi < Wo; zi++) {
                    var aa = hi[zi];
                    if (["captions", "descriptions", "subtitles"].indexOf(aa.kind) > -1 && aa.mode === "showing") {
                      wi = !1;
                      break;
                    }
                  }
                  wi && (this.player_.cache_.selectedLanguage = {
                    enabled: !1
                  });
                }, Ei;
              })(lp);
              ou.registerComponent("OffTextTrackMenuItem", eh);
              var $p = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  return ci === void 0 && (ci = {}), ci.tracks = yi.textTracks(), Vi.call(this, yi, ci) || this;
                }
                var bi = Ei.prototype;
                return bi.createItems = function(ci, hi) {
                  ci === void 0 && (ci = []), hi === void 0 && (hi = lp);
                  var wi;
                  this.label_ && (wi = this.label_ + " off"), ci.push(new eh(this.player_, {
                    kinds: this.kinds_,
                    kind: this.kind_,
                    label: wi
                  })), this.hideThreshold_ += 1;
                  var zi = this.player_.textTracks();
                  Array.isArray(this.kinds_) || (this.kinds_ = [this.kind_]);
                  for (var Wo = 0; Wo < zi.length; Wo++) {
                    var aa = zi[Wo];
                    if (this.kinds_.indexOf(aa.kind) > -1) {
                      var Ea = new hi(this.player_, {
                        track: aa,
                        kinds: this.kinds_,
                        kind: this.kind_,
                        // MenuItem is selectable
                        selectable: !0,
                        // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
                        multiSelectable: !1
                      });
                      Ea.addClass("vjs-" + aa.kind + "-menu-item"), ci.push(Ea);
                    }
                  }
                  return ci;
                }, Ei;
              })(ap);
              ou.registerComponent("TextTrackButton", $p);
              var Sg = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi, wi = ci.track, zi = ci.cue, Wo = yi.currentTime();
                  return ci.selectable = !0, ci.multiSelectable = !1, ci.label = zi.text, ci.selected = zi.startTime <= Wo && Wo < zi.endTime, hi = Vi.call(this, yi, ci) || this, hi.track = wi, hi.cue = zi, hi;
                }
                var bi = Ei.prototype;
                return bi.handleClick = function(ci) {
                  Vi.prototype.handleClick.call(this), this.player_.currentTime(this.cue.startTime);
                }, Ei;
              })(sp);
              ou.registerComponent("ChaptersTrackMenuItem", Sg);
              var wh = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci, hi) {
                  var wi;
                  return wi = Vi.call(this, yi, ci, hi) || this, wi.selectCurrentItem_ = function() {
                    wi.items.forEach(function(zi) {
                      zi.selected(wi.track_.activeCues[0] === zi.cue);
                    });
                  }, wi;
                }
                var bi = Ei.prototype;
                return bi.buildCSSClass = function() {
                  return "vjs-chapters-button " + Vi.prototype.buildCSSClass.call(this);
                }, bi.buildWrapperCSSClass = function() {
                  return "vjs-chapters-button " + Vi.prototype.buildWrapperCSSClass.call(this);
                }, bi.update = function(ci) {
                  if (!(ci && ci.track && ci.track.kind !== "chapters")) {
                    var hi = this.findChaptersTrack();
                    hi !== this.track_ ? (this.setTrack(hi), Vi.prototype.update.call(this)) : (!this.items || hi && hi.cues && hi.cues.length !== this.items.length) && Vi.prototype.update.call(this);
                  }
                }, bi.setTrack = function(ci) {
                  if (this.track_ !== ci) {
                    if (this.updateHandler_ || (this.updateHandler_ = this.update.bind(this)), this.track_) {
                      var hi = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
                      hi && hi.removeEventListener("load", this.updateHandler_), this.track_.removeEventListener("cuechange", this.selectCurrentItem_), this.track_ = null;
                    }
                    if (this.track_ = ci, this.track_) {
                      this.track_.mode = "hidden";
                      var wi = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
                      wi && wi.addEventListener("load", this.updateHandler_), this.track_.addEventListener("cuechange", this.selectCurrentItem_);
                    }
                  }
                }, bi.findChaptersTrack = function() {
                  for (var ci = this.player_.textTracks() || [], hi = ci.length - 1; hi >= 0; hi--) {
                    var wi = ci[hi];
                    if (wi.kind === this.kind_)
                      return wi;
                  }
                }, bi.getMenuCaption = function() {
                  return this.track_ && this.track_.label ? this.track_.label : this.localize(Ic(this.kind_));
                }, bi.createMenu = function() {
                  return this.options_.title = this.getMenuCaption(), Vi.prototype.createMenu.call(this);
                }, bi.createItems = function() {
                  var ci = [];
                  if (!this.track_)
                    return ci;
                  var hi = this.track_.cues;
                  if (!hi)
                    return ci;
                  for (var wi = 0, zi = hi.length; wi < zi; wi++) {
                    var Wo = hi[wi], aa = new Sg(this.player_, {
                      track: this.track_,
                      cue: Wo
                    });
                    ci.push(aa);
                  }
                  return ci;
                }, Ei;
              })($p);
              wh.prototype.kind_ = "chapters", wh.prototype.controlText_ = "Chapters", ou.registerComponent("ChaptersButton", wh);
              var _h = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci, hi) {
                  var wi;
                  wi = Vi.call(this, yi, ci, hi) || this;
                  var zi = yi.textTracks(), Wo = Tc((0, xi.default)(wi), wi.handleTracksChange);
                  return zi.addEventListener("change", Wo), wi.on("dispose", function() {
                    zi.removeEventListener("change", Wo);
                  }), wi;
                }
                var bi = Ei.prototype;
                return bi.handleTracksChange = function(ci) {
                  for (var hi = this.player().textTracks(), wi = !1, zi = 0, Wo = hi.length; zi < Wo; zi++) {
                    var aa = hi[zi];
                    if (aa.kind !== this.kind_ && aa.mode === "showing") {
                      wi = !0;
                      break;
                    }
                  }
                  wi ? this.disable() : this.enable();
                }, bi.buildCSSClass = function() {
                  return "vjs-descriptions-button " + Vi.prototype.buildCSSClass.call(this);
                }, bi.buildWrapperCSSClass = function() {
                  return "vjs-descriptions-button " + Vi.prototype.buildWrapperCSSClass.call(this);
                }, Ei;
              })($p);
              _h.prototype.kind_ = "descriptions", _h.prototype.controlText_ = "Descriptions", ou.registerComponent("DescriptionsButton", _h);
              var th = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci, hi) {
                  return Vi.call(this, yi, ci, hi) || this;
                }
                var bi = Ei.prototype;
                return bi.buildCSSClass = function() {
                  return "vjs-subtitles-button " + Vi.prototype.buildCSSClass.call(this);
                }, bi.buildWrapperCSSClass = function() {
                  return "vjs-subtitles-button " + Vi.prototype.buildWrapperCSSClass.call(this);
                }, Ei;
              })($p);
              th.prototype.kind_ = "subtitles", th.prototype.controlText_ = "Subtitles", ou.registerComponent("SubtitlesButton", th);
              var Ph = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  return ci.track = {
                    player: yi,
                    kind: ci.kind,
                    label: ci.kind + " settings",
                    selectable: !1,
                    default: !1,
                    mode: "disabled"
                  }, ci.selectable = !1, ci.name = "CaptionSettingsMenuItem", hi = Vi.call(this, yi, ci) || this, hi.addClass("vjs-texttrack-settings"), hi.controlText(", opens " + ci.kind + " settings dialog"), hi;
                }
                var bi = Ei.prototype;
                return bi.handleClick = function(ci) {
                  this.player().getChild("textTrackSettings").open();
                }, Ei;
              })(lp);
              ou.registerComponent("CaptionSettingsMenuItem", Ph);
              var ff = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci, hi) {
                  return Vi.call(this, yi, ci, hi) || this;
                }
                var bi = Ei.prototype;
                return bi.buildCSSClass = function() {
                  return "vjs-captions-button " + Vi.prototype.buildCSSClass.call(this);
                }, bi.buildWrapperCSSClass = function() {
                  return "vjs-captions-button " + Vi.prototype.buildWrapperCSSClass.call(this);
                }, bi.createItems = function() {
                  var ci = [];
                  return !(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild("textTrackSettings") && (ci.push(new Ph(this.player_, {
                    kind: this.kind_
                  })), this.hideThreshold_ += 1), Vi.prototype.createItems.call(this, ci);
                }, Ei;
              })($p);
              ff.prototype.kind_ = "captions", ff.prototype.controlText_ = "Captions", ou.registerComponent("CaptionsButton", ff);
              var xg = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei() {
                  return Vi.apply(this, arguments) || this;
                }
                var bi = Ei.prototype;
                return bi.createEl = function(ci, hi, wi) {
                  var zi = Vi.prototype.createEl.call(this, ci, hi, wi), Wo = zi.querySelector(".vjs-menu-item-text");
                  return this.options_.track.kind === "captions" && (Wo.appendChild(bl("span", {
                    className: "vjs-icon-placeholder"
                  }, {
                    "aria-hidden": !0
                  })), Wo.appendChild(bl("span", {
                    className: "vjs-control-text",
                    // space added as the text will visually flow with the
                    // label
                    textContent: " " + this.localize("Captions")
                  }))), zi;
                }, Ei;
              })(lp);
              ou.registerComponent("SubsCapsMenuItem", xg);
              var rh = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  return ci === void 0 && (ci = {}), hi = Vi.call(this, yi, ci) || this, hi.label_ = "subtitles", ["en", "en-us", "en-ca", "fr-ca"].indexOf(hi.player_.language_) > -1 && (hi.label_ = "captions"), hi.menuButton_.controlText(Ic(hi.label_)), hi;
                }
                var bi = Ei.prototype;
                return bi.buildCSSClass = function() {
                  return "vjs-subs-caps-button " + Vi.prototype.buildCSSClass.call(this);
                }, bi.buildWrapperCSSClass = function() {
                  return "vjs-subs-caps-button " + Vi.prototype.buildWrapperCSSClass.call(this);
                }, bi.createItems = function() {
                  var ci = [];
                  return !(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild("textTrackSettings") && (ci.push(new Ph(this.player_, {
                    kind: this.label_
                  })), this.hideThreshold_ += 1), ci = Vi.prototype.createItems.call(this, ci, xg), ci;
                }, Ei;
              })($p);
              rh.prototype.kinds_ = ["captions", "subtitles"], rh.prototype.controlText_ = "Subtitles", ou.registerComponent("SubsCapsButton", rh);
              var Ch = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi, wi = ci.track, zi = yi.audioTracks();
                  ci.label = wi.label || wi.language || "Unknown", ci.selected = wi.enabled, hi = Vi.call(this, yi, ci) || this, hi.track = wi, hi.addClass("vjs-" + wi.kind + "-menu-item");
                  var Wo = function() {
                    for (var Ea = arguments.length, Ka = new Array(Ea), Ha = 0; Ha < Ea; Ha++)
                      Ka[Ha] = arguments[Ha];
                    hi.handleTracksChange.apply((0, xi.default)(hi), Ka);
                  };
                  return zi.addEventListener("change", Wo), hi.on("dispose", function() {
                    zi.removeEventListener("change", Wo);
                  }), hi;
                }
                var bi = Ei.prototype;
                return bi.createEl = function(ci, hi, wi) {
                  var zi = Vi.prototype.createEl.call(this, ci, hi, wi), Wo = zi.querySelector(".vjs-menu-item-text");
                  return this.options_.track.kind === "main-desc" && (Wo.appendChild(bl("span", {
                    className: "vjs-icon-placeholder"
                  }, {
                    "aria-hidden": !0
                  })), Wo.appendChild(bl("span", {
                    className: "vjs-control-text",
                    textContent: " " + this.localize("Descriptions")
                  }))), zi;
                }, bi.handleClick = function(ci) {
                  if (Vi.prototype.handleClick.call(this, ci), this.track.enabled = !0, this.player_.tech_.featuresNativeAudioTracks)
                    for (var hi = this.player_.audioTracks(), wi = 0; wi < hi.length; wi++) {
                      var zi = hi[wi];
                      zi !== this.track && (zi.enabled = zi === this.track);
                    }
                }, bi.handleTracksChange = function(ci) {
                  this.selected(this.track.enabled);
                }, Ei;
              })(sp);
              ou.registerComponent("AudioTrackMenuItem", Ch);
              var wg = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  return ci === void 0 && (ci = {}), ci.tracks = yi.audioTracks(), Vi.call(this, yi, ci) || this;
                }
                var bi = Ei.prototype;
                return bi.buildCSSClass = function() {
                  return "vjs-audio-button " + Vi.prototype.buildCSSClass.call(this);
                }, bi.buildWrapperCSSClass = function() {
                  return "vjs-audio-button " + Vi.prototype.buildWrapperCSSClass.call(this);
                }, bi.createItems = function(ci) {
                  ci === void 0 && (ci = []), this.hideThreshold_ = 1;
                  for (var hi = this.player_.audioTracks(), wi = 0; wi < hi.length; wi++) {
                    var zi = hi[wi];
                    ci.push(new Ch(this.player_, {
                      track: zi,
                      // MenuItem is selectable
                      selectable: !0,
                      // MenuItem is NOT multiSelectable (i.e. only one can be marked "selected" at a time)
                      multiSelectable: !1
                    }));
                  }
                  return ci;
                }, Ei;
              })(ap);
              wg.prototype.controlText_ = "Audio Track", ou.registerComponent("AudioTrackButton", wg);
              var Rh = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi, wi = ci.rate, zi = parseFloat(wi, 10);
                  return ci.label = wi, ci.selected = zi === yi.playbackRate(), ci.selectable = !0, ci.multiSelectable = !1, hi = Vi.call(this, yi, ci) || this, hi.label = wi, hi.rate = zi, hi.on(yi, "ratechange", function(Wo) {
                    return hi.update(Wo);
                  }), hi;
                }
                var bi = Ei.prototype;
                return bi.handleClick = function(ci) {
                  Vi.prototype.handleClick.call(this), this.player().playbackRate(this.rate);
                }, bi.update = function(ci) {
                  this.selected(this.player().playbackRate() === this.rate);
                }, Ei;
              })(sp);
              Rh.prototype.contentElType = "button", ou.registerComponent("PlaybackRateMenuItem", Rh);
              var _g = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  return hi = Vi.call(this, yi, ci) || this, hi.menuButton_.el_.setAttribute("aria-describedby", hi.labelElId_), hi.updateVisibility(), hi.updateLabel(), hi.on(yi, "loadstart", function(wi) {
                    return hi.updateVisibility(wi);
                  }), hi.on(yi, "ratechange", function(wi) {
                    return hi.updateLabel(wi);
                  }), hi.on(yi, "playbackrateschange", function(wi) {
                    return hi.handlePlaybackRateschange(wi);
                  }), hi;
                }
                var bi = Ei.prototype;
                return bi.createEl = function() {
                  var ci = Vi.prototype.createEl.call(this);
                  return this.labelElId_ = "vjs-playback-rate-value-label-" + this.id_, this.labelEl_ = bl("div", {
                    className: "vjs-playback-rate-value",
                    id: this.labelElId_,
                    textContent: "1x"
                  }), ci.appendChild(this.labelEl_), ci;
                }, bi.dispose = function() {
                  this.labelEl_ = null, Vi.prototype.dispose.call(this);
                }, bi.buildCSSClass = function() {
                  return "vjs-playback-rate " + Vi.prototype.buildCSSClass.call(this);
                }, bi.buildWrapperCSSClass = function() {
                  return "vjs-playback-rate " + Vi.prototype.buildWrapperCSSClass.call(this);
                }, bi.createItems = function() {
                  for (var ci = this.playbackRates(), hi = [], wi = ci.length - 1; wi >= 0; wi--)
                    hi.push(new Rh(this.player(), {
                      rate: ci[wi] + "x"
                    }));
                  return hi;
                }, bi.updateARIAAttributes = function() {
                  this.el().setAttribute("aria-valuenow", this.player().playbackRate());
                }, bi.handleClick = function(ci) {
                  var hi = this.player().playbackRate(), wi = this.playbackRates(), zi = wi.indexOf(hi), Wo = (zi + 1) % wi.length;
                  this.player().playbackRate(wi[Wo]);
                }, bi.handlePlaybackRateschange = function(ci) {
                  this.update();
                }, bi.playbackRates = function() {
                  var ci = this.player();
                  return ci.playbackRates && ci.playbackRates() || [];
                }, bi.playbackRateSupported = function() {
                  return this.player().tech_ && this.player().tech_.featuresPlaybackRate && this.playbackRates() && this.playbackRates().length > 0;
                }, bi.updateVisibility = function(ci) {
                  this.playbackRateSupported() ? this.removeClass("vjs-hidden") : this.addClass("vjs-hidden");
                }, bi.updateLabel = function(ci) {
                  this.playbackRateSupported() && (this.labelEl_.textContent = this.player().playbackRate() + "x");
                }, Ei;
              })(Zp);
              _g.prototype.controlText_ = "Playback Rate", ou.registerComponent("PlaybackRateMenuButton", _g);
              var eg = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei() {
                  return Vi.apply(this, arguments) || this;
                }
                var bi = Ei.prototype;
                return bi.buildCSSClass = function() {
                  return "vjs-spacer " + Vi.prototype.buildCSSClass.call(this);
                }, bi.createEl = function(ci, hi, wi) {
                  return ci === void 0 && (ci = "div"), hi === void 0 && (hi = {}), wi === void 0 && (wi = {}), hi.className || (hi.className = this.buildCSSClass()), Vi.prototype.createEl.call(this, ci, hi, wi);
                }, Ei;
              })(ou);
              ou.registerComponent("Spacer", eg);
              var Kg = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei() {
                  return Vi.apply(this, arguments) || this;
                }
                var bi = Ei.prototype;
                return bi.buildCSSClass = function() {
                  return "vjs-custom-control-spacer " + Vi.prototype.buildCSSClass.call(this);
                }, bi.createEl = function() {
                  return Vi.prototype.createEl.call(this, "div", {
                    className: this.buildCSSClass(),
                    // No-flex/table-cell mode requires there be some content
                    // in the cell to fill the remaining space of the table.
                    textContent: " "
                  });
                }, Ei;
              })(eg);
              ou.registerComponent("CustomControlSpacer", Kg);
              var Cf = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei() {
                  return Vi.apply(this, arguments) || this;
                }
                var bi = Ei.prototype;
                return bi.createEl = function() {
                  return Vi.prototype.createEl.call(this, "div", {
                    className: "vjs-control-bar",
                    dir: "ltr"
                  });
                }, Ei;
              })(ou);
              Cf.prototype.options_ = {
                children: ["playToggle", "volumePanel", "currentTimeDisplay", "timeDivider", "durationDisplay", "progressControl", "liveDisplay", "seekToLive", "remainingTimeDisplay", "customControlSpacer", "playbackRateMenuButton", "chaptersButton", "descriptionsButton", "subsCapsButton", "audioTrackButton", "fullscreenToggle"]
              }, "exitPictureInPicture" in gi() && Cf.prototype.options_.children.splice(Cf.prototype.options_.children.length - 1, 0, "pictureInPictureToggle"), ou.registerComponent("ControlBar", Cf);
              var Oh = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  return hi = Vi.call(this, yi, ci) || this, hi.on(yi, "error", function(wi) {
                    return hi.open(wi);
                  }), hi;
                }
                var bi = Ei.prototype;
                return bi.buildCSSClass = function() {
                  return "vjs-error-display " + Vi.prototype.buildCSSClass.call(this);
                }, bi.content = function() {
                  var ci = this.player().error();
                  return ci ? this.localize(ci.message) : "";
                }, Ei;
              })(hd);
              Oh.prototype.options_ = (0, mi.default)({}, hd.prototype.options_, {
                pauseOnOpen: !1,
                fillAlways: !0,
                temporary: !1,
                uncloseable: !0
              }), ou.registerComponent("ErrorDisplay", Oh);
              var tg = "vjs-text-track-settings", rg = ["#000", "Black"], Pg = ["#00F", "Blue"], Ah = ["#0FF", "Cyan"], Ih = ["#0F0", "Green"], nh = ["#F0F", "Magenta"], $h = ["#F00", "Red"], Ua = ["#FFF", "White"], oa = ["#FF0", "Yellow"], ya = ["1", "Opaque"], ha = ["0.5", "Semi-Transparent"], Aa = ["0", "Transparent"], da = {
                backgroundColor: {
                  selector: ".vjs-bg-color > select",
                  id: "captions-background-color-%s",
                  label: "Color",
                  options: [rg, Ua, $h, Ih, Pg, oa, nh, Ah]
                },
                backgroundOpacity: {
                  selector: ".vjs-bg-opacity > select",
                  id: "captions-background-opacity-%s",
                  label: "Transparency",
                  options: [ya, ha, Aa]
                },
                color: {
                  selector: ".vjs-fg-color > select",
                  id: "captions-foreground-color-%s",
                  label: "Color",
                  options: [Ua, rg, $h, Ih, Pg, oa, nh, Ah]
                },
                edgeStyle: {
                  selector: ".vjs-edge-style > select",
                  id: "%s",
                  label: "Text Edge Style",
                  options: [["none", "None"], ["raised", "Raised"], ["depressed", "Depressed"], ["uniform", "Uniform"], ["dropshadow", "Dropshadow"]]
                },
                fontFamily: {
                  selector: ".vjs-font-family > select",
                  id: "captions-font-family-%s",
                  label: "Font Family",
                  options: [["proportionalSansSerif", "Proportional Sans-Serif"], ["monospaceSansSerif", "Monospace Sans-Serif"], ["proportionalSerif", "Proportional Serif"], ["monospaceSerif", "Monospace Serif"], ["casual", "Casual"], ["script", "Script"], ["small-caps", "Small Caps"]]
                },
                fontPercent: {
                  selector: ".vjs-font-percent > select",
                  id: "captions-font-size-%s",
                  label: "Font Size",
                  options: [["0.50", "50%"], ["0.75", "75%"], ["1.00", "100%"], ["1.25", "125%"], ["1.50", "150%"], ["1.75", "175%"], ["2.00", "200%"], ["3.00", "300%"], ["4.00", "400%"]],
                  default: 2,
                  parser: function(Ei) {
                    return Ei === "1.00" ? null : Number(Ei);
                  }
                },
                textOpacity: {
                  selector: ".vjs-text-opacity > select",
                  id: "captions-foreground-opacity-%s",
                  label: "Transparency",
                  options: [ya, ha]
                },
                // Options for this object are defined below.
                windowColor: {
                  selector: ".vjs-window-color > select",
                  id: "captions-window-color-%s",
                  label: "Color"
                },
                // Options for this object are defined below.
                windowOpacity: {
                  selector: ".vjs-window-opacity > select",
                  id: "captions-window-opacity-%s",
                  label: "Transparency",
                  options: [Aa, ha, ya]
                }
              };
              da.windowColor.options = da.backgroundColor.options;
              function fa(Vi, Ei) {
                if (Ei && (Vi = Ei(Vi)), Vi && Vi !== "none")
                  return Vi;
              }
              function gs(Vi, Ei) {
                var bi = Vi.options[Vi.options.selectedIndex].value;
                return fa(bi, Ei);
              }
              function Gs(Vi, Ei, bi) {
                if (Ei) {
                  for (var yi = 0; yi < Vi.options.length; yi++)
                    if (fa(Vi.options[yi].value, bi) === Ei) {
                      Vi.selectedIndex = yi;
                      break;
                    }
                }
              }
              var qs = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  return ci.temporary = !1, hi = Vi.call(this, yi, ci) || this, hi.updateDisplay = hi.updateDisplay.bind((0, xi.default)(hi)), hi.fill(), hi.hasBeenOpened_ = hi.hasBeenFilled_ = !0, hi.endDialog = bl("p", {
                    className: "vjs-control-text",
                    textContent: hi.localize("End of dialog window.")
                  }), hi.el().appendChild(hi.endDialog), hi.setDefaults(), ci.persistTextTrackSettings === void 0 && (hi.options_.persistTextTrackSettings = hi.options_.playerOptions.persistTextTrackSettings), hi.on(hi.$(".vjs-done-button"), "click", function() {
                    hi.saveSettings(), hi.close();
                  }), hi.on(hi.$(".vjs-default-button"), "click", function() {
                    hi.setDefaults(), hi.updateDisplay();
                  }), Ja(da, function(wi) {
                    hi.on(hi.$(wi.selector), "change", hi.updateDisplay);
                  }), hi.options_.persistTextTrackSettings && hi.restoreSettings(), hi;
                }
                var bi = Ei.prototype;
                return bi.dispose = function() {
                  this.endDialog = null, Vi.prototype.dispose.call(this);
                }, bi.createElSelect_ = function(ci, hi, wi) {
                  var zi = this;
                  hi === void 0 && (hi = ""), wi === void 0 && (wi = "label");
                  var Wo = da[ci], aa = Wo.id.replace("%s", this.id_), Ea = [hi, aa].join(" ").trim();
                  return ["<" + wi + ' id="' + aa + '" class="' + (wi === "label" ? "vjs-label" : "") + '">', this.localize(Wo.label), "</" + wi + ">", '<select aria-labelledby="' + Ea + '">'].concat(Wo.options.map(function(Ka) {
                    var Ha = aa + "-" + Ka[1].replace(/\W+/g, "");
                    return ['<option id="' + Ha + '" value="' + Ka[0] + '" ', 'aria-labelledby="' + Ea + " " + Ha + '">', zi.localize(Ka[1]), "</option>"].join("");
                  })).concat("</select>").join("");
                }, bi.createElFgColor_ = function() {
                  var ci = "captions-text-legend-" + this.id_;
                  return ['<fieldset class="vjs-fg-color vjs-track-setting">', '<legend id="' + ci + '">', this.localize("Text"), "</legend>", this.createElSelect_("color", ci), '<span class="vjs-text-opacity vjs-opacity">', this.createElSelect_("textOpacity", ci), "</span>", "</fieldset>"].join("");
                }, bi.createElBgColor_ = function() {
                  var ci = "captions-background-" + this.id_;
                  return ['<fieldset class="vjs-bg-color vjs-track-setting">', '<legend id="' + ci + '">', this.localize("Background"), "</legend>", this.createElSelect_("backgroundColor", ci), '<span class="vjs-bg-opacity vjs-opacity">', this.createElSelect_("backgroundOpacity", ci), "</span>", "</fieldset>"].join("");
                }, bi.createElWinColor_ = function() {
                  var ci = "captions-window-" + this.id_;
                  return ['<fieldset class="vjs-window-color vjs-track-setting">', '<legend id="' + ci + '">', this.localize("Window"), "</legend>", this.createElSelect_("windowColor", ci), '<span class="vjs-window-opacity vjs-opacity">', this.createElSelect_("windowOpacity", ci), "</span>", "</fieldset>"].join("");
                }, bi.createElColors_ = function() {
                  return bl("div", {
                    className: "vjs-track-settings-colors",
                    innerHTML: [this.createElFgColor_(), this.createElBgColor_(), this.createElWinColor_()].join("")
                  });
                }, bi.createElFont_ = function() {
                  return bl("div", {
                    className: "vjs-track-settings-font",
                    innerHTML: ['<fieldset class="vjs-font-percent vjs-track-setting">', this.createElSelect_("fontPercent", "", "legend"), "</fieldset>", '<fieldset class="vjs-edge-style vjs-track-setting">', this.createElSelect_("edgeStyle", "", "legend"), "</fieldset>", '<fieldset class="vjs-font-family vjs-track-setting">', this.createElSelect_("fontFamily", "", "legend"), "</fieldset>"].join("")
                  });
                }, bi.createElControls_ = function() {
                  var ci = this.localize("restore all settings to the default values");
                  return bl("div", {
                    className: "vjs-track-settings-controls",
                    innerHTML: ['<button type="button" class="vjs-default-button" title="' + ci + '">', this.localize("Reset"), '<span class="vjs-control-text"> ' + ci + "</span>", "</button>", '<button type="button" class="vjs-done-button">' + this.localize("Done") + "</button>"].join("")
                  });
                }, bi.content = function() {
                  return [this.createElColors_(), this.createElFont_(), this.createElControls_()];
                }, bi.label = function() {
                  return this.localize("Caption Settings Dialog");
                }, bi.description = function() {
                  return this.localize("Beginning of dialog window. Escape will cancel and close the window.");
                }, bi.buildCSSClass = function() {
                  return Vi.prototype.buildCSSClass.call(this) + " vjs-text-track-settings";
                }, bi.getValues = function() {
                  var ci = this;
                  return ja(da, function(hi, wi, zi) {
                    var Wo = gs(ci.$(wi.selector), wi.parser);
                    return Wo !== void 0 && (hi[zi] = Wo), hi;
                  }, {});
                }, bi.setValues = function(ci) {
                  var hi = this;
                  Ja(da, function(wi, zi) {
                    Gs(hi.$(wi.selector), ci[zi], wi.parser);
                  });
                }, bi.setDefaults = function() {
                  var ci = this;
                  Ja(da, function(hi) {
                    var wi = hi.hasOwnProperty("default") ? hi.default : 0;
                    ci.$(hi.selector).selectedIndex = wi;
                  });
                }, bi.restoreSettings = function() {
                  var ci;
                  try {
                    ci = JSON.parse(di().localStorage.getItem(tg));
                  } catch (hi) {
                    Xa.warn(hi);
                  }
                  ci && this.setValues(ci);
                }, bi.saveSettings = function() {
                  if (this.options_.persistTextTrackSettings) {
                    var ci = this.getValues();
                    try {
                      Object.keys(ci).length ? di().localStorage.setItem(tg, JSON.stringify(ci)) : di().localStorage.removeItem(tg);
                    } catch (hi) {
                      Xa.warn(hi);
                    }
                  }
                }, bi.updateDisplay = function() {
                  var ci = this.player_.getChild("textTrackDisplay");
                  ci && ci.updateDisplay();
                }, bi.conditionalBlur_ = function() {
                  this.previouslyActiveEl_ = null;
                  var ci = this.player_.controlBar, hi = ci && ci.subsCapsButton, wi = ci && ci.captionsButton;
                  hi ? hi.focus() : wi && wi.focus();
                }, Ei;
              })(hd);
              ou.registerComponent("TextTrackSettings", qs);
              var El = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi, wi = ci.ResizeObserver || di().ResizeObserver;
                  ci.ResizeObserver === null && (wi = !1);
                  var zi = Ec({
                    createEl: !wi,
                    reportTouchActivity: !1
                  }, ci);
                  return hi = Vi.call(this, yi, zi) || this, hi.ResizeObserver = ci.ResizeObserver || di().ResizeObserver, hi.loadListener_ = null, hi.resizeObserver_ = null, hi.debouncedHandler_ = Ff(function() {
                    hi.resizeHandler();
                  }, 100, !1, (0, xi.default)(hi)), wi ? (hi.resizeObserver_ = new hi.ResizeObserver(hi.debouncedHandler_), hi.resizeObserver_.observe(yi.el())) : (hi.loadListener_ = function() {
                    if (!(!hi.el_ || !hi.el_.contentWindow)) {
                      var Wo = hi.debouncedHandler_, aa = hi.unloadListener_ = function() {
                        Cc(this, "resize", Wo), Cc(this, "unload", aa), aa = null;
                      };
                      pd(hi.el_.contentWindow, "unload", aa), pd(hi.el_.contentWindow, "resize", Wo);
                    }
                  }, hi.one("load", hi.loadListener_)), hi;
                }
                var bi = Ei.prototype;
                return bi.createEl = function() {
                  return Vi.prototype.createEl.call(this, "iframe", {
                    className: "vjs-resize-manager",
                    tabIndex: -1,
                    title: this.localize("No content")
                  }, {
                    "aria-hidden": "true"
                  });
                }, bi.resizeHandler = function() {
                  !this.player_ || !this.player_.trigger || this.player_.trigger("playerresize");
                }, bi.dispose = function() {
                  this.debouncedHandler_ && this.debouncedHandler_.cancel(), this.resizeObserver_ && (this.player_.el() && this.resizeObserver_.unobserve(this.player_.el()), this.resizeObserver_.disconnect()), this.loadListener_ && this.off("load", this.loadListener_), this.el_ && this.el_.contentWindow && this.unloadListener_ && this.unloadListener_.call(this.el_.contentWindow), this.ResizeObserver = null, this.resizeObserver = null, this.debouncedHandler_ = null, this.loadListener_ = null, Vi.prototype.dispose.call(this);
                }, Ei;
              })(ou);
              ou.registerComponent("ResizeManager", El);
              var kl = {
                trackingThreshold: 20,
                liveTolerance: 15
              }, ju = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi, wi = Ec(kl, ci, {
                    createEl: !1
                  });
                  return hi = Vi.call(this, yi, wi) || this, hi.handleVisibilityChange_ = function(zi) {
                    return hi.handleVisibilityChange(zi);
                  }, hi.trackLiveHandler_ = function() {
                    return hi.trackLive_();
                  }, hi.handlePlay_ = function(zi) {
                    return hi.handlePlay(zi);
                  }, hi.handleFirstTimeupdate_ = function(zi) {
                    return hi.handleFirstTimeupdate(zi);
                  }, hi.handleSeeked_ = function(zi) {
                    return hi.handleSeeked(zi);
                  }, hi.seekToLiveEdge_ = function(zi) {
                    return hi.seekToLiveEdge(zi);
                  }, hi.reset_(), hi.on(hi.player_, "durationchange", function(zi) {
                    return hi.handleDurationchange(zi);
                  }), hi.on(hi.player_, "canplay", function() {
                    return hi.toggleTracking();
                  }), Bl && "hidden" in gi() && "visibilityState" in gi() && hi.on(gi(), "visibilitychange", hi.handleVisibilityChange_), hi;
                }
                var bi = Ei.prototype;
                return bi.handleVisibilityChange = function() {
                  this.player_.duration() === 1 / 0 && (gi().hidden ? this.stopTracking() : this.startTracking());
                }, bi.trackLive_ = function() {
                  var ci = this.player_.seekable();
                  if (!(!ci || !ci.length)) {
                    var hi = Number(di().performance.now().toFixed(4)), wi = this.lastTime_ === -1 ? 0 : (hi - this.lastTime_) / 1e3;
                    this.lastTime_ = hi, this.pastSeekEnd_ = this.pastSeekEnd() + wi;
                    var zi = this.liveCurrentTime(), Wo = this.player_.currentTime(), aa = this.player_.paused() || this.seekedBehindLive_ || Math.abs(zi - Wo) > this.options_.liveTolerance;
                    (!this.timeupdateSeen_ || zi === 1 / 0) && (aa = !1), aa !== this.behindLiveEdge_ && (this.behindLiveEdge_ = aa, this.trigger("liveedgechange"));
                  }
                }, bi.handleDurationchange = function() {
                  this.toggleTracking();
                }, bi.toggleTracking = function() {
                  this.player_.duration() === 1 / 0 && this.liveWindow() >= this.options_.trackingThreshold ? (this.player_.options_.liveui && this.player_.addClass("vjs-liveui"), this.startTracking()) : (this.player_.removeClass("vjs-liveui"), this.stopTracking());
                }, bi.startTracking = function() {
                  this.isTracking() || (this.timeupdateSeen_ || (this.timeupdateSeen_ = this.player_.hasStarted()), this.trackingInterval_ = this.setInterval(this.trackLiveHandler_, Qc), this.trackLive_(), this.on(this.player_, ["play", "pause"], this.trackLiveHandler_), this.timeupdateSeen_ ? this.on(this.player_, "seeked", this.handleSeeked_) : (this.one(this.player_, "play", this.handlePlay_), this.one(this.player_, "timeupdate", this.handleFirstTimeupdate_)));
                }, bi.handleFirstTimeupdate = function() {
                  this.timeupdateSeen_ = !0, this.on(this.player_, "seeked", this.handleSeeked_);
                }, bi.handleSeeked = function() {
                  var ci = Math.abs(this.liveCurrentTime() - this.player_.currentTime());
                  this.seekedBehindLive_ = this.nextSeekedFromUser_ && ci > 2, this.nextSeekedFromUser_ = !1, this.trackLive_();
                }, bi.handlePlay = function() {
                  this.one(this.player_, "timeupdate", this.seekToLiveEdge_);
                }, bi.reset_ = function() {
                  this.lastTime_ = -1, this.pastSeekEnd_ = 0, this.lastSeekEnd_ = -1, this.behindLiveEdge_ = !0, this.timeupdateSeen_ = !1, this.seekedBehindLive_ = !1, this.nextSeekedFromUser_ = !1, this.clearInterval(this.trackingInterval_), this.trackingInterval_ = null, this.off(this.player_, ["play", "pause"], this.trackLiveHandler_), this.off(this.player_, "seeked", this.handleSeeked_), this.off(this.player_, "play", this.handlePlay_), this.off(this.player_, "timeupdate", this.handleFirstTimeupdate_), this.off(this.player_, "timeupdate", this.seekToLiveEdge_);
                }, bi.nextSeekedFromUser = function() {
                  this.nextSeekedFromUser_ = !0;
                }, bi.stopTracking = function() {
                  this.isTracking() && (this.reset_(), this.trigger("liveedgechange"));
                }, bi.seekableEnd = function() {
                  for (var ci = this.player_.seekable(), hi = [], wi = ci ? ci.length : 0; wi--; )
                    hi.push(ci.end(wi));
                  return hi.length ? hi.sort()[hi.length - 1] : 1 / 0;
                }, bi.seekableStart = function() {
                  for (var ci = this.player_.seekable(), hi = [], wi = ci ? ci.length : 0; wi--; )
                    hi.push(ci.start(wi));
                  return hi.length ? hi.sort()[0] : 0;
                }, bi.liveWindow = function() {
                  var ci = this.liveCurrentTime();
                  return ci === 1 / 0 ? 0 : ci - this.seekableStart();
                }, bi.isLive = function() {
                  return this.isTracking();
                }, bi.atLiveEdge = function() {
                  return !this.behindLiveEdge();
                }, bi.liveCurrentTime = function() {
                  return this.pastSeekEnd() + this.seekableEnd();
                }, bi.pastSeekEnd = function() {
                  var ci = this.seekableEnd();
                  return this.lastSeekEnd_ !== -1 && ci !== this.lastSeekEnd_ && (this.pastSeekEnd_ = 0), this.lastSeekEnd_ = ci, this.pastSeekEnd_;
                }, bi.behindLiveEdge = function() {
                  return this.behindLiveEdge_;
                }, bi.isTracking = function() {
                  return typeof this.trackingInterval_ == "number";
                }, bi.seekToLiveEdge = function() {
                  this.seekedBehindLive_ = !1, !this.atLiveEdge() && (this.nextSeekedFromUser_ = !1, this.player_.currentTime(this.liveCurrentTime()));
                }, bi.dispose = function() {
                  this.off(gi(), "visibilitychange", this.handleVisibilityChange_), this.stopTracking(), Vi.prototype.dispose.call(this);
                }, Ei;
              })(ou);
              ou.registerComponent("LiveTracker", ju);
              var Yu = function(Ei) {
                var bi = Ei.el();
                if (bi.hasAttribute("src"))
                  return Ei.triggerSourceset(bi.src), !0;
                var yi = Ei.$$("source"), ci = [], hi = "";
                if (!yi.length)
                  return !1;
                for (var wi = 0; wi < yi.length; wi++) {
                  var zi = yi[wi].src;
                  zi && ci.indexOf(zi) === -1 && ci.push(zi);
                }
                return ci.length ? (ci.length === 1 && (hi = ci[0]), Ei.triggerSourceset(hi), !0) : !1;
              }, Lc = Object.defineProperty({}, "innerHTML", {
                get: function() {
                  return this.cloneNode(!0).innerHTML;
                },
                set: function(Ei) {
                  var bi = gi().createElement(this.nodeName.toLowerCase());
                  bi.innerHTML = Ei;
                  for (var yi = gi().createDocumentFragment(); bi.childNodes.length; )
                    yi.appendChild(bi.childNodes[0]);
                  return this.innerText = "", di().Element.prototype.appendChild.call(this, yi), this.innerHTML;
                }
              }), Ed = function(Ei, bi) {
                for (var yi = {}, ci = 0; ci < Ei.length && (yi = Object.getOwnPropertyDescriptor(Ei[ci], bi), !(yi && yi.set && yi.get)); ci++)
                  ;
                return yi.enumerable = !0, yi.configurable = !0, yi;
              }, tc = function(Ei) {
                return Ed([Ei.el(), di().HTMLMediaElement.prototype, di().Element.prototype, Lc], "innerHTML");
              }, bc = function(Ei) {
                var bi = Ei.el();
                if (!bi.resetSourceWatch_) {
                  var yi = {}, ci = tc(Ei), hi = function(zi) {
                    return function() {
                      for (var Wo = arguments.length, aa = new Array(Wo), Ea = 0; Ea < Wo; Ea++)
                        aa[Ea] = arguments[Ea];
                      var Ka = zi.apply(bi, aa);
                      return Yu(Ei), Ka;
                    };
                  };
                  ["append", "appendChild", "insertAdjacentHTML"].forEach(function(wi) {
                    bi[wi] && (yi[wi] = bi[wi], bi[wi] = hi(yi[wi]));
                  }), Object.defineProperty(bi, "innerHTML", Ec(ci, {
                    set: hi(ci.set)
                  })), bi.resetSourceWatch_ = function() {
                    bi.resetSourceWatch_ = null, Object.keys(yi).forEach(function(wi) {
                      bi[wi] = yi[wi];
                    }), Object.defineProperty(bi, "innerHTML", ci);
                  }, Ei.one("sourceset", bi.resetSourceWatch_);
                }
              }, ud = Object.defineProperty({}, "src", {
                get: function() {
                  return this.hasAttribute("src") ? Yd(di().Element.prototype.getAttribute.call(this, "src")) : "";
                },
                set: function(Ei) {
                  return di().Element.prototype.setAttribute.call(this, "src", Ei), Ei;
                }
              }), qf = function(Ei) {
                return Ed([Ei.el(), di().HTMLMediaElement.prototype, ud], "src");
              }, yd = function(Ei) {
                if (Ei.featuresSourceset) {
                  var bi = Ei.el();
                  if (!bi.resetSourceset_) {
                    var yi = qf(Ei), ci = bi.setAttribute, hi = bi.load;
                    Object.defineProperty(bi, "src", Ec(yi, {
                      set: function(zi) {
                        var Wo = yi.set.call(bi, zi);
                        return Ei.triggerSourceset(bi.src), Wo;
                      }
                    })), bi.setAttribute = function(wi, zi) {
                      var Wo = ci.call(bi, wi, zi);
                      return /src/i.test(wi) && Ei.triggerSourceset(bi.src), Wo;
                    }, bi.load = function() {
                      var wi = hi.call(bi);
                      return Yu(Ei) || (Ei.triggerSourceset(""), bc(Ei)), wi;
                    }, bi.currentSrc ? Ei.triggerSourceset(bi.currentSrc) : Yu(Ei) || bc(Ei), bi.resetSourceset_ = function() {
                      bi.resetSourceset_ = null, bi.load = hi, bi.setAttribute = ci, Object.defineProperty(bi, "src", yi), bi.resetSourceWatch_ && bi.resetSourceWatch_();
                    };
                  }
                }
              }, Id = function(Ei, bi, yi, ci) {
                ci === void 0 && (ci = !0);
                var hi = function(Wo) {
                  return Object.defineProperty(Ei, bi, {
                    value: Wo,
                    enumerable: !0,
                    writable: !0
                  });
                }, wi = {
                  configurable: !0,
                  enumerable: !0,
                  get: function() {
                    var Wo = yi();
                    return hi(Wo), Wo;
                  }
                };
                return ci && (wi.set = hi), Object.defineProperty(Ei, bi, wi);
              }, vu = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  hi = Vi.call(this, yi, ci) || this;
                  var wi = yi.source, zi = !1;
                  if (hi.featuresVideoFrameCallback = hi.featuresVideoFrameCallback && hi.el_.tagName === "VIDEO", wi && (hi.el_.currentSrc !== wi.src || yi.tag && yi.tag.initNetworkState_ === 3) ? hi.setSource(wi) : hi.handleLateInit_(hi.el_), yi.enableSourceset && hi.setupSourcesetHandling_(), hi.isScrubbing_ = !1, hi.el_.hasChildNodes()) {
                    for (var Wo = hi.el_.childNodes, aa = Wo.length, Ea = []; aa--; ) {
                      var Ka = Wo[aa], Ha = Ka.nodeName.toLowerCase();
                      Ha === "track" && (hi.featuresNativeTextTracks ? (hi.remoteTextTrackEls().addTrackElement_(Ka), hi.remoteTextTracks().addTrack(Ka.track), hi.textTracks().addTrack(Ka.track), !zi && !hi.el_.hasAttribute("crossorigin") && Ef(Ka.src) && (zi = !0)) : Ea.push(Ka));
                    }
                    for (var ks = 0; ks < Ea.length; ks++)
                      hi.el_.removeChild(Ea[ks]);
                  }
                  return hi.proxyNativeTracks_(), hi.featuresNativeTextTracks && zi && Xa.warn(`Text Tracks are being loaded from another origin but the crossorigin attribute isn't used.
This may prevent text tracks from loading.`), hi.restoreMetadataTracksInIOSNativePlayer_(), (Ul || hu || Is) && yi.nativeControlsForTouch === !0 && hi.setControls(!0), hi.proxyWebkitFullscreen_(), hi.triggerReady(), hi;
                }
                var bi = Ei.prototype;
                return bi.dispose = function() {
                  this.el_ && this.el_.resetSourceset_ && this.el_.resetSourceset_(), Ei.disposeMediaElement(this.el_), this.options_ = null, Vi.prototype.dispose.call(this);
                }, bi.setupSourcesetHandling_ = function() {
                  yd(this);
                }, bi.restoreMetadataTracksInIOSNativePlayer_ = function() {
                  var ci = this.textTracks(), hi, wi = function() {
                    hi = [];
                    for (var aa = 0; aa < ci.length; aa++) {
                      var Ea = ci[aa];
                      Ea.kind === "metadata" && hi.push({
                        track: Ea,
                        storedMode: Ea.mode
                      });
                    }
                  };
                  wi(), ci.addEventListener("change", wi), this.on("dispose", function() {
                    return ci.removeEventListener("change", wi);
                  });
                  var zi = function Wo() {
                    for (var aa = 0; aa < hi.length; aa++) {
                      var Ea = hi[aa];
                      Ea.track.mode === "disabled" && Ea.track.mode !== Ea.storedMode && (Ea.track.mode = Ea.storedMode);
                    }
                    ci.removeEventListener("change", Wo);
                  };
                  this.on("webkitbeginfullscreen", function() {
                    ci.removeEventListener("change", wi), ci.removeEventListener("change", zi), ci.addEventListener("change", zi);
                  }), this.on("webkitendfullscreen", function() {
                    ci.removeEventListener("change", wi), ci.addEventListener("change", wi), ci.removeEventListener("change", zi);
                  });
                }, bi.overrideNative_ = function(ci, hi) {
                  var wi = this;
                  if (hi === this["featuresNative" + ci + "Tracks"]) {
                    var zi = ci.toLowerCase();
                    this[zi + "TracksListeners_"] && Object.keys(this[zi + "TracksListeners_"]).forEach(function(Wo) {
                      var aa = wi.el()[zi + "Tracks"];
                      aa.removeEventListener(Wo, wi[zi + "TracksListeners_"][Wo]);
                    }), this["featuresNative" + ci + "Tracks"] = !hi, this[zi + "TracksListeners_"] = null, this.proxyNativeTracksForType_(zi);
                  }
                }, bi.overrideNativeAudioTracks = function(ci) {
                  this.overrideNative_("Audio", ci);
                }, bi.overrideNativeVideoTracks = function(ci) {
                  this.overrideNative_("Video", ci);
                }, bi.proxyNativeTracksForType_ = function(ci) {
                  var hi = this, wi = gd[ci], zi = this.el()[wi.getterName], Wo = this[wi.getterName]();
                  if (!(!this["featuresNative" + wi.capitalName + "Tracks"] || !zi || !zi.addEventListener)) {
                    var aa = {
                      change: function(Ha) {
                        var ks = {
                          type: "change",
                          target: Wo,
                          currentTarget: Wo,
                          srcElement: Wo
                        };
                        Wo.trigger(ks), ci === "text" && hi[Sf.remoteText.getterName]().trigger(ks);
                      },
                      addtrack: function(Ha) {
                        Wo.addTrack(Ha.track);
                      },
                      removetrack: function(Ha) {
                        Wo.removeTrack(Ha.track);
                      }
                    }, Ea = function() {
                      for (var Ha = [], ks = 0; ks < Wo.length; ks++) {
                        for (var gl = !1, Sl = 0; Sl < zi.length; Sl++)
                          if (zi[Sl] === Wo[ks]) {
                            gl = !0;
                            break;
                          }
                        gl || Ha.push(Wo[ks]);
                      }
                      for (; Ha.length; )
                        Wo.removeTrack(Ha.shift());
                    };
                    this[wi.getterName + "Listeners_"] = aa, Object.keys(aa).forEach(function(Ka) {
                      var Ha = aa[Ka];
                      zi.addEventListener(Ka, Ha), hi.on("dispose", function(ks) {
                        return zi.removeEventListener(Ka, Ha);
                      });
                    }), this.on("loadstart", Ea), this.on("dispose", function(Ka) {
                      return hi.off("loadstart", Ea);
                    });
                  }
                }, bi.proxyNativeTracks_ = function() {
                  var ci = this;
                  gd.names.forEach(function(hi) {
                    ci.proxyNativeTracksForType_(hi);
                  });
                }, bi.createEl = function() {
                  var ci = this.options_.tag;
                  if (!ci || !(this.options_.playerElIngest || this.movingMediaElementInDOM)) {
                    if (ci) {
                      var hi = ci.cloneNode(!0);
                      ci.parentNode && ci.parentNode.insertBefore(hi, ci), Ei.disposeMediaElement(ci), ci = hi;
                    } else {
                      ci = gi().createElement("video");
                      var wi = this.options_.tag && tu(this.options_.tag), zi = Ec({}, wi);
                      (!Ul || this.options_.nativeControlsForTouch !== !0) && delete zi.controls, Zl(ci, Ta(zi, {
                        id: this.options_.techId,
                        class: "vjs-tech"
                      }));
                    }
                    ci.playerId = this.options_.playerId;
                  }
                  typeof this.options_.preload < "u" && dl(ci, "preload", this.options_.preload), this.options_.disablePictureInPicture !== void 0 && (ci.disablePictureInPicture = this.options_.disablePictureInPicture);
                  for (var Wo = ["loop", "muted", "playsinline", "autoplay"], aa = 0; aa < Wo.length; aa++) {
                    var Ea = Wo[aa], Ka = this.options_[Ea];
                    typeof Ka < "u" && (Ka ? dl(ci, Ea, Ea) : Su(ci, Ea), ci[Ea] = Ka);
                  }
                  return ci;
                }, bi.handleLateInit_ = function(ci) {
                  if (!(ci.networkState === 0 || ci.networkState === 3)) {
                    if (ci.readyState === 0) {
                      var hi = !1, wi = function() {
                        hi = !0;
                      };
                      this.on("loadstart", wi);
                      var zi = function() {
                        hi || this.trigger("loadstart");
                      };
                      this.on("loadedmetadata", zi), this.ready(function() {
                        this.off("loadstart", wi), this.off("loadedmetadata", zi), hi || this.trigger("loadstart");
                      });
                      return;
                    }
                    var Wo = ["loadstart"];
                    Wo.push("loadedmetadata"), ci.readyState >= 2 && Wo.push("loadeddata"), ci.readyState >= 3 && Wo.push("canplay"), ci.readyState >= 4 && Wo.push("canplaythrough"), this.ready(function() {
                      Wo.forEach(function(aa) {
                        this.trigger(aa);
                      }, this);
                    });
                  }
                }, bi.setScrubbing = function(ci) {
                  this.isScrubbing_ = ci;
                }, bi.scrubbing = function() {
                  return this.isScrubbing_;
                }, bi.setCurrentTime = function(ci) {
                  try {
                    this.isScrubbing_ && this.el_.fastSeek && Ku ? this.el_.fastSeek(ci) : this.el_.currentTime = ci;
                  } catch (hi) {
                    Xa(hi, "Video is not ready. (Video.js)");
                  }
                }, bi.duration = function() {
                  var ci = this;
                  if (this.el_.duration === 1 / 0 && Vs && Il && this.el_.currentTime === 0) {
                    var hi = function wi() {
                      ci.el_.currentTime > 0 && (ci.el_.duration === 1 / 0 && ci.trigger("durationchange"), ci.off("timeupdate", wi));
                    };
                    return this.on("timeupdate", hi), NaN;
                  }
                  return this.el_.duration || NaN;
                }, bi.width = function() {
                  return this.el_.offsetWidth;
                }, bi.height = function() {
                  return this.el_.offsetHeight;
                }, bi.proxyWebkitFullscreen_ = function() {
                  var ci = this;
                  if ("webkitDisplayingFullscreen" in this.el_) {
                    var hi = function() {
                      this.trigger("fullscreenchange", {
                        isFullscreen: !1
                      }), this.el_.controls && !this.options_.nativeControlsForTouch && this.controls() && (this.el_.controls = !1);
                    }, wi = function() {
                      "webkitPresentationMode" in this.el_ && this.el_.webkitPresentationMode !== "picture-in-picture" && (this.one("webkitendfullscreen", hi), this.trigger("fullscreenchange", {
                        isFullscreen: !0,
                        // set a flag in case another tech triggers fullscreenchange
                        nativeIOSFullscreen: !0
                      }));
                    };
                    this.on("webkitbeginfullscreen", wi), this.on("dispose", function() {
                      ci.off("webkitbeginfullscreen", wi), ci.off("webkitendfullscreen", hi);
                    });
                  }
                }, bi.supportsFullScreen = function() {
                  if (typeof this.el_.webkitEnterFullScreen == "function") {
                    var ci = di().navigator && di().navigator.userAgent || "";
                    if (/Android/.test(ci) || !/Chrome|Mac OS X 10.5/.test(ci))
                      return !0;
                  }
                  return !1;
                }, bi.enterFullScreen = function() {
                  var ci = this.el_;
                  if (ci.paused && ci.networkState <= ci.HAVE_METADATA)
                    wd(this.el_.play()), this.setTimeout(function() {
                      ci.pause();
                      try {
                        ci.webkitEnterFullScreen();
                      } catch (hi) {
                        this.trigger("fullscreenerror", hi);
                      }
                    }, 0);
                  else
                    try {
                      ci.webkitEnterFullScreen();
                    } catch (hi) {
                      this.trigger("fullscreenerror", hi);
                    }
                }, bi.exitFullScreen = function() {
                  if (!this.el_.webkitDisplayingFullscreen) {
                    this.trigger("fullscreenerror", new Error("The video is not fullscreen"));
                    return;
                  }
                  this.el_.webkitExitFullScreen();
                }, bi.requestPictureInPicture = function() {
                  return this.el_.requestPictureInPicture();
                }, bi.requestVideoFrameCallback = function(ci) {
                  return this.featuresVideoFrameCallback && !this.el_.webkitKeys ? this.el_.requestVideoFrameCallback(ci) : Vi.prototype.requestVideoFrameCallback.call(this, ci);
                }, bi.cancelVideoFrameCallback = function(ci) {
                  this.featuresVideoFrameCallback && !this.el_.webkitKeys ? this.el_.cancelVideoFrameCallback(ci) : Vi.prototype.cancelVideoFrameCallback.call(this, ci);
                }, bi.src = function(ci) {
                  if (ci === void 0)
                    return this.el_.src;
                  this.setSrc(ci);
                }, bi.reset = function() {
                  Ei.resetMediaElement(this.el_);
                }, bi.currentSrc = function() {
                  return this.currentSource_ ? this.currentSource_.src : this.el_.currentSrc;
                }, bi.setControls = function(ci) {
                  this.el_.controls = !!ci;
                }, bi.addTextTrack = function(ci, hi, wi) {
                  return this.featuresNativeTextTracks ? this.el_.addTextTrack(ci, hi, wi) : Vi.prototype.addTextTrack.call(this, ci, hi, wi);
                }, bi.createRemoteTextTrack = function(ci) {
                  if (!this.featuresNativeTextTracks)
                    return Vi.prototype.createRemoteTextTrack.call(this, ci);
                  var hi = gi().createElement("track");
                  return ci.kind && (hi.kind = ci.kind), ci.label && (hi.label = ci.label), (ci.language || ci.srclang) && (hi.srclang = ci.language || ci.srclang), ci.default && (hi.default = ci.default), ci.id && (hi.id = ci.id), ci.src && (hi.src = ci.src), hi;
                }, bi.addRemoteTextTrack = function(ci, hi) {
                  var wi = Vi.prototype.addRemoteTextTrack.call(this, ci, hi);
                  return this.featuresNativeTextTracks && this.el().appendChild(wi), wi;
                }, bi.removeRemoteTextTrack = function(ci) {
                  if (Vi.prototype.removeRemoteTextTrack.call(this, ci), this.featuresNativeTextTracks)
                    for (var hi = this.$$("track"), wi = hi.length; wi--; )
                      (ci === hi[wi] || ci === hi[wi].track) && this.el().removeChild(hi[wi]);
                }, bi.getVideoPlaybackQuality = function() {
                  if (typeof this.el().getVideoPlaybackQuality == "function")
                    return this.el().getVideoPlaybackQuality();
                  var ci = {};
                  return typeof this.el().webkitDroppedFrameCount < "u" && typeof this.el().webkitDecodedFrameCount < "u" && (ci.droppedVideoFrames = this.el().webkitDroppedFrameCount, ci.totalVideoFrames = this.el().webkitDecodedFrameCount), di().performance && typeof di().performance.now == "function" ? ci.creationTime = di().performance.now() : di().performance && di().performance.timing && typeof di().performance.timing.navigationStart == "number" && (ci.creationTime = di().Date.now() - di().performance.timing.navigationStart), ci;
                }, Ei;
              })(Sc);
              Id(vu, "TEST_VID", function() {
                if (Ya()) {
                  var Vi = gi().createElement("video"), Ei = gi().createElement("track");
                  return Ei.kind = "captions", Ei.srclang = "en", Ei.label = "English", Vi.appendChild(Ei), Vi;
                }
              }), vu.isSupported = function() {
                try {
                  vu.TEST_VID.volume = 0.5;
                } catch {
                  return !1;
                }
                return !!(vu.TEST_VID && vu.TEST_VID.canPlayType);
              }, vu.canPlayType = function(Vi) {
                return vu.TEST_VID.canPlayType(Vi);
              }, vu.canPlaySource = function(Vi, Ei) {
                return vu.canPlayType(Vi.type);
              }, vu.canControlVolume = function() {
                try {
                  var Vi = vu.TEST_VID.volume;
                  vu.TEST_VID.volume = Vi / 2 + 0.1;
                  var Ei = Vi !== vu.TEST_VID.volume;
                  return Ei && Tu ? (di().setTimeout(function() {
                    vu && vu.prototype && (vu.prototype.featuresVolumeControl = Vi !== vu.TEST_VID.volume);
                  }), !1) : Ei;
                } catch {
                  return !1;
                }
              }, vu.canMuteVolume = function() {
                try {
                  var Vi = vu.TEST_VID.muted;
                  return vu.TEST_VID.muted = !Vi, vu.TEST_VID.muted ? dl(vu.TEST_VID, "muted", "muted") : Su(vu.TEST_VID, "muted", "muted"), Vi !== vu.TEST_VID.muted;
                } catch {
                  return !1;
                }
              }, vu.canControlPlaybackRate = function() {
                if (Vs && Il && Vl < 58)
                  return !1;
                try {
                  var Vi = vu.TEST_VID.playbackRate;
                  return vu.TEST_VID.playbackRate = Vi / 2 + 0.1, Vi !== vu.TEST_VID.playbackRate;
                } catch {
                  return !1;
                }
              }, vu.canOverrideAttributes = function() {
                try {
                  var Vi = function() {
                  };
                  Object.defineProperty(gi().createElement("video"), "src", {
                    get: Vi,
                    set: Vi
                  }), Object.defineProperty(gi().createElement("audio"), "src", {
                    get: Vi,
                    set: Vi
                  }), Object.defineProperty(gi().createElement("video"), "innerHTML", {
                    get: Vi,
                    set: Vi
                  }), Object.defineProperty(gi().createElement("audio"), "innerHTML", {
                    get: Vi,
                    set: Vi
                  });
                } catch {
                  return !1;
                }
                return !0;
              }, vu.supportsNativeTextTracks = function() {
                return Ku || Tu && Il;
              }, vu.supportsNativeVideoTracks = function() {
                return !!(vu.TEST_VID && vu.TEST_VID.videoTracks);
              }, vu.supportsNativeAudioTracks = function() {
                return !!(vu.TEST_VID && vu.TEST_VID.audioTracks);
              }, vu.Events = ["loadstart", "suspend", "abort", "error", "emptied", "stalled", "loadedmetadata", "loadeddata", "canplay", "canplaythrough", "playing", "waiting", "seeking", "seeked", "ended", "durationchange", "timeupdate", "progress", "play", "pause", "ratechange", "resize", "volumechange"], [["featuresMuteControl", "canMuteVolume"], ["featuresPlaybackRate", "canControlPlaybackRate"], ["featuresSourceset", "canOverrideAttributes"], ["featuresNativeTextTracks", "supportsNativeTextTracks"], ["featuresNativeVideoTracks", "supportsNativeVideoTracks"], ["featuresNativeAudioTracks", "supportsNativeAudioTracks"]].forEach(function(Vi) {
                var Ei = Vi[0], bi = Vi[1];
                Id(vu.prototype, Ei, function() {
                  return vu[bi]();
                }, !0);
              }), vu.prototype.featuresVolumeControl = vu.canControlVolume(), vu.prototype.movingMediaElementInDOM = !Tu, vu.prototype.featuresFullscreenResize = !0, vu.prototype.featuresProgressEvents = !0, vu.prototype.featuresTimeupdateEvents = !0, vu.prototype.featuresVideoFrameCallback = !!(vu.TEST_VID && vu.TEST_VID.requestVideoFrameCallback);
              var Cg;
              vu.patchCanPlayType = function() {
                es >= 4 && !fl && !Il && (Cg = vu.TEST_VID && vu.TEST_VID.constructor.prototype.canPlayType, vu.TEST_VID.constructor.prototype.canPlayType = function(Vi) {
                  var Ei = /^application\/(?:x-|vnd\.apple\.)mpegurl/i;
                  return Vi && Ei.test(Vi) ? "maybe" : Cg.call(this, Vi);
                });
              }, vu.unpatchCanPlayType = function() {
                var Vi = vu.TEST_VID.constructor.prototype.canPlayType;
                return Cg && (vu.TEST_VID.constructor.prototype.canPlayType = Cg), Vi;
              }, vu.patchCanPlayType(), vu.disposeMediaElement = function(Vi) {
                if (Vi) {
                  for (Vi.parentNode && Vi.parentNode.removeChild(Vi); Vi.hasChildNodes(); )
                    Vi.removeChild(Vi.firstChild);
                  Vi.removeAttribute("src"), typeof Vi.load == "function" && (function() {
                    try {
                      Vi.load();
                    } catch {
                    }
                  })();
                }
              }, vu.resetMediaElement = function(Vi) {
                if (Vi) {
                  for (var Ei = Vi.querySelectorAll("source"), bi = Ei.length; bi--; )
                    Vi.removeChild(Ei[bi]);
                  Vi.removeAttribute("src"), typeof Vi.load == "function" && (function() {
                    try {
                      Vi.load();
                    } catch {
                    }
                  })();
                }
              }, [
                /**
                 * Get the value of `muted` from the media element. `muted` indicates
                 * that the volume for the media should be set to silent. This does not actually change
                 * the `volume` attribute.
                 *
                 * @method Html5#muted
                 * @return {boolean}
                 *         - True if the value of `volume` should be ignored and the audio set to silent.
                 *         - False if the value of `volume` should be used.
                 *
                 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
                 */
                "muted",
                /**
                 * Get the value of `defaultMuted` from the media element. `defaultMuted` indicates
                 * whether the media should start muted or not. Only changes the default state of the
                 * media. `muted` and `defaultMuted` can have different values. {@link Html5#muted} indicates the
                 * current state.
                 *
                 * @method Html5#defaultMuted
                 * @return {boolean}
                 *         - The value of `defaultMuted` from the media element.
                 *         - True indicates that the media should start muted.
                 *         - False indicates that the media should not start muted
                 *
                 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
                 */
                "defaultMuted",
                /**
                 * Get the value of `autoplay` from the media element. `autoplay` indicates
                 * that the media should start to play as soon as the page is ready.
                 *
                 * @method Html5#autoplay
                 * @return {boolean}
                 *         - The value of `autoplay` from the media element.
                 *         - True indicates that the media should start as soon as the page loads.
                 *         - False indicates that the media should not start as soon as the page loads.
                 *
                 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
                 */
                "autoplay",
                /**
                 * Get the value of `controls` from the media element. `controls` indicates
                 * whether the native media controls should be shown or hidden.
                 *
                 * @method Html5#controls
                 * @return {boolean}
                 *         - The value of `controls` from the media element.
                 *         - True indicates that native controls should be showing.
                 *         - False indicates that native controls should be hidden.
                 *
                 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-controls}
                 */
                "controls",
                /**
                 * Get the value of `loop` from the media element. `loop` indicates
                 * that the media should return to the start of the media and continue playing once
                 * it reaches the end.
                 *
                 * @method Html5#loop
                 * @return {boolean}
                 *         - The value of `loop` from the media element.
                 *         - True indicates that playback should seek back to start once
                 *           the end of a media is reached.
                 *         - False indicates that playback should not loop back to the start when the
                 *           end of the media is reached.
                 *
                 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
                 */
                "loop",
                /**
                 * Get the value of `playsinline` from the media element. `playsinline` indicates
                 * to the browser that non-fullscreen playback is preferred when fullscreen
                 * playback is the native default, such as in iOS Safari.
                 *
                 * @method Html5#playsinline
                 * @return {boolean}
                 *         - The value of `playsinline` from the media element.
                 *         - True indicates that the media should play inline.
                 *         - False indicates that the media should not play inline.
                 *
                 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
                 */
                "playsinline"
              ].forEach(function(Vi) {
                vu.prototype[Vi] = function() {
                  return this.el_[Vi] || this.el_.hasAttribute(Vi);
                };
              }), [
                /**
                 * Set the value of `muted` on the media element. `muted` indicates that the current
                 * audio level should be silent.
                 *
                 * @method Html5#setMuted
                 * @param {boolean} muted
                 *        - True if the audio should be set to silent
                 *        - False otherwise
                 *
                 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
                 */
                "muted",
                /**
                 * Set the value of `defaultMuted` on the media element. `defaultMuted` indicates that the current
                 * audio level should be silent, but will only effect the muted level on initial playback..
                 *
                 * @method Html5.prototype.setDefaultMuted
                 * @param {boolean} defaultMuted
                 *        - True if the audio should be set to silent
                 *        - False otherwise
                 *
                 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
                 */
                "defaultMuted",
                /**
                 * Set the value of `autoplay` on the media element. `autoplay` indicates
                 * that the media should start to play as soon as the page is ready.
                 *
                 * @method Html5#setAutoplay
                 * @param {boolean} autoplay
                 *         - True indicates that the media should start as soon as the page loads.
                 *         - False indicates that the media should not start as soon as the page loads.
                 *
                 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
                 */
                "autoplay",
                /**
                 * Set the value of `loop` on the media element. `loop` indicates
                 * that the media should return to the start of the media and continue playing once
                 * it reaches the end.
                 *
                 * @method Html5#setLoop
                 * @param {boolean} loop
                 *         - True indicates that playback should seek back to start once
                 *           the end of a media is reached.
                 *         - False indicates that playback should not loop back to the start when the
                 *           end of the media is reached.
                 *
                 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
                 */
                "loop",
                /**
                 * Set the value of `playsinline` from the media element. `playsinline` indicates
                 * to the browser that non-fullscreen playback is preferred when fullscreen
                 * playback is the native default, such as in iOS Safari.
                 *
                 * @method Html5#setPlaysinline
                 * @param {boolean} playsinline
                 *         - True indicates that the media should play inline.
                 *         - False indicates that the media should not play inline.
                 *
                 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
                 */
                "playsinline"
              ].forEach(function(Vi) {
                vu.prototype["set" + Ic(Vi)] = function(Ei) {
                  this.el_[Vi] = Ei, Ei ? this.el_.setAttribute(Vi, Vi) : this.el_.removeAttribute(Vi);
                };
              }), [
                /**
                 * Get the value of `paused` from the media element. `paused` indicates whether the media element
                 * is currently paused or not.
                 *
                 * @method Html5#paused
                 * @return {boolean}
                 *         The value of `paused` from the media element.
                 *
                 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-paused}
                 */
                "paused",
                /**
                 * Get the value of `currentTime` from the media element. `currentTime` indicates
                 * the current second that the media is at in playback.
                 *
                 * @method Html5#currentTime
                 * @return {number}
                 *         The value of `currentTime` from the media element.
                 *
                 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-currenttime}
                 */
                "currentTime",
                /**
                 * Get the value of `buffered` from the media element. `buffered` is a `TimeRange`
                 * object that represents the parts of the media that are already downloaded and
                 * available for playback.
                 *
                 * @method Html5#buffered
                 * @return {TimeRange}
                 *         The value of `buffered` from the media element.
                 *
                 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-buffered}
                 */
                "buffered",
                /**
                 * Get the value of `volume` from the media element. `volume` indicates
                 * the current playback volume of audio for a media. `volume` will be a value from 0
                 * (silent) to 1 (loudest and default).
                 *
                 * @method Html5#volume
                 * @return {number}
                 *         The value of `volume` from the media element. Value will be between 0-1.
                 *
                 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
                 */
                "volume",
                /**
                 * Get the value of `poster` from the media element. `poster` indicates
                 * that the url of an image file that can/will be shown when no media data is available.
                 *
                 * @method Html5#poster
                 * @return {string}
                 *         The value of `poster` from the media element. Value will be a url to an
                 *         image.
                 *
                 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-video-poster}
                 */
                "poster",
                /**
                 * Get the value of `preload` from the media element. `preload` indicates
                 * what should download before the media is interacted with. It can have the following
                 * values:
                 * - none: nothing should be downloaded
                 * - metadata: poster and the first few frames of the media may be downloaded to get
                 *   media dimensions and other metadata
                 * - auto: allow the media and metadata for the media to be downloaded before
                 *    interaction
                 *
                 * @method Html5#preload
                 * @return {string}
                 *         The value of `preload` from the media element. Will be 'none', 'metadata',
                 *         or 'auto'.
                 *
                 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
                 */
                "preload",
                /**
                 * Get the value of the `error` from the media element. `error` indicates any
                 * MediaError that may have occurred during playback. If error returns null there is no
                 * current error.
                 *
                 * @method Html5#error
                 * @return {MediaError|null}
                 *         The value of `error` from the media element. Will be `MediaError` if there
                 *         is a current error and null otherwise.
                 *
                 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-error}
                 */
                "error",
                /**
                 * Get the value of `seeking` from the media element. `seeking` indicates whether the
                 * media is currently seeking to a new position or not.
                 *
                 * @method Html5#seeking
                 * @return {boolean}
                 *         - The value of `seeking` from the media element.
                 *         - True indicates that the media is currently seeking to a new position.
                 *         - False indicates that the media is not seeking to a new position at this time.
                 *
                 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seeking}
                 */
                "seeking",
                /**
                 * Get the value of `seekable` from the media element. `seekable` returns a
                 * `TimeRange` object indicating ranges of time that can currently be `seeked` to.
                 *
                 * @method Html5#seekable
                 * @return {TimeRange}
                 *         The value of `seekable` from the media element. A `TimeRange` object
                 *         indicating the current ranges of time that can be seeked to.
                 *
                 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seekable}
                 */
                "seekable",
                /**
                 * Get the value of `ended` from the media element. `ended` indicates whether
                 * the media has reached the end or not.
                 *
                 * @method Html5#ended
                 * @return {boolean}
                 *         - The value of `ended` from the media element.
                 *         - True indicates that the media has ended.
                 *         - False indicates that the media has not ended.
                 *
                 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-ended}
                 */
                "ended",
                /**
                 * Get the value of `playbackRate` from the media element. `playbackRate` indicates
                 * the rate at which the media is currently playing back. Examples:
                 *   - if playbackRate is set to 2, media will play twice as fast.
                 *   - if playbackRate is set to 0.5, media will play half as fast.
                 *
                 * @method Html5#playbackRate
                 * @return {number}
                 *         The value of `playbackRate` from the media element. A number indicating
                 *         the current playback speed of the media, where 1 is normal speed.
                 *
                 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
                 */
                "playbackRate",
                /**
                 * Get the value of `defaultPlaybackRate` from the media element. `defaultPlaybackRate` indicates
                 * the rate at which the media is currently playing back. This value will not indicate the current
                 * `playbackRate` after playback has started, use {@link Html5#playbackRate} for that.
                 *
                 * Examples:
                 *   - if defaultPlaybackRate is set to 2, media will play twice as fast.
                 *   - if defaultPlaybackRate is set to 0.5, media will play half as fast.
                 *
                 * @method Html5.prototype.defaultPlaybackRate
                 * @return {number}
                 *         The value of `defaultPlaybackRate` from the media element. A number indicating
                 *         the current playback speed of the media, where 1 is normal speed.
                 *
                 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
                 */
                "defaultPlaybackRate",
                /**
                 * Get the value of 'disablePictureInPicture' from the video element.
                 *
                 * @method Html5#disablePictureInPicture
                 * @return {boolean} value
                 *         - The value of `disablePictureInPicture` from the video element.
                 *         - True indicates that the video can't be played in Picture-In-Picture mode
                 *         - False indicates that the video can be played in Picture-In-Picture mode
                 *
                 * @see [Spec]{@link https://w3c.github.io/picture-in-picture/#disable-pip}
                 */
                "disablePictureInPicture",
                /**
                 * Get the value of `played` from the media element. `played` returns a `TimeRange`
                 * object representing points in the media timeline that have been played.
                 *
                 * @method Html5#played
                 * @return {TimeRange}
                 *         The value of `played` from the media element. A `TimeRange` object indicating
                 *         the ranges of time that have been played.
                 *
                 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-played}
                 */
                "played",
                /**
                 * Get the value of `networkState` from the media element. `networkState` indicates
                 * the current network state. It returns an enumeration from the following list:
                 * - 0: NETWORK_EMPTY
                 * - 1: NETWORK_IDLE
                 * - 2: NETWORK_LOADING
                 * - 3: NETWORK_NO_SOURCE
                 *
                 * @method Html5#networkState
                 * @return {number}
                 *         The value of `networkState` from the media element. This will be a number
                 *         from the list in the description.
                 *
                 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-networkstate}
                 */
                "networkState",
                /**
                 * Get the value of `readyState` from the media element. `readyState` indicates
                 * the current state of the media element. It returns an enumeration from the
                 * following list:
                 * - 0: HAVE_NOTHING
                 * - 1: HAVE_METADATA
                 * - 2: HAVE_CURRENT_DATA
                 * - 3: HAVE_FUTURE_DATA
                 * - 4: HAVE_ENOUGH_DATA
                 *
                 * @method Html5#readyState
                 * @return {number}
                 *         The value of `readyState` from the media element. This will be a number
                 *         from the list in the description.
                 *
                 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#ready-states}
                 */
                "readyState",
                /**
                 * Get the value of `videoWidth` from the video element. `videoWidth` indicates
                 * the current width of the video in css pixels.
                 *
                 * @method Html5#videoWidth
                 * @return {number}
                 *         The value of `videoWidth` from the video element. This will be a number
                 *         in css pixels.
                 *
                 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
                 */
                "videoWidth",
                /**
                 * Get the value of `videoHeight` from the video element. `videoHeight` indicates
                 * the current height of the video in css pixels.
                 *
                 * @method Html5#videoHeight
                 * @return {number}
                 *         The value of `videoHeight` from the video element. This will be a number
                 *         in css pixels.
                 *
                 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
                 */
                "videoHeight",
                /**
                 * Get the value of `crossOrigin` from the media element. `crossOrigin` indicates
                 * to the browser that should sent the cookies along with the requests for the
                 * different assets/playlists
                 *
                 * @method Html5#crossOrigin
                 * @return {string}
                 *         - anonymous indicates that the media should not sent cookies.
                 *         - use-credentials indicates that the media should sent cookies along the requests.
                 *
                 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-media-crossorigin}
                 */
                "crossOrigin"
              ].forEach(function(Vi) {
                vu.prototype[Vi] = function() {
                  return this.el_[Vi];
                };
              }), [
                /**
                 * Set the value of `volume` on the media element. `volume` indicates the current
                 * audio level as a percentage in decimal form. This means that 1 is 100%, 0.5 is 50%, and
                 * so on.
                 *
                 * @method Html5#setVolume
                 * @param {number} percentAsDecimal
                 *        The volume percent as a decimal. Valid range is from 0-1.
                 *
                 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
                 */
                "volume",
                /**
                 * Set the value of `src` on the media element. `src` indicates the current
                 * {@link Tech~SourceObject} for the media.
                 *
                 * @method Html5#setSrc
                 * @param {Tech~SourceObject} src
                 *        The source object to set as the current source.
                 *
                 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-src}
                 */
                "src",
                /**
                 * Set the value of `poster` on the media element. `poster` is the url to
                 * an image file that can/will be shown when no media data is available.
                 *
                 * @method Html5#setPoster
                 * @param {string} poster
                 *        The url to an image that should be used as the `poster` for the media
                 *        element.
                 *
                 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-poster}
                 */
                "poster",
                /**
                 * Set the value of `preload` on the media element. `preload` indicates
                 * what should download before the media is interacted with. It can have the following
                 * values:
                 * - none: nothing should be downloaded
                 * - metadata: poster and the first few frames of the media may be downloaded to get
                 *   media dimensions and other metadata
                 * - auto: allow the media and metadata for the media to be downloaded before
                 *    interaction
                 *
                 * @method Html5#setPreload
                 * @param {string} preload
                 *         The value of `preload` to set on the media element. Must be 'none', 'metadata',
                 *         or 'auto'.
                 *
                 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
                 */
                "preload",
                /**
                 * Set the value of `playbackRate` on the media element. `playbackRate` indicates
                 * the rate at which the media should play back. Examples:
                 *   - if playbackRate is set to 2, media will play twice as fast.
                 *   - if playbackRate is set to 0.5, media will play half as fast.
                 *
                 * @method Html5#setPlaybackRate
                 * @return {number}
                 *         The value of `playbackRate` from the media element. A number indicating
                 *         the current playback speed of the media, where 1 is normal speed.
                 *
                 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
                 */
                "playbackRate",
                /**
                 * Set the value of `defaultPlaybackRate` on the media element. `defaultPlaybackRate` indicates
                 * the rate at which the media should play back upon initial startup. Changing this value
                 * after a video has started will do nothing. Instead you should used {@link Html5#setPlaybackRate}.
                 *
                 * Example Values:
                 *   - if playbackRate is set to 2, media will play twice as fast.
                 *   - if playbackRate is set to 0.5, media will play half as fast.
                 *
                 * @method Html5.prototype.setDefaultPlaybackRate
                 * @return {number}
                 *         The value of `defaultPlaybackRate` from the media element. A number indicating
                 *         the current playback speed of the media, where 1 is normal speed.
                 *
                 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultplaybackrate}
                 */
                "defaultPlaybackRate",
                /**
                 * Prevents the browser from suggesting a Picture-in-Picture context menu
                 * or to request Picture-in-Picture automatically in some cases.
                 *
                 * @method Html5#setDisablePictureInPicture
                 * @param {boolean} value
                 *         The true value will disable Picture-in-Picture mode.
                 *
                 * @see [Spec]{@link https://w3c.github.io/picture-in-picture/#disable-pip}
                 */
                "disablePictureInPicture",
                /**
                 * Set the value of `crossOrigin` from the media element. `crossOrigin` indicates
                 * to the browser that should sent the cookies along with the requests for the
                 * different assets/playlists
                 *
                 * @method Html5#setCrossOrigin
                 * @param {string} crossOrigin
                 *         - anonymous indicates that the media should not sent cookies.
                 *         - use-credentials indicates that the media should sent cookies along the requests.
                 *
                 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-media-crossorigin}
                 */
                "crossOrigin"
              ].forEach(function(Vi) {
                vu.prototype["set" + Ic(Vi)] = function(Ei) {
                  this.el_[Vi] = Ei;
                };
              }), [
                /**
                 * A wrapper around the media elements `pause` function. This will call the `HTML5`
                 * media elements `pause` function.
                 *
                 * @method Html5#pause
                 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-pause}
                 */
                "pause",
                /**
                 * A wrapper around the media elements `load` function. This will call the `HTML5`s
                 * media element `load` function.
                 *
                 * @method Html5#load
                 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-load}
                 */
                "load",
                /**
                 * A wrapper around the media elements `play` function. This will call the `HTML5`s
                 * media element `play` function.
                 *
                 * @method Html5#play
                 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-play}
                 */
                "play"
              ].forEach(function(Vi) {
                vu.prototype[Vi] = function() {
                  return this.el_[Vi]();
                };
              }), Sc.withSourceHandlers(vu), vu.nativeSourceHandler = {}, vu.nativeSourceHandler.canPlayType = function(Vi) {
                try {
                  return vu.TEST_VID.canPlayType(Vi);
                } catch {
                  return "";
                }
              }, vu.nativeSourceHandler.canHandleSource = function(Vi, Ei) {
                if (Vi.type)
                  return vu.nativeSourceHandler.canPlayType(Vi.type);
                if (Vi.src) {
                  var bi = zp(Vi.src);
                  return vu.nativeSourceHandler.canPlayType("video/" + bi);
                }
                return "";
              }, vu.nativeSourceHandler.handleSource = function(Vi, Ei, bi) {
                Ei.setSrc(Vi.src);
              }, vu.nativeSourceHandler.dispose = function() {
              }, vu.registerSourceHandler(vu.nativeSourceHandler), Sc.registerTech("Html5", vu);
              var ng = [
                /**
                 * Fired while the user agent is downloading media data.
                 *
                 * @event Player#progress
                 * @type {EventTarget~Event}
                 */
                /**
                 * Retrigger the `progress` event that was triggered by the {@link Tech}.
                 *
                 * @private
                 * @method Player#handleTechProgress_
                 * @fires Player#progress
                 * @listens Tech#progress
                 */
                "progress",
                /**
                 * Fires when the loading of an audio/video is aborted.
                 *
                 * @event Player#abort
                 * @type {EventTarget~Event}
                 */
                /**
                 * Retrigger the `abort` event that was triggered by the {@link Tech}.
                 *
                 * @private
                 * @method Player#handleTechAbort_
                 * @fires Player#abort
                 * @listens Tech#abort
                 */
                "abort",
                /**
                 * Fires when the browser is intentionally not getting media data.
                 *
                 * @event Player#suspend
                 * @type {EventTarget~Event}
                 */
                /**
                 * Retrigger the `suspend` event that was triggered by the {@link Tech}.
                 *
                 * @private
                 * @method Player#handleTechSuspend_
                 * @fires Player#suspend
                 * @listens Tech#suspend
                 */
                "suspend",
                /**
                 * Fires when the current playlist is empty.
                 *
                 * @event Player#emptied
                 * @type {EventTarget~Event}
                 */
                /**
                 * Retrigger the `emptied` event that was triggered by the {@link Tech}.
                 *
                 * @private
                 * @method Player#handleTechEmptied_
                 * @fires Player#emptied
                 * @listens Tech#emptied
                 */
                "emptied",
                /**
                 * Fires when the browser is trying to get media data, but data is not available.
                 *
                 * @event Player#stalled
                 * @type {EventTarget~Event}
                 */
                /**
                 * Retrigger the `stalled` event that was triggered by the {@link Tech}.
                 *
                 * @private
                 * @method Player#handleTechStalled_
                 * @fires Player#stalled
                 * @listens Tech#stalled
                 */
                "stalled",
                /**
                 * Fires when the browser has loaded meta data for the audio/video.
                 *
                 * @event Player#loadedmetadata
                 * @type {EventTarget~Event}
                 */
                /**
                 * Retrigger the `loadedmetadata` event that was triggered by the {@link Tech}.
                 *
                 * @private
                 * @method Player#handleTechLoadedmetadata_
                 * @fires Player#loadedmetadata
                 * @listens Tech#loadedmetadata
                 */
                "loadedmetadata",
                /**
                 * Fires when the browser has loaded the current frame of the audio/video.
                 *
                 * @event Player#loadeddata
                 * @type {event}
                 */
                /**
                 * Retrigger the `loadeddata` event that was triggered by the {@link Tech}.
                 *
                 * @private
                 * @method Player#handleTechLoaddeddata_
                 * @fires Player#loadeddata
                 * @listens Tech#loadeddata
                 */
                "loadeddata",
                /**
                 * Fires when the current playback position has changed.
                 *
                 * @event Player#timeupdate
                 * @type {event}
                 */
                /**
                 * Retrigger the `timeupdate` event that was triggered by the {@link Tech}.
                 *
                 * @private
                 * @method Player#handleTechTimeUpdate_
                 * @fires Player#timeupdate
                 * @listens Tech#timeupdate
                 */
                "timeupdate",
                /**
                 * Fires when the video's intrinsic dimensions change
                 *
                 * @event Player#resize
                 * @type {event}
                 */
                /**
                 * Retrigger the `resize` event that was triggered by the {@link Tech}.
                 *
                 * @private
                 * @method Player#handleTechResize_
                 * @fires Player#resize
                 * @listens Tech#resize
                 */
                "resize",
                /**
                 * Fires when the volume has been changed
                 *
                 * @event Player#volumechange
                 * @type {event}
                 */
                /**
                 * Retrigger the `volumechange` event that was triggered by the {@link Tech}.
                 *
                 * @private
                 * @method Player#handleTechVolumechange_
                 * @fires Player#volumechange
                 * @listens Tech#volumechange
                 */
                "volumechange",
                /**
                 * Fires when the text track has been changed
                 *
                 * @event Player#texttrackchange
                 * @type {event}
                 */
                /**
                 * Retrigger the `texttrackchange` event that was triggered by the {@link Tech}.
                 *
                 * @private
                 * @method Player#handleTechTexttrackchange_
                 * @fires Player#texttrackchange
                 * @listens Tech#texttrackchange
                 */
                "texttrackchange"
              ], qg = {
                canplay: "CanPlay",
                canplaythrough: "CanPlayThrough",
                playing: "Playing",
                seeked: "Seeked"
              }, Yg = ["tiny", "xsmall", "small", "medium", "large", "xlarge", "huge"], Rg = {};
              Yg.forEach(function(Vi) {
                var Ei = Vi.charAt(0) === "x" ? "x-" + Vi.substring(1) : Vi;
                Rg[Vi] = "vjs-layout-" + Ei;
              });
              var ay = {
                tiny: 210,
                xsmall: 320,
                small: 425,
                medium: 768,
                large: 1440,
                xlarge: 2560,
                huge: 1 / 0
              }, id = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci, hi) {
                  var wi;
                  if (yi.id = yi.id || ci.id || "vjs_video_" + fd(), ci = Ta(Ei.getTagSettings(yi), ci), ci.initChildren = !1, ci.createEl = !1, ci.evented = !1, ci.reportTouchActivity = !1, !ci.language)
                    if (typeof yi.closest == "function") {
                      var zi = yi.closest("[lang]");
                      zi && zi.getAttribute && (ci.language = zi.getAttribute("lang"));
                    } else
                      for (var Wo = yi; Wo && Wo.nodeType === 1; ) {
                        if (tu(Wo).hasOwnProperty("lang")) {
                          ci.language = Wo.getAttribute("lang");
                          break;
                        }
                        Wo = Wo.parentNode;
                      }
                  if (wi = Vi.call(this, null, ci, hi) || this, wi.boundDocumentFullscreenChange_ = function(Ha) {
                    return wi.documentFullscreenChange_(Ha);
                  }, wi.boundFullWindowOnEscKey_ = function(Ha) {
                    return wi.fullWindowOnEscKey(Ha);
                  }, wi.boundUpdateStyleEl_ = function(Ha) {
                    return wi.updateStyleEl_(Ha);
                  }, wi.boundApplyInitTime_ = function(Ha) {
                    return wi.applyInitTime_(Ha);
                  }, wi.boundUpdateCurrentBreakpoint_ = function(Ha) {
                    return wi.updateCurrentBreakpoint_(Ha);
                  }, wi.boundHandleTechClick_ = function(Ha) {
                    return wi.handleTechClick_(Ha);
                  }, wi.boundHandleTechDoubleClick_ = function(Ha) {
                    return wi.handleTechDoubleClick_(Ha);
                  }, wi.boundHandleTechTouchStart_ = function(Ha) {
                    return wi.handleTechTouchStart_(Ha);
                  }, wi.boundHandleTechTouchMove_ = function(Ha) {
                    return wi.handleTechTouchMove_(Ha);
                  }, wi.boundHandleTechTouchEnd_ = function(Ha) {
                    return wi.handleTechTouchEnd_(Ha);
                  }, wi.boundHandleTechTap_ = function(Ha) {
                    return wi.handleTechTap_(Ha);
                  }, wi.isFullscreen_ = !1, wi.log = Es(wi.id_), wi.fsApi_ = pa, wi.isPosterFromTech_ = !1, wi.queuedCallbacks_ = [], wi.isReady_ = !1, wi.hasStarted_ = !1, wi.userActive_ = !1, wi.debugEnabled_ = !1, wi.audioOnlyMode_ = !1, wi.audioPosterMode_ = !1, wi.audioOnlyCache_ = {
                    playerHeight: null,
                    hiddenChildren: []
                  }, !wi.options_ || !wi.options_.techOrder || !wi.options_.techOrder.length)
                    throw new Error("No techOrder specified. Did you overwrite videojs.options instead of just changing the properties you want to override?");
                  if (wi.tag = yi, wi.tagAttributes = yi && tu(yi), wi.language(wi.options_.language), ci.languages) {
                    var aa = {};
                    Object.getOwnPropertyNames(ci.languages).forEach(function(Ha) {
                      aa[Ha.toLowerCase()] = ci.languages[Ha];
                    }), wi.languages_ = aa;
                  } else
                    wi.languages_ = Ei.prototype.options_.languages;
                  wi.resetCache_(), wi.poster_ = ci.poster || "", wi.controls_ = !!ci.controls, yi.controls = !1, yi.removeAttribute("controls"), wi.changingSrc_ = !1, wi.playCallbacks_ = [], wi.playTerminatedQueue_ = [], yi.hasAttribute("autoplay") ? wi.autoplay(!0) : wi.autoplay(wi.options_.autoplay), ci.plugins && Object.keys(ci.plugins).forEach(function(Ha) {
                    if (typeof wi[Ha] != "function")
                      throw new Error('plugin "' + Ha + '" does not exist');
                  }), wi.scrubbing_ = !1, wi.el_ = wi.createEl(), Up((0, xi.default)(wi), {
                    eventBusKey: "el_"
                  }), wi.fsApi_.requestFullscreen && (pd(gi(), wi.fsApi_.fullscreenchange, wi.boundDocumentFullscreenChange_), wi.on(wi.fsApi_.fullscreenchange, wi.boundDocumentFullscreenChange_)), wi.fluid_ && wi.on(["playerreset", "resize"], wi.boundUpdateStyleEl_);
                  var Ea = Ec(wi.options_);
                  ci.plugins && Object.keys(ci.plugins).forEach(function(Ha) {
                    wi[Ha](ci.plugins[Ha]);
                  }), ci.debug && wi.debug(!0), wi.options_.playerOptions = Ea, wi.middleware_ = [], wi.playbackRates(ci.playbackRates), wi.initChildren(), wi.isAudio(yi.nodeName.toLowerCase() === "audio"), wi.controls() ? wi.addClass("vjs-controls-enabled") : wi.addClass("vjs-controls-disabled"), wi.el_.setAttribute("role", "region"), wi.isAudio() ? wi.el_.setAttribute("aria-label", wi.localize("Audio Player")) : wi.el_.setAttribute("aria-label", wi.localize("Video Player")), wi.isAudio() && wi.addClass("vjs-audio"), wi.flexNotSupported_() && wi.addClass("vjs-no-flex"), Ul && wi.addClass("vjs-touch-enabled"), Tu || wi.addClass("vjs-workinghover"), Ei.players[wi.id_] = (0, xi.default)(wi);
                  var Ka = Hi.split(".")[0];
                  return wi.addClass("vjs-v" + Ka), wi.userActive(!0), wi.reportUserActivity(), wi.one("play", function(Ha) {
                    return wi.listenForUserActivity_(Ha);
                  }), wi.on("stageclick", function(Ha) {
                    return wi.handleStageClick_(Ha);
                  }), wi.on("keydown", function(Ha) {
                    return wi.handleKeyDown(Ha);
                  }), wi.on("languagechange", function(Ha) {
                    return wi.handleLanguagechange(Ha);
                  }), wi.breakpoints(wi.options_.breakpoints), wi.responsive(wi.options_.responsive), wi.on("ready", function() {
                    wi.audioPosterMode(wi.options_.audioPosterMode), wi.audioOnlyMode(wi.options_.audioOnlyMode);
                  }), wi;
                }
                var bi = Ei.prototype;
                return bi.dispose = function() {
                  var ci = this;
                  this.trigger("dispose"), this.off("dispose"), Cc(gi(), this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_), Cc(gi(), "keydown", this.boundFullWindowOnEscKey_), this.styleEl_ && this.styleEl_.parentNode && (this.styleEl_.parentNode.removeChild(this.styleEl_), this.styleEl_ = null), Ei.players[this.id_] = null, this.tag && this.tag.player && (this.tag.player = null), this.el_ && this.el_.player && (this.el_.player = null), this.tech_ && (this.tech_.dispose(), this.isPosterFromTech_ = !1, this.poster_ = ""), this.playerElIngest_ && (this.playerElIngest_ = null), this.tag && (this.tag = null), Qh(this), Yc.names.forEach(function(hi) {
                    var wi = Yc[hi], zi = ci[wi.getterName]();
                    zi && zi.off && zi.off();
                  }), Vi.prototype.dispose.call(this, {
                    restoreEl: this.options_.restoreEl
                  });
                }, bi.createEl = function() {
                  var ci = this.tag, hi, wi = this.playerElIngest_ = ci.parentNode && ci.parentNode.hasAttribute && ci.parentNode.hasAttribute("data-vjs-player"), zi = this.tag.tagName.toLowerCase() === "video-js";
                  wi ? hi = this.el_ = ci.parentNode : zi || (hi = this.el_ = Vi.prototype.createEl.call(this, "div"));
                  var Wo = tu(ci);
                  if (zi) {
                    for (hi = this.el_ = ci, ci = this.tag = gi().createElement("video"); hi.children.length; )
                      ci.appendChild(hi.firstChild);
                    zs(hi, "video-js") || al(hi, "video-js"), hi.appendChild(ci), wi = this.playerElIngest_ = hi, Object.keys(hi).forEach(function(gl) {
                      try {
                        ci[gl] = hi[gl];
                      } catch {
                      }
                    });
                  }
                  if (ci.setAttribute("tabindex", "-1"), Wo.tabindex = "-1", (Bl || Il && xl) && (ci.setAttribute("role", "application"), Wo.role = "application"), ci.removeAttribute("width"), ci.removeAttribute("height"), "width" in Wo && delete Wo.width, "height" in Wo && delete Wo.height, Object.getOwnPropertyNames(Wo).forEach(function(gl) {
                    zi && gl === "class" || hi.setAttribute(gl, Wo[gl]), zi && ci.setAttribute(gl, Wo[gl]);
                  }), ci.playerId = ci.id, ci.id += "_html5_api", ci.className = "vjs-tech", ci.player = hi.player = this, this.addClass("vjs-paused"), di().VIDEOJS_NO_DYNAMIC_STYLE !== !0) {
                    this.styleEl_ = sc("vjs-styles-dimensions");
                    var aa = xu(".vjs-styles-defaults"), Ea = xu("head");
                    Ea.insertBefore(this.styleEl_, aa ? aa.nextSibling : Ea.firstChild);
                  }
                  this.fill_ = !1, this.fluid_ = !1, this.width(this.options_.width), this.height(this.options_.height), this.fill(this.options_.fill), this.fluid(this.options_.fluid), this.aspectRatio(this.options_.aspectRatio), this.crossOrigin(this.options_.crossOrigin || this.options_.crossorigin);
                  for (var Ka = ci.getElementsByTagName("a"), Ha = 0; Ha < Ka.length; Ha++) {
                    var ks = Ka.item(Ha);
                    al(ks, "vjs-hidden"), ks.setAttribute("hidden", "hidden");
                  }
                  return ci.initNetworkState_ = ci.networkState, ci.parentNode && !wi && ci.parentNode.insertBefore(hi, ci), rl(ci, hi), this.children_.unshift(ci), this.el_.setAttribute("lang", this.language_), this.el_.setAttribute("translate", "no"), this.el_ = hi, hi;
                }, bi.crossOrigin = function(ci) {
                  if (!ci)
                    return this.techGet_("crossOrigin");
                  if (ci !== "anonymous" && ci !== "use-credentials") {
                    Xa.warn('crossOrigin must be "anonymous" or "use-credentials", given "' + ci + '"');
                    return;
                  }
                  this.techCall_("setCrossOrigin", ci);
                }, bi.width = function(ci) {
                  return this.dimension("width", ci);
                }, bi.height = function(ci) {
                  return this.dimension("height", ci);
                }, bi.dimension = function(ci, hi) {
                  var wi = ci + "_";
                  if (hi === void 0)
                    return this[wi] || 0;
                  if (hi === "" || hi === "auto") {
                    this[wi] = void 0, this.updateStyleEl_();
                    return;
                  }
                  var zi = parseFloat(hi);
                  if (isNaN(zi)) {
                    Xa.error('Improper value "' + hi + '" supplied for for ' + ci);
                    return;
                  }
                  this[wi] = zi, this.updateStyleEl_();
                }, bi.fluid = function(ci) {
                  var hi = this;
                  if (ci === void 0)
                    return !!this.fluid_;
                  this.fluid_ = !!ci, Vd(this) && this.off(["playerreset", "resize"], this.boundUpdateStyleEl_), ci ? (this.addClass("vjs-fluid"), this.fill(!1), Wd(this, function() {
                    hi.on(["playerreset", "resize"], hi.boundUpdateStyleEl_);
                  })) : this.removeClass("vjs-fluid"), this.updateStyleEl_();
                }, bi.fill = function(ci) {
                  if (ci === void 0)
                    return !!this.fill_;
                  this.fill_ = !!ci, ci ? (this.addClass("vjs-fill"), this.fluid(!1)) : this.removeClass("vjs-fill");
                }, bi.aspectRatio = function(ci) {
                  if (ci === void 0)
                    return this.aspectRatio_;
                  if (!/^\d+\:\d+$/.test(ci))
                    throw new Error("Improper value supplied for aspect ratio. The format should be width:height, for example 16:9.");
                  this.aspectRatio_ = ci, this.fluid(!0), this.updateStyleEl_();
                }, bi.updateStyleEl_ = function() {
                  if (di().VIDEOJS_NO_DYNAMIC_STYLE === !0) {
                    var ci = typeof this.width_ == "number" ? this.width_ : this.options_.width, hi = typeof this.height_ == "number" ? this.height_ : this.options_.height, wi = this.tech_ && this.tech_.el();
                    wi && (ci >= 0 && (wi.width = ci), hi >= 0 && (wi.height = hi));
                    return;
                  }
                  var zi, Wo, aa, Ea;
                  this.aspectRatio_ !== void 0 && this.aspectRatio_ !== "auto" ? aa = this.aspectRatio_ : this.videoWidth() > 0 ? aa = this.videoWidth() + ":" + this.videoHeight() : aa = "16:9";
                  var Ka = aa.split(":"), Ha = Ka[1] / Ka[0];
                  this.width_ !== void 0 ? zi = this.width_ : this.height_ !== void 0 ? zi = this.height_ / Ha : zi = this.videoWidth() || 300, this.height_ !== void 0 ? Wo = this.height_ : Wo = zi * Ha, /^[^a-zA-Z]/.test(this.id()) ? Ea = "dimensions-" + this.id() : Ea = this.id() + "-dimensions", this.addClass(Ea), wc(this.styleEl_, `
      .` + Ea + ` {
        width: ` + zi + `px;
        height: ` + Wo + `px;
      }

      .` + Ea + `.vjs-fluid:not(.vjs-audio-only-mode) {
        padding-top: ` + Ha * 100 + `%;
      }
    `);
                }, bi.loadTech_ = function(ci, hi) {
                  var wi = this;
                  this.tech_ && this.unloadTech_();
                  var zi = Ic(ci), Wo = ci.charAt(0).toLowerCase() + ci.slice(1);
                  zi !== "Html5" && this.tag && (Sc.getTech("Html5").disposeMediaElement(this.tag), this.tag.player = null, this.tag = null), this.techName_ = zi, this.isReady_ = !1;
                  var aa = this.autoplay();
                  (typeof this.autoplay() == "string" || this.autoplay() === !0 && this.options_.normalizeAutoplay) && (aa = !1);
                  var Ea = {
                    source: hi,
                    autoplay: aa,
                    nativeControlsForTouch: this.options_.nativeControlsForTouch,
                    playerId: this.id(),
                    techId: this.id() + "_" + Wo + "_api",
                    playsinline: this.options_.playsinline,
                    preload: this.options_.preload,
                    loop: this.options_.loop,
                    disablePictureInPicture: this.options_.disablePictureInPicture,
                    muted: this.options_.muted,
                    poster: this.poster(),
                    language: this.language(),
                    playerElIngest: this.playerElIngest_ || !1,
                    "vtt.js": this.options_["vtt.js"],
                    canOverridePoster: !!this.options_.techCanOverridePoster,
                    enableSourceset: this.options_.enableSourceset,
                    Promise: this.options_.Promise
                  };
                  Yc.names.forEach(function(Ha) {
                    var ks = Yc[Ha];
                    Ea[ks.getterName] = wi[ks.privateName];
                  }), Ta(Ea, this.options_[zi]), Ta(Ea, this.options_[Wo]), Ta(Ea, this.options_[ci.toLowerCase()]), this.tag && (Ea.tag = this.tag), hi && hi.src === this.cache_.src && this.cache_.currentTime > 0 && (Ea.startTime = this.cache_.currentTime);
                  var Ka = Sc.getTech(ci);
                  if (!Ka)
                    throw new Error("No Tech named '" + zi + "' exists! '" + zi + "' should be registered using videojs.registerTech()'");
                  this.tech_ = new Ka(Ea), this.tech_.ready(Tc(this, this.handleTechReady_), !0), Vp.jsonToTextTracks(this.textTracksJson_ || [], this.tech_), ng.forEach(function(Ha) {
                    wi.on(wi.tech_, Ha, function(ks) {
                      return wi["handleTech" + Ic(Ha) + "_"](ks);
                    });
                  }), Object.keys(qg).forEach(function(Ha) {
                    wi.on(wi.tech_, Ha, function(ks) {
                      if (wi.tech_.playbackRate() === 0 && wi.tech_.seeking()) {
                        wi.queuedCallbacks_.push({
                          callback: wi["handleTech" + qg[Ha] + "_"].bind(wi),
                          event: ks
                        });
                        return;
                      }
                      wi["handleTech" + qg[Ha] + "_"](ks);
                    });
                  }), this.on(this.tech_, "loadstart", function(Ha) {
                    return wi.handleTechLoadStart_(Ha);
                  }), this.on(this.tech_, "sourceset", function(Ha) {
                    return wi.handleTechSourceset_(Ha);
                  }), this.on(this.tech_, "waiting", function(Ha) {
                    return wi.handleTechWaiting_(Ha);
                  }), this.on(this.tech_, "ended", function(Ha) {
                    return wi.handleTechEnded_(Ha);
                  }), this.on(this.tech_, "seeking", function(Ha) {
                    return wi.handleTechSeeking_(Ha);
                  }), this.on(this.tech_, "play", function(Ha) {
                    return wi.handleTechPlay_(Ha);
                  }), this.on(this.tech_, "firstplay", function(Ha) {
                    return wi.handleTechFirstPlay_(Ha);
                  }), this.on(this.tech_, "pause", function(Ha) {
                    return wi.handleTechPause_(Ha);
                  }), this.on(this.tech_, "durationchange", function(Ha) {
                    return wi.handleTechDurationChange_(Ha);
                  }), this.on(this.tech_, "fullscreenchange", function(Ha, ks) {
                    return wi.handleTechFullscreenChange_(Ha, ks);
                  }), this.on(this.tech_, "fullscreenerror", function(Ha, ks) {
                    return wi.handleTechFullscreenError_(Ha, ks);
                  }), this.on(this.tech_, "enterpictureinpicture", function(Ha) {
                    return wi.handleTechEnterPictureInPicture_(Ha);
                  }), this.on(this.tech_, "leavepictureinpicture", function(Ha) {
                    return wi.handleTechLeavePictureInPicture_(Ha);
                  }), this.on(this.tech_, "error", function(Ha) {
                    return wi.handleTechError_(Ha);
                  }), this.on(this.tech_, "posterchange", function(Ha) {
                    return wi.handleTechPosterChange_(Ha);
                  }), this.on(this.tech_, "textdata", function(Ha) {
                    return wi.handleTechTextData_(Ha);
                  }), this.on(this.tech_, "ratechange", function(Ha) {
                    return wi.handleTechRateChange_(Ha);
                  }), this.on(this.tech_, "loadedmetadata", this.boundUpdateStyleEl_), this.usingNativeControls(this.techGet_("controls")), this.controls() && !this.usingNativeControls() && this.addTechControlsListeners_(), this.tech_.el().parentNode !== this.el() && (zi !== "Html5" || !this.tag) && rl(this.tech_.el(), this.el()), this.tag && (this.tag.player = null, this.tag = null);
                }, bi.unloadTech_ = function() {
                  var ci = this;
                  Yc.names.forEach(function(hi) {
                    var wi = Yc[hi];
                    ci[wi.privateName] = ci[wi.getterName]();
                  }), this.textTracksJson_ = Vp.textTracksToJson(this.tech_), this.isReady_ = !1, this.tech_.dispose(), this.tech_ = !1, this.isPosterFromTech_ && (this.poster_ = "", this.trigger("posterchange")), this.isPosterFromTech_ = !1;
                }, bi.tech = function(ci) {
                  return ci === void 0 && Xa.warn(`Using the tech directly can be dangerous. I hope you know what you're doing.
See https://github.com/videojs/video.js/issues/2617 for more info.
`), this.tech_;
                }, bi.addTechControlsListeners_ = function() {
                  this.removeTechControlsListeners_(), this.on(this.tech_, "click", this.boundHandleTechClick_), this.on(this.tech_, "dblclick", this.boundHandleTechDoubleClick_), this.on(this.tech_, "touchstart", this.boundHandleTechTouchStart_), this.on(this.tech_, "touchmove", this.boundHandleTechTouchMove_), this.on(this.tech_, "touchend", this.boundHandleTechTouchEnd_), this.on(this.tech_, "tap", this.boundHandleTechTap_);
                }, bi.removeTechControlsListeners_ = function() {
                  this.off(this.tech_, "tap", this.boundHandleTechTap_), this.off(this.tech_, "touchstart", this.boundHandleTechTouchStart_), this.off(this.tech_, "touchmove", this.boundHandleTechTouchMove_), this.off(this.tech_, "touchend", this.boundHandleTechTouchEnd_), this.off(this.tech_, "click", this.boundHandleTechClick_), this.off(this.tech_, "dblclick", this.boundHandleTechDoubleClick_);
                }, bi.handleTechReady_ = function() {
                  this.triggerReady(), this.cache_.volume && this.techCall_("setVolume", this.cache_.volume), this.handleTechPosterChange_(), this.handleTechDurationChange_();
                }, bi.handleTechLoadStart_ = function() {
                  this.removeClass("vjs-ended"), this.removeClass("vjs-seeking"), this.error(null), this.handleTechDurationChange_(), this.paused() ? (this.hasStarted(!1), this.trigger("loadstart")) : (this.trigger("loadstart"), this.trigger("firstplay")), this.manualAutoplay_(this.autoplay() === !0 && this.options_.normalizeAutoplay ? "play" : this.autoplay());
                }, bi.manualAutoplay_ = function(ci) {
                  var hi = this;
                  if (!(!this.tech_ || typeof ci != "string")) {
                    var wi = function() {
                      var aa = hi.muted();
                      hi.muted(!0);
                      var Ea = function() {
                        hi.muted(aa);
                      };
                      hi.playTerminatedQueue_.push(Ea);
                      var Ka = hi.play();
                      if (Dd(Ka))
                        return Ka.catch(function(Ha) {
                          throw Ea(), new Error("Rejection at manualAutoplay. Restoring muted value. " + (Ha || ""));
                        });
                    }, zi;
                    if (ci === "any" && !this.muted() ? (zi = this.play(), Dd(zi) && (zi = zi.catch(wi))) : ci === "muted" && !this.muted() ? zi = wi() : zi = this.play(), !!Dd(zi))
                      return zi.then(function() {
                        hi.trigger({
                          type: "autoplay-success",
                          autoplay: ci
                        });
                      }).catch(function() {
                        hi.trigger({
                          type: "autoplay-failure",
                          autoplay: ci
                        });
                      });
                  }
                }, bi.updateSourceCaches_ = function(ci) {
                  ci === void 0 && (ci = "");
                  var hi = ci, wi = "";
                  typeof hi != "string" && (hi = ci.src, wi = ci.type), this.cache_.source = this.cache_.source || {}, this.cache_.sources = this.cache_.sources || [], hi && !wi && (wi = ip(this, hi)), this.cache_.source = Ec({}, ci, {
                    src: hi,
                    type: wi
                  });
                  for (var zi = this.cache_.sources.filter(function(ks) {
                    return ks.src && ks.src === hi;
                  }), Wo = [], aa = this.$$("source"), Ea = [], Ka = 0; Ka < aa.length; Ka++) {
                    var Ha = tu(aa[Ka]);
                    Wo.push(Ha), Ha.src && Ha.src === hi && Ea.push(Ha.src);
                  }
                  Ea.length && !zi.length ? this.cache_.sources = Wo : zi.length || (this.cache_.sources = [this.cache_.source]), this.cache_.src = hi;
                }, bi.handleTechSourceset_ = function(ci) {
                  var hi = this;
                  if (!this.changingSrc_) {
                    var wi = function(Ea) {
                      return hi.updateSourceCaches_(Ea);
                    }, zi = this.currentSource().src, Wo = ci.src;
                    zi && !/^blob:/.test(zi) && /^blob:/.test(Wo) && (!this.lastSource_ || this.lastSource_.tech !== Wo && this.lastSource_.player !== zi) && (wi = function() {
                    }), wi(Wo), ci.src || this.tech_.any(["sourceset", "loadstart"], function(aa) {
                      if (aa.type !== "sourceset") {
                        var Ea = hi.techGet("currentSrc");
                        hi.lastSource_.tech = Ea, hi.updateSourceCaches_(Ea);
                      }
                    });
                  }
                  this.lastSource_ = {
                    player: this.currentSource().src,
                    tech: ci.src
                  }, this.trigger({
                    src: ci.src,
                    type: "sourceset"
                  });
                }, bi.hasStarted = function(ci) {
                  if (ci === void 0)
                    return this.hasStarted_;
                  ci !== this.hasStarted_ && (this.hasStarted_ = ci, this.hasStarted_ ? (this.addClass("vjs-has-started"), this.trigger("firstplay")) : this.removeClass("vjs-has-started"));
                }, bi.handleTechPlay_ = function() {
                  this.removeClass("vjs-ended"), this.removeClass("vjs-paused"), this.addClass("vjs-playing"), this.hasStarted(!0), this.trigger("play");
                }, bi.handleTechRateChange_ = function() {
                  this.tech_.playbackRate() > 0 && this.cache_.lastPlaybackRate === 0 && (this.queuedCallbacks_.forEach(function(ci) {
                    return ci.callback(ci.event);
                  }), this.queuedCallbacks_ = []), this.cache_.lastPlaybackRate = this.tech_.playbackRate(), this.trigger("ratechange");
                }, bi.handleTechWaiting_ = function() {
                  var ci = this;
                  this.addClass("vjs-waiting"), this.trigger("waiting");
                  var hi = this.currentTime(), wi = function zi() {
                    hi !== ci.currentTime() && (ci.removeClass("vjs-waiting"), ci.off("timeupdate", zi));
                  };
                  this.on("timeupdate", wi);
                }, bi.handleTechCanPlay_ = function() {
                  this.removeClass("vjs-waiting"), this.trigger("canplay");
                }, bi.handleTechCanPlayThrough_ = function() {
                  this.removeClass("vjs-waiting"), this.trigger("canplaythrough");
                }, bi.handleTechPlaying_ = function() {
                  this.removeClass("vjs-waiting"), this.trigger("playing");
                }, bi.handleTechSeeking_ = function() {
                  this.addClass("vjs-seeking"), this.trigger("seeking");
                }, bi.handleTechSeeked_ = function() {
                  this.removeClass("vjs-seeking"), this.removeClass("vjs-ended"), this.trigger("seeked");
                }, bi.handleTechFirstPlay_ = function() {
                  this.options_.starttime && (Xa.warn("Passing the `starttime` option to the player will be deprecated in 6.0"), this.currentTime(this.options_.starttime)), this.addClass("vjs-has-started"), this.trigger("firstplay");
                }, bi.handleTechPause_ = function() {
                  this.removeClass("vjs-playing"), this.addClass("vjs-paused"), this.trigger("pause");
                }, bi.handleTechEnded_ = function() {
                  this.addClass("vjs-ended"), this.removeClass("vjs-waiting"), this.options_.loop ? (this.currentTime(0), this.play()) : this.paused() || this.pause(), this.trigger("ended");
                }, bi.handleTechDurationChange_ = function() {
                  this.duration(this.techGet_("duration"));
                }, bi.handleTechClick_ = function(ci) {
                  this.controls_ && (this.options_ === void 0 || this.options_.userActions === void 0 || this.options_.userActions.click === void 0 || this.options_.userActions.click !== !1) && (this.options_ !== void 0 && this.options_.userActions !== void 0 && typeof this.options_.userActions.click == "function" ? this.options_.userActions.click.call(this, ci) : this.paused() ? wd(this.play()) : this.pause());
                }, bi.handleTechDoubleClick_ = function(ci) {
                  if (this.controls_) {
                    var hi = Array.prototype.some.call(this.$$(".vjs-control-bar, .vjs-modal-dialog"), function(wi) {
                      return wi.contains(ci.target);
                    });
                    hi || (this.options_ === void 0 || this.options_.userActions === void 0 || this.options_.userActions.doubleClick === void 0 || this.options_.userActions.doubleClick !== !1) && (this.options_ !== void 0 && this.options_.userActions !== void 0 && typeof this.options_.userActions.doubleClick == "function" ? this.options_.userActions.doubleClick.call(this, ci) : this.isFullscreen() ? this.exitFullscreen() : this.requestFullscreen());
                  }
                }, bi.handleTechTap_ = function() {
                  this.userActive(!this.userActive());
                }, bi.handleTechTouchStart_ = function() {
                  this.userWasActive = this.userActive();
                }, bi.handleTechTouchMove_ = function() {
                  this.userWasActive && this.reportUserActivity();
                }, bi.handleTechTouchEnd_ = function(ci) {
                  ci.cancelable && ci.preventDefault();
                }, bi.handleStageClick_ = function() {
                  this.reportUserActivity();
                }, bi.toggleFullscreenClass_ = function() {
                  this.isFullscreen() ? this.addClass("vjs-fullscreen") : this.removeClass("vjs-fullscreen");
                }, bi.documentFullscreenChange_ = function(ci) {
                  var hi = ci.target.player;
                  if (!(hi && hi !== this)) {
                    var wi = this.el(), zi = gi()[this.fsApi_.fullscreenElement] === wi;
                    !zi && wi.matches ? zi = wi.matches(":" + this.fsApi_.fullscreen) : !zi && wi.msMatchesSelector && (zi = wi.msMatchesSelector(":" + this.fsApi_.fullscreen)), this.isFullscreen(zi);
                  }
                }, bi.handleTechFullscreenChange_ = function(ci, hi) {
                  var wi = this;
                  hi && (hi.nativeIOSFullscreen && (this.addClass("vjs-ios-native-fs"), this.tech_.one("webkitendfullscreen", function() {
                    wi.removeClass("vjs-ios-native-fs");
                  })), this.isFullscreen(hi.isFullscreen));
                }, bi.handleTechFullscreenError_ = function(ci, hi) {
                  this.trigger("fullscreenerror", hi);
                }, bi.togglePictureInPictureClass_ = function() {
                  this.isInPictureInPicture() ? this.addClass("vjs-picture-in-picture") : this.removeClass("vjs-picture-in-picture");
                }, bi.handleTechEnterPictureInPicture_ = function(ci) {
                  this.isInPictureInPicture(!0);
                }, bi.handleTechLeavePictureInPicture_ = function(ci) {
                  this.isInPictureInPicture(!1);
                }, bi.handleTechError_ = function() {
                  var ci = this.tech_.error();
                  this.error(ci);
                }, bi.handleTechTextData_ = function() {
                  var ci = null;
                  arguments.length > 1 && (ci = arguments[1]), this.trigger("textdata", ci);
                }, bi.getCache = function() {
                  return this.cache_;
                }, bi.resetCache_ = function() {
                  this.cache_ = {
                    // Right now, the currentTime is not _really_ cached because it is always
                    // retrieved from the tech (see: currentTime). However, for completeness,
                    // we set it to zero here to ensure that if we do start actually caching
                    // it, we reset it along with everything else.
                    currentTime: 0,
                    initTime: 0,
                    inactivityTimeout: this.options_.inactivityTimeout,
                    duration: NaN,
                    lastVolume: 1,
                    lastPlaybackRate: this.defaultPlaybackRate(),
                    media: null,
                    src: "",
                    source: {},
                    sources: [],
                    playbackRates: [],
                    volume: 1
                  };
                }, bi.techCall_ = function(ci, hi) {
                  this.ready(function() {
                    if (ci in Jh)
                      return ef(this.middleware_, this.tech_, ci, hi);
                    if (ci in Eh)
                      return Yp(this.middleware_, this.tech_, ci, hi);
                    try {
                      this.tech_ && this.tech_[ci](hi);
                    } catch (wi) {
                      throw Xa(wi), wi;
                    }
                  }, !0);
                }, bi.techGet_ = function(ci) {
                  if (!(!this.tech_ || !this.tech_.isReady_)) {
                    if (ci in Th)
                      return Zd(this.middleware_, this.tech_, ci);
                    if (ci in Eh)
                      return Yp(this.middleware_, this.tech_, ci);
                    try {
                      return this.tech_[ci]();
                    } catch (hi) {
                      throw this.tech_[ci] === void 0 ? (Xa("Video.js: " + ci + " method not defined for " + this.techName_ + " playback technology.", hi), hi) : hi.name === "TypeError" ? (Xa("Video.js: " + ci + " unavailable on " + this.techName_ + " playback technology element.", hi), this.tech_.isReady_ = !1, hi) : (Xa(hi), hi);
                    }
                  }
                }, bi.play = function() {
                  var ci = this, hi = this.options_.Promise || di().Promise;
                  return hi ? new hi(function(wi) {
                    ci.play_(wi);
                  }) : this.play_();
                }, bi.play_ = function(ci) {
                  var hi = this;
                  ci === void 0 && (ci = wd), this.playCallbacks_.push(ci);
                  var wi = !!(!this.changingSrc_ && (this.src() || this.currentSrc())), zi = !!(Ku || Tu);
                  if (this.waitToPlay_ && (this.off(["ready", "loadstart"], this.waitToPlay_), this.waitToPlay_ = null), !this.isReady_ || !wi) {
                    this.waitToPlay_ = function(Ea) {
                      hi.play_();
                    }, this.one(["ready", "loadstart"], this.waitToPlay_), !wi && zi && this.load();
                    return;
                  }
                  var Wo = this.techGet_("play"), aa = zi && this.hasClass("vjs-ended");
                  aa && this.resetProgressBar_(), Wo === null ? this.runPlayTerminatedQueue_() : this.runPlayCallbacks_(Wo);
                }, bi.runPlayTerminatedQueue_ = function() {
                  var ci = this.playTerminatedQueue_.slice(0);
                  this.playTerminatedQueue_ = [], ci.forEach(function(hi) {
                    hi();
                  });
                }, bi.runPlayCallbacks_ = function(ci) {
                  var hi = this.playCallbacks_.slice(0);
                  this.playCallbacks_ = [], this.playTerminatedQueue_ = [], hi.forEach(function(wi) {
                    wi(ci);
                  });
                }, bi.pause = function() {
                  this.techCall_("pause");
                }, bi.paused = function() {
                  return this.techGet_("paused") !== !1;
                }, bi.played = function() {
                  return this.techGet_("played") || Tf(0, 0);
                }, bi.scrubbing = function(ci) {
                  if (typeof ci > "u")
                    return this.scrubbing_;
                  this.scrubbing_ = !!ci, this.techCall_("setScrubbing", this.scrubbing_), ci ? this.addClass("vjs-scrubbing") : this.removeClass("vjs-scrubbing");
                }, bi.currentTime = function(ci) {
                  if (typeof ci < "u") {
                    if (ci < 0 && (ci = 0), !this.isReady_ || this.changingSrc_ || !this.tech_ || !this.tech_.isReady_) {
                      this.cache_.initTime = ci, this.off("canplay", this.boundApplyInitTime_), this.one("canplay", this.boundApplyInitTime_);
                      return;
                    }
                    this.techCall_("setCurrentTime", ci), this.cache_.initTime = 0;
                    return;
                  }
                  return this.cache_.currentTime = this.techGet_("currentTime") || 0, this.cache_.currentTime;
                }, bi.applyInitTime_ = function() {
                  this.currentTime(this.cache_.initTime);
                }, bi.duration = function(ci) {
                  if (ci === void 0)
                    return this.cache_.duration !== void 0 ? this.cache_.duration : NaN;
                  ci = parseFloat(ci), ci < 0 && (ci = 1 / 0), ci !== this.cache_.duration && (this.cache_.duration = ci, ci === 1 / 0 ? this.addClass("vjs-live") : this.removeClass("vjs-live"), isNaN(ci) || this.trigger("durationchange"));
                }, bi.remainingTime = function() {
                  return this.duration() - this.currentTime();
                }, bi.remainingTimeDisplay = function() {
                  return Math.floor(this.duration()) - Math.floor(this.currentTime());
                }, bi.buffered = function() {
                  var ci = this.techGet_("buffered");
                  return (!ci || !ci.length) && (ci = Tf(0, 0)), ci;
                }, bi.bufferedPercent = function() {
                  return bp(this.buffered(), this.duration());
                }, bi.bufferedEnd = function() {
                  var ci = this.buffered(), hi = this.duration(), wi = ci.end(ci.length - 1);
                  return wi > hi && (wi = hi), wi;
                }, bi.volume = function(ci) {
                  var hi;
                  if (ci !== void 0) {
                    hi = Math.max(0, Math.min(1, parseFloat(ci))), this.cache_.volume = hi, this.techCall_("setVolume", hi), hi > 0 && this.lastVolume_(hi);
                    return;
                  }
                  return hi = parseFloat(this.techGet_("volume")), isNaN(hi) ? 1 : hi;
                }, bi.muted = function(ci) {
                  if (ci !== void 0) {
                    this.techCall_("setMuted", ci);
                    return;
                  }
                  return this.techGet_("muted") || !1;
                }, bi.defaultMuted = function(ci) {
                  return ci !== void 0 ? this.techCall_("setDefaultMuted", ci) : this.techGet_("defaultMuted") || !1;
                }, bi.lastVolume_ = function(ci) {
                  if (ci !== void 0 && ci !== 0) {
                    this.cache_.lastVolume = ci;
                    return;
                  }
                  return this.cache_.lastVolume;
                }, bi.supportsFullScreen = function() {
                  return this.techGet_("supportsFullScreen") || !1;
                }, bi.isFullscreen = function(ci) {
                  if (ci !== void 0) {
                    var hi = this.isFullscreen_;
                    this.isFullscreen_ = !!ci, this.isFullscreen_ !== hi && this.fsApi_.prefixed && this.trigger("fullscreenchange"), this.toggleFullscreenClass_();
                    return;
                  }
                  return this.isFullscreen_;
                }, bi.requestFullscreen = function(ci) {
                  var hi = this.options_.Promise || di().Promise;
                  if (hi) {
                    var wi = this;
                    return new hi(function(zi, Wo) {
                      function aa() {
                        wi.off("fullscreenerror", Ka), wi.off("fullscreenchange", Ea);
                      }
                      function Ea() {
                        aa(), zi();
                      }
                      function Ka(ks, gl) {
                        aa(), Wo(gl);
                      }
                      wi.one("fullscreenchange", Ea), wi.one("fullscreenerror", Ka);
                      var Ha = wi.requestFullscreenHelper_(ci);
                      Ha && (Ha.then(aa, aa), Ha.then(zi, Wo));
                    });
                  }
                  return this.requestFullscreenHelper_();
                }, bi.requestFullscreenHelper_ = function(ci) {
                  var hi = this, wi;
                  if (this.fsApi_.prefixed || (wi = this.options_.fullscreen && this.options_.fullscreen.options || {}, ci !== void 0 && (wi = ci)), this.fsApi_.requestFullscreen) {
                    var zi = this.el_[this.fsApi_.requestFullscreen](wi);
                    return zi && zi.then(function() {
                      return hi.isFullscreen(!0);
                    }, function() {
                      return hi.isFullscreen(!1);
                    }), zi;
                  } else this.tech_.supportsFullScreen() && !this.options_.preferFullWindow ? this.techCall_("enterFullScreen") : this.enterFullWindow();
                }, bi.exitFullscreen = function() {
                  var ci = this.options_.Promise || di().Promise;
                  if (ci) {
                    var hi = this;
                    return new ci(function(wi, zi) {
                      function Wo() {
                        hi.off("fullscreenerror", Ea), hi.off("fullscreenchange", aa);
                      }
                      function aa() {
                        Wo(), wi();
                      }
                      function Ea(Ha, ks) {
                        Wo(), zi(ks);
                      }
                      hi.one("fullscreenchange", aa), hi.one("fullscreenerror", Ea);
                      var Ka = hi.exitFullscreenHelper_();
                      Ka && (Ka.then(Wo, Wo), Ka.then(wi, zi));
                    });
                  }
                  return this.exitFullscreenHelper_();
                }, bi.exitFullscreenHelper_ = function() {
                  var ci = this;
                  if (this.fsApi_.requestFullscreen) {
                    var hi = gi()[this.fsApi_.exitFullscreen]();
                    return hi && wd(hi.then(function() {
                      return ci.isFullscreen(!1);
                    })), hi;
                  } else this.tech_.supportsFullScreen() && !this.options_.preferFullWindow ? this.techCall_("exitFullScreen") : this.exitFullWindow();
                }, bi.enterFullWindow = function() {
                  this.isFullscreen(!0), this.isFullWindow = !0, this.docOrigOverflow = gi().documentElement.style.overflow, pd(gi(), "keydown", this.boundFullWindowOnEscKey_), gi().documentElement.style.overflow = "hidden", al(gi().body, "vjs-full-window"), this.trigger("enterFullWindow");
                }, bi.fullWindowOnEscKey = function(ci) {
                  vi().isEventKey(ci, "Esc") && this.isFullscreen() === !0 && (this.isFullWindow ? this.exitFullWindow() : this.exitFullscreen());
                }, bi.exitFullWindow = function() {
                  this.isFullscreen(!1), this.isFullWindow = !1, Cc(gi(), "keydown", this.boundFullWindowOnEscKey_), gi().documentElement.style.overflow = this.docOrigOverflow, Ol(gi().body, "vjs-full-window"), this.trigger("exitFullWindow");
                }, bi.disablePictureInPicture = function(ci) {
                  if (ci === void 0)
                    return this.techGet_("disablePictureInPicture");
                  this.techCall_("setDisablePictureInPicture", ci), this.options_.disablePictureInPicture = ci, this.trigger("disablepictureinpicturechanged");
                }, bi.isInPictureInPicture = function(ci) {
                  if (ci !== void 0) {
                    this.isInPictureInPicture_ = !!ci, this.togglePictureInPictureClass_();
                    return;
                  }
                  return !!this.isInPictureInPicture_;
                }, bi.requestPictureInPicture = function() {
                  if ("pictureInPictureEnabled" in gi() && this.disablePictureInPicture() === !1)
                    return this.techGet_("requestPictureInPicture");
                }, bi.exitPictureInPicture = function() {
                  if ("pictureInPictureEnabled" in gi())
                    return gi().exitPictureInPicture();
                }, bi.handleKeyDown = function(ci) {
                  var hi = this.options_.userActions;
                  if (!(!hi || !hi.hotkeys)) {
                    var wi = function(Wo) {
                      var aa = Wo.tagName.toLowerCase();
                      if (Wo.isContentEditable)
                        return !0;
                      var Ea = ["button", "checkbox", "hidden", "radio", "reset", "submit"];
                      if (aa === "input")
                        return Ea.indexOf(Wo.type) === -1;
                      var Ka = ["textarea"];
                      return Ka.indexOf(aa) !== -1;
                    };
                    wi(this.el_.ownerDocument.activeElement) || (typeof hi.hotkeys == "function" ? hi.hotkeys.call(this, ci) : this.handleHotkeys(ci));
                  }
                }, bi.handleHotkeys = function(ci) {
                  var hi = this.options_.userActions ? this.options_.userActions.hotkeys : {}, wi = hi.fullscreenKey, zi = wi === void 0 ? function(Sl) {
                    return vi().isEventKey(Sl, "f");
                  } : wi, Wo = hi.muteKey, aa = Wo === void 0 ? function(Sl) {
                    return vi().isEventKey(Sl, "m");
                  } : Wo, Ea = hi.playPauseKey, Ka = Ea === void 0 ? function(Sl) {
                    return vi().isEventKey(Sl, "k") || vi().isEventKey(Sl, "Space");
                  } : Ea;
                  if (zi.call(this, ci)) {
                    ci.preventDefault(), ci.stopPropagation();
                    var Ha = ou.getComponent("FullscreenToggle");
                    gi()[this.fsApi_.fullscreenEnabled] !== !1 && Ha.prototype.handleClick.call(this, ci);
                  } else if (aa.call(this, ci)) {
                    ci.preventDefault(), ci.stopPropagation();
                    var ks = ou.getComponent("MuteToggle");
                    ks.prototype.handleClick.call(this, ci);
                  } else if (Ka.call(this, ci)) {
                    ci.preventDefault(), ci.stopPropagation();
                    var gl = ou.getComponent("PlayToggle");
                    gl.prototype.handleClick.call(this, ci);
                  }
                }, bi.canPlayType = function(ci) {
                  for (var hi, wi = 0, zi = this.options_.techOrder; wi < zi.length; wi++) {
                    var Wo = zi[wi], aa = Sc.getTech(Wo);
                    if (aa || (aa = ou.getComponent(Wo)), !aa) {
                      Xa.error('The "' + Wo + '" tech is undefined. Skipped browser support check for that tech.');
                      continue;
                    }
                    if (aa.isSupported() && (hi = aa.canPlayType(ci), hi))
                      return hi;
                  }
                  return "";
                }, bi.selectSource = function(ci) {
                  var hi = this, wi = this.options_.techOrder.map(function(Ka) {
                    return [Ka, Sc.getTech(Ka)];
                  }).filter(function(Ka) {
                    var Ha = Ka[0], ks = Ka[1];
                    return ks ? ks.isSupported() : (Xa.error('The "' + Ha + '" tech is undefined. Skipped browser support check for that tech.'), !1);
                  }), zi = function(Ha, ks, gl) {
                    var Sl;
                    return Ha.some(function(Fl) {
                      return ks.some(function(ru) {
                        if (Sl = gl(Fl, ru), Sl)
                          return !0;
                      });
                    }), Sl;
                  }, Wo, aa = function(Ha) {
                    return function(ks, gl) {
                      return Ha(gl, ks);
                    };
                  }, Ea = function(Ha, ks) {
                    var gl = Ha[0], Sl = Ha[1];
                    if (Sl.canPlaySource(ks, hi.options_[gl.toLowerCase()]))
                      return {
                        source: ks,
                        tech: gl
                      };
                  };
                  return this.options_.sourceOrder ? Wo = zi(ci, wi, aa(Ea)) : Wo = zi(wi, ci, Ea), Wo || !1;
                }, bi.handleSrc_ = function(ci, hi) {
                  var wi = this;
                  if (typeof ci > "u")
                    return this.cache_.src || "";
                  this.resetRetryOnError_ && this.resetRetryOnError_();
                  var zi = Sh(ci);
                  if (!zi.length) {
                    this.setTimeout(function() {
                      this.error({
                        code: 4,
                        message: this.options_.notSupportedMessage
                      });
                    }, 0);
                    return;
                  }
                  if (this.changingSrc_ = !0, hi || (this.cache_.sources = zi), this.updateSourceCaches_(zi[0]), Cd(this, zi[0], function(Ea, Ka) {
                    wi.middleware_ = Ka, hi || (wi.cache_.sources = zi), wi.updateSourceCaches_(Ea);
                    var Ha = wi.src_(Ea);
                    if (Ha) {
                      if (zi.length > 1)
                        return wi.handleSrc_(zi.slice(1));
                      wi.changingSrc_ = !1, wi.setTimeout(function() {
                        this.error({
                          code: 4,
                          message: this.options_.notSupportedMessage
                        });
                      }, 0), wi.triggerReady();
                      return;
                    }
                    Hf(Ka, wi.tech_);
                  }), this.options_.retryOnError && zi.length > 1) {
                    var Wo = function() {
                      wi.error(null), wi.handleSrc_(zi.slice(1), !0);
                    }, aa = function() {
                      wi.off("error", Wo);
                    };
                    this.one("error", Wo), this.one("playing", aa), this.resetRetryOnError_ = function() {
                      wi.off("error", Wo), wi.off("playing", aa);
                    };
                  }
                }, bi.src = function(ci) {
                  return this.handleSrc_(ci, !1);
                }, bi.src_ = function(ci) {
                  var hi = this, wi = this.selectSource([ci]);
                  return wi ? qh(wi.tech, this.techName_) ? (this.ready(function() {
                    this.tech_.constructor.prototype.hasOwnProperty("setSource") ? this.techCall_("setSource", ci) : this.techCall_("src", ci.src), this.changingSrc_ = !1;
                  }, !0), !1) : (this.changingSrc_ = !0, this.loadTech_(wi.tech, wi.source), this.tech_.ready(function() {
                    hi.changingSrc_ = !1;
                  }), !1) : !0;
                }, bi.load = function() {
                  this.techCall_("load");
                }, bi.reset = function() {
                  var ci = this, hi = this.options_.Promise || di().Promise;
                  if (this.paused() || !hi)
                    this.doReset_();
                  else {
                    var wi = this.play();
                    wd(wi.then(function() {
                      return ci.doReset_();
                    }));
                  }
                }, bi.doReset_ = function() {
                  this.tech_ && this.tech_.clearTracks("text"), this.resetCache_(), this.poster(""), this.loadTech_(this.options_.techOrder[0], null), this.techCall_("reset"), this.resetControlBarUI_(), Vd(this) && this.trigger("playerreset");
                }, bi.resetControlBarUI_ = function() {
                  this.resetProgressBar_(), this.resetPlaybackRate_(), this.resetVolumeBar_();
                }, bi.resetProgressBar_ = function() {
                  this.currentTime(0);
                  var ci = this.controlBar || {}, hi = ci.durationDisplay, wi = ci.remainingTimeDisplay;
                  hi && hi.updateContent(), wi && wi.updateContent();
                }, bi.resetPlaybackRate_ = function() {
                  this.playbackRate(this.defaultPlaybackRate()), this.handleTechRateChange_();
                }, bi.resetVolumeBar_ = function() {
                  this.volume(1), this.trigger("volumechange");
                }, bi.currentSources = function() {
                  var ci = this.currentSource(), hi = [];
                  return Object.keys(ci).length !== 0 && hi.push(ci), this.cache_.sources || hi;
                }, bi.currentSource = function() {
                  return this.cache_.source || {};
                }, bi.currentSrc = function() {
                  return this.currentSource() && this.currentSource().src || "";
                }, bi.currentType = function() {
                  return this.currentSource() && this.currentSource().type || "";
                }, bi.preload = function(ci) {
                  if (ci !== void 0) {
                    this.techCall_("setPreload", ci), this.options_.preload = ci;
                    return;
                  }
                  return this.techGet_("preload");
                }, bi.autoplay = function(ci) {
                  if (ci === void 0)
                    return this.options_.autoplay || !1;
                  var hi;
                  typeof ci == "string" && /(any|play|muted)/.test(ci) || ci === !0 && this.options_.normalizeAutoplay ? (this.options_.autoplay = ci, this.manualAutoplay_(typeof ci == "string" ? ci : "play"), hi = !1) : ci ? this.options_.autoplay = !0 : this.options_.autoplay = !1, hi = typeof hi > "u" ? this.options_.autoplay : hi, this.tech_ && this.techCall_("setAutoplay", hi);
                }, bi.playsinline = function(ci) {
                  return ci !== void 0 ? (this.techCall_("setPlaysinline", ci), this.options_.playsinline = ci, this) : this.techGet_("playsinline");
                }, bi.loop = function(ci) {
                  if (ci !== void 0) {
                    this.techCall_("setLoop", ci), this.options_.loop = ci;
                    return;
                  }
                  return this.techGet_("loop");
                }, bi.poster = function(ci) {
                  if (ci === void 0)
                    return this.poster_;
                  ci || (ci = ""), ci !== this.poster_ && (this.poster_ = ci, this.techCall_("setPoster", ci), this.isPosterFromTech_ = !1, this.trigger("posterchange"));
                }, bi.handleTechPosterChange_ = function() {
                  if ((!this.poster_ || this.options_.techCanOverridePoster) && this.tech_ && this.tech_.poster) {
                    var ci = this.tech_.poster() || "";
                    ci !== this.poster_ && (this.poster_ = ci, this.isPosterFromTech_ = !0, this.trigger("posterchange"));
                  }
                }, bi.controls = function(ci) {
                  if (ci === void 0)
                    return !!this.controls_;
                  ci = !!ci, this.controls_ !== ci && (this.controls_ = ci, this.usingNativeControls() && this.techCall_("setControls", ci), this.controls_ ? (this.removeClass("vjs-controls-disabled"), this.addClass("vjs-controls-enabled"), this.trigger("controlsenabled"), this.usingNativeControls() || this.addTechControlsListeners_()) : (this.removeClass("vjs-controls-enabled"), this.addClass("vjs-controls-disabled"), this.trigger("controlsdisabled"), this.usingNativeControls() || this.removeTechControlsListeners_()));
                }, bi.usingNativeControls = function(ci) {
                  if (ci === void 0)
                    return !!this.usingNativeControls_;
                  ci = !!ci, this.usingNativeControls_ !== ci && (this.usingNativeControls_ = ci, this.usingNativeControls_ ? (this.addClass("vjs-using-native-controls"), this.trigger("usingnativecontrols")) : (this.removeClass("vjs-using-native-controls"), this.trigger("usingcustomcontrols")));
                }, bi.error = function(ci) {
                  var hi = this;
                  if (ci === void 0)
                    return this.error_ || null;
                  if (Lo("beforeerror").forEach(function(zi) {
                    var Wo = zi(hi, ci);
                    if (!(rs(Wo) && !Array.isArray(Wo) || typeof Wo == "string" || typeof Wo == "number" || Wo === null)) {
                      hi.log.error("please return a value that MediaError expects in beforeerror hooks");
                      return;
                    }
                    ci = Wo;
                  }), this.options_.suppressNotSupportedError && ci && ci.code === 4) {
                    var wi = function() {
                      this.error(ci);
                    };
                    this.options_.suppressNotSupportedError = !1, this.any(["click", "touchstart"], wi), this.one("loadstart", function() {
                      this.off(["click", "touchstart"], wi);
                    });
                    return;
                  }
                  if (ci === null) {
                    this.error_ = ci, this.removeClass("vjs-error"), this.errorDisplay && this.errorDisplay.close();
                    return;
                  }
                  this.error_ = new od(ci), this.addClass("vjs-error"), Xa.error("(CODE:" + this.error_.code + " " + od.errorTypes[this.error_.code] + ")", this.error_.message, this.error_), this.trigger("error"), Lo("error").forEach(function(zi) {
                    return zi(hi, hi.error_);
                  });
                }, bi.reportUserActivity = function(ci) {
                  this.userActivity_ = !0;
                }, bi.userActive = function(ci) {
                  if (ci === void 0)
                    return this.userActive_;
                  if (ci = !!ci, ci !== this.userActive_) {
                    if (this.userActive_ = ci, this.userActive_) {
                      this.userActivity_ = !0, this.removeClass("vjs-user-inactive"), this.addClass("vjs-user-active"), this.trigger("useractive");
                      return;
                    }
                    this.tech_ && this.tech_.one("mousemove", function(hi) {
                      hi.stopPropagation(), hi.preventDefault();
                    }), this.userActivity_ = !1, this.removeClass("vjs-user-active"), this.addClass("vjs-user-inactive"), this.trigger("userinactive");
                  }
                }, bi.listenForUserActivity_ = function() {
                  var ci, hi, wi, zi = Tc(this, this.reportUserActivity), Wo = function(gl) {
                    (gl.screenX !== hi || gl.screenY !== wi) && (hi = gl.screenX, wi = gl.screenY, zi());
                  }, aa = function() {
                    zi(), this.clearInterval(ci), ci = this.setInterval(zi, 250);
                  }, Ea = function(gl) {
                    zi(), this.clearInterval(ci);
                  };
                  this.on("mousedown", aa), this.on("mousemove", Wo), this.on("mouseup", Ea), this.on("mouseleave", Ea);
                  var Ka = this.getChild("controlBar");
                  Ka && !Tu && !Vs && (Ka.on("mouseenter", function(ks) {
                    this.player().options_.inactivityTimeout !== 0 && (this.player().cache_.inactivityTimeout = this.player().options_.inactivityTimeout), this.player().options_.inactivityTimeout = 0;
                  }), Ka.on("mouseleave", function(ks) {
                    this.player().options_.inactivityTimeout = this.player().cache_.inactivityTimeout;
                  })), this.on("keydown", zi), this.on("keyup", zi);
                  var Ha;
                  this.setInterval(function() {
                    if (this.userActivity_) {
                      this.userActivity_ = !1, this.userActive(!0), this.clearTimeout(Ha);
                      var ks = this.options_.inactivityTimeout;
                      ks <= 0 || (Ha = this.setTimeout(function() {
                        this.userActivity_ || this.userActive(!1);
                      }, ks));
                    }
                  }, 250);
                }, bi.playbackRate = function(ci) {
                  if (ci !== void 0) {
                    this.techCall_("setPlaybackRate", ci);
                    return;
                  }
                  return this.tech_ && this.tech_.featuresPlaybackRate ? this.cache_.lastPlaybackRate || this.techGet_("playbackRate") : 1;
                }, bi.defaultPlaybackRate = function(ci) {
                  return ci !== void 0 ? this.techCall_("setDefaultPlaybackRate", ci) : this.tech_ && this.tech_.featuresPlaybackRate ? this.techGet_("defaultPlaybackRate") : 1;
                }, bi.isAudio = function(ci) {
                  if (ci !== void 0) {
                    this.isAudio_ = !!ci;
                    return;
                  }
                  return !!this.isAudio_;
                }, bi.enableAudioOnlyUI_ = function() {
                  var ci = this;
                  this.addClass("vjs-audio-only-mode");
                  var hi = this.children(), wi = this.getChild("ControlBar"), zi = wi && wi.currentHeight();
                  hi.forEach(function(Wo) {
                    Wo !== wi && Wo.el_ && !Wo.hasClass("vjs-hidden") && (Wo.hide(), ci.audioOnlyCache_.hiddenChildren.push(Wo));
                  }), this.audioOnlyCache_.playerHeight = this.currentHeight(), this.height(zi), this.trigger("audioonlymodechange");
                }, bi.disableAudioOnlyUI_ = function() {
                  this.removeClass("vjs-audio-only-mode"), this.audioOnlyCache_.hiddenChildren.forEach(function(ci) {
                    return ci.show();
                  }), this.height(this.audioOnlyCache_.playerHeight), this.trigger("audioonlymodechange");
                }, bi.audioOnlyMode = function(ci) {
                  var hi = this;
                  if (typeof ci != "boolean" || ci === this.audioOnlyMode_)
                    return this.audioOnlyMode_;
                  this.audioOnlyMode_ = ci;
                  var wi = this.options_.Promise || di().Promise;
                  if (wi) {
                    if (ci) {
                      var zi = [];
                      return this.isInPictureInPicture() && zi.push(this.exitPictureInPicture()), this.isFullscreen() && zi.push(this.exitFullscreen()), this.audioPosterMode() && zi.push(this.audioPosterMode(!1)), wi.all(zi).then(function() {
                        return hi.enableAudioOnlyUI_();
                      });
                    }
                    return wi.resolve().then(function() {
                      return hi.disableAudioOnlyUI_();
                    });
                  }
                  ci ? (this.isInPictureInPicture() && this.exitPictureInPicture(), this.isFullscreen() && this.exitFullscreen(), this.enableAudioOnlyUI_()) : this.disableAudioOnlyUI_();
                }, bi.enablePosterModeUI_ = function() {
                  var ci = this.tech_ && this.tech_;
                  ci.hide(), this.addClass("vjs-audio-poster-mode"), this.trigger("audiopostermodechange");
                }, bi.disablePosterModeUI_ = function() {
                  var ci = this.tech_ && this.tech_;
                  ci.show(), this.removeClass("vjs-audio-poster-mode"), this.trigger("audiopostermodechange");
                }, bi.audioPosterMode = function(ci) {
                  var hi = this;
                  if (typeof ci != "boolean" || ci === this.audioPosterMode_)
                    return this.audioPosterMode_;
                  this.audioPosterMode_ = ci;
                  var wi = this.options_.Promise || di().Promise;
                  if (wi) {
                    if (ci) {
                      if (this.audioOnlyMode()) {
                        var zi = this.audioOnlyMode(!1);
                        return zi.then(function() {
                          hi.enablePosterModeUI_();
                        });
                      }
                      return wi.resolve().then(function() {
                        hi.enablePosterModeUI_();
                      });
                    }
                    return wi.resolve().then(function() {
                      hi.disablePosterModeUI_();
                    });
                  }
                  if (ci) {
                    this.audioOnlyMode() && this.audioOnlyMode(!1), this.enablePosterModeUI_();
                    return;
                  }
                  this.disablePosterModeUI_();
                }, bi.addTextTrack = function(ci, hi, wi) {
                  if (this.tech_)
                    return this.tech_.addTextTrack(ci, hi, wi);
                }, bi.addRemoteTextTrack = function(ci, hi) {
                  if (this.tech_)
                    return this.tech_.addRemoteTextTrack(ci, hi);
                }, bi.removeRemoteTextTrack = function(ci) {
                  ci === void 0 && (ci = {});
                  var hi = ci, wi = hi.track;
                  if (wi || (wi = ci), this.tech_)
                    return this.tech_.removeRemoteTextTrack(wi);
                }, bi.getVideoPlaybackQuality = function() {
                  return this.techGet_("getVideoPlaybackQuality");
                }, bi.videoWidth = function() {
                  return this.tech_ && this.tech_.videoWidth && this.tech_.videoWidth() || 0;
                }, bi.videoHeight = function() {
                  return this.tech_ && this.tech_.videoHeight && this.tech_.videoHeight() || 0;
                }, bi.language = function(ci) {
                  if (ci === void 0)
                    return this.language_;
                  this.language_ !== String(ci).toLowerCase() && (this.language_ = String(ci).toLowerCase(), Vd(this) && this.trigger("languagechange"));
                }, bi.languages = function() {
                  return Ec(Ei.prototype.options_.languages, this.languages_);
                }, bi.toJSON = function() {
                  var ci = Ec(this.options_), hi = ci.tracks;
                  ci.tracks = [];
                  for (var wi = 0; wi < hi.length; wi++) {
                    var zi = hi[wi];
                    zi = Ec(zi), zi.player = void 0, ci.tracks[wi] = zi;
                  }
                  return ci;
                }, bi.createModal = function(ci, hi) {
                  var wi = this;
                  hi = hi || {}, hi.content = ci || "";
                  var zi = new hd(this, hi);
                  return this.addChild(zi), zi.on("dispose", function() {
                    wi.removeChild(zi);
                  }), zi.open(), zi;
                }, bi.updateCurrentBreakpoint_ = function() {
                  if (this.responsive())
                    for (var ci = this.currentBreakpoint(), hi = this.currentWidth(), wi = 0; wi < Yg.length; wi++) {
                      var zi = Yg[wi], Wo = this.breakpoints_[zi];
                      if (hi <= Wo) {
                        if (ci === zi)
                          return;
                        ci && this.removeClass(Rg[ci]), this.addClass(Rg[zi]), this.breakpoint_ = zi;
                        break;
                      }
                    }
                }, bi.removeCurrentBreakpoint_ = function() {
                  var ci = this.currentBreakpointClass();
                  this.breakpoint_ = "", ci && this.removeClass(ci);
                }, bi.breakpoints = function(ci) {
                  return ci === void 0 ? Ta(this.breakpoints_) : (this.breakpoint_ = "", this.breakpoints_ = Ta({}, ay, ci), this.updateCurrentBreakpoint_(), Ta(this.breakpoints_));
                }, bi.responsive = function(ci) {
                  if (ci === void 0)
                    return this.responsive_;
                  ci = !!ci;
                  var hi = this.responsive_;
                  if (ci !== hi)
                    return this.responsive_ = ci, ci ? (this.on("playerresize", this.boundUpdateCurrentBreakpoint_), this.updateCurrentBreakpoint_()) : (this.off("playerresize", this.boundUpdateCurrentBreakpoint_), this.removeCurrentBreakpoint_()), ci;
                }, bi.currentBreakpoint = function() {
                  return this.breakpoint_;
                }, bi.currentBreakpointClass = function() {
                  return Rg[this.breakpoint_] || "";
                }, bi.loadMedia = function(ci, hi) {
                  var wi = this;
                  if (!(!ci || typeof ci != "object")) {
                    this.reset(), this.cache_.media = Ec(ci);
                    var zi = this.cache_.media, Wo = zi.artwork, aa = zi.poster, Ea = zi.src, Ka = zi.textTracks;
                    !Wo && aa && (this.cache_.media.artwork = [{
                      src: aa,
                      type: zf(aa)
                    }]), Ea && this.src(Ea), aa && this.poster(aa), Array.isArray(Ka) && Ka.forEach(function(Ha) {
                      return wi.addRemoteTextTrack(Ha, !1);
                    }), this.ready(hi);
                  }
                }, bi.getMedia = function() {
                  if (!this.cache_.media) {
                    var ci = this.poster(), hi = this.currentSources(), wi = Array.prototype.map.call(this.remoteTextTracks(), function(Wo) {
                      return {
                        kind: Wo.kind,
                        label: Wo.label,
                        language: Wo.language,
                        src: Wo.src
                      };
                    }), zi = {
                      src: hi,
                      textTracks: wi
                    };
                    return ci && (zi.poster = ci, zi.artwork = [{
                      src: zi.poster,
                      type: zf(zi.poster)
                    }]), zi;
                  }
                  return Ec(this.cache_.media);
                }, Ei.getTagSettings = function(ci) {
                  var hi = {
                    sources: [],
                    tracks: []
                  }, wi = tu(ci), zi = wi["data-setup"];
                  if (zs(ci, "vjs-fill") && (wi.fill = !0), zs(ci, "vjs-fluid") && (wi.fluid = !0), zi !== null) {
                    var Wo = $i()(zi || "{}"), aa = Wo[0], Ea = Wo[1];
                    aa && Xa.error(aa), Ta(wi, Ea);
                  }
                  if (Ta(hi, wi), ci.hasChildNodes())
                    for (var Ka = ci.childNodes, Ha = 0, ks = Ka.length; Ha < ks; Ha++) {
                      var gl = Ka[Ha], Sl = gl.nodeName.toLowerCase();
                      Sl === "source" ? hi.sources.push(tu(gl)) : Sl === "track" && hi.tracks.push(tu(gl));
                    }
                  return hi;
                }, bi.flexNotSupported_ = function() {
                  var ci = gi().createElement("i");
                  return !("flexBasis" in ci.style || "webkitFlexBasis" in ci.style || "mozFlexBasis" in ci.style || "msFlexBasis" in ci.style || // IE10-specific (2012 flex spec), available for completeness
                  "msFlexOrder" in ci.style);
                }, bi.debug = function(ci) {
                  if (ci === void 0)
                    return this.debugEnabled_;
                  ci ? (this.trigger("debugon"), this.previousLogLevel_ = this.log.level, this.log.level("debug"), this.debugEnabled_ = !0) : (this.trigger("debugoff"), this.log.level(this.previousLogLevel_), this.previousLogLevel_ = void 0, this.debugEnabled_ = !1);
                }, bi.playbackRates = function(ci) {
                  if (ci === void 0)
                    return this.cache_.playbackRates;
                  Array.isArray(ci) && ci.every(function(hi) {
                    return typeof hi == "number";
                  }) && (this.cache_.playbackRates = ci, this.trigger("playbackrateschange"));
                }, Ei;
              })(ou);
              Yc.names.forEach(function(Vi) {
                var Ei = Yc[Vi];
                id.prototype[Ei.getterName] = function() {
                  return this.tech_ ? this.tech_[Ei.getterName]() : (this[Ei.privateName] = this[Ei.privateName] || new Ei.ListClass(), this[Ei.privateName]);
                };
              }), id.prototype.crossorigin = id.prototype.crossOrigin, id.players = {};
              var ig = di().navigator;
              id.prototype.options_ = {
                // Default order of fallback technology
                techOrder: Sc.defaultTechOrder_,
                html5: {},
                // default inactivity timeout
                inactivityTimeout: 2e3,
                // default playback rates
                playbackRates: [],
                // Add playback rate selection by adding rates
                // 'playbackRates': [0.5, 1, 1.5, 2],
                liveui: !1,
                // Included control sets
                children: ["mediaLoader", "posterImage", "textTrackDisplay", "loadingSpinner", "bigPlayButton", "liveTracker", "controlBar", "errorDisplay", "textTrackSettings", "resizeManager"],
                language: ig && (ig.languages && ig.languages[0] || ig.userLanguage || ig.language) || "en",
                // locales and their language translations
                languages: {},
                // Default message to show when a video cannot be played.
                notSupportedMessage: "No compatible source was found for this media.",
                normalizeAutoplay: !1,
                fullscreen: {
                  options: {
                    navigationUI: "hide"
                  }
                },
                breakpoints: {},
                responsive: !1,
                audioOnlyMode: !1,
                audioPosterMode: !1
              }, [
                /**
                 * Returns whether or not the player is in the "ended" state.
                 *
                 * @return {Boolean} True if the player is in the ended state, false if not.
                 * @method Player#ended
                 */
                "ended",
                /**
                 * Returns whether or not the player is in the "seeking" state.
                 *
                 * @return {Boolean} True if the player is in the seeking state, false if not.
                 * @method Player#seeking
                 */
                "seeking",
                /**
                 * Returns the TimeRanges of the media that are currently available
                 * for seeking to.
                 *
                 * @return {TimeRanges} the seekable intervals of the media timeline
                 * @method Player#seekable
                 */
                "seekable",
                /**
                 * Returns the current state of network activity for the element, from
                 * the codes in the list below.
                 * - NETWORK_EMPTY (numeric value 0)
                 *   The element has not yet been initialised. All attributes are in
                 *   their initial states.
                 * - NETWORK_IDLE (numeric value 1)
                 *   The element's resource selection algorithm is active and has
                 *   selected a resource, but it is not actually using the network at
                 *   this time.
                 * - NETWORK_LOADING (numeric value 2)
                 *   The user agent is actively trying to download data.
                 * - NETWORK_NO_SOURCE (numeric value 3)
                 *   The element's resource selection algorithm is active, but it has
                 *   not yet found a resource to use.
                 *
                 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#network-states
                 * @return {number} the current network activity state
                 * @method Player#networkState
                 */
                "networkState",
                /**
                 * Returns a value that expresses the current state of the element
                 * with respect to rendering the current playback position, from the
                 * codes in the list below.
                 * - HAVE_NOTHING (numeric value 0)
                 *   No information regarding the media resource is available.
                 * - HAVE_METADATA (numeric value 1)
                 *   Enough of the resource has been obtained that the duration of the
                 *   resource is available.
                 * - HAVE_CURRENT_DATA (numeric value 2)
                 *   Data for the immediate current playback position is available.
                 * - HAVE_FUTURE_DATA (numeric value 3)
                 *   Data for the immediate current playback position is available, as
                 *   well as enough data for the user agent to advance the current
                 *   playback position in the direction of playback.
                 * - HAVE_ENOUGH_DATA (numeric value 4)
                 *   The user agent estimates that enough data is available for
                 *   playback to proceed uninterrupted.
                 *
                 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-readystate
                 * @return {number} the current playback rendering state
                 * @method Player#readyState
                 */
                "readyState"
              ].forEach(function(Vi) {
                id.prototype[Vi] = function() {
                  return this.techGet_(Vi);
                };
              }), ng.forEach(function(Vi) {
                id.prototype["handleTech" + Ic(Vi) + "_"] = function() {
                  return this.trigger(Vi);
                };
              }), ou.registerComponent("Player", id);
              var Dh = "plugin", Dp = "activePlugins_", Rf = {}, ih = function(Ei) {
                return Rf.hasOwnProperty(Ei);
              }, pf = function(Ei) {
                return ih(Ei) ? Rf[Ei] : void 0;
              }, Xg = function(Ei, bi) {
                Ei[Dp] = Ei[Dp] || {}, Ei[Dp][bi] = !0;
              }, oh = function(Ei, bi, yi) {
                var ci = (yi ? "before" : "") + "pluginsetup";
                Ei.trigger(ci, bi), Ei.trigger(ci + ":" + bi.name, bi);
              }, sy = function(Ei, bi) {
                var yi = function() {
                  oh(this, {
                    name: Ei,
                    plugin: bi,
                    instance: null
                  }, !0);
                  var hi = bi.apply(this, arguments);
                  return Xg(this, Ei), oh(this, {
                    name: Ei,
                    plugin: bi,
                    instance: hi
                  }), hi;
                };
                return Object.keys(bi).forEach(function(ci) {
                  yi[ci] = bi[ci];
                }), yi;
              }, Jg = function(Ei, bi) {
                return bi.prototype.name = Ei, function() {
                  oh(this, {
                    name: Ei,
                    plugin: bi,
                    instance: null
                  }, !0);
                  for (var yi = arguments.length, ci = new Array(yi), hi = 0; hi < yi; hi++)
                    ci[hi] = arguments[hi];
                  var wi = (0, io.default)(bi, [this].concat(ci));
                  return this[Ei] = function() {
                    return wi;
                  }, oh(this, wi.getEventHash()), wi;
                };
              }, Yf = /* @__PURE__ */ (function() {
                function Vi(bi) {
                  if (this.constructor === Vi)
                    throw new Error("Plugin must be sub-classed; not directly instantiated.");
                  this.player = bi, this.log || (this.log = this.player.log.createLogger(this.name)), Up(this), delete this.trigger, hh(this, this.constructor.defaultState), Xg(bi, this.name), this.dispose = this.dispose.bind(this), bi.on("dispose", this.dispose);
                }
                var Ei = Vi.prototype;
                return Ei.version = function() {
                  return this.constructor.VERSION;
                }, Ei.getEventHash = function(yi) {
                  return yi === void 0 && (yi = {}), yi.name = this.name, yi.plugin = this.constructor, yi.instance = this, yi;
                }, Ei.trigger = function(yi, ci) {
                  return ci === void 0 && (ci = {}), jf(this.eventBusEl_, yi, this.getEventHash(ci));
                }, Ei.handleStateChanged = function(yi) {
                }, Ei.dispose = function() {
                  var yi = this.name, ci = this.player;
                  this.trigger("dispose"), this.off(), ci.off("dispose", this.dispose), ci[Dp][yi] = !1, this.player = this.state = null, ci[yi] = Jg(yi, Rf[yi]);
                }, Vi.isBasic = function(yi) {
                  var ci = typeof yi == "string" ? pf(yi) : yi;
                  return typeof ci == "function" && !Vi.prototype.isPrototypeOf(ci.prototype);
                }, Vi.registerPlugin = function(yi, ci) {
                  if (typeof yi != "string")
                    throw new Error('Illegal plugin name, "' + yi + '", must be a string, was ' + typeof yi + ".");
                  if (ih(yi))
                    Xa.warn('A plugin named "' + yi + '" already exists. You may want to avoid re-registering plugins!');
                  else if (id.prototype.hasOwnProperty(yi))
                    throw new Error('Illegal plugin name, "' + yi + '", cannot share a name with an existing player method!');
                  if (typeof ci != "function")
                    throw new Error('Illegal plugin for "' + yi + '", must be a function, was ' + typeof ci + ".");
                  return Rf[yi] = ci, yi !== Dh && (Vi.isBasic(ci) ? id.prototype[yi] = sy(yi, ci) : id.prototype[yi] = Jg(yi, ci)), ci;
                }, Vi.deregisterPlugin = function(yi) {
                  if (yi === Dh)
                    throw new Error("Cannot de-register base plugin.");
                  ih(yi) && (delete Rf[yi], delete id.prototype[yi]);
                }, Vi.getPlugins = function(yi) {
                  yi === void 0 && (yi = Object.keys(Rf));
                  var ci;
                  return yi.forEach(function(hi) {
                    var wi = pf(hi);
                    wi && (ci = ci || {}, ci[hi] = wi);
                  }), ci;
                }, Vi.getPluginVersion = function(yi) {
                  var ci = pf(yi);
                  return ci && ci.VERSION || "";
                }, Vi;
              })();
              Yf.getPlugin = pf, Yf.BASE_PLUGIN_NAME = Dh, Yf.registerPlugin(Dh, Yf), id.prototype.usingPlugin = function(Vi) {
                return !!this[Dp] && this[Dp][Vi] === !0;
              }, id.prototype.hasPlugin = function(Vi) {
                return !!ih(Vi);
              };
              var zm = !1, ly = function(Ei, bi) {
                bi === void 0 && (bi = {}), zm || (Xa.warn("videojs.extend is deprecated as of Video.js 7.22.0 and will be removed in Video.js 8.0.0"), zm = !0);
                var yi = function() {
                  Ei.apply(this, arguments);
                }, ci = {};
                typeof bi == "object" ? (bi.constructor !== Object.prototype.constructor && (yi = bi.constructor), ci = bi) : typeof bi == "function" && (yi = bi), (0, xo.default)(yi, Ei), Ei && (yi.super_ = Ei);
                for (var hi in ci)
                  ci.hasOwnProperty(hi) && (yi.prototype[hi] = ci[hi]);
                return yi;
              }, Km = function(Ei) {
                return Ei.indexOf("#") === 0 ? Ei.slice(1) : Ei;
              };
              function Rl(Vi, Ei, bi) {
                var yi = Rl.getPlayer(Vi);
                if (yi)
                  return Ei && Xa.warn('Player "' + Vi + '" is already initialised. Options will not be applied.'), bi && yi.ready(bi), yi;
                var ci = typeof Vi == "string" ? xu("#" + Km(Vi)) : Vi;
                if (!Ws(ci))
                  throw new TypeError("The element or ID supplied is not valid. (videojs)");
                (!ci.ownerDocument.defaultView || !ci.ownerDocument.body.contains(ci)) && Xa.warn("The element supplied is not included in the DOM"), Ei = Ei || {}, Ei.restoreEl === !0 && (Ei.restoreEl = (ci.parentNode && ci.parentNode.hasAttribute("data-vjs-player") ? ci.parentNode : ci).cloneNode(!0)), Lo("beforesetup").forEach(function(wi) {
                  var zi = wi(ci, Ec(Ei));
                  if (!rs(zi) || Array.isArray(zi)) {
                    Xa.error("please return an object in beforesetup hooks");
                    return;
                  }
                  Ei = Ec(Ei, zi);
                });
                var hi = ou.getComponent("Player");
                return yi = new hi(ci, Ei, bi), Lo("setup").forEach(function(wi) {
                  return wi(yi);
                }), yi;
              }
              if (Rl.hooks_ = zo, Rl.hooks = Lo, Rl.hook = sa, Rl.hookOnce = ca, Rl.removeHook = Ko, di().VIDEOJS_NO_DYNAMIC_STYLE !== !0 && Ya()) {
                var Og = xu(".vjs-styles-defaults");
                if (!Og) {
                  Og = sc("vjs-styles-defaults");
                  var og = xu("head");
                  og && og.insertBefore(Og, og.firstChild), wc(Og, `
      .video-js {
        width: 300px;
        height: 150px;
      }

      .vjs-fluid:not(.vjs-audio-only-mode) {
        padding-top: 56.25%
      }
    `);
                }
              }
              yc(1, Rl), Rl.VERSION = Hi, Rl.options = id.prototype.options_, Rl.getPlayers = function() {
                return id.players;
              }, Rl.getPlayer = function(Vi) {
                var Ei = id.players, bi;
                if (typeof Vi == "string") {
                  var yi = Km(Vi), ci = Ei[yi];
                  if (ci)
                    return ci;
                  bi = xu("#" + yi);
                } else
                  bi = Vi;
                if (Ws(bi)) {
                  var hi = bi, wi = hi.player, zi = hi.playerId;
                  if (wi || Ei[zi])
                    return wi || Ei[zi];
                }
              }, Rl.getAllPlayers = function() {
                return (
                  // Disposed players leave a key with a `null` value, so we need to make sure
                  // we filter those out.
                  Object.keys(id.players).map(function(Vi) {
                    return id.players[Vi];
                  }).filter(Boolean)
                );
              }, Rl.players = id.players, Rl.getComponent = ou.getComponent, Rl.registerComponent = function(Vi, Ei) {
                Sc.isTech(Ei) && Xa.warn("The " + Vi + " tech was registered as a component. It should instead be registered using videojs.registerTech(name, tech)"), ou.registerComponent.call(ou, Vi, Ei);
              }, Rl.getTech = Sc.getTech, Rl.registerTech = Sc.registerTech, Rl.use = Pd, Object.defineProperty(Rl, "middleware", {
                value: {},
                writeable: !1,
                enumerable: !0
              }), Object.defineProperty(Rl.middleware, "TERMINATOR", {
                value: Pp,
                writeable: !1,
                enumerable: !0
              }), Rl.browser = Wl, Rl.TOUCH_ENABLED = Ul, Rl.extend = ly, Rl.mergeOptions = Ec, Rl.bind = Tc, Rl.registerPlugin = Yf.registerPlugin, Rl.deregisterPlugin = Yf.deregisterPlugin, Rl.plugin = function(Vi, Ei) {
                return Xa.warn("videojs.plugin() is deprecated; use videojs.registerPlugin() instead"), Yf.registerPlugin(Vi, Ei);
              }, Rl.getPlugins = Yf.getPlugins, Rl.getPlugin = Yf.getPlugin, Rl.getPluginVersion = Yf.getPluginVersion, Rl.addLanguage = function(Vi, Ei) {
                var bi;
                return Vi = ("" + Vi).toLowerCase(), Rl.options.languages = Ec(Rl.options.languages, (bi = {}, bi[Vi] = Ei, bi)), Rl.options.languages[Vi];
              }, Rl.log = Xa, Rl.createLogger = Es, Rl.createTimeRange = Rl.createTimeRanges = Tf, Rl.formatTime = bs, Rl.setFormatTime = Na, Rl.resetFormatTime = Ma, Rl.parseUrl = _d, Rl.isCrossOrigin = Ef, Rl.EventTarget = Kc, Rl.on = pd, Rl.one = tp, Rl.off = Cc, Rl.trigger = jf, Rl.xhr = Di(), Rl.TextTrack = Xd, Rl.AudioTrack = np, Rl.VideoTrack = sf, ["isEl", "isTextNode", "createEl", "hasClass", "addClass", "removeClass", "toggleClass", "setAttributes", "getAttributes", "emptyEl", "appendContent", "insertContent"].forEach(function(Vi) {
                Rl[Vi] = function() {
                  return Xa.warn("videojs." + Vi + "() is deprecated; use videojs.dom." + Vi + "() instead"), hc[Vi].apply(null, arguments);
                };
              }), Rl.computedStyle = Cs, Rl.dom = hc, Rl.url = Yh, Rl.defineLazyProperty = Id, Rl.addLanguage("en", {
                "Non-Fullscreen": "Exit Fullscreen"
              });
              /*! @name @videojs/http-streaming @version 2.16.3 @license Apache-2.0 */
              var Of = fo.default, up = function(Ei, bi, yi) {
                return Ei && yi && yi.responseURL && bi !== yi.responseURL ? yi.responseURL : bi;
              }, Af = function(Ei) {
                return Rl.log.debug ? Rl.log.debug.bind(Rl, "VHS:", Ei + " >") : function() {
                };
              }, Xf = 1 / 30, Jf = Xf * 3, qm = function(Ei, bi) {
                var yi = [], ci;
                if (Ei && Ei.length)
                  for (ci = 0; ci < Ei.length; ci++)
                    bi(Ei.start(ci), Ei.end(ci)) && yi.push([Ei.start(ci), Ei.end(ci)]);
                return Rl.createTimeRanges(yi);
              }, kh = function(Ei, bi) {
                return qm(Ei, function(yi, ci) {
                  return yi - Jf <= bi && ci + Jf >= bi;
                });
              }, ag = function(Ei, bi) {
                return qm(Ei, function(yi) {
                  return yi - Xf >= bi;
                });
              }, uy = function(Ei) {
                if (Ei.length < 2)
                  return Rl.createTimeRanges();
                for (var bi = [], yi = 1; yi < Ei.length; yi++) {
                  var ci = Ei.end(yi - 1), hi = Ei.start(yi);
                  bi.push([ci, hi]);
                }
                return Rl.createTimeRanges(bi);
              }, If = function(Ei, bi) {
                var yi = null, ci = null, hi = 0, wi = [], zi = [];
                if (!Ei || !Ei.length || !bi || !bi.length)
                  return Rl.createTimeRange();
                for (var Wo = Ei.length; Wo--; )
                  wi.push({
                    time: Ei.start(Wo),
                    type: "start"
                  }), wi.push({
                    time: Ei.end(Wo),
                    type: "end"
                  });
                for (Wo = bi.length; Wo--; )
                  wi.push({
                    time: bi.start(Wo),
                    type: "start"
                  }), wi.push({
                    time: bi.end(Wo),
                    type: "end"
                  });
                for (wi.sort(function(aa, Ea) {
                  return aa.time - Ea.time;
                }), Wo = 0; Wo < wi.length; Wo++)
                  wi[Wo].type === "start" ? (hi++, hi === 2 && (yi = wi[Wo].time)) : wi[Wo].type === "end" && (hi--, hi === 1 && (ci = wi[Wo].time)), yi !== null && ci !== null && (zi.push([yi, ci]), yi = null, ci = null);
                return Rl.createTimeRanges(zi);
              }, Ym = function(Ei) {
                var bi = [];
                if (!Ei || !Ei.length)
                  return "";
                for (var yi = 0; yi < Ei.length; yi++)
                  bi.push(Ei.start(yi) + " => " + Ei.end(yi));
                return bi.join(", ");
              }, hf = function(Ei, bi, yi) {
                yi === void 0 && (yi = 1);
                var ci = Ei.length ? Ei.end(Ei.length - 1) : 0;
                return (ci - bi) / yi;
              }, Nd = function(Ei) {
                for (var bi = [], yi = 0; yi < Ei.length; yi++)
                  bi.push({
                    start: Ei.start(yi),
                    end: Ei.end(yi)
                  });
                return bi;
              }, cy = function(Ei, bi) {
                if (Ei === bi)
                  return !1;
                if (!Ei && bi || !bi && Ei || Ei.length !== bi.length)
                  return !0;
                for (var yi = 0; yi < Ei.length; yi++)
                  if (Ei.start(yi) !== bi.start(yi) || Ei.end(yi) !== bi.end(yi))
                    return !0;
                return !1;
              }, Qg = function(Ei) {
                if (!(!Ei || !Ei.length || !Ei.end))
                  return Ei.end(Ei.length - 1);
              }, sg = function(Ei, bi) {
                var yi = 0;
                if (!Ei || !Ei.length)
                  return yi;
                for (var ci = 0; ci < Ei.length; ci++) {
                  var hi = Ei.start(ci), wi = Ei.end(ci);
                  if (!(bi > wi)) {
                    if (bi > hi && bi <= wi) {
                      yi += wi - bi;
                      continue;
                    }
                    yi += wi - hi;
                  }
                }
                return yi;
              }, Xm = Rl.createTimeRange, Ag = function(Ei, bi) {
                if (!bi.preload)
                  return bi.duration;
                var yi = 0;
                return (bi.parts || []).forEach(function(ci) {
                  yi += ci.duration;
                }), (bi.preloadHints || []).forEach(function(ci) {
                  ci.type === "PART" && (yi += Ei.partTargetDuration);
                }), yi;
              }, Zg = function(Ei) {
                return (Ei.segments || []).reduce(function(bi, yi, ci) {
                  return yi.parts ? yi.parts.forEach(function(hi, wi) {
                    bi.push({
                      duration: hi.duration,
                      segmentIndex: ci,
                      partIndex: wi,
                      part: hi,
                      segment: yi
                    });
                  }) : bi.push({
                    duration: yi.duration,
                    segmentIndex: ci,
                    partIndex: null,
                    segment: yi,
                    part: null
                  }), bi;
                }, []);
              }, Jm = function(Ei) {
                var bi = Ei.segments && Ei.segments.length && Ei.segments[Ei.segments.length - 1];
                return bi && bi.parts || [];
              }, ah = function(Ei) {
                var bi = Ei.preloadSegment;
                if (bi) {
                  var yi = bi.parts, ci = bi.preloadHints, hi = (ci || []).reduce(function(wi, zi) {
                    return wi + (zi.type === "PART" ? 1 : 0);
                  }, 0);
                  return hi += yi && yi.length ? yi.length : 0, hi;
                }
              }, Mc = function(Ei, bi) {
                if (bi.endList)
                  return 0;
                if (Ei && Ei.suggestedPresentationDelay)
                  return Ei.suggestedPresentationDelay;
                var yi = Jm(bi).length > 0;
                return yi && bi.serverControl && bi.serverControl.partHoldBack ? bi.serverControl.partHoldBack : yi && bi.partTargetDuration ? bi.partTargetDuration * 3 : bi.serverControl && bi.serverControl.holdBack ? bi.serverControl.holdBack : bi.targetDuration ? bi.targetDuration * 3 : 0;
              }, Qm = function(Ei, bi) {
                var yi = 0, ci = bi - Ei.mediaSequence, hi = Ei.segments[ci];
                if (hi) {
                  if (typeof hi.start < "u")
                    return {
                      result: hi.start,
                      precise: !0
                    };
                  if (typeof hi.end < "u")
                    return {
                      result: hi.end - hi.duration,
                      precise: !0
                    };
                }
                for (; ci--; ) {
                  if (hi = Ei.segments[ci], typeof hi.end < "u")
                    return {
                      result: yi + hi.end,
                      precise: !0
                    };
                  if (yi += Ag(Ei, hi), typeof hi.start < "u")
                    return {
                      result: yi + hi.start,
                      precise: !0
                    };
                }
                return {
                  result: yi,
                  precise: !1
                };
              }, gf = function(Ei, bi) {
                for (var yi = 0, ci, hi = bi - Ei.mediaSequence; hi < Ei.segments.length; hi++) {
                  if (ci = Ei.segments[hi], typeof ci.start < "u")
                    return {
                      result: ci.start - yi,
                      precise: !0
                    };
                  if (yi += Ag(Ei, ci), typeof ci.end < "u")
                    return {
                      result: ci.end - yi,
                      precise: !0
                    };
                }
                return {
                  result: -1,
                  precise: !1
                };
              }, Zm = function(Ei, bi, yi) {
                if (typeof bi > "u" && (bi = Ei.mediaSequence + Ei.segments.length), bi < Ei.mediaSequence)
                  return 0;
                var ci = Qm(Ei, bi);
                if (ci.precise)
                  return ci.result;
                var hi = gf(Ei, bi);
                return hi.precise ? hi.result : ci.result + yi;
              }, em = function(Ei, bi, yi) {
                if (!Ei)
                  return 0;
                if (typeof yi != "number" && (yi = 0), typeof bi > "u") {
                  if (Ei.totalDuration)
                    return Ei.totalDuration;
                  if (!Ei.endList)
                    return di()[1 / 0];
                }
                return Zm(Ei, bi, yi);
              }, lg = function(Ei) {
                var bi = Ei.defaultDuration, yi = Ei.durationList, ci = Ei.startIndex, hi = Ei.endIndex, wi = 0;
                if (ci > hi) {
                  var zi = [hi, ci];
                  ci = zi[0], hi = zi[1];
                }
                if (ci < 0) {
                  for (var Wo = ci; Wo < Math.min(0, hi); Wo++)
                    wi += bi;
                  ci = 0;
                }
                for (var aa = ci; aa < hi; aa++)
                  wi += yi[aa].duration;
                return wi;
              }, ev = function(Ei, bi, yi, ci) {
                if (!Ei || !Ei.segments)
                  return null;
                if (Ei.endList)
                  return em(Ei);
                if (bi === null)
                  return null;
                bi = bi || 0;
                var hi = Zm(Ei, Ei.mediaSequence + Ei.segments.length, bi);
                return yi && (ci = typeof ci == "number" ? ci : Mc(null, Ei), hi -= ci), Math.max(0, hi);
              }, dy = function(Ei, bi, yi) {
                var ci = !0, hi = bi || 0, wi = ev(Ei, bi, ci, yi);
                return wi === null ? Xm() : Xm(hi, wi);
              }, fy = function(Ei) {
                for (var bi = Ei.playlist, yi = Ei.currentTime, ci = Ei.startingSegmentIndex, hi = Ei.startingPartIndex, wi = Ei.startTime, zi = Ei.experimentalExactManifestTimings, Wo = yi - wi, aa = Zg(bi), Ea = 0, Ka = 0; Ka < aa.length; Ka++) {
                  var Ha = aa[Ka];
                  if (ci === Ha.segmentIndex && !(typeof hi == "number" && typeof Ha.partIndex == "number" && hi !== Ha.partIndex)) {
                    Ea = Ka;
                    break;
                  }
                }
                if (Wo < 0) {
                  if (Ea > 0)
                    for (var ks = Ea - 1; ks >= 0; ks--) {
                      var gl = aa[ks];
                      if (Wo += gl.duration, zi) {
                        if (Wo < 0)
                          continue;
                      } else if (Wo + Xf <= 0)
                        continue;
                      return {
                        partIndex: gl.partIndex,
                        segmentIndex: gl.segmentIndex,
                        startTime: wi - lg({
                          defaultDuration: bi.targetDuration,
                          durationList: aa,
                          startIndex: Ea,
                          endIndex: ks
                        })
                      };
                    }
                  return {
                    partIndex: aa[0] && aa[0].partIndex || null,
                    segmentIndex: aa[0] && aa[0].segmentIndex || 0,
                    startTime: yi
                  };
                }
                if (Ea < 0) {
                  for (var Sl = Ea; Sl < 0; Sl++)
                    if (Wo -= bi.targetDuration, Wo < 0)
                      return {
                        partIndex: aa[0] && aa[0].partIndex || null,
                        segmentIndex: aa[0] && aa[0].segmentIndex || 0,
                        startTime: yi
                      };
                  Ea = 0;
                }
                for (var Fl = Ea; Fl < aa.length; Fl++) {
                  var ru = aa[Fl];
                  if (Wo -= ru.duration, zi) {
                    if (Wo > 0)
                      continue;
                  } else if (Wo - Xf >= 0)
                    continue;
                  return {
                    partIndex: ru.partIndex,
                    segmentIndex: ru.segmentIndex,
                    startTime: wi + lg({
                      defaultDuration: bi.targetDuration,
                      durationList: aa,
                      startIndex: Ea,
                      endIndex: Fl
                    })
                  };
                }
                return {
                  segmentIndex: aa[aa.length - 1].segmentIndex,
                  partIndex: aa[aa.length - 1].partIndex,
                  startTime: yi
                };
              }, tm = function(Ei) {
                return Ei.excludeUntil && Ei.excludeUntil > Date.now();
              }, rm = function(Ei) {
                return Ei.excludeUntil && Ei.excludeUntil === 1 / 0;
              }, Nh = function(Ei) {
                var bi = tm(Ei);
                return !Ei.disabled && !bi;
              }, py = function(Ei) {
                return Ei.disabled;
              }, Lh = function(Ei) {
                for (var bi = 0; bi < Ei.segments.length; bi++)
                  if (Ei.segments[bi].key)
                    return !0;
                return !1;
              }, tv = function(Ei, bi) {
                return bi.attributes && bi.attributes[Ei];
              }, nm = function(Ei, bi, yi, ci) {
                if (ci === void 0 && (ci = 0), !tv("BANDWIDTH", yi))
                  return NaN;
                var hi = Ei * yi.attributes.BANDWIDTH;
                return (hi - ci * 8) / bi;
              }, im = function(Ei, bi) {
                if (Ei.playlists.length === 1)
                  return !0;
                var yi = bi.attributes.BANDWIDTH || Number.MAX_VALUE;
                return Ei.playlists.filter(function(ci) {
                  return Nh(ci) ? (ci.attributes.BANDWIDTH || 0) < yi : !1;
                }).length === 0;
              }, om = function(Ei, bi) {
                return !Ei && !bi || !Ei && bi || Ei && !bi ? !1 : !!(Ei === bi || Ei.id && bi.id && Ei.id === bi.id || Ei.resolvedUri && bi.resolvedUri && Ei.resolvedUri === bi.resolvedUri || Ei.uri && bi.uri && Ei.uri === bi.uri);
              }, ed = function(Ei, bi) {
                var yi = Ei && Ei.mediaGroups && Ei.mediaGroups.AUDIO || {}, ci = !1;
                for (var hi in yi) {
                  for (var wi in yi[hi])
                    if (ci = bi(yi[hi][wi]), ci)
                      break;
                  if (ci)
                    break;
                }
                return !!ci;
              }, Mh = function(Ei) {
                if (!Ei || !Ei.playlists || !Ei.playlists.length) {
                  var bi = ed(Ei, function(wi) {
                    return wi.playlists && wi.playlists.length || wi.uri;
                  });
                  return bi;
                }
                for (var yi = function(zi) {
                  var Wo = Ei.playlists[zi], aa = Wo.attributes && Wo.attributes.CODECS;
                  if (aa && aa.split(",").every(function(Ka) {
                    return (0, Li.isAudioCodec)(Ka);
                  }))
                    return "continue";
                  var Ea = ed(Ei, function(Ka) {
                    return om(Wo, Ka);
                  });
                  return Ea ? "continue" : {
                    v: !1
                  };
                }, ci = 0; ci < Ei.playlists.length; ci++) {
                  var hi = yi(ci);
                  if (hi !== "continue" && typeof hi == "object")
                    return hi.v;
                }
                return !0;
              }, Jd = {
                liveEdgeDelay: Mc,
                duration: em,
                seekable: dy,
                getMediaInfoForTime: fy,
                isEnabled: Nh,
                isDisabled: py,
                isBlacklisted: tm,
                isIncompatible: rm,
                playlistEnd: ev,
                isAes: Lh,
                hasAttribute: tv,
                estimateSegmentRequestTime: nm,
                isLowestEnabledRendition: im,
                isAudioOnly: Mh,
                playlistMatch: om,
                segmentDurationWithParts: Ag
              }, Gc = Rl.log, am = function(Ei, bi) {
                return Ei + "-" + bi;
              }, hy = function(Ei, bi, yi) {
                return "placeholder-uri-" + Ei + "-" + bi + "-" + yi;
              }, gy = function(Ei) {
                var bi = Ei.onwarn, yi = Ei.oninfo, ci = Ei.manifestString, hi = Ei.customTagParsers, wi = hi === void 0 ? [] : hi, zi = Ei.customTagMappers, Wo = zi === void 0 ? [] : zi, aa = Ei.experimentalLLHLS, Ea = new _o.Parser();
                bi && Ea.on("warn", bi), yi && Ea.on("info", yi), wi.forEach(function(Sl) {
                  return Ea.addParser(Sl);
                }), Wo.forEach(function(Sl) {
                  return Ea.addTagMapper(Sl);
                }), Ea.push(ci), Ea.end();
                var Ka = Ea.manifest;
                if (aa || (["preloadSegment", "skip", "serverControl", "renditionReports", "partInf", "partTargetDuration"].forEach(function(Sl) {
                  Ka.hasOwnProperty(Sl) && delete Ka[Sl];
                }), Ka.segments && Ka.segments.forEach(function(Sl) {
                  ["parts", "preloadHints"].forEach(function(Fl) {
                    Sl.hasOwnProperty(Fl) && delete Sl[Fl];
                  });
                })), !Ka.targetDuration) {
                  var Ha = 10;
                  Ka.segments && Ka.segments.length && (Ha = Ka.segments.reduce(function(Sl, Fl) {
                    return Math.max(Sl, Fl.duration);
                  }, 0)), bi && bi("manifest has no targetDuration defaulting to " + Ha), Ka.targetDuration = Ha;
                }
                var ks = Jm(Ka);
                if (ks.length && !Ka.partTargetDuration) {
                  var gl = ks.reduce(function(Sl, Fl) {
                    return Math.max(Sl, Fl.duration);
                  }, 0);
                  bi && (bi("manifest has no partTargetDuration defaulting to " + gl), Gc.error("LL-HLS manifest has parts but lacks required #EXT-X-PART-INF:PART-TARGET value. See https://datatracker.ietf.org/doc/html/draft-pantos-hls-rfc8216bis-09#section-4.4.3.7. Playback is not guaranteed.")), Ka.partTargetDuration = gl;
                }
                return Ka;
              }, Oc = function(Ei, bi) {
                Ei.mediaGroups && ["AUDIO", "SUBTITLES"].forEach(function(yi) {
                  if (Ei.mediaGroups[yi])
                    for (var ci in Ei.mediaGroups[yi])
                      for (var hi in Ei.mediaGroups[yi][ci]) {
                        var wi = Ei.mediaGroups[yi][ci][hi];
                        bi(wi, yi, ci, hi);
                      }
                });
              }, Bc = function(Ei) {
                var bi = Ei.playlist, yi = Ei.uri, ci = Ei.id;
                bi.id = ci, bi.playlistErrors_ = 0, yi && (bi.uri = yi), bi.attributes = bi.attributes || {};
              }, rv = function(Ei) {
                for (var bi = Ei.playlists.length; bi--; ) {
                  var yi = Ei.playlists[bi];
                  Bc({
                    playlist: yi,
                    id: am(bi, yi.uri)
                  }), yi.resolvedUri = Of(Ei.uri, yi.uri), Ei.playlists[yi.id] = yi, Ei.playlists[yi.uri] = yi, yi.attributes.BANDWIDTH || Gc.warn("Invalid playlist STREAM-INF detected. Missing BANDWIDTH attribute.");
                }
              }, sm = function(Ei) {
                Oc(Ei, function(bi) {
                  bi.uri && (bi.resolvedUri = Of(Ei.uri, bi.uri));
                });
              }, kp = function(Ei, bi) {
                var yi = am(0, bi), ci = {
                  mediaGroups: {
                    AUDIO: {},
                    VIDEO: {},
                    "CLOSED-CAPTIONS": {},
                    SUBTITLES: {}
                  },
                  uri: di().location.href,
                  resolvedUri: di().location.href,
                  playlists: [{
                    uri: bi,
                    id: yi,
                    resolvedUri: bi,
                    // m3u8-parser does not attach an attributes property to media playlists so make
                    // sure that the property is attached to avoid undefined reference errors
                    attributes: {}
                  }]
                };
                return ci.playlists[yi] = ci.playlists[0], ci.playlists[bi] = ci.playlists[0], ci;
              }, Ig = function(Ei, bi, yi) {
                yi === void 0 && (yi = hy), Ei.uri = bi;
                for (var ci = 0; ci < Ei.playlists.length; ci++)
                  if (!Ei.playlists[ci].uri) {
                    var hi = "placeholder-uri-" + ci;
                    Ei.playlists[ci].uri = hi;
                  }
                var wi = Mh(Ei);
                Oc(Ei, function(zi, Wo, aa, Ea) {
                  if (!zi.playlists || !zi.playlists.length) {
                    if (wi && Wo === "AUDIO" && !zi.uri)
                      for (var Ka = 0; Ka < Ei.playlists.length; Ka++) {
                        var Ha = Ei.playlists[Ka];
                        if (Ha.attributes && Ha.attributes.AUDIO && Ha.attributes.AUDIO === aa)
                          return;
                      }
                    zi.playlists = [(0, mi.default)({}, zi)];
                  }
                  zi.playlists.forEach(function(ks, gl) {
                    var Sl = yi(Wo, aa, Ea, ks), Fl = am(gl, Sl);
                    ks.uri ? ks.resolvedUri = ks.resolvedUri || Of(Ei.uri, ks.uri) : (ks.uri = gl === 0 ? Sl : Fl, ks.resolvedUri = ks.uri), ks.id = ks.id || Fl, ks.attributes = ks.attributes || {}, Ei.playlists[ks.id] = ks, Ei.playlists[ks.uri] = ks;
                  });
                }), rv(Ei), sm(Ei);
              }, ug = Rl.mergeOptions, lm = Rl.EventTarget, my = function(Ei, bi) {
                if (bi.endList || !bi.serverControl)
                  return Ei;
                var yi = {};
                if (bi.serverControl.canBlockReload) {
                  var ci = bi.preloadSegment, hi = bi.mediaSequence + bi.segments.length;
                  if (ci) {
                    var wi = ci.parts || [], zi = ah(bi) - 1;
                    zi > -1 && zi !== wi.length - 1 && (yi._HLS_part = zi), (zi > -1 || wi.length) && hi--;
                  }
                  yi._HLS_msn = hi;
                }
                if (bi.serverControl && bi.serverControl.canSkipUntil && (yi._HLS_skip = bi.serverControl.canSkipDateranges ? "v2" : "YES"), Object.keys(yi).length) {
                  var Wo = new (di()).URL(Ei);
                  ["_HLS_skip", "_HLS_msn", "_HLS_part"].forEach(function(aa) {
                    yi.hasOwnProperty(aa) && Wo.searchParams.set(aa, yi[aa]);
                  }), Ei = Wo.toString();
                }
                return Ei;
              }, vy = function(Ei, bi) {
                if (!Ei)
                  return bi;
                var yi = ug(Ei, bi);
                if (Ei.preloadHints && !bi.preloadHints && delete yi.preloadHints, Ei.parts && !bi.parts)
                  delete yi.parts;
                else if (Ei.parts && bi.parts)
                  for (var ci = 0; ci < bi.parts.length; ci++)
                    Ei.parts && Ei.parts[ci] && (yi.parts[ci] = ug(Ei.parts[ci], bi.parts[ci]));
                return !Ei.skipped && bi.skipped && (yi.skipped = !1), Ei.preload && !bi.preload && (yi.preload = !1), yi;
              }, yy = function(Ei, bi, yi) {
                var ci = Ei.slice(), hi = bi.slice();
                yi = yi || 0;
                for (var wi = [], zi, Wo = 0; Wo < hi.length; Wo++) {
                  var aa = ci[Wo + yi], Ea = hi[Wo];
                  aa ? (zi = aa.map || zi, wi.push(vy(aa, Ea))) : (zi && !Ea.map && (Ea.map = zi), wi.push(Ea));
                }
                return wi;
              }, Np = function(Ei, bi) {
                !Ei.resolvedUri && Ei.uri && (Ei.resolvedUri = Of(bi, Ei.uri)), Ei.key && !Ei.key.resolvedUri && (Ei.key.resolvedUri = Of(bi, Ei.key.uri)), Ei.map && !Ei.map.resolvedUri && (Ei.map.resolvedUri = Of(bi, Ei.map.uri)), Ei.map && Ei.map.key && !Ei.map.key.resolvedUri && (Ei.map.key.resolvedUri = Of(bi, Ei.map.key.uri)), Ei.parts && Ei.parts.length && Ei.parts.forEach(function(yi) {
                  yi.resolvedUri || (yi.resolvedUri = Of(bi, yi.uri));
                }), Ei.preloadHints && Ei.preloadHints.length && Ei.preloadHints.forEach(function(yi) {
                  yi.resolvedUri || (yi.resolvedUri = Of(bi, yi.uri));
                });
              }, um = function(Ei) {
                var bi = Ei.segments || [], yi = Ei.preloadSegment;
                if (yi && yi.parts && yi.parts.length) {
                  if (yi.preloadHints) {
                    for (var ci = 0; ci < yi.preloadHints.length; ci++)
                      if (yi.preloadHints[ci].type === "MAP")
                        return bi;
                  }
                  yi.duration = Ei.targetDuration, yi.preload = !0, bi.push(yi);
                }
                return bi;
              }, Ac = function(Ei, bi) {
                return Ei === bi || Ei.segments && bi.segments && Ei.segments.length === bi.segments.length && Ei.endList === bi.endList && Ei.mediaSequence === bi.mediaSequence && Ei.preloadSegment === bi.preloadSegment;
              }, $g = function(Ei, bi, yi) {
                yi === void 0 && (yi = Ac);
                var ci = ug(Ei, {}), hi = ci.playlists[bi.id];
                if (!hi || yi(hi, bi))
                  return null;
                bi.segments = um(bi);
                var wi = ug(hi, bi);
                if (wi.preloadSegment && !bi.preloadSegment && delete wi.preloadSegment, hi.segments) {
                  if (bi.skip) {
                    bi.segments = bi.segments || [];
                    for (var zi = 0; zi < bi.skip.skippedSegments; zi++)
                      bi.segments.unshift({
                        skipped: !0
                      });
                  }
                  wi.segments = yy(hi.segments, bi.segments, bi.mediaSequence - hi.mediaSequence);
                }
                wi.segments.forEach(function(aa) {
                  Np(aa, wi.resolvedUri);
                });
                for (var Wo = 0; Wo < ci.playlists.length; Wo++)
                  ci.playlists[Wo].id === bi.id && (ci.playlists[Wo] = wi);
                return ci.playlists[bi.id] = wi, ci.playlists[bi.uri] = wi, Oc(Ei, function(aa, Ea, Ka, Ha) {
                  if (aa.playlists)
                    for (var ks = 0; ks < aa.playlists.length; ks++)
                      bi.id === aa.playlists[ks].id && (aa.playlists[ks] = wi);
                }), ci;
              }, Ld = function(Ei, bi) {
                var yi = Ei.segments || [], ci = yi[yi.length - 1], hi = ci && ci.parts && ci.parts[ci.parts.length - 1], wi = hi && hi.duration || ci && ci.duration;
                return bi && wi ? wi * 1e3 : (Ei.partTargetDuration || Ei.targetDuration || 10) * 500;
              }, jh = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci, hi) {
                  var wi;
                  if (hi === void 0 && (hi = {}), wi = Vi.call(this) || this, !yi)
                    throw new Error("A non-empty playlist URL or object is required");
                  wi.logger_ = Af("PlaylistLoader");
                  var zi = hi, Wo = zi.withCredentials, aa = Wo === void 0 ? !1 : Wo, Ea = zi.handleManifestRedirects, Ka = Ea === void 0 ? !1 : Ea;
                  wi.src = yi, wi.vhs_ = ci, wi.withCredentials = aa, wi.handleManifestRedirects = Ka;
                  var Ha = ci.options_;
                  return wi.customTagParsers = Ha && Ha.customTagParsers || [], wi.customTagMappers = Ha && Ha.customTagMappers || [], wi.experimentalLLHLS = Ha && Ha.experimentalLLHLS || !1, Rl.browser.IE_VERSION && (wi.experimentalLLHLS = !1), wi.state = "HAVE_NOTHING", wi.handleMediaupdatetimeout_ = wi.handleMediaupdatetimeout_.bind((0, xi.default)(wi)), wi.on("mediaupdatetimeout", wi.handleMediaupdatetimeout_), wi;
                }
                var bi = Ei.prototype;
                return bi.handleMediaupdatetimeout_ = function() {
                  var ci = this;
                  if (this.state === "HAVE_METADATA") {
                    var hi = this.media(), wi = Of(this.master.uri, hi.uri);
                    this.experimentalLLHLS && (wi = my(wi, hi)), this.state = "HAVE_CURRENT_METADATA", this.request = this.vhs_.xhr({
                      uri: wi,
                      withCredentials: this.withCredentials
                    }, function(zi, Wo) {
                      if (ci.request) {
                        if (zi)
                          return ci.playlistRequestError(ci.request, ci.media(), "HAVE_METADATA");
                        ci.haveMetadata({
                          playlistString: ci.request.responseText,
                          url: ci.media().uri,
                          id: ci.media().id
                        });
                      }
                    });
                  }
                }, bi.playlistRequestError = function(ci, hi, wi) {
                  var zi = hi.uri, Wo = hi.id;
                  this.request = null, wi && (this.state = wi), this.error = {
                    playlist: this.master.playlists[Wo],
                    status: ci.status,
                    message: "HLS playlist request error at URL: " + zi + ".",
                    responseText: ci.responseText,
                    code: ci.status >= 500 ? 4 : 2
                  }, this.trigger("error");
                }, bi.parseManifest_ = function(ci) {
                  var hi = this, wi = ci.url, zi = ci.manifestString;
                  return gy({
                    onwarn: function(aa) {
                      var Ea = aa.message;
                      return hi.logger_("m3u8-parser warn for " + wi + ": " + Ea);
                    },
                    oninfo: function(aa) {
                      var Ea = aa.message;
                      return hi.logger_("m3u8-parser info for " + wi + ": " + Ea);
                    },
                    manifestString: zi,
                    customTagParsers: this.customTagParsers,
                    customTagMappers: this.customTagMappers,
                    experimentalLLHLS: this.experimentalLLHLS
                  });
                }, bi.haveMetadata = function(ci) {
                  var hi = ci.playlistString, wi = ci.playlistObject, zi = ci.url, Wo = ci.id;
                  this.request = null, this.state = "HAVE_METADATA";
                  var aa = wi || this.parseManifest_({
                    url: zi,
                    manifestString: hi
                  });
                  aa.lastRequest = Date.now(), Bc({
                    playlist: aa,
                    uri: zi,
                    id: Wo
                  });
                  var Ea = $g(this.master, aa);
                  this.targetDuration = aa.partTargetDuration || aa.targetDuration, this.pendingMedia_ = null, Ea ? (this.master = Ea, this.media_ = this.master.playlists[Wo]) : this.trigger("playlistunchanged"), this.updateMediaUpdateTimeout_(Ld(this.media(), !!Ea)), this.trigger("loadedplaylist");
                }, bi.dispose = function() {
                  this.trigger("dispose"), this.stopRequest(), di().clearTimeout(this.mediaUpdateTimeout), di().clearTimeout(this.finalRenditionTimeout), this.off();
                }, bi.stopRequest = function() {
                  if (this.request) {
                    var ci = this.request;
                    this.request = null, ci.onreadystatechange = null, ci.abort();
                  }
                }, bi.media = function(ci, hi) {
                  var wi = this;
                  if (!ci)
                    return this.media_;
                  if (this.state === "HAVE_NOTHING")
                    throw new Error("Cannot switch media playlist from " + this.state);
                  if (typeof ci == "string") {
                    if (!this.master.playlists[ci])
                      throw new Error("Unknown playlist URI: " + ci);
                    ci = this.master.playlists[ci];
                  }
                  if (di().clearTimeout(this.finalRenditionTimeout), hi) {
                    var zi = (ci.partTargetDuration || ci.targetDuration) / 2 * 1e3 || 5e3;
                    this.finalRenditionTimeout = di().setTimeout(this.media.bind(this, ci, !1), zi);
                    return;
                  }
                  var Wo = this.state, aa = !this.media_ || ci.id !== this.media_.id, Ea = this.master.playlists[ci.id];
                  if (Ea && Ea.endList || // handle the case of a playlist object (e.g., if using vhs-json with a resolved
                  // media playlist or, for the case of demuxed audio, a resolved audio media group)
                  ci.endList && ci.segments.length) {
                    this.request && (this.request.onreadystatechange = null, this.request.abort(), this.request = null), this.state = "HAVE_METADATA", this.media_ = ci, aa && (this.trigger("mediachanging"), Wo === "HAVE_MASTER" ? this.trigger("loadedmetadata") : this.trigger("mediachange"));
                    return;
                  }
                  if (this.updateMediaUpdateTimeout_(Ld(ci, !0)), !!aa) {
                    if (this.state = "SWITCHING_MEDIA", this.request) {
                      if (ci.resolvedUri === this.request.url)
                        return;
                      this.request.onreadystatechange = null, this.request.abort(), this.request = null;
                    }
                    this.media_ && this.trigger("mediachanging"), this.pendingMedia_ = ci, this.request = this.vhs_.xhr({
                      uri: ci.resolvedUri,
                      withCredentials: this.withCredentials
                    }, function(Ka, Ha) {
                      if (wi.request) {
                        if (ci.lastRequest = Date.now(), ci.resolvedUri = up(wi.handleManifestRedirects, ci.resolvedUri, Ha), Ka)
                          return wi.playlistRequestError(wi.request, ci, Wo);
                        wi.haveMetadata({
                          playlistString: Ha.responseText,
                          url: ci.uri,
                          id: ci.id
                        }), Wo === "HAVE_MASTER" ? wi.trigger("loadedmetadata") : wi.trigger("mediachange");
                      }
                    });
                  }
                }, bi.pause = function() {
                  this.mediaUpdateTimeout && (di().clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null), this.stopRequest(), this.state === "HAVE_NOTHING" && (this.started = !1), this.state === "SWITCHING_MEDIA" ? this.media_ ? this.state = "HAVE_METADATA" : this.state = "HAVE_MASTER" : this.state === "HAVE_CURRENT_METADATA" && (this.state = "HAVE_METADATA");
                }, bi.load = function(ci) {
                  var hi = this;
                  this.mediaUpdateTimeout && (di().clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null);
                  var wi = this.media();
                  if (ci) {
                    var zi = wi ? (wi.partTargetDuration || wi.targetDuration) / 2 * 1e3 : 5e3;
                    this.mediaUpdateTimeout = di().setTimeout(function() {
                      hi.mediaUpdateTimeout = null, hi.load();
                    }, zi);
                    return;
                  }
                  if (!this.started) {
                    this.start();
                    return;
                  }
                  wi && !wi.endList ? this.trigger("mediaupdatetimeout") : this.trigger("loadedplaylist");
                }, bi.updateMediaUpdateTimeout_ = function(ci) {
                  var hi = this;
                  this.mediaUpdateTimeout && (di().clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null), !(!this.media() || this.media().endList) && (this.mediaUpdateTimeout = di().setTimeout(function() {
                    hi.mediaUpdateTimeout = null, hi.trigger("mediaupdatetimeout"), hi.updateMediaUpdateTimeout_(ci);
                  }, ci));
                }, bi.start = function() {
                  var ci = this;
                  if (this.started = !0, typeof this.src == "object") {
                    this.src.uri || (this.src.uri = di().location.href), this.src.resolvedUri = this.src.uri, setTimeout(function() {
                      ci.setupInitialPlaylist(ci.src);
                    }, 0);
                    return;
                  }
                  this.request = this.vhs_.xhr({
                    uri: this.src,
                    withCredentials: this.withCredentials
                  }, function(hi, wi) {
                    if (ci.request) {
                      if (ci.request = null, hi)
                        return ci.error = {
                          status: wi.status,
                          message: "HLS playlist request error at URL: " + ci.src + ".",
                          responseText: wi.responseText,
                          // MEDIA_ERR_NETWORK
                          code: 2
                        }, ci.state === "HAVE_NOTHING" && (ci.started = !1), ci.trigger("error");
                      ci.src = up(ci.handleManifestRedirects, ci.src, wi);
                      var zi = ci.parseManifest_({
                        manifestString: wi.responseText,
                        url: ci.src
                      });
                      ci.setupInitialPlaylist(zi);
                    }
                  });
                }, bi.srcUri = function() {
                  return typeof this.src == "string" ? this.src : this.src.uri;
                }, bi.setupInitialPlaylist = function(ci) {
                  if (this.state = "HAVE_MASTER", ci.playlists) {
                    this.master = ci, Ig(this.master, this.srcUri()), ci.playlists.forEach(function(wi) {
                      wi.segments = um(wi), wi.segments.forEach(function(zi) {
                        Np(zi, wi.resolvedUri);
                      });
                    }), this.trigger("loadedplaylist"), this.request || this.media(this.master.playlists[0]);
                    return;
                  }
                  var hi = this.srcUri() || di().location.href;
                  this.master = kp(ci, hi), this.haveMetadata({
                    playlistObject: ci,
                    url: hi,
                    id: this.master.playlists[0].id
                  }), this.trigger("loadedmetadata");
                }, Ei;
              })(lm), nv = Rl.xhr, by = Rl.mergeOptions, cm = function(Ei, bi, yi, ci) {
                var hi = Ei.responseType === "arraybuffer" ? Ei.response : Ei.responseText;
                !bi && hi && (Ei.responseTime = Date.now(), Ei.roundTripTime = Ei.responseTime - Ei.requestTime, Ei.bytesReceived = hi.byteLength || hi.length, Ei.bandwidth || (Ei.bandwidth = Math.floor(Ei.bytesReceived / Ei.roundTripTime * 8 * 1e3))), yi.headers && (Ei.responseHeaders = yi.headers), bi && bi.code === "ETIMEDOUT" && (Ei.timedout = !0), !bi && !Ei.aborted && yi.statusCode !== 200 && yi.statusCode !== 206 && yi.statusCode !== 0 && (bi = new Error("XHR Failed with a response of: " + (Ei && (hi || Ei.responseText)))), ci(bi, Ei);
              }, iv = function() {
                var Ei = function bi(yi, ci) {
                  yi = by({
                    timeout: 45e3
                  }, yi);
                  var hi = bi.beforeRequest || Rl.Vhs.xhr.beforeRequest;
                  if (hi && typeof hi == "function") {
                    var wi = hi(yi);
                    wi && (yi = wi);
                  }
                  var zi = Rl.Vhs.xhr.original === !0 ? nv : Rl.Vhs.xhr, Wo = zi(yi, function(Ea, Ka) {
                    return cm(Wo, Ea, Ka, ci);
                  }), aa = Wo.abort;
                  return Wo.abort = function() {
                    return Wo.aborted = !0, aa.apply(Wo, arguments);
                  }, Wo.uri = yi.uri, Wo.requestTime = Date.now(), Wo;
                };
                return Ei.original = !0, Ei;
              }, Ty = function(Ei) {
                var bi, yi = Ei.offset;
                return typeof Ei.offset == "bigint" || typeof Ei.length == "bigint" ? bi = di().BigInt(Ei.offset) + di().BigInt(Ei.length) - di().BigInt(1) : bi = Ei.offset + Ei.length - 1, "bytes=" + yi + "-" + bi;
              }, Dg = function(Ei) {
                var bi = {};
                return Ei.byterange && (bi.Range = Ty(Ei.byterange)), bi;
              }, kg = function(Ei, bi) {
                return Ei.start(bi) + "-" + Ei.end(bi);
              }, Ey = function(Ei, bi) {
                var yi = Ei.toString(16);
                return "00".substring(0, 2 - yi.length) + yi + (bi % 2 ? " " : "");
              }, dm = function(Ei) {
                return Ei >= 32 && Ei < 126 ? String.fromCharCode(Ei) : ".";
              }, ov = function(Ei) {
                var bi = {};
                return Object.keys(Ei).forEach(function(yi) {
                  var ci = Ei[yi];
                  (0, Ni.isArrayBufferView)(ci) ? bi[yi] = {
                    bytes: ci.buffer,
                    byteOffset: ci.byteOffset,
                    byteLength: ci.byteLength
                  } : bi[yi] = ci;
                }), bi;
              }, Ng = function(Ei) {
                var bi = Ei.byterange || {
                  length: 1 / 0,
                  offset: 0
                };
                return [bi.length, bi.offset, Ei.resolvedUri].join(",");
              }, av = function(Ei) {
                return Ei.resolvedUri;
              }, fm = function(Ei) {
                for (var bi = Array.prototype.slice.call(Ei), yi = 16, ci = "", hi, wi, zi = 0; zi < bi.length / yi; zi++)
                  hi = bi.slice(zi * yi, zi * yi + yi).map(Ey).join(""), wi = bi.slice(zi * yi, zi * yi + yi).map(dm).join(""), ci += hi + " " + wi + `
`;
                return ci;
              }, Sy = function(Ei) {
                var bi = Ei.bytes;
                return fm(bi);
              }, cp = function(Ei) {
                var bi = "", yi;
                for (yi = 0; yi < Ei.length; yi++)
                  bi += kg(Ei, yi) + " ";
                return bi;
              }, xy = /* @__PURE__ */ Object.freeze({
                __proto__: null,
                createTransferableMessage: ov,
                initSegmentId: Ng,
                segmentKeyId: av,
                hexDump: fm,
                tagDump: Sy,
                textRanges: cp
              }), $f = 0.25, dp = function(Ei, bi) {
                if (!bi.dateTimeObject)
                  return null;
                var yi = bi.videoTimingInfo.transmuxerPrependedSeconds, ci = bi.videoTimingInfo.transmuxedPresentationStart, hi = ci + yi, wi = Ei - hi;
                return new Date(bi.dateTimeObject.getTime() + wi * 1e3);
              }, pm = function(Ei) {
                return Ei.transmuxedPresentationEnd - Ei.transmuxedPresentationStart - Ei.transmuxerPrependedSeconds;
              }, hm = function(Ei, bi) {
                var yi;
                try {
                  yi = new Date(Ei);
                } catch {
                  return null;
                }
                if (!bi || !bi.segments || bi.segments.length === 0)
                  return null;
                var ci = bi.segments[0];
                if (yi < ci.dateTimeObject)
                  return null;
                for (var hi = 0; hi < bi.segments.length - 1; hi++) {
                  ci = bi.segments[hi];
                  var wi = bi.segments[hi + 1].dateTimeObject;
                  if (yi < wi)
                    break;
                }
                var zi = bi.segments[bi.segments.length - 1], Wo = zi.dateTimeObject, aa = zi.videoTimingInfo ? pm(zi.videoTimingInfo) : zi.duration + zi.duration * $f, Ea = new Date(Wo.getTime() + aa * 1e3);
                return yi > Ea ? null : (yi > Wo && (ci = zi), {
                  segment: ci,
                  estimatedStart: ci.videoTimingInfo ? ci.videoTimingInfo.transmuxedPresentationStart : Jd.duration(bi, bi.mediaSequence + bi.segments.indexOf(ci)),
                  // Although, given that all segments have accurate date time objects, the segment
                  // selected should be accurate, unless the video has been transmuxed at some point
                  // (determined by the presence of the videoTimingInfo object), the segment's "player
                  // time" (the start time in the player) can't be considered accurate.
                  type: ci.videoTimingInfo ? "accurate" : "estimate"
                });
              }, wy = function(Ei, bi) {
                if (!bi || !bi.segments || bi.segments.length === 0)
                  return null;
                for (var yi = 0, ci, hi = 0; hi < bi.segments.length && (ci = bi.segments[hi], yi = ci.videoTimingInfo ? ci.videoTimingInfo.transmuxedPresentationEnd : yi + ci.duration, !(Ei <= yi)); hi++)
                  ;
                var wi = bi.segments[bi.segments.length - 1];
                if (wi.videoTimingInfo && wi.videoTimingInfo.transmuxedPresentationEnd < Ei)
                  return null;
                if (Ei > yi) {
                  if (Ei > yi + wi.duration * $f)
                    return null;
                  ci = wi;
                }
                return {
                  segment: ci,
                  estimatedStart: ci.videoTimingInfo ? ci.videoTimingInfo.transmuxedPresentationStart : yi - ci.duration,
                  // Because videoTimingInfo is only set after transmux, it is the only way to get
                  // accurate timing values.
                  type: ci.videoTimingInfo ? "accurate" : "estimate"
                };
              }, _y = function(Ei, bi) {
                var yi, ci;
                try {
                  yi = new Date(Ei), ci = new Date(bi);
                } catch {
                }
                var hi = yi.getTime(), wi = ci.getTime();
                return (wi - hi) / 1e3;
              }, gm = function(Ei) {
                if (!Ei.segments || Ei.segments.length === 0)
                  return !1;
                for (var bi = 0; bi < Ei.segments.length; bi++) {
                  var yi = Ei.segments[bi];
                  if (!yi.dateTimeObject)
                    return !1;
                }
                return !0;
              }, mm = function(Ei) {
                var bi = Ei.playlist, yi = Ei.time, ci = yi === void 0 ? void 0 : yi, hi = Ei.callback;
                if (!hi)
                  throw new Error("getProgramTime: callback must be provided");
                if (!bi || ci === void 0)
                  return hi({
                    message: "getProgramTime: playlist and time must be provided"
                  });
                var wi = wy(ci, bi);
                if (!wi)
                  return hi({
                    message: "valid programTime was not found"
                  });
                if (wi.type === "estimate")
                  return hi({
                    message: "Accurate programTime could not be determined. Please seek to e.seekTime and try again",
                    seekTime: wi.estimatedStart
                  });
                var zi = {
                  mediaSeconds: ci
                }, Wo = dp(ci, wi.segment);
                return Wo && (zi.programDateTime = Wo.toISOString()), hi(null, zi);
              }, vm = function Vi(Ei) {
                var bi = Ei.programTime, yi = Ei.playlist, ci = Ei.retryCount, hi = ci === void 0 ? 2 : ci, wi = Ei.seekTo, zi = Ei.pauseAfterSeek, Wo = zi === void 0 ? !0 : zi, aa = Ei.tech, Ea = Ei.callback;
                if (!Ea)
                  throw new Error("seekToProgramTime: callback must be provided");
                if (typeof bi > "u" || !yi || !wi)
                  return Ea({
                    message: "seekToProgramTime: programTime, seekTo and playlist must be provided"
                  });
                if (!yi.endList && !aa.hasStarted_)
                  return Ea({
                    message: "player must be playing a live stream to start buffering"
                  });
                if (!gm(yi))
                  return Ea({
                    message: "programDateTime tags must be provided in the manifest " + yi.resolvedUri
                  });
                var Ka = hm(bi, yi);
                if (!Ka)
                  return Ea({
                    message: bi + " was not found in the stream"
                  });
                var Ha = Ka.segment, ks = _y(Ha.dateTimeObject, bi);
                if (Ka.type === "estimate") {
                  if (hi === 0)
                    return Ea({
                      message: bi + " is not buffered yet. Try again"
                    });
                  wi(Ka.estimatedStart + ks), aa.one("seeked", function() {
                    Vi({
                      programTime: bi,
                      playlist: yi,
                      retryCount: hi - 1,
                      seekTo: wi,
                      pauseAfterSeek: Wo,
                      tech: aa,
                      callback: Ea
                    });
                  });
                  return;
                }
                var gl = Ha.start + ks, Sl = function() {
                  return Ea(null, aa.currentTime());
                };
                aa.one("seeked", Sl), Wo && aa.pause(), wi(gl);
              }, ym = function(Ei, bi) {
                if (Ei.readyState === 4)
                  return bi();
              }, Sd = function(Ei, bi, yi) {
                var ci = [], hi, wi = !1, zi = function(Ha, ks, gl, Sl) {
                  return ks.abort(), wi = !0, yi(Ha, ks, gl, Sl);
                }, Wo = function(Ha, ks) {
                  if (!wi) {
                    if (Ha)
                      return zi(Ha, ks, "", ci);
                    var gl = ks.responseText.substring(ci && ci.byteLength || 0, ks.responseText.length);
                    if (ci = (0, Ni.concatTypedArrays)(ci, (0, Ni.stringToBytes)(gl, !0)), hi = hi || (0, Ui.getId3Offset)(ci), ci.length < 10 || hi && ci.length < hi + 2)
                      return ym(ks, function() {
                        return zi(Ha, ks, "", ci);
                      });
                    var Sl = (0, jo.detectContainerForBytes)(ci);
                    return Sl === "ts" && ci.length < 188 ? ym(ks, function() {
                      return zi(Ha, ks, "", ci);
                    }) : !Sl && ci.length < 376 ? ym(ks, function() {
                      return zi(Ha, ks, "", ci);
                    }) : zi(null, ks, Sl, ci);
                  }
                }, aa = {
                  uri: Ei,
                  beforeSend: function(Ha) {
                    Ha.overrideMimeType("text/plain; charset=x-user-defined"), Ha.addEventListener("progress", function(ks) {
                      return ks.total, ks.loaded, cm(Ha, null, {
                        statusCode: Ha.status
                      }, Wo);
                    });
                  }
                }, Ea = bi(aa, function(Ka, Ha) {
                  return cm(Ea, Ka, Ha, Wo);
                });
                return Ea;
              }, sv = Rl.EventTarget, fp = Rl.mergeOptions, lv = function(Ei, bi) {
                if (!Ac(Ei, bi) || Ei.sidx && bi.sidx && (Ei.sidx.offset !== bi.sidx.offset || Ei.sidx.length !== bi.sidx.length))
                  return !1;
                if (!Ei.sidx && bi.sidx || Ei.sidx && !bi.sidx || Ei.segments && !bi.segments || !Ei.segments && bi.segments)
                  return !1;
                if (!Ei.segments && !bi.segments)
                  return !0;
                for (var yi = 0; yi < Ei.segments.length; yi++) {
                  var ci = Ei.segments[yi], hi = bi.segments[yi];
                  if (ci.uri !== hi.uri)
                    return !1;
                  if (!(!ci.byterange && !hi.byterange)) {
                    var wi = ci.byterange, zi = hi.byterange;
                    if (wi && !zi || !wi && zi || wi.offset !== zi.offset || wi.length !== zi.length)
                      return !1;
                  }
                }
                return !0;
              }, uv = function(Ei, bi, yi, ci) {
                var hi = ci.attributes.NAME || yi;
                return "placeholder-uri-" + Ei + "-" + bi + "-" + hi;
              }, Py = function(Ei) {
                var bi = Ei.masterXml, yi = Ei.srcUrl, ci = Ei.clientOffset, hi = Ei.sidxMapping, wi = Ei.previousManifest, zi = (0, Yi.parse)(bi, {
                  manifestUri: yi,
                  clientOffset: ci,
                  sidxMapping: hi,
                  previousManifest: wi
                });
                return Ig(zi, yi, uv), zi;
              }, Cy = function(Ei, bi) {
                Oc(Ei, function(yi, ci, hi, wi) {
                  wi in bi.mediaGroups[ci][hi] || delete Ei.mediaGroups[ci][hi][wi];
                });
              }, Ry = function(Ei, bi, yi) {
                for (var ci = !0, hi = fp(Ei, {
                  // These are top level properties that can be updated
                  duration: bi.duration,
                  minimumUpdatePeriod: bi.minimumUpdatePeriod,
                  timelineStarts: bi.timelineStarts
                }), wi = 0; wi < bi.playlists.length; wi++) {
                  var zi = bi.playlists[wi];
                  if (zi.sidx) {
                    var Wo = (0, Yi.generateSidxKey)(zi.sidx);
                    yi && yi[Wo] && yi[Wo].sidx && (0, Yi.addSidxSegmentsToPlaylist)(zi, yi[Wo].sidx, zi.sidx.resolvedUri);
                  }
                  var aa = $g(hi, zi, lv);
                  aa && (hi = aa, ci = !1);
                }
                return Oc(bi, function(Ea, Ka, Ha, ks) {
                  if (Ea.playlists && Ea.playlists.length) {
                    var gl = Ea.playlists[0].id, Sl = $g(hi, Ea.playlists[0], lv);
                    Sl && (hi = Sl, ks in hi.mediaGroups[Ka][Ha] || (hi.mediaGroups[Ka][Ha][ks] = Ea), hi.mediaGroups[Ka][Ha][ks].playlists[0] = hi.playlists[gl], ci = !1);
                  }
                }), Cy(hi, bi), bi.minimumUpdatePeriod !== Ei.minimumUpdatePeriod && (ci = !1), ci ? null : hi;
              }, Oy = function(Ei, bi) {
                var yi = !Ei.map && !bi.map, ci = yi || !!(Ei.map && bi.map && Ei.map.byterange.offset === bi.map.byterange.offset && Ei.map.byterange.length === bi.map.byterange.length);
                return ci && Ei.uri === bi.uri && Ei.byterange.offset === bi.byterange.offset && Ei.byterange.length === bi.byterange.length;
              }, bm = function(Ei, bi) {
                var yi = {};
                for (var ci in Ei) {
                  var hi = Ei[ci], wi = hi.sidx;
                  if (wi) {
                    var zi = (0, Yi.generateSidxKey)(wi);
                    if (!bi[zi])
                      break;
                    var Wo = bi[zi].sidxInfo;
                    Oy(Wo, wi) && (yi[zi] = bi[zi]);
                  }
                }
                return yi;
              }, cv = function(Ei, bi) {
                var yi = bm(Ei.playlists, bi), ci = yi;
                return Oc(Ei, function(hi, wi, zi, Wo) {
                  if (hi.playlists && hi.playlists.length) {
                    var aa = hi.playlists;
                    ci = fp(ci, bm(aa, bi));
                  }
                }), ci;
              }, cg = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci, hi, wi) {
                  var zi;
                  hi === void 0 && (hi = {}), zi = Vi.call(this) || this, zi.masterPlaylistLoader_ = wi || (0, xi.default)(zi), wi || (zi.isMaster_ = !0);
                  var Wo = hi, aa = Wo.withCredentials, Ea = aa === void 0 ? !1 : aa, Ka = Wo.handleManifestRedirects, Ha = Ka === void 0 ? !1 : Ka;
                  if (zi.vhs_ = ci, zi.withCredentials = Ea, zi.handleManifestRedirects = Ha, !yi)
                    throw new Error("A non-empty playlist URL or object is required");
                  return zi.on("minimumUpdatePeriod", function() {
                    zi.refreshXml_();
                  }), zi.on("mediaupdatetimeout", function() {
                    zi.refreshMedia_(zi.media().id);
                  }), zi.state = "HAVE_NOTHING", zi.loadedPlaylists_ = {}, zi.logger_ = Af("DashPlaylistLoader"), zi.isMaster_ ? (zi.masterPlaylistLoader_.srcUrl = yi, zi.masterPlaylistLoader_.sidxMapping_ = {}) : zi.childPlaylist_ = yi, zi;
                }
                var bi = Ei.prototype;
                return bi.requestErrored_ = function(ci, hi, wi) {
                  if (!this.request)
                    return !0;
                  if (this.request = null, ci)
                    return this.error = typeof ci == "object" && !(ci instanceof Error) ? ci : {
                      status: hi.status,
                      message: "DASH request error at URL: " + hi.uri,
                      response: hi.response,
                      // MEDIA_ERR_NETWORK
                      code: 2
                    }, wi && (this.state = wi), this.trigger("error"), !0;
                }, bi.addSidxSegments_ = function(ci, hi, wi) {
                  var zi = this, Wo = ci.sidx && (0, Yi.generateSidxKey)(ci.sidx);
                  if (!ci.sidx || !Wo || this.masterPlaylistLoader_.sidxMapping_[Wo]) {
                    this.mediaRequest_ = di().setTimeout(function() {
                      return wi(!1);
                    }, 0);
                    return;
                  }
                  var aa = up(this.handleManifestRedirects, ci.sidx.resolvedUri), Ea = function(Ha, ks) {
                    if (!zi.requestErrored_(Ha, ks, hi)) {
                      var gl = zi.masterPlaylistLoader_.sidxMapping_, Sl;
                      try {
                        Sl = No()((0, Ni.toUint8)(ks.response).subarray(8));
                      } catch (Fl) {
                        zi.requestErrored_(Fl, ks, hi);
                        return;
                      }
                      return gl[Wo] = {
                        sidxInfo: ci.sidx,
                        sidx: Sl
                      }, (0, Yi.addSidxSegmentsToPlaylist)(ci, Sl, ci.sidx.resolvedUri), wi(!0);
                    }
                  };
                  this.request = Sd(aa, this.vhs_.xhr, function(Ka, Ha, ks, gl) {
                    if (Ka)
                      return Ea(Ka, Ha);
                    if (!ks || ks !== "mp4")
                      return Ea({
                        status: Ha.status,
                        message: "Unsupported " + (ks || "unknown") + " container type for sidx segment at URL: " + aa,
                        // response is just bytes in this case
                        // but we really don't want to return that.
                        response: "",
                        playlist: ci,
                        internal: !0,
                        blacklistDuration: 1 / 0,
                        // MEDIA_ERR_NETWORK
                        code: 2
                      }, Ha);
                    var Sl = ci.sidx.byterange, Fl = Sl.offset, ru = Sl.length;
                    if (gl.length >= ru + Fl)
                      return Ea(Ka, {
                        response: gl.subarray(Fl, Fl + ru),
                        status: Ha.status,
                        uri: Ha.uri
                      });
                    zi.request = zi.vhs_.xhr({
                      uri: aa,
                      responseType: "arraybuffer",
                      headers: Dg({
                        byterange: ci.sidx.byterange
                      })
                    }, Ea);
                  });
                }, bi.dispose = function() {
                  this.trigger("dispose"), this.stopRequest(), this.loadedPlaylists_ = {}, di().clearTimeout(this.minimumUpdatePeriodTimeout_), di().clearTimeout(this.mediaRequest_), di().clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null, this.mediaRequest_ = null, this.minimumUpdatePeriodTimeout_ = null, this.masterPlaylistLoader_.createMupOnMedia_ && (this.off("loadedmetadata", this.masterPlaylistLoader_.createMupOnMedia_), this.masterPlaylistLoader_.createMupOnMedia_ = null), this.off();
                }, bi.hasPendingRequest = function() {
                  return this.request || this.mediaRequest_;
                }, bi.stopRequest = function() {
                  if (this.request) {
                    var ci = this.request;
                    this.request = null, ci.onreadystatechange = null, ci.abort();
                  }
                }, bi.media = function(ci) {
                  var hi = this;
                  if (!ci)
                    return this.media_;
                  if (this.state === "HAVE_NOTHING")
                    throw new Error("Cannot switch media playlist from " + this.state);
                  var wi = this.state;
                  if (typeof ci == "string") {
                    if (!this.masterPlaylistLoader_.master.playlists[ci])
                      throw new Error("Unknown playlist URI: " + ci);
                    ci = this.masterPlaylistLoader_.master.playlists[ci];
                  }
                  var zi = !this.media_ || ci.id !== this.media_.id;
                  if (zi && this.loadedPlaylists_[ci.id] && this.loadedPlaylists_[ci.id].endList) {
                    this.state = "HAVE_METADATA", this.media_ = ci, zi && (this.trigger("mediachanging"), this.trigger("mediachange"));
                    return;
                  }
                  zi && (this.media_ && this.trigger("mediachanging"), this.addSidxSegments_(ci, wi, function(Wo) {
                    hi.haveMetadata({
                      startingState: wi,
                      playlist: ci
                    });
                  }));
                }, bi.haveMetadata = function(ci) {
                  var hi = ci.startingState, wi = ci.playlist;
                  this.state = "HAVE_METADATA", this.loadedPlaylists_[wi.id] = wi, this.mediaRequest_ = null, this.refreshMedia_(wi.id), hi === "HAVE_MASTER" ? this.trigger("loadedmetadata") : this.trigger("mediachange");
                }, bi.pause = function() {
                  this.masterPlaylistLoader_.createMupOnMedia_ && (this.off("loadedmetadata", this.masterPlaylistLoader_.createMupOnMedia_), this.masterPlaylistLoader_.createMupOnMedia_ = null), this.stopRequest(), di().clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null, this.isMaster_ && (di().clearTimeout(this.masterPlaylistLoader_.minimumUpdatePeriodTimeout_), this.masterPlaylistLoader_.minimumUpdatePeriodTimeout_ = null), this.state === "HAVE_NOTHING" && (this.started = !1);
                }, bi.load = function(ci) {
                  var hi = this;
                  di().clearTimeout(this.mediaUpdateTimeout), this.mediaUpdateTimeout = null;
                  var wi = this.media();
                  if (ci) {
                    var zi = wi ? wi.targetDuration / 2 * 1e3 : 5e3;
                    this.mediaUpdateTimeout = di().setTimeout(function() {
                      return hi.load();
                    }, zi);
                    return;
                  }
                  if (!this.started) {
                    this.start();
                    return;
                  }
                  wi && !wi.endList ? (this.isMaster_ && !this.minimumUpdatePeriodTimeout_ && (this.trigger("minimumUpdatePeriod"), this.updateMinimumUpdatePeriodTimeout_()), this.trigger("mediaupdatetimeout")) : this.trigger("loadedplaylist");
                }, bi.start = function() {
                  var ci = this;
                  if (this.started = !0, !this.isMaster_) {
                    this.mediaRequest_ = di().setTimeout(function() {
                      return ci.haveMaster_();
                    }, 0);
                    return;
                  }
                  this.requestMaster_(function(hi, wi) {
                    ci.haveMaster_(), !ci.hasPendingRequest() && !ci.media_ && ci.media(ci.masterPlaylistLoader_.master.playlists[0]);
                  });
                }, bi.requestMaster_ = function(ci) {
                  var hi = this;
                  this.request = this.vhs_.xhr({
                    uri: this.masterPlaylistLoader_.srcUrl,
                    withCredentials: this.withCredentials
                  }, function(wi, zi) {
                    if (hi.requestErrored_(wi, zi)) {
                      hi.state === "HAVE_NOTHING" && (hi.started = !1);
                      return;
                    }
                    var Wo = zi.responseText !== hi.masterPlaylistLoader_.masterXml_;
                    if (hi.masterPlaylistLoader_.masterXml_ = zi.responseText, zi.responseHeaders && zi.responseHeaders.date ? hi.masterLoaded_ = Date.parse(zi.responseHeaders.date) : hi.masterLoaded_ = Date.now(), hi.masterPlaylistLoader_.srcUrl = up(hi.handleManifestRedirects, hi.masterPlaylistLoader_.srcUrl, zi), Wo) {
                      hi.handleMaster_(), hi.syncClientServerClock_(function() {
                        return ci(zi, Wo);
                      });
                      return;
                    }
                    return ci(zi, Wo);
                  });
                }, bi.syncClientServerClock_ = function(ci) {
                  var hi = this, wi = (0, Yi.parseUTCTiming)(this.masterPlaylistLoader_.masterXml_);
                  if (wi === null)
                    return this.masterPlaylistLoader_.clientOffset_ = this.masterLoaded_ - Date.now(), ci();
                  if (wi.method === "DIRECT")
                    return this.masterPlaylistLoader_.clientOffset_ = wi.value - Date.now(), ci();
                  this.request = this.vhs_.xhr({
                    uri: Of(this.masterPlaylistLoader_.srcUrl, wi.value),
                    method: wi.method,
                    withCredentials: this.withCredentials
                  }, function(zi, Wo) {
                    if (hi.request) {
                      if (zi)
                        return hi.masterPlaylistLoader_.clientOffset_ = hi.masterLoaded_ - Date.now(), ci();
                      var aa;
                      wi.method === "HEAD" ? !Wo.responseHeaders || !Wo.responseHeaders.date ? aa = hi.masterLoaded_ : aa = Date.parse(Wo.responseHeaders.date) : aa = Date.parse(Wo.responseText), hi.masterPlaylistLoader_.clientOffset_ = aa - Date.now(), ci();
                    }
                  });
                }, bi.haveMaster_ = function() {
                  this.state = "HAVE_MASTER", this.isMaster_ ? this.trigger("loadedplaylist") : this.media_ || this.media(this.childPlaylist_);
                }, bi.handleMaster_ = function() {
                  this.mediaRequest_ = null;
                  var ci = this.masterPlaylistLoader_.master, hi = Py({
                    masterXml: this.masterPlaylistLoader_.masterXml_,
                    srcUrl: this.masterPlaylistLoader_.srcUrl,
                    clientOffset: this.masterPlaylistLoader_.clientOffset_,
                    sidxMapping: this.masterPlaylistLoader_.sidxMapping_,
                    previousManifest: ci
                  });
                  ci && (hi = Ry(ci, hi, this.masterPlaylistLoader_.sidxMapping_)), this.masterPlaylistLoader_.master = hi || ci;
                  var wi = this.masterPlaylistLoader_.master.locations && this.masterPlaylistLoader_.master.locations[0];
                  return wi && wi !== this.masterPlaylistLoader_.srcUrl && (this.masterPlaylistLoader_.srcUrl = wi), (!ci || hi && hi.minimumUpdatePeriod !== ci.minimumUpdatePeriod) && this.updateMinimumUpdatePeriodTimeout_(), !!hi;
                }, bi.updateMinimumUpdatePeriodTimeout_ = function() {
                  var ci = this.masterPlaylistLoader_;
                  ci.createMupOnMedia_ && (ci.off("loadedmetadata", ci.createMupOnMedia_), ci.createMupOnMedia_ = null), ci.minimumUpdatePeriodTimeout_ && (di().clearTimeout(ci.minimumUpdatePeriodTimeout_), ci.minimumUpdatePeriodTimeout_ = null);
                  var hi = ci.master && ci.master.minimumUpdatePeriod;
                  if (hi === 0 && (ci.media() ? hi = ci.media().targetDuration * 1e3 : (ci.createMupOnMedia_ = ci.updateMinimumUpdatePeriodTimeout_, ci.one("loadedmetadata", ci.createMupOnMedia_))), typeof hi != "number" || hi <= 0) {
                    hi < 0 && this.logger_("found invalid minimumUpdatePeriod of " + hi + ", not setting a timeout");
                    return;
                  }
                  this.createMUPTimeout_(hi);
                }, bi.createMUPTimeout_ = function(ci) {
                  var hi = this.masterPlaylistLoader_;
                  hi.minimumUpdatePeriodTimeout_ = di().setTimeout(function() {
                    hi.minimumUpdatePeriodTimeout_ = null, hi.trigger("minimumUpdatePeriod"), hi.createMUPTimeout_(ci);
                  }, ci);
                }, bi.refreshXml_ = function() {
                  var ci = this;
                  this.requestMaster_(function(hi, wi) {
                    wi && (ci.media_ && (ci.media_ = ci.masterPlaylistLoader_.master.playlists[ci.media_.id]), ci.masterPlaylistLoader_.sidxMapping_ = cv(ci.masterPlaylistLoader_.master, ci.masterPlaylistLoader_.sidxMapping_), ci.addSidxSegments_(ci.media(), ci.state, function(zi) {
                      ci.refreshMedia_(ci.media().id);
                    }));
                  });
                }, bi.refreshMedia_ = function(ci) {
                  var hi = this;
                  if (!ci)
                    throw new Error("refreshMedia_ must take a media id");
                  this.media_ && this.isMaster_ && this.handleMaster_();
                  var wi = this.masterPlaylistLoader_.master.playlists, zi = !this.media_ || this.media_ !== wi[ci];
                  if (zi ? this.media_ = wi[ci] : this.trigger("playlistunchanged"), !this.mediaUpdateTimeout) {
                    var Wo = function aa() {
                      hi.media().endList || (hi.mediaUpdateTimeout = di().setTimeout(function() {
                        hi.trigger("mediaupdatetimeout"), aa();
                      }, Ld(hi.media(), !!zi)));
                    };
                    Wo();
                  }
                  this.trigger("loadedplaylist");
                }, Ei;
              })(sv), bd = {
                GOAL_BUFFER_LENGTH: 30,
                MAX_GOAL_BUFFER_LENGTH: 60,
                BACK_BUFFER_LENGTH: 30,
                GOAL_BUFFER_LENGTH_RATE: 1,
                // 0.5 MB/s
                INITIAL_BANDWIDTH: 4194304,
                // A fudge factor to apply to advertised playlist bitrates to account for
                // temporary flucations in client bandwidth
                BANDWIDTH_VARIANCE: 1.2,
                // How much of the buffer must be filled before we consider upswitching
                BUFFER_LOW_WATER_LINE: 0,
                MAX_BUFFER_LOW_WATER_LINE: 30,
                // TODO: Remove this when experimentalBufferBasedABR is removed
                EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE: 16,
                BUFFER_LOW_WATER_LINE_RATE: 1,
                // If the buffer is greater than the high water line, we won't switch down
                BUFFER_HIGH_WATER_LINE: 30
              }, Fh = function(Ei) {
                for (var bi = new Uint8Array(new ArrayBuffer(Ei.length)), yi = 0; yi < Ei.length; yi++)
                  bi[yi] = Ei.charCodeAt(yi);
                return bi.buffer;
              }, dv = function(Ei) {
                return Ei.on = Ei.addEventListener, Ei.off = Ei.removeEventListener, Ei;
              }, Tm = function(Ei) {
                try {
                  return URL.createObjectURL(new Blob([Ei], {
                    type: "application/javascript"
                  }));
                } catch {
                  var bi = new BlobBuilder();
                  return bi.append(Ei), URL.createObjectURL(bi.getBlob());
                }
              }, fv = function(Ei) {
                return function() {
                  var bi = Tm(Ei), yi = dv(new Worker(bi));
                  yi.objURL = bi;
                  var ci = yi.terminate;
                  return yi.on = yi.addEventListener, yi.off = yi.removeEventListener, yi.terminate = function() {
                    return URL.revokeObjectURL(bi), ci.call(this);
                  }, yi;
                };
              }, pv = function(Ei) {
                return "var browserWorkerPolyFill = " + dv.toString() + `;
browserWorkerPolyFill(self);
` + Ei;
              }, Df = function(Ei) {
                return Ei.toString().replace(/^function.+?{/, "").slice(0, -1);
              }, hv = pv(Df(function() {
                var Vi = function() {
                  this.init = function() {
                    var Bo = {};
                    this.on = function(ua, la) {
                      Bo[ua] || (Bo[ua] = []), Bo[ua] = Bo[ua].concat(la);
                    }, this.off = function(ua, la) {
                      var va;
                      return Bo[ua] ? (va = Bo[ua].indexOf(la), Bo[ua] = Bo[ua].slice(), Bo[ua].splice(va, 1), va > -1) : !1;
                    }, this.trigger = function(ua) {
                      var la, va, Ra, Ba;
                      if (la = Bo[ua], !!la)
                        if (arguments.length === 2)
                          for (Ra = la.length, va = 0; va < Ra; ++va)
                            la[va].call(this, arguments[1]);
                        else {
                          for (Ba = [], va = arguments.length, va = 1; va < arguments.length; ++va)
                            Ba.push(arguments[va]);
                          for (Ra = la.length, va = 0; va < Ra; ++va)
                            la[va].apply(this, Ba);
                        }
                    }, this.dispose = function() {
                      Bo = {};
                    };
                  };
                };
                Vi.prototype.pipe = function(ms) {
                  return this.on("data", function(Bo) {
                    ms.push(Bo);
                  }), this.on("done", function(Bo) {
                    ms.flush(Bo);
                  }), this.on("partialdone", function(Bo) {
                    ms.partialFlush(Bo);
                  }), this.on("endedtimeline", function(Bo) {
                    ms.endTimeline(Bo);
                  }), this.on("reset", function(Bo) {
                    ms.reset(Bo);
                  }), ms;
                }, Vi.prototype.push = function(ms) {
                  this.trigger("data", ms);
                }, Vi.prototype.flush = function(ms) {
                  this.trigger("done", ms);
                }, Vi.prototype.partialFlush = function(ms) {
                  this.trigger("partialdone", ms);
                }, Vi.prototype.endTimeline = function(ms) {
                  this.trigger("endedtimeline", ms);
                }, Vi.prototype.reset = function(ms) {
                  this.trigger("reset", ms);
                };
                var Ei = Vi, bi = Math.pow(2, 32), yi = function(Bo) {
                  var ua = new DataView(Bo.buffer, Bo.byteOffset, Bo.byteLength), la;
                  return ua.getBigUint64 ? (la = ua.getBigUint64(0), la < Number.MAX_SAFE_INTEGER ? Number(la) : la) : ua.getUint32(0) * bi + ua.getUint32(4);
                }, ci = {
                  getUint64: yi,
                  MAX_UINT32: bi
                }, hi = ci.MAX_UINT32, wi, zi, Wo, aa, Ea, Ka, Ha, ks, gl, Sl, Fl, ru, $u, rc, Au, Iu, Bu, mu, au, Pu, nu, ec, Lu, oc, Uc, Hc, cd, Td, Xc, Qd, Dc, Lv, Zf, lh, Hh, hg;
                (function() {
                  var ms;
                  if (Lu = {
                    avc1: [],
                    // codingname
                    avcC: [],
                    btrt: [],
                    dinf: [],
                    dref: [],
                    esds: [],
                    ftyp: [],
                    hdlr: [],
                    mdat: [],
                    mdhd: [],
                    mdia: [],
                    mfhd: [],
                    minf: [],
                    moof: [],
                    moov: [],
                    mp4a: [],
                    // codingname
                    mvex: [],
                    mvhd: [],
                    pasp: [],
                    sdtp: [],
                    smhd: [],
                    stbl: [],
                    stco: [],
                    stsc: [],
                    stsd: [],
                    stsz: [],
                    stts: [],
                    styp: [],
                    tfdt: [],
                    tfhd: [],
                    traf: [],
                    trak: [],
                    trun: [],
                    trex: [],
                    tkhd: [],
                    vmhd: []
                  }, !(typeof Uint8Array > "u")) {
                    for (ms in Lu)
                      Lu.hasOwnProperty(ms) && (Lu[ms] = [ms.charCodeAt(0), ms.charCodeAt(1), ms.charCodeAt(2), ms.charCodeAt(3)]);
                    oc = new Uint8Array([105, 115, 111, 109]), Hc = new Uint8Array([97, 118, 99, 49]), Uc = new Uint8Array([0, 0, 0, 1]), cd = new Uint8Array([
                      0,
                      // version 0
                      0,
                      0,
                      0,
                      // flags
                      0,
                      0,
                      0,
                      0,
                      // pre_defined
                      118,
                      105,
                      100,
                      101,
                      // handler_type: 'vide'
                      0,
                      0,
                      0,
                      0,
                      // reserved
                      0,
                      0,
                      0,
                      0,
                      // reserved
                      0,
                      0,
                      0,
                      0,
                      // reserved
                      86,
                      105,
                      100,
                      101,
                      111,
                      72,
                      97,
                      110,
                      100,
                      108,
                      101,
                      114,
                      0
                      // name: 'VideoHandler'
                    ]), Td = new Uint8Array([
                      0,
                      // version 0
                      0,
                      0,
                      0,
                      // flags
                      0,
                      0,
                      0,
                      0,
                      // pre_defined
                      115,
                      111,
                      117,
                      110,
                      // handler_type: 'soun'
                      0,
                      0,
                      0,
                      0,
                      // reserved
                      0,
                      0,
                      0,
                      0,
                      // reserved
                      0,
                      0,
                      0,
                      0,
                      // reserved
                      83,
                      111,
                      117,
                      110,
                      100,
                      72,
                      97,
                      110,
                      100,
                      108,
                      101,
                      114,
                      0
                      // name: 'SoundHandler'
                    ]), Xc = {
                      video: cd,
                      audio: Td
                    }, Lv = new Uint8Array([
                      0,
                      // version 0
                      0,
                      0,
                      0,
                      // flags
                      0,
                      0,
                      0,
                      1,
                      // entry_count
                      0,
                      0,
                      0,
                      12,
                      // entry_size
                      117,
                      114,
                      108,
                      32,
                      // 'url' type
                      0,
                      // version 0
                      0,
                      0,
                      1
                      // entry_flags
                    ]), Dc = new Uint8Array([
                      0,
                      // version
                      0,
                      0,
                      0,
                      // flags
                      0,
                      0,
                      // balance, 0 means centered
                      0,
                      0
                      // reserved
                    ]), Zf = new Uint8Array([
                      0,
                      // version
                      0,
                      0,
                      0,
                      // flags
                      0,
                      0,
                      0,
                      0
                      // entry_count
                    ]), lh = Zf, Hh = new Uint8Array([
                      0,
                      // version
                      0,
                      0,
                      0,
                      // flags
                      0,
                      0,
                      0,
                      0,
                      // sample_size
                      0,
                      0,
                      0,
                      0
                      // sample_count
                    ]), hg = Zf, Qd = new Uint8Array([
                      0,
                      // version
                      0,
                      0,
                      1,
                      // flags
                      0,
                      0,
                      // graphicsmode
                      0,
                      0,
                      0,
                      0,
                      0,
                      0
                      // opcolor
                    ]);
                  }
                })(), wi = function(Bo) {
                  var ua = [], la = 0, va, Ra, Ba;
                  for (va = 1; va < arguments.length; va++)
                    ua.push(arguments[va]);
                  for (va = ua.length; va--; )
                    la += ua[va].byteLength;
                  for (Ra = new Uint8Array(la + 8), Ba = new DataView(Ra.buffer, Ra.byteOffset, Ra.byteLength), Ba.setUint32(0, Ra.byteLength), Ra.set(Bo, 4), va = 0, la = 8; va < ua.length; va++)
                    Ra.set(ua[va], la), la += ua[va].byteLength;
                  return Ra;
                }, zi = function() {
                  return wi(Lu.dinf, wi(Lu.dref, Lv));
                }, Wo = function(Bo) {
                  return wi(Lu.esds, new Uint8Array([
                    0,
                    // version
                    0,
                    0,
                    0,
                    // flags
                    // ES_Descriptor
                    3,
                    // tag, ES_DescrTag
                    25,
                    // length
                    0,
                    0,
                    // ES_ID
                    0,
                    // streamDependenceFlag, URL_flag, reserved, streamPriority
                    // DecoderConfigDescriptor
                    4,
                    // tag, DecoderConfigDescrTag
                    17,
                    // length
                    64,
                    // object type
                    21,
                    // streamType
                    0,
                    6,
                    0,
                    // bufferSizeDB
                    0,
                    0,
                    218,
                    192,
                    // maxBitrate
                    0,
                    0,
                    218,
                    192,
                    // avgBitrate
                    // DecoderSpecificInfo
                    5,
                    // tag, DecoderSpecificInfoTag
                    2,
                    // length
                    // ISO/IEC 14496-3, AudioSpecificConfig
                    // for samplingFrequencyIndex see ISO/IEC 13818-7:2006, 8.1.3.2.2, Table 35
                    Bo.audioobjecttype << 3 | Bo.samplingfrequencyindex >>> 1,
                    Bo.samplingfrequencyindex << 7 | Bo.channelcount << 3,
                    6,
                    1,
                    2
                    // GASpecificConfig
                  ]));
                }, aa = function() {
                  return wi(Lu.ftyp, oc, Uc, oc, Hc);
                }, Iu = function(Bo) {
                  return wi(Lu.hdlr, Xc[Bo]);
                }, Ea = function(Bo) {
                  return wi(Lu.mdat, Bo);
                }, Au = function(Bo) {
                  var ua = new Uint8Array([
                    0,
                    // version 0
                    0,
                    0,
                    0,
                    // flags
                    0,
                    0,
                    0,
                    2,
                    // creation_time
                    0,
                    0,
                    0,
                    3,
                    // modification_time
                    0,
                    1,
                    95,
                    144,
                    // timescale, 90,000 "ticks" per second
                    Bo.duration >>> 24 & 255,
                    Bo.duration >>> 16 & 255,
                    Bo.duration >>> 8 & 255,
                    Bo.duration & 255,
                    // duration
                    85,
                    196,
                    // 'und' language (undetermined)
                    0,
                    0
                  ]);
                  return Bo.samplerate && (ua[12] = Bo.samplerate >>> 24 & 255, ua[13] = Bo.samplerate >>> 16 & 255, ua[14] = Bo.samplerate >>> 8 & 255, ua[15] = Bo.samplerate & 255), wi(Lu.mdhd, ua);
                }, rc = function(Bo) {
                  return wi(Lu.mdia, Au(Bo), Iu(Bo.type), Ha(Bo));
                }, Ka = function(Bo) {
                  return wi(Lu.mfhd, new Uint8Array([
                    0,
                    0,
                    0,
                    0,
                    // flags
                    (Bo & 4278190080) >> 24,
                    (Bo & 16711680) >> 16,
                    (Bo & 65280) >> 8,
                    Bo & 255
                    // sequence_number
                  ]));
                }, Ha = function(Bo) {
                  return wi(Lu.minf, Bo.type === "video" ? wi(Lu.vmhd, Qd) : wi(Lu.smhd, Dc), zi(), mu(Bo));
                }, ks = function(Bo, ua) {
                  for (var la = [], va = ua.length; va--; )
                    la[va] = Pu(ua[va]);
                  return wi.apply(null, [Lu.moof, Ka(Bo)].concat(la));
                }, gl = function(Bo) {
                  for (var ua = Bo.length, la = []; ua--; )
                    la[ua] = ru(Bo[ua]);
                  return wi.apply(null, [Lu.moov, Fl(4294967295)].concat(la).concat(Sl(Bo)));
                }, Sl = function(Bo) {
                  for (var ua = Bo.length, la = []; ua--; )
                    la[ua] = nu(Bo[ua]);
                  return wi.apply(null, [Lu.mvex].concat(la));
                }, Fl = function(Bo) {
                  var ua = new Uint8Array([
                    0,
                    // version 0
                    0,
                    0,
                    0,
                    // flags
                    0,
                    0,
                    0,
                    1,
                    // creation_time
                    0,
                    0,
                    0,
                    2,
                    // modification_time
                    0,
                    1,
                    95,
                    144,
                    // timescale, 90,000 "ticks" per second
                    (Bo & 4278190080) >> 24,
                    (Bo & 16711680) >> 16,
                    (Bo & 65280) >> 8,
                    Bo & 255,
                    // duration
                    0,
                    1,
                    0,
                    0,
                    // 1.0 rate
                    1,
                    0,
                    // 1.0 volume
                    0,
                    0,
                    // reserved
                    0,
                    0,
                    0,
                    0,
                    // reserved
                    0,
                    0,
                    0,
                    0,
                    // reserved
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    64,
                    0,
                    0,
                    0,
                    // transformation: unity matrix
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    // pre_defined
                    255,
                    255,
                    255,
                    255
                    // next_track_ID
                  ]);
                  return wi(Lu.mvhd, ua);
                }, Bu = function(Bo) {
                  var ua = Bo.samples || [], la = new Uint8Array(4 + ua.length), va, Ra;
                  for (Ra = 0; Ra < ua.length; Ra++)
                    va = ua[Ra].flags, la[Ra + 4] = va.dependsOn << 4 | va.isDependedOn << 2 | va.hasRedundancy;
                  return wi(Lu.sdtp, la);
                }, mu = function(Bo) {
                  return wi(Lu.stbl, au(Bo), wi(Lu.stts, hg), wi(Lu.stsc, lh), wi(Lu.stsz, Hh), wi(Lu.stco, Zf));
                }, (function() {
                  var ms, Bo;
                  au = function(la) {
                    return wi(Lu.stsd, new Uint8Array([
                      0,
                      // version 0
                      0,
                      0,
                      0,
                      // flags
                      0,
                      0,
                      0,
                      1
                    ]), la.type === "video" ? ms(la) : Bo(la));
                  }, ms = function(la) {
                    var va = la.sps || [], Ra = la.pps || [], Ba = [], Ms = [], tl, vl;
                    for (tl = 0; tl < va.length; tl++)
                      Ba.push((va[tl].byteLength & 65280) >>> 8), Ba.push(va[tl].byteLength & 255), Ba = Ba.concat(Array.prototype.slice.call(va[tl]));
                    for (tl = 0; tl < Ra.length; tl++)
                      Ms.push((Ra[tl].byteLength & 65280) >>> 8), Ms.push(Ra[tl].byteLength & 255), Ms = Ms.concat(Array.prototype.slice.call(Ra[tl]));
                    if (vl = [Lu.avc1, new Uint8Array([
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      // reserved
                      0,
                      1,
                      // data_reference_index
                      0,
                      0,
                      // pre_defined
                      0,
                      0,
                      // reserved
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      // pre_defined
                      (la.width & 65280) >> 8,
                      la.width & 255,
                      // width
                      (la.height & 65280) >> 8,
                      la.height & 255,
                      // height
                      0,
                      72,
                      0,
                      0,
                      // horizresolution
                      0,
                      72,
                      0,
                      0,
                      // vertresolution
                      0,
                      0,
                      0,
                      0,
                      // reserved
                      0,
                      1,
                      // frame_count
                      19,
                      118,
                      105,
                      100,
                      101,
                      111,
                      106,
                      115,
                      45,
                      99,
                      111,
                      110,
                      116,
                      114,
                      105,
                      98,
                      45,
                      104,
                      108,
                      115,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      // compressorname
                      0,
                      24,
                      // depth = 24
                      17,
                      17
                      // pre_defined = -1
                    ]), wi(Lu.avcC, new Uint8Array([
                      1,
                      // configurationVersion
                      la.profileIdc,
                      // AVCProfileIndication
                      la.profileCompatibility,
                      // profile_compatibility
                      la.levelIdc,
                      // AVCLevelIndication
                      255
                      // lengthSizeMinusOne, hard-coded to 4 bytes
                    ].concat(
                      [va.length],
                      // numOfSequenceParameterSets
                      Ba,
                      // "SPS"
                      [Ra.length],
                      // numOfPictureParameterSets
                      Ms
                      // "PPS"
                    ))), wi(Lu.btrt, new Uint8Array([
                      0,
                      28,
                      156,
                      128,
                      // bufferSizeDB
                      0,
                      45,
                      198,
                      192,
                      // maxBitrate
                      0,
                      45,
                      198,
                      192
                      // avgBitrate
                    ]))], la.sarRatio) {
                      var ul = la.sarRatio[0], Pl = la.sarRatio[1];
                      vl.push(wi(Lu.pasp, new Uint8Array([(ul & 4278190080) >> 24, (ul & 16711680) >> 16, (ul & 65280) >> 8, ul & 255, (Pl & 4278190080) >> 24, (Pl & 16711680) >> 16, (Pl & 65280) >> 8, Pl & 255])));
                    }
                    return wi.apply(null, vl);
                  }, Bo = function(la) {
                    return wi(Lu.mp4a, new Uint8Array([
                      // SampleEntry, ISO/IEC 14496-12
                      0,
                      0,
                      0,
                      0,
                      0,
                      0,
                      // reserved
                      0,
                      1,
                      // data_reference_index
                      // AudioSampleEntry, ISO/IEC 14496-12
                      0,
                      0,
                      0,
                      0,
                      // reserved
                      0,
                      0,
                      0,
                      0,
                      // reserved
                      (la.channelcount & 65280) >> 8,
                      la.channelcount & 255,
                      // channelcount
                      (la.samplesize & 65280) >> 8,
                      la.samplesize & 255,
                      // samplesize
                      0,
                      0,
                      // pre_defined
                      0,
                      0,
                      // reserved
                      (la.samplerate & 65280) >> 8,
                      la.samplerate & 255,
                      0,
                      0
                      // samplerate, 16.16
                      // MP4AudioSampleEntry, ISO/IEC 14496-14
                    ]), Wo(la));
                  };
                })(), $u = function(Bo) {
                  var ua = new Uint8Array([
                    0,
                    // version 0
                    0,
                    0,
                    7,
                    // flags
                    0,
                    0,
                    0,
                    0,
                    // creation_time
                    0,
                    0,
                    0,
                    0,
                    // modification_time
                    (Bo.id & 4278190080) >> 24,
                    (Bo.id & 16711680) >> 16,
                    (Bo.id & 65280) >> 8,
                    Bo.id & 255,
                    // track_ID
                    0,
                    0,
                    0,
                    0,
                    // reserved
                    (Bo.duration & 4278190080) >> 24,
                    (Bo.duration & 16711680) >> 16,
                    (Bo.duration & 65280) >> 8,
                    Bo.duration & 255,
                    // duration
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    // reserved
                    0,
                    0,
                    // layer
                    0,
                    0,
                    // alternate_group
                    1,
                    0,
                    // non-audio track volume
                    0,
                    0,
                    // reserved
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    64,
                    0,
                    0,
                    0,
                    // transformation: unity matrix
                    (Bo.width & 65280) >> 8,
                    Bo.width & 255,
                    0,
                    0,
                    // width
                    (Bo.height & 65280) >> 8,
                    Bo.height & 255,
                    0,
                    0
                    // height
                  ]);
                  return wi(Lu.tkhd, ua);
                }, Pu = function(Bo) {
                  var ua, la, va, Ra, Ba, Ms, tl;
                  return ua = wi(Lu.tfhd, new Uint8Array([
                    0,
                    // version 0
                    0,
                    0,
                    58,
                    // flags
                    (Bo.id & 4278190080) >> 24,
                    (Bo.id & 16711680) >> 16,
                    (Bo.id & 65280) >> 8,
                    Bo.id & 255,
                    // track_ID
                    0,
                    0,
                    0,
                    1,
                    // sample_description_index
                    0,
                    0,
                    0,
                    0,
                    // default_sample_duration
                    0,
                    0,
                    0,
                    0,
                    // default_sample_size
                    0,
                    0,
                    0,
                    0
                    // default_sample_flags
                  ])), Ms = Math.floor(Bo.baseMediaDecodeTime / hi), tl = Math.floor(Bo.baseMediaDecodeTime % hi), la = wi(Lu.tfdt, new Uint8Array([
                    1,
                    // version 1
                    0,
                    0,
                    0,
                    // flags
                    // baseMediaDecodeTime
                    Ms >>> 24 & 255,
                    Ms >>> 16 & 255,
                    Ms >>> 8 & 255,
                    Ms & 255,
                    tl >>> 24 & 255,
                    tl >>> 16 & 255,
                    tl >>> 8 & 255,
                    tl & 255
                  ])), Ba = 92, Bo.type === "audio" ? (va = ec(Bo, Ba), wi(Lu.traf, ua, la, va)) : (Ra = Bu(Bo), va = ec(Bo, Ra.length + Ba), wi(Lu.traf, ua, la, va, Ra));
                }, ru = function(Bo) {
                  return Bo.duration = Bo.duration || 4294967295, wi(Lu.trak, $u(Bo), rc(Bo));
                }, nu = function(Bo) {
                  var ua = new Uint8Array([
                    0,
                    // version 0
                    0,
                    0,
                    0,
                    // flags
                    (Bo.id & 4278190080) >> 24,
                    (Bo.id & 16711680) >> 16,
                    (Bo.id & 65280) >> 8,
                    Bo.id & 255,
                    // track_ID
                    0,
                    0,
                    0,
                    1,
                    // default_sample_description_index
                    0,
                    0,
                    0,
                    0,
                    // default_sample_duration
                    0,
                    0,
                    0,
                    0,
                    // default_sample_size
                    0,
                    1,
                    0,
                    1
                    // default_sample_flags
                  ]);
                  return Bo.type !== "video" && (ua[ua.length - 1] = 0), wi(Lu.trex, ua);
                }, (function() {
                  var ms, Bo, ua;
                  ua = function(va, Ra) {
                    var Ba = 0, Ms = 0, tl = 0, vl = 0;
                    return va.length && (va[0].duration !== void 0 && (Ba = 1), va[0].size !== void 0 && (Ms = 2), va[0].flags !== void 0 && (tl = 4), va[0].compositionTimeOffset !== void 0 && (vl = 8)), [
                      0,
                      // version 0
                      0,
                      Ba | Ms | tl | vl,
                      1,
                      // flags
                      (va.length & 4278190080) >>> 24,
                      (va.length & 16711680) >>> 16,
                      (va.length & 65280) >>> 8,
                      va.length & 255,
                      // sample_count
                      (Ra & 4278190080) >>> 24,
                      (Ra & 16711680) >>> 16,
                      (Ra & 65280) >>> 8,
                      Ra & 255
                      // data_offset
                    ];
                  }, Bo = function(va, Ra) {
                    var Ba, Ms, tl, vl, ul, Pl;
                    for (vl = va.samples || [], Ra += 20 + 16 * vl.length, tl = ua(vl, Ra), Ms = new Uint8Array(tl.length + vl.length * 16), Ms.set(tl), Ba = tl.length, Pl = 0; Pl < vl.length; Pl++)
                      ul = vl[Pl], Ms[Ba++] = (ul.duration & 4278190080) >>> 24, Ms[Ba++] = (ul.duration & 16711680) >>> 16, Ms[Ba++] = (ul.duration & 65280) >>> 8, Ms[Ba++] = ul.duration & 255, Ms[Ba++] = (ul.size & 4278190080) >>> 24, Ms[Ba++] = (ul.size & 16711680) >>> 16, Ms[Ba++] = (ul.size & 65280) >>> 8, Ms[Ba++] = ul.size & 255, Ms[Ba++] = ul.flags.isLeading << 2 | ul.flags.dependsOn, Ms[Ba++] = ul.flags.isDependedOn << 6 | ul.flags.hasRedundancy << 4 | ul.flags.paddingValue << 1 | ul.flags.isNonSyncSample, Ms[Ba++] = ul.flags.degradationPriority & 61440, Ms[Ba++] = ul.flags.degradationPriority & 15, Ms[Ba++] = (ul.compositionTimeOffset & 4278190080) >>> 24, Ms[Ba++] = (ul.compositionTimeOffset & 16711680) >>> 16, Ms[Ba++] = (ul.compositionTimeOffset & 65280) >>> 8, Ms[Ba++] = ul.compositionTimeOffset & 255;
                    return wi(Lu.trun, Ms);
                  }, ms = function(va, Ra) {
                    var Ba, Ms, tl, vl, ul, Pl;
                    for (vl = va.samples || [], Ra += 20 + 8 * vl.length, tl = ua(vl, Ra), Ba = new Uint8Array(tl.length + vl.length * 8), Ba.set(tl), Ms = tl.length, Pl = 0; Pl < vl.length; Pl++)
                      ul = vl[Pl], Ba[Ms++] = (ul.duration & 4278190080) >>> 24, Ba[Ms++] = (ul.duration & 16711680) >>> 16, Ba[Ms++] = (ul.duration & 65280) >>> 8, Ba[Ms++] = ul.duration & 255, Ba[Ms++] = (ul.size & 4278190080) >>> 24, Ba[Ms++] = (ul.size & 16711680) >>> 16, Ba[Ms++] = (ul.size & 65280) >>> 8, Ba[Ms++] = ul.size & 255;
                    return wi(Lu.trun, Ba);
                  }, ec = function(va, Ra) {
                    return va.type === "audio" ? ms(va, Ra) : Bo(va, Ra);
                  };
                })();
                var Mp = {
                  ftyp: aa,
                  mdat: Ea,
                  moof: ks,
                  moov: gl,
                  initSegment: function(Bo) {
                    var ua = aa(), la = gl(Bo), va;
                    return va = new Uint8Array(ua.byteLength + la.byteLength), va.set(ua), va.set(la, ua.byteLength), va;
                  }
                }, Vg = function(Bo) {
                  var ua, la, va = [], Ra = [];
                  for (Ra.byteLength = 0, Ra.nalCount = 0, Ra.duration = 0, va.byteLength = 0, ua = 0; ua < Bo.length; ua++)
                    la = Bo[ua], la.nalUnitType === "access_unit_delimiter_rbsp" ? (va.length && (va.duration = la.dts - va.dts, Ra.byteLength += va.byteLength, Ra.nalCount += va.length, Ra.duration += va.duration, Ra.push(va)), va = [la], va.byteLength = la.data.byteLength, va.pts = la.pts, va.dts = la.dts) : (la.nalUnitType === "slice_layer_without_partitioning_rbsp_idr" && (va.keyFrame = !0), va.duration = la.dts - va.dts, va.byteLength += la.data.byteLength, va.push(la));
                  return Ra.length && (!va.duration || va.duration <= 0) && (va.duration = Ra[Ra.length - 1].duration), Ra.byteLength += va.byteLength, Ra.nalCount += va.length, Ra.duration += va.duration, Ra.push(va), Ra;
                }, Wg = function(Bo) {
                  var ua, la, va = [], Ra = [];
                  for (va.byteLength = 0, va.nalCount = 0, va.duration = 0, va.pts = Bo[0].pts, va.dts = Bo[0].dts, Ra.byteLength = 0, Ra.nalCount = 0, Ra.duration = 0, Ra.pts = Bo[0].pts, Ra.dts = Bo[0].dts, ua = 0; ua < Bo.length; ua++)
                    la = Bo[ua], la.keyFrame ? (va.length && (Ra.push(va), Ra.byteLength += va.byteLength, Ra.nalCount += va.nalCount, Ra.duration += va.duration), va = [la], va.nalCount = la.length, va.byteLength = la.byteLength, va.pts = la.pts, va.dts = la.dts, va.duration = la.duration) : (va.duration += la.duration, va.nalCount += la.length, va.byteLength += la.byteLength, va.push(la));
                  return Ra.length && va.duration <= 0 && (va.duration = Ra[Ra.length - 1].duration), Ra.byteLength += va.byteLength, Ra.nalCount += va.nalCount, Ra.duration += va.duration, Ra.push(va), Ra;
                }, Gg = function(Bo) {
                  var ua;
                  return !Bo[0][0].keyFrame && Bo.length > 1 && (ua = Bo.shift(), Bo.byteLength -= ua.byteLength, Bo.nalCount -= ua.nalCount, Bo[0][0].dts = ua.dts, Bo[0][0].pts = ua.pts, Bo[0][0].duration += ua.duration), Bo;
                }, Rb = function() {
                  return {
                    size: 0,
                    flags: {
                      isLeading: 0,
                      dependsOn: 1,
                      isDependedOn: 0,
                      hasRedundancy: 0,
                      degradationPriority: 0,
                      isNonSyncSample: 1
                    }
                  };
                }, b0 = function(Bo, ua) {
                  var la = Rb();
                  return la.dataOffset = ua, la.compositionTimeOffset = Bo.pts - Bo.dts, la.duration = Bo.duration, la.size = 4 * Bo.length, la.size += Bo.byteLength, Bo.keyFrame && (la.flags.dependsOn = 2, la.flags.isNonSyncSample = 0), la;
                }, Ob = function(Bo, ua) {
                  var la, va, Ra, Ba, Ms, tl = ua || 0, vl = [];
                  for (la = 0; la < Bo.length; la++)
                    for (Ba = Bo[la], va = 0; va < Ba.length; va++)
                      Ms = Ba[va], Ra = b0(Ms, tl), tl += Ra.size, vl.push(Ra);
                  return vl;
                }, Ab = function(Bo) {
                  var ua, la, va, Ra, Ba, Ms, tl = 0, vl = Bo.byteLength, ul = Bo.nalCount, Pl = vl + 4 * ul, Jl = new Uint8Array(Pl), Cu = new DataView(Jl.buffer);
                  for (ua = 0; ua < Bo.length; ua++)
                    for (Ra = Bo[ua], la = 0; la < Ra.length; la++)
                      for (Ba = Ra[la], va = 0; va < Ba.length; va++)
                        Ms = Ba[va], Cu.setUint32(tl, Ms.data.byteLength), tl += 4, Jl.set(Ms.data, tl), tl += Ms.data.byteLength;
                  return Jl;
                }, Ib = function(Bo, ua) {
                  var la, va = ua || 0, Ra = [];
                  return la = b0(Bo, va), Ra.push(la), Ra;
                }, $b = function(Bo) {
                  var ua, la, va = 0, Ra = Bo.byteLength, Ba = Bo.length, Ms = Ra + 4 * Ba, tl = new Uint8Array(Ms), vl = new DataView(tl.buffer);
                  for (ua = 0; ua < Bo.length; ua++)
                    la = Bo[ua], vl.setUint32(va, la.data.byteLength), va += 4, tl.set(la.data, va), va += la.data.byteLength;
                  return tl;
                }, jm = {
                  groupNalsIntoFrames: Vg,
                  groupFramesIntoGops: Wg,
                  extendFirstKeyFrame: Gg,
                  generateSampleTable: Ob,
                  concatenateNalData: Ab,
                  generateSampleTableForFrame: Ib,
                  concatenateNalDataForFrame: $b
                }, zh = [33, 16, 5, 32, 164, 27], e0 = [33, 65, 108, 84, 1, 2, 4, 8, 168, 2, 4, 8, 17, 191, 252], kc = function(Bo) {
                  for (var ua = []; Bo--; )
                    ua.push(0);
                  return ua;
                }, Db = function(Bo) {
                  return Object.keys(Bo).reduce(function(ua, la) {
                    return ua[la] = new Uint8Array(Bo[la].reduce(function(va, Ra) {
                      return va.concat(Ra);
                    }, [])), ua;
                  }, {});
                }, r0, kb = function() {
                  if (!r0) {
                    var Bo = {
                      96e3: [zh, [227, 64], kc(154), [56]],
                      88200: [zh, [231], kc(170), [56]],
                      64e3: [zh, [248, 192], kc(240), [56]],
                      48e3: [zh, [255, 192], kc(268), [55, 148, 128], kc(54), [112]],
                      44100: [zh, [255, 192], kc(268), [55, 163, 128], kc(84), [112]],
                      32e3: [zh, [255, 192], kc(268), [55, 234], kc(226), [112]],
                      24e3: [zh, [255, 192], kc(268), [55, 255, 128], kc(268), [111, 112], kc(126), [224]],
                      16e3: [zh, [255, 192], kc(268), [55, 255, 128], kc(268), [111, 255], kc(269), [223, 108], kc(195), [1, 192]],
                      12e3: [e0, kc(268), [3, 127, 248], kc(268), [6, 255, 240], kc(268), [13, 255, 224], kc(268), [27, 253, 128], kc(259), [56]],
                      11025: [e0, kc(268), [3, 127, 248], kc(268), [6, 255, 240], kc(268), [13, 255, 224], kc(268), [27, 255, 192], kc(268), [55, 175, 128], kc(108), [112]],
                      8e3: [e0, kc(268), [3, 121, 16], kc(47), [7]]
                    };
                    r0 = Db(Bo);
                  }
                  return r0;
                }, n0 = 9e4, i0, o0, Mv, a0, T0, E0, S0;
                i0 = function(Bo) {
                  return Bo * n0;
                }, o0 = function(Bo, ua) {
                  return Bo * ua;
                }, Mv = function(Bo) {
                  return Bo / n0;
                }, a0 = function(Bo, ua) {
                  return Bo / ua;
                }, T0 = function(Bo, ua) {
                  return i0(a0(Bo, ua));
                }, E0 = function(Bo, ua) {
                  return o0(Mv(Bo), ua);
                }, S0 = function(Bo, ua, la) {
                  return Mv(la ? Bo : Bo - ua);
                };
                var Pc = {
                  ONE_SECOND_IN_TS: n0,
                  secondsToVideoTs: i0,
                  secondsToAudioTs: o0,
                  videoTsToSeconds: Mv,
                  audioTsToSeconds: a0,
                  audioTsToVideoTs: T0,
                  videoTsToAudioTs: E0,
                  metadataTsToSeconds: S0
                }, Nb = function(Bo) {
                  var ua, la, va = 0;
                  for (ua = 0; ua < Bo.length; ua++)
                    la = Bo[ua], va += la.data.byteLength;
                  return va;
                }, Lb = function(Bo, ua, la, va) {
                  var Ra, Ba = 0, Ms = 0, tl = 0, vl = 0, ul, Pl, Jl;
                  if (ua.length && (Ra = Pc.audioTsToVideoTs(Bo.baseMediaDecodeTime, Bo.samplerate), Ba = Math.ceil(Pc.ONE_SECOND_IN_TS / (Bo.samplerate / 1024)), la && va && (Ms = Ra - Math.max(la, va), tl = Math.floor(Ms / Ba), vl = tl * Ba), !(tl < 1 || vl > Pc.ONE_SECOND_IN_TS / 2))) {
                    for (ul = kb()[Bo.samplerate], ul || (ul = ua[0].data), Pl = 0; Pl < tl; Pl++)
                      Jl = ua[0], ua.splice(0, 0, {
                        data: ul,
                        dts: Jl.dts - Ba,
                        pts: Jl.pts - Ba
                      });
                    return Bo.baseMediaDecodeTime -= Math.floor(Pc.videoTsToAudioTs(vl, Bo.samplerate)), vl;
                  }
                }, Mb = function(Bo, ua, la) {
                  return ua.minSegmentDts >= la ? Bo : (ua.minSegmentDts = 1 / 0, Bo.filter(function(va) {
                    return va.dts >= la ? (ua.minSegmentDts = Math.min(ua.minSegmentDts, va.dts), ua.minSegmentPts = ua.minSegmentDts, !0) : !1;
                  }));
                }, jb = function(Bo) {
                  var ua, la, va = [];
                  for (ua = 0; ua < Bo.length; ua++)
                    la = Bo[ua], va.push({
                      size: la.data.byteLength,
                      duration: 1024
                      // For AAC audio, all samples contain 1024 samples
                    });
                  return va;
                }, Fb = function(Bo) {
                  var ua, la, va = 0, Ra = new Uint8Array(Nb(Bo));
                  for (ua = 0; ua < Bo.length; ua++)
                    la = Bo[ua], Ra.set(la.data, va), va += la.data.byteLength;
                  return Ra;
                }, jv = {
                  prefixWithSilence: Lb,
                  trimAdtsFramesByEarliestDts: Mb,
                  generateSampleTable: jb,
                  concatenateFrameData: Fb
                }, Bb = Pc.ONE_SECOND_IN_TS, Ub = function(Bo, ua) {
                  typeof ua.pts == "number" && (Bo.timelineStartInfo.pts === void 0 && (Bo.timelineStartInfo.pts = ua.pts), Bo.minSegmentPts === void 0 ? Bo.minSegmentPts = ua.pts : Bo.minSegmentPts = Math.min(Bo.minSegmentPts, ua.pts), Bo.maxSegmentPts === void 0 ? Bo.maxSegmentPts = ua.pts : Bo.maxSegmentPts = Math.max(Bo.maxSegmentPts, ua.pts)), typeof ua.dts == "number" && (Bo.timelineStartInfo.dts === void 0 && (Bo.timelineStartInfo.dts = ua.dts), Bo.minSegmentDts === void 0 ? Bo.minSegmentDts = ua.dts : Bo.minSegmentDts = Math.min(Bo.minSegmentDts, ua.dts), Bo.maxSegmentDts === void 0 ? Bo.maxSegmentDts = ua.dts : Bo.maxSegmentDts = Math.max(Bo.maxSegmentDts, ua.dts));
                }, Vb = function(Bo) {
                  delete Bo.minSegmentDts, delete Bo.maxSegmentDts, delete Bo.minSegmentPts, delete Bo.maxSegmentPts;
                }, Wb = function(Bo, ua) {
                  var la, va, Ra = Bo.minSegmentDts;
                  return ua || (Ra -= Bo.timelineStartInfo.dts), la = Bo.timelineStartInfo.baseMediaDecodeTime, la += Ra, la = Math.max(0, la), Bo.type === "audio" && (va = Bo.samplerate / Bb, la *= va, la = Math.floor(la)), la;
                }, gp = {
                  clearDtsInfo: Vb,
                  calculateTrackBaseMediaDecodeTime: Wb,
                  collectDtsInfo: Ub
                }, x0 = 4, Gb = 128, Hb = function(Bo) {
                  for (var ua = 0, la = {
                    payloadType: -1,
                    payloadSize: 0
                  }, va = 0, Ra = 0; ua < Bo.byteLength && Bo[ua] !== Gb; ) {
                    for (; Bo[ua] === 255; )
                      va += 255, ua++;
                    for (va += Bo[ua++]; Bo[ua] === 255; )
                      Ra += 255, ua++;
                    if (Ra += Bo[ua++], !la.payload && va === x0) {
                      var Ba = String.fromCharCode(Bo[ua + 3], Bo[ua + 4], Bo[ua + 5], Bo[ua + 6]);
                      if (Ba === "GA94") {
                        la.payloadType = va, la.payloadSize = Ra, la.payload = Bo.subarray(ua, ua + Ra);
                        break;
                      } else
                        la.payload = void 0;
                    }
                    ua += Ra, va = 0, Ra = 0;
                  }
                  return la;
                }, zb = function(Bo) {
                  return Bo.payload[0] !== 181 || (Bo.payload[1] << 8 | Bo.payload[2]) !== 49 || String.fromCharCode(Bo.payload[3], Bo.payload[4], Bo.payload[5], Bo.payload[6]) !== "GA94" || Bo.payload[7] !== 3 ? null : Bo.payload.subarray(8, Bo.payload.length - 1);
                }, Kb = function(Bo, ua) {
                  var la = [], va, Ra, Ba, Ms;
                  if (!(ua[0] & 64))
                    return la;
                  for (Ra = ua[0] & 31, va = 0; va < Ra; va++)
                    Ba = va * 3, Ms = {
                      type: ua[Ba + 2] & 3,
                      pts: Bo
                    }, ua[Ba + 2] & 4 && (Ms.ccData = ua[Ba + 3] << 8 | ua[Ba + 4], la.push(Ms));
                  return la;
                }, qb = function(Bo) {
                  for (var ua = Bo.byteLength, la = [], va = 1, Ra, Ba; va < ua - 2; )
                    Bo[va] === 0 && Bo[va + 1] === 0 && Bo[va + 2] === 3 ? (la.push(va + 2), va += 2) : va++;
                  if (la.length === 0)
                    return Bo;
                  Ra = ua - la.length, Ba = new Uint8Array(Ra);
                  var Ms = 0;
                  for (va = 0; va < Ra; Ms++, va++)
                    Ms === la[0] && (Ms++, la.shift()), Ba[va] = Bo[Ms];
                  return Ba;
                }, Fm = {
                  parseSei: Hb,
                  parseUserData: zb,
                  parseCaptionPackets: Kb,
                  discardEmulationPreventionBytes: qb,
                  USER_DATA_REGISTERED_ITU_T_T35: x0
                }, Lf = function ms(Bo) {
                  Bo = Bo || {}, ms.prototype.init.call(this), this.parse708captions_ = typeof Bo.parse708captions == "boolean" ? Bo.parse708captions : !0, this.captionPackets_ = [], this.ccStreams_ = [
                    new td(0, 0),
                    // eslint-disable-line no-use-before-define
                    new td(0, 1),
                    // eslint-disable-line no-use-before-define
                    new td(1, 0),
                    // eslint-disable-line no-use-before-define
                    new td(1, 1)
                    // eslint-disable-line no-use-before-define
                  ], this.parse708captions_ && (this.cc708Stream_ = new Vc({
                    captionServices: Bo.captionServices
                  })), this.reset(), this.ccStreams_.forEach(function(ua) {
                    ua.on("data", this.trigger.bind(this, "data")), ua.on("partialdone", this.trigger.bind(this, "partialdone")), ua.on("done", this.trigger.bind(this, "done"));
                  }, this), this.parse708captions_ && (this.cc708Stream_.on("data", this.trigger.bind(this, "data")), this.cc708Stream_.on("partialdone", this.trigger.bind(this, "partialdone")), this.cc708Stream_.on("done", this.trigger.bind(this, "done")));
                };
                Lf.prototype = new Ei(), Lf.prototype.push = function(ms) {
                  var Bo, ua, la;
                  if (ms.nalUnitType === "sei_rbsp" && (Bo = Fm.parseSei(ms.escapedRBSP), !!Bo.payload && Bo.payloadType === Fm.USER_DATA_REGISTERED_ITU_T_T35 && (ua = Fm.parseUserData(Bo), !!ua))) {
                    if (ms.dts < this.latestDts_) {
                      this.ignoreNextEqualDts_ = !0;
                      return;
                    } else if (ms.dts === this.latestDts_ && this.ignoreNextEqualDts_) {
                      this.numSameDts_--, this.numSameDts_ || (this.ignoreNextEqualDts_ = !1);
                      return;
                    }
                    la = Fm.parseCaptionPackets(ms.pts, ua), this.captionPackets_ = this.captionPackets_.concat(la), this.latestDts_ !== ms.dts && (this.numSameDts_ = 0), this.numSameDts_++, this.latestDts_ = ms.dts;
                  }
                }, Lf.prototype.flushCCStreams = function(ms) {
                  this.ccStreams_.forEach(function(Bo) {
                    return ms === "flush" ? Bo.flush() : Bo.partialFlush();
                  }, this);
                }, Lf.prototype.flushStream = function(ms) {
                  if (!this.captionPackets_.length) {
                    this.flushCCStreams(ms);
                    return;
                  }
                  this.captionPackets_.forEach(function(Bo, ua) {
                    Bo.presortIndex = ua;
                  }), this.captionPackets_.sort(function(Bo, ua) {
                    return Bo.pts === ua.pts ? Bo.presortIndex - ua.presortIndex : Bo.pts - ua.pts;
                  }), this.captionPackets_.forEach(function(Bo) {
                    Bo.type < 2 ? this.dispatchCea608Packet(Bo) : this.dispatchCea708Packet(Bo);
                  }, this), this.captionPackets_.length = 0, this.flushCCStreams(ms);
                }, Lf.prototype.flush = function() {
                  return this.flushStream("flush");
                }, Lf.prototype.partialFlush = function() {
                  return this.flushStream("partialFlush");
                }, Lf.prototype.reset = function() {
                  this.latestDts_ = null, this.ignoreNextEqualDts_ = !1, this.numSameDts_ = 0, this.activeCea608Channel_ = [null, null], this.ccStreams_.forEach(function(ms) {
                    ms.reset();
                  });
                }, Lf.prototype.dispatchCea608Packet = function(ms) {
                  this.setsTextOrXDSActive(ms) ? this.activeCea608Channel_[ms.type] = null : this.setsChannel1Active(ms) ? this.activeCea608Channel_[ms.type] = 0 : this.setsChannel2Active(ms) && (this.activeCea608Channel_[ms.type] = 1), this.activeCea608Channel_[ms.type] !== null && this.ccStreams_[(ms.type << 1) + this.activeCea608Channel_[ms.type]].push(ms);
                }, Lf.prototype.setsChannel1Active = function(ms) {
                  return (ms.ccData & 30720) === 4096;
                }, Lf.prototype.setsChannel2Active = function(ms) {
                  return (ms.ccData & 30720) === 6144;
                }, Lf.prototype.setsTextOrXDSActive = function(ms) {
                  return (ms.ccData & 28928) === 256 || (ms.ccData & 30974) === 4138 || (ms.ccData & 30974) === 6186;
                }, Lf.prototype.dispatchCea708Packet = function(ms) {
                  this.parse708captions_ && this.cc708Stream_.push(ms);
                };
                var Yb = {
                  127: 9834,
                  // ♪
                  4128: 32,
                  // Transparent Space
                  4129: 160,
                  // Nob-breaking Transparent Space
                  4133: 8230,
                  // …
                  4138: 352,
                  // Š
                  4140: 338,
                  // Œ
                  4144: 9608,
                  // █
                  4145: 8216,
                  // ‘
                  4146: 8217,
                  // ’
                  4147: 8220,
                  // “
                  4148: 8221,
                  // ”
                  4149: 8226,
                  // •
                  4153: 8482,
                  // ™
                  4154: 353,
                  // š
                  4156: 339,
                  // œ
                  4157: 8480,
                  // ℠
                  4159: 376,
                  // Ÿ
                  4214: 8539,
                  // ⅛
                  4215: 8540,
                  // ⅜
                  4216: 8541,
                  // ⅝
                  4217: 8542,
                  // ⅞
                  4218: 9168,
                  // ⏐
                  4219: 9124,
                  // ⎤
                  4220: 9123,
                  // ⎣
                  4221: 9135,
                  // ⎯
                  4222: 9126,
                  // ⎦
                  4223: 9121,
                  // ⎡
                  4256: 12600
                  // ㄸ (CC char)
                }, Xb = function(Bo) {
                  var ua = Yb[Bo] || Bo;
                  return Bo & 4096 && Bo === ua ? "" : String.fromCharCode(ua);
                }, Fv = function(Bo) {
                  return 32 <= Bo && Bo <= 127 || 160 <= Bo && Bo <= 255;
                }, uh = function(Bo) {
                  this.windowNum = Bo, this.reset();
                };
                uh.prototype.reset = function() {
                  this.clearText(), this.pendingNewLine = !1, this.winAttr = {}, this.penAttr = {}, this.penLoc = {}, this.penColor = {}, this.visible = 0, this.rowLock = 0, this.columnLock = 0, this.priority = 0, this.relativePositioning = 0, this.anchorVertical = 0, this.anchorHorizontal = 0, this.anchorPoint = 0, this.rowCount = 1, this.virtualRowCount = this.rowCount + 1, this.columnCount = 41, this.windowStyle = 0, this.penStyle = 0;
                }, uh.prototype.getText = function() {
                  return this.rows.join(`
`);
                }, uh.prototype.clearText = function() {
                  this.rows = [""], this.rowIdx = 0;
                }, uh.prototype.newLine = function(ms) {
                  for (this.rows.length >= this.virtualRowCount && typeof this.beforeRowOverflow == "function" && this.beforeRowOverflow(ms), this.rows.length > 0 && (this.rows.push(""), this.rowIdx++); this.rows.length > this.virtualRowCount; )
                    this.rows.shift(), this.rowIdx--;
                }, uh.prototype.isEmpty = function() {
                  return this.rows.length === 0 ? !0 : this.rows.length === 1 ? this.rows[0] === "" : !1;
                }, uh.prototype.addText = function(ms) {
                  this.rows[this.rowIdx] += ms;
                }, uh.prototype.backspace = function() {
                  if (!this.isEmpty()) {
                    var ms = this.rows[this.rowIdx];
                    this.rows[this.rowIdx] = ms.substr(0, ms.length - 1);
                  }
                };
                var Bv = function(Bo, ua, la) {
                  this.serviceNum = Bo, this.text = "", this.currentWindow = new uh(-1), this.windows = [], this.stream = la, typeof ua == "string" && this.createTextDecoder(ua);
                };
                Bv.prototype.init = function(ms, Bo) {
                  this.startPts = ms;
                  for (var ua = 0; ua < 8; ua++)
                    this.windows[ua] = new uh(ua), typeof Bo == "function" && (this.windows[ua].beforeRowOverflow = Bo);
                }, Bv.prototype.setCurrentWindow = function(ms) {
                  this.currentWindow = this.windows[ms];
                }, Bv.prototype.createTextDecoder = function(ms) {
                  if (typeof TextDecoder > "u")
                    this.stream.trigger("log", {
                      level: "warn",
                      message: "The `encoding` option is unsupported without TextDecoder support"
                    });
                  else
                    try {
                      this.textDecoder_ = new TextDecoder(ms);
                    } catch (Bo) {
                      this.stream.trigger("log", {
                        level: "warn",
                        message: "TextDecoder could not be created with " + ms + " encoding. " + Bo
                      });
                    }
                };
                var Vc = function ms(Bo) {
                  Bo = Bo || {}, ms.prototype.init.call(this);
                  var ua = this, la = Bo.captionServices || {}, va = {}, Ra;
                  Object.keys(la).forEach(function(Ba) {
                    Ra = la[Ba], /^SERVICE/.test(Ba) && (va[Ba] = Ra.encoding);
                  }), this.serviceEncodings = va, this.current708Packet = null, this.services = {}, this.push = function(Ba) {
                    Ba.type === 3 ? (ua.new708Packet(), ua.add708Bytes(Ba)) : (ua.current708Packet === null && ua.new708Packet(), ua.add708Bytes(Ba));
                  };
                };
                Vc.prototype = new Ei(), Vc.prototype.new708Packet = function() {
                  this.current708Packet !== null && this.push708Packet(), this.current708Packet = {
                    data: [],
                    ptsVals: []
                  };
                }, Vc.prototype.add708Bytes = function(ms) {
                  var Bo = ms.ccData, ua = Bo >>> 8, la = Bo & 255;
                  this.current708Packet.ptsVals.push(ms.pts), this.current708Packet.data.push(ua), this.current708Packet.data.push(la);
                }, Vc.prototype.push708Packet = function() {
                  var ms = this.current708Packet, Bo = ms.data, ua = null, la = null, va = 0, Ra = Bo[va++];
                  for (ms.seq = Ra >> 6, ms.sizeCode = Ra & 63; va < Bo.length; va++)
                    Ra = Bo[va++], ua = Ra >> 5, la = Ra & 31, ua === 7 && la > 0 && (Ra = Bo[va++], ua = Ra), this.pushServiceBlock(ua, va, la), la > 0 && (va += la - 1);
                }, Vc.prototype.pushServiceBlock = function(ms, Bo, ua) {
                  var la, va = Bo, Ra = this.current708Packet.data, Ba = this.services[ms];
                  for (Ba || (Ba = this.initService(ms, va)); va < Bo + ua && va < Ra.length; va++)
                    la = Ra[va], Fv(la) ? va = this.handleText(va, Ba) : la === 24 ? va = this.multiByteCharacter(va, Ba) : la === 16 ? va = this.extendedCommands(va, Ba) : 128 <= la && la <= 135 ? va = this.setCurrentWindow(va, Ba) : 152 <= la && la <= 159 ? va = this.defineWindow(va, Ba) : la === 136 ? va = this.clearWindows(va, Ba) : la === 140 ? va = this.deleteWindows(va, Ba) : la === 137 ? va = this.displayWindows(va, Ba) : la === 138 ? va = this.hideWindows(va, Ba) : la === 139 ? va = this.toggleWindows(va, Ba) : la === 151 ? va = this.setWindowAttributes(va, Ba) : la === 144 ? va = this.setPenAttributes(va, Ba) : la === 145 ? va = this.setPenColor(va, Ba) : la === 146 ? va = this.setPenLocation(va, Ba) : la === 143 ? Ba = this.reset(va, Ba) : la === 8 ? Ba.currentWindow.backspace() : la === 12 ? Ba.currentWindow.clearText() : la === 13 ? Ba.currentWindow.pendingNewLine = !0 : la === 14 ? Ba.currentWindow.clearText() : la === 141 && va++;
                }, Vc.prototype.extendedCommands = function(ms, Bo) {
                  var ua = this.current708Packet.data, la = ua[++ms];
                  return Fv(la) && (ms = this.handleText(ms, Bo, {
                    isExtended: !0
                  })), ms;
                }, Vc.prototype.getPts = function(ms) {
                  return this.current708Packet.ptsVals[Math.floor(ms / 2)];
                }, Vc.prototype.initService = function(ms, Bo) {
                  var la = "SERVICE" + ms, ua = this, la, va;
                  return la in this.serviceEncodings && (va = this.serviceEncodings[la]), this.services[ms] = new Bv(ms, va, ua), this.services[ms].init(this.getPts(Bo), function(Ra) {
                    ua.flushDisplayed(Ra, ua.services[ms]);
                  }), this.services[ms];
                }, Vc.prototype.handleText = function(ms, Bo, ua) {
                  var la = ua && ua.isExtended, va = ua && ua.isMultiByte, Ra = this.current708Packet.data, Ba = la ? 4096 : 0, Ms = Ra[ms], tl = Ra[ms + 1], vl = Bo.currentWindow, ul, Pl;
                  return Bo.textDecoder_ && !la ? (va ? (Pl = [Ms, tl], ms++) : Pl = [Ms], ul = Bo.textDecoder_.decode(new Uint8Array(Pl))) : ul = Xb(Ba | Ms), vl.pendingNewLine && !vl.isEmpty() && vl.newLine(this.getPts(ms)), vl.pendingNewLine = !1, vl.addText(ul), ms;
                }, Vc.prototype.multiByteCharacter = function(ms, Bo) {
                  var ua = this.current708Packet.data, la = ua[ms + 1], va = ua[ms + 2];
                  return Fv(la) && Fv(va) && (ms = this.handleText(++ms, Bo, {
                    isMultiByte: !0
                  })), ms;
                }, Vc.prototype.setCurrentWindow = function(ms, Bo) {
                  var ua = this.current708Packet.data, la = ua[ms], va = la & 7;
                  return Bo.setCurrentWindow(va), ms;
                }, Vc.prototype.defineWindow = function(ms, Bo) {
                  var ua = this.current708Packet.data, la = ua[ms], va = la & 7;
                  Bo.setCurrentWindow(va);
                  var Ra = Bo.currentWindow;
                  return la = ua[++ms], Ra.visible = (la & 32) >> 5, Ra.rowLock = (la & 16) >> 4, Ra.columnLock = (la & 8) >> 3, Ra.priority = la & 7, la = ua[++ms], Ra.relativePositioning = (la & 128) >> 7, Ra.anchorVertical = la & 127, la = ua[++ms], Ra.anchorHorizontal = la, la = ua[++ms], Ra.anchorPoint = (la & 240) >> 4, Ra.rowCount = la & 15, la = ua[++ms], Ra.columnCount = la & 63, la = ua[++ms], Ra.windowStyle = (la & 56) >> 3, Ra.penStyle = la & 7, Ra.virtualRowCount = Ra.rowCount + 1, ms;
                }, Vc.prototype.setWindowAttributes = function(ms, Bo) {
                  var ua = this.current708Packet.data, la = ua[ms], va = Bo.currentWindow.winAttr;
                  return la = ua[++ms], va.fillOpacity = (la & 192) >> 6, va.fillRed = (la & 48) >> 4, va.fillGreen = (la & 12) >> 2, va.fillBlue = la & 3, la = ua[++ms], va.borderType = (la & 192) >> 6, va.borderRed = (la & 48) >> 4, va.borderGreen = (la & 12) >> 2, va.borderBlue = la & 3, la = ua[++ms], va.borderType += (la & 128) >> 5, va.wordWrap = (la & 64) >> 6, va.printDirection = (la & 48) >> 4, va.scrollDirection = (la & 12) >> 2, va.justify = la & 3, la = ua[++ms], va.effectSpeed = (la & 240) >> 4, va.effectDirection = (la & 12) >> 2, va.displayEffect = la & 3, ms;
                }, Vc.prototype.flushDisplayed = function(ms, Bo) {
                  for (var ua = [], la = 0; la < 8; la++)
                    Bo.windows[la].visible && !Bo.windows[la].isEmpty() && ua.push(Bo.windows[la].getText());
                  Bo.endPts = ms, Bo.text = ua.join(`

`), this.pushCaption(Bo), Bo.startPts = ms;
                }, Vc.prototype.pushCaption = function(ms) {
                  ms.text !== "" && (this.trigger("data", {
                    startPts: ms.startPts,
                    endPts: ms.endPts,
                    text: ms.text,
                    stream: "cc708_" + ms.serviceNum
                  }), ms.text = "", ms.startPts = ms.endPts);
                }, Vc.prototype.displayWindows = function(ms, Bo) {
                  var ua = this.current708Packet.data, la = ua[++ms], va = this.getPts(ms);
                  this.flushDisplayed(va, Bo);
                  for (var Ra = 0; Ra < 8; Ra++)
                    la & 1 << Ra && (Bo.windows[Ra].visible = 1);
                  return ms;
                }, Vc.prototype.hideWindows = function(ms, Bo) {
                  var ua = this.current708Packet.data, la = ua[++ms], va = this.getPts(ms);
                  this.flushDisplayed(va, Bo);
                  for (var Ra = 0; Ra < 8; Ra++)
                    la & 1 << Ra && (Bo.windows[Ra].visible = 0);
                  return ms;
                }, Vc.prototype.toggleWindows = function(ms, Bo) {
                  var ua = this.current708Packet.data, la = ua[++ms], va = this.getPts(ms);
                  this.flushDisplayed(va, Bo);
                  for (var Ra = 0; Ra < 8; Ra++)
                    la & 1 << Ra && (Bo.windows[Ra].visible ^= 1);
                  return ms;
                }, Vc.prototype.clearWindows = function(ms, Bo) {
                  var ua = this.current708Packet.data, la = ua[++ms], va = this.getPts(ms);
                  this.flushDisplayed(va, Bo);
                  for (var Ra = 0; Ra < 8; Ra++)
                    la & 1 << Ra && Bo.windows[Ra].clearText();
                  return ms;
                }, Vc.prototype.deleteWindows = function(ms, Bo) {
                  var ua = this.current708Packet.data, la = ua[++ms], va = this.getPts(ms);
                  this.flushDisplayed(va, Bo);
                  for (var Ra = 0; Ra < 8; Ra++)
                    la & 1 << Ra && Bo.windows[Ra].reset();
                  return ms;
                }, Vc.prototype.setPenAttributes = function(ms, Bo) {
                  var ua = this.current708Packet.data, la = ua[ms], va = Bo.currentWindow.penAttr;
                  return la = ua[++ms], va.textTag = (la & 240) >> 4, va.offset = (la & 12) >> 2, va.penSize = la & 3, la = ua[++ms], va.italics = (la & 128) >> 7, va.underline = (la & 64) >> 6, va.edgeType = (la & 56) >> 3, va.fontStyle = la & 7, ms;
                }, Vc.prototype.setPenColor = function(ms, Bo) {
                  var ua = this.current708Packet.data, la = ua[ms], va = Bo.currentWindow.penColor;
                  return la = ua[++ms], va.fgOpacity = (la & 192) >> 6, va.fgRed = (la & 48) >> 4, va.fgGreen = (la & 12) >> 2, va.fgBlue = la & 3, la = ua[++ms], va.bgOpacity = (la & 192) >> 6, va.bgRed = (la & 48) >> 4, va.bgGreen = (la & 12) >> 2, va.bgBlue = la & 3, la = ua[++ms], va.edgeRed = (la & 48) >> 4, va.edgeGreen = (la & 12) >> 2, va.edgeBlue = la & 3, ms;
                }, Vc.prototype.setPenLocation = function(ms, Bo) {
                  var ua = this.current708Packet.data, la = ua[ms], va = Bo.currentWindow.penLoc;
                  return Bo.currentWindow.pendingNewLine = !0, la = ua[++ms], va.row = la & 15, la = ua[++ms], va.column = la & 63, ms;
                }, Vc.prototype.reset = function(ms, Bo) {
                  var ua = this.getPts(ms);
                  return this.flushDisplayed(ua, Bo), this.initService(Bo.serviceNum, ms);
                };
                var Jb = {
                  42: 225,
                  // á
                  92: 233,
                  // é
                  94: 237,
                  // í
                  95: 243,
                  // ó
                  96: 250,
                  // ú
                  123: 231,
                  // ç
                  124: 247,
                  // ÷
                  125: 209,
                  // Ñ
                  126: 241,
                  // ñ
                  127: 9608,
                  // █
                  304: 174,
                  // ®
                  305: 176,
                  // °
                  306: 189,
                  // ½
                  307: 191,
                  // ¿
                  308: 8482,
                  // ™
                  309: 162,
                  // ¢
                  310: 163,
                  // £
                  311: 9834,
                  // ♪
                  312: 224,
                  // à
                  313: 160,
                  //
                  314: 232,
                  // è
                  315: 226,
                  // â
                  316: 234,
                  // ê
                  317: 238,
                  // î
                  318: 244,
                  // ô
                  319: 251,
                  // û
                  544: 193,
                  // Á
                  545: 201,
                  // É
                  546: 211,
                  // Ó
                  547: 218,
                  // Ú
                  548: 220,
                  // Ü
                  549: 252,
                  // ü
                  550: 8216,
                  // ‘
                  551: 161,
                  // ¡
                  552: 42,
                  // *
                  553: 39,
                  // '
                  554: 8212,
                  // —
                  555: 169,
                  // ©
                  556: 8480,
                  // ℠
                  557: 8226,
                  // •
                  558: 8220,
                  // “
                  559: 8221,
                  // ”
                  560: 192,
                  // À
                  561: 194,
                  // Â
                  562: 199,
                  // Ç
                  563: 200,
                  // È
                  564: 202,
                  // Ê
                  565: 203,
                  // Ë
                  566: 235,
                  // ë
                  567: 206,
                  // Î
                  568: 207,
                  // Ï
                  569: 239,
                  // ï
                  570: 212,
                  // Ô
                  571: 217,
                  // Ù
                  572: 249,
                  // ù
                  573: 219,
                  // Û
                  574: 171,
                  // «
                  575: 187,
                  // »
                  800: 195,
                  // Ã
                  801: 227,
                  // ã
                  802: 205,
                  // Í
                  803: 204,
                  // Ì
                  804: 236,
                  // ì
                  805: 210,
                  // Ò
                  806: 242,
                  // ò
                  807: 213,
                  // Õ
                  808: 245,
                  // õ
                  809: 123,
                  // {
                  810: 125,
                  // }
                  811: 92,
                  // \
                  812: 94,
                  // ^
                  813: 95,
                  // _
                  814: 124,
                  // |
                  815: 126,
                  // ~
                  816: 196,
                  // Ä
                  817: 228,
                  // ä
                  818: 214,
                  // Ö
                  819: 246,
                  // ö
                  820: 223,
                  // ß
                  821: 165,
                  // ¥
                  822: 164,
                  // ¤
                  823: 9474,
                  // │
                  824: 197,
                  // Å
                  825: 229,
                  // å
                  826: 216,
                  // Ø
                  827: 248,
                  // ø
                  828: 9484,
                  // ┌
                  829: 9488,
                  // ┐
                  830: 9492,
                  // └
                  831: 9496
                  // ┘
                }, Uv = function(Bo) {
                  return Bo === null ? "" : (Bo = Jb[Bo] || Bo, String.fromCharCode(Bo));
                }, Vv = 14, Qb = [4352, 4384, 4608, 4640, 5376, 5408, 5632, 5664, 5888, 5920, 4096, 4864, 4896, 5120, 5152], gg = function() {
                  for (var Bo = [], ua = Vv + 1; ua--; )
                    Bo.push("");
                  return Bo;
                }, td = function ms(Bo, ua) {
                  ms.prototype.init.call(this), this.field_ = Bo || 0, this.dataChannel_ = ua || 0, this.name_ = "CC" + ((this.field_ << 1 | this.dataChannel_) + 1), this.setConstants(), this.reset(), this.push = function(la) {
                    var va, Ra, Ba, Ms, tl;
                    if (va = la.ccData & 32639, va === this.lastControlCode_) {
                      this.lastControlCode_ = null;
                      return;
                    }
                    if ((va & 61440) === 4096 ? this.lastControlCode_ = va : va !== this.PADDING_ && (this.lastControlCode_ = null), Ba = va >>> 8, Ms = va & 255, va !== this.PADDING_)
                      if (va === this.RESUME_CAPTION_LOADING_)
                        this.mode_ = "popOn";
                      else if (va === this.END_OF_CAPTION_)
                        this.mode_ = "popOn", this.clearFormatting(la.pts), this.flushDisplayed(la.pts), Ra = this.displayed_, this.displayed_ = this.nonDisplayed_, this.nonDisplayed_ = Ra, this.startPts_ = la.pts;
                      else if (va === this.ROLL_UP_2_ROWS_)
                        this.rollUpRows_ = 2, this.setRollUp(la.pts);
                      else if (va === this.ROLL_UP_3_ROWS_)
                        this.rollUpRows_ = 3, this.setRollUp(la.pts);
                      else if (va === this.ROLL_UP_4_ROWS_)
                        this.rollUpRows_ = 4, this.setRollUp(la.pts);
                      else if (va === this.CARRIAGE_RETURN_)
                        this.clearFormatting(la.pts), this.flushDisplayed(la.pts), this.shiftRowsUp_(), this.startPts_ = la.pts;
                      else if (va === this.BACKSPACE_)
                        this.mode_ === "popOn" ? this.nonDisplayed_[this.row_] = this.nonDisplayed_[this.row_].slice(0, -1) : this.displayed_[this.row_] = this.displayed_[this.row_].slice(0, -1);
                      else if (va === this.ERASE_DISPLAYED_MEMORY_)
                        this.flushDisplayed(la.pts), this.displayed_ = gg();
                      else if (va === this.ERASE_NON_DISPLAYED_MEMORY_)
                        this.nonDisplayed_ = gg();
                      else if (va === this.RESUME_DIRECT_CAPTIONING_)
                        this.mode_ !== "paintOn" && (this.flushDisplayed(la.pts), this.displayed_ = gg()), this.mode_ = "paintOn", this.startPts_ = la.pts;
                      else if (this.isSpecialCharacter(Ba, Ms))
                        Ba = (Ba & 3) << 8, tl = Uv(Ba | Ms), this[this.mode_](la.pts, tl), this.column_++;
                      else if (this.isExtCharacter(Ba, Ms))
                        this.mode_ === "popOn" ? this.nonDisplayed_[this.row_] = this.nonDisplayed_[this.row_].slice(0, -1) : this.displayed_[this.row_] = this.displayed_[this.row_].slice(0, -1), Ba = (Ba & 3) << 8, tl = Uv(Ba | Ms), this[this.mode_](la.pts, tl), this.column_++;
                      else if (this.isMidRowCode(Ba, Ms))
                        this.clearFormatting(la.pts), this[this.mode_](la.pts, " "), this.column_++, (Ms & 14) === 14 && this.addFormatting(la.pts, ["i"]), (Ms & 1) === 1 && this.addFormatting(la.pts, ["u"]);
                      else if (this.isOffsetControlCode(Ba, Ms))
                        this.column_ += Ms & 3;
                      else if (this.isPAC(Ba, Ms)) {
                        var vl = Qb.indexOf(va & 7968);
                        this.mode_ === "rollUp" && (vl - this.rollUpRows_ + 1 < 0 && (vl = this.rollUpRows_ - 1), this.setRollUp(la.pts, vl)), vl !== this.row_ && (this.clearFormatting(la.pts), this.row_ = vl), Ms & 1 && this.formatting_.indexOf("u") === -1 && this.addFormatting(la.pts, ["u"]), (va & 16) === 16 && (this.column_ = ((va & 14) >> 1) * 4), this.isColorPAC(Ms) && (Ms & 14) === 14 && this.addFormatting(la.pts, ["i"]);
                      } else this.isNormalChar(Ba) && (Ms === 0 && (Ms = null), tl = Uv(Ba), tl += Uv(Ms), this[this.mode_](la.pts, tl), this.column_ += tl.length);
                  };
                };
                td.prototype = new Ei(), td.prototype.flushDisplayed = function(ms) {
                  var Bo = this.displayed_.map(function(ua, la) {
                    try {
                      return ua.trim();
                    } catch {
                      return this.trigger("log", {
                        level: "warn",
                        message: "Skipping a malformed 608 caption at index " + la + "."
                      }), "";
                    }
                  }, this).join(`
`).replace(/^\n+|\n+$/g, "");
                  Bo.length && this.trigger("data", {
                    startPts: this.startPts_,
                    endPts: ms,
                    text: Bo,
                    stream: this.name_
                  });
                }, td.prototype.reset = function() {
                  this.mode_ = "popOn", this.topRow_ = 0, this.startPts_ = 0, this.displayed_ = gg(), this.nonDisplayed_ = gg(), this.lastControlCode_ = null, this.column_ = 0, this.row_ = Vv, this.rollUpRows_ = 2, this.formatting_ = [];
                }, td.prototype.setConstants = function() {
                  this.dataChannel_ === 0 ? (this.BASE_ = 16, this.EXT_ = 17, this.CONTROL_ = (20 | this.field_) << 8, this.OFFSET_ = 23) : this.dataChannel_ === 1 && (this.BASE_ = 24, this.EXT_ = 25, this.CONTROL_ = (28 | this.field_) << 8, this.OFFSET_ = 31), this.PADDING_ = 0, this.RESUME_CAPTION_LOADING_ = this.CONTROL_ | 32, this.END_OF_CAPTION_ = this.CONTROL_ | 47, this.ROLL_UP_2_ROWS_ = this.CONTROL_ | 37, this.ROLL_UP_3_ROWS_ = this.CONTROL_ | 38, this.ROLL_UP_4_ROWS_ = this.CONTROL_ | 39, this.CARRIAGE_RETURN_ = this.CONTROL_ | 45, this.RESUME_DIRECT_CAPTIONING_ = this.CONTROL_ | 41, this.BACKSPACE_ = this.CONTROL_ | 33, this.ERASE_DISPLAYED_MEMORY_ = this.CONTROL_ | 44, this.ERASE_NON_DISPLAYED_MEMORY_ = this.CONTROL_ | 46;
                }, td.prototype.isSpecialCharacter = function(ms, Bo) {
                  return ms === this.EXT_ && Bo >= 48 && Bo <= 63;
                }, td.prototype.isExtCharacter = function(ms, Bo) {
                  return (ms === this.EXT_ + 1 || ms === this.EXT_ + 2) && Bo >= 32 && Bo <= 63;
                }, td.prototype.isMidRowCode = function(ms, Bo) {
                  return ms === this.EXT_ && Bo >= 32 && Bo <= 47;
                }, td.prototype.isOffsetControlCode = function(ms, Bo) {
                  return ms === this.OFFSET_ && Bo >= 33 && Bo <= 35;
                }, td.prototype.isPAC = function(ms, Bo) {
                  return ms >= this.BASE_ && ms < this.BASE_ + 8 && Bo >= 64 && Bo <= 127;
                }, td.prototype.isColorPAC = function(ms) {
                  return ms >= 64 && ms <= 79 || ms >= 96 && ms <= 127;
                }, td.prototype.isNormalChar = function(ms) {
                  return ms >= 32 && ms <= 127;
                }, td.prototype.setRollUp = function(ms, Bo) {
                  if (this.mode_ !== "rollUp" && (this.row_ = Vv, this.mode_ = "rollUp", this.flushDisplayed(ms), this.nonDisplayed_ = gg(), this.displayed_ = gg()), Bo !== void 0 && Bo !== this.row_)
                    for (var ua = 0; ua < this.rollUpRows_; ua++)
                      this.displayed_[Bo - ua] = this.displayed_[this.row_ - ua], this.displayed_[this.row_ - ua] = "";
                  Bo === void 0 && (Bo = this.row_), this.topRow_ = Bo - this.rollUpRows_ + 1;
                }, td.prototype.addFormatting = function(ms, Bo) {
                  this.formatting_ = this.formatting_.concat(Bo);
                  var ua = Bo.reduce(function(la, va) {
                    return la + "<" + va + ">";
                  }, "");
                  this[this.mode_](ms, ua);
                }, td.prototype.clearFormatting = function(ms) {
                  if (this.formatting_.length) {
                    var Bo = this.formatting_.reverse().reduce(function(ua, la) {
                      return ua + "</" + la + ">";
                    }, "");
                    this.formatting_ = [], this[this.mode_](ms, Bo);
                  }
                }, td.prototype.popOn = function(ms, Bo) {
                  var ua = this.nonDisplayed_[this.row_];
                  ua += Bo, this.nonDisplayed_[this.row_] = ua;
                }, td.prototype.rollUp = function(ms, Bo) {
                  var ua = this.displayed_[this.row_];
                  ua += Bo, this.displayed_[this.row_] = ua;
                }, td.prototype.shiftRowsUp_ = function() {
                  var ms;
                  for (ms = 0; ms < this.topRow_; ms++)
                    this.displayed_[ms] = "";
                  for (ms = this.row_ + 1; ms < Vv + 1; ms++)
                    this.displayed_[ms] = "";
                  for (ms = this.topRow_; ms < this.row_; ms++)
                    this.displayed_[ms] = this.displayed_[ms + 1];
                  this.displayed_[this.row_] = "";
                }, td.prototype.paintOn = function(ms, Bo) {
                  var ua = this.displayed_[this.row_];
                  ua += Bo, this.displayed_[this.row_] = ua;
                };
                var Wv = {
                  CaptionStream: Lf,
                  Cea608Stream: td,
                  Cea708Stream: Vc
                }, Fd = {
                  H264_STREAM_TYPE: 27,
                  ADTS_STREAM_TYPE: 15,
                  METADATA_STREAM_TYPE: 21
                }, Zb = 8589934592, eT = 4294967296, w0 = "shared", s0 = function(Bo, ua) {
                  var la = 1;
                  for (Bo > ua && (la = -1); Math.abs(ua - Bo) > eT; )
                    Bo += la * Zb;
                  return Bo;
                }, _0 = function ms(Bo) {
                  var ua, la;
                  ms.prototype.init.call(this), this.type_ = Bo || w0, this.push = function(va) {
                    this.type_ !== w0 && va.type !== this.type_ || (la === void 0 && (la = va.dts), va.dts = s0(va.dts, la), va.pts = s0(va.pts, la), ua = va.dts, this.trigger("data", va));
                  }, this.flush = function() {
                    la = ua, this.trigger("done");
                  }, this.endTimeline = function() {
                    this.flush(), this.trigger("endedtimeline");
                  }, this.discontinuity = function() {
                    la = void 0, ua = void 0;
                  }, this.reset = function() {
                    this.discontinuity(), this.trigger("reset");
                  };
                };
                _0.prototype = new Ei();
                var P0 = {
                  TimestampRolloverStream: _0,
                  handleRollover: s0
                }, C0 = function(Bo, ua, la) {
                  var va, Ra = "";
                  for (va = ua; va < la; va++)
                    Ra += "%" + ("00" + Bo[va].toString(16)).slice(-2);
                  return Ra;
                }, Gv = function(Bo, ua, la) {
                  return decodeURIComponent(C0(Bo, ua, la));
                }, tT = function(Bo, ua, la) {
                  return unescape(C0(Bo, ua, la));
                }, Hv = function(Bo) {
                  return Bo[0] << 21 | Bo[1] << 14 | Bo[2] << 7 | Bo[3];
                }, R0 = {
                  TXXX: function(Bo) {
                    var ua;
                    if (Bo.data[0] === 3) {
                      for (ua = 1; ua < Bo.data.length; ua++)
                        if (Bo.data[ua] === 0) {
                          Bo.description = Gv(Bo.data, 1, ua), Bo.value = Gv(Bo.data, ua + 1, Bo.data.length).replace(/\0*$/, "");
                          break;
                        }
                      Bo.data = Bo.value;
                    }
                  },
                  WXXX: function(Bo) {
                    var ua;
                    if (Bo.data[0] === 3) {
                      for (ua = 1; ua < Bo.data.length; ua++)
                        if (Bo.data[ua] === 0) {
                          Bo.description = Gv(Bo.data, 1, ua), Bo.url = Gv(Bo.data, ua + 1, Bo.data.length);
                          break;
                        }
                    }
                  },
                  PRIV: function(Bo) {
                    var ua;
                    for (ua = 0; ua < Bo.data.length; ua++)
                      if (Bo.data[ua] === 0) {
                        Bo.owner = tT(Bo.data, 0, ua);
                        break;
                      }
                    Bo.privateData = Bo.data.subarray(ua + 1), Bo.data = Bo.privateData;
                  }
                }, zv;
                zv = function(Bo) {
                  var ua = {
                    // the bytes of the program-level descriptor field in MP2T
                    // see ISO/IEC 13818-1:2013 (E), section 2.6 "Program and
                    // program element descriptors"
                    descriptor: Bo && Bo.descriptor
                  }, la = 0, va = [], Ra = 0, Ba;
                  if (zv.prototype.init.call(this), this.dispatchType = Fd.METADATA_STREAM_TYPE.toString(16), ua.descriptor)
                    for (Ba = 0; Ba < ua.descriptor.length; Ba++)
                      this.dispatchType += ("00" + ua.descriptor[Ba].toString(16)).slice(-2);
                  this.push = function(Ms) {
                    var tl, vl, ul, Pl, Jl, Cu;
                    if (Ms.type === "timed-metadata") {
                      if (Ms.dataAlignmentIndicator && (Ra = 0, va.length = 0), va.length === 0 && (Ms.data.length < 10 || Ms.data[0] !== 73 || Ms.data[1] !== 68 || Ms.data[2] !== 51)) {
                        this.trigger("log", {
                          level: "warn",
                          message: "Skipping unrecognized metadata packet"
                        });
                        return;
                      }
                      if (va.push(Ms), Ra += Ms.data.byteLength, va.length === 1 && (la = Hv(Ms.data.subarray(6, 10)), la += 10), !(Ra < la)) {
                        for (tl = {
                          data: new Uint8Array(la),
                          frames: [],
                          pts: va[0].pts,
                          dts: va[0].dts
                        }, Jl = 0; Jl < la; )
                          tl.data.set(va[0].data.subarray(0, la - Jl), Jl), Jl += va[0].data.byteLength, Ra -= va[0].data.byteLength, va.shift();
                        vl = 10, tl.data[5] & 64 && (vl += 4, vl += Hv(tl.data.subarray(10, 14)), la -= Hv(tl.data.subarray(16, 20)));
                        do {
                          if (ul = Hv(tl.data.subarray(vl + 4, vl + 8)), ul < 1) {
                            this.trigger("log", {
                              level: "warn",
                              message: "Malformed ID3 frame encountered. Skipping metadata parsing."
                            });
                            return;
                          }
                          if (Cu = String.fromCharCode(tl.data[vl], tl.data[vl + 1], tl.data[vl + 2], tl.data[vl + 3]), Pl = {
                            id: Cu,
                            data: tl.data.subarray(vl + 10, vl + ul + 10)
                          }, Pl.key = Pl.id, R0[Pl.id] && (R0[Pl.id](Pl), Pl.owner === "com.apple.streaming.transportStreamTimestamp")) {
                            var Vu = Pl.data, _u = (Vu[3] & 1) << 30 | Vu[4] << 22 | Vu[5] << 14 | Vu[6] << 6 | Vu[7] >>> 2;
                            _u *= 4, _u += Vu[7] & 3, Pl.timeStamp = _u, tl.pts === void 0 && tl.dts === void 0 && (tl.pts = Pl.timeStamp, tl.dts = Pl.timeStamp), this.trigger("timestamp", Pl);
                          }
                          tl.frames.push(Pl), vl += 10, vl += ul;
                        } while (vl < la);
                        this.trigger("data", tl);
                      }
                    }
                  };
                }, zv.prototype = new Ei();
                var rT = zv, nT = P0.TimestampRolloverStream, Kv, Bm, qv, Hg = 188, l0 = 71;
                Kv = function() {
                  var Bo = new Uint8Array(Hg), ua = 0;
                  Kv.prototype.init.call(this), this.push = function(la) {
                    var va = 0, Ra = Hg, Ba;
                    for (ua ? (Ba = new Uint8Array(la.byteLength + ua), Ba.set(Bo.subarray(0, ua)), Ba.set(la, ua), ua = 0) : Ba = la; Ra < Ba.byteLength; ) {
                      if (Ba[va] === l0 && Ba[Ra] === l0) {
                        this.trigger("data", Ba.subarray(va, Ra)), va += Hg, Ra += Hg;
                        continue;
                      }
                      va++, Ra++;
                    }
                    va < Ba.byteLength && (Bo.set(Ba.subarray(va), 0), ua = Ba.byteLength - va);
                  }, this.flush = function() {
                    ua === Hg && Bo[0] === l0 && (this.trigger("data", Bo), ua = 0), this.trigger("done");
                  }, this.endTimeline = function() {
                    this.flush(), this.trigger("endedtimeline");
                  }, this.reset = function() {
                    ua = 0, this.trigger("reset");
                  };
                }, Kv.prototype = new Ei(), Bm = function() {
                  var Bo, ua, la, va;
                  Bm.prototype.init.call(this), va = this, this.packetsWaitingForPmt = [], this.programMapTable = void 0, Bo = function(Ba, Ms) {
                    var tl = 0;
                    Ms.payloadUnitStartIndicator && (tl += Ba[tl] + 1), Ms.type === "pat" ? ua(Ba.subarray(tl), Ms) : la(Ba.subarray(tl), Ms);
                  }, ua = function(Ba, Ms) {
                    Ms.section_number = Ba[7], Ms.last_section_number = Ba[8], va.pmtPid = (Ba[10] & 31) << 8 | Ba[11], Ms.pmtPid = va.pmtPid;
                  }, la = function(Ba, Ms) {
                    var tl, vl, ul, Pl;
                    if (Ba[5] & 1) {
                      for (va.programMapTable = {
                        video: null,
                        audio: null,
                        "timed-metadata": {}
                      }, tl = (Ba[1] & 15) << 8 | Ba[2], vl = 3 + tl - 4, ul = (Ba[10] & 15) << 8 | Ba[11], Pl = 12 + ul; Pl < vl; ) {
                        var Jl = Ba[Pl], Cu = (Ba[Pl + 1] & 31) << 8 | Ba[Pl + 2];
                        Jl === Fd.H264_STREAM_TYPE && va.programMapTable.video === null ? va.programMapTable.video = Cu : Jl === Fd.ADTS_STREAM_TYPE && va.programMapTable.audio === null ? va.programMapTable.audio = Cu : Jl === Fd.METADATA_STREAM_TYPE && (va.programMapTable["timed-metadata"][Cu] = Jl), Pl += ((Ba[Pl + 3] & 15) << 8 | Ba[Pl + 4]) + 5;
                      }
                      Ms.programMapTable = va.programMapTable;
                    }
                  }, this.push = function(Ra) {
                    var Ba = {}, Ms = 4;
                    if (Ba.payloadUnitStartIndicator = !!(Ra[1] & 64), Ba.pid = Ra[1] & 31, Ba.pid <<= 8, Ba.pid |= Ra[2], (Ra[3] & 48) >>> 4 > 1 && (Ms += Ra[Ms] + 1), Ba.pid === 0)
                      Ba.type = "pat", Bo(Ra.subarray(Ms), Ba), this.trigger("data", Ba);
                    else if (Ba.pid === this.pmtPid)
                      for (Ba.type = "pmt", Bo(Ra.subarray(Ms), Ba), this.trigger("data", Ba); this.packetsWaitingForPmt.length; )
                        this.processPes_.apply(this, this.packetsWaitingForPmt.shift());
                    else this.programMapTable === void 0 ? this.packetsWaitingForPmt.push([Ra, Ms, Ba]) : this.processPes_(Ra, Ms, Ba);
                  }, this.processPes_ = function(Ra, Ba, Ms) {
                    Ms.pid === this.programMapTable.video ? Ms.streamType = Fd.H264_STREAM_TYPE : Ms.pid === this.programMapTable.audio ? Ms.streamType = Fd.ADTS_STREAM_TYPE : Ms.streamType = this.programMapTable["timed-metadata"][Ms.pid], Ms.type = "pes", Ms.data = Ra.subarray(Ba), this.trigger("data", Ms);
                  };
                }, Bm.prototype = new Ei(), Bm.STREAM_TYPES = {
                  h264: 27,
                  adts: 15
                }, qv = function() {
                  var Bo = this, ua = !1, la = {
                    data: [],
                    size: 0
                  }, va = {
                    data: [],
                    size: 0
                  }, Ra = {
                    data: [],
                    size: 0
                  }, Ba, Ms = function(ul, Pl) {
                    var Jl, Cu = ul[0] << 16 | ul[1] << 8 | ul[2];
                    Pl.data = new Uint8Array(), Cu === 1 && (Pl.packetLength = 6 + (ul[4] << 8 | ul[5]), Pl.dataAlignmentIndicator = (ul[6] & 4) !== 0, Jl = ul[7], Jl & 192 && (Pl.pts = (ul[9] & 14) << 27 | (ul[10] & 255) << 20 | (ul[11] & 254) << 12 | (ul[12] & 255) << 5 | (ul[13] & 254) >>> 3, Pl.pts *= 4, Pl.pts += (ul[13] & 6) >>> 1, Pl.dts = Pl.pts, Jl & 64 && (Pl.dts = (ul[14] & 14) << 27 | (ul[15] & 255) << 20 | (ul[16] & 254) << 12 | (ul[17] & 255) << 5 | (ul[18] & 254) >>> 3, Pl.dts *= 4, Pl.dts += (ul[18] & 6) >>> 1)), Pl.data = ul.subarray(9 + ul[8]));
                  }, tl = function(ul, Pl, Jl) {
                    var Cu = new Uint8Array(ul.size), Vu = {
                      type: Pl
                    }, _u = 0, uc = 0, xd = !1, of;
                    if (!(!ul.data.length || ul.size < 9)) {
                      for (Vu.trackId = ul.data[0].pid, _u = 0; _u < ul.data.length; _u++)
                        of = ul.data[_u], Cu.set(of.data, uc), uc += of.data.byteLength;
                      Ms(Cu, Vu), xd = Pl === "video" || Vu.packetLength <= ul.size, (Jl || xd) && (ul.size = 0, ul.data.length = 0), xd && Bo.trigger("data", Vu);
                    }
                  };
                  qv.prototype.init.call(this), this.push = function(vl) {
                    ({
                      pat: function() {
                      },
                      pes: function() {
                        var Pl, Jl;
                        switch (vl.streamType) {
                          case Fd.H264_STREAM_TYPE:
                            Pl = la, Jl = "video";
                            break;
                          case Fd.ADTS_STREAM_TYPE:
                            Pl = va, Jl = "audio";
                            break;
                          case Fd.METADATA_STREAM_TYPE:
                            Pl = Ra, Jl = "timed-metadata";
                            break;
                          default:
                            return;
                        }
                        vl.payloadUnitStartIndicator && tl(Pl, Jl, !0), Pl.data.push(vl), Pl.size += vl.data.byteLength;
                      },
                      pmt: function() {
                        var Pl = {
                          type: "metadata",
                          tracks: []
                        };
                        Ba = vl.programMapTable, Ba.video !== null && Pl.tracks.push({
                          timelineStartInfo: {
                            baseMediaDecodeTime: 0
                          },
                          id: +Ba.video,
                          codec: "avc",
                          type: "video"
                        }), Ba.audio !== null && Pl.tracks.push({
                          timelineStartInfo: {
                            baseMediaDecodeTime: 0
                          },
                          id: +Ba.audio,
                          codec: "adts",
                          type: "audio"
                        }), ua = !0, Bo.trigger("data", Pl);
                      }
                    })[vl.type]();
                  }, this.reset = function() {
                    la.size = 0, la.data.length = 0, va.size = 0, va.data.length = 0, this.trigger("reset");
                  }, this.flushStreams_ = function() {
                    tl(la, "video"), tl(va, "audio"), tl(Ra, "timed-metadata");
                  }, this.flush = function() {
                    if (!ua && Ba) {
                      var vl = {
                        type: "metadata",
                        tracks: []
                      };
                      Ba.video !== null && vl.tracks.push({
                        timelineStartInfo: {
                          baseMediaDecodeTime: 0
                        },
                        id: +Ba.video,
                        codec: "avc",
                        type: "video"
                      }), Ba.audio !== null && vl.tracks.push({
                        timelineStartInfo: {
                          baseMediaDecodeTime: 0
                        },
                        id: +Ba.audio,
                        codec: "adts",
                        type: "audio"
                      }), Bo.trigger("data", vl);
                    }
                    ua = !1, this.flushStreams_(), this.trigger("done");
                  };
                }, qv.prototype = new Ei();
                var O0 = {
                  PAT_PID: 0,
                  MP2T_PACKET_LENGTH: Hg,
                  TransportPacketStream: Kv,
                  TransportParseStream: Bm,
                  ElementaryStream: qv,
                  TimestampRolloverStream: nT,
                  CaptionStream: Wv.CaptionStream,
                  Cea608Stream: Wv.Cea608Stream,
                  Cea708Stream: Wv.Cea708Stream,
                  MetadataStream: rT
                };
                for (var u0 in Fd)
                  Fd.hasOwnProperty(u0) && (O0[u0] = Fd[u0]);
                var ch = O0, iT = Pc.ONE_SECOND_IN_TS, Yv, A0 = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350];
                Yv = function(Bo) {
                  var ua, la = 0;
                  Yv.prototype.init.call(this), this.skipWarn_ = function(va, Ra) {
                    this.trigger("log", {
                      level: "warn",
                      message: "adts skiping bytes " + va + " to " + Ra + " in frame " + la + " outside syncword"
                    });
                  }, this.push = function(va) {
                    var Ra = 0, Ba, Ms, tl, vl, ul;
                    if (Bo || (la = 0), va.type === "audio") {
                      ua && ua.length ? (tl = ua, ua = new Uint8Array(tl.byteLength + va.data.byteLength), ua.set(tl), ua.set(va.data, tl.byteLength)) : ua = va.data;
                      for (var Pl; Ra + 7 < ua.length; ) {
                        if (ua[Ra] !== 255 || (ua[Ra + 1] & 246) !== 240) {
                          typeof Pl != "number" && (Pl = Ra), Ra++;
                          continue;
                        }
                        if (typeof Pl == "number" && (this.skipWarn_(Pl, Ra), Pl = null), Ms = (~ua[Ra + 1] & 1) * 2, Ba = (ua[Ra + 3] & 3) << 11 | ua[Ra + 4] << 3 | (ua[Ra + 5] & 224) >> 5, vl = ((ua[Ra + 6] & 3) + 1) * 1024, ul = vl * iT / A0[(ua[Ra + 2] & 60) >>> 2], ua.byteLength - Ra < Ba)
                          break;
                        this.trigger("data", {
                          pts: va.pts + la * ul,
                          dts: va.dts + la * ul,
                          sampleCount: vl,
                          audioobjecttype: (ua[Ra + 2] >>> 6 & 3) + 1,
                          channelcount: (ua[Ra + 2] & 1) << 2 | (ua[Ra + 3] & 192) >>> 6,
                          samplerate: A0[(ua[Ra + 2] & 60) >>> 2],
                          samplingfrequencyindex: (ua[Ra + 2] & 60) >>> 2,
                          // assume ISO/IEC 14496-12 AudioSampleEntry default of 16
                          samplesize: 16,
                          // data is the frame without it's header
                          data: ua.subarray(Ra + 7 + Ms, Ra + Ba)
                        }), la++, Ra += Ba;
                      }
                      typeof Pl == "number" && (this.skipWarn_(Pl, Ra), Pl = null), ua = ua.subarray(Ra);
                    }
                  }, this.flush = function() {
                    la = 0, this.trigger("done");
                  }, this.reset = function() {
                    ua = void 0, this.trigger("reset");
                  }, this.endTimeline = function() {
                    ua = void 0, this.trigger("endedtimeline");
                  };
                }, Yv.prototype = new Ei();
                var I0 = Yv, $0;
                $0 = function(Bo) {
                  var ua = Bo.byteLength, la = 0, va = 0;
                  this.length = function() {
                    return 8 * ua;
                  }, this.bitsAvailable = function() {
                    return 8 * ua + va;
                  }, this.loadWord = function() {
                    var Ra = Bo.byteLength - ua, Ba = new Uint8Array(4), Ms = Math.min(4, ua);
                    if (Ms === 0)
                      throw new Error("no bytes available");
                    Ba.set(Bo.subarray(Ra, Ra + Ms)), la = new DataView(Ba.buffer).getUint32(0), va = Ms * 8, ua -= Ms;
                  }, this.skipBits = function(Ra) {
                    var Ba;
                    va > Ra ? (la <<= Ra, va -= Ra) : (Ra -= va, Ba = Math.floor(Ra / 8), Ra -= Ba * 8, ua -= Ba, this.loadWord(), la <<= Ra, va -= Ra);
                  }, this.readBits = function(Ra) {
                    var Ba = Math.min(va, Ra), Ms = la >>> 32 - Ba;
                    return va -= Ba, va > 0 ? la <<= Ba : ua > 0 && this.loadWord(), Ba = Ra - Ba, Ba > 0 ? Ms << Ba | this.readBits(Ba) : Ms;
                  }, this.skipLeadingZeros = function() {
                    var Ra;
                    for (Ra = 0; Ra < va; ++Ra)
                      if ((la & 2147483648 >>> Ra) !== 0)
                        return la <<= Ra, va -= Ra, Ra;
                    return this.loadWord(), Ra + this.skipLeadingZeros();
                  }, this.skipUnsignedExpGolomb = function() {
                    this.skipBits(1 + this.skipLeadingZeros());
                  }, this.skipExpGolomb = function() {
                    this.skipBits(1 + this.skipLeadingZeros());
                  }, this.readUnsignedExpGolomb = function() {
                    var Ra = this.skipLeadingZeros();
                    return this.readBits(Ra + 1) - 1;
                  }, this.readExpGolomb = function() {
                    var Ra = this.readUnsignedExpGolomb();
                    return 1 & Ra ? 1 + Ra >>> 1 : -1 * (Ra >>> 1);
                  }, this.readBoolean = function() {
                    return this.readBits(1) === 1;
                  }, this.readUnsignedByte = function() {
                    return this.readBits(8);
                  }, this.loadWord();
                };
                var oT = $0, Xv, Jv, D0;
                Jv = function() {
                  var Bo = 0, ua, la;
                  Jv.prototype.init.call(this), this.push = function(va) {
                    var Ra;
                    la ? (Ra = new Uint8Array(la.byteLength + va.data.byteLength), Ra.set(la), Ra.set(va.data, la.byteLength), la = Ra) : la = va.data;
                    for (var Ba = la.byteLength; Bo < Ba - 3; Bo++)
                      if (la[Bo + 2] === 1) {
                        ua = Bo + 5;
                        break;
                      }
                    for (; ua < Ba; )
                      switch (la[ua]) {
                        case 0:
                          if (la[ua - 1] !== 0) {
                            ua += 2;
                            break;
                          } else if (la[ua - 2] !== 0) {
                            ua++;
                            break;
                          }
                          Bo + 3 !== ua - 2 && this.trigger("data", la.subarray(Bo + 3, ua - 2));
                          do
                            ua++;
                          while (la[ua] !== 1 && ua < Ba);
                          Bo = ua - 2, ua += 3;
                          break;
                        case 1:
                          if (la[ua - 1] !== 0 || la[ua - 2] !== 0) {
                            ua += 3;
                            break;
                          }
                          this.trigger("data", la.subarray(Bo + 3, ua - 2)), Bo = ua - 2, ua += 3;
                          break;
                        default:
                          ua += 3;
                          break;
                      }
                    la = la.subarray(Bo), ua -= Bo, Bo = 0;
                  }, this.reset = function() {
                    la = null, Bo = 0, this.trigger("reset");
                  }, this.flush = function() {
                    la && la.byteLength > 3 && this.trigger("data", la.subarray(Bo + 3)), la = null, Bo = 0, this.trigger("done");
                  }, this.endTimeline = function() {
                    this.flush(), this.trigger("endedtimeline");
                  };
                }, Jv.prototype = new Ei(), D0 = {
                  100: !0,
                  110: !0,
                  122: !0,
                  244: !0,
                  44: !0,
                  83: !0,
                  86: !0,
                  118: !0,
                  128: !0,
                  // TODO: the three profiles below don't
                  // appear to have sps data in the specificiation anymore?
                  138: !0,
                  139: !0,
                  134: !0
                }, Xv = function() {
                  var Bo = new Jv(), ua, la, va, Ra, Ba, Ms, tl;
                  Xv.prototype.init.call(this), ua = this, this.push = function(vl) {
                    vl.type === "video" && (la = vl.trackId, va = vl.pts, Ra = vl.dts, Bo.push(vl));
                  }, Bo.on("data", function(vl) {
                    var ul = {
                      trackId: la,
                      pts: va,
                      dts: Ra,
                      data: vl,
                      nalUnitTypeCode: vl[0] & 31
                    };
                    switch (ul.nalUnitTypeCode) {
                      case 5:
                        ul.nalUnitType = "slice_layer_without_partitioning_rbsp_idr";
                        break;
                      case 6:
                        ul.nalUnitType = "sei_rbsp", ul.escapedRBSP = Ba(vl.subarray(1));
                        break;
                      case 7:
                        ul.nalUnitType = "seq_parameter_set_rbsp", ul.escapedRBSP = Ba(vl.subarray(1)), ul.config = Ms(ul.escapedRBSP);
                        break;
                      case 8:
                        ul.nalUnitType = "pic_parameter_set_rbsp";
                        break;
                      case 9:
                        ul.nalUnitType = "access_unit_delimiter_rbsp";
                        break;
                    }
                    ua.trigger("data", ul);
                  }), Bo.on("done", function() {
                    ua.trigger("done");
                  }), Bo.on("partialdone", function() {
                    ua.trigger("partialdone");
                  }), Bo.on("reset", function() {
                    ua.trigger("reset");
                  }), Bo.on("endedtimeline", function() {
                    ua.trigger("endedtimeline");
                  }), this.flush = function() {
                    Bo.flush();
                  }, this.partialFlush = function() {
                    Bo.partialFlush();
                  }, this.reset = function() {
                    Bo.reset();
                  }, this.endTimeline = function() {
                    Bo.endTimeline();
                  }, tl = function(ul, Pl) {
                    var Jl = 8, Cu = 8, Vu, _u;
                    for (Vu = 0; Vu < ul; Vu++)
                      Cu !== 0 && (_u = Pl.readExpGolomb(), Cu = (Jl + _u + 256) % 256), Jl = Cu === 0 ? Jl : Cu;
                  }, Ba = function(ul) {
                    for (var Pl = ul.byteLength, Jl = [], Cu = 1, Vu, _u; Cu < Pl - 2; )
                      ul[Cu] === 0 && ul[Cu + 1] === 0 && ul[Cu + 2] === 3 ? (Jl.push(Cu + 2), Cu += 2) : Cu++;
                    if (Jl.length === 0)
                      return ul;
                    Vu = Pl - Jl.length, _u = new Uint8Array(Vu);
                    var uc = 0;
                    for (Cu = 0; Cu < Vu; uc++, Cu++)
                      uc === Jl[0] && (uc++, Jl.shift()), _u[Cu] = ul[uc];
                    return _u;
                  }, Ms = function(ul) {
                    var Pl = 0, Jl = 0, Cu = 0, Vu = 0, _u, uc, xd, of, bg, f0, tb, rb, nb, p0, ib, dd = [1, 1], ob, Tg;
                    if (_u = new oT(ul), uc = _u.readUnsignedByte(), of = _u.readUnsignedByte(), xd = _u.readUnsignedByte(), _u.skipUnsignedExpGolomb(), D0[uc] && (bg = _u.readUnsignedExpGolomb(), bg === 3 && _u.skipBits(1), _u.skipUnsignedExpGolomb(), _u.skipUnsignedExpGolomb(), _u.skipBits(1), _u.readBoolean()))
                      for (ib = bg !== 3 ? 8 : 12, Tg = 0; Tg < ib; Tg++)
                        _u.readBoolean() && (Tg < 6 ? tl(16, _u) : tl(64, _u));
                    if (_u.skipUnsignedExpGolomb(), f0 = _u.readUnsignedExpGolomb(), f0 === 0)
                      _u.readUnsignedExpGolomb();
                    else if (f0 === 1)
                      for (_u.skipBits(1), _u.skipExpGolomb(), _u.skipExpGolomb(), tb = _u.readUnsignedExpGolomb(), Tg = 0; Tg < tb; Tg++)
                        _u.skipExpGolomb();
                    if (_u.skipUnsignedExpGolomb(), _u.skipBits(1), rb = _u.readUnsignedExpGolomb(), nb = _u.readUnsignedExpGolomb(), p0 = _u.readBits(1), p0 === 0 && _u.skipBits(1), _u.skipBits(1), _u.readBoolean() && (Pl = _u.readUnsignedExpGolomb(), Jl = _u.readUnsignedExpGolomb(), Cu = _u.readUnsignedExpGolomb(), Vu = _u.readUnsignedExpGolomb()), _u.readBoolean() && _u.readBoolean()) {
                      switch (ob = _u.readUnsignedByte(), ob) {
                        case 1:
                          dd = [1, 1];
                          break;
                        case 2:
                          dd = [12, 11];
                          break;
                        case 3:
                          dd = [10, 11];
                          break;
                        case 4:
                          dd = [16, 11];
                          break;
                        case 5:
                          dd = [40, 33];
                          break;
                        case 6:
                          dd = [24, 11];
                          break;
                        case 7:
                          dd = [20, 11];
                          break;
                        case 8:
                          dd = [32, 11];
                          break;
                        case 9:
                          dd = [80, 33];
                          break;
                        case 10:
                          dd = [18, 11];
                          break;
                        case 11:
                          dd = [15, 11];
                          break;
                        case 12:
                          dd = [64, 33];
                          break;
                        case 13:
                          dd = [160, 99];
                          break;
                        case 14:
                          dd = [4, 3];
                          break;
                        case 15:
                          dd = [3, 2];
                          break;
                        case 16:
                          dd = [2, 1];
                          break;
                        case 255: {
                          dd = [_u.readUnsignedByte() << 8 | _u.readUnsignedByte(), _u.readUnsignedByte() << 8 | _u.readUnsignedByte()];
                          break;
                        }
                      }
                      dd && dd[0] / dd[1];
                    }
                    return {
                      profileIdc: uc,
                      levelIdc: xd,
                      profileCompatibility: of,
                      width: (rb + 1) * 16 - Pl * 2 - Jl * 2,
                      height: (2 - p0) * (nb + 1) * 16 - Cu * 2 - Vu * 2,
                      // sar is sample aspect ratio
                      sarRatio: dd
                    };
                  };
                }, Xv.prototype = new Ei();
                var aT = {
                  H264Stream: Xv
                }, sT = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350], k0 = function(Bo, ua) {
                  var la = Bo[ua + 6] << 21 | Bo[ua + 7] << 14 | Bo[ua + 8] << 7 | Bo[ua + 9], va = Bo[ua + 5], Ra = (va & 16) >> 4;
                  return la = la >= 0 ? la : 0, Ra ? la + 20 : la + 10;
                }, lT = function ms(Bo, ua) {
                  return Bo.length - ua < 10 || Bo[ua] !== 73 || Bo[ua + 1] !== 68 || Bo[ua + 2] !== 51 ? ua : (ua += k0(Bo, ua), ms(Bo, ua));
                }, uT = function(Bo) {
                  var ua = lT(Bo, 0);
                  return Bo.length >= ua + 2 && (Bo[ua] & 255) === 255 && (Bo[ua + 1] & 240) === 240 && // verify that the 2 layer bits are 0, aka this
                  // is not mp3 data but aac data.
                  (Bo[ua + 1] & 22) === 16;
                }, N0 = function(Bo) {
                  return Bo[0] << 21 | Bo[1] << 14 | Bo[2] << 7 | Bo[3];
                }, cT = function(Bo, ua, la) {
                  var va, Ra = "";
                  for (va = ua; va < la; va++)
                    Ra += "%" + ("00" + Bo[va].toString(16)).slice(-2);
                  return Ra;
                }, dT = function(Bo, ua, la) {
                  return unescape(cT(Bo, ua, la));
                }, fT = function(Bo, ua) {
                  var la = (Bo[ua + 5] & 224) >> 5, va = Bo[ua + 4] << 3, Ra = Bo[ua + 3] & 6144;
                  return Ra | va | la;
                }, pT = function(Bo, ua) {
                  return Bo[ua] === 73 && Bo[ua + 1] === 68 && Bo[ua + 2] === 51 ? "timed-metadata" : Bo[ua] & !0 && (Bo[ua + 1] & 240) === 240 ? "audio" : null;
                }, hT = function(Bo) {
                  for (var ua = 0; ua + 5 < Bo.length; ) {
                    if (Bo[ua] !== 255 || (Bo[ua + 1] & 246) !== 240) {
                      ua++;
                      continue;
                    }
                    return sT[(Bo[ua + 2] & 60) >>> 2];
                  }
                  return null;
                }, gT = function(Bo) {
                  var ua, la, va, Ra;
                  ua = 10, Bo[5] & 64 && (ua += 4, ua += N0(Bo.subarray(10, 14)));
                  do {
                    if (la = N0(Bo.subarray(ua + 4, ua + 8)), la < 1)
                      return null;
                    if (Ra = String.fromCharCode(Bo[ua], Bo[ua + 1], Bo[ua + 2], Bo[ua + 3]), Ra === "PRIV") {
                      va = Bo.subarray(ua + 10, ua + la + 10);
                      for (var Ba = 0; Ba < va.byteLength; Ba++)
                        if (va[Ba] === 0) {
                          var Ms = dT(va, 0, Ba);
                          if (Ms === "com.apple.streaming.transportStreamTimestamp") {
                            var tl = va.subarray(Ba + 1), vl = (tl[3] & 1) << 30 | tl[4] << 22 | tl[5] << 14 | tl[6] << 6 | tl[7] >>> 2;
                            return vl *= 4, vl += tl[7] & 3, vl;
                          }
                          break;
                        }
                    }
                    ua += 10, ua += la;
                  } while (ua < Bo.byteLength);
                  return null;
                }, Qv = {
                  isLikelyAacData: uT,
                  parseId3TagSize: k0,
                  parseAdtsSize: fT,
                  parseType: pT,
                  parseSampleRate: hT,
                  parseAacTimestamp: gT
                }, Zv;
                Zv = function() {
                  var Bo = new Uint8Array(), ua = 0;
                  Zv.prototype.init.call(this), this.setTimestamp = function(la) {
                    ua = la;
                  }, this.push = function(la) {
                    var va = 0, Ra = 0, Ba, Ms, tl, vl;
                    for (Bo.length ? (vl = Bo.length, Bo = new Uint8Array(la.byteLength + vl), Bo.set(Bo.subarray(0, vl)), Bo.set(la, vl)) : Bo = la; Bo.length - Ra >= 3; ) {
                      if (Bo[Ra] === 73 && Bo[Ra + 1] === 68 && Bo[Ra + 2] === 51) {
                        if (Bo.length - Ra < 10 || (va = Qv.parseId3TagSize(Bo, Ra), Ra + va > Bo.length))
                          break;
                        Ms = {
                          type: "timed-metadata",
                          data: Bo.subarray(Ra, Ra + va)
                        }, this.trigger("data", Ms), Ra += va;
                        continue;
                      } else if ((Bo[Ra] & 255) === 255 && (Bo[Ra + 1] & 240) === 240) {
                        if (Bo.length - Ra < 7 || (va = Qv.parseAdtsSize(Bo, Ra), Ra + va > Bo.length))
                          break;
                        tl = {
                          type: "audio",
                          data: Bo.subarray(Ra, Ra + va),
                          pts: ua,
                          dts: ua
                        }, this.trigger("data", tl), Ra += va;
                        continue;
                      }
                      Ra++;
                    }
                    Ba = Bo.length - Ra, Ba > 0 ? Bo = Bo.subarray(Ra) : Bo = new Uint8Array();
                  }, this.reset = function() {
                    Bo = new Uint8Array(), this.trigger("reset");
                  }, this.endTimeline = function() {
                    Bo = new Uint8Array(), this.trigger("endedtimeline");
                  };
                }, Zv.prototype = new Ei();
                var mT = Zv, vT = ["audioobjecttype", "channelcount", "samplerate", "samplingfrequencyindex", "samplesize"], L0 = vT, yT = ["width", "height", "profileIdc", "levelIdc", "profileCompatibility", "sarRatio"], M0 = yT, bT = aT.H264Stream, TT = Qv.isLikelyAacData, ET = Pc.ONE_SECOND_IN_TS, ey, Um, ty, mg, ST = function(Bo, ua) {
                  ua.stream = Bo, this.trigger("log", ua);
                }, j0 = function(Bo, ua) {
                  for (var la = Object.keys(ua), va = 0; va < la.length; va++) {
                    var Ra = la[va];
                    Ra === "headOfPipeline" || !ua[Ra].on || ua[Ra].on("log", ST.bind(Bo, Ra));
                  }
                }, F0 = function(Bo, ua) {
                  var la;
                  if (Bo.length !== ua.length)
                    return !1;
                  for (la = 0; la < Bo.length; la++)
                    if (Bo[la] !== ua[la])
                      return !1;
                  return !0;
                }, B0 = function(Bo, ua, la, va, Ra, Ba) {
                  var Ms = la - ua, tl = va - ua, vl = Ra - la;
                  return {
                    start: {
                      dts: Bo,
                      pts: Bo + Ms
                    },
                    end: {
                      dts: Bo + tl,
                      pts: Bo + vl
                    },
                    prependedContentDuration: Ba,
                    baseMediaDecodeTime: Bo
                  };
                };
                Um = function(Bo, ua) {
                  var la = [], va, Ra = 0, Ba = 0, Ms = 1 / 0;
                  ua = ua || {}, va = ua.firstSequenceNumber || 0, Um.prototype.init.call(this), this.push = function(tl) {
                    gp.collectDtsInfo(Bo, tl), Bo && L0.forEach(function(vl) {
                      Bo[vl] = tl[vl];
                    }), la.push(tl);
                  }, this.setEarliestDts = function(tl) {
                    Ra = tl;
                  }, this.setVideoBaseMediaDecodeTime = function(tl) {
                    Ms = tl;
                  }, this.setAudioAppendStart = function(tl) {
                    Ba = tl;
                  }, this.flush = function() {
                    var tl, vl, ul, Pl, Jl, Cu, Vu;
                    if (la.length === 0) {
                      this.trigger("done", "AudioSegmentStream");
                      return;
                    }
                    tl = jv.trimAdtsFramesByEarliestDts(la, Bo, Ra), Bo.baseMediaDecodeTime = gp.calculateTrackBaseMediaDecodeTime(Bo, ua.keepOriginalTimestamps), Vu = jv.prefixWithSilence(Bo, tl, Ba, Ms), Bo.samples = jv.generateSampleTable(tl), ul = Mp.mdat(jv.concatenateFrameData(tl)), la = [], vl = Mp.moof(va, [Bo]), Pl = new Uint8Array(vl.byteLength + ul.byteLength), va++, Pl.set(vl), Pl.set(ul, vl.byteLength), gp.clearDtsInfo(Bo), Jl = Math.ceil(ET * 1024 / Bo.samplerate), tl.length && (Cu = tl.length * Jl, this.trigger("segmentTimingInfo", B0(
                      // The audio track's baseMediaDecodeTime is in audio clock cycles, but the
                      // frame info is in video clock cycles. Convert to match expectation of
                      // listeners (that all timestamps will be based on video clock cycles).
                      Pc.audioTsToVideoTs(Bo.baseMediaDecodeTime, Bo.samplerate),
                      // frame times are already in video clock, as is segment duration
                      tl[0].dts,
                      tl[0].pts,
                      tl[0].dts + Cu,
                      tl[0].pts + Cu,
                      Vu || 0
                    )), this.trigger("timingInfo", {
                      start: tl[0].pts,
                      end: tl[0].pts + Cu
                    })), this.trigger("data", {
                      track: Bo,
                      boxes: Pl
                    }), this.trigger("done", "AudioSegmentStream");
                  }, this.reset = function() {
                    gp.clearDtsInfo(Bo), la = [], this.trigger("reset");
                  };
                }, Um.prototype = new Ei(), ey = function(Bo, ua) {
                  var la, va = [], Ra = [], Ba, Ms;
                  ua = ua || {}, la = ua.firstSequenceNumber || 0, ey.prototype.init.call(this), delete Bo.minPTS, this.gopCache_ = [], this.push = function(tl) {
                    gp.collectDtsInfo(Bo, tl), tl.nalUnitType === "seq_parameter_set_rbsp" && !Ba && (Ba = tl.config, Bo.sps = [tl.data], M0.forEach(function(vl) {
                      Bo[vl] = Ba[vl];
                    }, this)), tl.nalUnitType === "pic_parameter_set_rbsp" && !Ms && (Ms = tl.data, Bo.pps = [tl.data]), va.push(tl);
                  }, this.flush = function() {
                    for (var tl, vl, ul, Pl, Jl, Cu, Vu = 0, _u, uc; va.length && va[0].nalUnitType !== "access_unit_delimiter_rbsp"; )
                      va.shift();
                    if (va.length === 0) {
                      this.resetStream_(), this.trigger("done", "VideoSegmentStream");
                      return;
                    }
                    if (tl = jm.groupNalsIntoFrames(va), ul = jm.groupFramesIntoGops(tl), ul[0][0].keyFrame || (vl = this.getGopForFusion_(va[0], Bo), vl ? (Vu = vl.duration, ul.unshift(vl), ul.byteLength += vl.byteLength, ul.nalCount += vl.nalCount, ul.pts = vl.pts, ul.dts = vl.dts, ul.duration += vl.duration) : ul = jm.extendFirstKeyFrame(ul)), Ra.length) {
                      var xd;
                      if (ua.alignGopsAtEnd ? xd = this.alignGopsAtEnd_(ul) : xd = this.alignGopsAtStart_(ul), !xd) {
                        this.gopCache_.unshift({
                          gop: ul.pop(),
                          pps: Bo.pps,
                          sps: Bo.sps
                        }), this.gopCache_.length = Math.min(6, this.gopCache_.length), va = [], this.resetStream_(), this.trigger("done", "VideoSegmentStream");
                        return;
                      }
                      gp.clearDtsInfo(Bo), ul = xd;
                    }
                    gp.collectDtsInfo(Bo, ul), Bo.samples = jm.generateSampleTable(ul), Jl = Mp.mdat(jm.concatenateNalData(ul)), Bo.baseMediaDecodeTime = gp.calculateTrackBaseMediaDecodeTime(Bo, ua.keepOriginalTimestamps), this.trigger("processedGopsInfo", ul.map(function(of) {
                      return {
                        pts: of.pts,
                        dts: of.dts,
                        byteLength: of.byteLength
                      };
                    })), _u = ul[0], uc = ul[ul.length - 1], this.trigger("segmentTimingInfo", B0(Bo.baseMediaDecodeTime, _u.dts, _u.pts, uc.dts + uc.duration, uc.pts + uc.duration, Vu)), this.trigger("timingInfo", {
                      start: ul[0].pts,
                      end: ul[ul.length - 1].pts + ul[ul.length - 1].duration
                    }), this.gopCache_.unshift({
                      gop: ul.pop(),
                      pps: Bo.pps,
                      sps: Bo.sps
                    }), this.gopCache_.length = Math.min(6, this.gopCache_.length), va = [], this.trigger("baseMediaDecodeTime", Bo.baseMediaDecodeTime), this.trigger("timelineStartInfo", Bo.timelineStartInfo), Pl = Mp.moof(la, [Bo]), Cu = new Uint8Array(Pl.byteLength + Jl.byteLength), la++, Cu.set(Pl), Cu.set(Jl, Pl.byteLength), this.trigger("data", {
                      track: Bo,
                      boxes: Cu
                    }), this.resetStream_(), this.trigger("done", "VideoSegmentStream");
                  }, this.reset = function() {
                    this.resetStream_(), va = [], this.gopCache_.length = 0, Ra.length = 0, this.trigger("reset");
                  }, this.resetStream_ = function() {
                    gp.clearDtsInfo(Bo), Ba = void 0, Ms = void 0;
                  }, this.getGopForFusion_ = function(tl) {
                    var vl = 45e3, ul = 1 / 0, Pl, Jl, Cu, Vu, _u;
                    for (_u = 0; _u < this.gopCache_.length; _u++)
                      Vu = this.gopCache_[_u], Cu = Vu.gop, !(!(Bo.pps && F0(Bo.pps[0], Vu.pps[0])) || !(Bo.sps && F0(Bo.sps[0], Vu.sps[0]))) && (Cu.dts < Bo.timelineStartInfo.dts || (Pl = tl.dts - Cu.dts - Cu.duration, Pl >= -1e4 && Pl <= vl && (!Jl || ul > Pl) && (Jl = Vu, ul = Pl)));
                    return Jl ? Jl.gop : null;
                  }, this.alignGopsAtStart_ = function(tl) {
                    var vl, ul, Pl, Jl, Cu, Vu, _u, uc;
                    for (Cu = tl.byteLength, Vu = tl.nalCount, _u = tl.duration, vl = ul = 0; vl < Ra.length && ul < tl.length && (Pl = Ra[vl], Jl = tl[ul], Pl.pts !== Jl.pts); ) {
                      if (Jl.pts > Pl.pts) {
                        vl++;
                        continue;
                      }
                      ul++, Cu -= Jl.byteLength, Vu -= Jl.nalCount, _u -= Jl.duration;
                    }
                    return ul === 0 ? tl : ul === tl.length ? null : (uc = tl.slice(ul), uc.byteLength = Cu, uc.duration = _u, uc.nalCount = Vu, uc.pts = uc[0].pts, uc.dts = uc[0].dts, uc);
                  }, this.alignGopsAtEnd_ = function(tl) {
                    var vl, ul, Pl, Jl, Cu, Vu;
                    for (vl = Ra.length - 1, ul = tl.length - 1, Cu = null, Vu = !1; vl >= 0 && ul >= 0; ) {
                      if (Pl = Ra[vl], Jl = tl[ul], Pl.pts === Jl.pts) {
                        Vu = !0;
                        break;
                      }
                      if (Pl.pts > Jl.pts) {
                        vl--;
                        continue;
                      }
                      vl === Ra.length - 1 && (Cu = ul), ul--;
                    }
                    if (!Vu && Cu === null)
                      return null;
                    var _u;
                    if (Vu ? _u = ul : _u = Cu, _u === 0)
                      return tl;
                    var uc = tl.slice(_u), xd = uc.reduce(function(of, bg) {
                      return of.byteLength += bg.byteLength, of.duration += bg.duration, of.nalCount += bg.nalCount, of;
                    }, {
                      byteLength: 0,
                      duration: 0,
                      nalCount: 0
                    });
                    return uc.byteLength = xd.byteLength, uc.duration = xd.duration, uc.nalCount = xd.nalCount, uc.pts = uc[0].pts, uc.dts = uc[0].dts, uc;
                  }, this.alignGopsWith = function(tl) {
                    Ra = tl;
                  };
                }, ey.prototype = new Ei(), mg = function(Bo, ua) {
                  this.numberOfTracks = 0, this.metadataStream = ua, Bo = Bo || {}, typeof Bo.remux < "u" ? this.remuxTracks = !!Bo.remux : this.remuxTracks = !0, typeof Bo.keepOriginalTimestamps == "boolean" ? this.keepOriginalTimestamps = Bo.keepOriginalTimestamps : this.keepOriginalTimestamps = !1, this.pendingTracks = [], this.videoTrack = null, this.pendingBoxes = [], this.pendingCaptions = [], this.pendingMetadata = [], this.pendingBytes = 0, this.emittedTracks = 0, mg.prototype.init.call(this), this.push = function(la) {
                    if (la.text)
                      return this.pendingCaptions.push(la);
                    if (la.frames)
                      return this.pendingMetadata.push(la);
                    this.pendingTracks.push(la.track), this.pendingBytes += la.boxes.byteLength, la.track.type === "video" && (this.videoTrack = la.track, this.pendingBoxes.push(la.boxes)), la.track.type === "audio" && (this.audioTrack = la.track, this.pendingBoxes.unshift(la.boxes));
                  };
                }, mg.prototype = new Ei(), mg.prototype.flush = function(ms) {
                  var Bo = 0, ua = {
                    captions: [],
                    captionStreams: {},
                    metadata: [],
                    info: {}
                  }, la, va, Ra, Ba = 0, Ms;
                  if (this.pendingTracks.length < this.numberOfTracks) {
                    if (ms !== "VideoSegmentStream" && ms !== "AudioSegmentStream")
                      return;
                    if (this.remuxTracks)
                      return;
                    if (this.pendingTracks.length === 0) {
                      this.emittedTracks++, this.emittedTracks >= this.numberOfTracks && (this.trigger("done"), this.emittedTracks = 0);
                      return;
                    }
                  }
                  if (this.videoTrack ? (Ba = this.videoTrack.timelineStartInfo.pts, M0.forEach(function(tl) {
                    ua.info[tl] = this.videoTrack[tl];
                  }, this)) : this.audioTrack && (Ba = this.audioTrack.timelineStartInfo.pts, L0.forEach(function(tl) {
                    ua.info[tl] = this.audioTrack[tl];
                  }, this)), this.videoTrack || this.audioTrack) {
                    for (this.pendingTracks.length === 1 ? ua.type = this.pendingTracks[0].type : ua.type = "combined", this.emittedTracks += this.pendingTracks.length, Ra = Mp.initSegment(this.pendingTracks), ua.initSegment = new Uint8Array(Ra.byteLength), ua.initSegment.set(Ra), ua.data = new Uint8Array(this.pendingBytes), Ms = 0; Ms < this.pendingBoxes.length; Ms++)
                      ua.data.set(this.pendingBoxes[Ms], Bo), Bo += this.pendingBoxes[Ms].byteLength;
                    for (Ms = 0; Ms < this.pendingCaptions.length; Ms++)
                      la = this.pendingCaptions[Ms], la.startTime = Pc.metadataTsToSeconds(la.startPts, Ba, this.keepOriginalTimestamps), la.endTime = Pc.metadataTsToSeconds(la.endPts, Ba, this.keepOriginalTimestamps), ua.captionStreams[la.stream] = !0, ua.captions.push(la);
                    for (Ms = 0; Ms < this.pendingMetadata.length; Ms++)
                      va = this.pendingMetadata[Ms], va.cueTime = Pc.metadataTsToSeconds(va.pts, Ba, this.keepOriginalTimestamps), ua.metadata.push(va);
                    for (ua.metadata.dispatchType = this.metadataStream.dispatchType, this.pendingTracks.length = 0, this.videoTrack = null, this.pendingBoxes.length = 0, this.pendingCaptions.length = 0, this.pendingBytes = 0, this.pendingMetadata.length = 0, this.trigger("data", ua), Ms = 0; Ms < ua.captions.length; Ms++)
                      la = ua.captions[Ms], this.trigger("caption", la);
                    for (Ms = 0; Ms < ua.metadata.length; Ms++)
                      va = ua.metadata[Ms], this.trigger("id3Frame", va);
                  }
                  this.emittedTracks >= this.numberOfTracks && (this.trigger("done"), this.emittedTracks = 0);
                }, mg.prototype.setRemux = function(ms) {
                  this.remuxTracks = ms;
                }, ty = function(Bo) {
                  var ua = this, la = !0, va, Ra;
                  ty.prototype.init.call(this), Bo = Bo || {}, this.baseMediaDecodeTime = Bo.baseMediaDecodeTime || 0, this.transmuxPipeline_ = {}, this.setupAacPipeline = function() {
                    var Ba = {};
                    this.transmuxPipeline_ = Ba, Ba.type = "aac", Ba.metadataStream = new ch.MetadataStream(), Ba.aacStream = new mT(), Ba.audioTimestampRolloverStream = new ch.TimestampRolloverStream("audio"), Ba.timedMetadataTimestampRolloverStream = new ch.TimestampRolloverStream("timed-metadata"), Ba.adtsStream = new I0(), Ba.coalesceStream = new mg(Bo, Ba.metadataStream), Ba.headOfPipeline = Ba.aacStream, Ba.aacStream.pipe(Ba.audioTimestampRolloverStream).pipe(Ba.adtsStream), Ba.aacStream.pipe(Ba.timedMetadataTimestampRolloverStream).pipe(Ba.metadataStream).pipe(Ba.coalesceStream), Ba.metadataStream.on("timestamp", function(Ms) {
                      Ba.aacStream.setTimestamp(Ms.timeStamp);
                    }), Ba.aacStream.on("data", function(Ms) {
                      Ms.type !== "timed-metadata" && Ms.type !== "audio" || Ba.audioSegmentStream || (Ra = Ra || {
                        timelineStartInfo: {
                          baseMediaDecodeTime: ua.baseMediaDecodeTime
                        },
                        codec: "adts",
                        type: "audio"
                      }, Ba.coalesceStream.numberOfTracks++, Ba.audioSegmentStream = new Um(Ra, Bo), Ba.audioSegmentStream.on("log", ua.getLogTrigger_("audioSegmentStream")), Ba.audioSegmentStream.on("timingInfo", ua.trigger.bind(ua, "audioTimingInfo")), Ba.adtsStream.pipe(Ba.audioSegmentStream).pipe(Ba.coalesceStream), ua.trigger("trackinfo", {
                        hasAudio: !!Ra,
                        hasVideo: !!va
                      }));
                    }), Ba.coalesceStream.on("data", this.trigger.bind(this, "data")), Ba.coalesceStream.on("done", this.trigger.bind(this, "done")), j0(this, Ba);
                  }, this.setupTsPipeline = function() {
                    var Ba = {};
                    this.transmuxPipeline_ = Ba, Ba.type = "ts", Ba.metadataStream = new ch.MetadataStream(), Ba.packetStream = new ch.TransportPacketStream(), Ba.parseStream = new ch.TransportParseStream(), Ba.elementaryStream = new ch.ElementaryStream(), Ba.timestampRolloverStream = new ch.TimestampRolloverStream(), Ba.adtsStream = new I0(), Ba.h264Stream = new bT(), Ba.captionStream = new ch.CaptionStream(Bo), Ba.coalesceStream = new mg(Bo, Ba.metadataStream), Ba.headOfPipeline = Ba.packetStream, Ba.packetStream.pipe(Ba.parseStream).pipe(Ba.elementaryStream).pipe(Ba.timestampRolloverStream), Ba.timestampRolloverStream.pipe(Ba.h264Stream), Ba.timestampRolloverStream.pipe(Ba.adtsStream), Ba.timestampRolloverStream.pipe(Ba.metadataStream).pipe(Ba.coalesceStream), Ba.h264Stream.pipe(Ba.captionStream).pipe(Ba.coalesceStream), Ba.elementaryStream.on("data", function(Ms) {
                      var tl;
                      if (Ms.type === "metadata") {
                        for (tl = Ms.tracks.length; tl--; )
                          !va && Ms.tracks[tl].type === "video" ? (va = Ms.tracks[tl], va.timelineStartInfo.baseMediaDecodeTime = ua.baseMediaDecodeTime) : !Ra && Ms.tracks[tl].type === "audio" && (Ra = Ms.tracks[tl], Ra.timelineStartInfo.baseMediaDecodeTime = ua.baseMediaDecodeTime);
                        va && !Ba.videoSegmentStream && (Ba.coalesceStream.numberOfTracks++, Ba.videoSegmentStream = new ey(va, Bo), Ba.videoSegmentStream.on("log", ua.getLogTrigger_("videoSegmentStream")), Ba.videoSegmentStream.on("timelineStartInfo", function(vl) {
                          Ra && !Bo.keepOriginalTimestamps && (Ra.timelineStartInfo = vl, Ba.audioSegmentStream.setEarliestDts(vl.dts - ua.baseMediaDecodeTime));
                        }), Ba.videoSegmentStream.on("processedGopsInfo", ua.trigger.bind(ua, "gopInfo")), Ba.videoSegmentStream.on("segmentTimingInfo", ua.trigger.bind(ua, "videoSegmentTimingInfo")), Ba.videoSegmentStream.on("baseMediaDecodeTime", function(vl) {
                          Ra && Ba.audioSegmentStream.setVideoBaseMediaDecodeTime(vl);
                        }), Ba.videoSegmentStream.on("timingInfo", ua.trigger.bind(ua, "videoTimingInfo")), Ba.h264Stream.pipe(Ba.videoSegmentStream).pipe(Ba.coalesceStream)), Ra && !Ba.audioSegmentStream && (Ba.coalesceStream.numberOfTracks++, Ba.audioSegmentStream = new Um(Ra, Bo), Ba.audioSegmentStream.on("log", ua.getLogTrigger_("audioSegmentStream")), Ba.audioSegmentStream.on("timingInfo", ua.trigger.bind(ua, "audioTimingInfo")), Ba.audioSegmentStream.on("segmentTimingInfo", ua.trigger.bind(ua, "audioSegmentTimingInfo")), Ba.adtsStream.pipe(Ba.audioSegmentStream).pipe(Ba.coalesceStream)), ua.trigger("trackinfo", {
                          hasAudio: !!Ra,
                          hasVideo: !!va
                        });
                      }
                    }), Ba.coalesceStream.on("data", this.trigger.bind(this, "data")), Ba.coalesceStream.on("id3Frame", function(Ms) {
                      Ms.dispatchType = Ba.metadataStream.dispatchType, ua.trigger("id3Frame", Ms);
                    }), Ba.coalesceStream.on("caption", this.trigger.bind(this, "caption")), Ba.coalesceStream.on("done", this.trigger.bind(this, "done")), j0(this, Ba);
                  }, this.setBaseMediaDecodeTime = function(Ba) {
                    var Ms = this.transmuxPipeline_;
                    Bo.keepOriginalTimestamps || (this.baseMediaDecodeTime = Ba), Ra && (Ra.timelineStartInfo.dts = void 0, Ra.timelineStartInfo.pts = void 0, gp.clearDtsInfo(Ra), Ms.audioTimestampRolloverStream && Ms.audioTimestampRolloverStream.discontinuity()), va && (Ms.videoSegmentStream && (Ms.videoSegmentStream.gopCache_ = []), va.timelineStartInfo.dts = void 0, va.timelineStartInfo.pts = void 0, gp.clearDtsInfo(va), Ms.captionStream.reset()), Ms.timestampRolloverStream && Ms.timestampRolloverStream.discontinuity();
                  }, this.setAudioAppendStart = function(Ba) {
                    Ra && this.transmuxPipeline_.audioSegmentStream.setAudioAppendStart(Ba);
                  }, this.setRemux = function(Ba) {
                    var Ms = this.transmuxPipeline_;
                    Bo.remux = Ba, Ms && Ms.coalesceStream && Ms.coalesceStream.setRemux(Ba);
                  }, this.alignGopsWith = function(Ba) {
                    va && this.transmuxPipeline_.videoSegmentStream && this.transmuxPipeline_.videoSegmentStream.alignGopsWith(Ba);
                  }, this.getLogTrigger_ = function(Ba) {
                    var Ms = this;
                    return function(tl) {
                      tl.stream = Ba, Ms.trigger("log", tl);
                    };
                  }, this.push = function(Ba) {
                    if (la) {
                      var Ms = TT(Ba);
                      Ms && this.transmuxPipeline_.type !== "aac" ? this.setupAacPipeline() : !Ms && this.transmuxPipeline_.type !== "ts" && this.setupTsPipeline(), la = !1;
                    }
                    this.transmuxPipeline_.headOfPipeline.push(Ba);
                  }, this.flush = function() {
                    la = !0, this.transmuxPipeline_.headOfPipeline.flush();
                  }, this.endTimeline = function() {
                    this.transmuxPipeline_.headOfPipeline.endTimeline();
                  }, this.reset = function() {
                    this.transmuxPipeline_.headOfPipeline && this.transmuxPipeline_.headOfPipeline.reset();
                  }, this.resetCaptions = function() {
                    this.transmuxPipeline_.captionStream && this.transmuxPipeline_.captionStream.reset();
                  };
                }, ty.prototype = new Ei();
                var xT = {
                  Transmuxer: ty
                }, wT = function(Bo) {
                  return Bo >>> 0;
                }, _T = function(Bo) {
                  return ("00" + Bo.toString(16)).slice(-2);
                }, ry = {
                  toUnsigned: wT,
                  toHexString: _T
                }, PT = function(Bo) {
                  var ua = "";
                  return ua += String.fromCharCode(Bo[0]), ua += String.fromCharCode(Bo[1]), ua += String.fromCharCode(Bo[2]), ua += String.fromCharCode(Bo[3]), ua;
                }, vg = PT, CT = ry.toUnsigned, RT = function ms(Bo, ua) {
                  var la = [], va, Ra, Ba, Ms, tl;
                  if (!ua.length)
                    return null;
                  for (va = 0; va < Bo.byteLength; )
                    Ra = CT(Bo[va] << 24 | Bo[va + 1] << 16 | Bo[va + 2] << 8 | Bo[va + 3]), Ba = vg(Bo.subarray(va + 4, va + 8)), Ms = Ra > 1 ? va + Ra : Bo.byteLength, Ba === ua[0] && (ua.length === 1 ? la.push(Bo.subarray(va + 8, Ms)) : (tl = ms(Bo.subarray(va + 8, Ms), ua.slice(1)), tl.length && (la = la.concat(tl)))), va = Ms;
                  return la;
                }, zc = RT, OT = ry.toUnsigned, AT = ci.getUint64, IT = function(Bo) {
                  var ua = {
                    version: Bo[0],
                    flags: new Uint8Array(Bo.subarray(1, 4))
                  };
                  return ua.version === 1 ? ua.baseMediaDecodeTime = AT(Bo.subarray(4)) : ua.baseMediaDecodeTime = OT(Bo[4] << 24 | Bo[5] << 16 | Bo[6] << 8 | Bo[7]), ua;
                }, U0 = IT, $T = function(Bo) {
                  return {
                    isLeading: (Bo[0] & 12) >>> 2,
                    dependsOn: Bo[0] & 3,
                    isDependedOn: (Bo[1] & 192) >>> 6,
                    hasRedundancy: (Bo[1] & 48) >>> 4,
                    paddingValue: (Bo[1] & 14) >>> 1,
                    isNonSyncSample: Bo[1] & 1,
                    degradationPriority: Bo[2] << 8 | Bo[3]
                  };
                }, V0 = $T, DT = function(Bo) {
                  var ua = {
                    version: Bo[0],
                    flags: new Uint8Array(Bo.subarray(1, 4)),
                    samples: []
                  }, la = new DataView(Bo.buffer, Bo.byteOffset, Bo.byteLength), va = ua.flags[2] & 1, Ra = ua.flags[2] & 4, Ba = ua.flags[1] & 1, Ms = ua.flags[1] & 2, tl = ua.flags[1] & 4, vl = ua.flags[1] & 8, ul = la.getUint32(4), Pl = 8, Jl;
                  for (va && (ua.dataOffset = la.getInt32(Pl), Pl += 4), Ra && ul && (Jl = {
                    flags: V0(Bo.subarray(Pl, Pl + 4))
                  }, Pl += 4, Ba && (Jl.duration = la.getUint32(Pl), Pl += 4), Ms && (Jl.size = la.getUint32(Pl), Pl += 4), vl && (ua.version === 1 ? Jl.compositionTimeOffset = la.getInt32(Pl) : Jl.compositionTimeOffset = la.getUint32(Pl), Pl += 4), ua.samples.push(Jl), ul--); ul--; )
                    Jl = {}, Ba && (Jl.duration = la.getUint32(Pl), Pl += 4), Ms && (Jl.size = la.getUint32(Pl), Pl += 4), tl && (Jl.flags = V0(Bo.subarray(Pl, Pl + 4)), Pl += 4), vl && (ua.version === 1 ? Jl.compositionTimeOffset = la.getInt32(Pl) : Jl.compositionTimeOffset = la.getUint32(Pl), Pl += 4), ua.samples.push(Jl);
                  return ua;
                }, W0 = DT, kT = function(Bo) {
                  var ua = new DataView(Bo.buffer, Bo.byteOffset, Bo.byteLength), la = {
                    version: Bo[0],
                    flags: new Uint8Array(Bo.subarray(1, 4)),
                    trackId: ua.getUint32(4)
                  }, va = la.flags[2] & 1, Ra = la.flags[2] & 2, Ba = la.flags[2] & 8, Ms = la.flags[2] & 16, tl = la.flags[2] & 32, vl = la.flags[0] & 65536, ul = la.flags[0] & 131072, Pl;
                  return Pl = 8, va && (Pl += 4, la.baseDataOffset = ua.getUint32(12), Pl += 4), Ra && (la.sampleDescriptionIndex = ua.getUint32(Pl), Pl += 4), Ba && (la.defaultSampleDuration = ua.getUint32(Pl), Pl += 4), Ms && (la.defaultSampleSize = ua.getUint32(Pl), Pl += 4), tl && (la.defaultSampleFlags = ua.getUint32(Pl)), vl && (la.durationIsEmpty = !0), !va && ul && (la.baseDataOffsetIsMoof = !0), la;
                }, G0 = kT, H0 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof oi.g < "u" ? oi.g : typeof self < "u" ? self : {}, Vm;
                typeof window < "u" ? Vm = window : typeof H0 < "u" ? Vm = H0 : typeof self < "u" ? Vm = self : Vm = {};
                var Wm = Vm, NT = Fm.discardEmulationPreventionBytes, LT = Wv.CaptionStream, MT = function(Bo, ua) {
                  for (var la = Bo, va = 0; va < ua.length; va++) {
                    var Ra = ua[va];
                    if (la < Ra.size)
                      return Ra;
                    la -= Ra.size;
                  }
                  return null;
                }, jT = function(Bo, ua, la) {
                  var va = new DataView(Bo.buffer, Bo.byteOffset, Bo.byteLength), Ra = {
                    logs: [],
                    seiNals: []
                  }, Ba, Ms, tl, vl;
                  for (Ms = 0; Ms + 4 < Bo.length; Ms += tl)
                    if (tl = va.getUint32(Ms), Ms += 4, !(tl <= 0))
                      switch (Bo[Ms] & 31) {
                        case 6:
                          var ul = Bo.subarray(Ms + 1, Ms + 1 + tl), Pl = MT(Ms, ua);
                          if (Ba = {
                            nalUnitType: "sei_rbsp",
                            size: tl,
                            data: ul,
                            escapedRBSP: NT(ul),
                            trackId: la
                          }, Pl)
                            Ba.pts = Pl.pts, Ba.dts = Pl.dts, vl = Pl;
                          else if (vl)
                            Ba.pts = vl.pts, Ba.dts = vl.dts;
                          else {
                            Ra.logs.push({
                              level: "warn",
                              message: "We've encountered a nal unit without data at " + Ms + " for trackId " + la + ". See mux.js#223."
                            });
                            break;
                          }
                          Ra.seiNals.push(Ba);
                          break;
                      }
                  return Ra;
                }, FT = function(Bo, ua, la) {
                  var va = ua, Ra = la.defaultSampleDuration || 0, Ba = la.defaultSampleSize || 0, Ms = la.trackId, tl = [];
                  return Bo.forEach(function(vl) {
                    var ul = W0(vl), Pl = ul.samples;
                    Pl.forEach(function(Jl) {
                      Jl.duration === void 0 && (Jl.duration = Ra), Jl.size === void 0 && (Jl.size = Ba), Jl.trackId = Ms, Jl.dts = va, Jl.compositionTimeOffset === void 0 && (Jl.compositionTimeOffset = 0), typeof va == "bigint" ? (Jl.pts = va + Wm.BigInt(Jl.compositionTimeOffset), va += Wm.BigInt(Jl.duration)) : (Jl.pts = va + Jl.compositionTimeOffset, va += Jl.duration);
                    }), tl = tl.concat(Pl);
                  }), tl;
                }, BT = function(Bo, ua) {
                  var la = zc(Bo, ["moof", "traf"]), va = zc(Bo, ["mdat"]), Ra = {}, Ba = [];
                  return va.forEach(function(Ms, tl) {
                    var vl = la[tl];
                    Ba.push({
                      mdat: Ms,
                      traf: vl
                    });
                  }), Ba.forEach(function(Ms) {
                    var tl = Ms.mdat, vl = Ms.traf, ul = zc(vl, ["tfhd"]), Pl = G0(ul[0]), Jl = Pl.trackId, Cu = zc(vl, ["tfdt"]), Vu = Cu.length > 0 ? U0(Cu[0]).baseMediaDecodeTime : 0, _u = zc(vl, ["trun"]), uc, xd;
                    ua === Jl && _u.length > 0 && (uc = FT(_u, Vu, Pl), xd = jT(tl, uc, Jl), Ra[Jl] || (Ra[Jl] = {
                      seiNals: [],
                      logs: []
                    }), Ra[Jl].seiNals = Ra[Jl].seiNals.concat(xd.seiNals), Ra[Jl].logs = Ra[Jl].logs.concat(xd.logs));
                  }), Ra;
                }, UT = function(Bo, ua, la) {
                  var va;
                  if (ua === null)
                    return null;
                  va = BT(Bo, ua);
                  var Ra = va[ua] || {};
                  return {
                    seiNals: Ra.seiNals,
                    logs: Ra.logs,
                    timescale: la
                  };
                }, VT = function() {
                  var Bo = !1, ua, la, va, Ra, Ba, Ms;
                  this.isInitialized = function() {
                    return Bo;
                  }, this.init = function(tl) {
                    ua = new LT(), Bo = !0, Ms = tl ? tl.isPartial : !1, ua.on("data", function(vl) {
                      vl.startTime = vl.startPts / Ra, vl.endTime = vl.endPts / Ra, Ba.captions.push(vl), Ba.captionStreams[vl.stream] = !0;
                    }), ua.on("log", function(vl) {
                      Ba.logs.push(vl);
                    });
                  }, this.isNewInit = function(tl, vl) {
                    return tl && tl.length === 0 || vl && typeof vl == "object" && Object.keys(vl).length === 0 ? !1 : va !== tl[0] || Ra !== vl[va];
                  }, this.parse = function(tl, vl, ul) {
                    var Pl;
                    if (this.isInitialized()) {
                      if (!vl || !ul)
                        return null;
                      if (this.isNewInit(vl, ul))
                        va = vl[0], Ra = ul[va];
                      else if (va === null || !Ra)
                        return la.push(tl), null;
                    } else return null;
                    for (; la.length > 0; ) {
                      var Jl = la.shift();
                      this.parse(Jl, vl, ul);
                    }
                    return Pl = UT(tl, va, Ra), Pl && Pl.logs && (Ba.logs = Ba.logs.concat(Pl.logs)), Pl === null || !Pl.seiNals ? Ba.logs.length ? {
                      logs: Ba.logs,
                      captions: [],
                      captionStreams: []
                    } : null : (this.pushNals(Pl.seiNals), this.flushStream(), Ba);
                  }, this.pushNals = function(tl) {
                    if (!this.isInitialized() || !tl || tl.length === 0)
                      return null;
                    tl.forEach(function(vl) {
                      ua.push(vl);
                    });
                  }, this.flushStream = function() {
                    if (!this.isInitialized())
                      return null;
                    Ms ? ua.partialFlush() : ua.flush();
                  }, this.clearParsedCaptions = function() {
                    Ba.captions = [], Ba.captionStreams = {}, Ba.logs = [];
                  }, this.resetCaptionStream = function() {
                    if (!this.isInitialized())
                      return null;
                    ua.reset();
                  }, this.clearAllCaptions = function() {
                    this.clearParsedCaptions(), this.resetCaptionStream();
                  }, this.reset = function() {
                    la = [], va = null, Ra = null, Ba ? this.clearParsedCaptions() : Ba = {
                      captions: [],
                      // CC1, CC2, CC3, CC4
                      captionStreams: {},
                      logs: []
                    }, this.resetCaptionStream();
                  }, this.reset();
                }, WT = VT, ny = ry.toUnsigned, Gm = ry.toHexString, GT = ci.getUint64, z0, K0, q0, Y0, X0, c0;
                z0 = function(Bo) {
                  var ua = {}, la = zc(Bo, ["moov", "trak"]);
                  return la.reduce(function(va, Ra) {
                    var Ba, Ms, tl, vl, ul;
                    return Ba = zc(Ra, ["tkhd"])[0], !Ba || (Ms = Ba[0], tl = Ms === 0 ? 12 : 20, vl = ny(Ba[tl] << 24 | Ba[tl + 1] << 16 | Ba[tl + 2] << 8 | Ba[tl + 3]), ul = zc(Ra, ["mdia", "mdhd"])[0], !ul) ? null : (Ms = ul[0], tl = Ms === 0 ? 12 : 20, va[vl] = ny(ul[tl] << 24 | ul[tl + 1] << 16 | ul[tl + 2] << 8 | ul[tl + 3]), va);
                  }, ua);
                }, K0 = function(Bo, ua) {
                  var la;
                  la = zc(ua, ["moof", "traf"]);
                  var va = la.reduce(function(Ra, Ba) {
                    var Ms = zc(Ba, ["tfhd"])[0], tl = ny(Ms[4] << 24 | Ms[5] << 16 | Ms[6] << 8 | Ms[7]), vl = Bo[tl] || 9e4, ul = zc(Ba, ["tfdt"])[0], Pl = new DataView(ul.buffer, ul.byteOffset, ul.byteLength), Jl;
                    ul[0] === 1 ? Jl = GT(ul.subarray(4, 12)) : Jl = Pl.getUint32(4);
                    var Cu;
                    return typeof Jl == "bigint" ? Cu = Jl / Wm.BigInt(vl) : typeof Jl == "number" && !isNaN(Jl) && (Cu = Jl / vl), Cu < Number.MAX_SAFE_INTEGER && (Cu = Number(Cu)), Cu < Ra && (Ra = Cu), Ra;
                  }, 1 / 0);
                  return typeof va == "bigint" || isFinite(va) ? va : 0;
                }, q0 = function(Bo, ua) {
                  var la = zc(ua, ["moof", "traf"]), va = 0, Ra = 0, Ba;
                  if (la && la.length) {
                    var Ms = zc(la[0], ["tfhd"])[0], tl = zc(la[0], ["trun"])[0], vl = zc(la[0], ["tfdt"])[0];
                    if (Ms) {
                      var ul = G0(Ms);
                      Ba = ul.trackId;
                    }
                    if (vl) {
                      var Pl = U0(vl);
                      va = Pl.baseMediaDecodeTime;
                    }
                    if (tl) {
                      var Jl = W0(tl);
                      Jl.samples && Jl.samples.length && (Ra = Jl.samples[0].compositionTimeOffset || 0);
                    }
                  }
                  var Cu = Bo[Ba] || 9e4;
                  typeof va == "bigint" && (Ra = Wm.BigInt(Ra), Cu = Wm.BigInt(Cu));
                  var Vu = (va + Ra) / Cu;
                  return typeof Vu == "bigint" && Vu < Number.MAX_SAFE_INTEGER && (Vu = Number(Vu)), Vu;
                }, Y0 = function(Bo) {
                  var ua = zc(Bo, ["moov", "trak"]), la = [];
                  return ua.forEach(function(va) {
                    var Ra = zc(va, ["mdia", "hdlr"]), Ba = zc(va, ["tkhd"]);
                    Ra.forEach(function(Ms, tl) {
                      var vl = vg(Ms.subarray(8, 12)), ul = Ba[tl], Pl, Jl, Cu;
                      vl === "vide" && (Pl = new DataView(ul.buffer, ul.byteOffset, ul.byteLength), Jl = Pl.getUint8(0), Cu = Jl === 0 ? Pl.getUint32(12) : Pl.getUint32(20), la.push(Cu));
                    });
                  }), la;
                }, c0 = function(Bo) {
                  var ua = Bo[0], la = ua === 0 ? 12 : 20;
                  return ny(Bo[la] << 24 | Bo[la + 1] << 16 | Bo[la + 2] << 8 | Bo[la + 3]);
                }, X0 = function(Bo) {
                  var ua = zc(Bo, ["moov", "trak"]), la = [];
                  return ua.forEach(function(va) {
                    var Ra = {}, Ba = zc(va, ["tkhd"])[0], Ms, tl;
                    Ba && (Ms = new DataView(Ba.buffer, Ba.byteOffset, Ba.byteLength), tl = Ms.getUint8(0), Ra.id = tl === 0 ? Ms.getUint32(12) : Ms.getUint32(20));
                    var vl = zc(va, ["mdia", "hdlr"])[0];
                    if (vl) {
                      var ul = vg(vl.subarray(8, 12));
                      ul === "vide" ? Ra.type = "video" : ul === "soun" ? Ra.type = "audio" : Ra.type = ul;
                    }
                    var Pl = zc(va, ["mdia", "minf", "stbl", "stsd"])[0];
                    if (Pl) {
                      var Jl = Pl.subarray(8);
                      Ra.codec = vg(Jl.subarray(4, 8));
                      var Cu = zc(Jl, [Ra.codec])[0], Vu, _u;
                      Cu && (/^[asm]vc[1-9]$/i.test(Ra.codec) ? (Vu = Cu.subarray(78), _u = vg(Vu.subarray(4, 8)), _u === "avcC" && Vu.length > 11 ? (Ra.codec += ".", Ra.codec += Gm(Vu[9]), Ra.codec += Gm(Vu[10]), Ra.codec += Gm(Vu[11])) : Ra.codec = "avc1.4d400d") : /^mp4[a,v]$/i.test(Ra.codec) ? (Vu = Cu.subarray(28), _u = vg(Vu.subarray(4, 8)), _u === "esds" && Vu.length > 20 && Vu[19] !== 0 ? (Ra.codec += "." + Gm(Vu[19]), Ra.codec += "." + Gm(Vu[20] >>> 2 & 63).replace(/^0/, "")) : Ra.codec = "mp4a.40.2") : Ra.codec = Ra.codec.toLowerCase());
                    }
                    var uc = zc(va, ["mdia", "mdhd"])[0];
                    uc && (Ra.timescale = c0(uc)), la.push(Ra);
                  }), la;
                };
                var J0 = {
                  // export mp4 inspector's findBox and parseType for backwards compatibility
                  findBox: zc,
                  parseType: vg,
                  timescale: z0,
                  startTime: K0,
                  compositionStartTime: q0,
                  videoTrackIds: Y0,
                  tracks: X0,
                  getTimescaleFromMediaHeader: c0
                }, Q0 = function(Bo) {
                  var ua = Bo[1] & 31;
                  return ua <<= 8, ua |= Bo[2], ua;
                }, iy = function(Bo) {
                  return !!(Bo[1] & 64);
                }, oy = function(Bo) {
                  var ua = 0;
                  return (Bo[3] & 48) >>> 4 > 1 && (ua += Bo[4] + 1), ua;
                }, HT = function(Bo, ua) {
                  var la = Q0(Bo);
                  return la === 0 ? "pat" : la === ua ? "pmt" : ua ? "pes" : null;
                }, zT = function(Bo) {
                  var ua = iy(Bo), la = 4 + oy(Bo);
                  return ua && (la += Bo[la] + 1), (Bo[la + 10] & 31) << 8 | Bo[la + 11];
                }, KT = function(Bo) {
                  var ua = {}, la = iy(Bo), va = 4 + oy(Bo);
                  if (la && (va += Bo[va] + 1), !!(Bo[va + 5] & 1)) {
                    var Ra, Ba, Ms;
                    Ra = (Bo[va + 1] & 15) << 8 | Bo[va + 2], Ba = 3 + Ra - 4, Ms = (Bo[va + 10] & 15) << 8 | Bo[va + 11];
                    for (var tl = 12 + Ms; tl < Ba; ) {
                      var vl = va + tl;
                      ua[(Bo[vl + 1] & 31) << 8 | Bo[vl + 2]] = Bo[vl], tl += ((Bo[vl + 3] & 15) << 8 | Bo[vl + 4]) + 5;
                    }
                    return ua;
                  }
                }, qT = function(Bo, ua) {
                  var la = Q0(Bo), va = ua[la];
                  switch (va) {
                    case Fd.H264_STREAM_TYPE:
                      return "video";
                    case Fd.ADTS_STREAM_TYPE:
                      return "audio";
                    case Fd.METADATA_STREAM_TYPE:
                      return "timed-metadata";
                    default:
                      return null;
                  }
                }, YT = function(Bo) {
                  var ua = iy(Bo);
                  if (!ua)
                    return null;
                  var la = 4 + oy(Bo);
                  if (la >= Bo.byteLength)
                    return null;
                  var va = null, Ra;
                  return Ra = Bo[la + 7], Ra & 192 && (va = {}, va.pts = (Bo[la + 9] & 14) << 27 | (Bo[la + 10] & 255) << 20 | (Bo[la + 11] & 254) << 12 | (Bo[la + 12] & 255) << 5 | (Bo[la + 13] & 254) >>> 3, va.pts *= 4, va.pts += (Bo[la + 13] & 6) >>> 1, va.dts = va.pts, Ra & 64 && (va.dts = (Bo[la + 14] & 14) << 27 | (Bo[la + 15] & 255) << 20 | (Bo[la + 16] & 254) << 12 | (Bo[la + 17] & 255) << 5 | (Bo[la + 18] & 254) >>> 3, va.dts *= 4, va.dts += (Bo[la + 18] & 6) >>> 1)), va;
                }, d0 = function(Bo) {
                  switch (Bo) {
                    case 5:
                      return "slice_layer_without_partitioning_rbsp_idr";
                    case 6:
                      return "sei_rbsp";
                    case 7:
                      return "seq_parameter_set_rbsp";
                    case 8:
                      return "pic_parameter_set_rbsp";
                    case 9:
                      return "access_unit_delimiter_rbsp";
                    default:
                      return null;
                  }
                }, XT = function(Bo) {
                  for (var ua = 4 + oy(Bo), la = Bo.subarray(ua), va = 0, Ra = 0, Ba = !1, Ms; Ra < la.byteLength - 3; Ra++)
                    if (la[Ra + 2] === 1) {
                      va = Ra + 5;
                      break;
                    }
                  for (; va < la.byteLength; )
                    switch (la[va]) {
                      case 0:
                        if (la[va - 1] !== 0) {
                          va += 2;
                          break;
                        } else if (la[va - 2] !== 0) {
                          va++;
                          break;
                        }
                        Ra + 3 !== va - 2 && (Ms = d0(la[Ra + 3] & 31), Ms === "slice_layer_without_partitioning_rbsp_idr" && (Ba = !0));
                        do
                          va++;
                        while (la[va] !== 1 && va < la.length);
                        Ra = va - 2, va += 3;
                        break;
                      case 1:
                        if (la[va - 1] !== 0 || la[va - 2] !== 0) {
                          va += 3;
                          break;
                        }
                        Ms = d0(la[Ra + 3] & 31), Ms === "slice_layer_without_partitioning_rbsp_idr" && (Ba = !0), Ra = va - 2, va += 3;
                        break;
                      default:
                        va += 3;
                        break;
                    }
                  return la = la.subarray(Ra), va -= Ra, Ra = 0, la && la.byteLength > 3 && (Ms = d0(la[Ra + 3] & 31), Ms === "slice_layer_without_partitioning_rbsp_idr" && (Ba = !0)), Ba;
                }, JT = {
                  parseType: HT,
                  parsePat: zT,
                  parsePmt: KT,
                  parsePayloadUnitStartIndicator: iy,
                  parsePesType: qT,
                  parsePesTime: YT,
                  videoPacketContainsKeyFrame: XT
                }, zg = P0.handleRollover, Nc = {};
                Nc.ts = JT, Nc.aac = Qv;
                var yg = Pc.ONE_SECOND_IN_TS, nf = 188, jp = 71, QT = function(Bo, ua) {
                  for (var la = 0, va = nf, Ra, Ba; va < Bo.byteLength; ) {
                    if (Bo[la] === jp && Bo[va] === jp) {
                      switch (Ra = Bo.subarray(la, va), Ba = Nc.ts.parseType(Ra, ua.pid), Ba) {
                        case "pat":
                          ua.pid = Nc.ts.parsePat(Ra);
                          break;
                        case "pmt":
                          var Ms = Nc.ts.parsePmt(Ra);
                          ua.table = ua.table || {}, Object.keys(Ms).forEach(function(tl) {
                            ua.table[tl] = Ms[tl];
                          });
                          break;
                      }
                      la += nf, va += nf;
                      continue;
                    }
                    la++, va++;
                  }
                }, Z0 = function(Bo, ua, la) {
                  for (var va = 0, Ra = nf, Ba, Ms, tl, vl, ul, Pl = !1; Ra <= Bo.byteLength; ) {
                    if (Bo[va] === jp && (Bo[Ra] === jp || Ra === Bo.byteLength)) {
                      switch (Ba = Bo.subarray(va, Ra), Ms = Nc.ts.parseType(Ba, ua.pid), Ms) {
                        case "pes":
                          tl = Nc.ts.parsePesType(Ba, ua.table), vl = Nc.ts.parsePayloadUnitStartIndicator(Ba), tl === "audio" && vl && (ul = Nc.ts.parsePesTime(Ba), ul && (ul.type = "audio", la.audio.push(ul), Pl = !0));
                          break;
                      }
                      if (Pl)
                        break;
                      va += nf, Ra += nf;
                      continue;
                    }
                    va++, Ra++;
                  }
                  for (Ra = Bo.byteLength, va = Ra - nf, Pl = !1; va >= 0; ) {
                    if (Bo[va] === jp && (Bo[Ra] === jp || Ra === Bo.byteLength)) {
                      switch (Ba = Bo.subarray(va, Ra), Ms = Nc.ts.parseType(Ba, ua.pid), Ms) {
                        case "pes":
                          tl = Nc.ts.parsePesType(Ba, ua.table), vl = Nc.ts.parsePayloadUnitStartIndicator(Ba), tl === "audio" && vl && (ul = Nc.ts.parsePesTime(Ba), ul && (ul.type = "audio", la.audio.push(ul), Pl = !0));
                          break;
                      }
                      if (Pl)
                        break;
                      va -= nf, Ra -= nf;
                      continue;
                    }
                    va--, Ra--;
                  }
                }, ZT = function(Bo, ua, la) {
                  for (var va = 0, Ra = nf, Ba, Ms, tl, vl, ul, Pl, Jl, Cu, Vu = !1, _u = {
                    data: [],
                    size: 0
                  }; Ra < Bo.byteLength; ) {
                    if (Bo[va] === jp && Bo[Ra] === jp) {
                      switch (Ba = Bo.subarray(va, Ra), Ms = Nc.ts.parseType(Ba, ua.pid), Ms) {
                        case "pes":
                          if (tl = Nc.ts.parsePesType(Ba, ua.table), vl = Nc.ts.parsePayloadUnitStartIndicator(Ba), tl === "video" && (vl && !Vu && (ul = Nc.ts.parsePesTime(Ba), ul && (ul.type = "video", la.video.push(ul), Vu = !0)), !la.firstKeyFrame)) {
                            if (vl && _u.size !== 0) {
                              for (Pl = new Uint8Array(_u.size), Jl = 0; _u.data.length; )
                                Cu = _u.data.shift(), Pl.set(Cu, Jl), Jl += Cu.byteLength;
                              if (Nc.ts.videoPacketContainsKeyFrame(Pl)) {
                                var uc = Nc.ts.parsePesTime(Pl);
                                uc ? (la.firstKeyFrame = uc, la.firstKeyFrame.type = "video") : console.warn("Failed to extract PTS/DTS from PES at first keyframe. This could be an unusual TS segment, or else mux.js did not parse your TS segment correctly. If you know your TS segments do contain PTS/DTS on keyframes please file a bug report! You can try ffprobe to double check for yourself.");
                              }
                              _u.size = 0;
                            }
                            _u.data.push(Ba), _u.size += Ba.byteLength;
                          }
                          break;
                      }
                      if (Vu && la.firstKeyFrame)
                        break;
                      va += nf, Ra += nf;
                      continue;
                    }
                    va++, Ra++;
                  }
                  for (Ra = Bo.byteLength, va = Ra - nf, Vu = !1; va >= 0; ) {
                    if (Bo[va] === jp && Bo[Ra] === jp) {
                      switch (Ba = Bo.subarray(va, Ra), Ms = Nc.ts.parseType(Ba, ua.pid), Ms) {
                        case "pes":
                          tl = Nc.ts.parsePesType(Ba, ua.table), vl = Nc.ts.parsePayloadUnitStartIndicator(Ba), tl === "video" && vl && (ul = Nc.ts.parsePesTime(Ba), ul && (ul.type = "video", la.video.push(ul), Vu = !0));
                          break;
                      }
                      if (Vu)
                        break;
                      va -= nf, Ra -= nf;
                      continue;
                    }
                    va--, Ra--;
                  }
                }, eE = function(Bo, ua) {
                  if (Bo.audio && Bo.audio.length) {
                    var la = ua;
                    (typeof la > "u" || isNaN(la)) && (la = Bo.audio[0].dts), Bo.audio.forEach(function(Ba) {
                      Ba.dts = zg(Ba.dts, la), Ba.pts = zg(Ba.pts, la), Ba.dtsTime = Ba.dts / yg, Ba.ptsTime = Ba.pts / yg;
                    });
                  }
                  if (Bo.video && Bo.video.length) {
                    var va = ua;
                    if ((typeof va > "u" || isNaN(va)) && (va = Bo.video[0].dts), Bo.video.forEach(function(Ba) {
                      Ba.dts = zg(Ba.dts, va), Ba.pts = zg(Ba.pts, va), Ba.dtsTime = Ba.dts / yg, Ba.ptsTime = Ba.pts / yg;
                    }), Bo.firstKeyFrame) {
                      var Ra = Bo.firstKeyFrame;
                      Ra.dts = zg(Ra.dts, va), Ra.pts = zg(Ra.pts, va), Ra.dtsTime = Ra.dts / yg, Ra.ptsTime = Ra.pts / yg;
                    }
                  }
                }, tE = function(Bo) {
                  for (var ua = !1, la = 0, va = null, Ra = null, Ba = 0, Ms = 0, tl; Bo.length - Ms >= 3; ) {
                    var vl = Nc.aac.parseType(Bo, Ms);
                    switch (vl) {
                      case "timed-metadata":
                        if (Bo.length - Ms < 10) {
                          ua = !0;
                          break;
                        }
                        if (Ba = Nc.aac.parseId3TagSize(Bo, Ms), Ba > Bo.length) {
                          ua = !0;
                          break;
                        }
                        Ra === null && (tl = Bo.subarray(Ms, Ms + Ba), Ra = Nc.aac.parseAacTimestamp(tl)), Ms += Ba;
                        break;
                      case "audio":
                        if (Bo.length - Ms < 7) {
                          ua = !0;
                          break;
                        }
                        if (Ba = Nc.aac.parseAdtsSize(Bo, Ms), Ba > Bo.length) {
                          ua = !0;
                          break;
                        }
                        va === null && (tl = Bo.subarray(Ms, Ms + Ba), va = Nc.aac.parseSampleRate(tl)), la++, Ms += Ba;
                        break;
                      default:
                        Ms++;
                        break;
                    }
                    if (ua)
                      return null;
                  }
                  if (va === null || Ra === null)
                    return null;
                  var ul = yg / va, Pl = {
                    audio: [{
                      type: "audio",
                      dts: Ra,
                      pts: Ra
                    }, {
                      type: "audio",
                      dts: Ra + la * 1024 * ul,
                      pts: Ra + la * 1024 * ul
                    }]
                  };
                  return Pl;
                }, nE = function(Bo) {
                  var ua = {
                    pid: null,
                    table: null
                  }, la = {};
                  QT(Bo, ua);
                  for (var va in ua.table)
                    if (ua.table.hasOwnProperty(va)) {
                      var Ra = ua.table[va];
                      switch (Ra) {
                        case Fd.H264_STREAM_TYPE:
                          la.video = [], ZT(Bo, ua, la), la.video.length === 0 && delete la.video;
                          break;
                        case Fd.ADTS_STREAM_TYPE:
                          la.audio = [], Z0(Bo, ua, la), la.audio.length === 0 && delete la.audio;
                          break;
                      }
                    }
                  return la;
                }, iE = function(Bo, ua) {
                  var la = Nc.aac.isLikelyAacData(Bo), va;
                  return la ? va = tE(Bo) : va = nE(Bo), !va || !va.audio && !va.video ? null : (eE(va, ua), va);
                }, oE = {
                  inspect: iE,
                  parseAudioPes_: Z0
                }, aE = function(Bo, ua) {
                  ua.on("data", function(la) {
                    var va = la.initSegment;
                    la.initSegment = {
                      data: va.buffer,
                      byteOffset: va.byteOffset,
                      byteLength: va.byteLength
                    };
                    var Ra = la.data;
                    la.data = Ra.buffer, Bo.postMessage({
                      action: "data",
                      segment: la,
                      byteOffset: Ra.byteOffset,
                      byteLength: Ra.byteLength
                    }, [la.data]);
                  }), ua.on("done", function(la) {
                    Bo.postMessage({
                      action: "done"
                    });
                  }), ua.on("gopInfo", function(la) {
                    Bo.postMessage({
                      action: "gopInfo",
                      gopInfo: la
                    });
                  }), ua.on("videoSegmentTimingInfo", function(la) {
                    var va = {
                      start: {
                        decode: Pc.videoTsToSeconds(la.start.dts),
                        presentation: Pc.videoTsToSeconds(la.start.pts)
                      },
                      end: {
                        decode: Pc.videoTsToSeconds(la.end.dts),
                        presentation: Pc.videoTsToSeconds(la.end.pts)
                      },
                      baseMediaDecodeTime: Pc.videoTsToSeconds(la.baseMediaDecodeTime)
                    };
                    la.prependedContentDuration && (va.prependedContentDuration = Pc.videoTsToSeconds(la.prependedContentDuration)), Bo.postMessage({
                      action: "videoSegmentTimingInfo",
                      videoSegmentTimingInfo: va
                    });
                  }), ua.on("audioSegmentTimingInfo", function(la) {
                    var va = {
                      start: {
                        decode: Pc.videoTsToSeconds(la.start.dts),
                        presentation: Pc.videoTsToSeconds(la.start.pts)
                      },
                      end: {
                        decode: Pc.videoTsToSeconds(la.end.dts),
                        presentation: Pc.videoTsToSeconds(la.end.pts)
                      },
                      baseMediaDecodeTime: Pc.videoTsToSeconds(la.baseMediaDecodeTime)
                    };
                    la.prependedContentDuration && (va.prependedContentDuration = Pc.videoTsToSeconds(la.prependedContentDuration)), Bo.postMessage({
                      action: "audioSegmentTimingInfo",
                      audioSegmentTimingInfo: va
                    });
                  }), ua.on("id3Frame", function(la) {
                    Bo.postMessage({
                      action: "id3Frame",
                      id3Frame: la
                    });
                  }), ua.on("caption", function(la) {
                    Bo.postMessage({
                      action: "caption",
                      caption: la
                    });
                  }), ua.on("trackinfo", function(la) {
                    Bo.postMessage({
                      action: "trackinfo",
                      trackInfo: la
                    });
                  }), ua.on("audioTimingInfo", function(la) {
                    Bo.postMessage({
                      action: "audioTimingInfo",
                      audioTimingInfo: {
                        start: Pc.videoTsToSeconds(la.start),
                        end: Pc.videoTsToSeconds(la.end)
                      }
                    });
                  }), ua.on("videoTimingInfo", function(la) {
                    Bo.postMessage({
                      action: "videoTimingInfo",
                      videoTimingInfo: {
                        start: Pc.videoTsToSeconds(la.start),
                        end: Pc.videoTsToSeconds(la.end)
                      }
                    });
                  }), ua.on("log", function(la) {
                    Bo.postMessage({
                      action: "log",
                      log: la
                    });
                  });
                }, eb = /* @__PURE__ */ (function() {
                  function ms(ua, la) {
                    this.options = la || {}, this.self = ua, this.init();
                  }
                  var Bo = ms.prototype;
                  return Bo.init = function() {
                    this.transmuxer && this.transmuxer.dispose(), this.transmuxer = new xT.Transmuxer(this.options), aE(this.self, this.transmuxer);
                  }, Bo.pushMp4Captions = function(la) {
                    this.captionParser || (this.captionParser = new WT(), this.captionParser.init());
                    var va = new Uint8Array(la.data, la.byteOffset, la.byteLength), Ra = this.captionParser.parse(va, la.trackIds, la.timescales);
                    this.self.postMessage({
                      action: "mp4Captions",
                      captions: Ra && Ra.captions || [],
                      logs: Ra && Ra.logs || [],
                      data: va.buffer
                    }, [va.buffer]);
                  }, Bo.probeMp4StartTime = function(la) {
                    var va = la.timescales, Ra = la.data, Ba = J0.startTime(va, Ra);
                    this.self.postMessage({
                      action: "probeMp4StartTime",
                      startTime: Ba,
                      data: Ra
                    }, [Ra.buffer]);
                  }, Bo.probeMp4Tracks = function(la) {
                    var va = la.data, Ra = J0.tracks(va);
                    this.self.postMessage({
                      action: "probeMp4Tracks",
                      tracks: Ra,
                      data: va
                    }, [va.buffer]);
                  }, Bo.probeTs = function(la) {
                    var va = la.data, Ra = la.baseStartTime, Ba = typeof Ra == "number" && !isNaN(Ra) ? Ra * Pc.ONE_SECOND_IN_TS : void 0, Ms = oE.inspect(va, Ba), tl = null;
                    Ms && (tl = {
                      // each type's time info comes back as an array of 2 times, start and end
                      hasVideo: Ms.video && Ms.video.length === 2 || !1,
                      hasAudio: Ms.audio && Ms.audio.length === 2 || !1
                    }, tl.hasVideo && (tl.videoStart = Ms.video[0].ptsTime), tl.hasAudio && (tl.audioStart = Ms.audio[0].ptsTime)), this.self.postMessage({
                      action: "probeTs",
                      result: tl,
                      data: va
                    }, [va.buffer]);
                  }, Bo.clearAllMp4Captions = function() {
                    this.captionParser && this.captionParser.clearAllCaptions();
                  }, Bo.clearParsedMp4Captions = function() {
                    this.captionParser && this.captionParser.clearParsedCaptions();
                  }, Bo.push = function(la) {
                    var va = new Uint8Array(la.data, la.byteOffset, la.byteLength);
                    this.transmuxer.push(va);
                  }, Bo.reset = function() {
                    this.transmuxer.reset();
                  }, Bo.setTimestampOffset = function(la) {
                    var va = la.timestampOffset || 0;
                    this.transmuxer.setBaseMediaDecodeTime(Math.round(Pc.secondsToVideoTs(va)));
                  }, Bo.setAudioAppendStart = function(la) {
                    this.transmuxer.setAudioAppendStart(Math.ceil(Pc.secondsToVideoTs(la.appendStart)));
                  }, Bo.setRemux = function(la) {
                    this.transmuxer.setRemux(la.remux);
                  }, Bo.flush = function(la) {
                    this.transmuxer.flush(), self.postMessage({
                      action: "done",
                      type: "transmuxed"
                    });
                  }, Bo.endTimeline = function() {
                    this.transmuxer.endTimeline(), self.postMessage({
                      action: "endedtimeline",
                      type: "transmuxed"
                    });
                  }, Bo.alignGopsWith = function(la) {
                    this.transmuxer.alignGopsWith(la.gopsToAlignWith.slice());
                  }, ms;
                })();
                self.onmessage = function(ms) {
                  if (ms.data.action === "init" && ms.data.options) {
                    this.messageHandlers = new eb(self, ms.data.options);
                    return;
                  }
                  this.messageHandlers || (this.messageHandlers = new eb(self)), ms.data && ms.data.action && ms.data.action !== "init" && this.messageHandlers[ms.data.action] && this.messageHandlers[ms.data.action](ms.data);
                };
              })), Ay = fv(hv), gv = function(Ei, bi, yi) {
                var ci = Ei.data.segment, hi = ci.type, wi = ci.initSegment, zi = ci.captions, Wo = ci.captionStreams, aa = ci.metadata, Ea = ci.videoFrameDtsTime, Ka = ci.videoFramePtsTime;
                bi.buffer.push({
                  captions: zi,
                  captionStreams: Wo,
                  metadata: aa
                });
                var Ha = Ei.data.segment.boxes || {
                  data: Ei.data.segment.data
                }, ks = {
                  type: hi,
                  // cast ArrayBuffer to TypedArray
                  data: new Uint8Array(Ha.data, Ha.data.byteOffset, Ha.data.byteLength),
                  initSegment: new Uint8Array(wi.data, wi.byteOffset, wi.byteLength)
                };
                typeof Ea < "u" && (ks.videoFrameDtsTime = Ea), typeof Ka < "u" && (ks.videoFramePtsTime = Ka), yi(ks);
              }, Iy = function(Ei) {
                var bi = Ei.transmuxedData, yi = Ei.callback;
                bi.buffer = [], yi(bi);
              }, $y = function(Ei, bi) {
                bi.gopInfo = Ei.data.gopInfo;
              }, Em = function(Ei) {
                var bi = Ei.transmuxer, yi = Ei.bytes, ci = Ei.audioAppendStart, hi = Ei.gopsToAlignWith, wi = Ei.remux, zi = Ei.onData, Wo = Ei.onTrackInfo, aa = Ei.onAudioTimingInfo, Ea = Ei.onVideoTimingInfo, Ka = Ei.onVideoSegmentTimingInfo, Ha = Ei.onAudioSegmentTimingInfo, ks = Ei.onId3, gl = Ei.onCaptions, Sl = Ei.onDone, Fl = Ei.onEndedTimeline, ru = Ei.onTransmuxerLog, $u = Ei.isEndOfTimeline, rc = {
                  buffer: []
                }, Au = $u, Iu = function(Pu) {
                  bi.currentTransmux === Ei && (Pu.data.action === "data" && gv(Pu, rc, zi), Pu.data.action === "trackinfo" && Wo(Pu.data.trackInfo), Pu.data.action === "gopInfo" && $y(Pu, rc), Pu.data.action === "audioTimingInfo" && aa(Pu.data.audioTimingInfo), Pu.data.action === "videoTimingInfo" && Ea(Pu.data.videoTimingInfo), Pu.data.action === "videoSegmentTimingInfo" && Ka(Pu.data.videoSegmentTimingInfo), Pu.data.action === "audioSegmentTimingInfo" && Ha(Pu.data.audioSegmentTimingInfo), Pu.data.action === "id3Frame" && ks([Pu.data.id3Frame], Pu.data.id3Frame.dispatchType), Pu.data.action === "caption" && gl(Pu.data.caption), Pu.data.action === "endedtimeline" && (Au = !1, Fl()), Pu.data.action === "log" && ru(Pu.data.log), Pu.data.type === "transmuxed" && (Au || (bi.onmessage = null, Iy({
                    transmuxedData: rc,
                    callback: Sl
                  }), Sm(bi))));
                };
                if (bi.onmessage = Iu, ci && bi.postMessage({
                  action: "setAudioAppendStart",
                  appendStart: ci
                }), Array.isArray(hi) && bi.postMessage({
                  action: "alignGopsWith",
                  gopsToAlignWith: hi
                }), typeof wi < "u" && bi.postMessage({
                  action: "setRemux",
                  remux: wi
                }), yi.byteLength) {
                  var Bu = yi instanceof ArrayBuffer ? yi : yi.buffer, mu = yi instanceof ArrayBuffer ? 0 : yi.byteOffset;
                  bi.postMessage({
                    action: "push",
                    // Send the typed-array of data as an ArrayBuffer so that
                    // it can be sent as a "Transferable" and avoid the costly
                    // memory copy
                    data: Bu,
                    // To recreate the original typed-array, we need information
                    // about what portion of the ArrayBuffer it was a view into
                    byteOffset: mu,
                    byteLength: yi.byteLength
                  }, [Bu]);
                }
                $u && bi.postMessage({
                  action: "endTimeline"
                }), bi.postMessage({
                  action: "flush"
                });
              }, Sm = function(Ei) {
                Ei.currentTransmux = null, Ei.transmuxQueue.length && (Ei.currentTransmux = Ei.transmuxQueue.shift(), typeof Ei.currentTransmux == "function" ? Ei.currentTransmux() : Em(Ei.currentTransmux));
              }, xm = function(Ei, bi) {
                Ei.postMessage({
                  action: bi
                }), Sm(Ei);
              }, wm = function(Ei, bi) {
                if (!bi.currentTransmux) {
                  bi.currentTransmux = Ei, xm(bi, Ei);
                  return;
                }
                bi.transmuxQueue.push(xm.bind(null, bi, Ei));
              }, _m = function(Ei) {
                wm("reset", Ei);
              }, Pm = function(Ei) {
                wm("endTimeline", Ei);
              }, mv = function(Ei) {
                if (!Ei.transmuxer.currentTransmux) {
                  Ei.transmuxer.currentTransmux = Ei, Em(Ei);
                  return;
                }
                Ei.transmuxer.transmuxQueue.push(Ei);
              }, Dy = function(Ei) {
                var bi = new Ay();
                bi.currentTransmux = null, bi.transmuxQueue = [];
                var yi = bi.terminate;
                return bi.terminate = function() {
                  return bi.currentTransmux = null, bi.transmuxQueue.length = 0, yi.call(bi);
                }, bi.postMessage({
                  action: "init",
                  options: Ei
                }), bi;
              }, Qf = {
                reset: _m,
                endTimeline: Pm,
                transmux: mv,
                createTransmuxer: Dy
              }, dg = function(Ei) {
                var bi = Ei.transmuxer, yi = Ei.endAction || Ei.action, ci = Ei.callback, hi = (0, mi.default)({}, Ei, {
                  endAction: null,
                  transmuxer: null,
                  callback: null
                }), wi = function aa(Ea) {
                  Ea.data.action === yi && (bi.removeEventListener("message", aa), Ea.data.data && (Ea.data.data = new Uint8Array(Ea.data.data, Ei.byteOffset || 0, Ei.byteLength || Ea.data.data.byteLength), Ei.data && (Ei.data = Ea.data.data)), ci(Ea.data));
                };
                if (bi.addEventListener("message", wi), Ei.data) {
                  var zi = Ei.data instanceof ArrayBuffer;
                  hi.byteOffset = zi ? 0 : Ei.data.byteOffset, hi.byteLength = Ei.data.byteLength;
                  var Wo = [zi ? Ei.data : Ei.data.buffer];
                  bi.postMessage(hi, Wo);
                } else
                  bi.postMessage(hi);
              }, mf = {
                FAILURE: 2,
                TIMEOUT: -101,
                ABORTED: -102
              }, Cm = function(Ei) {
                Ei.forEach(function(bi) {
                  bi.abort();
                });
              }, vv = function(Ei) {
                return {
                  bandwidth: Ei.bandwidth,
                  bytesReceived: Ei.bytesReceived || 0,
                  roundTripTime: Ei.roundTripTime || 0
                };
              }, Ny = function(Ei) {
                var bi = Ei.target, yi = Date.now() - bi.requestTime, ci = {
                  bandwidth: 1 / 0,
                  bytesReceived: 0,
                  roundTripTime: yi || 0
                };
                return ci.bytesReceived = Ei.loaded, ci.bandwidth = Math.floor(ci.bytesReceived / ci.roundTripTime * 8 * 1e3), ci;
              }, Rm = function(Ei, bi) {
                return bi.timedout ? {
                  status: bi.status,
                  message: "HLS request timed-out at URL: " + bi.uri,
                  code: mf.TIMEOUT,
                  xhr: bi
                } : bi.aborted ? {
                  status: bi.status,
                  message: "HLS request aborted at URL: " + bi.uri,
                  code: mf.ABORTED,
                  xhr: bi
                } : Ei ? {
                  status: bi.status,
                  message: "HLS request errored at URL: " + bi.uri,
                  code: mf.FAILURE,
                  xhr: bi
                } : bi.responseType === "arraybuffer" && bi.response.byteLength === 0 ? {
                  status: bi.status,
                  message: "Empty HLS response at URL: " + bi.uri,
                  code: mf.FAILURE,
                  xhr: bi
                } : null;
              }, yv = function(Ei, bi, yi) {
                return function(ci, hi) {
                  var wi = hi.response, zi = Rm(ci, hi);
                  if (zi)
                    return yi(zi, Ei);
                  if (wi.byteLength !== 16)
                    return yi({
                      status: hi.status,
                      message: "Invalid HLS key at URL: " + hi.uri,
                      code: mf.FAILURE,
                      xhr: hi
                    }, Ei);
                  for (var Wo = new DataView(wi), aa = new Uint32Array([Wo.getUint32(0), Wo.getUint32(4), Wo.getUint32(8), Wo.getUint32(12)]), Ea = 0; Ea < bi.length; Ea++)
                    bi[Ea].bytes = aa;
                  return yi(null, Ei);
                };
              }, bv = function(Ei, bi) {
                var yi = (0, jo.detectContainerForBytes)(Ei.map.bytes);
                if (yi !== "mp4") {
                  var ci = Ei.map.resolvedUri || Ei.map.uri;
                  return bi({
                    internal: !0,
                    message: "Found unsupported " + (yi || "unknown") + " container for initialization segment at URL: " + ci,
                    code: mf.FAILURE
                  });
                }
                dg({
                  action: "probeMp4Tracks",
                  data: Ei.map.bytes,
                  transmuxer: Ei.transmuxer,
                  callback: function(wi) {
                    var zi = wi.tracks, Wo = wi.data;
                    return Ei.map.bytes = Wo, zi.forEach(function(aa) {
                      Ei.map.tracks = Ei.map.tracks || {}, !Ei.map.tracks[aa.type] && (Ei.map.tracks[aa.type] = aa, typeof aa.id == "number" && aa.timescale && (Ei.map.timescales = Ei.map.timescales || {}, Ei.map.timescales[aa.id] = aa.timescale));
                    }), bi(null);
                  }
                });
              }, Ly = function(Ei) {
                var bi = Ei.segment, yi = Ei.finishProcessingFn;
                return function(ci, hi) {
                  var wi = Rm(ci, hi);
                  if (wi)
                    return yi(wi, bi);
                  var zi = new Uint8Array(hi.response);
                  if (bi.map.key)
                    return bi.map.encryptedBytes = zi, yi(null, bi);
                  bi.map.bytes = zi, bv(bi, function(Wo) {
                    if (Wo)
                      return Wo.xhr = hi, Wo.status = hi.status, yi(Wo, bi);
                    yi(null, bi);
                  });
                };
              }, My = function(Ei) {
                var bi = Ei.segment, yi = Ei.finishProcessingFn, ci = Ei.responseType;
                return function(hi, wi) {
                  var zi = Rm(hi, wi);
                  if (zi)
                    return yi(zi, bi);
                  var Wo = (
                    // although responseText "should" exist, this guard serves to prevent an error being
                    // thrown for two primary cases:
                    // 1. the mime type override stops working, or is not implemented for a specific
                    //    browser
                    // 2. when using mock XHR libraries like sinon that do not allow the override behavior
                    ci === "arraybuffer" || !wi.responseText ? wi.response : Fh(wi.responseText.substring(bi.lastReachedChar || 0))
                  );
                  return bi.stats = vv(wi), bi.key ? bi.encryptedBytes = new Uint8Array(Wo) : bi.bytes = new Uint8Array(Wo), yi(null, bi);
                };
              }, Tv = function(Ei) {
                var bi = Ei.segment, yi = Ei.bytes, ci = Ei.trackInfoFn, hi = Ei.timingInfoFn, wi = Ei.videoSegmentTimingInfoFn, zi = Ei.audioSegmentTimingInfoFn, Wo = Ei.id3Fn, aa = Ei.captionsFn, Ea = Ei.isEndOfTimeline, Ka = Ei.endedTimelineFn, Ha = Ei.dataFn, ks = Ei.doneFn, gl = Ei.onTransmuxerLog, Sl = bi.map && bi.map.tracks || {}, Fl = !!(Sl.audio && Sl.video), ru = hi.bind(null, bi, "audio", "start"), $u = hi.bind(null, bi, "audio", "end"), rc = hi.bind(null, bi, "video", "start"), Au = hi.bind(null, bi, "video", "end"), Iu = function() {
                  return mv({
                    bytes: yi,
                    transmuxer: bi.transmuxer,
                    audioAppendStart: bi.audioAppendStart,
                    gopsToAlignWith: bi.gopsToAlignWith,
                    remux: Fl,
                    onData: function(au) {
                      au.type = au.type === "combined" ? "video" : au.type, Ha(bi, au);
                    },
                    onTrackInfo: function(au) {
                      ci && (Fl && (au.isMuxed = !0), ci(bi, au));
                    },
                    onAudioTimingInfo: function(au) {
                      ru && typeof au.start < "u" && (ru(au.start), ru = null), $u && typeof au.end < "u" && $u(au.end);
                    },
                    onVideoTimingInfo: function(au) {
                      rc && typeof au.start < "u" && (rc(au.start), rc = null), Au && typeof au.end < "u" && Au(au.end);
                    },
                    onVideoSegmentTimingInfo: function(au) {
                      wi(au);
                    },
                    onAudioSegmentTimingInfo: function(au) {
                      zi(au);
                    },
                    onId3: function(au, Pu) {
                      Wo(bi, au, Pu);
                    },
                    onCaptions: function(au) {
                      aa(bi, [au]);
                    },
                    isEndOfTimeline: Ea,
                    onEndedTimeline: function() {
                      Ka();
                    },
                    onTransmuxerLog: gl,
                    onDone: function(au) {
                      ks && (au.type = au.type === "combined" ? "video" : au.type, ks(null, bi, au));
                    }
                  });
                };
                dg({
                  action: "probeTs",
                  transmuxer: bi.transmuxer,
                  data: yi,
                  baseStartTime: bi.baseStartTime,
                  callback: function(mu) {
                    bi.bytes = yi = mu.data;
                    var au = mu.result;
                    au && (ci(bi, {
                      hasAudio: au.hasAudio,
                      hasVideo: au.hasVideo,
                      isMuxed: Fl
                    }), ci = null, au.hasAudio && !Fl && ru(au.audioStart), au.hasVideo && rc(au.videoStart), ru = null, rc = null), Iu();
                  }
                });
              }, Ev = function(Ei) {
                var bi = Ei.segment, yi = Ei.bytes, ci = Ei.trackInfoFn, hi = Ei.timingInfoFn, wi = Ei.videoSegmentTimingInfoFn, zi = Ei.audioSegmentTimingInfoFn, Wo = Ei.id3Fn, aa = Ei.captionsFn, Ea = Ei.isEndOfTimeline, Ka = Ei.endedTimelineFn, Ha = Ei.dataFn, ks = Ei.doneFn, gl = Ei.onTransmuxerLog, Sl = new Uint8Array(yi);
                if ((0, jo.isLikelyFmp4MediaSegment)(Sl)) {
                  bi.isFmp4 = !0;
                  var Fl = bi.map.tracks, ru = {
                    isFmp4: !0,
                    hasVideo: !!Fl.video,
                    hasAudio: !!Fl.audio
                  };
                  Fl.audio && Fl.audio.codec && Fl.audio.codec !== "enca" && (ru.audioCodec = Fl.audio.codec), Fl.video && Fl.video.codec && Fl.video.codec !== "encv" && (ru.videoCodec = Fl.video.codec), Fl.video && Fl.audio && (ru.isMuxed = !0), ci(bi, ru);
                  var $u = function(Au) {
                    Ha(bi, {
                      data: Sl,
                      type: ru.hasAudio && !ru.isMuxed ? "audio" : "video"
                    }), Au && Au.length && aa(bi, Au), ks(null, bi, {});
                  };
                  dg({
                    action: "probeMp4StartTime",
                    timescales: bi.map.timescales,
                    data: Sl,
                    transmuxer: bi.transmuxer,
                    callback: function(Au) {
                      var Iu = Au.data, Bu = Au.startTime;
                      if (yi = Iu.buffer, bi.bytes = Sl = Iu, ru.hasAudio && !ru.isMuxed && hi(bi, "audio", "start", Bu), ru.hasVideo && hi(bi, "video", "start", Bu), !Fl.video || !Iu.byteLength || !bi.transmuxer) {
                        $u();
                        return;
                      }
                      dg({
                        action: "pushMp4Captions",
                        endAction: "mp4Captions",
                        transmuxer: bi.transmuxer,
                        data: Sl,
                        timescales: bi.map.timescales,
                        trackIds: [Fl.video.id],
                        callback: function(au) {
                          yi = au.data.buffer, bi.bytes = Sl = au.data, au.logs.forEach(function(Pu) {
                            gl(Rl.mergeOptions(Pu, {
                              stream: "mp4CaptionParser"
                            }));
                          }), $u(au.captions);
                        }
                      });
                    }
                  });
                  return;
                }
                if (!bi.transmuxer) {
                  ks(null, bi, {});
                  return;
                }
                if (typeof bi.container > "u" && (bi.container = (0, jo.detectContainerForBytes)(Sl)), bi.container !== "ts" && bi.container !== "aac") {
                  ci(bi, {
                    hasAudio: !1,
                    hasVideo: !1
                  }), ks(null, bi, {});
                  return;
                }
                Tv({
                  segment: bi,
                  bytes: yi,
                  trackInfoFn: ci,
                  timingInfoFn: hi,
                  videoSegmentTimingInfoFn: wi,
                  audioSegmentTimingInfoFn: zi,
                  id3Fn: Wo,
                  captionsFn: aa,
                  isEndOfTimeline: Ea,
                  endedTimelineFn: Ka,
                  dataFn: Ha,
                  doneFn: ks,
                  onTransmuxerLog: gl
                });
              }, Lg = function(Ei, bi) {
                var yi = Ei.id, ci = Ei.key, hi = Ei.encryptedBytes, wi = Ei.decryptionWorker, zi = function aa(Ea) {
                  if (Ea.data.source === yi) {
                    wi.removeEventListener("message", aa);
                    var Ka = Ea.data.decrypted;
                    bi(new Uint8Array(Ka.bytes, Ka.byteOffset, Ka.byteLength));
                  }
                };
                wi.addEventListener("message", zi);
                var Wo;
                ci.bytes.slice ? Wo = ci.bytes.slice() : Wo = new Uint32Array(Array.prototype.slice.call(ci.bytes)), wi.postMessage(ov({
                  source: yi,
                  encrypted: hi,
                  key: Wo,
                  iv: ci.iv
                }), [hi.buffer, Wo.buffer]);
              }, jy = function(Ei) {
                var bi = Ei.decryptionWorker, yi = Ei.segment, ci = Ei.trackInfoFn, hi = Ei.timingInfoFn, wi = Ei.videoSegmentTimingInfoFn, zi = Ei.audioSegmentTimingInfoFn, Wo = Ei.id3Fn, aa = Ei.captionsFn, Ea = Ei.isEndOfTimeline, Ka = Ei.endedTimelineFn, Ha = Ei.dataFn, ks = Ei.doneFn, gl = Ei.onTransmuxerLog;
                Lg({
                  id: yi.requestId,
                  key: yi.key,
                  encryptedBytes: yi.encryptedBytes,
                  decryptionWorker: bi
                }, function(Sl) {
                  yi.bytes = Sl, Ev({
                    segment: yi,
                    bytes: yi.bytes,
                    trackInfoFn: ci,
                    timingInfoFn: hi,
                    videoSegmentTimingInfoFn: wi,
                    audioSegmentTimingInfoFn: zi,
                    id3Fn: Wo,
                    captionsFn: aa,
                    isEndOfTimeline: Ea,
                    endedTimelineFn: Ka,
                    dataFn: Ha,
                    doneFn: ks,
                    onTransmuxerLog: gl
                  });
                });
              }, Bh = function(Ei) {
                var bi = Ei.activeXhrs, yi = Ei.decryptionWorker, ci = Ei.trackInfoFn, hi = Ei.timingInfoFn, wi = Ei.videoSegmentTimingInfoFn, zi = Ei.audioSegmentTimingInfoFn, Wo = Ei.id3Fn, aa = Ei.captionsFn, Ea = Ei.isEndOfTimeline, Ka = Ei.endedTimelineFn, Ha = Ei.dataFn, ks = Ei.doneFn, gl = Ei.onTransmuxerLog, Sl = 0, Fl = !1;
                return function(ru, $u) {
                  if (!Fl) {
                    if (ru)
                      return Fl = !0, Cm(bi), ks(ru, $u);
                    if (Sl += 1, Sl === bi.length) {
                      var rc = function() {
                        if ($u.encryptedBytes)
                          return jy({
                            decryptionWorker: yi,
                            segment: $u,
                            trackInfoFn: ci,
                            timingInfoFn: hi,
                            videoSegmentTimingInfoFn: wi,
                            audioSegmentTimingInfoFn: zi,
                            id3Fn: Wo,
                            captionsFn: aa,
                            isEndOfTimeline: Ea,
                            endedTimelineFn: Ka,
                            dataFn: Ha,
                            doneFn: ks,
                            onTransmuxerLog: gl
                          });
                        Ev({
                          segment: $u,
                          bytes: $u.bytes,
                          trackInfoFn: ci,
                          timingInfoFn: hi,
                          videoSegmentTimingInfoFn: wi,
                          audioSegmentTimingInfoFn: zi,
                          id3Fn: Wo,
                          captionsFn: aa,
                          isEndOfTimeline: Ea,
                          endedTimelineFn: Ka,
                          dataFn: Ha,
                          doneFn: ks,
                          onTransmuxerLog: gl
                        });
                      };
                      if ($u.endOfAllRequests = Date.now(), $u.map && $u.map.encryptedBytes && !$u.map.bytes)
                        return Lg({
                          decryptionWorker: yi,
                          // add -init to the "id" to differentiate between segment
                          // and init segment decryption, just in case they happen
                          // at the same time at some point in the future.
                          id: $u.requestId + "-init",
                          encryptedBytes: $u.map.encryptedBytes,
                          key: $u.map.key
                        }, function(Au) {
                          $u.map.bytes = Au, bv($u, function(Iu) {
                            if (Iu)
                              return Cm(bi), ks(Iu, $u);
                            rc();
                          });
                        });
                      rc();
                    }
                  }
                };
              }, Fy = function(Ei) {
                var bi = Ei.loadendState, yi = Ei.abortFn;
                return function(ci) {
                  var hi = ci.target;
                  hi.aborted && yi && !bi.calledAbortFn && (yi(), bi.calledAbortFn = !0);
                };
              }, Om = function(Ei) {
                var bi = Ei.segment, yi = Ei.progressFn;
                return function(ci) {
                  var hi = ci.target;
                  if (!hi.aborted)
                    return bi.stats = Rl.mergeOptions(bi.stats, Ny(ci)), !bi.stats.firstBytesReceivedAt && bi.stats.bytesReceived && (bi.stats.firstBytesReceivedAt = Date.now()), yi(ci, bi);
                };
              }, Sv = function(Ei) {
                var bi = Ei.xhr, yi = Ei.xhrOptions, ci = Ei.decryptionWorker, hi = Ei.segment, wi = Ei.abortFn, zi = Ei.progressFn, Wo = Ei.trackInfoFn, aa = Ei.timingInfoFn, Ea = Ei.videoSegmentTimingInfoFn, Ka = Ei.audioSegmentTimingInfoFn, Ha = Ei.id3Fn, ks = Ei.captionsFn, gl = Ei.isEndOfTimeline, Sl = Ei.endedTimelineFn, Fl = Ei.dataFn, ru = Ei.doneFn, $u = Ei.onTransmuxerLog, rc = [], Au = Bh({
                  activeXhrs: rc,
                  decryptionWorker: ci,
                  trackInfoFn: Wo,
                  timingInfoFn: aa,
                  videoSegmentTimingInfoFn: Ea,
                  audioSegmentTimingInfoFn: Ka,
                  id3Fn: Ha,
                  captionsFn: ks,
                  isEndOfTimeline: gl,
                  endedTimelineFn: Sl,
                  dataFn: Fl,
                  doneFn: ru,
                  onTransmuxerLog: $u
                });
                if (hi.key && !hi.key.bytes) {
                  var Iu = [hi.key];
                  hi.map && !hi.map.bytes && hi.map.key && hi.map.key.resolvedUri === hi.key.resolvedUri && Iu.push(hi.map.key);
                  var Bu = Rl.mergeOptions(yi, {
                    uri: hi.key.resolvedUri,
                    responseType: "arraybuffer"
                  }), mu = yv(hi, Iu, Au), au = bi(Bu, mu);
                  rc.push(au);
                }
                if (hi.map && !hi.map.bytes) {
                  var Pu = hi.map.key && (!hi.key || hi.key.resolvedUri !== hi.map.key.resolvedUri);
                  if (Pu) {
                    var nu = Rl.mergeOptions(yi, {
                      uri: hi.map.key.resolvedUri,
                      responseType: "arraybuffer"
                    }), ec = yv(hi, [hi.map.key], Au), Lu = bi(nu, ec);
                    rc.push(Lu);
                  }
                  var oc = Rl.mergeOptions(yi, {
                    uri: hi.map.resolvedUri,
                    responseType: "arraybuffer",
                    headers: Dg(hi.map)
                  }), Uc = Ly({
                    segment: hi,
                    finishProcessingFn: Au
                  }), Hc = bi(oc, Uc);
                  rc.push(Hc);
                }
                var cd = Rl.mergeOptions(yi, {
                  uri: hi.part && hi.part.resolvedUri || hi.resolvedUri,
                  responseType: "arraybuffer",
                  headers: Dg(hi)
                }), Td = My({
                  segment: hi,
                  finishProcessingFn: Au,
                  responseType: cd.responseType
                }), Xc = bi(cd, Td);
                Xc.addEventListener("progress", Om({
                  segment: hi,
                  progressFn: zi
                })), rc.push(Xc);
                var Qd = {};
                return rc.forEach(function(Dc) {
                  Dc.addEventListener("loadend", Fy({
                    loadendState: Qd,
                    abortFn: wi
                  }));
                }), function() {
                  return Cm(rc);
                };
              }, Am = Af("CodecUtils"), Im = function(Ei) {
                var bi = Ei.attributes || {};
                if (bi.CODECS)
                  return (0, Li.parseCodecs)(bi.CODECS);
              }, xv = function(Ei, bi) {
                var yi = bi.attributes || {};
                return Ei && Ei.mediaGroups && Ei.mediaGroups.AUDIO && yi.AUDIO && Ei.mediaGroups.AUDIO[yi.AUDIO];
              }, Md = function(Ei, bi) {
                if (!xv(Ei, bi))
                  return !0;
                var yi = bi.attributes || {}, ci = Ei.mediaGroups.AUDIO[yi.AUDIO];
                for (var hi in ci)
                  if (!ci[hi].uri && !ci[hi].playlists)
                    return !0;
                return !1;
              }, kf = function(Ei) {
                var bi = {};
                return Ei.forEach(function(yi) {
                  var ci = yi.mediaType, hi = yi.type, wi = yi.details;
                  bi[ci] = bi[ci] || [], bi[ci].push((0, Li.translateLegacyCodec)("" + hi + wi));
                }), Object.keys(bi).forEach(function(yi) {
                  if (bi[yi].length > 1) {
                    Am("multiple " + yi + " codecs found as attributes: " + bi[yi].join(", ") + ". Setting playlist codecs to null so that we wait for mux.js to probe segments for real codecs."), bi[yi] = null;
                    return;
                  }
                  bi[yi] = bi[yi][0];
                }), bi;
              }, Mg = function(Ei) {
                var bi = 0;
                return Ei.audio && bi++, Ei.video && bi++, bi;
              }, Uh = function(Ei, bi) {
                var yi = bi.attributes || {}, ci = kf(Im(bi) || []);
                if (xv(Ei, bi) && !ci.audio && !Md(Ei, bi)) {
                  var hi = kf((0, Li.codecsFromDefault)(Ei, yi.AUDIO) || []);
                  hi.audio && (ci.audio = hi.audio);
                }
                return ci;
              }, jg = Af("PlaylistSelector"), wv = function(Ei) {
                if (!(!Ei || !Ei.playlist)) {
                  var bi = Ei.playlist;
                  return JSON.stringify({
                    id: bi.id,
                    bandwidth: Ei.bandwidth,
                    width: Ei.width,
                    height: Ei.height,
                    codecs: bi.attributes && bi.attributes.CODECS || ""
                  });
                }
              }, Fg = function(Ei, bi) {
                if (!Ei)
                  return "";
                var yi = di().getComputedStyle(Ei);
                return yi ? yi[bi] : "";
              }, Vh = function(Ei, bi) {
                var yi = Ei.slice();
                Ei.sort(function(ci, hi) {
                  var wi = bi(ci, hi);
                  return wi === 0 ? yi.indexOf(ci) - yi.indexOf(hi) : wi;
                });
              }, $m = function(Ei, bi) {
                var yi, ci;
                return Ei.attributes.BANDWIDTH && (yi = Ei.attributes.BANDWIDTH), yi = yi || di().Number.MAX_VALUE, bi.attributes.BANDWIDTH && (ci = bi.attributes.BANDWIDTH), ci = ci || di().Number.MAX_VALUE, yi - ci;
              }, By = function(Ei, bi) {
                var yi, ci;
                return Ei.attributes.RESOLUTION && Ei.attributes.RESOLUTION.width && (yi = Ei.attributes.RESOLUTION.width), yi = yi || di().Number.MAX_VALUE, bi.attributes.RESOLUTION && bi.attributes.RESOLUTION.width && (ci = bi.attributes.RESOLUTION.width), ci = ci || di().Number.MAX_VALUE, yi === ci && Ei.attributes.BANDWIDTH && bi.attributes.BANDWIDTH ? Ei.attributes.BANDWIDTH - bi.attributes.BANDWIDTH : yi - ci;
              }, _v = function(Ei, bi, yi, ci, hi, wi) {
                if (Ei) {
                  var zi = {
                    bandwidth: bi,
                    width: yi,
                    height: ci,
                    limitRenditionByPlayerDimensions: hi
                  }, Wo = Ei.playlists;
                  Jd.isAudioOnly(Ei) && (Wo = wi.getAudioTrackPlaylists_(), zi.audioOnly = !0);
                  var aa = Wo.map(function(nu) {
                    var ec, Lu = nu.attributes && nu.attributes.RESOLUTION && nu.attributes.RESOLUTION.width, oc = nu.attributes && nu.attributes.RESOLUTION && nu.attributes.RESOLUTION.height;
                    return ec = nu.attributes && nu.attributes.BANDWIDTH, ec = ec || di().Number.MAX_VALUE, {
                      bandwidth: ec,
                      width: Lu,
                      height: oc,
                      playlist: nu
                    };
                  });
                  Vh(aa, function(nu, ec) {
                    return nu.bandwidth - ec.bandwidth;
                  }), aa = aa.filter(function(nu) {
                    return !Jd.isIncompatible(nu.playlist);
                  });
                  var Ea = aa.filter(function(nu) {
                    return Jd.isEnabled(nu.playlist);
                  });
                  Ea.length || (Ea = aa.filter(function(nu) {
                    return !Jd.isDisabled(nu.playlist);
                  }));
                  var Ka = Ea.filter(function(nu) {
                    return nu.bandwidth * bd.BANDWIDTH_VARIANCE < bi;
                  }), Ha = Ka[Ka.length - 1], ks = Ka.filter(function(nu) {
                    return nu.bandwidth === Ha.bandwidth;
                  })[0];
                  if (hi === !1) {
                    var gl = ks || Ea[0] || aa[0];
                    if (gl && gl.playlist) {
                      var Sl = "sortedPlaylistReps";
                      return ks && (Sl = "bandwidthBestRep"), Ea[0] && (Sl = "enabledPlaylistReps"), jg("choosing " + wv(gl) + " using " + Sl + " with options", zi), gl.playlist;
                    }
                    return jg("could not choose a playlist with options", zi), null;
                  }
                  var Fl = Ka.filter(function(nu) {
                    return nu.width && nu.height;
                  });
                  Vh(Fl, function(nu, ec) {
                    return nu.width - ec.width;
                  });
                  var ru = Fl.filter(function(nu) {
                    return nu.width === yi && nu.height === ci;
                  });
                  Ha = ru[ru.length - 1];
                  var $u = ru.filter(function(nu) {
                    return nu.bandwidth === Ha.bandwidth;
                  })[0], rc, Au, Iu;
                  $u || (rc = Fl.filter(function(nu) {
                    return nu.width > yi || nu.height > ci;
                  }), Au = rc.filter(function(nu) {
                    return nu.width === rc[0].width && nu.height === rc[0].height;
                  }), Ha = Au[Au.length - 1], Iu = Au.filter(function(nu) {
                    return nu.bandwidth === Ha.bandwidth;
                  })[0]);
                  var Bu;
                  if (wi.experimentalLeastPixelDiffSelector) {
                    var mu = Fl.map(function(nu) {
                      return nu.pixelDiff = Math.abs(nu.width - yi) + Math.abs(nu.height - ci), nu;
                    });
                    Vh(mu, function(nu, ec) {
                      return nu.pixelDiff === ec.pixelDiff ? ec.bandwidth - nu.bandwidth : nu.pixelDiff - ec.pixelDiff;
                    }), Bu = mu[0];
                  }
                  var au = Bu || Iu || $u || ks || Ea[0] || aa[0];
                  if (au && au.playlist) {
                    var Pu = "sortedPlaylistReps";
                    return Bu ? Pu = "leastPixelDiffRep" : Iu ? Pu = "resolutionPlusOneRep" : $u ? Pu = "resolutionBestRep" : ks ? Pu = "bandwidthBestRep" : Ea[0] && (Pu = "enabledPlaylistReps"), jg("choosing " + wv(au) + " using " + Pu + " with options", zi), au.playlist;
                  }
                  return jg("could not choose a playlist with options", zi), null;
                }
              }, Dm = function() {
                var Ei = this.useDevicePixelRatio && di().devicePixelRatio || 1;
                return _v(this.playlists.master, this.systemBandwidth, parseInt(Fg(this.tech_.el(), "width"), 10) * Ei, parseInt(Fg(this.tech_.el(), "height"), 10) * Ei, this.limitRenditionByPlayerDimensions, this.masterPlaylistController_);
              }, Bg = function(Ei) {
                var bi = -1, yi = -1;
                if (Ei < 0 || Ei > 1)
                  throw new Error("Moving average bandwidth decay must be between 0 and 1.");
                return function() {
                  var ci = this.useDevicePixelRatio && di().devicePixelRatio || 1;
                  return bi < 0 && (bi = this.systemBandwidth, yi = this.systemBandwidth), this.systemBandwidth > 0 && this.systemBandwidth !== yi && (bi = Ei * this.systemBandwidth + (1 - Ei) * bi, yi = this.systemBandwidth), _v(this.playlists.master, bi, parseInt(Fg(this.tech_.el(), "width"), 10) * ci, parseInt(Fg(this.tech_.el(), "height"), 10) * ci, this.limitRenditionByPlayerDimensions, this.masterPlaylistController_);
                };
              }, Uy = function(Ei) {
                var bi = Ei.master, yi = Ei.currentTime, ci = Ei.bandwidth, hi = Ei.duration, wi = Ei.segmentDuration, zi = Ei.timeUntilRebuffer, Wo = Ei.currentTimeline, aa = Ei.syncController, Ea = bi.playlists.filter(function(Sl) {
                  return !Jd.isIncompatible(Sl);
                }), Ka = Ea.filter(Jd.isEnabled);
                Ka.length || (Ka = Ea.filter(function(Sl) {
                  return !Jd.isDisabled(Sl);
                }));
                var Ha = Ka.filter(Jd.hasAttribute.bind(null, "BANDWIDTH")), ks = Ha.map(function(Sl) {
                  var Fl = aa.getSyncPoint(Sl, hi, Wo, yi), ru = Fl ? 1 : 2, $u = Jd.estimateSegmentRequestTime(wi, ci, Sl), rc = $u * ru - zi;
                  return {
                    playlist: Sl,
                    rebufferingImpact: rc
                  };
                }), gl = ks.filter(function(Sl) {
                  return Sl.rebufferingImpact <= 0;
                });
                return Vh(gl, function(Sl, Fl) {
                  return $m(Fl.playlist, Sl.playlist);
                }), gl.length ? gl[0] : (Vh(ks, function(Sl, Fl) {
                  return Sl.rebufferingImpact - Fl.rebufferingImpact;
                }), ks[0] || null);
              }, km = function() {
                var Ei = this, bi = this.playlists.master.playlists.filter(Jd.isEnabled);
                Vh(bi, function(ci, hi) {
                  return $m(ci, hi);
                });
                var yi = bi.filter(function(ci) {
                  return !!Uh(Ei.playlists.master, ci).video;
                });
                return yi[0] || null;
              }, Vy = function(Ei) {
                var bi = 0, yi;
                return Ei.bytes && (yi = new Uint8Array(Ei.bytes), Ei.segments.forEach(function(ci) {
                  yi.set(ci, bi), bi += ci.byteLength;
                })), yi;
              }, Pv = function(Ei, bi, yi) {
                if (!Ei[yi]) {
                  bi.trigger({
                    type: "usage",
                    name: "vhs-608"
                  }), bi.trigger({
                    type: "usage",
                    name: "hls-608"
                  });
                  var ci = yi;
                  /^cc708_/.test(yi) && (ci = "SERVICE" + yi.split("_")[1]);
                  var hi = bi.textTracks().getTrackById(ci);
                  if (hi)
                    Ei[yi] = hi;
                  else {
                    var wi = bi.options_.vhs && bi.options_.vhs.captionServices || {}, zi = yi, Wo = yi, aa = !1, Ea = wi[ci];
                    Ea && (zi = Ea.label, Wo = Ea.language, aa = Ea.default), Ei[yi] = bi.addRemoteTextTrack({
                      kind: "captions",
                      id: ci,
                      // TODO: investigate why this doesn't seem to turn the caption on by default
                      default: aa,
                      label: zi,
                      language: Wo
                    }, !1).track;
                  }
                }
              }, Wy = function(Ei) {
                var bi = Ei.inbandTextTracks, yi = Ei.captionArray, ci = Ei.timestampOffset;
                if (yi) {
                  var hi = di().WebKitDataCue || di().VTTCue;
                  yi.forEach(function(wi) {
                    var zi = wi.stream;
                    bi[zi].addCue(new hi(wi.startTime + ci, wi.endTime + ci, wi.text));
                  });
                }
              }, Gy = function(Ei) {
                Object.defineProperties(Ei.frame, {
                  id: {
                    get: function() {
                      return Rl.log.warn("cue.frame.id is deprecated. Use cue.value.key instead."), Ei.value.key;
                    }
                  },
                  value: {
                    get: function() {
                      return Rl.log.warn("cue.frame.value is deprecated. Use cue.value.data instead."), Ei.value.data;
                    }
                  },
                  privateData: {
                    get: function() {
                      return Rl.log.warn("cue.frame.privateData is deprecated. Use cue.value.data instead."), Ei.value.data;
                    }
                  }
                });
              }, Hy = function(Ei) {
                var bi = Ei.inbandTextTracks, yi = Ei.metadataArray, ci = Ei.timestampOffset, hi = Ei.videoDuration;
                if (yi) {
                  var wi = di().WebKitDataCue || di().VTTCue, zi = bi.metadataTrack_;
                  if (zi && (yi.forEach(function(ks) {
                    var gl = ks.cueTime + ci;
                    typeof gl != "number" || di().isNaN(gl) || gl < 0 || !(gl < 1 / 0) || ks.frames.forEach(function(Sl) {
                      var Fl = new wi(gl, gl, Sl.value || Sl.url || Sl.data || "");
                      Fl.frame = Sl, Fl.value = Sl, Gy(Fl), zi.addCue(Fl);
                    });
                  }), !(!zi.cues || !zi.cues.length))) {
                    for (var Wo = zi.cues, aa = [], Ea = 0; Ea < Wo.length; Ea++)
                      Wo[Ea] && aa.push(Wo[Ea]);
                    var Ka = aa.reduce(function(ks, gl) {
                      var Sl = ks[gl.startTime] || [];
                      return Sl.push(gl), ks[gl.startTime] = Sl, ks;
                    }, {}), Ha = Object.keys(Ka).sort(function(ks, gl) {
                      return Number(ks) - Number(gl);
                    });
                    Ha.forEach(function(ks, gl) {
                      var Sl = Ka[ks], Fl = Number(Ha[gl + 1]) || hi;
                      Sl.forEach(function(ru) {
                        ru.endTime = Fl;
                      });
                    });
                  }
                }
              }, zy = function(Ei, bi, yi) {
                Ei.metadataTrack_ || (Ei.metadataTrack_ = yi.addRemoteTextTrack({
                  kind: "metadata",
                  label: "Timed Metadata"
                }, !1).track, Ei.metadataTrack_.inBandMetadataTrackDispatchType = bi);
              }, fg = function(Ei, bi, yi) {
                var ci, hi;
                if (yi && yi.cues)
                  for (ci = yi.cues.length; ci--; )
                    hi = yi.cues[ci], hi.startTime >= Ei && hi.endTime <= bi && yi.removeCue(hi);
              }, Lp = function(Ei) {
                var bi = Ei.cues;
                if (bi)
                  for (var yi = 0; yi < bi.length; yi++) {
                    for (var ci = [], hi = 0, wi = 0; wi < bi.length; wi++)
                      bi[yi].startTime === bi[wi].startTime && bi[yi].endTime === bi[wi].endTime && bi[yi].text === bi[wi].text && (hi++, hi > 1 && ci.push(bi[wi]));
                    ci.length && ci.forEach(function(zi) {
                      return Ei.removeCue(zi);
                    });
                  }
              }, Cv = function(Ei, bi, yi) {
                if (typeof bi > "u" || bi === null || !Ei.length)
                  return [];
                var ci = Math.ceil((bi - yi + 3) * Wi.ONE_SECOND_IN_TS), hi;
                for (hi = 0; hi < Ei.length && !(Ei[hi].pts > ci); hi++)
                  ;
                return Ei.slice(hi);
              }, Rv = function(Ei, bi, yi) {
                if (!bi.length)
                  return Ei;
                if (yi)
                  return bi.slice();
                var ci = bi[0].pts, hi = 0;
                for (hi; hi < Ei.length && !(Ei[hi].pts >= ci); hi++)
                  ;
                return Ei.slice(0, hi).concat(bi);
              }, Nf = function(Ei, bi, yi, ci) {
                for (var hi = Math.ceil((bi - ci) * Wi.ONE_SECOND_IN_TS), wi = Math.ceil((yi - ci) * Wi.ONE_SECOND_IN_TS), zi = Ei.slice(), Wo = Ei.length; Wo-- && !(Ei[Wo].pts <= wi); )
                  ;
                if (Wo === -1)
                  return zi;
                for (var aa = Wo + 1; aa-- && !(Ei[aa].pts <= hi); )
                  ;
                return aa = Math.max(aa, 0), zi.splice(aa, Wo - aa + 1), zi;
              }, Ov = function(Ei, bi) {
                if (!Ei && !bi || !Ei && bi || Ei && !bi)
                  return !1;
                if (Ei === bi)
                  return !0;
                var yi = Object.keys(Ei).sort(), ci = Object.keys(bi).sort();
                if (yi.length !== ci.length)
                  return !1;
                for (var hi = 0; hi < yi.length; hi++) {
                  var wi = yi[hi];
                  if (wi !== ci[hi] || Ei[wi] !== bi[wi])
                    return !1;
                }
                return !0;
              }, Wh = 22, Ky = function(Ei, bi, yi) {
                bi = bi || [];
                for (var ci = [], hi = 0, wi = 0; wi < bi.length; wi++) {
                  var zi = bi[wi];
                  if (Ei === zi.timeline && (ci.push(wi), hi += zi.duration, hi > yi))
                    return wi;
                }
                return ci.length === 0 ? 0 : ci[ci.length - 1];
              }, Gh = 1, qy = 500, Av = function(Ei) {
                return typeof Ei == "number" && isFinite(Ei);
              }, pg = 1 / 60, Yy = function(Ei, bi, yi) {
                return Ei !== "main" || !bi || !yi ? null : !yi.hasAudio && !yi.hasVideo ? "Neither audio nor video found in segment." : bi.hasVideo && !yi.hasVideo ? "Only audio found in segment when we expected video. We can't switch to audio only from a stream that had video. To get rid of this message, please add codec information to the manifest." : !bi.hasVideo && yi.hasVideo ? "Video found in segment when we expected only audio. We can't switch to a stream with video from an audio only stream. To get rid of this message, please add codec information to the manifest." : null;
              }, Iv = function(Ei, bi, yi) {
                var ci = bi - bd.BACK_BUFFER_LENGTH;
                Ei.length && (ci = Math.max(ci, Ei.start(0)));
                var hi = bi - yi;
                return Math.min(hi, ci);
              }, pp = function(Ei) {
                var bi = Ei.startOfSegment, yi = Ei.duration, ci = Ei.segment, hi = Ei.part, wi = Ei.playlist, zi = wi.mediaSequence, Wo = wi.id, aa = wi.segments, Ea = aa === void 0 ? [] : aa, Ka = Ei.mediaIndex, Ha = Ei.partIndex, ks = Ei.timeline, gl = Ea.length - 1, Sl = "mediaIndex/partIndex increment";
                Ei.getMediaInfoForTime ? Sl = "getMediaInfoForTime (" + Ei.getMediaInfoForTime + ")" : Ei.isSyncRequest && (Sl = "getSyncSegmentCandidate (isSyncRequest)"), Ei.independent && (Sl += " with independent " + Ei.independent);
                var Fl = typeof Ha == "number", ru = Ei.segment.uri ? "segment" : "pre-segment", $u = Fl ? ah({
                  preloadSegment: ci
                }) - 1 : 0;
                return ru + " [" + (zi + Ka) + "/" + (zi + gl) + "]" + (Fl ? " part [" + Ha + "/" + $u + "]" : "") + (" segment start/end [" + ci.start + " => " + ci.end + "]") + (Fl ? " part start/end [" + hi.start + " => " + hi.end + "]" : "") + (" startOfSegment [" + bi + "]") + (" duration [" + yi + "]") + (" timeline [" + ks + "]") + (" selected by [" + Sl + "]") + (" playlist [" + Wo + "]");
              }, $v = function(Ei) {
                return Ei + "TimingInfo";
              }, Nm = function(Ei) {
                var bi = Ei.segmentTimeline, yi = Ei.currentTimeline, ci = Ei.startOfSegment, hi = Ei.buffered, wi = Ei.overrideCheck;
                return !wi && bi === yi ? null : bi < yi ? ci : hi.length ? hi.end(hi.length - 1) : ci;
              }, sh = function(Ei) {
                var bi = Ei.timelineChangeController, yi = Ei.currentTimeline, ci = Ei.segmentTimeline, hi = Ei.loaderType, wi = Ei.audioDisabled;
                if (yi === ci)
                  return !1;
                if (hi === "audio") {
                  var zi = bi.lastTimelineChange({
                    type: "main"
                  });
                  return !zi || zi.to !== ci;
                }
                if (hi === "main" && wi) {
                  var Wo = bi.pendingTimelineChange({
                    type: "audio"
                  });
                  return !(Wo && Wo.to === ci);
                }
                return !1;
              }, Dv = function(Ei) {
                var bi = 0;
                return ["video", "audio"].forEach(function(yi) {
                  var ci = Ei[yi + "TimingInfo"];
                  if (ci) {
                    var hi = ci.start, wi = ci.end, zi;
                    typeof hi == "bigint" || typeof wi == "bigint" ? zi = di().BigInt(wi) - di().BigInt(hi) : typeof hi == "number" && typeof wi == "number" && (zi = wi - hi), typeof zi < "u" && zi > bi && (bi = zi);
                  }
                }), typeof bi == "bigint" && bi < Number.MAX_SAFE_INTEGER && (bi = Number(bi)), bi;
              }, kv = function(Ei) {
                var bi = Ei.segmentDuration, yi = Ei.maxDuration;
                return bi ? Math.round(bi) > yi + Xf : !1;
              }, Xy = function(Ei, bi) {
                if (bi !== "hls")
                  return null;
                var yi = Dv({
                  audioTimingInfo: Ei.audioTimingInfo,
                  videoTimingInfo: Ei.videoTimingInfo
                });
                if (!yi)
                  return null;
                var ci = Ei.playlist.targetDuration, hi = kv({
                  segmentDuration: yi,
                  maxDuration: ci * 2
                }), wi = kv({
                  segmentDuration: yi,
                  maxDuration: ci
                }), zi = "Segment with index " + Ei.mediaIndex + " " + ("from playlist " + Ei.playlist.id + " ") + ("has a duration of " + yi + " ") + ("when the reported duration is " + Ei.duration + " ") + ("and the target duration is " + ci + ". ") + "For HLS content, a duration in excess of the target duration may result in playback issues. See the HLS specification section on EXT-X-TARGETDURATION for more details: https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.3.1";
                return hi || wi ? {
                  severity: hi ? "warn" : "info",
                  message: zi
                } : null;
              }, Ug = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  if (hi = Vi.call(this) || this, !yi)
                    throw new TypeError("Initialization settings are required");
                  if (typeof yi.currentTime != "function")
                    throw new TypeError("No currentTime getter specified");
                  if (!yi.mediaSource)
                    throw new TypeError("No MediaSource specified");
                  return hi.bandwidth = yi.bandwidth, hi.throughput = {
                    rate: 0,
                    count: 0
                  }, hi.roundTrip = NaN, hi.resetStats_(), hi.mediaIndex = null, hi.partIndex = null, hi.hasPlayed_ = yi.hasPlayed, hi.currentTime_ = yi.currentTime, hi.seekable_ = yi.seekable, hi.seeking_ = yi.seeking, hi.duration_ = yi.duration, hi.mediaSource_ = yi.mediaSource, hi.vhs_ = yi.vhs, hi.loaderType_ = yi.loaderType, hi.currentMediaInfo_ = void 0, hi.startingMediaInfo_ = void 0, hi.segmentMetadataTrack_ = yi.segmentMetadataTrack, hi.goalBufferLength_ = yi.goalBufferLength, hi.sourceType_ = yi.sourceType, hi.sourceUpdater_ = yi.sourceUpdater, hi.inbandTextTracks_ = yi.inbandTextTracks, hi.state_ = "INIT", hi.timelineChangeController_ = yi.timelineChangeController, hi.shouldSaveSegmentTimingInfo_ = !0, hi.parse708captions_ = yi.parse708captions, hi.useDtsForTimestampOffset_ = yi.useDtsForTimestampOffset, hi.captionServices_ = yi.captionServices, hi.experimentalExactManifestTimings = yi.experimentalExactManifestTimings, hi.checkBufferTimeout_ = null, hi.error_ = void 0, hi.currentTimeline_ = -1, hi.pendingSegment_ = null, hi.xhrOptions_ = null, hi.pendingSegments_ = [], hi.audioDisabled_ = !1, hi.isPendingTimestampOffset_ = !1, hi.gopBuffer_ = [], hi.timeMapping_ = 0, hi.safeAppend_ = Rl.browser.IE_VERSION >= 11, hi.appendInitSegment_ = {
                    audio: !0,
                    video: !0
                  }, hi.playlistOfLastInitSegment_ = {
                    audio: null,
                    video: null
                  }, hi.callQueue_ = [], hi.loadQueue_ = [], hi.metadataQueue_ = {
                    id3: [],
                    caption: []
                  }, hi.waitingOnRemove_ = !1, hi.quotaExceededErrorRetryTimeout_ = null, hi.activeInitSegmentId_ = null, hi.initSegments_ = {}, hi.cacheEncryptionKeys_ = yi.cacheEncryptionKeys, hi.keyCache_ = {}, hi.decrypter_ = yi.decrypter, hi.syncController_ = yi.syncController, hi.syncPoint_ = {
                    segmentIndex: 0,
                    time: 0
                  }, hi.transmuxer_ = hi.createTransmuxer_(), hi.triggerSyncInfoUpdate_ = function() {
                    return hi.trigger("syncinfoupdate");
                  }, hi.syncController_.on("syncinfoupdate", hi.triggerSyncInfoUpdate_), hi.mediaSource_.addEventListener("sourceopen", function() {
                    hi.isEndOfStream_() || (hi.ended_ = !1);
                  }), hi.fetchAtBuffer_ = !1, hi.logger_ = Af("SegmentLoader[" + hi.loaderType_ + "]"), Object.defineProperty((0, xi.default)(hi), "state", {
                    get: function() {
                      return this.state_;
                    },
                    set: function(zi) {
                      zi !== this.state_ && (this.logger_(this.state_ + " -> " + zi), this.state_ = zi, this.trigger("statechange"));
                    }
                  }), hi.sourceUpdater_.on("ready", function() {
                    hi.hasEnoughInfoToAppend_() && hi.processCallQueue_();
                  }), hi.loaderType_ === "main" && hi.timelineChangeController_.on("pendingtimelinechange", function() {
                    hi.hasEnoughInfoToAppend_() && hi.processCallQueue_();
                  }), hi.loaderType_ === "audio" && hi.timelineChangeController_.on("timelinechange", function() {
                    hi.hasEnoughInfoToLoad_() && hi.processLoadQueue_(), hi.hasEnoughInfoToAppend_() && hi.processCallQueue_();
                  }), hi;
                }
                var bi = Ei.prototype;
                return bi.createTransmuxer_ = function() {
                  return Qf.createTransmuxer({
                    remux: !1,
                    alignGopsAtEnd: this.safeAppend_,
                    keepOriginalTimestamps: !0,
                    parse708captions: this.parse708captions_,
                    captionServices: this.captionServices_
                  });
                }, bi.resetStats_ = function() {
                  this.mediaBytesTransferred = 0, this.mediaRequests = 0, this.mediaRequestsAborted = 0, this.mediaRequestsTimedout = 0, this.mediaRequestsErrored = 0, this.mediaTransferDuration = 0, this.mediaSecondsLoaded = 0, this.mediaAppends = 0;
                }, bi.dispose = function() {
                  this.trigger("dispose"), this.state = "DISPOSED", this.pause(), this.abort_(), this.transmuxer_ && this.transmuxer_.terminate(), this.resetStats_(), this.checkBufferTimeout_ && di().clearTimeout(this.checkBufferTimeout_), this.syncController_ && this.triggerSyncInfoUpdate_ && this.syncController_.off("syncinfoupdate", this.triggerSyncInfoUpdate_), this.off();
                }, bi.setAudio = function(ci) {
                  this.audioDisabled_ = !ci, ci ? this.appendInitSegment_.audio = !0 : this.sourceUpdater_.removeAudio(0, this.duration_());
                }, bi.abort = function() {
                  if (this.state !== "WAITING") {
                    this.pendingSegment_ && (this.pendingSegment_ = null);
                    return;
                  }
                  this.abort_(), this.state = "READY", this.paused() || this.monitorBuffer_();
                }, bi.abort_ = function() {
                  this.pendingSegment_ && this.pendingSegment_.abortRequests && this.pendingSegment_.abortRequests(), this.pendingSegment_ = null, this.callQueue_ = [], this.loadQueue_ = [], this.metadataQueue_.id3 = [], this.metadataQueue_.caption = [], this.timelineChangeController_.clearPendingTimelineChange(this.loaderType_), this.waitingOnRemove_ = !1, di().clearTimeout(this.quotaExceededErrorRetryTimeout_), this.quotaExceededErrorRetryTimeout_ = null;
                }, bi.checkForAbort_ = function(ci) {
                  return this.state === "APPENDING" && !this.pendingSegment_ ? (this.state = "READY", !0) : !this.pendingSegment_ || this.pendingSegment_.requestId !== ci;
                }, bi.error = function(ci) {
                  return typeof ci < "u" && (this.logger_("error occurred:", ci), this.error_ = ci), this.pendingSegment_ = null, this.error_;
                }, bi.endOfStream = function() {
                  this.ended_ = !0, this.transmuxer_ && Qf.reset(this.transmuxer_), this.gopBuffer_.length = 0, this.pause(), this.trigger("ended");
                }, bi.buffered_ = function() {
                  var ci = this.getMediaInfo_();
                  if (!this.sourceUpdater_ || !ci)
                    return Rl.createTimeRanges();
                  if (this.loaderType_ === "main") {
                    var hi = ci.hasAudio, wi = ci.hasVideo, zi = ci.isMuxed;
                    if (wi && hi && !this.audioDisabled_ && !zi)
                      return this.sourceUpdater_.buffered();
                    if (wi)
                      return this.sourceUpdater_.videoBuffered();
                  }
                  return this.sourceUpdater_.audioBuffered();
                }, bi.initSegmentForMap = function(ci, hi) {
                  if (hi === void 0 && (hi = !1), !ci)
                    return null;
                  var wi = Ng(ci), zi = this.initSegments_[wi];
                  return hi && !zi && ci.bytes && (this.initSegments_[wi] = zi = {
                    resolvedUri: ci.resolvedUri,
                    byterange: ci.byterange,
                    bytes: ci.bytes,
                    tracks: ci.tracks,
                    timescales: ci.timescales
                  }), zi || ci;
                }, bi.segmentKey = function(ci, hi) {
                  if (hi === void 0 && (hi = !1), !ci)
                    return null;
                  var wi = av(ci), zi = this.keyCache_[wi];
                  this.cacheEncryptionKeys_ && hi && !zi && ci.bytes && (this.keyCache_[wi] = zi = {
                    resolvedUri: ci.resolvedUri,
                    bytes: ci.bytes
                  });
                  var Wo = {
                    resolvedUri: (zi || ci).resolvedUri
                  };
                  return zi && (Wo.bytes = zi.bytes), Wo;
                }, bi.couldBeginLoading_ = function() {
                  return this.playlist_ && !this.paused();
                }, bi.load = function() {
                  if (this.monitorBuffer_(), !!this.playlist_) {
                    if (this.state === "INIT" && this.couldBeginLoading_())
                      return this.init_();
                    !this.couldBeginLoading_() || this.state !== "READY" && this.state !== "INIT" || (this.state = "READY");
                  }
                }, bi.init_ = function() {
                  return this.state = "READY", this.resetEverything(), this.monitorBuffer_();
                }, bi.playlist = function(ci, hi) {
                  if (hi === void 0 && (hi = {}), !!ci) {
                    var wi = this.playlist_, zi = this.pendingSegment_;
                    this.playlist_ = ci, this.xhrOptions_ = hi, this.state === "INIT" && (ci.syncInfo = {
                      mediaSequence: ci.mediaSequence,
                      time: 0
                    }, this.loaderType_ === "main" && this.syncController_.setDateTimeMappingForStart(ci));
                    var Wo = null;
                    if (wi && (wi.id ? Wo = wi.id : wi.uri && (Wo = wi.uri)), this.logger_("playlist update [" + Wo + " => " + (ci.id || ci.uri) + "]"), this.trigger("syncinfoupdate"), this.state === "INIT" && this.couldBeginLoading_())
                      return this.init_();
                    if (!wi || wi.uri !== ci.uri) {
                      this.mediaIndex !== null && (ci.endList ? this.resyncLoader() : this.resetLoader()), this.currentMediaInfo_ = void 0, this.trigger("playlistupdate");
                      return;
                    }
                    var aa = ci.mediaSequence - wi.mediaSequence;
                    if (this.logger_("live window shift [" + aa + "]"), this.mediaIndex !== null)
                      if (this.mediaIndex -= aa, this.mediaIndex < 0)
                        this.mediaIndex = null, this.partIndex = null;
                      else {
                        var Ea = this.playlist_.segments[this.mediaIndex];
                        if (this.partIndex && (!Ea.parts || !Ea.parts.length || !Ea.parts[this.partIndex])) {
                          var Ka = this.mediaIndex;
                          this.logger_("currently processing part (index " + this.partIndex + ") no longer exists."), this.resetLoader(), this.mediaIndex = Ka;
                        }
                      }
                    zi && (zi.mediaIndex -= aa, zi.mediaIndex < 0 ? (zi.mediaIndex = null, zi.partIndex = null) : (zi.mediaIndex >= 0 && (zi.segment = ci.segments[zi.mediaIndex]), zi.partIndex >= 0 && zi.segment.parts && (zi.part = zi.segment.parts[zi.partIndex]))), this.syncController_.saveExpiredSegmentInfo(wi, ci);
                  }
                }, bi.pause = function() {
                  this.checkBufferTimeout_ && (di().clearTimeout(this.checkBufferTimeout_), this.checkBufferTimeout_ = null);
                }, bi.paused = function() {
                  return this.checkBufferTimeout_ === null;
                }, bi.resetEverything = function(ci) {
                  this.ended_ = !1, this.activeInitSegmentId_ = null, this.appendInitSegment_ = {
                    audio: !0,
                    video: !0
                  }, this.resetLoader(), this.remove(0, 1 / 0, ci), this.transmuxer_ && (this.transmuxer_.postMessage({
                    action: "clearAllMp4Captions"
                  }), this.transmuxer_.postMessage({
                    action: "reset"
                  }));
                }, bi.resetLoader = function() {
                  this.fetchAtBuffer_ = !1, this.resyncLoader();
                }, bi.resyncLoader = function() {
                  this.transmuxer_ && Qf.reset(this.transmuxer_), this.mediaIndex = null, this.partIndex = null, this.syncPoint_ = null, this.isPendingTimestampOffset_ = !1, this.callQueue_ = [], this.loadQueue_ = [], this.metadataQueue_.id3 = [], this.metadataQueue_.caption = [], this.abort(), this.transmuxer_ && this.transmuxer_.postMessage({
                    action: "clearParsedMp4Captions"
                  });
                }, bi.remove = function(ci, hi, wi, zi) {
                  if (wi === void 0 && (wi = function() {
                  }), zi === void 0 && (zi = !1), hi === 1 / 0 && (hi = this.duration_()), hi <= ci) {
                    this.logger_("skipping remove because end ${end} is <= start ${start}");
                    return;
                  }
                  if (!this.sourceUpdater_ || !this.getMediaInfo_()) {
                    this.logger_("skipping remove because no source updater or starting media info");
                    return;
                  }
                  var Wo = 1, aa = function() {
                    Wo--, Wo === 0 && wi();
                  };
                  (zi || !this.audioDisabled_) && (Wo++, this.sourceUpdater_.removeAudio(ci, hi, aa)), (zi || this.loaderType_ === "main") && (this.gopBuffer_ = Nf(this.gopBuffer_, ci, hi, this.timeMapping_), Wo++, this.sourceUpdater_.removeVideo(ci, hi, aa));
                  for (var Ea in this.inbandTextTracks_)
                    fg(ci, hi, this.inbandTextTracks_[Ea]);
                  fg(ci, hi, this.segmentMetadataTrack_), aa();
                }, bi.monitorBuffer_ = function() {
                  this.checkBufferTimeout_ && di().clearTimeout(this.checkBufferTimeout_), this.checkBufferTimeout_ = di().setTimeout(this.monitorBufferTick_.bind(this), 1);
                }, bi.monitorBufferTick_ = function() {
                  this.state === "READY" && this.fillBuffer_(), this.checkBufferTimeout_ && di().clearTimeout(this.checkBufferTimeout_), this.checkBufferTimeout_ = di().setTimeout(this.monitorBufferTick_.bind(this), qy);
                }, bi.fillBuffer_ = function() {
                  if (!this.sourceUpdater_.updating()) {
                    var ci = this.chooseNextRequest_();
                    ci && (typeof ci.timestampOffset == "number" && (this.isPendingTimestampOffset_ = !1, this.timelineChangeController_.pendingTimelineChange({
                      type: this.loaderType_,
                      from: this.currentTimeline_,
                      to: ci.timeline
                    })), this.loadSegment_(ci));
                  }
                }, bi.isEndOfStream_ = function(ci, hi, wi) {
                  if (ci === void 0 && (ci = this.mediaIndex), hi === void 0 && (hi = this.playlist_), wi === void 0 && (wi = this.partIndex), !hi || !this.mediaSource_)
                    return !1;
                  var zi = typeof ci == "number" && hi.segments[ci], Wo = ci + 1 === hi.segments.length, aa = !zi || !zi.parts || wi + 1 === zi.parts.length;
                  return hi.endList && this.mediaSource_.readyState === "open" && Wo && aa;
                }, bi.chooseNextRequest_ = function() {
                  var ci = this.buffered_(), hi = Qg(ci) || 0, wi = sg(ci, this.currentTime_()), zi = !this.hasPlayed_() && wi >= 1, Wo = wi >= this.goalBufferLength_(), aa = this.playlist_.segments;
                  if (!aa.length || zi || Wo)
                    return null;
                  this.syncPoint_ = this.syncPoint_ || this.syncController_.getSyncPoint(this.playlist_, this.duration_(), this.currentTimeline_, this.currentTime_());
                  var Ea = {
                    partIndex: null,
                    mediaIndex: null,
                    startOfSegment: null,
                    playlist: this.playlist_,
                    isSyncRequest: !this.syncPoint_
                  };
                  if (Ea.isSyncRequest)
                    Ea.mediaIndex = Ky(this.currentTimeline_, aa, hi);
                  else if (this.mediaIndex !== null) {
                    var Ka = aa[this.mediaIndex], Ha = typeof this.partIndex == "number" ? this.partIndex : -1;
                    Ea.startOfSegment = Ka.end ? Ka.end : hi, Ka.parts && Ka.parts[Ha + 1] ? (Ea.mediaIndex = this.mediaIndex, Ea.partIndex = Ha + 1) : Ea.mediaIndex = this.mediaIndex + 1;
                  } else {
                    var ks = Jd.getMediaInfoForTime({
                      experimentalExactManifestTimings: this.experimentalExactManifestTimings,
                      playlist: this.playlist_,
                      currentTime: this.fetchAtBuffer_ ? hi : this.currentTime_(),
                      startingPartIndex: this.syncPoint_.partIndex,
                      startingSegmentIndex: this.syncPoint_.segmentIndex,
                      startTime: this.syncPoint_.time
                    }), gl = ks.segmentIndex, Sl = ks.startTime, Fl = ks.partIndex;
                    Ea.getMediaInfoForTime = this.fetchAtBuffer_ ? "bufferedEnd " + hi : "currentTime " + this.currentTime_(), Ea.mediaIndex = gl, Ea.startOfSegment = Sl, Ea.partIndex = Fl;
                  }
                  var ru = aa[Ea.mediaIndex], $u = ru && typeof Ea.partIndex == "number" && ru.parts && ru.parts[Ea.partIndex];
                  if (!ru || typeof Ea.partIndex == "number" && !$u)
                    return null;
                  if (typeof Ea.partIndex != "number" && ru.parts && (Ea.partIndex = 0, $u = ru.parts[0]), !wi && $u && !$u.independent)
                    if (Ea.partIndex === 0) {
                      var rc = aa[Ea.mediaIndex - 1], Au = rc.parts && rc.parts.length && rc.parts[rc.parts.length - 1];
                      Au && Au.independent && (Ea.mediaIndex -= 1, Ea.partIndex = rc.parts.length - 1, Ea.independent = "previous segment");
                    } else ru.parts[Ea.partIndex - 1].independent && (Ea.partIndex -= 1, Ea.independent = "previous part");
                  var Iu = this.mediaSource_ && this.mediaSource_.readyState === "ended";
                  return Ea.mediaIndex >= aa.length - 1 && Iu && !this.seeking_() ? null : this.generateSegmentInfo_(Ea);
                }, bi.generateSegmentInfo_ = function(ci) {
                  var hi = ci.independent, wi = ci.playlist, zi = ci.mediaIndex, Wo = ci.startOfSegment, aa = ci.isSyncRequest, Ea = ci.partIndex, Ka = ci.forceTimestampOffset, Ha = ci.getMediaInfoForTime, ks = wi.segments[zi], gl = typeof Ea == "number" && ks.parts[Ea], Sl = {
                    requestId: "segment-loader-" + Math.random(),
                    // resolve the segment URL relative to the playlist
                    uri: gl && gl.resolvedUri || ks.resolvedUri,
                    // the segment's mediaIndex at the time it was requested
                    mediaIndex: zi,
                    partIndex: gl ? Ea : null,
                    // whether or not to update the SegmentLoader's state with this
                    // segment's mediaIndex
                    isSyncRequest: aa,
                    startOfSegment: Wo,
                    // the segment's playlist
                    playlist: wi,
                    // unencrypted bytes of the segment
                    bytes: null,
                    // when a key is defined for this segment, the encrypted bytes
                    encryptedBytes: null,
                    // The target timestampOffset for this segment when we append it
                    // to the source buffer
                    timestampOffset: null,
                    // The timeline that the segment is in
                    timeline: ks.timeline,
                    // The expected duration of the segment in seconds
                    duration: gl && gl.duration || ks.duration,
                    // retain the segment in case the playlist updates while doing an async process
                    segment: ks,
                    part: gl,
                    byteLength: 0,
                    transmuxer: this.transmuxer_,
                    // type of getMediaInfoForTime that was used to get this segment
                    getMediaInfoForTime: Ha,
                    independent: hi
                  }, Fl = typeof Ka < "u" ? Ka : this.isPendingTimestampOffset_;
                  Sl.timestampOffset = this.timestampOffsetForSegment_({
                    segmentTimeline: ks.timeline,
                    currentTimeline: this.currentTimeline_,
                    startOfSegment: Wo,
                    buffered: this.buffered_(),
                    overrideCheck: Fl
                  });
                  var ru = Qg(this.sourceUpdater_.audioBuffered());
                  return typeof ru == "number" && (Sl.audioAppendStart = ru - this.sourceUpdater_.audioTimestampOffset()), this.sourceUpdater_.videoBuffered().length && (Sl.gopsToAlignWith = Cv(
                    this.gopBuffer_,
                    // since the transmuxer is using the actual timing values, but the time is
                    // adjusted by the timestmap offset, we must adjust the value here
                    this.currentTime_() - this.sourceUpdater_.videoTimestampOffset(),
                    this.timeMapping_
                  )), Sl;
                }, bi.timestampOffsetForSegment_ = function(ci) {
                  return Nm(ci);
                }, bi.earlyAbortWhenNeeded_ = function(ci) {
                  if (!(this.vhs_.tech_.paused() || // Don't abort if the current playlist is on the lowestEnabledRendition
                  // TODO: Replace using timeout with a boolean indicating whether this playlist is
                  //       the lowestEnabledRendition.
                  !this.xhrOptions_.timeout || // Don't abort if we have no bandwidth information to estimate segment sizes
                  !this.playlist_.attributes.BANDWIDTH) && !(Date.now() - (ci.firstBytesReceivedAt || Date.now()) < 1e3)) {
                    var hi = this.currentTime_(), wi = ci.bandwidth, zi = this.pendingSegment_.duration, Wo = Jd.estimateSegmentRequestTime(zi, wi, this.playlist_, ci.bytesReceived), aa = hf(this.buffered_(), hi, this.vhs_.tech_.playbackRate()) - 1;
                    if (!(Wo <= aa)) {
                      var Ea = Uy({
                        master: this.vhs_.playlists.master,
                        currentTime: hi,
                        bandwidth: wi,
                        duration: this.duration_(),
                        segmentDuration: zi,
                        timeUntilRebuffer: aa,
                        currentTimeline: this.currentTimeline_,
                        syncController: this.syncController_
                      });
                      if (Ea) {
                        var Ka = Wo - aa, Ha = Ka - Ea.rebufferingImpact, ks = 0.5;
                        aa <= Xf && (ks = 1), !(!Ea.playlist || Ea.playlist.uri === this.playlist_.uri || Ha < ks) && (this.bandwidth = Ea.playlist.attributes.BANDWIDTH * bd.BANDWIDTH_VARIANCE + 1, this.trigger("earlyabort"));
                      }
                    }
                  }
                }, bi.handleAbort_ = function(ci) {
                  this.logger_("Aborting " + pp(ci)), this.mediaRequestsAborted += 1;
                }, bi.handleProgress_ = function(ci, hi) {
                  this.earlyAbortWhenNeeded_(hi.stats), !this.checkForAbort_(hi.requestId) && this.trigger("progress");
                }, bi.handleTrackInfo_ = function(ci, hi) {
                  this.earlyAbortWhenNeeded_(ci.stats), !this.checkForAbort_(ci.requestId) && (this.checkForIllegalMediaSwitch(hi) || (hi = hi || {}, Ov(this.currentMediaInfo_, hi) || (this.appendInitSegment_ = {
                    audio: !0,
                    video: !0
                  }, this.startingMediaInfo_ = hi, this.currentMediaInfo_ = hi, this.logger_("trackinfo update", hi), this.trigger("trackinfo")), !this.checkForAbort_(ci.requestId) && (this.pendingSegment_.trackInfo = hi, this.hasEnoughInfoToAppend_() && this.processCallQueue_())));
                }, bi.handleTimingInfo_ = function(ci, hi, wi, zi) {
                  if (this.earlyAbortWhenNeeded_(ci.stats), !this.checkForAbort_(ci.requestId)) {
                    var Wo = this.pendingSegment_, aa = $v(hi);
                    Wo[aa] = Wo[aa] || {}, Wo[aa][wi] = zi, this.logger_("timinginfo: " + hi + " - " + wi + " - " + zi), this.hasEnoughInfoToAppend_() && this.processCallQueue_();
                  }
                }, bi.handleCaptions_ = function(ci, hi) {
                  var wi = this;
                  if (this.earlyAbortWhenNeeded_(ci.stats), !this.checkForAbort_(ci.requestId)) {
                    if (hi.length === 0) {
                      this.logger_("SegmentLoader received no captions from a caption event");
                      return;
                    }
                    var zi = this.pendingSegment_;
                    if (!zi.hasAppendedData_) {
                      this.metadataQueue_.caption.push(this.handleCaptions_.bind(this, ci, hi));
                      return;
                    }
                    var Wo = this.sourceUpdater_.videoTimestampOffset() === null ? this.sourceUpdater_.audioTimestampOffset() : this.sourceUpdater_.videoTimestampOffset(), aa = {};
                    hi.forEach(function(Ea) {
                      aa[Ea.stream] = aa[Ea.stream] || {
                        // Infinity, as any other value will be less than this
                        startTime: 1 / 0,
                        captions: [],
                        // 0 as an other value will be more than this
                        endTime: 0
                      };
                      var Ka = aa[Ea.stream];
                      Ka.startTime = Math.min(Ka.startTime, Ea.startTime + Wo), Ka.endTime = Math.max(Ka.endTime, Ea.endTime + Wo), Ka.captions.push(Ea);
                    }), Object.keys(aa).forEach(function(Ea) {
                      var Ka = aa[Ea], Ha = Ka.startTime, ks = Ka.endTime, gl = Ka.captions, Sl = wi.inbandTextTracks_;
                      wi.logger_("adding cues from " + Ha + " -> " + ks + " for " + Ea), Pv(Sl, wi.vhs_.tech_, Ea), fg(Ha, ks, Sl[Ea]), Wy({
                        captionArray: gl,
                        inbandTextTracks: Sl,
                        timestampOffset: Wo
                      });
                    }), this.transmuxer_ && this.transmuxer_.postMessage({
                      action: "clearParsedMp4Captions"
                    });
                  }
                }, bi.handleId3_ = function(ci, hi, wi) {
                  if (this.earlyAbortWhenNeeded_(ci.stats), !this.checkForAbort_(ci.requestId)) {
                    var zi = this.pendingSegment_;
                    if (!zi.hasAppendedData_) {
                      this.metadataQueue_.id3.push(this.handleId3_.bind(this, ci, hi, wi));
                      return;
                    }
                    var Wo = this.sourceUpdater_.videoTimestampOffset() === null ? this.sourceUpdater_.audioTimestampOffset() : this.sourceUpdater_.videoTimestampOffset();
                    zy(this.inbandTextTracks_, wi, this.vhs_.tech_), Hy({
                      inbandTextTracks: this.inbandTextTracks_,
                      metadataArray: hi,
                      timestampOffset: Wo,
                      videoDuration: this.duration_()
                    });
                  }
                }, bi.processMetadataQueue_ = function() {
                  this.metadataQueue_.id3.forEach(function(ci) {
                    return ci();
                  }), this.metadataQueue_.caption.forEach(function(ci) {
                    return ci();
                  }), this.metadataQueue_.id3 = [], this.metadataQueue_.caption = [];
                }, bi.processCallQueue_ = function() {
                  var ci = this.callQueue_;
                  this.callQueue_ = [], ci.forEach(function(hi) {
                    return hi();
                  });
                }, bi.processLoadQueue_ = function() {
                  var ci = this.loadQueue_;
                  this.loadQueue_ = [], ci.forEach(function(hi) {
                    return hi();
                  });
                }, bi.hasEnoughInfoToLoad_ = function() {
                  if (this.loaderType_ !== "audio")
                    return !0;
                  var ci = this.pendingSegment_;
                  return ci ? this.getCurrentMediaInfo_() ? (
                    // Technically, instead of waiting to load a segment on timeline changes, a segment
                    // can be requested and downloaded and only wait before it is transmuxed or parsed.
                    // But in practice, there are a few reasons why it is better to wait until a loader
                    // is ready to append that segment before requesting and downloading:
                    //
                    // 1. Because audio and main loaders cross discontinuities together, if this loader
                    //    is waiting for the other to catch up, then instead of requesting another
                    //    segment and using up more bandwidth, by not yet loading, more bandwidth is
                    //    allotted to the loader currently behind.
                    // 2. media-segment-request doesn't have to have logic to consider whether a segment
                    // is ready to be processed or not, isolating the queueing behavior to the loader.
                    // 3. The audio loader bases some of its segment properties on timing information
                    //    provided by the main loader, meaning that, if the logic for waiting on
                    //    processing was in media-segment-request, then it would also need to know how
                    //    to re-generate the segment information after the main loader caught up.
                    !sh({
                      timelineChangeController: this.timelineChangeController_,
                      currentTimeline: this.currentTimeline_,
                      segmentTimeline: ci.timeline,
                      loaderType: this.loaderType_,
                      audioDisabled: this.audioDisabled_
                    })
                  ) : !0 : !1;
                }, bi.getCurrentMediaInfo_ = function(ci) {
                  return ci === void 0 && (ci = this.pendingSegment_), ci && ci.trackInfo || this.currentMediaInfo_;
                }, bi.getMediaInfo_ = function(ci) {
                  return ci === void 0 && (ci = this.pendingSegment_), this.getCurrentMediaInfo_(ci) || this.startingMediaInfo_;
                }, bi.getPendingSegmentPlaylist = function() {
                  return this.pendingSegment_ ? this.pendingSegment_.playlist : null;
                }, bi.hasEnoughInfoToAppend_ = function() {
                  if (!this.sourceUpdater_.ready() || this.waitingOnRemove_ || this.quotaExceededErrorRetryTimeout_)
                    return !1;
                  var ci = this.pendingSegment_, hi = this.getCurrentMediaInfo_();
                  if (!ci || !hi)
                    return !1;
                  var wi = hi.hasAudio, zi = hi.hasVideo, Wo = hi.isMuxed;
                  return !(zi && !ci.videoTimingInfo || wi && !this.audioDisabled_ && !Wo && !ci.audioTimingInfo || sh({
                    timelineChangeController: this.timelineChangeController_,
                    currentTimeline: this.currentTimeline_,
                    segmentTimeline: ci.timeline,
                    loaderType: this.loaderType_,
                    audioDisabled: this.audioDisabled_
                  }));
                }, bi.handleData_ = function(ci, hi) {
                  if (this.earlyAbortWhenNeeded_(ci.stats), !this.checkForAbort_(ci.requestId)) {
                    if (this.callQueue_.length || !this.hasEnoughInfoToAppend_()) {
                      this.callQueue_.push(this.handleData_.bind(this, ci, hi));
                      return;
                    }
                    var wi = this.pendingSegment_;
                    if (this.setTimeMapping_(wi.timeline), this.updateMediaSecondsLoaded_(wi.part || wi.segment), this.mediaSource_.readyState !== "closed") {
                      if (ci.map && (ci.map = this.initSegmentForMap(ci.map, !0), wi.segment.map = ci.map), ci.key && this.segmentKey(ci.key, !0), wi.isFmp4 = ci.isFmp4, wi.timingInfo = wi.timingInfo || {}, wi.isFmp4)
                        this.trigger("fmp4"), wi.timingInfo.start = wi[$v(hi.type)].start;
                      else {
                        var zi = this.getCurrentMediaInfo_(), Wo = this.loaderType_ === "main" && zi && zi.hasVideo, aa;
                        Wo && (aa = wi.videoTimingInfo.start), wi.timingInfo.start = this.trueSegmentStart_({
                          currentStart: wi.timingInfo.start,
                          playlist: wi.playlist,
                          mediaIndex: wi.mediaIndex,
                          currentVideoTimestampOffset: this.sourceUpdater_.videoTimestampOffset(),
                          useVideoTimingInfo: Wo,
                          firstVideoFrameTimeForData: aa,
                          videoTimingInfo: wi.videoTimingInfo,
                          audioTimingInfo: wi.audioTimingInfo
                        });
                      }
                      if (this.updateAppendInitSegmentStatus(wi, hi.type), this.updateSourceBufferTimestampOffset_(wi), wi.isSyncRequest) {
                        this.updateTimingInfoEnd_(wi), this.syncController_.saveSegmentTimingInfo({
                          segmentInfo: wi,
                          shouldSaveTimelineMapping: this.loaderType_ === "main"
                        });
                        var Ea = this.chooseNextRequest_();
                        if (Ea.mediaIndex !== wi.mediaIndex || Ea.partIndex !== wi.partIndex) {
                          this.logger_("sync segment was incorrect, not appending");
                          return;
                        }
                        this.logger_("sync segment was correct, appending");
                      }
                      wi.hasAppendedData_ = !0, this.processMetadataQueue_(), this.appendData_(wi, hi);
                    }
                  }
                }, bi.updateAppendInitSegmentStatus = function(ci, hi) {
                  this.loaderType_ === "main" && typeof ci.timestampOffset == "number" && // in the case that we're handling partial data, we don't want to append an init
                  // segment for each chunk
                  !ci.changedTimestampOffset && (this.appendInitSegment_ = {
                    audio: !0,
                    video: !0
                  }), this.playlistOfLastInitSegment_[hi] !== ci.playlist && (this.appendInitSegment_[hi] = !0);
                }, bi.getInitSegmentAndUpdateState_ = function(ci) {
                  var hi = ci.type, wi = ci.initSegment, zi = ci.map, Wo = ci.playlist;
                  if (zi) {
                    var aa = Ng(zi);
                    if (this.activeInitSegmentId_ === aa)
                      return null;
                    wi = this.initSegmentForMap(zi, !0).bytes, this.activeInitSegmentId_ = aa;
                  }
                  return wi && this.appendInitSegment_[hi] ? (this.playlistOfLastInitSegment_[hi] = Wo, this.appendInitSegment_[hi] = !1, this.activeInitSegmentId_ = null, wi) : null;
                }, bi.handleQuotaExceededError_ = function(ci, hi) {
                  var wi = this, zi = ci.segmentInfo, Wo = ci.type, aa = ci.bytes, Ea = this.sourceUpdater_.audioBuffered(), Ka = this.sourceUpdater_.videoBuffered();
                  Ea.length > 1 && this.logger_("On QUOTA_EXCEEDED_ERR, found gaps in the audio buffer: " + Nd(Ea).join(", ")), Ka.length > 1 && this.logger_("On QUOTA_EXCEEDED_ERR, found gaps in the video buffer: " + Nd(Ka).join(", "));
                  var Ha = Ea.length ? Ea.start(0) : 0, ks = Ea.length ? Ea.end(Ea.length - 1) : 0, gl = Ka.length ? Ka.start(0) : 0, Sl = Ka.length ? Ka.end(Ka.length - 1) : 0;
                  if (ks - Ha <= Gh && Sl - gl <= Gh) {
                    this.logger_("On QUOTA_EXCEEDED_ERR, single segment too large to append to buffer, triggering an error. " + ("Appended byte length: " + aa.byteLength + ", ") + ("audio buffer: " + Nd(Ea).join(", ") + ", ") + ("video buffer: " + Nd(Ka).join(", ") + ", ")), this.error({
                      message: "Quota exceeded error with append of a single segment of content",
                      excludeUntil: 1 / 0
                    }), this.trigger("error");
                    return;
                  }
                  this.waitingOnRemove_ = !0, this.callQueue_.push(this.appendToSourceBuffer_.bind(this, {
                    segmentInfo: zi,
                    type: Wo,
                    bytes: aa
                  }));
                  var Fl = this.currentTime_(), ru = Fl - Gh;
                  this.logger_("On QUOTA_EXCEEDED_ERR, removing audio/video from 0 to " + ru), this.remove(0, ru, function() {
                    wi.logger_("On QUOTA_EXCEEDED_ERR, retrying append in " + Gh + "s"), wi.waitingOnRemove_ = !1, wi.quotaExceededErrorRetryTimeout_ = di().setTimeout(function() {
                      wi.logger_("On QUOTA_EXCEEDED_ERR, re-processing call queue"), wi.quotaExceededErrorRetryTimeout_ = null, wi.processCallQueue_();
                    }, Gh * 1e3);
                  }, !0);
                }, bi.handleAppendError_ = function(ci, hi) {
                  var wi = ci.segmentInfo, zi = ci.type, Wo = ci.bytes;
                  if (hi) {
                    if (hi.code === Wh) {
                      this.handleQuotaExceededError_({
                        segmentInfo: wi,
                        type: zi,
                        bytes: Wo
                      });
                      return;
                    }
                    this.logger_("Received non QUOTA_EXCEEDED_ERR on append", hi), this.error(zi + " append of " + Wo.length + "b failed for segment " + ("#" + wi.mediaIndex + " in playlist " + wi.playlist.id)), this.trigger("appenderror");
                  }
                }, bi.appendToSourceBuffer_ = function(ci) {
                  var hi = ci.segmentInfo, wi = ci.type, zi = ci.initSegment, Wo = ci.data, aa = ci.bytes;
                  if (!aa) {
                    var Ea = [Wo], Ka = Wo.byteLength;
                    zi && (Ea.unshift(zi), Ka += zi.byteLength), aa = Vy({
                      bytes: Ka,
                      segments: Ea
                    });
                  }
                  this.sourceUpdater_.appendBuffer({
                    segmentInfo: hi,
                    type: wi,
                    bytes: aa
                  }, this.handleAppendError_.bind(this, {
                    segmentInfo: hi,
                    type: wi,
                    bytes: aa
                  }));
                }, bi.handleSegmentTimingInfo_ = function(ci, hi, wi) {
                  if (!(!this.pendingSegment_ || hi !== this.pendingSegment_.requestId)) {
                    var zi = this.pendingSegment_.segment, Wo = ci + "TimingInfo";
                    zi[Wo] || (zi[Wo] = {}), zi[Wo].transmuxerPrependedSeconds = wi.prependedContentDuration || 0, zi[Wo].transmuxedPresentationStart = wi.start.presentation, zi[Wo].transmuxedDecodeStart = wi.start.decode, zi[Wo].transmuxedPresentationEnd = wi.end.presentation, zi[Wo].transmuxedDecodeEnd = wi.end.decode, zi[Wo].baseMediaDecodeTime = wi.baseMediaDecodeTime;
                  }
                }, bi.appendData_ = function(ci, hi) {
                  var wi = hi.type, zi = hi.data;
                  if (!(!zi || !zi.byteLength) && !(wi === "audio" && this.audioDisabled_)) {
                    var Wo = this.getInitSegmentAndUpdateState_({
                      type: wi,
                      initSegment: hi.initSegment,
                      playlist: ci.playlist,
                      map: ci.isFmp4 ? ci.segment.map : null
                    });
                    this.appendToSourceBuffer_({
                      segmentInfo: ci,
                      type: wi,
                      initSegment: Wo,
                      data: zi
                    });
                  }
                }, bi.loadSegment_ = function(ci) {
                  var hi = this;
                  if (this.state = "WAITING", this.pendingSegment_ = ci, this.trimBackBuffer_(ci), typeof ci.timestampOffset == "number" && this.transmuxer_ && this.transmuxer_.postMessage({
                    action: "clearAllMp4Captions"
                  }), !this.hasEnoughInfoToLoad_()) {
                    this.loadQueue_.push(function() {
                      var wi = (0, mi.default)({}, ci, {
                        forceTimestampOffset: !0
                      });
                      (0, mi.default)(ci, hi.generateSegmentInfo_(wi)), hi.isPendingTimestampOffset_ = !1, hi.updateTransmuxerAndRequestSegment_(ci);
                    });
                    return;
                  }
                  this.updateTransmuxerAndRequestSegment_(ci);
                }, bi.updateTransmuxerAndRequestSegment_ = function(ci) {
                  var hi = this;
                  this.shouldUpdateTransmuxerTimestampOffset_(ci.timestampOffset) && (this.gopBuffer_.length = 0, ci.gopsToAlignWith = [], this.timeMapping_ = 0, this.transmuxer_.postMessage({
                    action: "reset"
                  }), this.transmuxer_.postMessage({
                    action: "setTimestampOffset",
                    timestampOffset: ci.timestampOffset
                  }));
                  var wi = this.createSimplifiedSegmentObj_(ci), zi = this.isEndOfStream_(ci.mediaIndex, ci.playlist, ci.partIndex), Wo = this.mediaIndex !== null, aa = ci.timeline !== this.currentTimeline_ && // currentTimeline starts at -1, so we shouldn't end the timeline switching to 0,
                  // the first timeline
                  ci.timeline > 0, Ea = zi || Wo && aa;
                  this.logger_("Requesting " + pp(ci)), wi.map && !wi.map.bytes && (this.logger_("going to request init segment."), this.appendInitSegment_ = {
                    video: !0,
                    audio: !0
                  }), ci.abortRequests = Sv({
                    xhr: this.vhs_.xhr,
                    xhrOptions: this.xhrOptions_,
                    decryptionWorker: this.decrypter_,
                    segment: wi,
                    abortFn: this.handleAbort_.bind(this, ci),
                    progressFn: this.handleProgress_.bind(this),
                    trackInfoFn: this.handleTrackInfo_.bind(this),
                    timingInfoFn: this.handleTimingInfo_.bind(this),
                    videoSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, "video", ci.requestId),
                    audioSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, "audio", ci.requestId),
                    captionsFn: this.handleCaptions_.bind(this),
                    isEndOfTimeline: Ea,
                    endedTimelineFn: function() {
                      hi.logger_("received endedtimeline callback");
                    },
                    id3Fn: this.handleId3_.bind(this),
                    dataFn: this.handleData_.bind(this),
                    doneFn: this.segmentRequestFinished_.bind(this),
                    onTransmuxerLog: function(Ha) {
                      var ks = Ha.message, gl = Ha.level, Sl = Ha.stream;
                      hi.logger_(pp(ci) + " logged from transmuxer stream " + Sl + " as a " + gl + ": " + ks);
                    }
                  });
                }, bi.trimBackBuffer_ = function(ci) {
                  var hi = Iv(this.seekable_(), this.currentTime_(), this.playlist_.targetDuration || 10);
                  hi > 0 && this.remove(0, hi);
                }, bi.createSimplifiedSegmentObj_ = function(ci) {
                  var hi = ci.segment, wi = ci.part, zi = {
                    resolvedUri: wi ? wi.resolvedUri : hi.resolvedUri,
                    byterange: wi ? wi.byterange : hi.byterange,
                    requestId: ci.requestId,
                    transmuxer: ci.transmuxer,
                    audioAppendStart: ci.audioAppendStart,
                    gopsToAlignWith: ci.gopsToAlignWith,
                    part: ci.part
                  }, Wo = ci.playlist.segments[ci.mediaIndex - 1];
                  if (Wo && Wo.timeline === hi.timeline && (Wo.videoTimingInfo ? zi.baseStartTime = Wo.videoTimingInfo.transmuxedDecodeEnd : Wo.audioTimingInfo && (zi.baseStartTime = Wo.audioTimingInfo.transmuxedDecodeEnd)), hi.key) {
                    var aa = hi.key.iv || new Uint32Array([0, 0, 0, ci.mediaIndex + ci.playlist.mediaSequence]);
                    zi.key = this.segmentKey(hi.key), zi.key.iv = aa;
                  }
                  return hi.map && (zi.map = this.initSegmentForMap(hi.map)), zi;
                }, bi.saveTransferStats_ = function(ci) {
                  this.mediaRequests += 1, ci && (this.mediaBytesTransferred += ci.bytesReceived, this.mediaTransferDuration += ci.roundTripTime);
                }, bi.saveBandwidthRelatedStats_ = function(ci, hi) {
                  if (this.pendingSegment_.byteLength = hi.bytesReceived, ci < pg) {
                    this.logger_("Ignoring segment's bandwidth because its duration of " + ci + (" is less than the min to record " + pg));
                    return;
                  }
                  this.bandwidth = hi.bandwidth, this.roundTrip = hi.roundTripTime;
                }, bi.handleTimeout_ = function() {
                  this.mediaRequestsTimedout += 1, this.bandwidth = 1, this.roundTrip = NaN, this.trigger("bandwidthupdate"), this.trigger("timeout");
                }, bi.segmentRequestFinished_ = function(ci, hi, wi) {
                  if (this.callQueue_.length) {
                    this.callQueue_.push(this.segmentRequestFinished_.bind(this, ci, hi, wi));
                    return;
                  }
                  if (this.saveTransferStats_(hi.stats), !!this.pendingSegment_ && hi.requestId === this.pendingSegment_.requestId) {
                    if (ci) {
                      if (this.pendingSegment_ = null, this.state = "READY", ci.code === mf.ABORTED)
                        return;
                      if (this.pause(), ci.code === mf.TIMEOUT) {
                        this.handleTimeout_();
                        return;
                      }
                      this.mediaRequestsErrored += 1, this.error(ci), this.trigger("error");
                      return;
                    }
                    var zi = this.pendingSegment_;
                    this.saveBandwidthRelatedStats_(zi.duration, hi.stats), zi.endOfAllRequests = hi.endOfAllRequests, wi.gopInfo && (this.gopBuffer_ = Rv(this.gopBuffer_, wi.gopInfo, this.safeAppend_)), this.state = "APPENDING", this.trigger("appending"), this.waitForAppendsToComplete_(zi);
                  }
                }, bi.setTimeMapping_ = function(ci) {
                  var hi = this.syncController_.mappingForTimeline(ci);
                  hi !== null && (this.timeMapping_ = hi);
                }, bi.updateMediaSecondsLoaded_ = function(ci) {
                  typeof ci.start == "number" && typeof ci.end == "number" ? this.mediaSecondsLoaded += ci.end - ci.start : this.mediaSecondsLoaded += ci.duration;
                }, bi.shouldUpdateTransmuxerTimestampOffset_ = function(ci) {
                  return ci === null ? !1 : this.loaderType_ === "main" && ci !== this.sourceUpdater_.videoTimestampOffset() || !this.audioDisabled_ && ci !== this.sourceUpdater_.audioTimestampOffset();
                }, bi.trueSegmentStart_ = function(ci) {
                  var hi = ci.currentStart, wi = ci.playlist, zi = ci.mediaIndex, Wo = ci.firstVideoFrameTimeForData, aa = ci.currentVideoTimestampOffset, Ea = ci.useVideoTimingInfo, Ka = ci.videoTimingInfo, Ha = ci.audioTimingInfo;
                  if (typeof hi < "u")
                    return hi;
                  if (!Ea)
                    return Ha.start;
                  var ks = wi.segments[zi - 1];
                  return zi === 0 || !ks || typeof ks.start > "u" || ks.end !== Wo + aa ? Wo : Ka.start;
                }, bi.waitForAppendsToComplete_ = function(ci) {
                  var hi = this.getCurrentMediaInfo_(ci);
                  if (!hi) {
                    this.error({
                      message: "No starting media returned, likely due to an unsupported media format.",
                      blacklistDuration: 1 / 0
                    }), this.trigger("error");
                    return;
                  }
                  var wi = hi.hasAudio, zi = hi.hasVideo, Wo = hi.isMuxed, aa = this.loaderType_ === "main" && zi, Ea = !this.audioDisabled_ && wi && !Wo;
                  if (ci.waitingOnAppends = 0, !ci.hasAppendedData_) {
                    !ci.timingInfo && typeof ci.timestampOffset == "number" && (this.isPendingTimestampOffset_ = !0), ci.timingInfo = {
                      start: 0
                    }, ci.waitingOnAppends++, this.isPendingTimestampOffset_ || (this.updateSourceBufferTimestampOffset_(ci), this.processMetadataQueue_()), this.checkAppendsDone_(ci);
                    return;
                  }
                  aa && ci.waitingOnAppends++, Ea && ci.waitingOnAppends++, aa && this.sourceUpdater_.videoQueueCallback(this.checkAppendsDone_.bind(this, ci)), Ea && this.sourceUpdater_.audioQueueCallback(this.checkAppendsDone_.bind(this, ci));
                }, bi.checkAppendsDone_ = function(ci) {
                  this.checkForAbort_(ci.requestId) || (ci.waitingOnAppends--, ci.waitingOnAppends === 0 && this.handleAppendsDone_());
                }, bi.checkForIllegalMediaSwitch = function(ci) {
                  var hi = Yy(this.loaderType_, this.getCurrentMediaInfo_(), ci);
                  return hi ? (this.error({
                    message: hi,
                    blacklistDuration: 1 / 0
                  }), this.trigger("error"), !0) : !1;
                }, bi.updateSourceBufferTimestampOffset_ = function(ci) {
                  if (!(ci.timestampOffset === null || // we don't yet have the start for whatever media type (video or audio) has
                  // priority, timing-wise, so we must wait
                  typeof ci.timingInfo.start != "number" || // already updated the timestamp offset for this segment
                  ci.changedTimestampOffset || // the alt audio loader should not be responsible for setting the timestamp offset
                  this.loaderType_ !== "main")) {
                    var hi = !1;
                    ci.timestampOffset -= this.getSegmentStartTimeForTimestampOffsetCalculation_({
                      videoTimingInfo: ci.segment.videoTimingInfo,
                      audioTimingInfo: ci.segment.audioTimingInfo,
                      timingInfo: ci.timingInfo
                    }), ci.changedTimestampOffset = !0, ci.timestampOffset !== this.sourceUpdater_.videoTimestampOffset() && (this.sourceUpdater_.videoTimestampOffset(ci.timestampOffset), hi = !0), ci.timestampOffset !== this.sourceUpdater_.audioTimestampOffset() && (this.sourceUpdater_.audioTimestampOffset(ci.timestampOffset), hi = !0), hi && this.trigger("timestampoffset");
                  }
                }, bi.getSegmentStartTimeForTimestampOffsetCalculation_ = function(ci) {
                  var hi = ci.videoTimingInfo, wi = ci.audioTimingInfo, zi = ci.timingInfo;
                  return this.useDtsForTimestampOffset_ ? hi && typeof hi.transmuxedDecodeStart == "number" ? hi.transmuxedDecodeStart : wi && typeof wi.transmuxedDecodeStart == "number" ? wi.transmuxedDecodeStart : zi.start : zi.start;
                }, bi.updateTimingInfoEnd_ = function(ci) {
                  ci.timingInfo = ci.timingInfo || {};
                  var hi = this.getMediaInfo_(), wi = this.loaderType_ === "main" && hi && hi.hasVideo, zi = wi && ci.videoTimingInfo ? ci.videoTimingInfo : ci.audioTimingInfo;
                  zi && (ci.timingInfo.end = typeof zi.end == "number" ? (
                    // End time may not exist in a case where we aren't parsing the full segment (one
                    // current example is the case of fmp4), so use the rough duration to calculate an
                    // end time.
                    zi.end
                  ) : zi.start + ci.duration);
                }, bi.handleAppendsDone_ = function() {
                  if (this.pendingSegment_ && this.trigger("appendsdone"), !this.pendingSegment_) {
                    this.state = "READY", this.paused() || this.monitorBuffer_();
                    return;
                  }
                  var ci = this.pendingSegment_;
                  this.updateTimingInfoEnd_(ci), this.shouldSaveSegmentTimingInfo_ && this.syncController_.saveSegmentTimingInfo({
                    segmentInfo: ci,
                    shouldSaveTimelineMapping: this.loaderType_ === "main"
                  });
                  var hi = Xy(ci, this.sourceType_);
                  if (hi && (hi.severity === "warn" ? Rl.log.warn(hi.message) : this.logger_(hi.message)), this.recordThroughput_(ci), this.pendingSegment_ = null, this.state = "READY", ci.isSyncRequest && (this.trigger("syncinfoupdate"), !ci.hasAppendedData_)) {
                    this.logger_("Throwing away un-appended sync request " + pp(ci));
                    return;
                  }
                  this.logger_("Appended " + pp(ci)), this.addSegmentMetadataCue_(ci), this.fetchAtBuffer_ = !0, this.currentTimeline_ !== ci.timeline && (this.timelineChangeController_.lastTimelineChange({
                    type: this.loaderType_,
                    from: this.currentTimeline_,
                    to: ci.timeline
                  }), this.loaderType_ === "main" && !this.audioDisabled_ && this.timelineChangeController_.lastTimelineChange({
                    type: "audio",
                    from: this.currentTimeline_,
                    to: ci.timeline
                  })), this.currentTimeline_ = ci.timeline, this.trigger("syncinfoupdate");
                  var wi = ci.segment, zi = ci.part, Wo = wi.end && this.currentTime_() - wi.end > ci.playlist.targetDuration * 3, aa = zi && zi.end && this.currentTime_() - zi.end > ci.playlist.partTargetDuration * 3;
                  if (Wo || aa) {
                    this.logger_("bad " + (Wo ? "segment" : "part") + " " + pp(ci)), this.resetEverything();
                    return;
                  }
                  var Ea = this.mediaIndex !== null;
                  Ea && this.trigger("bandwidthupdate"), this.trigger("progress"), this.mediaIndex = ci.mediaIndex, this.partIndex = ci.partIndex, this.isEndOfStream_(ci.mediaIndex, ci.playlist, ci.partIndex) && this.endOfStream(), this.trigger("appended"), ci.hasAppendedData_ && this.mediaAppends++, this.paused() || this.monitorBuffer_();
                }, bi.recordThroughput_ = function(ci) {
                  if (ci.duration < pg) {
                    this.logger_("Ignoring segment's throughput because its duration of " + ci.duration + (" is less than the min to record " + pg));
                    return;
                  }
                  var hi = this.throughput.rate, wi = Date.now() - ci.endOfAllRequests + 1, zi = Math.floor(ci.byteLength / wi * 8 * 1e3);
                  this.throughput.rate += (zi - hi) / ++this.throughput.count;
                }, bi.addSegmentMetadataCue_ = function(ci) {
                  if (this.segmentMetadataTrack_) {
                    var hi = ci.segment, wi = hi.start, zi = hi.end;
                    if (!(!Av(wi) || !Av(zi))) {
                      fg(wi, zi, this.segmentMetadataTrack_);
                      var Wo = di().WebKitDataCue || di().VTTCue, aa = {
                        custom: hi.custom,
                        dateTimeObject: hi.dateTimeObject,
                        dateTimeString: hi.dateTimeString,
                        bandwidth: ci.playlist.attributes.BANDWIDTH,
                        resolution: ci.playlist.attributes.RESOLUTION,
                        codecs: ci.playlist.attributes.CODECS,
                        byteLength: ci.byteLength,
                        uri: ci.uri,
                        timeline: ci.timeline,
                        playlist: ci.playlist.id,
                        start: wi,
                        end: zi
                      }, Ea = JSON.stringify(aa), Ka = new Wo(wi, zi, Ea);
                      Ka.value = aa, this.segmentMetadataTrack_.addCue(Ka);
                    }
                  }
                }, Ei;
              })(Rl.EventTarget);
              function hp() {
              }
              var Nv = function(Ei) {
                return typeof Ei != "string" ? Ei : Ei.replace(/./, function(bi) {
                  return bi.toUpperCase();
                });
              }, Jy = ["video", "audio"], Lm = function(Ei, bi) {
                var yi = bi[Ei + "Buffer"];
                return yi && yi.updating || bi.queuePending[Ei];
              }, Qy = function(Ei, bi) {
                for (var yi = 0; yi < bi.length; yi++) {
                  var ci = bi[yi];
                  if (ci.type === "mediaSource")
                    return null;
                  if (ci.type === Ei)
                    return yi;
                }
                return null;
              }, Ai = function Vi(Ei, bi) {
                if (bi.queue.length !== 0) {
                  var yi = 0, ci = bi.queue[yi];
                  if (ci.type === "mediaSource") {
                    !bi.updating() && bi.mediaSource.readyState !== "closed" && (bi.queue.shift(), ci.action(bi), ci.doneFn && ci.doneFn(), Vi("audio", bi), Vi("video", bi));
                    return;
                  }
                  if (Ei !== "mediaSource" && !(!bi.ready() || bi.mediaSource.readyState === "closed" || Lm(Ei, bi))) {
                    if (ci.type !== Ei) {
                      if (yi = Qy(Ei, bi.queue), yi === null)
                        return;
                      ci = bi.queue[yi];
                    }
                    if (bi.queue.splice(yi, 1), bi.queuePending[Ei] = ci, ci.action(Ei, bi), !ci.doneFn) {
                      bi.queuePending[Ei] = null, Vi(Ei, bi);
                      return;
                    }
                  }
                }
              }, _i = function(Ei, bi) {
                var yi = bi[Ei + "Buffer"], ci = Nv(Ei);
                yi && (yi.removeEventListener("updateend", bi["on" + ci + "UpdateEnd_"]), yi.removeEventListener("error", bi["on" + ci + "Error_"]), bi.codecs[Ei] = null, bi[Ei + "Buffer"] = null);
              }, Po = function(Ei, bi) {
                return Ei && bi && Array.prototype.indexOf.call(Ei.sourceBuffers, bi) !== -1;
              }, Gi = {
                appendBuffer: function(Ei, bi, yi) {
                  return function(ci, hi) {
                    var wi = hi[ci + "Buffer"];
                    if (Po(hi.mediaSource, wi)) {
                      hi.logger_("Appending segment " + bi.mediaIndex + "'s " + Ei.length + " bytes to " + ci + "Buffer");
                      try {
                        wi.appendBuffer(Ei);
                      } catch (zi) {
                        hi.logger_("Error with code " + zi.code + " " + (zi.code === Wh ? "(QUOTA_EXCEEDED_ERR) " : "") + ("when appending segment " + bi.mediaIndex + " to " + ci + "Buffer")), hi.queuePending[ci] = null, yi(zi);
                      }
                    }
                  };
                },
                remove: function(Ei, bi) {
                  return function(yi, ci) {
                    var hi = ci[yi + "Buffer"];
                    if (Po(ci.mediaSource, hi)) {
                      ci.logger_("Removing " + Ei + " to " + bi + " from " + yi + "Buffer");
                      try {
                        hi.remove(Ei, bi);
                      } catch {
                        ci.logger_("Remove " + Ei + " to " + bi + " from " + yi + "Buffer failed");
                      }
                    }
                  };
                },
                timestampOffset: function(Ei) {
                  return function(bi, yi) {
                    var ci = yi[bi + "Buffer"];
                    Po(yi.mediaSource, ci) && (yi.logger_("Setting " + bi + "timestampOffset to " + Ei), ci.timestampOffset = Ei);
                  };
                },
                callback: function(Ei) {
                  return function(bi, yi) {
                    Ei();
                  };
                },
                endOfStream: function(Ei) {
                  return function(bi) {
                    if (bi.mediaSource.readyState === "open") {
                      bi.logger_("Calling mediaSource endOfStream(" + (Ei || "") + ")");
                      try {
                        bi.mediaSource.endOfStream(Ei);
                      } catch (yi) {
                        Rl.log.warn("Failed to call media source endOfStream", yi);
                      }
                    }
                  };
                },
                duration: function(Ei) {
                  return function(bi) {
                    bi.logger_("Setting mediaSource duration to " + Ei);
                    try {
                      bi.mediaSource.duration = Ei;
                    } catch (yi) {
                      Rl.log.warn("Failed to set media source duration", yi);
                    }
                  };
                },
                abort: function() {
                  return function(Ei, bi) {
                    if (bi.mediaSource.readyState === "open") {
                      var yi = bi[Ei + "Buffer"];
                      if (Po(bi.mediaSource, yi)) {
                        bi.logger_("calling abort on " + Ei + "Buffer");
                        try {
                          yi.abort();
                        } catch (ci) {
                          Rl.log.warn("Failed to abort on " + Ei + "Buffer", ci);
                        }
                      }
                    }
                  };
                },
                addSourceBuffer: function(Ei, bi) {
                  return function(yi) {
                    var ci = Nv(Ei), hi = (0, Li.getMimeForCodec)(bi);
                    yi.logger_("Adding " + Ei + "Buffer with codec " + bi + " to mediaSource");
                    var wi = yi.mediaSource.addSourceBuffer(hi);
                    wi.addEventListener("updateend", yi["on" + ci + "UpdateEnd_"]), wi.addEventListener("error", yi["on" + ci + "Error_"]), yi.codecs[Ei] = bi, yi[Ei + "Buffer"] = wi;
                  };
                },
                removeSourceBuffer: function(Ei) {
                  return function(bi) {
                    var yi = bi[Ei + "Buffer"];
                    if (_i(Ei, bi), !!Po(bi.mediaSource, yi)) {
                      bi.logger_("Removing " + Ei + "Buffer with codec " + bi.codecs[Ei] + " from mediaSource");
                      try {
                        bi.mediaSource.removeSourceBuffer(yi);
                      } catch (ci) {
                        Rl.log.warn("Failed to removeSourceBuffer " + Ei + "Buffer", ci);
                      }
                    }
                  };
                },
                changeType: function(Ei) {
                  return function(bi, yi) {
                    var ci = yi[bi + "Buffer"], hi = (0, Li.getMimeForCodec)(Ei);
                    if (Po(yi.mediaSource, ci) && yi.codecs[bi] !== Ei) {
                      yi.logger_("changing " + bi + "Buffer codec from " + yi.codecs[bi] + " to " + Ei);
                      try {
                        ci.changeType(hi), yi.codecs[bi] = Ei;
                      } catch (wi) {
                        Rl.log.warn("Failed to changeType on " + bi + "Buffer", wi);
                      }
                    }
                  };
                }
              }, na = function(Ei) {
                var bi = Ei.type, yi = Ei.sourceUpdater, ci = Ei.action, hi = Ei.doneFn, wi = Ei.name;
                yi.queue.push({
                  type: bi,
                  action: ci,
                  doneFn: hi,
                  name: wi
                }), Ai(bi, yi);
              }, ta = function(Ei, bi) {
                return function(yi) {
                  if (bi.queuePending[Ei]) {
                    var ci = bi.queuePending[Ei].doneFn;
                    bi.queuePending[Ei] = null, ci && ci(bi[Ei + "Error_"]);
                  }
                  Ai(Ei, bi);
                };
              }, Fo = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi) {
                  var ci;
                  return ci = Vi.call(this) || this, ci.mediaSource = yi, ci.sourceopenListener_ = function() {
                    return Ai("mediaSource", (0, xi.default)(ci));
                  }, ci.mediaSource.addEventListener("sourceopen", ci.sourceopenListener_), ci.logger_ = Af("SourceUpdater"), ci.audioTimestampOffset_ = 0, ci.videoTimestampOffset_ = 0, ci.queue = [], ci.queuePending = {
                    audio: null,
                    video: null
                  }, ci.delayedAudioAppendQueue_ = [], ci.videoAppendQueued_ = !1, ci.codecs = {}, ci.onVideoUpdateEnd_ = ta("video", (0, xi.default)(ci)), ci.onAudioUpdateEnd_ = ta("audio", (0, xi.default)(ci)), ci.onVideoError_ = function(hi) {
                    ci.videoError_ = hi;
                  }, ci.onAudioError_ = function(hi) {
                    ci.audioError_ = hi;
                  }, ci.createdSourceBuffers_ = !1, ci.initializedEme_ = !1, ci.triggeredReady_ = !1, ci;
                }
                var bi = Ei.prototype;
                return bi.initializedEme = function() {
                  this.initializedEme_ = !0, this.triggerReady();
                }, bi.hasCreatedSourceBuffers = function() {
                  return this.createdSourceBuffers_;
                }, bi.hasInitializedAnyEme = function() {
                  return this.initializedEme_;
                }, bi.ready = function() {
                  return this.hasCreatedSourceBuffers() && this.hasInitializedAnyEme();
                }, bi.createSourceBuffers = function(ci) {
                  this.hasCreatedSourceBuffers() || (this.addOrChangeSourceBuffers(ci), this.createdSourceBuffers_ = !0, this.trigger("createdsourcebuffers"), this.triggerReady());
                }, bi.triggerReady = function() {
                  this.ready() && !this.triggeredReady_ && (this.triggeredReady_ = !0, this.trigger("ready"));
                }, bi.addSourceBuffer = function(ci, hi) {
                  na({
                    type: "mediaSource",
                    sourceUpdater: this,
                    action: Gi.addSourceBuffer(ci, hi),
                    name: "addSourceBuffer"
                  });
                }, bi.abort = function(ci) {
                  na({
                    type: ci,
                    sourceUpdater: this,
                    action: Gi.abort(ci),
                    name: "abort"
                  });
                }, bi.removeSourceBuffer = function(ci) {
                  if (!this.canRemoveSourceBuffer()) {
                    Rl.log.error("removeSourceBuffer is not supported!");
                    return;
                  }
                  na({
                    type: "mediaSource",
                    sourceUpdater: this,
                    action: Gi.removeSourceBuffer(ci),
                    name: "removeSourceBuffer"
                  });
                }, bi.canRemoveSourceBuffer = function() {
                  return !Rl.browser.IE_VERSION && !Rl.browser.IS_FIREFOX && di().MediaSource && di().MediaSource.prototype && typeof di().MediaSource.prototype.removeSourceBuffer == "function";
                }, Ei.canChangeType = function() {
                  return di().SourceBuffer && di().SourceBuffer.prototype && typeof di().SourceBuffer.prototype.changeType == "function";
                }, bi.canChangeType = function() {
                  return this.constructor.canChangeType();
                }, bi.changeType = function(ci, hi) {
                  if (!this.canChangeType()) {
                    Rl.log.error("changeType is not supported!");
                    return;
                  }
                  na({
                    type: ci,
                    sourceUpdater: this,
                    action: Gi.changeType(hi),
                    name: "changeType"
                  });
                }, bi.addOrChangeSourceBuffers = function(ci) {
                  var hi = this;
                  if (!ci || typeof ci != "object" || Object.keys(ci).length === 0)
                    throw new Error("Cannot addOrChangeSourceBuffers to undefined codecs");
                  Object.keys(ci).forEach(function(wi) {
                    var zi = ci[wi];
                    if (!hi.hasCreatedSourceBuffers())
                      return hi.addSourceBuffer(wi, zi);
                    hi.canChangeType() && hi.changeType(wi, zi);
                  });
                }, bi.appendBuffer = function(ci, hi) {
                  var wi = this, zi = ci.segmentInfo, Wo = ci.type, aa = ci.bytes;
                  if (this.processedAppend_ = !0, Wo === "audio" && this.videoBuffer && !this.videoAppendQueued_) {
                    this.delayedAudioAppendQueue_.push([ci, hi]), this.logger_("delayed audio append of " + aa.length + " until video append");
                    return;
                  }
                  var Ea = hi;
                  if (na({
                    type: Wo,
                    sourceUpdater: this,
                    action: Gi.appendBuffer(aa, zi || {
                      mediaIndex: -1
                    }, Ea),
                    doneFn: hi,
                    name: "appendBuffer"
                  }), Wo === "video") {
                    if (this.videoAppendQueued_ = !0, !this.delayedAudioAppendQueue_.length)
                      return;
                    var Ka = this.delayedAudioAppendQueue_.slice();
                    this.logger_("queuing delayed audio " + Ka.length + " appendBuffers"), this.delayedAudioAppendQueue_.length = 0, Ka.forEach(function(Ha) {
                      wi.appendBuffer.apply(wi, Ha);
                    });
                  }
                }, bi.audioBuffered = function() {
                  return Po(this.mediaSource, this.audioBuffer) && this.audioBuffer.buffered ? this.audioBuffer.buffered : Rl.createTimeRange();
                }, bi.videoBuffered = function() {
                  return Po(this.mediaSource, this.videoBuffer) && this.videoBuffer.buffered ? this.videoBuffer.buffered : Rl.createTimeRange();
                }, bi.buffered = function() {
                  var ci = Po(this.mediaSource, this.videoBuffer) ? this.videoBuffer : null, hi = Po(this.mediaSource, this.audioBuffer) ? this.audioBuffer : null;
                  return hi && !ci ? this.audioBuffered() : ci && !hi ? this.videoBuffered() : If(this.audioBuffered(), this.videoBuffered());
                }, bi.setDuration = function(ci, hi) {
                  hi === void 0 && (hi = hp), na({
                    type: "mediaSource",
                    sourceUpdater: this,
                    action: Gi.duration(ci),
                    name: "duration",
                    doneFn: hi
                  });
                }, bi.endOfStream = function(ci, hi) {
                  ci === void 0 && (ci = null), hi === void 0 && (hi = hp), typeof ci != "string" && (ci = void 0), na({
                    type: "mediaSource",
                    sourceUpdater: this,
                    action: Gi.endOfStream(ci),
                    name: "endOfStream",
                    doneFn: hi
                  });
                }, bi.removeAudio = function(ci, hi, wi) {
                  if (wi === void 0 && (wi = hp), !this.audioBuffered().length || this.audioBuffered().end(0) === 0) {
                    wi();
                    return;
                  }
                  na({
                    type: "audio",
                    sourceUpdater: this,
                    action: Gi.remove(ci, hi),
                    doneFn: wi,
                    name: "remove"
                  });
                }, bi.removeVideo = function(ci, hi, wi) {
                  if (wi === void 0 && (wi = hp), !this.videoBuffered().length || this.videoBuffered().end(0) === 0) {
                    wi();
                    return;
                  }
                  na({
                    type: "video",
                    sourceUpdater: this,
                    action: Gi.remove(ci, hi),
                    doneFn: wi,
                    name: "remove"
                  });
                }, bi.updating = function() {
                  return !!(Lm("audio", this) || Lm("video", this));
                }, bi.audioTimestampOffset = function(ci) {
                  return typeof ci < "u" && this.audioBuffer && // no point in updating if it's the same
                  this.audioTimestampOffset_ !== ci && (na({
                    type: "audio",
                    sourceUpdater: this,
                    action: Gi.timestampOffset(ci),
                    name: "timestampOffset"
                  }), this.audioTimestampOffset_ = ci), this.audioTimestampOffset_;
                }, bi.videoTimestampOffset = function(ci) {
                  return typeof ci < "u" && this.videoBuffer && // no point in updating if it's the same
                  this.videoTimestampOffset !== ci && (na({
                    type: "video",
                    sourceUpdater: this,
                    action: Gi.timestampOffset(ci),
                    name: "timestampOffset"
                  }), this.videoTimestampOffset_ = ci), this.videoTimestampOffset_;
                }, bi.audioQueueCallback = function(ci) {
                  this.audioBuffer && na({
                    type: "audio",
                    sourceUpdater: this,
                    action: Gi.callback(ci),
                    name: "callback"
                  });
                }, bi.videoQueueCallback = function(ci) {
                  this.videoBuffer && na({
                    type: "video",
                    sourceUpdater: this,
                    action: Gi.callback(ci),
                    name: "callback"
                  });
                }, bi.dispose = function() {
                  var ci = this;
                  this.trigger("dispose"), Jy.forEach(function(hi) {
                    ci.abort(hi), ci.canRemoveSourceBuffer() ? ci.removeSourceBuffer(hi) : ci[hi + "QueueCallback"](function() {
                      return _i(hi, ci);
                    });
                  }), this.videoAppendQueued_ = !1, this.delayedAudioAppendQueue_.length = 0, this.sourceopenListener_ && this.mediaSource.removeEventListener("sourceopen", this.sourceopenListener_), this.off();
                }, Ei;
              })(Rl.EventTarget), Wa = function(Ei) {
                return decodeURIComponent(escape(String.fromCharCode.apply(null, Ei)));
              }, Va = new Uint8Array(`

`.split("").map(function(Vi) {
                return Vi.charCodeAt(0);
              })), wa = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei() {
                  return Vi.call(this, "Trying to parse received VTT cues, but there is no WebVTT. Make sure vtt.js is loaded.") || this;
                }
                return Ei;
              })(/* @__PURE__ */ (0, ji.default)(Error)), il = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci) {
                  var hi;
                  return ci === void 0 && (ci = {}), hi = Vi.call(this, yi, ci) || this, hi.mediaSource_ = null, hi.subtitlesTrack_ = null, hi.loaderType_ = "subtitle", hi.featuresNativeTextTracks_ = yi.featuresNativeTextTracks, hi.loadVttJs = yi.loadVttJs, hi.shouldSaveSegmentTimingInfo_ = !1, hi;
                }
                var bi = Ei.prototype;
                return bi.createTransmuxer_ = function() {
                  return null;
                }, bi.buffered_ = function() {
                  if (!this.subtitlesTrack_ || !this.subtitlesTrack_.cues || !this.subtitlesTrack_.cues.length)
                    return Rl.createTimeRanges();
                  var ci = this.subtitlesTrack_.cues, hi = ci[0].startTime, wi = ci[ci.length - 1].startTime;
                  return Rl.createTimeRanges([[hi, wi]]);
                }, bi.initSegmentForMap = function(ci, hi) {
                  if (hi === void 0 && (hi = !1), !ci)
                    return null;
                  var wi = Ng(ci), zi = this.initSegments_[wi];
                  if (hi && !zi && ci.bytes) {
                    var Wo = Va.byteLength + ci.bytes.byteLength, aa = new Uint8Array(Wo);
                    aa.set(ci.bytes), aa.set(Va, ci.bytes.byteLength), this.initSegments_[wi] = zi = {
                      resolvedUri: ci.resolvedUri,
                      byterange: ci.byterange,
                      bytes: aa
                    };
                  }
                  return zi || ci;
                }, bi.couldBeginLoading_ = function() {
                  return this.playlist_ && this.subtitlesTrack_ && !this.paused();
                }, bi.init_ = function() {
                  return this.state = "READY", this.resetEverything(), this.monitorBuffer_();
                }, bi.track = function(ci) {
                  return typeof ci > "u" ? this.subtitlesTrack_ : (this.subtitlesTrack_ = ci, this.state === "INIT" && this.couldBeginLoading_() && this.init_(), this.subtitlesTrack_);
                }, bi.remove = function(ci, hi) {
                  fg(ci, hi, this.subtitlesTrack_);
                }, bi.fillBuffer_ = function() {
                  var ci = this, hi = this.chooseNextRequest_();
                  if (hi) {
                    if (this.syncController_.timestampOffsetForTimeline(hi.timeline) === null) {
                      var wi = function() {
                        ci.state = "READY", ci.paused() || ci.monitorBuffer_();
                      };
                      this.syncController_.one("timestampoffset", wi), this.state = "WAITING_ON_TIMELINE";
                      return;
                    }
                    this.loadSegment_(hi);
                  }
                }, bi.timestampOffsetForSegment_ = function() {
                  return null;
                }, bi.chooseNextRequest_ = function() {
                  return this.skipEmptySegments_(Vi.prototype.chooseNextRequest_.call(this));
                }, bi.skipEmptySegments_ = function(ci) {
                  for (; ci && ci.segment.empty; ) {
                    if (ci.mediaIndex + 1 >= ci.playlist.segments.length) {
                      ci = null;
                      break;
                    }
                    ci = this.generateSegmentInfo_({
                      playlist: ci.playlist,
                      mediaIndex: ci.mediaIndex + 1,
                      startOfSegment: ci.startOfSegment + ci.duration,
                      isSyncRequest: ci.isSyncRequest
                    });
                  }
                  return ci;
                }, bi.stopForError = function(ci) {
                  this.error(ci), this.state = "READY", this.pause(), this.trigger("error");
                }, bi.segmentRequestFinished_ = function(ci, hi, wi) {
                  var zi = this;
                  if (!this.subtitlesTrack_) {
                    this.state = "READY";
                    return;
                  }
                  if (this.saveTransferStats_(hi.stats), !this.pendingSegment_) {
                    this.state = "READY", this.mediaRequestsAborted += 1;
                    return;
                  }
                  if (ci) {
                    ci.code === mf.TIMEOUT && this.handleTimeout_(), ci.code === mf.ABORTED ? this.mediaRequestsAborted += 1 : this.mediaRequestsErrored += 1, this.stopForError(ci);
                    return;
                  }
                  var Wo = this.pendingSegment_;
                  this.saveBandwidthRelatedStats_(Wo.duration, hi.stats), hi.key && this.segmentKey(hi.key, !0), this.state = "APPENDING", this.trigger("appending");
                  var aa = Wo.segment;
                  if (aa.map && (aa.map.bytes = hi.map.bytes), Wo.bytes = hi.bytes, typeof di().WebVTT != "function" && typeof this.loadVttJs == "function") {
                    this.state = "WAITING_ON_VTTJS", this.loadVttJs().then(function() {
                      return zi.segmentRequestFinished_(ci, hi, wi);
                    }, function() {
                      return zi.stopForError({
                        message: "Error loading vtt.js"
                      });
                    });
                    return;
                  }
                  aa.requested = !0;
                  try {
                    this.parseVTTCues_(Wo);
                  } catch (Ea) {
                    this.stopForError({
                      message: Ea.message
                    });
                    return;
                  }
                  if (this.updateTimeMapping_(Wo, this.syncController_.timelines[Wo.timeline], this.playlist_), Wo.cues.length ? Wo.timingInfo = {
                    start: Wo.cues[0].startTime,
                    end: Wo.cues[Wo.cues.length - 1].endTime
                  } : Wo.timingInfo = {
                    start: Wo.startOfSegment,
                    end: Wo.startOfSegment + Wo.duration
                  }, Wo.isSyncRequest) {
                    this.trigger("syncinfoupdate"), this.pendingSegment_ = null, this.state = "READY";
                    return;
                  }
                  Wo.byteLength = Wo.bytes.byteLength, this.mediaSecondsLoaded += aa.duration, Wo.cues.forEach(function(Ea) {
                    zi.subtitlesTrack_.addCue(zi.featuresNativeTextTracks_ ? new (di()).VTTCue(Ea.startTime, Ea.endTime, Ea.text) : Ea);
                  }), Lp(this.subtitlesTrack_), this.handleAppendsDone_();
                }, bi.handleData_ = function() {
                }, bi.updateTimingInfoEnd_ = function() {
                }, bi.parseVTTCues_ = function(ci) {
                  var hi, wi = !1;
                  if (typeof di().WebVTT != "function")
                    throw new wa();
                  typeof di().TextDecoder == "function" ? hi = new (di()).TextDecoder("utf8") : (hi = di().WebVTT.StringDecoder(), wi = !0);
                  var zi = new (di()).WebVTT.Parser(di(), di().vttjs, hi);
                  if (ci.cues = [], ci.timestampmap = {
                    MPEGTS: 0,
                    LOCAL: 0
                  }, zi.oncue = ci.cues.push.bind(ci.cues), zi.ontimestampmap = function(Ea) {
                    ci.timestampmap = Ea;
                  }, zi.onparsingerror = function(Ea) {
                    Rl.log.warn("Error encountered when parsing cues: " + Ea.message);
                  }, ci.segment.map) {
                    var Wo = ci.segment.map.bytes;
                    wi && (Wo = Wa(Wo)), zi.parse(Wo);
                  }
                  var aa = ci.bytes;
                  wi && (aa = Wa(aa)), zi.parse(aa), zi.flush();
                }, bi.updateTimeMapping_ = function(ci, hi, wi) {
                  var zi = ci.segment;
                  if (hi) {
                    if (!ci.cues.length) {
                      zi.empty = !0;
                      return;
                    }
                    var Wo = ci.timestampmap, aa = Wo.MPEGTS / Wi.ONE_SECOND_IN_TS - Wo.LOCAL + hi.mapping;
                    if (ci.cues.forEach(function(Ha) {
                      Ha.startTime += aa, Ha.endTime += aa;
                    }), !wi.syncInfo) {
                      var Ea = ci.cues[0].startTime, Ka = ci.cues[ci.cues.length - 1].startTime;
                      wi.syncInfo = {
                        mediaSequence: wi.mediaSequence + ci.mediaIndex,
                        time: Math.min(Ea, Ka - zi.duration)
                      };
                    }
                  }
                }, Ei;
              })(Ug), ol = function(Ei, bi) {
                for (var yi = Ei.cues, ci = 0; ci < yi.length; ci++) {
                  var hi = yi[ci];
                  if (bi >= hi.adStartTime && bi <= hi.adEndTime)
                    return hi;
                }
                return null;
              }, Ql = function(Ei, bi, yi) {
                if (yi === void 0 && (yi = 0), !!Ei.segments)
                  for (var ci = yi, hi, wi = 0; wi < Ei.segments.length; wi++) {
                    var zi = Ei.segments[wi];
                    if (hi || (hi = ol(bi, ci + zi.duration / 2)), hi) {
                      if ("cueIn" in zi) {
                        hi.endTime = ci, hi.adEndTime = ci, ci += zi.duration, hi = null;
                        continue;
                      }
                      if (ci < hi.endTime) {
                        ci += zi.duration;
                        continue;
                      }
                      hi.endTime += zi.duration;
                    } else if ("cueOut" in zi && (hi = new (di()).VTTCue(ci, ci + zi.duration, zi.cueOut), hi.adStartTime = ci, hi.adEndTime = ci + parseFloat(zi.cueOut), bi.addCue(hi)), "cueOutCont" in zi) {
                      var Wo = zi.cueOutCont.split("/").map(parseFloat), aa = Wo[0], Ea = Wo[1];
                      hi = new (di()).VTTCue(ci, ci + zi.duration, ""), hi.adStartTime = ci - aa, hi.adEndTime = hi.adStartTime + Ea, bi.addCue(hi);
                    }
                    ci += zi.duration;
                  }
              }, Uu = 86400, Wu = [
                // Stategy "VOD": Handle the VOD-case where the sync-point is *always*
                //                the equivalence display-time 0 === segment-index 0
                {
                  name: "VOD",
                  run: function(Ei, bi, yi, ci, hi) {
                    if (yi !== 1 / 0) {
                      var wi = {
                        time: 0,
                        segmentIndex: 0,
                        partIndex: null
                      };
                      return wi;
                    }
                    return null;
                  }
                },
                // Stategy "ProgramDateTime": We have a program-date-time tag in this playlist
                {
                  name: "ProgramDateTime",
                  run: function(Ei, bi, yi, ci, hi) {
                    if (!Object.keys(Ei.timelineToDatetimeMappings).length)
                      return null;
                    var wi = null, zi = null, Wo = Zg(bi);
                    hi = hi || 0;
                    for (var aa = 0; aa < Wo.length; aa++) {
                      var Ea = bi.endList || hi === 0 ? aa : Wo.length - (aa + 1), Ka = Wo[Ea], Ha = Ka.segment, ks = Ei.timelineToDatetimeMappings[Ha.timeline];
                      if (!(!ks || !Ha.dateTimeObject)) {
                        var gl = Ha.dateTimeObject.getTime() / 1e3, Sl = gl + ks;
                        if (Ha.parts && typeof Ka.partIndex == "number")
                          for (var Fl = 0; Fl < Ka.partIndex; Fl++)
                            Sl += Ha.parts[Fl].duration;
                        var ru = Math.abs(hi - Sl);
                        if (zi !== null && (ru === 0 || zi < ru))
                          break;
                        zi = ru, wi = {
                          time: Sl,
                          segmentIndex: Ka.segmentIndex,
                          partIndex: Ka.partIndex
                        };
                      }
                    }
                    return wi;
                  }
                },
                // Stategy "Segment": We have a known time mapping for a timeline and a
                //                    segment in the current timeline with timing data
                {
                  name: "Segment",
                  run: function(Ei, bi, yi, ci, hi) {
                    var wi = null, zi = null;
                    hi = hi || 0;
                    for (var Wo = Zg(bi), aa = 0; aa < Wo.length; aa++) {
                      var Ea = bi.endList || hi === 0 ? aa : Wo.length - (aa + 1), Ka = Wo[Ea], Ha = Ka.segment, ks = Ka.part && Ka.part.start || Ha && Ha.start;
                      if (Ha.timeline === ci && typeof ks < "u") {
                        var gl = Math.abs(hi - ks);
                        if (zi !== null && zi < gl)
                          break;
                        (!wi || zi === null || zi >= gl) && (zi = gl, wi = {
                          time: ks,
                          segmentIndex: Ka.segmentIndex,
                          partIndex: Ka.partIndex
                        });
                      }
                    }
                    return wi;
                  }
                },
                // Stategy "Discontinuity": We have a discontinuity with a known
                //                          display-time
                {
                  name: "Discontinuity",
                  run: function(Ei, bi, yi, ci, hi) {
                    var wi = null;
                    if (hi = hi || 0, bi.discontinuityStarts && bi.discontinuityStarts.length)
                      for (var zi = null, Wo = 0; Wo < bi.discontinuityStarts.length; Wo++) {
                        var aa = bi.discontinuityStarts[Wo], Ea = bi.discontinuitySequence + Wo + 1, Ka = Ei.discontinuities[Ea];
                        if (Ka) {
                          var Ha = Math.abs(hi - Ka.time);
                          if (zi !== null && zi < Ha)
                            break;
                          (!wi || zi === null || zi >= Ha) && (zi = Ha, wi = {
                            time: Ka.time,
                            segmentIndex: aa,
                            partIndex: null
                          });
                        }
                      }
                    return wi;
                  }
                },
                // Stategy "Playlist": We have a playlist with a known mapping of
                //                     segment index to display time
                {
                  name: "Playlist",
                  run: function(Ei, bi, yi, ci, hi) {
                    if (bi.syncInfo) {
                      var wi = {
                        time: bi.syncInfo.time,
                        segmentIndex: bi.syncInfo.mediaSequence - bi.mediaSequence,
                        partIndex: null
                      };
                      return wi;
                    }
                    return null;
                  }
                }
              ], Kl = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi) {
                  var ci;
                  return ci = Vi.call(this) || this, ci.timelines = [], ci.discontinuities = [], ci.timelineToDatetimeMappings = {}, ci.logger_ = Af("SyncController"), ci;
                }
                var bi = Ei.prototype;
                return bi.getSyncPoint = function(ci, hi, wi, zi) {
                  var Wo = this.runStrategies_(ci, hi, wi, zi);
                  return Wo.length ? this.selectSyncPoint_(Wo, {
                    key: "time",
                    value: zi
                  }) : null;
                }, bi.getExpiredTime = function(ci, hi) {
                  if (!ci || !ci.segments)
                    return null;
                  var wi = this.runStrategies_(ci, hi, ci.discontinuitySequence, 0);
                  if (!wi.length)
                    return null;
                  var zi = this.selectSyncPoint_(wi, {
                    key: "segmentIndex",
                    value: 0
                  });
                  return zi.segmentIndex > 0 && (zi.time *= -1), Math.abs(zi.time + lg({
                    defaultDuration: ci.targetDuration,
                    durationList: ci.segments,
                    startIndex: zi.segmentIndex,
                    endIndex: 0
                  }));
                }, bi.runStrategies_ = function(ci, hi, wi, zi) {
                  for (var Wo = [], aa = 0; aa < Wu.length; aa++) {
                    var Ea = Wu[aa], Ka = Ea.run(this, ci, hi, wi, zi);
                    Ka && (Ka.strategy = Ea.name, Wo.push({
                      strategy: Ea.name,
                      syncPoint: Ka
                    }));
                  }
                  return Wo;
                }, bi.selectSyncPoint_ = function(ci, hi) {
                  for (var wi = ci[0].syncPoint, zi = Math.abs(ci[0].syncPoint[hi.key] - hi.value), Wo = ci[0].strategy, aa = 1; aa < ci.length; aa++) {
                    var Ea = Math.abs(ci[aa].syncPoint[hi.key] - hi.value);
                    Ea < zi && (zi = Ea, wi = ci[aa].syncPoint, Wo = ci[aa].strategy);
                  }
                  return this.logger_("syncPoint for [" + hi.key + ": " + hi.value + "] chosen with strategy" + (" [" + Wo + "]: [time:" + wi.time + ",") + (" segmentIndex:" + wi.segmentIndex) + (typeof wi.partIndex == "number" ? ",partIndex:" + wi.partIndex : "") + "]"), wi;
                }, bi.saveExpiredSegmentInfo = function(ci, hi) {
                  var wi = hi.mediaSequence - ci.mediaSequence;
                  if (wi > Uu) {
                    Rl.log.warn("Not saving expired segment info. Media sequence gap " + wi + " is too large.");
                    return;
                  }
                  for (var zi = wi - 1; zi >= 0; zi--) {
                    var Wo = ci.segments[zi];
                    if (Wo && typeof Wo.start < "u") {
                      hi.syncInfo = {
                        mediaSequence: ci.mediaSequence + zi,
                        time: Wo.start
                      }, this.logger_("playlist refresh sync: [time:" + hi.syncInfo.time + "," + (" mediaSequence: " + hi.syncInfo.mediaSequence + "]")), this.trigger("syncinfoupdate");
                      break;
                    }
                  }
                }, bi.setDateTimeMappingForStart = function(ci) {
                  if (this.timelineToDatetimeMappings = {}, ci.segments && ci.segments.length && ci.segments[0].dateTimeObject) {
                    var hi = ci.segments[0], wi = hi.dateTimeObject.getTime() / 1e3;
                    this.timelineToDatetimeMappings[hi.timeline] = -wi;
                  }
                }, bi.saveSegmentTimingInfo = function(ci) {
                  var hi = ci.segmentInfo, wi = ci.shouldSaveTimelineMapping, zi = this.calculateSegmentTimeMapping_(hi, hi.timingInfo, wi), Wo = hi.segment;
                  zi && (this.saveDiscontinuitySyncInfo_(hi), hi.playlist.syncInfo || (hi.playlist.syncInfo = {
                    mediaSequence: hi.playlist.mediaSequence + hi.mediaIndex,
                    time: Wo.start
                  }));
                  var aa = Wo.dateTimeObject;
                  Wo.discontinuity && wi && aa && (this.timelineToDatetimeMappings[Wo.timeline] = -(aa.getTime() / 1e3));
                }, bi.timestampOffsetForTimeline = function(ci) {
                  return typeof this.timelines[ci] > "u" ? null : this.timelines[ci].time;
                }, bi.mappingForTimeline = function(ci) {
                  return typeof this.timelines[ci] > "u" ? null : this.timelines[ci].mapping;
                }, bi.calculateSegmentTimeMapping_ = function(ci, hi, wi) {
                  var zi = ci.segment, Wo = ci.part, aa = this.timelines[ci.timeline], Ea, Ka;
                  if (typeof ci.timestampOffset == "number")
                    aa = {
                      time: ci.startOfSegment,
                      mapping: ci.startOfSegment - hi.start
                    }, wi && (this.timelines[ci.timeline] = aa, this.trigger("timestampoffset"), this.logger_("time mapping for timeline " + ci.timeline + ": " + ("[time: " + aa.time + "] [mapping: " + aa.mapping + "]"))), Ea = ci.startOfSegment, Ka = hi.end + aa.mapping;
                  else if (aa)
                    Ea = hi.start + aa.mapping, Ka = hi.end + aa.mapping;
                  else
                    return !1;
                  return Wo && (Wo.start = Ea, Wo.end = Ka), (!zi.start || Ea < zi.start) && (zi.start = Ea), zi.end = Ka, !0;
                }, bi.saveDiscontinuitySyncInfo_ = function(ci) {
                  var hi = ci.playlist, wi = ci.segment;
                  if (wi.discontinuity)
                    this.discontinuities[wi.timeline] = {
                      time: wi.start,
                      accuracy: 0
                    };
                  else if (hi.discontinuityStarts && hi.discontinuityStarts.length)
                    for (var zi = 0; zi < hi.discontinuityStarts.length; zi++) {
                      var Wo = hi.discontinuityStarts[zi], aa = hi.discontinuitySequence + zi + 1, Ea = Wo - ci.mediaIndex, Ka = Math.abs(Ea);
                      if (!this.discontinuities[aa] || this.discontinuities[aa].accuracy > Ka) {
                        var Ha = void 0;
                        Ea < 0 ? Ha = wi.start - lg({
                          defaultDuration: hi.targetDuration,
                          durationList: hi.segments,
                          startIndex: ci.mediaIndex,
                          endIndex: Wo
                        }) : Ha = wi.end + lg({
                          defaultDuration: hi.targetDuration,
                          durationList: hi.segments,
                          startIndex: ci.mediaIndex + 1,
                          endIndex: Wo
                        }), this.discontinuities[aa] = {
                          time: Ha,
                          accuracy: Ka
                        };
                      }
                    }
                }, bi.dispose = function() {
                  this.trigger("dispose"), this.off();
                }, Ei;
              })(Rl.EventTarget), pl = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei() {
                  var yi;
                  return yi = Vi.call(this) || this, yi.pendingTimelineChanges_ = {}, yi.lastTimelineChanges_ = {}, yi;
                }
                var bi = Ei.prototype;
                return bi.clearPendingTimelineChange = function(ci) {
                  this.pendingTimelineChanges_[ci] = null, this.trigger("pendingtimelinechange");
                }, bi.pendingTimelineChange = function(ci) {
                  var hi = ci.type, wi = ci.from, zi = ci.to;
                  return typeof wi == "number" && typeof zi == "number" && (this.pendingTimelineChanges_[hi] = {
                    type: hi,
                    from: wi,
                    to: zi
                  }, this.trigger("pendingtimelinechange")), this.pendingTimelineChanges_[hi];
                }, bi.lastTimelineChange = function(ci) {
                  var hi = ci.type, wi = ci.from, zi = ci.to;
                  return typeof wi == "number" && typeof zi == "number" && (this.lastTimelineChanges_[hi] = {
                    type: hi,
                    from: wi,
                    to: zi
                  }, delete this.pendingTimelineChanges_[hi], this.trigger("timelinechange")), this.lastTimelineChanges_[hi];
                }, bi.dispose = function() {
                  this.trigger("dispose"), this.pendingTimelineChanges_ = {}, this.lastTimelineChanges_ = {}, this.off();
                }, Ei;
              })(Rl.EventTarget), pu = pv(Df(function() {
                var Vi = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof oi.g < "u" ? oi.g : typeof self < "u" ? self : {};
                function Ei(Au, Iu, Bu) {
                  return Bu = {
                    path: Iu,
                    exports: {},
                    require: function(au, Pu) {
                      return bi(au, Pu ?? Bu.path);
                    }
                  }, Au(Bu, Bu.exports), Bu.exports;
                }
                function bi() {
                  throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
                }
                var yi = Ei(function(Au) {
                  function Iu(mu, au) {
                    for (var Pu = 0; Pu < au.length; Pu++) {
                      var nu = au[Pu];
                      nu.enumerable = nu.enumerable || !1, nu.configurable = !0, "value" in nu && (nu.writable = !0), Object.defineProperty(mu, nu.key, nu);
                    }
                  }
                  function Bu(mu, au, Pu) {
                    return au && Iu(mu.prototype, au), Pu && Iu(mu, Pu), mu;
                  }
                  Au.exports = Bu, Au.exports.default = Au.exports, Au.exports.__esModule = !0;
                }), ci = Ei(function(Au) {
                  function Iu(Bu, mu) {
                    return Au.exports = Iu = Object.setPrototypeOf || function(Pu, nu) {
                      return Pu.__proto__ = nu, Pu;
                    }, Au.exports.default = Au.exports, Au.exports.__esModule = !0, Iu(Bu, mu);
                  }
                  Au.exports = Iu, Au.exports.default = Au.exports, Au.exports.__esModule = !0;
                }), hi = Ei(function(Au) {
                  function Iu(Bu, mu) {
                    Bu.prototype = Object.create(mu.prototype), Bu.prototype.constructor = Bu, ci(Bu, mu);
                  }
                  Au.exports = Iu, Au.exports.default = Au.exports, Au.exports.__esModule = !0;
                }), wi = /* @__PURE__ */ (function() {
                  function Au() {
                    this.listeners = {};
                  }
                  var Iu = Au.prototype;
                  return Iu.on = function(mu, au) {
                    this.listeners[mu] || (this.listeners[mu] = []), this.listeners[mu].push(au);
                  }, Iu.off = function(mu, au) {
                    if (!this.listeners[mu])
                      return !1;
                    var Pu = this.listeners[mu].indexOf(au);
                    return this.listeners[mu] = this.listeners[mu].slice(0), this.listeners[mu].splice(Pu, 1), Pu > -1;
                  }, Iu.trigger = function(mu) {
                    var au = this.listeners[mu];
                    if (au)
                      if (arguments.length === 2)
                        for (var Pu = au.length, nu = 0; nu < Pu; ++nu)
                          au[nu].call(this, arguments[1]);
                      else
                        for (var ec = Array.prototype.slice.call(arguments, 1), Lu = au.length, oc = 0; oc < Lu; ++oc)
                          au[oc].apply(this, ec);
                  }, Iu.dispose = function() {
                    this.listeners = {};
                  }, Iu.pipe = function(mu) {
                    this.on("data", function(au) {
                      mu.push(au);
                    });
                  }, Au;
                })();
                /*! @name pkcs7 @version 1.0.4 @license Apache-2.0 */
                function zi(Au) {
                  return Au.subarray(0, Au.byteLength - Au[Au.byteLength - 1]);
                }
                /*! @name aes-decrypter @version 3.1.3 @license Apache-2.0 */
                var Wo = function() {
                  var Iu = [[[], [], [], [], []], [[], [], [], [], []]], Bu = Iu[0], mu = Iu[1], au = Bu[4], Pu = mu[4], nu, ec, Lu, oc = [], Uc = [], Hc, cd, Td, Xc, Qd, Dc;
                  for (nu = 0; nu < 256; nu++)
                    Uc[(oc[nu] = nu << 1 ^ (nu >> 7) * 283) ^ nu] = nu;
                  for (ec = Lu = 0; !au[ec]; ec ^= Hc || 1, Lu = Uc[Lu] || 1)
                    for (Xc = Lu ^ Lu << 1 ^ Lu << 2 ^ Lu << 3 ^ Lu << 4, Xc = Xc >> 8 ^ Xc & 255 ^ 99, au[ec] = Xc, Pu[Xc] = ec, Td = oc[cd = oc[Hc = oc[ec]]], Dc = Td * 16843009 ^ cd * 65537 ^ Hc * 257 ^ ec * 16843008, Qd = oc[Xc] * 257 ^ Xc * 16843008, nu = 0; nu < 4; nu++)
                      Bu[nu][ec] = Qd = Qd << 24 ^ Qd >>> 8, mu[nu][Xc] = Dc = Dc << 24 ^ Dc >>> 8;
                  for (nu = 0; nu < 5; nu++)
                    Bu[nu] = Bu[nu].slice(0), mu[nu] = mu[nu].slice(0);
                  return Iu;
                }, aa = null, Ea = /* @__PURE__ */ (function() {
                  function Au(Bu) {
                    aa || (aa = Wo()), this._tables = [[aa[0][0].slice(), aa[0][1].slice(), aa[0][2].slice(), aa[0][3].slice(), aa[0][4].slice()], [aa[1][0].slice(), aa[1][1].slice(), aa[1][2].slice(), aa[1][3].slice(), aa[1][4].slice()]];
                    var mu, au, Pu, nu = this._tables[0][4], ec = this._tables[1], Lu = Bu.length, oc = 1;
                    if (Lu !== 4 && Lu !== 6 && Lu !== 8)
                      throw new Error("Invalid aes key size");
                    var Uc = Bu.slice(0), Hc = [];
                    for (this._key = [Uc, Hc], mu = Lu; mu < 4 * Lu + 28; mu++)
                      Pu = Uc[mu - 1], (mu % Lu === 0 || Lu === 8 && mu % Lu === 4) && (Pu = nu[Pu >>> 24] << 24 ^ nu[Pu >> 16 & 255] << 16 ^ nu[Pu >> 8 & 255] << 8 ^ nu[Pu & 255], mu % Lu === 0 && (Pu = Pu << 8 ^ Pu >>> 24 ^ oc << 24, oc = oc << 1 ^ (oc >> 7) * 283)), Uc[mu] = Uc[mu - Lu] ^ Pu;
                    for (au = 0; mu; au++, mu--)
                      Pu = Uc[au & 3 ? mu : mu - 4], mu <= 4 || au < 4 ? Hc[au] = Pu : Hc[au] = ec[0][nu[Pu >>> 24]] ^ ec[1][nu[Pu >> 16 & 255]] ^ ec[2][nu[Pu >> 8 & 255]] ^ ec[3][nu[Pu & 255]];
                  }
                  var Iu = Au.prototype;
                  return Iu.decrypt = function(mu, au, Pu, nu, ec, Lu) {
                    var oc = this._key[1], Uc = mu ^ oc[0], Hc = nu ^ oc[1], cd = Pu ^ oc[2], Td = au ^ oc[3], Xc, Qd, Dc, Lv = oc.length / 4 - 2, Zf, lh = 4, Hh = this._tables[1], hg = Hh[0], Mp = Hh[1], Vg = Hh[2], Wg = Hh[3], Gg = Hh[4];
                    for (Zf = 0; Zf < Lv; Zf++)
                      Xc = hg[Uc >>> 24] ^ Mp[Hc >> 16 & 255] ^ Vg[cd >> 8 & 255] ^ Wg[Td & 255] ^ oc[lh], Qd = hg[Hc >>> 24] ^ Mp[cd >> 16 & 255] ^ Vg[Td >> 8 & 255] ^ Wg[Uc & 255] ^ oc[lh + 1], Dc = hg[cd >>> 24] ^ Mp[Td >> 16 & 255] ^ Vg[Uc >> 8 & 255] ^ Wg[Hc & 255] ^ oc[lh + 2], Td = hg[Td >>> 24] ^ Mp[Uc >> 16 & 255] ^ Vg[Hc >> 8 & 255] ^ Wg[cd & 255] ^ oc[lh + 3], lh += 4, Uc = Xc, Hc = Qd, cd = Dc;
                    for (Zf = 0; Zf < 4; Zf++)
                      ec[(3 & -Zf) + Lu] = Gg[Uc >>> 24] << 24 ^ Gg[Hc >> 16 & 255] << 16 ^ Gg[cd >> 8 & 255] << 8 ^ Gg[Td & 255] ^ oc[lh++], Xc = Uc, Uc = Hc, Hc = cd, cd = Td, Td = Xc;
                  }, Au;
                })(), Ka = /* @__PURE__ */ (function(Au) {
                  hi(Iu, Au);
                  function Iu() {
                    var mu;
                    return mu = Au.call(this, wi) || this, mu.jobs = [], mu.delay = 1, mu.timeout_ = null, mu;
                  }
                  var Bu = Iu.prototype;
                  return Bu.processJob_ = function() {
                    this.jobs.shift()(), this.jobs.length ? this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay) : this.timeout_ = null;
                  }, Bu.push = function(au) {
                    this.jobs.push(au), this.timeout_ || (this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay));
                  }, Iu;
                })(wi), Ha = function(Iu) {
                  return Iu << 24 | (Iu & 65280) << 8 | (Iu & 16711680) >> 8 | Iu >>> 24;
                }, ks = function(Iu, Bu, mu) {
                  var au = new Int32Array(Iu.buffer, Iu.byteOffset, Iu.byteLength >> 2), Pu = new Ea(Array.prototype.slice.call(Bu)), nu = new Uint8Array(Iu.byteLength), ec = new Int32Array(nu.buffer), Lu, oc, Uc, Hc, cd, Td, Xc, Qd, Dc;
                  for (Lu = mu[0], oc = mu[1], Uc = mu[2], Hc = mu[3], Dc = 0; Dc < au.length; Dc += 4)
                    cd = Ha(au[Dc]), Td = Ha(au[Dc + 1]), Xc = Ha(au[Dc + 2]), Qd = Ha(au[Dc + 3]), Pu.decrypt(cd, Td, Xc, Qd, ec, Dc), ec[Dc] = Ha(ec[Dc] ^ Lu), ec[Dc + 1] = Ha(ec[Dc + 1] ^ oc), ec[Dc + 2] = Ha(ec[Dc + 2] ^ Uc), ec[Dc + 3] = Ha(ec[Dc + 3] ^ Hc), Lu = cd, oc = Td, Uc = Xc, Hc = Qd;
                  return nu;
                }, gl = /* @__PURE__ */ (function() {
                  function Au(Bu, mu, au, Pu) {
                    var nu = Au.STEP, ec = new Int32Array(Bu.buffer), Lu = new Uint8Array(Bu.byteLength), oc = 0;
                    for (this.asyncStream_ = new Ka(), this.asyncStream_.push(this.decryptChunk_(ec.subarray(oc, oc + nu), mu, au, Lu)), oc = nu; oc < ec.length; oc += nu)
                      au = new Uint32Array([Ha(ec[oc - 4]), Ha(ec[oc - 3]), Ha(ec[oc - 2]), Ha(ec[oc - 1])]), this.asyncStream_.push(this.decryptChunk_(ec.subarray(oc, oc + nu), mu, au, Lu));
                    this.asyncStream_.push(function() {
                      Pu(null, zi(Lu));
                    });
                  }
                  var Iu = Au.prototype;
                  return Iu.decryptChunk_ = function(mu, au, Pu, nu) {
                    return function() {
                      var ec = ks(mu, au, Pu);
                      nu.set(ec, mu.byteOffset);
                    };
                  }, yi(Au, null, [{
                    key: "STEP",
                    get: function() {
                      return 32e3;
                    }
                  }]), Au;
                })(), Sl;
                typeof window < "u" ? Sl = window : typeof Vi < "u" ? Sl = Vi : typeof self < "u" ? Sl = self : Sl = {};
                var Fl = Sl, ru = function(Iu) {
                  return ArrayBuffer.isView === "function" ? ArrayBuffer.isView(Iu) : Iu && Iu.buffer instanceof ArrayBuffer;
                }, $u = Fl.BigInt || Number;
                $u("0x1"), $u("0x100"), $u("0x10000"), $u("0x1000000"), $u("0x100000000"), $u("0x10000000000"), $u("0x1000000000000"), $u("0x100000000000000"), $u("0x10000000000000000");
                var rc = function(Iu) {
                  var Bu = {};
                  return Object.keys(Iu).forEach(function(mu) {
                    var au = Iu[mu];
                    ru(au) ? Bu[mu] = {
                      bytes: au.buffer,
                      byteOffset: au.byteOffset,
                      byteLength: au.byteLength
                    } : Bu[mu] = au;
                  }), Bu;
                };
                self.onmessage = function(Au) {
                  var Iu = Au.data, Bu = new Uint8Array(Iu.encrypted.bytes, Iu.encrypted.byteOffset, Iu.encrypted.byteLength), mu = new Uint32Array(Iu.key.bytes, Iu.key.byteOffset, Iu.key.byteLength / 4), au = new Uint32Array(Iu.iv.bytes, Iu.iv.byteOffset, Iu.iv.byteLength / 4);
                  new gl(Bu, mu, au, function(Pu, nu) {
                    self.postMessage(rc({
                      source: Iu.source,
                      decrypted: nu
                    }), [nu.buffer]);
                  });
                };
              })), lu = fv(pu), Nl = function(Ei) {
                var bi = Ei.default ? "main" : "alternative";
                return Ei.characteristics && Ei.characteristics.indexOf("public.accessibility.describes-video") >= 0 && (bi = "main-desc"), bi;
              }, Eu = function(Ei, bi) {
                Ei.abort(), Ei.pause(), bi && bi.activePlaylistLoader && (bi.activePlaylistLoader.pause(), bi.activePlaylistLoader = null);
              }, wu = function(Ei, bi) {
                bi.activePlaylistLoader = Ei, Ei.load();
              }, yu = function(Ei, bi) {
                return function() {
                  var yi = bi.segmentLoaders, ci = yi[Ei], hi = yi.main, wi = bi.mediaTypes[Ei], zi = wi.activeTrack(), Wo = wi.getActiveGroup(), aa = wi.activePlaylistLoader, Ea = wi.lastGroup_;
                  if (!(Wo && Ea && Wo.id === Ea.id) && (wi.lastGroup_ = Wo, wi.lastTrack_ = zi, Eu(ci, wi), !(!Wo || Wo.isMasterPlaylist))) {
                    if (!Wo.playlistLoader) {
                      aa && hi.resetEverything();
                      return;
                    }
                    ci.resyncLoader(), wu(Wo.playlistLoader, wi);
                  }
                };
              }, zl = function(Ei, bi) {
                return function() {
                  var yi = bi.segmentLoaders[Ei], ci = bi.mediaTypes[Ei];
                  ci.lastGroup_ = null, yi.abort(), yi.pause();
                };
              }, Qu = function(Ei, bi) {
                return function() {
                  var yi = bi.masterPlaylistLoader, ci = bi.segmentLoaders, hi = ci[Ei], wi = ci.main, zi = bi.mediaTypes[Ei], Wo = zi.activeTrack(), aa = zi.getActiveGroup(), Ea = zi.activePlaylistLoader, Ka = zi.lastTrack_;
                  if (!(Ka && Wo && Ka.id === Wo.id) && (zi.lastGroup_ = aa, zi.lastTrack_ = Wo, Eu(hi, zi), !!aa)) {
                    if (aa.isMasterPlaylist) {
                      if (!Wo || !Ka || Wo.id === Ka.id)
                        return;
                      var Ha = bi.vhs.masterPlaylistController_, ks = Ha.selectPlaylist();
                      if (Ha.media() === ks)
                        return;
                      zi.logger_("track change. Switching master audio from " + Ka.id + " to " + Wo.id), yi.pause(), wi.resetEverything(), Ha.fastQualityChange_(ks);
                      return;
                    }
                    if (Ei === "AUDIO") {
                      if (!aa.playlistLoader) {
                        wi.setAudio(!0), wi.resetEverything();
                        return;
                      }
                      hi.setAudio(!0), wi.setAudio(!1);
                    }
                    if (Ea === aa.playlistLoader) {
                      wu(aa.playlistLoader, zi);
                      return;
                    }
                    hi.track && hi.track(Wo), hi.resetEverything(), wu(aa.playlistLoader, zi);
                  }
                };
              }, gu = {
                /**
                 * Returns a function to be called when a SegmentLoader or PlaylistLoader encounters
                 * an error.
                 *
                 * @param {string} type
                 *        MediaGroup type
                 * @param {Object} settings
                 *        Object containing required information for media groups
                 * @return {Function}
                 *         Error handler. Logs warning (or error if the playlist is blacklisted) to
                 *         console and switches back to default audio track.
                 * @function onError.AUDIO
                 */
                AUDIO: function(Ei, bi) {
                  return function() {
                    var yi = bi.segmentLoaders[Ei], ci = bi.mediaTypes[Ei], hi = bi.blacklistCurrentPlaylist;
                    Eu(yi, ci);
                    var wi = ci.activeTrack(), zi = ci.activeGroup(), Wo = (zi.filter(function(Ka) {
                      return Ka.default;
                    })[0] || zi[0]).id, aa = ci.tracks[Wo];
                    if (wi === aa) {
                      hi({
                        message: "Problem encountered loading the default audio track."
                      });
                      return;
                    }
                    Rl.log.warn("Problem encountered loading the alternate audio track.Switching back to default.");
                    for (var Ea in ci.tracks)
                      ci.tracks[Ea].enabled = ci.tracks[Ea] === aa;
                    ci.onTrackChanged();
                  };
                },
                /**
                 * Returns a function to be called when a SegmentLoader or PlaylistLoader encounters
                 * an error.
                 *
                 * @param {string} type
                 *        MediaGroup type
                 * @param {Object} settings
                 *        Object containing required information for media groups
                 * @return {Function}
                 *         Error handler. Logs warning to console and disables the active subtitle track
                 * @function onError.SUBTITLES
                 */
                SUBTITLES: function(Ei, bi) {
                  return function() {
                    var yi = bi.segmentLoaders[Ei], ci = bi.mediaTypes[Ei];
                    Rl.log.warn("Problem encountered loading the subtitle track.Disabling subtitle track."), Eu(yi, ci);
                    var hi = ci.activeTrack();
                    hi && (hi.mode = "disabled"), ci.onTrackChanged();
                  };
                }
              }, pc = {
                /**
                 * Setup event listeners for audio playlist loader
                 *
                 * @param {string} type
                 *        MediaGroup type
                 * @param {PlaylistLoader|null} playlistLoader
                 *        PlaylistLoader to register listeners on
                 * @param {Object} settings
                 *        Object containing required information for media groups
                 * @function setupListeners.AUDIO
                 */
                AUDIO: function(Ei, bi, yi) {
                  if (bi) {
                    var ci = yi.tech, hi = yi.requestOptions, wi = yi.segmentLoaders[Ei];
                    bi.on("loadedmetadata", function() {
                      var zi = bi.media();
                      wi.playlist(zi, hi), (!ci.paused() || zi.endList && ci.preload() !== "none") && wi.load();
                    }), bi.on("loadedplaylist", function() {
                      wi.playlist(bi.media(), hi), ci.paused() || wi.load();
                    }), bi.on("error", gu[Ei](Ei, yi));
                  }
                },
                /**
                 * Setup event listeners for subtitle playlist loader
                 *
                 * @param {string} type
                 *        MediaGroup type
                 * @param {PlaylistLoader|null} playlistLoader
                 *        PlaylistLoader to register listeners on
                 * @param {Object} settings
                 *        Object containing required information for media groups
                 * @function setupListeners.SUBTITLES
                 */
                SUBTITLES: function(Ei, bi, yi) {
                  var ci = yi.tech, hi = yi.requestOptions, wi = yi.segmentLoaders[Ei], zi = yi.mediaTypes[Ei];
                  bi.on("loadedmetadata", function() {
                    var Wo = bi.media();
                    wi.playlist(Wo, hi), wi.track(zi.activeTrack()), (!ci.paused() || Wo.endList && ci.preload() !== "none") && wi.load();
                  }), bi.on("loadedplaylist", function() {
                    wi.playlist(bi.media(), hi), ci.paused() || wi.load();
                  }), bi.on("error", gu[Ei](Ei, yi));
                }
              }, Zu = {
                /**
                 * Setup PlaylistLoaders and AudioTracks for the audio groups
                 *
                 * @param {string} type
                 *        MediaGroup type
                 * @param {Object} settings
                 *        Object containing required information for media groups
                 * @function initialize.AUDIO
                 */
                AUDIO: function(Ei, bi) {
                  var yi = bi.vhs, ci = bi.sourceType, hi = bi.segmentLoaders[Ei], wi = bi.requestOptions, zi = bi.master.mediaGroups, Wo = bi.mediaTypes[Ei], aa = Wo.groups, Ea = Wo.tracks, Ka = Wo.logger_, Ha = bi.masterPlaylistLoader, ks = Mh(Ha.master);
                  (!zi[Ei] || Object.keys(zi[Ei]).length === 0) && (zi[Ei] = {
                    main: {
                      default: {
                        default: !0
                      }
                    }
                  }, ks && (zi[Ei].main.default.playlists = Ha.master.playlists));
                  for (var gl in zi[Ei]) {
                    aa[gl] || (aa[gl] = []);
                    for (var Sl in zi[Ei][gl]) {
                      var Fl = zi[Ei][gl][Sl], ru = void 0;
                      if (ks ? (Ka("AUDIO group '" + gl + "' label '" + Sl + "' is a master playlist"), Fl.isMasterPlaylist = !0, ru = null) : ci === "vhs-json" && Fl.playlists ? ru = new jh(Fl.playlists[0], yi, wi) : Fl.resolvedUri ? ru = new jh(Fl.resolvedUri, yi, wi) : Fl.playlists && ci === "dash" ? ru = new cg(Fl.playlists[0], yi, wi, Ha) : ru = null, Fl = Rl.mergeOptions({
                        id: Sl,
                        playlistLoader: ru
                      }, Fl), pc[Ei](Ei, Fl.playlistLoader, bi), aa[gl].push(Fl), typeof Ea[Sl] > "u") {
                        var $u = new Rl.AudioTrack({
                          id: Sl,
                          kind: Nl(Fl),
                          enabled: !1,
                          language: Fl.language,
                          default: Fl.default,
                          label: Sl
                        });
                        Ea[Sl] = $u;
                      }
                    }
                  }
                  hi.on("error", gu[Ei](Ei, bi));
                },
                /**
                 * Setup PlaylistLoaders and TextTracks for the subtitle groups
                 *
                 * @param {string} type
                 *        MediaGroup type
                 * @param {Object} settings
                 *        Object containing required information for media groups
                 * @function initialize.SUBTITLES
                 */
                SUBTITLES: function(Ei, bi) {
                  var yi = bi.tech, ci = bi.vhs, hi = bi.sourceType, wi = bi.segmentLoaders[Ei], zi = bi.requestOptions, Wo = bi.master.mediaGroups, aa = bi.mediaTypes[Ei], Ea = aa.groups, Ka = aa.tracks, Ha = bi.masterPlaylistLoader;
                  for (var ks in Wo[Ei]) {
                    Ea[ks] || (Ea[ks] = []);
                    for (var gl in Wo[Ei][ks])
                      if (!Wo[Ei][ks][gl].forced) {
                        var Sl = Wo[Ei][ks][gl], Fl = void 0;
                        if (hi === "hls")
                          Fl = new jh(Sl.resolvedUri, ci, zi);
                        else if (hi === "dash") {
                          var ru = Sl.playlists.filter(function(rc) {
                            return rc.excludeUntil !== 1 / 0;
                          });
                          if (!ru.length)
                            return;
                          Fl = new cg(Sl.playlists[0], ci, zi, Ha);
                        } else hi === "vhs-json" && (Fl = new jh(
                          // if the vhs-json object included the media playlist, use the media playlist
                          // as provided, otherwise use the resolved URI to load the playlist
                          Sl.playlists ? Sl.playlists[0] : Sl.resolvedUri,
                          ci,
                          zi
                        ));
                        if (Sl = Rl.mergeOptions({
                          id: gl,
                          playlistLoader: Fl
                        }, Sl), pc[Ei](Ei, Sl.playlistLoader, bi), Ea[ks].push(Sl), typeof Ka[gl] > "u") {
                          var $u = yi.addRemoteTextTrack({
                            id: gl,
                            kind: "subtitles",
                            default: Sl.default && Sl.autoselect,
                            language: Sl.language,
                            label: gl
                          }, !1).track;
                          Ka[gl] = $u;
                        }
                      }
                  }
                  wi.on("error", gu[Ei](Ei, bi));
                },
                /**
                 * Setup TextTracks for the closed-caption groups
                 *
                 * @param {String} type
                 *        MediaGroup type
                 * @param {Object} settings
                 *        Object containing required information for media groups
                 * @function initialize['CLOSED-CAPTIONS']
                 */
                "CLOSED-CAPTIONS": function(Ei, bi) {
                  var yi = bi.tech, ci = bi.master.mediaGroups, hi = bi.mediaTypes[Ei], wi = hi.groups, zi = hi.tracks;
                  for (var Wo in ci[Ei]) {
                    wi[Wo] || (wi[Wo] = []);
                    for (var aa in ci[Ei][Wo]) {
                      var Ea = ci[Ei][Wo][aa];
                      if (/^(?:CC|SERVICE)/.test(Ea.instreamId)) {
                        var Ka = yi.options_.vhs && yi.options_.vhs.captionServices || {}, Ha = {
                          label: aa,
                          language: Ea.language,
                          instreamId: Ea.instreamId,
                          default: Ea.default && Ea.autoselect
                        };
                        if (Ka[Ha.instreamId] && (Ha = Rl.mergeOptions(Ha, Ka[Ha.instreamId])), Ha.default === void 0 && delete Ha.default, wi[Wo].push(Rl.mergeOptions({
                          id: aa
                        }, Ea)), typeof zi[aa] > "u") {
                          var ks = yi.addRemoteTextTrack({
                            id: Ha.instreamId,
                            kind: "captions",
                            default: Ha.default,
                            language: Ha.language,
                            label: Ha.label
                          }, !1).track;
                          zi[aa] = ks;
                        }
                      }
                    }
                  }
                }
              }, gc = function Vi(Ei, bi) {
                for (var yi = 0; yi < Ei.length; yi++)
                  if (om(bi, Ei[yi]) || Ei[yi].playlists && Vi(Ei[yi].playlists, bi))
                    return !0;
                return !1;
              }, Du = function(Ei, bi) {
                return function(yi) {
                  var ci = bi.masterPlaylistLoader, hi = bi.mediaTypes[Ei].groups, wi = ci.media();
                  if (!wi)
                    return null;
                  var zi = null;
                  wi.attributes[Ei] && (zi = hi[wi.attributes[Ei]]);
                  var Wo = Object.keys(hi);
                  if (!zi)
                    if (Ei === "AUDIO" && Wo.length > 1 && Mh(bi.master))
                      for (var aa = 0; aa < Wo.length; aa++) {
                        var Ea = hi[Wo[aa]];
                        if (gc(Ea, wi)) {
                          zi = Ea;
                          break;
                        }
                      }
                    else hi.main ? zi = hi.main : Wo.length === 1 && (zi = hi[Wo[0]]);
                  return typeof yi > "u" ? zi : yi === null || !zi ? null : zi.filter(function(Ka) {
                    return Ka.id === yi.id;
                  })[0] || null;
                };
              }, ku = {
                /**
                 * Returns a function used to get the active track of type provided
                 *
                 * @param {string} type
                 *        MediaGroup type
                 * @param {Object} settings
                 *        Object containing required information for media groups
                 * @return {Function}
                 *         Function that returns the active media track for the provided type. Returns
                 *         null if no track is active
                 * @function activeTrack.AUDIO
                 */
                AUDIO: function(Ei, bi) {
                  return function() {
                    var yi = bi.mediaTypes[Ei].tracks;
                    for (var ci in yi)
                      if (yi[ci].enabled)
                        return yi[ci];
                    return null;
                  };
                },
                /**
                 * Returns a function used to get the active track of type provided
                 *
                 * @param {string} type
                 *        MediaGroup type
                 * @param {Object} settings
                 *        Object containing required information for media groups
                 * @return {Function}
                 *         Function that returns the active media track for the provided type. Returns
                 *         null if no track is active
                 * @function activeTrack.SUBTITLES
                 */
                SUBTITLES: function(Ei, bi) {
                  return function() {
                    var yi = bi.mediaTypes[Ei].tracks;
                    for (var ci in yi)
                      if (yi[ci].mode === "showing" || yi[ci].mode === "hidden")
                        return yi[ci];
                    return null;
                  };
                }
              }, Nu = function(Ei, bi) {
                var yi = bi.mediaTypes;
                return function() {
                  var ci = yi[Ei].activeTrack();
                  return ci ? yi[Ei].activeGroup(ci) : null;
                };
              }, Bi = function(Ei) {
                ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach(function(gl) {
                  Zu[gl](gl, Ei);
                });
                var bi = Ei.mediaTypes, yi = Ei.masterPlaylistLoader, ci = Ei.tech, hi = Ei.vhs, wi = Ei.segmentLoaders, zi = wi.AUDIO, Wo = wi.main;
                ["AUDIO", "SUBTITLES"].forEach(function(gl) {
                  bi[gl].activeGroup = Du(gl, Ei), bi[gl].activeTrack = ku[gl](gl, Ei), bi[gl].onGroupChanged = yu(gl, Ei), bi[gl].onGroupChanging = zl(gl, Ei), bi[gl].onTrackChanged = Qu(gl, Ei), bi[gl].getActiveGroup = Nu(gl, Ei);
                });
                var aa = bi.AUDIO.activeGroup();
                if (aa) {
                  var Ea = (aa.filter(function(gl) {
                    return gl.default;
                  })[0] || aa[0]).id;
                  bi.AUDIO.tracks[Ea].enabled = !0, bi.AUDIO.onGroupChanged(), bi.AUDIO.onTrackChanged();
                  var Ka = bi.AUDIO.getActiveGroup();
                  Ka.playlistLoader ? (Wo.setAudio(!1), zi.setAudio(!0)) : Wo.setAudio(!0);
                }
                yi.on("mediachange", function() {
                  ["AUDIO", "SUBTITLES"].forEach(function(gl) {
                    return bi[gl].onGroupChanged();
                  });
                }), yi.on("mediachanging", function() {
                  ["AUDIO", "SUBTITLES"].forEach(function(gl) {
                    return bi[gl].onGroupChanging();
                  });
                });
                var Ha = function() {
                  bi.AUDIO.onTrackChanged(), ci.trigger({
                    type: "usage",
                    name: "vhs-audio-change"
                  }), ci.trigger({
                    type: "usage",
                    name: "hls-audio-change"
                  });
                };
                ci.audioTracks().addEventListener("change", Ha), ci.remoteTextTracks().addEventListener("change", bi.SUBTITLES.onTrackChanged), hi.on("dispose", function() {
                  ci.audioTracks().removeEventListener("change", Ha), ci.remoteTextTracks().removeEventListener("change", bi.SUBTITLES.onTrackChanged);
                }), ci.clearTracks("audio");
                for (var ks in bi.AUDIO.tracks)
                  ci.audioTracks().addTrack(bi.AUDIO.tracks[ks]);
              }, Ci = function() {
                var Ei = {};
                return ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach(function(bi) {
                  Ei[bi] = {
                    groups: {},
                    tracks: {},
                    activePlaylistLoader: null,
                    activeGroup: hp,
                    activeTrack: hp,
                    getActiveGroup: hp,
                    onGroupChanged: hp,
                    onTrackChanged: hp,
                    lastTrack_: null,
                    logger_: Af("MediaGroups[" + bi + "]")
                  };
                }), Ei;
              }, ki = 120, Mo, Xo = ["mediaRequests", "mediaRequestsAborted", "mediaRequestsTimedout", "mediaRequestsErrored", "mediaTransferDuration", "mediaBytesTransferred", "mediaAppends"], Uo = function(Ei) {
                return this.audioSegmentLoader_[Ei] + this.mainSegmentLoader_[Ei];
              }, qa = function(Ei) {
                var bi = Ei.currentPlaylist, yi = Ei.buffered, ci = Ei.currentTime, hi = Ei.nextPlaylist, wi = Ei.bufferLowWaterLine, zi = Ei.bufferHighWaterLine, Wo = Ei.duration, aa = Ei.experimentalBufferBasedABR, Ea = Ei.log;
                if (!hi)
                  return Rl.log.warn("We received no playlist to switch to. Please check your stream."), !1;
                var Ka = "allowing switch " + (bi && bi.id || "null") + " -> " + hi.id;
                if (!bi)
                  return Ea(Ka + " as current playlist is not set"), !0;
                if (hi.id === bi.id)
                  return !1;
                var Ha = !!kh(yi, ci).length;
                if (!bi.endList)
                  return !Ha && typeof bi.partTargetDuration == "number" ? (Ea("not " + Ka + " as current playlist is live llhls, but currentTime isn't in buffered."), !1) : (Ea(Ka + " as current playlist is live"), !0);
                var ks = sg(yi, ci), gl = aa ? bd.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE : bd.MAX_BUFFER_LOW_WATER_LINE;
                if (Wo < gl)
                  return Ea(Ka + " as duration < max low water line (" + Wo + " < " + gl + ")"), !0;
                var Sl = hi.attributes.BANDWIDTH, Fl = bi.attributes.BANDWIDTH;
                if (Sl < Fl && (!aa || ks < zi)) {
                  var ru = Ka + " as next bandwidth < current bandwidth (" + Sl + " < " + Fl + ")";
                  return aa && (ru += " and forwardBuffer < bufferHighWaterLine (" + ks + " < " + zi + ")"), Ea(ru), !0;
                }
                if ((!aa || Sl > Fl) && ks >= wi) {
                  var $u = Ka + " as forwardBuffer >= bufferLowWaterLine (" + ks + " >= " + wi + ")";
                  return aa && ($u += " and next bandwidth > current bandwidth (" + Sl + " > " + Fl + ")"), Ea($u), !0;
                }
                return Ea("not " + Ka + " as no switching criteria met"), !1;
              }, Us = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi) {
                  var ci;
                  ci = Vi.call(this) || this;
                  var hi = yi.src, wi = yi.handleManifestRedirects, zi = yi.withCredentials, Wo = yi.tech, aa = yi.bandwidth, Ea = yi.externVhs, Ka = yi.useCueTags, Ha = yi.blacklistDuration, ks = yi.enableLowInitialPlaylist, gl = yi.sourceType, Sl = yi.cacheEncryptionKeys, Fl = yi.experimentalBufferBasedABR, ru = yi.experimentalLeastPixelDiffSelector, $u = yi.captionServices;
                  if (!hi)
                    throw new Error("A non-empty playlist URL or JSON manifest string is required");
                  var rc = yi.maxPlaylistRetries;
                  (rc === null || typeof rc > "u") && (rc = 1 / 0), Mo = Ea, ci.experimentalBufferBasedABR = !!Fl, ci.experimentalLeastPixelDiffSelector = !!ru, ci.withCredentials = zi, ci.tech_ = Wo, ci.vhs_ = Wo.vhs, ci.sourceType_ = gl, ci.useCueTags_ = Ka, ci.blacklistDuration = Ha, ci.maxPlaylistRetries = rc, ci.enableLowInitialPlaylist = ks, ci.useCueTags_ && (ci.cueTagsTrack_ = ci.tech_.addTextTrack("metadata", "ad-cues"), ci.cueTagsTrack_.inBandMetadataTrackDispatchType = ""), ci.requestOptions_ = {
                    withCredentials: zi,
                    handleManifestRedirects: wi,
                    maxPlaylistRetries: rc,
                    timeout: null
                  }, ci.on("error", ci.pauseLoading), ci.mediaTypes_ = Ci(), ci.mediaSource = new (di()).MediaSource(), ci.handleDurationChange_ = ci.handleDurationChange_.bind((0, xi.default)(ci)), ci.handleSourceOpen_ = ci.handleSourceOpen_.bind((0, xi.default)(ci)), ci.handleSourceEnded_ = ci.handleSourceEnded_.bind((0, xi.default)(ci)), ci.mediaSource.addEventListener("durationchange", ci.handleDurationChange_), ci.mediaSource.addEventListener("sourceopen", ci.handleSourceOpen_), ci.mediaSource.addEventListener("sourceended", ci.handleSourceEnded_), ci.seekable_ = Rl.createTimeRanges(), ci.hasPlayed_ = !1, ci.syncController_ = new Kl(yi), ci.segmentMetadataTrack_ = Wo.addRemoteTextTrack({
                    kind: "metadata",
                    label: "segment-metadata"
                  }, !1).track, ci.decrypter_ = new lu(), ci.sourceUpdater_ = new Fo(ci.mediaSource), ci.inbandTextTracks_ = {}, ci.timelineChangeController_ = new pl();
                  var Au = {
                    vhs: ci.vhs_,
                    parse708captions: yi.parse708captions,
                    useDtsForTimestampOffset: yi.useDtsForTimestampOffset,
                    captionServices: $u,
                    mediaSource: ci.mediaSource,
                    currentTime: ci.tech_.currentTime.bind(ci.tech_),
                    seekable: function() {
                      return ci.seekable();
                    },
                    seeking: function() {
                      return ci.tech_.seeking();
                    },
                    duration: function() {
                      return ci.duration();
                    },
                    hasPlayed: function() {
                      return ci.hasPlayed_;
                    },
                    goalBufferLength: function() {
                      return ci.goalBufferLength();
                    },
                    bandwidth: aa,
                    syncController: ci.syncController_,
                    decrypter: ci.decrypter_,
                    sourceType: ci.sourceType_,
                    inbandTextTracks: ci.inbandTextTracks_,
                    cacheEncryptionKeys: Sl,
                    sourceUpdater: ci.sourceUpdater_,
                    timelineChangeController: ci.timelineChangeController_,
                    experimentalExactManifestTimings: yi.experimentalExactManifestTimings
                  };
                  ci.masterPlaylistLoader_ = ci.sourceType_ === "dash" ? new cg(hi, ci.vhs_, ci.requestOptions_) : new jh(hi, ci.vhs_, ci.requestOptions_), ci.setupMasterPlaylistLoaderListeners_(), ci.mainSegmentLoader_ = new Ug(Rl.mergeOptions(Au, {
                    segmentMetadataTrack: ci.segmentMetadataTrack_,
                    loaderType: "main"
                  }), yi), ci.audioSegmentLoader_ = new Ug(Rl.mergeOptions(Au, {
                    loaderType: "audio"
                  }), yi), ci.subtitleSegmentLoader_ = new il(Rl.mergeOptions(Au, {
                    loaderType: "vtt",
                    featuresNativeTextTracks: ci.tech_.featuresNativeTextTracks,
                    loadVttJs: function() {
                      return new Promise(function(mu, au) {
                        function Pu() {
                          Wo.off("vttjserror", nu), mu();
                        }
                        function nu() {
                          Wo.off("vttjsloaded", Pu), au();
                        }
                        Wo.one("vttjsloaded", Pu), Wo.one("vttjserror", nu), Wo.addWebVttScript_();
                      });
                    }
                  }), yi), ci.setupSegmentLoaderListeners_(), ci.experimentalBufferBasedABR && (ci.masterPlaylistLoader_.one("loadedplaylist", function() {
                    return ci.startABRTimer_();
                  }), ci.tech_.on("pause", function() {
                    return ci.stopABRTimer_();
                  }), ci.tech_.on("play", function() {
                    return ci.startABRTimer_();
                  })), Xo.forEach(function(Bu) {
                    ci[Bu + "_"] = Uo.bind((0, xi.default)(ci), Bu);
                  }), ci.logger_ = Af("MPC"), ci.triggeredFmp4Usage = !1, ci.tech_.preload() === "none" ? (ci.loadOnPlay_ = function() {
                    ci.loadOnPlay_ = null, ci.masterPlaylistLoader_.load();
                  }, ci.tech_.one("play", ci.loadOnPlay_)) : ci.masterPlaylistLoader_.load(), ci.timeToLoadedData__ = -1, ci.mainAppendsToLoadedData__ = -1, ci.audioAppendsToLoadedData__ = -1;
                  var Iu = ci.tech_.preload() === "none" ? "play" : "loadstart";
                  return ci.tech_.one(Iu, function() {
                    var Bu = Date.now();
                    ci.tech_.one("loadeddata", function() {
                      ci.timeToLoadedData__ = Date.now() - Bu, ci.mainAppendsToLoadedData__ = ci.mainSegmentLoader_.mediaAppends, ci.audioAppendsToLoadedData__ = ci.audioSegmentLoader_.mediaAppends;
                    });
                  }), ci;
                }
                var bi = Ei.prototype;
                return bi.mainAppendsToLoadedData_ = function() {
                  return this.mainAppendsToLoadedData__;
                }, bi.audioAppendsToLoadedData_ = function() {
                  return this.audioAppendsToLoadedData__;
                }, bi.appendsToLoadedData_ = function() {
                  var ci = this.mainAppendsToLoadedData_(), hi = this.audioAppendsToLoadedData_();
                  return ci === -1 || hi === -1 ? -1 : ci + hi;
                }, bi.timeToLoadedData_ = function() {
                  return this.timeToLoadedData__;
                }, bi.checkABR_ = function(ci) {
                  ci === void 0 && (ci = "abr");
                  var hi = this.selectPlaylist();
                  hi && this.shouldSwitchToMedia_(hi) && this.switchMedia_(hi, ci);
                }, bi.switchMedia_ = function(ci, hi, wi) {
                  var zi = this.media(), Wo = zi && (zi.id || zi.uri), aa = ci.id || ci.uri;
                  Wo && Wo !== aa && (this.logger_("switch media " + Wo + " -> " + aa + " from " + hi), this.tech_.trigger({
                    type: "usage",
                    name: "vhs-rendition-change-" + hi
                  })), this.masterPlaylistLoader_.media(ci, wi);
                }, bi.startABRTimer_ = function() {
                  var ci = this;
                  this.stopABRTimer_(), this.abrTimer_ = di().setInterval(function() {
                    return ci.checkABR_();
                  }, 250);
                }, bi.stopABRTimer_ = function() {
                  this.tech_.scrubbing && this.tech_.scrubbing() || (di().clearInterval(this.abrTimer_), this.abrTimer_ = null);
                }, bi.getAudioTrackPlaylists_ = function() {
                  var ci = this.master(), hi = ci && ci.playlists || [];
                  if (!ci || !ci.mediaGroups || !ci.mediaGroups.AUDIO)
                    return hi;
                  var wi = ci.mediaGroups.AUDIO, zi = Object.keys(wi), Wo;
                  if (Object.keys(this.mediaTypes_.AUDIO.groups).length)
                    Wo = this.mediaTypes_.AUDIO.activeTrack();
                  else {
                    var aa = wi.main || zi.length && wi[zi[0]];
                    for (var Ea in aa)
                      if (aa[Ea].default) {
                        Wo = {
                          label: Ea
                        };
                        break;
                      }
                  }
                  if (!Wo)
                    return hi;
                  var Ka = [];
                  for (var Ha in wi)
                    if (wi[Ha][Wo.label]) {
                      var ks = wi[Ha][Wo.label];
                      if (ks.playlists && ks.playlists.length)
                        Ka.push.apply(Ka, ks.playlists);
                      else if (ks.uri)
                        Ka.push(ks);
                      else if (ci.playlists.length)
                        for (var gl = 0; gl < ci.playlists.length; gl++) {
                          var Sl = ci.playlists[gl];
                          Sl.attributes && Sl.attributes.AUDIO && Sl.attributes.AUDIO === Ha && Ka.push(Sl);
                        }
                    }
                  return Ka.length ? Ka : hi;
                }, bi.setupMasterPlaylistLoaderListeners_ = function() {
                  var ci = this;
                  this.masterPlaylistLoader_.on("loadedmetadata", function() {
                    var hi = ci.masterPlaylistLoader_.media(), wi = hi.targetDuration * 1.5 * 1e3;
                    im(ci.masterPlaylistLoader_.master, ci.masterPlaylistLoader_.media()) ? ci.requestOptions_.timeout = 0 : ci.requestOptions_.timeout = wi, hi.endList && ci.tech_.preload() !== "none" && (ci.mainSegmentLoader_.playlist(hi, ci.requestOptions_), ci.mainSegmentLoader_.load()), Bi({
                      sourceType: ci.sourceType_,
                      segmentLoaders: {
                        AUDIO: ci.audioSegmentLoader_,
                        SUBTITLES: ci.subtitleSegmentLoader_,
                        main: ci.mainSegmentLoader_
                      },
                      tech: ci.tech_,
                      requestOptions: ci.requestOptions_,
                      masterPlaylistLoader: ci.masterPlaylistLoader_,
                      vhs: ci.vhs_,
                      master: ci.master(),
                      mediaTypes: ci.mediaTypes_,
                      blacklistCurrentPlaylist: ci.blacklistCurrentPlaylist.bind(ci)
                    }), ci.triggerPresenceUsage_(ci.master(), hi), ci.setupFirstPlay(), !ci.mediaTypes_.AUDIO.activePlaylistLoader || ci.mediaTypes_.AUDIO.activePlaylistLoader.media() ? ci.trigger("selectedinitialmedia") : ci.mediaTypes_.AUDIO.activePlaylistLoader.one("loadedmetadata", function() {
                      ci.trigger("selectedinitialmedia");
                    });
                  }), this.masterPlaylistLoader_.on("loadedplaylist", function() {
                    ci.loadOnPlay_ && ci.tech_.off("play", ci.loadOnPlay_);
                    var hi = ci.masterPlaylistLoader_.media();
                    if (!hi) {
                      ci.excludeUnsupportedVariants_();
                      var wi;
                      if (ci.enableLowInitialPlaylist && (wi = ci.selectInitialPlaylist()), wi || (wi = ci.selectPlaylist()), !wi || !ci.shouldSwitchToMedia_(wi))
                        return;
                      ci.initialMedia_ = wi, ci.switchMedia_(ci.initialMedia_, "initial");
                      var zi = ci.sourceType_ === "vhs-json" && ci.initialMedia_.segments;
                      if (!zi)
                        return;
                      hi = ci.initialMedia_;
                    }
                    ci.handleUpdatedMediaPlaylist(hi);
                  }), this.masterPlaylistLoader_.on("error", function() {
                    ci.blacklistCurrentPlaylist(ci.masterPlaylistLoader_.error);
                  }), this.masterPlaylistLoader_.on("mediachanging", function() {
                    ci.mainSegmentLoader_.abort(), ci.mainSegmentLoader_.pause();
                  }), this.masterPlaylistLoader_.on("mediachange", function() {
                    var hi = ci.masterPlaylistLoader_.media(), wi = hi.targetDuration * 1.5 * 1e3;
                    im(ci.masterPlaylistLoader_.master, ci.masterPlaylistLoader_.media()) ? ci.requestOptions_.timeout = 0 : ci.requestOptions_.timeout = wi, ci.masterPlaylistLoader_.load(), ci.mainSegmentLoader_.playlist(hi, ci.requestOptions_), ci.mainSegmentLoader_.load(), ci.tech_.trigger({
                      type: "mediachange",
                      bubbles: !0
                    });
                  }), this.masterPlaylistLoader_.on("playlistunchanged", function() {
                    var hi = ci.masterPlaylistLoader_.media();
                    if (hi.lastExcludeReason_ !== "playlist-unchanged") {
                      var wi = ci.stuckAtPlaylistEnd_(hi);
                      wi && (ci.blacklistCurrentPlaylist({
                        message: "Playlist no longer updating.",
                        reason: "playlist-unchanged"
                      }), ci.tech_.trigger("playliststuck"));
                    }
                  }), this.masterPlaylistLoader_.on("renditiondisabled", function() {
                    ci.tech_.trigger({
                      type: "usage",
                      name: "vhs-rendition-disabled"
                    }), ci.tech_.trigger({
                      type: "usage",
                      name: "hls-rendition-disabled"
                    });
                  }), this.masterPlaylistLoader_.on("renditionenabled", function() {
                    ci.tech_.trigger({
                      type: "usage",
                      name: "vhs-rendition-enabled"
                    }), ci.tech_.trigger({
                      type: "usage",
                      name: "hls-rendition-enabled"
                    });
                  });
                }, bi.handleUpdatedMediaPlaylist = function(ci) {
                  this.useCueTags_ && this.updateAdCues_(ci), this.mainSegmentLoader_.playlist(ci, this.requestOptions_), this.updateDuration(!ci.endList), this.tech_.paused() || (this.mainSegmentLoader_.load(), this.audioSegmentLoader_ && this.audioSegmentLoader_.load());
                }, bi.triggerPresenceUsage_ = function(ci, hi) {
                  var wi = ci.mediaGroups || {}, zi = !0, Wo = Object.keys(wi.AUDIO);
                  for (var aa in wi.AUDIO)
                    for (var Ea in wi.AUDIO[aa]) {
                      var Ka = wi.AUDIO[aa][Ea];
                      Ka.uri || (zi = !1);
                    }
                  zi && (this.tech_.trigger({
                    type: "usage",
                    name: "vhs-demuxed"
                  }), this.tech_.trigger({
                    type: "usage",
                    name: "hls-demuxed"
                  })), Object.keys(wi.SUBTITLES).length && (this.tech_.trigger({
                    type: "usage",
                    name: "vhs-webvtt"
                  }), this.tech_.trigger({
                    type: "usage",
                    name: "hls-webvtt"
                  })), Mo.Playlist.isAes(hi) && (this.tech_.trigger({
                    type: "usage",
                    name: "vhs-aes"
                  }), this.tech_.trigger({
                    type: "usage",
                    name: "hls-aes"
                  })), Wo.length && Object.keys(wi.AUDIO[Wo[0]]).length > 1 && (this.tech_.trigger({
                    type: "usage",
                    name: "vhs-alternate-audio"
                  }), this.tech_.trigger({
                    type: "usage",
                    name: "hls-alternate-audio"
                  })), this.useCueTags_ && (this.tech_.trigger({
                    type: "usage",
                    name: "vhs-playlist-cue-tags"
                  }), this.tech_.trigger({
                    type: "usage",
                    name: "hls-playlist-cue-tags"
                  }));
                }, bi.shouldSwitchToMedia_ = function(ci) {
                  var hi = this.masterPlaylistLoader_.media() || this.masterPlaylistLoader_.pendingMedia_, wi = this.tech_.currentTime(), zi = this.bufferLowWaterLine(), Wo = this.bufferHighWaterLine(), aa = this.tech_.buffered();
                  return qa({
                    buffered: aa,
                    currentTime: wi,
                    currentPlaylist: hi,
                    nextPlaylist: ci,
                    bufferLowWaterLine: zi,
                    bufferHighWaterLine: Wo,
                    duration: this.duration(),
                    experimentalBufferBasedABR: this.experimentalBufferBasedABR,
                    log: this.logger_
                  });
                }, bi.setupSegmentLoaderListeners_ = function() {
                  var ci = this;
                  this.mainSegmentLoader_.on("bandwidthupdate", function() {
                    ci.checkABR_("bandwidthupdate"), ci.tech_.trigger("bandwidthupdate");
                  }), this.mainSegmentLoader_.on("timeout", function() {
                    ci.experimentalBufferBasedABR && ci.mainSegmentLoader_.load();
                  }), this.experimentalBufferBasedABR || this.mainSegmentLoader_.on("progress", function() {
                    ci.trigger("progress");
                  }), this.mainSegmentLoader_.on("error", function() {
                    ci.blacklistCurrentPlaylist(ci.mainSegmentLoader_.error());
                  }), this.mainSegmentLoader_.on("appenderror", function() {
                    ci.error = ci.mainSegmentLoader_.error_, ci.trigger("error");
                  }), this.mainSegmentLoader_.on("syncinfoupdate", function() {
                    ci.onSyncInfoUpdate_();
                  }), this.mainSegmentLoader_.on("timestampoffset", function() {
                    ci.tech_.trigger({
                      type: "usage",
                      name: "vhs-timestamp-offset"
                    }), ci.tech_.trigger({
                      type: "usage",
                      name: "hls-timestamp-offset"
                    });
                  }), this.audioSegmentLoader_.on("syncinfoupdate", function() {
                    ci.onSyncInfoUpdate_();
                  }), this.audioSegmentLoader_.on("appenderror", function() {
                    ci.error = ci.audioSegmentLoader_.error_, ci.trigger("error");
                  }), this.mainSegmentLoader_.on("ended", function() {
                    ci.logger_("main segment loader ended"), ci.onEndOfStream();
                  }), this.mainSegmentLoader_.on("earlyabort", function(wi) {
                    ci.experimentalBufferBasedABR || (ci.delegateLoaders_("all", ["abort"]), ci.blacklistCurrentPlaylist({
                      message: "Aborted early because there isn't enough bandwidth to complete the request without rebuffering."
                    }, ki));
                  });
                  var hi = function() {
                    if (!ci.sourceUpdater_.hasCreatedSourceBuffers())
                      return ci.tryToCreateSourceBuffers_();
                    var zi = ci.getCodecsOrExclude_();
                    zi && ci.sourceUpdater_.addOrChangeSourceBuffers(zi);
                  };
                  this.mainSegmentLoader_.on("trackinfo", hi), this.audioSegmentLoader_.on("trackinfo", hi), this.mainSegmentLoader_.on("fmp4", function() {
                    ci.triggeredFmp4Usage || (ci.tech_.trigger({
                      type: "usage",
                      name: "vhs-fmp4"
                    }), ci.tech_.trigger({
                      type: "usage",
                      name: "hls-fmp4"
                    }), ci.triggeredFmp4Usage = !0);
                  }), this.audioSegmentLoader_.on("fmp4", function() {
                    ci.triggeredFmp4Usage || (ci.tech_.trigger({
                      type: "usage",
                      name: "vhs-fmp4"
                    }), ci.tech_.trigger({
                      type: "usage",
                      name: "hls-fmp4"
                    }), ci.triggeredFmp4Usage = !0);
                  }), this.audioSegmentLoader_.on("ended", function() {
                    ci.logger_("audioSegmentLoader ended"), ci.onEndOfStream();
                  });
                }, bi.mediaSecondsLoaded_ = function() {
                  return Math.max(this.audioSegmentLoader_.mediaSecondsLoaded + this.mainSegmentLoader_.mediaSecondsLoaded);
                }, bi.load = function() {
                  this.mainSegmentLoader_.load(), this.mediaTypes_.AUDIO.activePlaylistLoader && this.audioSegmentLoader_.load(), this.mediaTypes_.SUBTITLES.activePlaylistLoader && this.subtitleSegmentLoader_.load();
                }, bi.smoothQualityChange_ = function(ci) {
                  ci === void 0 && (ci = this.selectPlaylist()), this.fastQualityChange_(ci);
                }, bi.fastQualityChange_ = function(ci) {
                  var hi = this;
                  if (ci === void 0 && (ci = this.selectPlaylist()), ci === this.masterPlaylistLoader_.media()) {
                    this.logger_("skipping fastQualityChange because new media is same as old");
                    return;
                  }
                  this.switchMedia_(ci, "fast-quality"), this.mainSegmentLoader_.resetEverything(function() {
                    Rl.browser.IE_VERSION || Rl.browser.IS_EDGE ? hi.tech_.setCurrentTime(hi.tech_.currentTime() + 0.04) : hi.tech_.setCurrentTime(hi.tech_.currentTime());
                  });
                }, bi.play = function() {
                  if (!this.setupFirstPlay()) {
                    this.tech_.ended() && this.tech_.setCurrentTime(0), this.hasPlayed_ && this.load();
                    var ci = this.tech_.seekable();
                    if (this.tech_.duration() === 1 / 0 && this.tech_.currentTime() < ci.start(0))
                      return this.tech_.setCurrentTime(ci.end(ci.length - 1));
                  }
                }, bi.setupFirstPlay = function() {
                  var ci = this, hi = this.masterPlaylistLoader_.media();
                  if (!hi || this.tech_.paused() || this.hasPlayed_)
                    return !1;
                  if (!hi.endList) {
                    var wi = this.seekable();
                    if (!wi.length)
                      return !1;
                    if (Rl.browser.IE_VERSION && this.tech_.readyState() === 0)
                      return this.tech_.one("loadedmetadata", function() {
                        ci.trigger("firstplay"), ci.tech_.setCurrentTime(wi.end(0)), ci.hasPlayed_ = !0;
                      }), !1;
                    this.trigger("firstplay"), this.tech_.setCurrentTime(wi.end(0));
                  }
                  return this.hasPlayed_ = !0, this.load(), !0;
                }, bi.handleSourceOpen_ = function() {
                  if (this.tryToCreateSourceBuffers_(), this.tech_.autoplay()) {
                    var ci = this.tech_.play();
                    typeof ci < "u" && typeof ci.then == "function" && ci.then(null, function(hi) {
                    });
                  }
                  this.trigger("sourceopen");
                }, bi.handleSourceEnded_ = function() {
                  if (this.inbandTextTracks_.metadataTrack_) {
                    var ci = this.inbandTextTracks_.metadataTrack_.cues;
                    if (!(!ci || !ci.length)) {
                      var hi = this.duration();
                      ci[ci.length - 1].endTime = isNaN(hi) || Math.abs(hi) === 1 / 0 ? Number.MAX_VALUE : hi;
                    }
                  }
                }, bi.handleDurationChange_ = function() {
                  this.tech_.trigger("durationchange");
                }, bi.onEndOfStream = function() {
                  var ci = this.mainSegmentLoader_.ended_;
                  if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
                    var hi = this.mainSegmentLoader_.getCurrentMediaInfo_();
                    !hi || hi.hasVideo ? ci = ci && this.audioSegmentLoader_.ended_ : ci = this.audioSegmentLoader_.ended_;
                  }
                  ci && (this.stopABRTimer_(), this.sourceUpdater_.endOfStream());
                }, bi.stuckAtPlaylistEnd_ = function(ci) {
                  var hi = this.seekable();
                  if (!hi.length)
                    return !1;
                  var wi = this.syncController_.getExpiredTime(ci, this.duration());
                  if (wi === null)
                    return !1;
                  var zi = Mo.Playlist.playlistEnd(ci, wi), Wo = this.tech_.currentTime(), aa = this.tech_.buffered();
                  if (!aa.length)
                    return zi - Wo <= Jf;
                  var Ea = aa.end(aa.length - 1);
                  return Ea - Wo <= Jf && zi - Ea <= Jf;
                }, bi.blacklistCurrentPlaylist = function(ci, hi) {
                  ci === void 0 && (ci = {});
                  var wi = ci.playlist || this.masterPlaylistLoader_.media();
                  if (hi = hi || ci.blacklistDuration || this.blacklistDuration, !wi) {
                    this.error = ci, this.mediaSource.readyState !== "open" ? this.trigger("error") : this.sourceUpdater_.endOfStream("network");
                    return;
                  }
                  wi.playlistErrors_++;
                  var zi = this.masterPlaylistLoader_.master.playlists, Wo = zi.filter(Nh), aa = Wo.length === 1 && Wo[0] === wi;
                  if (zi.length === 1 && hi !== 1 / 0)
                    return Rl.log.warn("Problem encountered with playlist " + wi.id + ". Trying again since it is the only playlist."), this.tech_.trigger("retryplaylist"), this.masterPlaylistLoader_.load(aa);
                  if (aa) {
                    var Ea = !1;
                    zi.forEach(function(ru) {
                      if (ru !== wi) {
                        var $u = ru.excludeUntil;
                        typeof $u < "u" && $u !== 1 / 0 && (Ea = !0, delete ru.excludeUntil);
                      }
                    }), Ea && (Rl.log.warn("Removing other playlists from the exclusion list because the last rendition is about to be excluded."), this.tech_.trigger("retryplaylist"));
                  }
                  var Ka;
                  wi.playlistErrors_ > this.maxPlaylistRetries ? Ka = 1 / 0 : Ka = Date.now() + hi * 1e3, wi.excludeUntil = Ka, ci.reason && (wi.lastExcludeReason_ = ci.reason), this.tech_.trigger("blacklistplaylist"), this.tech_.trigger({
                    type: "usage",
                    name: "vhs-rendition-blacklisted"
                  }), this.tech_.trigger({
                    type: "usage",
                    name: "hls-rendition-blacklisted"
                  });
                  var Ha = this.selectPlaylist();
                  if (!Ha) {
                    this.error = "Playback cannot continue. No available working or supported playlists.", this.trigger("error");
                    return;
                  }
                  var ks = ci.internal ? this.logger_ : Rl.log.warn, gl = ci.message ? " " + ci.message : "";
                  ks((ci.internal ? "Internal problem" : "Problem") + " encountered with playlist " + wi.id + "." + (gl + " Switching to playlist " + Ha.id + ".")), Ha.attributes.AUDIO !== wi.attributes.AUDIO && this.delegateLoaders_("audio", ["abort", "pause"]), Ha.attributes.SUBTITLES !== wi.attributes.SUBTITLES && this.delegateLoaders_("subtitle", ["abort", "pause"]), this.delegateLoaders_("main", ["abort", "pause"]);
                  var Sl = Ha.targetDuration / 2 * 1e3 || 5 * 1e3, Fl = typeof Ha.lastRequest == "number" && Date.now() - Ha.lastRequest <= Sl;
                  return this.switchMedia_(Ha, "exclude", aa || Fl);
                }, bi.pauseLoading = function() {
                  this.delegateLoaders_("all", ["abort", "pause"]), this.stopABRTimer_();
                }, bi.delegateLoaders_ = function(ci, hi) {
                  var wi = this, zi = [], Wo = ci === "all";
                  (Wo || ci === "main") && zi.push(this.masterPlaylistLoader_);
                  var aa = [];
                  (Wo || ci === "audio") && aa.push("AUDIO"), (Wo || ci === "subtitle") && (aa.push("CLOSED-CAPTIONS"), aa.push("SUBTITLES")), aa.forEach(function(Ea) {
                    var Ka = wi.mediaTypes_[Ea] && wi.mediaTypes_[Ea].activePlaylistLoader;
                    Ka && zi.push(Ka);
                  }), ["main", "audio", "subtitle"].forEach(function(Ea) {
                    var Ka = wi[Ea + "SegmentLoader_"];
                    Ka && (ci === Ea || ci === "all") && zi.push(Ka);
                  }), zi.forEach(function(Ea) {
                    return hi.forEach(function(Ka) {
                      typeof Ea[Ka] == "function" && Ea[Ka]();
                    });
                  });
                }, bi.setCurrentTime = function(ci) {
                  var hi = kh(this.tech_.buffered(), ci);
                  if (!(this.masterPlaylistLoader_ && this.masterPlaylistLoader_.media()) || !this.masterPlaylistLoader_.media().segments)
                    return 0;
                  if (hi && hi.length)
                    return ci;
                  this.mainSegmentLoader_.resetEverything(), this.mainSegmentLoader_.abort(), this.mediaTypes_.AUDIO.activePlaylistLoader && (this.audioSegmentLoader_.resetEverything(), this.audioSegmentLoader_.abort()), this.mediaTypes_.SUBTITLES.activePlaylistLoader && (this.subtitleSegmentLoader_.resetEverything(), this.subtitleSegmentLoader_.abort()), this.load();
                }, bi.duration = function() {
                  if (!this.masterPlaylistLoader_)
                    return 0;
                  var ci = this.masterPlaylistLoader_.media();
                  return ci ? ci.endList ? this.mediaSource ? this.mediaSource.duration : Mo.Playlist.duration(ci) : 1 / 0 : 0;
                }, bi.seekable = function() {
                  return this.seekable_;
                }, bi.onSyncInfoUpdate_ = function() {
                  var ci;
                  if (this.masterPlaylistLoader_) {
                    var hi = this.masterPlaylistLoader_.media();
                    if (hi) {
                      var wi = this.syncController_.getExpiredTime(hi, this.duration());
                      if (wi !== null) {
                        var zi = this.masterPlaylistLoader_.master, Wo = Mo.Playlist.seekable(hi, wi, Mo.Playlist.liveEdgeDelay(zi, hi));
                        if (Wo.length !== 0 && !(this.mediaTypes_.AUDIO.activePlaylistLoader && (hi = this.mediaTypes_.AUDIO.activePlaylistLoader.media(), wi = this.syncController_.getExpiredTime(hi, this.duration()), wi === null || (ci = Mo.Playlist.seekable(hi, wi, Mo.Playlist.liveEdgeDelay(zi, hi)), ci.length === 0)))) {
                          var aa, Ea;
                          this.seekable_ && this.seekable_.length && (aa = this.seekable_.end(0), Ea = this.seekable_.start(0)), ci ? ci.start(0) > Wo.end(0) || Wo.start(0) > ci.end(0) ? this.seekable_ = Wo : this.seekable_ = Rl.createTimeRanges([[ci.start(0) > Wo.start(0) ? ci.start(0) : Wo.start(0), ci.end(0) < Wo.end(0) ? ci.end(0) : Wo.end(0)]]) : this.seekable_ = Wo, !(this.seekable_ && this.seekable_.length && this.seekable_.end(0) === aa && this.seekable_.start(0) === Ea) && (this.logger_("seekable updated [" + Ym(this.seekable_) + "]"), this.tech_.trigger("seekablechanged"));
                        }
                      }
                    }
                  }
                }, bi.updateDuration = function(ci) {
                  if (this.updateDuration_ && (this.mediaSource.removeEventListener("sourceopen", this.updateDuration_), this.updateDuration_ = null), this.mediaSource.readyState !== "open") {
                    this.updateDuration_ = this.updateDuration.bind(this, ci), this.mediaSource.addEventListener("sourceopen", this.updateDuration_);
                    return;
                  }
                  if (ci) {
                    var hi = this.seekable();
                    if (!hi.length)
                      return;
                    (isNaN(this.mediaSource.duration) || this.mediaSource.duration < hi.end(hi.length - 1)) && this.sourceUpdater_.setDuration(hi.end(hi.length - 1));
                    return;
                  }
                  var wi = this.tech_.buffered(), zi = Mo.Playlist.duration(this.masterPlaylistLoader_.media());
                  wi.length > 0 && (zi = Math.max(zi, wi.end(wi.length - 1))), this.mediaSource.duration !== zi && this.sourceUpdater_.setDuration(zi);
                }, bi.dispose = function() {
                  var ci = this;
                  this.trigger("dispose"), this.decrypter_.terminate(), this.masterPlaylistLoader_.dispose(), this.mainSegmentLoader_.dispose(), this.loadOnPlay_ && this.tech_.off("play", this.loadOnPlay_), ["AUDIO", "SUBTITLES"].forEach(function(hi) {
                    var wi = ci.mediaTypes_[hi].groups;
                    for (var zi in wi)
                      wi[zi].forEach(function(Wo) {
                        Wo.playlistLoader && Wo.playlistLoader.dispose();
                      });
                  }), this.audioSegmentLoader_.dispose(), this.subtitleSegmentLoader_.dispose(), this.sourceUpdater_.dispose(), this.timelineChangeController_.dispose(), this.stopABRTimer_(), this.updateDuration_ && this.mediaSource.removeEventListener("sourceopen", this.updateDuration_), this.mediaSource.removeEventListener("durationchange", this.handleDurationChange_), this.mediaSource.removeEventListener("sourceopen", this.handleSourceOpen_), this.mediaSource.removeEventListener("sourceended", this.handleSourceEnded_), this.off();
                }, bi.master = function() {
                  return this.masterPlaylistLoader_.master;
                }, bi.media = function() {
                  return this.masterPlaylistLoader_.media() || this.initialMedia_;
                }, bi.areMediaTypesKnown_ = function() {
                  var ci = !!this.mediaTypes_.AUDIO.activePlaylistLoader, hi = !!this.mainSegmentLoader_.getCurrentMediaInfo_(), wi = ci ? !!this.audioSegmentLoader_.getCurrentMediaInfo_() : !0;
                  return !(!hi || !wi);
                }, bi.getCodecsOrExclude_ = function() {
                  var ci = this, hi = {
                    main: this.mainSegmentLoader_.getCurrentMediaInfo_() || {},
                    audio: this.audioSegmentLoader_.getCurrentMediaInfo_() || {}
                  }, wi = this.mainSegmentLoader_.getPendingSegmentPlaylist() || this.media();
                  hi.video = hi.main;
                  var zi = Uh(this.master(), wi), Wo = {}, aa = !!this.mediaTypes_.AUDIO.activePlaylistLoader;
                  if (hi.main.hasVideo && (Wo.video = zi.video || hi.main.videoCodec || Li.DEFAULT_VIDEO_CODEC), hi.main.isMuxed && (Wo.video += "," + (zi.audio || hi.main.audioCodec || Li.DEFAULT_AUDIO_CODEC)), (hi.main.hasAudio && !hi.main.isMuxed || hi.audio.hasAudio || aa) && (Wo.audio = zi.audio || hi.main.audioCodec || hi.audio.audioCodec || Li.DEFAULT_AUDIO_CODEC, hi.audio.isFmp4 = hi.main.hasAudio && !hi.main.isMuxed ? hi.main.isFmp4 : hi.audio.isFmp4), !Wo.audio && !Wo.video) {
                    this.blacklistCurrentPlaylist({
                      playlist: wi,
                      message: "Could not determine codecs for playlist.",
                      blacklistDuration: 1 / 0
                    });
                    return;
                  }
                  var Ea = function(ru, $u) {
                    return ru ? (0, Li.browserSupportsCodec)($u) : (0, Li.muxerSupportsCodec)($u);
                  }, Ka = {}, Ha;
                  if (["video", "audio"].forEach(function(Fl) {
                    if (Wo.hasOwnProperty(Fl) && !Ea(hi[Fl].isFmp4, Wo[Fl])) {
                      var ru = hi[Fl].isFmp4 ? "browser" : "muxer";
                      Ka[ru] = Ka[ru] || [], Ka[ru].push(Wo[Fl]), Fl === "audio" && (Ha = ru);
                    }
                  }), aa && Ha && wi.attributes.AUDIO) {
                    var ks = wi.attributes.AUDIO;
                    this.master().playlists.forEach(function(Fl) {
                      var ru = Fl.attributes && Fl.attributes.AUDIO;
                      ru === ks && Fl !== wi && (Fl.excludeUntil = 1 / 0);
                    }), this.logger_("excluding audio group " + ks + " as " + Ha + ' does not support codec(s): "' + Wo.audio + '"');
                  }
                  if (Object.keys(Ka).length) {
                    var gl = Object.keys(Ka).reduce(function(Fl, ru) {
                      return Fl && (Fl += ", "), Fl += ru + ' does not support codec(s): "' + Ka[ru].join(",") + '"', Fl;
                    }, "") + ".";
                    this.blacklistCurrentPlaylist({
                      playlist: wi,
                      internal: !0,
                      message: gl,
                      blacklistDuration: 1 / 0
                    });
                    return;
                  }
                  if (this.sourceUpdater_.hasCreatedSourceBuffers() && !this.sourceUpdater_.canChangeType()) {
                    var Sl = [];
                    if (["video", "audio"].forEach(function(Fl) {
                      var ru = ((0, Li.parseCodecs)(ci.sourceUpdater_.codecs[Fl] || "")[0] || {}).type, $u = ((0, Li.parseCodecs)(Wo[Fl] || "")[0] || {}).type;
                      ru && $u && ru.toLowerCase() !== $u.toLowerCase() && Sl.push('"' + ci.sourceUpdater_.codecs[Fl] + '" -> "' + Wo[Fl] + '"');
                    }), Sl.length) {
                      this.blacklistCurrentPlaylist({
                        playlist: wi,
                        message: "Codec switching not supported: " + Sl.join(", ") + ".",
                        blacklistDuration: 1 / 0,
                        internal: !0
                      });
                      return;
                    }
                  }
                  return Wo;
                }, bi.tryToCreateSourceBuffers_ = function() {
                  if (!(this.mediaSource.readyState !== "open" || this.sourceUpdater_.hasCreatedSourceBuffers()) && this.areMediaTypesKnown_()) {
                    var ci = this.getCodecsOrExclude_();
                    if (ci) {
                      this.sourceUpdater_.createSourceBuffers(ci);
                      var hi = [ci.video, ci.audio].filter(Boolean).join(",");
                      this.excludeIncompatibleVariants_(hi);
                    }
                  }
                }, bi.excludeUnsupportedVariants_ = function() {
                  var ci = this, hi = this.master().playlists, wi = [];
                  Object.keys(hi).forEach(function(zi) {
                    var Wo = hi[zi];
                    if (wi.indexOf(Wo.id) === -1) {
                      wi.push(Wo.id);
                      var aa = Uh(ci.master, Wo), Ea = [];
                      aa.audio && !(0, Li.muxerSupportsCodec)(aa.audio) && !(0, Li.browserSupportsCodec)(aa.audio) && Ea.push("audio codec " + aa.audio), aa.video && !(0, Li.muxerSupportsCodec)(aa.video) && !(0, Li.browserSupportsCodec)(aa.video) && Ea.push("video codec " + aa.video), aa.text && aa.text === "stpp.ttml.im1t" && Ea.push("text codec " + aa.text), Ea.length && (Wo.excludeUntil = 1 / 0, ci.logger_("excluding " + Wo.id + " for unsupported: " + Ea.join(", ")));
                    }
                  });
                }, bi.excludeIncompatibleVariants_ = function(ci) {
                  var hi = this, wi = [], zi = this.master().playlists, Wo = kf((0, Li.parseCodecs)(ci)), aa = Mg(Wo), Ea = Wo.video && (0, Li.parseCodecs)(Wo.video)[0] || null, Ka = Wo.audio && (0, Li.parseCodecs)(Wo.audio)[0] || null;
                  Object.keys(zi).forEach(function(Ha) {
                    var ks = zi[Ha];
                    if (!(wi.indexOf(ks.id) !== -1 || ks.excludeUntil === 1 / 0)) {
                      wi.push(ks.id);
                      var gl = [], Sl = Uh(hi.masterPlaylistLoader_.master, ks), Fl = Mg(Sl);
                      if (!(!Sl.audio && !Sl.video)) {
                        if (Fl !== aa && gl.push('codec count "' + Fl + '" !== "' + aa + '"'), !hi.sourceUpdater_.canChangeType()) {
                          var ru = Sl.video && (0, Li.parseCodecs)(Sl.video)[0] || null, $u = Sl.audio && (0, Li.parseCodecs)(Sl.audio)[0] || null;
                          ru && Ea && ru.type.toLowerCase() !== Ea.type.toLowerCase() && gl.push('video codec "' + ru.type + '" !== "' + Ea.type + '"'), $u && Ka && $u.type.toLowerCase() !== Ka.type.toLowerCase() && gl.push('audio codec "' + $u.type + '" !== "' + Ka.type + '"');
                        }
                        gl.length && (ks.excludeUntil = 1 / 0, hi.logger_("blacklisting " + ks.id + ": " + gl.join(" && ")));
                      }
                    }
                  });
                }, bi.updateAdCues_ = function(ci) {
                  var hi = 0, wi = this.seekable();
                  wi.length && (hi = wi.start(0)), Ql(ci, this.cueTagsTrack_, hi);
                }, bi.goalBufferLength = function() {
                  var ci = this.tech_.currentTime(), hi = bd.GOAL_BUFFER_LENGTH, wi = bd.GOAL_BUFFER_LENGTH_RATE, zi = Math.max(hi, bd.MAX_GOAL_BUFFER_LENGTH);
                  return Math.min(hi + ci * wi, zi);
                }, bi.bufferLowWaterLine = function() {
                  var ci = this.tech_.currentTime(), hi = bd.BUFFER_LOW_WATER_LINE, wi = bd.BUFFER_LOW_WATER_LINE_RATE, zi = Math.max(hi, bd.MAX_BUFFER_LOW_WATER_LINE), Wo = Math.max(hi, bd.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE);
                  return Math.min(hi + ci * wi, this.experimentalBufferBasedABR ? Wo : zi);
                }, bi.bufferHighWaterLine = function() {
                  return bd.BUFFER_HIGH_WATER_LINE;
                }, Ei;
              })(Rl.EventTarget), Hs = function(Ei, bi, yi) {
                return function(ci) {
                  var hi = Ei.master.playlists[bi], wi = rm(hi), zi = Nh(hi);
                  return typeof ci > "u" ? zi : (ci ? delete hi.disabled : hi.disabled = !0, ci !== zi && !wi && (yi(), ci ? Ei.trigger("renditionenabled") : Ei.trigger("renditiondisabled")), ci);
                };
              }, jl = function(Ei, bi, yi) {
                var ci = Ei.masterPlaylistController_, hi = Ei.options_.smoothQualityChange, wi = hi ? "smooth" : "fast", zi = ci[wi + "QualityChange_"].bind(ci);
                if (bi.attributes) {
                  var Wo = bi.attributes.RESOLUTION;
                  this.width = Wo && Wo.width, this.height = Wo && Wo.height, this.bandwidth = bi.attributes.BANDWIDTH, this.frameRate = bi.attributes["FRAME-RATE"];
                }
                this.codecs = Uh(ci.master(), bi), this.playlist = bi, this.id = yi, this.enabled = Hs(Ei.playlists, bi.id, zi);
              }, Al = function(Ei) {
                Ei.representations = function() {
                  var bi = Ei.masterPlaylistController_.master(), yi = Mh(bi) ? Ei.masterPlaylistController_.getAudioTrackPlaylists_() : bi.playlists;
                  return yi ? yi.filter(function(ci) {
                    return !rm(ci);
                  }).map(function(ci, hi) {
                    return new jl(Ei, ci, ci.id);
                  }) : [];
                };
              }, Ml = ["seeking", "seeked", "pause", "playing", "error"], ub = /* @__PURE__ */ (function() {
                function Vi(bi) {
                  var yi = this;
                  this.masterPlaylistController_ = bi.masterPlaylistController, this.tech_ = bi.tech, this.seekable = bi.seekable, this.allowSeeksWithinUnsafeLiveWindow = bi.allowSeeksWithinUnsafeLiveWindow, this.liveRangeSafeTimeDelta = bi.liveRangeSafeTimeDelta, this.media = bi.media, this.consecutiveUpdates = 0, this.lastRecordedTime = null, this.timer_ = null, this.checkCurrentTimeTimeout_ = null, this.logger_ = Af("PlaybackWatcher"), this.logger_("initialize");
                  var ci = function() {
                    return yi.monitorCurrentTime_();
                  }, hi = function() {
                    return yi.monitorCurrentTime_();
                  }, wi = function() {
                    return yi.techWaiting_();
                  }, zi = function() {
                    return yi.cancelTimer_();
                  }, Wo = this.masterPlaylistController_, aa = ["main", "subtitle", "audio"], Ea = {};
                  aa.forEach(function(Ha) {
                    Ea[Ha] = {
                      reset: function() {
                        return yi.resetSegmentDownloads_(Ha);
                      },
                      updateend: function() {
                        return yi.checkSegmentDownloads_(Ha);
                      }
                    }, Wo[Ha + "SegmentLoader_"].on("appendsdone", Ea[Ha].updateend), Wo[Ha + "SegmentLoader_"].on("playlistupdate", Ea[Ha].reset), yi.tech_.on(["seeked", "seeking"], Ea[Ha].reset);
                  });
                  var Ka = function(ks) {
                    ["main", "audio"].forEach(function(gl) {
                      Wo[gl + "SegmentLoader_"][ks]("appended", yi.seekingAppendCheck_);
                    });
                  };
                  this.seekingAppendCheck_ = function() {
                    yi.fixesBadSeeks_() && (yi.consecutiveUpdates = 0, yi.lastRecordedTime = yi.tech_.currentTime(), Ka("off"));
                  }, this.clearSeekingAppendCheck_ = function() {
                    return Ka("off");
                  }, this.watchForBadSeeking_ = function() {
                    yi.clearSeekingAppendCheck_(), Ka("on");
                  }, this.tech_.on("seeked", this.clearSeekingAppendCheck_), this.tech_.on("seeking", this.watchForBadSeeking_), this.tech_.on("waiting", wi), this.tech_.on(Ml, zi), this.tech_.on("canplay", hi), this.tech_.one("play", ci), this.dispose = function() {
                    yi.clearSeekingAppendCheck_(), yi.logger_("dispose"), yi.tech_.off("waiting", wi), yi.tech_.off(Ml, zi), yi.tech_.off("canplay", hi), yi.tech_.off("play", ci), yi.tech_.off("seeking", yi.watchForBadSeeking_), yi.tech_.off("seeked", yi.clearSeekingAppendCheck_), aa.forEach(function(Ha) {
                      Wo[Ha + "SegmentLoader_"].off("appendsdone", Ea[Ha].updateend), Wo[Ha + "SegmentLoader_"].off("playlistupdate", Ea[Ha].reset), yi.tech_.off(["seeked", "seeking"], Ea[Ha].reset);
                    }), yi.checkCurrentTimeTimeout_ && di().clearTimeout(yi.checkCurrentTimeTimeout_), yi.cancelTimer_();
                  };
                }
                var Ei = Vi.prototype;
                return Ei.monitorCurrentTime_ = function() {
                  this.checkCurrentTime_(), this.checkCurrentTimeTimeout_ && di().clearTimeout(this.checkCurrentTimeTimeout_), this.checkCurrentTimeTimeout_ = di().setTimeout(this.monitorCurrentTime_.bind(this), 250);
                }, Ei.resetSegmentDownloads_ = function(yi) {
                  var ci = this.masterPlaylistController_[yi + "SegmentLoader_"];
                  this[yi + "StalledDownloads_"] > 0 && this.logger_("resetting possible stalled download count for " + yi + " loader"), this[yi + "StalledDownloads_"] = 0, this[yi + "Buffered_"] = ci.buffered_();
                }, Ei.checkSegmentDownloads_ = function(yi) {
                  var ci = this.masterPlaylistController_, hi = ci[yi + "SegmentLoader_"], wi = hi.buffered_(), zi = cy(this[yi + "Buffered_"], wi);
                  if (this[yi + "Buffered_"] = wi, zi) {
                    this.resetSegmentDownloads_(yi);
                    return;
                  }
                  this[yi + "StalledDownloads_"]++, this.logger_("found #" + this[yi + "StalledDownloads_"] + " " + yi + " appends that did not increase buffer (possible stalled download)", {
                    playlistId: hi.playlist_ && hi.playlist_.id,
                    buffered: Nd(wi)
                  }), !(this[yi + "StalledDownloads_"] < 10) && (this.logger_(yi + " loader stalled download exclusion"), this.resetSegmentDownloads_(yi), this.tech_.trigger({
                    type: "usage",
                    name: "vhs-" + yi + "-download-exclusion"
                  }), yi !== "subtitle" && ci.blacklistCurrentPlaylist({
                    message: "Excessive " + yi + " segment downloading detected."
                  }, 1 / 0));
                }, Ei.checkCurrentTime_ = function() {
                  if (!(this.tech_.paused() || this.tech_.seeking())) {
                    var yi = this.tech_.currentTime(), ci = this.tech_.buffered();
                    if (this.lastRecordedTime === yi && (!ci.length || yi + Jf >= ci.end(ci.length - 1)))
                      return this.techWaiting_();
                    this.consecutiveUpdates >= 5 && yi === this.lastRecordedTime ? (this.consecutiveUpdates++, this.waiting_()) : yi === this.lastRecordedTime ? this.consecutiveUpdates++ : (this.consecutiveUpdates = 0, this.lastRecordedTime = yi);
                  }
                }, Ei.cancelTimer_ = function() {
                  this.consecutiveUpdates = 0, this.timer_ && (this.logger_("cancelTimer_"), clearTimeout(this.timer_)), this.timer_ = null;
                }, Ei.fixesBadSeeks_ = function() {
                  var yi = this.tech_.seeking();
                  if (!yi)
                    return !1;
                  var ci = this.seekable(), hi = this.tech_.currentTime(), wi = this.afterSeekableWindow_(ci, hi, this.media(), this.allowSeeksWithinUnsafeLiveWindow), zi;
                  if (wi) {
                    var Wo = ci.end(ci.length - 1);
                    zi = Wo;
                  }
                  if (this.beforeSeekableWindow_(ci, hi)) {
                    var aa = ci.start(0);
                    zi = aa + // if the playlist is too short and the seekable range is an exact time (can
                    // happen in live with a 3 segment playlist), then don't use a time delta
                    (aa === ci.end(0) ? 0 : Jf);
                  }
                  if (typeof zi < "u")
                    return this.logger_("Trying to seek outside of seekable at time " + hi + " with " + ("seekable range " + Ym(ci) + ". Seeking to ") + (zi + ".")), this.tech_.setCurrentTime(zi), !0;
                  for (var Ea = this.masterPlaylistController_.sourceUpdater_, Ka = this.tech_.buffered(), Ha = Ea.audioBuffer ? Ea.audioBuffered() : null, ks = Ea.videoBuffer ? Ea.videoBuffered() : null, gl = this.media(), Sl = gl.partTargetDuration ? gl.partTargetDuration : (gl.targetDuration - Xf) * 2, Fl = [Ha, ks], ru = 0; ru < Fl.length; ru++)
                    if (Fl[ru]) {
                      var $u = sg(Fl[ru], hi);
                      if ($u < Sl)
                        return !1;
                    }
                  var rc = ag(Ka, hi);
                  return rc.length === 0 ? !1 : (zi = rc.start(0) + Jf, this.logger_("Buffered region starts (" + rc.start(0) + ") " + (" just beyond seek point (" + hi + "). Seeking to " + zi + ".")), this.tech_.setCurrentTime(zi), !0);
                }, Ei.waiting_ = function() {
                  if (!this.techWaiting_()) {
                    var yi = this.tech_.currentTime(), ci = this.tech_.buffered(), hi = kh(ci, yi);
                    if (hi.length && yi + 3 <= hi.end(0)) {
                      this.cancelTimer_(), this.tech_.setCurrentTime(yi), this.logger_("Stopped at " + yi + " while inside a buffered region " + ("[" + hi.start(0) + " -> " + hi.end(0) + "]. Attempting to resume ") + "playback by seeking to the current time."), this.tech_.trigger({
                        type: "usage",
                        name: "vhs-unknown-waiting"
                      }), this.tech_.trigger({
                        type: "usage",
                        name: "hls-unknown-waiting"
                      });
                      return;
                    }
                  }
                }, Ei.techWaiting_ = function() {
                  var yi = this.seekable(), ci = this.tech_.currentTime();
                  if (this.tech_.seeking() || this.timer_ !== null)
                    return !0;
                  if (this.beforeSeekableWindow_(yi, ci)) {
                    var hi = yi.end(yi.length - 1);
                    return this.logger_("Fell out of live window at time " + ci + ". Seeking to " + ("live point (seekable end) " + hi)), this.cancelTimer_(), this.tech_.setCurrentTime(hi), this.tech_.trigger({
                      type: "usage",
                      name: "vhs-live-resync"
                    }), this.tech_.trigger({
                      type: "usage",
                      name: "hls-live-resync"
                    }), !0;
                  }
                  var wi = this.tech_.vhs.masterPlaylistController_.sourceUpdater_, zi = this.tech_.buffered(), Wo = this.videoUnderflow_({
                    audioBuffered: wi.audioBuffered(),
                    videoBuffered: wi.videoBuffered(),
                    currentTime: ci
                  });
                  if (Wo)
                    return this.cancelTimer_(), this.tech_.setCurrentTime(ci), this.tech_.trigger({
                      type: "usage",
                      name: "vhs-video-underflow"
                    }), this.tech_.trigger({
                      type: "usage",
                      name: "hls-video-underflow"
                    }), !0;
                  var aa = ag(zi, ci);
                  if (aa.length > 0) {
                    var Ea = aa.start(0) - ci;
                    return this.logger_("Stopped at " + ci + ", setting timer for " + Ea + ", seeking " + ("to " + aa.start(0))), this.cancelTimer_(), this.timer_ = setTimeout(this.skipTheGap_.bind(this), Ea * 1e3, ci), !0;
                  }
                  return !1;
                }, Ei.afterSeekableWindow_ = function(yi, ci, hi, wi) {
                  if (wi === void 0 && (wi = !1), !yi.length)
                    return !1;
                  var zi = yi.end(yi.length - 1) + Jf, Wo = !hi.endList;
                  return Wo && wi && (zi = yi.end(yi.length - 1) + hi.targetDuration * 3), ci > zi;
                }, Ei.beforeSeekableWindow_ = function(yi, ci) {
                  return !!(yi.length && // can't fall before 0 and 0 seekable start identifies VOD stream
                  yi.start(0) > 0 && ci < yi.start(0) - this.liveRangeSafeTimeDelta);
                }, Ei.videoUnderflow_ = function(yi) {
                  var ci = yi.videoBuffered, hi = yi.audioBuffered, wi = yi.currentTime;
                  if (ci) {
                    var zi;
                    if (ci.length && hi.length) {
                      var Wo = kh(ci, wi - 3), aa = kh(ci, wi), Ea = kh(hi, wi);
                      Ea.length && !aa.length && Wo.length && (zi = {
                        start: Wo.end(0),
                        end: Ea.end(0)
                      });
                    } else {
                      var Ka = ag(ci, wi);
                      Ka.length || (zi = this.gapFromVideoUnderflow_(ci, wi));
                    }
                    return zi ? (this.logger_("Encountered a gap in video from " + zi.start + " to " + zi.end + ". " + ("Seeking to current time " + wi)), !0) : !1;
                  }
                }, Ei.skipTheGap_ = function(yi) {
                  var ci = this.tech_.buffered(), hi = this.tech_.currentTime(), wi = ag(ci, hi);
                  this.cancelTimer_(), !(wi.length === 0 || hi !== yi) && (this.logger_("skipTheGap_:", "currentTime:", hi, "scheduled currentTime:", yi, "nextRange start:", wi.start(0)), this.tech_.setCurrentTime(wi.start(0) + Xf), this.tech_.trigger({
                    type: "usage",
                    name: "vhs-gap-skip"
                  }), this.tech_.trigger({
                    type: "usage",
                    name: "hls-gap-skip"
                  }));
                }, Ei.gapFromVideoUnderflow_ = function(yi, ci) {
                  for (var hi = uy(yi), wi = 0; wi < hi.length; wi++) {
                    var zi = hi.start(wi), Wo = hi.end(wi);
                    if (ci - zi < 4 && ci - zi > 2)
                      return {
                        start: zi,
                        end: Wo
                      };
                  }
                  return null;
                }, Vi;
              })(), cb = {
                errorInterval: 30,
                getSource: function(Ei) {
                  var bi = this.tech({
                    IWillNotUseThisInPlugins: !0
                  }), yi = bi.currentSource_ || this.currentSource();
                  return Ei(yi);
                }
              }, db = function Vi(Ei, bi) {
                var yi = 0, ci = 0, hi = Rl.mergeOptions(cb, bi);
                Ei.ready(function() {
                  Ei.trigger({
                    type: "usage",
                    name: "vhs-error-reload-initialized"
                  }), Ei.trigger({
                    type: "usage",
                    name: "hls-error-reload-initialized"
                  });
                });
                var wi = function() {
                  ci && Ei.currentTime(ci);
                }, zi = function(Ha) {
                  Ha != null && (ci = Ei.duration() !== 1 / 0 && Ei.currentTime() || 0, Ei.one("loadedmetadata", wi), Ei.src(Ha), Ei.trigger({
                    type: "usage",
                    name: "vhs-error-reload"
                  }), Ei.trigger({
                    type: "usage",
                    name: "hls-error-reload"
                  }), Ei.play());
                }, Wo = function() {
                  if (Date.now() - yi < hi.errorInterval * 1e3) {
                    Ei.trigger({
                      type: "usage",
                      name: "vhs-error-reload-canceled"
                    }), Ei.trigger({
                      type: "usage",
                      name: "hls-error-reload-canceled"
                    });
                    return;
                  }
                  if (!hi.getSource || typeof hi.getSource != "function") {
                    Rl.log.error("ERROR: reloadSourceOnError - The option getSource must be a function!");
                    return;
                  }
                  return yi = Date.now(), hi.getSource.call(Ei, zi);
                }, aa = function Ka() {
                  Ei.off("loadedmetadata", wi), Ei.off("error", Wo), Ei.off("dispose", Ka);
                }, Ea = function(Ha) {
                  aa(), Vi(Ei, Ha);
                };
                Ei.on("error", Wo), Ei.on("dispose", aa), Ei.reloadSourceOnError = Ea;
              }, fb = function(Ei) {
                db(this, Ei);
              }, g0 = "2.16.3", pb = "6.0.1", hb = "0.22.1", gb = "4.8.0", mb = "3.1.3", jd = {
                PlaylistLoader: jh,
                Playlist: Jd,
                utils: xy,
                STANDARD_PLAYLIST_SELECTOR: Dm,
                INITIAL_PLAYLIST_SELECTOR: km,
                lastBandwidthSelector: Dm,
                movingAverageBandwidthSelector: Bg,
                comparePlaylistBandwidth: $m,
                comparePlaylistResolution: By,
                xhr: iv()
              };
              Object.keys(bd).forEach(function(Vi) {
                Object.defineProperty(jd, Vi, {
                  get: function() {
                    return Rl.log.warn("using Vhs." + Vi + " is UNSAFE be sure you know what you are doing"), bd[Vi];
                  },
                  set: function(bi) {
                    if (Rl.log.warn("using Vhs." + Vi + " is UNSAFE be sure you know what you are doing"), typeof bi != "number" || bi < 0) {
                      Rl.log.warn("value of Vhs." + Vi + " must be greater than or equal to 0");
                      return;
                    }
                    bd[Vi] = bi;
                  }
                });
              });
              var m0 = "videojs-vhs", v0 = function(Ei, bi) {
                for (var yi = bi.media(), ci = -1, hi = 0; hi < Ei.length; hi++)
                  if (Ei[hi].id === yi.id) {
                    ci = hi;
                    break;
                  }
                Ei.selectedIndex_ = ci, Ei.trigger({
                  selectedIndex: ci,
                  type: "change"
                });
              }, vb = function(Ei, bi) {
                bi.representations().forEach(function(yi) {
                  Ei.addQualityLevel(yi);
                }), v0(Ei, bi.playlists);
              };
              jd.canPlaySource = function() {
                return Rl.log.warn("HLS is no longer a tech. Please remove it from your player's techOrder.");
              };
              var yb = function(Ei, bi, yi) {
                if (!Ei)
                  return Ei;
                var ci = {};
                bi && bi.attributes && bi.attributes.CODECS && (ci = kf((0, Li.parseCodecs)(bi.attributes.CODECS))), yi && yi.attributes && yi.attributes.CODECS && (ci.audio = yi.attributes.CODECS);
                var hi = (0, Li.getMimeForCodec)(ci.video), wi = (0, Li.getMimeForCodec)(ci.audio), zi = {};
                for (var Wo in Ei)
                  zi[Wo] = {}, wi && (zi[Wo].audioContentType = wi), hi && (zi[Wo].videoContentType = hi), bi.contentProtection && bi.contentProtection[Wo] && bi.contentProtection[Wo].pssh && (zi[Wo].pssh = bi.contentProtection[Wo].pssh), typeof Ei[Wo] == "string" && (zi[Wo].url = Ei[Wo]);
                return Rl.mergeOptions(Ei, zi);
              }, bb = function(Ei, bi) {
                return Ei.reduce(function(yi, ci) {
                  if (!ci.contentProtection)
                    return yi;
                  var hi = bi.reduce(function(wi, zi) {
                    var Wo = ci.contentProtection[zi];
                    return Wo && Wo.pssh && (wi[zi] = {
                      pssh: Wo.pssh
                    }), wi;
                  }, {});
                  return Object.keys(hi).length && yi.push(hi), yi;
                }, []);
              }, Tb = function(Ei) {
                var bi = Ei.player, yi = Ei.sourceKeySystems, ci = Ei.audioMedia, hi = Ei.mainPlaylists;
                if (!bi.eme.initializeMediaKeys)
                  return Promise.resolve();
                var wi = ci ? hi.concat([ci]) : hi, zi = bb(wi, Object.keys(yi)), Wo = [], aa = [];
                return zi.forEach(function(Ea) {
                  aa.push(new Promise(function(Ka, Ha) {
                    bi.tech_.one("keysessioncreated", Ka);
                  })), Wo.push(new Promise(function(Ka, Ha) {
                    bi.eme.initializeMediaKeys({
                      keySystems: Ea
                    }, function(ks) {
                      if (ks) {
                        Ha(ks);
                        return;
                      }
                      Ka();
                    });
                  }));
                }), Promise.race([
                  // If a session was previously created, these will all finish resolving without
                  // creating a new session, otherwise it will take until the end of all license
                  // requests, which is why the key session check is used (to make setup much faster).
                  Promise.all(Wo),
                  // Once a single session is created, the browser knows DRM will be used.
                  Promise.race(aa)
                ]);
              }, Eb = function(Ei) {
                var bi = Ei.player, yi = Ei.sourceKeySystems, ci = Ei.media, hi = Ei.audioMedia, wi = yb(yi, ci, hi);
                return wi ? (bi.currentSource().keySystems = wi, wi && !bi.eme ? (Rl.log.warn("DRM encrypted source cannot be decrypted without a DRM plugin"), !1) : !0) : !1;
              }, y0 = function() {
                if (!di().localStorage)
                  return null;
                var Ei = di().localStorage.getItem(m0);
                if (!Ei)
                  return null;
                try {
                  return JSON.parse(Ei);
                } catch {
                  return null;
                }
              }, Sb = function(Ei) {
                if (!di().localStorage)
                  return !1;
                var bi = y0();
                bi = bi ? Rl.mergeOptions(bi, Ei) : Ei;
                try {
                  di().localStorage.setItem(m0, JSON.stringify(bi));
                } catch {
                  return !1;
                }
                return bi;
              }, xb = function(Ei) {
                return Ei.toLowerCase().indexOf("data:application/vnd.videojs.vhs+json,") === 0 ? JSON.parse(Ei.substring(Ei.indexOf(",") + 1)) : Ei;
              };
              jd.supportsNativeHls = (function() {
                if (!gi() || !gi().createElement)
                  return !1;
                var Vi = gi().createElement("video");
                if (!Rl.getTech("Html5").isSupported())
                  return !1;
                var Ei = [
                  // Apple santioned
                  "application/vnd.apple.mpegurl",
                  // Apple sanctioned for backwards compatibility
                  "audio/mpegurl",
                  // Very common
                  "audio/x-mpegurl",
                  // Very common
                  "application/x-mpegurl",
                  // Included for completeness
                  "video/x-mpegurl",
                  "video/mpegurl",
                  "application/mpegurl"
                ];
                return Ei.some(function(bi) {
                  return /maybe|probably/i.test(Vi.canPlayType(bi));
                });
              })(), jd.supportsNativeDash = (function() {
                return !gi() || !gi().createElement || !Rl.getTech("Html5").isSupported() ? !1 : /maybe|probably/i.test(gi().createElement("video").canPlayType("application/dash+xml"));
              })(), jd.supportsTypeNatively = function(Vi) {
                return Vi === "hls" ? jd.supportsNativeHls : Vi === "dash" ? jd.supportsNativeDash : !1;
              }, jd.isSupported = function() {
                return Rl.log.warn("HLS is no longer a tech. Please remove it from your player's techOrder.");
              };
              var wb = Rl.getComponent("Component"), Zy = /* @__PURE__ */ (function(Vi) {
                (0, Si.default)(Ei, Vi);
                function Ei(yi, ci, hi) {
                  var wi;
                  if (wi = Vi.call(this, ci, Rl.mergeOptions(hi.hls, hi.vhs)) || this, hi.hls && Object.keys(hi.hls).length && Rl.log.warn("Using hls options is deprecated. Please rename `hls` to `vhs` in your options object."), typeof hi.initialBandwidth == "number" && (wi.options_.bandwidth = hi.initialBandwidth), wi.logger_ = Af("VhsHandler"), ci.options_ && ci.options_.playerId) {
                    var zi = Rl(ci.options_.playerId);
                    zi.hasOwnProperty("hls") || Object.defineProperty(zi, "hls", {
                      get: function() {
                        return Rl.log.warn("player.hls is deprecated. Use player.tech().vhs instead."), ci.trigger({
                          type: "usage",
                          name: "hls-player-access"
                        }), (0, xi.default)(wi);
                      },
                      configurable: !0
                    }), zi.hasOwnProperty("vhs") || Object.defineProperty(zi, "vhs", {
                      get: function() {
                        return Rl.log.warn("player.vhs is deprecated. Use player.tech().vhs instead."), ci.trigger({
                          type: "usage",
                          name: "vhs-player-access"
                        }), (0, xi.default)(wi);
                      },
                      configurable: !0
                    }), zi.hasOwnProperty("dash") || Object.defineProperty(zi, "dash", {
                      get: function() {
                        return Rl.log.warn("player.dash is deprecated. Use player.tech().vhs instead."), (0, xi.default)(wi);
                      },
                      configurable: !0
                    }), wi.player_ = zi;
                  }
                  if (wi.tech_ = ci, wi.source_ = yi, wi.stats = {}, wi.ignoreNextSeekingEvent_ = !1, wi.setOptions_(), wi.options_.overrideNative && ci.overrideNativeAudioTracks && ci.overrideNativeVideoTracks)
                    ci.overrideNativeAudioTracks(!0), ci.overrideNativeVideoTracks(!0);
                  else if (wi.options_.overrideNative && (ci.featuresNativeVideoTracks || ci.featuresNativeAudioTracks))
                    throw new Error("Overriding native HLS requires emulated tracks. See https://git.io/vMpjB");
                  return wi.on(gi(), ["fullscreenchange", "webkitfullscreenchange", "mozfullscreenchange", "MSFullscreenChange"], function(Wo) {
                    var aa = gi().fullscreenElement || gi().webkitFullscreenElement || gi().mozFullScreenElement || gi().msFullscreenElement;
                    aa && aa.contains(wi.tech_.el()) ? wi.masterPlaylistController_.fastQualityChange_() : wi.masterPlaylistController_.checkABR_();
                  }), wi.on(wi.tech_, "seeking", function() {
                    if (this.ignoreNextSeekingEvent_) {
                      this.ignoreNextSeekingEvent_ = !1;
                      return;
                    }
                    this.setCurrentTime(this.tech_.currentTime());
                  }), wi.on(wi.tech_, "error", function() {
                    this.tech_.error() && this.masterPlaylistController_ && this.masterPlaylistController_.pauseLoading();
                  }), wi.on(wi.tech_, "play", wi.play), wi;
                }
                var bi = Ei.prototype;
                return bi.setOptions_ = function() {
                  var ci = this;
                  if (this.options_.withCredentials = this.options_.withCredentials || !1, this.options_.handleManifestRedirects = this.options_.handleManifestRedirects !== !1, this.options_.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions !== !1, this.options_.useDevicePixelRatio = this.options_.useDevicePixelRatio || !1, this.options_.smoothQualityChange = this.options_.smoothQualityChange || !1, this.options_.useBandwidthFromLocalStorage = typeof this.source_.useBandwidthFromLocalStorage < "u" ? this.source_.useBandwidthFromLocalStorage : this.options_.useBandwidthFromLocalStorage || !1, this.options_.useNetworkInformationApi = this.options_.useNetworkInformationApi || !1, this.options_.useDtsForTimestampOffset = this.options_.useDtsForTimestampOffset || !1, this.options_.customTagParsers = this.options_.customTagParsers || [], this.options_.customTagMappers = this.options_.customTagMappers || [], this.options_.cacheEncryptionKeys = this.options_.cacheEncryptionKeys || !1, typeof this.options_.blacklistDuration != "number" && (this.options_.blacklistDuration = 300), typeof this.options_.bandwidth != "number" && this.options_.useBandwidthFromLocalStorage) {
                    var hi = y0();
                    hi && hi.bandwidth && (this.options_.bandwidth = hi.bandwidth, this.tech_.trigger({
                      type: "usage",
                      name: "vhs-bandwidth-from-local-storage"
                    }), this.tech_.trigger({
                      type: "usage",
                      name: "hls-bandwidth-from-local-storage"
                    })), hi && hi.throughput && (this.options_.throughput = hi.throughput, this.tech_.trigger({
                      type: "usage",
                      name: "vhs-throughput-from-local-storage"
                    }), this.tech_.trigger({
                      type: "usage",
                      name: "hls-throughput-from-local-storage"
                    }));
                  }
                  typeof this.options_.bandwidth != "number" && (this.options_.bandwidth = bd.INITIAL_BANDWIDTH), this.options_.enableLowInitialPlaylist = this.options_.enableLowInitialPlaylist && this.options_.bandwidth === bd.INITIAL_BANDWIDTH, ["withCredentials", "useDevicePixelRatio", "limitRenditionByPlayerDimensions", "bandwidth", "smoothQualityChange", "customTagParsers", "customTagMappers", "handleManifestRedirects", "cacheEncryptionKeys", "playlistSelector", "initialPlaylistSelector", "experimentalBufferBasedABR", "liveRangeSafeTimeDelta", "experimentalLLHLS", "useNetworkInformationApi", "useDtsForTimestampOffset", "experimentalExactManifestTimings", "experimentalLeastPixelDiffSelector"].forEach(function(wi) {
                    typeof ci.source_[wi] < "u" && (ci.options_[wi] = ci.source_[wi]);
                  }), this.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions, this.useDevicePixelRatio = this.options_.useDevicePixelRatio;
                }, bi.src = function(ci, hi) {
                  var wi = this;
                  if (ci) {
                    this.setOptions_(), this.options_.src = xb(this.source_.src), this.options_.tech = this.tech_, this.options_.externVhs = jd, this.options_.sourceType = (0, Co.simpleTypeFromSourceType)(hi), this.options_.seekTo = function(aa) {
                      wi.tech_.setCurrentTime(aa);
                    }, this.options_.smoothQualityChange && Rl.log.warn("smoothQualityChange is deprecated and will be removed in the next major version"), this.masterPlaylistController_ = new Us(this.options_);
                    var zi = Rl.mergeOptions({
                      liveRangeSafeTimeDelta: Jf
                    }, this.options_, {
                      seekable: function() {
                        return wi.seekable();
                      },
                      media: function() {
                        return wi.masterPlaylistController_.media();
                      },
                      masterPlaylistController: this.masterPlaylistController_
                    });
                    this.playbackWatcher_ = new ub(zi), this.masterPlaylistController_.on("error", function() {
                      var aa = Rl.players[wi.tech_.options_.playerId], Ea = wi.masterPlaylistController_.error;
                      typeof Ea == "object" && !Ea.code ? Ea.code = 3 : typeof Ea == "string" && (Ea = {
                        message: Ea,
                        code: 3
                      }), aa.error(Ea);
                    });
                    var Wo = this.options_.experimentalBufferBasedABR ? jd.movingAverageBandwidthSelector(0.55) : jd.STANDARD_PLAYLIST_SELECTOR;
                    this.masterPlaylistController_.selectPlaylist = this.selectPlaylist ? this.selectPlaylist.bind(this) : Wo.bind(this), this.masterPlaylistController_.selectInitialPlaylist = jd.INITIAL_PLAYLIST_SELECTOR.bind(this), this.playlists = this.masterPlaylistController_.masterPlaylistLoader_, this.mediaSource = this.masterPlaylistController_.mediaSource, Object.defineProperties(this, {
                      selectPlaylist: {
                        get: function() {
                          return this.masterPlaylistController_.selectPlaylist;
                        },
                        set: function(Ea) {
                          this.masterPlaylistController_.selectPlaylist = Ea.bind(this);
                        }
                      },
                      throughput: {
                        get: function() {
                          return this.masterPlaylistController_.mainSegmentLoader_.throughput.rate;
                        },
                        set: function(Ea) {
                          this.masterPlaylistController_.mainSegmentLoader_.throughput.rate = Ea, this.masterPlaylistController_.mainSegmentLoader_.throughput.count = 1;
                        }
                      },
                      bandwidth: {
                        get: function() {
                          var Ea = this.masterPlaylistController_.mainSegmentLoader_.bandwidth, Ka = di().navigator.connection || di().navigator.mozConnection || di().navigator.webkitConnection, Ha = 1e7;
                          if (this.options_.useNetworkInformationApi && Ka) {
                            var ks = Ka.downlink * 1e3 * 1e3;
                            ks >= Ha && Ea >= Ha ? Ea = Math.max(Ea, ks) : Ea = ks;
                          }
                          return Ea;
                        },
                        set: function(Ea) {
                          this.masterPlaylistController_.mainSegmentLoader_.bandwidth = Ea, this.masterPlaylistController_.mainSegmentLoader_.throughput = {
                            rate: 0,
                            count: 0
                          };
                        }
                      },
                      /**
                       * `systemBandwidth` is a combination of two serial processes bit-rates. The first
                       * is the network bitrate provided by `bandwidth` and the second is the bitrate of
                       * the entire process after that - decryption, transmuxing, and appending - provided
                       * by `throughput`.
                       *
                       * Since the two process are serial, the overall system bandwidth is given by:
                       *   sysBandwidth = 1 / (1 / bandwidth + 1 / throughput)
                       */
                      systemBandwidth: {
                        get: function() {
                          var Ea = 1 / (this.bandwidth || 1), Ka;
                          this.throughput > 0 ? Ka = 1 / this.throughput : Ka = 0;
                          var Ha = Math.floor(1 / (Ea + Ka));
                          return Ha;
                        },
                        set: function() {
                          Rl.log.error('The "systemBandwidth" property is read-only');
                        }
                      }
                    }), this.options_.bandwidth && (this.bandwidth = this.options_.bandwidth), this.options_.throughput && (this.throughput = this.options_.throughput), Object.defineProperties(this.stats, {
                      bandwidth: {
                        get: function() {
                          return wi.bandwidth || 0;
                        },
                        enumerable: !0
                      },
                      mediaRequests: {
                        get: function() {
                          return wi.masterPlaylistController_.mediaRequests_() || 0;
                        },
                        enumerable: !0
                      },
                      mediaRequestsAborted: {
                        get: function() {
                          return wi.masterPlaylistController_.mediaRequestsAborted_() || 0;
                        },
                        enumerable: !0
                      },
                      mediaRequestsTimedout: {
                        get: function() {
                          return wi.masterPlaylistController_.mediaRequestsTimedout_() || 0;
                        },
                        enumerable: !0
                      },
                      mediaRequestsErrored: {
                        get: function() {
                          return wi.masterPlaylistController_.mediaRequestsErrored_() || 0;
                        },
                        enumerable: !0
                      },
                      mediaTransferDuration: {
                        get: function() {
                          return wi.masterPlaylistController_.mediaTransferDuration_() || 0;
                        },
                        enumerable: !0
                      },
                      mediaBytesTransferred: {
                        get: function() {
                          return wi.masterPlaylistController_.mediaBytesTransferred_() || 0;
                        },
                        enumerable: !0
                      },
                      mediaSecondsLoaded: {
                        get: function() {
                          return wi.masterPlaylistController_.mediaSecondsLoaded_() || 0;
                        },
                        enumerable: !0
                      },
                      mediaAppends: {
                        get: function() {
                          return wi.masterPlaylistController_.mediaAppends_() || 0;
                        },
                        enumerable: !0
                      },
                      mainAppendsToLoadedData: {
                        get: function() {
                          return wi.masterPlaylistController_.mainAppendsToLoadedData_() || 0;
                        },
                        enumerable: !0
                      },
                      audioAppendsToLoadedData: {
                        get: function() {
                          return wi.masterPlaylistController_.audioAppendsToLoadedData_() || 0;
                        },
                        enumerable: !0
                      },
                      appendsToLoadedData: {
                        get: function() {
                          return wi.masterPlaylistController_.appendsToLoadedData_() || 0;
                        },
                        enumerable: !0
                      },
                      timeToLoadedData: {
                        get: function() {
                          return wi.masterPlaylistController_.timeToLoadedData_() || 0;
                        },
                        enumerable: !0
                      },
                      buffered: {
                        get: function() {
                          return Nd(wi.tech_.buffered());
                        },
                        enumerable: !0
                      },
                      currentTime: {
                        get: function() {
                          return wi.tech_.currentTime();
                        },
                        enumerable: !0
                      },
                      currentSource: {
                        get: function() {
                          return wi.tech_.currentSource_;
                        },
                        enumerable: !0
                      },
                      currentTech: {
                        get: function() {
                          return wi.tech_.name_;
                        },
                        enumerable: !0
                      },
                      duration: {
                        get: function() {
                          return wi.tech_.duration();
                        },
                        enumerable: !0
                      },
                      master: {
                        get: function() {
                          return wi.playlists.master;
                        },
                        enumerable: !0
                      },
                      playerDimensions: {
                        get: function() {
                          return wi.tech_.currentDimensions();
                        },
                        enumerable: !0
                      },
                      seekable: {
                        get: function() {
                          return Nd(wi.tech_.seekable());
                        },
                        enumerable: !0
                      },
                      timestamp: {
                        get: function() {
                          return Date.now();
                        },
                        enumerable: !0
                      },
                      videoPlaybackQuality: {
                        get: function() {
                          return wi.tech_.getVideoPlaybackQuality();
                        },
                        enumerable: !0
                      }
                    }), this.tech_.one("canplay", this.masterPlaylistController_.setupFirstPlay.bind(this.masterPlaylistController_)), this.tech_.on("bandwidthupdate", function() {
                      wi.options_.useBandwidthFromLocalStorage && Sb({
                        bandwidth: wi.bandwidth,
                        throughput: Math.round(wi.throughput)
                      });
                    }), this.masterPlaylistController_.on("selectedinitialmedia", function() {
                      Al(wi);
                    }), this.masterPlaylistController_.sourceUpdater_.on("createdsourcebuffers", function() {
                      wi.setupEme_();
                    }), this.on(this.masterPlaylistController_, "progress", function() {
                      this.tech_.trigger("progress");
                    }), this.on(this.masterPlaylistController_, "firstplay", function() {
                      this.ignoreNextSeekingEvent_ = !0;
                    }), this.setupQualityLevels_(), this.tech_.el() && (this.mediaSourceUrl_ = di().URL.createObjectURL(this.masterPlaylistController_.mediaSource), this.tech_.src(this.mediaSourceUrl_));
                  }
                }, bi.createKeySessions_ = function() {
                  var ci = this, hi = this.masterPlaylistController_.mediaTypes_.AUDIO.activePlaylistLoader;
                  this.logger_("waiting for EME key session creation"), Tb({
                    player: this.player_,
                    sourceKeySystems: this.source_.keySystems,
                    audioMedia: hi && hi.media(),
                    mainPlaylists: this.playlists.master.playlists
                  }).then(function() {
                    ci.logger_("created EME key session"), ci.masterPlaylistController_.sourceUpdater_.initializedEme();
                  }).catch(function(wi) {
                    ci.logger_("error while creating EME key session", wi), ci.player_.error({
                      message: "Failed to initialize media keys for EME",
                      code: 3
                    });
                  });
                }, bi.handleWaitingForKey_ = function() {
                  this.logger_("waitingforkey fired, attempting to create any new key sessions"), this.createKeySessions_();
                }, bi.setupEme_ = function() {
                  var ci = this, hi = this.masterPlaylistController_.mediaTypes_.AUDIO.activePlaylistLoader, wi = Eb({
                    player: this.player_,
                    sourceKeySystems: this.source_.keySystems,
                    media: this.playlists.media(),
                    audioMedia: hi && hi.media()
                  });
                  if (this.player_.tech_.on("keystatuschange", function(zi) {
                    if (zi.status === "output-restricted") {
                      var Wo = ci.masterPlaylistController_.master();
                      if (!(!Wo || !Wo.playlists)) {
                        var aa = [];
                        if (Wo.playlists.forEach(function(Ka) {
                          Ka && Ka.attributes && Ka.attributes.RESOLUTION && Ka.attributes.RESOLUTION.height >= 720 && (!Ka.excludeUntil || Ka.excludeUntil < 1 / 0) && (Ka.excludeUntil = 1 / 0, aa.push(Ka));
                        }), aa.length) {
                          var Ea;
                          (Ea = Rl.log).warn.apply(Ea, ['DRM keystatus changed to "output-restricted." Removing the following HD playlists that will most likely fail to play and clearing the buffer. This may be due to HDCP restrictions on the stream and the capabilities of the current device.'].concat(aa)), ci.masterPlaylistController_.fastQualityChange_();
                        }
                      }
                    }
                  }), this.handleWaitingForKey_ = this.handleWaitingForKey_.bind(this), this.player_.tech_.on("waitingforkey", this.handleWaitingForKey_), Rl.browser.IE_VERSION === 11 || !wi) {
                    this.masterPlaylistController_.sourceUpdater_.initializedEme();
                    return;
                  }
                  this.createKeySessions_();
                }, bi.setupQualityLevels_ = function() {
                  var ci = this, hi = Rl.players[this.tech_.options_.playerId];
                  !hi || !hi.qualityLevels || this.qualityLevels_ || (this.qualityLevels_ = hi.qualityLevels(), this.masterPlaylistController_.on("selectedinitialmedia", function() {
                    vb(ci.qualityLevels_, ci);
                  }), this.playlists.on("mediachange", function() {
                    v0(ci.qualityLevels_, ci.playlists);
                  }));
                }, Ei.version = function() {
                  return {
                    "@videojs/http-streaming": g0,
                    "mux.js": pb,
                    "mpd-parser": hb,
                    "m3u8-parser": gb,
                    "aes-decrypter": mb
                  };
                }, bi.version = function() {
                  return this.constructor.version();
                }, bi.canChangeType = function() {
                  return Fo.canChangeType();
                }, bi.play = function() {
                  this.masterPlaylistController_.play();
                }, bi.setCurrentTime = function(ci) {
                  this.masterPlaylistController_.setCurrentTime(ci);
                }, bi.duration = function() {
                  return this.masterPlaylistController_.duration();
                }, bi.seekable = function() {
                  return this.masterPlaylistController_.seekable();
                }, bi.dispose = function() {
                  this.playbackWatcher_ && this.playbackWatcher_.dispose(), this.masterPlaylistController_ && this.masterPlaylistController_.dispose(), this.qualityLevels_ && this.qualityLevels_.dispose(), this.player_ && (delete this.player_.vhs, delete this.player_.dash, delete this.player_.hls), this.tech_ && this.tech_.vhs && delete this.tech_.vhs, this.tech_ && delete this.tech_.hls, this.mediaSourceUrl_ && di().URL.revokeObjectURL && (di().URL.revokeObjectURL(this.mediaSourceUrl_), this.mediaSourceUrl_ = null), this.tech_ && this.tech_.off("waitingforkey", this.handleWaitingForKey_), Vi.prototype.dispose.call(this);
                }, bi.convertToProgramTime = function(ci, hi) {
                  return mm({
                    playlist: this.masterPlaylistController_.media(),
                    time: ci,
                    callback: hi
                  });
                }, bi.seekToProgramTime = function(ci, hi, wi, zi) {
                  return wi === void 0 && (wi = !0), zi === void 0 && (zi = 2), vm({
                    programTime: ci,
                    playlist: this.masterPlaylistController_.media(),
                    retryCount: zi,
                    pauseAfterSeek: wi,
                    seekTo: this.options_.seekTo,
                    tech: this.options_.tech,
                    callback: hi
                  });
                }, Ei;
              })(wb), Mm = {
                name: "videojs-http-streaming",
                VERSION: g0,
                canHandleSource: function(Ei, bi) {
                  bi === void 0 && (bi = {});
                  var yi = Rl.mergeOptions(Rl.options, bi);
                  return Mm.canPlayType(Ei.type, yi);
                },
                handleSource: function(Ei, bi, yi) {
                  yi === void 0 && (yi = {});
                  var ci = Rl.mergeOptions(Rl.options, yi);
                  return bi.vhs = new Zy(Ei, bi, ci), Rl.hasOwnProperty("hls") || Object.defineProperty(bi, "hls", {
                    get: function() {
                      return Rl.log.warn("player.tech().hls is deprecated. Use player.tech().vhs instead."), bi.vhs;
                    },
                    configurable: !0
                  }), bi.vhs.xhr = iv(), bi.vhs.src(Ei.src, Ei.type), bi.vhs;
                },
                canPlayType: function(Ei, bi) {
                  var yi = (0, Co.simpleTypeFromSourceType)(Ei);
                  if (!yi)
                    return "";
                  var ci = Mm.getOverrideNative(bi), hi = jd.supportsTypeNatively(yi), wi = !hi || ci;
                  return wi ? "maybe" : "";
                },
                getOverrideNative: function(Ei) {
                  Ei === void 0 && (Ei = {});
                  var bi = Ei, yi = bi.vhs, ci = yi === void 0 ? {} : yi, hi = bi.hls, wi = hi === void 0 ? {} : hi, zi = !(Rl.browser.IS_ANY_SAFARI || Rl.browser.IS_IOS), Wo = ci.overrideNative, aa = Wo === void 0 ? zi : Wo, Ea = wi.overrideNative, Ka = Ea === void 0 ? !1 : Ea;
                  return Ka || aa;
                }
              }, _b = function() {
                return (0, Li.browserSupportsCodec)("avc1.4d400d,mp4a.40.2");
              };
              if (_b() && Rl.getTech("Html5").registerSourceHandler(Mm, 0), Rl.VhsHandler = Zy, Object.defineProperty(Rl, "HlsHandler", {
                get: function() {
                  return Rl.log.warn("videojs.HlsHandler is deprecated. Use videojs.VhsHandler instead."), Zy;
                },
                configurable: !0
              }), Rl.VhsSourceHandler = Mm, Object.defineProperty(Rl, "HlsSourceHandler", {
                get: function() {
                  return Rl.log.warn("videojs.HlsSourceHandler is deprecated. Use videojs.VhsSourceHandler instead."), Mm;
                },
                configurable: !0
              }), Rl.Vhs = jd, Object.defineProperty(Rl, "Hls", {
                get: function() {
                  return Rl.log.warn("videojs.Hls is deprecated. Use videojs.Vhs instead."), jd;
                },
                configurable: !0
              }), Rl.use || (Rl.registerComponent("Hls", jd), Rl.registerComponent("Vhs", jd)), Rl.options.vhs = Rl.options.vhs || {}, Rl.options.hls = Rl.options.hls || {}, !Rl.getPlugin || !Rl.getPlugin("reloadSourceOnError")) {
                var Pb = Rl.registerPlugin || Rl.plugin;
                Pb("reloadSourceOnError", fb);
              }
              const Cb = Rl;
            })
          ),
          /***/
          "./node_modules/videojs-errors/dist/videojs-errors.es.js": (
            /*!***************************************************************!*\
              !*** ./node_modules/videojs-errors/dist/videojs-errors.es.js ***!
              \***************************************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                default: () => $i
                /* harmony export */
              });
              var si = oi(
                /*! video.js */
                "./node_modules/video.js/dist/video.es.js"
              ), di = oi(
                /*! global/document */
                "./node_modules/global/document.js"
              ), fi = /* @__PURE__ */ oi.n(di);
              /*! @name videojs-errors @version 4.3.2 @license Apache-2.0 */
              var gi = "4.3.2", mi = si.default.getComponent("Flash"), Ti = !si.default.browser.IS_IPHONE, vi = si.default.registerPlugin || si.default.plugin, xi = {
                header: "",
                code: "",
                message: "",
                timeout: 45 * 1e3,
                dismiss: Ti,
                errors: {
                  1: {
                    type: "MEDIA_ERR_ABORTED",
                    headline: "The video download was cancelled"
                  },
                  2: {
                    type: "MEDIA_ERR_NETWORK",
                    headline: "The video connection was lost, please confirm you are connected to the internet"
                  },
                  3: {
                    type: "MEDIA_ERR_DECODE",
                    headline: "The video is bad or in a format that cannot be played on your browser"
                  },
                  4: {
                    type: "MEDIA_ERR_SRC_NOT_SUPPORTED",
                    headline: "This video is either unavailable or not supported in this browser"
                  },
                  5: {
                    type: "MEDIA_ERR_ENCRYPTED",
                    headline: "The video you are trying to watch is encrypted and we do not know how to decrypt it"
                  },
                  unknown: {
                    type: "MEDIA_ERR_UNKNOWN",
                    headline: "An unanticipated problem was encountered, check back soon and try again"
                  },
                  "-1": {
                    type: "PLAYER_ERR_NO_SRC",
                    headline: "No video has been loaded"
                  },
                  "-2": {
                    type: "PLAYER_ERR_TIMEOUT",
                    headline: "Could not download the video"
                  },
                  PLAYER_ERR_DOMAIN_RESTRICTED: {
                    headline: "This video is restricted from playing on your current domain"
                  },
                  PLAYER_ERR_IP_RESTRICTED: {
                    headline: "This video is restricted at your current IP address"
                  },
                  PLAYER_ERR_GEO_RESTRICTED: {
                    headline: "This video is restricted from playing in your current geographic region"
                  },
                  FLASHLS_ERR_CROSS_DOMAIN: {
                    headline: "The video could not be loaded: crossdomain access denied."
                  }
                }
              }, Si = function Oi(Di, Mi) {
                var Oo, io, xo, fo = [], _o = function(ji) {
                  Mi.errors = si.default.mergeOptions(Mi.errors, ji), Object.keys(Mi.errors).forEach(function(Hi) {
                    var zo = Mi.errors[Hi];
                    zo.type || (zo.type = Hi);
                  });
                };
                _o();
                var Li = function() {
                  Di.clearTimeout(io), xo && (xo = !1, Di.removeClass("vjs-waiting")), io = Di.setTimeout(function() {
                    Di.error() || Di.paused() || Di.ended() || (xo = !0, Di.addClass("vjs-waiting"));
                  }, 1e3), Di.clearTimeout(Oo), Oo = Di.setTimeout(function() {
                    Di.error() || Di.paused() || Di.ended() || Di.error({
                      code: -2,
                      type: "PLAYER_ERR_TIMEOUT"
                    });
                  }, Mi.timeout), Di.error() && Di.error().code === -2 && Di.error(null);
                }, Co = function() {
                  for (var ji; fo.length; )
                    ji = fo.shift(), Di.off(ji[0], ji[1]);
                  Di.clearTimeout(Oo), Di.clearTimeout(io);
                }, Ni = function(ji, Hi) {
                  var zo = function() {
                    if (!Di.error()) {
                      var sa = Di.$(".vjs-tech");
                      if (sa && sa.type === "application/x-shockwave-flash" && !sa.vjs_getProperty) {
                        Di.error({
                          code: -2,
                          type: "PLAYER_ERR_TIMEOUT"
                        });
                        return;
                      }
                      if (Di.paused() || Di.ended())
                        return Li();
                    }
                    Hi.call(this);
                  };
                  Di.on(ji, zo), fo.push([ji, zo]);
                }, Yi = function() {
                  var ji = 0;
                  Co(), Li(), Ni(["timeupdate", "adtimeupdate"], function() {
                    var Hi = Di.currentTime();
                    Hi !== ji && (ji = Hi, Li());
                  });
                }, Vo = function() {
                  Di.currentSrc() || Di.error({
                    code: -1,
                    type: "PLAYER_ERR_NO_SRC"
                  });
                }, No = function() {
                  var ji = "", Hi = Di.error(), zo = fi().createElement("div"), Lo = "";
                  if (Hi) {
                    if (Hi = si.default.mergeOptions(Hi, Mi.errors[Hi.code || Hi.type || 0]), Hi.message && (ji = '<div class="vjs-errors-details">' + Di.localize("Technical details") + `
        : <div class="vjs-errors-message">` + Di.localize(Hi.message) + `</div>
        </div>`), Hi.code === 4 && mi && !mi.isSupported()) {
                      var sa = Di.localize("If you are using an older browser please try upgrading or installing Flash.");
                      ji += '<span class="vjs-errors-flashmessage">' + sa + "</span>";
                    }
                    var Ko = Di.getChild("errorDisplay");
                    zo.className = "vjs-errors-dialog", zo.id = "vjs-errors-dialog", Lo = `<div class="vjs-errors-content-container">
      <h2 class="vjs-errors-headline">` + this.localize(Hi.headline) + `</h2>
        <div class="vjs-errors-code"><b>` + this.localize("Error Code") + ":</b> " + (Hi.type || Hi.code) + `</div>
        ` + ji + `
      </div>`;
                    var ca = Ko.closeable(!("dismiss" in Hi) || Hi.dismiss);
                    if (ca) {
                      Lo += `<div class="vjs-errors-ok-button-container">
          <button class="vjs-errors-ok-button">` + this.localize("OK") + `</button>
        </div>`, zo.innerHTML = Lo, Ko.fillWith(zo), Ko.contentEl().firstChild.appendChild(Ko.getChild("closeButton").el());
                      var pa = Ko.el().querySelector(".vjs-errors-ok-button");
                      Di.on(pa, "click", function() {
                        Ko.close();
                      });
                    } else
                      zo.innerHTML = Lo, Ko.fillWith(zo);
                    (Di.currentWidth() <= 600 || Di.currentHeight() <= 250) && Ko.addClass("vjs-xs"), Ko.one("modalclose", function() {
                      return Di.error(null);
                    });
                  }
                }, Ui = function Wi() {
                  Co(), Di.removeClass("vjs-errors"), Di.off("play", Yi), Di.off("play", Vo), Di.off("dispose", Wi), Di.off(["aderror", "error"], No);
                }, jo = function(ji) {
                  Ui(), Oi(Di, si.default.mergeOptions(xi, ji));
                };
                jo.extend = function(Wi) {
                  return _o(Wi);
                }, jo.getAll = function() {
                  return si.default.mergeOptions(Mi.errors);
                }, jo.timeout = function(Wi) {
                  if (typeof Wi > "u")
                    return Mi.timeout;
                  Wi !== Mi.timeout && (Mi.timeout = Wi, Di.paused() || Yi());
                }, jo.disableProgress = function() {
                }, Di.on("play", Yi), Di.on("play", Vo), Di.on("dispose", Ui), Di.on(["aderror", "contenterror", "error"], No), Di.ready(function() {
                  Di.addClass("vjs-errors");
                }), Di.paused() || Yi(), jo.VERSION = gi, Di.errors = jo;
              }, Pi = function(Di) {
                Si(this, si.default.mergeOptions(xi, Di));
              };
              ["extend", "getAll"].forEach(function(Oi) {
                Pi[Oi] = function() {
                  si.default.log.warn("The errors." + Oi + "() method is not available until the plugin has been initialized!");
                };
              }), Pi.VERSION = gi, vi("errors", Pi);
              const $i = Pi;
            })
          ),
          /***/
          "./node_modules/videojs-flash/dist/videojs-flash.es.js": (
            /*!*************************************************************!*\
              !*** ./node_modules/videojs-flash/dist/videojs-flash.es.js ***!
              \*************************************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                default: () => Vo
                /* harmony export */
              });
              var si = oi(
                /*! video.js */
                "./node_modules/video.js/dist/video.es.js"
              ), di = oi(
                /*! videojs-swf/package.json */
                "./node_modules/videojs-swf/package.json"
              ), fi = oi(
                /*! global/window */
                "./node_modules/global/window.js"
              ), gi = /* @__PURE__ */ oi.n(fi), mi = "2.2.1";
              function Ti(No) {
                return No.streamingFormats = {
                  "rtmp/mp4": "MP4",
                  "rtmp/flv": "FLV"
                }, No.streamFromParts = function(Ui, jo) {
                  return Ui + "&" + jo;
                }, No.streamToParts = function(Ui) {
                  var jo = {
                    connection: "",
                    stream: ""
                  };
                  if (!Ui)
                    return jo;
                  var Wi = Ui.search(/&(?![\w-]+=)/), ji = void 0;
                  return Wi !== -1 ? ji = Wi + 1 : (Wi = ji = Ui.lastIndexOf("/") + 1, Wi === 0 && (Wi = ji = Ui.length)), jo.connection = Ui.substring(0, Wi), jo.stream = Ui.substring(ji, Ui.length), jo;
                }, No.isStreamingType = function(Ui) {
                  return Ui in No.streamingFormats;
                }, No.RTMP_RE = /^rtmp[set]?:\/\//i, No.isStreamingSrc = function(Ui) {
                  return No.RTMP_RE.test(Ui);
                }, No.rtmpSourceHandler = {}, No.rtmpSourceHandler.canPlayType = function(Ui) {
                  return No.isStreamingType(Ui) ? "maybe" : "";
                }, No.rtmpSourceHandler.canHandleSource = function(Ui, jo) {
                  var Wi = No.rtmpSourceHandler.canPlayType(Ui.type);
                  return Wi || (No.isStreamingSrc(Ui.src) ? "maybe" : "");
                }, No.rtmpSourceHandler.handleSource = function(Ui, jo, Wi) {
                  var ji = No.streamToParts(Ui.src);
                  jo.setRtmpConnection(ji.connection), jo.setRtmpStream(ji.stream);
                }, No.registerSourceHandler(No.rtmpSourceHandler), No;
              }
              var vi = function(No, Ui) {
                if (!(No instanceof Ui))
                  throw new TypeError("Cannot call a class as a function");
              }, xi = function(No, Ui) {
                if (typeof Ui != "function" && Ui !== null)
                  throw new TypeError("Super expression must either be null or a function, not " + typeof Ui);
                No.prototype = Object.create(Ui && Ui.prototype, {
                  constructor: {
                    value: No,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                  }
                }), Ui && (Object.setPrototypeOf ? Object.setPrototypeOf(No, Ui) : No.__proto__ = Ui);
              }, Si = function(No, Ui) {
                if (!No)
                  throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return Ui && (typeof Ui == "object" || typeof Ui == "function") ? Ui : No;
              }, Pi = si.default.getComponent("Tech"), $i = si.default.dom, Oi = si.default.url, Di = si.default.createTimeRange, Mi = si.default.mergeOptions, Oo = gi() && gi().navigator || {}, io = (function(No) {
                xi(Ui, No);
                function Ui(jo, Wi) {
                  vi(this, Ui);
                  var ji = Si(this, No.call(this, jo, Wi));
                  return jo.source && ji.ready(function() {
                    this.setSource(jo.source);
                  }, !0), jo.startTime && ji.ready(function() {
                    this.load(), this.play(), this.currentTime(jo.startTime);
                  }, !0), gi().videojs = gi().videojs || {}, gi().videojs.Flash = gi().videojs.Flash || {}, gi().videojs.Flash.onReady = Ui.onReady, gi().videojs.Flash.onEvent = Ui.onEvent, gi().videojs.Flash.onError = Ui.onError, ji.on("seeked", function() {
                    this.lastSeekTarget_ = void 0;
                  }), ji;
                }
                return Ui.prototype.createEl = function() {
                  var Wi = this.options_;
                  Wi.swf || (Wi.swf = "https://vjs.zencdn.net/swf/" + di.version + "/video-js.swf");
                  var ji = Wi.techId, Hi = Mi({
                    // SWF Callback Functions
                    readyFunction: "videojs.Flash.onReady",
                    eventProxyFunction: "videojs.Flash.onEvent",
                    errorEventProxyFunction: "videojs.Flash.onError",
                    // Player Settings
                    autoplay: Wi.autoplay,
                    preload: Wi.preload,
                    loop: Wi.loop,
                    muted: Wi.muted
                  }, Wi.flashVars), zo = Mi({
                    // Opaque is needed to overlay controls, but can affect playback performance
                    wmode: "opaque",
                    // Using bgcolor prevents a white flash when the object is loading
                    bgcolor: "#000000"
                  }, Wi.params), Lo = Mi({
                    // Both ID and Name needed or swf to identify itself
                    id: ji,
                    name: ji,
                    class: "vjs-tech"
                  }, Wi.attributes);
                  return this.el_ = Ui.embed(Wi.swf, Hi, zo, Lo), this.el_.tech = this, this.el_;
                }, Ui.prototype.play = function() {
                  this.ended() && this.setCurrentTime(0), this.el_.vjs_play();
                }, Ui.prototype.pause = function() {
                  this.el_.vjs_pause();
                }, Ui.prototype.src = function(Wi) {
                  return Wi === void 0 ? this.currentSrc() : this.setSrc(Wi);
                }, Ui.prototype.setSrc = function(Wi) {
                  var ji = this;
                  Wi = Oi.getAbsoluteURL(Wi), this.el_.vjs_src(Wi), this.autoplay() && this.setTimeout(function() {
                    return ji.play();
                  }, 0);
                }, Ui.prototype.seeking = function() {
                  return this.lastSeekTarget_ !== void 0;
                }, Ui.prototype.setCurrentTime = function(Wi) {
                  var ji = this.seekable();
                  ji.length && (Wi = Wi > ji.start(0) ? Wi : ji.start(0), Wi = Wi < ji.end(ji.length - 1) ? Wi : ji.end(ji.length - 1), this.lastSeekTarget_ = Wi, this.trigger("seeking"), this.el_.vjs_setProperty("currentTime", Wi), No.prototype.setCurrentTime.call(this));
                }, Ui.prototype.currentTime = function() {
                  return this.seeking() ? this.lastSeekTarget_ || 0 : this.el_.vjs_getProperty("currentTime");
                }, Ui.prototype.currentSrc = function() {
                  return this.currentSource_ ? this.currentSource_.src : this.el_.vjs_getProperty("currentSrc");
                }, Ui.prototype.duration = function() {
                  if (this.readyState() === 0)
                    return NaN;
                  var Wi = this.el_.vjs_getProperty("duration");
                  return Wi >= 0 ? Wi : 1 / 0;
                }, Ui.prototype.load = function() {
                  this.el_.vjs_load();
                }, Ui.prototype.poster = function() {
                  this.el_.vjs_getProperty("poster");
                }, Ui.prototype.setPoster = function() {
                }, Ui.prototype.seekable = function() {
                  var Wi = this.duration();
                  return Wi === 0 ? Di() : Di(0, Wi);
                }, Ui.prototype.buffered = function() {
                  var Wi = this.el_.vjs_getProperty("buffered");
                  return Wi.length === 0 ? Di() : Di(Wi[0][0], Wi[0][1]);
                }, Ui.prototype.supportsFullScreen = function() {
                  return !1;
                }, Ui.prototype.enterFullScreen = function() {
                  return !1;
                }, Ui.prototype.getVideoPlaybackQuality = function() {
                  var Wi = this.el_.vjs_getProperty("getVideoPlaybackQuality");
                  return gi().performance && typeof gi().performance.now == "function" ? Wi.creationTime = gi().performance.now() : gi().performance && gi().performance.timing && typeof gi().performance.timing.navigationStart == "number" && (Wi.creationTime = gi().Date.now() - gi().performance.timing.navigationStart), Wi;
                }, Ui;
              })(Pi), xo = ["rtmpConnection", "rtmpStream", "preload", "defaultPlaybackRate", "playbackRate", "autoplay", "loop", "controls", "volume", "muted", "defaultMuted"], fo = ["networkState", "readyState", "initialTime", "startOffsetTime", "paused", "ended", "videoWidth", "videoHeight"], _o = io.prototype;
              function Li(No) {
                var Ui = No.charAt(0).toUpperCase() + No.slice(1);
                _o["set" + Ui] = function(jo) {
                  return this.el_.vjs_setProperty(No, jo);
                };
              }
              function Co(No) {
                _o[No] = function() {
                  return this.el_.vjs_getProperty(No);
                };
              }
              for (var Ni = 0; Ni < xo.length; Ni++)
                Co(xo[Ni]), Li(xo[Ni]);
              for (var Yi = 0; Yi < fo.length; Yi++)
                Co(fo[Yi]);
              io.isSupported = function() {
                return si.default.browser.IS_CHROME && (!si.default.browser.IS_ANDROID || !si.default.browser.IS_IOS) || si.default.browser.IS_SAFARI && !si.default.browser.IS_IOS || si.default.browser.IS_EDGE ? !0 : io.version()[0] >= 10;
              }, Pi.withSourceHandlers(io), io.nativeSourceHandler = {}, io.nativeSourceHandler.canPlayType = function(No) {
                return No in io.formats ? "maybe" : "";
              }, io.nativeSourceHandler.canHandleSource = function(No, Ui) {
                var jo = void 0;
                function Wi(ji) {
                  var Hi = Oi.getFileExtension(ji);
                  return Hi ? "video/" + Hi : "";
                }
                return No.type ? jo = No.type.replace(/;.*/, "").toLowerCase() : jo = Wi(No.src), io.nativeSourceHandler.canPlayType(jo);
              }, io.nativeSourceHandler.handleSource = function(No, Ui, jo) {
                Ui.setSrc(No.src);
              }, io.nativeSourceHandler.dispose = function() {
              }, io.registerSourceHandler(io.nativeSourceHandler), io.formats = {
                "video/flv": "FLV",
                "video/x-flv": "FLV",
                "video/mp4": "MP4",
                "video/m4v": "MP4"
              }, io.onReady = function(No) {
                var Ui = $i.$("#" + No), jo = Ui && Ui.tech;
                jo && jo.el() && io.checkReady(jo);
              }, io.checkReady = function(No) {
                No.el() && (No.el().vjs_getProperty ? No.triggerReady() : this.setTimeout(function() {
                  io.checkReady(No);
                }, 50));
              }, io.onEvent = function(No, Ui) {
                var jo = $i.$("#" + No).tech, Wi = Array.prototype.slice.call(arguments, 2);
                jo.setTimeout(function() {
                  jo.trigger(Ui, Wi);
                }, 1);
              }, io.onError = function(No, Ui) {
                var jo = $i.$("#" + No).tech;
                if (Ui === "srcnotfound")
                  return jo.error(4);
                typeof Ui == "string" ? jo.error("FLASH: " + Ui) : (Ui.origin = "flash", jo.error(Ui));
              }, io.version = function() {
                var No = "0,0,0";
                try {
                  No = new (gi()).ActiveXObject("ShockwaveFlash.ShockwaveFlash").GetVariable("$version").replace(/\D+/g, ",").match(/^,?(.+),?$/)[1];
                } catch {
                  try {
                    Oo.mimeTypes["application/x-shockwave-flash"].enabledPlugin && (No = (Oo.plugins["Shockwave Flash 2.0"] || Oo.plugins["Shockwave Flash"]).description.replace(/\D+/g, ",").match(/^,?(.+),?$/)[1]);
                  } catch {
                  }
                }
                return No.split(",");
              }, io.embed = function(No, Ui, jo, Wi) {
                var ji = io.getEmbedCode(No, Ui, jo, Wi), Hi = $i.createEl("div", { innerHTML: ji }).childNodes[0];
                return Hi;
              }, io.getEmbedCode = function(No, Ui, jo, Wi) {
                var ji = '<object type="application/x-shockwave-flash" ', Hi = "", zo = "", Lo = "";
                return Ui && Object.getOwnPropertyNames(Ui).forEach(function(sa) {
                  Hi += sa + "=" + Ui[sa] + "&amp;";
                }), jo = Mi({
                  movie: No,
                  flashvars: Hi,
                  // Required to talk to swf
                  allowScriptAccess: "always",
                  // All should be default, but having security issues.
                  allowNetworking: "all"
                }, jo), Object.getOwnPropertyNames(jo).forEach(function(sa) {
                  zo += '<param name="' + sa + '" value="' + jo[sa] + '" />';
                }), Wi = Mi({
                  // Add swf to attributes (need both for IE and Others to work)
                  data: No,
                  // Default to 100% width/height
                  width: "100%",
                  height: "100%"
                }, Wi), Object.getOwnPropertyNames(Wi).forEach(function(sa) {
                  Lo += sa + '="' + Wi[sa] + '" ';
                }), "" + ji + Lo + ">" + zo + "</object>";
              }, Ti(io), Pi.getTech("Flash") ? (si.default.log.warn("Not using videojs-flash as it appears to already be registered"), si.default.log.warn("videojs-flash should only be used with video.js@6 and above")) : si.default.registerTech("Flash", io), io.VERSION = mi;
              const Vo = io;
            })
          ),
          /***/
          "./node_modules/videojs-vtt.js/lib/browser-index.js": (
            /*!**********************************************************!*\
              !*** ./node_modules/videojs-vtt.js/lib/browser-index.js ***!
              \**********************************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! global/window */
                "./node_modules/global/window.js"
              ), di = ai.exports = {
                WebVTT: oi(
                  /*! ./vtt.js */
                  "./node_modules/videojs-vtt.js/lib/vtt.js"
                ),
                VTTCue: oi(
                  /*! ./vttcue.js */
                  "./node_modules/videojs-vtt.js/lib/vttcue.js"
                ),
                VTTRegion: oi(
                  /*! ./vttregion.js */
                  "./node_modules/videojs-vtt.js/lib/vttregion.js"
                )
              };
              si.vttjs = di, si.WebVTT = di.WebVTT;
              var fi = di.VTTCue, gi = di.VTTRegion, mi = si.VTTCue, Ti = si.VTTRegion;
              di.shim = function() {
                si.VTTCue = fi, si.VTTRegion = gi;
              }, di.restore = function() {
                si.VTTCue = mi, si.VTTRegion = Ti;
              }, si.VTTCue || di.shim();
            })
          ),
          /***/
          "./node_modules/videojs-vtt.js/lib/vtt.js": (
            /*!************************************************!*\
              !*** ./node_modules/videojs-vtt.js/lib/vtt.js ***!
              \************************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! global/document */
                "./node_modules/global/document.js"
              ), di = Object.create || /* @__PURE__ */ (function() {
                function Ui() {
                }
                return function(jo) {
                  if (arguments.length !== 1)
                    throw new Error("Object.create shim only accepts one parameter.");
                  return Ui.prototype = jo, new Ui();
                };
              })();
              function fi(Ui, jo) {
                this.name = "ParsingError", this.code = Ui.code, this.message = jo || Ui.message;
              }
              fi.prototype = di(Error.prototype), fi.prototype.constructor = fi, fi.Errors = {
                BadSignature: {
                  code: 0,
                  message: "Malformed WebVTT signature."
                },
                BadTimeStamp: {
                  code: 1,
                  message: "Malformed time stamp."
                }
              };
              function gi(Ui) {
                function jo(ji, Hi, zo, Lo) {
                  return (ji | 0) * 3600 + (Hi | 0) * 60 + (zo | 0) + (Lo | 0) / 1e3;
                }
                var Wi = Ui.match(/^(\d+):(\d{1,2})(:\d{1,2})?\.(\d{3})/);
                return Wi ? Wi[3] ? jo(Wi[1], Wi[2], Wi[3].replace(":", ""), Wi[4]) : Wi[1] > 59 ? jo(Wi[1], Wi[2], 0, Wi[4]) : jo(0, Wi[1], Wi[2], Wi[4]) : null;
              }
              function mi() {
                this.values = di(null);
              }
              mi.prototype = {
                // Only accept the first assignment to any key.
                set: function(Ui, jo) {
                  !this.get(Ui) && jo !== "" && (this.values[Ui] = jo);
                },
                // Return the value for a key, or a default value.
                // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
                // a number of possible default values as properties where 'defaultKey' is
                // the key of the property that will be chosen; otherwise it's assumed to be
                // a single value.
                get: function(Ui, jo, Wi) {
                  return Wi ? this.has(Ui) ? this.values[Ui] : jo[Wi] : this.has(Ui) ? this.values[Ui] : jo;
                },
                // Check whether we have a value for a key.
                has: function(Ui) {
                  return Ui in this.values;
                },
                // Accept a setting if its one of the given alternatives.
                alt: function(Ui, jo, Wi) {
                  for (var ji = 0; ji < Wi.length; ++ji)
                    if (jo === Wi[ji]) {
                      this.set(Ui, jo);
                      break;
                    }
                },
                // Accept a setting if its a valid (signed) integer.
                integer: function(Ui, jo) {
                  /^-?\d+$/.test(jo) && this.set(Ui, parseInt(jo, 10));
                },
                // Accept a setting if its a valid percentage.
                percent: function(Ui, jo) {
                  return jo.match(/^([\d]{1,3})(\.[\d]*)?%$/) && (jo = parseFloat(jo), jo >= 0 && jo <= 100) ? (this.set(Ui, jo), !0) : !1;
                }
              };
              function Ti(Ui, jo, Wi, ji) {
                var Hi = ji ? Ui.split(ji) : [Ui];
                for (var zo in Hi)
                  if (typeof Hi[zo] == "string") {
                    var Lo = Hi[zo].split(Wi);
                    if (Lo.length === 2) {
                      var sa = Lo[0].trim(), Ko = Lo[1].trim();
                      jo(sa, Ko);
                    }
                  }
              }
              function vi(Ui, jo, Wi) {
                var ji = Ui;
                function Hi() {
                  var sa = gi(Ui);
                  if (sa === null)
                    throw new fi(
                      fi.Errors.BadTimeStamp,
                      "Malformed timestamp: " + ji
                    );
                  return Ui = Ui.replace(/^[^\sa-zA-Z-]+/, ""), sa;
                }
                function zo(sa, Ko) {
                  var ca = new mi();
                  Ti(sa, function(pa, ga) {
                    switch (pa) {
                      case "region":
                        for (var ia = Wi.length - 1; ia >= 0; ia--)
                          if (Wi[ia].id === ga) {
                            ca.set(pa, Wi[ia].region);
                            break;
                          }
                        break;
                      case "vertical":
                        ca.alt(pa, ga, ["rl", "lr"]);
                        break;
                      case "line":
                        var ra = ga.split(","), qo = ra[0];
                        ca.integer(pa, qo), ca.percent(pa, qo) && ca.set("snapToLines", !1), ca.alt(pa, qo, ["auto"]), ra.length === 2 && ca.alt("lineAlign", ra[1], ["start", "center", "end"]);
                        break;
                      case "position":
                        ra = ga.split(","), ca.percent(pa, ra[0]), ra.length === 2 && ca.alt("positionAlign", ra[1], ["start", "center", "end"]);
                        break;
                      case "size":
                        ca.percent(pa, ga);
                        break;
                      case "align":
                        ca.alt(pa, ga, ["start", "center", "end", "left", "right"]);
                        break;
                    }
                  }, /:/, /\s/), Ko.region = ca.get("region", null), Ko.vertical = ca.get("vertical", "");
                  try {
                    Ko.line = ca.get("line", "auto");
                  } catch {
                  }
                  Ko.lineAlign = ca.get("lineAlign", "start"), Ko.snapToLines = ca.get("snapToLines", !0), Ko.size = ca.get("size", 100);
                  try {
                    Ko.align = ca.get("align", "center");
                  } catch {
                    Ko.align = ca.get("align", "middle");
                  }
                  try {
                    Ko.position = ca.get("position", "auto");
                  } catch {
                    Ko.position = ca.get("position", {
                      start: 0,
                      left: 0,
                      center: 50,
                      middle: 50,
                      end: 100,
                      right: 100
                    }, Ko.align);
                  }
                  Ko.positionAlign = ca.get("positionAlign", {
                    start: "start",
                    left: "start",
                    center: "center",
                    middle: "center",
                    end: "end",
                    right: "end"
                  }, Ko.align);
                }
                function Lo() {
                  Ui = Ui.replace(/^\s+/, "");
                }
                if (Lo(), jo.startTime = Hi(), Lo(), Ui.substr(0, 3) !== "-->")
                  throw new fi(
                    fi.Errors.BadTimeStamp,
                    "Malformed time stamp (time stamps must be separated by '-->'): " + ji
                  );
                Ui = Ui.substr(3), Lo(), jo.endTime = Hi(), Lo(), zo(Ui, jo);
              }
              var xi = si.createElement && si.createElement("textarea"), Si = {
                c: "span",
                i: "i",
                b: "b",
                u: "u",
                ruby: "ruby",
                rt: "rt",
                v: "span",
                lang: "span"
              }, Pi = {
                white: "rgba(255,255,255,1)",
                lime: "rgba(0,255,0,1)",
                cyan: "rgba(0,255,255,1)",
                red: "rgba(255,0,0,1)",
                yellow: "rgba(255,255,0,1)",
                magenta: "rgba(255,0,255,1)",
                blue: "rgba(0,0,255,1)",
                black: "rgba(0,0,0,1)"
              }, $i = {
                v: "title",
                lang: "lang"
              }, Oi = {
                rt: "ruby"
              };
              function Di(Ui, jo) {
                function Wi() {
                  if (!jo)
                    return null;
                  function qo($a) {
                    return jo = jo.substr($a.length), $a;
                  }
                  var xa = jo.match(/^([^<]*)(<[^>]*>?)?/);
                  return qo(xa[1] ? xa[1] : xa[2]);
                }
                function ji(qo) {
                  return xi.innerHTML = qo, qo = xi.textContent, xi.textContent = "", qo;
                }
                function Hi(qo, xa) {
                  return !Oi[xa.localName] || Oi[xa.localName] === qo.localName;
                }
                function zo(qo, xa) {
                  var $a = Si[qo];
                  if (!$a)
                    return null;
                  var ys = Ui.document.createElement($a), Ss = $i[qo];
                  return Ss && xa && (ys[Ss] = xa.trim()), ys;
                }
                for (var Lo = Ui.document.createElement("div"), sa = Lo, Ko, ca = []; (Ko = Wi()) !== null; ) {
                  if (Ko[0] === "<") {
                    if (Ko[1] === "/") {
                      ca.length && ca[ca.length - 1] === Ko.substr(2).replace(">", "") && (ca.pop(), sa = sa.parentNode);
                      continue;
                    }
                    var pa = gi(Ko.substr(1, Ko.length - 2)), ga;
                    if (pa) {
                      ga = Ui.document.createProcessingInstruction("timestamp", pa), sa.appendChild(ga);
                      continue;
                    }
                    var ia = Ko.match(/^<([^.\s/0-9>]+)(\.[^\s\\>]+)?([^>\\]+)?(\\?)>?$/);
                    if (!ia || (ga = zo(ia[1], ia[3]), !ga) || !Hi(sa, ga))
                      continue;
                    if (ia[2]) {
                      var ra = ia[2].split(".");
                      ra.forEach(function(qo) {
                        var xa = /^bg_/.test(qo), $a = xa ? qo.slice(3) : qo;
                        if (Pi.hasOwnProperty($a)) {
                          var ys = xa ? "background-color" : "color", Ss = Pi[$a];
                          ga.style[ys] = Ss;
                        }
                      }), ga.className = ra.join(" ");
                    }
                    ca.push(ia[1]), sa.appendChild(ga), sa = ga;
                    continue;
                  }
                  sa.appendChild(Ui.document.createTextNode(ji(Ko)));
                }
                return Lo;
              }
              var Mi = [
                [1470, 1470],
                [1472, 1472],
                [1475, 1475],
                [1478, 1478],
                [1488, 1514],
                [1520, 1524],
                [1544, 1544],
                [1547, 1547],
                [1549, 1549],
                [1563, 1563],
                [1566, 1610],
                [1645, 1647],
                [1649, 1749],
                [1765, 1766],
                [1774, 1775],
                [1786, 1805],
                [1807, 1808],
                [1810, 1839],
                [1869, 1957],
                [1969, 1969],
                [1984, 2026],
                [2036, 2037],
                [2042, 2042],
                [2048, 2069],
                [2074, 2074],
                [2084, 2084],
                [2088, 2088],
                [2096, 2110],
                [2112, 2136],
                [2142, 2142],
                [2208, 2208],
                [2210, 2220],
                [8207, 8207],
                [64285, 64285],
                [64287, 64296],
                [64298, 64310],
                [64312, 64316],
                [64318, 64318],
                [64320, 64321],
                [64323, 64324],
                [64326, 64449],
                [64467, 64829],
                [64848, 64911],
                [64914, 64967],
                [65008, 65020],
                [65136, 65140],
                [65142, 65276],
                [67584, 67589],
                [67592, 67592],
                [67594, 67637],
                [67639, 67640],
                [67644, 67644],
                [67647, 67669],
                [67671, 67679],
                [67840, 67867],
                [67872, 67897],
                [67903, 67903],
                [67968, 68023],
                [68030, 68031],
                [68096, 68096],
                [68112, 68115],
                [68117, 68119],
                [68121, 68147],
                [68160, 68167],
                [68176, 68184],
                [68192, 68223],
                [68352, 68405],
                [68416, 68437],
                [68440, 68466],
                [68472, 68479],
                [68608, 68680],
                [126464, 126467],
                [126469, 126495],
                [126497, 126498],
                [126500, 126500],
                [126503, 126503],
                [126505, 126514],
                [126516, 126519],
                [126521, 126521],
                [126523, 126523],
                [126530, 126530],
                [126535, 126535],
                [126537, 126537],
                [126539, 126539],
                [126541, 126543],
                [126545, 126546],
                [126548, 126548],
                [126551, 126551],
                [126553, 126553],
                [126555, 126555],
                [126557, 126557],
                [126559, 126559],
                [126561, 126562],
                [126564, 126564],
                [126567, 126570],
                [126572, 126578],
                [126580, 126583],
                [126585, 126588],
                [126590, 126590],
                [126592, 126601],
                [126603, 126619],
                [126625, 126627],
                [126629, 126633],
                [126635, 126651],
                [1114109, 1114109]
              ];
              function Oo(Ui) {
                for (var jo = 0; jo < Mi.length; jo++) {
                  var Wi = Mi[jo];
                  if (Ui >= Wi[0] && Ui <= Wi[1])
                    return !0;
                }
                return !1;
              }
              function io(Ui) {
                var jo = [], Wi = "", ji;
                if (!Ui || !Ui.childNodes)
                  return "ltr";
                function Hi(sa, Ko) {
                  for (var ca = Ko.childNodes.length - 1; ca >= 0; ca--)
                    sa.push(Ko.childNodes[ca]);
                }
                function zo(sa) {
                  if (!sa || !sa.length)
                    return null;
                  var Ko = sa.pop(), ca = Ko.textContent || Ko.innerText;
                  if (ca) {
                    var pa = ca.match(/^.*(\n|\r)/);
                    return pa ? (sa.length = 0, pa[0]) : ca;
                  }
                  if (Ko.tagName === "ruby")
                    return zo(sa);
                  if (Ko.childNodes)
                    return Hi(sa, Ko), zo(sa);
                }
                for (Hi(jo, Ui); Wi = zo(jo); )
                  for (var Lo = 0; Lo < Wi.length; Lo++)
                    if (ji = Wi.charCodeAt(Lo), Oo(ji))
                      return "rtl";
                return "ltr";
              }
              function xo(Ui) {
                if (typeof Ui.line == "number" && (Ui.snapToLines || Ui.line >= 0 && Ui.line <= 100))
                  return Ui.line;
                if (!Ui.track || !Ui.track.textTrackList || !Ui.track.textTrackList.mediaElement)
                  return -1;
                for (var jo = Ui.track, Wi = jo.textTrackList, ji = 0, Hi = 0; Hi < Wi.length && Wi[Hi] !== jo; Hi++)
                  Wi[Hi].mode === "showing" && ji++;
                return ++ji * -1;
              }
              function fo() {
              }
              fo.prototype.applyStyles = function(Ui, jo) {
                jo = jo || this.div;
                for (var Wi in Ui)
                  Ui.hasOwnProperty(Wi) && (jo.style[Wi] = Ui[Wi]);
              }, fo.prototype.formatStyle = function(Ui, jo) {
                return Ui === 0 ? 0 : Ui + jo;
              };
              function _o(Ui, jo, Wi) {
                fo.call(this), this.cue = jo, this.cueDiv = Di(Ui, jo.text);
                var ji = {
                  color: "rgba(255, 255, 255, 1)",
                  backgroundColor: "rgba(0, 0, 0, 0.8)",
                  position: "relative",
                  left: 0,
                  right: 0,
                  top: 0,
                  bottom: 0,
                  display: "inline",
                  writingMode: jo.vertical === "" ? "horizontal-tb" : jo.vertical === "lr" ? "vertical-lr" : "vertical-rl",
                  unicodeBidi: "plaintext"
                };
                this.applyStyles(ji, this.cueDiv), this.div = Ui.document.createElement("div"), ji = {
                  direction: io(this.cueDiv),
                  writingMode: jo.vertical === "" ? "horizontal-tb" : jo.vertical === "lr" ? "vertical-lr" : "vertical-rl",
                  unicodeBidi: "plaintext",
                  textAlign: jo.align === "middle" ? "center" : jo.align,
                  font: Wi.font,
                  whiteSpace: "pre-line",
                  position: "absolute"
                }, this.applyStyles(ji), this.div.appendChild(this.cueDiv);
                var Hi = 0;
                switch (jo.positionAlign) {
                  case "start":
                  case "line-left":
                    Hi = jo.position;
                    break;
                  case "center":
                    Hi = jo.position - jo.size / 2;
                    break;
                  case "end":
                  case "line-right":
                    Hi = jo.position - jo.size;
                    break;
                }
                jo.vertical === "" ? this.applyStyles({
                  left: this.formatStyle(Hi, "%"),
                  width: this.formatStyle(jo.size, "%")
                }) : this.applyStyles({
                  top: this.formatStyle(Hi, "%"),
                  height: this.formatStyle(jo.size, "%")
                }), this.move = function(zo) {
                  this.applyStyles({
                    top: this.formatStyle(zo.top, "px"),
                    bottom: this.formatStyle(zo.bottom, "px"),
                    left: this.formatStyle(zo.left, "px"),
                    right: this.formatStyle(zo.right, "px"),
                    height: this.formatStyle(zo.height, "px"),
                    width: this.formatStyle(zo.width, "px")
                  });
                };
              }
              _o.prototype = di(fo.prototype), _o.prototype.constructor = _o;
              function Li(Ui) {
                var jo, Wi, ji, Hi;
                if (Ui.div) {
                  Wi = Ui.div.offsetHeight, ji = Ui.div.offsetWidth, Hi = Ui.div.offsetTop;
                  var zo = (zo = Ui.div.childNodes) && (zo = zo[0]) && zo.getClientRects && zo.getClientRects();
                  Ui = Ui.div.getBoundingClientRect(), jo = zo ? Math.max(zo[0] && zo[0].height || 0, Ui.height / zo.length) : 0;
                }
                this.left = Ui.left, this.right = Ui.right, this.top = Ui.top || Hi, this.height = Ui.height || Wi, this.bottom = Ui.bottom || Hi + (Ui.height || Wi), this.width = Ui.width || ji, this.lineHeight = jo !== void 0 ? jo : Ui.lineHeight;
              }
              Li.prototype.move = function(Ui, jo) {
                switch (jo = jo !== void 0 ? jo : this.lineHeight, Ui) {
                  case "+x":
                    this.left += jo, this.right += jo;
                    break;
                  case "-x":
                    this.left -= jo, this.right -= jo;
                    break;
                  case "+y":
                    this.top += jo, this.bottom += jo;
                    break;
                  case "-y":
                    this.top -= jo, this.bottom -= jo;
                    break;
                }
              }, Li.prototype.overlaps = function(Ui) {
                return this.left < Ui.right && this.right > Ui.left && this.top < Ui.bottom && this.bottom > Ui.top;
              }, Li.prototype.overlapsAny = function(Ui) {
                for (var jo = 0; jo < Ui.length; jo++)
                  if (this.overlaps(Ui[jo]))
                    return !0;
                return !1;
              }, Li.prototype.within = function(Ui) {
                return this.top >= Ui.top && this.bottom <= Ui.bottom && this.left >= Ui.left && this.right <= Ui.right;
              }, Li.prototype.overlapsOppositeAxis = function(Ui, jo) {
                switch (jo) {
                  case "+x":
                    return this.left < Ui.left;
                  case "-x":
                    return this.right > Ui.right;
                  case "+y":
                    return this.top < Ui.top;
                  case "-y":
                    return this.bottom > Ui.bottom;
                }
              }, Li.prototype.intersectPercentage = function(Ui) {
                var jo = Math.max(0, Math.min(this.right, Ui.right) - Math.max(this.left, Ui.left)), Wi = Math.max(0, Math.min(this.bottom, Ui.bottom) - Math.max(this.top, Ui.top)), ji = jo * Wi;
                return ji / (this.height * this.width);
              }, Li.prototype.toCSSCompatValues = function(Ui) {
                return {
                  top: this.top - Ui.top,
                  bottom: Ui.bottom - this.bottom,
                  left: this.left - Ui.left,
                  right: Ui.right - this.right,
                  height: this.height,
                  width: this.width
                };
              }, Li.getSimpleBoxPosition = function(Ui) {
                var jo = Ui.div ? Ui.div.offsetHeight : Ui.tagName ? Ui.offsetHeight : 0, Wi = Ui.div ? Ui.div.offsetWidth : Ui.tagName ? Ui.offsetWidth : 0, ji = Ui.div ? Ui.div.offsetTop : Ui.tagName ? Ui.offsetTop : 0;
                Ui = Ui.div ? Ui.div.getBoundingClientRect() : Ui.tagName ? Ui.getBoundingClientRect() : Ui;
                var Hi = {
                  left: Ui.left,
                  right: Ui.right,
                  top: Ui.top || ji,
                  height: Ui.height || jo,
                  bottom: Ui.bottom || ji + (Ui.height || jo),
                  width: Ui.width || Wi
                };
                return Hi;
              };
              function Co(Ui, jo, Wi, ji) {
                function Hi($a, ys) {
                  for (var Ss, Xa = new Li($a), Es = 1, Rs = 0; Rs < ys.length; Rs++) {
                    for (; $a.overlapsOppositeAxis(Wi, ys[Rs]) || $a.within(Wi) && $a.overlapsAny(ji); )
                      $a.move(ys[Rs]);
                    if ($a.within(Wi))
                      return $a;
                    var La = $a.intersectPercentage(Wi);
                    Es > La && (Ss = new Li($a), Es = La), $a = new Li(Xa);
                  }
                  return Ss || Xa;
                }
                var zo = new Li(jo), Lo = jo.cue, sa = xo(Lo), Ko = [];
                if (Lo.snapToLines) {
                  var ca;
                  switch (Lo.vertical) {
                    case "":
                      Ko = ["+y", "-y"], ca = "height";
                      break;
                    case "rl":
                      Ko = ["+x", "-x"], ca = "width";
                      break;
                    case "lr":
                      Ko = ["-x", "+x"], ca = "width";
                      break;
                  }
                  var pa = zo.lineHeight, ga = pa * Math.round(sa), ia = Wi[ca] + pa, ra = Ko[0];
                  Math.abs(ga) > ia && (ga = ga < 0 ? -1 : 1, ga *= Math.ceil(ia / pa) * pa), sa < 0 && (ga += Lo.vertical === "" ? Wi.height : Wi.width, Ko = Ko.reverse()), zo.move(ra, ga);
                } else {
                  var qo = zo.lineHeight / Wi.height * 100;
                  switch (Lo.lineAlign) {
                    case "center":
                      sa -= qo / 2;
                      break;
                    case "end":
                      sa -= qo;
                      break;
                  }
                  switch (Lo.vertical) {
                    case "":
                      jo.applyStyles({
                        top: jo.formatStyle(sa, "%")
                      });
                      break;
                    case "rl":
                      jo.applyStyles({
                        left: jo.formatStyle(sa, "%")
                      });
                      break;
                    case "lr":
                      jo.applyStyles({
                        right: jo.formatStyle(sa, "%")
                      });
                      break;
                  }
                  Ko = ["+y", "-x", "+x", "-y"], zo = new Li(jo);
                }
                var xa = Hi(zo, Ko);
                jo.move(xa.toCSSCompatValues(Wi));
              }
              function Ni() {
              }
              Ni.StringDecoder = function() {
                return {
                  decode: function(Ui) {
                    if (!Ui)
                      return "";
                    if (typeof Ui != "string")
                      throw new Error("Error - expected string data.");
                    return decodeURIComponent(encodeURIComponent(Ui));
                  }
                };
              }, Ni.convertCueToDOMTree = function(Ui, jo) {
                return !Ui || !jo ? null : Di(Ui, jo);
              };
              var Yi = 0.05, Vo = "sans-serif", No = "1.5%";
              Ni.processCues = function(Ui, jo, Wi) {
                if (!Ui || !jo || !Wi)
                  return null;
                for (; Wi.firstChild; )
                  Wi.removeChild(Wi.firstChild);
                var ji = Ui.document.createElement("div");
                ji.style.position = "absolute", ji.style.left = "0", ji.style.right = "0", ji.style.top = "0", ji.style.bottom = "0", ji.style.margin = No, Wi.appendChild(ji);
                function Hi(pa) {
                  for (var ga = 0; ga < pa.length; ga++)
                    if (pa[ga].hasBeenReset || !pa[ga].displayState)
                      return !0;
                  return !1;
                }
                if (!Hi(jo)) {
                  for (var zo = 0; zo < jo.length; zo++)
                    ji.appendChild(jo[zo].displayState);
                  return;
                }
                var Lo = [], sa = Li.getSimpleBoxPosition(ji), Ko = Math.round(sa.height * Yi * 100) / 100, ca = {
                  font: Ko + "px " + Vo
                };
                (function() {
                  for (var pa, ga, ia = 0; ia < jo.length; ia++)
                    ga = jo[ia], pa = new _o(Ui, ga, ca), ji.appendChild(pa.div), Co(Ui, pa, sa, Lo), ga.displayState = pa.div, Lo.push(Li.getSimpleBoxPosition(pa));
                })();
              }, Ni.Parser = function(Ui, jo, Wi) {
                Wi || (Wi = jo, jo = {}), jo || (jo = {}), this.window = Ui, this.vttjs = jo, this.state = "INITIAL", this.buffer = "", this.decoder = Wi || new TextDecoder("utf8"), this.regionList = [];
              }, Ni.Parser.prototype = {
                // If the error is a ParsingError then report it to the consumer if
                // possible. If it's not a ParsingError then throw it like normal.
                reportOrThrowError: function(Ui) {
                  if (Ui instanceof fi)
                    this.onparsingerror && this.onparsingerror(Ui);
                  else
                    throw Ui;
                },
                parse: function(Ui) {
                  var jo = this;
                  Ui && (jo.buffer += jo.decoder.decode(Ui, { stream: !0 }));
                  function Wi() {
                    for (var pa = jo.buffer, ga = 0; ga < pa.length && pa[ga] !== "\r" && pa[ga] !== `
`; )
                      ++ga;
                    var ia = pa.substr(0, ga);
                    return pa[ga] === "\r" && ++ga, pa[ga] === `
` && ++ga, jo.buffer = pa.substr(ga), ia;
                  }
                  function ji(pa) {
                    var ga = new mi();
                    if (Ti(pa, function(ra, qo) {
                      switch (ra) {
                        case "id":
                          ga.set(ra, qo);
                          break;
                        case "width":
                          ga.percent(ra, qo);
                          break;
                        case "lines":
                          ga.integer(ra, qo);
                          break;
                        case "regionanchor":
                        case "viewportanchor":
                          var xa = qo.split(",");
                          if (xa.length !== 2)
                            break;
                          var $a = new mi();
                          if ($a.percent("x", xa[0]), $a.percent("y", xa[1]), !$a.has("x") || !$a.has("y"))
                            break;
                          ga.set(ra + "X", $a.get("x")), ga.set(ra + "Y", $a.get("y"));
                          break;
                        case "scroll":
                          ga.alt(ra, qo, ["up"]);
                          break;
                      }
                    }, /=/, /\s/), ga.has("id")) {
                      var ia = new (jo.vttjs.VTTRegion || jo.window.VTTRegion)();
                      ia.width = ga.get("width", 100), ia.lines = ga.get("lines", 3), ia.regionAnchorX = ga.get("regionanchorX", 0), ia.regionAnchorY = ga.get("regionanchorY", 100), ia.viewportAnchorX = ga.get("viewportanchorX", 0), ia.viewportAnchorY = ga.get("viewportanchorY", 100), ia.scroll = ga.get("scroll", ""), jo.onregion && jo.onregion(ia), jo.regionList.push({
                        id: ga.get("id"),
                        region: ia
                      });
                    }
                  }
                  function Hi(pa) {
                    var ga = new mi();
                    Ti(pa, function(ia, ra) {
                      switch (ia) {
                        case "MPEGT":
                          ga.integer(ia + "S", ra);
                          break;
                        case "LOCA":
                          ga.set(ia + "L", gi(ra));
                          break;
                      }
                    }, /[^\d]:/, /,/), jo.ontimestampmap && jo.ontimestampmap({
                      MPEGTS: ga.get("MPEGTS"),
                      LOCAL: ga.get("LOCAL")
                    });
                  }
                  function zo(pa) {
                    pa.match(/X-TIMESTAMP-MAP/) ? Ti(pa, function(ga, ia) {
                      switch (ga) {
                        case "X-TIMESTAMP-MAP":
                          Hi(ia);
                          break;
                      }
                    }, /=/) : Ti(pa, function(ga, ia) {
                      switch (ga) {
                        case "Region":
                          ji(ia);
                          break;
                      }
                    }, /:/);
                  }
                  try {
                    var Lo;
                    if (jo.state === "INITIAL") {
                      if (!/\r\n|\n/.test(jo.buffer))
                        return this;
                      Lo = Wi();
                      var sa = Lo.match(/^WEBVTT([ \t].*)?$/);
                      if (!sa || !sa[0])
                        throw new fi(fi.Errors.BadSignature);
                      jo.state = "HEADER";
                    }
                    for (var Ko = !1; jo.buffer; ) {
                      if (!/\r\n|\n/.test(jo.buffer))
                        return this;
                      switch (Ko ? Ko = !1 : Lo = Wi(), jo.state) {
                        case "HEADER":
                          /:/.test(Lo) ? zo(Lo) : Lo || (jo.state = "ID");
                          continue;
                        case "NOTE":
                          Lo || (jo.state = "ID");
                          continue;
                        case "ID":
                          if (/^NOTE($|[ \t])/.test(Lo)) {
                            jo.state = "NOTE";
                            break;
                          }
                          if (!Lo)
                            continue;
                          jo.cue = new (jo.vttjs.VTTCue || jo.window.VTTCue)(0, 0, "");
                          try {
                            jo.cue.align = "center";
                          } catch {
                            jo.cue.align = "middle";
                          }
                          if (jo.state = "CUE", Lo.indexOf("-->") === -1) {
                            jo.cue.id = Lo;
                            continue;
                          }
                        // Process line as start of a cue.
                        /*falls through*/
                        case "CUE":
                          try {
                            vi(Lo, jo.cue, jo.regionList);
                          } catch (pa) {
                            jo.reportOrThrowError(pa), jo.cue = null, jo.state = "BADCUE";
                            continue;
                          }
                          jo.state = "CUETEXT";
                          continue;
                        case "CUETEXT":
                          var ca = Lo.indexOf("-->") !== -1;
                          if (!Lo || ca && (Ko = !0)) {
                            jo.oncue && jo.oncue(jo.cue), jo.cue = null, jo.state = "ID";
                            continue;
                          }
                          jo.cue.text && (jo.cue.text += `
`), jo.cue.text += Lo.replace(/\u2028/g, `
`).replace(/u2029/g, `
`);
                          continue;
                        case "BADCUE":
                          Lo || (jo.state = "ID");
                          continue;
                      }
                    }
                  } catch (pa) {
                    jo.reportOrThrowError(pa), jo.state === "CUETEXT" && jo.cue && jo.oncue && jo.oncue(jo.cue), jo.cue = null, jo.state = jo.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
                  }
                  return this;
                },
                flush: function() {
                  var Ui = this;
                  try {
                    if (Ui.buffer += Ui.decoder.decode(), (Ui.cue || Ui.state === "HEADER") && (Ui.buffer += `

`, Ui.parse()), Ui.state === "INITIAL")
                      throw new fi(fi.Errors.BadSignature);
                  } catch (jo) {
                    Ui.reportOrThrowError(jo);
                  }
                  return Ui.onflush && Ui.onflush(), this;
                }
              }, ai.exports = Ni;
            })
          ),
          /***/
          "./node_modules/videojs-vtt.js/lib/vttcue.js": (
            /*!***************************************************!*\
              !*** ./node_modules/videojs-vtt.js/lib/vttcue.js ***!
              \***************************************************/
            /***/
            ((ai) => {
              var li = "auto", oi = {
                "": 1,
                lr: 1,
                rl: 1
              }, si = {
                start: 1,
                center: 1,
                end: 1,
                left: 1,
                right: 1,
                auto: 1,
                "line-left": 1,
                "line-right": 1
              };
              function di(mi) {
                if (typeof mi != "string")
                  return !1;
                var Ti = oi[mi.toLowerCase()];
                return Ti ? mi.toLowerCase() : !1;
              }
              function fi(mi) {
                if (typeof mi != "string")
                  return !1;
                var Ti = si[mi.toLowerCase()];
                return Ti ? mi.toLowerCase() : !1;
              }
              function gi(mi, Ti, vi) {
                this.hasBeenReset = !1;
                var xi = "", Si = !1, Pi = mi, $i = Ti, Oi = vi, Di = null, Mi = "", Oo = !0, io = "auto", xo = "start", fo = "auto", _o = "auto", Li = 100, Co = "center";
                Object.defineProperties(this, {
                  id: {
                    enumerable: !0,
                    get: function() {
                      return xi;
                    },
                    set: function(Ni) {
                      xi = "" + Ni;
                    }
                  },
                  pauseOnExit: {
                    enumerable: !0,
                    get: function() {
                      return Si;
                    },
                    set: function(Ni) {
                      Si = !!Ni;
                    }
                  },
                  startTime: {
                    enumerable: !0,
                    get: function() {
                      return Pi;
                    },
                    set: function(Ni) {
                      if (typeof Ni != "number")
                        throw new TypeError("Start time must be set to a number.");
                      Pi = Ni, this.hasBeenReset = !0;
                    }
                  },
                  endTime: {
                    enumerable: !0,
                    get: function() {
                      return $i;
                    },
                    set: function(Ni) {
                      if (typeof Ni != "number")
                        throw new TypeError("End time must be set to a number.");
                      $i = Ni, this.hasBeenReset = !0;
                    }
                  },
                  text: {
                    enumerable: !0,
                    get: function() {
                      return Oi;
                    },
                    set: function(Ni) {
                      Oi = "" + Ni, this.hasBeenReset = !0;
                    }
                  },
                  region: {
                    enumerable: !0,
                    get: function() {
                      return Di;
                    },
                    set: function(Ni) {
                      Di = Ni, this.hasBeenReset = !0;
                    }
                  },
                  vertical: {
                    enumerable: !0,
                    get: function() {
                      return Mi;
                    },
                    set: function(Ni) {
                      var Yi = di(Ni);
                      if (Yi === !1)
                        throw new SyntaxError("Vertical: an invalid or illegal direction string was specified.");
                      Mi = Yi, this.hasBeenReset = !0;
                    }
                  },
                  snapToLines: {
                    enumerable: !0,
                    get: function() {
                      return Oo;
                    },
                    set: function(Ni) {
                      Oo = !!Ni, this.hasBeenReset = !0;
                    }
                  },
                  line: {
                    enumerable: !0,
                    get: function() {
                      return io;
                    },
                    set: function(Ni) {
                      if (typeof Ni != "number" && Ni !== li)
                        throw new SyntaxError("Line: an invalid number or illegal string was specified.");
                      io = Ni, this.hasBeenReset = !0;
                    }
                  },
                  lineAlign: {
                    enumerable: !0,
                    get: function() {
                      return xo;
                    },
                    set: function(Ni) {
                      var Yi = fi(Ni);
                      Yi ? (xo = Yi, this.hasBeenReset = !0) : console.warn("lineAlign: an invalid or illegal string was specified.");
                    }
                  },
                  position: {
                    enumerable: !0,
                    get: function() {
                      return fo;
                    },
                    set: function(Ni) {
                      if (Ni < 0 || Ni > 100)
                        throw new Error("Position must be between 0 and 100.");
                      fo = Ni, this.hasBeenReset = !0;
                    }
                  },
                  positionAlign: {
                    enumerable: !0,
                    get: function() {
                      return _o;
                    },
                    set: function(Ni) {
                      var Yi = fi(Ni);
                      Yi ? (_o = Yi, this.hasBeenReset = !0) : console.warn("positionAlign: an invalid or illegal string was specified.");
                    }
                  },
                  size: {
                    enumerable: !0,
                    get: function() {
                      return Li;
                    },
                    set: function(Ni) {
                      if (Ni < 0 || Ni > 100)
                        throw new Error("Size must be between 0 and 100.");
                      Li = Ni, this.hasBeenReset = !0;
                    }
                  },
                  align: {
                    enumerable: !0,
                    get: function() {
                      return Co;
                    },
                    set: function(Ni) {
                      var Yi = fi(Ni);
                      if (!Yi)
                        throw new SyntaxError("align: an invalid or illegal alignment string was specified.");
                      Co = Yi, this.hasBeenReset = !0;
                    }
                  }
                }), this.displayState = void 0;
              }
              gi.prototype.getCueAsHTML = function() {
                return WebVTT.convertCueToDOMTree(window, this.text);
              }, ai.exports = gi;
            })
          ),
          /***/
          "./node_modules/videojs-vtt.js/lib/vttregion.js": (
            /*!******************************************************!*\
              !*** ./node_modules/videojs-vtt.js/lib/vttregion.js ***!
              \******************************************************/
            /***/
            ((ai) => {
              var li = {
                "": !0,
                up: !0
              };
              function oi(fi) {
                if (typeof fi != "string")
                  return !1;
                var gi = li[fi.toLowerCase()];
                return gi ? fi.toLowerCase() : !1;
              }
              function si(fi) {
                return typeof fi == "number" && fi >= 0 && fi <= 100;
              }
              function di() {
                var fi = 100, gi = 3, mi = 0, Ti = 100, vi = 0, xi = 100, Si = "";
                Object.defineProperties(this, {
                  width: {
                    enumerable: !0,
                    get: function() {
                      return fi;
                    },
                    set: function(Pi) {
                      if (!si(Pi))
                        throw new Error("Width must be between 0 and 100.");
                      fi = Pi;
                    }
                  },
                  lines: {
                    enumerable: !0,
                    get: function() {
                      return gi;
                    },
                    set: function(Pi) {
                      if (typeof Pi != "number")
                        throw new TypeError("Lines must be set to a number.");
                      gi = Pi;
                    }
                  },
                  regionAnchorY: {
                    enumerable: !0,
                    get: function() {
                      return Ti;
                    },
                    set: function(Pi) {
                      if (!si(Pi))
                        throw new Error("RegionAnchorX must be between 0 and 100.");
                      Ti = Pi;
                    }
                  },
                  regionAnchorX: {
                    enumerable: !0,
                    get: function() {
                      return mi;
                    },
                    set: function(Pi) {
                      if (!si(Pi))
                        throw new Error("RegionAnchorY must be between 0 and 100.");
                      mi = Pi;
                    }
                  },
                  viewportAnchorY: {
                    enumerable: !0,
                    get: function() {
                      return xi;
                    },
                    set: function(Pi) {
                      if (!si(Pi))
                        throw new Error("ViewportAnchorY must be between 0 and 100.");
                      xi = Pi;
                    }
                  },
                  viewportAnchorX: {
                    enumerable: !0,
                    get: function() {
                      return vi;
                    },
                    set: function(Pi) {
                      if (!si(Pi))
                        throw new Error("ViewportAnchorX must be between 0 and 100.");
                      vi = Pi;
                    }
                  },
                  scroll: {
                    enumerable: !0,
                    get: function() {
                      return Si;
                    },
                    set: function(Pi) {
                      var $i = oi(Pi);
                      $i === !1 ? console.warn("Scroll: an invalid or illegal string was specified.") : Si = $i;
                    }
                  }
                });
              }
              ai.exports = di;
            })
          ),
          /***/
          "./node_modules/which-typed-array/index.js": (
            /*!*************************************************!*\
              !*** ./node_modules/which-typed-array/index.js ***!
              \*************************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! for-each */
                "./node_modules/for-each/index.js"
              ), di = oi(
                /*! available-typed-arrays */
                "./node_modules/available-typed-arrays/index.js"
              ), fi = oi(
                /*! call-bind */
                "./node_modules/call-bind/index.js"
              ), gi = oi(
                /*! call-bound */
                "./node_modules/call-bound/index.js"
              ), mi = oi(
                /*! gopd */
                "./node_modules/gopd/index.js"
              ), Ti = oi(
                /*! get-proto */
                "./node_modules/get-proto/index.js"
              ), vi = gi("Object.prototype.toString"), xi = oi(
                /*! has-tostringtag/shams */
                "./node_modules/has-tostringtag/shams.js"
              )(), Si = typeof globalThis > "u" ? oi.g : globalThis, Pi = di(), $i = gi("String.prototype.slice"), Oi = gi("Array.prototype.indexOf", !0) || function(xo, fo) {
                for (var _o = 0; _o < xo.length; _o += 1)
                  if (xo[_o] === fo)
                    return _o;
                return -1;
              }, Di = { __proto__: null };
              xi && mi && Ti ? si(Pi, function(io) {
                var xo = new Si[io]();
                if (Symbol.toStringTag in xo && Ti) {
                  var fo = Ti(xo), _o = mi(fo, Symbol.toStringTag);
                  if (!_o && fo) {
                    var Li = Ti(fo);
                    _o = mi(Li, Symbol.toStringTag);
                  }
                  Di["$" + io] = fi(_o.get);
                }
              }) : si(Pi, function(io) {
                var xo = new Si[io](), fo = xo.slice || xo.set;
                fo && (Di[
                  /** @type {`$${import('.').TypedArrayName}`} */
                  "$" + io
                ] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */
                // @ts-expect-error TODO FIXME
                fi(fo));
              });
              var Mi = function(xo) {
                var fo = !1;
                return si(
                  /** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */
                  Di,
                  /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
                  function(_o, Li) {
                    if (!fo)
                      try {
                        "$" + _o(xo) === Li && (fo = /** @type {import('.').TypedArrayName} */
                        $i(Li, 1));
                      } catch {
                      }
                  }
                ), fo;
              }, Oo = function(xo) {
                var fo = !1;
                return si(
                  /** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */
                  Di,
                  /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
                  function(_o, Li) {
                    if (!fo)
                      try {
                        _o(xo), fo = /** @type {import('.').TypedArrayName} */
                        $i(Li, 1);
                      } catch {
                      }
                  }
                ), fo;
              };
              ai.exports = function(xo) {
                if (!xo || typeof xo != "object")
                  return !1;
                if (!xi) {
                  var fo = $i(vi(xo), 8, -1);
                  return Oi(Pi, fo) > -1 ? fo : fo !== "Object" ? !1 : Oo(xo);
                }
                return mi ? Mi(xo) : null;
              };
            })
          ),
          /***/
          "?34aa": (
            /*!******************************!*\
              !*** min-document (ignored) ***!
              \******************************/
            /***/
            (() => {
            })
          ),
          /***/
          "./node_modules/@babel/runtime/helpers/extends.js": (
            /*!********************************************************!*\
              !*** ./node_modules/@babel/runtime/helpers/extends.js ***!
              \********************************************************/
            /***/
            ((ai) => {
              function li() {
                return ai.exports = li = Object.assign ? Object.assign.bind() : function(oi) {
                  for (var si = 1; si < arguments.length; si++) {
                    var di = arguments[si];
                    for (var fi in di) ({}).hasOwnProperty.call(di, fi) && (oi[fi] = di[fi]);
                  }
                  return oi;
                }, ai.exports.__esModule = !0, ai.exports.default = ai.exports, li.apply(null, arguments);
              }
              ai.exports = li, ai.exports.__esModule = !0, ai.exports.default = ai.exports;
            })
          ),
          /***/
          "./node_modules/available-typed-arrays/index.js": (
            /*!******************************************************!*\
              !*** ./node_modules/available-typed-arrays/index.js ***!
              \******************************************************/
            /***/
            ((ai, li, oi) => {
              var si = oi(
                /*! possible-typed-array-names */
                "./node_modules/possible-typed-array-names/index.js"
              ), di = typeof globalThis > "u" ? oi.g : globalThis;
              ai.exports = function() {
                for (var gi = [], mi = 0; mi < si.length; mi++)
                  typeof di[si[mi]] == "function" && (gi[gi.length] = si[mi]);
                return gi;
              };
            })
          ),
          /***/
          "./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js": (
            /*!**************************************************************************!*\
              !*** ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js ***!
              \**************************************************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                default: () => (
                  /* binding */
                  si
                )
                /* harmony export */
              });
              function si(di) {
                if (di === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return di;
              }
            })
          ),
          /***/
          "./node_modules/@babel/runtime/helpers/esm/construct.js": (
            /*!**************************************************************!*\
              !*** ./node_modules/@babel/runtime/helpers/esm/construct.js ***!
              \**************************************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                default: () => (
                  /* binding */
                  fi
                )
                /* harmony export */
              });
              var si = oi(
                /*! ./isNativeReflectConstruct.js */
                "./node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js"
              ), di = oi(
                /*! ./setPrototypeOf.js */
                "./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js"
              );
              function fi(gi, mi, Ti) {
                if ((0, si.default)()) return Reflect.construct.apply(null, arguments);
                var vi = [null];
                vi.push.apply(vi, mi);
                var xi = new (gi.bind.apply(gi, vi))();
                return Ti && (0, di.default)(xi, Ti.prototype), xi;
              }
            })
          ),
          /***/
          "./node_modules/@babel/runtime/helpers/esm/extends.js": (
            /*!************************************************************!*\
              !*** ./node_modules/@babel/runtime/helpers/esm/extends.js ***!
              \************************************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                default: () => (
                  /* binding */
                  si
                )
                /* harmony export */
              });
              function si() {
                return si = Object.assign ? Object.assign.bind() : function(di) {
                  for (var fi = 1; fi < arguments.length; fi++) {
                    var gi = arguments[fi];
                    for (var mi in gi) ({}).hasOwnProperty.call(gi, mi) && (di[mi] = gi[mi]);
                  }
                  return di;
                }, si.apply(null, arguments);
              }
            })
          ),
          /***/
          "./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js": (
            /*!*******************************************************************!*\
              !*** ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js ***!
              \*******************************************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                default: () => (
                  /* binding */
                  si
                )
                /* harmony export */
              });
              function si(di) {
                return si = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(fi) {
                  return fi.__proto__ || Object.getPrototypeOf(fi);
                }, si(di);
              }
            })
          ),
          /***/
          "./node_modules/@babel/runtime/helpers/esm/inherits.js": (
            /*!*************************************************************!*\
              !*** ./node_modules/@babel/runtime/helpers/esm/inherits.js ***!
              \*************************************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                default: () => (
                  /* binding */
                  di
                )
                /* harmony export */
              });
              var si = oi(
                /*! ./setPrototypeOf.js */
                "./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js"
              );
              function di(fi, gi) {
                if (typeof gi != "function" && gi !== null) throw new TypeError("Super expression must either be null or a function");
                fi.prototype = Object.create(gi && gi.prototype, {
                  constructor: {
                    value: fi,
                    writable: !0,
                    configurable: !0
                  }
                }), Object.defineProperty(fi, "prototype", {
                  writable: !1
                }), gi && (0, si.default)(fi, gi);
              }
            })
          ),
          /***/
          "./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js": (
            /*!******************************************************************!*\
              !*** ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js ***!
              \******************************************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                default: () => (
                  /* binding */
                  di
                )
                /* harmony export */
              });
              var si = oi(
                /*! ./setPrototypeOf.js */
                "./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js"
              );
              function di(fi, gi) {
                fi.prototype = Object.create(gi.prototype), fi.prototype.constructor = fi, (0, si.default)(fi, gi);
              }
            })
          ),
          /***/
          "./node_modules/@babel/runtime/helpers/esm/isNativeFunction.js": (
            /*!*********************************************************************!*\
              !*** ./node_modules/@babel/runtime/helpers/esm/isNativeFunction.js ***!
              \*********************************************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                default: () => (
                  /* binding */
                  si
                )
                /* harmony export */
              });
              function si(di) {
                try {
                  return Function.toString.call(di).indexOf("[native code]") !== -1;
                } catch {
                  return typeof di == "function";
                }
              }
            })
          ),
          /***/
          "./node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js": (
            /*!*****************************************************************************!*\
              !*** ./node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js ***!
              \*****************************************************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                default: () => (
                  /* binding */
                  si
                )
                /* harmony export */
              });
              function si() {
                try {
                  var di = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
                  }));
                } catch {
                }
                return (si = function() {
                  return !!di;
                })();
              }
            })
          ),
          /***/
          "./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js": (
            /*!*******************************************************************!*\
              !*** ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js ***!
              \*******************************************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                default: () => (
                  /* binding */
                  si
                )
                /* harmony export */
              });
              function si(di, fi) {
                return si = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(gi, mi) {
                  return gi.__proto__ = mi, gi;
                }, si(di, fi);
              }
            })
          ),
          /***/
          "./node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js": (
            /*!********************************************************************!*\
              !*** ./node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js ***!
              \********************************************************************/
            /***/
            ((ai, li, oi) => {
              oi.r(li), oi.d(li, {
                /* harmony export */
                default: () => (
                  /* binding */
                  mi
                )
                /* harmony export */
              });
              var si = oi(
                /*! ./getPrototypeOf.js */
                "./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js"
              ), di = oi(
                /*! ./setPrototypeOf.js */
                "./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js"
              ), fi = oi(
                /*! ./isNativeFunction.js */
                "./node_modules/@babel/runtime/helpers/esm/isNativeFunction.js"
              ), gi = oi(
                /*! ./construct.js */
                "./node_modules/@babel/runtime/helpers/esm/construct.js"
              );
              function mi(Ti) {
                var vi = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
                return mi = function(Si) {
                  if (Si === null || !(0, fi.default)(Si)) return Si;
                  if (typeof Si != "function") throw new TypeError("Super expression must either be null or a function");
                  if (vi !== void 0) {
                    if (vi.has(Si)) return vi.get(Si);
                    vi.set(Si, Pi);
                  }
                  function Pi() {
                    return (0, gi.default)(Si, arguments, (0, si.default)(this).constructor);
                  }
                  return Pi.prototype = Object.create(Si.prototype, {
                    constructor: {
                      value: Pi,
                      enumerable: !1,
                      writable: !0,
                      configurable: !0
                    }
                  }), (0, di.default)(Pi, Si);
                }, mi(Ti);
              }
            })
          ),
          /***/
          "./node_modules/videojs-swf/package.json": (
            /*!***********************************************!*\
              !*** ./node_modules/videojs-swf/package.json ***!
              \***********************************************/
            /***/
            ((ai) => {
              ai.exports = /* @__PURE__ */ JSON.parse('{"name":"videojs-swf","description":"The Flash-fallback video player for video.js (http://videojs.com)","version":"5.4.2","copyright":"Copyright 2014 Brightcove, Inc. https://github.com/videojs/video-js-swf/blob/master/LICENSE","keywords":["flash","video","player"],"homepage":"http://videojs.com","author":"Brightcove","repository":{"type":"git","url":"https://github.com/videojs/video-js-swf.git"},"devDependencies":{"async":"~0.2.9","chg":"^0.3.2","flex-sdk":"4.6.0-0","grunt":"~0.4.0","grunt-bumpup":"~0.5.0","grunt-cli":"~0.1.0","grunt-connect":"~0.2.0","grunt-contrib-jshint":"~0.4.3","grunt-contrib-qunit":"~0.2.1","grunt-contrib-watch":"~0.1.4","grunt-npm":"~0.0.2","grunt-prompt":"~0.1.2","grunt-shell":"~0.6.1","grunt-tagrelease":"~0.3.1","qunitjs":"~1.12.0","video.js":"^5.9.2"},"scripts":{"version":"chg release -y && grunt dist && git add -f dist/ && git add CHANGELOG.md"}}');
            })
          ),
          /***/
          "./package.json": (
            /*!**********************!*\
              !*** ./package.json ***!
              \**********************/
            /***/
            ((ai) => {
              ai.exports = /* @__PURE__ */ JSON.parse('{"name":"@skyline-platform/skyline-player","title":"Skyline Video Player","libraryName":"skylinePlayer","version":"5.1.5","description":"Skyline Video Player","main":"dist/skyline-player.js","author":"","license":"UNLICENSED","publishConfig":{"@skyline-platform:registry":"https://gitlab.com/api/v4/projects/58148100/packages/npm/"},"scripts":{"build":"NODE_ENV=production ./scripts/build.sh","build:clear":"rm -rf ./dist","serve":"./scripts/serve.sh","serve:vagrant":"WATCH_WITH_POLLING=true yarn run serve","lint":"./scripts/lint.sh","lint-fix":"./scripts/lint.sh --fix","markdown-docs":"jsdoc2md src/*.js > api.md","demo":"yarn build && yarn demo:stop && yarn demo:build && yarn demo:start","demo:build":"./scripts/docker.sh --build","demo:start":"./scripts/docker.sh --start","demo:stop":"./scripts/docker.sh --stop","preversion":"./scripts/version.sh --pre","version":"./scripts/version.sh","postversion":"./scripts/version.sh --post"},"dependencies":{"@skylineos/videojs-clsp":"0.19.14","assert":"^2.1.0","buffer":"^6.0.3","debug":"4.1.1","lodash.debounce":"4.0.8","proxy-polyfill":"0.3.1","video.js":"7.21.7","videojs-errors":"4.3.2","videojs-flash":"2.2.1","videojs-swf":"5.4.2"},"devDependencies":{"@babel/core":"7.23.7","@babel/eslint-parser":"7.23.3","@babel/plugin-syntax-dynamic-import":"7.8.3","@babel/plugin-transform-class-properties":"7.23.3","@babel/plugin-transform-object-rest-spread":"7.23.4","@babel/plugin-transform-runtime":"^7.23.7","@babel/polyfill":"^7.12.1","@babel/preset-env":"7.23.8","babel-loader":"9.1.3","chalk":"4.0.0","css-loader":"7.1.2","eslint":"7.32.0","eslint-config-standard":"14.1.1","eslint-plugin-import":"2.31.0","eslint-plugin-node":"11.1.0","eslint-plugin-promise":"4.2.1","eslint-plugin-standard":"4.0.1","file-loader":"6.0.0","humanize":"0.0.9","jquery":"3.5.1","jquery-ui":"1.12.1","jsdoc-to-markdown":"9.1.1","mini-css-extract-plugin":"2.7.6","progress-bar-webpack-plugin":"2.1.0","sass":"^1.69.7","sass-loader":"13.3.3","standard":"14.3.4","store":"2.0.12","style-loader":"1.2.1","terser-webpack-plugin":"3.0.1","url-loader":"4.1.0","webpack":"5.94.0","webpack-bundle-analyzer":"4.10.0","webpack-dev-server":"4.10.1","write-file-webpack-plugin":"4.5.1"},"packageManager":"yarn@1.22.22+sha512.a6b2f7906b721bba3d67d4aff083df04dad64c399707841b7acf00f6b133b7ac24255f2652fa22ae3534329dc6180534e98d17432037ff6fd140556e2bb3137e"}');
            })
          )
          /******/
        }, ti = {};
        function ii(ai) {
          var li = ti[ai];
          if (li !== void 0)
            return li.exports;
          var oi = ti[ai] = {
            /******/
            // no module.id needed
            /******/
            // no module.loaded needed
            /******/
            exports: {}
            /******/
          };
          return ir[ai].call(oi.exports, oi, oi.exports, ii), oi.exports;
        }
        ii.n = (ai) => {
          var li = ai && ai.__esModule ? (
            /******/
            () => ai.default
          ) : (
            /******/
            () => ai
          );
          return ii.d(li, { a: li }), li;
        }, ii.d = (ai, li) => {
          for (var oi in li)
            ii.o(li, oi) && !ii.o(ai, oi) && Object.defineProperty(ai, oi, { enumerable: !0, get: li[oi] });
        }, ii.g = (function() {
          if (typeof globalThis == "object") return globalThis;
          try {
            return this || new Function("return this")();
          } catch {
            if (typeof window == "object") return window;
          }
        })(), ii.o = (ai, li) => Object.prototype.hasOwnProperty.call(ai, li), ii.r = (ai) => {
          typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(ai, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(ai, "__esModule", { value: !0 });
        }, ii.p = "";
        var ui = {};
        return (() => {
          /*!*******************************!*\
            !*** ./src/skyline-player.js ***!
            \*******************************/
          ii.r(ui), ii.d(ui, {
            /* harmony export */
            default: () => zo
            /* harmony export */
          });
          var ai = ii(
            /*! lodash.debounce */
            "./node_modules/lodash.debounce/index.js"
          ), li = /* @__PURE__ */ ii.n(ai), oi = ii(
            /*! debug */
            "./node_modules/debug/src/browser.js"
          ), si = /* @__PURE__ */ ii.n(oi), di = ii(
            /*! assert */
            "./node_modules/assert/build/assert.js"
          ), fi = /* @__PURE__ */ ii.n(di), gi = ii(
            /*! ../package.json */
            "./package.json"
          ), mi = ii(
            /*! ./defaults */
            "./src/defaults.js"
          ), Ti = ii(
            /*! video.js */
            "./node_modules/video.js/dist/video.es.js"
          );
          ii(
            /*! videojs-errors */
            "./node_modules/videojs-errors/dist/videojs-errors.es.js"
          ), ii(
            /*! videojs-swf/dist/video-js.swf */
            "./node_modules/videojs-swf/dist/video-js.swf"
          ), ii(
            /*! ./assets/video-js-buffer3-exactfit.swf */
            "./src/assets/video-js-buffer3-exactfit.swf"
          ), ii(
            /*! ./assets/video-js-buffer3.swf */
            "./src/assets/video-js-buffer3.swf"
          ), ii(
            /*! ./assets/video-js-buffer5.swf */
            "./src/assets/video-js-buffer5.swf"
          ), ii(
            /*! ./skyline-player.scss */
            "./src/skyline-player.scss"
          );
          var vi = ii(
            /*! ./utils */
            "./src/utils.js"
          );
          ii(
            /*! ./assets/PreRoll1_Full.mp4 */
            "./src/assets/PreRoll1_Full.mp4"
          ), ii(
            /*! ./assets/PreRoll2_Full.mp4 */
            "./src/assets/PreRoll2_Full.mp4"
          ), ii(
            /*! ./assets/PreRoll3_Full.mp4 */
            "./src/assets/PreRoll3_Full.mp4"
          ), ii(
            /*! ./assets/dog.mp4 */
            "./src/assets/dog.mp4"
          );
          function xi(Lo) {
            "@babel/helpers - typeof";
            return xi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(sa) {
              return typeof sa;
            } : function(sa) {
              return sa && typeof Symbol == "function" && sa.constructor === Symbol && sa !== Symbol.prototype ? "symbol" : typeof sa;
            }, xi(Lo);
          }
          function Si(Lo, sa) {
            var Ko = typeof Symbol < "u" && Lo[Symbol.iterator] || Lo["@@iterator"];
            if (!Ko) {
              if (Array.isArray(Lo) || (Ko = Pi(Lo)) || sa) {
                Ko && (Lo = Ko);
                var ca = 0, pa = function() {
                };
                return { s: pa, n: function() {
                  return ca >= Lo.length ? { done: !0 } : { done: !1, value: Lo[ca++] };
                }, e: function(xa) {
                  throw xa;
                }, f: pa };
              }
              throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            var ga, ia = !0, ra = !1;
            return { s: function() {
              Ko = Ko.call(Lo);
            }, n: function() {
              var xa = Ko.next();
              return ia = xa.done, xa;
            }, e: function(xa) {
              ra = !0, ga = xa;
            }, f: function() {
              try {
                ia || Ko.return == null || Ko.return();
              } finally {
                if (ra) throw ga;
              }
            } };
          }
          function Pi(Lo, sa) {
            if (Lo) {
              if (typeof Lo == "string") return $i(Lo, sa);
              var Ko = {}.toString.call(Lo).slice(8, -1);
              return Ko === "Object" && Lo.constructor && (Ko = Lo.constructor.name), Ko === "Map" || Ko === "Set" ? Array.from(Lo) : Ko === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(Ko) ? $i(Lo, sa) : void 0;
            }
          }
          function $i(Lo, sa) {
            (sa == null || sa > Lo.length) && (sa = Lo.length);
            for (var Ko = 0, ca = Array(sa); Ko < sa; Ko++) ca[Ko] = Lo[Ko];
            return ca;
          }
          function Oi(Lo, sa) {
            var Ko = Object.keys(Lo);
            if (Object.getOwnPropertySymbols) {
              var ca = Object.getOwnPropertySymbols(Lo);
              sa && (ca = ca.filter(function(pa) {
                return Object.getOwnPropertyDescriptor(Lo, pa).enumerable;
              })), Ko.push.apply(Ko, ca);
            }
            return Ko;
          }
          function Di(Lo) {
            for (var sa = 1; sa < arguments.length; sa++) {
              var Ko = arguments[sa] != null ? arguments[sa] : {};
              sa % 2 ? Oi(Object(Ko), !0).forEach(function(ca) {
                Mi(Lo, ca, Ko[ca]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Lo, Object.getOwnPropertyDescriptors(Ko)) : Oi(Object(Ko)).forEach(function(ca) {
                Object.defineProperty(Lo, ca, Object.getOwnPropertyDescriptor(Ko, ca));
              });
            }
            return Lo;
          }
          function Mi(Lo, sa, Ko) {
            return (sa = fo(sa)) in Lo ? Object.defineProperty(Lo, sa, { value: Ko, enumerable: !0, configurable: !0, writable: !0 }) : Lo[sa] = Ko, Lo;
          }
          function Oo(Lo, sa) {
            if (!(Lo instanceof sa)) throw new TypeError("Cannot call a class as a function");
          }
          function io(Lo, sa) {
            for (var Ko = 0; Ko < sa.length; Ko++) {
              var ca = sa[Ko];
              ca.enumerable = ca.enumerable || !1, ca.configurable = !0, "value" in ca && (ca.writable = !0), Object.defineProperty(Lo, fo(ca.key), ca);
            }
          }
          function xo(Lo, sa, Ko) {
            return sa && io(Lo.prototype, sa), Ko && io(Lo, Ko), Object.defineProperty(Lo, "prototype", { writable: !1 }), Lo;
          }
          function fo(Lo) {
            var sa = _o(Lo, "string");
            return xi(sa) == "symbol" ? sa : sa + "";
          }
          function _o(Lo, sa) {
            if (xi(Lo) != "object" || !Lo) return Lo;
            var Ko = Lo[Symbol.toPrimitive];
            if (Ko !== void 0) {
              var ca = Ko.call(Lo, sa);
              if (xi(ca) != "object") return ca;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return (sa === "string" ? String : Number)(Lo);
          }
          window.videojs = Ti.default, ii(
            /*! @skylineos/videojs-clsp */
            "./node_modules/@skylineos/videojs-clsp/dist/videojs-clsp.min.js"
          ), fi()(window.clspUtils);
          var Li = window.clspUtils;
          ii(
            /*! videojs-flash */
            "./node_modules/videojs-flash/dist/videojs-flash.es.js"
          );
          for (var Co = si()("skyline:skyline-player"), Ni = {}, Yi = /* @__PURE__ */ new Set([
            // private members
            "player",
            "playerOptions",
            "components",
            "options",
            "handlers",
            "sources",
            "id",
            "video",
            "overlay",
            "started",
            "rtmpIntervals",
            "sourceElements",
            "isPlaying",
            "isUsingClsp",
            "prerollSrc",
            "usePreroll",
            "prerollTimeout",
            "html5Sources",
            "hasHtml5Sources",
            "additionalClasses",
            "playerTimeout",
            "refreshTimer",
            "usingRefresh",
            "refreshInterval",
            "previousPlayer",
            // private methods
            "craftSourceUrl",
            "craftSecureStreamUrl",
            "addVideoElementClasses",
            "createHTMLSourceUrl",
            "createCLSPSourceUrl",
            "createSources",
            "createVideoElementIfNeeded",
            "createSourceElements",
            "createOverlayElement",
            "createPrerollUrl",
            "createPlayer",
            "cleanUpIntervals",
            "handleVideoStart",
            "handleVideoEnd",
            "handleVideoLoading",
            "handleVideoPlaying",
            "handleVideoError",
            "handleVideoPaused",
            "handleTechClick",
            "handleCLSPNetworkError",
            "clearHandlers",
            "setHandlers",
            "setIsPlayingToFalse",
            "provideSources",
            "handlePrerollCondition",
            "doPrerollRequest",
            "refreshPlayer",
            "getParent"
          ]), Vo = 2e3, No = "position: absolute; top: 0; left: 0; width: 100%; height: 100%;", Ui = "refresh-container", jo = 0, Wi = Array.from(Yi); jo < Wi.length; jo++) {
            var ji = Wi[jo];
            Ni["_".concat(ji)] = Symbol(ji);
          }
          window.addEventListener("unhandledrejection", function(Lo) {
            var sa = Lo.reason.message;
            if (sa && sa.toLowerCase().includes("the play() request was interrupted by a call to pause()"))
              return Lo.preventDefault(), Lo.stopImmediatePropagation();
          }, !1);
          var Hi = /* @__PURE__ */ (function(Lo, sa, Ko, ca, pa, ga, ia, ra, qo, xa, $a, ys, Ss, Xa, Es, Rs, La, Ja, ja, Ta, rs) {
            function Qa(Cs, _a, _s) {
              Oo(this, Qa), this[Ni._components] = vi.difference(mi.DEFAULT_PLAYER_FEATURES, vi.difference(_s.exclude, mi.BLACKLISTED_FEATURES)), this[Ni._playerOptions] = Di(Di(Di({}, JSON.parse(JSON.stringify(mi.DEFAULT_PLAYER_OPTIONS))), JSON.parse(JSON.stringify(_s.playerOptions))), {}, {
                children: this[Ni._components]
              }), delete this[Ni._playerOptions].techOrder, this[Ni._rtmpIntervals] = [], this[Ni._playerOptions].autoplay && (vi.log.debug("autoplay property set - removing bigPlayButton"), this[Ni._playerOptions].bigPlayButton = !1), this[Ni._video] = null, this[Ni._overlay] = null, this[Ni._sources] = [], this[Ni._handlers] = {
                onVideoStart: _s.onVideoStart || mi.NOOP,
                onVideoPlaying: _s.onVideoPlaying || mi.NOOP,
                onVideoEnd: _s.onVideoEnd || mi.NOOP,
                onVideoLoading: _s.onVideoLoading || mi.NOOP,
                onVideoPause: _s.onVideoPause || mi.NOOP,
                onVideoError: _s.onVideoError || mi.NOOP,
                onTechClick: _s.onTechClick || mi.NOOP,
                onCLSPNetworkError: _s.onCLSPNetworkError || mi.NOOP
              }, this[Ni._id] = Cs, this[Ni._sources] = _a, this[Ni._options] = Di(Di({}, mi.DEFAULT_OPTIONS), JSON.parse(JSON.stringify(_s))), _s.isMobile === !0 && _s.preroll === !0 && (this[Ni._usePreroll] = !0), _s.preroll && (this[Ni._options].rtmpRetry = !1), this[Ni._additionalClasses] = mi.DEFAULT_VIDEO_ELEMENT_CLASSES.concat(_s.additionalClasses).filter(function(el) {
                return typeof el == "string" && el.length > 0;
              }), this[Ni._playerTimeout] = !isNaN(_s.playerTimeout) && Number(_s.playerTimeout) >= 0 ? Number(_s.playerTimeout) : mi.DEFAULT_PLAYER_TIMEOUT, typeof _s.streamRefreshInterval == "number" && _s.streamRefreshInterval > 0 && (this[Ni._refreshInterval] = Math.max(Math.ceil(_s.streamRefreshInterval), mi.MINIMUM_REFERSH_RATE), this[Ni._usingRefresh] = !0);
            }
            return xo(Qa, [{
              key: Ko,
              value: (
                /**
                 * Creates a VIDEO HTML element if needed.
                 *
                 * If the passed argument 'id' does not reference a VIDEO HTML element, this
                 * method will create a VIDEO HTML element with an id of 'video-for-<x>',
                 * where '<x>' is the value of the 'id' parameter.
                 *
                 * It will then append the newly created VIDEO HTML element to the element
                 * referenced by the 'id' argument.
                 *
                 * No matter what it will return a VIDEO HTML element (either the newly created
                 * one or the originally referenced one.)
                 *
                 * @param {(string|HTMLElement)} id - An string value referencing a HTML DOM element by id
                 *
                 * @returns {HTMLElement.Video}
                 * @throws AssertionError - if the value passed as the 'id' argument does not reference an HTML Element in the DOM
                 * @private
                 */
                function() {
                  var _a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this[Ni._id], _s = _a;
                  if (typeof _s == "string" && (_s = this[Ni._getParent](_a), fi().ok(_s, "No element with id of ".concat(_a, " exists in the DOM"))), fi().ok(_s instanceof window.HTMLElement, "Item found / passed is not a valid HTML Element"), _s.nodeName.toLowerCase() !== "video") {
                    var el = _s.getElementsByTagName("video");
                    if (el.length > 0)
                      return el.item(0);
                    var Ps = document.createElement("video");
                    return Ps.setAttribute("id", "video-for-".concat(_s.id)), Ps.setAttribute("class", "video-js"), _s.appendChild(Ps), Ps;
                  }
                  return _s;
                }
              )
              /**
               * Adds src array to the passed player.
               *
               * While iterating through the sources argument, the method also inspects the
               * 'type' property of each item. If the property equates to the Claris Live
               * Streaming Protocol, it will set the private property 'isUsingClsp' to
               * true.
               *
               * @param {array.<SourceObject>} sources
               *  A list (array) of objects containing a structure like: `{src: 'url', type: 'mimetype'}`
               * @param {VideoJsPlayer} player
               *  The player to add the sources to
               *
               * @throws AssertionError - if the sources array contains anything but plain object that have a 'src' and
               *  'type' property; each property must be a non-empty string
               * @private
               */
            }, {
              key: ca,
              value: function(_a, _s) {
                fi().ok(Array.isArray(_a), "_createSourceElements() requires that the first argument be an array");
                var el = [], Ps = Si(_a), nl;
                try {
                  for (Ps.s(); !(nl = Ps.n()).done; ) {
                    var Vs = nl.value;
                    if (fi().ok(xi(Vs) === "object" && !Array.isArray(Vs), "_createSourceSlements() requires that all items in the sources array be plain objects"), fi()(Vs.src !== void 0, "_createSourceSlements() requires that all items in the sources array be plain objects with a src and type property"), fi().ok(Vs.type !== void 0, "_createSourceSlements() requires that all items in the sources array be plain objects with a src and type property"), fi().ok(typeof Vs.src == "string" && Vs.src.length > 0, "_createSourceSlements() requires that all items in the sources array have a 'src' property that is a string, and that the string is not empty"), fi().ok(typeof Vs.type == "string" && Vs.type.length > 0, "_createSourceSlements() requires that all items in the sources array have a 'type' property that is a string, and that the string is not empty"), Vs.type === mi.PROTOCOL_MAPPING.clsp && !Li.supported()) {
                      this[Ni._isUsingClsp] = !1;
                      continue;
                    }
                    el.push(Vs), Vs.type === mi.PROTOCOL_MAPPING.clsp && (this[Ni._isUsingClsp] = !0, this[Ni._options].rtmpRetry = !1);
                  }
                } catch (es) {
                  Ps.e(es);
                } finally {
                  Ps.f();
                }
                _s.src(el);
              }
              /**
               * Creates an DIV HTML Element that is positioned over the VIDEO HTML
               * Element which VideoJS is using to stream video.
               *
               * This element should be used to put other elements over the VideoJS
               * elements. This element is created after the `videojs` call.
               *
               * @param {string} parentId - The string that references an HTML DOM Element by id
               *
               * @throws AssertionError - If no HTML element is returned from the document.getElementById() call
               * @private
               * @notimplemented
               */
            }, {
              key: pa,
              value: function(_a) {
                var _s = document.getElementById(_a);
                fi().ok(_s, "_createOverlayElement(): no element with id '".concat(_a, "' in the DOM."));
                var el = document.createElement("div");
                el.setAttribute("class", "overlay-for-".concat(_a, " skyline-player-overlay")), _s.appendChild(el);
              }
              /**
               * Hanlder attached to the 'play' event of the VideoJS player object
               *
               * - Hides the spinner, if it isn't already.
               * - Cleans up any setInterval references created for video start.
               * - Sets the '_started' property to true.
               * - Calls the user provided 'onVideoStart' handler.
               *
               * If the usingRefresh flag is set it also:
               * 0
               *
               * @param {Event} [event] - The event object passed from the VideoJS event (if any)
               * @param {EventObject} event - The Event object passed from VideoJS
               */
            }, {
              key: ga,
              value: function(_a) {
                var _s = this;
                this.hideSpinner(), this[Ni._options].rtmpRetry && this[Ni._cleanUpIntervals](), this[Ni._started] || (this[Ni._started] = !0), this[Ni._usingRefresh] && window.setTimeout(function() {
                  _s[Ni._previousPlayer] && (_s[Ni._player].el().parentNode.style.zIndex = 0, _s[Ni._previousPlayer].el().parentNode.style.zIndex = -1, _s.destroy(_s[Ni._previousPlayer])), _s[Ni._refreshPlayer]();
                }, Vo), this[Ni._handlers].onVideoStart(_a);
              }
              /**
               * Handler attached to the 'playing' event of the VideoJS player object.
               *
               * - Calls the user provided 'onVideoPlaying' handler
               * - Sets the isPlaying private variable to true
               *
               * @param {Event} [event] - The event object passed from the VideoJS event (if any)
               * @private
               */
            }, {
              key: ia,
              value: function(_a) {
                this[Ni._isPlaying] = !0, this[Ni._handlers].onVideoPlaying(_a);
              }
              /**
               * Handler attached to the 'pause' event of the VideoJS player object.
               *
               * - Calls the user provided 'onVideoPause' handler
               *
               * @param {Event} [event] - The event object passed from the VideoJS event (if any)
               * @private
               */
            }, {
              key: ra,
              value: function(_a) {
                this[Ni._handlers].onVideoPause(_a);
              }
              /**
               * Handler attached to the 'end' event of the VideoJS player object.
               *
               * - Sets the 'started' private variable to false
               * - Calls the user provided 'onVideoEnd' handler
               *
               * @param {Event} [event] - The event object passed from the VideoJS event (if any)
               * @private
               */
            }, {
              key: qo,
              value: function(_a) {
                this.hideSpinner(), this[Ni._started] = !1, this[Ni._handlers].onVideoEnd(_a);
              }
              /**
               * Handler attached to the 'loadstart' event of the VideoJS player object.
               *
               * - Calls the user provided 'onVideoLoading' handler
               *
               * @param {Event} [event] - The event object passed from the VideoJS event (if any)
               * @private
               */
            }, {
              key: xa,
              value: function(_a) {
                this[Ni._handlers].onVideoLoading(_a);
              }
              /**
               * Handler attached to the 'error' and 'aderror' events of the VideoJS player object.
               *
               * - Hides the spinner (loading screen)
               * - Calls the user provided 'onVideoError' handler
               *
               * @param {Event} [event] - The event object passed from the VideoJS event (if any)
               * @private
               */
            }, {
              key: $a,
              value: function(_a) {
                this.hideSpinner(), this[Ni._handlers].onVideoError(_a);
              }
              /**
               * Handler attached to the custom event 'network-error'. Passes the event
               * object, the id passed to the constructor, and the reason for the error
               * to the handler.
               *
               * @param {Event} event
               *  The event object passed from the emitter
               * @param {string} reason
               *  A comment about the cause for the error
               * @private
               */
            }, {
              key: ys,
              value: function(_a, _s) {
                this[Ni._handlers].onCLSPNetworkError(_a, this[Ni._id], _s);
              }
              /**
               * Sets the 'isPlaying' private property to false.
               *
               * Attached to various VideoJS events.
               *
               * @private
               */
            }, {
              key: Ss,
              value: function() {
                this[Ni._isPlaying] = !1;
              }
              /**
               * Clears the intervals created from the RTMP retry setting.
               *
               * If the 'rtmpRetry' option is set to 'true' we create intervals to ensure
               * that the video stream will play. This method is used to clean-up those
               * intervals.
               */
            }, {
              key: Xa,
              value: function() {
                if (Array.isArray(this[Ni._rtmpIntervals]))
                  for (; this[Ni._rtmpIntervals].length > 0; )
                    clearInterval(this[Ni._rtmpIntervals].shift());
              }
              /**
               * Deregisters the main event handlers from the player
               *
               * @param {Player} [player = this[MemberSymbols._player]]
               */
            }, {
              key: Es,
              value: function() {
                var _a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this[Ni._player];
                _a.off(this[Ni._isUsingClsp] ? Qa.CustomPlayerEvents.CLSP_FIRST_FRAME_SHOWN : Qa.VideoJSPlayerEvents.PLAY), _a.off(Qa.VideoJSPlayerEvents.PLAYING), _a.off(Qa.VideoJSPlayerEvents.PAUSE), _a.off(Qa.VideoJSPlayerEvents.ENDED), _a.off(Qa.VideoJSPlayerEvents.LOAD_START), _a.off(Qa.CustomPlayerEvents.NETWORK_ERROR), _a.off([Qa.VideoJSPlayerEvents.ERROR, Qa.VideoJSPlayerEvents.AD_ERROR]), _a.off([Qa.VideoJSPlayerEvents.WAITING, Qa.VideoJSPlayerEvents.PAUSE, Qa.VideoJSPlayerEvents.ENDED, Qa.VideoJSPlayerEvents.ERROR, Qa.VideoJSPlayerEvents.AD_ERROR]), _a.off(Qa.CustomPlayerEvents.NETWORK_ERROR), _a.off(Qa.VideoJSPlayerEvents.DISPOSE);
              }
              /**
               * Registers the main event handlers from the player
               *
               * @param {Player} [player = this[MemberSymbols._player]]
               */
            }, {
              key: Rs,
              value: function() {
                var _a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this[Ni._player];
                _a.on(this[Ni._isUsingClsp] ? Qa.CustomPlayerEvents.CLSP_FIRST_FRAME_SHOWN : Qa.VideoJSPlayerEvents.PLAY, li()(this[Ni._handleVideoStart].bind(this), 100)), _a.on(Qa.VideoJSPlayerEvents.PLAYING, this[Ni._handleVideoPlaying].bind(this)), _a.on(Qa.VideoJSPlayerEvents.PAUSE, this[Ni._handleVideoPaused].bind(this)), _a.on(Qa.VideoJSPlayerEvents.ENDED, this[Ni._handleVideoEnd].bind(this)), _a.on(Qa.VideoJSPlayerEvents.LOAD_START, this[Ni._handleVideoLoading].bind(this)), _a.on(Qa.CustomPlayerEvents.NETWORK_ERROR, this[Ni._handleCLSPNetworkError].bind(this)), _a.on([Qa.VideoJSPlayerEvents.ERROR, Qa.VideoJSPlayerEvents.AD_ERROR], this[Ni._handleVideoError].bind(this)), _a.on([Qa.VideoJSPlayerEvents.WAITING, Qa.VideoJSPlayerEvents.PAUSE, Qa.VideoJSPlayerEvents.ENDED, Qa.VideoJSPlayerEvents.ERROR, Qa.VideoJSPlayerEvents.AD_ERROR], this[Ni._setIsPlayingToFalse].bind(this));
              }
              /**
               * Overrides the default `player.handleTechClick_`. If the caller has disabled
               * the `pauseOnClick` functionality, then the method will only execute the
               * `onTechClick` callback.
               *
               * If not, then the method will check if the controls have been added.
               * If so, then it will pause the player if it is not (using the local `stop`
               * method) or start the player (using the local `play` method).
               *
               * @param {Event} event
               *  The event object passed from the `handlTechClick_` method
               */
            }, {
              key: La,
              value: function(_a) {
                var _s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this[Ni._player], el = vi.pathParser(this[Ni._options]), Ps = mi.DISABLE_OPTIONS.pauseOnClick;
                if (el["disabledFeatures?.includes?.()"](Ps))
                  return this[Ni._handlers].onTechClick(_a);
                if (_s.controls())
                  if (_s.paused())
                    this.play();
                  else
                    return this.stop();
                this[Ni._handlers].onTechClick(_a);
              }
              /**
               * If preroll is being used, returns only those sources that match the html5 protocol
               * (http / https) type.
               *
               * Otherwise return all of the sources
               *
               * @returns {array.<SourceObject>}
               */
            }, {
              key: Ja,
              value: function() {
                return this[Ni._usePreroll] ? this[Ni._sources].filter(function(_a) {
                  _a.src;
                  var _s = _a.type;
                  return _s === mi.PROTOCOL_MAPPING.html5;
                }) : this[Ni._sources];
              }
              /**
               * Adds the classes to the video element.
               *
               * @param {Node} [element = this[MemberSymbols._video]]
               *  The element to add the classes to.
               */
            }, {
              key: ja,
              value: function() {
                var _a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this[Ni._video], _s = this[Ni._additionalClasses], el = Si(_s), Ps;
                try {
                  for (el.s(); !(Ps = el.n()).done; ) {
                    var nl = Ps.value;
                    _a.classList.add(nl);
                  }
                } catch (Vs) {
                  el.e(Vs);
                } finally {
                  el.f();
                }
              }
              /**
               * Refershes the current player by creating a new one in a sepearte container. The new player
               * will be created with the sources passed as the first argument, but with the same
               * player options as used in the first player. A reference to the old player will be
               * saved in the previousPlayer property. The new play will replace the old one.
               *
               * @param {array.<Source>} [sources = this[MemberSymbols._provideSources(]()]
               */
            }, {
              key: Ta,
              value: function() {
                var _a = this, _s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this[Ni._provideSources]();
                if (this[Ni._usingRefresh] === !0 && !this[Ni._refreshTimer] && this[Ni._player]) {
                  this[Ni._previousPlayer] = this[Ni._player], this[Ni._player] = void 0;
                  var el = this[Ni._refreshInterval], Ps = this[Ni._createVideoElementIfNeeded]();
                  this[Ni._refreshTimer] = window.setTimeout(
                    function() {
                      _a[Ni._refreshTimer] = void 0, _a[Ni._video] = Ps;
                      var nl = (0, Ti.default)(Ps, _a[Ni._playerOptions]);
                      _a[Ni._player] = nl, _a[Ni._createSourceElements](_s, nl), _a[Ni._addVideoElementClasses](Ps), _a[Ni._isUsingClsp] && nl.clsp(), nl.handleTechClick_ = function(Vs) {
                        return _a[Ni._handleTechClick](Vs);
                      }, _a[Ni._setHandlers]();
                    },
                    // streamRefreshInterval should be a number of milliseconds.
                    el
                  );
                }
              }
              /**
               * Retruns the parent element which will contain the videos. If the refresh stream
               * option isn't being used, this will be the element which corresponds to the id
               * passed as an argument.
               *
               * If the refresh stream option is being used, this will be the child element of
               * the parent that has the class 'refresh-container', and doesn't have the class
               * 'active'.
               *
               * If the parent doesn't have any children with the 'refresh-container' class
               * two will be added to it.
               *
               * @param {string} [id = this[MemberSymbols._id]
               *  The id or query used to retrieve the parent element
               */
            }, {
              key: rs,
              value: function() {
                var _a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this[Ni._id], _s = document.getElementById(_a);
                if (!(_s instanceof window.HTMLElement) && (_s = document.querySelector(_a), !(_s instanceof window.HTMLElement)))
                  throw new TypeError("Unable to find element matching query / id ".concat(_a));
                if (this[Ni._usingRefresh] !== !0)
                  return _s;
                var el = _s.getElementsByClassName("refresh-container");
                if (el.length > 0) {
                  var Ps = Si(el), nl;
                  try {
                    for (Ps.s(); !(nl = Ps.n()).done; ) {
                      var Vs = nl.value;
                      if (Vs.childElementCount === 0)
                        return Vs;
                    }
                  } catch (fl) {
                    Ps.e(fl);
                  } finally {
                    Ps.f();
                  }
                  return el.item(0);
                }
                var es = document.createElement("div"), Is = document.createElement("div");
                return es.style.cssText = No, es.style.zIndex = 0, es.classList.add(Ui), Is.style.cssText = No, Is.style.zIndex = -1, Is.classList.add(Ui), es.id = "refresh-container-1-for-".concat(_a), Is.id = "refresh-container-2-for-".concat(_a), _s.appendChild(es), _s.appendChild(Is), es;
              }
              // _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
              // Public Methods
              // _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
              /**
               * Creates a list (array) of dictionaries (objects) containing the source
               * (as src) and type for a stream.
               *
               * The techs currently supported are:
               * - flash (RTMP)
               * - html5 (HLS)
               * - clsp (Claris Live Streaming Protocol)
               *
               * @param {string} server - The host URN or IP address
               * @param {string} stream - The stream name / URN
               * @param {array.<string>} [techOrder = clsp,flash,html5]- A list of techs to use and their order
               * @param {object} [opts] - Options object passed to the method
               * @param {boolean} [opts.usingSkylineSFS = true] - A flag indicating that the streaming server is a Skyline SFS
               * @param {boolean} opts.isMobile - A flag indicating that the video referenced is constantly streaming
               * @param {string | number} opts.preroll - A port to use for prerolling if the video stream is not constant
               * @param {boolean}
               *  opts.useSecureVideo - A flag indicating that the secure video syntax should be added to the protocol URL
               * @param {string} opts.secureVideoToken - A string used in the secure video syntax
               *
               * @returns {array.<SourceObject>}
               * @throws AssertionError - if a non-string is provided in the tech order list
               * @throws AssertionError - if a tech value is not supported
               */
              // @todo - rename the opt.isMobile to something more proper (i.e.: alwaysOn)
            }, {
              key: "initialize",
              value: (
                /**
                 * Initializes the player
                 *
                 * This methos must be called in order to present video. It:
                 * - Creates the VIDEO element (if needed)
                 * - Creates and appends the SOURCE elements to the VIDEO element
                 * - Creates the VideoJS player object
                 * - Sets up the main 'play' event handler
                 * - Sets up the main 'playing' event handler
                 * - Sets up the main 'pause' event handler
                 * - Sets up the main 'ended' event handler
                 * - Sets up the main 'loadstart' event handler
                 * - Sets up the main 'aderror' event handler
                 * - Sets up the main 'error' event handler
                 * - Sets up RTMP retries if the option has been set
                 * - Sets up the VideoJS errors plugin
                 */
                function() {
                  var _a = this;
                  this[Ni._video] = this[Ni._createVideoElementIfNeeded](), this[Ni._addVideoElementClasses]();
                  var _s = this[Ni._provideSources](), el = (0, Ti.default)(this[Ni._video], this[Ni._playerOptions]);
                  this[Ni._createSourceElements](_s, el);
                  var Ps = vi.pathParser(this[Ni._options]);
                  el.handleTechClick_ = function(nl) {
                    return _a[Ni._handleTechClick](nl);
                  }, this[Ni._isUsingClsp] ? el.clsp() : Ps.rtmpRetry && this[Ni._playerOptions].autoplay && el.on("progress", function() {
                    _a.hasStarted || _a[Ni._rtmpIntervals].push(setInterval(function() {
                      el.play();
                    }, Ps.rtmpRetryDelay));
                  }), this[Ni._player] = el, this.showSpinner(), this[Ni._setHandlers](), this[Ni._isUsingClsp] || el.errors({
                    timeout: this[Ni._playerTimeout]
                  });
                }
              )
              /**
               * Destroys the VideoJS player and the items used to create it.
               *
               * Essentially makes this instance useless and requires a call to initialize()
               * again to make it useful. If no player has been created, then this method
               * does nothing.
               *
               * @param {Player} [player = this[MemberSymbols._player]]
               *  The player to destroy.
               */
            }, {
              key: "destroy",
              value: function() {
                var _a = this, _s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this[Ni._player] || this[Ni._previousPlayer];
                if (_s) {
                  var el = vi.pathParser(_s), Ps = el["tech_?.hls?.masterPlaylistController_?.mediaSource"];
                  if (Ps) {
                    Co("video was playing via HLS - removing ancillary reference to player");
                    var nl = function() {
                      Ps.player_ = null;
                    };
                    typeof Ps.on == "function" ? Ps.on("sourceclose", nl) : Ps.onsourceclose = nl;
                  }
                  this.reset(_s), _s.on("dispose", function() {
                    _a[Ni._clearHandlers](_s);
                    var Vs = _s.el().parentNode.id;
                    if (Vs) {
                      var es = document.getElementById(Vs);
                      if (es) {
                        var Is = Si(es.children), fl;
                        try {
                          for (Is.s(); !(fl = Is.n()).done; ) {
                            var sl = fl.value;
                            es.removeChild(sl);
                          }
                        } catch (Il) {
                          Is.e(Il);
                        } finally {
                          Is.f();
                        }
                      }
                    }
                  }), _s.dispose(), clearTimeout(this[Ni._refreshTimer]), this[Ni._refreshTimer] = void 0, this[Ni._previousPlayer] = null, (this[Ni._player] === _s || !this[Ni._player]) && (this[Ni._video] = null, this[Ni._player] = null, this[Ni._handlers].onVideoEnd());
                }
              }
              /**
               * Shows or hides the spinner.
               *
               * Adds, or removes,  the the 'vjs-waiting' class from the player instance.
               * Calling this if the player has not been initiated does nothing.
               *
               * @param {boolean} [flag = true] - Indicates if the spinner should be displayed or not
               * @param {string} [message = ''] - Display a message under the spinner
               */
            }, {
              key: "showSpinner",
              value: function() {
                var _a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0, _s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
                if (this[Ni._player]) {
                  if (!_a)
                    return this[Ni._player].removeClass("vjs-waiting");
                  this[Ni._player].addClass("vjs-waiting"), this.setSpinnerText(_s);
                }
              }
              /**
               * Hides the spinner.
               *
               * A convience method which calls showSpinner() with an argument of 'false'
               */
            }, {
              key: "hideSpinner",
              value: function() {
                this.showSpinner(!1), this.setSpinnerText("");
              }
              /**
               * Changes the text under the spinner. Will not show or hide the spinner.
               *
               * @param {string} [message = ''] - The message text under the spinner
               */
            }, {
              key: "setSpinnerText",
              value: function() {
                var _a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", _s = this[Ni._player].el().querySelector(".video-js .vjs-loading-spinner > .vjs-control-text");
                _s && (_s.textContent = _a || "");
              }
              /**
               * Wrapper method for the VideoJS player play() method.
               *
               * If there is no VideoJS player instance, this method does nothing.
               *
               * The VideoJS player.play() method has the ability to return a promise;
               * however, this isn't guaranteed. So this method is asynchronous to
               * standardize the return type.
               *
               * @returns {Promise}
               */
            }, {
              key: "play",
              value: function() {
                var _a = this;
                if (this[Ni._player])
                  return Promise.resolve(function() {
                    return _a[Ni._player].play();
                  }).catch(function(_s) {
                    /request was interrupted/.test(_s.message) || console.error(_s);
                  });
              }
              /**
               * Wrapper method for the VideoJS player pause() method.
               *
               * The VideoJS player instance does not have a stop(), just pause().
               */
            }, {
              key: "stop",
              value: function() {
                var _a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !this[Ni._player];
                _a && (this[Ni._playerOptions].autoplay || _a.pause(), _a === this[Ni._player] && (clearTimeout(this[Ni._refreshTimer]), this[Ni._refreshTimer] = void 0, this[Ni._player].trigger(Qa.VideoJSPlayerEvents.PAUSE)));
              }
              /**
               * Performs a reset on the instance.
               *
               * If there is no player instance, this method does nothing.
               *
               * - Stops / Pauses playback
               * - Sets the started flag to 'false'
               * - Cleans up any intervals that might still be running
               */
            }, {
              key: "reset",
              value: function() {
                var _a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this[Ni._player];
                if (!(!_a || _a !== this[Ni._player])) {
                  if (clearTimeout(this[Ni._refreshTimer]), this[Ni._previousPlayer]) {
                    var _s = this[Ni._previousPlayer];
                    this[Ni._previousPlayer] = void 0, this.destroy(_s);
                  }
                  this.stop(_a), this[Ni._started] = !1, this[Ni._cleanUpIntervals](), this[Ni._setIsPlayingToFalse]();
                }
              }
              /**
               * Changes the source URL string for the VideoJS player.
               *
               * If there is not player instance, this method does nothing.
               *
               * This method makes a few presumptions:
               * - That the caller is keeping the current tech
               * - That the stream URL can work with the current tech
               *
               * The method calls the reset() method, then executes the 'src()' method
               * on the player instance. After that it exectes 'load()' and finally
               * 'play()', if autoplay is required, on the player instance.
               *
               * @param {string|SourceObject} src - A URL representing a streaming video source
               *
               * @throws AssertionError - if src parameter is not a string, or is an empty string
               */
            }, {
              key: "changeSrc",
              value: function(_a) {
                if (this[Ni._player]) {
                  fi()(["string", "object"].includes(xi(_a)), "changeSrc() requires either a valid string or a object as the first argument"), xi(_a) === "object" && (fi()(!Array.isArray(_a), "changeSrc() requires a valid object as the first argument"), fi()(_a.src !== void 0 && _a.type !== void 0, "changeSrc() requires that the first argument be a SourceObject ({ src, type})"));
                  var _s = this[Ni._player];
                  if (this[Ni._isUsingClsp])
                    return _s.trigger(Qa.CustomPlayerEvents.CHANGESRC, {
                      eid: _s.id(),
                      url: typeof _a == "string" ? _a : _a.src
                    });
                  this.reset(), _s.src(_a), _s.load(), this[Ni._playerOptions].autoplay && this.play();
                }
              }
              /**
               * Indicates if the underlying video is playing.
               *
               * @returns {boolean}
               */
            }, {
              key: "isPlaying",
              value: function() {
                return this[Ni._isPlaying];
              }
            }], [{
              key: "factory",
              value: function(_a) {
                var _s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], el = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                return new Qa(_a, _s, Di({
                  playerOptions: {},
                  // In our experience, this event is fired when the video player
                  // can estabilsh a connection with the remote source, but the
                  // video hasn't actually started playing yet
                  onVideoStart: mi.NOOP,
                  // In our experience, this event is fired when the video player
                  // is actually displaying frames of video
                  onVideoPlaying: mi.NOOP,
                  // // What to do when a video stops playing
                  onVideoEnd: mi.NOOP,
                  // What to do when a video is being loaded
                  onVideoLoading: mi.NOOP,
                  // What to do when a video error is encountered
                  onVideoError: mi.NOOP,
                  // What to do when a video is paused
                  onVideoPause: mi.NOOP
                }, el));
              }
              /**
               * A static getter to make use of the values in the DISABLE_OPTIONS enum.
               *
               * @returns {DisableOptions}
               */
            }, {
              key: "disableOptions",
              get: function() {
                return mi.DISABLE_OPTIONS;
              }
              // _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
              // Private Methods
              // _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
              /**
               * Creates a URL string based on the arguments passed. If the
               * protocol argument is 'rtmp' and the opts argument
               * contains the property 'prerollPort' with a value, this value is
               * used instead of the standard ':1935/rtplive'.
               *
               * @param {string} server - The host URN or IP address
               * @param {string} stream - The stream name / URN
               * @param {string} protocol - The protocol to use for the URL (e.g.: clsp, rtmp, etc)
               * @param {string} [port = ''] - The port to add to the URL
               * @param {object} [opts = {}] - Options for the method
               * @param {boolean} opts.useSecureVideo - Flag indicating that secure streaming should be used; this is not
               *  the same as requesting HLS across a TLS connection
               * @param {boolean} opts.useTLSStreaming - request the stream over a secure/encrypted connection
               * @param {string} opts.secureVideoToken - The token value to append to the URL string
               *
               * @returns {string}
               * @private
               * @static
               */
            }, {
              key: Lo,
              value: function(_a, _s, el) {
                var Ps = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", nl = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
                return xi(Ps) === "object" && !Array.isArray(Ps) && (nl = Ps, Ps = ""), Ps.length > 0 && !Ps.startsWith(":") && (Ps = ":".concat(Ps)), Qa[Ni._craftSecureStreamUrl]("".concat(el, "://").concat(_a).concat(Ps, "/").concat(_s), nl);
              }
              /**
               * Appends the secure video token string to the end of the passed URL, if the opts.useSecureVideo is set to true
               *
               * @param {boolean} opts.useSecureVideo - Flag indicating that secure streaming should be used; this is not the
               *  same as requesting HLS across a TLS connection
               * @param {string} opts.secureVideoToken - The token value to append to the URL string
               * @private
               * @static
               */
            }, {
              key: sa,
              value: function(_a) {
                var _s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return _s.useSecureVideo !== !0 ? _a : (fi().ok(typeof _s.secureVideoToken == "string" && _s.secureVideoToken.length > 0, "_craftsourceUrl(): a valid secure video token must be provided if using secure video"), "".concat(_a, "?token=").concat(_s.secureVideoToken));
              }
            }, {
              key: "createSources",
              value: function(_a, _s) {
                var el = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : mi.DEFAULT_TECH_ORDER, Ps = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                xi(el) === "object" && (Array.isArray(el) || (Ps = el, el = mi.DEFAULT_TECH_ORDER));
                var nl = Di(Di({}, mi.DEFAULT_OPTIONS), Ps);
                fi().ok(typeof el == "string" || Array.isArray(el), "SkylineVideoPlayer.createSources() techOrder must be either a string or an Array"), typeof el == "string" && (el = [el]);
                var Vs = [], es = nl.usingSkylineSFS ? nl.isMobile && nl.preroll ? ":".concat(nl.preroll) : ":1935/rtplive" : "", Is = Si(el), fl;
                try {
                  for (Is.s(); !(fl = Is.n()).done; ) {
                    var sl = fl.value;
                    fi()(typeof sl == "string", "SkylineVideoPlayer.createSources() requires that all items provided in techOrder parameter must be strings"), fi().ok(Ti.default.getTech(sl) || mi.CUSTOM_TECH.includes(sl), "SkylineVideoPlayer.createSources(): ".concat(sl, " is not a currently supported tech"));
                    var Il = void 0;
                    switch (sl) {
                      case "html5":
                        Il = "http", nl.useTLSStreaming && (Il = "https", es = nl.preroll ? "/preroll" : "/rtplive"), Vs.push({
                          src: Qa[Ni._craftSourceUrl](_a, "".concat(_s, "/playlist.m3u8"), Il, es, nl),
                          type: mi.PROTOCOL_MAPPING[sl]
                        });
                        continue;
                      case "flash":
                        Vs.push({
                          src: Qa[Ni._craftSourceUrl](_a, _s, "rtmp", es, nl),
                          type: mi.PROTOCOL_MAPPING.rtmp
                        });
                        continue;
                      case "clsp":
                        Il = nl.useTLSStreaming ? "clsps" : "clsp", Vs.push({
                          src: Qa[Ni._craftSourceUrl](_a, _s, Il, nl),
                          type: mi.PROTOCOL_MAPPING[sl]
                        });
                        continue;
                      default:
                        fi().fail("'".concat(sl, " is not currently supported by SkylineVideoPlayer"));
                    }
                  }
                } catch (Vl) {
                  Is.e(Vl);
                } finally {
                  Is.f();
                }
                return Vs;
              }
            }]);
          })(Ni._craftSourceUrl, Ni._craftSecureStreamUrl, Ni._createVideoElementIfNeeded, Ni._createSourceElements, Ni._createOverlayElement, Ni._handleVideoStart, Ni._handleVideoPlaying, Ni._handleVideoPaused, Ni._handleVideoEnd, Ni._handleVideoLoading, Ni._handleVideoError, Ni._handleCLSPNetworkError, Ni._setIsPlayingToFalse, Ni._cleanUpIntervals, Ni._clearHandlers, Ni._setHandlers, Ni._handleTechClick, Ni._provideSources, Ni._addVideoElementClasses, Ni._refreshPlayer, Ni._getParent);
          Hi.VideoJSPlayerEvents = {
            get PLAY() {
              return "play";
            },
            get PAUSE() {
              return "pause";
            },
            get ENDED() {
              return "ended";
            },
            get LOAD_START() {
              return "loadstart";
            },
            get AD_ERROR() {
              return "aderror";
            },
            get ERROR() {
              return "error";
            },
            get PLAYING() {
              return "playing";
            },
            get WAITING() {
              return "waiting";
            },
            get FIRSTPLAY() {
              return "firstplay";
            },
            get DISPOSE() {
              return "dispose";
            }
          }, Hi.CustomPlayerEvents = {
            get NETWORK_ERROR() {
              return "network-error";
            },
            get CHANGESRC() {
              return "changesrc";
            },
            get CLSP_FIRST_FRAME_SHOWN() {
              return "firstFrameShown";
            }
          }, Hi.TypesFromProtocol = Di({}, mi.PROTOCOL_MAPPING), Hi.features = mi.DISABLE_OPTIONS, Hi.version = gi.version, window && (window.HELP_IMPROVE_VIDEOJS = !1);
          const zo = Hi;
        })(), ui;
      })()
    ));
  })(skylinePlayer)), skylinePlayer.exports;
}
var skylinePlayerExports = requireSkylinePlayer();
const SkylinePlayer = /* @__PURE__ */ getDefaultExportFromCjs$1(skylinePlayerExports), StreamViewer = ({
  stream: pt
}) => {
  const yt = useRef(null), ir = useRef(null);
  return useEffect(() => {
    let ti = [
      {
        src: pt.https_url,
        type: "application/x-mpegURL"
      }
    ];
    return ir.current = SkylinePlayer.factory(yt.current, ti, {
      exclude: {
        controlBar: !1
      }
    }), ir.current.initialize(), () => {
      ir.current && (ir.current.destroy(), ir.current = null);
    };
  }, [pt]), /* @__PURE__ */ jsxRuntimeExports$1.jsx("sky-stream-viewer", { children: /* @__PURE__ */ jsxRuntimeExports$1.jsx(
    "video",
    {
      ref: yt,
      class: "skyline-player"
    }
  ) });
};
StreamViewer.propTypes = {
  stream: PropTypes$1.object
};
const StreamCard = ({
  stream: pt,
  compact: yt = !1,
  onViewDetails: ir
}) => {
  const [ti, ii] = useState(!1), ui = (pt == null ? void 0 : pt.description) || (pt == null ? void 0 : pt.name) || "stream";
  return useEffect(() => {
    startTransition(() => ii(!1));
  }, [pt]), pt ? /* @__PURE__ */ jsxRuntimeExports$1.jsxs("sky-stream-card", { children: [
    /* @__PURE__ */ jsxRuntimeExports$1.jsxs("h3", { children: [
      /* @__PURE__ */ jsxRuntimeExports$1.jsx("span", { title: pt.name, children: pt.name }),
      /* @__PURE__ */ jsxRuntimeExports$1.jsx("span", { className: pt.status, children: typeof pt.confidence == "number" && pt.confidence >= 0 ? /* @__PURE__ */ jsxRuntimeExports$1.jsxs(jsxRuntimeExports$1.Fragment, { children: [
        pt.confidence.toFixed(1),
        "%"
      ] }) : "Missing Result" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports$1.jsx(
      "button",
      {
        title: ti ? `Display snapshot for ${ui}` : `Play live video for ${ui}`,
        "aria-label": ti ? `Display snapshot for ${ui}` : `Play live video for ${ui}`,
        className: "image-video-container",
        onKeyDown: (ai) => {
          ai.key === " " && ai.preventDefault();
        },
        onKeyUp: (ai) => {
          if (!(ai.key !== "Enter" && ai.key !== " ")) {
            if (ai.preventDefault(), ai.stopPropagation(), ti) {
              ii(!1);
              return;
            }
            ii(!0);
          }
        },
        onClick: () => {
          if (ti) {
            ii(!1);
            return;
          }
          ii(!0);
        },
        children: ti ? /* @__PURE__ */ jsxRuntimeExports$1.jsx(
          StreamViewer,
          {
            stream: pt,
            onClick: () => {
              ii(!1);
            }
          }
        ) : /* @__PURE__ */ jsxRuntimeExports$1.jsx(
          ImageViewer,
          {
            tabIndex: -1,
            src: pt.image_url,
            alt: `Snapshot of stream ${pt.id}`,
            stream: pt,
            nullConfidence: typeof pt.confidence != "number"
          }
        )
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports$1.jsx("footer", { children: yt && ir ? /* @__PURE__ */ jsxRuntimeExports$1.jsx(
      Button,
      {
        title: `View details for ${ui}`,
        type: "outlined",
        onClick: () => ir(pt.id),
        children: "View Details"
      }
    ) : /* @__PURE__ */ jsxRuntimeExports$1.jsxs("span", { children: [
      /* @__PURE__ */ jsxRuntimeExports$1.jsx("strong", { children: "Last Run:" }),
      " ",
      new Date(pt.timestamp).toLocaleString()
    ] }) })
  ] }) : null;
};
StreamCard.propTypes = {
  stream: PropTypes$1.object.isRequired,
  onFlag: PropTypes$1.func,
  isFlagged: PropTypes$1.bool,
  compact: PropTypes$1.bool,
  onViewDetails: PropTypes$1.func
};
const Pagination = ({
  rowsPerPage: pt,
  currentPage: yt,
  onChangePage: ir,
  rowCount: ti,
  ...ii
}) => {
  const ui = Math.ceil(ti / pt), ai = (yt - 1) * pt + 1, li = Math.min(yt * pt, ti);
  return /* @__PURE__ */ jsxRuntimeExports$1.jsxs("sky-pagination-bar", { children: [
    /* @__PURE__ */ jsxRuntimeExports$1.jsxs("span", { children: [
      ai,
      "-",
      li,
      " of ",
      ti
    ] }),
    /* @__PURE__ */ jsxRuntimeExports$1.jsx(
      Pagination$1,
      {
        id: "sky-pagination",
        "data-testid": "pagination",
        count: ui,
        page: yt,
        onChange: ir,
        shape: "rounded",
        color: "primary",
        ...ii
      }
    )
  ] });
};
Pagination.propTypes = {
  rowsPerPage: PropTypes$1.number.isRequired,
  currentPage: PropTypes$1.number.isRequired,
  onChangePage: PropTypes$1.func.isRequired,
  rowCount: PropTypes$1.number.isRequired
};
const GridView = ({
  streams: pt,
  flagged: yt,
  onFlag: ir,
  onStreamClick: ti
}) => {
  const [ii, ui] = useState(1), ai = 20, li = pt != null && pt.length ? pt[0] : null;
  let oi = null;
  li && (oi = new Date(li.timestamp).toLocaleString());
  const si = useMemo(() => {
    const fi = (ii - 1) * ai;
    return pt.slice(fi, fi + ai);
  }, [pt, ii]), di = (fi, gi) => {
    ui(gi), window.scrollTo(0, 0);
  };
  return useEffect(() => {
    const fi = pt.length / ai;
    ii !== 1 && fi < ii && startTransition(() => ui(Math.ceil(fi)));
  }, [pt, ii]), /* @__PURE__ */ jsxRuntimeExports$1.jsx("sky-grid-view", { children: pt.length === 0 ? /* @__PURE__ */ jsxRuntimeExports$1.jsx("div", { className: "no-results", role: "alert", children: "No streams to display." }) : /* @__PURE__ */ jsxRuntimeExports$1.jsxs(jsxRuntimeExports$1.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports$1.jsxs("div", { className: "grid-header", children: [
      /* @__PURE__ */ jsxRuntimeExports$1.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports$1.jsx("b", { children: "Last Run:" }),
        " ",
        oi
      ] }),
      /* @__PURE__ */ jsxRuntimeExports$1.jsxs("div", { children: [
        "Showing ",
        si.length,
        " of ",
        pt.length,
        " stream",
        pt.length !== 1 ? "s" : ""
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports$1.jsx("div", { className: "grid-view", children: si.map((fi, gi) => /* @__PURE__ */ jsxRuntimeExports$1.jsx(
      StreamCard,
      {
        stream: fi,
        onFlag: ir,
        isFlagged: yt.includes(fi.id),
        compact: !0,
        onViewDetails: ti
      },
      `${fi.id}-${gi}`
    )) }),
    /* @__PURE__ */ jsxRuntimeExports$1.jsx(
      Pagination,
      {
        rowsPerPage: ai,
        currentPage: ii,
        onChangePage: di,
        rowCount: pt.length
      }
    )
  ] }) });
};
GridView.propTypes = {
  streams: PropTypes$1.array.isRequired,
  flagged: PropTypes$1.array.isRequired,
  onFlag: PropTypes$1.func.isRequired,
  onStreamClick: PropTypes$1.func.isRequired
};
const SkipToMainContent = ({ text: pt = "Skip to main content", targetSelector: yt = "alc-pagination-bar" }) => {
  const ir = useRef(null), ti = (ii) => {
    var oi;
    ii.preventDefault();
    const ui = ((oi = ir.current) == null ? void 0 : oi.closest('section, main, [class*="all-"], gar-all-cameras, gar-all-streams, gar-all-zones, gar-all-appliances')) ?? document, ai = () => ui.querySelector(yt) ?? document.querySelector(yt), li = ai();
    li && (li.scrollIntoView({ behavior: "instant", block: "nearest" }), setTimeout(() => {
      const si = ai();
      if (!si) return;
      const di = si.querySelectorAll(
        [
          "button:not([disabled])",
          "[href]",
          "input:not([disabled])",
          "select:not([disabled])",
          "textarea:not([disabled])",
          '[tabindex]:not([tabindex="-1"])'
        ].join(", ")
      );
      di.length > 0 ? di[0].focus() : (si.setAttribute("tabindex", "-1"), si.focus(), setTimeout(() => {
        si.removeAttribute("tabindex");
      }, 50));
    }, 100));
  };
  return /* @__PURE__ */ jsxRuntimeExports$1.jsx(
    "a",
    {
      ref: ir,
      href: `#${yt}`,
      className: "skip-to-main-content",
      onClick: ti,
      children: pt
    }
  );
};
SkipToMainContent.propTypes = {
  text: PropTypes$1.string,
  targetSelector: PropTypes$1.string
};
function Home({ dataUrl: pt }) {
  const yt = pt, [ir, ti] = useStreamResults(yt), [ii, ui] = useState(0), [ai, li] = useState([]), [oi, si] = useState(""), [di, fi] = useState([]), [gi, mi] = useState("grid"), [Ti, vi] = useState("confidence"), [xi, Si] = useState("asc"), Pi = useFilterSortStreams(ir, {
    filters: ai,
    search: oi,
    sortBy: Ti,
    sortOrder: xi
  }), $i = Pi[ii] || null, Oi = Pi.length === 0;
  function Di() {
    return ti ? /* @__PURE__ */ jsxRuntimeExports$1.jsxs(jsxRuntimeExports$1.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports$1.jsx(
        "div",
        {
          className: "loading-indicator",
          role: "status",
          "aria-live": "polite",
          "aria-label": "Loading stream health results"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports$1.jsx("div", { className: "no-results", role: "alert", children: "Loading latest stream health results." })
    ] }) : Oi || ai.length === 0 ? /* @__PURE__ */ jsxRuntimeExports$1.jsx("div", { className: "no-results", role: "alert", children: "No matching records found." }) : gi === "stream" ? /* @__PURE__ */ jsxRuntimeExports$1.jsxs(jsxRuntimeExports$1.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports$1.jsx(
        Navigator,
        {
          index: ii,
          total: Pi.length,
          onPageChange: ui
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports$1.jsxs("article", { "aria-label": "Stream detail view", children: [
        /* @__PURE__ */ jsxRuntimeExports$1.jsx(
          StreamCard,
          {
            stream: $i,
            isFlagged: di.includes($i.id),
            onFlag: (Mi) => fi((Oo) => [...Oo, Mi.id])
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports$1.jsx(DetailsPanel, { stream: $i })
      ] })
    ] }) : /* @__PURE__ */ jsxRuntimeExports$1.jsxs(jsxRuntimeExports$1.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports$1.jsx(SkipToMainContent, { targetSelector: "sky-pagination-bar", text: "Skip to pagination controls" }),
      /* @__PURE__ */ jsxRuntimeExports$1.jsx(
        GridView,
        {
          streams: Pi,
          streamsLoading: !0,
          flagged: di,
          onFlag: (Mi) => fi((Oo) => [...Oo, Mi.id]),
          onStreamClick: (Mi) => {
            const Oo = Pi.findIndex((io) => io.id === Mi);
            Oo !== -1 && (ui(Oo), mi("stream"));
          }
        }
      )
    ] });
  }
  return /* @__PURE__ */ jsxRuntimeExports$1.jsxs("sky-page", { children: [
    /* @__PURE__ */ jsxRuntimeExports$1.jsx(Title, { level: 1, title: "Stream Health", children: /* @__PURE__ */ jsxRuntimeExports$1.jsxs("div", { className: "controlContainer", children: [
      /* @__PURE__ */ jsxRuntimeExports$1.jsx(
        "button",
        {
          className: gi === "stream" ? "active" : "",
          onClick: () => mi("stream"),
          "aria-label": "Stream view",
          title: "Go to Stream Detail View",
          children: /* @__PURE__ */ jsxRuntimeExports$1.jsx("i", { className: "fa-regular fa-image" })
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports$1.jsx(
        "button",
        {
          className: gi === "grid" ? "active" : "",
          onClick: () => mi("grid"),
          "aria-label": "Grid view",
          title: "Go to Stream List View",
          children: /* @__PURE__ */ jsxRuntimeExports$1.jsx("i", { className: "fa-solid fa-grid-2" })
        }
      )
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports$1.jsxs("main", { children: [
      /* @__PURE__ */ jsxRuntimeExports$1.jsx(
        Toolbar,
        {
          searchValue: oi,
          onSearchChange: si,
          filters: ai,
          onFiltersChange: li,
          sortBy: Ti,
          sortOrder: xi,
          onSortByChange: vi,
          onSortOrderToggle: () => Si((Mi) => Mi === "asc" ? "desc" : "asc")
        }
      ),
      Di()
    ] })
  ] });
}
function PickerLink({
  href: pt,
  className: yt = "",
  iconClass: ir,
  icon: ti,
  iconLabel: ii,
  text: ui,
  isDisabled: ai = !1
}) {
  const oi = [ti ? React__default.cloneElement(ti, {
    "aria-hidden": ii ? void 0 : !0,
    role: ii ? "img" : void 0,
    "aria-label": ii,
    ...ti.props
  }) : ir ? /* @__PURE__ */ jsxRuntimeExports$1.jsx("i", { className: ir, "aria-hidden": "true" }) : null, ui];
  return ai ? /* @__PURE__ */ jsxRuntimeExports$1.jsx(
    "span",
    {
      className: `${yt} disabled`,
      children: oi
    }
  ) : /* @__PURE__ */ jsxRuntimeExports$1.jsx(
    "a",
    {
      href: pt,
      className: yt,
      children: oi
    }
  );
}
PickerLink.propTypes = {
  href: PropTypes$1.string.isRequired,
  className: PropTypes$1.string,
  iconClass: PropTypes$1.string,
  icon: PropTypes$1.element,
  iconLabel: PropTypes$1.string,
  text: PropTypes$1.node.isRequired,
  isDisabled: PropTypes$1.bool
};
const streamHealthIcon = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20id='Layer_2'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2041.29%2036.24'%3e%3cdefs%3e%3cstyle%3e.cls-1{fill:none;}.cls-2{fill:%230a3658;}%3c/style%3e%3c/defs%3e%3cg%20id='Basic-Stream-Analytics'%3e%3cpath%20class='cls-1'%20d='M20.8,11.36c-.57,0-1.03.46-1.03,1.03v8c0,.57.46,1.03,1.03,1.03s1.03-.46,1.03-1.03v-8c0-.57-.46-1.03-1.03-1.03Z'/%3e%3cpath%20class='cls-1'%20d='M13.67,8.6c-.57,0-1.03.46-1.03,1.03v10.75c0,.57.46,1.03,1.03,1.03s1.03-.46,1.03-1.03v-10.75c0-.57-.46-1.03-1.03-1.03Z'/%3e%3cpath%20class='cls-1'%20d='M6.79,13.6c-.57,0-1.03.46-1.03,1.03v5.75c0,.57.46,1.03,1.03,1.03s1.03-.46,1.03-1.03v-5.75c0-.57-.46-1.03-1.03-1.03Z'/%3e%3crect%20class='cls-1'%20x='9.36'%20y='11.36'%20width='2.05'%20height='10.05'%20rx='1.03'%20ry='1.03'/%3e%3cpath%20class='cls-1'%20d='M24.08,8.6c-.57,0-1.03.46-1.03,1.03v10.75c0,.57.46,1.03,1.03,1.03s1.03-.46,1.03-1.03v-10.75c0-.57-.46-1.03-1.03-1.03Z'/%3e%3cpath%20class='cls-1'%20d='M17.2,13.6c-.57,0-1.03.46-1.03,1.03v5.75c0,.57.46,1.03,1.03,1.03s1.03-.46,1.03-1.03v-5.75c0-.57-.46-1.03-1.03-1.03Z'/%3e%3crect%20class='cls-1'%20x='26.58'%20y='13.6'%20width='2.05'%20height='7.81'%20rx='1.03'%20ry='1.03'/%3e%3cpath%20class='cls-1'%20d='M34.49,8.6c-.57,0-1.03.46-1.03,1.03v10.75c0,.57.46,1.03,1.03,1.03s1.03-.46,1.03-1.03v-10.75c0-.57-.46-1.03-1.03-1.03Z'/%3e%3cpath%20class='cls-1'%20d='M31.21,11.36c-.57,0-1.03.46-1.03,1.03v8c0,.57.46,1.03,1.03,1.03s1.03-.46,1.03-1.03v-8c0-.57-.46-1.03-1.03-1.03Z'/%3e%3cpath%20class='cls-2'%20d='M34.89,0H6.4C2.87,0,0,2.87,0,6.4v17.22c0,3.53,2.87,6.4,6.4,6.4h10.34l3.79-4.53,3.79,4.53h10.58c3.53,0,6.4-2.87,6.4-6.4V6.4c0-3.53-2.87-6.4-6.4-6.4ZM7.82,20.38c0,.57-.46,1.03-1.03,1.03s-1.03-.46-1.03-1.03v-5.75c0-.57.46-1.03,1.03-1.03s1.03.46,1.03,1.03v5.75ZM11.41,20.38c0,.57-.46,1.03-1.03,1.03h0c-.57,0-1.03-.46-1.03-1.03v-8c0-.57.46-1.03,1.03-1.03h0c.57,0,1.03.46,1.03,1.03v8ZM14.7,20.38c0,.57-.46,1.03-1.03,1.03s-1.03-.46-1.03-1.03v-10.75c0-.57.46-1.03,1.03-1.03s1.03.46,1.03,1.03v10.75ZM18.23,20.38c0,.57-.46,1.03-1.03,1.03s-1.03-.46-1.03-1.03v-5.75c0-.57.46-1.03,1.03-1.03s1.03.46,1.03,1.03v5.75ZM21.82,20.38c0,.57-.46,1.03-1.03,1.03s-1.03-.46-1.03-1.03v-8c0-.57.46-1.03,1.03-1.03s1.03.46,1.03,1.03v8ZM25.11,20.38c0,.57-.46,1.03-1.03,1.03s-1.03-.46-1.03-1.03v-10.75c0-.57.46-1.03,1.03-1.03s1.03.46,1.03,1.03v10.75ZM28.64,20.38c0,.57-.46,1.03-1.03,1.03h0c-.57,0-1.03-.46-1.03-1.03v-5.75c0-.57.46-1.03,1.03-1.03h0c.57,0,1.03.46,1.03,1.03v5.75ZM32.23,20.38c0,.57-.46,1.03-1.03,1.03s-1.03-.46-1.03-1.03v-8c0-.57.46-1.03,1.03-1.03s1.03.46,1.03,1.03v8ZM35.52,20.38c0,.57-.46,1.03-1.03,1.03s-1.03-.46-1.03-1.03v-10.75c0-.57.46-1.03,1.03-1.03s1.03.46,1.03,1.03v10.75Z'/%3e%3cpolygon%20class='cls-2'%20points='12.83%2036.24%2028.21%2036.24%2023.01%2030.01%2018.04%2030.01%2012.83%2036.24'/%3e%3cpolygon%20class='cls-2'%20points='18.04%2030.01%2023.01%2030.01%2020.52%2027.04%2018.04%2030.01'/%3e%3c/g%3e%3c/svg%3e", streamHealtDisabledIcon = "data:image/svg+xml,%3c?xml%20version='1.0'%20encoding='UTF-8'?%3e%3csvg%20id='Layer_2'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2041.29%2036.24'%3e%3cdefs%3e%3cstyle%3e.cls-1{fill:none;}.cls-2{fill:%235B616B;}%3c/style%3e%3c/defs%3e%3cg%20id='Basic-Stream-Analytics'%3e%3cpath%20class='cls-1'%20d='M20.8,11.36c-.57,0-1.03.46-1.03,1.03v8c0,.57.46,1.03,1.03,1.03s1.03-.46,1.03-1.03v-8c0-.57-.46-1.03-1.03-1.03Z'/%3e%3cpath%20class='cls-1'%20d='M13.67,8.6c-.57,0-1.03.46-1.03,1.03v10.75c0,.57.46,1.03,1.03,1.03s1.03-.46,1.03-1.03v-10.75c0-.57-.46-1.03-1.03-1.03Z'/%3e%3cpath%20class='cls-1'%20d='M6.79,13.6c-.57,0-1.03.46-1.03,1.03v5.75c0,.57.46,1.03,1.03,1.03s1.03-.46,1.03-1.03v-5.75c0-.57-.46-1.03-1.03-1.03Z'/%3e%3crect%20class='cls-1'%20x='9.36'%20y='11.36'%20width='2.05'%20height='10.05'%20rx='1.03'%20ry='1.03'/%3e%3cpath%20class='cls-1'%20d='M24.08,8.6c-.57,0-1.03.46-1.03,1.03v10.75c0,.57.46,1.03,1.03,1.03s1.03-.46,1.03-1.03v-10.75c0-.57-.46-1.03-1.03-1.03Z'/%3e%3cpath%20class='cls-1'%20d='M17.2,13.6c-.57,0-1.03.46-1.03,1.03v5.75c0,.57.46,1.03,1.03,1.03s1.03-.46,1.03-1.03v-5.75c0-.57-.46-1.03-1.03-1.03Z'/%3e%3crect%20class='cls-1'%20x='26.58'%20y='13.6'%20width='2.05'%20height='7.81'%20rx='1.03'%20ry='1.03'/%3e%3cpath%20class='cls-1'%20d='M34.49,8.6c-.57,0-1.03.46-1.03,1.03v10.75c0,.57.46,1.03,1.03,1.03s1.03-.46,1.03-1.03v-10.75c0-.57-.46-1.03-1.03-1.03Z'/%3e%3cpath%20class='cls-1'%20d='M31.21,11.36c-.57,0-1.03.46-1.03,1.03v8c0,.57.46,1.03,1.03,1.03s1.03-.46,1.03-1.03v-8c0-.57-.46-1.03-1.03-1.03Z'/%3e%3cpath%20class='cls-2'%20d='M34.89,0H6.4C2.87,0,0,2.87,0,6.4v17.22c0,3.53,2.87,6.4,6.4,6.4h10.34l3.79-4.53,3.79,4.53h10.58c3.53,0,6.4-2.87,6.4-6.4V6.4c0-3.53-2.87-6.4-6.4-6.4ZM7.82,20.38c0,.57-.46,1.03-1.03,1.03s-1.03-.46-1.03-1.03v-5.75c0-.57.46-1.03,1.03-1.03s1.03.46,1.03,1.03v5.75ZM11.41,20.38c0,.57-.46,1.03-1.03,1.03h0c-.57,0-1.03-.46-1.03-1.03v-8c0-.57.46-1.03,1.03-1.03h0c.57,0,1.03.46,1.03,1.03v8ZM14.7,20.38c0,.57-.46,1.03-1.03,1.03s-1.03-.46-1.03-1.03v-10.75c0-.57.46-1.03,1.03-1.03s1.03.46,1.03,1.03v10.75ZM18.23,20.38c0,.57-.46,1.03-1.03,1.03s-1.03-.46-1.03-1.03v-5.75c0-.57.46-1.03,1.03-1.03s1.03.46,1.03,1.03v5.75ZM21.82,20.38c0,.57-.46,1.03-1.03,1.03s-1.03-.46-1.03-1.03v-8c0-.57.46-1.03,1.03-1.03s1.03.46,1.03,1.03v8ZM25.11,20.38c0,.57-.46,1.03-1.03,1.03s-1.03-.46-1.03-1.03v-10.75c0-.57.46-1.03,1.03-1.03s1.03.46,1.03,1.03v10.75ZM28.64,20.38c0,.57-.46,1.03-1.03,1.03h0c-.57,0-1.03-.46-1.03-1.03v-5.75c0-.57.46-1.03,1.03-1.03h0c.57,0,1.03.46,1.03,1.03v5.75ZM32.23,20.38c0,.57-.46,1.03-1.03,1.03s-1.03-.46-1.03-1.03v-8c0-.57.46-1.03,1.03-1.03s1.03.46,1.03,1.03v8ZM35.52,20.38c0,.57-.46,1.03-1.03,1.03s-1.03-.46-1.03-1.03v-10.75c0-.57.46-1.03,1.03-1.03s1.03.46,1.03,1.03v10.75Z'/%3e%3cpolygon%20class='cls-2'%20points='12.83%2036.24%2028.21%2036.24%2023.01%2030.01%2018.04%2030.01%2012.83%2036.24'/%3e%3cpolygon%20class='cls-2'%20points='18.04%2030.01%2023.01%2030.01%2020.52%2027.04%2018.04%2030.01'/%3e%3c/g%3e%3c/svg%3e";
function Picker({ routesEnabled: pt = { streamHealth: !1 } }) {
  return /* @__PURE__ */ jsxRuntimeExports$1.jsxs("sky-page", { children: [
    /* @__PURE__ */ jsxRuntimeExports$1.jsx(Title, { level: 1, title: "Analytics Marketplace" }),
    /* @__PURE__ */ jsxRuntimeExports$1.jsx("main", { children: /* @__PURE__ */ jsxRuntimeExports$1.jsx("article", { children: /* @__PURE__ */ jsxRuntimeExports$1.jsxs("nav", { "aria-label": "Analytics tools", children: [
      /* @__PURE__ */ jsxRuntimeExports$1.jsx(
        PickerLink,
        {
          href: "/analytics/stream-health",
          className: "snapshot-viewer",
          icon: /* @__PURE__ */ jsxRuntimeExports$1.jsx("img", { src: pt.streamHealth ? streamHealthIcon : streamHealtDisabledIcon, alt: "" }),
          text: "Stream Health",
          isDisabled: !pt.streamHealth
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports$1.jsx(
        PickerLink,
        {
          href: "#",
          className: "coming-soon",
          iconClass: "fa-solid fa-vial",
          text: "Coming Soon",
          isDisabled: !0
        }
      )
    ] }) }) })
  ] });
}
export {
  Home,
  Picker
};
